import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';

export class TypedDocumentString<TResult, TVariables> extends String implements DocumentTypeDecoration<TResult, TVariables> {
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(private value: string, public __meta__?: Record<string, any>) { super(value); }
  override toString(): string & DocumentTypeDecoration<TResult, TVariables> { return this.value as unknown as string & DocumentTypeDecoration<TResult, TVariables>; }
}
import { TDateISO } from '~/@types/TDateISO';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: TDateISO; output: TDateISO; }
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: number; output: number; }
  JSON: { input: unknown; output: unknown; }
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: string; output: string; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: number; output: number; }
  /** The ObjectId scalar type represents a 12 byte ObjectId, represented as UTF-8 character sequences. */
  ObjectId: { input: string; output: string; }
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: { input: unknown; output: unknown; }
  UUID: { input: string; output: string; }
};

export type AbortOtaRolloutInput = {
  lineId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  rolloutId: Scalars['String']['input'];
};

/** Filter operations on a boolean field whose absent stored key means false. The Mongo provider treats false-or-missing as one state: eq: false matches rows lacking the stored key, and eq: true / eq: false partition the collection. */
export type AbsentAsFalseBooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input recording the caller's acceptance of a GrowerBenchmark acceptable-use terms version (contract C7). */
export type AcceptGrowerBenchmarkAcceptableUseInput = {
  /** Version identifier of the accepted acceptable-use terms. */
  acceptableUseVersion: Scalars['String']['input'];
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
};

export type AcceptUserInviteInput = {
  code: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum AccountClassification {
  Asset = 'ASSET',
  Equity = 'EQUITY',
  Expense = 'EXPENSE',
  Liability = 'LIABILITY',
  Revenue = 'REVENUE'
}

export type AccountClassificationOperationFilterInput = {
  eq?: InputMaybe<AccountClassification>;
  in?: InputMaybe<Array<AccountClassification>>;
  neq?: InputMaybe<AccountClassification>;
  nin?: InputMaybe<Array<AccountClassification>>;
};

/**
 * MongoDB read-model document for a tenant's accounting integration policy. There is exactly one
 * document per tenant; Id equals TenantId today, but use GetDocumentId for all
 * reads/writes so that invariant can evolve without breaking call sites. Holds policy only —
 * Merge.dev connection secrets continue to live on MergeTenantIntegration /
 * TenantIntegrationDocument.
 */
export type AccountingIntegrationConfigDocument = {
  __typename?: 'AccountingIntegrationConfigDocument';
  defaultIncomeAccount?: Maybe<DefaultIncomeAccount>;
  /** Live Chart-of-Accounts row for the tenant default income account, resolved from its ImportId — falling back to a lookup by the legacy RemoteId until the backfill has run (Helm 9f8b7004). Null when no default income account is configured or the linked account no longer exists. */
  defaultIncomeAccountJoined?: Maybe<MergeDevAccountDocument>;
  /** Linked Chart-of-Accounts row resolved from DepositAppliedAccountId. Null when unset or removed. */
  depositAppliedAccount?: Maybe<MergeDevAccountDocument>;
  /** Merge.dev account ImportId for the "Deposit applied" non-product-line export (Helm 9f8b7004). */
  depositAppliedAccountId?: Maybe<Scalars['String']['output']>;
  /** Linked Chart-of-Accounts row resolved from FreightAccountId. Null when unset or removed. */
  freightAccount?: Maybe<MergeDevAccountDocument>;
  /** Merge.dev account ImportId for the "Freight" non-product-line export (Helm 9f8b7004). */
  freightAccountId?: Maybe<Scalars['String']['output']>;
  /** Linked Chart-of-Accounts row resolved from FuelSurchargeAccountId. Null when unset or removed. */
  fuelSurchargeAccount?: Maybe<MergeDevAccountDocument>;
  /** Merge.dev account ImportId for the "Fuel surcharge" non-product-line export. */
  fuelSurchargeAccountId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  mergeDevAccountId?: Maybe<Scalars['String']['output']>;
  oneTimePullCompleted: Scalars['Boolean']['output'];
  oneTimePullCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  outboundDetail: OutboundDetailLevel;
  /** Placeholder items the accounting provider refused to create, one entry per (purpose, account). Each line purpose has at most one entry, for its currently configured account; Sales entries are per revenue account. Empty when nothing has been refused, including on documents written before refusals were recorded. */
  placeholderRefusals: Array<AccountingPlaceholderRefusal>;
  provider: AccountingProvider;
  /** Linked Chart-of-Accounts row resolved from RoundingAdjustmentAccountId. Null when unset or removed. */
  roundingAdjustmentAccount?: Maybe<MergeDevAccountDocument>;
  /** Merge.dev account ImportId for the "Rounding adjustment" non-product-line export (Helm 9f8b7004). */
  roundingAdjustmentAccountId?: Maybe<Scalars['String']['output']>;
  /** Linked Chart-of-Accounts row resolved from SalesTaxAccountId. Null when unset or removed. */
  salesTaxAccount?: Maybe<MergeDevAccountDocument>;
  /** Merge.dev account ImportId for the "Sales tax" non-product-line export (Helm 9f8b7004). */
  salesTaxAccountId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type AccountingIntegrationConfigPayload = {
  __typename?: 'AccountingIntegrationConfigPayload';
  accountingIntegrationConfig?: Maybe<AccountingIntegrationConfigStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type AccountingIntegrationConfigStateData = {
  __typename?: 'AccountingIntegrationConfigStateData';
  defaultIncomeAccount?: Maybe<DefaultIncomeAccount>;
  /** Live Chart-of-Accounts row for the tenant default income account, resolved from its ImportId — falling back to a lookup by the legacy RemoteId until the backfill has run (Helm 9f8b7004). Null when no default income account is configured or the linked account no longer exists. */
  defaultIncomeAccountJoined?: Maybe<MergeDevAccountDocument>;
  /** Linked Chart-of-Accounts row resolved from DepositAppliedAccountId. Null when unset or removed. */
  depositAppliedAccount?: Maybe<MergeDevAccountDocument>;
  depositAppliedAccountId?: Maybe<Scalars['String']['output']>;
  /** Linked Chart-of-Accounts row resolved from FreightAccountId. Null when unset or removed. */
  freightAccount?: Maybe<MergeDevAccountDocument>;
  freightAccountId?: Maybe<Scalars['String']['output']>;
  /** Linked Chart-of-Accounts row resolved from FuelSurchargeAccountId. Null when unset or removed. */
  fuelSurchargeAccount?: Maybe<MergeDevAccountDocument>;
  fuelSurchargeAccountId?: Maybe<Scalars['String']['output']>;
  mergeDevAccountId?: Maybe<Scalars['String']['output']>;
  oneTimePullCompleted: Scalars['Boolean']['output'];
  oneTimePullCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  outboundDetail: OutboundDetailLevel;
  placeholderRefusals: Array<AccountingPlaceholderRefusal>;
  provider: AccountingProvider;
  /** Linked Chart-of-Accounts row resolved from RoundingAdjustmentAccountId. Null when unset or removed. */
  roundingAdjustmentAccount?: Maybe<MergeDevAccountDocument>;
  roundingAdjustmentAccountId?: Maybe<Scalars['String']['output']>;
  /** Linked Chart-of-Accounts row resolved from SalesTaxAccountId. Null when unset or removed. */
  salesTaxAccount?: Maybe<MergeDevAccountDocument>;
  salesTaxAccountId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

/** What an exported invoice line is for: the product line, one of the five non-product lines configured by setAccountingLineAccounts, or a flat charge from the charge list. */
export enum AccountingPlaceholderPurpose {
  /** The Deposit applied line. */
  DepositApplied = 'DEPOSIT_APPLIED',
  /** A flat order charge from the tenant's charge list, routed to its entry's account. */
  FlatCharge = 'FLAT_CHARGE',
  /** The Freight line. */
  Freight = 'FREIGHT',
  /** The Fuel surcharge line: the system charge written with freight, routed to FuelSurchargeAccountId. */
  FuelSurcharge = 'FUEL_SURCHARGE',
  /** The Rounding adjustment line. */
  Rounding = 'ROUNDING',
  /** A product line, routed by the revenue account ladder. */
  Sales = 'SALES',
  /** QuickBooks reserves its automated sales-tax agency accounts for its own tax postings and will not accept items against them. Choose a plain liability account such as Sales Tax Clearing. */
  SalesTax = 'SALES_TAX'
}

/** The accounting provider's definitive refusal to create the export's placeholder item for one (purpose, account) pair, as reported by the export worker. */
export type AccountingPlaceholderRefusal = {
  __typename?: 'AccountingPlaceholderRefusal';
  /** Merge.dev account ImportId of the refused account. */
  accountImportId: Scalars['String']['output'];
  /** Name of the refused Chart-of-Accounts row, resolved live from accountImportId. Null when the account no longer exists for the tenant. */
  accountName?: Maybe<Scalars['String']['output']>;
  /** Merge's problem_type for the refusal. Null when the refusal carried none. */
  mergeProblemType?: Maybe<Scalars['String']['output']>;
  /** Which invoice line the refused placeholder item was for. */
  purpose: AccountingPlaceholderPurpose;
  /** The provider's refusal message, verbatim. */
  reason: Scalars['String']['output'];
  /** When the export worker first saw the refusal. */
  refusedAt: Scalars['DateTime']['output'];
};

export enum AccountingProvider {
  NetSuite = 'NET_SUITE',
  None = 'NONE',
  QuickBooks = 'QUICK_BOOKS',
  Xero = 'XERO'
}

export type ActivateCategoryInput = {
  code: Scalars['String']['input'];
};

export type ActivateConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
};

export type ActivateContainerConfigInput = {
  containerConfigId: Scalars['String']['input'];
};

export type ActivateCustomerGroupInput = {
  id: Scalars['String']['input'];
};

export type ActivateCustomerInput = {
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ActivateCustomerItemInput = {
  customerItemId: Scalars['String']['input'];
};

export type ActivateCustomerTypeInput = {
  id: Scalars['String']['input'];
};

export type ActivateDeliveryScheduleInput = {
  id: Scalars['String']['input'];
};

export type ActivateFeatureFlagInput = {
  name: FeatureFlagName;
};

export type ActivateItemInput = {
  itemId: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type ActivateLocationInput = {
  locationId: Scalars['String']['input'];
};

export type ActivateMaterialItemInput = {
  id: Scalars['String']['input'];
};

export type ActivatePaymentProcessorInput = {
  id: Scalars['String']['input'];
};

export type ActivatePriceGroupInput = {
  id: Scalars['String']['input'];
};

export type ActivateProductionCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
};

export type ActivateProductionItemInput = {
  productionItemId: Scalars['String']['input'];
};

export type ActivateProductionLotInput = {
  productionLotId: Scalars['String']['input'];
};

export type ActivateProductionMaterialEventDetailInput = {
  productionMaterialEventDetailId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type ActivateProductionMaterialEventInput = {
  productionMaterialEventId: Scalars['String']['input'];
};

export type ActivateProductionPlanInput = {
  productionPlanId: Scalars['String']['input'];
};

export type ActivateProductionRecipeInput = {
  productionRecipeId: Scalars['String']['input'];
};

export type ActivateProductionSpaceCategoryInput = {
  productionSpaceCategoryId: Scalars['String']['input'];
};

export type ActivateProductionSpaceEventDetailInput = {
  productionSpaceEventDetailId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type ActivateProductionSpaceEventInput = {
  productionSpaceEventId: Scalars['String']['input'];
};

export type ActivateProductionSpaceTypeInput = {
  productionSpaceTypeId: Scalars['String']['input'];
};

export type ActivateProductionTaskEventDetailInput = {
  productionTaskEventDetailId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type ActivateProductionTaskEventInput = {
  productionTaskEventId: Scalars['String']['input'];
};

export type ActivateProductionTriggerInput = {
  productionTriggerId: Scalars['String']['input'];
};

export type ActivateSftpTenantConfigInput = {
  configId: Scalars['String']['input'];
};

export type ActivateSizeUomInput = {
  code: Scalars['String']['input'];
};

export type ActivateTaskEventTypeInput = {
  taskEventTypeId: Scalars['String']['input'];
};

export type ActivateTenantInput = {
  entityId: Scalars['String']['input'];
};

export type ActivateVendorInput = {
  id: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type ActiveImportJobsConnection = {
  __typename?: 'ActiveImportJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ActiveImportJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AsyncImportJobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ActiveImportJobsEdge = {
  __typename?: 'ActiveImportJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AsyncImportJobDocument;
};

export type ActivePortalUserMapping = {
  __typename?: 'ActivePortalUserMapping';
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  portalUserId: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

export type AddBayPolesInput = {
  bayLocationId: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type AddBillingAddressInput = {
  address: CreateAddressInput;
  customerId: Scalars['String']['input'];
};

export type AddBlockingRuleLinkedItemsInput = {
  blockingRuleId: Scalars['String']['input'];
  linkedItemIds: Array<Scalars['String']['input']>;
};

export type AddBlockingRuleLinkedLocationsInput = {
  blockingRuleId: Scalars['String']['input'];
  linkedLocationIds: Array<Scalars['String']['input']>;
};

/**
 * GraphQL input for addBpfLotChange. Primitive/non-Option fields only (HotChocolate input
 * type). Tenant and user are taken from the authenticated principal, never this input.
 *
 * MissionEntryId is optional: the Nav [BP Cycle Count Assign].[Entry ID] of the BPF
 * mission task this count is recorded against, paired with LotCountId to identify the task
 * ({TenantId}-{MissionEntryId}-{LotCountId}). When supplied, this change is validated as still
 * open for counting and, on success, stamps the task's IsComplete / OldQuantity /
 * NewQuantity / LotChangeId / CompletedAt / CompletedByEmail. Every
 * existing ad-hoc caller leaves it null and is unaffected.
 */
export type AddBpfLotChangeInput = {
  changeReasonCode: Scalars['String']['input'];
  changeType: BpfLotChangeType;
  countedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  fromSiteLocationId: Scalars['String']['input'];
  fromSubLocationId: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  itemReference: Scalars['String']['input'];
  jobReference: Scalars['String']['input'];
  lotCountId: Scalars['String']['input'];
  lotReference: Scalars['String']['input'];
  missionEntryId?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  quantityChange: Scalars['Decimal']['input'];
  recordedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stage: BpfLotStage;
  toSiteLocationId: Scalars['String']['input'];
  toSubLocationId: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  variantReference: Scalars['String']['input'];
};

export type AddCategoryInput = {
  category: CategoryDataInput;
};

export type AddConfigCategoryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  configCategoryId: Scalars['String']['input'];
  defaultSizeUomCode: Scalars['String']['input'];
  eachesPerUnit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  ownSizeUom?: InputMaybe<OwnSizeUomDataInput>;
  sizeUomCodes: Array<Scalars['String']['input']>;
};

export type AddContactInput = {
  contact: ContactDataInput;
  customerId: Scalars['String']['input'];
};

export type AddContainerConfigForConfigCategoryDataInput = {
  categoryCode: Scalars['String']['input'];
  configCategoryId: Scalars['String']['input'];
  containerCode: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
  containerName: Scalars['String']['input'];
  depth: Scalars['Decimal']['input'];
  height: Scalars['Decimal']['input'];
  maxLayersPerContainer: Scalars['Int']['input'];
  maxTraysPerLayer: Scalars['Int']['input'];
  parentContainerConfigId?: InputMaybe<Scalars['String']['input']>;
  shipFactor: Scalars['Int']['input'];
  shipMinimum: Scalars['Int']['input'];
  siteCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeUomCode: Scalars['String']['input'];
  width: Scalars['Decimal']['input'];
};

export type AddContainerConfigInput = {
  categoryCode: Scalars['String']['input'];
  containerCode: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
  containerName: Scalars['String']['input'];
  depth: Scalars['Decimal']['input'];
  height: Scalars['Decimal']['input'];
  maxLayersPerContainer: Scalars['Int']['input'];
  maxTraysPerLayer: Scalars['Int']['input'];
  parentContainerConfigId?: InputMaybe<Scalars['String']['input']>;
  shipFactor: Scalars['Int']['input'];
  shipIncrement?: InputMaybe<Scalars['Int']['input']>;
  shipMinimum: Scalars['Int']['input'];
  siteCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeUomCode: Scalars['String']['input'];
  width: Scalars['Decimal']['input'];
};

export type AddContainerConfigToConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
};

export type AddCustomerGroupInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddCustomerInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerGroupId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  customerLookupCode?: InputMaybe<Scalars['String']['input']>;
  customerTypeId?: InputMaybe<Scalars['String']['input']>;
  defaultDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  erpPriceGroupId: Scalars['String']['input'];
  federalTaxNumber?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  poRequired?: Scalars['Boolean']['input'];
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  synchronizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  taxExemptNumber?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
};

export type AddCustomerItemInput = {
  customerId: Scalars['String']['input'];
  customerItemId: Scalars['String']['input'];
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveUntil?: InputMaybe<Scalars['DateTime']['input']>;
  isDefault: Scalars['Boolean']['input'];
  itemId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
  retailShelfPrice?: InputMaybe<Scalars['Decimal']['input']>;
  retailShelfPriceCurrency?: InputMaybe<Scalars['String']['input']>;
  shippingConfigCategoryCode?: InputMaybe<Scalars['String']['input']>;
  sizeUomCode?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type AddCustomerItemsInput = {
  customerItems: Array<AddCustomerItemInput>;
};

export type AddCustomerLocationSettingsNoteInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  noteId: Scalars['String']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
};

export type AddCustomerTypeInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  revenueGlAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type AddCustomerUpgradeInput = {
  customerId: Scalars['String']['input'];
  upgrade: CustomerUpgradeDataInput;
};

export type AddEffectiveMaterialPriceInput = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedPurchasingRevision?: InputMaybe<Scalars['Int']['input']>;
  materialItemId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  reviewedBaseOnly?: Scalars['Boolean']['input'];
  source?: InputMaybe<ReviewedMaterialPriceSourceInput>;
  supplierRoyaltyPerEach?: InputMaybe<Scalars['String']['input']>;
  supplierRoyaltyStatus: SupplierRoyaltyStatus;
  unitCost: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type AddFlatChargeTypeInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  taxable: Scalars['Boolean']['input'];
};

/** Input appending one entry to the calling reader's dashboard and compare activity trail (contract C1). */
export type AddGrowerBenchmarkActivityEntryInput = {
  communityId: Scalars['String']['input'];
  kind: GrowerBenchmarkActivityKind;
  periodId?: InputMaybe<Scalars['String']['input']>;
  summary: Scalars['String']['input'];
};

/** Input creating a new GrowerBenchmark community and seeding its first COMMUNITY_ADMIN roster entry (contract C7). */
export type AddGrowerBenchmarkCommunityInput = {
  /** Subject user identifier seeded as the first community administrator. */
  initialAdminUserId: Scalars['String']['input'];
  /** Neutral internal display name of the community. */
  name: Scalars['String']['input'];
  /** Industry segment of the community. */
  segment: GrowerBenchmarkCommunitySegment;
  /** Classification tags attached to the community. */
  tags: Array<Scalars['String']['input']>;
  /** Optional IANA time zone identifier read by period rules. */
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
};

/** Adds an email address or a whole domain documents are accepted from. */
export type AddInboundAllowedSenderInput = {
  /** Whether the value is one email address or a whole domain. */
  type: InboundAllowedSenderType;
  /** The email address or domain. Stored trimmed and in lower case. */
  value: Scalars['String']['input'];
};

export type AddInventoryNoteInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type AddItemCharacteristicInput = {
  itemCharacteristicId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type AddItemCharacteristicValueInput = {
  itemCharacteristicId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
  valueId: Scalars['String']['input'];
};

export type AddItemInput = {
  categories: Array<ItemCategoryAssignmentDataInput>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: Scalars['String']['input'];
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  native?: InputMaybe<Scalars['Boolean']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type AddItemToCartInput = {
  cartId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  upc: Scalars['String']['input'];
};

export type AddItemUpgradeInput = {
  itemId: Scalars['String']['input'];
  upgrade: ItemUpgradeDataInput;
};

export type AddLineItemDataInput = {
  addedBy: Scalars['String']['input'];
  containerCode?: InputMaybe<Scalars['String']['input']>;
  cost: Scalars['Decimal']['input'];
  currency: Scalars['String']['input'];
  customerItemId?: InputMaybe<Scalars['String']['input']>;
  dateAdded: Scalars['DateTime']['input'];
  eachesQuantity?: InputMaybe<Scalars['Int']['input']>;
  fulfillmentSource?: FulfillmentSource;
  /** @deprecated Read only on a line that resolves no Shipping UOM, where it is the pack size the line prices on. On a Shipping UOM line the server snapshots eaches-per-unit from the Shipping UOM and ignores this value. Send `shippingUomId` instead. */
  handlingUom?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  kitGroupId?: InputMaybe<Scalars['String']['input']>;
  kitId?: InputMaybe<Scalars['String']['input']>;
  lineNumber: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
  overridePrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** Override price for one shipping unit (flat, tray) of this line, in place of overridePrice. Send this or overridePrice, never both (both is refused). Prices are stored and billed per each: the server stores this ÷ the line's eaches per unit, unrounded, once the line's shipping unit is resolved. On a line with no shipping unit it is the per-each override. */
  overrideUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  price: Scalars['Decimal']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  royaltyExempt?: Scalars['Boolean']['input'];
  shippingConfigCategoryCode?: InputMaybe<Scalars['String']['input']>;
  shippingUomId?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  tag1ColorId?: InputMaybe<Scalars['String']['input']>;
  tag1Locked?: InputMaybe<Scalars['Boolean']['input']>;
  tag2ColorId?: InputMaybe<Scalars['String']['input']>;
  tag2Locked?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type AddLineItemsInput = {
  items: Array<AddLineItemDataInput>;
  minimumOverrideReason?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type AddLineItemsWithPricingInput = {
  batchSize?: Scalars['Int']['input'];
  items: Array<AddLineItemDataInput>;
  locationId: Scalars['UUID']['input'];
  minimumOverrideReason?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type AddLocationInput = {
  customerId: Scalars['String']['input'];
  location: CreateCustomerLocationInput;
};

export type AddMasterLineItemDataInput = {
  addedBy: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  dateAdded: Scalars['DateTime']['input'];
  id: Scalars['UUID']['input'];
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
  orderedQuantity?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Decimal']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type AddMasterLineItemsInput = {
  items: Array<AddMasterLineItemDataInput>;
  masterOrderId: Scalars['String']['input'];
};

export type AddNoteInput = {
  noteContent: Scalars['String']['input'];
  taskAssignmentId: Scalars['String']['input'];
};

export type AddOrderFlatChargeInput = {
  amount: Scalars['Decimal']['input'];
  flatChargeId: Scalars['String']['input'];
  flatChargeTypeId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddOrderLineUpgradeInput = {
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<OrderLineUpgradeCostDataInput>;
  lineItemId: Scalars['String']['input'];
  lineItemUpgradeId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  pricing: OrderLineUpgradePricingDataInput;
  sourceItemUpgradeId?: InputMaybe<Scalars['String']['input']>;
};

export type AddParentCompanyAdministratorInput = {
  email: Scalars['String']['input'];
  fusionAuthUserId: Scalars['String']['input'];
  parentCompanyId: Scalars['String']['input'];
};

export type AddParentCompanyInput = {
  name: Scalars['String']['input'];
  parentCompanyId?: InputMaybe<Scalars['String']['input']>;
  primaryContact: ContactDataInput;
};

export type AddPortalCustomDomainInput = {
  domain: Scalars['String']['input'];
};

export type AddPriceGroupInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddProductionLotAsyncImportJobRowsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<ProductionLotImportRowValuesInput>;
};

export type AddProductionMaterialEventDetailsDataInput = {
  description: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  multiple: Scalars['Decimal']['input'];
  productionMaterialEventDetailId: Scalars['String']['input'];
  triggerId: Scalars['String']['input'];
};

export type AddProductionMaterialEventDetailsInput = {
  details: Array<AddProductionMaterialEventDetailsDataInput>;
  productionMaterialEventId: Scalars['String']['input'];
};

export type AddProductionMaterialEventToCategoryInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  productionCategoryId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type AddProductionMaterialEventToJobDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type AddProductionRecipeVariationInput = {
  productionRecipeId: Scalars['String']['input'];
  variation: ProductionRecipeVariationDataInput;
};

export type AddProductionSpaceEventDetailsDataInput = {
  description: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
  productionSpaceEventDetailId: Scalars['String']['input'];
  productionSpaceTypeId: Scalars['String']['input'];
  triggerId: Scalars['String']['input'];
};

export type AddProductionSpaceEventDetailsInput = {
  details: Array<AddProductionSpaceEventDetailsDataInput>;
  productionSpaceEventId: Scalars['String']['input'];
};

export type AddProductionSpaceEventToCategoryInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  productionCategoryId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type AddProductionSpaceEventToJobDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type AddProductionTaskEventDetailsDataInput = {
  description: Scalars['String']['input'];
  materialItemId?: InputMaybe<Scalars['String']['input']>;
  multiple: Scalars['Decimal']['input'];
  productionTaskEventDetailId: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  taskEventTypeId: Scalars['String']['input'];
  triggerId: Scalars['String']['input'];
};

export type AddProductionTaskEventDetailsInput = {
  details: Array<AddProductionTaskEventDetailsDataInput>;
  productionTaskEventId: Scalars['String']['input'];
};

export type AddProductionTaskEventToCategoryInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  productionCategoryId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type AddProductionTaskEventToItemInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  productionItemId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type AddPromotionRuleLinkedItemsInput = {
  linkedItemIds: Array<Scalars['String']['input']>;
  promotionRuleId: Scalars['String']['input'];
};

export type AddPromotionRuleLinkedLocationsInput = {
  linkedLocationIds: Array<Scalars['String']['input']>;
  promotionRuleId: Scalars['String']['input'];
};

export type AddPurchaseOrderLineItemInput = {
  erpJobId?: InputMaybe<Scalars['String']['input']>;
  eventDetailId?: InputMaybe<Scalars['String']['input']>;
  itemName: Scalars['String']['input'];
  jobShares?: InputMaybe<Array<AddVendorPurchaseOrderLineJobShareDataInput>>;
  lineItemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  materialItemErpId?: InputMaybe<Scalars['String']['input']>;
  materialItemId: Scalars['String']['input'];
  productionJobId?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderId: Scalars['String']['input'];
  quantityOrdered: Scalars['Decimal']['input'];
  unitCost?: InputMaybe<Scalars['Decimal']['input']>;
  unitCostText?: InputMaybe<Scalars['String']['input']>;
};

export type AddReserveRuleLinkedItemsInput = {
  linkedItemIds: Array<Scalars['String']['input']>;
  reserveRuleId: Scalars['String']['input'];
};

export type AddReserveRuleLinkedLocationsInput = {
  linkedLocationIds: Array<Scalars['String']['input']>;
  reserveRuleId: Scalars['String']['input'];
};

/**
 * GraphQL input for the retail product-count mutations. Primitive/non-Option fields only (HotChocolate
 * input type). Tenant and user are taken from the authenticated principal, never this input.
 */
export type AddRetailProductCountInput = {
  bpLotCode: Scalars['String']['input'];
  countType: RetailCountType;
  customerReference: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  itemReference: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  locationId: Scalars['String']['input'];
  longitude: Scalars['Float']['input'];
  note: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantityChange: Scalars['Decimal']['input'];
  recordedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unit: Scalars['String']['input'];
  unitQuantityChange: Scalars['Decimal']['input'];
};

export type AddSftpDestinationInput = {
  configId: Scalars['String']['input'];
  destination: DestinationConfigDataInput;
};

export type AddSftpMongoDestinationInput = {
  configId: Scalars['String']['input'];
  destination: MongoDestinationConfigDataInput;
};

export type AddSftpTenantConfigInput = {
  batchSize: Scalars['Int']['input'];
  configId: Scalars['String']['input'];
  configName: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  podId: Scalars['String']['input'];
  sourceDirectory: Scalars['String']['input'];
  sourceEndpoint: Scalars['String']['input'];
  sourceFilePattern: Scalars['String']['input'];
  sourcePassword: Scalars['String']['input'];
  sourcePort: Scalars['Int']['input'];
  sourceType: Scalars['String']['input'];
  sourceUsername: Scalars['String']['input'];
};

export type AddShipFromLocationInput = {
  customerId: Scalars['String']['input'];
  location: ShipFromLocationDataInput;
};

export type AddSignatureImageInput = {
  base64SignatureImage: Scalars['String']['input'];
  dateCaptured: Scalars['DateTime']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mime: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type AddSiteLocationAsyncImportJobRowsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<SiteLocationImportRowValuesInput>;
};

export type AddSizeUomInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  eachesPerUnit: Scalars['Int']['input'];
};

export type AddSizeUomToConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
  sizeUomCode: Scalars['String']['input'];
};

export type AddSubLocationInput = {
  erpId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  locationType: SiteLocationType;
  name: Scalars['String']['input'];
  parentLocationId?: InputMaybe<Scalars['String']['input']>;
  pickSequence?: InputMaybe<Scalars['Int']['input']>;
  siteLocationId: Scalars['String']['input'];
};

export type AddTagColorInput = {
  name: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
  tagColorId: Scalars['String']['input'];
};

export type AddTenantEmailDomainInput = {
  domain: Scalars['String']['input'];
};

export type AddTenantEmailSenderInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  stateProvince?: InputMaybe<Scalars['String']['input']>;
  verificationMethod: EmailSenderVerificationMethod;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddTenantInput = {
  entityId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddTenantUomNameInput = {
  name: Scalars['String']['input'];
};

export type AddTermsInput = {
  accrueInterestPercentage: Scalars['Decimal']['input'];
  discountDays?: Scalars['Int']['input'];
  financeChargeMonthlyRate?: Scalars['Decimal']['input'];
  id: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  maximumAnnualFinanceChargeRate?: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  termLimitDays: Scalars['Int']['input'];
};

/** A supplier's name for one of a vendor's materials. */
export type AddVendorItemAliasInput = {
  /**
   * The manufacturer in its key form (vendor:{id} or label:{text}), as the alias list publishes it; empty when
   * the manufacturer is unknown.
   */
  manufacturerKey?: InputMaybe<Scalars['String']['input']>;
  /** The material the supplier's item is. */
  materialItemId: Scalars['String']['input'];
  /** Whether another material's alias on the same key is retired and replaced rather than refused. */
  replaceExisting?: Scalars['Boolean']['input'];
  /** Who is adding: MANUAL for a person, CSV_IMPORT for a bulk alias import, PO_IMPORT for a purchase order line import. */
  source?: VendorItemAliasSource;
  /** The supplier's description: the alias's key when there is no item id. */
  supplierDescription?: InputMaybe<Scalars['String']['input']>;
  /** The supplier's item id: the alias's key whenever it is not blank. */
  supplierItemId?: InputMaybe<Scalars['String']['input']>;
  /** The purchasing vendor. */
  vendorId: Scalars['String']['input'];
};

export type AddVendorPurchaseOrderChargeInput = {
  amount: Scalars['Decimal']['input'];
  chargeId: Scalars['String']['input'];
  kind?: InputMaybe<VendorPurchaseOrderChargeKind>;
  label: Scalars['String']['input'];
  purchaseOrderId: Scalars['String']['input'];
};

export type AddVendorPurchaseOrderLineJobShareDataInput = {
  eventDetailId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
};

export type AddWsapiImportEntityMappingInput = {
  enabled: Scalars['Boolean']['input'];
  entityType: WsapiImportEntityType;
  fieldMappings: Array<FieldMappingInput>;
  keySourceField: Scalars['String']['input'];
  keyTargetField: Scalars['String']['input'];
  sourceTable: Scalars['String']['input'];
  wsapiImportId: Scalars['String']['input'];
};

/**
 * Budget figures for the recipe's extra costs (such as plug freight, non-stock packaging or testing
 * fees). Like the supplier royalty, its actual side is deliberately ABSENT rather than zero: the
 * recorded cost ledger has no additional-cost category, so nothing has ever posted an actual for it.
 */
export type AdditionalCostValueModel = {
  __typename?: 'AdditionalCostValueModel';
  /** Always absent, because additional costs are not separately tracked in the actual ledger. */
  actual?: Maybe<Scalars['Decimal']['output']>;
  /** Budgeted extra costs: each job's additional cost per flat times that job's quantity, summed. */
  budget: Scalars['Decimal']['output'];
  /** Always absent, because it is an actual plus the budgeted remainder. */
  projected?: Maybe<Scalars['Decimal']['output']>;
  /** Always absent, because it is budget minus an actual that does not exist. */
  variance?: Maybe<Scalars['Decimal']['output']>;
};

export type AddressData = {
  __typename?: 'AddressData';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  stateProvince: Scalars['String']['output'];
  toName: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type AddressDataFilterInput = {
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AddressDataFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AddressDataFilterInput>>;
  stateProvince?: InputMaybe<StringOperationFilterInput>;
  toName?: InputMaybe<StringOperationFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type AddressDataInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  id: Scalars['String']['input'];
  stateProvince: Scalars['String']['input'];
  toName: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type AddressDataSortInput = {
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  stateProvince?: InputMaybe<SortEnumType>;
  toName?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

export type AdjustAllocationInput = {
  allocationId: Scalars['String']['input'];
  newQty: Scalars['Decimal']['input'];
  reason: Scalars['String']['input'];
};

export type AdjustCountedQuantityInput = {
  correctionId: Scalars['String']['input'];
  countSessionId: Scalars['String']['input'];
  delta: Scalars['Long']['input'];
};

/** Input for the adjust-invoice mutation. */
export type AdjustInvoiceInput = {
  /** How much less the invoice is owed. Must be greater than zero and may not exceed what it still owes. */
  amount: Scalars['Decimal']['input'];
  /** The issued invoice to reduce. */
  invoiceId: Scalars['String']['input'];
  /**
   * What the reduction is being called — WRITE_OFF, DISCOUNT or OTHER. Required; UNKNOWN is refused.
   * Reporting only: every kind reduces the balance the same way.
   */
  kind: InvoiceAdjustmentKind;
  /**
   * Why the invoice is being reduced. Required — it is the only part of an adjustment a later reader
   * cannot reconstruct.
   */
  reason: Scalars['String']['input'];
};

export type AdjustMaterialItemInput = {
  batches?: InputMaybe<Array<MaterialBinBatchQuantityDataInput>>;
  locationId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode?: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
  why: Scalars['String']['input'];
};

export type AdjustOrderFreightInput = {
  freightChargeType: FreightChargeType;
  freightChargeValue: Scalars['Decimal']['input'];
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type AdjustPostedProductionDataInput = {
  adjustmentId: Scalars['String']['input'];
  delta: Scalars['Int']['input'];
  grade: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  producedLocationId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  reasonCode: Scalars['Int']['input'];
};

export type AdjustPriceLevelsInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  fields?: InputMaybe<Array<PriceLevelPriceField>>;
  newStartDate: Scalars['LocalDate']['input'];
  percent?: InputMaybe<Scalars['Decimal']['input']>;
  priceGroupId: Scalars['String']['input'];
  priceLevelIds: Array<Scalars['String']['input']>;
};

/**
 * adjustPriceLevels' answer: the group as it now stands, plus one row per addressed level per
 * adjusted price field saying what moved. Refusals arrive as coded errors exactly as every
 * other price group mutation returns them; the write is all-or-nothing, so a payload carrying an
 * error carries no rows and changed nothing.
 */
export type AdjustPriceLevelsPayload = {
  __typename?: 'AdjustPriceLevelsPayload';
  /** The coded refusal, when there was one. */
  errors?: Maybe<Array<ValidationError>>;
  /** The group after the write; null on a refusal. */
  pricing?: Maybe<PriceGroupStateData>;
  /**
   * One row per (addressed level, adjusted field). Never null, empty on a refusal. Adjusting the
   * default single field gives exactly one row per level.
   */
  results: Array<AdjustedPriceLevelData>;
};

export type AdjustProductionLotAllocationInput = {
  allocationId: Scalars['String']['input'];
  newAllocatedQty: Scalars['Int']['input'];
  orderedQty: Scalars['Int']['input'];
};

/**
 * One row of an adjustPriceLevels result on the wire: what happened to ONE price field of ONE
 * addressed level. A level adjusted on the default single field produces exactly one row; a level
 * adjusted on several fields produces one row per field, all sharing the same
 * priceLevelId/successorPriceLevelId pair.
 */
export type AdjustedPriceLevelData = {
  __typename?: 'AdjustedPriceLevelData';
  /** Which money field on the level this row reports. */
  field: PriceLevelPriceField;
  /** The same field on the successor; null when the old value was null. */
  newPrice?: Maybe<Scalars['Decimal']['output']>;
  /** The addressed field's value before the write; null when the level carried none. */
  oldPrice?: Maybe<Scalars['Decimal']['output']>;
  /** The addressed level, the one that was end-dated. */
  priceLevelId: Scalars['String']['output'];
  /** The level appended to carry the adjusted price. */
  successorPriceLevelId: Scalars['String']['output'];
};

/**
 * Normalized MongoDB read model for admin management of background service configs.
 * One document per service. Contains the full PodAssignments array.
 * MultiReplicaCapable is code-owned (set by the seed via Set so it
 * stays authoritative across restarts) and never accepted on a mutation input.
 */
export type AdminBackgroundServiceConfigDocument = {
  __typename?: 'AdminBackgroundServiceConfigDocument';
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  multiReplicaCapable: Scalars['Boolean']['output'];
  podAssignments: Array<PodAssignmentData>;
  scope: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  timerPeriodSeconds: Scalars['Int']['output'];
  updatedBy: Scalars['String']['output'];
  workerConfigs: Array<Scalars['String']['output']>;
};

export type AdminBackgroundServiceConfigPayload = {
  __typename?: 'AdminBackgroundServiceConfigPayload';
  data?: Maybe<BackgroundServiceConfigStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Admin view of a background service config for paginated listing. */
export type AdminBackgroundServiceConfigResult = {
  __typename?: 'AdminBackgroundServiceConfigResult';
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  podAssignmentCount: Scalars['Int']['output'];
  scope: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  timerPeriodSeconds: Scalars['Int']['output'];
  totalTenantCount: Scalars['Int']['output'];
  updatedBy: Scalars['String']['output'];
  workerConfigCount: Scalars['Int']['output'];
};

/** Admin view of a background service config for paginated listing. */
export type AdminBackgroundServiceConfigResultFilterInput = {
  and?: InputMaybe<Array<AdminBackgroundServiceConfigResultFilterInput>>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AdminBackgroundServiceConfigResultFilterInput>>;
  podAssignmentCount?: InputMaybe<IntOperationFilterInput>;
  scope?: InputMaybe<BackgroundServiceScopeOperationFilterInput>;
  serviceName?: InputMaybe<BackgroundServiceNameOperationFilterInput>;
  timerPeriodSeconds?: InputMaybe<IntOperationFilterInput>;
  totalTenantCount?: InputMaybe<IntOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  workerConfigCount?: InputMaybe<IntOperationFilterInput>;
};

/** Admin view of a background service config for paginated listing. */
export type AdminBackgroundServiceConfigResultSortInput = {
  displayName?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  podAssignmentCount?: InputMaybe<SortEnumType>;
  scope?: InputMaybe<SortEnumType>;
  serviceName?: InputMaybe<SortEnumType>;
  timerPeriodSeconds?: InputMaybe<SortEnumType>;
  totalTenantCount?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  workerConfigCount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AdminBackgroundServiceConfigsConnection = {
  __typename?: 'AdminBackgroundServiceConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminBackgroundServiceConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminBackgroundServiceConfigResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminBackgroundServiceConfigsEdge = {
  __typename?: 'AdminBackgroundServiceConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminBackgroundServiceConfigResult;
};

/**
 * Flattened admin view of background service pod assignments — one row per (pod x service)
 * pair. Drives the wsapi-admin-pwa "Pods" tab so the client can group services by pod
 * without N+1 detail calls. NotTenants is the raw exclusion flag from the
 * pod assignment; runtime exclusion math is the manifest query's job.
 */
export type AdminBackgroundServicePodResult = {
  __typename?: 'AdminBackgroundServicePodResult';
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  lastModified: Scalars['DateTime']['output'];
  notTenants: Scalars['Boolean']['output'];
  podName: Scalars['String']['output'];
  scope: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  tenantCount: Scalars['Int']['output'];
  timerPeriodSeconds: Scalars['Int']['output'];
};

/**
 * Flattened admin view of background service pod assignments — one row per (pod x service)
 * pair. Drives the wsapi-admin-pwa "Pods" tab so the client can group services by pod
 * without N+1 detail calls. NotTenants is the raw exclusion flag from the
 * pod assignment; runtime exclusion math is the manifest query's job.
 */
export type AdminBackgroundServicePodResultFilterInput = {
  and?: InputMaybe<Array<AdminBackgroundServicePodResultFilterInput>>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  notTenants?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<AdminBackgroundServicePodResultFilterInput>>;
  podName?: InputMaybe<StringOperationFilterInput>;
  scope?: InputMaybe<BackgroundServiceScopeOperationFilterInput>;
  serviceName?: InputMaybe<BackgroundServiceNameOperationFilterInput>;
  tenantCount?: InputMaybe<IntOperationFilterInput>;
  timerPeriodSeconds?: InputMaybe<IntOperationFilterInput>;
};

/**
 * Flattened admin view of background service pod assignments — one row per (pod x service)
 * pair. Drives the wsapi-admin-pwa "Pods" tab so the client can group services by pod
 * without N+1 detail calls. NotTenants is the raw exclusion flag from the
 * pod assignment; runtime exclusion math is the manifest query's job.
 */
export type AdminBackgroundServicePodResultSortInput = {
  displayName?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  notTenants?: InputMaybe<SortEnumType>;
  podName?: InputMaybe<SortEnumType>;
  scope?: InputMaybe<SortEnumType>;
  serviceName?: InputMaybe<SortEnumType>;
  tenantCount?: InputMaybe<SortEnumType>;
  timerPeriodSeconds?: InputMaybe<SortEnumType>;
};

/**
 * Bulk-create summary: Sent = emails an invite was created for (the worker emails them
 * within one tick), AlreadyInvited = emails that already have a pending unexpired invite
 * in this tenant. Whether the email already belongs to an existing FusionAuth user is detected
 * asynchronously by the worker before sending (the FusionAuth API key lives only in worker
 * config) and surfaced on the invite list.
 */
export type AdminCreateUserInvitesPayload = {
  __typename?: 'AdminCreateUserInvitesPayload';
  alreadyInvited: Array<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  invites: Array<UserInviteDocument>;
  sent: Array<Scalars['String']['output']>;
};

/** Force-recalc every row for a given (tenant, customer) across all items and locations. */
export type AdminDbrCalcForceRecalcByCustomerInput = {
  customerLookupCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Force-recalc every row for a given (tenant, item) across all customers and locations. */
export type AdminDbrCalcForceRecalcByItemInput = {
  itemLookupCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Force-recalc every row for a given (tenant, location) across all customers and items. */
export type AdminDbrCalcForceRecalcByLocationInput = {
  locationLookupCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** Force-recalc every row for a tenant. */
export type AdminDbrCalcForceRecalcByTenantInput = {
  tenantId: Scalars['String']['input'];
};

/** Force-recalc a single (tenant, customer, item, location) row. */
export type AdminDbrCalcForceRecalcRowInput = {
  customerLookupCode: Scalars['String']['input'];
  itemLookupCode: Scalars['String']['input'];
  locationLookupCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type AdminDbrCalcResultsByCustomerConnection = {
  __typename?: 'AdminDbrCalcResultsByCustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDbrCalcResultsByCustomerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDbrCalcResultsByCustomerEdge = {
  __typename?: 'AdminDbrCalcResultsByCustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminDbrCalcResultsByItemConnection = {
  __typename?: 'AdminDbrCalcResultsByItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDbrCalcResultsByItemEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDbrCalcResultsByItemEdge = {
  __typename?: 'AdminDbrCalcResultsByItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminDbrCalcResultsByLocationConnection = {
  __typename?: 'AdminDbrCalcResultsByLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDbrCalcResultsByLocationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDbrCalcResultsByLocationEdge = {
  __typename?: 'AdminDbrCalcResultsByLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminDbrCalcResultsByTenantConnection = {
  __typename?: 'AdminDbrCalcResultsByTenantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDbrCalcResultsByTenantEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDbrCalcResultsByTenantEdge = {
  __typename?: 'AdminDbrCalcResultsByTenantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminDbrCalcTenantQueueConnection = {
  __typename?: 'AdminDbrCalcTenantQueueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDbrCalcTenantQueueEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcTenantQueueDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDbrCalcTenantQueueEdge = {
  __typename?: 'AdminDbrCalcTenantQueueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcTenantQueueDocument;
};

/**
 * Result of a force-recalc admin mutation. ModifiedCount is the number
 * of RestockWorkQueueDocument rows whose LastCalcDate, LockedDate,
 * and LeaseId were unset by the call. A modified count of zero is not an error —
 * it means no rows existed yet for the requested scope; the next upsert pass (S14/S15)
 * will create them with LastCalcDate=null, which the worker filter picks up.
 */
export type AdminDbrCalcWorkPayload = {
  __typename?: 'AdminDbrCalcWorkPayload';
  errors?: Maybe<Array<ValidationError>>;
  modifiedCount: Scalars['Long']['output'];
};

export type AdminDeleteWhatsNewFeatureInput = {
  id: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type AdminDevicesConnection = {
  __typename?: 'AdminDevicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminDevicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminDevicesEdge = {
  __typename?: 'AdminDevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceDocument;
};

/**
 * One tenant and customer email kind pair: whether that email will actually send, and which of the
 * four independent gates is holding it back when it will not.
 */
export type AdminEmailDeliveryRow = {
  __typename?: 'AdminEmailDeliveryRow';
  /** Gets the tenant-scoped reasons this kind cannot send. */
  blockers: Array<OrderEmailSendBlocker>;
  /** Gets the email kind: confirmation, acknowledgment or invoice only. */
  docType: OrderEmailDocType;
  /** Gets whether the email will actually send: flag, tenant opt-in, worker coverage and no blockers. */
  effective: Scalars['Boolean']['output'];
  /** Gets the flag value resolved for this tenant. */
  flagEnabled: Scalars['Boolean']['output'];
  /** Gets the kill-switch flag that gates this kind. */
  flagName: FeatureFlagName;
  /** Gets whether the tenant is a trial tenant (a trial expiration date is set). */
  isTrial: Scalars['Boolean']['output'];
  /** Gets when this kind was last sent for the tenant, or null when it never was. */
  lastSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets whether the tenant has ever written settings for this kind. */
  tenantConfigured: Scalars['Boolean']['output'];
  /** Gets whether the tenant has switched this kind on in its notification catalog. */
  tenantEnabled: Scalars['Boolean']['output'];
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the tenant display name. */
  tenantName: Scalars['String']['output'];
  /** Gets the tenant lifecycle status. */
  tenantStatus: TenantStatus;
  /** Gets whether the background service for this kind selects this tenant. */
  workerCovers: Scalars['Boolean']['output'];
};

/** One tenant's answer for one flag, and where it comes from, for the admin flag detail. */
export type AdminFeatureFlagHolder = {
  __typename?: 'AdminFeatureFlagHolder';
  /** Whether the flag is on for the tenant. */
  enabled: Scalars['Boolean']['output'];
  /** The product that turns the flag on, when the source is PRODUCT. */
  productName?: Maybe<Scalars['String']['output']>;
  /** Where the answer comes from. */
  source: FeatureFlagHolderSource;
  /** The tenant. */
  tenantId: Scalars['String']['output'];
  /** The tenant's name. */
  tenantName: Scalars['String']['output'];
};

/** How many tenants hold one flag, and through what, for the admin Feature Flags list. */
export type AdminFeatureFlagHolderCount = {
  __typename?: 'AdminFeatureFlagHolderCount';
  /** How many tenants were counted: every tenant that is not deleted. */
  customerCount: Scalars['Int']['output'];
  /** The flag. */
  name: FeatureFlagName;
  /** How many tenants have the flag on, through any source. */
  onCount: Scalars['Int']['output'];
  /** How many tenants have it off through their own setting. */
  ownSettingOffCount: Scalars['Int']['output'];
  /** How many tenants have it on through their own setting. */
  ownSettingOnCount: Scalars['Int']['output'];
  /** How many tenants have it on through one of their products. */
  throughProductCount: Scalars['Int']['output'];
};

/** GraphQL payload for admin feature flag mutations, containing either the result data or validation errors. */
export type AdminFeatureFlagPayload = {
  __typename?: 'AdminFeatureFlagPayload';
  data?: Maybe<FeatureFlagStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Admin view of a feature flag, including status, config, enabled state, and tenant override count. */
export type AdminFeatureFlagResult = {
  __typename?: 'AdminFeatureFlagResult';
  /** The date the flag first appeared on master, as yyyy-MM-dd. */
  added: Scalars['String']['output'];
  config: Scalars['String']['output'];
  /** One line on what the flag turns on, or for a retired flag what it used to gate. */
  description: Scalars['String']['output'];
  /** The flag's plain name, such as Plan Builder for PRODUCE_PLAN_BUILDER. */
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  featureName: FeatureFlagName;
  /**
   * The 32-character id of the Helm project that adds this temporary flag. Null for standing and retired
   * flags, and for the older temporary flags that name none.
   */
  helmProjectId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**
   * What kind of flag this is: TEMPORARY while a feature is built or beta tested, removed once it is on for
   * every tenant; STANDING for a module tenants buy, a special feature or a kill switch; RETIRED once nothing
   * reads it. Declared in code with the flag, not stored.
   */
  kind: FeatureFlagKind;
  status: FeatureFlagStatus;
  tenantOverrideCount: Scalars['Int']['output'];
};

/** Admin view of a feature flag, including status, config, enabled state, and tenant override count. */
export type AdminFeatureFlagResultFilterInput = {
  and?: InputMaybe<Array<AdminFeatureFlagResultFilterInput>>;
  config?: InputMaybe<StringOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  featureName?: InputMaybe<FeatureFlagNameOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdminFeatureFlagResultFilterInput>>;
  status?: InputMaybe<FeatureFlagStatusOperationFilterInput>;
  tenantOverrideCount?: InputMaybe<IntOperationFilterInput>;
};

/** Admin view of a feature flag, including status, config, enabled state, and tenant override count. */
export type AdminFeatureFlagResultSortInput = {
  config?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  featureName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantOverrideCount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AdminFeatureFlagsConnection = {
  __typename?: 'AdminFeatureFlagsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminFeatureFlagsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminFeatureFlagResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminFeatureFlagsEdge = {
  __typename?: 'AdminFeatureFlagsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminFeatureFlagResult;
};

/** A connection to a list of items. */
export type AdminMigrationImportRunFailuresConnection = {
  __typename?: 'AdminMigrationImportRunFailuresConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminMigrationImportRunFailuresEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MigrationImportRunFailureDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminMigrationImportRunFailuresEdge = {
  __typename?: 'AdminMigrationImportRunFailuresEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MigrationImportRunFailureDocument;
};

/**
 * One Active WorkSuiteUsers directory row whose KurrentDB stream is orphaned, for the ops-repair
 * grid behind adminOrphanedUsers. DeletedAt is joined from the WorkerServices
 * DeletedStreams collection when that worker recorded the deletion; a row whose stream was wiped
 * by something other than that worker (e.g. the Reset Tenant path this surface exists for) carries no
 * such record and reads null. ProbeError is set only when StreamState is
 * Unknown.
 */
export type AdminOrphanedUserData = {
  __typename?: 'AdminOrphanedUserData';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  fusionAuthUserId?: Maybe<Scalars['String']['output']>;
  probeError?: Maybe<Scalars['String']['output']>;
  roles: Array<UserRole>;
  status: UserStatus;
  streamState: AdminOrphanedUserStreamState;
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/**
 * How the per-row stream-deletion probe behind adminOrphanedUsers resolved.
 * SoftDeleted and Tombstoned mirror the two ways a stream can be gone (the second is
 * unrepairable); Unknown means the probe itself failed — a transient KurrentDB read error, say —
 * so the row is still reported, with ProbeError carrying the failure, rather than being silently
 * dropped or failing the whole list.
 */
export enum AdminOrphanedUserStreamState {
  SoftDeleted = 'SOFT_DELETED',
  Tombstoned = 'TOMBSTONED',
  Unknown = 'UNKNOWN'
}

/**
 * The bounded-scan result behind adminOrphanedUsers: the orphaned rows found within the scan cap,
 * plus whether the cap was actually reached — so a short (or empty) Orphans list can never be
 * misread as "that's everything" when the scan was truncated before covering every Active row.
 */
export type AdminOrphanedUsersResult = {
  __typename?: 'AdminOrphanedUsersResult';
  capReached: Scalars['Boolean']['output'];
  orphans: Array<AdminOrphanedUserData>;
};

/** A connection to a list of items. */
export type AdminParentCompaniesConnection = {
  __typename?: 'AdminParentCompaniesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminParentCompaniesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ParentCompanyDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminParentCompaniesEdge = {
  __typename?: 'AdminParentCompaniesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ParentCompanyDocument;
};

/**
 * The result of a parent-company mutation. Either data carries the parent company as it
 * stands after the change, or errors describes why the mutation was refused — a refused
 * mutation never throws and never records anything.
 */
export type AdminParentCompanyPayload = {
  __typename?: 'AdminParentCompanyPayload';
  data?: Maybe<ParentCompanyStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type AdminRemoveDeviceInput = {
  deviceId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AdminRestockCalcBatchTimingsResult = {
  __typename?: 'AdminRestockCalcBatchTimingsResult';
  averageMs?: Maybe<Scalars['Long']['output']>;
  p95Ms?: Maybe<Scalars['Long']['output']>;
  sampleCount: Scalars['Int']['output'];
};

export type AdminRestockCalcForceRecalcByCustomerInput = {
  customerCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type AdminRestockCalcForceRecalcByItemInput = {
  itemCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type AdminRestockCalcForceRecalcByLocationInput = {
  locationCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type AdminRestockCalcForceRecalcByTenantInput = {
  tenantId: Scalars['String']['input'];
};

/**
 * Force-recalc a single 5-tuple. weeksOfSupply is required because the
 *             on-demand work collection is keyed by the full 5-tuple.
 */
export type AdminRestockCalcForceRecalcRowInput = {
  customerCode: Scalars['String']['input'];
  itemCode: Scalars['String']['input'];
  locationCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  weeksOfSupply: Scalars['Decimal']['input'];
};

/**
 * AR1 parity twin of WorkQueue.AdminRestockWorkQueuePayload. EnqueuedCount
 * here counts rows inserted-or-already-pending in RestockCalcOnDemandWork (legacy
 * AdminDbrCalcWorkPayload.modifiedCount counted rows whose calc-cache fields were unset
 * in RestockCalcWork). Field name carries the new semantics so the PWA can distinguish.
 */
export type AdminRestockCalcPayload = {
  __typename?: 'AdminRestockCalcPayload';
  enqueuedCount: Scalars['Long']['output'];
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueResultDocument. Same Mongo
 * collection (RestockCalcResults), same field layout — distinct C# type so HotChocolate
 * publishes a separate AdminRestockCalcResultDocument GraphQL type alongside the legacy
 * DbrCalcResultDocument while AR2/DEL2 are in flight. Both types deserialize identically
 * because BSON binds on field names; do not diverge field shapes here.
 */
export type AdminRestockCalcResultDocument = {
  __typename?: 'AdminRestockCalcResultDocument';
  achievableQuantity?: Maybe<Scalars['Int']['output']>;
  calcDate: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  demandQuantity: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  inputsSnapshot: Array<AdminRestockCalcResultInputDocument>;
  itemCode: Scalars['String']['output'];
  locationCode: Scalars['String']['output'];
  strategyKey: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  weeksOfSupply: Scalars['Decimal']['output'];
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueResultDocument. Same Mongo
 * collection (RestockCalcResults), same field layout — distinct C# type so HotChocolate
 * publishes a separate AdminRestockCalcResultDocument GraphQL type alongside the legacy
 * DbrCalcResultDocument while AR2/DEL2 are in flight. Both types deserialize identically
 * because BSON binds on field names; do not diverge field shapes here.
 */
export type AdminRestockCalcResultDocumentFilterInput = {
  achievableQuantity?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<AdminRestockCalcResultDocumentFilterInput>>;
  calcDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  demandQuantity?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inputsSnapshot?: InputMaybe<ListFilterInputTypeOfAdminRestockCalcResultInputDocumentFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  locationCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdminRestockCalcResultDocumentFilterInput>>;
  strategyKey?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  weeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueResultDocument. Same Mongo
 * collection (RestockCalcResults), same field layout — distinct C# type so HotChocolate
 * publishes a separate AdminRestockCalcResultDocument GraphQL type alongside the legacy
 * DbrCalcResultDocument while AR2/DEL2 are in flight. Both types deserialize identically
 * because BSON binds on field names; do not diverge field shapes here.
 */
export type AdminRestockCalcResultDocumentSortInput = {
  achievableQuantity?: InputMaybe<SortEnumType>;
  calcDate?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  demandQuantity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCode?: InputMaybe<SortEnumType>;
  locationCode?: InputMaybe<SortEnumType>;
  strategyKey?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  weeksOfSupply?: InputMaybe<SortEnumType>;
};

export type AdminRestockCalcResultInputDocument = {
  __typename?: 'AdminRestockCalcResultInputDocument';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdminRestockCalcResultInputDocumentFilterInput = {
  and?: InputMaybe<Array<AdminRestockCalcResultInputDocumentFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdminRestockCalcResultInputDocumentFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type AdminRestockCalcResultsByCustomerConnection = {
  __typename?: 'AdminRestockCalcResultsByCustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockCalcResultsByCustomerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockCalcResultsByCustomerEdge = {
  __typename?: 'AdminRestockCalcResultsByCustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminRestockCalcResultsByItemConnection = {
  __typename?: 'AdminRestockCalcResultsByItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockCalcResultsByItemEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockCalcResultsByItemEdge = {
  __typename?: 'AdminRestockCalcResultsByItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminRestockCalcResultsByLocationConnection = {
  __typename?: 'AdminRestockCalcResultsByLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockCalcResultsByLocationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockCalcResultsByLocationEdge = {
  __typename?: 'AdminRestockCalcResultsByLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockCalcResultDocument;
};

/** A connection to a list of items. */
export type AdminRestockCalcResultsByTenantConnection = {
  __typename?: 'AdminRestockCalcResultsByTenantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockCalcResultsByTenantEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockCalcResultsByTenantEdge = {
  __typename?: 'AdminRestockCalcResultsByTenantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockCalcResultDocument;
};

/** AR1 parity twin of WorkQueue.RestockWorkQueueSchedulerStatusResult. */
export type AdminRestockCalcSchedulerStatusResult = {
  __typename?: 'AdminRestockCalcSchedulerStatusResult';
  lastSuccessfulTick?: Maybe<Scalars['DateTime']['output']>;
  lastTick?: Maybe<Scalars['DateTime']['output']>;
  lastTickSucceeded?: Maybe<Scalars['Boolean']['output']>;
  tickIntervalMs?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type AdminRestockCalcTenantQueueConnection = {
  __typename?: 'AdminRestockCalcTenantQueueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockCalcTenantQueueEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockCalcTenantQueueDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueTenantDocument. Same Mongo
 * collection (RestockCalcTenantQueue), same field layout — distinct C# type so
 * HotChocolate publishes a separate AdminRestockCalcTenantQueueDocument GraphQL type
 * alongside the legacy DbrCalcTenantQueueDocument.
 */
export type AdminRestockCalcTenantQueueDocument = {
  __typename?: 'AdminRestockCalcTenantQueueDocument';
  enabled: Scalars['Boolean']['output'];
  hasPendingWork: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  maxStalenessHours: Scalars['Int']['output'];
  oldestPendingCalcDate?: Maybe<Scalars['DateTime']['output']>;
  priority: Scalars['Int']['output'];
  refreshHours: Scalars['Int']['output'];
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueTenantDocument. Same Mongo
 * collection (RestockCalcTenantQueue), same field layout — distinct C# type so
 * HotChocolate publishes a separate AdminRestockCalcTenantQueueDocument GraphQL type
 * alongside the legacy DbrCalcTenantQueueDocument.
 */
export type AdminRestockCalcTenantQueueDocumentFilterInput = {
  and?: InputMaybe<Array<AdminRestockCalcTenantQueueDocumentFilterInput>>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  hasPendingWork?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  maxStalenessHours?: InputMaybe<IntOperationFilterInput>;
  oldestPendingCalcDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AdminRestockCalcTenantQueueDocumentFilterInput>>;
  priority?: InputMaybe<IntOperationFilterInput>;
  refreshHours?: InputMaybe<IntOperationFilterInput>;
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueTenantDocument. Same Mongo
 * collection (RestockCalcTenantQueue), same field layout — distinct C# type so
 * HotChocolate publishes a separate AdminRestockCalcTenantQueueDocument GraphQL type
 * alongside the legacy DbrCalcTenantQueueDocument.
 */
export type AdminRestockCalcTenantQueueDocumentSortInput = {
  enabled?: InputMaybe<SortEnumType>;
  hasPendingWork?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxStalenessHours?: InputMaybe<SortEnumType>;
  oldestPendingCalcDate?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  refreshHours?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type AdminRestockCalcTenantQueueEdge = {
  __typename?: 'AdminRestockCalcTenantQueueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockCalcTenantQueueDocument;
};

/**
 * AR1 parity twin of WorkQueue.RestockWorkQueueSummary exposed by
 * AdminRestockCalcTenantQuery.GetAdminRestockCalcWorkSummary.
 */
export type AdminRestockCalcWorkSummary = {
  __typename?: 'AdminRestockCalcWorkSummary';
  hasPendingWork: Scalars['Boolean']['output'];
  oldestPending?: Maybe<Scalars['DateTime']['output']>;
};

/** AR1 parity twin of WorkQueue.RestockWorkQueueWorkerFleetStatusResult. */
export type AdminRestockCalcWorkerFleetStatusResult = {
  __typename?: 'AdminRestockCalcWorkerFleetStatusResult';
  currentLeases: Scalars['Int']['output'];
  oldestLeaseAgeMs?: Maybe<Scalars['Long']['output']>;
  recentBatchTimings: AdminRestockCalcBatchTimingsResult;
  recentIterationCount: Scalars['Int']['output'];
};

/**
 * Cross-tenant SuperAdmin payload for adminRestockDataValidity. Summary is
 * null only when input validation fails; per-check Mongo failures degrade that check to
 * Unknown inside the service rather than failing the query.
 */
export type AdminRestockDataValidityPayload = {
  __typename?: 'AdminRestockDataValidityPayload';
  errors?: Maybe<Array<ValidationError>>;
  summary?: Maybe<RestockDataValiditySummary>;
};

/**
 * Seeds Restock import data for a tenant. LocationCodes are per-store ErpIds (the values
 * surfaced by adminRestockSeedingCustomerLocations); empty means ALL resolvable
 * restock-configured stores of the selected customers (server-side expansion).
 * DryRun defaults to true: preview counts without writing.
 */
export type AdminRestockSeedImportDataInput = {
  customerCodes: Array<Scalars['String']['input']>;
  days?: Scalars['Int']['input'];
  dryRun?: Scalars['Boolean']['input'];
  itemCodes: Array<Scalars['String']['input']>;
  itemCost?: Scalars['Decimal']['input'];
  locationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId: Scalars['String']['input'];
  unitsOnHand?: Scalars['Int']['input'];
  unitsPerDay?: Scalars['Int']['input'];
};

export type AdminRestockSeedImportDataPayload = {
  __typename?: 'AdminRestockSeedImportDataPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<AdminRestockSeedImportDataResult>;
};

/**
 * Outcome of a seed request: the expanded scope, per-collection upsert counts (zero in dry-run),
 * the seeded date window, the deterministic validation target
 * (ExpectedWeeklyRateOfSale = 7 × unitsPerDay), and non-fatal warnings
 * (unconfigured tuples skipped, items without availability).
 */
export type AdminRestockSeedImportDataResult = {
  __typename?: 'AdminRestockSeedImportDataResult';
  customerCount: Scalars['Int']['output'];
  dayCount: Scalars['Int']['output'];
  documentsPerCollection: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  expectedWeeklyRateOfSale: Scalars['Decimal']['output'];
  inventoryStatesModified: Scalars['Long']['output'];
  inventoryStatesUpserted: Scalars['Long']['output'];
  itemCount: Scalars['Int']['output'];
  locationTupleCount: Scalars['Int']['output'];
  transactionSummariesModified: Scalars['Long']['output'];
  transactionSummariesUpserted: Scalars['Long']['output'];
  warnings: Array<Scalars['String']['output']>;
  windowEndUtc: Scalars['DateTime']['output'];
  windowStartUtc: Scalars['DateTime']['output'];
};

/** A connection to a list of items. */
export type AdminRestockSeedingCustomerLocationsConnection = {
  __typename?: 'AdminRestockSeedingCustomerLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockSeedingCustomerLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockSeedingCustomerResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockSeedingCustomerLocationsEdge = {
  __typename?: 'AdminRestockSeedingCustomerLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockSeedingCustomerResult;
};

/**
 * A restock-configured customer with its per-store locations, for the seeding page dropdowns.
 * Sourced from RestockCustomerLocations joined per store to CustomersSummary; only stores with a
 * resolvable ErpId (the seed/dashboard key) are surfaced, so every selectable store can flow.
 */
export type AdminRestockSeedingCustomerResult = {
  __typename?: 'AdminRestockSeedingCustomerResult';
  customerLookupCode: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  locations: Array<AdminRestockSeedingLocationResult>;
};

/**
 * An item selectable for seeding. HasAvailability badges items with at least one
 * positive-quantity RestockAvailability row — items without it will seed demand but keep a
 * null achievable (allocation requires greenhouse availability).
 */
export type AdminRestockSeedingItemResult = {
  __typename?: 'AdminRestockSeedingItemResult';
  hasAvailability: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  itemLookupCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type AdminRestockSeedingItemsConnection = {
  __typename?: 'AdminRestockSeedingItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminRestockSeedingItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminRestockSeedingItemResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminRestockSeedingItemsEdge = {
  __typename?: 'AdminRestockSeedingItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminRestockSeedingItemResult;
};

/**
 * Kicks the daily pre-calc pipeline for a tenant so freshly seeded import data flows the same
 * day: clears today's RestockPreCalculation success marker and satisfies the InventoryState
 * dependency. CustomerCodes scopes which seeded customers the admin is acting on (for
 * validation and the audit log); the next pre-calc tick picks up their data.
 */
export type AdminRestockSeedingKickPipelineInput = {
  customerCodes: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type AdminRestockSeedingKickPipelinePayload = {
  __typename?: 'AdminRestockSeedingKickPipelinePayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<AdminRestockSeedingKickPipelineResult>;
};

/**
 * Outcome of a pipeline kick: which markers were cleared/written and the refreshed pipeline
 * status block.
 */
export type AdminRestockSeedingKickPipelineResult = {
  __typename?: 'AdminRestockSeedingKickPipelineResult';
  inventoryStateSyntheticWritten: Scalars['Boolean']['output'];
  preCalcMarkersCleared: Scalars['Long']['output'];
  status: AdminRestockSeedingPipelineStatusResult;
};

/**
 * A restock-configured store belonging to a seeding-page customer. LocationLookupCode is
 * the store's CustomersSummary.ErpId — the per-store key the seed write and the dashboard
 * store-row join use, echoed back as AdminRestockSeedImportDataInput.LocationCodes to
 * narrow to a single store. StoreNumber is for display only.
 */
export type AdminRestockSeedingLocationResult = {
  __typename?: 'AdminRestockSeedingLocationResult';
  locationLookupCode: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  storeNumber: Scalars['String']['output'];
};

/**
 * One pipeline entity's state. TodaySatisfied mirrors the wsapi-services daily guard:
 * any successful iteration ending within today UTC.
 */
export type AdminRestockSeedingPipelineEntityStatus = {
  __typename?: 'AdminRestockSeedingPipelineEntityStatus';
  entity: Scalars['String']['output'];
  lastIteration?: Maybe<AdminRestockSeedingPipelineIterationInfo>;
  todaySatisfied: Scalars['Boolean']['output'];
};

/** The most recent iteration of a pipeline entity, successful or not. */
export type AdminRestockSeedingPipelineIterationInfo = {
  __typename?: 'AdminRestockSeedingPipelineIterationInfo';
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  error: Scalars['String']['output'];
  itemsProcessed: Scalars['Long']['output'];
  start: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * Per-entity pipeline state for a tenant: the last iteration of each daily-chain worker and
 * whether its today-UTC guard is satisfied. Explains why seeded data is not flowing and shows
 * post-kick progress.
 */
export type AdminRestockSeedingPipelineStatusResult = {
  __typename?: 'AdminRestockSeedingPipelineStatusResult';
  entities: Array<AdminRestockSeedingPipelineEntityStatus>;
  todayUtc: Scalars['DateTime']['output'];
};

export type AdminSaveWhatsNewFeatureInput = {
  /** Required for a release label that doesn't exist yet; otherwise the release's date is used. */
  effectiveOn?: InputMaybe<Scalars['LocalDate']['input']>;
  feature: WhatsNewFeatureInput;
  /** Null to add. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Required unless feature.comingSoon. */
  releaseLabel?: InputMaybe<Scalars['String']['input']>;
};

export type AdminSetCompanySlugInput = {
  companySlug: Scalars['String']['input'];
};

export type AdminSetWhatsNewEmailRecipientInput = {
  email: Scalars['String']['input'];
  subscribed: Scalars['Boolean']['input'];
  tenantId: Scalars['String']['input'];
};

export type AdminSetWhatsNewReleaseEffectiveOnInput = {
  effectiveOn: Scalars['LocalDate']['input'];
  label: Scalars['String']['input'];
};

/** MongoDB read model for cross-tenant admin queries. Projected from Tenant event stream. */
export type AdminTenantDocument = {
  __typename?: 'AdminTenantDocument';
  allowOrderBillingAddressEdit: Scalars['Boolean']['output'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['output'];
  /**
   * Per-tenant platform-billing state (Stripe linkage, rate card, active cadence, subscription
   * status, last payment). Nullable so pre-feature BSON documents deserialize cleanly to null;
   * initialized to an empty billing state when a tenant is created. Set by the billing event
   * handlers in AdminTenantProjectionService.
   */
  billing?: Maybe<TenantBillingData>;
  /**
   * Tenant-configured business time zone (decision D's zone source), as a validated IANA id.
   * null means never configured — NEVER read as UTC.
   */
  businessTimeZone?: Maybe<Scalars['String']['output']>;
  /**
   * The modules and add-ons this tenant contracted for. Once the tenant's WorkSuite products are set it is their
   * names as the product catalog has them now: the products every tenant has first, then catalog order, so it
   * follows a product rename without the tenant being saved. Before that it is whatever staff typed, and empty
   * means not typed. Free text — never parsed into a structured list. Filtering and sorting on it match the text
   * as last saved, which trails a product rename until the tenant's products are saved again.
   */
  contractedProducts: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  /**
   * The tenant's customer texting setup: toll-free number, Messaging Service SID, verified business
   * name, state and submitted date. Null for a tenant that never had one set.
   */
  customerTexting?: Maybe<CustomerTextingData>;
  /** The tenant-level default freight charge type, or null if not configured. */
  defaultFreightChargeType?: Maybe<Scalars['Int']['output']>;
  /** The tenant-level default freight charge value. */
  defaultFreightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The tenant default minimum freight charge, applied once per order. A customer override wins
   * over it. Null means no minimum is configured.
   */
  defaultMinimumFreightCharge?: Maybe<Scalars['Decimal']['output']>;
  /** Whether fernie's suggestions show for this company. On by default. Off hides every fernie suggestion for everyone at the company. Set with updateFernieSuggestionsOn. */
  fernieSuggestionsOn: Scalars['Boolean']['output'];
  finalCreditEnabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  maxDiscountPercentage: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  /**
   * The last day of onboarding help mode, as staff picked it (local midnight with its offset).
   * Null means help mode was never turned on or was cleared.
   */
  onboardingHelpUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   * How far the tenant has progressed through onboarding data setup. UNKNOWN means unset,
   * which is what every tenant created before new tenants started at NOT_STARTED reads.
   */
  onboardingSetup: OnboardingSetupStage;
  /**
   * How far the tenant has progressed through onboarding training. Independent of the data-setup
   * stage; UNKNOWN means unset.
   */
  onboardingTraining: OnboardingTrainingStatus;
  /**
   * The files the grower delivered through the onboarding card, oldest first. Empty for a tenant
   * that has uploaded nothing.
   */
  onboardingUploads: Array<TenantOnboardingUploadData>;
  /**
   * Report aggregate ID rendered as the Orders page acknowledgement PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderAcknowledgementReportId: Scalars['String']['output'];
  /**
   * Report aggregate ID rendered as the Orders page invoice PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderInvoiceReportId: Scalars['String']['output'];
  /**
   * Report aggregate ID rendered as the Orders page Pro Forma PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderProFormaReportId: Scalars['String']['output'];
  /**
   * Report aggregate ID rendered as the Orders page pull slip PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderPullSlipReportId: Scalars['String']['output'];
  /**
   * Per-tenant policy for missing OrganicLotCode on an organic VPO receive item.
   * Defaults to OrganicReceiveMode.Warn so pre-feature BSON documents
   * deserialize cleanly. The receive validation layer reads this field.
   */
  organicReceiveMode: OrganicReceiveMode;
  /**
   * The parent company this tenant belongs to, or empty when it belongs to none. Set with
   * setAdminTenantParentCompany; filterable via adminTenants(where: { parentCompanyId }).
   */
  parentCompanyId: Scalars['String']['output'];
  /**
   * Tenant-configured maximum length for sales-order and master-order PO numbers.
   * Default: 64 — current/unchanged behavior for tenants that have not configured this.
   */
  poNumberMaxLength: Scalars['Int']['output'];
  /**
   * Tenant-configured number of decimals used when rounding price calculations.
   * Default: 2 — current/unchanged (cent-rounded) behavior for tenants that have not
   * configured this. Governs ApplyPercentOff rounding only, never display.
   */
  pricingCalcDecimals: Scalars['Int']['output'];
  /** Whether matching item numbers link automatically. On when never configured. */
  produceAutoLinkMatchingNumbers: Scalars['Boolean']['output'];
  produceEnabled: Scalars['Boolean']['output'];
  /**
   * Who can create a production plan from an order. Defaults to anyone who can open the order, which is
   * the behaviour every tenant had before this setting existed.
   */
  producePlanFromOrderAccess: ProducePlanFromOrderAccess;
  /**
   * True when a production entry made by someone without production-admin rights is held for review by a
   * production admin. Default: false, today's behaviour.
   */
  produceProductionEntryReview: Scalars['Boolean']['output'];
  /** How many decimals PRODUCE quantities display with on reports (0 to 4). Display only. */
  produceQuantityDecimals: Scalars['Int']['output'];
  /**
   * How a produced quantity rounds on the production schedule. Defaults to rounding up to a full
   * container/tray, which is the behaviour every tenant had before this setting existed.
   */
  produceRounding: ProduceRoundingMode;
  /**
   * Which quantity the space plan consumes bench for. Defaults to ProduceQuantity — the
   * yield-adjusted quantity to produce — which is the behaviour every tenant had before this
   * setting existed.
   */
  produceSpaceConsumptionBasis: ProduceSpaceConsumptionBasis;
  /** The day a production week is displayed from: Monday, Saturday or Sunday. Default: Monday. */
  produceWeekDisplayAnchor: ProduceWeekDisplayAnchor;
  /** The tenant's chosen Purchase Order design. Empty = the built-in design. */
  purchaseOrderReportId: Scalars['String']['output'];
  /** Per-tenant feature gate for the Demand-Based Replenishment Engine. Default: false. */
  restockCalcEnabled: Scalars['Boolean']['output'];
  /**
   * Maximum allowable staleness of RestockCalc results before they are considered invalid, in hours.
   * Must be >= TenantState.MinRestockCalcHours and >= RestockCalcRefreshHours
   * (enforced by the PatchTenant invariant guard).
   * Default: TenantState.DefaultRestockCalcMaxStalenessHours.
   */
  restockCalcMaxStalenessHours: Scalars['Int']['output'];
  /**
   * RestockCalc cache refresh interval, in hours. Must be >= TenantState.MinRestockCalcHours
   * (enforced by ValidInt). Default: TenantState.DefaultRestockCalcRefreshHours.
   */
  restockCalcRefreshHours: Scalars['Int']['output'];
  /**
   * Identifier selecting which RestockCalc strategy implementation processes this tenant.
   * Free-form for now; will tighten to a registered set once additional strategies land.
   * Default: TenantState.DefaultRestockCalcStrategyKey.
   */
  restockCalcStrategyKey: Scalars['String']['output'];
  /**
   * Per-tenant Restock IRosProvider selection (keyed-DI key plus opaque per-provider
   * JSON). Nullable so pre-feature BSON documents deserialize cleanly; session creation
   * falls through to the default key statistical-v1 when this is null.
   */
  restockProviderSettings?: Maybe<RestockProviderSettingsData>;
  status: TenantStatus;
  /**
   * Per-tenant Stripe Connect state — the tenant's own connected account (acct_…) and
   * the Stripe Tax readiness observed on it. Nullable so pre-feature BSON documents deserialize
   * cleanly to null; initialized to an empty connect state when a tenant is created. Set by the
   * Stripe-connect event handlers in AdminTenantProjectionService.
   *
   * This is the field the inbound account.updated webhook resolves a tenant by — the Connect
   * analogue of the Billing.StripeCustomerId lookup — so it must be projected even though the
   * tenant-facing query reads the aggregate directly.
   */
  stripeConnect?: Maybe<TenantStripeConnectData>;
  /**
   * Whether the tenant tracks shipment weight. Off (the default) hides weight totals and weight gap warnings
   * in Fulfill and lists no item weight gaps in Missing Data.
   */
  trackShipmentWeight: Scalars['Boolean']['output'];
  /**
   * When an expired trial's tenant data was manually deleted, stamped by an administrator. Null
   * means no deletion has been recorded. Lets the Trial Tenants grid separate "expired, data
   * still present" from "expired and cleaned up"; deletion itself stays a manual operation.
   */
  trialDataDeletedDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * When the tenant's self-serve trial expires. Null means a real (non-trial) tenant —
   * presence of a date is what marks a trial tenant; there is no separate tenant-type field.
   * Nullable so pre-feature BSON documents deserialize cleanly. The trial-expiry worker
   * filters on Status == Active && TrialExpirationDate <= now, then
   * inactivates the tenant so it drops out of that filter.
   */
  trialExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Which trial policy the tenant runs under. Persisted as a STRING (not the ordinal) so the
   * admin surfaces and follow-on trial-enforcement consumers read a stable, self-describing
   * value. Null means no kind was ever stamped — read that as
   * Standard, the restrictive default, so trials
   * provisioned before this field existed stay bounded with no backfill.
   */
  trialKind?: Maybe<TrialKind>;
  /**
   * Per-tenant overrides for the trial creation caps. Null means the tenant has no overrides and
   * every category falls through to the TrialPolicy default for its kind; a null category inside
   * the object means the same thing for that one category. Nullable so pre-feature BSON
   * documents deserialize cleanly.
   */
  trialLimits?: Maybe<TrialLimitsData>;
  /**
   * Per-tenant unit configuration for the restock / replenishment pipeline.
   * Nullable so pre-feature BSON documents (written before this field existed)
   * deserialize cleanly to null. Consumers should use FetchUnitConfigOrDefaultAsync
   * which falls back to TenantUnitConfig.AllTrays.
   */
  unitConfig?: Maybe<TenantUnitConfigData>;
  useErpPricing: Scalars['Boolean']['output'];
  /**
   * The ids of the WorkSuite products this tenant has, in catalog order, without the products every
   * tenant has. Empty for a tenant whose products were never set.
   */
  workSuiteProductIds: Array<Scalars['String']['output']>;
};

/** MongoDB read model for cross-tenant admin queries. Projected from Tenant event stream. */
export type AdminTenantDocumentFilterInput = {
  allowOrderBillingAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  allowOrderLocationAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AdminTenantDocumentFilterInput>>;
  /**
   * Per-tenant platform-billing state (Stripe linkage, rate card, active cadence, subscription
   * status, last payment). Nullable so pre-feature BSON documents deserialize cleanly to null;
   * initialized to an empty billing state when a tenant is created. Set by the billing event
   * handlers in AdminTenantProjectionService.
   */
  billing?: InputMaybe<TenantBillingDataFilterInput>;
  /**
   * Tenant-configured business time zone (decision D's zone source), as a validated IANA id.
   * null means never configured — NEVER read as UTC.
   */
  businessTimeZone?: InputMaybe<StringOperationFilterInput>;
  /**
   * The modules and add-ons this tenant contracted for, as last saved: once the tenant's WorkSuite products
   * are set, the product names its last products save wrote, the products every tenant has first, in catalog
   * order. Before that it is whatever staff typed, and empty means not typed. Free text — never parsed into a
   * structured list. Filtering and sorting match this saved text, which trails a product rename until the
   * tenant's products are saved again.
   */
  contractedProducts?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The tenant's customer texting setup: toll-free number, Messaging Service SID, verified business
   * name, state and submitted date. Null for a tenant that never had one set.
   */
  customerTexting?: InputMaybe<CustomerTextingDataFilterInput>;
  /** The tenant-level default freight charge type, or null if not configured. */
  defaultFreightChargeType?: InputMaybe<IntOperationFilterInput>;
  /** The tenant-level default freight charge value. */
  defaultFreightChargeValue?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The tenant default minimum freight charge, applied once per order. A customer override wins
   * over it. Null means no minimum is configured.
   */
  defaultMinimumFreightCharge?: InputMaybe<DecimalOperationFilterInput>;
  /** Whether fernie's suggestions show for this company. On by default. Off hides every fernie suggestion for everyone at the company. Set with updateFernieSuggestionsOn. */
  fernieSuggestionsOn?: InputMaybe<BooleanOperationFilterInput>;
  finalCreditEnabled?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  maxDiscountPercentage?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  /**
   * The last day of onboarding help mode, as staff picked it (local midnight with its offset).
   * Null means help mode was never turned on or was cleared.
   */
  onboardingHelpUntil?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * How far the tenant has progressed through onboarding data setup. UNKNOWN means unset,
   * which is what every tenant created before new tenants started at NOT_STARTED reads.
   */
  onboardingSetup?: InputMaybe<OnboardingSetupStageOperationFilterInput>;
  /**
   * How far the tenant has progressed through onboarding training. Independent of the data-setup
   * stage; UNKNOWN means unset.
   */
  onboardingTraining?: InputMaybe<OnboardingTrainingStatusOperationFilterInput>;
  /**
   * The files the grower delivered through the onboarding card, oldest first. Empty for a tenant
   * that has uploaded nothing.
   */
  onboardingUploads?: InputMaybe<ListFilterInputTypeOfTenantOnboardingUploadDataFilterInput>;
  or?: InputMaybe<Array<AdminTenantDocumentFilterInput>>;
  /**
   * Report aggregate ID rendered as the Orders page acknowledgement PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderAcknowledgementReportId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Report aggregate ID rendered as the Orders page invoice PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderInvoiceReportId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Report aggregate ID rendered as the Orders page Pro Forma PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderProFormaReportId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Report aggregate ID rendered as the Orders page pull slip PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderPullSlipReportId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Per-tenant policy for missing OrganicLotCode on an organic VPO receive item.
   * Defaults to OrganicReceiveMode.Warn so pre-feature BSON documents
   * deserialize cleanly. The receive validation layer reads this field.
   */
  organicReceiveMode?: InputMaybe<OrganicReceiveModeOperationFilterInput>;
  /**
   * The parent company this tenant belongs to, or empty when it belongs to none. Set with
   * setAdminTenantParentCompany; filterable via adminTenants(where: { parentCompanyId }).
   */
  parentCompanyId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Tenant-configured maximum length for sales-order and master-order PO numbers.
   * Default: 64 — current/unchanged behavior for tenants that have not configured this.
   */
  poNumberMaxLength?: InputMaybe<IntOperationFilterInput>;
  /**
   * Tenant-configured number of decimals used when rounding price calculations.
   * Default: 2 — current/unchanged (cent-rounded) behavior for tenants that have not
   * configured this. Governs ApplyPercentOff rounding only, never display.
   */
  pricingCalcDecimals?: InputMaybe<IntOperationFilterInput>;
  /** Whether matching item numbers link automatically. On when never configured. */
  produceAutoLinkMatchingNumbers?: InputMaybe<BooleanOperationFilterInput>;
  produceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Who can create a production plan from an order. Defaults to anyone who can open the order, which is
   * the behaviour every tenant had before this setting existed.
   */
  producePlanFromOrderAccess?: InputMaybe<ProducePlanFromOrderAccessOperationFilterInput>;
  /**
   * True when a production entry made by someone without production-admin rights is held for review by a
   * production admin. Default: false, today's behaviour.
   */
  produceProductionEntryReview?: InputMaybe<BooleanOperationFilterInput>;
  /** How many decimals PRODUCE quantities display with on reports (0 to 4). Display only. */
  produceQuantityDecimals?: InputMaybe<IntOperationFilterInput>;
  /**
   * How a produced quantity rounds on the production schedule. Defaults to rounding up to a full
   * container/tray, which is the behaviour every tenant had before this setting existed.
   */
  produceRounding?: InputMaybe<ProduceRoundingModeOperationFilterInput>;
  /**
   * Which quantity the space plan consumes bench for. Defaults to ProduceQuantity — the
   * yield-adjusted quantity to produce — which is the behaviour every tenant had before this
   * setting existed.
   */
  produceSpaceConsumptionBasis?: InputMaybe<ProduceSpaceConsumptionBasisOperationFilterInput>;
  /** The day a production week is displayed from: Monday, Saturday or Sunday. Default: Monday. */
  produceWeekDisplayAnchor?: InputMaybe<ProduceWeekDisplayAnchorOperationFilterInput>;
  /** The tenant's chosen Purchase Order design. Empty = the built-in design. */
  purchaseOrderReportId?: InputMaybe<StringOperationFilterInput>;
  /** Per-tenant feature gate for the Demand-Based Replenishment Engine. Default: false. */
  restockCalcEnabled?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Maximum allowable staleness of RestockCalc results before they are considered invalid, in hours.
   * Must be >= TenantState.MinRestockCalcHours and >= RestockCalcRefreshHours
   * (enforced by the PatchTenant invariant guard).
   * Default: TenantState.DefaultRestockCalcMaxStalenessHours.
   */
  restockCalcMaxStalenessHours?: InputMaybe<IntOperationFilterInput>;
  /**
   * RestockCalc cache refresh interval, in hours. Must be >= TenantState.MinRestockCalcHours
   * (enforced by ValidInt). Default: TenantState.DefaultRestockCalcRefreshHours.
   */
  restockCalcRefreshHours?: InputMaybe<IntOperationFilterInput>;
  /**
   * Identifier selecting which RestockCalc strategy implementation processes this tenant.
   * Free-form for now; will tighten to a registered set once additional strategies land.
   * Default: TenantState.DefaultRestockCalcStrategyKey.
   */
  restockCalcStrategyKey?: InputMaybe<StringOperationFilterInput>;
  /**
   * Per-tenant Restock IRosProvider selection (keyed-DI key plus opaque per-provider
   * JSON). Nullable so pre-feature BSON documents deserialize cleanly; session creation
   * falls through to the default key statistical-v1 when this is null.
   */
  restockProviderSettings?: InputMaybe<RestockProviderSettingsDataFilterInput>;
  status?: InputMaybe<TenantStatusOperationFilterInput>;
  /**
   * Per-tenant Stripe Connect state — the tenant's own connected account (acct_…) and
   * the Stripe Tax readiness observed on it. Nullable so pre-feature BSON documents deserialize
   * cleanly to null; initialized to an empty connect state when a tenant is created. Set by the
   * Stripe-connect event handlers in AdminTenantProjectionService.
   *
   * This is the field the inbound account.updated webhook resolves a tenant by — the Connect
   * analogue of the Billing.StripeCustomerId lookup — so it must be projected even though the
   * tenant-facing query reads the aggregate directly.
   */
  stripeConnect?: InputMaybe<TenantStripeConnectDataFilterInput>;
  /**
   * Whether the tenant tracks shipment weight. Off (the default) hides weight totals and weight gap warnings
   * in Fulfill and lists no item weight gaps in Missing Data.
   */
  trackShipmentWeight?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * When an expired trial's tenant data was manually deleted, stamped by an administrator. Null
   * means no deletion has been recorded. Lets the Trial Tenants grid separate "expired, data
   * still present" from "expired and cleaned up"; deletion itself stays a manual operation.
   */
  trialDataDeletedDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * When the tenant's self-serve trial expires. Null means a real (non-trial) tenant —
   * presence of a date is what marks a trial tenant; there is no separate tenant-type field.
   * Nullable so pre-feature BSON documents deserialize cleanly. The trial-expiry worker
   * filters on Status == Active && TrialExpirationDate <= now, then
   * inactivates the tenant so it drops out of that filter.
   */
  trialExpirationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Which trial policy the tenant runs under. Persisted as a STRING (not the ordinal) so the
   * admin surfaces and follow-on trial-enforcement consumers read a stable, self-describing
   * value. Null means no kind was ever stamped — read that as
   * Standard, the restrictive default, so trials
   * provisioned before this field existed stay bounded with no backfill.
   */
  trialKind?: InputMaybe<NullableOfTrialKindOperationFilterInput>;
  /**
   * Per-tenant overrides for the trial creation caps. Null means the tenant has no overrides and
   * every category falls through to the TrialPolicy default for its kind; a null category inside
   * the object means the same thing for that one category. Nullable so pre-feature BSON
   * documents deserialize cleanly.
   */
  trialLimits?: InputMaybe<TrialLimitsDataFilterInput>;
  /**
   * Per-tenant unit configuration for the restock / replenishment pipeline.
   * Nullable so pre-feature BSON documents (written before this field existed)
   * deserialize cleanly to null. Consumers should use FetchUnitConfigOrDefaultAsync
   * which falls back to TenantUnitConfig.AllTrays.
   */
  unitConfig?: InputMaybe<TenantUnitConfigDataFilterInput>;
  useErpPricing?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The ids of the WorkSuite products this tenant has, in catalog order, without the products every
   * tenant has. Empty for a tenant whose products were never set.
   */
  workSuiteProductIds?: InputMaybe<ListStringOperationFilterInput>;
};

/** MongoDB read model for cross-tenant admin queries. Projected from Tenant event stream. */
export type AdminTenantDocumentSortInput = {
  allowOrderBillingAddressEdit?: InputMaybe<SortEnumType>;
  allowOrderLocationAddressEdit?: InputMaybe<SortEnumType>;
  /**
   * Per-tenant platform-billing state (Stripe linkage, rate card, active cadence, subscription
   * status, last payment). Nullable so pre-feature BSON documents deserialize cleanly to null;
   * initialized to an empty billing state when a tenant is created. Set by the billing event
   * handlers in AdminTenantProjectionService.
   */
  billing?: InputMaybe<TenantBillingDataSortInput>;
  /**
   * Tenant-configured business time zone (decision D's zone source), as a validated IANA id.
   * null means never configured — NEVER read as UTC.
   */
  businessTimeZone?: InputMaybe<SortEnumType>;
  /**
   * The modules and add-ons this tenant contracted for, as last saved: once the tenant's WorkSuite products
   * are set, the product names its last products save wrote, the products every tenant has first, in catalog
   * order. Before that it is whatever staff typed, and empty means not typed. Free text — never parsed into a
   * structured list. Filtering and sorting match this saved text, which trails a product rename until the
   * tenant's products are saved again.
   */
  contractedProducts?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  /**
   * The tenant's customer texting setup: toll-free number, Messaging Service SID, verified business
   * name, state and submitted date. Null for a tenant that never had one set.
   */
  customerTexting?: InputMaybe<CustomerTextingDataSortInput>;
  /** The tenant-level default freight charge type, or null if not configured. */
  defaultFreightChargeType?: InputMaybe<SortEnumType>;
  /** The tenant-level default freight charge value. */
  defaultFreightChargeValue?: InputMaybe<SortEnumType>;
  /**
   * The tenant default minimum freight charge, applied once per order. A customer override wins
   * over it. Null means no minimum is configured.
   */
  defaultMinimumFreightCharge?: InputMaybe<SortEnumType>;
  /** Whether fernie's suggestions show for this company. On by default. Off hides every fernie suggestion for everyone at the company. Set with updateFernieSuggestionsOn. */
  fernieSuggestionsOn?: InputMaybe<SortEnumType>;
  finalCreditEnabled?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxDiscountPercentage?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /**
   * The last day of onboarding help mode, as staff picked it (local midnight with its offset).
   * Null means help mode was never turned on or was cleared.
   */
  onboardingHelpUntil?: InputMaybe<SortEnumType>;
  /**
   * How far the tenant has progressed through onboarding data setup. UNKNOWN means unset,
   * which is what every tenant created before new tenants started at NOT_STARTED reads.
   */
  onboardingSetup?: InputMaybe<SortEnumType>;
  /**
   * How far the tenant has progressed through onboarding training. Independent of the data-setup
   * stage; UNKNOWN means unset.
   */
  onboardingTraining?: InputMaybe<SortEnumType>;
  /**
   * Report aggregate ID rendered as the Orders page acknowledgement PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderAcknowledgementReportId?: InputMaybe<SortEnumType>;
  /**
   * Report aggregate ID rendered as the Orders page invoice PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderInvoiceReportId?: InputMaybe<SortEnumType>;
  /**
   * Report aggregate ID rendered as the Orders page Pro Forma PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderProFormaReportId?: InputMaybe<SortEnumType>;
  /**
   * Report aggregate ID rendered as the Orders page pull slip PDF for this tenant.
   * Empty string means no report is configured.
   */
  orderPullSlipReportId?: InputMaybe<SortEnumType>;
  /**
   * Per-tenant policy for missing OrganicLotCode on an organic VPO receive item.
   * Defaults to OrganicReceiveMode.Warn so pre-feature BSON documents
   * deserialize cleanly. The receive validation layer reads this field.
   */
  organicReceiveMode?: InputMaybe<SortEnumType>;
  /**
   * The parent company this tenant belongs to, or empty when it belongs to none. Set with
   * setAdminTenantParentCompany; filterable via adminTenants(where: { parentCompanyId }).
   */
  parentCompanyId?: InputMaybe<SortEnumType>;
  /**
   * Tenant-configured maximum length for sales-order and master-order PO numbers.
   * Default: 64 — current/unchanged behavior for tenants that have not configured this.
   */
  poNumberMaxLength?: InputMaybe<SortEnumType>;
  /**
   * Tenant-configured number of decimals used when rounding price calculations.
   * Default: 2 — current/unchanged (cent-rounded) behavior for tenants that have not
   * configured this. Governs ApplyPercentOff rounding only, never display.
   */
  pricingCalcDecimals?: InputMaybe<SortEnumType>;
  /** Whether matching item numbers link automatically. On when never configured. */
  produceAutoLinkMatchingNumbers?: InputMaybe<SortEnumType>;
  produceEnabled?: InputMaybe<SortEnumType>;
  /**
   * Who can create a production plan from an order. Defaults to anyone who can open the order, which is
   * the behaviour every tenant had before this setting existed.
   */
  producePlanFromOrderAccess?: InputMaybe<SortEnumType>;
  /**
   * True when a production entry made by someone without production-admin rights is held for review by a
   * production admin. Default: false, today's behaviour.
   */
  produceProductionEntryReview?: InputMaybe<SortEnumType>;
  /** How many decimals PRODUCE quantities display with on reports (0 to 4). Display only. */
  produceQuantityDecimals?: InputMaybe<SortEnumType>;
  /**
   * How a produced quantity rounds on the production schedule. Defaults to rounding up to a full
   * container/tray, which is the behaviour every tenant had before this setting existed.
   */
  produceRounding?: InputMaybe<SortEnumType>;
  /**
   * Which quantity the space plan consumes bench for. Defaults to ProduceQuantity — the
   * yield-adjusted quantity to produce — which is the behaviour every tenant had before this
   * setting existed.
   */
  produceSpaceConsumptionBasis?: InputMaybe<SortEnumType>;
  /** The day a production week is displayed from: Monday, Saturday or Sunday. Default: Monday. */
  produceWeekDisplayAnchor?: InputMaybe<SortEnumType>;
  /** The tenant's chosen Purchase Order design. Empty = the built-in design. */
  purchaseOrderReportId?: InputMaybe<SortEnumType>;
  /** Per-tenant feature gate for the Demand-Based Replenishment Engine. Default: false. */
  restockCalcEnabled?: InputMaybe<SortEnumType>;
  /**
   * Maximum allowable staleness of RestockCalc results before they are considered invalid, in hours.
   * Must be >= TenantState.MinRestockCalcHours and >= RestockCalcRefreshHours
   * (enforced by the PatchTenant invariant guard).
   * Default: TenantState.DefaultRestockCalcMaxStalenessHours.
   */
  restockCalcMaxStalenessHours?: InputMaybe<SortEnumType>;
  /**
   * RestockCalc cache refresh interval, in hours. Must be >= TenantState.MinRestockCalcHours
   * (enforced by ValidInt). Default: TenantState.DefaultRestockCalcRefreshHours.
   */
  restockCalcRefreshHours?: InputMaybe<SortEnumType>;
  /**
   * Identifier selecting which RestockCalc strategy implementation processes this tenant.
   * Free-form for now; will tighten to a registered set once additional strategies land.
   * Default: TenantState.DefaultRestockCalcStrategyKey.
   */
  restockCalcStrategyKey?: InputMaybe<SortEnumType>;
  /**
   * Per-tenant Restock IRosProvider selection (keyed-DI key plus opaque per-provider
   * JSON). Nullable so pre-feature BSON documents deserialize cleanly; session creation
   * falls through to the default key statistical-v1 when this is null.
   */
  restockProviderSettings?: InputMaybe<RestockProviderSettingsDataSortInput>;
  status?: InputMaybe<SortEnumType>;
  /**
   * Per-tenant Stripe Connect state — the tenant's own connected account (acct_…) and
   * the Stripe Tax readiness observed on it. Nullable so pre-feature BSON documents deserialize
   * cleanly to null; initialized to an empty connect state when a tenant is created. Set by the
   * Stripe-connect event handlers in AdminTenantProjectionService.
   *
   * This is the field the inbound account.updated webhook resolves a tenant by — the Connect
   * analogue of the Billing.StripeCustomerId lookup — so it must be projected even though the
   * tenant-facing query reads the aggregate directly.
   */
  stripeConnect?: InputMaybe<TenantStripeConnectDataSortInput>;
  /**
   * Whether the tenant tracks shipment weight. Off (the default) hides weight totals and weight gap warnings
   * in Fulfill and lists no item weight gaps in Missing Data.
   */
  trackShipmentWeight?: InputMaybe<SortEnumType>;
  /**
   * When an expired trial's tenant data was manually deleted, stamped by an administrator. Null
   * means no deletion has been recorded. Lets the Trial Tenants grid separate "expired, data
   * still present" from "expired and cleaned up"; deletion itself stays a manual operation.
   */
  trialDataDeletedDate?: InputMaybe<SortEnumType>;
  /**
   * When the tenant's self-serve trial expires. Null means a real (non-trial) tenant —
   * presence of a date is what marks a trial tenant; there is no separate tenant-type field.
   * Nullable so pre-feature BSON documents deserialize cleanly. The trial-expiry worker
   * filters on Status == Active && TrialExpirationDate <= now, then
   * inactivates the tenant so it drops out of that filter.
   */
  trialExpirationDate?: InputMaybe<SortEnumType>;
  /**
   * Which trial policy the tenant runs under. Persisted as a STRING (not the ordinal) so the
   * admin surfaces and follow-on trial-enforcement consumers read a stable, self-describing
   * value. Null means no kind was ever stamped — read that as
   * Standard, the restrictive default, so trials
   * provisioned before this field existed stay bounded with no backfill.
   */
  trialKind?: InputMaybe<SortEnumType>;
  /**
   * Per-tenant overrides for the trial creation caps. Null means the tenant has no overrides and
   * every category falls through to the TrialPolicy default for its kind; a null category inside
   * the object means the same thing for that one category. Nullable so pre-feature BSON
   * documents deserialize cleanly.
   */
  trialLimits?: InputMaybe<TrialLimitsDataSortInput>;
  /**
   * Per-tenant unit configuration for the restock / replenishment pipeline.
   * Nullable so pre-feature BSON documents (written before this field existed)
   * deserialize cleanly to null. Consumers should use FetchUnitConfigOrDefaultAsync
   * which falls back to TenantUnitConfig.AllTrays.
   */
  unitConfig?: InputMaybe<TenantUnitConfigDataSortInput>;
  useErpPricing?: InputMaybe<SortEnumType>;
};

/** A flag a tenant features save turns on or off for the tenant. */
export type AdminTenantFeatureChange = {
  __typename?: 'AdminTenantFeatureChange';
  /** The flag's plain name. */
  displayName: Scalars['String']['output'];
  /** The flag. */
  name: FeatureFlagName;
  /** True when the save turns the flag on for the tenant, false when it turns it off. */
  turnsOn: Scalars['Boolean']['output'];
};

/** One flag for one tenant: what it is, whether it is on for the tenant, and why. */
export type AdminTenantFeatureFlag = {
  __typename?: 'AdminTenantFeatureFlag';
  /** The flag's plain name. */
  displayName: Scalars['String']['output'];
  /** Whether the flag is on for the tenant, exactly as the tenant's sessions resolve it. */
  enabled: Scalars['Boolean']['output'];
  /** Temporary, Standing or Retired, as the flag declares in code. */
  kind: FeatureFlagKind;
  /** The flag. */
  name: FeatureFlagName;
  /**
   * The tenant's own setting on the flag, or null when it has none. A save that changes the flag sends it back as
   * expectedOwnSetting.
   */
  ownSetting?: Maybe<AdminTenantFlagOwnSetting>;
  /** The product that turns the flag on, when the source is PRODUCT. */
  productName?: Maybe<Scalars['String']['output']>;
  /** Where that answer comes from. */
  source: FeatureFlagHolderSource;
  /** Whether the flag is active; an inactive flag is off for every tenant. */
  status: FeatureFlagStatus;
};

/** One tenant's features, as the admin Features card reads and saves them. */
export type AdminTenantFeatures = {
  __typename?: 'AdminTenantFeatures';
  /** Every flag, in enum order, with its answer for the tenant and where that answer comes from. */
  flags: Array<AdminTenantFeatureFlag>;
  /** The tenant. */
  tenantId: Scalars['String']['output'];
  /**
   * The tenant's products, in catalog order, without the products every tenant has. A save sends them back as
   * expectedWorkSuiteProductIds.
   */
  workSuiteProductIds: Array<Scalars['String']['output']>;
};

/** A tenant's own setting on a flag. */
export type AdminTenantFlagOwnSetting = {
  __typename?: 'AdminTenantFlagOwnSetting';
  /** The tenant's settings JSON, merged over the flag's config when the flag is on for the tenant. */
  config: Scalars['String']['output'];
  /** On, off, or settings only (on/off follows the tenant's products, its trial and the default). */
  mode: TenantFlagSettingMode;
};

/** GraphQL mutation payload for admin tenant operations. */
export type AdminTenantPayload = {
  __typename?: 'AdminTenantPayload';
  errors?: Maybe<Array<ValidationError>>;
  tenant?: Maybe<TenantStateData>;
};

export type AdminTenantPricingPageDeleteInput = {
  tenantId: Scalars['String']['input'];
};

export type AdminTenantPricingPageUpsertInput = {
  content: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type AdminTenantsConnection = {
  __typename?: 'AdminTenantsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminTenantsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminTenantDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminTenantsEdge = {
  __typename?: 'AdminTenantsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminTenantDocument;
};

/**
 * GraphQL payload for admin trial policy mutations, containing either the resulting policy or
 * validation errors.
 */
export type AdminTrialPolicyPayload = {
  __typename?: 'AdminTrialPolicyPayload';
  data?: Maybe<TrialPolicyStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A connection to a list of items. */
export type AdminUserInvitesConnection = {
  __typename?: 'AdminUserInvitesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminUserInvitesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserInviteDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminUserInvitesEdge = {
  __typename?: 'AdminUserInvitesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserInviteDocument;
};

/** A connection to a list of items. */
export type AdminUsersConnection = {
  __typename?: 'AdminUsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminUsersEdge = {
  __typename?: 'AdminUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserDocument;
};

/**
 * Result of adminSaveWhatsNewFeature, adminDeleteWhatsNewFeature and
 * adminSetWhatsNewReleaseEffectiveOn.
 */
export type AdminWhatsNewPayload = {
  __typename?: 'AdminWhatsNewPayload';
  /** Why the change was refused, each with a code; null when it succeeded. */
  errors?: Maybe<Array<ValidationError>>;
  /** The saved feature, or the deleted one; null for a release date change or a refusal. */
  feature?: Maybe<WhatsNewAdminFeature>;
  /** The feature's release as it now stands; null for a Coming soon feature, a release left empty, or a refusal. */
  release?: Maybe<WhatsNewReleaseSummary>;
};

/** A product in the WorkSuite product catalog, with how many tenants have it. */
export type AdminWorkSuiteProduct = {
  __typename?: 'AdminWorkSuiteProduct';
  /** How many tenants that are not deleted have the product. */
  customerCount: Scalars['Int']['output'];
  /** The flags the product turns on. Empty for a product that only records the contract. */
  flags: Array<FeatureFlagName>;
  /** The product id. */
  id: Scalars['String']['output'];
  /** True for a product every tenant has without a switch, such as FULFILL. */
  includedForEveryCustomer: Scalars['Boolean']['output'];
  /** The product name. */
  name: Scalars['String']['output'];
  /** The catalog position; lower sorts first. */
  order: Scalars['Int']['output'];
};

/** How many tenants one flag of a product change turns on and off. */
export type AdminWorkSuiteProductFlagImpact = {
  __typename?: 'AdminWorkSuiteProductFlagImpact';
  /** A flag the change adds to or removes from the product. */
  name: FeatureFlagName;
  /** How many tenants the change turns the flag off for. */
  turnsOffCount: Scalars['Int']['output'];
  /** How many tenants the change turns the flag on for. */
  turnsOnCount: Scalars['Int']['output'];
};

/** The result of a product create or update: the product as written, or the errors that stopped the write. */
export type AdminWorkSuiteProductPayload = {
  __typename?: 'AdminWorkSuiteProductPayload';
  /** The product as written, or null when the write was refused. */
  data?: Maybe<WorkSuiteProductStateData>;
  /** Why the write was refused, or null. */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * Always empty: a rename writes only the product, so no tenant write can fail.
   * @deprecated A rename no longer writes any tenant: each tenant's contractedProducts is derived from its products when it is read, so it shows the new name without a tenant being re-set. Always 0 and empty.
   */
  tenantFailures: Array<AdminWorkSuiteProductTenantFailure>;
  /**
   * Always 0: a rename writes only the product, never a tenant.
   * @deprecated A rename no longer writes any tenant: each tenant's contractedProducts is derived from its products when it is read, so it shows the new name without a tenant being re-set. Always 0 and empty.
   */
  tenantsUpdated: Scalars['Int']['output'];
};

/** A tenant a product rename could not re-set, with the reason. No longer produced: a rename writes no tenant. */
export type AdminWorkSuiteProductTenantFailure = {
  __typename?: 'AdminWorkSuiteProductTenantFailure';
  /** Why its re-set failed. */
  message: Scalars['String']['output'];
  /** The tenant. */
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read model for admin management of worker configs.
 * One document per config name. Contains the full TenantValues array.
 */
export type AdminWorkerConfigDocument = {
  __typename?: 'AdminWorkerConfigDocument';
  /**
   * Every approval recorded against this config, oldest first — who attested, which approver class their
   * config declared, when, and which authored-SQL fields changed. Read from the projected approval
   * documents, so no stream replay is involved.
   */
  authoredSqlApprovals: Array<AuthoredSqlApprovalDocument>;
  configName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  tenantValues: Array<TenantValueData>;
};

export type AdminWorkerConfigPayload = {
  __typename?: 'AdminWorkerConfigPayload';
  data?: Maybe<WorkerConfigStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Admin view of a worker config for paginated listing. */
export type AdminWorkerConfigResult = {
  __typename?: 'AdminWorkerConfigResult';
  configName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  tenantValueCount: Scalars['Int']['output'];
};

/** Admin view of a worker config for paginated listing. */
export type AdminWorkerConfigResultFilterInput = {
  and?: InputMaybe<Array<AdminWorkerConfigResultFilterInput>>;
  configName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AdminWorkerConfigResultFilterInput>>;
  tenantValueCount?: InputMaybe<IntOperationFilterInput>;
};

/** Admin view of a worker config for paginated listing. */
export type AdminWorkerConfigResultSortInput = {
  configName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  tenantValueCount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AdminWorkerConfigsConnection = {
  __typename?: 'AdminWorkerConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AdminWorkerConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AdminWorkerConfigResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminWorkerConfigsEdge = {
  __typename?: 'AdminWorkerConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AdminWorkerConfigResult;
};

/** Input to advanceBackgroundJob, sent by the background jobs worker. */
export type AdvanceBackgroundJobInput = {
  /** The job id, as openBackgroundJobs returned it. */
  jobId: Scalars['String']['input'];
  /** The most items this call handles; capped at 100, and 100 when null. */
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  /** The tenant of the job, as openBackgroundJobs returned it. */
  tenantId: Scalars['String']['input'];
};

/**
 * What one advanceBackgroundJob call did. The counts are this call's: the items it handled, and of those how many
 * are done and how many failed; one handled but neither was skipped.
 */
export type AdvanceBackgroundJobPayload = {
  __typename?: 'AdvanceBackgroundJobPayload';
  /** How many of them are done. */
  done: Scalars['Int']['output'];
  /** What stopped the call, if anything. One item failing is not an error here. */
  errors?: Maybe<Array<ValidationError>>;
  /** How many of them failed. */
  failed: Scalars['Int']['output'];
  /** True while the job is pending or running: the worker should call again. */
  hasMoreWork: Scalars['Boolean']['output'];
  /** The job id the worker passed. */
  jobId: Scalars['String']['output'];
  /** How many items this call handled. */
  processed: Scalars['Int']['output'];
  /** Where the job is now. Failed when the call failed before reading it. */
  status: BackgroundJobStatus;
};

/** What one advanceBulkOrderDeleteJob call left the job at. Counts are for the whole job, not just this call. */
export type AdvanceBulkOrderDeleteJobPayload = {
  __typename?: 'AdvanceBulkOrderDeleteJobPayload';
  /** How many orders are now deleted, including ones that already were. */
  deletedCount: Scalars['Int']['output'];
  /** What stopped the call, if anything. A single order failing is not an error here. */
  errors?: Maybe<Array<ValidationError>>;
  /** How many orders could not be deleted. */
  failedCount: Scalars['Int']['output'];
  /** True while the job is Pending or Running: the worker should call again. */
  hasMoreWork: Scalars['Boolean']['output'];
  /** The job id the worker passed: the document id, tenant then job id. */
  jobId: Scalars['String']['output'];
  /** How many orders have been handled, deleted or failed. */
  processedCount: Scalars['Int']['output'];
  /** Where the job is now. Unknown when the call failed before reading it. */
  status: BulkOrderDeleteJobStatus;
  /** How many orders the job was asked to delete. */
  totalCount: Scalars['Int']['output'];
};

export type AdvanceConsolidationApplicationInput = {
  applicationId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/**
 * What one advanceCorrectionRun call left the run at. The row counts are CUMULATIVE for the whole run, not
 * this call's: the worker reads rowsRemaining and calls again while it is above 0 and the run is open.
 */
export type AdvanceCorrectionRunPayload = {
  __typename?: 'AdvanceCorrectionRunPayload';
  /** What stopped the call: the run is unknown, cancelled or finished, or a store call failed. */
  errors?: Maybe<Array<ValidationError>>;
  /** Rows whose correction was already in their stream, so nothing was written. */
  rowsAlreadyApplied: Scalars['Int']['output'];
  /** Rows the run has written. */
  rowsApplied: Scalars['Int']['output'];
  /** Rows that could not be applied. */
  rowsFailed: Scalars['Int']['output'];
  /** Approved rows without a result yet. */
  rowsRemaining: Scalars['Int']['output'];
  /** Rows whose aggregate moved after the plan, so nothing was written; they need a new run. */
  rowsStale: Scalars['Int']['output'];
  /** The run the worker passed. */
  runId: Scalars['String']['output'];
  /** Where the run is now. Unknown when the call failed before reading it. */
  status: CorrectionRunStatus;
};

/** What one advanceFeatureFlagProductConversionJob call left the job at. Counts are for the whole job. */
export type AdvanceFeatureFlagProductConversionJobPayload = {
  __typename?: 'AdvanceFeatureFlagProductConversionJobPayload';
  /** The chunk this call applied; null when it applied none. */
  appliedChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** How many chunks are applied. */
  chunksApplied: Scalars['Int']['output'];
  /** How many chunks the job has. */
  chunksTotal: Scalars['Int']['output'];
  /**
   * True when a chunk tenant changed since its read models were read, so nothing was written; the next call plans the
   * chunk again.
   */
  conflict: Scalars['Boolean']['output'];
  /** What stopped the call, if anything. */
  errors?: Maybe<Array<ValidationError>>;
  /** True while the job is Pending or Running: the worker should call again. */
  hasMoreWork: Scalars['Boolean']['output'];
  /** The job id the caller passed. */
  jobId: Scalars['String']['output'];
  /** Where the job is now. Unknown when the call failed before reading it. */
  status: FeatureFlagProductConversionJobStatus;
  /** How many of the job's tenants are in applied chunks. */
  tenantsConverted: Scalars['Int']['output'];
};

/**
 * Advances one claimed import run from the cursor on the run the claim returned, then the cursor each advance
 * returns; any other cursor returns the run unchanged.
 */
export type AdvanceMigrationImportRunInput = {
  claimToken: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** An advance's result with the error the run stopped on or released its claim for, or why the advance changed nothing. */
export type AdvanceMigrationImportRunPayload = {
  __typename?: 'AdvanceMigrationImportRunPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<MigrationImportRunAdvanceResult>;
};

/** Validates one page of a prepared revision, under the job's claim. */
export type AdvanceMigrationValidationInput = {
  /** The job's current claim token. Checked, not identity. */
  claimToken: Scalars['String']['input'];
  /** The job's composite id. */
  id: Scalars['String']['input'];
  /** The page to validate: the run's observed page. */
  page: Scalars['Int']['input'];
  /** The prepared revision, as the row-page call returned it. */
  revisionId: Scalars['String']['input'];
  /** The run, as the first call returned it; leave it out on page 0 to open a run. */
  runId?: InputMaybe<Scalars['String']['input']>;
};

export type AdvanceMigrationValidationPayload = {
  __typename?: 'AdvanceMigrationValidationPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<AdvanceMigrationValidationResult>;
};

/** What a validation page call did. */
export type AdvanceMigrationValidationResult = {
  __typename?: 'AdvanceMigrationValidationResult';
  /** The run's next page to validate. */
  observedPage: Scalars['Int']['output'];
  /** How many operations the page validated. */
  operations: Scalars['Int']['output'];
  /** Recorded now, or already recorded by an earlier call. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The page validated. */
  page: Scalars['Int']['output'];
  /** How many pages the run has; complete the run once the observed page reaches it. */
  pageCount: Scalars['Int']['output'];
  /** The prepared revision. */
  revisionId: Scalars['String']['output'];
  /** The run; send it on every later page and on completion. */
  runId: Scalars['String']['output'];
};

/**
 * Result of one page-scoped advance call: the refreshed job (carrying id, status and the per-phase
 * progress counts), the phase that ran, how many rows this call processed, whether the scheduler
 * should call again (hasMoreWork), and any error.
 */
export type AdvanceProductionLotAsyncImportJobPayload = {
  __typename?: 'AdvanceProductionLotAsyncImportJobPayload';
  errors?: Maybe<Array<ValidationError>>;
  hasMoreWork: Scalars['Boolean']['output'];
  job?: Maybe<AsyncImportJobDocument>;
  phase: ProductionLotAdvancePhase;
  rowsProcessed: Scalars['Int']['output'];
};

export type AffectedChildJob = {
  __typename?: 'AffectedChildJob';
  affectedVariationIds: Array<Scalars['String']['output']>;
  /**
   * Why a reapply cannot update this child job, or null when it can. A reapply of the parent whose
   * cascade would rewrite a child that carries a reason is refused as a whole (JOB_NOT_ACTIVE).
   */
  blockedReason?: Maybe<ReapplyBlockedReason>;
  /**
   * currentQuantity before it was rounded to whole containers: the child's exact quantity, or
   * its whole quantity when it has no exact one. Additive beside the whole number.
   */
  currentExactQuantity: Scalars['Decimal']['output'];
  /** This child job's quantity to produce as it stands today. */
  currentQuantity: Scalars['Int']['output'];
  /** The lot's requested quantity — the same anchor the finish job's quantity derives from. */
  lotQuantity: Scalars['Int']['output'];
  parentProductionJobId?: Maybe<Scalars['String']['output']>;
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  /**
   * projectedQuantity before it was rounded to whole containers: the cascaded exact quantity
   * when the cascade moved this child, otherwise currentExactQuantity.
   */
  projectedExactQuantity: Scalars['Decimal']['output'];
  /**
   * This child job's quantity to produce if the pending yield change is applied — the cascaded
   * number the reapply mutation would write for this job. Reflects a Yield-scope reapply's
   * cascade ONLY: a reapply scoped to Links or PlantsPerPot rebuilds its child jobs through a
   * separate path, and this field does not project those quantities. Equals currentQuantity
   * when no yield change is pending or when this hop's multiplier is uninferable. A child whose
   * own recipe was deleted is omitted from affectedChildJobs entirely rather than reported with
   * an unchanged quantity. Render this as "would become if you apply the yield change", not
   * "will become".
   */
  projectedQuantity: Scalars['Int']['output'];
};

/**
 * Result of the agGridColumnCapabilities query: the colIds a client may sort and filter on for one
 * grid, so it can disable the options the server would refuse instead of sending a request that fails.
 */
export type AgGridColumnCapabilities = {
  __typename?: 'AgGridColumnCapabilities';
  /** colIds agGridRows accepts as top-level filterModel keys (request switches excluded). */
  filterableColIds: Array<Scalars['String']['output']>;
  /** The grid these lists describe. */
  gridId: Scalars['String']['output'];
  /** colIds agGridRows accepts in sortModel (array columns are never sortable). */
  sortableColIds: Array<Scalars['String']['output']>;
};

/**
 * Result of the agGridRows query: row payloads plus an exact total computed only on the first
 * block. AG Grid's server-side row model in infinite-scroll mode detects the final block by a short
 * return, so a $facet/double-pass count cost is never paid;
 * the first-block count is a separate sort-free $count (or Atlas $searchMeta) aggregation
 * that lets the client size the scrollbar / show a total.
 */
export type AgGridRowsResult = {
  __typename?: 'AgGridRowsResult';
  /**
   * Exact total row count for the current query, populated only when request.startRow == 0 and
   * null on every later block — AG Grid re-requests from row 0 whenever filter/sort/search/group keys
   * change, so the first-block count is always fresh. In grouping mode this counts groups at the
   * requested level.
   */
  rowCount?: Maybe<Scalars['Int']['output']>;
  /** The block's rows — heterogeneous by design (group rows vs leaf rows differ in shape). */
  rowData: Array<Scalars['JSON']['output']>;
  /**
   * Unfiltered grand total (records, ignoring the current filter/search), populated only on the first
   * block and only for grids that supply an unfiltered-count hook (e.g. combinedOrders); null otherwise.
   * Lets the client show "N filtered of M total" without a second round-trip.
   */
  unfilteredRowCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * Result of AgGridSetValuesQuery: the distinct set-filter option values for one grid column,
 * normalized to grid-ready JSON primitives (canonical enum names, ISO dates, plain numbers) exactly like the
 * agGridRows output, sorted ascending and capped.
 */
export type AgGridSetValuesResult = {
  __typename?: 'AgGridSetValuesResult';
  /**
   * The distinct, normalized, ascending values a set filter offers for the requested column, reflecting the
   * grid's OTHER active filters (the target column's own filter is excluded). Never includes blanks.
   */
  values: Array<Scalars['JSON']['output']>;
};

export enum AgentType {
  Claude = 'CLAUDE',
  Codex = 'CODEX',
  ExternalConnector = 'EXTERNAL_CONNECTOR',
  Gemini = 'GEMINI',
  Jev = 'JEV',
  NotApplicable = 'NOT_APPLICABLE'
}

/** A connection to a list of items. */
export type AllBaseRatesOfSaleConnection = {
  __typename?: 'AllBaseRatesOfSaleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllBaseRatesOfSaleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BaseRateOfSaleDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllBaseRatesOfSaleEdge = {
  __typename?: 'AllBaseRatesOfSaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BaseRateOfSaleDocument;
};

/** A connection to a list of items. */
export type AllContainerConfigsConnection = {
  __typename?: 'AllContainerConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllContainerConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ContainerConfigDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllContainerConfigsEdge = {
  __typename?: 'AllContainerConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContainerConfigDocument;
};

/** A connection to a list of items. */
export type AllDailySalesProportionsConnection = {
  __typename?: 'AllDailySalesProportionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllDailySalesProportionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DailySalesProportionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllDailySalesProportionsEdge = {
  __typename?: 'AllDailySalesProportionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DailySalesProportionDocument;
};

/** A connection to a list of items. */
export type AllDeliverySchedulesConnection = {
  __typename?: 'AllDeliverySchedulesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllDeliverySchedulesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeliveryScheduleDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllDeliverySchedulesEdge = {
  __typename?: 'AllDeliverySchedulesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeliveryScheduleDocument;
};

/** A connection to a list of items. */
export type AllForecastSettingsConnection = {
  __typename?: 'AllForecastSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllForecastSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ForecastSettingsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllForecastSettingsEdge = {
  __typename?: 'AllForecastSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ForecastSettingsDocument;
};

/** A connection to a list of items. */
export type AllProgramReplenishmentSettingsConnection = {
  __typename?: 'AllProgramReplenishmentSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllProgramReplenishmentSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProgramReplenishmentSettingsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllProgramReplenishmentSettingsEdge = {
  __typename?: 'AllProgramReplenishmentSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProgramReplenishmentSettingsDocument;
};

/** A connection to a list of items. */
export type AllReplenishmentSettingsConnection = {
  __typename?: 'AllReplenishmentSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllReplenishmentSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReplenishmentSettingsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllReplenishmentSettingsEdge = {
  __typename?: 'AllReplenishmentSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReplenishmentSettingsDocument;
};

/** A connection to a list of items. */
export type AllWeeklySlopeFactorsConnection = {
  __typename?: 'AllWeeklySlopeFactorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllWeeklySlopeFactorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WeeklySlopeFactorDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllWeeklySlopeFactorsEdge = {
  __typename?: 'AllWeeklySlopeFactorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WeeklySlopeFactorDocument;
};

export type AllocateCommandInput = {
  allocationType: AllocationType;
  availability?: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  mode?: AllocationMode;
  perStoreMinimum?: Scalars['Int']['input'];
  priorities: Array<AllocationPriorityDimension>;
  reservationQuantity: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
  stationCode: Scalars['String']['input'];
  storeFilters: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type AllocateLineItemDataInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  lineItemId: Scalars['UUID']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type AllocateLineItemsInput = {
  items: Array<AllocateLineItemDataInput>;
  orderId: Scalars['String']['input'];
};

export type AllocateProductionLotToOrderLineInput = {
  allocatedQty: Scalars['Int']['input'];
  allocationId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  orderLineId: Scalars['String']['input'];
  orderedQty: Scalars['Int']['input'];
  productionLotId: Scalars['String']['input'];
};

export type AllocationErrorData = {
  __typename?: 'AllocationErrorData';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AllocationItemData = {
  __typename?: 'AllocationItemData';
  allocatedAt: Scalars['DateTime']['output'];
  allocatedBy: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

export type AllocationItemDocument = {
  __typename?: 'AllocationItemDocument';
  allocatedAt: Scalars['DateTime']['output'];
  allocatedBy: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

export type AllocationItemDocumentFilterInput = {
  allocatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  allocatedBy?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AllocationItemDocumentFilterInput>>;
  grade?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  lineItemId?: InputMaybe<UuidOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AllocationItemDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type AllocationItemDocumentSortInput = {
  allocatedAt?: InputMaybe<SortEnumType>;
  allocatedBy?: InputMaybe<SortEnumType>;
  grade?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  lineItemId?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type AllocationLineItemData = {
  __typename?: 'AllocationLineItemData';
  allocatedQuantity: Scalars['Decimal']['output'];
  orderLineItemId: Scalars['String']['output'];
  purchaseOrderLineItemId: Scalars['String']['output'];
};

export type AllocationLineItemDataFilterInput = {
  allocatedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<AllocationLineItemDataFilterInput>>;
  or?: InputMaybe<Array<AllocationLineItemDataFilterInput>>;
  orderLineItemId?: InputMaybe<StringOperationFilterInput>;
  purchaseOrderLineItemId?: InputMaybe<StringOperationFilterInput>;
};

export enum AllocationMode {
  AllocateAll = 'ALLOCATE_ALL',
  AllocateUpTo = 'ALLOCATE_UP_TO'
}

export type AllocationModeOperationFilterInput = {
  eq?: InputMaybe<AllocationMode>;
  in?: InputMaybe<Array<AllocationMode>>;
  neq?: InputMaybe<AllocationMode>;
  nin?: InputMaybe<Array<AllocationMode>>;
};

export type AllocationPayload = {
  __typename?: 'AllocationPayload';
  errors?: Maybe<Array<AllocationErrorData>>;
  result?: Maybe<AllocationResultData>;
};

export enum AllocationPriorityDimension {
  Available = 'AVAILABLE',
  Carts = 'CARTS',
  DaysSinceLastDelivery = 'DAYS_SINCE_LAST_DELIVERY',
  DaysSinceLastSale = 'DAYS_SINCE_LAST_SALE',
  DemandQuantity = 'DEMAND_QUANTITY',
  SellDownUnits = 'SELL_DOWN_UNITS',
  StoreClass = 'STORE_CLASS',
  TrailingSales = 'TRAILING_SALES',
  UnitsOnHand = 'UNITS_ON_HAND',
  WeeklyRateOfSale = 'WEEKLY_RATE_OF_SALE'
}

export type AllocationPriorityDimensionOperationFilterInput = {
  eq?: InputMaybe<AllocationPriorityDimension>;
  in?: InputMaybe<Array<AllocationPriorityDimension>>;
  neq?: InputMaybe<AllocationPriorityDimension>;
  nin?: InputMaybe<Array<AllocationPriorityDimension>>;
};

export type AllocationResultData = {
  __typename?: 'AllocationResultData';
  allocations: Array<StoreAllocationData>;
  feasibilityStatus: FeasibilityStatus;
  warnings: Array<Scalars['String']['output']>;
};

/** Which side of an allocation transfer this order records. */
export enum AllocationTakeDirection {
  /** Plants left this source order for another order. */
  TakenFor = 'TAKEN_FOR',
  /** Plants arrived on this receiving order from a source order. */
  TakenFrom = 'TAKEN_FROM'
}

export type AllocationTemplateData = {
  __typename?: 'AllocationTemplateData';
  allocationType: AllocationType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  equalizeWeeksOfSupply: Scalars['Boolean']['output'];
  favorHigherWeight: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  mode: AllocationMode;
  name: Scalars['String']['output'];
  priorities: Array<AllocationPriorityDimension>;
  targetWeeksOfSupply?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type AllocationTemplateDocument = {
  __typename?: 'AllocationTemplateDocument';
  allocationType: AllocationType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  equalizeWeeksOfSupply: Scalars['Boolean']['output'];
  favorHigherWeight: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  mode: AllocationMode;
  name: Scalars['String']['output'];
  priorities: Array<AllocationPriorityDimension>;
  targetWeeksOfSupply?: Maybe<Scalars['Decimal']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type AllocationTemplateDocumentFilterInput = {
  allocationType?: InputMaybe<AllocationTypeOperationFilterInput>;
  and?: InputMaybe<Array<AllocationTemplateDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  equalizeWeeksOfSupply?: InputMaybe<BooleanOperationFilterInput>;
  favorHigherWeight?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  mode?: InputMaybe<AllocationModeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AllocationTemplateDocumentFilterInput>>;
  priorities?: InputMaybe<ListAllocationPriorityDimensionOperationFilterInput>;
  targetWeeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type AllocationTemplateDocumentSortInput = {
  allocationType?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  equalizeWeeksOfSupply?: InputMaybe<SortEnumType>;
  favorHigherWeight?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  mode?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  targetWeeksOfSupply?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type AllocationTemplatePayload = {
  __typename?: 'AllocationTemplatePayload';
  errors?: Maybe<Array<ValidationError>>;
  template?: Maybe<AllocationTemplateData>;
};

/** A connection to a list of items. */
export type AllocationTemplatesConnection = {
  __typename?: 'AllocationTemplatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllocationTemplatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AllocationTemplateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AllocationTemplatesEdge = {
  __typename?: 'AllocationTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AllocationTemplateDocument;
};

export enum AllocationType {
  StrictPriority = 'STRICT_PRIORITY',
  WeeklyDistribution = 'WEEKLY_DISTRIBUTION',
  WeightedDistribution = 'WEIGHTED_DISTRIBUTION'
}

export type AllocationTypeOperationFilterInput = {
  eq?: InputMaybe<AllocationType>;
  in?: InputMaybe<Array<AllocationType>>;
  neq?: InputMaybe<AllocationType>;
  nin?: InputMaybe<Array<AllocationType>>;
};

/**
 * Per-(tenant, productionCategory) allotted-time learning baseline (CC-WSAPI-B1), projected from
 * CountSessionCompleted events. A forward-only rolling baseline: every completed session
 * with a positive pace contributes its units/min and minutes/unit to a window capped at the most
 * recent WindowSize sessions (by completion time). The averages and median are
 * recomputed from the stored window on every update — never via relative operators — so the
 * document is a pure function of the SET of contributing sessions and is identical on replay
 * (Atlas accaf08f). Keyed by the composite {tenantId}-{productionCategoryId} document id,
 * so all access is by the auto-indexed _id.
 */
export type AllottedTimeBaselineDocument = {
  __typename?: 'AllottedTimeBaselineDocument';
  averageMinutesPerUnit: Scalars['Decimal']['output'];
  averageUnitsPerMinute: Scalars['Decimal']['output'];
  /** Number of sessions in the rolling window (capped at WindowSize). */
  completedSessionsCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  medianMinutesPerUnit: Scalars['Decimal']['output'];
  productionCategoryId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type AmendPurchaseOrderLineItemInput = {
  erpJobId?: InputMaybe<Scalars['String']['input']>;
  eventDetailId?: InputMaybe<Scalars['String']['input']>;
  itemName: Scalars['String']['input'];
  jobShares?: InputMaybe<Array<AmendVendorPurchaseOrderLineJobShareDataInput>>;
  lineItemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  materialItemErpId?: InputMaybe<Scalars['String']['input']>;
  materialItemId: Scalars['String']['input'];
  productionJobId?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderId: Scalars['String']['input'];
  quantityOrdered: Scalars['Decimal']['input'];
  unitCost?: InputMaybe<Scalars['Decimal']['input']>;
  unitCostText?: InputMaybe<Scalars['String']['input']>;
};

export type AmendVendorPurchaseOrderLineJobShareDataInput = {
  eventDetailId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
};

/** A grower's answer to one question, as sent from chat. */
export type AnswerMigrationImportQuestionInput = {
  /** The identity decision, for an existing-record question. */
  decision?: InputMaybe<MigrationImportDecisionInput>;
  /** Rows of the displayed group the answer leaves out. */
  exceptions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The lineage, as the question page listed it. */
  lineageId: Scalars['String']['input'];
  /** The option chosen. */
  option: Scalars['String']['input'];
  /** The question, as the question page listed it. */
  questionId: Scalars['String']['input'];
  /** The question revision the grower saw. */
  questionRevision: Scalars['Int']['input'];
  /** The chat references; session, turn and sent message are required. */
  routing: OnboardingJourneyRoutingInput;
  /** The record id or value a mapping answer names. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum AppTag {
  Forecast = 'FORECAST',
  Fulfill = 'FULFILL',
  OrdersGrid = 'ORDERS_GRID',
  Produce = 'PRODUCE',
  Restock = 'RESTOCK'
}

export type AppTagOperationFilterInput = {
  eq?: InputMaybe<AppTag>;
  in?: InputMaybe<Array<AppTag>>;
  neq?: InputMaybe<AppTag>;
  nin?: InputMaybe<Array<AppTag>>;
};

/** Whether a price applies to the day being priced, and if not, why not. */
export enum ApplicablePriceState {
  /**
   * Tied prices could not be ranked because one of them has no usable PriceId yet. Temporary until the
   * price identity replay has reached every row.
   */
  IdentityUnavailable = 'IDENTITY_UNAVAILABLE',
  /** Nothing applies yet, but a dated price starts on a later day. */
  NotYetEffective = 'NOT_YET_EFFECTIVE',
  /** Nothing applies and nothing is scheduled to. */
  NoPrice = 'NO_PRICE',
  /** A dated price in force on the day, or the base rate when no dated price is. */
  Priced = 'PRICED'
}

export type ApplyConsolidationGroupDataInput = {
  categoryGroup?: InputMaybe<Scalars['String']['input']>;
  customerGroupId?: InputMaybe<Scalars['String']['input']>;
  genusCode?: InputMaybe<Scalars['String']['input']>;
  newQuantity: Scalars['Int']['input'];
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  rollupLevel?: InputMaybe<ConsolidationPreviewRollupLevel>;
  sourceProductionLotIds: Array<Scalars['String']['input']>;
  weekReady: Scalars['DateTime']['input'];
};

export type ApplyConsolidationInput = {
  groups: Array<ApplyConsolidationGroupDataInput>;
};

export type ApplyConsolidationPayload = {
  __typename?: 'ApplyConsolidationPayload';
  consolidationResults: Array<ApplyConsolidationResultData>;
  errors?: Maybe<Array<ValidationError>>;
  success: Scalars['Boolean']['output'];
};

export type ApplyConsolidationPreviewInput = {
  previewId: Scalars['String']['input'];
};

export type ApplyConsolidationResultData = {
  __typename?: 'ApplyConsolidationResultData';
  archivedProductionLotIds: Array<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  newProductionLotId?: Maybe<Scalars['String']['output']>;
};

/** Apply some of what is left of a credit memo to one open invoice of the same customer. */
export type ApplyCreditMemoInput = {
  /** How much to apply: no more than the memo has unapplied and no more than the invoice owes. */
  amount: Scalars['Decimal']['input'];
  /**
   * The caller's idempotency key. Re-sending the same id applies once; leaving it out mints one, so the request
   * is not safe to retry.
   */
  applicationId?: InputMaybe<Scalars['String']['input']>;
  /** The invoice to apply it to. */
  invoiceId: Scalars['String']['input'];
  /** The Credit-type order whose memo is applied. */
  orderId: Scalars['String']['input'];
};

export type ApplyCustomerCreditInput = {
  amount: Scalars['Decimal']['input'];
  applicationId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
};

/** The result of applying customer credit to an invoice. */
export type ApplyCustomerCreditPayload = {
  __typename?: 'ApplyCustomerCreditPayload';
  /** The customer's credit balance after the application; null on error. */
  customerCredit?: Maybe<CustomerCreditStateData>;
  /** Why the application was refused, when it was. */
  errors?: Maybe<Array<ValidationError>>;
  /** The invoice after the application; null on error. */
  invoice?: Maybe<InvoiceStateData>;
};

export type ApplyLoadFreightInput = {
  expectedInputRevision: Scalars['String']['input'];
  loadId: Scalars['String']['input'];
};

/**
 * The outcome of Apply freight. A refused apply writes nothing and returns errors with empty results;
 * refusal repeats a load refusal so the named lines stay named. Skips are results, never errors.
 */
export type ApplyLoadFreightPayload = {
  __typename?: 'ApplyLoadFreightPayload';
  /** Why nothing was written. */
  errors?: Maybe<Array<ValidationError>>;
  /** The load refusal, when the load cannot be priced. */
  refusal?: Maybe<LoadFreightRefusal>;
  /** One row per order, with what the apply did. */
  results: Array<LoadFreightOrderResult>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

/** The approval of a supplier price import to apply. */
export type ApplySupplierPriceImportInput = {
  /** The approval to apply. */
  approvalId: Scalars['String']['input'];
  /** The import the approval belongs to. */
  importId: Scalars['String']['input'];
};

/** Where an apply stands after one call, or why the call failed. */
export type ApplySupplierPriceImportPayload = {
  __typename?: 'ApplySupplierPriceImportPayload';
  /** Every row of the approved document with its status after this call; null when the call failed. */
  apply?: Maybe<SupplierPriceImportApply>;
  /**
   * Why the call failed. A write the call stopped on is the apply's stop, never an error here. A call can fail
   * after it saved writes; the supplierPriceImportApply query shows what it saved.
   */
  errors?: Maybe<Array<ValidationError>>;
};

/** Input approving an InReview GrowerBenchmark submission version (contract C7). */
export type ApproveGrowerBenchmarkSubmissionInput = {
  /** Approval provenance recorded onto the version. */
  approvalType: GrowerBenchmarkApprovalType;
  /** Target submission version identifier. */
  submissionId: Scalars['String']['input'];
};

/** A grower's sent approval of one presented subject, exactly as typed and sent in chat. */
export type ApproveMigrationReviewInput = {
  /** The orchestrator's signed envelope over the call. */
  envelope?: InputMaybe<MigrationApprovalEnvelopeInput>;
  /** The journey the subject belongs to. */
  journeyId: Scalars['String']['input'];
  /** The approval asked for: a data approval or a settings approval. */
  kind: MigrationApprovalKind;
  /** The presentation the grower saw, as the present call returned it. */
  presentationId?: InputMaybe<Scalars['String']['input']>;
  /** The chat references; session, turn, sent message and the per-call key are required. */
  routing: OnboardingJourneyRoutingInput;
  /** The portion id or the settings-operation revision id. */
  subjectId: Scalars['String']['input'];
  /** The text the grower typed, exactly as sent. */
  typedText?: InputMaybe<Scalars['String']['input']>;
};

export type ApproveProductionLotInput = {
  productionLotId: Scalars['String']['input'];
};

export type ApprovePurchaseOrderInput = {
  purchaseOrderId: Scalars['String']['input'];
};

export type AssignDeviceLocationInput = {
  deviceId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
};

export type AssignDueDateInput = {
  dueDate: Scalars['DateTime']['input'];
  taskAssignmentId: Scalars['String']['input'];
};

export type AssignItemGlAccountsInput = {
  incomeGlAccountId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
};

export type AssignMaterialItemToVendorInput = {
  /**
   * The calendar DAY this cost takes effect. Any time of day you send is DISCARDED: the server stores midnight UTC of the day your value names IN THE OFFSET YOU SENT, not in UTC, so 2026-08-21T23:00:00-05:00 is stored as 2026-08-21T00:00:00Z and not 2026-08-22. Reading the cost back returns that midnight-UTC value rather than what you submitted. A cost is picked by the latest effective day on or before today, so a future day does not apply early. Omit the field (or send null) to record the always-effective BASE RATE for this vendor instead of a dated cost — null here is not "unknown". Supplying it without a unitCost is REJECTED rather than silently ignored, because an effective day with no cost dates nothing.
   * @deprecated Superseded by the effective material price surface. Assign the vendor without a cost, then use addEffectiveMaterialPrice to record a new effective quote, correctMaterialPrice to change a quote that is already selected, and voidMaterialPrice to exclude a quote from selection. Read materialPriceWriteCapability first to see whether this tenant may write prices. These fields still work exactly as before and are not scheduled for removal yet, so existing callers keep working until they migrate.
   */
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  /** @deprecated Superseded by the effective material price surface. Assign the vendor without a cost, then use addEffectiveMaterialPrice to record a new effective quote, correctMaterialPrice to change a quote that is already selected, and voidMaterialPrice to exclude a quote from selection. Read materialPriceWriteCapability first to see whether this tenant may write prices. These fields still work exactly as before and are not scheduled for removal yet, so existing callers keep working until they migrate. */
  unitCost?: InputMaybe<Scalars['Decimal']['input']>;
  vendor: MaterialVendorInput;
};

/**
 * Boundary input for the assignOrderToLoad convenience mutation — a thin wrapper over
 *             mergeLoadLine that fixes the shape callers use when putting an order onto a load for the
 *             first time (no stop assignment yet; that comes later via setLoadLineStop).
 */
export type AssignOrderToLoadInput = {
  containerCount?: InputMaybe<Scalars['Int']['input']>;
  customerName: Scalars['String']['input'];
  loadId: Scalars['String']['input'];
  loadLineId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
};

export type AssignReportOwnerInput = {
  ownerEmail: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
};

export type AssignUserCustomerInput = {
  customerId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AssignUserCustomersInput = {
  customerIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignUserRoutesInput = {
  routes: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignUserSitesInput = {
  siteLocationIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignmentOverrideChangeProjection = {
  __typename?: 'AssignmentOverrideChangeProjection';
  eventId: Scalars['String']['output'];
  hasExistingOverride: Scalars['Boolean']['output'];
  jobDefaultAssignedTo?: Maybe<Scalars['String']['output']>;
  recipeDefaultAssignedTo?: Maybe<Scalars['String']['output']>;
};

/**
 * Read model for the supervisor "Assignments" tab in HardgoodsSidePanel: one document
 * per (tenant, assignment) carrying assignment-level state plus a per-task summary map
 * keyed by TaskId. Projected from CycleCountAssignment.V1.* events (HGI-09) with
 * absolute upserts and absolute per-task-key sets only — no reads, no relative operators
 * (atlas standard accaf08f270b40efa04fbbcdd605fc1c).
 */
export type AssignmentSummaryDocument = {
  __typename?: 'AssignmentSummaryDocument';
  assignmentId: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['String']['output'];
  dueBy: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastEventAt: Scalars['DateTime']['output'];
  /**
   * Flattened, distinct list of every material item touched by this assignment's
   * tasks. Maintained absolutely on CycleCountAssignmentEvents.V1.AssignmentCreated
   * from the per-task MaterialItemId. Backs Mongo-side filtering in
   * GetAssignmentHistoryByItem via $in + index seek (B4-E).
   */
  materialItemIds: Array<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * The worker id this assignment was reassigned FROM by the most recent
   * reassignCountAssignment/unassignCountAssignment mutation (Round 8
   * finding), or null when the assignment has never been reassigned or was previously
   * unassigned. Maintained absolutely from AssignmentReassigned.PreviousWorkerUserId
   * — together with workerUserId (the new worker, empty when unassigned),
   * workerReassignedBy and workerReassignedAt, this is the
   * audit trail the supervisor "Assignments" history panel shows for a worker change.
   */
  previousWorkerUserId?: Maybe<Scalars['String']['output']>;
  /**
   * Flattened, distinct list of every site location touched by this assignment's
   * tasks. Maintained absolutely on CycleCountAssignmentEvents.V1.AssignmentCreated
   * from the per-task SiteLocationId. Backs Mongo-side filtering in
   * GetAssignmentsByLocation via $in (B4-E). Empty when no task
   * carries a site (pre-B4-E historical events).
   */
  siteLocationIds: Array<Scalars['String']['output']>;
  status: CycleCountAssignmentStatus;
  tasks: Array<KeyValuePairOfStringAndAssignmentTaskSummary>;
  tenantId: Scalars['String']['output'];
  /** When the most recent reassign/unassign happened. Null until the first one. */
  workerReassignedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user id who performed the most recent reassign/unassign. Null until the first one. */
  workerReassignedBy?: Maybe<Scalars['String']['output']>;
  workerUserId: Scalars['String']['output'];
};

/**
 * Per-task projection of an assignment task for the supervisor summary. Read-model-only type
 * (not the event record). Status reflects the last absolute lifecycle event for the task.
 */
export type AssignmentTaskSummary = {
  __typename?: 'AssignmentTaskSummary';
  binLocationId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedQty?: Maybe<Scalars['Decimal']['output']>;
  expectedQty: Scalars['Decimal']['output'];
  materialItemId: Scalars['String']['output'];
  overrideQty?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Site location of the bin this task targets (B4-E). Captured on the
   * CycleCountAssignmentEvents.V1.AssignmentCreated event from
   * the MaterialItemLocationQuantity row at fan-out time. Null on
   * historical pre-B4-E events.
   */
  siteLocationId?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CycleCountTaskStatus;
  taskId: Scalars['String']['output'];
  varianceReasonCode?: Maybe<Scalars['Int']['output']>;
};

export type AsyncImportJobDocument = {
  __typename?: 'AsyncImportJobDocument';
  asyncImportJobId: Scalars['String']['output'];
  autoStartImport: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  failedRows: Scalars['Int']['output'];
  /**
   * The name of the file the import was uploaded from. Null for imports created before names were saved, and
   *             for a client that sends none.
   */
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importedRows: Scalars['Int']['output'];
  jobType: AsyncImportJobType;
  status: AsyncImportJobStatus;
  tenantId: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  validatedRows: Scalars['Int']['output'];
};

export type AsyncImportJobDocumentFilterInput = {
  and?: InputMaybe<Array<AsyncImportJobDocumentFilterInput>>;
  asyncImportJobId?: InputMaybe<StringOperationFilterInput>;
  autoStartImport?: InputMaybe<BooleanOperationFilterInput>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  failedRows?: InputMaybe<IntOperationFilterInput>;
  /**
   * The name of the file the import was uploaded from. Null for imports created before names were saved, and
   *             for a client that sends none.
   */
  fileName?: InputMaybe<OptionOfStringFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  importedRows?: InputMaybe<IntOperationFilterInput>;
  jobType?: InputMaybe<AsyncImportJobTypeOperationFilterInput>;
  or?: InputMaybe<Array<AsyncImportJobDocumentFilterInput>>;
  status?: InputMaybe<AsyncImportJobStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalRows?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  validatedRows?: InputMaybe<IntOperationFilterInput>;
};

export type AsyncImportJobDocumentSortInput = {
  asyncImportJobId?: InputMaybe<SortEnumType>;
  autoStartImport?: InputMaybe<SortEnumType>;
  completedAt?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  failedRows?: InputMaybe<SortEnumType>;
  /**
   * The name of the file the import was uploaded from. Null for imports created before names were saved, and
   *             for a client that sends none.
   */
  fileName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importedRows?: InputMaybe<SortEnumType>;
  jobType?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalRows?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  validatedRows?: InputMaybe<SortEnumType>;
};

export type AsyncImportJobPayload = {
  __typename?: 'AsyncImportJobPayload';
  asyncImportJob?: Maybe<AsyncImportJobDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum AsyncImportJobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Importing = 'IMPORTING',
  Pending = 'PENDING',
  ReadyForImport = 'READY_FOR_IMPORT',
  Unknown = 'UNKNOWN',
  Uploading = 'UPLOADING',
  Validated = 'VALIDATED',
  Validating = 'VALIDATING',
  ValidationFailed = 'VALIDATION_FAILED'
}

export type AsyncImportJobStatusOperationFilterInput = {
  eq?: InputMaybe<AsyncImportJobStatus>;
  in?: InputMaybe<Array<AsyncImportJobStatus>>;
  neq?: InputMaybe<AsyncImportJobStatus>;
  nin?: InputMaybe<Array<AsyncImportJobStatus>>;
};

export enum AsyncImportJobType {
  ProductionLot = 'PRODUCTION_LOT',
  SiteLocation = 'SITE_LOCATION',
  Unknown = 'UNKNOWN'
}

export type AsyncImportJobTypeOperationFilterInput = {
  eq?: InputMaybe<AsyncImportJobType>;
  in?: InputMaybe<Array<AsyncImportJobType>>;
  neq?: InputMaybe<AsyncImportJobType>;
  nin?: InputMaybe<Array<AsyncImportJobType>>;
};

/** A connection to a list of items. */
export type AsyncImportJobsConnection = {
  __typename?: 'AsyncImportJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AsyncImportJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AsyncImportJobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AsyncImportJobsEdge = {
  __typename?: 'AsyncImportJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AsyncImportJobDocument;
};

export enum AsyncImportRowStatus {
  Imported = 'IMPORTED',
  ImportFailed = 'IMPORT_FAILED',
  New = 'NEW',
  Unknown = 'UNKNOWN',
  Validated = 'VALIDATED',
  ValidationFailed = 'VALIDATION_FAILED'
}

export type AsyncImportRowStatusOperationFilterInput = {
  eq?: InputMaybe<AsyncImportRowStatus>;
  in?: InputMaybe<Array<AsyncImportRowStatus>>;
  neq?: InputMaybe<AsyncImportRowStatus>;
  nin?: InputMaybe<Array<AsyncImportRowStatus>>;
};

/**
 * Input record for the atomicMove mutation. Emits Created + Shipped + Received
 * in a single transaction with shared timestamp.
 */
export type AtomicMoveMovementOrderInput = {
  fromLocationId?: InputMaybe<Scalars['String']['input']>;
  fromSiteLocationId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  lines: Array<MovementOrderLineInput>;
  movementOrderId: Scalars['String']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  toLocationId?: InputMaybe<Scalars['String']['input']>;
  toSiteLocationId: Scalars['String']['input'];
};

export type AttachAvailabilityPhotoInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type AttachRestockSessionKitInput = {
  kitId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

/**
 * One recorded self-attested approval of an authored-SQL edit — ONE DOCUMENT PER APPROVAL, in
 * AdminWorkerConfigApprovals, read straight from the
 * WorkerConfig.V1.AuthoredSqlApprovalRecorded event so approval history is readable without
 * replaying the stream.
 */
export type AuthoredSqlApprovalDocument = {
  __typename?: 'AuthoredSqlApprovalDocument';
  /**
   * This approval's identity, minted on the event and used verbatim as the document key: the config, the
   * tenant, the merge it approves, the admin who attested to it, and a fingerprint of the change.
   */
  approvalId: Scalars['String']['output'];
  approvedAt: Scalars['DateTime']['output'];
  /** Which agent, if any, acted for that user — NotApplicable for an ordinary admin edit. */
  approvedByAgent: AgentType;
  /** The admin who made the edit and thereby attested to it. */
  approvedByUser: Scalars['String']['output'];
  changedFields: Array<AuthoredSqlFieldApprovalData>;
  /** The config the approved edit was made against. */
  configName: Scalars['String']['output'];
  /** The tenant whose config carried the edited field. */
  tenantId: Scalars['String']['output'];
};

export enum AuthoredSqlChangeKind {
  Added = 'ADDED',
  Edited = 'EDITED',
  Removed = 'REMOVED'
}

/** One authored-SQL field an approval covered. */
export type AuthoredSqlFieldApprovalData = {
  __typename?: 'AuthoredSqlFieldApprovalData';
  /**
   * Where the field sits in the tenant's config JSON — OverrideSql, SiteLocationSql, or
   * Destinations[n:{name}].{field} — Destinations[i:{index}].{field} when the destination
   * declares no name.
   */
  fieldPath: Scalars['String']['output'];
  /**
   * Whether the field was added, edited, or removed. A removal — emptying the field, or dropping its whole
   * tenant from the config — would otherwise read as an ordinary edit.
   */
  kind: AuthoredSqlChangeKind;
  /**
   * The approver class the config DECLARED, verbatim: Client, Internal, null when it declared
   * none, or whatever else it named. Never inferred from a connection string, and never guessed.
   * OptionTypeInterceptor surfaces it as a nullable GraphQL String.
   */
  whoseSystem?: Maybe<Scalars['String']['output']>;
};

export type AutoAllocateRestockSessionOrderQuantitiesInput = {
  allocations: Array<AutoAllocateRestockSessionOrderQuantityAllocationDataInput>;
  itemId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type AutoAllocateRestockSessionOrderQuantityAllocationDataInput = {
  customerLocationId: Scalars['String']['input'];
  orderQuantity: Scalars['Int']['input'];
};

export type AutoLinkRampBillToPurchaseOrderInput = {
  purchaseOrderId: Scalars['String']['input'];
  rampBillId: Scalars['String']['input'];
};

export type AvailabilityAdjustmentData = {
  __typename?: 'AvailabilityAdjustmentData';
  comment: Scalars['String']['output'];
  direction: AvailabilityAdjustmentDirection;
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  reason: AvailabilityAdjustmentReason;
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export enum AvailabilityAdjustmentDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

export enum AvailabilityAdjustmentReason {
  Ordered = 'ORDERED',
  OrderCancelled = 'ORDER_CANCELLED'
}

export type AvailabilityCountData = {
  __typename?: 'AvailabilityCountData';
  comment: Scalars['String']['output'];
  countRowId: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type AvailabilityImportItemInput = {
  itemMatcher: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
};

export enum AvailabilityImportItemMatchStatus {
  Matched = 'MATCHED',
  MultipleMatches = 'MULTIPLE_MATCHES',
  NotFound = 'NOT_FOUND'
}

export type AvailabilityImportItemResolutionData = {
  __typename?: 'AvailabilityImportItemResolutionData';
  itemId?: Maybe<Scalars['String']['output']>;
  itemMatcher: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  status: AvailabilityImportItemMatchStatus;
};

export type AvailabilityImportItemResolutionPayload = {
  __typename?: 'AvailabilityImportItemResolutionPayload';
  errors?: Maybe<Array<ValidationError>>;
  items?: Maybe<Array<AvailabilityImportItemResolutionData>>;
};

/** The odds the model gave one grade. */
export type AvailabilityPhotoGradeOdds = {
  __typename?: 'AvailabilityPhotoGradeOdds';
  /** The grade, 1 to 5. */
  grade: Scalars['Int']['output'];
  /** The model's probability for the grade, 0 to 1. */
  probability: Scalars['Float']['output'];
};

/** The odds the model gave one grade. */
export type AvailabilityPhotoGradeOddsInput = {
  /** The grade, 1 to 5. */
  grade: Scalars['Int']['input'];
  /** The model's probability for the grade, 0 to 1. */
  probability: Scalars['Float']['input'];
};

/** What the grading worker reports for one claimed photo. */
export enum AvailabilityPhotoGradeOutcome {
  /** The model failed permanently for this photo. */
  Failed = 'FAILED',
  /** The worker did not grade the photo, for example because the model answered none. */
  Skipped = 'SKIPPED',
  /** The model suggested a grade, recorded as its own event. */
  Suggested = 'SUGGESTED',
  /** Unset: no outcome recorded yet. The worker never sends it; a record carrying it is refused. */
  Unknown = 'UNKNOWN'
}

/** One photo the grading worker has leased. */
export type AvailabilityPhotoGradeRequest = {
  __typename?: 'AvailabilityPhotoGradeRequest';
  /** How many times the row has been claimed, this claim included. */
  attempts: Scalars['Int']['output'];
  /** The item the photo is of. */
  itemId: Scalars['String']['output'];
  /** The bin the photo was taken at; null when the photo has no bin. */
  locationId?: Maybe<Scalars['String']['output']>;
  /** The photo. */
  photoId: Scalars['String']['output'];
  /** The photo's absolute public URL. */
  photoUrl: Scalars['String']['output'];
  /** When the photo was taken. */
  recordedAt: Scalars['DateTime']['output'];
  /** The row to record the outcome against, {tenantId}-{photoId}. */
  requestId: Scalars['String']['output'];
};

/** The newest grade suggestion recorded for one photo. */
export type AvailabilityPhotoGradeSuggestion = {
  __typename?: 'AvailabilityPhotoGradeSuggestion';
  /** The model's confidence in the grade, 0 to 1. */
  confidence: Scalars['Float']['output'];
  /** The suggested grade, 1 to 5. */
  grade: Scalars['Int']['output'];
  /** The odds the model gave each grade 1 to 5, in grade order. */
  gradeOdds: Array<AvailabilityPhotoGradeOdds>;
  /** The item the photo is of. */
  itemId: Scalars['String']['output'];
  /** The bin the photo was taken at; null when the photo has no bin. */
  locationId?: Maybe<Scalars['String']['output']>;
  /** The model and scale that made the suggestion. */
  modelVersion: Scalars['String']['output'];
  /** The photo the suggestion is for. */
  photoId: Scalars['String']['output'];
  /** When the suggestion was recorded. */
  suggestedAt: Scalars['DateTime']['output'];
};

/** The model's grade suggestion for one photo. */
export type AvailabilityPhotoGradeSuggestionInput = {
  /** The model's confidence in the grade, 0 to 1. */
  confidence: Scalars['Float']['input'];
  /** The suggested grade, 1 to 5: the grade with the highest odds. */
  grade: Scalars['Int']['input'];
  /** One entry per grade 1 to 5, each 0 to 1, summing to 1 within 0.01. */
  gradeOdds: Array<AvailabilityPhotoGradeOddsInput>;
  /** The model and scale that made the suggestion, at most 128 characters. */
  modelVersion: Scalars['String']['input'];
};

export enum AvailabilityQuantityBasis {
  Eaches = 'EACHES',
  ShippingUom = 'SHIPPING_UOM'
}

export enum AvailabilityQuantityEntry {
  Calculator = 'CALCULATOR',
  Keypad = 'KEYPAD'
}

export type AvailabilitySessionLogData = {
  __typename?: 'AvailabilitySessionLogData';
  comment: Scalars['String']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
};

/** The result of an availability session mutation. */
export type AvailabilitySessionPayload = {
  __typename?: 'AvailabilitySessionPayload';
  /**
   * The id of the photo attachAvailabilitySessionPhoto attached or found already attached; null for every other
   * mutation and for an idempotent replay of a record written before the id was kept.
   */
  attachedPhotoId?: Maybe<Scalars['String']['output']>;
  /** Populated only when the mutation failed. */
  errors?: Maybe<Array<ValidationError>>;
  /** The session after the change; null on failure and for a photo attach. */
  session?: Maybe<AvailabilitySessionStateData>;
};

/**
 * The schema shape of AvailabilitySessionPayload.session. Availability sessions are retired and nothing
 * builds this any more, so the field is always null; the shape stays so clients that still select it keep
 * validating.
 */
export type AvailabilitySessionStateData = {
  __typename?: 'AvailabilitySessionStateData';
  adjustments: Array<AvailabilityAdjustmentData>;
  counts: Array<AvailabilityCountData>;
  logs: Array<AvailabilitySessionLogData>;
  sessionId: Scalars['String']['output'];
  status: AvailabilitySessionStatus;
  tenantId: Scalars['String']['output'];
};

export enum AvailabilitySessionStatus {
  Closed = 'CLOSED',
  Live = 'LIVE',
  Staged = 'STAGED'
}

export enum AvailabilitySource {
  Ledger = 'LEDGER',
  Session = 'SESSION'
}

/** A connection to a list of items. */
export type AvailableInventoryConnection = {
  __typename?: 'AvailableInventoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AvailableInventoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InventoryItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AvailableInventoryEdge = {
  __typename?: 'AvailableInventoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InventoryItemDocument;
};

/** One of the caller's background jobs, as the header queue shows it. */
export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  /** When the job was requested. */
  createdAt: Scalars['DateTime']['output'];
  /** When the owner dismissed it; null until then. */
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  /** How many items are done. */
  done: Scalars['Int']['output'];
  /** How many items failed. */
  failed: Scalars['Int']['output'];
  /** When the job finished; null while it is open. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True for a job the queue only lists: it cannot be cancelled or retried from here. */
  isListedOnly: Scalars['Boolean']['output'];
  /** The tenant-unique job id. */
  jobId: Scalars['String']['output'];
  /** Where to see what the job made, or null when its type has no result page. */
  resultLink?: Maybe<Scalars['String']['output']>;
  /** The screen route the job was started from. */
  sourceRoute: Scalars['String']['output'];
  /** Where the job is. */
  status: BackgroundJobStatus;
  /** The label the queue shows. */
  title: Scalars['String']['output'];
  /** How many items the job has. */
  total: Scalars['Int']['output'];
  /** What the job does. */
  type: BackgroundJobType;
  /** When the job last changed. */
  updatedAt: Scalars['DateTime']['output'];
};

/** One item of a background job, as the owner sees it. */
export type BackgroundJobItem = {
  __typename?: 'BackgroundJobItem';
  /** How many times the item has been attempted. */
  attempt: Scalars['Int']['output'];
  /** Why the item failed or was skipped; null when there is no reason. */
  error?: Maybe<Scalars['String']['output']>;
  /** The job-unique id of the item. */
  itemId: Scalars['String']['output'];
  /** What the row shows. */
  label: Scalars['String']['output'];
  /** The ids of what handling the item created or changed. */
  resultIds: Array<Scalars['String']['output']>;
  /** Where the item is. */
  state: BackgroundJobItemState;
};

/** Where one item of a background job is. Stored by NAME; never reorder, renumber or reuse a member. */
export enum BackgroundJobItemState {
  /** Handled successfully. */
  Done = 'DONE',
  /** Handling failed; the error says why. */
  Failed = 'FAILED',
  /** Not handled yet. */
  Pending = 'PENDING',
  /** Not attempted, for example because the job was cancelled first. */
  Skipped = 'SKIPPED'
}

/** A background job, or the errors that stopped the call. */
export type BackgroundJobPayload = {
  __typename?: 'BackgroundJobPayload';
  backgroundJob?: Maybe<BackgroundJob>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * The id-only event onBackgroundJobProgress emits when one of the caller's jobs changes. Read the job with
 * backgroundJob or myBackgroundJobs on each event; nothing else is carried, so the event stays small
 * on the Redis subscription provider and never renders a stale job.
 */
export type BackgroundJobProgressEvent = {
  __typename?: 'BackgroundJobProgressEvent';
  /** The job that changed. */
  jobId: Scalars['String']['output'];
};

/**
 * Where a background job is. Stored by NAME; the explicit ordinals keep the GraphQL enum stable. Never
 * reorder, renumber or reuse a member.
 */
export enum BackgroundJobStatus {
  /** Stopped by the owner. Items handled before the stop stay handled. */
  Cancelled = 'CANCELLED',
  /** Every item was handled and none failed. */
  Completed = 'COMPLETED',
  /** Every item was handled and at least one failed. */
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  /** The job itself broke. */
  Failed = 'FAILED',
  /** Waiting for the worker's next pass. */
  Pending = 'PENDING',
  /** Stored but not yet handed to the worker. */
  Queued = 'QUEUED',
  /** The worker has started on this job's items. */
  Running = 'RUNNING'
}

/**
 * What a background job does. Stored by NAME; the explicit ordinals keep the GraphQL enum stable. Never
 * reorder, renumber or reuse a member. A type is only usable once its job type is registered.
 */
export enum BackgroundJobType {
  /** The bulk order delete job, listed in the queue read-only. */
  BulkOrderDelete = 'BULK_ORDER_DELETE',
  /** Saves a portal buyer's reviewed retail price drafts for its own customer, one item per draft row. */
  BuyerRetailPriceSave = 'BUYER_RETAIL_PRICE_SAVE',
  /** Creates a produce plan, one item per plan line. */
  CreatePlan = 'CREATE_PLAN',
  /** Requests one planned-arrival notice per served stop. */
  EtaNotices = 'ETA_NOTICES',
  /** Updates a registered field, one customer, item or vendor per item. */
  FieldUpdate = 'FIELD_UPDATE',
  /** Attaches one event to many production jobs of the Production Schedule, one item per job. */
  JobEventsAdd = 'JOB_EVENTS_ADD',
  /** Removes one event from many production jobs of the Production Schedule, one item per job. */
  JobEventsRemove = 'JOB_EVENTS_REMOVE',
  /** Applies a lot change to many lots. */
  LotChanges = 'LOT_CHANGES',
  /** Deactivates production lots, one item per lot. */
  LotDeactivate = 'LOT_DEACTIVATE',
  /** Moves the ready and start weeks of production jobs, one item per lot, cascading to descendant jobs. */
  LotWeekOverrides = 'LOT_WEEK_OVERRIDES',
  /** Imports validated CSV orders, one item per order. */
  OrderImport = 'ORDER_IMPORT',
  /** Renders invoice PDFs and packages them for download. */
  PdfZip = 'PDF_ZIP',
  /** Invites one customer contact per item. */
  PortalInvites = 'PORTAL_INVITES',
  /** Posts production jobs from the produce schedule, one item per finish job, then consumes its hardgoods. */
  PostJobs = 'POST_JOBS',
  /** Links QuickBooks customers, or undoes a previous link job. */
  QuickBooksCustomerLink = 'QUICK_BOOKS_CUSTOMER_LINK',
  /** The schedule import job, listed in the queue read-only. */
  ScheduleImport = 'SCHEDULE_IMPORT'
}

/**
 * Result containing an enabled background service configuration for a pod manifest.
 * MultiReplicaCapable is derived from ServiceName;
 * Replicas is the deployment replica count for this (service × pod) row.
 */
export type BackgroundServiceConfigManifestResult = {
  __typename?: 'BackgroundServiceConfigManifestResult';
  displayName: Scalars['String']['output'];
  multiReplicaCapable: Scalars['Boolean']['output'];
  replicas: Scalars['Int']['output'];
  scope: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  tenantIds: Array<Scalars['String']['output']>;
  timerPeriodSeconds: Scalars['Int']['output'];
  workerConfigs: Array<Scalars['String']['output']>;
};

export type BackgroundServiceConfigStateData = {
  __typename?: 'BackgroundServiceConfigStateData';
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  lastModified: Scalars['DateTime']['output'];
  /**
   * Code-owned flag derived from ServiceName. Read-only on the API surface —
   * never present on any mutation input.
   */
  multiReplicaCapable: Scalars['Boolean']['output'];
  podAssignments: Array<PodAssignmentStateData>;
  scope: BackgroundServiceScope;
  serviceName: BackgroundServiceName;
  timerPeriodSeconds: Scalars['Int']['output'];
  updatedBy: Scalars['String']['output'];
  workerConfigs: Array<Scalars['String']['output']>;
};

export enum BackgroundServiceName {
  AcknowledgmentEmail = 'ACKNOWLEDGMENT_EMAIL',
  AsyncImport = 'ASYNC_IMPORT',
  AutoInvoice = 'AUTO_INVOICE',
  AvailabilityPhotoGrade = 'AVAILABILITY_PHOTO_GRADE',
  BackgroundJobs = 'BACKGROUND_JOBS',
  BcCustomerSync = 'BC_CUSTOMER_SYNC',
  BcItemSync = 'BC_ITEM_SYNC',
  /** @deprecated Superseded by GrowerBenchmarkCohortStatistics (142). Retained for BSON string round-tripping of existing config docs per discipline bf43effe. Never renumber or reuse ordinal 140. */
  BenchmarkCohortStatistics = 'BENCHMARK_COHORT_STATISTICS',
  BillingStatusNotifier = 'BILLING_STATUS_NOTIFIER',
  /** @deprecated Superseded by LegacyProduceSync (127), the generic per-tenant legacy PRODUCE feed. Retained for BSON string round-tripping of existing config docs per discipline bf43effe. Never renumber or reuse ordinal 125. */
  BlnProduceSync = 'BLN_PRODUCE_SYNC',
  BpfCustomerSync = 'BPF_CUSTOMER_SYNC',
  BpfCycleCountMissionPostback = 'BPF_CYCLE_COUNT_MISSION_POSTBACK',
  BpfCycleCountMissionSync = 'BPF_CYCLE_COUNT_MISSION_SYNC',
  BpfDtsOnHandQueuing = 'BPF_DTS_ON_HAND_QUEUING',
  BpfErpAvailabilitySync = 'BPF_ERP_AVAILABILITY_SYNC',
  BpfErpInTransitSync = 'BPF_ERP_IN_TRANSIT_SYNC',
  BpfErpOrderReceiptPostback = 'BPF_ERP_ORDER_RECEIPT_POSTBACK',
  BpfErpOrderSync = 'BPF_ERP_ORDER_SYNC',
  BpfErpRouteAssignmentSync = 'BPF_ERP_ROUTE_ASSIGNMENT_SYNC',
  BpfFgAvailabilitySift = 'BPF_FG_AVAILABILITY_SIFT',
  BpfFgAvailabilitySnapshot = 'BPF_FG_AVAILABILITY_SNAPSHOT',
  BpfFinishLotPostback = 'BPF_FINISH_LOT_POSTBACK',
  BpfFinishLotSync = 'BPF_FINISH_LOT_SYNC',
  BpfInventoryInTransitSync = 'BPF_INVENTORY_IN_TRANSIT_SYNC',
  BpfInventoryStateSync = 'BPF_INVENTORY_STATE_SYNC',
  BpfItemPricingSync = 'BPF_ITEM_PRICING_SYNC',
  BpfItemSync = 'BPF_ITEM_SYNC',
  BpfLotChangeReasonSync = 'BPF_LOT_CHANGE_REASON_SYNC',
  BpfMaterialCountPostback = 'BPF_MATERIAL_COUNT_POSTBACK',
  BpfMaterialLotProcessing = 'BPF_MATERIAL_LOT_PROCESSING',
  BpfNavOnHandQueuing = 'BPF_NAV_ON_HAND_QUEUING',
  BpfOnHandProcess = 'BPF_ON_HAND_PROCESS',
  BpfRetailBpLotSync = 'BPF_RETAIL_BP_LOT_SYNC',
  BpfRetailCountPostback = 'BPF_RETAIL_COUNT_POSTBACK',
  BpfRfidScanSync = 'BPF_RFID_SCAN_SYNC',
  BpfSalesPeopleSync = 'BPF_SALES_PEOPLE_SYNC',
  BpfSiteLocationsSync = 'BPF_SITE_LOCATIONS_SYNC',
  BpfStationManagerSync = 'BPF_STATION_MANAGER_SYNC',
  BpfUnitsOnHandSync = 'BPF_UNITS_ON_HAND_SYNC',
  BpfUnitsShippedSync = 'BPF_UNITS_SHIPPED_SYNC',
  BpfUserStartingNodeSync = 'BPF_USER_STARTING_NODE_SYNC',
  BulkOrderDelete = 'BULK_ORDER_DELETE',
  ClickUpTimeAggregation = 'CLICK_UP_TIME_AGGREGATION',
  ConfirmationEmail = 'CONFIRMATION_EMAIL',
  ConsolidationApplication = 'CONSOLIDATION_APPLICATION',
  ContractRecordEnrollmentWorker = 'CONTRACT_RECORD_ENROLLMENT_WORKER',
  CorrectionRun = 'CORRECTION_RUN',
  CsvIngest = 'CSV_INGEST',
  CsvToMongoSync = 'CSV_TO_MONGO_SYNC',
  CsvToSqlSync = 'CSV_TO_SQL_SYNC',
  CustomerClean = 'CUSTOMER_CLEAN',
  CustomerSync = 'CUSTOMER_SYNC',
  DailyTenantSync = 'DAILY_TENANT_SYNC',
  DuplicateFinder = 'DUPLICATE_FINDER',
  ErpLoadListRouteSync = 'ERP_LOAD_LIST_ROUTE_SYNC',
  ErpLoadListUserSync = 'ERP_LOAD_LIST_USER_SYNC',
  FeatureFlagProductConversion = 'FEATURE_FLAG_PRODUCT_CONVERSION',
  /** @deprecated Retired by the FinanceCharge teardown; late charges accrue at read time through InvoiceAccrual and nothing assesses a period. Retained for BSON string round-tripping of existing config docs per discipline bf43effe. Never renumber or reuse ordinal 106. */
  FinanceChargeAssessment = 'FINANCE_CHARGE_ASSESSMENT',
  FlagStaleFloatingTimeEntry = 'FLAG_STALE_FLOATING_TIME_ENTRY',
  FlakyTaskCreator = 'FLAKY_TASK_CREATOR',
  FootTrafficIngestion = 'FOOT_TRAFFIC_INGESTION',
  FredIngestion = 'FRED_INGESTION',
  GrowerBenchmarkCohortStatistics = 'GROWER_BENCHMARK_COHORT_STATISTICS',
  GrowPointCategoryImport = 'GROW_POINT_CATEGORY_IMPORT',
  GrowPointCategoryValidate = 'GROW_POINT_CATEGORY_VALIDATE',
  GrowPointCustomerExtract = 'GROW_POINT_CUSTOMER_EXTRACT',
  GrowPointCustomerExtractor = 'GROW_POINT_CUSTOMER_EXTRACTOR',
  GrowPointCustomerImport = 'GROW_POINT_CUSTOMER_IMPORT',
  GrowPointCustomerValidate = 'GROW_POINT_CUSTOMER_VALIDATE',
  GrowPointHistoricalOrderImport = 'GROW_POINT_HISTORICAL_ORDER_IMPORT',
  GrowPointHistoricalOrderValidate = 'GROW_POINT_HISTORICAL_ORDER_VALIDATE',
  GrowPointImport = 'GROW_POINT_IMPORT',
  GrowPointInventoryImport = 'GROW_POINT_INVENTORY_IMPORT',
  GrowPointInventoryValidate = 'GROW_POINT_INVENTORY_VALIDATE',
  GrowPointItemExtract = 'GROW_POINT_ITEM_EXTRACT',
  GrowPointItemExtractor = 'GROW_POINT_ITEM_EXTRACTOR',
  GrowPointItemImport = 'GROW_POINT_ITEM_IMPORT',
  GrowPointItemValidate = 'GROW_POINT_ITEM_VALIDATE',
  GrowPointPriceImport = 'GROW_POINT_PRICE_IMPORT',
  GrowPointPriceValidate = 'GROW_POINT_PRICE_VALIDATE',
  GrowPointSiteLocationImport = 'GROW_POINT_SITE_LOCATION_IMPORT',
  GrowPointSiteLocationValidate = 'GROW_POINT_SITE_LOCATION_VALIDATE',
  GrowPointTaxAuthorityImport = 'GROW_POINT_TAX_AUTHORITY_IMPORT',
  GrowPointTaxAuthorityValidate = 'GROW_POINT_TAX_AUTHORITY_VALIDATE',
  GrowPointTermsImport = 'GROW_POINT_TERMS_IMPORT',
  GrowPointTermsValidate = 'GROW_POINT_TERMS_VALIDATE',
  InboundDocumentIngest = 'INBOUND_DOCUMENT_INGEST',
  InvoiceEmail = 'INVOICE_EMAIL',
  IoTIngestion = 'IO_T_INGESTION',
  IoTPendingRoutesDrain = 'IO_T_PENDING_ROUTES_DRAIN',
  ItemClean = 'ITEM_CLEAN',
  ItemPricingSync = 'ITEM_PRICING_SYNC',
  ItemProgramClean = 'ITEM_PROGRAM_CLEAN',
  ItemSync = 'ITEM_SYNC',
  IterationFailureEmail = 'ITERATION_FAILURE_EMAIL',
  JobSync = 'JOB_SYNC',
  LearningNudge = 'LEARNING_NUDGE',
  LegacyProduceSync = 'LEGACY_PRODUCE_SYNC',
  LoadEmailDispatch = 'LOAD_EMAIL_DISPATCH',
  LoadListSync = 'LOAD_LIST_SYNC',
  LocationSync = 'LOCATION_SYNC',
  MergeDevCrmExport = 'MERGE_DEV_CRM_EXPORT',
  MergeDevCrmImport = 'MERGE_DEV_CRM_IMPORT',
  MergeDevImport = 'MERGE_DEV_IMPORT',
  MigrationImport = 'MIGRATION_IMPORT',
  MigrationPreparation = 'MIGRATION_PREPARATION',
  NewsIngestion = 'NEWS_INGESTION',
  NoaaIngestion = 'NOAA_INGESTION',
  NotificationDispatch = 'NOTIFICATION_DISPATCH',
  OrderEaseAvailability = 'ORDER_EASE_AVAILABILITY',
  OrderEaseCatalog = 'ORDER_EASE_CATALOG',
  OrderEaseImport = 'ORDER_EASE_IMPORT',
  OrderSync = 'ORDER_SYNC',
  PipelineFlakeImport = 'PIPELINE_FLAKE_IMPORT',
  PortalLoginRedirectSync = 'PORTAL_LOGIN_REDIRECT_SYNC',
  /** @deprecated Retired with the PortalUserRequest queue (Kennedy 2026-07-17); worker decommission tracked separately. Retained for BSON string round-tripping of existing config docs per discipline bf43effe — never renumber or reuse ordinal 33. */
  PortalUserSync = 'PORTAL_USER_SYNC',
  ProductionTriggerReminders = 'PRODUCTION_TRIGGER_REMINDERS',
  /** wsapi-services worker that syncs Ramp vendors and bills, links bills to POs and copies POs to Ramp (Ramp Plus). */
  RampSync = 'RAMP_SYNC',
  ReportScheduleExecution = 'REPORT_SCHEDULE_EXECUTION',
  RestockCalcAchievableQuantity = 'RESTOCK_CALC_ACHIEVABLE_QUANTITY',
  RestockCalcAchievableQuantityDrain = 'RESTOCK_CALC_ACHIEVABLE_QUANTITY_DRAIN',
  RestockCalcDemandQuantity = 'RESTOCK_CALC_DEMAND_QUANTITY',
  RestockCalcScheduler = 'RESTOCK_CALC_SCHEDULER',
  RestockCalcStalenessNotifier = 'RESTOCK_CALC_STALENESS_NOTIFIER',
  RestockCalcWorkMembershipUpserter = 'RESTOCK_CALC_WORK_MEMBERSHIP_UPSERTER',
  RestockOrderSync = 'RESTOCK_ORDER_SYNC',
  RestockPreCalculation = 'RESTOCK_PRE_CALCULATION',
  SalesPeopleSync = 'SALES_PEOPLE_SYNC',
  ScheduledInventoryTransfer = 'SCHEDULED_INVENTORY_TRANSFER',
  ScheduledSql = 'SCHEDULED_SQL',
  SftpSync = 'SFTP_SYNC',
  ShopifyAvailabilitySync = 'SHOPIFY_AVAILABILITY_SYNC',
  ShopifyOrderImport = 'SHOPIFY_ORDER_IMPORT',
  SignupForgeHook = 'SIGNUP_FORGE_HOOK',
  SiteLocationsSync = 'SITE_LOCATIONS_SYNC',
  StatementPrintBatch = 'STATEMENT_PRINT_BATCH',
  SupportHelm = 'SUPPORT_HELM',
  SupportNotify = 'SUPPORT_NOTIFY',
  TestTimingRollup = 'TEST_TIMING_ROLLUP',
  TrialExpiry = 'TRIAL_EXPIRY',
  TrialProvisioning = 'TRIAL_PROVISIONING',
  Unknown = 'UNKNOWN',
  UserInvite = 'USER_INVITE',
  UserLastLoginSync = 'USER_LAST_LOGIN_SYNC',
  /** wsapi-services worker that leases What's new email batches, sends one SendGrid request per batch and records each attempt. */
  WhatsNewEmailDispatch = 'WHATS_NEW_EMAIL_DISPATCH'
}

export type BackgroundServiceNameOperationFilterInput = {
  eq?: InputMaybe<BackgroundServiceName>;
  in?: InputMaybe<Array<BackgroundServiceName>>;
  neq?: InputMaybe<BackgroundServiceName>;
  nin?: InputMaybe<Array<BackgroundServiceName>>;
};

export enum BackgroundServiceScope {
  PerTenant = 'PER_TENANT',
  System = 'SYSTEM'
}

export type BackgroundServiceScopeOperationFilterInput = {
  eq?: InputMaybe<BackgroundServiceScope>;
  in?: InputMaybe<Array<BackgroundServiceScope>>;
  neq?: InputMaybe<BackgroundServiceScope>;
  nin?: InputMaybe<Array<BackgroundServiceScope>>;
};

export type BaseRateOfSaleDocument = {
  __typename?: 'BaseRateOfSaleDocument';
  calcSteps: Array<RestockCalcStep>;
  calculatedAt: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemCode: Scalars['String']['output'];
  locationCode: Scalars['String']['output'];
  program: Scalars['String']['output'];
  /** Total units sold across all days in the base-rate-of-sale trailing window (pre-constraint). */
  rawTrailingUnitsSold: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  /** Units sold across the subset of trailing days that passed constraint detection. */
  usableTrailingUnitsSold: Scalars['Int']['output'];
  weeklyRateOfSale: Scalars['Decimal']['output'];
};

export type BaseRateOfSaleDocumentFilterInput = {
  and?: InputMaybe<Array<BaseRateOfSaleDocumentFilterInput>>;
  calcSteps?: InputMaybe<ListFilterInputTypeOfRestockCalcStepFilterInput>;
  calculatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  locationCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BaseRateOfSaleDocumentFilterInput>>;
  program?: InputMaybe<StringOperationFilterInput>;
  /** Total units sold across all days in the base-rate-of-sale trailing window (pre-constraint). */
  rawTrailingUnitsSold?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Units sold across the subset of trailing days that passed constraint detection. */
  usableTrailingUnitsSold?: InputMaybe<IntOperationFilterInput>;
  weeklyRateOfSale?: InputMaybe<DecimalOperationFilterInput>;
};

export type BaseRateOfSaleDocumentSortInput = {
  calculatedAt?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCode?: InputMaybe<SortEnumType>;
  locationCode?: InputMaybe<SortEnumType>;
  program?: InputMaybe<SortEnumType>;
  /** Total units sold across all days in the base-rate-of-sale trailing window (pre-constraint). */
  rawTrailingUnitsSold?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Units sold across the subset of trailing days that passed constraint detection. */
  usableTrailingUnitsSold?: InputMaybe<SortEnumType>;
  weeklyRateOfSale?: InputMaybe<SortEnumType>;
};

export type BatchActivateCategoriesInput = {
  categories: Array<ActivateCategoryInput>;
};

export type BatchActivateCustomersInput = {
  customers: Array<ActivateCustomerInput>;
};

export type BatchActivateItemsInput = {
  items: Array<ActivateItemInput>;
};

export type BatchActivatePriceGroupsInput = {
  priceGroups: Array<ActivatePriceGroupInput>;
};

export type BatchAddCategoriesInput = {
  categories: Array<AddCategoryInput>;
};

export type BatchAssignItemStripeTaxCodeInput = {
  itemIds: Array<Scalars['String']['input']>;
  stripeTaxCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One row's outcome. skipped is true when a lot already exists at productionLotId: nothing
 * was written and productionLot is that lot. A deleted lot at the id is not skipped; the row has an
 * error instead. errors says why a row was not created.
 */
export type BatchCreateDraftProductionLotResult = {
  __typename?: 'BatchCreateDraftProductionLotResult';
  errors?: Maybe<Array<ValidationError>>;
  productionLot?: Maybe<ProductionLotStateData>;
  productionLotId: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
};

/** The draft production lots to submit in one call, each with the id the caller chose for it. */
export type BatchCreateDraftProductionLotsInput = {
  items: Array<CreateProductionLotInput>;
};

/**
 * One result per input row, in input order. errors is set, with no results, when the whole call is
 * refused and nothing was written.
 */
export type BatchCreateDraftProductionLotsPayload = {
  __typename?: 'BatchCreateDraftProductionLotsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<BatchCreateDraftProductionLotResult>;
};

export type BatchDeactivateProductionLotResult = {
  __typename?: 'BatchDeactivateProductionLotResult';
  errors?: Maybe<Array<ValidationError>>;
  productionLot?: Maybe<ProductionLotStateData>;
  productionLotId: Scalars['String']['output'];
};

export type BatchDeactivateProductionLotsInput = {
  items: Array<DeactivateProductionLotInput>;
};

export type BatchDeactivateProductionLotsPayload = {
  __typename?: 'BatchDeactivateProductionLotsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<BatchDeactivateProductionLotResult>;
};

export type BatchDeleteCustomersInput = {
  customers: Array<DeleteCustomerInput>;
};

export type BatchDeleteItemsInput = {
  items: Array<DeleteItemInput>;
};

export type BatchDeletePriceGroupsInput = {
  priceGroups: Array<DeletePriceGroupInput>;
};

export type BatchDeleteSiteLocationsInput = {
  siteLocations: Array<DeleteSiteLocationInput>;
};

export type BatchImportItemsInput = {
  items: Array<ImportItemRowInput>;
};

export type BatchInactivateCategoriesInput = {
  categories: Array<InactivateCategoryInput>;
};

export type BatchInactivateCustomersInput = {
  customers: Array<InactivateCustomerInput>;
};

export type BatchInactivateItemsInput = {
  items: Array<InactivateItemInput>;
};

export type BatchInactivatePriceGroupsInput = {
  priceGroups: Array<InactivatePriceGroupInput>;
};

/** One lot's quantity change. Carries exactly one of newQuantity or scalePercent. */
export type BatchLotQuantityOverrideInput = {
  /** The lot's new quantity, a positive whole number. */
  newQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The lot to change. */
  productionLotId: Scalars['String']['input'];
  /**
   * A non-zero percentage from -99 to 500 to scale the lot's current quantity by. The result rounds to the
   * nearest whole unit, halves away from zero, and is never below 1.
   */
  scalePercent?: InputMaybe<Scalars['Decimal']['input']>;
};

/** One row's outcome, in input order. A row that changes nothing is ok and saves nothing. */
export type BatchLotQuantityOverrideResult = {
  __typename?: 'BatchLotQuantityOverrideResult';
  /** Why the row failed, when ok is false. Other rows are not affected. */
  errors?: Maybe<Array<ValidationError>>;
  /** The lot's quantity after the change. */
  newQuantity?: Maybe<Scalars['Int']['output']>;
  /** The finish job's quantity after the change, refigured through yield. */
  newQuantityToProduce?: Maybe<Scalars['Int']['output']>;
  /** True when the row applied, or would apply on a dry run. */
  ok: Scalars['Boolean']['output'];
  /** The lot's quantity before the change. */
  previousQuantity?: Maybe<Scalars['Int']['output']>;
  /** The finish job's quantity before the change. */
  previousQuantityToProduce?: Maybe<Scalars['Int']['output']>;
  /** The lot the row named. */
  productionLotId: Scalars['String']['output'];
};

export type BatchOverrideProductionJobWeeksCascadedJob = {
  __typename?: 'BatchOverrideProductionJobWeeksCascadedJob';
  newWeekReadyDate?: Maybe<Scalars['DateTime']['output']>;
  newWeekStartDate?: Maybe<Scalars['DateTime']['output']>;
  previousWeekReadyDate?: Maybe<Scalars['DateTime']['output']>;
  previousWeekStartDate?: Maybe<Scalars['DateTime']['output']>;
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
};

export type BatchOverrideProductionJobWeeksInput = {
  lots: Array<BatchOverrideProductionJobWeeksLotInput>;
};

export type BatchOverrideProductionJobWeeksLotInput = {
  jobs: Array<BatchWeekOverrideJobInput>;
  productionLotId: Scalars['String']['input'];
};

export type BatchOverrideProductionJobWeeksPayload = {
  __typename?: 'BatchOverrideProductionJobWeeksPayload';
  cascadedJobs?: Maybe<Array<BatchOverrideProductionJobWeeksCascadedJob>>;
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
  results: Array<BatchOverrideProductionJobWeeksResult>;
};

export type BatchOverrideProductionJobWeeksResult = {
  __typename?: 'BatchOverrideProductionJobWeeksResult';
  errors?: Maybe<Array<ValidationError>>;
  ok: Scalars['Boolean']['output'];
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  weekReadyDate?: Maybe<Scalars['DateTime']['output']>;
  weekStartDate?: Maybe<Scalars['DateTime']['output']>;
};

/** A batch of lot quantity changes: 1 to 500 rows, each naming a different lot. */
export type BatchOverrideProductionLotQuantitiesInput = {
  /** When true, every row is checked and figured but nothing is saved. */
  dryRun?: Scalars['Boolean']['input'];
  /** The rows, one per lot. A lot id may appear only once. */
  lots: Array<BatchLotQuantityOverrideInput>;
};

/** The outcome of a batch lot quantity change. */
export type BatchOverrideProductionLotQuantitiesPayload = {
  __typename?: 'BatchOverrideProductionLotQuantitiesPayload';
  /**
   * Set only when the whole batch was rejected and nothing was written: no rows, more than 500 lots, a lot
   * id sent twice, or a lot with a job outside the caller's sites.
   */
  errors?: Maybe<Array<ValidationError>>;
  /** The current state of every lot whose row is ok, in input order. Null on a dry run. */
  productionLots?: Maybe<Array<ProductionLotStateData>>;
  /** One result per row, in input order. Empty when the whole batch was rejected. */
  results: Array<BatchLotQuantityOverrideResult>;
};

export type BatchRemoveCategoriesInput = {
  categories: Array<RemoveCategoryInput>;
};

export enum BatchSourceKind {
  Erp = 'ERP',
  Grown = 'GROWN',
  Store = 'STORE',
  Unknown = 'UNKNOWN',
  Vendor = 'VENDOR'
}

export type BatchSourceKindOperationFilterInput = {
  eq?: InputMaybe<BatchSourceKind>;
  in?: InputMaybe<Array<BatchSourceKind>>;
  neq?: InputMaybe<BatchSourceKind>;
  nin?: InputMaybe<Array<BatchSourceKind>>;
};

/** Batch timing aggregates over the recent window. */
export type BatchTimingsResult = {
  __typename?: 'BatchTimingsResult';
  /** Mean of TotalMs across the window. Null when no recent samples. */
  averageMs?: Maybe<Scalars['Long']['output']>;
  /**
   * 95th-percentile TotalMs using the nearest-rank method
   * (ceil(0.95 * n) - 1, clamped to [0, n-1]). Null when no recent samples.
   */
  p95Ms?: Maybe<Scalars['Long']['output']>;
  /** Number of iteration samples contributing to AverageMs / P95Ms. */
  sampleCount: Scalars['Int']['output'];
};

export type BatchUpdateCategoriesInput = {
  categories: Array<UpdateCategoryInput>;
};

/**
 * Batch input for batchUpdateCrmExportStatuses. The wsapi-services worker submits one row
 * per customer it processed this cycle; each row carries exactly one outcome. Mirrors
 * BatchUpdateMergeDevExportStatuses. Rows with zero or multiple outcomes are rejected
 * per-row, not at the batch level.
 */
export type BatchUpdateCrmExportStatusesInput = {
  updates: Array<CrmExportStatusUpdateRowInput>;
};

/**
 * Batch input for batchUpdateMergeDevExportStatuses. The worker submits one row per
 * processed entity; each row carries exactly one outcome discriminator (MergeDevExportStatusUpdateRow.Completed,
 * MergeDevExportStatusUpdateRow.FailedTransient, MergeDevExportStatusUpdateRow.FailedPermanent,
 * or MergeDevExportStatusUpdateRow.NotExported).
 * Rows with zero or multiple discriminators are rejected per-row, not at the batch level.
 */
export type BatchUpdateMergeDevExportStatusesInput = {
  updates: Array<MergeDevExportStatusUpdateRowInput>;
};

/** Many single-field variation saves in one call, applied one at a time in the order sent. */
export type BatchUpdateProductionRecipeVariationFieldsInput = {
  rows: Array<UpdateProductionRecipeVariationFieldsInput>;
};

/**
 * One result per row reached, in request order. Errors carries whole-batch outcomes only: an empty batch
 * or one over the size cap (Results empty), or the marker that the run stopped early because the request
 * was cancelled or its time budget was spent (Results holds every row reached).
 */
export type BatchUpdateProductionRecipeVariationFieldsPayload = {
  __typename?: 'BatchUpdateProductionRecipeVariationFieldsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<ProductionRecipeVariationFieldsResult>;
};

/** One row's outcome, keyed by recipe and variation so a caller can map it back to its request row. */
export type BatchUpdateProductionRecipeVariationResult = {
  __typename?: 'BatchUpdateProductionRecipeVariationResult';
  errors?: Maybe<Array<ValidationError>>;
  productionRecipeId: Scalars['String']['output'];
  status: BatchUpdateProductionRecipeVariationStatus;
  variationId: Scalars['String']['output'];
};

/** How one requested row of a batch variation update ended. */
export enum BatchUpdateProductionRecipeVariationStatus {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Skipped = 'SKIPPED'
}

/** The rows of one batch variation update, each identical to a single-update input. */
export type BatchUpdateProductionRecipeVariationsInput = {
  rows: Array<UpdateProductionRecipeVariationInput>;
};

/**
 * Per-row results in request order. Top-level Errors carries whole-batch outcomes rather than row
 * ones: the rejections raised before any row is touched (an empty batch, the size cap, duplicate
 * variation ids) and the marker that the run was truncated, by a cancelled request or by its time
 * budget being spent. A rejection leaves Results empty; a truncated run leaves in Results every row it
 * actually processed, whatever that row's status, so a short Results list is never silently read as a
 * complete report.
 */
export type BatchUpdateProductionRecipeVariationsPayload = {
  __typename?: 'BatchUpdateProductionRecipeVariationsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<BatchUpdateProductionRecipeVariationResult>;
};

export type BatchWeekOverrideJobInput = {
  newWeekReadyDate?: InputMaybe<Scalars['DateTime']['input']>;
  newWeekStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  productionJobId: Scalars['String']['input'];
  shiftWeeks?: InputMaybe<Scalars['Int']['input']>;
};

/** The site after a bulk pole create, with the pole names it created and the names the bay already had. */
export type BayPolesPayload = {
  __typename?: 'BayPolesPayload';
  created?: Maybe<Array<Scalars['String']['output']>>;
  errors?: Maybe<Array<ValidationError>>;
  siteLocation?: Maybe<SiteLocationStateData>;
  skipped?: Maybe<Array<Scalars['String']['output']>>;
};

/** Input opening one member firm of a GrowerBenchmark community for a typed reason (contract K2). */
export type BeginGrowerBenchmarkFirmLookupInput = {
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Registered firm identifier within the community. */
  firmId: Scalars['String']['input'];
  /** Reason recorded on the access log row; required by the schema. */
  reason: Scalars['String']['input'];
};

export enum BillingFrequency {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Quarterly = 'QUARTERLY'
}

export type BillingFrequencyOperationFilterInput = {
  eq?: InputMaybe<BillingFrequency>;
  in?: InputMaybe<Array<BillingFrequency>>;
  neq?: InputMaybe<BillingFrequency>;
  nin?: InputMaybe<Array<BillingFrequency>>;
};

export enum BillingStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  None = 'NONE',
  PastDue = 'PAST_DUE',
  Suspended = 'SUSPENDED',
  Trialing = 'TRIALING'
}

export type BillingStatusOperationFilterInput = {
  eq?: InputMaybe<BillingStatus>;
  in?: InputMaybe<Array<BillingStatus>>;
  neq?: InputMaybe<BillingStatus>;
  nin?: InputMaybe<Array<BillingStatus>>;
};

export type BlockingRuleItemLocationDocument = {
  __typename?: 'BlockingRuleItemLocationDocument';
  blockingRuleId: Scalars['String']['output'];
  blockingRuleName: Scalars['String']['output'];
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BlockingRuleItemLocationDocumentFilterInput = {
  and?: InputMaybe<Array<BlockingRuleItemLocationDocumentFilterInput>>;
  blockingRuleId?: InputMaybe<StringOperationFilterInput>;
  blockingRuleName?: InputMaybe<StringOperationFilterInput>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BlockingRuleItemLocationDocumentFilterInput>>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BlockingRuleItemLocationDocumentSortInput = {
  blockingRuleId?: InputMaybe<SortEnumType>;
  blockingRuleName?: InputMaybe<SortEnumType>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BlockingRuleItemLocationsConnection = {
  __typename?: 'BlockingRuleItemLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BlockingRuleItemLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BlockingRuleItemLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BlockingRuleItemLocationsEdge = {
  __typename?: 'BlockingRuleItemLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BlockingRuleItemLocationDocument;
};

export type BlockingRulePayload = {
  __typename?: 'BlockingRulePayload';
  blockingRule?: Maybe<BlockingRuleStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type BlockingRuleStateData = {
  __typename?: 'BlockingRuleStateData';
  blockingRuleId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  linkedItemIds: Array<Scalars['String']['output']>;
  linkedLocationIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: BlockingRuleStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum BlockingRuleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of items. */
export type BpfCycleCountMissionTasksConnection = {
  __typename?: 'BpfCycleCountMissionTasksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfCycleCountMissionTasksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfMissionTaskDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfCycleCountMissionTasksEdge = {
  __typename?: 'BpfCycleCountMissionTasksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfMissionTaskDocument;
};

/** A connection to a list of items. */
export type BpfCycleCountMissionsConnection = {
  __typename?: 'BpfCycleCountMissionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfCycleCountMissionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfMissionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfCycleCountMissionsEdge = {
  __typename?: 'BpfCycleCountMissionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfMissionDocument;
};

/**
 * Immutable audit record for a single BPF lot-inventory change recorded by a field user — the
 * wsapi-resident replacement for the legacy InventoryFinish.LotChange rows. Written exactly
 * once per logical change (idempotency-key deduped); never updated after creation. The ERP write-back
 * enqueue precedes this write; the optimistic delta to BpfLotCountDocument follows it.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type BpfLotChangeDocument = {
  __typename?: 'BpfLotChangeDocument';
  /** The change-reason code (required for MOVE / DECREMENT); empty otherwise. */
  changeReasonCode: Scalars['String']['output'];
  /** The kind of change recorded. */
  changeType: BpfLotChangeType;
  /** When the change was recorded. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The ERP write-back queue record id this change enqueued: a MATERIAL_COUNT record for a MATERIAL
   * change, a FINISH record for GROW and READY. Empty on a MATERIAL change recorded before Material
   * counts were queued.
   */
  erpWriteBackId: Scalars['String']['output'];
  /** For a MOVE: the source location node. Empty for non-move changes. */
  fromSiteLocationId: Scalars['String']['output'];
  /** For a MOVE: the source sub-location node; empty when at the station root or non-move. */
  fromSubLocationId: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{LotChangeId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit of the same change with the same
   * key returns the existing record without re-applying the optimistic delta or re-enqueuing a
   * write-back, so a PWA retry / offline replay never double-counts. A submit that reuses the key
   * for a different change is refused with BPF_LOT_CHANGE_KEY_REUSED and writes nothing.
   */
  idempotencyKey: Scalars['String']['output'];
  /** The Nav item / SKU this change concerns. */
  itemReference: Scalars['String']['output'];
  /** The Nav job reference (required for BACKTOGROW); empty otherwise. */
  jobReference: Scalars['String']['output'];
  /** The server-generated audit-record id, distinct from the composite Id. */
  lotChangeId: Scalars['String']['output'];
  /** The lot count affected; empty for AddInventory (no prior count). */
  lotCountId: Scalars['String']['output'];
  /** The greenhouse / organic lot reference. */
  lotReference: Scalars['String']['output'];
  /** Free-form field-user notes; empty when none. */
  notes: Scalars['String']['output'];
  /** The signed quantity delta the field user recorded. */
  quantityChange: Scalars['Decimal']['output'];
  /** The stage the change applies to (Grow / Ready / Material). */
  stage: BpfLotStage;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The target/affected station node. The destination for a MOVE / ADDINVENTORY / BACKTOGROW. */
  toSiteLocationId: Scalars['String']['output'];
  /** The target/affected sub-location node; empty when at the station root. */
  toSubLocationId: Scalars['String']['output'];
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit: Scalars['String']['output'];
  /** The field user (email) who recorded the change, from the authenticated principal. */
  user: Scalars['String']['output'];
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference: Scalars['String']['output'];
};

/**
 * Immutable audit record for a single BPF lot-inventory change recorded by a field user — the
 * wsapi-resident replacement for the legacy InventoryFinish.LotChange rows. Written exactly
 * once per logical change (idempotency-key deduped); never updated after creation. The ERP write-back
 * enqueue precedes this write; the optimistic delta to BpfLotCountDocument follows it.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type BpfLotChangeDocumentFilterInput = {
  and?: InputMaybe<Array<BpfLotChangeDocumentFilterInput>>;
  /** The change-reason code (required for MOVE / DECREMENT); empty otherwise. */
  changeReasonCode?: InputMaybe<StringOperationFilterInput>;
  /** The kind of change recorded. */
  changeType?: InputMaybe<BpfLotChangeTypeOperationFilterInput>;
  /** When the change was recorded. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The ERP write-back queue record id this change enqueued: a MATERIAL_COUNT record for a MATERIAL
   * change, a FINISH record for GROW and READY. Empty on a MATERIAL change recorded before Material
   * counts were queued.
   */
  erpWriteBackId?: InputMaybe<StringOperationFilterInput>;
  /** For a MOVE: the source location node. Empty for non-move changes. */
  fromSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /** For a MOVE: the source sub-location node; empty when at the station root or non-move. */
  fromSubLocationId?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{LotChangeId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit of the same change with the same
   * key returns the existing record without re-applying the optimistic delta or re-enqueuing a
   * write-back, so a PWA retry / offline replay never double-counts. A submit that reuses the key
   * for a different change is refused with BPF_LOT_CHANGE_KEY_REUSED and writes nothing.
   */
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  /** The Nav item / SKU this change concerns. */
  itemReference?: InputMaybe<StringOperationFilterInput>;
  /** The Nav job reference (required for BACKTOGROW); empty otherwise. */
  jobReference?: InputMaybe<StringOperationFilterInput>;
  /** The server-generated audit-record id, distinct from the composite Id. */
  lotChangeId?: InputMaybe<StringOperationFilterInput>;
  /** The lot count affected; empty for AddInventory (no prior count). */
  lotCountId?: InputMaybe<StringOperationFilterInput>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<StringOperationFilterInput>;
  /** Free-form field-user notes; empty when none. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BpfLotChangeDocumentFilterInput>>;
  /** The signed quantity delta the field user recorded. */
  quantityChange?: InputMaybe<DecimalOperationFilterInput>;
  /** The stage the change applies to (Grow / Ready / Material). */
  stage?: InputMaybe<BpfLotStageOperationFilterInput>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The target/affected station node. The destination for a MOVE / ADDINVENTORY / BACKTOGROW. */
  toSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The target/affected sub-location node; empty when at the station root. */
  toSubLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** The field user (email) who recorded the change, from the authenticated principal. */
  user?: InputMaybe<StringOperationFilterInput>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Immutable audit record for a single BPF lot-inventory change recorded by a field user — the
 * wsapi-resident replacement for the legacy InventoryFinish.LotChange rows. Written exactly
 * once per logical change (idempotency-key deduped); never updated after creation. The ERP write-back
 * enqueue precedes this write; the optimistic delta to BpfLotCountDocument follows it.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type BpfLotChangeDocumentSortInput = {
  /** The change-reason code (required for MOVE / DECREMENT); empty otherwise. */
  changeReasonCode?: InputMaybe<SortEnumType>;
  /** The kind of change recorded. */
  changeType?: InputMaybe<SortEnumType>;
  /** When the change was recorded. */
  createdAt?: InputMaybe<SortEnumType>;
  /**
   * The ERP write-back queue record id this change enqueued: a MATERIAL_COUNT record for a MATERIAL
   * change, a FINISH record for GROW and READY. Empty on a MATERIAL change recorded before Material
   * counts were queued.
   */
  erpWriteBackId?: InputMaybe<SortEnumType>;
  /** For a MOVE: the source location node. Empty for non-move changes. */
  fromSiteLocationId?: InputMaybe<SortEnumType>;
  /** For a MOVE: the source sub-location node; empty when at the station root or non-move. */
  fromSubLocationId?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{LotChangeId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit of the same change with the same
   * key returns the existing record without re-applying the optimistic delta or re-enqueuing a
   * write-back, so a PWA retry / offline replay never double-counts. A submit that reuses the key
   * for a different change is refused with BPF_LOT_CHANGE_KEY_REUSED and writes nothing.
   */
  idempotencyKey?: InputMaybe<SortEnumType>;
  /** The Nav item / SKU this change concerns. */
  itemReference?: InputMaybe<SortEnumType>;
  /** The Nav job reference (required for BACKTOGROW); empty otherwise. */
  jobReference?: InputMaybe<SortEnumType>;
  /** The server-generated audit-record id, distinct from the composite Id. */
  lotChangeId?: InputMaybe<SortEnumType>;
  /** The lot count affected; empty for AddInventory (no prior count). */
  lotCountId?: InputMaybe<SortEnumType>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<SortEnumType>;
  /** Free-form field-user notes; empty when none. */
  notes?: InputMaybe<SortEnumType>;
  /** The signed quantity delta the field user recorded. */
  quantityChange?: InputMaybe<SortEnumType>;
  /** The stage the change applies to (Grow / Ready / Material). */
  stage?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The target/affected station node. The destination for a MOVE / ADDINVENTORY / BACKTOGROW. */
  toSiteLocationId?: InputMaybe<SortEnumType>;
  /** The target/affected sub-location node; empty when at the station root. */
  toSubLocationId?: InputMaybe<SortEnumType>;
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit?: InputMaybe<SortEnumType>;
  /** The field user (email) who recorded the change, from the authenticated principal. */
  user?: InputMaybe<SortEnumType>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<SortEnumType>;
};

/**
 * Single-record payload for the BPF lot-change mutation. Carries the audit record on success, or the
 * validation error(s) on failure (including the BPF-only tenant rejection).
 */
export type BpfLotChangePayload = {
  __typename?: 'BpfLotChangePayload';
  errors?: Maybe<Array<ValidationError>>;
  lotChange?: Maybe<BpfLotChangeDocument>;
};

/**
 * MongoDB reference-data document for a BPF lot-change reason code — the parity replacement for the
 * legacy countReasons query the inventory PWA presents in its reason dropdown. One document
 * per (tenant, code). Synced from Nav Reason Codes by the FinishLotSync worker (separate task);
 * this feature only exposes the read query the PWA needs.
 */
export type BpfLotChangeReasonDocument = {
  __typename?: 'BpfLotChangeReasonDocument';
  /** The reason code as keyed by a lot change's ChangeReasonCode. */
  code: Scalars['String']['output'];
  /** The human-facing reason description shown in the PWA dropdown. */
  description: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{Code}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /**
   * The kind of change the reason is offered for: PhysicalInventory, JobMutation, or empty when it
   * applies at any stage (also every reason loaded before the type was captured).
   */
  type: Scalars['String']['output'];
};

/**
 * MongoDB reference-data document for a BPF lot-change reason code — the parity replacement for the
 * legacy countReasons query the inventory PWA presents in its reason dropdown. One document
 * per (tenant, code). Synced from Nav Reason Codes by the FinishLotSync worker (separate task);
 * this feature only exposes the read query the PWA needs.
 */
export type BpfLotChangeReasonDocumentFilterInput = {
  and?: InputMaybe<Array<BpfLotChangeReasonDocumentFilterInput>>;
  /** The reason code as keyed by a lot change's ChangeReasonCode. */
  code?: InputMaybe<StringOperationFilterInput>;
  /** The human-facing reason description shown in the PWA dropdown. */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{Code}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BpfLotChangeReasonDocumentFilterInput>>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The kind of change the reason is offered for: PhysicalInventory, JobMutation, or empty when it
   * applies at any stage (also every reason loaded before the type was captured).
   */
  type?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB reference-data document for a BPF lot-change reason code — the parity replacement for the
 * legacy countReasons query the inventory PWA presents in its reason dropdown. One document
 * per (tenant, code). Synced from Nav Reason Codes by the FinishLotSync worker (separate task);
 * this feature only exposes the read query the PWA needs.
 */
export type BpfLotChangeReasonDocumentSortInput = {
  /** The reason code as keyed by a lot change's ChangeReasonCode. */
  code?: InputMaybe<SortEnumType>;
  /** The human-facing reason description shown in the PWA dropdown. */
  description?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{Code}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /**
   * The kind of change the reason is offered for: PhysicalInventory, JobMutation, or empty when it
   * applies at any stage (also every reason loaded before the type was captured).
   */
  type?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BpfLotChangeReasonsConnection = {
  __typename?: 'BpfLotChangeReasonsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfLotChangeReasonsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfLotChangeReasonDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfLotChangeReasonsEdge = {
  __typename?: 'BpfLotChangeReasonsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfLotChangeReasonDocument;
};

export enum BpfLotChangeType {
  AddInventory = 'ADD_INVENTORY',
  BackToGrow = 'BACK_TO_GROW',
  Confirm = 'CONFIRM',
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT',
  Move = 'MOVE',
  Output = 'OUTPUT',
  Unknown = 'UNKNOWN'
}

export type BpfLotChangeTypeOperationFilterInput = {
  eq?: InputMaybe<BpfLotChangeType>;
  in?: InputMaybe<Array<BpfLotChangeType>>;
  neq?: InputMaybe<BpfLotChangeType>;
  nin?: InputMaybe<Array<BpfLotChangeType>>;
};

/** A connection to a list of items. */
export type BpfLotChangesConnection = {
  __typename?: 'BpfLotChangesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfLotChangesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfLotChangeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfLotChangesEdge = {
  __typename?: 'BpfLotChangesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfLotChangeDocument;
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) lot count — one document per
 * (tenant, lot-count) keyed by composite _id = {TenantId}-{LotCountId}. Backs the
 * bpfLotCounts query the inventory PWA uses to display GROW / READY / MATERIAL counts per
 * station/house/section.
 *
 * Nav is the source of truth. This collection is owned by the FinishLotSync worker (separate
 * task), which upserts + sweeps it from Nav (ErpAvailabilitySync pattern). The lot-change mutations
 * in this feature apply an OPTIMISTIC delta so the PWA reflects a change immediately; the next Nav
 * sync reconciles any drift and reconciliation always wins (it overwrites optimistic state).
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems/RestockAvailability writes. GROW is unsellable and
 * READY is reconciled from Nav's FINGOOD import, so these counts must never reach restock.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional text fields use plain strings (empty when not applicable). navQuantity is null until a
 * Nav read sets it and filters by presence.
 */
export type BpfLotCountDocument = {
  __typename?: 'BpfLotCountDocument';
  /** Document id — composite {TenantId}-{LotCountId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /** The Nav item / SKU this lot concerns. */
  itemReference: Scalars['String']['output'];
  /** The Nav job reference this lot originated from; empty when not applicable. */
  jobReference: Scalars['String']['output'];
  /** The Nav-sourced lot-count id — the stable natural key within the tenant. */
  lotCountId: Scalars['String']['output'];
  /** The greenhouse / organic lot reference. */
  lotReference: Scalars['String']['output'];
  /**
   * The quantity the last Nav read gave this lot; null until a Nav read sets it. A lot change keeps it,
   * so it stays Nav's value while the quantity moves with unsynced changes.
   */
  navQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The current on-hand quantity at this stage and location. */
  quantity: Scalars['Decimal']['output'];
  /** The station (SiteLocation) this count sits at — the location-hierarchy surface's site id. */
  siteLocationId: Scalars['String']['output'];
  /**
   * The last writer: the Nav sync value when reconciled from Nav, or the optimistic value
   * when last touched by a mutation's optimistic delta. Nav reconciliation always overwrites
   * optimistic state.
   */
  source: Scalars['String']['output'];
  /** The inventory stage this count represents (Grow / Ready / Material). */
  stage: BpfLotStage;
  /** The sub-location node (house / section / bin); empty when the count is at the station root. */
  subLocationId: Scalars['String']['output'];
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The unit of measure for the quantity (e.g. EA, FLAT). */
  unit: Scalars['String']['output'];
  /** When this count was last written — by a Nav sync or by an optimistic mutation delta. */
  updated: Scalars['DateTime']['output'];
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference: Scalars['String']['output'];
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) lot count — one document per
 * (tenant, lot-count) keyed by composite _id = {TenantId}-{LotCountId}. Backs the
 * bpfLotCounts query the inventory PWA uses to display GROW / READY / MATERIAL counts per
 * station/house/section.
 *
 * Nav is the source of truth. This collection is owned by the FinishLotSync worker (separate
 * task), which upserts + sweeps it from Nav (ErpAvailabilitySync pattern). The lot-change mutations
 * in this feature apply an OPTIMISTIC delta so the PWA reflects a change immediately; the next Nav
 * sync reconciles any drift and reconciliation always wins (it overwrites optimistic state).
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems/RestockAvailability writes. GROW is unsellable and
 * READY is reconciled from Nav's FINGOOD import, so these counts must never reach restock.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional text fields use plain strings (empty when not applicable). navQuantity is null until a
 * Nav read sets it and filters by presence.
 */
export type BpfLotCountDocumentFilterInput = {
  and?: InputMaybe<Array<BpfLotCountDocumentFilterInput>>;
  /** Document id — composite {TenantId}-{LotCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** The Nav item / SKU this lot concerns. */
  itemReference?: InputMaybe<StringOperationFilterInput>;
  /** The Nav job reference this lot originated from; empty when not applicable. */
  jobReference?: InputMaybe<StringOperationFilterInput>;
  /** The Nav-sourced lot-count id — the stable natural key within the tenant. */
  lotCountId?: InputMaybe<StringOperationFilterInput>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<StringOperationFilterInput>;
  /**
   * The quantity the last Nav read gave this lot; null until a Nav read sets it. A lot change keeps it,
   * so it stays Nav's value while the quantity moves with unsynced changes.
   */
  navQuantity?: InputMaybe<OptionOfDecimalFilterInput>;
  or?: InputMaybe<Array<BpfLotCountDocumentFilterInput>>;
  /** The current on-hand quantity at this stage and location. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** The station (SiteLocation) this count sits at — the location-hierarchy surface's site id. */
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The last writer: the Nav sync value when reconciled from Nav, or the optimistic value
   * when last touched by a mutation's optimistic delta. Nav reconciliation always overwrites
   * optimistic state.
   */
  source?: InputMaybe<StringOperationFilterInput>;
  /** The inventory stage this count represents (Grow / Ready / Material). */
  stage?: InputMaybe<BpfLotStageOperationFilterInput>;
  /** The sub-location node (house / section / bin); empty when the count is at the station root. */
  subLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The unit of measure for the quantity (e.g. EA, FLAT). */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** When this count was last written — by a Nav sync or by an optimistic mutation delta. */
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) lot count — one document per
 * (tenant, lot-count) keyed by composite _id = {TenantId}-{LotCountId}. Backs the
 * bpfLotCounts query the inventory PWA uses to display GROW / READY / MATERIAL counts per
 * station/house/section.
 *
 * Nav is the source of truth. This collection is owned by the FinishLotSync worker (separate
 * task), which upserts + sweeps it from Nav (ErpAvailabilitySync pattern). The lot-change mutations
 * in this feature apply an OPTIMISTIC delta so the PWA reflects a change immediately; the next Nav
 * sync reconciles any drift and reconciliation always wins (it overwrites optimistic state).
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems/RestockAvailability writes. GROW is unsellable and
 * READY is reconciled from Nav's FINGOOD import, so these counts must never reach restock.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional text fields use plain strings (empty when not applicable). navQuantity is null until a
 * Nav read sets it and filters by presence.
 */
export type BpfLotCountDocumentSortInput = {
  /** Document id — composite {TenantId}-{LotCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /** The Nav item / SKU this lot concerns. */
  itemReference?: InputMaybe<SortEnumType>;
  /** The Nav job reference this lot originated from; empty when not applicable. */
  jobReference?: InputMaybe<SortEnumType>;
  /** The Nav-sourced lot-count id — the stable natural key within the tenant. */
  lotCountId?: InputMaybe<SortEnumType>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<SortEnumType>;
  /**
   * The quantity the last Nav read gave this lot; null until a Nav read sets it. A lot change keeps it,
   * so it stays Nav's value while the quantity moves with unsynced changes.
   */
  navQuantity?: InputMaybe<SortEnumType>;
  /** The current on-hand quantity at this stage and location. */
  quantity?: InputMaybe<SortEnumType>;
  /** The station (SiteLocation) this count sits at — the location-hierarchy surface's site id. */
  siteLocationId?: InputMaybe<SortEnumType>;
  /**
   * The last writer: the Nav sync value when reconciled from Nav, or the optimistic value
   * when last touched by a mutation's optimistic delta. Nav reconciliation always overwrites
   * optimistic state.
   */
  source?: InputMaybe<SortEnumType>;
  /** The inventory stage this count represents (Grow / Ready / Material). */
  stage?: InputMaybe<SortEnumType>;
  /** The sub-location node (house / section / bin); empty when the count is at the station root. */
  subLocationId?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The unit of measure for the quantity (e.g. EA, FLAT). */
  unit?: InputMaybe<SortEnumType>;
  /** When this count was last written — by a Nav sync or by an optimistic mutation delta. */
  updated?: InputMaybe<SortEnumType>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BpfLotCountsByStageConnection = {
  __typename?: 'BpfLotCountsByStageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfLotCountsByStageEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfLotCountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfLotCountsByStageEdge = {
  __typename?: 'BpfLotCountsByStageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfLotCountDocument;
};

/** A connection to a list of items. */
export type BpfLotCountsConnection = {
  __typename?: 'BpfLotCountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfLotCountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfLotCountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfLotCountsEdge = {
  __typename?: 'BpfLotCountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfLotCountDocument;
};

export enum BpfLotStage {
  Grow = 'GROW',
  Material = 'MATERIAL',
  Ready = 'READY',
  Unknown = 'UNKNOWN'
}

export type BpfLotStageOperationFilterInput = {
  eq?: InputMaybe<BpfLotStage>;
  in?: InputMaybe<Array<BpfLotStage>>;
  neq?: InputMaybe<BpfLotStage>;
  nin?: InputMaybe<Array<BpfLotStage>>;
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) material cycle-count mission — one document
 * per distinct (StartDate, EndDate) pair, the wsapi read-model replacement for the legacy
 * Availability Event grouping (MaterialCycleCountMissionImporter.GetOrCreateEvents).
 * Keyed by composite _id = {TenantId}-{MissionKey}.
 *
 * Nav is the source of truth. Nav's [BP Cycle Count Assign] table drives this
 * collection (and BpfMissionTaskDocument), owned by the BpfCycleCountMissionSync
 * (import) and BpfCycleCountMissionPostback (expire / close-out) workers — both separate tasks.
 * This feature is READ SIDE ONLY: it exposes the tenant-scoped queries the inventory PWA's
 * assignment list uses.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain, per the
 * project's architecture decision: no InventoryEvents, no InventoryItems /
 * RestockAvailability writes, and no KurrentDB aggregate/events/projection — these
 * documents are worker-owned, not event-sourced.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional fields use plain strings (empty when not applicable), not Option<T>, which
 * would leak as a broken OptionOf{X}FilterInput (the BpfLotCountDocument convention).
 */
export type BpfMissionDocument = {
  __typename?: 'BpfMissionDocument';
  /** When this mission document was first created. */
  created: Scalars['DateTime']['output'];
  /**
   * Human-facing mission label. Legacy format, preserved verbatim:
   * "Cycle Count " + StartDate("yyyy-MM-dd") + " - " + EndDate("yyyy-MM-dd").
   */
  description: Scalars['String']['output'];
  /** The Nav [BP Cycle Count Assign].[Ending Date] shared by every assignment in this mission. */
  endDate: Scalars['DateTime']['output'];
  /** Document id — composite {TenantId}-{MissionKey}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /**
   * The stable mission key — {StartDate:yyyyMMdd}-{EndDate:yyyyMMdd}. Route through
   * ComposeMissionKey; a CROSS-REPO CONTRACT with the wsapi-services
   * BpfCycleCountMissionSync worker, which independently composes the same key from the Nav
   * (StartingDate, EndingDate) pair so both repos converge on the same mission row.
   */
  missionKey: Scalars['String']['output'];
  /** The Nav [BP Cycle Count Assign].[Starting Date] shared by every assignment in this mission. */
  startDate: Scalars['DateTime']['output'];
  /** The mission's lifecycle status. See BpfMissionStatus. */
  status: BpfMissionStatus;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** When this mission document was last written. */
  updated: Scalars['DateTime']['output'];
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) material cycle-count mission — one document
 * per distinct (StartDate, EndDate) pair, the wsapi read-model replacement for the legacy
 * Availability Event grouping (MaterialCycleCountMissionImporter.GetOrCreateEvents).
 * Keyed by composite _id = {TenantId}-{MissionKey}.
 *
 * Nav is the source of truth. Nav's [BP Cycle Count Assign] table drives this
 * collection (and BpfMissionTaskDocument), owned by the BpfCycleCountMissionSync
 * (import) and BpfCycleCountMissionPostback (expire / close-out) workers — both separate tasks.
 * This feature is READ SIDE ONLY: it exposes the tenant-scoped queries the inventory PWA's
 * assignment list uses.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain, per the
 * project's architecture decision: no InventoryEvents, no InventoryItems /
 * RestockAvailability writes, and no KurrentDB aggregate/events/projection — these
 * documents are worker-owned, not event-sourced.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional fields use plain strings (empty when not applicable), not Option<T>, which
 * would leak as a broken OptionOf{X}FilterInput (the BpfLotCountDocument convention).
 */
export type BpfMissionDocumentFilterInput = {
  and?: InputMaybe<Array<BpfMissionDocumentFilterInput>>;
  /** When this mission document was first created. */
  created?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Human-facing mission label. Legacy format, preserved verbatim:
   * "Cycle Count " + StartDate("yyyy-MM-dd") + " - " + EndDate("yyyy-MM-dd").
   */
  description?: InputMaybe<StringOperationFilterInput>;
  /** The Nav [BP Cycle Count Assign].[Ending Date] shared by every assignment in this mission. */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Document id — composite {TenantId}-{MissionKey}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable mission key — {StartDate:yyyyMMdd}-{EndDate:yyyyMMdd}. Route through
   * ComposeMissionKey; a CROSS-REPO CONTRACT with the wsapi-services
   * BpfCycleCountMissionSync worker, which independently composes the same key from the Nav
   * (StartingDate, EndingDate) pair so both repos converge on the same mission row.
   */
  missionKey?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BpfMissionDocumentFilterInput>>;
  /** The Nav [BP Cycle Count Assign].[Starting Date] shared by every assignment in this mission. */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** The mission's lifecycle status. See BpfMissionStatus. */
  status?: InputMaybe<BpfMissionStatusOperationFilterInput>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** When this mission document was last written. */
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read model for a single BPF (Bonnie Plants) material cycle-count mission — one document
 * per distinct (StartDate, EndDate) pair, the wsapi read-model replacement for the legacy
 * Availability Event grouping (MaterialCycleCountMissionImporter.GetOrCreateEvents).
 * Keyed by composite _id = {TenantId}-{MissionKey}.
 *
 * Nav is the source of truth. Nav's [BP Cycle Count Assign] table drives this
 * collection (and BpfMissionTaskDocument), owned by the BpfCycleCountMissionSync
 * (import) and BpfCycleCountMissionPostback (expire / close-out) workers — both separate tasks.
 * This feature is READ SIDE ONLY: it exposes the tenant-scoped queries the inventory PWA's
 * assignment list uses.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain, per the
 * project's architecture decision: no InventoryEvents, no InventoryItems /
 * RestockAvailability writes, and no KurrentDB aggregate/events/projection — these
 * documents are worker-owned, not event-sourced.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input — so
 * optional fields use plain strings (empty when not applicable), not Option<T>, which
 * would leak as a broken OptionOf{X}FilterInput (the BpfLotCountDocument convention).
 */
export type BpfMissionDocumentSortInput = {
  /** When this mission document was first created. */
  created?: InputMaybe<SortEnumType>;
  /**
   * Human-facing mission label. Legacy format, preserved verbatim:
   * "Cycle Count " + StartDate("yyyy-MM-dd") + " - " + EndDate("yyyy-MM-dd").
   */
  description?: InputMaybe<SortEnumType>;
  /** The Nav [BP Cycle Count Assign].[Ending Date] shared by every assignment in this mission. */
  endDate?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{MissionKey}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable mission key — {StartDate:yyyyMMdd}-{EndDate:yyyyMMdd}. Route through
   * ComposeMissionKey; a CROSS-REPO CONTRACT with the wsapi-services
   * BpfCycleCountMissionSync worker, which independently composes the same key from the Nav
   * (StartingDate, EndingDate) pair so both repos converge on the same mission row.
   */
  missionKey?: InputMaybe<SortEnumType>;
  /** The Nav [BP Cycle Count Assign].[Starting Date] shared by every assignment in this mission. */
  startDate?: InputMaybe<SortEnumType>;
  /** The mission's lifecycle status. See BpfMissionStatus. */
  status?: InputMaybe<SortEnumType>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** When this mission document was last written. */
  updated?: InputMaybe<SortEnumType>;
};

export enum BpfMissionStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Expired = 'EXPIRED',
  Unknown = 'UNKNOWN'
}

export type BpfMissionStatusOperationFilterInput = {
  eq?: InputMaybe<BpfMissionStatus>;
  in?: InputMaybe<Array<BpfMissionStatus>>;
  neq?: InputMaybe<BpfMissionStatus>;
  nin?: InputMaybe<Array<BpfMissionStatus>>;
};

/**
 * MongoDB read model for a single countable lot within a BPF (Bonnie Plants) material cycle-count
 * mission — one document per (tenant, Nav [BP Cycle Count Assign].[Entry ID], lot-count)
 * triple, the wsapi read-model replacement for the legacy Availability
 * CycleCountTaskListLotCount join row. Keyed by composite _id =
 * {TenantId}-{EntryId}-{LotCountId}.
 *
 * Denormalised display/sort fields are REQUIRED, not optional. The legacy sort options are
 * exactly Category → lot.product.productCategory.description, Item Id →
 * lot.product.referenceId, Location → bin description, Product Name →
 * lot.product.description (assignmentSortSelections.json), and legacy search matches
 * product description, item number, bin description and category. Mongo cannot join these onto the
 * task at query time, so the itemDescription, categoryDescription and
 * binDescription fields are carried directly on this document — without them the PWA would be
 * forced back into client-side sort over a single page, the exact defect this read model exists to
 * avoid. Legacy's own "Location" sort path (lotCount.treeLocation.description) targets
 * the wrong object and is a silent no-op; binDescription is populated correctly here.
 *
 *
 * Nav is the source of truth. Owned by the wsapi-services BpfCycleCountMissionSync worker
 * (import + fan-out) and BpfCycleCountMissionPostback worker (post-back / expire / close-out) —
 * both separate tasks. Every field here is worker-owned EXCEPT the six count-state fields wsapi
 * stamps when an addBpfLotChange names this task via its optional missionEntryId:
 * IsComplete, OldQuantity, NewQuantity, LotChangeId, CompletedAt
 * and CompletedByEmail. wsapi writes those six and nothing else: it never inserts, deletes or
 * sweeps this collection, and every other field is read-only to it. A recorded count is durable —
 * re-importing an already-counted task from Nav leaves the stamp untouched.
 * Queries over this document remain read-only — the stamp is a server-side Mongo write, never a
 * GraphQL mutation input.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems / RestockAvailability writes, no KurrentDB
 * aggregate/events/projection.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain nullable value/string
 * types (never Option<T>), per the BpfLotCountDocument convention.
 */
export type BpfMissionTaskDocument = {
  __typename?: 'BpfMissionTaskDocument';
  /** Whether the underlying lot count is active (open for counting). */
  active: Scalars['Boolean']['output'];
  /** Denormalised bin description — backs the legacy "Location" sort/search (implemented correctly here; see the type-level remarks on the legacy no-op). */
  binDescription: Scalars['String']['output'];
  /** Denormalised product-category description — backs the legacy "Category" sort/search. */
  categoryDescription: Scalars['String']['output'];
  /** When the count was recorded; null until counted. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The field user (email) who recorded the count; null until counted. */
  completedByEmail?: Maybe<Scalars['String']['output']>;
  /** The Nav [BP Cycle Count Assign].[Entry ID] this task originated from. */
  entryId: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{EntryId}-{LotCountId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /** Whether a count has been recorded against this task (legacy CycleCountTaskListLotCount.IsComplete). */
  isComplete: Scalars['Boolean']['output'];
  /** Denormalised product description — backs the legacy "Product Name" sort/search. */
  itemDescription: Scalars['String']['output'];
  /** The Nav item / SKU this task's lot concerns. */
  itemReference: Scalars['String']['output'];
  /** The Nav [BP Cycle Count Assign].[Location Code] this task's assignment targets. */
  locationCode: Scalars['String']['output'];
  /** The BpfLotChanges record id the recorded count produced; null until counted. */
  lotChangeId?: Maybe<Scalars['String']['output']>;
  /** The countable lot this task targets — the Nav-sourced lot-count id. */
  lotCountId: Scalars['String']['output'];
  /** The greenhouse / organic lot reference. */
  lotReference: Scalars['String']['output'];
  /** The owning mission's key — joins to BpfMissionDocument.missionKey. */
  missionKey: Scalars['String']['output'];
  /** The resulting available quantity after the recorded change; null until counted. */
  newQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The lot-count quantity immediately before the recorded change; null until counted. */
  oldQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** Whether the postback worker has posted this task's outcome to Nav. */
  processed: Scalars['Boolean']['output'];
  /** The station (SiteLocation) this task's assignment targets. */
  siteLocationId: Scalars['String']['output'];
  /** The sub-location node (house / section / bin) the counted lot sits at; empty when at the station root. */
  subLocationId: Scalars['String']['output'];
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference: Scalars['String']['output'];
};

/**
 * MongoDB read model for a single countable lot within a BPF (Bonnie Plants) material cycle-count
 * mission — one document per (tenant, Nav [BP Cycle Count Assign].[Entry ID], lot-count)
 * triple, the wsapi read-model replacement for the legacy Availability
 * CycleCountTaskListLotCount join row. Keyed by composite _id =
 * {TenantId}-{EntryId}-{LotCountId}.
 *
 * Denormalised display/sort fields are REQUIRED, not optional. The legacy sort options are
 * exactly Category → lot.product.productCategory.description, Item Id →
 * lot.product.referenceId, Location → bin description, Product Name →
 * lot.product.description (assignmentSortSelections.json), and legacy search matches
 * product description, item number, bin description and category. Mongo cannot join these onto the
 * task at query time, so the itemDescription, categoryDescription and
 * binDescription fields are carried directly on this document — without them the PWA would be
 * forced back into client-side sort over a single page, the exact defect this read model exists to
 * avoid. Legacy's own "Location" sort path (lotCount.treeLocation.description) targets
 * the wrong object and is a silent no-op; binDescription is populated correctly here.
 *
 *
 * Nav is the source of truth. Owned by the wsapi-services BpfCycleCountMissionSync worker
 * (import + fan-out) and BpfCycleCountMissionPostback worker (post-back / expire / close-out) —
 * both separate tasks. Every field here is worker-owned EXCEPT the six count-state fields wsapi
 * stamps when an addBpfLotChange names this task via its optional missionEntryId:
 * IsComplete, OldQuantity, NewQuantity, LotChangeId, CompletedAt
 * and CompletedByEmail. wsapi writes those six and nothing else: it never inserts, deletes or
 * sweeps this collection, and every other field is read-only to it. A recorded count is durable —
 * re-importing an already-counted task from Nav leaves the stamp untouched.
 * Queries over this document remain read-only — the stamp is a server-side Mongo write, never a
 * GraphQL mutation input.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems / RestockAvailability writes, no KurrentDB
 * aggregate/events/projection.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain nullable value/string
 * types (never Option<T>), per the BpfLotCountDocument convention.
 */
export type BpfMissionTaskDocumentFilterInput = {
  /** Whether the underlying lot count is active (open for counting). */
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<BpfMissionTaskDocumentFilterInput>>;
  /** Denormalised bin description — backs the legacy "Location" sort/search (implemented correctly here; see the type-level remarks on the legacy no-op). */
  binDescription?: InputMaybe<StringOperationFilterInput>;
  /** Denormalised product-category description — backs the legacy "Category" sort/search. */
  categoryDescription?: InputMaybe<StringOperationFilterInput>;
  /** When the count was recorded; null until counted. */
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The field user (email) who recorded the count; null until counted. */
  completedByEmail?: InputMaybe<StringOperationFilterInput>;
  /** The Nav [BP Cycle Count Assign].[Entry ID] this task originated from. */
  entryId?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{EntryId}-{LotCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Whether a count has been recorded against this task (legacy CycleCountTaskListLotCount.IsComplete). */
  isComplete?: InputMaybe<BooleanOperationFilterInput>;
  /** Denormalised product description — backs the legacy "Product Name" sort/search. */
  itemDescription?: InputMaybe<StringOperationFilterInput>;
  /** The Nav item / SKU this task's lot concerns. */
  itemReference?: InputMaybe<StringOperationFilterInput>;
  /** The Nav [BP Cycle Count Assign].[Location Code] this task's assignment targets. */
  locationCode?: InputMaybe<StringOperationFilterInput>;
  /** The BpfLotChanges record id the recorded count produced; null until counted. */
  lotChangeId?: InputMaybe<StringOperationFilterInput>;
  /** The countable lot this task targets — the Nav-sourced lot-count id. */
  lotCountId?: InputMaybe<StringOperationFilterInput>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<StringOperationFilterInput>;
  /** The owning mission's key — joins to BpfMissionDocument.missionKey. */
  missionKey?: InputMaybe<StringOperationFilterInput>;
  /** The resulting available quantity after the recorded change; null until counted. */
  newQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** The lot-count quantity immediately before the recorded change; null until counted. */
  oldQuantity?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<BpfMissionTaskDocumentFilterInput>>;
  /** Whether the postback worker has posted this task's outcome to Nav. */
  processed?: InputMaybe<BooleanOperationFilterInput>;
  /** The station (SiteLocation) this task's assignment targets. */
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The sub-location node (house / section / bin) the counted lot sits at; empty when at the station root. */
  subLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read model for a single countable lot within a BPF (Bonnie Plants) material cycle-count
 * mission — one document per (tenant, Nav [BP Cycle Count Assign].[Entry ID], lot-count)
 * triple, the wsapi read-model replacement for the legacy Availability
 * CycleCountTaskListLotCount join row. Keyed by composite _id =
 * {TenantId}-{EntryId}-{LotCountId}.
 *
 * Denormalised display/sort fields are REQUIRED, not optional. The legacy sort options are
 * exactly Category → lot.product.productCategory.description, Item Id →
 * lot.product.referenceId, Location → bin description, Product Name →
 * lot.product.description (assignmentSortSelections.json), and legacy search matches
 * product description, item number, bin description and category. Mongo cannot join these onto the
 * task at query time, so the itemDescription, categoryDescription and
 * binDescription fields are carried directly on this document — without them the PWA would be
 * forced back into client-side sort over a single page, the exact defect this read model exists to
 * avoid. Legacy's own "Location" sort path (lotCount.treeLocation.description) targets
 * the wrong object and is a silent no-op; binDescription is populated correctly here.
 *
 *
 * Nav is the source of truth. Owned by the wsapi-services BpfCycleCountMissionSync worker
 * (import + fan-out) and BpfCycleCountMissionPostback worker (post-back / expire / close-out) —
 * both separate tasks. Every field here is worker-owned EXCEPT the six count-state fields wsapi
 * stamps when an addBpfLotChange names this task via its optional missionEntryId:
 * IsComplete, OldQuantity, NewQuantity, LotChangeId, CompletedAt
 * and CompletedByEmail. wsapi writes those six and nothing else: it never inserts, deletes or
 * sweeps this collection, and every other field is read-only to it. A recorded count is durable —
 * re-importing an already-counted task from Nav leaves the stamp untouched.
 * Queries over this document remain read-only — the stamp is a server-side Mongo write, never a
 * GraphQL mutation input.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain: no
 * InventoryEvents, no InventoryItems / RestockAvailability writes, no KurrentDB
 * aggregate/events/projection.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain nullable value/string
 * types (never Option<T>), per the BpfLotCountDocument convention.
 */
export type BpfMissionTaskDocumentSortInput = {
  /** Whether the underlying lot count is active (open for counting). */
  active?: InputMaybe<SortEnumType>;
  /** Denormalised bin description — backs the legacy "Location" sort/search (implemented correctly here; see the type-level remarks on the legacy no-op). */
  binDescription?: InputMaybe<SortEnumType>;
  /** Denormalised product-category description — backs the legacy "Category" sort/search. */
  categoryDescription?: InputMaybe<SortEnumType>;
  /** When the count was recorded; null until counted. */
  completedAt?: InputMaybe<SortEnumType>;
  /** The field user (email) who recorded the count; null until counted. */
  completedByEmail?: InputMaybe<SortEnumType>;
  /** The Nav [BP Cycle Count Assign].[Entry ID] this task originated from. */
  entryId?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{EntryId}-{LotCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /** Whether a count has been recorded against this task (legacy CycleCountTaskListLotCount.IsComplete). */
  isComplete?: InputMaybe<SortEnumType>;
  /** Denormalised product description — backs the legacy "Product Name" sort/search. */
  itemDescription?: InputMaybe<SortEnumType>;
  /** The Nav item / SKU this task's lot concerns. */
  itemReference?: InputMaybe<SortEnumType>;
  /** The Nav [BP Cycle Count Assign].[Location Code] this task's assignment targets. */
  locationCode?: InputMaybe<SortEnumType>;
  /** The BpfLotChanges record id the recorded count produced; null until counted. */
  lotChangeId?: InputMaybe<SortEnumType>;
  /** The countable lot this task targets — the Nav-sourced lot-count id. */
  lotCountId?: InputMaybe<SortEnumType>;
  /** The greenhouse / organic lot reference. */
  lotReference?: InputMaybe<SortEnumType>;
  /** The owning mission's key — joins to BpfMissionDocument.missionKey. */
  missionKey?: InputMaybe<SortEnumType>;
  /** The resulting available quantity after the recorded change; null until counted. */
  newQuantity?: InputMaybe<SortEnumType>;
  /** The lot-count quantity immediately before the recorded change; null until counted. */
  oldQuantity?: InputMaybe<SortEnumType>;
  /** Whether the postback worker has posted this task's outcome to Nav. */
  processed?: InputMaybe<SortEnumType>;
  /** The station (SiteLocation) this task's assignment targets. */
  siteLocationId?: InputMaybe<SortEnumType>;
  /** The sub-location node (house / section / bin) the counted lot sits at; empty when at the station root. */
  subLocationId?: InputMaybe<SortEnumType>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The size/color/grade variant reference; empty when not applicable. */
  variantReference?: InputMaybe<SortEnumType>;
};

/**
 * One Nav position of a BPF station (a house or a section), stocked or empty. A Move can target any
 * position of the cell's station.
 */
export type BpfPositionDocument = {
  __typename?: 'BpfPositionDocument';
  /** The Nav Position Code. */
  positionCode: Scalars['String']['output'];
  /** The Nav Section Code: the house the position belongs to. */
  sectionCode: Scalars['String']['output'];
  /** The station: its Nav Location Code, the same value a lot count's `siteLocationId` holds. */
  siteLocationId: Scalars['String']['output'];
};

export type BpfStartingNodeDataInput = {
  siteLocationId: Scalars['String']['input'];
  subLocationId?: InputMaybe<Scalars['String']['input']>;
  treeType: BpfTreeType;
};

/** One starting-node grant stored within a BpfUserStartingNodeDocument. */
export type BpfStartingNodeDocument = {
  __typename?: 'BpfStartingNodeDocument';
  siteLocationId: Scalars['String']['output'];
  /** The sub-location entry point, or None to enter at the station (site) root. */
  subLocationId?: Maybe<Scalars['String']['output']>;
  treeType: BpfTreeType;
};

/** One starting-node grant stored within a BpfUserStartingNodeDocument. */
export type BpfStartingNodeDocumentFilterInput = {
  and?: InputMaybe<Array<BpfStartingNodeDocumentFilterInput>>;
  or?: InputMaybe<Array<BpfStartingNodeDocumentFilterInput>>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The sub-location entry point, or None to enter at the station (site) root. */
  subLocationId?: InputMaybe<OptionOfStringFilterInput>;
  treeType?: InputMaybe<BpfTreeTypeOperationFilterInput>;
};

/** One starting-node grant in the mutation payload output. */
export type BpfStartingNodeStateData = {
  __typename?: 'BpfStartingNodeStateData';
  siteLocationId: Scalars['String']['output'];
  subLocationId?: Maybe<Scalars['String']['output']>;
  treeType: BpfTreeType;
};

/**
 * MongoDB read model of one BPF sync worker's last successful Nav read. One document per
 * (tenant, worker); composite _id = {tenantId}-{worker}. Written by the FinishLotSync
 * and RetailBpLotSync workers after every successful read, whether or not any row changed; read by
 * the bpfSyncStatus query.
 */
export type BpfSyncStatusDocument = {
  __typename?: 'BpfSyncStatusDocument';
  /** When that worker last started a successful Nav read (UTC). */
  lastReadAt: Scalars['DateTime']['output'];
  /** The worker that read Nav: BpfFinishLotSync or BpfRetailBpLotSync. */
  worker: Scalars['String']['output'];
};

export enum BpfTreeType {
  Finish = 'FINISH',
  Material = 'MATERIAL',
  Retail = 'RETAIL',
  Unknown = 'UNKNOWN'
}

export type BpfTreeTypeOperationFilterInput = {
  eq?: InputMaybe<BpfTreeType>;
  in?: InputMaybe<Array<BpfTreeType>>;
  neq?: InputMaybe<BpfTreeType>;
  nin?: InputMaybe<Array<BpfTreeType>>;
};

/**
 * MongoDB read model for a single BPF user's starting-node grants. One document per (tenant, user);
 * composite _id = {tenantId}-{userId}. Backs the bpfUserStartingNodes (admin,
 * tenant-scoped) and myBpfStartingNodes (caller-scoped) queries the PWA uses to resolve a
 * user's entry points into the finish/material/retail location trees.
 */
export type BpfUserStartingNodeDocument = {
  __typename?: 'BpfUserStartingNodeDocument';
  id: Scalars['String']['output'];
  startingNodes: Array<BpfStartingNodeDocument>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

/**
 * MongoDB read model for a single BPF user's starting-node grants. One document per (tenant, user);
 * composite _id = {tenantId}-{userId}. Backs the bpfUserStartingNodes (admin,
 * tenant-scoped) and myBpfStartingNodes (caller-scoped) queries the PWA uses to resolve a
 * user's entry points into the finish/material/retail location trees.
 */
export type BpfUserStartingNodeDocumentFilterInput = {
  and?: InputMaybe<Array<BpfUserStartingNodeDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BpfUserStartingNodeDocumentFilterInput>>;
  startingNodes?: InputMaybe<ListFilterInputTypeOfBpfStartingNodeDocumentFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read model for a single BPF user's starting-node grants. One document per (tenant, user);
 * composite _id = {tenantId}-{userId}. Backs the bpfUserStartingNodes (admin,
 * tenant-scoped) and myBpfStartingNodes (caller-scoped) queries the PWA uses to resolve a
 * user's entry points into the finish/material/retail location trees.
 */
export type BpfUserStartingNodeDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type BpfUserStartingNodePayload = {
  __typename?: 'BpfUserStartingNodePayload';
  bpfUserStartingNode?: Maybe<BpfUserStartingNodeStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * GraphQL output projection of BpfUserStartingNodeState returned by the
 * set mutation's payload.
 */
export type BpfUserStartingNodeStateData = {
  __typename?: 'BpfUserStartingNodeStateData';
  startingNodes: Array<BpfStartingNodeStateData>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type BpfUserStartingNodesConnection = {
  __typename?: 'BpfUserStartingNodesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BpfUserStartingNodesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BpfUserStartingNodeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BpfUserStartingNodesEdge = {
  __typename?: 'BpfUserStartingNodesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BpfUserStartingNodeDocument;
};

export enum BsonDataType {
  Boolean = 'BOOLEAN',
  DateTime = 'DATE_TIME',
  Decimal128 = 'DECIMAL128',
  Double = 'DOUBLE',
  Guid = 'GUID',
  Int32 = 'INT32',
  Int64 = 'INT64',
  NotSet = 'NOT_SET',
  ObjectId = 'OBJECT_ID',
  String = 'STRING'
}

export type BsonDataTypeOperationFilterInput = {
  eq?: InputMaybe<BsonDataType>;
  in?: InputMaybe<Array<BsonDataType>>;
  neq?: InputMaybe<BsonDataType>;
  nin?: InputMaybe<Array<BsonDataType>>;
};

export type BuildItemInput = {
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  unitOfMeasure: Scalars['String']['input'];
};

/**
 * One line the run could not fill completely: what it needed, what it got, and the gap. This is the
 * variance the results panel lists so a grower can see exactly where inventory ran out.
 */
export type BulkAllocateLineShortfall = {
  __typename?: 'BulkAllocateLineShortfall';
  allocatedQuantity: Scalars['Int']['output'];
  /**
   * allocatedQuantity in units of the line's Shipping UOM, cut at two decimals, never rounded up to
   * a unit that was not filled: the figure the order page shows in the line's allocated units cell.
   */
  allocatedUnits?: Maybe<Scalars['Decimal']['output']>;
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  orderedQuantity: Scalars['Int']['output'];
  /**
   * orderedQuantity in whole units of the line's Shipping UOM, rounded up: the line's own unit
   * count for the quantity allocation is measured against.
   */
  orderedUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * The name of the Shipping UOM the line was placed under, as the order's documents print it. Null when
   * the line names no Shipping UOM of its own, or when its unit holds one each, so the eaches are the
   * line's only count. Every unit field is null exactly when this is.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  shortByQuantity: Scalars['Int']['output'];
  /**
   * shortByQuantity in units of the line's Shipping UOM, cut at two decimals, never rounded up:
   * the stock still to find.
   */
  shortByUnits?: Maybe<Scalars['Decimal']['output']>;
};

/** Why one line was left alone inside an order the run did process. */
export enum BulkAllocateLineSkipReason {
  /**
   * The line already carries an allocation, so the run did not touch it. Bulk allocate fills empty
   * lines only — a hand-placed allocation is never re-pointed. This includes a line allocated by hand
   * while the run was in progress.
   */
  AlreadyAllocated = 'ALREADY_ALLOCATED',
  /** The line is make-to-order. It routes to Produce and is never a FULFILL allocation gap. */
  MakeToOrder = 'MAKE_TO_ORDER',
  /**
   * The line's acknowledged, container and ordered quantities are all zero or unset, so there is no
   * quantity to allocate against. A line recorded only in eaches reads this way.
   */
  NoAllocationQuantity = 'NO_ALLOCATION_QUANTITY'
}

/**
 * The outcome for one order in the batch. Every requested id the run reached yields exactly one of
 * these, whatever happened to it — one order failing never removes another order's result.
 */
export type BulkAllocateOrderResult = {
  __typename?: 'BulkAllocateOrderResult';
  /** The order's customer, read on the server. Null when the order could not be read. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** How many lines the run filled, in whole or in part. */
  linesAllocated: Scalars['Int']['output'];
  /** Set only when outcome is FAILED: the error that stopped this order. */
  message?: Maybe<Scalars['String']['output']>;
  /** The requested id, echoed back so the caller can match results to selection. */
  orderId: Scalars['String']['output'];
  /** The order's number, read on the server. Null when the order could not be read. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** What the run did to this order. */
  outcome: BulkAllocateOutcome;
  /** Every line the run could not fill completely. */
  shortfalls: Array<BulkAllocateLineShortfall>;
  /** Set only when outcome is SKIPPED. */
  skipReason?: Maybe<BulkAllocateSkipReason>;
  /** Every line the run left alone, with its reason. */
  skippedLines: Array<BulkAllocateSkippedLine>;
  /**
   * Inventory the write left over-allocated, as allocateLineItems reports it. The run plans
   * against availability read before it started, so stock taken elsewhere in the meantime can show up
   * here. Empty when nothing was written or nothing went negative.
   */
  warnings: Array<OverAllocationWarningData>;
};

/**
 * Input to bulkAllocateOrders: the orders the grower selected on the grid, plus the ONE
 * strategy to apply across the whole run.
 */
export type BulkAllocateOrdersInput = {
  /**
   * The orders to allocate. Duplicates collapse; the batch is processed in the order supplied, which
   * matters because orders competing for the same stock are served first-come within the run.
   */
  orderIds: Array<Scalars['String']['input']>;
  /**
   * Grades in the order PRIORITY should use them, applied within a location. Grades left out are
   * used after every ranked one. Ignored by every other strategy. PRIORITY needs at least one
   * ranked location or grade.
   */
  priorityGrades?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Locations in the order PRIORITY should use them. Locations left out are used after every
   * ranked one. Ignored by every other strategy.
   */
  priorityLocationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The only location SINGLE_LOCATION may fill from. Required for that strategy and ignored by
   * every other.
   */
  singleLocationId?: InputMaybe<Scalars['String']['input']>;
  /** Which inventory to prefer. Defaults to HIGHEST_GRADE. */
  strategy?: BulkAllocationStrategy;
};

/**
 * The bulk-allocate result set, in the order requested. A run that could not start at all (an invalid
 * strategy argument, or a batch over the size cap) returns errors with an empty
 * results. A run cut short by cancellation returns a result for every order it reached plus a
 * batch-cancelled error; orders it never reached carry no result. Anything that goes wrong on a single
 * order is reported on that order's own result and never touches the rest.
 */
export type BulkAllocateOrdersPayload = {
  __typename?: 'BulkAllocateOrdersPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<BulkAllocateOrderResult>;
};

/** What a bulk run did to one order. */
export enum BulkAllocateOutcome {
  /** Every line the run targeted was filled to its full quantity. */
  Allocated = 'ALLOCATED',
  /**
   * The order could not be read, or its write was attempted and failed. message carries the
   * error. Nothing was written for it.
   */
  Failed = 'FAILED',
  /** Some targeted lines were filled and at least one came up short. */
  PartiallyAllocated = 'PARTIALLY_ALLOCATED',
  /**
   * The run found no inventory for any line it targeted, so it filled nothing and wrote nothing. The
   * order is left exactly as it was. shortfalls lists every line.
   */
  Short = 'SHORT',
  /** The order was not processed at all. skipReason says why. */
  Skipped = 'SKIPPED'
}

/**
 * Why a whole order was left alone. Every order that is not processed comes back with one of these —
 * a bulk run never drops an order silently.
 */
export enum BulkAllocateSkipReason {
  /**
   * The customer requires a deposit and it is not yet satisfied, so allocation is locked. The same
   * rule the order screen's Allocate button is disabled by.
   */
  DepositLocked = 'DEPOSIT_LOCKED',
  /** The id is a master order. Master orders carry no lines, so there is nothing to fill. */
  MasterOrder = 'MASTER_ORDER',
  /**
   * The order has nothing for this run to work on. Every line already carries an allocation, is
   * make-to-order, or has no quantity to allocate against. skippedLines names each one.
   */
  NoFillableLines = 'NO_FILLABLE_LINES',
  /** No order exists for the id under this tenant. */
  OrderNotFound = 'ORDER_NOT_FOUND',
  /**
   * The order's status is past the point where allocations may change. Allocation is permitted in
   * Open, Initialized, Submitted, Acknowledged and Picked only.
   */
  OrderStatusNotAllocatable = 'ORDER_STATUS_NOT_ALLOCATABLE'
}

/** One line the run deliberately left alone, and why. */
export type BulkAllocateSkippedLine = {
  __typename?: 'BulkAllocateSkippedLine';
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  reason: BulkAllocateLineSkipReason;
};

/**
 * How bulkAllocateOrders chooses which inventory to fill a line from. One strategy applies to
 * the whole run. The six values are the vocabulary the FULFILL order screen already ships
 * (worksuite-pwa allocationStrategies.ts), so the bulk ribbon's picker and the per-order Quick
 * Allocate picker offer the same words for the same intent.
 */
export enum BulkAllocationStrategy {
  /**
   * Spreads each line across every location holding the item, in proportion to how much each has
   * available. Rounding goes to the largest remainders and never past what a location holds.
   */
  Balanced = 'BALANCED',
  /**
   * Oldest crop first, by the inventory's ready date, or by the date the row was created when it
   * has no ready date. Ties go to the earlier-created row.
   */
  Fifo = 'FIFO',
  /**
   * Highest grade first, then the location holding the most available. The default, and the same
   * order the allocation modal presents its rows in.
   */
  HighestGrade = 'HIGHEST_GRADE',
  /**
   * Newest crop first, by the inventory's ready date, or by the date the row was created when it
   * has no ready date. Ties go to the later-created row.
   */
  Lifo = 'LIFO',
  /**
   * Fills in the caller's ranked order — priorityLocationIds first, then
   * priorityGrades within a location. Anything unranked is used last. At least one location or
   * grade must be ranked.
   */
  Priority = 'PRIORITY',
  /**
   * Fills ONLY from singleLocationId. Anything that location cannot cover is reported as a
   * shortfall rather than quietly taken from somewhere else.
   */
  SingleLocation = 'SINGLE_LOCATION'
}

/**
 * Input for the bulkAssignTasks mutation.
 * Assigns a single worker to multiple task assignments in one operation.
 */
export type BulkAssignTasksInput = {
  assignedTo: Scalars['String']['input'];
  taskAssignmentIds: Array<Scalars['String']['input']>;
};

/** GraphQL payload wrapper for bulk task assignment mutation results. */
export type BulkAssignTasksPayload = {
  __typename?: 'BulkAssignTasksPayload';
  errors?: Maybe<Array<ValidationError>>;
  taskAssignments?: Maybe<Array<TaskAssignmentStateData>>;
};

export type BulkCreateMaterialItemInput = {
  materialItems: Array<CreateMaterialItemInput>;
};

/**
 * One bulk order delete job, in BulkOrderDeleteJobs. The job and its per-order results live here
 * so progress survives a page reload or a different API pod. Nothing in this document deletes an order:
 * the worker-only advance mutation does.
 */
export type BulkOrderDeleteJobDocument = {
  __typename?: 'BulkOrderDeleteJobDocument';
  /** When the job reached a terminal status. Not set while it is Pending or Running. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the job was requested. */
  createdAt: Scalars['DateTime']['output'];
  /** How many orders are now deleted, including ones that already were. */
  deletedCount: Scalars['Int']['output'];
  /** How many orders could not be deleted. */
  failedCount: Scalars['Int']['output'];
  /** Globally unique document id, {TenantId}-{JobId}, which the worker uses to address a job. */
  id: Scalars['String']['output'];
  /** The tenant-unique id the requester gets back. */
  jobId: Scalars['String']['output'];
  /** How many orders have been handled, deleted or failed. */
  processedCount: Scalars['Int']['output'];
  /** The requesting user's email; the advance mutation records it as who deleted each order. */
  requestedBy: Scalars['String']['output'];
  /** One entry per order processed so far, in the order processed. */
  results: Array<BulkOrderDeleteResultData>;
  /** When the worker first claimed the job. Not set while it is Pending. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Where the job is. */
  status: BulkOrderDeleteJobStatus;
  /** The tenant that requested the job. */
  tenantId: Scalars['String']['output'];
  /** How many orders the job was asked to delete. */
  totalCount: Scalars['Int']['output'];
};

/**
 * One bulk order delete job, in BulkOrderDeleteJobs. The job and its per-order results live here
 * so progress survives a page reload or a different API pod. Nothing in this document deletes an order:
 * the worker-only advance mutation does.
 */
export type BulkOrderDeleteJobDocumentFilterInput = {
  and?: InputMaybe<Array<BulkOrderDeleteJobDocumentFilterInput>>;
  /** When the job was requested. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** How many orders are now deleted, including ones that already were. */
  deletedCount?: InputMaybe<IntOperationFilterInput>;
  /** How many orders could not be deleted. */
  failedCount?: InputMaybe<IntOperationFilterInput>;
  /** Globally unique document id, {TenantId}-{JobId}, which the worker uses to address a job. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** The tenant-unique id the requester gets back. */
  jobId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BulkOrderDeleteJobDocumentFilterInput>>;
  /** The requesting user's email; the advance mutation records it as who deleted each order. */
  requestedBy?: InputMaybe<StringOperationFilterInput>;
  /** Where the job is. */
  status?: InputMaybe<BulkOrderDeleteJobStatusOperationFilterInput>;
  /** The tenant that requested the job. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** How many orders the job was asked to delete. */
  totalCount?: InputMaybe<IntOperationFilterInput>;
};

/** A bulk order delete job, or the errors that stopped the call. */
export type BulkOrderDeleteJobPayload = {
  __typename?: 'BulkOrderDeleteJobPayload';
  bulkOrderDeleteJob?: Maybe<BulkOrderDeleteJobDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * The progress event the advance mutation publishes after each page it works, and the cancel mutation after a
 * cancel, on the job's topic; what onBulkOrderDeleteJobProgress emits. Counts only, never the
 * per-order results, so the event stays small on a distributed subscription provider.
 */
export type BulkOrderDeleteJobProgress = {
  __typename?: 'BulkOrderDeleteJobProgress';
  /** How many orders are now deleted, including ones that already were. */
  deletedCount: Scalars['Int']['output'];
  /** How many orders could not be deleted. */
  failedCount: Scalars['Int']['output'];
  /** The tenant-unique job id the requester holds. */
  jobId: Scalars['String']['output'];
  /** How many orders have been handled, deleted or failed. */
  processedCount: Scalars['Int']['output'];
  /** Where the job is after the page or the cancel. */
  status: BulkOrderDeleteJobStatus;
  /** How many orders the job was asked to delete. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Where a bulk order delete job is. Stored by NAME (the document maps it as a string); the explicit
 * ordinals keep the GraphQL enum stable. Never reorder, renumber or reuse a member.
 */
export enum BulkOrderDeleteJobStatus {
  /** Stopped by the user. Orders deleted before the stop stay deleted. */
  Cancelled = 'CANCELLED',
  /** Every requested order was handled and none failed. */
  Completed = 'COMPLETED',
  /** Every requested order was handled and at least one could not be deleted. */
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  /** The job itself broke; orders it had not reached were not deleted. */
  Failed = 'FAILED',
  /** Stored and waiting its turn. A tenant runs one job at a time, oldest first. */
  Pending = 'PENDING',
  /** The worker has started deleting this job's orders. */
  Running = 'RUNNING',
  /** Not a real status; the default for an unset value. */
  Unknown = 'UNKNOWN'
}

export type BulkOrderDeleteJobStatusOperationFilterInput = {
  eq?: InputMaybe<BulkOrderDeleteJobStatus>;
  in?: InputMaybe<Array<BulkOrderDeleteJobStatus>>;
  neq?: InputMaybe<BulkOrderDeleteJobStatus>;
  nin?: InputMaybe<Array<BulkOrderDeleteJobStatus>>;
};

/** A connection to a list of items. */
export type BulkOrderDeleteJobsConnection = {
  __typename?: 'BulkOrderDeleteJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BulkOrderDeleteJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BulkOrderDeleteJobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BulkOrderDeleteJobsEdge = {
  __typename?: 'BulkOrderDeleteJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BulkOrderDeleteJobDocument;
};

/** What one order in a bulk delete job came to. */
export type BulkOrderDeleteResultData = {
  __typename?: 'BulkOrderDeleteResultData';
  /** The requested id. */
  orderId: Scalars['String']['output'];
  /** The order's number once deleted. Not set whenever Success is false. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Set only when Success is false: the error that stopped this order. */
  reason?: Maybe<Scalars['String']['output']>;
  /** True when the order is now Deleted, including one that already was (a repeat delete is a no-op). */
  success: Scalars['Boolean']['output'];
};

export enum CalculationStatus {
  Blocked = 'BLOCKED',
  Error = 'ERROR',
  Ok = 'OK',
  Warning = 'WARNING'
}

/** Input for cancelAssignment. */
export type CancelAssignmentInput = {
  assignmentId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Input to cancelBulkOrderDeleteJob. */
export type CancelBulkOrderDeleteJobInput = {
  /** The job to cancel, as returned by requestBulkOrderDelete. */
  jobId: Scalars['String']['input'];
};

export type CancelContractRecordEnrollmentInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
};

export type CancelCountSessionInput = {
  countSessionId: Scalars['String']['input'];
};

export type CancelErpLoadListSessionInput = {
  sessionId: Scalars['String']['input'];
};

/** The result of cancelFeatureFlagProductConversionJob: the job, or what stopped the call. */
export type CancelFeatureFlagProductConversionJobPayload = {
  __typename?: 'CancelFeatureFlagProductConversionJobPayload';
  /** What stopped the call, if anything. */
  errors?: Maybe<Array<ValidationError>>;
  /** The job: cancelled, or unchanged when it was already finished. Null when the call failed. */
  job?: Maybe<FeatureFlagProductConversionJob>;
};

export type CancelMarkedScheduleAndReEnrollInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
};

export type CancelProductionLotAllocationInput = {
  allocationId: Scalars['String']['input'];
};

export type CancelPurchaseOrderInput = {
  purchaseOrderId: Scalars['String']['input'];
};

export type CancelRestockSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type CancelScheduledInventoryTransferInput = {
  scheduledInventoryTransferId: Scalars['String']['input'];
  why?: InputMaybe<Scalars['String']['input']>;
};

export type CancelScheduledLaborRateInput = {
  effectiveFrom: Scalars['DateTime']['input'];
  laborTypeId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type CancelScheduledOverheadRateInput = {
  effectiveFrom: Scalars['DateTime']['input'];
  siteLocationId: Scalars['String']['input'];
  subLocationId?: InputMaybe<Scalars['String']['input']>;
};

/** Withdraws the approval a reviewer is looking at, at the generation they read it under. */
export type CancelSupplierPriceImportApprovalInput = {
  approvalId: Scalars['String']['input'];
  expectedGeneration: Scalars['Int']['input'];
  importId: Scalars['String']['input'];
};

export type CancelTaskInput = {
  taskAssignmentId: Scalars['String']['input'];
};

export type CaptureSignatureDataInput = {
  base64SignatureImage: Scalars['String']['input'];
  dateCaptured: Scalars['DateTime']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mime: Scalars['String']['input'];
};

/** One receipt on an order's payment ledger, and what the repair did with it. */
export type CarriedOrderReceiptData = {
  __typename?: 'CarriedOrderReceiptData';
  /** The cash the entry recorded. */
  amount: Scalars['Decimal']['output'];
  /**
   * The amount the invoice already holds for this receipt, when it holds one: under the same reference
   * (ALREADY_ON_INVOICE, REFERENCE_AMOUNT_CONFLICT), as the imported payment it was matched to
   * (ACCOUNTING_PAYMENT_ON_INVOICE), or under the accounting line's earlier identity
   * (STALE_CARRIED_PAYMENT_ON_INVOICE), beside the amount the ledger now says. Null otherwise.
   */
  amountOnInvoice?: Maybe<Scalars['Decimal']['output']>;
  /** The entry's currency. */
  currency: Scalars['String']['output'];
  /** The accounting platform's id for an imported entry; null otherwise. */
  externalRemoteId?: Maybe<Scalars['String']['output']>;
  /** Whether the ledger entry is a payment or a deposit. */
  kind: OrderPaymentKind;
  /** Whether it was applied, and if not, why it was left alone. */
  outcome: OrderReceiptCarryOutcome;
  /** When the money was received — the date the invoice payment keeps. */
  receivedDate: Scalars['DateTime']['output'];
  /** Whether the entry was recorded in FULFILL or imported from the accounting platform. */
  source: OrderPaymentSource;
  /**
   * The receipt's identity — order-payment- followed by 32 hex characters — which is the transactionRef of
   * the payment it becomes on the invoice, and stays the same on every invoice of the order.
   */
  transactionRef: Scalars['String']['output'];
};

/**
 * The distinct carrier values in use across this tenant. Values appear automatically as
 * customers, ship-tos, orders and the tenant default carrier are saved; case and whitespace
 * variants collapse to a single entry that keeps the first spelling seen.
 */
export type CarrierDocument = {
  __typename?: 'CarrierDocument';
  carrier: Scalars['String']['output'];
  id: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * The distinct carrier values in use across this tenant. Values appear automatically as
 * customers, ship-tos, orders and the tenant default carrier are saved; case and whitespace
 * variants collapse to a single entry that keeps the first spelling seen.
 */
export type CarrierDocumentFilterInput = {
  and?: InputMaybe<Array<CarrierDocumentFilterInput>>;
  carrier?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CarrierDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * The distinct carrier values in use across this tenant. Values appear automatically as
 * customers, ship-tos, orders and the tenant default carrier are saved; case and whitespace
 * variants collapse to a single entry that keeps the first spelling seen.
 */
export type CarrierDocumentSortInput = {
  carrier?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export enum CarrierRateBasis {
  Flat = 'FLAT',
  PerContainer = 'PER_CONTAINER',
  PerMile = 'PER_MILE',
  PerStop = 'PER_STOP',
  Unknown = 'UNKNOWN'
}

export type CarrierRateBasisOperationFilterInput = {
  eq?: InputMaybe<CarrierRateBasis>;
  in?: InputMaybe<Array<CarrierRateBasis>>;
  neq?: InputMaybe<CarrierRateBasis>;
  nin?: InputMaybe<Array<CarrierRateBasis>>;
};

export enum CarrierType {
  HouseFleet = 'HOUSE_FLEET',
  Parcel = 'PARCEL',
  ThirdParty = 'THIRD_PARTY',
  Unknown = 'UNKNOWN'
}

export type CarrierTypeOperationFilterInput = {
  eq?: InputMaybe<CarrierType>;
  in?: InputMaybe<Array<CarrierType>>;
  neq?: InputMaybe<CarrierType>;
  nin?: InputMaybe<Array<CarrierType>>;
};

/** A connection to a list of items. */
export type CarriersConnection = {
  __typename?: 'CarriersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CarriersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CarrierDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CarriersEdge = {
  __typename?: 'CarriersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CarrierDocument;
};

/** Input for the carry-order-receipts-to-invoice repair mutation. */
export type CarryOrderReceiptsToInvoiceInput = {
  /**
   * Required on a live run: the transactionRefs the approved dry run listed in applied. The live run writes
   * exactly these or nothing. Ignored on a dry run.
   */
  approvedReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * True unless sent as false: nothing is written, and the payload reports what would be applied and what
   * would be left alone. A live run is an explicit false.
   */
  dryRun?: Scalars['Boolean']['input'];
  /** The issued, live invoice to carry its order's receipts onto. */
  invoiceId: Scalars['String']['input'];
};

/** Payload returned from the carry-order-receipts-to-invoice repair mutation. */
export type CarryOrderReceiptsToInvoicePayload = {
  __typename?: 'CarryOrderReceiptsToInvoicePayload';
  /**
   * The receipts this call recorded on the invoice (on a dry run, the ones it would record), in ledger
   * order. Empty when there was nothing left to carry.
   */
  applied: Array<CarriedOrderReceiptData>;
  /** Whether this was a dry run that wrote nothing. */
  dryRun: Scalars['Boolean']['output'];
  /** Populated only when the request was refused, in which case nothing was recorded. */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * The invoice as it stands after the call — with the applied receipts among its payments on a live run,
   * unchanged on a dry run (its balance after the repair is this balance less the applied amounts, because a
   * carried receipt takes no discount and no finance charge). Null when the request was refused.
   */
  invoice?: Maybe<InvoiceStateData>;
  /** Every other receipt on the order's ledger, each with the reason it was left alone. */
  skipped: Array<CarriedOrderReceiptData>;
};

export type CartAddressData = {
  __typename?: 'CartAddressData';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  stateProvince: Scalars['String']['output'];
  toName: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export enum CatalogChipSource {
  Category = 'CATEGORY',
  ItemGroup = 'ITEM_GROUP'
}

export enum CatalogDisplayMode {
  Grid = 'GRID',
  List = 'LIST'
}

/** A connection to a list of items. */
export type CategoriesConnection = {
  __typename?: 'CategoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CategoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CategoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CategoriesEdge = {
  __typename?: 'CategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CategoryDocument;
};

export type CategoryBulkActionPayload = {
  __typename?: 'CategoryBulkActionPayload';
  categories?: Maybe<Array<CategoryPayload>>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CategoryData = {
  __typename?: 'CategoryData';
  code: Scalars['String']['output'];
  /**
   * DEAD on a category. Nothing writes it any more: a category's read-model row keeps whatever count it was projected with before the cutover, strictly read-only, and anything with no such value — a category created after the cutover, and every addCategory / updateCategory payload, which is built from aggregate state that no longer holds a count — reports the constant 1. It is deliberately NOT derived from the tagged Shipping UOM's eachesPerUnit: deriving it would make a field nothing writes and nothing validates authoritative for money again, which is the defect this cutover removes. 1 is the multiplicative identity, so a consumer still computing `quantity * eaches` gets the same number it will get once the field is gone. On the deprecated `item.categories` this field is NOT dead: that field is still this same type, kept for one release for the worksuite-pwa bundle cut on 2026-08-30, and there this value is the item's own live eaches snapshot, which the server derives an order line's eaches quantity and the royalty payout from. The same rows are published as `item.categoryAssignments`, typed `ItemCategoryAssignmentData`, whose `eaches` carries that snapshot on a type with no deprecated field — read item snapshots there, because `item.categories` goes away with this one.
   * @deprecated A category no longer has an eaches count — a Shipping UOM (ConfigCategory) owns eachesPerUnit and a category only tags one. Read the tagged Shipping UOM's eachesPerUnit instead. Accepted but IGNORED on every Category write. It survives only for the one-release wire-compatibility window this cutover opened, so that deployed senders keep working unmodified, and MUST be removed once they stop supplying it.
   */
  eaches: Scalars['Int']['output'];
  /** The Shipping UOM (ConfigCategory) this category tags, by `configCategoryId` — the identity a rename cannot break. Null means the category tags no Shipping UOM. ALWAYS null on the deprecated `item.categories`, which is still this same type: an item's category assignments are a denormalized snapshot and never carry the tag, and the Category read model is the only authoritative source for a category's Shipping UOM. `item.categoryAssignments`, the item's own read surface, is published by `ItemCategoryAssignmentData`, which does not publish this field at all. */
  shippingUomId?: Maybe<Scalars['String']['output']>;
};

export type CategoryDataFilterInput = {
  and?: InputMaybe<Array<CategoryDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CategoryDataFilterInput>>;
  shippingUomId?: InputMaybe<StringOperationFilterInput>;
};

export type CategoryDataInput = {
  code: Scalars['String']['input'];
  /**
   * IGNORED on addCategory / updateCategory / batchAddCategories / batchUpdateCategories — the only mutations that take this input type: accepted so deployed senders keep working unmodified during the deprecation window, written nowhere, and never reaching a command. It is NO LONGER the field an item's category assignments carry. Those take `ItemCategoryAssignmentDataInput`, whose identically-spelled `eaches` is REQUIRED and recorded as that item's own snapshot, and is rejected rather than defaulted when omitted — read that field's own description, not this one, for the item path.
   * @deprecated A category no longer has an eaches count — a Shipping UOM (ConfigCategory) owns eachesPerUnit and a category only tags one. Read the tagged Shipping UOM's eachesPerUnit instead. Accepted but IGNORED on every Category write. It survives only for the one-release wire-compatibility window this cutover opened, so that deployed senders keep working unmodified, and MUST be removed once they stop supplying it.
   */
  eaches?: InputMaybe<Scalars['Int']['input']>;
  /** The Shipping UOM this category tags, supplied as a ConfigCategory code. It is resolved to that config category's `configCategoryId` once, at the mutation edge, by EXACT match after the same trim-and-lowercase normalization a code gets when it is stored, and there is no id or name fallback and no fuzzy matching. A code that names no ACTIVE ConfigCategory is REJECTED; nothing is ever created implicitly. Accepted only by addCategory / updateCategory / batchAddCategories / batchUpdateCategories. An item's category assignments take `ItemCategoryAssignmentDataInput`, which carries no Shipping UOM member of either spelling: the tag belongs to the Category and is set here. OMITTING this field LEAVES the category's existing tag exactly as it is; sending it as an explicit null, or as a blank code, CLEARS the tag. Those are two different requests, not one: a caller that never mentions the field changes nothing, and clearing has to be asked for. An explicit null (here or on `shippingUomId`) is the ONLY way to clear a tag, which is why there is no separate clear mutation. To name a Shipping UOM by its id instead, send `shippingUomId`. A write may send one of the two, never both. */
  shippingUomCode?: InputMaybe<Scalars['String']['input']>;
  /** The Shipping UOM this category tags, supplied as a ConfigCategory `configCategoryId`. Use it to name a Shipping UOM by id, including one whose code is blank. The id must name an ACTIVE ConfigCategory of the caller's tenant: an inactive id, another tenant's id or an id that names nothing is REJECTED, and nothing is ever created implicitly. Accepted only by addCategory / updateCategory / batchAddCategories / batchUpdateCategories. OMITTING this field LEAVES the category's existing tag exactly as it is; sending it as an explicit null, or as a blank id, CLEARS the tag; sending an id SETS the tag to it. Send this or `shippingUomCode`, never both: a write that sends both is rejected. */
  shippingUomId?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryDataSortInput = {
  code?: InputMaybe<SortEnumType>;
  shippingUomId?: InputMaybe<SortEnumType>;
};

export type CategoryDocument = {
  __typename?: 'CategoryDocument';
  category: CategoryData;
  id: Scalars['String']['output'];
  /** Linked Chart-of-Accounts row resolved from IncomeGlAccountId. Null when the category has no income account configured, or when the linked account no longer exists for the tenant. */
  incomeGlAccount?: Maybe<MergeDevAccountDocument>;
  /**
   * The category's optional income GL account (rung 3 of the revenue ladder, Helm 432f8bb4), by
   * MergeDevAccount ImportId. Null means no income account is configured.
   */
  incomeGlAccountId?: Maybe<Scalars['String']['output']>;
  status: CategoryStatus;
  tenantId: Scalars['String']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
  /**
   * What uses this category: the items in it, the category price levels that target it and the hard
   * goods in it, one group per kind. The total equals the Usage Count and the count a refused delete
   * names. Staff only: a customer caller gets an error and a null list, so the field stays nullable. Read
   * it for one category at a time: it reads its own groups for each category it is selected on, so
   * selecting it on a list of categories costs several reads per row.
   */
  usedBy?: Maybe<UsedBy>;
};


export type CategoryDocumentUsedByArgs = {
  first?: Scalars['Int']['input'];
  kind?: InputMaybe<RecordKind>;
  offset?: Scalars['Int']['input'];
};

export type CategoryDocumentFilterInput = {
  and?: InputMaybe<Array<CategoryDocumentFilterInput>>;
  category?: InputMaybe<CategoryDataFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The category's optional income GL account (rung 3 of the revenue ladder, Helm 432f8bb4), by
   * MergeDevAccount ImportId. Null means no income account is configured.
   */
  incomeGlAccountId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CategoryDocumentFilterInput>>;
  status?: InputMaybe<CategoryStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type CategoryDocumentSortInput = {
  category?: InputMaybe<CategoryDataSortInput>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The category's optional income GL account (rung 3 of the revenue ladder, Helm 432f8bb4), by
   * MergeDevAccount ImportId. Null means no income account is configured.
   */
  incomeGlAccountId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type CategoryPayload = {
  __typename?: 'CategoryPayload';
  data?: Maybe<CategoryPayloadData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CategoryPayloadData = {
  __typename?: 'CategoryPayloadData';
  category: CategoryData;
  id: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * Per-row failure surfaced by validateCategoryDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError carries one (best-effort), otherwise null.
 */
export type CategoryStagedRowError = {
  __typename?: 'CategoryStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export enum CategoryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Initialized = 'INITIALIZED',
  Unknown = 'UNKNOWN'
}

export type CategoryStatusOperationFilterInput = {
  eq?: InputMaybe<CategoryStatus>;
  in?: InputMaybe<Array<CategoryStatus>>;
  neq?: InputMaybe<CategoryStatus>;
  nin?: InputMaybe<Array<CategoryStatus>>;
};

/**
 * How much of a category a category-volume tier would actually pay out on, answered at configuration
 * time — before any order exists.
 *
 * An item that has won its own item-specific price in the same price group counts toward its
 * category's volume threshold and is paid nothing at the tier, because a negotiated price does not
 * stack with a category break. That is intended, and it is invisible on the price-level editor:
 * someone setting a "1,000 units → $0.99" category tier has no way to see that 40 of the category's
 * 50 items already carry their own price in this very group and will therefore never be charged
 * $0.99. These two numbers let the editor say so while there is still time to change the
 * configuration.
 *
 * A prediction, not a receipt. It counts ITEMS in the catalogue, not units on an order. The
 * order-time truth — how many units actually went undiscounted and why — is on an order's
 * categoryVolumeProgress, whose ITEM_SPECIFIC_PRICING bucket is this same exclusion
 * measured after the fact. The two are deliberately separate: a warning that could only be shown
 * once a customer had already been underpaid would be a report, not a warning.
 *
 * Counts, not lists. A category can hold thousands of items and the editor needs a sentence,
 * not a catalogue, so returning ids would make the response size scale with the category and hand
 * the caller a second problem to solve.
 */
export type CategoryVolumeCoverage = {
  __typename?: 'CategoryVolumeCoverage';
  /**
   * The category asked about, echoed back so a caller rendering several warnings cannot mis-pair a
   * response with its request.
   */
  categoryCode: Scalars['String']['output'];
  /**
   * How many of those active items currently carry their OWN item-specific price in this price group —
   * the numerator, and the count of items a category tier configured here would never pay out on.
   *
   * Evaluated as of right now: an item counts only while it has an own price in force today. An item
   * whose only own price has already expired, or whose own price has not started yet, is not counted —
   * such an item is priced from the category instead, so a tier configured here does reach it. Because
   * this is answered "as of now" rather than as of any particular future order, the count is a snapshot
   * of this moment and can change the next time this is asked, as prices start or end.
   *
   *
   * Never exceeds totalActiveItems: it is counted by intersecting the group's currently-active
   * item-specific prices with the category's active items, so a price targeting an inactive item — or
   * an item in another category — cannot inflate it.
   */
  itemsWithOwnPriceLevel: Scalars['Int']['output'];
  /**
   * The price group asked about, echoed back for the same reason. The item-specific-price exclusion is
   * GROUP-SCOPED — the same item can carry its own price in one group and none in another — so this
   * figure is meaningless without knowing which group produced it.
   */
  priceGroupId: Scalars['String']['output'];
  /**
   * Active items in the category — the denominator, the "50" in "40 of 50". Counts only items an
   * operator can currently pick as a price-level target, which is the same population the price-level
   * editor's item picker offers; an item that cannot be ordered would inflate both figures and
   * describe a catalogue nobody can buy from. Zero is a real answer, and means the category is empty
   * or holds nothing active — in which case the editor should say nothing at all rather than warn
   * about a proportion of zero.
   */
  totalActiveItems: Scalars['Int']['output'];
};

export enum CategoryVolumeExclusionReason {
  AssignedToAnotherCategory = 'ASSIGNED_TO_ANOTHER_CATEGORY',
  ItemSpecificPricing = 'ITEM_SPECIFIC_PRICING',
  NonDiscountableItem = 'NON_DISCOUNTABLE_ITEM',
  OverridePrice = 'OVERRIDE_PRICE',
  PooledPricing = 'POOLED_PRICING',
  Unspecified = 'UNSPECIFIED'
}

export type CategoryVolumeExclusionReasonOperationFilterInput = {
  eq?: InputMaybe<CategoryVolumeExclusionReason>;
  in?: InputMaybe<Array<CategoryVolumeExclusionReason>>;
  neq?: InputMaybe<CategoryVolumeExclusionReason>;
  nin?: InputMaybe<Array<CategoryVolumeExclusionReason>>;
};

export type ChangePortalAvailabilityRuleInput = {
  availabilityLocationId?: InputMaybe<Scalars['String']['input']>;
  availabilityMinGrade: Scalars['Int']['input'];
  includeSellableHardGoods: Scalars['Boolean']['input'];
};

export type ChangePortalCheckoutMethodInput = {
  checkoutMethod: PortalCheckoutMethod;
  orderContactName?: InputMaybe<Scalars['String']['input']>;
  orderContactPhone?: InputMaybe<Scalars['String']['input']>;
};

export type ChangePortalHelpContactInput = {
  clear?: InputMaybe<Scalars['Boolean']['input']>;
  set?: InputMaybe<PortalHelpContactDataInput>;
};

export type ChangeProductionCatalogStatusInput = {
  productionCatalogId: Scalars['String']['input'];
  status: ProductionCatalogStatus;
};

export type ChangeVendorPurchaseOrderItemsInput = {
  items: Array<ChangedVendorPurchaseOrderItemInput>;
  vendorPurchaseOrderId: Scalars['String']['input'];
};

export type ChangeVendorPurchaseOrderStatusInput = {
  purchaseOrderId: Scalars['String']['input'];
  status: VendorPurchaseOrderStatus;
};

export type ChangeWorkOrderQuantityProducedInput = {
  jobId: Scalars['String']['input'];
  quantityProduced: Scalars['Int']['input'];
  workOrderId: Scalars['String']['input'];
};

export type ChangeWorkOrderStatusInput = {
  jobId: Scalars['String']['input'];
  status: WorkOrderStatus;
  workOrderId: Scalars['String']['input'];
};

export type ChangedVendorPurchaseOrderItemInput = {
  id: Scalars['String']['input'];
  quantityReceived: Scalars['Decimal']['input'];
};

/**
 * One channel's attempt to deliver one notification — the shape the dispatch worker leases, sends
 * under, and records against, copied from the ErpWriteBackDocument claim pattern.
 */
export type ChannelDeliveryData = {
  __typename?: 'ChannelDeliveryData';
  /** How many send attempts this channel has made, for the retry budget. */
  attempts: Scalars['Int']['output'];
  /**
   * When the provider confirmed the message actually reached the recipient's carrier or device, as
   * opposed to merely accepting it for sending. null until a delivery confirmation webhook
   * (e.g. Twilio's delivered status) lands. Distinct from UpdatedAt, which is
   * stamped from this process's own clock when a block last changed; this is the PROVIDER's own
   * timestamp for the confirmation, carried through unchanged so the support trail reflects what
   * actually happened rather than when we got around to recording it.
   */
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The last failure reason, or null when this channel has not failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** When the current worker's claim on this row expires, or null when unclaimed. What stops two replicas sending the same message. */
  leaseUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Earliest time the next attempt may be claimed (the backoff), or null when none is scheduled. */
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  /** The provider's id for the accepted message (SendGrid, Twilio), for reconciling delivery webhooks. null until accepted. */
  providerMessageId?: Maybe<Scalars['String']['output']>;
  /** Where this channel's delivery stands. Persisted as the INTEGER ordinal — see NotificationDeliveryStatus. */
  status: NotificationDeliveryStatus;
  /** When this block last changed, or null while it is still in its inserted state. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CheckpointPayload = {
  __typename?: 'CheckpointPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<CheckpointStateData>;
};

export type CheckpointStateData = {
  __typename?: 'CheckpointStateData';
  checkpointType: CheckpointType;
  externalId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export enum CheckpointType {
  BpfNavInventory = 'BPF_NAV_INVENTORY',
  DtsInventory = 'DTS_INVENTORY',
  UnitsOnHand = 'UNITS_ON_HAND'
}

export type ChildParentRelationship = {
  __typename?: 'ChildParentRelationship';
  child: SiteLocationType;
  validParents: Array<SiteLocationType>;
};

/** Input for claimAvailabilityPhotoGradeRequests. The tenant comes from the worker's token. */
export type ClaimAvailabilityPhotoGradeRequestsInput = {
  /** The most rows to lease, from 1 to 50. */
  first: Scalars['Int']['input'];
  /** How long the worker holds each row, from 10 to 300 seconds. */
  leaseSeconds: Scalars['Int']['input'];
};

/** Result of a claim: the photos this worker now holds a lease on. Empty means nothing to grade. */
export type ClaimAvailabilityPhotoGradeRequestsPayload = {
  __typename?: 'ClaimAvailabilityPhotoGradeRequestsPayload';
  /** Populated only when the claim itself failed. */
  errors?: Maybe<Array<ValidationError>>;
  /** The leased photos, oldest first. */
  requests: Array<AvailabilityPhotoGradeRequest>;
};

export type ClaimContractRecordEnrollmentInput = {
  requestId: Scalars['String']['input'];
  supportsManualInvoiceDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClaimContractRecordFeeInvoiceInput = {
  requestId: Scalars['String']['input'];
};

/** Input for claiming customer messages. The tenant is taken from the worker's token, never from here. */
export type ClaimCustomerDeliveriesInput = {
  /** Which channel's delivery block to lease: EMAIL or SMS. */
  channel: NotificationChannel;
  /** The most rows to scan in this call, between one and five hundred. */
  first: Scalars['Int']['input'];
};

export type ClaimDeviceInput = {
  claimCode: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  serial: Scalars['String']['input'];
};

/** Input for claimLoadEmails. The tenant comes from the worker's token. */
export type ClaimLoadEmailsInput = {
  /** The most rows to lease, from 1 to 500. */
  batchSize: Scalars['Int']['input'];
};

/** Names one preparation job or import run by its composite id. */
export type ClaimMigrationRecordInput = {
  id: Scalars['String']['input'];
};

/**
 * Input for claiming outbound notifications. The tenant is taken from the worker's token, never
 * from here.
 */
export type ClaimNotificationDeliveriesInput = {
  /**
   * Which channel's delivery block to lease. EMAIL, PUSH and SMS are dispatched; IN_APP is not, because
   * for that channel the notification row itself is the delivery.
   */
  channel: NotificationChannel;
  /**
   * The most rows to scan in this call, between one and five hundred. Fewer messages than this may
   * come back once skipped and suppressed rows are taken out, and a digest recipient's day may
   * account for more rows than this, because a due digest is gathered for that recipient rather than
   * taken from the scan. That gathering is itself capped at five hundred rows and sees only what is
   * claimable at the moment it runs, so a day heavy enough to exceed the cap, or one holding a row
   * another worker has leased, yields more than one message for that day. Ordinary days do not.
   */
  first: Scalars['Int']['input'];
};

/** A claim of one channel's deliveries. */
export type ClaimOnboardingHelpDeliveriesInput = {
  /** The channel to drain. */
  channel: OnboardingHelpChannel;
  /** The most channels to take in this call, between one and five hundred. */
  first: Scalars['Int']['input'];
};

/** The result of a claim, or why it was refused. */
export type ClaimOnboardingHelpDeliveriesPayload = {
  __typename?: 'ClaimOnboardingHelpDeliveriesPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<ClaimOnboardingHelpDeliveriesResult>;
};

/** The channels the worker now holds. */
export type ClaimOnboardingHelpDeliveriesResult = {
  __typename?: 'ClaimOnboardingHelpDeliveriesResult';
  /** Each channel leased to the caller. */
  deliveries: Array<OnboardingHelpClaimedDelivery>;
};

/**
 * GraphQL input for claimPendingErpWriteBacks. marksPosting is the claimer's promise that it marks
 * Posting before every send; false when left out, so workers that predate it keep working.
 */
export type ClaimPendingErpWriteBacksInput = {
  batchSize: Scalars['Int']['input'];
  marksPosting?: Scalars['Boolean']['input'];
  workflow: ErpWriteBackWorkflow;
};

/** GraphQL input for claimPostedErpWriteBacks. */
export type ClaimPostedErpWriteBacksInput = {
  batchSize: Scalars['Int']['input'];
  workflow: ErpWriteBackWorkflow;
};

export type ClaimRampPurchaseOrderCopiesInput = {
  /** 1 to 50. */
  limit?: Scalars['Int']['input'];
};

export type ClaimRampPurchaseOrderCopiesPayload = {
  __typename?: 'ClaimRampPurchaseOrderCopiesPayload';
  claims: Array<RampPurchaseOrderCopyClaimData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Input of claimWhatsNewEmailBatches. */
export type ClaimWhatsNewEmailBatchesInput = {
  /** The most batches to lease, from 1 to 100. */
  batchSize: Scalars['Int']['input'];
};

export type CleanCustomersInput = {
  erpIds: Array<Scalars['String']['input']>;
};

export type CleanItemsInput = {
  erpIds: Array<Scalars['String']['input']>;
};

export type ClearActiveCountSessionInput = {
  productionLineId: Scalars['String']['input'];
};

export type ClearCategoryLaborCostInput = {
  productionCategoryId: Scalars['String']['input'];
};

export type ClearCustomerCommissionOverrideInput = {
  customerId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ClearCustomerItemShippingConfigCategoryCodeInput = {
  customerItemId: Scalars['String']['input'];
};

export type ClearCustomerLocationNoteInput = {
  context: NoteContext;
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type ClearCustomerNoteInput = {
  context: NoteContext;
  customerId: Scalars['String']['input'];
};

/** Input for the clear-email-suppression mutation. */
export type ClearEmailSuppressionInput = {
  /** A recorded SendGrid dropped reason that names the list, used when listType is null. */
  dropReason?: InputMaybe<Scalars['String']['input']>;
  /** The address to remove from the suppression list. */
  email: Scalars['String']['input'];
  /** The caller tenant's email send this clear is made from. When set, the clear is contextual and is refused unless that send records the address as dropped for the requested list. When null, the clear is the explicit one, which only a superadmin may make. */
  emailSendId?: InputMaybe<Scalars['String']['input']>;
  /** The suppression list to clear. When null, the list is resolved from dropReason. */
  listType?: InputMaybe<EmailSuppressionListType>;
};

/** Payload returned from the clear-email-suppression mutation. */
export type ClearEmailSuppressionPayload = {
  __typename?: 'ClearEmailSuppressionPayload';
  cleared: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  errors?: Maybe<Array<ValidationError>>;
  listType?: Maybe<EmailSuppressionListType>;
};

export type ClearFeatureFlagTenantOverrideInput = {
  name: FeatureFlagName;
  tenantId: Scalars['String']['input'];
};

/** How many finished jobs clearFinishedBackgroundJobs dismissed, or the errors that stopped the call. */
export type ClearFinishedBackgroundJobsPayload = {
  __typename?: 'ClearFinishedBackgroundJobsPayload';
  /** The number of jobs dismissed. */
  count: Scalars['Int']['output'];
  /** What stopped the call, if anything. */
  errors?: Maybe<Array<ValidationError>>;
};

export type ClearInventoryNoteInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  noteId: Scalars['UUID']['input'];
};

export type ClearItemContainerConfigOverrideInput = {
  containerCode: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  shippingConfigCategoryCode: Scalars['String']['input'];
  siteCode: Scalars['String']['input'];
  sizeUomCode: Scalars['String']['input'];
};

export type ClearItemLaborCostInput = {
  productionItemId: Scalars['String']['input'];
};

export type ClearItemNoteInput = {
  context: NoteContext;
  itemId: Scalars['String']['input'];
};

export type ClearJobGrowWeeksOverrideDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type ClearJobLinksOverrideDataInput = {
  linkId?: InputMaybe<Scalars['String']['input']>;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type ClearJobPlannedHoursOverrideDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type ClearJobPlantsPerPotOverrideDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type ClearLoadDockInput = {
  loadId: Scalars['String']['input'];
};

export type ClearLoadMilesInput = {
  loadId: Scalars['String']['input'];
};

export type ClearLoadPickupWindowInput = {
  loadId: Scalars['String']['input'];
};

export type ClearLoadStopPlannedTimeInput = {
  loadId: Scalars['String']['input'];
  routeStopId: Scalars['String']['input'];
};

export type ClearOnHandAdjustmentQueueInput = {
  batchSize?: Scalars['Int']['input'];
};

export type ClearOrderDropShipDestinationInput = {
  orderId: Scalars['String']['input'];
};

/** Clears one doc-type's routing entry back to the built-in default. */
export type ClearOrderEmailRecipientRoutingInput = {
  docType: OrderEmailRecipientDocType;
};

/** Clears an order's No tax. Clearing an order that is not marked No tax returns the ENTITY_NO_CHANGES error and records nothing. */
export type ClearOrderNoTaxInput = {
  /** The order. Refused with ORDER_NO_TAX_STATUS_LOCKED when it is Synchronized, Cancelled or Deleted, or past Shipped and already synchronized to the ERP; with ORDER_NO_TAX_CREDIT_ORDER when it is a credit order; and with ORDER_INVOICED while it has a live invoice (a voided invoice does not count). */
  orderId: Scalars['String']['input'];
};

export type ClearOrderNoteInput = {
  context: NoteContext;
  orderId: Scalars['String']['input'];
};

/** Jobs whose started and done marks to undo, 1 to 500 per call, each named once. */
export type ClearProductionJobsProgressInput = {
  jobs: Array<ProductionJobRefInput>;
};

export type ClearProductionLotCustomerGroupInput = {
  productionLotId: Scalars['String']['input'];
};

export type ClearProductionLotCustomerInput = {
  productionLotId: Scalars['String']['input'];
};

export type ClearProductionTaskEventJobExclusionDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type ClearRestockSessionKitCapInput = {
  kitId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type ClearSpaceCategorySiteOverrideInput = {
  productionSpaceCategoryId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type ClearSpaceDimensionOverrideInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  productionSpaceCategoryId: Scalars['String']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type ClearStopOutcomeInput = {
  loadId: Scalars['String']['input'];
  routeStopId: Scalars['String']['input'];
};

export type ClearTaskEventDirectCostInput = {
  productionTaskEventId: Scalars['String']['input'];
};

export type ClearTaskEventLaborTypeTagInput = {
  productionTaskEventId: Scalars['String']['input'];
};

export type ClearTaskEventThroughputInput = {
  productionTaskEventId: Scalars['String']['input'];
};

/**
 * Result of clearTenantIntegrationData: the tenant whose Merge read models were cleared, the
 * total documents deleted, the per-collection breakdown, and any error. On a clean re-run the counts
 * are zero and errors is empty — the reset is idempotent.
 */
export type ClearTenantIntegrationDataPayload = {
  __typename?: 'ClearTenantIntegrationDataPayload';
  cleared: Array<ClearedCollection>;
  errors?: Maybe<Array<ValidationError>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  totalDeleted: Scalars['Long']['output'];
};

/** The number of documents deleted from a single read-model collection during a reset. */
export type ClearedCollection = {
  __typename?: 'ClearedCollection';
  collectionName: Scalars['String']['output'];
  deletedCount: Scalars['Long']['output'];
};

export type ClickUpRoadmapTaskData = {
  __typename?: 'ClickUpRoadmapTaskData';
  addToRoadmap: Scalars['Boolean']['output'];
  dateUpdated: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  listName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publicScore: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ClickUpTaskData = {
  __typename?: 'ClickUpTaskData';
  assigneeEmails: Array<Scalars['String']['output']>;
  dateUpdated: Scalars['String']['output'];
  id: Scalars['String']['output'];
  listName: Scalars['String']['output'];
  logHoursEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Input closing an open GrowerBenchmark collection cycle (contract D9). */
export type CloseGrowerBenchmarkCycleInput = {
  /** Identifier of the collection cycle to close. */
  cycleId: Scalars['String']['input'];
};

/**
 * A combine and its picks. AddKeptCustomerToLimitedStaff (default false) gives the survivor to every
 * staff user the preview lists in limitedStaff; an admin must ask for it when anyone is listed.
 * LetOldSyncUpdateSettings (default false) lets the loser's outside-sync record, which the
 * preview lists in oldCustomerSyncSources, also update the survivor's settings; when off, an
 * import through the loser's keys only adds or updates the loser's own ship-tos and contacts.
 */
export type CombineCustomersInput = {
  addKeptCustomerToLimitedStaff?: InputMaybe<Scalars['Boolean']['input']>;
  letOldSyncUpdateSettings?: InputMaybe<Scalars['Boolean']['input']>;
  loserId: Scalars['String']['input'];
  picks: Array<CustomerCombinePickInput>;
  survivorId: Scalars['String']['input'];
};

export type CombineCustomersPayload = {
  __typename?: 'CombineCustomersPayload';
  errors?: Maybe<Array<ValidationError>>;
  loserId?: Maybe<Scalars['String']['output']>;
  survivorId?: Maybe<Scalars['String']['output']>;
};

export type CombineItemsInput = {
  loserId: Scalars['String']['input'];
  picks: Array<ItemCombinePickInput>;
  survivorId: Scalars['String']['input'];
};

export type CombineItemsPayload = {
  __typename?: 'CombineItemsPayload';
  errors?: Maybe<Array<ValidationError>>;
  loserId?: Maybe<Scalars['String']['output']>;
  survivorId?: Maybe<Scalars['String']['output']>;
};

export type CombineProductionCatalogsInput = {
  loserId: Scalars['String']['input'];
  picks: Array<ProductionCombinePickInput>;
  survivorId: Scalars['String']['input'];
};

export type CombineProductionCatalogsPayload = {
  __typename?: 'CombineProductionCatalogsPayload';
  errors?: Maybe<Array<ValidationError>>;
  loserId?: Maybe<Scalars['String']['output']>;
  survivorId?: Maybe<Scalars['String']['output']>;
};

export type CombineProductionItemsInput = {
  loserId: Scalars['String']['input'];
  picks: Array<ProductionCombinePickInput>;
  survivorId: Scalars['String']['input'];
};

export type CombineProductionItemsPayload = {
  __typename?: 'CombineProductionItemsPayload';
  errors?: Maybe<Array<ValidationError>>;
  loserId?: Maybe<Scalars['String']['output']>;
  survivorId?: Maybe<Scalars['String']['output']>;
};

export type CombineShipTosInput = {
  loserLocationId: Scalars['String']['input'];
  picks: Array<ShipToCombinePickInput>;
  survivorLocationId: Scalars['String']['input'];
};

export type CombineShipTosPayload = {
  __typename?: 'CombineShipTosPayload';
  customerId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  loserLocationId?: Maybe<Scalars['String']['output']>;
  survivorLocationId?: Maybe<Scalars['String']['output']>;
};

export type CombineSubLocationsInput = {
  loserLocationId: Scalars['String']['input'];
  picks: Array<SubLocationCombinePickInput>;
  siteLocationId: Scalars['String']['input'];
  survivorLocationId: Scalars['String']['input'];
};

export type CombineSubLocationsPayload = {
  __typename?: 'CombineSubLocationsPayload';
  errors?: Maybe<Array<ValidationError>>;
  loserLocationId?: Maybe<Scalars['String']['output']>;
  survivorLocationId?: Maybe<Scalars['String']['output']>;
};

export type CombineTermsInput = {
  /** The payment terms combined into the survivor. */
  loserId: Scalars['String']['input'];
  /** One pick for every conflicting field of termsCombinePreview. */
  picks: Array<TermsCombinePickInput>;
  /** The payment terms that stay. */
  survivorId: Scalars['String']['input'];
};

export type CombineTermsPayload = {
  __typename?: 'CombineTermsPayload';
  errors?: Maybe<Array<ValidationError>>;
  loserId?: Maybe<Scalars['String']['output']>;
  survivorId?: Maybe<Scalars['String']['output']>;
};

export type CombinedCustomerRowInput = {
  mode: CombinedCustomerRowMode;
};

export enum CombinedCustomerRowMode {
  AlsoSettings = 'ALSO_SETTINGS',
  ShipTosAndContacts = 'SHIP_TOS_AND_CONTACTS'
}

export type CombinedOrderDocument = {
  __typename?: 'CombinedOrderDocument';
  /**
   * Order-level allocation rollup mirrored from the order document's allocation rollup, so the
   * Fulfill Orders grid can answer "which orders still need allocating?" without opening each order.
   * Null for master orders (no lines, so no allocation rollup) and, on an order, when no allocation
   * status has been derived for it yet — deliberately a different answer from NOT_STARTED.
   */
  allocationStatus?: Maybe<OrderAllocationStatus>;
  /**
   * What has been received against the order. Once a LIVE invoice stands against it this is the cash
   * recorded on that invoice; otherwise it is the order's own amount-paid rollup — every payment and
   * deposit applied to the order — which is null until the first one is applied. Always null for master
   * orders. Written by the same two sources as paymentStatus, and filterable and sortable for the same
   * reason.
   */
  amountPaid?: Maybe<MoneyData>;
  /**
   * The order's outstanding balance. Once a LIVE invoice stands against it this is that invoice's open
   * balance; otherwise it is the order's own balance rollup, which is NULL until the first payment is
   * applied and is always null for a master order. A null balance means nothing has been recorded
   * against the order yet — it is NOT a zero balance, and rendering it as 0 asserts the order is settled
   * when it may never even have been billed. Voiding the only live bill returns it to null for exactly
   * that reason. Written by the same two sources as paymentStatus, and filterable and sortable for the
   * same reason.
   */
  balance?: Maybe<MoneyData>;
  billingAddress: AddressData;
  confirmationEmail?: Maybe<ConfirmationEmailData>;
  /** Where a Credit-type order's money stands: APPLIED when all of its credit memo has been applied to invoices or refunded, PARTIALLY_APPLIED when some has, UNAPPLIED when none has or no memo has been issued yet. A credit is never a sale, so it never reads UNPAID: render this instead of paymentStatus for a Credit-type order. Null for every other order and for a master order. */
  creditApplicationStatus?: Maybe<CreditApplicationStatus>;
  /** The credit memo this Credit-type order issued instead of an invoice. Null for every other order, for a master order, and for a Credit-type order whose memo has not been issued yet. */
  creditMemo?: Maybe<CreditMemoDocument>;
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  /**
   * What the customer is billed: orderTotal without the royalty, the same figure the invoice
   * shows. Equals orderTotal when the order carries no royalty, has an override total, or is a
   * master order, and always for a customer-portal caller, who is given the billed total in both.
   */
  customerTotal: MoneyData;
  /**
   * Denormalized effective route (tier 1 → ship-to snapshot → inherited customer-location →
   * customer → tenant-default), stamped at projection-write time. Served straight from storage so
   * the grid sorts / filters / groups on it without per-row resolution.
   */
  effectiveRoute?: Maybe<Scalars['String']['output']>;
  erpId?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  finalCredit?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The sum of the order's named flat charges, inside orderTotal beside freightAmount. Null
   * on an order that never carried a charge, and on a master order.
   */
  flatChargesAmount?: Maybe<MoneyData>;
  /**
   * The day the order's quote follow-up is due, as a tenant-local date, mirrored from the order's
   * follow-up. Null for master orders and for orders with no follow-up, and always null for a
   * customer-portal caller, whose combinedOrders or agGridRows request that filters or sorts on it is
   * refused with GRID_COLUMN_STAFF_ONLY. Carries the day only, and stays set once the follow-up is done
   * or stopped by a move of the order out of draft (a submit, an acknowledge, a ship or a load
   * dispatch); quoteFollowUpsDue is the list of follow-ups that still remind. The
   * Fulfill Orders grid renders, sorts and filters on this column.
   */
  followUpOn?: Maybe<Scalars['LocalDate']['output']>;
  /** The computed freight dollar amount applied to the order. */
  freightAmount?: Maybe<MoneyData>;
  /** The freight charge type applied to the order. */
  freightChargeType?: Maybe<Scalars['Int']['output']>;
  generalNotes?: Maybe<Scalars['String']['output']>;
  /**
   * Order-level make-to-order rollup mirrored from hasMakeToOrderLine;
   * the Produce order-allocation queue filters on this (replacing produceAllocate).
   * Null for master orders, which carry no lines.
   */
  hasMakeToOrderLine?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Why the order is held, as staff entered it. Empty for an order that is not held and for a master
   * order, and always empty for a customer-portal caller, whose request that filters or sorts on it is
   * refused with GRID_COLUMN_STAFF_ONLY.
   */
  holdReason: Scalars['String']['output'];
  initializedDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The id of the invoice invoiceNumber names, for linking to the bill. Null for an order that
   * has never been billed, and for every master order. Output only — nothing filters, sorts or groups on
   * an opaque key.
   */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /**
   * The invoice number of the bill raised against this order — what a person calls it. The ACTIVE bill's
   * number where one still stands, and the most recently withdrawn bill's where every bill has been.
   * Null for an order that has never been billed, and for every master order. Stored, filterable and
   * sortable.
   */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this order has been billed. INVOICED means a live invoice stands against it — what the
   * customer owes on this order is then that bill's business, and this row's balance and paymentStatus
   * are reported from it. VOIDED means the order was billed and every bill against it has since been
   * withdrawn, which is a different fact from never having been billed at all. NOT_INVOICED means no
   * invoice has ever been raised, and is also how a master order reads — a master order carries no lines
   * and is never billed.
   *
   * STORED ON THE ORDER, written by the projection from the invoice's own events, so it is filterable
   * and sortable and a filter selects exactly the rows that read that way. UNKNOWN is never produced: it
   * is what a row predating this field reads as, and it is not a claim that the order has never been
   * billed.
   */
  invoiceStatus: OrderInvoiceStatus;
  /** Every invoice raised against this order, newest first. An order has one invoice today — the invoicing aggregate refuses a second — so this is empty or a single entry; it is published as a list so a re-bill would extend the surface rather than break it. Always empty for a master order. Carries enough to link to the bill and show where it stands; the billed lines, the tax breakdown and the payments stay behind invoice(invoiceId). */
  invoices: Array<OrderInvoiceLink>;
  /**
   * When an allocate or deallocate was last applied, mirrored from the order document's allocation
   * timestamp. Null for master orders and for any order never allocated against.
   */
  lastAllocatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The order's load factor — its rack count, for planning how much of a truck the order fills. The sum, across every line, of the line's eaches quantity times its item's configured load factor; never the pricing/handling-UOM quantity, which can be a tray or case count that would understate the racks. A line contributes only when BOTH its eaches quantity and its item's load factor were captured, so an item with no load factor contributes nothing rather than a zero. Null when NO line carries a load-factor-bearing item — an unknown rack count, which is not the same fact as an order that genuinely occupies no racks — and always null for a master order, which has no lines. Resolved live from the item read model, so it reflects load factors as configured today rather than as they stood when the order was placed. */
  loadFactor?: Maybe<Scalars['Decimal']['output']>;
  locations: OrderLocationDocumentData;
  numberOfLines: Scalars['Int']['output'];
  /**
   * Whether the order is on hold. False for an order that was never held or whose hold was released, and
   * for a master order, which cannot be held. Always false for a customer-portal caller, whose
   * combinedOrders or agGridRows request that filters or sorts on it is refused with
   * GRID_COLUMN_STAFF_ONLY. The Fulfill Orders grid renders and filters on this column.
   */
  onHold: Scalars['Boolean']['output'];
  orderEntityId: Scalars['String']['output'];
  orderEntityNumber: Scalars['String']['output'];
  orderEntityType: OrderEntityType;
  /**
   * The id of the order's Order kind. Null for master orders and for orders with none. The Orders grid filters
   * and groups on this id; the kind's name is resolved at query time from the tenant's Order kinds list, so a
   * rename needs no write on the orders.
   */
  orderKindId?: Maybe<Scalars['String']['output']>;
  /** The current name of the order's Order kind, read from the tenant's Order kinds list, so a rename shows at once. Null for a master order, for an order with no kind, and when the kind has been deleted. Filter by kind on orderKindId. */
  orderKindName?: Maybe<Scalars['String']['output']>;
  /**
   * The order's grand total, royalty included. For a customer-portal caller, from whom the royalty is
   * withheld, it is the billed total, the same figure as customerTotal.
   */
  orderTotal: MoneyData;
  orderType: OrderType;
  /**
   * The customer this order or master order belonged to before a customer combine moved it onto the
   * customer it was combined into; null when it was never moved.
   * Set once, so a chain of combines keeps the first customer.
   */
  originalCustomerId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the customer this order or master order belonged to before a customer combine moved
   * it, as that customer was named when combined; null when it was never moved. What the screens show
   * as "from <original name>".
   */
  originalCustomerName?: Maybe<Scalars['String']['output']>;
  /**
   * The ship-to location id this order or master order named before a combine moved it onto the ship-to
   * it was combined into and re-pointed locations.id; null when it was never moved. Set once, so a
   * chain of combines keeps the first ship-to.
   */
  originalLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * The ship-to address id this order or master order named before the same combine re-pointed
   * locations.address.id; null when it was never moved.
   */
  originalShipToId?: Maybe<Scalars['String']['output']>;
  /**
   * The order's payment standing. Once a LIVE invoice stands against the order this reports that
   * invoice's standing, because the bill is then what the customer owes; with no live invoice — never
   * billed, or every bill withdrawn — it reports the order's own payment-status rollup, derived on the
   * order when a payment is applied. Master orders have no payment ledger and are never billed, so they
   * are always UNPAID.
   *
   * ONE STORED READING, WRITTEN BY WHICHEVER AGGREGATE OWNS THE MONEY. The order's own payment events
   * write it while the order is unbilled; the INVOICE's events overwrite it from the moment a bill is
   * issued. Filtering and sorting therefore select by exactly what this field publishes — there is no
   * longer a per-row derivation for a server-side predicate to miss.
   */
  paymentStatus: PaymentStatus;
  poNumber: Scalars['String']['output'];
  produceAllocate?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The order's Program, a name from the tenant's Programs list. Null for master orders, which carry none, and
   * for orders with none. The Orders grid renders, sorts, filters and groups on this column.
   */
  program?: Maybe<Scalars['String']['output']>;
  pullNotes?: Maybe<Scalars['String']['output']>;
  /**
   * Staff only; refused for customer-portal callers.
   * Why the last QuickBooks export attempt did not get there. Null unless quickBooksExportStatus is
   * FAILED, and for every master order. Output only.
   */
  quickBooksExportError?: Maybe<Scalars['String']['output']>;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether the invoice raised against this order reached QuickBooks. NOT_EXPORTED for an order that has
   * never been billed, for a tenant with no accounting integration, for every master order, and for an
   * order whose export row is the legacy ORDER export rather than an invoice export. Stored, filterable
   * and sortable.
   */
  quickBooksExportStatus: QuickBooksExportStatus;
  /**
   * Staff only; refused for customer-portal callers.
   * The id QuickBooks gave the invoice raised against this order. Null until an export has succeeded, and
   * for every master order. Output only.
   */
  quickBooksRemoteInvoiceId?: Maybe<Scalars['String']['output']>;
  /**
   * The last day the order's quote is valid, as a tenant-local date, mirrored from the order's
   * quoteValidUntil. Null for master orders and for orders with none set. The Fulfill Orders grid
   * renders, sorts and filters on this column.
   */
  quoteValidUntil?: Maybe<Scalars['LocalDate']['output']>;
  /** Order-level route override (tier 1), served straight from storage. */
  route?: Maybe<Scalars['String']['output']>;
  salesPerson?: Maybe<Scalars['String']['output']>;
  scheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The order's structured ship-from site (WorkSuite-native SiteLocationId), mirrored from
   * ShipFromSiteLocationId. Empty for master orders and for orders with no
   * ship-from site. Powers the Fulfill Orders grid's Ship-From Site id filter.
   */
  shipFromSiteLocationId: Scalars['String']['output'];
  /**
   * Denormalized ship-from site display name, mirrored from
   * ShipFromSiteName. Empty for master orders and for orders with no
   * ship-from site. The Fulfill Orders grid renders, sorts, filters, and groups on this column.
   */
  shipFromSiteName: Scalars['String']['output'];
  shipNotes?: Maybe<Scalars['String']['output']>;
  shippedDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Where the order was created from. Set once when the order is created and never changed afterwards.
   * Orders created before this field existed, and orders whose origin was never recorded, read as
   * UNKNOWN — that value is never guessed at. Master orders have no creation entry point of their
   * own and are always UNKNOWN. The Fulfill Orders grid renders, sorts, and filters on this column.
   */
  source: OrderSource;
  status: OrderStatus;
  /**
   * First moment the order entered an active status; null for master orders, drafts, and orders
   * re-opened since.
   */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  syncDate?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  termsId?: Maybe<Scalars['String']['output']>;
  termsName?: Maybe<Scalars['String']['output']>;
  termsTermLimitDays?: Maybe<Scalars['Int']['output']>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC, copied from the
   * order's persisted WeekNumber. Null for master orders and for
   * orders that have no expected delivery date.
   */
  weekNumber?: Maybe<Scalars['Int']['output']>;
};

export type CombinedOrderDocumentFilterInput = {
  /**
   * Order-level allocation rollup mirrored from the order document's allocation rollup, so the
   * Fulfill Orders grid can answer "which orders still need allocating?" without opening each order.
   * Null for master orders (no lines, so no allocation rollup) and, on an order, when no allocation
   * status has been derived for it yet — deliberately a different answer from NOT_STARTED.
   */
  allocationStatus?: InputMaybe<NullableOfOrderAllocationStatusOperationFilterInput>;
  /**
   * What has been received against the order. Once a LIVE invoice stands against it this is the cash
   * recorded on that invoice; otherwise it is the order's own amount-paid rollup — every payment and
   * deposit applied to the order — which is null until the first one is applied. Always null for master
   * orders. Written by the same two sources as paymentStatus, and filterable and sortable for the same
   * reason.
   */
  amountPaid?: InputMaybe<OptionOfMoneyDataFilterInput>;
  and?: InputMaybe<Array<CombinedOrderDocumentFilterInput>>;
  /**
   * The order's outstanding balance. Once a LIVE invoice stands against it this is that invoice's open
   * balance; otherwise it is the order's own balance rollup, which is NULL until the first payment is
   * applied and is always null for a master order. A null balance means nothing has been recorded
   * against the order yet — it is NOT a zero balance, and rendering it as 0 asserts the order is settled
   * when it may never even have been billed. Voiding the only live bill returns it to null for exactly
   * that reason. Written by the same two sources as paymentStatus, and filterable and sortable for the
   * same reason.
   */
  balance?: InputMaybe<OptionOfMoneyDataFilterInput>;
  billingAddress?: InputMaybe<AddressDataFilterInput>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  /**
   * What the customer is billed: orderTotal without the royalty, the same figure the invoice
   * shows. Equals orderTotal when the order carries no royalty, has an override total, or is a
   * master order, and always for a customer-portal caller, who is given the billed total in both.
   */
  customerTotal?: InputMaybe<MoneyDataFilterInput>;
  /**
   * Denormalized effective route (tier 1 → ship-to snapshot → inherited customer-location →
   * customer → tenant-default), stamped at projection-write time. Served straight from storage so
   * the grid sorts / filters / groups on it without per-row resolution.
   */
  effectiveRoute?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  expectedDeliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  finalCredit?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The sum of the order's named flat charges, inside orderTotal beside freightAmount. Null
   * on an order that never carried a charge, and on a master order.
   */
  flatChargesAmount?: InputMaybe<MoneyDataFilterInput>;
  /**
   * The day the order's quote follow-up is due, as a tenant-local date, mirrored from the order's
   * follow-up. Null for master orders and for orders with no follow-up, and always null for a
   * customer-portal caller, whose combinedOrders or agGridRows request that filters or sorts on it is
   * refused with GRID_COLUMN_STAFF_ONLY. Carries the day only, and stays set once the follow-up is done
   * or stopped by a move of the order out of draft (a submit, an acknowledge, a ship or a load
   * dispatch); quoteFollowUpsDue is the list of follow-ups that still remind. The
   * Fulfill Orders grid renders, sorts and filters on this column.
   */
  followUpOn?: InputMaybe<LocalDateOperationFilterInput>;
  /** The computed freight dollar amount applied to the order. */
  freightAmount?: InputMaybe<MoneyDataFilterInput>;
  /** The freight charge type applied to the order. */
  freightChargeType?: InputMaybe<IntOperationFilterInput>;
  /**
   * Order-level make-to-order rollup mirrored from hasMakeToOrderLine;
   * the Produce order-allocation queue filters on this (replacing produceAllocate).
   * Null for master orders, which carry no lines.
   */
  hasMakeToOrderLine?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Why the order is held, as staff entered it. Empty for an order that is not held and for a master
   * order, and always empty for a customer-portal caller, whose request that filters or sorts on it is
   * refused with GRID_COLUMN_STAFF_ONLY.
   */
  holdReason?: InputMaybe<StringOperationFilterInput>;
  initializedDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The id of the invoice invoiceNumber names, for linking to the bill. Null for an order that
   * has never been billed, and for every master order. Output only — nothing filters, sorts or groups on
   * an opaque key.
   */
  invoiceId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The invoice number of the bill raised against this order — what a person calls it. The ACTIVE bill's
   * number where one still stands, and the most recently withdrawn bill's where every bill has been.
   * Null for an order that has never been billed, and for every master order. Stored, filterable and
   * sortable.
   */
  invoiceNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether this order has been billed. INVOICED means a live invoice stands against it — what the
   * customer owes on this order is then that bill's business, and this row's balance and paymentStatus
   * are reported from it. VOIDED means the order was billed and every bill against it has since been
   * withdrawn, which is a different fact from never having been billed at all. NOT_INVOICED means no
   * invoice has ever been raised, and is also how a master order reads — a master order carries no lines
   * and is never billed.
   *
   * STORED ON THE ORDER, written by the projection from the invoice's own events, so it is filterable
   * and sortable and a filter selects exactly the rows that read that way. UNKNOWN is never produced: it
   * is what a row predating this field reads as, and it is not a claim that the order has never been
   * billed.
   */
  invoiceStatus?: InputMaybe<OrderInvoiceStatusOperationFilterInput>;
  /**
   * When an allocate or deallocate was last applied, mirrored from the order document's allocation
   * timestamp. Null for master orders and for any order never allocated against.
   */
  lastAllocatedDate?: InputMaybe<DateTimeOperationFilterInput>;
  locations?: InputMaybe<OrderLocationDocumentDataFilterInput>;
  numberOfLines?: InputMaybe<IntOperationFilterInput>;
  /**
   * Whether the order is on hold. False for an order that was never held or whose hold was released, and
   * for a master order, which cannot be held. Always false for a customer-portal caller, whose
   * combinedOrders or agGridRows request that filters or sorts on it is refused with
   * GRID_COLUMN_STAFF_ONLY. The Fulfill Orders grid renders and filters on this column.
   */
  onHold?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CombinedOrderDocumentFilterInput>>;
  orderEntityId?: InputMaybe<StringOperationFilterInput>;
  orderEntityNumber?: InputMaybe<StringOperationFilterInput>;
  orderEntityType?: InputMaybe<OrderEntityTypeOperationFilterInput>;
  /**
   * The id of the order's Order kind. Null for master orders and for orders with none. The Orders grid filters
   * and groups on this id; the kind's name is resolved at query time from the tenant's Order kinds list, so a
   * rename needs no write on the orders.
   */
  orderKindId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The order's grand total, royalty included. For a customer-portal caller, from whom the royalty is
   * withheld, it is the billed total, the same figure as customerTotal.
   */
  orderTotal?: InputMaybe<MoneyDataFilterInput>;
  orderType?: InputMaybe<OrderTypeOperationFilterInput>;
  /**
   * The customer this order or master order belonged to before a customer combine moved it onto the
   * customer it was combined into; null when it was never moved.
   * Set once, so a chain of combines keeps the first customer.
   */
  originalCustomerId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The name of the customer this order or master order belonged to before a customer combine moved
   * it, as that customer was named when combined; null when it was never moved. What the screens show
   * as "from <original name>".
   */
  originalCustomerName?: InputMaybe<StringOperationFilterInput>;
  /**
   * The ship-to location id this order or master order named before a combine moved it onto the ship-to
   * it was combined into and re-pointed locations.id; null when it was never moved. Set once, so a
   * chain of combines keeps the first ship-to.
   */
  originalLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The ship-to address id this order or master order named before the same combine re-pointed
   * locations.address.id; null when it was never moved.
   */
  originalShipToId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The order's payment standing. Once a LIVE invoice stands against the order this reports that
   * invoice's standing, because the bill is then what the customer owes; with no live invoice — never
   * billed, or every bill withdrawn — it reports the order's own payment-status rollup, derived on the
   * order when a payment is applied. Master orders have no payment ledger and are never billed, so they
   * are always UNPAID.
   *
   * ONE STORED READING, WRITTEN BY WHICHEVER AGGREGATE OWNS THE MONEY. The order's own payment events
   * write it while the order is unbilled; the INVOICE's events overwrite it from the moment a bill is
   * issued. Filtering and sorting therefore select by exactly what this field publishes — there is no
   * longer a per-row derivation for a server-side predicate to miss.
   */
  paymentStatus?: InputMaybe<PaymentStatusOperationFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  produceAllocate?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The order's Program, a name from the tenant's Programs list. Null for master orders, which carry none, and
   * for orders with none. The Orders grid renders, sorts, filters and groups on this column.
   */
  program?: InputMaybe<StringOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * Why the last QuickBooks export attempt did not get there. Null unless quickBooksExportStatus is
   * FAILED, and for every master order. Output only.
   */
  quickBooksExportError?: InputMaybe<StringOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether the invoice raised against this order reached QuickBooks. NOT_EXPORTED for an order that has
   * never been billed, for a tenant with no accounting integration, for every master order, and for an
   * order whose export row is the legacy ORDER export rather than an invoice export. Stored, filterable
   * and sortable.
   */
  quickBooksExportStatus?: InputMaybe<QuickBooksExportStatusOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * The id QuickBooks gave the invoice raised against this order. Null until an export has succeeded, and
   * for every master order. Output only.
   */
  quickBooksRemoteInvoiceId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The last day the order's quote is valid, as a tenant-local date, mirrored from the order's
   * quoteValidUntil. Null for master orders and for orders with none set. The Fulfill Orders grid
   * renders, sorts and filters on this column.
   */
  quoteValidUntil?: InputMaybe<LocalDateOperationFilterInput>;
  /** Order-level route override (tier 1), served straight from storage. */
  route?: InputMaybe<StringOperationFilterInput>;
  salesPerson?: InputMaybe<StringOperationFilterInput>;
  scheduledOrdersCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * The order's structured ship-from site (WorkSuite-native SiteLocationId), mirrored from
   * ShipFromSiteLocationId. Empty for master orders and for orders with no
   * ship-from site. Powers the Fulfill Orders grid's Ship-From Site id filter.
   */
  shipFromSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized ship-from site display name, mirrored from
   * ShipFromSiteName. Empty for master orders and for orders with no
   * ship-from site. The Fulfill Orders grid renders, sorts, filters, and groups on this column.
   */
  shipFromSiteName?: InputMaybe<StringOperationFilterInput>;
  shippedDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Where the order was created from. Set once when the order is created and never changed afterwards.
   * Orders created before this field existed, and orders whose origin was never recorded, read as
   * UNKNOWN — that value is never guessed at. Master orders have no creation entry point of their
   * own and are always UNKNOWN. The Fulfill Orders grid renders, sorts, and filters on this column.
   */
  source?: InputMaybe<OrderSourceOperationFilterInput>;
  status?: InputMaybe<OrderStatusOperationFilterInput>;
  /**
   * First moment the order entered an active status; null for master orders, drafts, and orders
   * re-opened since.
   */
  submittedAt?: InputMaybe<DateTimeOperationFilterInput>;
  syncDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
  termsName?: InputMaybe<StringOperationFilterInput>;
  termsTermLimitDays?: InputMaybe<IntOperationFilterInput>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC, copied from the
   * order's persisted WeekNumber. Null for master orders and for
   * orders that have no expected delivery date.
   */
  weekNumber?: InputMaybe<IntOperationFilterInput>;
};

export type CombinedOrderDocumentSortInput = {
  /**
   * Order-level allocation rollup mirrored from the order document's allocation rollup, so the
   * Fulfill Orders grid can answer "which orders still need allocating?" without opening each order.
   * Null for master orders (no lines, so no allocation rollup) and, on an order, when no allocation
   * status has been derived for it yet — deliberately a different answer from NOT_STARTED.
   */
  allocationStatus?: InputMaybe<SortEnumType>;
  /**
   * What has been received against the order. Once a LIVE invoice stands against it this is the cash
   * recorded on that invoice; otherwise it is the order's own amount-paid rollup — every payment and
   * deposit applied to the order — which is null until the first one is applied. Always null for master
   * orders. Written by the same two sources as paymentStatus, and filterable and sortable for the same
   * reason.
   */
  amountPaid?: InputMaybe<SortEnumType>;
  /**
   * The order's outstanding balance. Once a LIVE invoice stands against it this is that invoice's open
   * balance; otherwise it is the order's own balance rollup, which is NULL until the first payment is
   * applied and is always null for a master order. A null balance means nothing has been recorded
   * against the order yet — it is NOT a zero balance, and rendering it as 0 asserts the order is settled
   * when it may never even have been billed. Voiding the only live bill returns it to null for exactly
   * that reason. Written by the same two sources as paymentStatus, and filterable and sortable for the
   * same reason.
   */
  balance?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<AddressDataSortInput>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  /**
   * What the customer is billed: orderTotal without the royalty, the same figure the invoice
   * shows. Equals orderTotal when the order carries no royalty, has an override total, or is a
   * master order, and always for a customer-portal caller, who is given the billed total in both.
   */
  customerTotal?: InputMaybe<MoneyDataSortInput>;
  /**
   * Denormalized effective route (tier 1 → ship-to snapshot → inherited customer-location →
   * customer → tenant-default), stamped at projection-write time. Served straight from storage so
   * the grid sorts / filters / groups on it without per-row resolution.
   */
  effectiveRoute?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  expectedDeliveryDate?: InputMaybe<SortEnumType>;
  finalCredit?: InputMaybe<SortEnumType>;
  /**
   * The sum of the order's named flat charges, inside orderTotal beside freightAmount. Null
   * on an order that never carried a charge, and on a master order.
   */
  flatChargesAmount?: InputMaybe<MoneyDataSortInput>;
  /**
   * The day the order's quote follow-up is due, as a tenant-local date, mirrored from the order's
   * follow-up. Null for master orders and for orders with no follow-up, and always null for a
   * customer-portal caller, whose combinedOrders or agGridRows request that filters or sorts on it is
   * refused with GRID_COLUMN_STAFF_ONLY. Carries the day only, and stays set once the follow-up is done
   * or stopped by a move of the order out of draft (a submit, an acknowledge, a ship or a load
   * dispatch); quoteFollowUpsDue is the list of follow-ups that still remind. The
   * Fulfill Orders grid renders, sorts and filters on this column.
   */
  followUpOn?: InputMaybe<SortEnumType>;
  /** The computed freight dollar amount applied to the order. */
  freightAmount?: InputMaybe<MoneyDataSortInput>;
  /** The freight charge type applied to the order. */
  freightChargeType?: InputMaybe<SortEnumType>;
  /**
   * Order-level make-to-order rollup mirrored from hasMakeToOrderLine;
   * the Produce order-allocation queue filters on this (replacing produceAllocate).
   * Null for master orders, which carry no lines.
   */
  hasMakeToOrderLine?: InputMaybe<SortEnumType>;
  /**
   * Why the order is held, as staff entered it. Empty for an order that is not held and for a master
   * order, and always empty for a customer-portal caller, whose request that filters or sorts on it is
   * refused with GRID_COLUMN_STAFF_ONLY.
   */
  holdReason?: InputMaybe<SortEnumType>;
  initializedDate?: InputMaybe<SortEnumType>;
  /**
   * The id of the invoice invoiceNumber names, for linking to the bill. Null for an order that
   * has never been billed, and for every master order. Output only — nothing filters, sorts or groups on
   * an opaque key.
   */
  invoiceId?: InputMaybe<SortEnumType>;
  /**
   * The invoice number of the bill raised against this order — what a person calls it. The ACTIVE bill's
   * number where one still stands, and the most recently withdrawn bill's where every bill has been.
   * Null for an order that has never been billed, and for every master order. Stored, filterable and
   * sortable.
   */
  invoiceNumber?: InputMaybe<SortEnumType>;
  /**
   * Whether this order has been billed. INVOICED means a live invoice stands against it — what the
   * customer owes on this order is then that bill's business, and this row's balance and paymentStatus
   * are reported from it. VOIDED means the order was billed and every bill against it has since been
   * withdrawn, which is a different fact from never having been billed at all. NOT_INVOICED means no
   * invoice has ever been raised, and is also how a master order reads — a master order carries no lines
   * and is never billed.
   *
   * STORED ON THE ORDER, written by the projection from the invoice's own events, so it is filterable
   * and sortable and a filter selects exactly the rows that read that way. UNKNOWN is never produced: it
   * is what a row predating this field reads as, and it is not a claim that the order has never been
   * billed.
   */
  invoiceStatus?: InputMaybe<SortEnumType>;
  /**
   * When an allocate or deallocate was last applied, mirrored from the order document's allocation
   * timestamp. Null for master orders and for any order never allocated against.
   */
  lastAllocatedDate?: InputMaybe<SortEnumType>;
  locations?: InputMaybe<OrderLocationDocumentDataSortInput>;
  numberOfLines?: InputMaybe<SortEnumType>;
  /**
   * Whether the order is on hold. False for an order that was never held or whose hold was released, and
   * for a master order, which cannot be held. Always false for a customer-portal caller, whose
   * combinedOrders or agGridRows request that filters or sorts on it is refused with
   * GRID_COLUMN_STAFF_ONLY. The Fulfill Orders grid renders and filters on this column.
   */
  onHold?: InputMaybe<SortEnumType>;
  orderEntityId?: InputMaybe<SortEnumType>;
  orderEntityNumber?: InputMaybe<SortEnumType>;
  orderEntityType?: InputMaybe<SortEnumType>;
  /**
   * The id of the order's Order kind. Null for master orders and for orders with none. The Orders grid filters
   * and groups on this id; the kind's name is resolved at query time from the tenant's Order kinds list, so a
   * rename needs no write on the orders.
   */
  orderKindId?: InputMaybe<SortEnumType>;
  /**
   * The order's grand total, royalty included. For a customer-portal caller, from whom the royalty is
   * withheld, it is the billed total, the same figure as customerTotal.
   */
  orderTotal?: InputMaybe<MoneyDataSortInput>;
  orderType?: InputMaybe<SortEnumType>;
  /**
   * The customer this order or master order belonged to before a customer combine moved it onto the
   * customer it was combined into; null when it was never moved.
   * Set once, so a chain of combines keeps the first customer.
   */
  originalCustomerId?: InputMaybe<SortEnumType>;
  /**
   * The name of the customer this order or master order belonged to before a customer combine moved
   * it, as that customer was named when combined; null when it was never moved. What the screens show
   * as "from <original name>".
   */
  originalCustomerName?: InputMaybe<SortEnumType>;
  /**
   * The ship-to location id this order or master order named before a combine moved it onto the ship-to
   * it was combined into and re-pointed locations.id; null when it was never moved. Set once, so a
   * chain of combines keeps the first ship-to.
   */
  originalLocationId?: InputMaybe<SortEnumType>;
  /**
   * The ship-to address id this order or master order named before the same combine re-pointed
   * locations.address.id; null when it was never moved.
   */
  originalShipToId?: InputMaybe<SortEnumType>;
  /**
   * The order's payment standing. Once a LIVE invoice stands against the order this reports that
   * invoice's standing, because the bill is then what the customer owes; with no live invoice — never
   * billed, or every bill withdrawn — it reports the order's own payment-status rollup, derived on the
   * order when a payment is applied. Master orders have no payment ledger and are never billed, so they
   * are always UNPAID.
   *
   * ONE STORED READING, WRITTEN BY WHICHEVER AGGREGATE OWNS THE MONEY. The order's own payment events
   * write it while the order is unbilled; the INVOICE's events overwrite it from the moment a bill is
   * issued. Filtering and sorting therefore select by exactly what this field publishes — there is no
   * longer a per-row derivation for a server-side predicate to miss.
   */
  paymentStatus?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  produceAllocate?: InputMaybe<SortEnumType>;
  /**
   * The order's Program, a name from the tenant's Programs list. Null for master orders, which carry none, and
   * for orders with none. The Orders grid renders, sorts, filters and groups on this column.
   */
  program?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * Why the last QuickBooks export attempt did not get there. Null unless quickBooksExportStatus is
   * FAILED, and for every master order. Output only.
   */
  quickBooksExportError?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether the invoice raised against this order reached QuickBooks. NOT_EXPORTED for an order that has
   * never been billed, for a tenant with no accounting integration, for every master order, and for an
   * order whose export row is the legacy ORDER export rather than an invoice export. Stored, filterable
   * and sortable.
   */
  quickBooksExportStatus?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * The id QuickBooks gave the invoice raised against this order. Null until an export has succeeded, and
   * for every master order. Output only.
   */
  quickBooksRemoteInvoiceId?: InputMaybe<SortEnumType>;
  /**
   * The last day the order's quote is valid, as a tenant-local date, mirrored from the order's
   * quoteValidUntil. Null for master orders and for orders with none set. The Fulfill Orders grid
   * renders, sorts and filters on this column.
   */
  quoteValidUntil?: InputMaybe<SortEnumType>;
  /** Order-level route override (tier 1), served straight from storage. */
  route?: InputMaybe<SortEnumType>;
  salesPerson?: InputMaybe<SortEnumType>;
  scheduledOrdersCount?: InputMaybe<SortEnumType>;
  /**
   * The order's structured ship-from site (WorkSuite-native SiteLocationId), mirrored from
   * ShipFromSiteLocationId. Empty for master orders and for orders with no
   * ship-from site. Powers the Fulfill Orders grid's Ship-From Site id filter.
   */
  shipFromSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Denormalized ship-from site display name, mirrored from
   * ShipFromSiteName. Empty for master orders and for orders with no
   * ship-from site. The Fulfill Orders grid renders, sorts, filters, and groups on this column.
   */
  shipFromSiteName?: InputMaybe<SortEnumType>;
  shippedDate?: InputMaybe<SortEnumType>;
  /**
   * Where the order was created from. Set once when the order is created and never changed afterwards.
   * Orders created before this field existed, and orders whose origin was never recorded, read as
   * UNKNOWN — that value is never guessed at. Master orders have no creation entry point of their
   * own and are always UNKNOWN. The Fulfill Orders grid renders, sorts, and filters on this column.
   */
  source?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /**
   * First moment the order entered an active status; null for master orders, drafts, and orders
   * re-opened since.
   */
  submittedAt?: InputMaybe<SortEnumType>;
  syncDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
  termsName?: InputMaybe<SortEnumType>;
  termsTermLimitDays?: InputMaybe<SortEnumType>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC, copied from the
   * order's persisted WeekNumber. Null for master orders and for
   * orders that have no expected delivery date.
   */
  weekNumber?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CombinedOrdersConnection = {
  __typename?: 'CombinedOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CombinedOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CombinedOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CombinedOrdersEdge = {
  __typename?: 'CombinedOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CombinedOrderDocument;
};

export type CommandBarDocument = {
  __typename?: 'CommandBarDocument';
  aggregateId: Scalars['String']['output'];
  aggregateType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  optionName: Scalars['String']['output'];
  optionValue: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type CommandBarDocumentFilterInput = {
  aggregateId?: InputMaybe<StringOperationFilterInput>;
  aggregateType?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CommandBarDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  optionName?: InputMaybe<StringOperationFilterInput>;
  optionValue?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CommandBarDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type CommandBarDocumentSortInput = {
  aggregateId?: InputMaybe<SortEnumType>;
  aggregateType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  optionName?: InputMaybe<SortEnumType>;
  optionValue?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CommandBarOptionsConnection = {
  __typename?: 'CommandBarOptionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CommandBarOptionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CommandBarDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommandBarOptionsEdge = {
  __typename?: 'CommandBarOptionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommandBarDocument;
};

/**
 * A user's commission configuration: a default rate plus optional per-customer
 * overrides. The effective rate for a customer is the customer's override when one
 * exists, otherwise the default rate.
 */
export type CommissionConfigDocument = {
  __typename?: 'CommissionConfigDocument';
  /** Same value as the user id — a user has at most one commission config per tenant. */
  commissionConfigId: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  customerOverrides: Array<CustomerCommissionOverrideData>;
  /** The commission rate, as a percent value (0–100), applied when no customer override matches. */
  defaultRatePercent: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/**
 * A user's commission configuration: a default rate plus optional per-customer
 * overrides. The effective rate for a customer is the customer's override when one
 * exists, otherwise the default rate.
 */
export type CommissionConfigDocumentFilterInput = {
  and?: InputMaybe<Array<CommissionConfigDocumentFilterInput>>;
  /** Same value as the user id — a user has at most one commission config per tenant. */
  commissionConfigId?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerOverrides?: InputMaybe<ListFilterInputTypeOfCustomerCommissionOverrideDataFilterInput>;
  /** The commission rate, as a percent value (0–100), applied when no customer override matches. */
  defaultRatePercent?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CommissionConfigDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A user's commission configuration: a default rate plus optional per-customer
 * overrides. The effective rate for a customer is the customer's override when one
 * exists, otherwise the default rate.
 */
export type CommissionConfigDocumentSortInput = {
  /** Same value as the user id — a user has at most one commission config per tenant. */
  commissionConfigId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  /** The commission rate, as a percent value (0–100), applied when no customer override matches. */
  defaultRatePercent?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type CommissionConfigPayload = {
  __typename?: 'CommissionConfigPayload';
  commissionConfig?: Maybe<CommissionConfigDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A connection to a list of items. */
export type CommissionConfigsConnection = {
  __typename?: 'CommissionConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CommissionConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CommissionConfigDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommissionConfigsEdge = {
  __typename?: 'CommissionConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommissionConfigDocument;
};

/** Input for commitGrowPointStagedRows. */
export type CommitGrowPointStagedRowsInput = {
  /**
   * The id the caller allocates before sending. A lost reply is checked by reading this id with
   * growPointCommit; sending it again returns the first result and never queues twice.
   */
  commitId: Scalars['String']['input'];
  /** The staged entity to import. */
  entity: GrowPointStagedEntity;
  /** Every staged row the caller reviewed, with the version it reviewed. */
  rows: Array<GrowPointReviewedRowInput>;
};

/**
 * Result of commitGrowPointStagedRows: the stored commit, queued or rejected with its reason
 * and changed rows. Commit null with a validation error or GROWPOINT_COMMIT_IN_PROGRESS
 * means nothing was stored. Commit null with any other error is an unknown outcome: send the
 * same commitId again or read it with growPointCommit. A queued commit with no
 * triggeredAt was stored but its import trigger was not confirmed (the first reply also
 * carries the error); a repeat does not trigger it again, and it runs the next time RunNow
 * is set for that import worker.
 */
export type CommitGrowPointStagedRowsPayload = {
  __typename?: 'CommitGrowPointStagedRowsPayload';
  commit?: Maybe<GrowPointCommitData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CommitSpaceRebalanceInput = {
  moves: Array<CommitSpaceRebalanceMoveInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CommitSpaceRebalanceMoveInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  toLocationId?: InputMaybe<Scalars['String']['input']>;
  toWeekReadyDate?: InputMaybe<Scalars['DateTime']['input']>;
  toWeekStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommitSpaceRebalancePayload = {
  __typename?: 'CommitSpaceRebalancePayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
};

/** Input for completeAssignmentTask; records the worker's counted quantity. */
export type CompleteAssignmentTaskInput = {
  /** The assignment. */
  assignmentId: Scalars['String']['input'];
  /**
   * The one batch the whole count is on, optional, as countMaterialItem reads its batchCode: a
   * batch-tracked material item's bin then holds that batch alone. There is no plant date or status beside it; to plant
   * the batch, send it as the one part of batches.
   */
  batchCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Every batch the count found, optional, as countMaterialItem reads its batches: the parts add up to
   * completedQty, a part with a null code is stock on the unknown batch, and each part may carry its plant date
   * and status. Sent with batchCode it is refused. A material item that is not batch tracked ignores both, and
   * its completion records none. The count posts in the same append as the completion.
   */
  batches?: InputMaybe<Array<MaterialBinBatchQuantityDataInput>>;
  /** The bin counted. */
  binLocationId: Scalars['String']['input'];
  /** The quantity counted. */
  completedQty: Scalars['Decimal']['input'];
  /** The client's retry-correlation token. */
  idempotentKey: Scalars['String']['input'];
  /** The material item counted. */
  materialItemId: Scalars['String']['input'];
  /** Why the count differs from what was expected, if it does. */
  varianceReasonCode?: InputMaybe<Scalars['Int']['input']>;
};

export type CompleteCountSessionInput = {
  countSessionId: Scalars['String']['input'];
};

export type CompleteDeliveryInput = {
  loadId: Scalars['String']['input'];
};

export type CompleteDepositExportInput = {
  entityId: Scalars['String']['input'];
  mergeJournalEntryId: Scalars['String']['input'];
  mergeJournalEntryRemoteId?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteDuplicateCheckRequestInput = {
  id: Scalars['String']['input'];
};

/**
 * Input for completeM365MailboxConnect. The state is the signed value returned by
 * m365MailboxAuthorizeUrl and is required — it binds the callback to the user who started the
 * connect. The redirectUri is optional and falls back to the configured default redirect URI when
 * omitted. Never carries tenant or user id (those come from the JWT).
 */
export type CompleteM365MailboxConnectInput = {
  code: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type CompleteMergeLinkInput = {
  publicToken: Scalars['String']['input'];
  setup?: InputMaybe<MergeConnectSetupInput>;
};

/**
 * Input for completeMyMultiFactorEnrollment: the secret the caller was handed at start, and
 * the code their authenticator app now shows for it.
 */
export type CompleteMyMultiFactorEnrollmentInput = {
  /** The six-digit code the authenticator app is showing. */
  code: Scalars['String']['input'];
  /** The Base32 secret returned by startMyMultiFactorEnrollment. */
  secretBase32Encoded: Scalars['String']['input'];
};

/** Reports a completed enrollment: the new state, plus the recovery codes FusionAuth issued. */
export type CompleteMyMultiFactorEnrollmentPayload = {
  __typename?: 'CompleteMyMultiFactorEnrollmentPayload';
  errors?: Maybe<Array<ValidationError>>;
  recoveryCodes?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<MyMultiFactorStatus>;
};

export type CompletePaymentExportInput = {
  entityId: Scalars['String']['input'];
  mergePaymentId: Scalars['String']['input'];
};

export type CompleteRampConnectInput = {
  /** The code query parameter Ramp put on the callback URL. */
  code: Scalars['String']['input'];
  /** The state query parameter Ramp put on the callback URL. */
  state: Scalars['String']['input'];
};

export type CompleteTaskInput = {
  taskAssignmentId: Scalars['String']['input'];
};

export type CompleteTenantEmailSenderVerificationInput = {
  senderId: Scalars['String']['input'];
  verificationLink: Scalars['String']['input'];
};

/**
 * The invitation code, and nothing else: the login being completed for is the signed-in
 * subject, and the invitation is whatever the code resolves to.
 */
export type CompleteUserInviteAsSignedInUserInput = {
  code: Scalars['String']['input'];
};

/**
 * Result of completeUserInviteAsSignedInUser. Completed is true when the invitation is
 * now (or already was) used by the signed-in login; NextAction is the invitation's
 * re-evaluated next step either way, so the page renders from the same classification the public
 * lookup uses; Errors carries the typed refusal codes.
 */
export type CompleteUserInviteAsSignedInUserPayload = {
  __typename?: 'CompleteUserInviteAsSignedInUserPayload';
  completed: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ValidationError>>;
  nextAction: UserInviteNextAction;
};

export type ComputeLoadMilesInput = {
  loadId: Scalars['String']['input'];
  mode?: InputMaybe<LoadMilesComputeMode>;
};

/** A connection to a list of items. */
export type ConfigCategoriesConnection = {
  __typename?: 'ConfigCategoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConfigCategoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ConfigCategoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConfigCategoriesEdge = {
  __typename?: 'ConfigCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConfigCategoryDocument;
};

/** MongoDB read model document for config categories. */
export type ConfigCategoryDocument = {
  __typename?: 'ConfigCategoryDocument';
  code: Scalars['String']['output'];
  configCategoryId: Scalars['String']['output'];
  containerConfigIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  defaultSizeUomCode: Scalars['String']['output'];
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * Eaches in one unit of this Shipping UOM. Null only on a pre-cutover row that never stated a
   * count — treat it as "no opinion", never as zero eaches.
   */
  resolvedEachesPerUnit?: Maybe<Scalars['Int']['output']>;
  sizeUomCodes: Array<Scalars['String']['output']>;
  status: ConfigCategoryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** MongoDB read model document for config categories. */
export type ConfigCategoryDocumentFilterInput = {
  and?: InputMaybe<Array<ConfigCategoryDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  configCategoryId?: InputMaybe<StringOperationFilterInput>;
  containerConfigIds?: InputMaybe<ListStringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  defaultSizeUomCode?: InputMaybe<StringOperationFilterInput>;
  eachesPerUnit?: InputMaybe<OptionOfInt32FilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConfigCategoryDocumentFilterInput>>;
  sizeUomCodes?: InputMaybe<ListStringOperationFilterInput>;
  status?: InputMaybe<ConfigCategoryStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for config categories. */
export type ConfigCategoryDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  configCategoryId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  defaultSizeUomCode?: InputMaybe<SortEnumType>;
  eachesPerUnit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** GraphQL payload for config category mutations. */
export type ConfigCategoryPayload = {
  __typename?: 'ConfigCategoryPayload';
  configCategory?: Maybe<ConfigCategoryStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ConfigCategoryStateData = {
  __typename?: 'ConfigCategoryStateData';
  code: Scalars['String']['output'];
  configCategoryId: Scalars['String']['output'];
  containerConfigIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  defaultSizeUomCode: Scalars['String']['output'];
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  sizeUomCodes: Array<Scalars['String']['output']>;
  status: ConfigCategoryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ConfigCategoryStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ConfigCategoryStatusOperationFilterInput = {
  eq?: InputMaybe<ConfigCategoryStatus>;
  in?: InputMaybe<Array<ConfigCategoryStatus>>;
  neq?: InputMaybe<ConfigCategoryStatus>;
  nin?: InputMaybe<Array<ConfigCategoryStatus>>;
};

export type ConfirmAllocationInput = {
  allocationId: Scalars['String']['input'];
  confirmedQty: Scalars['Decimal']['input'];
};

export type ConfirmContractRecordFeeVoidInput = {
  requestId: Scalars['String']['input'];
  stripeInvoiceId: Scalars['String']['input'];
};

/**
 * Input for confirmMyPhoneVerification. The code only. Which number it verifies was fixed when
 * the code was issued and is read off the caller's own aggregate.
 */
export type ConfirmMyPhoneVerificationInput = {
  /** The code as the user typed it. Surrounding whitespace is forgiven. */
  code: Scalars['String']['input'];
};

/**
 * Input of confirmProducedQuantityEntry. Leave quantity and
 * locations out to apply the entry as entered; give either to edit it. An edit is validated
 * the same way as overrideProducedQuantity, so a changed quantity needs a split that still adds up.
 */
export type ConfirmProducedQuantityEntryInput = {
  /** The held entry to confirm. */
  entryId: Scalars['UUID']['input'];
  /** The edited split, or null to keep the entered one. */
  locations?: InputMaybe<Array<ProducedLocationQuantityInput>>;
  /** The job the entry is on. */
  productionJobId: Scalars['String']['input'];
  /** The lot the job belongs to. */
  productionLotId: Scalars['String']['input'];
  /** The edited quantity, or null to keep the entered one. */
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ConfirmReceiptInput = {
  vendorPurchaseOrderId: Scalars['String']['input'];
};

export type ConfirmationEmailData = {
  __typename?: 'ConfirmationEmailData';
  sent: Scalars['DateTime']['output'];
  toEmail: Scalars['String']['output'];
};

export type ConfirmationEmailDataFilterInput = {
  and?: InputMaybe<Array<ConfirmationEmailDataFilterInput>>;
  or?: InputMaybe<Array<ConfirmationEmailDataFilterInput>>;
  sent?: InputMaybe<DateTimeOperationFilterInput>;
  toEmail?: InputMaybe<StringOperationFilterInput>;
};

export type ConfirmationEmailDataSortInput = {
  sent?: InputMaybe<SortEnumType>;
  toEmail?: InputMaybe<SortEnumType>;
};

/** Input for connectOrderEaseIntegration — the supplier-scoped credential pair. */
export type ConnectOrderEaseIntegrationInput = {
  clientKey: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type ConsolidationApplication = {
  __typename?: 'ConsolidationApplication';
  appliedAt: Scalars['DateTime']['output'];
  appliedBy: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  lotsAbsorbed: Scalars['Int']['output'];
  lotsChanged: Scalars['Int']['output'];
  lotsCreated: Scalars['Int']['output'];
  lotsDone: Scalars['Int']['output'];
  lotsMovedToPlan: Scalars['Int']['output'];
  lotsRemoved: Scalars['Int']['output'];
  lotsTotal: Scalars['Int']['output'];
  previewId: Scalars['String']['output'];
  productionPlanIds: Array<Scalars['String']['output']>;
  quantityAfter: Scalars['Int']['output'];
  quantityBefore: Scalars['Int']['output'];
  quantityRemoved: Scalars['Int']['output'];
  rulesVersion: Scalars['Int']['output'];
  scenario: ConsolidationScenario;
  status: ConsolidationApplicationStatus;
  tenantId: Scalars['String']['output'];
  undoneAt?: Maybe<Scalars['DateTime']['output']>;
  undoneBy?: Maybe<Scalars['String']['output']>;
};

export type ConsolidationApplicationLot = {
  __typename?: 'ConsolidationApplicationLot';
  absorbedIntoProductionLotId?: Maybe<Scalars['String']['output']>;
  applicationStatus: ConsolidationApplicationStatus;
  appliedAt: Scalars['DateTime']['output'];
  changes: Array<ConsolidationLotChange>;
  consolidationApplicationId: Scalars['String']['output'];
  lotNumber: Scalars['Int']['output'];
  newLotNumber?: Maybe<Scalars['Int']['output']>;
  newProductionLotId?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  productionPlanIdAfter: Scalars['String']['output'];
  productionPlanIdBefore: Scalars['String']['output'];
  productionPlanIds: Array<Scalars['String']['output']>;
  quantityAfter: Scalars['Int']['output'];
  quantityBefore: Scalars['Int']['output'];
  readyWeekAfter: Scalars['DateTime']['output'];
  readyWeekBefore: Scalars['DateTime']['output'];
  siteLocationIdAfter?: Maybe<Scalars['String']['output']>;
  siteLocationIdBefore?: Maybe<Scalars['String']['output']>;
  startWeekAfter: Scalars['DateTime']['output'];
  startWeekBefore: Scalars['DateTime']['output'];
};

export type ConsolidationApplicationPayload = {
  __typename?: 'ConsolidationApplicationPayload';
  application?: Maybe<ConsolidationApplication>;
  errors?: Maybe<Array<ValidationError>>;
  success: Scalars['Boolean']['output'];
};

export enum ConsolidationApplicationStatus {
  Applied = 'APPLIED',
  Applying = 'APPLYING',
  Failed = 'FAILED',
  RollingBack = 'ROLLING_BACK',
  Undoing = 'UNDOING',
  Undone = 'UNDONE',
  UndoFailed = 'UNDO_FAILED',
  Unknown = 'UNKNOWN'
}

export enum ConsolidationBridgeKind {
  LotsAfter = 'LOTS_AFTER',
  LotsInPlans = 'LOTS_IN_PLANS',
  MovedToLaterPlan = 'MOVED_TO_LATER_PLAN',
  OffsetByExtraDemand = 'OFFSET_BY_EXTRA_DEMAND',
  RemovedShortRuns = 'REMOVED_SHORT_RUNS',
  RoundedUpToMinimum = 'ROUNDED_UP_TO_MINIMUM',
  SkippedCategories = 'SKIPPED_CATEGORIES'
}

export type ConsolidationBridgeLine = {
  __typename?: 'ConsolidationBridgeLine';
  kind: ConsolidationBridgeKind;
  lots: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type ConsolidationCustomerGroupSites = {
  __typename?: 'ConsolidationCustomerGroupSites';
  customerGroupId: Scalars['String']['output'];
  siteLocationIds: Array<Scalars['String']['output']>;
};

export type ConsolidationCustomerGroupSitesInput = {
  customerGroupId: Scalars['String']['input'];
  siteLocationIds: Array<Scalars['String']['input']>;
};

export enum ConsolidationCustomerGrouping {
  Combine = 'COMBINE',
  KeepSeparate = 'KEEP_SEPARATE'
}

export type ConsolidationDemandRules = {
  __typename?: 'ConsolidationDemandRules';
  lastReadyWeek?: Maybe<Scalars['Int']['output']>;
  laterDemandProductionPlanId?: Maybe<Scalars['String']['output']>;
  skipProductionCategoryIds: Array<Scalars['String']['output']>;
};

export type ConsolidationDemandRulesInput = {
  lastReadyWeek?: InputMaybe<Scalars['Int']['input']>;
  laterDemandProductionPlanId?: InputMaybe<Scalars['String']['input']>;
  skipProductionCategoryIds: Array<Scalars['String']['input']>;
};

export enum ConsolidationDirection {
  BackwardOnly = 'BACKWARD_ONLY',
  Both = 'BOTH',
  ForwardOnly = 'FORWARD_ONLY'
}

export enum ConsolidationExtraDemandMode {
  Add = 'ADD',
  AddAndOffset = 'ADD_AND_OFFSET',
  ReplacePlan = 'REPLACE_PLAN'
}

export type ConsolidationExtraDemandRules = {
  __typename?: 'ConsolidationExtraDemandRules';
  enabled: Scalars['Boolean']['output'];
  sources: Array<ConsolidationExtraDemandSource>;
};

export type ConsolidationExtraDemandRulesInput = {
  enabled: Scalars['Boolean']['input'];
  sources: Array<ConsolidationExtraDemandSourceInput>;
};

export type ConsolidationExtraDemandSource = {
  __typename?: 'ConsolidationExtraDemandSource';
  customerGroupIds: Array<Scalars['String']['output']>;
  customerIds: Array<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  mode: ConsolidationExtraDemandMode;
  name: Scalars['String']['output'];
  offsetCustomerGroupId?: Maybe<Scalars['String']['output']>;
  offsetSiteLocationId?: Maybe<Scalars['String']['output']>;
  productionPlanId?: Maybe<Scalars['String']['output']>;
};

export type ConsolidationExtraDemandSourceInput = {
  customerGroupIds: Array<Scalars['String']['input']>;
  customerIds: Array<Scalars['String']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  mode: ConsolidationExtraDemandMode;
  name: Scalars['String']['input'];
  offsetCustomerGroupId?: InputMaybe<Scalars['String']['input']>;
  offsetSiteLocationId?: InputMaybe<Scalars['String']['input']>;
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
};

export type ConsolidationGenusMinimumRules = {
  __typename?: 'ConsolidationGenusMinimumRules';
  enabled: Scalars['Boolean']['output'];
  maxMoveWeeks?: Maybe<Scalars['Int']['output']>;
  minQuantity: Scalars['Int']['output'];
};

export type ConsolidationGenusMinimumRulesInput = {
  enabled: Scalars['Boolean']['input'];
  maxMoveWeeks?: InputMaybe<Scalars['Int']['input']>;
  minQuantity: Scalars['Int']['input'];
};

export enum ConsolidationLastSeasonFallback {
  Category = 'CATEGORY',
  FirstListedSite = 'FIRST_LISTED_SITE'
}

export enum ConsolidationLastSeasonMatch {
  Category = 'CATEGORY',
  CategoryAndGenus = 'CATEGORY_AND_GENUS',
  Item = 'ITEM'
}

export type ConsolidationLastSeasonRule = {
  __typename?: 'ConsolidationLastSeasonRule';
  enabled: Scalars['Boolean']['output'];
  fallback: ConsolidationLastSeasonFallback;
  matchOn: ConsolidationLastSeasonMatch;
  minSharePercent?: Maybe<Scalars['Decimal']['output']>;
  productionPlanIds: Array<Scalars['String']['output']>;
};

export type ConsolidationLastSeasonRuleInput = {
  enabled: Scalars['Boolean']['input'];
  fallback: ConsolidationLastSeasonFallback;
  matchOn: ConsolidationLastSeasonMatch;
  minSharePercent?: InputMaybe<Scalars['Decimal']['input']>;
  productionPlanIds: Array<Scalars['String']['input']>;
};

export enum ConsolidationLocationGrouping {
  Combine = 'COMBINE',
  KeepSeparate = 'KEEP_SEPARATE'
}

export enum ConsolidationLotChange {
  AbsorbedLots = 'ABSORBED_LOTS',
  BelowMinimum = 'BELOW_MINIMUM',
  ExtraDemand = 'EXTRA_DEMAND',
  Folded = 'FOLDED',
  GenusMoved = 'GENUS_MOVED',
  KeptBoundToOrder = 'KEPT_BOUND_TO_ORDER',
  KeptNoRecipe = 'KEPT_NO_RECIPE',
  KeptPinned = 'KEPT_PINNED',
  KeptPlannerChange = 'KEPT_PLANNER_CHANGE',
  MergedIdentical = 'MERGED_IDENTICAL',
  MovedToLaterPlan = 'MOVED_TO_LATER_PLAN',
  MovedToWindowEnd = 'MOVED_TO_WINDOW_END',
  MovedToWindowStart = 'MOVED_TO_WINDOW_START',
  OffsetByExtraDemand = 'OFFSET_BY_EXTRA_DEMAND',
  RecipeWindowClamped = 'RECIPE_WINDOW_CLAMPED',
  RemovedShortRun = 'REMOVED_SHORT_RUN',
  RemovedSkippedCategory = 'REMOVED_SKIPPED_CATEGORY',
  RolledEarlier = 'ROLLED_EARLIER',
  RolledLater = 'ROLLED_LATER',
  RoundedUp = 'ROUNDED_UP',
  SiteChanged = 'SITE_CHANGED',
  WeekMerged = 'WEEK_MERGED'
}

export enum ConsolidationLotOutcome {
  Absorbed = 'ABSORBED',
  Changed = 'CHANGED',
  MovedToPlan = 'MOVED_TO_PLAN',
  Removed = 'REMOVED',
  Unchanged = 'UNCHANGED'
}

export type ConsolidationMergeRule = {
  __typename?: 'ConsolidationMergeRule';
  earlierWeeks: Scalars['Int']['output'];
  laterWeeks: Scalars['Int']['output'];
  maxTimesMinimum: Scalars['Decimal']['output'];
};

export type ConsolidationMergeRuleInput = {
  earlierWeeks: Scalars['Int']['input'];
  laterWeeks: Scalars['Int']['input'];
  maxTimesMinimum: Scalars['Decimal']['input'];
};

export type ConsolidationMinimumRow = {
  __typename?: 'ConsolidationMinimumRow';
  bySite: Array<ConsolidationSiteMinimum>;
  productionCategoryId: Scalars['String']['output'];
};

export type ConsolidationMinimumRowInput = {
  bySite: Array<ConsolidationSiteMinimumInput>;
  productionCategoryId: Scalars['String']['input'];
};

export type ConsolidationMinimumRunRules = {
  __typename?: 'ConsolidationMinimumRunRules';
  closeEnoughPercent: Scalars['Decimal']['output'];
  enabled: Scalars['Boolean']['output'];
  groupBy: ConsolidationRunGrouping;
  merge: ConsolidationMergeRule;
  minimums: Array<ConsolidationMinimumRow>;
  slowWeeks: ConsolidationSlowWeekRule;
  smallestMinimum: Scalars['Int']['output'];
  smallestMinimumUnit: ConsolidationQuantityUnit;
  stillShort: ConsolidationStillShortRule;
};

export type ConsolidationMinimumRunRulesInput = {
  closeEnoughPercent: Scalars['Decimal']['input'];
  enabled: Scalars['Boolean']['input'];
  groupBy: ConsolidationRunGrouping;
  merge: ConsolidationMergeRuleInput;
  minimums: Array<ConsolidationMinimumRowInput>;
  slowWeeks: ConsolidationSlowWeekRuleInput;
  smallestMinimum: Scalars['Int']['input'];
  smallestMinimumUnit: ConsolidationQuantityUnit;
  stillShort: ConsolidationStillShortRuleInput;
};

export enum ConsolidationMissingWindow {
  Flag = 'FLAG',
  NoLimit = 'NO_LIMIT'
}

export enum ConsolidationMoveDirection {
  Earlier = 'EARLIER',
  Later = 'LATER',
  Nearest = 'NEAREST'
}

export type ConsolidationPlannerChangeGroup = {
  __typename?: 'ConsolidationPlannerChangeGroup';
  firstChangedAt?: Maybe<Scalars['DateTime']['output']>;
  kept: Scalars['Boolean']['output'];
  kind: ConsolidationPlannerChangeKind;
  lastChangedAt?: Maybe<Scalars['DateTime']['output']>;
  lots: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export enum ConsolidationPlannerChangeKind {
  LotsAdded = 'LOTS_ADDED',
  LotsDeleted = 'LOTS_DELETED',
  LotsPinned = 'LOTS_PINNED',
  QuantityChanged = 'QUANTITY_CHANGED',
  SiteChanged = 'SITE_CHANGED',
  WeekChanged = 'WEEK_CHANGED'
}

export type ConsolidationPlannerChangeRules = {
  __typename?: 'ConsolidationPlannerChangeRules';
  keepByDefault: Scalars['Boolean']['output'];
  pinnedNeverMove: Scalars['Boolean']['output'];
};

export type ConsolidationPlannerChangeRulesInput = {
  keepByDefault: Scalars['Boolean']['input'];
  pinnedNeverMove: Scalars['Boolean']['input'];
};

export type ConsolidationPreview = {
  __typename?: 'ConsolidationPreview';
  computeMilliseconds: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  plannerChanges: Array<ConsolidationPlannerChangeGroup>;
  productionPlanIds: Array<Scalars['String']['output']>;
  rulesVersion: Scalars['Int']['output'];
  runs: Array<ConsolidationPreviewRun>;
  scenario: ConsolidationScenario;
  space: Array<ConsolidationSpaceImpact>;
  summary: ConsolidationPreviewSummary;
  windowEdgeNotes: Array<ConsolidationWindowEdgeNote>;
};

/**
 * A single pivot cell — the rolled-up demand for one (row, week) intersection.
 * TotalQty is post-rounding (per the rule set's RoundingUnit). The raw,
 * un-rounded sum is preserved in RawTotalQty for client-side display.
 */
export type ConsolidationPreviewCellData = {
  __typename?: 'ConsolidationPreviewCellData';
  demandEstimated: Scalars['Boolean']['output'];
  efficiencyFlag: ConsolidationPreviewEfficiencyFlag;
  jobCount: Scalars['Int']['output'];
  rawTotalQty: Scalars['Int']['output'];
  sourceJobIds: Array<Scalars['String']['output']>;
  totalQty: Scalars['Int']['output'];
  weekStart: Scalars['DateTime']['output'];
};

/**
 * GraphQL output for the consolidationPreview query. Weeks lists the
 * pivot's column headers in chronological order; Rows contains one row per
 * rollup grouping (granularity controlled by the request's
 * ConsolidationPreviewRollupLevel).
 */
export type ConsolidationPreviewData = {
  __typename?: 'ConsolidationPreviewData';
  rows: Array<ConsolidationPreviewRowData>;
  ruleContext: ConsolidationPreviewRuleSetContextData;
  weeks: Array<Scalars['DateTime']['output']>;
};

/**
 * Indicates how a cell's TotalQty compares to the rule set's
 * MinimumLotQuantity. Empty cells (TotalQty == 0) are treated as
 * BelowMin when the minimum is positive, and AtMin
 * when the minimum is zero.
 */
export enum ConsolidationPreviewEfficiencyFlag {
  AboveMin = 'ABOVE_MIN',
  AtMin = 'AT_MIN',
  BelowMin = 'BELOW_MIN'
}

/**
 * Raw GraphQL input for ValidGetConsolidationPreview. StartWeek
 * and EndWeek are treated as UTC instants; the query aligns each job's
 * DeliveryDate into its ISO-week start (Monday 00:00 UTC) before pivoting.
 */
export type ConsolidationPreviewInput = {
  endWeek: Scalars['DateTime']['input'];
  productionCatalogIds: Array<Scalars['String']['input']>;
  rollupLevel: ConsolidationPreviewRollupLevel;
  startWeek: Scalars['DateTime']['input'];
};

export type ConsolidationPreviewLot = {
  __typename?: 'ConsolidationPreviewLot';
  absorbedIntoProductionLotId?: Maybe<Scalars['String']['output']>;
  boundToOrder: Scalars['Boolean']['output'];
  changes: Array<ConsolidationLotChange>;
  color?: Maybe<Scalars['String']['output']>;
  customerGroupId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  genus?: Maybe<Scalars['String']['output']>;
  lotNumber: Scalars['Int']['output'];
  outcome: ConsolidationLotOutcome;
  pinned: Scalars['Boolean']['output'];
  plannerSiteLocationId?: Maybe<Scalars['String']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  productionPlanIdAfter: Scalars['String']['output'];
  productionPlanIdBefore: Scalars['String']['output'];
  quantityAfter: Scalars['Int']['output'];
  quantityBefore: Scalars['Int']['output'];
  readyWeekAfter: Scalars['DateTime']['output'];
  readyWeekBefore: Scalars['DateTime']['output'];
  rulesSiteLocationId?: Maybe<Scalars['String']['output']>;
  runStatus?: Maybe<ConsolidationRunStatus>;
  series?: Maybe<Scalars['String']['output']>;
  siteLocationIdAfter?: Maybe<Scalars['String']['output']>;
  siteLocationIdBefore?: Maybe<Scalars['String']['output']>;
  startWeekAfter: Scalars['DateTime']['output'];
  startWeekBefore: Scalars['DateTime']['output'];
};

export type ConsolidationPreviewLotsPayload = {
  __typename?: 'ConsolidationPreviewLotsPayload';
  errors?: Maybe<Array<ValidationError>>;
  lots: Array<ConsolidationPreviewLot>;
  success: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

/**
 * Payload-style envelope for consolidationPreview. Read-side queries in
 * this slice surface validation/lookup failures via the same payload contract
 * mutations use (Atlas discipline cd1f708d) rather than throwing, so the client
 * can render an error message inline with the pivot UI.
 */
export type ConsolidationPreviewPayload = {
  __typename?: 'ConsolidationPreviewPayload';
  consolidationPreview?: Maybe<ConsolidationPreviewData>;
  errors?: Maybe<Array<ValidationError>>;
  /**
   * True when the preview was produced without validation/lookup errors. Computed from the
   * payload contents (mirrors the sibling convention, e.g. CycleCountPayload) so clients
   * can branch on success without inspecting the errors array.
   */
  success: Scalars['Boolean']['output'];
};

/**
 * Granularity of the rows in the consolidation preview pivot. Cell emits one
 * row per production catalog, Genus collapses by genus across catalogs, and
 * Category emits one rolled-up row across all requested catalogs.
 */
export enum ConsolidationPreviewRollupLevel {
  Category = 'CATEGORY',
  Cell = 'CELL',
  Genus = 'GENUS'
}

/**
 * A pivot row. ProductionCatalogId is populated only for
 * Cell rows; GenusCode for
 * Genus rows; both are
 * Option`1.None on Category
 * rollups. Cells aligns positionally with Weeks.
 */
export type ConsolidationPreviewRowData = {
  __typename?: 'ConsolidationPreviewRowData';
  categoryGroup?: Maybe<Scalars['String']['output']>;
  cells: Array<ConsolidationPreviewCellData>;
  genusCode?: Maybe<Scalars['String']['output']>;
  level: ConsolidationPreviewRollupLevel;
  productionCatalogId?: Maybe<Scalars['String']['output']>;
};

/**
 * Snapshot of the consolidation rules applied to this preview. Surfaces the values
 * the server actually used so the client can show the same context to operators
 * without re-reading the rule set.
 */
export type ConsolidationPreviewRuleSetContextData = {
  __typename?: 'ConsolidationPreviewRuleSetContextData';
  fromTenantOverride: Scalars['Boolean']['output'];
  minimumLotQuantity: Scalars['Int']['output'];
  roundingUnit?: Maybe<Scalars['Int']['output']>;
};

export type ConsolidationPreviewRun = {
  __typename?: 'ConsolidationPreviewRun';
  containers?: Maybe<Scalars['Int']['output']>;
  genera: Array<Scalars['String']['output']>;
  mergedStartWeeks: Array<Scalars['DateTime']['output']>;
  minimumEaches?: Maybe<Scalars['Int']['output']>;
  productionCategoryId: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  siteLocationId: Scalars['String']['output'];
  slowWeek: Scalars['Boolean']['output'];
  startWeek: Scalars['DateTime']['output'];
  status: ConsolidationRunStatus;
};

export type ConsolidationPreviewSummary = {
  __typename?: 'ConsolidationPreviewSummary';
  bridge: Array<ConsolidationBridgeLine>;
  lotsAfter: Scalars['Int']['output'];
  lotsBefore: Scalars['Int']['output'];
  lotsBoundToOrder: Scalars['Int']['output'];
  lotsKeptAtPlannerSite: Scalars['Int']['output'];
  lotsWithoutRecipe: Scalars['Int']['output'];
  pinnedLots: Scalars['Int']['output'];
  quantityAfter: Scalars['Int']['output'];
  quantityBefore: Scalars['Int']['output'];
  runCount: Scalars['Int']['output'];
  runStatusCounts: Array<ConsolidationRunStatusCount>;
  smallLotUnder: Scalars['Int']['output'];
  smallLotsAfter: Scalars['Int']['output'];
  smallLotsBefore: Scalars['Int']['output'];
  steps: Array<ConsolidationStepImpact>;
  windowEdgeNoteCount: Scalars['Int']['output'];
};

export enum ConsolidationQuantityUnit {
  Containers = 'CONTAINERS',
  Eaches = 'EACHES'
}

export type ConsolidationReadyWindow = {
  __typename?: 'ConsolidationReadyWindow';
  customerGroupId: Scalars['String']['output'];
  firstWeek?: Maybe<Scalars['Int']['output']>;
  genus?: Maybe<Scalars['String']['output']>;
  lastWeek?: Maybe<Scalars['Int']['output']>;
  productionCategoryId: Scalars['String']['output'];
};

export type ConsolidationReadyWindowInput = {
  customerGroupId: Scalars['String']['input'];
  firstWeek?: InputMaybe<Scalars['Int']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  lastWeek?: InputMaybe<Scalars['Int']['input']>;
  productionCategoryId: Scalars['String']['input'];
};

export type ConsolidationReadyWindowRules = {
  __typename?: 'ConsolidationReadyWindowRules';
  enabled: Scalars['Boolean']['output'];
  flagEdgePileUps: Scalars['Boolean']['output'];
  weeksAre: ConsolidationWindowWeeks;
  whenMissing: ConsolidationMissingWindow;
  windows: Array<ConsolidationReadyWindow>;
};

export type ConsolidationReadyWindowRulesInput = {
  enabled: Scalars['Boolean']['input'];
  flagEdgePileUps: Scalars['Boolean']['input'];
  weeksAre: ConsolidationWindowWeeks;
  whenMissing: ConsolidationMissingWindow;
  windows: Array<ConsolidationReadyWindowInput>;
};

/**
 * MongoDB read-model document for a tenant's consolidation rule set. There is exactly
 * one document per tenant; Id equals TenantId today, but
 * use GetDocumentId for all reads/writes so that invariant can evolve
 * without breaking call sites.
 */
export type ConsolidationRuleSetDocument = {
  __typename?: 'ConsolidationRuleSetDocument';
  customerGrouping: ConsolidationCustomerGrouping;
  direction: ConsolidationDirection;
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  locationGrouping: ConsolidationLocationGrouping;
  lookBackWeeks: Scalars['Int']['output'];
  lookForwardWeeks: Scalars['Int']['output'];
  minimumLotQuantity: Scalars['Int']['output'];
  roundingUnit?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['String']['output'];
};

export type ConsolidationRuleSetPayload = {
  __typename?: 'ConsolidationRuleSetPayload';
  consolidationRuleSet?: Maybe<ConsolidationRuleSetStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ConsolidationRuleSetStateData = {
  __typename?: 'ConsolidationRuleSetStateData';
  customerGrouping: ConsolidationCustomerGrouping;
  direction: ConsolidationDirection;
  locationGrouping: ConsolidationLocationGrouping;
  lookBackWeeks: Scalars['Int']['output'];
  lookForwardWeeks: Scalars['Int']['output'];
  minimumLotQuantity: Scalars['Int']['output'];
  roundingUnit?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['String']['output'];
};

export type ConsolidationRules = {
  __typename?: 'ConsolidationRules';
  demand: ConsolidationDemandRules;
  extraDemand: ConsolidationExtraDemandRules;
  genusMinimum: ConsolidationGenusMinimumRules;
  minimumRuns: ConsolidationMinimumRunRules;
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  plannerChanges: ConsolidationPlannerChangeRules;
  productionPlanIds: Array<Scalars['String']['output']>;
  readyWindows: ConsolidationReadyWindowRules;
  savedAt: Scalars['DateTime']['output'];
  savedBy: Scalars['String']['output'];
  siteLocationIds: Array<Scalars['String']['output']>;
  sites: ConsolidationSiteRules;
  smallRuns: ConsolidationSmallRunRules;
  tidyUp: ConsolidationTidyUpRules;
  version: Scalars['Int']['output'];
};

export type ConsolidationRulesVersion = {
  __typename?: 'ConsolidationRulesVersion';
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  savedAt: Scalars['DateTime']['output'];
  savedBy: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum ConsolidationRunGrouping {
  SiteCategoryGenusStartWeek = 'SITE_CATEGORY_GENUS_START_WEEK',
  SiteCategoryStartWeek = 'SITE_CATEGORY_START_WEEK'
}

export enum ConsolidationRunStatus {
  BelowMinimum = 'BELOW_MINIMUM',
  ExtraDemand = 'EXTRA_DEMAND',
  Merged = 'MERGED',
  NoMinimum = 'NO_MINIMUM',
  Ok = 'OK',
  Removed = 'REMOVED'
}

export type ConsolidationRunStatusCount = {
  __typename?: 'ConsolidationRunStatusCount';
  count: Scalars['Int']['output'];
  status: ConsolidationRunStatus;
};

export enum ConsolidationScenario {
  KeepPlannerChanges = 'KEEP_PLANNER_CHANGES',
  RulesOnly = 'RULES_ONLY'
}

export type ConsolidationSiteLimit = {
  __typename?: 'ConsolidationSiteLimit';
  note?: Maybe<Scalars['String']['output']>;
  productionCategoryIds: Array<Scalars['String']['output']>;
  siteLocationId: Scalars['String']['output'];
};

export type ConsolidationSiteLimitInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productionCategoryIds: Array<Scalars['String']['input']>;
  siteLocationId: Scalars['String']['input'];
};

export type ConsolidationSiteMinimum = {
  __typename?: 'ConsolidationSiteMinimum';
  minimumEaches?: Maybe<Scalars['Int']['output']>;
  siteLocationId: Scalars['String']['output'];
};

export type ConsolidationSiteMinimumInput = {
  minimumEaches?: InputMaybe<Scalars['Int']['input']>;
  siteLocationId: Scalars['String']['input'];
};

export type ConsolidationSiteRules = {
  __typename?: 'ConsolidationSiteRules';
  customerGroupSites: Array<ConsolidationCustomerGroupSites>;
  enabled: Scalars['Boolean']['output'];
  lastSeason: ConsolidationLastSeasonRule;
  onlyToSitesWithRecipe: Scalars['Boolean']['output'];
  siteLimits: Array<ConsolidationSiteLimit>;
};

export type ConsolidationSiteRulesInput = {
  customerGroupSites: Array<ConsolidationCustomerGroupSitesInput>;
  enabled: Scalars['Boolean']['input'];
  lastSeason: ConsolidationLastSeasonRuleInput;
  onlyToSitesWithRecipe: Scalars['Boolean']['input'];
  siteLimits: Array<ConsolidationSiteLimitInput>;
};

export type ConsolidationSlowWeekRule = {
  __typename?: 'ConsolidationSlowWeekRule';
  belowPercentOfPeak: Scalars['Decimal']['output'];
  enabled: Scalars['Boolean']['output'];
  minimumPercent: Scalars['Decimal']['output'];
};

export type ConsolidationSlowWeekRuleInput = {
  belowPercentOfPeak: Scalars['Decimal']['input'];
  enabled: Scalars['Boolean']['input'];
  minimumPercent: Scalars['Decimal']['input'];
};

export type ConsolidationSmallRunRules = {
  __typename?: 'ConsolidationSmallRunRules';
  direction: ConsolidationMoveDirection;
  enabled: Scalars['Boolean']['output'];
  keepRolling: Scalars['Boolean']['output'];
  maxMoveWeeks?: Maybe<Scalars['Int']['output']>;
  underQuantity: Scalars['Int']['output'];
  unit: ConsolidationQuantityUnit;
};

export type ConsolidationSmallRunRulesInput = {
  direction: ConsolidationMoveDirection;
  enabled: Scalars['Boolean']['input'];
  keepRolling: Scalars['Boolean']['input'];
  maxMoveWeeks?: InputMaybe<Scalars['Int']['input']>;
  underQuantity: Scalars['Int']['input'];
  unit: ConsolidationQuantityUnit;
};

export type ConsolidationSpaceImpact = {
  __typename?: 'ConsolidationSpaceImpact';
  after: ConsolidationSpacePeak;
  approximate: Scalars['Boolean']['output'];
  before: ConsolidationSpacePeak;
  siteLocationId: Scalars['String']['output'];
  spaceTypeId: Scalars['String']['output'];
  weeks: Array<ConsolidationSpaceWeek>;
};

export type ConsolidationSpacePeak = {
  __typename?: 'ConsolidationSpacePeak';
  peakPercent: Scalars['Decimal']['output'];
  peakWeek?: Maybe<Scalars['DateTime']['output']>;
  weeksOver: Scalars['Int']['output'];
};

export type ConsolidationSpaceWeek = {
  __typename?: 'ConsolidationSpaceWeek';
  after: Scalars['Decimal']['output'];
  before: Scalars['Decimal']['output'];
  capacity: Scalars['Decimal']['output'];
  week: Scalars['DateTime']['output'];
};

export enum ConsolidationStep {
  Demand = 'DEMAND',
  ExtraDemand = 'EXTRA_DEMAND',
  GenusMinimum = 'GENUS_MINIMUM',
  MinimumRuns = 'MINIMUM_RUNS',
  PlannerChanges = 'PLANNER_CHANGES',
  ReadyWindows = 'READY_WINDOWS',
  Sites = 'SITES',
  SmallRuns = 'SMALL_RUNS',
  TidyUp = 'TIDY_UP'
}

export type ConsolidationStepImpact = {
  __typename?: 'ConsolidationStepImpact';
  change: ConsolidationLotChange;
  lots: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  step: ConsolidationStep;
};

export type ConsolidationStillShortRule = {
  __typename?: 'ConsolidationStillShortRule';
  flag: Scalars['Boolean']['output'];
  removeUnderPercentOfSeason?: Maybe<Scalars['Decimal']['output']>;
  roundUp: Scalars['Boolean']['output'];
};

export type ConsolidationStillShortRuleInput = {
  flag: Scalars['Boolean']['input'];
  removeUnderPercentOfSeason?: InputMaybe<Scalars['Decimal']['input']>;
  roundUp: Scalars['Boolean']['input'];
};

export type ConsolidationTidyUpRules = {
  __typename?: 'ConsolidationTidyUpRules';
  foldUnderQuantity: Scalars['Int']['output'];
  mergeIdentical: Scalars['Boolean']['output'];
  sameColorFirst: Scalars['Boolean']['output'];
  takeBiggerLotsCustomerGroup: Scalars['Boolean']['output'];
};

export type ConsolidationTidyUpRulesInput = {
  foldUnderQuantity: Scalars['Int']['input'];
  mergeIdentical: Scalars['Boolean']['input'];
  sameColorFirst: Scalars['Boolean']['input'];
  takeBiggerLotsCustomerGroup: Scalars['Boolean']['input'];
};

export enum ConsolidationWindowEdge {
  End = 'END',
  Start = 'START'
}

export type ConsolidationWindowEdgeNote = {
  __typename?: 'ConsolidationWindowEdgeNote';
  customerGroupId: Scalars['String']['output'];
  edge: ConsolidationWindowEdge;
  genus?: Maybe<Scalars['String']['output']>;
  neighborQuantity?: Maybe<Scalars['Int']['output']>;
  neighborReadyWeek?: Maybe<Scalars['DateTime']['output']>;
  productionCategoryId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  readyWeek: Scalars['DateTime']['output'];
};

export enum ConsolidationWindowWeeks {
  Ready = 'READY',
  Start = 'START'
}

export type ConsumeProductionJobMaterialDataInput = {
  locationId: Scalars['String']['input'];
  lotCode?: InputMaybe<Scalars['String']['input']>;
  materialItemId: Scalars['String']['input'];
  quantityConsumed: Scalars['Decimal']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type ConsumeProductionJobMaterialsEntryInput = {
  consumedMaterials: Array<ConsumeProductionJobMaterialDataInput>;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type ConsumeProductionJobMaterialsResult = {
  __typename?: 'ConsumeProductionJobMaterialsResult';
  /**
   * The orders whose allocations this job's consumption released because it took stock orders held: free stock
   * goes first, then the newest orders' allocations. Only the orders the caller can see under the orders
   * visibility rule are named; otherAffectedOrderCount counts the rest. Empty when nothing was
   * released.
   */
  affectedOrders: Array<InventoryOrderImpactData>;
  errors?: Maybe<Array<ValidationError>>;
  /** How many other released orders there are, which the caller cannot see. */
  otherAffectedOrderCount: Scalars['Int']['output'];
  productionJobId: Scalars['String']['output'];
  productionLot?: Maybe<ProductionLotStateData>;
};

export type ConsumeProductionJobsMaterialsInput = {
  jobs: Array<ConsumeProductionJobMaterialsEntryInput>;
};

export type ConsumeProductionJobsMaterialsPayload = {
  __typename?: 'ConsumeProductionJobsMaterialsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<ConsumeProductionJobMaterialsResult>;
};

export type ConsumedMaterialDataInput = {
  locationId: Scalars['String']['input'];
  lotCode: Scalars['String']['input'];
  materialAllocationId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  quantityConsumed: Scalars['Decimal']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type ContactData = {
  __typename?: 'ContactData';
  emailAddresses: Array<EmailAddressData>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  importId: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumbers: Array<PhoneNumberData>;
  status: ContactStatus;
  title: Scalars['String']['output'];
  type: ContactType;
};

export type ContactDataInput = {
  emailAddresses: Array<EmailAddressDataInput>;
  firstName: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  importId?: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumbers: Array<PhoneNumberDataInput>;
  status?: ContactStatus;
  title: Scalars['String']['input'];
  type: ContactType;
};

export enum ContactStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

/** One (customer, contact, mobile). A mobile with no entry is NOT_AGREED. An expired request reads NOT_AGREED. */
export type ContactTextConsentData = {
  __typename?: 'ContactTextConsentData';
  agreedOn?: Maybe<Scalars['LocalDate']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  contactId: Scalars['UUID']['output'];
  customerId: Scalars['String']['output'];
  /** The last YES request text did not go through. Cleared by the next record. */
  lastTextFailed: Scalars['Boolean']['output'];
  method?: Maybe<ContactTextConsentMethod>;
  phoneNumber: Scalars['String']['output'];
  proofReference?: Maybe<Scalars['String']['output']>;
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  recordedBy?: Maybe<Scalars['String']['output']>;
  /** Set while REPLIED_STOP: the customer must text START to the grower's number. */
  repliedStopAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set while WAITING_FOR_YES. */
  requestExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  status: ContactTextConsentStatus;
  /** Set while STOPPED. */
  stoppedAt?: Maybe<Scalars['DateTime']['output']>;
  wordingVersion?: Maybe<Scalars['Int']['output']>;
};

/** UNKNOWN = 0, SIGNED_FORM = 1, EMAIL = 2, ORDER_FORM = 3, OTHER = 4. */
export enum ContactTextConsentMethod {
  Email = 'EMAIL',
  OrderForm = 'ORDER_FORM',
  Other = 'OTHER',
  SignedForm = 'SIGNED_FORM',
  Unknown = 'UNKNOWN'
}

export type ContactTextConsentPayload = {
  __typename?: 'ContactTextConsentPayload';
  errors?: Maybe<Array<ValidationError>>;
  textConsent?: Maybe<ContactTextConsentData>;
};

/** UNKNOWN = 0, NOT_AGREED = 1, WAITING_FOR_YES = 2, ON = 3, REPLIED_STOP = 4, STOPPED = 5. */
export enum ContactTextConsentStatus {
  NotAgreed = 'NOT_AGREED',
  On = 'ON',
  RepliedStop = 'REPLIED_STOP',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN',
  WaitingForYes = 'WAITING_FOR_YES'
}

export enum ContactType {
  AccountsPayable = 'ACCOUNTS_PAYABLE',
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Sales = 'SALES',
  Support = 'SUPPORT',
  Unknown = 'UNKNOWN'
}

export type ContactTypeOperationFilterInput = {
  eq?: InputMaybe<ContactType>;
  in?: InputMaybe<Array<ContactType>>;
  neq?: InputMaybe<ContactType>;
  nin?: InputMaybe<Array<ContactType>>;
};

/** MongoDB read-model document for a ContainerConfig, populated by the projection service. */
export type ContainerConfigDocument = {
  __typename?: 'ContainerConfigDocument';
  categoryCode: Scalars['String']['output'];
  containerCode: Scalars['String']['output'];
  containerConfigId: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  depth: Scalars['Decimal']['output'];
  height: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  maxLayersPerContainer: Scalars['Int']['output'];
  maxTraysPerLayer: Scalars['Int']['output'];
  parentContainerConfigId?: Maybe<Scalars['String']['output']>;
  shipFactor: Scalars['Int']['output'];
  /**
   * The multiple this configuration ships in, under the name that is replacing Ship Factor
   * (Nathan, 2026-07-17). It is computed on read from the stored Ship Factor value, never
   * stored independently, so the two can never disagree. The old name stays readable until
   * the PWA has moved off it.
   */
  shipIncrement: Scalars['Int']['output'];
  shipMinimum: Scalars['Int']['output'];
  siteCodes: Array<Scalars['String']['output']>;
  sizeUomCode: Scalars['String']['output'];
  status: ContainerConfigStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  /** The container's own weight, stated in weightUnit, or null when none is set. */
  weight?: Maybe<Scalars['Decimal']['output']>;
  /** Unit of the weight. UNKNOWN when no weight is set. */
  weightUnit: WeightUnit;
  width: Scalars['Decimal']['output'];
};

/** MongoDB read-model document for a ContainerConfig, populated by the projection service. */
export type ContainerConfigDocumentFilterInput = {
  and?: InputMaybe<Array<ContainerConfigDocumentFilterInput>>;
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  containerConfigId?: InputMaybe<StringOperationFilterInput>;
  containerName?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  depth?: InputMaybe<DecimalOperationFilterInput>;
  height?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  maxLayersPerContainer?: InputMaybe<IntOperationFilterInput>;
  maxTraysPerLayer?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ContainerConfigDocumentFilterInput>>;
  parentContainerConfigId?: InputMaybe<OptionOfStringFilterInput>;
  shipFactor?: InputMaybe<IntOperationFilterInput>;
  /**
   * The multiple this configuration ships in, under the name that is replacing Ship Factor
   * (Nathan, 2026-07-17). It is computed on read from the stored Ship Factor value, never
   * stored independently, so the two can never disagree. The old name stays readable until
   * the PWA has moved off it.
   */
  shipIncrement?: InputMaybe<IntOperationFilterInput>;
  shipMinimum?: InputMaybe<IntOperationFilterInput>;
  siteCodes?: InputMaybe<ListStringOperationFilterInput>;
  sizeUomCode?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ContainerConfigStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  /** The container's own weight, stated in weightUnit, or null when none is set. */
  weight?: InputMaybe<DecimalOperationFilterInput>;
  /** Unit of the weight. UNKNOWN when no weight is set. */
  weightUnit?: InputMaybe<WeightUnitOperationFilterInput>;
  width?: InputMaybe<DecimalOperationFilterInput>;
};

/** MongoDB read-model document for a ContainerConfig, populated by the projection service. */
export type ContainerConfigDocumentSortInput = {
  categoryCode?: InputMaybe<SortEnumType>;
  containerCode?: InputMaybe<SortEnumType>;
  containerConfigId?: InputMaybe<SortEnumType>;
  containerName?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  depth?: InputMaybe<SortEnumType>;
  height?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxLayersPerContainer?: InputMaybe<SortEnumType>;
  maxTraysPerLayer?: InputMaybe<SortEnumType>;
  parentContainerConfigId?: InputMaybe<SortEnumType>;
  shipFactor?: InputMaybe<SortEnumType>;
  /**
   * The multiple this configuration ships in, under the name that is replacing Ship Factor
   * (Nathan, 2026-07-17). It is computed on read from the stored Ship Factor value, never
   * stored independently, so the two can never disagree. The old name stays readable until
   * the PWA has moved off it.
   */
  shipIncrement?: InputMaybe<SortEnumType>;
  shipMinimum?: InputMaybe<SortEnumType>;
  sizeUomCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  /** The container's own weight, stated in weightUnit, or null when none is set. */
  weight?: InputMaybe<SortEnumType>;
  /** Unit of the weight. UNKNOWN when no weight is set. */
  weightUnit?: InputMaybe<SortEnumType>;
  width?: InputMaybe<SortEnumType>;
};

export type ContainerConfigPayload = {
  __typename?: 'ContainerConfigPayload';
  containerConfig?: Maybe<ContainerConfigStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ContainerConfigStateData = {
  __typename?: 'ContainerConfigStateData';
  categoryCode: Scalars['String']['output'];
  containerCode: Scalars['String']['output'];
  containerConfigId: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  depth: Scalars['Decimal']['output'];
  height: Scalars['Decimal']['output'];
  maxLayersPerContainer: Scalars['Int']['output'];
  maxTraysPerLayer: Scalars['Int']['output'];
  parentContainerConfigId?: Maybe<Scalars['String']['output']>;
  shipFactor: Scalars['Int']['output'];
  shipIncrement: Scalars['Int']['output'];
  shipMinimum: Scalars['Int']['output'];
  siteCodes: Array<Scalars['String']['output']>;
  sizeUomCode: Scalars['String']['output'];
  status: ContainerConfigStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  weight?: Maybe<Scalars['Decimal']['output']>;
  weightUnit: WeightUnit;
  width: Scalars['Decimal']['output'];
};

export enum ContainerConfigStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ContainerConfigStatusOperationFilterInput = {
  eq?: InputMaybe<ContainerConfigStatus>;
  in?: InputMaybe<Array<ContainerConfigStatus>>;
  neq?: InputMaybe<ContainerConfigStatus>;
  nin?: InputMaybe<Array<ContainerConfigStatus>>;
};

/**
 * Aggregated view of a Container backing the Maintenance → Containers tab.
 * Distinct rows per ContainerCode, projected from the ContainerConfig
 * documents that share the same code. Per the 2026-04-09 Items Review,
 * container metadata (name, dimensions) lives on ContainerConfig itself
 * rather than a separate Container aggregate; this query is the read-only
 * distinct view that surfaces in the Containers tab.
 */
export type ContainerRow = {
  __typename?: 'ContainerRow';
  containerCode: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  depth: Scalars['Decimal']['output'];
  height: Scalars['Decimal']['output'];
  status: ContainerConfigStatus;
  updatedAt: Scalars['DateTime']['output'];
  weight?: Maybe<Scalars['Decimal']['output']>;
  weightUnit: WeightUnit;
  width: Scalars['Decimal']['output'];
};

export enum ContractCollectionMethod {
  ChargeAutomatically = 'CHARGE_AUTOMATICALLY',
  SendInvoice = 'SEND_INVOICE',
  Unknown = 'UNKNOWN'
}

export enum ContractFeeNeedsAttentionReason {
  InvalidTaxLocation = 'INVALID_TAX_LOCATION',
  ReadBackMismatch = 'READ_BACK_MISMATCH',
  StripeRejected = 'STRIPE_REJECTED',
  Unknown = 'UNKNOWN',
  VoidedOutOfBand = 'VOIDED_OUT_OF_BAND'
}

export enum ContractFeeStatus {
  NeedsAttention = 'NEEDS_ATTENTION',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  RetryRequired = 'RETRY_REQUIRED',
  Sent = 'SENT'
}

export type ContractFeeStatusOperationFilterInput = {
  eq?: InputMaybe<ContractFeeStatus>;
  in?: InputMaybe<Array<ContractFeeStatus>>;
  neq?: InputMaybe<ContractFeeStatus>;
  nin?: InputMaybe<Array<ContractFeeStatus>>;
};

export type ContractPhaseDataInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  unitAmountCents: Scalars['Int']['input'];
};

/** Read-model shape of one billing-schedule phase. */
export type ContractPhaseDocument = {
  __typename?: 'ContractPhaseDocument';
  endDate: Scalars['DateTime']['output'];
  startDate: Scalars['DateTime']['output'];
  unitAmountCents: Scalars['Int']['output'];
};

/**
 * MongoDB read model for one contract's billing record (Helm 63df59d8). One document per
 * ContractRecord aggregate, keyed by {TenantId}-{RequestId}. Backs the
 * wsapi-admin-pwa screen (list + by-id) and the WorkerService-policy worker callback resolvers,
 * which look the EntityId/TenantId pair up by the public RequestId exactly like
 * markTrialRequestProvisioning resolves TrialRequestDocument.EntityId.
 */
export type ContractRecordDocument = {
  __typename?: 'ContractRecordDocument';
  attester?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  collectionMethod: ContractCollectionMethod;
  completedSteps: Array<ContractRecordStepDocument>;
  daysUntilDue?: Maybe<Scalars['Int']['output']>;
  /** Deterministic stream/entity id — equal to requestId for this aggregate. */
  entityId: Scalars['String']['output'];
  /**
   * The contract's installation-fee lane, or null when the enrollment carried no fee. Nested
   * rather than flattened so the fee's status, generation and step ledger can never be confused
   * with the enrollment's at a call site.
   */
  fee?: Maybe<ContractRecordFeeDocument>;
  generation: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastMarkedForCancellationScheduleId?: Maybe<Scalars['String']['output']>;
  manualInvoiceDelivery: Scalars['Boolean']['output'];
  needsAttentionReason: ContractRecordNeedsAttentionReason;
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  paperReference?: Maybe<Scalars['String']['output']>;
  phases: Array<ContractPhaseDocument>;
  /** Unguessable public id; worker mutations key on this. */
  requestId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status: ContractRecordStatus;
  /** The Stripe schedule the worker last reported a cancel outcome for. */
  stripeCancelledScheduleId?: Maybe<Scalars['String']['output']>;
  /** What the worker did about that schedule — cancelled it, or left an already-released subscription alone. */
  stripeScheduleCancelOutcome: ContractRecordScheduleCancelOutcome;
  /** When the enrollment worker reported back on the Stripe-side cancel of stripeCancelledScheduleId. */
  stripeScheduleCancelledAt?: Maybe<Scalars['DateTime']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionScheduleId?: Maybe<Scalars['String']['output']>;
  submittedAt: Scalars['DateTime']['output'];
  succeededAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * MongoDB read model for one contract's billing record (Helm 63df59d8). One document per
 * ContractRecord aggregate, keyed by {TenantId}-{RequestId}. Backs the
 * wsapi-admin-pwa screen (list + by-id) and the WorkerService-policy worker callback resolvers,
 * which look the EntityId/TenantId pair up by the public RequestId exactly like
 * markTrialRequestProvisioning resolves TrialRequestDocument.EntityId.
 */
export type ContractRecordDocumentFilterInput = {
  and?: InputMaybe<Array<ContractRecordDocumentFilterInput>>;
  /**
   * The contract's installation-fee lane, or null when the enrollment carried no fee. Nested
   * rather than flattened so the fee's status, generation and step ledger can never be confused
   * with the enrollment's at a call site.
   */
  fee?: InputMaybe<ContractRecordFeeDocumentFilterInput>;
  generation?: InputMaybe<IntOperationFilterInput>;
  manualInvoiceDelivery?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ContractRecordDocumentFilterInput>>;
  /** Unguessable public id; worker mutations key on this. */
  requestId?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ContractRecordStatusOperationFilterInput>;
  /** What the worker did about that schedule — cancelled it, or left an already-released subscription alone. */
  stripeScheduleCancelOutcome?: InputMaybe<ContractRecordScheduleCancelOutcomeOperationFilterInput>;
  /** When the enrollment worker reported back on the Stripe-side cancel of stripeCancelledScheduleId. */
  stripeScheduleCancelledAt?: InputMaybe<DateTimeOperationFilterInput>;
  submittedAt?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read model for one contract's billing record (Helm 63df59d8). One document per
 * ContractRecord aggregate, keyed by {TenantId}-{RequestId}. Backs the
 * wsapi-admin-pwa screen (list + by-id) and the WorkerService-policy worker callback resolvers,
 * which look the EntityId/TenantId pair up by the public RequestId exactly like
 * markTrialRequestProvisioning resolves TrialRequestDocument.EntityId.
 */
export type ContractRecordDocumentSortInput = {
  attester?: InputMaybe<SortEnumType>;
  cancelReason?: InputMaybe<SortEnumType>;
  cancelledAt?: InputMaybe<SortEnumType>;
  claimedAt?: InputMaybe<SortEnumType>;
  collectionMethod?: InputMaybe<SortEnumType>;
  daysUntilDue?: InputMaybe<SortEnumType>;
  /** Deterministic stream/entity id — equal to requestId for this aggregate. */
  entityId?: InputMaybe<SortEnumType>;
  /**
   * The contract's installation-fee lane, or null when the enrollment carried no fee. Nested
   * rather than flattened so the fee's status, generation and step ledger can never be confused
   * with the enrollment's at a call site.
   */
  fee?: InputMaybe<ContractRecordFeeDocumentSortInput>;
  generation?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastError?: InputMaybe<SortEnumType>;
  lastMarkedForCancellationScheduleId?: InputMaybe<SortEnumType>;
  manualInvoiceDelivery?: InputMaybe<SortEnumType>;
  needsAttentionReason?: InputMaybe<SortEnumType>;
  nextAttemptAt?: InputMaybe<SortEnumType>;
  paperReference?: InputMaybe<SortEnumType>;
  /** Unguessable public id; worker mutations key on this. */
  requestId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /** The Stripe schedule the worker last reported a cancel outcome for. */
  stripeCancelledScheduleId?: InputMaybe<SortEnumType>;
  /** What the worker did about that schedule — cancelled it, or left an already-released subscription alone. */
  stripeScheduleCancelOutcome?: InputMaybe<SortEnumType>;
  /** When the enrollment worker reported back on the Stripe-side cancel of stripeCancelledScheduleId. */
  stripeScheduleCancelledAt?: InputMaybe<SortEnumType>;
  stripeSubscriptionId?: InputMaybe<SortEnumType>;
  stripeSubscriptionScheduleId?: InputMaybe<SortEnumType>;
  submittedAt?: InputMaybe<SortEnumType>;
  succeededAt?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  verifiedAt?: InputMaybe<SortEnumType>;
};

/**
 * Read-model shape of the installation-fee lane — a standalone Stripe invoice raised at signing.
 * Present only on contracts whose enrollment was submitted with a fee.
 */
export type ContractRecordFeeDocument = {
  __typename?: 'ContractRecordFeeDocument';
  amountCents: Scalars['Int']['output'];
  amountPaidCents?: Maybe<Scalars['Int']['output']>;
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  completedSteps: Array<ContractRecordStepDocument>;
  daysUntilDue: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** The fee's own generation, independent of the enrollment lane's. */
  feeGeneration: Scalars['Int']['output'];
  /** Stripe's hosted invoice page, which is how the grower pays the fee. */
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  needsAttentionReason: ContractFeeNeedsAttentionReason;
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  status: ContractFeeStatus;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  /**
   * The Stripe invoice's tax. Null until a Sent event carries it; a fee sent before this field
   * shipped stays null forever.
   */
  taxCents?: Maybe<Scalars['Long']['output']>;
  /**
   * The Stripe invoice's total. Null until a Sent event carries it; a fee sent before this field
   * shipped stays null forever.
   */
  totalCents?: Maybe<Scalars['Long']['output']>;
  /** When the worker reported the Stripe-side void back. */
  voidConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  voidReason?: Maybe<Scalars['String']['output']>;
  /** Set by the human void. Cancelling the contract's enrollment never sets this. */
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Read-model shape of the installation-fee lane — a standalone Stripe invoice raised at signing.
 * Present only on contracts whose enrollment was submitted with a fee.
 */
export type ContractRecordFeeDocumentFilterInput = {
  and?: InputMaybe<Array<ContractRecordFeeDocumentFilterInput>>;
  or?: InputMaybe<Array<ContractRecordFeeDocumentFilterInput>>;
  status?: InputMaybe<ContractFeeStatusOperationFilterInput>;
};

/**
 * Read-model shape of the installation-fee lane — a standalone Stripe invoice raised at signing.
 * Present only on contracts whose enrollment was submitted with a fee.
 */
export type ContractRecordFeeDocumentSortInput = {
  amountCents?: InputMaybe<SortEnumType>;
  amountPaidCents?: InputMaybe<SortEnumType>;
  claimedAt?: InputMaybe<SortEnumType>;
  daysUntilDue?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  dueDate?: InputMaybe<SortEnumType>;
  /** The fee's own generation, independent of the enrollment lane's. */
  feeGeneration?: InputMaybe<SortEnumType>;
  /** Stripe's hosted invoice page, which is how the grower pays the fee. */
  hostedInvoiceUrl?: InputMaybe<SortEnumType>;
  lastError?: InputMaybe<SortEnumType>;
  needsAttentionReason?: InputMaybe<SortEnumType>;
  nextAttemptAt?: InputMaybe<SortEnumType>;
  paidAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  stripeInvoiceId?: InputMaybe<SortEnumType>;
  /**
   * The Stripe invoice's tax. Null until a Sent event carries it; a fee sent before this field
   * shipped stays null forever.
   */
  taxCents?: InputMaybe<SortEnumType>;
  /**
   * The Stripe invoice's total. Null until a Sent event carries it; a fee sent before this field
   * shipped stays null forever.
   */
  totalCents?: InputMaybe<SortEnumType>;
  /** When the worker reported the Stripe-side void back. */
  voidConfirmedAt?: InputMaybe<SortEnumType>;
  voidReason?: InputMaybe<SortEnumType>;
  /** Set by the human void. Cancelling the contract's enrollment never sets this. */
  voidedAt?: InputMaybe<SortEnumType>;
};

export enum ContractRecordNeedsAttentionReason {
  PastStartDate = 'PAST_START_DATE',
  ReadBackMismatch = 'READ_BACK_MISMATCH',
  StripeRejected = 'STRIPE_REJECTED',
  Unknown = 'UNKNOWN'
}

/** Common payload shape for every ContractRecord mutation. */
export type ContractRecordPayload = {
  __typename?: 'ContractRecordPayload';
  data?: Maybe<ContractRecordDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum ContractRecordScheduleCancelOutcome {
  AlreadyReleased = 'ALREADY_RELEASED',
  Cancelled = 'CANCELLED',
  Unknown = 'UNKNOWN'
}

export type ContractRecordScheduleCancelOutcomeOperationFilterInput = {
  eq?: InputMaybe<ContractRecordScheduleCancelOutcome>;
  in?: InputMaybe<Array<ContractRecordScheduleCancelOutcome>>;
  neq?: InputMaybe<ContractRecordScheduleCancelOutcome>;
  nin?: InputMaybe<Array<ContractRecordScheduleCancelOutcome>>;
};

export enum ContractRecordStatus {
  NeedsAttention = 'NEEDS_ATTENTION',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  RetryRequired = 'RETRY_REQUIRED',
  Succeeded = 'SUCCEEDED',
  Verified = 'VERIFIED'
}

export type ContractRecordStatusOperationFilterInput = {
  eq?: InputMaybe<ContractRecordStatus>;
  in?: InputMaybe<Array<ContractRecordStatus>>;
  neq?: InputMaybe<ContractRecordStatus>;
  nin?: InputMaybe<Array<ContractRecordStatus>>;
};

/** Read-model shape of one idempotently-recorded worker progress step. */
export type ContractRecordStepDocument = {
  __typename?: 'ContractRecordStepDocument';
  completedAt: Scalars['DateTime']['output'];
  stepName: Scalars['String']['output'];
  stripeObjectId?: Maybe<Scalars['String']['output']>;
};

export enum ContractRecordStripeObjectKind {
  Customer = 'CUSTOMER',
  Invoice = 'INVOICE',
  Subscription = 'SUBSCRIPTION',
  SubscriptionSchedule = 'SUBSCRIPTION_SCHEDULE',
  Unknown = 'UNKNOWN'
}

/** A connection to a list of items. */
export type ContractRecordsConnection = {
  __typename?: 'ContractRecordsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContractRecordsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ContractRecordDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContractRecordsEdge = {
  __typename?: 'ContractRecordsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContractRecordDocument;
};

/** The result of convertFeatureFlagOverridesToProducts: the report, the job a real run started, or what stopped it. */
export type ConvertFeatureFlagOverridesToProductsPayload = {
  __typename?: 'ConvertFeatureFlagOverridesToProductsPayload';
  /** Why the call was refused, or null. */
  errors?: Maybe<Array<ValidationError>>;
  /** The job a real run started; null on a dry run or a refusal. */
  jobId?: Maybe<Scalars['String']['output']>;
  /** The report; null only when the call failed before it could plan. */
  report?: Maybe<FeatureFlagProductConversionReport>;
};

export type CorrectAcknowledgedQuantityDataInput = {
  acknowledgedQuantity?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
};

export type CorrectAcknowledgedQuantityItemsInput = {
  items: Array<CorrectAcknowledgedQuantityDataInput>;
  orderId: Scalars['String']['input'];
};

export type CorrectCountedTotalInput = {
  correctionId: Scalars['String']['input'];
  countSessionId: Scalars['String']['input'];
  total: Scalars['Long']['input'];
};

export type CorrectMaterialPriceInput = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedPriceRevision: Scalars['Int']['input'];
  expectedPurchasingRevision?: InputMaybe<Scalars['Int']['input']>;
  materialItemId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  reviewedBaseOnly?: Scalars['Boolean']['input'];
  source?: InputMaybe<ReviewedMaterialPriceSourceInput>;
  supplierRoyaltyPerEach?: InputMaybe<Scalars['String']['input']>;
  supplierRoyaltyStatus: SupplierRoyaltyStatus;
  unitCost: Scalars['String']['input'];
};

export type CorrectOrderInput = {
  creditOrderId?: InputMaybe<Scalars['String']['input']>;
  newCustomerId: Scalars['String']['input'];
  newOrderId?: InputMaybe<Scalars['String']['input']>;
  sourceOrderId: Scalars['String']['input'];
};

/**
 * Payload for the internal wrong-customer correction mutation. Order is the
 * replacement order created for the new customer; CreditOrder is the credit
 * created for the original customer. Both are created atomically — on failure both are null
 * and Errors is populated.
 */
export type CorrectOrderPayload = {
  __typename?: 'CorrectOrderPayload';
  creditOrder?: Maybe<OrderStateData>;
  errors?: Maybe<Array<ValidationError>>;
  order?: Maybe<OrderStateData>;
  stageResult?: Maybe<OrderWriteStageResultData>;
};

/** One superadmin's approval of a run's plan. */
export type CorrectionApprovalData = {
  __typename?: 'CorrectionApprovalData';
  /** When they approved. */
  at: Scalars['DateTime']['output'];
  /** True for the requester's approval, recorded with the plan it approves. */
  automatic: Scalars['Boolean']['output'];
  /** The approving superadmin's email. */
  by: Scalars['String']['output'];
  /** The plan revision they approved. A re-plan voids it. */
  planRevision: Scalars['Int']['output'];
};

/** A registered correction, as the admin page lists it. */
export type CorrectionDefinition = {
  __typename?: 'CorrectionDefinition';
  /** What it fixes and how. */
  description: Scalars['String']['output'];
  /** Name shown to the operator. */
  displayName: Scalars['String']['output'];
  /** What must hold before it runs. */
  guards: Array<CorrectionGuardDefinition>;
  /** Stable upper-case key. */
  key: Scalars['String']['output'];
  /** The fields of one row. */
  rowShape: Array<CorrectionRowField>;
};

/** One named value stored on a run row. */
export type CorrectionFieldData = {
  __typename?: 'CorrectionFieldData';
  /** The field name. */
  name: Scalars['String']['output'];
  /** The value as text. */
  value: Scalars['String']['output'];
};

/** One field of a row supplied to createCorrectionRun. */
export type CorrectionFieldInput = {
  /** The field name, as the correction's row shape names it. */
  name: Scalars['String']['input'];
  /** The value as text, numbers and flags in the invariant culture. */
  value: Scalars['String']['input'];
};

/** A guard of a registered correction, as the admin page shows it. */
export type CorrectionGuardDefinition = {
  __typename?: 'CorrectionGuardDefinition';
  /** What it protects against. */
  description: Scalars['String']['output'];
  /** Stable, upper-snake identifier of the guard. */
  key: Scalars['String']['output'];
};

/** One field of a correction's row shape. */
export type CorrectionRowField = {
  __typename?: 'CorrectionRowField';
  /** The field name, as the typed row record declares it. */
  name: Scalars['String']['output'];
  /** The field's scalar type: String, Int32, Int64, Decimal or Boolean. */
  type: Scalars['String']['output'];
};

/** One row supplied to createCorrectionRun: every field of the correction's row shape, once. */
export type CorrectionRowInput = {
  /** The row's fields. */
  fields: Array<CorrectionFieldInput>;
};

export enum CorrectionRowStatus {
  AlreadyApplied = 'ALREADY_APPLIED',
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Found = 'FOUND',
  Planned = 'PLANNED',
  Stale = 'STALE',
  Unknown = 'UNKNOWN'
}

/** How many of a run's rows are at one status. */
export type CorrectionRowStatusCountData = {
  __typename?: 'CorrectionRowStatusCountData';
  /** How many rows are at it. */
  count: Scalars['Int']['output'];
  /** The row status. */
  status: CorrectionRowStatus;
};

/** What re-measuring one row found, in a run's verify report. */
export type CorrectionRowVerificationData = {
  __typename?: 'CorrectionRowVerificationData';
  /** What was measured. */
  detail: Scalars['String']['output'];
  /** True when the row has its planned after values. */
  holds: Scalars['Boolean']['output'];
  /** The row. */
  rowKey: Scalars['String']['output'];
};

/**
 * One run of one registered correction against one tenant, in CorrectionRuns: the read model of the run's
 * events (its request, plans, approvals, cancel, the results of its executed rows and its verify report), with who
 * and when for each.
 */
export type CorrectionRunDocument = {
  __typename?: 'CorrectionRunDocument';
  /** Every approval given, in order, including ones a later re-plan voided. */
  approvals: Array<CorrectionApprovalData>;
  /** Who cancelled the run, and when. Set only when it is Cancelled. */
  cancelled?: Maybe<CorrectionStampData>;
  /** The registered correction the run executes. */
  correctionKey: Scalars['String']['output'];
  /** When the run was requested. A bare BSON date, so the run lists sort by it. */
  createdAt: Scalars['DateTime']['output'];
  /** The approvals that count: the ones given to the current plan revision. */
  currentApprovals: Array<CorrectionApprovalData>;
  /** Who the last executed chunk of rows was written as (the approver), and when. Not set before one. */
  executed?: Maybe<CorrectionStampData>;
  /** The current plan revision: 0 before the first plan, then one more on every plan. */
  planRevision: Scalars['Int']['output'];
  /** Who saved the current plan, and when. Not set before the first plan. */
  planned?: Maybe<CorrectionStampData>;
  /** Who requested the run, and when its rows were found. */
  requested: CorrectionStampData;
  /** How many different superadmins must approve the current plan, as the run was requested: two, the requester and a peer. */
  requiredApprovals: Scalars['Int']['output'];
  /** How many rows the run has. */
  rowCount: Scalars['Int']['output'];
  /** How many rows are at each status, for the statuses any row is at. */
  rowCounts: Array<CorrectionRowStatusCountData>;
  /** The rows, in the order found or supplied. */
  rows: Array<CorrectionRunRowData>;
  /** The run id, unique across tenants. */
  runId: Scalars['String']['output'];
  /** Where the run is. */
  status: CorrectionRunStatus;
  /** The tenant the run corrects. */
  tenantId: Scalars['String']['output'];
  /** The verify report. Set once every approved row was handled and the run was re-measured. */
  verification?: Maybe<CorrectionVerificationData>;
};

/** A correction run, or the errors that stopped the call. */
export type CorrectionRunPayload = {
  __typename?: 'CorrectionRunPayload';
  /** The run as its stream reads straight after the call. */
  correctionRun?: Maybe<CorrectionRunDocument>;
  /** What stopped the call. */
  errors?: Maybe<Array<ValidationError>>;
};

/** One row of a correction run: its input, its plan and where it is. */
export type CorrectionRunRowData = {
  __typename?: 'CorrectionRunRowData';
  /** The row's values once applied. */
  after: Array<CorrectionFieldData>;
  /** The row's values when it was planned. */
  before: Array<CorrectionFieldData>;
  /** Why the row could not be planned or applied. Set only when its status is Failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** The row's fields, in row-shape order. */
  input: Array<CorrectionFieldData>;
  /** The plan revision that last planned the row; 0 before it is planned. */
  planRevision: Scalars['Int']['output'];
  /** The row's identity within the run. */
  rowKey: Scalars['String']['output'];
  /** Where the row is. */
  status: CorrectionRowStatus;
  /** Every stream the row's plan read, at the version it read. Empty before it is planned. */
  streamVersions: Array<CorrectionStreamVersionData>;
};

export enum CorrectionRunStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Executing = 'EXECUTING',
  Failed = 'FAILED',
  Finding = 'FINDING',
  Planned = 'PLANNED',
  Unknown = 'UNKNOWN',
  Verifying = 'VERIFYING'
}

/** A connection to a list of items. */
export type CorrectionRunsConnection = {
  __typename?: 'CorrectionRunsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CorrectionRunsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CorrectionRunDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CorrectionRunsEdge = {
  __typename?: 'CorrectionRunsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorrectionRunDocument;
};

/** Who did something to a run, and when. */
export type CorrectionStampData = {
  __typename?: 'CorrectionStampData';
  /** When. */
  at: Scalars['DateTime']['output'];
  /** The superadmin's email. */
  by: Scalars['String']['output'];
};

/** The version of one stream a row's plan read. */
export type CorrectionStreamVersionData = {
  __typename?: 'CorrectionStreamVersionData';
  /** The stream read. */
  streamName: Scalars['String']['output'];
  /** The revision of its last event when it was read. */
  version: Scalars['Long']['output'];
};

/** The positive control of a run's verify report. */
export type CorrectionVerificationControlData = {
  __typename?: 'CorrectionVerificationControlData';
  /** What was checked. */
  detail: Scalars['String']['output'];
  /** True when every row the run applied is seen written, under the run's id, in its stream. */
  holds: Scalars['Boolean']['output'];
};

/** A run's verify report: who ran it and when, the positive control and each re-measured row. */
export type CorrectionVerificationData = {
  __typename?: 'CorrectionVerificationData';
  /** When the run was verified. */
  at: Scalars['DateTime']['output'];
  /** The superadmin the run executes as: its approver. */
  by: Scalars['String']['output'];
  /** Whether every row the run applied is seen written in its stream. */
  positiveControl: CorrectionVerificationControlData;
  /** What re-measuring each Applied or AlreadyApplied row found, in run order. */
  rows: Array<CorrectionRowVerificationData>;
};

/**
 * A single step in the cost calculation audit trail, recording what happened at each
 * decision point during cost resolution. Includes a severity-coded message and
 * expandable key-value context for downstream display (e.g., WorkSuite AI explanations).
 */
export type CostCalcStep = {
  __typename?: 'CostCalcStep';
  code: Scalars['String']['output'];
  context: Array<CostCalcStepContextEntry>;
  message: Scalars['String']['output'];
  severity: CostCalcStepSeverity;
};

/**
 * A key-value pair providing additional context for a CostCalcStep.
 * Rendered as expandable detail in the calculation steps modal (e.g., "UnitCost": "$0.12").
 */
export type CostCalcStepContextEntry = {
  __typename?: 'CostCalcStepContextEntry';
  /** Optional entity ID for navigation. Paired with EntityType to build the route. */
  entityId?: Maybe<Scalars['String']['output']>;
  /**
   * Optional entity type hint for navigation (e.g., "ProductionCategory", "SiteLocation").
   * When set, the frontend can render the value as a clickable link.
   */
  entityType?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Severity level for a cost calculation audit step.
 * Used to derive the overall status of a cost resolution result
 * (Error > Warning > Info).
 */
export enum CostCalcStepSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum CostCategory {
  Labor = 'LABOR',
  Material = 'MATERIAL',
  Overhead = 'OVERHEAD'
}

/**
 * One row of a job's cost breakdown grouped by subcategory, summarizing quantity, cost, and
 * (for labor) headcount for the cost records that share that subcategory.
 */
export type CostCategoryBreakdown = {
  __typename?: 'CostCategoryBreakdown';
  /** Combined headcount for the subcategory, or null when no record carries one. */
  headcount?: Maybe<Scalars['Int']['output']>;
  /** Number of cost records aggregated into this row. */
  recordCount: Scalars['Int']['output'];
  /** The subcategory these records were grouped under, or null when unspecified. */
  subcategory?: Maybe<Scalars['String']['output']>;
  /** Total cost of the records in this subcategory. */
  totalCost: Scalars['Decimal']['output'];
  /** Total quantity across the records in this subcategory. */
  totalQuantity: Scalars['Decimal']['output'];
  /** Unit of measure for the quantity, taken from the first record that specifies one. */
  unit?: Maybe<Scalars['String']['output']>;
  /** Cost per unit (total cost divided by total quantity), or null when quantity is zero. */
  unitCost?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * An individual cost line item within a cost category (material, labor, or overhead).
 * Provides a human-readable name for display and a source entity ID for navigation.
 */
export type CostEventResult = {
  __typename?: 'CostEventResult';
  /** Optional additional context describing how the cost was derived. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Human-readable name (e.g., material item name, labor type name, location name). */
  name: Scalars['String']['output'];
  /** Cost per unit for this line item. */
  perUnitCost: Scalars['Decimal']['output'];
  /** The source entity ID, enabling frontend navigation to the originating record. */
  sourceId: Scalars['String']['output'];
  /**
   * The type of entity that SourceId refers to (e.g., "SiteLocation", "MaterialItem",
   * "ProductionCategory", "ProductionTaskEvent"). Enables the frontend to build the correct navigation route
   * without hardcoding source-type inference per cost category.
   */
  sourceType: Scalars['String']['output'];
};

export enum CostSourceType {
  CountC = 'COUNT_C',
  EventsTimeEntry = 'EVENTS_TIME_ENTRY',
  InventoryDrawDown = 'INVENTORY_DRAW_DOWN',
  Manual = 'MANUAL',
  OverheadAllocation = 'OVERHEAD_ALLOCATION',
  PurchaseOrder = 'PURCHASE_ORDER'
}

/**
 * One week of a job's cost timeline, carrying the labor, material, and overhead spend recorded
 * in that UTC week so cost can be charted over the production window.
 */
export type CostTimelineEntry = {
  __typename?: 'CostTimelineEntry';
  /** Labor cost recorded during the week. */
  laborCost: Scalars['Decimal']['output'];
  /** Material cost recorded during the week. */
  materialCost: Scalars['Decimal']['output'];
  /** Overhead cost recorded during the week. */
  overheadCost: Scalars['Decimal']['output'];
  /** Human-readable label for the week, formatted as the week-start date (yyyy-MM-dd). */
  weekLabel: Scalars['String']['output'];
  /** UTC start (Monday) of the week this entry covers. */
  weekStart: Scalars['DateTime']['output'];
};

/** A connection to a list of items. */
export type CountCorrectionHistoryConnection = {
  __typename?: 'CountCorrectionHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CountCorrectionHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CountCorrectionHistoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/**
 * One correction a count session has carried, with the state it has reached. Unlike the session's
 * single pendingCorrection* slot, a row stays readable after the next correction is requested.
 * Order by requestVersion, never by a timestamp.
 */
export type CountCorrectionHistoryDocument = {
  __typename?: 'CountCorrectionHistoryDocument';
  correctionId: Scalars['String']['output'];
  countSessionId: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: CountCorrectionKind;
  /** Why the device refused the correction, verbatim; present only with DeviceRefused. */
  refusalReason?: Maybe<Scalars['String']['output']>;
  /**
   * The session-stream position the request was committed at. THE ORDERING KEY between corrections:
   * a later request always has a higher value.
   */
  requestVersion: Scalars['Int']['output'];
  /** When the correction was requested, server UTC. DISPLAY ONLY — order by requestVersion. */
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Scalars['String']['output'];
  /**
   * The absolute total the device was told. Absent only on a row rebuilt from a session snapshot,
   * which does not carry it.
   */
  resultingTotal?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The state this correction has reached. InFlight means no transport outcome yet, and a row
   * may stay there or in DispatchUnknown for good.
   */
  state: CountCorrectionState;
  /** When the state last changed, server UTC. DISPLAY ONLY — order by version. */
  stateChangedAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
  /**
   * The session-stream position of this row's latest transition; the higher of two copies of one
   * correction is the newer.
   */
  version: Scalars['Int']['output'];
};

/**
 * One correction a count session has carried, with the state it has reached. Unlike the session's
 * single pendingCorrection* slot, a row stays readable after the next correction is requested.
 * Order by requestVersion, never by a timestamp.
 */
export type CountCorrectionHistoryDocumentFilterInput = {
  and?: InputMaybe<Array<CountCorrectionHistoryDocumentFilterInput>>;
  correctionId?: InputMaybe<StringOperationFilterInput>;
  countSessionId?: InputMaybe<StringOperationFilterInput>;
  deviceId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  kind?: InputMaybe<CountCorrectionKindOperationFilterInput>;
  or?: InputMaybe<Array<CountCorrectionHistoryDocumentFilterInput>>;
  /**
   * The session-stream position the request was committed at. THE ORDERING KEY between corrections:
   * a later request always has a higher value.
   */
  requestVersion?: InputMaybe<IntOperationFilterInput>;
  /** When the correction was requested, server UTC. DISPLAY ONLY — order by requestVersion. */
  requestedAt?: InputMaybe<DateTimeOperationFilterInput>;
  requestedBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * The state this correction has reached. InFlight means no transport outcome yet, and a row
   * may stay there or in DispatchUnknown for good.
   */
  state?: InputMaybe<CountCorrectionStateOperationFilterInput>;
  /** When the state last changed, server UTC. DISPLAY ONLY — order by version. */
  stateChangedAt?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The session-stream position of this row's latest transition; the higher of two copies of one
   * correction is the newer.
   */
  version?: InputMaybe<IntOperationFilterInput>;
};

/**
 * One correction a count session has carried, with the state it has reached. Unlike the session's
 * single pendingCorrection* slot, a row stays readable after the next correction is requested.
 * Order by requestVersion, never by a timestamp.
 */
export type CountCorrectionHistoryDocumentSortInput = {
  correctionId?: InputMaybe<SortEnumType>;
  countSessionId?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  /**
   * The session-stream position the request was committed at. THE ORDERING KEY between corrections:
   * a later request always has a higher value.
   */
  requestVersion?: InputMaybe<SortEnumType>;
  /** When the correction was requested, server UTC. DISPLAY ONLY — order by requestVersion. */
  requestedAt?: InputMaybe<SortEnumType>;
  requestedBy?: InputMaybe<SortEnumType>;
  /**
   * The state this correction has reached. InFlight means no transport outcome yet, and a row
   * may stay there or in DispatchUnknown for good.
   */
  state?: InputMaybe<SortEnumType>;
  /** When the state last changed, server UTC. DISPLAY ONLY — order by version. */
  stateChangedAt?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
  /**
   * The session-stream position of this row's latest transition; the higher of two copies of one
   * correction is the newer.
   */
  version?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type CountCorrectionHistoryEdge = {
  __typename?: 'CountCorrectionHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CountCorrectionHistoryDocument;
};

export enum CountCorrectionKind {
  AbsoluteTotal = 'ABSOLUTE_TOTAL',
  SignedDelta = 'SIGNED_DELTA'
}

export type CountCorrectionKindOperationFilterInput = {
  eq?: InputMaybe<CountCorrectionKind>;
  in?: InputMaybe<Array<CountCorrectionKind>>;
  neq?: InputMaybe<CountCorrectionKind>;
  nin?: InputMaybe<Array<CountCorrectionKind>>;
};

/**
 * What the two operator correction mutations answer with. Distinct from
 * CountSessionPayload because a correction call has an outcome of its own to report that
 * the session state cannot carry — see CountCorrectionRecord.
 */
export type CountCorrectionPayload = {
  __typename?: 'CountCorrectionPayload';
  /**
   * The correction record this call refers to — the stored outcome on an identical replay, the new
   * record otherwise. Null only when the call failed before any correction was resolved, in which case
   * errors says why.
   */
  correction?: Maybe<CountCorrectionRecord>;
  /**
   * The session as it stands after this call, which on a replay is the session as it stands NOW — not
   * as it stood when the replayed correction was first made. Null when the call failed.
   */
  countSession?: Maybe<CountSessionStateData>;
  /** Why the call failed, when it did. Populated exactly when the other two are null. */
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * The correction record a correction call refers to: THE STORED OUTCOME ON AN IDENTICAL REPLAY, THE
 * NEW RECORD OTHERWISE.
 */
export type CountCorrectionRecord = {
  __typename?: 'CountCorrectionRecord';
  /** The client-minted id this call presented, echoed back verbatim. */
  correctionId: Scalars['String']['output'];
  /** The device this correction was aimed at. */
  deviceId: Scalars['String']['output'];
  /**
   * Half of the immutable intent — absolute total or signed delta. Pinned at claim time and never
   * updated, so replaying one id with a different intent is refused rather than silently re-aimed.
   */
  kind: CountCorrectionKind;
  /** When the correction was requested, server UTC. DISPLAY ONLY — never order by this. */
  requestedAt: Scalars['DateTime']['output'];
  /**
   * The outcome this correction reached. IN_FLIGHT means a transport outcome is still outstanding and
   * is NOT hub acceptance — never render it as sent, queued, accepted, confirmed or applied.
   * DISPATCH_UNKNOWN is terminal and is never retried under this id; recovery is a NEW correction with
   * a NEW id.
   */
  state: CountCorrectionState;
  /**
   * When the state last changed, server UTC. DISPLAY ONLY — never order by this. While a correction is
   * still in flight this equals requestedAt rather than being null.
   */
  stateChangedAt: Scalars['DateTime']['output'];
  /** The other half of the immutable intent: the total or delta asked for. */
  value: Scalars['Decimal']['output'];
};

export enum CountCorrectionState {
  DeviceRefused = 'DEVICE_REFUSED',
  Dispatched = 'DISPATCHED',
  DispatchRefused = 'DISPATCH_REFUSED',
  DispatchUnknown = 'DISPATCH_UNKNOWN',
  InFlight = 'IN_FLIGHT',
  ReportedSinceRequest = 'REPORTED_SINCE_REQUEST'
}

export type CountCorrectionStateOperationFilterInput = {
  eq?: InputMaybe<CountCorrectionState>;
  in?: InputMaybe<Array<CountCorrectionState>>;
  neq?: InputMaybe<CountCorrectionState>;
  nin?: InputMaybe<Array<CountCorrectionState>>;
};

export type CountMaterialItemInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  batches?: InputMaybe<Array<MaterialBinBatchQuantityDataInput>>;
  countType: MaterialItemCountType;
  countedByUserEmail: Scalars['String']['input'];
  countedRecorded: Scalars['DateTime']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  plantDate?: InputMaybe<Scalars['LocalDate']['input']>;
  plantStatus?: InputMaybe<Scalars['String']['input']>;
  quantityCounted: Scalars['Decimal']['input'];
  reasonCode?: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type CountProductionLinesConnection = {
  __typename?: 'CountProductionLinesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CountProductionLinesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionLineDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CountProductionLinesEdge = {
  __typename?: 'CountProductionLinesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionLineDocument;
};

export type CountReasonData = {
  __typename?: 'CountReasonData';
  code: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a single tick within a count session — the
 * per-tick history feeding audit + analytics. Composite Id is
 * "{CountSessionId}-{SequenceNumber}"; the projection writes one document
 * per CountRegistered event, idempotent under replay because Id is
 * deterministic from the event payload (Atlas accaf08f).
 */
export type CountRegistrationDocument = {
  __typename?: 'CountRegistrationDocument';
  countSessionId: Scalars['String']['output'];
  countedQtyAfter: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  occurredAt: Scalars['DateTime']['output'];
  paceUnitsPerMinute: Scalars['Decimal']['output'];
  /**
   * The quantity this registration applied, SIGNED. Three paths write a row, and all three write
   * the delta they applied: a registerCount increment, which is always positive; a
   * setCountedQuantity absolute correction (the MANUAL path); and a device report arriving
   * through ingestDeviceCount (the DEVICE path). The latter two are NEGATIVE when the
   * session was corrected downward. Read CountedQtyAfter for a running total
   * guaranteed non-negative.
   */
  quantity: Scalars['Decimal']['output'];
  registeredBy: Scalars['String']['output'];
  remainingQty: Scalars['Decimal']['output'];
  sequenceNumber: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a single tick within a count session — the
 * per-tick history feeding audit + analytics. Composite Id is
 * "{CountSessionId}-{SequenceNumber}"; the projection writes one document
 * per CountRegistered event, idempotent under replay because Id is
 * deterministic from the event payload (Atlas accaf08f).
 */
export type CountRegistrationDocumentFilterInput = {
  and?: InputMaybe<Array<CountRegistrationDocumentFilterInput>>;
  countSessionId?: InputMaybe<StringOperationFilterInput>;
  countedQtyAfter?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CountRegistrationDocumentFilterInput>>;
  paceUnitsPerMinute?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The quantity this registration applied, SIGNED. Three paths write a row, and all three write
   * the delta they applied: a registerCount increment, which is always positive; a
   * setCountedQuantity absolute correction (the MANUAL path); and a device report arriving
   * through ingestDeviceCount (the DEVICE path). The latter two are NEGATIVE when the
   * session was corrected downward. Read CountedQtyAfter for a running total
   * guaranteed non-negative.
   */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  registeredBy?: InputMaybe<StringOperationFilterInput>;
  remainingQty?: InputMaybe<DecimalOperationFilterInput>;
  sequenceNumber?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a single tick within a count session — the
 * per-tick history feeding audit + analytics. Composite Id is
 * "{CountSessionId}-{SequenceNumber}"; the projection writes one document
 * per CountRegistered event, idempotent under replay because Id is
 * deterministic from the event payload (Atlas accaf08f).
 */
export type CountRegistrationDocumentSortInput = {
  countSessionId?: InputMaybe<SortEnumType>;
  countedQtyAfter?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  occurredAt?: InputMaybe<SortEnumType>;
  paceUnitsPerMinute?: InputMaybe<SortEnumType>;
  /**
   * The quantity this registration applied, SIGNED. Three paths write a row, and all three write
   * the delta they applied: a registerCount increment, which is always positive; a
   * setCountedQuantity absolute correction (the MANUAL path); and a device report arriving
   * through ingestDeviceCount (the DEVICE path). The latter two are NEGATIVE when the
   * session was corrected downward. Read CountedQtyAfter for a running total
   * guaranteed non-negative.
   */
  quantity?: InputMaybe<SortEnumType>;
  registeredBy?: InputMaybe<SortEnumType>;
  remainingQty?: InputMaybe<SortEnumType>;
  sequenceNumber?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CountRegistrationsConnection = {
  __typename?: 'CountRegistrationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CountRegistrationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CountRegistrationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CountRegistrationsEdge = {
  __typename?: 'CountRegistrationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CountRegistrationDocument;
};

/**
 * MongoDB read-model document for a count session, projected from the Counts event
 * stream into the CountSessions collection. Derived fields
 * (PaceUnitsPerMinute, RemainingQty, LastTickAt) are pre-computed in the entity at
 * command time and carried on the event payload — the projection never recomputes
 * (Atlas accaf08f — Projections Idempotent, No Reads, No Relative Operators).
 */
export type CountSessionDocument = {
  __typename?: 'CountSessionDocument';
  /**
   * What this session has counted so far, in eaches: countedQty containers times the plants one
   * of them holds. Ruling D3: a count records progress only, so this feeds no stock figure. Reads 0
   * when the session's category does not resolve, so show it only when unitLabel is non-empty
   * and it is above 0.
   */
  countedEaches: Scalars['Decimal']['output'];
  countedQty: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  crewSize: Scalars['Int']['output'];
  /**
   * Whether this session's counting device has gone quiet — its last server-observed report is older
   * than the staleness window. True for a session that has never reported. Drives the operator's
   * "device not reporting" banner, and mirrors the guard that refuses to send a correction into
   * silence.
   */
  deviceReportingStale: Scalars['Boolean']['output'];
  /**
   * How many plants ONE of the containers this session counts holds, as its production category states
   * it. Null when the session's category does not resolve, which is a different answer from a category
   * that states 0. For a tooltip explaining a rendered eaches figure, and for previewing an entry an
   * operator has typed but not yet saved; every saved figure on this session already carries its own
   * eaches field. NOT plantsPerPot, which this session also publishes: that one counts plants
   * in a POT and was frozen from the recipe when the run started, while this one counts plants in a
   * CONTAINER and follows the category live, so converting a container figure through
   * plantsPerPot gives a total that is both wrong and stale.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  estimatedMinutesRemaining?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  /**
   * The job's human-readable number, as of session start. Null when the session predates this
   * field, its job could not be resolved at that time, or the job had not yet been assigned a
   * number.
   */
  jobNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * When wsapi last ingested a report from this session's counting device; null when it never has.
   * Written from the event payload on EVERY report, including one whose total did not move.
   */
  lastDeviceReportAt?: Maybe<Scalars['DateTime']['output']>;
  lastTickAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The pace this session is counting at, in eaches per minute: paceUnitsPerMinute containers
   * per minute times the plants one of them holds. Reads 0 for a session that has not moved yet and
   * for one whose category does not resolve, which a client tells apart by unitLabel.
   */
  paceEachesPerMinute: Scalars['Decimal']['output'];
  paceUnitsPerMinute: Scalars['Decimal']['output'];
  pendingCorrectionDeviceId?: Maybe<Scalars['String']['output']>;
  /**
   * The LAST correction requested on this session, flattened onto the document rather than nested.
   * It keeps its terminal state until the next request replaces it, so a value here says nothing
   * about pendency: pendingCorrectionState is the only pendency signal. Every correction,
   * including replaced ones, is in countCorrectionHistory.
   */
  pendingCorrectionId?: Maybe<Scalars['String']['output']>;
  pendingCorrectionKind?: Maybe<CountCorrectionKind>;
  /**
   * Why the DEVICE rejected the pending correction, when it did. Present only alongside
   * DeviceRefused.
   */
  pendingCorrectionRefusalReason?: Maybe<Scalars['String']['output']>;
  pendingCorrectionRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The last correction's state, and the ONLY pendency signal in the slot: terminal states are
   * retained until the next request. InFlight means the claim is taken and the dispatch has
   * not returned — it is NOT an acceptance, and must never be read as one.
   */
  pendingCorrectionState?: Maybe<CountCorrectionState>;
  /** When the pending correction's state last changed, server UTC. DISPLAY ONLY. */
  pendingCorrectionStateChangedAt?: Maybe<Scalars['DateTime']['output']>;
  pendingCorrectionValue?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Monotonic version of the pending correction, incremented on EVERY state transition. THE
   * ORDERING FIELD for a client holding the same correction from two sources.
   */
  pendingCorrectionVersion?: Maybe<Scalars['Int']['output']>;
  plantsPerPot?: Maybe<Scalars['Int']['output']>;
  /**
   * Category of the session's ProductionJob, snapshotted onto CountSessionStarted and
   * projected here so the estimatedMinutesRemaining resolver (CC-WSAPI-B1) can look up
   * the per-category allotted-time baseline for an in-progress session. Empty when unresolved.
   */
  productionCategoryId: Scalars['String']['output'];
  productionCategoryName?: Maybe<Scalars['String']['output']>;
  productionJobId: Scalars['String']['output'];
  productionLineId: Scalars['String']['output'];
  recipeName?: Maybe<Scalars['String']['output']>;
  /**
   * What is left to count, in eaches: remainingQty containers times the plants one of them
   * holds. Reads 0 when the session's category does not resolve, which a client tells apart from a
   * finished run by unitLabel being empty.
   */
  remainingEaches: Scalars['Decimal']['output'];
  remainingQty: Scalars['Decimal']['output'];
  startedAt: Scalars['DateTime']['output'];
  startedBy: Scalars['String']['output'];
  status: CountSessionStatus;
  /**
   * The run target in eaches: targetQty containers times the plants one of them holds. Reads 0
   * when the session's category does not resolve, so show it only when unitLabel is non-empty
   * and it is above 0.
   */
  targetEaches: Scalars['Decimal']['output'];
  targetQty: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
  /**
   * What a grower calls the container this session counts: the label its production category states,
   * or that category's code when it states no label. EMPTY when the session's category does not
   * resolve, which is the signal that none of this session's eaches figures mean anything. Show an
   * eaches figure only when this is non-empty and that figure is above 0.
   */
  unitLabel: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * MongoDB read-model document for a count session, projected from the Counts event
 * stream into the CountSessions collection. Derived fields
 * (PaceUnitsPerMinute, RemainingQty, LastTickAt) are pre-computed in the entity at
 * command time and carried on the event payload — the projection never recomputes
 * (Atlas accaf08f — Projections Idempotent, No Reads, No Relative Operators).
 */
export type CountSessionDocumentFilterInput = {
  and?: InputMaybe<Array<CountSessionDocumentFilterInput>>;
  countedQty?: InputMaybe<DecimalOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  crewSize?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  /**
   * The job's human-readable number, as of session start. Null when the session predates this
   * field, its job could not be resolved at that time, or the job had not yet been assigned a
   * number.
   */
  jobNumber?: InputMaybe<IntOperationFilterInput>;
  lastTickAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CountSessionDocumentFilterInput>>;
  paceUnitsPerMinute?: InputMaybe<DecimalOperationFilterInput>;
  plantsPerPot?: InputMaybe<IntOperationFilterInput>;
  /**
   * Category of the session's ProductionJob, snapshotted onto CountSessionStarted and
   * projected here so the estimatedMinutesRemaining resolver (CC-WSAPI-B1) can look up
   * the per-category allotted-time baseline for an in-progress session. Empty when unresolved.
   */
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryName?: InputMaybe<StringOperationFilterInput>;
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  productionLineId?: InputMaybe<StringOperationFilterInput>;
  recipeName?: InputMaybe<StringOperationFilterInput>;
  remainingQty?: InputMaybe<DecimalOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  startedBy?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<CountSessionStatusOperationFilterInput>;
  targetQty?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for a count session, projected from the Counts event
 * stream into the CountSessions collection. Derived fields
 * (PaceUnitsPerMinute, RemainingQty, LastTickAt) are pre-computed in the entity at
 * command time and carried on the event payload — the projection never recomputes
 * (Atlas accaf08f — Projections Idempotent, No Reads, No Relative Operators).
 */
export type CountSessionDocumentSortInput = {
  countedQty?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  crewSize?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  /**
   * The job's human-readable number, as of session start. Null when the session predates this
   * field, its job could not be resolved at that time, or the job had not yet been assigned a
   * number.
   */
  jobNumber?: InputMaybe<SortEnumType>;
  lastTickAt?: InputMaybe<SortEnumType>;
  paceUnitsPerMinute?: InputMaybe<SortEnumType>;
  plantsPerPot?: InputMaybe<SortEnumType>;
  /**
   * Category of the session's ProductionJob, snapshotted onto CountSessionStarted and
   * projected here so the estimatedMinutesRemaining resolver (CC-WSAPI-B1) can look up
   * the per-category allotted-time baseline for an in-progress session. Empty when unresolved.
   */
  productionCategoryId?: InputMaybe<SortEnumType>;
  productionCategoryName?: InputMaybe<SortEnumType>;
  productionJobId?: InputMaybe<SortEnumType>;
  productionLineId?: InputMaybe<SortEnumType>;
  recipeName?: InputMaybe<SortEnumType>;
  remainingQty?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  startedBy?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  targetQty?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type CountSessionPayload = {
  __typename?: 'CountSessionPayload';
  countSession?: Maybe<CountSessionStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CountSessionStateData = {
  __typename?: 'CountSessionStateData';
  countSessionId: Scalars['String']['output'];
  countedQty: Scalars['Decimal']['output'];
  crewSize: Scalars['Int']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  jobNumber?: Maybe<Scalars['Int']['output']>;
  lastDeviceReportAt?: Maybe<Scalars['DateTime']['output']>;
  lastSequenceNumber: Scalars['Int']['output'];
  lastTickAt?: Maybe<Scalars['DateTime']['output']>;
  pendingCorrection?: Maybe<PendingCountCorrection>;
  plantsPerPot?: Maybe<Scalars['Int']['output']>;
  productionCategoryId: Scalars['String']['output'];
  productionCategoryName?: Maybe<Scalars['String']['output']>;
  productionJobId: Scalars['String']['output'];
  productionLineId: Scalars['String']['output'];
  recentCorrectionIds: Array<Scalars['String']['output']>;
  recipeName?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  startedBy: Scalars['String']['output'];
  status: CountSessionStatus;
  targetQty: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
};

export enum CountSessionStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Paused = 'PAUSED',
  Running = 'RUNNING'
}

export type CountSessionStatusOperationFilterInput = {
  eq?: InputMaybe<CountSessionStatus>;
  in?: InputMaybe<Array<CountSessionStatus>>;
  neq?: InputMaybe<CountSessionStatus>;
  nin?: InputMaybe<Array<CountSessionStatus>>;
};

/** A connection to a list of items. */
export type CountSessionsConnection = {
  __typename?: 'CountSessionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CountSessionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CountSessionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CountSessionsEdge = {
  __typename?: 'CountSessionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CountSessionDocument;
};

export type CreateAdHocVendorPurchaseOrderInput = {
  id: Scalars['String']['input'];
  isUrgent?: Scalars['Boolean']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
  vendorName: Scalars['String']['input'];
};

export type CreateAddress = {
  __typename?: 'CreateAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  stateProvince: Scalars['String']['output'];
  toName: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type CreateAddressFilterInput = {
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CreateAddressFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CreateAddressFilterInput>>;
  stateProvince?: InputMaybe<StringOperationFilterInput>;
  toName?: InputMaybe<StringOperationFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type CreateAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  id: Scalars['String']['input'];
  stateProvince: Scalars['String']['input'];
  toName: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CreateAddressSortInput = {
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  stateProvince?: InputMaybe<SortEnumType>;
  toName?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

export type CreateAllocationLineItemInput = {
  allocatedQuantity: Scalars['Decimal']['input'];
  orderLineItemId: Scalars['String']['input'];
  purchaseOrderLineItemId: Scalars['String']['input'];
};

export type CreateAllocationTemplateInput = {
  allocationType: AllocationType;
  equalizeWeeksOfSupply: Scalars['Boolean']['input'];
  favorHigherWeight: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  mode: AllocationMode;
  name: Scalars['String']['input'];
  priorities: Array<AllocationPriorityDimension>;
  targetWeeksOfSupply?: InputMaybe<Scalars['Decimal']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One material item to count, supplied by the supervisor when creating an
 * assignment. The (item, bin) fan-out is computed server-side by joining the
 * MaterialItemLocationQuantity read model — clients only nominate items.
 */
export type CreateAssignmentItemInput = {
  materialItemId: Scalars['String']['input'];
  overrideQty?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateBlockingRuleInput = {
  blockingRuleId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateCartInput = {
  billToAddressCity: Scalars['String']['input'];
  billToAddressCountry: Scalars['String']['input'];
  billToAddressId: Scalars['String']['input'];
  billToAddressLine1: Scalars['String']['input'];
  billToAddressLine2: Scalars['String']['input'];
  billToAddressStateProvince: Scalars['String']['input'];
  billToAddressToName: Scalars['String']['input'];
  billToAddressZipcode: Scalars['String']['input'];
  cartId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  expectedDeliveryDate: Scalars['DateTime']['input'];
  shipToAddressCity: Scalars['String']['input'];
  shipToAddressCountry: Scalars['String']['input'];
  shipToAddressId: Scalars['String']['input'];
  shipToAddressLine1: Scalars['String']['input'];
  shipToAddressLine2: Scalars['String']['input'];
  shipToAddressStateProvince: Scalars['String']['input'];
  shipToAddressToName: Scalars['String']['input'];
  shipToAddressZipcode: Scalars['String']['input'];
  shopperEmail: Scalars['String']['input'];
  shopperFirstName: Scalars['String']['input'];
  shopperId: Scalars['String']['input'];
  shopperLastName: Scalars['String']['input'];
  shopperPhone: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type CreateCommissionConfigInput = {
  defaultRatePercent: Scalars['Decimal']['input'];
  userId: Scalars['String']['input'];
};

export type CreateConsolidationPreviewInput = {
  productionPlanIds: Array<Scalars['String']['input']>;
  scenario: ConsolidationScenario;
};

export type CreateConsolidationPreviewPayload = {
  __typename?: 'CreateConsolidationPreviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  preview?: Maybe<ConsolidationPreview>;
  success: Scalars['Boolean']['output'];
};

/**
 * Input for createCountAssignment. IdempotentKey is a client-supplied
 * retry-correlation token validated as ValidIdStrict (32-char dashless GUID)
 * at the mutation boundary so clients can use Guid.NewGuid().ToString("N").
 * Dedup is the aggregate's job — StartWithNewEntity rejects duplicate creates
 * on AssignmentId.
 */
export type CreateCountAssignmentInput = {
  assignmentId: Scalars['String']['input'];
  dueBy: Scalars['DateTime']['input'];
  idempotentKey: Scalars['String']['input'];
  items: Array<CreateAssignmentItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  workerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerLocationInput = {
  adGroup: Scalars['String']['input'];
  address: CreateAddressInput;
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  clearUnloadMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  defaultContactId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  globalLocationNumber: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  locationLookupCode?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['String']['input'];
  name: Scalars['String']['input'];
  poRequired?: InputMaybe<Scalars['Boolean']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  receivingEmail?: InputMaybe<Scalars['String']['input']>;
  receivingWindowEnd?: InputMaybe<Scalars['String']['input']>;
  receivingWindowStart?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  salesPeople: Array<SalesPersonDataInput>;
  sendInvoiceEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendOrderEmails?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<CreateCustomerLocationSettingsInput>;
  storeNumber: Scalars['String']['input'];
  termsId?: InputMaybe<Scalars['String']['input']>;
  unloadMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCustomerLocationSettingsInput = {
  notes?: InputMaybe<Array<CreateNoteDataInput>>;
  retailerName: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  ruleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingNotes?: InputMaybe<Scalars['String']['input']>;
  storeClass: Scalars['String']['input'];
  zone: Scalars['String']['input'];
};

export type CreateErpLoadListSessionInput = {
  containerCode: Scalars['String']['input'];
  routes: Array<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  sessionName: Scalars['String']['input'];
  stationCode: Scalars['String']['input'];
};

export type CreateFavoritesListInput = {
  createdBy: Scalars['String']['input'];
  description: Scalars['String']['input'];
  favoritesListId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['Int']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateForecastInput = {
  customerId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  forecastId: Scalars['String']['input'];
  level: ForecastLevel;
  name: Scalars['String']['input'];
  programIds: Array<Scalars['String']['input']>;
  scenarioSlot: ForecastScenarioSlot;
  startDate: Scalars['DateTime']['input'];
  weeklyMetric: ForecastWeeklyMetric;
};

/** Input opening a Draft submission version for a reporting unit and period (contract C7). */
export type CreateGrowerBenchmarkSubmissionDraftInput = {
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Reporting period identifier (for example 2026 or 2026-09). */
  periodId: Scalars['String']['input'];
  /** Reporting unit identifier owned by the caller's firm. */
  reportingUnitId: Scalars['String']['input'];
};

export type CreateInventoryItemCommandInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  itemType: ItemType;
  locationId: Scalars['String']['input'];
  plantDate?: InputMaybe<Scalars['LocalDate']['input']>;
  plantStatus?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Decimal']['input'];
  readyDate?: InputMaybe<Scalars['LocalDate']['input']>;
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  why: Scalars['String']['input'];
};

/**
 * Input for createInvoiceEmailDraft. Carries the order id, plus an optional explicit
 * docType override; the tenant and user come from the caller's JWT (the draft is created in
 * the caller's own mailbox for the caller's own tenant).
 */
export type CreateInvoiceEmailDraftInput = {
  /**
   * Optional, additive override of the resolved default (OrderEmailDocTypeResolution — the
   * order's live issued invoice, else its status). Omitted, the draft resolves exactly the doc type
   * it always has. Supplied, it is honored only when the order accepts it
   * (OrderEmailDocTypeResolution.AllowsExplicit — always the order's own resolved default, and
   * otherwise per OrderStatusExtensions.AllowsExplicitOrderEmailDocType) — e.g. requesting
   * Acknowledgment on a Submitted order, which the default alone would resolve to the invoice.
   */
  docType?: InputMaybe<OrderEmailDocType>;
  /** The order to draft a document for. */
  orderId: Scalars['String']['input'];
};

/**
 * Result of createInvoiceEmailDraft: the created draft's Outlook webLink (so the pwa can
 * deep-link into Outlook) and its Graph draft id on success, or the coded validation error(s) that
 * stopped it. WebLink/DraftId are null on failure.
 */
export type CreateInvoiceEmailDraftPayload = {
  __typename?: 'CreateInvoiceEmailDraftPayload';
  draftId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  webLink?: Maybe<Scalars['String']['output']>;
};

export type CreateJobInput = {
  containerQuantity: Scalars['Int']['input'];
  deliveryDate: Scalars['DateTime']['input'];
  erpId?: Scalars['String']['input'];
  id: Scalars['String']['input'];
  itemErpId?: Scalars['String']['input'];
  itemGenusCode: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
  itemRecordId: Scalars['String']['input'];
  itemUPC: Scalars['String']['input'];
  jobStatus: JobStatus;
  jobType: JobType;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productionQuantity: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  unitOfMeasure: Scalars['String']['input'];
};

export type CreateKitInput = {
  containerCode: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  kitId: Scalars['String']['input'];
  lines: Array<KitLineDataInput>;
  name: Scalars['String']['input'];
  /** @deprecated Ignored. Send siteIds to set the Sites a kit is limited to. */
  siteId?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type CreateLocationInput = {
  erpId?: Scalars['String']['input'];
  id: Scalars['String']['input'];
  locationType: LocationType;
  name: Scalars['String']['input'];
  parentLocationId: Scalars['String']['input'];
  siteParentId?: Scalars['String']['input'];
};

export type CreateMakeToOrderPlanForLinesInput = {
  customerGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Set only when every line's order is for this customer. */
  customerId?: InputMaybe<Scalars['String']['input']>;
  /** 1 to 200 order lines for one production item: one group from makeToOrderPlanPreview. */
  lines: Array<MakeToOrderPlanLineInput>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  preFinished?: Scalars['Boolean']['input'];
  productionItemId: Scalars['String']['input'];
  productionPlanId: Scalars['String']['input'];
  /** Monday of the ready week. Null: Monday of the earliest line's delivery week. */
  readyWeek?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * The result of createMakeToOrderPlanForLines: the id of the one lot planned for every line, or the
 * errors that refused the whole call (nothing is written then).
 */
export type CreateMakeToOrderPlanForLinesPayload = {
  __typename?: 'CreateMakeToOrderPlanForLinesPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLotId?: Maybe<Scalars['String']['output']>;
};

export type CreateMakeToOrderPlanInput = {
  containerQuantity?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  orderLineId: Scalars['String']['input'];
  preFinished?: Scalars['Boolean']['input'];
  productionItemId?: InputMaybe<Scalars['String']['input']>;
  productionPlanId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

/**
 * The result of createMakeToOrderPlan: the minted lot plus the unit conversion it was sized
 * with, so the Create Plan dialog can show what was actually planned and reserved.
 */
export type CreateMakeToOrderPlanPayload = {
  __typename?: 'CreateMakeToOrderPlanPayload';
  /** Containers planned: the lot quantity before recipe yield and rounding. */
  containers?: Maybe<Scalars['Int']['output']>;
  /** Eaches one container holds, as resolved from the order line. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /** Sales eaches reserved against the order line. */
  eachesReserved?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  /** The minted lot; its quantity is the container count. */
  productionLot?: Maybe<ProductionLotStateData>;
};

export type CreateMaterialItemInput = {
  accountingId?: InputMaybe<Scalars['String']['input']>;
  base64Image?: InputMaybe<Scalars['String']['input']>;
  /** The material's unit of measure. Omit it, or send EACH, for an each material. Bulk create (bulkCreateMaterialItem) does not take a unit yet: a row that sets baseUnit is refused and nothing is saved. Set the unit afterwards with setMaterialItemBaseUnit. */
  baseUnit?: InputMaybe<MaterialUnit>;
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  erpId?: Scalars['String']['input'];
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isOrganic?: Scalars['Boolean']['input'];
  itemType?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sellable?: Scalars['Boolean']['input'];
};

/**
 * Input record for createMovementOrder. IdempotentKey is a client-supplied
 * retry-correlation token validated as ValidIdStrict (32-char dashless GUID) so
 * clients can use Guid.NewGuid().ToString("N"). Dedup is the aggregate's job:
 * StartWithNewEntity rejects duplicate creates on MovementOrderId.
 */
export type CreateMovementOrderInput = {
  fromLocationId?: InputMaybe<Scalars['String']['input']>;
  fromSiteLocationId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  lines: Array<MovementOrderLineInput>;
  movementOrderId: Scalars['String']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  toLocationId?: InputMaybe<Scalars['String']['input']>;
  toSiteLocationId: Scalars['String']['input'];
};

export type CreateNoteDataInput = {
  id: Scalars['String']['input'];
  noteText: Scalars['String']['input'];
};

export type CreateOrUpdateTagByTagCodeInput = {
  erpId?: InputMaybe<Scalars['String']['input']>;
  materialCategory?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tag: TagSpecDataInput;
};

/** Names one exact build of the firmware releases index to release over the air, and how to release it. */
export type CreateOtaReleaseInput = {
  /** The channel the release is offered on. */
  channel: OtaReleaseChannel;
  /** The build's device model, exactly as the index lists it. */
  deviceModel: Scalars['String']['input'];
  /** The build's firmware name, exactly as the index lists it. */
  firmwareName: Scalars['String']['input'];
  /** Operator notes recorded with the release. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The device profile the release targets; its hardware model must be the build's device model. */
  profile: DeviceProfile;
  /** The build's full commit sha, exactly as the index lists it. */
  sha: Scalars['String']['input'];
  /** The build's version, exactly as the index lists it. */
  version: Scalars['String']['input'];
};

export type CreatePaymentProcessorInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  onlinePaymentMaxAmount: Scalars['Long']['input'];
};

/**
 * Admin input for provisioning a customer-portal (Buyer) user through the unified path: one
 * WorkSuiteUser (carrying Portal + the customer scope) and a
 * linked portal-scoped UserInvite so the wsapi-services worker creates the FusionAuth login
 * with the wsCustomerId/wsUserType=customer claims and sends the set-password email.
 * Single-use Data type per the read-model/command type-isolation convention.
 */
export type CreatePortalUserDataInput = {
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiresInDays: Scalars['Int']['input'];
  fullName: Scalars['String']['input'];
  registrations: Array<UserInviteRegistrationDataInput>;
};

export type CreatePortalUserInput = {
  createdBy: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  portalUserId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userType: UserType;
};

export type CreateProductionCatalogInput = {
  alternateFarmVendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  color: Scalars['String']['input'];
  defaultFarmVendorId?: InputMaybe<Scalars['String']['input']>;
  genus: Scalars['String']['input'];
  origin?: InputMaybe<ProductionCatalogOrigin>;
  productionCatalogId: Scalars['String']['input'];
  series: Scalars['String']['input'];
};

export type CreateProductionItemInput = {
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionItemId: Scalars['String']['input'];
  productionItemNumber: Scalars['String']['input'];
};

export type CreateProductionLineInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  deviceIds: Array<Scalars['String']['input']>;
  productionLineId: Scalars['String']['input'];
};

/** Starts a schedule import. */
export type CreateProductionLotAsyncImportJobInput = {
  /** Import as soon as every row validates. */
  autoStartImport: Scalars['Boolean']['input'];
  /**
   * The name of the uploaded file, shown in the imports list. Trimmed, at most 255
   *             characters; omitted or blank saves none.
   */
  fileName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductionLotInput = {
  customerGroupId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  isAd: Scalars['Boolean']['input'];
  isTrial: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  preFinished?: Scalars['Boolean']['input'];
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionItemId?: InputMaybe<Scalars['String']['input']>;
  productionLotId?: InputMaybe<Scalars['String']['input']>;
  productionPlanId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  weekReadyDate: Scalars['DateTime']['input'];
};

export type CreateProductionMaterialEventInput = {
  name: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type CreateProductionRecipeInput = {
  isCombo: Scalars['Boolean']['input'];
  isStartRecipe: Scalars['Boolean']['input'];
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionRecipeId: Scalars['String']['input'];
};

export type CreateProductionRecipeWithVariationInput = {
  genus?: InputMaybe<Scalars['String']['input']>;
  isCombo: Scalars['Boolean']['input'];
  isStartRecipe: Scalars['Boolean']['input'];
  productionCatalogId?: InputMaybe<Scalars['String']['input']>;
  productionCategoryId: Scalars['String']['input'];
  productionRecipeId: Scalars['String']['input'];
  series?: InputMaybe<Scalars['String']['input']>;
  targetKind?: InputMaybe<ProductionRecipeTargetKind>;
  variation: ProductionRecipeVariationDataInput;
};

export type CreateProductionSpaceEventInput = {
  name: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type CreateProductionTaskEventInput = {
  name: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type CreateProductionTriggerInput = {
  expireBy?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  productionTriggerId: Scalars['String']['input'];
  source: ProductionTriggerSource;
  unit: ProductionTriggerUnit;
};

export type CreatePromotionRuleInput = {
  description: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  promotionRuleId: Scalars['String']['input'];
  quantityFloor: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreatePurchaseOrderAllocationInput = {
  id: Scalars['String']['input'];
  items: Array<CreateAllocationLineItemInput>;
  orderId: Scalars['String']['input'];
  purchaseOrderId: Scalars['String']['input'];
};

export type CreateReportFolderInput = {
  folderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReportInput = {
  appTags?: InputMaybe<Array<AppTag>>;
  craftJsTemplate: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  filters: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
  handlebarsTemplate: Scalars['String']['input'];
  isStarred: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pageSettings: Scalars['String']['input'];
  parameterConfig: Scalars['String']['input'];
  parameterValues: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
  spreadsheetColumns?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReportScheduleInput = {
  cronExpression: Scalars['String']['input'];
  docType?: InputMaybe<OrderEmailDocType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive: Scalars['Boolean']['input'];
  lastRunAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  nextRunAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  outputFormat: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<ReportSchedulePurpose>;
  recipients: Array<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
  reportTemplateId?: InputMaybe<Scalars['String']['input']>;
  runOnce: Scalars['Boolean']['input'];
  scheduleId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeZoneId: Scalars['String']['input'];
};

export type CreateReportTemplateInput = {
  category: Scalars['String']['input'];
  craftJsTemplate: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  handlebarsTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  tags: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export type CreateReserveRuleInput = {
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  level: ReserveRuleLevel;
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  mode: ReserveRuleMode;
  name: Scalars['String']['input'];
  percentage: Scalars['Decimal']['input'];
  reserveRuleId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type CreateRestockSessionInput = {
  items: Array<CreateRestockSessionItemDataInput>;
  sessionId: Scalars['String']['input'];
  sessionName: Scalars['String']['input'];
  shipDate: Scalars['DateTime']['input'];
  stationCode?: InputMaybe<Scalars['String']['input']>;
  stores: Array<CreateRestockSessionStoreInput>;
  targetWeeksOfSupply: Scalars['Decimal']['input'];
};

export type CreateRestockSessionItemDataInput = {
  itemId: Scalars['String']['input'];
};

export type CreateRestockSessionStoreInput = {
  customerLocationId: Scalars['String']['input'];
  storeName: Scalars['String']['input'];
};

export type CreateScheduledOrderInput = {
  lineItems: AddLineItemsInput;
  masterOrderId: Scalars['String']['input'];
  masterOrderNumber: Scalars['String']['input'];
  order: InitializeOrderInput;
};

export type CreateSiteLocationAsyncImportJobInput = {
  autoStartImport: Scalars['Boolean']['input'];
};

export type CreateSiteMapInput = {
  customerId: Scalars['String']['input'];
  customerLocationId: Scalars['String']['input'];
  excludeFromDistribution: Scalars['Boolean']['input'];
  programId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
  siteMapId: Scalars['String']['input'];
};

/** Opens a private import workspace for one existing purchasing vendor. */
export type CreateSupplierPriceImportInput = {
  purchasingVendorId: Scalars['String']['input'];
};

export type CreateTagInput = {
  erpId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  materialCategory?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tag: TagSpecDataInput;
};

export type CreateTaskAssignmentInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  productionJobId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  sourceLevel: TaskAssignmentSourceLevel;
  taskAssignmentId: Scalars['String']['input'];
  taskEventName: Scalars['String']['input'];
};

export type CreateTaskEventTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reducesSellableStock?: InputMaybe<Scalars['Boolean']['input']>;
  taskEventTypeId: Scalars['String']['input'];
};

/**
 * Simplified input for the createTask mutation.
 * Resolves TaskEventType by ID rather than requiring the name.
 */
export type CreateTaskInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  productionJobId?: InputMaybe<Scalars['String']['input']>;
  taskEventTypeId: Scalars['String']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  roles: Array<UserRole>;
  userId: Scalars['String']['input'];
};

export type CreateUserInviteInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  expiresInDays: Scalars['Int']['input'];
  linkedUserId?: InputMaybe<Scalars['String']['input']>;
  recipientEmail: Scalars['String']['input'];
  registrations: Array<UserInviteRegistrationDataInput>;
  userType?: UserType;
};

export type CreateUserInvitesInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  expiresInDays: Scalars['Int']['input'];
  linkedUserId?: InputMaybe<Scalars['String']['input']>;
  recipientEmails: Array<Scalars['String']['input']>;
  registrations: Array<UserInviteRegistrationDataInput>;
  userType?: UserType;
};

export type CreateVendorInput = {
  billingAddress: CreateAddressInput;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateVendorPurchaseOrderInput = {
  billingAddress: CreateAddressInput;
  erpId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isUrgent?: Scalars['Boolean']['input'];
  items: Array<CreateVendorPurchaseOrderItemInput>;
  orderPlacedDate: Scalars['DateTime']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
  shippingAddress: CreateAddressInput;
  siteLocationId: Scalars['String']['input'];
  status: VendorPurchaseOrderStatus;
  vendorName: Scalars['String']['input'];
};

export type CreateVendorPurchaseOrderItemInput = {
  erpJobId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
  jobShares?: InputMaybe<Array<CreateVendorPurchaseOrderLineJobShareDataInput>>;
  lineNumber: Scalars['Int']['input'];
  materialItemErpId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  quantityOrdered: Scalars['Decimal']['input'];
  quantityReceived: Scalars['Decimal']['input'];
  unitCost?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateVendorPurchaseOrderLineJobShareDataInput = {
  eventDetailId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
};

export type CreateVolumePoolInput = {
  code: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  quantityBasis?: QuantityBasis;
};

export type CreateWorkOrderInput = {
  activityCode: Scalars['String']['input'];
  containerQuantityToProduce: Scalars['Int']['input'];
  erpId?: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  plannedQuantity: Scalars['Int']['input'];
  productionPhaseCode: Scalars['String']['input'];
  quantityToProduce: Scalars['Int']['input'];
  workOrderId: Scalars['String']['input'];
  workOrderItems: Array<BuildItemInput>;
  workOrderStatus: WorkOrderStatus;
};

export type CreateWorkSuiteProductInput = {
  flags: Array<FeatureFlagName>;
  includedForEveryCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateWsapiImportInput = {
  enabled: Scalars['Boolean']['input'];
  integrationId: Scalars['String']['input'];
  scheduleDayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  scheduleTimeOfDay?: InputMaybe<Scalars['String']['input']>;
  wsapiImportId: Scalars['String']['input'];
};

export enum CreditApplicationStatus {
  Applied = 'APPLIED',
  PartiallyApplied = 'PARTIALLY_APPLIED',
  Unapplied = 'UNAPPLIED'
}

export type CreditExistingOrderInput = {
  creditOrderId: Scalars['String']['input'];
  lines?: InputMaybe<Array<CreditOrderLineDataInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sourceOrderId: Scalars['String']['input'];
};

export enum CreditLinkKind {
  Correction = 'CORRECTION',
  CreditExistingOrder = 'CREDIT_EXISTING_ORDER'
}

/** One staff-chosen application of a credit memo to an open invoice of the same customer. */
export type CreditMemoApplicationDataInput = {
  /** How much of the memo to apply: more than zero, in whole cents, and no more than the invoice owes. */
  amount: Scalars['Decimal']['input'];
  /** The invoice to apply the memo to. It must bill the memo's customer and still be open. */
  invoiceId: Scalars['String']['input'];
};

/** One application of a credit memo's money to an invoice. */
export type CreditMemoApplicationDocument = {
  __typename?: 'CreditMemoApplicationDocument';
  /** How much of the memo's credit it took. */
  amount: Scalars['Decimal']['output'];
  /** The application's identity on the customer's credit. */
  applicationId: Scalars['String']['output'];
  /** When it was applied. */
  appliedAt: Scalars['DateTime']['output'];
  /** Who, or what system actor, applied it. */
  appliedBy: Scalars['String']['output'];
  /** The invoice the memo's credit was applied to. */
  invoiceId: Scalars['String']['output'];
  /** When the invoice was voided and the credit came back unapplied; null while it stands. */
  reversedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** One Credit-type order, as the credit memo backfill found it. */
export type CreditMemoBackfillCredit = {
  __typename?: 'CreditMemoBackfillCredit';
  /** The memo's number, CM- and the credit order's number. */
  creditMemoNumber: Scalars['String']['output'];
  /** The credit order. */
  creditOrderId: Scalars['String']['output'];
  /** The credit order's own live invoice, when it was billed as a sale. */
  creditOrderInvoiceId?: Maybe<Scalars['String']['output']>;
  /** That invoice's number. */
  creditOrderInvoiceNumber?: Maybe<Scalars['String']['output']>;
  /** Its number. */
  creditOrderNumber: Scalars['String']['output'];
  /** Its status. */
  creditOrderStatus: OrderStatus;
  /**
   * Why it failed, or why it is blocked, when it is; on a refile recorded at the figures Stripe already held within a cent
   * of its plan, which is not a failure, why the memos after it on its source order wait for the next run; on a memo
   * issued whose catch-up of the invoice its source order issued meanwhile failed, why, and that the memos after it on
   * that order wait for the next run.
   */
  error?: Maybe<Scalars['String']['output']>;
  /** What the issued memo credits, tax included; null until it is issued. */
  memoTotal?: Maybe<Scalars['Decimal']['output']>;
  /** What the memo credits before the tax a Stripe reversal adds when it is issued. */
  preTaxTotal: Scalars['Decimal']['output'];
  /**
   * How much of the memo, tax included, applies to the source's live invoice by default, after the credits planned
   * before it in the same run; zero when the source has no live invoice (the memo then comes off that invoice when it
   * issues) or owes nothing.
   */
  proposedApplication: Scalars['Decimal']['output'];
  /** Why it was skipped, when it was. */
  skipReason?: Maybe<CreditMemoBackfillSkipReason>;
  /** That order's live invoice, when it has one. */
  sourceInvoiceId?: Maybe<Scalars['String']['output']>;
  /** That invoice's number. */
  sourceInvoiceNumber?: Maybe<Scalars['String']['output']>;
  /** The order it credits, when it was raised against one. */
  sourceOrderId?: Maybe<Scalars['String']['output']>;
  /** That order's number. */
  sourceOrderNumber?: Maybe<Scalars['String']['output']>;
  /** What the backfill found or did. */
  status: CreditMemoBackfillStatus;
  /**
   * For a memo filed again against the invoice that replaced a voided one, the tax the memo's earlier reversals credited
   * that is not taken back at Stripe on this invoice: what the reissued invoice could not take, or Stripe's own tax on
   * goods or freight that no refile takes back. It is what a dry run finds a run that writes would record, what this
   * run recorded, or what the memo already records. The memo's tax and total grow only by taxToppedUp. Recorded only
   * when the reissued invoice's tax was filed at Stripe; zero otherwise.
   */
  taxHeldBack: Scalars['Decimal']['output'];
  /**
   * The part of taxHeldBack the reissued invoice still charges and Stripe still counts as collected, once the Stripe
   * reversal, its top-up included, is counted.
   */
  taxStillCountedAtStripe: Scalars['Decimal']['output'];
  /**
   * For a memo filed again against the invoice that replaced a voided one, the tax credited to the customer for eaches
   * and freight the memo's earlier reversals left out, first reversed on this invoice in the same Stripe reversal: what
   * a dry run finds a run that writes would credit, what this run credited, or what the memo already records. Zero on
   * every other row.
   */
  taxToppedUp: Scalars['Decimal']['output'];
  /**
   * The tax the Stripe reversal would credit (the credited share of the tax Stripe recorded on the source invoice's
   * lines and freight); zero when none would be recorded. The memo total is the two figures added. For a memo filed
   * again against the invoice that replaced a voided one, the refile part only: the Stripe reversal carries taxTotal
   * plus taxToppedUp, and only taxToppedUp is credited to the customer. A refile whose Stripe answer was lost and which
   * a run that writes records at the figures Stripe already held, within a cent of tax per line of its plan, reports
   * Stripe's: up to a cent per line from its dry run, as are its taxHeldBack and taxStillCountedAtStripe.
   */
  taxTotal: Scalars['Decimal']['output'];
  /** The tenant. */
  tenantId: Scalars['String']['output'];
};

/** What one page of the credit memo backfill found and did. */
export type CreditMemoBackfillPayload = {
  __typename?: 'CreditMemoBackfillPayload';
  /** Credit orders that already had their memo. On a second run, every one not skipped. */
  alreadyIssued: Scalars['Int']['output'];
  /**
   * Whether the walk reached the last credit order. False when the page stopped at its time budget: call again with
   * next as after, and keep calling until complete is true.
   */
  complete: Scalars['Boolean']['output'];
  /** Credit-type orders this page reports. */
  creditOrdersFound: Scalars['Int']['output'];
  /**
   * Every credit order this page reports, in the order the backfill walks them, with its source, its source invoice and
   * the proposed application. The pages of one run, concatenated, are the report a single page would give.
   */
  credits: Array<CreditMemoBackfillCredit>;
  /** Whether the run only reported and wrote nothing. */
  dryRun: Scalars['Boolean']['output'];
  /**
   * Why the run was refused before it read anything (a tenantIds list that names no tenant, an id that is not a tenant
   * id, or an after that is not a cursor this backfill returned for the tenants it runs); null when it ran.
   */
  errors?: Maybe<Array<ValidationError>>;
  /** Credit orders whose memo failed to issue. */
  failed: Scalars['Int']['output'];
  /** Memos this run issued. Zero on a dry run, and zero on a second run. */
  issued: Scalars['Int']['output'];
  /** The cursor to pass as after to resume the walk after this page; null once complete, and on a refused run. */
  next?: Maybe<Scalars['String']['output']>;
  /** Credit orders that cannot issue a memo. */
  skipped: Scalars['Int']['output'];
  /** Issued memos whose tax this run reversed against the source's live invoice. */
  taxReversed: Scalars['Int']['output'];
  /** Credit orders a dry run would issue a memo for. */
  toIssue: Scalars['Int']['output'];
  /** Issued memos a dry run found still owed their tax reversal against the source's live invoice. */
  toReverseTax: Scalars['Int']['output'];
};

/** Why the backfill leaves a Credit-type order without a memo. */
export enum CreditMemoBackfillSkipReason {
  /**
   * The ERP billed the credit order (Synchronized or billed earlier), so WorkSuite issues no memo for it: its credit
   * is already in the customer's ERP account.
   */
  BilledInErp = 'BILLED_IN_ERP',
  /** The credit order was cancelled or deleted, so it credits nothing. */
  CancelledOrDeleted = 'CANCELLED_OR_DELETED',
  /**
   * The order the credit credits does not record which of the credit's lines take some of its lines, or records
   * them out of step with what those lines bill, and its invoice's tax was filed at Stripe, so the money the credit
   * refunds there, and the tax to reverse, cannot be told. Nothing was filed. Run the order credit back-reference
   * backfill to name the lines; a memo not yet issued can instead be cancelled and credited again. Then re-run.
   */
  CreditedMoneyUnproven = 'CREDITED_MONEY_UNPROVEN',
  /**
   * The credit order stands billed as a positive WorkSuite invoice (the defect this memo replaces). No memo is
   * issued; staff void that invoice, and a later run issues the memo. Never voided automatically.
   */
  HasLiveInvoice = 'HAS_LIVE_INVOICE',
  /** The credit order credits nothing, so there is no memo to issue. */
  NothingToCredit = 'NOTHING_TO_CREDIT',
  /** The credit order has not shipped, so its credit is not final yet; a later run picks it up. */
  NotShipped = 'NOT_SHIPPED',
  /**
   * The live invoice of the order the credit credits does not yet hold payments the customer made on that order,
   * which the receipt repair (carryOrderReceiptsToInvoice) would carry onto it. No memo is issued and nothing is
   * filed at Stripe: a memo applied first would take that money as still owed, and the repair then refuses the
   * invoice. Run the repair on the invoice the row names, then re-run; the memo is then issued against what the
   * invoice still owes.
   */
  OrderReceiptsNotCarried = 'ORDER_RECEIPTS_NOT_CARRIED',
  /**
   * The reversal the memo would file would take back more sales than the memo credits in goods, so its lines were
   * paired with the invoice's wrongly. Nothing was filed. Report it; a re-run does the same.
   */
  ReversalExceedsGoods = 'REVERSAL_EXCEEDS_GOODS',
  /**
   * The order the credit credits has no record of the credit. Run the order credit back-reference backfill
   * first, so the tax reversal can name the lines credited.
   */
  SourceCreditNotRecorded = 'SOURCE_CREDIT_NOT_RECORDED',
  /**
   * The order the credit credits recorded it at a figure the credit order no longer totals, so the tax reversal
   * would not match the lines credited. Restate the credit on its source order first.
   */
  SourceRecordDisagrees = 'SOURCE_RECORD_DISAGREES'
}

/** What the credit memo backfill found, or did, for one Credit-type order. */
export enum CreditMemoBackfillStatus {
  /** The credit order already has its memo; nothing was written for it. */
  AlreadyIssued = 'ALREADY_ISSUED',
  /** Issuing failed; error says why, and re-running retries it. */
  Failed = 'FAILED',
  /** This run issued the credit order's memo. */
  Issued = 'ISSUED',
  /** The credit order cannot issue a memo; skipReason says why. Nothing was written for it. */
  Skipped = 'SKIPPED',
  /** This run reversed the tax of an already-issued memo against the source's live invoice. */
  TaxReversed = 'TAX_REVERSED',
  /** A dry run found the credit order has no memo yet; a run that writes issues it. */
  ToIssue = 'TO_ISSUE',
  /**
   * A dry run found the memo issued but its tax not yet reversed against the source's live invoice (a failed or
   * lost step); a run that writes reverses it.
   */
  ToReverseTax = 'TO_REVERSE_TAX'
}

/**
 * A credit memo: the document a Credit-type order issues instead of an invoice. Its money is a credit on the
 * customer's balance, applied to invoices or held unapplied; applications, amountApplied, unapplied and
 * applicationStatus say where it stands, read live from the customer's credit.
 */
export type CreditMemoDocument = {
  __typename?: 'CreditMemoDocument';
  /** How much of this memo's credit stands applied to invoices. */
  amountApplied: Scalars['Decimal']['output'];
  /** How much of this memo's credit was paid back to the customer out of band. */
  amountRefunded: Scalars['Decimal']['output'];
  /** APPLIED, PARTIALLY_APPLIED or UNAPPLIED: how much of this memo's credit has been used. Never UNPAID. */
  applicationStatus: CreditApplicationStatus;
  /** Every application of this memo's credit to an invoice, oldest first, including ones a void reversed. */
  applications: Array<CreditMemoApplicationDocument>;
  /** The memo's id — the credit order's id. */
  creditMemoId: Scalars['String']['output'];
  /** The memo's document number: CM- followed by the credit order's number. */
  creditMemoNumber: Scalars['String']['output'];
  /** The Credit-type order the memo is for. */
  creditOrderId: Scalars['String']['output'];
  /** That order's number. */
  creditOrderNumber: Scalars['String']['output'];
  /** The customer credited. */
  customerId: Scalars['String']['output'];
  /** The credited flat charges. */
  flatChargesTotal: Scalars['Decimal']['output'];
  /** The credited freight. */
  freight: Scalars['Decimal']['output'];
  /** The composite Mongo _id. */
  id: Scalars['String']['output'];
  /** The instant the memo was issued. */
  issuedAt: Scalars['DateTime']['output'];
  /** Staff only; refused for customer-portal callers. Who issued it. */
  issuedBy: Scalars['String']['output'];
  /** The credited lines. */
  lines: Array<CreditMemoLineDocument>;
  /**
   * The source order's live invoice when the memo was issued; null when the source had not been invoiced, in
   * which case the memo comes off that invoice when it issues.
   */
  sourceInvoiceId?: Maybe<Scalars['String']['output']>;
  /** That invoice's number. */
  sourceInvoiceNumber?: Maybe<Scalars['String']['output']>;
  /** The order the credit was raised against; null for a credit raised against no order. */
  sourceOrderId?: Maybe<Scalars['String']['output']>;
  /** That order's number. */
  sourceOrderNumber?: Maybe<Scalars['String']['output']>;
  /** The credited lines' sum, before freight, charges and tax. */
  subtotal: Scalars['Decimal']['output'];
  /** Every partial Stripe Tax reversal the memo recorded, oldest first. */
  taxReversals: Array<CreditMemoTaxReversalDocument>;
  /**
   * CALCULATED when tax on the credited lines was reversed at Stripe; NOT_CALCULATED when the invoice they were
   * billed on carried no calculated tax, or none has issued yet.
   */
  taxStatus: InvoiceTaxStatus;
  /**
   * The tax credited: the first reversal's tax at Stripe on the credited lines, plus every re-filing's taxToppedUp.
   * Never a rate WorkSuite computed.
   */
  taxTotal: Scalars['Decimal']['output'];
  /** The owning tenant. */
  tenantId: Scalars['String']['output'];
  /** What the memo credits: subtotal + freight + flatChargesTotal + taxTotal. */
  total: Scalars['Decimal']['output'];
  /**
   * How much of this memo's credit is still unapplied — the remainder held on the customer's credit. Always
   * total less amountApplied less amountRefunded.
   */
  unapplied: Scalars['Decimal']['output'];
};

export type CreditMemoLineData = {
  __typename?: 'CreditMemoLineData';
  discountAmount: Scalars['Decimal']['output'];
  extended: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  unitPrice: Scalars['Decimal']['output'];
};

/** One credited line on a credit memo. */
export type CreditMemoLineDocument = {
  __typename?: 'CreditMemoLineDocument';
  /** The line's share of the credit order's discount. */
  discountAmount: Scalars['Decimal']['output'];
  /** What the line credits, before tax. */
  extended: Scalars['Decimal']['output'];
  /** The catalog item credited. */
  itemId: Scalars['String']['output'];
  /** The item's name as it stood when the memo was issued. */
  itemName: Scalars['String']['output'];
  /** The credit order line's number. */
  lineNumber: Scalars['Int']['output'];
  /** The credited each count. */
  quantity: Scalars['Int']['output'];
  /** The item's SKU as it stood when the memo was issued. */
  sku: Scalars['String']['output'];
  /** The per-each price the row credits at. */
  unitPrice: Scalars['Decimal']['output'];
};

/** The result of issuing a credit memo. */
export type CreditMemoPayload = {
  __typename?: 'CreditMemoPayload';
  /** The memo as issued; null on error. */
  creditMemo?: Maybe<CreditMemoStateData>;
  /** Why it was refused, when it was. */
  errors?: Maybe<Array<ValidationError>>;
};

export type CreditMemoStateData = {
  __typename?: 'CreditMemoStateData';
  creditMemoId: Scalars['String']['output'];
  creditMemoNumber: Scalars['String']['output'];
  creditOrderId: Scalars['String']['output'];
  creditOrderNumber: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  flatChargesTotal: Scalars['Decimal']['output'];
  freight: Scalars['Decimal']['output'];
  issuedAt: Scalars['DateTime']['output'];
  lines: Array<CreditMemoLineData>;
  sourceInvoiceId?: Maybe<Scalars['String']['output']>;
  sourceOrderId?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Decimal']['output'];
  taxStatus: InvoiceTaxStatus;
  taxTotal: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

/** One partial Stripe Tax reversal a credit memo recorded against an invoice's tax. */
export type CreditMemoTaxReversalDocument = {
  __typename?: 'CreditMemoTaxReversalDocument';
  /** The invoice whose tax transaction was partially reversed. */
  invoiceId: Scalars['String']['output'];
  /** That invoice's number. */
  invoiceNumber: Scalars['String']['output'];
  /**
   * Whether this reversal re-filed, against a reissued invoice's new transaction, tax the memo had already credited
   * the customer; the customer was not credited that tax a second time. Eaches and freight it first reverses there
   * are credited once, as taxToppedUp.
   */
  refiled: Scalars['Boolean']['output'];
  /** The instant it was recorded. */
  reversedAt: Scalars['DateTime']['output'];
  /**
   * The reversal transaction Stripe recorded; empty on a re-filing that had nothing left to file, where Stripe was
   * not asked.
   */
  stripeTaxReversalTransactionId: Scalars['String']['output'];
  /**
   * The tax reversed: on a first reversal, what the memo credits for tax against that invoice. On a re-filing
   * (refiled is true), the refile part only: the Stripe reversal carries taxAmount plus taxToppedUp, and what the
   * memo credits there is taxToppedUp.
   */
  taxAmount: Scalars['Decimal']['output'];
  /**
   * On a re-filing (refiled is true), the tax the memo's earlier reversals credited that was not taken back at Stripe
   * on this invoice: what the reissued invoice could not take, or Stripe's own tax on goods or freight that no refile
   * takes back. taxAmount plus taxHeldBack is the tax the memo's earlier reversals credited. The memo's taxTotal and
   * total grow only by taxToppedUp. Recorded only when the reissued invoice's tax was filed at Stripe; zero on every
   * other reversal.
   */
  taxHeldBack: Scalars['Decimal']['output'];
  /**
   * The part of taxHeldBack the reissued invoice still charges and Stripe still counts as collected, once the Stripe
   * reversal, its taxToppedUp included, is counted. Recorded only when the reissued invoice's tax was filed at
   * Stripe; zero on every other reversal.
   */
  taxStillCountedAtStripe: Scalars['Decimal']['output'];
  /**
   * On a re-filing, the tax credited to the customer for eaches and freight the memo's earlier reversals left out,
   * first reversed on this invoice; zero on every other reversal.
   */
  taxToppedUp: Scalars['Decimal']['output'];
};

export type CreditOrderLineDataInput = {
  lineNumber: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

/** What a credit was compared with. */
export enum CreditPricingBasis {
  /** The source order's live invoice: what its lines billed. */
  Invoice = 'INVOICE',
  /** The source order's lines as they stand, which is what its invoice will bill: it has no live invoice. */
  Order = 'ORDER'
}

/** One credit the report lists. */
export type CreditPricingReportCredit = {
  __typename?: 'CreditPricingReportCredit';
  /** The credit order. */
  creditOrderId: Scalars['String']['output'];
  /** The credit order's number. */
  creditOrderNumber: Scalars['String']['output'];
  /** What the credit's named lines bill, before tax. */
  credited: Scalars['Decimal']['output'];
  /** What the credit bills less what the sale billed for them. */
  difference: Scalars['Decimal']['output'];
  /** Each sale line the credit takes. */
  lines: Array<CreditPricingReportLine>;
  /** What the credit was compared with, when its source was found. */
  pricedFrom?: Maybe<CreditPricingBasis>;
  /** What the sale billed for the eaches those lines take. */
  saleBilled: Scalars['Decimal']['output'];
  /** The source order's live invoice, when it has one. */
  sourceInvoiceId?: Maybe<Scalars['String']['output']>;
  /** That invoice's number. */
  sourceInvoiceNumber?: Maybe<Scalars['String']['output']>;
  /** The order the credit was raised from. */
  sourceOrderId: Scalars['String']['output'];
  /** That order's number. */
  sourceOrderNumber: Scalars['String']['output'];
  /** Why the credit is listed. */
  status: CreditPricingReportStatus;
  /** The tenant. */
  tenantId: Scalars['String']['output'];
};

/** One sale line a listed credit takes, beside what the sale billed for those eaches. */
export type CreditPricingReportLine = {
  __typename?: 'CreditPricingReportLine';
  /** The credit line that takes it, if the record names one. */
  creditLineNumber?: Maybe<Scalars['Int']['output']>;
  /** What the credit line bills, or none when the record names no credit line. */
  credited?: Maybe<Scalars['Decimal']['output']>;
  /** The eaches the credit takes of it. */
  creditedEaches: Scalars['Int']['output'];
  /** What the credit line bills less what the sale billed, when the credit line is named. */
  difference?: Maybe<Scalars['Decimal']['output']>;
  /** What the sale billed for those eaches. */
  saleBilled: Scalars['Decimal']['output'];
  /** The sale line. */
  sourceLineNumber: Scalars['Int']['output'];
};

/** What the credit pricing report found. */
export type CreditPricingReportPayload = {
  __typename?: 'CreditPricingReportPayload';
  /** The Credit-type orders of the tenants reported on. */
  creditOrdersFound: Scalars['Int']['output'];
  /** Every credit checked that is not, with why. */
  credits: Array<CreditPricingReportCredit>;
  /** Those raised from a source order and neither cancelled nor deleted. */
  creditsChecked: Scalars['Int']['output'];
  /** Those checked whose every line bills what its sale line billed, to the cent. */
  creditsPricedLikeTheirSale: Scalars['Int']['output'];
  /** Why the report was refused, or the credits it could not read. */
  errors?: Maybe<Array<ValidationError>>;
};

/** Why a credit is listed. */
export enum CreditPricingReportStatus {
  /** The source's record of the credit names no credit line for a line it takes: run backfillOrderCreditBackReferences. */
  CreditLinesNotNamed = 'CREDIT_LINES_NOT_NAMED',
  /** A credit line bills more than a cent apart from what its sale line billed for the eaches it credits. */
  Differs = 'DIFFERS',
  /** The source order does not record the credit: run backfillOrderCreditBackReferences. */
  SourceDoesNotRecordTheCredit = 'SOURCE_DOES_NOT_RECORD_THE_CREDIT',
  /** The source order the credit names was not found. */
  SourceNotFound = 'SOURCE_NOT_FOUND'
}

/**
 * Batch mutation result. One CrmExportPayload per input row, in submission order, so
 * the worker can inspect each row's outcome. Per-row problems land on that row's
 * errors; the whole batch never rejects for a single bad row.
 * Errors here is reserved for whole-batch failures (empty updates today); when it is
 * non-null CrmExports is null.
 */
export type CrmExportBatchPayload = {
  __typename?: 'CrmExportBatchPayload';
  crmExports?: Maybe<Array<CrmExportPayload>>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * MongoDB outbox document for one customer's outbound export to a Merge.dev CRM. Unlike the
 * accounting MergeDevExportDocument (one row per order-export attempt, initialized inline
 * at the single Order trigger call site), customers have no single trigger and DO round-trip
 * through inbound sync — so intent (PENDING) is stamped
 * go-forward by CrmExportProjectionService off the Customer stream, one row per
 * customer (contacts and billing addresses ride the customer push). The wsapi-services worker
 * reads rows the status matrix leaves eligible (Pending / FailedTransient with
 * NextRetryAt <= now), pushes them, and reports outcomes back via
 * batchUpdateCrmExportStatuses.
 */
export type CrmExportDocument = {
  __typename?: 'CrmExportDocument';
  customerId: Scalars['String']['output'];
  exportStatus: CrmExportStatus;
  /** Composite id {TenantId}-{CustomerId} — one outbox row per customer, so a re-stamp updates in place rather than duplicating. */
  id: Scalars['String']['output'];
  /**
   * Last failure message reported by the worker. Null unless ExportStatus is
   * FAILED_TRANSIENT or FAILED_PERMANENT;
   * cleared on every intent re-stamp and on Completed.
   */
  lastError?: Maybe<Scalars['String']['output']>;
  /**
   * Earliest moment the worker may attempt this customer again. Non-null only while
   * ExportStatus is FAILED_TRANSIENT; cleared on intent
   * re-stamp, Completed, and FailedPermanent. Worker filter: NextRetryAt <= now.
   */
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on every
   * intent stamp (a genuine field change starts a fresh export attempt); carried forward across
   * transient retries by the worker.
   */
  retryCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  /** Last write timestamp (observability only). */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB outbox document for one customer's outbound export to a Merge.dev CRM. Unlike the
 * accounting MergeDevExportDocument (one row per order-export attempt, initialized inline
 * at the single Order trigger call site), customers have no single trigger and DO round-trip
 * through inbound sync — so intent (PENDING) is stamped
 * go-forward by CrmExportProjectionService off the Customer stream, one row per
 * customer (contacts and billing addresses ride the customer push). The wsapi-services worker
 * reads rows the status matrix leaves eligible (Pending / FailedTransient with
 * NextRetryAt <= now), pushes them, and reports outcomes back via
 * batchUpdateCrmExportStatuses.
 */
export type CrmExportDocumentFilterInput = {
  and?: InputMaybe<Array<CrmExportDocumentFilterInput>>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  exportStatus?: InputMaybe<CrmExportStatusOperationFilterInput>;
  /** Composite id {TenantId}-{CustomerId} — one outbox row per customer, so a re-stamp updates in place rather than duplicating. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Last failure message reported by the worker. Null unless ExportStatus is
   * FAILED_TRANSIENT or FAILED_PERMANENT;
   * cleared on every intent re-stamp and on Completed.
   */
  lastError?: InputMaybe<StringOperationFilterInput>;
  /**
   * Earliest moment the worker may attempt this customer again. Non-null only while
   * ExportStatus is FAILED_TRANSIENT; cleared on intent
   * re-stamp, Completed, and FailedPermanent. Worker filter: NextRetryAt <= now.
   */
  nextRetryAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CrmExportDocumentFilterInput>>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on every
   * intent stamp (a genuine field change starts a fresh export attempt); carried forward across
   * transient retries by the worker.
   */
  retryCount?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Last write timestamp (observability only). */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB outbox document for one customer's outbound export to a Merge.dev CRM. Unlike the
 * accounting MergeDevExportDocument (one row per order-export attempt, initialized inline
 * at the single Order trigger call site), customers have no single trigger and DO round-trip
 * through inbound sync — so intent (PENDING) is stamped
 * go-forward by CrmExportProjectionService off the Customer stream, one row per
 * customer (contacts and billing addresses ride the customer push). The wsapi-services worker
 * reads rows the status matrix leaves eligible (Pending / FailedTransient with
 * NextRetryAt <= now), pushes them, and reports outcomes back via
 * batchUpdateCrmExportStatuses.
 */
export type CrmExportDocumentSortInput = {
  customerId?: InputMaybe<SortEnumType>;
  exportStatus?: InputMaybe<SortEnumType>;
  /** Composite id {TenantId}-{CustomerId} — one outbox row per customer, so a re-stamp updates in place rather than duplicating. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Last failure message reported by the worker. Null unless ExportStatus is
   * FAILED_TRANSIENT or FAILED_PERMANENT;
   * cleared on every intent re-stamp and on Completed.
   */
  lastError?: InputMaybe<SortEnumType>;
  /**
   * Earliest moment the worker may attempt this customer again. Non-null only while
   * ExportStatus is FAILED_TRANSIENT; cleared on intent
   * re-stamp, Completed, and FailedPermanent. Worker filter: NextRetryAt <= now.
   */
  nextRetryAt?: InputMaybe<SortEnumType>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on every
   * intent stamp (a genuine field change starts a fresh export attempt); carried forward across
   * transient retries by the worker.
   */
  retryCount?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Last write timestamp (observability only). */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Discriminator payload for a terminal failure. */
export type CrmExportFailedPermanentUpdateDataInput = {
  lastError: Scalars['String']['input'];
};

/**
 * Discriminator payload for a retryable failure. The worker computed RetryCount (new total
 * after this attempt) and NextRetryAt (earliest next attempt) from its own retry-budget
 * policy — wsapi just records them.
 */
export type CrmExportFailedTransientUpdateDataInput = {
  lastError: Scalars['String']['input'];
  nextRetryAt: Scalars['DateTime']['input'];
  retryCount: Scalars['Int']['input'];
};

/**
 * Result of a single worker status report. On success CrmExport is the outbox row as it
 * stands after the write; Errors carries a per-row failure (bad discriminator shape, or the
 * customer has no outbox row) and then CrmExport is null. The two are mutually exclusive.
 */
export type CrmExportPayload = {
  __typename?: 'CrmExportPayload';
  crmExport?: Maybe<CrmExportDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * Lifecycle status of a single customer's outbound export to a Merge.dev CRM
 * (Salesforce / HubSpot). One row per customer in the CrmExports outbox; the
 * wsapi-services worker drains rows the transition matrix leaves eligible.
 */
export enum CrmExportStatus {
  /** The worker successfully pushed the customer/contacts to the CRM. */
  Completed = 'COMPLETED',
  /**
   * Terminal failure (non-retryable, or the transient budget was exhausted). Surfaces for human
   * review. A subsequent intent stamp resets the row to PENDING so corrected data
   * re-exports.
   */
  FailedPermanent = 'FAILED_PERMANENT',
  /**
   * Most recent attempt failed transiently (5xx, 429, timeout, etc.). The worker retries at or
   * after nextRetryAt until its budget is exhausted, then writes
   * a terminal FAILED_PERMANENT. A fresh intent stamp resets the row to
   * PENDING (new field values may cure the failure).
   */
  FailedTransient = 'FAILED_TRANSIENT',
  /** Intent stamped (a mapped field changed) and no terminal outcome recorded yet — the worker should attempt the push. */
  Pending = 'PENDING'
}

export type CrmExportStatusOperationFilterInput = {
  eq?: InputMaybe<CrmExportStatus>;
  in?: InputMaybe<Array<CrmExportStatus>>;
  neq?: InputMaybe<CrmExportStatus>;
  nin?: InputMaybe<Array<CrmExportStatus>>;
};

/**
 * One row in the batch. Exactly one outcome must be set: completed = true, OR
 * failedTransient, OR failedPermanent.
 *
 * Completed is a bare flag rather than a nested payload object (as it is on the accounting
 * MergeDevExportStatusUpdateRow, which carries the QB invoice id) because a CRM completion
 * carries no outbox payload — the CRM record URL is persisted on the customer itself via
 * setCustomerCrmLink, and a GraphQL input object must define at least one field, so an
 * empty Completed payload type is not expressible.
 */
export type CrmExportStatusUpdateRowInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['String']['input'];
  failedPermanent?: InputMaybe<CrmExportFailedPermanentUpdateDataInput>;
  failedTransient?: InputMaybe<CrmExportFailedTransientUpdateDataInput>;
};

/** A connection to a list of items. */
export type CrmExportsConnection = {
  __typename?: 'CrmExportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CrmExportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CrmExportDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CrmExportsEdge = {
  __typename?: 'CrmExportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CrmExportDocument;
};

/**
 * One entry in a customer's merged activity timeline. A single flat, kind-tagged row spanning all three
 * activity sources — order milestones, order payment-ledger entries, and customer notes — so the feed
 * pages as one strictly reverse-chronological stream. Fields that do not apply to an entry's kind are
 * null: order milestones carry the order identity and status, ledger entries add amount, source and the
 * recording user, and notes carry text and their author. Ordering is newest first, tie-broken by Id so
 * paging stays stable across a page boundary.
 */
export type CustomerActivityEntry = {
  __typename?: 'CustomerActivityEntry';
  /** The user who recorded a payment or wrote a note; null when unknown or not applicable. */
  actedBy?: Maybe<Scalars['String']['output']>;
  /** Amount and currency of a payment or deposit entry; null for every other kind. */
  amount?: Maybe<MoneyData>;
  /** Stable identifier for this entry, unique within the feed and used as the ordering tie-break. */
  id: Scalars['String']['output'];
  /** Which kind of activity this entry records. */
  kind: CustomerActivityKind;
  /** When the activity happened. The feed is sorted by this value, newest first. */
  occurredAt: Scalars['DateTime']['output'];
  /** Identifier of the order this entry belongs to; null for a note. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Human-readable number of the order this entry belongs to; null for a note. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** The order's current status; null for a note. */
  orderStatus?: Maybe<OrderStatus>;
  /**
   * The customer the order was taken for, when a customer combine has since moved it onto this
   * customer; null for an order of the customer's own and for a note.
   */
  originalCustomerId?: Maybe<Scalars['String']['output']>;
  /** The name of that customer when it was combined; null when the order was never moved. */
  originalCustomerName?: Maybe<Scalars['String']['output']>;
  /**
   * Where a payment or deposit came from — imported from the accounting integration, or recorded
   * manually in FULFILL. Null for every other kind.
   */
  source?: Maybe<OrderPaymentSource>;
  /** The note's text; null for every kind other than a note. */
  text?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type CustomerActivityFeedConnection = {
  __typename?: 'CustomerActivityFeedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerActivityFeedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerActivityEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerActivityFeedEdge = {
  __typename?: 'CustomerActivityFeedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerActivityEntry;
};

/**
 * What a single customer activity entry records. Order milestones carry the moment the order reached
 * that state; Payment and Deposit are the order payment ledger's two entry kinds; Note is a customer
 * note. The kind tells a client which of the entry's optional fields are populated.
 */
export enum CustomerActivityKind {
  /** A deposit was received toward an order's deposit requirement. */
  Deposit = 'DEPOSIT',
  /** A note was recorded against the customer. */
  Note = 'NOTE',
  /** The order was created. */
  OrderPlaced = 'ORDER_PLACED',
  /** The order shipped. */
  OrderShipped = 'ORDER_SHIPPED',
  /** The order first entered an active state (submitted, acknowledged, picked or shipped). */
  OrderSubmitted = 'ORDER_SUBMITTED',
  /** The order synchronized to the tenant's ERP or accounting system. */
  OrderSynchronized = 'ORDER_SYNCHRONIZED',
  /** A payment was applied to an order balance. */
  Payment = 'PAYMENT'
}

/**
 * A customer's outstanding balance distributed across days-past-due buckets. An invoice's due date is
 * the one FROZEN onto it when it was issued — the invoice date offset by the terms' net-due window —
 * so a later edit to the tenant's terms cannot move an issued invoice between buckets. The five buckets
 * PARTITION arBalance: every standing invoice lands in exactly one of them, so they sum back to it.
 */
export type CustomerArAging = {
  __typename?: 'CustomerArAging';
  /** Outstanding amount that is not yet past due. */
  current: Scalars['Decimal']['output'];
  /** Outstanding amount between 1 and 30 days past due. */
  days1To30: Scalars['Decimal']['output'];
  /** Outstanding amount between 31 and 60 days past due. */
  days31To60: Scalars['Decimal']['output'];
  /** Outstanding amount between 61 and 90 days past due. */
  days61To90: Scalars['Decimal']['output'];
  /** Outstanding amount more than 90 days past due. */
  days90Plus: Scalars['Decimal']['output'];
};

export type CustomerBulkActionPayload = {
  __typename?: 'CustomerBulkActionPayload';
  customers?: Maybe<Array<CustomerPayload>>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A refusal the combine would meet: its error code and its message, which names the customer. */
export type CustomerCombineBlocker = {
  __typename?: 'CustomerCombineBlocker';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** One row of a combine preview: a field's value on each customer and after the combine. */
export type CustomerCombineField = {
  __typename?: 'CustomerCombineField';
  isConflict: Scalars['Boolean']['output'];
  keepBothAllowed: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: CustomerCombineFieldKind;
  label: Scalars['String']['output'];
  loserValue?: Maybe<Scalars['String']['output']>;
  resultValue?: Maybe<Scalars['String']['output']>;
  sameAsRefusal?: Maybe<Scalars['String']['output']>;
  survivorValue?: Maybe<Scalars['String']['output']>;
};

/** How a field is merged when one customer is combined into another. */
export enum CustomerCombineFieldKind {
  /** A count of history, shown for comparison only. */
  History = 'HISTORY',
  /** The survivor keeps its value; the combined customer's value becomes an alias. Never a conflict. */
  Identity = 'IDENTITY',
  /**
   * A list that is unioned. The same item mapped to two different customer SKUs is a conflict, and so
   * is each suggested contact or ship-to pair ("same as" or "keep both") and each customer item a
   * "same as" ship-to would bring that differs from the survivor's.
   */
  Multi = 'MULTI',
  /** A setting. Any difference, blank included, is a conflict. */
  Setting = 'SETTING',
  /** The survivor's value wins and a blank is filled from the combined customer. Two different values are a conflict. */
  Single = 'SINGLE'
}

/** Counts of what a customer already has. */
export type CustomerCombineHistory = {
  __typename?: 'CustomerCombineHistory';
  contacts: Scalars['Int']['output'];
  locations: Scalars['Int']['output'];
  openInvoices: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  portalUsers: Scalars['Int']['output'];
  statementRuns: Scalars['Int']['output'];
};

/**
 * A staff user limited to assigned customers who has the loser but not the survivor, so loses sight of the
 * loser's orders once combined unless the combine gives them the survivor: their id and their full name,
 * or email when they have none.
 */
export type CustomerCombineLimitedStaff = {
  __typename?: 'CustomerCombineLimitedStaff';
  name: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Which value a conflicting field keeps. */
export enum CustomerCombinePickChoice {
  KeepBoth = 'KEEP_BOTH',
  Loser = 'LOSER',
  Survivor = 'SURVIVOR'
}

/** The resolution of one conflicting field, by its preview key. */
export type CustomerCombinePickInput = {
  choice: CustomerCombinePickChoice;
  key: Scalars['String']['input'];
};

/**
 * A portal buyer the combine moves to the kept customer, or its undo moves back: their id and their full
 * name, or email when they have none.
 */
export type CustomerCombinePortalBuyer = {
  __typename?: 'CustomerCombinePortalBuyer';
  name: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/**
 * What combining the loser into the survivor would do. Nothing is written. Blockers are the
 * refusals the combine would meet as things stand; LimitedStaff never blocks it.
 * PortalBuyersMoving are the loser's Active portal buyers the combine moves to the survivor; they
 * never block it either.
 * OldCustomerSyncSources and KeptCustomerSyncSources name the outside syncs enabled for the
 * tenant that feed the loser and the survivor (GrowPoint, OrderEase, Shopify, the accounting system,
 * the CRM): each customer carries that source's key. ShipToCustomerItemsMoving is the loser's active
 * customer items on its ship-tos, which move with the ship-to or, on one picked "same as", move or retire;
 * CustomerLevelCustomerItems is the loser's active customer-level customer items, which carry over
 * to the survivor as the customer SKU picks say.
 */
export type CustomerCombinePreview = {
  __typename?: 'CustomerCombinePreview';
  blockers: Array<CustomerCombineBlocker>;
  conflictCount: Scalars['Int']['output'];
  customerLevelCustomerItems: Scalars['Int']['output'];
  fields: Array<CustomerCombineField>;
  keptCustomerSyncSources: Array<Scalars['String']['output']>;
  limitedStaff: Array<CustomerCombineLimitedStaff>;
  loserHistory: CustomerCombineHistory;
  loserId: Scalars['String']['output'];
  oldCustomerSyncSources: Array<Scalars['String']['output']>;
  portalBuyersMoving: Array<CustomerCombinePortalBuyer>;
  shipToCustomerItemsMoving: Scalars['Int']['output'];
  survivorHistory: CustomerCombineHistory;
  survivorId: Scalars['String']['output'];
  survivorSuggested: Scalars['Boolean']['output'];
};

export type CustomerCombinePreviewPayload = {
  __typename?: 'CustomerCombinePreviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  preview?: Maybe<CustomerCombinePreview>;
};

/** How a ship-to or contact the undo gives back changed while the customers were combined. */
export enum CustomerCombineRevertChange {
  /** It was added to the kept customer for the old customer while combined. */
  Added = 'ADDED',
  /** The combine moved it and it was edited since. */
  Edited = 'EDITED',
  /** The combine moved it and it is unchanged since. */
  Moved = 'MOVED'
}

/** The ship-tos and contacts the combine moved that were deleted while combined, by name. They stay deleted. */
export type CustomerCombineRevertDeleted = {
  __typename?: 'CustomerCombineRevertDeleted';
  contacts: Array<Scalars['String']['output']>;
  shipTos: Array<Scalars['String']['output']>;
};

/**
 * What the undo gives the old customer back: its ship-tos and contacts as the kept customer holds them, how many
 * customer items go back on its ship-tos and at customer level, and how many orders and invoices move back to it.
 */
export type CustomerCombineRevertGoesBack = {
  __typename?: 'CustomerCombineRevertGoesBack';
  contacts: Array<CustomerCombineRevertRecord>;
  customerLevelCustomerItems: Scalars['Int']['output'];
  invoices: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  shipToCustomerItems: Scalars['Int']['output'];
  shipTos: Array<CustomerCombineRevertRecord>;
};

/**
 * What undoing a combine would do. Nothing is written. StaysOnKeptCustomer are the settings the combine
 * changed that were changed again since, which keep their value; SettingsRestored the ones it sets back.
 * StaffLosingKeptCustomer are the staff users the combine gave the kept customer who lose it again.
 * PortalBuyersMovingBack are the portal buyers the combine moved who go back to the old customer, those
 * still Active on the kept customer.
 * WindowClosedReason names the order, invoice or payment that closed the window, null while it is open.
 * Blockers are the other refusals the undo would meet as things stand.
 */
export type CustomerCombineRevertPreview = {
  __typename?: 'CustomerCombineRevertPreview';
  blockers: Array<CustomerCombineBlocker>;
  deletedWhileCombined: CustomerCombineRevertDeleted;
  goesBack: CustomerCombineRevertGoesBack;
  loserId: Scalars['String']['output'];
  loserName: Scalars['String']['output'];
  portalBuyersMovingBack: Array<CustomerCombinePortalBuyer>;
  settingsRestored: Array<CustomerCombineRevertSetting>;
  skusComingOff: Array<CustomerCombineRevertSkus>;
  staffLosingKeptCustomer: Array<CustomerCombineLimitedStaff>;
  staysOnKeptCustomer: Array<CustomerCombineRevertSetting>;
  survivorId: Scalars['String']['output'];
  survivorName: Scalars['String']['output'];
  windowClosedReason?: Maybe<Scalars['String']['output']>;
  windowOpen: Scalars['Boolean']['output'];
};

export type CustomerCombineRevertPreviewPayload = {
  __typename?: 'CustomerCombineRevertPreviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  preview?: Maybe<CustomerCombineRevertPreview>;
};

/** A ship-to or contact the undo gives back: its id, its name and how it changed while combined. */
export type CustomerCombineRevertRecord = {
  __typename?: 'CustomerCombineRevertRecord';
  change: CustomerCombineRevertChange;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * A setting the combine changed on the kept customer: its key, its label, its value now and, when the undo sets it
 * back, the value it restores; null when the setting changed since the combine and stays as it is.
 */
export type CustomerCombineRevertSetting = {
  __typename?: 'CustomerCombineRevertSetting';
  current: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  restored?: Maybe<Scalars['String']['output']>;
};

/** A kept customer's customer item the combine added SKUs to: its id, its SKU and the SKUs the undo takes off it. */
export type CustomerCombineRevertSkus = {
  __typename?: 'CustomerCombineRevertSkus';
  customerItemId: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  skusComingOff: Array<Scalars['String']['output']>;
};

/** A per-customer commission rate (percent value, 0–100) that takes precedence over the user's default rate. */
export type CustomerCommissionOverrideData = {
  __typename?: 'CustomerCommissionOverrideData';
  /**
   * The customer this override applies to. Null when the customer no longer exists
   * in the caller's tenant, or when the lookup is briefly unavailable — never treat
   * null as "override inactive"; the override's own fields remain authoritative.
   */
  customer?: Maybe<CustomersSummaryDocument>;
  customerId: Scalars['String']['output'];
  ratePercent: Scalars['Decimal']['output'];
};

/** A per-customer commission rate (percent value, 0–100) that takes precedence over the user's default rate. */
export type CustomerCommissionOverrideDataFilterInput = {
  and?: InputMaybe<Array<CustomerCommissionOverrideDataFilterInput>>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerCommissionOverrideDataFilterInput>>;
  ratePercent?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * One denormalized, searchable (contact, phone) pair on ContactSearchEntries.
 * Deliberately a document-side type distinct from ContactSearchEventRecord (the domain event
 * payload shape) so the GraphQL contract can evolve independently of the event shape, even though
 * today the two are a trivial field-for-field mapping.
 */
export type CustomerContactSearchEntry = {
  __typename?: 'CustomerContactSearchEntry';
  /** The contact this entry was derived from. */
  contactId: Scalars['UUID']['output'];
  /** The contact's "{FirstName} {LastName}", trimmed and single-spaced. */
  name: Scalars['String']['output'];
  /** The phone number exactly as stored, or empty for a contact with no phones. */
  phone: Scalars['String']['output'];
  /**
   * Phone reduced to its digits, so [UseFiltering] contains can match a
   * bare-digit search term against a formatted stored value. Empty when Phone is.
   */
  phoneDigits: Scalars['String']['output'];
};

/**
 * One denormalized, searchable (contact, phone) pair on ContactSearchEntries.
 * Deliberately a document-side type distinct from ContactSearchEventRecord (the domain event
 * payload shape) so the GraphQL contract can evolve independently of the event shape, even though
 * today the two are a trivial field-for-field mapping.
 */
export type CustomerContactSearchEntryFilterInput = {
  and?: InputMaybe<Array<CustomerContactSearchEntryFilterInput>>;
  /** The contact this entry was derived from. */
  contactId?: InputMaybe<UuidOperationFilterInput>;
  /** The contact's "{FirstName} {LastName}", trimmed and single-spaced. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerContactSearchEntryFilterInput>>;
  /** The phone number exactly as stored, or empty for a contact with no phones. */
  phone?: InputMaybe<StringOperationFilterInput>;
  /**
   * Phone reduced to its digits, so [UseFiltering] contains can match a
   * bare-digit search term against a formatted stored value. Empty when Phone is.
   */
  phoneDigits?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerContextNoteData = {
  __typename?: 'CustomerContextNoteData';
  context: NoteContext;
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CustomerCreditApplicationData = {
  __typename?: 'CustomerCreditApplicationData';
  amount: Scalars['Decimal']['output'];
  applicationId: Scalars['String']['output'];
  appliedAt: Scalars['DateTime']['output'];
  appliedBy: Scalars['String']['output'];
  draws: Array<CustomerCreditDrawData>;
  invoiceId: Scalars['String']['output'];
  isLive: Scalars['Boolean']['output'];
  reversedAt?: Maybe<Scalars['DateTime']['output']>;
  reversedBy?: Maybe<Scalars['String']['output']>;
};

/**
 * One application of a customer's credit to one of their invoices, as the customer credit read model
 * carries it.
 */
export type CustomerCreditApplicationDocument = {
  __typename?: 'CustomerCreditApplicationDocument';
  /** How much credit was applied. Always greater than zero. */
  amount: Scalars['Decimal']['output'];
  /** This application's identity, shared with the invoice it was applied to — and the projection's dedup key. */
  applicationId: Scalars['String']['output'];
  /** The instant it was applied. */
  appliedAt: Scalars['DateTime']['output'];
  /** The email of whoever, or whatever system actor, applied it. */
  appliedBy: Scalars['String']['output'];
  /** Which entries the amount came from, and how much of each. */
  draws: Array<CustomerCreditDrawDocument>;
  /** The invoice the credit was applied to. */
  invoiceId: Scalars['String']['output'];
  /** Whether this application still settles its invoice — it has not been reversed by a void. */
  isLive: Scalars['Boolean']['output'];
  /**
   * When the invoice this application settled was voided and the credit came back unapplied; null while the
   * application stands. A reversed application no longer counts toward totalApplied, and its draws no longer
   * count against the entries they came from.
   */
  reversedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email of whoever voided the invoice, when the application was reversed. */
  reversedBy?: Maybe<Scalars['String']['output']>;
};

/**
 * One customer's credit balance: every credit the grower owes them, every application of it to one of
 * their invoices, and every refund of it. The balance is what is still unapplied.
 */
export type CustomerCreditDocument = {
  __typename?: 'CustomerCreditDocument';
  /** Every application of credit to one of the customer's invoices, oldest first. */
  applications: Array<CustomerCreditApplicationDocument>;
  /**
   * What is still unapplied — the customer's credit balance. Always totalReceived less totalApplied less
   * totalRefunded, and never below zero.
   */
  balance: Scalars['Decimal']['output'];
  /** The customer the credit is owed to. */
  customerId: Scalars['String']['output'];
  /** Every credit received onto the balance, oldest first. */
  entries: Array<CustomerCreditEntryDocument>;
  /**
   * The composite Mongo _id. Embedding the tenant means a read filters on _id alone and
   * cannot leak across tenants.
   */
  id: Scalars['String']['output'];
  /**
   * Every entry with credit still unapplied on it, and how much, oldest first. Together they add up to
   * balance.
   */
  openEntries: Array<CustomerCreditOpenEntryData>;
  /** Every refund of credit, recorded by staff or confirmed by Stripe, oldest first. */
  refunds: Array<CustomerCreditRefundDocument>;
  /** The owning tenant. */
  tenantId: Scalars['String']['output'];
  /**
   * Everything applied to an invoice from the balance that still stands — an application reversed by a void of
   * its invoice no longer counts.
   */
  totalApplied: Scalars['Decimal']['output'];
  /** Everything ever received onto the balance. */
  totalReceived: Scalars['Decimal']['output'];
  /** Everything ever refunded out of the balance. */
  totalRefunded: Scalars['Decimal']['output'];
};

export type CustomerCreditDrawData = {
  __typename?: 'CustomerCreditDrawData';
  amount: Scalars['Decimal']['output'];
  entryId: Scalars['String']['output'];
  sourceKind: CustomerCreditSourceKind;
  sourceReference: Scalars['String']['output'];
};

/** The part of one credit entry an application or a refund drew down. */
export type CustomerCreditDrawDocument = {
  __typename?: 'CustomerCreditDrawDocument';
  /** How much of the entry was drawn. */
  amount: Scalars['Decimal']['output'];
  /** The entry drawn from. */
  entryId: Scalars['String']['output'];
  /** Where that entry's credit came from. */
  sourceKind: CustomerCreditSourceKind;
  /** The originating writer's own reference for that credit. */
  sourceReference: Scalars['String']['output'];
};

export type CustomerCreditEntryData = {
  __typename?: 'CustomerCreditEntryData';
  amount: Scalars['Decimal']['output'];
  entryId: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  receivedBy: Scalars['String']['output'];
  sourceKind: CustomerCreditSourceKind;
  sourceReference: Scalars['String']['output'];
  targetOrderId?: Maybe<Scalars['String']['output']>;
};

/** One credit received onto a customer's balance, as the customer credit read model carries it. */
export type CustomerCreditEntryDocument = {
  __typename?: 'CustomerCreditEntryDocument';
  /** What was received. Always greater than zero. */
  amount: Scalars['Decimal']['output'];
  /** This entry's identity — and the projection's dedup key. */
  entryId: Scalars['String']['output'];
  /** The instant it was recorded. */
  receivedAt: Scalars['DateTime']['output'];
  /** The email of whoever, or whatever system actor, recorded it. */
  receivedBy: Scalars['String']['output'];
  /** Where the credit came from: a credit memo, a deposit overage, or a payment excess. */
  sourceKind: CustomerCreditSourceKind;
  /** The originating writer's own reference for the credit. */
  sourceReference: Scalars['String']['output'];
  /**
   * The order this credit comes off by default when that order's invoice issues; null for ordinary
   * account credit. A default only — the credit can be applied elsewhere or refunded like any other.
   */
  targetOrderId?: Maybe<Scalars['String']['output']>;
};

export type CustomerCreditOpenEntryData = {
  __typename?: 'CustomerCreditOpenEntryData';
  amount: Scalars['Decimal']['output'];
  entryId: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  sourceKind: CustomerCreditSourceKind;
  sourceReference: Scalars['String']['output'];
  targetOrderId?: Maybe<Scalars['String']['output']>;
  unapplied: Scalars['Decimal']['output'];
};

/** The result of a write to a customer's credit balance. */
export type CustomerCreditPayload = {
  __typename?: 'CustomerCreditPayload';
  /** The customer's credit balance after the write; null on error. */
  customerCredit?: Maybe<CustomerCreditStateData>;
  /** Why the write was refused, when it was. */
  errors?: Maybe<Array<ValidationError>>;
};

export type CustomerCreditRefundData = {
  __typename?: 'CustomerCreditRefundData';
  amount: Scalars['Decimal']['output'];
  draws: Array<CustomerCreditDrawData>;
  method: CustomerCreditRefundMethod;
  note?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  refundId: Scalars['String']['output'];
  refundedAt: Scalars['DateTime']['output'];
  refundedBy: Scalars['String']['output'];
};

/**
 * One refund of a customer's credit, as the customer credit read model carries it: paid back outside Work Suite and
 * recorded by staff, or a Stripe refund Stripe confirmed.
 */
export type CustomerCreditRefundDocument = {
  __typename?: 'CustomerCreditRefundDocument';
  /** How much credit was paid back. Always greater than zero. */
  amount: Scalars['Decimal']['output'];
  /** Which entries the amount came from, and how much of each. */
  draws: Array<CustomerCreditDrawDocument>;
  /**
   * How the money went back to the customer: CHECK, ACH, CARD or OTHER when staff recorded a refund made outside Work
   * Suite; STRIPE when it was a Stripe refund of an online payment's credit that Stripe confirmed, the reference then
   * naming the Stripe refund or dispute.
   */
  method: CustomerCreditRefundMethod;
  /** Free text carrying any detail the structured fields do not. */
  note?: Maybe<Scalars['String']['output']>;
  /** The check number, ACH trace or similar, when one was given. */
  reference?: Maybe<Scalars['String']['output']>;
  /** This refund's identity — and the projection's dedup key. */
  refundId: Scalars['String']['output'];
  /** The instant it was recorded. */
  refundedAt: Scalars['DateTime']['output'];
  /** The email of whoever recorded it. */
  refundedBy: Scalars['String']['output'];
};

export enum CustomerCreditRefundMethod {
  Ach = 'ACH',
  Card = 'CARD',
  Check = 'CHECK',
  Other = 'OTHER',
  Stripe = 'STRIPE',
  Unknown = 'UNKNOWN'
}

export enum CustomerCreditSourceKind {
  CreditMemo = 'CREDIT_MEMO',
  DepositOverage = 'DEPOSIT_OVERAGE',
  PaymentExcess = 'PAYMENT_EXCESS',
  Unknown = 'UNKNOWN'
}

export type CustomerCreditStateData = {
  __typename?: 'CustomerCreditStateData';
  applications: Array<CustomerCreditApplicationData>;
  balance: Scalars['Decimal']['output'];
  customerId: Scalars['String']['output'];
  entries: Array<CustomerCreditEntryData>;
  openEntries: Array<CustomerCreditOpenEntryData>;
  refunds: Array<CustomerCreditRefundData>;
  tenantId: Scalars['String']['output'];
  totalApplied: Scalars['Decimal']['output'];
  totalReceived: Scalars['Decimal']['output'];
  totalRefunded: Scalars['Decimal']['output'];
};

/**
 * Result of a claim: the customer messages this worker now holds a lease on. An empty list means there is
 * nothing to send.
 */
export type CustomerDeliveryClaimPayload = {
  __typename?: 'CustomerDeliveryClaimPayload';
  /** The leased rows, oldest first. */
  claims: Array<CustomerDeliveryDocument>;
  /** Populated only when the claim itself failed. */
  errors?: Maybe<Array<ValidationError>>;
  /** Set on an SMS claim that returned rows. Null for EMAIL. */
  textSender?: Maybe<CustomerTextSenderData>;
};

/** The delivery state of a customer email, per channel. */
export type CustomerDeliveryData = {
  __typename?: 'CustomerDeliveryData';
  /** The email channel's delivery state. */
  email: ChannelDeliveryData;
  /** The text channel's delivery state. Null on an email row. A text row's email block is SKIPPED. */
  sms?: Maybe<ChannelDeliveryData>;
};

/**
 * One customer message on the dispatch rail: an order confirmation, an order acknowledgment or an
 * invoice for one document, by email or by text, or a consent request text, with its delivery state.
 */
export type CustomerDeliveryDocument = {
  __typename?: 'CustomerDeliveryDocument';
  /** When the event that raised the email happened. The send window counts from here. */
  createdAt: Scalars['DateTime']['output'];
  /** The customer the email goes to. Never empty. */
  customerId: Scalars['String']['output'];
  /** The customer's name when the email triggered. */
  customerName: Scalars['String']['output'];
  /** The email's delivery state. */
  delivery: CustomerDeliveryData;
  /** The order id or the invoice id the message is about, or the contact id on a CONSENT_REQUEST row. */
  entityId: Scalars['String']['output'];
  /** The kind of record the message is about. */
  entityType: CustomerDeliveryEntity;
  /** The row id. */
  id: Scalars['String']['output'];
  /** The kind of customer email. */
  kind: CustomerDeliveryKind;
  /** The order number when the email triggered. */
  orderNumber: Scalars['String']['output'];
  /** The sender that owns the email. Always DISPATCH on a row. */
  route: CustomerEmailRoute;
  /** The id of the event that raised the email. */
  sourceEventId: Scalars['String']['output'];
  /** The tenant the email belongs to. */
  tenantId: Scalars['String']['output'];
  /** The text this row sends. Null on an email row. */
  text?: Maybe<CustomerTextData>;
};

export enum CustomerDeliveryEntity {
  Contact = 'CONTACT',
  Invoice = 'INVOICE',
  Order = 'ORDER',
  Unknown = 'UNKNOWN'
}

export enum CustomerDeliveryKind {
  ConsentRequest = 'CONSENT_REQUEST',
  Invoice = 'INVOICE',
  OrderAcknowledgment = 'ORDER_ACKNOWLEDGMENT',
  OrderConfirmation = 'ORDER_CONFIRMATION',
  Unknown = 'UNKNOWN'
}

/** Result of recording a customer message outcome: the row as it now stands. */
export type CustomerDeliveryPayload = {
  __typename?: 'CustomerDeliveryPayload';
  /** The row as it now stands. */
  delivery?: Maybe<CustomerDeliveryDocument>;
  /** Populated when the row was not leased to a worker, or does not exist. */
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * A portal customer's effective Shipping UOM for one catalog item: the code and display name a
 * portal client cannot resolve for itself (it has no configCategories access), together
 * with the eaches-per-unit count and the container a line on that unit carries.
 */
export type CustomerEffectiveShippingUomData = {
  __typename?: 'CustomerEffectiveShippingUomData';
  /** The Shipping UOM code. */
  code: Scalars['String']['output'];
  /**
   * The container code a portal line on this unit should carry, or null when the tenant names no
   * container for the unit (or more than one).
   */
  containerCode?: Maybe<Scalars['String']['output']>;
  /** The eaches-per-unit count. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /** The Shipping UOM display name. */
  label: Scalars['String']['output'];
  /**
   * The effective Ship Increment in shipping units for this item, unit and container, or null with no
   * container. 0 means no increment.
   */
  shipIncrement?: Maybe<Scalars['Int']['output']>;
  /**
   * The effective Ship Minimum in shipping units for this item, unit and container, or null with no
   * container. 0 means no minimum.
   */
  shipMinimum?: Maybe<Scalars['Int']['output']>;
};

export enum CustomerEmailRoute {
  Dispatch = 'DISPATCH',
  Legacy = 'LEGACY',
  Unknown = 'UNKNOWN'
}

export type CustomerEmailRouteOperationFilterInput = {
  eq?: InputMaybe<CustomerEmailRoute>;
  in?: InputMaybe<Array<CustomerEmailRoute>>;
  neq?: InputMaybe<CustomerEmailRoute>;
  nin?: InputMaybe<Array<CustomerEmailRoute>>;
};

export type CustomerErpIdPayload = {
  __typename?: 'CustomerErpIdPayload';
  customerId: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * MongoDB read-model document for a customer group. Composite Id is
 * {TenantId}-{CustomerGroupId}; CustomerGroupId is the plain entity id. Mirrors
 * CustomerTypeDocument.
 */
export type CustomerGroupDocument = {
  __typename?: 'CustomerGroupDocument';
  customerGroupId: Scalars['String']['output'];
  /** Whether production in this group should use customer-item holds. Defaults to false. */
  holdProduction: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  status: CustomerGroupStatus;
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a customer group. Composite Id is
 * {TenantId}-{CustomerGroupId}; CustomerGroupId is the plain entity id. Mirrors
 * CustomerTypeDocument.
 */
export type CustomerGroupDocumentFilterInput = {
  and?: InputMaybe<Array<CustomerGroupDocumentFilterInput>>;
  customerGroupId?: InputMaybe<StringOperationFilterInput>;
  /** Whether production in this group should use customer-item holds. Defaults to false. */
  holdProduction?: InputMaybe<AbsentAsFalseBooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerGroupDocumentFilterInput>>;
  status?: InputMaybe<CustomerGroupStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a customer group. Composite Id is
 * {TenantId}-{CustomerGroupId}; CustomerGroupId is the plain entity id. Mirrors
 * CustomerTypeDocument.
 */
export type CustomerGroupDocumentSortInput = {
  customerGroupId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL mutation payload for the CustomerGroup aggregate. Either
 * CustomerGroup contains the post-event state, or Errors describes why the
 * mutation failed.
 */
export type CustomerGroupPayload = {
  __typename?: 'CustomerGroupPayload';
  customerGroup?: Maybe<CustomerGroupStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CustomerGroupStateData = {
  __typename?: 'CustomerGroupStateData';
  customerGroupId: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  holdProduction: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: CustomerGroupStatus;
  tenantId: Scalars['String']['output'];
};

export enum CustomerGroupStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type CustomerGroupStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerGroupStatus>;
  in?: InputMaybe<Array<CustomerGroupStatus>>;
  neq?: InputMaybe<CustomerGroupStatus>;
  nin?: InputMaybe<Array<CustomerGroupStatus>>;
};

/** A connection to a list of items. */
export type CustomerGroupsConnection = {
  __typename?: 'CustomerGroupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerGroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerGroupDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerGroupsEdge = {
  __typename?: 'CustomerGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerGroupDocument;
};

/**
 * The authoritative, backend-resolved answer to "where will this customer's invoices be sent" — the
 * same rules the on-demand invoice email compose dialog uses, exposed read-only so the UI never needs
 * its own copy of the routing logic. recipients is empty exactly when fallbackReason is
 * not None; a non-None reason means an actual send would fall back to the order's own
 * contact instead, which this customer-level view has no order to show.
 */
export type CustomerInvoiceRecipientsData = {
  __typename?: 'CustomerInvoiceRecipientsData';
  /**
   * Why recipients is empty: None when it isn't; NoRoutedContact when the
   * customer simply has no contact of the routed type (normal, not a misconfiguration);
   * RoutedContactHasNoEmail when a routed contact exists but every one of its emails is
   * blank — the misconfiguration this query exists to surface, since an actual send would silently
   * fall back to the purchaser with no warning.
   */
  fallbackReason: CustomerRecipientFallbackReason;
  /**
   * Every non-blank email of every contact currently routed to receive this customer's invoice
   * emails (every AccountsPayable contact by default, or the tenant's configured override),
   * deduped case-insensitively, contact-then-email order preserved. Empty when fallbackReason
   * is not None.
   */
  recipients: Array<Scalars['String']['output']>;
};

/** Where an invoice stands for a customer deciding whether to pay it: payable, paid, voided, or unavailable. */
export enum CustomerInvoiceStatus {
  /** The invoice owes nothing. */
  Paid = 'PAID',
  /** The invoice stands and still owes something. */
  Payable = 'PAYABLE',
  /** The invoice cannot be paid online right now. */
  Unavailable = 'UNAVAILABLE',
  /** The invoice was withdrawn. It is neither owed nor paid. */
  Voided = 'VOIDED'
}

/**
 * Result of addCustomerItems: one CustomerItemPayload per input row, in input order, each carrying
 * that row's own errors. errors is call-level only — an empty or oversized chunk, or a failure before
 * any row was appended — and when it is set nothing was written and customerItems is null.
 */
export type CustomerItemBulkActionPayload = {
  __typename?: 'CustomerItemBulkActionPayload';
  customerItems?: Maybe<Array<CustomerItemPayload>>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CustomerItemEffectiveDateOverlap = {
  __typename?: 'CustomerItemEffectiveDateOverlap';
  customerItemId: Scalars['String']['output'];
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerItemPayload = {
  __typename?: 'CustomerItemPayload';
  customerItem?: Maybe<CustomerItemStateData>;
  errors?: Maybe<Array<ValidationError>>;
  typedErrors?: Maybe<CustomerItemTypedErrors>;
};

/** One tenant's or one customer's replay counts. */
export type CustomerItemReplayCounts = {
  __typename?: 'CustomerItemReplayCounts';
  /** The customer; null on a tenant's row, and on a customer row for streams that could not be read. */
  customerId?: Maybe<Scalars['String']['output']>;
  /** The streams that could not be read or applied. */
  failed: Scalars['Int']['output'];
  /** The rows inserted; on a dry run, the rows a run would insert. */
  inserted: Scalars['Int']['output'];
  /** The streams whose customer, ship-to or item has since been combined away, deleted or deactivated. */
  skippedCombinedOrDeleted: Scalars['Int']['output'];
  /** The streams whose row, or another row at their customer, ship-to and item, already exists. */
  skippedExists: Scalars['Int']['output'];
  /** The streams whose events would also write a collection other than CustomerItems. */
  skippedWouldWriteOtherCollection: Scalars['Int']['output'];
  /** The tenant. */
  tenantId: Scalars['String']['output'];
};

/** A dead-lettered customer item the replay could not read or apply. */
export type CustomerItemReplayFailure = {
  __typename?: 'CustomerItemReplayFailure';
  /** The customer item. */
  customerItemId: Scalars['String']['output'];
  /** Why it failed. */
  message: Scalars['String']['output'];
  /** The tenant. */
  tenantId: Scalars['String']['output'];
};

/** A dead-lettered customer item the replay skipped and listed, with the reason. */
export type CustomerItemReplaySkip = {
  __typename?: 'CustomerItemReplaySkip';
  /** The customer the stream points at. */
  customerId: Scalars['String']['output'];
  /** The customer item, whose stream was not applied. */
  customerItemId: Scalars['String']['output'];
  /** The item the stream points at. */
  itemId: Scalars['String']['output'];
  /** The ship-to the stream points at; null for a customer-level row. */
  locationId?: Maybe<Scalars['String']['output']>;
  /** What changed. */
  reason: CustomerItemReplaySkipReason;
  /** The tenant. */
  tenantId: Scalars['String']['output'];
};

/** Why the replay skipped a dead-lettered customer item. */
export enum CustomerItemReplaySkipReason {
  /** The customer was combined into another customer. */
  CustomerCombined = 'CUSTOMER_COMBINED',
  /** The customer was deleted, or its stream no longer exists. */
  CustomerDeleted = 'CUSTOMER_DELETED',
  /** The customer is inactive. */
  CustomerInactive = 'CUSTOMER_INACTIVE',
  /** The item was combined into another item. */
  ItemCombined = 'ITEM_COMBINED',
  /** The item was deleted, or its stream no longer exists. */
  ItemDeleted = 'ITEM_DELETED',
  /** The item is inactive. */
  ItemInactive = 'ITEM_INACTIVE',
  /** The ship-to was combined into another ship-to of the customer. */
  ShipToCombined = 'SHIP_TO_COMBINED',
  /** The ship-to is no longer on the customer. */
  ShipToRemoved = 'SHIP_TO_REMOVED',
  /** Never set. */
  Unknown = 'UNKNOWN',
  /** An event on the stream names a program, so applying it would also write the tenant's Programs list. */
  WritesPrograms = 'WRITES_PROGRAMS'
}

export type CustomerItemStateData = {
  __typename?: 'CustomerItemStateData';
  additionalSkus: Array<Scalars['String']['output']>;
  additionalUpcs: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerItemId: Scalars['String']['output'];
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
  isDefault: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Scalars['String']['output']>;
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  retailShelfPriceCurrency?: Maybe<Scalars['String']['output']>;
  shippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  shippingUomId?: Maybe<Scalars['String']['output']>;
  sizeUomCode?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  status: CustomerItemStatus;
  tenantId: Scalars['String']['output'];
  upc?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum CustomerItemStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type CustomerItemStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerItemStatus>;
  in?: InputMaybe<Array<CustomerItemStatus>>;
  neq?: InputMaybe<CustomerItemStatus>;
  nin?: InputMaybe<Array<CustomerItemStatus>>;
};

export type CustomerItemTypedErrors = {
  __typename?: 'CustomerItemTypedErrors';
  effectiveDateOverlap?: Maybe<CustomerItemEffectiveDateOverlap>;
  upcSkuCollision?: Maybe<CustomerItemUpcSkuCollision>;
};

export type CustomerItemUpcSkuCollision = {
  __typename?: 'CustomerItemUpcSkuCollision';
  customerItemId: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type CustomerItemsConnection = {
  __typename?: 'CustomerItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SkuUpcMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerItemsEdge = {
  __typename?: 'CustomerItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SkuUpcMapping;
};

/**
 * One ship-to folded into a CustomerLocationDocument: its id, address id, Code and name,
 * each empty when it had none, and the customer it came from.
 */
export type CustomerLocationAliasData = {
  __typename?: 'CustomerLocationAliasData';
  addressId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  originCustomerId: Scalars['String']['output'];
};

/**
 * One ship-to folded into a CustomerLocationDocument: its id, address id, Code and name,
 * each empty when it had none, and the customer it came from.
 */
export type CustomerLocationAliasDataFilterInput = {
  addressId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CustomerLocationAliasDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerLocationAliasDataFilterInput>>;
  originCustomerId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB document for a single per-location typed note (one per NoteContext).
 * Mirrors the customer-level typed-note read surface.
 */
export type CustomerLocationContextNoteDocument = {
  __typename?: 'CustomerLocationContextNoteDocument';
  context: NoteContext;
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * MongoDB document for a single per-location typed note (one per NoteContext).
 * Mirrors the customer-level typed-note read surface.
 */
export type CustomerLocationContextNoteDocumentFilterInput = {
  and?: InputMaybe<Array<CustomerLocationContextNoteDocumentFilterInput>>;
  context?: InputMaybe<NoteContextOperationFilterInput>;
  or?: InputMaybe<Array<CustomerLocationContextNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Result of the location-side delivery-schedule override. Reports the assignment from the LOCATION's
 * point of view rather than returning a DeliverySchedule, because clearing the override targets
 * no schedule — a null DeliverySchedulePayload.DeliverySchedule with no error would read as a
 * failure.
 */
export type CustomerLocationDeliverySchedulePayload = {
  __typename?: 'CustomerLocationDeliverySchedulePayload';
  customerId: Scalars['String']['output'];
  deliveryScheduleId: Scalars['String']['output'];
  errors?: Maybe<Array<ValidationError>>;
  locationId: Scalars['String']['output'];
};

export type CustomerLocationDocument = {
  __typename?: 'CustomerLocationDocument';
  adGroup: Scalars['String']['output'];
  address?: Maybe<AddressData>;
  /**
   * The ship-tos a customer combine folded into this one ("same as"), from the combine's event;
   * a revert removes them. Empty for most ship-tos, and on rows written before the fold existed.
   */
  aliases: Array<CustomerLocationAliasData>;
  allowOrderBillingAddressEdit: Scalars['Boolean']['output'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['output'];
  /**
   * Ship-to freight carrier override — tier 2 of the hierarchical carrier setting. Empty means
   * "inherit the customer's carrier". Read by MongoCustomerService.GetInheritedCarrier.
   */
  carrier: Scalars['String']['output'];
  code: Scalars['String']['output'];
  /**
   * The ship-tos of the same customer combined into this one, from each combine's event; a revert
   * removes its entry. Empty for most ship-tos, and on rows written before ship-to combines existed.
   */
  combinedShipTos: Array<ShipToCombineRecord>;
  customerId: Scalars['String']['output'];
  customerLookupCode: Scalars['String']['output'];
  /** The display name of the customer associated with this location. */
  customerName: Scalars['String']['output'];
  /**
   * The ship-to's own default contact: one of this customer's contact ids, stored 32-hex (no
   * dashes). Null when the ship-to inherits the customer's Primary contact. Cleared when that
   * contact is removed. The effective contact (this, else the customer's first active Primary
   * contact) is computed on read and never stored.
   */
  defaultContactId?: Maybe<Scalars['UUID']['output']>;
  /** The end (HH:mm) of the receiving window in effect; see effectiveReceivingWindowStart. */
  effectiveReceivingWindowEnd?: Maybe<Scalars['String']['output']>;
  /** The start (HH:mm) of the receiving window in effect: the ship-to's own, else its customer's. Null when neither has a window. */
  effectiveReceivingWindowStart?: Maybe<Scalars['String']['output']>;
  /** The unload minutes in effect: the ship-to's own, else its customer's. Null when neither has them. Resolves independently of the window. */
  effectiveUnloadMinutes?: Maybe<Scalars['Int']['output']>;
  /** The kept ship-to id when this row was folded by a customer combine. */
  foldedIntoLocationId?: Maybe<Scalars['String']['output']>;
  /** The freight charge type override for this location, or null if inheriting from customer. */
  freightChargeType?: Maybe<Scalars['Int']['output']>;
  /** The freight charge value override for this location. */
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  globalLocationNumber: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * Optional GPS latitude for this retail ship-to. Null means unset/cleared. Persisted by
   * setCustomerLocationCoordinates; shared AddressData stays postal-only.
   */
  latitude?: Maybe<Scalars['Decimal']['output']>;
  locationId: Scalars['UUID']['output'];
  locationLookupCode: Scalars['String']['output'];
  /** Optional GPS longitude paired with Latitude. */
  longitude?: Maybe<Scalars['Decimal']['output']>;
  market: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The ship-to's order email contacts (its store's buyers) as contact ids. Empty when none. */
  orderEmailContactIds: Array<Scalars['UUID']['output']>;
  /**
   * Location-level "purchase order required" override. Null means "inherit from the
   * customer" (the resolved value falls back to the customer-level flag, default false);
   * true/false is an explicit per-location override.
   */
  poRequired?: Maybe<Scalars['Boolean']['output']>;
  priceGroupId: Scalars['String']['output'];
  priceGroupName: Scalars['String']['output'];
  /** The ship-to's receiving email, where its delivery notices go. Null when none is set. */
  receivingEmail?: Maybe<Scalars['String']['output']>;
  /** The end (HH:mm) of the ship-to's own receiving window; see receivingWindowStart. */
  receivingWindowEnd?: Maybe<Scalars['String']['output']>;
  /** The start (HH:mm) of the ship-to's own receiving window. Null when it inherits the customer's. */
  receivingWindowStart?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  /**
   * Ship-to route override — tier 3 of the hierarchical route setting. Empty means "inherit the
   * customer's route". Read by MongoCustomerService.GetInheritedRoute.
   */
  route: Scalars['String']['output'];
  /**
   * Location-level override of the invoice-email toggle.
   * null means inherit from customer; a concrete value overrides.
   */
  sendInvoiceEmails?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Location-level override of the order-confirmation-email toggle.
   * null means inherit from customer; a concrete value overrides.
   */
  sendOrderEmails?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The WorkSuite-native SiteLocationId of the site that services this ship-to, as set by
   * setCustomerLocationServicingSite. EMPTY means no servicing site is assigned — there is
   * no inherited customer-level tier to fall back to. This is the explicit ship-to to site link
   * the order-email workers are to read when resolving that site's contacts; those workers still
   * match a site by a prefix of the location code today, a convention this field is intended to
   * replace but does not itself retire.
   */
  servicingSiteLocationId: Scalars['String']['output'];
  settings?: Maybe<CustomerLocationSettingsDocument>;
  storeNumber: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  termsId: Scalars['String']['output'];
  termsName: Scalars['String']['output'];
  /** The ship-to's own unload minutes. Null when it inherits the customer's. */
  unloadMinutes?: Maybe<Scalars['Int']['output']>;
  /** The orders on this ship-to, counted per request in one batch; nothing is stored. */
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomerLocationDocumentFilterInput = {
  adGroup?: InputMaybe<StringOperationFilterInput>;
  address?: InputMaybe<AddressDataFilterInput>;
  /**
   * The ship-tos a customer combine folded into this one ("same as"), from the combine's event;
   * a revert removes them. Empty for most ship-tos, and on rows written before the fold existed.
   */
  aliases?: InputMaybe<ListFilterInputTypeOfCustomerLocationAliasDataFilterInput>;
  allowOrderBillingAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  allowOrderLocationAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomerLocationDocumentFilterInput>>;
  /**
   * Ship-to freight carrier override — tier 2 of the hierarchical carrier setting. Empty means
   * "inherit the customer's carrier". Read by MongoCustomerService.GetInheritedCarrier.
   */
  carrier?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  /**
   * The ship-tos of the same customer combined into this one, from each combine's event; a revert
   * removes its entry. Empty for most ship-tos, and on rows written before ship-to combines existed.
   */
  combinedShipTos?: InputMaybe<ListFilterInputTypeOfShipToCombineRecordFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerLookupCode?: InputMaybe<StringOperationFilterInput>;
  /** The display name of the customer associated with this location. */
  customerName?: InputMaybe<StringOperationFilterInput>;
  /**
   * The ship-to's own default contact: one of this customer's contact ids, stored 32-hex (no
   * dashes). Null when the ship-to inherits the customer's Primary contact. Cleared when that
   * contact is removed. The effective contact (this, else the customer's first active Primary
   * contact) is computed on read and never stored.
   */
  defaultContactId?: InputMaybe<StringOperationFilterInput>;
  /** The kept ship-to id when this row was folded by a customer combine. */
  foldedIntoLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The freight charge type override for this location, or null if inheriting from customer. */
  freightChargeType?: InputMaybe<IntOperationFilterInput>;
  /** The freight charge value override for this location. */
  freightChargeValue?: InputMaybe<DecimalOperationFilterInput>;
  globalLocationNumber?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Optional GPS latitude for this retail ship-to. Null means unset/cleared. Persisted by
   * setCustomerLocationCoordinates; shared AddressData stays postal-only.
   */
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  locationId?: InputMaybe<UuidOperationFilterInput>;
  locationLookupCode?: InputMaybe<StringOperationFilterInput>;
  /** Optional GPS longitude paired with Latitude. */
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerLocationDocumentFilterInput>>;
  /**
   * The ship-to's order email contacts, its store's buyers: 32-hex contact ids (no dashes), like
   * defaultContactId. Empty when none, and for a row written before the field existed.
   * Dropped when a contact is removed.
   */
  orderEmailContactIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Location-level "purchase order required" override. Null means "inherit from the
   * customer" (the resolved value falls back to the customer-level flag, default false);
   * true/false is an explicit per-location override.
   */
  poRequired?: InputMaybe<BooleanOperationFilterInput>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceGroupName?: InputMaybe<StringOperationFilterInput>;
  /** The ship-to's receiving email, where its delivery notices go. Null when none is set. */
  receivingEmail?: InputMaybe<StringOperationFilterInput>;
  /** The end (HH:mm) of the ship-to's own receiving window; see receivingWindowStart. */
  receivingWindowEnd?: InputMaybe<StringOperationFilterInput>;
  /** The start (HH:mm) of the ship-to's own receiving window. Null when it inherits the customer's. */
  receivingWindowStart?: InputMaybe<StringOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  /**
   * Ship-to route override — tier 3 of the hierarchical route setting. Empty means "inherit the
   * customer's route". Read by MongoCustomerService.GetInheritedRoute.
   */
  route?: InputMaybe<StringOperationFilterInput>;
  /**
   * Location-level override of the invoice-email toggle.
   * null means inherit from customer; a concrete value overrides.
   */
  sendInvoiceEmails?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Location-level override of the order-confirmation-email toggle.
   * null means inherit from customer; a concrete value overrides.
   */
  sendOrderEmails?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The WorkSuite-native SiteLocationId of the site that services this ship-to, as set by
   * setCustomerLocationServicingSite. EMPTY means no servicing site is assigned — there is
   * no inherited customer-level tier to fall back to. This is the explicit ship-to to site link
   * the order-email workers are to read when resolving that site's contacts; those workers still
   * match a site by a prefix of the location code today, a convention this field is intended to
   * replace but does not itself retire.
   */
  servicingSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  settings?: InputMaybe<CustomerLocationSettingsDocumentFilterInput>;
  storeNumber?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
  termsName?: InputMaybe<StringOperationFilterInput>;
  /** The ship-to's own unload minutes. Null when it inherits the customer's. */
  unloadMinutes?: InputMaybe<IntOperationFilterInput>;
};

export type CustomerLocationDocumentSortInput = {
  adGroup?: InputMaybe<SortEnumType>;
  address?: InputMaybe<AddressDataSortInput>;
  allowOrderBillingAddressEdit?: InputMaybe<SortEnumType>;
  allowOrderLocationAddressEdit?: InputMaybe<SortEnumType>;
  /**
   * Ship-to freight carrier override — tier 2 of the hierarchical carrier setting. Empty means
   * "inherit the customer's carrier". Read by MongoCustomerService.GetInheritedCarrier.
   */
  carrier?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerLookupCode?: InputMaybe<SortEnumType>;
  /** The display name of the customer associated with this location. */
  customerName?: InputMaybe<SortEnumType>;
  /**
   * The ship-to's own default contact: one of this customer's contact ids, stored 32-hex (no
   * dashes). Null when the ship-to inherits the customer's Primary contact. Cleared when that
   * contact is removed. The effective contact (this, else the customer's first active Primary
   * contact) is computed on read and never stored.
   */
  defaultContactId?: InputMaybe<SortEnumType>;
  /** The kept ship-to id when this row was folded by a customer combine. */
  foldedIntoLocationId?: InputMaybe<SortEnumType>;
  /** The freight charge type override for this location, or null if inheriting from customer. */
  freightChargeType?: InputMaybe<SortEnumType>;
  /** The freight charge value override for this location. */
  freightChargeValue?: InputMaybe<SortEnumType>;
  globalLocationNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * Optional GPS latitude for this retail ship-to. Null means unset/cleared. Persisted by
   * setCustomerLocationCoordinates; shared AddressData stays postal-only.
   */
  latitude?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationLookupCode?: InputMaybe<SortEnumType>;
  /** Optional GPS longitude paired with Latitude. */
  longitude?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /**
   * Location-level "purchase order required" override. Null means "inherit from the
   * customer" (the resolved value falls back to the customer-level flag, default false);
   * true/false is an explicit per-location override.
   */
  poRequired?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceGroupName?: InputMaybe<SortEnumType>;
  /** The ship-to's receiving email, where its delivery notices go. Null when none is set. */
  receivingEmail?: InputMaybe<SortEnumType>;
  /** The end (HH:mm) of the ship-to's own receiving window; see receivingWindowStart. */
  receivingWindowEnd?: InputMaybe<SortEnumType>;
  /** The start (HH:mm) of the ship-to's own receiving window. Null when it inherits the customer's. */
  receivingWindowStart?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  /**
   * Ship-to route override — tier 3 of the hierarchical route setting. Empty means "inherit the
   * customer's route". Read by MongoCustomerService.GetInheritedRoute.
   */
  route?: InputMaybe<SortEnumType>;
  /**
   * Location-level override of the invoice-email toggle.
   * null means inherit from customer; a concrete value overrides.
   */
  sendInvoiceEmails?: InputMaybe<SortEnumType>;
  /**
   * Location-level override of the order-confirmation-email toggle.
   * null means inherit from customer; a concrete value overrides.
   */
  sendOrderEmails?: InputMaybe<SortEnumType>;
  /**
   * The WorkSuite-native SiteLocationId of the site that services this ship-to, as set by
   * setCustomerLocationServicingSite. EMPTY means no servicing site is assigned — there is
   * no inherited customer-level tier to fall back to. This is the explicit ship-to to site link
   * the order-email workers are to read when resolving that site's contacts; those workers still
   * match a site by a prefix of the location code today, a convention this field is intended to
   * replace but does not itself retire.
   */
  servicingSiteLocationId?: InputMaybe<SortEnumType>;
  settings?: InputMaybe<CustomerLocationSettingsDocumentSortInput>;
  storeNumber?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
  termsName?: InputMaybe<SortEnumType>;
  /** The ship-to's own unload minutes. Null when it inherits the customer's. */
  unloadMinutes?: InputMaybe<SortEnumType>;
};

/**
 * One group header for the Restock Locations sidebar: the group's Key (also used as the
 * where eq-value when lazy-loading the group's children via restockCustomerLocations), a
 * display Label, and the server-computed Count of locations in the group
 * under the active search.
 */
export type CustomerLocationGroupBucket = {
  __typename?: 'CustomerLocationGroupBucket';
  /** Number of locations in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /** Raw group key — the location's Region or Market value. */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for customerLocationGroups. Mirrors the Restock Locations sidebar's
 * group-by options so the client renders server-computed group headers instead of grouping the full
 * location list in memory. Both options are flat scalar fields on
 * RestockCustomerLocationDocument that map cleanly to the Restock Locations list
 * where eq-value (e.g. restockCustomerLocations(where: { region: { eq: "<Key>" } })),
 * so a bucket's Key is directly usable to lazy-load its
 * children. RestockCustomerLocationDocument carries no Status/location-type field, so the
 * Region/Market location dimensions are used instead of the speculative Status dimension.
 */
export enum CustomerLocationGroupField {
  /** One bucket per distinct location Market. */
  Market = 'MARKET',
  /** One bucket per distinct location Region. */
  Region = 'REGION'
}

/** MongoDB document for customer location notes. */
export type CustomerLocationNoteDocument = {
  __typename?: 'CustomerLocationNoteDocument';
  id: Scalars['String']['output'];
  noteText: Scalars['String']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
};

/** MongoDB document for customer location notes. */
export type CustomerLocationNoteDocumentFilterInput = {
  and?: InputMaybe<Array<CustomerLocationNoteDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  noteText?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerLocationNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerLocationSettingsData = {
  __typename?: 'CustomerLocationSettingsData';
  deliveryScheduleId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<NoteData>>;
  retailerName: Scalars['String']['output'];
  route?: Maybe<Scalars['String']['output']>;
  ruleIds: Array<Scalars['String']['output']>;
  shippingNotes?: Maybe<Scalars['String']['output']>;
  storeClass: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

export type CustomerLocationSettingsDataInput = {
  deliveryScheduleId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Array<NoteDataInput>>;
  retailerName: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  ruleIds: Array<Scalars['String']['input']>;
  shippingNotes?: InputMaybe<Scalars['String']['input']>;
  storeClass: Scalars['String']['input'];
  zone: Scalars['String']['input'];
};

/** MongoDB document for customer location settings. */
export type CustomerLocationSettingsDocument = {
  __typename?: 'CustomerLocationSettingsDocument';
  /**
   * Per-location typed notes — one current value per NoteContext (Ship/Pull/General).
   * The single source of truth for the location's notes; the legacy flat ShippingNotes
   * is a derived read of the Ship entry. Written by
   * CustomerLocationProjectionService on the typed-note events. A separate concern from the
   * legacy append-only Notes activity log.
   */
  contextNotes: Array<CustomerLocationContextNoteDocument>;
  deliveryScheduleId: Scalars['String']['output'];
  deliveryScheduleName: Scalars['String']['output'];
  notes: Array<CustomerLocationNoteDocument>;
  retailerName: Scalars['String']['output'];
  route: Scalars['String']['output'];
  ruleIds: Array<Scalars['String']['output']>;
  /**
   * Backward-compatible flat shipping-notes value. As of per-location typed notes this is no longer
   * an independently-authored field: it is a denormalized mirror of the
   * Ship entry in ContextNotes (the single source of truth),
   * re-stamped by CustomerLocationProjectionService on every typed-note and legacy
   * settings event. Retained as a stored field (rather than a pure resolver) so existing GraphQL
   * filtering/sorting on settings.shippingNotes keeps working, and so existing clients
   * (worksuite-pwa LocationForm / CustomerLocationFields) that select
   * shippingNotes keep working until they migrate to contextNotes. Never written
   * from a value that competes with the Ship note.
   */
  shippingNotes: Scalars['String']['output'];
  storeClass: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

/** MongoDB document for customer location settings. */
export type CustomerLocationSettingsDocumentFilterInput = {
  and?: InputMaybe<Array<CustomerLocationSettingsDocumentFilterInput>>;
  /**
   * Per-location typed notes — one current value per NoteContext (Ship/Pull/General).
   * The single source of truth for the location's notes; the legacy flat ShippingNotes
   * is a derived read of the Ship entry. Written by
   * CustomerLocationProjectionService on the typed-note events. A separate concern from the
   * legacy append-only Notes activity log.
   */
  contextNotes?: InputMaybe<ListFilterInputTypeOfCustomerLocationContextNoteDocumentFilterInput>;
  deliveryScheduleId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Always "" in MongoDB — never written by any projection.
   * The real value is resolved at the GraphQL layer via CustomerLocationSettingsDocumentResolvers.GetDeliveryScheduleNameAsync.
   */
  deliveryScheduleName?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<ListFilterInputTypeOfCustomerLocationNoteDocumentFilterInput>;
  or?: InputMaybe<Array<CustomerLocationSettingsDocumentFilterInput>>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  route?: InputMaybe<StringOperationFilterInput>;
  ruleIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Backward-compatible flat shipping-notes value. As of per-location typed notes this is no longer
   * an independently-authored field: it is a denormalized mirror of the
   * Ship entry in ContextNotes (the single source of truth),
   * re-stamped by CustomerLocationProjectionService on every typed-note and legacy
   * settings event. Retained as a stored field (rather than a pure resolver) so existing GraphQL
   * filtering/sorting on settings.shippingNotes keeps working, and so existing clients
   * (worksuite-pwa LocationForm / CustomerLocationFields) that select
   * shippingNotes keep working until they migrate to contextNotes. Never written
   * from a value that competes with the Ship note.
   */
  shippingNotes?: InputMaybe<StringOperationFilterInput>;
  storeClass?: InputMaybe<StringOperationFilterInput>;
  zone?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB document for customer location settings. */
export type CustomerLocationSettingsDocumentSortInput = {
  deliveryScheduleId?: InputMaybe<SortEnumType>;
  /**
   * Always "" in MongoDB — never written by any projection.
   * The real value is resolved at the GraphQL layer via CustomerLocationSettingsDocumentResolvers.GetDeliveryScheduleNameAsync.
   */
  deliveryScheduleName?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  route?: InputMaybe<SortEnumType>;
  /**
   * Backward-compatible flat shipping-notes value. As of per-location typed notes this is no longer
   * an independently-authored field: it is a denormalized mirror of the
   * Ship entry in ContextNotes (the single source of truth),
   * re-stamped by CustomerLocationProjectionService on every typed-note and legacy
   * settings event. Retained as a stored field (rather than a pure resolver) so existing GraphQL
   * filtering/sorting on settings.shippingNotes keeps working, and so existing clients
   * (worksuite-pwa LocationForm / CustomerLocationFields) that select
   * shippingNotes keep working until they migrate to contextNotes. Never written
   * from a value that competes with the Ship note.
   */
  shippingNotes?: InputMaybe<SortEnumType>;
  storeClass?: InputMaybe<SortEnumType>;
  zone?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CustomerLocationsConnection = {
  __typename?: 'CustomerLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerLocationsEdge = {
  __typename?: 'CustomerLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerLocationDocument;
};

/** A connection to a list of items. */
export type CustomerLocationsWithBaseRateOfSaleConnection = {
  __typename?: 'CustomerLocationsWithBaseRateOfSaleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerLocationsWithBaseRateOfSaleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerLocationsWithBaseRateOfSaleEdge = {
  __typename?: 'CustomerLocationsWithBaseRateOfSaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerLocationDocument;
};

/**
 * Server-computed order-history and accounts-receivable rollup for one customer, produced by a single
 * MongoDB aggregation over the combined-orders read model. Every figure here covers ONE order set: the
 * customer's orders excluding master orders, cancelled orders and deleted orders — only orders actually
 * placed count, and a withdrawn order never inflates a total. Master orders are recurring templates rather
 * than purchases and carry no payment ledger, so they are excluded outright rather than counted in some
 * figures and not others. A customer with no orders yields a zeroed instance rather than null.
 */
export type CustomerOrderStats = {
  __typename?: 'CustomerOrderStats';
  /** The arBalance split into days-past-due buckets. */
  aging: CustomerArAging;
  /**
   * Sum of amounts paid across every order in scope — the same order set as lifetimeOrderValue, so the
   * two are read side by side. This is a server-side total in its own right, deliberately NOT
   * lifetimeOrderValue less arBalance: those two cover different order sets (drafts are in the lifetime
   * figure and out of the AR figure), so subtracting one from the other reports money as paid that was
   * never paid.
   */
  amountPaid: Scalars['Decimal']['output'];
  /**
   * Total money the customer owes: the sum of every standing invoice's open balance, sales tax
   * included, as of now.
   *
   * THE RECEIVABLE IS THE INVOICE, not the order. Nothing is owed until an order has been invoiced,
   * and once it has, what is owed is what the invoice billed on the shipped basis less what has been
   * recorded against it. A voided invoice contributes nothing — it is excluded by its status, not by
   * its balance, which a void deliberately leaves standing.
   *
   * This is the same figure customerReceivables reports for the same customer, read from the same
   * invoices through the same rule, so the two cannot disagree — subject to the caller's own order
   * visibility, which narrows this rollup as it narrows the counters beside it.
   *
   * Accrued late charges and available early-pay discounts are NOT in this figure. Both are as-of
   * amounts nobody has assessed yet, so neither is owed; read them from customerReceivables.
   */
  arBalance: Scalars['Decimal']['output'];
  /** Lifetime order value divided by order count; 0 when the customer has no orders. */
  averageOrderValue: Scalars['Decimal']['output'];
  /** Initialized date of the customer's earliest order; null when there is none. */
  firstOrderDate?: Maybe<Scalars['DateTime']['output']>;
  /** Initialized date of the customer's most recent order; null when there is none. */
  lastOrderDate?: Maybe<Scalars['DateTime']['output']>;
  /** Sum of order totals across every order in scope. */
  lifetimeOrderValue: Scalars['Decimal']['output'];
  /**
   * Number of orders that have neither completed nor been withdrawn: the drafts (initialized, open), the
   * orders in fulfillment (submitted, acknowledged, picked, shipped), and sync-error orders, which are
   * quarantined mid-flight rather than finished.
   *
   * This set counts ORDERS, while arBalance counts invoices, so the two are not meant to agree and
   * should not be reconciled against each other. An order that is still open has usually not been
   * invoiced at all, and nothing is owed until it has been.
   */
  openOrderCount: Scalars['Int']['output'];
  /**
   * Number of the customer's orders in scope. Master orders, cancelled orders and deleted orders are
   * excluded.
   */
  totalOrderCount: Scalars['Int']['output'];
  /** Sum of order totals for orders initialized on or after January 1st of the current year. */
  ytdOrderValue: Scalars['Decimal']['output'];
};

export type CustomerPayload = {
  __typename?: 'CustomerPayload';
  customer?: Maybe<CustomerStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * The buyer-safe view of a customer account served to portal users. It carries only what the
 * portal Account page and checkout need, so office-only customer fields stay unselectable.
 */
export type CustomerPortalAccountData = {
  __typename?: 'CustomerPortalAccountData';
  billingAddresses: Array<CreateAddress>;
  contacts: Array<CustomerPortalContactData>;
  customerId: Scalars['String']['output'];
  /** The unit this customer's orders are placed in: the customer's own override when set, otherwise the tenant default. */
  effectiveOrderEntryUnit: OrderEntryUnit;
  /** How sales prices are entered and shown for this customer: per each or per shipping unit. Prices are always stored and billed per each. The customer's own override when set, otherwise the company default, otherwise each. */
  effectivePriceEntryUnit: PriceEntryUnit;
  erpId: Scalars['String']['output'];
  locations: Array<CustomerPortalLocationData>;
  name: Scalars['String']['output'];
  orderSubmitter?: Maybe<OrderSubmitterData>;
  priceGroupId: Scalars['String']['output'];
  /** The sales reps assigned to the customer itself, readable without a ship-to location. */
  salesPeople: Array<SalesPersonData>;
  shipFromLocations: Array<ShipFromLocationData>;
  termsId: Scalars['String']['output'];
  termsName: Scalars['String']['output'];
};

/** account is always set on success; null exactly when errors is non-empty. */
export type CustomerPortalAccountPayload = {
  __typename?: 'CustomerPortalAccountPayload';
  account?: Maybe<CustomerPortalAccountData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A contact a buyer adds to their own company. The server assigns its id. */
export type CustomerPortalAddContactInput = {
  emailAddresses: Array<EmailAddressDataInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumbers: Array<PhoneNumberDataInput>;
  title: Scalars['String']['input'];
  type: ContactType;
};

/** Input of customerPortalCancelOrder. */
export type CustomerPortalCancelOrderInput = {
  orderId: Scalars['String']['input'];
};

/**
 * Result of customerPortalCancelOrder. result is set whenever the order was looked up;
 * order is present for every result except NOT_AVAILABLE; errors carries a refusal
 * raised before the lookup (wrong tenant, staff caller, portal disabled, inactive customer) or a failed
 * write, and then result is null.
 */
export type CustomerPortalCancelOrderPayload = {
  __typename?: 'CustomerPortalCancelOrderPayload';
  errors?: Maybe<Array<ValidationError>>;
  order?: Maybe<OrderStateData>;
  result?: Maybe<CustomerPortalCancelOrderResult>;
};

/**
 * The authoritative answer to a buyer's cancel, read from the order's own stream and never from the
 * Orders read model, so it holds even while that read model lags.
 */
export enum CustomerPortalCancelOrderResult {
  /** The caller's order was already Cancelled or Deleted. It can no longer become a live order. */
  AlreadyClosed = 'ALREADY_CLOSED',
  /** The caller's own order was live and not past the stock release (Open or Submitted, for example) and is now Cancelled. */
  Cancelled = 'CANCELLED',
  /**
   * No order by that id is available to this caller. A missing order and another customer's order give
   * this same answer with no order in the payload.
   */
  NotAvailable = 'NOT_AVAILABLE',
  /**
   * The caller's own order is live but past the stock release (shipped or later), so it needs a credit or
   * return, or it is an unsubmitted draft. Nothing was changed; the order is returned so the app can say what
   * state it is in.
   */
  NotCancellable = 'NOT_CANCELLABLE'
}

/** A contact on the buyer-safe portal account. */
export type CustomerPortalContactData = {
  __typename?: 'CustomerPortalContactData';
  emailAddresses: Array<EmailAddressData>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  phoneNumbers: Array<PhoneNumberData>;
  title: Scalars['String']['output'];
  type: ContactType;
};

/** A connection to a list of items. */
export type CustomerPortalFavoritesListsConnection = {
  __typename?: 'CustomerPortalFavoritesListsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalFavoritesListsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FavoritesListDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalFavoritesListsEdge = {
  __typename?: 'CustomerPortalFavoritesListsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FavoritesListDocument;
};

/** A connection to a list of items. */
export type CustomerPortalInventoryAvailabilityConnection = {
  __typename?: 'CustomerPortalInventoryAvailabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalInventoryAvailabilityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InventoryItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalInventoryAvailabilityEdge = {
  __typename?: 'CustomerPortalInventoryAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InventoryItemDocument;
};

/** One of the signed-in buyer's own invoices, as the customer portal shows it. */
export type CustomerPortalInvoice = {
  __typename?: 'CustomerPortalInvoice';
  /** The payments recorded against the invoice. */
  amountPaid: Scalars['Decimal']['output'];
  /** Whether the grower can take an online payment right now, and the ways Checkout would offer to pay. */
  availability: InvoicePaymentAvailability;
  /** The ISO-4217 currency the invoice is billed in. */
  currency: Scalars['String']['output'];
  /** The deposit already held against the order, applied to this invoice as a credit. */
  depositApplied: Scalars['Decimal']['output'];
  /** The date payment is due. */
  dueDate: Scalars['DateTime']['output'];
  /** The freight charged. */
  freight: Scalars['Decimal']['output'];
  /** The date the invoice was issued. */
  invoiceDate: Scalars['DateTime']['output'];
  /** The invoice's id. */
  invoiceId: Scalars['String']['output'];
  /** The invoice number the buyer was billed under. */
  invoiceNumber: Scalars['String']['output'];
  /** Why the latest online payment of this invoice failed, when it did; otherwise null. */
  lastFailure?: Maybe<Scalars['String']['output']>;
  /** The billed lines, in line order. */
  lines: Array<CustomerPortalInvoiceLine>;
  /**
   * The online payment holding this invoice, OPEN or PROCESSING, from the portal or a pay link, with its id; null when
   * none holds it. OPEN can be resumed with Pay; PROCESSING means a payment is in progress.
   */
  openAttempt?: Maybe<InvoicePaymentOpenAttempt>;
  /** The payments recorded against the invoice, oldest first. */
  payments: Array<CustomerPortalInvoicePayment>;
  /**
   * What a bank payment still clearing will pay toward this invoice; zero when none is clearing. Not yet in
   * postedBalance.
   */
  pendingAmount: Scalars['Decimal']['output'];
  /**
   * What the invoice still owes from the payments and adjustments recorded against it. Not a payment quote: an
   * early-pay discount or a late charge that has not been recorded is not in it.
   */
  postedBalance: Scalars['Decimal']['output'];
  /**
   * What paying the invoice in full online costs right now, with its discount and late charge, and until when that
   * price holds; null unless status is PAYABLE. Viewing it locks nothing: Pay prices the invoice again.
   */
  quote?: Maybe<InvoicePaymentQuote>;
  /** PAYABLE, PAID, VOIDED or UNAVAILABLE. */
  status: CustomerInvoiceStatus;
  /** The sum of the lines' billed amounts, before freight and tax. */
  subtotal: Scalars['Decimal']['output'];
  /** The final tax by jurisdiction; empty when taxStatus is NOT_CALCULATED. */
  taxRows: Array<CustomerPortalInvoiceTaxRow>;
  /** CALCULATED when sales tax was calculated for this invoice; NOT_CALCULATED when it never was. */
  taxStatus: InvoiceTaxStatus;
  /** The final sales tax charged. Zero with taxStatus NOT_CALCULATED means none was calculated. */
  taxTotal: Scalars['Decimal']['output'];
  /** What the invoice billed, after the deposit credit. */
  total: Scalars['Decimal']['output'];
};

/** What a portal buyer's Pay or Pay selected got: Stripe's hosted Checkout URL, or a typed refusal. */
export type CustomerPortalInvoiceCheckoutStartPayload = {
  __typename?: 'CustomerPortalInvoiceCheckoutStartPayload';
  /**
   * The payment attempt the session belongs to, whose status customerPortalInvoicePaymentAttempt reads; set only when
   * the start succeeded.
   */
  attemptId?: Maybe<Scalars['String']['output']>;
  /** The hosted Checkout URL to redirect to; set only when the start succeeded. */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** Why the start was refused; null when it succeeded. */
  refusal?: Maybe<InvoiceCheckoutRefusal>;
};

/** One billed line of a buyer's invoice. */
export type CustomerPortalInvoiceLine = {
  __typename?: 'CustomerPortalInvoiceLine';
  /** The discount taken off the line. */
  discountAmount: Scalars['Decimal']['output'];
  /** The line's billed amount. */
  extended: Scalars['Decimal']['output'];
  /** The item's name as billed. */
  itemName: Scalars['String']['output'];
  /** The line's position on the invoice. */
  lineNumber: Scalars['Int']['output'];
  /** The quantity billed, on the shipped basis. */
  shippedQuantity: Scalars['Int']['output'];
  /** The item's SKU as billed. */
  sku: Scalars['String']['output'];
  /** The sales tax attributed to the line. */
  taxAmount: Scalars['Decimal']['output'];
  /** The price per unit. */
  unitPrice: Scalars['Decimal']['output'];
};

/** One payment recorded against a buyer's invoice. */
export type CustomerPortalInvoicePayment = {
  __typename?: 'CustomerPortalInvoicePayment';
  /** The amount received. */
  amount: Scalars['Decimal']['output'];
  /** The early-pay discount taken with the payment. */
  discountTaken: Scalars['Decimal']['output'];
  /** The late charge assessed with the payment. */
  lateChargeAssessed: Scalars['Decimal']['output'];
  /** How the payment reached the grower. */
  method: InvoicePaymentMethod;
  /** When the payment was received. */
  receivedDate: Scalars['DateTime']['output'];
  /** The payer-side reference, such as a check number, or null when none was recorded. */
  reference?: Maybe<Scalars['String']['output']>;
};

/** The combined quote a portal buyer sees before Pay selected, or why there is none. */
export type CustomerPortalInvoicePaymentQuotePayload = {
  __typename?: 'CustomerPortalInvoicePaymentQuotePayload';
  /** The combined quote; null when refused. */
  quote?: Maybe<InvoicePaymentCombinedQuote>;
  /** Why these invoices cannot be quoted together; null when quoted. */
  refusal?: Maybe<InvoiceCheckoutRefusal>;
};

/** One jurisdiction's final sales tax on a buyer's invoice. */
export type CustomerPortalInvoiceTaxRow = {
  __typename?: 'CustomerPortalInvoiceTaxRow';
  /** The tax charged. */
  amount: Scalars['Decimal']['output'];
  /** The taxing jurisdiction's name. */
  jurisdiction: Scalars['String']['output'];
  /** The jurisdiction's level, such as state or county. */
  level: Scalars['String']['output'];
  /** The rate charged, as a percentage. */
  rate: Scalars['Decimal']['output'];
  /** Why the tax is what it is, such as standard_rated or not_collecting. */
  reason: Scalars['String']['output'];
  /** The state the jurisdiction is in, or null when none applies. */
  state?: Maybe<Scalars['String']['output']>;
  /** The amount the rate was applied to. */
  taxableAmount: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type CustomerPortalInvoicesConnection = {
  __typename?: 'CustomerPortalInvoicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalInvoicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerPortalInvoice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalInvoicesEdge = {
  __typename?: 'CustomerPortalInvoicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerPortalInvoice;
};

/** A connection to a list of items. */
export type CustomerPortalItemGradeAvailabilityConnection = {
  __typename?: 'CustomerPortalItemGradeAvailabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalItemGradeAvailabilityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PortalItemGradeAvailabilityData>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalItemGradeAvailabilityEdge = {
  __typename?: 'CustomerPortalItemGradeAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PortalItemGradeAvailabilityData;
};

/** A connection to a list of items. */
export type CustomerPortalItemsConnection = {
  __typename?: 'CustomerPortalItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalItemsEdge = {
  __typename?: 'CustomerPortalItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemSummaryDocument;
};

/** A ship-to location on the buyer-safe portal account. */
export type CustomerPortalLocationData = {
  __typename?: 'CustomerPortalLocationData';
  address: CreateAddress;
  code: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  salesPeople: Array<SalesPersonData>;
};

/**
 * The order header a buyer places with customerPortalPlaceOrder. Everything the server decides is absent:
 * the order id is the mutation's own argument, the order number is drawn once every check passed, and the discount,
 * the placed date, the import key and the ERP id are never a buyer's to set.
 */
export type CustomerPortalPlaceOrderHeaderDataInput = {
  /** The carrier, or none to inherit it. */
  carrier?: InputMaybe<Scalars['String']['input']>;
  /** The buyer's customer, ship-to, bill-to and contact. Must be the caller's own customer. */
  customer: OrderCustomerDataInput;
  /** The delivery date, checked against the ship-to's delivery schedule. */
  expectedDeliveryDate: Scalars['DateTime']['input'];
  /** Whether the order is a final credit (tenant setting must allow it). */
  finalCredit?: Scalars['Boolean']['input'];
  /** The ship-from location. */
  fromLocation: ShipFromLocationDataInput;
  /** The buyer's PO number. */
  poNumber: Scalars['String']['input'];
  /** Whether the order allocates produce (tenant setting must allow it). */
  produceAllocate?: Scalars['Boolean']['input'];
  /** The sales person, checked against the ship-to. */
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  /** The structured ship-from site, if any. */
  shipFromSiteLocationId?: InputMaybe<Scalars['String']['input']>;
  /** The terms, or none to inherit them. */
  termsId?: InputMaybe<Scalars['String']['input']>;
  /** The order type. */
  type: OrderType;
};

/**
 * The answer to customerPortalPlaceOrder: result and order when the order is placed or was
 * already placed, errors (and, for an availability, delivery-date or combine refusal, the matching recovery
 * field) when it is refused. A refusal writes nothing.
 */
export type CustomerPortalPlaceOrderPayload = {
  __typename?: 'CustomerPortalPlaceOrderPayload';
  /** Per-item shortfalls, with CUSTOMER_PORTAL_INSUFFICIENT_AVAILABILITY. */
  availabilityShortfalls?: Maybe<Array<PortalAvailabilityShortfallData>>;
  /** The orderable dates, with a delivery-date refusal. */
  deliveryDateRejection?: Maybe<PortalDeliveryDateRejectionData>;
  /** The refusal; null on success. */
  errors?: Maybe<Array<ValidationError>>;
  /** The order; null on a refusal. */
  order?: Maybe<OrderStateData>;
  /** What the call did; null on a refusal. */
  result?: Maybe<CustomerPortalPlaceOrderResult>;
  /** The surviving customer id with CUSTOMER_COMBINED; refresh the buyer token before retrying once with this id. Null otherwise. */
  survivorCustomerId?: Maybe<Scalars['String']['output']>;
  /** The surviving ship-to location id with SHIP_TO_COMBINED; null otherwise. */
  survivorShipToLocationId?: Maybe<Scalars['String']['output']>;
};

/** What customerPortalPlaceOrder did. */
export enum CustomerPortalPlaceOrderResult {
  /** The caller's order with this id already exists; it is returned and nothing was written. */
  AlreadyPlaced = 'ALREADY_PLACED',
  /** The order was created, with its lines, in this call's one append. */
  Placed = 'PLACED'
}

/** The contact a buyer removes from their own company. */
export type CustomerPortalRemoveContactInput = {
  contactId: Scalars['UUID']['input'];
};

/** What a buyer's reviewed draft row does to the item's retail price. */
export enum CustomerPortalRetailPriceAction {
  /** Cancels a scheduled future standing price and keeps the price in effect today. */
  CancelScheduledStanding = 'CANCEL_SCHEDULED_STANDING',
  /** Clears the standing price from today and any running or scheduled promo. */
  Clear = 'CLEAR',
  /** Removes a running or scheduled promo and keeps the standing price. */
  RemovePromo = 'REMOVE_PROMO',
  /** Sets a standing price or a promo. Takes a price; the dates are optional. */
  Set = 'SET'
}

/** A connection to a list of items. */
export type CustomerPortalRetailPriceHistoryConnection = {
  __typename?: 'CustomerPortalRetailPriceHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalRetailPriceHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerRetailPriceRecord>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalRetailPriceHistoryEdge = {
  __typename?: 'CustomerPortalRetailPriceHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerRetailPriceRecord;
};

/**
 * One reviewed draft row. baselineToken is the token read with the item's customerRetailPrice,
 * or null when the item showed no customerRetailPrice. Only a SET row takes a price and dates,
 * and a SET row must have a price: a missing price never means clear. Dates follow the staff import:
 * none is a standing price from today, an end date alone is a promo from today, both are a promo, and a start
 * date alone is a standing price from that day.
 */
export type CustomerPortalRetailPriceRowInput = {
  action: CustomerPortalRetailPriceAction;
  baselineToken?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveUntil?: InputMaybe<Scalars['DateTime']['input']>;
  itemId: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Decimal']['input']>;
};

/**
 * One draft row of a save, in input order. customerRetailPrice is the item's retail price as it stands now,
 * with its current baselineToken, for every row whose item is in the catalog, whatever its status; null for an
 * item with no customer-level record, for an item not in the catalog, and for a refused save's invalid rows.
 */
export type CustomerPortalRetailPriceRowResult = {
  __typename?: 'CustomerPortalRetailPriceRowResult';
  action: CustomerPortalRetailPriceAction;
  customerRetailPrice?: Maybe<CustomerRetailPrice>;
  errors: Array<ValidationError>;
  itemId: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  status: CustomerPortalRetailPriceRowStatus;
};

/** Where one draft row is. */
export enum CustomerPortalRetailPriceRowStatus {
  /** Saved. */
  Applied = 'APPLIED',
  /**
   * Its outcome is not known: it failed after its first write, or on a fault, so part of the change may be saved.
   * Review the refreshed price.
   */
  Incomplete = 'INCOMPLETE',
  /** Not saved yet: the worker has not reached it. */
  Pending = 'PENDING',
  /** Refused before anything was written; errors says why. */
  Rejected = 'REJECTED',
  /** Never attempted, because the save was cancelled first. */
  Skipped = 'SKIPPED',
  /** Already the item's retail price, so nothing was written. A re-sent save that landed reads this. */
  Unchanged = 'UNCHANGED'
}

/**
 * A buyer's stored retail price save and how far the worker has got. done counts rows that read
 * APPLIED or UNCHANGED, failed rows that read REJECTED or INCOMPLETE; the save is
 * finished once status is COMPLETED, COMPLETED_WITH_ERRORS, CANCELLED or FAILED.
 */
export type CustomerPortalRetailPriceSave = {
  __typename?: 'CustomerPortalRetailPriceSave';
  createdAt: Scalars['DateTime']['output'];
  done: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  jobId: Scalars['String']['output'];
  /**
   * One page of the save's rows in input order: take rows (1 to 100) after skipping
   * skip. Each carries its status and errors, and the item's retail price as it stands now with
   * its current baselineToken, read the way the catalog reads it, in one read for the page.
   */
  rows: Array<CustomerPortalRetailPriceRowResult>;
  status: BackgroundJobStatus;
  total: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A buyer's stored retail price save and how far the worker has got. done counts rows that read
 * APPLIED or UNCHANGED, failed rows that read REJECTED or INCOMPLETE; the save is
 * finished once status is COMPLETED, COMPLETED_WITH_ERRORS, CANCELLED or FAILED.
 */
export type CustomerPortalRetailPriceSaveRowsArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

/**
 * Up to 2,000 reviewed draft rows, saved one at a time in input order by the background jobs worker.
 * jobId is a GUID the screen reserves for this save: sending it again returns the save already stored.
 */
export type CustomerPortalSaveRetailPricesInput = {
  jobId: Scalars['String']['input'];
  rows: Array<CustomerPortalRetailPriceRowInput>;
};

/**
 * save is the stored save, which the worker then runs; read its progress and rows with
 * customerPortalRetailPriceSave. errors is set when the whole save was refused and nothing was stored,
 * which leaves save null. When the refusal is RETAIL_PRICE_ROWS_INVALID, invalidRows carries
 * each refused row, in input order, with its error; it is empty otherwise.
 */
export type CustomerPortalSaveRetailPricesPayload = {
  __typename?: 'CustomerPortalSaveRetailPricesPayload';
  errors?: Maybe<Array<ValidationError>>;
  invalidRows: Array<CustomerPortalRetailPriceRowResult>;
  save?: Maybe<CustomerPortalRetailPriceSave>;
};

/** A connection to a list of items. */
export type CustomerPortalSellableHardgoodsConnection = {
  __typename?: 'CustomerPortalSellableHardgoodsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalSellableHardgoodsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalSellableHardgoodsEdge = {
  __typename?: 'CustomerPortalSellableHardgoodsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemDocument;
};

/**
 * Customer-readable, read-only projection of the portal settings. Surfaces the
 * enforcement fields the worksuite-pwa portal needs to gate a real customer session:
 * portalEnabled (route guard), minimumOrderAmount (cart minimum),
 * CatalogDisplayMode (catalog view), and the FULFILL "Availability rule"
 * (availabilityMinGrade + availabilityLocationIds, the rule's location pin resolved to
 * the location set it admits) the portal feeds into the existing
 * customerPortalInventoryAvailability grade/location filter so a customer sees exactly the
 * items the operator made available. It is the customer-scope counterpart of the
 * staff-only portal settings and is returned by the
 * customerPortalSettings query (task 729b97fa). showGradeOnPortal plus the
 * gradeLabels type-extension field carry the grade-display contract (task a409b39f):
 * whether to show grades at all, and the vocabulary to show them in.
 */
export type CustomerPortalSettingsData = {
  __typename?: 'CustomerPortalSettingsData';
  /**
   * Location filter of the FULFILL "Availability rule" as saved (a site or a sub-location id);
   * nullable — null means "all locations". A site pin also covers every location under the
   * site, so match inventory against availabilityLocationIds, not this id.
   */
  availabilityLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * The location ids the Availability rule admits, resolved from its availabilityLocationId pin. Empty
   * when there is no pin (every location is admitted). For a site pin: the site id, then every location
   * under the site (its sub-locations at every depth and the legacy locations it owns, whatever their
   * status). For a sub-location pin: that id, then every active sub-location beneath it at any depth
   * (a leaf admits only itself). Match inventory location ids against this list rather than
   * availabilityLocationId, so a pin admits the stock held under it; it is the same set the server
   * applies to portal availability.
   */
  availabilityLocationIds: Array<Scalars['String']['output']>;
  /**
   * Minimum inventory grade (grade-or-higher) of the FULFILL "Availability rule". 0 is the
   * "Any" option (no grade floor, so gradeless hard-good inventory is included); a tenant that has
   * never saved settings reads 1 (the lowest live grade, so every live grade shows).
   */
  availabilityMinGrade: Scalars['Int']['output'];
  /**
   * Retired. The availability source the tenant last saved; it no longer changes anything.
   * Every tenant's portal availability (catalog, inventory availability and the add-to-cart limit)
   * comes from inventory on hand minus allocated, through the Availability rule. Reads
   * LEDGER on a tenant that has never saved settings.
   */
  availabilitySource: AvailabilitySource;
  /**
   * The Portal "Buyers can edit their contacts" setting: whether this customer may add, edit and
   * remove its own contacts on the portal Account page. Defaults to false on a tenant that
   * has never opted in, and on any tenant whose settings stream predates this flag. The portal
   * shows edit controls only when it is on.
   */
  buyerContactEditingEnabled: Scalars['Boolean']['output'];
  /**
   * Whether this customer may save its own retail prices from the portal right now: true
   * only while the portal, Pre-pricing and the grower's "Buyers can edit their retail prices"
   * setting are all on. Defaults to false. The portal shows retail price edit controls only
   * when it is on.
   */
  buyerRetailPriceEditingEnabled: Scalars['Boolean']['output'];
  /**
   * What the catalog's filter chips are built from: CATEGORY (the default, and what any
   * tenant that never set it reads) or ITEM_GROUP.
   */
  catalogChipSource: CatalogChipSource;
  catalogDisplayMode: CatalogDisplayMode;
  /**
   * How this customer places orders: ONLINE_CHECKOUT (the default, and what any tenant that
   * never set it reads) or CALL_TO_ORDER. Under CALL_TO_ORDER the portal takes no
   * order and shows orderContact for the customer to call instead.
   */
  checkoutMethod: PortalCheckoutMethod;
  /**
   * The tenant's custom display labels for inventory grades 1–5 (e.g. grade 1 → "Premium"), for a
   * storefront that is showing grades because showGradeOnPortal is true. Only grades
   * the tenant has actually labelled appear — an unlabelled grade is ABSENT rather than invented,
   * so the client falls back to the numeric grade. Empty for a tenant that configured none, and
   * empty (never an error) for a tenant whose aggregate does not exist.
   */
  gradeLabels: Array<TenantGradeLabelData>;
  /**
   * The grower-designated help contact a customer is told to reach when no salesperson is
   * assigned; null when the grower has designated none. The client puts the assigned
   * salesperson first and shows this only when there is none. It is the one field a staff
   * member typed for customers to read, so it carries nothing but the contact itself.
   */
  helpContact?: Maybe<PortalHelpContactData>;
  /**
   * "Include sellable hard goods" option of the FULFILL "Availability rule". When true,
   * gradeless sellable hard goods are included in availability; defaults to false on a
   * tenant that has never opted in.
   */
  includeSellableHardGoods: Scalars['Boolean']['output'];
  minimumOrderAmount: Scalars['Decimal']['output'];
  /**
   * Who to call to place an order: present only while checkoutMethod is
   * CALL_TO_ORDER, and null otherwise even if staff saved a contact.
   */
  orderContact?: Maybe<PortalOrderContactData>;
  portalEnabled: Scalars['Boolean']['output'];
  /**
   * The Portal "Pre-pricing" setting: whether this customer sees the retail prices staff set for
   * it. While it is off, customerRetailPrice on catalog items answers null, and the
   * pull slips and container tags for its orders print no retail price. Defaults to false
   * on a tenant that has never opted in, and on any tenant whose settings stream predates this
   * flag. Turning it off does not clear saved retail prices; turning it back on restores them.
   */
  prePricingEnabled: Scalars['Boolean']['output'];
  /**
   * Whether this portal login's prices are hidden. While true, render no price, total, charge, tax, freight,
   * discount or balance anywhere, and offer no Invoices or Pay pages: every hidden money field still answers
   * (null, or 0 when it cannot be null), so a zero never means $0. Retail prices stay visible. Always false for
   * staff.
   */
  pricesHidden: Scalars['Boolean']['output'];
  /**
   * FULFILL Customer Portal "Show grade on portal" toggle. When true the storefront may
   * display each item's grade to the buyer, labelled with the tenant's grade-label vocabulary
   * (see the gradeLabels field on this type). Defaults to false on a tenant that has
   * never opted in — and on any tenant whose settings stream predates this flag — so grades stay
   * hidden unless an operator explicitly turns them on.
   */
  showGradeOnPortal: Scalars['Boolean']['output'];
};

/**
 * A buyer's edit of one of their own company's contacts. Every editable field is sent (PUT
 * semantics), exactly as the staff updateContact takes them.
 */
export type CustomerPortalUpdateContactInput = {
  contactId: Scalars['UUID']['input'];
  emailAddresses: Array<EmailAddressDataInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumbers: Array<PhoneNumberDataInput>;
  title: Scalars['String']['input'];
  type: ContactType;
};

/** A connection to a list of items. */
export type CustomerPortalUsersConnection = {
  __typename?: 'CustomerPortalUsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerPortalUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PortalUserDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerPortalUsersEdge = {
  __typename?: 'CustomerPortalUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PortalUserDocument;
};

/** One standing invoice on a customer's receivable — an aging-DETAIL row. */
export type CustomerReceivableInvoice = {
  __typename?: 'CustomerReceivableInvoice';
  /**
   * The finance charge this invoice has run up and nobody has assessed yet, as of the reference date,
   * NET of anything already forgiven. UNRECORDED — it is not in openBalance and is not owed
   * until a payment assesses it.
   */
  accruedLateCharge: Scalars['Decimal']['output'];
  /** The early-pay discount still on offer as of the reference date. Zero once the window has closed. */
  availableDiscount: Scalars['Decimal']['output'];
  /** How many days past due it is as of the read's reference date. Negative when not yet due. */
  daysPastDue: Scalars['Int']['output'];
  /** The date payment fell due, as frozen onto the invoice at issue. */
  dueDate: Scalars['DateTime']['output'];
  /** The date the customer was billed. */
  invoiceDate: Scalars['DateTime']['output'];
  /** The invoice's own id. The order it bills is the separate orderId field. */
  invoiceId: Scalars['String']['output'];
  /**
   * The invoice number: the order number on the order's first bill, and orderNumber-R1 and so on for a
   * bill raised after a previous one was withdrawn.
   */
  invoiceNumber: Scalars['String']['output'];
  /**
   * The finance charge already FORGIVEN on this invoice — the sum of its waivers. Shown beside
   * accruedLateCharge, which is already net of it, so a collections screen can say what was
   * forgiven rather than leaving a customer's charge looking mysteriously small.
   */
  lateChargeWaived: Scalars['Decimal']['output'];
  /** What the invoice still owes from the amounts recorded against it. */
  openBalance: Scalars['Decimal']['output'];
  /** The order this invoice bills. */
  orderId: Scalars['String']['output'];
  /**
   * The customer this invoice belonged to before a customer combine moved it onto this customer; null
   * for an invoice of the customer's own.
   */
  originalCustomerId?: Maybe<Scalars['String']['output']>;
  /** Whether the invoice reads as open or part paid. */
  standing: InvoiceStanding;
  /**
   * Whether the invoice's tax was CALCULATED at Stripe Tax, or was never calculated at all. A
   * NOT_CALCULATED row's taxTotal is $0 because nothing was computed, not
   * because nothing was owed — so a receivables surface must not present it as tax that was assessed.
   */
  taxStatus: InvoiceTaxStatus;
  /** The sales tax the invoice billed. Part of total, shown so a row foots. */
  taxTotal: Scalars['Decimal']['output'];
  /** What the invoice was owed at issue, after the deposit credit. */
  total: Scalars['Decimal']['output'];
};

/**
 * What one customer owes on the INVOICE basis, and the aging and accrual of it — the rollup that feeds
 * the receivables view, the aging report and the customer statement.
 */
export type CustomerReceivables = {
  __typename?: 'CustomerReceivables';
  /**
   * The finance charge the customer's overdue invoices have run up but nobody has assessed, summed per
   * invoice through the shared accrual rule and NET of anything already forgiven. NOT part of
   * arBalance.
   */
  accruedLateCharge: Scalars['Decimal']['output'];
  /**
   * The aging of that balance, which it partitions: the buckets sum back to arBalance, with the unapplied
   * credit netted in current.
   */
  aging: CustomerReceivablesAging;
  /**
   * What the customer owed at asOfDate: the sum of every invoice issued by then and still standing then,
   * each at its balance then, sales tax included (it is part of what they were charged), less the customer's
   * unapplied credit then (unappliedCredit). A payment, adjustment or credit dated after asOfDate does not
   * lower it, and an invoice voided after asOfDate still counts. A voided invoice contributes nothing — it is
   * excluded by its status, not by its balance, which a void deliberately leaves standing. Negative when the
   * customer's credit exceeds what their invoices owe. Unbilled exposure is not in it.
   */
  arBalance: Scalars['Decimal']['output'];
  /**
   * The instant every figure was read at, and the reference the aging and the accruals were evaluated
   * against: the last instant of the day when asOfDate named a whole day.
   */
  asOfDate: Scalars['DateTime']['output'];
  /**
   * The early-pay discount still on offer across the customer's invoices, summed per invoice through
   * the shared accrual rule.
   */
  availableDiscount: Scalars['Decimal']['output'];
  /** The customer this rollup is for. */
  customerId: Scalars['String']['output'];
  /**
   * The cash recorded on that last payment; None when none ever has been. Carried beside the date
   * rather than left to a caller to look up, so the receivables grid's row and this rollup name the same
   * payment by construction — the two would otherwise be free to pick different ones out of a day that
   * took several.
   */
  lastPaymentAmount?: Maybe<Scalars['Decimal']['output']>;
  /**
   * When money was last received against ANY of this customer's invoices, on or before asOfDate;
   * None when none had been by then. Includes a payment recorded against a voided invoice,
   * because a void does not unmake a payment.
   */
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The invoices behind the balance — every standing invoice still owing something, oldest due first.
   * The aging-detail rows: with unappliedCredit taken off, they foot to aging and to arBalance.
   */
  openInvoices: Array<CustomerReceivableInvoice>;
  /**
   * The customer's credit still unapplied at asOfDate: what remains of their credit memos, deposit overages and
   * payment excess once every application to an invoice and every refund recorded by then is taken off. It is
   * money owed to the customer, so arBalance is net of it and aging carries it in current. Credit already
   * applied is not here: it is inside the open balance of the invoice it was applied to. Zero when the
   * receivable was read for a caller who sees only some of the customer's orders, because credit belongs to the
   * account and not to an order.
   */
  unappliedCredit: Scalars['Decimal']['output'];
  /**
   * What the customer's shipped orders that had no live invoice at asOfDate are owed, and how many there
   * were — exposure reported BESIDE arBalance and never inside it or inside any aging bucket. An order
   * leaves this figure on the date it is invoiced, and from then on is part of arBalance. Orders imported as
   * history, Credit orders and orders the ERP billed are never in it.
   */
  unbilled: UnbilledExposure;
};

/**
 * An accounts-receivable balance split across the five aging buckets every A/R surface in the system
 * reports, on the INVOICE basis.
 */
export type CustomerReceivablesAging = {
  __typename?: 'CustomerReceivablesAging';
  /**
   * Not yet due as of the reference instant, less the customer's unapplied credit, which falls due on no date and
   * so ages as current.
   */
  current: Scalars['Decimal']['output'];
  /** 1 to 30 days past due. */
  days1To30: Scalars['Decimal']['output'];
  /** 31 to 60 days past due. */
  days31To60: Scalars['Decimal']['output'];
  /** 61 to 90 days past due. */
  days61To90: Scalars['Decimal']['output'];
  /** More than 90 days past due. */
  days90Plus: Scalars['Decimal']['output'];
  /** The balance these buckets partition — equal by construction to the sum of them. */
  total: Scalars['Decimal']['output'];
};

/**
 * Why a customer-only recipient resolution (ResolveForCustomerAsync) returned no recipients.
 * There is no order in this scope, so unlike the order-scoped ResolveAsync there is nothing to
 * fall back to — the caller gets an honest reason instead of a resolved address.
 */
export enum CustomerRecipientFallbackReason {
  /** Recipients were resolved; the recipient list is non-empty. */
  None = 'NONE',
  /**
   * No send derives recipients for this kind at this scope (only the confirmation and acknowledgment
   * document mails route through the customer's contacts), so nothing is derived and only explicit
   * additions apply.
   */
  NotDerivedAtThisScope = 'NOT_DERIVED_AT_THIS_SCOPE',
  /**
   * The customer has no contact of the routed contact type at all. A normal, unconfigured state —
   * not a misconfiguration.
   */
  NoRoutedContact = 'NO_ROUTED_CONTACT',
  /**
   * The customer has one or more contacts of the routed contact type, but every one of them has only
   * blank/whitespace email addresses. A misconfiguration: at send time this same customer would
   * silently fall back to the purchaser with no warning.
   */
  RoutedContactHasNoEmail = 'ROUTED_CONTACT_HAS_NO_EMAIL'
}

/**
 * One item's Pre-pricing standing at a moment in time, from the customer's own Active
 * customer-level rows: current (the priced row in effect now), last (the most recent priced row
 * that already ended), promo and afterPromo (a running or scheduled promo and the standing price
 * it reverts to), and scheduledStanding (a future open-ended standing change). baselineToken
 * identifies exactly these records: send it back with a retail price save so the save is refused,
 * not applied, when the records changed after they were read.
 */
export type CustomerRetailPrice = {
  __typename?: 'CustomerRetailPrice';
  afterPromo?: Maybe<CustomerRetailPriceRecord>;
  baselineToken: Scalars['String']['output'];
  current?: Maybe<CustomerRetailPriceRecord>;
  itemId: Scalars['String']['output'];
  last?: Maybe<CustomerRetailPriceRecord>;
  promo?: Maybe<CustomerRetailPriceRecord>;
  scheduledStanding?: Maybe<CustomerRetailPriceRecord>;
};

/**
 * One customer-level SKU/UPC mapping record, shaped for the Pre-pricing GraphQL surface. The price
 * is null for an unpriced record (for example a cleared standing window); the currency is null
 * exactly when the price is null (contract 0.5).
 */
export type CustomerRetailPriceRecord = {
  __typename?: 'CustomerRetailPriceRecord';
  currency?: Maybe<Scalars['String']['output']>;
  customerItemId: Scalars['String']['output'];
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
  fromDate?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  throughDate?: Maybe<Scalars['String']['output']>;
};

/** One spreadsheet or single-edit row of the staff import (contract 5.1). */
export type CustomerRetailPriceRowInput = {
  cancelScheduledStanding?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveUntil?: InputMaybe<Scalars['DateTime']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  itemNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  removePromo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One entry per input row, in input order (F21). */
export type CustomerRetailPriceRowResult = {
  __typename?: 'CustomerRetailPriceRowResult';
  itemId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  status: CustomerRetailPriceRowStatus;
};

/** One row's outcome: applied, unchanged, its item was not found, or it was invalid. */
export enum CustomerRetailPriceRowStatus {
  Applied = 'APPLIED',
  Invalid = 'INVALID',
  ItemNotFound = 'ITEM_NOT_FOUND',
  Unchanged = 'UNCHANGED'
}

/** A connection to a list of items. */
export type CustomerRetailPricesConnection = {
  __typename?: 'CustomerRetailPricesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerRetailPricesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SkuUpcMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerRetailPricesEdge = {
  __typename?: 'CustomerRetailPricesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SkuUpcMapping;
};

/**
 * Order figures for one ship-to store of a customer. The rows of one customer add up to its
 * customerOrderStats totals for the same caller: both fold the same order set through the same
 * accumulators.
 */
export type CustomerShipToStats = {
  __typename?: 'CustomerShipToStats';
  /** The city from the current ship-to, or from the newest order's ship-to snapshot when the store is no longer a ship-to. */
  city: Scalars['String']['output'];
  /** The code from the current ship-to, or from the newest order's ship-to snapshot when the store is no longer a ship-to. */
  code: Scalars['String']['output'];
  /** Initialized date of the store's most recent order; null when the store never ordered. */
  lastOrderDate?: Maybe<Scalars['DateTime']['output']>;
  /** Sum of order totals across the store's orders in scope. */
  lifetimeOrderValue: Scalars['Decimal']['output'];
  /**
   * The ship-to id as a Guid string. Equals CustomerStateData.locations[].id and the value the
   * combinedOrders locations: { id: { eq } } filter takes. The one exception is the
   * "No ship-to" row, which collects the orders that carry no ship-to: its id is the empty Guid
   * (00000000-0000-0000-0000-000000000000), its name is "No ship-to" and it matches no location.
   * It appears only when such orders exist, so the rows still add up to the customerOrderStats totals.
   */
  locationId: Scalars['String']['output'];
  /** The name from the current ship-to, or from the newest order's ship-to snapshot when the store is no longer a ship-to. */
  name: Scalars['String']['output'];
  /** Number of the store's orders in scope. Master, cancelled and deleted orders are excluded. */
  orderCount: Scalars['Int']['output'];
  /** The state or province from the current ship-to, or from the newest order's ship-to snapshot when the store is no longer a ship-to. */
  stateProvince: Scalars['String']['output'];
  /** The store number from the current ship-to, or from the newest order's ship-to snapshot when the store is no longer a ship-to. */
  storeNumber: Scalars['String']['output'];
  /** Sum of order totals for orders initialized on or after January 1st of the current year. */
  ytdOrderValue: Scalars['Decimal']['output'];
};

/**
 * Per-row failure surfaced by validateCustomerDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError carries one (best-effort), otherwise null.
 */
export type CustomerStagedRowError = {
  __typename?: 'CustomerStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type CustomerStateData = {
  __typename?: 'CustomerStateData';
  allowOrderBillingAddressEdit: Scalars['Boolean']['output'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['output'];
  billingAddresses: Array<CreateAddress>;
  carrier: Scalars['String']['output'];
  combinedIntoCustomerId?: Maybe<Scalars['String']['output']>;
  combinedIntoCustomerName?: Maybe<Scalars['String']['output']>;
  contacts: Array<ContactData>;
  contextNotes: Array<CustomerContextNoteData>;
  crmRecordUrl: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customerGroupId: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerLookupCode: Scalars['String']['output'];
  customerTypeId: Scalars['String']['output'];
  defaultDiscountPercentage?: Maybe<Scalars['Decimal']['output']>;
  defaultTagColorId?: Maybe<Scalars['String']['output']>;
  depositRequirementType?: Maybe<DepositRequirementType>;
  depositRequirementValue?: Maybe<Scalars['Decimal']['output']>;
  description: Scalars['String']['output'];
  disabledVolumePoolIds: Array<Scalars['String']['output']>;
  /** The volume pools this customer has opted out of, resolved from the pool registry by id so code and name are always current. Retired pools are included — the opt-out keeps its history — and an id whose pool cannot be found is omitted. Empty when every pool on the customer's price ladders applies. */
  disabledVolumePools: Array<VolumePool>;
  /** The unit this customer's orders are placed in: the customer's own orderEntryUnit override when set, otherwise the tenant default. */
  effectiveOrderEntryUnit: OrderEntryUnit;
  /** How sales prices are entered and shown for this customer: per each or per shipping unit. Prices are always stored and billed per each. The customer's own priceEntryUnit override when set, otherwise the company default, otherwise each. */
  effectivePriceEntryUnit: PriceEntryUnit;
  /** How this customer's statement of account reaches them: the customer's own statementDeliveryMethod override when set, otherwise the tenant default. EMAIL when neither has been configured, which is today's behaviour. */
  effectiveStatementDeliveryMethod: StatementDeliveryMethod;
  /** Whether this customer is passed over when they close a statement period at exactly zero, resolved through the same two rungs. False when neither has been configured, which is today's behaviour. */
  effectiveStatementSkipZeroBalance: Scalars['Boolean']['output'];
  erpId: Scalars['String']['output'];
  erpPriceGroupId: Scalars['String']['output'];
  erpRouteAssignments: Array<ErpRouteAssignmentData>;
  federalTaxNumber: Scalars['String']['output'];
  freightChargeType?: Maybe<FreightChargeType>;
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  hasOwnBillingAddress: Scalars['Boolean']['output'];
  locations: Array<LocationData>;
  name: Scalars['String']['output'];
  notes: Array<NoteData>;
  orderEntryUnit?: Maybe<OrderEntryUnit>;
  orderSubmitter?: Maybe<OrderSubmitterData>;
  poRequired: Scalars['Boolean']['output'];
  /** How sales prices are entered and shown for this customer: per each or per shipping unit. Prices are always stored and billed per each. This is the customer's override of the company default; null means the customer follows the company default. Read effectivePriceEntryUnit for the resolved value. */
  priceEntryUnit?: Maybe<PriceEntryUnit>;
  priceGroupId: Scalars['String']['output'];
  priceGroupName: Scalars['String']['output'];
  receivingWindowEnd?: Maybe<Scalars['String']['output']>;
  receivingWindowStart?: Maybe<Scalars['String']['output']>;
  route: Scalars['String']['output'];
  salesPeople: Array<SalesPersonData>;
  sendInvoiceEmails: Scalars['Boolean']['output'];
  sendOrderEmails: Scalars['Boolean']['output'];
  shipFromLocations: Array<ShipFromLocationData>;
  statementDeliveryMethod?: Maybe<StatementDeliveryMethod>;
  statementSkipZeroBalance?: Maybe<Scalars['Boolean']['output']>;
  status: CustomerStatus;
  synchronizeOrders: Scalars['Boolean']['output'];
  taxExemptNumber: Scalars['String']['output'];
  taxExemptions: Array<CustomerTaxExemption>;
  tenantId: Scalars['String']['output'];
  termsId: Scalars['String']['output'];
  termsName: Scalars['String']['output'];
  unloadMinutes?: Maybe<Scalars['Int']['output']>;
  upgrades: Array<CustomerUpgrade>;
};

/** GraphQL view of one statement run. */
export type CustomerStatementRunData = {
  __typename?: 'CustomerStatementRunData';
  /** Gets the instant the run was generated. */
  completedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who generated it. */
  completedBy: Scalars['String']['output'];
  /** Gets one line per considered customer — routed and skipped alike, never only the successes. */
  outcomes: Array<CustomerStatementRunOutcomeData>;
  /** Gets the output format each statement is rendered to. */
  outputFormat: Scalars['String']['output'];
  /** Gets the exclusive end of the statement period. */
  periodEndExclusive: Scalars['DateTime']['output'];
  /** Gets the inclusive start of the statement period. */
  periodStart: Scalars['DateTime']['output'];
  /** Gets the report each statement is rendered from. */
  reportId: Scalars['String']['output'];
  /** Gets the report template each statement is rendered with, when one was named. */
  reportTemplateId?: Maybe<Scalars['String']['output']>;
  /** Gets how many customers the run resolved an address for, and so how many an operator may select. */
  routedCount: Scalars['Int']['output'];
  /** Gets the run identifier. */
  runId: Scalars['String']['output'];
  /** Gets how many customers have actually been sent their statement from this run. */
  sentCount: Scalars['Int']['output'];
  /** Gets how many eligible customers the run could not send to at all. */
  skippedCount: Scalars['Int']['output'];
  /** Gets how far along the generate-review-send flow this run is. */
  status: CustomerStatementRunStatus;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
};

export enum CustomerStatementRunDisposition {
  DeliveredByAnEarlierAttempt = 'DELIVERED_BY_AN_EARLIER_ATTEMPT',
  PrintOnlyNotEmailed = 'PRINT_ONLY_NOT_EMAILED',
  ScheduledToAccountsPayable = 'SCHEDULED_TO_ACCOUNTS_PAYABLE',
  ScheduledToPrimaryContactFallback = 'SCHEDULED_TO_PRIMARY_CONTACT_FALLBACK',
  SkippedAccountsPayableContactHasNoEmail = 'SKIPPED_ACCOUNTS_PAYABLE_CONTACT_HAS_NO_EMAIL',
  SkippedContactCouldNotBeResolved = 'SKIPPED_CONTACT_COULD_NOT_BE_RESOLVED',
  SkippedCustomerNotFound = 'SKIPPED_CUSTOMER_NOT_FOUND',
  SkippedDeliveryMethodNone = 'SKIPPED_DELIVERY_METHOD_NONE',
  SkippedNoContactWithEmail = 'SKIPPED_NO_CONTACT_WITH_EMAIL',
  SkippedStatementCouldNotBeQueued = 'SKIPPED_STATEMENT_COULD_NOT_BE_QUEUED'
}

export type CustomerStatementRunDispositionOperationFilterInput = {
  eq?: InputMaybe<CustomerStatementRunDisposition>;
  in?: InputMaybe<Array<CustomerStatementRunDisposition>>;
  neq?: InputMaybe<CustomerStatementRunDisposition>;
  nin?: InputMaybe<Array<CustomerStatementRunDisposition>>;
};

/** MongoDB read model for one statement run. */
export type CustomerStatementRunDocument = {
  __typename?: 'CustomerStatementRunDocument';
  /** Gets the instant the run was generated. */
  completedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who generated it. */
  completedBy: Scalars['String']['output'];
  /** Gets the MongoDB document identifier. */
  id: Scalars['String']['output'];
  /** Gets the instant this document was last written by the projection. */
  lastModified: Scalars['DateTime']['output'];
  /** Gets one line per considered customer — routed and skipped alike. */
  outcomes: Array<CustomerStatementRunOutcomeDocument>;
  /** Gets the output format each statement is rendered to. */
  outputFormat: Scalars['String']['output'];
  /** Gets the exclusive end of the statement period. */
  periodEndExclusive: Scalars['DateTime']['output'];
  /** Gets the inclusive start of the statement period. */
  periodStart: Scalars['DateTime']['output'];
  /** Gets the report each statement is rendered from. */
  reportId: Scalars['String']['output'];
  /** Gets the report template each statement is rendered with, when one was named. */
  reportTemplateId?: Maybe<Scalars['String']['output']>;
  /** Gets how many customers the run resolved an address for. */
  routedCount: Scalars['Int']['output'];
  /** Gets the run identifier. */
  runId: Scalars['String']['output'];
  /** Gets how many customers have actually been sent their statement from this run. */
  sentCount: Scalars['Int']['output'];
  /** Gets how many eligible customers the run could not send to at all. */
  skippedCount: Scalars['Int']['output'];
  /** Gets how far along the generate-review-send flow this run is. */
  status: CustomerStatementRunStatus;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
};

/** MongoDB read model for one statement run. */
export type CustomerStatementRunDocumentFilterInput = {
  and?: InputMaybe<Array<CustomerStatementRunDocumentFilterInput>>;
  /** Gets the instant the run was generated. */
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the email of the user who generated it. */
  completedBy?: InputMaybe<StringOperationFilterInput>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Gets the instant this document was last written by the projection. */
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerStatementRunDocumentFilterInput>>;
  /** Gets one line per considered customer — routed and skipped alike. */
  outcomes?: InputMaybe<ListFilterInputTypeOfCustomerStatementRunOutcomeDocumentFilterInput>;
  /** Gets the output format each statement is rendered to. */
  outputFormat?: InputMaybe<StringOperationFilterInput>;
  /** Gets the exclusive end of the statement period. */
  periodEndExclusive?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the inclusive start of the statement period. */
  periodStart?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the report each statement is rendered from. */
  reportId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the report template each statement is rendered with, when one was named. */
  reportTemplateId?: InputMaybe<OptionOfStringFilterInput>;
  /** Gets how many customers the run resolved an address for. */
  routedCount?: InputMaybe<IntOperationFilterInput>;
  /** Gets the run identifier. */
  runId?: InputMaybe<StringOperationFilterInput>;
  /** Gets how many customers have actually been sent their statement from this run. */
  sentCount?: InputMaybe<IntOperationFilterInput>;
  /** Gets how many eligible customers the run could not send to at all. */
  skippedCount?: InputMaybe<IntOperationFilterInput>;
  /** Gets how far along the generate-review-send flow this run is. */
  status?: InputMaybe<CustomerStatementRunStatusOperationFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model for one statement run. */
export type CustomerStatementRunDocumentSortInput = {
  /** Gets the instant the run was generated. */
  completedAt?: InputMaybe<SortEnumType>;
  /** Gets the email of the user who generated it. */
  completedBy?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the instant this document was last written by the projection. */
  lastModified?: InputMaybe<SortEnumType>;
  /** Gets the output format each statement is rendered to. */
  outputFormat?: InputMaybe<SortEnumType>;
  /** Gets the exclusive end of the statement period. */
  periodEndExclusive?: InputMaybe<SortEnumType>;
  /** Gets the inclusive start of the statement period. */
  periodStart?: InputMaybe<SortEnumType>;
  /** Gets the report each statement is rendered from. */
  reportId?: InputMaybe<SortEnumType>;
  /** Gets the report template each statement is rendered with, when one was named. */
  reportTemplateId?: InputMaybe<SortEnumType>;
  /** Gets how many customers the run resolved an address for. */
  routedCount?: InputMaybe<SortEnumType>;
  /** Gets the run identifier. */
  runId?: InputMaybe<SortEnumType>;
  /** Gets how many customers have actually been sent their statement from this run. */
  sentCount?: InputMaybe<SortEnumType>;
  /** Gets how many eligible customers the run could not send to at all. */
  skippedCount?: InputMaybe<SortEnumType>;
  /** Gets how far along the generate-review-send flow this run is. */
  status?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
};

/** GraphQL view of one customer's review line on a statement run. */
export type CustomerStatementRunOutcomeData = {
  __typename?: 'CustomerStatementRunOutcomeData';
  /**
   * Gets the finance charge this customer's standing invoices had run up unassessed as of the period's
   * last day, net of anything forgiven — the same figure the statement prints in its interest column.
   * NOT part of closingBalance: nothing has charged it, so it is not owed.
   */
  accruedLateCharge: Scalars['Decimal']['output'];
  /** Gets what this customer's statement closes at. Signed: a credit balance is negative. */
  closingBalance: Scalars['Decimal']['output'];
  /** Gets the customer the statement is for. */
  customerId: Scalars['String']['output'];
  /** Gets the customer's name. */
  customerName: Scalars['String']['output'];
  /** Gets where the run routed this customer, or why it could not. */
  disposition: CustomerStatementRunDisposition;
  /** Gets the plain sentence explaining this line. */
  reason: Scalars['String']['output'];
  /** Gets the addresses this customer's statement is routed to. Empty on every skip. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets whether this customer has an address, and so may be selected for sending. */
  routed: Scalars['Boolean']['output'];
  /** Gets the schedule the statement was queued on once sent, or None while nothing was queued. */
  scheduleId?: Maybe<Scalars['String']['output']>;
  /** Gets whether this customer has actually been sent their statement. */
  sent: Scalars['Boolean']['output'];
  /**
   * Gets the report parameters this customer's statement renders from, so the exact document reviewed can
   * be reproduced. Statement archiving was declined, so nothing keeps the rendered file itself.
   */
  statementParameters: Scalars['String']['output'];
  /**
   * Gets what has already been FORGIVEN of that charge across the same invoices. accruedLateCharge
   * is already net of this, so the two must never be added together.
   */
  waivedLateCharge: Scalars['Decimal']['output'];
};

/** One customer's review line on a projected statement run. */
export type CustomerStatementRunOutcomeDocument = {
  __typename?: 'CustomerStatementRunOutcomeDocument';
  /**
   * Gets what this customer's standing invoices had run up in finance charges as of the period's last
   * day, net of anything forgiven — the figure the statement prints in its interest column.
   */
  accruedLateCharge: Scalars['Decimal']['output'];
  /** Gets what this customer's statement closes at. Signed: a credit balance is negative. */
  closingBalance: Scalars['Decimal']['output'];
  /** Gets the customer the statement is for. */
  customerId: Scalars['String']['output'];
  /** Gets the customer's name. */
  customerName: Scalars['String']['output'];
  /** Gets where the run routed this customer, or why it could not. */
  disposition: CustomerStatementRunDisposition;
  /**
   * Gets the customer the statement was for before a customer combine moved this line onto the
   * customer it was combined into; null when never moved. Set once,
   * so a chain of combines keeps the first customer.
   */
  originalCustomerId?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the name of the customer the statement was for before that combine, as that customer was
   * named when combined; null when never moved.
   */
  originalCustomerName?: Maybe<Scalars['String']['output']>;
  /** Gets the plain sentence explaining this line. */
  reason: Scalars['String']['output'];
  /** Gets the addresses this customer's statement is routed to. Empty on every skip. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets whether this customer has an address, and so may be selected for sending. */
  routed: Scalars['Boolean']['output'];
  /** Gets the schedule the statement was queued on once sent, or None while nothing was queued. */
  scheduleId?: Maybe<Scalars['String']['output']>;
  /** Gets whether this customer has actually been sent their statement. */
  sent: Scalars['Boolean']['output'];
  /**
   * Gets the report parameters this customer's statement renders from, so the exact document reviewed can
   * be reproduced. Statement archiving was declined, so nothing keeps the rendered file itself and this
   * stands in for it.
   */
  statementParameters: Scalars['String']['output'];
  /**
   * Gets what has already been FORGIVEN of that charge across the same invoices. Shown beside the
   * accrual, which is already net of it.
   */
  waivedLateCharge: Scalars['Decimal']['output'];
};

/** One customer's review line on a projected statement run. */
export type CustomerStatementRunOutcomeDocumentFilterInput = {
  /**
   * Gets what this customer's standing invoices had run up in finance charges as of the period's last
   * day, net of anything forgiven — the figure the statement prints in its interest column.
   */
  accruedLateCharge?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<CustomerStatementRunOutcomeDocumentFilterInput>>;
  /** Gets what this customer's statement closes at. Signed: a credit balance is negative. */
  closingBalance?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the customer the statement is for. */
  customerId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the customer's name. */
  customerName?: InputMaybe<StringOperationFilterInput>;
  /** Gets where the run routed this customer, or why it could not. */
  disposition?: InputMaybe<CustomerStatementRunDispositionOperationFilterInput>;
  or?: InputMaybe<Array<CustomerStatementRunOutcomeDocumentFilterInput>>;
  /**
   * Gets the customer the statement was for before a customer combine moved this line onto the
   * customer it was combined into; null when never moved. Set once,
   * so a chain of combines keeps the first customer.
   */
  originalCustomerId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Gets the name of the customer the statement was for before that combine, as that customer was
   * named when combined; null when never moved.
   */
  originalCustomerName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the plain sentence explaining this line. */
  reason?: InputMaybe<StringOperationFilterInput>;
  /** Gets the addresses this customer's statement is routed to. Empty on every skip. */
  recipients?: InputMaybe<ListStringOperationFilterInput>;
  /** Gets whether this customer has an address, and so may be selected for sending. */
  routed?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the schedule the statement was queued on once sent, or None while nothing was queued. */
  scheduleId?: InputMaybe<OptionOfStringFilterInput>;
  /** Gets whether this customer has actually been sent their statement. */
  sent?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Gets the report parameters this customer's statement renders from, so the exact document reviewed can
   * be reproduced. Statement archiving was declined, so nothing keeps the rendered file itself and this
   * stands in for it.
   */
  statementParameters?: InputMaybe<StringOperationFilterInput>;
  /**
   * Gets what has already been FORGIVEN of that charge across the same invoices. Shown beside the
   * accrual, which is already net of it.
   */
  waivedLateCharge?: InputMaybe<DecimalOperationFilterInput>;
};

/** Payload returned from the generate-customer-statement-run mutation. */
export type CustomerStatementRunPayload = {
  __typename?: 'CustomerStatementRunPayload';
  customerStatementRun?: Maybe<CustomerStatementRunData>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum CustomerStatementRunStatus {
  GeneratedAwaitingReview = 'GENERATED_AWAITING_REVIEW',
  PartiallySent = 'PARTIALLY_SENT',
  Sent = 'SENT'
}

export type CustomerStatementRunStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerStatementRunStatus>;
  in?: InputMaybe<Array<CustomerStatementRunStatus>>;
  neq?: InputMaybe<CustomerStatementRunStatus>;
  nin?: InputMaybe<Array<CustomerStatementRunStatus>>;
};

/** A connection to a list of items. */
export type CustomerStatementRunsConnection = {
  __typename?: 'CustomerStatementRunsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerStatementRunsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerStatementRunDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerStatementRunsEdge = {
  __typename?: 'CustomerStatementRunsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerStatementRunDocument;
};

export enum CustomerStatementSendDisposition {
  AlreadySent = 'ALREADY_SENT',
  NotInRun = 'NOT_IN_RUN',
  NotSendable = 'NOT_SENDABLE',
  SendFailed = 'SEND_FAILED',
  Sent = 'SENT'
}

/** GraphQL view of what one send did about one selected customer. */
export type CustomerStatementSendOutcomeData = {
  __typename?: 'CustomerStatementSendOutcomeData';
  /** Gets the customer that was selected. */
  customerId: Scalars['String']['output'];
  /** Gets the customer's name, empty when the run never considered them. */
  customerName: Scalars['String']['output'];
  /** Gets what the send did about this customer. */
  disposition: CustomerStatementSendDisposition;
  /** Gets the plain sentence explaining this line. */
  reason: Scalars['String']['output'];
  /** Gets the addresses the statement was queued to. Empty whenever nothing was queued. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the schedule the statement was queued on, or None when nothing was queued. */
  scheduleId?: Maybe<Scalars['String']['output']>;
  /** Gets whether this customer's statement is on its way. */
  sent: Scalars['Boolean']['output'];
};

/** Payload returned from the send-customer-statements mutation. */
export type CustomerStatementSendPayload = {
  __typename?: 'CustomerStatementSendPayload';
  /** The run as it stands after this send. */
  customerStatementRun?: Maybe<CustomerStatementRunData>;
  /** Populated only when the send was refused outright and nothing was queued. */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * What THIS send did about every customer it was asked for. Separate from the run's own lines because the
   * run accumulates every send ever made from it — only this tells an operator what the button they just
   * pressed did.
   */
  sends?: Maybe<Array<CustomerStatementSendOutcomeData>>;
};

export enum CustomerStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Initialized = 'INITIALIZED',
  Unknown = 'UNKNOWN'
}

export type CustomerStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerStatus>;
  in?: InputMaybe<Array<CustomerStatus>>;
  neq?: InputMaybe<CustomerStatus>;
  nin?: InputMaybe<Array<CustomerStatus>>;
};

export type CustomerTaxExemption = {
  __typename?: 'CustomerTaxExemption';
  certificateNumber: Scalars['String']['output'];
  expiresOn?: Maybe<Scalars['LocalDate']['output']>;
  reason?: Maybe<CustomerTaxExemptionReason>;
  state?: Maybe<Scalars['String']['output']>;
};

export type CustomerTaxExemptionInput = {
  certificateNumber: Scalars['String']['input'];
  expiresOn?: InputMaybe<Scalars['LocalDate']['input']>;
  reason?: InputMaybe<CustomerTaxExemptionReason>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomerTaxExemptionReason {
  Agricultural = 'AGRICULTURAL',
  Government = 'GOVERNMENT',
  Nonprofit = 'NONPROFIT',
  Other = 'OTHER',
  Resale = 'RESALE',
  Unknown = 'UNKNOWN'
}

export type CustomerTextConsentWordingData = {
  __typename?: 'CustomerTextConsentWordingData';
  version: Scalars['Int']['output'];
  wording: Scalars['String']['output'];
  /** The exact text the YES request sends. */
  yesRequestText: Scalars['String']['output'];
};

/** The one mobile a text row goes to, and what was sent to it. */
export type CustomerTextData = {
  __typename?: 'CustomerTextData';
  /** The Twilio account the text was sent from. */
  accountSid?: Maybe<Scalars['String']['output']>;
  /** CONSENT_REQUEST: the exact YES text, stamped by the claim. Other kinds: null until recorded. */
  body?: Maybe<Scalars['String']['output']>;
  /** Set on CONSENT_REQUEST rows. */
  consentRequestId?: Maybe<Scalars['UUID']['output']>;
  /** The contact whose mobile this is. */
  contactId: Scalars['UUID']['output'];
  /** The contact's name when the row was written. */
  contactName: Scalars['String']['output'];
  /** The From number Twilio used. */
  fromNumber?: Maybe<Scalars['String']['output']>;
  /** Null means unknown. Never 0. */
  numSegments?: Maybe<Scalars['Int']['output']>;
  /** The To number, E.164. */
  phoneNumber: Scalars['String']['output'];
  /** Twilio's error code on the last failure. */
  providerErrorCode?: Maybe<Scalars['Int']['output']>;
  /** When the send was recorded SENT. */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Stored as the int: UNKNOWN = 0, CONFIRMED = 1, NO_LIVE_REQUEST = 2, OPTED_OUT = 3, OPTED_IN = 4, NO_MATCH = 5, ALREADY_APPLIED = 6, IGNORED = 7, UNKNOWN_NUMBER = 8. */
export enum CustomerTextReplyOutcome {
  AlreadyApplied = 'ALREADY_APPLIED',
  Confirmed = 'CONFIRMED',
  Ignored = 'IGNORED',
  NoLiveRequest = 'NO_LIVE_REQUEST',
  NoMatch = 'NO_MATCH',
  OptedIn = 'OPTED_IN',
  OptedOut = 'OPTED_OUT',
  Unknown = 'UNKNOWN',
  UnknownNumber = 'UNKNOWN_NUMBER'
}

/** Classified by the relay. UNSTOP is sent as START. Stored as the int: UNKNOWN = 0, YES = 1, STOP = 2, START = 3, HELP = 4, OPT_OUT_TEXT = 5. */
export enum CustomerTextReplyType {
  Help = 'HELP',
  OptOutText = 'OPT_OUT_TEXT',
  Start = 'START',
  Stop = 'STOP',
  Unknown = 'UNKNOWN',
  Yes = 'YES'
}

/** The grower's sender for every row in an SMS claim. */
export type CustomerTextSenderData = {
  __typename?: 'CustomerTextSenderData';
  /** The business name Twilio verified, which the texts name the grower by. */
  businessName: Scalars['String']['output'];
  /** The Twilio Messaging Service the texts go out through. */
  messagingServiceSid: Scalars['String']['output'];
  /** The grower's toll-free number, E.164. */
  phoneNumber: Scalars['String']['output'];
};

/**
 * A tenant's customer texting setup. A tenant never set up reads NOT_SET_UP with every other field
 * null. Served by the customerTexting query and embedded in the admin tenants read model.
 */
export type CustomerTextingData = {
  __typename?: 'CustomerTextingData';
  /** The business name Twilio verified. Every customer text starts with it. Null when NOT_SET_UP. */
  businessName?: Maybe<Scalars['String']['output']>;
  /** The Twilio Messaging Service SID (MG...). Null when NOT_SET_UP. */
  messagingServiceSid?: Maybe<Scalars['String']['output']>;
  /** The grower's toll-free number, E.164. Null when NOT_SET_UP. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** How far the setup has got. */
  state: CustomerTextingState;
  /** The day the toll-free verification was submitted to Twilio. */
  submittedOn?: Maybe<Scalars['LocalDate']['output']>;
  /** When the setup was last written. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * A tenant's customer texting setup. A tenant never set up reads NOT_SET_UP with every other field
 * null. Served by the customerTexting query and embedded in the admin tenants read model.
 */
export type CustomerTextingDataFilterInput = {
  and?: InputMaybe<Array<CustomerTextingDataFilterInput>>;
  /** The business name Twilio verified. Every customer text starts with it. Null when NOT_SET_UP. */
  businessName?: InputMaybe<StringOperationFilterInput>;
  /** The Twilio Messaging Service SID (MG...). Null when NOT_SET_UP. */
  messagingServiceSid?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerTextingDataFilterInput>>;
  /** The grower's toll-free number, E.164. Null when NOT_SET_UP. */
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  /** How far the setup has got. */
  state?: InputMaybe<CustomerTextingStateOperationFilterInput>;
  /** The day the toll-free verification was submitted to Twilio. */
  submittedOn?: InputMaybe<LocalDateOperationFilterInput>;
  /** When the setup was last written. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * A tenant's customer texting setup. A tenant never set up reads NOT_SET_UP with every other field
 * null. Served by the customerTexting query and embedded in the admin tenants read model.
 */
export type CustomerTextingDataSortInput = {
  /** The business name Twilio verified. Every customer text starts with it. Null when NOT_SET_UP. */
  businessName?: InputMaybe<SortEnumType>;
  /** The Twilio Messaging Service SID (MG...). Null when NOT_SET_UP. */
  messagingServiceSid?: InputMaybe<SortEnumType>;
  /** The grower's toll-free number, E.164. Null when NOT_SET_UP. */
  phoneNumber?: InputMaybe<SortEnumType>;
  /** How far the setup has got. */
  state?: InputMaybe<SortEnumType>;
  /** The day the toll-free verification was submitted to Twilio. */
  submittedOn?: InputMaybe<SortEnumType>;
  /** When the setup was last written. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Payload returned from the customer texting mutation. */
export type CustomerTextingPayload = {
  __typename?: 'CustomerTextingPayload';
  customerTexting?: Maybe<CustomerTextingData>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum CustomerTextingState {
  InReview = 'IN_REVIEW',
  NotSetUp = 'NOT_SET_UP',
  Ready = 'READY',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

export type CustomerTextingStateOperationFilterInput = {
  eq?: InputMaybe<CustomerTextingState>;
  in?: InputMaybe<Array<CustomerTextingState>>;
  neq?: InputMaybe<CustomerTextingState>;
  nin?: InputMaybe<Array<CustomerTextingState>>;
};

/** A connection to a list of items. */
export type CustomerTimeEntriesConnection = {
  __typename?: 'CustomerTimeEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerTimeEntriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TimeEntryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerTimeEntriesEdge = {
  __typename?: 'CustomerTimeEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TimeEntryDocument;
};

/**
 * One row of a customer's top-N SKUs by quantity, produced by a single MongoDB aggregation over the
 * customer's non-deleted orders and their line items. Revenue is the sum of each matched line's
 * quantity times its effective unit price (OverridePrice when set, else Price), matching
 * how the order itself values the line.
 */
export type CustomerTopSku = {
  __typename?: 'CustomerTopSku';
  /** Display name of the SKU, taken from the first matched line item. */
  name: Scalars['String']['output'];
  /** Total quantity of this SKU across every matched line, the ranking key. */
  quantity: Scalars['Int']['output'];
  /** Total revenue for this SKU across every matched line. */
  revenue: Scalars['Decimal']['output'];
  /** The item SKU this row summarizes. */
  sku: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a customer type. Composite Id is
 * {TenantId}-{CustomerTypeId}; CustomerTypeId is the plain entity id.
 */
export type CustomerTypeDocument = {
  __typename?: 'CustomerTypeDocument';
  customerTypeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** Linked Chart-of-Accounts row resolved from RevenueGlAccountId. Null when the customer type is classification-only (no revenue account configured), or when the linked account no longer exists for the tenant. */
  revenueGlAccount?: Maybe<MergeDevAccountDocument>;
  /**
   * Optional FK into MergeDevAccount (the linked revenue account's stable ImportId).
   * Empty when the type is classification-only. The revenueGlAccount resolver
   * (CustomerTypeDocumentType) hydrates the linked MergeDevAccountDocument
   * at query time.
   */
  revenueGlAccountId: Scalars['String']['output'];
  status: CustomerTypeStatus;
  tenantId: Scalars['String']['output'];
  /**
   * The number of customers assigned to this customer type, company-wide: the number a refused delete
   * names. Null when the count is unavailable, and always null for a customer-portal caller, as the count
   * is a tenant-wide cross-customer aggregate.
   */
  usageCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The customers assigned to this customer type, in one group. The total equals the Usage Count and the
   * count a refused delete names. Staff only: a customer caller gets an error and a null list, so the
   * field stays nullable. Read it for one customer type at a time: it reads its own group for each type it
   * is selected on, so selecting it on a list of types costs several reads per row.
   */
  usedBy?: Maybe<UsedBy>;
};


/**
 * MongoDB read-model document for a customer type. Composite Id is
 * {TenantId}-{CustomerTypeId}; CustomerTypeId is the plain entity id.
 */
export type CustomerTypeDocumentUsedByArgs = {
  first?: Scalars['Int']['input'];
  kind?: InputMaybe<RecordKind>;
  offset?: Scalars['Int']['input'];
};

/**
 * MongoDB read-model document for a customer type. Composite Id is
 * {TenantId}-{CustomerTypeId}; CustomerTypeId is the plain entity id.
 */
export type CustomerTypeDocumentFilterInput = {
  and?: InputMaybe<Array<CustomerTypeDocumentFilterInput>>;
  customerTypeId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerTypeDocumentFilterInput>>;
  /**
   * Optional FK into MergeDevAccount (the linked revenue account's stable ImportId).
   * Empty when the type is classification-only. The revenueGlAccount resolver
   * (CustomerTypeDocumentType) hydrates the linked MergeDevAccountDocument
   * at query time.
   */
  revenueGlAccountId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<CustomerTypeStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a customer type. Composite Id is
 * {TenantId}-{CustomerTypeId}; CustomerTypeId is the plain entity id.
 */
export type CustomerTypeDocumentSortInput = {
  customerTypeId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /**
   * Optional FK into MergeDevAccount (the linked revenue account's stable ImportId).
   * Empty when the type is classification-only. The revenueGlAccount resolver
   * (CustomerTypeDocumentType) hydrates the linked MergeDevAccountDocument
   * at query time.
   */
  revenueGlAccountId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL mutation payload for the CustomerType aggregate. Either
 * CustomerType contains the post-event state, or Errors describes why the
 * mutation failed.
 */
export type CustomerTypePayload = {
  __typename?: 'CustomerTypePayload';
  customerType?: Maybe<CustomerTypeStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type CustomerTypeStateData = {
  __typename?: 'CustomerTypeStateData';
  customerTypeId: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  revenueGlAccountId: Scalars['String']['output'];
  status: CustomerTypeStatus;
  tenantId: Scalars['String']['output'];
};

export enum CustomerTypeStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type CustomerTypeStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerTypeStatus>;
  in?: InputMaybe<Array<CustomerTypeStatus>>;
  neq?: InputMaybe<CustomerTypeStatus>;
  nin?: InputMaybe<Array<CustomerTypeStatus>>;
};

/** A connection to a list of items. */
export type CustomerTypesConnection = {
  __typename?: 'CustomerTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerTypeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerTypesEdge = {
  __typename?: 'CustomerTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerTypeDocument;
};

export type CustomerUpgrade = {
  __typename?: 'CustomerUpgrade';
  appliesToItemId?: Maybe<Scalars['String']['output']>;
  categoryLabel?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<ItemUpgradeCost>;
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pricing?: Maybe<ItemUpgradePricing>;
  status: ItemUpgradeStatus;
  upgradeId: Scalars['String']['output'];
};

export type CustomerUpgradeDataInput = {
  appliesToItemId?: InputMaybe<Scalars['String']['input']>;
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<ItemUpgradeCostDataInput>;
  isDefault?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pricing?: InputMaybe<ItemUpgradePricingDataInput>;
  upgradeId: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type CustomersByNamesConnection = {
  __typename?: 'CustomersByNamesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomersByNamesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomersSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomersByNamesEdge = {
  __typename?: 'CustomersByNamesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomersSummaryDocument;
};

/** A connection to a list of items. */
export type CustomersConnection = {
  __typename?: 'CustomersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomersSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomersEdge = {
  __typename?: 'CustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomersSummaryDocument;
};

/** A connection to a list of items. */
export type CustomersForImportConnection = {
  __typename?: 'CustomersForImportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomersForImportEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerStateData>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CustomersForImportEdge = {
  __typename?: 'CustomersForImportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerStateData;
};

export type CustomersSummaryDocument = {
  __typename?: 'CustomersSummaryDocument';
  /** The CRM import ids of the customers combined into this one; imports under them update this customer. */
  absorbedCrmImportIds: Array<Scalars['String']['output']>;
  /** The customers combined into this one. */
  absorbedCustomerIds: Array<Scalars['String']['output']>;
  /** The ERP ids of the customers combined into this one; imports under them update this customer. */
  absorbedErpIds: Array<Scalars['String']['output']>;
  /** The import ids of the customers combined into this one; imports under them update this customer. */
  absorbedImportIds: Array<Scalars['String']['output']>;
  /** The lookup codes of the customers combined into this one. */
  absorbedLookupCodes: Array<Scalars['String']['output']>;
  /**
   * The customer-level default freight carrier (ENS). Plain optional string — not a managed
   * carrier master/aggregate. Empty when not recorded. New Orders for this customer inherit
   * it at create time (see MongoCustomerService.GetInheritedCarrier); overridable
   * per-order.
   */
  carrier: Scalars['String']['output'];
  /** When this customer was combined into another, or null. */
  combinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who combined this customer into another, or null. */
  combinedBy?: Maybe<Scalars['String']['output']>;
  /**
   * The customer this one was combined into, or null while it stands on its own. A combined
   * customer is inactive, keeps its row and is hidden from the customer lists unless
   * includeCombined is true.
   */
  combinedIntoCustomerId?: Maybe<Scalars['String']['output']>;
  /**
   * The customer's denormalized, searchable contact list: one entry per (contact, phone), and one
   * entry with an empty phone for a contact carrying none — so a customer is findable by any
   * contact's name even when that contact recorded no number. Covers every contact type (Primary,
   * Sales, Support, AccountsPayable and the rest), unlike PrimaryContactPhone, which
   * deliberately narrows to the first Primary contact. Exists purely for search: it is not a
   * display value and duplicates data already on CustomerState's contacts.
   * PhoneDigits is why this is denormalized at all —
   * phone numbers are stored formatted and the GraphQL contains filter is a literal
   * substring match, so a bare-digit search (4148) can only match a digits-only projection.
   * Resolved by ContactSearchRule in the DOMAIN and carried on the contact events — the
   * projection never derives it. Seeded to an empty list on CustomerAdded so the BSON
   * element always exists (required for some/any list filters to behave
   * consistently across every document).
   */
  contactSearchEntries: Array<CustomerContactSearchEntry>;
  /**
   * The stable external CRM sync key (Salesforce/HubSpot via Merge.dev) this customer was imported
   * under. Indexed (TenantId, CrmImportId) so mergeCustomer resolves CRM create-vs-update by
   * a CrmImportId lookup on a field SEPARATE from ImportId (the accounting key), so a
   * tenant syncing both never collides. Empty for native / non-CRM customers.
   */
  crmImportId: Scalars['String']['output'];
  /**
   * The record's URL in the source CRM (Merge's account_url — e.g. the HubSpot company
   * page), surfaced by the pwa "View in CRM" link. A display value, distinct from
   * CrmImportId (the routing key). Empty for native / non-CRM customers.
   */
  crmRecordUrl: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  /**
   * Optional FK into the CustomerGroup read model. Empty when the customer has no group assigned.
   * PATCH-shaped on updateCustomer: omitting the field (or sending null) preserves the
   * existing assignment; sending an empty string explicitly clears it; sending an id sets it.
   * Also set directly via the narrow setCustomerGroup mutation.
   */
  customerGroupId?: Maybe<Scalars['String']['output']>;
  /**
   * The assigned CustomerGroup's name, resolved at query time. Empty when the customer has no
   * group assigned.
   */
  customerGroupName?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  customerLookupCode: Scalars['String']['output'];
  /**
   * Optional FK into the CustomerType read model (CustomerTypes). Empty when the
   * customer has no type assigned. PATCH-shaped on updateCustomer: omitting the field (or
   * sending null) preserves the existing assignment — a mergeCustomer/importCustomer sync, which
   * never carries this native-only field, cannot wipe it on re-sync. Sending an empty string
   * explicitly clears the assignment; sending an id sets it (validated: must exist and be
   * Active). See CustomerProjectionService.UpdateCustomer's conditional Set.
   */
  customerTypeId?: Maybe<Scalars['String']['output']>;
  /**
   * Resolved at query time via ICustomerTypeNameByTenantAndCustomerTypeIdDataLoader
   * (mirrors PriceGroupName/TermsName) — never written by the
   * projection.
   */
  customerTypeName?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['DateTime']['output'];
  /**
   * The customer-level default discount percentage. Auto-applies to new orders for this customer.
   * Null means no default discount.
   */
  defaultDiscountPercentage?: Maybe<Scalars['Decimal']['output']>;
  /** Id of the Tag color new orders for this customer start with. Null means the customer has no default color. */
  defaultTagColorId?: Maybe<Scalars['String']['output']>;
  /**
   * How the customer's order-deposit requirement is calculated, or null when the customer
   * requires no deposit (their orders are never deposit-blocked). The order allocate-lock reads
   * this (with the deposit requirement value) to compute the required deposit.
   */
  depositRequirementType?: Maybe<DepositRequirementType>;
  /**
   * The customer's deposit requirement value: a percentage (0–100) for Percentage requirements,
   * or a flat amount for FlatAmount requirements. Null when no requirement is configured.
   */
  depositRequirementValue?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Ids of the volume pools this customer has opted out of; empty when every pool on the
   * customer's price ladders applies. Honoured for every location of the customer, including one
   * assigned its own price group. Resolve the pools themselves through disabledVolumePools.
   */
  disabledVolumePoolIds: Array<Scalars['String']['output']>;
  /** The volume pools this customer has opted out of, resolved from the pool registry by id so code and name are always current. Retired pools are included — the opt-out keeps its history — and an id whose pool cannot be found is omitted. Empty when every pool on the customer's price ladders applies. */
  disabledVolumePools: Array<VolumePool>;
  /** The unit this customer's orders are placed in: the customer's own orderEntryUnit override when set, otherwise the tenant default. */
  effectiveOrderEntryUnit: OrderEntryUnit;
  /** How sales prices are entered and shown for this customer: per each or per shipping unit. Prices are always stored and billed per each. The customer's own priceEntryUnit override when set, otherwise the company default, otherwise each. */
  effectivePriceEntryUnit: PriceEntryUnit;
  /** How this customer's statement of account reaches them: the customer's own statementDeliveryMethod override when set, otherwise the tenant default. EMAIL when neither has been configured, which is today's behaviour. */
  effectiveStatementDeliveryMethod: StatementDeliveryMethod;
  /** Whether this customer is passed over when they close a statement period at exactly zero, resolved through the same two rungs. False when neither has been configured, which is today's behaviour. */
  effectiveStatementSkipZeroBalance: Scalars['Boolean']['output'];
  erpId: Scalars['String']['output'];
  erpPriceGroupId?: Maybe<Scalars['String']['output']>;
  /**
   * The customer-level federal tax number. Empty when not recorded. Mirrors
   * the taxExemptNumber field.
   */
  federalTaxNumber: Scalars['String']['output'];
  /** The names of the customers combined into this one. */
  formerNames: Array<Scalars['String']['output']>;
  /** The customer-level freight charge type, or null if not configured. */
  freightChargeType?: Maybe<Scalars['Int']['output']>;
  /** The customer-level freight charge value. */
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  history: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**
   * The stable external sync key (Merge.dev document id) this customer was imported under.
   * Indexed (TenantId, ImportId) so mergeCustomer resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for native
   * customers / those imported before ImportId existed. Distinct from ErpId.
   */
  importId: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The customers combined into this one whose combine let their outside-sync record also update this
   * customer's settings. An import routed through any other combined customer's keys only adds or
   * updates that customer's own ship-tos and contacts here.
   */
  letOldSyncUpdateSettingsCustomerIds?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The customer override of the tenant default minimum freight charge, applied once per order.
   * Null means the tenant default applies.
   */
  minimumFreightCharge?: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  numberOfBillingAddresses: Scalars['Int']['output'];
  numberOfContacts: Scalars['Int']['output'];
  numberOfLocations: Scalars['Int']['output'];
  numberOfNotes: Scalars['Int']['output'];
  numberOfShipFromLocations: Scalars['Int']['output'];
  /**
   * The customer's override of the tenant's default order entry unit — the unit this customer's
   * orders are placed in. Null means the customer has no override and inherits the tenant
   * default (and keeps inheriting it as that default changes), which is also how every customer
   * created before this setting existed reads. Read effectiveOrderEntryUnit for the
   * resolved value; compare the two to tell "inherited" from "overridden" without a second
   * query.
   */
  orderEntryUnit?: Maybe<OrderEntryUnit>;
  /**
   * The customer-level "purchase order required" flag. Resolves to a concrete value
   * (default false). A location's own poRequired override inherits this value when unset.
   */
  poRequired: Scalars['Boolean']['output'];
  /**
   * How sales prices are entered and shown for this customer: per each or per shipping unit.
   * Prices are always stored and billed per each. This is the customer's OVERRIDE of the company
   * default; null means the customer follows the company default. Read
   * effectivePriceEntryUnit for the resolved value.
   */
  priceEntryUnit?: Maybe<PriceEntryUnit>;
  priceGroupId?: Maybe<Scalars['String']['output']>;
  priceGroupName?: Maybe<Scalars['String']['output']>;
  /**
   * The customer's phone number as the GrowPoint-parity reports render it: the
   * ContactType.Primary contact's first phone number. Empty when the customer has no
   * Primary contact, or that contact records no phone — never null, never a placeholder. There is
   * no fallback to a non-Primary contact.
   */
  primaryContactPhone: Scalars['String']['output'];
  /** The end (HH:mm) of the customer's receiving window; see receivingWindowStart. */
  receivingWindowEnd?: Maybe<Scalars['String']['output']>;
  /**
   * The start (HH:mm) of the customer's receiving window, the window of every ship-to that sets none of
   * its own. Null when the customer has no window.
   */
  receivingWindowStart?: Maybe<Scalars['String']['output']>;
  /**
   * Customer-level route override — tier 2 of the hierarchical route setting. Empty means
   * "inherit the tenant default". Read by MongoCustomerService.GetInheritedRoute.
   */
  route: Scalars['String']['output'];
  /**
   * Customer-level master toggle for whether invoice-issue emails are sent.
   * Null on legacy documents; consumers must coalesce to the policy default.
   */
  sendInvoiceEmails?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Customer-level master toggle for whether order-confirmation emails are sent.
   * Null on legacy documents; consumers must coalesce to the policy default.
   */
  sendOrderEmails?: Maybe<Scalars['Boolean']['output']>;
  /** The distinct, sorted state/province values across this customer's ship-to locations. Ship-from locations are a separate collection and are never included here. Empty when the customer has no ship-to locations, or none of them have a state recorded. */
  shipToStates: Array<Scalars['String']['output']>;
  /**
   * The customer's override of the tenant's default statement delivery METHOD — how their
   * statement of account reaches them. Null means the customer has no override and inherits the
   * tenant default (and keeps inheriting it as that default changes), which is also how every
   * customer created before this setting existed reads. Read
   * effectiveStatementDeliveryMethod for the resolved value; compare the two to tell
   * "inherited" from "overridden" without a second query.
   */
  statementDeliveryMethod?: Maybe<StatementDeliveryMethod>;
  /**
   * The skip-zero-balance half of this customer's statement delivery override. Null exactly when
   * statementDeliveryMethod is null — the override is the whole policy or nothing.
   * Read effectiveStatementSkipZeroBalance for the resolved value.
   */
  statementSkipZeroBalance?: Maybe<Scalars['Boolean']['output']>;
  status: CustomerStatus;
  synchronizeOrders: Scalars['Boolean']['output'];
  /** The customer-level tax exempt number. Empty when the customer is taxable. */
  taxExemptNumber: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  termsId?: Maybe<Scalars['String']['output']>;
  termsName?: Maybe<Scalars['String']['output']>;
  /**
   * The customer's unload minutes, the minutes of every ship-to that sets none of its own. Null when the
   * customer has none.
   */
  unloadMinutes?: Maybe<Scalars['Int']['output']>;
  /**
   * The default upgrades this customer carries, deactivated ones included with their status. One with no
   * appliesToItemId applies to every item the customer orders; one that names an item applies only to
   * that item.
   */
  upgrades: Array<CustomerUpgrade>;
  /**
   * How many of this customer's orders count toward its usage: the same order set as
   * customerOrderStats' order history, with Deleted and Cancelled orders excluded.
   */
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomersSummaryDocumentFilterInput = {
  /** The CRM import ids of the customers combined into this one; imports under them update this customer. */
  absorbedCrmImportIds?: InputMaybe<ListStringOperationFilterInput>;
  /** The customers combined into this one. */
  absorbedCustomerIds?: InputMaybe<ListStringOperationFilterInput>;
  /** The ERP ids of the customers combined into this one; imports under them update this customer. */
  absorbedErpIds?: InputMaybe<ListStringOperationFilterInput>;
  /** The import ids of the customers combined into this one; imports under them update this customer. */
  absorbedImportIds?: InputMaybe<ListStringOperationFilterInput>;
  /** The lookup codes of the customers combined into this one. */
  absorbedLookupCodes?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<CustomersSummaryDocumentFilterInput>>;
  /**
   * The customer-level default freight carrier (ENS). Plain optional string — not a managed
   * carrier master/aggregate. Empty when not recorded. New Orders for this customer inherit
   * it at create time (see MongoCustomerService.GetInheritedCarrier); overridable
   * per-order.
   */
  carrier?: InputMaybe<StringOperationFilterInput>;
  /** When this customer was combined into another, or null. */
  combinedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The user who combined this customer into another, or null. */
  combinedBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer this one was combined into, or null while it stands on its own. A combined
   * customer is inactive, keeps its row and is hidden from the customer lists unless
   * includeCombined is true.
   */
  combinedIntoCustomerId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer's denormalized, searchable contact list: one entry per (contact, phone), and one
   * entry with an empty phone for a contact carrying none — so a customer is findable by any
   * contact's name even when that contact recorded no number. Covers every contact type (Primary,
   * Sales, Support, AccountsPayable and the rest), unlike PrimaryContactPhone, which
   * deliberately narrows to the first Primary contact. Exists purely for search: it is not a
   * display value and duplicates data already on CustomerState's contacts.
   * PhoneDigits is why this is denormalized at all —
   * phone numbers are stored formatted and the GraphQL contains filter is a literal
   * substring match, so a bare-digit search (4148) can only match a digits-only projection.
   * Resolved by ContactSearchRule in the DOMAIN and carried on the contact events — the
   * projection never derives it. Seeded to an empty list on CustomerAdded so the BSON
   * element always exists (required for some/any list filters to behave
   * consistently across every document).
   */
  contactSearchEntries?: InputMaybe<ListFilterInputTypeOfCustomerContactSearchEntryFilterInput>;
  /**
   * The stable external CRM sync key (Salesforce/HubSpot via Merge.dev) this customer was imported
   * under. Indexed (TenantId, CrmImportId) so mergeCustomer resolves CRM create-vs-update by
   * a CrmImportId lookup on a field SEPARATE from ImportId (the accounting key), so a
   * tenant syncing both never collides. Empty for native / non-CRM customers.
   */
  crmImportId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The record's URL in the source CRM (Merge's account_url — e.g. the HubSpot company
   * page), surfaced by the pwa "View in CRM" link. A display value, distinct from
   * CrmImportId (the routing key). Empty for native / non-CRM customers.
   */
  crmRecordUrl?: InputMaybe<StringOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  /**
   * Optional FK into the CustomerGroup read model. Empty when the customer has no group assigned.
   * PATCH-shaped on updateCustomer: omitting the field (or sending null) preserves the
   * existing assignment; sending an empty string explicitly clears it; sending an id sets it.
   * Also set directly via the narrow setCustomerGroup mutation.
   */
  customerGroupId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The assigned CustomerGroup's name, resolved at query time. Empty when the customer has no
   * group assigned.
   */
  customerGroupName?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerLookupCode?: InputMaybe<StringOperationFilterInput>;
  /**
   * Optional FK into the CustomerType read model (CustomerTypes). Empty when the
   * customer has no type assigned. PATCH-shaped on updateCustomer: omitting the field (or
   * sending null) preserves the existing assignment — a mergeCustomer/importCustomer sync, which
   * never carries this native-only field, cannot wipe it on re-sync. Sending an empty string
   * explicitly clears the assignment; sending an id sets it (validated: must exist and be
   * Active). See CustomerProjectionService.UpdateCustomer's conditional Set.
   */
  customerTypeId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Resolved at query time via ICustomerTypeNameByTenantAndCustomerTypeIdDataLoader
   * (mirrors PriceGroupName/TermsName) — never written by the
   * projection.
   */
  customerTypeName?: InputMaybe<StringOperationFilterInput>;
  dateCreated?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The customer-level default discount percentage. Auto-applies to new orders for this customer.
   * Null means no default discount.
   */
  defaultDiscountPercentage?: InputMaybe<DecimalOperationFilterInput>;
  /** Id of the Tag color new orders for this customer start with. Null means the customer has no default color. */
  defaultTagColorId?: InputMaybe<StringOperationFilterInput>;
  /**
   * How the customer's order-deposit requirement is calculated, or null when the customer
   * requires no deposit (their orders are never deposit-blocked). The order allocate-lock reads
   * this (with the deposit requirement value) to compute the required deposit.
   */
  depositRequirementType?: InputMaybe<NullableOfDepositRequirementTypeOperationFilterInput>;
  /**
   * The customer's deposit requirement value: a percentage (0–100) for Percentage requirements,
   * or a flat amount for FlatAmount requirements. Null when no requirement is configured.
   */
  depositRequirementValue?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Ids of the volume pools this customer has opted out of; empty when every pool on the
   * customer's price ladders applies. Honoured for every location of the customer, including one
   * assigned its own price group. Resolve the pools themselves through disabledVolumePools.
   */
  disabledVolumePoolIds?: InputMaybe<ListStringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  erpPriceGroupId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer-level federal tax number. Empty when not recorded. Mirrors
   * the taxExemptNumber field.
   */
  federalTaxNumber?: InputMaybe<StringOperationFilterInput>;
  /** The names of the customers combined into this one. */
  formerNames?: InputMaybe<ListStringOperationFilterInput>;
  /** The customer-level freight charge type, or null if not configured. */
  freightChargeType?: InputMaybe<IntOperationFilterInput>;
  /** The customer-level freight charge value. */
  freightChargeValue?: InputMaybe<DecimalOperationFilterInput>;
  history?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external sync key (Merge.dev document id) this customer was imported under.
   * Indexed (TenantId, ImportId) so mergeCustomer resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for native
   * customers / those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The customers combined into this one whose combine let their outside-sync record also update this
   * customer's settings. An import routed through any other combined customer's keys only adds or
   * updates that customer's own ship-tos and contacts here.
   */
  letOldSyncUpdateSettingsCustomerIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * The customer override of the tenant default minimum freight charge, applied once per order.
   * Null means the tenant default applies.
   */
  minimumFreightCharge?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberOfBillingAddresses?: InputMaybe<IntOperationFilterInput>;
  numberOfContacts?: InputMaybe<IntOperationFilterInput>;
  numberOfLocations?: InputMaybe<IntOperationFilterInput>;
  numberOfNotes?: InputMaybe<IntOperationFilterInput>;
  numberOfShipFromLocations?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CustomersSummaryDocumentFilterInput>>;
  /**
   * The customer's override of the tenant's default order entry unit — the unit this customer's
   * orders are placed in. Null means the customer has no override and inherits the tenant
   * default (and keeps inheriting it as that default changes), which is also how every customer
   * created before this setting existed reads. Read effectiveOrderEntryUnit for the
   * resolved value; compare the two to tell "inherited" from "overridden" without a second
   * query.
   */
  orderEntryUnit?: InputMaybe<NullableOfOrderEntryUnitOperationFilterInput>;
  /**
   * The customer-level "purchase order required" flag. Resolves to a concrete value
   * (default false). A location's own poRequired override inherits this value when unset.
   */
  poRequired?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * How sales prices are entered and shown for this customer: per each or per shipping unit.
   * Prices are always stored and billed per each. This is the customer's OVERRIDE of the company
   * default; null means the customer follows the company default. Read
   * effectivePriceEntryUnit for the resolved value.
   */
  priceEntryUnit?: InputMaybe<NullableOfPriceEntryUnitOperationFilterInput>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceGroupName?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer's phone number as the GrowPoint-parity reports render it: the
   * ContactType.Primary contact's first phone number. Empty when the customer has no
   * Primary contact, or that contact records no phone — never null, never a placeholder. There is
   * no fallback to a non-Primary contact.
   */
  primaryContactPhone?: InputMaybe<StringOperationFilterInput>;
  /** The end (HH:mm) of the customer's receiving window; see receivingWindowStart. */
  receivingWindowEnd?: InputMaybe<StringOperationFilterInput>;
  /**
   * The start (HH:mm) of the customer's receiving window, the window of every ship-to that sets none of
   * its own. Null when the customer has no window.
   */
  receivingWindowStart?: InputMaybe<StringOperationFilterInput>;
  /**
   * Customer-level route override — tier 2 of the hierarchical route setting. Empty means
   * "inherit the tenant default". Read by MongoCustomerService.GetInheritedRoute.
   */
  route?: InputMaybe<StringOperationFilterInput>;
  /**
   * Customer-level master toggle for whether invoice-issue emails are sent.
   * Null on legacy documents; consumers must coalesce to the policy default.
   */
  sendInvoiceEmails?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Customer-level master toggle for whether order-confirmation emails are sent.
   * Null on legacy documents; consumers must coalesce to the policy default.
   */
  sendOrderEmails?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The customer's override of the tenant's default statement delivery METHOD — how their
   * statement of account reaches them. Null means the customer has no override and inherits the
   * tenant default (and keeps inheriting it as that default changes), which is also how every
   * customer created before this setting existed reads. Read
   * effectiveStatementDeliveryMethod for the resolved value; compare the two to tell
   * "inherited" from "overridden" without a second query.
   */
  statementDeliveryMethod?: InputMaybe<NullableOfStatementDeliveryMethodOperationFilterInput>;
  /**
   * The skip-zero-balance half of this customer's statement delivery override. Null exactly when
   * statementDeliveryMethod is null — the override is the whole policy or nothing.
   * Read effectiveStatementSkipZeroBalance for the resolved value.
   */
  statementSkipZeroBalance?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<CustomerStatusOperationFilterInput>;
  synchronizeOrders?: InputMaybe<BooleanOperationFilterInput>;
  /** The customer-level tax exempt number. Empty when the customer is taxable. */
  taxExemptNumber?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
  termsName?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer's unload minutes, the minutes of every ship-to that sets none of its own. Null when the
   * customer has none.
   */
  unloadMinutes?: InputMaybe<IntOperationFilterInput>;
};

export type CustomersSummaryDocumentSortInput = {
  /**
   * The customer-level default freight carrier (ENS). Plain optional string — not a managed
   * carrier master/aggregate. Empty when not recorded. New Orders for this customer inherit
   * it at create time (see MongoCustomerService.GetInheritedCarrier); overridable
   * per-order.
   */
  carrier?: InputMaybe<SortEnumType>;
  /** When this customer was combined into another, or null. */
  combinedAt?: InputMaybe<SortEnumType>;
  /** The user who combined this customer into another, or null. */
  combinedBy?: InputMaybe<SortEnumType>;
  /**
   * The customer this one was combined into, or null while it stands on its own. A combined
   * customer is inactive, keeps its row and is hidden from the customer lists unless
   * includeCombined is true.
   */
  combinedIntoCustomerId?: InputMaybe<SortEnumType>;
  /**
   * The stable external CRM sync key (Salesforce/HubSpot via Merge.dev) this customer was imported
   * under. Indexed (TenantId, CrmImportId) so mergeCustomer resolves CRM create-vs-update by
   * a CrmImportId lookup on a field SEPARATE from ImportId (the accounting key), so a
   * tenant syncing both never collides. Empty for native / non-CRM customers.
   */
  crmImportId?: InputMaybe<SortEnumType>;
  /**
   * The record's URL in the source CRM (Merge's account_url — e.g. the HubSpot company
   * page), surfaced by the pwa "View in CRM" link. A display value, distinct from
   * CrmImportId (the routing key). Empty for native / non-CRM customers.
   */
  crmRecordUrl?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  /**
   * Optional FK into the CustomerGroup read model. Empty when the customer has no group assigned.
   * PATCH-shaped on updateCustomer: omitting the field (or sending null) preserves the
   * existing assignment; sending an empty string explicitly clears it; sending an id sets it.
   * Also set directly via the narrow setCustomerGroup mutation.
   */
  customerGroupId?: InputMaybe<SortEnumType>;
  /**
   * The assigned CustomerGroup's name, resolved at query time. Empty when the customer has no
   * group assigned.
   */
  customerGroupName?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerLookupCode?: InputMaybe<SortEnumType>;
  /**
   * Optional FK into the CustomerType read model (CustomerTypes). Empty when the
   * customer has no type assigned. PATCH-shaped on updateCustomer: omitting the field (or
   * sending null) preserves the existing assignment — a mergeCustomer/importCustomer sync, which
   * never carries this native-only field, cannot wipe it on re-sync. Sending an empty string
   * explicitly clears the assignment; sending an id sets it (validated: must exist and be
   * Active). See CustomerProjectionService.UpdateCustomer's conditional Set.
   */
  customerTypeId?: InputMaybe<SortEnumType>;
  /**
   * Resolved at query time via ICustomerTypeNameByTenantAndCustomerTypeIdDataLoader
   * (mirrors PriceGroupName/TermsName) — never written by the
   * projection.
   */
  customerTypeName?: InputMaybe<SortEnumType>;
  dateCreated?: InputMaybe<SortEnumType>;
  /**
   * The customer-level default discount percentage. Auto-applies to new orders for this customer.
   * Null means no default discount.
   */
  defaultDiscountPercentage?: InputMaybe<SortEnumType>;
  /** Id of the Tag color new orders for this customer start with. Null means the customer has no default color. */
  defaultTagColorId?: InputMaybe<SortEnumType>;
  /**
   * How the customer's order-deposit requirement is calculated, or null when the customer
   * requires no deposit (their orders are never deposit-blocked). The order allocate-lock reads
   * this (with the deposit requirement value) to compute the required deposit.
   */
  depositRequirementType?: InputMaybe<SortEnumType>;
  /**
   * The customer's deposit requirement value: a percentage (0–100) for Percentage requirements,
   * or a flat amount for FlatAmount requirements. Null when no requirement is configured.
   */
  depositRequirementValue?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  erpPriceGroupId?: InputMaybe<SortEnumType>;
  /**
   * The customer-level federal tax number. Empty when not recorded. Mirrors
   * the taxExemptNumber field.
   */
  federalTaxNumber?: InputMaybe<SortEnumType>;
  /** The customer-level freight charge type, or null if not configured. */
  freightChargeType?: InputMaybe<SortEnumType>;
  /** The customer-level freight charge value. */
  freightChargeValue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable external sync key (Merge.dev document id) this customer was imported under.
   * Indexed (TenantId, ImportId) so mergeCustomer resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for native
   * customers / those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  /**
   * The customer override of the tenant default minimum freight charge, applied once per order.
   * Null means the tenant default applies.
   */
  minimumFreightCharge?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  numberOfBillingAddresses?: InputMaybe<SortEnumType>;
  numberOfContacts?: InputMaybe<SortEnumType>;
  numberOfLocations?: InputMaybe<SortEnumType>;
  numberOfNotes?: InputMaybe<SortEnumType>;
  numberOfShipFromLocations?: InputMaybe<SortEnumType>;
  /**
   * The customer's override of the tenant's default order entry unit — the unit this customer's
   * orders are placed in. Null means the customer has no override and inherits the tenant
   * default (and keeps inheriting it as that default changes), which is also how every customer
   * created before this setting existed reads. Read effectiveOrderEntryUnit for the
   * resolved value; compare the two to tell "inherited" from "overridden" without a second
   * query.
   */
  orderEntryUnit?: InputMaybe<SortEnumType>;
  /**
   * The customer-level "purchase order required" flag. Resolves to a concrete value
   * (default false). A location's own poRequired override inherits this value when unset.
   */
  poRequired?: InputMaybe<SortEnumType>;
  /**
   * How sales prices are entered and shown for this customer: per each or per shipping unit.
   * Prices are always stored and billed per each. This is the customer's OVERRIDE of the company
   * default; null means the customer follows the company default. Read
   * effectivePriceEntryUnit for the resolved value.
   */
  priceEntryUnit?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceGroupName?: InputMaybe<SortEnumType>;
  /**
   * The customer's phone number as the GrowPoint-parity reports render it: the
   * ContactType.Primary contact's first phone number. Empty when the customer has no
   * Primary contact, or that contact records no phone — never null, never a placeholder. There is
   * no fallback to a non-Primary contact.
   */
  primaryContactPhone?: InputMaybe<SortEnumType>;
  /** The end (HH:mm) of the customer's receiving window; see receivingWindowStart. */
  receivingWindowEnd?: InputMaybe<SortEnumType>;
  /**
   * The start (HH:mm) of the customer's receiving window, the window of every ship-to that sets none of
   * its own. Null when the customer has no window.
   */
  receivingWindowStart?: InputMaybe<SortEnumType>;
  /**
   * Customer-level route override — tier 2 of the hierarchical route setting. Empty means
   * "inherit the tenant default". Read by MongoCustomerService.GetInheritedRoute.
   */
  route?: InputMaybe<SortEnumType>;
  /**
   * Customer-level master toggle for whether invoice-issue emails are sent.
   * Null on legacy documents; consumers must coalesce to the policy default.
   */
  sendInvoiceEmails?: InputMaybe<SortEnumType>;
  /**
   * Customer-level master toggle for whether order-confirmation emails are sent.
   * Null on legacy documents; consumers must coalesce to the policy default.
   */
  sendOrderEmails?: InputMaybe<SortEnumType>;
  /**
   * The customer's override of the tenant's default statement delivery METHOD — how their
   * statement of account reaches them. Null means the customer has no override and inherits the
   * tenant default (and keeps inheriting it as that default changes), which is also how every
   * customer created before this setting existed reads. Read
   * effectiveStatementDeliveryMethod for the resolved value; compare the two to tell
   * "inherited" from "overridden" without a second query.
   */
  statementDeliveryMethod?: InputMaybe<SortEnumType>;
  /**
   * The skip-zero-balance half of this customer's statement delivery override. Null exactly when
   * statementDeliveryMethod is null — the override is the whole policy or nothing.
   * Read effectiveStatementSkipZeroBalance for the resolved value.
   */
  statementSkipZeroBalance?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  synchronizeOrders?: InputMaybe<SortEnumType>;
  /** The customer-level tax exempt number. Empty when the customer is taxable. */
  taxExemptNumber?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
  termsName?: InputMaybe<SortEnumType>;
  /**
   * The customer's unload minutes, the minutes of every ship-to that sets none of its own. Null when the
   * customer has none.
   */
  unloadMinutes?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL payload returned by every CycleCountAssignment mutation. Follows the
 * standard mutation payload convention: nullable state on success,
 * ValidationError array on failure
 * (Atlas: cd1f708de28e44f8ae6d21f9a20f2212 — Payload Error Convention).
 *
 * SkippedItems reports MaterialItemIds that the supervisor
 * nominated on createCountAssignment but which produced ZERO count tasks:
 * either the item had no stocked bins in the
 * MaterialItemLocationQuantity read model, or every one of its bins failed
 * the site invariant (the location hierarchy named no owning site, or two
 * different ones). They produce no tasks but must remain visible so the
 * supervisor can distinguish "0 assignable bins for item X" from
 * "no items requested at all" (B4-D). An item that loses only SOME of its bins
 * still produces tasks for the resolvable ones and is NOT listed here. The field
 * is additive
 * (Atlas: bde8323d82064d928e44bebcff552a2e) — every mutation populates it
 * with at least an empty array, never null, so the schema surface is the
 * non-null-list-of-non-null-strings shape clients can rely on
 * (Codex C2-F3 cycle 1 finding).
 */
export type CycleCountAssignmentPayload = {
  __typename?: 'CycleCountAssignmentPayload';
  /**
   * The orders whose allocations completeAssignmentTask released because its count took stock orders held: free
   * stock goes first, then the newest orders' allocations. Only the orders the caller can see under the
   * orders visibility rule are named; otherAffectedOrderCount counts the rest. Empty when
   * nothing was released, and on every other mutation.
   */
  affectedOrders: Array<InventoryOrderImpactData>;
  cycleCountAssignment?: Maybe<CycleCountAssignmentStateData>;
  errors?: Maybe<Array<ValidationError>>;
  /** How many other released orders there are, which the caller cannot see. */
  otherAffectedOrderCount: Scalars['Int']['output'];
  /**
   * Material item IDs the supervisor nominated on createCountAssignment
   * that produced ZERO count tasks: either the item had no stocked bins in the
   * read model, or every one of its bins failed the site invariant (the location
   * hierarchy named no owning site, or two different ones). An item that loses
   * only SOME of its bins still produces tasks for the resolvable ones and is
   * NOT listed here — see
   * CycleCountAssignmentMutation.BuildCommandFromResolvedBins. Always
   * populated as an empty array (never null) on every other mutation so the
   * schema surface is the non-null-list-of-non-null-strings shape clients can
   * rely on (Codex C2-F3 cycle 1; Atlas bde8323d82064d928e44bebcff552a2e).
   */
  skippedItems: Array<Scalars['String']['output']>;
};

/**
 * Flattened GraphQL projection of CycleCountAssignmentState. The
 * StateData suffix follows the WSAPI convention reserved for cross-layer
 * shapes (Atlas: ...Data types are unique to their producing layer).
 */
export type CycleCountAssignmentStateData = {
  __typename?: 'CycleCountAssignmentStateData';
  assignmentId: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['String']['output'];
  dueBy: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  status: CycleCountAssignmentStatus;
  tasks: Array<CycleCountAssignmentTaskStateData>;
  tenantId: Scalars['String']['output'];
  workerUserId?: Maybe<Scalars['String']['output']>;
};

export enum CycleCountAssignmentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS',
  Unknown = 'UNKNOWN'
}

/** Per-task GraphQL projection. */
export type CycleCountAssignmentTaskStateData = {
  __typename?: 'CycleCountAssignmentTaskStateData';
  binLocationId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedQty?: Maybe<Scalars['Decimal']['output']>;
  expectedQty: Scalars['Decimal']['output'];
  materialItemId: Scalars['String']['output'];
  overrideQty?: Maybe<Scalars['Decimal']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CycleCountTaskStatus;
  taskId: Scalars['String']['output'];
  varianceReasonCode?: Maybe<Scalars['Int']['output']>;
};

/**
 * One batch of a counted item: the code as typed, or one of the store row's existing batches, and the
 * quantity counted on it. A null code is the unknown batch.
 */
export type CycleCountBatchInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Decimal']['input'];
};

/** A connection to a list of items. */
export type CycleCountHistoryConnection = {
  __typename?: 'CycleCountHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CycleCountHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CycleCountLogDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CycleCountHistoryEdge = {
  __typename?: 'CycleCountHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CycleCountLogDocument;
};

/** Input for a single item within a cycle count submission. */
export type CycleCountItemInput = {
  batches?: InputMaybe<Array<CycleCountBatchInput>>;
  itemId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Decimal']['input'];
  reasonCode?: InputMaybe<Scalars['String']['input']>;
};

/** One batch the counter named for an item in a cycle count submission. */
export type CycleCountLogBatch = {
  __typename?: 'CycleCountLogBatch';
  /** The batch code as typed; null for stock counted on the unknown batch. */
  code?: Maybe<Scalars['String']['output']>;
  /** The quantity counted on that batch. */
  quantity: Scalars['Decimal']['output'];
};

/** One batch the counter named for an item in a cycle count submission. */
export type CycleCountLogBatchFilterInput = {
  and?: InputMaybe<Array<CycleCountLogBatchFilterInput>>;
  /** The batch code as typed; null for stock counted on the unknown batch. */
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CycleCountLogBatchFilterInput>>;
  /** The quantity counted on that batch. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * Persisted record of a cycle count submission — one document per
 * CycleCountMutation.PostCycleCounts call.
 * Queried by CycleCountQuery.GetCycleCountHistory.
 */
export type CycleCountLogDocument = {
  __typename?: 'CycleCountLogDocument';
  /** The device fix's reported accuracy radius in metres; null when not sent. */
  accuracyMeters?: Maybe<Scalars['Decimal']['output']>;
  /** When the device took the fix, as the client reported it; null when not sent. */
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** Optional client-provided key to prevent duplicate submissions from offline queue retries. */
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  /** Total number of items in this submission. */
  itemCount: Scalars['Int']['output'];
  /** Individual item counts within this submission. */
  items: Array<CycleCountLogItem>;
  /**
   * Latitude of the counter's device when the count was submitted. Null when the client sent no fix
   * (location not allowed or unavailable) and on documents written before geo was captured.
   */
  latitude?: Maybe<Scalars['Decimal']['output']>;
  /** Store/site location that was counted. */
  locationId: Scalars['String']['output'];
  /** Display name of the location at the time of posting. */
  locationName: Scalars['String']['output'];
  /** Longitude of the counter's device, paired with latitude; null exactly when latitude is. */
  longitude?: Maybe<Scalars['Decimal']['output']>;
  /** UTC time the count was submitted. */
  postedAt: Scalars['DateTime']['output'];
  /** Email of the person who submitted the count. */
  recordedBy: Scalars['String']['output'];
  /** Tenant that owns this count record. */
  tenantId: Scalars['String']['output'];
};

/**
 * Persisted record of a cycle count submission — one document per
 * CycleCountMutation.PostCycleCounts call.
 * Queried by CycleCountQuery.GetCycleCountHistory.
 */
export type CycleCountLogDocumentFilterInput = {
  and?: InputMaybe<Array<CycleCountLogDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** Optional client-provided key to prevent duplicate submissions from offline queue retries. */
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  /** Total number of items in this submission. */
  itemCount?: InputMaybe<IntOperationFilterInput>;
  /** Individual item counts within this submission. */
  items?: InputMaybe<ListFilterInputTypeOfCycleCountLogItemFilterInput>;
  /** Store/site location that was counted. */
  locationId?: InputMaybe<StringOperationFilterInput>;
  /** Display name of the location at the time of posting. */
  locationName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CycleCountLogDocumentFilterInput>>;
  /** UTC time the count was submitted. */
  postedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Email of the person who submitted the count. */
  recordedBy?: InputMaybe<StringOperationFilterInput>;
  /** Tenant that owns this count record. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Persisted record of a cycle count submission — one document per
 * CycleCountMutation.PostCycleCounts call.
 * Queried by CycleCountQuery.GetCycleCountHistory.
 */
export type CycleCountLogDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  /** Optional client-provided key to prevent duplicate submissions from offline queue retries. */
  idempotencyKey?: InputMaybe<SortEnumType>;
  /** Total number of items in this submission. */
  itemCount?: InputMaybe<SortEnumType>;
  /** Store/site location that was counted. */
  locationId?: InputMaybe<SortEnumType>;
  /** Display name of the location at the time of posting. */
  locationName?: InputMaybe<SortEnumType>;
  /** UTC time the count was submitted. */
  postedAt?: InputMaybe<SortEnumType>;
  /** Email of the person who submitted the count. */
  recordedBy?: InputMaybe<SortEnumType>;
  /** Tenant that owns this count record. */
  tenantId?: InputMaybe<SortEnumType>;
};

/** A single item-level entry within a CycleCountLogDocument. */
export type CycleCountLogItem = {
  __typename?: 'CycleCountLogItem';
  /**
   * The batches the counter named for this item, as typed, in the order sent. Empty when the count
   * named none, and on documents written before batches existed. Recorded whether or not the item is
   * batch tracked, so the submission keeps what the counter entered.
   */
  batches: Array<CycleCountLogBatch>;
  /** Item identifier. */
  itemId: Scalars['String']['output'];
  /** Display name of the item at the time of posting. */
  itemName: Scalars['String']['output'];
  /**
   * Optional free-text note captured at count submit time. Bounded by
   * MaxNoteLength; null when absent.
   */
  note?: Maybe<Scalars['String']['output']>;
  /** The hard-count quantity recorded for this item at this location. */
  quantity: Scalars['Decimal']['output'];
  /**
   * Optional reason recorded with this item count (e.g. "Damaged", "Moved").
   * Validated at the mutation boundary against
   * WorkSuite.Domain.Shared.CountReasons; null when absent
   * or whitespace at submission time. Legacy documents written before this field was
   * introduced read back as null.
   */
  reasonCode?: Maybe<Scalars['String']['output']>;
  /** SKU of the item. */
  sku: Scalars['String']['output'];
};

/** A single item-level entry within a CycleCountLogDocument. */
export type CycleCountLogItemFilterInput = {
  and?: InputMaybe<Array<CycleCountLogItemFilterInput>>;
  /**
   * The batches the counter named for this item, as typed, in the order sent. Empty when the count
   * named none, and on documents written before batches existed. Recorded whether or not the item is
   * batch tracked, so the submission keeps what the counter entered.
   */
  batches?: InputMaybe<ListFilterInputTypeOfCycleCountLogBatchFilterInput>;
  /** Item identifier. */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** Display name of the item at the time of posting. */
  itemName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Optional free-text note captured at count submit time. Bounded by
   * MaxNoteLength; null when absent.
   */
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CycleCountLogItemFilterInput>>;
  /** The hard-count quantity recorded for this item at this location. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Optional reason recorded with this item count (e.g. "Damaged", "Moved").
   * Validated at the mutation boundary against
   * WorkSuite.Domain.Shared.CountReasons; null when absent
   * or whitespace at submission time. Legacy documents written before this field was
   * introduced read back as null.
   */
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  /** SKU of the item. */
  sku?: InputMaybe<StringOperationFilterInput>;
};

/**
 * GraphQL payload returned from CycleCountMutation.PostCycleCounts.
 * Returns the persisted log document on success, or validation errors on failure.
 */
export type CycleCountPayload = {
  __typename?: 'CycleCountPayload';
  cycleCount?: Maybe<CycleCountLogDocument>;
  errors?: Maybe<Array<ValidationError>>;
  /** Number of items successfully posted. Zero on failure. */
  itemsPosted: Scalars['Int']['output'];
  /** True when all items were successfully posted. */
  success: Scalars['Boolean']['output'];
};

export enum CycleCountTaskStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
  Unknown = 'UNKNOWN'
}

export type CycleCountTaskStatusOperationFilterInput = {
  eq?: InputMaybe<CycleCountTaskStatus>;
  in?: InputMaybe<Array<CycleCountTaskStatus>>;
  neq?: InputMaybe<CycleCountTaskStatus>;
  nin?: InputMaybe<Array<CycleCountTaskStatus>>;
};

export type DailySalesProportionDocument = {
  __typename?: 'DailySalesProportionDocument';
  calcSteps: Array<RestockCalcStep>;
  calculatedAt: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  dayOfWeek: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  productGroup: Scalars['String']['output'];
  proportion: Scalars['Decimal']['output'];
  region: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type DailySalesProportionDocumentFilterInput = {
  and?: InputMaybe<Array<DailySalesProportionDocumentFilterInput>>;
  calcSteps?: InputMaybe<ListFilterInputTypeOfRestockCalcStepFilterInput>;
  calculatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  dayOfWeek?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DailySalesProportionDocumentFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  proportion?: InputMaybe<DecimalOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type DailySalesProportionDocumentSortInput = {
  calculatedAt?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  dayOfWeek?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  proportion?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/**
 * MongoDB read model for the Restock work-queue worker's latest output per
 * (TenantId, CustomerCode, ItemCode, LocationCode, WeeksOfSupply). Direct-write —
 * written by the wsapi-services DbrCalcDemandQuantity worker, not projected
 * from KurrentDB events. Latest-only; the 5-tuple Id extends the
 * historical 4-tuple by appending the calc-time WOS so UC3 user-override values
 * (different WOS for the same natural key) don't collide on the cache key.
 * Wire-level Mongo collection name retained as DbrCalcResults during dev rollout.
 */
export type DbrCalcResultDocument = {
  __typename?: 'DbrCalcResultDocument';
  /**
   * Per-store achievable quantity from the R33 allocation engine, or null
   * when allocation did not run for the row. Pre-R34 this is null for most rows;
   * T-C callers surface 0 with an OTel achievable-null counter rather than blocking.
   */
  achievableQuantity?: Maybe<Scalars['Int']['output']>;
  /** Timestamp at which this result was produced. */
  calcDate: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  /**
   * Customer display name resolved from CustomersSummaryDocument via the
   * row's RestockWorkQueueResultDocument.CustomerCode (i.e. the customer's
   * CustomerLookupCode). Null when no summary exists for the code so the client
   * can render a fallback rather than receiving an empty string that masks missing data.
   */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Primary calc output — the demand quantity produced by the strategy. */
  demandQuantity: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  /**
   * Bounded snapshot of inputs that fed the calculation. Captured for explainability
   * rather than recomputation — keep small, do not store full upstream documents.
   */
  inputsSnapshot: Array<DbrCalcResultInputDocument>;
  itemCode: Scalars['String']['output'];
  /**
   * Item display name resolved from ItemSummaryDocument via the row's
   * RestockWorkQueueResultDocument.ItemCode (i.e. the item's
   * ItemLookupCode). Null when no summary exists for the code.
   */
  itemName?: Maybe<Scalars['String']['output']>;
  locationCode: Scalars['String']['output'];
  /**
   * Customer-location display name resolved from CustomerLocationDocument
   * via the row's (RestockWorkQueueResultDocument.CustomerCode,
   * RestockWorkQueueResultDocument.LocationCode) pair (i.e. the location's
   * CustomerLookupCode + LocationLookupCode). Both codes are needed because
   * LocationLookupCode is only unique within a customer.
   */
  locationName?: Maybe<Scalars['String']['output']>;
  /**
   * Operator-facing per-row order quantity. Reads RestockWorkQueueResultDocument.AchievableQuantity
   * when allocation has run; falls back to a rounded RestockWorkQueueResultDocument.DemandQuantity
   * for rows where the allocation engine did not produce a value (per T-E spec:
   * "orderQuantity = demand for now"). Does NOT recompute achievable — see Atlas
   * standard e05b714192b34cc298e08d3bbbc241da.
   */
  orderQuantity: Scalars['Int']['output'];
  /**
   * Per-store Restock Index (0–100) for the row's RestockWorkQueueResultDocument.CustomerCode
   * + RestockWorkQueueResultDocument.LocationCode pair. Aggregated across
   * every current calc row for that store (not just the daily-demand grid's
   * asOf/weeksOfSupply slice) so the column shows the same value as the
   * per-store dashboard. Resolved via a batch DataLoader so a page of N daily-demand
   * rows costs one round-trip, not N.
   */
  storeRanking?: Maybe<Scalars['Int']['output']>;
  /** Identifier of the strategy that produced this result. */
  strategyKey: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /**
   * Weeks-of-supply the calc row was produced for. Top-level (not folded into
   * InputsSnapshot) so the 5-tuple Id remains
   * reconstructible without parsing and per-WOS reads can filter directly.
   */
  weeksOfSupply: Scalars['Decimal']['output'];
};

/**
 * MongoDB read model for the Restock work-queue worker's latest output per
 * (TenantId, CustomerCode, ItemCode, LocationCode, WeeksOfSupply). Direct-write —
 * written by the wsapi-services DbrCalcDemandQuantity worker, not projected
 * from KurrentDB events. Latest-only; the 5-tuple Id extends the
 * historical 4-tuple by appending the calc-time WOS so UC3 user-override values
 * (different WOS for the same natural key) don't collide on the cache key.
 * Wire-level Mongo collection name retained as DbrCalcResults during dev rollout.
 */
export type DbrCalcResultDocumentFilterInput = {
  /**
   * Per-store achievable quantity from the R33 allocation engine, or null
   * when allocation did not run for the row. Pre-R34 this is null for most rows;
   * T-C callers surface 0 with an OTel achievable-null counter rather than blocking.
   */
  achievableQuantity?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<DbrCalcResultDocumentFilterInput>>;
  /** Timestamp at which this result was produced. */
  calcDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  /** Primary calc output — the demand quantity produced by the strategy. */
  demandQuantity?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Bounded snapshot of inputs that fed the calculation. Captured for explainability
   * rather than recomputation — keep small, do not store full upstream documents.
   */
  inputsSnapshot?: InputMaybe<ListFilterInputTypeOfDbrCalcResultInputDocumentFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  locationCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DbrCalcResultDocumentFilterInput>>;
  /** Identifier of the strategy that produced this result. */
  strategyKey?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Weeks-of-supply the calc row was produced for. Top-level (not folded into
   * InputsSnapshot) so the 5-tuple Id remains
   * reconstructible without parsing and per-WOS reads can filter directly.
   */
  weeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * MongoDB read model for the Restock work-queue worker's latest output per
 * (TenantId, CustomerCode, ItemCode, LocationCode, WeeksOfSupply). Direct-write —
 * written by the wsapi-services DbrCalcDemandQuantity worker, not projected
 * from KurrentDB events. Latest-only; the 5-tuple Id extends the
 * historical 4-tuple by appending the calc-time WOS so UC3 user-override values
 * (different WOS for the same natural key) don't collide on the cache key.
 * Wire-level Mongo collection name retained as DbrCalcResults during dev rollout.
 */
export type DbrCalcResultDocumentSortInput = {
  /**
   * Per-store achievable quantity from the R33 allocation engine, or null
   * when allocation did not run for the row. Pre-R34 this is null for most rows;
   * T-C callers surface 0 with an OTel achievable-null counter rather than blocking.
   */
  achievableQuantity?: InputMaybe<SortEnumType>;
  /** Timestamp at which this result was produced. */
  calcDate?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  /** Primary calc output — the demand quantity produced by the strategy. */
  demandQuantity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCode?: InputMaybe<SortEnumType>;
  locationCode?: InputMaybe<SortEnumType>;
  /** Identifier of the strategy that produced this result. */
  strategyKey?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /**
   * Weeks-of-supply the calc row was produced for. Top-level (not folded into
   * InputsSnapshot) so the 5-tuple Id remains
   * reconstructible without parsing and per-WOS reads can filter directly.
   */
  weeksOfSupply?: InputMaybe<SortEnumType>;
};

/**
 * Single named input captured in RestockWorkQueueResultDocument.InputsSnapshot.
 * String value keeps the snapshot type-uniform regardless of input shape.
 */
export type DbrCalcResultInputDocument = {
  __typename?: 'DbrCalcResultInputDocument';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Single named input captured in RestockWorkQueueResultDocument.InputsSnapshot.
 * String value keeps the snapshot type-uniform regardless of input shape.
 */
export type DbrCalcResultInputDocumentFilterInput = {
  and?: InputMaybe<Array<DbrCalcResultInputDocumentFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DbrCalcResultInputDocumentFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

/** Scheduler heartbeat snapshot exposed by RestockWorkQueueFleetQuery.GetAdminRestockWorkQueueSchedulerStatus. */
export type DbrCalcSchedulerStatusResult = {
  __typename?: 'DbrCalcSchedulerStatusResult';
  /**
   * Most recent successful EntityType.DbrCalcScheduler iteration End.
   * Diverges from LastTick when the scheduler is currently failing — operational
   * signal that the heartbeat is degraded. Null when no successful tick has been recorded.
   */
  lastSuccessfulTick?: Maybe<Scalars['DateTime']['output']>;
  /** Most recent EntityType.DbrCalcScheduler iteration End regardless of success. Null when none recorded. */
  lastTick?: Maybe<Scalars['DateTime']['output']>;
  /** Success flag of the most recent tick (the one represented by LastTick). Null when none recorded. */
  lastTickSucceeded?: Maybe<Scalars['Boolean']['output']>;
  /** Configured tick interval in milliseconds (TimerPeriodSeconds * 1000). Null when no config row exists. */
  tickIntervalMs?: Maybe<Scalars['Int']['output']>;
};

/**
 * One row per tenant tracked by the Restock work-queue scheduler/worker.
 * Direct-write collection (not event-sourced). The scheduler (S16) maintains
 * OldestPendingCalcDate, HasPendingWork, and
 * Priority on each tick from work-queue rows;
 * RefreshHours, MaxStalenessHours, and
 * Enabled are copied from the Tenant aggregate config so workers
 * can pick a tenant without resolving the aggregate. Workers query
 * Enabled = true sorted by Priority ascending and take 1.
 * Wire-level Mongo collection name retained as DbrCalcTenantQueue during dev rollout.
 */
export type DbrCalcTenantQueueDocument = {
  __typename?: 'DbrCalcTenantQueueDocument';
  /** Per-tenant feature gate, copied from Tenant config; workers exclude rows with Enabled = false. */
  enabled: Scalars['Boolean']['output'];
  /** True when the tenant currently has work-queue rows pending recalculation. */
  hasPendingWork: Scalars['Boolean']['output'];
  /** Natural id — the tenantId; one row per tenant. */
  id: Scalars['String']['output'];
  /** Maximum allowable staleness (hours), copied from Tenant config for cheap reads. */
  maxStalenessHours: Scalars['Int']['output'];
  /** Earliest work-queue LastCalcDate across the tenant's pending rows; null when no pending rows. */
  oldestPendingCalcDate?: Maybe<Scalars['DateTime']['output']>;
  /** EDF deadline rank — smaller = higher priority. Computed by the scheduler (S16). */
  priority: Scalars['Int']['output'];
  /** Cache refresh interval (hours), copied from Tenant config for cheap reads. */
  refreshHours: Scalars['Int']['output'];
};

/**
 * One row per tenant tracked by the Restock work-queue scheduler/worker.
 * Direct-write collection (not event-sourced). The scheduler (S16) maintains
 * OldestPendingCalcDate, HasPendingWork, and
 * Priority on each tick from work-queue rows;
 * RefreshHours, MaxStalenessHours, and
 * Enabled are copied from the Tenant aggregate config so workers
 * can pick a tenant without resolving the aggregate. Workers query
 * Enabled = true sorted by Priority ascending and take 1.
 * Wire-level Mongo collection name retained as DbrCalcTenantQueue during dev rollout.
 */
export type DbrCalcTenantQueueDocumentFilterInput = {
  and?: InputMaybe<Array<DbrCalcTenantQueueDocumentFilterInput>>;
  /** Per-tenant feature gate, copied from Tenant config; workers exclude rows with Enabled = false. */
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  /** True when the tenant currently has work-queue rows pending recalculation. */
  hasPendingWork?: InputMaybe<BooleanOperationFilterInput>;
  /** Natural id — the tenantId; one row per tenant. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Maximum allowable staleness (hours), copied from Tenant config for cheap reads. */
  maxStalenessHours?: InputMaybe<IntOperationFilterInput>;
  /** Earliest work-queue LastCalcDate across the tenant's pending rows; null when no pending rows. */
  oldestPendingCalcDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DbrCalcTenantQueueDocumentFilterInput>>;
  /** EDF deadline rank — smaller = higher priority. Computed by the scheduler (S16). */
  priority?: InputMaybe<IntOperationFilterInput>;
  /** Cache refresh interval (hours), copied from Tenant config for cheap reads. */
  refreshHours?: InputMaybe<IntOperationFilterInput>;
};

/**
 * One row per tenant tracked by the Restock work-queue scheduler/worker.
 * Direct-write collection (not event-sourced). The scheduler (S16) maintains
 * OldestPendingCalcDate, HasPendingWork, and
 * Priority on each tick from work-queue rows;
 * RefreshHours, MaxStalenessHours, and
 * Enabled are copied from the Tenant aggregate config so workers
 * can pick a tenant without resolving the aggregate. Workers query
 * Enabled = true sorted by Priority ascending and take 1.
 * Wire-level Mongo collection name retained as DbrCalcTenantQueue during dev rollout.
 */
export type DbrCalcTenantQueueDocumentSortInput = {
  /** Per-tenant feature gate, copied from Tenant config; workers exclude rows with Enabled = false. */
  enabled?: InputMaybe<SortEnumType>;
  /** True when the tenant currently has work-queue rows pending recalculation. */
  hasPendingWork?: InputMaybe<SortEnumType>;
  /** Natural id — the tenantId; one row per tenant. */
  id?: InputMaybe<SortEnumType>;
  /** Maximum allowable staleness (hours), copied from Tenant config for cheap reads. */
  maxStalenessHours?: InputMaybe<SortEnumType>;
  /** Earliest work-queue LastCalcDate across the tenant's pending rows; null when no pending rows. */
  oldestPendingCalcDate?: InputMaybe<SortEnumType>;
  /** EDF deadline rank — smaller = higher priority. Computed by the scheduler (S16). */
  priority?: InputMaybe<SortEnumType>;
  /** Cache refresh interval (hours), copied from Tenant config for cheap reads. */
  refreshHours?: InputMaybe<SortEnumType>;
};

/**
 * Per-tenant summary projected from RestockWorkQueueTenantDocument for
 * SuperAdmin observability of the Restock work-queue backlog.
 */
export type DbrCalcWorkSummary = {
  __typename?: 'DbrCalcWorkSummary';
  /** True when the tenant has work-queue rows pending recalculation. */
  hasPendingWork: Scalars['Boolean']['output'];
  /** Earliest pending work-queue LastCalcDate for the tenant; null when no pending rows. */
  oldestPending?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Worker fleet snapshot exposed by RestockWorkQueueFleetQuery.GetAdminRestockWorkQueueWorkerFleetStatus.
 * All counts are global (cross-tenant) — the query is SuperAdmin-gated.
 */
export type DbrCalcWorkerFleetStatusResult = {
  __typename?: 'DbrCalcWorkerFleetStatusResult';
  /** Current count of RestockWorkQueueDocument rows with a non-null LeaseId. */
  currentLeases: Scalars['Int']['output'];
  /**
   * Age in milliseconds of the oldest in-flight lease (smallest LockedDate among
   * rows with a non-null LeaseId). Null when there are no current leases.
   */
  oldestLeaseAgeMs?: Maybe<Scalars['Long']['output']>;
  /** Batch timing aggregates over the recent window. */
  recentBatchTimings: BatchTimingsResult;
  /**
   * Count of EntityType.DbrCalcDemandQuantity iteration documents whose
   * End falls inside the recent window. NOT a distinct worker count — a single
   * worker producing N batches contributes N to this value. IterationDocument
   * has no WorkerId field, so true distinct counts are out of scope here.
   */
  recentIterationCount: Scalars['Int']['output'];
};

export type DeactivateConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
};

export type DeactivateContainerConfigInput = {
  containerConfigId: Scalars['String']['input'];
};

export type DeactivateCustomerGroupInput = {
  id: Scalars['String']['input'];
};

export type DeactivateCustomerItemInput = {
  customerItemId: Scalars['String']['input'];
};

export type DeactivateCustomerTypeInput = {
  id: Scalars['String']['input'];
};

export type DeactivateCustomerUpgradeInput = {
  customerId: Scalars['String']['input'];
  upgradeId: Scalars['String']['input'];
};

export type DeactivateFlatChargeTypeInput = {
  id: Scalars['String']['input'];
};

export type DeactivateItemUpgradeInput = {
  itemId: Scalars['String']['input'];
  upgradeId: Scalars['String']['input'];
};

export type DeactivatePaymentProcessorInput = {
  id: Scalars['String']['input'];
};

export type DeactivatePortalUserInput = {
  deactivatedBy: Scalars['String']['input'];
  portalUserId: Scalars['String']['input'];
};

export type DeactivateProductionCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
};

export type DeactivateProductionLineInput = {
  productionLineId: Scalars['String']['input'];
};

export type DeactivateProductionLotInput = {
  archiveNotes?: InputMaybe<Scalars['String']['input']>;
  consolidatedIntoProductionLotId?: InputMaybe<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};

export type DeactivateProductionPlanInput = {
  productionPlanId: Scalars['String']['input'];
};

export type DeactivateProductionSpaceCategoryInput = {
  productionSpaceCategoryId: Scalars['String']['input'];
};

export type DeactivateProductionSpaceTypeInput = {
  productionSpaceTypeId: Scalars['String']['input'];
};

export type DeactivateSizeUomInput = {
  code: Scalars['String']['input'];
};

export type DeactivateUserInput = {
  userId: Scalars['String']['input'];
};

export type DeallocatePurchaseOrderAllocationInput = {
  allocationId: Scalars['String']['input'];
};

/** What a reviewer decided one extracted row means, and the evidence their decision rests on. */
export type DecideSupplierPriceImportRowInput = {
  /** Whether the base amount prices one each or a stated pack. */
  baseBasis: SupplierPriceQuoteBasis;
  /** How many of the material's units the base amount covers: one for a direct per-each quote, otherwise a pack size (a decimal, greater than zero, at most 4 decimal places). */
  baseDenominator: Scalars['Decimal']['input'];
  /** What the row is: matched, created, skipped, informational or unresolved. */
  disposition: SupplierPriceRowDisposition;
  /** The draft material's reviewed category, which has to already exist. */
  draftCategory?: InputMaybe<Scalars['String']['input']>;
  /** The draft material's reviewed name. */
  draftName?: InputMaybe<Scalars['String']['input']>;
  /** Whether a missing date is a deliberate choice to save the always-effective base rate. */
  effectiveDateDeliberatelyOmitted: Scalars['Boolean']['input'];
  /** The review revision the reviewer read. A save against any other revision is refused. */
  expectedReviewRevision: Scalars['Int']['input'];
  /** The import the row belongs to. */
  importId: Scalars['String']['input'];
  /** Whether more than one candidate manufacturer is still in play. */
  manufacturerAmbiguous: Scalars['Boolean']['input'];
  /** The day the price takes effect, read as the calendar day in the offset sent. */
  reviewedEffectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** A manufacturer label for this tenant, when no vendor record fits. */
  reviewedManufacturerLabel?: InputMaybe<Scalars['String']['input']>;
  /** An existing vendor record named as the manufacturer. */
  reviewedManufacturerVendorId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the royalty amount prices one each or a stated pack. */
  royaltyBasis: SupplierPriceQuoteBasis;
  /** How many of the material's units the royalty amount covers: one for a direct per-each quote, otherwise a pack size (a decimal, greater than zero, at most 4 decimal places). Set on its own rather than copied from the base. */
  royaltyDenominator: Scalars['Decimal']['input'];
  /** The new-material draft a created row belongs to. Repeated rows may share one. */
  sharedDraftId?: InputMaybe<Scalars['String']['input']>;
  /** The extracted row being decided. */
  sourceRowId: Scalars['String']['input'];
  /** The existing material a matched row points at. */
  targetMaterialItemId?: InputMaybe<Scalars['String']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DecommissionDeviceInput = {
  deviceId: Scalars['String']['input'];
};

export type DefaultIncomeAccount = {
  __typename?: 'DefaultIncomeAccount';
  accountImportId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  accountRemoteId: Scalars['String']['output'];
};

export type DefineHolidayInput = {
  date: Scalars['LocalDate']['input'];
  holidayName: Scalars['String']['input'];
  isoWeek: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

/**
 * Result of deleteAllStagedEntityDocuments: the per-entity
 * DeleteStagedEntityResultData for every GrowPointStagedEntity the
 * bulk purge cleared (one Results entry per member), plus TotalDeleted — the grand
 * total of staged documents removed across every entity and its backing collections — so the PWA
 * can show per-entity and overall counts. Errors is non-null only when the whole purge was
 * rejected up front (any of the caller tenant's import workers is running); in that case nothing
 * was deleted and Results is empty.
 */
export type DeleteAllStagedEntitiesResultData = {
  __typename?: 'DeleteAllStagedEntitiesResultData';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<DeleteStagedEntityResultData>;
  totalDeleted: Scalars['Long']['output'];
};

export type DeleteAllocationTemplateInput = {
  id: Scalars['String']['input'];
};

export type DeleteBlockingRuleInput = {
  blockingRuleId: Scalars['String']['input'];
};

export type DeleteCarrierInput = {
  carrierId: Scalars['String']['input'];
};

export type DeleteCustomerGroupInput = {
  id: Scalars['String']['input'];
};

export type DeleteCustomerInput = {
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DeleteCustomerTypeInput = {
  id: Scalars['String']['input'];
};

export type DeleteDeliveryScheduleInput = {
  id: Scalars['String']['input'];
};

export type DeleteDockInput = {
  dockId: Scalars['String']['input'];
};

export type DeleteDriverInput = {
  driverId: Scalars['String']['input'];
};

export type DeleteErpLoadListSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type DeleteErpLoadListUserInput = {
  erpLoadListUserId: Scalars['String']['input'];
};

export type DeleteFavoritesListInput = {
  favoritesListId: Scalars['String']['input'];
};

/** Names exactly one published file for removal. */
export type DeleteFirmwareFileInput = {
  deviceModel: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  firmwareName: Scalars['String']['input'];
  sha: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/**
 * Outcome of a delete. Deleted is false both when the file was genuinely not there to remove
 * AND when the request was refused before storage was ever asked — deleting not enabled while firmware
 * is served from the releases index, a bad address
 * (FirmwareAddressRefusedError) or an unconfigured storage account
 * (FirmwareStorageNotConfiguredError). Errors is populated for those refusal
 * cases and left null for a genuinely absent file, so an operator deleting something with no undo can
 * tell "refused" apart from "already gone".
 */
export type DeleteFirmwareFilePayload = {
  __typename?: 'DeleteFirmwareFilePayload';
  deleted: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ValidationError>>;
};

export type DeleteForecastInput = {
  forecastId: Scalars['String']['input'];
};

/**
 * Result of deleteGrowPointIterations: the number of GrowPoint iteration/error documents
 * removed from the Synchronization Iterations collection for the caller's tenant.
 */
export type DeleteGrowPointIterationsResultData = {
  __typename?: 'DeleteGrowPointIterationsResultData';
  deletedCount: Scalars['Long']['output'];
};

export type DeleteHolidayInput = {
  holidayId: Scalars['String']['input'];
};

export type DeleteItemCharacteristicInput = {
  itemCharacteristicId: Scalars['String']['input'];
};

export type DeleteItemCharacteristicValueInput = {
  itemCharacteristicId: Scalars['String']['input'];
  valueId: Scalars['String']['input'];
};

export type DeleteItemInput = {
  itemId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DeleteKitInput = {
  kitId: Scalars['String']['input'];
};

export type DeleteLoadInput = {
  loadId: Scalars['String']['input'];
};

export type DeleteLoadLineInput = {
  loadLineId: Scalars['String']['input'];
};

export type DeleteLogisticsRouteInput = {
  routeId: Scalars['String']['input'];
};

export type DeleteMasterOrderInput = {
  masterOrderId: Scalars['String']['input'];
};

export type DeleteMaterialItemInput = {
  materialItemId: Scalars['String']['input'];
};

export type DeleteOrderInput = {
  orderId: Scalars['String']['input'];
};

export type DeleteOrderKindInput = {
  orderKindId: Scalars['String']['input'];
};

export type DeleteParentCompanyInput = {
  parentCompanyId: Scalars['String']['input'];
};

export type DeletePaymentProcessorInput = {
  id: Scalars['String']['input'];
};

export type DeletePriceGroupInput = {
  id: Scalars['String']['input'];
};

export type DeletePriceLevelInput = {
  priceGroupId: Scalars['String']['input'];
  priceLevelId: Scalars['String']['input'];
};

export type DeletePriceLevelsInput = {
  priceGroupId: Scalars['String']['input'];
  priceLevelIds: Array<Scalars['String']['input']>;
};

export type DeleteProductionCatalogInput = {
  productionCatalogId: Scalars['String']['input'];
};

export type DeleteProductionCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
};

export type DeleteProductionItemInput = {
  productionItemId: Scalars['String']['input'];
};

export type DeleteProductionLotInput = {
  productionLotId: Scalars['String']['input'];
};

export type DeleteProductionMaterialEventInput = {
  productionMaterialEventId: Scalars['String']['input'];
};

export type DeleteProductionPlanInput = {
  productionPlanId: Scalars['String']['input'];
};

export type DeleteProductionRecipeInput = {
  productionRecipeId: Scalars['String']['input'];
};

export type DeleteProductionSpaceCategoryInput = {
  productionSpaceCategoryId: Scalars['String']['input'];
};

export type DeleteProductionSpaceEventInput = {
  productionSpaceEventId: Scalars['String']['input'];
};

export type DeleteProductionSpaceTypeInput = {
  productionSpaceTypeId: Scalars['String']['input'];
};

export type DeleteProductionTaskEventInput = {
  productionTaskEventId: Scalars['String']['input'];
};

export type DeleteProductionTriggerInput = {
  productionTriggerId: Scalars['String']['input'];
};

export type DeletePromotionRuleInput = {
  promotionRuleId: Scalars['String']['input'];
};

/** Runs to delete. Retained runs among them are refused, not deleted. */
export type DeleteQaTestRunsInput = {
  /** Run ids to delete; at most 5000, blank ids refused. */
  ids: Array<Scalars['String']['input']>;
};

export type DeleteReportExecutionInput = {
  executionId: Scalars['String']['input'];
};

export type DeleteReportFolderInput = {
  folderId: Scalars['String']['input'];
};

export type DeleteReportInput = {
  reportId: Scalars['String']['input'];
};

export type DeleteReportScheduleInput = {
  scheduleId: Scalars['String']['input'];
};

export type DeleteReportTemplateInput = {
  templateId: Scalars['String']['input'];
};

export type DeleteReserveRuleInput = {
  reserveRuleId: Scalars['String']['input'];
};

export type DeleteRestockSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type DeleteSftpTenantConfigInput = {
  configId: Scalars['String']['input'];
};

export type DeleteSiteLocationInput = {
  siteLocationId: Scalars['String']['input'];
};

export type DeleteSiteMapInput = {
  siteMapId: Scalars['String']['input'];
};

/**
 * Result of deleteStagedEntityDocuments: the GrowPointStagedEntity that was
 * cleared, the total number of staged documents removed across all of its backing collections, and
 * the per-collection breakdown so the caller can confirm every backing collection was touched.
 * Errors is non-null only when the purge was rejected (e.g. the staged collections are
 * locked while the tenant's import worker is running) — nothing was deleted.
 */
export type DeleteStagedEntityResultData = {
  __typename?: 'DeleteStagedEntityResultData';
  collections: Array<StagedCollectionDeletionData>;
  entity: GrowPointStagedEntity;
  errors?: Maybe<Array<ValidationError>>;
  totalDeleted: Scalars['Long']['output'];
};

export type DeleteTagColorInput = {
  tagColorId: Scalars['String']['input'];
};

export type DeleteTaskEventTypeInput = {
  taskEventTypeId: Scalars['String']['input'];
};

export type DeleteTenantIntegrationInput = {
  integrationId: Scalars['String']['input'];
};

/** Delete input data */
export type DeleteTimeEntryInput = {
  clickUpTaskId: Scalars['String']['input'];
  entryDate: Scalars['DateTime']['input'];
};

/** Delete operation result */
export type DeleteTimeEntryPayload = {
  __typename?: 'DeleteTimeEntryPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteUserInput = {
  userId: Scalars['String']['input'];
};

export type DeleteUserInviteInput = {
  inviteId: Scalars['String']['input'];
};

export type DeleteVehicleInput = {
  vehicleId: Scalars['String']['input'];
};

export type DeleteVehicleTypeInput = {
  vehicleTypeId: Scalars['String']['input'];
};

export type DeleteVendorInput = {
  id: Scalars['String']['input'];
};

export type DeleteWorkerConfigInput = {
  configName: Scalars['String']['input'];
};

export type DeleteWsapiImportInput = {
  wsapiImportId: Scalars['String']['input'];
};

export type DeletedStreamDocument = {
  __typename?: 'DeletedStreamDocument';
  deletedAt: Scalars['DateTime']['output'];
  streamName: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type DeletedStreamDocumentFilterInput = {
  and?: InputMaybe<Array<DeletedStreamDocumentFilterInput>>;
  deletedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DeletedStreamDocumentFilterInput>>;
  streamName?: InputMaybe<StringOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type DeletedStreamDocumentSortInput = {
  deletedAt?: InputMaybe<SortEnumType>;
  streamName?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type DeletedStreamTransactionDocument = {
  __typename?: 'DeletedStreamTransactionDocument';
  checkpointPosition?: Maybe<Scalars['Long']['output']>;
  ended?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  started: Scalars['DateTime']['output'];
  streamPrefix: Scalars['String']['output'];
  streamsDeleted: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type DeletedStreamTransactionDocumentFilterInput = {
  and?: InputMaybe<Array<DeletedStreamTransactionDocumentFilterInput>>;
  checkpointPosition?: InputMaybe<LongOperationFilterInput>;
  ended?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeletedStreamTransactionDocumentFilterInput>>;
  started?: InputMaybe<DateTimeOperationFilterInput>;
  streamPrefix?: InputMaybe<StringOperationFilterInput>;
  streamsDeleted?: InputMaybe<IntOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type DeletedStreamTransactionDocumentSortInput = {
  checkpointPosition?: InputMaybe<SortEnumType>;
  ended?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  started?: InputMaybe<SortEnumType>;
  streamPrefix?: InputMaybe<SortEnumType>;
  streamsDeleted?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeletedStreamTransactionsConnection = {
  __typename?: 'DeletedStreamTransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeletedStreamTransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeletedStreamTransactionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeletedStreamTransactionsEdge = {
  __typename?: 'DeletedStreamTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeletedStreamTransactionDocument;
};

/** A connection to a list of items. */
export type DeletedStreamsConnection = {
  __typename?: 'DeletedStreamsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeletedStreamsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeletedStreamDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeletedStreamsEdge = {
  __typename?: 'DeletedStreamsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeletedStreamDocument;
};

export enum DeliveryDateIneligibleReason {
  BeyondMaxDaysOut = 'BEYOND_MAX_DAYS_OUT',
  Closed = 'CLOSED',
  NotADeliveryDay = 'NOT_A_DELIVERY_DAY',
  PastCutoff = 'PAST_CUTOFF'
}

/**
 * One load line's delivery portion — one row per load line, keyed {tenantId}-{loadLineId}.
 * Drives the order editor's Routing tab ("Delivery 1 of 2 · Load 9") and the Deliveries grid rows.
 * Pre-seeded as Pending when the load is dispatched; a split order's portion completes independently
 * the moment its own stop's outcome is recorded, so two portions of the same order on different
 * loads can show different outcomes at the same time.
 */
export type DeliveryOrderPortionDocument = {
  __typename?: 'DeliveryOrderPortionDocument';
  deliveredQuantity: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  loadId: Scalars['String']['output'];
  loadLineId: Scalars['String']['output'];
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  outcome: DeliveryOutcome;
  plannedContainerCount?: Maybe<Scalars['Int']['output']>;
  refusedQuantity: Scalars['Int']['output'];
  routeStopId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

/**
 * One load line's delivery portion — one row per load line, keyed {tenantId}-{loadLineId}.
 * Drives the order editor's Routing tab ("Delivery 1 of 2 · Load 9") and the Deliveries grid rows.
 * Pre-seeded as Pending when the load is dispatched; a split order's portion completes independently
 * the moment its own stop's outcome is recorded, so two portions of the same order on different
 * loads can show different outcomes at the same time.
 */
export type DeliveryOrderPortionDocumentFilterInput = {
  and?: InputMaybe<Array<DeliveryOrderPortionDocumentFilterInput>>;
  deliveredQuantity?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  loadId?: InputMaybe<StringOperationFilterInput>;
  loadLineId?: InputMaybe<StringOperationFilterInput>;
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DeliveryOrderPortionDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  outcome?: InputMaybe<DeliveryOutcomeOperationFilterInput>;
  plannedContainerCount?: InputMaybe<IntOperationFilterInput>;
  refusedQuantity?: InputMaybe<IntOperationFilterInput>;
  routeStopId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One load line's delivery portion — one row per load line, keyed {tenantId}-{loadLineId}.
 * Drives the order editor's Routing tab ("Delivery 1 of 2 · Load 9") and the Deliveries grid rows.
 * Pre-seeded as Pending when the load is dispatched; a split order's portion completes independently
 * the moment its own stop's outcome is recorded, so two portions of the same order on different
 * loads can show different outcomes at the same time.
 */
export type DeliveryOrderPortionDocumentSortInput = {
  deliveredQuantity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  loadId?: InputMaybe<SortEnumType>;
  loadLineId?: InputMaybe<SortEnumType>;
  occurredAt?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  orderNumber?: InputMaybe<SortEnumType>;
  outcome?: InputMaybe<SortEnumType>;
  plannedContainerCount?: InputMaybe<SortEnumType>;
  refusedQuantity?: InputMaybe<SortEnumType>;
  routeStopId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/**
 * The recorded outcome at a delivery stop, or of an order's portion of one. An unset value
 *             is Unknown; a real row always carries at least Pending.
 */
export enum DeliveryOutcome {
  Delivered = 'DELIVERED',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Refused = 'REFUSED',
  Unknown = 'UNKNOWN'
}

export type DeliveryOutcomeOperationFilterInput = {
  eq?: InputMaybe<DeliveryOutcome>;
  in?: InputMaybe<Array<DeliveryOutcome>>;
  neq?: InputMaybe<DeliveryOutcome>;
  nin?: InputMaybe<Array<DeliveryOutcome>>;
};

export type DeliveryPayload = {
  __typename?: 'DeliveryPayload';
  delivery?: Maybe<DeliveryStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type DeliveryScheduleDocument = {
  __typename?: 'DeliveryScheduleDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deliveryScheduleId: Scalars['String']['output'];
  friday: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  locationIds: Array<Scalars['String']['output']>;
  monday: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  saturday: Scalars['Boolean']['output'];
  status: DeliveryScheduleStatus;
  sunday: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  thursday: Scalars['Boolean']['output'];
  tuesday: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  wednesday: Scalars['Boolean']['output'];
};

export type DeliveryScheduleDocumentFilterInput = {
  and?: InputMaybe<Array<DeliveryScheduleDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  deliveryScheduleId?: InputMaybe<StringOperationFilterInput>;
  friday?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationIds?: InputMaybe<ListStringOperationFilterInput>;
  monday?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeliveryScheduleDocumentFilterInput>>;
  saturday?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<DeliveryScheduleStatusOperationFilterInput>;
  sunday?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  thursday?: InputMaybe<BooleanOperationFilterInput>;
  tuesday?: InputMaybe<BooleanOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  wednesday?: InputMaybe<BooleanOperationFilterInput>;
};

export type DeliveryScheduleDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  deliveryScheduleId?: InputMaybe<SortEnumType>;
  friday?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  monday?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  saturday?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  sunday?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  thursday?: InputMaybe<SortEnumType>;
  tuesday?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  wednesday?: InputMaybe<SortEnumType>;
};

export type DeliverySchedulePayload = {
  __typename?: 'DeliverySchedulePayload';
  deliverySchedule?: Maybe<DeliveryScheduleStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type DeliveryScheduleStateData = {
  __typename?: 'DeliveryScheduleStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deliveryScheduleId: Scalars['String']['output'];
  friday: Scalars['Boolean']['output'];
  locationIds: Array<Scalars['String']['output']>;
  monday: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  saturday: Scalars['Boolean']['output'];
  status: DeliveryScheduleStatus;
  sunday: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  thursday: Scalars['Boolean']['output'];
  tuesday: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  wednesday: Scalars['Boolean']['output'];
};

export enum DeliveryScheduleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type DeliveryScheduleStatusOperationFilterInput = {
  eq?: InputMaybe<DeliveryScheduleStatus>;
  in?: InputMaybe<Array<DeliveryScheduleStatus>>;
  neq?: InputMaybe<DeliveryScheduleStatus>;
  nin?: InputMaybe<Array<DeliveryScheduleStatus>>;
};

/**
 * A delivery schedule's name, weekday flags, and lifecycle status, resolved at query time rather
 * than stored on the referencing document — so a rename, day-toggle, or status change needs no
 * projection replay. A narrow projection of the delivery-schedule read model, not the document
 * itself: a referencing entry has no business exposing its location ids or audit stamps.
 */
export type DeliveryScheduleSummaryData = {
  __typename?: 'DeliveryScheduleSummaryData';
  /** True when the schedule delivers on Friday. */
  friday: Scalars['Boolean']['output'];
  /** True when the schedule delivers on Monday. */
  monday: Scalars['Boolean']['output'];
  /** The schedule's current display name. */
  name: Scalars['String']['output'];
  /** True when the schedule delivers on Saturday. */
  saturday: Scalars['Boolean']['output'];
  /**
   * The schedule's current lifecycle status. Enforcement honors an ACTIVE schedule only, so an
   * INACTIVE schedule still resolves here rather than being filtered out, letting a caller flag
   * the mapping as unenforced.
   */
  status: DeliveryScheduleStatus;
  /** True when the schedule delivers on Sunday. */
  sunday: Scalars['Boolean']['output'];
  /** True when the schedule delivers on Thursday. */
  thursday: Scalars['Boolean']['output'];
  /** True when the schedule delivers on Tuesday. */
  tuesday: Scalars['Boolean']['output'];
  /** True when the schedule delivers on Wednesday. */
  wednesday: Scalars['Boolean']['output'];
};

/** Which setting produced this answer: the location's own schedule, its route's schedule, or nothing. */
export enum DeliveryScheduleTier {
  /** The location's own delivery schedule won. */
  LocationOverride = 'LOCATION_OVERRIDE',
  /** The effective route's mapped schedule won. */
  RouteMapped = 'ROUTE_MAPPED',
  /** No tier was configured; every day is offered. */
  Unrestricted = 'UNRESTRICTED'
}

/**
 * The dispatch and delivery lifecycle of one load, plus the current outcome recorded at
 *             each of its route stops.
 */
export type DeliveryStateData = {
  __typename?: 'DeliveryStateData';
  isCompleted: Scalars['Boolean']['output'];
  isDispatched: Scalars['Boolean']['output'];
  loadId: Scalars['String']['output'];
  stopOutcomes: Array<StopOutcomeStateData>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * One route stop on one load's delivery — one row per (load, route stop), keyed
 * {tenantId}-{loadId}-{routeStopId}. Drives the load view's drop cards and map popup, and the
 * Deliveries Map. Pre-seeded as Pending when the load is dispatched, so every planned stop renders
 * even before an outcome is recorded; clearing a recorded outcome resets the row back to Pending
 * rather than removing it.
 */
export type DeliveryStopDocument = {
  __typename?: 'DeliveryStopDocument';
  customerLocationId?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  loadId: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  outcome: DeliveryOutcome;
  recordedBy: Scalars['String']['output'];
  routeStopId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * One route stop on one load's delivery — one row per (load, route stop), keyed
 * {tenantId}-{loadId}-{routeStopId}. Drives the load view's drop cards and map popup, and the
 * Deliveries Map. Pre-seeded as Pending when the load is dispatched, so every planned stop renders
 * even before an outcome is recorded; clearing a recorded outcome resets the row back to Pending
 * rather than removing it.
 */
export type DeliveryStopDocumentFilterInput = {
  and?: InputMaybe<Array<DeliveryStopDocumentFilterInput>>;
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  loadId?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DeliveryStopDocumentFilterInput>>;
  outcome?: InputMaybe<DeliveryOutcomeOperationFilterInput>;
  recordedBy?: InputMaybe<StringOperationFilterInput>;
  routeStopId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One route stop on one load's delivery — one row per (load, route stop), keyed
 * {tenantId}-{loadId}-{routeStopId}. Drives the load view's drop cards and map popup, and the
 * Deliveries Map. Pre-seeded as Pending when the load is dispatched, so every planned stop renders
 * even before an outcome is recorded; clearing a recorded outcome resets the row back to Pending
 * rather than removing it.
 */
export type DeliveryStopDocumentSortInput = {
  customerLocationId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  loadId?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  occurredAt?: InputMaybe<SortEnumType>;
  outcome?: InputMaybe<SortEnumType>;
  recordedBy?: InputMaybe<SortEnumType>;
  routeStopId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/**
 * One load's delivery rollup — one row per load, keyed {tenantId}-{loadId}. Drives the
 * planned-load cards and the Deliveries Loads view. Status mirrors the same Loaded/Dispatched/
 * Delivered progression the load itself follows, so dispatchedAt and completedAt are present
 * exactly while the load is currently dispatched or completed and cleared — not deleted history —
 * when a dispatch or completion is undone.
 */
export type DeliverySummaryDocument = {
  __typename?: 'DeliverySummaryDocument';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  dispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  loadId: Scalars['String']['output'];
  status: LoadStatus;
  stopsDelivered: Scalars['Int']['output'];
  stopsPartial: Scalars['Int']['output'];
  stopsPending: Scalars['Int']['output'];
  stopsRefused: Scalars['Int']['output'];
  stopsTotal: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * One load's delivery rollup — one row per load, keyed {tenantId}-{loadId}. Drives the
 * planned-load cards and the Deliveries Loads view. Status mirrors the same Loaded/Dispatched/
 * Delivered progression the load itself follows, so dispatchedAt and completedAt are present
 * exactly while the load is currently dispatched or completed and cleared — not deleted history —
 * when a dispatch or completion is undone.
 */
export type DeliverySummaryDocumentFilterInput = {
  and?: InputMaybe<Array<DeliverySummaryDocumentFilterInput>>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  dispatchedAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  loadId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeliverySummaryDocumentFilterInput>>;
  status?: InputMaybe<LoadStatusOperationFilterInput>;
  stopsDelivered?: InputMaybe<IntOperationFilterInput>;
  stopsPartial?: InputMaybe<IntOperationFilterInput>;
  stopsPending?: InputMaybe<IntOperationFilterInput>;
  stopsRefused?: InputMaybe<IntOperationFilterInput>;
  stopsTotal?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One load's delivery rollup — one row per load, keyed {tenantId}-{loadId}. Drives the
 * planned-load cards and the Deliveries Loads view. Status mirrors the same Loaded/Dispatched/
 * Delivered progression the load itself follows, so dispatchedAt and completedAt are present
 * exactly while the load is currently dispatched or completed and cleared — not deleted history —
 * when a dispatch or completion is undone.
 */
export type DeliverySummaryDocumentSortInput = {
  completedAt?: InputMaybe<SortEnumType>;
  dispatchedAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  loadId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  stopsDelivered?: InputMaybe<SortEnumType>;
  stopsPartial?: InputMaybe<SortEnumType>;
  stopsPending?: InputMaybe<SortEnumType>;
  stopsRefused?: InputMaybe<SortEnumType>;
  stopsTotal?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** One invoice the deposit-overage backfill found: what it bills, what it applied and what moves. */
export type DepositOverageBackfillInvoice = {
  __typename?: 'DepositOverageBackfillInvoice';
  /** The deposit beyond the gross: what moves (or moved) to the customer's credit. */
  amount: Scalars['Decimal']['output'];
  /** What it owed before this run: less than nothing. */
  balanceBefore: Scalars['Decimal']['output'];
  /**
   * The customer whose credit the overage becomes: the customer billed, or the customer a combine has since folded it
   * into.
   */
  customerId: Scalars['String']['output'];
  /** The deposit it applied as issued, before this run. */
  depositApplied: Scalars['Decimal']['output'];
  /** Why the move failed, on a failed row. */
  error?: Maybe<Scalars['String']['output']>;
  /** Everything the invoice charges. */
  grossTotal: Scalars['Decimal']['output'];
  /** The invoice. */
  invoiceId: Scalars['String']['output'];
  /** Its number. */
  invoiceNumber: Scalars['String']['output'];
  /** The order it bills, on which the deposit was taken. */
  orderId: Scalars['String']['output'];
  /** That order's number. */
  orderNumber: Scalars['String']['output'];
  /** What the run found or did. */
  status: DepositOverageBackfillStatus;
  /** The invoice's tenant. */
  tenantId: Scalars['String']['output'];
};

/** What one run of the deposit-overage backfill found and did. */
export type DepositOverageBackfillPayload = {
  __typename?: 'DepositOverageBackfillPayload';
  /** The deposit the ToMove rows (dry run) or the Moved rows (a run that writes) move. */
  amountToMove: Scalars['Decimal']['output'];
  /** Whether the run only reported and wrote nothing. */
  dryRun: Scalars['Boolean']['output'];
  /**
   * Why the run was refused before it read anything (a tenantIds list that names no tenant, or an id that is not a
   * tenant id); null when it ran.
   */
  errors?: Maybe<Array<ValidationError>>;
  /** Invoices whose move failed. */
  failed: Scalars['Int']['output'];
  /** Every invoice found, with its order, customer and the amount. */
  invoices: Array<DepositOverageBackfillInvoice>;
  /** Issued invoices the read model lists as owing less than nothing. */
  invoicesFound: Scalars['Int']['output'];
  /** Invoices this run moved deposit off. Zero on a dry run, and zero on a second run. */
  moved: Scalars['Int']['output'];
  /** Invoices whose own stream holds nothing to move. */
  nothingToMove: Scalars['Int']['output'];
  /** Invoices a dry run would move deposit off. */
  toMove: Scalars['Int']['output'];
};

/** What the deposit-overage backfill found, or did, for one invoice. */
export enum DepositOverageBackfillStatus {
  /** The move failed; error says why, and re-running retries it. */
  Failed = 'FAILED',
  /** This run moved the deposit beyond the invoice's gross to the customer's credit. */
  Moved = 'MOVED',
  /**
   * The invoice, read from its own stream, has nothing to move — already moved, voided, or owing something — so
   * nothing was written for it.
   */
  NothingToMove = 'NOTHING_TO_MOVE',
  /** A dry run found deposit beyond the invoice's gross; a run that writes moves it. */
  ToMove = 'TO_MOVE'
}

export enum DepositRequirementType {
  FlatAmount = 'FLAT_AMOUNT',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

/**
 * Whether a deposit recorded for the caller's tenant is written back to its connected accounting
 * platform, and the reason when it is not.
 */
export type DepositWriteBackCapabilityPayload = {
  __typename?: 'DepositWriteBackCapabilityPayload';
  /** Whether a recorded deposit is written back to the connected accounting platform. */
  supported: Scalars['Boolean']['output'];
  /**
   * Why it is not: NO_ACCOUNTING_INTEGRATION when the tenant has no accounting link, or
   * PLATFORM_INBOUND_ONLY when the connected platform cannot take a journal entry through Merge.
   * Null when supported.
   */
  unsupportedReason?: Maybe<Scalars['String']['output']>;
};

/**
 * Why a price is what it is when it came from a WHOLE-GROUP derivation: "derived from
 * ReferencePriceGroupName at −PercentOff%".
 * DerivedPrice always equals the explanation's finalPrice (and therefore
 * itemPrice) — it is the number the engine charges, produced by the same resolution, not a
 * re-computation.
 */
export type DerivedPriceExplanation = {
  __typename?: 'DerivedPriceExplanation';
  /** The resulting charge price: ReferencePrice minus PercentOff percent. */
  derivedPrice: Scalars['Decimal']['output'];
  /** The percentage taken off the reference price, in percent-value form (4 = 4%). */
  percentOff: Scalars['Decimal']['output'];
  /** What the reference group itself resolved to for this item, before the percentage. */
  referencePrice: Scalars['Decimal']['output'];
  /** The price group this group derives from. */
  referencePriceGroupId: Scalars['String']['output'];
  /** Display name of the reference price group; empty when it could not be resolved. */
  referencePriceGroupName: Scalars['String']['output'];
  /**
   * Which level in the reference group produced ReferencePrice, or None when the
   * reference group itself priced through ITS own derivation (a chained derivation).
   */
  referenceWinningLevelId?: Maybe<Scalars['String']['output']>;
};

export type DestinationConfigData = {
  __typename?: 'DestinationConfigData';
  connectionString: Scalars['String']['output'];
  destinationId: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  schemaName: Scalars['String']['output'];
  scriptTimeout: Scalars['String']['output'];
  sqlAfterScript?: Maybe<Scalars['String']['output']>;
  sqlBeforeScript?: Maybe<Scalars['String']['output']>;
  sqlColumns: Array<SqlColumnMapData>;
  tableName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DestinationConfigDataFilterInput = {
  and?: InputMaybe<Array<DestinationConfigDataFilterInput>>;
  destinationId?: InputMaybe<StringOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DestinationConfigDataFilterInput>>;
  schemaName?: InputMaybe<StringOperationFilterInput>;
  scriptTimeout?: InputMaybe<StringOperationFilterInput>;
  sqlAfterScript?: InputMaybe<StringOperationFilterInput>;
  sqlBeforeScript?: InputMaybe<StringOperationFilterInput>;
  sqlColumns?: InputMaybe<ListFilterInputTypeOfSqlColumnMapDataFilterInput>;
  tableName?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type DestinationConfigDataInput = {
  connectionString: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  schemaName: Scalars['String']['input'];
  scriptTimeout: Scalars['String']['input'];
  sqlAfterScript?: InputMaybe<Scalars['String']['input']>;
  sqlBeforeScript?: InputMaybe<Scalars['String']['input']>;
  sqlColumns: Array<SqlColumnMapDataInput>;
  tableName: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum DeviceCommandName {
  AdjustCount = 'ADJUST_COUNT',
  CheckForUpdate = 'CHECK_FOR_UPDATE',
  ForgetWifi = 'FORGET_WIFI',
  Reboot = 'REBOOT',
  RequestSettingsReport = 'REQUEST_SETTINGS_REPORT',
  ResetCount = 'RESET_COUNT',
  SetCount = 'SET_COUNT',
  SetWifi = 'SET_WIFI'
}

/**
 * The GraphQL-facing projection of DeviceConfigDriftEntry — one config key whose desired
 * and reported values disagree. Either side's value is null when the key is missing from that side.
 */
export type DeviceConfigDriftEntryData = {
  __typename?: 'DeviceConfigDriftEntryData';
  desiredValue?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  reportedValue?: Maybe<Scalars['String']['output']>;
};

export type DeviceConfigKeyEntryDataInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum DeviceConnectivity {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

/**
 * The connection credential for a newly registered device — the hub host it connects to, the device id
 * it authenticates as (always the device's serial), and its shared access key.
 *
 * KEY MATERIAL, returned exactly once by registerDevice and by nothing else. It is never stored
 * by WorkSuite: not on the aggregate, not in an event, not in the read model. Factory tooling must
 * capture it here and flash it onto the physical device — a lost key cannot be recovered, only the
 * device re-registered.
 */
export type DeviceCredentialData = {
  __typename?: 'DeviceCredentialData';
  connectionString: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  hostName: Scalars['String']['output'];
  sharedAccessKey: Scalars['String']['output'];
};

export enum DeviceCredentialStatus {
  Active = 'ACTIVE',
  None = 'NONE',
  Revoked = 'REVOKED'
}

export type DeviceCredentialStatusOperationFilterInput = {
  eq?: InputMaybe<DeviceCredentialStatus>;
  in?: InputMaybe<Array<DeviceCredentialStatus>>;
  neq?: InputMaybe<DeviceCredentialStatus>;
  nin?: InputMaybe<Array<DeviceCredentialStatus>>;
};

/**
 * MongoDB read-model document for a device, projected from the Device event stream into the
 * Devices collection.
 *
 * Unlike most tenant-scoped documents in this codebase, the document id is the BARE
 * DeviceId — never composited with a tenant id. A device is registered before it belongs to
 * any tenant, and the registry is deliberately built so a future release could re-tenant one (see
 * DeviceRegistryIdentity — no command does so in this task), so the document's identity has to
 * stay stable across a change of ownerTenantId; compositing on the CURRENT owner would force a
 * delete+recreate the moment that becomes possible.
 */
export type DeviceDocument = {
  __typename?: 'DeviceDocument';
  /**
   * The tenant this physical unit is destined for — an ACL scoping deviceLobby visibility,
   * not ownership itself (that is ownerTenantId, stamped only once claimed).
   */
  assignedTenantId: Scalars['String']['output'];
  /**
   * The wire behaviours this device's firmware reports it honours, as tokens — correlatedReset
   * today. Empty for a device that has never reported, and for firmware that predates the capability
   * list: treat an absent token as "does not honour it", never as "unknown". The vocabulary is open,
   * so a token this server does not recognize is still returned verbatim rather than dropped.
   */
  capabilities: Array<Scalars['String']['output']>;
  /**
   * When this device's claim code lapses. Published (the code itself never is) because
   * deviceLobby keeps listing a device after its code expires — nothing moves it out of
   * Lobby and there is no reissue command yet — so without this field a client could not tell
   * a claimable device from one whose code claimDevice will always reject. Compare it against
   * now with Device.IsClaimable's rule; a value in the past means "expired — reissue
   * required", not "claimable".
   */
  claimCodeExpiresAt: Scalars['DateTime']['output'];
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  connectivity?: Maybe<DeviceConnectivity>;
  created: Scalars['DateTime']['output'];
  credentialStatus: DeviceCredentialStatus;
  decommissionedAt?: Maybe<Scalars['DateTime']['output']>;
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The outcome of the most recently dispatched SET_WIFI change that has actually
   *             RESOLVED — null when none has. A change that is still PENDING, or that TIMED_OUT with no result,
   *             does not hide the last known outcome: this walks back to the newest dispatch that has one. Compare
   *             its changeId against the one sendDeviceCommand returned, or poll
   *             wifiChangeStatus(changeId:) instead, to tell whether THIS specific request resolved yet —
   *             that field is the authoritative per-request answer.
   */
  lastWifiChange?: Maybe<DeviceWifiChangeData>;
  /**
   * Optional "physically located at" assignment — see DeviceState.LocationId for the full
   * design rationale (one field for both line-attached and standalone-sensor usage, no
   * schema-level granularity constraint, survives decommission). Projected here — not
   * payload-only — so it is queryable, filterable, and sortable via the fleet queries'
   * [UseFiltering]/[UseSorting] surfaces, unlike the read-model gap tracked by Atlas
   * 7e027a4968f54aa990d6ad2a8f62f995 (credentialIssuedAt/credentialRevokedAt exist
   * only on DeviceStateData).
   */
  locationId?: Maybe<Scalars['String']['output']>;
  /**
   * The hardware model from the most recent boot that reported one (e.g. EdgeBox-ESP-100). Null until
   * the device reports one.
   */
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Empty while status is Lobby (no owner yet). */
  ownerTenantId: Scalars['String']['output'];
  profile: DeviceProfile;
  registeredAt: Scalars['DateTime']['output'];
  /** When a SuperAdmin removed the device; null while it is still listed. */
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The functional role this device's profile plays — counter (at most one allowed per
   *             production line) or sensor (unlimited). Lets a client enforce the at-most-one-counter guard by
   *             reading this field instead of matching the profile enum directly.
   */
  role: DeviceRole;
  serial: Scalars['String']['output'];
  /**
   * The device's shadow — its desired/reported config pair and their versions — or null for
   *             a device whose desired config has never been set and that has never reported.
   */
  shadow?: Maybe<DeviceShadowDocument>;
  status: DeviceStatus;
  updated: Scalars['DateTime']['output'];
  /**
   * The derived state of one SET_WIFI request — PENDING, APPLIED, ROLLED_BACK or
   *             TIMED_OUT — keyed by the changeId sendDeviceCommand returned. Poll this instead of
   *             lastWifiChange while waiting on a specific request: it never confuses an older change's
   *             outcome for this one's, and it reports TIMED_OUT on its own once the device has had long enough to
   *             answer, so the caller never has to poll forever. Null only for a changeId wsapi has no
   *             record of dispatching to this device.
   */
  wifiChangeStatus?: Maybe<DeviceWifiChangeStatusData>;
};


/**
 * MongoDB read-model document for a device, projected from the Device event stream into the
 * Devices collection.
 *
 * Unlike most tenant-scoped documents in this codebase, the document id is the BARE
 * DeviceId — never composited with a tenant id. A device is registered before it belongs to
 * any tenant, and the registry is deliberately built so a future release could re-tenant one (see
 * DeviceRegistryIdentity — no command does so in this task), so the document's identity has to
 * stay stable across a change of ownerTenantId; compositing on the CURRENT owner would force a
 * delete+recreate the moment that becomes possible.
 */
export type DeviceDocumentWifiChangeStatusArgs = {
  changeId: Scalars['String']['input'];
};

/**
 * MongoDB read-model document for a device, projected from the Device event stream into the
 * Devices collection.
 *
 * Unlike most tenant-scoped documents in this codebase, the document id is the BARE
 * DeviceId — never composited with a tenant id. A device is registered before it belongs to
 * any tenant, and the registry is deliberately built so a future release could re-tenant one (see
 * DeviceRegistryIdentity — no command does so in this task), so the document's identity has to
 * stay stable across a change of ownerTenantId; compositing on the CURRENT owner would force a
 * delete+recreate the moment that becomes possible.
 */
export type DeviceDocumentFilterInput = {
  and?: InputMaybe<Array<DeviceDocumentFilterInput>>;
  /**
   * The tenant this physical unit is destined for — an ACL scoping deviceLobby visibility,
   * not ownership itself (that is ownerTenantId, stamped only once claimed).
   */
  assignedTenantId?: InputMaybe<StringOperationFilterInput>;
  /**
   * When this device's claim code lapses. Published (the code itself never is) because
   * deviceLobby keeps listing a device after its code expires — nothing moves it out of
   * Lobby and there is no reissue command yet — so without this field a client could not tell
   * a claimable device from one whose code claimDevice will always reject. Compare it against
   * now with Device.IsClaimable's rule; a value in the past means "expired — reissue
   * required", not "claimable".
   */
  claimCodeExpiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  claimedAt?: InputMaybe<DateTimeOperationFilterInput>;
  connectivity?: InputMaybe<NullableOfDeviceConnectivityOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  credentialStatus?: InputMaybe<DeviceCredentialStatusOperationFilterInput>;
  decommissionedAt?: InputMaybe<DateTimeOperationFilterInput>;
  firmwareVersion?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastSeenAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Optional "physically located at" assignment — see DeviceState.LocationId for the full
   * design rationale (one field for both line-attached and standalone-sensor usage, no
   * schema-level granularity constraint, survives decommission). Projected here — not
   * payload-only — so it is queryable, filterable, and sortable via the fleet queries'
   * [UseFiltering]/[UseSorting] surfaces, unlike the read-model gap tracked by Atlas
   * 7e027a4968f54aa990d6ad2a8f62f995 (credentialIssuedAt/credentialRevokedAt exist
   * only on DeviceStateData).
   */
  locationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The hardware model from the most recent boot that reported one (e.g. EdgeBox-ESP-100). Null until
   * the device reports one.
   */
  model?: InputMaybe<OptionOfStringFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceDocumentFilterInput>>;
  /** Empty while status is Lobby (no owner yet). */
  ownerTenantId?: InputMaybe<StringOperationFilterInput>;
  profile?: InputMaybe<DeviceProfileOperationFilterInput>;
  registeredAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When a SuperAdmin removed the device; null while it is still listed. */
  removedAt?: InputMaybe<DateTimeOperationFilterInput>;
  serial?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<DeviceStatusOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for a device, projected from the Device event stream into the
 * Devices collection.
 *
 * Unlike most tenant-scoped documents in this codebase, the document id is the BARE
 * DeviceId — never composited with a tenant id. A device is registered before it belongs to
 * any tenant, and the registry is deliberately built so a future release could re-tenant one (see
 * DeviceRegistryIdentity — no command does so in this task), so the document's identity has to
 * stay stable across a change of ownerTenantId; compositing on the CURRENT owner would force a
 * delete+recreate the moment that becomes possible.
 */
export type DeviceDocumentSortInput = {
  /**
   * The tenant this physical unit is destined for — an ACL scoping deviceLobby visibility,
   * not ownership itself (that is ownerTenantId, stamped only once claimed).
   */
  assignedTenantId?: InputMaybe<SortEnumType>;
  /**
   * When this device's claim code lapses. Published (the code itself never is) because
   * deviceLobby keeps listing a device after its code expires — nothing moves it out of
   * Lobby and there is no reissue command yet — so without this field a client could not tell
   * a claimable device from one whose code claimDevice will always reject. Compare it against
   * now with Device.IsClaimable's rule; a value in the past means "expired — reissue
   * required", not "claimable".
   */
  claimCodeExpiresAt?: InputMaybe<SortEnumType>;
  claimedAt?: InputMaybe<SortEnumType>;
  connectivity?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  credentialStatus?: InputMaybe<SortEnumType>;
  decommissionedAt?: InputMaybe<SortEnumType>;
  firmwareVersion?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastSeenAt?: InputMaybe<SortEnumType>;
  /**
   * Optional "physically located at" assignment — see DeviceState.LocationId for the full
   * design rationale (one field for both line-attached and standalone-sensor usage, no
   * schema-level granularity constraint, survives decommission). Projected here — not
   * payload-only — so it is queryable, filterable, and sortable via the fleet queries'
   * [UseFiltering]/[UseSorting] surfaces, unlike the read-model gap tracked by Atlas
   * 7e027a4968f54aa990d6ad2a8f62f995 (credentialIssuedAt/credentialRevokedAt exist
   * only on DeviceStateData).
   */
  locationId?: InputMaybe<SortEnumType>;
  /**
   * The hardware model from the most recent boot that reported one (e.g. EdgeBox-ESP-100). Null until
   * the device reports one.
   */
  model?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /** Empty while status is Lobby (no owner yet). */
  ownerTenantId?: InputMaybe<SortEnumType>;
  profile?: InputMaybe<SortEnumType>;
  registeredAt?: InputMaybe<SortEnumType>;
  /** When a SuperAdmin removed the device; null while it is still listed. */
  removedAt?: InputMaybe<SortEnumType>;
  serial?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceLobbyConnection = {
  __typename?: 'DeviceLobbyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceLobbyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceLobbyEdge = {
  __typename?: 'DeviceLobbyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceDocument;
};

/**
 * The network a device reports it is running on: the effective mode, its current IPv4 address, and whether its
 * firmware supports static configuration at all.
 */
export type DeviceNetworkReportData = {
  __typename?: 'DeviceNetworkReportData';
  /** The device's current IPv4 address, or null if it has not reported one. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** The effective mode: dhcp, static, or dhcpFallback after a failed static boot. */
  mode: Scalars['String']['output'];
  /** Whether the device advertises the staticNet capability. */
  supportsStaticNetwork: Scalars['Boolean']['output'];
};

/** The resolution a writer claimed: the token for the device's target, or an empty token for no current offer. */
export type DeviceOtaFenceDocument = {
  __typename?: 'DeviceOtaFenceDocument';
  authorizationSequence: Scalars['Long']['output'];
  imageSha256: Scalars['String']['output'];
  lineVersion: Scalars['Long']['output'];
  offers: Scalars['Boolean']['output'];
  resolvedAt: Scalars['DateTime']['output'];
  ringIndex: Scalars['Int']['output'];
  rolloutId: Scalars['String']['output'];
  sha: Scalars['String']['output'];
  token: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** A write started under a claimed line version and not yet checked against the fence. */
export type DeviceOtaInFlightDocument = {
  __typename?: 'DeviceOtaInFlightDocument';
  lineVersion: Scalars['Long']['output'];
  operationId: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  writerId: Scalars['String']['output'];
};

/** The checkForUpdate sent after a confirmed offer, for the line version it confirmed. */
export type DeviceOtaNudgeDocument = {
  __typename?: 'DeviceOtaNudgeDocument';
  at: Scalars['DateTime']['output'];
  error: Scalars['String']['output'];
  lineVersion: Scalars['Long']['output'];
  status: DeviceOtaNudgeStatus;
};

/** Whether the device hub accepted the checkForUpdate nudge, refused it, or gave no definite answer. */
export enum DeviceOtaNudgeStatus {
  Refused = 'REFUSED',
  Sent = 'SENT',
  Unknown = 'UNKNOWN'
}

/** The authorization a device was last offered: its rollout, ring, sequence and the build it names. */
export type DeviceOtaOfferDocument = {
  __typename?: 'DeviceOtaOfferDocument';
  authorizationSequence: Scalars['Long']['output'];
  imageSha256: Scalars['String']['output'];
  offeredAt: Scalars['DateTime']['output'];
  ringIndex: Scalars['Int']['output'];
  rolloutId: Scalars['String']['output'];
  sha: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** What the device reported about its current offer, and the last result sequence and authorization it took. */
export type DeviceOtaOutcomeDocument = {
  __typename?: 'DeviceOtaOutcomeDocument';
  attempt: Scalars['Int']['output'];
  authorizationSequence: Scalars['Long']['output'];
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  failure: OtaDeviceFailure;
  lastResultSeq: Scalars['Long']['output'];
  state: OtaDeviceOutcomeState;
};

/** The latest firmware report recorded for the device, with the disposition it was given. */
export type DeviceOtaReportSummaryDocument = {
  __typename?: 'DeviceOtaReportSummaryDocument';
  disposition: OtaReportDisposition;
  observedAt: Scalars['DateTime']['output'];
  recordedAt: Scalars['DateTime']['output'];
  seq: Scalars['Long']['output'];
  sha: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/**
 * One device's OTA delivery and outcome. The fence is the newest resolution any writer claimed for the device, keyed by
 * the line version it was resolved from; a write is settled when no writer is still in flight and the confirmed version
 * has reached the fence. The offer and outcome describe the authorization the device was last offered and what it
 * reported about it.
 */
export type DeviceOtaStateDocument = {
  __typename?: 'DeviceOtaStateDocument';
  confirmedLineVersion: Scalars['Long']['output'];
  fence: DeviceOtaFenceDocument;
  id: Scalars['String']['output'];
  inFlight: Array<DeviceOtaInFlightDocument>;
  lastReport?: Maybe<DeviceOtaReportSummaryDocument>;
  lineId: Scalars['String']['output'];
  nudge?: Maybe<DeviceOtaNudgeDocument>;
  offer?: Maybe<DeviceOtaOfferDocument>;
  outcome?: Maybe<DeviceOtaOutcomeDocument>;
  settled: Scalars['Boolean']['output'];
  updated: Scalars['DateTime']['output'];
};

/** The target WorkSuite last wrote and confirmed for a device, which is not a read of the twin itself. */
export type DeviceOtaTargetData = {
  __typename?: 'DeviceOtaTargetData';
  authorizationSequence: Scalars['Long']['output'];
  confirmedLineVersion: Scalars['Long']['output'];
  deviceId: Scalars['String']['output'];
  lineId: Scalars['String']['output'];
  lineVersion: Scalars['Long']['output'];
  rolloutId: Scalars['String']['output'];
  settled: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
};

export type DevicePayload = {
  __typename?: 'DevicePayload';
  device?: Maybe<DeviceStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum DeviceProfile {
  CountBeamBreak = 'COUNT_BEAM_BREAK'
}

export type DeviceProfileOperationFilterInput = {
  eq?: InputMaybe<DeviceProfile>;
  in?: InputMaybe<Array<DeviceProfile>>;
  neq?: InputMaybe<DeviceProfile>;
  nin?: InputMaybe<Array<DeviceProfile>>;
};

/**
 * One metric's value inside an ingest envelope. Carries NO device or tenant identity of its own:
 * both are envelope-level, so a single call can never span two devices.
 */
export type DeviceReadingInput = {
  /**
   * The metric this value belongs to, e.g. temperatureC. Stored as reported and used as the
   * third column of the dedupe key, so two metrics in one envelope legitimately share the
   * envelope's seq while a redelivery of that envelope still converges each metric to one
   * stored reading.
   */
  metric: Scalars['String']['input'];
  /**
   * The value's unit of measure, e.g. C. Optional — an omitted unit is stored as the empty
   * string, matching a reading that never carried one.
   */
  unit?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export enum DeviceRole {
  Counter = 'COUNTER',
  Sensor = 'SENSOR'
}

/**
 * A device's shadow — the Mongo-backed desired/reported pair (the DB-backed variant of AWS/Azure
 * device twins), one document per device.
 */
export type DeviceShadowDocument = {
  __typename?: 'DeviceShadowDocument';
  /**
   * The config the shadow was last told to converge the device to, keyed by the device's
   *             profile. An optional key that was never set reads as the default the device applies when the key
   *             is absent (sensorBreakState: HIGH), so every optional key is always present.
   */
  desired: Array<KeyValuePairOfStringAndString>;
  /**
   * A monotonically increasing per-device sequence number that advances every time the desired
   * config is written — not a count of distinct configure calls. Mirrors AWS/Azure shadow
   * versioning, which likewise advances per shadow write, not per unique change.
   */
  desiredVersion: Scalars['Long']['output'];
  deviceId: Scalars['String']['output'];
  /**
   * Every config key we asked this device for whose reported value disagrees — a key in
   *             agreement is omitted, and a desired key the device has not reported yet shows a null reported
   *             value. Keys the device reports that are not config keys for its profile are device-owned state
   *             and never appear here.
   */
  drift: Array<DeviceConfigDriftEntryData>;
  id: Scalars['String']['output'];
  /** The network the device reports it is running on, or null until it reports a network mode. */
  network?: Maybe<DeviceNetworkReportData>;
  /** The config the device last reported having applied. */
  reported: Array<KeyValuePairOfStringAndString>;
  reportedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A caller-supplied monotonic version — the device's own notion of "which config generation is
   * this."
   */
  reportedVersion: Scalars['Long']['output'];
  updated: Scalars['DateTime']['output'];
};

export type DeviceStateData = {
  __typename?: 'DeviceStateData';
  assignedTenantId: Scalars['String']['output'];
  claimCodeExpiresAt: Scalars['DateTime']['output'];
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  claimedBy: Scalars['String']['output'];
  credentialIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialRevokedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialStatus: DeviceCredentialStatus;
  decommissionedAt?: Maybe<Scalars['DateTime']['output']>;
  decommissionedBy: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerTenantId: Scalars['String']['output'];
  profile: DeviceProfile;
  registeredAt: Scalars['DateTime']['output'];
  registeredBy: Scalars['String']['output'];
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  serial: Scalars['String']['output'];
  status: DeviceStatus;
};

export enum DeviceStatus {
  Claimed = 'CLAIMED',
  Decommissioned = 'DECOMMISSIONED',
  Lobby = 'LOBBY'
}

export type DeviceStatusOperationFilterInput = {
  eq?: InputMaybe<DeviceStatus>;
  in?: InputMaybe<Array<DeviceStatus>>;
  neq?: InputMaybe<DeviceStatus>;
  nin?: InputMaybe<Array<DeviceStatus>>;
};

/**
 * One downsampled bucket of device telemetry history — the average, minimum, maximum, and last raw
 * value, plus how many raw samples were folded in, for the time window starting at
 * bucketStart.
 */
export type DeviceTelemetryBucketData = {
  __typename?: 'DeviceTelemetryBucketData';
  averageValue: Scalars['Float']['output'];
  bucketStart: Scalars['DateTime']['output'];
  lastValue: Scalars['Float']['output'];
  maxValue: Scalars['Float']['output'];
  minValue: Scalars['Float']['output'];
  sampleCount: Scalars['Int']['output'];
};

/**
 * The deviceTelemetryLatest response — the latest reading per (device, metric) pair in scope,
 * plus the truncation signal a bare [DeviceTelemetryPoint!]! could not carry.
 */
export type DeviceTelemetryLatestData = {
  __typename?: 'DeviceTelemetryLatestData';
  pairCount: Scalars['Int']['output'];
  points: Array<DeviceTelemetryPoint>;
  truncated: Scalars['Boolean']['output'];
};

/**
 * A single point-in-time telemetry value — the GraphQL-facing shape for both the
 * deviceTelemetryLatest query and the deviceTelemetryTicked subscription event.
 */
export type DeviceTelemetryPoint = {
  __typename?: 'DeviceTelemetryPoint';
  deviceId: Scalars['String']['output'];
  deviceTime: Scalars['DateTime']['output'];
  metric: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  seq: Scalars['Long']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/**
 * The latest confirmed outcome of a setWifi network change, decoded from the D2C
 * wifiChangeResult business event — success or rollback per changeId, so the caller can
 * match it against the id sendDeviceCommand returned and show the customer whether their update
 * applied.
 */
export type DeviceWifiChangeData = {
  __typename?: 'DeviceWifiChangeData';
  at: Scalars['DateTime']['output'];
  changeId: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

/**
 * The three terminal answers CONTRACT gives for a setWifi change, plus the platform-side
 *             PENDING/TIMED_OUT split neither the C2D wire nor the device can ever report.
 */
export enum DeviceWifiChangeState {
  /** The device tried the new network, it connected, and it persisted the change. */
  Applied = 'APPLIED',
  /** Dispatched; no wifiChangeResult yet, and still inside the result timeout. */
  Pending = 'PENDING',
  /** The device tried the new network, it did not connect, and it kept the old one. */
  RolledBack = 'ROLLED_BACK',
  /**
   * Dispatched; no wifiChangeResult has arrived within the result timeout. The device
   *             may have restarted between committing the flash and queuing the result (firmware task 79b8d6ee,
   *             CONTRACT §7.6) — this is what keeps the PWA from polling forever.
   */
  TimedOut = 'TIMED_OUT'
}

/**
 * The derived state of one SET_WIFI request, keyed by the changeId
 *             sendDeviceCommand returned. reason/at are populated only once a
 *             wifiChangeResult has actually arrived (APPLIED/ROLLED_BACK) — null for PENDING/TIMED_OUT, since
 *             there is nothing to report yet.
 */
export type DeviceWifiChangeStatusData = {
  __typename?: 'DeviceWifiChangeStatusData';
  at?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  state: DeviceWifiChangeState;
};

/** A connection to a list of items. */
export type DevicesConnection = {
  __typename?: 'DevicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DevicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DevicesEdge = {
  __typename?: 'DevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceDocument;
};

export enum DimensionSource {
  CustomerOverride = 'CUSTOMER_OVERRIDE',
  CustomerSpaceTypeOverride = 'CUSTOMER_SPACE_TYPE_OVERRIDE',
  Default = 'DEFAULT',
  SiteAndCustomerOverride = 'SITE_AND_CUSTOMER_OVERRIDE',
  SiteCustomerSpaceTypeOverride = 'SITE_CUSTOMER_SPACE_TYPE_OVERRIDE',
  SiteOverride = 'SITE_OVERRIDE',
  SiteSpaceTypeOverride = 'SITE_SPACE_TYPE_OVERRIDE',
  SpaceTypeOverride = 'SPACE_TYPE_OVERRIDE'
}

/** Input for disableMyMultiFactor: proof the caller still controls the account. */
export type DisableMyMultiFactorInput = {
  /**
   * A current authenticator code, or one of the caller's recovery codes. FusionAuth accepts either and
   * makes the comparison itself; wsapi passes the value through without inspecting it.
   */
  code: Scalars['String']['input'];
};

export type DisableWsapiImportInput = {
  wsapiImportId: Scalars['String']['input'];
};

export type DiscardFloatingTimeEntryInput = {
  floatingTimeEntryId: Scalars['String']['input'];
};

/** Discards a document that is not needed. */
export type DiscardInboundDocumentInput = {
  /** The document id. */
  documentId: Scalars['String']['input'];
};

export type DismissDuplicateCandidatesInput = {
  ids: Array<Scalars['String']['input']>;
};

export type DispatchLoadInput = {
  loadId: Scalars['String']['input'];
};

/**
 * GraphQL-output projection of a single (document type → render mode) pairing. Used both for the
 * tenant's explicitly-configured overrides and for the resolved-with-default effective set.
 */
export type DocumentRenderModeData = {
  __typename?: 'DocumentRenderModeData';
  docType: RenderDocType;
  mode: RenderMode;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Driver, keyed
 * {tenantId}-{driverId}. Projected by LogisticsDriverProjectionService. Deleted rows
 * are removed outright (matching the pwa reference slice's hard-delete-from-array semantics) rather
 * than retained with a status flag.
 */
export type DriverDocument = {
  __typename?: 'DriverDocument';
  carrierId: Scalars['String']['output'];
  driverId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  licenseNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Driver, keyed
 * {tenantId}-{driverId}. Projected by LogisticsDriverProjectionService. Deleted rows
 * are removed outright (matching the pwa reference slice's hard-delete-from-array semantics) rather
 * than retained with a status flag.
 */
export type DriverDocumentFilterInput = {
  and?: InputMaybe<Array<DriverDocumentFilterInput>>;
  carrierId?: InputMaybe<StringOperationFilterInput>;
  driverId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  licenseNumber?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DriverDocumentFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Driver, keyed
 * {tenantId}-{driverId}. Projected by LogisticsDriverProjectionService. Deleted rows
 * are removed outright (matching the pwa reference slice's hard-delete-from-array semantics) rather
 * than retained with a status flag.
 */
export type DriverDocumentSortInput = {
  carrierId?: InputMaybe<SortEnumType>;
  driverId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  licenseNumber?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type DriverPayload = {
  __typename?: 'DriverPayload';
  driver?: Maybe<DriverStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** GraphQL output shape returned by the Driver mutations: the driver row after the command applied. */
export type DriverStateData = {
  __typename?: 'DriverStateData';
  carrierId: Scalars['String']['output'];
  driverId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  licenseNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type DropShipDestinationDataInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  shipToName: Scalars['String']['input'];
  stateProvince?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One due scheduled transfer as the execution worker discovers it: which tenant and which schedule, and when it
 * fell due. Nothing else is needed to call executeScheduledInventoryTransfer.
 */
export type DueScheduledInventoryTransfer = {
  __typename?: 'DueScheduledInventoryTransfer';
  /** The UTC instant the schedule fell due. */
  dueAt: Scalars['DateTime']['output'];
  /** The schedule's id: the value executeScheduledInventoryTransfer takes. */
  id: Scalars['String']['output'];
  /** The tenant the schedule belongs to, whose token the worker executes it under. */
  tenantId: Scalars['String']['output'];
};

/**
 * The keyset cursor of dueScheduledInventoryTransfers: the (dueAt, id) of the last row the worker already
 * tried, so the next page starts strictly after it.
 */
export type DueScheduledInventoryTransferCursorInput = {
  /** The dueAt of the last row tried. */
  dueAt: Scalars['DateTime']['input'];
  /** The id of the last row tried. */
  id: Scalars['String']['input'];
};

/** One suspected duplicate pair. Its id is the pair key. */
export type DuplicateCandidate = {
  __typename?: 'DuplicateCandidate';
  a: DuplicateRecordSummary;
  b: DuplicateRecordSummary;
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  dismissedBy?: Maybe<Scalars['String']['output']>;
  entityType: DuplicateEntityType;
  flags: Array<DuplicateFieldFlag>;
  id: Scalars['String']['output'];
  judgment: DuplicateJudgment;
  outcome?: Maybe<DuplicateCandidateOutcome>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  source: DuplicateCandidateSource;
  status: DuplicateCandidateStatus;
};

export type DuplicateCandidateCounts = {
  __typename?: 'DuplicateCandidateCounts';
  dismissed: Scalars['Int']['output'];
  entityType: DuplicateEntityType;
  open: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
};

/** The pair keys (or, for a completed check, the request id) the call acted on, and what it refused. */
export type DuplicateCandidateIdsPayload = {
  __typename?: 'DuplicateCandidateIdsPayload';
  errors?: Maybe<Array<ValidationError>>;
  ids: Array<Scalars['String']['output']>;
};

export enum DuplicateCandidateOutcome {
  Combined = 'COMBINED',
  EitherInactive = 'EITHER_INACTIVE'
}

export enum DuplicateCandidateSource {
  Exact = 'EXACT',
  Import = 'IMPORT',
  Sweep = 'SWEEP'
}

export enum DuplicateCandidateStatus {
  Dismissed = 'DISMISSED',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type DuplicateCandidatesInput = {
  entityType?: InputMaybe<DuplicateEntityType>;
  status: DuplicateCandidateStatus;
};

/**
 * The pairs in one status, the tenant's counts per entity type (every type, whatever the filter), and whether a
 * check a person asked for is still waiting for the worker.
 */
export type DuplicateCandidatesPayload = {
  __typename?: 'DuplicateCandidatesPayload';
  checkPending: Scalars['Boolean']['output'];
  counts: Array<DuplicateCandidateCounts>;
  errors?: Maybe<Array<ValidationError>>;
  items: Array<DuplicateCandidate>;
};

export type DuplicateCheckRequest = {
  __typename?: 'DuplicateCheckRequest';
  entityType?: Maybe<DuplicateEntityType>;
  id: Scalars['String']['output'];
  requestedAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
};

export type DuplicateCheckRequestsPayload = {
  __typename?: 'DuplicateCheckRequestsPayload';
  errors?: Maybe<Array<ValidationError>>;
  requests: Array<DuplicateCheckRequest>;
};

export enum DuplicateEntityType {
  Category = 'CATEGORY',
  Customer = 'CUSTOMER',
  Item = 'ITEM',
  ProductionCatalog = 'PRODUCTION_CATALOG',
  ProductionItem = 'PRODUCTION_ITEM',
  ShipTo = 'SHIP_TO',
  SiteLocation = 'SITE_LOCATION',
  Terms = 'TERMS'
}

export type DuplicateFieldFlag = {
  __typename?: 'DuplicateFieldFlag';
  agrees: Scalars['Boolean']['output'];
  field: Scalars['String']['output'];
  probability: Scalars['Float']['output'];
};

export type DuplicateFieldFlagInput = {
  agrees: Scalars['Boolean']['input'];
  field: Scalars['String']['input'];
  probability: Scalars['Float']['input'];
};

export type DuplicateJudgment = {
  __typename?: 'DuplicateJudgment';
  confidence: Scalars['Float']['output'];
  foundAt: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  modelVersion: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type DuplicatePriceGroupInput = {
  name: Scalars['String']['input'];
  newId: Scalars['String']['input'];
  originalId: Scalars['String']['input'];
};

export type DuplicateProductionRecipeInput = {
  sourceProductionRecipeId: Scalars['String']['input'];
  targetProductionCatalogId: Scalars['String']['input'];
  targetProductionCategoryId?: InputMaybe<Scalars['String']['input']>;
};

/** The duplicated recipe, or why it could not be duplicated. */
export type DuplicateProductionRecipePayload = {
  __typename?: 'DuplicateProductionRecipePayload';
  errors?: Maybe<Array<ValidationError>>;
  productionRecipe?: Maybe<ProductionRecipeStateData>;
};

export type DuplicateRecordSummary = {
  __typename?: 'DuplicateRecordSummary';
  erpId?: Maybe<Scalars['String']['output']>;
  historyCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum DynamicDefaultType {
  DateTime = 'DATE_TIME',
  Guid = 'GUID',
  NotSet = 'NOT_SET'
}

export type DynamicDefaultTypeOperationFilterInput = {
  eq?: InputMaybe<DynamicDefaultType>;
  in?: InputMaybe<Array<DynamicDefaultType>>;
  neq?: InputMaybe<DynamicDefaultType>;
  nin?: InputMaybe<Array<DynamicDefaultType>>;
};

export type DynamicDefaultUnitData = {
  __typename?: 'DynamicDefaultUnitData';
  argument?: Maybe<Scalars['String']['output']>;
  type: DynamicDefaultType;
};

export type DynamicDefaultUnitDataFilterInput = {
  and?: InputMaybe<Array<DynamicDefaultUnitDataFilterInput>>;
  argument?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DynamicDefaultUnitDataFilterInput>>;
  type?: InputMaybe<DynamicDefaultTypeOperationFilterInput>;
};

export type DynamicDefaultUnitDataInput = {
  argument?: InputMaybe<Scalars['String']['input']>;
  type: DynamicDefaultType;
};

export type DynamicTransformUnitData = {
  __typename?: 'DynamicTransformUnitData';
  argument?: Maybe<Scalars['String']['output']>;
  type: TransformType;
};

export type DynamicTransformUnitDataFilterInput = {
  and?: InputMaybe<Array<DynamicTransformUnitDataFilterInput>>;
  argument?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DynamicTransformUnitDataFilterInput>>;
  type?: InputMaybe<TransformTypeOperationFilterInput>;
};

export type DynamicTransformUnitDataInput = {
  argument?: InputMaybe<Scalars['String']['input']>;
  type: TransformType;
};

/** One user's early access request for one flag in one tenant. */
export type EarlyAccessRequest = {
  __typename?: 'EarlyAccessRequest';
  /** The requesting user's email. */
  email: Scalars['String']['output'];
  /** The flag the user asked to try early. */
  flag: FeatureFlagName;
  /** When the request was first recorded; a repeat request does not change it. */
  requestedAt: Scalars['DateTime']['output'];
  /** The requesting user's tenant. */
  tenantId: Scalars['String']['output'];
};

export type EditCustomerInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  clearMinimumFreightCharge?: InputMaybe<Scalars['Boolean']['input']>;
  clearUnloadMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  currency: Scalars['String']['input'];
  customerGroupId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  customerLookupCode?: InputMaybe<Scalars['String']['input']>;
  customerTypeId?: InputMaybe<Scalars['String']['input']>;
  defaultDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  erpPriceGroupId: Scalars['String']['input'];
  federalTaxNumber?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  minimumFreightCharge?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  poRequired?: Scalars['Boolean']['input'];
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  receivingWindowEnd?: InputMaybe<Scalars['String']['input']>;
  receivingWindowStart?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  synchronizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  taxExemptNumber?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
  unloadMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type EditCustomerLocationSettingsNoteInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  noteId: Scalars['String']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
};

export type EditMasterOrderInput = {
  customer: MasterOrderCustomerDataInput;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  fromLocation: ShipFromLocationDataInput;
  masterOrderId: Scalars['String']['input'];
  masterOrderNumber: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
  type: OrderType;
};

export type EditOrderFlatChargeInput = {
  amount: Scalars['Decimal']['input'];
  flatChargeId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  taxable: Scalars['Boolean']['input'];
};

export type EditOrderInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  customer: OrderCustomerDataInput;
  discountAmount?: InputMaybe<Scalars['Decimal']['input']>;
  discountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  discountReason?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['DateTime']['input'];
  finalCredit?: Scalars['Boolean']['input'];
  freightChargeReason?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  fromLocation: ShipFromLocationDataInput;
  orderId: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  overrideTotal?: InputMaybe<Scalars['Decimal']['input']>;
  poNumber: Scalars['String']['input'];
  produceAllocate?: Scalars['Boolean']['input'];
  termsId?: InputMaybe<Scalars['String']['input']>;
  type: OrderType;
};

export type EditPlanCellsInput = {
  edits: Array<PlanCellEditInput>;
  forecastId: Scalars['String']['input'];
};

export type EditScheduledLaborRateInput = {
  currentEffectiveFrom: Scalars['DateTime']['input'];
  laborTypeId: Scalars['String']['input'];
  newEffectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  newRatePerHour?: InputMaybe<Scalars['Decimal']['input']>;
  siteLocationId: Scalars['String']['input'];
};

export type EditScheduledOverheadRateInput = {
  currentEffectiveFrom: Scalars['DateTime']['input'];
  newCostPerSqFtPerWeek?: InputMaybe<Scalars['Decimal']['input']>;
  newEffectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  siteLocationId: Scalars['String']['input'];
  subLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type EditWeeklyCellsInput = {
  edits: Array<WeeklyCellEditInput>;
  forecastId: Scalars['String']['input'];
};

/**
 * The delivery schedule in force for one customer ship-to location, after the server has applied
 * the full precedence.
 */
export type EffectiveDeliveryScheduleData = {
  __typename?: 'EffectiveDeliveryScheduleData';
  /**
   * The schedule in force, or null when nothing is configured. Non-null with every weekday false
   * means an active schedule that selects no day — a different state, which this field separates.
   */
  deliveryScheduleId?: Maybe<Scalars['String']['output']>;
  /** The display name of the schedule in force; null when there is none. */
  deliveryScheduleName?: Maybe<Scalars['String']['output']>;
  /**
   * The route the schedule was resolved through (the location's, else the customer's, else the
   * tenant default), or null when no route was reached.
   */
  effectiveRoute?: Maybe<Scalars['String']['output']>;
  /** Whether the schedule in force delivers on Friday; false when there is none. */
  friday: Scalars['Boolean']['output'];
  /** Whether the schedule in force delivers on Monday; false when there is none. */
  monday: Scalars['Boolean']['output'];
  /**
   * Whether any restriction applies. False means every day is deliverable — either nothing is
   * configured or the schedule in force selects no day.
   */
  restrictionActive: Scalars['Boolean']['output'];
  /** Whether the schedule in force delivers on Saturday; false when there is none. */
  saturday: Scalars['Boolean']['output'];
  /** Whether the schedule in force delivers on Sunday; false when there is none. */
  sunday: Scalars['Boolean']['output'];
  /** Whether the schedule in force delivers on Thursday; false when there is none. */
  thursday: Scalars['Boolean']['output'];
  /** Which setting produced this answer: the location's override, its route's schedule, or nothing. */
  tier: DeliveryScheduleTier;
  /** Whether the schedule in force delivers on Tuesday; false when there is none. */
  tuesday: Scalars['Boolean']['output'];
  /** Whether the schedule in force delivers on Wednesday; false when there is none. */
  wednesday: Scalars['Boolean']['output'];
};

/**
 * The route the tenant's ordinary customer email takes now, observed from the approved selection and the
 * senders' current verification. Reading it never verifies, switches or sends anything.
 */
export type EffectiveEmailSenderRouteData = {
  __typename?: 'EffectiveEmailSenderRouteData';
  /** Gets what the effective sender is for. */
  intendedUse: EmailSenderIntendedUse;
  /**
   * Gets whether the effective sender can send now. A COMPANY selection whose sender is not verified, or whose
   * verification has not reached the read model yet, is SELECTED_SENDER_PENDING; one whose sender is gone is
   * SELECTED_SENDER_UNAVAILABLE. Neither falls back to another sender.
   */
  readiness: EmailSenderReadiness;
  /** Gets where a customer reply goes: the platform no-reply mailbox or the sender's own mailbox. */
  replyRouting: EmailReplyRouting;
  /** Gets the address a customer reply goes to. */
  replyToEmail: Scalars['String']['output'];
  /**
   * Gets the effective From identity (email and display name). For a COMPANY selection that is not ready this is
   * still the approved company sender, never another identity.
   */
  sender: TenantEmailSenderData;
};

/**
 * Where one item's revenue would post today, ignoring who is being billed: the account, the
 * precedence rung that supplied it, and any category disagreement that was stepped over.
 *
 *
 * This walks the item rung, the category rung and the tenant default — NOT the customer type rung,
 * which is invoice-wide and unknowable from an item alone. note says so in words, because a
 * customer type mapping outranks everything answered here.
 */
export type EffectiveIncomeGlAccount = {
  __typename?: 'EffectiveIncomeGlAccount';
  /**
   * The Chart-of-Accounts row this item would post to. Null when rung is UNMAPPED — no item,
   * category or tenant-default mapping applied.
   */
  account?: Maybe<MergeDevAccountDocument>;
  /**
   * The categories that disagreed, when this item sits in two or more mapped categories pointing
   * at different accounts. The category rung is skipped in that case and routing falls to the
   * tenant default. Empty otherwise.
   */
  conflictingCategoryIds: Array<Scalars['String']['output']>;
  /**
   * The standing caveat that a customer type mapping outranks whatever this preview says, since
   * no customer is in scope on an item.
   */
  note: Scalars['String']['output'];
  /**
   * Which rung supplied the account: ITEM, CATEGORY, TENANT_DEFAULT, or UNMAPPED when none did.
   * Never CUSTOMER_TYPE — that rung is not walked here.
   */
  rung: MergeDevRevenueRung;
  /** Every archived account this resolution stepped over, named with the rung that offered it. */
  staleMappings: Array<StaleRevenueMapping>;
};

/**
 * Which tier of the live order-note inheritance chain produced an order's effective note for a
 * given NoteContext. Surfaced alongside the resolved text so the UI can label where
 * the note came from (e.g. "inherited from customer").
 */
export enum EffectiveNoteSource {
  /** The customer supplies the note for this context (tier 3). */
  Customer = 'CUSTOMER',
  /** The order's ship-to customer location supplies the note for this context (tier 2). */
  Location = 'LOCATION',
  /** No note is set on any tier for this context. */
  None = 'NONE',
  /** The order carries its own override note for this context (tier 1). */
  Order = 'ORDER'
}

/**
 * An order's effective typed note for one NoteContext, resolved by live inheritance
 * (order override → ship-to location → customer) at read time. Text is null
 * when Source is None; otherwise it is the resolving
 * tier's current note body. One entry is always returned per context so the consumer never has to
 * reason about absence by missing key.
 */
export type EffectiveOrderNote = {
  __typename?: 'EffectiveOrderNote';
  context: NoteContext;
  source: EffectiveNoteSource;
  text?: Maybe<Scalars['String']['output']>;
};

/**
 * One calendar day the portal date picker renders, with the reason it cannot be picked when it is
 * ineligible. Ineligible days are returned rather than omitted so a nearer date disappearing from
 * the calendar is always explainable instead of reading as a bug.
 */
export type EligibleDeliveryDateData = {
  __typename?: 'EligibleDeliveryDateData';
  /** The delivery date, as a calendar day in the tenant's cutoff time zone. */
  date: Scalars['LocalDate']['output'];
  /** Why the date cannot be selected; null when it is eligible. */
  ineligibleReason?: Maybe<DeliveryDateIneligibleReason>;
  /** Whether the buyer may select this date. */
  isEligible: Scalars['Boolean']['output'];
};

/**
 * The selectable delivery dates for one customer ship-to location over a bounded horizon, computed
 * server-side against the clock at request time so the portal never duplicates delivery-day or
 * order-cutoff logic.
 */
export type EligibleDeliveryDatesData = {
  __typename?: 'EligibleDeliveryDatesData';
  /** Every day in the horizon, ascending, eligible and ineligible alike. */
  dates: Array<EligibleDeliveryDateData>;
  /**
   * The first selectable date, so the picker can default to it without scanning. Null when
   * nothing in the horizon is selectable.
   */
  earliestEligibleDate?: Maybe<Scalars['LocalDate']['output']>;
  /** True when the company enforces portal delivery dates, so checkout refuses a date this calendar marks ineligible. False when enforcement is off: checkout accepts any date. */
  enforcedAtCheckout: Scalars['Boolean']['output'];
  /**
   * Whether any restriction applies at all. False means an unconfigured tenant, so the picker can
   * render an open calendar directly instead of inferring it from a fully eligible list.
   */
  restrictionActive: Scalars['Boolean']['output'];
};

export type EmailAddressData = {
  __typename?: 'EmailAddressData';
  type: EmailAddressType;
  value: Scalars['String']['output'];
};

export type EmailAddressDataFilterInput = {
  and?: InputMaybe<Array<EmailAddressDataFilterInput>>;
  or?: InputMaybe<Array<EmailAddressDataFilterInput>>;
  type?: InputMaybe<EmailAddressTypeOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type EmailAddressDataInput = {
  type: EmailAddressType;
  value: Scalars['String']['input'];
};

export enum EmailAddressType {
  Home = 'HOME',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  Work = 'WORK'
}

export type EmailAddressTypeOperationFilterInput = {
  eq?: InputMaybe<EmailAddressType>;
  in?: InputMaybe<Array<EmailAddressType>>;
  neq?: InputMaybe<EmailAddressType>;
  nin?: InputMaybe<Array<EmailAddressType>>;
};

/** GraphQL data transfer object for a recorded email-delivery ledger. */
export type EmailDeliveryData = {
  __typename?: 'EmailDeliveryData';
  deliveries: Array<EmailDeliveryEntryData>;
  sendGridMessageId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** GraphQL data transfer object for a single delivery event. */
export type EmailDeliveryEntryData = {
  __typename?: 'EmailDeliveryEntryData';
  bounceClassification?: Maybe<Scalars['String']['output']>;
  bounceType?: Maybe<Scalars['String']['output']>;
  eventType: EmailDeliveryEventType;
  occurredAt: Scalars['DateTime']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  recipient: Scalars['String']['output'];
  sgEventId?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
};

export enum EmailDeliveryEventType {
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  Opened = 'OPENED',
  SpamReport = 'SPAM_REPORT'
}

/** Payload returned from the record-email-delivery mutation. */
export type EmailDeliveryPayload = {
  __typename?: 'EmailDeliveryPayload';
  emailDelivery?: Maybe<EmailDeliveryData>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum EmailDeliveryStatus {
  Blocked = 'BLOCKED',
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  Failed = 'FAILED',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  Pending = 'PENDING',
  SpamReport = 'SPAM_REPORT'
}

export type EmailDeliveryStatusOperationFilterInput = {
  eq?: InputMaybe<EmailDeliveryStatus>;
  in?: InputMaybe<Array<EmailDeliveryStatus>>;
  neq?: InputMaybe<EmailDeliveryStatus>;
  nin?: InputMaybe<Array<EmailDeliveryStatus>>;
};

/**
 * Recognized DMARC enforcement policies, parsed from a domain's _dmarc TXT record p=
 * tag. None here is the DMARC record's own monitor-only policy value — distinct from the
 * domain simply having no DMARC record at all, which the dmarcPolicy field represents as
 * null (a missing field over the wire).
 */
export enum EmailDmarcPolicy {
  /** DMARC p=none — monitor only, no enforcement on a failing message. */
  None = 'NONE',
  /** DMARC p=quarantine — a failing message is delivered to spam/junk. */
  Quarantine = 'QUARANTINE',
  /** DMARC p=reject — a failing message is rejected outright. */
  Reject = 'REJECT'
}

export enum EmailDomainOrigin {
  Created = 'CREATED',
  Grandfathered = 'GRANDFATHERED'
}

export enum EmailRecipientDeliveryStatus {
  Blocked = 'BLOCKED',
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  Opened = 'OPENED',
  Pending = 'PENDING',
  SpamReport = 'SPAM_REPORT'
}

export enum EmailRecipientKind {
  Cc = 'CC',
  To = 'TO'
}

export type EmailRecipientKindOperationFilterInput = {
  eq?: InputMaybe<EmailRecipientKind>;
  in?: InputMaybe<Array<EmailRecipientKind>>;
  neq?: InputMaybe<EmailRecipientKind>;
  nin?: InputMaybe<Array<EmailRecipientKind>>;
};

export enum EmailRecipientSendStatus {
  Failed = 'FAILED',
  Sent = 'SENT'
}

export type EmailRecipientSendStatusOperationFilterInput = {
  eq?: InputMaybe<EmailRecipientSendStatus>;
  in?: InputMaybe<Array<EmailRecipientSendStatus>>;
  neq?: InputMaybe<EmailRecipientSendStatus>;
  nin?: InputMaybe<Array<EmailRecipientSendStatus>>;
};

/** Where a customer's reply to the tenant's ordinary customer email goes. */
export enum EmailReplyRouting {
  /** Replies go to the Work Suite platform no-reply address, which nobody reads. */
  PlatformNoReply = 'PLATFORM_NO_REPLY',
  /** Replies go to the company sender's own mailbox. */
  SenderMailbox = 'SENDER_MAILBOX',
  /** Not resolved. */
  Unknown = 'UNKNOWN'
}

/** GraphQL data transfer object for a recorded email send. */
export type EmailSendData = {
  __typename?: 'EmailSendData';
  channel?: Maybe<EmailSenderChannel>;
  deliveryStatus: EmailDeliveryStatus;
  docType?: Maybe<Scalars['String']['output']>;
  emailSendId: Scalars['String']['output'];
  fromEmail: Scalars['String']['output'];
  fromName?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  pdfSizeBytes?: Maybe<Scalars['Long']['output']>;
  recipients: Array<EmailSendRecipientData>;
  reportId?: Maybe<Scalars['String']['output']>;
  scheduleId?: Maybe<Scalars['String']['output']>;
  sendGridMessageId?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['DateTime']['output'];
  sentBy: Scalars['String']['output'];
  source: EmailSendSource;
  subject: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a single unified email-send log entry. Send-time facts are
 * written by the EmailSendRecorded projection; the delivery rollup (per-recipient status +
 * aggregate DeliveryStatus) is PERSISTED here — projected from the
 * EmailSendDeliveryRolledUp event that recordEmailDelivery emits atomically alongside
 * the delivery ledger write (Atlas 2a4e5847), each an absolute write (Atlas accaf08f). Persisting
 * the rollup turns Email-Issues failure filtering into a plain indexed query on
 * DeliveryStatus instead of a query-time correlation. A freshly-recorded send (no
 * delivery yet) defaults every delivery field to Pending/null; the query-time read resolver
 * keeps the read fallback for any row whose rollup has not yet landed (e.g. a delivery event
 * that arrived before its send).
 */
export type EmailSendDocument = {
  __typename?: 'EmailSendDocument';
  /** Gets the channel the send was dispatched through, when recorded (null for legacy sends). */
  channel?: Maybe<EmailSenderChannel>;
  /** Gets the aggregated delivery status across all recipients. Persisted from the EmailSendDeliveryRolledUp projection so failure filtering is a plain indexed query; defaults to Pending until the first delivery event rolls up. Stored in its default (integer) representation — like OrdersDocument.OrderStatus — so the HotChocolate MongoDB where.deliveryStatus.in filter matches the stored value. */
  deliveryStatus: EmailDeliveryStatus;
  /** Gets the document type, when order-driven. */
  docType?: Maybe<Scalars['String']['output']>;
  /** Gets the driver name a planned-arrival notice was sent with. */
  driverName?: Maybe<Scalars['String']['output']>;
  /** Gets the unique email-send identifier. */
  emailSendId: Scalars['String']['output'];
  /** Gets the sender email address. */
  fromEmail: Scalars['String']['output'];
  /** Gets the sender display name. */
  fromName?: Maybe<Scalars['String']['output']>;
  /** Gets whether any recipient's rolled-up delivery status is a terminal failure (Bounced/Blocked/Dropped/SpamReport — Deferred is not terminal). Persisted from the EmailSendDeliveryRolledUp projection in the same write as DeliveryStatus so the Email Issues grid can distinguish a PartiallyDelivered send with a real failure from one whose remaining recipients are merely pending or deferred. Legacy rows lacking the field deserialize to false. */
  hasFailedRecipient: Scalars['Boolean']['output'];
  /** Gets the MongoDB document identifier. */
  id: Scalars['String']['output'];
  /** Gets the load a load email was about, when the send is a load email. */
  loadId?: Maybe<Scalars['String']['output']>;
  /** Gets whether an operator asserted the send by hand rather than a worker reporting it. */
  operatorAsserted?: Maybe<Scalars['Boolean']['output']>;
  /** Gets the order identifier, when order-driven. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Gets the order number, when order-driven. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Gets the order numbers a planned-arrival notice was sent with. */
  orderNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /** Gets the size of the attached PDF in bytes, when present. */
  pdfSizeBytes?: Maybe<Scalars['Long']['output']>;
  /** Gets the planned delivery date a planned-arrival notice was sent with. */
  plannedDeliveryDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Gets the planned time (HH:mm) a planned-arrival notice was sent with. */
  plannedTime?: Maybe<Scalars['String']['output']>;
  /** Gets the rack count a planned-arrival notice was sent with. */
  rackCount?: Maybe<Scalars['Int']['output']>;
  /** Gets the recipients addressed by this send. */
  recipients: Array<EmailSendRecipientDocument>;
  /** Gets the report identifier, when report-driven. */
  reportId?: Maybe<Scalars['String']['output']>;
  /** Gets the load email reservation the send came from. */
  reservationId?: Maybe<Scalars['String']['output']>;
  /** Gets the version of the load email reservation the send came from. */
  reservationVersion?: Maybe<Scalars['Int']['output']>;
  /** Gets the route stop a planned-arrival notice was about. */
  routeStopId?: Maybe<Scalars['String']['output']>;
  /** Gets the schedule identifier, when schedule-driven. */
  scheduleId?: Maybe<Scalars['String']['output']>;
  /** Gets the SendGrid message identifier that correlates delivery events. */
  sendGridMessageId?: Maybe<Scalars['String']['output']>;
  /** Gets the timestamp when the send occurred. */
  sentAt: Scalars['DateTime']['output'];
  /** Gets the user or worker that performed the send. */
  sentBy: Scalars['String']['output'];
  /** Gets the origin of the send. */
  source: EmailSendSource;
  /** Gets the stop number a planned-arrival notice was sent with. */
  stopNumber?: Maybe<Scalars['Int']['output']>;
  /** Gets the email subject line. */
  subject: Scalars['String']['output'];
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a single unified email-send log entry. Send-time facts are
 * written by the EmailSendRecorded projection; the delivery rollup (per-recipient status +
 * aggregate DeliveryStatus) is PERSISTED here — projected from the
 * EmailSendDeliveryRolledUp event that recordEmailDelivery emits atomically alongside
 * the delivery ledger write (Atlas 2a4e5847), each an absolute write (Atlas accaf08f). Persisting
 * the rollup turns Email-Issues failure filtering into a plain indexed query on
 * DeliveryStatus instead of a query-time correlation. A freshly-recorded send (no
 * delivery yet) defaults every delivery field to Pending/null; the query-time read resolver
 * keeps the read fallback for any row whose rollup has not yet landed (e.g. a delivery event
 * that arrived before its send).
 */
export type EmailSendDocumentFilterInput = {
  and?: InputMaybe<Array<EmailSendDocumentFilterInput>>;
  /** Gets the channel the send was dispatched through, when recorded (null for legacy sends). */
  channel?: InputMaybe<NullableOfEmailSenderChannelOperationFilterInput>;
  /** Gets the aggregated delivery status across all recipients. Persisted from the EmailSendDeliveryRolledUp projection so failure filtering is a plain indexed query; defaults to Pending until the first delivery event rolls up. Stored in its default (integer) representation — like OrdersDocument.OrderStatus — so the HotChocolate MongoDB where.deliveryStatus.in filter matches the stored value. */
  deliveryStatus?: InputMaybe<EmailDeliveryStatusOperationFilterInput>;
  /** Gets the document type, when order-driven. */
  docType?: InputMaybe<StringOperationFilterInput>;
  /** Gets the driver name a planned-arrival notice was sent with. */
  driverName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the unique email-send identifier. */
  emailSendId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the sender email address. */
  fromEmail?: InputMaybe<StringOperationFilterInput>;
  /** Gets the sender display name. */
  fromName?: InputMaybe<StringOperationFilterInput>;
  /** Gets whether any recipient's rolled-up delivery status is a terminal failure (Bounced/Blocked/Dropped/SpamReport — Deferred is not terminal). Persisted from the EmailSendDeliveryRolledUp projection in the same write as DeliveryStatus so the Email Issues grid can distinguish a PartiallyDelivered send with a real failure from one whose remaining recipients are merely pending or deferred. Legacy rows lacking the field deserialize to false. */
  hasFailedRecipient?: InputMaybe<AbsentAsFalseBooleanOperationFilterInput>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Gets the load a load email was about, when the send is a load email. */
  loadId?: InputMaybe<StringOperationFilterInput>;
  /** Gets whether an operator asserted the send by hand rather than a worker reporting it. */
  operatorAsserted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<EmailSendDocumentFilterInput>>;
  /** Gets the order identifier, when order-driven. */
  orderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the order number, when order-driven. */
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  /** Gets the order numbers a planned-arrival notice was sent with. */
  orderNumbers?: InputMaybe<ListStringOperationFilterInput>;
  /** Gets the size of the attached PDF in bytes, when present. */
  pdfSizeBytes?: InputMaybe<LongOperationFilterInput>;
  /** Gets the planned delivery date a planned-arrival notice was sent with. */
  plannedDeliveryDate?: InputMaybe<LocalDateOperationFilterInput>;
  /** Gets the planned time (HH:mm) a planned-arrival notice was sent with. */
  plannedTime?: InputMaybe<StringOperationFilterInput>;
  /** Gets the rack count a planned-arrival notice was sent with. */
  rackCount?: InputMaybe<IntOperationFilterInput>;
  /** Gets the recipients addressed by this send. */
  recipients?: InputMaybe<ListFilterInputTypeOfEmailSendRecipientDocumentFilterInput>;
  /** Gets the report identifier, when report-driven. */
  reportId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the load email reservation the send came from. */
  reservationId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the version of the load email reservation the send came from. */
  reservationVersion?: InputMaybe<IntOperationFilterInput>;
  /** Gets the route stop a planned-arrival notice was about. */
  routeStopId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the schedule identifier, when schedule-driven. */
  scheduleId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the SendGrid message identifier that correlates delivery events. */
  sendGridMessageId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the timestamp when the send occurred. */
  sentAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the user or worker that performed the send. */
  sentBy?: InputMaybe<StringOperationFilterInput>;
  /** Gets the origin of the send. */
  source?: InputMaybe<EmailSendSourceOperationFilterInput>;
  /** Gets the stop number a planned-arrival notice was sent with. */
  stopNumber?: InputMaybe<IntOperationFilterInput>;
  /** Gets the email subject line. */
  subject?: InputMaybe<StringOperationFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a single unified email-send log entry. Send-time facts are
 * written by the EmailSendRecorded projection; the delivery rollup (per-recipient status +
 * aggregate DeliveryStatus) is PERSISTED here — projected from the
 * EmailSendDeliveryRolledUp event that recordEmailDelivery emits atomically alongside
 * the delivery ledger write (Atlas 2a4e5847), each an absolute write (Atlas accaf08f). Persisting
 * the rollup turns Email-Issues failure filtering into a plain indexed query on
 * DeliveryStatus instead of a query-time correlation. A freshly-recorded send (no
 * delivery yet) defaults every delivery field to Pending/null; the query-time read resolver
 * keeps the read fallback for any row whose rollup has not yet landed (e.g. a delivery event
 * that arrived before its send).
 */
export type EmailSendDocumentSortInput = {
  /** Gets the channel the send was dispatched through, when recorded (null for legacy sends). */
  channel?: InputMaybe<SortEnumType>;
  /** Gets the aggregated delivery status across all recipients. Persisted from the EmailSendDeliveryRolledUp projection so failure filtering is a plain indexed query; defaults to Pending until the first delivery event rolls up. Stored in its default (integer) representation — like OrdersDocument.OrderStatus — so the HotChocolate MongoDB where.deliveryStatus.in filter matches the stored value. */
  deliveryStatus?: InputMaybe<SortEnumType>;
  /** Gets the document type, when order-driven. */
  docType?: InputMaybe<SortEnumType>;
  /** Gets the driver name a planned-arrival notice was sent with. */
  driverName?: InputMaybe<SortEnumType>;
  /** Gets the unique email-send identifier. */
  emailSendId?: InputMaybe<SortEnumType>;
  /** Gets the sender email address. */
  fromEmail?: InputMaybe<SortEnumType>;
  /** Gets the sender display name. */
  fromName?: InputMaybe<SortEnumType>;
  /** Gets whether any recipient's rolled-up delivery status is a terminal failure (Bounced/Blocked/Dropped/SpamReport — Deferred is not terminal). Persisted from the EmailSendDeliveryRolledUp projection in the same write as DeliveryStatus so the Email Issues grid can distinguish a PartiallyDelivered send with a real failure from one whose remaining recipients are merely pending or deferred. Legacy rows lacking the field deserialize to false. */
  hasFailedRecipient?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the load a load email was about, when the send is a load email. */
  loadId?: InputMaybe<SortEnumType>;
  /** Gets whether an operator asserted the send by hand rather than a worker reporting it. */
  operatorAsserted?: InputMaybe<SortEnumType>;
  /** Gets the order identifier, when order-driven. */
  orderId?: InputMaybe<SortEnumType>;
  /** Gets the order number, when order-driven. */
  orderNumber?: InputMaybe<SortEnumType>;
  /** Gets the size of the attached PDF in bytes, when present. */
  pdfSizeBytes?: InputMaybe<SortEnumType>;
  /** Gets the planned delivery date a planned-arrival notice was sent with. */
  plannedDeliveryDate?: InputMaybe<SortEnumType>;
  /** Gets the planned time (HH:mm) a planned-arrival notice was sent with. */
  plannedTime?: InputMaybe<SortEnumType>;
  /** Gets the rack count a planned-arrival notice was sent with. */
  rackCount?: InputMaybe<SortEnumType>;
  /** Gets the report identifier, when report-driven. */
  reportId?: InputMaybe<SortEnumType>;
  /** Gets the load email reservation the send came from. */
  reservationId?: InputMaybe<SortEnumType>;
  /** Gets the version of the load email reservation the send came from. */
  reservationVersion?: InputMaybe<SortEnumType>;
  /** Gets the route stop a planned-arrival notice was about. */
  routeStopId?: InputMaybe<SortEnumType>;
  /** Gets the schedule identifier, when schedule-driven. */
  scheduleId?: InputMaybe<SortEnumType>;
  /** Gets the SendGrid message identifier that correlates delivery events. */
  sendGridMessageId?: InputMaybe<SortEnumType>;
  /** Gets the timestamp when the send occurred. */
  sentAt?: InputMaybe<SortEnumType>;
  /** Gets the user or worker that performed the send. */
  sentBy?: InputMaybe<SortEnumType>;
  /** Gets the origin of the send. */
  source?: InputMaybe<SortEnumType>;
  /** Gets the stop number a planned-arrival notice was sent with. */
  stopNumber?: InputMaybe<SortEnumType>;
  /** Gets the email subject line. */
  subject?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
};

/** Payload returned from the record-email-send mutation. */
export type EmailSendPayload = {
  __typename?: 'EmailSendPayload';
  emailSend?: Maybe<EmailSendData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** GraphQL data transfer object for a single recipient of an email send. */
export type EmailSendRecipientData = {
  __typename?: 'EmailSendRecipientData';
  bounceClassification?: Maybe<Scalars['String']['output']>;
  deliveryReason?: Maybe<Scalars['String']['output']>;
  deliveryStatus: EmailRecipientDeliveryStatus;
  deliveryUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  kind: EmailRecipientKind;
  sendErrorMessage?: Maybe<Scalars['String']['output']>;
  sendStatus: EmailRecipientSendStatus;
  statusCode?: Maybe<Scalars['String']['output']>;
};

/** MongoDB sub-document for a single recipient of an email send. */
export type EmailSendRecipientDocument = {
  __typename?: 'EmailSendRecipientDocument';
  /** Gets SendGrid's human bounce category (bounce_classification, e.g. "Invalid Address"), when a hard failure. Persisted from the delivery rollup. */
  bounceClassification?: Maybe<Scalars['String']['output']>;
  /** Gets the delivery failure/deferral reason (SendGrid reason), when applicable. Persisted from the delivery rollup. */
  deliveryReason?: Maybe<Scalars['String']['output']>;
  /** Gets the per-recipient delivery status. Persisted from the EmailSendDeliveryRolledUp projection (default integer representation); defaults to Pending until the first correlated delivery event. */
  deliveryStatus: EmailRecipientDeliveryStatus;
  /** Gets the timestamp of the most recent delivery event for this recipient. Persisted from the delivery rollup. */
  deliveryUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the recipient email address. */
  email: Scalars['String']['output'];
  /** Gets whether this recipient was on the To or Cc line. */
  kind: EmailRecipientKind;
  /** Gets the per-recipient send error message, when the send failed. */
  sendErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Gets the per-recipient send outcome recorded at send time. */
  sendStatus: EmailRecipientSendStatus;
  /** Gets the SMTP status code (SendGrid status, e.g. "5.1.1"), when a failure/deferral. Persisted from the delivery rollup. */
  statusCode?: Maybe<Scalars['String']['output']>;
};

/** MongoDB sub-document for a single recipient of an email send. */
export type EmailSendRecipientDocumentFilterInput = {
  and?: InputMaybe<Array<EmailSendRecipientDocumentFilterInput>>;
  /** Gets the recipient email address. */
  email?: InputMaybe<StringOperationFilterInput>;
  /** Gets whether this recipient was on the To or Cc line. */
  kind?: InputMaybe<EmailRecipientKindOperationFilterInput>;
  or?: InputMaybe<Array<EmailSendRecipientDocumentFilterInput>>;
  /** Gets the per-recipient send error message, when the send failed. */
  sendErrorMessage?: InputMaybe<StringOperationFilterInput>;
  /** Gets the per-recipient send outcome recorded at send time. */
  sendStatus?: InputMaybe<EmailRecipientSendStatusOperationFilterInput>;
};

export enum EmailSendSource {
  AutoInvoice = 'AUTO_INVOICE',
  Benchmark = 'BENCHMARK',
  Load = 'LOAD',
  LoadStop = 'LOAD_STOP',
  ManualReport = 'MANUAL_REPORT',
  Notification = 'NOTIFICATION',
  OrderAcknowledgment = 'ORDER_ACKNOWLEDGMENT',
  OrderConfirmation = 'ORDER_CONFIRMATION',
  PersonalAccount = 'PERSONAL_ACCOUNT',
  ScheduledReport = 'SCHEDULED_REPORT',
  WhatsNew = 'WHATS_NEW'
}

export type EmailSendSourceOperationFilterInput = {
  eq?: InputMaybe<EmailSendSource>;
  in?: InputMaybe<Array<EmailSendSource>>;
  neq?: InputMaybe<EmailSendSource>;
  nin?: InputMaybe<Array<EmailSendSource>>;
};

export enum EmailSenderChannel {
  M365 = 'M365',
  SendgridDomain = 'SENDGRID_DOMAIN',
  SendgridSingle = 'SENDGRID_SINGLE',
  Smtp = 'SMTP'
}

export enum EmailSenderIntendedUse {
  OrdinaryCustomerEmail = 'ORDINARY_CUSTOMER_EMAIL',
  TemporaryWhileCompanySenderPending = 'TEMPORARY_WHILE_COMPANY_SENDER_PENDING',
  Unknown = 'UNKNOWN'
}

/** Whether the effective sender of a tenant's ordinary customer email can send now. */
export enum EmailSenderReadiness {
  /** The effective sender is verified and sends now. */
  Ready = 'READY',
  /**
   * The approved company sender is not verified, or its verification has not reached the read model yet. Email
   * that needs a verified sender waits; nothing is sent from another identity.
   */
  SelectedSenderPending = 'SELECTED_SENDER_PENDING',
  /**
   * The approved company sender no longer exists on its channel (removed, or its SMTP connection removed).
   * Nothing is sent from another identity until another selection is approved.
   */
  SelectedSenderUnavailable = 'SELECTED_SENDER_UNAVAILABLE',
  /** Not resolved. */
  Unknown = 'UNKNOWN'
}

/**
 * The approved sender selection. INHERIT at revision 0 means no selection was ever approved (legacy
 * behavior); INHERIT is never a pin of the platform sender.
 */
export type EmailSenderSelectionData = {
  __typename?: 'EmailSenderSelectionData';
  /** Gets the approval id of the settings operation that applied the last selection; null for a direct selection. */
  approvalId?: Maybe<Scalars['String']['output']>;
  /** Gets the pinned company sender as approved; null unless the kind is COMPANY. */
  companySender?: Maybe<SelectedCompanySenderData>;
  /** Gets what the approved sender is for. */
  intendedUse: EmailSenderIntendedUse;
  /** Gets which sender is approved: PLATFORM, COMPANY or INHERIT. */
  kind: EmailSenderSelectionKind;
  /** Gets the operation id (receipt key) of the settings operation that applied the last selection; null for a direct selection. */
  operationId?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the selection revision, 0 when no selection was ever approved. Pass it as expectedRevision on the
   * next selectTenantEmailSender call.
   */
  revision: Scalars['Int']['output'];
  /** Gets when the last selection was approved; null when none was. */
  selectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the user who approved the last selection; null when none was or no user was recorded. */
  selectedBy?: Maybe<Scalars['String']['output']>;
};

export enum EmailSenderSelectionKind {
  Company = 'COMPANY',
  Inherit = 'INHERIT',
  Platform = 'PLATFORM',
  Unknown = 'UNKNOWN'
}

export enum EmailSenderVerificationMethod {
  Domain = 'DOMAIN',
  SingleSender = 'SINGLE_SENDER'
}

export type EmailSenderVerificationMethodOperationFilterInput = {
  eq?: InputMaybe<EmailSenderVerificationMethod>;
  in?: InputMaybe<Array<EmailSenderVerificationMethod>>;
  neq?: InputMaybe<EmailSenderVerificationMethod>;
  nin?: InputMaybe<Array<EmailSenderVerificationMethod>>;
};

export enum EmailSenderVerificationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type EmailSenderVerificationStatusOperationFilterInput = {
  eq?: InputMaybe<EmailSenderVerificationStatus>;
  in?: InputMaybe<Array<EmailSenderVerificationStatus>>;
  neq?: InputMaybe<EmailSenderVerificationStatus>;
  nin?: InputMaybe<Array<EmailSenderVerificationStatus>>;
};

/** A connection to a list of items. */
export type EmailSendsConnection = {
  __typename?: 'EmailSendsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailSendsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EmailSendDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailSendsEdge = {
  __typename?: 'EmailSendsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EmailSendDocument;
};

/**
 * The four SendGrid suppression lists clearEmailSuppression can delete an address from, each
 * with its own DELETE endpoint. A recorded delivery dropped reason names the list an address
 * landed on (per the recorded drop-reason to list mapping); dropped itself stays as-is
 * (SendGrid never attempted the send — the reason names the list).
 */
export enum EmailSuppressionListType {
  /** The block suppression list (DELETE /v3/suppression/blocks/{email}) — temporary IP/reputation blocks ("Blocked"). */
  Blocks = 'BLOCKS',
  /** The bounce suppression list (DELETE /v3/suppression/bounces/{email}) — hard bounces ("Bounced Address"). */
  Bounces = 'BOUNCES',
  /** The spam-report suppression list (DELETE /v3/suppression/spam_reports/{email}) — "Spam Reporting Address". */
  SpamReports = 'SPAM_REPORTS',
  /** The global unsubscribe list (DELETE /v3/asm/suppressions/global/{email}) — "Unsubscribed Address". */
  Unsubscribes = 'UNSUBSCRIBES'
}

export type EnableWsapiImportInput = {
  wsapiImportId: Scalars['String']['input'];
};

/**
 * GraphQL input for enqueueErpWriteBack. Primitive/non-Option fields only (HotChocolate input
 * type). The tenant is taken from the authenticated user context, never the input.
 */
export type EnqueueErpWriteBackInput = {
  binCode?: InputMaybe<Scalars['String']['input']>;
  changeReason: Scalars['String']['input'];
  changeType: Scalars['String']['input'];
  countedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  customerReference?: InputMaybe<Scalars['String']['input']>;
  fromBinCode?: InputMaybe<Scalars['String']['input']>;
  fromLocationReference?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  itemReference: Scalars['String']['input'];
  jobReference?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationReference: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Float']['input']>;
  lotReference: Scalars['String']['input'];
  quantityChange: Scalars['Decimal']['input'];
  recordedAt?: InputMaybe<Scalars['DateTime']['input']>;
  routeLocationId?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  unit: Scalars['String']['input'];
  unitQuantityChange?: InputMaybe<Scalars['Decimal']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
  variantReference: Scalars['String']['input'];
  workflow: ErpWriteBackWorkflow;
};

/** Input to the ensure-invoice-pay-link mutation. */
export type EnsureInvoicePayLinkInput = {
  /** The issued invoice to make sure has an active pay link. */
  invoiceId: Scalars['String']['input'];
};

export type EntityCheckpointDocument = {
  __typename?: 'EntityCheckpointDocument';
  entityName: Scalars['String']['output'];
  position?: Maybe<Scalars['Long']['output']>;
  positionString?: Maybe<Scalars['String']['output']>;
};

export type EntityCheckpointDocumentFilterInput = {
  and?: InputMaybe<Array<EntityCheckpointDocumentFilterInput>>;
  entityName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EntityCheckpointDocumentFilterInput>>;
  position?: InputMaybe<LongOperationFilterInput>;
  positionString?: InputMaybe<StringOperationFilterInput>;
};

export type EntityCheckpointDocumentSortInput = {
  entityName?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  positionString?: InputMaybe<SortEnumType>;
};

export type EntityMappingData = {
  __typename?: 'EntityMappingData';
  enabled: Scalars['Boolean']['output'];
  entityMappingId: Scalars['String']['output'];
  entityType: WsapiImportEntityType;
  fieldMappings: Array<FieldMappingData>;
  keySourceField: Scalars['String']['output'];
  keyTargetField: Scalars['String']['output'];
  sourceTable: Scalars['String']['output'];
};

export type EntityMappingDataFilterInput = {
  and?: InputMaybe<Array<EntityMappingDataFilterInput>>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  entityMappingId?: InputMaybe<StringOperationFilterInput>;
  entityType?: InputMaybe<WsapiImportEntityTypeOperationFilterInput>;
  fieldMappings?: InputMaybe<ListFilterInputTypeOfFieldMappingDataFilterInput>;
  keySourceField?: InputMaybe<StringOperationFilterInput>;
  keyTargetField?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EntityMappingDataFilterInput>>;
  sourceTable?: InputMaybe<StringOperationFilterInput>;
};

export enum EntityType {
  ClickUpTimeAggregation = 'CLICK_UP_TIME_AGGREGATION',
  ConfirmationEmail = 'CONFIRMATION_EMAIL',
  Customer = 'CUSTOMER',
  CustomerCleaner = 'CUSTOMER_CLEANER',
  DbrCalcDemandQuantity = 'DBR_CALC_DEMAND_QUANTITY',
  DbrCalcScheduler = 'DBR_CALC_SCHEDULER',
  GrowPointCategoryImport = 'GROW_POINT_CATEGORY_IMPORT',
  GrowPointCategoryValidate = 'GROW_POINT_CATEGORY_VALIDATE',
  GrowPointCustomerExtract = 'GROW_POINT_CUSTOMER_EXTRACT',
  GrowPointCustomerImport = 'GROW_POINT_CUSTOMER_IMPORT',
  GrowPointCustomerValidate = 'GROW_POINT_CUSTOMER_VALIDATE',
  GrowPointHistoricalOrderImport = 'GROW_POINT_HISTORICAL_ORDER_IMPORT',
  GrowPointHistoricalOrderValidate = 'GROW_POINT_HISTORICAL_ORDER_VALIDATE',
  GrowPointImport = 'GROW_POINT_IMPORT',
  GrowPointInventoryImport = 'GROW_POINT_INVENTORY_IMPORT',
  GrowPointInventoryValidate = 'GROW_POINT_INVENTORY_VALIDATE',
  GrowPointItemExtract = 'GROW_POINT_ITEM_EXTRACT',
  GrowPointItemImport = 'GROW_POINT_ITEM_IMPORT',
  GrowPointPriceImport = 'GROW_POINT_PRICE_IMPORT',
  GrowPointPriceValidate = 'GROW_POINT_PRICE_VALIDATE',
  GrowPointSiteLocationImport = 'GROW_POINT_SITE_LOCATION_IMPORT',
  GrowPointSiteLocationValidate = 'GROW_POINT_SITE_LOCATION_VALIDATE',
  GrowPointTaxAuthorityImport = 'GROW_POINT_TAX_AUTHORITY_IMPORT',
  GrowPointTaxAuthorityValidate = 'GROW_POINT_TAX_AUTHORITY_VALIDATE',
  GrowPointTermsImport = 'GROW_POINT_TERMS_IMPORT',
  GrowPointTermsValidate = 'GROW_POINT_TERMS_VALIDATE',
  Item = 'ITEM',
  ItemCleaner = 'ITEM_CLEANER',
  ItemPricing = 'ITEM_PRICING',
  IterationFailureEmail = 'ITERATION_FAILURE_EMAIL',
  Job = 'JOB',
  Location = 'LOCATION',
  MergeDevImport = 'MERGE_DEV_IMPORT',
  OnHandProcessing = 'ON_HAND_PROCESSING',
  OnHandQueuing = 'ON_HAND_QUEUING',
  Order = 'ORDER',
  QuickBooks = 'QUICK_BOOKS',
  /**
   * The Restock 2.0 ROS pre-calculation iteration written per-tenant by the
   * RestockPreCalculation background service (wsapi-services). Read by the
   * adminRestockDataValidity precalc.lastrun check; the stored Entity string is
   * "RestockPreCalculation".
   */
  RestockPreCalculation = 'RESTOCK_PRE_CALCULATION',
  SalesPeople = 'SALES_PEOPLE',
  SftpSynchronization = 'SFTP_SYNCHRONIZATION',
  StationManager = 'STATION_MANAGER',
  TransferLine = 'TRANSFER_LINE',
  Unknown = 'UNKNOWN',
  WalmartOpdZero = 'WALMART_OPD_ZERO'
}

export type EntityTypeOperationFilterInput = {
  eq?: InputMaybe<EntityType>;
  in?: InputMaybe<Array<EntityType>>;
  neq?: InputMaybe<EntityType>;
  nin?: InputMaybe<Array<EntityType>>;
};

/** The result of erpAccessDarkRunDiff. */
export type ErpAccessDarkRunDiffResult = {
  __typename?: 'ErpAccessDarkRunDiffResult';
  /** The calendar date the ERP rows were judged on. */
  asOfDate: Scalars['LocalDate']['output'];
  /** Whether rows exist beyond this page. */
  hasMore: Scalars['Boolean']['output'];
  /** Everyone who loses at least one ship-to, most ship-tos first. */
  peopleLosingAccess: Array<ErpAccessDarkRunPerson>;
  /** The requested page of ship-to rows, ordered by the ship-to document id. */
  rows: Array<ErpAccessDarkRunShipTo>;
  /** How many rows the paging runs over (all ship-tos, or only changed ones). */
  rowsMatching: Scalars['Int']['output'];
  /** Rows skipped before this page. */
  skip: Scalars['Int']['output'];
  /** The page size asked for. */
  take: Scalars['Int']['output'];
  /** The tenant compared. */
  tenantId: Scalars['String']['output'];
  /** Counts over every ship-to. */
  totals: ErpAccessDarkRunTotals;
};

/** One person who would lose access to at least one ship-to. */
export type ErpAccessDarkRunPerson = {
  __typename?: 'ErpAccessDarkRunPerson';
  /** The person's email, trimmed and lower-cased. */
  email: Scalars['String']['output'];
  /** How many ship-tos they would lose. */
  shipTosLost: Scalars['Int']['output'];
};

/** One ship-to of the dark-run comparison: who has access today and who the ERP would grant. */
export type ErpAccessDarkRunShipTo = {
  __typename?: 'ErpAccessDarkRunShipTo';
  /** In derived and not in current. */
  added: Array<Scalars['String']['output']>;
  /** The ship-to code. */
  code: Scalars['String']['output'];
  /**
   * LocationsSalesPerson.SalesPersonEmails as stored today, trimmed, lower-cased and de-duplicated, with
   * blank entries removed.
   */
  current: Array<Scalars['String']['output']>;
  /** The customer's ERP id. */
  customerErpId: Scalars['String']['output'];
  /** The customer that owns the ship-to. */
  customerId: Scalars['String']['output'];
  /** access(S, asOfDate) from the ERP read models, in the same form. */
  derived: Array<Scalars['String']['output']>;
  /** In current and not in derived. */
  dropped: Array<Scalars['String']['output']>;
  /** The ship-to's location id. */
  locationId: Scalars['UUID']['output'];
  /** The ship-to name. */
  name: Scalars['String']['output'];
};

/** The counts over every ship-to of the comparison, whatever page of rows was asked for. */
export type ErpAccessDarkRunTotals = {
  __typename?: 'ErpAccessDarkRunTotals';
  /** Blank entries of the stored lists, left out of the comparison. */
  blankCurrentEmailsExcluded: Scalars['Int']['output'];
  /** Ship-tos of combined customers, which the customer picker hides. */
  combinedShipTosExcluded: Scalars['Int']['output'];
  /** Ship-tos compared; combined customers' hidden ship-tos are not among them. */
  shipTosCompared: Scalars['Int']['output'];
  /** Ship-tos whose current and derived sets are the same. */
  unchanged: Scalars['Int']['output'];
  /** Ship-tos where at least one person would gain access. */
  withAdds: Scalars['Int']['output'];
  /** Ship-tos where the ERP names at least one person on the date. */
  withDerivedAccess: Scalars['Int']['output'];
  /** Ship-tos where at least one person would lose access. */
  withDrops: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type ErpAvailabilityConnection = {
  __typename?: 'ErpAvailabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpAvailabilityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpAvailabilityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ErpAvailabilityDocument = {
  __typename?: 'ErpAvailabilityDocument';
  id: Scalars['String']['output'];
  itemNo: Scalars['String']['output'];
  mustGoQty: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  stationCode: Scalars['String']['output'];
  syncDateTime: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
};

export type ErpAvailabilityDocumentFilterInput = {
  and?: InputMaybe<Array<ErpAvailabilityDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemNo?: InputMaybe<StringOperationFilterInput>;
  mustGoQty?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ErpAvailabilityDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  syncDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type ErpAvailabilityDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  itemNo?: InputMaybe<SortEnumType>;
  mustGoQty?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  syncDateTime?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type ErpAvailabilityEdge = {
  __typename?: 'ErpAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpAvailabilityDocument;
};

export type ErpAvailabilityItem = {
  __typename?: 'ErpAvailabilityItem';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  erpItemId: Scalars['String']['output'];
  inTransitQty: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  mustGoQty: Scalars['Int']['output'];
  productGroup: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  stationCode: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ErpAvailabilityRefreshItem = {
  __typename?: 'ErpAvailabilityRefreshItem';
  erpItemId: Scalars['String']['output'];
  inTransitQty: Scalars['Int']['output'];
  mustGoQty: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  stationCode: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ErpItemPriceData = {
  __typename?: 'ErpItemPriceData';
  containerQuantity: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  erpItemId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  unitPrice: Scalars['Decimal']['output'];
};

export type ErpItemPricingDocument = {
  __typename?: 'ErpItemPricingDocument';
  containerQuantity: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  erpItemId: Scalars['String']['output'];
  erpItemPricingId: Scalars['String']['output'];
  erpPriceGroupId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  unitPrice: Scalars['Decimal']['output'];
};

export type ErpItemPricingDocumentFilterInput = {
  and?: InputMaybe<Array<ErpItemPricingDocumentFilterInput>>;
  containerQuantity?: InputMaybe<IntOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  erpItemId?: InputMaybe<StringOperationFilterInput>;
  erpItemPricingId?: InputMaybe<StringOperationFilterInput>;
  erpPriceGroupId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpItemPricingDocumentFilterInput>>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  unitPrice?: InputMaybe<DecimalOperationFilterInput>;
};

export type ErpItemPricingDocumentSortInput = {
  containerQuantity?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  erpItemId?: InputMaybe<SortEnumType>;
  erpItemPricingId?: InputMaybe<SortEnumType>;
  erpPriceGroupId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  unitPrice?: InputMaybe<SortEnumType>;
};

export type ErpItemPricingPayload = {
  __typename?: 'ErpItemPricingPayload';
  erpItemPrice?: Maybe<ErpItemPricingStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ErpItemPricingStateData = {
  __typename?: 'ErpItemPricingStateData';
  erpPriceGroupId: Scalars['String']['output'];
  itemPrices: Array<ErpItemPriceData>;
  startYear: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ErpLoadListAvailabilityConnection = {
  __typename?: 'ErpLoadListAvailabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpLoadListAvailabilityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpLoadListAvailabilityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ErpLoadListAvailabilityDocument = {
  __typename?: 'ErpLoadListAvailabilityDocument';
  allocatedQuantity: Scalars['Int']['output'];
  availableQuantity: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  erpItemId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inTransitQuantity: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  mustGoQuantity: Scalars['Int']['output'];
  productGroup: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  stationCode: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ErpLoadListAvailabilityDocumentFilterInput = {
  allocatedQuantity?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<ErpLoadListAvailabilityDocumentFilterInput>>;
  availableQuantity?: InputMaybe<IntOperationFilterInput>;
  category?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  erpItemId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inTransitQuantity?: InputMaybe<IntOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  mustGoQuantity?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ErpLoadListAvailabilityDocumentFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListAvailabilityDocumentSortInput = {
  allocatedQuantity?: InputMaybe<SortEnumType>;
  availableQuantity?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  erpItemId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inTransitQuantity?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  mustGoQuantity?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type ErpLoadListAvailabilityEdge = {
  __typename?: 'ErpLoadListAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpLoadListAvailabilityDocument;
};

export type ErpLoadListItemData = {
  __typename?: 'ErpLoadListItemData';
  allocatedQuantity: Scalars['Int']['output'];
  availableQuantity: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  erpItemId: Scalars['String']['output'];
  inTransitQuantity: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  mustGoQuantity: Scalars['Int']['output'];
  productGroup: Scalars['String']['output'];
  stationCode: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ErpLoadListQuantitiesConnection = {
  __typename?: 'ErpLoadListQuantitiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpLoadListQuantitiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpLoadListQuantitiesDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ErpLoadListQuantitiesDocument = {
  __typename?: 'ErpLoadListQuantitiesDocument';
  containerCode: Scalars['String']['output'];
  containerUtilization: Scalars['Decimal']['output'];
  erpItemId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  routeCode: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ErpLoadListQuantitiesDocumentFilterInput = {
  and?: InputMaybe<Array<ErpLoadListQuantitiesDocumentFilterInput>>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  containerUtilization?: InputMaybe<DecimalOperationFilterInput>;
  erpItemId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpLoadListQuantitiesDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  routeCode?: InputMaybe<StringOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListQuantitiesDocumentSortInput = {
  containerCode?: InputMaybe<SortEnumType>;
  containerUtilization?: InputMaybe<SortEnumType>;
  erpItemId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  routeCode?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type ErpLoadListQuantitiesEdge = {
  __typename?: 'ErpLoadListQuantitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpLoadListQuantitiesDocument;
};

export type ErpLoadListQuantityData = {
  __typename?: 'ErpLoadListQuantityData';
  containerCode: Scalars['String']['output'];
  containerUtilization: Scalars['Decimal']['output'];
  erpItemId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  routeCode: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ErpLoadListRouteData = {
  __typename?: 'ErpLoadListRouteData';
  routeCode: Scalars['String']['output'];
};

export type ErpLoadListRouteDataFilterInput = {
  and?: InputMaybe<Array<ErpLoadListRouteDataFilterInput>>;
  or?: InputMaybe<Array<ErpLoadListRouteDataFilterInput>>;
  routeCode?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListRouteDocument = {
  __typename?: 'ErpLoadListRouteDocument';
  id: Scalars['String']['output'];
  routeCode: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type ErpLoadListRouteDocumentFilterInput = {
  and?: InputMaybe<Array<ErpLoadListRouteDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpLoadListRouteDocumentFilterInput>>;
  routeCode?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListRouteDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  routeCode?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ErpLoadListRoutesConnection = {
  __typename?: 'ErpLoadListRoutesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpLoadListRoutesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpLoadListRouteDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ErpLoadListRoutesEdge = {
  __typename?: 'ErpLoadListRoutesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpLoadListRouteDocument;
};

export type ErpLoadListRoutesPayload = {
  __typename?: 'ErpLoadListRoutesPayload';
  errors?: Maybe<Array<ValidationError>>;
  routesReplaced: Scalars['Int']['output'];
};

export type ErpLoadListSessionDocument = {
  __typename?: 'ErpLoadListSessionDocument';
  availabilityUpdatedAt: Scalars['DateTime']['output'];
  availabilityUpdatedBy: Scalars['String']['output'];
  containerCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  routes: Array<ErpLoadListRouteData>;
  sessionId: Scalars['String']['output'];
  sessionName: Scalars['String']['output'];
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  stationCode: Scalars['String']['output'];
  status: ErpLoadListSessionStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ErpLoadListSessionDocumentFilterInput = {
  and?: InputMaybe<Array<ErpLoadListSessionDocumentFilterInput>>;
  availabilityUpdatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  availabilityUpdatedBy?: InputMaybe<StringOperationFilterInput>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpLoadListSessionDocumentFilterInput>>;
  routes?: InputMaybe<ListFilterInputTypeOfErpLoadListRouteDataFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  sessionName?: InputMaybe<StringOperationFilterInput>;
  shipDate?: InputMaybe<DateTimeOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ErpLoadListSessionStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListSessionDocumentSortInput = {
  availabilityUpdatedAt?: InputMaybe<SortEnumType>;
  availabilityUpdatedBy?: InputMaybe<SortEnumType>;
  containerCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  sessionName?: InputMaybe<SortEnumType>;
  shipDate?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ErpLoadListSessionPayload = {
  __typename?: 'ErpLoadListSessionPayload';
  erpLoadListSession?: Maybe<ErpLoadListSessionStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ErpLoadListSessionStateData = {
  __typename?: 'ErpLoadListSessionStateData';
  containerCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  items: Array<ErpLoadListItemData>;
  quantities: Array<ErpLoadListQuantityData>;
  routes: Array<ErpLoadListRouteData>;
  sessionId: Scalars['String']['output'];
  sessionName: Scalars['String']['output'];
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  stationCode: Scalars['String']['output'];
  status: ErpLoadListSessionStatus;
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum ErpLoadListSessionStatus {
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
  InProgress = 'IN_PROGRESS',
  Processed = 'PROCESSED',
  Submitted = 'SUBMITTED'
}

export type ErpLoadListSessionStatusOperationFilterInput = {
  eq?: InputMaybe<ErpLoadListSessionStatus>;
  in?: InputMaybe<Array<ErpLoadListSessionStatus>>;
  neq?: InputMaybe<ErpLoadListSessionStatus>;
  nin?: InputMaybe<Array<ErpLoadListSessionStatus>>;
};

/** A connection to a list of items. */
export type ErpLoadListSessionsConnection = {
  __typename?: 'ErpLoadListSessionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpLoadListSessionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpLoadListSessionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ErpLoadListSessionsEdge = {
  __typename?: 'ErpLoadListSessionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpLoadListSessionDocument;
};

export type ErpLoadListUserDocument = {
  __typename?: 'ErpLoadListUserDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  email: Scalars['String']['output'];
  erpLoadListUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  site: Scalars['String']['output'];
  status: ErpLoadListUserStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ErpLoadListUserDocumentFilterInput = {
  and?: InputMaybe<Array<ErpLoadListUserDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  erpLoadListUserId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpLoadListUserDocumentFilterInput>>;
  site?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ErpLoadListUserStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ErpLoadListUserDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  erpLoadListUserId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ErpLoadListUserPayload = {
  __typename?: 'ErpLoadListUserPayload';
  erpLoadListUser?: Maybe<ErpLoadListUserStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ErpLoadListUserStateData = {
  __typename?: 'ErpLoadListUserStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  email: Scalars['String']['output'];
  erpLoadListUserId: Scalars['String']['output'];
  sites: Array<Scalars['String']['output']>;
  status: ErpLoadListUserStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ErpLoadListUserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Unknown = 'UNKNOWN'
}

export type ErpLoadListUserStatusOperationFilterInput = {
  eq?: InputMaybe<ErpLoadListUserStatus>;
  in?: InputMaybe<Array<ErpLoadListUserStatus>>;
  neq?: InputMaybe<ErpLoadListUserStatus>;
  nin?: InputMaybe<Array<ErpLoadListUserStatus>>;
};

/** A connection to a list of items. */
export type ErpLoadListUsersConnection = {
  __typename?: 'ErpLoadListUsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpLoadListUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpLoadListUserDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ErpLoadListUsersEdge = {
  __typename?: 'ErpLoadListUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpLoadListUserDocument;
};

export type ErpLotDataInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  firstRecordedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  quantity: Scalars['Decimal']['input'];
};

export type ErpManagerEmailData = {
  __typename?: 'ErpManagerEmailData';
  email: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type ErpManagerEmailDataInput = {
  email: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type ErpManagerEmailsPayload = {
  __typename?: 'ErpManagerEmailsPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<ErpManagerEmailsStateData>;
};

export type ErpManagerEmailsStateData = {
  __typename?: 'ErpManagerEmailsStateData';
  emails: Array<ErpManagerEmailData>;
  tenantId: Scalars['String']['output'];
};

/**
 * wsapi read-side document for a single open material order (PO / inbound transfer order) carrying at
 * least one item-bearing line at its receiving station. This is the read shape the
 * inventory PWA's Material receiving workflow reads — the parity replacement for inventory-api's
 * Material order-line queries.
 *
 * Worker-owned, Nav-sourced. The ErpOrders collection is written by the wsapi-services
 * ErpOrderSync worker (Nav upsert + strict-cutoff sweep). The field set is a CONTRACT defined
 * by that worker's ErpOrderDocument; this type mirrors it for the GraphQL read side. Work
 * Suite never writes it: a line's OutstandingQuantity is always NAV's value, and the quantity
 * a crew can still receive on each line is in the order's receiptStatus.
 *
 *
 * Two-tier item resolution — no silent line drops. Every item-bearing Nav line is retained in
 * Lines. A line's ItemId is the canonical wsapi ItemId
 * when the Nav item resolves to a finished good present in ItemSummary; otherwise it passes through
 * the raw Nav item number unchanged (material items, and any item the worker cannot resolve to a
 * wsapi id) as an audit passthrough — NAV write-back and validation always key on
 * ErpItemNo, never on ItemId. Only an order with NO item-bearing
 * line at all is excluded from this collection, routed instead to the side
 * ErpOrdersUnresolved collection with reason NoItemBearingLines.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain — no
 * InventoryEvents, no InventoryItems/RestockAvailability writes.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — never a mutation input — so optional fields use
 * plain T? / empty strings (the worker writes Option<T>.None as BSON null, which
 * the default serializer reads back as null), never Option<T>, which would leak as a
 * broken OptionOf{X}FilterInput. [BsonIgnoreExtraElements] keeps the read tolerant of
 * worker-side additive fields.
 */
export type ErpOrderDocument = {
  __typename?: 'ErpOrderDocument';
  /** Free-text order description (Nav posting description, or a sensible default). */
  description: Scalars['String']['output'];
  /** Nav expected/receipt date when present; null otherwise. */
  expectedReceiptDate?: Maybe<Scalars['DateTime']['output']>;
  /** Inbound transfer-order source station (Transfer-from Code); null for POs. */
  fromLocationCode?: Maybe<Scalars['String']['output']>;
  /** Composite document id — {TenantId}-{OrderType}-{OrderNumber}. Route through GetDocumentId. */
  id: Scalars['String']['output'];
  /** The outstanding lines on this order. Every item-bearing Nav line is retained (see class summary). */
  lines: Array<ErpOrderLine>;
  /** Canonical wsapi SiteLocationId of the receiving station, resolved by the import worker. */
  locationId: Scalars['String']['output'];
  /** Nav order date when present; null otherwise. */
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  /** Nav order number — [Document No_] for POs, [No_] for transfer orders. */
  orderNumber: Scalars['String']['output'];
  /** Whether this is a purchase order or an inbound transfer order. */
  orderType: ErpOrderType;
  /**
   * One entry per line of this order, in line order: the quantity that can still be received on the
   * line, and whether NAV's view of it may not yet show a receipt made in Work Suite. Empty for an
   * order with no lines. Read only: neither value refuses or holds a receipt.
   */
  receiptStatus: Array<ErpOrderLineReceiptStatus>;
  /** Raw Nav station code (PO Location Code / TO Transfer-to Code). */
  stationCode: Scalars['String']['output'];
  /** UTC instant the order was last refreshed by an import iteration. Drives the worker's sweep. */
  syncDateTime: Scalars['DateTime']['output'];
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** Purchase-order vendor (Buy-from Vendor No_); null for transfer orders. */
  vendorNo?: Maybe<Scalars['String']['output']>;
};

/**
 * wsapi read-side document for a single open material order (PO / inbound transfer order) carrying at
 * least one item-bearing line at its receiving station. This is the read shape the
 * inventory PWA's Material receiving workflow reads — the parity replacement for inventory-api's
 * Material order-line queries.
 *
 * Worker-owned, Nav-sourced. The ErpOrders collection is written by the wsapi-services
 * ErpOrderSync worker (Nav upsert + strict-cutoff sweep). The field set is a CONTRACT defined
 * by that worker's ErpOrderDocument; this type mirrors it for the GraphQL read side. Work
 * Suite never writes it: a line's OutstandingQuantity is always NAV's value, and the quantity
 * a crew can still receive on each line is in the order's receiptStatus.
 *
 *
 * Two-tier item resolution — no silent line drops. Every item-bearing Nav line is retained in
 * Lines. A line's ItemId is the canonical wsapi ItemId
 * when the Nav item resolves to a finished good present in ItemSummary; otherwise it passes through
 * the raw Nav item number unchanged (material items, and any item the worker cannot resolve to a
 * wsapi id) as an audit passthrough — NAV write-back and validation always key on
 * ErpItemNo, never on ItemId. Only an order with NO item-bearing
 * line at all is excluded from this collection, routed instead to the side
 * ErpOrdersUnresolved collection with reason NoItemBearingLines.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain — no
 * InventoryEvents, no InventoryItems/RestockAvailability writes.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — never a mutation input — so optional fields use
 * plain T? / empty strings (the worker writes Option<T>.None as BSON null, which
 * the default serializer reads back as null), never Option<T>, which would leak as a
 * broken OptionOf{X}FilterInput. [BsonIgnoreExtraElements] keeps the read tolerant of
 * worker-side additive fields.
 */
export type ErpOrderDocumentFilterInput = {
  and?: InputMaybe<Array<ErpOrderDocumentFilterInput>>;
  /** Free-text order description (Nav posting description, or a sensible default). */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Nav expected/receipt date when present; null otherwise. */
  expectedReceiptDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Inbound transfer-order source station (Transfer-from Code); null for POs. */
  fromLocationCode?: InputMaybe<StringOperationFilterInput>;
  /** Composite document id — {TenantId}-{OrderType}-{OrderNumber}. Route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** The outstanding lines on this order. Every item-bearing Nav line is retained (see class summary). */
  lines?: InputMaybe<ListFilterInputTypeOfErpOrderLineFilterInput>;
  /** Canonical wsapi SiteLocationId of the receiving station, resolved by the import worker. */
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpOrderDocumentFilterInput>>;
  /** Nav order date when present; null otherwise. */
  orderDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Nav order number — [Document No_] for POs, [No_] for transfer orders. */
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  /** Whether this is a purchase order or an inbound transfer order. */
  orderType?: InputMaybe<ErpOrderTypeOperationFilterInput>;
  /** Raw Nav station code (PO Location Code / TO Transfer-to Code). */
  stationCode?: InputMaybe<StringOperationFilterInput>;
  /** UTC instant the order was last refreshed by an import iteration. Drives the worker's sweep. */
  syncDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Purchase-order vendor (Buy-from Vendor No_); null for transfer orders. */
  vendorNo?: InputMaybe<StringOperationFilterInput>;
};

/**
 * wsapi read-side document for a single open material order (PO / inbound transfer order) carrying at
 * least one item-bearing line at its receiving station. This is the read shape the
 * inventory PWA's Material receiving workflow reads — the parity replacement for inventory-api's
 * Material order-line queries.
 *
 * Worker-owned, Nav-sourced. The ErpOrders collection is written by the wsapi-services
 * ErpOrderSync worker (Nav upsert + strict-cutoff sweep). The field set is a CONTRACT defined
 * by that worker's ErpOrderDocument; this type mirrors it for the GraphQL read side. Work
 * Suite never writes it: a line's OutstandingQuantity is always NAV's value, and the quantity
 * a crew can still receive on each line is in the order's receiptStatus.
 *
 *
 * Two-tier item resolution — no silent line drops. Every item-bearing Nav line is retained in
 * Lines. A line's ItemId is the canonical wsapi ItemId
 * when the Nav item resolves to a finished good present in ItemSummary; otherwise it passes through
 * the raw Nav item number unchanged (material items, and any item the worker cannot resolve to a
 * wsapi id) as an audit passthrough — NAV write-back and validation always key on
 * ErpItemNo, never on ItemId. Only an order with NO item-bearing
 * line at all is excluded from this collection, routed instead to the side
 * ErpOrdersUnresolved collection with reason NoItemBearingLines.
 *
 *
 * This domain is deliberately ISOLATED from the shared InventoryItem domain — no
 * InventoryEvents, no InventoryItems/RestockAvailability writes.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — never a mutation input — so optional fields use
 * plain T? / empty strings (the worker writes Option<T>.None as BSON null, which
 * the default serializer reads back as null), never Option<T>, which would leak as a
 * broken OptionOf{X}FilterInput. [BsonIgnoreExtraElements] keeps the read tolerant of
 * worker-side additive fields.
 */
export type ErpOrderDocumentSortInput = {
  /** Free-text order description (Nav posting description, or a sensible default). */
  description?: InputMaybe<SortEnumType>;
  /** Nav expected/receipt date when present; null otherwise. */
  expectedReceiptDate?: InputMaybe<SortEnumType>;
  /** Inbound transfer-order source station (Transfer-from Code); null for POs. */
  fromLocationCode?: InputMaybe<SortEnumType>;
  /** Composite document id — {TenantId}-{OrderType}-{OrderNumber}. Route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /** Canonical wsapi SiteLocationId of the receiving station, resolved by the import worker. */
  locationId?: InputMaybe<SortEnumType>;
  /** Nav order date when present; null otherwise. */
  orderDate?: InputMaybe<SortEnumType>;
  /** Nav order number — [Document No_] for POs, [No_] for transfer orders. */
  orderNumber?: InputMaybe<SortEnumType>;
  /** Whether this is a purchase order or an inbound transfer order. */
  orderType?: InputMaybe<SortEnumType>;
  /** Raw Nav station code (PO Location Code / TO Transfer-to Code). */
  stationCode?: InputMaybe<SortEnumType>;
  /** UTC instant the order was last refreshed by an import iteration. Drives the worker's sweep. */
  syncDateTime?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Purchase-order vendor (Buy-from Vendor No_); null for transfer orders. */
  vendorNo?: InputMaybe<SortEnumType>;
};

/**
 * One outstanding line on an ErpOrderDocument — the wsapi read-side mirror of the
 * worker's ErpOrderLine. Every item-bearing Nav line is embedded, whether or not its ERP item
 * resolves to a canonical wsapi ItemId (see ItemId and the two-tier resolution
 * note on ErpOrderDocument). Query OUTPUT only — optional fields use plain T?.
 */
export type ErpOrderLine = {
  __typename?: 'ErpOrderLine';
  /** Receiving bin code when present (PO bin / transfer-to bin); null otherwise. */
  binCode?: Maybe<Scalars['String']['output']>;
  /** Line description from Nav. */
  description: Scalars['String']['output'];
  /** Raw Nav item number. */
  erpItemNo: Scalars['String']['output'];
  /**
   * True when NAV marks the line's item organic. A receipt of an organic line needs a vendor lot
   * number. False until the order sync writes it.
   */
  isOrganic: Scalars['Boolean']['output'];
  /**
   * The canonical wsapi ItemId when ErpItemNo resolves to a finished good
   * present in ItemSummary; otherwise the raw Nav item number is passed through unchanged (material
   * items, and any item the worker cannot resolve to a wsapi id) — an audit passthrough only. NAV
   * write-back and validation always key on ErpItemNo, never on this field.
   */
  itemId: Scalars['String']['output'];
  /** Nav Line No_ — unique within the order. */
  lineNo: Scalars['Int']['output'];
  /**
   * Outstanding quantity still to be received against this line, as NAV held it at the last order
   * sync. A receipt never changes it.
   */
  outstandingQuantity: Scalars['Decimal']['output'];
  /** Nav unit-of-measure code when present; null otherwise. */
  unitOfMeasureCode?: Maybe<Scalars['String']['output']>;
  /** Nav variant code when present; null otherwise. */
  variantCode?: Maybe<Scalars['String']['output']>;
  /** Vendor lot number when present (transfer lines carry Lot No_); null otherwise. */
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * One outstanding line on an ErpOrderDocument — the wsapi read-side mirror of the
 * worker's ErpOrderLine. Every item-bearing Nav line is embedded, whether or not its ERP item
 * resolves to a canonical wsapi ItemId (see ItemId and the two-tier resolution
 * note on ErpOrderDocument). Query OUTPUT only — optional fields use plain T?.
 */
export type ErpOrderLineFilterInput = {
  and?: InputMaybe<Array<ErpOrderLineFilterInput>>;
  /** Receiving bin code when present (PO bin / transfer-to bin); null otherwise. */
  binCode?: InputMaybe<StringOperationFilterInput>;
  /** Line description from Nav. */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Raw Nav item number. */
  erpItemNo?: InputMaybe<StringOperationFilterInput>;
  /**
   * True when NAV marks the line's item organic. A receipt of an organic line needs a vendor lot
   * number. False until the order sync writes it.
   */
  isOrganic?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The canonical wsapi ItemId when ErpItemNo resolves to a finished good
   * present in ItemSummary; otherwise the raw Nav item number is passed through unchanged (material
   * items, and any item the worker cannot resolve to a wsapi id) — an audit passthrough only. NAV
   * write-back and validation always key on ErpItemNo, never on this field.
   */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** Nav Line No_ — unique within the order. */
  lineNo?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ErpOrderLineFilterInput>>;
  /**
   * Outstanding quantity still to be received against this line, as NAV held it at the last order
   * sync. A receipt never changes it.
   */
  outstandingQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Nav unit-of-measure code when present; null otherwise. */
  unitOfMeasureCode?: InputMaybe<StringOperationFilterInput>;
  /** Nav variant code when present; null otherwise. */
  variantCode?: InputMaybe<StringOperationFilterInput>;
  /** Vendor lot number when present (transfer lines carry Lot No_); null otherwise. */
  vendorLotNumber?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Where one line of an open material order stands for receiving: the quantity that can still be
 * received, and whether NAV's view of the line may not yet show a receipt already made in Work Suite.
 * Read only; neither value refuses or holds a receipt.
 */
export type ErpOrderLineReceiptStatus = {
  __typename?: 'ErpOrderLineReceiptStatus';
  /** The Nav line number, the same as lineNo on the order's line. */
  lineNo: Scalars['Int']['output'];
  /**
   * True while NAV may not yet show a receipt of this line: a worker is posting it, it is waiting for
   * review, or it was posted after NAV's last read of the order.
   */
  navUpdatePending: Scalars['Boolean']['output'];
  /**
   * The quantity that can still be received on this line: NAV's outstanding quantity less every Work
   * Suite receipt of the line that NAV does not hold and no worker is posting yet. Below zero when
   * such receipts add up to more than NAV still shows outstanding.
   */
  receivableQuantity: Scalars['Decimal']['output'];
};

/**
 * Type of imported inbound order — the wsapi read-side mirror of the worker's ErpOrderType.
 * Persisted as a BSON string so the material-order GraphQL layer (and operators) can filter on the
 * value directly. Outbound (ship) transfer orders are deliberately NOT a member — they are a dead
 * workflow the import worker never imports.
 */
export enum ErpOrderType {
  /** An inbound Nav transfer order — shipped but not yet completely received at this station. */
  InboundTransferOrder = 'INBOUND_TRANSFER_ORDER',
  /** An open Nav purchase order. */
  PurchaseOrder = 'PURCHASE_ORDER'
}

export type ErpOrderTypeOperationFilterInput = {
  eq?: InputMaybe<ErpOrderType>;
  in?: InputMaybe<Array<ErpOrderType>>;
  neq?: InputMaybe<ErpOrderType>;
  nin?: InputMaybe<Array<ErpOrderType>>;
};

export type ErpRouteAssignmentData = {
  __typename?: 'ErpRouteAssignmentData';
  b1Id: Scalars['String']['output'];
  endingDate: Scalars['LocalDate']['output'];
  isDeleted: Scalars['Boolean']['output'];
  routeCode: Scalars['String']['output'];
  seasonCode: Scalars['String']['output'];
  startingDate: Scalars['LocalDate']['output'];
  stationCode: Scalars['String']['output'];
};

/** One Bonnie One customerRouteAssignments row, copied as the ERP holds it. */
export type ErpRouteAssignmentInput = {
  /** Bonnie One's customerRouteAssignmentId: the row's identity. */
  b1Id: Scalars['String']['input'];
  /** The last day the assignment applies (inclusive). Must not be before startingDate. */
  endingDate: Scalars['LocalDate']['input'];
  /** True when Bonnie One marks the row deleted. The row is kept. */
  isDeleted: Scalars['Boolean']['input'];
  /** The route code in Bonnie One's hyphen form, e.g. 010-0000. */
  routeCode: Scalars['String']['input'];
  /** The season the row was issued for, e.g. S26. Send an empty string when there is none. */
  seasonCode: Scalars['String']['input'];
  /** The first day the assignment applies (inclusive). */
  startingDate: Scalars['LocalDate']['input'];
  /** The station the route belongs to, e.g. 010. */
  stationCode: Scalars['String']['input'];
};

/** The result of setErpRouteSalespeople: the route as stored, or the errors that refused the set. */
export type ErpRoutePayload = {
  __typename?: 'ErpRoutePayload';
  erpRoute?: Maybe<ErpRouteStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A Bonnie One route mirrored into WorkSuite, with every salesperson row the ERP assigns to it. */
export type ErpRouteStateData = {
  __typename?: 'ErpRouteStateData';
  /** The route's name; empty when Bonnie One carries none. */
  name: Scalars['String']['output'];
  /** The route code in Bonnie One's hyphen form, e.g. 010-0000. */
  routeCode: Scalars['String']['output'];
  /** Every salesperson row for the route, deleted rows included, ordered by B1 id. */
  salespersonAssignments: Array<ErpSalespersonAssignmentData>;
  /** The station the route belongs to, e.g. 010. */
  stationCode: Scalars['String']['output'];
  /** The tenant the route belongs to. */
  tenantId: Scalars['String']['output'];
};

export type ErpSalespersonAssignmentData = {
  __typename?: 'ErpSalespersonAssignmentData';
  b1Id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  endingDate: Scalars['LocalDate']['output'];
  isDeleted: Scalars['Boolean']['output'];
  salespersonCode: Scalars['String']['output'];
  seasonCode: Scalars['String']['output'];
  startingDate: Scalars['LocalDate']['output'];
};

/** One Bonnie One salespersonRouteAssignments row, copied as the ERP holds it. */
export type ErpSalespersonAssignmentInput = {
  /** Bonnie One's salespersonRouteAssignmentId: the row's identity. */
  b1Id: Scalars['String']['input'];
  /** The salesperson's email address. Stored lower-case. */
  email: Scalars['String']['input'];
  /** The last day the assignment applies (inclusive). Must not be before startingDate. */
  endingDate: Scalars['LocalDate']['input'];
  /** True when Bonnie One marks the row deleted. The row is kept. */
  isDeleted: Scalars['Boolean']['input'];
  /** Bonnie One's code for the salesperson. Send an empty string when there is none. */
  salespersonCode: Scalars['String']['input'];
  /** The season the row was issued for, e.g. S26. Send an empty string when there is none. */
  seasonCode: Scalars['String']['input'];
  /** The first day the assignment applies (inclusive). */
  startingDate: Scalars['LocalDate']['input'];
};

/**
 * Payload for the worker batch-claim mutations (claimPending / claimPosted) — the set of records this worker
 * leased in the call. An empty list means there was no work to lease for the workflow/tenant.
 */
export type ErpWriteBackClaimPayload = {
  __typename?: 'ErpWriteBackClaimPayload';
  claimedRecords: Array<ErpWriteBackDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * MongoDB document for a single durable ERP write-back record — the wsapi-resident replacement for
 * the legacy bpf SQL queue tables (InventoryFinish.LotChange,
 * InventoryMaterial.OrderLineChange/ShipOrderLineChange,
 * InventoryRetail.LocationProductCount pending semantics). PWA-facing inventory mutations
 * enqueue a record here; a wsapi-services worker claims pending records by workflow + tenant, posts
 * them to Nav (WCF/SQL), and marks each Processed or Failed. This is a worker-owned work queue, NOT
 * an event-sourced aggregate — it is deliberately isolated from the shared InventoryItem
 * domain (no InventoryEvents, no RestockAvailability writes); Nav reconciliation always wins.
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data. The claim and processing fields keep T? so their filters keep eq and
 * in (an Option<T> member filters only by presence, as OptionOf{X}FilterInput).
 * The record v2 optional fields use Option<T> (null-safety standard 5a153a33): recordedAt
 * keeps the DateTime filter operators, and countedQuantity filters by presence.
 *
 *
 * Workflow and Status persist as their enum member NAMES (BSON strings) so the worker queue and
 * inspection UI can filter and sort on them; the ordinals stay int-stable.
 */
export type ErpWriteBackDocument = {
  __typename?: 'ErpWriteBackDocument';
  /**
   * When the poster reported that Nav accepted the latest send (markErpWriteBackAccepted). Null until then,
   * and cleared by each Posting mark, since it describes the latest send.
   */
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The bin at the location reference: a lot change's destination sub-location, or a receipt's bin.
   * Empty when not applicable.
   */
  binCode: Scalars['String']['output'];
  /** The business reason captured for the change (move / add / confirm / output / back-to-grow / receive / count). */
  changeReason: Scalars['String']['output'];
  /** Workflow-specific change discriminator (e.g. the Nav journal/receipt/count operation). Free-form per slice. */
  changeType: Scalars['String']['output'];
  /**
   * Opaque claim token a worker writes when it leases the record; null when the record is not currently
   * claimed. claimPendingErpWriteBacks claims Pending records for posting, and claimPostedErpWriteBacks
   * Posting and Posted records for verifying. A Pending claim older than the claim lease is never leased
   * again: claimed with marksPosting it returns to unclaimed Pending (no Posting mark was made under it,
   * so nothing was sent), otherwise it moves to NeedsReview with its token kept, since Nav may already
   * hold the post. A Posting or Posted record keeps its claim past the lease until
   * claimPostedErpWriteBacks leases it again. Kept on a NeedsReview record a claimant held, which no claim
   * takes again whatever its age, unless a tenant admin resolves it NOT_POSTED with resolveErpWriteBack,
   * which clears the claim. Cleared when Nav accepts a send (markErpWriteBackAccepted).
   */
  claimToken?: Maybe<Scalars['String']['output']>;
  /**
   * When the current claim was taken; null when not currently claimed. Covers the same statuses as
   * claimToken: a Pending claim older than the claim lease is released or moved to NeedsReview by the next
   * claim, never leased again; a Posting or Posted claim older than the lease may be leased by
   * claimPostedErpWriteBacks. Kept on a NeedsReview record a claimant held, which no claim takes again
   * whatever its age, unless a tenant admin resolves it NOT_POSTED with resolveErpWriteBack, which clears
   * the claim.
   */
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The Material counted total (zero or more) a MATERIAL_COUNT record posts. Null for every other
   * workflow, and when the device sent no count.
   */
  countedQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** When the record was enqueued. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The faithful ERP customer id (Nav Customer.No) this change posts against — resolved at
   * enqueue from the producing slice's customer/location read models. The Retail post-back worker
   * writes this directly into Nav xCustomerInventoryLog.CustomerId (which is NOT NULL), so it
   * must never fall back to LocationReference. Empty when the slice does not resolve a
   * customer (non-Retail workflows, or an unresolved Retail association — the worker then fails the
   * record rather than inserting a falsified Nav row).
   */
  customerReference: Scalars['String']['output'];
  /** The write-back record id (server-generated), distinct from the composite Id. */
  erpWriteBackId: Scalars['String']['output'];
  /**
   * The error text from the last Failed or NeedsReview move: the worker's, or the queue's own when it
   * parked an expired claim or a record recorded before a rollback ended; null when there was none. A
   * resolve after a NAV check adds what NAV showed, the admin's email and the note after it.
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The source bin of a move or back-to-grow. Empty for every other change. */
  fromBinCode: Scalars['String']['output'];
  /** The source location of a move or back-to-grow. Empty for every other change. */
  fromLocationReference: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{ErpWriteBackId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /**
   * Idempotency key supplied by the producing mutation. Unique per (tenant, key): a duplicate
   * enqueue with the same key returns the existing record rather than creating a second one, so a
   * PWA retry or at-least-once delivery does not double-post to Nav.
   */
  idempotencyKey: Scalars['String']['output'];
  /** The item reference (Nav item / SKU) this change concerns. Empty when not applicable to the workflow. */
  itemReference: Scalars['String']['output'];
  /**
   * The Nav job the change posts against: the GROW cell's job, or the READY cell's job for a
   * back-to-grow. Empty when not applicable.
   */
  jobReference: Scalars['String']['output'];
  /**
   * When the record was last sent: its latest Posting mark, or that mark's re-send under the same claim, which
   * the worker sends on too. The settle wait is counted from here, and postedAt minus this is the measured
   * send-to-confirm time. Null until the first Posting mark.
   */
  lastPostingAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The latitude where the change was recorded. 0 when the producing workflow does not capture geo
   * (Finish / Material, or a Retail count recorded with no location fix).
   */
  latitude: Scalars['Float']['output'];
  /** The location reference (station / house / section / store / warehouse) this change concerns. */
  locationReference: Scalars['String']['output'];
  /** The longitude where the change was recorded. 0 when the producing workflow does not capture geo. */
  longitude: Scalars['Float']['output'];
  /** The lot reference (greenhouse / organic lot) this change concerns. Empty when not applicable. */
  lotReference: Scalars['String']['output'];
  /**
   * Whether the record's latest claim was taken by a worker that marks Posting before every send. Written
   * by every claimPendingErpWriteBacks from its own input, true or false, and by nothing else. A Pending
   * claim taken with it returns to unclaimed Pending when its lease expires, since a send would have been
   * marked first. A NeedsReview record takes NOT_POSTED after the settle wait from its latest send only while
   * it is true; parked under a claim taken without it, the record keeps the rule of one never marked Posting.
   * False on records claimed before it was captured.
   */
  marksPosting: Scalars['Boolean']['output'];
  /**
   * The Nav document number the record is sent under, set by its first Posting mark and the same on every
   * send, so a verify step finds any of them by it. Kept when a verify step releases the record to be sent
   * again. Null until the first Posting mark.
   */
  navDocumentNo?: Maybe<Scalars['String']['output']>;
  /**
   * Nav's own posting time for the latest send, when the poster reported one with the accepted mark. Null
   * otherwise, and cleared by each Posting mark.
   */
  navPostedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * When the record's document number was found in Nav (markErpWriteBackPosted): by a verify step, or by its
   * poster before a re-attempt, never at Nav's acceptance. Null until then, and cleared by each Posting mark.
   */
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the record was first sent: its first Posting mark, never overwritten. Null until then. */
  postingAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * How many times the record has been sent: one per Posting mark; a mark sent again under the same claim
   * adds none. 0 until the first.
   */
  postingAttempts: Scalars['Int']['output'];
  /**
   * When the record reached Processed or Failed; null while Pending or NeedsReview. Failed is final for
   * the worker, but a tenant admin can still resolve it with resolveErpWriteBack: POSTED sets this to
   * the time of the resolve, as it does for any record the resolve closes, and NOT_POSTED clears it.
   */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The signed quantity delta to post to Nav. */
  quantityChange: Scalars['Decimal']['output'];
  /**
   * One receipt group's lots, posted together in this record. Empty when the record carries a single
   * lot (every lot change, and every record enqueued before receipt groups were captured).
   */
  receiptLines: Array<ErpWriteBackReceiptLineDocument>;
  /**
   * When the change was recorded on the device, or the enqueue time when the device sent none. Null
   * on records enqueued before it was captured.
   */
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Number of times a worker has attempted to post this record to Nav. The queue also counts one when it
   * parks an expired claim or a record recorded before a rollback ended.
   */
  retryCount: Scalars['Int']['output'];
  /**
   * The faithful route / Nav location id this change posts against — resolved at enqueue from the
   * producing slice's customer-location read model (the retail customer-location Code = the
   * route). The Retail post-back worker writes this into the Nav route LocationId column.
   * Empty when the slice does not resolve a route (non-Retail workflows, or an unresolved Retail
   * association).
   */
  routeLocationId: Scalars['String']['output'];
  /**
   * The BPF lot stage the change was recorded at: Grow, Ready or Material. Empty for receipts and
   * Retail, and on records enqueued before the stage was captured.
   */
  stage: Scalars['String']['output'];
  /**
   * Lifecycle status — Pending until a worker posts it, then Processed or Failed; NeedsReview when Nav
   * may or may not hold the post: the worker could not tell, its claim lease expired, or the record was
   * recorded before a rollback ended. A worker that marks each send moves it to Posting before the send; it
   * moves to Posted once its document number is found in Nav (by a verify step, or by the worker before a
   * re-attempt), then to Processed after the audit.
   * After checking NAV, a tenant admin's resolveErpWriteBack moves a Failed, NeedsReview, Posting or Posted
   * record (and, under a rollback hold, a Pending one) to Processed when NAV shows it, or a Failed,
   * NeedsReview or Posting one back to Pending to post again when it does not.
   */
  status: ErpWriteBackStatus;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit: Scalars['String']['output'];
  /**
   * The signed unit/eaches-of-measure quantity delta to post to Nav, distinct from
   * the trays quantity above. Empty (0) when the producing workflow does not distinguish
   * trays from eaches (Finish / Material).
   */
  unitQuantityChange: Scalars['Decimal']['output'];
  /**
   * The item's UPC, resolved here from the shared Item read model by the resolved item reference.
   * Empty when the producing workflow does not resolve a UPC, or the item reference does not match
   * a known item.
   */
  upc: Scalars['String']['output'];
  /** The user (email) who originated the change in the PWA. */
  user: Scalars['String']['output'];
  /** The variant reference (size/color/grade variant) this change concerns. Empty when not applicable. */
  variantReference: Scalars['String']['output'];
  /** The BPF business solution that produced this record (Finish / Material receipts / Retail / Material counts). */
  workflow: ErpWriteBackWorkflow;
};

/**
 * MongoDB document for a single durable ERP write-back record — the wsapi-resident replacement for
 * the legacy bpf SQL queue tables (InventoryFinish.LotChange,
 * InventoryMaterial.OrderLineChange/ShipOrderLineChange,
 * InventoryRetail.LocationProductCount pending semantics). PWA-facing inventory mutations
 * enqueue a record here; a wsapi-services worker claims pending records by workflow + tenant, posts
 * them to Nav (WCF/SQL), and marks each Processed or Failed. This is a worker-owned work queue, NOT
 * an event-sourced aggregate — it is deliberately isolated from the shared InventoryItem
 * domain (no InventoryEvents, no RestockAvailability writes); Nav reconciliation always wins.
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data. The claim and processing fields keep T? so their filters keep eq and
 * in (an Option<T> member filters only by presence, as OptionOf{X}FilterInput).
 * The record v2 optional fields use Option<T> (null-safety standard 5a153a33): recordedAt
 * keeps the DateTime filter operators, and countedQuantity filters by presence.
 *
 *
 * Workflow and Status persist as their enum member NAMES (BSON strings) so the worker queue and
 * inspection UI can filter and sort on them; the ordinals stay int-stable.
 */
export type ErpWriteBackDocumentFilterInput = {
  /**
   * When the poster reported that Nav accepted the latest send (markErpWriteBackAccepted). Null until then,
   * and cleared by each Posting mark, since it describes the latest send.
   */
  acceptedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ErpWriteBackDocumentFilterInput>>;
  /**
   * The bin at the location reference: a lot change's destination sub-location, or a receipt's bin.
   * Empty when not applicable.
   */
  binCode?: InputMaybe<StringOperationFilterInput>;
  /** The business reason captured for the change (move / add / confirm / output / back-to-grow / receive / count). */
  changeReason?: InputMaybe<StringOperationFilterInput>;
  /** Workflow-specific change discriminator (e.g. the Nav journal/receipt/count operation). Free-form per slice. */
  changeType?: InputMaybe<StringOperationFilterInput>;
  /**
   * Opaque claim token a worker writes when it leases the record; null when the record is not currently
   * claimed. claimPendingErpWriteBacks claims Pending records for posting, and claimPostedErpWriteBacks
   * Posting and Posted records for verifying. A Pending claim older than the claim lease is never leased
   * again: claimed with marksPosting it returns to unclaimed Pending (no Posting mark was made under it,
   * so nothing was sent), otherwise it moves to NeedsReview with its token kept, since Nav may already
   * hold the post. A Posting or Posted record keeps its claim past the lease until
   * claimPostedErpWriteBacks leases it again. Kept on a NeedsReview record a claimant held, which no claim
   * takes again whatever its age, unless a tenant admin resolves it NOT_POSTED with resolveErpWriteBack,
   * which clears the claim. Cleared when Nav accepts a send (markErpWriteBackAccepted).
   */
  claimToken?: InputMaybe<StringOperationFilterInput>;
  /**
   * When the current claim was taken; null when not currently claimed. Covers the same statuses as
   * claimToken: a Pending claim older than the claim lease is released or moved to NeedsReview by the next
   * claim, never leased again; a Posting or Posted claim older than the lease may be leased by
   * claimPostedErpWriteBacks. Kept on a NeedsReview record a claimant held, which no claim takes again
   * whatever its age, unless a tenant admin resolves it NOT_POSTED with resolveErpWriteBack, which clears
   * the claim.
   */
  claimedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The Material counted total (zero or more) a MATERIAL_COUNT record posts. Null for every other
   * workflow, and when the device sent no count.
   */
  countedQuantity?: InputMaybe<OptionOfDecimalFilterInput>;
  /** When the record was enqueued. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The faithful ERP customer id (Nav Customer.No) this change posts against — resolved at
   * enqueue from the producing slice's customer/location read models. The Retail post-back worker
   * writes this directly into Nav xCustomerInventoryLog.CustomerId (which is NOT NULL), so it
   * must never fall back to LocationReference. Empty when the slice does not resolve a
   * customer (non-Retail workflows, or an unresolved Retail association — the worker then fails the
   * record rather than inserting a falsified Nav row).
   */
  customerReference?: InputMaybe<StringOperationFilterInput>;
  /** The write-back record id (server-generated), distinct from the composite Id. */
  erpWriteBackId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The error text from the last Failed or NeedsReview move: the worker's, or the queue's own when it
   * parked an expired claim or a record recorded before a rollback ended; null when there was none. A
   * resolve after a NAV check adds what NAV showed, the admin's email and the note after it.
   */
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  /** The source bin of a move or back-to-grow. Empty for every other change. */
  fromBinCode?: InputMaybe<StringOperationFilterInput>;
  /** The source location of a move or back-to-grow. Empty for every other change. */
  fromLocationReference?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{ErpWriteBackId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Idempotency key supplied by the producing mutation. Unique per (tenant, key): a duplicate
   * enqueue with the same key returns the existing record rather than creating a second one, so a
   * PWA retry or at-least-once delivery does not double-post to Nav.
   */
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  /** The item reference (Nav item / SKU) this change concerns. Empty when not applicable to the workflow. */
  itemReference?: InputMaybe<StringOperationFilterInput>;
  /**
   * The Nav job the change posts against: the GROW cell's job, or the READY cell's job for a
   * back-to-grow. Empty when not applicable.
   */
  jobReference?: InputMaybe<StringOperationFilterInput>;
  /**
   * When the record was last sent: its latest Posting mark, or that mark's re-send under the same claim, which
   * the worker sends on too. The settle wait is counted from here, and postedAt minus this is the measured
   * send-to-confirm time. Null until the first Posting mark.
   */
  lastPostingAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The latitude where the change was recorded. 0 when the producing workflow does not capture geo
   * (Finish / Material, or a Retail count recorded with no location fix).
   */
  latitude?: InputMaybe<FloatOperationFilterInput>;
  /** The location reference (station / house / section / store / warehouse) this change concerns. */
  locationReference?: InputMaybe<StringOperationFilterInput>;
  /** The longitude where the change was recorded. 0 when the producing workflow does not capture geo. */
  longitude?: InputMaybe<FloatOperationFilterInput>;
  /** The lot reference (greenhouse / organic lot) this change concerns. Empty when not applicable. */
  lotReference?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether the record's latest claim was taken by a worker that marks Posting before every send. Written
   * by every claimPendingErpWriteBacks from its own input, true or false, and by nothing else. A Pending
   * claim taken with it returns to unclaimed Pending when its lease expires, since a send would have been
   * marked first. A NeedsReview record takes NOT_POSTED after the settle wait from its latest send only while
   * it is true; parked under a claim taken without it, the record keeps the rule of one never marked Posting.
   * False on records claimed before it was captured.
   */
  marksPosting?: InputMaybe<AbsentAsFalseBooleanOperationFilterInput>;
  /**
   * The Nav document number the record is sent under, set by its first Posting mark and the same on every
   * send, so a verify step finds any of them by it. Kept when a verify step releases the record to be sent
   * again. Null until the first Posting mark.
   */
  navDocumentNo?: InputMaybe<StringOperationFilterInput>;
  /**
   * Nav's own posting time for the latest send, when the poster reported one with the accepted mark. Null
   * otherwise, and cleared by each Posting mark.
   */
  navPostedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ErpWriteBackDocumentFilterInput>>;
  /**
   * When the record's document number was found in Nav (markErpWriteBackPosted): by a verify step, or by its
   * poster before a re-attempt, never at Nav's acceptance. Null until then, and cleared by each Posting mark.
   */
  postedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When the record was first sent: its first Posting mark, never overwritten. Null until then. */
  postingAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * When the record reached Processed or Failed; null while Pending or NeedsReview. Failed is final for
   * the worker, but a tenant admin can still resolve it with resolveErpWriteBack: POSTED sets this to
   * the time of the resolve, as it does for any record the resolve closes, and NOT_POSTED clears it.
   */
  processedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The signed quantity delta to post to Nav. */
  quantityChange?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * One receipt group's lots, posted together in this record. Empty when the record carries a single
   * lot (every lot change, and every record enqueued before receipt groups were captured).
   */
  receiptLines?: InputMaybe<ListFilterInputTypeOfErpWriteBackReceiptLineDocumentFilterInput>;
  /**
   * When the change was recorded on the device, or the enqueue time when the device sent none. Null
   * on records enqueued before it was captured.
   */
  recordedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Number of times a worker has attempted to post this record to Nav. The queue also counts one when it
   * parks an expired claim or a record recorded before a rollback ended.
   */
  retryCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * The faithful route / Nav location id this change posts against — resolved at enqueue from the
   * producing slice's customer-location read model (the retail customer-location Code = the
   * route). The Retail post-back worker writes this into the Nav route LocationId column.
   * Empty when the slice does not resolve a route (non-Retail workflows, or an unresolved Retail
   * association).
   */
  routeLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The BPF lot stage the change was recorded at: Grow, Ready or Material. Empty for receipts and
   * Retail, and on records enqueued before the stage was captured.
   */
  stage?: InputMaybe<StringOperationFilterInput>;
  /**
   * Lifecycle status — Pending until a worker posts it, then Processed or Failed; NeedsReview when Nav
   * may or may not hold the post: the worker could not tell, its claim lease expired, or the record was
   * recorded before a rollback ended. A worker that marks each send moves it to Posting before the send; it
   * moves to Posted once its document number is found in Nav (by a verify step, or by the worker before a
   * re-attempt), then to Processed after the audit.
   * After checking NAV, a tenant admin's resolveErpWriteBack moves a Failed, NeedsReview, Posting or Posted
   * record (and, under a rollback hold, a Pending one) to Processed when NAV shows it, or a Failed,
   * NeedsReview or Posting one back to Pending to post again when it does not.
   */
  status?: InputMaybe<ErpWriteBackStatusOperationFilterInput>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit?: InputMaybe<StringOperationFilterInput>;
  /**
   * The signed unit/eaches-of-measure quantity delta to post to Nav, distinct from
   * the trays quantity above. Empty (0) when the producing workflow does not distinguish
   * trays from eaches (Finish / Material).
   */
  unitQuantityChange?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The item's UPC, resolved here from the shared Item read model by the resolved item reference.
   * Empty when the producing workflow does not resolve a UPC, or the item reference does not match
   * a known item.
   */
  upc?: InputMaybe<StringOperationFilterInput>;
  /** The user (email) who originated the change in the PWA. */
  user?: InputMaybe<StringOperationFilterInput>;
  /** The variant reference (size/color/grade variant) this change concerns. Empty when not applicable. */
  variantReference?: InputMaybe<StringOperationFilterInput>;
  /** The BPF business solution that produced this record (Finish / Material receipts / Retail / Material counts). */
  workflow?: InputMaybe<ErpWriteBackWorkflowOperationFilterInput>;
};

/**
 * MongoDB document for a single durable ERP write-back record — the wsapi-resident replacement for
 * the legacy bpf SQL queue tables (InventoryFinish.LotChange,
 * InventoryMaterial.OrderLineChange/ShipOrderLineChange,
 * InventoryRetail.LocationProductCount pending semantics). PWA-facing inventory mutations
 * enqueue a record here; a wsapi-services worker claims pending records by workflow + tenant, posts
 * them to Nav (WCF/SQL), and marks each Processed or Failed. This is a worker-owned work queue, NOT
 * an event-sourced aggregate — it is deliberately isolated from the shared InventoryItem
 * domain (no InventoryEvents, no RestockAvailability writes); Nav reconciliation always wins.
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data. The claim and processing fields keep T? so their filters keep eq and
 * in (an Option<T> member filters only by presence, as OptionOf{X}FilterInput).
 * The record v2 optional fields use Option<T> (null-safety standard 5a153a33): recordedAt
 * keeps the DateTime filter operators, and countedQuantity filters by presence.
 *
 *
 * Workflow and Status persist as their enum member NAMES (BSON strings) so the worker queue and
 * inspection UI can filter and sort on them; the ordinals stay int-stable.
 */
export type ErpWriteBackDocumentSortInput = {
  /**
   * When the poster reported that Nav accepted the latest send (markErpWriteBackAccepted). Null until then,
   * and cleared by each Posting mark, since it describes the latest send.
   */
  acceptedAt?: InputMaybe<SortEnumType>;
  /**
   * The bin at the location reference: a lot change's destination sub-location, or a receipt's bin.
   * Empty when not applicable.
   */
  binCode?: InputMaybe<SortEnumType>;
  /** The business reason captured for the change (move / add / confirm / output / back-to-grow / receive / count). */
  changeReason?: InputMaybe<SortEnumType>;
  /** Workflow-specific change discriminator (e.g. the Nav journal/receipt/count operation). Free-form per slice. */
  changeType?: InputMaybe<SortEnumType>;
  /**
   * Opaque claim token a worker writes when it leases the record; null when the record is not currently
   * claimed. claimPendingErpWriteBacks claims Pending records for posting, and claimPostedErpWriteBacks
   * Posting and Posted records for verifying. A Pending claim older than the claim lease is never leased
   * again: claimed with marksPosting it returns to unclaimed Pending (no Posting mark was made under it,
   * so nothing was sent), otherwise it moves to NeedsReview with its token kept, since Nav may already
   * hold the post. A Posting or Posted record keeps its claim past the lease until
   * claimPostedErpWriteBacks leases it again. Kept on a NeedsReview record a claimant held, which no claim
   * takes again whatever its age, unless a tenant admin resolves it NOT_POSTED with resolveErpWriteBack,
   * which clears the claim. Cleared when Nav accepts a send (markErpWriteBackAccepted).
   */
  claimToken?: InputMaybe<SortEnumType>;
  /**
   * When the current claim was taken; null when not currently claimed. Covers the same statuses as
   * claimToken: a Pending claim older than the claim lease is released or moved to NeedsReview by the next
   * claim, never leased again; a Posting or Posted claim older than the lease may be leased by
   * claimPostedErpWriteBacks. Kept on a NeedsReview record a claimant held, which no claim takes again
   * whatever its age, unless a tenant admin resolves it NOT_POSTED with resolveErpWriteBack, which clears
   * the claim.
   */
  claimedAt?: InputMaybe<SortEnumType>;
  /**
   * The Material counted total (zero or more) a MATERIAL_COUNT record posts. Null for every other
   * workflow, and when the device sent no count.
   */
  countedQuantity?: InputMaybe<SortEnumType>;
  /** When the record was enqueued. */
  createdAt?: InputMaybe<SortEnumType>;
  /**
   * The faithful ERP customer id (Nav Customer.No) this change posts against — resolved at
   * enqueue from the producing slice's customer/location read models. The Retail post-back worker
   * writes this directly into Nav xCustomerInventoryLog.CustomerId (which is NOT NULL), so it
   * must never fall back to LocationReference. Empty when the slice does not resolve a
   * customer (non-Retail workflows, or an unresolved Retail association — the worker then fails the
   * record rather than inserting a falsified Nav row).
   */
  customerReference?: InputMaybe<SortEnumType>;
  /** The write-back record id (server-generated), distinct from the composite Id. */
  erpWriteBackId?: InputMaybe<SortEnumType>;
  /**
   * The error text from the last Failed or NeedsReview move: the worker's, or the queue's own when it
   * parked an expired claim or a record recorded before a rollback ended; null when there was none. A
   * resolve after a NAV check adds what NAV showed, the admin's email and the note after it.
   */
  errorMessage?: InputMaybe<SortEnumType>;
  /** The source bin of a move or back-to-grow. Empty for every other change. */
  fromBinCode?: InputMaybe<SortEnumType>;
  /** The source location of a move or back-to-grow. Empty for every other change. */
  fromLocationReference?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{ErpWriteBackId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Idempotency key supplied by the producing mutation. Unique per (tenant, key): a duplicate
   * enqueue with the same key returns the existing record rather than creating a second one, so a
   * PWA retry or at-least-once delivery does not double-post to Nav.
   */
  idempotencyKey?: InputMaybe<SortEnumType>;
  /** The item reference (Nav item / SKU) this change concerns. Empty when not applicable to the workflow. */
  itemReference?: InputMaybe<SortEnumType>;
  /**
   * The Nav job the change posts against: the GROW cell's job, or the READY cell's job for a
   * back-to-grow. Empty when not applicable.
   */
  jobReference?: InputMaybe<SortEnumType>;
  /**
   * When the record was last sent: its latest Posting mark, or that mark's re-send under the same claim, which
   * the worker sends on too. The settle wait is counted from here, and postedAt minus this is the measured
   * send-to-confirm time. Null until the first Posting mark.
   */
  lastPostingAt?: InputMaybe<SortEnumType>;
  /**
   * The latitude where the change was recorded. 0 when the producing workflow does not capture geo
   * (Finish / Material, or a Retail count recorded with no location fix).
   */
  latitude?: InputMaybe<SortEnumType>;
  /** The location reference (station / house / section / store / warehouse) this change concerns. */
  locationReference?: InputMaybe<SortEnumType>;
  /** The longitude where the change was recorded. 0 when the producing workflow does not capture geo. */
  longitude?: InputMaybe<SortEnumType>;
  /** The lot reference (greenhouse / organic lot) this change concerns. Empty when not applicable. */
  lotReference?: InputMaybe<SortEnumType>;
  /**
   * Whether the record's latest claim was taken by a worker that marks Posting before every send. Written
   * by every claimPendingErpWriteBacks from its own input, true or false, and by nothing else. A Pending
   * claim taken with it returns to unclaimed Pending when its lease expires, since a send would have been
   * marked first. A NeedsReview record takes NOT_POSTED after the settle wait from its latest send only while
   * it is true; parked under a claim taken without it, the record keeps the rule of one never marked Posting.
   * False on records claimed before it was captured.
   */
  marksPosting?: InputMaybe<SortEnumType>;
  /**
   * The Nav document number the record is sent under, set by its first Posting mark and the same on every
   * send, so a verify step finds any of them by it. Kept when a verify step releases the record to be sent
   * again. Null until the first Posting mark.
   */
  navDocumentNo?: InputMaybe<SortEnumType>;
  /**
   * Nav's own posting time for the latest send, when the poster reported one with the accepted mark. Null
   * otherwise, and cleared by each Posting mark.
   */
  navPostedAt?: InputMaybe<SortEnumType>;
  /**
   * When the record's document number was found in Nav (markErpWriteBackPosted): by a verify step, or by its
   * poster before a re-attempt, never at Nav's acceptance. Null until then, and cleared by each Posting mark.
   */
  postedAt?: InputMaybe<SortEnumType>;
  /** When the record was first sent: its first Posting mark, never overwritten. Null until then. */
  postingAt?: InputMaybe<SortEnumType>;
  /**
   * How many times the record has been sent: one per Posting mark; a mark sent again under the same claim
   * adds none. 0 until the first.
   */
  postingAttempts?: InputMaybe<SortEnumType>;
  /**
   * When the record reached Processed or Failed; null while Pending or NeedsReview. Failed is final for
   * the worker, but a tenant admin can still resolve it with resolveErpWriteBack: POSTED sets this to
   * the time of the resolve, as it does for any record the resolve closes, and NOT_POSTED clears it.
   */
  processedAt?: InputMaybe<SortEnumType>;
  /** The signed quantity delta to post to Nav. */
  quantityChange?: InputMaybe<SortEnumType>;
  /**
   * When the change was recorded on the device, or the enqueue time when the device sent none. Null
   * on records enqueued before it was captured.
   */
  recordedAt?: InputMaybe<SortEnumType>;
  /**
   * Number of times a worker has attempted to post this record to Nav. The queue also counts one when it
   * parks an expired claim or a record recorded before a rollback ended.
   */
  retryCount?: InputMaybe<SortEnumType>;
  /**
   * The faithful route / Nav location id this change posts against — resolved at enqueue from the
   * producing slice's customer-location read model (the retail customer-location Code = the
   * route). The Retail post-back worker writes this into the Nav route LocationId column.
   * Empty when the slice does not resolve a route (non-Retail workflows, or an unresolved Retail
   * association).
   */
  routeLocationId?: InputMaybe<SortEnumType>;
  /**
   * The BPF lot stage the change was recorded at: Grow, Ready or Material. Empty for receipts and
   * Retail, and on records enqueued before the stage was captured.
   */
  stage?: InputMaybe<SortEnumType>;
  /**
   * Lifecycle status — Pending until a worker posts it, then Processed or Failed; NeedsReview when Nav
   * may or may not hold the post: the worker could not tell, its claim lease expired, or the record was
   * recorded before a rollback ended. A worker that marks each send moves it to Posting before the send; it
   * moves to Posted once its document number is found in Nav (by a verify step, or by the worker before a
   * re-attempt), then to Processed after the audit.
   * After checking NAV, a tenant admin's resolveErpWriteBack moves a Failed, NeedsReview, Posting or Posted
   * record (and, under a rollback hold, a Pending one) to Processed when NAV shows it, or a Failed,
   * NeedsReview or Posting one back to Pending to post again when it does not.
   */
  status?: InputMaybe<SortEnumType>;
  /** The owning tenant. Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The unit of measure for QuantityChange (e.g. EA, FLAT). */
  unit?: InputMaybe<SortEnumType>;
  /**
   * The signed unit/eaches-of-measure quantity delta to post to Nav, distinct from
   * the trays quantity above. Empty (0) when the producing workflow does not distinguish
   * trays from eaches (Finish / Material).
   */
  unitQuantityChange?: InputMaybe<SortEnumType>;
  /**
   * The item's UPC, resolved here from the shared Item read model by the resolved item reference.
   * Empty when the producing workflow does not resolve a UPC, or the item reference does not match
   * a known item.
   */
  upc?: InputMaybe<SortEnumType>;
  /** The user (email) who originated the change in the PWA. */
  user?: InputMaybe<SortEnumType>;
  /** The variant reference (size/color/grade variant) this change concerns. Empty when not applicable. */
  variantReference?: InputMaybe<SortEnumType>;
  /** The BPF business solution that produced this record (Finish / Material receipts / Retail / Material counts). */
  workflow?: InputMaybe<SortEnumType>;
};

/**
 * A tenant's ERP write-back hold, one document per tenant. While the hold is on, claimPendingErpWriteBacks
 * returns no records, so nothing posts to Nav, and enqueueErpWriteBack keeps storing Pending records. A
 * rollback hold is the one set while the tenant goes back to the legacy system: setting it adds 1 to
 * rollbackEpoch, and turning it off stamps rolledBackUntil. After that, a Pending record recorded before
 * the rollback ended and not reconciled since it started goes to NEEDS_REVIEW instead of being posted.
 */
export type ErpWriteBackHoldDocument = {
  __typename?: 'ErpWriteBackHoldDocument';
  /** When the hold was last set or released. */
  changedAt: Scalars['DateTime']['output'];
  /** The email of the admin who last set or released the hold. */
  changedBy: Scalars['String']['output'];
  /** Whether the hold is on. While it is, claims return no records and nothing posts to Nav. */
  hold: Scalars['Boolean']['output'];
  /** Why the hold was last set or released, as the admin entered it. */
  reason: Scalars['String']['output'];
  /** Whether the hold that is on is a rollback hold. Always false while the hold is off. */
  rollback: Scalars['Boolean']['output'];
  /** How many rollback holds the tenant has started. 0 until the first one. */
  rollbackEpoch: Scalars['Int']['output'];
  /**
   * When the latest rollback hold was turned off; null until a rollback hold has been released. A Pending
   * record recorded at or before this time, and not reconciled since that rollback started, goes to
   * NEEDS_REVIEW instead of being posted.
   */
  rolledBackUntil?: Maybe<Scalars['DateTime']['output']>;
  /** The tenant the hold applies to. */
  tenantId: Scalars['String']['output'];
};

/** Payload for setErpWriteBackHold: the hold as stored, or why it was not set. */
export type ErpWriteBackHoldPayload = {
  __typename?: 'ErpWriteBackHoldPayload';
  erpWriteBackHold?: Maybe<ErpWriteBackHoldDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum ErpWriteBackNavCheck {
  NotPosted = 'NOT_POSTED',
  Posted = 'POSTED'
}

/**
 * Standard single-record payload for the ERP write-back mutations (enqueue / markPosting / markAccepted /
 * markPosted / markProcessed / markFailed / markNeedsReview / release / resolve). Carries the affected record
 * on success, or the validation error(s) on failure.
 */
export type ErpWriteBackPayload = {
  __typename?: 'ErpWriteBackPayload';
  erpWriteBack?: Maybe<ErpWriteBackDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A connection to a list of items. */
export type ErpWriteBackQueueConnection = {
  __typename?: 'ErpWriteBackQueueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErpWriteBackQueueEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpWriteBackDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ErpWriteBackQueueEdge = {
  __typename?: 'ErpWriteBackQueueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpWriteBackDocument;
};

/** One lot of a receipt group carried by a single write-back record, with the quantity received into it. */
export type ErpWriteBackReceiptLineDocument = {
  __typename?: 'ErpWriteBackReceiptLineDocument';
  /** The vendor lot the quantity was received into. */
  lotReference: Scalars['String']['output'];
  /** The quantity received into this lot. */
  quantity: Scalars['Decimal']['output'];
};

/** One lot of a receipt group carried by a single write-back record, with the quantity received into it. */
export type ErpWriteBackReceiptLineDocumentFilterInput = {
  and?: InputMaybe<Array<ErpWriteBackReceiptLineDocumentFilterInput>>;
  /** The vendor lot the quantity was received into. */
  lotReference?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ErpWriteBackReceiptLineDocumentFilterInput>>;
  /** The quantity received into this lot. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
};

export enum ErpWriteBackStatus {
  Failed = 'FAILED',
  NeedsReview = 'NEEDS_REVIEW',
  Pending = 'PENDING',
  Posted = 'POSTED',
  Posting = 'POSTING',
  Processed = 'PROCESSED',
  Unknown = 'UNKNOWN'
}

export type ErpWriteBackStatusOperationFilterInput = {
  eq?: InputMaybe<ErpWriteBackStatus>;
  in?: InputMaybe<Array<ErpWriteBackStatus>>;
  neq?: InputMaybe<ErpWriteBackStatus>;
  nin?: InputMaybe<Array<ErpWriteBackStatus>>;
};

export enum ErpWriteBackWorkflow {
  Finish = 'FINISH',
  Material = 'MATERIAL',
  MaterialCount = 'MATERIAL_COUNT',
  Retail = 'RETAIL',
  Unknown = 'UNKNOWN'
}

export type ErpWriteBackWorkflowOperationFilterInput = {
  eq?: InputMaybe<ErpWriteBackWorkflow>;
  in?: InputMaybe<Array<ErpWriteBackWorkflow>>;
  neq?: InputMaybe<ErpWriteBackWorkflow>;
  nin?: InputMaybe<Array<ErpWriteBackWorkflow>>;
};

/** An error returned by a GraphQL operation. */
export type Error = {
  __typename?: 'Error';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type EventAssignmentOverrideData = {
  __typename?: 'EventAssignmentOverrideData';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type EventAssignmentOverrideDataInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
};

export type EventAssignmentOverrideDocument = {
  __typename?: 'EventAssignmentOverrideDocument';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type EventAssignmentOverrideDocumentFilterInput = {
  and?: InputMaybe<Array<EventAssignmentOverrideDocumentFilterInput>>;
  defaultAssignedTo?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventAssignmentOverrideDocumentFilterInput>>;
};

export enum EventChangeKind {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type EventCountDocument = {
  __typename?: 'EventCountDocument';
  count: Scalars['Long']['output'];
  eventName: Scalars['String']['output'];
};

export type EventCountDocumentFilterInput = {
  and?: InputMaybe<Array<EventCountDocumentFilterInput>>;
  count?: InputMaybe<LongOperationFilterInput>;
  eventName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventCountDocumentFilterInput>>;
};

export type EventCountDocumentSortInput = {
  count?: InputMaybe<SortEnumType>;
  eventName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EventCountsConnection = {
  __typename?: 'EventCountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventCountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EventCountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventCountsEdge = {
  __typename?: 'EventCountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EventCountDocument;
};

export type EventIdChangeProjection = {
  __typename?: 'EventIdChangeProjection';
  eventId: Scalars['String']['output'];
  eventListName: Scalars['String']['output'];
  expectedEventFingerprint?: Maybe<Scalars['String']['output']>;
  hasExistingOverride: Scalars['Boolean']['output'];
  kind: EventChangeKind;
};

export type EventRecordData = {
  __typename?: 'EventRecordData';
  contentType: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  eventId: Scalars['String']['output'];
  eventNumber: Scalars['Long']['output'];
  eventStreamId: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
  position: PositionData;
};

export type EventStreamAggregateDocument = {
  __typename?: 'EventStreamAggregateDocument';
  checkpointPosition?: Maybe<Scalars['Long']['output']>;
  ended?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  started: Scalars['DateTime']['output'];
};

export type EventStreamAggregateDocumentFilterInput = {
  and?: InputMaybe<Array<EventStreamAggregateDocumentFilterInput>>;
  checkpointPosition?: InputMaybe<LongOperationFilterInput>;
  ended?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventStreamAggregateDocumentFilterInput>>;
  started?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EventStreamAggregateDocumentSortInput = {
  checkpointPosition?: InputMaybe<SortEnumType>;
  ended?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  started?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EventStreamAggregatesConnection = {
  __typename?: 'EventStreamAggregatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventStreamAggregatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EventStreamAggregateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventStreamAggregatesEdge = {
  __typename?: 'EventStreamAggregatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EventStreamAggregateDocument;
};

/** Redeem a handoff code from the target domain's handoff page. */
export type ExchangePortalSessionHandoffCodeInput = {
  /**
   * The single-use code, as delivered in the handoff URL. Consumed by this call whatever the outcome.
   * The domain redeeming it is NOT a parameter — it is observed from the request's Origin
   * header, because a self-declared domain would make the binding meaningless.
   */
  code: Scalars['String']['input'];
};

export type ExecuteProductionJobInput = {
  consumedMaterials: Array<ConsumedMaterialDataInput>;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

/** Input for executeScheduledInventoryTransfer; the tenant comes from the worker's token. */
export type ExecuteScheduledInventoryTransferInput = {
  /** The schedule's id, as dueScheduledInventoryTransfers returned it. */
  id: Scalars['String']['input'];
};

/** The result of executeScheduledInventoryTransfer: the execution, or the errors that left it undone. */
export type ExecuteScheduledInventoryTransferPayload = {
  __typename?: 'ExecuteScheduledInventoryTransferPayload';
  errors?: Maybe<Array<ValidationError>>;
  execution?: Maybe<ScheduledInventoryTransferExecution>;
};

export type ExpectedCustomerDefaultTagColorInput = {
  tagColorId?: InputMaybe<Scalars['String']['input']>;
};

export type ExpectedItemCharacteristicDataInput = {
  name: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type ExpectedItemCharacteristicPickValueDataInput = {
  valueId?: InputMaybe<Scalars['String']['input']>;
};

export type ExpectedItemCharacteristicValueDataInput = {
  name: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type ExpectedItemTagColorInput = {
  tagColorId?: InputMaybe<Scalars['String']['input']>;
  tagColorLocked: Scalars['Boolean']['input'];
};

export type ExpectedTagColorInput = {
  tagColorId?: InputMaybe<Scalars['String']['input']>;
};

/** A price level annotated with the reason it did or did not contribute to the resolved price. */
export type ExplainedLevel = {
  __typename?: 'ExplainedLevel';
  customerSellPrice?: Maybe<Scalars['Decimal']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The charged price for this level. CustomerSellPrice is never a charge source. */
  growerSellPrice: Scalars['Decimal']['output'];
  /** Fixed $/unit (default) vs percentage-off-a-reference-group. See PriceKind. */
  kind: PriceKind;
  /** LinePrice (default) vs CategoryVolume. See PriceLevelType. */
  levelType: PriceLevelType;
  /** Percentage discount value (4 = 4%). Present only for PercentOff levels. */
  percentOff?: Maybe<Scalars['Decimal']['output']>;
  priceLevelId: Scalars['String']['output'];
  quantityThreshold: Scalars['Decimal']['output'];
  /**
   * The price group this level discounts off of. Present only for PercentOff
   * levels.
   */
  referencePriceGroupId?: Maybe<Scalars['String']['output']>;
  /**
   * The actual charge price for this level: for Fixed this equals
   * GrowerSellPrice; for PercentOff this is the derived value — the
   * reference group's resolved price for this same target, minus PercentOff percent. Always
   * the number the pricing engine would actually charge, so a percent level's derivation is fully
   * transparent without the caller re-computing it.
   */
  resolvedPrice: Scalars['Decimal']['output'];
  startDate: Scalars['DateTime']['output'];
  /** Why this level did or did not apply to the resolution. */
  status: LevelStatus;
  targetId: Scalars['String']['output'];
  /**
   * Display name of the target: the item/material Name for item targets, the category code for
   * category targets. Empty when the referenced item/material could not be found.
   */
  targetName: Scalars['String']['output'];
  type: TargetType;
};

/**
 * The quantity the money path multiplies a unit price by, and the two numbers it is chosen from —
 * the eaches quantity when the line carries one, else the ordered quantity. Echoed so a caller reconciling a sub-cent unit price against a document
 * total can state the whole multiplication (basis x unitPriceExact) from this payload alone.
 *
 * quantityBasis is not always quantity, and that is the point.
 * The quantity that gates a price level's threshold is the ordered
 * quantity, while the quantity money multiplies is
 * eachesQuantity when present — a pre-existing, deliberate divergence in the order engine
 * between the quantity a price level is gated on and the quantity money is multiplied by. A user
 * reconciling a total against a quantity is otherwise reading the wrong one of the two.
 */
export type ExplainedLineBasis = {
  __typename?: 'ExplainedLineBasis';
  /**
   * The line's eaches quantity when the caller supplied one, else None. A catalog caller that has
   * no line supplies none, and quantityBasis is then quantity.
   */
  eachesQuantity?: Maybe<Scalars['Int']['output']>;
  /** The ordered/container-scale quantity the caller supplied — the number price-level thresholds were gated on. */
  quantity: Scalars['Int']['output'];
  /**
   * The money basis: eachesQuantity when present, else quantity.
   * Produced by the order engine's own money-basis rule, never by a second expression here — a
   * diagnostic that answered "which quantity does money use" differently from the engine would be
   * a receipt for an arithmetic nobody performed.
   */
  quantityBasis: Scalars['Int']['output'];
};

/**
 * A price group's qualification conditions as configured, echoed into the trace. Both fields are
 * optional and independent: either alone, both (AND), or neither.
 */
export type ExplainedQualificationConditions = {
  __typename?: 'ExplainedQualificationConditions';
  /**
   * The minimum whole days between the placed day and the requested ship day, inclusive at the
   * boundary. None when the group imposes no lead time; 0 is a configured condition that
   * any forward-dated ship satisfies and is NOT the same as None.
   */
  minLeadTimeDays?: Maybe<Scalars['Int']['output']>;
  /**
   * The last day an order may be PLACED on and still qualify, inclusive, judged on the tenant's
   * business calendar. None when the group imposes no cutoff.
   */
  orderByDate?: Maybe<Scalars['LocalDate']['output']>;
};

/**
 * The rung a pooled line earned: which level set its price, at what threshold, and at what per-each
 * price. The pooled counterpart of winningLevelId, carrying the two numbers that make a pool
 * legible — "you reached the 504 rung at $4.74" — without the caller joining back to
 * candidateLevels.
 */
export type ExplainedRung = {
  __typename?: 'ExplainedRung';
  /** The per-each price charged. Always greater than zero: the kernel never emits a pooled $0. */
  price: Scalars['Decimal']['output'];
  /** The winning level's id. */
  priceLevelId: Scalars['String']['output'];
  /**
   * The winning level's threshold — compared against pooledQuantity, never against this line's
   * own quantity. A threshold above the line's own quantity is the whole point of the pool.
   */
  quantityThreshold: Scalars['Decimal']['output'];
};

/** MongoDB read model document for a favorites list. */
export type FavoritesListDocument = {
  __typename?: 'FavoritesListDocument';
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  favoritesListId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  items: Array<FavoritesListItemDocument>;
  lastModified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  scope: Scalars['Int']['output'];
  scopeId: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

/** MongoDB read model document for a favorites list. */
export type FavoritesListDocumentFilterInput = {
  and?: InputMaybe<Array<FavoritesListDocumentFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  favoritesListId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfFavoritesListItemDocumentFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FavoritesListDocumentFilterInput>>;
  scope?: InputMaybe<IntOperationFilterInput>;
  scopeId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for a favorites list. */
export type FavoritesListDocumentSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  favoritesListId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  scope?: InputMaybe<SortEnumType>;
  scopeId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type FavoritesListItemDataInput = {
  id: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** MongoDB read model document for a favorites list item. */
export type FavoritesListItemDocument = {
  __typename?: 'FavoritesListItemDocument';
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  /**
   * The item this entry named before the latest item combine pointed it at the kept item; null when
   * no combine moved it. Every write of the list's items, a combine or revert of another item
   * included, rewrites the items and clears it.
   */
  originalItemId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
};

/** MongoDB read model document for a favorites list item. */
export type FavoritesListItemDocumentFilterInput = {
  and?: InputMaybe<Array<FavoritesListItemDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FavoritesListItemDocumentFilterInput>>;
  /**
   * The item this entry named before the latest item combine pointed it at the kept item; null when
   * no combine moved it. Every write of the list's items, a combine or revert of another item
   * included, rewrites the items and clears it.
   */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
};

export type FavoritesListPayload = {
  __typename?: 'FavoritesListPayload';
  errors?: Maybe<Array<ValidationError>>;
  favoritesList?: Maybe<FavoritesListDocument>;
};

export enum FeasibilityStatus {
  FullySatisfied = 'FULLY_SATISFIED',
  Infeasible = 'INFEASIBLE',
  PartiallySatisfied = 'PARTIALLY_SATISFIED'
}

/**
 * Payload delivered to onFeatureFlagChanged subscribers. Tells the client
 * which flag to refetch. ChangedTenantIds is the tenant scope of
 * the change: null means the change is global (status toggle or global value
 * edit) and affects every tenant; otherwise it lists the tenants whose effective
 * resolution may have shifted (added or removed overrides).
 */
export type FeatureFlagChangedEvent = {
  __typename?: 'FeatureFlagChangedEvent';
  changedTenantIds?: Maybe<Array<Scalars['String']['output']>>;
  name: FeatureFlagName;
};

/** MongoDB read model document for a feature flag, including status, global value, and tenant overrides. */
export type FeatureFlagDocument = {
  __typename?: 'FeatureFlagDocument';
  /** The date the flag first appeared on master, as yyyy-MM-dd. */
  added: Scalars['String']['output'];
  config: Scalars['String']['output'];
  /** One line on what the flag turns on, or for a retired flag what it used to gate. */
  description: Scalars['String']['output'];
  /** The flag's plain name, such as Plan Builder for PRODUCE_PLAN_BUILDER. */
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  featureName: FeatureFlagName;
  /**
   * The 32-character id of the Helm project that adds this temporary flag. Null for standing and retired
   * flags, and for the older temporary flags that name none.
   */
  helmProjectId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**
   * What kind of flag this is: TEMPORARY while a feature is built or beta tested, removed once it is on for
   * every tenant; STANDING for a module tenants buy, a special feature or a kill switch; RETIRED once nothing
   * reads it. Declared in code with the flag, not stored.
   */
  kind: FeatureFlagKind;
  status: FeatureFlagStatus;
  tenantOverrideCount: Scalars['Int']['output'];
  tenantOverrides: Array<TenantOverrideDocument>;
};

/**
 * Where a tenant's answer for a flag comes from, as the admin Feature Flags page shows it: the flag is
 * switched off for everyone, the tenant has its own setting, one of its products turns it on, its trial
 * does not include it, or it has everyone's default.
 */
export enum FeatureFlagHolderSource {
  /** The tenant's own setting decides. */
  CustomerSetting = 'CUSTOMER_SETTING',
  /** Everyone's default decides. */
  Default = 'DEFAULT',
  /** The flag is inactive, so it is off for every tenant. */
  Inactive = 'INACTIVE',
  /** One of the tenant's products turns the flag on. */
  Product = 'PRODUCT',
  /** The tenant is on a trial that does not include the flag. */
  Trial = 'TRIAL',
  /** The default value; never the source of a real answer. */
  Unknown = 'UNKNOWN'
}

export enum FeatureFlagKind {
  Retired = 'RETIRED',
  Standing = 'STANDING',
  Temporary = 'TEMPORARY',
  Unknown = 'UNKNOWN'
}

export enum FeatureFlagName {
  ActivityCenter = 'ACTIVITY_CENTER',
  AiChat = 'AI_CHAT',
  AvailabilityApp = 'AVAILABILITY_APP',
  BackgroundJobs = 'BACKGROUND_JOBS',
  Benchmark = 'BENCHMARK',
  CostAccounting = 'COST_ACCOUNTING',
  CountApp = 'COUNT_APP',
  CustomerNotificationsDispatch = 'CUSTOMER_NOTIFICATIONS_DISPATCH',
  CustomerPortal = 'CUSTOMER_PORTAL',
  DataTransform = 'DATA_TRANSFORM',
  Edi = 'EDI',
  Engage = 'ENGAGE',
  EngageRfid = 'ENGAGE_RFID',
  ErpAccessDerivation = 'ERP_ACCESS_DERIVATION',
  EventsApp = 'EVENTS_APP',
  FernieRequestsTab = 'FERNIE_REQUESTS_TAB',
  FlatCharges = 'FLAT_CHARGES',
  Forecast = 'FORECAST',
  ForwarderAck = 'FORWARDER_ACK',
  FulfillDashboard = 'FULFILL_DASHBOARD',
  FulfillKits = 'FULFILL_KITS',
  FulfillLogistics = 'FULFILL_LOGISTICS',
  FulfillMaintenanceMenu = 'FULFILL_MAINTENANCE_MENU',
  GrowerBenchmarks = 'GROWER_BENCHMARKS',
  HardgoodShipCountRequests = 'HARDGOOD_SHIP_COUNT_REQUESTS',
  HomeDashboard = 'HOME_DASHBOARD',
  InboundDocuments = 'INBOUND_DOCUMENTS',
  InlineInventoryEdit = 'INLINE_INVENTORY_EDIT',
  Intelligence = 'INTELLIGENCE',
  InviteSignInCompletion = 'INVITE_SIGN_IN_COMPLETION',
  InvoiceEmail = 'INVOICE_EMAIL',
  JevDecisions = 'JEV_DECISIONS',
  LearningPath = 'LEARNING_PATH',
  MaterialApp = 'MATERIAL_APP',
  MaterialPriceCorrections = 'MATERIAL_PRICE_CORRECTIONS',
  MaterialPriceV2Writes = 'MATERIAL_PRICE_V2_WRITES',
  Notifications = 'NOTIFICATIONS',
  OrderAcknowledgmentEmail = 'ORDER_ACKNOWLEDGMENT_EMAIL',
  OrderConfirmationEmail = 'ORDER_CONFIRMATION_EMAIL',
  OrderCorrection = 'ORDER_CORRECTION',
  PdfGenerator = 'PDF_GENERATOR',
  PersonalizedPricingPage = 'PERSONALIZED_PRICING_PAGE',
  PooledPricing = 'POOLED_PRICING',
  PortalDeliveryDateEnforcement = 'PORTAL_DELIVERY_DATE_ENFORCEMENT',
  PriceGroupQualificationEnforcement = 'PRICE_GROUP_QUALIFICATION_ENFORCEMENT',
  Produce = 'PRODUCE',
  ProducedLotFulfillInventory = 'PRODUCED_LOT_FULFILL_INVENTORY',
  ProduceConsolidation = 'PRODUCE_CONSOLIDATION',
  ProducePlanBuilder = 'PRODUCE_PLAN_BUILDER',
  ProductionCenter = 'PRODUCTION_CENTER',
  PurchasingPoWorkspace = 'PURCHASING_PO_WORKSPACE',
  /** Per-tenant release gate for the Ramp integration (Settings > Integrations > Ramp, vendor link, PO invoices card, RampSync worker). Default OFF. */
  RampInvoices = 'RAMP_INVOICES',
  ReapplyRecipes = 'REAPPLY_RECIPES',
  ReportProductionCostsEnabled = 'REPORT_PRODUCTION_COSTS_ENABLED',
  ReportUnitsAndEaches = 'REPORT_UNITS_AND_EACHES',
  Restock = 'RESTOCK',
  RoyaltyEnabled = 'ROYALTY_ENABLED',
  SavedViews = 'SAVED_VIEWS',
  ScheduledItemTransfers = 'SCHEDULED_ITEM_TRANSFERS',
  ShipToCombine = 'SHIP_TO_COMBINE',
  SmsNotifications = 'SMS_NOTIFICATIONS',
  SnapSpeakLook = 'SNAP_SPEAK_LOOK',
  StoreClasses = 'STORE_CLASSES',
  SupplierPriceImportApplyEnabled = 'SUPPLIER_PRICE_IMPORT_APPLY_ENABLED',
  Tags = 'TAGS',
  TaxCalculationEnabled = 'TAX_CALCULATION_ENABLED',
  TenantLocalDateWindows = 'TENANT_LOCAL_DATE_WINDOWS',
  Unknown = 'UNKNOWN',
  UseErpAvailability = 'USE_ERP_AVAILABILITY',
  Verify = 'VERIFY',
  WhatsNew = 'WHATS_NEW'
}

export type FeatureFlagNameOperationFilterInput = {
  eq?: InputMaybe<FeatureFlagName>;
  in?: InputMaybe<Array<FeatureFlagName>>;
  neq?: InputMaybe<FeatureFlagName>;
  nin?: InputMaybe<Array<FeatureFlagName>>;
};

/** One catalog product the conversion ensures. */
export type FeatureFlagProductConversionCatalogProduct = {
  __typename?: 'FeatureFlagProductConversionCatalogProduct';
  /** True when the catalog held it already; false when the conversion creates it. */
  existed: Scalars['Boolean']['output'];
  /** The flags it turns on. */
  flags: Array<FeatureFlagName>;
  /** True when a tenant gets it because its Contracted Products text names it. */
  fromContractedProductsText: Scalars['Boolean']['output'];
  /** True when every tenant has it. */
  includedForEveryCustomer: Scalars['Boolean']['output'];
  /** Its name. */
  name: Scalars['String']['output'];
  /** Its id: the catalog's, or the one the conversion creates it under. */
  workSuiteProductId: Scalars['String']['output'];
};

/** A flag whose answer the conversion would change. */
export type FeatureFlagProductConversionDifference = {
  __typename?: 'FeatureFlagProductConversionDifference';
  /** Its answer after the conversion. */
  after: FeatureFlagProductConversionValue;
  /** Its answer now. */
  before: FeatureFlagProductConversionValue;
  /** The flag. */
  flag: FeatureFlagName;
};

/**
 * One feature flag product conversion job: where it is and how far it has got. The worker discovers open jobs here
 * and advances each one chunk per call.
 */
export type FeatureFlagProductConversionJob = {
  __typename?: 'FeatureFlagProductConversionJob';
  /** How many tenants one chunk holds. */
  chunkSize: Scalars['Int']['output'];
  /** How many chunks are applied. */
  chunksApplied: Scalars['Int']['output'];
  /** How many chunks those tenants make. */
  chunksTotal: Scalars['Int']['output'];
  /** When the job reached Completed, Refused, Failed or Cancelled; null while it is open. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the job was started. */
  createdAt: Scalars['DateTime']['output'];
  /** The job id, which addresses the job in every job operation. */
  jobId: Scalars['String']['output'];
  /** Why a Refused or Failed job stopped; null otherwise. */
  refusalReason?: Maybe<Scalars['String']['output']>;
  /** The superadmin who started the job. */
  requestedBy: Scalars['String']['output'];
  /** Where the job is. */
  status: FeatureFlagProductConversionJobStatus;
  /** How many tenants the job converts. */
  tenantCount: Scalars['Int']['output'];
  /** How many of the job's tenants are in applied chunks. */
  tenantsConverted: Scalars['Int']['output'];
};

export enum FeatureFlagProductConversionJobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refused = 'REFUSED',
  Running = 'RUNNING',
  Unknown = 'UNKNOWN'
}

/**
 * What the conversion does, tenant by tenant, and the check that it changes no tenant's flags: every tenant's products,
 * own-setting changes, Learning modules before and after, and every flag whose answer would differ.
 */
export type FeatureFlagProductConversionReport = {
  __typename?: 'FeatureFlagProductConversionReport';
  /** The catalog products the conversion ensures, in catalog-table order. */
  catalog: Array<FeatureFlagProductConversionCatalogProduct>;
  /** How many resolved flags the conversion would change, over every tenant. It must be 0: a real run is refused otherwise. */
  differenceCount: Scalars['Int']['output'];
  /** True when nothing was written. */
  dryRun: Scalars['Boolean']['output'];
  /** How many tenants were planned. */
  tenantCount: Scalars['Int']['output'];
  /** Every planned tenant, in tenant-id order. */
  tenants: Array<FeatureFlagProductConversionTenantReport>;
  /** How many of them the conversion changes anything of. */
  tenantsToConvert: Scalars['Int']['output'];
};

/** One tenant's conversion. */
export type FeatureFlagProductConversionTenantReport = {
  __typename?: 'FeatureFlagProductConversionTenantReport';
  /** The flags whose answer the conversion would change for the tenant; none in a safe plan. */
  differences: Array<FeatureFlagProductConversionDifference>;
  /** The Learning modules they give after the conversion. */
  learningModulesAfter: Array<LearningModule>;
  /** The Learning modules the tenant's Contracted Products give now. */
  learningModulesBefore: Array<LearningModule>;
  /** Its name. */
  name: Scalars['String']['output'];
  /** The flags whose own setting it leaves as it is. */
  overridesKept: Array<FeatureFlagName>;
  /** The flags whose own setting it makes settings only, config kept. */
  overridesMadeSettingsOnly: Array<FeatureFlagName>;
  /** The flags whose own setting the conversion removes. */
  overridesRemoved: Array<FeatureFlagName>;
  /** The products it has after the conversion, the products every tenant has first. */
  productNames: Array<Scalars['String']['output']>;
  /** The products the conversion gives it. */
  productsAdded: Array<Scalars['String']['output']>;
  /** The tenant. */
  tenantId: Scalars['String']['output'];
};

/** A flag's answer for a tenant: whether it is on, and its merged config. */
export type FeatureFlagProductConversionValue = {
  __typename?: 'FeatureFlagProductConversionValue';
  /** The merged config JSON. */
  config: Scalars['String']['output'];
  /** Whether the flag is on. */
  enabled: Scalars['Boolean']['output'];
};

export enum FeatureFlagResolutionReason {
  Global = 'GLOBAL',
  Inactive = 'INACTIVE',
  Product = 'PRODUCT',
  TenantOverride = 'TENANT_OVERRIDE',
  TrialSuppressed = 'TRIAL_SUPPRESSED'
}

/**
 * One row of the allFeatureFlags query result: a feature flag name with the
 * effective config and enabled state for the authenticated tenant, plus the reason it
 * resolved that way (see FeatureFlagResolutionReason) — e.g. distinguishing a flag
 * that reads false because it is switched off from one that reads false because the
 * tenant's trial policy suppresses it.
 */
export type FeatureFlagResolvedItem = {
  __typename?: 'FeatureFlagResolvedItem';
  config: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  name: FeatureFlagName;
  reason: FeatureFlagResolutionReason;
};

/** Data projection of feature flag state returned in mutation payloads. */
export type FeatureFlagStateData = {
  __typename?: 'FeatureFlagStateData';
  config: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  featureName: FeatureFlagName;
  status: FeatureFlagStatus;
};

export enum FeatureFlagStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type FeatureFlagStatusOperationFilterInput = {
  eq?: InputMaybe<FeatureFlagStatus>;
  in?: InputMaybe<Array<FeatureFlagStatus>>;
  neq?: InputMaybe<FeatureFlagStatus>;
  nin?: InputMaybe<Array<FeatureFlagStatus>>;
};

/**
 * Result containing the resolved feature flag value for the authenticated tenant, plus the reason
 * it resolved that way (see FeatureFlagResolutionReason) — e.g. distinguishing a flag
 * that reads false because it is switched off from one that reads false because the
 * tenant's trial policy suppresses it.
 */
export type FeatureFlagValueResult = {
  __typename?: 'FeatureFlagValueResult';
  config: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  reason: FeatureFlagResolutionReason;
};

export type FernieAccountingCandidate = {
  __typename?: 'FernieAccountingCandidate';
  detail?: Maybe<Scalars['String']['output']>;
  /** The value Use saves: a QuickBooks customer id or a Stripe tax code. */
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** A missing-data gap fernie can fill from the grower's own records. */
export enum FernieFillableGap {
  CatalogNoColor = 'CATALOG_NO_COLOR',
  CategoryNoShippingUom = 'CATEGORY_NO_SHIPPING_UOM',
  CustomerCatchAllType = 'CUSTOMER_CATCH_ALL_TYPE',
  CustomerNoTerms = 'CUSTOMER_NO_TERMS',
  CustomerNoType = 'CUSTOMER_NO_TYPE',
  ItemNoCategory = 'ITEM_NO_CATEGORY',
  ItemNoShippingUom = 'ITEM_NO_SHIPPING_UOM',
  MaterialNoDefaultVendor = 'MATERIAL_NO_DEFAULT_VENDOR',
  MaterialNoType = 'MATERIAL_NO_TYPE',
  MaterialVendorNoPurchaseUnit = 'MATERIAL_VENDOR_NO_PURCHASE_UNIT',
  OrderNoRoute = 'ORDER_NO_ROUTE',
  ProductionItemNoRecipe = 'PRODUCTION_ITEM_NO_RECIPE',
  ProductionJobNoLocation = 'PRODUCTION_JOB_NO_LOCATION',
  ProductionJobSpaceWeekNoSpaceType = 'PRODUCTION_JOB_SPACE_WEEK_NO_SPACE_TYPE',
  ProductionRecipeNoMaterials = 'PRODUCTION_RECIPE_NO_MATERIALS',
  ShipToNoPriceGroup = 'SHIP_TO_NO_PRICE_GROUP',
  SubLocationNoDefaultSpaceType = 'SUB_LOCATION_NO_DEFAULT_SPACE_TYPE',
  TaskEventNoLaborType = 'TASK_EVENT_NO_LABOR_TYPE',
  Unknown = 'UNKNOWN'
}

export type FernieFindCandidate = {
  __typename?: 'FernieFindCandidate';
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type FernieFindCandidatesInput = {
  kind: FernieFindKind;
  /** Narrows the list: the customer id for SHIP_TO, the site id for SITE_LOCATION, the vendor id for MATERIAL and PURCHASE_ORDER. */
  scopeId?: InputMaybe<Scalars['String']['input']>;
  /** The person's words, in any order. 200 characters at most. */
  text: Scalars['String']['input'];
};

export type FernieFindCandidatesPayload = {
  __typename?: 'FernieFindCandidatesPayload';
  /** Eligible records sharing any typed word or word start, best first, at most 250. */
  candidates: Array<FernieFindCandidate>;
  errors?: Maybe<Array<Error>>;
};

export enum FernieFindKind {
  HardGood = 'HARD_GOOD',
  ItemCharacteristic = 'ITEM_CHARACTERISTIC',
  Kit = 'KIT',
  Material = 'MATERIAL',
  Order = 'ORDER',
  PriceGroup = 'PRICE_GROUP',
  ProductionCatalog = 'PRODUCTION_CATALOG',
  ProductionCategory = 'PRODUCTION_CATEGORY',
  ProductionJob = 'PRODUCTION_JOB',
  ProductionPlan = 'PRODUCTION_PLAN',
  PurchaseOrder = 'PURCHASE_ORDER',
  Recipe = 'RECIPE',
  ShipTo = 'SHIP_TO',
  Site = 'SITE',
  SiteLocation = 'SITE_LOCATION',
  User = 'USER',
  Vendor = 'VENDOR'
}

export type FernieGapCandidate = {
  __typename?: 'FernieGapCandidate';
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type FernieGapCandidatesInput = {
  gap: FernieFillableGap;
  /** The records to suggest for, 1 to 200. Omit to take the first 200 records with this gap. */
  recordIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FernieGapCandidatesPayload = {
  __typename?: 'FernieGapCandidatesPayload';
  errors?: Maybe<Array<Error>>;
  records: Array<FernieGapRecord>;
};

export type FernieGapFillValueInput = {
  recordId: Scalars['String']['input'];
  /** The id of the candidate the person used, or the value they edited it to. */
  valueId: Scalars['String']['input'];
};

export type FernieGapJob = {
  __typename?: 'FernieGapJob';
  errors: Array<Error>;
  fillJobId: Scalars['String']['output'];
  filled: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  kind: FernieGapJobKind;
  processed: Scalars['Int']['output'];
  records: Array<FernieGapJobRecord>;
  restored: Scalars['Int']['output'];
  status: FernieGapJobStatus;
  total: Scalars['Int']['output'];
};

export enum FernieGapJobKind {
  Fill = 'FILL',
  Undo = 'UNDO',
  Unknown = 'UNKNOWN'
}

export type FernieGapJobRecord = {
  __typename?: 'FernieGapJobRecord';
  reason?: Maybe<Scalars['String']['output']>;
  recordId: Scalars['String']['output'];
  status: FernieGapRecordStatus;
};

export enum FernieGapJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Unknown = 'UNKNOWN'
}

export type FernieGapRecord = {
  __typename?: 'FernieGapRecord';
  /** The grower's own values that could fill the gap, narrowed by code, best first. At most 250. For CATALOG_NO_COLOR each id is 'series|color'; for PRODUCTION_RECIPE_NO_MATERIALS each id is a donor recipe id. */
  candidates: Array<FernieGapCandidate>;
  /** The record with the gap: an item, category, customer, ship-to, order, material, sub-location, task event, job, production item, recipe or catalog. */
  recordId: Scalars['String']['output'];
  recordLabel: Scalars['String']['output'];
  /** Words that describe the record for the pick, e.g. the item name and container. 300 characters at most. */
  wording: Scalars['String']['output'];
};

export enum FernieGapRecordStatus {
  ChangedSinceFill = 'CHANGED_SINCE_FILL',
  Filled = 'FILLED',
  NotRestored = 'NOT_RESTORED',
  Pending = 'PENDING',
  Refused = 'REFUSED',
  Restored = 'RESTORED',
  Unknown = 'UNKNOWN'
}

export type FernieQuickBooksLinkRow = {
  __typename?: 'FernieQuickBooksLinkRow';
  /** The tenant's synced QuickBooks customers that share a word with this customer's name, best first, at most 50. */
  candidates: Array<FernieAccountingCandidate>;
  /** The customer's billing city and email, when it has them. */
  customerDetail?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
};

export type FernieQuickBooksLinksInput = {
  /** The endCursor of the previous page. Omit for the first page. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** How many customers to return, 1 to 50. */
  first?: Scalars['Int']['input'];
};

export type FernieQuickBooksLinksPayload = {
  __typename?: 'FernieQuickBooksLinksPayload';
  /** Pass as after for the next page. Null on the last page. */
  endCursor?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** Active customers whose next invoice export would create a QuickBooks customer by name, ordered by name. */
  rows: Array<FernieQuickBooksLinkRow>;
  /** How many such customers the tenant has. */
  totalCount: Scalars['Int']['output'];
};

export type FernieStripeTaxCodeCandidatesInput = {
  /** The item's category. Omit for an item with no category. */
  categoryId?: InputMaybe<Scalars['String']['input']>;
};

export type FernieStripeTaxCodeCandidatesPayload = {
  __typename?: 'FernieStripeTaxCodeCandidatesPayload';
  /** At most 250, best first: the codes the tenant's Active items in the category use, most used first, then the codes its other items use, then the rest of Stripe's list. */
  candidates: Array<FernieAccountingCandidate>;
  errors?: Maybe<Array<Error>>;
};

export type FernieValueInUse = {
  __typename?: 'FernieValueInUse';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** How many active records use this value. */
  usageCount: Scalars['Int']['output'];
  /** What usageCount counts, e.g. items, customers, jobs. */
  usageNoun: Scalars['String']['output'];
};

export enum FernieValueList {
  BatchCode = 'BATCH_CODE',
  Carrier = 'CARRIER',
  CatalogColor = 'CATALOG_COLOR',
  CatalogGenus = 'CATALOG_GENUS',
  CatalogSeries = 'CATALOG_SERIES',
  CharacteristicName = 'CHARACTERISTIC_NAME',
  /** scopeId = the characteristic id */
  CharacteristicValue = 'CHARACTERISTIC_VALUE',
  ContainerCategoryCode = 'CONTAINER_CATEGORY_CODE',
  ContainerCode = 'CONTAINER_CODE',
  ContainerName = 'CONTAINER_NAME',
  CustomerGroup = 'CUSTOMER_GROUP',
  CustomerName = 'CUSTOMER_NAME',
  CustomerType = 'CUSTOMER_TYPE',
  ErpPriceGroupId = 'ERP_PRICE_GROUP_ID',
  ItemCategory = 'ITEM_CATEGORY',
  ItemCode = 'ITEM_CODE',
  ItemGroup = 'ITEM_GROUP',
  ItemSubcategory = 'ITEM_SUBCATEGORY',
  KindOfWork = 'KIND_OF_WORK',
  KitName = 'KIT_NAME',
  LaborType = 'LABOR_TYPE',
  MaterialCategory = 'MATERIAL_CATEGORY',
  MaterialEventName = 'MATERIAL_EVENT_NAME',
  MaterialType = 'MATERIAL_TYPE',
  PriceGroup = 'PRICE_GROUP',
  ProductionCategoryCode = 'PRODUCTION_CATEGORY_CODE',
  ProductionCategoryLabel = 'PRODUCTION_CATEGORY_LABEL',
  ProductionPlan = 'PRODUCTION_PLAN',
  Program = 'PROGRAM',
  PurchaseUnit = 'PURCHASE_UNIT',
  RetailerName = 'RETAILER_NAME',
  Route = 'ROUTE',
  RoyaltyPayee = 'ROYALTY_PAYEE',
  ShippingUomCode = 'SHIPPING_UOM_CODE',
  ShipToAdGroup = 'SHIP_TO_AD_GROUP',
  ShipToMarket = 'SHIP_TO_MARKET',
  ShipToRegion = 'SHIP_TO_REGION',
  SiteLocation = 'SITE_LOCATION',
  SpaceCategoryCode = 'SPACE_CATEGORY_CODE',
  SpaceEventName = 'SPACE_EVENT_NAME',
  SpaceTypeCode = 'SPACE_TYPE_CODE',
  StoreClass = 'STORE_CLASS',
  StoreZone = 'STORE_ZONE',
  TaskEventName = 'TASK_EVENT_NAME',
  TaskEventType = 'TASK_EVENT_TYPE',
  Terms = 'TERMS',
  TriggerName = 'TRIGGER_NAME',
  /** Not a list; the zero value. A request that names it is refused. */
  Unknown = 'UNKNOWN',
  UpgradeCategory = 'UPGRADE_CATEGORY',
  VehicleName = 'VEHICLE_NAME',
  VehicleTypeName = 'VEHICLE_TYPE_NAME',
  Vendor = 'VENDOR',
  VolumePool = 'VOLUME_POOL'
}

export type FernieValuesInUseInput = {
  list: FernieValueList;
  /** Narrows a list that lives under a parent: the catalog genus for CATALOG_SERIES, the item id for BATCH_CODE, the parent location for SITE_LOCATION, the characteristic id for CHARACTERISTIC_VALUE. */
  scopeId?: InputMaybe<Scalars['String']['input']>;
  /** The typed text. The closest values come first; case, spacing, punctuation and one trailing s are ignored. */
  text: Scalars['String']['input'];
};

export type FernieValuesInUsePayload = {
  __typename?: 'FernieValuesInUsePayload';
  errors?: Maybe<Array<Error>>;
  /** At most 250 values, closest first. */
  values: Array<FernieValueInUse>;
};

export type FieldMappingData = {
  __typename?: 'FieldMappingData';
  kind: FieldMappingKind;
  sanitize: Scalars['Boolean']['output'];
  sourceField: Scalars['String']['output'];
  targetField: Scalars['String']['output'];
};

export type FieldMappingDataFilterInput = {
  and?: InputMaybe<Array<FieldMappingDataFilterInput>>;
  kind?: InputMaybe<FieldMappingKindOperationFilterInput>;
  or?: InputMaybe<Array<FieldMappingDataFilterInput>>;
  sanitize?: InputMaybe<BooleanOperationFilterInput>;
  sourceField?: InputMaybe<StringOperationFilterInput>;
  targetField?: InputMaybe<StringOperationFilterInput>;
};

export type FieldMappingInput = {
  kind: FieldMappingKind;
  sanitize: Scalars['Boolean']['input'];
  sourceField: Scalars['String']['input'];
  targetField: Scalars['String']['input'];
};

export enum FieldMappingKind {
  Column = 'COLUMN',
  Literal = 'LITERAL'
}

export type FieldMappingKindOperationFilterInput = {
  eq?: InputMaybe<FieldMappingKind>;
  in?: InputMaybe<Array<FieldMappingKind>>;
  neq?: InputMaybe<FieldMappingKind>;
  nin?: InputMaybe<Array<FieldMappingKind>>;
};

export type FillFernieGapsInput = {
  /** 1 to 500 fills. */
  fills: Array<FernieGapFillValueInput>;
  gap: FernieFillableGap;
};

export type FillFernieGapsPayload = {
  __typename?: 'FillFernieGapsPayload';
  errors?: Maybe<Array<Error>>;
  filled: Scalars['Int']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  /** The fill job id. Pass to undoFernieGapFill within 24 hours; only records still filled or not restored are retried. */
  undoToken?: Maybe<Scalars['String']['output']>;
};

export type FinalizeImportUploadInput = {
  asyncImportJobId: Scalars['String']['input'];
};

/** Everything a caller needs to flash one release: the manifest, and a link per file. */
export type FirmwareDownload = {
  __typename?: 'FirmwareDownload';
  deviceModel: Scalars['String']['output'];
  files: Array<FirmwareFile>;
  firmwareName: Scalars['String']['output'];
  manifestUrl?: Maybe<Scalars['String']['output']>;
  sha: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** One published file within a release. */
export type FirmwareFile = {
  __typename?: 'FirmwareFile';
  /**
   * This file's download URL: a plain blob URL while the container is public, a short-lived
   * read-only signed URL once it is not. Empty when no link can be minted — which a caller should
   * surface rather than retry, because the usual cause is a missing role assignment.
   */
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  sizeInBytes: Scalars['Long']['output'];
};

/** One published firmware build and the files it contains. */
export type FirmwareRelease = {
  __typename?: 'FirmwareRelease';
  deviceModel: Scalars['String']['output'];
  files: Array<FirmwareFile>;
  firmwareName: Scalars['String']['output'];
  sha: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type FlagStaleEntriesInput = {
  floatingTimeEntryId: Scalars['String']['input'];
};

/**
 * The GraphQL-exposed shape of an un-migrated location — the worklist entry Nathan acts on. Kept as
 * its own boundary type, distinct from the migration's internal planning row, so the migration's
 * read-side logic (which reads raw legacy BSON) and the public payload sub-type can evolve
 * independently — the isolation the repo's Data-suffix boundary-type convention exists to enforce.
 */
export type FlatCapacityMigrationCandidateData = {
  __typename?: 'FlatCapacityMigrationCandidateData';
  capacity: Scalars['Decimal']['output'];
  defaultSpaceTypeId?: Maybe<Scalars['String']['output']>;
  siteLocationId: Scalars['String']['output'];
  subLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** What one run of the flat-capacity migration did. */
export type FlatCapacityMigrationPayload = {
  __typename?: 'FlatCapacityMigrationPayload';
  /** One entry per candidate whose migration failed. Does not abort the run. */
  errors?: Maybe<Array<ValidationError>>;
  /** Locations whose flat capacity became a per-space-type capacity row. */
  migrated: Scalars['Int']['output'];
  /**
   * Locations with non-zero flat capacity and no default space type — NOT migrated. Hand this list to
   * Nathan so defaults can be assigned before prod; a re-run finds exactly this list again (shrinking as
   * defaults are assigned) until it is empty.
   */
  missingDefaultSpaceType: Array<FlatCapacityMigrationCandidateData>;
  /** Locations whose stale zero-capacity field was cleared; nothing to migrate. */
  zeroCapacityCleared: Scalars['Int']['output'];
};

/**
 * Read-model document for one entry on a tenant's charge list, keyed {tenantId}-{flatChargeTypeId}.
 * Entries are never deleted: a deactivated entry stays, so an order or invoice that used it always resolves it.
 */
export type FlatChargeTypeDocument = {
  __typename?: 'FlatChargeTypeDocument';
  /** Linked Chart-of-Accounts row resolved from accountId. Null when the entry has no account mapped, or when the linked account no longer exists for the tenant. */
  account?: Maybe<MergeDevAccountDocument>;
  /** The QuickBooks account's stable ImportId; null when no account is mapped. Resolved by account. */
  accountId?: Maybe<Scalars['String']['output']>;
  flatChargeTypeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Whether a charge added from this entry is taxable unless the order says otherwise. */
  taxable: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Read-model document for one entry on a tenant's charge list, keyed {tenantId}-{flatChargeTypeId}.
 * Entries are never deleted: a deactivated entry stays, so an order or invoice that used it always resolves it.
 */
export type FlatChargeTypeDocumentFilterInput = {
  /** The QuickBooks account's stable ImportId; null when no account is mapped. Resolved by account. */
  accountId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<FlatChargeTypeDocumentFilterInput>>;
  flatChargeTypeId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FlatChargeTypeDocumentFilterInput>>;
  /** Whether a charge added from this entry is taxable unless the order says otherwise. */
  taxable?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one entry on a tenant's charge list, keyed {tenantId}-{flatChargeTypeId}.
 * Entries are never deleted: a deactivated entry stays, so an order or invoice that used it always resolves it.
 */
export type FlatChargeTypeDocumentSortInput = {
  /** The QuickBooks account's stable ImportId; null when no account is mapped. Resolved by account. */
  accountId?: InputMaybe<SortEnumType>;
  flatChargeTypeId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /** Whether a charge added from this entry is taxable unless the order says otherwise. */
  taxable?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type FlatChargeTypePayload = {
  __typename?: 'FlatChargeTypePayload';
  errors?: Maybe<Array<ValidationError>>;
  flatChargeType?: Maybe<FlatChargeTypeStateData>;
};

/** GraphQL output of one charge-list entry's post-event state. */
export type FlatChargeTypeStateData = {
  __typename?: 'FlatChargeTypeStateData';
  accountId?: Maybe<Scalars['String']['output']>;
  flatChargeTypeId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  taxable: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type FlatChargeTypesConnection = {
  __typename?: 'FlatChargeTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FlatChargeTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FlatChargeTypeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FlatChargeTypesEdge = {
  __typename?: 'FlatChargeTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FlatChargeTypeDocument;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

/** A connection to a list of items. */
export type FloatingTimeEntriesConnection = {
  __typename?: 'FloatingTimeEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FloatingTimeEntriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FloatingTimeEntryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FloatingTimeEntriesEdge = {
  __typename?: 'FloatingTimeEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FloatingTimeEntryDocument;
};

/** GraphQL data type for a floating time entry allocation. */
export type FloatingTimeEntryAllocationData = {
  __typename?: 'FloatingTimeEntryAllocationData';
  duration: Scalars['TimeSpan']['output'];
  taskAssignmentId: Scalars['String']['output'];
};

/** MongoDB sub-document for a floating time entry allocation. */
export type FloatingTimeEntryAllocationDocument = {
  __typename?: 'FloatingTimeEntryAllocationDocument';
  duration: Scalars['TimeSpan']['output'];
  taskAssignmentId: Scalars['String']['output'];
  timeEntryId: Scalars['String']['output'];
};

/** MongoDB sub-document for a floating time entry allocation. */
export type FloatingTimeEntryAllocationDocumentFilterInput = {
  and?: InputMaybe<Array<FloatingTimeEntryAllocationDocumentFilterInput>>;
  duration?: InputMaybe<TimeSpanOperationFilterInput>;
  or?: InputMaybe<Array<FloatingTimeEntryAllocationDocumentFilterInput>>;
  taskAssignmentId?: InputMaybe<StringOperationFilterInput>;
  timeEntryId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for the FloatingTimeEntry aggregate. */
export type FloatingTimeEntryDocument = {
  __typename?: 'FloatingTimeEntryDocument';
  allocatedDuration: Scalars['TimeSpan']['output'];
  allocations: Array<FloatingTimeEntryAllocationDocument>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  duration?: Maybe<Scalars['TimeSpan']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  floatingTimeEntryId: Scalars['String']['output'];
  headcount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isStale: Scalars['Boolean']['output'];
  remainingDuration: Scalars['TimeSpan']['output'];
  /**
   * Timestamp at which the entry was flagged stale. Null when the entry has never
   * been flagged, or was subsequently linked/partially-linked/discarded (which clear
   * the flag and the timestamp together). Independent of UpdatedAt so
   * the audit trail is not perturbed by the stale-flag advisory.
   */
  staleFlaggedAt?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status: FloatingTimeEntryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  workerId: Scalars['String']['output'];
};

/** MongoDB read model document for the FloatingTimeEntry aggregate. */
export type FloatingTimeEntryDocumentFilterInput = {
  allocatedDuration?: InputMaybe<TimeSpanOperationFilterInput>;
  allocations?: InputMaybe<ListFilterInputTypeOfFloatingTimeEntryAllocationDocumentFilterInput>;
  and?: InputMaybe<Array<FloatingTimeEntryDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  duration?: InputMaybe<TimeSpanOperationFilterInput>;
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  floatingTimeEntryId?: InputMaybe<StringOperationFilterInput>;
  headcount?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isStale?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FloatingTimeEntryDocumentFilterInput>>;
  remainingDuration?: InputMaybe<TimeSpanOperationFilterInput>;
  /**
   * Timestamp at which the entry was flagged stale. Null when the entry has never
   * been flagged, or was subsequently linked/partially-linked/discarded (which clear
   * the flag and the timestamp together). Independent of UpdatedAt so
   * the audit trail is not perturbed by the stale-flag advisory.
   */
  staleFlaggedAt?: InputMaybe<DateTimeOperationFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<FloatingTimeEntryStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  workerId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for the FloatingTimeEntry aggregate. */
export type FloatingTimeEntryDocumentSortInput = {
  allocatedDuration?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  floatingTimeEntryId?: InputMaybe<SortEnumType>;
  headcount?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isStale?: InputMaybe<SortEnumType>;
  remainingDuration?: InputMaybe<SortEnumType>;
  /**
   * Timestamp at which the entry was flagged stale. Null when the entry has never
   * been flagged, or was subsequently linked/partially-linked/discarded (which clear
   * the flag and the timestamp together). Independent of UpdatedAt so
   * the audit trail is not perturbed by the stale-flag advisory.
   */
  staleFlaggedAt?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  workerId?: InputMaybe<SortEnumType>;
};

/** GraphQL payload for FloatingTimeEntry mutations. */
export type FloatingTimeEntryPayload = {
  __typename?: 'FloatingTimeEntryPayload';
  errors?: Maybe<Array<ValidationError>>;
  floatingTimeEntry?: Maybe<FloatingTimeEntryStateData>;
};

/** GraphQL data type for FloatingTimeEntry state. */
export type FloatingTimeEntryStateData = {
  __typename?: 'FloatingTimeEntryStateData';
  allocatedDuration: Scalars['TimeSpan']['output'];
  allocations: Array<FloatingTimeEntryAllocationData>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  duration?: Maybe<Scalars['TimeSpan']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  floatingTimeEntryId: Scalars['String']['output'];
  headcount: Scalars['Int']['output'];
  isStale: Scalars['Boolean']['output'];
  remainingDuration: Scalars['TimeSpan']['output'];
  staleFlaggedAt?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status: FloatingTimeEntryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  workerId: Scalars['String']['output'];
};

export enum FloatingTimeEntryStatus {
  Discarded = 'DISCARDED',
  Linked = 'LINKED',
  PartiallyLinked = 'PARTIALLY_LINKED',
  Running = 'RUNNING',
  Unlinked = 'UNLINKED'
}

export type FloatingTimeEntryStatusOperationFilterInput = {
  eq?: InputMaybe<FloatingTimeEntryStatus>;
  in?: InputMaybe<Array<FloatingTimeEntryStatus>>;
  neq?: InputMaybe<FloatingTimeEntryStatus>;
  nin?: InputMaybe<Array<FloatingTimeEntryStatus>>;
};

export type ForceCancelStuckReservationInput = {
  allocationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type ForceFailConsolidationApplicationInput = {
  applicationId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type ForceReadyHandoffStuckReservationInput = {
  allocationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/**
 * Read-model document for one forecast header, keyed by tenantId-forecastId. The composite _id
 * embeds the tenant, so single-forecast reads filter on _id and cannot leak across tenants
 * (discipline acada0ab); list reads filter on TenantId plus IsDeleted so soft-deleted forecasts are
 * excluded (guarded by a cross-tenant leak integration test). Machine-generated plan/weekly rows are
 * separate worker-owned collections (later slices) — this document holds only the header.
 */
export type ForecastDocument = {
  __typename?: 'ForecastDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  /** The forecast customer's display name, resolved at query time from the customer's CustomersSummary row (scoped to the calling tenant) rather than stored on the forecast, so it always reflects the current customer name. Empty when the customer id has no summary row in the tenant. */
  customerName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  forecastId: Scalars['String']['output'];
  /**
   * Server-driven generation run status (W9), projected from the Started/Progressed/Completed/Failed
   * events so the PWA can poll a single field for progress and the final override accounting. Null until
   * the forecast's first generation run starts.
   */
  generationStatus?: Maybe<ForecastGenerationStatusView>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  level: ForecastLevel;
  lockedConfig: ForecastLockedConfig;
  name: Scalars['String']['output'];
  programIds: Array<Scalars['String']['output']>;
  scenarioSlot: ForecastScenarioSlot;
  startDate: Scalars['DateTime']['output'];
  status: ForecastStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  weeklyMetric: ForecastWeeklyMetric;
};

/**
 * Read-model document for one forecast header, keyed by tenantId-forecastId. The composite _id
 * embeds the tenant, so single-forecast reads filter on _id and cannot leak across tenants
 * (discipline acada0ab); list reads filter on TenantId plus IsDeleted so soft-deleted forecasts are
 * excluded (guarded by a cross-tenant leak integration test). Machine-generated plan/weekly rows are
 * separate worker-owned collections (later slices) — this document holds only the header.
 */
export type ForecastDocumentFilterInput = {
  and?: InputMaybe<Array<ForecastDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  forecastId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Server-driven generation run status (W9), projected from the Started/Progressed/Completed/Failed
   * events so the PWA can poll a single field for progress and the final override accounting. Null until
   * the forecast's first generation run starts.
   */
  generationStatus?: InputMaybe<ForecastGenerationStatusViewFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  level?: InputMaybe<ForecastLevelOperationFilterInput>;
  lockedConfig?: InputMaybe<ForecastLockedConfigFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ForecastDocumentFilterInput>>;
  programIds?: InputMaybe<ListStringOperationFilterInput>;
  scenarioSlot?: InputMaybe<ForecastScenarioSlotOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ForecastStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  weeklyMetric?: InputMaybe<ForecastWeeklyMetricOperationFilterInput>;
};

/**
 * Read-model document for one forecast header, keyed by tenantId-forecastId. The composite _id
 * embeds the tenant, so single-forecast reads filter on _id and cannot leak across tenants
 * (discipline acada0ab); list reads filter on TenantId plus IsDeleted so soft-deleted forecasts are
 * excluded (guarded by a cross-tenant leak integration test). Machine-generated plan/weekly rows are
 * separate worker-owned collections (later slices) — this document holds only the header.
 */
export type ForecastDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  forecastId?: InputMaybe<SortEnumType>;
  /**
   * Server-driven generation run status (W9), projected from the Started/Progressed/Completed/Failed
   * events so the PWA can poll a single field for progress and the final override accounting. Null until
   * the forecast's first generation run starts.
   */
  generationStatus?: InputMaybe<ForecastGenerationStatusViewSortInput>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  level?: InputMaybe<SortEnumType>;
  lockedConfig?: InputMaybe<ForecastLockedConfigSortInput>;
  name?: InputMaybe<SortEnumType>;
  scenarioSlot?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  weeklyMetric?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL/read-model view of a forecast's server-driven generation run status (W9), projected onto the
 * forecast document from the Started/Progressed/Completed/Failed events so the PWA's Generate dialog (P5)
 * can poll a single field for progress and the final preserved/overwritten override accounting (DoD
 * "progress observable"). Null until the first run starts.
 */
export type ForecastGenerationStatusView = {
  __typename?: 'ForecastGenerationStatusView';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentChunk: Scalars['Int']['output'];
  /** Set only in the failed phase — surfaced verbatim so the dialog never spins silently. */
  error?: Maybe<Scalars['String']['output']>;
  lastProgressAt: Scalars['DateTime']['output'];
  overwriteOverrides: Scalars['Boolean']['output'];
  /** Override cells cleared by the last completed overwrite run. */
  overwrittenOverrideCount: Scalars['Int']['output'];
  /**
   * One of loading / computing / persisting (in-flight) or
   *             completed / failed (terminal).
   */
  phase: Scalars['String']['output'];
  /** Machine plan rows written by the last completed run. */
  planRowCount: Scalars['Int']['output'];
  /** Override cells left intact by the last completed run. */
  preservedOverrideCount: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  totalChunks: Scalars['Int']['output'];
  /**
   * Distinct items that produced a plan row but had no configured price — surfaced so a $0-priced
   *             item is explicit to the planner, never a silent zero.
   */
  unpricedItemCount: Scalars['Int']['output'];
  watermark: Scalars['DateTime']['output'];
};

/**
 * GraphQL/read-model view of a forecast's server-driven generation run status (W9), projected onto the
 * forecast document from the Started/Progressed/Completed/Failed events so the PWA's Generate dialog (P5)
 * can poll a single field for progress and the final preserved/overwritten override accounting (DoD
 * "progress observable"). Null until the first run starts.
 */
export type ForecastGenerationStatusViewFilterInput = {
  and?: InputMaybe<Array<ForecastGenerationStatusViewFilterInput>>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  currentChunk?: InputMaybe<IntOperationFilterInput>;
  /** Set only in the failed phase — surfaced verbatim so the dialog never spins silently. */
  error?: InputMaybe<StringOperationFilterInput>;
  lastProgressAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ForecastGenerationStatusViewFilterInput>>;
  overwriteOverrides?: InputMaybe<BooleanOperationFilterInput>;
  /** Override cells cleared by the last completed overwrite run. */
  overwrittenOverrideCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * One of loading / computing / persisting (in-flight) or
   *             completed / failed (terminal).
   */
  phase?: InputMaybe<StringOperationFilterInput>;
  /** Machine plan rows written by the last completed run. */
  planRowCount?: InputMaybe<IntOperationFilterInput>;
  /** Override cells left intact by the last completed run. */
  preservedOverrideCount?: InputMaybe<IntOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  totalChunks?: InputMaybe<IntOperationFilterInput>;
  /**
   * Distinct items that produced a plan row but had no configured price — surfaced so a $0-priced
   *             item is explicit to the planner, never a silent zero.
   */
  unpricedItemCount?: InputMaybe<IntOperationFilterInput>;
  watermark?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * GraphQL/read-model view of a forecast's server-driven generation run status (W9), projected onto the
 * forecast document from the Started/Progressed/Completed/Failed events so the PWA's Generate dialog (P5)
 * can poll a single field for progress and the final preserved/overwritten override accounting (DoD
 * "progress observable"). Null until the first run starts.
 */
export type ForecastGenerationStatusViewSortInput = {
  completedAt?: InputMaybe<SortEnumType>;
  currentChunk?: InputMaybe<SortEnumType>;
  /** Set only in the failed phase — surfaced verbatim so the dialog never spins silently. */
  error?: InputMaybe<SortEnumType>;
  lastProgressAt?: InputMaybe<SortEnumType>;
  overwriteOverrides?: InputMaybe<SortEnumType>;
  /** Override cells cleared by the last completed overwrite run. */
  overwrittenOverrideCount?: InputMaybe<SortEnumType>;
  /**
   * One of loading / computing / persisting (in-flight) or
   *             completed / failed (terminal).
   */
  phase?: InputMaybe<SortEnumType>;
  /** Machine plan rows written by the last completed run. */
  planRowCount?: InputMaybe<SortEnumType>;
  /** Override cells left intact by the last completed run. */
  preservedOverrideCount?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  totalChunks?: InputMaybe<SortEnumType>;
  /**
   * Distinct items that produced a plan row but had no configured price — surfaced so a $0-priced
   *             item is explicit to the planner, never a silent zero.
   */
  unpricedItemCount?: InputMaybe<SortEnumType>;
  watermark?: InputMaybe<SortEnumType>;
};

/**
 * The freshness of the tenant's natively-synced history, per ImportData source — surfaced on the plan/list
 * pages (P12) in place of the legacy manual "Import Data" step (ADR-001 §4.2). Each value is the most recent
 * transaction Date present in that source for the tenant, capped at now, or null when the source has
 * no history.
 *
 * Semantic (reconciled with W9). This is the max transaction Date — the exact quantity
 * a W9 generation run pins its inputs at (ADR-001 ARCH-3), NOT an ingest wall-clock time — so the freshness
 * shown here is the same date a generation run would consume, from one shared computation. The only
 * deliberate divergence from the generation watermark is the empty-history case: generation falls back to
 * "now" so a run can still pin a (rows-less) input, whereas a freshness display reports null — there is
 * nothing to be fresh about.
 */
export type ForecastHistoryWatermark = {
  __typename?: 'ForecastHistoryWatermark';
  /** Most recent day in ImportData.DailyInventoryStates (on-hand) for the tenant, or null. */
  dailyInventoryThrough?: Maybe<Scalars['DateTime']['output']>;
  /** Most recent day in ImportData.DailyTransactionSummaries (sales/ships) for the tenant, or null. */
  dailyTransactionsThrough?: Maybe<Scalars['DateTime']['output']>;
  /** The later of the two source through-dates (the overall history freshness), or null when both are empty. */
  latestThrough?: Maybe<Scalars['DateTime']['output']>;
};

export enum ForecastLevel {
  Locations = 'LOCATIONS',
  Regions = 'REGIONS'
}

export type ForecastLevelOperationFilterInput = {
  eq?: InputMaybe<ForecastLevel>;
  in?: InputMaybe<Array<ForecastLevel>>;
  neq?: InputMaybe<ForecastLevel>;
  nin?: InputMaybe<Array<ForecastLevel>>;
};

/**
 * GraphQL/read-model view of a forecast's captured comp-parameter snapshot. Populated once at
 * creation from the tenant's forecast settings (or the A2 defaults) and never mutated afterward, so
 * the Assumptions page can show that an existing forecast keeps the values it was created with even
 * after tenant settings change (ADR-001 §5.3/§6, DoD #8).
 */
export type ForecastLockedConfig = {
  __typename?: 'ForecastLockedConfig';
  compAim: Scalars['Decimal']['output'];
  compMax: Scalars['Decimal']['output'];
  compMin: Scalars['Decimal']['output'];
  excludedHistoryYears: Array<Scalars['Int']['output']>;
  maxYearOffset: Scalars['Int']['output'];
  roundingBias: Scalars['Decimal']['output'];
  shipShift: Scalars['Boolean']['output'];
};

/**
 * GraphQL/read-model view of a forecast's captured comp-parameter snapshot. Populated once at
 * creation from the tenant's forecast settings (or the A2 defaults) and never mutated afterward, so
 * the Assumptions page can show that an existing forecast keeps the values it was created with even
 * after tenant settings change (ADR-001 §5.3/§6, DoD #8).
 */
export type ForecastLockedConfigFilterInput = {
  and?: InputMaybe<Array<ForecastLockedConfigFilterInput>>;
  compAim?: InputMaybe<DecimalOperationFilterInput>;
  compMax?: InputMaybe<DecimalOperationFilterInput>;
  compMin?: InputMaybe<DecimalOperationFilterInput>;
  excludedHistoryYears?: InputMaybe<ListIntOperationFilterInput>;
  maxYearOffset?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ForecastLockedConfigFilterInput>>;
  roundingBias?: InputMaybe<DecimalOperationFilterInput>;
  shipShift?: InputMaybe<BooleanOperationFilterInput>;
};

/**
 * GraphQL/read-model view of a forecast's captured comp-parameter snapshot. Populated once at
 * creation from the tenant's forecast settings (or the A2 defaults) and never mutated afterward, so
 * the Assumptions page can show that an existing forecast keeps the values it was created with even
 * after tenant settings change (ADR-001 §5.3/§6, DoD #8).
 */
export type ForecastLockedConfigSortInput = {
  compAim?: InputMaybe<SortEnumType>;
  compMax?: InputMaybe<SortEnumType>;
  compMin?: InputMaybe<SortEnumType>;
  maxYearOffset?: InputMaybe<SortEnumType>;
  roundingBias?: InputMaybe<SortEnumType>;
  shipShift?: InputMaybe<SortEnumType>;
};

export type ForecastPayload = {
  __typename?: 'ForecastPayload';
  errors?: Maybe<Array<ValidationError>>;
  forecast?: Maybe<ForecastStateData>;
};

export enum ForecastPlanCell {
  ForecastSalesUnits = 'FORECAST_SALES_UNITS',
  ForecastShipUnits = 'FORECAST_SHIP_UNITS',
  PriceNy = 'PRICE_NY',
  RetailNy = 'RETAIL_NY',
  UnitSellThroughNy = 'UNIT_SELL_THROUGH_NY'
}

export enum ForecastPlanCellEditOperation {
  AddTo = 'ADD_TO',
  PercentageOf = 'PERCENTAGE_OF',
  Replace = 'REPLACE',
  SubtractFrom = 'SUBTRACT_FROM'
}

export enum ForecastScenarioSlot {
  Base = 'BASE',
  Downside = 'DOWNSIDE',
  Submitted = 'SUBMITTED',
  Upside = 'UPSIDE',
  Working = 'WORKING'
}

export type ForecastScenarioSlotOperationFilterInput = {
  eq?: InputMaybe<ForecastScenarioSlot>;
  in?: InputMaybe<Array<ForecastScenarioSlot>>;
  neq?: InputMaybe<ForecastScenarioSlot>;
  nin?: InputMaybe<Array<ForecastScenarioSlot>>;
};

export type ForecastSettingsDocument = {
  __typename?: 'ForecastSettingsDocument';
  compAim: Scalars['Decimal']['output'];
  compMax: Scalars['Decimal']['output'];
  compMin: Scalars['Decimal']['output'];
  excludedHistoryYears: Array<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  maxYearOffset: Scalars['Int']['output'];
  roundingBias: Scalars['Decimal']['output'];
  shipShift: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ForecastSettingsDocumentFilterInput = {
  and?: InputMaybe<Array<ForecastSettingsDocumentFilterInput>>;
  compAim?: InputMaybe<DecimalOperationFilterInput>;
  compMax?: InputMaybe<DecimalOperationFilterInput>;
  compMin?: InputMaybe<DecimalOperationFilterInput>;
  excludedHistoryYears?: InputMaybe<ListIntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  maxYearOffset?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ForecastSettingsDocumentFilterInput>>;
  roundingBias?: InputMaybe<DecimalOperationFilterInput>;
  shipShift?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ForecastSettingsDocumentSortInput = {
  compAim?: InputMaybe<SortEnumType>;
  compMax?: InputMaybe<SortEnumType>;
  compMin?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxYearOffset?: InputMaybe<SortEnumType>;
  roundingBias?: InputMaybe<SortEnumType>;
  shipShift?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ForecastSettingsPayload = {
  __typename?: 'ForecastSettingsPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<ForecastSettingsStateData>;
};

export type ForecastSettingsStateData = {
  __typename?: 'ForecastSettingsStateData';
  compAim: Scalars['Decimal']['output'];
  compMax: Scalars['Decimal']['output'];
  compMin: Scalars['Decimal']['output'];
  excludedHistoryYears: Array<Scalars['Int']['output']>;
  maxYearOffset: Scalars['Int']['output'];
  roundingBias: Scalars['Decimal']['output'];
  shipShift: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * GraphQL output shape returned by the forecast mutations (create/update/delete). Mirrors the
 * aggregate state after the command applied.
 */
export type ForecastStateData = {
  __typename?: 'ForecastStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  forecastId: Scalars['String']['output'];
  level: ForecastLevel;
  lockedConfig: ForecastLockedConfig;
  name: Scalars['String']['output'];
  programIds: Array<Scalars['String']['output']>;
  scenarioSlot: ForecastScenarioSlot;
  startDate: Scalars['DateTime']['output'];
  status: ForecastStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  weeklyMetric: ForecastWeeklyMetric;
};

export enum ForecastStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ForecastStatusOperationFilterInput = {
  eq?: InputMaybe<ForecastStatus>;
  in?: InputMaybe<Array<ForecastStatus>>;
  neq?: InputMaybe<ForecastStatus>;
  nin?: InputMaybe<Array<ForecastStatus>>;
};

/**
 * Server-computed KPI rollup for the forecast plan grid's Summary panel (spec §3.2), over the rows in
 * the requested scope: sum of plan dollars/units, the two weighted-average sell-throughs, the top item
 * by forecast sales, and the vs-last-year deltas. Computed in a single MongoDB aggregation so the panel
 * is correct even when the grid is server-grouped beyond what the client has loaded. All divisions are
 * zero-guarded: a weighted sell-through with a zero weight is 0, and a vs-last-year percent with a zero
 * last-year base is null.
 */
export type ForecastSummary = {
  __typename?: 'ForecastSummary';
  /** Sum of ForecastSales (next-year sales dollars) across the scope. */
  forecastSales: Scalars['Decimal']['output'];
  /** Sum of ForecastSalesUnits across the scope. */
  forecastSalesUnits: Scalars['Decimal']['output'];
  /** Sum of ForecastShipUnits across the scope. */
  forecastShipUnits: Scalars['Decimal']['output'];
  /** Sum of ForecastShips (next-year ship dollars) across the scope. */
  forecastShips: Scalars['Decimal']['output'];
  /** Sum of last-year Sales dollars across the scope (the vs-last-year sales base). */
  lySales: Scalars['Decimal']['output'];
  /** Sum of last-year SalesUnits across the scope (the vs-last-year units base). */
  lySalesUnits: Scalars['Decimal']['output'];
  /** Sum of last-year ShipUnits across the scope (the vs-last-year ship-units base). */
  lyShipUnits: Scalars['Decimal']['output'];
  /**
   * Forecast retail margin dollars — the sum of (ForecastSales − ForecastSalesUnits × PriceNy) over
   * the scope (spec §3.2 Margin$).
   */
  marginNy: Scalars['Decimal']['output'];
  /** Number of plan rows aggregated into this summary. */
  rowCount: Scalars['Int']['output'];
  /** (ForecastSales − LySales) ÷ LySales, expressed as a fraction (0.1 = +10%); null when LySales is 0. */
  salesVsLyPercent?: Maybe<Scalars['Decimal']['output']>;
  /** (ForecastShipUnits − LyShipUnits) ÷ LyShipUnits, as a fraction; null when LyShipUnits is 0. */
  shipUnitsVsLyPercent?: Maybe<Scalars['Decimal']['output']>;
  /** The item with the greatest total ForecastSales in the scope, or null when the scope is empty. */
  topItem?: Maybe<ForecastSummaryTopItem>;
  /** (ForecastSalesUnits − LySalesUnits) ÷ LySalesUnits, as a fraction; null when LySalesUnits is 0. */
  unitsVsLyPercent?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Next-year retail sell-through, averaged across the scope weighted by ForecastSales, where each
   * row's retail sell-through is ForecastSales ÷ max(ForecastShips, ForecastSales)
   * (Σ(retailSellThrough × ForecastSales) ÷ Σ ForecastSales); 0 when the weight is 0.
   */
  weightedRetailSellThroughNy: Scalars['Decimal']['output'];
  /**
   * Next-year unit sell-through, averaged across the scope weighted by ForecastSalesUnits
   * (Σ(UnitSellThroughNy × ForecastSalesUnits) ÷ Σ ForecastSalesUnits); 0 when the weight is 0.
   */
  weightedUnitSellThroughNy: Scalars['Decimal']['output'];
};

/**
 * Optional scope narrowing a forecast summary to the selected-or-visible rows (spec §3.2). Every list is
 * optional and additive: the supplied lists AND together, and each row must match all of them. An
 * omitted or empty scope summarizes the whole forecast. Each dimension mirrors a groupable/filterable
 * column of the plan grid, and PlanRowIds is the explicit row selection (the plan-row composite ids).
 */
export type ForecastSummaryScopeInput = {
  /** Restricts the summary to rows whose category is in this set. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the summary to rows whose item id is in this set. */
  itemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the summary to rows whose merchant is in this set. */
  merchants?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Explicit plan-row selection — the composite plan-row ids to include. */
  planRowIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the summary to rows whose product group is in this set. */
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the summary to rows whose program is in this set. */
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the summary to rows whose region is in this set. */
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The top item of a forecast summary — the item with the highest total forecast sales in scope. */
export type ForecastSummaryTopItem = {
  __typename?: 'ForecastSummaryTopItem';
  /** Total ForecastSales for this item across the scope. */
  forecastSales: Scalars['Decimal']['output'];
  /** WorkSuite item id of the top item. */
  itemId: Scalars['String']['output'];
  /** Display name of the top item. */
  itemName: Scalars['String']['output'];
  /** Item SKU of the top item. */
  itemSku: Scalars['String']['output'];
};

/**
 * The weekly-cell totals for one plan row (region × item) of a forecast: the sum of every weekly cell's
 * forecast sales units and forecast ship units across the weeks (spec §3.2 Delta column). The PWA (P6)
 * computes the plan grid's Delta as the plan row's macro units minus these weekly sums, so a distribution
 * that no longer ties out to the macro plan is visible. Returned by forecastWeeklyDeltaInputs, one
 * row per (region, item) that has at least one weekly cell.
 */
export type ForecastWeeklyDeltaInput = {
  __typename?: 'ForecastWeeklyDeltaInput';
  /** WorkSuite item id of this plan row. */
  itemId: Scalars['String']['output'];
  /** Region key of this plan row. */
  region: Scalars['String']['output'];
  /** Sum of ForecastSalesUnits across this row's weekly cells. */
  weeklyForecastSalesUnits: Scalars['Decimal']['output'];
  /** Sum of ForecastShipUnits across this row's weekly cells. */
  weeklyForecastShipUnits: Scalars['Decimal']['output'];
};

/**
 * Optional scope narrowing forecastWeeklyDeltaInputs to the selected-or-visible plan rows. Both
 * lists are optional and additive: the supplied lists AND together (a row must match all of them). An
 * omitted or empty scope returns the Delta inputs for the whole forecast. The dimensions mirror the plan
 * grid's region / item scope so the PWA can fetch Delta inputs for exactly the rows it is showing.
 */
export type ForecastWeeklyDeltaScopeInput = {
  /** Restricts the Delta inputs to weekly cells whose item id is in this set. */
  itemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts the Delta inputs to weekly cells whose region is in this set. */
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ForecastWeeklyHistoryRebuildPayload = {
  __typename?: 'ForecastWeeklyHistoryRebuildPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<ForecastWeeklyHistoryRebuildResult>;
};

/** Outcome of a rebuildForecastWeeklyHistory run for one customer. */
export type ForecastWeeklyHistoryRebuildResult = {
  __typename?: 'ForecastWeeklyHistoryRebuildResult';
  /** The most recent history date rolled into the cache, or null when the customer has no history. */
  builtThroughDate?: Maybe<Scalars['DateTime']['output']>;
  /** The customer whose shared weekly-history cache was rebuilt. */
  customerId: Scalars['String']['output'];
  /** Number of weekly-history buckets written (upserted) by this run. */
  rowsWritten: Scalars['Int']['output'];
  /** Daily rows dropped because their location or item did not resolve to WorkSuite master data. */
  skippedUnmappedRows: Scalars['Int']['output'];
  /** Number of stale buckets from a prior rebuild removed within the (tenant, customer) scope. */
  staleRowsRemoved: Scalars['Int']['output'];
};

export enum ForecastWeeklyMetric {
  Sales = 'SALES',
  Ships = 'SHIPS'
}

export type ForecastWeeklyMetricOperationFilterInput = {
  eq?: InputMaybe<ForecastWeeklyMetric>;
  in?: InputMaybe<Array<ForecastWeeklyMetric>>;
  neq?: InputMaybe<ForecastWeeklyMetric>;
  nin?: InputMaybe<Array<ForecastWeeklyMetric>>;
};

/** A connection to a list of items. */
export type ForecastsConnection = {
  __typename?: 'ForecastsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ForecastsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ForecastDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ForecastsEdge = {
  __typename?: 'ForecastsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ForecastDocument;
};

export enum FreightChargeType {
  FlatFee = 'FLAT_FEE',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

/** A load's latest Freight Quote send. */
export type FreightQuoteSend = {
  __typename?: 'FreightQuoteSend';
  /** Why the last attempt failed or is uncertain; null otherwise. */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The email provider's id for the sent message; null when there is none. */
  providerMessageId?: Maybe<Scalars['String']['output']>;
  /** The address it goes, or went, to. */
  recipientEmail: Scalars['String']['output'];
  /** The send's reservation, which resolveUncertainLoadEmail takes. */
  reservationId: Scalars['String']['output'];
  /** When it was sent, or marked sent; null unless Sent. */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Where the send stands. */
  state: LoadEmailStatus;
};

export enum FreightSource {
  Inherited = 'INHERITED',
  Load = 'LOAD',
  Manual = 'MANUAL',
  Unknown = 'UNKNOWN'
}

export type FreightSourceOperationFilterInput = {
  eq?: InputMaybe<FreightSource>;
  in?: InputMaybe<Array<FreightSource>>;
  neq?: InputMaybe<FreightSource>;
  nin?: InputMaybe<Array<FreightSource>>;
};

export type FulfillAllocationInput = {
  allocationId: Scalars['String']['input'];
  fulfilledQty: Scalars['Decimal']['input'];
};

export enum FulfillmentSource {
  ExistingStock = 'EXISTING_STOCK',
  MakeToOrder = 'MAKE_TO_ORDER',
  Unspecified = 'UNSPECIFIED'
}

export type FulfillmentSourceOperationFilterInput = {
  eq?: InputMaybe<FulfillmentSource>;
  in?: InputMaybe<Array<FulfillmentSource>>;
  neq?: InputMaybe<FulfillmentSource>;
  nin?: InputMaybe<Array<FulfillmentSource>>;
};

/** Input for the generate-customer-statement-run mutation. */
export type GenerateCustomerStatementRunInput = {
  /** The format to render to. Defaults to PDF. */
  outputFormat?: InputMaybe<Scalars['String']['input']>;
  /**
   * The EXCLUSIVE end of the statement period. Exclusive so consecutive periods tile exactly and no order
   * can fall into two of them — a calendar month is [1 Jul, 1 Aug).
   */
  periodEndExclusive: Scalars['DateTime']['input'];
  /** The INCLUSIVE start of the statement period. */
  periodStart: Scalars['DateTime']['input'];
  /** The report each customer's statement is rendered from. */
  reportId: Scalars['String']['input'];
  /**
   * The template to render with. Defaults to the seeded Customer Statement template, which is the only
   * system template rendered in aggregate mode and so the only one that emits the statement's balances,
   * aging buckets and finance-charge lines.
   */
  reportTemplateId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The caller-minted id this run is addressed by, and the id its statements are later sent under. Recording
   * is once-only per id, so re-submitting a run that already generated is rejected rather than silently
   * replacing the record an operator may already have reviewed.
   */
  runId: Scalars['String']['input'];
};

export type GenerateForecastInput = {
  forecastId: Scalars['String']['input'];
  overwriteOverrides: Scalars['Boolean']['input'];
};

export type GradeInventoryItemCommandInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  currentGrade: Scalars['Int']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  newGrade: Scalars['Int']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  why: Scalars['String']['input'];
};

export type GradeLabelDataInput = {
  grade: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/**
 * Grants a user access to work in one or more of a parent company's member tenants. The user is named
 * either by login id or by email address — exactly one of the two. Every named tenant must belong to
 * the parent company, or nothing is applied.
 */
export type GrantParentCompanyTenantAccessInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fusionAuthUserId?: InputMaybe<Scalars['String']['input']>;
  parentCompanyId: Scalars['String']['input'];
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GridRequestInput = {
  endRow: Scalars['Int']['input'];
  filterModel?: InputMaybe<Scalars['JSON']['input']>;
  groupKeys: Array<Scalars['String']['input']>;
  rowGroupCols: Array<GroupColumnInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortModel: Array<SortColumnInput>;
  startRow: Scalars['Int']['input'];
  valueCols: Array<ValueColumnInput>;
};

export type GroupColumnInput = {
  field: Scalars['String']['input'];
};

/**
 * One GrowPoint commit exactly as recorded: the reviewed rows with the version each was reviewed
 * at, why it was rejected (when it was), and each row's import outcome once the worker records it.
 */
export type GrowPointCommitData = {
  __typename?: 'GrowPointCommitData';
  /** Gets the caller-allocated commit id, in its stored dashless lower-case form. */
  commitId: Scalars['String']['output'];
  /** Gets when the commit was recorded. */
  committedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who committed. */
  committedBy: Scalars['String']['output'];
  /** Gets the staged entity the commit imports. */
  entity: GrowPointStagedEntity;
  /** Gets the reason and changed rows when the commit was rejected before anything was queued. */
  rejection?: Maybe<GrowPointCommitRejectionData>;
  /** Gets the reviewed rows, each with its recorded outcome once the import worker records one. */
  rows: Array<GrowPointCommitRowData>;
  /** Gets whether the commit was rejected, is queued, or has an outcome for every row. */
  status: GrowPointCommitStatus;
  /**
   * Gets when the import worker's RunNow was acknowledged for this commit. Empty on a
   * queued commit means the trigger was not confirmed.
   */
  triggeredAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Why a commit was rejected before anything was queued. */
export type GrowPointCommitRejectionData = {
  __typename?: 'GrowPointCommitRejectionData';
  /** Gets the rejection code. */
  code: Scalars['String']['output'];
  /** Gets the reviewed rows that changed after review; empty for other rejections. */
  conflicts: Array<GrowPointRowConflictData>;
  /** Gets the rejection message. */
  message: Scalars['String']['output'];
};

/** One reviewed row of a commit. */
export type GrowPointCommitRowData = {
  __typename?: 'GrowPointCommitRowData';
  /** Gets the outcome the import worker recorded for the row, when it has recorded one. */
  outcome?: Maybe<GrowPointCommitRowOutcomeData>;
  /** Gets the staged row id (the staged summary document id). */
  rowId: Scalars['String']['output'];
  /** Gets the version the row was reviewed at. */
  version: Scalars['String']['output'];
};

/** The import outcome recorded for one reviewed row. */
export type GrowPointCommitRowOutcomeData = {
  __typename?: 'GrowPointCommitRowOutcomeData';
  /** Gets the canonical id of the entity the row became, when the worker knows it. */
  canonicalId?: Maybe<Scalars['String']['output']>;
  /** Gets the Synchronization iteration id the outcome was recorded under. */
  iterationId: Scalars['String']['output'];
  /** Gets the worker's message for the row, when it gave one. */
  message?: Maybe<Scalars['String']['output']>;
  /** Gets whether the row was created, updated, failed or has an unknown outcome. */
  outcome: GrowPointRowOutcome;
  /** Gets when the outcome was recorded. */
  recordedAt: Scalars['DateTime']['output'];
};

/** Where a commit is in its life: rejected before queuing, queued, or every row has an outcome. */
export enum GrowPointCommitStatus {
  Completed = 'COMPLETED',
  Queued = 'QUEUED',
  Rejected = 'REJECTED'
}

/** The queued commit the import worker should run, with any staging drift found at read time. */
export type GrowPointPendingCommitData = {
  __typename?: 'GrowPointPendingCommitData';
  /** Gets the queued commit, with any outcomes already recorded. */
  commit: GrowPointCommitData;
  /**
   * Gets the reviewed rows that differ from current staging at the time of this read. Not empty
   * means the reviewed batch can no longer run exactly as reviewed.
   */
  stagingConflicts: Array<GrowPointRowConflictData>;
};

/** One reviewed staged row: its id and the version read from growPointStagedRowVersions. */
export type GrowPointReviewedRowInput = {
  rowId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** How a reviewed row differs from current staging. */
export enum GrowPointRowChange {
  Added = 'ADDED',
  Edited = 'EDITED',
  Removed = 'REMOVED'
}

/** A row whose reviewed version no longer matches current staging. */
export type GrowPointRowConflictData = {
  __typename?: 'GrowPointRowConflictData';
  /** Gets how the row changed: edited, removed from staging, or added to staging. */
  change: GrowPointRowChange;
  /** Gets the staged row id. */
  rowId: Scalars['String']['output'];
};

/** What the import worker did with one reviewed row. */
export enum GrowPointRowOutcome {
  Created = 'CREATED',
  Failed = 'FAILED',
  Unknown = 'UNKNOWN',
  Updated = 'UPDATED'
}

/** The outcome of one reviewed row. */
export type GrowPointRowOutcomeInput = {
  /** The canonical entity id; required for created and updated rows. */
  canonicalId?: InputMaybe<Scalars['String']['input']>;
  /** An optional message, such as the failure reason. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** What the import did with the row. */
  outcome: GrowPointRowOutcome;
  /** The reviewed row id. */
  rowId: Scalars['String']['input'];
};

/**
 * GraphQL-facing selector for a GrowPoint staged-entity type. Each member maps 1:1 to the staged
 * collection set in GrowPointCollectionNames that
 * backs it. Deliberately distinct from the domain enum
 * WorkSuite.Domain.WsapiImport.Models.WsapiImportEntityType — that enum's ordinals are
 * persisted in events and read models, so surfacing it would couple the public schema to a storage
 * detail and break on any reordering. This dedicated enum keeps the schema decoupled.
 */
export enum GrowPointStagedEntity {
  Categories = 'CATEGORIES',
  Customers = 'CUSTOMERS',
  HistoricalOrders = 'HISTORICAL_ORDERS',
  Inventory = 'INVENTORY',
  Items = 'ITEMS',
  PriceGroups = 'PRICE_GROUPS',
  SiteLocations = 'SITE_LOCATIONS',
  Terms = 'TERMS'
}

/** The current version of one staged row, to send back with a commit. */
export type GrowPointStagedRowVersionData = {
  __typename?: 'GrowPointStagedRowVersionData';
  /** Gets the staged row id (the staged summary document id). */
  rowId: Scalars['String']['output'];
  /** Gets the row's current version. */
  version: Scalars['String']['output'];
};

export type GrowWeeksOverride = {
  __typename?: 'GrowWeeksOverride';
  growWeeks: Scalars['Int']['output'];
  productionRecipeVariationId: Scalars['String']['output'];
  setAt: Scalars['DateTime']['output'];
  setBy: Scalars['String']['output'];
};

export type GrowWeeksOverrideFilterInput = {
  and?: InputMaybe<Array<GrowWeeksOverrideFilterInput>>;
  growWeeks?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<GrowWeeksOverrideFilterInput>>;
  productionRecipeVariationId?: InputMaybe<StringOperationFilterInput>;
  setAt?: InputMaybe<DateTimeOperationFilterInput>;
  setBy?: InputMaybe<StringOperationFilterInput>;
};

/** GraphQL representation of one community access-log entry returned by growerBenchmarkAccessLog (contract C7). */
export type GrowerBenchmarkAccessLogEntry = {
  __typename?: 'GrowerBenchmarkAccessLogEntry';
  /** Audit action ("Granted", "Revoked", "Expired", "Accessed", or "Denied"). */
  action: Scalars['String']['output'];
  /** Authenticated user identifier of the acting caller. */
  actorUserId: Scalars['String']['output'];
  /** Granted/revoked role name or firm-lookup detail. */
  detail: Scalars['String']['output'];
  /** Event identifier of the source event from which this row was projected. */
  entryId: Scalars['String']['output'];
  /** Target firm identifier on firm-lookup rows, or null on grant/revoke rows. */
  firmId?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the audited action occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** Subject user identifier on grant/revoke rows, or null on firm-lookup rows. */
  subjectUserId?: Maybe<Scalars['String']['output']>;
};

/** Community access log rendered as a CSV file in base64, in the column order of contract K3. */
export type GrowerBenchmarkAccessLogExport = {
  __typename?: 'GrowerBenchmarkAccessLogExport';
  /** UTF-8 CSV content encoded as base64. */
  csvBase64: Scalars['String']['output'];
  /** File name formatted as benchmark-access-log-{communityId}-{yyyyMMdd}.csv. */
  fileName: Scalars['String']['output'];
};

/** GraphQL representation of one persisted entry in the reader's activity trail (contract C1). */
export type GrowerBenchmarkActivityEntry = {
  __typename?: 'GrowerBenchmarkActivityEntry';
  createdAt: Scalars['DateTime']['output'];
  entryId: Scalars['String']['output'];
  kind: GrowerBenchmarkActivityKind;
  periodId?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
};

/** Mutation payload returned by addGrowerBenchmarkActivityEntry (contract C1). */
export type GrowerBenchmarkActivityEntryPayload = {
  __typename?: 'GrowerBenchmarkActivityEntryPayload';
  entry?: Maybe<GrowerBenchmarkActivityEntry>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * Add-only classification of persisted reader actions in the GrowerBenchmark dashboard and compare activity trail
 * (contract C1).
 */
export enum GrowerBenchmarkActivityKind {
  /** The reader highlighted or cleared a set of anonymized peer firm codes on compare. */
  PeersHighlighted = 'PEERS_HIGHLIGHTED',
  /** The reader switched the active reporting period on the results or compare surface. */
  PeriodSwitched = 'PERIOD_SWITCHED',
  /** The reader saved or updated a named compare view. */
  ViewSaved = 'VIEW_SAVED'
}

export enum GrowerBenchmarkApprovalType {
  Correction = 'CORRECTION',
  Import = 'IMPORT',
  QueueReview = 'QUEUE_REVIEW'
}

/** Predicate comparison operator used by growerBenchmarkFirmCodesMatching (contract C1). */
export enum GrowerBenchmarkAttributeComparison {
  /** Metric value in the selected period is greater than or equal to the supplied threshold. */
  AtLeast = 'AT_LEAST',
  /** Metric value in the selected period is less than or equal to the supplied threshold. */
  AtMost = 'AT_MOST',
  /** Metric value decreased relative to withinPeriods comparison steps earlier. */
  Decreased = 'DECREASED',
  Equals = 'EQUALS',
  /** Metric value increased relative to withinPeriods comparison steps earlier. */
  Increased = 'INCREASED'
}

export enum GrowerBenchmarkBillingSource {
  External = 'EXTERNAL',
  Unset = 'UNSET',
  Worksuite = 'WORKSUITE'
}

/** One billing summary row returned by growerBenchmarkBillingSummary for a registered member firm (contract K2). */
export type GrowerBenchmarkBillingSummaryRow = {
  __typename?: 'GrowerBenchmarkBillingSummaryRow';
  /** Real display name of the member firm. */
  displayName: Scalars['String']['output'];
  /** External paid-through timestamp when source is EXTERNAL, otherwise null. */
  externalPaidThrough?: Maybe<Scalars['DateTime']['output']>;
  /** External subscription status when source is EXTERNAL, otherwise null. */
  externalStatus?: Maybe<Scalars['String']['output']>;
  /** Stable identifier of the member firm within the community. */
  firmId: Scalars['String']['output'];
  /** Configured billing source for the firm. */
  source: GrowerBenchmarkBillingSource;
  /** Platform subscription currentPeriodEnd when source is WORKSUITE and a subscription exists, otherwise null. */
  worksuiteCurrentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Platform BillingStatus member name when source is WORKSUITE and a subscription exists, otherwise null. */
  worksuiteSubscriptionStatus?: Maybe<Scalars['String']['output']>;
};

/** Single cohort classification facet key-value pair on a GrowerBenchmarkFirm (contract C7). */
export type GrowerBenchmarkClassificationFacet = {
  __typename?: 'GrowerBenchmarkClassificationFacet';
  /** Lowercase [a-z0-9]{1,32} facet key. */
  key: Scalars['String']['output'];
  /** Facet value assigned to the firm. */
  value: Scalars['String']['output'];
};

/** Input facet key-value pair supplied when registering a GrowerBenchmark firm (contract C7). */
export type GrowerBenchmarkClassificationFacetInput = {
  /** Lowercase [a-z0-9]{1,32} facet key. */
  key: Scalars['String']['input'];
  /** Facet value assigned to the firm. */
  value: Scalars['String']['input'];
};

/**
 * GraphQL representation of a cohort's canonical key, descriptor facets, matching firm count, floor status, and
 * community-wide period submission coverage (contract C1).
 */
export type GrowerBenchmarkCohort = {
  __typename?: 'GrowerBenchmarkCohort';
  cohortKey: Scalars['String']['output'];
  facets: Array<GrowerBenchmarkCohortFacetValue>;
  firmCount: Scalars['Int']['output'];
  floorFirmCount: Scalars['Int']['output'];
  isBelowFloor: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  reportedFirmCount: Scalars['Int']['output'];
  statisticsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  totalFirmCount: Scalars['Int']['output'];
};

/** GraphQL representation of one cohort classification facet and its options (contract C1). */
export type GrowerBenchmarkCohortFacet = {
  __typename?: 'GrowerBenchmarkCohortFacet';
  facetKey: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<GrowerBenchmarkCohortFacetOption>;
};

/** GraphQL representation of one selectable facet option and its firm count and floor flag (contract C1). */
export type GrowerBenchmarkCohortFacetOption = {
  __typename?: 'GrowerBenchmarkCohortFacetOption';
  firmCount: Scalars['Int']['output'];
  isBelowFloor: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * GraphQL representation of one saved facet key-to-values selection inside a GrowerBenchmarkCompareView
 * (contract C1).
 */
export type GrowerBenchmarkCohortFacetSelection = {
  __typename?: 'GrowerBenchmarkCohortFacetSelection';
  facetKey: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

/** Input specifying selected option values for one cohort classification facet (contract C1). */
export type GrowerBenchmarkCohortFacetSelectionInput = {
  facetKey: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

/** GraphQL representation of one resolved facet key-value descriptor on a cohort (contract C1). */
export type GrowerBenchmarkCohortFacetValue = {
  __typename?: 'GrowerBenchmarkCohortFacetValue';
  facetKey: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
  valueLabel: Scalars['String']['output'];
};

/**
 * GraphQL representation of a cohort's summary statistics for one metric in one period, subject to both the cohort
 * floor and the per-metric floor (contract C1).
 */
export type GrowerBenchmarkCohortMetricStatistics = {
  __typename?: 'GrowerBenchmarkCohortMetricStatistics';
  cohortKey: Scalars['String']['output'];
  firmCount: Scalars['Int']['output'];
  floorFirmCount: Scalars['Int']['output'];
  isBelowFloor: Scalars['Boolean']['output'];
  lowerQuartile?: Maybe<Scalars['Float']['output']>;
  maximum?: Maybe<Scalars['Float']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  metricKey: Scalars['String']['output'];
  minimum?: Maybe<Scalars['Float']['output']>;
  periodId: Scalars['String']['output'];
  priorPeriodMedian?: Maybe<Scalars['Float']['output']>;
  reportedCount: Scalars['Int']['output'];
  topQuartile?: Maybe<Scalars['Float']['output']>;
};

/** Payload returned by growerBenchmarkQueueCohortPass (contracts M3 and C7). */
export type GrowerBenchmarkCohortPassQueuePayload = {
  __typename?: 'GrowerBenchmarkCohortPassQueuePayload';
  /** Typed validation or gate errors, or null on success. */
  errors?: Maybe<Array<ValidationError>>;
  /** The queued run record, or null on refusal. */
  run?: Maybe<GrowerBenchmarkCohortPassRun>;
};

/** One cohort statistics pass run record (contracts M3 and M4). The worker's lease fields are on no GraphQL type. */
export type GrowerBenchmarkCohortPassRun = {
  __typename?: 'GrowerBenchmarkCohortPassRun';
  /** Cohorts the pass withheld under the firm-count floor. */
  cohortsWithheld: Scalars['Int']['output'];
  /** GrowerBenchmark community whose statistics the pass computes. */
  communityId: Scalars['String']['output'];
  /** Time the worker finished the run, or null until it does. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Worker message about the outcome, or null. */
  message?: Maybe<Scalars['String']['output']>;
  /** Reporting period the pass computes. */
  periodId: Scalars['String']['output'];
  /** Time the analyst queued the run. */
  queuedAt: Scalars['DateTime']['output'];
  /** Rows the pass wrote. */
  rowsWritten: Scalars['Int']['output'];
  /** Run id, the document id of the run record. */
  runId: Scalars['String']['output'];
  /** Time the worker claimed the run, or null while queued. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Lifecycle status of the run. */
  status: GrowerBenchmarkCohortPassStatus;
};

export enum GrowerBenchmarkCohortPassStatus {
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

/** Input specifying a community, reporting period, and cohort facet filter selection (contract C1). */
export type GrowerBenchmarkCohortSelectionInput = {
  communityId: Scalars['String']['input'];
  facets: Array<GrowerBenchmarkCohortFacetSelectionInput>;
  periodId: Scalars['String']['input'];
};

/** Summary statistics of one cohort on one metric in one period (contracts M3 and C9). */
export type GrowerBenchmarkCohortStatistic = {
  __typename?: 'GrowerBenchmarkCohortStatistic';
  /** Collection cadence of the period. */
  cadence: GrowerBenchmarkReportingCadence;
  /** Facets describing the cohort, ordered by key. */
  cohortFacets: Array<GrowerBenchmarkClassificationFacet>;
  /** Canonical cohort key (contract C11). */
  cohortKey: Scalars['String']['output'];
  /** Time the cohort worker computed the row. */
  computedAt: Scalars['DateTime']['output'];
  /** Firms in the cohort. */
  firmCount: Scalars['Int']['output'];
  /** 25th percentile across reporting firms. */
  lowerQuartile: Scalars['Float']['output'];
  /** Highest reported value. */
  maximum: Scalars['Float']['output'];
  /** Median across reporting firms. */
  median: Scalars['Float']['output'];
  /** Catalog metric key summarized. */
  metricKey: Scalars['String']['output'];
  /** Lowest reported value. */
  minimum: Scalars['Float']['output'];
  /** Reporting period identifier. */
  periodId: Scalars['String']['output'];
  /** The same cohort's median one period back, or null. */
  priorPeriodMedian?: Maybe<Scalars['Float']['output']>;
  /** Firms with a non-null, non-excluded value for the metric. */
  reportedCount: Scalars['Int']['output'];
  /** 75th percentile across reporting firms. */
  topQuartile: Scalars['Float']['output'];
};

/**
 * GraphQL representation of a GrowerBenchmark community, its registered member firms, and its program-side roster
 * (contract C7).
 */
export type GrowerBenchmarkCommunity = {
  __typename?: 'GrowerBenchmarkCommunity';
  /** Stable identifier of the GrowerBenchmark community. */
  communityId: Scalars['String']['output'];
  /** Member firms registered in the community. */
  firms: Array<GrowerBenchmarkFirm>;
  /** Neutral internal display name of the community. */
  name: Scalars['String']['output'];
  /** Program-side roster entries on the community. */
  roster: Array<GrowerBenchmarkRosterEntry>;
  /** Industry segment of the community. */
  segment: GrowerBenchmarkCommunitySegment;
  /** Classification tags attached to the community. */
  tags: Array<Scalars['String']['output']>;
};

/** Mutation payload returned by GrowerBenchmark community, firm-registry, and roster mutations (contract C7). */
export type GrowerBenchmarkCommunityPayload = {
  __typename?: 'GrowerBenchmarkCommunityPayload';
  /** Updated or unchanged community view on success, or null on validation/gate refusal. */
  community?: Maybe<GrowerBenchmarkCommunity>;
  /** Typed validation or gate errors ([ValidationError!]), or null on success. */
  errors?: Maybe<Array<ValidationError>>;
};

export enum GrowerBenchmarkCommunitySegment {
  Grower = 'GROWER',
  Retail = 'RETAIL'
}

/** GraphQL representation of one metric card and its anonymized peer rows on growerBenchmarkCompare (contract C1). */
export type GrowerBenchmarkCompareMetric = {
  __typename?: 'GrowerBenchmarkCompareMetric';
  definition: GrowerBenchmarkMetricDefinition;
  rows: Array<GrowerBenchmarkPeerRow>;
  self?: Maybe<GrowerBenchmarkFirmMetricValue>;
  statistics: GrowerBenchmarkCohortMetricStatistics;
};

/** GraphQL representation of a reader's saved compare page view (contract C1). */
export type GrowerBenchmarkCompareView = {
  __typename?: 'GrowerBenchmarkCompareView';
  communityId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  facets: Array<GrowerBenchmarkCohortFacetSelection>;
  highlightedFirmLabels: Array<Scalars['String']['output']>;
  metricKeys: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  periodId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewId: Scalars['String']['output'];
};

/** Mutation payload returned by saveGrowerBenchmarkCompareView (contract C1). */
export type GrowerBenchmarkCompareViewPayload = {
  __typename?: 'GrowerBenchmarkCompareViewPayload';
  errors?: Maybe<Array<ValidationError>>;
  view?: Maybe<GrowerBenchmarkCompareView>;
};

/** GraphQL representation of one same-kind prior comparison point for a firm metric or finding (contract C1). */
export type GrowerBenchmarkComparisonPoint = {
  __typename?: 'GrowerBenchmarkComparisonPoint';
  label: Scalars['String']['output'];
  periodId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/**
 * Program-side GraphQL representation of a GrowerBenchmark collection cycle window and its read-time standing counts
 * (contracts C12 and D9).
 */
export type GrowerBenchmarkCycle = {
  __typename?: 'GrowerBenchmarkCycle';
  /** Timestamp when the collection cycle closed, or null while open. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the GrowerBenchmark community running this collection cycle. */
  communityId: Scalars['String']['output'];
  /** Read-time firm standing counts across the cycle's participating firms. */
  counts: GrowerBenchmarkCycleCounts;
  /** Deterministic identifier of the collection cycle. */
  cycleId: Scalars['String']['output'];
  /** Calendar days remaining until dueAt in the community's configured time zone. */
  daysRemaining: Scalars['Int']['output'];
  /** Target deadline timestamp for member submissions. */
  dueAt: Scalars['DateTime']['output'];
  /** Program reviewer-facing cycle name. */
  label: Scalars['String']['output'];
  /** Timestamp when the collection cycle opened for intake. */
  openedAt: Scalars['DateTime']['output'];
  /** Ordered period identifiers collected by this cycle window. */
  periodIds: Array<Scalars['String']['output']>;
};

/** Read-time firm standing rollup counts for a GrowerBenchmark collection cycle (contracts C12 and D9). */
export type GrowerBenchmarkCycleCounts = {
  __typename?: 'GrowerBenchmarkCycleCounts';
  /** Participating firms where every Cycle-cadence reporting unit has reached Approved. */
  approvedCount: Scalars['Int']['output'];
  /** Percentage from 0 to 100 of firmCount whose Cycle-cadence units are all Approved. */
  coveragePercent: Scalars['Float']['output'];
  /** Active member firms in the community holding at least one Cycle-cadence reporting unit. */
  firmCount: Scalars['Int']['output'];
  /** Participating firms still owing at least one Cycle-cadence unit submission. */
  notStartedCount: Scalars['Int']['output'];
  /** Participating firms with at least one Cycle-cadence unit in Queried status. */
  queriedCount: Scalars['Int']['output'];
  /** Participating firms whose standing is past NotStarted (firmCount minus notStartedCount). */
  submittedCount: Scalars['Int']['output'];
  /** Participating firms with a Submitted or InReview unit and no Queried unit. */
  waitingOnReviewerCount: Scalars['Int']['output'];
};

/** Mutation payload returned by openGrowerBenchmarkCycle and closeGrowerBenchmarkCycle (contract D9). */
export type GrowerBenchmarkCyclePayload = {
  __typename?: 'GrowerBenchmarkCyclePayload';
  /** Opened or closed collection cycle view on success, or null on validation or gate refusal. */
  cycle?: Maybe<GrowerBenchmarkCycle>;
  /** Typed validation or gate errors, or null on success. */
  errors?: Maybe<Array<ValidationError>>;
};

/** What wsapi's code settled about a subject before any question could be asked. */
export enum GrowerBenchmarkDecisionCode {
  /** The subject needs a person, for example a partial-year file. */
  NeedsPerson = 'NEEDS_PERSON',
  /** There is nothing to ask, for example an under-floor cohort or a subject code already closed. */
  NothingToAsk = 'NOTHING_TO_ASK',
  /** Code resolved the subject itself, for example from placement memory or an exact match. */
  ResolvedByCode = 'RESOLVED_BY_CODE'
}

/**
 * The decision orchestrator's view of one subject: the gates wsapi owns and, only when they all hold, what may be
 * asked. A subject the caller may not see carries its subjectKey and accessDenied (true), and nothing else.
 */
export type GrowerBenchmarkDecisionContextData = {
  __typename?: 'GrowerBenchmarkDecisionContextData';
  /** True when the caller may not see the subject, or it could not be found; every other field is then null. */
  accessDenied: Scalars['Boolean']['output'];
  /** What code already settled; null for an open subject or unless every gate above holds. */
  code?: Maybe<GrowerBenchmarkDecisionCode>;
  /** For a cohort fact, how many firms the cohort holds. */
  cohortFirmCount?: Maybe<Scalars['Int']['output']>;
  /** The subject's current source revision; null unless every gate above holds. */
  currentRevision?: Maybe<Scalars['String']['output']>;
  /** Whether the subject's tenant is excluded from fernie advice. Bonnie Plants always is. */
  excluded?: Maybe<Scalars['Boolean']['output']>;
  /** The subject's firm, for binding and records only; it never reaches a provider. */
  firmId?: Maybe<Scalars['String']['output']>;
  /** Whether Grower Benchmarks is on for the subject's tenant; null when it could not be read. */
  moduleOn?: Maybe<Scalars['Boolean']['output']>;
  /** The options a choice question may pick from; null unless every gate above holds. */
  options?: Maybe<Array<Maybe<GrowerBenchmarkDecisionOptionData>>>;
  /** How many picks a choice question may return; null means one. */
  pickLimit?: Maybe<Scalars['Int']['output']>;
  /** The idea's allowlisted, code-worded and redacted state; null unless every gate above holds. */
  state?: Maybe<Array<Maybe<GrowerBenchmarkDecisionStateFieldData>>>;
  /** The subject key exactly as it was asked about. */
  subjectKey: Scalars['String']['output'];
  /** Whether fernie suggestions are on for the subject's company; null when it could not be read. */
  subjectSwitchOn?: Maybe<Scalars['Boolean']['output']>;
  /** The tenant that owns the subject's firm, for binding and records only; it never reaches a provider. */
  tenantId?: Maybe<Scalars['String']['output']>;
};

/** One option a choice question may pick, keyed by the caller's own local key. */
export type GrowerBenchmarkDecisionOptionData = {
  __typename?: 'GrowerBenchmarkDecisionOptionData';
  /** An optional second line, such as the option's group. */
  detail?: Maybe<Scalars['String']['output']>;
  /** The caller's own local key; the orchestrator replaces it before anything is sent. */
  key: Scalars['String']['output'];
  /** The option's label, 120 characters at most. */
  label: Scalars['String']['output'];
};

/** One allowlisted state field: a single value, or a list of values. */
export type GrowerBenchmarkDecisionStateFieldData = {
  __typename?: 'GrowerBenchmarkDecisionStateFieldData';
  /** The field name from the idea's allowlist. */
  name: Scalars['String']['output'];
  /** The value of a single field; null for a list field. */
  value?: Maybe<Scalars['String']['output']>;
  /** The values of a list field; null for a single field. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** One approved line fact of a member firm's reporting unit in a period (contracts M3 and M1). */
export type GrowerBenchmarkFact = {
  __typename?: 'GrowerBenchmarkFact';
  /** Collection cadence of the period. */
  cadence: GrowerBenchmarkReportingCadence;
  /** Cohort classification facets of the firm, ordered by key. */
  classification: Array<GrowerBenchmarkClassificationFacet>;
  /** Line code the fact reports. */
  factKey: Scalars['String']['output'];
  /** Community firm registry identifier. */
  firmId: Scalars['String']['output'];
  /** Reporting period identifier. */
  periodId: Scalars['String']['output'];
  /** Reporting unit within the firm. */
  reportingUnitId: Scalars['String']['output'];
  /** Reported figure, or null when not reported. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** GraphQL representation of one released review finding on GrowerBenchmarkFirmHome (contract C1). */
export type GrowerBenchmarkFinding = {
  __typename?: 'GrowerBenchmarkFinding';
  cause?: Maybe<GrowerBenchmarkFindingCause>;
  cohortMedian?: Maybe<Scalars['Float']['output']>;
  gapReference?: Maybe<GrowerBenchmarkGapReference>;
  gapValue?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  metricKey: Scalars['String']['output'];
  priorPeriods: Array<GrowerBenchmarkComparisonPoint>;
  reviewerQuote?: Maybe<GrowerBenchmarkReviewerQuote>;
  sortOrder: Scalars['Int']['output'];
  status?: Maybe<GrowerBenchmarkFindingStatus>;
  value?: Maybe<Scalars['Float']['output']>;
  workStatus?: Maybe<GrowerBenchmarkWorkStatus>;
};

/**
 * GraphQL representation of the sibling metric with the largest adverse move against the comparison period inside the
 * same catalog group (contract C1).
 */
export type GrowerBenchmarkFindingCause = {
  __typename?: 'GrowerBenchmarkFindingCause';
  change: Scalars['Float']['output'];
  direction: GrowerBenchmarkMetricDirection;
  label: Scalars['String']['output'];
  metricKey: Scalars['String']['output'];
};

/**
 * Headline status of a released review finding relative to the cohort median or target in the metric's direction
 * (contract C1).
 */
export enum GrowerBenchmarkFindingStatus {
  /** Firm value sits on the worse side of the reference benchmark for the metric's direction. */
  NeedsAttention = 'NEEDS_ATTENTION',
  /** Firm value meets or exceeds the reference benchmark for the metric's direction. */
  StrengthToProtect = 'STRENGTH_TO_PROTECT'
}

/** GraphQL representation of a member firm registered in a GrowerBenchmark community (contract C7). */
export type GrowerBenchmarkFirm = {
  __typename?: 'GrowerBenchmarkFirm';
  /** Ordered cohort classification facets of the firm. */
  classification: Array<GrowerBenchmarkClassificationFacet>;
  /** Stable identifier of the firm within the community. */
  firmId: Scalars['String']['output'];
  /** Whether the firm registration is active. */
  isActive: Scalars['Boolean']['output'];
  /** Neutral peer-row code. */
  label: Scalars['String']['output'];
  /** Reporting units registered under the firm. */
  reportingUnits: Array<GrowerBenchmarkReportingUnit>;
  /** Owning WorkSuite tenant identifier. */
  tenantId: Scalars['String']['output'];
};

/**
 * Input specifying a classification or metric attribute predicate for growerBenchmarkFirmCodesMatching
 * (contract C1).
 */
export type GrowerBenchmarkFirmAttributePredicateInput = {
  attributeKey: Scalars['String']['input'];
  comparison: GrowerBenchmarkAttributeComparison;
  value: Scalars['String']['input'];
  withinPeriods?: InputMaybe<Scalars['Int']['input']>;
};

/** New value of the reclassified facet for one member firm. */
export type GrowerBenchmarkFirmFacetAssignmentInput = {
  /** Registered firm identifier within the community. */
  firmId: Scalars['String']['input'];
  /** New facet value for the firm. */
  value: Scalars['String']['input'];
};

/** Root firm results payload returned by growerBenchmarkFirmHome for one selected reporting period (contract C1). */
export type GrowerBenchmarkFirmHome = {
  __typename?: 'GrowerBenchmarkFirmHome';
  cohort: GrowerBenchmarkCohort;
  communityId: Scalars['String']['output'];
  comparisonPeriod?: Maybe<GrowerBenchmarkPeriod>;
  findings: Array<GrowerBenchmarkFinding>;
  firmId: Scalars['String']['output'];
  headlineMetrics: Array<GrowerBenchmarkMetricPosition>;
  period: GrowerBenchmarkPeriod;
  positionMetrics: Array<GrowerBenchmarkMetricPosition>;
  review: GrowerBenchmarkPeriodReview;
  segment: GrowerBenchmarkCommunitySegment;
  selfFirmLabel: Scalars['String']['output'];
  series: Array<GrowerBenchmarkFirmMetricSeries>;
};

/**
 * One firm opened by beginGrowerBenchmarkFirmLookup: the firm's registry entry, console profile and submission
 * versions, with the typed reason and the time the access was recorded (contract K2).
 */
export type GrowerBenchmarkFirmLookup = {
  __typename?: 'GrowerBenchmarkFirmLookup';
  /** Community firm registry entry including reporting units and cohort facets. */
  firm: GrowerBenchmarkFirm;
  /** Timestamp recorded on the access log row for this lookup. */
  openedAt: Scalars['DateTime']['output'];
  /** Console firm profile; its displayName is the firm's neutral registry label. */
  profile: GrowerBenchmarkFirmProfile;
  /** Typed reason recorded on the access log row for this lookup. */
  reason: Scalars['String']['output'];
  /** Every GrowerBenchmark submission version of the firm in the community, newest first. */
  submissions: Array<GrowerBenchmarkSubmission>;
};

/** Mutation payload returned by beginGrowerBenchmarkFirmLookup (contract K2). */
export type GrowerBenchmarkFirmLookupPayload = {
  __typename?: 'GrowerBenchmarkFirmLookupPayload';
  /** Typed gate or validation errors, or null on success. */
  errors?: Maybe<Array<ValidationError>>;
  /** Opened firm on success, or null on a validation or gate refusal. */
  lookup?: Maybe<GrowerBenchmarkFirmLookup>;
};

/**
 * One member firm reporting unit's value on one metric in one period, with its standing in its cohort
 * (contracts M3 and C9).
 */
export type GrowerBenchmarkFirmMetric = {
  __typename?: 'GrowerBenchmarkFirmMetric';
  /** Canonical key of the firm's cohort (contract C11). */
  cohortKey: Scalars['String']['output'];
  /** Reported values in the cohort, or null when the cohort was withheld. */
  cohortSize?: Maybe<Scalars['Int']['output']>;
  /** Community firm registry identifier. */
  firmId: Scalars['String']['output'];
  /** Catalog metric key. */
  metricKey: Scalars['String']['output'];
  /** Reporting period identifier. */
  periodId: Scalars['String']['output'];
  /** One for the best reported value in the cohort, or null when the value is excluded or the cohort was withheld. */
  rankInCohort?: Maybe<Scalars['Int']['output']>;
  /** Reporting unit within the firm. */
  reportingUnitId: Scalars['String']['output'];
  /** Computed value, or null when the metric could not be computed. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** GraphQL representation of one period data point in a firm's own sparkline series (contract C1). */
export type GrowerBenchmarkFirmMetricPoint = {
  __typename?: 'GrowerBenchmarkFirmMetricPoint';
  periodId: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

/** GraphQL representation of a firm's own historical series for one active catalog metric (contract C1). */
export type GrowerBenchmarkFirmMetricSeries = {
  __typename?: 'GrowerBenchmarkFirmMetricSeries';
  metricKey: Scalars['String']['output'];
  points: Array<GrowerBenchmarkFirmMetricPoint>;
};

/**
 * GraphQL representation of the caller firm's own value, up to two prior comparison points, three-year average, and
 * cohort rank for one metric in one period (contract C1).
 */
export type GrowerBenchmarkFirmMetricValue = {
  __typename?: 'GrowerBenchmarkFirmMetricValue';
  metricKey: Scalars['String']['output'];
  periodId: Scalars['String']['output'];
  priorPeriods: Array<GrowerBenchmarkComparisonPoint>;
  rank?: Maybe<Scalars['Int']['output']>;
  rankOf?: Maybe<Scalars['Int']['output']>;
  threeYearAverage?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** GraphQL representation of a member firm's console profile in a GrowerBenchmark community (contract K2). */
export type GrowerBenchmarkFirmProfile = {
  __typename?: 'GrowerBenchmarkFirmProfile';
  /** Onboarding checklist items tracked for the firm. */
  checklist: Array<GrowerBenchmarkOnboardingChecklistItem>;
  /** Stable identifier of the GrowerBenchmark community. */
  communityId: Scalars['String']['output'];
  /** Real display name of the member firm, surfaced only inside gated console fields. */
  displayName: Scalars['String']['output'];
  /** Stable identifier of the member firm within the community. */
  firmId: Scalars['String']['output'];
  /** Free-form console labels attached to the firm profile. */
  tags: Array<Scalars['String']['output']>;
  /** Optional ticker symbol assigned to the firm profile. */
  ticker?: Maybe<Scalars['String']['output']>;
};

/** Mutation payload returned by console firm profile, checklist, and billing-state mutations (contract K2). */
export type GrowerBenchmarkFirmProfilePayload = {
  __typename?: 'GrowerBenchmarkFirmProfilePayload';
  /** Typed validation or gate errors, or null on success. */
  errors?: Maybe<Array<ValidationError>>;
  /** Updated firm profile on success, or null on validation/gate refusal. */
  profile?: Maybe<GrowerBenchmarkFirmProfile>;
};

/** Nearest published benchmark line that a firm has not yet met on a released review finding (contract C1). */
export enum GrowerBenchmarkGapReference {
  /** Gap is measured to the cohort median. */
  Median = 'MEDIAN',
  /** Gap is measured to the catalog metric target. */
  Target = 'TARGET',
  /** Gap is measured to the cohort top quartile. */
  TopQuartile = 'TOP_QUARTILE'
}

/** GraphQL representation of one staged legacy line value (contract G2). */
export type GrowerBenchmarkImportedLine = {
  __typename?: 'GrowerBenchmarkImportedLine';
  /** Text found in a numeric source cell, kept verbatim. */
  capturedNote?: Maybe<Scalars['String']['output']>;
  /** GrowerBenchmark line code the value belongs to. */
  lineCode: Scalars['String']['output'];
  /** Period column inside the period the value was reported for. */
  periodKey: Scalars['String']['output'];
  /** Reported figure, null when the source did not report it and 0 when it reported zero. */
  value?: Maybe<Scalars['Decimal']['output']>;
};

/** One legacy line value to stage (contract G2). */
export type GrowerBenchmarkImportedLineInput = {
  /** Text found in a numeric source cell, kept verbatim. */
  capturedNote?: InputMaybe<Scalars['String']['input']>;
  /** GrowerBenchmark line code the value belongs to. */
  lineCode: Scalars['String']['input'];
  /** Period column inside the period the value was reported for. */
  periodKey: Scalars['String']['input'];
  /** Reported figure, null when the source did not report it and 0 when it reported zero. */
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

/** GraphQL representation of one staged imported-lines document (contracts C10 and G2). */
export type GrowerBenchmarkImportedLines = {
  __typename?: 'GrowerBenchmarkImportedLines';
  /** GrowerBenchmark community the lines were staged into. */
  communityId: Scalars['String']['output'];
  /** Registered firm the reporting unit belongs to. */
  firmId: Scalars['String']['output'];
  /** Staging key formatted as communityId-reportingUnitId-periodId-sourceDigest. */
  id: Scalars['String']['output'];
  /** Staged line values. */
  lines: Array<GrowerBenchmarkImportedLine>;
  /** Reporting period identifier. */
  periodId: Scalars['String']['output'];
  /** Reporting unit the staged figures belong to. */
  reportingUnitId: Scalars['String']['output'];
  /** Lowercase hexadecimal SHA-256 digest of the source file. */
  sourceDigest: Scalars['String']['output'];
  /** Original file name of the legacy source. */
  sourceFileName: Scalars['String']['output'];
  /** When the lines were staged. */
  stagedAt: Scalars['DateTime']['output'];
};

/** Mutation payload returned by stageGrowerBenchmarkImportedLines (contract G2). */
export type GrowerBenchmarkImportedLinesPayload = {
  __typename?: 'GrowerBenchmarkImportedLinesPayload';
  /** Typed validation or gate errors, or null on success. */
  errors?: Maybe<Array<ValidationError>>;
  /** The staged document, or null on a validation or gate refusal. */
  importedLines?: Maybe<GrowerBenchmarkImportedLines>;
};

/** GraphQL representation of a section definition on a GrowerBenchmarkInstructionVersion (contracts R1 and R4). */
export type GrowerBenchmarkInstructionSection = {
  __typename?: 'GrowerBenchmarkInstructionSection';
  isRequired: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  sectionId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Section definition input supplied to addGrowerBenchmarkInstructionSetVersion (contract R4). */
export type GrowerBenchmarkInstructionSectionInput = {
  isRequired: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
  sectionId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** GraphQL representation of a GrowerBenchmark review instruction set and its immutable version history (contracts R1 and R4). */
export type GrowerBenchmarkInstructionSet = {
  __typename?: 'GrowerBenchmarkInstructionSet';
  communityId: Scalars['String']['output'];
  currentVersionId?: Maybe<Scalars['String']['output']>;
  instructionSetId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  segment: GrowerBenchmarkCommunitySegment;
  versions: Array<GrowerBenchmarkInstructionVersion>;
};

/** Mutation payload returned by addGrowerBenchmarkInstructionSet and addGrowerBenchmarkInstructionSetVersion (contract R4). */
export type GrowerBenchmarkInstructionSetPayload = {
  __typename?: 'GrowerBenchmarkInstructionSetPayload';
  errors?: Maybe<Array<ValidationError>>;
  instructionSet?: Maybe<GrowerBenchmarkInstructionSet>;
};

/** GraphQL representation of an immutable version on a GrowerBenchmarkInstructionSet (contracts R1 and R4). */
export type GrowerBenchmarkInstructionVersion = {
  __typename?: 'GrowerBenchmarkInstructionVersion';
  authorUserId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  effectiveAt: Scalars['DateTime']['output'];
  sections: Array<GrowerBenchmarkInstructionSection>;
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

/**
 * One member directory row pairing a community's GrowerBenchmarkFirm registry entry with its console GrowerBenchmarkFirmProfile
 * (contract K2).
 */
export type GrowerBenchmarkMemberDirectoryRow = {
  __typename?: 'GrowerBenchmarkMemberDirectoryRow';
  /** Community firm registry entry including reporting units and cohort facets. */
  firm: GrowerBenchmarkFirm;
  /** Console firm profile including displayName, tags, ticker, and checklist. */
  profile: GrowerBenchmarkFirmProfile;
};

/** One metric definition on a community's GrowerBenchmark metric catalog (contracts M3 and C9). */
export type GrowerBenchmarkMetric = {
  __typename?: 'GrowerBenchmarkMetric';
  /** Ordered presentation threshold bands. */
  bands: Array<GrowerBenchmarkMetricBand>;
  /** GrowerBenchmark community owning the catalog. */
  communityId: Scalars['String']['output'];
  /** Fractional digits rendered for values of the metric. */
  decimalPlaces: Scalars['Int']['output'];
  /** Whether higher or lower values are better. */
  direction: GrowerBenchmarkMetricDirection;
  /** Arithmetic expression over the named inputs. */
  formula: Scalars['String']['output'];
  /** Presentation section key on the firm home and compare pages. */
  groupKey: Scalars['String']['output'];
  /** Fact keys the formula reads. */
  inputs: Array<Scalars['String']['output']>;
  /** Whether the metric is published and evaluated. */
  isActive: Scalars['Boolean']['output'];
  /** Display label of the metric. */
  label: Scalars['String']['output'];
  /** Stable machine key of the metric within the community. */
  metricKey: Scalars['String']['output'];
  /** Display position within the group. */
  sortOrder: Scalars['Int']['output'];
  /** Display unit: currency, percent, ratio, count or days. */
  unit: Scalars['String']['output'];
  /** Time of this revision. */
  updatedAt: Scalars['DateTime']['output'];
  /** Revision of this metric key, one for its first definition. */
  version: Scalars['Int']['output'];
};

/** Presentation threshold band on a GrowerBenchmark catalog metric (contract C7 and C9). */
export type GrowerBenchmarkMetricBand = {
  __typename?: 'GrowerBenchmarkMetricBand';
  /** Display label naming this performance band. */
  label: Scalars['String']['output'];
  /** Inclusive lower bound of the band, or null when the band is unbounded below. */
  lowerThreshold?: Maybe<Scalars['Float']['output']>;
  /** Upper bound of the band, or null when the band is unbounded above. */
  upperThreshold?: Maybe<Scalars['Float']['output']>;
};

/** One presentation band supplied to growerBenchmarkUpsertMetric (contract M3). */
export type GrowerBenchmarkMetricBandInput = {
  /** Display label naming the band. */
  label: Scalars['String']['input'];
  /** Inclusive lower bound, or null when open below. */
  lowerThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** Upper bound, or null when open above. */
  upperThreshold?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * GraphQL representation of one active catalog metric definition returned on the firm home and compare surfaces
 * (contract C1).
 */
export type GrowerBenchmarkMetricDefinition = {
  __typename?: 'GrowerBenchmarkMetricDefinition';
  bands: Array<GrowerBenchmarkMetricBand>;
  decimals: Scalars['Int']['output'];
  direction: GrowerBenchmarkMetricDirection;
  formula: Scalars['String']['output'];
  groupKey: Scalars['String']['output'];
  inputs: Array<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  metricKey: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  target?: Maybe<Scalars['Float']['output']>;
  unit: GrowerBenchmarkMetricUnit;
};

export enum GrowerBenchmarkMetricDirection {
  HigherIsBetter = 'HIGHER_IS_BETTER',
  LowerIsBetter = 'LOWER_IS_BETTER'
}

/**
 * GraphQL representation of one headline or Strategic Profit Model position row on GrowerBenchmarkFirmHome
 * (contract C1).
 */
export type GrowerBenchmarkMetricPosition = {
  __typename?: 'GrowerBenchmarkMetricPosition';
  definition: GrowerBenchmarkMetricDefinition;
  self?: Maybe<GrowerBenchmarkFirmMetricValue>;
  statistics: GrowerBenchmarkCohortMetricStatistics;
  verdict?: Maybe<GrowerBenchmarkPositionVerdict>;
};

/** Display unit formatting classification for a GrowerBenchmark catalog metric (contract C1). */
export enum GrowerBenchmarkMetricUnit {
  /** Whole or fractional item/headcount figure. */
  Count = 'COUNT',
  /** Monetary currency amount. */
  Currency = 'CURRENCY',
  /** Duration measured in days. */
  Days = 'DAYS',
  /** Percentage value. */
  Percent = 'PERCENT',
  /** Dimensionless ratio or multiple. */
  Ratio = 'RATIO'
}

/**
 * Input adding or retuning one metric on a community's catalog (contract M3). Carries no version: the catalog
 * computes it.
 */
export type GrowerBenchmarkMetricUpsertInput = {
  /** Ordered presentation threshold bands. */
  bands: Array<GrowerBenchmarkMetricBandInput>;
  /** GrowerBenchmark community whose catalog is changed. */
  communityId: Scalars['String']['input'];
  /** Fractional digits rendered for values of the metric. */
  decimalPlaces: Scalars['Int']['input'];
  /** Whether higher or lower values are better. */
  direction: GrowerBenchmarkMetricDirection;
  /** Arithmetic expression over the named inputs. */
  formula: Scalars['String']['input'];
  /** Presentation section key on the firm home and compare pages. */
  groupKey: Scalars['String']['input'];
  /** Fact keys the formula reads. */
  inputs: Array<Scalars['String']['input']>;
  /** Whether the metric is published and evaluated. */
  isActive: Scalars['Boolean']['input'];
  /** Display label of the metric. */
  label: Scalars['String']['input'];
  /** Stable machine key of the metric within the community. */
  metricKey: Scalars['String']['input'];
  /** Display position within the group. */
  sortOrder: Scalars['Int']['input'];
  /** Display unit: currency, percent, ratio, count or days. */
  unit: Scalars['String']['input'];
};

/** Payload returned by growerBenchmarkUpsertMetric (contracts M3 and C7). */
export type GrowerBenchmarkMetricUpsertPayload = {
  __typename?: 'GrowerBenchmarkMetricUpsertPayload';
  /** Typed validation or gate errors, or null on success. */
  errors?: Maybe<Array<ValidationError>>;
  /** The metric as the upsert event carried it, or null on refusal. */
  metric?: Maybe<GrowerBenchmarkMetric>;
};

/**
 * Grower-facing GraphQL representation of the currently open reporting period for the caller's member firm
 * (contract D9). Exposes period details and aggregate participation counts without internal program identifiers
 * or peer names.
 */
export type GrowerBenchmarkMyPeriod = {
  __typename?: 'GrowerBenchmarkMyPeriod';
  /** Submission deadline timestamp for the open reporting period. */
  dueAt: Scalars['DateTime']['output'];
  /** Total participating member firms in the community for this reporting period. */
  firmCount: Scalars['Int']['output'];
  /** Reporting period identifier (for example 2026). */
  periodId: Scalars['String']['output'];
  /** Human-readable English label for periodId (for example Full Year 2026). */
  periodLabel: Scalars['String']['output'];
  /** Participating member firms that have submitted for this reporting period. */
  submittedCount: Scalars['Int']['output'];
};

/** One onboarding checklist item on a GrowerBenchmarkFirmProfile (contracts K1 and K2). */
export type GrowerBenchmarkOnboardingChecklistItem = {
  __typename?: 'GrowerBenchmarkOnboardingChecklistItem';
  /** Timestamp when the item was marked complete, or null when incomplete. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Authenticated user identifier that completed the item, or null when incomplete. */
  completedByUserId?: Maybe<Scalars['String']['output']>;
  /** Whether the checklist item has been marked complete. */
  isComplete: Scalars['Boolean']['output'];
  /** Stable checklist item key rather than display text. */
  itemKey: Scalars['String']['output'];
};

/** Anonymized peer-firm row on growerBenchmarkCompare, carrying only the firm code and numeric figures (contract C1). */
export type GrowerBenchmarkPeerRow = {
  __typename?: 'GrowerBenchmarkPeerRow';
  firmLabel: Scalars['String']['output'];
  isSelf: Scalars['Boolean']['output'];
  priorPeriodValue?: Maybe<Scalars['Float']['output']>;
  threeYearAverage?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** GraphQL representation of one reporting period on the period picker and results/compare headers (contract C1). */
export type GrowerBenchmarkPeriod = {
  __typename?: 'GrowerBenchmarkPeriod';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  cadence: GrowerBenchmarkReportingCadence;
  comparisonPeriodId?: Maybe<Scalars['String']['output']>;
  kind: GrowerBenchmarkPeriodKind;
  label: Scalars['String']['output'];
  periodId: Scalars['String']['output'];
};

/**
 * Structural shape of a GrowerBenchmark reporting period identifier derived by GrowerBenchmarkPeriodComparison
 * (contract C1).
 */
export enum GrowerBenchmarkPeriodKind {
  /** Four-digit calendar or fiscal full-year period such as "2026". */
  FullYear = 'FULL_YEAR',
  /** Half-year period such as "2026-H1" or "2026-H2". */
  HalfYear = 'HALF_YEAR',
  /** Calendar month period such as "2026-09". */
  Month = 'MONTH',
  /** Any period identifier outside the full-year, half-year, and month shapes. */
  Other = 'OTHER'
}

/** GraphQL representation of the per-period written review card on GrowerBenchmarkFirmHome (contract C1). */
export type GrowerBenchmarkPeriodReview = {
  __typename?: 'GrowerBenchmarkPeriodReview';
  draftOrigin?: Maybe<Scalars['String']['output']>;
  releasedAt?: Maybe<Scalars['DateTime']['output']>;
  releasedByName?: Maybe<Scalars['String']['output']>;
  reviewId?: Maybe<Scalars['String']['output']>;
  sectionCount?: Maybe<Scalars['Int']['output']>;
  state: GrowerBenchmarkReviewCardState;
};

/**
 * Performance band verdict rendered on a GrowerBenchmark position row, or NO_COHORT when the metric's own reported
 * firm count falls below the floor (contract C1).
 */
export enum GrowerBenchmarkPositionVerdict {
  /** Value falls inside the metric's Needs work band. */
  NeedsWork = 'NEEDS_WORK',
  /** Metric reported count is below the five-firm floor so no verdict is computed. */
  NoCohort = 'NO_COHORT',
  /** Value falls inside the metric's On track band. */
  OnTrack = 'ON_TRACK',
  /** Value falls inside the metric's Well done band. */
  WellDone = 'WELL_DONE'
}

/** Input required to confirm a real GrowerBenchmark module purge run (contract CP1). */
export type GrowerBenchmarkPurgeInput = {
  /** Must equal the resolved GrowerBenchmark MongoDB database name at runtime. */
  confirmationPhrase: Scalars['String']['input'];
};

/**
 * Discriminator category of a GrowerBenchmark module data inventory item reported by a purge dry run or real purge run
 * (contract CP1).
 */
export enum GrowerBenchmarkPurgeItemKind {
  /** Purge completion audit records persisted in the default database. */
  AuditRecord = 'AUDIT_RECORD',
  /** Per-tenant blob-name scope segment inside member tenants' blob containers. */
  BlobContainer = 'BLOB_CONTAINER',
  /** Cached artifact key prefix owned by the GrowerBenchmark module. */
  CachedArtifact = 'CACHED_ARTIFACT',
  /** MongoDB read-model collection stored in the dedicated GrowerBenchmark database. */
  Collection = 'COLLECTION',
  /** GrowerBenchmark-sourced sent-email records and correlated delivery events. */
  EmailRecord = 'EMAIL_RECORD',
  /** Declared GrowerBenchmark module record persisted in a default-database platform collection. */
  ExternalRecord = 'EXTERNAL_RECORD',
  /** Stateless external or in-cluster processor disclosed by the inventory that retains nothing. */
  Processor = 'PROCESSOR',
  /** Default-database projection checkpoint, health, and dead-letter rows for a GrowerBenchmark projection. */
  ProjectionBookkeeping = 'PROJECTION_BOOKKEEPING',
  /** Event-store stream category addressed under the GrowerBenchmark stream prefix. */
  StreamCategory = 'STREAM_CATEGORY'
}

/** Per-item outcome reported by a GrowerBenchmark module purge dry run or real purge run (contract CP1). */
export type GrowerBenchmarkPurgeItemResult = {
  __typename?: 'GrowerBenchmarkPurgeItemResult';
  /** Items counted for this inventory entry. */
  countedItems: Scalars['Int']['output'];
  /** Whether this inventory kind is reachable for removal during a real purge. */
  isReachable: Scalars['Boolean']['output'];
  /** Inventory item category. */
  kind: GrowerBenchmarkPurgeItemKind;
  /** Canonical store, stream category, scope segment, bookkeeping key, or external record name. */
  name: Scalars['String']['output'];
  /** Audit note describing how the item was counted or removed. */
  note: Scalars['String']['output'];
  /** Service provider register row key derived from the item kind. */
  provider: Scalars['String']['output'];
  /** Human-readable description of what the inventory item represents. */
  purpose: Scalars['String']['output'];
  /** Items removed for this inventory entry (zero in dry-run mode). */
  removedItems: Scalars['Int']['output'];
};

/** Execution mode of a GrowerBenchmark module purge operation (contract CP1). */
export enum GrowerBenchmarkPurgeMode {
  /** Counts every declared inventory item without removing any data. */
  DryRun = 'DRY_RUN',
  /** Counts and removes every reachable GrowerBenchmark module store, stream, and bookkeeping record. */
  Real = 'REAL'
}

/** Summary and per-item breakdown of a GrowerBenchmark module purge dry run or real purge run (contract CP1). */
export type GrowerBenchmarkPurgeRun = {
  __typename?: 'GrowerBenchmarkPurgeRun';
  /** Timestamp when the run finished, or null if a prior run never closed its lease. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Resolved GrowerBenchmark MongoDB database name. */
  databaseName: Scalars['String']['output'];
  /** Per-item count and removal results in inventory order. */
  items: Array<GrowerBenchmarkPurgeItemResult>;
  /** Whether the run was a dry run or a real purge. */
  mode: GrowerBenchmarkPurgeMode;
  /** Unique identifier of the purge run. */
  purgeRunId: Scalars['String']['output'];
  /** Email address of the SuperAdmin operator who requested the run. */
  runByEmail: Scalars['String']['output'];
  /** Identifier of the SuperAdmin operator who requested the run. */
  runByUserId: Scalars['String']['output'];
  /** Timestamp when the run started. */
  startedAt: Scalars['DateTime']['output'];
  /** Terminal status of the run. */
  status: GrowerBenchmarkPurgeStatus;
  /** Leading KurrentDB stream category prefix scanned by the run. */
  streamCategoryPrefix: Scalars['String']['output'];
  /** Sum of counted items across all inventory entries. */
  totalCounted: Scalars['Int']['output'];
  /** Sum of removed items across all inventory entries. */
  totalRemoved: Scalars['Int']['output'];
  /** Names of inventory entries whose kind is not reachable for removal. */
  unreachableItemNames: Array<Scalars['String']['output']>;
};

/** Mutation payload returned by growerBenchmarkPurgeDryRun and growerBenchmarkPurge (contract CP1). */
export type GrowerBenchmarkPurgeRunPayload = {
  __typename?: 'GrowerBenchmarkPurgeRunPayload';
  /** Typed validation errors ([ValidationError!]), or null on success. */
  errors?: Maybe<Array<ValidationError>>;
  /** Completed purge run report on success, or null when refused by a validation error. */
  purgeRun?: Maybe<GrowerBenchmarkPurgeRun>;
};

/** Terminal outcome status of a GrowerBenchmark module purge run (contract CP1). */
export enum GrowerBenchmarkPurgeStatus {
  /** Every declared inventory item was processed to completion. */
  Completed = 'COMPLETED',
  /** The purge run stopped before completing all declared inventory items. */
  Failed = 'FAILED'
}

/**
 * One band or cohort row of a reclassification preview. A row below the floor is withheld for every metric; a row at
 * or above it can still be withheld for a metric fewer than floorFirmCount of its firms report.
 */
export type GrowerBenchmarkReclassifyCohortCount = {
  __typename?: 'GrowerBenchmarkReclassifyCohortCount';
  /** Facet values of the row, taken from the lowest firmId in it. */
  cohortFacets: Array<GrowerBenchmarkClassificationFacet>;
  /** Canonical cohort key of the row (contract C11). */
  cohortKey: Scalars['String']['output'];
  /** Counted firms in the row under the current classification. */
  currentFirmCount: Scalars['Int']['output'];
  /**
   * True when proposedFirmCount is below floorFirmCount: the row is withheld for every metric. A row at or above the
   * floor can still be withheld for a metric fewer than floorFirmCount of its firms report.
   */
  isBelowFloor: Scalars['Boolean']['output'];
  /** Counted firms in the row once the assignments are saved. */
  proposedFirmCount: Scalars['Int']['output'];
};

/**
 * Input setting one cohort classification facet on many member firms, read by growerBenchmarkReclassifyFirmsPreview and
 * saved by growerBenchmarkReclassifyFirms.
 */
export type GrowerBenchmarkReclassifyFirmsInput = {
  /** New facet value per firm; each firm may appear once. */
  assignments: Array<GrowerBenchmarkFirmFacetAssignmentInput>;
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Lowercase [a-z0-9]{1,32} facet key being reassigned, for example salesband. */
  facetKey: Scalars['String']['input'];
};

/**
 * Before-save preview of an analyst bulk reclassification: current and proposed firm counts per band and per cohort.
 * Advisory only: saving is never refused for a row below the floor, and growerBenchmarkReclassifyFirms re-reads the
 * registry when it saves.
 */
export type GrowerBenchmarkReclassifyFirmsPreview = {
  __typename?: 'GrowerBenchmarkReclassifyFirmsPreview';
  /** Rows grouped by the reclassified facet alone; a firm without that facet is in no band row. */
  bands: Array<GrowerBenchmarkReclassifyCohortCount>;
  /** Rows grouped by each firm's full classification, as the cohort pass groups them. */
  cohorts: Array<GrowerBenchmarkReclassifyCohortCount>;
  /** Minimum firm count a row needs before cohort statistics are published. */
  floorFirmCount: Scalars['Int']['output'];
};

export enum GrowerBenchmarkReportingCadence {
  Cycle = 'CYCLE',
  Month = 'MONTH'
}

/** GraphQL representation of a reporting unit under a GrowerBenchmarkFirm (contract C7). */
export type GrowerBenchmarkReportingUnit = {
  __typename?: 'GrowerBenchmarkReportingUnit';
  /** Collection cadence of the reporting unit. */
  cadence: GrowerBenchmarkReportingCadence;
  /** Display label of the reporting unit. */
  label: Scalars['String']['output'];
  /** Stable reporting unit identifier. */
  reportingUnitId: Scalars['String']['output'];
};

/** Input specifying one reporting unit on RegisterGrowerBenchmarkFirmInput (contract C7). */
export type GrowerBenchmarkReportingUnitInput = {
  /** Collection cadence of the reporting unit. */
  cadence: GrowerBenchmarkReportingCadence;
  /** Display label of the reporting unit. */
  label: Scalars['String']['input'];
  /** Optional earliest period identifier read by period-start rules. */
  reportingStartPeriodId?: InputMaybe<Scalars['String']['input']>;
  /** Stable reporting unit identifier. */
  reportingUnitId: Scalars['String']['input'];
};

/**
 * GraphQL representation of one calendar month row for a retail reporting unit, carrying null status, version,
 * submissionId, and values when no submission exists for that month (contract CR2).
 */
export type GrowerBenchmarkRetailMonth = {
  __typename?: 'GrowerBenchmarkRetailMonth';
  /** Identifier of the GrowerBenchmark community owning reportingUnitId. */
  communityId: Scalars['String']['output'];
  /** Calendar month period identifier in YYYY-MM form. */
  periodId: Scalars['String']['output'];
  /** Reporting unit identifier. */
  reportingUnitId: Scalars['String']['output'];
  /** Current lifecycle status of the latest version for this month, or null when unsubmitted. */
  status?: Maybe<GrowerBenchmarkSubmissionStatus>;
  /** Submission identifier of the latest version for this month, or null when unsubmitted. */
  submissionId?: Maybe<Scalars['String']['output']>;
  /** Retail month values for the latest version on this month, or null when unsubmitted. */
  values?: Maybe<GrowerBenchmarkRetailMonthValues>;
  /** 1-based version number of the latest version for this month, or null when unsubmitted. */
  version?: Maybe<Scalars['Int']['output']>;
};

/** GraphQL representation of a field-scoped warning finding on a retail month submission (contracts CR2 and CR3). */
export type GrowerBenchmarkRetailMonthFinding = {
  __typename?: 'GrowerBenchmarkRetailMonthFinding';
  /** Stable warning rule code. */
  code: Scalars['String']['output'];
  /** Input field identifier to which the warning belongs. */
  field: Scalars['String']['output'];
  /** Plain-language explanation of the warning. */
  message: Scalars['String']['output'];
};

/** Mutation payload returned by setGrowerBenchmarkRetailMonthValues (contract CR2). */
export type GrowerBenchmarkRetailMonthPayload = {
  __typename?: 'GrowerBenchmarkRetailMonthPayload';
  /** Blocking validation or gate errors, or null when no blocking rule fired. */
  errors?: Maybe<Array<ValidationError>>;
  /** Updated retail month view on a committed write, or null when refused or awaiting warning acceptance. */
  month?: Maybe<GrowerBenchmarkRetailMonth>;
  /** Warning findings evaluated on the submitted values. */
  warnings: Array<GrowerBenchmarkRetailMonthFinding>;
};

/** GraphQL representation of the six retail month figures recorded for one GrowerBenchmark submission version (contract CR2). */
export type GrowerBenchmarkRetailMonthValues = {
  __typename?: 'GrowerBenchmarkRetailMonthValues';
  /** Identifier of the GrowerBenchmark community owning the submission. */
  communityId: Scalars['String']['output'];
  /** Customer count figure. */
  customerCount: Scalars['Int']['output'];
  /** Timestamp when the figures were entered. */
  enteredAt: Scalars['DateTime']['output'];
  /** Authenticated user identifier that entered the figures. */
  enteredByUserId: Scalars['String']['output'];
  /** Identifier of the member firm owning reportingUnitId. */
  firmId: Scalars['String']['output'];
  /** Gross margin dollars figure. */
  grossMarginDollars: Scalars['Decimal']['output'];
  /** Gross sales figure. */
  grossSales: Scalars['Decimal']['output'];
  /** Labor dollars figure. */
  laborDollars: Scalars['Decimal']['output'];
  /** Labor hours figure. */
  laborHours: Scalars['Decimal']['output'];
  /** Calendar month period identifier in YYYY-MM form. */
  periodId: Scalars['String']['output'];
  /** Reporting unit identifier. */
  reportingUnitId: Scalars['String']['output'];
  /** Unique submission version identifier. */
  submissionId: Scalars['String']['output'];
  /** Optional unit count figure, or null when omitted. */
  unitCount?: Maybe<Scalars['Int']['output']>;
  /** 1-based submission version number. */
  version: Scalars['Int']['output'];
};

/** Input carrying the six retail month figures in fixed contract CR1 order (contract CR2). */
export type GrowerBenchmarkRetailMonthValuesInput = {
  /** Customer count figure. */
  customerCount: Scalars['Int']['input'];
  /** Gross margin dollars figure. */
  grossMarginDollars: Scalars['Decimal']['input'];
  /** Gross sales figure. */
  grossSales: Scalars['Decimal']['input'];
  /** Labor dollars figure. */
  laborDollars: Scalars['Decimal']['input'];
  /** Labor hours figure. */
  laborHours: Scalars['Decimal']['input'];
  /** Optional unit count figure, or null when omitted. */
  unitCount?: InputMaybe<Scalars['Int']['input']>;
};

/** GraphQL representation of a per-firm GrowerBenchmark review, its versions, its approval, and its release (contracts R2 and R4). */
export type GrowerBenchmarkReview = {
  __typename?: 'GrowerBenchmarkReview';
  analystEditSeconds: Scalars['Int']['output'];
  approval?: Maybe<GrowerBenchmarkReviewApproval>;
  approvedVersionId?: Maybe<Scalars['String']['output']>;
  draftedAt: Scalars['DateTime']['output'];
  firmId: Scalars['String']['output'];
  periodId: Scalars['String']['output'];
  release?: Maybe<GrowerBenchmarkReviewRelease>;
  reportingUnitId: Scalars['String']['output'];
  reportingUnitLabel: Scalars['String']['output'];
  reviewId: Scalars['String']['output'];
  segment: GrowerBenchmarkCommunitySegment;
  status: GrowerBenchmarkReviewStatus;
  versions: Array<GrowerBenchmarkReviewVersion>;
};

/** GraphQL representation of the approval record on a GrowerBenchmarkReview (contracts R2 and R4). */
export type GrowerBenchmarkReviewApproval = {
  __typename?: 'GrowerBenchmarkReviewApproval';
  analystEditSeconds: Scalars['Int']['output'];
  approvedAt: Scalars['DateTime']['output'];
  approvedByUserId: Scalars['String']['output'];
  approvedVersionId: Scalars['String']['output'];
  outputType: GrowerBenchmarkReviewOutputType;
};

/** Publication state of the per-firm written review card for a selected reporting period (contract C1). */
export enum GrowerBenchmarkReviewCardState {
  /** The period's figures are approved, and the written review has not yet been released. */
  Coming = 'COMING',
  /** The period is not approved and has no released review. */
  None = 'NONE',
  /** A written review for the selected period has been approved and released. */
  Released = 'RELEASED'
}

/**
 * Mutation payload returned by draftGrowerBenchmarkReviewsForPeriod (contract R4). A code that refuses the whole call comes
 * back in errors with empty results; one firm's code comes back on that firm's result.
 */
export type GrowerBenchmarkReviewDraftBatchPayload = {
  __typename?: 'GrowerBenchmarkReviewDraftBatchPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<GrowerBenchmarkReviewDraftResult>;
};

/** Outcome of one firm and reporting unit in a period draft (contract R4). */
export enum GrowerBenchmarkReviewDraftOutcome {
  /** The draft landed; the result carries the review id. */
  Drafted = 'DRAFTED',
  /** The draft did not land; the result carries this firm's code. */
  Failed = 'FAILED',
  /** The review already holds a version at this instruction version; nothing was appended. */
  Skipped = 'SKIPPED'
}

/**
 * One firm and reporting unit's answer in a period draft (contract R4). DRAFTED and SKIPPED carry the
 * review id; FAILED carries a null review id and that firm's own code.
 */
export type GrowerBenchmarkReviewDraftResult = {
  __typename?: 'GrowerBenchmarkReviewDraftResult';
  /** The firm's code when the draft failed, otherwise null. */
  code?: Maybe<Scalars['String']['output']>;
  /** Member firm identifier. */
  firmId: Scalars['String']['output'];
  /** Drafted, skipped or failed. */
  outcome: GrowerBenchmarkReviewDraftOutcome;
  /** Reporting unit identifier. */
  reportingUnitId: Scalars['String']['output'];
  /** Review identifier, or null when the draft failed. */
  reviewId?: Maybe<Scalars['String']['output']>;
};

/** GraphQL representation of a metric evidence link inside a GrowerBenchmarkReviewSection (contracts R2 and R4). */
export type GrowerBenchmarkReviewEvidenceLink = {
  __typename?: 'GrowerBenchmarkReviewEvidenceLink';
  label: Scalars['String']['output'];
  metricKey: Scalars['String']['output'];
  periodId: Scalars['String']['output'];
};

/**
 * A direct, attributed quote from the reviewer about one metric, rendered beside that finding on
 * the firm's results page as well as inside the review document. One note per metricKey per version.
 */
export type GrowerBenchmarkReviewFindingNote = {
  __typename?: 'GrowerBenchmarkReviewFindingNote';
  attributedToName: Scalars['String']['output'];
  attributedToUserId: Scalars['String']['output'];
  metricKey: Scalars['String']['output'];
  quote: Scalars['String']['output'];
  writtenAt: Scalars['DateTime']['output'];
};

/**
 * Reviewer finding-note input supplied to saveGrowerBenchmarkReviewVersion (contract R4). Attribution is resolved
 * server-side from the authenticated caller and never supplied on input.
 */
export type GrowerBenchmarkReviewFindingNoteInput = {
  metricKey: Scalars['String']['input'];
  quote: Scalars['String']['input'];
};

/**
 * Two counts, never one. No total is exposed on purpose: a reviewed per-firm review and
 * retainer content are metered separately and adding them would misstate both.
 */
export type GrowerBenchmarkReviewMetering = {
  __typename?: 'GrowerBenchmarkReviewMetering';
  communityId: Scalars['String']['output'];
  perFirmReviewCount: Scalars['Int']['output'];
  periodId: Scalars['String']['output'];
  retainerContentCount: Scalars['Int']['output'];
};

export enum GrowerBenchmarkReviewOutputType {
  PerFirmReview = 'PER_FIRM_REVIEW',
  RetainerContent = 'RETAINER_CONTENT'
}

/** Mutation payload returned by GrowerBenchmarkReview write operations (contract R4). */
export type GrowerBenchmarkReviewPayload = {
  __typename?: 'GrowerBenchmarkReviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  review?: Maybe<GrowerBenchmarkReview>;
};

/** Payload returned from the growerBenchmarkMyReviewPdf query, the shape generateReportPdf returns. */
export type GrowerBenchmarkReviewPdfPayload = {
  __typename?: 'GrowerBenchmarkReviewPdfPayload';
  /** The stable GrowerBenchmark code on a refusal, or a generic message on a failure. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The base64-encoded PDF, or null on a refusal or failure. */
  pdfBase64?: Maybe<Scalars['String']['output']>;
  /** Whether the review rendered. */
  success: Scalars['Boolean']['output'];
};

/** Reviewer report-queue row summarizing one per-firm GrowerBenchmark review (contract R4). */
export type GrowerBenchmarkReviewQueueRow = {
  __typename?: 'GrowerBenchmarkReviewQueueRow';
  draftedAt: Scalars['DateTime']['output'];
  firmId: Scalars['String']['output'];
  instructionVersionId: Scalars['String']['output'];
  instructionVersionNumber: Scalars['Int']['output'];
  periodId: Scalars['String']['output'];
  reportingUnitId: Scalars['String']['output'];
  reportingUnitLabel: Scalars['String']['output'];
  reviewId: Scalars['String']['output'];
  status: GrowerBenchmarkReviewStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Null until the review is released. Approval is not release: a period can be approved with its
 * review not yet released, and in that state the firm sees its numbers and a review card that is
 * still coming. There is no page count: the PDF is rendered on demand and stored nowhere.
 */
export type GrowerBenchmarkReviewRelease = {
  __typename?: 'GrowerBenchmarkReviewRelease';
  draftOrigin: GrowerBenchmarkReviewVersionOrigin;
  releasedAt: Scalars['DateTime']['output'];
  releasedByName: Scalars['String']['output'];
  releasedByUserId: Scalars['String']['output'];
  sectionCount: Scalars['Int']['output'];
};

/** GraphQL representation of a section inside a GrowerBenchmarkReviewVersion (contracts R2 and R4). */
export type GrowerBenchmarkReviewSection = {
  __typename?: 'GrowerBenchmarkReviewSection';
  evidence: Array<GrowerBenchmarkReviewEvidenceLink>;
  narrative: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  sectionId: Scalars['String']['output'];
  tableRows: Array<GrowerBenchmarkReviewTableRow>;
  tiles: Array<GrowerBenchmarkReviewTile>;
  title: Scalars['String']['output'];
};

/** Section edit input supplied to saveGrowerBenchmarkReviewVersion (contract R4). */
export type GrowerBenchmarkReviewSectionInput = {
  narrative: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  sectionId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export enum GrowerBenchmarkReviewStatus {
  Approved = 'APPROVED',
  Drafted = 'DRAFTED',
  InEdit = 'IN_EDIT',
  Released = 'RELEASED',
  Superseded = 'SUPERSEDED'
}

/** GraphQL representation of a formatted table row inside a GrowerBenchmarkReviewSection (contracts R2 and R4). */
export type GrowerBenchmarkReviewTableRow = {
  __typename?: 'GrowerBenchmarkReviewTableRow';
  label: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

/** GraphQL representation of a pre-formatted display tile inside a GrowerBenchmarkReviewSection (contracts R2 and R4). */
export type GrowerBenchmarkReviewTile = {
  __typename?: 'GrowerBenchmarkReviewTile';
  comparison?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** GraphQL representation of an immutable version on a GrowerBenchmarkReview (contracts R2 and R4). */
export type GrowerBenchmarkReviewVersion = {
  __typename?: 'GrowerBenchmarkReviewVersion';
  authorUserId: Scalars['String']['output'];
  changedSectionIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  findingNotes: Array<GrowerBenchmarkReviewFindingNote>;
  instructionSetId: Scalars['String']['output'];
  instructionVersionId: Scalars['String']['output'];
  origin: GrowerBenchmarkReviewVersionOrigin;
  sections: Array<GrowerBenchmarkReviewSection>;
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export enum GrowerBenchmarkReviewVersionOrigin {
  Edited = 'EDITED',
  Generated = 'GENERATED',
  Restored = 'RESTORED'
}

/**
 * GraphQL representation of the reviewer's verbatim attributed finding note from the released review version
 * (contract C1).
 */
export type GrowerBenchmarkReviewerQuote = {
  __typename?: 'GrowerBenchmarkReviewerQuote';
  attributedToName: Scalars['String']['output'];
  quote: Scalars['String']['output'];
  writtenAt: Scalars['DateTime']['output'];
};

/** GraphQL representation of a program-side roster entry on a GrowerBenchmark community (contract C7). */
export type GrowerBenchmarkRosterEntry = {
  __typename?: 'GrowerBenchmarkRosterEntry';
  /** Timestamp when acceptable use was accepted, or null. */
  acceptableUseAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Accepted acceptable-use version string, or null. */
  acceptableUseVersion?: Maybe<Scalars['String']['output']>;
  /** Recorded reason why userId holds role. */
  basis: Scalars['String']['output'];
  /** Optional scheduled expiry timestamp. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the entry is currently unrevoked, started, unexpired, and acceptable-use accepted. */
  isEffective: Scalars['Boolean']['output'];
  /** Granted roster role. */
  role: GrowerBenchmarkRosterRole;
  /** Stable identifier of the roster entry. */
  rosterEntryId: Scalars['String']['output'];
  /** Timestamp at which the entry's active window opens. */
  startsAt: Scalars['DateTime']['output'];
  /** Subject user identifier. */
  userId: Scalars['String']['output'];
};

export enum GrowerBenchmarkRosterRole {
  CommunityAdmin = 'COMMUNITY_ADMIN',
  CommunityAnalyst = 'COMMUNITY_ANALYST',
  CommunityViewer = 'COMMUNITY_VIEWER'
}

/** GraphQL representation of a GrowerBenchmark submission version (contract C7). */
export type GrowerBenchmarkSubmission = {
  __typename?: 'GrowerBenchmarkSubmission';
  /** Approval provenance once approved, or null. */
  approvalType?: Maybe<GrowerBenchmarkApprovalType>;
  /** Timestamp when the version was approved, or null. */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Approving analyst or superadmin user identifier, or null. */
  approvedByUserId?: Maybe<Scalars['String']['output']>;
  /** Identifier of the GrowerBenchmark community owning the submission. */
  communityId: Scalars['String']['output'];
  /** Identifier of the member firm owning reportingUnitId. */
  firmId: Scalars['String']['output'];
  /** Reporting period identifier (for example 2026 or 2026-09). */
  periodId: Scalars['String']['output'];
  /** Reporting unit identifier. */
  reportingUnitId: Scalars['String']['output'];
  /** Current lifecycle status of the submission version. */
  status: GrowerBenchmarkSubmissionStatus;
  /** Unique submission version identifier. */
  submissionId: Scalars['String']['output'];
  /** Timestamp when the version was submitted, or null when never submitted. */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User identifier that submitted the version, or empty string when never submitted. */
  submittedByUserId: Scalars['String']['output'];
  /** Identifier of the newer approved submission version replacing this one, or null. */
  supersededBySubmissionId?: Maybe<Scalars['String']['output']>;
  /** 1-based submission version number. */
  version: Scalars['Int']['output'];
};

/** Mutation payload returned by GrowerBenchmark submission mutations (contract C7). */
export type GrowerBenchmarkSubmissionPayload = {
  __typename?: 'GrowerBenchmarkSubmissionPayload';
  /** Typed validation or gate errors, or null on success. */
  errors?: Maybe<Array<ValidationError>>;
  /** Updated or unchanged submission view on success, or null on validation or gate refusal. */
  submission?: Maybe<GrowerBenchmarkSubmission>;
};

export enum GrowerBenchmarkSubmissionStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  Queried = 'QUERIED',
  Submitted = 'SUBMITTED',
  Superseded = 'SUPERSEDED'
}

/** Action status pill on a released review finding relative to the metric target or cohort median (contract C1). */
export enum GrowerBenchmarkWorkStatus {
  /** Firm value has not yet reached the target (or cohort median when no target exists). */
  NeedsWork = 'NEEDS_WORK',
  /** Firm value meets or beats the target (or cohort median when no target exists). */
  OnTrack = 'ON_TRACK'
}

export type HaltOtaReleaseInput = {
  reason: Scalars['String']['input'];
  releaseId: Scalars['String']['input'];
};

/**
 * Per-bin on-hand snapshot. On-hand is the absolute post-event quantity carried by
 *             (or computed as a pure function of) the originating MaterialItem count/move/adjust event.
 */
export type HardgoodsBinBreakdown = {
  __typename?: 'HardgoodsBinBreakdown';
  /**
   * When this bin was last counted (an observation). Advances only on a
   * MaterialItemCounted projection — NOT on an adjust (a correction) or a move (a
   * relocation), both of which leave this marker untouched while still updating
   * OnHand. So a null/stale bin-level LastCountedAt next to a recent
   * on-hand correctly reads as "on-hand was corrected/moved, not re-counted."
   */
  lastCountedAt?: Maybe<Scalars['DateTime']['output']>;
  onHand: Scalars['Decimal']['output'];
};

/**
 * Per-bin on-hand snapshot. On-hand is the absolute post-event quantity carried by
 *             (or computed as a pure function of) the originating MaterialItem count/move/adjust event.
 */
export type HardgoodsBinBreakdownFilterInput = {
  and?: InputMaybe<Array<HardgoodsBinBreakdownFilterInput>>;
  /**
   * When this bin was last counted (an observation). Advances only on a
   * MaterialItemCounted projection — NOT on an adjust (a correction) or a move (a
   * relocation), both of which leave this marker untouched while still updating
   * OnHand. So a null/stale bin-level LastCountedAt next to a recent
   * on-hand correctly reads as "on-hand was corrected/moved, not re-counted."
   */
  lastCountedAt?: InputMaybe<DateTimeOperationFilterInput>;
  onHand?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<HardgoodsBinBreakdownFilterInput>>;
};

/** A connection to a list of items. */
export type HardgoodsInventoryGridConnection = {
  __typename?: 'HardgoodsInventoryGridConnection';
  /** A list of edges. */
  edges?: Maybe<Array<HardgoodsInventoryGridEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<HardgoodsInventoryGridDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Read model row for the Hardgoods Inventory grid: one document per
 * (tenant, MaterialItemId, SiteLocationId) carrying the per-bin on-hand breakdown,
 * the last-counted timestamp, and the active cycle-count assignment (if any). Projected from
 * the MaterialItem stream (counts, moves) and the CycleCountAssignment stream
 * (active-assignment info), HGI-09.
 */
export type HardgoodsInventoryGridDocument = {
  __typename?: 'HardgoodsInventoryGridDocument';
  activeAssignmentId?: Maybe<Scalars['String']['output']>;
  activeAssignmentStatus?: Maybe<CycleCountAssignmentStatus>;
  /**
   * What production can still plan against at this site: on hand − committed, where on
   * hand is the sum of this row's per-bin quantities. 500 on hand with 100 sold and unshipped
   * reads 400 available.
   *
   * Counting still counts ON HAND — this number is for planning, and the two are never
   * conflated. Negative when more is sold than is on the shelf, which is a real answer a planner
   * needs rather than a zero that hides it.
   */
  available: Scalars['Decimal']['output'];
  bins: Array<KeyValuePairOfStringAndHardgoodsBinBreakdown>;
  /**
   * Hard goods sold but not yet shipped at this row's (materialItemId, siteLocationId) —
   * the eaches still owed to customers out of this site's stock, summed as
   * ordered − shipped over the open order lines naming this hard good on orders from
   * Submitted onward, drafts excluded, until they ship.
   *
   * Site-level: the figure belongs to the whole site, so the per-bin breakdown on this row stays
   * on-hand only rather than apportioning a sold quantity across bins that never sold anything.
   *
   *
   * Derived at query time from the Orders read model on every read. Nothing is written into the
   * Material ledger: the stock is physically still on the shelf, so a count must keep finding it.
   */
  committed: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  lastCountedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEventAt: Scalars['DateTime']['output'];
  materialItemId: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * Read model row for the Hardgoods Inventory grid: one document per
 * (tenant, MaterialItemId, SiteLocationId) carrying the per-bin on-hand breakdown,
 * the last-counted timestamp, and the active cycle-count assignment (if any). Projected from
 * the MaterialItem stream (counts, moves) and the CycleCountAssignment stream
 * (active-assignment info), HGI-09.
 */
export type HardgoodsInventoryGridDocumentFilterInput = {
  activeAssignmentId?: InputMaybe<StringOperationFilterInput>;
  activeAssignmentStatus?: InputMaybe<NullableOfCycleCountAssignmentStatusOperationFilterInput>;
  and?: InputMaybe<Array<HardgoodsInventoryGridDocumentFilterInput>>;
  bins?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastCountedAt?: InputMaybe<DateTimeOperationFilterInput>;
  lastEventAt?: InputMaybe<DateTimeOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HardgoodsInventoryGridDocumentFilterInput>>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read model row for the Hardgoods Inventory grid: one document per
 * (tenant, MaterialItemId, SiteLocationId) carrying the per-bin on-hand breakdown,
 * the last-counted timestamp, and the active cycle-count assignment (if any). Projected from
 * the MaterialItem stream (counts, moves) and the CycleCountAssignment stream
 * (active-assignment info), HGI-09.
 */
export type HardgoodsInventoryGridDocumentSortInput = {
  activeAssignmentId?: InputMaybe<SortEnumType>;
  activeAssignmentStatus?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastCountedAt?: InputMaybe<SortEnumType>;
  lastEventAt?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type HardgoodsInventoryGridEdge = {
  __typename?: 'HardgoodsInventoryGridEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HardgoodsInventoryGridDocument;
};

/**
 * The required quantity of a single material item for a site location over the queried week
 * or needed-week range, summed across every scheduled production lot in that window
 * (recipe material multiple × production job lot size).
 */
export type HardgoodsRequiredItem = {
  __typename?: 'HardgoodsRequiredItem';
  /**
   * What production can plan against: on hand − committed for this material
   * item over the queried site scope, where committed is the stock sold but not yet shipped
   * (open order lines from Submitted onward, drafts excluded, ordered − shipped). On hand
   * is the Material ledger's per-bin quantities rolled up to the site, the same stock a count
   * surfaces — counting still counts on hand, and only planning reads this.
   *
   * Site-scoped exactly as the required figure beside it: the site queried, or every site of the
   * tenant when none was named. Independent of the queried week — stock and sales are a position
   * held right now, not a per-week figure.
   */
  available: Scalars['Decimal']['output'];
  /**
   * The plants (eaches) in one container of the jobs' production category. Null when the jobs span
   * categories with different eaches or when the category no longer resolves. States the basis only: no
   * quantity in this result is multiplied by it.
   */
  eachesPerContainer?: Maybe<Scalars['Int']['output']>;
  /**
   * The container count of the scheduled production jobs that need this material, each job counted once
   * even when several of its material events use the item. requiredQuantity is those
   * containers times the recipe multiple, in material units.
   */
  jobContainerCount: Scalars['Int']['output'];
  /** The material item category (denormalized for display). */
  materialItemCategory: Scalars['String']['output'];
  /** The material item identifier. */
  materialItemId: Scalars['String']['output'];
  /** The material item name (denormalized for display). */
  materialItemName: Scalars['String']['output'];
  /**
   * required − available: how much of this material must still be obtained to
   * cover the queried window's production. Negative when there is headroom. Stock on order from
   * a vendor is deliberately NOT netted off here — a buyer reads net short beside on-order
   * rather than through it.
   *
   * Required here is requiredQuantity exactly as returned beside it. The container count,
   * eaches per container and unit label state the basis of that figure and are never applied to
   * available or to net short.
   */
  netShort: Scalars['Decimal']['output'];
  /**
   * The total quantity of this material required across all scheduled production lots
   * in the queried week or week range. Decimal because the recipe material multiple is decimal.
   */
  requiredQuantity: Scalars['Decimal']['output'];
  /**
   * The name of the jobs' container, such as "4.5 inch tray": the production category's label, or its code
   * when the label is blank. Null when the jobs span categories with different names or when the
   * category no longer resolves.
   */
  unitLabel?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of hardgoodsRequiredByReadyWeek and hardgoodsRequiredByNeededWeekRange:
 * the per-material-item required quantities for a site location and week (or week range),
 * plus the recipe-coverage metric (the board's pre-flight check — what fraction of material
 * items are recipe-covered).
 */
export type HardgoodsRequiredSummary = {
  __typename?: 'HardgoodsRequiredSummary';
  /** Required quantity per material item, one entry per distinct material item. */
  items: Array<HardgoodsRequiredItem>;
  /**
   * Count of distinct material items that are referenced by at least one production
   * recipe (via a recipe variation's material events) for the tenant.
   */
  itemsWithRecipe: Scalars['Int']['output'];
  /**
   * Recipe coverage percentage = ItemsWithRecipe / TotalItems
   * × 100, or 0 when there are no material items. Surfaced by the UI as the
   * "Recipe coverage: XX%" chip.
   */
  recipeCoveragePct: Scalars['Decimal']['output'];
  /** Count of active material items for the tenant (the coverage denominator). */
  totalItems: Scalars['Int']['output'];
  /**
   * Per-material-item-per-week required quantity breakdown. Populated only when the
   * query's includeWeeklyBreakdown argument is true; empty for
   * hardgoodsRequiredByReadyWeek (which has no such argument) and for range
   * queries that did not opt in.
   */
  weeklyBreakdown: Array<HardgoodsRequiredWeeklyItem>;
};

/**
 * One material item's required quantity for a single ISO week within a queried needed-week
 * range: the optional per-week breakdown of hardgoodsRequiredByNeededWeekRange, e.g.
 * for the PWA hardgoods grid's per-week tooltip. The week is the week the material is needed
 * (its Event Schedule scheduled week), not the job's start or ready week.
 */
export type HardgoodsRequiredWeeklyItem = {
  __typename?: 'HardgoodsRequiredWeeklyItem';
  /** The ISO week number of the week this quantity is needed in. */
  isoWeek: Scalars['Int']['output'];
  /** The ISO year of the week this quantity is needed in. */
  isoYear: Scalars['Int']['output'];
  /** The material item identifier. */
  materialItemId: Scalars['String']['output'];
  /** The quantity of this material needed in this single week. */
  requiredQuantity: Scalars['Decimal']['output'];
};

/** Why one row of a historical invoice batch was refused. */
export type HistoricalInvoiceImportRowError = {
  __typename?: 'HistoricalInvoiceImportRowError';
  /** The input field at fault, or null when the row is refused as a whole. */
  field?: Maybe<Scalars['String']['output']>;
  /** Why the row was refused. */
  message: Scalars['String']['output'];
  /** The zero-based position of the row in the input array. */
  rowIndex: Scalars['Int']['output'];
};

export type HistoricalOrderImportRowError = {
  __typename?: 'HistoricalOrderImportRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type HistoricalOrderLineItemInput = {
  acknowledgedQuantity?: InputMaybe<Scalars['Int']['input']>;
  addedBy: Scalars['String']['input'];
  containerCode?: InputMaybe<Scalars['String']['input']>;
  cost: Scalars['Decimal']['input'];
  currency: Scalars['String']['input'];
  dateAdded: Scalars['DateTime']['input'];
  eachesQuantity?: InputMaybe<Scalars['Int']['input']>;
  handlingUom?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
  overridePrice?: InputMaybe<Scalars['Decimal']['input']>;
  price: Scalars['Decimal']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  royaltyExempt: Scalars['Boolean']['input'];
  shippedQuantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Staged line-item read model written synchronously by the validateHistoricalOrderDocuments
 * mutation into HistoricalOrders.Staged.Lines in the GrowPointIntegrations database —
 * a 1:1 echo of HistoricalOrderCommands.HistoricalOrderLineItemInput keyed by
 * {tenantId}-{orderId}-{lineItemId}, plus the LineTotal rollup the staged-review
 * grid displays. Read by stagedHistoricalOrderLineItems(orderId); a re-validate of the parent
 * order replaces the order's staged lines wholesale (scoped delete-then-insert), so the collection
 * never holds orphaned lines.
 */
export type HistoricalOrderStagedLineItemDocument = {
  __typename?: 'HistoricalOrderStagedLineItemDocument';
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  addedBy: Scalars['String']['output'];
  containerCode?: Maybe<Scalars['String']['output']>;
  cost: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  dateAdded: Scalars['DateTime']['output'];
  eachesQuantity?: Maybe<Scalars['Int']['output']>;
  handlingUom?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  lineTotal: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  noteText?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  overridePrice?: Maybe<Scalars['Decimal']['output']>;
  price: Scalars['Decimal']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  royaltyExempt: Scalars['Boolean']['output'];
  shippedQuantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  upc?: Maybe<Scalars['String']['output']>;
};

/**
 * Per-row failure surfaced by validateHistoricalOrderDocuments. RowIndex is the
 * position in the posted batch (so wsapi-services / AG Grid can map back to the source row);
 * Field is the offending field name when the underlying ValidationError implements
 * IFieldValidationError, otherwise null.
 */
export type HistoricalOrderStagedRowError = {
  __typename?: 'HistoricalOrderStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

/**
 * Staged-summary read model written synchronously by the validateHistoricalOrderDocuments
 * mutation into HistoricalOrders.Staged.Summary in the GrowPointIntegrations database.
 * Mirrors the shape the pwa staged-review grid binds to so the stagedHistoricalOrders query
 * can replace the page's mock data verbatim. One document per successfully-validated order; rejected
 * rows surface as HistoricalOrderStagedRowError instead.
 */
export type HistoricalOrderStagedSummaryDocument = {
  __typename?: 'HistoricalOrderStagedSummaryDocument';
  customerName: Scalars['String']['output'];
  expectedDeliveryDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lineItemCount: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  poNumber: Scalars['String']['output'];
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  status: OrderStatus;
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

/**
 * Staged-summary read model written synchronously by the validateHistoricalOrderDocuments
 * mutation into HistoricalOrders.Staged.Summary in the GrowPointIntegrations database.
 * Mirrors the shape the pwa staged-review grid binds to so the stagedHistoricalOrders query
 * can replace the page's mock data verbatim. One document per successfully-validated order; rejected
 * rows surface as HistoricalOrderStagedRowError instead.
 */
export type HistoricalOrderStagedSummaryDocumentFilterInput = {
  and?: InputMaybe<Array<HistoricalOrderStagedSummaryDocumentFilterInput>>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  expectedDeliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lineItemCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<HistoricalOrderStagedSummaryDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  shipDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<OrderStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalAmount?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * Staged-summary read model written synchronously by the validateHistoricalOrderDocuments
 * mutation into HistoricalOrders.Staged.Summary in the GrowPointIntegrations database.
 * Mirrors the shape the pwa staged-review grid binds to so the stagedHistoricalOrders query
 * can replace the page's mock data verbatim. One document per successfully-validated order; rejected
 * rows surface as HistoricalOrderStagedRowError instead.
 */
export type HistoricalOrderStagedSummaryDocumentSortInput = {
  customerName?: InputMaybe<SortEnumType>;
  expectedDeliveryDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lineItemCount?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  orderNumber?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  shipDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalAmount?: InputMaybe<SortEnumType>;
};

/**
 * Read-model document for one FORECAST holiday reference row, keyed {tenantId}-{holidayId}. The
 * composite _id embeds the tenant, so per-row reads filter on _id and cannot leak across tenants
 * (discipline acada0ab), and it is cheap to compute from a (tenant, holidayId) pair. The (year, ISO
 * week, date) triple is validated for W1 consistency on the write path, so the weekly-spread engine can
 * bucket a holiday by its stored ISO week without recomputing.
 *
 * Maintenance owner: pending A2 decision (spec open question 13 — who maintains the legacy
 * Config.Holidays set, seeded only through 2024).
 */
export type HolidayDocument = {
  __typename?: 'HolidayDocument';
  date: Scalars['LocalDate']['output'];
  holidayId: Scalars['String']['output'];
  holidayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isoWeek: Scalars['Int']['output'];
  status: HolidayStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type HolidayPayload = {
  __typename?: 'HolidayPayload';
  errors?: Maybe<Array<ValidationError>>;
  holiday?: Maybe<HolidayStateData>;
};

/**
 * GraphQL output shape returned by the holiday CRUD mutations: the holiday row after the command
 * applied. Mirrors the aggregate state.
 */
export type HolidayStateData = {
  __typename?: 'HolidayStateData';
  date: Scalars['LocalDate']['output'];
  holidayId: Scalars['String']['output'];
  holidayName: Scalars['String']['output'];
  isoWeek: Scalars['Int']['output'];
  status: HolidayStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export enum HolidayStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

/** A missing-data warning this user chose to ignore. */
export type IgnoredMissingData = {
  __typename?: 'IgnoredMissingData';
  /**
   * The ignored warning's code: a MissingDataCode, OrderUncountedLineReason,
   * OrderUnweighedLineReason or OrderUnweighedContainerReason name.
   */
  code: Scalars['String']['output'];
  /** The record the warning was ignored on, or null when every warning of the code is ignored. */
  subjectId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Input creating an Approved submission version directly from staged imported lines for a historical period
 * (contract C7).
 */
export type ImportApprovedGrowerBenchmarkSubmissionInput = {
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Reporting period identifier (for example 2026 or 2026-09). */
  periodId: Scalars['String']['input'];
  /** Reporting unit identifier to which the staged figures belong. */
  reportingUnitId: Scalars['String']['input'];
  /** Digest of the staged source file. */
  sourceDigest: Scalars['String']['input'];
  /** Original file name of the imported workbook or extract. */
  sourceFileName: Scalars['String']['input'];
};

export type ImportCustomerInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress: CreateAddressInput;
  contacts?: InputMaybe<Array<ContactDataInput>>;
  currency: Scalars['String']['input'];
  customerGroupName?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  customerLookupCode?: InputMaybe<Scalars['String']['input']>;
  customerTypeName?: InputMaybe<Scalars['String']['input']>;
  defaultDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  erpPriceGroupId: Scalars['String']['input'];
  federalTaxNumber?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  locations: Array<CreateCustomerLocationInput>;
  name: Scalars['String']['input'];
  orderSubmitter?: InputMaybe<OrderSubmitterDataInput>;
  poRequired?: Scalars['Boolean']['input'];
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  synchronizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  taxExemptNumber?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
};

/** Up to 2,000 rows for one customer, applied in input order (contract 5.2). */
export type ImportCustomerRetailPricesInput = {
  customerId: Scalars['String']['input'];
  rows: Array<CustomerRetailPriceRowInput>;
};

/**
 * rows carries one entry per row the import processed, in input order. errors is set
 * when the whole import was refused before any row ran (the 2,000-row cap, or a customer id that
 * names no customer in the tenant), which leaves rows empty, and when a cancelled run stopped
 * at a row boundary, which leaves rows holding every row it reached.
 */
export type ImportCustomerRetailPricesPayload = {
  __typename?: 'ImportCustomerRetailPricesPayload';
  errors?: Maybe<Array<ValidationError>>;
  rows: Array<CustomerRetailPriceRowResult>;
};

export type ImportHistoricalInvoiceInput = {
  billToLocationId?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  historicalOrderId?: InputMaybe<Scalars['String']['input']>;
  importedByEmail: Scalars['String']['input'];
  invoiceDate: Scalars['DateTime']['input'];
  invoiceNumber: Scalars['String']['input'];
  openBalance: Scalars['Decimal']['input'];
  originalAmount: Scalars['Decimal']['input'];
  termsId?: InputMaybe<Scalars['String']['input']>;
};

/** What importHistoricalInvoices did with a batch: how many rows it imported, and why it refused the rest. */
export type ImportHistoricalInvoicesResult = {
  __typename?: 'ImportHistoricalInvoicesResult';
  /** The number of rows imported as issued invoices. */
  imported: Scalars['Int']['output'];
  /** One error for each refused row; a refused row imports nothing. */
  rowErrors: Array<HistoricalInvoiceImportRowError>;
};

export type ImportHistoricalOrderInput = {
  customer: OrderCustomerDataInput;
  dateShippedOverride?: InputMaybe<Scalars['DateTime']['input']>;
  discountAmount?: InputMaybe<Scalars['Decimal']['input']>;
  discountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  discountReason?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['DateTime']['input'];
  finalCredit: Scalars['Boolean']['input'];
  freightChargeReason?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  fromLocation: ShipFromLocationDataInput;
  importedByEmail: Scalars['String']['input'];
  initializationDateOverride?: InputMaybe<Scalars['DateTime']['input']>;
  lineItems: Array<HistoricalOrderLineItemInput>;
  orderId: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  overrideTotal?: InputMaybe<Scalars['Decimal']['input']>;
  poNumber: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  status: OrderStatus;
  statusDateOverride?: InputMaybe<Scalars['DateTime']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
  type: OrderType;
};

export type ImportHistoricalOrdersResult = {
  __typename?: 'ImportHistoricalOrdersResult';
  imported: Scalars['Int']['output'];
  rowErrors: Array<HistoricalOrderImportRowError>;
};

export type ImportItemInput = {
  categories: Array<ItemCategoryAssignmentDataInput>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: Scalars['String']['input'];
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  native?: InputMaybe<Scalars['Boolean']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  stripeTaxCode?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ImportItemRowInput = {
  categories: Array<ItemCategoryAssignmentDataInput>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: Scalars['String']['input'];
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  native?: InputMaybe<Scalars['Boolean']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  status?: InputMaybe<ItemStatus>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ImportOrderContactDataInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ImportOrderDataInput = {
  contact?: InputMaybe<ImportOrderContactDataInput>;
  customerId: Scalars['String']['input'];
  customerLocationId: Scalars['UUID']['input'];
  expectedDeliveryDate: Scalars['DateTime']['input'];
  items: Array<AddLineItemDataInput>;
  orderId: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  status: OrderStatus;
  type: OrderType;
};

/**
 * The result of one order of an importOrders call. errors is null when the order was written.
 * When a step failed after the header may have been written, the order was deleted again;
 * rollbackFailed is true when that delete itself failed, and the delete's error is the last entry of
 * errors.
 */
export type ImportOrderPayload = {
  __typename?: 'ImportOrderPayload';
  errors?: Maybe<Array<ValidationError>>;
  failedStep?: Maybe<ImportOrderStep>;
  orderId: Scalars['String']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  rollbackFailed: Scalars['Boolean']['output'];
};

/** The step of an imported order that failed. */
export enum ImportOrderStep {
  /** Adding the lines, as addLineItems and addLineItemsWithPricing do. */
  AddItems = 'ADD_ITEMS',
  /** Creating the order header, as initializeOrder does. */
  Initialize = 'INITIALIZE',
  /** Drawing the order number from the tenant's counter. */
  OrderNumber = 'ORDER_NUMBER',
  /** Never a business value. */
  Unknown = 'UNKNOWN',
  /** Moving the order to its target status, as updateOrderStatus does. */
  UpdateStatus = 'UPDATE_STATUS',
  /**
   * The row's fields, the customer snapshot (an unknown customer or location, or a customer with no
   * billing address) or the order-entry guards. Nothing was written and no order number was drawn.
   */
  Validate = 'VALIDATE'
}

export type ImportOrdersInput = {
  orders: Array<ImportOrderDataInput>;
};

/**
 * Result of importOrders: one ImportOrderPayload per input order, in input order, each carrying that
 * order's own errors. errors is call-level only (an empty or oversized chunk, or a failure before any
 * order was processed), and when it is set nothing was written and orders is null.
 */
export type ImportOrdersPayload = {
  __typename?: 'ImportOrdersPayload';
  errors?: Maybe<Array<ValidationError>>;
  orders?: Maybe<Array<ImportOrderPayload>>;
};

export type ImportPriceGroupInput = {
  id: Scalars['String']['input'];
  makeDefaultIfNoDefaultExists: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priceLevels: Array<PriceLevelInputDataInput>;
};

/** One CSV import a person ran in a WorkSuite wizard, and how it ended. */
export type ImportSession = {
  __typename?: 'ImportSession';
  /** The rows that failed. importSessionRows lists at most 1000 of them. */
  failedRows: Scalars['Int']['output'];
  /** The name of the uploaded file. */
  fileName: Scalars['String']['output'];
  /** When the import ended. Null while it is STARTED. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The session id. Pass it to importSession and importSessionRows. */
  id: Scalars['String']['output'];
  /** The rows that loaded. */
  importedRows: Scalars['Int']['output'];
  /** Which wizard ran. */
  kind: ImportSessionKind;
  /** When the import started. */
  startedAt: Scalars['DateTime']['output'];
  /** The email of the person who started the import. */
  startedBy: Scalars['String']['output'];
  /** Where the import stands. */
  status: ImportSessionStatus;
  /** The tenant the import ran in. */
  tenantId: Scalars['String']['output'];
  /** The rows the wizard read from the file. */
  totalRows: Scalars['Int']['output'];
};

/** One CSV import a person ran in a WorkSuite wizard, and how it ended. */
export type ImportSessionFilterInput = {
  and?: InputMaybe<Array<ImportSessionFilterInput>>;
  /** The rows that failed. importSessionRows lists at most 1000 of them. */
  failedRows?: InputMaybe<IntOperationFilterInput>;
  /** The name of the uploaded file. */
  fileName?: InputMaybe<StringOperationFilterInput>;
  /** When the import ended. Null while it is STARTED. */
  finishedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The session id. Pass it to importSession and importSessionRows. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** The rows that loaded. */
  importedRows?: InputMaybe<IntOperationFilterInput>;
  /** Which wizard ran. */
  kind?: InputMaybe<ImportSessionKindOperationFilterInput>;
  or?: InputMaybe<Array<ImportSessionFilterInput>>;
  /** When the import started. */
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The email of the person who started the import. */
  startedBy?: InputMaybe<StringOperationFilterInput>;
  /** Where the import stands. */
  status?: InputMaybe<ImportSessionStatusOperationFilterInput>;
  /** The tenant the import ran in. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The rows the wizard read from the file. */
  totalRows?: InputMaybe<IntOperationFilterInput>;
};

export enum ImportSessionKind {
  Catalog = 'CATALOG',
  Customers = 'CUSTOMERS',
  Items = 'ITEMS',
  Orders = 'ORDERS',
  Pricing = 'PRICING'
}

export type ImportSessionKindOperationFilterInput = {
  eq?: InputMaybe<ImportSessionKind>;
  in?: InputMaybe<Array<ImportSessionKind>>;
  neq?: InputMaybe<ImportSessionKind>;
  nin?: InputMaybe<Array<ImportSessionKind>>;
};

/** One CSV row an import could not load. */
export type ImportSessionRow = {
  __typename?: 'ImportSessionRow';
  /** The column at fault, when the failure belongs to one column. */
  field?: Maybe<Scalars['String']['output']>;
  /** Why the row failed, as the wizard showed it. */
  reason: Scalars['String']['output'];
  /** The row number the wizard showed, from 1. */
  rowNumber: Scalars['Int']['output'];
  /** The value the row held, exactly as read. */
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportSessionRowDataInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ImportSessionStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Rejected = 'REJECTED',
  Started = 'STARTED'
}

export type ImportSessionStatusOperationFilterInput = {
  eq?: InputMaybe<ImportSessionStatus>;
  in?: InputMaybe<Array<ImportSessionStatus>>;
  neq?: InputMaybe<ImportSessionStatus>;
  nin?: InputMaybe<Array<ImportSessionStatus>>;
};

/** A connection to a list of items. */
export type ImportSessionsConnection = {
  __typename?: 'ImportSessionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ImportSessionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ImportSession>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ImportSessionsEdge = {
  __typename?: 'ImportSessionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ImportSession;
};

export type ImportTermsInput = {
  accrueInterestPercentage: Scalars['Decimal']['input'];
  discountDays?: Scalars['Int']['input'];
  isDefault?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  termLimitDays: Scalars['Int']['input'];
  termsCode: Scalars['String']['input'];
  termsId: Scalars['String']['input'];
};

export type InUseCount = {
  __typename?: 'InUseCount';
  count: Scalars['Int']['output'];
  kind: InUseKind;
};

export enum InUseKind {
  AvailabilityCount = 'AVAILABILITY_COUNT',
  AvailabilityPhoto = 'AVAILABILITY_PHOTO',
  AvailabilitySession = 'AVAILABILITY_SESSION',
  BackgroundService = 'BACKGROUND_SERVICE',
  BpfStartingNode = 'BPF_STARTING_NODE',
  CombinedItem = 'COMBINED_ITEM',
  ConsolidationApplication = 'CONSOLIDATION_APPLICATION',
  CountLog = 'COUNT_LOG',
  Customer = 'CUSTOMER',
  CustomerItem = 'CUSTOMER_ITEM',
  CycleCountTask = 'CYCLE_COUNT_TASK',
  Device = 'DEVICE',
  ForecastMapping = 'FORECAST_MAPPING',
  HardGood = 'HARD_GOOD',
  Inventory = 'INVENTORY',
  InventoryHistory = 'INVENTORY_HISTORY',
  Item = 'ITEM',
  Job = 'JOB',
  Kit = 'KIT',
  MakeToOrderPlan = 'MAKE_TO_ORDER_PLAN',
  MasterOrder = 'MASTER_ORDER',
  MaterialAllocation = 'MATERIAL_ALLOCATION',
  MaterialBin = 'MATERIAL_BIN',
  MovementOrder = 'MOVEMENT_ORDER',
  OpenOrder = 'OPEN_ORDER',
  Order = 'ORDER',
  OrderLine = 'ORDER_LINE',
  Photo = 'PHOTO',
  PortalAvailabilityRule = 'PORTAL_AVAILABILITY_RULE',
  PriceGroup = 'PRICE_GROUP',
  PriceLevel = 'PRICE_LEVEL',
  ProductionCategory = 'PRODUCTION_CATEGORY',
  ProductionItem = 'PRODUCTION_ITEM',
  ProductionJob = 'PRODUCTION_JOB',
  ProductionJobLine = 'PRODUCTION_JOB_LINE',
  ProductionLine = 'PRODUCTION_LINE',
  Recipe = 'RECIPE',
  ScheduledTransfer = 'SCHEDULED_TRANSFER',
  ShipTo = 'SHIP_TO',
  SpaceEvent = 'SPACE_EVENT',
  TaskEvent = 'TASK_EVENT',
  UserAssignedNode = 'USER_ASSIGNED_NODE',
  VpoReceipt = 'VPO_RECEIPT',
  WorkOrder = 'WORK_ORDER'
}

export type InactivateCategoryInput = {
  code: Scalars['String']['input'];
};

export type InactivateCustomerInput = {
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InactivateDeliveryScheduleInput = {
  id: Scalars['String']['input'];
};

export type InactivateFeatureFlagInput = {
  name: FeatureFlagName;
};

export type InactivateItemInput = {
  itemId: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type InactivateLocationInput = {
  locationId: Scalars['String']['input'];
};

export type InactivateMaterialItemInput = {
  id: Scalars['String']['input'];
};

export type InactivatePriceGroupInput = {
  id: Scalars['String']['input'];
};

export type InactivateProductionItemInput = {
  productionItemId: Scalars['String']['input'];
};

export type InactivateProductionMaterialEventDetailInput = {
  productionMaterialEventDetailId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type InactivateProductionMaterialEventInput = {
  productionMaterialEventId: Scalars['String']['input'];
};

export type InactivateProductionRecipeInput = {
  productionRecipeId: Scalars['String']['input'];
};

export type InactivateProductionSpaceEventDetailInput = {
  productionSpaceEventDetailId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type InactivateProductionSpaceEventInput = {
  productionSpaceEventId: Scalars['String']['input'];
};

export type InactivateProductionTaskEventDetailInput = {
  productionTaskEventDetailId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type InactivateProductionTaskEventInput = {
  productionTaskEventId: Scalars['String']['input'];
};

export type InactivateProductionTriggerInput = {
  productionTriggerId: Scalars['String']['input'];
};

export type InactivateSftpTenantConfigInput = {
  configId: Scalars['String']['input'];
};

export type InactivateSiteLocationInput = {
  acknowledgeInUse: Scalars['Boolean']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type InactivateSubLocationInput = {
  acknowledgeInUse: Scalars['Boolean']['input'];
  locationId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type InactivateTaskEventTypeInput = {
  taskEventTypeId: Scalars['String']['input'];
};

export type InactivateTenantInput = {
  entityId: Scalars['String']['input'];
};

export type InactivateVendorInput = {
  id: Scalars['String']['input'];
};

/** An email address or a whole domain documents are accepted from. */
export type InboundAllowedSender = {
  __typename?: 'InboundAllowedSender';
  /** When the sender was added. */
  addedAt: Scalars['DateTime']['output'];
  /** The email of the person who added the sender. */
  addedBy: Scalars['String']['output'];
  /** The id to remove the sender by. */
  id: Scalars['String']['output'];
  /** Whether the value is one email address or a whole domain. */
  type: InboundAllowedSenderType;
  /** The email address or domain, in lower case. */
  value: Scalars['String']['output'];
};

export enum InboundAllowedSenderType {
  Address = 'ADDRESS',
  Domain = 'DOMAIN',
  Unknown = 'UNKNOWN'
}

/** A document forwarded or uploaded to the company: what it is, where it came from and what happened to it. */
export type InboundDocument = {
  __typename?: 'InboundDocument';
  /** When the document was recorded. */
  addedAt: Scalars['DateTime']['output'];
  /** Who recorded the document. */
  addedBy: Scalars['String']['output'];
  /** The lower-case hex SHA-256 of the file. Empty when the file was too large to be read. */
  contentHash: Scalars['String']['output'];
  /** The document this one repeats. Null unless the status is DUPLICATE. */
  duplicateOfDocumentId?: Maybe<Scalars['String']['output']>;
  /** The email the document came in. Null for a document that did not come by email. */
  email?: Maybe<InboundDocumentEmail>;
  /** The file name it arrived with. */
  fileName: Scalars['String']['output'];
  /** The kind of file. */
  fileType: InboundDocumentFileType;
  /** The document id. */
  id: Scalars['String']['output'];
  /** What the document is. UNKNOWN until it is known. */
  kind: InboundDocumentKind;
  /** How the kind was decided. */
  kindSource: InboundDocumentKindSource;
  /** The number of pages of a PDF. Null for other files. */
  pageCount?: Maybe<Scalars['Int']['output']>;
  /** When the document arrived. */
  receivedAt: Scalars['DateTime']['output'];
  /** Why the document was refused or held back, such as FILE_TOO_LARGE. Empty otherwise. */
  rejectReason: Scalars['String']['output'];
  /** Where the document was sent. Null until it was sent somewhere. */
  routedTo?: Maybe<InboundDocumentRoute>;
  /** The file size in bytes. Zero when the file was too large to be read. */
  sizeBytes: Scalars['Long']['output'];
  /** How the document arrived. */
  source: InboundDocumentSource;
  /** The key that identifies the document within its source. */
  sourceKey: Scalars['String']['output'];
  /** Where the document is in its life. */
  status: InboundDocumentStatus;
  /** When the document last changed. */
  updatedAt: Scalars['DateTime']['output'];
  /** Who last changed the document. */
  updatedBy: Scalars['String']['output'];
};

/** The reply to the person who forwarded a document. */
export type InboundDocumentAck = {
  __typename?: 'InboundDocumentAck';
  /** When the reply was taken on. Null until then. */
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The mail provider's id of the sent reply. Null until it was sent. */
  providerMessageId?: Maybe<Scalars['String']['output']>;
  /** Why no reply was sent, such as SettingOff, or why a reply failed. Empty otherwise. */
  reason: Scalars['String']['output'];
  /** When the reply was sent. Null until it was sent. */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Where the reply is. CLAIMED with no sentAt means the reply was not confirmed and is never sent again. */
  state: InboundDocumentAckState;
};

export enum InboundDocumentAckState {
  Claimed = 'CLAIMED',
  None = 'NONE',
  Sent = 'SENT',
  Suppressed = 'SUPPRESSED',
  Unknown = 'UNKNOWN'
}

/** A place a document can be sent to, and the counterparty it needs. */
export type InboundDocumentAvailableTarget = {
  __typename?: 'InboundDocumentAvailableTarget';
  /** The kind of counterparty the place needs. UNKNOWN when it needs none. */
  requiredCounterparty: InboundDocumentCounterpartyType;
  /** The place. */
  target: InboundDocumentTarget;
};

/** A vendor or customer a route binds a document to. */
export type InboundDocumentCounterparty = {
  __typename?: 'InboundDocumentCounterparty';
  /** The counterparty id. */
  id: Scalars['String']['output'];
  /** Whether it is a vendor or a customer. */
  type: InboundDocumentCounterpartyType;
};

/** The vendor or customer a document is sent for. */
export type InboundDocumentCounterpartyInput = {
  /** The vendor or customer id. */
  id: Scalars['String']['input'];
  /** Whether the id is a vendor's or a customer's. */
  type: InboundDocumentCounterpartyType;
};

export enum InboundDocumentCounterpartyType {
  Customer = 'CUSTOMER',
  Unknown = 'UNKNOWN',
  Vendor = 'VENDOR'
}

/** The email a document came in. */
export type InboundDocumentEmail = {
  __typename?: 'InboundDocumentEmail';
  /** The reply to the forwarder. */
  ack: InboundDocumentAck;
  /** The id of the attachment within the email. */
  attachmentId: Scalars['String']['output'];
  /** True when the email passed the sender's DMARC check. */
  dmarcPass: Scalars['Boolean']['output'];
  /** True when the email was sent automatically, such as an out-of-office reply. */
  isAutomatic: Scalars['Boolean']['output'];
  /** The email's message id. */
  messageId: Scalars['String']['output'];
  /** The note the forwarder wrote above the forwarded email. */
  noteText: Scalars['String']['output'];
  /** The address the forwarded email first came from, or the sender when it was not forwarded. */
  originalSender: Scalars['String']['output'];
  /** The company address the email was sent to. */
  recipient: Scalars['String']['output'];
  /** The address that sent the email to the company's address. */
  sender: Scalars['String']['output'];
  /** The email's subject. */
  subject: Scalars['String']['output'];
};

export enum InboundDocumentFileType {
  Csv = 'CSV',
  Pdf = 'PDF',
  Unknown = 'UNKNOWN',
  Xlsx = 'XLSX'
}

export enum InboundDocumentKind {
  ImportFile = 'IMPORT_FILE',
  SupplierOrderConfirmation = 'SUPPLIER_ORDER_CONFIRMATION',
  SupplierPriceList = 'SUPPLIER_PRICE_LIST',
  Unknown = 'UNKNOWN'
}

export enum InboundDocumentKindSource {
  Hint = 'HINT',
  Rule = 'RULE',
  Signature = 'SIGNATURE',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

/** The answer to a change of a document. */
export type InboundDocumentPayload = {
  __typename?: 'InboundDocumentPayload';
  /** Empty when the change was made. Otherwise one error saying why it was refused. */
  errors: Array<ValidationError>;
  /** The document after the change. Null when the change was refused. */
  inboundDocument?: Maybe<InboundDocument>;
};

/** Where a document was sent. */
export type InboundDocumentRoute = {
  __typename?: 'InboundDocumentRoute';
  /** The vendor or customer the document was sent for. Null when none was needed. */
  counterparty?: Maybe<InboundDocumentCounterparty>;
  /** When the document was sent. */
  routedAt: Scalars['DateTime']['output'];
  /** Who sent the document. */
  routedBy: Scalars['String']['output'];
  /** Where the document was sent. */
  target: InboundDocumentTarget;
  /** The id of the record made from the document there. Empty for a place that makes no record. */
  targetRecordId: Scalars['String']['output'];
};

export enum InboundDocumentSource {
  Chat = 'CHAT',
  Email = 'EMAIL',
  Unknown = 'UNKNOWN',
  Upload = 'UPLOAD'
}

export enum InboundDocumentStatus {
  Discarded = 'DISCARDED',
  Duplicate = 'DUPLICATE',
  NeedsKind = 'NEEDS_KIND',
  Quarantined = 'QUARANTINED',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  Routed = 'ROUTED',
  Unknown = 'UNKNOWN'
}

export enum InboundDocumentTarget {
  ImportWizard = 'IMPORT_WIZARD',
  SupplierPriceImport = 'SUPPLIER_PRICE_IMPORT',
  Unknown = 'UNKNOWN'
}

/** The address growers forward supplier documents to, who may send to it, and whether the forwarder gets a reply. */
export type InboundIntakeSettings = {
  __typename?: 'InboundIntakeSettings';
  /** The file extensions accepted, such as pdf. */
  acceptedFileTypes: Array<Scalars['String']['output']>;
  /** The address to forward documents to. */
  address: Scalars['String']['output'];
  /** The email addresses and domains documents are accepted from, in the order they were added. */
  allowedSenders: Array<InboundAllowedSender>;
  /** The largest file accepted, in bytes. */
  maxBytes: Scalars['Long']['output'];
  /** The address this one replaced. Null until the address is changed for the first time. */
  previousAddress?: Maybe<Scalars['String']['output']>;
  /** When the previous address stops receiving documents. Null when there is no previous address. */
  previousAddressValidUntil?: Maybe<Scalars['DateTime']['output']>;
  /** True when the person who forwarded a document gets a reply saying what happened to it. */
  replyToForwarder: Scalars['Boolean']['output'];
  /** When the address was created. */
  rotatedAt: Scalars['DateTime']['output'];
};

/** The answer to a change of the forwarding settings. */
export type InboundIntakeSettingsPayload = {
  __typename?: 'InboundIntakeSettingsPayload';
  /** Empty when the change was made. Otherwise one error saying why it was refused. */
  errors: Array<ValidationError>;
  /** The settings after the change. Null when the change was refused. */
  settings?: Maybe<InboundIntakeSettings>;
};

export type IncrementInventoryItemInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['Int']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemType: ItemType;
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  why: Scalars['String']['input'];
};

export type IngestDeviceCountInput = {
  answeredCorrectionId?: InputMaybe<Scalars['String']['input']>;
  bootNonce?: InputMaybe<Scalars['String']['input']>;
  correctionRefused?: InputMaybe<Scalars['String']['input']>;
  countSessionId: Scalars['String']['input'];
  countedQuantity: Scalars['Long']['input'];
  deviceId: Scalars['String']['input'];
  deviceTimeUtc?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * ONE transmission from ONE device: the device's identity, the per-envelope sequence number and the
 * device's own claimed reading time, plus every metric value that transmission carried. There is no
 * tenant field — the owning tenant is resolved server-side from the device registry and a caller
 * cannot influence it.
 */
export type IngestDeviceReadingsInput = {
  /**
   * The reporting device's registry id. It is the ONLY identity the caller supplies, and it is what
   * the owning tenant is resolved from — the device must be registered and currently claimed.
   */
  deviceId: Scalars['String']['input'];
  /**
   * The reading time the device itself claims. Never trusted outright: an implausible value (a
   * reset clock reporting near the Unix epoch, or a runaway forward drift) is rewritten to the
   * server's own receipt time before the reading is stored.
   */
  deviceTimeUtc: Scalars['DateTime']['input'];
  /**
   * Every metric value this transmission carried. At least one is required, and at most 500: one
   * envelope is one transmission, so a larger batch is a concatenated or malfunctioning one and is
   * rejected whole rather than truncated.
   */
  readings: Array<DeviceReadingInput>;
  /**
   * The device's per-envelope sequence number, carried through as reported. Together with the
   * tenant, device and metric it forms the unique dedupe key, so redelivering the same envelope
   * converges onto the same stored readings rather than duplicating them.
   */
  seq: Scalars['Long']['input'];
};

/**
 * Result of an ingest. Follows the repo's payload convention: data on success, errors on a
 * rejection, never both.
 */
export type IngestDeviceReadingsPayload = {
  __typename?: 'IngestDeviceReadingsPayload';
  data?: Maybe<IngestDeviceReadingsResult>;
  errors?: Maybe<Array<ValidationError>>;
};

/** What wsapi accepted for one ingest envelope. */
export type IngestDeviceReadingsResult = {
  __typename?: 'IngestDeviceReadingsResult';
  deviceId: Scalars['String']['output'];
  /**
   * How many readings the envelope carried and wsapi accepted. A redelivery reports the same count
   * it did the first time: converging onto existing rows is a success, not a partial write.
   */
  readingCount: Scalars['Int']['output'];
  seq: Scalars['Long']['output'];
  /** The owning tenant resolved from the device registry — never anything the caller sent. */
  tenantId: Scalars['String']['output'];
};

/**
 * A finished test run as submitted by the Playwright publisher. Mirrors the dashboard's run shape
 * minus the server-owned fields (isNew, ingestedAt).
 */
export type IngestQaTestRunInput = {
  adoUrl?: InputMaybe<Scalars['String']['input']>;
  appBuild?: InputMaybe<Scalars['String']['input']>;
  /**
   * Opaque relman candidate id; null for red runs and no-release weekly runs. Stored WITHOUT a
   * lookup: ingest must not fail because relman is unreachable, and this slice registers only a
   * mock candidate source anyway.
   */
  candidateId?: InputMaybe<Scalars['String']['input']>;
  /** Commit sha of catalog/coverage-catalog.json in ado-playwright-tests. */
  catalogRevision?: InputMaybe<Scalars['String']['input']>;
  /**
   * 2 when the fields below are sent; null or 1 is a legacy payload. Any other
   * value is rejected rather than treated as legacy — a versioned contract that silently
   * downgrades what it does not recognise stores a v3 run as a v1 row and tells no one.
   */
  contractVersion?: InputMaybe<Scalars['Int']['input']>;
  counts: QaRunCountsInput;
  dateUtc: Scalars['DateTime']['input'];
  durationSec: Scalars['Int']['input'];
  /**
   * stage or red; rejected otherwise. Optional — a publisher that omits it lands in
   * the stage stream, so pipelines predating this field keep publishing exactly where they
   * always did instead of failing on a required argument.
   */
  environment?: InputMaybe<Scalars['String']['input']>;
  /**
   * Scenarios this run was expected to exercise. The half of the coverage question a test result
   * cannot answer: a run reports what it ran, and only the expected set reveals what it did not.
   */
  expectedScenarioIds?: InputMaybe<Array<Scalars['String']['input']>>;
  flows: Array<QaFlowInput>;
  /** ADO build id for pipeline runs, or a stamped local-… id for developer runs. */
  id: Scalars['String']['input'];
  /** Subset run — recorded so the health tiles can skip it. */
  partial: Scalars['Boolean']['input'];
  /** Null means the legacy answer — PUBLISHED with media available. */
  publication?: InputMaybe<QaPublicationInput>;
  result: Scalars['String']['input'];
  /** worksuite or inventory; rejected otherwise. */
  suite: Scalars['String']['input'];
  /** Required when contractVersion is 2. */
  target?: InputMaybe<QaExecutionTargetInput>;
  trigger: Scalars['String']['input'];
};

/** Ingest input. Its errors is a NULLABLE list per the pin ([String!]). */
export type IngestQaWatcherHeartbeatInput = {
  errors?: InputMaybe<Array<Scalars['String']['input']>>;
  host?: InputMaybe<Scalars['String']['input']>;
  lastAction?: InputMaybe<Scalars['String']['input']>;
  lastObservedRunAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastObservedRunId?: InputMaybe<Scalars['String']['input']>;
  observedAt: Scalars['DateTime']['input'];
  status: QaWatcherStatus;
  version?: InputMaybe<Scalars['String']['input']>;
  watcher: Scalars['String']['input'];
};

export type InitializeMasterOrderInput = {
  customer: MasterOrderCustomerDataInput;
  fromLocation: ShipFromLocationDataInput;
  masterOrderId: Scalars['String']['input'];
  masterOrderNumber: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  type: OrderType;
};

export type InitializeMergeDevExportInput = {
  entityId: Scalars['String']['input'];
  entityType: MergeDevExportEntityType;
};

export type InitializeOrderInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  customer: OrderCustomerDataInput;
  discountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  discountReason?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['DateTime']['input'];
  finalCredit?: Scalars['Boolean']['input'];
  fromLocation: ShipFromLocationDataInput;
  importId?: InputMaybe<Scalars['String']['input']>;
  initializationDateOverride?: InputMaybe<Scalars['DateTime']['input']>;
  orderId: Scalars['String']['input'];
  orderKindId?: InputMaybe<Scalars['String']['input']>;
  orderNumber: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
  produceAllocate?: Scalars['Boolean']['input'];
  program?: InputMaybe<Scalars['String']['input']>;
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  shipFromSiteLocationId?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
  type: OrderType;
};

export type InstallFeeInput = {
  amountCents: Scalars['Int']['input'];
  daysUntilDue?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export enum IntegrationCategory {
  Accounting = 'ACCOUNTING',
  Crm = 'CRM',
  Unknown = 'UNKNOWN'
}

export type IntegrationCategoryOperationFilterInput = {
  eq?: InputMaybe<IntegrationCategory>;
  in?: InputMaybe<Array<IntegrationCategory>>;
  neq?: InputMaybe<IntegrationCategory>;
  nin?: InputMaybe<Array<IntegrationCategory>>;
};

/**
 * A computed, read-only health snapshot for a single tenant's Merge.dev / accounting integration. Built
 * on demand from the connection, sync-state, WsapiImport, and accounting-policy read models — it is
 * not itself a stored document. Surfaces the "connected but never synced / mis-seeded" failure modes that
 * the per-surface signals (link present, consecutiveFailures: 0) cannot show, so a falsely-green
 * integration is caught immediately instead of by a manual cross-check of read-model counts.
 */
export type IntegrationHealthDocument = {
  __typename?: 'IntegrationHealthDocument';
  /** The Merge.dev integration id this health snapshot was computed for. */
  integrationId: Scalars['String']['output'];
  /**
   * True when a MERGE_DEV TenantIntegration link exists for this integration. When false the
   * integration is simply not connected (rather than connected-but-unhealthy) and Reasons
   * is empty — there is nothing to be unhealthy about yet.
   */
  isConnected: Scalars['Boolean']['output'];
  /**
   * True when the integration is connected and has no unhealthy reasons — it has synced at least once,
   * has an enabled import gate, and a real accounting provider. A not-connected integration is reported
   * healthy (nothing wrong) so the card only flags genuine connected-but-broken states.
   */
  isHealthy: Scalars['Boolean']['output'];
  /**
   * The distinguishable reasons the integration is unhealthy. Empty when healthy. An integration can hit
   * more than one reason at once (e.g. never-synced AND provider-none), so each finding is reported
   * independently rather than collapsed into a single status.
   */
  reasons: Array<IntegrationHealthReason>;
  /** The tenant that owns the integration this health snapshot describes. */
  tenantId: Scalars['String']['output'];
};

/**
 * A distinguishable reason a connected Merge.dev / accounting integration is unhealthy. A single
 * integration can report more than one of these at once, so Reasons
 * is a list rather than a single status. Each value names a silent failure mode that previously left the
 * integration looking falsely "green" (link present, no errors) while never actually moving any data.
 */
export enum IntegrationHealthReason {
  /**
   * The integration is linked (a MERGE_DEV TenantIntegration exists) but has never completed a
   * sync cycle: the synchronizer has captured no connection metadata (mergeDevConnection is null)
   * AND there are zero mergeDevSyncState rows for it. The integration card would otherwise show
   * "connected" while no chart-of-accounts, tax rates, items, or customers have ever been pulled.
   */
  NeverSynced = 'NEVER_SYNCED',
  /**
   * No enabled WsapiImport selects this tenant. The MergeDevImport worker's only gate is an
   * enabled WsapiImport that is RunNow or schedule-matched; with none, the worker hits
   * NoWorkIteration forever and writes nothing — no error, no sync state, no connection. The
   * link looks healthy but the worker silently skips the tenant on every cycle.
   */
  NoEnabledImport = 'NO_ENABLED_IMPORT',
  /**
   * The accounting policy provider is None while a Merge link is active. Reconnecting the Merge
   * link upserts credentials but never sets the provider, so outbound (ship→invoice) is silently
   * disabled even though the tenant appears connected.
   */
  ProviderNone = 'PROVIDER_NONE'
}

export enum IntegrationSource {
  GrowPoint = 'GROW_POINT',
  MergeDev = 'MERGE_DEV',
  OrderEase = 'ORDER_EASE',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN'
}

export type IntegrationSourceOperationFilterInput = {
  eq?: InputMaybe<IntegrationSource>;
  in?: InputMaybe<Array<IntegrationSource>>;
  neq?: InputMaybe<IntegrationSource>;
  nin?: InputMaybe<Array<IntegrationSource>>;
};

/** One batch exactly as submitted in the original adjustment request. */
export type InventoryAdjustRequestBatchData = {
  __typename?: 'InventoryAdjustRequestBatchData';
  /** The batch code, stored and returned exactly as sent, untrimmed. */
  code?: Maybe<Scalars['String']['output']>;
  /** The plant date, stored and returned exactly as sent, untrimmed. */
  plantDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The plant status, stored and returned exactly as sent, untrimmed. */
  plantStatus?: Maybe<Scalars['String']['output']>;
  /** The batch quantity, stored and returned exactly as sent, untrimmed. */
  quantity: Scalars['Decimal']['output'];
};

/** The original submitted adjustment request, independent of its stored claim representation. */
export type InventoryAdjustRequestData = {
  __typename?: 'InventoryAdjustRequestData';
  /** The batches, stored and returned exactly as sent, untrimmed. */
  batches?: Maybe<Array<Maybe<InventoryAdjustRequestBatchData>>>;
  /** The grade, stored and returned exactly as sent, untrimmed. */
  grade: Scalars['Int']['output'];
  /** The item id, stored and returned exactly as sent, untrimmed. */
  itemId: Scalars['String']['output'];
  /** The item type, stored and returned exactly as sent, untrimmed. */
  itemType: ItemType;
  /** The location id, stored and returned exactly as sent, untrimmed. */
  locationId: Scalars['String']['output'];
  /** The quantity, stored and returned exactly as sent, untrimmed. */
  quantity: Scalars['Decimal']['output'];
  /** The reason code, stored and returned exactly as sent, untrimmed. */
  reasonCode?: Maybe<Scalars['Int']['output']>;
  /** The why text, stored and returned exactly as sent, untrimmed. */
  why: Scalars['String']['output'];
};

/** A keyed adjustInventoryItem attempt as the claim its submit saved holds it. */
export type InventoryAdjustmentAttemptData = {
  __typename?: 'InventoryAdjustmentAttemptData';
  /** The saved claim's own id. */
  claimId: Scalars['String']['output'];
  /** When the claim was saved, by the server's clock. */
  claimedAt: Scalars['DateTime']['output'];
  /** The key the attempt was claimed under, trimmed as the write trimmed it. */
  idempotencyKey: Scalars['String']['output'];
  /** The request exactly as the submit sent it. */
  request: InventoryAdjustRequestData;
  /** The inventory state the submit was answered with, not today's stock. */
  result: InventoryItemStateData;
};

/**
 * One order line's allocation against an inventory key, including MakeToOrder produced-pegged allocations.
 * Quantity is the ABSOLUTE amount allocated to that line on this slot; AllocatedBy is the
 * acting user's email for a manual allocation or the "MakeToOrder" sentinel for a produced-lot peg.
 * LineItemId/OrderId are stored as strings so a consumer can link straight to the order line.
 */
export type InventoryAllocationDocument = {
  __typename?: 'InventoryAllocationDocument';
  allocatedBy: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  lineItemId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
};

/**
 * One order line's allocation against an inventory key, including MakeToOrder produced-pegged allocations.
 * Quantity is the ABSOLUTE amount allocated to that line on this slot; AllocatedBy is the
 * acting user's email for a manual allocation or the "MakeToOrder" sentinel for a produced-lot peg.
 * LineItemId/OrderId are stored as strings so a consumer can link straight to the order line.
 */
export type InventoryAllocationDocumentFilterInput = {
  allocatedBy?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<InventoryAllocationDocumentFilterInput>>;
  grade?: InputMaybe<IntOperationFilterInput>;
  lineItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InventoryAllocationDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
};

/** Which stock write a preview is for. */
export enum InventoryAllocationImpactKind {
  /** A regrade (gradeInventoryItem): the orders whose reservations it would carry to the new grade. */
  Regrade = 'REGRADE',
  /** A scrap (scrapInventoryItem): the orders whose reservations it would release. */
  Scrap = 'SCRAP',
  /** No kind was given (the zero value). A preview refuses it. */
  Unknown = 'UNKNOWN'
}

/** The row and quantity a preview asks about. */
export type InventoryAllocationImpactPreviewInput = {
  /** The row's current grade (currentGrade of a regrade, grade of a scrap); the preview assumes a regrade's new grade differs from the current grade (a same-grade regrade carries nothing), and otherwise the new grade does not change who is carried. */
  grade: Scalars['Int']['input'];
  /** The row's item. */
  itemId: Scalars['String']['input'];
  /** Whether to preview a regrade or a scrap. UNKNOWN is refused. */
  kind: InventoryAllocationImpactKind;
  /** The row's location. */
  locationId: Scalars['String']['input'];
  /** The quantity that would be regraded or scrapped. */
  quantity: Scalars['Decimal']['input'];
};

/** The orders a preview found, as the caller may see them. */
export type InventoryAllocationImpactPreviewPayload = {
  __typename?: 'InventoryAllocationImpactPreviewPayload';
  /** The affected orders the caller can see, in the write's order (oldest first for a regrade, newest first for a scrap). */
  affectedOrders: Array<InventoryOrderImpactData>;
  /** Why the preview was refused, as the write would refuse it. */
  errors?: Maybe<Array<ValidationError>>;
  /** How many other orders would be affected, which the caller cannot see. */
  otherAffectedOrderCount: Scalars['Int']['output'];
};

export type InventoryAvailabilityData = {
  __typename?: 'InventoryAvailabilityData';
  comment: Scalars['String']['output'];
  locationCode: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
};

/**
 * One batch an inventory row holds: its code, where it came from, the date it is aged from and its
 * quantity. The unknown batch has an empty code and the UNKNOWN source kind.
 */
export type InventoryBatch = {
  __typename?: 'InventoryBatch';
  /** The date the batch is aged from; null when nobody knows it. */
  ageDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The batch code as first written; empty for the unknown batch. */
  code: Scalars['String']['output'];
  /**
   * The date the batch was planted; null when nobody recorded it. A grown batch takes its job's start week
   * when its job is posted; any other batch takes the date typed when it was added, counted or received.
   */
  plantDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Free text recorded beside the plant date, for example a secondary date or a grow location; null when
   * none was recorded. The server gives it no meaning. Not a stock status.
   */
  plantStatus?: Maybe<Scalars['String']['output']>;
  /** The quantity on the batch. */
  quantity: Scalars['Decimal']['output'];
  /** Where the batch's stock came from. */
  sourceKind: BatchSourceKind;
};

export type InventoryBatchQuantityDataInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  plantDate?: InputMaybe<Scalars['LocalDate']['input']>;
  plantStatus?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Decimal']['input'];
};

/** Plants held for one customer mapping, with its current customer name and barcodes. */
export type InventoryCustomerHold = {
  __typename?: 'InventoryCustomerHold';
  /** Customer identifier, or empty when the mapping is missing. */
  customerId: Scalars['String']['output'];
  /** Hold owner's customer mapping identifier, retained if the mapping is missing. */
  customerItemId: Scalars['String']['output'];
  /** Current customer name, or empty when not projected. */
  customerName: Scalars['String']['output'];
  /** Current customer SKU, or empty when the mapping is missing. */
  customerSku: Scalars['String']['output'];
  /** Current customer UPC, absent for a missing UPC or mapping. */
  customerUpc?: Maybe<Scalars['String']['output']>;
  /** Plants held for this mapping within the queried row or summary. */
  quantity: Scalars['Decimal']['output'];
};

/** Staff stock fields; portal callers use general availability without owner metadata. */
export type InventoryItemDocument = {
  __typename?: 'InventoryItemDocument';
  allocatedQuantity: Scalars['Decimal']['output'];
  /**
   * Per-order allocation breakdown for this inventory key — one entry per allocated
   * (orderId, lineItemId), INCLUDING MakeToOrder produced-pegged allocations. Powers the FULFILL
   * inventory item "allocated orders" side panel (read in one query, collapsing the per-order GetOrder
   * N+1). Written by InventoryItemProjectionService from the InventoryItem stream's
   * ItemAllocated/ItemDeallocated events as an idempotent, replay-safe absolute rewrite;
   * empty for unallocated keys.
   */
  allocations: Array<InventoryAllocationDocument>;
  availableQuantity: Scalars['Decimal']['output'];
  /**
   * The batches this row holds, every one with stock, summing to the row's quantity. Empty when the
   * item is not batch tracked, and always empty for a customer-portal caller. A row of a tracked item
   * that has not yet recorded batches shows its whole quantity on the unknown batch.
   */
  batches: Array<InventoryBatch>;
  category: Scalars['String']['output'];
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  /** Staff customer hold quantities and current mapping details; empty when disabled. */
  customerHolds: Array<InventoryCustomerHold>;
  /** Staff general stock: on hand minus enabled holds; allocated plants remain included. */
  generalQuantity: Scalars['Decimal']['output'];
  genus: Scalars['String']['output'];
  grade: Scalars['Int']['output'];
  group: Scalars['String']['output'];
  /** Staff-held plants, or zero when customer stock is disabled. */
  heldQuantity: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  itemCode: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  /**
   * This row's item's effective Shipping UOM: the code and display name a caller with no
   * configCategories access cannot resolve for itself, together with the eaches-per-unit
   * count. Null when the item resolves to no Shipping UOM — including every hard-good row, which
   * has no ItemSummary rungs to resolve. Also null for a customer-portal caller: this is
   * the item rung only, with no customer-item override applied, so a portal caller must read
   * customerEffectiveShippingUom instead, which does apply it.
   */
  itemShippingUom?: Maybe<ItemShippingUomData>;
  itemType: ItemType;
  lastTransactionDate: Scalars['DateTime']['output'];
  lastTransactionType: Scalars['String']['output'];
  /**
   * The most recently submitted note on this key, or null when there are none. Derived on read
   * from the notes list (latest by submit date) so it can never drift from the list and is
   * never stored independently. Ties on submit date are broken by append order — the later
   * appended note wins — so the result is deterministic even when two notes share a timestamp.
   */
  latestNote?: Maybe<InventoryNoteDocument>;
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationStatus?: Maybe<LocationStatus>;
  /**
   * All free-text notes on this inventory key (item + location + grade), in append order, written
   * by the inventory-note projection.
   * Multiple notes are allowed per key and the live set (history minus cleared notes) is retained
   * here; the full KurrentDB event history is always available on the stream. Notes are
   * independent of quantity — they survive a depletion to zero and reappear on re-add — and play
   * no part in the inventory uniqueness/grouping key. Empty until a note is added.
   */
  notes: Array<InventoryNoteDocument>;
  /**
   * Quantity on order from purchase orders that has not yet been received.
   * Calculated as sum of (QuantityOrdered - QuantityReceived) across open PO line items
   * for this material item at this location.
   */
  onOrderQuantity: Scalars['Decimal']['output'];
  previousQuantity: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  /**
   * Optional, manually-entered date the live goods are projected to be ready
   * (replaces the legacy GrowPoint "seasons" concept). Null when no ready date was
   * supplied on the inventory add. Additive field: existing documents that predate it
   * read back as null.
   */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * ISO 8601 week number (1–53) DERIVED from ReadyDate. Computed on read so it
   * can never drift from the date — it is never stored independently. Null when there is no
   * ready date.
   */
  readyWeek?: Maybe<Scalars['Int']['output']>;
  reasonCode: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  /**
   * The production jobs that fed this Live Goods inventory key, one entry per job (jobId, quantity
   * contributed, the job's ready week). Written by the produced-lot → Live Goods feed projection as an
   * absolute overwrite of the full set the increment/decrement event carries, so it stays idempotent on
   * replay. Empty for inventory keys that no production job has fed (e.g. a manually-added line). Powers
   * the FULFILL inventory item "Jobs feeding this item" tab and grid. The item's `readyDate`
   * (and derived `readyWeek`) is the earliest `jobReadyWeekDate` across this set.
   */
  sourceJobContributions: Array<InventorySourceJobContributionDocument>;
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  why: Scalars['String']['output'];
};

export type InventoryItemDocumentFilterInput = {
  allocatedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Per-order allocation breakdown for this inventory key — one entry per allocated
   * (orderId, lineItemId), INCLUDING MakeToOrder produced-pegged allocations. Powers the FULFILL
   * inventory item "allocated orders" side panel (read in one query, collapsing the per-order GetOrder
   * N+1). Written by InventoryItemProjectionService from the InventoryItem stream's
   * ItemAllocated/ItemDeallocated events as an idempotent, replay-safe absolute rewrite;
   * empty for unallocated keys.
   */
  allocations?: InputMaybe<ListFilterInputTypeOfInventoryAllocationDocumentFilterInput>;
  and?: InputMaybe<Array<InventoryItemDocumentFilterInput>>;
  availableQuantity?: InputMaybe<DecimalOperationFilterInput>;
  category?: InputMaybe<StringOperationFilterInput>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  genus?: InputMaybe<StringOperationFilterInput>;
  grade?: InputMaybe<IntOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  /** Plants held for customer items, excluded from general available stock. */
  heldQuantity?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  itemType?: InputMaybe<ItemTypeOperationFilterInput>;
  lastTransactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastTransactionType?: InputMaybe<StringOperationFilterInput>;
  /**
   * The most recently submitted note on this key, or null when there are none. Derived on read
   * from the notes list (latest by submit date) so it can never drift from the list and is
   * never stored independently. Ties on submit date are broken by append order — the later
   * appended note wins — so the result is deterministic even when two notes share a timestamp.
   */
  latestNote?: InputMaybe<InventoryNoteDocumentFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  locationStatus?: InputMaybe<NullableOfLocationStatusOperationFilterInput>;
  /**
   * All free-text notes on this inventory key (item + location + grade), in append order, written
   * by the inventory-note projection.
   * Multiple notes are allowed per key and the live set (history minus cleared notes) is retained
   * here; the full KurrentDB event history is always available on the stream. Notes are
   * independent of quantity — they survive a depletion to zero and reappear on re-add — and play
   * no part in the inventory uniqueness/grouping key. Empty until a note is added.
   */
  notes?: InputMaybe<ListFilterInputTypeOfInventoryNoteDocumentFilterInput>;
  /**
   * Quantity on order from purchase orders that has not yet been received.
   * Calculated as sum of (QuantityOrdered - QuantityReceived) across open PO line items
   * for this material item at this location.
   */
  onOrderQuantity?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<InventoryItemDocumentFilterInput>>;
  previousQuantity?: InputMaybe<DecimalOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Optional, manually-entered date the live goods are projected to be ready
   * (replaces the legacy GrowPoint "seasons" concept). Null when no ready date was
   * supplied on the inventory add. Additive field: existing documents that predate it
   * read back as null.
   */
  readyDate?: InputMaybe<LocalDateOperationFilterInput>;
  /**
   * ISO 8601 week number (1–53) DERIVED from ReadyDate. Computed on read so it
   * can never drift from the date — it is never stored independently. Null when there is no
   * ready date.
   */
  readyWeek?: InputMaybe<IntOperationFilterInput>;
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  /**
   * The production jobs that fed this Live Goods inventory key, one entry per job (jobId, quantity
   * contributed, the job's ready week). Written by the produced-lot → Live Goods feed projection as an
   * absolute overwrite of the full set the increment/decrement event carries, so it stays idempotent on
   * replay. Empty for inventory keys that no production job has fed (e.g. a manually-added line). Powers
   * the FULFILL inventory item "Jobs feeding this item" tab and grid. The item's `readyDate`
   * (and derived `readyWeek`) is the earliest `jobReadyWeekDate` across this set.
   */
  sourceJobContributions?: InputMaybe<ListFilterInputTypeOfInventorySourceJobContributionDocumentFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  why?: InputMaybe<StringOperationFilterInput>;
};

export type InventoryItemDocumentSortInput = {
  allocatedQuantity?: InputMaybe<SortEnumType>;
  availableQuantity?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  genus?: InputMaybe<SortEnumType>;
  grade?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  /** Plants held for customer items, excluded from general available stock. */
  heldQuantity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCode?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  itemType?: InputMaybe<SortEnumType>;
  lastTransactionDate?: InputMaybe<SortEnumType>;
  lastTransactionType?: InputMaybe<SortEnumType>;
  /**
   * The most recently submitted note on this key, or null when there are none. Derived on read
   * from the notes list (latest by submit date) so it can never drift from the list and is
   * never stored independently. Ties on submit date are broken by append order — the later
   * appended note wins — so the result is deterministic even when two notes share a timestamp.
   */
  latestNote?: InputMaybe<InventoryNoteDocumentSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  locationStatus?: InputMaybe<SortEnumType>;
  /**
   * Quantity on order from purchase orders that has not yet been received.
   * Calculated as sum of (QuantityOrdered - QuantityReceived) across open PO line items
   * for this material item at this location.
   */
  onOrderQuantity?: InputMaybe<SortEnumType>;
  previousQuantity?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  /**
   * Optional, manually-entered date the live goods are projected to be ready
   * (replaces the legacy GrowPoint "seasons" concept). Null when no ready date was
   * supplied on the inventory add. Additive field: existing documents that predate it
   * read back as null.
   */
  readyDate?: InputMaybe<SortEnumType>;
  /**
   * ISO 8601 week number (1–53) DERIVED from ReadyDate. Computed on read so it
   * can never drift from the date — it is never stored independently. Null when there is no
   * ready date.
   */
  readyWeek?: InputMaybe<SortEnumType>;
  reasonCode?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  why?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL payload returned from grade change mutations, containing both source (old grade)
 * and destination (new grade) inventory item states.
 */
export type InventoryItemGradePayload = {
  __typename?: 'InventoryItemGradePayload';
  /** The carried orders the caller may see (orders query rule); null if refused. */
  affectedOrders?: Maybe<Array<InventoryOrderImpactData>>;
  /** The new grade's state; null when the regrade was refused. */
  destinationInventoryItem?: Maybe<InventoryItemStateData>;
  /** Why the regrade was refused. */
  errors?: Maybe<Array<ValidationError>>;
  /** How many other carried orders there are, which the caller cannot see. */
  otherAffectedOrderCount: Scalars['Int']['output'];
  /** The old grade's state; null when the regrade was refused. */
  sourceInventoryItem?: Maybe<InventoryItemStateData>;
};

/**
 * GraphQL payload returned from move mutations, containing both source and destination
 * inventory item states so the frontend can update both in the cache without a refetch.
 */
export type InventoryItemMovePayload = {
  __typename?: 'InventoryItemMovePayload';
  destinationInventoryItem?: Maybe<InventoryItemStateData>;
  errors?: Maybe<Array<ValidationError>>;
  sourceInventoryItem?: Maybe<InventoryItemStateData>;
};

/**
 * GraphQL payload returned from inventory item mutations, containing either
 * the updated state data or validation errors.
 */
export type InventoryItemPayload = {
  __typename?: 'InventoryItemPayload';
  /**
   * Only scrapInventoryItem fills this (Helm 66bfecdb): the released orders the caller may see (orders query
   * rule), newest order first, empty when the scrap stayed within the free quantity; null if refused and on
   * every other mutation that returns this payload.
   */
  affectedOrders?: Maybe<Array<InventoryOrderImpactData>>;
  /** Why the mutation was refused. */
  errors?: Maybe<Array<ValidationError>>;
  /** The key's state after the mutation; null when it was refused. */
  inventoryItem?: Maybe<InventoryItemStateData>;
  /** How many other released orders there are, which the caller cannot see; 0 on every other mutation. */
  otherAffectedOrderCount: Scalars['Int']['output'];
};

/**
 * Per-row failure surfaced by validateInventoryItemDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError carries one (best-effort), otherwise null.
 */
export type InventoryItemStagedRowError = {
  __typename?: 'InventoryItemStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

/**
 * Inventory item state returned from mutations. Display fields (item name, location name, UPC)
 * are resolved lazily via DataLoader on InventoryItemStateDataType — no follow-up
 * query needed for frontend cache updates.
 */
export type InventoryItemStateData = {
  __typename?: 'InventoryItemStateData';
  /** Available plants after allocations and holds when enabled; legacy payload value when disabled. */
  availableQuantity: Scalars['Decimal']['output'];
  /**
   * The batches this row holds after the mutation, every one with stock, summing to the row's
   * quantity. Empty when the item is not batch tracked.
   */
  batches: Array<InventoryBatch>;
  /** Staff customer hold quantities and current mapping details; empty when disabled. */
  customerHolds: Array<InventoryCustomerHold>;
  /**
   * Destination location ID for Move mutations. Used by the DataLoader resolver
   * to resolve DestinationLocationName. Null for all other mutation types.
   */
  destinationLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * Display name of the destination location, resolved via DataLoader.
   * Populated only for Move mutations (when DestinationLocationId is set).
   */
  destinationLocationName?: Maybe<Scalars['String']['output']>;
  /** Staff general stock: on hand minus enabled holds; allocated plants remain included. */
  generalQuantity: Scalars['Decimal']['output'];
  grade: Scalars['Int']['output'];
  /** Staff-held plants, or zero when customer stock is disabled. */
  heldQuantity: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  /**
   * Display name of the item, resolved via DataLoader from the ItemSummary projection.
   * Null when the item is not yet projected or the read model is unavailable.
   */
  itemName?: Maybe<Scalars['String']['output']>;
  itemType: ItemType;
  lastTransactionDate: Scalars['DateTime']['output'];
  locationId: Scalars['String']['output'];
  /**
   * Display name of the location, resolved via DataLoader from SubLocations or SiteLocations.
   * Null when the location is not yet projected or the read model is unavailable.
   */
  locationName?: Maybe<Scalars['String']['output']>;
  /**
   * All free-text notes currently on this inventory key (item + location + grade), in append
   * order. Multiple notes are allowed and the full history is retained; Notes here
   * is the live set after the mutation (a cleared note is absent). Notes are independent of
   * quantity and never affect the inventory uniqueness/grouping key.
   */
  notes: Array<InventoryNoteData>;
  previousQuantity: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  /**
   * Optional, manually-entered date the live goods are projected to be ready.
   * Null when no ready date was supplied on the add.
   */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * ISO 8601 week number (1–53) DERIVED from ReadyDate. Computed, never stored,
   * so it cannot drift from the date. Null when there is no ready date.
   */
  readyWeek?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /**
   * UPC code of the item, resolved via DataLoader from the ItemSummary projection.
   * Null when the item is not yet projected or the read model is unavailable.
   */
  upc?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  why: Scalars['String']['output'];
};

/** An item's stock across the caller's permitted locations and grades. */
export type InventoryItemStockSummary = {
  __typename?: 'InventoryItemStockSummary';
  /** Plants already allocated to orders. */
  allocatedQuantity: Scalars['Decimal']['output'];
  /** General plants available after allocations and holds. */
  availableQuantity: Scalars['Decimal']['output'];
  /** Hold quantities grouped by customer mapping, empty when disabled. */
  customerHolds: Array<InventoryCustomerHold>;
  /** On-hand plants minus enabled holds; includes allocated plants. */
  generalQuantity: Scalars['Decimal']['output'];
  /** Customer-held plants, or zero when customer stock is disabled. */
  heldQuantity: Scalars['Decimal']['output'];
  /** Inventory item identifier. */
  itemId: Scalars['String']['output'];
  /** On-hand plants across permitted locations and grades. */
  quantity: Scalars['Decimal']['output'];
};

/**
 * Result of an item-to-item transfer: the source key the quantity left and the destination key it
 * arrived at, both returned so a client can update the two in its cache without a refetch.
 */
export type InventoryItemTransferPayload = {
  __typename?: 'InventoryItemTransferPayload';
  destinationInventoryItem?: Maybe<InventoryItemStateData>;
  errors?: Maybe<Array<ValidationError>>;
  sourceInventoryItem?: Maybe<InventoryItemStateData>;
};

/** A connection to a list of items. */
export type InventoryItemsConnection = {
  __typename?: 'InventoryItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InventoryItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InventoryItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InventoryItemsEdge = {
  __typename?: 'InventoryItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InventoryItemDocument;
};

/**
 * GraphQL representation of a single free-text inventory note: its stable id (used to clear it),
 * body, and the recorded author and timestamp.
 */
export type InventoryNoteData = {
  __typename?: 'InventoryNoteData';
  noteId: Scalars['UUID']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * Read-model representation of a single free-text inventory note. Document-only sub-record (the
 * parent InventoryItemDocument is itself the read-model boundary type). Carries the note's
 * stable id (used by the clear mutation), body, author, and timestamp.
 */
export type InventoryNoteDocument = {
  __typename?: 'InventoryNoteDocument';
  noteId: Scalars['UUID']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * Read-model representation of a single free-text inventory note. Document-only sub-record (the
 * parent InventoryItemDocument is itself the read-model boundary type). Carries the note's
 * stable id (used by the clear mutation), body, author, and timestamp.
 */
export type InventoryNoteDocumentFilterInput = {
  and?: InputMaybe<Array<InventoryNoteDocumentFilterInput>>;
  noteId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<InventoryNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model representation of a single free-text inventory note. Document-only sub-record (the
 * parent InventoryItemDocument is itself the read-model boundary type). Carries the note's
 * stable id (used by the clear mutation), body, author, and timestamp.
 */
export type InventoryNoteDocumentSortInput = {
  noteId?: InputMaybe<SortEnumType>;
  submitDate?: InputMaybe<SortEnumType>;
  submittedBy?: InputMaybe<SortEnumType>;
  text?: InputMaybe<SortEnumType>;
};

/**
 * One order a regrade or a scrap touched: a regrade carries its reservation onto the new grade, a scrap releases it
 * (Helm 66bfecdb), so the screen can name the orders affected.
 */
export type InventoryOrderImpactData = {
  __typename?: 'InventoryOrderImpactData';
  /** The order's customer. */
  customerName: Scalars['String']['output'];
  /** The order. */
  orderId: Scalars['String']['output'];
  /** The order's number. */
  orderNumber: Scalars['String']['output'];
  /** The eaches of the order's reservation carried or released, over all its lines. */
  quantity: Scalars['Int']['output'];
};

/**
 * Read-model representation of a single production job's contribution to a Live Goods inventory key.
 * Document-only sub-record (the parent InventoryItemDocument is itself the read-model boundary
 * type). Carries the feeding job's id, the quantity it contributed, and the job's ready week (the Monday
 * of its ISO ready week). The item rolls the earliest `jobReadyWeekDate` up onto its ready
 * date.
 */
export type InventorySourceJobContributionDocument = {
  __typename?: 'InventorySourceJobContributionDocument';
  contributedQuantity: Scalars['Decimal']['output'];
  /**
   * Produce job number for this contribution. Null when the job no longer exists or the caller
   * is a customer-portal user, because job numbers are internal.
   */
  jobNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * ISO 8601 week number (1–53) DERIVED from `jobReadyWeekDate`. Computed on read so it can
   * never drift from the date — it is never stored independently.
   */
  jobReadyWeek: Scalars['Int']['output'];
  jobReadyWeekDate: Scalars['LocalDate']['output'];
  productionJobId: Scalars['String']['output'];
};

/**
 * Read-model representation of a single production job's contribution to a Live Goods inventory key.
 * Document-only sub-record (the parent InventoryItemDocument is itself the read-model boundary
 * type). Carries the feeding job's id, the quantity it contributed, and the job's ready week (the Monday
 * of its ISO ready week). The item rolls the earliest `jobReadyWeekDate` up onto its ready
 * date.
 */
export type InventorySourceJobContributionDocumentFilterInput = {
  and?: InputMaybe<Array<InventorySourceJobContributionDocumentFilterInput>>;
  contributedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * ISO 8601 week number (1–53) DERIVED from `jobReadyWeekDate`. Computed on read so it can
   * never drift from the date — it is never stored independently.
   */
  jobReadyWeek?: InputMaybe<IntOperationFilterInput>;
  jobReadyWeekDate?: InputMaybe<LocalDateOperationFilterInput>;
  or?: InputMaybe<Array<InventorySourceJobContributionDocumentFilterInput>>;
  productionJobId?: InputMaybe<StringOperationFilterInput>;
};

/** One batch's change on an inventory transaction. */
export type InventoryTransactionBatchDocument = {
  __typename?: 'InventoryTransactionBatchDocument';
  /** The batch's age date, when one is known. */
  ageDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The batch code as first written; empty for the unknown batch. */
  code: Scalars['String']['output'];
  /** The signed change: negative for stock that left the batch, positive for stock that arrived. */
  quantity: Scalars['Decimal']['output'];
  /** Where the batch's stock came from. */
  sourceKind: BatchSourceKind;
};

/** One batch's change on an inventory transaction. */
export type InventoryTransactionBatchDocumentFilterInput = {
  /** The batch's age date, when one is known. */
  ageDate?: InputMaybe<OptionOfDateOnlyFilterInput>;
  and?: InputMaybe<Array<InventoryTransactionBatchDocumentFilterInput>>;
  /** The batch code as first written; empty for the unknown batch. */
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InventoryTransactionBatchDocumentFilterInput>>;
  /** The signed change: negative for stock that left the batch, positive for stock that arrived. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Where the batch's stock came from. */
  sourceKind?: InputMaybe<BatchSourceKindOperationFilterInput>;
};

export type InventoryTransactionDocument = {
  __typename?: 'InventoryTransactionDocument';
  /**
   * The batches this transaction moved, one entry per batch with its signed change: negative for
   * stock that left the batch, positive for stock that arrived. Empty when the item is not batch
   * tracked. On a row that holds no batches it lists the batches that arrived from a batch-tracked
   * item, which is the only place that history is kept.
   */
  batchMovements: Array<InventoryTransactionBatchDocument>;
  /**
   * The item on the other side of an item-to-item transfer: the item the quantity went TO on a
   * TRANSFERRED_OUT row, and the item it came FROM on a TRANSFERRED_IN row. Null on every other
   * transaction type.
   */
  counterpartItemId?: Maybe<Scalars['String']['output']>;
  /**
   * Location of the key on the other side of an item-to-item transfer. Carried alongside the item
   * because a transfer may change location and grade as well as the item, so a row describes the whole
   * movement without reading its paired row. Null off a transfer.
   */
  counterpartLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * SKU of the item on the other side of an item-to-item transfer. Null off a transfer, and also when
   * that item has no SKU recorded — so "no SKU known" is distinguishable from a real value, and a
   * caller can fall back to counterpartItemId.
   */
  counterpartSku?: Maybe<Scalars['String']['output']>;
  grade: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  /**
   * This transaction row's item's Shipping UOM: the code, display name and eaches-per-unit count a
   * client needs to render the row as trays. Null when the item resolves to no Shipping UOM —
   * including every hard-good row, which has no ItemSummary rungs to resolve. Also null for
   * a customer-portal caller.
   */
  itemShippingUom?: Maybe<InventoryTransactionShippingUomData>;
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  /**
   * The item the transaction was recorded against, when an item combine has since moved the row to the
   * item it was combined into (with that item's SKU and name); null when no combine moved it.
   */
  originalItemId?: Maybe<Scalars['String']['output']>;
  previousQuantity: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  reasonCode: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  transactionType: InventoryTransactionType;
  /**
   * Links the two halves of one item-to-item transfer: the TRANSFERRED_OUT row and its TRANSFERRED_IN
   * row carry the same value, so the pair can be matched directly rather than inferred from timestamps
   * or quantities. Null off a transfer.
   */
  transferId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  /**
   * Why the transaction happened. On an allocation, deallocation or pull row it names the order by its number;
   * the order's id stands in when the order cannot be found.
   */
  why: Scalars['String']['output'];
};

export type InventoryTransactionDocumentFilterInput = {
  and?: InputMaybe<Array<InventoryTransactionDocumentFilterInput>>;
  /**
   * The batches this transaction moved, one entry per batch with its signed change: negative for
   * stock that left the batch, positive for stock that arrived. Empty when the item is not batch
   * tracked. On a row that holds no batches it lists the batches that arrived from a batch-tracked
   * item, which is the only place that history is kept.
   */
  batchMovements?: InputMaybe<ListFilterInputTypeOfInventoryTransactionBatchDocumentFilterInput>;
  /**
   * The item on the other side of an item-to-item transfer: the item the quantity went TO on a
   * TRANSFERRED_OUT row, and the item it came FROM on a TRANSFERRED_IN row. Null on every other
   * transaction type.
   */
  counterpartItemId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * Location of the key on the other side of an item-to-item transfer. Carried alongside the item
   * because a transfer may change location and grade as well as the item, so a row describes the whole
   * movement without reading its paired row. Null off a transfer.
   */
  counterpartLocationId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * SKU of the item on the other side of an item-to-item transfer. Null off a transfer, and also when
   * that item has no SKU recorded — so "no SKU known" is distinguishable from a real value, and a
   * caller can fall back to counterpartItemId.
   */
  counterpartSku?: InputMaybe<OptionOfStringFilterInput>;
  grade?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InventoryTransactionDocumentFilterInput>>;
  /**
   * The item the transaction was recorded against, when an item combine has since moved the row to the
   * item it was combined into (with that item's SKU and name); null when no combine moved it.
   */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  previousQuantity?: InputMaybe<DecimalOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
  transactionType?: InputMaybe<InventoryTransactionTypeOperationFilterInput>;
  /**
   * Links the two halves of one item-to-item transfer: the TRANSFERRED_OUT row and its TRANSFERRED_IN
   * row carry the same value, so the pair can be matched directly rather than inferred from timestamps
   * or quantities. Null off a transfer.
   */
  transferId?: InputMaybe<OptionOfStringFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  why?: InputMaybe<StringOperationFilterInput>;
};

export type InventoryTransactionDocumentSortInput = {
  /**
   * The item on the other side of an item-to-item transfer: the item the quantity went TO on a
   * TRANSFERRED_OUT row, and the item it came FROM on a TRANSFERRED_IN row. Null on every other
   * transaction type.
   */
  counterpartItemId?: InputMaybe<SortEnumType>;
  /**
   * Location of the key on the other side of an item-to-item transfer. Carried alongside the item
   * because a transfer may change location and grade as well as the item, so a row describes the whole
   * movement without reading its paired row. Null off a transfer.
   */
  counterpartLocationId?: InputMaybe<SortEnumType>;
  /**
   * SKU of the item on the other side of an item-to-item transfer. Null off a transfer, and also when
   * that item has no SKU recorded — so "no SKU known" is distinguishable from a real value, and a
   * caller can fall back to counterpartItemId.
   */
  counterpartSku?: InputMaybe<SortEnumType>;
  grade?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  /**
   * The item the transaction was recorded against, when an item combine has since moved the row to the
   * item it was combined into (with that item's SKU and name); null when no combine moved it.
   */
  originalItemId?: InputMaybe<SortEnumType>;
  previousQuantity?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  reasonCode?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  timestamp?: InputMaybe<SortEnumType>;
  transactionType?: InputMaybe<SortEnumType>;
  /**
   * Links the two halves of one item-to-item transfer: the TRANSFERRED_OUT row and its TRANSFERRED_IN
   * row carry the same value, so the pair can be matched directly rather than inferred from timestamps
   * or quantities. Null off a transfer.
   */
  transferId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  why?: InputMaybe<SortEnumType>;
};

/**
 * An inventory transaction row's item-rung Shipping UOM for the FULFILL history feed: the code and
 * display name a caller with no configCategories access cannot resolve for itself, together
 * with the eaches-per-unit count.
 */
export type InventoryTransactionShippingUomData = {
  __typename?: 'InventoryTransactionShippingUomData';
  code: Scalars['String']['output'];
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
};

export enum InventoryTransactionType {
  Allocated = 'ALLOCATED',
  Created = 'CREATED',
  /** An order's reservation at this key was handed back. */
  Deallocated = 'DEALLOCATED',
  Decremented = 'DECREMENTED',
  GradeChanged = 'GRADE_CHANGED',
  /** Held plants returned to general stock by a row shortage. */
  HoldReduced = 'HOLD_REDUCED',
  Incremented = 'INCREMENTED',
  Moved = 'MOVED',
  Scrapped = 'SCRAPPED',
  Set = 'SET',
  /** Quantity arrived at this key from a different ITEM's key (item→item transfer, destination half). */
  TransferredIn = 'TRANSFERRED_IN',
  /** Quantity left this key on its way to a different ITEM's key (item→item transfer, source half). */
  TransferredOut = 'TRANSFERRED_OUT',
  Unknown = 'UNKNOWN'
}

export type InventoryTransactionTypeOperationFilterInput = {
  eq?: InputMaybe<InventoryTransactionType>;
  in?: InputMaybe<Array<InventoryTransactionType>>;
  neq?: InputMaybe<InventoryTransactionType>;
  nin?: InputMaybe<Array<InventoryTransactionType>>;
};

/** A connection to a list of items. */
export type InventoryTransactionsConnection = {
  __typename?: 'InventoryTransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InventoryTransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InventoryTransactionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InventoryTransactionsEdge = {
  __typename?: 'InventoryTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InventoryTransactionDocument;
};

export type InvoiceAdjustmentData = {
  __typename?: 'InvoiceAdjustmentData';
  adjustedAt: Scalars['DateTime']['output'];
  adjustedBy: Scalars['String']['output'];
  adjustmentId: Scalars['String']['output'];
  amount: Scalars['Decimal']['output'];
  kind: InvoiceAdjustmentKind;
  reason: Scalars['String']['output'];
};

/** One adjustment recorded against an invoice, as the invoice read model carries it. */
export type InvoiceAdjustmentEntry = {
  __typename?: 'InvoiceAdjustmentEntry';
  /** The instant it was recorded. */
  adjustedAt: Scalars['DateTime']['output'];
  /** The email of whoever recorded it. */
  adjustedBy: Scalars['String']['output'];
  /** This adjustment's identity — and the projection's dedup key. */
  adjustmentId: Scalars['String']['output'];
  /** How much the invoice is owed less. Always greater than zero. */
  amount: Scalars['Decimal']['output'];
  /** What the operator is calling the reduction. Reporting only; the arithmetic never branches on it. */
  kind: InvoiceAdjustmentKind;
  /** Why it was adjusted. */
  reason: Scalars['String']['output'];
};

export enum InvoiceAdjustmentKind {
  Discount = 'DISCOUNT',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  WriteOff = 'WRITE_OFF'
}

/** A typed refusal of a Checkout start. */
export type InvoiceCheckoutRefusal = {
  __typename?: 'InvoiceCheckoutRefusal';
  /** Why the start was refused. */
  code: InvoiceCheckoutRefusalCode;
  /**
   * True when the pay link's own expiry is what makes the session too short: a new link is needed, which an expired
   * link's page can ask for once it has run out.
   */
  linkBound: Scalars['Boolean']['output'];
  /** The pay link's expiry, when linkBound is true; otherwise null. */
  linkExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** A plain-English explanation, for logs and support. */
  message: Scalars['String']['output'];
  /** Whether trying again later can succeed without anything else changing. */
  retryable: Scalars['Boolean']['output'];
};

/** Why a Checkout start was refused. Nothing was charged and, unless stated, nothing was written. */
export enum InvoiceCheckoutRefusalCode {
  /** Checkout could not be opened. Try again later. */
  CheckoutUnavailable = 'CHECKOUT_UNAVAILABLE',
  /**
   * The session would have to end in under 30 minutes, Stripe's minimum: the pay link expires, or the discount ends
   * or the late charge grows, too soon. Nothing was written. linkBound tells which.
   */
  CheckoutWindowTooShort = 'CHECKOUT_WINDOW_TOO_SHORT',
  /** The invoices are billed in different currencies and cannot be paid together. */
  MixedCurrency = 'MIXED_CURRENCY',
  /** Nothing is owed on these invoices right now. */
  NothingToPay = 'NOTHING_TO_PAY',
  /** A payment of one of these invoices is already in progress and has not cleared yet. */
  PaymentInProgress = 'PAYMENT_IN_PROGRESS',
  /** The grower is not taking online payments right now: switched off, or the Stripe account is not ready. */
  PaymentUnavailable = 'PAYMENT_UNAVAILABLE',
  /** One or more of the invoices cannot be paid by this caller. The same answer whatever the reason. */
  SelectionInvalid = 'SELECTION_INVALID',
  /** Another start for these invoices is in progress, or a call did not complete. Try again in a moment. */
  TryAgain = 'TRY_AGAIN'
}

export type InvoiceCreditApplicationData = {
  __typename?: 'InvoiceCreditApplicationData';
  amount: Scalars['Decimal']['output'];
  applicationId: Scalars['String']['output'];
  appliedAt: Scalars['DateTime']['output'];
  appliedBy: Scalars['String']['output'];
  creditCustomerId: Scalars['String']['output'];
  sources: Array<InvoiceCreditSourceData>;
};

/** One application of the customer's credit to an invoice, as the invoice read model carries it. */
export type InvoiceCreditApplicationEntry = {
  __typename?: 'InvoiceCreditApplicationEntry';
  /** How much the invoice is owed less. Always greater than zero. */
  amount: Scalars['Decimal']['output'];
  /** This application's identity, shared with the customer's credit balance — and the projection's dedup key. */
  applicationId: Scalars['String']['output'];
  /** The instant it was applied. */
  appliedAt: Scalars['DateTime']['output'];
  /** The email of whoever, or whatever system actor, applied it. */
  appliedBy: Scalars['String']['output'];
  /** Which of the customer's credits the amount came from, and how much of each. */
  sources: Array<InvoiceCreditSourceEntry>;
};

export type InvoiceCreditSourceData = {
  __typename?: 'InvoiceCreditSourceData';
  amount: Scalars['Decimal']['output'];
  entryId: Scalars['String']['output'];
  sourceKind: CustomerCreditSourceKind;
  sourceReference: Scalars['String']['output'];
};

/** One of the customer's credits an application drew from, as the invoice read model carries it. */
export type InvoiceCreditSourceEntry = {
  __typename?: 'InvoiceCreditSourceEntry';
  /** How much of the application came from that credit. */
  amount: Scalars['Decimal']['output'];
  /** The customer credit entry drawn from. */
  entryId: Scalars['String']['output'];
  /** Where that credit came from: a credit memo, a deposit overage, or a payment excess. */
  sourceKind: CustomerCreditSourceKind;
  /** The originating writer's own reference for that credit. */
  sourceReference: Scalars['String']['output'];
};

/**
 * Read-model document for one invoice, keyed {tenantId}-{invoiceId}. Projected from the
 * Invoice streams; the receivables, aging, statement and portal surfaces all read invoices here
 * rather than folding a stream per invoice.
 *
 *
 * THE STORED FIELDS ARE STREAM FACTS; EVERY MONEY DERIVATION IS COMPUTED ON READ. What the invoice
 * billed is frozen at issue; what has been recorded against it is payments; and what it is
 * therefore OWED (openBalance) and whether that reads as open, part paid or paid
 * (standing) are derived on read, through the same arithmetic the invoice itself folds through.
 * Storing a balance or a paid flag would put a second answer to those questions in the database, free
 * to drift from the stream the moment a projection arm was missed; this document cannot drift, because
 * it holds no answer of its own.
 *
 *
 * ACCRUAL IS NOT HERE AT ALL, and could not be: an accrued late charge and an available discount are a
 * function of the invoice AND a date, so they are not knowable at projection time. They come from the
 * one shared accrual rule, given a caller-supplied as-of date, exactly as aging buckets do — read both
 * from customerReceivables.
 *
 *
 * orderId IS A FIRST-CLASS LOOKUP, not merely a payload field: it carries two indexes of its
 * own. One is unique but PARTIAL, scoped to the bills that still stand, which is what enforces at most
 * one live invoice per order while leaving an order free to keep every bill it has ever had; the plain
 * twin beside it is all-status, and is what answers the history questions the partial one cannot see.
 * Together they are how "which of these shipped orders already have a live bill" is asked, which is what
 * the mark-for-invoicing surface's filter is.
 */
export type InvoiceDocument = {
  __typename?: 'InvoiceDocument';
  /**
   * Every adjustment recorded against this invoice — write-offs and post-billing discounts — in the
   * order they were recorded.
   */
  adjustments: Array<InvoiceAdjustmentEntry>;
  /**
   * What has been adjusted off the invoice — written off, discounted, or otherwise reduced without
   * money arriving. Part of what settles the bill, and never money the tenant received.
   */
  amountAdjusted: Scalars['Decimal']['output'];
  /**
   * The customer credit applied to the invoice — money the customer already had on account, spent here.
   * Part of what settles the bill, and never cash received.
   */
  amountCreditApplied: Scalars['Decimal']['output'];
  /** The cash recorded against the invoice. */
  amountPaid: Scalars['Decimal']['output'];
  /**
   * Every application of the customer's credit to this invoice, in the order they were applied. Credit
   * applied settles the bill without cash arriving, like an adjustment, and is reported apart from both.
   */
  creditsApplied: Array<InvoiceCreditApplicationEntry>;
  /** The customer billed — the axis every A/R rollup groups on. */
  customerId: Scalars['String']['output'];
  /**
   * The invoice's customer-type revenue GL account resolved to its Merge.dev account RemoteId,
   * for the outbound invoice export's customer-type routing tier. Null when the billed customer
   * has no type assigned, the type is inactive, deleted, or has no RevenueGlAccountId, the
   * mapped account is archived, or no MergeDevAccount matches — the downstream wsapi-services
   * handler owns the unmapped fallback. Every one of those null cases agrees with the
   * revenue-account ladder's revenueAccountSummary instead of handing a caller a RemoteId that
   * fails at QuickBooks. Output-only field; every hop is tenant-scoped.
   */
  customerTypeIncomeGlAccountRemoteId?: Maybe<Scalars['String']['output']>;
  /**
   * The deposit held against the order, applied to this invoice as a credit line. Never more than grossTotal on an
   * invoice issued since deposits were capped, or once the deposit-overage backfill has moved the rest: a deposit
   * beyond it is depositOverage.
   */
  depositApplied: Scalars['Decimal']['output'];
  /**
   * The part of the order's deposit beyond grossTotal, which this invoice did not apply and moved to the customer's
   * unapplied credit, where staff may apply it to another invoice or record a refund. Zero when the deposit fit the
   * gross.
   */
  depositOverage: Scalars['Decimal']['output'];
  /** The early-pay discount payers have taken against the invoice. */
  discountTaken: Scalars['Decimal']['output'];
  /**
   * The date payment is due, as frozen onto the invoice at issue. Stored rather than re-derived from
   * invoiceDate and terms so a later terms edit cannot move it.
   */
  dueDate: Scalars['DateTime']['output'];
  /** Resolved boolean controlling whether an invoice-issue email should be sent for this invoice. Cascade is order ?? location ?? customer (most-specific-wins), resolved through the invoice's order. True means send; false means skip. */
  effectiveSendInvoiceEmails: Scalars['Boolean']['output'];
  /**
   * The named flat charges billed beside the freight, inside grossTotal. Empty on an invoice that
   * bills none, which is every invoice issued before charges existed.
   */
  flatCharges: Array<InvoiceFlatChargeEntry>;
  /** The freight charged. */
  freight: Scalars['Decimal']['output'];
  /** Everything charged, before the deposit credit is applied. */
  grossTotal: Scalars['Decimal']['output'];
  /**
   * The composite Mongo _id. Embedding the tenant means a per-invoice read filters on _id
   * alone and cannot leak across tenants — not-found and belongs-to-another-tenant are the same answer
   * by construction.
   */
  id: Scalars['String']['output'];
  /** The date the invoice was issued. The terms clock, and the early-pay window, start here. */
  invoiceDate: Scalars['DateTime']['output'];
  /**
   * Which sender owns this invoice's email: LEGACY or DISPATCH, decided when the invoice was issued,
   * or UNKNOWN for an invoice issued before the route existed.
   */
  invoiceEmailRoute: CustomerEmailRoute;
  /**
   * The invoice's own identifier, minted when the invoice was issued. Not the order's id: an order
   * billed, withdrawn and billed again holds one of these per bill.
   */
  invoiceId: Scalars['String']['output'];
  /**
   * The invoice number: the order number on the order's first bill, and orderNumber-R1, orderNumber-R2
   * and so on for each bill raised after a previous one was withdrawn.
   */
  invoiceNumber: Scalars['String']['output'];
  /**
   * Whether this invoice was loaded from GP as an open receivable at cutover rather than issued here.
   * Such an invoice never emailed the customer and never exported to accounting, and its total is the
   * balance GP still showed open.
   */
  isHistoricalImport: Scalars['Boolean']['output'];
  /** The instant the invoice was issued. */
  issuedAt: Scalars['DateTime']['output'];
  /** The email of the user who issued it. */
  issuedBy: Scalars['String']['output'];
  /**
   * When money was last recorded against this invoice; None when none ever has. Read from the
   * received dates rather than the recorded ones, because that is the date a customer recognises.
   */
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** The finance charge assessed against the invoice so far. */
  lateChargeAssessed: Scalars['Decimal']['output'];
  /**
   * The finance charge that has been FORGIVEN on this invoice. Not part of openBalance — a
   * waiver forgives an accrual nobody had assessed, so it was never owed. What it reduces is the
   * accrued figure customerReceivables and the statement report.
   */
  lateChargeWaived: Scalars['Decimal']['output'];
  /** Every waiver of this invoice's accrued finance charge, in the order they were recorded. */
  lateChargeWaivers: Array<InvoiceLateChargeWaiverEntry>;
  /** The billed lines, on the shipped basis, in line-number order. */
  lines: Array<InvoiceLineData>;
  /**
   * What the invoice still owes from the amounts recorded against it. Excludes any late charge it has
   * run up but nobody has assessed, and any early-pay discount still available to it — both are as-of
   * figures, and customerReceivables is what reports them.
   */
  openBalance: Scalars['Decimal']['output'];
  /**
   * The order this invoice bills. Many invoices may name one order over its life, but at most one of
   * them is live at a time, which is what this collection's partial unique index enforces — see this
   * type's remarks.
   */
  orderId: Scalars['String']['output'];
  /**
   * The number of the order this invoice bills, so every bill of one order, a re-bill included, carries
   * the same value. Stored rather than recovered from invoiceNumber, so the invoices grid
   * filters and sorts on it as on any other column.
   */
  orderNumber: Scalars['String']['output'];
  /**
   * The customer this invoice belonged to before a customer combine moved it onto the customer it was
   * combined into, or the customer its order names when it was issued to the customer that one had been
   * combined into; null otherwise. Set once, so a chain of combines keeps the first
   * customer.
   */
  originalCustomerId?: Maybe<Scalars['String']['output']>;
  /**
   * Every payment recorded against this invoice, in the order they were recorded. Held here as well as
   * per payment behind invoicePaymentGroup — the invoice page needs them without a second read,
   * and the remittance view needs them keyed by reference across invoices.
   */
  payments: Array<InvoicePaymentEntry>;
  /** Where this invoice stands with QuickBooks: whether it got there, which QuickBooks invoice it became, why it did not, when it was last attempted, and how many attempts have failed since it was last armed. Reads NOT_EXPORTED for an invoice with no export of its own — a tenant with no accounting integration, an invoice issued before there was one, or an id whose export row tracks the order rather than the invoice. */
  quickBooksExport: QuickBooksExportState;
  /**
   * Why the last QuickBooks export attempt did not get there. Null unless quickBooksExportStatus is
   * FAILED.
   */
  quickBooksExportError?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this invoice reached QuickBooks. NOT_EXPORTED until an export is armed for it — which is
   * also how an invoice reads for a tenant with no accounting integration, and how an id whose export
   * row tracks the ORDER rather than the invoice reads, because that outcome was never about this bill.
   *
   * STORED ON THE INVOICE so the invoices list can filter and sort on it server-side. What it says and
   * what quickBooksExport says are one answer with one writer: both come from the same export row, this
   * one denormalized when the row is written and that one read straight off it.
   */
  quickBooksExportStatus: QuickBooksExportStatus;
  /**
   * The id QuickBooks gave the invoice it created from this bill, for opening it there. Null until an
   * export has succeeded, and kept afterwards — a later attempt does not erase the pointer to a
   * QuickBooks invoice that already exists.
   */
  quickBooksRemoteInvoiceId?: Maybe<Scalars['String']['output']>;
  /**
   * The invoice-wide revenue routing for a SUMMARY-detail export: the account and precedence rung
   * that route the single synthetic Sales line, walking customer type then the tenant default and
   * reading UNMAPPED when neither applies. The item and category rungs are deliberately not walked
   * — one synthetic line stands for every item on the invoice, so no item is the right one to
   * resolve against. An ITEM-detail export reads each line's own revenueAccount instead. Never
   * null, and never fails the invoice: an unroutable invoice reads UNMAPPED with a null account.
   */
  revenueAccountSummary: ResolvedRevenueAccount;
  /** Whether the invoice reads as open, part paid, paid or void — derived from the amounts, never stored. */
  standing: InvoiceStanding;
  /**
   * Where the invoice stands as a DOCUMENT — issued, or withdrawn. Stored because withdrawing a bill is
   * an act somebody performed and rides the stream; contrast standing, which is money.
   */
  status: InvoiceStatus;
  /** The Stripe Tax calculation the tax was taken from. */
  stripeTaxCalculationId: Scalars['String']['output'];
  /** The Stripe Tax reversal recorded when the invoice was voided. */
  stripeTaxReversalTransactionId?: Maybe<Scalars['String']['output']>;
  /** The recorded Stripe Tax transaction — the filing record for this invoice. */
  stripeTaxTransactionId: Scalars['String']['output'];
  /** The sum of the lines' billed amounts, before freight and tax. */
  subtotal: Scalars['Decimal']['output'];
  /**
   * The per-jurisdiction tax breakdown, one row per distinct jurisdiction, rate and reason. A $0
   * row reading not_collecting means the tenant holds no registration in that jurisdiction — data,
   * not a failure.
   */
  taxBreakdown: Array<InvoiceTaxJurisdictionData>;
  /** The date tax law was evaluated as of, which equals the invoice date. */
  taxDate: Scalars['DateTime']['output'];
  /**
   * Whether this invoice's tax was CALCULATED at Stripe Tax, or was never calculated at all because
   * the tenant had no Stripe connected account when it was issued. A NOT_CALCULATED invoice
   * carries a $0 taxTotal and an empty taxBreakdown because nothing was computed
   * — not because nothing was owed. A $0 tax Stripe DID calculate reads CALCULATED with
   * a not_collecting breakdown row, and the two must stay distinguishable forever.
   */
  taxStatus: InvoiceTaxStatus;
  /** The total sales tax, as STRIPE calculated it — never a re-sum of taxBreakdown. */
  taxTotal: Scalars['Decimal']['output'];
  /** The owning tenant — the leading component of id and of every index. */
  tenantId: Scalars['String']['output'];
  /** The terms frozen onto this invoice at issue. */
  terms: InvoiceTermsSnapshotData;
  /**
   * What the invoice is owed at issue: the gross charged less the deposit credit. A stream fact — the
   * issue event fixes it — so it is stored rather than derived, unlike openBalance.
   */
  total: Scalars['Decimal']['output'];
  /** Why the invoice was voided; None on an invoice that still stands. */
  voidReason?: Maybe<Scalars['String']['output']>;
  /** When the invoice was voided; None on an invoice that still stands. */
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who voided it; None on an invoice that still stands. */
  voidedBy?: Maybe<Scalars['String']['output']>;
};

/**
 * Read-model document for one invoice, keyed {tenantId}-{invoiceId}. Projected from the
 * Invoice streams; the receivables, aging, statement and portal surfaces all read invoices here
 * rather than folding a stream per invoice.
 *
 *
 * THE STORED FIELDS ARE STREAM FACTS; EVERY MONEY DERIVATION IS COMPUTED ON READ. What the invoice
 * billed is frozen at issue; what has been recorded against it is payments; and what it is
 * therefore OWED (openBalance) and whether that reads as open, part paid or paid
 * (standing) are derived on read, through the same arithmetic the invoice itself folds through.
 * Storing a balance or a paid flag would put a second answer to those questions in the database, free
 * to drift from the stream the moment a projection arm was missed; this document cannot drift, because
 * it holds no answer of its own.
 *
 *
 * ACCRUAL IS NOT HERE AT ALL, and could not be: an accrued late charge and an available discount are a
 * function of the invoice AND a date, so they are not knowable at projection time. They come from the
 * one shared accrual rule, given a caller-supplied as-of date, exactly as aging buckets do — read both
 * from customerReceivables.
 *
 *
 * orderId IS A FIRST-CLASS LOOKUP, not merely a payload field: it carries two indexes of its
 * own. One is unique but PARTIAL, scoped to the bills that still stand, which is what enforces at most
 * one live invoice per order while leaving an order free to keep every bill it has ever had; the plain
 * twin beside it is all-status, and is what answers the history questions the partial one cannot see.
 * Together they are how "which of these shipped orders already have a live bill" is asked, which is what
 * the mark-for-invoicing surface's filter is.
 */
export type InvoiceDocumentFilterInput = {
  and?: InputMaybe<Array<InvoiceDocumentFilterInput>>;
  /** The customer billed — the axis every A/R rollup groups on. */
  customerId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The date payment is due, as frozen onto the invoice at issue. Stored rather than re-derived from
   * invoiceDate and terms so a later terms edit cannot move it.
   */
  dueDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** The date the invoice was issued. The terms clock, and the early-pay window, start here. */
  invoiceDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Which sender owns this invoice's email: LEGACY or DISPATCH, decided when the invoice was issued,
   * or UNKNOWN for an invoice issued before the route existed.
   */
  invoiceEmailRoute?: InputMaybe<CustomerEmailRouteOperationFilterInput>;
  /**
   * The invoice's own identifier, minted when the invoice was issued. Not the order's id: an order
   * billed, withdrawn and billed again holds one of these per bill.
   */
  invoiceId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The invoice number: the order number on the order's first bill, and orderNumber-R1, orderNumber-R2
   * and so on for each bill raised after a previous one was withdrawn.
   */
  invoiceNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether this invoice was loaded from GP as an open receivable at cutover rather than issued here.
   * Such an invoice never emailed the customer and never exported to accounting, and its total is the
   * balance GP still showed open.
   */
  isHistoricalImport?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<InvoiceDocumentFilterInput>>;
  /**
   * The order this invoice bills. Many invoices may name one order over its life, but at most one of
   * them is live at a time, which is what this collection's partial unique index enforces — see this
   * type's remarks.
   */
  orderId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether this invoice reached QuickBooks. NOT_EXPORTED until an export is armed for it — which is
   * also how an invoice reads for a tenant with no accounting integration, and how an id whose export
   * row tracks the ORDER rather than the invoice reads, because that outcome was never about this bill.
   *
   * STORED ON THE INVOICE so the invoices list can filter and sort on it server-side. What it says and
   * what quickBooksExport says are one answer with one writer: both come from the same export row, this
   * one denormalized when the row is written and that one read straight off it.
   */
  quickBooksExportStatus?: InputMaybe<QuickBooksExportStatusOperationFilterInput>;
  /**
   * Where the invoice stands as a DOCUMENT — issued, or withdrawn. Stored because withdrawing a bill is
   * an act somebody performed and rides the stream; contrast standing, which is money.
   */
  status?: InputMaybe<InvoiceStatusOperationFilterInput>;
  /** The total sales tax, as STRIPE calculated it — never a re-sum of taxBreakdown. */
  taxTotal?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * What the invoice is owed at issue: the gross charged less the deposit credit. A stream fact — the
   * issue event fixes it — so it is stored rather than derived, unlike openBalance.
   */
  total?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * Read-model document for one invoice, keyed {tenantId}-{invoiceId}. Projected from the
 * Invoice streams; the receivables, aging, statement and portal surfaces all read invoices here
 * rather than folding a stream per invoice.
 *
 *
 * THE STORED FIELDS ARE STREAM FACTS; EVERY MONEY DERIVATION IS COMPUTED ON READ. What the invoice
 * billed is frozen at issue; what has been recorded against it is payments; and what it is
 * therefore OWED (openBalance) and whether that reads as open, part paid or paid
 * (standing) are derived on read, through the same arithmetic the invoice itself folds through.
 * Storing a balance or a paid flag would put a second answer to those questions in the database, free
 * to drift from the stream the moment a projection arm was missed; this document cannot drift, because
 * it holds no answer of its own.
 *
 *
 * ACCRUAL IS NOT HERE AT ALL, and could not be: an accrued late charge and an available discount are a
 * function of the invoice AND a date, so they are not knowable at projection time. They come from the
 * one shared accrual rule, given a caller-supplied as-of date, exactly as aging buckets do — read both
 * from customerReceivables.
 *
 *
 * orderId IS A FIRST-CLASS LOOKUP, not merely a payload field: it carries two indexes of its
 * own. One is unique but PARTIAL, scoped to the bills that still stand, which is what enforces at most
 * one live invoice per order while leaving an order free to keep every bill it has ever had; the plain
 * twin beside it is all-status, and is what answers the history questions the partial one cannot see.
 * Together they are how "which of these shipped orders already have a live bill" is asked, which is what
 * the mark-for-invoicing surface's filter is.
 */
export type InvoiceDocumentSortInput = {
  /** The customer billed — the axis every A/R rollup groups on. */
  customerId?: InputMaybe<SortEnumType>;
  /**
   * The date payment is due, as frozen onto the invoice at issue. Stored rather than re-derived from
   * invoiceDate and terms so a later terms edit cannot move it.
   */
  dueDate?: InputMaybe<SortEnumType>;
  /** The date the invoice was issued. The terms clock, and the early-pay window, start here. */
  invoiceDate?: InputMaybe<SortEnumType>;
  /**
   * The invoice number: the order number on the order's first bill, and orderNumber-R1, orderNumber-R2
   * and so on for each bill raised after a previous one was withdrawn.
   */
  invoiceNumber?: InputMaybe<SortEnumType>;
  /**
   * Whether this invoice reached QuickBooks. NOT_EXPORTED until an export is armed for it — which is
   * also how an invoice reads for a tenant with no accounting integration, and how an id whose export
   * row tracks the ORDER rather than the invoice reads, because that outcome was never about this bill.
   *
   * STORED ON THE INVOICE so the invoices list can filter and sort on it server-side. What it says and
   * what quickBooksExport says are one answer with one writer: both come from the same export row, this
   * one denormalized when the row is written and that one read straight off it.
   */
  quickBooksExportStatus?: InputMaybe<SortEnumType>;
  /**
   * Where the invoice stands as a DOCUMENT — issued, or withdrawn. Stored because withdrawing a bill is
   * an act somebody performed and rides the stream; contrast standing, which is money.
   */
  status?: InputMaybe<SortEnumType>;
  /**
   * What the invoice is owed at issue: the gross charged less the deposit credit. A stream fact — the
   * issue event fixes it — so it is stored rather than derived, unlike openBalance.
   */
  total?: InputMaybe<SortEnumType>;
};

/**
 * The seller's own name and contact details as an invoice email prints them — the remit-to block.
 * Every field but the name is null until the tenant fills its company profile in.
 */
export type InvoiceEmailCompanyTokens = {
  __typename?: 'InvoiceEmailCompanyTokens';
  /** The city, or null when unset. */
  city?: Maybe<Scalars['String']['output']>;
  /** The contact email address, or null when unset. */
  email?: Maybe<Scalars['String']['output']>;
  /** The tenant's trading name, falling back to the tenant's own name. */
  name: Scalars['String']['output'];
  /** The phone number, or null when unset. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The state or province, or null when unset. */
  state?: Maybe<Scalars['String']['output']>;
  /** The street address, or null when unset. */
  street?: Maybe<Scalars['String']['output']>;
  /** The website, or null when unset. */
  website?: Maybe<Scalars['String']['output']>;
  /** The postal code, or null when unset. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** What a staff resend did. Never a silent no-op: QUEUED, or SUPPRESSED with a reason. */
export type InvoiceEmailResendResult = {
  __typename?: 'InvoiceEmailResendResult';
  /** The last day the emailed pay link works; null when suppressed. */
  linkExpiresOn?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Whether the resend made a new pay link, because the invoice had none live or the one it had had fewer than 10
   * days left. A new link stops the one the customer already holds from working. False when suppressed.
   */
  newLinkMade: Scalars['Boolean']['output'];
  /** The reason in plain words, to show staff; null when queued. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Why it was suppressed; null when queued. */
  reasonCode?: Maybe<InvoiceEmailResendSuppression>;
  /** The run-once report schedule that carries the email; null when suppressed. */
  scheduleId?: Maybe<Scalars['String']['output']>;
  /** QUEUED or SUPPRESSED. Queued, never sent: the worker sends it. */
  status: InvoiceEmailResendStatus;
};

/** Whether a staff resend was queued. */
export enum InvoiceEmailResendStatus {
  /** The email is queued: the send worker emails it, with the PDF, on its next pass. */
  Queued = 'QUEUED',
  /** Nothing was queued; reasonCode and reason say why. */
  Suppressed = 'SUPPRESSED'
}

/** Why a pay-link resend was not queued. */
export enum InvoiceEmailResendSuppression {
  /** The invoice has already been resent the most times allowed today. */
  DailyLimitReached = 'DAILY_LIMIT_REACHED',
  /** The customer or the order is set to never get invoice emails. */
  InvoiceEmailsOptedOut = 'INVOICE_EMAILS_OPTED_OUT',
  /** The invoice is paid in full, so there is nothing left to pay online. */
  InvoicePaid = 'INVOICE_PAID',
  /** No invoice document could be resolved to attach. */
  InvoiceReportNotConfigured = 'INVOICE_REPORT_NOT_CONFIGURED',
  /** The invoice was voided. */
  InvoiceVoided = 'INVOICE_VOIDED',
  /** No email address is on file for the invoice's order. */
  NoRecipients = 'NO_RECIPIENTS',
  /** The grower's online invoice payments are switched off, so there is no pay link to send. */
  OnlineInvoicePaymentsDisabled = 'ONLINE_INVOICE_PAYMENTS_DISABLED',
  /** The order this invoice bills could not be found. */
  OrderNotFound = 'ORDER_NOT_FOUND',
  /** A new pay link was needed and could not be made, so nothing was sent. */
  PayLinkNotMade = 'PAY_LINK_NOT_MADE'
}

/**
 * The invoice-type merge tokens an invoice email's subject and body render against, over and above
 * the order tokens every order email already carries. Money arrives pre-formatted and dates
 * pre-rendered because a raw decimal or date handed to Handlebars stringifies at whatever scale and
 * in whatever culture the process happens to carry, and that string reaches a grower's customer.
 */
export type InvoiceEmailTokens = {
  __typename?: 'InvoiceEmailTokens';
  /** The cash recorded against the invoice, N2-formatted. */
  amountPaid: Scalars['String']['output'];
  /** What the invoice still owes, N2-formatted. This is the amount to ask the customer for. */
  balance: Scalars['String']['output'];
  /** The seller's remit-to block, from the tenant's company profile. */
  company: InvoiceEmailCompanyTokens;
  /**
   * When payment is due: the invoice date plus the net-due window of the terms the invoice was issued
   * under. The same date the invoice PDF prints.
   */
  dueDate?: Maybe<Scalars['String']['output']>;
  /** The date the invoice was issued, in the report PDF date format. */
  invoiceDate: Scalars['String']['output'];
  /**
   * The invoice number: the order number on the order's first bill, and orderNumber-R1, orderNumber-R2
   * and so on for each bill raised after a previous one was withdrawn.
   */
  invoiceNumber: Scalars['String']['output'];
  /**
   * Why the invoice went out with No tax, for example Resale, as recorded when it was issued, or null
   * when it did not. The order's No tax note is never included.
   */
  noTaxReason?: Maybe<Scalars['String']['output']>;
  /**
   * Where the customer can pay this invoice online, or null when there is nowhere. The invoice's durable pay
   * URL when the grower's online invoice payments are switched on and the invoice has an active pay link —
   * the same URL its PDF encodes as a QR code — and otherwise the grower's legacy payment-portal link, when it
   * has one.
   */
  payOnlineUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The last day payOnlineUrl works, as the invoice PDF prints dates, such as "Nov 30, 2026"; null when
   * payOnlineUrl is not a link that expires: no link at all, or the grower's legacy payment-portal link. The
   * invoice email's expiry line prints only when this is set.
   */
  payOnlineUrlExpiresOn?: Maybe<Scalars['String']['output']>;
  /** Where the invoice stands as money: Unpaid, PartiallyPaid, Paid or Overpaid. */
  paymentStatus: Scalars['String']['output'];
  /**
   * The terms the invoice was issued under, as the label the invoice PDF prints, such as "Net 30" or
   * "2/10 Net 30".
   */
  paymentTerms?: Maybe<Scalars['String']['output']>;
  /**
   * What the invoice charged before any deposit credit, N2-formatted: lines, freight, flat charges and
   * the tax the invoice carries. The same figure the invoice PDF prints as its total.
   */
  totalAmount: Scalars['String']['output'];
};

export type InvoiceFlatChargeData = {
  __typename?: 'InvoiceFlatChargeData';
  amount: Scalars['Decimal']['output'];
  flatChargeTypeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: OrderFlatChargeKind;
  name: Scalars['String']['output'];
  taxable: Scalars['Boolean']['output'];
};

/**
 * One named flat charge billed on an invoice, as the invoice read model carries it. Not an invoice line:
 * its tax is inside the invoice's taxTotal and taxBreakdown only.
 */
export type InvoiceFlatChargeEntry = {
  __typename?: 'InvoiceFlatChargeEntry';
  /**
   * The QuickBooks account of the charge-list entry this charge was picked from, resolved when read, so
   * a remap of the entry is followed. Null for the system fuel surcharge, which posts to the tenant's
   * fuel surcharge account, and when the entry has no account or the account no longer exists.
   */
  account?: Maybe<MergeDevAccountDocument>;
  /** The amount billed. */
  amount: Scalars['Decimal']['output'];
  /** The charge-list entry it was picked from; none for the system fuel surcharge. */
  flatChargeTypeId?: Maybe<Scalars['String']['output']>;
  /** The charge's id on the order. */
  id: Scalars['String']['output'];
  /** Where the charge came from: a charge-list entry, or the system fuel surcharge. */
  kind: OrderFlatChargeKind;
  /** The charge's name, as copied from its entry when it was added to the order. */
  name: Scalars['String']['output'];
  /** Whether the charge was sent to Stripe Tax as taxable. */
  taxable: Scalars['Boolean']['output'];
};

/** Why one order in the request was not invoiced. */
export type InvoiceIssueFailureData = {
  __typename?: 'InvoiceIssueFailureData';
  /** The failure's stable code, for a client that branches on it. */
  code: Scalars['String']['output'];
  /** The human-readable reason. */
  message: Scalars['String']['output'];
  /** The order that was not invoiced. */
  orderId: Scalars['String']['output'];
};

export type InvoiceLateChargeWaiverData = {
  __typename?: 'InvoiceLateChargeWaiverData';
  amount: Scalars['Decimal']['output'];
  asOfDate: Scalars['DateTime']['output'];
  reason: Scalars['String']['output'];
  waivedAt: Scalars['DateTime']['output'];
  waivedBy: Scalars['String']['output'];
  waiverId: Scalars['String']['output'];
};

/** One forgiveness of an invoice's accrued finance charge, as the invoice read model carries it. */
export type InvoiceLateChargeWaiverEntry = {
  __typename?: 'InvoiceLateChargeWaiverEntry';
  /** The finance charge forgiven. Always greater than zero. */
  amount: Scalars['Decimal']['output'];
  /** The date the forgiven charge was struck as of. Later months accrue again. */
  asOfDate: Scalars['DateTime']['output'];
  /** Why it was forgiven. */
  reason: Scalars['String']['output'];
  /** The instant it was recorded. */
  waivedAt: Scalars['DateTime']['output'];
  /** The email of whoever recorded it. */
  waivedBy: Scalars['String']['output'];
  /** This waiver's identity — and the projection's dedup key. */
  waiverId: Scalars['String']['output'];
};

export type InvoiceLineData = {
  __typename?: 'InvoiceLineData';
  discountAmount: Scalars['Decimal']['output'];
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  extended: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  originalItemId?: Maybe<Scalars['String']['output']>;
  /**
   * Where this line's revenue posts, and which precedence rung decided it: customer type, then
   * this line's item, then the item's category when its mapped categories agree on one account,
   * then the tenant default, then UNMAPPED. An archived account is skipped at every rung, and
   * categories that disagree are reported rather than picked between. This is what an ITEM-detail
   * export GL-codes each product line with; a SUMMARY-detail export reads the invoice's
   * revenueAccountSummary instead. Never null, and never fails the invoice.
   */
  revenueAccount: ResolvedRevenueAccount;
  shippedQuantity: Scalars['Int']['output'];
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  taxAmount: Scalars['Decimal']['output'];
  unitPrice: Scalars['Decimal']['output'];
  units?: Maybe<Scalars['Int']['output']>;
};

/** One open invoice the backfill could not give a pay link. */
export type InvoicePayLinkBackfillFailure = {
  __typename?: 'InvoicePayLinkBackfillFailure';
  /** The failure's stable code. */
  code: Scalars['String']['output'];
  /** The invoice left without a link. */
  invoiceId: Scalars['String']['output'];
  /** The human-readable reason. */
  message: Scalars['String']['output'];
};

/** Payload returned from the pay-link backfill mutation. */
export type InvoicePayLinkBackfillPayload = {
  __typename?: 'InvoicePayLinkBackfillPayload';
  /** Populated only when the whole run was refused. */
  errors?: Maybe<Array<ValidationError>>;
  /** What the run did. */
  result?: Maybe<InvoicePayLinkBackfillResult>;
};

/** What one backfill run did for a tenant's open invoices. */
export type InvoicePayLinkBackfillResult = {
  __typename?: 'InvoicePayLinkBackfillResult';
  /** Of those, the ones that already had a pay link, active, expired or revoked. The backfill never replaces one. */
  alreadyLinked: Scalars['Int']['output'];
  /** False when the run stopped at its per-run cap with invoices still unlinked; running it again continues. */
  complete: Scalars['Boolean']['output'];
  /** Invoices this run could not link, one line each. */
  failures: Array<InvoicePayLinkBackfillFailure>;
  /** First links this run issued. */
  linksIssued: Scalars['Int']['output'];
  /** Issued invoices that still owe something. */
  openInvoices: Scalars['Int']['output'];
};

/**
 * An invoice's pay link as staff see it: the invoice it opens, whether it still opens, until when, and the URL to
 * send the customer.
 */
export type InvoicePayLinkData = {
  __typename?: 'InvoicePayLinkData';
  /** The ISO-4217 currency the invoice is billed in. */
  currency: Scalars['String']['output'];
  /** The customer that invoice bills. */
  customerId: Scalars['String']['output'];
  /** The first instant the link no longer opens: the start of the day after expiresOn in the grower's time zone. */
  expiresAt: Scalars['DateTime']['output'];
  /** The last day the link works, as the invoice email prints it. */
  expiresOn: Scalars['LocalDate']['output'];
  /** The one invoice the link opens. */
  invoiceId: Scalars['String']['output'];
  /** When the link's current token was issued. */
  issuedAt: Scalars['DateTime']['output'];
  /** Who issued the link's current token. */
  issuedBy: Scalars['String']['output'];
  /** The link's own non-secret identifier — what revokeInvoicePayLink takes. */
  payLinkId: Scalars['String']['output'];
  /**
   * The durable pay URL, /pay/ followed by the token, on the environment's public origin. Null unless the link is
   * ACTIVE, and null when the environment cannot derive it.
   */
  payUrl?: Maybe<Scalars['String']['output']>;
  /** Why the link was revoked, or null while it stands. */
  revokeReason?: Maybe<Scalars['String']['output']>;
  /** When the link was revoked, or null while it stands. */
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ACTIVE, REVOKED or EXPIRED. */
  status: InvoicePayLinkStatus;
};

/** Payload returned from the ensure and revoke pay-link mutations. */
export type InvoicePayLinkPayload = {
  __typename?: 'InvoicePayLinkPayload';
  /** Populated only when the operation was refused, in which case nothing was written. */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * Whether this call made a new link, replacing the token the customer held: true only when ensureInvoicePayLink
   * found no live link, or one with fewer than 10 days left. Always false for revokeInvoicePayLink.
   */
  newLinkMade: Scalars['Boolean']['output'];
  /** The link as it stands after the operation. */
  payLink?: Maybe<InvoicePayLinkData>;
};

/** Whether a pay link opens anything right now. */
export enum InvoicePayLinkStatus {
  /** The link opens its invoice. */
  Active = 'ACTIVE',
  /** The link passed its expiry and opens nothing. */
  Expired = 'EXPIRED',
  /** The link was revoked and opens nothing. */
  Revoked = 'REVOKED'
}

/** Payload returned from the void-invoice mutation. */
export type InvoicePayload = {
  __typename?: 'InvoicePayload';
  /** Populated only when the operation was refused. */
  errors?: Maybe<Array<ValidationError>>;
  /** The invoice as it stands after the operation. */
  invoice?: Maybe<InvoiceStateData>;
};

/** Where one invoice's share of an online payment stands. */
export enum InvoicePaymentAllocationState {
  /** The payment was recorded against the invoice; any excess is unappliedCreditAmount. */
  Applied = 'APPLIED',
  /** Nothing could be applied to the invoice; the whole share became unapplied customer credit. */
  Credited = 'CREDITED',
  /** The payment is open, clearing, or succeeded and not yet recorded against the invoice. */
  Pending = 'PENDING',
  /** The payment ended without being paid; the invoice is free to be paid again. */
  Released = 'RELEASED'
}

/** Where one online payment stands, for its return page. */
export type InvoicePaymentAttempt = {
  __typename?: 'InvoicePaymentAttempt';
  /** The payment attempt's id. */
  attemptId: Scalars['String']['output'];
  /** The ISO-4217 currency. */
  currency: Scalars['String']['output'];
  /** Each invoice's share and what became of it. */
  invoices: Array<InvoicePaymentAttemptInvoice>;
  /** Why the payment failed, when it did; otherwise null. */
  lastFailure?: Maybe<Scalars['String']['output']>;
  /**
   * OPEN (not paid yet: still open, or the payer left Checkout), PROCESSING (a bank payment is clearing; never show it
   * as paid), SUCCEEDED, FAILED, CANCELLED or EXPIRED. A browser returning from Checkout never changes it.
   */
  status: PaymentAttemptStatus;
  /** What the payer is charged. */
  total: Scalars['Decimal']['output'];
};

/** One invoice's share of an online payment, and what became of it. */
export type InvoicePaymentAttemptInvoice = {
  __typename?: 'InvoicePaymentAttemptInvoice';
  /** The cash the payment collects for this invoice. */
  allocatedAmount: Scalars['Decimal']['output'];
  /** The cash recorded against the invoice once the payment succeeded; zero until then. */
  appliedAmount: Scalars['Decimal']['output'];
  /** The early-pay discount recorded with the payment; zero until it succeeds. */
  discountApplied: Scalars['Decimal']['output'];
  /** The invoice's id. */
  invoiceId: Scalars['String']['output'];
  /** PENDING, APPLIED, CREDITED or RELEASED. */
  state: InvoicePaymentAllocationState;
  /**
   * The part of the allocation that could not be applied, because the invoice owed less by then, kept as credit for
   * the customer; zero otherwise.
   */
  unappliedCreditAmount: Scalars['Decimal']['output'];
};

/** Whether a grower can take an online payment right now, and how. */
export type InvoicePaymentAvailability = {
  __typename?: 'InvoicePaymentAvailability';
  /** Whether Silver Fern has switched online invoice payments on for the grower. */
  enabled: Scalars['Boolean']['output'];
  /**
   * The ways to pay Checkout would offer; empty while the grower's Stripe account is not ready or this invoice may not
   * be paid online.
   */
  methods: Array<InvoicePaymentMethodOption>;
  /** Whether the grower's Stripe account can take a payment. */
  ready: Scalars['Boolean']['output'];
};

/** What paying several of a customer's invoices together, in full, would cost right now. */
export type InvoicePaymentCombinedQuote = {
  __typename?: 'InvoicePaymentCombinedQuote';
  /** The ISO-4217 currency of every amount. */
  currency: Scalars['String']['output'];
  /** When the earliest of the invoices' prices stops holding. */
  expiresAt: Scalars['DateTime']['output'];
  /** Each invoice's quote, in the order they were asked for. */
  invoices: Array<InvoicePaymentQuoteLine>;
  /** When the amounts were priced. */
  quotedAt: Scalars['DateTime']['output'];
  /** The sum of the invoices' payable amounts: what one payment of them all costs. */
  total: Scalars['Decimal']['output'];
};

export type InvoicePaymentData = {
  __typename?: 'InvoicePaymentData';
  amount: Scalars['Decimal']['output'];
  discountTaken: Scalars['Decimal']['output'];
  lateChargeAssessed: Scalars['Decimal']['output'];
  method: InvoicePaymentMethod;
  note?: Maybe<Scalars['String']['output']>;
  orderReceiptExternalRemoteId?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  receivedDate: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  reversesReference?: Maybe<Scalars['String']['output']>;
  transactionRef?: Maybe<Scalars['String']['output']>;
};

/** One payment recorded against an invoice, as the invoice read model carries it. */
export type InvoicePaymentEntry = {
  __typename?: 'InvoicePaymentEntry';
  /** The payment's id in the accounting platform, once it has been created there. */
  accountingPaymentId?: Maybe<Scalars['String']['output']>;
  /** The amount received. The cash figure only. */
  amount: Scalars['Decimal']['output'];
  /** The early-pay discount the payer took. Settles the bill alongside the cash. */
  discountTaken: Scalars['Decimal']['output'];
  /** The finance charge assessed with this payment. ADDS to what the invoice is owed. */
  lateChargeAssessed: Scalars['Decimal']['output'];
  /** How the payment reached the tenant. */
  method: InvoicePaymentMethod;
  /** Free text carrying any detail the structured fields do not. */
  note?: Maybe<Scalars['String']['output']>;
  /**
   * The payment line id — the key its accounting export and sync status are stored under. Null on a
   * payment recorded before the id existed.
   */
  paymentId?: Maybe<Scalars['String']['output']>;
  /**
   * Where this payment stands with the tenant's accounting platform. NOT_APPLICABLE when the tenant has
   * no accounting integration, the payment came from the accounting platform, or it predates per-payment
   * sync; RECORDED_LOCALLY_ONLY when the platform cannot take payments or the invoice was never exported.
   */
  paymentSyncStatus: PaymentSyncStatus;
  /** When the money was received, which is not necessarily when it was recorded. */
  receivedDate: Scalars['DateTime']['output'];
  /** The instant the payment was recorded. */
  recordedAt: Scalars['DateTime']['output'];
  /** The email of whoever recorded it, or the webhook that did. */
  recordedBy: Scalars['String']['output'];
  /**
   * For a negative line, the reference of the online payment it takes cash back from, because Stripe refunded it or
   * a dispute withdrew it; its amount, discount and late charge are then negative. None for any other payment.
   */
  reversesReference?: Maybe<Scalars['String']['output']>;
  /** Where this payment sits on the invoice's stream — its identity, and the projection's dedup key. */
  streamRevision: Scalars['Long']['output'];
  /**
   * Why the payment is not in the accounting system. For FAILED_TRANSIENT and FAILED_PERMANENT, the
   * failure the export reported. For RECORDED_LOCALLY_ONLY, a plain-language cause such as: the invoice has
   * not exported yet, the invoice was imported from GP and never exports, the accounting platform cannot
   * record payments, or the payment is order-level. Null for every other status.
   */
  syncFailureReason?: Maybe<Scalars['String']['output']>;
  /**
   * The payer-side reference — a check number, or a Stripe PaymentIntent id. SHARED across a payment
   * that settles several invoices at once, which is what the payment-group read model groups on.
   */
  transactionRef?: Maybe<Scalars['String']['output']>;
};

/**
 * One remittance: every payment recorded under a single transaction reference, across every invoice it
 * settled. The answer to "what did this check cover".
 */
export type InvoicePaymentGroup = {
  __typename?: 'InvoicePaymentGroup';
  /** How many invoices the remittance settled. */
  invoiceCount: Scalars['Int']['output'];
  /** The per-invoice settlements, oldest received first. */
  lines: Array<InvoicePaymentGroupLine>;
  /**
   * When the money was received. The EARLIEST of the lines' received dates: they should all agree — one
   * payment arrives once — and taking the earliest means a later correction cannot move the date the
   * remittance is reconciled under.
   */
  receivedDate: Scalars['DateTime']['output'];
  /** The cash the remittance carried, across every invoice it settled. */
  totalAmount: Scalars['Decimal']['output'];
  /** The early-pay discount taken across the remittance. */
  totalDiscountTaken: Scalars['Decimal']['output'];
  /** The finance charge assessed across the remittance. */
  totalLateChargeAssessed: Scalars['Decimal']['output'];
  /** The payer-side reference the payments share — a check number, or a Stripe PaymentIntent id. */
  transactionRef: Scalars['String']['output'];
};

/** One invoice's share of a remittance: which invoice it settled, and by how much. */
export type InvoicePaymentGroupLine = {
  __typename?: 'InvoicePaymentGroupLine';
  /** The customer billed, joined from the invoice read model. Empty for the same reason. */
  customerId: Scalars['String']['output'];
  /** The invoice this part of the remittance settled. */
  invoiceId: Scalars['String']['output'];
  /**
   * That invoice's number, joined from the invoice read model. Empty when the invoice projection has
   * not caught up — the payment is still reported, because the money is real either way.
   */
  invoiceNumber: Scalars['String']['output'];
  /** The payment itself. */
  payment: InvoicePaymentEntry;
};

export enum InvoicePaymentMethod {
  Ach = 'ACH',
  Card = 'CARD',
  Cash = 'CASH',
  Check = 'CHECK',
  Edi = 'EDI',
  Link = 'LINK',
  Other = 'OTHER',
  Stripe = 'STRIPE'
}

/** A way to pay that hosted Checkout offers. */
export enum InvoicePaymentMethodOption {
  /** ACH Direct Debit from a US bank account. Offered only when the grower's account can take it. */
  AchDebit = 'ACH_DEBIT',
  /** A credit or debit card. */
  Card = 'CARD',
  /** Stripe Link, the payer's saved Stripe wallet. */
  Link = 'LINK'
}

/** The online payment holding an invoice: OPEN can be resumed, PROCESSING is clearing. */
export type InvoicePaymentOpenAttempt = {
  __typename?: 'InvoicePaymentOpenAttempt';
  /** The payment attempt's id, whose status customerPortalInvoicePaymentAttempt reads. */
  attemptId: Scalars['String']['output'];
  /** OPEN or PROCESSING. */
  status: PaymentAttemptStatus;
};

/**
 * What recording a payment of a given size, received on a given date, would settle beside its cash —
 * answered without recording anything.
 *
 *
 * THESE ARE THE FIGURES recordInvoicePayment WOULD APPLY, not an estimate of them. A payment
 * screen needs to show an operator what a discount and a finance charge will be BEFORE they commit, and
 * the only safe way to do that is for the preview and the mutation to be the same function of the same
 * invoice — which they are: both resolve through the one accrual rule, with no operator overrides
 * supplied. Sending these values back as overrides is neither required nor wanted; leave them out and
 * the mutation recomputes them at the instant it records.
 *
 *
 * A PREVIEW IS ADVISORY AND CAN GO STALE. It is struck on the invoice as it stands when it is asked, so
 * a payment recorded against the same invoice in between moves the answer. The mutation always
 * recomputes against the state it appends to, so a stale preview can mislead a screen but can never
 * mis-record a payment.
 */
export type InvoicePaymentPreview = {
  __typename?: 'InvoicePaymentPreview';
  /** The cash the preview was asked about — echoed back so a debounced client can match responses. */
  amount: Scalars['Decimal']['output'];
  /**
   * The early-pay discount this payment would earn: pro-rata to the cash, so a partial payment earns
   * the discount on what it settles and only a payment that closes the invoice earns the whole of it.
   * Zero once the early-pay window has closed.
   */
  discountTaken: Scalars['Decimal']['output'];
  /** The invoice the preview is for. */
  invoiceId: Scalars['String']['output'];
  /**
   * The finance charge this payment would assess, net of anything already forgiven. It ADDS to what
   * the invoice is owed rather than reducing it.
   */
  lateChargeAssessed: Scalars['Decimal']['output'];
  /**
   * Whether this payment would close the invoice — the cash plus the discount meeting or exceeding
   * what is owed once the finance charge is added on.
   */
  settles: Scalars['Boolean']['output'];
};

/** What paying one invoice in full online would cost right now, and until when that price holds. */
export type InvoicePaymentQuote = {
  __typename?: 'InvoicePaymentQuote';
  /** The ISO-4217 currency of every amount. */
  currency: Scalars['String']['output'];
  /** The early-pay discount paying in full now earns; zero once the early-pay window has closed. */
  discount: Scalars['Decimal']['output'];
  /**
   * When this price stops holding: the next moment the discount ends or the late charge grows, and never more than 24
   * hours after quotedAt. Read again after it.
   */
  expiresAt: Scalars['DateTime']['output'];
  /** The late charge paying now assesses; zero while the invoice is not past due. */
  lateCharge: Scalars['Decimal']['output'];
  /** What paying the invoice in full now costs: postedBalance plus lateCharge less discount. */
  payableAmount: Scalars['Decimal']['output'];
  /**
   * What the invoice owes from the payments and adjustments recorded against it, before any discount or late charge
   * a payment would bring.
   */
  postedBalance: Scalars['Decimal']['output'];
  /** When the amounts were priced. */
  quotedAt: Scalars['DateTime']['output'];
};

/** One invoice's line in a combined quote for several invoices. */
export type InvoicePaymentQuoteLine = {
  __typename?: 'InvoicePaymentQuoteLine';
  /** The invoice's id. */
  invoiceId: Scalars['String']['output'];
  /** The invoice number. */
  invoiceNumber: Scalars['String']['output'];
  /** What paying it in full now costs. */
  quote: InvoicePaymentQuote;
};

export enum InvoiceStanding {
  Open = 'OPEN',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Void = 'VOID'
}

export type InvoiceStateData = {
  __typename?: 'InvoiceStateData';
  adjustments: Array<InvoiceAdjustmentData>;
  amountAdjusted: Scalars['Decimal']['output'];
  amountCreditApplied: Scalars['Decimal']['output'];
  amountPaid: Scalars['Decimal']['output'];
  balance: Scalars['Decimal']['output'];
  creditsApplied: Array<InvoiceCreditApplicationData>;
  customerId: Scalars['String']['output'];
  depositApplied: Scalars['Decimal']['output'];
  depositOverage: Scalars['Decimal']['output'];
  discountTaken: Scalars['Decimal']['output'];
  dueDate: Scalars['DateTime']['output'];
  flatCharges: Array<InvoiceFlatChargeData>;
  freight: Scalars['Decimal']['output'];
  grossTotal: Scalars['Decimal']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  issuedAt: Scalars['DateTime']['output'];
  issuedBy: Scalars['String']['output'];
  lateChargeAssessed: Scalars['Decimal']['output'];
  lateChargeWaived: Scalars['Decimal']['output'];
  lateChargeWaivers: Array<InvoiceLateChargeWaiverData>;
  lines: Array<InvoiceLineData>;
  orderId: Scalars['String']['output'];
  payments: Array<InvoicePaymentData>;
  status: InvoiceStatus;
  stripeTaxCalculationId: Scalars['String']['output'];
  stripeTaxReversalTransactionId?: Maybe<Scalars['String']['output']>;
  stripeTaxTransactionId: Scalars['String']['output'];
  subtotal: Scalars['Decimal']['output'];
  taxBreakdown: Array<InvoiceTaxJurisdictionData>;
  taxDate: Scalars['DateTime']['output'];
  taxStatus: InvoiceTaxStatus;
  taxTotal: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
  terms: InvoiceTermsSnapshotData;
  total: Scalars['Decimal']['output'];
  voidReason?: Maybe<Scalars['String']['output']>;
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
  voidedBy?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceStatus {
  Issued = 'ISSUED',
  Voided = 'VOIDED'
}

export type InvoiceStatusOperationFilterInput = {
  eq?: InputMaybe<InvoiceStatus>;
  in?: InputMaybe<Array<InvoiceStatus>>;
  neq?: InputMaybe<InvoiceStatus>;
  nin?: InputMaybe<Array<InvoiceStatus>>;
};

export type InvoiceTaxJurisdictionData = {
  __typename?: 'InvoiceTaxJurisdictionData';
  amount: Scalars['Decimal']['output'];
  jurisdiction: Scalars['String']['output'];
  level: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  reason: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  taxableAmount: Scalars['Decimal']['output'];
};

export enum InvoiceTaxStatus {
  Calculated = 'CALCULATED',
  NotCalculated = 'NOT_CALCULATED',
  Unknown = 'UNKNOWN'
}

export type InvoiceTermsSnapshotData = {
  __typename?: 'InvoiceTermsSnapshotData';
  discountDays: Scalars['Int']['output'];
  discountRate: Scalars['Decimal']['output'];
  lateChargeMonthlyRate: Scalars['Decimal']['output'];
  maxAnnualRate: Scalars['Decimal']['output'];
  termLimitDays: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type InvoicesConnection = {
  __typename?: 'InvoicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InvoicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InvoiceDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InvoicesEdge = {
  __typename?: 'InvoicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InvoiceDocument;
};

export enum InvoicingMode {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  Unknown = 'UNKNOWN'
}

/**
 * MongoDB read-model document for one dead-lettered IoT ingestion message — mirrors
 * WorkSuite.Services.Share.IoTIngestion.IoTDeadLetterDocument in wsapi-services field for
 * field (see IotDeadLetterReason for why this is declared separately rather than
 * shared).
 */
export type IotDeadLetterDocument = {
  __typename?: 'IotDeadLetterDocument';
  /** UTC instant of the FIRST rejection for this pair. */
  firstOccurredAt: Scalars['DateTime']['output'];
  /** The collapse key — "{Reason}:{TransportDeviceId}" in wsapi-services. */
  id: Scalars['String']['output'];
  /** UTC instant of the most recent rejection. */
  lastOccurredAt: Scalars['DateTime']['output'];
  /**
   * How many messages have collapsed into this document — the rejection count an operator
   *             triages on.
   */
  occurrenceCount: Scalars['Long']['output'];
  /** The most recent raw body, truncated at write time — kept for forensics. */
  rawBody: Scalars['String']['output'];
  /** Why the message was rejected. */
  reason: IotDeadLetterReason;
  /**
   * The most recent human-readable detail for this (Reason, device) pair. Overwritten
   *             by each recurrence; occurrenceCount carries the history.
   */
  reasonDetail: Scalars['String']['output'];
  /** The transport device id, when the decoder got far enough to read one; empty otherwise. */
  transportDeviceId: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for one dead-lettered IoT ingestion message — mirrors
 * WorkSuite.Services.Share.IoTIngestion.IoTDeadLetterDocument in wsapi-services field for
 * field (see IotDeadLetterReason for why this is declared separately rather than
 * shared).
 */
export type IotDeadLetterDocumentFilterInput = {
  and?: InputMaybe<Array<IotDeadLetterDocumentFilterInput>>;
  /** UTC instant of the FIRST rejection for this pair. */
  firstOccurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The collapse key — "{Reason}:{TransportDeviceId}" in wsapi-services. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** UTC instant of the most recent rejection. */
  lastOccurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * How many messages have collapsed into this document — the rejection count an operator
   *             triages on.
   */
  occurrenceCount?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<IotDeadLetterDocumentFilterInput>>;
  /** The most recent raw body, truncated at write time — kept for forensics. */
  rawBody?: InputMaybe<StringOperationFilterInput>;
  /** Why the message was rejected. */
  reason?: InputMaybe<IotDeadLetterReasonOperationFilterInput>;
  /**
   * The most recent human-readable detail for this (Reason, device) pair. Overwritten
   *             by each recurrence; occurrenceCount carries the history.
   */
  reasonDetail?: InputMaybe<StringOperationFilterInput>;
  /** The transport device id, when the decoder got far enough to read one; empty otherwise. */
  transportDeviceId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for one dead-lettered IoT ingestion message — mirrors
 * WorkSuite.Services.Share.IoTIngestion.IoTDeadLetterDocument in wsapi-services field for
 * field (see IotDeadLetterReason for why this is declared separately rather than
 * shared).
 */
export type IotDeadLetterDocumentSortInput = {
  /** UTC instant of the FIRST rejection for this pair. */
  firstOccurredAt?: InputMaybe<SortEnumType>;
  /** The collapse key — "{Reason}:{TransportDeviceId}" in wsapi-services. */
  id?: InputMaybe<SortEnumType>;
  /** UTC instant of the most recent rejection. */
  lastOccurredAt?: InputMaybe<SortEnumType>;
  /**
   * How many messages have collapsed into this document — the rejection count an operator
   *             triages on.
   */
  occurrenceCount?: InputMaybe<SortEnumType>;
  /** The most recent raw body, truncated at write time — kept for forensics. */
  rawBody?: InputMaybe<SortEnumType>;
  /** Why the message was rejected. */
  reason?: InputMaybe<SortEnumType>;
  /**
   * The most recent human-readable detail for this (Reason, device) pair. Overwritten
   *             by each recurrence; occurrenceCount carries the history.
   */
  reasonDetail?: InputMaybe<SortEnumType>;
  /** The transport device id, when the decoder got far enough to read one; empty otherwise. */
  transportDeviceId?: InputMaybe<SortEnumType>;
};

/**
 * Why one IoT ingestion message was dead-lettered instead of processed — mirrors
 * WorkSuite.Services.Share.IoTIngestion.IoTDeadLetterReason in wsapi-services, the process
 * that actually writes IotDeadLetterDocument rows. Declared separately rather than shared
 * because WorkSuite.GraphQl has no project reference to wsapi-services (a different
 * repo/deployable).
 */
export enum IotDeadLetterReason {
  CountSessionRejected = 'CountSessionRejected',
  CountUnattributed = 'CountUnattributed',
  DrainReplayFailed = 'DrainReplayFailed',
  /**
   * The message decoded at the envelope level but a post-decode, pre-route validation stage rejected
   * it: the envelope seq re-check or a telemetry readings batch. Appended to the
   * writer enum by wsapi-services PR 15144.
   */
  EnvelopeValidationFailed = 'EnvelopeValidationFailed',
  MalformedPayload = 'MalformedPayload',
  UnknownDevice = 'UnknownDevice'
}

export type IotDeadLetterReasonOperationFilterInput = {
  eq?: InputMaybe<IotDeadLetterReason>;
  in?: InputMaybe<Array<IotDeadLetterReason>>;
  neq?: InputMaybe<IotDeadLetterReason>;
  nin?: InputMaybe<Array<IotDeadLetterReason>>;
};

/** A connection to a list of items. */
export type IotDeadLettersConnection = {
  __typename?: 'IotDeadLettersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<IotDeadLettersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<IotDeadLetterDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IotDeadLettersEdge = {
  __typename?: 'IotDeadLettersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: IotDeadLetterDocument;
};

/**
 * MongoDB read-model document for one flushed IoT ingestion-metrics window — mirrors
 * WorkSuite.Services.Share.IoTIngestion.IoTIngestionOpsMetricsDocument in wsapi-services field
 * for field (see IotDeadLetterReason for why this is declared separately rather than
 * shared). Append-only: wsapi-services' ingestion worker flushes one row per window on a fixed
 * cadence, ordered for this surface by windowEnd — the wsapi-admin-pwa Ingestion tab's
 * ops-metrics tiles read the most recent windows.
 */
export type IotIngestionOpsMetricsDocument = {
  __typename?: 'IotIngestionOpsMetricsDocument';
  /** Mean ingestion lag across the window's processed events, in milliseconds. */
  avgLagMs: Scalars['Float']['output'];
  /**
   * countPosted reports in this window whose absolute total moved a count session's
   *             counted quantity.
   */
  countAppliedCount: Scalars['Long']['output'];
  /**
   * countPosted reports in this window wsapi rejected for a reason that is NOT a
   *             no-op — a count session that is Paused, Completed, or otherwise not accepting counts.
   */
  countRejectedCount: Scalars['Long']['output'];
  /**
   * countPosted reports in this window from a device that resolved to no production
   *             line, or to a line with no active count session — the operator signal that somebody needs to
   *             start a session, not a loss count.
   */
  countUnattributedCount: Scalars['Long']['output'];
  /**
   * countPosted reports in this window carrying a total the session already
   *             held — a SUCCESS, expected to DOMINATE countAppliedCount whenever a line is
   *             idle.
   */
  countUnchangedCount: Scalars['Long']['output'];
  /**
   * Events dead-lettered in this window: undecodable, missing a required field, or from an
   *             unregistered serial.
   */
  deadLetterCount: Scalars['Long']['output'];
  /**
   * Events that routed but LOST the dedupe claim to an earlier delivery — a benign
   *             redelivery.
   */
  dedupeHitCount: Scalars['Long']['output'];
  /** Server-assigned snapshot id — these rows are append-only, so nothing here dereferences it. */
  id: Scalars['ObjectId']['output'];
  /** Max observed ingestion lag in the window, in milliseconds. */
  maxLagMs: Scalars['Float']['output'];
  /**
   * Events that routed and WON their dedupe claim in this window — the exactly-once
   *             processed count.
   */
  processedCount: Scalars['Long']['output'];
  /** Events from a registered but unclaimed (lobby / decommissioned) device. */
  unclaimedDeviceSkipCount: Scalars['Long']['output'];
  /** End of the flush window these counters cover, as a flat UTC BSON Date. */
  windowEnd: Scalars['DateTime']['output'];
  /** Start of the flush window these counters cover. */
  windowStart: Scalars['DateTime']['output'];
};

/** Issue the credit memo of one Credit-type order. */
export type IssueCreditMemoInput = {
  /**
   * Where to apply the memo. Omit it to apply the memo to the live invoice of the order it credits, up to what
   * that invoice owes. Name invoices to apply it to those instead; an empty list applies it nowhere. Whatever is
   * not applied stays on the customer's credit as unapplied credit.
   */
  applications?: InputMaybe<Array<CreditMemoApplicationDataInput>>;
  /** The Credit-type order. Its memo is numbered CM- and its number. */
  orderId: Scalars['String']['input'];
};

export type ItemAttributesData = {
  __typename?: 'ItemAttributesData';
  addedShippingUomIds: Array<Scalars['String']['output']>;
  commissionable: Scalars['Boolean']['output'];
  containerConfigIds: Array<Scalars['String']['output']>;
  containerConfigOverrides: Array<ItemContainerConfigOverrideData>;
  defaultCarrier?: Maybe<Scalars['String']['output']>;
  defaultShippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  defaultShippingUomId?: Maybe<Scalars['String']['output']>;
  discountable: Scalars['Boolean']['output'];
  heightInches?: Maybe<Scalars['Decimal']['output']>;
  isOrganic: Scalars['Boolean']['output'];
  lengthInches?: Maybe<Scalars['Decimal']['output']>;
  loadFactor?: Maybe<Scalars['Decimal']['output']>;
  minShipQty?: Maybe<Scalars['Int']['output']>;
  native: Scalars['Boolean']['output'];
  royalty?: Maybe<RoyaltyConfig>;
  shippingConfigCategoryCodes: Array<Scalars['String']['output']>;
  shippingIncrement?: Maybe<Scalars['Int']['output']>;
  stripeTaxCode?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  substitution?: Maybe<Substitution>;
  taxable: Scalars['Boolean']['output'];
  upgrades: Array<ItemUpgrade>;
  usedForRetail: Scalars['Boolean']['output'];
  weightLbs?: Maybe<Scalars['Decimal']['output']>;
  widthInches?: Maybe<Scalars['Decimal']['output']>;
};

/** One item's figures for a date. */
export type ItemAvailabilityByDate = {
  __typename?: 'ItemAvailabilityByDate';
  /** The date asked for; only its calendar day (UTC) counts. */
  asOf: Scalars['DateTime']['output'];
  /** On hand plus planted minus open demand; it may be negative. */
  availableBy: Scalars['Int']['output'];
  /** The item these figures are for. */
  itemId: Scalars['String']['output'];
  /** Live Goods stock on hand that is ready on or before the day; stock with no ready date counts as ready now. */
  onHandReadyBy: Scalars['Int']['output'];
  /** Open orders due on or before the day, allocated or not, leaving out drafts and the excluded order. */
  openDemandDueBy: Scalars['Int']['output'];
  /** Production on lots not yet planted that is ready on or before the day; it is not part of available by. */
  plannedReadyBy: Scalars['Int']['output'];
  /** Production on planted lots, not yet posted to stock, that is ready on or before the day. */
  plantedReadyBy: Scalars['Int']['output'];
};

/** Input for itemAvailabilityByDate. */
export type ItemAvailabilityByDateInput = {
  /** The date the figures are for, such as an order's ready-by date. Only its calendar day (UTC) counts. */
  asOf: Scalars['DateTime']['input'];
  /** Leave this order's lines out of the open demand: the order being edited. */
  excludeOrderId?: InputMaybe<Scalars['String']['input']>;
  /** 1 to 200 items. */
  itemIds: Array<Scalars['String']['input']>;
};

/** The result of itemAvailabilityByDate: the items in the order asked, or the errors. */
export type ItemAvailabilityByDatePayload = {
  __typename?: 'ItemAvailabilityByDatePayload';
  errors?: Maybe<Array<ValidationError>>;
  items?: Maybe<Array<ItemAvailabilityByDate>>;
};

/**
 * One location/grade row of ALLOCATION-AWARE availability for an item. Quantity mirrors
 * InventoryItemDocument.AvailableQuantity (the live on-hand Quantity minus
 * AllocatedQuantity, reconciled by InventoryItemProjectionService) for that exact
 * (item, location, grade) key — the same number InventoryItemQuery.GetInventoryItems /
 * GetAvailableInventory already return to the add-items dialog (worksuite-pwa PR 13016), so
 * the order-line surfaces and the add-items dialog agree.
 */
export type ItemAvailabilityByLocationData = {
  __typename?: 'ItemAvailabilityByLocationData';
  grade: Scalars['Int']['output'];
  locationId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
};

export type ItemAvailabilityDocument = {
  __typename?: 'ItemAvailabilityDocument';
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  sku: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ItemAvailabilityDocumentFilterInput = {
  and?: InputMaybe<Array<ItemAvailabilityDocumentFilterInput>>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemAvailabilityDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  recordedAt?: InputMaybe<DateTimeOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
};

export type ItemAvailabilityDocumentSortInput = {
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  recordedAt?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
};

/**
 * One grower availability photo. Reads return the collection with the primary photo first
 * so the portal can show the primary and keep the rest behind a tap.
 */
export type ItemAvailabilityPhotoData = {
  __typename?: 'ItemAvailabilityPhotoData';
  isPrimary: Scalars['Boolean']['output'];
  photoId: Scalars['String']['output'];
  photoUrl: Scalars['String']['output'];
  recordedAt: Scalars['DateTime']['output'];
};

export type ItemAvailabilityPhotoPayload = {
  __typename?: 'ItemAvailabilityPhotoPayload';
  errors?: Maybe<Array<ValidationError>>;
  photos?: Maybe<Array<ItemAvailabilityPhotoData>>;
};

export type ItemBulkActionPayload = {
  __typename?: 'ItemBulkActionPayload';
  errors?: Maybe<Array<ValidationError>>;
  items?: Maybe<Array<ItemPayload>>;
};

/** One row of an item's category assignments: the category's code plus THIS item's own eaches snapshot. Distinct from `CategoryData`, which describes the Category itself — a Category no longer has an eaches count (a Shipping UOM owns eachesPerUnit and a Category only tags one), whereas an item's assignment does, and owns it. */
export type ItemCategoryAssignmentData = {
  __typename?: 'ItemCategoryAssignmentData';
  code: Scalars['String']['output'];
  /** This item's own eaches snapshot for the assignment: the count recorded when the assignment was written. The Item owns it, not the Category, and the server derives an order line's eaches quantity — and the royalty payout — from this same snapshot. It is NOT the deprecated `eaches` on `CategoryData`, which is dead. Reports 1 when no snapshot was recorded, which only the GrowPoint staged-item echo can produce: every write path rejects an omitted eaches, so a persisted assignment always carries a real one. */
  eaches: Scalars['Int']['output'];
};

/** One row of an item's category assignments, as supplied to addItem / updateItem / importItem / mergeItem / patchItem. Distinct from `CategoryDataInput`, which addCategory / updateCategory / batchAddCategories / batchUpdateCategories take: the same `eaches` field is deprecated and IGNORED there and REQUIRED here, so the two surfaces no longer share one type. This one carries no Shipping UOM member of either spelling — the Category owns that tag, a copy on the item would go stale the moment the Category's tag changed, and it is set with addCategory / updateCategory instead. */
export type ItemCategoryAssignmentDataInput = {
  code: Scalars['String']['input'];
  /** REQUIRED on an item's category assignment, and recorded as that item's own eaches snapshot. Omitting it is REJECTED rather than defaulted, because the snapshot reaches an order line's eaches quantity and the royalty payout from there — a caller who omitted it would get a success payload for an eaches they never chose. It is nullable on the wire only so that the omission is answered by a named field error instead of by input coercion; a supplied value is still validated, so a zero or a negative is rejected. */
  eaches?: InputMaybe<Scalars['Int']['input']>;
};

/** A characteristic in the tenant's list, with its pick list, deleted entries included. */
export type ItemCharacteristicDocument = {
  __typename?: 'ItemCharacteristicDocument';
  /** The characteristic's id, unique within the tenant. It stays the same when it is renamed. */
  itemCharacteristicId: Scalars['String']['output'];
  /**
   * The name a grower gave it, such as USDA Zone. Unique within the tenant ignoring case, deleted
   * characteristics included.
   */
  name: Scalars['String']['output'];
  /**
   * Whether the tenant has put this characteristic on hold. Screens mark it "(on hold)" and still allow
   * it to be picked.
   */
  onHold: Scalars['Boolean']['output'];
  /** The characteristic's position in the tenant's list, 0 or more. Lower values come first. */
  sortOrder: Scalars['Int']['output'];
  /**
   * ACTIVE while the characteristic is in the list, DELETED after deleteItemCharacteristic. Deleted ones
   * are still returned so items that use them can name them; undeleteItemCharacteristic brings one back.
   */
  status: ItemCharacteristicStatus;
  /** The characteristic's pick list, deleted values included, ordered by sortOrder and then name. */
  values: Array<ItemCharacteristicValueDocument>;
};

/** A characteristic in the tenant's list, with its pick list, deleted entries included. */
export type ItemCharacteristicDocumentFilterInput = {
  and?: InputMaybe<Array<ItemCharacteristicDocumentFilterInput>>;
  /** The characteristic's id, unique within the tenant. It stays the same when it is renamed. */
  itemCharacteristicId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The name a grower gave it, such as USDA Zone. Unique within the tenant ignoring case, deleted
   * characteristics included.
   */
  name?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether the tenant has put this characteristic on hold. Screens mark it "(on hold)" and still allow
   * it to be picked.
   */
  onHold?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ItemCharacteristicDocumentFilterInput>>;
  /** The characteristic's position in the tenant's list, 0 or more. Lower values come first. */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  /**
   * ACTIVE while the characteristic is in the list, DELETED after deleteItemCharacteristic. Deleted ones
   * are still returned so items that use them can name them; undeleteItemCharacteristic brings one back.
   */
  status?: InputMaybe<ItemCharacteristicStatusOperationFilterInput>;
  /** The characteristic's pick list, deleted values included, ordered by sortOrder and then name. */
  values?: InputMaybe<ListFilterInputTypeOfItemCharacteristicValueDocumentFilterInput>;
};

/** A characteristic in the tenant's list, with its pick list, deleted entries included. */
export type ItemCharacteristicDocumentSortInput = {
  /** The characteristic's id, unique within the tenant. It stays the same when it is renamed. */
  itemCharacteristicId?: InputMaybe<SortEnumType>;
  /**
   * The name a grower gave it, such as USDA Zone. Unique within the tenant ignoring case, deleted
   * characteristics included.
   */
  name?: InputMaybe<SortEnumType>;
  /**
   * Whether the tenant has put this characteristic on hold. Screens mark it "(on hold)" and still allow
   * it to be picked.
   */
  onHold?: InputMaybe<SortEnumType>;
  /** The characteristic's position in the tenant's list, 0 or more. Lower values come first. */
  sortOrder?: InputMaybe<SortEnumType>;
  /**
   * ACTIVE while the characteristic is in the list, DELETED after deleteItemCharacteristic. Deleted ones
   * are still returned so items that use them can name them; undeleteItemCharacteristic brings one back.
   */
  status?: InputMaybe<SortEnumType>;
};

/**
 * The result of a characteristic or value mutation: the characteristic after the change, or the errors
 * that stopped it.
 */
export type ItemCharacteristicPayload = {
  __typename?: 'ItemCharacteristicPayload';
  errors?: Maybe<Array<ValidationError>>;
  itemCharacteristic?: Maybe<ItemCharacteristicStateData>;
};

export type ItemCharacteristicPickData = {
  __typename?: 'ItemCharacteristicPickData';
  itemCharacteristicId: Scalars['String']['output'];
  valueId: Scalars['String']['output'];
};

/** One characteristic value on an item, as the items read model holds it. */
export type ItemCharacteristicPickDocument = {
  __typename?: 'ItemCharacteristicPickDocument';
  itemCharacteristicId: Scalars['String']['output'];
  valueId: Scalars['String']['output'];
};

/** One characteristic value on an item, as the items read model holds it. */
export type ItemCharacteristicPickDocumentFilterInput = {
  and?: InputMaybe<Array<ItemCharacteristicPickDocumentFilterInput>>;
  itemCharacteristicId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemCharacteristicPickDocumentFilterInput>>;
  valueId?: InputMaybe<StringOperationFilterInput>;
};

/** A characteristic as a mutation returns it, after the change. */
export type ItemCharacteristicStateData = {
  __typename?: 'ItemCharacteristicStateData';
  /** The characteristic's id, unique within the tenant. It stays the same when it is renamed. */
  itemCharacteristicId: Scalars['String']['output'];
  /** The name a grower gave it. Unique within the tenant ignoring case, deleted ones included. */
  name: Scalars['String']['output'];
  /** Whether the tenant has put this characteristic on hold. */
  onHold: Scalars['Boolean']['output'];
  /** The characteristic's position in the tenant's list, 0 or more. Lower values come first. */
  sortOrder: Scalars['Int']['output'];
  /** ACTIVE while in the list, DELETED after deleteItemCharacteristic. */
  status: ItemCharacteristicStatus;
  /** The pick list after the change, deleted values included. */
  values: Array<ItemCharacteristicValueStateData>;
};

export enum ItemCharacteristicStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ItemCharacteristicStatusOperationFilterInput = {
  eq?: InputMaybe<ItemCharacteristicStatus>;
  in?: InputMaybe<Array<ItemCharacteristicStatus>>;
  neq?: InputMaybe<ItemCharacteristicStatus>;
  nin?: InputMaybe<Array<ItemCharacteristicStatus>>;
};

/** One value in a characteristic's pick list. */
export type ItemCharacteristicValueDocument = {
  __typename?: 'ItemCharacteristicValueDocument';
  /** The value's name, such as 5b. Unique within its characteristic ignoring case, deleted values included. */
  name: Scalars['String']['output'];
  /** Whether the tenant has put this value on hold. Pickers mark it "(on hold)" and still allow it. */
  onHold: Scalars['Boolean']['output'];
  /** The value's position in the pick list, 0 or more. Lower values come first. */
  sortOrder: Scalars['Int']['output'];
  /**
   * ACTIVE while the value is in the pick list, DELETED after deleteItemCharacteristicValue. Deleted
   * values are still returned so items that hold them can name them.
   */
  status: ItemCharacteristicStatus;
  /** The value's id, unique within its characteristic. It stays the same when it is renamed. */
  valueId: Scalars['String']['output'];
};

/** One value in a characteristic's pick list. */
export type ItemCharacteristicValueDocumentFilterInput = {
  and?: InputMaybe<Array<ItemCharacteristicValueDocumentFilterInput>>;
  /** The value's name, such as 5b. Unique within its characteristic ignoring case, deleted values included. */
  name?: InputMaybe<StringOperationFilterInput>;
  /** Whether the tenant has put this value on hold. Pickers mark it "(on hold)" and still allow it. */
  onHold?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ItemCharacteristicValueDocumentFilterInput>>;
  /** The value's position in the pick list, 0 or more. Lower values come first. */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  /**
   * ACTIVE while the value is in the pick list, DELETED after deleteItemCharacteristicValue. Deleted
   * values are still returned so items that hold them can name them.
   */
  status?: InputMaybe<ItemCharacteristicStatusOperationFilterInput>;
  /** The value's id, unique within its characteristic. It stays the same when it is renamed. */
  valueId?: InputMaybe<StringOperationFilterInput>;
};

/** A value as a mutation returns it, after the change. */
export type ItemCharacteristicValueStateData = {
  __typename?: 'ItemCharacteristicValueStateData';
  /** The value's name. Unique within its characteristic ignoring case, deleted values included. */
  name: Scalars['String']['output'];
  /** Whether the tenant has put this value on hold. */
  onHold: Scalars['Boolean']['output'];
  /** The value's position in the pick list, 0 or more. Lower values come first. */
  sortOrder: Scalars['Int']['output'];
  /** ACTIVE while in the pick list, DELETED after deleteItemCharacteristicValue. */
  status: ItemCharacteristicStatus;
  /** The value's id, unique within its characteristic. */
  valueId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ItemCharacteristicsConnection = {
  __typename?: 'ItemCharacteristicsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemCharacteristicsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemCharacteristicDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ItemCharacteristicsEdge = {
  __typename?: 'ItemCharacteristicsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemCharacteristicDocument;
};

export enum ItemCodeMatchKind {
  CapitalsDiffer = 'CAPITALS_DIFFER',
  Same = 'SAME',
  SpacesDiffer = 'SPACES_DIFFER'
}

/** One row of an item combine: both items' values and the value the combine will leave. */
export type ItemCombineField = {
  __typename?: 'ItemCombineField';
  isConflict: Scalars['Boolean']['output'];
  keepBothAllowed: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: ItemCombineFieldKind;
  label: Scalars['String']['output'];
  loserValue?: Maybe<Scalars['String']['output']>;
  resultValue?: Maybe<Scalars['String']['output']>;
  survivorValue?: Maybe<Scalars['String']['output']>;
};

export enum ItemCombineFieldKind {
  History = 'HISTORY',
  Identity = 'IDENTITY',
  Multi = 'MULTI',
  Reference = 'REFERENCE',
  Single = 'SINGLE'
}

/** How much history points at one item: counts, shown so the survivor can be chosen with care. */
export type ItemCombineHistory = {
  __typename?: 'ItemCombineHistory';
  customerItems: Scalars['Int']['output'];
  invoices: Scalars['Int']['output'];
  kits: Scalars['Int']['output'];
  orderLines: Scalars['Int']['output'];
  priceLevels: Scalars['Int']['output'];
  productionLinks: Scalars['Int']['output'];
};

export enum ItemCombinePickChoice {
  KeepBoth = 'KEEP_BOTH',
  Loser = 'LOSER',
  Survivor = 'SURVIVOR'
}

export type ItemCombinePickInput = {
  choice: ItemCombinePickChoice;
  key: Scalars['String']['input'];
};

/** What combining the loser into the survivor would do. Nothing is written to build it. */
export type ItemCombinePreview = {
  __typename?: 'ItemCombinePreview';
  conflictCount: Scalars['Int']['output'];
  fields: Array<ItemCombineField>;
  loserHistory: ItemCombineHistory;
  loserId: Scalars['String']['output'];
  loserStock: Array<ItemCombineStockRecord>;
  priceLadderConflicts: Array<ItemCombinePriceLadderConflict>;
  survivorHistory: ItemCombineHistory;
  survivorId: Scalars['String']['output'];
  survivorSuggested: Scalars['Boolean']['output'];
};

export type ItemCombinePreviewPayload = {
  __typename?: 'ItemCombinePreviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  preview?: Maybe<ItemCombinePreview>;
};

/**
 * The levels of one price group whose volume pools disagree once the two items' levels are one ladder;
 * the combine is refused until they agree.
 */
export type ItemCombinePriceLadderConflict = {
  __typename?: 'ItemCombinePriceLadderConflict';
  priceGroupId: Scalars['String']['output'];
  priceGroupName: Scalars['String']['output'];
  priceLevelIds: Array<Scalars['String']['output']>;
};

/** One stock record of the loser that blocks a combine. */
export type ItemCombineStockRecord = {
  __typename?: 'ItemCombineStockRecord';
  allocatedQuantity: Scalars['Int']['output'];
  grade: Scalars['Int']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type ItemContainerConfigOverrideData = {
  __typename?: 'ItemContainerConfigOverrideData';
  containerCode: Scalars['String']['output'];
  maxLayersPerContainer?: Maybe<Scalars['Int']['output']>;
  maxTraysPerLayer?: Maybe<Scalars['Int']['output']>;
  shipFactor?: Maybe<Scalars['Int']['output']>;
  shipIncrement?: Maybe<Scalars['Int']['output']>;
  shipMinimum?: Maybe<Scalars['Int']['output']>;
  shippingConfigCategoryCode: Scalars['String']['output'];
  siteCode: Scalars['String']['output'];
  sizeUomCode: Scalars['String']['output'];
};

/**
 * Projection-side representation of an item-level ContainerConfig override.
 * Nullable numeric fields fall back to the inherited ContainerConfig value
 * when the user did not override them.
 */
export type ItemContainerConfigOverrideDocument = {
  __typename?: 'ItemContainerConfigOverrideDocument';
  containerCode: Scalars['String']['output'];
  maxLayersPerContainer?: Maybe<Scalars['Int']['output']>;
  maxTraysPerLayer?: Maybe<Scalars['Int']['output']>;
  shipFactor?: Maybe<Scalars['Int']['output']>;
  /**
   * The multiple this item ships in on the named configuration, under the name that is replacing
   * Ship Factor. It is computed on read from the stored Ship Factor value, never stored
   * independently, so the two can never disagree.
   */
  shipIncrement?: Maybe<Scalars['Int']['output']>;
  shipMinimum?: Maybe<Scalars['Int']['output']>;
  shippingConfigCategoryCode: Scalars['String']['output'];
  siteCode: Scalars['String']['output'];
  sizeUomCode: Scalars['String']['output'];
};

/**
 * Projection-side representation of an item-level ContainerConfig override.
 * Nullable numeric fields fall back to the inherited ContainerConfig value
 * when the user did not override them.
 */
export type ItemContainerConfigOverrideDocumentFilterInput = {
  and?: InputMaybe<Array<ItemContainerConfigOverrideDocumentFilterInput>>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  maxLayersPerContainer?: InputMaybe<IntOperationFilterInput>;
  maxTraysPerLayer?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ItemContainerConfigOverrideDocumentFilterInput>>;
  shipFactor?: InputMaybe<IntOperationFilterInput>;
  /**
   * The multiple this item ships in on the named configuration, under the name that is replacing
   * Ship Factor. It is computed on read from the stored Ship Factor value, never stored
   * independently, so the two can never disagree.
   */
  shipIncrement?: InputMaybe<IntOperationFilterInput>;
  shipMinimum?: InputMaybe<IntOperationFilterInput>;
  shippingConfigCategoryCode?: InputMaybe<StringOperationFilterInput>;
  siteCode?: InputMaybe<StringOperationFilterInput>;
  sizeUomCode?: InputMaybe<StringOperationFilterInput>;
};

export type ItemContextNoteData = {
  __typename?: 'ItemContextNoteData';
  context: NoteContext;
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ItemDocumentSize = {
  __typename?: 'ItemDocumentSize';
  code: Scalars['String']['output'];
  eaches: Scalars['Int']['output'];
  uom: Scalars['Int']['output'];
};

export type ItemDocumentSizeFilterInput = {
  and?: InputMaybe<Array<ItemDocumentSizeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  eaches?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ItemDocumentSizeFilterInput>>;
  uom?: InputMaybe<IntOperationFilterInput>;
};

/**
 * A single erpId-to-itemId resolution returned by the itemIdsByErpId query.
 * Single-purpose by design (per the wsapi single-use type convention) — do not reuse for other surfaces.
 */
export type ItemErpIdPair = {
  __typename?: 'ItemErpIdPair';
  erpId: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
};

export type ItemErpIdPayload = {
  __typename?: 'ItemErpIdPayload';
  erpId: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * One group header for the Fulfill Items list pane: the group's Key (also used as the
 * where equality value when lazy-loading the group's children via the items query), a
 * display Label, and the server-computed Count of items in the group under
 * the active search. For the Status dimension the Key is the
 * canonical GraphQL enum value (e.g. ACTIVE) the status eq filter expects.
 */
export type ItemGroupBucket = {
  __typename?: 'ItemGroupBucket';
  /** Number of items in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /**
   * Raw group key — the scalar sort-category string, the item group, or (for the Status dimension)
   * the canonical enum value. Doubles as the where: { <field>: { eq: Key } } filter value
   * the items list applies when lazy-loading the group's children.
   */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for the itemListGroups resolver. Mirrors the Fulfill Items list-pane
 * group-by options so the client can render server-computed group headers instead of loading every
 * item and grouping in memory. Each value buckets on a FLAT scalar field of
 * ItemSummaryDocument (no $lookup/$unwind), so every in-scope item lands
 * in exactly one bucket and sum(count) equals the unfiltered item total.
 */
export enum ItemGroupField {
  /**
   * One bucket per distinct SortCategory (the scalar sort-category
   * string — the item's category codes joined and ordered — NOT the multi-valued
   * Categories array).
   */
  Category = 'CATEGORY',
  /** One bucket per distinct Group (the item group). */
  Group = 'GROUP',
  /** One bucket per distinct Status (item lifecycle status). */
  Status = 'STATUS'
}

/**
 * What a portal buyer last paid for one catalog item, and when. Absent (null) rather than zero when the
 * customer has never bought the item inside the lookback window — zero would read as "free".
 */
export type ItemLastOrderedData = {
  __typename?: 'ItemLastOrderedData';
  orderDate: Scalars['DateTime']['output'];
  unitPrice: Scalars['Decimal']['output'];
};

/** The rung of the matching ladder that found a candidate, strongest first. */
export enum ItemMatchRung {
  /** An active alias on the supplier's normalized description: it suggests, never decides. */
  AliasDescription = 'ALIAS_DESCRIPTION',
  /** An active alias on the supplier's normalized item id. */
  AliasExact = 'ALIAS_EXACT',
  /** The material's ERP id. */
  ErpId = 'ERP_ID',
  /** The material's name, equal to the description once both are normalized, ignoring case. */
  NameExact = 'NAME_EXACT',
  /** Every word of the description appears in the material's name or description. */
  TokenContainment = 'TOKEN_CONTAINMENT',
  /** Some words of the description appear in the material's name or description. */
  TokenOverlap = 'TOKEN_OVERLAP',
  Unknown = 'UNKNOWN',
  /** The item id on the material's own assignment to the vendor. */
  VendorItemId = 'VENDOR_ITEM_ID'
}

export type ItemPayload = {
  __typename?: 'ItemPayload';
  errors?: Maybe<Array<ValidationError>>;
  item?: Maybe<ItemStateData>;
};

/** Represents the resolved price for a single item in a bulk pricing query. */
export type ItemPriceData = {
  __typename?: 'ItemPriceData';
  itemId: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
};

/**
 * Read-only diagnostic trace of how itemPrice resolved (or failed to resolve) a price for a
 * single item at a given location, date, and quantity. Surfaced by the itemPriceExplanation
 * query so a user can see exactly why an item priced the way it did (or didn't). The engine is not
 * changed: finalPrice here always equals what itemPrice returns for identical
 * inputs — this type only explains that number, it never alters it.
 */
export type ItemPriceExplanation = {
  __typename?: 'ItemPriceExplanation';
  /**
   * Levels in the resolved group targeting THIS item or one of its categories, each annotated with
   * why it did or didn't apply.
   */
  candidateLevels: Array<ExplainedLevel>;
  /**
   * Present exactly when the price came from the group's WHOLE-GROUP derivation ("this group =
   * group X minus N%") rather than from any of the group's own levels — i.e. exactly when
   * Outcome is PricedByDerivation. Carries the
   * reference group, the percentage, what the reference itself resolved to (and which of ITS levels
   * won), and the derived result, so the derivation is fully transparent without the caller
   * re-deriving it. None whenever the group's own levels priced the item, or nothing priced it.
   */
  derivation?: Maybe<DerivedPriceExplanation>;
  /**
   * The internal resolution error text — surfaced here instead of being swallowed to 0 by
   * itemPrice — or None when no error occurred.
   */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * The resolved charge price. Always equal to what itemPrice returns for identical inputs
   * (0 when nothing priced, including the error and no-group cases).
   */
  finalPrice: Scalars['Decimal']['output'];
  /**
   * The quantity the money path would multiply unitPriceExact by, and the two
   * numbers it is chosen from. See ExplainedLineBasis.
   */
  lineBasis: ExplainedLineBasis;
  /**
   * The missing price setup behind outcome, or null. ITEM_NO_PRICE_LEVEL on the item, fixed
   * at priceGroup, when the outcome is NO_LEVELS_FOR_ITEM or NO_LEVEL_MATCHES;
   * SHIP_TO_NO_PRICE_GROUP on the ship-to when it is NO_PRICE_GROUP and the ship-to has that
   * warning; null for every other outcome and always null in a tenant that prices through its ERP. Read off
   * the outcome only, never off the price. Advisory: it changes no number. Null when the lookup cannot be
   * read; it never fails the explanation.
   */
  missingData?: Maybe<MissingDataFinding>;
  /** The single, distinguishable reason this item did or did not price. */
  outcome: PriceResolutionOutcome;
  /**
   * The volume pool this line was priced in, resolved from the pool registry by id so its code
   * and name are always current. Null on every catalog call — the pool is a fact about an ORDER,
   * so it is populated only when orderId and lineItemId were supplied and the
   * tenant has pooled pricing enabled — null when the line is in no pool (see
   * unpooledReason), and null when the referenced pool cannot be found.
   */
  pool?: Maybe<VolumePool>;
  /**
   * The quantity this line was PRICED AT — the summed basis eaches of every line counting toward
   * volumePoolId, in eaches (Ruling 3) and on the basis the order's status bills
   * (Ruling 2). This is the number the rung thresholds in candidateLevels were
   * compared against, which is why they can report APPLIED for a threshold far above this
   * line's own quantity.
   *
   * None whenever volumePoolId is None. Present with a pool, always: a pooled line
   * is always priced at SOME quantity, even one that reaches no break.
   */
  pooledQuantity?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The price group resolution landed on (id, name, hierarchy source), or None when no group was
   * found or resolution errored before a group could be resolved.
   */
  priceGroup?: Maybe<ResolvedPriceGroup>;
  /**
   * The qualification conditions configured on the group that WAS used (priceGroup),
   * echoed so a reader can see the rule the order satisfied, not only the rules it failed. None
   * when the used group carries no conditions — which is every group that predates this feature,
   * and the case where a UI should show nothing at all rather than an empty condition card.
   */
  qualificationConditions?: Maybe<ExplainedQualificationConditions>;
  /**
   * The rung the pool's own ladder earned at pooledQuantity.
   *
   * Present only when the earned rung actually came from the ladder that supplied the pool.
   * A group whose date-eligible rungs are all unresolvable PercentOff still owns the ladder — so
   * the line reports that ladder's pool — while the price falls through to the group's whole-group
   * derivation and is set by a rung in a DIFFERENT group. Reporting that rung here would present
   * two unrelated ladders as one and tell a grower they earned a break they did not. In that case
   * this is None and outcome is PRICED_BY_DERIVATION with
   * derivation carrying the real account of the price.
   *
   *
   * Also None when the line is unpooled, when its price is pinned by an override
   * (unpooledReason says so), and when no rung resolved at the pooled quantity at
   * all.
   */
  rungChosen?: Maybe<ExplainedRung>;
  /**
   * Levels in the resolved group targeting OTHER items (the near-duplicate hint). Each carries
   * DIFFERENT_TARGET and includes its targetName so a user can spot
   * a level configured on a near-identical item.
   */
  siblingLevels: Array<ExplainedLevel>;
  /**
   * Every price group the QUALIFICATION walk offered and rejected on the way to
   * priceGroup, in the order it tried them, each with the reason and the numbers
   * behind it. Empty for the ordinary case — a tenant with no conditional groups, or an order
   * that qualifies for the first group offered.
   *
   * This is what the price would have been resolved from and was not, so it is the half of
   * the trace a grower's "why didn't I get the early-order price" question is actually about. The
   * entries come from the SAME walk that decided the price
   * (the same qualification walk that decided the price), not from a re-evaluation here — the reason,
   * the localized placed day, and the lead time it counted are carried out of that walk.
   *
   *
   * It describes the rules AS THEY ARE CONFIGURED NOW (decision C, Kevin 2026-08-20). No
   * per-line pricing receipt is stored anywhere in FULFILL, so this cannot and does not claim to
   * restate what an already-charged line was charged under: a cutoff edited since the order was
   * placed changes what this returns. Any UI rendering it must say so.
   */
  skippedPriceGroups: Array<SkippedPriceGroupExplanation>;
  /**
   * The tenant's price CALCULATION precision in effect for this resolution
   * (default 2) — how many decimals a derived or
   * percent-off price was rounded to on its way to unitPriceExact. Not a DISPLAY
   * setting: display rounding is cents everywhere and is unchanged.
   */
  unitPriceDecimals: Scalars['Int']['output'];
  /**
   * The resolved unit price at FULL precision — the number the money path multiplies the line
   * quantity by, before any display rounding.
   *
   * The same number as finalPrice, restated deliberately. A tenant on a
   * sub-cent calc precision (DHG: 10 decimals) is charged 0.4953984 per unit while every display
   * in the product rounds it to $0.50, so a broker reconciling "100 x $0.50 = $49.54" files a
   * dispute against arithmetic that is in fact correct (Kevin, 2026-08-21). Answering that needs
   * the exact multiplicand, its precision, and the quantity it was multiplied by to be readable as
   * ONE receipt; finalPrice's contract is agreement with itemPrice, and a
   * caller formatting it as money has no signal that rounding it destroys the answer. This field's
   * name is that signal. It is an echo, never a second computation — nothing here re-derives or
   * re-rounds anything.
   */
  unitPriceExact: Scalars['Decimal']['output'];
  /**
   * Why this line receives no pooled price, or None for an ordinary pooled line. The reason comes
   * verbatim from the pricing kernel's own membership decision, never from a second reading of the
   * rules here (invariant I18).
   *
   * OVERRIDE_PRICE is the one value that appears BESIDE a present
   * volumePoolId: such a line counts toward its pool — the goods are on the order —
   * while its own price stays pinned to what the operator typed. The other three
   * (NO_POOL, CUSTOMER_DISABLED, NOT_DISCOUNTABLE) each mean the line is in
   * no pool at all, and pooledQuantity is then None.
   *
   *
   * None also when no order context was supplied. A caller that asked WITHOUT orderId
   * already knows it asked a catalog question.
   */
  unpooledReason?: Maybe<UnpooledReason>;
  /**
   * The volume pool this line was priced in (FULFILL Pooled Pricing), or None. Carries the pool's
   * ID only; the pool itself is resolved from the registry at query time by
   * ItemPriceExplanationVolumePoolResolvers.pool, because pool names change on rename
   * (decision D5).
   *
   * None on every catalog call — the pool is a fact about an ORDER, so it is populated only when
   * the caller supplies orderId and lineItemId. Also None when the line is in no pool, which
   * unpooledReason then explains.
   */
  volumePoolId?: Maybe<Scalars['String']['output']>;
  /** The price level whose grower sell price was charged, or None when nothing applied. */
  winningLevelId?: Maybe<Scalars['String']['output']>;
};

export type ItemPriceInput = {
  containerQuantity: Scalars['Int']['input'];
  endDate: Scalars['DateTime']['input'];
  erpItemId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  unitPrice: Scalars['Decimal']['input'];
};

/**
 * Flattened row for the Items page Pricing tab: a PriceLevel targeting the item
 * (directly or via one of its categories), joined with its parent PriceGroup
 * and the target's display name.
 */
export type ItemPriceLevelRow = {
  __typename?: 'ItemPriceLevelRow';
  /** Customer sell price override for this price level; null to fall back to default. */
  customerSellPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Effective end date of the price level; null for open-ended. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Grower cost for this price level; null when not configured. */
  growerCost?: Maybe<Scalars['Decimal']['output']>;
  /** Grower sell price for this price level. */
  growerSellPrice: Scalars['Decimal']['output'];
  /** Fixed $/unit (default) vs percentage-off-a-reference-group. See PriceKind. */
  kind: PriceKind;
  /** Percentage discount value (4 = 4%); null for Fixed levels. */
  percentOff?: Maybe<Scalars['Decimal']['output']>;
  /** Identifier of the parent PriceGroup. */
  priceGroupId: Scalars['String']['output'];
  /** Display name of the parent PriceGroup; empty string if the group is missing. */
  priceGroupName: Scalars['String']['output'];
  /** Identifier of the PriceLevel row. */
  priceLevelId: Scalars['String']['output'];
  /** Minimum quantity required to trigger this price level. */
  quantityThreshold: Scalars['Decimal']['output'];
  /** The price group this level discounts off of; null for Fixed levels. */
  referencePriceGroupId?: Maybe<Scalars['String']['output']>;
  /** Effective start date of the price level. */
  startDate: Scalars['DateTime']['output'];
  /**
   * Target identifier. An item id when Type is TargetType.Item. When Type is
   * TargetType.Category, the category's guid.
   */
  targetId: Scalars['String']['output'];
  /**
   * Resolved display name for the target — the item's Name for item targets, the category Code
   * for category targets. Empty string when the referenced target is missing or soft-deleted.
   */
  targetName: Scalars['String']['output'];
  /**
   * Whether the PriceLevel targets an individual item or a category.
   * Determines how TargetId and TargetName are interpreted.
   */
  type: TargetType;
  /**
   * The volume pool this level belongs to, or null when it prices on its own line quantity alone.
   * Resolved from the pool registry by id, so the code and name are always current, and null also
   * when the referenced pool cannot be found.
   */
  volumePool?: Maybe<VolumePool>;
  /**
   * The id of the volume pool this level belongs to; null when the level prices on its own line
   * quantity alone. The pool's code and name are on the volumePool field, resolved from the registry.
   */
  volumePoolId?: Maybe<Scalars['String']['output']>;
};

/**
 * Payload returned by the GetItemPrices bulk pricing query.
 * Contains either a list of item prices or validation errors.
 */
export type ItemPricesPayload = {
  __typename?: 'ItemPricesPayload';
  errors?: Maybe<Array<ValidationError>>;
  itemPrices?: Maybe<Array<ItemPriceData>>;
};

/**
 * Read-model document for one sales item's production mapping, keyed {tenantId}-{salesItemId}. The
 * composite _id embeds the tenant, so per-item reads filter on _id and cannot leak across tenants
 * (discipline acada0ab), and the id is cheap to compute from a (tenant, salesItemId) pair — the shape
 * W9 (Generate Forecast) and W17 (To PRODUCE export) join against. Taxonomy is never copied onto the
 * lines; each line carries only ProductionItemId and is enriched from the native ProductionItems
 * catalog at query time (W5).
 */
export type ItemProductionMappingDocument = {
  __typename?: 'ItemProductionMappingDocument';
  id: Scalars['String']['output'];
  lines: Array<ItemProductionMappingLineDocument>;
  /**
   * The combined item whose mapping an item combine gave this sales item; null once any other save
   * replaces the lines.
   */
  originalItemId?: Maybe<Scalars['String']['output']>;
  salesItemId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * One mapping line of an item's production mapping. The optional ISO week window is stored as flat
 * nullable endpoints (all four set together or none); an empty regions list means all regions. The
 * production item taxonomy is resolved from the native catalog at query time, not stored on the line.
 */
export type ItemProductionMappingLineDocument = {
  __typename?: 'ItemProductionMappingLineDocument';
  endIsoWeek?: Maybe<Scalars['Int']['output']>;
  endIsoYear?: Maybe<Scalars['Int']['output']>;
  mixPct: Scalars['Decimal']['output'];
  /**
   * Resolves this mapping line's production item taxonomy from the native ProductionItems catalog,
   * batched and scoped to the calling tenant. Null when the referenced production item no longer exists.
   */
  productionItem?: Maybe<ProductionItemCatalogEntry>;
  productionItemId: Scalars['String']['output'];
  regions: Array<Scalars['String']['output']>;
  startIsoWeek?: Maybe<Scalars['Int']['output']>;
  startIsoYear?: Maybe<Scalars['Int']['output']>;
};

export type ItemProductionMappingLineStateData = {
  __typename?: 'ItemProductionMappingLineStateData';
  endIsoWeek?: Maybe<Scalars['Int']['output']>;
  endIsoYear?: Maybe<Scalars['Int']['output']>;
  mixPct: Scalars['Decimal']['output'];
  productionItemId: Scalars['String']['output'];
  regions: Array<Scalars['String']['output']>;
  startIsoWeek?: Maybe<Scalars['Int']['output']>;
  startIsoYear?: Maybe<Scalars['Int']['output']>;
};

export type ItemProductionMappingPayload = {
  __typename?: 'ItemProductionMappingPayload';
  errors?: Maybe<Array<ValidationError>>;
  mapping?: Maybe<ItemProductionMappingStateData>;
};

/**
 * GraphQL output shape returned by the setItemProductionMappings mutation: the item's full
 * mapping set after the command applied. Mirrors the aggregate state.
 */
export type ItemProductionMappingStateData = {
  __typename?: 'ItemProductionMappingStateData';
  lines: Array<ItemProductionMappingLineStateData>;
  salesItemId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ItemProgramDocument = {
  __typename?: 'ItemProgramDocument';
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  program: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type ItemProgramDocumentFilterInput = {
  and?: InputMaybe<Array<ItemProgramDocumentFilterInput>>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemProgramDocumentFilterInput>>;
  program?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type ItemProgramDocumentSortInput = {
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  program?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ItemProgramsConnection = {
  __typename?: 'ItemProgramsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemProgramsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemProgramDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ItemProgramsEdge = {
  __typename?: 'ItemProgramsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemProgramDocument;
};

/** How one supplier line resolved to the vendor's materials. */
export enum ItemResolveOutcome {
  /** Exactly one material, sure enough to take without asking. */
  Auto = 'AUTO',
  /** Candidates a person must choose between, the suggested one first. */
  Review = 'REVIEW',
  Unknown = 'UNKNOWN',
  /** Nothing scored high enough to suggest; any material that scored at all is still listed. */
  Unmatched = 'UNMATCHED'
}

export type ItemRestockMetricsData = {
  __typename?: 'ItemRestockMetricsData';
  allocated: Scalars['Int']['output'];
  allocatedValue: Scalars['Decimal']['output'];
  available: Scalars['Int']['output'];
  availableValue: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

/**
 * An inventory row's item-rung Shipping UOM for the staff FULFILL surface: the code and display
 * name a caller with no configCategories access cannot resolve for itself, together with
 * the eaches-per-unit count.
 */
export type ItemShippingUomData = {
  __typename?: 'ItemShippingUomData';
  code: Scalars['String']['output'];
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
};

/**
 * A single sku-to-itemId resolution returned by the itemIdsBySku query.
 * Single-purpose by design (per the wsapi single-use type convention); do not reuse for other surfaces.
 */
export type ItemSkuPair = {
  __typename?: 'ItemSkuPair';
  itemId: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

/**
 * Per-row failure surfaced by validateItemsDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the
 * underlying ValidationError implements IFieldValidationError,
 * otherwise null.
 */
export type ItemStagedRowError = {
  __typename?: 'ItemStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type ItemStateData = {
  __typename?: 'ItemStateData';
  attributes: ItemAttributesData;
  availability: Array<InventoryAvailabilityData>;
  batchTracked: Scalars['Boolean']['output'];
  /** @deprecated An item's category assignment is not a Category: it carries this item's own eaches snapshot and never a Shipping UOM tag. Read `categoryAssignments` instead, which is the same rows on a type of their own. This field is kept, still populated, for the one release the worksuite-pwa bundle cut on 2026-08-30 stays cached in browsers, and is removed after that; `CategoryData.eaches` cannot be dropped until then. */
  categories: Array<CategoryData>;
  /** This item's category assignments: the category code plus the eaches snapshot THIS item recorded, which the server derives an order line's eaches quantity and the royalty payout from. The same rows as the deprecated `categories` field, on a type of their own — so that a Category shedding its dead `eaches` cannot take this snapshot with it. It carries no Shipping UOM of either spelling: the Category owns that tag. */
  categoryAssignments: Array<ItemCategoryAssignmentData>;
  characteristics: Array<ItemCharacteristicPickData>;
  cogs?: Maybe<Scalars['Decimal']['output']>;
  defaultTagColorId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  genus: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  incomeGlAccountId?: Maybe<Scalars['String']['output']>;
  itemGroup: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemLookupCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Array<ItemContextNoteData>;
  priceLabelId?: Maybe<Scalars['String']['output']>;
  productGroup: Scalars['String']['output'];
  programs: Array<Scalars['String']['output']>;
  /** @deprecated Pricing managed via price groups. Will be removed in a future release. */
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  sku: Scalars['String']['output'];
  status: ItemStatus;
  tagColorLocked: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export enum ItemStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ItemStatusOperationFilterInput = {
  eq?: InputMaybe<ItemStatus>;
  in?: InputMaybe<Array<ItemStatus>>;
  neq?: InputMaybe<ItemStatus>;
  nin?: InputMaybe<Array<ItemStatus>>;
};

/**
 * HotChocolate join resolver that inlines the linked MergeDevAccountDocument
 * onto ItemSummaryDocument for the item's QuickBooks Income mapping. Returns
 * null when the id is unset or when the referenced account is missing from the
 * read model — the GraphQL field is nullable so the unset case is observable to clients.
 * Re-key (Helm 5c56fe08): the stored FK is the target account's stable ImportId
 * (the Merge.dev document id), so the lookup goes through the shared
 * MergeDevAccountsByImportId DataLoader keyed on (TenantId, ImportId) — the
 * mapping therefore survives the account being deleted and recreated under a new random
 * internal id. The tenant-scoped key keeps a batch from leaking one tenant's account to
 * another.
 */
export type ItemSummaryDocument = {
  __typename?: 'ItemSummaryDocument';
  /** ERP ids of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedErpIds: Array<Scalars['String']['output']>;
  /**
   * Ids of the items this item absorbed, in combine order, including the items each of those had
   * itself absorbed.
   */
  absorbedItemIds: Array<Scalars['String']['output']>;
  /** Lookup codes of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedLookupCodes: Array<Scalars['String']['output']>;
  /** SKUs of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedSkus: Array<Scalars['String']['output']>;
  /** UPCs of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedUpcs: Array<Scalars['String']['output']>;
  /**
   * Shipping UOM ids (ConfigCategoryId) this item added to its available set, on top of what its
   * categories tag. Inherited ids are not included.
   */
  addedShippingUomIds: Array<Scalars['String']['output']>;
  /**
   * This item's stock by ready date: stock with no ready date first, then one bucket per ready date in
   * ascending order. Empty when no stock matches. Null for a staff caller, or when the tenant's portal
   * settings cannot be read.
   */
  availabilityByReadyDate?: Maybe<Array<PortalReadyDateBucket>>;
  /**
   * The quantity of this item ready now: stock with no ready date or a ready date on or before the tenant's
   * local today, netted across locations. Null for a staff caller, or when the tenant's portal settings
   * cannot be read.
   */
  availableNowQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * Available quantity as the customer portal catalog computes it from the inventory ledger. Not
   * maintained on the stored item: read anywhere else it is a frozen value from retired
   * availability counts, or null.
   */
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * Everything this item may be shipped as: inheritedShippingUomIds followed by
   * addedShippingUomIds, de-duplicated. This is the set a customer-item override and an
   * order line's Shipping UOM pick are both constrained to.
   */
  availableShippingUomIds: Array<Scalars['String']['output']>;
  batchTracked: Scalars['Boolean']['output'];
  categories?: Maybe<Array<Scalars['String']['output']>>;
  characteristics: Array<ItemCharacteristicPickDocument>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value, distinct from the (removed-from-this-surface)
   * QuickBooks GL account this cost used to book to.
   */
  cogs?: Maybe<Scalars['Decimal']['output']>;
  /** When the item was combined into combinedIntoItemId. */
  combinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who combined the item into combinedIntoItemId. */
  combinedBy?: Maybe<Scalars['String']['output']>;
  /** The item this one was combined into. Null for an item that stands on its own. */
  combinedIntoItemId?: Maybe<Scalars['String']['output']>;
  commissionable: Scalars['Boolean']['output'];
  containerConfigIds: Array<Scalars['String']['output']>;
  /**
   * Item-level ContainerConfig overrides. Populated by the item projection
   * from ItemContainerConfigOverrideSet and
   * ItemContainerConfigOverrideCleared events. Nullable numeric fields
   * on each entry fall back to the inherited ContainerConfig value when the
   * user did not override them.
   */
  containerConfigOverrides: Array<ItemContainerConfigOverrideDocument>;
  /**
   * This portal customer's effective Shipping UOM for the item: this customer's active override
   * when their customer item names one, otherwise the item's own effective pick — the same rule
   * staff's effective Shipping UOM applies, published here with the code and display name a
   * portal client cannot look up itself. Null when nothing in the chain names a Shipping UOM, and
   * null for every staff (non-portal) caller: this field is shared with the staff items
   * query, where there is no customer whose override it could mean.
   */
  customerEffectiveShippingUom?: Maybe<CustomerEffectiveShippingUomData>;
  /**
   * The signed-in customer's Pre-pricing standing for this catalog row: current, last, promo,
   * afterPromo and scheduledStanding, plus the baselineToken to send back with a retail price save.
   * Null when the tenant's Pre-pricing setting is off, for any caller who is not a portal customer,
   * or when this customer has no Active customer-level record for the item.
   */
  customerRetailPrice?: Maybe<CustomerRetailPrice>;
  defaultCarrier?: Maybe<Scalars['String']['output']>;
  /**
   * The charges a new order line for this item will carry for the signed-in customer, each with its
   * name and pricing. Empty for any caller who is not a portal customer, and when nothing applies.
   * Advisory: the order applies its own charges when the line is added.
   */
  defaultCharges: Array<PortalItemCharge>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  /**
   * The item's own default Shipping UOM pick (ConfigCategoryId). Null means the item made no
   * pick and its category's tag is the default.
   */
  defaultShippingUomId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  discountable: Scalars['Boolean']['output'];
  /**
   * Eaches in one unit of effectiveShippingUomId. Null means UNSTATED — never zero, never
   * one. It is null when no Shipping UOM won, and also when the winning one has never stated a
   * count; a caller that substitutes a number for either invents a quantity nothing configured.
   */
  effectiveEachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The Shipping UOM this item ships as by default: its own defaultShippingUomId when it
   * picked one, otherwise the first id in inheritedShippingUomIds. Null when neither the
   * item nor any category it sits in names one.
   */
  effectiveShippingUomId?: Maybe<Scalars['String']['output']>;
  /**
   * Which rung supplied effectiveShippingUomId: the item's own pick (ITEM), a
   * category tag (CATEGORY), or nothing (NONE). An item that picks the very id it
   * inherits reports ITEM — an explicit pick is an assignment — so this cannot be inferred
   * by comparing the id against inheritedShippingUomIds. CUSTOMER_ITEM never appears
   * here.
   */
  effectiveShippingUomSource: ShippingUomSource;
  erpId: Scalars['String']['output'];
  /** Names of the absorbed items, index-aligned with absorbedItemIds. */
  formerNames: Array<Scalars['String']['output']>;
  genus: Scalars['String']['output'];
  group: Scalars['String']['output'];
  heightInches?: Maybe<Scalars['Decimal']['output']>;
  history: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  incomeGlAccount?: Maybe<MergeDevAccountDocument>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: Maybe<Scalars['String']['output']>;
  /**
   * The Shipping UOM ids this item inherits from the categories it is assigned to, in the item's
   * own category-assignment order — not alphabetical. A category that is deleted, or that tags no
   * Shipping UOM, contributes nothing. The item cannot remove these.
   */
  inheritedShippingUomIds: Array<Scalars['String']['output']>;
  isOrganic: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  itemLookupCode: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The unit price this customer last transacted for this item and the date of that order, so a trade
   * buyer can compare it against the price being shown now. Sourced from order history — the number
   * actually charged — not by re-resolving a price rule, because FULFILL™ pricing is price-level based
   * with no base price, so a re-resolved figure is today's answer rather than what they paid.
   *
   * Null for an item this customer has not bought inside the configured lookback window, and null for
   * any caller that is not a portal customer: ItemSummaryDocument is shared with the staff
   * items query, where there is no customer whose history this could mean.
   *
   * Resolution is batched — one aggregation per page of items, never per item.
   */
  lastOrdered?: Maybe<ItemLastOrderedData>;
  lengthInches?: Maybe<Scalars['Decimal']['output']>;
  loadFactor?: Maybe<Scalars['Decimal']['output']>;
  minShipQty?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Nursery-sense native plant species flag. Default false, no backfill (Helm 6a93ebe7). */
  native: Scalars['Boolean']['output'];
  /**
   * This item's photo gallery, primary first, for a portal buyer. Empty when the item has no photo.
   * The tenant is read from the caller's token, never from the item row or an argument.
   */
  portalPhotos?: Maybe<Array<PortalItemPhoto>>;
  /**
   * The price label each plant of this item is charged when the signed-in customer has a retail price
   * for it. Null for any caller who is not a portal customer, when the tenant's Pre-pricing setting is
   * off, or when the tenant has no price labels.
   */
  priceLabel?: Maybe<PortalItemPriceLabel>;
  productGroup: Scalars['String']['output'];
  programs?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Earliest InventoryItem ledger ready date for this item (Helm 5d559558), joined into the
   * portal catalog aggregate alongside availableQuantity — never a stored field, so it reads
   * null outside customerPortalItems, and null there when no matching InventoryItem row
   * carries a ready date.
   */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * ISO 8601 week (1–53) derived from readyDate on read; never stored independently;
   * null when there is no ready date.
   */
  readyWeek?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Pricing managed via price groups. Will be removed in a future release. */
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  royalty?: Maybe<RoyaltyConfigDocument>;
  /** @deprecated Use RetailPrice instead. */
  sellPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Shipping-config category codes the item participates in. */
  shippingConfigCategoryCodes: Array<Scalars['String']['output']>;
  shippingIncrement?: Maybe<Scalars['Int']['output']>;
  sizes?: Maybe<Array<ItemDocumentSize>>;
  sku: Scalars['String']['output'];
  sortCategory?: Maybe<Scalars['String']['output']>;
  status: ItemStatus;
  /**
   * The Stripe product tax code a taxable sale of this item is sent to Stripe Tax under. Null means the
   * item carries none, so the seller's Stripe Tax default applies. A non-taxable item is always sent as
   * Nontaxable, whatever its code.
   */
  stripeTaxCode?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  substitution?: Maybe<SubstitutionDocument>;
  taxable: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
  usedForRetail: Scalars['Boolean']['output'];
  weightLbs?: Maybe<Scalars['Decimal']['output']>;
  widthInches?: Maybe<Scalars['Decimal']['output']>;
};

export type ItemSummaryDocumentFilterInput = {
  /** ERP ids of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedErpIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Ids of the items this item absorbed, in combine order, including the items each of those had
   * itself absorbed.
   */
  absorbedItemIds?: InputMaybe<ListStringOperationFilterInput>;
  /** Lookup codes of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedLookupCodes?: InputMaybe<ListStringOperationFilterInput>;
  /** SKUs of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedSkus?: InputMaybe<ListStringOperationFilterInput>;
  /** UPCs of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedUpcs?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Shipping UOM ids (ConfigCategoryId) this item added to its available set, on top of what its
   * categories tag. Inherited ids are not included.
   */
  addedShippingUomIds?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<ItemSummaryDocumentFilterInput>>;
  /**
   * Available quantity as the customer portal catalog computes it from the inventory ledger. Not
   * maintained on the stored item: read anywhere else it is a frozen value from retired
   * availability counts, or null.
   */
  availableQuantity?: InputMaybe<IntOperationFilterInput>;
  batchTracked?: InputMaybe<BooleanOperationFilterInput>;
  categories?: InputMaybe<ListStringOperationFilterInput>;
  characteristics?: InputMaybe<ListFilterInputTypeOfItemCharacteristicPickDocumentFilterInput>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value, distinct from the (removed-from-this-surface)
   * QuickBooks GL account this cost used to book to.
   */
  cogs?: InputMaybe<DecimalOperationFilterInput>;
  /** When the item was combined into combinedIntoItemId. */
  combinedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Who combined the item into combinedIntoItemId. */
  combinedBy?: InputMaybe<StringOperationFilterInput>;
  /** The item this one was combined into. Null for an item that stands on its own. */
  combinedIntoItemId?: InputMaybe<StringOperationFilterInput>;
  commissionable?: InputMaybe<BooleanOperationFilterInput>;
  containerConfigIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Item-level ContainerConfig overrides. Populated by the item projection
   * from ItemContainerConfigOverrideSet and
   * ItemContainerConfigOverrideCleared events. Nullable numeric fields
   * on each entry fall back to the inherited ContainerConfig value when the
   * user did not override them.
   */
  containerConfigOverrides?: InputMaybe<ListFilterInputTypeOfItemContainerConfigOverrideDocumentFilterInput>;
  defaultCarrier?: InputMaybe<StringOperationFilterInput>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: InputMaybe<StringOperationFilterInput>;
  /**
   * The item's own default Shipping UOM pick (ConfigCategoryId). Null means the item made no
   * pick and its category's tag is the default.
   */
  defaultShippingUomId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  discountable?: InputMaybe<BooleanOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  /** Names of the absorbed items, index-aligned with absorbedItemIds. */
  formerNames?: InputMaybe<ListStringOperationFilterInput>;
  genus?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  heightInches?: InputMaybe<DecimalOperationFilterInput>;
  history?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: InputMaybe<StringOperationFilterInput>;
  isOrganic?: InputMaybe<BooleanOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemLookupCode?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  lengthInches?: InputMaybe<DecimalOperationFilterInput>;
  loadFactor?: InputMaybe<DecimalOperationFilterInput>;
  minShipQty?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  /** Nursery-sense native plant species flag. Default false, no backfill (Helm 6a93ebe7). */
  native?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ItemSummaryDocumentFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  programs?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Earliest InventoryItem ledger ready date for this item (Helm 5d559558), joined into the
   * portal catalog aggregate alongside availableQuantity — never a stored field, so it reads
   * null outside customerPortalItems, and null there when no matching InventoryItem row
   * carries a ready date.
   */
  readyDate?: InputMaybe<LocalDateOperationFilterInput>;
  /**
   * ISO 8601 week (1–53) derived from readyDate on read; never stored independently;
   * null when there is no ready date.
   */
  readyWeek?: InputMaybe<IntOperationFilterInput>;
  retailPrice?: InputMaybe<DecimalOperationFilterInput>;
  royalty?: InputMaybe<RoyaltyConfigDocumentFilterInput>;
  sellPrice?: InputMaybe<DecimalOperationFilterInput>;
  /** Shipping-config category codes the item participates in. */
  shippingConfigCategoryCodes?: InputMaybe<ListStringOperationFilterInput>;
  shippingIncrement?: InputMaybe<IntOperationFilterInput>;
  sizes?: InputMaybe<ListFilterInputTypeOfItemDocumentSizeFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  sortCategory?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ItemStatusOperationFilterInput>;
  /**
   * The Stripe product tax code a taxable sale of this item is sent to Stripe Tax under. Null means the
   * item carries none, so the seller's Stripe Tax default applies. A non-taxable item is always sent as
   * Nontaxable, whatever its code.
   */
  stripeTaxCode?: InputMaybe<StringOperationFilterInput>;
  subcategory?: InputMaybe<StringOperationFilterInput>;
  substitution?: InputMaybe<SubstitutionDocumentFilterInput>;
  taxable?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  usedForRetail?: InputMaybe<BooleanOperationFilterInput>;
  weightLbs?: InputMaybe<DecimalOperationFilterInput>;
  widthInches?: InputMaybe<DecimalOperationFilterInput>;
};

export type ItemSummaryDocumentSortInput = {
  /**
   * Available quantity as the customer portal catalog computes it from the inventory ledger. Not
   * maintained on the stored item: read anywhere else it is a frozen value from retired
   * availability counts, or null.
   */
  availableQuantity?: InputMaybe<SortEnumType>;
  batchTracked?: InputMaybe<SortEnumType>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value, distinct from the (removed-from-this-surface)
   * QuickBooks GL account this cost used to book to.
   */
  cogs?: InputMaybe<SortEnumType>;
  /** When the item was combined into combinedIntoItemId. */
  combinedAt?: InputMaybe<SortEnumType>;
  /** Who combined the item into combinedIntoItemId. */
  combinedBy?: InputMaybe<SortEnumType>;
  /** The item this one was combined into. Null for an item that stands on its own. */
  combinedIntoItemId?: InputMaybe<SortEnumType>;
  commissionable?: InputMaybe<SortEnumType>;
  defaultCarrier?: InputMaybe<SortEnumType>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: InputMaybe<SortEnumType>;
  /**
   * The item's own default Shipping UOM pick (ConfigCategoryId). Null means the item made no
   * pick and its category's tag is the default.
   */
  defaultShippingUomId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  discountable?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  genus?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  heightInches?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: InputMaybe<SortEnumType>;
  isOrganic?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemLookupCode?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  lengthInches?: InputMaybe<SortEnumType>;
  loadFactor?: InputMaybe<SortEnumType>;
  minShipQty?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /** Nursery-sense native plant species flag. Default false, no backfill (Helm 6a93ebe7). */
  native?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  /**
   * Earliest InventoryItem ledger ready date for this item (Helm 5d559558), joined into the
   * portal catalog aggregate alongside availableQuantity — never a stored field, so it reads
   * null outside customerPortalItems, and null there when no matching InventoryItem row
   * carries a ready date.
   */
  readyDate?: InputMaybe<SortEnumType>;
  /**
   * ISO 8601 week (1–53) derived from readyDate on read; never stored independently;
   * null when there is no ready date.
   */
  readyWeek?: InputMaybe<SortEnumType>;
  retailPrice?: InputMaybe<SortEnumType>;
  royalty?: InputMaybe<RoyaltyConfigDocumentSortInput>;
  sellPrice?: InputMaybe<SortEnumType>;
  shippingIncrement?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  sortCategory?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /**
   * The Stripe product tax code a taxable sale of this item is sent to Stripe Tax under. Null means the
   * item carries none, so the seller's Stripe Tax default applies. A non-taxable item is always sent as
   * Nontaxable, whatever its code.
   */
  stripeTaxCode?: InputMaybe<SortEnumType>;
  subcategory?: InputMaybe<SortEnumType>;
  substitution?: InputMaybe<SubstitutionDocumentSortInput>;
  taxable?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  usedForRetail?: InputMaybe<SortEnumType>;
  weightLbs?: InputMaybe<SortEnumType>;
  widthInches?: InputMaybe<SortEnumType>;
};

export enum ItemType {
  GrowItem = 'GROW_ITEM',
  MaterialItem = 'MATERIAL_ITEM',
  ReadyItem = 'READY_ITEM',
  Unknown = 'UNKNOWN'
}

export type ItemTypeOperationFilterInput = {
  eq?: InputMaybe<ItemType>;
  in?: InputMaybe<Array<ItemType>>;
  neq?: InputMaybe<ItemType>;
  nin?: InputMaybe<Array<ItemType>>;
};

export type ItemUpgrade = {
  __typename?: 'ItemUpgrade';
  categoryLabel?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<ItemUpgradeCost>;
  isDefault: Scalars['Boolean']['output'];
  isExclusiveInCategory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pricing?: Maybe<ItemUpgradePricing>;
  status: ItemUpgradeStatus;
  upgradeId: Scalars['String']['output'];
};

export type ItemUpgradeCost = {
  __typename?: 'ItemUpgradeCost';
  labor?: Maybe<LaborMetric>;
  materialCost?: Maybe<Scalars['Decimal']['output']>;
};

export type ItemUpgradeCostDataInput = {
  labor?: InputMaybe<LaborMetricDataInput>;
  materialCost?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ItemUpgradeDataInput = {
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<ItemUpgradeCostDataInput>;
  isDefault?: Scalars['Boolean']['input'];
  isExclusiveInCategory?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pricing?: InputMaybe<ItemUpgradePricingDataInput>;
  upgradeId: Scalars['String']['input'];
};

export type ItemUpgradePricing = {
  __typename?: 'ItemUpgradePricing';
  flatPrice?: Maybe<Scalars['Decimal']['output']>;
  markupPercent?: Maybe<Scalars['Decimal']['output']>;
  mode: PricingMode;
};

export type ItemUpgradePricingDataInput = {
  flatPrice?: InputMaybe<Scalars['Decimal']['input']>;
  markupPercent?: InputMaybe<Scalars['Decimal']['input']>;
  mode: PricingMode;
};

export type ItemUpgradePricingFilterInput = {
  and?: InputMaybe<Array<ItemUpgradePricingFilterInput>>;
  flatPrice?: InputMaybe<OptionOfDecimalFilterInput>;
  markupPercent?: InputMaybe<OptionOfDecimalFilterInput>;
  mode?: InputMaybe<PricingModeOperationFilterInput>;
  or?: InputMaybe<Array<ItemUpgradePricingFilterInput>>;
};

export enum ItemUpgradeStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/**
 * Items projection joined with the per-item sum of
 * RestockAvailabilityDocument rows. The joined sub-document is
 * nullable so items with no availability rows still surface in the result set.
 */
export type ItemWithRestockAvailabilityDocument = {
  __typename?: 'ItemWithRestockAvailabilityDocument';
  /** ERP ids of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedErpIds: Array<Scalars['String']['output']>;
  /**
   * Ids of the items this item absorbed, in combine order, including the items each of those had
   * itself absorbed.
   */
  absorbedItemIds: Array<Scalars['String']['output']>;
  /** Lookup codes of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedLookupCodes: Array<Scalars['String']['output']>;
  /** SKUs of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedSkus: Array<Scalars['String']['output']>;
  /** UPCs of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedUpcs: Array<Scalars['String']['output']>;
  /**
   * Shipping UOM ids (ConfigCategoryId) this item added to its available set, on top of what its
   * categories tag. Inherited ids are not included.
   */
  addedShippingUomIds: Array<Scalars['String']['output']>;
  /**
   * This item's stock by ready date: stock with no ready date first, then one bucket per ready date in
   * ascending order. Empty when no stock matches. Null for a staff caller, or when the tenant's portal
   * settings cannot be read.
   */
  availabilityByReadyDate?: Maybe<Array<PortalReadyDateBucket>>;
  /**
   * The quantity of this item ready now: stock with no ready date or a ready date on or before the tenant's
   * local today, netted across locations. Null for a staff caller, or when the tenant's portal settings
   * cannot be read.
   */
  availableNowQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * Available quantity as the customer portal catalog computes it from the inventory ledger. Not
   * maintained on the stored item: read anywhere else it is a frozen value from retired
   * availability counts, or null.
   */
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * Everything this item may be shipped as: inheritedShippingUomIds followed by
   * addedShippingUomIds, de-duplicated. This is the set a customer-item override and an
   * order line's Shipping UOM pick are both constrained to.
   */
  availableShippingUomIds: Array<Scalars['String']['output']>;
  batchTracked: Scalars['Boolean']['output'];
  categories?: Maybe<Array<Scalars['String']['output']>>;
  characteristics: Array<ItemCharacteristicPickDocument>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value, distinct from the (removed-from-this-surface)
   * QuickBooks GL account this cost used to book to.
   */
  cogs?: Maybe<Scalars['Decimal']['output']>;
  /** When the item was combined into combinedIntoItemId. */
  combinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who combined the item into combinedIntoItemId. */
  combinedBy?: Maybe<Scalars['String']['output']>;
  /** The item this one was combined into. Null for an item that stands on its own. */
  combinedIntoItemId?: Maybe<Scalars['String']['output']>;
  commissionable: Scalars['Boolean']['output'];
  containerConfigIds: Array<Scalars['String']['output']>;
  /**
   * Item-level ContainerConfig overrides. Populated by the item projection
   * from ItemContainerConfigOverrideSet and
   * ItemContainerConfigOverrideCleared events. Nullable numeric fields
   * on each entry fall back to the inherited ContainerConfig value when the
   * user did not override them.
   */
  containerConfigOverrides: Array<ItemContainerConfigOverrideDocument>;
  /**
   * This portal customer's effective Shipping UOM for the item: this customer's active override
   * when their customer item names one, otherwise the item's own effective pick — the same rule
   * staff's effective Shipping UOM applies, published here with the code and display name a
   * portal client cannot look up itself. Null when nothing in the chain names a Shipping UOM, and
   * null for every staff (non-portal) caller: this field is shared with the staff items
   * query, where there is no customer whose override it could mean.
   */
  customerEffectiveShippingUom?: Maybe<CustomerEffectiveShippingUomData>;
  /**
   * The signed-in customer's Pre-pricing standing for this catalog row: current, last, promo,
   * afterPromo and scheduledStanding, plus the baselineToken to send back with a retail price save.
   * Null when the tenant's Pre-pricing setting is off, for any caller who is not a portal customer,
   * or when this customer has no Active customer-level record for the item.
   */
  customerRetailPrice?: Maybe<CustomerRetailPrice>;
  defaultCarrier?: Maybe<Scalars['String']['output']>;
  /**
   * The charges a new order line for this item will carry for the signed-in customer, each with its
   * name and pricing. Empty for any caller who is not a portal customer, and when nothing applies.
   * Advisory: the order applies its own charges when the line is added.
   */
  defaultCharges: Array<PortalItemCharge>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  /**
   * The item's own default Shipping UOM pick (ConfigCategoryId). Null means the item made no
   * pick and its category's tag is the default.
   */
  defaultShippingUomId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  discountable: Scalars['Boolean']['output'];
  /**
   * Eaches in one unit of effectiveShippingUomId. Null means UNSTATED — never zero, never
   * one. It is null when no Shipping UOM won, and also when the winning one has never stated a
   * count; a caller that substitutes a number for either invents a quantity nothing configured.
   */
  effectiveEachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The Shipping UOM this item ships as by default: its own defaultShippingUomId when it
   * picked one, otherwise the first id in inheritedShippingUomIds. Null when neither the
   * item nor any category it sits in names one.
   */
  effectiveShippingUomId?: Maybe<Scalars['String']['output']>;
  /**
   * Which rung supplied effectiveShippingUomId: the item's own pick (ITEM), a
   * category tag (CATEGORY), or nothing (NONE). An item that picks the very id it
   * inherits reports ITEM — an explicit pick is an assignment — so this cannot be inferred
   * by comparing the id against inheritedShippingUomIds. CUSTOMER_ITEM never appears
   * here.
   */
  effectiveShippingUomSource: ShippingUomSource;
  erpId: Scalars['String']['output'];
  /** Names of the absorbed items, index-aligned with absorbedItemIds. */
  formerNames: Array<Scalars['String']['output']>;
  genus: Scalars['String']['output'];
  group: Scalars['String']['output'];
  heightInches?: Maybe<Scalars['Decimal']['output']>;
  history: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  incomeGlAccount?: Maybe<MergeDevAccountDocument>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: Maybe<Scalars['String']['output']>;
  /**
   * The Shipping UOM ids this item inherits from the categories it is assigned to, in the item's
   * own category-assignment order — not alphabetical. A category that is deleted, or that tags no
   * Shipping UOM, contributes nothing. The item cannot remove these.
   */
  inheritedShippingUomIds: Array<Scalars['String']['output']>;
  isOrganic: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  itemLookupCode: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The unit price this customer last transacted for this item and the date of that order, so a trade
   * buyer can compare it against the price being shown now. Sourced from order history — the number
   * actually charged — not by re-resolving a price rule, because FULFILL™ pricing is price-level based
   * with no base price, so a re-resolved figure is today's answer rather than what they paid.
   *
   * Null for an item this customer has not bought inside the configured lookback window, and null for
   * any caller that is not a portal customer: ItemSummaryDocument is shared with the staff
   * items query, where there is no customer whose history this could mean.
   *
   * Resolution is batched — one aggregation per page of items, never per item.
   */
  lastOrdered?: Maybe<ItemLastOrderedData>;
  lengthInches?: Maybe<Scalars['Decimal']['output']>;
  loadFactor?: Maybe<Scalars['Decimal']['output']>;
  minShipQty?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Nursery-sense native plant species flag. Default false, no backfill (Helm 6a93ebe7). */
  native: Scalars['Boolean']['output'];
  /**
   * This item's photo gallery, primary first, for a portal buyer. Empty when the item has no photo.
   * The tenant is read from the caller's token, never from the item row or an argument.
   */
  portalPhotos?: Maybe<Array<PortalItemPhoto>>;
  /**
   * The price label each plant of this item is charged when the signed-in customer has a retail price
   * for it. Null for any caller who is not a portal customer, when the tenant's Pre-pricing setting is
   * off, or when the tenant has no price labels.
   */
  priceLabel?: Maybe<PortalItemPriceLabel>;
  productGroup: Scalars['String']['output'];
  programs?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Earliest InventoryItem ledger ready date for this item (Helm 5d559558), joined into the
   * portal catalog aggregate alongside availableQuantity — never a stored field, so it reads
   * null outside customerPortalItems, and null there when no matching InventoryItem row
   * carries a ready date.
   */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * ISO 8601 week (1–53) derived from readyDate on read; never stored independently;
   * null when there is no ready date.
   */
  readyWeek?: Maybe<Scalars['Int']['output']>;
  restockAvailabilityByItemId?: Maybe<RestockAvailabilityByItemIdSummary>;
  /** @deprecated Pricing managed via price groups. Will be removed in a future release. */
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  royalty?: Maybe<RoyaltyConfigDocument>;
  /** @deprecated Use RetailPrice instead. */
  sellPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Shipping-config category codes the item participates in. */
  shippingConfigCategoryCodes: Array<Scalars['String']['output']>;
  shippingIncrement?: Maybe<Scalars['Int']['output']>;
  sizes?: Maybe<Array<ItemDocumentSize>>;
  sku: Scalars['String']['output'];
  sortCategory?: Maybe<Scalars['String']['output']>;
  status: ItemStatus;
  /**
   * The Stripe product tax code a taxable sale of this item is sent to Stripe Tax under. Null means the
   * item carries none, so the seller's Stripe Tax default applies. A non-taxable item is always sent as
   * Nontaxable, whatever its code.
   */
  stripeTaxCode?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  substitution?: Maybe<SubstitutionDocument>;
  taxable: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
  usedForRetail: Scalars['Boolean']['output'];
  weightLbs?: Maybe<Scalars['Decimal']['output']>;
  widthInches?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * Items projection joined with the per-item sum of
 * RestockAvailabilityDocument rows. The joined sub-document is
 * nullable so items with no availability rows still surface in the result set.
 */
export type ItemWithRestockAvailabilityDocumentFilterInput = {
  /** ERP ids of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedErpIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Ids of the items this item absorbed, in combine order, including the items each of those had
   * itself absorbed.
   */
  absorbedItemIds?: InputMaybe<ListStringOperationFilterInput>;
  /** Lookup codes of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedLookupCodes?: InputMaybe<ListStringOperationFilterInput>;
  /** SKUs of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedSkus?: InputMaybe<ListStringOperationFilterInput>;
  /** UPCs of the absorbed items, index-aligned with absorbedItemIds. */
  absorbedUpcs?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Shipping UOM ids (ConfigCategoryId) this item added to its available set, on top of what its
   * categories tag. Inherited ids are not included.
   */
  addedShippingUomIds?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<ItemWithRestockAvailabilityDocumentFilterInput>>;
  /**
   * Available quantity as the customer portal catalog computes it from the inventory ledger. Not
   * maintained on the stored item: read anywhere else it is a frozen value from retired
   * availability counts, or null.
   */
  availableQuantity?: InputMaybe<IntOperationFilterInput>;
  batchTracked?: InputMaybe<BooleanOperationFilterInput>;
  categories?: InputMaybe<ListStringOperationFilterInput>;
  characteristics?: InputMaybe<ListFilterInputTypeOfItemCharacteristicPickDocumentFilterInput>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value, distinct from the (removed-from-this-surface)
   * QuickBooks GL account this cost used to book to.
   */
  cogs?: InputMaybe<DecimalOperationFilterInput>;
  /** When the item was combined into combinedIntoItemId. */
  combinedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Who combined the item into combinedIntoItemId. */
  combinedBy?: InputMaybe<StringOperationFilterInput>;
  /** The item this one was combined into. Null for an item that stands on its own. */
  combinedIntoItemId?: InputMaybe<StringOperationFilterInput>;
  commissionable?: InputMaybe<BooleanOperationFilterInput>;
  containerConfigIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Item-level ContainerConfig overrides. Populated by the item projection
   * from ItemContainerConfigOverrideSet and
   * ItemContainerConfigOverrideCleared events. Nullable numeric fields
   * on each entry fall back to the inherited ContainerConfig value when the
   * user did not override them.
   */
  containerConfigOverrides?: InputMaybe<ListFilterInputTypeOfItemContainerConfigOverrideDocumentFilterInput>;
  defaultCarrier?: InputMaybe<StringOperationFilterInput>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: InputMaybe<StringOperationFilterInput>;
  /**
   * The item's own default Shipping UOM pick (ConfigCategoryId). Null means the item made no
   * pick and its category's tag is the default.
   */
  defaultShippingUomId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  discountable?: InputMaybe<BooleanOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  /** Names of the absorbed items, index-aligned with absorbedItemIds. */
  formerNames?: InputMaybe<ListStringOperationFilterInput>;
  genus?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  heightInches?: InputMaybe<DecimalOperationFilterInput>;
  history?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: InputMaybe<StringOperationFilterInput>;
  isOrganic?: InputMaybe<BooleanOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemLookupCode?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  lengthInches?: InputMaybe<DecimalOperationFilterInput>;
  loadFactor?: InputMaybe<DecimalOperationFilterInput>;
  minShipQty?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  /** Nursery-sense native plant species flag. Default false, no backfill (Helm 6a93ebe7). */
  native?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ItemWithRestockAvailabilityDocumentFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  programs?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Earliest InventoryItem ledger ready date for this item (Helm 5d559558), joined into the
   * portal catalog aggregate alongside availableQuantity — never a stored field, so it reads
   * null outside customerPortalItems, and null there when no matching InventoryItem row
   * carries a ready date.
   */
  readyDate?: InputMaybe<LocalDateOperationFilterInput>;
  /**
   * ISO 8601 week (1–53) derived from readyDate on read; never stored independently;
   * null when there is no ready date.
   */
  readyWeek?: InputMaybe<IntOperationFilterInput>;
  restockAvailabilityByItemId?: InputMaybe<RestockAvailabilityByItemIdSummaryFilterInput>;
  retailPrice?: InputMaybe<DecimalOperationFilterInput>;
  royalty?: InputMaybe<RoyaltyConfigDocumentFilterInput>;
  sellPrice?: InputMaybe<DecimalOperationFilterInput>;
  /** Shipping-config category codes the item participates in. */
  shippingConfigCategoryCodes?: InputMaybe<ListStringOperationFilterInput>;
  shippingIncrement?: InputMaybe<IntOperationFilterInput>;
  sizes?: InputMaybe<ListFilterInputTypeOfItemDocumentSizeFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  sortCategory?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ItemStatusOperationFilterInput>;
  /**
   * The Stripe product tax code a taxable sale of this item is sent to Stripe Tax under. Null means the
   * item carries none, so the seller's Stripe Tax default applies. A non-taxable item is always sent as
   * Nontaxable, whatever its code.
   */
  stripeTaxCode?: InputMaybe<StringOperationFilterInput>;
  subcategory?: InputMaybe<StringOperationFilterInput>;
  substitution?: InputMaybe<SubstitutionDocumentFilterInput>;
  taxable?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  usedForRetail?: InputMaybe<BooleanOperationFilterInput>;
  weightLbs?: InputMaybe<DecimalOperationFilterInput>;
  widthInches?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * Items projection joined with the per-item sum of
 * RestockAvailabilityDocument rows. The joined sub-document is
 * nullable so items with no availability rows still surface in the result set.
 */
export type ItemWithRestockAvailabilityDocumentSortInput = {
  /**
   * Available quantity as the customer portal catalog computes it from the inventory ledger. Not
   * maintained on the stored item: read anywhere else it is a frozen value from retired
   * availability counts, or null.
   */
  availableQuantity?: InputMaybe<SortEnumType>;
  batchTracked?: InputMaybe<SortEnumType>;
  /**
   * Cost-of-goods (purchase price) value for the item — the dollar cost FULFILL pays/records,
   * the field QuickBooks exposes as purchase_price via Merge.dev. Null when no cost is set.
   * NOT deprecated. This is the monetary value, distinct from the (removed-from-this-surface)
   * QuickBooks GL account this cost used to book to.
   */
  cogs?: InputMaybe<SortEnumType>;
  /** When the item was combined into combinedIntoItemId. */
  combinedAt?: InputMaybe<SortEnumType>;
  /** Who combined the item into combinedIntoItemId. */
  combinedBy?: InputMaybe<SortEnumType>;
  /** The item this one was combined into. Null for an item that stands on its own. */
  combinedIntoItemId?: InputMaybe<SortEnumType>;
  commissionable?: InputMaybe<SortEnumType>;
  defaultCarrier?: InputMaybe<SortEnumType>;
  /** Default shipping-config category code; must be one of ShippingConfigCategoryCodes. */
  defaultShippingConfigCategoryCode?: InputMaybe<SortEnumType>;
  /**
   * The item's own default Shipping UOM pick (ConfigCategoryId). Null means the item made no
   * pick and its category's tag is the default.
   */
  defaultShippingUomId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  discountable?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  genus?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  heightInches?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  /**
   * QuickBooks (Merge.dev) Income GL-account id this item's invoice revenue posts to.
   * Null when no mapping is configured — outbound exports fall back to QB defaults.
   * Join into MergeDevAccount.MergeDevAccountDocument via the
   * incomeGlAccount resolver field.
   */
  incomeGlAccountId?: InputMaybe<SortEnumType>;
  isOrganic?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemLookupCode?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  lengthInches?: InputMaybe<SortEnumType>;
  loadFactor?: InputMaybe<SortEnumType>;
  minShipQty?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /** Nursery-sense native plant species flag. Default false, no backfill (Helm 6a93ebe7). */
  native?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  /**
   * Earliest InventoryItem ledger ready date for this item (Helm 5d559558), joined into the
   * portal catalog aggregate alongside availableQuantity — never a stored field, so it reads
   * null outside customerPortalItems, and null there when no matching InventoryItem row
   * carries a ready date.
   */
  readyDate?: InputMaybe<SortEnumType>;
  /**
   * ISO 8601 week (1–53) derived from readyDate on read; never stored independently;
   * null when there is no ready date.
   */
  readyWeek?: InputMaybe<SortEnumType>;
  restockAvailabilityByItemId?: InputMaybe<RestockAvailabilityByItemIdSummarySortInput>;
  retailPrice?: InputMaybe<SortEnumType>;
  royalty?: InputMaybe<RoyaltyConfigDocumentSortInput>;
  sellPrice?: InputMaybe<SortEnumType>;
  shippingIncrement?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  sortCategory?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /**
   * The Stripe product tax code a taxable sale of this item is sent to Stripe Tax under. Null means the
   * item carries none, so the seller's Stripe Tax default applies. A non-taxable item is always sent as
   * Nontaxable, whatever its code.
   */
  stripeTaxCode?: InputMaybe<SortEnumType>;
  subcategory?: InputMaybe<SortEnumType>;
  substitution?: InputMaybe<SubstitutionDocumentSortInput>;
  taxable?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  usedForRetail?: InputMaybe<SortEnumType>;
  weightLbs?: InputMaybe<SortEnumType>;
  widthInches?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ItemsConnection = {
  __typename?: 'ItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ItemsEdge = {
  __typename?: 'ItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemSummaryDocument;
};

/** A connection to a list of items. */
export type ItemsWithBaseRateOfSaleConnection = {
  __typename?: 'ItemsWithBaseRateOfSaleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemsWithBaseRateOfSaleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ItemsWithBaseRateOfSaleEdge = {
  __typename?: 'ItemsWithBaseRateOfSaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemSummaryDocument;
};

/** A connection to a list of items. */
export type ItemsWithRestockAvailabilityConnection = {
  __typename?: 'ItemsWithRestockAvailabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemsWithRestockAvailabilityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemWithRestockAvailabilityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ItemsWithRestockAvailabilityEdge = {
  __typename?: 'ItemsWithRestockAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemWithRestockAvailabilityDocument;
};

export type IterationDocument = {
  __typename?: 'IterationDocument';
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  entity: EntityType;
  erpBatchSize: Scalars['Int']['output'];
  erpFetchMs: Scalars['Long']['output'];
  error: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  items: Array<IterationItem>;
  itemsProcessed: Scalars['Long']['output'];
  retries: Scalars['Int']['output'];
  skippedItems: Array<IterationItem>;
  start: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  totalMs: Scalars['Long']['output'];
  workSuiteProcessMs: Scalars['Long']['output'];
};

export type IterationDocumentFilterInput = {
  and?: InputMaybe<Array<IterationDocumentFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  end?: InputMaybe<DateTimeOperationFilterInput>;
  entity?: InputMaybe<EntityTypeOperationFilterInput>;
  erpBatchSize?: InputMaybe<IntOperationFilterInput>;
  erpFetchMs?: InputMaybe<LongOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ObjectIdOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfIterationItemFilterInput>;
  itemsProcessed?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<IterationDocumentFilterInput>>;
  retries?: InputMaybe<IntOperationFilterInput>;
  skippedItems?: InputMaybe<ListFilterInputTypeOfIterationItemFilterInput>;
  start?: InputMaybe<DateTimeOperationFilterInput>;
  success?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalMs?: InputMaybe<LongOperationFilterInput>;
  workSuiteProcessMs?: InputMaybe<LongOperationFilterInput>;
};

export type IterationDocumentSortInput = {
  description?: InputMaybe<SortEnumType>;
  end?: InputMaybe<SortEnumType>;
  entity?: InputMaybe<SortEnumType>;
  erpBatchSize?: InputMaybe<SortEnumType>;
  erpFetchMs?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemsProcessed?: InputMaybe<SortEnumType>;
  retries?: InputMaybe<SortEnumType>;
  start?: InputMaybe<SortEnumType>;
  success?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalMs?: InputMaybe<SortEnumType>;
  workSuiteProcessMs?: InputMaybe<SortEnumType>;
};

export type IterationItem = {
  __typename?: 'IterationItem';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type IterationItemFilterInput = {
  and?: InputMaybe<Array<IterationItemFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IterationItemFilterInput>>;
  reason?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type JobCostPayload = {
  __typename?: 'JobCostPayload';
  errors?: Maybe<Array<ValidationError>>;
  jobCostRecord?: Maybe<JobCostRecordDocument>;
};

/**
 * Read-model projection of a single recorded job cost, written from the job cost ledger events
 * and queried to build a job's cost summary, breakdown, and timeline.
 */
export type JobCostRecordDocument = {
  __typename?: 'JobCostRecordDocument';
  /** Recorded cost amount. */
  amount: Scalars['Decimal']['output'];
  /** Accounting bucket (material, labor, or overhead) the cost rolls up into. */
  costCategory: CostCategory;
  /** Timestamp the record was created in the read model. */
  createdDate: Scalars['DateTime']['output'];
  /** Free-text description of the cost; None when not provided. */
  description?: Maybe<Scalars['String']['output']>;
  /** Headcount associated with a labor cost; None for non-labor costs. */
  headcount?: Maybe<Scalars['Int']['output']>;
  /** Composite primary key, {tenantId}-{recordId}. */
  id: Scalars['String']['output'];
  /** True when the amount is an estimate rather than a settled actual. */
  isEstimated: Scalars['Boolean']['output'];
  /**
   * True when this record is a compensating reversal of an earlier cost. A reversal carries a
   * negative amount that nets the reversed cost to zero. Additive — pre-feature documents missing
   * the field deserialize to false.
   */
  isReversal: Scalars['Boolean']['output'];
  /** True when a reversal of this hand-entered cost exists, so the cost is already netted to zero. */
  isReversed: Scalars['Boolean']['output'];
  /** Id of the production job the cost is attributed to. */
  jobId: Scalars['String']['output'];
  /** Quantity associated with the cost when applicable; None otherwise. */
  quantity?: Maybe<Scalars['Decimal']['output']>;
  /** Unique id of this cost record. */
  recordId: Scalars['String']['output'];
  /** Business date the cost was incurred, used to bucket the cost timeline by week. */
  recordedDate: Scalars['DateTime']['output'];
  /** On a reversal of a hand-entered cost, the id of the record it reverses. */
  reversedRecordId?: Maybe<Scalars['String']['output']>;
  /** Id of the source record in the originating workflow. */
  sourceId: Scalars['String']['output'];
  /** Upstream workflow that produced the cost (purchase order, time entry, manual, etc.). */
  sourceType: CostSourceType;
  /** Optional subcategory used to group the cost in breakdowns; None when unspecified. */
  subcategory?: Maybe<Scalars['String']['output']>;
  /** The owning tenant id. */
  tenantId: Scalars['String']['output'];
  /** Unit of measure for Quantity; None when not unit-based. */
  unit?: Maybe<Scalars['String']['output']>;
  /** Per-unit cost when applicable; None for costs that are not unit-priced. */
  unitCost?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * Aggregated cost picture for a production job or lot — budget, actual, variance, and projected
 * figures per cost category plus completion context — surfaced to the cost-tracking UI.
 */
export type JobCostSummary = {
  __typename?: 'JobCostSummary';
  /**
   * The recipe's extra costs as their own Additional budget line, with the actual side absent
   * rather than zero. Its budget is included in Total exactly once.
   */
  additional: AdditionalCostValueModel;
  /** Actual extra costs incurred to date; always absent, because they are not separately tracked. */
  additionalActual?: Maybe<Scalars['Decimal']['output']>;
  /** Budgeted extra costs (flattened from Additional). */
  additionalBudget: Scalars['Decimal']['output'];
  /** Alias for TotalBudget, exposed for callers expecting a single budget figure. */
  budgetAmount: Scalars['Decimal']['output'];
  /** Actual total cost per completed unit, or null when nothing has been produced yet. */
  effectiveCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  /** True when any underlying cost record is an estimate rather than an actual. */
  hasEstimatedCosts: Scalars['Boolean']['output'];
  /**
   * False when the budget of any job in scope could not be fully costed, so the budget figures leave
   * something out. Advisory only: no figure changes with it.
   */
  isComplete: Scalars['Boolean']['output'];
  /** Labor budget/actual/variance/projected figures. */
  labor: JobCostValueModel;
  /** Actual labor cost incurred to date (flattened from Labor). */
  laborActual: Scalars['Decimal']['output'];
  /** Budgeted labor cost (flattened from Labor). */
  laborBudget: Scalars['Decimal']['output'];
  /** Whether labor cost records exist (flattened from Labor). */
  laborHasCostRecords: Scalars['Boolean']['output'];
  /** Projected labor cost at completion (flattened from Labor). */
  laborProjected: Scalars['Decimal']['output'];
  /** Labor cost variance, budget minus actual (flattened from Labor). */
  laborVariance: Scalars['Decimal']['output'];
  /** BASE material (raw goods) budget/actual/variance/projected figures. Never includes the supplier royalty. */
  material: JobCostValueModel;
  /** Actual material cost incurred to date (flattened from Material). */
  materialActual: Scalars['Decimal']['output'];
  /** Budgeted BASE material cost (flattened from Material). */
  materialBudget: Scalars['Decimal']['output'];
  /** Whether material cost records exist (flattened from Material). */
  materialHasCostRecords: Scalars['Boolean']['output'];
  /** Projected material cost at completion (flattened from Material). */
  materialProjected: Scalars['Decimal']['output'];
  /** Material cost variance, budget minus actual (flattened from Material). */
  materialVariance: Scalars['Decimal']['output'];
  /**
   * The missing-data warnings behind the incomplete jobs' budgets: the production category with no labor
   * cost, the site with no overhead rate and the material with no default vendor their cost steps name, one
   * per warning. An incomplete job can carry none, such as a default vendor with no price. Warnings the
   * caller chose to ignore are included; a client hides them from its own ignore list. Always empty for a
   * customer-portal caller.
   */
  missingData: Array<MissingDataFinding>;
  /** Overhead budget/actual/variance/projected figures. */
  overhead: JobCostValueModel;
  /** Actual overhead cost incurred to date (flattened from Overhead). */
  overheadActual: Scalars['Decimal']['output'];
  /** Budgeted overhead cost (flattened from Overhead). */
  overheadBudget: Scalars['Decimal']['output'];
  /** Whether overhead cost records exist (flattened from Overhead). */
  overheadHasCostRecords: Scalars['Boolean']['output'];
  /** Projected overhead cost at completion (flattened from Overhead). */
  overheadProjected: Scalars['Decimal']['output'];
  /** Overhead cost variance, budget minus actual (flattened from Overhead). */
  overheadVariance: Scalars['Decimal']['output'];
  /** Quantity produced so far, used to weight the projected-at-completion figures. */
  quantityCompleted: Scalars['Decimal']['output'];
  /** Target quantity for the job or lot. */
  quantityTarget: Scalars['Decimal']['output'];
  /**
   * Supplier-royalty budget, with its actual side absent rather than zero. Its budget is included
   * in Total exactly once; TotalActual keeps summing exactly the same recorded entries it always
   * has, which is why a job carrying a royalty budget shows that royalty in TotalVariance.
   */
  supplierRoyalty: SupplierRoyaltyCostValueModel;
  /** Actual supplier royalty incurred to date; always absent, because it is not separately tracked. */
  supplierRoyaltyActual?: Maybe<Scalars['Decimal']['output']>;
  /** Budgeted supplier royalty (flattened from SupplierRoyalty). */
  supplierRoyaltyBudget: Scalars['Decimal']['output'];
  /** Whether every quote behind the supplier-royalty budget states its royalty. */
  supplierRoyaltyCoverage: SupplierRoyaltyCoverage;
  /**
   * Combined material, supplier royalty, labor, overhead and additional figures. The royalty and the
   * additional cost are each counted into the BUDGET exactly once and into no actual, so the actual
   * sums exactly the recorded entries it always has.
   */
  total: JobCostValueModel;
  /** Total actual cost incurred to date across all categories (flattened from Total). */
  totalActual: Scalars['Decimal']['output'];
  /** Total budgeted cost across all categories (flattened from Total). */
  totalBudget: Scalars['Decimal']['output'];
  /** Whether any cost records exist in scope (flattened from Total). */
  totalHasCostRecords: Scalars['Boolean']['output'];
  /** Total projected cost at completion across all categories (flattened from Total). */
  totalProjected: Scalars['Decimal']['output'];
  /** Total cost variance, budget minus actual (flattened from Total). */
  totalVariance: Scalars['Decimal']['output'];
};

/**
 * Budget-versus-actual figures for a single cost category (or the rolled-up total), used to
 * drive the per-category breakdown on a JobCostSummary.
 */
export type JobCostValueModel = {
  __typename?: 'JobCostValueModel';
  /** Actual cost incurred to date, summed from recorded cost entries. */
  actual: Scalars['Decimal']['output'];
  /**
   * Budgeted cost for the category, resolved from recipe/site pricing. A job's budget is fixed at its first
   * execution; a job not yet executed is resolved live.
   */
  budget: Scalars['Decimal']['output'];
  /** True when the bucket has at least one cost record, including zero amounts, estimates and reversals. */
  hasCostRecords: Scalars['Boolean']['output'];
  /** Projected cost at completion: actual plus the budgeted cost of the remaining (not-yet-produced) quantity. */
  projected: Scalars['Decimal']['output'];
  /** Budget minus actual; positive when under budget, negative when over. */
  variance: Scalars['Decimal']['output'];
};

export type JobData = {
  __typename?: 'JobData';
  containerQuantity: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  item: JobItem;
  jobStatus: JobStatus;
  jobType: JobType;
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  unitOfMeasure: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  workOrders: Array<WorkOrderData>;
};

export type JobDiffProjection = {
  __typename?: 'JobDiffProjection';
  changedVariations: Array<VariationDiffProjection>;
  currentRecipeVersion: Scalars['Int']['output'];
  removedVariations: Array<RemovedVariationProjection>;
};

export type JobDocument = {
  __typename?: 'JobDocument';
  containerQuantity: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  item: JobItem;
  jobStatus: JobStatus;
  jobType: JobType;
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  unitOfMeasure: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  workOrderCount: Scalars['Int']['output'];
};

export type JobDocumentFilterInput = {
  and?: InputMaybe<Array<JobDocumentFilterInput>>;
  containerQuantity?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  deliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  item?: InputMaybe<JobItemFilterInput>;
  jobStatus?: InputMaybe<JobStatusOperationFilterInput>;
  jobType?: InputMaybe<JobTypeOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JobDocumentFilterInput>>;
  productionQuantity?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  unitOfMeasure?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  workOrderCount?: InputMaybe<IntOperationFilterInput>;
};

export type JobDocumentSortInput = {
  containerQuantity?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  deliveryDate?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  item?: InputMaybe<JobItemSortInput>;
  jobStatus?: InputMaybe<SortEnumType>;
  jobType?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productionQuantity?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  unitOfMeasure?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  workOrderCount?: InputMaybe<SortEnumType>;
};

/** Which family of event a job event request attaches or removes. Explicit ordinals keep the GraphQL enum stable. */
export enum JobEventKind {
  /** A material event. */
  Material = 'MATERIAL',
  /** A space event. */
  Space = 'SPACE',
  /** A task event, which is a task assignment on the job. Added only; the schedule never removes one this way. */
  Task = 'TASK',
  /** Not a kind. Never accepted on a request; a stored item that names it is not a job event. */
  Unknown = 'UNKNOWN'
}

/** One event attached to at least one selected job. */
export type JobEventSelectionEvent = {
  __typename?: 'JobEventSelectionEvent';
  /** The material or space event id, or the task event id of a task event. */
  eventId: Scalars['String']['output'];
  /** How many of the selected jobs carry it. */
  jobCount: Scalars['Int']['output'];
  /** The family of the event. */
  kind: JobEventKind;
};

/** The events attached across a selection. */
export type JobEventSelectionPayload = {
  __typename?: 'JobEventSelectionPayload';
  /** Each event any selected job carries, with how many do, most carried first. */
  events: Array<JobEventSelectionEvent>;
  /** How many jobs the selection resolved to. */
  jobCount: Scalars['Int']['output'];
};

/** Which jobs the events-in-selection query reads: job ids, or the Production Schedule's filter. */
export type JobEventsSelectionInput = {
  /** The jobs to read. Send this or scheduleFilter, not both. */
  productionJobIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The Production Schedule filter whose rows to read (Select All). */
  scheduleFilter?: InputMaybe<LotChangesScheduleFilterInput>;
};

/**
 * Which production jobs a JOB_EVENTS_ADD or JOB_EVENTS_REMOVE request changes, and with which event.
 * The server resolves the jobs when the job is requested and stores one item per job; the job then runs those jobs
 * whatever the schedule looks like later.
 */
export type JobEventsSelectorInput = {
  /** For a task event add, who the task is assigned to; blank leaves it unassigned. */
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  /** For a task event add, the due date; none for no due date. */
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The material or space event id. Required for those kinds; not used for a task. */
  eventId?: InputMaybe<Scalars['String']['input']>;
  /** The family of the event. */
  kind: JobEventKind;
  /** The jobs to change. Send this or scheduleFilter, not both. */
  productionJobIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The Production Schedule filter whose rows to change (Select All). */
  scheduleFilter?: InputMaybe<LotChangesScheduleFilterInput>;
  /** For a task event add, the task event's name, as the Add Event dialog sends it. */
  taskEventName?: InputMaybe<Scalars['String']['input']>;
};

export enum JobExecutionStatus {
  Executed = 'EXECUTED',
  Executing = 'EXECUTING',
  Pending = 'PENDING'
}

export type JobExecutionStatusOperationFilterInput = {
  eq?: InputMaybe<JobExecutionStatus>;
  in?: InputMaybe<Array<JobExecutionStatus>>;
  neq?: InputMaybe<JobExecutionStatus>;
  nin?: InputMaybe<Array<JobExecutionStatus>>;
};

export type JobItem = {
  __typename?: 'JobItem';
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  genusCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * The item the job was written for, when an item combine has since moved the job to the item it was
   * combined into (with that item's name); null when no combine moved it.
   */
  originalItemId?: Maybe<Scalars['String']['output']>;
  upc: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type JobItemFilterInput = {
  and?: InputMaybe<Array<JobItemFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  genusCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JobItemFilterInput>>;
  /**
   * The item the job was written for, when an item combine has since moved the job to the item it was
   * combined into (with that item's name); null when no combine moved it.
   */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type JobItemSortInput = {
  created?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  genusCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /**
   * The item the job was written for, when an item combine has since moved the job to the item it was
   * combined into (with that item's name); null when no combine moved it.
   */
  originalItemId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type JobPayload = {
  __typename?: 'JobPayload';
  errors?: Maybe<Array<ValidationError>>;
  job?: Maybe<JobData>;
};

export enum JobPostingStatus {
  Closed = 'CLOSED',
  NotPosted = 'NOT_POSTED',
  PartiallyPosted = 'PARTIALLY_POSTED'
}

export type JobPostingStatusOperationFilterInput = {
  eq?: InputMaybe<JobPostingStatus>;
  in?: InputMaybe<Array<JobPostingStatus>>;
  neq?: InputMaybe<JobPostingStatus>;
  nin?: InputMaybe<Array<JobPostingStatus>>;
};

/**
 * One run of consecutive ISO weeks a job books at a single footprint. spaceTypeId and
 * spaceTypeCode are null when the run resolved no space type. spaceEventId and
 * spaceEventDetailId are null on a BASE run.
 */
export type JobSpaceBooking = {
  __typename?: 'JobSpaceBooking';
  endIsoWeek: Scalars['Int']['output'];
  endIsoYear: Scalars['Int']['output'];
  source: JobSpaceBookingSource;
  spaceCategoryCode: Scalars['String']['output'];
  spaceEventDetailId?: Maybe<Scalars['String']['output']>;
  spaceEventId?: Maybe<Scalars['String']['output']>;
  spaceTypeCode?: Maybe<Scalars['String']['output']>;
  spaceTypeId?: Maybe<Scalars['String']['output']>;
  sqFtPerWeek: Scalars['Decimal']['output'];
  startIsoWeek: Scalars['Int']['output'];
  startIsoYear: Scalars['Int']['output'];
  weekCount: Scalars['Int']['output'];
};

/** Which footprint a booked run of weeks comes from. */
export enum JobSpaceBookingSource {
  /** The job's own space category footprint: weeks before the first step, or every week of a job with no step. */
  Base = 'BASE',
  /** The weeks after a spacing step ended, in which the job keeps that step's footprint and space type. */
  Held = 'HELD',
  /** The weeks of a space-event detail (a spacing step), from its trigger week for its duration. */
  SpaceEvent = 'SPACE_EVENT'
}

export enum JobStatus {
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Finished = 'FINISHED',
  InProduction = 'IN_PRODUCTION',
  Planned = 'PLANNED',
  Released = 'RELEASED',
  Unknown = 'UNKNOWN'
}

export type JobStatusOperationFilterInput = {
  eq?: InputMaybe<JobStatus>;
  in?: InputMaybe<Array<JobStatus>>;
  neq?: InputMaybe<JobStatus>;
  nin?: InputMaybe<Array<JobStatus>>;
};

export enum JobType {
  Conventional = 'CONVENTIONAL',
  Organic = 'ORGANIC',
  Unknown = 'UNKNOWN'
}

export type JobTypeOperationFilterInput = {
  eq?: InputMaybe<JobType>;
  in?: InputMaybe<Array<JobType>>;
  neq?: InputMaybe<JobType>;
  nin?: InputMaybe<Array<JobType>>;
};

/** A connection to a list of items. */
export type JobsConnection = {
  __typename?: 'JobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<JobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<JobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type JobsEdge = {
  __typename?: 'JobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: JobDocument;
};

export type KeyValuePairOfStringAndAssignmentTaskSummary = {
  __typename?: 'KeyValuePairOfStringAndAssignmentTaskSummary';
  key: Scalars['String']['output'];
  value: AssignmentTaskSummary;
};

export type KeyValuePairOfStringAndHardgoodsBinBreakdown = {
  __typename?: 'KeyValuePairOfStringAndHardgoodsBinBreakdown';
  key: Scalars['String']['output'];
  value: HardgoodsBinBreakdown;
};

export type KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>>;
  value?: InputMaybe<HardgoodsBinBreakdownFilterInput>;
};

export type KeyValuePairOfStringAndInt32 = {
  __typename?: 'KeyValuePairOfStringAndInt32';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type KeyValuePairOfStringAndInt32FilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndInt32FilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndInt32FilterInput>>;
  value?: InputMaybe<IntOperationFilterInput>;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * A kit: a named, optionally date-bound grouping of item and nested-kit lines, open to all Sites
 * or limited to some, served by the kits and kit queries.
 */
export type KitDocument = {
  __typename?: 'KitDocument';
  containerCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  kitId: Scalars['String']['output'];
  lines: Array<KitLineDocument>;
  name: Scalars['String']['output'];
  /**
   * Always an empty string. A kit is open to all Sites or limited to several, so it has no single
   * Site. Read siteIds instead.
   * @deprecated A kit is open to all Sites or limited to several, so it has no single Site. Always empty. Use siteIds.
   */
  siteId: Scalars['String']['output'];
  /** The Sites the kit is limited to. Empty means the kit is open to all Sites. */
  siteIds: Array<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * A kit: a named, optionally date-bound grouping of item and nested-kit lines, open to all Sites
 * or limited to some, served by the kits and kit queries.
 */
export type KitDocumentFilterInput = {
  and?: InputMaybe<Array<KitDocumentFilterInput>>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<LocalDateOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  kitId?: InputMaybe<StringOperationFilterInput>;
  lines?: InputMaybe<ListFilterInputTypeOfKitLineDocumentFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KitDocumentFilterInput>>;
  /** The Sites the kit is limited to. Empty means the kit is open to all Sites. */
  siteIds?: InputMaybe<ListStringOperationFilterInput>;
  startDate?: InputMaybe<LocalDateOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A kit: a named, optionally date-bound grouping of item and nested-kit lines, open to all Sites
 * or limited to some, served by the kits and kit queries.
 */
export type KitDocumentSortInput = {
  containerCode?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  kitId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type KitLineDataInput = {
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  eachesPerTray?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  kind: KitLineKind;
  label: Scalars['String']['input'];
  multiple: Scalars['Int']['input'];
  refId: Scalars['String']['input'];
  secondaryLabel?: InputMaybe<Scalars['String']['input']>;
  shippingConfigCategoryCode?: InputMaybe<Scalars['String']['input']>;
  sizeCode?: InputMaybe<Scalars['String']['input']>;
  uomCode: KitLineUom;
};

/**
 * One line of a kit: either a catalog item or another kit nested inside it, with the multiple and
 * unit it is counted in plus the display snapshot captured when the line was saved.
 */
export type KitLineDocument = {
  __typename?: 'KitLineDocument';
  categoryCode?: Maybe<Scalars['String']['output']>;
  eachesPerTray?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  kind: KitLineKind;
  label: Scalars['String']['output'];
  multiple: Scalars['Int']['output'];
  /**
   * The item this line named before the latest item combine pointed it at the kept item; null when no
   * combine moved it. Every write of the kit's lines, a combine or revert of another item included,
   * rewrites the lines and clears it.
   */
  originalItemId?: Maybe<Scalars['String']['output']>;
  refId: Scalars['String']['output'];
  secondaryLabel: Scalars['String']['output'];
  shippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  sizeCode?: Maybe<Scalars['String']['output']>;
  uomCode: KitLineUom;
};

/**
 * One line of a kit: either a catalog item or another kit nested inside it, with the multiple and
 * unit it is counted in plus the display snapshot captured when the line was saved.
 */
export type KitLineDocumentFilterInput = {
  and?: InputMaybe<Array<KitLineDocumentFilterInput>>;
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  eachesPerTray?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  kind?: InputMaybe<KitLineKindOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  multiple?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<KitLineDocumentFilterInput>>;
  /**
   * The item this line named before the latest item combine pointed it at the kept item; null when no
   * combine moved it. Every write of the kit's lines, a combine or revert of another item included,
   * rewrites the lines and clears it.
   */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  refId?: InputMaybe<StringOperationFilterInput>;
  secondaryLabel?: InputMaybe<StringOperationFilterInput>;
  shippingConfigCategoryCode?: InputMaybe<StringOperationFilterInput>;
  sizeCode?: InputMaybe<StringOperationFilterInput>;
  uomCode?: InputMaybe<KitLineUomOperationFilterInput>;
};

export enum KitLineKind {
  Item = 'ITEM',
  Kit = 'KIT'
}

export type KitLineKindOperationFilterInput = {
  eq?: InputMaybe<KitLineKind>;
  in?: InputMaybe<Array<KitLineKind>>;
  neq?: InputMaybe<KitLineKind>;
  nin?: InputMaybe<Array<KitLineKind>>;
};

export type KitLineStateData = {
  __typename?: 'KitLineStateData';
  categoryCode?: Maybe<Scalars['String']['output']>;
  eachesPerTray?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  kind: KitLineKind;
  label: Scalars['String']['output'];
  multiple: Scalars['Int']['output'];
  refId: Scalars['String']['output'];
  secondaryLabel: Scalars['String']['output'];
  shippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  sizeCode?: Maybe<Scalars['String']['output']>;
  uomCode: KitLineUom;
};

export enum KitLineUom {
  Each = 'EACH',
  Kit = 'KIT',
  Layer = 'LAYER',
  Tray = 'TRAY'
}

export type KitLineUomOperationFilterInput = {
  eq?: InputMaybe<KitLineUom>;
  in?: InputMaybe<Array<KitLineUom>>;
  neq?: InputMaybe<KitLineUom>;
  nin?: InputMaybe<Array<KitLineUom>>;
};

export type KitPayload = {
  __typename?: 'KitPayload';
  errors?: Maybe<Array<ValidationError>>;
  kit?: Maybe<KitStateData>;
};

export type KitStateData = {
  __typename?: 'KitStateData';
  containerCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  kitId: Scalars['String']['output'];
  lines: Array<KitLineStateData>;
  name: Scalars['String']['output'];
  /**
   * Always an empty string. A kit is open to all Sites or limited to several, so it has no single
   * Site. Read siteIds instead.
   * @deprecated A kit is open to all Sites or limited to several, so it has no single Site. Always empty. Use siteIds.
   */
  siteId: Scalars['String']['output'];
  siteIds: Array<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type KitsConnection = {
  __typename?: 'KitsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<KitsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<KitDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KitsEdge = {
  __typename?: 'KitsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: KitDocument;
};

export type LaborDemandCalcStep = {
  __typename?: 'LaborDemandCalcStep';
  code: Scalars['String']['output'];
  context: Array<LaborDemandCalcStepContextEntry>;
  message: Scalars['String']['output'];
  severity: LaborDemandCalcStepSeverity;
};

export type LaborDemandCalcStepContextEntry = {
  __typename?: 'LaborDemandCalcStepContextEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum LaborDemandCalcStepSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type LaborDemandEntry = {
  __typename?: 'LaborDemandEntry';
  blockName: Scalars['String']['output'];
  calcSteps: Array<LaborDemandCalcStep>;
  /**
   * The day the hours count on: the step's trigger date for this job, else the job's ready week date (a
   * whole-event entry, a manual override, a deleted event, or a step with no usable trigger).
   */
  date: Scalars['DateTime']['output'];
  eventSource: LaborDemandEventSource;
  plannedCost: Scalars['Decimal']['output'];
  plannedHours: Scalars['Decimal']['output'];
  productionJobId: Scalars['String']['output'];
  productionJobName?: Maybe<Scalars['String']['output']>;
  /**
   * The task event step (detail) this entry is for. Null for a whole-event entry: an event with no active step, a
   * manual override or a deleted event.
   */
  productionTaskEventDetailId?: Maybe<Scalars['String']['output']>;
  /**
   * The job's whole-container count the planned hours and cost scale by. Whole in every rounding mode, Exact
   * included: labor charges the whole tray, so a job planned at 0.23 of a tray demands one tray of labor.
   */
  quantity: Scalars['Int']['output'];
  /** The step's task type name, else its description. Null for a whole-event entry or a nameless step. */
  stepName?: Maybe<Scalars['String']['output']>;
  taskEventTypeId: Scalars['String']['output'];
  taskEventTypeName: Scalars['String']['output'];
  /**
   * The step's trigger date for this job: the job's start or ready week date moved by the step's trigger offset.
   * Null when the entry has no step or the step has no usable trigger, in which case the entry sits on the ready
   * week date.
   */
  triggerDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum LaborDemandEventSource {
  AdHoc = 'AD_HOC',
  Manual = 'MANUAL',
  Recipe = 'RECIPE'
}

export type LaborDemandSummary = {
  __typename?: 'LaborDemandSummary';
  entries: Array<LaborDemandEntry>;
  totalPlannedCost: Scalars['Decimal']['output'];
  totalPlannedHours: Scalars['Decimal']['output'];
};

export type LaborMetric = {
  __typename?: 'LaborMetric';
  laborTypeCode: Scalars['String']['output'];
  minutes: Scalars['Decimal']['output'];
};

export type LaborMetricDataInput = {
  laborTypeCode: Scalars['String']['input'];
  minutes: Scalars['Decimal']['input'];
};

/**
 * Append-only labor rate history document. One doc per (tenantId, siteLocationId, laborTypeId, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LaborRateDocument = {
  __typename?: 'LaborRateDocument';
  /**
   * Set when the owning site was cascade-deactivated (labor rates are site-keyed only,
   * not sub-keyed). Typed as Option{T} per discipline
   * 5a153a332f5f4f338cfe45d2f46870ef; OptionBsonSerializer stores None as BSON
   * null so on-disk shape matches the prior DateTimeOffset? field — additive
   * only, no collection drop.
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  laborTypeId: Scalars['String']['output'];
  ratePerHour: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * Append-only labor rate history document. One doc per (tenantId, siteLocationId, laborTypeId, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LaborRateDocumentFilterInput = {
  and?: InputMaybe<Array<LaborRateDocumentFilterInput>>;
  /**
   * Set when the owning site was cascade-deactivated (labor rates are site-keyed only,
   * not sub-keyed). Typed as Option{T} per discipline
   * 5a153a332f5f4f338cfe45d2f46870ef; OptionBsonSerializer stores None as BSON
   * null so on-disk shape matches the prior DateTimeOffset? field — additive
   * only, no collection drop.
   */
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveTo?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  laborTypeId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LaborRateDocumentFilterInput>>;
  ratePerHour?: InputMaybe<DecimalOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Append-only labor rate history document. One doc per (tenantId, siteLocationId, laborTypeId, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LaborRateDocumentSortInput = {
  /**
   * Set when the owning site was cascade-deactivated (labor rates are site-keyed only,
   * not sub-keyed). Typed as Option{T} per discipline
   * 5a153a332f5f4f338cfe45d2f46870ef; OptionBsonSerializer stores None as BSON
   * null so on-disk shape matches the prior DateTimeOffset? field — additive
   * only, no collection drop.
   */
  deactivatedAt?: InputMaybe<SortEnumType>;
  effectiveFrom?: InputMaybe<SortEnumType>;
  effectiveTo?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  laborTypeId?: InputMaybe<SortEnumType>;
  ratePerHour?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LaborRatesConnection = {
  __typename?: 'LaborRatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LaborRatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LaborRateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LaborRatesEdge = {
  __typename?: 'LaborRatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LaborRateDocument;
};

export type LaborTypeDataInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Denormalized labor type reference stored within a site location document. */
export type LaborTypeDocumentData = {
  __typename?: 'LaborTypeDocumentData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Denormalized labor type reference stored within a site location document. */
export type LaborTypeDocumentDataFilterInput = {
  and?: InputMaybe<Array<LaborTypeDocumentDataFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LaborTypeDocumentDataFilterInput>>;
};

export type LaborTypeStateData = {
  __typename?: 'LaborTypeStateData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum LanguagePreference {
  En = 'EN',
  Es = 'ES'
}

export type LanguagePreferenceOperationFilterInput = {
  eq?: InputMaybe<LanguagePreference>;
  in?: InputMaybe<Array<LanguagePreference>>;
  neq?: InputMaybe<LanguagePreference>;
  nin?: InputMaybe<Array<LanguagePreference>>;
};

/** One catalog concept with the caller's progress on it. */
export type LearningConcept = {
  __typename?: 'LearningConcept';
  /** The stable catalog id. */
  conceptId: Scalars['String']['output'];
  /** The docs page that explains the concept. */
  docsPath: Scalars['String']['output'];
  /**
   * True once the milestone is observed or, for a concept with no milestone, once its check is answered or its
   * walkthrough is completed. An abandoned walkthrough never completes a concept, and a walkthrough never completes
   * a concept that has a milestone.
   */
  isComplete: Scalars['Boolean']['output'];
  /** The event that completes the concept, if it has one. */
  milestone?: Maybe<LearningMilestone>;
  /** The module the concept belongs to. */
  module: LearningModule;
  /** The concept's place within its module. */
  order: Scalars['Int']['output'];
  /** What the caller has done on the concept so far. */
  progress: LearningConceptProgress;
  /** The roles that see the concept. Empty means every role. */
  roles: Array<Scalars['String']['output']>;
  /** The client's translation key for the summary. */
  summaryKey: Scalars['String']['output'];
  /** The client's translation key for the title. */
  titleKey: Scalars['String']['output'];
  /** The PWA walkthrough registry id of the concept's guided tour, such as createOrder, if it has one. */
  walkthroughId?: Maybe<Scalars['String']['output']>;
};

/** The concept with the caller's progress after the command, or why it failed. */
export type LearningConceptPayload = {
  __typename?: 'LearningConceptPayload';
  concept?: Maybe<LearningConcept>;
  errors?: Maybe<Array<ValidationError>>;
};

/** The caller's progress on one concept. Every field is null until that step first happens. */
export type LearningConceptProgress = {
  __typename?: 'LearningConceptProgress';
  /** The catalog version of the last write. */
  catalogVersion?: Maybe<Scalars['Int']['output']>;
  /** When the check was first answered, or first answered correctly. */
  checkAnsweredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the check was answered correctly. A correct answer is never downgraded. */
  checkCorrect?: Maybe<Scalars['Boolean']['output']>;
  /** When the concept was first explained. */
  explainedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The latest learning activity on the concept. */
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the milestone event was first observed. */
  milestoneObservedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The event that met the milestone. */
  milestoneSourceEventId?: Maybe<Scalars['String']['output']>;
  /** When that outcome was recorded. */
  walkthroughAt?: Maybe<Scalars['DateTime']['output']>;
  /** How the walkthrough ended, COMPLETED or ABANDONED. Completed is never downgraded. Offered and dismissed tours are in myWalkthroughState. */
  walkthroughOutcome?: Maybe<LearningWalkthroughOutcome>;
};

/** The business event that completes a concept. */
export type LearningMilestone = {
  __typename?: 'LearningMilestone';
  /** The event types that count. */
  eventTypes: Array<Scalars['String']['output']>;
  /** An optional named condition on the event. */
  predicate?: Maybe<Scalars['String']['output']>;
};

/** A WorkSuite module a learning path teaches. */
export enum LearningModule {
  Fulfill = 'FULFILL',
  Mobile = 'MOBILE',
  Portal = 'PORTAL',
  Produce = 'PRODUCE'
}

/** One learning path as the caller sees it, with their progress through it. */
export type LearningPath = {
  __typename?: 'LearningPath';
  /** How many of those concepts are complete. */
  completedCount: Scalars['Int']['output'];
  /** The concepts the caller's roles allow, in path order. */
  concepts: Array<LearningConcept>;
  /** The module the path teaches. */
  module: LearningModule;
  /** The first concept not yet complete, or null once every concept is. */
  nextConceptId?: Maybe<Scalars['String']['output']>;
  /** The catalog id of the path. */
  pathId: Scalars['String']['output'];
  /** How many concepts the caller sees on the path. */
  totalCount: Scalars['Int']['output'];
};

/** One office user's learning across the tenant, as staff and the learning nudge worker see it. */
export type LearningUserProgress = {
  __typename?: 'LearningUserProgress';
  /** The user's full name, or null when the directory has none. */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * True when a path is incomplete and the user has been idle Learning:NudgeAfterDays days: since their
   * last activity, or since they were created when they never started.
   */
  isStuck: Scalars['Boolean']['output'];
  /** The user's latest learning activity on any concept, or null if they never started. */
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** True when a stuck user has been idle Learning:EscalateAfterDays days. */
  needsEscalation: Scalars['Boolean']['output'];
  /** The next concept of the first incomplete path, or null once every path is complete. */
  nextConceptId?: Maybe<Scalars['String']['output']>;
  /** The user's learning paths with their progress, as the user would see them. */
  paths: Array<LearningPath>;
  /** When the user became stuck, or null while they are not. */
  stuckSince?: Maybe<Scalars['DateTime']['output']>;
  /** The user's email, as the directory stores it. */
  userEmail: Scalars['String']['output'];
};

/**
 * What happened to a guided walkthrough: how a run ended (completed or abandoned, kept on the concept's
 * progress), or that the tour was offered or declined (kept as tour state per walkthrough).
 */
export enum LearningWalkthroughOutcome {
  /** The run was left unfinished; recorded on the concept's progress only when no run has ended yet. */
  Abandoned = 'ABANDONED',
  /** The run finished; recorded on the concept's progress and never downgraded. */
  Completed = 'COMPLETED',
  /** The tour was declined; recorded as tour state, first time wins, and it also stamps offeredAt. */
  Dismissed = 'DISMISSED',
  /** The tour was shown; recorded as tour state, first time wins, and the concept is not stored. */
  Offered = 'OFFERED'
}

/**
 * A walkthrough outcome after the command, or why it failed: the concept with the caller's progress for
 * COMPLETED and ABANDONED, the caller's tour state for OFFERED and DISMISSED.
 */
export type LearningWalkthroughOutcomePayload = {
  __typename?: 'LearningWalkthroughOutcomePayload';
  concept?: Maybe<LearningConcept>;
  errors?: Maybe<Array<ValidationError>>;
  walkthrough?: Maybe<LearningWalkthroughState>;
};

/** The caller's tour state for one walkthrough. */
export type LearningWalkthroughState = {
  __typename?: 'LearningWalkthroughState';
  /** When the caller first declined it ("No thanks"). */
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the walkthrough was first offered. Null means it has never been offered. */
  offeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The PWA walkthrough registry id, such as createOrder. */
  walkthroughId: Scalars['String']['output'];
};

export type LeaseDuplicateCheckRequestsInput = {
  leaseSeconds: Scalars['Int']['input'];
  max: Scalars['Int']['input'];
};

/** Why a single price level did or did not contribute to the resolved price. */
export enum LevelStatus {
  /** Applied — in the winning tier and passing the date and quantity filters. */
  Applied = 'APPLIED',
  /** A sibling level targeting a different item (near-duplicate hint). */
  DifferentTarget = 'DIFFERENT_TARGET',
  /** The order date is after the level's end date. */
  Ended = 'ENDED',
  /**
   * A CategoryVolume level — never a candidate for a per-line
   * price. Evaluated only order-wide by the volume-discount engine, so it always shows here as
   * excluded even when its own date/quantity clauses would otherwise pass.
   */
  ExcludedCategoryVolume = 'EXCLUDED_CATEGORY_VOLUME',
  /** The order date is before the level's start date. */
  NotStarted = 'NOT_STARTED',
  /**
   * A category-tier level shadowed by an item-specific level that is IN FORCE on the order date
   * (most-specific-wins). An item whose own levels have all expired is priced from its category
   * instead, so its category level is never given this status.
   */
  OutrankedByItemTier = 'OUTRANKED_BY_ITEM_TIER',
  /** The order quantity is below the level's quantity threshold. */
  QtyBelowThreshold = 'QTY_BELOW_THRESHOLD'
}

/** Represents the actual quantity available for a line item after considering allocations */
export type LineItemActualQuantityDocument = {
  __typename?: 'LineItemActualQuantityDocument';
  actualQuantity: Scalars['Decimal']['output'];
  availableQuantity: Scalars['Decimal']['output'];
  grade?: Maybe<Scalars['Int']['output']>;
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  reservedQuantity: Scalars['Decimal']['output'];
};

export type LineItemContextNoteData = {
  __typename?: 'LineItemContextNoteData';
  context: NoteContext;
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** One order line's note for a single note context: the note text, who submitted it, and when. */
export type LineItemContextNoteDocument = {
  __typename?: 'LineItemContextNoteDocument';
  context: NoteContext;
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** One order line's note for a single note context: the note text, who submitted it, and when. */
export type LineItemContextNoteDocumentFilterInput = {
  and?: InputMaybe<Array<LineItemContextNoteDocumentFilterInput>>;
  context?: InputMaybe<NoteContextOperationFilterInput>;
  or?: InputMaybe<Array<LineItemContextNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
};

export type LineItemData = {
  __typename?: 'LineItemData';
  acknowledgedEaches?: Maybe<Scalars['Int']['output']>;
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  acknowledgedUnits?: Maybe<Scalars['Int']['output']>;
  acknowledgedZeroBillsNothing: Scalars['Boolean']['output'];
  /** The user who added this line. Staff only; refused for customer-portal callers. */
  addedBy: Scalars['String']['output'];
  allocatedUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * The quantity of this line's item currently available across all locations and grades — the
   * per-line "Available Number", matching OrderLineItemDocument.available exactly. Resolved
   * at read time from the live, ALLOCATION-AWARE InventoryItem read model (summed over
   * every location/grade row for the item) via the shared, batched availability DataLoader. The
   * sum is rounded to the nearest whole unit to preserve this field's existing Int shape;
   * see availableByLocation for the un-rounded, per-location breakdown. A site-assigned
   * caller only sees rows for their assigned locations (same fail-closed scope as the add-items
   * dialog). Returns 0 when the line carries no item id or the item has no inventory rows
   * in scope, and 0 for every customer-portal caller — the storefront publishes availability
   * only through the portal's own configured location/grade window, and the site scope treats an
   * unassigned caller (which every buyer is) as unrestricted. This surface is portal-reachable:
   * customerPortalInitializeOrder, customerPortalAddLineItems and
   * customerPortalUpdateOrderStatus all return OrderPayload.order.lineItems, which is
   * this type.
   */
  available: Scalars['Int']['output'];
  /**
   * The allocation-aware available quantity for this line's item, broken out per location/grade —
   * the un-summed rows behind available. Sourced from the same InventoryItemDocument
   * read model as the add-items dialog, via a batched DataLoader (no N+1 across order lines), and
   * scoped to the caller's assigned locations exactly as the dialog is. Returns an empty list when
   * the line carries no item id or the item has no inventory rows in scope, and for every
   * customer-portal caller: these rows name the grower's internal locations and their live stock
   * position per grade, which the storefront must never surface (see available for why the
   * site scope alone does not cover a buyer, and for the portal mutations that reach this type).
   */
  availableByLocation: Array<ItemAvailabilityByLocationData>;
  billableEaches: Scalars['Int']['output'];
  category?: Maybe<Scalars['String']['output']>;
  containerCode?: Maybe<Scalars['String']['output']>;
  cost: Scalars['Decimal']['output'];
  /**
   * The largest quantity, in EACHES, that a partial credit of THIS LINE alone will still accept:
   * the line's credit ceiling less the eaches every earlier credit already took from it
   * (creditedEaches), never below 0.
   * creditExistingOrder(lines: [{ lineNumber: <this line's lineNumber>, quantity }])
   * accepts quantity up to and including this value and refuses one more, with the same
   * refusal the mutation itself returns. Computed by calling the exact function the mutation's
   * ceiling check calls — never a second copy of it — so the two can never disagree.
   * This is a PER-LINE ceiling only: an order creditExistingOrder refuses outright before
   * it ever reaches a per-line check — one not yet submitted, one that is itself a Credit, or one
   * that is Cancelled or Deleted — refuses every request against that order regardless of this
   * value. 0 means no partial credit of this line is possible, because a request's
   * quantity must be at least 1.
   */
  creditableEaches: Scalars['Int']['output'];
  /** The eaches credited from this line across every credit raised against the order. creditableEaches is the line's credit ceiling less this figure. 0 for a line nothing has been credited from. */
  creditedEaches: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  customerItemId?: Maybe<Scalars['String']['output']>;
  customerSku?: Maybe<Scalars['String']['output']>;
  customerUpc?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  eaches: Scalars['Int']['output'];
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  eachesQuantity?: Maybe<Scalars['Int']['output']>;
  fulfillmentSource: FulfillmentSource;
  handlingUom?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  /**
   * The line item's Item Income GL account resolved to its Merge.dev account RemoteId, for the
   * outbound order export. Null when the line item has no matching Item, the Item has no
   * IncomeGlAccountId, or no MergeDevAccount matches — the downstream wsapi-services handler
   * owns the unmapped fallback (warn + omit). Output-only field (never on LineItemDataInput);
   * the resolver is tenant-scoped, so a batch cannot leak one tenant's account into another.
   */
  incomeGlAccountRemoteId?: Maybe<Scalars['String']['output']>;
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  kitGroupId?: Maybe<Scalars['String']['output']>;
  kitId?: Maybe<Scalars['String']['output']>;
  lineNumber: Scalars['Int']['output'];
  lineSubtotal: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<LineItemNoteData>;
  notes: Array<LineItemContextNoteData>;
  orderedEaches?: Maybe<Scalars['Int']['output']>;
  orderedQuantity?: Maybe<Scalars['Int']['output']>;
  orderedUnits?: Maybe<Scalars['Int']['output']>;
  overridePrice?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Override price for one shipping unit (flat, tray) of this line: overridePrice × resolvedEachesPerUnit.
   * Null when the line has no override. Prices are stored and billed per each; overridePrice is the price
   * the line bills on.
   */
  overrideUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  price: Scalars['Decimal']['output'];
  productionCatalogId?: Maybe<Scalars['String']['output']>;
  productionCategoryId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  /**
   * The line's quantity as a document prints it: the unit count with its label, then the eaches, for
   * example "2 (4.5 inch tray) · 30 ea". The bare each count when the line has no labelled unit.
   */
  quantityText: Scalars['String']['output'];
  resolvedEachesPerUnit: Scalars['Int']['output'];
  royalty?: Maybe<LineItemRoyaltyData>;
  royaltyExempt: Scalars['Boolean']['output'];
  shippedQuantity?: Maybe<Scalars['Int']['output']>;
  shippedUnits?: Maybe<Scalars['Int']['output']>;
  shippedZeroBillsNothing: Scalars['Boolean']['output'];
  shippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  shippingUomId?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  stageBasisQuantity: Scalars['Int']['output'];
  tag1ColorId?: Maybe<Scalars['String']['output']>;
  tag1Locked: Scalars['Boolean']['output'];
  tag2ColorId?: Maybe<Scalars['String']['output']>;
  tag2Locked: Scalars['Boolean']['output'];
  /**
   * The name of the shipping unit the line was placed under, such as "4.5 inch tray". Null when the line has
   * no pack above one or no shipping unit with a name resolves for it.
   */
  unitLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Price for one shipping unit (flat, tray) of this line. Prices are stored and billed per each; this is
   * the effective per-each price (overridePrice when set, otherwise price) × resolvedEachesPerUnit. Equals
   * the per-each price when the line has no shipping unit (a pack of one). For display and entry only:
   * lineSubtotal is what the line bills.
   */
  unitPrice: Scalars['Decimal']['output'];
  /**
   * The line's count in whole shipping units (trays, flats, cases), the stored unit rung the line's money
   * follows. Null when the line has no pack above one. Unlike eachesQuantity, which carries the same
   * count under a name that says eaches, this field is named for what it holds; read billableEaches
   * for the each count.
   */
  units?: Maybe<Scalars['Int']['output']>;
  upc: Scalars['String']['output'];
  upgradeSubtotalAdjustment: Scalars['Decimal']['output'];
  upgrades: Array<OrderLineUpgradeData>;
  volumePoolId?: Maybe<Scalars['String']['output']>;
};

export type LineItemNoteData = {
  __typename?: 'LineItemNoteData';
  noteText: Scalars['String']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
};

export type LineItemNoteDocument = {
  __typename?: 'LineItemNoteDocument';
  noteText: Scalars['String']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
};

export type LineItemNoteDocumentFilterInput = {
  and?: InputMaybe<Array<LineItemNoteDocumentFilterInput>>;
  noteText?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LineItemNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
};

export type LineItemNoteDocumentSortInput = {
  noteText?: InputMaybe<SortEnumType>;
  submitDate?: InputMaybe<SortEnumType>;
  submittedBy?: InputMaybe<SortEnumType>;
};

export type LineItemRoyaltyData = {
  __typename?: 'LineItemRoyaltyData';
  amount: Scalars['Decimal']['output'];
  payeeName: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  rateType: RoyaltyRateType;
};

/**
 * Frozen snapshot of an item's royalty terms at line-add time. Amount is the
 * calculated royalty amount for the line at that moment.
 */
export type LineItemRoyaltyDocument = {
  __typename?: 'LineItemRoyaltyDocument';
  amount: Scalars['Decimal']['output'];
  payeeName: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  rateType: RoyaltyRateType;
};

export type LineItemTagColorsInput = {
  expected?: InputMaybe<LineItemTagColorsValuesInput>;
  lineItemId: Scalars['String']['input'];
  tag1ColorId?: InputMaybe<Scalars['String']['input']>;
  tag1Locked: Scalars['Boolean']['input'];
  tag2ColorId?: InputMaybe<Scalars['String']['input']>;
  tag2Locked: Scalars['Boolean']['input'];
};

export type LineItemTagColorsValuesInput = {
  tag1ColorId?: InputMaybe<Scalars['String']['input']>;
  tag1Locked: Scalars['Boolean']['input'];
  tag2ColorId?: InputMaybe<Scalars['String']['input']>;
  tag2Locked: Scalars['Boolean']['input'];
};

export type LineItemUpdateDataInput = {
  department: Scalars['String']['input'];
  eachesQuantity?: InputMaybe<Scalars['Int']['input']>;
  minimumOverrideReason?: InputMaybe<Scalars['String']['input']>;
  notes: Array<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type LinkAllocationDataInput = {
  duration: Scalars['TimeSpan']['input'];
  taskAssignmentId: Scalars['String']['input'];
  timeEntryId: Scalars['String']['input'];
};

export type LinkFloatingTimeEntryInput = {
  allocations: Array<LinkAllocationDataInput>;
  floatingTimeEntryId: Scalars['String']['input'];
};

export type LinkFusionAuthUserByEmailInput = {
  email: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type LinkFusionAuthUserInput = {
  fusionAuthUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Input for linking multiple production items to one sales item. */
export type LinkProductionItemsToSalesItemInput = {
  productionItemIds: Array<Scalars['String']['input']>;
  salesItemId: Scalars['String']['input'];
};

/** Bulk payload returning the resulting production item states and any per-command errors. */
export type LinkProductionItemsToSalesItemPayload = {
  __typename?: 'LinkProductionItemsToSalesItemPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionItems: Array<ProductionItemStateData>;
  /**
   * One result per distinct requested production item the run started, in request order. An id with no result
   * was not reached.
   */
  results: Array<ProductionItemLinkResult>;
};

/** At most 500 pairs; duplicate production items are refused rather than raced. */
export type LinkProductionItemsToSalesItemsInput = {
  pairs: Array<ProductionItemLinkPairInput>;
};

/** One result per original pair, including rows not reached; RowIndex is zero-based. */
export type LinkProductionItemsToSalesItemsPayload = {
  __typename?: 'LinkProductionItemsToSalesItemsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<ProductionItemLinkPairResult>;
};

export type LinkRampBillToPurchaseOrderInput = {
  purchaseOrderId: Scalars['String']['input'];
  rampBillId: Scalars['String']['input'];
};

export type LinkSuggestedRampVendorsPayload = {
  __typename?: 'LinkSuggestedRampVendorsPayload';
  errors?: Maybe<Array<ValidationError>>;
  linkedCount: Scalars['Int']['output'];
};

export type LinkVendorToRampVendorInput = {
  rampVendorId: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type LinksOverride = {
  __typename?: 'LinksOverride';
  linkId: Scalars['String']['output'];
  productionRecipeVariationId: Scalars['String']['output'];
  setAt: Scalars['DateTime']['output'];
  setBy: Scalars['String']['output'];
};

export type LinksOverrideFilterInput = {
  and?: InputMaybe<Array<LinksOverrideFilterInput>>;
  linkId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LinksOverrideFilterInput>>;
  productionRecipeVariationId?: InputMaybe<StringOperationFilterInput>;
  setAt?: InputMaybe<DateTimeOperationFilterInput>;
  setBy?: InputMaybe<StringOperationFilterInput>;
};

export type ListAllocationPriorityDimensionOperationFilterInput = {
  all?: InputMaybe<AllocationPriorityDimensionOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AllocationPriorityDimensionOperationFilterInput>;
  some?: InputMaybe<AllocationPriorityDimensionOperationFilterInput>;
};

export type ListAppTagOperationFilterInput = {
  all?: InputMaybe<AppTagOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AppTagOperationFilterInput>;
  some?: InputMaybe<AppTagOperationFilterInput>;
};

export type ListFilterInputTypeOfAdminRestockCalcResultInputDocumentFilterInput = {
  all?: InputMaybe<AdminRestockCalcResultInputDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AdminRestockCalcResultInputDocumentFilterInput>;
  some?: InputMaybe<AdminRestockCalcResultInputDocumentFilterInput>;
};

export type ListFilterInputTypeOfAllocationLineItemDataFilterInput = {
  all?: InputMaybe<AllocationLineItemDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AllocationLineItemDataFilterInput>;
  some?: InputMaybe<AllocationLineItemDataFilterInput>;
};

export type ListFilterInputTypeOfBpfStartingNodeDocumentFilterInput = {
  all?: InputMaybe<BpfStartingNodeDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BpfStartingNodeDocumentFilterInput>;
  some?: InputMaybe<BpfStartingNodeDocumentFilterInput>;
};

export type ListFilterInputTypeOfCustomerCommissionOverrideDataFilterInput = {
  all?: InputMaybe<CustomerCommissionOverrideDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerCommissionOverrideDataFilterInput>;
  some?: InputMaybe<CustomerCommissionOverrideDataFilterInput>;
};

export type ListFilterInputTypeOfCustomerContactSearchEntryFilterInput = {
  all?: InputMaybe<CustomerContactSearchEntryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerContactSearchEntryFilterInput>;
  some?: InputMaybe<CustomerContactSearchEntryFilterInput>;
};

export type ListFilterInputTypeOfCustomerLocationAliasDataFilterInput = {
  all?: InputMaybe<CustomerLocationAliasDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerLocationAliasDataFilterInput>;
  some?: InputMaybe<CustomerLocationAliasDataFilterInput>;
};

export type ListFilterInputTypeOfCustomerLocationContextNoteDocumentFilterInput = {
  all?: InputMaybe<CustomerLocationContextNoteDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerLocationContextNoteDocumentFilterInput>;
  some?: InputMaybe<CustomerLocationContextNoteDocumentFilterInput>;
};

export type ListFilterInputTypeOfCustomerLocationNoteDocumentFilterInput = {
  all?: InputMaybe<CustomerLocationNoteDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerLocationNoteDocumentFilterInput>;
  some?: InputMaybe<CustomerLocationNoteDocumentFilterInput>;
};

export type ListFilterInputTypeOfCustomerStatementRunOutcomeDocumentFilterInput = {
  all?: InputMaybe<CustomerStatementRunOutcomeDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerStatementRunOutcomeDocumentFilterInput>;
  some?: InputMaybe<CustomerStatementRunOutcomeDocumentFilterInput>;
};

export type ListFilterInputTypeOfCycleCountLogBatchFilterInput = {
  all?: InputMaybe<CycleCountLogBatchFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CycleCountLogBatchFilterInput>;
  some?: InputMaybe<CycleCountLogBatchFilterInput>;
};

export type ListFilterInputTypeOfCycleCountLogItemFilterInput = {
  all?: InputMaybe<CycleCountLogItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CycleCountLogItemFilterInput>;
  some?: InputMaybe<CycleCountLogItemFilterInput>;
};

export type ListFilterInputTypeOfDbrCalcResultInputDocumentFilterInput = {
  all?: InputMaybe<DbrCalcResultInputDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DbrCalcResultInputDocumentFilterInput>;
  some?: InputMaybe<DbrCalcResultInputDocumentFilterInput>;
};

export type ListFilterInputTypeOfDestinationConfigDataFilterInput = {
  all?: InputMaybe<DestinationConfigDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DestinationConfigDataFilterInput>;
  some?: InputMaybe<DestinationConfigDataFilterInput>;
};

export type ListFilterInputTypeOfEmailSendRecipientDocumentFilterInput = {
  all?: InputMaybe<EmailSendRecipientDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmailSendRecipientDocumentFilterInput>;
  some?: InputMaybe<EmailSendRecipientDocumentFilterInput>;
};

export type ListFilterInputTypeOfEntityMappingDataFilterInput = {
  all?: InputMaybe<EntityMappingDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EntityMappingDataFilterInput>;
  some?: InputMaybe<EntityMappingDataFilterInput>;
};

export type ListFilterInputTypeOfErpLoadListRouteDataFilterInput = {
  all?: InputMaybe<ErpLoadListRouteDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ErpLoadListRouteDataFilterInput>;
  some?: InputMaybe<ErpLoadListRouteDataFilterInput>;
};

export type ListFilterInputTypeOfErpOrderLineFilterInput = {
  all?: InputMaybe<ErpOrderLineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ErpOrderLineFilterInput>;
  some?: InputMaybe<ErpOrderLineFilterInput>;
};

export type ListFilterInputTypeOfErpWriteBackReceiptLineDocumentFilterInput = {
  all?: InputMaybe<ErpWriteBackReceiptLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ErpWriteBackReceiptLineDocumentFilterInput>;
  some?: InputMaybe<ErpWriteBackReceiptLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfEventAssignmentOverrideDocumentFilterInput = {
  all?: InputMaybe<EventAssignmentOverrideDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EventAssignmentOverrideDocumentFilterInput>;
  some?: InputMaybe<EventAssignmentOverrideDocumentFilterInput>;
};

export type ListFilterInputTypeOfFavoritesListItemDocumentFilterInput = {
  all?: InputMaybe<FavoritesListItemDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FavoritesListItemDocumentFilterInput>;
  some?: InputMaybe<FavoritesListItemDocumentFilterInput>;
};

export type ListFilterInputTypeOfFieldMappingDataFilterInput = {
  all?: InputMaybe<FieldMappingDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FieldMappingDataFilterInput>;
  some?: InputMaybe<FieldMappingDataFilterInput>;
};

export type ListFilterInputTypeOfFloatingTimeEntryAllocationDocumentFilterInput = {
  all?: InputMaybe<FloatingTimeEntryAllocationDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FloatingTimeEntryAllocationDocumentFilterInput>;
  some?: InputMaybe<FloatingTimeEntryAllocationDocumentFilterInput>;
};

export type ListFilterInputTypeOfGrowWeeksOverrideFilterInput = {
  all?: InputMaybe<GrowWeeksOverrideFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GrowWeeksOverrideFilterInput>;
  some?: InputMaybe<GrowWeeksOverrideFilterInput>;
};

export type ListFilterInputTypeOfInventoryAllocationDocumentFilterInput = {
  all?: InputMaybe<InventoryAllocationDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InventoryAllocationDocumentFilterInput>;
  some?: InputMaybe<InventoryAllocationDocumentFilterInput>;
};

export type ListFilterInputTypeOfInventoryNoteDocumentFilterInput = {
  all?: InputMaybe<InventoryNoteDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InventoryNoteDocumentFilterInput>;
  some?: InputMaybe<InventoryNoteDocumentFilterInput>;
};

export type ListFilterInputTypeOfInventorySourceJobContributionDocumentFilterInput = {
  all?: InputMaybe<InventorySourceJobContributionDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InventorySourceJobContributionDocumentFilterInput>;
  some?: InputMaybe<InventorySourceJobContributionDocumentFilterInput>;
};

export type ListFilterInputTypeOfInventoryTransactionBatchDocumentFilterInput = {
  all?: InputMaybe<InventoryTransactionBatchDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InventoryTransactionBatchDocumentFilterInput>;
  some?: InputMaybe<InventoryTransactionBatchDocumentFilterInput>;
};

export type ListFilterInputTypeOfItemCharacteristicPickDocumentFilterInput = {
  all?: InputMaybe<ItemCharacteristicPickDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ItemCharacteristicPickDocumentFilterInput>;
  some?: InputMaybe<ItemCharacteristicPickDocumentFilterInput>;
};

export type ListFilterInputTypeOfItemCharacteristicValueDocumentFilterInput = {
  all?: InputMaybe<ItemCharacteristicValueDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ItemCharacteristicValueDocumentFilterInput>;
  some?: InputMaybe<ItemCharacteristicValueDocumentFilterInput>;
};

export type ListFilterInputTypeOfItemContainerConfigOverrideDocumentFilterInput = {
  all?: InputMaybe<ItemContainerConfigOverrideDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ItemContainerConfigOverrideDocumentFilterInput>;
  some?: InputMaybe<ItemContainerConfigOverrideDocumentFilterInput>;
};

export type ListFilterInputTypeOfItemDocumentSizeFilterInput = {
  all?: InputMaybe<ItemDocumentSizeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ItemDocumentSizeFilterInput>;
  some?: InputMaybe<ItemDocumentSizeFilterInput>;
};

export type ListFilterInputTypeOfIterationItemFilterInput = {
  all?: InputMaybe<IterationItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IterationItemFilterInput>;
  some?: InputMaybe<IterationItemFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndHardgoodsBinBreakdownFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndInt32FilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndInt32FilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndInt32FilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndInt32FilterInput>;
};

export type ListFilterInputTypeOfKitLineDocumentFilterInput = {
  all?: InputMaybe<KitLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KitLineDocumentFilterInput>;
  some?: InputMaybe<KitLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfLaborTypeDocumentDataFilterInput = {
  all?: InputMaybe<LaborTypeDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LaborTypeDocumentDataFilterInput>;
  some?: InputMaybe<LaborTypeDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfLineItemContextNoteDocumentFilterInput = {
  all?: InputMaybe<LineItemContextNoteDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LineItemContextNoteDocumentFilterInput>;
  some?: InputMaybe<LineItemContextNoteDocumentFilterInput>;
};

export type ListFilterInputTypeOfLinksOverrideFilterInput = {
  all?: InputMaybe<LinksOverrideFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LinksOverrideFilterInput>;
  some?: InputMaybe<LinksOverrideFilterInput>;
};

export type ListFilterInputTypeOfLockedLocationOverrideFilterInput = {
  all?: InputMaybe<LockedLocationOverrideFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LockedLocationOverrideFilterInput>;
  some?: InputMaybe<LockedLocationOverrideFilterInput>;
};

export type ListFilterInputTypeOfMasterOrderLineDocumentDataFilterInput = {
  all?: InputMaybe<MasterOrderLineDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MasterOrderLineDocumentDataFilterInput>;
  some?: InputMaybe<MasterOrderLineDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMasterOrderReleaseDocumentDataFilterInput = {
  all?: InputMaybe<MasterOrderReleaseDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MasterOrderReleaseDocumentDataFilterInput>;
  some?: InputMaybe<MasterOrderReleaseDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMasterOrderReleaseLineDocumentDataFilterInput = {
  all?: InputMaybe<MasterOrderReleaseLineDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MasterOrderReleaseLineDocumentDataFilterInput>;
  some?: InputMaybe<MasterOrderReleaseLineDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMasterOrderShipmentDocumentDataFilterInput = {
  all?: InputMaybe<MasterOrderShipmentDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MasterOrderShipmentDocumentDataFilterInput>;
  some?: InputMaybe<MasterOrderShipmentDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMasterOrderShipmentLineDocumentDataFilterInput = {
  all?: InputMaybe<MasterOrderShipmentLineDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MasterOrderShipmentLineDocumentDataFilterInput>;
  some?: InputMaybe<MasterOrderShipmentLineDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMatchCandidateDocumentFilterInput = {
  all?: InputMaybe<MatchCandidateDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MatchCandidateDocumentFilterInput>;
  some?: InputMaybe<MatchCandidateDocumentFilterInput>;
};

export type ListFilterInputTypeOfMaterialEventVendorOverrideDocumentFilterInput = {
  all?: InputMaybe<MaterialEventVendorOverrideDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MaterialEventVendorOverrideDocumentFilterInput>;
  some?: InputMaybe<MaterialEventVendorOverrideDocumentFilterInput>;
};

export type ListFilterInputTypeOfMaterialTransactionReceiptLotDataFilterInput = {
  all?: InputMaybe<MaterialTransactionReceiptLotDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MaterialTransactionReceiptLotDataFilterInput>;
  some?: InputMaybe<MaterialTransactionReceiptLotDataFilterInput>;
};

export type ListFilterInputTypeOfMaterialVendorDataFilterInput = {
  all?: InputMaybe<MaterialVendorDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MaterialVendorDataFilterInput>;
  some?: InputMaybe<MaterialVendorDataFilterInput>;
};

export type ListFilterInputTypeOfMergeDevPaymentAppliedLineDocumentFilterInput = {
  all?: InputMaybe<MergeDevPaymentAppliedLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MergeDevPaymentAppliedLineDocumentFilterInput>;
  some?: InputMaybe<MergeDevPaymentAppliedLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfMongoAggregationFieldDocumentDataFilterInput = {
  all?: InputMaybe<MongoAggregationFieldDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MongoAggregationFieldDocumentDataFilterInput>;
  some?: InputMaybe<MongoAggregationFieldDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMongoColumnMapDocumentDataFilterInput = {
  all?: InputMaybe<MongoColumnMapDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MongoColumnMapDocumentDataFilterInput>;
  some?: InputMaybe<MongoColumnMapDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMongoDestinationDocumentDataFilterInput = {
  all?: InputMaybe<MongoDestinationDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MongoDestinationDocumentDataFilterInput>;
  some?: InputMaybe<MongoDestinationDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfMovementOrderHistoryLineDocumentFilterInput = {
  all?: InputMaybe<MovementOrderHistoryLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MovementOrderHistoryLineDocumentFilterInput>;
  some?: InputMaybe<MovementOrderHistoryLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfNotificationKindPreferenceDataFilterInput = {
  all?: InputMaybe<NotificationKindPreferenceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NotificationKindPreferenceDataFilterInput>;
  some?: InputMaybe<NotificationKindPreferenceDataFilterInput>;
};

export type ListFilterInputTypeOfOrderCategoryVolumeDiscountDocumentFilterInput = {
  all?: InputMaybe<OrderCategoryVolumeDiscountDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderCategoryVolumeDiscountDocumentFilterInput>;
  some?: InputMaybe<OrderCategoryVolumeDiscountDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderCategoryVolumeExclusionDocumentFilterInput = {
  all?: InputMaybe<OrderCategoryVolumeExclusionDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderCategoryVolumeExclusionDocumentFilterInput>;
  some?: InputMaybe<OrderCategoryVolumeExclusionDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderCategoryVolumeLineDocumentFilterInput = {
  all?: InputMaybe<OrderCategoryVolumeLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderCategoryVolumeLineDocumentFilterInput>;
  some?: InputMaybe<OrderCategoryVolumeLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderCategoryVolumeProgressDocumentFilterInput = {
  all?: InputMaybe<OrderCategoryVolumeProgressDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderCategoryVolumeProgressDocumentFilterInput>;
  some?: InputMaybe<OrderCategoryVolumeProgressDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderContextNoteDocumentFilterInput = {
  all?: InputMaybe<OrderContextNoteDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderContextNoteDocumentFilterInput>;
  some?: InputMaybe<OrderContextNoteDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderFlatChargeDocumentFilterInput = {
  all?: InputMaybe<OrderFlatChargeDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderFlatChargeDocumentFilterInput>;
  some?: InputMaybe<OrderFlatChargeDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderLineUpgradeDocumentFilterInput = {
  all?: InputMaybe<OrderLineUpgradeDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderLineUpgradeDocumentFilterInput>;
  some?: InputMaybe<OrderLineUpgradeDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderNonDiscountableLineDocumentFilterInput = {
  all?: InputMaybe<OrderNonDiscountableLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderNonDiscountableLineDocumentFilterInput>;
  some?: InputMaybe<OrderNonDiscountableLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderPaymentEntryDocumentFilterInput = {
  all?: InputMaybe<OrderPaymentEntryDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderPaymentEntryDocumentFilterInput>;
  some?: InputMaybe<OrderPaymentEntryDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderTaxEstimateJurisdictionDocumentFilterInput = {
  all?: InputMaybe<OrderTaxEstimateJurisdictionDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderTaxEstimateJurisdictionDocumentFilterInput>;
  some?: InputMaybe<OrderTaxEstimateJurisdictionDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderVolumeLineDocumentFilterInput = {
  all?: InputMaybe<OrderVolumeLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderVolumeLineDocumentFilterInput>;
  some?: InputMaybe<OrderVolumeLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfOrderVolumePoolProgressDocumentFilterInput = {
  all?: InputMaybe<OrderVolumePoolProgressDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderVolumePoolProgressDocumentFilterInput>;
  some?: InputMaybe<OrderVolumePoolProgressDocumentFilterInput>;
};

export type ListFilterInputTypeOfOtaOpenedRingDocumentFilterInput = {
  all?: InputMaybe<OtaOpenedRingDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OtaOpenedRingDocumentFilterInput>;
  some?: InputMaybe<OtaOpenedRingDocumentFilterInput>;
};

export type ListFilterInputTypeOfOtaRingPlanDocumentFilterInput = {
  all?: InputMaybe<OtaRingPlanDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OtaRingPlanDocumentFilterInput>;
  some?: InputMaybe<OtaRingPlanDocumentFilterInput>;
};

export type ListFilterInputTypeOfParentCompanyAdministratorDocumentFilterInput = {
  all?: InputMaybe<ParentCompanyAdministratorDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ParentCompanyAdministratorDocumentFilterInput>;
  some?: InputMaybe<ParentCompanyAdministratorDocumentFilterInput>;
};

export type ListFilterInputTypeOfParentCompanyContactMethodDocumentFilterInput = {
  all?: InputMaybe<ParentCompanyContactMethodDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ParentCompanyContactMethodDocumentFilterInput>;
  some?: InputMaybe<ParentCompanyContactMethodDocumentFilterInput>;
};

export type ListFilterInputTypeOfPendingTransferOrderLineDocumentFilterInput = {
  all?: InputMaybe<PendingTransferOrderLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PendingTransferOrderLineDocumentFilterInput>;
  some?: InputMaybe<PendingTransferOrderLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfPlannedArrivalDocumentFilterInput = {
  all?: InputMaybe<PlannedArrivalDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PlannedArrivalDocumentFilterInput>;
  some?: InputMaybe<PlannedArrivalDocumentFilterInput>;
};

export type ListFilterInputTypeOfPlantsPerPotOverrideFilterInput = {
  all?: InputMaybe<PlantsPerPotOverrideFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PlantsPerPotOverrideFilterInput>;
  some?: InputMaybe<PlantsPerPotOverrideFilterInput>;
};

export type ListFilterInputTypeOfProductionCatalogFarmDocumentDataFilterInput = {
  all?: InputMaybe<ProductionCatalogFarmDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionCatalogFarmDocumentDataFilterInput>;
  some?: InputMaybe<ProductionCatalogFarmDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfProductionCatalogTripleDocumentFilterInput = {
  all?: InputMaybe<ProductionCatalogTripleDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionCatalogTripleDocumentFilterInput>;
  some?: InputMaybe<ProductionCatalogTripleDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionEventAttachmentDocumentDataFilterInput = {
  all?: InputMaybe<ProductionEventAttachmentDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionEventAttachmentDocumentDataFilterInput>;
  some?: InputMaybe<ProductionEventAttachmentDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfProductionItemEventAttachmentDocumentFilterInput = {
  all?: InputMaybe<ProductionItemEventAttachmentDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionItemEventAttachmentDocumentFilterInput>;
  some?: InputMaybe<ProductionItemEventAttachmentDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionJobAdjustmentDocumentFilterInput = {
  all?: InputMaybe<ProductionJobAdjustmentDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionJobAdjustmentDocumentFilterInput>;
  some?: InputMaybe<ProductionJobAdjustmentDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionJobEventAttachmentDocumentFilterInput = {
  all?: InputMaybe<ProductionJobEventAttachmentDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionJobEventAttachmentDocumentFilterInput>;
  some?: InputMaybe<ProductionJobEventAttachmentDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionJobEventExclusionDocumentFilterInput = {
  all?: InputMaybe<ProductionJobEventExclusionDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionJobEventExclusionDocumentFilterInput>;
  some?: InputMaybe<ProductionJobEventExclusionDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionJobPostedLineDocumentFilterInput = {
  all?: InputMaybe<ProductionJobPostedLineDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionJobPostedLineDocumentFilterInput>;
  some?: InputMaybe<ProductionJobPostedLineDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionJobShrinkEventDocumentFilterInput = {
  all?: InputMaybe<ProductionJobShrinkEventDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionJobShrinkEventDocumentFilterInput>;
  some?: InputMaybe<ProductionJobShrinkEventDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductionLotAsyncImportReadAsMeantFilterInput = {
  all?: InputMaybe<ProductionLotAsyncImportReadAsMeantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionLotAsyncImportReadAsMeantFilterInput>;
  some?: InputMaybe<ProductionLotAsyncImportReadAsMeantFilterInput>;
};

export type ListFilterInputTypeOfProductionLotAsyncImportRowReasonFilterInput = {
  all?: InputMaybe<ProductionLotAsyncImportRowReasonFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionLotAsyncImportRowReasonFilterInput>;
  some?: InputMaybe<ProductionLotAsyncImportRowReasonFilterInput>;
};

export type ListFilterInputTypeOfProductionRecipeLinkDataFilterInput = {
  all?: InputMaybe<ProductionRecipeLinkDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionRecipeLinkDataFilterInput>;
  some?: InputMaybe<ProductionRecipeLinkDataFilterInput>;
};

export type ListFilterInputTypeOfProductionRecipeYieldTierDocumentFilterInput = {
  all?: InputMaybe<ProductionRecipeYieldTierDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionRecipeYieldTierDocumentFilterInput>;
  some?: InputMaybe<ProductionRecipeYieldTierDocumentFilterInput>;
};

export type ListFilterInputTypeOfReportDataSourceFieldFilterInput = {
  all?: InputMaybe<ReportDataSourceFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReportDataSourceFieldFilterInput>;
  some?: InputMaybe<ReportDataSourceFieldFilterInput>;
};

export type ListFilterInputTypeOfReportDataSourceGroupByFilterInput = {
  all?: InputMaybe<ReportDataSourceGroupByFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReportDataSourceGroupByFilterInput>;
  some?: InputMaybe<ReportDataSourceGroupByFilterInput>;
};

export type ListFilterInputTypeOfReportDataSourceGroupHeaderFieldFilterInput = {
  all?: InputMaybe<ReportDataSourceGroupHeaderFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReportDataSourceGroupHeaderFieldFilterInput>;
  some?: InputMaybe<ReportDataSourceGroupHeaderFieldFilterInput>;
};

export type ListFilterInputTypeOfReportDataSourceGroupTotalFilterInput = {
  all?: InputMaybe<ReportDataSourceGroupTotalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReportDataSourceGroupTotalFilterInput>;
  some?: InputMaybe<ReportDataSourceGroupTotalFilterInput>;
};

export type ListFilterInputTypeOfReportDataSourceParameterFilterInput = {
  all?: InputMaybe<ReportDataSourceParameterFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReportDataSourceParameterFilterInput>;
  some?: InputMaybe<ReportDataSourceParameterFilterInput>;
};

export type ListFilterInputTypeOfReportGrantDocumentFilterInput = {
  all?: InputMaybe<ReportGrantDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReportGrantDocumentFilterInput>;
  some?: InputMaybe<ReportGrantDocumentFilterInput>;
};

export type ListFilterInputTypeOfRestockCalcStepContextEntryFilterInput = {
  all?: InputMaybe<RestockCalcStepContextEntryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RestockCalcStepContextEntryFilterInput>;
  some?: InputMaybe<RestockCalcStepContextEntryFilterInput>;
};

export type ListFilterInputTypeOfRestockCalcStepFilterInput = {
  all?: InputMaybe<RestockCalcStepFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RestockCalcStepFilterInput>;
  some?: InputMaybe<RestockCalcStepFilterInput>;
};

export type ListFilterInputTypeOfRestockSessionReserveRuleDocumentFilterInput = {
  all?: InputMaybe<RestockSessionReserveRuleDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RestockSessionReserveRuleDocumentFilterInput>;
  some?: InputMaybe<RestockSessionReserveRuleDocumentFilterInput>;
};

export type ListFilterInputTypeOfRouteStopDataFilterInput = {
  all?: InputMaybe<RouteStopDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RouteStopDataFilterInput>;
  some?: InputMaybe<RouteStopDataFilterInput>;
};

export type ListFilterInputTypeOfSalesPersonDataFilterInput = {
  all?: InputMaybe<SalesPersonDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SalesPersonDataFilterInput>;
  some?: InputMaybe<SalesPersonDataFilterInput>;
};

export type ListFilterInputTypeOfScheduledOrderDataFilterInput = {
  all?: InputMaybe<ScheduledOrderDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ScheduledOrderDataFilterInput>;
  some?: InputMaybe<ScheduledOrderDataFilterInput>;
};

export type ListFilterInputTypeOfShipToCombineRecordFilterInput = {
  all?: InputMaybe<ShipToCombineRecordFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ShipToCombineRecordFilterInput>;
  some?: InputMaybe<ShipToCombineRecordFilterInput>;
};

export type ListFilterInputTypeOfSiteContactDocumentDataFilterInput = {
  all?: InputMaybe<SiteContactDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SiteContactDocumentDataFilterInput>;
  some?: InputMaybe<SiteContactDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfSiteLaborRateDocumentDataFilterInput = {
  all?: InputMaybe<SiteLaborRateDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SiteLaborRateDocumentDataFilterInput>;
  some?: InputMaybe<SiteLaborRateDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfSqlColumnMapDataFilterInput = {
  all?: InputMaybe<SqlColumnMapDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SqlColumnMapDataFilterInput>;
  some?: InputMaybe<SqlColumnMapDataFilterInput>;
};

export type ListFilterInputTypeOfTenantOnboardingUploadDataFilterInput = {
  all?: InputMaybe<TenantOnboardingUploadDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TenantOnboardingUploadDataFilterInput>;
  some?: InputMaybe<TenantOnboardingUploadDataFilterInput>;
};

export type ListFilterInputTypeOfTenantSubscriptionItemDataFilterInput = {
  all?: InputMaybe<TenantSubscriptionItemDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TenantSubscriptionItemDataFilterInput>;
  some?: InputMaybe<TenantSubscriptionItemDataFilterInput>;
};

export type ListFilterInputTypeOfUserInviteRegistrationDocumentDataFilterInput = {
  all?: InputMaybe<UserInviteRegistrationDocumentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserInviteRegistrationDocumentDataFilterInput>;
  some?: InputMaybe<UserInviteRegistrationDocumentDataFilterInput>;
};

export type ListFilterInputTypeOfVehicleTypeCapacityDataFilterInput = {
  all?: InputMaybe<VehicleTypeCapacityDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VehicleTypeCapacityDataFilterInput>;
  some?: InputMaybe<VehicleTypeCapacityDataFilterInput>;
};

export type ListFilterInputTypeOfVendorPurchaseOrderChargeDataFilterInput = {
  all?: InputMaybe<VendorPurchaseOrderChargeDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VendorPurchaseOrderChargeDataFilterInput>;
  some?: InputMaybe<VendorPurchaseOrderChargeDataFilterInput>;
};

export type ListFilterInputTypeOfVendorPurchaseOrderItemDataFilterInput = {
  all?: InputMaybe<VendorPurchaseOrderItemDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VendorPurchaseOrderItemDataFilterInput>;
  some?: InputMaybe<VendorPurchaseOrderItemDataFilterInput>;
};

export type ListFilterInputTypeOfVendorPurchaseOrderLineJobShareDataFilterInput = {
  all?: InputMaybe<VendorPurchaseOrderLineJobShareDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VendorPurchaseOrderLineJobShareDataFilterInput>;
  some?: InputMaybe<VendorPurchaseOrderLineJobShareDataFilterInput>;
};

export type ListFilterInputTypeOfVendorPurchaseOrderReceiptDataFilterInput = {
  all?: InputMaybe<VendorPurchaseOrderReceiptDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VendorPurchaseOrderReceiptDataFilterInput>;
  some?: InputMaybe<VendorPurchaseOrderReceiptDataFilterInput>;
};

export type ListFilterInputTypeOfVerifyContainerOrderAssociationDocumentFilterInput = {
  all?: InputMaybe<VerifyContainerOrderAssociationDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VerifyContainerOrderAssociationDocumentFilterInput>;
  some?: InputMaybe<VerifyContainerOrderAssociationDocumentFilterInput>;
};

export type ListFilterInputTypeOfVerifyContainerScanDocumentFilterInput = {
  all?: InputMaybe<VerifyContainerScanDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VerifyContainerScanDocumentFilterInput>;
  some?: InputMaybe<VerifyContainerScanDocumentFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderBuildItemDataFilterInput = {
  all?: InputMaybe<WorkOrderBuildItemDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<WorkOrderBuildItemDataFilterInput>;
  some?: InputMaybe<WorkOrderBuildItemDataFilterInput>;
};

export type ListIntOperationFilterInput = {
  all?: InputMaybe<IntOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IntOperationFilterInput>;
  some?: InputMaybe<IntOperationFilterInput>;
};

export type ListOnboardingReviewAreaOperationFilterInput = {
  all?: InputMaybe<OnboardingReviewAreaOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OnboardingReviewAreaOperationFilterInput>;
  some?: InputMaybe<OnboardingReviewAreaOperationFilterInput>;
};

export type ListProductionTriggerReminderLeadTimeOperationFilterInput = {
  all?: InputMaybe<ProductionTriggerReminderLeadTimeOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductionTriggerReminderLeadTimeOperationFilterInput>;
  some?: InputMaybe<ProductionTriggerReminderLeadTimeOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type ListUserRoleOperationFilterInput = {
  all?: InputMaybe<UserRoleOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserRoleOperationFilterInput>;
  some?: InputMaybe<UserRoleOperationFilterInput>;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Load, keyed
 * {tenantId}-{loadId}. Deleted rows are removed outright.
 */
export type LoadDocument = {
  __typename?: 'LoadDocument';
  carrierId?: Maybe<Scalars['String']['output']>;
  containerConfigId?: Maybe<Scalars['String']['output']>;
  containerName: Scalars['String']['output'];
  /** The Dock the Load ships from. Set only by dock events, never by mergeLoad. */
  dockId?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  /**
   * The orders the last Apply freight on the load wrote or left owning its freight. Set only by
   * LoadFreightApplied, never by mergeLoad.
   */
  freightAppliedOrderIds: Array<Scalars['String']['output']>;
  /**
   * The input revision of the last Apply freight on the load. Set only by LoadFreightApplied, never by
   * mergeLoad.
   */
  freightInputRevision?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  loadId: Scalars['String']['output'];
  loadNumber: Scalars['Int']['output'];
  /** Miles for the whole load. Set only by miles events, never by mergeLoad. */
  miles?: Maybe<Scalars['Decimal']['output']>;
  /** The ordered route stop ids the miles were entered or computed for; consumers compare it with the load's current served stops to derive staleness. */
  milesItinerary: Array<Scalars['String']['output']>;
  milesSource: MilesSource;
  /** The pickup window. Set only by pickup-window events, never by mergeLoad. */
  pickupWindow?: Maybe<PickupWindowDocument>;
  /** Planned arrival per route stop; readers ignore an entry whose stop has no live LoadLine on the load. */
  plannedArrivals: Array<PlannedArrivalDocument>;
  routeId?: Maybe<Scalars['String']['output']>;
  shipDate: Scalars['LocalDate']['output'];
  status: LoadStatus;
  tenantId: Scalars['String']['output'];
  transitKind: TransitKind;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  vehicleId?: Maybe<Scalars['String']['output']>;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Load, keyed
 * {tenantId}-{loadId}. Deleted rows are removed outright.
 */
export type LoadDocumentFilterInput = {
  and?: InputMaybe<Array<LoadDocumentFilterInput>>;
  carrierId?: InputMaybe<OptionOfStringFilterInput>;
  containerConfigId?: InputMaybe<OptionOfStringFilterInput>;
  containerName?: InputMaybe<StringOperationFilterInput>;
  /** The Dock the Load ships from. Set only by dock events, never by mergeLoad. */
  dockId?: InputMaybe<OptionOfStringFilterInput>;
  driverId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * The orders the last Apply freight on the load wrote or left owning its freight. Set only by
   * LoadFreightApplied, never by mergeLoad.
   */
  freightAppliedOrderIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * The input revision of the last Apply freight on the load. Set only by LoadFreightApplied, never by
   * mergeLoad.
   */
  freightInputRevision?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  loadId?: InputMaybe<StringOperationFilterInput>;
  loadNumber?: InputMaybe<IntOperationFilterInput>;
  /** Miles for the whole load. Set only by miles events, never by mergeLoad. */
  miles?: InputMaybe<DecimalOperationFilterInput>;
  /** The ordered route stop ids the miles were entered or computed for; consumers compare it with the load's current served stops to derive staleness. */
  milesItinerary?: InputMaybe<ListStringOperationFilterInput>;
  milesSource?: InputMaybe<MilesSourceOperationFilterInput>;
  or?: InputMaybe<Array<LoadDocumentFilterInput>>;
  /** The pickup window. Set only by pickup-window events, never by mergeLoad. */
  pickupWindow?: InputMaybe<PickupWindowDocumentFilterInput>;
  /** Planned arrival per route stop; readers ignore an entry whose stop has no live LoadLine on the load. */
  plannedArrivals?: InputMaybe<ListFilterInputTypeOfPlannedArrivalDocumentFilterInput>;
  routeId?: InputMaybe<OptionOfStringFilterInput>;
  shipDate?: InputMaybe<LocalDateOperationFilterInput>;
  status?: InputMaybe<LoadStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  transitKind?: InputMaybe<TransitKindOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  vehicleId?: InputMaybe<OptionOfStringFilterInput>;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Load, keyed
 * {tenantId}-{loadId}. Deleted rows are removed outright.
 */
export type LoadDocumentSortInput = {
  carrierId?: InputMaybe<SortEnumType>;
  containerConfigId?: InputMaybe<SortEnumType>;
  containerName?: InputMaybe<SortEnumType>;
  /** The Dock the Load ships from. Set only by dock events, never by mergeLoad. */
  dockId?: InputMaybe<SortEnumType>;
  driverId?: InputMaybe<SortEnumType>;
  /**
   * The input revision of the last Apply freight on the load. Set only by LoadFreightApplied, never by
   * mergeLoad.
   */
  freightInputRevision?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  loadId?: InputMaybe<SortEnumType>;
  loadNumber?: InputMaybe<SortEnumType>;
  /** Miles for the whole load. Set only by miles events, never by mergeLoad. */
  miles?: InputMaybe<SortEnumType>;
  milesSource?: InputMaybe<SortEnumType>;
  /** The pickup window. Set only by pickup-window events, never by mergeLoad. */
  pickupWindow?: InputMaybe<PickupWindowDocumentSortInput>;
  routeId?: InputMaybe<SortEnumType>;
  shipDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  transitKind?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  vehicleId?: InputMaybe<SortEnumType>;
};

/** Result of a claim: the rows this worker now holds a lease on. Empty means nothing to send. */
export type LoadEmailClaimPayload = {
  __typename?: 'LoadEmailClaimPayload';
  /** The claimed rows, oldest first, each with its stored rendering. */
  emails: Array<LoadEmailDocument>;
  /** Populated only when the claim itself failed. */
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * One load email on the send queue, keyed {tenantId}-{reservationId}: the reservation a planner's
 * request made, its lease state, and the subject, body and recipients wsapi rendered at reservation time.
 */
export type LoadEmailDocument = {
  __typename?: 'LoadEmailDocument';
  /** 1 when reserved; each retry of a failed send adds one. */
  attempt: Scalars['Int']['output'];
  /** The rendered HTML body, sent verbatim. */
  body: Scalars['String']['output'];
  /** What changed since the replaced send; empty unless corrected. */
  changedFields: Array<Scalars['String']['output']>;
  /** When the row was last claimed; null when the row is not Sending. */
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True when this is a corrected send that replaces an earlier one. */
  corrected: Scalars['Boolean']['output'];
  /** When the reservation was made. */
  createdAt: Scalars['DateTime']['output'];
  /** Why the last attempt failed or is uncertain, as the worker reported it. */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The worker's note when it fell back to another sender channel. */
  fallbackNote?: Maybe<Scalars['String']['output']>;
  /** The row id. */
  id: Scalars['String']['output'];
  /** What kind of load email this is. */
  kind: LoadEmailKind;
  /** When the current claim's lease runs out; null when the row is not Sending. */
  leaseExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The load the email is about. */
  loadId: Scalars['String']['output'];
  /** The token values a planned-arrival notice was rendered from; null for any other kind. */
  plannedArrival?: Maybe<LoadEmailPlannedArrivalData>;
  /** The planned arrival time (HH:mm) the email is keyed on; null for a kind with no stop. */
  plannedTime?: Maybe<Scalars['String']['output']>;
  /** The provider's message id for the last attempt, when it reported one. */
  providerMessageId?: Maybe<Scalars['String']['output']>;
  /** The addresses to send to, resolved at reservation time. */
  recipients: Array<Scalars['String']['output']>;
  /**
   * True once a claim found this row Sending with an expired lease. A reclaimed row may only be recorded
   * UNCERTAIN.
   */
  reclaimed: Scalars['Boolean']['output'];
  /** The version a corrected send replaces; null otherwise. */
  replacesVersion?: Maybe<Scalars['Int']['output']>;
  /**
   * The report the worker renders at send time and attaches as a PDF; null on a planned-arrival notice,
   * which carries no attachment.
   */
  reportBinding?: Maybe<LoadEmailReportBinding>;
  /** Who requested the current attempt. */
  requestedBy: Scalars['String']['output'];
  /** The reservation id the worker claims and records against. */
  reservationId: Scalars['String']['output'];
  /** The route stop the email is about; null for a kind with no stop. */
  routeStopId?: Maybe<Scalars['String']['output']>;
  /** Where the email stands. */
  status: LoadEmailStatus;
  /** The rendered subject, sent verbatim. */
  subject: Scalars['String']['output'];
  /** The tenant the email belongs to. */
  tenantId: Scalars['String']['output'];
  /** When the row last changed. */
  updatedAt: Scalars['DateTime']['output'];
  /** 1 for the first send of a key; each corrected send takes the next version. */
  version: Scalars['Int']['output'];
};

export enum LoadEmailKind {
  FreightQuote = 'FREIGHT_QUOTE',
  PlannedArrivalNotice = 'PLANNED_ARRIVAL_NOTICE',
  Unknown = 'UNKNOWN'
}

/** The outcome the worker reports for one claimed load email. */
export enum LoadEmailOutcome {
  /** The send failed and nothing was delivered. */
  Failed = 'FAILED',
  /** The provider accepted the email. */
  Sent = 'SENT',
  /** The worker cannot establish whether the provider accepted the email. */
  Uncertain = 'UNCERTAIN',
  /** Unset; refused on record. */
  Unknown = 'UNKNOWN'
}

/** Result of a record or a resolution: the row as it now stands. */
export type LoadEmailPayload = {
  __typename?: 'LoadEmailPayload';
  /** The row as it now stands; null when the call failed. */
  email?: Maybe<LoadEmailDocument>;
  /** Populated when the row does not exist or the move is not allowed. */
  errors?: Maybe<Array<ValidationError>>;
};

/** The token values one planned-arrival notice was rendered from. */
export type LoadEmailPlannedArrivalData = {
  __typename?: 'LoadEmailPlannedArrivalData';
  /** The load's driver. */
  driverName: Scalars['String']['output'];
  /** The stop's order numbers, each once. */
  orderNumbers: Array<Scalars['String']['output']>;
  /** The load's ship date plus the stop's transit days. */
  plannedDeliveryDate: Scalars['LocalDate']['output'];
  /** The planned arrival time, HH:mm. */
  plannedTime: Scalars['String']['output'];
  /** The containers on the stop's lines. */
  rackCount: Scalars['Int']['output'];
  /** The stop's position among the load's served stops, from 1. */
  stopNumber: Scalars['Int']['output'];
  /** The stop's store name. */
  storeName: Scalars['String']['output'];
  /** The template the notice was rendered from: the default's version, or the authored row's last update. */
  templateVersion: Scalars['String']['output'];
};

/**
 * The report a load email attaches as a PDF. The worker renders it for the load at send time, so the row
 * carries no bytes.
 */
export type LoadEmailReportBinding = {
  __typename?: 'LoadEmailReportBinding';
  /** The load the report prints, passed to the render as its loadId parameter. */
  loadId: Scalars['String']['output'];
  /** The report or seeded template to render. */
  templateId: Scalars['String']['output'];
  /** The template's last update when the send was requested. */
  templateVersion: Scalars['String']['output'];
};

export enum LoadEmailResolution {
  MarkFailed = 'MARK_FAILED',
  MarkSent = 'MARK_SENT',
  Unknown = 'UNKNOWN'
}

/** Where one load email stands on the send queue. */
export enum LoadEmailStatus {
  /** The send failed; a planner may request it again, which retries this row in place. */
  Failed = 'FAILED',
  /** Reserved and waiting for the worker to claim it. */
  Pending = 'PENDING',
  /** Claimed by the worker under a lease. */
  Sending = 'SENDING',
  /** The provider accepted it, or an operator recorded it as sent. */
  Sent = 'SENT',
  /**
   * Nobody can say whether the provider accepted it. Never retried automatically: an operator closes it
   * through resolveUncertainLoadEmail.
   */
  Uncertain = 'UNCERTAIN',
  /** Unset; no stored row carries it. */
  Unknown = 'UNKNOWN'
}

export type LoadFreightContributionData = {
  __typename?: 'LoadFreightContributionData';
  carrierId: Scalars['String']['output'];
  containers: Scalars['Int']['output'];
  loadContainers: Scalars['Int']['output'];
  loadCost: Scalars['Decimal']['output'];
  loadId: Scalars['String']['output'];
  miles?: Maybe<Scalars['Decimal']['output']>;
  portion: Scalars['Decimal']['output'];
  rateAmount: Scalars['Decimal']['output'];
  rateBasis: CarrierRateBasis;
  share: Scalars['Decimal']['output'];
  stops: Scalars['Int']['output'];
  surcharge: Scalars['Decimal']['output'];
  surchargePercent: Scalars['Decimal']['output'];
};

/** One load's part in an order's load-written freight. Document-only sub-record. */
export type LoadFreightContributionDocument = {
  __typename?: 'LoadFreightContributionDocument';
  carrierId: Scalars['String']['output'];
  containers: Scalars['Int']['output'];
  loadContainers: Scalars['Int']['output'];
  loadCost: Scalars['Decimal']['output'];
  loadId: Scalars['String']['output'];
  miles?: Maybe<Scalars['Decimal']['output']>;
  portion: Scalars['Decimal']['output'];
  rateAmount: Scalars['Decimal']['output'];
  rateBasis: CarrierRateBasis;
  share: Scalars['Decimal']['output'];
  stops: Scalars['Int']['output'];
  surcharge: Scalars['Decimal']['output'];
  surchargePercent: Scalars['Decimal']['output'];
};

/** One load's part in an order's freight. */
export type LoadFreightContributionResult = {
  __typename?: 'LoadFreightContributionResult';
  /** The load's carrier. */
  carrierId: Scalars['String']['output'];
  /** The order's containers on the load. */
  containers: Scalars['Int']['output'];
  /** All containers on the load. */
  loadContainers: Scalars['Int']['output'];
  /** The load's cost before the surcharge, to the cent. */
  loadCost: Scalars['Decimal']['output'];
  /** The load. */
  loadId: Scalars['String']['output'];
  /** The load's number, shown to the planner. */
  loadNumber: Scalars['Int']['output'];
  /** The load's miles as priced; null when it has none. */
  miles?: Maybe<Scalars['Decimal']['output']>;
  /** The load's part of the order's final freight, after the minimum. */
  portion: Scalars['Decimal']['output'];
  /** The carrier's rate. */
  rateAmount: Scalars['Decimal']['output'];
  /** How the carrier prices the load. */
  rateBasis: CarrierRateBasis;
  /** The order's share of the load's cost. */
  share: Scalars['Decimal']['output'];
  /** The stops the load serves. */
  stops: Scalars['Int']['output'];
  /** The surcharge that portion carries. */
  surcharge: Scalars['Decimal']['output'];
  /** The carrier's fuel surcharge percent. */
  surchargePercent: Scalars['Decimal']['output'];
};

/**
 * One order's row in the preview or the apply: its outcome, the calculation and the order's current freight and
 * surcharge, so a skipped or departed order shows both the amount it carries and the amount that would apply.
 */
export type LoadFreightOrderResult = {
  __typename?: 'LoadFreightOrderResult';
  /** The order's containers across its loads. */
  containers: Scalars['Int']['output'];
  /** Each load the freight is built from. */
  contributions: Array<LoadFreightContributionResult>;
  /** The freight the order carries now. */
  currentFreight: Scalars['Decimal']['output'];
  /** The system fuel surcharge the order carries now. */
  currentSurcharge: Scalars['Decimal']['output'];
  /** The freight that applies: the share or the minimum, whichever is more. */
  freight: Scalars['Decimal']['output'];
  /** The outcome in words. */
  message: Scalars['String']['output'];
  /** The order's effective minimum freight; null when none is configured. */
  minimum?: Maybe<Scalars['Decimal']['output']>;
  /** Whether the minimum lifted the freight above the share. */
  minimumApplied: Scalars['Boolean']['output'];
  /** The order. */
  orderId: Scalars['String']['output'];
  /** The order's number. */
  orderNumber: Scalars['String']['output'];
  /** What Apply freight does to the order. */
  outcome: LoadFreightOutcome;
  /** The sum of its shares of its loads' cost, before the minimum. */
  share: Scalars['Decimal']['output'];
  /** Why the order is left alone; null when it is applied or cleared. */
  skipReason?: Maybe<LoadFreightSkipReason>;
  /** The fuel surcharge on that freight. */
  surcharge: Scalars['Decimal']['output'];
  /** The surcharge's basis text, for example "12% of $75.00". */
  surchargeBasis: Scalars['String']['output'];
  /**
   * The containers the order needs that are on no load yet; 0 when its need is met or unknown. Above 0 exactly when
   * the row warns SIBLING_PORTION_UNPLANNED.
   */
  unplannedContainers: Scalars['Int']['output'];
  /** The number of the other load that cannot be priced; null unless the order is skipped as SIBLING_LOAD_UNPRICED. */
  unpricedLoadNumber?: Maybe<Scalars['Int']['output']>;
  /** What the planner should know about the order. */
  warnings: Array<LoadFreightWarning>;
};

/** What Apply freight did, or would do, to one order. */
export enum LoadFreightOutcome {
  /** The order's freight, fuel surcharge and provenance are written. */
  Applied = 'APPLIED',
  /** The order left the load, so the freight the load wrote on it is cleared and it inherits again. */
  Cleared = 'CLEARED',
  /** The order left the load but is final, so its stale load freight stands and needs attention. */
  Reported = 'REPORTED',
  /** The order is left alone; skipReason says why. */
  Skipped = 'SKIPPED'
}

/**
 * The freight Apply freight would write for one load, read-only. Apply it with applyLoadFreight, passing
 * inputRevision back, so the apply writes only what this preview showed.
 */
export type LoadFreightPreview = {
  __typename?: 'LoadFreightPreview';
  /** The revision of every input the calculation read. */
  inputRevision: Scalars['String']['output'];
  /** Why the load cannot be priced; null when it can. Results are empty when it is set. */
  refusal?: Maybe<LoadFreightRefusal>;
  /** One row per order on the load, and per order that left it since the last apply. */
  results: Array<LoadFreightOrderResult>;
};

export type LoadFreightProvenanceData = {
  __typename?: 'LoadFreightProvenanceData';
  contributions: Array<LoadFreightContributionData>;
  freight: Scalars['Decimal']['output'];
  inputRevision: Scalars['String']['output'];
  minimum?: Maybe<Scalars['Decimal']['output']>;
  minimumApplied: Scalars['Boolean']['output'];
  share: Scalars['Decimal']['output'];
  surcharge: Scalars['Decimal']['output'];
  surchargeBasis: Scalars['String']['output'];
};

/**
 * What an order's load-written freight was built from. Document-only sub-record, used by this document and nothing
 * else.
 */
export type LoadFreightProvenanceDocument = {
  __typename?: 'LoadFreightProvenanceDocument';
  contributions: Array<LoadFreightContributionDocument>;
  freight: Scalars['Decimal']['output'];
  inputRevision: Scalars['String']['output'];
  minimum?: Maybe<Scalars['Decimal']['output']>;
  minimumApplied: Scalars['Boolean']['output'];
  share: Scalars['Decimal']['output'];
  surcharge: Scalars['Decimal']['output'];
  surchargeBasis: Scalars['String']['output'];
};

/** Why freight cannot be applied to the load at all, naming the load and, for a missing count, the lines. */
export type LoadFreightRefusal = {
  __typename?: 'LoadFreightRefusal';
  /** The refusal code, as in errors. */
  code: Scalars['String']['output'];
  /** The lines with no container count or a negative one; empty for every other code. */
  lineIds: Array<Scalars['ID']['output']>;
  /** The load. */
  loadId: Scalars['ID']['output'];
  /** The refusal in words. */
  message: Scalars['String']['output'];
};

/** Why Apply freight leaves an order alone. Every order on the load that is not written has one. */
export enum LoadFreightSkipReason {
  /** A live invoice stands for the order. */
  AccountingFinal = 'ACCOUNTING_FINAL',
  /** The order's effective freight type is None, set at its location or customer or inherited. */
  Exempt = 'EXEMPT',
  /** The order came from the external accounting system, which owns its freight. */
  Imported = 'IMPORTED',
  /** A user set the order's freight by hand. */
  ManualFreight = 'MANUAL_FREIGHT',
  /** A load carrying the order has dispatched, or the order's status is accounting-final. */
  PortionAlreadyFinal = 'PORTION_ALREADY_FINAL',
  /** Another load carrying the order cannot be priced, so the order's share cannot be known. */
  SiblingLoadUnpriced = 'SIBLING_LOAD_UNPRICED',
  /** The order left the load after its freight was applied and is final, so the stale charge stands. */
  StaleChargeNeedsAttention = 'STALE_CHARGE_NEEDS_ATTENTION'
}

/** Something the planner should know about an order, whatever its outcome. */
export enum LoadFreightWarning {
  /** Part of the order is not on any load yet, so its freight will change when that part is planned. */
  SiblingPortionUnplanned = 'SIBLING_PORTION_UNPLANNED'
}

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) LoadLine, keyed
 * {tenantId}-{loadLineId}. Deleted rows are removed outright.
 */
export type LoadLineDocument = {
  __typename?: 'LoadLineDocument';
  containerCount?: Maybe<Scalars['Int']['output']>;
  customerName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  loadId: Scalars['String']['output'];
  loadLineId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  routeStopId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) LoadLine, keyed
 * {tenantId}-{loadLineId}. Deleted rows are removed outright.
 */
export type LoadLineDocumentFilterInput = {
  and?: InputMaybe<Array<LoadLineDocumentFilterInput>>;
  containerCount?: InputMaybe<OptionOfInt32FilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  loadId?: InputMaybe<StringOperationFilterInput>;
  loadLineId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LoadLineDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  routeStopId?: InputMaybe<OptionOfStringFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) LoadLine, keyed
 * {tenantId}-{loadLineId}. Deleted rows are removed outright.
 */
export type LoadLineDocumentSortInput = {
  containerCount?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  loadId?: InputMaybe<SortEnumType>;
  loadLineId?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  orderNumber?: InputMaybe<SortEnumType>;
  routeStopId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type LoadLinePayload = {
  __typename?: 'LoadLinePayload';
  errors?: Maybe<Array<ValidationError>>;
  loadLine?: Maybe<LoadLineStateData>;
};

export type LoadLineStateData = {
  __typename?: 'LoadLineStateData';
  containerCount?: Maybe<Scalars['Int']['output']>;
  customerName: Scalars['String']['output'];
  loadId: Scalars['String']['output'];
  loadLineId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  routeStopId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum LoadMilesComputeMode {
  Automatic = 'AUTOMATIC',
  Explicit = 'EXPLICIT'
}

/**
 * GraphQL-output projection of a single load paperwork kind's Report aggregate ID binding. Only
 * kinds the tenant has explicitly bound appear in the bindings list.
 */
export type LoadPaperworkBindingData = {
  __typename?: 'LoadPaperworkBindingData';
  kind: LoadPaperworkKind;
  reportId: Scalars['String']['output'];
};

/** GraphQL-output projection of the tenant's load paperwork settings for the Logistics load screen. */
export type LoadPaperworkData = {
  __typename?: 'LoadPaperworkData';
  bindings: Array<LoadPaperworkBindingData>;
  policy?: Maybe<LoadPaperworkPolicyData>;
};

export enum LoadPaperworkKind {
  DeliveryTicket = 'DELIVERY_TICKET',
  FreightQuote = 'FREIGHT_QUOTE',
  Invoice = 'INVOICE',
  Manifest = 'MANIFEST',
  PullSheet = 'PULL_SHEET',
  Unknown = 'UNKNOWN'
}

/**
 * GraphQL-output projection of the tenant's load paperwork policy — which load paperwork kinds
 * print for a regular load and for a drop-ship load.
 */
export type LoadPaperworkPolicyData = {
  __typename?: 'LoadPaperworkPolicyData';
  dropShip: Array<LoadPaperworkKind>;
  regular: Array<LoadPaperworkKind>;
};

export type LoadPayload = {
  __typename?: 'LoadPayload';
  errors?: Maybe<Array<ValidationError>>;
  load?: Maybe<LoadStateData>;
};

export type LoadStateData = {
  __typename?: 'LoadStateData';
  carrierId?: Maybe<Scalars['String']['output']>;
  containerConfigId?: Maybe<Scalars['String']['output']>;
  containerName: Scalars['String']['output'];
  dockId?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  loadId: Scalars['String']['output'];
  loadNumber: Scalars['Int']['output'];
  miles?: Maybe<Scalars['Decimal']['output']>;
  milesItinerary: Array<Scalars['String']['output']>;
  milesSource: MilesSource;
  pickupWindow?: Maybe<PickupWindowStateData>;
  plannedArrivals: Array<PlannedArrivalStateData>;
  routeId?: Maybe<Scalars['String']['output']>;
  shipDate: Scalars['LocalDate']['output'];
  status: LoadStatus;
  tenantId: Scalars['String']['output'];
  transitKind: TransitKind;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export enum LoadStatus {
  Delivered = 'DELIVERED',
  Dispatched = 'DISPATCHED',
  Loaded = 'LOADED',
  Planning = 'PLANNING',
  Unknown = 'UNKNOWN'
}

export type LoadStatusOperationFilterInput = {
  eq?: InputMaybe<LoadStatus>;
  in?: InputMaybe<Array<LoadStatus>>;
  neq?: InputMaybe<LoadStatus>;
  nin?: InputMaybe<Array<LoadStatus>>;
};

/**
 * One served stop's notice status: what was last requested and sent, and, separately, what the next send
 * would carry.
 */
export type LoadStopNoticeStatus = {
  __typename?: 'LoadStopNoticeStatus';
  /** For a suppressed stop, the order that suppresses it. */
  blockingOrderNumber?: Maybe<Scalars['String']['output']>;
  /** What changed since that send; empty unless stale. */
  changedFields: Array<Scalars['String']['output']>;
  /** The stop's most recent queue row; null when none exists. */
  lastRequest?: Maybe<LoadEmailDocument>;
  /** The stop's most recent send, with the recipients, stop number and planned time it used; null when never sent. */
  lastSent?: Maybe<EmailSendDocument>;
  /** For a stop that is not ready, the missing field. */
  missingField?: Maybe<Scalars['String']['output']>;
  /** The stop's current planned delivery date. */
  plannedDeliveryDate: Scalars['LocalDate']['output'];
  /** The stop's current planned arrival time; null when none is set. */
  plannedTime?: Maybe<Scalars['String']['output']>;
  /** Whether a notice could be sent now. */
  readiness: PlannedArrivalNoticeReadiness;
  /** The recipients the next send would use. */
  recipients: Array<Scalars['String']['output']>;
  /** The route stop. */
  routeStopId: Scalars['String']['output'];
  /** True when the last send for the current planned time differs from the current content. */
  stale: Scalars['Boolean']['output'];
  /** The stop's current position among the load's served stops. */
  stopNumber: Scalars['Int']['output'];
  /** The stop's store name. */
  storeName: Scalars['String']['output'];
  /** Conditions worth attention that do not stop the notice. */
  warnings: Array<PlannedArrivalNoticeWarning>;
};

/** One load's weight for the Loads grid, derived on every read and never stored. */
export type LoadWeight = {
  __typename?: 'LoadWeight';
  /**
   * True when nothing is missing from totalWeightLbs: no order that puts containers on the load has an
   * unweighed or uncounted line, every order on the load could be read, and the load's container type has a
   * weight whenever the load carries containers.
   */
  isComplete: Scalars['Boolean']['output'];
  /** The load this figure is for. */
  loadId: Scalars['String']['output'];
  /**
   * The load's weight in lb: the goods share of each of its orders plus its containers times the weight of
   * the load's container type. The truck is not counted. Partial unless isComplete is true.
   */
  totalWeightLbs: Scalars['Decimal']['output'];
  /**
   * How many containers on the load add no weight: every container on the load when its type has no weight
   * or the load names no container type, otherwise 0.
   */
  unweighedContainerCount: Scalars['Int']['output'];
  /** How many lines add no weight, summed over the orders that put containers on the load. */
  unweighedLineCount: Scalars['Int']['output'];
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LocationAliasData = {
  __typename?: 'LocationAliasData';
  addressId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LocationData = {
  __typename?: 'LocationData';
  adGroup: Scalars['String']['output'];
  address: CreateAddress;
  aliases: Array<LocationAliasData>;
  allowOrderBillingAddressEdit?: Maybe<Scalars['Boolean']['output']>;
  allowOrderLocationAddressEdit?: Maybe<Scalars['Boolean']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  defaultContactId?: Maybe<Scalars['UUID']['output']>;
  description: Scalars['String']['output'];
  effectiveContactId?: Maybe<Scalars['UUID']['output']>;
  effectiveContactInherited: Scalars['Boolean']['output'];
  effectiveReceivingWindowEnd?: Maybe<Scalars['String']['output']>;
  effectiveReceivingWindowStart?: Maybe<Scalars['String']['output']>;
  effectiveUnloadMinutes?: Maybe<Scalars['Int']['output']>;
  freightChargeType?: Maybe<FreightChargeType>;
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  globalLocationNumber: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  locationLookupCode?: Maybe<Scalars['String']['output']>;
  market: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderEmailContactIds: Array<Scalars['UUID']['output']>;
  poRequired?: Maybe<Scalars['Boolean']['output']>;
  priceGroupId?: Maybe<Scalars['String']['output']>;
  priceGroupName?: Maybe<Scalars['String']['output']>;
  receivingEmail?: Maybe<Scalars['String']['output']>;
  receivingWindowEnd?: Maybe<Scalars['String']['output']>;
  receivingWindowStart?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  route?: Maybe<Scalars['String']['output']>;
  salesPeople: Array<SalesPersonData>;
  sendInvoiceEmails?: Maybe<Scalars['Boolean']['output']>;
  sendOrderEmails?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<CustomerLocationSettingsData>;
  storeNumber: Scalars['String']['output'];
  /**
   * Always an empty list. Tax authorities were retired when Stripe Tax took over rates and
   * jurisdictions, so a ship-to no longer carries an authority override and nothing populates
   * this. Retained only so existing queries that select it stay valid; stop selecting it.
   * @deprecated Tax authorities were retired; always empty. Kept for clients that still select it.
   */
  taxAuthorityIds: Array<Scalars['String']['output']>;
  termsId?: Maybe<Scalars['String']['output']>;
  termsName?: Maybe<Scalars['String']['output']>;
  unloadMinutes?: Maybe<Scalars['Int']['output']>;
};

export type LocationDataInput = {
  adGroup: Scalars['String']['input'];
  address: CreateAddressInput;
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  globalLocationNumber: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  locationLookupCode?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['String']['input'];
  name: Scalars['String']['input'];
  poRequired?: InputMaybe<Scalars['Boolean']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  priceGroupName?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  salesPeople: Array<SalesPersonDataInput>;
  sendInvoiceEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendOrderEmails?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<CustomerLocationSettingsDataInput>;
  storeNumber: Scalars['String']['input'];
  /** @deprecated Tax authorities were retired; the value is ignored. Kept for clients that still send it. */
  taxAuthorityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  termsId?: InputMaybe<Scalars['String']['input']>;
  termsName?: InputMaybe<Scalars['String']['input']>;
};

export type LocationDocument = {
  __typename?: 'LocationDocument';
  address?: Maybe<AddressData>;
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationType: LocationType;
  name: Scalars['String']['output'];
  parentLocationId: Scalars['String']['output'];
  siteParentId: Scalars['String']['output'];
  status: LocationStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type LocationDocumentFilterInput = {
  address?: InputMaybe<AddressDataFilterInput>;
  and?: InputMaybe<Array<LocationDocumentFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationType?: InputMaybe<LocationTypeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationDocumentFilterInput>>;
  parentLocationId?: InputMaybe<StringOperationFilterInput>;
  siteParentId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<LocationStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type LocationDocumentSortInput = {
  address?: InputMaybe<AddressDataSortInput>;
  created?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentLocationId?: InputMaybe<SortEnumType>;
  siteParentId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type LocationInUsePayload = {
  __typename?: 'LocationInUsePayload';
  errors?: Maybe<Array<ValidationError>>;
  report?: Maybe<LocationInUseReport>;
};

/** What still references a site or a sub-location subtree. Nothing is written to build it. */
export type LocationInUseReport = {
  __typename?: 'LocationInUseReport';
  /** True when any record references any of the locations. */
  inUse: Scalars['Boolean']['output'];
  /** The sub-location asked about, or null for the whole site. */
  locationId?: Maybe<Scalars['String']['output']>;
  /** Every location id the report covers. */
  locationIds: Array<Scalars['String']['output']>;
  /** Up to 50 records per kind. */
  references: Array<SubLocationReference>;
  /** The site the report was read on. */
  siteLocationId: Scalars['String']['output'];
  /** The full count per kind, only for kinds with at least one reference. */
  totals: Array<LocationReferenceTotal>;
};

/**
 * Append-only overhead rate history document. One doc per (tenantId, siteLocationId, subLocationId?, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LocationOverheadRateDocument = {
  __typename?: 'LocationOverheadRateDocument';
  costPerSqFtPerWeek: Scalars['Decimal']['output'];
  /**
   * Set when the owning site or sub-location was cascade-deactivated; None otherwise.
   * Typed as Option{T} per discipline 5a153a332f5f4f338cfe45d2f46870ef.
   * OptionBsonSerializer stores None as BSON null and Some(v) as the raw value,
   * so the on-disk shape matches the prior DateTimeOffset? field — additive
   * migration only, no collection drop required.
   * Queries default to filtering deactivated rows out; admin views can opt in via
   * includeDeactivated: true on paginated history resolvers.
   */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  /** Null for site-level rates; non-null for per-sub-location overrides. */
  subLocationId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * Append-only overhead rate history document. One doc per (tenantId, siteLocationId, subLocationId?, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LocationOverheadRateDocumentFilterInput = {
  and?: InputMaybe<Array<LocationOverheadRateDocumentFilterInput>>;
  costPerSqFtPerWeek?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Set when the owning site or sub-location was cascade-deactivated; None otherwise.
   * Typed as Option{T} per discipline 5a153a332f5f4f338cfe45d2f46870ef.
   * OptionBsonSerializer stores None as BSON null and Some(v) as the raw value,
   * so the on-disk shape matches the prior DateTimeOffset? field — additive
   * migration only, no collection drop required.
   * Queries default to filtering deactivated rows out; admin views can opt in via
   * includeDeactivated: true on paginated history resolvers.
   */
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveTo?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationOverheadRateDocumentFilterInput>>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  /** Null for site-level rates; non-null for per-sub-location overrides. */
  subLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Append-only overhead rate history document. One doc per (tenantId, siteLocationId, subLocationId?, effectiveFrom)
 * bucket. Rewriting the same event produces a byte-identical document (deterministic composite _id).
 */
export type LocationOverheadRateDocumentSortInput = {
  costPerSqFtPerWeek?: InputMaybe<SortEnumType>;
  /**
   * Set when the owning site or sub-location was cascade-deactivated; None otherwise.
   * Typed as Option{T} per discipline 5a153a332f5f4f338cfe45d2f46870ef.
   * OptionBsonSerializer stores None as BSON null and Some(v) as the raw value,
   * so the on-disk shape matches the prior DateTimeOffset? field — additive
   * migration only, no collection drop required.
   * Queries default to filtering deactivated rows out; admin views can opt in via
   * includeDeactivated: true on paginated history resolvers.
   */
  deactivatedAt?: InputMaybe<SortEnumType>;
  effectiveFrom?: InputMaybe<SortEnumType>;
  effectiveTo?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  /** Null for site-level rates; non-null for per-sub-location overrides. */
  subLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LocationOverheadRatesConnection = {
  __typename?: 'LocationOverheadRatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationOverheadRatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LocationOverheadRateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationOverheadRatesEdge = {
  __typename?: 'LocationOverheadRatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LocationOverheadRateDocument;
};

export type LocationPayload = {
  __typename?: 'LocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  location?: Maybe<LocationDocument>;
};

/** How many records of one kind reference the report's locations. */
export type LocationReferenceTotal = {
  __typename?: 'LocationReferenceTotal';
  count: Scalars['Long']['output'];
  kind: SubLocationReferenceKind;
};

export type LocationStateData = {
  __typename?: 'LocationStateData';
  erpId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationType: SiteLocationType;
  name: Scalars['String']['output'];
  parentLocationId: Scalars['String']['output'];
  pickSequence?: Maybe<Scalars['Int']['output']>;
  status: LocationStatus;
};

export enum LocationStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type LocationStatusOperationFilterInput = {
  eq?: InputMaybe<LocationStatus>;
  in?: InputMaybe<Array<LocationStatus>>;
  neq?: InputMaybe<LocationStatus>;
  nin?: InputMaybe<Array<LocationStatus>>;
};

export enum LocationType {
  Aisle = 'AISLE',
  Bay = 'BAY',
  Bin = 'BIN',
  Customer = 'CUSTOMER',
  Field = 'FIELD',
  House = 'HOUSE',
  Section = 'SECTION',
  ShipTo = 'SHIP_TO',
  Site = 'SITE',
  Staging = 'STAGING',
  Unknown = 'UNKNOWN',
  Warehouse = 'WAREHOUSE'
}

export type LocationTypeOperationFilterInput = {
  eq?: InputMaybe<LocationType>;
  in?: InputMaybe<Array<LocationType>>;
  neq?: InputMaybe<LocationType>;
  nin?: InputMaybe<Array<LocationType>>;
};

/** A connection to a list of items. */
export type LocationsConnection = {
  __typename?: 'LocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationsEdge = {
  __typename?: 'LocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LocationDocument;
};

/** A connection to a list of items. */
export type LocationsSalesPeopleConnection = {
  __typename?: 'LocationsSalesPeopleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationsSalesPeopleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LocationsSalesPersonDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationsSalesPeopleEdge = {
  __typename?: 'LocationsSalesPeopleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LocationsSalesPersonDocument;
};

export type LocationsSalesPersonDocument = {
  __typename?: 'LocationsSalesPersonDocument';
  code: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  salesPersonEmails: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type LocationsSalesPersonDocumentFilterInput = {
  and?: InputMaybe<Array<LocationsSalesPersonDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationsSalesPersonDocumentFilterInput>>;
  salesPersonEmails?: InputMaybe<ListStringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type LocationsSalesPersonDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type LockedAlgorithmSettings = {
  __typename?: 'LockedAlgorithmSettings';
  defaultTargetWeeksOfSupply: Scalars['Decimal']['output'];
  forwardDaysLastYear: Scalars['Int']['output'];
  inventoryTrailingDays: Scalars['Int']['output'];
  sellThroughThreshold?: Maybe<Scalars['Decimal']['output']>;
  trailingDaysThisYear: Scalars['Int']['output'];
};

export type LockedAlgorithmSettingsFilterInput = {
  and?: InputMaybe<Array<LockedAlgorithmSettingsFilterInput>>;
  defaultTargetWeeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
  forwardDaysLastYear?: InputMaybe<IntOperationFilterInput>;
  inventoryTrailingDays?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<LockedAlgorithmSettingsFilterInput>>;
  sellThroughThreshold?: InputMaybe<DecimalOperationFilterInput>;
  trailingDaysThisYear?: InputMaybe<IntOperationFilterInput>;
};

export type LockedAlgorithmSettingsSortInput = {
  defaultTargetWeeksOfSupply?: InputMaybe<SortEnumType>;
  forwardDaysLastYear?: InputMaybe<SortEnumType>;
  inventoryTrailingDays?: InputMaybe<SortEnumType>;
  sellThroughThreshold?: InputMaybe<SortEnumType>;
  trailingDaysThisYear?: InputMaybe<SortEnumType>;
};

export type LockedBusinessRules = {
  __typename?: 'LockedBusinessRules';
  allocationPriorities: Array<AllocationPriorityDimension>;
  allocationReservationPercentage: Scalars['Decimal']['output'];
  allocationType: AllocationType;
  minUsableDaysThreshold?: Maybe<Scalars['Int']['output']>;
  roundToFullCart: Scalars['Boolean']['output'];
  shipmentIncrement: Scalars['Int']['output'];
};

export type LockedBusinessRulesFilterInput = {
  allocationPriorities?: InputMaybe<ListAllocationPriorityDimensionOperationFilterInput>;
  allocationReservationPercentage?: InputMaybe<DecimalOperationFilterInput>;
  allocationType?: InputMaybe<AllocationTypeOperationFilterInput>;
  and?: InputMaybe<Array<LockedBusinessRulesFilterInput>>;
  minUsableDaysThreshold?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<LockedBusinessRulesFilterInput>>;
  roundToFullCart?: InputMaybe<BooleanOperationFilterInput>;
  shipmentIncrement?: InputMaybe<IntOperationFilterInput>;
};

export type LockedBusinessRulesSortInput = {
  allocationReservationPercentage?: InputMaybe<SortEnumType>;
  allocationType?: InputMaybe<SortEnumType>;
  minUsableDaysThreshold?: InputMaybe<SortEnumType>;
  roundToFullCart?: InputMaybe<SortEnumType>;
  shipmentIncrement?: InputMaybe<SortEnumType>;
};

export type LockedLocationOverride = {
  __typename?: 'LockedLocationOverride';
  customerLocationId: Scalars['String']['output'];
};

export type LockedLocationOverrideFilterInput = {
  and?: InputMaybe<Array<LockedLocationOverrideFilterInput>>;
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LockedLocationOverrideFilterInput>>;
};

export type LockedRestockConfig = {
  __typename?: 'LockedRestockConfig';
  algorithmSettings: LockedAlgorithmSettings;
  businessRules: LockedBusinessRules;
  locationOverrides: Array<LockedLocationOverride>;
  providerConfigJson: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
};

export type LockedRestockConfigFilterInput = {
  algorithmSettings?: InputMaybe<LockedAlgorithmSettingsFilterInput>;
  and?: InputMaybe<Array<LockedRestockConfigFilterInput>>;
  businessRules?: InputMaybe<LockedBusinessRulesFilterInput>;
  locationOverrides?: InputMaybe<ListFilterInputTypeOfLockedLocationOverrideFilterInput>;
  or?: InputMaybe<Array<LockedRestockConfigFilterInput>>;
  providerConfigJson?: InputMaybe<StringOperationFilterInput>;
  providerKey?: InputMaybe<StringOperationFilterInput>;
};

export type LockedRestockConfigSortInput = {
  algorithmSettings?: InputMaybe<LockedAlgorithmSettingsSortInput>;
  businessRules?: InputMaybe<LockedBusinessRulesSortInput>;
  providerConfigJson?: InputMaybe<SortEnumType>;
  providerKey?: InputMaybe<SortEnumType>;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Carrier, keyed
 * {tenantId}-{carrierId}. Named LogisticsCarrierDocument (not CarrierDocument)
 * to stay distinct from the unrelated, pre-existing CarrierDocument GraphQL type (the
 * free-text carrier-name normalization read model in Features.Carriers). Deleted rows are
 * removed outright.
 */
export type LogisticsCarrierDocument = {
  __typename?: 'LogisticsCarrierDocument';
  carrierId: Scalars['String']['output'];
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone: Scalars['String']['output'];
  dotNumber: Scalars['String']['output'];
  fuelSurchargePercent?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  mcNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  rateAmount?: Maybe<Scalars['Decimal']['output']>;
  rateBasis: CarrierRateBasis;
  tenantId: Scalars['String']['output'];
  type: CarrierType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Carrier, keyed
 * {tenantId}-{carrierId}. Named LogisticsCarrierDocument (not CarrierDocument)
 * to stay distinct from the unrelated, pre-existing CarrierDocument GraphQL type (the
 * free-text carrier-name normalization read model in Features.Carriers). Deleted rows are
 * removed outright.
 */
export type LogisticsCarrierDocumentFilterInput = {
  and?: InputMaybe<Array<LogisticsCarrierDocumentFilterInput>>;
  carrierId?: InputMaybe<StringOperationFilterInput>;
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  dotNumber?: InputMaybe<StringOperationFilterInput>;
  fuelSurchargePercent?: InputMaybe<OptionOfDecimalFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  mcNumber?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LogisticsCarrierDocumentFilterInput>>;
  rateAmount?: InputMaybe<OptionOfDecimalFilterInput>;
  rateBasis?: InputMaybe<CarrierRateBasisOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<CarrierTypeOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Carrier, keyed
 * {tenantId}-{carrierId}. Named LogisticsCarrierDocument (not CarrierDocument)
 * to stay distinct from the unrelated, pre-existing CarrierDocument GraphQL type (the
 * free-text carrier-name normalization read model in Features.Carriers). Deleted rows are
 * removed outright.
 */
export type LogisticsCarrierDocumentSortInput = {
  carrierId?: InputMaybe<SortEnumType>;
  contactEmail?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  contactPhone?: InputMaybe<SortEnumType>;
  dotNumber?: InputMaybe<SortEnumType>;
  fuelSurchargePercent?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  mcNumber?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  rateAmount?: InputMaybe<SortEnumType>;
  rateBasis?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type LogisticsCarrierPayload = {
  __typename?: 'LogisticsCarrierPayload';
  carrier?: Maybe<LogisticsCarrierStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type LogisticsCarrierStateData = {
  __typename?: 'LogisticsCarrierStateData';
  carrierId: Scalars['String']['output'];
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone: Scalars['String']['output'];
  dotNumber: Scalars['String']['output'];
  fuelSurchargePercent?: Maybe<Scalars['Decimal']['output']>;
  isActive: Scalars['Boolean']['output'];
  mcNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  rateAmount?: Maybe<Scalars['Decimal']['output']>;
  rateBasis: CarrierRateBasis;
  tenantId: Scalars['String']['output'];
  type: CarrierType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type LogisticsCarriersConnection = {
  __typename?: 'LogisticsCarriersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsCarriersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LogisticsCarrierDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsCarriersEdge = {
  __typename?: 'LogisticsCarriersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LogisticsCarrierDocument;
};

/** A connection to a list of items. */
export type LogisticsDeliveryOrderPortionsConnection = {
  __typename?: 'LogisticsDeliveryOrderPortionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsDeliveryOrderPortionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeliveryOrderPortionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsDeliveryOrderPortionsEdge = {
  __typename?: 'LogisticsDeliveryOrderPortionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeliveryOrderPortionDocument;
};

/** A connection to a list of items. */
export type LogisticsDeliveryStopsConnection = {
  __typename?: 'LogisticsDeliveryStopsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsDeliveryStopsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeliveryStopDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsDeliveryStopsEdge = {
  __typename?: 'LogisticsDeliveryStopsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeliveryStopDocument;
};

/** A connection to a list of items. */
export type LogisticsDeliverySummariesConnection = {
  __typename?: 'LogisticsDeliverySummariesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsDeliverySummariesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeliverySummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsDeliverySummariesEdge = {
  __typename?: 'LogisticsDeliverySummariesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeliverySummaryDocument;
};

/**
 * Read-model document for one FULFILL Logistics Dock, keyed {tenantId}-{dockId}. Deleted
 * rows are removed outright.
 */
export type LogisticsDockDocument = {
  __typename?: 'LogisticsDockDocument';
  dockId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  /** The most loads the Dock takes on one ship date, 1 to 99. Null is no limit; the limit only warns. */
  loadsPerDay?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Read-model document for one FULFILL Logistics Dock, keyed {tenantId}-{dockId}. Deleted
 * rows are removed outright.
 */
export type LogisticsDockDocumentFilterInput = {
  and?: InputMaybe<Array<LogisticsDockDocumentFilterInput>>;
  dockId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  /** The most loads the Dock takes on one ship date, 1 to 99. Null is no limit; the limit only warns. */
  loadsPerDay?: InputMaybe<OptionOfInt32FilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LogisticsDockDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one FULFILL Logistics Dock, keyed {tenantId}-{dockId}. Deleted
 * rows are removed outright.
 */
export type LogisticsDockDocumentSortInput = {
  dockId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  /** The most loads the Dock takes on one ship date, 1 to 99. Null is no limit; the limit only warns. */
  loadsPerDay?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type LogisticsDockPayload = {
  __typename?: 'LogisticsDockPayload';
  dock?: Maybe<LogisticsDockStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type LogisticsDockStateData = {
  __typename?: 'LogisticsDockStateData';
  dockId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  loadsPerDay?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type LogisticsDocksConnection = {
  __typename?: 'LogisticsDocksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsDocksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LogisticsDockDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsDocksEdge = {
  __typename?: 'LogisticsDocksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LogisticsDockDocument;
};

/** A connection to a list of items. */
export type LogisticsDriversConnection = {
  __typename?: 'LogisticsDriversConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsDriversEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DriverDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsDriversEdge = {
  __typename?: 'LogisticsDriversEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DriverDocument;
};

/** A connection to a list of items. */
export type LogisticsLoadLinesByOrderConnection = {
  __typename?: 'LogisticsLoadLinesByOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsLoadLinesByOrderEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LoadLineDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsLoadLinesByOrderEdge = {
  __typename?: 'LogisticsLoadLinesByOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LoadLineDocument;
};

/** A connection to a list of items. */
export type LogisticsLoadLinesConnection = {
  __typename?: 'LogisticsLoadLinesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsLoadLinesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LoadLineDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsLoadLinesEdge = {
  __typename?: 'LogisticsLoadLinesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LoadLineDocument;
};

/** A connection to a list of items. */
export type LogisticsLoadsByShipDateConnection = {
  __typename?: 'LogisticsLoadsByShipDateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsLoadsByShipDateEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LoadDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsLoadsByShipDateEdge = {
  __typename?: 'LogisticsLoadsByShipDateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LoadDocument;
};

/** A connection to a list of items. */
export type LogisticsLoadsConnection = {
  __typename?: 'LogisticsLoadsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsLoadsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LoadDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsLoadsEdge = {
  __typename?: 'LogisticsLoadsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LoadDocument;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) LogisticsRoute, keyed
 * {tenantId}-{routeId}, carrying its embedded ordered stop list. Named
 * LogisticsRouteDocument (not RouteDocument) to stay distinct from the unrelated,
 * pre-existing RouteDocument GraphQL type (the ERP-load-list route reference in
 * Features.Routes). Deleted rows are removed outright.
 */
export type LogisticsRouteDocument = {
  __typename?: 'LogisticsRouteDocument';
  code: Scalars['String']['output'];
  defaultVehicleId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  driverId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdHoc: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  routeId: Scalars['String']['output'];
  stops: Array<RouteStopData>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) LogisticsRoute, keyed
 * {tenantId}-{routeId}, carrying its embedded ordered stop list. Named
 * LogisticsRouteDocument (not RouteDocument) to stay distinct from the unrelated,
 * pre-existing RouteDocument GraphQL type (the ERP-load-list route reference in
 * Features.Routes). Deleted rows are removed outright.
 */
export type LogisticsRouteDocumentFilterInput = {
  and?: InputMaybe<Array<LogisticsRouteDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  defaultVehicleId?: InputMaybe<OptionOfStringFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  driverId?: InputMaybe<OptionOfStringFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isAdHoc?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LogisticsRouteDocumentFilterInput>>;
  routeId?: InputMaybe<StringOperationFilterInput>;
  stops?: InputMaybe<ListFilterInputTypeOfRouteStopDataFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) LogisticsRoute, keyed
 * {tenantId}-{routeId}, carrying its embedded ordered stop list. Named
 * LogisticsRouteDocument (not RouteDocument) to stay distinct from the unrelated,
 * pre-existing RouteDocument GraphQL type (the ERP-load-list route reference in
 * Features.Routes). Deleted rows are removed outright.
 */
export type LogisticsRouteDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  defaultVehicleId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  driverId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isAdHoc?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  routeId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type LogisticsRoutePayload = {
  __typename?: 'LogisticsRoutePayload';
  errors?: Maybe<Array<ValidationError>>;
  logisticsRoute?: Maybe<LogisticsRouteStateData>;
};

export type LogisticsRouteStateData = {
  __typename?: 'LogisticsRouteStateData';
  code: Scalars['String']['output'];
  defaultVehicleId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  driverId?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAdHoc: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  routeId: Scalars['String']['output'];
  stops: Array<RouteStopStateData>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type LogisticsRoutesConnection = {
  __typename?: 'LogisticsRoutesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsRoutesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LogisticsRouteDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsRoutesEdge = {
  __typename?: 'LogisticsRoutesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LogisticsRouteDocument;
};

/** A connection to a list of items. */
export type LogisticsVehicleTypesConnection = {
  __typename?: 'LogisticsVehicleTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsVehicleTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VehicleTypeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsVehicleTypesEdge = {
  __typename?: 'LogisticsVehicleTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VehicleTypeDocument;
};

/** A connection to a list of items. */
export type LogisticsVehiclesConnection = {
  __typename?: 'LogisticsVehiclesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LogisticsVehiclesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VehicleDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogisticsVehiclesEdge = {
  __typename?: 'LogisticsVehiclesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VehicleDocument;
};

export type LogoImageDataInput = {
  image: Scalars['String']['input'];
  mime: Scalars['String']['input'];
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

/** What a lot change sets. Explicit ordinals keep the GraphQL enum stable; never reorder or reuse one. */
export enum LotChangeKind {
  /** Sets the lot's customer, or clears it (a spec lot) when the value is blank. */
  Customer = 'CUSTOMER',
  /** Sets the lot's own customer group, or clears it when the value is blank. */
  CustomerGroup = 'CUSTOMER_GROUP',
  /** Moves the lot's job to another location. The value is the location id. */
  Location = 'LOCATION',
  /** Moves the lot to another production plan. The value is the plan id. */
  Plan = 'PLAN',
  /** Not a change. Never accepted on a request; a stored item that names it is not a lot change. */
  Unknown = 'UNKNOWN'
}

/**
 * The filter the Production Schedule grid query takes, as agGridRows reads it: the same filter model and
 * search text, resolved for the caller's tenant.
 */
export type LotChangesScheduleFilterInput = {
  /** The grid's filter model; none selects every row the caller can see. */
  filterModel?: InputMaybe<Scalars['JSON']['input']>;
  /** The grid's search text, if any. */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Which lots a LOT_CHANGES request changes, and how, when the screen does not list
 * the lots itself. The server resolves it to lot ids when the job is requested and stores one item per lot; the
 * job then runs those lots whatever the schedule looks like later.
 */
export type LotChangesSelectorInput = {
  /** What to change. */
  kind: LotChangeKind;
  /** The lots to change. Send this or scheduleFilter, not both. */
  productionLotIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The Production Schedule filter whose rows to change (Select All). */
  scheduleFilter?: InputMaybe<LotChangesScheduleFilterInput>;
  /**
   * The new plan id or location id, which a plan or location change needs. The new customer id or customer group id
   * for those kinds; blank clears it.
   */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum LotClosedStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  PartiallyPosted = 'PARTIALLY_POSTED'
}

export type LotClosedStatusOperationFilterInput = {
  eq?: InputMaybe<LotClosedStatus>;
  in?: InputMaybe<Array<LotClosedStatus>>;
  neq?: InputMaybe<LotClosedStatus>;
  nin?: InputMaybe<Array<LotClosedStatus>>;
};

/**
 * Which lots a LOT_DEACTIVATE request deactivates: the lots listed, or the rows of the Production Schedule
 * filter (Select All). Resolved to lot ids when the job is requested, by the same resolver as LOT_CHANGES.
 */
export type LotDeactivateSelectorInput = {
  /** The lots to deactivate. Send this or scheduleFilter, not both. */
  productionLotIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The Production Schedule filter whose rows to deactivate (Select All). */
  scheduleFilter?: InputMaybe<LotChangesScheduleFilterInput>;
};

/**
 * Which jobs a LOT_WEEK_OVERRIDES request moves, and to which weeks, when the screen does not list each lot's
 * rows itself. The lots (or the schedule rows of the filter) are resolved when the job is requested; every job found is
 * given the same new weeks. A listed lot moves its top-level job; a schedule row moves the job it names. One item
 * per lot carries all of that lot's jobs.
 */
export type LotWeekOverridesSelectorInput = {
  /** The new week-ready Monday; none leaves the ready week alone. */
  newWeekReadyDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The new week-start Monday; none leaves the start week alone. A moved start week reschedules the job's descendants. */
  newWeekStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The lots whose top-level job to move. Send this or scheduleFilter, not both. */
  productionLotIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The Production Schedule filter whose rows' jobs to move (Select All). */
  scheduleFilter?: InputMaybe<LotChangesScheduleFilterInput>;
};

/**
 * Result of a connect/disconnect mutation: the resulting mailbox status (connected flag + address,
 * never tokens) or the validation error(s) that stopped it.
 */
export type M365MailboxConnectPayload = {
  __typename?: 'M365MailboxConnectPayload';
  errors?: Maybe<Array<ValidationError>>;
  status?: Maybe<M365MailboxStatus>;
};

/**
 * GraphQL view of a user's M365 mailbox connection: whether it is connected, when it is, the mailbox
 * address, and whether the connection can actually send mail. Never carries tokens.
 */
export type M365MailboxStatus = {
  __typename?: 'M365MailboxStatus';
  connected: Scalars['Boolean']['output'];
  /**
   * Whether this connection's granted permissions include sending mail, as observed at the last
   * connect or reconnect. Lets a client distinguish a connection that can only create drafts from one
   * that can send. Reads false for a connection made before the send permission was
   * requested, for a connection whose record predates send-capability being stored at all, and for a
   * fresh grant that did not include Mail.Send — in every case, reconnecting re-authorizes and
   * flips this to true when the new grant includes Mail.Send.
   */
  grantsSendScope: Scalars['Boolean']['output'];
  mailboxAddress?: Maybe<Scalars['String']['output']>;
};

/**
 * Read-model binding between a make-to-order production lot and the order line that drove its
 * creation (Phase 2 FULFILL→PRODUCE bridge). One document per (TenantId, ProductionLotId), keyed by
 * the composite _id so lookups use the free primary index. Projected from
 * Production.V1.ProductionPlanCreatedForOrderLine by ProductionLotProjectionService via
 * a pure absolute upsert — every value rides on the event (Atlas accaf08f), so replaying the create
 * event re-writes the same document with no drift. Surfaces the binding the downstream born-Reserved
 * pegging saga consumes; the reservation write itself is a separate task.
 */
export type MakeToOrderPlanDocument = {
  __typename?: 'MakeToOrderPlanDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * The customer on the source order, carried on the binding event so the make-to-order plan
   *             reflects the order's customer (and the "Linked Orders" surface shows it) without joining back to the
   *             order. None when the source order had no customer.
   */
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderLineId: Scalars['String']['output'];
  /**
   * The sales item the order line mapped to when the plan was made, when an item combine has since moved
   * the plan to the item it was combined into (salesItemId); null when no combine moved it.
   */
  originalSalesItemId?: Maybe<Scalars['String']['output']>;
  /**
   * The production item chosen to source this plan — the explicit pick on a 1:N
   *             sales-item→production-item mapping. None when the mapping was unambiguous and no explicit
   *             choice was supplied.
   */
  productionItemId?: Maybe<Scalars['String']['output']>;
  /** The finish (root) job of the minted lot — the job the reservation pegs against. */
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  /** The sales eaches this plan reserves for the order line. The container count is the lot's quantity. */
  quantity: Scalars['Int']['output'];
  /** Resolved sales item the order line maps to. None only for a malformed payload. */
  salesItemId?: Maybe<Scalars['String']['output']>;
  /** The order line's delivery week the plan was pre-filled to. */
  targetDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * Read-model binding between a make-to-order production lot and the order line that drove its
 * creation (Phase 2 FULFILL→PRODUCE bridge). One document per (TenantId, ProductionLotId), keyed by
 * the composite _id so lookups use the free primary index. Projected from
 * Production.V1.ProductionPlanCreatedForOrderLine by ProductionLotProjectionService via
 * a pure absolute upsert — every value rides on the event (Atlas accaf08f), so replaying the create
 * event re-writes the same document with no drift. Surfaces the binding the downstream born-Reserved
 * pegging saga consumes; the reservation write itself is a separate task.
 */
export type MakeToOrderPlanDocumentFilterInput = {
  and?: InputMaybe<Array<MakeToOrderPlanDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer on the source order, carried on the binding event so the make-to-order plan
   *             reflects the order's customer (and the "Linked Orders" surface shows it) without joining back to the
   *             order. None when the source order had no customer.
   */
  customerId?: InputMaybe<OptionOfStringFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MakeToOrderPlanDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderLineId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The sales item the order line mapped to when the plan was made, when an item combine has since moved
   * the plan to the item it was combined into (salesItemId); null when no combine moved it.
   */
  originalSalesItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The production item chosen to source this plan — the explicit pick on a 1:N
   *             sales-item→production-item mapping. None when the mapping was unambiguous and no explicit
   *             choice was supplied.
   */
  productionItemId?: InputMaybe<OptionOfStringFilterInput>;
  /** The finish (root) job of the minted lot — the job the reservation pegs against. */
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  /** The sales eaches this plan reserves for the order line. The container count is the lot's quantity. */
  quantity?: InputMaybe<IntOperationFilterInput>;
  /** Resolved sales item the order line maps to. None only for a malformed payload. */
  salesItemId?: InputMaybe<OptionOfStringFilterInput>;
  /** The order line's delivery week the plan was pre-filled to. */
  targetDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model binding between a make-to-order production lot and the order line that drove its
 * creation (Phase 2 FULFILL→PRODUCE bridge). One document per (TenantId, ProductionLotId), keyed by
 * the composite _id so lookups use the free primary index. Projected from
 * Production.V1.ProductionPlanCreatedForOrderLine by ProductionLotProjectionService via
 * a pure absolute upsert — every value rides on the event (Atlas accaf08f), so replaying the create
 * event re-writes the same document with no drift. Surfaces the binding the downstream born-Reserved
 * pegging saga consumes; the reservation write itself is a separate task.
 */
export type MakeToOrderPlanDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * The customer on the source order, carried on the binding event so the make-to-order plan
   *             reflects the order's customer (and the "Linked Orders" surface shows it) without joining back to the
   *             order. None when the source order had no customer.
   */
  customerId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  orderLineId?: InputMaybe<SortEnumType>;
  /**
   * The sales item the order line mapped to when the plan was made, when an item combine has since moved
   * the plan to the item it was combined into (salesItemId); null when no combine moved it.
   */
  originalSalesItemId?: InputMaybe<SortEnumType>;
  /**
   * The production item chosen to source this plan — the explicit pick on a 1:N
   *             sales-item→production-item mapping. None when the mapping was unambiguous and no explicit
   *             choice was supplied.
   */
  productionItemId?: InputMaybe<SortEnumType>;
  /** The finish (root) job of the minted lot — the job the reservation pegs against. */
  productionJobId?: InputMaybe<SortEnumType>;
  productionLotId?: InputMaybe<SortEnumType>;
  /** The sales eaches this plan reserves for the order line. The container count is the lot's quantity. */
  quantity?: InputMaybe<SortEnumType>;
  /** Resolved sales item the order line maps to. None only for a malformed payload. */
  salesItemId?: InputMaybe<SortEnumType>;
  /** The order line's delivery week the plan was pre-filled to. */
  targetDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type MakeToOrderPlanLineInput = {
  orderId: Scalars['String']['input'];
  orderLineId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

/**
 * When one line's lot would start and ship. Weeks are Monday dates. PlugStartWeek is the week the
 * chain's earliest job starts, and is null when the recipe has no job under the finish job. A line that
 * cannot be planned carries errors and no timing.
 */
export type MakeToOrderPlanLineTiming = {
  __typename?: 'MakeToOrderPlanLineTiming';
  errors?: Maybe<Array<ValidationError>>;
  finishGrowWeeks?: Maybe<Scalars['Int']['output']>;
  orderLineId: Scalars['String']['output'];
  plugStartWeek?: Maybe<Scalars['DateTime']['output']>;
  shipWeek?: Maybe<Scalars['DateTime']['output']>;
  transplantWeek?: Maybe<Scalars['DateTime']['output']>;
};

/** Eaches one order line would take from an Active spec lot already growing for its item. */
export type MakeToOrderPlanPreviewFill = {
  __typename?: 'MakeToOrderPlanPreviewFill';
  /** The line's sales item. */
  itemName: Scalars['String']['output'];
  /** The growing lot's number. */
  lotNumber: Scalars['Int']['output'];
  /** The order. */
  orderId: Scalars['String']['output'];
  /** The order line, without dashes: allocateProductionLotToOrderLine's orderLineId. */
  orderLineId: Scalars['String']['output'];
  /** The order's number. */
  orderNumber: Scalars['String']['output'];
  /** The line's ordered eaches: allocateProductionLotToOrderLine's orderedQty. */
  orderedQuantity: Scalars['Int']['output'];
  /** The growing lot: allocateProductionLotToOrderLine's productionLotId. */
  productionLotId: Scalars['String']['output'];
  /** Eaches to allocate from this lot: allocateProductionLotToOrderLine's allocatedQty. */
  quantity: Scalars['Int']['output'];
  /** Monday of the lot's ready week. */
  readyWeek: Scalars['DateTime']['output'];
};

/** The lines that share one lot: the same production item, ready week, sales item and pack size. Two groups can have the same item and week when their sales item or pack size differs, because a lot rounds to one container size. */
export type MakeToOrderPlanPreviewGroup = {
  __typename?: 'MakeToOrderPlanPreviewGroup';
  /** Set when every line in the group is for this customer. */
  customerId?: Maybe<Scalars['String']['output']>;
  /** The lines in the group. */
  lines: Array<MakeToOrderPlanPreviewLine>;
  /** The lines' total rounded once to the container size. */
  lotQuantity: Scalars['Int']['output'];
  /** The production item the lot makes. */
  productionItemId: Scalars['String']['output'];
  /** The production item's number, as the lot lists it. */
  productionItemName: Scalars['String']['output'];
  /** Monday of the ready week. */
  readyWeek: Scalars['DateTime']['output'];
};

/** The orders whose lines makeToOrderPlanPreview groups, and the choices every lot shares. */
export type MakeToOrderPlanPreviewInput = {
  /** Fill untouched lines from Active spec lots already growing for the item and ready by the order's delivery week, before grouping the rest into new lots. */
  fillFromGrowingLots?: Scalars['Boolean']['input'];
  /** The lots' location, the same for every group. */
  locationId?: InputMaybe<Scalars['String']['input']>;
  /** 1 to 200 orders. */
  orderIds: Array<Scalars['String']['input']>;
  /** Whether the lots would be planned as Pre-finish, the same for every group. */
  preFinished?: Scalars['Boolean']['input'];
  /** The plan the lots would sit under. */
  productionPlanId: Scalars['String']['input'];
};

/** One order line that would go into a lot. */
export type MakeToOrderPlanPreviewLine = {
  __typename?: 'MakeToOrderPlanPreviewLine';
  /** The order's customer name. */
  customerName: Scalars['String']['output'];
  /** The order's expected delivery date. */
  expectedDeliveryDate: Scalars['DateTime']['output'];
  /** The line's sales item. */
  itemName: Scalars['String']['output'];
  /** The order. */
  orderId: Scalars['String']['output'];
  /** The order line. */
  orderLineId: Scalars['String']['output'];
  /** The order's number. */
  orderNumber: Scalars['String']['output'];
  /** The eaches the lot plans for the line: what production lots do not already cover. */
  quantity: Scalars['Int']['output'];
};

/** What makeToOrderPlanPreview returns: the groups, what was skipped, and any refusal. */
export type MakeToOrderPlanPreviewPayload = {
  __typename?: 'MakeToOrderPlanPreviewPayload';
  /** Why the whole call was refused (order count, access, plan, location or a read failure); null when it ran. */
  errors?: Maybe<Array<ValidationError>>;
  /** Null unless fillFromGrowingLots. */
  fills?: Maybe<Array<MakeToOrderPlanPreviewFill>>;
  /** The lots the lines would make; null when the call was refused. */
  groups?: Maybe<Array<MakeToOrderPlanPreviewGroup>>;
  /** Null unless fillFromGrowingLots. */
  shortfalls?: Maybe<Array<MakeToOrderPlanPreviewShortfall>>;
  /** The orders and lines left out, with the reason; null when the call was refused. */
  skipped?: Maybe<Array<MakeToOrderPlanPreviewSkip>>;
};

/** What one order's lines need in this run, how much growing lots fill, and what goes into new lots. */
export type MakeToOrderPlanPreviewShortfall = {
  __typename?: 'MakeToOrderPlanPreviewShortfall';
  /** Eaches filled from growing lots. */
  filledQuantity: Scalars['Int']['output'];
  /** Eaches this order's lines need in this run. */
  neededQuantity: Scalars['Int']['output'];
  /** The order. */
  orderId: Scalars['String']['output'];
  /** The order's number. */
  orderNumber: Scalars['String']['output'];
  /** neededQuantity minus filledQuantity: what goes into new lots. */
  shortQuantity: Scalars['Int']['output'];
};

/** An order or line left out of the groups, with the reason. */
export type MakeToOrderPlanPreviewSkip = {
  __typename?: 'MakeToOrderPlanPreviewSkip';
  /** Create Plan's own message for the refusal, or a plain sentence for a line already allocated or planned. */
  message: Scalars['String']['output'];
  /** The skipped order. */
  orderId: Scalars['String']['output'];
  /** Null when the whole order is skipped. */
  orderLineId?: Maybe<Scalars['String']['output']>;
  /** The order's number; null when the order was not found. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Why it was skipped. */
  reason: MakeToOrderPlanSkipReason;
};

/** Why an order or line is left out of the groups. */
export enum MakeToOrderPlanSkipReason {
  /** The line already holds stock. */
  AlreadyAllocated = 'ALREADY_ALLOCATED',
  /** Production lots already cover all of the line's eaches. */
  AlreadyPlanned = 'ALREADY_PLANNED',
  /** Create Plan would refuse the order, the line, or the lot its group would make. */
  NotEligible = 'NOT_ELIGIBLE',
  /** No order with this id exists. */
  NotFound = 'NOT_FOUND',
  /** The line's sales item has no active production item linked. */
  NoProductionItem = 'NO_PRODUCTION_ITEM'
}

/**
 * The Create Plan dialog's preview request: the order whose customer and ship week are used, the plan the
 * lots would sit under, and the lines being planned. PreFinished applies to every line, as it does in
 * createMakeToOrderPlan.
 */
export type MakeToOrderPlanTimingInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  lines: Array<MakeToOrderPlanTimingLineInput>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  preFinished?: Scalars['Boolean']['input'];
  productionPlanId: Scalars['String']['input'];
};

/** One order line being planned, with the same optional picks createMakeToOrderPlan takes. */
export type MakeToOrderPlanTimingLineInput = {
  containerQuantity?: InputMaybe<Scalars['Int']['input']>;
  orderLineId: Scalars['String']['input'];
  productionItemId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

/** A connection to a list of items. */
export type MakeToOrderPlansConnection = {
  __typename?: 'MakeToOrderPlansConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MakeToOrderPlansEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MakeToOrderPlanDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MakeToOrderPlansEdge = {
  __typename?: 'MakeToOrderPlansEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MakeToOrderPlanDocument;
};

/**
 * Reason a ManifestChangedEvent was published. Lets consumers
 * distinguish a direct service-config edit from a worker-config edit that
 * fanned out to every pod referencing the worker.
 */
export enum ManifestChangeTrigger {
  BackgroundServiceConfig = 'BACKGROUND_SERVICE_CONFIG',
  WorkerConfig = 'WORKER_CONFIG'
}

/**
 * Payload delivered to manifestChanged subscribers. Intentionally minimal —
 * consumers re-fetch the manifest and re-fingerprint to filter false positives,
 * so the event only needs to say "something might have changed for this pod".
 */
export type ManifestChangedEvent = {
  __typename?: 'ManifestChangedEvent';
  runsOn: Scalars['String']['output'];
  triggeredBy: ManifestChangeTrigger;
};

/**
 * Whether the caller's tenant will have a manual payment accepted right now, and the reason when it
 * will not.
 */
export type ManualPaymentCapabilityPayload = {
  __typename?: 'ManualPaymentCapabilityPayload';
  /** The reason manual payments are unavailable; null when they are available. */
  disabledReason?: Maybe<Scalars['String']['output']>;
  /** Whether recordInvoicePayment/recordOrderPayment will be accepted for this tenant. */
  enabled: Scalars['Boolean']['output'];
};

/**
 * Input for markAdminTenantOnboardingUploadImported. No occurredAt: the server selects
 * the NEWEST upload row for blobName from folded state and stamps its own timestamp into the
 * command, so the client never has to carry it (and can never point the mutation at a superseded
 * row).
 */
export type MarkAdminTenantOnboardingUploadImportedInput = {
  /**
   * The review areas this file populated. Zero areas is allowed — a file with no dedicated review
   * screen still gets its imported mark.
   */
  areas: Array<OnboardingReviewArea>;
  /** The stored object name of the file to mark imported. */
  blobName: Scalars['String']['input'];
};

/**
 * Result of markAdminTenantOnboardingUploadImported. No growerNotified boolean: a
 * caller that needs to know whether anything was sent reads notNotifiedReason being null versus
 * populated, rather than two fields that could disagree.
 */
export type MarkAdminTenantOnboardingUploadImportedPayload = {
  __typename?: 'MarkAdminTenantOnboardingUploadImportedPayload';
  /** Populated, with tenant null, when the mutation was refused. */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * null when a notification was raised (or the row was already imported, in which case
   * nothing changed and nothing was ever owed); "NotificationsOff" when the tenant's
   * Notifications feature flag is disabled; "NoRecipients" when the tenant has no active
   * non-portal directory users to notify.
   */
  notNotifiedReason?: Maybe<Scalars['String']['output']>;
  /** The tenant as it now stands, with the marked row's importedAt set. */
  tenant?: Maybe<TenantStateData>;
};

/**
 * Result of markAllNotificationsRead: how many of the caller's rows changed from unread to
 * read. Zero is an ordinary success — it means the caller had nothing unread.
 */
export type MarkAllNotificationsReadPayload = {
  __typename?: 'MarkAllNotificationsReadPayload';
  /** Populated only when the write itself failed. */
  errors?: Maybe<Array<ValidationError>>;
  /** Rows changed by this call. */
  markedCount: Scalars['Int']['output'];
};

export type MarkContractRecordEnrollmentNeedsAttentionInput = {
  lastError?: InputMaybe<Scalars['String']['input']>;
  reason: ContractRecordNeedsAttentionReason;
  requestId: Scalars['String']['input'];
};

export type MarkContractRecordEnrollmentSucceededInput = {
  requestId: Scalars['String']['input'];
  stripeSubscriptionScheduleId: Scalars['String']['input'];
};

export type MarkContractRecordEnrollmentVerifiedInput = {
  requestId: Scalars['String']['input'];
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkContractRecordFeeInvoicePaidInput = {
  amountPaidCents: Scalars['Int']['input'];
  paidAt: Scalars['DateTime']['input'];
  requestId: Scalars['String']['input'];
};

export type MarkContractRecordFeeInvoiceSentInput = {
  dueDate: Scalars['DateTime']['input'];
  hostedInvoiceUrl: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  stripeInvoiceId: Scalars['String']['input'];
  taxCents?: InputMaybe<Scalars['Long']['input']>;
  totalCents?: InputMaybe<Scalars['Long']['input']>;
};

export type MarkContractRecordFeeNeedsAttentionInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  reason: ContractFeeNeedsAttentionReason;
  requestId: Scalars['String']['input'];
};

export type MarkContractRecordScheduleCancelledInput = {
  outcome: ContractRecordScheduleCancelOutcome;
  requestId: Scalars['String']['input'];
  scheduleId: Scalars['String']['input'];
};

/**
 * GraphQL input for markErpWriteBackAccepted: the record, Nav's own posting time when the worker has
 * it, and the token the claim returned.
 */
export type MarkErpWriteBackAcceptedInput = {
  claimToken: Scalars['String']['input'];
  erpWriteBackId: Scalars['String']['input'];
  navPostedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * GraphQL input for markErpWriteBackFailed. ClaimToken is the token the claim returned;
 * optional so workers that predate claim tokens keep working on records they claimed.
 */
export type MarkErpWriteBackFailedInput = {
  claimToken?: InputMaybe<Scalars['String']['input']>;
  erpWriteBackId: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
};

/** GraphQL input for markErpWriteBackNeedsReview. ClaimToken is the token the claim returned. */
export type MarkErpWriteBackNeedsReviewInput = {
  claimToken: Scalars['String']['input'];
  erpWriteBackId: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
};

/**
 * GraphQL input for markErpWriteBackPosted. claimToken is the record's current claim token: the one
 * the claim or the lease returned.
 */
export type MarkErpWriteBackPostedInput = {
  claimToken: Scalars['String']['input'];
  erpWriteBackId: Scalars['String']['input'];
};

/**
 * GraphQL input for markErpWriteBackPosting: the record, the Nav document number the worker sends it
 * under, and the token the claim returned.
 */
export type MarkErpWriteBackPostingInput = {
  claimToken: Scalars['String']['input'];
  erpWriteBackId: Scalars['String']['input'];
  navDocumentNo: Scalars['String']['input'];
};

/**
 * GraphQL input for markErpWriteBackProcessed. ClaimToken is the token the claim returned;
 * optional so workers that predate claim tokens keep working on records they claimed.
 */
export type MarkErpWriteBackProcessedInput = {
  claimToken?: InputMaybe<Scalars['String']['input']>;
  erpWriteBackId: Scalars['String']['input'];
};

export type MarkMergeDevExportCompletedInput = {
  entityId: Scalars['String']['input'];
  mergeInvoiceId: Scalars['String']['input'];
  resolvedRevenueAccountRemoteId?: InputMaybe<Scalars['String']['input']>;
  resolvedRevenueRung?: InputMaybe<MergeDevRevenueRung>;
};

export type MarkMergeDevExportFailedPermanentInput = {
  entityId: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
};

export type MarkMergeDevExportFailedTransientInput = {
  entityId: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
  nextRetryAt: Scalars['DateTime']['input'];
  retryCount: Scalars['Int']['input'];
};

export type MarkMergeDevExportNotExportedInput = {
  entityId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/**
 * Input for markNotificationRead. The row id only — whose row it is comes from the token,
 * never from here.
 */
export type MarkNotificationReadInput = {
  /** The row id the client holds from a prior read. */
  notificationId: Scalars['String']['input'];
};

/**
 * Input for markNotificationUnread. The row id only — whose row it is comes from the token,
 * never from here.
 */
export type MarkNotificationUnreadInput = {
  /** The row id the client holds from a prior read. */
  notificationId: Scalars['String']['input'];
};

/** Input for the mark-orders-for-invoicing mutation. */
export type MarkOrdersForInvoicingInput = {
  /**
   * The date to issue every invoice in this request as of. Leave it out to issue as of now, which is what
   * invoicing a shipment you have just shipped wants. Supplying it dates the invoice AND its due date —
   * the terms window runs from this date, not from today — which is what lets an order shipped weeks ago
   * be billed at the date it actually shipped. It may not fall before an order's own shipped date, nor in
   * the future; an order it does not suit comes back as an INVOICE_DATE_OUT_OF_RANGE failure line while
   * the rest of the request is invoiced. Nor may it fall before the void of an earlier invoice of the order
   * that holds a payment recorded on it, or had customer credit applied to it; that order comes back as an
   * INVOICE_DATE_BEFORE_VOIDED_INVOICE_PAYMENT or INVOICE_DATE_BEFORE_VOIDED_INVOICE_CREDIT failure line.
   */
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The shipped orders to invoice, named explicitly. An empty list is refused rather than read as
   * "everything shipped"; a repeated id is invoiced once.
   */
  orderIds: Array<Scalars['String']['input']>;
};

/** Payload returned from the mark-orders-for-invoicing mutation. */
export type MarkOrdersForInvoicingPayload = {
  __typename?: 'MarkOrdersForInvoicingPayload';
  /**
   * The credit memos issued by this request: one for each Credit-type order named, which is never billed and
   * issues its credit memo instead.
   */
  creditMemos?: Maybe<Array<CreditMemoStateData>>;
  /**
   * Populated only when the whole request was refused and nothing was issued — for example when the tenant
   * is not Stripe-Tax-ready.
   */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * One line per order that was not invoiced, with the reason. Separate from the errors list because these
   * are per-order outcomes of a request that otherwise succeeded.
   */
  failures?: Maybe<Array<InvoiceIssueFailureData>>;
  /** The invoices issued by this request. */
  invoices?: Maybe<Array<InvoiceStateData>>;
};

/**
 * Jobs to mark done, 1 to 500 per call, each named once. at is when the floor finished them (not in the
 * future, at most 366 days back); omitted means now.
 */
export type MarkProductionJobsDoneInput = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
  jobs: Array<ProductionJobRefInput>;
};

/**
 * Jobs to mark started, 1 to 500 per call, each named once. at is when the floor started them (not in the
 * future, at most 366 days back); omitted means now.
 */
export type MarkProductionJobsStartedInput = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
  jobs: Array<ProductionJobRefInput>;
};

export type MarkProductionLotReadyInput = {
  productionLotId: Scalars['String']['input'];
};

export type MarkRampPurchaseOrderCopyCompletedInput = {
  purchaseOrderId: Scalars['String']['input'];
  /** Required for COPY. Omit for ARCHIVE (the stored id is kept). */
  rampPurchaseOrderId?: InputMaybe<Scalars['String']['input']>;
  /** Ramp's purchase_order_number of the copy, as Ramp returned it. Ramp drops a leading PO- (PO-1007 is stored as 1007). Omit for ARCHIVE. */
  rampPurchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  rampPurchaseOrderUrl?: InputMaybe<Scalars['String']['input']>;
};

export type MarkRampPurchaseOrderCopyFailedPermanentInput = {
  errorMessage: Scalars['String']['input'];
  purchaseOrderId: Scalars['String']['input'];
};

export type MarkRampPurchaseOrderCopyFailedTransientInput = {
  errorMessage: Scalars['String']['input'];
  /** When the job may be claimed again. Worker budget: 1m, 5m, 30m, 2h, then 5 attempts reached means FailedPermanent. */
  nextRetryAt: Scalars['DateTime']['input'];
  purchaseOrderId: Scalars['String']['input'];
  /** The worker's attempt count after this failure (1 or more). */
  retryCount: Scalars['Int']['input'];
};

export type MarkRampReconnectNeededInput = {
  /** Short reason with no token or response body in it, e.g. 'Refresh refused: invalid_grant'. Max 500 characters. */
  reason: Scalars['String']['input'];
};

/** Mark as synced operation result */
export type MarkRfidScansAsSyncedPayload = {
  __typename?: 'MarkRfidScansAsSyncedPayload';
  errors?: Maybe<Array<ValidationError>>;
  modifiedCount: Scalars['Long']['output'];
};

/** Input for a worker failing a batch. */
export type MarkStatementPrintBatchFailedInput = {
  /** What went wrong, in words an operator can act on. */
  failureReason: Scalars['String']['input'];
  /** The batch that could not be rendered. */
  printBatchId: Scalars['String']['input'];
};

/** Input for a worker completing a batch. */
export type MarkStatementPrintBatchReadyInput = {
  /** The URL the rendered batch can be downloaded from, stored and surfaced exactly as given. */
  downloadUrl: Scalars['String']['input'];
  /** The batch that finished rendering. */
  printBatchId: Scalars['String']['input'];
};

/** WORKER input recording provisioning success and the tenant provisioned into. */
export type MarkTrialRequestProvisionedInput = {
  requestId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** WORKER input recording a (retryable) provisioning failure. */
export type MarkTrialRequestProvisioningFailedInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
};

/**
 * WORKER input to stamp the generated tenant code and begin provisioning, keyed by the public
 * requestId. TenantCode is optional: supply it on the new-tenant (Approve) path;
 * omit it on the Link path or a retry to reuse the already-stamped code.
 */
export type MarkTrialRequestProvisioningInput = {
  requestId: Scalars['String']['input'];
  tenantCode?: InputMaybe<Scalars['String']['input']>;
};

export type MarkUserInviteCompletedInput = {
  fusionAuthUserId: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
  reactivatedLogin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarkUserInviteEmailFailedInput = {
  error: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
  sendGeneration?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkUserInviteEmailSentInput = {
  changePasswordId?: InputMaybe<Scalars['String']['input']>;
  fusionAuthUserId?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['String']['input'];
  sendGeneration?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkUserInviteFailedInput = {
  error: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
};

export type MassUpdatePayload = {
  __typename?: 'MassUpdatePayload';
  /**
   * Count of items that failed processing. A value of -1 means the count is unknown
   * because the queue fetch failed before per-item processing began.
   */
  failedCount: Scalars['Int']['output'];
  /** True when every queued item processed successfully; false otherwise. */
  success: Scalars['Boolean']['output'];
  /** Tenant whose queue was processed. */
  tenantId: Scalars['String']['output'];
  /** Count of items successfully processed. */
  updatedCount: Scalars['Int']['output'];
};

export type MasterLineItemData = {
  __typename?: 'MasterLineItemData';
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  addedBy: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  dateAdded: Scalars['DateTime']['output'];
  eaches: Scalars['Int']['output'];
  /**
   * Eaches in one unit of the Shipping UOM this master's customer orders this item in: the customer
   * item's override, else the item's own pick, else its category's, resolved as an order line resolves
   * it. 1 when the item has no Shipping UOM (or none that states a count), so
   * quantity x eachesPerUnit is always the eaches.
   */
  eachesPerUnit: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<LineItemNoteData>;
  orderedQuantity?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Decimal']['output'];
  scheduledQuantity?: Maybe<Scalars['Int']['output']>;
  shippedQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * The display name of the Shipping UOM this master's customer orders this item in (for example
   * "Flat"), or an empty string when the item has no Shipping UOM. Pairs with eachesPerUnit.
   */
  shippingUomName: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type MasterLineItemUpdateDataInput = {
  department: Scalars['String']['input'];
  notes: Array<Scalars['String']['input']>;
  orderedQuantity: Scalars['Int']['input'];
};

export type MasterOrderContactData = {
  __typename?: 'MasterOrderContactData';
  emailAddress: EmailAddressData;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: PhoneNumberData;
  title: Scalars['String']['output'];
  type: ContactType;
};

export type MasterOrderContactDataInput = {
  emailAddress: EmailAddressDataInput;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: PhoneNumberDataInput;
  title: Scalars['String']['input'];
  type: ContactType;
};

/** The master order's single contact, flattened from the event's contact fields. */
export type MasterOrderContactDocumentData = {
  __typename?: 'MasterOrderContactDocumentData';
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['Int']['output'];
};

export type MasterOrderCustomerData = {
  __typename?: 'MasterOrderCustomerData';
  billToAddress: AddressData;
  contact: MasterOrderContactData;
  id: Scalars['String']['output'];
  location?: Maybe<LocationData>;
  name: Scalars['String']['output'];
};

export type MasterOrderCustomerDataInput = {
  billToAddress: AddressDataInput;
  contact: MasterOrderContactDataInput;
  id: Scalars['String']['input'];
  location?: InputMaybe<LocationDataInput>;
  name: Scalars['String']['input'];
};

/**
 * One master-order line as the MasterOrder read model stores it — the event-carried facts
 * only. Released and shipped quantities are deliberately NOT stored here: the events that move
 * them (ScheduledOrderCreated, MasterOrderShippedQuantityUpdatedFromOrder) carry
 * per-release deltas, not running totals, so a stored total would need a relative $inc
 * the projection standard forbids. They are derived at read time from the document's releases
 * and shipments by SKU, the same rule MasterOrderState applies.
 */
export type MasterOrderLineDocumentData = {
  __typename?: 'MasterOrderLineDocumentData';
  /**
   * Seeded equal to the ordered quantity on add and on ordered-quantity edit, then set by
   * acknowledgement.
   */
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  dateAdded: Scalars['DateTime']['output'];
  itemGroup: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  /** The line's stable id, as a string so array filters key on it without Guid-representation concerns. */
  lineId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  noteText?: Maybe<Scalars['String']['output']>;
  orderedQuantity: Scalars['Int']['output'];
  /**
   * The item the line was written for, when an item combine has since moved the line to the item it was
   * combined into; null when no combine moved it. The line's SKU and name stay the original item's.
   */
  originalItemId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Decimal']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

/**
 * One master-order line as the MasterOrder read model stores it — the event-carried facts
 * only. Released and shipped quantities are deliberately NOT stored here: the events that move
 * them (ScheduledOrderCreated, MasterOrderShippedQuantityUpdatedFromOrder) carry
 * per-release deltas, not running totals, so a stored total would need a relative $inc
 * the projection standard forbids. They are derived at read time from the document's releases
 * and shipments by SKU, the same rule MasterOrderState applies.
 */
export type MasterOrderLineDocumentDataFilterInput = {
  /**
   * Seeded equal to the ordered quantity on add and on ordered-quantity edit, then set by
   * acknowledgement.
   */
  acknowledgedQuantity?: InputMaybe<OptionOfInt32FilterInput>;
  and?: InputMaybe<Array<MasterOrderLineDocumentDataFilterInput>>;
  currency?: InputMaybe<StringOperationFilterInput>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  itemGroup?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** The line's stable id, as a string so array filters key on it without Guid-representation concerns. */
  lineId?: InputMaybe<StringOperationFilterInput>;
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  noteText?: InputMaybe<OptionOfStringFilterInput>;
  or?: InputMaybe<Array<MasterOrderLineDocumentDataFilterInput>>;
  orderedQuantity?: InputMaybe<IntOperationFilterInput>;
  /**
   * The item the line was written for, when an item combine has since moved the line to the item it was
   * combined into; null when no combine moved it. The line's SKU and name stay the original item's.
   */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
};

export type MasterOrderPayload = {
  __typename?: 'MasterOrderPayload';
  errors?: Maybe<Array<ValidationError>>;
  masterOrder?: Maybe<MasterOrderStateData>;
};

/**
 * One release (scheduled child order) cut from the master order — the per-release facts the
 * domain's ScheduledOrder (id + number only) does not retain. Foundation for the
 * "Master Release Sub-Orders" report; also what the read kernel sums to derive each line's
 * released quantity.
 */
export type MasterOrderReleaseDocumentData = {
  __typename?: 'MasterOrderReleaseDocumentData';
  currency: Scalars['String']['output'];
  expectedDeliveryDate: Scalars['DateTime']['output'];
  initializationDate: Scalars['DateTime']['output'];
  lines: Array<MasterOrderReleaseLineDocumentData>;
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  orderTotal: Scalars['Decimal']['output'];
};

/**
 * One release (scheduled child order) cut from the master order — the per-release facts the
 * domain's ScheduledOrder (id + number only) does not retain. Foundation for the
 * "Master Release Sub-Orders" report; also what the read kernel sums to derive each line's
 * released quantity.
 */
export type MasterOrderReleaseDocumentDataFilterInput = {
  and?: InputMaybe<Array<MasterOrderReleaseDocumentDataFilterInput>>;
  currency?: InputMaybe<StringOperationFilterInput>;
  expectedDeliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  initializationDate?: InputMaybe<DateTimeOperationFilterInput>;
  lines?: InputMaybe<ListFilterInputTypeOfMasterOrderReleaseLineDocumentDataFilterInput>;
  or?: InputMaybe<Array<MasterOrderReleaseDocumentDataFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  orderTotal?: InputMaybe<DecimalOperationFilterInput>;
};

/** One line of a release (scheduled order) as carried on ScheduledOrderCreated. */
export type MasterOrderReleaseLineDocumentData = {
  __typename?: 'MasterOrderReleaseLineDocumentData';
  /**
   * The line's quantity in eaches, as the release carried it. Absent on a release stored before this field
   * existed; reports then fall back to the line's quantity, the entered quantity, which for a Shipping UOM
   * customer is units, not eaches.
   */
  eaches?: Maybe<Scalars['Int']['output']>;
  itemId: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  /** The line's quantity in the customer's order entry unit (flats for a Shipping UOM customer). */
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

/** One line of a release (scheduled order) as carried on ScheduledOrderCreated. */
export type MasterOrderReleaseLineDocumentDataFilterInput = {
  and?: InputMaybe<Array<MasterOrderReleaseLineDocumentDataFilterInput>>;
  /**
   * The line's quantity in eaches, as the release carried it. Absent on a release stored before this field
   * existed; reports then fall back to the line's quantity, the entered quantity, which for a Shipping UOM
   * customer is units, not eaches.
   */
  eaches?: InputMaybe<OptionOfInt32FilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MasterOrderReleaseLineDocumentDataFilterInput>>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  /** The line's quantity in the customer's order entry unit (flats for a Shipping UOM customer). */
  quantity?: InputMaybe<IntOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One shipment fact relayed from a child order (MasterOrderShippedQuantityUpdatedFromOrder).
 * Stored as a fact rather than folded into a running total so the projection stays idempotent.
 */
export type MasterOrderShipmentDocumentData = {
  __typename?: 'MasterOrderShipmentDocumentData';
  lines: Array<MasterOrderShipmentLineDocumentData>;
  sourceOrderId: Scalars['String']['output'];
  sourceOrderNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * One shipment fact relayed from a child order (MasterOrderShippedQuantityUpdatedFromOrder).
 * Stored as a fact rather than folded into a running total so the projection stays idempotent.
 */
export type MasterOrderShipmentDocumentDataFilterInput = {
  and?: InputMaybe<Array<MasterOrderShipmentDocumentDataFilterInput>>;
  lines?: InputMaybe<ListFilterInputTypeOfMasterOrderShipmentLineDocumentDataFilterInput>;
  or?: InputMaybe<Array<MasterOrderShipmentDocumentDataFilterInput>>;
  sourceOrderId?: InputMaybe<StringOperationFilterInput>;
  sourceOrderNumber?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** One SKU's shipped quantity as reported by a child order's shipment. */
export type MasterOrderShipmentLineDocumentData = {
  __typename?: 'MasterOrderShipmentLineDocumentData';
  shippedQuantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

/** One SKU's shipped quantity as reported by a child order's shipment. */
export type MasterOrderShipmentLineDocumentDataFilterInput = {
  and?: InputMaybe<Array<MasterOrderShipmentLineDocumentDataFilterInput>>;
  or?: InputMaybe<Array<MasterOrderShipmentLineDocumentDataFilterInput>>;
  shippedQuantity?: InputMaybe<IntOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
};

export type MasterOrderStateData = {
  __typename?: 'MasterOrderStateData';
  confirmationEmails: Array<ConfirmationEmailData>;
  customer: MasterOrderCustomerData;
  masterLineItems: Array<MasterLineItemData>;
  masterOrderId: Scalars['String']['output'];
  masterOrderNumber: Scalars['String']['output'];
  /**
   * The unit this master's customer orders in: the customer's own setting when it has one, otherwise the
   * tenant default, resolved exactly as the customer's effectiveOrderEntryUnit is. SHIPPING_UOM
   * means the screens enter and show shipping units (flats) with eaches beside them; EACHES means they
   * enter eaches.
   */
  orderEntryUnit: OrderEntryUnit;
  poNumber: Scalars['String']['output'];
  salesPerson: Scalars['String']['output'];
  scheduledOrders: Array<ScheduledOrderData>;
  shipFromLocation: ShipFromLocationData;
  status: MasterOrderStatus;
  tenantId: Scalars['String']['output'];
  type: OrderType;
};

export enum MasterOrderStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Open = 'OPEN',
  Submitted = 'SUBMITTED'
}

export type MasterOrderStatusOperationFilterInput = {
  eq?: InputMaybe<MasterOrderStatus>;
  in?: InputMaybe<Array<MasterOrderStatus>>;
  neq?: InputMaybe<MasterOrderStatus>;
  nin?: InputMaybe<Array<MasterOrderStatus>>;
};

/** A connection to a list of items. */
export type MasterOrdersConnection = {
  __typename?: 'MasterOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MasterOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MasterOrdersDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type MasterOrdersDocument = {
  __typename?: 'MasterOrdersDocument';
  billingAddress: AddressData;
  confirmationEmail?: Maybe<ConfirmationEmailData>;
  /**
   * The master order's single contact, flattened from the initialization and contact-update
   * events. None on documents projected before this field existed until replay.
   */
  contact?: Maybe<MasterOrderContactDocumentData>;
  /**
   * When the master order was initialized — the KurrentDB timestamp of MasterOrderInitialized,
   * the aggregate carrying no order date of its own. Null for documents projected before this field
   * existed until the projection is replayed; the ds-master-orders report reads it as the
   * order date.
   */
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemIds: Scalars['String']['output'];
  /** The master order's lines. Empty on documents projected before this field existed until replay. */
  lineItems: Array<MasterOrderLineDocumentData>;
  /**
   * The master's ship-to; null on a customer-level master ("All ship-tos"), whose weeks each name
   * their own ship-to of the customer when they are scheduled.
   */
  locations?: Maybe<OrderLocationDocumentData>;
  masterOrderId: Scalars['String']['output'];
  masterOrderNumber: Scalars['String']['output'];
  masterOrderStatus: MasterOrderStatus;
  numberOfLines: Scalars['Int']['output'];
  orderTotal: MoneyData;
  orderType: OrderType;
  /**
   * The customer this master order belonged to before a customer combine moved it onto the customer it
   * was combined into; null when it was never moved.
   * Set once, so a chain of combines keeps the first customer.
   */
  originalCustomerId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the customer this master order belonged to before a customer combine moved it, as
   * that customer was named when combined; null when it was never moved. What the screens show as
   * "from <original name>".
   */
  originalCustomerName?: Maybe<Scalars['String']['output']>;
  /**
   * The items this master order named before an item combine moved its references to the item each
   * was combined into, space-separated like itemIds; null when no combine moved any.
   */
  originalItemIds?: Maybe<Scalars['String']['output']>;
  /**
   * The ship-to location id this master order named before a combine moved it onto the ship-to it was
   * combined into (a ship-to combine, or a customer combine's "same as" ship-to) and re-pointed
   * locations.id; null when it was never moved. Set once, so a chain of combines keeps the first
   * ship-to. The master order's ship-to name, code and address stay as they were when it was taken.
   */
  originalLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * The ship-to address id this master order named before the same combine re-pointed
   * locations.address.id; null when it was never moved.
   */
  originalShipToId?: Maybe<Scalars['String']['output']>;
  poNumber: Scalars['String']['output'];
  /** Every release cut from this master order, with the per-release lines the domain does not retain. */
  releases: Array<MasterOrderReleaseDocumentData>;
  salesPerson?: Maybe<Scalars['String']['output']>;
  scheduledOrders: Array<ScheduledOrderData>;
  /**
   * The name of the location the master order ships from. Empty on documents projected before
   * this field existed until the projection is replayed.
   */
  shipFromLocationName: Scalars['String']['output'];
  /** Every shipment fact relayed from a child order. */
  shipments: Array<MasterOrderShipmentDocumentData>;
  tenantId: Scalars['String']['output'];
};

export type MasterOrdersDocumentFilterInput = {
  and?: InputMaybe<Array<MasterOrdersDocumentFilterInput>>;
  billingAddress?: InputMaybe<AddressDataFilterInput>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataFilterInput>;
  /**
   * The master order's single contact, flattened from the initialization and contact-update
   * events. None on documents projected before this field existed until replay.
   */
  contact?: InputMaybe<OptionOfMasterOrderContactDocumentDataFilterInput>;
  /**
   * When the master order was initialized — the KurrentDB timestamp of MasterOrderInitialized,
   * the aggregate carrying no order date of its own. Null for documents projected before this field
   * existed until the projection is replayed; the ds-master-orders report reads it as the
   * order date.
   */
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemIds?: InputMaybe<StringOperationFilterInput>;
  /** The master order's lines. Empty on documents projected before this field existed until replay. */
  lineItems?: InputMaybe<ListFilterInputTypeOfMasterOrderLineDocumentDataFilterInput>;
  /**
   * The master's ship-to; null on a customer-level master ("All ship-tos"), whose weeks each name
   * their own ship-to of the customer when they are scheduled.
   */
  locations?: InputMaybe<OrderLocationDocumentDataFilterInput>;
  masterOrderId?: InputMaybe<StringOperationFilterInput>;
  masterOrderNumber?: InputMaybe<StringOperationFilterInput>;
  masterOrderStatus?: InputMaybe<MasterOrderStatusOperationFilterInput>;
  numberOfLines?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MasterOrdersDocumentFilterInput>>;
  orderTotal?: InputMaybe<MoneyDataFilterInput>;
  orderType?: InputMaybe<OrderTypeOperationFilterInput>;
  /**
   * The customer this master order belonged to before a customer combine moved it onto the customer it
   * was combined into; null when it was never moved.
   * Set once, so a chain of combines keeps the first customer.
   */
  originalCustomerId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The name of the customer this master order belonged to before a customer combine moved it, as
   * that customer was named when combined; null when it was never moved. What the screens show as
   * "from <original name>".
   */
  originalCustomerName?: InputMaybe<StringOperationFilterInput>;
  /**
   * The items this master order named before an item combine moved its references to the item each
   * was combined into, space-separated like itemIds; null when no combine moved any.
   */
  originalItemIds?: InputMaybe<StringOperationFilterInput>;
  /**
   * The ship-to location id this master order named before a combine moved it onto the ship-to it was
   * combined into (a ship-to combine, or a customer combine's "same as" ship-to) and re-pointed
   * locations.id; null when it was never moved. Set once, so a chain of combines keeps the first
   * ship-to. The master order's ship-to name, code and address stay as they were when it was taken.
   */
  originalLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The ship-to address id this master order named before the same combine re-pointed
   * locations.address.id; null when it was never moved.
   */
  originalShipToId?: InputMaybe<StringOperationFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  /** Every release cut from this master order, with the per-release lines the domain does not retain. */
  releases?: InputMaybe<ListFilterInputTypeOfMasterOrderReleaseDocumentDataFilterInput>;
  salesPerson?: InputMaybe<StringOperationFilterInput>;
  scheduledOrders?: InputMaybe<ListFilterInputTypeOfScheduledOrderDataFilterInput>;
  /**
   * The name of the location the master order ships from. Empty on documents projected before
   * this field existed until the projection is replayed.
   */
  shipFromLocationName?: InputMaybe<StringOperationFilterInput>;
  /** Every shipment fact relayed from a child order. */
  shipments?: InputMaybe<ListFilterInputTypeOfMasterOrderShipmentDocumentDataFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type MasterOrdersDocumentSortInput = {
  billingAddress?: InputMaybe<AddressDataSortInput>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataSortInput>;
  /**
   * The master order's single contact, flattened from the initialization and contact-update
   * events. None on documents projected before this field existed until replay.
   */
  contact?: InputMaybe<SortEnumType>;
  /**
   * When the master order was initialized — the KurrentDB timestamp of MasterOrderInitialized,
   * the aggregate carrying no order date of its own. Null for documents projected before this field
   * existed until the projection is replayed; the ds-master-orders report reads it as the
   * order date.
   */
  createdDate?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemIds?: InputMaybe<SortEnumType>;
  /**
   * The master's ship-to; null on a customer-level master ("All ship-tos"), whose weeks each name
   * their own ship-to of the customer when they are scheduled.
   */
  locations?: InputMaybe<OrderLocationDocumentDataSortInput>;
  masterOrderId?: InputMaybe<SortEnumType>;
  masterOrderNumber?: InputMaybe<SortEnumType>;
  masterOrderStatus?: InputMaybe<SortEnumType>;
  numberOfLines?: InputMaybe<SortEnumType>;
  orderTotal?: InputMaybe<MoneyDataSortInput>;
  orderType?: InputMaybe<SortEnumType>;
  /**
   * The customer this master order belonged to before a customer combine moved it onto the customer it
   * was combined into; null when it was never moved.
   * Set once, so a chain of combines keeps the first customer.
   */
  originalCustomerId?: InputMaybe<SortEnumType>;
  /**
   * The name of the customer this master order belonged to before a customer combine moved it, as
   * that customer was named when combined; null when it was never moved. What the screens show as
   * "from <original name>".
   */
  originalCustomerName?: InputMaybe<SortEnumType>;
  /**
   * The items this master order named before an item combine moved its references to the item each
   * was combined into, space-separated like itemIds; null when no combine moved any.
   */
  originalItemIds?: InputMaybe<SortEnumType>;
  /**
   * The ship-to location id this master order named before a combine moved it onto the ship-to it was
   * combined into (a ship-to combine, or a customer combine's "same as" ship-to) and re-pointed
   * locations.id; null when it was never moved. Set once, so a chain of combines keeps the first
   * ship-to. The master order's ship-to name, code and address stay as they were when it was taken.
   */
  originalLocationId?: InputMaybe<SortEnumType>;
  /**
   * The ship-to address id this master order named before the same combine re-pointed
   * locations.address.id; null when it was never moved.
   */
  originalShipToId?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  salesPerson?: InputMaybe<SortEnumType>;
  /**
   * The name of the location the master order ships from. Empty on documents projected before
   * this field existed until the projection is replayed.
   */
  shipFromLocationName?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type MasterOrdersEdge = {
  __typename?: 'MasterOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MasterOrdersDocument;
};

/** Read-model shape of a single existing-tenant match annotation. Context for the approver only. */
export type MatchCandidateDocument = {
  __typename?: 'MatchCandidateDocument';
  /** TrialRequestMatchedOn ordinal. */
  matchedOn: Scalars['Int']['output'];
  requestId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** Read-model shape of a single existing-tenant match annotation. Context for the approver only. */
export type MatchCandidateDocumentFilterInput = {
  and?: InputMaybe<Array<MatchCandidateDocumentFilterInput>>;
  /** TrialRequestMatchedOn ordinal. */
  matchedOn?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<MatchCandidateDocumentFilterInput>>;
  requestId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a material allocation, projected from the
 * allocation event stream into the MaterialAllocations collection. Also returned
 * directly as the GraphQL output type for allocation queries and payloads.
 */
export type MaterialAllocationDocument = {
  __typename?: 'MaterialAllocationDocument';
  confirmedQty: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  fulfilledQty: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  requiredQty: Scalars['Decimal']['output'];
  status: MaterialAllocationStatus;
  targetLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * MongoDB read-model document for a material allocation, projected from the
 * allocation event stream into the MaterialAllocations collection. Also returned
 * directly as the GraphQL output type for allocation queries and payloads.
 */
export type MaterialAllocationDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialAllocationDocumentFilterInput>>;
  confirmedQty?: InputMaybe<DecimalOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  fulfilledQty?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  jobId?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialAllocationDocumentFilterInput>>;
  requiredQty?: InputMaybe<DecimalOperationFilterInput>;
  status?: InputMaybe<MaterialAllocationStatusOperationFilterInput>;
  targetLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for a material allocation, projected from the
 * allocation event stream into the MaterialAllocations collection. Also returned
 * directly as the GraphQL output type for allocation queries and payloads.
 */
export type MaterialAllocationDocumentSortInput = {
  confirmedQty?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  fulfilledQty?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jobId?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  requiredQty?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  targetLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL mutation payload for material-allocation operations: carries either the
 * resulting allocation document or the validation errors, never both.
 */
export type MaterialAllocationPayload = {
  __typename?: 'MaterialAllocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  materialAllocation?: Maybe<MaterialAllocationDocument>;
};

export enum MaterialAllocationStatus {
  Confirmed = 'CONFIRMED',
  Fulfilled = 'FULFILLED',
  Released = 'RELEASED',
  Requested = 'REQUESTED'
}

export type MaterialAllocationStatusOperationFilterInput = {
  eq?: InputMaybe<MaterialAllocationStatus>;
  in?: InputMaybe<Array<MaterialAllocationStatus>>;
  neq?: InputMaybe<MaterialAllocationStatus>;
  nin?: InputMaybe<Array<MaterialAllocationStatus>>;
};

/** A connection to a list of items. */
export type MaterialAllocationsConnection = {
  __typename?: 'MaterialAllocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialAllocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialAllocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialAllocationsEdge = {
  __typename?: 'MaterialAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialAllocationDocument;
};

/** The price that applies to a material and vendor on one day, or why none does. */
export type MaterialApplicablePriceData = {
  __typename?: 'MaterialApplicablePriceData';
  /** The day pricing starts; null unless the state is not yet effective. */
  earliestFutureEffectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The applicable quote; null unless the state is priced. */
  quote?: Maybe<MaterialPriceQuoteData>;
  /** Whether a price applies, and when none does, why. */
  state: ApplicablePriceState;
};

export type MaterialBinBatchQuantityDataInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  plantDate?: InputMaybe<Scalars['LocalDate']['input']>;
  plantStatus?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Decimal']['input'];
};

/**
 * A single material demand entry representing the quantity of a specific material
 * needed for a production job in a given week.
 */
export type MaterialDemandEntry = {
  __typename?: 'MaterialDemandEntry';
  /**
   * The plants (eaches) in one container of the job's production category. Zero when the job's category
   * no longer resolves. States the basis only: no quantity in this result is multiplied by it.
   */
  eachesPerContainer: Scalars['Int']['output'];
  /** Whether this material event came from the recipe or was ad-hoc. */
  eventSource: MaterialDemandEventSource;
  /**
   * The container count this entry's requiredQuantity scales by. Under the Exact rounding mode it is the
   * job's unrounded planned count (0.23 for a job planned at 0.23 of a tray, whose jobQuantity is 1);
   * otherwise, and for a job planned before the exact count was stored, it equals jobQuantity.
   */
  exactQuantity: Scalars['Decimal']['output'];
  /**
   * The production job's container count (for example 500 trays). Each container holds
   * eachesPerContainer plants.
   */
  jobQuantity: Scalars['Int']['output'];
  /** The location name where the job is scheduled. */
  locationName: Scalars['String']['output'];
  /** The production material event detail identifier (unique per material within an event). */
  materialEventDetailId: Scalars['String']['output'];
  /** The production material event identifier that defines this material usage. */
  materialEventId: Scalars['String']['output'];
  /** The production material event name (denormalized for display). */
  materialEventName: Scalars['String']['output'];
  /** The material item category (denormalized for display). */
  materialItemCategory: Scalars['String']['output'];
  /** The material item identifier. */
  materialItemId: Scalars['String']['output'];
  /** The material item name (denormalized for display). */
  materialItemName: Scalars['String']['output'];
  /**
   * The material units consumed per container of the job, from the material event detail. Enter it per
   * container, not per plant: requiredQuantity is jobQuantity times this value.
   */
  multiple: Scalars['Decimal']['output'];
  /** The production job identifier. */
  productionJobId: Scalars['String']['output'];
  /** The production job display name. */
  productionJobName: Scalars['String']['output'];
  /** The recipe variation ID that was matched for this job (null if no variation found). */
  productionRecipeVariationId?: Maybe<Scalars['String']['output']>;
  /**
   * The quantity of material required, in the material's own units: exactQuantity times multiple.
   * That is the job's container count (jobQuantity) unless the tenant rounds Exact, when it is the
   * job's unrounded container count. Not a count of containers, and not converted through
   * eachesPerContainer.
   */
  requiredQuantity: Scalars['Decimal']['output'];
  /**
   * The name of the job's container, such as "4.5 inch tray": the production category's label, or its code
   * when the label is blank. Empty when the job's category no longer resolves.
   */
  unitLabel: Scalars['String']['output'];
  /** The week start date for which this material is needed. */
  weekStartDate: Scalars['DateTime']['output'];
  /** The ISO week number of the week start date. */
  weekStartIsoWeek: Scalars['Int']['output'];
  /** The ISO year of the week start date. */
  weekStartIsoYear: Scalars['Int']['output'];
};

/**
 * Represents the material demand source — whether the material event came from
 * the recipe definition or was attached ad-hoc to the production job.
 */
export enum MaterialDemandEventSource {
  /** Material event was attached ad-hoc directly to the job. */
  AdHoc = 'AD_HOC',
  /** Material event originated from the recipe variation. */
  Recipe = 'RECIPE'
}

/** Summary of material demand across all jobs in the queried range. */
export type MaterialDemandSummary = {
  __typename?: 'MaterialDemandSummary';
  /** The number of distinct material items in the result. */
  distinctMaterialCount: Scalars['Int']['output'];
  /** Individual material demand entries. */
  entries: Array<MaterialDemandEntry>;
  /**
   * The sum of requiredQuantity across all entries: material units summed across material items.
   * It is not a count of containers or plants.
   */
  totalRequiredQuantity: Scalars['Decimal']['output'];
};

/**
 * One group header for the Material Events sidebar: the group's Key (also used as the
 * where eq-value when lazy-loading the group's children via productionMaterialEvents), a
 * display Label, and the server-computed Count of events in the group under
 * the active search. For the Status dimension the Key is the canonical SCREAMING_SNAKE
 * enum name (e.g. ACTIVE), so it is directly usable as the GraphQL enum literal in
 * where: { status: { eq: ACTIVE } }.
 */
export type MaterialEventGroupBucket = {
  __typename?: 'MaterialEventGroupBucket';
  /** Number of events in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /** Raw group key — canonical status enum name, or the event name. */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for materialEventGroups. Mirrors the Material Events sidebar's group-by
 * options so the client can render server-computed group headers instead of grouping the full event
 * list in memory: Status buckets on the event lifecycle status, Name buckets on the
 * event name. Both are flat scalar fields on ProductionMaterialEventDocument.
 */
export enum MaterialEventGroupField {
  /** One bucket per distinct event name. */
  Name = 'NAME',
  /** One bucket per distinct event status (Active / Inactive / Deleted / Unknown). */
  Status = 'STATUS'
}

export type MaterialEventVendorOverrideData = {
  __typename?: 'MaterialEventVendorOverrideData';
  materialItemId: Scalars['String']['output'];
  productionMaterialEventId: Scalars['String']['output'];
  vendorId: Scalars['String']['output'];
};

/**
 * Read-model twin of MaterialEventVendorOverride: which vendor's cost prices one material
 * item on one of the recipe's material events.
 */
export type MaterialEventVendorOverrideDocument = {
  __typename?: 'MaterialEventVendorOverrideDocument';
  materialItemId: Scalars['String']['output'];
  productionMaterialEventId: Scalars['String']['output'];
  vendorId: Scalars['String']['output'];
};

/**
 * Read-model twin of MaterialEventVendorOverride: which vendor's cost prices one material
 * item on one of the recipe's material events.
 */
export type MaterialEventVendorOverrideDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialEventVendorOverrideDocumentFilterInput>>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialEventVendorOverrideDocumentFilterInput>>;
  productionMaterialEventId?: InputMaybe<StringOperationFilterInput>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
};

export type MaterialImageData = {
  __typename?: 'MaterialImageData';
  image: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  mime: Scalars['String']['output'];
};

export type MaterialImageDataFilterInput = {
  and?: InputMaybe<Array<MaterialImageDataFilterInput>>;
  image?: InputMaybe<StringOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  mime?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialImageDataFilterInput>>;
};

export type MaterialImageDataSortInput = {
  image?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  mime?: InputMaybe<SortEnumType>;
};

export type MaterialItemBulkActionPayload = {
  __typename?: 'MaterialItemBulkActionPayload';
  errors?: Maybe<Array<ValidationError>>;
  materialItems?: Maybe<Array<MaterialItemPayload>>;
};

export enum MaterialItemCountType {
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT',
  Set = 'SET',
  Unknown = 'UNKNOWN'
}

export type MaterialItemCountTypeOperationFilterInput = {
  eq?: InputMaybe<MaterialItemCountType>;
  in?: InputMaybe<Array<MaterialItemCountType>>;
  neq?: InputMaybe<MaterialItemCountType>;
  nin?: InputMaybe<Array<MaterialItemCountType>>;
};

/** What one run of the default-vendor backfill did across every tenant it touched. */
export type MaterialItemDefaultVendorBackfillPayload = {
  __typename?: 'MaterialItemDefaultVendorBackfillPayload';
  /**
   * One entry per item whose repair failed. A failure never aborts the run: every other item is still
   * repaired, and re-running picks up whatever was left behind.
   */
  errors?: Maybe<Array<ValidationError>>;
  /** Total items repaired across all tenants. */
  repaired: Scalars['Int']['output'];
  /**
   * Total repaired items whose promoted vendor has cost rows — the ones now visible in recipe cost
   * estimates again.
   */
  repairedWithCostRows: Scalars['Int']['output'];
  /**
   * Total repaired items whose promoted vendor has no cost row and therefore still cost nothing.
   * Non-zero means there is grower data entry left to do; see the per-tenant split.
   */
  repairedWithoutCostRows: Scalars['Int']['output'];
  /** Total candidates that needed nothing once the aggregate was consulted. */
  skipped: Scalars['Int']['output'];
  /**
   * The per-tenant breakdown, ordered by tenant id. Empty when no tenant had a single candidate —
   * which is exactly what a second run looks like.
   */
  tenants: Array<MaterialItemDefaultVendorBackfillTenantResult>;
};

/** What one run of the default-vendor backfill did for a single tenant. */
export type MaterialItemDefaultVendorBackfillTenantResult = {
  __typename?: 'MaterialItemDefaultVendorBackfillTenantResult';
  /**
   * Candidates whose repair failed. Counted per tenant; the errors themselves ride on the run-level
   * errors array.
   */
  failed: Scalars['Int']['output'];
  /**
   * Material items this run promoted a default vendor for. Always
   * repairedWithCostRows + repairedWithoutCostRows.
   */
  repaired: Scalars['Int']['output'];
  /**
   * Repaired items whose promoted vendor ALREADY has at least one vendor-material cost row, so the
   * projection's promotion arm re-flagged a real cost row and the item is back in recipe cost
   * estimates. This is the count that means "fixed end to end".
   */
  repairedWithCostRows: Scalars['Int']['output'];
  /** The material item ids behind RepairedWithCostRows. */
  repairedWithCostRowsMaterialItemIds: Array<Scalars['String']['output']>;
  /**
   * Repaired items whose promoted vendor has NO cost row at all. The default-vendor flag is now
   * correct on both the aggregate and the read model, but the item still contributes nothing to a
   * recipe cost estimate: MaterialsCostResolver reads cost ROWS flagged
   * IsDefaultVendor, and the promotion arm re-flags existing rows without inventing one.
   * These items need a price entered by the grower — this backfill cannot invent one. Reported
   * separately so a run that repairs many and leaves some uncosted can never be mistaken for full
   * success.
   */
  repairedWithoutCostRows: Scalars['Int']['output'];
  /**
   * The material item ids behind RepairedWithoutCostRows — the operator's
   * worklist. Returned rather than only counted because the repair REMOVES its own candidates from
   * every discovery surface: a promoted item carries a default, so InScopeFilter
   * no longer matches it and there is no query on this API that re-derives which items still need a
   * grower price. Same reason TrialKindBackfillPayload.StampedTenantIds returns its ids.
   */
  repairedWithoutCostRowsMaterialItemIds: Array<Scalars['String']['output']>;
  /**
   * Candidates the read model offered that the AGGREGATE said needed nothing — already carrying a
   * default, carrying no vendors at all, or having no stream. No event was emitted for any of them.
   * A clean re-run is all Skipped and zero Repaired.
   */
  skipped: Scalars['Int']['output'];
  /** The tenant these counts belong to. */
  tenantId: Scalars['String']['output'];
};

/**
 * Represents a material item in the system.
 *     Material Item will belong to a company via TenantId. (Not LocationId.)
 */
export type MaterialItemDocument = {
  __typename?: 'MaterialItemDocument';
  accountingId?: Maybe<Scalars['String']['output']>;
  /**
   * This hard good's stock by ready date: stock with no ready date first, then one bucket per ready date in
   * ascending order. Empty when no stock matches. Null for a staff caller, or when the tenant's portal
   * settings cannot be read.
   */
  availabilityByReadyDate?: Maybe<Array<PortalReadyDateBucket>>;
  /**
   * The quantity of this hard good ready now: stock with no ready date or a ready date on or before the
   * tenant's local today, netted across locations. Null for a staff caller, or when the tenant's portal
   * settings cannot be read.
   */
  availableNowQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * This hard good's portal ledger availableQuantity, or null for a staff caller or
   * when the tenant's portal settings cannot be read.
   */
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  baseUnit: MaterialUnit;
  batchTracked: Scalars['Boolean']['output'];
  category: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isOrganic: Scalars['Boolean']['output'];
  itemType?: Maybe<Scalars['String']['output']>;
  materialImage?: Maybe<MaterialImageData>;
  name: Scalars['String']['output'];
  /**
   * Replay-derived purchasing counter: advances once per event that changes what a purchasing
   * reviewer looked at (creation, details, lifecycle, vendor assignment and metadata, default
   * vendor, detach, every price write) and not at all for stock moves, counts, adjustments or the
   * image patch that share the material's physical stream. A reviewed purchasing context compares
   * against this; the stream version stays the append guard. Zero on a legacy document the replay
   * has not reached yet.
   */
  purchasingRevision: Scalars['Int']['output'];
  /**
   * The total quantity of this material item on hand across all locations. Zero when none is
   * stocked anywhere, and null when the caller is not allowed to read stock levels.
   */
  quantityOnHand?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The earliest InventoryItem ledger ready date among this hard good's matching rows, or
   * null for a staff caller, when the tenant's portal settings cannot be read, or when no
   * matching row carries a ready date.
   */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * ISO 8601 week number (1–53) DERIVED from this hard good's ready date. Computed on read so it
   * can never drift from the date — it is never stored independently. Null when there is no ready
   * date, for a staff caller, or when the tenant's portal settings cannot be read.
   */
  readyWeek?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether this hard good is offered for sale in the FULFILL context. Legacy documents
   * written before this field hydrate as the C# default (false — not offered for
   * sale), which is the safe default; only the available-to-sell query filters on it.
   */
  sellable: Scalars['Boolean']['output'];
  status: MaterialItemStatus;
  /**
   * The produce-tag identity of this material item, or null when it is an ordinary
   * hardgood. Legacy documents written before tags existed hydrate as null, which is the
   * correct answer for every one of them — a tag is a material item, but almost no material item
   * is a tag.
   */
  tag?: Maybe<MaterialItemTagData>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  vendors: Array<MaterialVendorData>;
};

/**
 * Represents a material item in the system.
 *     Material Item will belong to a company via TenantId. (Not LocationId.)
 */
export type MaterialItemDocumentFilterInput = {
  accountingId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<MaterialItemDocumentFilterInput>>;
  batchTracked?: InputMaybe<BooleanOperationFilterInput>;
  category?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isOrganic?: InputMaybe<BooleanOperationFilterInput>;
  itemType?: InputMaybe<StringOperationFilterInput>;
  materialImage?: InputMaybe<MaterialImageDataFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialItemDocumentFilterInput>>;
  /**
   * Replay-derived purchasing counter: advances once per event that changes what a purchasing
   * reviewer looked at (creation, details, lifecycle, vendor assignment and metadata, default
   * vendor, detach, every price write) and not at all for stock moves, counts, adjustments or the
   * image patch that share the material's physical stream. A reviewed purchasing context compares
   * against this; the stream version stays the append guard. Zero on a legacy document the replay
   * has not reached yet.
   */
  purchasingRevision?: InputMaybe<IntOperationFilterInput>;
  /**
   * Whether this hard good is offered for sale in the FULFILL context. Legacy documents
   * written before this field hydrate as the C# default (false — not offered for
   * sale), which is the safe default; only the available-to-sell query filters on it.
   */
  sellable?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<MaterialItemStatusOperationFilterInput>;
  /**
   * The produce-tag identity of this material item, or null when it is an ordinary
   * hardgood. Legacy documents written before tags existed hydrate as null, which is the
   * correct answer for every one of them — a tag is a material item, but almost no material item
   * is a tag.
   */
  tag?: InputMaybe<MaterialItemTagDataFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  vendors?: InputMaybe<ListFilterInputTypeOfMaterialVendorDataFilterInput>;
};

/**
 * Represents a material item in the system.
 *     Material Item will belong to a company via TenantId. (Not LocationId.)
 */
export type MaterialItemDocumentSortInput = {
  accountingId?: InputMaybe<SortEnumType>;
  batchTracked?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isOrganic?: InputMaybe<SortEnumType>;
  itemType?: InputMaybe<SortEnumType>;
  materialImage?: InputMaybe<MaterialImageDataSortInput>;
  name?: InputMaybe<SortEnumType>;
  /**
   * Replay-derived purchasing counter: advances once per event that changes what a purchasing
   * reviewer looked at (creation, details, lifecycle, vendor assignment and metadata, default
   * vendor, detach, every price write) and not at all for stock moves, counts, adjustments or the
   * image patch that share the material's physical stream. A reviewed purchasing context compares
   * against this; the stream version stays the append guard. Zero on a legacy document the replay
   * has not reached yet.
   */
  purchasingRevision?: InputMaybe<SortEnumType>;
  /**
   * Whether this hard good is offered for sale in the FULFILL context. Legacy documents
   * written before this field hydrate as the C# default (false — not offered for
   * sale), which is the safe default; only the available-to-sell query filters on it.
   */
  sellable?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /**
   * The produce-tag identity of this material item, or null when it is an ordinary
   * hardgood. Legacy documents written before tags existed hydrate as null, which is the
   * correct answer for every one of them — a tag is a material item, but almost no material item
   * is a tag.
   */
  tag?: InputMaybe<MaterialItemTagDataSortInput>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MaterialItemLocationQuantitiesConnection = {
  __typename?: 'MaterialItemLocationQuantitiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialItemLocationQuantitiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemLocationQuantityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialItemLocationQuantitiesEdge = {
  __typename?: 'MaterialItemLocationQuantitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemLocationQuantityDocument;
};

export type MaterialItemLocationQuantityDocument = {
  __typename?: 'MaterialItemLocationQuantityDocument';
  /**
   * The batches this bin holds, every one with stock, summing to the bin's quantity. Empty when the
   * material item is not batch tracked. A bin of a tracked material item that has not recorded batches
   * yet shows its whole quantity on the unknown batch.
   */
  batches: Array<InventoryBatch>;
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type MaterialItemLocationQuantityDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialItemLocationQuantityDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialItemLocationQuantityDocumentFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type MaterialItemLocationQuantityDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type MaterialItemLocationQuantityPayload = {
  __typename?: 'MaterialItemLocationQuantityPayload';
  /**
   * The orders whose allocations a count or adjust released because it took stock orders held: free stock goes
   * first, then the newest orders' allocations. Only the orders the caller can see under the orders
   * visibility rule are named; otherAffectedOrderCount counts the rest. Empty when nothing was
   * released, and on every other mutation.
   */
  affectedOrders: Array<InventoryOrderImpactData>;
  errors?: Maybe<Array<ValidationError>>;
  materialItemLocationQuantity?: Maybe<Array<MaterialItemLocationQuantityDocument>>;
  /** How many other released orders there are, which the caller cannot see. */
  otherAffectedOrderCount: Scalars['Int']['output'];
};

export type MaterialItemPayload = {
  __typename?: 'MaterialItemPayload';
  errors?: Maybe<Array<ValidationError>>;
  materialItem?: Maybe<MaterialItemDocument>;
};

/** A connection to a list of items. */
export type MaterialItemSiteLocationQuantitiesConnection = {
  __typename?: 'MaterialItemSiteLocationQuantitiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialItemSiteLocationQuantitiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemSiteLocationQuantityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialItemSiteLocationQuantitiesEdge = {
  __typename?: 'MaterialItemSiteLocationQuantitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemSiteLocationQuantityDocument;
};

export type MaterialItemSiteLocationQuantityDocument = {
  __typename?: 'MaterialItemSiteLocationQuantityDocument';
  id: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type MaterialItemSiteLocationQuantityDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialItemSiteLocationQuantityDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialItemSiteLocationQuantityDocumentFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type MaterialItemSiteLocationQuantityDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export enum MaterialItemStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type MaterialItemStatusOperationFilterInput = {
  eq?: InputMaybe<MaterialItemStatus>;
  in?: InputMaybe<Array<MaterialItemStatus>>;
  neq?: InputMaybe<MaterialItemStatus>;
  nin?: InputMaybe<Array<MaterialItemStatus>>;
};

/**
 * The tag identity denormalized onto a MaterialItemDocument. Present only on material
 * items that ARE produce tags; null on every ordinary hardgood.
 */
export type MaterialItemTagData = {
  __typename?: 'MaterialItemTagData';
  category?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extraCodes: Array<Scalars['String']['output']>;
  /**
   * A plain reference string naming a fulfill item. It carries NO behavior in v1 — nothing
   * validates it against fulfill, inherits it, auto-assigns it or derives a UPC from it. Fulfill
   * item linking is v2's scope.
   */
  fulfillItemCode?: Maybe<Scalars['String']['output']>;
  genus?: Maybe<Scalars['String']['output']>;
  retail?: Maybe<Scalars['Decimal']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this tag is maintained by hand or kept in step with a fulfill item automatically.
   * Always manual today, because no automatic sync exists yet.
   */
  source: ProduceTagSource;
  tagCode: Scalars['String']['output'];
  tagId?: Maybe<Scalars['String']['output']>;
  tagType?: Maybe<Scalars['String']['output']>;
  upc?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['String']['output']>;
  weekFrom?: Maybe<Scalars['Int']['output']>;
  weekTo?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/**
 * The tag identity denormalized onto a MaterialItemDocument. Present only on material
 * items that ARE produce tags; null on every ordinary hardgood.
 */
export type MaterialItemTagDataFilterInput = {
  and?: InputMaybe<Array<MaterialItemTagDataFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  color?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  extraCodes?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * A plain reference string naming a fulfill item. It carries NO behavior in v1 — nothing
   * validates it against fulfill, inherits it, auto-assigns it or derives a UPC from it. Fulfill
   * item linking is v2's scope.
   */
  fulfillItemCode?: InputMaybe<StringOperationFilterInput>;
  genus?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialItemTagDataFilterInput>>;
  retail?: InputMaybe<DecimalOperationFilterInput>;
  series?: InputMaybe<StringOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  tagCode?: InputMaybe<StringOperationFilterInput>;
  tagId?: InputMaybe<StringOperationFilterInput>;
  tagType?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  volume?: InputMaybe<StringOperationFilterInput>;
  weekFrom?: InputMaybe<IntOperationFilterInput>;
  weekTo?: InputMaybe<IntOperationFilterInput>;
  year?: InputMaybe<IntOperationFilterInput>;
};

/**
 * The tag identity denormalized onto a MaterialItemDocument. Present only on material
 * items that ARE produce tags; null on every ordinary hardgood.
 */
export type MaterialItemTagDataSortInput = {
  category?: InputMaybe<SortEnumType>;
  color?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  /**
   * A plain reference string naming a fulfill item. It carries NO behavior in v1 — nothing
   * validates it against fulfill, inherits it, auto-assigns it or derives a UPC from it. Fulfill
   * item linking is v2's scope.
   */
  fulfillItemCode?: InputMaybe<SortEnumType>;
  genus?: InputMaybe<SortEnumType>;
  retail?: InputMaybe<SortEnumType>;
  series?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  tagCode?: InputMaybe<SortEnumType>;
  tagId?: InputMaybe<SortEnumType>;
  tagType?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  volume?: InputMaybe<SortEnumType>;
  weekFrom?: InputMaybe<SortEnumType>;
  weekTo?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MaterialItemsConnection = {
  __typename?: 'MaterialItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialItemsEdge = {
  __typename?: 'MaterialItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemDocument;
};

/** A connection to a list of items. */
export type MaterialOrdersConnection = {
  __typename?: 'MaterialOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialOrdersEdge = {
  __typename?: 'MaterialOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpOrderDocument;
};

/** A connection to a list of items. */
export type MaterialOrdersForLocationConnection = {
  __typename?: 'MaterialOrdersForLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialOrdersForLocationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialOrdersForLocationEdge = {
  __typename?: 'MaterialOrdersForLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpOrderDocument;
};

/** The action a price preview is asked about. */
export enum MaterialPriceAction {
  /** Restate the whole quote tuple of one price, keeping its identity. */
  Correct = 'CORRECT',
  /** Exclude one price from every live read, keeping it and its revisions for history. */
  Void = 'VOID'
}

/**
 * A read-only preview of what correcting or voiding one vendor price would do to the price that applies
 * on a stated day. Nothing is written, and the values it reports are the ones a commit must be checked
 * against.
 */
export type MaterialPriceActionPreview = {
  __typename?: 'MaterialPriceActionPreview';
  /** The action previewed. */
  action: MaterialPriceAction;
  /** The server-calendar day the applicable price was resolved for. */
  asOf: Scalars['LocalDate']['output'];
  /** The price applicable to this vendor on the stated day now. */
  current: MaterialApplicablePriceData;
  /** What that difference does to estimates pricing against this vendor. */
  estimateEffect: MaterialPriceEstimateEffect;
  /** The same difference in words, for the confirmation the grower reads. */
  explanation: Scalars['String']['output'];
  /** Whether that vendor is the material's default vendor. */
  isDefaultVendor: Scalars['Boolean']['output'];
  /** The material the price belongs to. */
  materialItemId: Scalars['String']['output'];
  /** The same price as the action would leave it. */
  proposed: MaterialPriceQuoteData;
  /**
   * The material's purchasing revision when the preview was taken. It advances on any vendor, assignment,
   * default or price change, so a commit that carries it back rejects a reviewed write that a default,
   * unit-of-measure, SKU, detach or lifecycle change has since invalidated, even when the price revision
   * has not moved.
   */
  purchasingRevision: Scalars['Int']['output'];
  /** The price that would be applicable on the stated day after the action. */
  resulting: MaterialApplicablePriceData;
  /** The price the action names, as it stands now. */
  selected: MaterialPriceQuoteData;
  /** The vendor the price belongs to. */
  vendorId: Scalars['String']['output'];
};

/**
 * Input for the price action preview: which price, which action, the values the action would write, and
 * the day to resolve the applicable price for.
 */
export type MaterialPriceActionPreviewInput = {
  /** Correct or void. */
  action: MaterialPriceAction;
  /** The day to resolve against; the server's current day when omitted. */
  asOf?: InputMaybe<Scalars['LocalDate']['input']>;
  /** The corrected effective day; omitted means the always-effective base rate. */
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** The material holding the price. */
  materialItemId: Scalars['String']['input'];
  /** The price the action names, canonical lower-case 32-hex. */
  priceId: Scalars['String']['input'];
  /** The corrected royalty per each, which the status pins. */
  supplierRoyaltyPerEach?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * The corrected royalty per each as exact decimal text. Send this rather than supplierRoyaltyPerEach
   * for the same reason as unitCostText; when both are sent they must be the same amount. Rejected for
   * a void.
   */
  supplierRoyaltyPerEachText?: InputMaybe<Scalars['String']['input']>;
  /** The review state the correction records. Required for a correction, rejected for a void. */
  supplierRoyaltyStatus?: InputMaybe<SupplierRoyaltyStatus>;
  /** The corrected per-each base amount as a number. A correction needs this or unitCostText; rejected for a void. */
  unitCost?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * The corrected per-each base amount as exact decimal text, in the same form correctMaterialPrice
   * takes. Send this rather than unitCost, which a JSON client can only send as a double, so the
   * preview states every digit the correction will save. When both are sent they must be the same
   * amount; a pair that disagrees is refused rather than one of them being picked. Rejected for a void.
   */
  unitCostText?: InputMaybe<Scalars['String']['input']>;
};

/** Reports a price action preview, or why one could not be produced. */
export type MaterialPriceActionPreviewPayload = {
  __typename?: 'MaterialPriceActionPreviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  preview?: Maybe<MaterialPriceActionPreview>;
};

export enum MaterialPriceComponentOrigin {
  ManualOverride = 'MANUAL_OVERRIDE',
  SupplierQuote = 'SUPPLIER_QUOTE'
}

/** What an action does to the estimates that price against the affected vendor. */
export enum MaterialPriceEstimateEffect {
  /** A quote applies before the action and none after it. */
  BecomesMissing = 'BECOMES_MISSING',
  /** No quote applies before the action and one does after it. */
  BecomesPriced = 'BECOMES_PRICED',
  /** The applicable result differs: another quote, or no quote either way but a different day pricing starts. */
  PriceChanged = 'PRICE_CHANGED',
  /** The applicable result is identical before and after. */
  Unchanged = 'UNCHANGED'
}

/**
 * Live prices of one material and vendor that share an effective day (or are both base rates) and an
 * Updated instant exact to the tick. The winner was formerly unspecified; PriceId ordering makes it the
 * lowest PriceId once identity readiness is reached.
 */
export type MaterialPriceExactTie = {
  __typename?: 'MaterialPriceExactTie';
  /** The shared effective day; null for tied base rates. */
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Whether the tied prices are base rates. */
  isBaseRate: Scalars['Boolean']['output'];
  /** The material the tied prices belong to. */
  materialItemId: Scalars['String']['output'];
  /** The tied rows in stored order. */
  tiedRows: Array<MaterialPriceExactTieRow>;
  /** The shared Updated instant. */
  updated: Scalars['DateTime']['output'];
  /** The vendor the tied prices belong to. */
  vendorId: Scalars['String']['output'];
  /** The winner under PriceId ordering; null while any tied row lacks a unique canonical PriceId. */
  winnerPriceId?: Maybe<Scalars['String']['output']>;
};

/** One row of an exact price tie. */
export type MaterialPriceExactTieRow = {
  __typename?: 'MaterialPriceExactTieRow';
  /** The row's PriceId; null when the identity replay has not reached it. */
  priceId?: Maybe<Scalars['String']['output']>;
  /** The price row's opaque document id. */
  rowId: Scalars['String']['output'];
  /** The row's per-each amount, which never decides the tie. */
  unitCost: Scalars['Decimal']['output'];
};

/** What one price event did, as the history query classifies it. Append only. */
export enum MaterialPriceHistoryAction {
  /** A legacy scalar write replaced the price already holding its slot. */
  LegacyPriceReplaced = 'LEGACY_PRICE_REPLACED',
  /** A legacy scalar write created a price in a vacant slot. */
  LegacyPriceSet = 'LEGACY_PRICE_SET',
  /** A legacy scalar write resolved to a voided price and changed nothing. */
  LegacyWriteIgnored = 'LEGACY_WRITE_IGNORED',
  /** An explicit versioned price was added under its own PriceId. */
  PriceAdded = 'PRICE_ADDED',
  /** An explicit correction advanced an existing price. */
  PriceCorrected = 'PRICE_CORRECTED',
  /** An explicit void made an existing price terminal. */
  PriceVoided = 'PRICE_VOIDED',
  /** A correction or void named a PriceId this material never held, or a voided one. */
  UnresolvedTarget = 'UNRESOLVED_TARGET'
}

/**
 * One entry in a material's price history: one price event from the material's stream, in stream
 * order, with the price it touched, the revision it produced, the values before and after, and
 * the actor, time, reason and source evidence where the event recorded them.
 */
export type MaterialPriceHistoryRecord = {
  __typename?: 'MaterialPriceHistoryRecord';
  /** What the event did, including the no-op outcomes. */
  action: MaterialPriceHistoryAction;
  /** The acting user recorded on the event; null when the event carries none. */
  actor?: Maybe<Scalars['String']['output']>;
  /** The tuple after the event; null for a no-op with no target. */
  after?: Maybe<MaterialPriceHistoryValues>;
  /** The tuple before the event; null for a first write or a no-op with no target. */
  before?: Maybe<MaterialPriceHistoryValues>;
  /** Why a no-op event changed nothing; null for every applied event. */
  diagnostic?: Maybe<Scalars['String']['output']>;
  /** The event store's id for the event. */
  eventId: Scalars['String']['output'];
  /** The event's position in the material's stream; the causal order. */
  eventNumber: Scalars['Long']['output'];
  /** The persisted event type name. */
  eventType: Scalars['String']['output'];
  /** The event's own timestamp. */
  occurredAt: Scalars['DateTime']['output'];
  /** The price the event resolved to or named; a legacy id is replay-derived. */
  priceId: Scalars['String']['output'];
  /** The reason the writer recorded; null for legacy writes. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The price's revision after the event; unchanged for a no-op. */
  revision: Scalars['Int']['output'];
  /** Source evidence in force for this revision; null when none was ever recorded. */
  sourceProvenance?: Maybe<MaterialPriceSourceProvenanceData>;
  /** The price's lifecycle after the event. */
  status: MaterialPriceStatus;
  /** Whether the vendor is unassigned from the material today. History is kept either way; live eligibility is not decided here. */
  vendorDetached: Scalars['Boolean']['output'];
  /** The vendor the price belongs to; empty when no target resolved. */
  vendorId: Scalars['String']['output'];
};

/**
 * The quote tuple of one price as it stood before or after an event. A null effective date with the
 * base-rate flag set means the always-effective base rate.
 */
export type MaterialPriceHistoryValues = {
  __typename?: 'MaterialPriceHistoryValues';
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  effectiveWeek?: Maybe<Scalars['Int']['output']>;
  effectiveYear?: Maybe<Scalars['Int']['output']>;
  isBaseRate: Scalars['Boolean']['output'];
  status: MaterialPriceStatus;
  supplierRoyaltyPerEach?: Maybe<Scalars['Decimal']['output']>;
  /** The recorded royalty per each as exact decimal text, null whenever supplierRoyaltyPerEach is null. Read this rather than the number for the same reason as unitCostText. */
  supplierRoyaltyPerEachText?: Maybe<Scalars['String']['output']>;
  supplierRoyaltyStatus: SupplierRoyaltyStatus;
  unitCost: Scalars['Decimal']['output'];
  /** The per-each base amount as exact decimal text. The same amount as unitCost, in a form that carries every digit the price held at this point in its history; read this rather than the number, which a JSON client receives as a double. */
  unitCostText: Scalars['String']['output'];
};

/** Whether a tenant's vendor price read model is ready to be read by PriceId: the MaterialPriceIdentityReadReady marker. */
export type MaterialPriceIdentityReadinessPayload = {
  __typename?: 'MaterialPriceIdentityReadinessPayload';
  /** PriceIds held by more than one row of the tenant. */
  duplicateIdentity: Scalars['Long']['output'];
  /**
   * The caller's tenant's live prices whose winner is decided only by an exact tie, with the winner
   * PriceId ordering selects. Every other selection is unchanged by readiness.
   */
  exactTies: Array<MaterialPriceExactTie>;
  /** Rows whose PriceId is not canonical lower-case 32-hex. */
  invalidIdentity: Scalars['Long']['output'];
  /** True only when every count below is zero and the identity replay has caught up. */
  materialPriceIdentityReadReady: Scalars['Boolean']['output'];
  /** Rows the identity replay has not reached: no PriceId or no Revision yet. */
  missingIdentity: Scalars['Long']['output'];
  /** Vendor price rows the tenant holds, voided and detached included. */
  priceRows: Scalars['Long']['output'];
  /** The first thing keeping the marker false; null when ready. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Whether the projection has replayed past the position it held when the identity replay was started, or no replay was ever started. */
  replayCaughtUp: Scalars['Boolean']['output'];
};

export enum MaterialPriceOperationKind {
  Add = 'ADD',
  AssignWithQuote = 'ASSIGN_WITH_QUOTE',
  Correct = 'CORRECT',
  Create = 'CREATE',
  Void = 'VOID'
}

export enum MaterialPriceQuoteBasis {
  ConvertedPerPack = 'CONVERTED_PER_PACK',
  DirectPerEach = 'DIRECT_PER_EACH',
  Unresolved = 'UNRESOLVED'
}

/**
 * One vendor price as a preview reports it: the identity and revision an action must name, the stored
 * quote tuple, and the royalty coverage that tuple carries.
 */
export type MaterialPriceQuoteData = {
  __typename?: 'MaterialPriceQuoteData';
  /** The day the price applies from; null when it is the base rate. */
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Whether the price is the always-effective base rate. */
  isBaseRate: Scalars['Boolean']['output'];
  /** The price's stable identity. */
  priceId: Scalars['String']['output'];
  /** The revision the values belong to; a commit must still enforce it. */
  revision: Scalars['Int']['output'];
  /** Whether that review state makes the royalty known. */
  royaltyCoverage: RoyaltyCoverage;
  /** Active, or Voided. */
  status: MaterialPriceStatus;
  /** The separately recorded royalty per each; null unless the status carries one. */
  supplierRoyaltyPerEach?: Maybe<Scalars['Decimal']['output']>;
  /** The recorded royalty per each as exact decimal text, null whenever supplierRoyaltyPerEach is null. Read this rather than the number for the same reason as unitCostText. */
  supplierRoyaltyPerEachText?: Maybe<Scalars['String']['output']>;
  /** The review state of the royalty component. */
  supplierRoyaltyStatus: SupplierRoyaltyStatus;
  /** The per-each base amount, exactly as stored. */
  unitCost: Scalars['Decimal']['output'];
  /** The per-each base amount as exact decimal text. The same amount as unitCost, in a form that carries every digit the price holds; seed a correction from this rather than from the number, which a JSON client receives as a double. */
  unitCostText: Scalars['String']['output'];
};

/** How much of a tenant's live vendor pricing states its supplier royalty, counted by review state. */
export type MaterialPriceRoyaltyCoveragePayload = {
  __typename?: 'MaterialPriceRoyaltyCoveragePayload';
  /** Live prices a reviewer explicitly confirmed carry no royalty. */
  confirmedNone: Scalars['Long']['output'];
  /** Confirmed only when every live price states its royalty; not applicable when the tenant has none. */
  coverage: SupplierRoyaltyCoverage;
  /** Live prices whose royalty was never recorded, which is unknown history rather than a confirmed none. */
  legacyUnspecified: Scalars['Long']['output'];
  /** Live prices counted, which excludes voided and detached rows exactly as pricing does. */
  livePrices: Scalars['Long']['output'];
  /** Live prices a reviewer explicitly saved base only, leaving the royalty unconfirmed. */
  reviewedUnconfirmed: Scalars['Long']['output'];
  /** Live prices carrying a stated royalty amount. */
  specified: Scalars['Long']['output'];
};

/**
 * The source evidence recorded with a price revision, exactly as reviewed then: the document,
 * draft and row it came from, where on the page, the supplier's own description and identifier,
 * the amount, unit and pack as quoted, how royalty was stated, the per-each result the reviewer
 * accepted, and the basis and precision that produced it. Never a reconstruction from today's pack
 * multiplier or today's tenant setting.
 */
export type MaterialPriceSourceProvenanceData = {
  __typename?: 'MaterialPriceSourceProvenanceData';
  /**
   * Whether the quoted amount was stated per each or per pack: the difference between a direct quote
   * kept at its own precision and one the server converted. Null on a revision recorded before the
   * basis was carried.
   */
  basis?: Maybe<MaterialPriceQuoteBasis>;
  /**
   * The recorded N: the tenant calculation precision this conversion actually ran at, not whatever the
   * tenant is configured for today. Null on a revision recorded before it was carried.
   */
  calcDecimals?: Maybe<Scalars['Int']['output']>;
  /** Where on the source document the quote sits, page. */
  pageReference?: Maybe<Scalars['String']['output']>;
  /** The amount as quoted, before any per-each conversion. */
  quotedAmount?: Maybe<Scalars['Decimal']['output']>;
  /** The amount as quoted, before any per-each conversion, as exact decimal text, null whenever quotedAmount is null. Read this rather than the number, which a JSON client receives as a double. */
  quotedAmountText?: Maybe<Scalars['String']['output']>;
  /** The pack size the quoted amount covered; one for a direct quote. */
  quotedPackQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The unit the quoted amount was stated in. */
  quotedUnit?: Maybe<Scalars['String']['output']>;
  /** The per-each result the reviewer accepted from the quote. */
  reviewedPerEachCost?: Maybe<Scalars['Decimal']['output']>;
  /** Where on the source document the quote sits, row or line. */
  rowReference?: Maybe<Scalars['String']['output']>;
  /** How the source stated royalty, as reviewed. */
  royaltyTreatment?: Maybe<Scalars['String']['output']>;
  /**
   * The tenant document the quote was read from; null on a MANUAL entry, which has no document. Null
   * here therefore means "worked out by hand" rather than "evidence missing": a revision with no
   * evidence at all carries no provenance object.
   */
  sourceDocumentId?: Maybe<Scalars['String']['output']>;
  /** The import draft the row belonged to, when one existed. */
  sourceDraftId?: Maybe<Scalars['String']['output']>;
  /** The reviewed row within that draft. */
  sourceRowId?: Maybe<Scalars['String']['output']>;
  /** The supplier's own description of the item. */
  supplierDescription?: Maybe<Scalars['String']['output']>;
  /** The supplier's own item identifier, when printed. */
  supplierIdentifier?: Maybe<Scalars['String']['output']>;
};

export enum MaterialPriceStatus {
  Active = 'ACTIVE',
  Voided = 'VOIDED'
}

export type MaterialPriceStatusOperationFilterInput = {
  eq?: InputMaybe<MaterialPriceStatus>;
  in?: InputMaybe<Array<MaterialPriceStatus>>;
  neq?: InputMaybe<MaterialPriceStatus>;
  nin?: InputMaybe<Array<MaterialPriceStatus>>;
};

/**
 * Whether a tenant may make explicit versioned material price writes right now, and the evidence
 * behind the answer.
 */
export type MaterialPriceWriteCapabilityPayload = {
  __typename?: 'MaterialPriceWriteCapabilityPayload';
  /** The first thing withholding the capability; null when it is available. */
  disabledReason?: Maybe<Scalars['String']['output']>;
  /** Whether the three explicit price writes will be accepted for this tenant. */
  enabled: Scalars['Boolean']['output'];
  /** Whether the MaterialPriceCorrections capability resolves on for the tenant. */
  flagEnabled: Scalars['Boolean']['output'];
  /** How that value was resolved: the global value, a tenant override, a trial restriction, or an inactive flag. */
  flagResolutionReason: FeatureFlagResolutionReason;
  /** The first thing keeping identity readiness false; null when it is ready. */
  identityReadinessReason?: Maybe<Scalars['String']['output']>;
  /** Whether every one of the tenant's price rows carries a canonical identity. */
  materialPriceIdentityReadReady: Scalars['Boolean']['output'];
  /** Whether the SupplierPriceImportApplyEnabled capability resolves on for the tenant. Reported only; it does not change Enabled. */
  supplierPriceImportApplyFlagEnabled: Scalars['Boolean']['output'];
  /** How that value was resolved: the global value, a tenant override, a trial restriction, or an inactive flag. */
  supplierPriceImportApplyFlagResolutionReason: FeatureFlagResolutionReason;
};

/** Reports a gated price write's receipt, or why one was not produced. */
export type MaterialPriceWritePayload = {
  __typename?: 'MaterialPriceWritePayload';
  errors?: Maybe<Array<ValidationError>>;
  receipt?: Maybe<MaterialPriceWriteReceipt>;
};

/**
 * The receipt one gated price write produces: which operation it was, the price it landed on, and
 * the two revisions the caller needs to make its NEXT write without waiting for the read model.
 */
export type MaterialPriceWriteReceipt = {
  __typename?: 'MaterialPriceWriteReceipt';
  /** Which of the three writes it was. */
  kind: MaterialPriceOperationKind;
  /** The material the price belongs to. */
  materialItemId: Scalars['String']['output'];
  /** The caller's own idempotency key for the write. */
  operationId: Scalars['String']['output'];
  /** The price the write landed on; server minted for an add. */
  priceId: Scalars['String']['output'];
  /** That price's revision after the write. */
  priceRevision: Scalars['Int']['output'];
  /** The material's purchasing revision after the write. */
  purchasingRevision: Scalars['Int']['output'];
  /** When the write was recorded, on the domain clock. */
  recorded: Scalars['DateTime']['output'];
};

/**
 * Immutable audit record for a single material-order receipt recorded by a BPF field user — the
 * wsapi-resident replacement for the legacy InventoryMaterial.OrderLineChange rows. Written
 * exactly once per logical receipt (idempotency-key deduped), before the Material ERP write-back is
 * enqueued; the only later change is storing that write-back's id.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type MaterialReceiptDocument = {
  __typename?: 'MaterialReceiptDocument';
  /** The receiving bin code; empty when not supplied. */
  binCode: Scalars['String']['output'];
  /** When the receipt was recorded. */
  createdAt: Scalars['DateTime']['output'];
  /** The raw Nav item number of the received line (snapshot at receipt time). */
  erpItemNo: Scalars['String']['output'];
  /**
   * The Material ERP write-back queue record that posts this receipt; every receipt of a group holds
   * the group's one record. Empty until that record is enqueued.
   */
  erpWriteBackId: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{ReceiptId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit with the same key returns the
   * existing record and never saves or enqueues a second one, so a PWA retry / offline replay never
   * double-receives; it only finishes an enqueue the first submit did not get to.
   */
  idempotencyKey: Scalars['String']['output'];
  /**
   * Snapshot (at receipt time) of the received line's ItemId: the canonical wsapi
   * ItemId when the ERP item is a finished good present in ItemSummary, else the raw ERP
   * item number passed through unchanged — an audit passthrough only. Validation and the Material
   * ERP write-back always key on ErpItemNo, never on this field.
   */
  itemId: Scalars['String']['output'];
  /** The Nav line number the receipt is against. */
  lineNo: Scalars['Int']['output'];
  /** The receiving station (canonical wsapi SiteLocationId) the receipt posts to. */
  locationId: Scalars['String']['output'];
  /** Free-form field-user notes; empty when none. */
  notes: Scalars['String']['output'];
  /** The Nav order number the receipt is against. */
  orderNumber: Scalars['String']['output'];
  /** Whether the receipt is against a purchase order or an inbound transfer order. */
  orderType: ErpOrderType;
  /** NAV's outstanding quantity on the line, as the order sync last read it, when the receipt was recorded. */
  outstandingBefore: Scalars['Decimal']['output'];
  /** The quantity received (always positive). */
  quantityReceived: Scalars['Decimal']['output'];
  /** The server-generated receipt id, distinct from the composite Id. */
  receiptId: Scalars['String']['output'];
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The unit of measure for QuantityReceived (e.g. EA, FLAT); empty when not supplied. */
  unit: Scalars['String']['output'];
  /** The field user (email) who recorded the receipt, from the authenticated principal. */
  user: Scalars['String']['output'];
  /**
   * The vendor / lot number captured for the receipt, trimmed and upper-cased; empty when not
   * supplied, which an organic line refuses.
   */
  vendorLotNumber: Scalars['String']['output'];
};

/**
 * Immutable audit record for a single material-order receipt recorded by a BPF field user — the
 * wsapi-resident replacement for the legacy InventoryMaterial.OrderLineChange rows. Written
 * exactly once per logical receipt (idempotency-key deduped), before the Material ERP write-back is
 * enqueued; the only later change is storing that write-back's id.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type MaterialReceiptDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialReceiptDocumentFilterInput>>;
  /** The receiving bin code; empty when not supplied. */
  binCode?: InputMaybe<StringOperationFilterInput>;
  /** When the receipt was recorded. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The raw Nav item number of the received line (snapshot at receipt time). */
  erpItemNo?: InputMaybe<StringOperationFilterInput>;
  /**
   * The Material ERP write-back queue record that posts this receipt; every receipt of a group holds
   * the group's one record. Empty until that record is enqueued.
   */
  erpWriteBackId?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{ReceiptId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit with the same key returns the
   * existing record and never saves or enqueues a second one, so a PWA retry / offline replay never
   * double-receives; it only finishes an enqueue the first submit did not get to.
   */
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  /**
   * Snapshot (at receipt time) of the received line's ItemId: the canonical wsapi
   * ItemId when the ERP item is a finished good present in ItemSummary, else the raw ERP
   * item number passed through unchanged — an audit passthrough only. Validation and the Material
   * ERP write-back always key on ErpItemNo, never on this field.
   */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** The Nav line number the receipt is against. */
  lineNo?: InputMaybe<IntOperationFilterInput>;
  /** The receiving station (canonical wsapi SiteLocationId) the receipt posts to. */
  locationId?: InputMaybe<StringOperationFilterInput>;
  /** Free-form field-user notes; empty when none. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialReceiptDocumentFilterInput>>;
  /** The Nav order number the receipt is against. */
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  /** Whether the receipt is against a purchase order or an inbound transfer order. */
  orderType?: InputMaybe<ErpOrderTypeOperationFilterInput>;
  /** NAV's outstanding quantity on the line, as the order sync last read it, when the receipt was recorded. */
  outstandingBefore?: InputMaybe<DecimalOperationFilterInput>;
  /** The quantity received (always positive). */
  quantityReceived?: InputMaybe<DecimalOperationFilterInput>;
  /** The server-generated receipt id, distinct from the composite Id. */
  receiptId?: InputMaybe<StringOperationFilterInput>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The unit of measure for QuantityReceived (e.g. EA, FLAT); empty when not supplied. */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** The field user (email) who recorded the receipt, from the authenticated principal. */
  user?: InputMaybe<StringOperationFilterInput>;
  /**
   * The vendor / lot number captured for the receipt, trimmed and upper-cased; empty when not
   * supplied, which an organic line refuses.
   */
  vendorLotNumber?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Immutable audit record for a single material-order receipt recorded by a BPF field user — the
 * wsapi-resident replacement for the legacy InventoryMaterial.OrderLineChange rows. Written
 * exactly once per logical receipt (idempotency-key deduped), before the Material ERP write-back is
 * enqueued; the only later change is storing that write-back's id.
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>.
 */
export type MaterialReceiptDocumentSortInput = {
  /** The receiving bin code; empty when not supplied. */
  binCode?: InputMaybe<SortEnumType>;
  /** When the receipt was recorded. */
  createdAt?: InputMaybe<SortEnumType>;
  /** The raw Nav item number of the received line (snapshot at receipt time). */
  erpItemNo?: InputMaybe<SortEnumType>;
  /**
   * The Material ERP write-back queue record that posts this receipt; every receipt of a group holds
   * the group's one record. Empty until that record is enqueued.
   */
  erpWriteBackId?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{ReceiptId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Idempotency key. Unique per (tenant, key): a duplicate submit with the same key returns the
   * existing record and never saves or enqueues a second one, so a PWA retry / offline replay never
   * double-receives; it only finishes an enqueue the first submit did not get to.
   */
  idempotencyKey?: InputMaybe<SortEnumType>;
  /**
   * Snapshot (at receipt time) of the received line's ItemId: the canonical wsapi
   * ItemId when the ERP item is a finished good present in ItemSummary, else the raw ERP
   * item number passed through unchanged — an audit passthrough only. Validation and the Material
   * ERP write-back always key on ErpItemNo, never on this field.
   */
  itemId?: InputMaybe<SortEnumType>;
  /** The Nav line number the receipt is against. */
  lineNo?: InputMaybe<SortEnumType>;
  /** The receiving station (canonical wsapi SiteLocationId) the receipt posts to. */
  locationId?: InputMaybe<SortEnumType>;
  /** Free-form field-user notes; empty when none. */
  notes?: InputMaybe<SortEnumType>;
  /** The Nav order number the receipt is against. */
  orderNumber?: InputMaybe<SortEnumType>;
  /** Whether the receipt is against a purchase order or an inbound transfer order. */
  orderType?: InputMaybe<SortEnumType>;
  /** NAV's outstanding quantity on the line, as the order sync last read it, when the receipt was recorded. */
  outstandingBefore?: InputMaybe<SortEnumType>;
  /** The quantity received (always positive). */
  quantityReceived?: InputMaybe<SortEnumType>;
  /** The server-generated receipt id, distinct from the composite Id. */
  receiptId?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The unit of measure for QuantityReceived (e.g. EA, FLAT); empty when not supplied. */
  unit?: InputMaybe<SortEnumType>;
  /** The field user (email) who recorded the receipt, from the authenticated principal. */
  user?: InputMaybe<SortEnumType>;
  /**
   * The vendor / lot number captured for the receipt, trimmed and upper-cased; empty when not
   * supplied, which an organic line refuses.
   */
  vendorLotNumber?: InputMaybe<SortEnumType>;
};

/**
 * Payload of the material-receipt group mutation: the group's saved receipts in body order on
 * success, or the validation error(s) on failure, when receipts is empty.
 */
export type MaterialReceiptGroupPayload = {
  __typename?: 'MaterialReceiptGroupPayload';
  errors?: Maybe<Array<ValidationError>>;
  receipts: Array<MaterialReceiptDocument>;
};

/**
 * Single-record payload for the material-receipt mutation. Carries the receipt audit record on
 * success, or the validation error(s) on failure (including the BPF-only tenant rejection and the
 * order/line/quantity validation errors).
 */
export type MaterialReceiptPayload = {
  __typename?: 'MaterialReceiptPayload';
  errors?: Maybe<Array<ValidationError>>;
  receipt?: Maybe<MaterialReceiptDocument>;
};

/** A connection to a list of items. */
export type MaterialReceiptsConnection = {
  __typename?: 'MaterialReceiptsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialReceiptsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialReceiptDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialReceiptsEdge = {
  __typename?: 'MaterialReceiptsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialReceiptDocument;
};

/**
 * Read-model document representing a single material transaction (count, move, receive, or
 * production consumption or adjustment).
 * Written by WorkSuite.GraphQl.Services.MaterialTransactionProjectionService
 * and queried via MaterialTransactionQuery.
 */
export type MaterialTransactionDocument = {
  __typename?: 'MaterialTransactionDocument';
  countType: MaterialItemCountType;
  id: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  /** Number of the consuming job, or null when there is none. */
  jobNumber?: Maybe<Scalars['Int']['output']>;
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  /** Number of the consuming lot, or null when there is none. */
  lotNumber?: Maybe<Scalars['Int']['output']>;
  materialItemId: Scalars['String']['output'];
  previousQuantity: Scalars['Decimal']['output'];
  /** Production job that consumed the material, or empty when the row is not production. */
  productionJobId: Scalars['String']['output'];
  /** Production lot holding the consuming job, or empty when the row is not production. */
  productionLotId: Scalars['String']['output'];
  /** Purchase order number for receive transactions. */
  purchaseOrderNumber: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  reasonCode: Scalars['String']['output'];
  /**
   * The vendor lots a receive transaction brought in, each with the quantity received on it, so a line received
   * as several lots lists every lot. Empty for every other transaction type and for a receive that named no
   * vendor lot.
   */
  receiptLots: Array<MaterialTransactionReceiptLotData>;
  siteLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  /** Destination location for move transactions. */
  toLocationId: Scalars['String']['output'];
  /** Destination location name for move transactions. */
  toLocationName: Scalars['String']['output'];
  transactionType: MaterialTransactionType;
  userEmail: Scalars['String']['output'];
  /** Vendor name for receive transactions. */
  vendorName: Scalars['String']['output'];
  /** Vendor purchase order ID for receive transactions. */
  vendorPurchaseOrderId: Scalars['String']['output'];
};

/**
 * Read-model document representing a single material transaction (count, move, receive, or
 * production consumption or adjustment).
 * Written by WorkSuite.GraphQl.Services.MaterialTransactionProjectionService
 * and queried via MaterialTransactionQuery.
 */
export type MaterialTransactionDocumentFilterInput = {
  and?: InputMaybe<Array<MaterialTransactionDocumentFilterInput>>;
  countType?: InputMaybe<MaterialItemCountTypeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  /** Number of the consuming job, or null when there is none. */
  jobNumber?: InputMaybe<IntOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  /** Number of the consuming lot, or null when there is none. */
  lotNumber?: InputMaybe<IntOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MaterialTransactionDocumentFilterInput>>;
  previousQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Production job that consumed the material, or empty when the row is not production. */
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  /** Production lot holding the consuming job, or empty when the row is not production. */
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  /** Purchase order number for receive transactions. */
  purchaseOrderNumber?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  /**
   * The vendor lots a receive transaction brought in, each with the quantity received on it, so a line received
   * as several lots lists every lot. Empty for every other transaction type and for a receive that named no
   * vendor lot.
   */
  receiptLots?: InputMaybe<ListFilterInputTypeOfMaterialTransactionReceiptLotDataFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
  /** Destination location for move transactions. */
  toLocationId?: InputMaybe<StringOperationFilterInput>;
  /** Destination location name for move transactions. */
  toLocationName?: InputMaybe<StringOperationFilterInput>;
  transactionType?: InputMaybe<MaterialTransactionTypeOperationFilterInput>;
  userEmail?: InputMaybe<StringOperationFilterInput>;
  /** Vendor name for receive transactions. */
  vendorName?: InputMaybe<StringOperationFilterInput>;
  /** Vendor purchase order ID for receive transactions. */
  vendorPurchaseOrderId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document representing a single material transaction (count, move, receive, or
 * production consumption or adjustment).
 * Written by WorkSuite.GraphQl.Services.MaterialTransactionProjectionService
 * and queried via MaterialTransactionQuery.
 */
export type MaterialTransactionDocumentSortInput = {
  countType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  /** Number of the consuming job, or null when there is none. */
  jobNumber?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  /** Number of the consuming lot, or null when there is none. */
  lotNumber?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  previousQuantity?: InputMaybe<SortEnumType>;
  /** Production job that consumed the material, or empty when the row is not production. */
  productionJobId?: InputMaybe<SortEnumType>;
  /** Production lot holding the consuming job, or empty when the row is not production. */
  productionLotId?: InputMaybe<SortEnumType>;
  /** Purchase order number for receive transactions. */
  purchaseOrderNumber?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  reasonCode?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  timestamp?: InputMaybe<SortEnumType>;
  /** Destination location for move transactions. */
  toLocationId?: InputMaybe<SortEnumType>;
  /** Destination location name for move transactions. */
  toLocationName?: InputMaybe<SortEnumType>;
  transactionType?: InputMaybe<SortEnumType>;
  userEmail?: InputMaybe<SortEnumType>;
  /** Vendor name for receive transactions. */
  vendorName?: InputMaybe<SortEnumType>;
  /** Vendor purchase order ID for receive transactions. */
  vendorPurchaseOrderId?: InputMaybe<SortEnumType>;
};

/** One vendor lot a receive transaction brought in, with the quantity received on it. */
export type MaterialTransactionReceiptLotData = {
  __typename?: 'MaterialTransactionReceiptLotData';
  /** The quantity received on this lot. */
  quantity: Scalars['Decimal']['output'];
  /**
   * The purchase order receipt this lot was recorded on: the receiptEntryId of the matching entry in the
   * vendor purchase order's receipts.
   */
  receiptEntryId: Scalars['String']['output'];
  /** The vendor's lot number. */
  vendorLotNumber: Scalars['String']['output'];
};

/** One vendor lot a receive transaction brought in, with the quantity received on it. */
export type MaterialTransactionReceiptLotDataFilterInput = {
  and?: InputMaybe<Array<MaterialTransactionReceiptLotDataFilterInput>>;
  or?: InputMaybe<Array<MaterialTransactionReceiptLotDataFilterInput>>;
  /** The quantity received on this lot. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The purchase order receipt this lot was recorded on: the receiptEntryId of the matching entry in the
   * vendor purchase order's receipts.
   */
  receiptEntryId?: InputMaybe<StringOperationFilterInput>;
  /** The vendor's lot number. */
  vendorLotNumber?: InputMaybe<StringOperationFilterInput>;
};

/** Discriminator for the type of material transaction. */
export enum MaterialTransactionType {
  /** An audit correction that sets a bin's absolute on-hand quantity. */
  Adjusted = 'ADJUSTED',
  Counted = 'COUNTED',
  Moved = 'MOVED',
  /** A count a production job wrote when it consumed the material. */
  ProductionConsumed = 'PRODUCTION_CONSUMED',
  Received = 'RECEIVED',
  ReceivedCorrection = 'RECEIVED_CORRECTION',
  Unknown = 'UNKNOWN'
}

export type MaterialTransactionTypeOperationFilterInput = {
  eq?: InputMaybe<MaterialTransactionType>;
  in?: InputMaybe<Array<MaterialTransactionType>>;
  neq?: InputMaybe<MaterialTransactionType>;
  nin?: InputMaybe<Array<MaterialTransactionType>>;
};

/** A connection to a list of items. */
export type MaterialTransactionsConnection = {
  __typename?: 'MaterialTransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MaterialTransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialTransactionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MaterialTransactionsEdge = {
  __typename?: 'MaterialTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialTransactionDocument;
};

export enum MaterialUnit {
  CubicFoot = 'CUBIC_FOOT',
  CubicYard = 'CUBIC_YARD',
  Each = 'EACH',
  FluidOunce = 'FLUID_OUNCE',
  Foot = 'FOOT',
  Gallon = 'GALLON',
  Gram = 'GRAM',
  Kilogram = 'KILOGRAM',
  Liter = 'LITER',
  Ounce = 'OUNCE',
  Pound = 'POUND',
  Quart = 'QUART',
  SquareFoot = 'SQUARE_FOOT',
  Unknown = 'UNKNOWN'
}

export type MaterialVendorData = {
  __typename?: 'MaterialVendorData';
  isDefault: Scalars['Boolean']['output'];
  purchaseUom?: Maybe<Scalars['String']['output']>;
  unitsPerUom?: Maybe<Scalars['Decimal']['output']>;
  vendorId: Scalars['String']['output'];
  vendorItemId?: Maybe<Scalars['String']['output']>;
  vendorName: Scalars['String']['output'];
};

export type MaterialVendorDataFilterInput = {
  and?: InputMaybe<Array<MaterialVendorDataFilterInput>>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<MaterialVendorDataFilterInput>>;
  purchaseUom?: InputMaybe<StringOperationFilterInput>;
  unitsPerUom?: InputMaybe<DecimalOperationFilterInput>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
  vendorItemId?: InputMaybe<StringOperationFilterInput>;
  vendorName?: InputMaybe<StringOperationFilterInput>;
};

/** A vendor's assignment to a material item. Submitting this for a vendor ALREADY assigned to the item UPDATES the assignment rather than failing: vendorName, vendorItemId, purchaseUom and unitsPerUom are all replaced with what you send, so send the complete assignment you want. vendorName is REQUIRED and cannot be cleared; omit vendorItemId, purchaseUom or unitsPerUom to clear them. isDefault only ever promotes — sending false never demotes the current default, because an item with vendors must always have exactly one. Re-sending an assignment that changes nothing is rejected as a no-op. */
export type MaterialVendorInput = {
  isDefault: Scalars['Boolean']['input'];
  /** The name of the unit this vendor quotes and ships in, for example "bag" or "case". Stored lower-case, so "Bag" is returned as "bag". purchaseUom and unitsPerUom are a PAIR: supply both to state this vendor's pack, or neither to say the vendor prices in eaches. Half a pair is REJECTED, because ordered quantity reaches eaches by multiplying by unitsPerUom and a missing multiplier would understate the order by the whole pack size rather than fail. Send neither (or null, or "") to CLEAR a pack size previously stated — null and empty mean the same thing here. */
  purchaseUom?: InputMaybe<Scalars['String']['input']>;
  /** How many of the material's units make up one purchaseUom pack — a bag of 1,000 tags is 1000, a bale of growing mix is 7.11 cubic yards. A decimal: must be greater than 0 with at most 4 decimal places. purchaseUom and unitsPerUom are a PAIR: supply both to state this vendor's pack, or neither to say the vendor prices in eaches. Half a pair is REJECTED, because ordered quantity reaches eaches by multiplying by unitsPerUom and a missing multiplier would understate the order by the whole pack size rather than fail. Send neither (or null, or "") to CLEAR a pack size previously stated — null and empty mean the same thing here. */
  unitsPerUom?: InputMaybe<Scalars['Decimal']['input']>;
  vendorId: Scalars['String']['input'];
  vendorItemId?: InputMaybe<Scalars['String']['input']>;
  vendorName: Scalars['String']['input'];
};

/** One bounded page of a stage's questions for one artifact revision, under the job's claim. */
export type MaterializeMigrationImportQuestionsInput = {
  /** The artifact revision the stage ran on. */
  artifactRevision: Scalars['String']['input'];
  /** The job's current claim token. Checked, not identity. */
  claimToken: Scalars['String']['input'];
  /** The job's composite id. */
  id: Scalars['String']['input'];
  /** Whether it is the stage's last page for the revision. Send a last page, empty when the stage raised nothing, so questions it no longer raises stop being current. */
  lastPage: Scalars['Boolean']['input'];
  /** The page, from 0. */
  page: Scalars['Int']['input'];
  /** At most 100 questions, each key once. */
  questions: Array<MigrationImportQuestionInput>;
  /** The stage that raised the questions. */
  stage: Scalars['String']['input'];
};

export type MaterializeMigrationImportQuestionsPayload = {
  __typename?: 'MaterializeMigrationImportQuestionsPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<MaterializeMigrationImportQuestionsResult>;
};

/** What a question materialization recorded. */
export type MaterializeMigrationImportQuestionsResult = {
  __typename?: 'MaterializeMigrationImportQuestionsResult';
  /** The lineage whose question stream holds the questions. */
  lineageId: Scalars['String']['output'];
  /** The call's identity, derived from (lineage, revision, stage, page). */
  materializationId: Scalars['String']['output'];
  /** How many blocking questions the lineage has open now. */
  openBlockingQuestions: Scalars['Int']['output'];
  /** Recorded now, or already recorded by an earlier call. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The question stream revision after the call. */
  streamRevision: Scalars['Long']['output'];
};

export type MergeBackgroundServiceConfigInput = {
  displayName: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  podAssignments: Array<PodAssignmentDataInput>;
  scope?: InputMaybe<BackgroundServiceScope>;
  serviceName: BackgroundServiceName;
  timerPeriodSeconds: Scalars['Int']['input'];
  workerConfigs: Array<Scalars['String']['input']>;
};

export type MergeCarrierInput = {
  carrierId: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  dotNumber: Scalars['String']['input'];
  fuelSurchargePercent?: InputMaybe<Scalars['Decimal']['input']>;
  isActive: Scalars['Boolean']['input'];
  mcNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  rateAmount?: InputMaybe<Scalars['Decimal']['input']>;
  rateBasis: CarrierRateBasis;
  type: CarrierType;
};

export type MergeCategoryInput = {
  code: Scalars['String']['input'];
  /** @deprecated A category no longer has an eaches count — a Shipping UOM (ConfigCategory) owns eachesPerUnit and a category only tags one. Read the tagged Shipping UOM's eachesPerUnit instead. Accepted but IGNORED on every Category write. It survives only for the one-release wire-compatibility window this cutover opened, so that deployed senders keep working unmodified, and MUST be removed once they stop supplying it. */
  eaches?: Scalars['Int']['input'];
};

/**
 * The explicit connect-time setup choices the FULFILL-source-of-truth accounting wizard sends with
 * completeMergeLink / reconnectMergeLink. The seeder honours these instead of the
 * hardcoded MergeDevFlowDefaults, so a tenant opts into exactly the QuickBooks import flows
 * it wants (a one-time bootstrap) while Order Export stays on by default.
 */
export type MergeConnectSetupInput = {
  defaultIncomeAccountName?: InputMaybe<Scalars['String']['input']>;
  defaultIncomeAccountRemoteId?: InputMaybe<Scalars['String']['input']>;
  enabledImportFlows?: InputMaybe<Array<WsapiImportEntityType>>;
  outboundDetail: OutboundDetailLevel;
};

export type MergeContainerConfigInput = {
  categoryCode: Scalars['String']['input'];
  containerCode: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
  containerName: Scalars['String']['input'];
  depth: Scalars['Decimal']['input'];
  height: Scalars['Decimal']['input'];
  maxLayersPerContainer: Scalars['Int']['input'];
  maxTraysPerLayer: Scalars['Int']['input'];
  parentContainerConfigId?: InputMaybe<Scalars['String']['input']>;
  shipFactor: Scalars['Int']['input'];
  shipIncrement?: InputMaybe<Scalars['Int']['input']>;
  shipMinimum: Scalars['Int']['input'];
  siteCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeUomCode: Scalars['String']['input'];
  width: Scalars['Decimal']['input'];
};

export type MergeCustomerInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<CreateAddressInput>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<ContactDataInput>>;
  crmImportId?: InputMaybe<Scalars['String']['input']>;
  crmRecordUrl?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerLookupCode?: InputMaybe<Scalars['String']['input']>;
  customerTypeId?: InputMaybe<Scalars['String']['input']>;
  customerTypeName?: InputMaybe<Scalars['String']['input']>;
  defaultDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  erpPriceGroupId: Scalars['String']['input'];
  federalTaxNumber?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  importId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<CreateCustomerLocationInput>;
  name: Scalars['String']['input'];
  orderSubmitter?: InputMaybe<OrderSubmitterDataInput>;
  poRequired?: InputMaybe<Scalars['Boolean']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  synchronizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  taxExemptNumber?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
};

export type MergeDeliveryScheduleInput = {
  friday: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  locationIds: Array<Scalars['String']['input']>;
  monday: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  saturday: Scalars['Boolean']['input'];
  sunday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export type MergeDevAccountDocument = {
  __typename?: 'MergeDevAccountDocument';
  accountNumber: Scalars['String']['output'];
  classification: AccountClassification;
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * The stable external sync key (Merge.dev document id) this account was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevAccount resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for accounts
   * imported before ImportId existed. Distinct from RemoteId.
   */
  importId: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  mergeDevAccountId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  status: MergeDevAccountStatus;
  tenantId: Scalars['String']['output'];
};

export type MergeDevAccountDocumentFilterInput = {
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<MergeDevAccountDocumentFilterInput>>;
  classification?: InputMaybe<AccountClassificationOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external sync key (Merge.dev document id) this account was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevAccount resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for accounts
   * imported before ImportId existed. Distinct from RemoteId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  mergeDevAccountId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MergeDevAccountDocumentFilterInput>>;
  remoteId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<MergeDevAccountStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type MergeDevAccountDocumentSortInput = {
  accountNumber?: InputMaybe<SortEnumType>;
  classification?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable external sync key (Merge.dev document id) this account was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevAccount resolves create-vs-update by an
   * ImportId lookup rather than the entity identity it used to collide on. Empty for accounts
   * imported before ImportId existed. Distinct from RemoteId.
   */
  importId?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  mergeDevAccountId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  remoteId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type MergeDevAccountPayload = {
  __typename?: 'MergeDevAccountPayload';
  errors?: Maybe<Array<ValidationError>>;
  mergeDevAccount?: Maybe<MergeDevAccountStateData>;
};

export type MergeDevAccountStateData = {
  __typename?: 'MergeDevAccountStateData';
  accountNumber: Scalars['String']['output'];
  classification: AccountClassification;
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mergeDevAccountId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  status: MergeDevAccountStatus;
  tenantId: Scalars['String']['output'];
};

export enum MergeDevAccountStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type MergeDevAccountStatusOperationFilterInput = {
  eq?: InputMaybe<MergeDevAccountStatus>;
  in?: InputMaybe<Array<MergeDevAccountStatus>>;
  neq?: InputMaybe<MergeDevAccountStatus>;
  nin?: InputMaybe<Array<MergeDevAccountStatus>>;
};

/** A connection to a list of items. */
export type MergeDevAccountsConnection = {
  __typename?: 'MergeDevAccountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MergeDevAccountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MergeDevAccountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MergeDevAccountsEdge = {
  __typename?: 'MergeDevAccountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MergeDevAccountDocument;
};

/**
 * MongoDB read model holding per-integration Merge.dev connection metadata that is not part of the
 * per-entity sync checkpoint — currently the friendly QuickBooks company name shown on the
 * Integrations connected-state card. One document exists per (IntegrationId, TenantId). Written by
 * the synchronizer (wsapi-services) from Merge.dev CompanyInfo; read here by the
 * mergeDevConnection query. wsapi's global IgnoreExtraElementsConvention tolerates any
 * additional fields the synchronizer adds later.
 */
export type MergeDevConnectionDocument = {
  __typename?: 'MergeDevConnectionDocument';
  /**
   * The friendly QuickBooks company name (e.g. "Bonnie Plants, LLC"), captured from Merge.dev
   * CompanyInfo during sync. None until the synchronizer has captured it — the
   * OptionTypeInterceptor surfaces it as a nullable GraphQL String so older clients and
   * never-synced integrations are unaffected.
   */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Composite key: "{integrationId}:{tenantId}". Built via the GetDocumentId helper. */
  connectionId: Scalars['String']['output'];
  /** The tenant that owns this integration. */
  tenantId: Scalars['String']['output'];
};

/** Per-entity sync metrics within a sync cycle. */
export type MergeDevEntitySyncMetricDocument = {
  __typename?: 'MergeDevEntitySyncMetricDocument';
  /** Number of API calls made for this entity type. */
  apiCalls: Scalars['Int']['output'];
  /** Time spent processing this entity type. */
  duration: Scalars['TimeSpan']['output'];
  /** The Merge.dev model name (e.g., "Contact", "Item"). */
  model: Scalars['String']['output'];
  /** Records that failed validation or upsert. */
  recordsFailed: Scalars['Int']['output'];
  /** Total records fetched from Merge.dev. */
  recordsProcessed: Scalars['Int']['output'];
  /** Records successfully upserted into WorkSuite. */
  recordsSucceeded: Scalars['Int']['output'];
};

/**
 * Batch mutation result. One MergeDevExportPayload per input row, in the same
 * order the worker submitted them. Per-row errors (validation, discriminator violations, entity
 * not found, etc.) land in that row's MergeDevExportPayload.Errors; the worker can
 * inspect each row to decide which entities to retry next cycle.
 * Errors is reserved for whole-batch failures — empty updates today, and
 * future quota / size-limit rejections. When Errors is non-null
 * MergeDevExports is null; the two are mutually exclusive.
 */
export type MergeDevExportBatchPayload = {
  __typename?: 'MergeDevExportBatchPayload';
  errors?: Maybe<Array<ValidationError>>;
  mergeDevExports?: Maybe<Array<MergeDevExportPayload>>;
};

/**
 * Discriminator payload for a successful export attempt.
 * ResolvedRevenueAccountRemoteId (the Merge.dev RemoteId of the revenue GL account the
 * invoice posted to) and ResolvedRevenueRung (the winning precedence rung) are optional so
 * older callers that omit them still succeed; the worker in wsapi-services supplies both when it
 * reports the outcome, making the CMG GL-routing result queryable from WorkSuite.
 */
export type MergeDevExportCompletedUpdateDataInput = {
  mergeInvoiceId: Scalars['String']['input'];
  resolvedRevenueAccountRemoteId?: InputMaybe<Scalars['String']['input']>;
  resolvedRevenueRung?: InputMaybe<MergeDevRevenueRung>;
};

/**
 * MongoDB read model document for a single outbound export attempt to Merge.dev.
 * Worker pre-check: query this collection for rows with ExportStatus values
 * the worker is configured to attempt, then fetch full source-entity details via the
 * matching wsapi query (e.g. order for MergeDevExportEntityType.Order).
 */
export type MergeDevExportDocument = {
  __typename?: 'MergeDevExportDocument';
  /** The payment amount a PAYMENT export sends. Null on every other entity type. */
  amount?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The accounting-side invoice a PAYMENT export applies its payment to — the completed Invoice (or
   * legacy Order) export's MergeInvoiceId, captured when the payment was armed. Null on every
   * other entity type. Held apart from MergeInvoiceId, which stays null on a payment row.
   */
  appliedToMergeInvoiceId?: Maybe<Scalars['String']['output']>;
  /** The ISO currency of Amount. Null on every other entity type. */
  currency?: Maybe<Scalars['String']['output']>;
  /** The FULFILL customer a DEPOSIT export is taken from. Null on every other entity type. */
  depositCustomerId?: Maybe<Scalars['String']['output']>;
  /**
   * The order number of the order a DEPOSIT export was taken on; the order id is in PaymentLedgerEntityId.
   * Null on every other entity type.
   */
  depositOrderNumber?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  entityType: MergeDevExportEntityType;
  /**
   * Captured error message on failure. None unless ExportStatus is
   * MergeDevExportStatus.FailedTransient or MergeDevExportStatus.FailedPermanent.
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  exportStatus: MergeDevExportStatus;
  /** Composite id: {TenantId}-{EntityId} so the read model is unique per attempt. */
  id: Scalars['String']['output'];
  /** QB-side invoice id returned by Merge.dev on successful completion. None until completion. */
  mergeInvoiceId?: Maybe<Scalars['String']['output']>;
  /**
   * The Merge-side journal entry id recorded when a DEPOSIT export completes. Null until then, and on every
   * other entity type.
   */
  mergeJournalEntryId?: Maybe<Scalars['String']['output']>;
  /**
   * The accounting platform's own id for the deposit's journal entry (Merge's remote_id), when the worker
   * sent one. Null until a DEPOSIT export completes, and on every other entity type.
   */
  mergeJournalEntryRemoteId?: Maybe<Scalars['String']['output']>;
  /**
   * The Merge-side payment id recorded when a PAYMENT export completes. Null until then, and on every
   * other entity type.
   */
  mergePaymentId?: Maybe<Scalars['String']['output']>;
  /**
   * Earliest moment the worker is allowed to attempt this export again. Some only when
   * ExportStatus is MergeDevExportStatus.FailedTransient; cleared
   * on Completed and FailedPermanent. Worker query filter: NextRetryAt <= now.
   */
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Why this export correctly wrote nothing to Merge.dev. Some only when ExportStatus is
   * MergeDevExportStatus.NotExported. Held separate from ErrorMessage so a benign
   * outcome never reads as a failure: the PWA Errors tab and export reporting filter on
   * ExportStatus and surface ErrorMessage, and neither should show this row.
   */
  notExportedReason?: Maybe<Scalars['String']['output']>;
  /**
   * Which FULFILL ledger a PAYMENT export's payment line sits on (ORDER or INVOICE). Null on every other
   * entity type.
   */
  paymentLedger?: Maybe<MergeDevPaymentLedger>;
  /** The order or invoice id owning a PAYMENT export's payment line. Null on every other entity type. */
  paymentLedgerEntityId?: Maybe<Scalars['String']['output']>;
  /**
   * Merge.dev RemoteId of the revenue GL account the exported invoice posted revenue to, as
   * supplied verbatim by the worker on completion. None until (and unless) a completion carries
   * it — pre-existing completions and "mixed" multi-account Item-rung outcomes leave it
   * None. Surfaces as a nullable string on the GraphQL type so the CMG GL-routing outcome is
   * queryable without a QBO login.
   */
  resolvedRevenueAccountRemoteId?: Maybe<Scalars['String']['output']>;
  /**
   * The precedence rung whose income-GL mapping won (see the MergeDevRevenueRung enum). None
   * until a completion carries it. Surfaces as a nullable enum on the GraphQL type.
   */
  resolvedRevenueRung?: Maybe<MergeDevRevenueRung>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on
   * initialization and stays at 0 through successful Completed. Increments on each
   * FailedTransient write; carried forward through retries. Used by the worker to gate
   * retry-budget exhaustion.
   */
  retryCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  /** When the payment was received. Null on every other entity type. */
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Last write timestamp. Drives the 180-day TTL index that ages rows out of the collection. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB read model document for a single outbound export attempt to Merge.dev.
 * Worker pre-check: query this collection for rows with ExportStatus values
 * the worker is configured to attempt, then fetch full source-entity details via the
 * matching wsapi query (e.g. order for MergeDevExportEntityType.Order).
 */
export type MergeDevExportDocumentFilterInput = {
  /** The payment amount a PAYMENT export sends. Null on every other entity type. */
  amount?: InputMaybe<OptionOfDecimalFilterInput>;
  and?: InputMaybe<Array<MergeDevExportDocumentFilterInput>>;
  /**
   * The accounting-side invoice a PAYMENT export applies its payment to — the completed Invoice (or
   * legacy Order) export's MergeInvoiceId, captured when the payment was armed. Null on every
   * other entity type. Held apart from MergeInvoiceId, which stays null on a payment row.
   */
  appliedToMergeInvoiceId?: InputMaybe<OptionOfStringFilterInput>;
  /** The ISO currency of Amount. Null on every other entity type. */
  currency?: InputMaybe<OptionOfStringFilterInput>;
  /** The FULFILL customer a DEPOSIT export is taken from. Null on every other entity type. */
  depositCustomerId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * The order number of the order a DEPOSIT export was taken on; the order id is in PaymentLedgerEntityId.
   * Null on every other entity type.
   */
  depositOrderNumber?: InputMaybe<OptionOfStringFilterInput>;
  entityId?: InputMaybe<StringOperationFilterInput>;
  entityType?: InputMaybe<MergeDevExportEntityTypeOperationFilterInput>;
  /**
   * Captured error message on failure. None unless ExportStatus is
   * MergeDevExportStatus.FailedTransient or MergeDevExportStatus.FailedPermanent.
   */
  errorMessage?: InputMaybe<OptionOfStringFilterInput>;
  exportStatus?: InputMaybe<MergeDevExportStatusOperationFilterInput>;
  /** Composite id: {TenantId}-{EntityId} so the read model is unique per attempt. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** QB-side invoice id returned by Merge.dev on successful completion. None until completion. */
  mergeInvoiceId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * The Merge-side journal entry id recorded when a DEPOSIT export completes. Null until then, and on every
   * other entity type.
   */
  mergeJournalEntryId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * The accounting platform's own id for the deposit's journal entry (Merge's remote_id), when the worker
   * sent one. Null until a DEPOSIT export completes, and on every other entity type.
   */
  mergeJournalEntryRemoteId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * The Merge-side payment id recorded when a PAYMENT export completes. Null until then, and on every
   * other entity type.
   */
  mergePaymentId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * Earliest moment the worker is allowed to attempt this export again. Some only when
   * ExportStatus is MergeDevExportStatus.FailedTransient; cleared
   * on Completed and FailedPermanent. Worker query filter: NextRetryAt <= now.
   */
  nextRetryAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Why this export correctly wrote nothing to Merge.dev. Some only when ExportStatus is
   * MergeDevExportStatus.NotExported. Held separate from ErrorMessage so a benign
   * outcome never reads as a failure: the PWA Errors tab and export reporting filter on
   * ExportStatus and surface ErrorMessage, and neither should show this row.
   */
  notExportedReason?: InputMaybe<OptionOfStringFilterInput>;
  or?: InputMaybe<Array<MergeDevExportDocumentFilterInput>>;
  /**
   * Which FULFILL ledger a PAYMENT export's payment line sits on (ORDER or INVOICE). Null on every other
   * entity type.
   */
  paymentLedger?: InputMaybe<OptionOfMergeDevPaymentLedgerFilterInput>;
  /** The order or invoice id owning a PAYMENT export's payment line. Null on every other entity type. */
  paymentLedgerEntityId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * Merge.dev RemoteId of the revenue GL account the exported invoice posted revenue to, as
   * supplied verbatim by the worker on completion. None until (and unless) a completion carries
   * it — pre-existing completions and "mixed" multi-account Item-rung outcomes leave it
   * None. Surfaces as a nullable string on the GraphQL type so the CMG GL-routing outcome is
   * queryable without a QBO login.
   */
  resolvedRevenueAccountRemoteId?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * The precedence rung whose income-GL mapping won (see the MergeDevRevenueRung enum). None
   * until a completion carries it. Surfaces as a nullable enum on the GraphQL type.
   */
  resolvedRevenueRung?: InputMaybe<OptionOfMergeDevRevenueRungFilterInput>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on
   * initialization and stays at 0 through successful Completed. Increments on each
   * FailedTransient write; carried forward through retries. Used by the worker to gate
   * retry-budget exhaustion.
   */
  retryCount?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** When the payment was received. Null on every other entity type. */
  transactionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Last write timestamp. Drives the 180-day TTL index that ages rows out of the collection. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read model document for a single outbound export attempt to Merge.dev.
 * Worker pre-check: query this collection for rows with ExportStatus values
 * the worker is configured to attempt, then fetch full source-entity details via the
 * matching wsapi query (e.g. order for MergeDevExportEntityType.Order).
 */
export type MergeDevExportDocumentSortInput = {
  /** The payment amount a PAYMENT export sends. Null on every other entity type. */
  amount?: InputMaybe<SortEnumType>;
  /**
   * The accounting-side invoice a PAYMENT export applies its payment to — the completed Invoice (or
   * legacy Order) export's MergeInvoiceId, captured when the payment was armed. Null on every
   * other entity type. Held apart from MergeInvoiceId, which stays null on a payment row.
   */
  appliedToMergeInvoiceId?: InputMaybe<SortEnumType>;
  /** The ISO currency of Amount. Null on every other entity type. */
  currency?: InputMaybe<SortEnumType>;
  /** The FULFILL customer a DEPOSIT export is taken from. Null on every other entity type. */
  depositCustomerId?: InputMaybe<SortEnumType>;
  /**
   * The order number of the order a DEPOSIT export was taken on; the order id is in PaymentLedgerEntityId.
   * Null on every other entity type.
   */
  depositOrderNumber?: InputMaybe<SortEnumType>;
  entityId?: InputMaybe<SortEnumType>;
  entityType?: InputMaybe<SortEnumType>;
  /**
   * Captured error message on failure. None unless ExportStatus is
   * MergeDevExportStatus.FailedTransient or MergeDevExportStatus.FailedPermanent.
   */
  errorMessage?: InputMaybe<SortEnumType>;
  exportStatus?: InputMaybe<SortEnumType>;
  /** Composite id: {TenantId}-{EntityId} so the read model is unique per attempt. */
  id?: InputMaybe<SortEnumType>;
  /** QB-side invoice id returned by Merge.dev on successful completion. None until completion. */
  mergeInvoiceId?: InputMaybe<SortEnumType>;
  /**
   * The Merge-side journal entry id recorded when a DEPOSIT export completes. Null until then, and on every
   * other entity type.
   */
  mergeJournalEntryId?: InputMaybe<SortEnumType>;
  /**
   * The accounting platform's own id for the deposit's journal entry (Merge's remote_id), when the worker
   * sent one. Null until a DEPOSIT export completes, and on every other entity type.
   */
  mergeJournalEntryRemoteId?: InputMaybe<SortEnumType>;
  /**
   * The Merge-side payment id recorded when a PAYMENT export completes. Null until then, and on every
   * other entity type.
   */
  mergePaymentId?: InputMaybe<SortEnumType>;
  /**
   * Earliest moment the worker is allowed to attempt this export again. Some only when
   * ExportStatus is MergeDevExportStatus.FailedTransient; cleared
   * on Completed and FailedPermanent. Worker query filter: NextRetryAt <= now.
   */
  nextRetryAt?: InputMaybe<SortEnumType>;
  /**
   * Why this export correctly wrote nothing to Merge.dev. Some only when ExportStatus is
   * MergeDevExportStatus.NotExported. Held separate from ErrorMessage so a benign
   * outcome never reads as a failure: the PWA Errors tab and export reporting filter on
   * ExportStatus and surface ErrorMessage, and neither should show this row.
   */
  notExportedReason?: InputMaybe<SortEnumType>;
  /**
   * Which FULFILL ledger a PAYMENT export's payment line sits on (ORDER or INVOICE). Null on every other
   * entity type.
   */
  paymentLedger?: InputMaybe<SortEnumType>;
  /** The order or invoice id owning a PAYMENT export's payment line. Null on every other entity type. */
  paymentLedgerEntityId?: InputMaybe<SortEnumType>;
  /**
   * Merge.dev RemoteId of the revenue GL account the exported invoice posted revenue to, as
   * supplied verbatim by the worker on completion. None until (and unless) a completion carries
   * it — pre-existing completions and "mixed" multi-account Item-rung outcomes leave it
   * None. Surfaces as a nullable string on the GraphQL type so the CMG GL-routing outcome is
   * queryable without a QBO login.
   */
  resolvedRevenueAccountRemoteId?: InputMaybe<SortEnumType>;
  /**
   * The precedence rung whose income-GL mapping won (see the MergeDevRevenueRung enum). None
   * until a completion carries it. Surfaces as a nullable enum on the GraphQL type.
   */
  resolvedRevenueRung?: InputMaybe<SortEnumType>;
  /**
   * Worker-computed count of attempts that have ended in transient failure. Reset to 0 on
   * initialization and stays at 0 through successful Completed. Increments on each
   * FailedTransient write; carried forward through retries. Used by the worker to gate
   * retry-budget exhaustion.
   */
  retryCount?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** When the payment was received. Null on every other entity type. */
  transactionDate?: InputMaybe<SortEnumType>;
  /** Last write timestamp. Drives the 180-day TTL index that ages rows out of the collection. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export enum MergeDevExportEntityType {
  Deposit = 'DEPOSIT',
  /** @deprecated Retired by the FinanceCharge teardown; no trigger raises an export of this type any more. Retained because export rows persist the member name and their streams persist its value. Never reorder, renumber or reuse 1. */
  FinanceCharge = 'FINANCE_CHARGE',
  Invoice = 'INVOICE',
  Order = 'ORDER',
  Payment = 'PAYMENT'
}

export type MergeDevExportEntityTypeOperationFilterInput = {
  eq?: InputMaybe<MergeDevExportEntityType>;
  in?: InputMaybe<Array<MergeDevExportEntityType>>;
  neq?: InputMaybe<MergeDevExportEntityType>;
  nin?: InputMaybe<Array<MergeDevExportEntityType>>;
};

/** Discriminator payload for a terminal failure. */
export type MergeDevExportFailedPermanentUpdateDataInput = {
  errorMessage: Scalars['String']['input'];
};

/**
 * Discriminator payload for a retryable failure. The worker computed RetryCount
 * (new total after this attempt) and NextRetryAt (earliest next attempt) from its
 * own retry-budget policy.
 */
export type MergeDevExportFailedTransientUpdateDataInput = {
  errorMessage: Scalars['String']['input'];
  nextRetryAt: Scalars['DateTime']['input'];
  retryCount: Scalars['Int']['input'];
};

/**
 * Discriminator payload for a terminal close where the export correctly wrote nothing.
 * Reason records why — it is not an error message, and this outcome is not counted as a
 * failure.
 */
export type MergeDevExportNotExportedUpdateDataInput = {
  reason: Scalars['String']['input'];
};

export type MergeDevExportPayload = {
  __typename?: 'MergeDevExportPayload';
  errors?: Maybe<Array<ValidationError>>;
  mergeDevExport?: Maybe<MergeDevExportStateData>;
};

export type MergeDevExportStateData = {
  __typename?: 'MergeDevExportStateData';
  amount?: Maybe<Scalars['Decimal']['output']>;
  appliedToMergeInvoiceId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  depositCustomerId?: Maybe<Scalars['String']['output']>;
  depositOrderNumber?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  entityType: MergeDevExportEntityType;
  errorMessage?: Maybe<Scalars['String']['output']>;
  exportStatus: MergeDevExportStatus;
  mergeInvoiceId?: Maybe<Scalars['String']['output']>;
  mergeJournalEntryId?: Maybe<Scalars['String']['output']>;
  mergeJournalEntryRemoteId?: Maybe<Scalars['String']['output']>;
  mergePaymentId?: Maybe<Scalars['String']['output']>;
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  notExportedReason?: Maybe<Scalars['String']['output']>;
  paymentLedger?: Maybe<MergeDevPaymentLedger>;
  paymentLedgerEntityId?: Maybe<Scalars['String']['output']>;
  resolvedRevenueAccountRemoteId?: Maybe<Scalars['String']['output']>;
  resolvedRevenueRung?: Maybe<MergeDevRevenueRung>;
  retryCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum MergeDevExportStatus {
  Completed = 'COMPLETED',
  /** @deprecated Use FailedPermanent for non-retryable failures and FailedTransient for retryable ones. Retained for BSON ordinal stability per discipline bf43effe. */
  Failed = 'FAILED',
  FailedPermanent = 'FAILED_PERMANENT',
  FailedTransient = 'FAILED_TRANSIENT',
  NotExported = 'NOT_EXPORTED',
  Pending = 'PENDING'
}

export type MergeDevExportStatusOperationFilterInput = {
  eq?: InputMaybe<MergeDevExportStatus>;
  in?: InputMaybe<Array<MergeDevExportStatus>>;
  neq?: InputMaybe<MergeDevExportStatus>;
  nin?: InputMaybe<Array<MergeDevExportStatus>>;
};

/**
 * One row in the batch. Exactly one of Completed / FailedTransient /
 * FailedPermanent / NotExported must be set; the others must be null.
 */
export type MergeDevExportStatusUpdateRowInput = {
  completed?: InputMaybe<MergeDevExportCompletedUpdateDataInput>;
  entityId: Scalars['String']['input'];
  failedPermanent?: InputMaybe<MergeDevExportFailedPermanentUpdateDataInput>;
  failedTransient?: InputMaybe<MergeDevExportFailedTransientUpdateDataInput>;
  notExported?: InputMaybe<MergeDevExportNotExportedUpdateDataInput>;
};

/** A connection to a list of items. */
export type MergeDevExportsConnection = {
  __typename?: 'MergeDevExportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MergeDevExportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MergeDevExportDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MergeDevExportsEdge = {
  __typename?: 'MergeDevExportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MergeDevExportDocument;
};

/** A single field definition discovered from Merge.dev's /meta and /remote-fields endpoints. */
export type MergeDevFieldDefinitionDocument = {
  __typename?: 'MergeDevFieldDefinitionDocument';
  /** Human-readable description of the field from the accounting system. */
  description: Scalars['String']['output'];
  /** Valid values when the field is an enumeration type. */
  enumValues: Array<Scalars['String']['output']>;
  /** Indicates whether this field originates from Merge.dev's /remote-fields endpoint rather than /meta. */
  isRemoteField: Scalars['Boolean']['output'];
  /** The field name as reported by Merge.dev. */
  name: Scalars['String']['output'];
  /** Whether the field is required when creating records. */
  required: Scalars['Boolean']['output'];
  /** The field data type (e.g., "string", "number", "date"). */
  type: Scalars['String']['output'];
};

/**
 * Entity types supported by the Merge.dev Accounting API import. Mirrors the
 * synchronizer's MergeDevImportEntityType on wsapi-services. The numeric values
 * MUST stay identical to the synchronizer's enum because the value is persisted to Mongo
 * by its ordinal (no [BsonRepresentation(BsonType.String)] on the source field).
 */
export enum MergeDevImportEntityType {
  /** QuickBooks chart-of-accounts accounts. */
  Account = 'ACCOUNT',
  /** QuickBooks contacts (customers/vendors). */
  Contact = 'CONTACT',
  /** WorkSuite recorded deposit → accounting-system journal entry (outbound, create-only). Mirrors wsapi-services MergeDevImportEntityType.DepositExport (ordinal 12); gated by its own DEPOSIT_EXPORT flow, drained on every worker tick — so its sync-state row is rewritten every minute for every tenant with the deposit export flow running. Surfaced so that row serializes instead of nulling out the whole mergeDevSyncState result. */
  DepositExport = 'DEPOSIT_EXPORT',
  /** WorkSuite posted finance charge → accounting-system invoice (outbound). Mirrors wsapi-services MergeDevImportEntityType.FinanceChargeExport (ordinal 9); shares the ORDER_EXPORT flow toggle and is drained on every worker tick. Surfaced so a sync-state / failure row the synchronizer writes by ordinal 9 serializes instead of nulling out the whole result. */
  FinanceChargeExport = 'FINANCE_CHARGE_EXPORT',
  /** WorkSuite issued invoice → accounting-system invoice (outbound, create-only). Mirrors wsapi-services MergeDevImportEntityType.InvoiceExport (ordinal 10); gated by its own INVOICE_EXPORT flow, enabled by default, drained on every worker tick — so its sync-state row is rewritten every minute for every tenant with an accounting integration. Surfaced so that row serializes instead of nulling out the whole mergeDevSyncState result. */
  InvoiceExport = 'INVOICE_EXPORT',
  /** QuickBooks invoices imported into WorkSuite. */
  InvoiceImport = 'INVOICE_IMPORT',
  /** QuickBooks items / products. */
  Item = 'ITEM',
  /** QuickBooks journal entries. */
  JournalEntry = 'JOURNAL_ENTRY',
  /** Outbound WorkSuite orders exported as QuickBooks invoices. */
  OrderExport = 'ORDER_EXPORT',
  /** QuickBooks payments. */
  Payment = 'PAYMENT',
  /** WorkSuite recorded payment → accounting-system payment (outbound, create-only). Mirrors wsapi-services MergeDevImportEntityType.PaymentExport (ordinal 11); gated by its own PAYMENT_EXPORT flow, drained on every worker tick — so its sync-state row is rewritten every minute for every tenant with the payment export flow running. Surfaced so that row serializes instead of nulling out the whole mergeDevSyncState result. */
  PaymentExport = 'PAYMENT_EXPORT',
  /** Accounting provider → WorkSuite unit-price import (inbound). Runs inside the item handler on the synchronizer; mirrors wsapi-services MergeDevImportEntityType.PricingImport. Surfaced here so a pricing-import failure row (or sync-state row) the synchronizer writes by ordinal 8 serializes instead of nulling out the whole result. */
  PricingImport = 'PRICING_IMPORT',
  /** QuickBooks tax rates. */
  TaxRate = 'TAX_RATE'
}

/**
 * MongoDB document mirroring the synchronizer's MergeDevImportFailureDocument on
 * wsapi-services. Holds a single genuine per-record Merge.dev import failure — the data behind the
 * Integrations "Errors" tab that tells operators why a record was dropped. One document
 * exists per (integration × entity-type × source record id); a re-run of the same record upserts the
 * reason and timestamp in place, so the collection is bounded by the distinct set of currently-failing
 * records rather than an unbounded history. Only genuine failures land here (validation errors, 4xx/5xx
 * from wsapi, exceptions, records with no resolvable name); benign/idempotent rejections are classified
 * as success upstream and never produce a row. wsapi's global IgnoreExtraElementsConvention
 * tolerates the synchronizer's composite-key and any later-added fields on read.
 */
export type MergeDevImportFailureDocument = {
  __typename?: 'MergeDevImportFailureDocument';
  /** The human-readable entity label as logged (e.g. "Customer", "Vendor", "Item"). Finer than EntityType: a Contact import can fail as either a Customer or a Vendor for the same source record. */
  entityLabel: Scalars['String']['output'];
  /** The Merge.dev entity type whose import produced this failure. */
  entityType: MergeDevImportEntityType;
  /** The human-readable failure reason (the wsapi payload error text, the transport error message, or a data-gap description such as "contact has no resolvable name"). */
  reason: Scalars['String']['output'];
  /** The Merge.dev source record id this failure is for. */
  recordId: Scalars['String']['output'];
  /** The tenant that owns this integration. */
  tenantId: Scalars['String']['output'];
  /** When this failure was last observed. */
  timestamp: Scalars['DateTime']['output'];
};

export type MergeDevPaymentAppliedLine = {
  __typename?: 'MergeDevPaymentAppliedLine';
  appliedAmount: Scalars['Decimal']['output'];
  creditNoteRemoteId: Scalars['String']['output'];
  invoiceRemoteId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
};

export type MergeDevPaymentAppliedLineDataInput = {
  appliedAmount: Scalars['Decimal']['input'];
  creditNoteRemoteId?: InputMaybe<Scalars['String']['input']>;
  invoiceRemoteId?: InputMaybe<Scalars['String']['input']>;
  remoteId: Scalars['String']['input'];
};

export type MergeDevPaymentAppliedLineDocument = {
  __typename?: 'MergeDevPaymentAppliedLineDocument';
  appliedAmount: Scalars['Decimal']['output'];
  creditNoteRemoteId: Scalars['String']['output'];
  invoiceRemoteId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
};

export type MergeDevPaymentAppliedLineDocumentFilterInput = {
  and?: InputMaybe<Array<MergeDevPaymentAppliedLineDocumentFilterInput>>;
  appliedAmount?: InputMaybe<DecimalOperationFilterInput>;
  creditNoteRemoteId?: InputMaybe<StringOperationFilterInput>;
  invoiceRemoteId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MergeDevPaymentAppliedLineDocumentFilterInput>>;
  remoteId?: InputMaybe<StringOperationFilterInput>;
};

export type MergeDevPaymentDocument = {
  __typename?: 'MergeDevPaymentDocument';
  account: Scalars['String']['output'];
  appliedToLines: Array<MergeDevPaymentAppliedLineDocument>;
  company: Scalars['String']['output'];
  contact: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  exchangeRate: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  /**
   * The stable external sync key (Merge.dev payment document id) this payment was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevPayment resolves create-vs-update by an
   * ImportId lookup rather than the deterministic entity identity it used to collide on. Empty for
   * payments imported before ImportId existed. Distinct from RemoteId.
   */
  importId: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  mergeDevPaymentId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Decimal']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

export type MergeDevPaymentDocumentFilterInput = {
  account?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<MergeDevPaymentDocumentFilterInput>>;
  appliedToLines?: InputMaybe<ListFilterInputTypeOfMergeDevPaymentAppliedLineDocumentFilterInput>;
  company?: InputMaybe<StringOperationFilterInput>;
  contact?: InputMaybe<StringOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  exchangeRate?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external sync key (Merge.dev payment document id) this payment was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevPayment resolves create-vs-update by an
   * ImportId lookup rather than the deterministic entity identity it used to collide on. Empty for
   * payments imported before ImportId existed. Distinct from RemoteId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  mergeDevPaymentId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MergeDevPaymentDocumentFilterInput>>;
  remoteId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalAmount?: InputMaybe<DecimalOperationFilterInput>;
  transactionDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type MergeDevPaymentDocumentSortInput = {
  account?: InputMaybe<SortEnumType>;
  company?: InputMaybe<SortEnumType>;
  contact?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  exchangeRate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable external sync key (Merge.dev payment document id) this payment was imported under.
   * Indexed (TenantId, ImportId) so mergeMergeDevPayment resolves create-vs-update by an
   * ImportId lookup rather than the deterministic entity identity it used to collide on. Empty for
   * payments imported before ImportId existed. Distinct from RemoteId.
   */
  importId?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  mergeDevPaymentId?: InputMaybe<SortEnumType>;
  remoteId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalAmount?: InputMaybe<SortEnumType>;
  transactionDate?: InputMaybe<SortEnumType>;
};

export enum MergeDevPaymentLedger {
  Invoice = 'INVOICE',
  Order = 'ORDER'
}

export type MergeDevPaymentPayload = {
  __typename?: 'MergeDevPaymentPayload';
  errors?: Maybe<Array<ValidationError>>;
  mergeDevPayment?: Maybe<MergeDevPaymentStateData>;
};

export type MergeDevPaymentStateData = {
  __typename?: 'MergeDevPaymentStateData';
  account: Scalars['String']['output'];
  appliedToLines: Array<MergeDevPaymentAppliedLine>;
  company: Scalars['String']['output'];
  contact: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  exchangeRate: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  mergeDevPaymentId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Decimal']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

/** A connection to a list of items. */
export type MergeDevPaymentsConnection = {
  __typename?: 'MergeDevPaymentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MergeDevPaymentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MergeDevPaymentDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MergeDevPaymentsEdge = {
  __typename?: 'MergeDevPaymentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MergeDevPaymentDocument;
};

export enum MergeDevRevenueRung {
  Category = 'CATEGORY',
  CustomerType = 'CUSTOMER_TYPE',
  Item = 'ITEM',
  Mixed = 'MIXED',
  TenantDefault = 'TENANT_DEFAULT',
  Unmapped = 'UNMAPPED'
}

/** MongoDB document mirroring the synchronizer's MergeDevModelSchema for cached field definitions. */
export type MergeDevSchemaDocument = {
  __typename?: 'MergeDevSchemaDocument';
  /** When this schema was last discovered from Merge.dev's /meta endpoint. */
  discoveredAt: Scalars['DateTime']['output'];
  /** The field definitions discovered for this model. */
  fields: Array<MergeDevFieldDefinitionDocument>;
  /** The Merge.dev model name (e.g., "Contact", "Item", "Account"). */
  model: Scalars['String']['output'];
  /** Composite key: "{accountToken}:{model}". */
  schemaId: Scalars['String']['output'];
  /** The tenant that owns this integration. */
  tenantId: Scalars['String']['output'];
};

/** MongoDB document mirroring the synchronizer's MergeDevSyncMetricsDocument for rate limiting and throughput metrics. */
export type MergeDevSyncMetricsDocument = {
  __typename?: 'MergeDevSyncMetricsDocument';
  /** Average requests per minute across the sync cycle. */
  avgRequestsPerMinute: Scalars['Float']['output'];
  /** The configured maximum requests per minute ceiling. */
  configuredMaxPerMinute: Scalars['Int']['output'];
  /** When the sync cycle completed. */
  cycleCompletedAt: Scalars['DateTime']['output'];
  /** When the sync cycle began. */
  cycleStartedAt: Scalars['DateTime']['output'];
  /** Per-entity breakdown of sync metrics for this cycle. */
  entityMetrics: Array<MergeDevEntitySyncMetricDocument>;
  /** Composite key: "{accountToken}:{timestamp}". */
  metricsId: Scalars['String']['output'];
  /** Peak requests per minute observed during the sync cycle. */
  peakRequestsPerMinute: Scalars['Float']['output'];
  /** The tenant that owns this integration. */
  tenantId: Scalars['String']['output'];
  /** Number of HTTP 429 (rate-limited) responses received from Merge.dev. */
  throttledRequests: Scalars['Int']['output'];
  /** Total number of API calls made to Merge.dev during this sync cycle. */
  totalApiCalls: Scalars['Int']['output'];
  /** Cumulative time the synchronizer waited due to rate-limit throttling. */
  totalThrottleWaitTime: Scalars['TimeSpan']['output'];
};

/**
 * MongoDB document mirroring the synchronizer's MergeDevSyncStateDocument. Holds the
 * authoritative per-entity sync checkpoint for a Merge.dev integration: the last successful
 * sync time and the consecutive-failure count. One document exists per (TenantId, EntityType).
 * The synchronizer's pagination Cursor is intentionally not surfaced here; wsapi's global
 * IgnoreExtraElementsConvention tolerates the unmapped field on read.
 */
export type MergeDevSyncStateDocument = {
  __typename?: 'MergeDevSyncStateDocument';
  /** Number of consecutive failed sync attempts for this entity type. A non-zero value signals degraded connection health. */
  consecutiveFailures: Scalars['Int']['output'];
  /** The Merge.dev entity type this sync state tracks. */
  entityType: MergeDevImportEntityType;
  /** Wall-clock duration of the last successful sync cycle in milliseconds. Stamped by the synchronizer's success path; documents written before the field existed read back as 0. */
  lastSyncDurationMs: Scalars['Long']['output'];
  /** The last time this entity type completed a successful sync, or null if it has never synced. */
  lastSyncTime?: Maybe<Scalars['DateTime']['output']>;
  /** Records that failed validation/upsert for this entity type on the last completed sync cycle. */
  recordsFailed: Scalars['Int']['output'];
  /** Records imported from Merge.dev for this entity type on the last completed sync cycle. */
  recordsProcessed: Scalars['Int']['output'];
  /** Records successfully upserted into WorkSuite for this entity type on the last completed sync cycle. */
  recordsSucceeded: Scalars['Int']['output'];
  /** Composite key: "{integrationId}:{entityType}". */
  stateId: Scalars['String']['output'];
  /** The tenant that owns this integration. */
  tenantId: Scalars['String']['output'];
};

export type MergeDockInput = {
  clearLoadsPerDay?: InputMaybe<Scalars['Boolean']['input']>;
  dockId: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  loadsPerDay?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type MergeDriverInput = {
  carrierId: Scalars['String']['input'];
  driverId: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  licenseNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type MergeErpLoadListUserInput = {
  email: Scalars['String']['input'];
  erpLoadListUserId: Scalars['String']['input'];
  sites: Array<Scalars['String']['input']>;
};

export type MergeForecastSettingsInput = {
  compAim: Scalars['Decimal']['input'];
  compMax: Scalars['Decimal']['input'];
  compMin: Scalars['Decimal']['input'];
  excludedHistoryYears: Array<Scalars['Int']['input']>;
  maxYearOffset: Scalars['Int']['input'];
  roundingBias: Scalars['Decimal']['input'];
  shipShift: Scalars['Boolean']['input'];
};

export type MergeItemInput = {
  categories: Array<ItemCategoryAssignmentDataInput>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: Scalars['String']['input'];
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  native?: InputMaybe<Scalars['Boolean']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  stripeTaxCode?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type MergeJobWorkOrdersInput = {
  containerQuantity: Scalars['Int']['input'];
  deliveryDate: Scalars['DateTime']['input'];
  erpId?: Scalars['String']['input'];
  id: Scalars['String']['input'];
  itemErpId?: Scalars['String']['input'];
  itemGenusCode: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
  itemRecordId: Scalars['String']['input'];
  itemUPC: Scalars['String']['input'];
  jobStatus: JobStatus;
  jobType: JobType;
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productionQuantity: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  unitOfMeasure: Scalars['String']['input'];
  workOrders: Array<WorkOrderInput>;
};

/** The Merge.dev product category a link token is scoped to. */
export enum MergeLinkCategory {
  Accounting = 'ACCOUNTING',
  Crm = 'CRM'
}

export type MergeLinkTokenPayload = {
  __typename?: 'MergeLinkTokenPayload';
  errors?: Maybe<Array<ValidationError>>;
  linkToken?: Maybe<Scalars['String']['output']>;
};

export type MergeLoadInput = {
  carrierId?: InputMaybe<Scalars['String']['input']>;
  containerConfigId?: InputMaybe<Scalars['String']['input']>;
  containerName: Scalars['String']['input'];
  driverId?: InputMaybe<Scalars['String']['input']>;
  loadId: Scalars['String']['input'];
  routeId?: InputMaybe<Scalars['String']['input']>;
  shipDate: Scalars['LocalDate']['input'];
  status: LoadStatus;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type MergeLoadLineInput = {
  containerCount?: InputMaybe<Scalars['Int']['input']>;
  customerName: Scalars['String']['input'];
  loadId: Scalars['String']['input'];
  loadLineId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  routeStopId?: InputMaybe<Scalars['String']['input']>;
};

export type MergeLogisticsRouteInput = {
  code: Scalars['String']['input'];
  defaultVehicleId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  driverId?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isAdHoc: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  routeId: Scalars['String']['input'];
  stops: Array<RouteStopDataInput>;
};

export type MergeMaterialItemByErpIdInput = {
  accountingId?: InputMaybe<Scalars['String']['input']>;
  base64Image?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MergeMergeDevAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  classification: AccountClassification;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  importId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  remoteId: Scalars['String']['input'];
  status: MergeDevAccountStatus;
};

export type MergeMergeDevPaymentInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  appliedToLines: Array<MergeDevPaymentAppliedLineDataInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  exchangeRate: Scalars['Decimal']['input'];
  id: Scalars['String']['input'];
  importId?: InputMaybe<Scalars['String']['input']>;
  remoteId: Scalars['String']['input'];
  totalAmount: Scalars['Decimal']['input'];
  transactionDate: Scalars['DateTime']['input'];
};

export type MergeOrderKindInput = {
  name: Scalars['String']['input'];
  orderKindId: Scalars['String']['input'];
};

export type MergePriceGroupInput = {
  id: Scalars['String']['input'];
  makeDefaultIfNoDefaultExists: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type MergePriceLevelInput = {
  customerSellPrice?: InputMaybe<Scalars['Decimal']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  growerCost?: InputMaybe<Scalars['Decimal']['input']>;
  growerSellPrice: Scalars['Decimal']['input'];
  kind?: PriceKind;
  levelType?: InputMaybe<PriceLevelType>;
  percentOff?: InputMaybe<Scalars['Decimal']['input']>;
  priceGroupId: Scalars['String']['input'];
  priceLevelId: Scalars['String']['input'];
  quantityThreshold: Scalars['Decimal']['input'];
  referencePriceGroupId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  targetId: Scalars['String']['input'];
  type: TargetType;
  volumePoolId?: InputMaybe<Scalars['String']['input']>;
};

export type MergeProductionCategoryInput = {
  code: Scalars['String']['input'];
  eaches: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  productionCategoryId: Scalars['String']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
};

export type MergeProductionItemInput = {
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionItemId: Scalars['String']['input'];
  productionItemNumber: Scalars['String']['input'];
};

export type MergeProductionPlanInput = {
  name: Scalars['String']['input'];
  productionPlanId: Scalars['String']['input'];
};

export type MergeProductionSpaceCategoryInput = {
  code: Scalars['String']['input'];
  length: Scalars['Decimal']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
  stagger?: Scalars['Boolean']['input'];
  width: Scalars['Decimal']['input'];
};

export type MergeProductionSpaceTypeInput = {
  code: Scalars['String']['input'];
  productionSpaceTypeId: Scalars['String']['input'];
};

export type MergeReplenishmentSettingsInput = {
  allocationPriorities: Array<AllocationPriorityDimension>;
  allocationReservationPercentage: Scalars['Decimal']['input'];
  allocationType: AllocationType;
  defaultTargetWeeksOfSupply: Scalars['Decimal']['input'];
  forwardDaysLastYear: Scalars['Int']['input'];
  inventoryTrailingDays: Scalars['Int']['input'];
  minUsableDaysThreshold?: InputMaybe<Scalars['Int']['input']>;
  programWindowConfigs: Array<ProgramWindowConfigDataInput>;
  roundToFullCart: Scalars['Boolean']['input'];
  sellThroughThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  shipmentIncrement: Scalars['Int']['input'];
  trailingDaysThisYear: Scalars['Int']['input'];
};

export type MergeSiteLocationInput = {
  address?: InputMaybe<SiteAddressDataInput>;
  erpId: Scalars['String']['input'];
  locations: Array<SubLocationDataInput>;
  name: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
  status: LocationStatus;
};

export type MergeVehicleInput = {
  carrierId?: InputMaybe<Scalars['String']['input']>;
  hasLiftgate: Scalars['Boolean']['input'];
  isActive: Scalars['Boolean']['input'];
  isTempControlled: Scalars['Boolean']['input'];
  licensePlate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ownership: VehicleOwnership;
  vehicleId: Scalars['String']['input'];
  vehicleTypeId: Scalars['String']['input'];
};

export type MergeVehicleTypeInput = {
  capacities: Array<VehicleTypeCapacityDataInput>;
  /** The most this vehicle type may carry, stated in maxLoadWeightUnit. This mutation replaces the whole vehicle type, so omitting both maxLoadWeight and maxLoadWeightUnit clears a stored limit. A weight needs maxLoadWeightUnit POUNDS or KILOGRAMS. Above zero, at most 1,000,000, at most 2 decimals, never rounded. The limit is advisory: nothing refuses a load over it. */
  maxLoadWeight?: InputMaybe<Scalars['Decimal']['input']>;
  /** POUNDS or KILOGRAMS, required with maxLoadWeight. UNKNOWN or null with no weight means no limit. POUNDS or KILOGRAMS without a weight is refused. */
  maxLoadWeightUnit?: InputMaybe<WeightUnit>;
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  vehicleTypeId: Scalars['String']['input'];
};

export type MergeVendorInput = {
  billingAddress: CreateAddressInput;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  importId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MergeWorkerConfigInput = {
  configName: Scalars['String']['input'];
  tenantValues: Array<TenantValueDataInput>;
};

/**
 * A single restock metric expressed as both a physical Quantity and a
 * wholesale dollar Value. Used by RestockMetricsData to
 * pair a quantity and a value under each of the six physical concepts (Available,
 * Allocated, In Transit, Available for Orders, On Order, Remaining Availability).
 * The GraphQL type is exposed as MetricValue to match the unified frontend
 * contract and RTK Query cache-tag strategy.
 */
export type MetricValue = {
  __typename?: 'MetricValue';
  quantity: Scalars['Int']['output'];
  value: Scalars['Decimal']['output'];
};

/**
 * The orchestrator's signed statement that a grower typed and sent an approval of one presented subject in
 * this chat turn (471ecef8 C6 (b), contract 4b3858e4 9.1 and AP2): it binds the tenant, the grower's token
 * subject, the session, turn and sent message, the hash of the typed text, the approve action, the portion
 * or settings-operation revision id and the presentation the grower saw.
 */
export type MigrationApprovalEnvelopeInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  expiresAt: Scalars['DateTime']['input'];
  issuedAt: Scalars['DateTime']['input'];
  keyId?: InputMaybe<Scalars['String']['input']>;
  presentationId?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  sentMessageReference?: InputMaybe<Scalars['String']['input']>;
  sessionReference?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  turnId?: InputMaybe<Scalars['String']['input']>;
  typedTextHash?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum MigrationApprovalKind {
  DataPortion = 'DATA_PORTION',
  SettingsRevision = 'SETTINGS_REVISION',
  Unknown = 'UNKNOWN'
}

/** What an approve call ended with. */
export enum MigrationApprovalOutcome {
  /** The subject's approval was already recorded; it and its run are returned, and nothing new was approved. */
  AlreadyApproved = 'ALREADY_APPROVED',
  /** This call recorded the approval; for data, its run was created in Queued. */
  Approved = 'APPROVED',
  /**
   * Nothing was approved: the data is being validated again, because the check found it stale or another change
   * re-queued it. Show the review again once it is ready and send a new approval.
   */
  Pending = 'PENDING'
}

export type MigrationApprovalPayload = {
  __typename?: 'MigrationApprovalPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<MigrationApprovalResult>;
};

/**
 * What an approve call ended with. Approved or already approved name the approval and, for data, its run in
 * Queued (with any control a grower already sent on it), or for a setting, the settings write. Pending names no
 * approval: the job is being validated again, with the reasons.
 */
export type MigrationApprovalResult = {
  __typename?: 'MigrationApprovalResult';
  approvalId?: Maybe<Scalars['String']['output']>;
  jobState?: Maybe<MigrationPreparationJobState>;
  kind?: Maybe<MigrationApprovalKind>;
  outcome: MigrationApprovalOutcome;
  pendingReasons: Array<Scalars['String']['output']>;
  presentationId?: Maybe<Scalars['String']['output']>;
  run?: Maybe<MigrationImportRunStatus>;
  settingsWrite?: Maybe<MigrationSettingsWriteOutcome>;
  subjectId?: Maybe<Scalars['String']['output']>;
};

/** How many of a run's operations read with one current status. */
export type MigrationConfidenceCount = {
  __typename?: 'MigrationConfidenceCount';
  operations: Scalars['Int']['output'];
  status: MigrationRecordConfidenceStatus;
};

/** Whether a run's operations were read again for a report. */
export enum MigrationConfidenceRecheck {
  /** No verification is recorded for the run yet, so nothing current is claimed. */
  NotVerified = 'NOT_VERIFIED',
  /** Every operation verification recorded was read again now. */
  Rechecked = 'RECHECKED',
  /**
   * The run has more operations than one bounded recheck reads, so none was read now and nothing current is claimed;
   * the paced runtime observes it instead.
   */
  TooLarge = 'TOO_LARGE'
}

/** Which upload, prepared revision and portion a run's evidence rests on. */
export type MigrationConfidenceVersions = {
  __typename?: 'MigrationConfidenceVersions';
  /** The preparation job that prepared it. */
  jobId: Scalars['String']['output'];
  /** The approved portion the run applied. */
  portionId: Scalars['String']['output'];
  /** The prepared revision's SHA-256; none when its record is gone. */
  revisionDigest?: Maybe<Scalars['String']['output']>;
  /** The prepared revision the portion was cut from. */
  revisionId: Scalars['String']['output'];
  /** The prepared revision's number; none when its record is gone. */
  revisionNumber?: Maybe<Scalars['Int']['output']>;
  /** The upload. */
  sourceId: Scalars['String']['output'];
  /** The upload's version. */
  sourceVersion: Scalars['Int']['output'];
};

/**
 * The orchestrator's signed statement that a grower typed and sent this control in this chat turn: it
 * binds the tenant, the grower's token subject, the session, turn and sent message, the hash of the typed
 * text, the action, the run and the control version the grower saw (471ecef8, C6 resolved (b)).
 */
export type MigrationControlEnvelopeInput = {
  action: MigrationRunControlAction;
  controlVersion: Scalars['Int']['input'];
  expiresAt: Scalars['DateTime']['input'];
  issuedAt: Scalars['DateTime']['input'];
  keyId?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  runId?: InputMaybe<Scalars['String']['input']>;
  sentMessageReference?: InputMaybe<Scalars['String']['input']>;
  sessionReference?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  turnId?: InputMaybe<Scalars['String']['input']>;
  typedTextHash?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** One field a grower's correction sets, with the value the grower gave. */
export type MigrationCorrectedFieldView = {
  __typename?: 'MigrationCorrectedFieldView';
  field: Scalars['String']['output'];
  row: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Why the selected scope cannot be reported verified. */
export enum MigrationCoverageGap {
  /** A source row of the selected work was not imported because the grower cancelled. */
  CancelledRows = 'CANCELLED_ROWS',
  /** A source row of the selected work failed. */
  FailedRows = 'FAILED_ROWS',
  /** Nothing is selected yet. */
  NothingSelected = 'NOTHING_SELECTED',
  /** A question is still open. */
  OpenQuestions = 'OPEN_QUESTIONS',
  /** A source row of the selected work is still pending. */
  PendingRows = 'PENDING_ROWS',
  /** A file's prepared rows expired, so its rows can no longer be split by what the import did. */
  RowLineageExpired = 'ROW_LINEAGE_EXPIRED',
  /** A selected item, or something it depends on, is not complete. */
  SelectedWorkIncomplete = 'SELECTED_WORK_INCOMPLETE',
  /** A source row is not accounted for. */
  UnaccountedRows = 'UNACCOUNTED_ROWS',
  /** A preparation job has not prepared its file yet, or an import run is not finished. */
  WorkInFlight = 'WORK_IN_FLIGHT'
}

export enum MigrationDetailAnswer {
  AddBillingAddress = 'ADD_BILLING_ADDRESS',
  AddMissingContacts = 'ADD_MISSING_CONTACTS',
  AddNewLevelsOnly = 'ADD_NEW_LEVELS_ONLY',
  ApplyCorrection = 'APPLY_CORRECTION',
  KeepBillingAddress = 'KEEP_BILLING_ADDRESS',
  KeepExistingLevels = 'KEEP_EXISTING_LEVELS',
  KeepLaterEdit = 'KEEP_LATER_EDIT',
  KeepWorkSuiteValue = 'KEEP_WORK_SUITE_VALUE',
  LeaveContactsUnchanged = 'LEAVE_CONTACTS_UNCHANGED',
  ReplaceCurrentAndFutureLevels = 'REPLACE_CURRENT_AND_FUTURE_LEVELS',
  ReplacePrimaryBillingAddress = 'REPLACE_PRIMARY_BILLING_ADDRESS',
  Unknown = 'UNKNOWN',
  UseSourceValue = 'USE_SOURCE_VALUE'
}

/** One detail answer of an identity decision; values are digests. */
export type MigrationDetailDecisionInput = {
  /** The answer chosen. */
  answer: MigrationDetailAnswer;
  /** The field, or the subject's name. */
  field: Scalars['String']['input'];
  /** Digest of the value the record carried when the grower answered. */
  observedValueDigest: Scalars['String']['input'];
  /** Digest of the value the source carries. */
  sourceValueDigest: Scalars['String']['input'];
  /** What the detail question is about. */
  subject: MigrationDetailSubject;
};

export enum MigrationDetailSubject {
  BillingAddress = 'BILLING_ADDRESS',
  Contacts = 'CONTACTS',
  Field = 'FIELD',
  LaterEdit = 'LATER_EDIT',
  PriceLevels = 'PRICE_LEVELS',
  Unknown = 'UNKNOWN'
}

/** One record past its retention period, for the purge to take one at a time by its class and id. */
export type MigrationExpiredRecord = {
  __typename?: 'MigrationExpiredRecord';
  dueAt: Scalars['DateTime']['output'];
  recordClass: MigrationRetentionClass;
  recordId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** One family's coverage across the journey's files. */
export type MigrationFamilyCoverage = {
  __typename?: 'MigrationFamilyCoverage';
  /** Its answered questions. */
  answeredQuestions: Scalars['Int']['output'];
  /** The records verification found a conflict or a duplicate for. */
  conflictingEntities: Scalars['Int']['output'];
  /** The records whose write was refused or ran out of attempts. */
  failedWrites: Scalars['Int']['output'];
  /** The family. */
  family: Scalars['String']['output'];
  /** The records its rows were grouped into. */
  groupedEntities: Scalars['Int']['output'];
  /** The records verification found mismatched: an unexpected change. */
  mismatchedEntities: Scalars['Int']['output'];
  /** Its open questions. */
  openQuestions: Scalars['Int']['output'];
  /** Those rows by fate and reason. */
  rows: Array<MigrationRowFateCount>;
  /** Whether the grower selected it, deferred it or has not selected it. */
  scope: OnboardingJourneyScopeStatus;
  /** The records validation held back: blocked, pending or not importable yet. */
  skippedEntities: Scalars['Int']['output'];
  /** The source rows that fed it. */
  sourceRows: Scalars['Int']['output'];
  /** The notes review showed with its records, by code. */
  transformations: Array<MigrationTransformationCount>;
  /** The records verification confirmed, leaving out items while their duplicate check is incomplete. */
  verifiedEntities: Scalars['Int']['output'];
};

/** One material field that holds another value now than verification observed. */
export type MigrationFieldChange = {
  __typename?: 'MigrationFieldChange';
  /** The value now; none once the record is gone. */
  current?: Maybe<Scalars['String']['output']>;
  /** The field. */
  name: Scalars['String']['output'];
  /** The value verification observed. */
  recorded: Scalars['String']['output'];
};

/** Whether a source adapter supplies one prepared-shape field (worksuite-onboarding "Field support by adapter"). */
export enum MigrationFieldSupport {
  /** The field has no meaning for the adapter's source. */
  NotApplicable = 'NOT_APPLICABLE',
  /** The adapter does not supply it, so rows that need it are not importable yet. */
  NotSupplied = 'NOT_SUPPLIED',
  /** The adapter supplies the field; a blank value means the source has none. */
  Supplied = 'SUPPLIED'
}

/** One prepared-shape field's support, as the source adapter's field-support table gives it. */
export type MigrationFieldSupportInput = {
  /** The prepared-shape field, for example ShippedQuantity. */
  field: Scalars['String']['input'];
  /** The table's reason, when it gives one. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Supplied, not supplied or not applicable. */
  support: MigrationFieldSupport;
};

/** One material field's value. */
export type MigrationFieldValue = {
  __typename?: 'MigrationFieldValue';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * One handoff left undone for at least one claim window, for staff. It reads Unhealthy, and stuck once
 * four windows have passed since it became due. The due time is when the missing step was owed: for a
 * newer source version, when the first job for a newer version of the same source was registered.
 */
export type MigrationHandoffFacts = {
  __typename?: 'MigrationHandoffFacts';
  dueAt: Scalars['DateTime']['output'];
  health: MigrationHealth;
  id: Scalars['String']['output'];
  journeyId: Scalars['String']['output'];
  kind: MigrationUndoneHandoffKind;
  stuck: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

/** What a handoff repair did. */
export enum MigrationHandoffRepairOutcome {
  /** Nothing was missing, or a live claim will apply it, so nothing changed. */
  NothingToRepair = 'NOTHING_TO_REPAIR',
  /** The missing document step was done. */
  Repaired = 'REPAIRED'
}

/** What a handoff repair did, and the record as it left it. */
export type MigrationHandoffRepairPayload = {
  __typename?: 'MigrationHandoffRepairPayload';
  errors?: Maybe<Array<ValidationError>>;
  job?: Maybe<MigrationPreparationJobStatus>;
  outcome?: Maybe<MigrationHandoffRepairOutcome>;
};

/** Whether a record is moving, waiting on a person, or needs someone to look at the runtime. */
export enum MigrationHealth {
  /** Nothing more will happen: completed, cancelled or superseded. */
  Done = 'DONE',
  /** The runtime is not moving it: failed, or no worker has taken it for more than one claim window. */
  Unhealthy = 'UNHEALTHY',
  /** Blocked on something a person must fix (a permission, an entitlement, a prerequisite setting). */
  WaitingOnSpecialist = 'WAITING_ON_SPECIALIST',
  /** Waiting on the grower: answers, a review or approval, or a resume of a pause. */
  WaitingOnUser = 'WAITING_ON_USER',
  /** A worker holds it, or it was queued less than one claim window ago. */
  Working = 'WORKING'
}

/** Health of every preparation job and import run in one journey. */
export type MigrationHealthFacts = {
  __typename?: 'MigrationHealthFacts';
  handoffs: Array<MigrationHandoffFacts>;
  jobs: Array<MigrationPreparationJobFacts>;
  runs: Array<MigrationImportRunFacts>;
};

export enum MigrationIdentityAnswer {
  CreateDeactivated = 'CREATE_DEACTIVATED',
  CreateNew = 'CREATE_NEW',
  DifferentRecord = 'DIFFERENT_RECORD',
  LeaveOut = 'LEAVE_OUT',
  PickRecord = 'PICK_RECORD',
  ReactivateAndUpdate = 'REACTIVATE_AND_UPDATE',
  SameRecord = 'SAME_RECORD',
  Unknown = 'UNKNOWN',
  UpdateChosenFields = 'UPDATE_CHOSEN_FIELDS',
  UseUnchanged = 'USE_UNCHANGED'
}

export type MigrationImportAnswerPayload = {
  __typename?: 'MigrationImportAnswerPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<MigrationImportAnswerResult>;
};

/** What a grower's answer or correction recorded, and where the job stands. */
export type MigrationImportAnswerResult = {
  __typename?: 'MigrationImportAnswerResult';
  /** The job's state after the job step; null when the lineage has no current job. */
  jobState?: Maybe<MigrationPreparationJobState>;
  /** The lineage. */
  lineageId: Scalars['String']['output'];
  /** Recorded now, or already recorded by an earlier call from the same turn. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The question answered; for a correction, the grower-raised question. */
  questionId: Scalars['String']['output'];
  /** The question's revision after the call. */
  questionRevision: Scalars['Int']['output'];
  /** The answer's or correction's identity. */
  recordId: Scalars['String']['output'];
  /** Whether it re-queues the job so the next stage applies it. */
  requeuesJob: Scalars['Boolean']['output'];
  /** The question stream revision after the call. */
  streamRevision: Scalars['Long']['output'];
};

/** The answer a question holds. */
export type MigrationImportAnswerView = {
  __typename?: 'MigrationImportAnswerView';
  /** The answer's identity. */
  answerId: Scalars['String']['output'];
  /** When it was accepted. */
  answeredAt: Scalars['DateTime']['output'];
  /** Whether it answers the question's current group revision; an answer to an earlier group does not carry over. */
  applicable: Scalars['Boolean']['output'];
  /** The rows it leaves out. */
  exceptions: Array<Scalars['String']['output']>;
  /** The group revision it answered. */
  groupRevision: Scalars['Int']['output'];
  /** The option chosen. */
  option: Scalars['String']['output'];
  /** The record id or value a mapping answer names. */
  value?: Maybe<Scalars['String']['output']>;
};

/** One field a grower corrected, with the value they gave. */
export type MigrationImportCorrectedFieldInput = {
  field: Scalars['String']['input'];
  row: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** The grower's answer to an existing-record question as the identity component records it, field for field. */
export type MigrationImportDecisionInput = {
  /** The answer chosen from the question's offered set. */
  answer: MigrationIdentityAnswer;
  /** The answers to the detail questions. */
  details: Array<MigrationDetailDecisionInput>;
  /** The source row's business-identity digest. */
  identityDigest: Scalars['String']['input'];
  /** That record as the question showed it. */
  observedTarget?: InputMaybe<MigrationTargetObservationInput>;
  /** The existing records the question named. */
  offeredEntityIds: Array<Scalars['String']['input']>;
  /** What the lookup found. */
  question: MigrationMatchKind;
  /** The existing record the answer acts on, if any. */
  targetEntityId?: InputMaybe<Scalars['String']['input']>;
};

/** One question a stage raised. */
export type MigrationImportQuestionInput = {
  /** How many rows it covers. */
  affectedCount: Scalars['Int']['input'];
  /** Where the answer goes in the stage's answers. */
  answerKey: Scalars['String']['input'];
  /** Whether the affected rows stay out of every portion until it is answered. */
  blocking: Scalars['Boolean']['input'];
  /** Up to five of those rows, by reference. */
  exampleRows: Array<Scalars['String']['input']>;
  /** The data family it concerns. */
  family: Scalars['String']['input'];
  /** Every row it covers, by reference, at most 20,000. Send it whenever the rows are known: a grouped answer binds exactly these rows. */
  membership?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The answers offered; empty when the answer is a value. */
  options: Array<MigrationImportQuestionOptionInput>;
  /** The stage's key for it; the question id derives from (tenant, lineage, key). */
  questionKey: Scalars['String']['input'];
  /** The option fernie may recommend. */
  recommendedOption?: InputMaybe<Scalars['String']['input']>;
  /** The stage's own reference for the issue. */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** The question. Never a row's field value. */
  text: Scalars['String']['input'];
};

export enum MigrationImportQuestionKind {
  GrowerRaised = 'GROWER_RAISED',
  Preparation = 'PREPARATION',
  Validation = 'VALIDATION'
}

/** One answer a question offers. */
export type MigrationImportQuestionOptionInput = {
  /** The option's key. */
  key: Scalars['String']['input'];
  /** What the grower sees. */
  label: Scalars['String']['input'];
  /** For a grain question, how many records the option makes. */
  recordCount?: InputMaybe<Scalars['Int']['input']>;
};

/** One answer a question offers. */
export type MigrationImportQuestionOptionView = {
  __typename?: 'MigrationImportQuestionOptionView';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  recordCount?: Maybe<Scalars['Int']['output']>;
};

/** One page of a lineage's questions. */
export type MigrationImportQuestionPage = {
  __typename?: 'MigrationImportQuestionPage';
  /** The lineage; send it with an answer. */
  lineageId: Scalars['String']['output'];
  /** How many blocking questions are open. */
  openBlockingQuestions: Scalars['Int']['output'];
  /** This page. */
  questions: Array<MigrationImportQuestionView>;
  /** The question stream revision this read reflects. */
  streamRevision: Scalars['Long']['output'];
  /** How many questions match, across every page. */
  total: Scalars['Int']['output'];
};

/** One question of a lineage, with its example rows' values read now. */
export type MigrationImportQuestionView = {
  __typename?: 'MigrationImportQuestionView';
  /** How many rows it covers. */
  affectedCount: Scalars['Int']['output'];
  /** Its latest answer, if any. */
  answer?: Maybe<MigrationImportAnswerView>;
  /** Whether the affected rows stay out of every portion until it is answered. */
  blocking: Scalars['Boolean']['output'];
  /** Whether the stage still raises it at the revision it last ran on. */
  current: Scalars['Boolean']['output'];
  /** Up to five example rows, with their values as the prepared rows hold them now. */
  examples: Array<MigrationPreparedRowView>;
  /** The data family it concerns. */
  family: Scalars['String']['output'];
  /** The group revision an answer applies to. */
  groupRevision: Scalars['Int']['output'];
  /** Preparation, validation or grower-raised. */
  kind: MigrationImportQuestionKind;
  /** The hash of the exact rows it covers; a grouped answer binds it. */
  membershipHash: Scalars['String']['output'];
  /** Current, with no answer to its current group revision. */
  open: Scalars['Boolean']['output'];
  /** The answers offered. */
  options: Array<MigrationImportQuestionOptionView>;
  /** The question's stable id. */
  questionId: Scalars['String']['output'];
  /** The stage's key for it. */
  questionKey: Scalars['String']['output'];
  /** The revision to send with an answer. */
  questionRevision: Scalars['Int']['output'];
  /** The option fernie may recommend. Never a default. */
  recommendedOption?: Maybe<Scalars['String']['output']>;
  /** The stage that last raised it. */
  stage: Scalars['String']['output'];
  /** The question. */
  text: Scalars['String']['output'];
};

/** One import run after an advance, whether the worker calls again under the same claim, and how many operations the advance settled. */
export type MigrationImportRunAdvanceResult = {
  __typename?: 'MigrationImportRunAdvanceResult';
  hasMoreWork: Scalars['Boolean']['output'];
  rowsProcessed: Scalars['Int']['output'];
  run: MigrationImportRunStatus;
};

/** A claimed import run, the token every later call on it carries, and the control the claim read from the run's control stream. */
export type MigrationImportRunClaimPayload = {
  __typename?: 'MigrationImportRunClaimPayload';
  claimToken?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  run?: Maybe<MigrationImportRunStatus>;
};

/**
 * One import run's current confidence (O7): what its verification recorded and what each record holds now, in the
 * run's own scope only.
 */
export type MigrationImportRunConfidenceReport = {
  __typename?: 'MigrationImportRunConfidenceReport';
  /** The approval the run applied. */
  approvalId: Scalars['String']['output'];
  /** When the report was read. */
  checkedAt: Scalars['DateTime']['output'];
  /** How many operations read with each current status; empty unless rechecked. */
  current: Array<MigrationConfidenceCount>;
  /** The run's journey. */
  journeyId: Scalars['String']['output'];
  /** The run's latest paced observation, with its age; none before the first. */
  observation?: Maybe<MigrationImportRunObservation>;
  /**
   * Whether a paced observation is pending: the run is too large for a bounded read and holds none younger than the
   * observation refresh, so the paced runtime is due to record one.
   */
  observationPending: Scalars['Boolean']['output'];
  /** The operations whose record changed after import. */
  operationsChangedAfterImport: Scalars['Int']['output'];
  /** The operations verification confirmed. */
  operationsConfirmed: Scalars['Int']['output'];
  /** The operations verification found mismatched. */
  operationsMismatched: Scalars['Int']['output'];
  /** The operations verification left pending. */
  operationsPending: Scalars['Int']['output'];
  /** Every executable operation the run's approval covers. */
  operationsTotal: Scalars['Int']['output'];
  /** The operations verification recorded a result for. */
  operationsVerified: Scalars['Int']['output'];
  /**
   * Each prerequisite the run's operations referenced (a price group, terms, customer type or another existing record,
   * never one the run wrote) or material setting that no longer holds as validation recorded it, as the approval
   * recheck names it; empty unless rechecked.
   */
  prerequisitesChangedAfterImport: Array<Scalars['String']['output']>;
  /**
   * Whether the prerequisites the run's operations referenced were read again now: false while verification is pending,
   * or once the run's validation receipt or what its portion observed expired, and then nothing is claimed for them.
   */
  prerequisitesRechecked: Scalars['Boolean']['output'];
  /** How far each read model had projected when the records were read. */
  readModels: Array<MigrationReadModelWatermark>;
  /** Whether every verified operation was read again now. */
  recheck: MigrationConfidenceRecheck;
  /** Whether the recorded values expired (F27); each result and digest stays. */
  recordedValuesExpired: Scalars['Boolean']['output'];
  /** When the recorded values were purged. */
  recordedValuesPurgedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether every approved operation of this run reads CurrentVerified now and every prerequisite it referenced still
   * holds as validation recorded it. Run scope only: it never claims anything for other runs, families, the selected
   * work or the tenant.
   */
  runCurrentlyVerified: Scalars['Boolean']['output'];
  /** The run. */
  runId: Scalars['String']['output'];
  /** When verification was recorded; none while it is pending. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The upload, prepared revision and portion the evidence rests on. */
  versions: MigrationConfidenceVersions;
};

/** A grower's pause, resume or cancel of one import run, exactly as the grower typed and sent it in chat. */
export type MigrationImportRunControlInput = {
  /** The orchestrator's signed envelope over the call. */
  envelope?: InputMaybe<MigrationControlEnvelopeInput>;
  /** The run's control version as last read; a control sent against an older version is refused. */
  expectedControlVersion: Scalars['Int']['input'];
  /** The orchestrator's per-call key. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** The journey the run belongs to. */
  journeyId: Scalars['String']['input'];
  /** The run the control targets. */
  runId: Scalars['String']['input'];
  /** The sent message. */
  sentMessageReference?: InputMaybe<Scalars['String']['input']>;
  /** The chat session the message was sent in. */
  sessionReference?: InputMaybe<Scalars['String']['input']>;
  /** The chat turn the message opened. One control per turn and run. */
  turnId?: InputMaybe<Scalars['String']['input']>;
  /** The text the grower typed, exactly as sent. */
  typedText?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The committed outcome of a pause, resume or cancel, with the control's identity and the run's control
 * state after the call; send the control version with the next control. A refusal for a stale version
 * or a disallowed change carries the current control state as well.
 */
export type MigrationImportRunControlPayload = {
  __typename?: 'MigrationImportRunControlPayload';
  controlId?: Maybe<Scalars['String']['output']>;
  controlVersion?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  outcome?: Maybe<MigrationRunControlOutcomeKind>;
  requestedControl?: Maybe<MigrationRequestedControl>;
  state?: Maybe<MigrationImportRunState>;
};

/**
 * Health and completion of one import run. A run is Finished only once it is Completed and its
 * verification is recorded; a cancelled run says Cancelled, with the writes that happened and the
 * work left unwritten. Confirmed counts the committed operations the verification confirmed (zero while
 * it is pending). Unfinished counts the selected operations not done: everything not confirmed once
 * verified, otherwise everything not committed, so rejected operations and those that left at a resume
 * recheck are always in it. Once verified, an operation the verification found committed after the run
 * recorded it rejected or not applied counts committed, never rejected or left for review, and Late written
 * reports how many of the run's operations committed late. The acknowledged control version is the one the worker last acknowledged; with
 * the Blocked state it names one block episode, which is what a Blocked migration-status notice is keyed by.
 */
export type MigrationImportRunFacts = {
  __typename?: 'MigrationImportRunFacts';
  acknowledgedControlVersion: Scalars['Int']['output'];
  attemptCount: Scalars['Int']['output'];
  completion: MigrationRunCompletion;
  finished: Scalars['Boolean']['output'];
  health: MigrationHealth;
  id: Scalars['String']['output'];
  journeyId: Scalars['String']['output'];
  operationsCommitted: Scalars['Int']['output'];
  operationsConfirmed: Scalars['Int']['output'];
  operationsLateWritten: Scalars['Int']['output'];
  operationsLeftForReview: Scalars['Int']['output'];
  operationsRejected: Scalars['Int']['output'];
  operationsTotal: Scalars['Int']['output'];
  operationsUnconfirmed: Scalars['Int']['output'];
  operationsUnfinished: Scalars['Int']['output'];
  requestedControl: MigrationRequestedControl;
  runId: Scalars['String']['output'];
  state: MigrationImportRunState;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verification: MigrationVerificationStatus;
};

/**
 * One counted failure of an import run's advance (e5a81400 D2): when it happened, the error it stopped on, the
 * consecutive count it reached and whether it ended the run Failed.
 */
export type MigrationImportRunFailureDocument = {
  __typename?: 'MigrationImportRunFailureDocument';
  /** When the failure was counted, on the wsapi clock. */
  at: Scalars['DateTime']['output'];
  /** The error's code, when it has one. */
  code?: Maybe<Scalars['String']['output']>;
  /** The run's consecutive failures with this one counted. */
  consecutiveFailures: Scalars['Int']['output'];
  /** Whether this failure ended the run Failed. */
  endedRun: Scalars['Boolean']['output'];
  /** A generated id, unique to this failure. */
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  runId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * A paced observation of a run too large for a bounded read: how every operation its verification recorded read when
 * the paced runtime read them all again, with its age. Run scope only.
 */
export type MigrationImportRunObservation = {
  __typename?: 'MigrationImportRunObservation';
  /** How long before the report was read it started reading. */
  age: Scalars['TimeSpan']['output'];
  /** How many operations read with each current status then. */
  current: Array<MigrationConfidenceCount>;
  /** The observation. */
  observationId: Scalars['String']['output'];
  /** When it started reading: every record was read at or after it. */
  observedAt: Scalars['DateTime']['output'];
  /** The operations whose record had changed after import then. */
  operationsChangedAfterImport: Scalars['Int']['output'];
  /** How many operations it read again. */
  operationsRead: Scalars['Int']['output'];
  /** Each read model's checkpoint as it first read it. */
  readModels: Array<MigrationReadModelWatermark>;
  /**
   * Whether every approved operation of the run read CurrentVerified then. It says nothing about now, other runs,
   * families or the tenant.
   */
  runVerifiedWhenObserved: Scalars['Boolean']['output'];
};

/** A run the paced runtime is due to observe. */
export type MigrationImportRunObservationDue = {
  __typename?: 'MigrationImportRunObservationDue';
  /** The run's composite id, as the observation call takes it. */
  id: Scalars['String']['output'];
  /** When its latest observation started reading; none when it has none. */
  lastObservedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** One page of a paced observation, as the worker's call answers it. */
export type MigrationImportRunObservationPage = {
  __typename?: 'MigrationImportRunObservationPage';
  /** How many of the page's operations read with each current status. */
  current: Array<MigrationConfidenceCount>;
  /** When the page started reading: every record on it was read at or after it. */
  observedAt: Scalars['DateTime']['output'];
  /** How many of the page's operations' records changed after import. */
  operationsChangedAfterImport: Scalars['Int']['output'];
  /** How many operations the page read again. */
  operationsRead: Scalars['Int']['output'];
  /** The page, from 0. */
  page: Scalars['Int']['output'];
  /** How many pages cover every operation the run's verification recorded. */
  pages: Scalars['Int']['output'];
};

/** One import run after a call, or why the call changed nothing. */
export type MigrationImportRunPayload = {
  __typename?: 'MigrationImportRunPayload';
  errors?: Maybe<Array<ValidationError>>;
  run?: Maybe<MigrationImportRunStatus>;
};

/**
 * Named records, or a filtered sample, of one run, each read now. A sample illustrates findings for a review table;
 * it never replaces the run's reconciliation coverage and never supports a success claim.
 */
export type MigrationImportRunRecordsReport = {
  __typename?: 'MigrationImportRunRecordsReport';
  /** When the records were read. */
  checkedAt: Scalars['DateTime']['output'];
  /** Whether more records may match than are listed: the bound stopped the read or the list. */
  limited: Scalars['Boolean']['output'];
  /** How many records read again matched the filter. */
  matched: Scalars['Int']['output'];
  /** How far each read model had projected when the records were read. */
  readModels: Array<MigrationReadModelWatermark>;
  /** How many records were read again. */
  rechecked: Scalars['Int']['output'];
  /** Whether the recorded values expired (F27); each result and digest stays. */
  recordedValuesExpired: Scalars['Boolean']['output'];
  /** The records, in portion order. */
  records: Array<MigrationRecordConfidence>;
  /** The run. */
  runId: Scalars['String']['output'];
  /** Whether these are a filtered sample rather than records the caller named. */
  sample: Scalars['Boolean']['output'];
  /** When verification was recorded; none while it is pending, and then there are no records. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The upload, prepared revision and portion the evidence rests on. */
  versions: MigrationConfidenceVersions;
};

export enum MigrationImportRunState {
  Applied = 'APPLIED',
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

/**
 * Where one import run stands, with the grower's control still waiting for the worker. Carries no claim
 * token. The requested control is what was accepted after the acknowledged control version and not yet
 * acted on (a status read may lag the control stream by a moment). The control version is the number of
 * accepted controls: send it back as the expected version of the next control.
 */
export type MigrationImportRunStatus = {
  __typename?: 'MigrationImportRunStatus';
  acknowledgedControlVersion: Scalars['Int']['output'];
  approvalId: Scalars['String']['output'];
  attemptCount: Scalars['Int']['output'];
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  contractVersion: Scalars['String']['output'];
  controlVersion: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  cursor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageSha: Scalars['String']['output'];
  inputHash: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  journeyId: Scalars['String']['output'];
  operationsCommitted: Scalars['Int']['output'];
  operationsLeftForReview: Scalars['Int']['output'];
  operationsRejected: Scalars['Int']['output'];
  operationsTotal: Scalars['Int']['output'];
  requestedControl: MigrationRequestedControl;
  runId: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceVersion: Scalars['Int']['output'];
  stage: Scalars['String']['output'];
  state: MigrationImportRunState;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * An import run after its verification was recorded: when, and how many of its written operations the verification
 * confirmed, found mismatched, or left pending, and how many committed after the run recorded them rejected or not
 * applied.
 */
export type MigrationImportRunVerificationSummary = {
  __typename?: 'MigrationImportRunVerificationSummary';
  operationsConfirmed: Scalars['Int']['output'];
  operationsLateWritten: Scalars['Int']['output'];
  operationsMismatched: Scalars['Int']['output'];
  operationsPending: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  run: MigrationImportRunStatus;
};

/** One page of the answers the next stage of a job applies. */
export type MigrationJobAnswerPage = {
  __typename?: 'MigrationJobAnswerPage';
  /** This page, at most 100, by question kind, then question key. */
  answers: Array<MigrationJobAnswerView>;
  /** The job's artifact lineage. */
  lineageId: Scalars['String']['output'];
  /** The page to read next; null on the last page. */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** The question stream revision this read reflects. */
  streamRevision: Scalars['Long']['output'];
  /** How many answers apply, across every page. */
  total: Scalars['Int']['output'];
};

/** One recorded answer the next stage of a job applies, under the answer key its question gave. */
export type MigrationJobAnswerView = {
  __typename?: 'MigrationJobAnswerView';
  /** The answer's identity; a revision built from it lists it in its applied answers. */
  answerId: Scalars['String']['output'];
  /** Where the answer goes in the stage's answers. */
  answerKey: Scalars['String']['output'];
  /** For a correction, each field the grower gave with its value; empty otherwise. */
  correctedFields: Array<MigrationCorrectedFieldView>;
  /** A correction whose values were purged with the prepared rows. */
  correctionExpired: Scalars['Boolean']['output'];
  /** The rows the answer leaves out. */
  exceptions: Array<Scalars['String']['output']>;
  /** The group revision it answers. */
  groupRevision: Scalars['Int']['output'];
  /** Preparation, validation or grower-raised. */
  kind: MigrationImportQuestionKind;
  /** The membership it bound. */
  membershipHash: Scalars['String']['output'];
  /** The option chosen; corrected for a correction. */
  option: Scalars['String']['output'];
  /** The question's stable id. */
  questionId: Scalars['String']['output'];
  /** The stage's key for the question. */
  questionKey: Scalars['String']['output'];
  /** The stage that last raised the question. */
  stage: Scalars['String']['output'];
  /** The record id or value a mapping answer names. */
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * The journey's coverage report: per family, per portion, per file and per question, read now. It speaks for the
 * grower's selected work only: it never says anything about every family, the tenant's data or a release.
 */
export type MigrationJourneyConfidenceReport = {
  __typename?: 'MigrationJourneyConfidenceReport';
  /** When the report was read. */
  checkedAt: Scalars['DateTime']['output'];
  /** The families the grower deferred. */
  deferredFamilies: Array<Scalars['String']['output']>;
  /** Each family's coverage. */
  families: Array<MigrationFamilyCoverage>;
  /** Why the selected work is not verified; empty when it is. */
  gaps: Array<MigrationCoverageGap>;
  /** The journey. */
  journeyId: Scalars['String']['output'];
  /** The families the grower has not selected. */
  notSelectedFamilies: Array<Scalars['String']['output']>;
  /** Each portion's coverage. */
  portions: Array<MigrationPortionCoverage>;
  /** Every question, listed once. */
  questions: Array<MigrationQuestionCoverage>;
  /** The families the grower selected, in whole or in part. */
  selectedFamilies: Array<Scalars['String']['output']>;
  /**
   * Whether the selected work is verified: something is selected, every selected item and its dependencies are complete,
   * nothing is in flight, every source row is accounted for, no row of the selected work is pending, failed or
   * cancelled, and no question is open. Scope-limited: it never claims tenant-wide or release-wide success.
   */
  selectedScopeVerified: Scalars['Boolean']['output'];
  /** Each registered file's coverage. */
  uploads: Array<MigrationUploadCoverage>;
};

export enum MigrationMatchKind {
  Absent = 'ABSENT',
  CandidateMatch = 'CANDIDATE_MATCH',
  DeactivatedMatch = 'DEACTIVATED_MATCH',
  DeletedMatch = 'DELETED_MATCH',
  KeyMatch = 'KEY_MATCH',
  Lagging = 'LAGGING',
  MissingReference = 'MISSING_REFERENCE',
  TwoRecords = 'TWO_RECORDS',
  Unknown = 'UNKNOWN',
  Unproved = 'UNPROVED'
}

/** Where validation left one operation. */
export enum MigrationOperationOutcome {
  /** A blocking question or a failed rule holds it, or something it depends on. */
  Blocked = 'BLOCKED',
  /** Left out with a reason: one excluded count in review. */
  Excluded = 'EXCLUDED',
  /** The source adapter does not supply a field the rows need (record identity contract section 5.7). */
  NotImportableYet = 'NOT_IMPORTABLE_YET',
  /** Selected work that cannot be proved yet: a lookup is unproved or a route does not exist. */
  Pending = 'PENDING',
  /** Every rule passed and every dependency is satisfied: it may enter a portion. */
  Ready = 'READY'
}

/** What one operation's receipt says, without its claim tokens. */
export type MigrationOperationReceiptStatus = {
  __typename?: 'MigrationOperationReceiptStatus';
  /** The approval of the latest attempt. */
  approvalId: Scalars['String']['output'];
  /** How many attempts were issued. */
  attempts: Scalars['Int']['output'];
  /** When the first attempt was issued. */
  createdAt: Scalars['DateTime']['output'];
  /** A data portion or a settings revision. */
  kind: MigrationApprovalKind;
  /** Whether the write was found after its attempt was recorded as rejected or not applied. */
  lateWrite: Scalars['Boolean']['output'];
  /** The planned operation id. */
  operationId: Scalars['String']['output'];
  /** Issued (uncertain), Committed (written, not yet verified), Rejected or NotApplied. */
  outcome: MigrationReceiptOutcome;
  /** The written record's id, once committed. */
  persistedId?: Maybe<Scalars['String']['output']>;
  /** Why it was rejected or not applied. */
  reason?: Maybe<MigrationReceiptReason>;
  /** The record's stream revision after the operation's write. */
  resultingRevision?: Maybe<Scalars['Long']['output']>;
  /** The import run of the latest attempt; none for a settings operation. */
  runId?: Maybe<Scalars['String']['output']>;
  /** The kind of record the operation writes. */
  targetEntity: Scalars['String']['output'];
  /** The record's id. */
  targetId: Scalars['String']['output'];
  /** When the receipt last changed. */
  updatedAt: Scalars['DateTime']['output'];
};

/** How many of a portion's operations have one status. */
export type MigrationOperationStatusCount = {
  __typename?: 'MigrationOperationStatusCount';
  operations: Scalars['Int']['output'];
  status: OnboardingJourneyOperationStatus;
};

/** Why an operation's verification result is not Confirmed. */
export enum MigrationOperationVerificationReason {
  /** An event the operation did not write landed in its write interval (O6). */
  ConcurrentEdit = 'CONCURRENT_EDIT',
  /** The duplicate check could not prove the created identity, so verification waits. */
  DuplicateCheckPending = 'DUPLICATE_CHECK_PENDING',
  /** Two or more records hold the created identity (RACE-2): unresolved, never verified, never merged. */
  FoundDuplicate = 'FOUND_DUPLICATE',
  /** No event carries the operation id and its receipt is not applied. */
  NotApplied = 'NOT_APPLIED',
  /** The domain refused the operation and no event carries its id; the receipt reason says why. */
  Rejected = 'REJECTED',
  /** The target record is not there at the committed revision. */
  TargetMissing = 'TARGET_MISSING',
  /** The receipt is still Issued: its outcome is uncertain. */
  Uncertain = 'UNCERTAIN',
  Unknown = 'UNKNOWN',
  /** A persisted material field differs from the approved value. */
  ValuesDiffer = 'VALUES_DIFFER'
}

/** One operation's verification result (471ecef8 section 6.1). */
export enum MigrationOperationVerificationResult {
  /** The target holds what the operation approved, with no conflict: the only result that counts it complete. */
  Confirmed = 'CONFIRMED',
  /** The target contradicts the approval, or the operation did not write it. */
  Mismatch = 'MISMATCH',
  /** Not settled yet: the read lagged or the duplicate check could not prove the identity. */
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

/** One review shown to the caller whose subject has no approval yet. */
export type MigrationPendingReview = {
  __typename?: 'MigrationPendingReview';
  kind: MigrationApprovalKind;
  presentationId: Scalars['String']['output'];
  presentedAt: Scalars['DateTime']['output'];
  subjectHash: Scalars['String']['output'];
  subjectId: Scalars['String']['output'];
  turnId: Scalars['String']['output'];
};

/** One approved or proposed portion's coverage, connected to the selected work it was cut from. */
export type MigrationPortionCoverage = {
  __typename?: 'MigrationPortionCoverage';
  /** When the portion was read. */
  checkedAt: Scalars['DateTime']['output'];
  /** The lineage it was cut from. */
  lineageId: Scalars['String']['output'];
  /** Its operations. */
  operations: Scalars['Int']['output'];
  /** Its operations in a family the grower deferred or has not selected. */
  outsideSelectedScope: Scalars['Int']['output'];
  /** The portion. */
  portionId: Scalars['String']['output'];
  /**
   * Whether every operation of the portion is complete. It speaks for this portion only, never for the selected work,
   * the family or the tenant.
   */
  portionVerified: Scalars['Boolean']['output'];
  /** The selected work validation left out of it and why. */
  remaining: Array<MigrationRemainingCount>;
  /** The prepared revision number it was cut from. */
  revision: Scalars['Int']['output'];
  /** The run that applied it; none before it is approved. */
  runId?: Maybe<Scalars['String']['output']>;
  /** That run's state. */
  runState?: Maybe<OnboardingJourneyRunState>;
  /** Its operations by status. */
  statuses: Array<MigrationOperationStatusCount>;
  /** When the run's verification was recorded; none while it is pending. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A claimed preparation job and the token every later call on it carries. The token is null when the claim superseded the job instead. */
export type MigrationPreparationJobClaimPayload = {
  __typename?: 'MigrationPreparationJobClaimPayload';
  claimToken?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  job?: Maybe<MigrationPreparationJobStatus>;
};

/** Health of one preparation job. */
export type MigrationPreparationJobFacts = {
  __typename?: 'MigrationPreparationJobFacts';
  attemptCount: Scalars['Int']['output'];
  health: MigrationHealth;
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  journeyId: Scalars['String']['output'];
  state: MigrationPreparationJobState;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** One preparation job after a call, or why the call changed nothing. */
export type MigrationPreparationJobPayload = {
  __typename?: 'MigrationPreparationJobPayload';
  errors?: Maybe<Array<ValidationError>>;
  job?: Maybe<MigrationPreparationJobStatus>;
};

export enum MigrationPreparationJobState {
  Failed = 'FAILED',
  NeedsAnswers = 'NEEDS_ANSWERS',
  Pending = 'PENDING',
  Prepared = 'PREPARED',
  Running = 'RUNNING',
  Superseded = 'SUPERSEDED'
}

/**
 * Where one preparation job stands. Carries no claim token. The id is the composite of tenant and job
 * id, which the worker addresses the job by. The state reads Superseded as soon as a job for a newer
 * version of the same source exists, and the claim time is null while the job is unclaimed.
 */
export type MigrationPreparationJobStatus = {
  __typename?: 'MigrationPreparationJobStatus';
  attemptCount: Scalars['Int']['output'];
  blockingQuestions: Scalars['Int']['output'];
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  contractVersion: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageSha: Scalars['String']['output'];
  inputHash: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  journeyId: Scalars['String']['output'];
  rowsPrepared: Scalars['Int']['output'];
  rowsRead: Scalars['Int']['output'];
  sourceId: Scalars['String']['output'];
  sourceVersion: Scalars['Int']['output'];
  stage: Scalars['String']['output'];
  state: MigrationPreparationJobState;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum MigrationPreparationStageOutcome {
  AttemptFailed = 'ATTEMPT_FAILED',
  Failed = 'FAILED',
  NeedsAnswers = 'NEEDS_ANSWERS',
  Prepared = 'PREPARED',
  StageCompleted = 'STAGE_COMPLETED'
}

/** A recorded stage result: what the worker reported and where it moved the job when it was recorded. A repeat returns the same. */
export type MigrationPreparationStageResultPayload = {
  __typename?: 'MigrationPreparationStageResultPayload';
  errors?: Maybe<Array<ValidationError>>;
  job?: Maybe<MigrationPreparationJobStatus>;
  outcome?: Maybe<MigrationPreparationStageOutcome>;
  resultingState?: Maybe<MigrationPreparationJobState>;
};

/** The prepared artifact a page belongs to; every page of one artifact sends the same values. */
export type MigrationPreparedArtifactInput = {
  /** For an answer-driven revision, the answer and correction ids it applied. */
  answersApplied: Array<Scalars['String']['input']>;
  /** The field-support row of the adapter that prepared it. */
  fieldSupport: Array<MigrationFieldSupportInput>;
  /** How many pages the artifact is sent in, 1 to 1000. */
  pageCount: Scalars['Int']['input'];
  /** How many rows it has in all. */
  rowCount: Scalars['Int']['input'];
  /** The artifact's lowercase SHA-256. */
  sha256: Scalars['String']['input'];
  /** The rows read from each registered upload. */
  uploads: Array<MigrationUploadRowsInput>;
};

/** One field of a prepared row, exactly as the prepared file holds it. */
export type MigrationPreparedFieldInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** One prepared field as the grower sees it. */
export type MigrationPreparedFieldView = {
  __typename?: 'MigrationPreparedFieldView';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** One prepared row. */
export type MigrationPreparedRowInput = {
  /** Its fields, each name once. */
  fields: Array<MigrationPreparedFieldInput>;
  /** The prepared file it belongs to, for example fulfill/customer_import.csv. */
  file: Scalars['String']['input'];
  /** The row's reference, unique within the artifact. */
  row: Scalars['String']['input'];
  /** The source rows it was derived from. */
  sourceRows: Array<Scalars['String']['input']>;
};

/** One page of a prepared revision's rows. */
export type MigrationPreparedRowPage = {
  __typename?: 'MigrationPreparedRowPage';
  /** The retention purge took the revision's prepared rows, so none can be shown: expired, needs preparation. */
  expired: Scalars['Boolean']['output'];
  /** The lineage. */
  lineageId: Scalars['String']['output'];
  /** The revision read; null when the lineage has none. */
  revisionId?: Maybe<Scalars['String']['output']>;
  /** Its number within the lineage; 0 when none. */
  revisionNumber: Scalars['Int']['output'];
  /** This page, in submission order; empty when expired. */
  rows: Array<MigrationPreparedRowView>;
  /** How many rows match, across every page; 0 when expired. */
  total: Scalars['Long']['output'];
};

/** One prepared row, or an example row whose values are gone. */
export type MigrationPreparedRowView = {
  __typename?: 'MigrationPreparedRowView';
  /** The prepared rows were purged, so its values can no longer be shown. */
  expired: Scalars['Boolean']['output'];
  /** Its fields; empty when expired. */
  fields: Array<MigrationPreparedFieldView>;
  /** The prepared file it belongs to; empty when expired. */
  file: Scalars['String']['output'];
  /** The row's reference. */
  row: Scalars['String']['output'];
  /** The source rows it was derived from. */
  sourceRows: Array<Scalars['String']['output']>;
};

export type MigrationPresentationPayload = {
  __typename?: 'MigrationPresentationPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<MigrationPresentationResult>;
};

/** A recorded presentation: carry its id with the review and send it with the approval. */
export type MigrationPresentationResult = {
  __typename?: 'MigrationPresentationResult';
  kind: MigrationApprovalKind;
  outcome: OnboardingJourneyRecordOutcome;
  presentationId: Scalars['String']['output'];
  presentedAt: Scalars['DateTime']['output'];
  subjectHash: Scalars['String']['output'];
  subjectId: Scalars['String']['output'];
  turnId: Scalars['String']['output'];
};

/** What one purge call did to one record. */
export enum MigrationPurgeOutcome {
  /** The content was already purged; nothing changed. */
  AlreadyPurged = 'ALREADY_PURGED',
  /** A job, approval or run still holds the content, or a use reserved it; nothing was deleted. */
  Held = 'HELD',
  /** The class's retention period has not passed yet; nothing changed. */
  NotDue = 'NOT_DUE',
  /** The content was deleted and the purge recorded. */
  Purged = 'PURGED',
  /**
   * Held, and at least one reservation is older than one claim window with no durable hold behind it. It
   * stays until its command or staff resolves it; the purge never drops it.
   */
  ReservationUnresolved = 'RESERVATION_UNRESOLVED'
}

/** One question of the journey, listed once, with the files whose rows it covers. */
export type MigrationQuestionCoverage = {
  __typename?: 'MigrationQuestionCoverage';
  /** Whether the rows it covers stay out of every portion until it is answered. */
  blocking: Scalars['Boolean']['output'];
  /** The family it concerns. */
  family: Scalars['String']['output'];
  /** The lineage it was raised in. */
  lineageId: Scalars['String']['output'];
  /** The question. */
  questionId: Scalars['String']['output'];
  /** Open or answered. */
  state: OnboardingJourneyQuestionState;
  /** Each file whose rows it covers, with how many. */
  uploads: Array<MigrationUploadRows>;
};

/** How many of one file's source rows a question covers. */
export type MigrationQuestionRows = {
  __typename?: 'MigrationQuestionRows';
  /** The question. */
  questionId: Scalars['String']['output'];
  /** How many of the file's source rows it covers. */
  rows: Scalars['Int']['output'];
};

/** How far one read model had projected when a report was checked; none when it has no checkpoint. */
export type MigrationReadModelWatermark = {
  __typename?: 'MigrationReadModelWatermark';
  checkpoint?: Maybe<Scalars['Long']['output']>;
  readModel: Scalars['String']['output'];
};

/** The four receipt outcomes (471ecef8 section 7.3). */
export enum MigrationReceiptOutcome {
  /** An event carrying the operation id exists, or the command returned success. */
  Committed = 'COMMITTED',
  /** Written before the business command: the outcome is uncertain until reconciled. */
  Issued = 'ISSUED',
  /** Reconciled as never written: no event carries the operation id and the attempt is a window old. */
  NotApplied = 'NOT_APPLIED',
  /** The domain refused the operation: reported and actionable, never issued again. */
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

/** Why an operation was rejected or not applied (e5a81400 section 4.2). */
export enum MigrationReceiptReason {
  /** Not applied because the grower cancelled the run. */
  Cancelled = 'CANCELLED',
  /** The domain refused the command: validation or a guard. */
  DomainRefused = 'DOMAIN_REFUSED',
  /** Not applied because the run failed. */
  Failed = 'FAILED',
  /** Not applied after the last attempt the approval allows. */
  RetryBudgetSpent = 'RETRY_BUDGET_SPENT',
  /** A material field, the status or the identity of the target changed after review. */
  TargetChanged = 'TARGET_CHANGED',
  /** The target is gone or deleted. */
  TargetMissing = 'TARGET_MISSING',
  Unknown = 'UNKNOWN'
}

/** A journey's operation receipts and per-upload accounting. */
export type MigrationReceiptsReport = {
  __typename?: 'MigrationReceiptsReport';
  /** Every operation receipt of the journey, oldest first. */
  receipts: Array<MigrationOperationReceiptStatus>;
  /** Each upload's accounting. */
  uploads: Array<MigrationUploadAccounting>;
};

/** How a record changed after import. */
export enum MigrationRecordChange {
  /** The record was made inactive, as a keep-list cleanup or staff do. */
  Deactivated = 'DEACTIVATED',
  /** A material field other than status and identity holds another value, or the digest differs once values expired. */
  Edited = 'EDITED',
  /**
   * The record now holds another business identity (an item's SKU, a customer's ErpId): a semantic mislink, since
   * anything loaded against it now points at another business entity (e5a81400 section 7). Reported only; it is
   * fixed through a correction or by staff, never relinked automatically.
   */
  IdentityChanged = 'IDENTITY_CHANGED',
  /** Events the operation did not write landed after it, with no material field changed. */
  OtherChange = 'OTHER_CHANGE',
  /** The record was deleted or is gone: reported "removed after import". */
  Removed = 'REMOVED'
}

/**
 * One verified operation's record: what verification recorded, what the record holds now, and what that means
 * (O7). Observed only: nothing here repairs, relinks or rewrites the recorded evidence.
 */
export type MigrationRecordConfidence = {
  __typename?: 'MigrationRecordConfidence';
  /** When the latest event the operation did not write landed after it. */
  changedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Each material field that holds another value now, while the recorded values are kept. */
  changedFields: Array<MigrationFieldChange>;
  /** How the record changed after import; empty when it did not, or was not read. */
  changes: Array<MigrationRecordChange>;
  /** When the record was read now. */
  checkedAt: Scalars['DateTime']['output'];
  /** The digest of the material fields now; none when not read or the record is gone. */
  currentDigest?: Maybe<Scalars['String']['output']>;
  /** The stream's last revision now; none when it was not read or holds nothing. */
  currentRevision?: Maybe<Scalars['Long']['output']>;
  /** The material fields now; empty when not read or the record is gone. */
  currentValues: Array<MigrationFieldValue>;
  /** The material fields compared, in order; kept after the recorded values expire. */
  fieldNames: Array<Scalars['String']['output']>;
  /** The planned operation id. */
  operationId: Scalars['String']['output'];
  /** Why it is Unknown or not visible yet. */
  reason?: Maybe<MigrationRecordConfidenceReason>;
  /** When verification recorded it. */
  recordedAt: Scalars['DateTime']['output'];
  /** The digest of the recorded values; kept after they expire. */
  recordedDigest: Scalars['String']['output'];
  /** Why the recorded result is not Confirmed. */
  recordedReason?: Maybe<MigrationOperationVerificationReason>;
  /** The result verification recorded: Confirmed, Mismatch or Pending. */
  recordedResult: MigrationOperationVerificationResult;
  /** The stream revision verification observed the record at. */
  recordedRevision?: Maybe<Scalars['Long']['output']>;
  /** The values verification observed; empty once they expired. */
  recordedValues: Array<MigrationFieldValue>;
  /** Whether the recorded values have expired (F27), leaving the result, names and digest. */
  recordedValuesExpired: Scalars['Boolean']['output'];
  /** What the record's current confidence is. */
  status: MigrationRecordConfidenceStatus;
  /** The kind of record the operation wrote. */
  targetEntity: Scalars['String']['output'];
  /** The record's id. */
  targetId: Scalars['String']['output'];
  /** The position the recorded post-write duplicate check read the lookup at. */
  watermark?: Maybe<Scalars['Long']['output']>;
};

/** Why a record is Unknown or not visible yet. */
export enum MigrationRecordConfidenceReason {
  /**
   * RACE-2 W2 item gap: the item lookup reads ItemSummary, whose unique (TenantId, Sku) index hides a later stream
   * with the same SKU, so no item duplicate check is proved until 19c589d3's lookup covers it.
   */
  DuplicateCheckIncomplete = 'DUPLICATE_CHECK_INCOMPLETE',
  /** The record kind has no current-confidence read yet, so nothing current is claimed for it. */
  KindNotRechecked = 'KIND_NOT_RECHECKED',
  /** The record's stream could not be read now. */
  ReadFailed = 'READ_FAILED',
  /** The read model has not projected through the record's last event yet. */
  ReadModelBehind = 'READ_MODEL_BEHIND',
  /**
   * The read model projected past the record's last event and holds no row for it, as when another item already
   * holds its SKU and the SKU index kept the other one.
   */
  ReadModelRowMissing = 'READ_MODEL_ROW_MISSING',
  /** Verification recorded the operation pending; its recorded reason says why. */
  VerificationPending = 'VERIFICATION_PENDING'
}

/** What a current-confidence observation (O7) says about one verified operation's record now. */
export enum MigrationRecordConfidenceStatus {
  /** The store holds the write but the read model growers see has not shown it yet: lag, never a write failure. */
  CommittedNotVisible = 'COMMITTED_NOT_VISIBLE',
  /** The record still holds what verification confirmed, its read model shows it, and nothing is pending. */
  CurrentVerified = 'CURRENT_VERIFIED',
  /** Verification recorded a mismatch: the record contradicted the approval when it was verified. */
  Mismatch = 'MISMATCH',
  /** The record moved on after import through events the operation did not write: changed after import. */
  Stale = 'STALE',
  /** The fresh read did not finish within the recheck's time budget. */
  Timeout = 'TIMEOUT',
  /** Nothing current can be claimed: verification left it pending, the fresh read failed, or a check is not proved. */
  Unknown = 'UNKNOWN',
  /** The operation never wrote: its receipt is Rejected or NotApplied. */
  WriteFailed = 'WRITE_FAILED'
}

/**
 * What one purge call did to one record: the outcome, the rule the record's class expires under and when
 * its period ends, what holds it, and any reservation left unresolved for staff.
 */
export type MigrationRecordPurge = {
  __typename?: 'MigrationRecordPurge';
  dueAt: Scalars['DateTime']['output'];
  heldBy: Array<Scalars['String']['output']>;
  outcome: MigrationPurgeOutcome;
  recordClass: MigrationRetentionClass;
  recordId: Scalars['String']['output'];
  rule: MigrationRetentionRule;
  unresolvedReservations: Array<Scalars['String']['output']>;
};

/** What one purge call did, or why it was refused. */
export type MigrationRecordPurgePayload = {
  __typename?: 'MigrationRecordPurgePayload';
  errors?: Maybe<Array<ValidationError>>;
  purge?: Maybe<MigrationRecordPurge>;
};

export enum MigrationRecordStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

/** Selected work validation left out of a portion, as counts. */
export type MigrationRemainingCount = {
  __typename?: 'MigrationRemainingCount';
  /** The family. */
  family: Scalars['String']['output'];
  /** How many records. */
  operations: Scalars['Int']['output'];
  /** Where validation left it. */
  outcome: MigrationOperationOutcome;
  /** Why. */
  reason: Scalars['String']['output'];
  /** How many prepared rows. */
  rows: Scalars['Int']['output'];
};

export enum MigrationRequestedControl {
  Cancel = 'CANCEL',
  None = 'NONE',
  Pause = 'PAUSE',
  Resume = 'RESUME'
}

export enum MigrationRetentionClass {
  DerivedArtifactRevision = 'DERIVED_ARTIFACT_REVISION',
  ObservedValues = 'OBSERVED_VALUES',
  PreparedRows = 'PREPARED_ROWS',
  SessionTouch = 'SESSION_TOUCH',
  SourceVersion = 'SOURCE_VERSION',
  ValidationRun = 'VALIDATION_RUN'
}

export enum MigrationRetentionRule {
  LastUse = 'LAST_USE',
  RowTime = 'ROW_TIME',
  VerificationTime = 'VERIFICATION_TIME'
}

/** What became of one source row. */
export enum MigrationRowFate {
  /** Not imported because the grower cancelled the run. */
  Cancelled = 'CANCELLED',
  /** Left out with a reason. */
  Excluded = 'EXCLUDED',
  /** The write was refused or ran out of attempts, or verification found a readback mismatch. */
  Failed = 'FAILED',
  /** Folded as a duplicate into another row under the approved grouping. */
  Folded = 'FOLDED',
  /** In a family the grower deferred or did not select: left for later, never counted as excluded or pending. */
  LeftForLater = 'LEFT_FOR_LATER',
  /**
   * Not settled yet: waiting on a question or a dependency, held back, not imported yet, or written and not yet
   * verified. The reason says which.
   */
  Pending = 'PENDING',
  /** No prepared row names it, so nothing says what became of it. It blocks any success claim. */
  Unaccounted = 'UNACCOUNTED',
  /** Imported, and its run's verification confirmed it. */
  Verified = 'VERIFIED'
}

/** How many source rows had one fate, for one reason. */
export type MigrationRowFateCount = {
  __typename?: 'MigrationRowFateCount';
  /** What became of them. */
  fate: MigrationRowFate;
  /** Why, for example "written, not yet verified" or the code of the rule that left them out. */
  reason: Scalars['String']['output'];
  /** How many source rows. */
  rows: Scalars['Int']['output'];
};

/** How a run ended, for notices. Only a verified completed run is Finished. */
export enum MigrationRunCompletion {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Finished = 'FINISHED',
  NotFinished = 'NOT_FINISHED'
}

export enum MigrationRunControlAction {
  Cancel = 'CANCEL',
  Pause = 'PAUSE',
  Resume = 'RESUME'
}

export enum MigrationRunControlOutcomeKind {
  Accepted = 'ACCEPTED',
  AlreadyRecorded = 'ALREADY_RECORDED',
  NoChange = 'NO_CHANGE'
}

/** One setting change the grower is asked to approve. */
export type MigrationSettingChangeInput = {
  /** The value proposed. */
  after: Scalars['String']['input'];
  /** The value the grower was shown as current; empty when the setting has none. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** The catalog key, such as invoice-mode or terms:{termsId}. */
  setting: Scalars['String']['input'];
};

/** One setting change of a revision, its value now, its latest readback and its write receipts. */
export type MigrationSettingChangeResult = {
  __typename?: 'MigrationSettingChangeResult';
  after: Scalars['String']['output'];
  before: Scalars['String']['output'];
  current: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  readback: MigrationSettingReadback;
  reason?: Maybe<Scalars['String']['output']>;
  receipts: Array<MigrationOperationReceiptStatus>;
  setting: Scalars['String']['output'];
};

/** What the readback of one approved setting change found. */
export enum MigrationSettingReadback {
  /** A created record has a second record with the same business identity: unresolved, never verified. */
  Duplicate = 'DUPLICATE',
  /** The write committed but the setting's read shows another value. */
  Mismatch = 'MISMATCH',
  /** Not written yet. */
  NotRead = 'NOT_READ',
  /** The write is uncertain or not visible yet: the setting's read still shows another value. */
  Pending = 'PENDING',
  /** The write was refused: the target changed, went missing, or the domain refused it. */
  Rejected = 'REJECTED',
  /** The setting's own read shows the approved value. */
  Verified = 'VERIFIED'
}

/** A setting's value as its own query reads it now. */
export type MigrationSettingValue = {
  __typename?: 'MigrationSettingValue';
  setting: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Result of recordMigrationSettingsRevision or withdrawMigrationSettingsRevision. */
export type MigrationSettingsRevisionPayload = {
  __typename?: 'MigrationSettingsRevisionPayload';
  /** Why the call failed, such as a refused change; null when it succeeded. */
  errors?: Maybe<Array<ValidationError>>;
  /** The revision as it now stands; null when the call failed. */
  result?: Maybe<MigrationSettingsRevisionResult>;
};

/** A settings-operation revision: present it with its revision id and hash, then approve it in chat. */
export type MigrationSettingsRevisionResult = {
  __typename?: 'MigrationSettingsRevisionResult';
  approvalId?: Maybe<Scalars['String']['output']>;
  changes: Array<MigrationSettingChangeResult>;
  createdAt: Scalars['DateTime']['output'];
  hash: Scalars['String']['output'];
  journeyId: Scalars['String']['output'];
  revisionId: Scalars['String']['output'];
  state: MigrationSettingsRevisionState;
  updatedAt: Scalars['DateTime']['output'];
};

/** Where a settings-operation revision stands. */
export enum MigrationSettingsRevisionState {
  /** Approved: its writes run under its approval, and it can no longer be withdrawn. */
  Approved = 'APPROVED',
  /** Recorded and not yet approved: it can be presented, approved or withdrawn. */
  Open = 'OPEN',
  /** Withdrawn before approval, for example after the grower declined it: it can never be approved. */
  Withdrawn = 'WITHDRAWN'
}

/** What a settings write did for one approval. */
export enum MigrationSettingsWriteOutcome {
  /** The approval's write had already committed; nothing was written again. */
  AlreadyApplied = 'ALREADY_APPLIED',
  /** The write committed and the readback matched the approved values. */
  Applied = 'APPLIED',
  /**
   * A write is uncertain, waits for the identity lookup, or is not visible in its read yet. Approving again
   * reconciles it; nothing is written twice.
   */
  Pending = 'PENDING',
  /**
   * A write was refused (its target changed or went missing since review, or the domain refused it), read back
   * another value, or created a record that has a duplicate. Nothing is retried; record a new revision.
   */
  Rejected = 'REJECTED'
}

/**
 * A target observation as the identity component records it, as the
 * question showed it. The revision is a GraphQL Long and must not be negative.
 */
export type MigrationTargetObservationInput = {
  entityId: Scalars['String']['input'];
  identityDigest: Scalars['String']['input'];
  materialDigest: Scalars['String']['input'];
  revision: Scalars['Long']['input'];
  status: MigrationRecordStatus;
};

/** A note review showed with a family's records: a normalization, conversion or default the grower reviewed. */
export type MigrationTransformationCount = {
  __typename?: 'MigrationTransformationCount';
  /** The note's code. */
  code: Scalars['String']['output'];
  /** What review showed for it. */
  detail: Scalars['String']['output'];
  /** How many records carry it. */
  operations: Scalars['Int']['output'];
};

/** One handoff left undone for more than one claim window, for the repair to take one at a time by its id. */
export type MigrationUndoneHandoff = {
  __typename?: 'MigrationUndoneHandoff';
  dueAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  journeyId: Scalars['String']['output'];
  kind: MigrationUndoneHandoffKind;
  tenantId: Scalars['String']['output'];
};

/** Which document step a handoff left undone. */
export enum MigrationUndoneHandoffKind {
  /** A data approval was accepted and its import run was never created. The id is the approval's, {tenantId}-{approvalId}. */
  ApprovalWithoutRun = 'APPROVAL_WITHOUT_RUN',
  /** A job for a newer version of the same source exists and this job was never superseded. */
  NewerSourceVersion = 'NEWER_SOURCE_VERSION',
  /** A NeedsAnswers job has no open blocking question left and was never re-queued. */
  NoOpenBlockingQuestion = 'NO_OPEN_BLOCKING_QUESTION',
  /** A NeedsAnswers or Prepared job got a re-queueing answer or correction after its last stage result and was never re-queued. */
  RequeueingAnswer = 'REQUEUEING_ANSWER'
}

/** What became of one registered upload's rows (onboarding principle 4): counts that add up to the rows read. */
export type MigrationUploadAccounting = {
  __typename?: 'MigrationUploadAccounting';
  /** The counts by fate and reason. */
  fates: Array<MigrationUploadFate>;
  /** The upload's preparation lineage. */
  lineageId: Scalars['String']['output'];
  /** The prepared revision the counts are read from: the lineage's latest validated one. */
  revisionId: Scalars['String']['output'];
  /** Whether the prepared rows are gone, so the counts are the validation receipt's, without the import outcomes. */
  rowsPurged: Scalars['Boolean']['output'];
  /** The rows read from the upload. */
  rowsRead: Scalars['Int']['output'];
  /** The upload's row-id prefix. */
  source: Scalars['String']['output'];
};

/** What became of one registered file's rows: the families it fed and counts that add up to the rows read. */
export type MigrationUploadCoverage = {
  __typename?: 'MigrationUploadCoverage';
  /** Whether every row is accounted for and split by what the import did. */
  accounted: Scalars['Boolean']['output'];
  /** The families the file's rows fed. */
  families: Array<Scalars['String']['output']>;
  /** The file's preparation lineage. */
  lineageId: Scalars['String']['output'];
  /** Each question that covers some of the file's rows, with how many. */
  questions: Array<MigrationQuestionRows>;
  /** The prepared revision the counts are read from: the lineage's latest validated one. */
  revisionId: Scalars['String']['output'];
  /** That revision's number. */
  revisionNumber: Scalars['Int']['output'];
  /** The counts by fate and reason, unaccounted rows included; they add up to the rows read. */
  rows: Array<MigrationRowFateCount>;
  /**
   * Whether the prepared rows expired, so the counts are the validation receipt's and ready rows are not split by what
   * the import did.
   */
  rowsExpired: Scalars['Boolean']['output'];
  /** The rows read from the file. */
  rowsRead: Scalars['Int']['output'];
  /** The file's row-id prefix. */
  source: Scalars['String']['output'];
  /** How many rows nothing accounts for. */
  unaccountedRows: Scalars['Int']['output'];
  /** When that revision's validation receipt was written. */
  validatedAt: Scalars['DateTime']['output'];
  /** The validation receipt's digest, which covers the prerequisite records and material settings validation read. */
  validationDigest: Scalars['String']['output'];
};

/** A count of an upload's source rows with one fate and reason. */
export type MigrationUploadFate = {
  __typename?: 'MigrationUploadFate';
  /** Pending, Failed, Cancelled, or the validation fate of rows that were never ready to import. */
  fate: Scalars['String']['output'];
  /** Why, for example "written, not yet verified". */
  reason: Scalars['String']['output'];
  /** How many source rows. */
  rows: Scalars['Int']['output'];
};

/** How many of a question's source rows come from one file. */
export type MigrationUploadRows = {
  __typename?: 'MigrationUploadRows';
  /** How many of its source rows the question covers. */
  rows: Scalars['Int']['output'];
  /** The file's row-id prefix. */
  source: Scalars['String']['output'];
};

/** How many rows the preparation read from one registered upload. */
export type MigrationUploadRowsInput = {
  /** The rows or extracted records read from it. */
  rowsRead: Scalars['Int']['input'];
  /** The upload's row-id prefix: the first 16 characters of its SHA-256. */
  source: Scalars['String']['input'];
};

/** Whether the verification of a run's approved portion is recorded. */
export enum MigrationVerificationStatus {
  Pending = 'PENDING',
  Recorded = 'RECORDED'
}

export enum MilesSource {
  Map = 'MAP',
  Typed = 'TYPED',
  Unknown = 'UNKNOWN'
}

export type MilesSourceOperationFilterInput = {
  eq?: InputMaybe<MilesSource>;
  in?: InputMaybe<Array<MilesSource>>;
  neq?: InputMaybe<MilesSource>;
  nin?: InputMaybe<Array<MilesSource>>;
};

/**
 * Mint a single-use handoff code that lets one verified custom domain pick up the caller's
 * just-completed session.
 */
export type MintPortalSessionHandoffCodeInput = {
  /**
   * The session payload the portal client will need on the target domain. Opaque to the server: it is
   * accepted as an arbitrary string and never parsed, so its shape is entirely the caller's to choose.
   * Bounded — an oversized payload is refused rather than stored. It travels in this request body over
   * TLS, is encrypted before it is stored, and is handed back exactly once by the exchange; it never
   * appears in a URL or a log line.
   */
  sessionMaterial: Scalars['String']['input'];
  /**
   * The custom domain the session is being handed to. Must be a VERIFIED custom domain of the calling
   * tenant — that check is the open-redirect gate.
   */
  targetDomain: Scalars['String']['input'];
};

/**
 * What setup data a record is missing. Advisory only: a warning never blocks a save and never changes
 * a number.
 */
export enum MissingDataCode {
  /**
   * The tenant is connected to accounting and leaves its sales tax, freight, deposit or rounding account
   * unset, so those invoice lines post to the accounting system's default account.
   */
  AccountingComponentAccountsUnset = 'ACCOUNTING_COMPONENT_ACCOUNTS_UNSET',
  /** The category names no shipping UOM. One fix clears every item that inherits from it. */
  CategoryNoShippingUom = 'CATEGORY_NO_SHIPPING_UOM',
  /**
   * An active customer's type is a catch-all (General, Misc, Miscellaneous or Other) while the tenant has
   * at least two other active customer types to choose from.
   */
  CustomerCatchAllType = 'CUSTOMER_CATCH_ALL_TYPE',
  /** A customer-level customer item has no retail price while Pre-pricing is on. */
  CustomerItemNoRetailPrice = 'CUSTOMER_ITEM_NO_RETAIL_PRICE',
  /**
   * In a tenant connected to accounting, an active customer has no ERP ID and no accounting contact link,
   * so its first invoice export creates the accounting customer by name.
   */
  CustomerNoAccountingLink = 'CUSTOMER_NO_ACCOUNTING_LINK',
  /**
   * The customer has no terms, it has no ship-to or a ship-to with no terms, and the tenant has no Default
   * terms, so an order shipped there carries no terms.
   */
  CustomerNoTerms = 'CUSTOMER_NO_TERMS',
  /** The customer has no customer type while the tenant assigns a type to other active customers. */
  CustomerNoType = 'CUSTOMER_NO_TYPE',
  /**
   * The freight is set to Flat Fee or Percentage with a 0 or empty amount, which hides the positive freight
   * that would apply if it were set back to inherit.
   */
  FreightTypeHidesDefault = 'FREIGHT_TYPE_HIDES_DEFAULT',
  /** The item is in no category while the tenant puts a category on other active items. */
  ItemNoCategory = 'ITEM_NO_CATEGORY',
  /** The item has no load factor while the tenant sets a load factor on other active items. */
  ItemNoLoadFactor = 'ITEM_NO_LOAD_FACTOR',
  /**
   * The price group a line resolved to has no level that prices the item on the order's date and
   * quantity. Shown only on a price explanation, never listed.
   */
  ItemNoPriceLevel = 'ITEM_NO_PRICE_LEVEL',
  /** Neither the item's own pick nor any category it is in names a shipping UOM. */
  ItemNoShippingUom = 'ITEM_NO_SHIPPING_UOM',
  /** The item has no weight while the tenant tracks shipment weight. A weight of 0 is a set weight. */
  ItemNoWeight = 'ITEM_NO_WEIGHT',
  /** An active upgrade marked default has no price, so every new order line gets it at 0. */
  ItemUpgradeDefaultNoPrice = 'ITEM_UPGRADE_DEFAULT_NO_PRICE',
  /**
   * A material has no vendor, or no vendor flagged default, so a recipe line priced from the default vendor
   * reads zero.
   */
  MaterialNoDefaultVendor = 'MATERIAL_NO_DEFAULT_VENDOR',
  /** An active material or hard good has no type. */
  MaterialNoType = 'MATERIAL_NO_TYPE',
  /**
   * An active material's default vendor is not active, so a purchase order to it is refused when it is
   * created.
   */
  MaterialVendorInactive = 'MATERIAL_VENDOR_INACTIVE',
  /**
   * An active material has a vendor with no vendor item number, so a purchase order to that vendor prints the
   * material's own ERP id or nothing in its place.
   */
  MaterialVendorNoItemNumber = 'MATERIAL_VENDOR_NO_ITEM_NUMBER',
  /**
   * An active material has a vendor whose pack names no purchase unit or fewer than one each per unit, so a
   * purchase order to that vendor counts eaches at the per-each cost.
   */
  MaterialVendorNoPurchaseUnit = 'MATERIAL_VENDOR_NO_PURCHASE_UNIT',
  /** An open order has no route while the tenant routes its other orders. */
  OrderNoRoute = 'ORDER_NO_ROUTE',
  /**
   * The price group has an order-by date or lead time condition while the tenant has no business time zone,
   * so the group never applies.
   */
  PriceGroupConditionNoTimeZone = 'PRICE_GROUP_CONDITION_NO_TIME_ZONE',
  /**
   * A production category a recipe costs its labor from has no labor cost per unit or no effective date, so
   * its jobs' labor estimate reads zero.
   */
  ProductionCategoryNoLaborCost = 'PRODUCTION_CATEGORY_NO_LABOR_COST',
  /**
   * An active production item has no recipe for its catalog item and category, so a lot for it cannot build
   * its jobs.
   */
  ProductionItemNoRecipe = 'PRODUCTION_ITEM_NO_RECIPE',
  /** The production item is linked to no sales item, so its jobs cannot post to inventory. */
  ProductionItemNoSalesItem = 'PRODUCTION_ITEM_NO_SALES_ITEM',
  /** The job has no assigned site or sub-location while it is not executed or posted. */
  ProductionJobNoLocation = 'PRODUCTION_JOB_NO_LOCATION',
  /** The job carries no material events. */
  ProductionJobNoMaterialEvents = 'PRODUCTION_JOB_NO_MATERIAL_EVENTS',
  /**
   * A move put the job on a site where its recipe has no variation for it, so the job kept the recipe
   * values of the site it left.
   */
  ProductionJobNoRecipeAtSite = 'PRODUCTION_JOB_NO_RECIPE_AT_SITE',
  /** The job carries no space events. */
  ProductionJobNoSpaceEvents = 'PRODUCTION_JOB_NO_SPACE_EVENTS',
  /** The job carries no task events. */
  ProductionJobNoTaskEvents = 'PRODUCTION_JOB_NO_TASK_EVENTS',
  /**
   * The job books at least one run of weeks with no space type, because the bay it sits in has no Default
   * Space Type.
   */
  ProductionJobSpaceWeekNoSpaceType = 'PRODUCTION_JOB_SPACE_WEEK_NO_SPACE_TYPE',
  /** An active recipe has a variation that would build a job with no material events. */
  ProductionRecipeNoMaterialEvents = 'PRODUCTION_RECIPE_NO_MATERIAL_EVENTS',
  /** An active recipe has a variation that would build a job with no space events. */
  ProductionRecipeNoSpaceEvents = 'PRODUCTION_RECIPE_NO_SPACE_EVENTS',
  /** An active recipe has a variation that would build a job with no task events. */
  ProductionRecipeNoTaskEvents = 'PRODUCTION_RECIPE_NO_TASK_EVENTS',
  /**
   * The ship-to, its customer and the tenant's Default all name no price group, so every line shipped to
   * it prices at 0.
   */
  ShipToNoPriceGroup = 'SHIP_TO_NO_PRICE_GROUP',
  /** An active site's address lacks a street, city, state or zip, so a purchase order shipping to it fails at submit. */
  SiteNoAddress = 'SITE_NO_ADDRESS',
  /**
   * A site has no site-level overhead rate in effect, in a tenant with production jobs, so the overhead
   * estimate of a job there reads zero.
   */
  SiteNoOverheadRate = 'SITE_NO_OVERHEAD_RATE',
  /** A site has no time zone, so its overhead and labor rates cannot be shown or added on their effective dates. */
  SiteNoTimeZone = 'SITE_NO_TIME_ZONE',
  /**
   * An active sub-location has a Default Space Type but no capacity set up for it at all, so the space board
   * finds no capacity there in any week.
   */
  SubLocationNoCapacity = 'SUB_LOCATION_NO_CAPACITY',
  /**
   * An active sub-location has no Default Space Type while the tenant has an active space type, so space it
   * books is planned under no space type.
   */
  SubLocationNoDefaultSpaceType = 'SUB_LOCATION_NO_DEFAULT_SPACE_TYPE',
  /**
   * A task event has no direct cost in effect and no units per hour or no labor type, or no labor rate for its
   * type at the job's site, so its planned hours or cost read zero.
   */
  TaskEventNoLaborSetup = 'TASK_EVENT_NO_LABOR_SETUP',
  /**
   * A task on a production job has no labor type, or no labor rate for its labor type at its site, so time
   * logged on it adds no labor cost to the job.
   */
  TaskNoLaborCost = 'TASK_NO_LABOR_COST',
  /** At least one active item has no cost, so it adds nothing to a stock valuation on cost. */
  TenantItemsNoCost = 'TENANT_ITEMS_NO_COST',
  /** The effective company profile lacks a street, city, state or zip, so seller documents print a blank address. */
  TenantNoCompanyProfile = 'TENANT_NO_COMPANY_PROFILE',
  /** The terms carry a percent but 0 net days, so the percent can never apply. */
  TermsDiscountNeverApplies = 'TERMS_DISCOUNT_NEVER_APPLIES',
  /** The terms carry a percent and net days but 0 discount days, so no early-pay discount is ever applied. */
  TermsDiscountNoDays = 'TERMS_DISCOUNT_NO_DAYS',
  /** The terms name a day count, such as Net 30, but have 0 net days, so an invoice falls due on delivery. */
  TermsZeroNetDays = 'TERMS_ZERO_NET_DAYS'
}

/** The kind of record a missing-data warning is shown on, or is fixed on. */
export enum MissingDataEntityType {
  Category = 'CATEGORY',
  Customer = 'CUSTOMER',
  CustomerItem = 'CUSTOMER_ITEM',
  CustomerLocation = 'CUSTOMER_LOCATION',
  Item = 'ITEM',
  MaterialItem = 'MATERIAL_ITEM',
  Order = 'ORDER',
  PriceGroup = 'PRICE_GROUP',
  ProductionCategory = 'PRODUCTION_CATEGORY',
  ProductionItem = 'PRODUCTION_ITEM',
  ProductionJob = 'PRODUCTION_JOB',
  ProductionRecipe = 'PRODUCTION_RECIPE',
  ProductionTask = 'PRODUCTION_TASK',
  ProductionTaskEvent = 'PRODUCTION_TASK_EVENT',
  SiteLocation = 'SITE_LOCATION',
  SubLocation = 'SUB_LOCATION',
  Tenant = 'TENANT',
  Terms = 'TERMS'
}

/** One missing-data warning on one record. */
export type MissingDataFinding = {
  __typename?: 'MissingDataFinding';
  /** What is missing. */
  code: MissingDataCode;
  /**
   * Where a person fixes it: the record itself, or the category an item inherits its shipping UOM
   * from, or the recipe a job was built from, or the tenant whose setting a record depends on, or the price
   * group a line resolved to, or the site a task's labor rate is looked up at.
   */
  fixAt: RecordRef;
  /** {code}:{subject.id}, stable across calls, so a client can attach to one warning. */
  key: Scalars['String']['output'];
  /** The record the warning is shown on. */
  subject: RecordRef;
};

export type MoneyData = {
  __typename?: 'MoneyData';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
};

export type MoneyDataFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<MoneyDataFilterInput>>;
  currency?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MoneyDataFilterInput>>;
};

export type MoneyDataSortInput = {
  amount?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
};

export type MongoAggregationConfigData = {
  __typename?: 'MongoAggregationConfigData';
  aggregationFields: Array<MongoAggregationFieldData>;
  groupFields: Array<Scalars['String']['output']>;
  mergeOnFields: Array<Scalars['String']['output']>;
  targetCollection: Scalars['String']['output'];
  useAccumulativeMerge: Scalars['Boolean']['output'];
  whenMatched: MongoMergeWhenMatched;
  whenNotMatched: MongoMergeWhenNotMatched;
};

export type MongoAggregationConfigDataInput = {
  aggregationFields: Array<MongoAggregationFieldDataInput>;
  groupFields: Array<Scalars['String']['input']>;
  mergeOnFields: Array<Scalars['String']['input']>;
  targetCollection: Scalars['String']['input'];
  useAccumulativeMerge: Scalars['Boolean']['input'];
  whenMatched: MongoMergeWhenMatched;
  whenNotMatched: MongoMergeWhenNotMatched;
};

export type MongoAggregationDocumentData = {
  __typename?: 'MongoAggregationDocumentData';
  aggregationFields: Array<MongoAggregationFieldDocumentData>;
  groupFields: Array<Scalars['String']['output']>;
  mergeOnFields: Array<Scalars['String']['output']>;
  targetCollection: Scalars['String']['output'];
  useAccumulativeMerge: Scalars['Boolean']['output'];
  whenMatched: MongoMergeWhenMatched;
  whenNotMatched: MongoMergeWhenNotMatched;
};

export type MongoAggregationDocumentDataFilterInput = {
  aggregationFields?: InputMaybe<ListFilterInputTypeOfMongoAggregationFieldDocumentDataFilterInput>;
  and?: InputMaybe<Array<MongoAggregationDocumentDataFilterInput>>;
  groupFields?: InputMaybe<ListStringOperationFilterInput>;
  mergeOnFields?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<MongoAggregationDocumentDataFilterInput>>;
  targetCollection?: InputMaybe<StringOperationFilterInput>;
  useAccumulativeMerge?: InputMaybe<BooleanOperationFilterInput>;
  whenMatched?: InputMaybe<MongoMergeWhenMatchedOperationFilterInput>;
  whenNotMatched?: InputMaybe<MongoMergeWhenNotMatchedOperationFilterInput>;
};

export type MongoAggregationFieldData = {
  __typename?: 'MongoAggregationFieldData';
  operator: MongoAggregationOperator;
  outputFieldName: Scalars['String']['output'];
  sourceFieldName: Scalars['String']['output'];
};

export type MongoAggregationFieldDataInput = {
  operator: MongoAggregationOperator;
  outputFieldName: Scalars['String']['input'];
  sourceFieldName: Scalars['String']['input'];
};

export type MongoAggregationFieldDocumentData = {
  __typename?: 'MongoAggregationFieldDocumentData';
  operator: MongoAggregationOperator;
  outputFieldName: Scalars['String']['output'];
  sourceFieldName: Scalars['String']['output'];
};

export type MongoAggregationFieldDocumentDataFilterInput = {
  and?: InputMaybe<Array<MongoAggregationFieldDocumentDataFilterInput>>;
  operator?: InputMaybe<MongoAggregationOperatorOperationFilterInput>;
  or?: InputMaybe<Array<MongoAggregationFieldDocumentDataFilterInput>>;
  outputFieldName?: InputMaybe<StringOperationFilterInput>;
  sourceFieldName?: InputMaybe<StringOperationFilterInput>;
};

export enum MongoAggregationOperator {
  AddToSet = 'ADD_TO_SET',
  Avg = 'AVG',
  Count = 'COUNT',
  First = 'FIRST',
  Last = 'LAST',
  Max = 'MAX',
  Min = 'MIN',
  NotSet = 'NOT_SET',
  Push = 'PUSH',
  Sum = 'SUM'
}

export type MongoAggregationOperatorOperationFilterInput = {
  eq?: InputMaybe<MongoAggregationOperator>;
  in?: InputMaybe<Array<MongoAggregationOperator>>;
  neq?: InputMaybe<MongoAggregationOperator>;
  nin?: InputMaybe<Array<MongoAggregationOperator>>;
};

export type MongoColumnMapData = {
  __typename?: 'MongoColumnMapData';
  csvHeader?: Maybe<Scalars['String']['output']>;
  dynamicDefault?: Maybe<DynamicDefaultUnitData>;
  fieldName: Scalars['String']['output'];
  staticDefault?: Maybe<StaticDefaultUnitData>;
  transform?: Maybe<DynamicTransformUnitData>;
  type: BsonDataType;
};

export type MongoColumnMapDataInput = {
  csvHeader?: InputMaybe<Scalars['String']['input']>;
  dynamicDefault?: InputMaybe<DynamicDefaultUnitDataInput>;
  fieldName: Scalars['String']['input'];
  staticDefault?: InputMaybe<StaticDefaultUnitDataInput>;
  transform?: InputMaybe<DynamicTransformUnitDataInput>;
  type: BsonDataType;
};

export type MongoColumnMapDocumentData = {
  __typename?: 'MongoColumnMapDocumentData';
  csvHeader?: Maybe<Scalars['String']['output']>;
  dynamicDefault?: Maybe<DynamicDefaultUnitData>;
  fieldName: Scalars['String']['output'];
  staticDefault?: Maybe<StaticDefaultUnitData>;
  transform?: Maybe<DynamicTransformUnitData>;
  type: BsonDataType;
};

export type MongoColumnMapDocumentDataFilterInput = {
  and?: InputMaybe<Array<MongoColumnMapDocumentDataFilterInput>>;
  csvHeader?: InputMaybe<StringOperationFilterInput>;
  dynamicDefault?: InputMaybe<DynamicDefaultUnitDataFilterInput>;
  fieldName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MongoColumnMapDocumentDataFilterInput>>;
  staticDefault?: InputMaybe<StaticDefaultUnitDataFilterInput>;
  transform?: InputMaybe<DynamicTransformUnitDataFilterInput>;
  type?: InputMaybe<BsonDataTypeOperationFilterInput>;
};

export type MongoDestinationConfigData = {
  __typename?: 'MongoDestinationConfigData';
  aggregation?: Maybe<MongoAggregationConfigData>;
  collectionName: Scalars['String']['output'];
  connectionString: Scalars['String']['output'];
  databaseName: Scalars['String']['output'];
  destinationId: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  mongoColumns: Array<MongoColumnMapData>;
};

export type MongoDestinationConfigDataInput = {
  aggregation?: InputMaybe<MongoAggregationConfigDataInput>;
  collectionName: Scalars['String']['input'];
  connectionString: Scalars['String']['input'];
  databaseName: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  mongoColumns: Array<MongoColumnMapDataInput>;
};

export type MongoDestinationDocumentData = {
  __typename?: 'MongoDestinationDocumentData';
  aggregation?: Maybe<MongoAggregationDocumentData>;
  collectionName: Scalars['String']['output'];
  connectionString: Scalars['String']['output'];
  databaseName: Scalars['String']['output'];
  destinationId: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  mongoColumns: Array<MongoColumnMapDocumentData>;
};

export type MongoDestinationDocumentDataFilterInput = {
  aggregation?: InputMaybe<MongoAggregationDocumentDataFilterInput>;
  and?: InputMaybe<Array<MongoDestinationDocumentDataFilterInput>>;
  collectionName?: InputMaybe<StringOperationFilterInput>;
  databaseName?: InputMaybe<StringOperationFilterInput>;
  destinationId?: InputMaybe<StringOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  mongoColumns?: InputMaybe<ListFilterInputTypeOfMongoColumnMapDocumentDataFilterInput>;
  or?: InputMaybe<Array<MongoDestinationDocumentDataFilterInput>>;
};

export enum MongoMergeWhenMatched {
  Fail = 'FAIL',
  KeepExisting = 'KEEP_EXISTING',
  Merge = 'MERGE',
  NotSet = 'NOT_SET',
  Replace = 'REPLACE'
}

export type MongoMergeWhenMatchedOperationFilterInput = {
  eq?: InputMaybe<MongoMergeWhenMatched>;
  in?: InputMaybe<Array<MongoMergeWhenMatched>>;
  neq?: InputMaybe<MongoMergeWhenMatched>;
  nin?: InputMaybe<Array<MongoMergeWhenMatched>>;
};

export enum MongoMergeWhenNotMatched {
  Discard = 'DISCARD',
  Fail = 'FAIL',
  Insert = 'INSERT',
  NotSet = 'NOT_SET'
}

export type MongoMergeWhenNotMatchedOperationFilterInput = {
  eq?: InputMaybe<MongoMergeWhenNotMatched>;
  in?: InputMaybe<Array<MongoMergeWhenNotMatched>>;
  neq?: InputMaybe<MongoMergeWhenNotMatched>;
  nin?: InputMaybe<Array<MongoMergeWhenNotMatched>>;
};

export type MoveInventoryItemCommandInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['Int']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  toLocationId: Scalars['String']['input'];
  why: Scalars['String']['input'];
};

export type MoveMaterialItemInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  countedRecorded: Scalars['DateTime']['input'];
  fromLocationId: Scalars['String']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  materialItemId: Scalars['String']['input'];
  movedByUserEmail: Scalars['String']['input'];
  quantityMoved: Scalars['Decimal']['input'];
  reasonCode?: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
  toLocationId: Scalars['String']['input'];
};

/**
 * Read-model document for the MTR-08a MovementOrder history projection. One document
 * exists per MovementOrder and is retained permanently — unlike
 * PendingTransferOrderDocument, the receive event does not tombstone or delete
 * it. The MTR-08 worksuite-pwa History tab reads this via
 * movementOrderTransactionsByLocation.
 */
export type MovementOrderHistoryDocument = {
  __typename?: 'MovementOrderHistoryDocument';
  /** Timestamp from the originating MovementOrderCreated event. */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the movement order. */
  createdBy: Scalars['String']['output'];
  /**
   * The bin-level location the stock landed in: the bin the receive event named, else the bin
   * the order was created with, else the destination site id. Same non-empty guarantee and
   * site-id-is-a-real-bin rule as sourceBinId.
   */
  destinationBinId: Scalars['String']['output'];
  /** Source site — where stock shipped from. Outbound history rows match on this. */
  fromSiteLocationId: Scalars['String']['output'];
  /**
   * Name of the source site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  fromSiteLocationName: Scalars['String']['output'];
  /**
   * Composite Mongo _id in the form {TenantId}-{MovementOrderId}. Build via
   * GetMovementOrderHistoryDocumentId at every read/write site.
   */
  id: Scalars['String']['output'];
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId: Scalars['String']['output'];
  /**
   * The CountReasons code this movement was recorded under, resolved last-opinion-wins across
   * the receive, ship and create events, and defaulting to CountReasons.Transfer (4) when none
   * of them named one — which is what a movement order without an explicit reason is. Always a
   * valid CountReasons code: the mutation boundary rejects any other value, so 0 is impossible.
   */
  reasonCode: Scalars['Int']['output'];
  /**
   * Display label for reasonCode, the reason's name from the server-owned CountReasons table such
   * as "Transfer" or "Import", so a history row
   * renders the reason without a second round trip to the countReasons query. Empty string only
   * if the stored code is not a known reason, which the mutation boundary prevents.
   */
  reasonName: Scalars['String']['output'];
  /** Receive timestamp; None until MovementOrderReceived lands. */
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Receiver; None until MovementOrderReceived lands. */
  receivedBy?: Maybe<Scalars['String']['output']>;
  /** Per-line snapshot from MovementOrderReceived (the actual received quantities). */
  receivedLines: Array<MovementOrderHistoryLineDocument>;
  /** Reconciliation timestamp; None until MovementOrderReconciled lands. */
  reconciledAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who recorded the variance reconciliation; None until reconciled. */
  reconciledBy?: Maybe<Scalars['String']['output']>;
  /** Per-line snapshot from MovementOrderCreated (the ordered/requested quantities). */
  requestedLines: Array<MovementOrderHistoryLineDocument>;
  /** Ship timestamp; None until MovementOrderShipped lands. */
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Shipper; None until MovementOrderShipped lands. */
  shippedBy?: Maybe<Scalars['String']['output']>;
  /** Per-line snapshot from MovementOrderShipped (the actual shipped quantities). */
  shippedLines: Array<MovementOrderHistoryLineDocument>;
  /**
   * The bin-level location the stock left, resolved the way the domain resolves it: the bin the
   * ship event named, else the bin the order was created with, else the source site id. The
   * site id is a legitimate bin id here rather than a sentinel — an order that names only its
   * sites moves a site-shaped bin — so this is never empty and never needs a null check.
   */
  sourceBinId: Scalars['String']['output'];
  /**
   * Lifecycle status, derived from the lifecycle timestamps rather than persisted — see the
   * class remarks. Mirrors the inferred-status approach of
   * WorkSuite.Domain.MovementOrder.MovementOrderState.
   */
  status: MovementOrderStatus;
  /** Owning tenant; every query filters by this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** Destination site — where stock shipped to. Inbound history rows match on this. */
  toSiteLocationId: Scalars['String']['output'];
  /**
   * Name of the destination site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  toSiteLocationName: Scalars['String']['output'];
  /**
   * Human-readable transfer-order number (TO-xxx) shown as the row label instead of the raw id.
   * Empty on legacy rows until backfilled.
   */
  transferOrderNumber: Scalars['String']['output'];
};

/**
 * Read-model document for the MTR-08a MovementOrder history projection. One document
 * exists per MovementOrder and is retained permanently — unlike
 * PendingTransferOrderDocument, the receive event does not tombstone or delete
 * it. The MTR-08 worksuite-pwa History tab reads this via
 * movementOrderTransactionsByLocation.
 */
export type MovementOrderHistoryDocumentFilterInput = {
  and?: InputMaybe<Array<MovementOrderHistoryDocumentFilterInput>>;
  /** Timestamp from the originating MovementOrderCreated event. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** User who created the movement order. */
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /** Source site — where stock shipped from. Outbound history rows match on this. */
  fromSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Name of the source site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  fromSiteLocationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Composite Mongo _id in the form {TenantId}-{MovementOrderId}. Build via
   * GetMovementOrderHistoryDocumentId at every read/write site.
   */
  id?: InputMaybe<StringOperationFilterInput>;
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MovementOrderHistoryDocumentFilterInput>>;
  /** Receive timestamp; None until MovementOrderReceived lands. */
  receivedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Receiver; None until MovementOrderReceived lands. */
  receivedBy?: InputMaybe<OptionOfStringFilterInput>;
  /** Per-line snapshot from MovementOrderReceived (the actual received quantities). */
  receivedLines?: InputMaybe<ListFilterInputTypeOfMovementOrderHistoryLineDocumentFilterInput>;
  /** Reconciliation timestamp; None until MovementOrderReconciled lands. */
  reconciledAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** User who recorded the variance reconciliation; None until reconciled. */
  reconciledBy?: InputMaybe<OptionOfStringFilterInput>;
  /** Per-line snapshot from MovementOrderCreated (the ordered/requested quantities). */
  requestedLines?: InputMaybe<ListFilterInputTypeOfMovementOrderHistoryLineDocumentFilterInput>;
  /** Ship timestamp; None until MovementOrderShipped lands. */
  shippedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Shipper; None until MovementOrderShipped lands. */
  shippedBy?: InputMaybe<OptionOfStringFilterInput>;
  /** Per-line snapshot from MovementOrderShipped (the actual shipped quantities). */
  shippedLines?: InputMaybe<ListFilterInputTypeOfMovementOrderHistoryLineDocumentFilterInput>;
  /** Owning tenant; every query filters by this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Destination site — where stock shipped to. Inbound history rows match on this. */
  toSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Name of the destination site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  toSiteLocationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Human-readable transfer-order number (TO-xxx) shown as the row label instead of the raw id.
   * Empty on legacy rows until backfilled.
   */
  transferOrderNumber?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for the MTR-08a MovementOrder history projection. One document
 * exists per MovementOrder and is retained permanently — unlike
 * PendingTransferOrderDocument, the receive event does not tombstone or delete
 * it. The MTR-08 worksuite-pwa History tab reads this via
 * movementOrderTransactionsByLocation.
 */
export type MovementOrderHistoryDocumentSortInput = {
  /** Timestamp from the originating MovementOrderCreated event. */
  createdAt?: InputMaybe<SortEnumType>;
  /** User who created the movement order. */
  createdBy?: InputMaybe<SortEnumType>;
  /** Source site — where stock shipped from. Outbound history rows match on this. */
  fromSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Name of the source site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  fromSiteLocationName?: InputMaybe<SortEnumType>;
  /**
   * Composite Mongo _id in the form {TenantId}-{MovementOrderId}. Build via
   * GetMovementOrderHistoryDocumentId at every read/write site.
   */
  id?: InputMaybe<SortEnumType>;
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId?: InputMaybe<SortEnumType>;
  /** Receive timestamp; None until MovementOrderReceived lands. */
  receivedAt?: InputMaybe<SortEnumType>;
  /** Receiver; None until MovementOrderReceived lands. */
  receivedBy?: InputMaybe<SortEnumType>;
  /** Reconciliation timestamp; None until MovementOrderReconciled lands. */
  reconciledAt?: InputMaybe<SortEnumType>;
  /** User who recorded the variance reconciliation; None until reconciled. */
  reconciledBy?: InputMaybe<SortEnumType>;
  /** Ship timestamp; None until MovementOrderShipped lands. */
  shippedAt?: InputMaybe<SortEnumType>;
  /** Shipper; None until MovementOrderShipped lands. */
  shippedBy?: InputMaybe<SortEnumType>;
  /** Owning tenant; every query filters by this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Destination site — where stock shipped to. Inbound history rows match on this. */
  toSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Name of the destination site location, shown in place of the raw id. Empty when the name is
   * unavailable — including legacy rows until backfilled.
   */
  toSiteLocationName?: InputMaybe<SortEnumType>;
  /**
   * Human-readable transfer-order number (TO-xxx) shown as the row label instead of the raw id.
   * Empty on legacy rows until backfilled.
   */
  transferOrderNumber?: InputMaybe<SortEnumType>;
};

/**
 * Per-line snapshot persisted on the create / ship / receive line lists of
 * MovementOrderHistoryDocument. Its own dedicated type (Atlas df828612 —
 * separate types per architectural layer): not shared with
 * PendingTransferOrderDocument or the events-only line record.
 */
export type MovementOrderHistoryLineDocument = {
  __typename?: 'MovementOrderHistoryLineDocument';
  /** Locked-at-receive-time organic flag carried verbatim from the event record. */
  isOrganicAtReceive: Scalars['Boolean']['output'];
  /** Stable client-supplied line-item id (matches the event record's LineItemId). */
  lineItemId: Scalars['String']['output'];
  /** MaterialItem moving on this line. */
  materialItemId: Scalars['String']['output'];
  /** Optional organic lot identifier carried verbatim from the source lot. */
  organicLotCode?: Maybe<Scalars['String']['output']>;
  /** Quantity recorded by the originating event (created = requested, shipped/received = actual). */
  quantity: Scalars['Decimal']['output'];
  /** Optional vendor lot identifier (BPF Tier 2 future-proofing). */
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Per-line snapshot persisted on the create / ship / receive line lists of
 * MovementOrderHistoryDocument. Its own dedicated type (Atlas df828612 —
 * separate types per architectural layer): not shared with
 * PendingTransferOrderDocument or the events-only line record.
 */
export type MovementOrderHistoryLineDocumentFilterInput = {
  and?: InputMaybe<Array<MovementOrderHistoryLineDocumentFilterInput>>;
  /** Locked-at-receive-time organic flag carried verbatim from the event record. */
  isOrganicAtReceive?: InputMaybe<BooleanOperationFilterInput>;
  /** Stable client-supplied line-item id (matches the event record's LineItemId). */
  lineItemId?: InputMaybe<StringOperationFilterInput>;
  /** MaterialItem moving on this line. */
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MovementOrderHistoryLineDocumentFilterInput>>;
  /** Optional organic lot identifier carried verbatim from the source lot. */
  organicLotCode?: InputMaybe<OptionOfStringFilterInput>;
  /** Quantity recorded by the originating event (created = requested, shipped/received = actual). */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Optional vendor lot identifier (BPF Tier 2 future-proofing). */
  vendorLotNumber?: InputMaybe<OptionOfStringFilterInput>;
};

/**
 * One batch of a movement-order line: the batch code and the quantity of the line on it. A null code is
 * stock on the unknown batch.
 */
export type MovementOrderLineBatchInput = {
  /** The batch code; null for the unknown batch. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The quantity of the line on the batch. */
  quantity: Scalars['Decimal']['input'];
};

/**
 * Per-line input shape used by every MovementOrder mutation. Mirrors the domain
 * command's MovementOrderLineData but lives at the GraphQL boundary so
 * future GraphQL-only field additions (e.g. a derived display label) do not bleed
 * into the durable domain command. HotChocolate auto-appends Input, so the SDL
 * type is MovementOrderLineInput — the Data suffix is reserved for
 * cross-layer shapes per the WSAPI convention.
 */
export type MovementOrderLineInput = {
  batches?: InputMaybe<Array<MovementOrderLineBatchInput>>;
  isOrganicAtReceive: Scalars['Boolean']['input'];
  lineItemId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  organicLotCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Decimal']['input'];
  vendorLotNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * GraphQL projection of a single MovementOrder line snapshot (Created / Shipped /
 * Received). Carries the organic-at-receive flag and lot codes that downstream
 * material projections rely on (see MTR-04 and MTR-07).
 */
export type MovementOrderLineStateData = {
  __typename?: 'MovementOrderLineStateData';
  isOrganicAtReceive: Scalars['Boolean']['output'];
  lineItemId: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  organicLotCode?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Decimal']['output'];
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * GraphQL payload returned by every MovementOrder mutation. Follows the standard
 * mutation payload convention: nullable state on success, ValidationError array on failure
 * (see Atlas `cd1f708de28e44f8ae6d21f9a20f2212` — Payload Error Convention).
 */
export type MovementOrderPayload = {
  __typename?: 'MovementOrderPayload';
  errors?: Maybe<Array<ValidationError>>;
  movementOrder?: Maybe<MovementOrderStateData>;
};

/**
 * GraphQL boundary projection of MovementOrderState. Returned as the
 * state field on every MovementOrderPayload.
 * Optional timestamps from the state (MovementOrderState.ShippedAt etc.)
 * are declared as Option<DateTimeOffset>; the schema-build OptionTypeInterceptor
 * rewrites them to nullable in the emitted SDL for client consumption.
 */
export type MovementOrderStateData = {
  __typename?: 'MovementOrderStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  fromSiteLocationId: Scalars['String']['output'];
  lines: Array<MovementOrderLineStateData>;
  movementOrderId: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  receivedBy: Scalars['String']['output'];
  receivedLines: Array<MovementOrderLineStateData>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy: Scalars['String']['output'];
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  shippedBy: Scalars['String']['output'];
  shippedLines: Array<MovementOrderLineStateData>;
  status: MovementOrderStatus;
  tenantId: Scalars['String']['output'];
  toSiteLocationId: Scalars['String']['output'];
  varianceResolutions: Array<VarianceResolutionStateData>;
};

export enum MovementOrderStatus {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Received = 'RECEIVED',
  Reconciled = 'RECONCILED',
  Shipped = 'SHIPPED',
  Unknown = 'UNKNOWN'
}

export type MovementOrderStatusOperationFilterInput = {
  eq?: InputMaybe<MovementOrderStatus>;
  in?: InputMaybe<Array<MovementOrderStatus>>;
  neq?: InputMaybe<MovementOrderStatus>;
  nin?: InputMaybe<Array<MovementOrderStatus>>;
};

/** A connection to a list of items. */
export type MovementOrderTransactionsConnection = {
  __typename?: 'MovementOrderTransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MovementOrderTransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MovementOrderHistoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MovementOrderTransactionsEdge = {
  __typename?: 'MovementOrderTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MovementOrderHistoryDocument;
};

/**
 * Everything a client needs to render an enrollment QR code and let a user type the secret in by
 * hand — the one point in this feature where a live credential legitimately crosses to the client.
 */
export type MultiFactorEnrollmentStart = {
  __typename?: 'MultiFactorEnrollmentStart';
  /** The account label the authenticator app will show. */
  accountName: Scalars['String']['output'];
  /** The HMAC algorithm FusionAuth will verify with. */
  algorithm: Scalars['String']['output'];
  /** The number of digits in a code. */
  digits: Scalars['Int']['output'];
  /** The issuer the authenticator app will show. */
  issuer: Scalars['String']['output'];
  /** The provisioning URI to render as a QR code. */
  otpAuthUri: Scalars['String']['output'];
  /** The code's lifetime in seconds. */
  periodSeconds: Scalars['Int']['output'];
  /** The Base32 secret, for manual entry. */
  secretBase32Encoded: Scalars['String']['output'];
};

/** Reports the caller's recovery codes, or why they could not be produced. */
export type MultiFactorRecoveryCodesPayload = {
  __typename?: 'MultiFactorRecoveryCodesPayload';
  errors?: Maybe<Array<ValidationError>>;
  recoveryCodes?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type Mutation = {
  __typename?: 'Mutation';
  /** Aborts a rollout. Aborting is permanent, and the aborted rollout targets no device. */
  abortOtaRollout: OtaRolloutPayload;
  /**
   * Stamps acceptable-use acceptance onto the caller's active, started, unrevoked roster entry for a GrowerBenchmark
   * community (contract C5 and C7). For a platform superadmin holding no roster entry, or when the caller has
   * already accepted the same acceptableUseVersion, appends nothing and returns the community unchanged.
   */
  acceptGrowerBenchmarkAcceptableUse: GrowerBenchmarkCommunityPayload;
  /** Activates a feature flag, enabling its configured value for all tenants. */
  activateAdminFeatureFlag: AdminFeatureFlagPayload;
  activateAdminTenant: AdminTenantPayload;
  activateCategory: CategoryPayload;
  activateConfigCategory: ConfigCategoryPayload;
  activateContainerConfig: ContainerConfigPayload;
  activateCustomer: CustomerPayload;
  /**
   * Reactivates an inactive customer group. Rejected when another active group in the tenant
   * already uses this group's name.
   */
  activateCustomerGroup: CustomerGroupPayload;
  activateCustomerItem: CustomerItemPayload;
  /** @deprecated Use deleteCustomerType. The active/inactive toggle is being retired in favor of delete (AI Helm fd75fc05) -- this mutation is deprecated but still functional. */
  activateCustomerType: CustomerTypePayload;
  activateDeliverySchedule: DeliverySchedulePayload;
  activateItem: ItemPayload;
  /** @deprecated Use SiteLocation mutations instead. */
  activateLocation: LocationPayload;
  activateMaterialItem: MaterialItemPayload;
  /**
   * Makes this processor the system's Active one, atomically deactivating whichever processor was
   * previously Active (if any). Re-activating the already-Active processor is rejected as a
   * no-changes error, and activating a soft-deleted one is rejected before anything is written.
   */
  activatePaymentProcessor: PaymentProcessorPayload;
  activatePriceGroup: PriceGroupPayload;
  activateProductionCategory: ProductionCategoryPayload;
  activateProductionItem: ProductionItemPayload;
  activateProductionLot: ProductionLotPayload;
  activateProductionMaterialEvent: ProductionMaterialEventPayload;
  activateProductionMaterialEventDetail: ProductionMaterialEventPayload;
  activateProductionPlan: ProductionPlanPayload;
  activateProductionRecipe: ProductionRecipePayload;
  activateProductionSpaceCategory: ProductionSpaceCategoryPayload;
  activateProductionSpaceEvent: ProductionSpaceEventPayload;
  activateProductionSpaceEventDetail: ProductionSpaceEventPayload;
  activateProductionSpaceType: ProductionSpaceTypePayload;
  activateProductionTaskEvent: ProductionTaskEventPayload;
  activateProductionTaskEventDetail: ProductionTaskEventPayload;
  activateProductionTrigger: ProductionTriggerPayload;
  /** @deprecated Status-based activation is deprecated. Use the Enabled flag instead. */
  activateSftpTenantConfig: SftpTenantConfigPayload;
  activateSizeUom: SizeUomPayload;
  activateTaskEventType: TaskEventTypePayload;
  activateTerms: TermsPayload;
  activateVendor: VendorPayload;
  /**
   * Creates a parent company. The name must be free system-wide among parent companies that have
   * not been deleted, and the primary contact must carry both name fields plus at least one phone
   * number or email address.
   */
  addAdminParentCompany: AdminParentCompanyPayload;
  /**
   * Grants parent-company administrator rights to a FusionAuth user. Adding someone already on the
   * roster with the same display email writes no event.
   */
  addAdminParentCompanyAdministrator: AdminParentCompanyPayload;
  addAdminTenant: AdminTenantPayload;
  /**
   * Adds Active poles named after the bay, from <bay name>-P01 up to count (H11B01-P01 for
   * bay H11B01), padded to at least two digits. Names the bay already has are skipped, so sending it again
   * creates nothing. Returns the names it created and the names it skipped. Refused unless the parent is a bay.
   */
  addBayPoles: BayPolesPayload;
  addBillingAddress: CustomerPayload;
  addBlockingRuleLinkedItems: BlockingRulePayload;
  addBlockingRuleLinkedLocations: BlockingRulePayload;
  /**
   * Records a single lot change (move / add / subtract / output / confirm / add-inventory /
   * back-to-grow) for the calling BPF field user. Validates against current read state, writes an
   * immutable audit record, applies an optimistic delta to the BpfLotCounts read model, and
   * enqueues an ERP write-back for the post-back worker. Idempotent on IdempotencyKey: a
   * duplicate submit of the same change returns the existing audit record without re-applying or
   * re-enqueuing, and a submit reusing the key for a different change is refused with
   * BPF_LOT_CHANGE_KEY_REUSED without writing anything.
   */
  addBpfLotChange: BpfLotChangePayload;
  addCategory: CategoryPayload;
  /**
   * Creates a Shipping UOM. eachesPerUnit is REQUIRED and must be at least 1 despite its
   * nullable Int type on the input: omitting it returns a RequiredField error naming
   * EachesPerUnit rather than creating a Shipping UOM with no count of its own. The field is
   * nullable only so that a client which omits it gets that named domain error instead of a
   * query-validation failure that would also reject clients which DO send it.
   */
  addConfigCategory: ConfigCategoryPayload;
  addContact: CustomerPayload;
  addContainerConfig: ContainerConfigPayload;
  /**
   * Coordinated mutation backing the wireframe's "Add New" button on the
   * ConfigCategory detail → Container Configs sub-tab. Creates the
   * ContainerConfig and then attaches its id to the ConfigCategory's
   * ContainerConfigIds list. If the second write fails the first stays;
   * the caller can retry the attach by id.
   */
  addContainerConfigForConfigCategory: ConfigCategoryPayload;
  addContainerConfigToConfigCategory: ConfigCategoryPayload;
  addCustomerGroup: CustomerGroupPayload;
  addCustomerItem: CustomerItemPayload;
  /**
   * Adds 1 to 100 customer items in one call, in input order, returning one payload per row.
   * A row that fails validation or a business rule reports the error in its own payload and does
   * not stop the rows after it. An empty or oversized list fails the whole call and writes nothing.
   */
  addCustomerItems: CustomerItemBulkActionPayload;
  /**
   * Adds ONE note to a location's legacy note list (settings.notes) under the noteId
   * the caller allocated, stamped with the server clock and the signed-in user, leaving every other
   * note as stored. Error codes: CUSTOMER_LOCATION_NOTE_ID_CONFLICT (the id already holds
   * other text), ENTITY_NO_CHANGES (the id already holds this text). Neither means this call
   * wrote the note. There is no optimistic concurrency, so the payload is the state this call read
   * plus its own note; read the location back and compare the text to confirm.
   */
  addCustomerLocationSettingsNote: CustomerPayload;
  /**
   * The customer-type name field moved to Program-style free-solo creation: addCustomerType
   * now fires implicitly whenever a typed name does not match an existing option, rather than
   * from a deliberate "create new type" dialog. That makes same-name collisions routine instead
   * of exceptional, so this resolves them instead of erroring:
   *
   * An ACTIVE type with the same case-insensitive trimmed name already exists -> return
   * its current state (idempotent) instead of creating a duplicate or failing. Checked FIRST,
   * ahead of any inactive match, so a tenant that (via update-rename) ends up with both an
   * active and an inactive type sharing a name always converges on the active one.
   * No active match, but an INACTIVE (deactivated) type with that name exists ->
   * reactivate it and return the reactivated state. Chosen over rejecting: the free-solo UI has
   * no way to show the caller a deactivated type, so a rejection would be a dead end with no
   * path to recover the name. Reactivation only flips CustomerTypeStatus back to Active
   * -- it does not apply the incoming payload's RevenueGlAccountId to the reactivated
   * type, matching plain ActivateCustomerType's existing semantics. Reactivation runs
   * through a dedicated optimistic-concurrency entity function, so two callers racing the same
   * deactivated name cannot both append: the losing writer's append is rejected rather than
   * silently succeeding. That rejection is recovered into the current state only when the type
   * is Active (another reactivation won): exactly one CustomerTypeActivated event is
   * written and every racing caller returns the same id. If the type is still Inactive (a
   * rename or similar won the race) the reactivation is retried once, and if it is still not
   * Active an error is returned.
   * No match at all -> create as before.
   *
   *
   * The decision tree itself lives in CustomerTypeNameResolution, shared verbatim with the
   * mergeCustomer / importCustomer by-name resolution so a type typed here and a
   * type named by an import can never diverge into case-variant duplicates.
   */
  addCustomerType: CustomerTypePayload;
  /**
   * Adds a default upgrade to this customer: a name the grower types, optional pricing and cost shaped like an
   * item upgrade, and a Default switch. With no appliesToItemId it applies to every item the customer
   * orders; with one it applies only to that item. Refused when another active upgrade of this customer has
   * the same name (ignoring case and surrounding spaces) at the same scope; the same name at a different scope
   * is accepted. Repeating an identical add records no change.
   */
  addCustomerUpgrade: CustomerPayload;
  /**
   * Adds one explicit versioned quote for a vendor at one effective placement, minting its price
   * id. An active quote already covering that vendor and date is a conflict naming the price to
   * review; a voided one there is not, and the new quote gets its own identity beside it.
   */
  addEffectiveMaterialPrice: MaterialPriceWritePayload;
  /**
   * Adds an entry to the tenant's charge list. Refused while the FlatCharges flag is off for the
   * tenant, when the name is already used (case-insensitively, inactive entries included), or when the
   * account is not an active Revenue account.
   */
  addFlatChargeType: FlatChargeTypePayload;
  /**
   * Appends one entry to the calling reader's dashboard and compare activity trail for their primary firm in
   * input.communityId (contract C1).
   */
  addGrowerBenchmarkActivityEntry: GrowerBenchmarkActivityEntryPayload;
  /**
   * Creates a new GrowerBenchmark community and seeds initialAdminUserId as its first COMMUNITY_ADMIN roster entry
   * in the same stream append (projected into growerBenchmarkAccessLog as "Granted"). Restricted to platform
   * superadmins.
   */
  addGrowerBenchmarkCommunity: GrowerBenchmarkCommunityPayload;
  /**
   * Creates a new GrowerBenchmark review instruction set for communityId and segment with an empty version list and a null
   * currentVersionId (contracts R1 and R4). Restricted to effective COMMUNITY_ANALYST roster holders and platform
   * superadmins.
   */
  addGrowerBenchmarkInstructionSet: GrowerBenchmarkInstructionSetPayload;
  /**
   * Appends a new immutable version to instructionSetId without mutating any existing version (contracts R1 and R4).
   * Restricted to effective COMMUNITY_ANALYST roster holders and platform superadmins on the owning community; an
   * unknown instructionSetId returns GROWER_BENCHMARKS_ACCESS_DENIED.
   */
  addGrowerBenchmarkInstructionSetVersion: GrowerBenchmarkInstructionSetPayload;
  /**
   * Adds an email address or a whole domain documents are accepted from. INTAKE_ADDRESS_REQUIRED before the
   * address is created; ALLOWED_SENDER_EXISTS when the sender is already on the list.
   */
  addInboundAllowedSender: InboundIntakeSettingsPayload;
  /**
   * Adds a free-text note to an inventory key (item + location + grade). Multiple notes are
   * allowed on the same key and the full history is retained; the author and timestamp are
   * recorded server-side. Notes are independent of quantity and never affect the inventory
   * uniqueness/grouping key. The resulting full note set is returned on the payload's inventory item.
   */
  addInventoryNote: InventoryItemPayload;
  addItem: ItemPayload;
  /** Adds a characteristic to the tenant's list. The name must not be used by any other characteristic, deleted ones included. */
  addItemCharacteristic: ItemCharacteristicPayload;
  /** Adds a value to a characteristic's pick list. The name must not be used by another value of the same characteristic, deleted ones included. A deleted characteristic refuses it. */
  addItemCharacteristicValue: ItemCharacteristicPayload;
  /** Adds an upgrade ("Value Add") definition to the item's Attributes.Upgrades collection. */
  addItemUpgrade: ItemPayload;
  addLineItems: OrderPayload;
  /** Bulk adds hundreds of line items with optimized price resolution processing */
  addLineItemsWithPricing: OrderPayload;
  addLocation: CustomerPayload;
  addMasterLineItems: MasterOrderPayload;
  /**
   * Records a BATCH of retail product counts in one request — the PWA's offline-replay flush path.
   * The BPF-only tenant hard-gate runs once for the whole batch (a non-BPF tenant is rejected
   * wholesale); each count is then validated, written, and enqueued independently and idempotently,
   * so a per-count failure surfaces against that count rather than failing the batch. Returns one
   * result per input count, in input order.
   */
  addMultipleRetailProductCount: RetailProductCountBatchPayload;
  /**
   * Adds a charge picked from the tenant's charge list. The name is copied from the entry, Taxable defaults
   * from it unless given, and the entry must be active. There is no free-typed name, and the system fuel
   * surcharge cannot be added here.
   */
  addOrderFlatCharge: OrderPayload;
  /** Attaches an upgrade ("Value Add") to an order line. */
  addOrderLineUpgrade: OrderPayload;
  /**
   * Claims input.domain for the calling tenant's portal and returns the DNS TXT record the
   * tenant must publish to prove ownership (read back off the returned settings). The domain is
   * PENDING until verified: it serves nothing and can trigger no certificate issuance.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  addPortalCustomDomain: PortalSettingsPayload;
  addPriceGroup: PriceGroupPayload;
  addProductionLotAsyncImportJobRows: AsyncImportJobPayload;
  addProductionMaterialEventDetails: ProductionMaterialEventPayload;
  addProductionMaterialEventToCategory: ProductionCategoryPayload;
  /**
   * Attaches a material event to one production job — the grower's "Add Event" flow on the
   * production schedule. Only Active event definitions may be attached.
   */
  addProductionMaterialEventToJob: ProductionLotPayload;
  addProductionRecipeVariation: ProductionRecipePayload;
  addProductionSpaceEventDetails: ProductionSpaceEventPayload;
  addProductionSpaceEventToCategory: ProductionCategoryPayload;
  addProductionSpaceEventToJob: ProductionLotPayload;
  addProductionTaskEventDetails: ProductionTaskEventPayload;
  addProductionTaskEventToCategory: ProductionCategoryPayload;
  /** Attaches a production task event to a production item with optional default assignment. */
  addProductionTaskEventToItem: ProductionItemPayload;
  addPromotionRuleLinkedItems: PromotionRulePayload;
  addPromotionRuleLinkedLocations: PromotionRulePayload;
  addPurchaseOrderLineItem: VendorPurchaseOrderPayload;
  addReserveRuleLinkedItems: ReserveRulePayload;
  addReserveRuleLinkedLocations: ReserveRulePayload;
  /**
   * Records a single retail product count (drop-off / credit / cycle-count; must-go is refused) at a
   * retail customer location for the calling BPF field user. Validates the input, writes an immutable
   * audit record, and enqueues an ERP write-back (workflow = Retail) for the post-back worker → Nav
   * CustomerInventoryLog. Idempotent on IdempotencyKey: a duplicate submit returns the
   * existing audit record without re-enqueuing.
   */
  addRetailProductCount: RetailProductCountPayload;
  addSftpDestination: SftpTenantConfigPayload;
  addSftpMongoDestination: SftpTenantConfigPayload;
  addSftpTenantConfig: SftpTenantConfigPayload;
  addShipFromLocation: CustomerPayload;
  addSignatureImage: OrderPayload;
  addSiteLocationAsyncImportJobRows: AsyncImportJobPayload;
  addSizeUom: SizeUomPayload;
  addSizeUomToConfigCategory: ConfigCategoryPayload;
  /**
   * Adds one Active sub-location to a site. It is checked against the site's other sub-locations with the
   * same rules as mergeSiteLocation, and its id against every other site. Sending the same row again
   * changes nothing.
   */
  addSubLocation: SiteLocationPayload;
  /** Adds a color to the tenant's list of tag colors. The name must not be used by any other color, deleted ones included. */
  addTagColor: TagColorPayload;
  /** Add a note to a task assignment. */
  addTaskAssignmentNote: TaskAssignmentPayload;
  /**
   * Binds an email-authentication domain to this tenant. The created path (the domain is not yet
   * authenticated account-wide with SendGrid) creates a SendGrid domain authentication and starts
   * Pending until its CNAME records validate — SendGrid's CNAME proof establishes ownership there.
   * The grandfather path (the domain is already SendGrid-authenticated account-wide and unclaimed)
   * no longer binds as Verified immediately: it starts Pending with a per-tenant ownership-challenge
   * TXT token that must be published at _worksuite.{domain} and confirmed via
   * validateTenantEmailDomain before it becomes Verified. A tenant may only have one bound
   * domain at a time, and a domain (or its underlying SendGrid authentication) may only be Verified
   * to one tenant at a time; a stale unverified pending claim stops reserving the domain after the
   * squat-relief window so it can never permanently block the rightful owner. The platform default
   * sender domain (silverfern.group) is rejected outright and can never be bound — no tenant
   * could publish its ownership TXT even absent that guard.
   */
  addTenantEmailDomain: TenantEmailDomainPayload;
  /** Adds a new sender identity (starts Pending). A same-address re-add is a no-op. */
  addTenantEmailSender: TenantEmailSenderPayload;
  /**
   * Appends one purchase UOM name to the tenant's list — the server home for the PWA's
   * creatable-dropdown "type a new name and it joins the list" behaviour. Normalizes lowercase and
   * dedupes against the fixed seed list AND the tenant's existing custom names; a name already
   * present (either source) is a no-op. On success returns the FULL merged (seed ∪ custom) list so
   * the caller can repaint its dropdown immediately; a no-op instead returns
   * errors: [EntityCommandHasNoChanges] with names: null, so callers must fall back to the
   * tenantUomNames query on that path.
   */
  addTenantUomName: TenantUomListPayload;
  addTerms: TermsPayload;
  /**
   * Makes a supplier's item id, or its description when it has none, an alias of a material for one vendor.
   * Adding an alias that already exists changes nothing and returns it; adding one that was retired
   * reactivates it as a new version, except from a CSV import, which is refused. When another material
   * already owns the key, the add is refused with typedErrors.collision unless replaceExisting is true.
   * The vendor must exist, and the material must exist, not be deleted, and be assigned to the vendor.
   */
  addVendorItemAlias: VendorItemAliasPayload;
  addVendorPurchaseOrderCharge: VendorPurchaseOrderPayload;
  addWsapiImportEntityMapping: WsapiImportPayload;
  /**
   * Asks this session's counting device to move its running total by a signed amount. The absolute
   * the device is told to hold is resolved from its LATEST REPORTED TOTAL at request time and
   * range-checked before anything is claimed, appended or sent.
   */
  adjustCountedQuantity: CountCorrectionPayload;
  /** Adjusts the quantity of an existing inventory item. */
  adjustInventoryItem: InventoryItemPayload;
  /**
   * Reduces what one issued invoice is owed — a write-off, a discount granted after the bill went out,
   * or another stated reduction.
   */
  adjustInvoice: InvoicePayload;
  /**
   * Adjusts the required quantity of an allocation that is still Requested or Confirmed,
   * recording the adjustment reason. A no-op (no event) when the new quantity equals the
   * current required quantity.
   *
   *
   * **Returns:**
   * The adjusted allocation, or validation/no-change errors.
   */
  adjustMaterialAllocation: MaterialAllocationPayload;
  /**
   * Adjusts (corrects) a material item's on-hand quantity at a bin to a new absolute value
   * with a reason. Distinct from countMaterialItem (an observation) and moveMaterialItem (a
   * relocation); mirrors FULFILL's adjustInventoryItem. The acting user is resolved from the
   * request context.
   */
  adjustMaterialItem: MaterialItemLocationQuantityPayload;
  /**
   * Sets the freight on a Shipped or Closed order that has no live invoice, recomputing the order
   * total, balance and payment status. The status does not change, and the discount, override and
   * line prices are left as they are. The reason is required and shows in the order history with
   * who made the change and when. An order that has not shipped changes its freight through
   * editOrder; an order with a live invoice is refused with ORDER_INVOICED, and the
   * change is made by crediting the invoice.
   */
  adjustOrderFreight: OrderPayload;
  adjustPostedProduction: ProductionLotPayload;
  /**
   * The yearly price change: end-dates every addressed level the day before newStartDate and
   * appends a successor for each at a price raised by percent or by amount, in ONE
   * write. Exactly one of percent and amount; fields defaults to the grower sell price;
   * newStartDate must be after every addressed level's own start date. All-or-nothing: an
   * id the group does not hold, a percent-off level, or a bad date refuses the whole request, and
   * per-row results say what each level's old and new price ended up being.
   */
  adjustPriceLevels: AdjustPriceLevelsPayload;
  /**
   * Adjusts the allocated quantity of an existing order-production-lot allocation. A no-op
   * (no event) when the new quantity equals the current allocated quantity. Rejected when
   * the allocation is Cancelled.
   */
  adjustProductionLotAllocation: OrderProductionLotAllocationPayload;
  adminCreateUserInvites: AdminCreateUserInvitesPayload;
  adminDbrCalcForceRecalcByCustomer: AdminDbrCalcWorkPayload;
  adminDbrCalcForceRecalcByItem: AdminDbrCalcWorkPayload;
  adminDbrCalcForceRecalcByLocation: AdminDbrCalcWorkPayload;
  adminDbrCalcForceRecalcByTenant: AdminDbrCalcWorkPayload;
  adminDbrCalcForceRecalcRow: AdminDbrCalcWorkPayload;
  adminDeleteUserInvite: UserInvitePayload;
  /** SuperAdmin. Removes the feature; a run-published one comes back if the release run re-publishes its release. */
  adminDeleteWhatsNewFeature: AdminWhatsNewPayload;
  /**
   * SuperAdmin removal of a device in any tenant, or in none (a Lobby device has no owner). A Lobby or
   * Decommissioned device is removed from every listing, including adminDevices unless
   * includeRemoved is set; its event stream is kept. A Claimed device is decommissioned exactly as
   * decommissionDevice would, without the owning-tenant check, and stays listed as Decommissioned;
   * removing it again then removes it from the listings. Repeating a removal is a success that appends
   * nothing. The acting user and the optional reason are recorded on the event.
   */
  adminRemoveDevice: DevicePayload;
  /**
   * The ops-repair mutation for the 17-user Reset Tenant orphan incident (and any future recurrence):
   * re-creates a soft-deleted WorkSuiteUser stream from its still-Active read-model row, so
   * every mutation that currently fails with "WorkSuiteUser does not exist" against these rows works
   * again. Platform superadmin only, gated exactly like the other admin* surfaces.
   *
   * Preconditions: the WorkSuiteUsers row for tenantId/userId must exist and be
   * Active, else the payload carries a typed error and nothing is read further. The stream is
   * then probed: Live is a no-op (the current state is returned, no event written — the user
   * was never actually orphaned, or somebody already fixed it); Tombstoned is refused (a
   * hard-deleted stream cannot be re-created); SoftDeleted is repaired by appending the row's
   * own data back onto the SAME stream id.
   */
  adminRepairOrphanedUser: UserPayload;
  adminResendUserInvite: UserInvitePayload;
  adminRestockCalcForceRecalcByCustomer: AdminRestockCalcPayload;
  adminRestockCalcForceRecalcByItem: AdminRestockCalcPayload;
  adminRestockCalcForceRecalcByLocation: AdminRestockCalcPayload;
  adminRestockCalcForceRecalcByTenant: AdminRestockCalcPayload;
  adminRestockCalcForceRecalcRow: AdminRestockCalcPayload;
  adminRestockSeedImportData: AdminRestockSeedImportDataPayload;
  /**
   * Makes already-seeded import data flow the same day: clears today's RestockPreCalculation
   * success marker and satisfies the InventoryState dependency with a synthetic successful
   * iteration so the next worker tick re-runs the pre-calc for the tenant. Pairs with
   * adminRestockSeedImportData; poll adminRestockSeedingPipelineStatus after.
   */
  adminRestockSeedingKickPipeline: AdminRestockSeedingKickPipelinePayload;
  /** SuperAdmin. Adds a feature or changes any attribute of one; moving it to an earlier release back-dates it. */
  adminSaveWhatsNewFeature: AdminWhatsNewPayload;
  /** SuperAdmin. Subscribes or unsubscribes one of the tenant's users. */
  adminSetWhatsNewEmailRecipient: WhatsNewEmailRecipientPayload;
  /** SuperAdmin. Sets the effective date of every feature in the release. */
  adminSetWhatsNewReleaseEffectiveOn: AdminWhatsNewPayload;
  /**
   * Worker only: advances one background job by at most one page of maxItems items (at most 100), then
   * returns this call's counts. Of two calls on one job at once, exactly one handles a page; the other returns
   * with nothing processed. A job that waits for an order another job is changing, or whose page another call is
   * handling, returns hasMoreWork true with nothing processed. A finished or cancelled job returns hasMoreWork
   * false. The worker calls again while hasMoreWork is true.
   */
  advanceBackgroundJob: AdvanceBackgroundJobPayload;
  /**
   * Worker only: advances one bulk order delete job by at most one page of 25 orders, then returns. Each
   * order is deleted one after another through the same command a single deleteOrder uses, performed by the
   * user who requested the job; one order failing never stops the rest. Only a tenant's oldest unfinished
   * job advances: a newer one returns hasMoreWork true with no work done. A cancelled or finished job deletes
   * nothing and returns hasMoreWork false. The worker calls again while hasMoreWork is true.
   */
  advanceBulkOrderDeleteJob: AdvanceBulkOrderDeleteJobPayload;
  advanceConsolidationApplication: ConsolidationApplicationPayload;
  /** Applies the next chunk (25-50, configurable) of the run's approved rows; when none remain, runs Verify and completes the run. */
  advanceCorrectionRun: AdvanceCorrectionRunPayload;
  /**
   * Worker or superadmin: applies the next chunk of a conversion job, in one atomic write covering every tenant of the
   * chunk, then returns. One call is one chunk. A chunk whose plan would change a customer's flags is refused and the
   * job stops (REFUSED); a chunk tenant changed since it was read writes nothing and returns conflict true, and the next
   * call plans the chunk again. A finished or cancelled job applies nothing. Call again while hasMoreWork is true.
   */
  advanceFeatureFlagProductConversionJob: AdvanceFeatureFlagProductConversionJobPayload;
  /**
   * Applies at most one page of the run's approved portion under the caller's claim and reports whether to call
   * again. Worker only; not trial-limited, since migrated records are exempt.
   */
  advanceMigrationImportRun: AdvanceMigrationImportRunPayload;
  /**
   * Validates the run's next page of whole operations against the domain rules, opening the run on page 0
   * when no run id is sent. Writes only the run and its page's results. Worker only.
   */
  advanceMigrationValidation: AdvanceMigrationValidationPayload;
  /**
   * Coarse, page-scoped advance of a single ProductionLot async-import job, driven by the external
   * wsapi-services scheduler. One call claims the job (if needed) and processes AT MOST one page of
   * the current phase, then returns — so request time is bounded and the scheduler loops while
   * hasMoreWork is true. The phase logic itself lives in the shared
   * ProductionLotAsyncImportAdvanceService (the same code the in-process worker runs).
   */
  advanceProductionLotAsyncImportJob: AdvanceProductionLotAsyncImportJobPayload;
  allocateLineItems: OrderPayload;
  /**
   * Allocates an order line against a spec production lot (CustomerId == null), creating
   * a new allocation stream with an absolute quantity reservation. The lot is looked up
   * in the read model to snapshot its Quantity (server-authoritative LotQty)
   * and FinishJobWeekReadyDate onto the event and to enforce the spec-lot constraint.
   * OrderedQty is a caller-supplied snapshot; LotQty is always resolved from
   * the lot document so the per-lot availability denominator cannot be corrupted by client input.
   * A lot with no FinishJobWeekReadyDate is rejected — spec lots are resolved via a
   * FinishJob, so a ready date must exist.
   * The chosen lot's sales item must be the order line's: the order line's ItemId is
   * resolved from the read model and must equal the lot's sales item, which is its own production
   * item's sales item when it has one, else the one sales item its finish job's plant and pot sells
   * as. A plant and pot selling as several sales items is refused until the lot's production item
   * is set. This makes the T5d
   * single-writer rule (PRODUCE only allocates where FULFILL designated, against linked lots)
   * non-bypassable server-side, independent of any client-supplied scoping.
   */
  allocateProductionLotToOrderLine: OrderProductionLotAllocationPayload;
  allocateRestockSessionInventory: AllocationPayload;
  amendPurchaseOrderLineItem: VendorPurchaseOrderPayload;
  /**
   * Records the grower's answer to one question, then re-queues the job when the answer changes planned
   * work or closes its last open blocking question. Send the question revision the question page showed:
   * an answer to an older revision is refused with the question as it stands. When the job's prepared data
   * is past its retention period nothing is recorded: expired, needs preparation.
   */
  answerMigrationImportQuestion: MigrationImportAnswerPayload;
  applyConsolidation: ApplyConsolidationPayload;
  applyConsolidationPreview: ConsolidationApplicationPayload;
  /**
   * Applies some of what is left of a credit memo to one open invoice of the same customer, reducing what that
   * invoice owes. The amount may not exceed what the memo still has unapplied or what the invoice owes; a voided
   * invoice, or one of another customer, is refused. Send an applicationId to make the request safe to retry.
   */
  applyCreditMemo: ApplyCustomerCreditPayload;
  /**
   * Applies some of a customer's unapplied credit to one of their invoices, reducing what the invoice owes.
   * The amount may not exceed the customer's unapplied credit or the invoice's open balance; a voided
   * invoice, or an invoice of another customer, is refused. Send an applicationId to make the request
   * safe to retry: the same applicationId, invoice and amount applies exactly once.
   */
  applyCustomerCredit: ApplyCustomerCreditPayload;
  /**
   * Applies the freight the preview showed for one load: every eligible order's freight, fuel surcharge and
   * provenance, and the clear of any order that left the load, in one atomic write. Recomputes from the current
   * loads and refuses with STALE_INPUT_VERSION when anything moved since the preview; skipped orders are results,
   * never errors.
   */
  applyLoadFreight: ApplyLoadFreightPayload;
  /**
   * Saves the next writes of an approved supplier price import and reports every row of the approved
   * document. A call stops before a write that would take it past five rows, but its first write always runs,
   * and one write can stand for more than five rows. The first call captures the approval as the plan every
   * later call works from. Call again only while stepsRemain is true, stop is null, and the last call moved at
   * least one row out of waiting.
   */
  applySupplierPriceImport: ApplySupplierPriceImportPayload;
  /**
   * Gives the second approval of plan revision planRevision, the one the caller reviewed, which approves the
   * run. Refused when the run was re-planned since (CORRECTION_PLAN_SUPERSEDED). The requester already gave
   * the first with the plan and is refused (CORRECTION_REQUESTER_CANNOT_APPROVE), as is a superadmin
   * approving the same revision twice (CORRECTION_ALREADY_APPROVED_BY_YOU).
   */
  approveCorrectionRun: CorrectionRunPayload;
  /**
   * Approves versionId on an InEdit GrowerBenchmark review with outputType and accumulated edit seconds (contracts R2
   * and R4). Refuses reviews that have never entered InEdit with GROWER_BENCHMARKS_REVIEW_NOT_REVIEWED and any non-InEdit
   * status with GROWER_BENCHMARKS_REVIEW_STATUS_INVALID. Restricted to effective COMMUNITY_ANALYST roster holders and
   * platform superadmins.
   */
  approveGrowerBenchmarkReview: GrowerBenchmarkReviewPayload;
  /**
   * Approves an InReview submission version, recording approvalType, approver, approval time, cadence, and firm
   * classification while atomically superseding any earlier Approved version for the same reporting unit and
   * period (contract C6 and C7). Restricted to effective COMMUNITY_ANALYST roster holders and platform superadmins.
   */
  approveGrowerBenchmarkSubmission: GrowerBenchmarkSubmissionPayload;
  /**
   * Approves exactly the presented portion or settings revision the grower's sent message names. For data it
   * creates the portion's import run in Queued in the same request; for a setting it writes the setting. A
   * replay returns the recorded approval and its run. Data whose validation is no longer current is re-queued
   * and answered pending, with nothing approved.
   */
  approveMigrationReview: MigrationApprovalPayload;
  /**
   * Approves a Draft production lot, which becomes Active live work. Only a superadmin or a produce admin
   * may approve. Approving an Active lot returns ENTITY_NO_CHANGES; an archived or deleted lot is
   * refused. Rejecting a draft is deleteProductionLot.
   */
  approveProductionLot: ProductionLotPayload;
  approvePurchaseOrder: VendorPurchaseOrderPayload;
  /**
   * Assigns (or clears, when locationId is null) the device's optional location field. The
   * field's MEANING is per-profile UI/policy — coarse, informational "physically located at" for a
   * line-attached counter (Count's line→device association remains the authoritative operational
   * placement) or the authoritative measurement location for a future standalone sensor profile —
   * but this mutation enforces NO granularity itself: a site-level or sub-location-level id
   * validates identically, via the same location-existence check every other fleet mutation's
   * location input uses. Scoped to the owning tenant, same as the other fleet mutations; clearing
   * (null) always succeeds without a lookup. Assigning the exact value the device already has
   * (including null → null) is a no-op and records no history.
   */
  assignDeviceLocation: DevicePayload;
  /**
   * Assigns the QuickBooks (Merge.dev) Income GL-account id for an item. The id is
   * nullable — null clears the mapping. A non-null id is validated against
   * MongoMergeDevAccount to ensure it exists and carries the expected
   * classification (Revenue) before the V1.ItemGlAccountsAssigned event is
   * appended.
   */
  assignItemGlAccounts: ItemPayload;
  assignMaterialItemToVendor: MaterialItemPayload;
  /**
   * Puts an order onto a load — creates or full-replace updates the LoadLine. Stop
   *             assignment is always reset here (a fresh assignment, or a re-assignment to a possibly
   *             different load, has no stop yet); set it separately via setLoadLineStop.
   */
  assignOrderToLoad: LoadLinePayload;
  /**
   * Company admins only. Converts an open report (one saved before saved views, or while the flag was off) into a
   * saved view owned by the given person, with no grants, so from then on only its owner and company admins see
   * it until it is shared. Giving the same owner again writes nothing; a view that already has another owner is
   * refused with REPORT_ALREADY_OWNED. Refused with SAVED_VIEWS_NOT_ENABLED while the company's SavedViews flag
   * is off.
   */
  assignReportOwner: ReportPayload;
  /**
   * Scopes the user to a customer (the Portal/Buyer scope). Re-assigning the same
   * customer writes no event and reports "no changes". A customer combined into another is
   * refused (CUSTOMER_COMBINED). Staff users normally have no customer scope.
   *
   * Admin/SuperAdmin gated, matching its plural sibling assignUserCustomers: customer scope
   * is an access limiter, so who may set it is an authorization question.
   */
  assignUserCustomer: UserPayload;
  /**
   * Assigns the user a multi-value customer access limiter — the resolved customer scope used to
   * limit what the user can see (consumed by B2/C2/C3). An empty list clears the limit ("sees all");
   * re-assigning the same set (order-insensitive) writes no event and reports "no changes". This is
   * purely an access limiter: it NEVER adds the Portal role (Portal is an explicit role only).
   *
   * Admin/SuperAdmin gated: the outer RestockWriter policy excludes portal callers, and
   * RequireTenantAdmin requires either a platform superadmin JWT or the caller's own Active
   * directory entry holding the tenant Admin role. Tenant isolation comes from the caller's JWT.
   */
  assignUserCustomers: UserPayload;
  /**
   * Assigns the user a multi-value route access limiter (D2 keystone; blocks D3/D4) — a resolved
   * set of route CODE strings used to limit what the user can see (consumed by D3). An empty list
   * clears the limit ("sees all"); re-assigning the same set (order-insensitive) writes no event
   * and reports "no changes". This is purely an access limiter and never touches roles.
   *
   * Admin/SuperAdmin gated: the outer RestockWriter policy excludes portal callers, and
   * RequireTenantAdmin requires either a platform superadmin JWT or the caller's own Active
   * directory entry holding the tenant Admin role. Tenant isolation comes from the caller's JWT.
   */
  assignUserRoutes: UserPayload;
  /**
   * Scopes the user to a set of site/location nodes (parent-and-below access): the user gains
   * access to each assigned node and every descendant beneath it. An empty list clears the scope
   * ("no site limit" — the user sees all sites). Re-assigning the identical set writes no event
   * and reports "no changes". This axis is independent of roles and customer scope — the mutation
   * never touches either. Gated to tenant Admins (or a platform superadmin), matching the
   * invite/portal-provisioning surface, since site assignment grants access scope.
   */
  assignUserSites: UserPayload;
  /**
   * Atomic bench-to-bench move: emits Created + Shipped + Received in a single
   * KurrentDB transaction with one shared OccurredAt timestamp. Used by the Move
   * tab for same-site moves where there is no in-transit phase (~90% of greenhouse
   * volume per the MTR-01 board verdict). GraphQL field name is atomicMove
   * per the MTR-03 task spec.
   */
  atomicMove: MovementOrderPayload;
  /**
   * Attaches a grower availability photo to an item: validates the payload (jpeg/png/webp, up to
   * 5MB), stores the bytes in the shared public-read "item-images" Azure Blob container under a
   * tenant/item-scoped, content-addressed path, then records the returned RELATIVE path on a
   * session-less per-item photo stream with its recorded time — a configured public base URL
   * composes the absolute URL at resolve time. The image bytes never enter the event store — only
   * the resulting path is persisted and projected. The portal item image then resolves to the
   * newest availability photo, falling back to the item's own image. SessionId on input is
   * accepted but ignored: availability capture no longer flows through staged sessions, so no
   * session is resolved or required here.
   *
   * input.IdempotencyKey is optional: when supplied, a duplicate submit under the same
   * (TenantId, key) short-circuits before re-uploading the image / re-appending a PhotoAttached
   * event and answers with the empty-session success payload, carrying the photo id the first submit kept.
   *
   *
   * attachedPhotoId carries the attached photo's id: the new photo's on a fresh attach, the photo
   * already in that bin's gallery when a byte-identical repeat no-ops, and the id kept on the claim when a
   * key replays. A claim written before the id was kept replays null, as does a gallery read that fails.
   */
  attachAvailabilitySessionPhoto: AvailabilitySessionPayload;
  /**
   * Attaches a reusable Kit to a Draft session as a snapshot of its complete stored composition:
   * every nested Kit, every Item, and each Item line's Shipping UOM and eaches count. Returns the
   * same session id and the snapshot saved. It writes no order quantity and never changes the
   * reusable Kit, and a later edit to that Kit does not change the snapshot. A Kit graph the caller
   * cannot fully read, or one with a missing, deleted, combined or unprovable part, is refused whole.
   * A source Kit attaches to a session once; after an unknown outcome, read the session's kits to
   * reconcile.
   */
  attachRestockSessionKit: RestockSessionKitPayload;
  autoAllocateRestockSessionOrderQuantities: RestockSessionPayload;
  /**
   * W3. WORKER ONLY. Same checks as linkRampBillToPurchaseOrder, source AUTO. Returns ENTITY_NO_CHANGES
   * (and writes nothing) when the bill is already on that PO or a user unlinked it before.
   */
  autoLinkRampBillToPurchaseOrder: RampBillLinkPayload;
  /**
   * SuperAdmin: gives every open issued invoice of a tenant that has never had a pay link its first one, for a
   * tenant whose online invoice payments have just been switched on. Idempotent, and it never replaces a link:
   * an invoice that already has one, active, expired or revoked, is counted and left alone. Capped per run;
   * when the result is not complete, run it again.
   */
  backfillAdminTenantInvoicePayLinks: InvoicePayLinkBackfillPayload;
  /**
   * Backfills the Stripe customer for a pre-existing tenant that was created before Stripe
   * provisioning (or while Stripe was unavailable). Idempotent — a tenant that already has a Stripe
   * customer is returned unchanged with no duplicate created. Unlike the create hook this surfaces a
   * Stripe failure as an error on the payload so an admin can retry.
   */
  backfillAdminTenantStripeCustomer: AdminTenantPayload;
  /**
   * Issues the credit memo of every existing Credit-type order that has none, for credits raised before credit
   * orders issued memos, and reports every credit order: its source order, the source's live invoice, the pre-tax
   * total, the tax the Stripe reversal would credit, and the application the memo makes — applied to that invoice
   * up to what it owes, after the credits listed before it, or held for its invoice when the source has not been
   * invoiced. Each source's credit orders are listed together: those whose memo is issued (and may be owed a tax
   * step) first, then those still to issue, each in the order the source keeps its credits; a dry run proposes
   * exactly what a real run applies. Pass dryRun: true to report without writing anything, here or at Stripe; run a
   * dry run first. A dry run reads from Stripe only the shipping tax it recorded on an invoice that also taxed a flat
   * charge, for a memo crediting freight there, as a real run does. Safe to re-run: a credit order that has its memo
   * is never issued again, so a second run writes nothing — except that an issued memo whose tax was never reversed
   * against its source's live invoice (reported TO_REVERSE_TAX) has that reversal made, once, under the reference
   * the first attempt used. Credit orders the ERP
   * billed (BILLED_IN_ERP), credit orders still billed as a positive invoice (HAS_LIVE_INVOICE: void it, then
   * re-run), credits whose source order records them at another figure or not at all (SOURCE_RECORD_DISAGREES,
   * SOURCE_CREDIT_NOT_RECORDED: run the order credit back-reference backfill first), and credits whose source's invoice
   * does not yet hold payments recorded on the source order (ORDER_RECEIPTS_NOT_CARRIED: run
   * carryOrderReceiptsToInvoice on the invoice the row names, then re-run) are skipped with their reason, in a dry run
   * and a real run alike. Once one memo's step fails, no later memo of the same source order is issued or has its tax
   * reversed in that run, even when the source's invoice issued during the run; the next run retries them in order.
   * Issued invoices are never re-issued or restated, and never voided; a memo only applies credit to them.
   * tenantIds narrows the run to those tenants; omitting it reads credit orders across every tenant. A tenantIds list
   * that names no tenant (CREDIT_MEMO_BACKFILL_NO_TENANTS), or an id in it that is not a tenant id, refuses the run:
   * nothing is read, written or asked of Stripe, and errors says why. A run is walked a page at a time: each call
   * stops once half the request timeout is spent, at the end of the source order it is on, and returns complete:
   * false with a cursor in next. Call with after: null first, then again with after set to the next of the page
   * before, keeping dryRun and tenantIds the same, until complete is true; keep each page's report. A run that writes
   * has written every memo its page reports. An after this backfill did not return, or one that resumes a tenant
   * tenantIds does not name, refuses the run (CREDIT_MEMO_BACKFILL_INVALID_CURSOR).
   */
  backfillCreditMemos: CreditMemoBackfillPayload;
  /**
   * Moves the deposit every issued, non-voided invoice applied beyond its gross, before deposits were capped at
   * issue, to the customer's unapplied credit, and reports every invoice found: its order, its customer, its gross,
   * the deposit it applied, what it owed and the amount moved. Each invoice is brought from less than nothing to
   * what it owes in one write that also records the customer's DEPOSIT_OVERAGE credit, keyed by the order and the
   * invoice; staff may then apply that credit to another invoice or record a refund. The issued invoice itself is
   * never rewritten. Pass dryRun: true to report without writing anything; run a dry run first, and a run that
   * writes moves exactly what it reported. Safe to re-run: an invoice already moved no longer owes less than nothing,
   * so a second run finds nothing to move and writes nothing. tenantIds narrows the run to those tenants; omitting
   * it reads invoices across every tenant. A tenantIds list that names no tenant
   * (DEPOSIT_OVERAGE_BACKFILL_NO_TENANTS), or an id in it that is not a tenant id, refuses the run: nothing is read
   * or written, and errors says why.
   */
  backfillDepositOverages: DepositOverageBackfillPayload;
  /**
   * Repairs every material item stranded with assigned vendors but NO default vendor, by promoting
   * each one's earliest-assigned vendor through the ordinary setDefaultVendor command path.
   * Returns per-tenant counts of what it repaired.
   *
   * SAFE TO RE-RUN, AND MEANT TO BE. Selection is decided against the AGGREGATE, not the read
   * model: an item that already carries a default is never selected, so a second run reports all
   * skipped, zero repaired, and appends nothing to any stream. Re-running is the
   * intended remedy if the defect recurs — appends are not revision-pinned (tech debt
   * 19f0a487), so a concurrent setVendorMaterialCost + setDefaultVendor can
   * still re-create a mis-defaulted item after a clean run.
   *
   *
   * READ BOTH REPAIR COUNTS. repairedWithCostRows is the number now back in recipe cost
   * estimates. repairedWithoutCostRows is flag-correct but still priceless: the projection's
   * promotion arm re-flags EXISTING cost rows and does not invent one, so an item whose promoted
   * vendor has never had a cost recorded still contributes nothing to an estimate (tech debt
   * fd2ab697). Those items need a price from the grower; this mutation cannot invent one.
   * A run reporting a non-zero repairedWithoutCostRows is a PARTIAL success, and the
   * per-tenant breakdown says who has data entry left to do.
   *
   *
   * tenantIds narrows the run to those tenants — the shape to use for a single-tenant
   * verification run before the fleet-wide one. OMITTING it runs across every tenant, and
   * discovery is then an UNINDEXED FULL SCAN of the material item collection: the candidate
   * predicate matches on the vendor array, which carries no index, so only a supplied
   * tenantIds bounds the scan (via the TenantId index prefix). A fleet-wide run
   * should FOLLOW a tenant-scoped verification run, not lead.
   */
  backfillMaterialItemDefaultVendors: MaterialItemDefaultVendorBackfillPayload;
  /**
   * Records every existing credit order on the order it was raised against, for credits created
   * before creditExistingOrder recorded that back-reference itself, and reports every source order,
   * its credits, and any line already credited past its credit ceiling. Over-credited lines are
   * reported, never reversed. A credit line that cannot be proved to come from exactly one line the
   * source still carries is never guessed: it is left off the recorded lines, listed in the report of
   * the run that records the credit, and logged at Warning by that run; the credit is still recorded
   * with its amount and its other lines. A cancelled or deleted credit order is skipped, and withdrawn
   * from its source if the source records it. A credit its source already records is never recorded
   * again, but its record is brought in line with its credit order: the run names the credit lines the
   * matching proves on a record that names none (linesMapped, and linesNamed once written), leaving a
   * tied or omitted line unnamed, and restates a record whose amount or eaches differ from what the
   * credit order bills now (outOfStep), with one OrderCreditRestated per credit it changes on the
   * source; a line that then stands credited past its ceiling is reported, never reversed. So a run
   * writes for credits recorded before their lines were named, or edited while nothing kept their
   * source in sync, even when it records nothing. A restatement that does not
   * finish after a recording is reported as restatementPending with the source in errors, and the next
   * run restates it. Pass dryRun: true to report without writing anything; a dry run reports the
   * figures the write then records. Safe to re-run: a run after a write that settled writes nothing,
   * and its dry run reports creditsToRecord, creditsToWithdraw, creditsOutOfStep and linesToName as 0.
   * tenantIds narrows the run to those tenants; omitting it reads credit orders across every tenant.
   */
  backfillOrderCreditBackReferences: OrderCreditBackfillPayload;
  /**
   * Stamps trialKind = Standard on every existing trial tenant that carries no kind, so the
   * admin surfaces, the per-tenant override editor and any kind-conditional logic read a concrete
   * value instead of each re-deriving the same default. Idempotent: a tenant that already carries a
   * kind is left exactly as it is, and a re-run stamps nothing.
   *
   * Only the kind is written. trialLimits is left null — null already means "use the policy
   * default for this kind" — and restockCalcEnabled is never touched, because a backfill must
   * not retroactively flip configuration an existing tenant is already running on.
   *
   *
   * Nothing distinguishes a migrating customer's trial from an ordinary one retroactively, so EVERY
   * kind-less trial is stamped Standard, the restrictive kind. Known migrators are re-flagged
   * afterwards by hand from the Trial Tenants grid; the stamped ids are returned for exactly that
   * review.
   *
   *
   * tenantIds narrows the run to those tenants — useful for a small verification run before
   * the full one; omitted or empty runs across every trial tenant. Non-trial and deleted tenants are
   * never stamped, even when named explicitly.
   */
  backfillTrialKinds: TrialKindBackfillPayload;
  batchActivateCategories: CategoryBulkActionPayload;
  batchActivateCustomers: CustomerBulkActionPayload;
  batchActivateItems: ItemBulkActionPayload;
  batchActivatePriceGroups: PriceGroupBulkActionPayload;
  batchAddCategories: CategoryBulkActionPayload;
  /**
   * Sets one Stripe tax code on many items, or clears it when stripeTaxCode is null or blank. The code is
   * checked against Stripe's catalogue once, before any item is touched: an unknown code fails the whole
   * call with one error and changes nothing. Each item is then patched on its own, so one item's failure
   * (a missing item, say) is reported against that item and the rest are still updated. Items come back
   * in input order.
   */
  batchAssignItemStripeTaxCode: ItemBulkActionPayload;
  /**
   * Submits up to 500 production lots as Drafts in one call, each exactly as submitDraftProductionLot
   * submits one, at the id the caller chose for it. A row whose lot already exists is skipped and writes
   * nothing, so calling again with the same ids never duplicates a lot. A row whose id belongs to a deleted lot
   * is an error and writes nothing. Rows succeed or fail on their own and come back in input order. An empty
   * call or one over the cap is refused whole and writes nothing.
   */
  batchCreateDraftProductionLots: BatchCreateDraftProductionLotsPayload;
  batchDeactivateProductionLots: BatchDeactivateProductionLotsPayload;
  batchDeleteCustomers: CustomerBulkActionPayload;
  batchDeleteItems: ItemBulkActionPayload;
  batchDeletePriceGroups: PriceGroupBulkActionPayload;
  batchDeleteSiteLocations: SiteLocationBulkActionPayload;
  /**
   * Creates many items in one call. Each row takes the fields addItem takes, plus a status: ACTIVE, or INACTIVE
   * to create the item inactive, so it is never orderable. An omitted status is ACTIVE. Results come back in
   * input order, one per row. A row that fails (a SKU another item holds or an earlier row of the batch created,
   * a deleted item's SKU or ERP id, an invalid field) reports its own error, and the rows after it still run.
   */
  batchImportItems: ItemBulkActionPayload;
  batchInactivateCategories: CategoryBulkActionPayload;
  batchInactivateCustomers: CustomerBulkActionPayload;
  batchInactivateItems: ItemBulkActionPayload;
  batchInactivatePriceGroups: PriceGroupBulkActionPayload;
  /**
   * Moves the ready and start weeks of up to 500 jobs across many lots in one call. Each row carries
   * newWeekReadyDate and newWeekStartDate (Mondays, either or both), or shiftWeeks, never both. shiftWeeks
   * is a non-zero whole number of weeks from -52 to 52 that moves the job's current ready and start weeks
   * together, so its grow weeks are unchanged. A shift applies to the job's weeks when the batch runs,
   * so sending the same shift twice moves the job twice. A moved start week reschedules the job's
   * descendants. Results come back in input order, and a lot that fails does not stop the others.
   * Top-level errors mean the whole batch was rejected and nothing was written.
   */
  batchOverrideProductionJobWeeks: BatchOverrideProductionJobWeeksPayload;
  /**
   * Changes the quantity of up to 500 production lots in one call. Each row carries exactly one of
   * newQuantity, a positive whole number, or scalePercent, a non-zero percentage from -99 to 500 of the
   * lot's current quantity, rounded to the nearest whole unit with halves away from zero and never
   * below 1. Each lot follows the same rules as overrideProductionLotQuantity, so its job quantities
   * are refigured through yield. Results come back in input order, and a row that fails does not stop
   * the others. Top-level errors mean the whole batch was rejected and nothing was written: no rows,
   * more than 500 lots, a lot id sent twice, or a lot with a job outside the caller's sites. With
   * dryRun, nothing is saved and productionLots is null.
   */
  batchOverrideProductionLotQuantities: BatchOverrideProductionLotQuantitiesPayload;
  batchRemoveCategories: CategoryBulkActionPayload;
  batchUpdateCategories: CategoryBulkActionPayload;
  /**
   * Batch entry point for the wsapi-services CRM export worker. Each row carries exactly one
   * outcome (Completed / FailedTransient / FailedPermanent) for one customer. A row with a bad
   * outcome shape, an unknown customer, or a write failure lands in that row's
   * errors so one bad row never strands the rest of the cycle;
   * only an empty batch surfaces on the batch payload's errors.
   */
  batchUpdateCrmExportStatuses: CrmExportBatchPayload;
  /**
   * Batch entry point for the wsapi-services worker. Each row carries exactly one outcome
   * discriminator (Completed / FailedTransient / FailedPermanent / NotExported). Rows with bad
   * discriminator shape land in that row's MergeDevExportPayload.Errors; the
   * whole batch never rejects, so a single bad row doesn't strand the rest of the cycle.
   * Whole-batch failures (empty updates, future quota / size limits) surface on
   * MergeDevExportBatchPayload.Errors instead.
   */
  batchUpdateMergeDevExportStatuses: MergeDevExportBatchPayload;
  /**
   * Applies many single-field variation saves in one call, one at a time in the order sent, and reports
   * every row's outcome and saved values.
   */
  batchUpdateProductionRecipeVariationFields: BatchUpdateProductionRecipeVariationFieldsPayload;
  /** Applies many variation updates in one call and reports the outcome of every row. */
  batchUpdateProductionRecipeVariations: BatchUpdateProductionRecipeVariationsPayload;
  /**
   * Opens one registered firm of communityId for a typed reason and returns its registry entry, profile and
   * submission versions, recording the access on the community's access log (contract K2). Requires an effective
   * COMMUNITY_ANALYST roster entry (or platform superadmin). A refusal in an existing community, including a firm
   * outside it, is recorded and returns GROWER_BENCHMARKS_ACCESS_DENIED; an unknown community returns GROWER_BENCHMARKS_ACCESS_DENIED
   * and records nothing. A reason that is empty or only whitespace is recorded as a refusal and returns
   * GROWER_BENCHMARKS_LOOKUP_REASON_REQUIRED with no firm data.
   */
  beginGrowerBenchmarkFirmLookup: GrowerBenchmarkFirmLookupPayload;
  /**
   * Allocates many orders in one call, applying one strategy across the whole run, and reports per
   * order what it filled and what it could not. Only lines with no allocation are filled; a line that
   * already has one is left untouched and reported as skipped. An order the run can fill nothing on
   * is reported short and left unchanged.
   */
  bulkAllocateOrders: BulkAllocateOrdersPayload;
  /**
   * Atomically reassigns a single worker to multiple task assignments in one operation.
   * All reassignments are written in a single KurrentDB multi-stream append — either every
   * task is reassigned or none are persisted. No partial application on mid-batch failure.
   * The assignee must be an active user of the tenant; the choice is kept by Reapply Recipes.
   */
  bulkAssignTasks: BulkAssignTasksPayload;
  bulkCreateMaterialItem: MaterialItemBulkActionPayload;
  calculateRestockOrderQuantity: RestockCalculationPayload;
  /** Cancel an assignment. The caller's userId becomes the CancelledBy. */
  cancelAssignment: CycleCountAssignmentPayload;
  /**
   * Cancels one of the caller's queued, pending or running jobs. Items not yet started are skipped; a page the
   * worker is already handling finishes and records, and nothing after it starts. What already ran stays done. A
   * finished job is refused and left unchanged.
   */
  cancelBackgroundJob: BackgroundJobPayload;
  /**
   * Cancels the tenant's Pending or Running job. The worker stops before its next page; orders already
   * deleted stay deleted. A finished job is refused and left unchanged. A cancelled job's progress is
   * published to onBulkOrderDeleteJobProgress; a failed publish never fails the cancel.
   */
  cancelBulkOrderDeleteJob: BulkOrderDeleteJobPayload;
  /**
   * Cancels a record. Human-only; stops all further worker/human action on it except the worker's
   * markContractRecordScheduleCancelled compensation stamp.
   */
  cancelContractRecordEnrollment: ContractRecordPayload;
  /** Cancels a run that has not finished. Rows already applied stay applied. */
  cancelCorrectionRun: CorrectionRunPayload;
  /**
   * Discards a count session — marks it Canceled without posting its counted quantity as
   * production output. Legal from Running and Paused (the only exit from Paused); rejected once
   * Completed or already Canceled. Also clears the session's line's active-session pointer when
   * it still names this session, so the line is never left permanently "busy".
   */
  cancelCountSession: CountSessionPayload;
  cancelErpLoadListSession: ErpLoadListSessionPayload;
  /**
   * Cancels a conversion job: no further chunk is applied, and the chunks already applied stay. A finished job is
   * returned unchanged.
   */
  cancelFeatureFlagProductConversionJob: CancelFeatureFlagProductConversionJobPayload;
  /**
   * Compensation action: marks the current Stripe schedule for cancellation and re-runs
   * enrollment from scratch (back to Pending, generation bumped). The Stripe-side cancel of the
   * marked schedule is performed by the wsapi-services enrollment worker and reported back through
   * markContractRecordScheduleCancelled.
   */
  cancelMarkedScheduleAndReEnrollContractRecord: ContractRecordPayload;
  /**
   * Asks the worker to stop the run for good at its next safe boundary. Writes already made stay and are
   * reported; the rest stays visible as unfinished.
   */
  cancelMigrationImportRun: MigrationImportRunControlPayload;
  /**
   * Cancels an existing order-production-lot allocation, releasing the reserved quantity.
   * A no-op (no event) when the allocation is already Cancelled.
   */
  cancelProductionLotAllocation: OrderProductionLotAllocationPayload;
  cancelPurchaseOrder: VendorPurchaseOrderPayload;
  cancelRestockSession: RestockSessionPayload;
  /**
   * Cancels a scheduled transfer that has not fired yet. Refused once it has left Scheduled, including a
   * second cancel, whether sent after the first or at the same time. Not gated by the ScheduledItemTransfers
   * flag, so a schedule can always be cancelled.
   */
  cancelScheduledInventoryTransfer: ScheduledInventoryTransferPayload;
  /**
   * Cancels a scheduled future labor rate before it takes effect. Same error surface as
   * CancelScheduledOverheadRate.
   */
  cancelScheduledLaborRate: SiteLocationPayload;
  /**
   * Cancels a scheduled future overhead rate before it takes effect. Returns the post-cancel
   * aggregate state. Errors: RATE_CANCEL_CURRENT, RATE_CANCEL_HISTORICAL,
   * RATE_NOT_FOUND.
   */
  cancelScheduledOverheadRate: SiteLocationPayload;
  /**
   * Cancels the running extraction attempt and fences it immediately, so a late answer from it cannot
   * publish. Everything a previous attempt extracted, and everything reviewed on it, is untouched.
   */
  cancelSupplierPriceExtraction: SupplierPriceImportPayload;
  /**
   * Withdraws the import's approved selection, so a reviewer who approved the wrong rows can start
   * again or discard the import. Nothing is rolled back: a withdrawn approval is retired for good and
   * can never be made eligible again, and any step already committed under it stays committed.
   */
  cancelSupplierPriceImportApproval: SupplierPriceImportPayload;
  /** Cancel a task assignment. */
  cancelTask: TaskAssignmentPayload;
  /**
   * Admin repair: records on one issued, live invoice every payment and post-issue deposit on its
   * order's ledger that the invoice does not hold yet, exactly as issuing it today would have carried
   * them, and reports what it applied and what it left alone. A dry run unless dryRun is false, and a
   * live run writes only the receipts its approvedReferences name.
   */
  carryOrderReceiptsToInvoice: CarryOrderReceiptsToInvoicePayload;
  /**
   * Changes only the calling tenant's Portal Availability rule: availabilityLocationId,
   * availabilityMinGrade and includeSellableHardGoods, written together exactly as
   * supplied. A null or omitted availabilityLocationId means all locations, and an
   * availabilityMinGrade of 0 means any grade. Every other Portal setting, including the help
   * contact, keeps its saved value, even when another save changes it at the same time.
   * Staff-only and tenant-derived, like updatePortalSettings: a customer-type portal JWT is not
   * authorized. Portal settings must already have been saved. Re-submitting the current rule is a
   * no-op. There is no conflict check: when two rule changes overlap, both succeed and the later one
   * is the rule, so read portalSettings back to see what is saved.
   */
  changePortalAvailabilityRule: PortalSettingsPayload;
  /**
   * Sets how the calling tenant's portal buyers place orders: ONLINE_CHECKOUT (they check out
   * in the portal) or CALL_TO_ORDER (they are shown the order contact and told to call). The
   * method, contact name and contact phone are written together, exactly as sent. A phone is
   * required for CALL_TO_ORDER and whenever a name is given, and must be a valid phone
   * number, otherwise the call is refused and nothing is written, so the phone cannot be removed
   * while Call to order is on. The name is optional. Online checkout with a blank name and phone
   * clears the contact; Online checkout with a phone keeps it saved, so switching back needs no
   * retyping. It writes only these two settings, so no other Portal setting can change, and
   * updatePortalSettings in turn leaves them alone. Staff-only and tenant-derived: a
   * customer-type portal JWT is refused. Portal settings must
   * already have been saved. Re-submitting the current values is a no-op.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  changePortalCheckoutMethod: PortalSettingsPayload;
  /**
   * Designates or clears the calling tenant's Portal help contact: the person a Portal customer
   * is told to reach when no salesperson is assigned. Supply exactly one of set (the
   * contact to designate) or clear: true; neither, or both, is rejected and nothing is
   * written. It writes only the contact, so no other Portal setting can change, and
   * updatePortalSettings in turn leaves the contact alone. Staff-only and tenant-derived,
   * like updatePortalSettings: a customer-type portal JWT is not authorized. Portal
   * settings must already have been saved. It sends nothing and grants no access.
   * Re-submitting the current state is a no-op.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  changePortalHelpContact: PortalSettingsPayload;
  /**
   * Changes the status of a production catalog entry to ACTIVE or INACTIVE. DELETED is refused: use
   * deleteProductionCatalog.
   */
  changeProductionCatalogStatus: ProductionCatalogPayload;
  /**
   * Change the due date of an open task assignment. Refused for a completed or cancelled task.
   * The change is recorded as TaskAssignmentDueDateAssigned (AssignedBy and AssignedAt).
   */
  changeTaskAssignmentDueDate: TaskAssignmentPayload;
  changeVendorPurchaseOrderItems: VendorPurchaseOrderPayload;
  changeVendorPurchaseOrderStatus: VendorPurchaseOrderPayload;
  changeWorkOrderQuantityProduced: JobPayload;
  changeWorkOrderStatus: JobPayload;
  /** Leases up to first availability photos for the grading worker to grade, oldest first. */
  claimAvailabilityPhotoGradeRequests: ClaimAvailabilityPhotoGradeRequestsPayload;
  /** Claims a Pending/RetryRequired record for processing. */
  claimContractRecordEnrollment: ContractRecordPayload;
  /** Claims a Pending/RetryRequired installation fee for processing. */
  claimContractRecordFeeInvoice: ContractRecordPayload;
  /**
   * Leases a batch of customer messages for one channel: EMAIL rows, or SMS text rows. IN_APP and PUSH
   * are refused.
   *
   *
   * **Returns:**
   * The customer messages this worker now holds.
   */
  claimCustomerDeliveries: CustomerDeliveryClaimPayload;
  /**
   * Binds a registered device to the calling tenant, moving it out of the lobby and into the fleet.
   * The supplied serial resolves the device to a stream id via the read model, scoped to the
   * caller's own tenant: serials are not secret, but WHICH tenant a pending device is assigned to is
   * the visibility boundary, so a serial belonging to another tenant is reported identically to
   * "no such serial". The claim itself is authorized by the aggregate's own guard, which re-checks
   * the assigned tenant and compares a hash of the supplied claim code against the stored hash —
   * defense in depth on top of the read-model pre-filter. The plaintext claim code never touches the
   * read model or a Mongo query. Optionally sets the device's location ATOMICALLY in the same claim
   * (input.locationId), validated to exist and belong to the caller's tenant BEFORE the
   * append — never a second, independently-failing call.
   *
   * Claiming also enables the device's IoT Hub identity, which registration deliberately left
   * disabled. This is the point at which the device becomes able to connect, because it is the point
   * at which its data has an owning tenant to be stamped with. No key material is returned here — the
   * credential was issued once, at registration.
   */
  claimDevice: DevicePayload;
  /**
   * Leases up to batchSize load emails for the worker to send, each with the subject, body and
   * recipients to send verbatim.
   */
  claimLoadEmails: LoadEmailClaimPayload;
  /**
   * Claims one import run for the import worker, with the control its stream holds past the acknowledged
   * version. Worker only.
   */
  claimMigrationImportRun: MigrationImportRunClaimPayload;
  /**
   * Claims one preparation job for the preparation worker. A second claim inside the claim window is
   * refused as claimed. Worker only.
   */
  claimMigrationPreparationJob: MigrationPreparationJobClaimPayload;
  /**
   * Leases a batch of outbound notifications for one channel and returns them grouped into the
   * messages to send — one per notification for a recipient on immediate delivery, one per
   * recipient for a digest.
   *
   *
   * **Returns:**
   * The messages this worker now holds.
   */
  claimNotificationDeliveries: NotificationDeliveryClaimPayload;
  /**
   * Leases accepted help requests for one channel to the calling worker: requests waiting whose time has
   * come, channels whose previous lease expired, and channels whose last provider result was uncertain.
   */
  claimOnboardingHelpDeliveries: ClaimOnboardingHelpDeliveriesPayload;
  /**
   * Atomically claims up to batchSize unclaimed Pending records for the given workflow and the
   * calling tenant, oldest first, leasing each with a fresh claim token so concurrent workers do not
   * double-process it, and writing marksPosting on each from this input, true or false. A record waits
   * while an older record of the same item is claimed, POSTING, POSTED or in NEEDS_REVIEW; FAILED and
   * PROCESSED records hold nothing, and records of one item in one claim come oldest first. A Pending
   * claim older than the claim lease is never leased again: claimed with marksPosting it returns to
   * unclaimed PENDING (nothing was sent under it), otherwise the claim moves it to NEEDS_REVIEW with its
   * claim kept ("claim lease expired; check NAV"). Pass marksPosting only from a worker that calls
   * markErpWriteBackPosting before every send; wsapi cannot check that promise. After a rollback hold is
   * released, an unclaimed record recorded before the rollback ended and not reconciled since it started
   * also moves to NEEDS_REVIEW instead of being claimed. While the tenant's write-back hold is on, returns
   * no records. One claim runs at a time for a tenant and workflow: a call made while another claim for
   * the same tenant and workflow is still running returns no records at once, without waiting, and the
   * worker claims again on its next poll. Worker-facing: wsapi-services calls this via the
   * CallWorkSuite typed client, processes the returned records against Nav, then calls
   * markProcessed / markFailed per record.
   */
  claimPendingErpWriteBacks: ErpWriteBackClaimPayload;
  /**
   * Leases up to batchSize POSTING and POSTED records of the given workflow and the calling tenant
   * to a verify step, oldest first, each with a fresh claim token and claimedAt. It takes, when the record
   * has no live claim (none, or one older than the claim lease), a POSTED record and a POSTING record NAV
   * accepted at once, and a POSTING record NAV has not accepted once the settle wait setting has passed
   * since its latest send (lastPostingAt). The same claim lock, write-back hold and rollback quarantine
   * apply as for claimPendingErpWriteBacks. Worker-facing: the verify step looks each record up in NAV by
   * its navDocumentNo, then calls markErpWriteBackPosted, markErpWriteBackProcessed,
   * markErpWriteBackNeedsReview or releaseErpWriteBack under the returned token.
   */
  claimPostedErpWriteBacks: ErpWriteBackClaimPayload;
  /**
   * W4. WORKER ONLY. Claims due jobs for the token's tenant: status PENDING or FAILED_TRANSIENT,
   * nextRetryAt null or past, claim lapsed. Each claim lasts 5 minutes. A COPY job whose PO now has an
   * uncosted line, an unlinked vendor or a PO number Ramp refuses (A2's rule) is recorded NOT_COPIED
   * instead of being returned. Empty when the connection is not CONNECTED or has no entity.
   */
  claimRampPurchaseOrderCopies: ClaimRampPurchaseOrderCopiesPayload;
  /**
   * Claims the company's oldest outstanding print batch for a worker and moves it to RENDERING,
   * handing back the statements to render in the order they must be rendered. Worker-facing.
   */
  claimStatementPrintBatch: StatementPrintBatchPayload;
  /** WorkerService. Leases up to batchSize pending batches (the claimLoadEmails lease pattern). */
  claimWhatsNewEmailBatches: WhatsNewEmailClaimPayload;
  cleanCustomers: Array<CustomerErpIdPayload>;
  cleanItems: Array<ItemErpIdPayload>;
  clearActiveCountSession: ProductionLinePayload;
  /**
   * Removes one tenant's own setting on a flag, so the flag follows the tenant's products, its trial and
   * everyone's default. Every other tenant's setting is kept as it is. Clearing a tenant with no setting writes
   * nothing.
   */
  clearAdminFeatureFlagTenantOverride: AdminFeatureFlagPayload;
  /** Clears a production category's labor cost per unit, leaving it with no configured rate. Production items that were inheriting it resolve to no labor cost until one is set again. */
  clearCategoryLaborCost: ProductionCategoryPayload;
  /**
   * Removes a per-customer commission rate override, so the customer falls back to
   * the user's default rate.
   */
  clearCustomerCommissionOverride: CommissionConfigPayload;
  /**
   * Clears this customer item's Shipping UOM override back to "inherit the item's default".
   * Clears both override rungs — the id-based shippingUomId and the retired
   * shippingConfigCategoryCode string — and is rejected as a no-op when neither is set.
   */
  clearCustomerItemShippingConfigCategoryCode: CustomerItemPayload;
  /**
   * Clears the typed note for a single NoteContext on one of
   * a customer's locations. Rejected as a no-op when that location/context has no current note.
   */
  clearCustomerLocationNote: CustomerPayload;
  /**
   * Clears the customer-level typed note for a single
   * NoteContext. Rejected as a no-op when that context has
   * no current note.
   */
  clearCustomerNote: CustomerPayload;
  /**
   * Removes a recipient address from one SendGrid suppression list (bounces / blocks / spam_reports /
   * global unsubscribes) so future sends to it are attempted again. The list belongs to the one
   * platform SendGrid account behind WorkSuite's system API key, so the clear lifts that suppression
   * for every tenant whose mail goes through that account, not only the caller's tenant. It is never a
   * tenant-local change. It sends no email, re-queues nothing and leaves every send's history as recorded.
   * Callers: any authenticated principal that is not a customer-portal user (the RestockWriter policy,
   * which checks no role). Every such caller may clear Bounces and Blocks from one of its own sends.
   * Unsubscribes and SpamReports record the recipient's own request to stop mail, so only a superadmin
   * may clear them, on both paths below; any other caller gets EMAIL_SUPPRESSION_LIST_REQUIRES_SUPERADMIN
   * before SendGrid is called.
   * The list comes from an explicit listType, or is resolved from a recorded dropReason
   * ("Bounced Address"→bounces, "Blocked"→blocks, "Unsubscribed Address"→unsubscribes, "Spam Reporting
   * Address"→spam_reports).
   * Without emailSendId this is the explicit clear of any address, which only a superadmin may
   * make; any other caller gets EMAIL_SUPPRESSION_SEND_REQUIRED before SendGrid is called, after the list
   * rule above. With emailSendId it is a contextual clear, refused before SendGrid is called unless
   * that send is one of the caller tenant's own, the address is one of its recipients, and the send's
   * recorded delivery reason for that recipient names the requested list (codes
   * EMAIL_SUPPRESSION_SEND_NOT_FOUND and EMAIL_SUPPRESSION_NOT_RECORDED_ON_SEND).
   * cleared is true only when SendGrid confirmed the delete. A non-2xx answer below 500 is a known
   * refusal. No answer, or a 5xx, is EMAIL_SUPPRESSION_CLEAR_OUTCOME_UNKNOWN: the address may or may not
   * have left the list, and the caller checks before trying again.
   */
  clearEmailSuppression: ClearEmailSuppressionPayload;
  /**
   * Dismisses every finished job in the caller's queue, listed jobs included, and returns how many it dismissed.
   * Jobs still queued, pending or running are left alone.
   */
  clearFinishedBackgroundJobs: ClearFinishedBackgroundJobsPayload;
  /**
   * Clears a single inventory note from a key (item + location + grade) by its note id. Rejected
   * as a no-op when the key has no note with that id. Other notes on the key are untouched.
   */
  clearInventoryNote: InventoryItemPayload;
  clearItemContainerConfigOverride: ItemPayload;
  /** Clears a production item's labor-cost override, reverting it to inherit from its category. */
  clearItemLaborCost: ProductionItemPayload;
  /**
   * Clears the item-level typed note for a single
   * NoteContext. Rejected as a no-op when that context has
   * no current note.
   */
  clearItemNote: ItemPayload;
  clearJobGrowWeeksOverride: ProductionLotPayload;
  clearJobLinksOverride: ProductionLotPayload;
  clearJobPlannedHoursOverride: ProductionLotPayload;
  clearJobPlantsPerPotOverride: ProductionLotPayload;
  /** Clears a Load's Dock. Allowed only while the Load is Planning or Loaded. */
  clearLoadDock: LoadPayload;
  /** Clears the Load's miles, source and itinerary while it is Planning or Loaded. */
  clearLoadMiles: LoadPayload;
  /** Clears the Load's pickup window while it is Planning or Loaded. */
  clearLoadPickupWindow: LoadPayload;
  /** Clears the planned arrival time of one route stop on a Load; refused when Delivered or deleted. */
  clearLoadStopPlannedTime: LoadPayload;
  /**
   * Clears the CALLING user's own profile picture. Resolves the caller's own directory entry from the
   * JWT and reports "no changes" (framework no-op) when no picture is currently set. No admin path.
   */
  clearMyProfileImage: UserPayload;
  clearOnHandAdjustmentQueue: MassUpdatePayload;
  /** Clears the order's drop-ship destination. Refused once the order is Cancelled or Deleted. */
  clearOrderDropShipDestination: OrderPayload;
  /**
   * Clears the tenant's routing entry for one doc-type, reverting it to the built-in default
   * recipient contact type. Not idempotent: clearing a doc-type that has no tenant override
   * (never set, or already cleared) is a no-op that returns an EntityCommandHasNoChangesError
   * in `errors` with a null `orderEmailRecipientRouting`, rather than succeeding silently.
   * Mirrors setOrderEmailRecipientRouting.
   */
  clearOrderEmailRecipientRouting: OrderEmailRecipientRoutingPayload;
  /**
   * Clears an order's No tax, so its sales tax estimate and its invoice include tax again. This mutation
   * never calculates tax, so a stored estimate reads as out of date until it is refreshed. Refused as
   * setOrderNoTax is: ORDER_NO_TAX_STATUS_LOCKED, ORDER_NO_TAX_CREDIT_ORDER, ORDER_INVOICED and
   * ORDER_NO_TAX_NOT_AVAILABLE_TO_PORTAL. Clearing an order that is not marked No tax returns the
   * no-changes error and records nothing.
   */
  clearOrderNoTax: OrderPayload;
  /**
   * Clears the order-level typed note for a single
   * NoteContext. Rejected with a specific
   * "No <context> note exists to clear" ValidationError when that context has no current note.
   */
  clearOrderNote: OrderPayload;
  /** Undoes jobs' started and done marks (This week, Undo). A job with neither writes nothing. */
  clearProductionJobsProgress: ProductionJobsProgressPayload;
  /**
   * Clears a production lot's customer back to none (spec lot). Rejected when the lot has an active
   * order allocation — clearing it would silently make the lot allocatable under an order it is not
   * actually free for.
   */
  clearProductionLotCustomer: ProductionLotPayload;
  /**
   * Clears a production lot's own customer group. Always allowed — no allocation guard, since
   * allocations bind to customers, not groups. A no-op when the lot has no group.
   */
  clearProductionLotCustomerGroup: ProductionLotPayload;
  /**
   * Clears a task event's job-level exclusion — the undo for
   * TaskAssignmentMutation.RemoveProductionTaskEventFromJob. There is no
   * addProductionTaskEventToJob counterpart to Material/Space's re-add path: a task event's
   * job presence is driven by its TaskAssignment, not by a job-level attachment list the grower
   * re-populates directly, so this mutation only lifts the exclusion. The task event returns when
   * the next recipe reapply applies its taskEventIds Added change, or via task regeneration when a
   * scalar field change is also selected and applied.
   */
  clearProductionTaskEventJobExclusion: ProductionLotPayload;
  /**
   * Removes a Draft session's own cap on one Kit. The current component availability is read fresh
   * under the caller's own scope, and the clear is refused when it cannot prove the Kit's supported
   * maximum, since unavailable is never zero. The read's scope, time and conversion are saved with the
   * clear as provenance only. Entered counts are never changed.
   */
  clearRestockSessionKitCap: RestockSessionKitPlanPayload;
  /** @deprecated Use clearSpaceDimensionOverride, which supports customer-scoped overrides. */
  clearSpaceCategorySiteOverride: ProductionSpaceCategoryPayload;
  clearSpaceDimensionOverride: ProductionSpaceCategoryPayload;
  /**
   * Correction: clears a route stop's currently recorded outcome so it can be re-recorded.
   *             Refused with ORDER_INVOICED when it would write to an order with a live invoice. Void the invoice first.
   *             A refusal leaves the whole stop unchanged.
   */
  clearStopOutcome: DeliveryPayload;
  clearTaskEventDirectCost: ProductionTaskEventPayload;
  clearTaskEventLaborTypeTag: ProductionTaskEventPayload;
  clearTaskEventThroughput: ProductionTaskEventPayload;
  /**
   * Superadmin escape hatch (T30): clears a tenant's mirrored Stripe subscription linkage —
   * subscription id, mirrored schedule id, subscription items, current period end, and last-payment
   * date/amount — and returns billing status to NONE, so the tenant renders the self-serve subscribe
   * flow again. Reads the LIVE Stripe subscription as authority (never the mirror, which may be
   * stale — the same T23 split-brain concern ReconcileStaleScheduleMirror exists for) and
   * allows the clear ONLY when Stripe reports the subscription canceled or incomplete_expired — the
   * permanently-terminal statuses — or has no record of the subscription at all. Every other live
   * status (active/trialing/past_due/unpaid/paused, or one Stripe adds later) refuses with that
   * status named in the error: an allow-list, so an unrecognised status fails closed rather than
   * permitting a destructive clear. A tenant with no mirrored subscription id has no subscription to
   * check against Stripe, so the live read is skipped entirely. The clear itself still runs on that
   * path: any stranded schedule id, subscription items, period end, last-payment date/amount, or
   * non-NONE status is reset. Only a tenant with none of those left is a no-op success. Retains the
   * Stripe customer id and the rate card (monthly/quarterly/annual amounts, currency, and the active
   * cadence) so the tenant can re-subscribe immediately.
   */
  clearTenantBillingLinkage: AdminTenantPayload;
  /**
   * Clears a tenant's platform-billing rate card, returning it to the unoffered/no-rate-card state
   * (superadmin) — the counterpart to setTenantBillingRateCard, which cannot express an all-null card.
   * Every cadence is reset to not-offered, the currency to the default, and the active cadence cleared,
   * so the tenant sees the contact-your-representative alert again. Rejected with a validation error
   * when the tenant has an active Stripe subscription — the rate card cannot be pulled out from under a
   * live sub. Audited on the tenant stream like every other rate-card change; a tenant already unoffered
   * is a no-op.
   */
  clearTenantBillingRateCard: AdminTenantPayload;
  /**
   * Read-model-only reset of the calling tenant's Merge.dev integration data — the supported
   * "reset before recreate" step (reset → reconnect → re-sync). Deletes ONLY the tenant's
   * Merge-populated MongoDB read-model documents (customers + locations / contacts / sales-person,
   * vendors, item summaries incl. GL mappings, MergeDevAccount,
   * orders + line items, MergeDevPayment, and the Merge sync-state / connection / sync-metrics
   * docs). It does NOT delete KurrentDB streams, reset projection checkpoints, or trigger a replay;
   * on reconnect the importer creates fresh random-id entities the live projection writes forward.
   * Idempotent and strictly scoped to the calling tenant. SuperAdmin only — a destructive
   * tenant-wide purge. See docs/runbooks/clear-tenant-integration-data.md.
   */
  clearTenantIntegrationData: ClearTenantIntegrationDataPayload;
  /**
   * Clears this tenant's online-payment ceiling override (T28, superadmin), returning it to the
   * system-resolved cap. A tenant with no override set is a no-op.
   */
  clearTenantOnlinePaymentMaxAmountOverride: AdminTenantPayload;
  /**
   * Closes an open collection cycle identified by input.cycleId and clears the owning community's open cycle in the
   * same atomic append (contracts C12 and D9). Restricted to effective COMMUNITY_ANALYST roster holders and
   * platform superadmins; returns GROWER_BENCHMARKS_ACCESS_DENIED when cycleId is unknown and GROWER_BENCHMARKS_CYCLE_NOT_OPEN when
   * the cycle is already closed.
   */
  closeGrowerBenchmarkCycle: GrowerBenchmarkCyclePayload;
  /**
   * Combines the loser into the survivor. The loser becomes inactive and hidden, its ERP id, import
   * ids, lookup code and name become aliases of the survivor, and its contacts, ship-to locations and
   * billing addresses are added to the survivor, except a contact or ship-to picked "same as" its
   * suggested pair, which folds into the survivor's as an alias. Customer items on the loser's ship-tos
   * move with them, and its customer-level ones carry over to the survivor as the customer SKU picks say.
   * Every conflict from customerCombinePreview needs a pick. Refused while the
   * tenant syncs customers from its ERP, while the loser has portal invites never accepted, when two
   * ship-tos made the same as one map an item differently, and when the combine would save more changes
   * than one append can hold. The loser's Active portal buyers, which the preview lists in
   * portalBuyersMoving, move to the survivor in the same append; only an admin may combine while
   * anyone is listed there. With
   * addKeptCustomerToLimitedStaff, the staff users the preview lists in limitedStaff get the
   * survivor in the same append; only an admin may ask for that while anyone is listed.
   */
  combineCustomers: CombineCustomersPayload;
  /**
   * Combines the loser into the survivor. The loser becomes an Inactive alias that keeps its own
   * SKU, UPC, ERP id and lookup code; the survivor records the loser's identity and takes the
   * resolved values. Refused while the loser holds stock, while any conflicting field has no pick,
   * when a pick names a field that is not a conflict or names one twice, or when the loser carries an
   * ERP id other than the survivor's own (its own or one it absorbed in an earlier combine) and the
   * tenant syncs items from its ERP: keep the item with the ERP id instead. In the same write the
   * loser's price levels, customer items, kit lines, production links, favorites entries and portal
   * cart lines move to the survivor; the loser's forecast mapping is cleared, and copied to the
   * survivor only when the survivor has none. A price level or default customer item that collides
   * with the survivor's is a conflict that needs a SURVIVOR or LOSER pick. A price group where the two
   * items' levels disagree on the volume pool refuses the combine with ITEM_COMBINE_PRICE_LADDER_CONFLICT.
   */
  combineItems: CombineItemsPayload;
  /**
   * Combines the loser catalog into the survivor in one atomic write. The loser becomes inactive and hidden
   * and keeps its genus, series and color, so a lot import that names them lands on the survivor. Its items
   * move to the survivor; an item pair of one category and one sales item is combined into the survivor's
   * item; its recipes move to the survivor or, on a collision, the recipe that loses goes inactive; every
   * variation link to the loser moves to the survivor; every job on the loser, open or posted, moves to the
   * survivor with its recipe, and each lot keeps its own production item. Every conflict from
   * productionCatalogCombinePreview needs a pick.
   */
  combineProductionCatalogs: CombineProductionCatalogsPayload;
  /**
   * Combines the loser into the survivor on the same plant and pot. The loser becomes inactive and hidden;
   * the survivor takes the picked sales link and labor cost and gains the loser's task events; the
   * loser's forecast mapping lines move to the survivor. Every conflict from
   * productionItemCombinePreview needs a pick. Lots are not changed: a lot stamped with the loser
   * posts to the survivor's sales link.
   */
  combineProductionItems: CombineProductionItemsPayload;
  /**
   * Combines the loser ship-to into the survivor ship-to of the same customer. The loser is removed and
   * becomes one alias on the survivor (its id, ship-to address id, Code and name), so imports carrying
   * any of them land on the survivor, and the customer items on the loser move to the survivor or, where
   * the survivor maps the same item, retire. Every conflict from shipToCombinePreview needs a pick.
   * Refused for a tenant switched off, while a restock session, delivery schedule, replenishment rule or
   * site map names the loser, while a loser key that differs from the survivor's feeds code-keyed data,
   * and when the combine would save more than one append can hold.
   */
  combineShipTos: CombineShipTosPayload;
  /**
   * Combines the loser sub-location into the survivor, two Active siblings of the same type on one
   * site. The loser becomes an Inactive alias that keeps its own name and ErpId; the survivor records
   * the loser's identity and takes the resolved pick sequence and config. Refused while anything still
   * references the loser (history, stock, open tasks, devices, users and the other blockers the
   * preview lists), and while any conflicting field has no pick.
   */
  combineSubLocations: CombineSubLocationsPayload;
  /**
   * Combines the loser into the survivor. The loser becomes an Inactive alias that keeps its own name
   * and ERP id and refuses every change except the revert; the survivor records the loser's identity and
   * takes the picked values; the default moves to the survivor when the loser holds it; and every
   * customer and ship-to on the loser moves to the survivor. Orders that carry their own terms keep the
   * loser's. Every conflict from termsCombinePreview needs a pick. Refused when either side is not
   * Active or is combined, when net days or discount days differ, when the picked name is used by other
   * payment terms, and when the combine would save more changes than one save can hold.
   */
  combineTerms: CombineTermsPayload;
  /**
   * Commits exactly the reviewed batch of one GrowPoint staged entity for the caller's tenant.
   * The reviewed rows (row ids with the versions read from growPointStagedRowVersions) are
   * compared with current staging before anything is queued: a row edited, removed or added since
   * review rejects the whole commit with those row ids. On accept the commit is stored as one
   * record with status QUEUED and the entity's import worker is started through the existing
   * RunNow path, which also engages the staged-collection import lock for the run.
   */
  commitGrowPointStagedRows: CommitGrowPointStagedRowsPayload;
  commitSpaceRebalance: CommitSpaceRebalancePayload;
  /**
   * Complete a task. On the transition from non-Completed -> Completed, atomically
   * emits a cross-aggregate CountMaterialItem with
   * MaterialItemCountType.Set against the MaterialItem aggregate so
   * the inventory snapshot reflects the worker's recorded count. Implemented as a
   * single KurrentDB.Client.KurrentDBClient multi-stream append via
   * WorkSuite.Domain.CycleCountAssignment.CompleteAssignmentTaskWithCount:
   *
   * * Serial identical retries are deterministic no-ops: the second call
   *   reads the already-Completed aggregate, IfChangedPer produces
   *   zero primary events, and the dynamic multi-stream builder
   *   short-circuits the secondary MaterialItemCounted.
   * * Primary-success + secondary-failure can no longer leave the cycle-count
   *   permanently uncounted — both writes are atomic in one KurrentDB
   *   transaction (multi-stream append).
   * * Both streams share the same client-IdempotentKey-derived
   *   EventMetadata for retry/correlation audit (cycle-2 Codex F3).
   *
   *
   * Concurrent completes (B25-A). The primary stream opts into optimistic
   * concurrency (WithOptimisticConcurrency()): the multi-stream append is
   * pinned to the assignment stream's revision observed at state-load time. Two
   * TRULY CONCURRENT requests against the same task both read the non-Completed
   * aggregate at the same revision; KurrentDB serializes the atomic multi-stream
   * appends and rejects the loser with WrongExpectedVersion (surfaced as
   * EntityAlreadyExists), rolling back BOTH its primary
   * AssignmentTaskCompleted and its secondary MaterialItemCounted.
   * The rejected writer is then reconciled against the now-Completed aggregate by
   * ReconcileAlreadyAppliedCompletion:
   *
   *
   * * an identical concurrent retry resolves to idempotent success — exactly one
   *   AssignmentTaskCompleted and one MaterialItemCounted are recorded;
   * * a concurrent retry carrying a DIFFERENT quantity surfaces a clean
   *   EntityAlreadyExists error (never a raw WrongExpectedVersionException),
   *   and the MaterialItem ledger is never double-counted.
   */
  completeAssignmentTask: CycleCountAssignmentPayload;
  completeCountSession: CountSessionPayload;
  /**
   * Completes a delivery (Dispatched -> Delivered). Refused while any order on the load
   *             has not yet reached Picked.
   */
  completeDelivery: DeliveryPayload;
  /**
   * Marks a DEPOSIT export posted in the accounting platform, with the Merge-side journal entry id. Called by
   * the wsapi-services worker after a successful journal entry create. Refused on any row that is not an armed
   * Deposit export; a Deposit row's failures are reported through the same
   * markMergeDevExportFailedTransient / markMergeDevExportFailedPermanent every export uses.
   */
  completeDepositExport: MergeDevExportPayload;
  /** Marks a check done. Completing it again changes nothing. Worker only. */
  completeDuplicateCheckRequest: DuplicateCandidateIdsPayload;
  /**
   * Completes an OAuth connect: validates the signed state against the caller, exchanges the
   * authorization code for tokens, resolves the mailbox address, and persists the connection to
   * the calling user's aggregate. The tenant and user are taken from the caller's JWT — never from
   * input.
   */
  completeM365MailboxConnect: M365MailboxConnectPayload;
  /**
   * Exchanges the Merge.dev public_token returned by the frontend Merge Link widget for a durable
   * account_token, then persists the integration via the existing UpsertMergeTenantIntegration
   * command. The public_token is single-use and is never stored.
   */
  completeMergeLink: TenantPayload;
  /**
   * Finishes enrollment by proving the authenticator app works: verifies the code against the
   * secret from CancellationToken) and enables the method on the caller's
   * login. Returns the recovery codes, which are shown once and never again.
   *
   *
   * **Returns:**
   * The new state and the recovery codes, or why the code was refused.
   */
  completeMyMultiFactorEnrollment: CompleteMyMultiFactorEnrollmentPayload;
  /**
   * Marks a PAYMENT export created in the accounting platform, with the Merge-side payment id. Called by
   * the wsapi-services worker after a successful payment create. Refused on any row that is not an armed
   * Payment export; a Payment row's failures are reported through the same
   * markMergeDevExportFailedTransient / markMergeDevExportFailedPermanent every export uses.
   */
  completePaymentExport: MergeDevExportPayload;
  /**
   * TENANT ADMIN, FLAG. Burns the state, exchanges the code at POST {apiBase}/developer/v1/token
   * (HTTP Basic client_id:client_secret), reads the entities (GET /developer/v1/entities), records the
   * connection, and writes the tokens encrypted to the tenant's token document (never to an event).
   * Status becomes CONNECTED. Refuses with RAMP_NO_ENTITIES when Ramp lists no entity, before anything is
   * recorded. Also used to reconnect after RECONNECT_NEEDED; a
   * reconnect keeps the picked entity, and refuses with RAMP_ACCOUNT_MISMATCH when that entity is not in
   * the new token's entity list (a different Ramp account; disconnect first).
   * Codes: RAMP_NOT_ENABLED, RAMP_NOT_CONFIGURED, RAMP_CONNECT_STATE_INVALID, RAMP_TOKEN_EXCHANGE_FAILED,
   * RAMP_REFRESH_TOKEN_MISSING, RAMP_NO_ENTITIES, RAMP_ACCOUNT_MISMATCH.
   */
  completeRampConnect: RampConnectionPayload;
  /** Complete a task assignment. Transitions from InProgress to Completed. */
  completeTask: TaskAssignmentPayload;
  /**
   * Completes a sender's verification from the link (or raw token) pasted out of the SendGrid
   * confirmation email: extracts the token, calls SendGrid verify-by-token with our API key (no
   * SendGrid login), then re-polls and records the status through the existing refresh path.
   */
  completeTenantEmailSenderVerification: TenantEmailSenderPayload;
  /**
   * Runs the module's post-reset steps for the tenant, after the worker has deleted its data. PRODUCE has none
   * today. Never rebuilds or replays a projection. Idempotent. createdFrom / createdTo as for
   * prepare.
   */
  completeTenantModuleReset: TenantModuleResetCompletion;
  /**
   * Finishes an invitation for the person who signed in as the login it was provisioned for,
   * with no password change: the recovery path when the setup link has expired but the account
   * already exists. The server proves the identity end to end — the JWT subject must be the
   * login the send leg recorded, the token must be minted for one of the invitation's
   * applications (or the Work Suite application), and a current FusionAuth read must show that
   * login active, at the recipient's address, stamped to the invitation's tenant and scope, and
   * registered to every invited application. Then the invitation is marked used and the
   * directory row it names is linked to that login in one atomic append. Never writes to
   * FusionAuth, never sends email, never unlocks anything. Gated per invitation tenant by the
   * INVITE_SIGN_IN_COMPLETION feature flag. Repeating the call for an invitation this login
   * already completed reports completed: true. Errors carry stable codes:
   * INVITE_SIGN_IN_COMPLETION_UNAVAILABLE, INVITE_NOT_AVAILABLE, INVITE_SETUP_PENDING,
   * INVITE_IDENTITY_UNBOUND, INVITE_ACCOUNT_MISMATCH, INVITE_ACCOUNT_INACTIVE,
   * INVITE_ACCOUNT_SCOPE_MISMATCH, INVITE_FORCED_RESET_REQUIRES_SETUP_LINK,
   * INVITE_DIRECTORY_LINK_CONFLICT, SERVICE_UNAVAILABLE. nextAction is the invitation's
   * re-evaluated next step either way.
   */
  completeUserInviteAsSignedInUser: CompleteUserInviteAsSignedInUserPayload;
  /** Computes the Load's driving miles from its origin site through its served stops in route order and writes them with source Map and that itinerary, while it is Planning or Loaded. */
  computeLoadMiles: LoadPayload;
  /**
   * Confirms the Stripe-side void of a fee a human already voided here. Idempotent per record, so
   * a worker retry after a crash appends nothing.
   */
  confirmContractRecordFeeVoid: ContractRecordPayload;
  /**
   * Confirms a MaterialAllocationStatus.Requested allocation, moving it to
   * MaterialAllocationStatus.Confirmed and recording the confirmed quantity.
   * Rejected if the allocation is not currently Requested.
   *
   *
   * **Returns:**
   * The confirmed allocation, or validation errors.
   */
  confirmMaterialAllocation: MaterialAllocationPayload;
  /**
   * Returns the code that was texted, completing the exchange and making the number the one this
   * user's notification texts are sent to. A wrong code, an expired one, or a code submitted when
   * none is outstanding are each refused with their own reason.
   *
   *
   * **Returns:**
   * The caller's directory entry, now verified, or the reason the code was refused.
   */
  confirmMyPhoneVerification: UserPayload;
  /**
   * Confirms a held production entry: applies it to the job through the same path as
   * overrideProducedQuantity, as entered or with an edited quantity or split (validated the same way),
   * and keeps the submitted values, the confirmed values, and who confirmed and when. Refused when the job was
   * posted (Post Jobs) after the entry was made. Confirming an entry already confirmed changes nothing.
   */
  confirmProducedQuantityEntry: ProductionLotPayload;
  confirmReceipt: VendorPurchaseOrderPayload;
  /**
   * Connects the current tenant to OrderEase. The supplied client key/secret are VALIDATED with a
   * live server-side grant against OrderEase (POST /api/v3/Auth/grant, platform X-Integration-Key
   * from server config); on success the credentials plus the returned refresh token #1 are stored
   * per-tenant via the UpsertOrderEaseTenantIntegration command, and a connection-status payload is
   * returned. The client secret and refresh token are never echoed back.
   */
  connectOrderEaseIntegration: OrderEaseConnectionPayload;
  consumeProductionJobsMaterials: ConsumeProductionJobsMaterialsPayload;
  /**
   * Converts today's per-customer flag overrides into products, changing no customer's flags. With dryRun true it
   * returns the report over every tenant and writes nothing: each tenant's products, the own settings removed, made
   * settings only or kept, its Learning modules before and after, and every flag whose answer would change, which
   * must be none. With dryRun false it ensures the product catalog by name, creating what is missing and never a
   * duplicate, runs the dry run again and starts a conversion job over the tenants with something to convert, which
   * the worker then applies chunkSize tenants at a time (25 to 50, default 25). It is refused, starting nothing,
   * while the report finds any difference, when no tenant has anything to convert, or while another job is open.
   * jobId is null on a dry run and on a refusal.
   */
  convertFeatureFlagOverridesToProducts: ConvertFeatureFlagOverridesToProductsPayload;
  /**
   * Corrects the acknowledged quantity on one or more lines of an order that has ALREADY been
   * acknowledged (Acknowledged or Picked), WITHOUT re-firing the acknowledge status transition.
   * Rejects at Shipped and at every terminal/quarantine status; a pre-acknowledge order goes
   * through the updateAcknowledgedQuantity mutation instead.
   */
  correctAcknowledgedQuantity: OrderPayload;
  /**
   * Asks this session's counting device to set its running total to an absolute value. Writes
   * nothing itself: the device owns the count and reports the result back, so a successful response
   * means the command was accepted for delivery, never that the count has already changed.
   */
  correctCountedTotal: CountCorrectionPayload;
  /**
   * Corrects one quote, addressed by price id and the revision the caller reviewed. The whole
   * tuple is restated, so a royalty-only correction re-states the unchanged amount and date and
   * still advances the revision.
   */
  correctMaterialPrice: MaterialPriceWritePayload;
  /**
   * Internal wrong-customer correction (Bonnie-flagged UI). Atomically creates a
   * replacement order for newCustomerId and a credit for the source order's
   * customer from the source order's data via the multi-stream save — all-or-nothing.
   * The source order is left untouched. Purpose-built and intentionally specific: this is
   * NOT a generic duplicate-order or bulk-submit surface. A newCustomerId combined into
   * another customer is refused with CUSTOMER_COMBINED.
   */
  correctOrder: CorrectOrderPayload;
  countMaterialItem: MaterialItemLocationQuantityPayload;
  createAdHocVendorPurchaseOrder: VendorPurchaseOrderPayload;
  /**
   * Adds a product to the WorkSuite product catalog: a name no other product uses, and the flags it turns
   * on. The product takes the catalog position after the last one.
   */
  createAdminWorkSuiteProduct: AdminWorkSuiteProductPayload;
  createAllocationTemplate: AllocationTemplatePayload;
  /**
   * Creates a Stripe Customer Billing Portal session for the calling tenant's own Stripe customer,
   * returning to returnUrl (tenant-scoped, not superadmin — the surface a tenant
   * uses to manage its own subscription in T7). A customer-type portal JWT is rejected. Returns the
   * hosted portal URL.
   * Restricted to Admin, Finance or superadmin callers; any other staff caller gets a payload error.
   */
  createBillingPortalSession: StripeBillingPortalSessionPayload;
  /**
   * Creates a Stripe Customer Billing Portal session for ANOTHER tenant's Stripe customer (superadmin),
   * so staff can enter or correct that client's billing address and payment method on its behalf before
   * enrollment. The tenant is the explicit tenantId argument, never the caller's own tenant from
   * the sign-in. Refused when that tenant has no billing read model, when it has no linked Stripe
   * customer, or when Stripe is not configured. Returns the hosted portal URL in portalUrl; on a
   * refusal portalUrl is null and errors carries the reason. Which management features the
   * portal then offers comes from the Stripe account's default portal configuration, an ops setting this
   * mutation deliberately does not pin.
   */
  createBillingPortalSessionForTenant: StripeBillingPortalSessionPayload;
  createBlockingRule: BlockingRulePayload;
  /**
   * Creates the commission configuration for a user. The user must exist in the
   * tenant's directory, be active, and hold the Sales or Sales Manager role. A user
   * can have only one commission configuration; creating a second one is rejected.
   */
  createCommissionConfig: CommissionConfigPayload;
  createConsolidationPreview: CreateConsolidationPreviewPayload;
  /**
   * Creates a run of a registered correction for a tenant. Its rows are the rows given, each with exactly the
   * correction's row-shape fields, or, when none are given, what the correction's Find returns. Refused when the
   * correction is unknown (UNKNOWN_CORRECTION), a guard does not hold (CORRECTION_GUARD_BLOCKED),
   * or the rows are invalid (CORRECTION_ROWS_INVALID). The caller is the run's requester.
   */
  createCorrectionRun: CorrectionRunPayload;
  /**
   * Create a new cycle-count assignment. Server-side fan-out: each input item is
   * joined against MaterialItemLocationQuantityDocument to produce
   * one task per bin where the material is stocked. The supervisor nominates
   * items, the server materializes the (item × bin) tuples.
   */
  createCountAssignment: CycleCountAssignmentPayload;
  createCustomer: CustomerPayload;
  createErpLoadListSession: ErpLoadListSessionPayload;
  /**
   * Creates a forecast: Monday-snapped 1-53 week window, unique active name, customer and programs
   * required, Regions level only, with the tenant's comp settings captured into LockedConfig.
   */
  createForecast: ForecastPayload;
  /**
   * Opens a Draft submission version for a reporting unit owned by the caller's member firm in communityId, or
   * returns the existing open Draft unchanged (contract C6 and C7).
   */
  createGrowerBenchmarkSubmissionDraft: GrowerBenchmarkSubmissionPayload;
  /** Creates a new inventory item at the specified location. */
  createInventoryItem: InventoryItemPayload;
  /**
   * Renders the order's resolved document PDF — the invoice, or the acknowledgement when the order
   * is Acknowledged or Picked (doc type derived server-side via
   * OrderEmailDocTypeResolution, which resolves the Invoice kind for an order carrying a live
   * issued invoice) — and creates a
   * prefilled draft (with the PDF attached) in the calling user's connected M365 mailbox, returning
   * the draft's Outlook webLink. Worksuite sends nothing — draft creation only. The order must
   * belong to the caller's resolved tenant (a foreign-tenant orderId is rejected as not-found), and
   * the mailbox token is fetched for the caller's own JWT identity; neither tenant nor user id is
   * ever accepted from input. input.docType is an optional, additive override of the
   * resolved default (OrderEmailDocTypeResolution — the order's live invoice, else its
   * status): omitted, behavior is byte-for-byte what it was before this field existed; supplied, it
   * is honored only when the order accepts it
   * (OrderEmailDocTypeResolution.AllowsExplicit — always its own resolved default, and
   * otherwise per OrderStatusExtensions.AllowsExplicitOrderEmailDocType), else the draft
   * fails with DOC_TYPE_NOT_ALLOWED_FOR_STATUS. A QUOTE is accepted only for a draft
   * (Initialized or Open) order and renders the seeded Quote template.
   */
  createInvoiceEmailDraft: CreateInvoiceEmailDraftPayload;
  createJob: JobPayload;
  /**
   * Creates a kit for the caller's tenant. The tenant always comes from the JWT. The kit is open to
   * all Sites unless siteIds limits it, and every nested kit must be available at every Site the new
   * kit is.
   */
  createKit: KitPayload;
  /** @deprecated Use SiteLocation mutations instead. */
  createLocation: LocationPayload;
  createMakeToOrderPlan: CreateMakeToOrderPlanPayload;
  createMakeToOrderPlanForLines: CreateMakeToOrderPlanForLinesPayload;
  createMaterialItem: MaterialItemPayload;
  /** Create a new MovementOrder in Created state. Emits MovementOrderCreated. */
  createMovementOrder: MovementOrderPayload;
  /**
   * Starts a Stripe Checkout session so the signed-in tenant can pay for its own platform subscription
   * at the price set for the chosen billing frequency (tenant-scoped — the account is the caller's own,
   * taken from the sign-in, never supplied). The amount is set on the server from the account's agreed
   * pricing; the client never supplies a charge. ACH is offered at any amount; card is offered only up
   * to the T28 effective card-eligibility ceiling (T21) — no charge is rejected by amount. This is
   * available only when the account has no active subscription and the chosen frequency has a
   * published price. Returns the hosted Checkout URL to send the payer to.
   * Restricted to Admin, Finance or superadmin callers; any other staff caller gets a payload error.
   */
  createMySubscriptionCheckoutSession: StripeCheckoutSessionPayload;
  /**
   * CSV-import upsert: addresses a tag by its tagCode, creating it when the tenant has none
   * and updating it in place when it does.
   */
  createOrUpdateTagByTagCode: MaterialItemPayload;
  /**
   * Creates a Draft OTA release from one exact build of the firmware releases index. The build must be listed in a
   * schema-2 index, which names its application image; that image's path, size, digest and URL are recorded with the
   * release and never read from the index again. A build is released once, so creating it twice is refused.
   */
  createOtaRelease: OtaReleasePayload;
  /** Adds a new system payment processor. Always created Inactive — activate it separately. */
  createPaymentProcessor: PaymentProcessorPayload;
  /**
   * Provisions a customer-portal (Buyer) user through the unified WorkSuiteUser
   * path — the single write path for portal users. Creates one directory user carrying
   * Portal, scopes it to the customer via AssignUserCustomer, then
   * emits a linked, portal-scoped UserInvite (LinkedUserId = the new user,
   * UserType.Customer + CustomerId). The wsapi-services invite worker then creates
   * the FusionAuth login stamped with the wsCustomerId/wsUserType=customer claims
   * and sends the set-password email, so the buyer signs in customer-scoped — no separate portal
   * user record. The auto-link of the FusionAuth user back onto this directory entry is chained
   * by MarkUserInviteCompleted exactly as for staff invites.
   *
   * Failure atomicity. Every command is validated (and the email-in-use guard run)
   * before any event is appended, so malformed input cannot persist a half-provisioned
   * user. The directory user and its customer scope are then written in ONE atomic append on the
   *  stream (), so a
   * fault can never leave an Active, scope-less Portal user. The invite is a second stream and
   * KurrentDB appends are single-stream-atomic, so it cannot join that append — that is the only
   * residual boundary, and it is reached solely with fully validated input.
   *
   *
   * Gated like createUserInvite:  excludes portal
   * callers, and the caller must be a platform superadmin JWT OR hold the Admin role in its own
   * directory entry (the superadmin arm lets a superadmin bootstrap the first portal user into an
   * empty tenant). The customer scope comes from the input; the tenant comes from the caller's JWT.
   *
   *
   * The requested registrations are ignored: a portal user's invite always gets the Work
   * Suite application with the portal-user role, for every caller, platform superadmin included.
   * Below platform superadmin an email at silverfern.com or silverfern.app is refused with
   * SILVER_FERN_ADDRESS_NOT_ALLOWED before any event is written.
   */
  createPortalUser: UserPayload;
  /** Creates a new production catalog entry. */
  createProductionCatalog: ProductionCatalogPayload;
  createProductionItem: ProductionItemPayload;
  createProductionLine: ProductionLinePayload;
  createProductionLot: ProductionLotPayload;
  createProductionLotAsyncImportJob: AsyncImportJobPayload;
  createProductionMaterialEvent: ProductionMaterialEventPayload;
  createProductionRecipe: ProductionRecipePayload;
  createProductionRecipeWithVariation: ProductionRecipePayload;
  createProductionSpaceEvent: ProductionSpaceEventPayload;
  createProductionTaskEvent: ProductionTaskEventPayload;
  createProductionTrigger: ProductionTriggerPayload;
  createPromotionRule: PromotionRulePayload;
  createPurchaseOrderAllocation: PurchaseOrderAllocationPayload;
  /**
   * Creates a report. While the company's SavedViews flag is on, the new report is a saved view owned by its
   * creator and visible only to them until they share it. While the flag is off, it is open to everyone in the
   * company, as every report was before saved views.
   */
  createReport: ReportPayload;
  createReportFolder: ReportFolderPayload;
  /**
   * Creates a new report schedule. A run-once INVOICE schedule for an order (the Send invoice dialog's system
   * send) first keeps the order's live invoice's pay link fresh: a new link when the current one is dead or has
   * fewer than 10 days left, so the email and PDF the worker renders print a link that works.
   */
  createReportSchedule: ReportSchedulePayload;
  /** Creates a new report template. */
  createReportTemplate: ReportTemplatePayload;
  createReserveRule: ReserveRulePayload;
  /**
   * Creates a Restock 2.0 session and immediately hands the heavy hydrate/populate/persist work
   * to the asynchronous RestockSessionCreationWorkflowWorker. The mutation appends
   * SessionCreated + SessionCreationStarted in one atomic batch and returns the
   * freshly-created (non-terminal, Populating phase) session — sub-second p95 even for
   * ~10k (location × item) sessions. Progress and terminal state are owned by the worker and the
   * projection (which drives the onRestockSessionBatchProgress contract); the PWA observes
   * completion via that subscription rather than blocking on this call.
   */
  createRestockSession: RestockSessionPayload;
  /**
   * Makes one order of an acknowledged standing order. A standing order of a customer combined into
   * another makes its order for the kept customer, at the ship-to the combine moved or folded its own
   * into, so the kept customer's terms, discount and entry unit apply. Every line gets a new id: line ids
   * sent by the caller are ignored, and lines follow the Master's by position, Item, SKU and name.
   */
  createScheduledOrder: MasterOrderPayload;
  createSiteLocationAsyncImportJob: AsyncImportJobPayload;
  /**
   * Creates a site map mapping a customer location and program to the grower site that produces for
   * it, with an optional exclude-from-distribution flag. Rejected when a mapping for the same location
   * and program already exists for the tenant.
   */
  createSiteMap: SiteMapPayload;
  /**
   * Starts a Stripe Checkout session (subscription mode) for the tenant at the rate-card amount for the
   * chosen cadence (superadmin). The charge is priced inline against the configured product and set
   * server-side. ACH is offered at any amount; card is offered only up to the T28 effective
   * card-eligibility ceiling (T21) — no charge is rejected by amount. Returns the hosted Checkout URL
   * to hand the tenant.
   */
  createSubscriptionCheckoutSession: StripeCheckoutSessionPayload;
  /**
   * Opens a workspace for one existing purchasing vendor. The vendor is the tenant's own selection and is
   * never taken from, or changed by, anything a document's header says about its manufacturer.
   */
  createSupplierPriceImport: SupplierPriceImportPayload;
  /**
   * Creates a produce tag. A tag IS a material item, so this creates a material item that carries
   * a tag identity — one row, in the ordinary MaterialItem collection, that every existing
   * inventory and vendor-cost path already understands.
   */
  createTag: MaterialItemPayload;
  /**
   * Simplified task creation mutation for the Events App.
   * Resolves the TaskEventType name from its ID and creates a TaskAssignment. A blank assignee is the caller;
   * any other assignee must be an active user of the tenant.
   */
  createTask: TaskAssignmentPayload;
  /**
   * Creates a new task assignment for a given task event. A named assignee must be an active user of the
   * tenant; the choice is kept by Reapply Recipes.
   */
  createTaskAssignment: TaskAssignmentPayload;
  createTaskEventType: TaskEventTypePayload;
  /**
   * Mints a Stripe Account Session for the calling tenant's connected account with
   * components enabled, returning the client_secret worksuite-pwa
   * initializes ConnectJS with. The five components this surface exists for are
   * ACCOUNT_ONBOARDING, TAX_SETTINGS and TAX_REGISTRATIONS — everything a tenant
   * with no Stripe Dashboard needs to become tax-ready without leaving WorkSuite — plus
   * ACCOUNT_MANAGEMENT and NOTIFICATION_BANNER, which are REQUIRED rather than optional:
   * the 2026-09-08 ruling (Stripe-liable, no-dashboard connected accounts; Atlas standard
   * 65316676845a4a8a84dcb51eb21ec55f) obligates both, since Stripe otherwise has no Dashboard surface
   * to show account details or required-action notices on.
   * Restricted to Admin, Finance or superadmin callers; any other staff caller gets a payload error.
   */
  createTenantStripeAccountSession: StripeAccountSessionPayload;
  /**
   * Creates the calling tenant's Stripe connected account and records it on the tenant aggregate.
   * IDEMPOTENT in two layers: the aggregate is read first and, when an account is already linked, NO
   * Stripe call is made and the existing state is returned unchanged; behind that, the entity
   * function Tenant.CreateTenantStripeConnectedAccount refuses a second link, and the Stripe
   * call itself carries a tenant-scoped idempotency key. That belt-and-braces matters because
   * Stripe's controller.stripe_dashboard.type is immutable — a duplicate account could not be
   * reconfigured, only abandoned.
   *
   * The account is created with controller properties (Accounts v1; the type parameter is
   * deprecated) in the Stripe-liable, no-Stripe-Dashboard configuration ruled 2026-09-08 (prod-power:
   * Kevin, Nathan, Chris; Atlas standard 65316676845a4a8a84dcb51eb21ec55f) — losses.payments:
   * stripe, fees.payer: account, requirement_collection: stripe,
   * stripe_dashboard.type: none. The account is created in the country on the company profile:
   * a blank or US country gets a US account requesting card_payments, transfers and
   * us_bank_account_ach_payments; Canada gets a Canadian account in cad requesting
   * card_payments, transfers and acss_debit_payments (pre-authorized debit);
   * any other country is refused before Stripe is called. A post-create read-back guard verifies the
   * account Stripe actually returns still carries these four values and refuses to attach a deviating account to the
   * tenant, logging Critical instead — controller properties are immutable per account, so a wrong
   * account can never be corrected in place, only recreated.
   *
   * Restricted to Admin, Finance or superadmin callers; any other staff caller gets a payload error.
   */
  createTenantStripeConnectedAccount: TenantStripeConnectPayload;
  /**
   * Creates a user in the tenant's directory. The email must not belong to another
   * active user in the tenant. Roles may be empty; they can be assigned later.
   *
   * Re-adding a previously DELETED user REVIVES them: when the email matches a tombstone in this
   * tenant, the original aggregate is restored on its existing stream instead of a second one being
   * started, and the payload returns that original userId — which may differ from the one the
   * caller supplied. Deactivated users are untouched by this: deactivation frees the email and a
   * re-add there still creates a new entry, exactly as before.
   */
  createUser: UserPayload;
  /**
   * Tenant-scoped invite creation for the worksuite app's Administration > Users page
   * ("Send invite"). Unlike the SuperAdmin-only Admin* console surface, this is callable
   * by any tenant user whose WorkSuiteUser directory entry is Active and holds the Admin role;
   * the tenant comes from the caller's JWT. Optionally carries the WorkSuiteUser to auto-link
   * when the worker reports provisioning completion.
   *
   * The server decides the stored registrations. For a customer invite
   * (userType: CUSTOMER) the requested registrations are ignored and the invite always gets
   * the Work Suite application with the portal-user role, for every caller. For a staff invite from
   * a caller below platform superadmin, every registration must be the Work Suite application with
   * roles from the staff allow-list (an empty role list is stored as user); anything else is
   * refused with INVITE_REGISTRATION_NOT_ALLOWED. Below platform superadmin a recipient at
   * silverfern.com or silverfern.app is refused with SILVER_FERN_ADDRESS_NOT_ALLOWED.
   * Both refusals happen before any event is written.
   */
  createUserInvite: UserInvitePayload;
  /**
   * Tenant-scoped BULK invite creation for the worksuite app's Administration > Users page:
   * bulk-inviting staff (TENANT) users, rather than one at
   * a time via createUserInvite. Reuses the SuperAdmin-only adminCreateUserInvites'
   * input and payload shapes (CreateUserInvitesInput / AdminCreateUserInvitesPayload)
   * and its per-email create-and-fold aggregation, but the tenant comes from the caller's JWT —
   * never a client-supplied tenantId — and the same in-code Admin gate as every other
   * tenant invite mutation applies.
   *
   * Every recipient email in the batch runs through the SAME three per-recipient guards
   * createUserInvite itself runs — already-has-an-account, already-has-a-pending-invite,
   * and already-has-an-expired-invite-awaiting-resend — so a rejected email is reported in
   * errors without blocking the rest of the batch. The dedicated alreadyInvited list
   * stays empty on this path: a pending duplicate surfaces through errors instead, with the
   * same message createUserInvite uses, rather than the SuperAdmin path's separate bucket
   * (a convenience of ITS batch-partition query, not a payload guarantee).
   *
   *
   * Unlike the SuperAdmin path, this mutation never pre-creates or auto-links a directory row for
   * a recipient with no existing one: an explicit linkedUserId is passed through as-is
   * (capped, like the SuperAdmin path, to a single-email batch), exactly as the singular
   * createUserInvite already allows. An empty recipient list is rejected outright, and a batch of more than 200 recipients
   * is rejected outright too, with no partial work either way.
   *
   *
   * The stored registrations follow the same server-set rule as createUserInvite,
   * decided once for the whole batch: allow-listed for a caller below
   * platform superadmin, where a refusal fails the whole request with no invite created. The
   * Silver Fern address rule runs per recipient: below platform superadmin a recipient at
   * silverfern.com or silverfern.app is reported in errors and the other recipients are
   * still invited.
   *
   *
   * Staff invites only: userType must be TENANT and customerId must be blank. A
   * CUSTOMER request is refused outright (BULK_INVITE_CUSTOMER_NOT_SUPPORTED), and so is a
   * TENANT request carrying a customerId (BULK_INVITE_CUSTOMER_ID_NOT_SUPPORTED), both
   * before anything is written, because this path never creates the directory user a customer-portal
   * login needs (it would be invisible on Administration > Users and could not be deactivated) and a
   * staff invite never carries a customer scope. Use createPortalUser to invite a customer
   * portal user.
   */
  createUserInvites: AdminCreateUserInvitesPayload;
  createVendor: VendorPayload;
  createVendorPurchaseOrder: VendorPurchaseOrderPayload;
  /**
   * Creates a volume pool. The code must be unique in the tenant (case-insensitive, trimmed) and is
   * immutable afterwards; a collision is returned as a payload error, never as a silent merge onto the
   * existing pool.
   */
  createVolumePool: VolumePoolPayload;
  createWorkOrder: JobPayload;
  createWsapiImport: WsapiImportPayload;
  /**
   * Creates one new Credit-type order from an existing order ("correct order with
   * credit"). Omit lines to credit the whole order; provide it to credit specific
   * lines/quantities. The credit links back to its source via creditedFromOrderId and a
   * V1.OrderCreditedFromSource audit event, and the source order records the credit — its
   * lines, eaches, amount and reason — through a V1.OrderCreditRecorded event
   * appended in the same atomic write, so the source lists it under credits. No line can be
   * credited past its creditableEaches, which counts every earlier credit of the line; a
   * whole-order credit is refused once any of its lines has been credited. Deliberately a dedicated
   * mutation (not the generic duplicate flow) per architecture guidance for order/money corrections.
   */
  creditExistingOrder: OrderPayload;
  /** Adds a contact to the caller's own customer and answers the buyer-safe account. */
  customerPortalAddContact: CustomerPortalAccountPayload;
  /** Adds an item to an existing shopping cart for the authenticated tenant. */
  customerPortalAddItemToShoppingCart: ShoppingCartPayload;
  /**
   * Adds line items to an order for the authenticated tenant.
   * @deprecated Use customerPortalPlaceOrder, which places the order with its lines in one write.
   */
  customerPortalAddLineItems: OrderPayload;
  /** A buyer cancels their own order and is told authoritatively where that order stands. */
  customerPortalCancelOrder: CustomerPortalCancelOrderPayload;
  /**
   * Ends a customer-portal checkout for the caller's own portal order and returns the order, whose
   * status says what happened.
   * @deprecated Use customerPortalPlaceOrder, which places the order with its lines in one write.
   */
  customerPortalCompleteCheckout: OrderPayload;
  /**
   * Creates a new favorites list for the authenticated tenant. Staff-only: a customer-type
   * portal JWT is rejected with a CUSTOMER_PORTAL_UNAUTHORIZED error and no event is
   * written — favorites lists are tenant-wide quick-order lists administered by staff.
   */
  customerPortalCreateFavoritesList: FavoritesListPayload;
  /**
   * Creates a customer-portal user, backed by the unified WorkSuiteUser aggregate.
   * Staff-only: a customer-type portal JWT is rejected with CUSTOMER_PORTAL_UNAUTHORIZED and
   * no event is written. Routes through the single shared PortalUserProvisioning
   * write path (Portal role + customer scope in one atomic append + a linked portal
   * UserInvite), so the customer must exist in the tenant and a FusionAuth login is
   * provisioned by the wsapi-services worker exactly as for the unified createPortalUser.
   *
   * Facade boundaries (see the @deprecated reason). The unified model has no free-form role
   * and a single display name, so the legacy Role string is ignored (the user is the Portal
   * role), FirstName/LastName are composed into the unified FullName, the
   * server generates the user id (the legacy caller-supplied PortalUserId is ignored), and a
   * customer scope is always required (Tenant-type portal users are no longer supported here).
   *
   *
   * Below platform superadmin an email at silverfern.com or silverfern.app is refused with
   * SILVER_FERN_ADDRESS_NOT_ALLOWED before any event is written.
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (createPortalUser / updateUserFullName + assignUserCustomer / deactivateUser) instead.
   */
  customerPortalCreatePortalUser: PortalUserPayload;
  /** Creates a new shopping cart for the authenticated tenant. */
  customerPortalCreateShoppingCart: ShoppingCartPayload;
  /**
   * Deactivates a customer-portal user, backed by the unified WorkSuiteUser aggregate.
   * Staff-only: a customer-type portal JWT is rejected with CUSTOMER_PORTAL_UNAUTHORIZED and
   * no event is written — this prevents a portal buyer from triggering an irreversible deactivation.
   * Maps onto the unified DeactivateUser command; an already-inactive user is rejected,
   * matching the legacy contract.
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (createPortalUser / updateUserFullName + assignUserCustomer / deactivateUser) instead.
   */
  customerPortalDeactivatePortalUser: PortalUserPayload;
  /**
   * A buyer deletes their own empty draft order: an order still Initialized with no line items, such as the
   * one left behind when checkout starts and the tenant then switches to Call to order. It is the same soft
   * delete as staff deleteOrder (same command and event) and writes nothing else.
   */
  customerPortalDeleteEmptyOrder: OrderPayload;
  /**
   * Soft-deletes a favorites list for the authenticated tenant. Staff-only: a customer-type
   * portal JWT is rejected with a CUSTOMER_PORTAL_UNAUTHORIZED error and no event is written.
   */
  customerPortalDeleteFavoritesList: FavoritesListPayload;
  /**
   * Initializes a new order from a shopping cart for the authenticated tenant.
   * @deprecated Use customerPortalPlaceOrder, which places the order with its lines in one write.
   */
  customerPortalInitializeOrder: OrderPayload;
  /**
   * A buyer's whole checkout in ONE write: the order is created with its lines, its server-decided money and
   * Open when the tenant checks out Open or the customer synchronizes orders, and Submitted otherwise.
   * A refusal writes nothing. Replaces
   * customerPortalInitializeOrder, customerPortalAddLineItems and
   * customerPortalCompleteCheckout, and runs every check those three run.
   */
  customerPortalPlaceOrder: CustomerPortalPlaceOrderPayload;
  /**
   * Removes one of the caller's own customer's contacts and answers the buyer-safe account.
   * Refused when the contact is not the caller's, or is the customer's only Primary or only A/P
   * contact.
   */
  customerPortalRemoveContact: CustomerPortalAccountPayload;
  /**
   * Stores a buyer's reviewed retail price drafts for its own customer as one background save, one item per row,
   * and answers the stored save. The background jobs worker then saves the rows in input order, at most 50 rows
   * per call; read its progress with customerPortalRetailPriceSave. The customer is always the one the
   * buyer's token names; no input carries a customer, program, location, currency, label or fee. Every check that
   * needs no write runs first, and a refusal stores nothing: a tenantId that is not the caller's own, a caller who
   * is not a portal buyer, more than 2,000 rows, the portal off or the buyer's customer not Active or combined,
   * buyer retail price editing off (Pre-pricing or "Buyers can edit their retail prices"), and any row whose own
   * fields can't be saved (RETAIL_PRICE_ROWS_INVALID, with invalidRows).
   */
  customerPortalSaveRetailPrices: CustomerPortalSaveRetailPricesPayload;
  /**
   * ANONYMOUS, rate-limited customer self-registration. Provisions a customer-portal (Buyer) user
   * through the SAME unified WorkSuiteUser composition the admin
   * createPortalUser mutation uses (PortalUserProvisioning): one directory
   * user carrying Portal + the customer scope, plus a single linked,
   * portal-scoped UserInvite so the wsapi-services worker creates the FusionAuth login with
   * the wsCustomerId/wsUserType=customer claims and sends the set-password email.
   *
   * Authorization. The caller is unauthenticated, so there is no JWT to scope the tenant —
   * the tenant is an explicit argument (the worksuite-pwa resolves it from its host/config exactly
   * as the other customer-portal entry points pass tenantId). Two gates stand in for the
   * missing JWT, both read straight from the tenant's PortalSettings KurrentDB stream (no
   * projection lag):  and
   *  must both be true. This reads
   * PortalEnabled directly rather than through the shared  gate —
   * that helper's staff bypass (!user.IsCustomer) would incorrectly ALLOW an anonymous
   * caller, which has no  at all. Both gates return the SAME
   * neutral, tenant-id-free error so an anonymous probe cannot distinguish "portal disabled" from
   * "self-registration disabled". When either gate fails the mutation is rejected with no event
   * written.
   *
   *
   * Untrusted input is server-bounded. Because the caller is unauthenticated, the FusionAuth
   * application + roles the new user is registered to are NOT taken from client input — they are
   * fixed server-side from  (portal application id +
   * a non-privileged role), so a caller cannot request registration into an arbitrary application
   * or a privileged role. The client-supplied CustomerId is additionally checked for
   * tenant-scoped existence inside the shared provisioning composition, so a buyer cannot scope
   * their new user to a customer they have no relationship with. Abuse resistance: per-client rate
   * limiting () plus the shared
   * active-email-in-use guard. The registrant's own (sanitized) email is recorded as the directory
   * user's and invite's CreatedBy, since a self-registered user is its own provisioner.
   * An email at silverfern.com or silverfern.app is always refused with
   * EMAIL_CANNOT_REGISTER before any event is written: logins at those domains come only
   * from Silver Fern.
   *
   *
   * Live portal sign-in for a self-registered user additionally requires the wsapi-services
   * FusionAuth claim-stamping worker (PR-B); this mutation only writes the unified shape that
   * worker consumes.
   */
  customerPortalSelfRegister: UserPayload;
  /**
   * Sets a favorites list's active state for the authenticated tenant, without deleting it.
   * Staff-only: a customer-type portal JWT is rejected with a CUSTOMER_PORTAL_UNAUTHORIZED
   * error and no event is written. active: false moves an Active list to Inactive;
   * active: true moves an Inactive list back to Active. A Deleted list is refused.
   */
  customerPortalSetFavoritesListActive: FavoritesListPayload;
  /**
   * The signed-in portal buyer's Pay and Pay selected: starts Stripe hosted Checkout for one or several of the
   * buyer's own customer's open invoices, all in one currency, and returns the URL to redirect to with the payment
   * attempt's id. The server prices every invoice; only invoice ids are accepted. An id that is not the buyer's own
   * payable invoice, of this tenant, answers SELECTION_INVALID, the same however it is wrong. Starting again while
   * the session is open returns the same session, or a newly priced one.
   */
  customerPortalStartInvoiceCheckout: CustomerPortalInvoiceCheckoutStartPayload;
  /** Atomically increments and returns the next order number for the authenticated tenant. */
  customerPortalUpdateAndGetNextOrderNumber?: Maybe<NextOrderNumberPayload>;
  /**
   * Replaces one of the caller's own customer's contacts with the input and answers the buyer-safe
   * account. Refused when the contact is not the caller's, or when the edit would change the type
   * of the customer's only Primary or only A/P contact.
   */
  customerPortalUpdateContact: CustomerPortalAccountPayload;
  /**
   * Updates an existing favorites list for the authenticated tenant. Staff-only: a customer-type
   * portal JWT is rejected with a CUSTOMER_PORTAL_UNAUTHORIZED error and no event is written.
   */
  customerPortalUpdateFavoritesList: FavoritesListPayload;
  /** Updates the status of an order for the authenticated tenant. */
  customerPortalUpdateOrderStatus: OrderPayload;
  /**
   * Updates a customer-portal user's name and customer scope, backed by the unified
   * WorkSuiteUser aggregate. Staff-only: a customer-type portal JWT is rejected with
   * CUSTOMER_PORTAL_UNAUTHORIZED and no event is written. The legacy single-shot update is
   * decomposed onto the unified stream (UpdateUserFullName + AssignUserCustomer) in
   * one atomic append; a fully unchanged request surfaces the unified "command data has no changes"
   * error, and an update against a deactivated user is rejected — matching the legacy contract.
   *
   * Facade boundaries. The free-form Role string and UserType on the legacy
   * input have no unified representation and are ignored; FirstName/LastName are
   * composed into the unified FullName.
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (createPortalUser / updateUserFullName + assignUserCustomer / deactivateUser) instead.
   */
  customerPortalUpdatePortalUser: PortalUserPayload;
  /** Updates an existing shopping cart for the authenticated tenant. */
  customerPortalUpdateShoppingCart: ShoppingCartPayload;
  deactivateConfigCategory: ConfigCategoryPayload;
  deactivateContainerConfig: ContainerConfigPayload;
  deactivateCustomerGroup: CustomerGroupPayload;
  deactivateCustomerItem: CustomerItemPayload;
  /** @deprecated Use deleteCustomerType. The active/inactive toggle is being retired in favor of delete (AI Helm fd75fc05) -- this mutation is deprecated but still functional. */
  deactivateCustomerType: CustomerTypePayload;
  /**
   * Soft-deactivates a customer upgrade. It stays on the customer with an Inactive status and no longer
   * attaches to new order lines; existing order lines are unchanged.
   */
  deactivateCustomerUpgrade: CustomerPayload;
  /** Deactivates an entry: orders can no longer pick it, and orders that carry it keep it. */
  deactivateFlatChargeType: FlatChargeTypePayload;
  /** Marks an upgrade Inactive (soft-deactivate); the definition is retained for replay/history. */
  deactivateItemUpgrade: ItemPayload;
  /** Deactivates a processor. Already-inactive is a no-op. */
  deactivatePaymentProcessor: PaymentProcessorPayload;
  deactivateProductionCategory: ProductionCategoryPayload;
  deactivateProductionLine: ProductionLinePayload;
  deactivateProductionLot: ProductionLotPayload;
  deactivateProductionPlan: ProductionPlanPayload;
  deactivateProductionSpaceCategory: ProductionSpaceCategoryPayload;
  deactivateProductionSpaceType: ProductionSpaceTypePayload;
  deactivateSizeUom: SizeUomPayload;
  deactivateTerms: TermsPayload;
  /**
   * Deactivates the user. Deactivated users keep their history but no longer appear
   * as active directory entries.
   *
   * Admin/SuperAdmin gated: revoking somebody's access is an authorization decision, and an
   * ungated deactivate is a denial-of-service against every colleague in the tenant.
   *
   *
   * Self-deactivation is refused, exactly as self-delete is, and for a sharper reason: it strips
   * the caller's own Admin authority in the same stroke, so nobody short of a platform superadmin
   * could undo it. The refusal is enforced in the domain against event-sourced aggregate state, so
   * it holds while the read model is behind.
   */
  deactivateUser: UserPayload;
  deallocatePurchaseOrderAllocation: PurchaseOrderAllocationPayload;
  /**
   * Saves one row's decision against the workspace revision the reviewer read. A decision and the
   * money review are separate saves: deciding a line is a skip, or that it belongs to a material
   * already in the catalog, is a different act from accepting its price.
   */
  decideSupplierPriceImportRow: SupplierPriceImportPayload;
  /**
   * Retires a device from the owning tenant's fleet. Scoped to the owning tenant, and terminal: a
   * decommissioned device stays in the fleet history but cannot be renamed, re-credentialed or
   * re-claimed — this release has no command that returns one to the lobby.
   *
   * The device's IoT Hub identity is deleted outright, so a retired unit cannot keep talking. Deletion
   * rather than disablement because the status is terminal and hub device count is a quota: leaving a
   * tombstone per retired device would consume that quota permanently.
   */
  decommissionDevice: DevicePayload;
  /**
   * Creates or updates one holiday reference row for the calling tenant. The row's stream is keyed by
   * the (holiday name, year) pair, so redefining the same holiday for a year updates it in place.
   * Rejected when the (year, ISO week, date) triple is inconsistent per the W1 calendar, or when the
   * Forecast flag is disabled (no event written).
   */
  defineForecastHoliday: HolidayPayload;
  /**
   * Soft-deletes a parent company. Refused with a typed PARENT_COMPANY_HAS_TENANTS error
   * while any tenant still references it.
   */
  deleteAdminParentCompany: AdminParentCompanyPayload;
  deleteAdminTenantIntegration: AdminTenantPayload;
  deleteAdminTenantPricingPage: TenantPricingPagePayload;
  /**
   * SuperAdmin-only bulk purge of every staged GrowPoint document for the caller's tenant — the
   * backend for the PWA "Delete All" button. Runs a single up-front import-lock check across all
   * GrowPointStagedEntity members (GrowPointImportLock); if any of the
   * tenant's import workers is running the whole operation is refused and nothing is deleted.
   * Otherwise it fans out over every enum member calling the same per-entity
   * DeleteStagedEntityForTenantAsync plumbing (each scoped to TenantId == user.TenantId)
   * and returns the aggregated per-entity results plus the grand total deleted.
   */
  deleteAllStagedEntityDocuments: DeleteAllStagedEntitiesResultData;
  deleteAllocationTemplate: AllocationTemplatePayload;
  deleteBlockingRule: BlockingRulePayload;
  /**
   * Deletes a Carrier and, in the same atomic append: removes every Driver it employs, clears
   * CarrierId off every Vehicle naming it, and clears CarrierId (and DriverId, for the drivers just
   * removed) off every Load naming it — matching the pwa reference slice's deleteCarrier.
   */
  deleteCarrier: LogisticsCarrierPayload;
  deleteCustomer: CustomerPayload;
  /**
   * Soft-deletes a customer group. Deleting an already-deleted group is an idempotent no-op,
   * not an error. Unlike deleteCustomerType, there is no in-use guard here -- no
   * customer can yet be assigned to a group (that FK is a separate, blocked-on-this Helm task),
   * so there is nothing to block on.
   */
  deleteCustomerGroup: CustomerGroupPayload;
  /**
   * Soft-deletes a customer type (AI Helm fd75fc05). Blocked while any customer is still
   * assigned to the type -- the in-use guard runs BEFORE the entity
   * transition and returns a payload error naming the assigned-customer count, never an
   * exception, and never silently clears the assignments. Deleting an already-deleted type is
   * an idempotent no-op, not an error.
   */
  deleteCustomerType: CustomerTypePayload;
  deleteDeliverySchedule: DeliverySchedulePayload;
  /** Deletes a Driver, clearing it off every Load naming it in the same atomic append. */
  deleteDriver: DriverPayload;
  deleteErpLoadListSession: ErpLoadListSessionPayload;
  deleteErpLoadListUser: ErpLoadListUserPayload;
  /** Removes exactly ONE published file. */
  deleteFirmwareFile: DeleteFirmwareFilePayload;
  /**
   * Soft-deletes a forecast (creator-only, guarded in the aggregate). The forecast drops out of
   * queries and no longer counts toward name uniqueness, but its stream and audit history remain.
   */
  deleteForecast: ForecastPayload;
  /**
   * Soft-deletes one holiday reference row (status flipped to Deleted; the query hides it). Rejected
   * when the Forecast flag is disabled (no event written).
   */
  deleteForecastHoliday: HolidayPayload;
  /**
   * SuperAdmin-only purge of the caller tenant's GrowPoint iteration/error records — the backend
   * for the PWA Integrations "Delete Errors" button. Runs a single DeleteManyAsync on the
   * Synchronization Iterations collection (database: Synchronization, collection: Iterations)
   * filtered on TenantId == user.TenantId AND the GrowPoint scope — never a tenant-less delete.
   *
   * The GrowPoint scope is Description contains "GrowPoint" OR Entity beginning with
   * GrowPoint. The first branch is exactly the population the Errors tab shows (its
   * synchronizationIterations query is filtered client-side by description contains
   * "GrowPoint"), so the tab empties after deletion; the second branch also clears any GrowPoint
   * worker iteration whose free-text description happens not to contain the word — including future
   * worker names the deployed enum has not learned yet, since Entity is persisted as its raw
   * string. Both branches are GrowPoint-specific, so non-GrowPoint synchronization iterations and
   * other tenants are never touched. Returns the deleted-document count.
   */
  deleteGrowPointIterations: DeleteGrowPointIterationsResultData;
  deleteItem: ItemPayload;
  /** Deletes a characteristic from the list. Items that use it still name it. Deleting a deleted characteristic changes nothing. */
  deleteItemCharacteristic: ItemCharacteristicPayload;
  /** Deletes a value from the pick list. Items that hold it still name it. Deleting a deleted value changes nothing. */
  deleteItemCharacteristicValue: ItemCharacteristicPayload;
  /**
   * Soft-deletes a kit and strips every line that referenced it from the other kits in the same
   * tenant, atomically. The referencing kits are resolved from the read model.
   */
  deleteKit: KitPayload;
  /** Deletes a Load, cascading (in the same atomic append) to every LoadLine on it and to its Delivery. A Dispatched load is refused with LOAD_DISPATCHED_NOT_DELETABLE and a Delivered one with LOAD_DELIVERED_NOT_DELETABLE; nothing is written. */
  deleteLoad: LoadPayload;
  deleteLoadLine: LoadLinePayload;
  /**
   * Deletes a Dock, clearing it off every Load naming it (in every Load status) in the same
   *             atomic append.
   */
  deleteLogisticsDock: LogisticsDockPayload;
  /**
   * Deletes a route and, in the same atomic append, clears RouteId off every Load naming
   *             it and RouteStopId off every LoadLine on those loads.
   */
  deleteLogisticsRoute: LogisticsRoutePayload;
  /**
   * Soft-deletes a master order from any status, the way deleteOrder deletes an order. Idempotent.
   * Refused with MASTER_ORDER_HAS_LIVE_SCHEDULED_ORDERS while any weekly order is not Deleted.
   */
  deleteMasterOrder: MasterOrderPayload;
  /**
   * Soft-deletes a material item. Deleted is terminal: updateMaterialItemDetails and
   * activateMaterialItem both reject a Deleted item, and mergeMaterialItemByErpId treats a
   * Deleted item as a silent no-op so an ERP resync can never revive one.
   */
  deleteMaterialItem: MaterialItemPayload;
  deleteOrder: OrderPayload;
  /** Deletes an order kind. Refused while orders that are not deleted use it, with how many. */
  deleteOrderKind: OrderKindPayload;
  /** Soft-deletes a processor. Rejected while Active — deactivate it first. */
  deletePaymentProcessor: PaymentProcessorPayload;
  deletePriceGroup: PriceGroupPayload;
  /** Removes a single price level from a price group by id, leaving every other level in the group untouched. */
  deletePriceLevel: PriceGroupPayload;
  /** Removes one or more price levels from a single price group in one atomic update, leaving every other level in the group untouched. */
  deletePriceLevels: PriceGroupPayload;
  /**
   * Deletes a production catalog entry. The entry is kept with status DELETED and can be restored with
   * undeleteProductionCatalog. Items and recipes that reference it keep its name.
   */
  deleteProductionCatalog: ProductionCatalogPayload;
  deleteProductionCategory: ProductionCategoryPayload;
  deleteProductionItem: ProductionItemPayload;
  deleteProductionLot: ProductionLotPayload;
  deleteProductionMaterialEvent: ProductionMaterialEventPayload;
  deleteProductionPlan: ProductionPlanPayload;
  deleteProductionRecipe: ProductionRecipePayload;
  deleteProductionSpaceCategory: ProductionSpaceCategoryPayload;
  deleteProductionSpaceEvent: ProductionSpaceEventPayload;
  deleteProductionSpaceType: ProductionSpaceTypePayload;
  deleteProductionTaskEvent: ProductionTaskEventPayload;
  deleteProductionTrigger: ProductionTriggerPayload;
  deletePromotionRule: PromotionRulePayload;
  /**
   * Deletes the given runs' documents, refusing every run that is still retained (pinned, or
   * pinUntil still ahead). Each requested id is reported once, in deletedIds or refusedIds; an id
   * with no document is reported as deleted. Blob media and ADO artifacts are not touched.
   */
  deleteQaTestRuns: QaRetentionPayload;
  /**
   * Deletes a report. Anyone in the company may delete an open report. A saved view may be deleted only by its
   * owner or a company admin; anyone else is refused with REPORT_RIGHT_DENIED, or gets the not-found error when
   * they cannot open it.
   */
  deleteReport: ReportPayload;
  /**
   * Deletes a report execution record (soft delete). A run of a saved view the caller cannot open answers as a run
   * that does not exist.
   */
  deleteReportExecution: ReportExecutionPayload;
  deleteReportFolder: ReportFolderPayload;
  /** Deletes a report schedule (soft delete). */
  deleteReportSchedule: ReportSchedulePayload;
  /** Deletes a report template (soft delete). */
  deleteReportTemplate: ReportTemplatePayload;
  deleteReserveRule: ReserveRulePayload;
  deleteRestockSession: RestockSessionPayload;
  deleteSftpTenantConfig: SftpTenantConfigPayload;
  deleteSiteLocation: SiteLocationPayload;
  /**
   * Soft-deletes a site map. The mapping drops out of queries and stops counting toward coverage, but
   * its stream and audit history remain, and its location/program natural key is freed for reuse.
   */
  deleteSiteMap: SiteMapPayload;
  /**
   * SuperAdmin-only purge of every staged GrowPoint document for one staged-entity type, scoped
   * to the caller's tenant. Clears each Mongo collection that backs the chosen
   * entity (e.g. Items clears both Items.Staged.Summary and
   * Items.Staged.ImportCommand) filtered on TenantId == user.TenantId — never a
   * tenant-less delete. Returns the per-collection and total deleted counts.
   */
  deleteStagedEntityDocuments: DeleteStagedEntityResultData;
  /**
   * Deletes a tag color from the list. Records that use it still name it. Deleting a deleted color
   * changes nothing.
   */
  deleteTagColor: TagColorPayload;
  deleteTaskEventType: TaskEventTypePayload;
  /** Requires the caller's tenant Admin directory role or platform SuperAdmin. */
  deleteTenantIntegration: TenantPayload;
  deleteTenantPricingPage: TenantPricingPagePayload;
  deleteTerms: TermsPayload;
  /** Delete a time entry */
  deleteTimeEntry: DeleteTimeEntryPayload;
  /**
   * DELETES the user's directory entry — a distinct concept from deactivateUser.
   * Deactivation hides an otherwise-live user and keeps the read-model row (Status =
   * Inactive); deletion retires the entry, so the projection REMOVES the WorkSuiteUsers
   * row and leaves only a tombstone. Allowed from Active OR Inactive; rejected once the user is
   * already Deleted. Built for operator cleanup of the hundreds of FusionAuth-disconnected users.
   *
   * Gated like the rest of the tenant user-admin surface: the RestockWriter policy (which
   * only excludes portal principals) plus the in-code RequireTenantAdmin check, so an
   * ordinary staff member cannot delete anyone — the tenant authority is carried by the caller's own
   * Active directory entry holding the Admin role, exactly as createUserInvite and
   * deleteUserInvite resolve it. A platform superadmin also satisfies that gate. Tenant
   * isolation comes from the caller's JWT: the command stream is keyed by the caller's tenant, so a
   * target in another tenant resolves to a non-existent stream and is rejected. The strong confirm
   * in front of this lives in the PWA.
   *
   *
   * Self-delete is rejected so an operator cannot lock themselves out mid-cleanup: the caller may
   * not delete the entry carrying their own email (case-insensitively) or their own FusionAuth
   * subject. The check is enforced against authoritative event-sourced state, so it holds even
   * while the user directory is still catching up.
   *
   *
   * Every UNUSED invite linked to the user is revoked as part of the delete, so the wsapi-services
   * invite worker is left with nothing to act on for an entry that no longer exists. The revoke set
   * is keyed on the invite's linked USER ID, never on the email address, so a different user sharing
   * that address keeps their pending invite.
   */
  deleteUser: UserPayload;
  /**
   * Tenant-scoped invite delete for the worksuite app's Administration > Users page. Unlike the
   * SuperAdmin-only adminDeleteUserInvite, the tenant comes from the caller's JWT and
   * the command stream is keyed by that tenant, so a tenant can only delete its OWN invites — an
   * inviteId belonging to another tenant resolves to a non-existent stream and is rejected. Gated
   * in code on the caller's Active Admin directory entry, like createUserInvite.
   */
  deleteUserInvite: UserInvitePayload;
  /** Deletes a Vehicle, clearing it off every Load naming it in the same atomic append. */
  deleteVehicle: VehiclePayload;
  /**
   * No cascade — a Vehicle referencing a deleted VehicleType keeps the stale id, matching
   *             the pwa reference slice.
   */
  deleteVehicleType: VehicleTypePayload;
  /**
   * Soft-deletes a vendor. Refused while the vendor has an open purchase order, with a typed error
   * that names up to five POs so the screen can offer Make Inactive instead.
   */
  deleteVendor: VendorPayload;
  deleteWorkerConfig: AdminWorkerConfigPayload;
  deleteWsapiImport: WsapiImportPayload;
  /**
   * Turns two-step verification off for the caller's own login, on proof they still control it.
   *
   *
   * **Returns:**
   * The state after removal, or why the code was refused.
   */
  disableMyMultiFactor: MyMultiFactorStatusPayload;
  disableWsapiImport: WsapiImportPayload;
  /** Discard an unlinked floating time entry. Transitions to Discarded status. */
  discardFloatingTimeEntry: FloatingTimeEntryPayload;
  /**
   * Discards a document that is not needed, from RECEIVED or NEEDS_KIND only. The document stays in the list as
   * DISCARDED and its file is deleted. ROUTE_IN_PROGRESS while a send of the document is running.
   */
  discardInboundDocument: InboundDocumentPayload;
  /**
   * Discards an import nothing has applied from, and removes its stored document. Refused once a step
   * was committed under any of its approvals, which is the existing business-record lifecycle rather than
   * a rule this feature invented, and refused while an approval is eligible until that approval is
   * cancelled.
   */
  discardSupplierPriceImport: SupplierPriceImportPayload;
  /** Disconnects the calling user's mailbox (idempotent). Tenant and user come from the JWT. */
  disconnectM365Mailbox: M365MailboxConnectPayload;
  /**
   * Disconnects the current tenant from OrderEase: best-effort revokes the grant upstream
   * (POST /api/v3/Auth/revoke) then clears the stored credentials via deleteTenantIntegration.
   * Idempotent — disconnecting a tenant that is not connected is a clean success, not an error —
   * and it never blocks on the upstream revoke outcome, so a grower can always clear stale local
   * credentials.
   */
  disconnectOrderEaseIntegration: OrderEaseConnectionPayload;
  /**
   * TENANT ADMIN, FLAG. Revokes the refresh token at POST {apiBase}/developer/v1/token/revoke (best
   * effort), then clears the entity choice and deletes the token document. Status becomes NOT_CONNECTED. Vendor
   * links, invoice links and cached Ramp data stay. Already NOT_CONNECTED: ENTITY_NO_CHANGES.
   */
  disconnectRamp: RampConnectionPayload;
  /**
   * Takes one of the caller's finished jobs out of the queue. Dismissing it twice changes nothing. A job that is
   * still queued, pending or running is refused. For a job the queue only lists (bulk order delete, schedule
   * import), pass its type: the dismiss is a per-user mark and the job's own documents are untouched, and
   * the payload carries no job.
   */
  dismissBackgroundJob: BackgroundJobPayload;
  /**
   * Clears pairs a person says are not duplicates. A cleared pair is never raised again; clearing it twice
   * is not an error. A resolved pair is refused. Admin staff only.
   */
  dismissDuplicateCandidates: DuplicateCandidateIdsPayload;
  /**
   * Hides the caller's Home welcome in this tenant for good. It stops no work and changes no shared
   * progress; fernie imports stay available.
   */
  dismissOnboardingWelcome: OnboardingWelcomePreferencePayload;
  /** Dispatches a Load (Loaded -> Dispatched). */
  dispatchLoad: DeliveryPayload;
  /**
   * Re-drafts one DRAFTED GrowerBenchmark review from its firm's approved submission at the community segment's selected
   * instruction-set version (contracts R3 and R4). A change to the content, source submission or instruction
   * version appends the next version and every earlier version stays readable; a re-draft that changes none of them
   * appends nothing. Refuses any other status with GROWER_BENCHMARKS_REVIEW_STATUS_INVALID and an unknown reviewId with
   * GROWER_BENCHMARKS_ACCESS_DENIED. Restricted to effective COMMUNITY_ANALYST roster holders and platform superadmins.
   */
  draftGrowerBenchmarkReview: GrowerBenchmarkReviewPayload;
  /**
   * Drafts every member firm and reporting unit of a period at the community segment's selected instruction-set
   * version, answering one result per firm and reporting unit in firm id order (contracts R3 and R4). DRAFTED and
   * SKIPPED carry the reviewId; SKIPPED is a review that already holds a version at this instruction version, so a
   * re-run never appends to a firm that succeeded. FAILED carries that firm's code, and one firm's failure never
   * refuses the others. GROWER_BENCHMARKS_DISABLED, GROWER_BENCHMARKS_ACCESS_DENIED and GROWER_BENCHMARKS_INSTRUCTION_SET_MISSING refuse the
   * whole call with empty results. Restricted to effective COMMUNITY_ANALYST roster holders and platform superadmins.
   */
  draftGrowerBenchmarkReviewsForPeriod: GrowerBenchmarkReviewDraftBatchPayload;
  duplicatePriceGroup: PriceGroupPayload;
  /**
   * Copies a recipe onto a target catalog, and the target category when one is given, as a new Active recipe:
   * every variation with its week window, scopes, grow weeks, plants per pot and yield, its event assignments,
   * exclusions and links, and the recipe's labor source and task events. Lots, jobs, costs and history stay with
   * the source. Refused when the target catalog and category already have a recipe or the catalog is not active.
   */
  duplicateProductionRecipe: DuplicateProductionRecipePayload;
  /**
   * Replaces the text of ONE existing legacy location note, targeted by its exact noteId. The
   * note keeps its id, position, submitDate and submittedBy. Error codes:
   * CUSTOMER_LOCATION_NOTE_NOT_FOUND, ENTITY_NO_CHANGES (text unchanged). There is no
   * optimistic concurrency: two edits of the same note can both succeed and only the one appended
   * last is stored, so read the location back and compare the text to confirm.
   */
  editCustomerLocationSettingsNote: CustomerPayload;
  editMasterOrder: MasterOrderPayload;
  editOrder: OrderPayload;
  /** Edits a charge's amount and taxable flag, with a reason. */
  editOrderFlatCharge: OrderPayload;
  /**
   * Commits one or more macro plan-cell edits. Each edit names a row (region + item), an editable cell,
   * an operation (Replace / AddTo / SubtractFrom / PercentageOf), and an operand; the server applies the
   * operation to the row's current value and re-derives the dependent cells per spec §4.4 (ships/sales
   * unit CEILING/FLOOR identities, last-year realization ratio for dollars, zero-guards), marking the
   * touched cells as user overrides so the next generation preserves them. At most one edit per row
   * (region + item) is allowed per call, so each row lands from one consistent recalc; a batch that
   * edits the same row twice is rejected. Rejects an edit to a row that does not exist in the forecast;
   * an all-no-op batch appends nothing.
   */
  editPlanCells: ForecastPayload;
  /**
   * Atomically edits a scheduled future labor rate. Same error surface as
   * EditScheduledOverheadRate.
   */
  editScheduledLaborRate: SiteLocationPayload;
  /**
   * Atomically edits a scheduled future overhead rate by emitting a cancel + insert event pair
   * in one command. Errors: RATE_NOT_FOUND, RATE_CANCEL_CURRENT,
   * RATE_CANCEL_HISTORICAL, RATE_EDIT_RETROACTIVE, RATE_EDIT_NOOP.
   */
  editScheduledOverheadRate: SiteLocationPayload;
  /**
   * Commits one or more weekly-cell edits. Each edit names a cell (ISO year + ISO week + region + item),
   * the metric to set (Sales or Ships units), and the absolute value; the server writes that metric's
   * value, marks it as a user override so the next weekly-distribution regeneration preserves it, and —
   * if the cell does not exist — creates it with all four values 0 plus the edited value (the two
   * Original* machine-baseline twins start at 0 for a user-invented week). It NEVER touches
   * Original*. At most one edit per weekly cell is allowed per call; a batch that edits the same
   * cell twice is rejected. An edit equal to the cell's current value is a no-op that appends nothing.
   */
  editWeeklyCells: ForecastPayload;
  enableWsapiImport: WsapiImportPayload;
  /**
   * Enqueues a single ERP write-back record (status Pending) for the calling tenant. Called by the
   * PWA-facing inventory mutation slices (Finish / Material / Retail) after they apply their
   * optimistic delta. Idempotent on IdempotencyKey: a duplicate enqueue with the same key
   * returns the existing record, so a retry never double-posts to Nav.
   */
  enqueueErpWriteBack: ErpWriteBackPayload;
  /**
   * Makes sure an issued invoice that still owes something has a pay link a customer can open without a Work
   * Suite login, and returns it with its pay URL and expiry. Call it when staff click Copy pay link, never on
   * page load: an invoice whose link is active with at least 10 days left gets that same link and URL back, but
   * a revoked or expired link, or one with fewer than 10 days left, is replaced with a new token and a new expiry
   * (30 days after the due date, or after today when the due date has passed, and never more than 120 days from
   * today), which stops the link the customer already holds from working. newLinkMade says whether this call
   * replaced it.
   */
  ensureInvoicePayLink: InvoicePayLinkPayload;
  /**
   * Trades a handoff code for the session material it stands for, and burns it. Called by the handoff
   * page on the custom domain.
   */
  exchangePortalSessionHandoffCode: PortalSessionHandoffExchangePayload;
  executeProductionJob: ProductionLotPayload;
  /** Executes one due scheduled inventory transfer in the caller's tenant. WorkerService only. */
  executeScheduledInventoryTransfer: ExecuteScheduledInventoryTransferPayload;
  fillFernieGaps: FillFernieGapsPayload;
  finalizeImportUpload: AsyncImportJobPayload;
  /** Flag a floating time entry as stale when it exceeds the linking window. */
  flagStaleEntry: FloatingTimeEntryPayload;
  /**
   * ADMIN ESCAPE HATCH — force-resolves a stuck make-to-order reservation to the Cancelled terminal
   * state, emitting a distinct audited cancellation event (recording the acting admin and the required
   * reason). SuperAdmin-only. Rejected unless the allocation is in a non-terminal reservation state
   * (Reserved or ProducedPegged); a terminal or manual-allocation state rejects, so the escape hatch
   * never races the saga to a resolved allocation.
   */
  forceCancelStuckMtoReservation: OrderProductionLotAllocationPayload;
  forceFailConsolidationApplication: ConsolidationApplicationPayload;
  /**
   * ADMIN ESCAPE HATCH — force-resolves a stuck make-to-order reservation to the ReadyHandedOff terminal
   * state, emitting a distinct audited ready-handoff event (recording the acting admin and the required
   * reason). SuperAdmin-only. Rejected unless the allocation is in a non-terminal reservation state
   * (Reserved or ProducedPegged).
   */
  forceReadyHandoffStuckMtoReservation: OrderProductionLotAllocationPayload;
  /**
   * Fulfills a MaterialAllocationStatus.Confirmed allocation, moving it to
   * MaterialAllocationStatus.Fulfilled and recording the fulfilled quantity.
   * Rejected if the allocation is not currently Confirmed.
   *
   *
   * **Returns:**
   * The fulfilled allocation, or validation errors.
   */
  fulfillMaterialAllocation: MaterialAllocationPayload;
  /** Generates a period's customer statements for review. SENDS NO EMAIL. */
  generateCustomerStatementRun: CustomerStatementRunPayload;
  /**
   * Kicks off a server-driven generation run for a forecast (W9). Runs the feature gate first, computes
   * the history freshness watermark this run pins its inputs at (ADR-001 §5.3, ARCH-3 — so repeat
   * generation over unchanged inputs is deterministic), then appends Forecast.V1.GenerationStarted
   * with an expected-version check. The aggregate rejects a second run while one is in flight (serialized
   * per forecastId, §5.1) and refuses a non-Regions or soft-deleted forecast. The background generation
   * worker picks the event up, runs the pure engine, and MERGE-upserts plan rows preserving planner
   * overrides unless overwriteOverrides. Progress and the final preserved/overwritten counts are
   * observable on the
   * forecast document's generationStatus.
   */
  generateForecast: ForecastPayload;
  /** Changes the grade of an inventory item. */
  gradeInventoryItem: InventoryItemGradePayload;
  /**
   * Gives a user an active directory entry in each of the named member tenants, creating, linking or
   * reactivating their entry as needed, and adding their own home tenant when that tenant belongs to
   * the same parent company. Only an administrator of that parent company may call it, only its
   * member tenants may be named, and an administrator of the group may not be the target. Repeating
   * an identical grant changes nothing and records nothing.
   */
  grantParentCompanyTenantAccess: ParentCompanyAccessPayload;
  /**
   * Counts and removes every reachable store, stream, blob, and bookkeeping record in the GrowerBenchmark module data
   * inventory and writes a permanent completion audit record in the default database. Requires the GrowerBenchmarks
   * feature flag to be globally off and confirmationPhrase to match the resolved GrowerBenchmark database name.
   * Restricted to platform superadmins.
   */
  growerBenchmarkPurge: GrowerBenchmarkPurgeRunPayload;
  /**
   * Counts every item in the GrowerBenchmark module data inventory without removing any rows, streams, or blobs.
   * Restricted to platform superadmins and runnable regardless of the GrowerBenchmarks feature flag state.
   */
  growerBenchmarkPurgeDryRun: GrowerBenchmarkPurgeRunPayload;
  /**
   * Queues a cohort statistics pass for communityId and periodId and returns the QUEUED run record (contracts M3
   * and M4), or the run already QUEUED or RUNNING for that community and period. Restricted to effective
   * COMMUNITY_ANALYST roster holders and platform superadmins.
   */
  growerBenchmarkQueueCohortPass: GrowerBenchmarkCohortPassQueuePayload;
  /**
   * Sets one cohort classification facet on many member firms in one save, appended as a single event on the
   * community stream; the next cohort pass of a period groups firms by the new values. Requires an effective
   * COMMUNITY_ANALYST roster entry (or platform superadmin) and refuses firms outside the community with
   * GROWER_BENCHMARKS_ACCESS_DENIED. A row below the five-firm floor never blocks the save, and when no value changes
   * nothing is appended.
   */
  growerBenchmarkReclassifyFirms: GrowerBenchmarkCommunityPayload;
  /**
   * Adds a metric to input.communityId's catalog, or retunes an existing one, and returns it at its new version
   * (contracts M3 and C9). Restricted to effective COMMUNITY_ANALYST roster holders and platform superadmins; an
   * upsert that changes nothing returns the metric at its current version and appends nothing.
   */
  growerBenchmarkUpsertMetric: GrowerBenchmarkMetricUpsertPayload;
  /**
   * Halts an OTA release. Halting is permanent: no rollout of a halted release targets any device, whatever that
   * rollout's own state. Each rollout of the release on its product line is halted too, so the halt is recorded on the
   * line its devices' targets are delivered from, and those targets are revoked.
   */
  haltOtaRelease: OtaReleasePayload;
  /**
   * Ignores one missing-data warning for the CALLING user: the one on subjectId, or every
   * warning of code when no subject is given. code is a MissingDataCode,
   * OrderUncountedLineReason, OrderUnweighedLineReason or
   * OrderUnweighedContainerReason name. Resolves the caller's own directory entry from the JWT
   * exactly like setMyLanguagePreference; there is no admin-sets-others path, and every other
   * user still sees the warning. Ignoring an entry that is already ignored writes nothing and returns
   * the user.
   */
  ignoreMissingData: UserPayload;
  /**
   * Creates an Approved submission version directly from staged imported lines for a historical period with
   * approvalType IMPORT (contract C6, C7, and C10). Restricted to effective COMMUNITY_ANALYST roster holders and
   * platform superadmins.
   */
  importApprovedGrowerBenchmarkSubmission: GrowerBenchmarkSubmissionPayload;
  /**
   * Atomic create-or-merge of a customer plus N ship-to locations in a single
   * write. Equivalent to MergeCustomerAsync followed by N
   * addLocation calls — but transactional. Locations[0] is the
   * primary ship-to; the rest are additional ship-to locations.
   */
  importCustomer: CustomerPayload;
  /**
   * Applies up to 2,000 retail-price rows for one customer, one row at a time and in input
   * order. Staff-only and independent of the tenant's Pre-pricing setting. A single-row call is
   * the staff edit path from the Pre-pricing tab (D7), including Remove promo (D11). A customer
   * combined into another is refused (CUSTOMER_COMBINED) before any row runs.
   */
  importCustomerRetailPrices: ImportCustomerRetailPricesPayload;
  /**
   * Loads a GP grower's open receivables at cutover, each as an issued invoice that owes the open balance GP
   * showed. An imported invoice reaches A/R, aging and statements and takes payments, but it never queues a
   * customer email and is never sent to accounting: GP already sent the one and holds the other.
   */
  importHistoricalInvoices: ImportHistoricalInvoicesResult;
  /**
   * Imports historical orders, each as its own order. A row naming a customer that was combined into
   * another lands on the customer it was combined into, following a chain of combines, and records the
   * one it named as its original customer; a row whose ship-to or bill-to that customer no longer has
   * is refused with CUSTOMER_COMBINED.
   */
  importHistoricalOrders: ImportHistoricalOrdersResult;
  /**
   * Imports 1 to 25 orders and master orders in one call, in input order, returning one payload per row.
   * Per row the server builds the customer snapshot for the named location, draws the order number,
   * creates the header as initializeOrder does, adds the lines, and moves the order to its target
   * status. A row of type MASTER_ORDER creates a master order instead, as initializeMasterOrder,
   * addMasterLineItems and updateMasterOrderStatus do, with its line quantities converted
   * from shipping units to eaches. A row that fails reports its own error and failed step and does not stop
   * the rows after it. An empty or oversized list fails the whole call and writes nothing.
   */
  importOrders: ImportOrdersPayload;
  /**
   * GrowPoint production import of one payment-terms row. Dedupes by the GrowPoint
   * terms-master natural key (TermsCode = artrm.CODE) against the production
   * terms read model: a code unseen for the tenant starts a NEW Terms aggregate stream
   * (addTerms), while a seen code re-keys onto the existing stream and appends edit
   * events (updateTerms). Idempotent — re-importing identical data emits zero new
   * events (the domain's IfChangedPer guard). A code found on payment terms that were
   * combined into others writes nothing and returns the payment terms that stand for them.
   * COMMITS events via KurrentDB; this is the
   * promotion the staged validateTermsDocuments mutation defers to. Tenant
   * [Authorize] (NOT SuperAdmin): the import worker authenticates as the tenant.
   */
  importTerms: TermsPayload;
  /** Inactivates a feature flag, forcing it to return defaults regardless of configured values. */
  inactivateAdminFeatureFlag: AdminFeatureFlagPayload;
  inactivateAdminTenant: AdminTenantPayload;
  inactivateCategory: CategoryPayload;
  inactivateCustomer: CustomerPayload;
  inactivateDeliverySchedule: DeliverySchedulePayload;
  inactivateItem: ItemPayload;
  /** @deprecated Use SiteLocation mutations instead. */
  inactivateLocation: LocationPayload;
  inactivateMaterialItem: MaterialItemPayload;
  inactivatePriceGroup: PriceGroupPayload;
  inactivateProductionItem: ProductionItemPayload;
  inactivateProductionMaterialEvent: ProductionMaterialEventPayload;
  inactivateProductionMaterialEventDetail: ProductionMaterialEventPayload;
  inactivateProductionRecipe: ProductionRecipePayload;
  inactivateProductionSpaceEvent: ProductionSpaceEventPayload;
  inactivateProductionSpaceEventDetail: ProductionSpaceEventPayload;
  inactivateProductionTaskEvent: ProductionTaskEventPayload;
  inactivateProductionTaskEventDetail: ProductionTaskEventPayload;
  inactivateProductionTrigger: ProductionTriggerPayload;
  /** @deprecated Status-based inactivation is deprecated. Use the Enabled flag instead. */
  inactivateSftpTenantConfig: SftpTenantConfigPayload;
  /**
   * Inactivates a site; its sub-locations keep their status. While any record references the site or any of
   * its sub-locations it is refused with LOCATION_IN_USE unless acknowledgeInUse is true.
   */
  inactivateSiteLocation: SiteLocationPayload;
  /**
   * Inactivates a sub-location and every Active sub-location under it. While any record references them it
   * is refused with LOCATION_IN_USE unless acknowledgeInUse is true. Refused for a combined sub-location.
   */
  inactivateSubLocation: SiteLocationPayload;
  inactivateTaskEventType: TaskEventTypePayload;
  inactivateVendor: VendorPayload;
  /** Adds a strictly positive quantity to an inventory item's on-hand as a DELTA ("Add N"). */
  incrementInventoryItem: InventoryItemPayload;
  /**
   * Records one report from the counting device assigned to this session's line. The device owns
   * the count, so this is the ONLY path that writes a device-backed session's total — the operator
   * correction mutations deliberately write none.
   */
  ingestDeviceCount: CountSessionPayload;
  /**
   * Ingests one transmission from one device: every metric value it carried, sharing the
   * envelope's sequence number and device-claimed time. The owning tenant is resolved from the
   * device registry — the caller supplies no tenant and cannot influence the one used, so a
   * reading can only ever land under the tenant that actually owns the device. The device must be
   * registered and currently claimed; a device still in the lobby or already decommissioned is
   * rejected. Redelivering an envelope converges onto the readings already stored instead of
   * duplicating them or failing, so an at-least-once transport may safely retry.
   */
  ingestDeviceReadings: IngestDeviceReadingsPayload;
  /**
   * Stores one finished test run, overwriting any existing run with the same id so a publisher
   * that retries after a network failure converges rather than duplicating.
   *
   * Open to SuperAdmin OR the workerservice tier (the QaPublisher policy): the ADO pipeline
   * publishes with a service account, while a developer publishing a local run authenticates as
   * themselves.
   */
  ingestQaTestRun: QaTestRunPayload;
  /**
   * Records one heartbeat. Heartbeats are append-only — a watcher reporting twice leaves two
   * rows, because the history is the evidence the dashboard renders.
   */
  ingestQaWatcherHeartbeat: QaWatcherHeartbeatPayload;
  initializeMasterOrder: MasterOrderPayload;
  /**
   * Manual re-export entry point: a SuperAdmin operator re-arms an entity's export by hand (e.g.
   * re-exporting an invoice after a worker failure). The application layer arms exports on issue
   * directly, not through this mutation, so this is purely an operator recovery tool; the
   * wsapi-services worker reads the resulting MergeDevExports read-model row. Refused when
   * the entity id already tracks an export of a different type, or when the requested type is
   * ORDER — new ORDER exports are retired.
   */
  initializeMergeDevExport: MergeDevExportPayload;
  initializeOrder: OrderPayload;
  /**
   * Issues the credit memo of a shipped Credit-type order — the document a credit issues instead of an invoice,
   * numbered CM- and the credit order's number. A Credit-type order is never billed; markOrdersForInvoicing
   * issues its memo the same way. The memo credits the order's lines, freight and charges, and the tax the
   * credited order's invoice was charged on those lines, which is reversed at Stripe Tax for exactly those lines
   * (no tax rate is computed). By default the memo is applied to the credited order's live invoice, up to what
   * it owes; when that order has not been invoiced yet, the memo comes off its invoice when it issues. Name
   * applications to apply it to other open invoices of the same customer instead. Whatever is not applied is the
   * customer's unapplied credit. A credit order issues one memo; asking again is refused.
   */
  issueCreditMemo: CreditMemoPayload;
  /**
   * Leases waiting checks, oldest first. A leased check is hidden from every other lease until its lease runs
   * out, then offered again if it was never completed. Worker only.
   */
  leaseDuplicateCheckRequests: DuplicateCheckRequestsPayload;
  /**
   * Link a floating time entry to one or more task assignments with split support.
   * Replay-idempotent: when every incoming TimeEntryId is already present on the
   * aggregate with the same TaskAssignmentId/Duration/order (or the FTE has reached
   * the terminal Linked status), the domain handler short-circuits via the primary
   * builder's AllowNoOp() opt-in and returns the unchanged current state.
   * No events are appended on the FTE primary stream or on any TaskAssignment
   * secondary stream. MixedReplay (partial overlap, or same TimeEntryId with a
   * mutated payload) is rejected upstream in Ensure as a ValidationError
   * and surfaces here in the payload's Errors array, unchanged.
   */
  linkFloatingTimeEntry: FloatingTimeEntryPayload;
  /**
   * Links the user to a FusionAuth login. Linking is rejected when the user is already
   * linked to a different FusionAuth user; re-linking the same FusionAuth user writes
   * no event and reports "no changes".
   *
   * Admin/SuperAdmin gated. This mutation decides WHICH login speaks for a directory entry, so
   * leaving it open is an escalation path in its own right: an ungated caller could link an
   * unlinked Admin-role entry to their OWN FusionAuth subject, after which
   * CallerUserResolution's subject arm resolves them as that admin. Its by-email sibling
   * linkFusionAuthUserByEmail reaches the same command and carries the same gate.
   *
   *
   * Cross-tenant guard. The supplied FusionAuth user id must belong to a login stamped to
   * the CALLER'S tenant; a login FusionAuth does not have, or one stamped to another tenant, is
   * refused with the same NotFound-style error linkFusionAuthUserByEmail returns, and no
   * event is written. One FusionAuth instance serves every tenant, so without this a tenant admin
   * could mint a directory row pointing at any login in the estate — and under the parent-company
   * design a directory row IS the entitlement to that tenant, making the row itself a silent
   * cross-tenant access grant. Legitimate cross-tenant rows are created only by the privileged
   * parent-company grant path, which reaches the same command through an internal seam that is
   * not exposed as a GraphQL field — never through this one.
   */
  linkFusionAuthUser: UserPayload;
  /**
   * Links the user to an existing FusionAuth login resolved by email instead of a raw
   * FusionAuth user id. The email is resolved against the existing FusionAuth integration scoped
   * to the caller's tenant; the resolved id is then dispatched through the SAME
   * LinkFusionAuthUser command/event as the GUID-based mutation. When no in-tenant
   * FusionAuth user matches the email, a typed NotFound error is returned in
   * errors (no exception). Linking is rejected when the user is already linked to a
   * different FusionAuth user; re-linking the same FusionAuth user writes no event and reports
   * "no changes".
   *
   * Carries the same Admin/SuperAdmin gate as the GUID-based linkFusionAuthUser, and must:
   * it dispatches the IDENTICAL LinkFusionAuthUser command, so gating only its sibling
   * would leave the link-yourself-onto-an-Admin-entry escalation reachable through this door.
   */
  linkFusionAuthUserByEmail: UserPayload;
  /** Links one or more production items to a single sales item. Each link overwrites any prior link on that production item. */
  linkProductionItemsToSalesItem: LinkProductionItemsToSalesItemPayload;
  /** Links up to 500 production-item/Sales-Item pairs through the existing link command, with one zero-based row result per pair. */
  linkProductionItemsToSalesItems: LinkProductionItemsToSalesItemsPayload;
  /**
   * W3. FLAG. Links a cached bill to a PO. Many bills per PO, one PO per bill. Codes: RAMP_NOT_ENABLED,
   * RAMP_BILL_NOT_FOUND, ENTITY_DOES_NOT_EXIST (PO), RAMP_VENDOR_NOT_LINKED (PO vendor has no Ramp link),
   * RAMP_BILL_VENDOR_MISMATCH (bill's Ramp vendor is not the PO vendor's linked Ramp vendor),
   * RAMP_BILL_ALREADY_LINKED (linked to another PO; the message names that PO's number). Same PO again: ENTITY_NO_CHANGES.
   */
  linkRampBillToPurchaseOrder: RampBillLinkPayload;
  /**
   * W2. FLAG. Link all suggested: links every unlinked vendor whose suggestion is SAME_NAME or SUGGESTED, never
   * CHECK. Skips a Ramp vendor another vendor already has; when two vendors are suggested the same Ramp
   * vendor, links only the one first by name. Each link is the same Linked event as linkVendorToRampVendor.
   * Nothing to link: linkedCount 0, no error. Codes: RAMP_NOT_ENABLED.
   */
  linkSuggestedRampVendors: LinkSuggestedRampVendorsPayload;
  /**
   * W2. FLAG. Links a Work Suite vendor to one cached Ramp vendor (replaces an earlier link). A Ramp vendor
   * belongs to one Work Suite vendor. When rampVendorId equals the vendor's stored suggestion, the Linked event
   * records that suggestion's source, tier and modelVersion. Codes: RAMP_NOT_ENABLED, RAMP_VENDOR_NOT_FOUND,
   * RAMP_VENDOR_ALREADY_LINKED (another vendor has it; the message names that vendor).
   */
  linkVendorToRampVendor: VendorPayload;
  /**
   * Marks the universal one-time inbound pull as completed for the calling tenant, stamping the
   * completion time from Clock. Idempotent: re-invocation after completion is a no-op. The
   * inbound sync worker drives this once its first pull cycle finishes (§4.2+).
   */
  markAccountingOneTimePullCompleted: AccountingIntegrationConfigPayload;
  /**
   * Staff-facing SuperAdmin mutation for the per-file Imported tick: marks one onboarding upload
   * row as imported and, unless the tenant's Notifications flag is off or it has no eligible
   * grower users, raises one OnboardingFileImported notification row per recipient in process
   * before the mark is appended.
   */
  markAdminTenantOnboardingUploadImported: MarkAdminTenantOnboardingUploadImportedPayload;
  /**
   * Clears the signed-in user's whole unread count in one write, and reports how many rows that
   * moved. Scoped to the caller like every other mutation here: no other recipient's rows are
   * read or written, in this tenant or any other.
   *
   *
   * **Returns:**
   * How many of the caller's visible rows changed from unread to read.
   */
  markAllNotificationsRead: MarkAllNotificationsReadPayload;
  /** Records a non-retryable condition that needs a human; moves the record to NeedsAttention. */
  markContractRecordEnrollmentNeedsAttention: ContractRecordPayload;
  /** Records that the Stripe subscription schedule was created; moves the record to Succeeded. */
  markContractRecordEnrollmentSucceeded: ContractRecordPayload;
  /** Confirms the enrollment reconciled against Stripe; moves the record to Verified. */
  markContractRecordEnrollmentVerified: ContractRecordPayload;
  /** Records that Stripe reported the fee invoice paid; moves the fee to Paid. */
  markContractRecordFeeInvoicePaid: ContractRecordPayload;
  /** Records that the standalone Stripe fee invoice was finalized and sent; moves the fee to Sent. */
  markContractRecordFeeInvoiceSent: ContractRecordPayload;
  /** Records a non-retryable fee condition that needs a human; moves the fee to NeedsAttention. */
  markContractRecordFeeNeedsAttention: ContractRecordPayload;
  /**
   * Records what the enrollment worker did about a Stripe schedule this record owns — cancelled
   * it, or found it already released into a live subscription and left that subscription alone.
   * Idempotent per schedule id, and deliberately accepted on a cancelled record, since the
   * worker's cancel sweep runs precisely over cancelled records.
   */
  markContractRecordScheduleCancelled: ContractRecordPayload;
  /**
   * Records that NAV accepted the latest send of a POSTING record: under the claimToken its POSTING mark
   * was made with, while that claim is still the record's, it stamps acceptedAt and, when sent, navPostedAt
   * (NAV's own posting time), keeps the record POSTING and clears its claim, so claimPostedErpWriteBacks
   * hands it to a verify step at once. It does not mark the record POSTED: only markErpWriteBackPosted
   * does, once navDocumentNo is found in NAV (by a verify step, or by the poster before a re-attempt).
   * Sent again with the same claimToken after it landed, it answers the record
   * as it is and changes nothing. Any other token, or a record not POSTING, surfaces
   * ERP_WRITE_BACK_INVALID_STATUS_TRANSITION. Worker-facing.
   */
  markErpWriteBackAccepted: ErpWriteBackPayload;
  /**
   * Marks a claimed record Failed (recording the worker error and incrementing the retry count)
   * after a non-retryable Nav post failure: a PENDING record, or a POSTING one under the claimToken its
   * POSTING mark was made with, before NAV accepted the send (NAV refused it). Worker-facing. Same
   * claimToken rule and ERP_WRITE_BACK_INVALID_STATUS_TRANSITION refusal as markErpWriteBackProcessed, a
   * re-send after it landed included.
   */
  markErpWriteBackFailed: ErpWriteBackPayload;
  /**
   * Parks a claimed record in NEEDS_REVIEW when the worker cannot tell whether Nav holds the post, or a
   * verify step finds something other than what was sent (for a POSTING record NAV accepted but whose
   * navDocumentNo is not in NAV: "NAV accepted it but document {navDocumentNo} is not in NAV; check NAV").
   * Moves a PENDING, POSTING or POSTED record. Keeps the claim, records the error message and increments
   * the retry count; no claim takes the record again unless a tenant admin resolves it NOT_POSTED with
   * resolveErpWriteBack, which clears the claim and returns it to PENDING. Worker-facing. The claimToken
   * must be the record's current one; otherwise, or if the record is in another status, surfaces
   * ERP_WRITE_BACK_INVALID_STATUS_TRANSITION, a re-send after it landed included (the record is then
   * NEEDS_REVIEW).
   */
  markErpWriteBackNeedsReview: ErpWriteBackPayload;
  /**
   * Marks a POSTING record POSTED once its navDocumentNo is found in NAV, with postedAt from wsapi's clock,
   * under the record's current claimToken: a verify step's that claimPostedErpWriteBacks returned, or the
   * poster's own on a re-attempt (the record was sent before, and the poster found it in NAV before sending
   * again). Under the poster's claimToken on a first send it is refused with
   * ERP_WRITE_BACK_INVALID_STATUS_TRANSITION: the poster reports NAV's acceptance with
   * markErpWriteBackAccepted, so postedAt always means the number was found in NAV. The claim is kept: the
   * same caller goes on to audit the record and mark it PROCESSED or NEEDS_REVIEW, and if it stops,
   * claimPostedErpWriteBacks leases the record again once that claim is older than the claim lease. Sent
   * again with the same claimToken after it landed, it answers the record as it is and changes nothing. Any
   * other token, or a record not POSTING, surfaces ERP_WRITE_BACK_INVALID_STATUS_TRANSITION. Worker-facing.
   */
  markErpWriteBackPosted: ErpWriteBackPayload;
  /**
   * Writes a send down before the worker sends a claimed PENDING record to NAV under navDocumentNo: the
   * record moves to POSTING under the claimToken the claim returned. The first send sets navDocumentNo and
   * postingAt; every send sets lastPostingAt, adds one to postingAttempts and clears acceptedAt,
   * navPostedAt and postedAt. navDocumentNo is stored and compared trimmed of surrounding whitespace, so a
   * padded re-send is the same number; a blank one, one longer than NAV's document number field holds, or
   * one with a control character is refused before the record is read and writes nothing. A later send
   * keeps postingAt and must carry the same navDocumentNo, or it is refused with
   * ERP_WRITE_BACK_DOCUMENT_NO_CHANGED. Sent again with the same claimToken and navDocumentNo after it
   * landed (a lost answer), while that claim is still the record's, it answers success and raises
   * lastPostingAt to the time of the re-send, never back, since the worker sends on that answer;
   * postingAt, postingAttempts and navDocumentNo stay as they were. Once markErpWriteBackAccepted cleared
   * the claim or a verify step leased the record, the same claimToken is refused. No Posting mark, a
   * re-send included, is accepted once its claim is as old as the claim lease. Any other token, or a
   * record not PENDING, surfaces ERP_WRITE_BACK_INVALID_STATUS_TRANSITION. Worker-facing; a worker that
   * claimed with marksPosting calls it before every send, sends nothing unless it succeeds, and then sends
   * at once, never once its claim is as old as the claim lease.
   */
  markErpWriteBackPosting: ErpWriteBackPayload;
  /**
   * Marks a claimed record Processed after the worker successfully posted it to Nav, or after a verify
   * step audited a POSTED record. Worker-facing. Send the claimToken the claim returned: the mark then
   * succeeds only while that claim is still the record's current one. Without a claimToken (workers that
   * predate tokens) the record must be a claimed PENDING one. Surfaces
   * ERP_WRITE_BACK_INVALID_STATUS_TRANSITION if the record is neither PENDING nor POSTED or the caller does
   * not hold its claim — including a late call from a worker whose expired claim was moved to
   * NEEDS_REVIEW, which this rejects instead of corrupting the record. Sent again after it landed (a lost
   * answer), it is refused the same way, since the record no longer carries the caller's claim: read the
   * record and carry on from its status. Only markErpWriteBackPosting, markErpWriteBackAccepted and
   * markErpWriteBackPosted answer a re-send with success.
   */
  markErpWriteBackProcessed: ErpWriteBackPayload;
  /**
   * Marks a Merge.dev export attempt successful with the Merge.dev-side invoice id. Called
   * by the wsapi-services worker after a successful CreateInvoice.
   */
  markMergeDevExportCompleted: MergeDevExportPayload;
  /**
   * Records a terminal (non-retryable) failure. Used both for inherently non-retryable
   * failures (validation, auth, 4xx-non-429) and for retry-budget exhaustion. Surfaces in the
   * admin UI for human review.
   */
  markMergeDevExportFailedPermanent: MergeDevExportPayload;
  /**
   * Records a transient (retryable) failure. The worker computed RetryCount and
   * NextRetryAt from its own budget (1m → 5m → 30m → 2h, 5 attempts) and is just
   * reporting; wsapi is purely a recorder. Re-submitting the same values is a no-op via
   * IfChangedPer.
   */
  markMergeDevExportFailedTransient: MergeDevExportPayload;
  /**
   * Terminally closes an export that was evaluated and correctly wrote nothing to Merge.dev —
   * a finance charge reversed before it was ever invoiced, for example. Takes no
   * mergeInvoiceId and records none, so the row closes without entering inbound
   * echo-suppression. Not counted as a failure.
   */
  markMergeDevExportNotExported: MergeDevExportPayload;
  /**
   * Marks one of the signed-in user's notifications read — what the bell does when a row is
   * clicked. Safe to call again on a row that is already read: the second call changes nothing,
   * keeps the time the user first saw it, and still succeeds, so a client never needs to check
   * first or surface a failure for a double tap.
   *
   * Only the caller's own rows are reachable. An id belonging to another user is accepted,
   * changes nothing, and comes back as an empty success — the same answer as an id that was never
   * issued.
   *
   *
   *
   * **Returns:**
   * The row as it now stands, or an empty payload when the caller owns no such row.
   */
  markNotificationRead: NotificationPayload;
  /**
   * Returns one of the signed-in user's notifications to the unread state, putting it back in the
   * badge count. The mirror of marking read, with the same rules: already-unread is a no-op
   * success, and a row the caller does not own is an empty success.
   *
   *
   * **Returns:**
   * The row as it now stands, or an empty payload when the caller owns no such row.
   */
  markNotificationUnread: NotificationPayload;
  /**
   * Finalizes the bill for one or more shipped orders. An order has at most one LIVE invoice at a
   * time, so an order whose previous bill was withdrawn can be billed again; the new bill is numbered
   * orderNumber-R1, orderNumber-R2 and so on.
   */
  markOrdersForInvoicing: MarkOrdersForInvoicingPayload;
  /**
   * Marks jobs done (This week, Mark done) at the given time or now, by the caller. A job never started is marked
   * started at the same time by the same user. A job already done writes nothing. Never touches the job's
   * execution or posting status.
   */
  markProductionJobsDone: ProductionJobsProgressPayload;
  /**
   * Marks jobs started (This week, Mark started) at the given time or now, by the caller. A job already started
   * keeps its first started time and writes nothing. Never touches the job's execution or posting status.
   */
  markProductionJobsStarted: ProductionJobsProgressPayload;
  markProductionLotReady: ProductionLotPayload;
  /** W4. WORKER ONLY. Records a finished COPY (stores the Ramp PO id) or ARCHIVE. A COPY that finishes after its PO was cancelled is recorded, then becomes a PENDING ARCHIVE job at once. */
  markRampPurchaseOrderCopyCompleted: RampPurchaseOrderCopyPayload;
  /** W4. WORKER ONLY. Records a final failure (4xx other than 429, or the retry budget is spent). */
  markRampPurchaseOrderCopyFailedPermanent: RampPurchaseOrderCopyPayload;
  /** W4. WORKER ONLY. Records a retryable failure; wsapi only records the worker's retry values. */
  markRampPurchaseOrderCopyFailedTransient: RampPurchaseOrderCopyPayload;
  /** WORKER ONLY. Ramp refused the tokens (401 or invalid_grant on refresh). Status becomes RECONNECT_NEEDED and the token document is deleted. */
  markRampReconnectNeeded: RampConnectionPayload;
  /** Mark RFID scan records as synced to external system */
  markRfidScansAsSynced: MarkRfidScansAsSyncedPayload;
  /**
   * Marks a rendering batch FAILED and records the reason, so an operator reads what went wrong
   * rather than a bare status. Worker-facing.
   */
  markStatementPrintBatchFailed: StatementPrintBatchPayload;
  /**
   * Marks a rendering batch READY and records the URL it can be downloaded from. Worker-facing, and
   * the only thing that ever sets that URL — the API never composes one.
   */
  markStatementPrintBatchReady: StatementPrintBatchPayload;
  /** WORKER: records provisioning success and the provisioned tenant, keyed by requestId. */
  markTrialRequestProvisioned: TrialRequestPayload;
  /**
   * WORKER: stamps the generated tenant code on an Approved/Linked (or previously Failed) request
   * and moves it to Provisioning, keyed by the public requestId. The stamp is idempotent —
   * re-stamping the same code is a no-op success; a different code is rejected — so the worker can
   * safely retry. Omit tenantCode on the Link path or a retry to reuse the stamped code.
   */
  markTrialRequestProvisioning: TrialRequestPayload;
  /**
   * WORKER: records a (retryable) provisioning failure, keyed by requestId. The stamped
   * tenant code is preserved so the next provisioning attempt reuses it.
   */
  markTrialRequestProvisioningFailed: TrialRequestPayload;
  markUserInviteCompleted: UserInvitePayload;
  markUserInviteEmailFailed: UserInvitePayload;
  markUserInviteEmailSent: UserInvitePayload;
  markUserInviteFailed: UserInvitePayload;
  /**
   * Records one bounded page of the questions a stage raised for one artifact revision on the lineage's
   * question stream. A question keeps its id across restarts and revisions. Worker only.
   */
  materializeMigrationImportQuestions: MaterializeMigrationImportQuestionsPayload;
  mergeBackgroundServiceConfig: AdminBackgroundServiceConfigPayload;
  mergeCarrier: LogisticsCarrierPayload;
  mergeContainerConfig: ContainerConfigPayload;
  mergeCustomer: CustomerPayload;
  mergeDeliverySchedule: DeliverySchedulePayload;
  mergeDriver: DriverPayload;
  mergeErpLoadListUser: ErpLoadListUserPayload;
  /**
   * Upserts the calling tenant's forecast comp settings (one doc per tenant). Refused with a
   * ForecastDisabled error — no event written — when the tenant's
   * Forecast flag is disabled.
   */
  mergeForecastSettings: ForecastSettingsPayload;
  mergeItem: ItemPayload;
  mergeJobWorkOrders: JobPayload;
  /**
   * Issues a Merge.dev link_token for the current tenant. The frontend Merge Link widget consumes
   * this token to launch the connect flow; which connectors the widget offers is controlled entirely
   * in the SF Merge dashboard. The org Merge API key never leaves wsapi. The category argument
   * selects the Merge product category the link is scoped to — accounting (default, unchanged) or
   * CRM.
   */
  mergeLinkToken: MergeLinkTokenPayload;
  /**
   * Creates or full-replace updates one Load. LoadNumber is never a client input:
   *             an existing Load keeps its number; a new one is allocated the next per-tenant sequence
   *             value.
   */
  mergeLoad: LoadPayload;
  mergeLoadLine: LoadLinePayload;
  mergeLogisticsDock: LogisticsDockPayload;
  /**
   * Full-replace merges a route. When the submitted stop list drops a stop that a
   *             LoadLine on one of this route's Loads was pointing at, that LoadLine's stop is cleared in the
   *             same atomic append — the "editing a route's stops clears orphaned load lines" cascade.
   */
  mergeLogisticsRoute: LogisticsRoutePayload;
  mergeMaterialItemByErpId: MaterialItemPayload;
  mergeMergeDevAccount: MergeDevAccountPayload;
  mergeMergeDevPayment: MergeDevPaymentPayload;
  /**
   * Sync-style upsert wrapper around initializeOrder. Returns the existing order
   * unchanged when one already exists at the deterministic OrderId; otherwise runs
   * the full initialize flow. Designed for MergeDev invoice import where the same
   * deterministic OrderId is emitted every sync cycle.
   */
  mergeOrder: OrderPayload;
  /** Creates an order kind, or renames one, by id. Names are unique per tenant, ignoring case and surrounding spaces. */
  mergeOrderKind: OrderKindPayload;
  mergePriceGroup: PriceGroupPayload;
  mergePriceLevel: PriceGroupPayload;
  mergeProductionCategory: ProductionCategoryPayload;
  /** Upserts a production item from an external sync, creating it if new or merging changes if it already exists. */
  mergeProductionItem: ProductionItemPayload;
  mergeProductionPlan: ProductionPlanPayload;
  mergeProductionSpaceCategory: ProductionSpaceCategoryPayload;
  mergeProductionSpaceType: ProductionSpaceTypePayload;
  mergeReplenishmentSettings: ReplenishmentSettingsPayload;
  mergeSiteLocation: SiteLocationPayload;
  mergeVehicle: VehiclePayload;
  mergeVehicleType: VehicleTypePayload;
  mergeVendor: VendorPayload;
  mergeWorkerConfig: AdminWorkerConfigPayload;
  /**
   * One-time, re-runnable operator migration: moves every location's legacy flat, shared-across-
   * space-types capacity onto a per-space-type capacity row against that location's default space
   * type. Locations with non-zero flat capacity but no default space type are left un-migrated and
   * returned on the payload for a human to assign a default before re-running. This goes through
   * the real setSpaceTypeCapacity command path rather than a direct database write, so the
   * migrated capacity survives later edits and a full read-model rebuild.
   */
  migrateFlatLocationCapacityToSpaceType: FlatCapacityMigrationPayload;
  /**
   * Issues a single-use, short-TTL handoff code that lets input.targetDomain pick up the
   * caller's just-completed session. Called by the canonical host once PKCE returns.
   */
  mintPortalSessionHandoffCode: PortalSessionHandoffMintPayload;
  /** Moves inventory from one location to another. */
  moveInventoryItem: InventoryItemMovePayload;
  moveMaterialItem: MaterialItemLocationQuantityPayload;
  /**
   * Opens a new collection cycle window for input.communityId with input.periodIds, input.label, and input.dueAt
   * (contracts C12 and D9). Restricted to effective COMMUNITY_ANALYST roster holders and platform superadmins;
   * refuses with GROWER_BENCHMARKS_CYCLE_ALREADY_OPEN when a cycle is already open on the community or already exists for
   * that period.
   */
  openGrowerBenchmarkCycle: GrowerBenchmarkCyclePayload;
  /**
   * Moves a Drafted GrowerBenchmark review into InEdit and starts reviewer edit-time metering on the aggregate
   * (contracts R2 and R4). Restricted to effective COMMUNITY_ANALYST roster holders and platform superadmins.
   */
  openGrowerBenchmarkReviewForEdit: GrowerBenchmarkReviewPayload;
  /**
   * D2 — overriding an inherited category event clones it into a recipe-scoped event and excludes
   * the original on the named variation. The clone starts as an exact copy of the source event's
   * name and active items; item edits afterward go through the clone's own existing add/update/
   * remove-detail mutations, unchanged by this command.
   */
  overrideInheritedEventForRecipe: OverrideInheritedEventForRecipePayload;
  /** Overrides the pricing of an existing order-line upgrade. */
  overrideOrderLineUpgradePricing: OrderPayload;
  overrideProducedQuantity: ProductionLotPayload;
  overrideProductionJobLocation: ProductionLotPayload;
  overrideProductionJobQuantity: ProductionLotPayload;
  overrideProductionJobWeekReady: ProductionLotPayload;
  overrideProductionJobWeekStart: ProductionLotPayload;
  overrideProductionJobYield: ProductionLotPayload;
  overrideProductionLotCustomer: ProductionLotPayload;
  /**
   * Sets a production lot's own customer group. The group must exist (active, same tenant) and, when
   * the lot has a customer, that customer must be in the group. The job chain is not rebuilt and
   * recipes on existing jobs are not re-resolved — same as a customer override.
   */
  overrideProductionLotCustomerGroup: ProductionLotPayload;
  overrideProductionLotQuantity: ProductionLotPayload;
  /**
   * Consolidated override mutation covering six per-row bulk operations: Add, Subtract,
   * Replace, ToDemand, ToAchievable, ToTargetWeeksOfSupply. Replaces the seven per-operation
   * mutations from Restock 1.x. When RestockOverrideType.ToTargetWeeksOfSupply is
   * selected the handler resolves quantities from the on-demand calc lane —
   * RestockCalcResults at the target weeks of supply, enqueueing cache misses for the
   * wsapi-services drain — so override, recalc, and session creation share one quantity
   * source; for all other types the entity computes the new per-row quantity inline. Undo
   * continues to flow through UndoRestockSessionOrderQuantityOverride pending
   * semantics redesign — see helm task 89e727277e9640228e5d23e22a646911.
   */
  overrideRestockSessionOrderQuantities: RestockSessionPayload;
  patchBatchAdminTenant: Array<AdminTenantPayload>;
  patchItem: ItemPayload;
  pauseCountSession: CountSessionPayload;
  /**
   * Asks the worker to pause the run at its next safe boundary. Records the request on the run's control
   * stream and stops nothing by itself.
   */
  pauseMigrationImportRun: MigrationImportRunControlPayload;
  /** Pauses an active rollout at the named ring; a paused rollout targets no device until it is resumed. */
  pauseOtaRollout: OtaRolloutPayload;
  /**
   * Pins a run so retention keeps it: indefinitely when until is null, otherwise until that
   * instant, which must be after now. Replaces any earlier pin on the run.
   */
  pinQaTestRun: QaTestRunPayload;
  /**
   * Places an order on hold, with a reason. While the hold stands the order cannot be picked, shipped,
   * verified, closed or dispatched on a load: each of those is refused with ORDER_ON_HOLD (a load dispatch
   * with DELIVERY_BLOCKED_BY_HELD_ORDERS), in a message that names the order by its number and gives the
   * reason. Allocation, acknowledgment, edits, cancel and delete are unaffected. The reason is required: it
   * is trimmed and must then carry text, up to 1024 characters. A hold can be placed on an order that is
   * Initialized, Open, Submitted, Acknowledged or Picked; any other status is refused with
   * ORDER_HOLD_STATUS_NOT_ALLOWED. An order that is already on hold is refused with ORDER_ALREADY_ON_HOLD,
   * so release it first to change the reason. The hold records who placed it and when. Staff only: a
   * customer-portal caller is refused with ORDER_HOLD_STAFF_ONLY and nothing is recorded.
   */
  placeOrderHold: OrderPayload;
  /**
   * Saves the run's dry run as its next plan revision: every row is planned from its aggregate, recording the stream
   * versions read and the before and after values, or marked Failed with the reason. Writes nothing to the data
   * being corrected. The plan records the requester's approval of it, and every approval of an earlier revision
   * stops counting. Only the requester plans (CORRECTION_PLAN_BY_REQUESTER_ONLY), and only a Finding,
   * Planned or Approved run.
   */
  planCorrectionRun: CorrectionRunPayload;
  /**
   * Creates one unassigned Move task per job, due on moveDate, carrying the move. A job's earlier open Move
   * task is cancelled in the same append. Runs the same checks as updateProductionJobLocation (site scope,
   * at most 100, no duplicate jobs, destinations exist and are not combined), and refuses a lot that is not planted
   * yet and a destination the job is already at.
   */
  planProductionJobMoves: PlanProductionJobMovesPayload;
  /**
   * Posts a set of cycle counts for a store location.
   * Each count SETS (hard-counts) the inventory quantity for that item at that location.
   * Items not included in the submission are unaffected — a separate scheduled process
   * handles the zero-out window.
   */
  postCycleCounts: CycleCountPayload;
  postProductionJob: ProductionLotPayload;
  postProductionJobs: PostProductionJobsPayload;
  /**
   * Checks the module's guards for the tenant and, when they all hold, runs its pre-reset steps — for PRODUCE,
   * clearing every PRODUCE link and field on other modules' records by event. A refusing guard changes nothing
   * and is reported as ready: false with the reason. Idempotent: once prepared, a repeat writes nothing.
   * An unknown module is an UNKNOWN_RESET_MODULE error; a step that fails is an error, and the steps
   * already run stay done. createdFrom / createdTo (inclusive days on the tenant's clock) limit an
   * ORDERS reset to orders created in that range; a range for any other module is
   * RESET_RANGE_NOT_SUPPORTED. Pass the same range the manifest was read with.
   */
  prepareTenantModuleReset: TenantModuleResetPreparation;
  /**
   * Records that fernie showed the grower the review of one current portion or settings revision in this chat
   * turn, and returns the presentation id the approval must carry. A repeat in the same turn returns the
   * recorded presentation. A superseded, missing or not-ready subject is refused.
   */
  presentMigrationReview: MigrationPresentationPayload;
  /**
   * Records that a support summary, with the staff route it would go to, was shown to the grower for review.
   * Nothing is sent and nothing is accepted: the grower sends it in a later message with
   * submitOnboardingHelpRequest.
   */
  presentOnboardingHelp: PresentOnboardingHelpPayload;
  processErpLoadListSession: ErpLoadListSessionPayload;
  processOnHandAdjustment: OnHandProcessPayload;
  /**
   * Promotes a rollout from the named ring once that ring meets its success threshold and not its halt threshold,
   * opening the next non-empty ring or completing the rollout.
   */
  promoteOtaRolloutRing: OtaRolloutPayload;
  /**
   * Saves a prorate across many orders in one call: for each order line sent, its acknowledged
   * quantity, its override price and its General note, whichever of the three are sent. Only Submitted,
   * Acknowledged and Picked orders are prorated; master, credit and invoiced orders, and orders in any
   * other status, are skipped with a reason. The ordered quantity is never changed.
   */
  prorateOrderLines: ProrateOrderLinesPayload;
  /**
   * UNAUTHENTICATED acceptance. Validates the code against the read model, then appends the
   * acceptance to the aggregate via a revision-pinned (optimistic-concurrency) append: the
   * expected stream revision is captured when state is loaded, so two concurrent accepts that
   * both observe the Unused revision cannot both append — the loser fails
   * WrongExpectedVersion (surfaced as EntityAlreadyExists) and receives the
   * terminal validity from the read model, never Valid. Single-use is therefore enforced at the
   * aggregate (atomic, not merely by the EnsureCanAccept guard), keyed by the 154-bit
   * unguessable code. No password is collected: the wsapi-services worker creates the
   * FusionAuth user with sendSetPasswordEmail = true within ~one tick.
   */
  publicUserInviteAccept: PublicUserInviteAcceptPayload;
  /**
   * Publishes the trusted, non-secret staff route for the worker's tenant: the existing data-received
   * staff-flow policy, a revision, a fingerprint of the intended audience and destinations, the audience in
   * words and the channels. A later revision replaces it; the same content again changes nothing.
   */
  publishOnboardingHelpRoute: PublishOnboardingHelpRoutePayload;
  /**
   * Publishes a Draft OTA release so rollouts can target it. Publishing an already-published release changes nothing,
   * and a halted release can never be published again.
   */
  publishOtaRelease: OtaReleasePayload;
  publishRestockWorkQueueResultBatch: RestockWorkQueueResultBatchPublishedPayload;
  /** WhatsNewPublisher. Replaces the tenant's run-published Coming soon features; staff-edited ones stay. */
  publishWhatsNewComingSoon: PublishWhatsNewPayload;
  /** WhatsNewPublisher. Replaces the release's run-published features; staff-edited ones stay. */
  publishWhatsNewRelease: PublishWhatsNewPayload;
  /**
   * Purges one record whose retention period has passed and that nothing holds, or says why not. Deletes
   * bulky content only and never an event. A repeat changes nothing. Worker only.
   */
  purgeMigrationRecord: MigrationRecordPurgePayload;
  queueOnHandAdjustment: OnHandProcessPayload;
  /** WhatsNewPublisher. Queues the release's email once. */
  queueWhatsNewEmail: QueueWhatsNewEmailPayload;
  /**
   * Records the pairs the finder found. A pair already open or cleared is left as it is and its key is still
   * returned; a resolved pair opens again with the new judgment. Worker only.
   */
  raiseDuplicateCandidates: DuplicateCandidateIdsPayload;
  /**
   * Raises the migration-status notice for one recorded outcome of an import run to the customer's team: its
   * verified completion summary, its failure, or one block episode. Refused unless the run's recorded state shows
   * that outcome and the source key is the one the outcome is keyed by. A repeat changes nothing and sends
   * nothing; pause, resume and cancel raise none. Writes notification rows only. Worker only.
   */
  raiseMigrationStatusNotice: RaiseMigrationStatusNoticePayload;
  /**
   * Raises a batch of notifications with no carrying event, one row per entry.
   *
   *
   * **Returns:**
   * The row each entry now stands as, in the same order as the input batch.
   */
  raiseNotifications: RaiseNotificationsPayload;
  /** Reactivates a deactivated entry so orders can pick it again. */
  reactivateFlatChargeType: FlatChargeTypePayload;
  /**
   * Reactivates a previously deactivated user, restoring the directory entry to Active.
   * Reactivating a user that is already active is rejected with a typed error, and so is one whose
   * customer is combined into another (CUSTOMER_COMBINED). Admin/SuperAdmin
   * gated: restoring access is the same authorization decision as revoking it, and an ungated
   * reactivate would simply undo every deactivation an admin performed.
   *
   * No self-guard here, deliberately, and the asymmetry with deactivateUser is the point:
   * reactivating oneself is not reachable in the first place. A caller can only satisfy the Admin
   * gate through an Active directory entry (CallerUserResolution is Active-only) or
   * as a superadmin, and an Active entry is not a candidate for reactivation — the domain's
   * EnsureInactive rejects it. There is no self-elevation to block.
   */
  reactivateUser: UserPayload;
  /**
   * Brings a retired volume pool back into service, clearing its retirement and returning it to the
   * default volumePools listing so price levels can be assigned to it again. Always explicit:
   * reactivating changes which order lines pool together toward a volume break, so no other mutation
   * does it as a side effect. Reactivating a pool that is already active succeeds and changes nothing.
   * Refused with a payload error when another active pool in the tenant has taken the code.
   */
  reactivateVolumePool: VolumePoolPayload;
  reapplyRecipes: ReapplyRecipesPayload;
  /**
   * Reassign an open assignment to a different worker (Round 8 finding). The caller's
   * userId becomes ReassignedBy. Rejected once the assignment is Completed or
   * Cancelled; reassigning to the current worker is an idempotent no-op.
   */
  reassignCountAssignment: CycleCountAssignmentPayload;
  /**
   * Reassign a task assignment to a different worker. The assignee must be an active user of the tenant;
   * the choice is kept by Reapply Recipes.
   */
  reassignTask: TaskAssignmentPayload;
  reassignWsapiImportIntegration: WsapiImportPayload;
  /**
   * Rebuilds the weekly retail-history cache for customerId in the calling tenant and reports how many
   * buckets were written, how many stale buckets were removed, how many unmapped daily rows were skipped,
   * and the history through-date. Replay-idempotent: a re-run over unchanged ImportData leaves
   * byte-identical documents.
   */
  rebuildForecastWeeklyHistory: ForecastWeeklyHistoryRebuildPayload;
  /**
   * BYOA-v1 recalc (RC5), synchronous and always the whole session. Enumerates the session's
   * existing rows, enqueues each (tenant, customer, item, location, wos) tuple into
   * RestockCalcOnDemandWork for the wsapi-services drain, polls RestockCalcResults
   * until every row has a CalcDate at or after the request stamp, then records its own
   * request, the fresh demand/achievable values and its Completed terminal in one append. The
   * payload's requestId is the session's new lastRequestId; on a timeout nothing is written and
   * lastRequestId does not move, so a caller whose response was lost can tell whether the
   * recalculation landed. Refused with RESTOCK_CALC_ALREADY_IN_PROGRESS while a requested
   * calculation is InProgress. Per-row user overrides survive: the patch record carries no
   * OrderQuantity, so WorkSuite.Domain.Restock.Session.RestockSessionState's patch
   * apply leaves existing override state untouched.
   */
  recalculateRestockSession: RestockSessionPayload;
  /**
   * Record receipt of an in-flight MovementOrder. Transitions Shipped → Received.
   * Identical retries are deterministic no-ops.
   */
  receiveMovementOrder: MovementOrderPayload;
  receiveVendorPurchaseOrderItems: VendorPurchaseOrderPayload;
  /**
   * On-demand tenant-scoped rebuild of the SpaceUsage read model. The SpaceUsage projection only
   * recomputes a job when an event it subscribes to arrives, so documents written before the
   * interval model stay on their old shape for as long as nothing touches their job, and the events
   * that WOULD touch them have already been consumed. Replaying the $all stream to reach them
   * is forbidden; a SCOPED reset of this projection's own EntityCheckpoint is not — that is
   * the mechanism atlas practice b4c5d6e7f8a90b1c2d3e4f5a6b7c8d90 prescribes under "Projection
   * re-runs" — but it is still the wrong tool here. It rewrites in place without dropping the
   * collection, and this projection plans a job partly from documents it wrote itself, so a replay
   * from 0 over a populated collection reads its own pre-replay output as input. This mutation
   * re-plans every job of one tenant through the projection's own single write path, with the
   * collection's current state as the deliberate starting point. That includes jobs with no space
   * event, which book their default space from start through ready, so it is also how a lot created
   * before that rule reaches the board.
   */
  recomputeSpaceUsage: RecomputeSpaceUsagePayload;
  /**
   * Resolve a shipped-vs-received variance on a received MovementOrder. Transitions
   * Received → Reconciled; the aggregate is terminal after reconciliation.
   */
  reconcileMovementOrder: MovementOrderPayload;
  /**
   * Delivers a product line to its devices' twins again: every device is converged on the line's current resolution, and
   * writes whose writers stopped before checking the fence are finished.
   */
  reconcileOtaDeliveries: OtaReconcilePayload;
  /**
   * Confirms a changed staff route on an accepted request. When a worker holds a channel because the route
   * changed after the grower reviewed it, the grower reviews the new route (presentOnboardingHelp
   * with the same content records that review) and confirms it here in a later message.
   */
  reconfirmOnboardingHelpRoute: ReconfirmOnboardingHelpRoutePayload;
  /**
   * Resolves the tenant's existing Merge.dev linked account server-side and reactivates the
   * integration with no public-token exchange. Covers the disconnect-then-reconnect path: when
   * Merge still holds the link, the Merge Link widget shows "You're connected!" and closes
   * firing only onExit, so the frontend never receives a public token for completeMergeLink.
   * The account token retained on TenantState (it survives deleteTenantIntegration; Merge
   * tokens do not rotate) is verified against Merge's account-details endpoint before the
   * integration is upserted. A tenant with no still-valid Merge linked account gets a clear
   * GraphQL error, never a silent no-op; the deterministic IntegrationId plus the upsert's
   * change guard make the reconnect idempotent when the integration is already active.
   */
  reconnectMergeLink: TenantPayload;
  /**
   * Records the export worker's report that the accounting provider definitively refused to
   * create the placeholder item for one (purpose, account ImportId) pair, so the refusal can be
   * shown beside the setting it concerns. Idempotent per (tenant, purpose, account ImportId): a
   * repeated report succeeds, writes nothing, and keeps the first refusal. A report for a line
   * purpose whose configured account has since changed also succeeds without recording anything.
   * Worker only.
   */
  recordAccountingPlaceholderRefusal: AccountingIntegrationConfigPayload;
  /** Records what the grading worker made of one leased photo. */
  recordAvailabilityPhotoGrade: RecordAvailabilityPhotoGradePayload;
  /** Opens a 7-day YES request. The YES text goes out through the delivery queue (W3). */
  recordContactTextConsent: ContactTextConsentPayload;
  /**
   * Records one idempotent processing step. A duplicate completion of the same step name within
   * the current generation is a no-op success, so the worker can safely retry after a crash.
   */
  recordContractRecordEnrollmentStepCompleted: ContractRecordPayload;
  /**
   * Records one idempotent fee-processing step. A duplicate completion of the same step name
   * within the current fee generation is a no-op success, so the worker can safely retry after a
   * crash.
   */
  recordContractRecordFeeStepCompleted: ContractRecordPayload;
  /**
   * Records that some of a customer's unapplied credit was paid back to them outside WorkSuite — by check,
   * ACH, a card refund made by hand, or otherwise. Nothing is sent to Stripe. The amount may not exceed the
   * customer's unapplied credit. Send a refundId to make the request safe to retry.
   */
  recordCustomerCreditRefund: CustomerCreditPayload;
  /**
   * Reports the outcome of one leased customer message. A send is final; a failure either schedules
   * another attempt or spends the last one, and a permanent failure is final at once.
   *
   *
   * **Returns:**
   * The row as it now stands.
   */
  recordCustomerDelivery: CustomerDeliveryPayload;
  /** Throws a GraphQL error with code CUSTOMER_TEXT_REPLY_FAILED on a write failure so the relay retries. */
  recordCustomerTextReply: RecordCustomerTextReplyResult;
  /** Throws a GraphQL error with code CUSTOMER_TEXT_STATUS_FAILED on a write failure so the relay retries. */
  recordCustomerTextStatus: RecordCustomerTextStatusResult;
  /**
   * Records a firmware report forwarded by ingestion, keyed by the device and its persisted sequence: a redelivery returns
   * the original disposition and changes nothing. An otaResult moves the device's offer only when it names that offer's
   * rollout and authorization and the build it reports matches the offer; a report without one is a birth, whose version
   * is kept as evidence. A failure that puts its ring over the halt threshold halts the rollout and revokes the ring.
   */
  recordDeviceFirmwareReport: OtaFirmwareReportPayload;
  /**
   * Records a SendGrid delivery event, correlating it to a send by message id and recipient. When a correlated
   * send is found, the delivery ledger write AND an absolute delivery rollup onto the send are
   * emitted in one atomic multi-stream transaction (Atlas 2a4e5847), so the send's persisted
   * DeliveryStatus is failure-filterable by an indexed query. When no send is found yet
   * (a delivery that raced ahead of its send), only the ledger is written and the query-time read
   * fallback surfaces the outcome until a later event rolls up.
   * Worker-tier only via [Authorize(Policy = Policies.WorkerService)] (role
   * workerservice), mirroring the MergeDevExport worker-outcome mutations: its
   * FindCorrelatedSend lookup is deliberately NOT tenant-scoped (the SendGrid webhook
   * responder authenticates as the System tenant and correlates cross-tenant by the SendGrid
   * message id and recipient), so a tenant JWT is rejected here rather than being able to forge
   * DeliveryStatus/classification onto another tenant's send read-model.
   */
  recordEmailDelivery: EmailDeliveryPayload;
  /** Records a single email send. Called by each send path after dispatching to SendGrid. */
  recordEmailSend: EmailSendPayload;
  /**
   * Records, for one queued GrowPoint commit, the Synchronization iteration id of the import run
   * and each reviewed row's outcome (created, updated, failed or unknown) with its canonical
   * entity id. Gated to the wsapi-services worker tier. Idempotent per commit and row: a row that
   * already has an outcome keeps it, whatever a repeat sends. Once every reviewed row has an
   * outcome the commit's status becomes COMPLETED. Returns the commit with every outcome as
   * recorded.
   */
  recordGrowPointCommitOutcomes: RecordGrowPointCommitOutcomesPayload;
  /**
   * Records one CSV wizard run and the rows it could not load. Recording a STARTED session again replaces it; a
   * session with a final status is refused any different record, and the same record again changes nothing. A
   * record is refused when it sends more rows than failedRows, or reports COMPLETED with failedRows above 0.
   */
  recordImportSession: RecordImportSessionPayload;
  /** Records money received against one or more issued invoices as a single payment. */
  recordInvoicePayment: RecordInvoicePaymentPayload;
  /**
   * Records the caller's answer to a concept's check. A correct answer is never downgraded, and a
   * replay keeps the first time.
   */
  recordLearningCheckAnswered: LearningConceptPayload;
  /**
   * Records that the caller was shown a concept's explanation. A replay keeps the first time and only
   * moves the last activity forward.
   */
  recordLearningConceptExplained: LearningConceptPayload;
  /**
   * Records a walkthrough outcome for the caller. COMPLETED and ABANDONED record how the run of a
   * concept's walkthrough ended: the concept is required, the walkthrough must be its own, and the
   * payload answers the concept. A completed walkthrough is never downgraded. OFFERED and DISMISSED
   * record tour state keyed by the walkthrough: the concept is optional and never stored, but when given
   * the walkthrough must be its own, and the payload answers the walkthrough. Every outcome is
   * idempotent and a replay keeps the first time.
   */
  recordLearningWalkthroughOutcome: LearningWalkthroughOutcomePayload;
  /** Records what happened to one claimed load email. */
  recordLoadEmailOutcome: LoadEmailPayload;
  /**
   * Records a manually-entered cost against a production job. The command is validated, appended
   * to the job cost ledger stream, and the persisted cost record is returned in the payload.
   *
   *
   * **Returns:**
   * A payload containing the recorded cost record, or validation errors.
   */
  recordManualJobCost: JobCostPayload;
  /**
   * Records a single receipt against an open material order line for the calling BPF field user.
   * Validates against the worker-owned ErpOrders read model (order + line exist, a vendor lot on an
   * organic line, quantity > 0 and no more than the line's receivable quantity), saves an
   * immutable receipt audit record with its lot trimmed and upper-cased, then enqueues a Material ERP
   * write-back for the receipt post-back worker with the receipt's bin and recorded time. Idempotent
   * on IdempotencyKey: a duplicate submit returns the saved receipt, finishing its enqueue if that
   * was interrupted, and never saves or enqueues twice.
   */
  recordMaterialReceipt: MaterialReceiptPayload;
  /**
   * Records 2 to 20 receipts of one order line into one bin, each with its own vendor lot and
   * idempotency key, as one group for the calling BPF field user, and enqueues ONE Material ERP
   * write-back that carries every lot once every receipt is saved. All or none: a receipt that
   * fails validation, or a key that already holds a receipt this call does not repeat, refuses the
   * whole call and receipts is empty. Replaying the same body returns the group and finishes one
   * that was interrupted.
   */
  recordMaterialReceiptGroup: MaterialReceiptGroupPayload;
  /**
   * Records a grower's correction to prepared rows when no question is open for it, as a grower-raised
   * question with its answer, and re-queues the revision's job so the next stage applies it. When those rows
   * or the job's prepared data are past their retention period nothing is recorded: expired, needs preparation.
   */
  recordMigrationImportCorrection: MigrationImportAnswerPayload;
  /**
   * Reads one page of at most 1000 of the operations a verified import run's verification recorded again, within 60
   * seconds, and records how they read once as that page of a paced confidence observation of the run, for a run too
   * large for a bounded confidence read. Answers the next page to read, or, once the observation's pages cover every
   * verified operation, the observation, recorded once. Never changes the run, its verification or a receipt. A
   * repeat of a page answers from the recorded page; a run with no verification, or a page outside the run's pages,
   * is refused. Worker only.
   */
  recordMigrationImportRunObservation: RecordMigrationImportRunObservationPayload;
  /**
   * Records the verification of the applied import run the caller holds, once, and completes the run: the one call
   * that moves a run from Applied to Completed. Refused, changing nothing, while a pause, resume or cancel newer than
   * the acknowledged control is pending. A repeat under the claim that completed the run answers from the recorded
   * evidence. Worker only.
   */
  recordMigrationImportRunVerification: RecordMigrationImportRunVerificationPayload;
  /**
   * Records what one preparation stage ended with and moves the job. A repeat returns the recorded
   * result. Worker only.
   */
  recordMigrationPreparationStageResult: MigrationPreparationStageResultPayload;
  /**
   * Records the settings a grower is asked to approve, each with the value shown as current and the value
   * proposed, and returns the revision to present. Unsupported settings, values the setting does not take, values
   * that are no longer current and settings the caller may not change are refused, with nothing recorded. The same
   * key returns the same revision; the same key with other changes is refused.
   */
  recordMigrationSettingsRevision: MigrationSettingsRevisionPayload;
  /**
   * Completes a validation run whose every page is recorded: its questions, its ready portion and its
   * receipt, written once. Moves no job; the stage result reads the receipt. Worker only.
   */
  recordMigrationValidationCompletion: RecordMigrationValidationCompletionPayload;
  /**
   * Reports the outcome of one leased notification. A send is final; a failure either schedules
   * another attempt or spends the last one.
   *
   *
   * **Returns:**
   * The row as it now stands.
   */
  recordNotificationDelivery: NotificationDeliveryPayload;
  /** Reports the outcome of one leased channel: SENT, FAILED, UNAVAILABLE, UNCERTAIN or HELD. */
  recordOnboardingHelpDelivery: RecordOnboardingHelpDeliveryPayload;
  /**
   * Records that a staff member has acknowledged an accepted request, or resolved it. Resolving needs a
   * prior acknowledgement; a step already recorded changes nothing.
   */
  recordOnboardingHelpRequestHandling: RecordOnboardingHelpRequestHandlingPayload;
  /**
   * Records one journey fact: a scope selection or deferral, a goal, the no-files path, a dependency
   * reason, a validated observation or a model note. Changing scope records another fact; nothing is
   * ever rewritten.
   */
  recordOnboardingJourneyFact: OnboardingJourneyCommandPayload;
  /**
   * Records that a chat session loaded the journey. Sent once per session by the chat service itself;
   * a repeat from any turn of the same session changes nothing. Reading the journey writes nothing.
   */
  recordOnboardingJourneySessionLoaded: OnboardingJourneyCommandPayload;
  /**
   * Records a deposit against an order. The deposit is written as a Kind = Deposit entry on
   * the order's payment ledger (a FULFILL-local concept, not pulled from an accounting
   * integration), counts toward the order's amount paid, and can satisfy the customer's deposit
   * requirement so the order can be allocated. Refused with ORDER_INVOICED_DEPOSIT while the
   * order has a live invoice: money received once the bill stands is recorded as a payment on the
   * invoice in Receive Payments.
   */
  recordOrderDeposit: OrderPayload;
  /**
   * Records a manual payment against an order's payment ledger (full or partial amount),
   * appending a manual entry and recomputing the order's amount-paid, balance, and payment
   * status. Available to integrated tenants too: an integrated tenant's entry is recorded
   * FULFILL-only (order-level payments are never exported) and its sync status reads
   * RECORDED_LOCALLY_ONLY. Multiple manual payments accumulate into a payment history.
   * Deprecated: money received before the invoice is a deposit (recordOrderDeposit), and money
   * received after it is a payment on the invoice (recordInvoicePayment). A payment recorded here is
   * still carried onto the order's invoice when the invoice is issued.
   * @deprecated Record money received before the invoice with recordOrderDeposit, and money received after it with recordInvoicePayment. Payments recorded here are carried onto the order's invoice when it is issued.
   */
  recordOrderPayment: OrderPayload;
  /**
   * Records where a puller took each order line from, and moves each line's allocation to where it was pulled.
   * A pull is recorded with who pulled and when, and a repeat of a pullAttemptKey the order already holds
   * changes nothing. After the pull the line's allocation is what was pulled, by location and grade, plus any
   * part not yet pulled left where it was, so availability is right at both locations. On-hand is not touched:
   * shipping takes it from where the line is allocated, which is now the pulled-from location.
   */
  recordOrderPulls: OrderPayload;
  /** Records a new report execution. */
  recordReportExecution: ReportExecutionPayload;
  recordShrinkEvent: ProductionLotPayload;
  /**
   * Applies one inbound carrier STOP or START to every user in the named tenant who holds the
   * number it came from. STOP stops the SMS channel for that handset; START starts it again.
   *
   *
   * **Returns:**
   * How many users matched, and whether anything was written.
   */
  recordSmsCarrierOptOut: RecordSmsCarrierOptOutResult;
  /**
   * Applies one Twilio delivery-status webhook to the row whose SMS block carries the given
   * provider message id.
   *
   *
   * **Returns:**
   * What happened to the row, and its resulting SMS status.
   */
  recordSmsDeliveryStatus: RecordSmsDeliveryStatusResult;
  /**
   * Records a route stop as fully delivered. Only accepted while the load is Dispatched;
   *             per-order quantities cannot exceed the stop's load-line allocation. Orders with no carts accept 0/0.
   *             Refused with ORDER_INVOICED when it would change what an order with a live invoice bills.
   */
  recordStopDelivered: DeliveryPayload;
  /**
   * Records a route stop as partially delivered. Only accepted while the load is
   *             Dispatched; per-order quantities cannot exceed the stop's load-line allocation. Each order's portion
   *             is judged by its own quantities: nothing delivered is Failed Delivery, everything delivered is
   *             Delivered, anything between is Partially Delivered. Orders with no carts accept 0/0 and are Delivered.
   *             Each order's optional billing choice sets what
   *             it bills. Refused with ORDER_INVOICED when it would change what an order with a live invoice
   *             bills.
   */
  recordStopPartiallyDelivered: DeliveryPayload;
  /**
   * Records a route stop as fully refused. Only accepted while the load is Dispatched;
   *             per-order quantities cannot exceed the stop's load-line allocation. Orders with no carts accept 0/0.
   *             Each order's portion is judged by its own quantities (nothing delivered is Failed Delivery, including
   *             orders with no carts), and each order's optional billing choice sets what it bills. Refused with
   *             ORDER_INVOICED when it would change what an order with a live invoice bills.
   */
  recordStopRefused: DeliveryPayload;
  /**
   * Stamps the calling staff user's own directory record with the current time as their last-active
   * moment, throttled server-side to once per hour so a misbehaving client cannot spam writes.
   * Always reports success -- an activity heartbeat must never surface an error to the caller, so
   * any failure (no directory entry, a transient write error) is logged and swallowed internally.
   */
  recordUserActivity: Scalars['Boolean']['output'];
  /**
   * Applies a batch of FusionAuth last-login instants to the caller's tenant. The tenant is always
   * the caller's own JWT tenant, never part of the input -- an entry cannot reach another tenant's
   * document. Each entry's fusionAuthUserId is validated as a GUID before anything is
   * written; a malformed id fails the whole batch loudly (a populated errors array), naming
   * the offending index and value, rather than silently reporting updatedCount = 0. Entries
   * sharing the same fusionAuthUserId within one batch are collapsed to the single LATEST
   * instant before the write, so a duplicated id can never inflate updatedCount. A monotonic
   * guard (lastLoginAt unset, or strictly older than the incoming instant -- an EQUAL instant
   * does not re-advance) is re-asserted atomically at the database via the filter on each per-row
   * update, so a stale or replayed page can never move a user's last-login backwards; an entry whose
   * fusionAuthUserId matches no row in the tenant is likewise excluded from the match, not an
   * error. One bulk write carries every row in a single round-trip rather than looping per entry.
   *
   * Gated to the wsapi-services worker tier (a service-account JWT), NOT the broader staff
   * gate recordUserActivity uses: that mutation only ever stamps the CALLER's own row, so any
   * staff JWT is safe; this mutation writes OTHER users' rows keyed by a client-supplied
   * fusionAuthUserId, so an ordinary staff caller must not be able to forge another user's
   * last-login.
   */
  recordUserLastLogins: RecordUserLastLoginsPayload;
  /** WorkerService. Records one batch attempt. */
  recordWhatsNewEmailBatchOutcome: RecordWhatsNewEmailBatchOutcomePayload;
  /**
   * Works out what this order's sales tax would be if it were billed exactly as it stands, and saves
   * that estimate on the order.
   */
  refreshOrderTaxEstimate: RefreshOrderTaxEstimatePayload;
  /** Refreshes (polls) a sender's verification status from SendGrid. */
  refreshTenantEmailSenderStatus: TenantEmailSenderPayload;
  refreshTenantIntegrationTokens: TenantIntegrationTokensPayload;
  /**
   * Re-reads the calling tenant's Stripe Tax readiness from Stripe (Tax Settings API, scoped to the
   * tenant's connected account by the Stripe Tax adapter) and records it on the tenant —
   * the manual half of the readiness refresh; the account.updated webhook is the automatic
   * half, so the gate stays webhook-fresh rather than only as fresh as the last click.
   *
   * A tenant with no connected account is NOT pre-guarded here: the adapter already refuses a blank
   * connected account with the typed StripeTaxNotReadyError before constructing any Stripe
   * client, and that error is surfaced on the payload rather than swallowed — one guard, one message,
   * no second copy to drift. An unmapped Stripe status is likewise surfaced as an error rather than
   * guessed at (see StripeConnectRequestFactory.MapTaxSettingsStatus): the gate must never be
   * moved by a status wsapi does not understand.
   *
   * Recording is idempotent and change-scoped — re-clicking with nothing changed is a successful
   * no-op that appends no event.
   * Restricted to Admin, Finance or superadmin callers; any other staff caller gets a payload error.
   */
  refreshTenantStripeTaxReadiness: TenantStripeConnectPayload;
  /**
   * Grower finance staff: refund one of your succeeded online payments through Stripe, in full or in part, with a
   * required reason; who asked and when are recorded. Target PAYMENT takes the refund off the payment's unapplied
   * credit first, then its invoices; UNAPPLIED_CREDIT refunds only the credit it left. Nothing moves in Work Suite
   * until Stripe confirms the refund: the result is pending until then. refundRequestId is required: make one per
   * refund and send the same one on every retry, so a retry can never refund twice. No payer card or bank details
   * are asked for.
   */
  refundOnlinePayment: RefundOnlinePaymentPayload;
  /**
   * Issues the caller a fresh set of recovery codes, invalidating every code previously issued to
   * them.
   *
   *
   * **Returns:**
   * The new codes, or why they could not be issued.
   */
  regenerateMyMultiFactorRecoveryCodes: MultiFactorRecoveryCodesPayload;
  registerCount: CountSessionPayload;
  /**
   * Mints a new device in the registry (SuperAdmin/factory only), provisions its Azure IoT Hub
   * identity, and assigns it to the tenant the physical unit is being shipped to — assignment scopes
   * who can see it in deviceLobby and who may claim it, but confers no ownership yet. Returns
   * the plaintext claim code AND the device's connection credential exactly once, in this response and
   * nowhere else: neither is stored, so a lost one cannot be recovered. The code lapses 30 days after
   * registration (claimCodeExpiresAt).
   *
   * The hub identity is created DISABLED. A registered device can therefore be flashed with its
   * credential at the factory but cannot connect until a tenant claims it, which is the moment there
   * is an owner to attribute its data to.
   */
  registerDevice: RegisterDevicePayload;
  /**
   * Registers a member firm in a GrowerBenchmark community, or updates label and classification on an
   * already-registered firm while leaving its reporting units unchanged (contract C5 and C7). Requires an
   * effective COMMUNITY_ADMIN roster entry (or platform superadmin).
   */
  registerGrowerBenchmarkFirm: GrowerBenchmarkCommunityPayload;
  /**
   * Enrolls the browser the caller is signed in on to receive push notifications, or refreshes it
   * if it is already enrolled. Safe to call on every page load: the same device converges on one
   * registration rather than accumulating them.
   *
   * The device is enrolled for the caller and no one else. Registering a device someone else was
   * last signed in on transfers it, which is what a shared machine needs — the previous user stops
   * receiving on it the moment the new one enrolls.
   *
   *
   *
   * **Returns:**
   * The registration as it now stands.
   */
  registerMyPushSubscription: PushSubscriptionPayload;
  /**
   * Registers one completed upload for preparation in the tenant's journey, and in the same command
   * creates its preparation job in Pending: the durable preparation intent the preparation worker
   * discovers and claims. Nothing else starts preparation. A repeat returns the same job.
   */
  registerOnboardingUpload: OnboardingUploadRegistrationPayload;
  /**
   * Mints a fresh claim code for a device still in the LOBBY, addressed by the serial printed on the
   * unit, and returns the new plaintext exactly once — in this response and nowhere else. The old
   * code stops working immediately, and the 30-day window restarts from this call. Applies whether
   * the previous code has LAPSED or was simply never captured; the latter is the commoner case, so
   * this is deliberately not gated on expiry. A CLAIMED device is refused: its secret is the hub
   * credential, which rotateDeviceCredential owns.
   */
  reissueDeviceClaimCode: ReissueDeviceClaimCodePayload;
  /**
   * Rejects a held production entry with a required reason, keeping who rejected it and when. The job's
   * produced quantity and split stay as they were. Rejecting an entry already rejected changes nothing.
   */
  rejectProducedQuantityEntry: ProductionLotPayload;
  /**
   * Hands a claimed record back. A PENDING record goes back unattempted: it returns to unclaimed PENDING
   * with its retry count unchanged, and the next claim takes it with a new token. A POSTING record whose
   * navDocumentNo a verify step did not find in NAV is released only under that verify step's claimToken
   * (never the one its POSTING mark was made with), only if NAV never accepted the send, and only once the
   * settle wait setting has passed since lastPostingAt (before that, ERP_WRITE_BACK_NAV_MAY_STILL_POST
   * states the wait and when it ends): it returns to unclaimed PENDING with navDocumentNo, postingAt and
   * postingAttempts kept, to be sent again under the same number, or, once postingAttempts has reached the
   * most sends setting, moves to NEEDS_REVIEW with its claim kept ("sent {postingAttempts} times, never
   * found in NAV; check NAV"). The status of the returned record says which. Worker-facing. The claimToken
   * must be the record's current one; otherwise, or if the record is in another status, surfaces
   * ERP_WRITE_BACK_INVALID_STATUS_TRANSITION, a re-send after it landed included.
   */
  releaseErpWriteBack: ErpWriteBackPayload;
  /**
   * Releases an Approved GrowerBenchmark review so the member firm can read its approved version, stamping releaser
   * attribution, release time, sectionCount, and draftOrigin in a single GrowerBenchmarkReviewReleased event (contracts
   * R2 and R4). Restricted to effective COMMUNITY_ANALYST roster holders and platform superadmins.
   */
  releaseGrowerBenchmarkReview: GrowerBenchmarkReviewPayload;
  /** Returns some or all of a customer item's held plants to general stock. */
  releaseInventoryHold: InventoryItemPayload;
  /**
   * Releases an allocation, moving it to MaterialAllocationStatus.Released
   * and recording the release reason. Rejected if the allocation is already Fulfilled;
   * a no-op (no event) when the allocation is already Released.
   *
   *
   * **Returns:**
   * The released allocation, or validation/no-change errors.
   */
  releaseMaterialAllocation: MaterialAllocationPayload;
  /**
   * Superadmin operator escape hatch (T23): clears a tenant's mirrored Stripe schedule id without
   * waiting for Stripe's detach webhook, so a missed webhook (endpoint downtime, a secret rotation,
   * an unmapped subscription status) never permanently locks the tenant out of
   * setTenantBillingRateCard/setTenantBillingFrequency. Named by the refusal error on those two
   * mutations as the recovery path when Stripe shows no schedule on the subscription but the local
   * mirror still does. Rejected when the tenant has no mirrored schedule to release.
   */
  releaseMirroredStripeSchedule: AdminTenantPayload;
  /**
   * Releases the hold on an order, so it can be picked and shipped again. Works in whatever status the
   * order is. The release records who released the hold and when. Releasing an order that is not on hold
   * returns the no-changes error and records nothing. Staff only: a customer-portal caller is refused with
   * ORDER_HOLD_STAFF_ONLY and the hold stands.
   */
  releaseOrderHold: OrderPayload;
  /**
   * ADMIN REPAIR: releases the allocations a Deleted or Cancelled order still holds at inventory keys in the session
   * tenant, such as a make-to-order peg posted by Post Jobs that the delete or cancel did not release. Each release
   * is one inventory deallocation per key naming the order's lines, written on the key alone; the order is never
   * written. dryRun defaults to true: it reports every release (order, status, key, lines and quantity) and writes
   * nothing. orderIds names the orders; a named order that is neither Deleted nor Cancelled refuses the run and
   * nothing is written. Omitting orderIds scans the tenant for Deleted and Cancelled orders that still hold
   * allocations. An order id with no order stream is skipped. Safe to re-run: a key that no longer holds the
   * order's lines writes nothing.
   */
  releaseOrphanedOrderAllocations: ReleaseOrphanedOrderAllocationsPayload;
  /** Revokes parent-company administrator rights from a FusionAuth user. */
  removeAdminParentCompanyAdministrator: AdminParentCompanyPayload;
  removeBillingAddress: CustomerPayload;
  removeBlockingRuleLinkedItems: BlockingRulePayload;
  removeBlockingRuleLinkedLocations: BlockingRulePayload;
  removeCategory: CategoryPayload;
  removeContact: CustomerPayload;
  removeContainerConfigFromConfigCategory: ConfigCategoryPayload;
  removeImportRows: AsyncImportJobPayload;
  /**
   * Removes an allowed sender. INTAKE_ADDRESS_REQUIRED before the address is created; ALLOWED_SENDER_NOT_FOUND
   * when no sender has the id.
   */
  removeInboundAllowedSender: InboundIntakeSettingsPayload;
  removeItemAvailabilityPhoto: ItemAvailabilityPhotoPayload;
  /**
   * Explicitly clears the item's minimum ship quantity. Only PatchItem treats an omitted
   * MinShipQty as "preserve existing" — UpdateItem and UpdateItemAttributes are full-replace
   * for this field, so omitting it there already clears it. This dedicated mutation is the
   * reliable, self-documenting way to clear a MinShipQty regardless of which mutation a caller
   * otherwise uses. No-op (EntityCommandHasNoChanges) when none is currently set.
   */
  removeItemMinShipQty: ItemPayload;
  /**
   * Explicitly clears the item's royalty configuration. UpdateItem, UpdateItemAttributes, and
   * PatchItem all treat an omitted royalty as "preserve existing" (Royalty is one of the few fields,
   * alongside Commissionable, Discountable and StripeTaxCode, that those otherwise full-replace
   * mutations preserve on omission), so this dedicated mutation is the only way to REMOVE a
   * royalty once set. No-op (EntityCommandHasNoChanges) when no royalty is currently set.
   */
  removeItemRoyalty: ItemPayload;
  /**
   * Explicitly clears the item's substitution. Only PatchItem treats an omitted substitution
   * as "preserve existing" — UpdateItem and UpdateItemAttributes are full-replace for this
   * field, so omitting it there already clears it. This dedicated mutation is the reliable,
   * self-documenting way to clear a substitution regardless of which mutation a caller
   * otherwise uses. No-op (EntityCommandHasNoChanges) when none is currently set.
   */
  removeItemSubstitution: ItemPayload;
  removeLineItem: OrderPayload;
  removeLineItemAllocations: OrderPayload;
  removeLocation: CustomerPayload;
  removeMasterLineItem: MasterOrderPayload;
  /**
   * Stops one of the caller's own browsers receiving push notifications — the Push switch being
   * turned off, or the browser reporting its subscription gone. An endpoint the caller does not
   * hold reports that nothing was removed rather than failing, so a client never needs to check
   * first.
   *
   *
   * **Returns:**
   * Whether a registration was removed.
   */
  removeMyPushSubscription: RemovePushSubscriptionPayload;
  /** Removes a charge from the order, with a reason. */
  removeOrderFlatCharge: OrderPayload;
  /** Removes an upgrade from an order line. */
  removeOrderLineUpgrade: OrderPayload;
  /**
   * Withdraws a custom portal domain: the host stops resolving and stops being approved for
   * certificate issuance immediately, and the host is released for any tenant to claim.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  removePortalCustomDomain: PortalSettingsPayload;
  removeProductionMaterialEventDetail: ProductionMaterialEventPayload;
  removeProductionMaterialEventFromCategory: ProductionCategoryPayload;
  removeProductionMaterialEventFromJob: ProductionLotPayload;
  removeProductionRecipeVariation: ProductionRecipePayload;
  removeProductionSpaceEventDetail: ProductionSpaceEventPayload;
  removeProductionSpaceEventFromCategory: ProductionCategoryPayload;
  removeProductionSpaceEventFromJob: ProductionLotPayload;
  removeProductionTaskEventDetail: ProductionTaskEventPayload;
  removeProductionTaskEventFromCategory: ProductionCategoryPayload;
  /** Detaches a production task event from a production item. */
  removeProductionTaskEventFromItem: ProductionItemPayload;
  /**
   * Remove a task assignment from its job, identified the way an Event Schedule grid row
   * identifies it (job id + attached task event id — a row carries no TaskAssignmentId).
   * Rejects an assignment that is already completed or cancelled.
   */
  removeProductionTaskEventFromJob: TaskAssignmentPayload;
  removePromotionRuleLinkedItems: PromotionRulePayload;
  removePromotionRuleLinkedLocations: PromotionRulePayload;
  removePurchaseOrderLineItem: VendorPurchaseOrderPayload;
  /**
   * Retires a device the push service has reported gone, on the dispatch worker's behalf. Called
   * when a send comes back 404 or 410, which the push service uses to say the subscription no
   * longer exists.
   *
   *
   * **Returns:**
   * Whether a registration was removed.
   */
  removePushSubscriptionForWorker: RemovePushSubscriptionPayload;
  removeReserveRuleLinkedItems: ReserveRulePayload;
  removeReserveRuleLinkedLocations: ReserveRulePayload;
  removeSftpDestination: SftpTenantConfigPayload;
  removeSftpMongoDestination: SftpTenantConfigPayload;
  removeShrinkEvent: ProductionLotPayload;
  removeSizeUomFromConfigCategory: ConfigCategoryPayload;
  /**
   * Removes a space-capacity window by its full key (sub-location, space type, year-scope, week range).
   * A no-op when the window does not exist.
   */
  removeSpaceCapacityWindow: SiteLocationPayload;
  /**
   * Removes the year-round default capacity for a (sub-location, space type). A no-op when no row
   * exists. Resolution then falls back to a capacity window, or to uncovered (null) if none covers
   * the week.
   */
  removeSpaceTypeCapacity: SiteLocationPayload;
  /**
   * Removes a sub-location and every sub-location under it from the site, and deactivates the rates,
   * capacities and default space types they owned. While any record references them it is refused with
   * LOCATION_IN_USE unless acknowledgeInUse is true. Removing a sub-location the site does not have changes
   * nothing. Refused while the sub-locations include a combined sub-location or a combine survivor.
   */
  removeSubLocation: SiteLocationPayload;
  /** Remove a completed time entry from a task assignment. */
  removeTaskAssignmentTimeEntry: TaskAssignmentPayload;
  /**
   * Unbinds this tenant's email-authentication domain. Blocked with a payload error while any
   * DOMAIN-method sender still depends on it (remove or re-verify those senders first). The
   * underlying SendGrid domain authentication is only deleted when it was created for this tenant
   * (the created path); a grandfathered account-wide authentication is left intact.
   */
  removeTenantEmailDomain: TenantEmailDomainPayload;
  /**
   * Removes a sender identity. When the sender carries a SendGrid id its verified-sender record is
   * deleted from SendGrid first; orphans (never registered with SendGrid) are removed locally only.
   */
  removeTenantEmailSender: TenantEmailSenderPayload;
  /** Removes the tenant's SMTP connection (idempotent). Returns a null connection on success. */
  removeTenantSmtpConnection: TenantSmtpConnectionPayload;
  removeVendorPurchaseOrderCharge: VendorPurchaseOrderPayload;
  removeVerifyContainer: VerifyContainerPayload;
  removeWsapiImportEntityMapping: WsapiImportPayload;
  /**
   * Gives a category a new code and keeps its id. The input's code is the category's current code,
   * or a code it once held while no category holds that code now; newCode is the code it gets. The
   * old code stays reserved to the category and keeps reaching it, so the category's items, price
   * levels and Shipping UOM inheritance are unchanged. Refused when another category holds newCode
   * or once held it, in any casing, when the category is deleted, and when code names no category.
   */
  renameCategory: CategoryPayload;
  /**
   * Sets a device's display name. Scoped to the owning tenant: a device the caller does not own — or
   * that is not currently claimed — is reported as not found, indistinguishably from one that does
   * not exist. Renaming to the name the device already has is a no-op and records no history.
   */
  renameDevice: DevicePayload;
  renameReportFolder: ReportFolderPayload;
  /** Renames a volume pool. Submitting the current name again appends nothing. */
  renameVolumePool: VolumePoolPayload;
  /** Renews the caller's claim on one import run. Worker only. */
  renewMigrationImportRunClaim: MigrationImportRunPayload;
  /** Renews the caller's claim on one preparation job. Worker only. */
  renewMigrationPreparationJobClaim: MigrationPreparationJobPayload;
  reopenProductionJob: ProductionLotPayload;
  reorderItemAvailabilityPhotos: ItemAvailabilityPhotoPayload;
  /**
   * Does the one missing document step of a handoff left undone, for one record. Appends no event; a
   * repeat changes nothing. Worker only.
   */
  repairMigrationHandoff: MigrationHandoffRepairPayload;
  /**
   * Applies each named job's PENDING reservation peg: the target its latest committed post or adjustment
   * recorded, through the reservation's own idempotent peg. It never posts the job, so a committed inventory
   * post is never written twice, and a reservation already holding the target writes nothing. Guarded like
   * postProductionJobs: at most 500 jobs, each in the caller's site scope and named once, before any
   * job is read.
   */
  repairProductionJobReservationPegs: RepairProductionJobReservationPegsPayload;
  replaceCustomerSalesPeople: CustomerPayload;
  replaceErpLoadListRoutes: ErpLoadListRoutesPayload;
  replaceSalesPeople: CustomerPayload;
  /**
   * Replaces one exact space-capacity window (old full key and value) with a window under a changed
   * key in a single append. The new window is validated against the site without the original
   * (existing sub-location, parents included, active space type, key collision, overlap); on any failure nothing is written
   * and the original window stays. A same-key edit is rejected: use setSpaceCapacityWindow. Replaying
   * a committed replace answers the no-changes error. One append does not isolate concurrent users.
   */
  replaceSpaceCapacityWindow: SiteLocationPayload;
  /**
   * Replays the dead-lettered CustomerItemAdded streams of the named tenants into the customer item
   * read model. Each stream is read in full from the event store and every event is applied, in
   * order, through the CustomerItems projection's own handlers. A stream is skipped when its row
   * already exists, by id or by another row at its customer, ship-to and item, and is skipped and
   * listed when its customer, ship-to or item has since been combined away, deleted or deactivated, or
   * when applying it would also write another collection. Pass dryRun: true to report the counts without
   * writing anything.
   */
  replayDeadLetteredCustomerItems: ReplayDeadLetteredCustomerItemsPayload;
  /**
   * Grower finance staff: replay a reconciliation exception once its cause is resolved. Its Stripe event is processed
   * again through the same checks and posting, on what Stripe holds now; nothing is posted twice, and a resolved
   * exception is not processed again. Who replayed it and when are recorded.
   */
  replayOnlinePaymentException: ReplayOnlinePaymentExceptionPayload;
  /**
   * Moves every link that points at one recipe's (catalog, category) pair onto another ACTIVE, non-combo
   * recipe's pair (Start or Simple), across every recipe variation that links it, and reports the outcome per
   * linking recipe. The server owns "find every linking variation and rewrite it": the client names
   * only the two recipes, and the list visited is exactly what productionRecipesLinkingPair
   * returns for the source pair — the list the delete refusal showed.
   */
  repointProductionRecipeLinks: RepointProductionRecipeLinksPayload;
  /**
   * Reports how many of a batch's statements a worker has rendered so far, which is what the status
   * query shows as progress. Worker-facing.
   */
  reportStatementPrintBatchProgress: StatementPrintBatchPayload;
  /**
   * Re-runs price resolution for every line of an Open or Initialized order, e.g. after a price level
   * changed, through the same whole-order pass every line edit runs, and reports how many lines were
   * repriced, kept their price, or were skipped because they carry an override price. Override prices
   * are never touched, and a line no price resolves for keeps its price rather than dropping to $0.
   * From Submitted on the order's prices are locked and the call fails with
   * ORDER_PRICES_LOCKED_FOR_REPRICE; the counts are null whenever errors is set.
   */
  repriceOrder: RepriceOrderPayload;
  /**
   * Re-runs price resolution for one line of an Open or Initialized order — e.g. after adding the
   * price level it was missing — and reports what happened to that line. As on any line edit the
   * whole order is re-resolved, so other stale lines move too and override prices stay as they
   * are. An override-priced line is left as it is and nothing runs (outcome SKIPPED_OVERRIDE_PRICE);
   * an unchanged price succeeds with outcome UNCHANGED.
   */
  repriceOrderLine: RepriceOrderLinePayload;
  /**
   * Stores one user action as a background job and returns it at once; the worker handles its items later, one
   * page per call. The job is Pending, or Queued while the caller already has 5 jobs pending or running (it starts
   * when one of them finishes). A LOT_CHANGES job may send a selector instead of items: the lots it names, or the
   * Production Schedule's filter (Select All, no 2,000 cap), are resolved for the caller's tenant now and frozen
   * into one item per lot. Sending a job id the caller already used returns that job unchanged. A request
   * with no items, more than 10,000, or a malformed item is refused whole, as is any request while the tenant's
   * BackgroundJobs flag is off, except a BUYER_RETAIL_PRICE_SAVE, which the grower's buyer editing setting gates.
   */
  requestBackgroundJob: BackgroundJobPayload;
  /**
   * Stores a bulk order delete job and returns it at once; the worker deletes the orders later, one page
   * per call. Same restrictions as single deleteOrder (no extra role). A request with no orders, or
   * more than the tenant's MaxOrdersPerJob (default 10,000), is refused whole. A tenant that
   * already has a job pending or running gets a new Pending job that queues behind it. This writes one
   * Mongo document and no events, so it is not a batch mutation.
   */
  requestBulkOrderDelete: BulkOrderDeleteJobPayload;
  /** StaffNotCustomer. Records once per (tenant, user, flag) and emails Silver Fern. */
  requestEarlyAccess: RequestEarlyAccessPayload;
  /**
   * Requests the load's Freight Quote be emailed to its carrier, with the quote attached as a PDF. The
   * load email worker sends it; nothing is sent by this call.
   */
  requestFreightQuoteSend: RequestFreightQuoteSendPayload;
  /**
   * UNAUTHENTICATED "send me a new link" for the expired pay page. Given the token from an expired pay link, emails
   * a new link for the same invoice to the invoice's own email address on file, never to an address the visitor
   * supplies; it takes no email argument. Answers accepted to every token, so it reveals nothing: not whether the
   * token was known, expired or valid, and not whether an email was sent. A new link lasts at least 30 days, so
   * one token sends at most one email a month. Limited per IP address and per token.
   */
  requestInvoicePayLinkResend: RequestInvoicePayLinkResendPayload;
  /**
   * Requests a new material allocation, creating the aggregate in the
   * MaterialAllocationStatus.Requested state.
   *
   *
   * **Returns:**
   * The created allocation, or validation errors.
   */
  requestMaterialAllocation: MaterialAllocationPayload;
  /**
   * Texts a fresh verification code to a phone number so the caller can prove it is theirs. The code
   * is good for ten minutes, and no more than three may be asked for in an hour.
   *
   * The code is never returned here. It arrives by text and only by text. That is the whole
   * mechanism, and a response carrying it would verify the session rather than the handset.
   *
   *
   *
   * **Returns:**
   * The caller's directory entry as it now stands, or the reason the code was refused.
   */
  requestMyPhoneVerification: UserPayload;
  /**
   * Requests the planned-arrival notice for stops of a load. Each ready stop gets one reservation per
   * planned time, which the notice worker then sends; nothing is sent by this call.
   */
  requestPlannedArrivalNotices: RequestPlannedArrivalNoticesPayload;
  /**
   * W4. FLAG. Copy to Ramp again, after the grower fixed what stopped it. Allowed when the copy is NOT_COPIED or
   * FAILED_PERMANENT and the PO is not cancelled. Sets the job back to PENDING COPY with retryCount 0 and clears
   * notCopiedReason and errorMessage; the worker's next claim checks the PO again (still uncosted means
   * NOT_COPIED again). Codes: RAMP_NOT_ENABLED, ENTITY_DOES_NOT_EXIST (no copy job for the PO),
   * RAMP_COPY_PURCHASE_ORDERS_OFF, RAMP_COPY_NOT_RETRYABLE.
   */
  requestRampPurchaseOrderCopy: RampPurchaseOrderCopyPayload;
  /**
   * Requests server-side Restock calculation for a session. Emits a RestockCalculationRequested
   * event and returns immediately; the background orchestrator routes the requested scope through
   * the on-demand calc lane (wsapi-services drain) and patches the fresh results back onto the
   * session's rows. Empty itemIds/locationIds means all rows on the session. The payload's
   * requestId identifies this request; track it via the session's lastRequestId and
   * calculationStatus (InProgress to Idle, or Failed with lastCalculationError). When Idle,
   * resolvedRowCount below requestedRowCount means only part of the scope was calculated. A
   * request while another is InProgress is refused with RESTOCK_CALC_ALREADY_IN_PROGRESS.
   */
  requestRestockCalculation: RestockSessionPayload;
  requestRestockDashboardRecalc: RestockDashboardRecalcPayload;
  /**
   * Requests a print batch for one completed statement run, recording WHICH of that run's
   * statements are to be printed. Renders nothing: a print worker picks the request up and does the
   * work.
   */
  requestStatementPrintBatch: StatementPrintBatchPayload;
  /** Triggers SendGrid verification for a sender and records the returned handle + status. */
  requestTenantEmailSenderVerification: TenantEmailSenderPayload;
  /**
   * ANONYMOUS: issues a short-lived email-verification code for a trial prospect. Rate-limited on
   * BOTH caller IP and submitted email (the reusable identity path), and disposable domains are
   * rejected up front. wsapi writes the code to the verification stream; the wsapi-services
   * delivery worker sends the email — wsapi never sends mail directly (the same split as
   * UserInvite). The response is uniform: it never reveals whether the address is already known.
   */
  requestTrialSignupVerification: RequestTrialSignupVerificationPayload;
  /**
   * Staff: queues the invoice email again, with the invoice PDF and a pay link that works, to the invoice's own
   * recipients, as the same run-once system send the Send invoice dialog makes. Answers QUEUED (with the pay
   * link's last day and whether a new link was made) or SUPPRESSED with a reason code and a plain reason; never a
   * silent no-op. The link is the invoice's current one when it has at least 10 days left, otherwise a new one,
   * which stops the old link working. SUPPRESSED when online invoice payments are off, the invoice is paid or
   * voided, the customer or order is set to never get invoice emails, no address or invoice document is on file,
   * the invoice was already resent 5 times today (the grower's day), or a needed new link could not be made.
   * Refused for portal users and for an invoice this tenant has not issued. A read or write that fails, a store
   * outage for example, is returned in errors, never as SUPPRESSED.
   */
  resendInvoiceEmail: ResendInvoiceEmailPayload;
  /**
   * Tenant-scoped invite resend for the worksuite app's Administration > Users page. Unlike the
   * SuperAdmin-only adminResendUserInvite, the tenant comes from the caller's JWT and
   * the command stream is keyed by that tenant, so a tenant can only resend its OWN invites — an
   * inviteId belonging to another tenant resolves to a non-existent stream and is rejected. Gated
   * in code on the caller's Active Admin directory entry, like createUserInvite.
   *
   * This is also the chosen re-invite path for an EXPIRED invite. The aggregate's
   * EnsureCanResend guard only checks !Deleted && Status == Unused — it does
   * not check ExpiresAt — and the resent event always sets
   * ExpiresAt = now.AddDays(state.ExpiresInDays), so calling this on an invite that is
   * Unused-but-expired already works today with no aggregate change: it resets the expiry (and
   * re-queues the send by resetting EmailStatus to PendingSend) on the SAME invite
   * row, reusing the SAME code. A tenant admin finds the expired invite's id via
   * userInvites(includeExpired: true) and calls this exactly as for a still-pending invite.
   * The alternative path — calling createUserInvite again for that email — is deliberately
   * rejected instead (TenantInviteAccess.EnsureNoExpiredInviteAwaitingResend) so a
   * caller who tries that gets an actionable error pointing back here, rather than silently
   * accumulating a second, independent invite for the same recipient.
   */
  resendUserInvite: UserInvitePayload;
  resetAcknowledgmentEmail: Array<OrderPayload>;
  /**
   * Cross-tenant admin mutation that clears ALL of a tenant's integration links plus the retained
   * Merge account token from the Tenant aggregate. This is the compensating transition for the
   * tenant-reset flow: the reset preserves the Tenant aggregate stream (so benign tenant config
   * survives) but the integration link lives on that same stream, so without this it survives as a
   * "zombie" connected integration while every read model is wiped. Idempotent — a tenant with no
   * integrations and no retained Merge token is a no-op. Unlike deleteTenantIntegration
   * (single link, token kept for reconnect), this deliberately also clears the Merge account token
   * so a full reset leaves a completely clean slate. SuperAdmin only.
   * It also returns the tenant's accounting integration policy to its unconfigured default, for
   * the same reason: that config lives on its own stream, which the reset likewise preserves.
   */
  resetAdminTenantIntegrations: AdminTenantPayload;
  resetConfirmationEmail: Array<OrderPayload>;
  resetOrderSyncStatus: Array<OrderPayload>;
  /**
   * Recovers a user whose FusionAuth login is dead or stale — the FusionAuth account was deleted
   * out-of-band, leaving a dangling fusionAuthUserId on the directory row that makes the
   * Users page report a (false) "Active login" and hide the invite action. In ONE call the stale
   * link is cleared and a fresh invite linked to the SAME directory row is issued, so the user is
   * never deactivated and never forked into a duplicate row.
   *
   * Why unlink and invite must be one mutation. Both existing invariants point the same
   * way. EnsureEmailHasNoActiveAccount blocks a plain
   * createUserInvite while the row is Active with a non-empty FusionAuthUserId —
   * the unlink is exactly what flips that guard to pass — and, at the other end,
   * MarkUserInviteCompleted's auto-link is rejected by
   * EnsureActiveAndNotLinkedToAnotherUser when a DIFFERENT FusionAuth id already sits on
   * the user, so the new login could never bind while the dead id remained. This resolver
   * therefore performs the unlink itself and does NOT run the active-account guard; that guard's
   * semantics on the plain createUserInvite path are untouched.
   *
   *
   * A dead link is indistinguishable from a live one here. Nothing on the directory row
   * records whether the FusionAuth account still exists — that is precisely why the incident's
   * Users page reported a working "Active login" — and this surface issues no FusionAuth traffic
   * (the worker holds the only FusionAuth API key). So a reset is deliberately allowed against a
   * healthy login too, and its effect there is the same recoverable one: the login is replaced by
   * a set-password invite to the row's own address. It grants a tenant Admin nothing they could
   * not already do by deactivating and re-adding the user — only without forking the row.
   *
   *
   * Duplicate pending invites: revoke-and-replace. Any pending, unexpired invite for the
   * same email is deleted before the replacement is created (rather than erroring like
   * EnsureNoPendingInvite does for createUserInvite). A
   * broken login is precisely the state that accumulates dead pending invites, so refusing to
   * reset until an admin hand-deletes them would re-create the dead end this recovery exists to
   * break; the outcome is always exactly one live invite for the address.
   *
   *
   * Atomicity. Both commands built from caller input are validated before any event is
   * appended, so malformed input can never clear a link and then fail to issue the replacement.
   * (The revoke leg's own validation runs later, since its ids come from a read that follows the
   * unlink; those ids are database-derived and always well-formed, so no caller input reaches an
   * append unvalidated.) The three appends
   * (user, revoked invites, new invite) are issued sequentially rather than through
   * SaveEventsToMultipleStreams, matching how PortalUserProvisioning composes the
   * same user-plus-invite pair. The chain is therefore deliberately retry-safe: an already-clear
   * link is a success, not a "no changes" failure, so re-running after a partial failure
   * completes the recovery.
   *
   *
   * Gated exactly like createUserInvite: RestockWriter excludes
   * portal principals and the in-code RequireTenantAdmin gate
   * requires a superadmin JWT or the caller's own Active Admin directory entry. The tenant comes
   * from the caller's JWT, so a reset can only ever target the caller's own tenant.
   *
   *
   * The replacement invite's registrations follow the same server-set rule as
   * createUserInvite: ignored when the target row has a customer scope (always the Work
   * Suite application with the portal-user role), allow-listed for a staff row when the caller is
   * below platform superadmin. Below platform superadmin a target row whose email is at
   * silverfern.com or silverfern.app is refused. Both refusals happen before the login is unlinked
   * or any event is written.
   */
  resetUserLogin: UserInvitePayload;
  resetWorkOrderQuantityProduced: JobPayload;
  /**
   * Clears the per-tenant RunNow trigger on a worker config after a triggered run.
   * Gated to the wsapi-services worker tier via the WorkerService policy so workers can only
   * clear the flag — setting it stays a SuperAdmin operation (setWorkerConfigRunNow).
   * When the flag is already clear the change detector returns the standard "no changes"
   * validation error and no event is written.
   */
  resetWorkerConfigRunNow: AdminWorkerConfigPayload;
  resetWsapiImportRunNow: WsapiImportPayload;
  /** Resolves an open pair: the two were combined, or either went inactive. Worker only. */
  resolveDuplicateCandidate: DuplicateCandidateIdsPayload;
  /**
   * Resolves a write-back record after a tenant admin has checked NAV. navShows POSTED (posted by the app
   * or by hand) closes it as PROCESSED. NOT_POSTED returns it to PENDING under the same id, idempotency
   * key and createdAt, with its claim cleared and its navDocumentNo, postingAt and postingAttempts kept, so a
   * later claim posts it: from FAILED at any time. From NEEDS_REVIEW, a record whose latest claim was taken
   * with marksPosting, that carries a navDocumentNo and that wsapi never found in NAV after its latest send
   * (postedAt null) takes NOT_POSTED in any workflow, its navDocumentNo having been looked up in NAV, once the
   * settle wait setting has passed since lastPostingAt (before that, ERP_WRITE_BACK_NAV_MAY_STILL_POST states
   * the wait and when it ends). Any other NEEDS_REVIEW record (no navDocumentNo, a latest claim taken without
   * marksPosting, whose claimant may have sent it with no POSTING mark, or postedAt set) takes it only for
   * RETAIL, whose poster skips a change NAV already holds, and only once a minimum wait after its claim has
   * passed (before that, ERP_WRITE_BACK_NAV_MAY_STILL_POST states the wait and when it ends); any other
   * workflow is posted in NAV by hand and then resolved POSTED (ERP_WRITE_BACK_REPOST_BY_HAND), except a
   * record the rollback quarantine parked, which was never claimed and takes NOT_POSTED in any workflow. A
   * PENDING record can be resolved only while a rollback
   * hold is on: an unclaimed one closes on POSTED and stays PENDING on NOT_POSTED, and a claim past its
   * lease resolves as NEEDS_REVIEW. A POSTED record takes POSTED only. A POSTING record takes POSTED at any
   * time, and NOT_POSTED in any workflow, its navDocumentNo having been looked up in NAV, only with no live
   * claim and once the settle wait setting has passed since lastPostingAt (before that,
   * ERP_WRITE_BACK_NAV_MAY_STILL_POST states the wait and when it ends). A live claim, or a PENDING record
   * with no rollback hold on, gets ERP_WRITE_BACK_INVALID_STATUS_TRANSITION, as does a record that changed
   * while it was being resolved. NOT_POSTED is also refused, with ERP_WRITE_BACK_NEWER_CHANGE_POSTED naming
   * the newer record, while a newer record of the same item in the same workflow is PROCESSED, POSTING or
   * POSTED, is claimed, or is in NEEDS_REVIEW with its claim kept: that change has reached NAV, or may have,
   * and this older one would post after it.
   * Post it in NAV by hand if NAV still needs it and resolve it POSTED, or leave it. Every resolve records
   * the tenant's rollback epoch on the record and adds the check, the admin's email and the note to
   * errorMessage after what was there. The note is required, may not be longer than the length limit for
   * a reason, and is stored trimmed. Tenant admins only.
   */
  resolveErpWriteBack: ErpWriteBackPayload;
  /**
   * Grower finance staff: mark a reconciliation exception resolved by hand, with a required note saying how, for a
   * cause no replay can settle (a refund that failed after it was taken back, an event from another account or
   * payment). Nothing is posted. Who resolved it, when and how are recorded; resolving it again changes nothing.
   */
  resolveOnlinePaymentException: ResolveOnlinePaymentExceptionPayload;
  /**
   * SUPERADMIN: resolves a pending trial request — Approve (new tenant, cold-trial length),
   * LinkToExisting (admin invite into an existing tenant + longer GP trial), or Reject. The
   * worker provisions only Approved/Linked outcomes. Matching only ever annotated the request;
   * Link is always this explicit human decision, never an auto-join.
   */
  resolveTrialRequest: TrialRequestPayload;
  /** Closes an uncertain load email as sent or failed, by an operator's decision. */
  resolveUncertainLoadEmail: LoadEmailPayload;
  /**
   * Appends a Restored version copying the target version's sections and findingNotes onto an InEdit GrowerBenchmark
   * review without removing any existing version (contracts R2 and R4). Restricted to effective COMMUNITY_ANALYST
   * roster holders and platform superadmins.
   */
  restoreGrowerBenchmarkReviewVersion: GrowerBenchmarkReviewPayload;
  resumeCountSession: CountSessionPayload;
  /**
   * Asks the worker to resume a paused or blocked run with the same remaining approved work. Approves no
   * new or changed data.
   */
  resumeMigrationImportRun: MigrationImportRunControlPayload;
  /** Resumes a paused rollout at the named ring, issuing a new, higher authorization for its opened rings. */
  resumeOtaRollout: OtaRolloutPayload;
  /**
   * Retires an alias: it stops resolving and keeps its row, RETIRED, with retiredAt and effectiveUntil set.
   * Retiring a retired alias changes nothing and returns it.
   */
  retireVendorItemAlias: VendorItemAliasPayload;
  /**
   * Retires a volume pool. Refused with a payload error while any price level in the tenant still
   * references the pool, and when the pool is already retired. A retired pool keeps its code
   * reserved and is brought back with reactivateVolumePool.
   */
  retireVolumePool: VolumePoolPayload;
  /**
   * Runs the failed items of one of the caller's finished jobs again: they go back to waiting, one attempt higher,
   * and the job back to Pending. Done and skipped items are not run again. Refused for an open or cancelled job,
   * or one with nothing failed.
   */
  retryFailedBackgroundJobItems: BackgroundJobPayload;
  /** Sends an issued invoice to QuickBooks again after a failed export. */
  retryInvoiceExport: RetryInvoiceExportPayload;
  /**
   * Re-arms the accounting export of one payment OR DEPOSIT recorded in FULFILL — the SAME export row, put back to
   * Pending, so the worker creates the payment in the accounting platform on its next tick and the
   * payment's paymentSyncStatus reads PENDING straight away.
   */
  retryPaymentExport: RetryPaymentExportPayload;
  revalidateImport: AsyncImportJobPayload;
  /**
   * Reverses one hand-entered cost. The original stays, and a negated entry carrying its subcategory is
   * appended so the cost nets to zero in the summary, breakdown and timeline. Reversing a record that is
   * already reversed returns the existing reversal. Unknown records, records that are not hand-entered and
   * reversal records are rejected. Any concurrent write to the same job ledger can refuse the call with an
   * already-exists error; retrying is safe because a second reversal of the same record is never created.
   *
   *
   * **Returns:**
   * A payload containing the reversal record, or validation errors.
   */
  reverseManualJobCost: JobCostPayload;
  /**
   * Reverts a combine: the combined customer is active again with its own contacts, ship-to locations
   * and billing addresses, the survivor loses the aliases and gets its prior values back, and the
   * customer items the combine moved or retired go back, as do the additional SKUs of the survivor's customer
   * items the combine added SKUs to and the portal buyers the combine moved who are still Active on the
   * survivor. Only an admin may revert a combine that moved portal buyers.
   * Only allowed until the survivor has an order,
   * invoice or payment created after the combine, refused while a later combine made one of its
   * contacts or ship-tos the same as one this combine brought, and refused when the undo would save
   * more changes than one append can hold.
   */
  revertCustomerCombine: RevertCustomerCombinePayload;
  /**
   * Reverts a combine so the former loser stands on its own again, and gives the survivor back the
   * values it held just before the combine, except any changed on the survivor since. Refused once
   * the survivor has recorded an order line, invoice line or inventory transaction since the combine,
   * or while the survivor is itself combined into another item. The price levels, customer items, kit
   * lines, production links, favorites entries, portal cart lines and forecast mapping the combine
   * moved go back too, except any changed since. A price level given back that would leave a price
   * group's levels disagreeing on the volume pool refuses the revert with
   * ITEM_COMBINE_PRICE_LADDER_CONFLICT. Refused with SKU_ALREADY_USED when another live item now holds
   * the former loser's SKU.
   */
  revertItemCombine: RevertItemCombinePayload;
  /**
   * Reverts a catalog combine: the combined catalog is active again, and everything the combine moved goes
   * back, its lots' jobs included, with the survivor's own genus, series and color. Forecast mapping lines
   * moved for an item pair go back unless they changed since the combine; those sales items are named in
   * forecastSalesItemIdsNotRestored. Only allowed while nothing on the survivor has changed since the
   * combine: no lot, no job posted, no recipe and no production item written since, only for the
   * survivor's latest combine, and only while no other catalog holds the genus, series and color it puts back.
   */
  revertProductionCatalogCombine: RevertProductionCatalogCombinePayload;
  /**
   * Reverts a combine: the combined item is active again, and the survivor gets its own sales link and
   * labor cost back and loses the task events the combine added. Forecast mapping lines the combine moved
   * go back to the combined item unless they changed since the combine; those sales items are named in
   * forecastSalesItemIdsNotRestored. Only allowed while no job on the plant and pot has posted since the
   * combine and the survivor is still active on that plant and pot, and only for the survivor's latest
   * combine.
   */
  revertProductionItemCombine: RevertProductionItemCombinePayload;
  /**
   * Reverts a report's content to an earlier version. This is forward-only: the target version's
   * snapshot is read from the report's event stream and re-applied as a normal update, appending a
   * new version at the head (attributed to the caller) rather than truncating history. The read
   * model self-heals via the report projection. Reverting to a version whose content already
   * matches the report's current content — the head, for instance — succeeds and writes no event.
   *
   * Spreadsheet columns are part of the snapshot, so a revert restores the target version's columns;
   * a version saved before the report had any restores none.
   *
   * App tags are not part of a version snapshot and are deliberately preserved across a revert:
   * they describe where a report is surfaced rather than what it contains, so reverting content
   * leaves the report's current tags exactly as they were, and a tag change between now and the
   * target version never blocks the revert. Change tags with setReportAppTags.
   *
   * A revert is a save, so a saved view needs the change right, as updateReport does. A view the caller cannot
   * open answers as a report that does not exist.
   *
   *
   * **Returns:**
   * A payload containing the reverted report, or validation errors.
   */
  revertReport: ReportPayload;
  /**
   * Reverts a ship-to combine: the loser is restored exactly as it was, the survivor goes back to what it
   * was before the combine, keeping the aliases later combines added, and the customer items the combine
   * moved or retired go back. Only allowed until an order on the survivor ship-to is created after the
   * combine. Never refused for a tenant switched off.
   */
  revertShipToCombine: RevertShipToCombinePayload;
  /**
   * Reverts a sub-location combine so the loser stands on its own again, and gives both sides back the
   * pick sequence, capacities, windows and default space type they held just before the combine. An
   * overhead rate the survivor took from the loser is cancelled; the loser's own overhead rate stays
   * deactivated (set it again with the rate setter). Refused once the survivor's row or config changed
   * after the combine.
   */
  revertSubLocationCombine: RevertSubLocationCombinePayload;
  /**
   * Reverts a combine so the former loser stands on its own again: it is Active with its own values, the
   * survivor gets back the values it held before the combine, the default moves back when the combine
   * moved it, and the customers and ship-tos the combine moved go back. Refused once the survivor has
   * changed since the combine, or once any customer or ship-to the combine moved has changed its terms.
   */
  revertTermsCombine: RevertTermsCombinePayload;
  /**
   * Sets a suggestion's review state and staff note. Send the stream revision the suggestion was listed
   * with: a review is appended only at that revision, a stale one returns the current state, and setting
   * the review state and staff note the suggestion already has changes nothing. A changed note alone is
   * a new review.
   */
  reviewOnboardingParsingSuggestion: ReviewOnboardingParsingSuggestionPayload;
  /**
   * Grower finance staff: mark the unapplied credit one invoice's share of an online payment left as reviewed. Who and
   * when are recorded; reviewing it again changes nothing.
   */
  reviewOnlinePaymentCredit: ReviewOnlinePaymentCreditPayload;
  /** Saves one reviewer decision, under the revision they were looking at. */
  reviewSupplierPriceImportRow: SupplierPriceImportPayload;
  /**
   * Revokes the device's connectivity credential, cutting off its access while leaving the device
   * claimed and in the tenant's fleet. Scoped to the owning tenant, and requires a credential that is
   * currently active; anything else is reported as not found. There is no un-revoke in this release.
   *
   * The revocation is real, not just a status column: the device's IoT Hub identity is disabled and
   * its key replaced with one nobody holds, so an open connection drops and the credential the device
   * was flashed with stops working.
   */
  revokeDeviceCredential: DevicePayload;
  /**
   * Revokes an existing roster entry on a GrowerBenchmark community and projects a "Revoked" row into
   * growerBenchmarkAccessLog (contract C5 and C7). Requires an effective COMMUNITY_ADMIN roster entry
   * (or platform superadmin).
   */
  revokeGrowerBenchmarkRosterEntry: GrowerBenchmarkCommunityPayload;
  /**
   * Revokes a pay link: its token stops opening anything immediately. Revoking a link that is already revoked
   * changes nothing and returns it. A reason is required. Allowed whether or not online invoice payments are
   * switched on.
   */
  revokeInvoicePayLink: InvoicePayLinkPayload;
  /**
   * Deactivates a user's directory entry in each of the named member tenants, so they can no longer
   * work there. Their login is not changed in any way and their entries in other tenants are
   * untouched. Tenants where they have no entry, or an already-inactive one, are left alone. Only an
   * administrator of the parent company may call it, only its member tenants may be named, and an
   * administrator of the group may not be the target.
   */
  revokeParentCompanyTenantAccess: ParentCompanyAccessPayload;
  /**
   * Creates a new address to forward documents to. The first call creates the address. A later call replaces it,
   * and the old address keeps receiving documents for 7 days.
   */
  rotateInboundIntakeAddress: InboundIntakeSettingsPayload;
  roundRestockSessionOrderQuantityToFullCart: RestockSessionPayload;
  /**
   * Sends a document to a place that makes something from it. The places a document can go are the ones
   * availableTargets lists; counterparty is required by a place that names one and refused by one that does not.
   * ROUTE_IN_PROGRESS while another send of the same document is running.
   */
  routeInboundDocument: InboundDocumentPayload;
  /**
   * Asks the duplicate finder to check now, for one entity type or every type. While a check is waiting,
   * asking again returns the same request. Admin staff only.
   */
  runDuplicateCheck: RunDuplicateCheckPayload;
  /**
   * Runs one saved version of a report by hand: wsapi generates its PDF and records the run as a report
   * execution linked to that PDF, so run history and links can inspect exactly this run. Nothing is scheduled
   * and nothing is emailed.
   *
   *
   * **Returns:**
   * The outcome of the run, or the reason it was refused.
   */
  runReport: RunReportPayload;
  saveConsolidationRules: SaveConsolidationRulesPayload;
  /**
   * Saves or replaces a named compare page view owned by the calling reader for their primary firm in
   * input.communityId (contract C1).
   */
  saveGrowerBenchmarkCompareView: GrowerBenchmarkCompareViewPayload;
  /**
   * Appends an Edited version carrying section narratives, changedSectionIds, and server-attributed findingNotes
   * onto an InEdit GrowerBenchmark review (contracts R2 and R4). Restricted to effective COMMUNITY_ANALYST roster holders
   * and platform superadmins; refuses duplicate metricKeys, empty quotes, or uncatalogued metricKeys with
   * GROWER_BENCHMARKS_REVIEW_FINDING_NOTE_INVALID. The sections must list every section of the latest version exactly once
   * and each changedSectionIds entry must name one of them at most once; otherwise the save is refused with a field
   * validation error and no version is appended. Tiles, table rows and evidence carry over from the latest version.
   */
  saveGrowerBenchmarkReviewVersion: GrowerBenchmarkReviewPayload;
  /**
   * Saves Kit counts for some of a Draft session's Kit and Store pairs; every other pair keeps its
   * count. Each component's planned-quantity unit is proved from the tenant's saved unit
   * configuration and the Item's own tray size, and recorded with the counts. Returns the session's
   * Kit plan, derived again from the saved inputs: a count may leave a component in deficit, which
   * the plan shows for review. It writes no order quantity and reserves no stock. Two requests saving
   * the same session at once are not serialized: the later append wins for any pair both name.
   */
  saveRestockSessionKitCounts: RestockSessionKitPlanPayload;
  /** Records a retryable failure; moves the record to RetryRequired. */
  scheduleContractRecordEnrollmentRetry: ContractRecordPayload;
  /** Records a retryable fee failure; moves the fee to RetryRequired. */
  scheduleContractRecordFeeRetry: ContractRecordPayload;
  /**
   * Schedules a transfer of one inventory key (location, item, grade) to another live-goods item, to fire
   * at the start of a future effective date in the tenant's business time zone. Nothing moves now; the
   * schedule is listed by scheduledInventoryTransfers and can be cancelled until it fires. Refused while the
   * tenant's ScheduledItemTransfers flag is off. A reason code is required: a schedule that names none, or 0,
   * is refused with "A reason is required." (COUNT_REASON_REQUIRED).
   */
  scheduleInventoryTransfer: ScheduledInventoryTransferPayload;
  /**
   * Schedules one week of an Acknowledged Master Order into one child Order: a subset of the Master's
   * lines, in any order, each named by its Master line id with its own reserved child line id.
   */
  scheduleMasterOrderWeek: ScheduleMasterOrderWeekPayload;
  /** Scraps inventory, removing it from stock. */
  scrapInventoryItem: InventoryItemPayload;
  /**
   * Seeds the legacy holiday reference set for the calling tenant, from the 2018 legacy floor through
   * the requested year (default 2035). Idempotent: only holidays the tenant does not already have are
   * created, so re-running preserves any admin edits and deletes. Returns how many holidays the range
   * produced, how many new rows were written, and how many were already present. Returns an error when
   * the FORECAST flag is disabled (nothing is written).
   */
  seedForecastHolidays: SeedForecastHolidaysPayload;
  /** TENANT ADMIN, FLAG. Picks one of the stored entities. Codes: RAMP_NOT_CONNECTED, RAMP_ENTITY_NOT_FOUND. */
  selectRampEntity: RampConnectionPayload;
  /** Adds one row to, or removes it from, the selection a confirmation would cover. */
  selectSupplierPriceImportRow: SupplierPriceImportPayload;
  /**
   * Approves which sender the tenant's ordinary customer email uses: PLATFORM (the Work Suite platform sender,
   * which stays in effect when a company sender is verified later), COMPANY (one specific verified company
   * sender: a verified address, an authenticated-domain address, or a custom SMTP address named with its SMTP
   * connection id), or INHERIT (the legacy default behavior). Admin only. expectedRevision is the revision the
   * caller read from tenantEmailSenderSelection; a selection approved since then refuses the call as stale,
   * while repeating the selection already in effect is a no-op. Returns the selection read back after the
   * write. Selecting a sender never verifies one, enables email, or sends anything.
   */
  selectTenantEmailSender: TenantEmailSenderSelectionPayload;
  /** Sends the statements of the customers named in customerIds, and nobody else. */
  sendCustomerStatements: CustomerStatementSendPayload;
  /**
   * Dispatches a server-side command to the device and records the dispatch as an audit event. The
   * command must be one the device's profile implements; the command is sent via the transport
   * gateway ONLY after the request itself is fully parsed and validated, and the audit event is
   * written only once that dispatch succeeds — a browser never talks to the transport directly, and
   * neither a bad request nor a failed dispatch ever produces a false "sent" record. For
   * SET_WIFI, changeId is a freshly minted correlation id — poll
   * device(id).wifiChangeStatus(changeId:) for PENDING/APPLIED/ROLLED_BACK/TIMED_OUT, or read
   * lastWifiChange for the device's latest change regardless of which one it was; every other
   * command returns a null changeId.
   */
  sendDeviceCommand: SendDeviceCommandPayload;
  /**
   * Sends the one-time invoice email from the calling user's own connected M365 mailbox ("From: me"
   * — same compose dialog as createInvoiceEmailDraft, real send instead of a draft), returning
   * whether it was sent and the sent message's Outlook draftWebLink. The
   * input subject/body arrive RAW (unrendered Handlebars) and are rendered
   * server-side over the order token context before sending — the dialog never sends pre-rendered
   * text. Recipients, subject, and body are all OPTIONAL: omitting recipients resolves every
   * email of every AccountsPayable-typed contact on the order's customer, falling back to the
   * order's own contact email when the customer has none; omitting subject/body seeds the
   * doc-type-keyed defaults (Invoice {{invoiceNumber}} for an order carrying a live invoice,
   * else Invoice {{orderNumber}} or Order Acknowledgement {{orderNumber}}, or
   * Quote {{orderNumber}} when input.docType is QUOTE). An order
   * mailed as an invoice renders the invoice merge tokens too — number, dates, terms, money and the
   * tenant's remit-to block — over the order tokens every send already carries.
   * The order must belong to the caller's resolved tenant (a foreign-tenant orderId is rejected
   * as not-found), and the mailbox token is fetched for the caller's own JWT identity; neither tenant
   * nor user id is ever accepted from input. The rendered document resolves the same way View does:
   * a customer override, else the tenant's bound report, else the built-in Professional Invoice /
   * Order Acknowledgement default, so a tenant that never configured a report still sends the stock
   * document rather than failing. A QUOTE always renders the seeded Quote template, ignoring
   * any customer override or tenant binding. A mailbox that has not granted send permission yields
   * SEND_PERMISSION_MISSING (the pwa walks the user through a one-time reconnect); a draft
   * that was created but could not be sent yields DRAFT_CREATED_SEND_FAILED with the draft
   * link so the user can finish it in Outlook.
   * On Graph success (and ONLY then) the send is recorded in EmailSends as PERSONAL_ACCOUNT —
   * a draft never reaches this mutation's audit write. input.docType is an optional, additive
   * override of the resolved default (OrderEmailDocTypeResolution — the order's live
   * invoice, else its status): omitted, behavior is byte-for-byte what it was before this field
   * existed; supplied, it is honored only when the order accepts it
   * (OrderEmailDocTypeResolution.AllowsExplicit — always its own resolved default, and
   * otherwise per OrderStatusExtensions.AllowsExplicitOrderEmailDocType), else the send
   * fails with DOC_TYPE_NOT_ALLOWED_FOR_STATUS before any draft is created.
   */
  sendInvoiceEmail: SendInvoiceEmailPayload;
  /**
   * Sends a master order's acknowledgement email from the calling user's own connected M365 mailbox,
   * the master counterpart of sendInvoiceEmail (same payload, same
   * SEND_PERMISSION_MISSING and DRAFT_CREATED_SEND_FAILED outcomes). The seeded Master
   * Order Acknowledgement renders with the master number and is attached as a PDF. The raw
   * subject/body arrive unrendered and are rendered server-side over the master's tokens:
   * {{orderNumber}} is the master number, with {{customerName}} and {{poNumber}};
   * order-only tokens render empty. Omitted recipients resolve every email of every
   * AccountsPayable-typed contact on the master's customer, else the master's own contact email;
   * omitted subject/body use the acknowledgement defaults. The master must belong to the caller's
   * resolved tenant (a foreign-tenant or unknown id is rejected as not-found), and an Open master
   * is refused with DOC_TYPE_NOT_ALLOWED_FOR_STATUS before any render or draft. Masters send only
   * from the caller's own mailbox. On Graph success (and ONLY then) the send is recorded in EmailSends as
   * PERSONAL_ACCOUNT.
   */
  sendMasterOrderEmail: SendInvoiceEmailPayload;
  /**
   * Sets/replaces the calling tenant's accounting integration policy (provider, outbound detail
   * level, and the optional Merge.dev linked-account id) wholesale. Additive surface for §4.3a;
   * connection secrets are unaffected and remain on MergeTenantIntegration.
   */
  setAccountingIntegrationConfig: AccountingIntegrationConfigPayload;
  /**
   * Sets/clears the five optional non-product-line GL accounts (Sales tax, Freight, Deposit
   * applied, Rounding adjustment, Fuel surcharge) exported alongside the tenant's product lines (Helm 9f8b7004).
   * Per-field omit-preserve/empty-clears/value-sets semantics — see
   * SetAccountingLineAccounts. Each supplied
   * (non-clearing) id is gated by AccountingLineAccountsGate for existence, Active
   * status, and the field's allowed classification(s) before the event is written.
   */
  setAccountingLineAccounts: AccountingIntegrationConfigPayload;
  setActiveCountSession: ProductionLinePayload;
  /** Sets the global config and enabled state of a feature flag. */
  setAdminFeatureFlagGlobalValue: AdminFeatureFlagPayload;
  /**
   * Sets one tenant's own setting on a flag: on, off, or settings only (the tenant's settings JSON, while on/off
   * follows its products, its trial and everyone's default). Every other tenant's setting is kept as it is.
   * Re-sending the setting the tenant already has writes nothing.
   */
  setAdminFeatureFlagTenantOverride: AdminFeatureFlagPayload;
  /** Sets tenant-specific overrides for a feature flag, replacing all existing overrides. */
  setAdminFeatureFlagTenantOverrides: AdminFeatureFlagPayload;
  /**
   * Overrides tenantId's portal company slug outside the ordinary
   * settings-save path. Re-runs the SAME normalization + collision rules provisioning uses
   * (CompanySlugService.ResolveForAdminOverride): the requested value is normalized the
   * way a tenant short code is, then rejected — not silently substituted — if nothing slug-safe
   * survives or if the normalized result is already claimed by another tenant, so the Mongo slug
   * registry (tenantByCompanySlug, the subdomain host resolver) stays consistent with
   * whatever slug this call actually persists. Requires the tenant to already have saved portal
   * settings; resubmitting the CURRENT slug is a no-op.
   */
  setAdminPortalCompanySlug: PortalSettingsPayload;
  /**
   * Replaces a tenant's customer texting setup (PUT semantics): the toll-free number, Messaging
   * Service SID, verified business name, state and submitted date. NOT_SET_UP clears every other
   * field. An unchanged save returns an EntityCommandHasNoChangesError.
   */
  setAdminTenantCustomerTexting: CustomerTextingPayload;
  /**
   * Saves one tenant's features in one call: its products and the own settings listed, and nothing of any other
   * tenant, all in one write. Refused with TENANT_FEATURES_CONFLICT, saving nothing, when the tenant's products or a
   * listed flag's own setting are no longer the expected ones the caller read; data then holds the saved values.
   * After a save, data holds what was written, so it can be the next save's expected parts. With dryRun nothing is
   * written, and changes lists the flags the save would turn on or off.
   */
  setAdminTenantFeatures: SetAdminTenantFeaturesPayload;
  /**
   * Sets or clears a tenant's parent-company membership (SuperAdmin). Setting a non-empty id is
   * refused with a typed error when the parent company does not exist or has been soft-deleted;
   * clearing (a null or empty id) needs no such guard. A tenant belongs to at most one parent
   * company by construction, so this always replaces any prior membership.
   */
  setAdminTenantParentCompany: AdminTenantPayload;
  /**
   * Sets the WorkSuite products a tenant has (PUT semantics: the list replaces its products) and rewrites
   * its Contracted Products text from the product names. A product every tenant has may be listed and is
   * not stored. Re-sending the same products writes nothing. Open sessions of the tenant are told which
   * flags may have changed.
   */
  setAdminTenantWorkSuiteProducts: AdminTenantPayload;
  setBackgroundServiceEnabled: AdminBackgroundServiceConfigPayload;
  /**
   * Replaces a user's full set of BPF starting-node grants (PUT). Tenant-scoped via the caller's
   * JWT; the target user is the userId on the input, matching the legacy importer that
   * rewrote a user's StartingNodes set wholesale. Pass an empty startingNodes list to clear
   * a user's entry points.
   */
  setBpfUserStartingNodes: BpfUserStartingNodePayload;
  /**
   * Sets or clears the category's income GL account (rung 3 of the revenue ladder, Helm
   * 432f8bb4) — mirrors CustomerTypeMutation.SetCustomerTypeRevenueGlAccount's shape.
   * The only Category mutation that takes categoryId directly rather than a code, so it
   * does NOT go through ResolveCategoryId's code->guid resolution edge: the caller
   * already has the category's real guid from a prior query. Explicit clear sends an empty
   * incomeGlAccountId (PWA convention, PR 12746) — there is no "omit to preserve" case.
   */
  setCategoryIncomeGlAccount: CategoryPayload;
  /** Sets or updates the labor cost per unit for a production category. */
  setCategoryLaborCost: ProductionCategoryPayload;
  /** Sets how many units of a production category fit on one pole (Pints = 250). Send null to clear it; a category with none set does not count by pole. */
  setCategoryUnitsPerPole: ProductionCategoryPayload;
  setCheckpoint: CheckpointPayload;
  /**
   * Sets the user's default commission rate (percent, 0–100), which applies to every
   * customer without an override.
   */
  setCommissionDefaultRate: CommissionConfigPayload;
  setConsolidationLotPins: SetConsolidationLotPinsPayload;
  /**
   * Replaces the tenant's consolidation rule set wholesale (PUT semantics). All seven
   * rule fields are required on every call; resubmitting the identical rule set is a
   * no-op that surfaces EntityCommandHasNoChanges in the payload errors.
   */
  setConsolidationRuleSet: ConsolidationRuleSetPayload;
  setContactCrmLink: CustomerPayload;
  /** Forces a record back to Pending for a fresh worker attempt. Bumps generation. */
  setContractRecordEnrollmentBackToPending: ContractRecordPayload;
  /**
   * Forces the installation fee back to Pending for a fresh worker attempt. Bumps the fee
   * generation and clears the fee's step ledger; the enrollment lane is untouched.
   */
  setContractRecordFeeBackToPending: ContractRecordPayload;
  setCountSessionTarget: CountSessionPayload;
  /**
   * Sets the session's counted quantity to an absolute value, correcting it either up or down.
   * Use this to fix a miscount, or to post a full running total from a device that tracks its
   * own count; use registerCount to add an increment. Zero is accepted; a negative quantity is
   * rejected. Allowed only while the session is running, and setting the value the session
   * already holds makes no change.
   */
  setCountedQuantity: CountSessionPayload;
  /**
   * Sets a per-customer commission rate override (percent, 0–100) on the user's
   * configuration. Setting an override for a customer that already has one replaces it.
   */
  setCustomerCommissionOverride: CommissionConfigPayload;
  setCustomerCrmLink: CustomerPayload;
  /**
   * Sets or clears the Tag color new orders for this customer start with. Pass tagColorId: null (or omit
   * it) to clear the default. Send expected with the color last read (null for none) to refuse the change
   * with CUSTOMER_DEFAULT_TAG_COLOR_CHANGED when someone else changed it first; omit expected to
   * skip that check. Resubmitting the color already stored succeeds unchanged and emits no event.
   */
  setCustomerDefaultTagColor: CustomerPayload;
  /**
   * Sets or clears the customer's order-deposit requirement. Pass
   * depositRequirementType: NONE (or null) to clear the requirement so the customer's
   * orders are never deposit-blocked; pass PERCENTAGE (value 0–100) or FLAT_AMOUNT
   * (non-negative amount) to require a deposit of that size before an order can be allocated.
   */
  setCustomerDepositRequirement: CustomerPayload;
  /**
   * Replaces this customer's volume-pool opt-out list with the pools given — the complete set of
   * pools this customer no longer pools across, so each of its lines on those pools is priced at
   * its own line quantity. Pass an empty volumePoolIds to CLEAR every opt-out so all of
   * the customer's ladders pool again. Every id must name a pool in this tenant; a retired pool is
   * accepted, so the customer's history of opt-outs survives the pool's retirement. The list
   * applies to every location of the customer, including one assigned its own price group.
   * Resubmitting the list already stored, in any order, succeeds without emitting an event.
   */
  setCustomerDisabledVolumePools: CustomerPayload;
  /**
   * Sets or clears a customer's Customer Group. Pass a customerGroupId to assign that
   * group (validated to exist and be active, exactly as setCustomerType does); pass
   * null (or omit it) to clear the assignment.
   */
  setCustomerGroup: CustomerPayload;
  setCustomerItemEffectiveDates: CustomerItemPayload;
  setCustomerItemRetailPrice: CustomerItemPayload;
  /**
   * Sets this customer item's Shipping UOM override, by Shipping UOM id
   * (ConfigCategoryId).
   *
   * The chosen Shipping UOM must be one the ITEM is available in — what the item inherits from
   * its categories plus what the item added; anything outside that set is rejected. Choosing the
   * item's own effective default means "inherit", so no override is stored and any existing one
   * is cleared.
   */
  setCustomerItemShippingUom: CustomerItemPayload;
  /**
   * Sets or clears optional GPS on a customer location (retail ship-to). Pass both
   * latitude and longitude null to clear. Out-of-range or unpaired coords are
   * rejected. Re-submitting the pair already stored succeeds without emitting an event.
   * Does not touch postal address — shared address inputs stay postal-only.
   */
  setCustomerLocationCoordinates: CustomerPayload;
  /**
   * Sets or clears ONE customer location's delivery schedule — the in-house manual override of the
   * route-driven default. Pass deliveryScheduleId: null (or omit it) to CLEAR the override.
   * The target must exist on the caller's tenant and be ACTIVE, and the location must belong to the
   * named customer; both are rejected before anything is appended.
   */
  setCustomerLocationDeliverySchedule: CustomerLocationDeliverySchedulePayload;
  /**
   * Sets (creates or replaces) the typed note for a single
   * NoteContext (Ship/Pull/General) on one of a customer's
   * locations. One current value per context per location. The Ship-context note is the single
   * source of truth for the legacy flat settings.shippingNotes read. Exposed back on
   * getCustomerLocations' settings.contextNotes. Separate from the legacy append-only
   * location note list.
   */
  setCustomerLocationNote: CustomerPayload;
  /**
   * Sets or clears a customer location's receiving email, where its delivery notices go. Pass
   * email null or blank to clear. A malformed address is rejected. Re-submitting the address
   * already stored succeeds without emitting an event.
   */
  setCustomerLocationReceivingEmail: CustomerPayload;
  /**
   * Sets or clears a ship-to (customer-location)'s route override — tier 3 of the hierarchical
   * route setting, one tier down from setCustomerRoute — with just
   * (customerId, locationId, route). An empty/blank value clears the override so the
   * effective route inherits the customer's route. The narrow setter behind the planner's
   * route-assignment board (AssignShipTosDialog), additive to — and independent of — the
   * full-location updateLocation edit path. Its write-scope guard mirrors
   * SetCustomerRouteAsync one tier down: the RESOLVED target is the route this ship-to
   * carries AFTER the write — the new route when non-blank, else what the ship-to inherits once
   * its own override is gone (the customer's route, else the tenant default).
   */
  setCustomerLocationRoute: CustomerPayload;
  /**
   * Sets or clears the servicing site of one of a customer's locations — "which site services this
   * ship-to". Pass servicingSiteLocationId: null (or an empty string) to clear the link.
   * A non-empty id is rejected unless it resolves to a SiteLocation on the caller's tenant.
   * Re-submitting the link already stored succeeds without emitting an event.
   */
  setCustomerLocationServicingSite: CustomerPayload;
  /**
   * Sets or clears this customer's minimum freight charge, which overrides the tenant default, without
   * resubmitting the whole customer. Send minimumFreightCharge to set it, or
   * clearMinimumFreightCharge: true to remove it so the tenant default applies. The value must be
   * non-negative with at most two decimal places. Sending neither, or resubmitting the value already
   * stored, succeeds without emitting an event and leaves the minimum unchanged.
   */
  setCustomerMinimumFreightCharge: CustomerPayload;
  /**
   * Sets (creates or replaces) the customer-level typed note for a single
   * NoteContext (Ship/Pull/General). One current value per
   * context; the customer's notes default into orders via live inheritance. Exposed back on
   * getCustomer's contextNotes field. Separate from the legacy append-only note
   * list.
   */
  setCustomerNote: CustomerPayload;
  /**
   * Sets or clears this customer's override of the company default for the unit their orders are
   * placed in — the customer half of "Customers order in: Shipping UOM | Eaches". Pass
   * orderEntryUnit: null (or omit it) to CLEAR the override so the customer inherits the
   * tenant default and keeps inheriting it as that default changes. Read
   * effectiveOrderEntryUnit for the resolved value. Resubmitting the value already stored
   * succeeds without emitting an event.
   */
  setCustomerOrderEntryUnit: CustomerPayload;
  /**
   * Sets or clears this customer's override of the company default for how sales prices are entered
   * and shown — the customer half of "Price per: Each | Unit". Pass priceEntryUnit: null (or
   * omit it) to CLEAR the override so the customer follows the company default. Prices are always
   * stored and billed per each. Read effectivePriceEntryUnit for the resolved value.
   * Resubmitting the value already stored succeeds without emitting an event.
   */
  setCustomerPriceEntryUnit: CustomerPayload;
  /**
   * Sets or clears a customer's route override — tier 2 of the hierarchical route setting
   * (tenant default → customer → ship-to → order, most-specific-wins) — with just
   * (customerId, route). Route is a free-text scalar (not a managed aggregate), so there is
   * no existence gate. An empty/blank value clears the override so the effective route inherits
   * the tenant default. The narrow setter behind the planner's route-assignment board, additive
   * to — and independent of — the full-customer updateCustomer edit path, which this
   * mutation's write-scope guard matches exactly (B2/D3 — see UpdateCustomerAsync).
   */
  setCustomerRoute: CustomerPayload;
  /**
   * Sets or clears this customer's override of the company default statement delivery policy —
   * how their statement of account reaches them, and whether they are billed at all when they
   * close the period at exactly zero. Pass deliveryMethod: null (or omit it) to CLEAR the
   * override so the customer inherits the tenant default and keeps inheriting it as that default
   * changes. Omit skipZeroBalance to skip settled accounts. Read
   * effectiveStatementDeliveryMethod for the resolved value. Resubmitting the policy
   * already stored succeeds without emitting an event.
   */
  setCustomerStatementDelivery: CustomerPayload;
  /**
   * Saves everything on the customer's Tax tab in one call: the Federal Tax Number (blank clears it)
   * and the whole list of sales tax exemption certificates. The list is the complete set: send an empty
   * list for no certificates. Each certificate covers one state, or all states when its state is empty;
   * a certificate with a state needs a reason, there is at most one certificate per state and at most one
   * for all states, and the certificate number is required. Resubmitting what is already stored succeeds
   * without emitting an event, except that the first save of a customer always records the list.
   */
  setCustomerTaxDetails: CustomerPayload;
  /**
   * Sets or clears a customer's Customer Type with just (customerId, customerTypeId?) — the
   * narrow, event-sourced setter behind the bulk-assign flow. Pass a customerTypeId to
   * assign that type (validated to exist and be active, exactly as updateCustomer does);
   * pass null (or omit it) to CLEAR the assignment. Additive to — and independent of — the
   * full-customer updateCustomer edit path, which continues to carry customerTypeId as one
   * PATCH field among many. A route/customer scope guard mirrors updateCustomer's write side.
   */
  setCustomerType: CustomerPayload;
  /**
   * Dedicated set/clear mutation for the revenue GL mapping (Helm 33293b5e — the "unmap
   * path" fast-follow). A value replaces the mapping (Revenue-classification gate enforced
   * via CustomerTypeGlAccountGate); null/empty clears it, requiring no gate.
   * Leaves UpdateCustomerType)'s PATCH/preserve-on-omit semantics untouched.
   */
  setCustomerTypeRevenueGlAccount: CustomerTypePayload;
  setDefaultGroup: PriceGroupPayload;
  setDefaultTerms: TermsPayload;
  setDefaultVendor: MaterialItemPayload;
  /**
   * Sets the device's ENTIRE desired config — the shadow's DESIRED side — and writes it to the
   * device's IoT Hub twin, which is how a connected device actually learns what it should be doing.
   * configKeys must carry every REQUIRED key in the device's profile, each with a value: a
   * submission missing a required key, carrying a key the profile does not define, or repeating a key
   * rejects the whole call and writes nothing, and the error names the offending keys. Query
   * deviceProfileConfigKeys for the keys a given profile accepts. An OPTIONAL key
   * (sensorBreakState) may be left out: the device keeps the value it already has, or the
   * firmware default (HIGH) if it was never set, so leaving it out never resets it. To change
   * one key, read the current desired config and resubmit it with that one updated — no required key
   * is filled in on the server, because wsapi would only be guessing at a physical device's settings.
   * Scoped to the owning tenant, same as the other fleet mutations. Setting the exact config the device
   * already has still rewrites the twin but records no history.
   */
  setDeviceDesiredConfig: DevicePayload;
  /**
   * Flips a sender's admin-only restriction (Decision D). Admin-authorized: only an unrestricted
   * staff (admin) caller may change this. Defaults to false (anyone-can-send) when a sender is
   * first added; setting the same value twice is a successful no-op.
   */
  setEmailSenderAdminOnly: TenantEmailSenderPayload;
  /**
   * Replaces the ERP route assignments of the customer with the given ERP id. Send every Bonnie One
   * customerRouteAssignments row the ERP holds for the customer, deleted rows included; an empty list
   * clears them. Resending the list already stored, in any order, succeeds without recording a change.
   * An ERP id that matches no customer is an error: this never creates a customer. The rows are stored
   * as sent; which of them is in effect on a given date is not decided here.
   */
  setErpCustomerRouteAssignments: CustomerPayload;
  /**
   * Replaces a Bonnie One route's station, name and complete list of salesperson assignments, creating
   * the route the first time its code is seen. Send every salesperson row the ERP holds for the route,
   * deleted rows included; an empty list clears them. Emails are stored lower-case. Resending what is
   * already stored, in any order, succeeds without recording a change. The rows are stored as sent:
   * which of them is in effect on a given date is not decided here.
   */
  setErpRouteSalespeople: ErpRoutePayload;
  /**
   * Turns the calling tenant's ERP write-back hold on or off. While it is on, claimPendingErpWriteBacks
   * returns no records, so nothing posts to Nav, and enqueued writes keep waiting as PENDING. Set rollback
   * when the tenant is going back to the legacy system: that adds 1 to the rollback epoch, and turning the
   * hold off then records when the rollback ended (rolledBackUntil), after which a write recorded before
   * then goes to NEEDS_REVIEW instead of being posted. Turning on a hold that is already on never adds to
   * the epoch again; a plain hold set again with rollback becomes a rollback hold once. Turning off a hold
   * that is already off, or one the tenant never set, only records the reason. Rollback only counts when
   * turning the hold on; null is false. The reason is required, at most 1024 characters, and stored
   * trimmed. Every set is kept in the hold's history. ERP_WRITE_BACK_HOLD_CHANGED means another admin set
   * the hold first: nothing was changed; read it again and retry. Tenant admins only.
   */
  setErpWriteBackHold: ErpWriteBackHoldPayload;
  /**
   * Sets the console billing state for a registered member firm (contracts K1 and K2). Refuses WORKSUITE or UNSET
   * sources accompanied by externalStatus or externalPaidThrough with GROWER_BENCHMARKS_BILLING_STATE_INVALID in errors.
   * Requires an effective COMMUNITY_ADMIN roster entry (or platform superadmin) and refuses firms outside the
   * community with GROWER_BENCHMARKS_ACCESS_DENIED.
   */
  setGrowerBenchmarkFirmBillingState: GrowerBenchmarkFirmProfilePayload;
  /**
   * Marks an onboarding checklist item complete or incomplete on a registered member firm's console profile,
   * recording the acting user and completion timestamp when marked complete (contracts K1 and K2). Requires an
   * effective COMMUNITY_ADMIN roster entry (or platform superadmin) and refuses firms outside the community with
   * GROWER_BENCHMARKS_ACCESS_DENIED.
   */
  setGrowerBenchmarkFirmChecklistItem: GrowerBenchmarkFirmProfilePayload;
  /**
   * Updates a registered member firm's console tags and ticker together with its community registry label and
   * classification facets in one stream append (contracts K1 and K2). Requires an effective COMMUNITY_ADMIN roster
   * entry (or platform superadmin) and refuses firms outside the community with GROWER_BENCHMARKS_ACCESS_DENIED.
   */
  setGrowerBenchmarkFirmProfile: GrowerBenchmarkFirmProfilePayload;
  /**
   * Creates or replaces the six retail month figures for a month-cadence reporting unit owned by the caller's firm,
   * leaving the month Submitted (or minting a new version and superseding the prior version when correcting an
   * Approved month). Returns unaccepted warnings without writing when a warning code is absent from
   * acceptedWarningCodes (contracts CR2 and CR3).
   */
  setGrowerBenchmarkRetailMonthValues: GrowerBenchmarkRetailMonthPayload;
  /**
   * Grants or updates a user's program-side roster entry on a GrowerBenchmark community and projects a "Granted"
   * row into growerBenchmarkAccessLog (contract C5 and C7). Requires an effective COMMUNITY_ADMIN roster entry
   * (or platform superadmin).
   */
  setGrowerBenchmarkRosterEntry: GrowerBenchmarkCommunityPayload;
  /**
   * Transitions a submission version along the non-approval edges of the contract C6 status machine. Effective
   * COMMUNITY_ANALYST roster holders and platform superadmins may perform all permitted status transitions for
   * member firms in the community, whereas an owning member firm may only transition its own Draft or Queried
   * submission to Submitted.
   */
  setGrowerBenchmarkSubmissionStatus: GrowerBenchmarkSubmissionPayload;
  /**
   * Sets what a document is, from RECEIVED or NEEDS_KIND only. With rememberRule true the kind is also used for
   * the next document from the same sender that looks the same; REMEMBER_RULE_NOT_AVAILABLE for a document that did
   * not come by email.
   */
  setInboundDocumentKind: InboundDocumentPayload;
  /**
   * Edits the planting of one batch an inventory row holds: its plant date, its plant status, or both. A
   * field left out is kept; a field sent as null (or a blank status) is cleared. Audited: the row records
   * who changed the planting, from what, to what.
   */
  setInventoryBatchPlantDate: InventoryItemPayload;
  /**
   * Sets or changes the manually-entered ready date on an existing live-goods inventory item,
   * scoped to the caller's tenant. The derived ISO ready week updates with it (it is never set
   * directly). Setting the same date is a no-op. Scope is the ready date only.
   */
  setInventoryItemReadyDate: InventoryItemPayload;
  /**
   * The Invoice kind's channel (admin gate of setOrderEmailEnablement). Invoice on/off stays
   * emailInvoiceOnIssue.
   */
  setInvoiceEmailChannel: OrderEmailSettingsPayload;
  setItemAvailabilityPhotoPrimary: ItemAvailabilityPhotoPayload;
  setItemBatchTracking: ItemPayload;
  /**
   * Sets, changes or clears the item's value for each listed characteristic. A characteristic the request does not
   * list is untouched; a pick with a null valueId clears that characteristic. A pick that carries
   * expected is refused with ITEM_CHARACTERISTIC_PICK_CHANGED when the item no longer holds that value;
   * an omitted expected is not checked. An unknown characteristic or value, and a newly chosen deleted
   * characteristic or value, are refused with nothing saved. A request that leaves the item where it is answers
   * ENTITY_NO_CHANGES.
   */
  setItemCharacteristics: ItemPayload;
  setItemContainerConfigOverride: ItemPayload;
  /**
   * Sets or clears the Tag color new order lines for this item start with, and whether the color is kept on
   * the lines (tagColorLocked, shown as "Keep on order lines"). Pass tagColorId: null to clear
   * the default; the lock is then stored false. Send expected with the color and lock last read to
   * refuse the change with ITEM_DEFAULT_TAG_COLOR_CHANGED when someone else changed them first; omit it
   * to skip that check. Resubmitting the values already stored succeeds unchanged and emits no event.
   */
  setItemDefaultTagColor: ItemPayload;
  /** Sets or updates the labor cost per unit for a production item. */
  setItemLaborCost: ProductionItemPayload;
  /**
   * Sets (creates or replaces) the item-level typed note for a single
   * NoteContext (Ship/Pull/General). One current value per
   * context; the item's General note auto-populates an order line's note when the item is added
   * to an order. Exposed back on getItem's notes field.
   */
  setItemNote: ItemPayload;
  /**
   * Sets the tenant price label the item uses, or clears it with a null priceLabelId so the item
   * uses the tenant's Default label. The id is not checked against the tenant's list: a removed label
   * resolves to the Default. A request that leaves the item where it is answers ENTITY_NO_CHANGES.
   */
  setItemPriceLabel: ItemPayload;
  /**
   * Sets the complete set of production mapping lines for a sales item (replace semantics; an empty
   * list clears the item's mapping). Rejected when the mix percentages do not sum to exactly 100 per
   * (region, week) across the set, or when a line is malformed.
   */
  setItemProductionMappings: ItemProductionMappingPayload;
  /**
   * Sets the Shipping UOMs an item is available in, and which of them is its default; both by
   * Shipping UOM id (ConfigCategoryId).
   *
   * shippingUomIds replaces the item's whole available set, so an id left out is removed.
   * It must include every Shipping UOM the item inherits from its categories — an item cannot
   * remove those — and every id must name an active Shipping UOM. defaultShippingUomId,
   * when supplied, must be one of the ids sent.
   */
  setItemShippingUoms: ItemPayload;
  setJobGrowWeeksOverride: ProductionLotPayload;
  setJobLinksOverride: ProductionLotPayload;
  setJobPlannedHoursOverride: ProductionLotPayload;
  setJobPlantsPerPotOverride: ProductionLotPayload;
  setLaborTypes: SiteLocationPayload;
  /**
   * Re-points an existing line at another customer item (customer SKU/UPC) — any active customer
   * item of the line's item, in any customer, in effect now — or, with a null
   * customerItemId, back to the ordering customer's default. Changes only the SKU/UPC the line
   * prints on invoices and pull slips; the price stays the ordering customer's. Allowed until the
   * order ships. Find candidates with skuUpcMappings(itemId), which lists every customer's
   * mappings for an item with customerName.
   */
  setLineItemCustomerItem: OrderPayload;
  setLineItemOverridePrice: OrderPayload;
  /**
   * Switches an existing line to another of its item's Shipping UOMs. The server re-stamps the
   * line's eaches-per-unit from the chosen Shipping UOM, keeps the unit count or the eaches per
   * the ORDER's frozen order entry unit, and re-derives the rest; the line keeps its identity,
   * notes and allocations. Allowed while the order is Initialized, Open or Submitted.
   */
  setLineItemShippingUom: OrderPayload;
  /**
   * Sets both Tag colors and both locks on one or more of the order's lines, as sent: a null color clears
   * that slot. A locked first Tag color keeps its color when the order's Tag color changes. Send each
   * line's expected values so a change someone else made in between is refused
   * (LINE_TAG_COLORS_CHANGED, naming the line). An unknown line, an unknown color, or a deleted color that
   * the slot does not already hold is refused; a line still holding a deleted color can change its locks.
   * Lines whose values do not change are left alone.
   */
  setLineItemTagColors: OrderPayload;
  /**
   * Sets (or changes) a Load's Dock. Allowed only while the Load is Planning or Loaded.
   *             The Dock must exist, be active and not be deleted — read from the Dock aggregate stream, never
   *             the read model, so a Dock deleted moments earlier is refused. Deliberately not part of
   *             mergeLoad.
   */
  setLoadDock: LoadPayload;
  /** Sets (or clears, with a null id) which route stop a LoadLine comes off at. */
  setLoadLineStop: LoadLinePayload;
  /** Sets the Load's typed miles (one decimal place, zero allowed) while it is Planning or Loaded; the itinerary is resolved server-side. */
  setLoadMiles: LoadPayload;
  /** Sets the Load's pickup window (date, from and to as HH:mm, wall-clock as typed) while it is Planning or Loaded. */
  setLoadPickupWindow: LoadPayload;
  /** Sets the planned arrival time (HH:mm, ship-to local) of one route stop on a Load; refused when Delivered, deleted or the stop has no live LoadLine. */
  setLoadStopPlannedTime: LoadPayload;
  /** Sets the Load's transit kind (same day, overnight or multi-day) while it is Planning or Loaded; Unknown is refused. */
  setLoadTransitKind: LoadPayload;
  /**
   * Sets (or clears, with a null spaceTypeId) the default production space type for a
   * sub-location — the type inventory placed there is assumed to occupy absent a more specific
   * per-item assignment. Rejects an unknown/deleted sub-location (RATE_INSERT_UNKNOWN_SUB_LOCATION)
   * or an inactive/unknown space type (DEFAULT_SPACE_TYPE_NOT_ACTIVE).
   */
  setLocationDefaultSpaceType: SiteLocationPayload;
  /**
   * Sets a ship-to's order email contacts, its store's buyers: contactIds replaces the whole list and
   * [] clears it. Each must be an active contact of the customer with an email address. Hand-sent
   * confirmations, acknowledgments and quotes for an order at the ship-to go to them too; invoices never do.
   * updateLocation never changes the list.
   */
  setLocationOrderEmailContacts: CustomerPayload;
  /**
   * Sets the overhead rate for a location. Returns state from the aggregate.
   * Clients should use the locationOverheadRate query for read-after-write,
   * not the siteLocation query, which reads from a separate projection
   * that does not include overhead fields.
   */
  setLocationOverheadRate: SiteLocationPayload;
  /** Sets the unit the material item counts (each, cubic foot, cubic yard, and so on). */
  setMaterialItemBaseUnit: MaterialItemPayload;
  /**
   * Edits the planting of one batch a material bin holds: its plant date, its plant status, or both. A
   * field left out is kept; a field sent as null (or a blank status) is cleared. The bin's FULFILL site
   * row is restated in the same write.
   */
  setMaterialItemBatchPlantDate: MaterialItemLocationQuantityPayload;
  setMaterialItemBatchTracking: MaterialItemPayload;
  /**
   * Image-only patch: sets ONLY materialImage on an existing MaterialItem, touching nothing
   * else — the alternative to updateMaterialItemDetails' full overwrite for callers (bulk
   * image uploader, portal, availability-count flows) that only need to set an image and
   * previously had to echo every other field back verbatim. The image itself is replaced as
   * a UNIT: supply at least one of base64Image / imageUrl (they are alternative
   * representations of the same image); a call carrying neither is rejected. Setting a
   * hosted imageUrl clears the inline base64Image bytes and vice-versa — this mutation does
   * not patch the two sub-fields independently.
   */
  setMaterialItemImage: MaterialItemPayload;
  /**
   * Sets (or replaces) the produce-tag identity on an existing material item, touching nothing
   * else about it — including, decisively, its on-hand quantities.
   */
  setMaterialItemTagSpec: MaterialItemPayload;
  /**
   * Sets the CALLING user's own language preference (EN or ES) for the Work Suite UI. Resolves the
   * caller's own directory entry from the JWT exactly like setMyProfileImage — there is no
   * admin-sets-others path. An invalid enum value never reaches this resolver (GraphQL rejects an
   * out-of-schema literal at request-validation time); re-setting the SAME preference writes no
   * event and reports "no changes" (framework no-op).
   */
  setMyLanguagePreference: UserPayload;
  /**
   * Replaces the CALLING user's own notification settings: which channels reach them, the number
   * their texts go to, whether email arrives immediately or as one daily digest, and any per-kind
   * exceptions. Resolves the caller's own directory entry from the JWT exactly like
   * setMyLanguagePreference; there is no admin-sets-others path. Send the complete settings
   * on every call: this replaces the whole set rather than merging, so an omitted per-kind exception
   * reverts to the channel default and an omitted phone number clears it. Re-sending the identical
   * settings writes no event and reports "no changes".
   * A save that turns texts on needs the tenant's SmsNotifications feature flag; without it the
   * save is refused with SMS_NOTIFICATIONS_NOT_ENABLED and stores nothing. A save turns texts on
   * when it switches the Text channel on, or when a kind's text value goes from off to on. A
   * kind's text value is its exception's text switch, or the Text channel's value when the kind
   * has no exception, so dropping an exception whose text was off counts too. Text values sent
   * back exactly as stored never read the flag, so while it is off a user can still change their
   * other channels and keep the text choices they already saved. Turning texts off always works.
   */
  setMyNotificationPreferences: UserPayload;
  /**
   * Sets (creates or replaces) the CALLING user's own profile picture. The image is validated
   * (jpeg/png/webp, <= 5 MB), staged to the shared public-read "user-avatars" Azure Blob container
   * under a tenant/user-scoped, content-addressed path ({tenantId}/{userId}/{contentHash}.{ext})
   * exactly as item photos are stored, then the returned RELATIVE path is persisted via the
   * SetUserProfileImage event — a configured public base URL composes the absolute URL at
   * resolve time. The image bytes never enter the event store. The target is always the caller's own
   * directory entry (resolved from the JWT); there is no admin-sets-others in v1. Invalid type/size is
   * rejected with a clear error before any blob write.
   */
  setMyProfileImage: UserPayload;
  /** StaffNotCustomer. Opts the signed-in user in or out. */
  setMyWhatsNewEmail: WhatsNewEmailRecipientPayload;
  /**
   * Binds the report design that renders one order document for a customer, replacing the tenant's
   * binding for that customer's orders. Customer scope only. A null report id removes the override.
   * Rejects a report id that does not resolve for the tenant (never existed, or has been deleted)
   * or one that has no design saved yet, since either would leave that customer's document render
   * failing while the tenant-level setting still looks fine. Re-submitting the value already held
   * is a successful no-op. Not trial-limited: it records a setting against an existing customer and
   * creates no billable entity.
   */
  setNotificationDocumentReport: NotificationOverridesPayload;
  /**
   * Adjusts who receives one notification kind for a customer or an order: the derived recipients to
   * leave out and the extra addresses to add. The derived list itself is not stored here; it is
   * resolved from the customer's contacts at send time, so a contact change flows through. Both
   * lists empty removes the override. Re-submitting the value already held is a successful no-op.
   * Not trial-limited: it records a setting against an existing customer or order and creates no
   * billable entity.
   */
  setNotificationRecipients: NotificationOverridesPayload;
  /**
   * Sets whether one notification kind is sent for a customer or an order. Never blocks sends started
   * from the order and makes readiness report every route as blocked; automated sending honours it
   * once the sending worker reads overrides. Always records that the kind is wanted even where the
   * order-email cascade is off, for automated sending to honour. Inherit removes the override so the
   * next scope up decides. The customer or order must exist in the caller's tenant. Re-submitting the
   * value already held is a successful no-op. Not trial-limited: it records a setting against an
   * existing customer or order and creates no billable entity.
   */
  setNotificationSendChoice: NotificationOverridesPayload;
  setNotificationTextRecipients: NotificationOverridesPayload;
  /**
   * Sets, changes or clears the ORDER's shipping container — a ContainerConfig.ContainerCode
   * naming the container the load ships on. A null/blank containerCode clears it. Dedicated
   * single-purpose mutation because EditOrderInput cannot carry this, exactly as
   * setOrderShipFromSite exists for the ship-from site.
   *
   * ORDER-level only. The per-LINE container code is a separate fact with its own mutation
   * (updateLineItemsContainerCode); setting the order's container does NOT cascade to any
   * line. The code is validated for format only — an order-level container code alone is not a
   * full ContainerConfig key (category × size UOM × container × site), so there is no existence
   * gate, matching the per-line container code and the order's route override.
   */
  setOrderContainer: OrderPayload;
  /**
   * Sets (or replaces) the order's drop-ship destination — where planning ships and pins the
   * load INSTEAD of the order's ship-to location, which this never touches. Refused once the
   * order is Cancelled or Deleted.
   */
  setOrderDropShipDestination: OrderPayload;
  /**
   * Sets a catalog kind's delivery state for the caller's tenant: whether the platform sends that
   * customer-facing notification at all, and over which channel. This flag — not any platform
   * configuration — is what the sending workers and
   * orderEmailSendReadiness both read, so "on" here is the only truth about whether a kind
   * sends. Tenant-admin only, on the same admin precedence as
   * setEmailSenderAdminOnly.
   */
  setOrderEmailEnablement: OrderEmailSettingsPayload;
  /**
   * Sets (replaces) the tenant's routed contact type for one doc-type. Re-setting the value a
   * doc-type already has is a no-op that returns an EntityCommandHasNoChangesError with a null
   * payload. The Confirmation doc-type is rejected. Mirrors setTenantDefaultRoute.
   */
  setOrderEmailRecipientRouting: OrderEmailRecipientRoutingPayload;
  /**
   * Sets (replaces) the authorable recipients + subject + body for a tenant + doc-type.
   * Requires a tenant admin (JWT admin/superadmin or directory Admin role); customer-portal
   * callers are never authorized. Unauthorized resolver calls return EMAIL_SENDER_ADMIN_REQUIRED.
   * Subject and body are Handlebars strings (tokens + inline {{#if}}) rendered at send time;
   * null/empty subject or body means "not authored" and the send worker falls back to today's
   * behavior (hardcoded subject / per-tenant SendGrid template body). The confirmation subject
   * branches invoice-vs-credit on orderType within one config, e.g.
   * {{#if (eq orderType "Credit")}}Bonnie Plants Credit Memo No. {{orderNumber}}{{else}}Bonnie
   * Plants Document No. {{orderNumber}}{{/if}}.
   */
  setOrderEmailSettings: OrderEmailSettingsPayload;
  /**
   * Sets, changes or clears an order's Order kind, from the tenant's Order kinds list. A null orderKindId
   * clears it. A kind that is not in the list, or has been deleted, is refused. Allowed wherever the order header
   * can be edited, and changes nothing else on the order, exactly as setOrderProgram does.
   */
  setOrderKind: OrderPayload;
  /**
   * Marks an order No tax with a reason and an optional note, or changes its reason or note: a one-off
   * exempt sale where the customer holds no certificate. Records who set it and when. While it is set,
   * the order's sales tax estimate and its invoice are calculated as exempt; this mutation itself never
   * calculates tax, so a stored estimate reads as out of date until it is refreshed. Refused with
   * ORDER_NO_TAX_STATUS_LOCKED on a Synchronized, Cancelled or Deleted order and on an order past Shipped
   * already synchronized to the ERP, with ORDER_NO_TAX_CREDIT_ORDER on a credit order, with ORDER_INVOICED
   * while the order has a live invoice (a voided invoice does not count), and with
   * ORDER_NO_TAX_NOT_AVAILABLE_TO_PORTAL for a portal (customer) user. A caller with no email address is
   * refused on SetBy. Saving the reason and note the order already carries returns the no-changes error
   * and records nothing.
   */
  setOrderNoTax: OrderPayload;
  /**
   * Sets (creates or replaces) the order-level typed note for a single
   * NoteContext (Ship/Pull/General). One current value
   * per context; the resulting raw notes are exposed on the order's orderNotes field.
   */
  setOrderNote: OrderPayload;
  /**
   * Sets, changes or clears an order's PLANNED ship date post-create — the date the load is
   * scheduled to leave the building, distinct from shippedDate (the actual, past-tense ship
   * event). A null plannedShipDate clears it. Dedicated single-purpose mutation because
   * EditOrderInput cannot carry this, exactly as setOrderContainer exists for the
   * order's shipping container.
   */
  setOrderPlannedShipDate: OrderPayload;
  /**
   * Sets, changes or clears an order's Program, a name from the tenant's Programs list. A null program
   * clears it. A program that is not in the list is refused. Allowed wherever the order header can be edited, and
   * changes nothing else on the order: not another header field, the status or a price. Dedicated mutation
   * because EditOrderInput does not carry the Program, so saving the whole header can never clear it.
   */
  setOrderProgram: OrderPayload;
  /**
   * Sets, changes or clears the quote details on a draft order: the last day the quote is valid, and
   * a staff follow-up on it (the day, a note, who it is assigned to, and whether it is done). A field
   * left out keeps its current value, and a follow-up started without an assignee is assigned to the
   * caller. Refused unless the order is Initialized or Open. A save that changes nothing returns the
   * no-changes error and records nothing.
   */
  setOrderQuoteDetails: OrderPayload;
  /**
   * Sets or changes an order's structured ship-from site post-create. shipFromSiteLocationId is
   * the WorkSuite-native SiteLocationId the FULFILL container / ContainerConfig /
   * config-category surfaces key on (NOT the ERP station code); the site must exist (by native id) and
   * be active for the tenant. Additive companion to the legacy name-only ship-from location.
   */
  setOrderShipFromSite: OrderPayload;
  /**
   * Sets, changes or clears the order's Tag color. A null or blank tagColorId clears it. Every line
   * whose first Tag color is unlocked follows it in the same change; locked lines and every line's second
   * Tag color stay as they are. Send expected with the color you last read so a change someone else
   * made in between is refused (ORDER_TAG_COLOR_CHANGED); leave it out to skip that check. An unknown or
   * deleted color, or a deleted order, is refused, and choosing the color the order already has changes
   * nothing.
   */
  setOrderTagColor: OrderPayload;
  /**
   * Sets or clears the tenant's Orderful API key secret-name reference (a @keyvault(...)
   * reference string into ws-tenant-secrets; clear by omitting the value). Stores the
   * reference only — wsapi never resolves, mints, or deletes the underlying secret.
   */
  setOrderfulApiKeySecretName: OrderfulIntegrationConfigPayload;
  /** Sets or clears the tenant to Orderful Organization mapping (clear by omitting the name). */
  setOrderfulIntegrationMapping: OrderfulIntegrationConfigPayload;
  /** Sets the tenant's Orderful integration status (Active / Inactive / Deleted). */
  setOrderfulIntegrationStatus: OrderfulIntegrationConfigPayload;
  /**
   * Sets or clears the tenant's own Orderful Organization ISA id(s) (clear by passing an empty list).
   * These identify the tenant so transaction direction (inbound/outbound) can be derived by matching
   * against sender/receiver ISA. Entries are trimmed, blanks dropped, and deduped case-insensitively.
   */
  setOrderfulOrganizationIsaIds: OrderfulIntegrationConfigPayload;
  setPodAssignmentReplicas: AdminBackgroundServiceConfigPayload;
  /**
   * Sets what a portal user may see in the customer portal: today, whether they see prices
   * (pricing: OFF hides wholesale prices, totals, charges, tax and freight from every portal field,
   * refuses invoices and payment, and leaves retail prices visible). The whole permission set is sent and
   * replaces the stored one; sending the stored values writes no event and reports "no changes". Refused
   * with USER_NOT_PORTAL_USER for a user who does not hold the Portal role.
   *
   * Admin/SuperAdmin gated like the rest of the tenant user-admin surface: what a customer's login may see
   * is an access decision. Portal principals are excluded by the RestockWriter policy, so a buyer cannot
   * turn their own prices back on. Separate from the staff-side feature permissions (Helm 1ded239f).
   */
  setPortalUserPermissions: UserPayload;
  /**
   * Sets — or clears — a price group's whole-group percentage derivation ("this group = group X
   * minus N%"). Supply both derivedFromPriceGroupId and derivedPercentOff to derive;
   * supply neither to clear. Deliberately a mutation of its own rather than fields on
   * updatePriceGroup: that whole-record write carries only id+name, so folding the derivation
   * into it would let any existing caller silently clear a configured one.
   * derivedPercentOff is a percent VALUE (4 = 4%), matching the price LEVEL surface.
   * Managed (QB-sync-owned) groups are read-only here for the same reason their name and levels are.
   */
  setPriceGroupDerivation: PriceGroupPayload;
  /**
   * Sets — or clears — a price group's ORDER VOLUME discount rule: "an order of ≥N units (or ≥$X)
   * gets P% (or $Y) off". Supply all four fields to configure it; supply none to clear it.
   * value is a percent VALUE (10 = 10%) for a percentage rule and dollars for a flat one,
   * matching the rest of the pricing surface — never a 0–1 fraction.
   *
   * Its own mutation rather than fields on updatePriceGroup, and its own section rather than
   * a row in the price-level grid: the rule targets no item and no category, and it produces a
   * DISCOUNT rather than a charge. It is not GrowPoint's whole-order price-level jump — no line
   * price moves.
   *
   *
   * Staff-only. Bare [Authorize] puts this on the same internal surface as every
   * other price-group mutation, which the customer portal's schema does not expose — a portal user
   * configuring the volume discount their own orders receive is the failure mode this excludes.
   * Managed (QB-sync-owned) groups are read-only here for the same reason their name and levels
   * are.
   *
   *
   * A PERCENTAGE rule is validated against the tenant's MaxDiscountPercentage here, where
   * the person typing it can be told. A FLAT rule has no order to measure a percentage against at
   * this point ("$500 off" is legal on a $5,000 order), so it is bounded at order-evaluation time
   * instead — by the tenant cap as well as by the discountable base. Every rule is capped; only
   * the moment of enforcement differs.
   */
  setPriceGroupOrderVolumeDiscount: PriceGroupPayload;
  /**
   * Sets — or clears — a price group's declarative QUALIFICATION conditions: "these prices only
   * apply when the order was placed on/before orderByDate AND at least
   * minLeadTimeDays days ahead of the requested ship date". Supply either field, or both,
   * to configure; supply neither to clear the group back to unconditional.
   *
   * The two conditions are INDEPENDENT and combine with AND — either alone is a complete
   * configuration. orderByDate is INCLUSIVE (an order placed on the cutoff day qualifies)
   * and minLeadTimeDays is inclusive at its boundary (exactly N days qualifies, N-1 does
   * not). minLeadTimeDays: 0 is a configured condition, NOT the same as omitting it.
   *
   *
   * Its own mutation rather than fields on updatePriceGroup, and its own section rather than
   * a row in the price-level grid: that whole-record write carries only id+name, so folding these
   * in would let any existing caller silently clear a group's conditions — turning a gated
   * early-order group into one that discounts every order.
   *
   *
   * Staff-only. Bare [Authorize] puts this on the same internal surface as every
   * other price-group mutation, which the customer portal's schema does not expose — a portal user
   * editing the cutoff their own orders are judged against is the failure mode this excludes.
   * Managed (QB-sync-owned) groups are read-only here for the same reason their name and levels
   * are.
   *
   *
   * This mutation CHANGES PRICES. Nothing here evaluates a condition — this is still only
   * the write — but the per-order resolver that reads these conditions is live, so configuring a
   * group alters what orders are charged from the moment it is saved, for every tenant whose
   * PriceGroupQualificationEnforcement feature flag is ON. An order that fails a condition
   * is priced from the group the failing group DERIVES FROM, then down the Location → Customer →
   * Default hierarchy; an order that fails every candidate is refused a price rather than given
   * one of $0. For a tenant whose flag is OFF the conditions are stored and not evaluated, and
   * pricing is unchanged.
   */
  setPriceGroupQualificationConditions: PriceGroupPayload;
  /**
   * Sets or clears the volume pool on a set of price levels in one write: every addressed level
   * moves into the given pool, or out of any pool when volumePoolId is null. All-or-nothing — an id
   * the group does not hold refuses the whole request — and the resulting ladders must still agree
   * on their pool. This is the only way to clear a pool; the merge and update inputs treat null as
   * "preserve". Re-sending the current assignment appends nothing.
   */
  setPriceLevelsVolumePool: PriceGroupPayload;
  /**
   * Makes an already-VERIFIED custom domain the portal's PRIMARY host — the switch step of a move
   * to a new domain. After it, the portal link, canonical login and self-registration links all
   * resolve to input.domain, and the outgoing domain can be withdrawn.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  setPrimaryPortalCustomDomain: PortalSettingsPayload;
  /** Sets a job's notes. Null or blank clears them. */
  setProductionJobNotes: ProductionLotPayload;
  setProductionLotAsyncImportJobRowIds: AsyncImportJobPayload;
  /**
   * Sets, changes or clears the production item a lot grows. The item must be Active and on the
   * lot's plant and pot. Refused once the lot has posted any quantity.
   */
  setProductionLotProductionItem: ProductionLotPayload;
  /**
   * Sets or clears the recipe's whole-estimate flat-rate cost override. When an amount is
   * supplied the recipe's cost IS that amount and calculateRecipeCost reports costSource
   * FLAT_RATE, keeping the computed breakdown alongside it for reference. Supplying no
   * flatRateCost clears the override and returns the recipe to its computed cost. A supplied
   * amount must be greater than zero.
   */
  setProductionRecipeFlatRateCost: ProductionRecipePayload;
  /**
   * Sets or clears which of a material item's assigned vendors prices that material on one of the
   * recipe's material events. Supplying no vendorId clears the override, returning that
   * material line to the item's default vendor.
   */
  setProductionRecipeMaterialVendor: ProductionRecipePayload;
  setProductionRecipeTaskEventIds: ProductionRecipePayload;
  /**
   * Switches a recipe between Simple and Start. Simple → Start removes every variation's link in the same
   * write. Start → Simple is allowed while other recipes link this one: any active recipe is a link target,
   * so nothing is left dangling. A combo recipe is refused
   * with RECIPE_TYPE_IS_FIXED_FOR_COMBO; a deleted recipe is refused; asking for the type the recipe
   * already has changes nothing. Jobs and lots built from the recipe are not changed.
   */
  setProductionRecipeType: ProductionRecipePayload;
  /** Replaces reminder settings. No recipient or empty lead times turns reminders off. */
  setProductionTriggerReminders: ProductionTriggerPayload;
  /**
   * Sets planned quantities for one site and ISO year, one cell per production item and ISO week, creating
   * the plan on its first write. A quantity of 0 clears the week. Cells not named are left as they are.
   * Rejected, with nothing written, when any cell is invalid or names a production item that does not
   * exist. Also rejected, with nothing written, as PRODUCTION_YEAR_PLAN_CHANGED when a cell's
   * baseQuantity no longer matches its saved week and the save would change that week; the payload then
   * carries the plan as it is saved now and one conflict per clashing week.
   */
  setProductionYearPlanCells: ProductionYearPlanPayload;
  /**
   * Sets or clears one production item's "planned like" link for a site and ISO year: plan this item as a
   * percentage of a comparison item, shifted by a number of weeks. A null plannedLike clears the
   * link. Rejected, with nothing written, when either production item does not exist.
   */
  setProductionYearPlanItem: ProductionYearPlanPayload;
  /**
   * Links or unlinks the production plan a site's year plan belongs to. A null productionPlanId
   * clears the link. Rejected, with nothing written, when the production plan does not exist.
   */
  setProductionYearPlanProductionPlan: ProductionYearPlanPayload;
  setPropagationYield: ProductionLotPayload;
  setPurchaseOrderUrgent: VendorPurchaseOrderPayload;
  /** TENANT ADMIN, FLAG. Turns Copy POs to Ramp on or off. Codes: RAMP_NOT_CONNECTED. */
  setRampCopyPurchaseOrders: RampConnectionPayload;
  /** W2. WORKER ONLY. Stores the worker's match results for the token's tenant. Rows for linked or unknown vendors are skipped, not refused. */
  setRampVendorSuggestions: SetRampVendorSuggestionsPayload;
  /**
   * Sets which task events are the recipe's additional flat costs, replacing the whole list. Each
   * id must name an existing task event in the tenant. calculateRecipeCost adds each task event's
   * CostPerEvent to additionalCost, and flags one with no CostPerEvent as incomplete. An empty list
   * clears the recipe's additional costs.
   */
  setRecipeAdditionalCostEventIds: ProductionRecipePayload;
  setRecipeLaborSource: ProductionRecipePayload;
  /**
   * Replaces the report's app tags and nothing else. Tags are deliberately kept off the
   * updateReport full-replace path so that unrelated edits — rename, star, move-to-folder,
   * parameter or template changes — can never clear them by omission. Duplicate tags in the
   * input are collapsed, and an empty list clears every tag. Submitting the same tags in the same
   * order writes nothing; resubmitting the same set in a different order is treated as a change,
   * so preserve the order returned by the API rather than rebuilding the list.
   *
   * The Orders grid tag is accepted only on a report whose data source takes orderNumbers; any other
   * report is refused with ORDERS_GRID_REQUIRES_ORDER_SOURCE and nothing is written.
   *
   * Tag changes are not report versions: they do not appear in reportVersions and cannot be
   * reverted to. The append is revision-pinned, so a concurrent write to the same report is
   * rejected rather than silently overwritten — on that error, re-read the report's tags,
   * reapply the change, and submit again.
   *
   * On a saved view, tags need the change right, as updateReport does.
   */
  setReportAppTags: ReportPayload;
  /**
   * Sets the authorable email subject/body (Handlebars, tokens + inline {{#if}}) on an
   * existing schedule. Null/empty clears a field back to the "not authored" fallback, which the
   * downstream send worker resolves to the report name (subject) / per-tenant template (body).
   */
  setReportScheduleEmailSettings: ReportSchedulePayload;
  /**
   * Sets a Draft session's own cap on one Kit's total across its Stores. The cap must be at most the
   * maximum the current component availability supports, read under the caller's own scope, after
   * every other Kit's entered total takes its share of a shared component. Raising a lower cap within
   * that maximum is allowed. Entered counts are never changed: a total above the cap shows as excess
   * and blocks Submit until corrected. The availability's scope, time and conversion are saved with
   * the cap as provenance only; the cap reserves nothing.
   */
  setRestockSessionKitCap: RestockSessionKitPlanPayload;
  /**
   * PWA AG-grid manual-edit path. Each cell change posts the new OrderQuantity for
   * one or more (ItemId, CustomerLocationId) rows. The event payload carries every
   * absolute the projections write (post-event OverrideCount and full per-item
   * allocation snapshot), so projections perform pure $set/upsert writes — see
   * atlas standard accaf08f270b40efa04fbbcdd605fc1c.
   */
  setRestockSessionOrderQuantities: RestockSessionPayload;
  /**
   * Sets (replaces) the tenant's delivery-schedule mapping for one route. The schedule must
   * exist for the tenant and be ACTIVE. Route codes match case-insensitively: re-setting the
   * schedule a route already has — including with different route casing — is a no-op that
   * returns an EntityCommandHasNoChangesError with a null payload. Mirrors
   * setOrderEmailRecipientRouting.
   */
  setRouteDeliverySchedule: RouteDeliveryScheduleConfigPayload;
  /**
   * Replaces the site's entire contact list (role, name, email, phone). An empty list clears
   * every contact. Email is required per contact; name and phone are optional.
   */
  setSiteContacts: SiteLocationPayload;
  setSiteLaborRate: SiteLocationPayload;
  setSiteLocationAsyncImportJobRowIds: AsyncImportJobPayload;
  /**
   * Pins or clears a site's GPS coordinates (device GPS or typed). Both null clears. The site must already
   * have an address, and a later address save keeps the pin.
   */
  setSiteLocationCoordinates: SiteLocationPayload;
  /**
   * Sets the IANA time-zone id on a SiteLocation. Required before rate mutations
   * (setLocationOverheadRate, setSiteLaborRate) are accepted.
   */
  setSiteTimeZone: SiteLocationPayload;
  /**
   * Creates or updates a space-capacity window on any existing, non-deleted sub-location of a site (a parent included) for a space type, over an
   * ISO-week range (wrap-aware) and an optional year (null = recurring/seasonal). Rejects a window that
   * overlaps another in the same (sub-location, space type, year-scope) bucket, an inactive space type,
   * or an unknown or deleted sub-location. A location's capacity is its own if set, otherwise the sum of
   * its children, recursively; the parent's own capacity wins, so it is never counted twice.
   */
  setSpaceCapacityWindow: SiteLocationPayload;
  /** @deprecated Use setSpaceDimensionOverride, which supports customer-scoped overrides. */
  setSpaceCategorySiteOverride: ProductionSpaceCategoryPayload;
  setSpaceDimensionOverride: ProductionSpaceCategoryPayload;
  /**
   * Creates or updates the year-round default capacity for a (sub-location, space type) — the
   * square footage that space type gets in every week no capacity window covers. Rejects an inactive
   * space type, an unknown or deleted sub-location, or an amount of 0 or less — clear a row with
   * removeSpaceTypeCapacity. A parent location may hold it; its own capacity wins over its children's
   * sum. Capacity windows remain the week-range overrides.
   */
  setSpaceTypeCapacity: SiteLocationPayload;
  /** Sets one inventory row's or one material bin's batches, and so its total, from an ERP read of the stock. */
  setStockBatchesFromErp: SetStockBatchesFromErpPayload;
  setStoreClasses: StoreClassPayload;
  /**
   * Sets one step's own crew speed in containers per hour. Labor demand and cost divide the job quantity by
   * each active step's speed and add the results. A step with no speed of its own uses the event's
   * unitsPerHour multiplied by the number of active steps, so an event at 120 with three steps reads
   * 360 per step until someone sets real speeds. Changing one step never changes another step.
   */
  setTaskEventDetailThroughput: ProductionTaskEventPayload;
  setTaskEventDirectCost: ProductionTaskEventPayload;
  setTaskEventLaborTypeTag: ProductionTaskEventPayload;
  setTaskEventThroughput: ProductionTaskEventPayload;
  /** Sets the company-wide Availability quantity basis. Requires tenant Admin or platform SuperAdmin. Identical submissions succeed without an event. */
  setTenantAvailabilityQuantityBasis: TenantPayload;
  /** Sets the company-wide Availability quantity entry. Requires tenant Admin or platform SuperAdmin. Identical submissions succeed without an event. */
  setTenantAvailabilityQuantityEntry: TenantPayload;
  /**
   * Selects a tenant's active billing cadence (superadmin). The cadence must be one the rate card
   * offers (or None to clear it); otherwise the mutation is rejected with no event written.
   */
  setTenantBillingFrequency: AdminTenantPayload;
  /**
   * Sets a tenant's per-cadence platform-billing rate card (superadmin). Amounts are in minor units;
   * a null cadence is not offered. Audited on the tenant stream. Resubmitting the same prices is a no-op.
   */
  setTenantBillingRateCard: AdminTenantPayload;
  /**
   * Sets or clears the tenant's default carrier — tier 0 of the hierarchical carrier setting
   * (tenant default → customer → ship-to → order). Carrier is a free-text scalar; an empty/blank
   * value clears the default. Mirrors SetTenantDefaultRoute.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  setTenantDefaultCarrier: TenantCarrierConfigPayload;
  /**
   * Marks an existing SendGrid sender as the tenant default (clearing any previous default). The default flag
   * routes mail only while the tenant's sender selection is INHERIT: under an explicit PLATFORM or COMPANY
   * selection the call is refused with EMAIL_SENDER_SELECTION_IS_EXPLICIT, and selectTenantEmailSender changes
   * the sender. A custom SMTP sender is selected with selectTenantEmailSender, never here.
   */
  setTenantDefaultEmailSender: TenantEmailSenderPayload;
  /**
   * Sets or clears the tenant's default route — tier 0 of the hierarchical route setting
   * (tenant default → customer → ship-to → order). Route is a free-text scalar; an empty/blank
   * value clears the default.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  setTenantDefaultRoute: TenantRouteConfigPayload;
  /**
   * Sets or clears the Report aggregate ID bound to one load paperwork kind (manifest, pull
   * sheet, delivery ticket, invoice, freight quote) for the Logistics load screen. Updating one kind leaves
   * every other kind's binding untouched. Pass null or empty reportId to clear the binding — for
   * the Invoice kind, a cleared binding falls back to the tenant's effective order invoice
   * report. Rejects a report id that does not resolve for the tenant or has no design saved yet.
   */
  setTenantLoadPaperworkBinding: TenantPayload;
  /**
   * Sets the tenant's load paperwork policy: which load paperwork kinds print for a regular load
   * and for a drop-ship load. Replaces the whole policy for both load types.
   */
  setTenantLoadPaperworkPolicy: TenantPayload;
  /**
   * Sets whether the caller's tenant requires unenrolled staff to enrol, and how many days of
   * advisory notice they get first. Always replaces the stored requirement outright — this is not a
   * merge or a versioned update. Turning the requirement back on after it was off restarts the grace
   * window; saving again while it is already on leaves the grace window's start untouched.
   *
   *
   * **Returns:**
   * The requirement as stored, or why it could not be set.
   */
  setTenantMultiFactorRequirement: TenantMultiFactorPolicyPayload;
  /**
   * Sets this tenant's per-tenant online-payment ceiling override (T28, superadmin), in minor units.
   * Wins over the system payment-configuration aggregate's Active processor cap and the domain
   * default wherever the effective cap is resolved (TenantBillingData.OnlinePaymentMaxAmount;
   * the T21 checkout gate composes the same resolution). Resubmitting the same amount is a no-op.
   */
  setTenantOnlinePaymentMaxAmountOverride: AdminTenantPayload;
  /**
   * Sets the company default for the unit customers place orders in — the "Customers order in:
   * Shipping UOM | Eaches" setting. SHIPPING_UOM is today's behaviour and the value a
   * tenant that has never configured this reads as. A customer's own orderEntryUnit
   * override wins over this default; a customer with no override follows it, so changing this
   * value flows through to every such customer. Resubmitting the value already stored succeeds
   * without emitting an event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  setTenantOrderEntryUnit: TenantPayload;
  /**
   * Sets the company default for how sales prices are entered and shown — the "Price per: Each |
   * Unit" setting. EACH is today's behaviour and what a tenant that has never set this reads
   * as. Prices are always stored and billed per each, so this changes no price, total or invoice. A
   * customer's own priceEntryUnit override wins over this default; a customer with no override
   * follows it. New orders are stamped with the resolved value; existing orders keep theirs.
   * Resubmitting the value already stored succeeds without emitting an event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  setTenantPriceEntryUnit: TenantPayload;
  /**
   * Sets (creates or replaces) the tenant's SMTP connection. The password is encrypted at rest before
   * the event is written; the config change resets verification to unverified.
   */
  setTenantSmtpConnection: TenantSmtpConnectionPayload;
  /** @deprecated Superseded by the effective material price surface. Use addEffectiveMaterialPrice to record a new effective quote, correctMaterialPrice to change a quote that is already selected, and voidMaterialPrice to exclude a quote from selection. Read materialPriceWriteCapability first to see whether this tenant may write prices. This path still works exactly as before and is not scheduled for removal yet, so existing callers keep working until they migrate. */
  setVendorMaterialCost: MaterialItemPayload;
  /** Replaces buyer purpose text on an open purchase order; empty clears it. */
  setVendorPurchaseOrderPurposeText: VendorPurchaseOrderPayload;
  setWorkOrderLineNumber: JobPayload;
  setWorkerConfigRunNow: AdminWorkerConfigPayload;
  setWsapiImportRunNow: WsapiImportPayload;
  /**
   * Shares a saved view with one person (by email) or the whole company (no email), with the USE right (open it
   * and run its row actions within the user's own rights) or CHANGE (also edit it). Sharing again with the same
   * grantee replaces their right; sharing with the owner, or giving a right the grantee already holds, writes
   * nothing. A grant never raises anyone's own rights on the records a row action writes.
   *
   * Only the owner or a company admin may share (myRights.share); anyone else is refused with REPORT_RIGHT_DENIED.
   * An open report has no owner and is refused with REPORT_OPEN_ACCESS: a company admin gives it an owner first
   * with assignReportOwner. Refused with SAVED_VIEWS_NOT_ENABLED while the company's SavedViews flag is off.
   */
  shareReport: ReportPayload;
  /**
   * Ship an existing MovementOrder. Transitions Created → Shipped. Identical
   * retries are deterministic no-ops thanks to IfChangedPer in the aggregate.
   */
  shipMovementOrder: MovementOrderPayload;
  /**
   * Ships an order whose lines are short of stock, in one write: adds the live-goods stock it is short, counts up
   * the hard goods it is short, allocates the lines as sent, and ships them. All of it is recorded, or none of it.
   */
  shipOrderWithStockCorrections: OrderPayload;
  shipPurchaseOrder: VendorPurchaseOrderPayload;
  /** Skip a task. Idempotent: identical reason replayed is a no-op. */
  skipAssignmentTask: CycleCountAssignmentPayload;
  /**
   * Hides the caller's Home welcome for 7 days in this tenant. Calling it again while the snooze runs
   * keeps the original time and expiry. Once it has expired, calling it starts a new period.
   */
  snoozeOnboardingWelcome: OnboardingWelcomePreferencePayload;
  splitProductionLot: SplitProductionLotPayload;
  /**
   * Stages one firm period's legacy line values read from a source file, ahead of its import approval. Restaging
   * the same source digest returns the document already staged and writes nothing. Restricted to platform
   * superadmins.
   */
  stageGrowerBenchmarkImportedLines: GrowerBenchmarkImportedLinesPayload;
  /**
   * Records the wsapi-services worker's FusionAuth login-redirect sync outcome for a custom portal
   * domain — the only writer that records a REAL worker-observed outcome for
   * loginRedirectRegistered / loginSyncFailureReason. Both fields are also assigned by
   * the PortalCustomDomainVerified and PortalCustomDomainRemoved folds on their own transitions,
   * from values hardcoded false/null in this release.
   * Gated to the worker's service-account JWT (WorkerService policy); never reachable by a staff or
   * customer JWT.
   */
  stampPortalCustomDomainLoginRedirectSync: PortalSettingsPayload;
  /** Start a task. Idempotent: an identical retry is a deterministic no-op. */
  startAssignmentTask: CycleCountAssignmentPayload;
  /**
   * Starts a count session on a production line. When the line has claimed count devices, each
   * device's running total is reset first, and the session starts only after every device confirms
   * its reset. If a device cannot be reset or does not confirm in time, no session is started and the
   * error names the device and the reason. Retrying with the same count session id resumes the same
   * reset instead of resetting again, and returns the session if it has already started.
   */
  startCountSession: CountSessionPayload;
  /**
   * Start a floating timer for a worker without selecting a task.
   * Enforces the global one-timer-per-worker rule across both FloatingTimeEntry and TaskAssignment aggregates.
   */
  startFloatingTimer: FloatingTimeEntryPayload;
  /**
   * UNAUTHENTICATED. The guest pay page's Pay button: given only the token from a pay link, starts Stripe hosted
   * Checkout for the one invoice the link opens and returns the URL to redirect to. The server prices the invoice;
   * nothing else is accepted. A token publicInvoicePayLink answers EXPIRED gets EXPIRED here too, with the grower
   * and no invoice data, and every other token that opens nothing gets the single invalid answer. Pressing Pay again
   * while the session is open returns the same session, or a newly priced one. A refusal says why and whether to try
   * again; when the pay link itself ends too soon for a payment, it says so and when the link expires.
   */
  startInvoicePayLinkCheckout: PublicInvoiceCheckoutStartPayload;
  /**
   * Begins enrolling an authenticator app: mints a secret and returns it with the provisioning URI
   * to render as a QR code. Nothing is enabled yet.
   *
   *
   * **Returns:**
   * The secret and provisioning URI, or why enrollment could not start.
   */
  startMyMultiFactorEnrollment: StartMyMultiFactorEnrollmentPayload;
  /**
   * Starts the tenant's onboarding journey, or resumes the one it has: one journey per tenant, created on
   * the first call and returned by every later one. A call from a chat turn other than the one that
   * started the journey records that turn's resume, once per turn. Returns the journey's current state in
   * brief; the full state is the journey state query.
   */
  startOrResumeOnboardingJourney: OnboardingJourneyStartPayload;
  /**
   * Starts a rollout of a published release on its product line and opens the first ring over the eligible fleet.
   * Refused while another rollout of the line is in progress.
   */
  startOtaRollout: OtaRolloutPayload;
  /**
   * TENANT ADMIN, FLAG. Mints a single-use state bound to the caller's tenant and user (valid 10
   * minutes) and returns the Ramp authorize URL (sandbox https://demo.ramp.com/v1/authorize, production
   * https://app.ramp.com/v1/authorize, from config). Scopes requested: bills:read vendors:read
   * entities:read purchase_orders:read purchase_orders:write.
   * Codes: RAMP_NOT_ENABLED, RAMP_NOT_CONFIGURED.
   */
  startRampConnect: StartRampConnectPayload;
  /**
   * Queues a background Reapply Recipes run for the same input reapplyRecipes takes and returns at once
   * with the run QUEUED. The run worker applies the selections chunk by chunk with the same code
   * reapplyRecipes uses; poll reapplyRecipesRun for progress and results.
   */
  startReapplyRecipesRun: StartReapplyRecipesRunPayload;
  /**
   * Begins a server-driven Restock session creation workflow. Emits SessionCreationStarted
   * immediately; the BackgroundWorkflows.RestockSessionCreation.RestockSessionCreationWorkflowWorker
   * then chunks by location, runs populate→calculate→persist per chunk, and emits progress/completion
   * events that subscribers observe via onRestockSessionBatchProgress.
   */
  startRestockSessionCreation: RestockSessionPayload;
  /** Start working on a task assignment. Transitions from Open to InProgress. */
  startTask: TaskAssignmentPayload;
  /**
   * Start a timer on a task assignment.
   * Enforces the global one-timer-per-worker rule: checks for running floating timers
   * and other running task assignment timers before allowing start.
   */
  startTaskAssignmentTimer: TaskAssignmentPayload;
  /**
   * ANONYMOUS: submits a trial signup. Guarded by the reusable per-IP + per-email rate limit,
   * disposable-email blocklist, optional email verification (RequireVerification, default
   * off — the human approval gate is the control), and the daily new-tenant cap. Records a
   * TrialRequest in PendingApproval — NOTHING ever auto-creates a tenant — annotated with
   * existing-tenant match candidates for the human approver. Idempotent on email+company: a
   * duplicate submit returns the existing request. When RequireApproval is off AND there
   * were NO match candidates, the request is auto-approved (still via a recorded Approved event
   * the worker consumes). The response is deliberately uniform for every accepted signup.
   */
  startTrial: StartTrialPayload;
  /** Only from ON. */
  stopContactTexts: ContactTextConsentPayload;
  /** Stop a running floating timer. Transitions the entry to Unlinked status. */
  stopFloatingTimer: FloatingTimeEntryPayload;
  /** Stop a running timer on a task assignment. */
  stopTaskAssignmentTimer: TaskAssignmentPayload;
  /**
   * WORKER ONLY. Overwrites the tenant's token document in place; writes no event. Call it ONLY when
   * a refresh response carries a refresh_token different from the stored one, and send that refresh
   * token with the access token from the same response. A refresh that returns only a new access token
   * is never stored: keep that access token in worker memory, and after a restart refresh again.
   * Never recreates a deleted document (after a disconnect or RECONNECT_NEEDED it returns
   * RAMP_NOT_CONNECTED). Codes: RAMP_NOT_CONNECTED.
   */
  storeRampTokens: RampConnectionPayload;
  /**
   * One-time cleanup for the retired Maintenance and Ops roles: removes them from every user in every
   * tenant that still holds them and leaves every other role alone. Each user gets the ordinary
   * role-change event, so the directory row follows through the projection. Pass dryRun: true to
   * list the users and the roles they would end with, writing nothing. Safe to re-run: once the
   * projection has caught up, a run finds nobody. A user whose write fails is reported with
   * error set and the run carries on with the rest. Platform superadmin only.
   */
  stripRetiredUserRoles: StripRetiredUserRolesPayload;
  /** Submits a contract's autopay enrollment. Submitting IS acceptance (EULA-like). */
  submitContractRecordEnrollment: ContractRecordPayload;
  /**
   * Submits a production lot as a Draft for a produce admin to approve with approveProductionLot.
   * It takes the same input, site scope and validation as createProductionLot and takes its Lot and
   * Job numbers now. Demand, schedules, reports and counts ignore it until it is approved; rejecting it is
   * deleteProductionLot.
   */
  submitDraftProductionLot: ProductionLotPayload;
  submitErpLoadListSession: ErpLoadListSessionPayload;
  submitFullOrder: OrderPayload;
  /**
   * Stores one page of a prepared artifact's rows: the revision header once, then the page's rows once
   * each. A repeat of a page returns it as recorded; other content for a recorded page is refused. Worker
   * only.
   */
  submitMigrationPreparedRowPage: SubmitMigrationPreparedRowPagePayload;
  /**
   * Accepts the grower's sent help request, citing the review shown in an earlier message. The accepted
   * request is what the existing data-received staff flow delivers by email and Teams; this call sends
   * nothing itself.
   */
  submitOnboardingHelpRequest: SubmitOnboardingHelpPayload;
  /**
   * Stores fernie's answer to "what about this source or this parse would you change to make preparation
   * better next time?" as a suggestion for Silverfern staff. It is never applied and grants nothing: it
   * changes no mapping, setting, artifact, question, approval, job or run.
   */
  submitOnboardingParsingSuggestion: SubmitOnboardingParsingSuggestionPayload;
  /**
   * The supervisor's per-order verification commit (the heart of the Verify manager flow). Gated to
   * VerifyManager regardless of the tenant's staged/direct mode. In one atomic
   * commit it emits V1.OrderVerified (setting each line's ShippedQuantity), transitions the
   * order picked → shipped through the existing inventory-release path (decrement + deallocate), and
   * then records this order's consumption of every listed container via the existing
   * VerifyVerifyContainer aggregate function. A container becomes Verified once every order
   * associated with it has consumed it, so a container shared by several orders stays consumable until
   * the last of them verifies; the container projection then flips the document to Verified and
   * publishes the Verified status to the dashboard subscription. SubmittedBy is the
   * authenticated submitter (in direct mode, the worker — recorded as the verifier). Substitutions are
   * accepted as empty arrays in v1.
   *
   * Only a Picked order is verified, and only from containers neither Verified nor sent back. Anything else is
   * refused with a named error and changes nothing, asked in this order: ORDER_ON_HOLD,
   * ORDER_NOT_PICKED (e.g. an Open, Acknowledged or Synchronized order) or ORDER_ALREADY_VERIFIED
   * (a second verification of a verified order, whatever its quantities), then
   * VERIFY_CONTAINER_ALREADY_VERIFIED or VERIFY_CONTAINER_REMOVED (a container sent back through
   * removeVerifyContainer), for the first such container the submit names. A keyed replay of the recorded
   * verification, with the same containers and quantities, is not refused: it is answered with the order as it
   * stands and writes nothing to it, whatever its status; it only consumes a recorded container the first attempt
   * never reached. Of two submits of one order racing each other, the one that loses is refused with
   * CONCURRENT_WRITE_CONFLICT or ORDER_ALREADY_VERIFIED and changes nothing; retried under its key,
   * it is answered.
   *
   *
   * input.IdempotencyKey is optional: when supplied, a duplicate submit under the same
   * (TenantId, key) short-circuits before re-evaluating the command and answers with the ORIGINAL
   * result instead of the ORDER_ALREADY_VERIFIED refusal a keyless resubmit gets.
   */
  submitOrderVerification: OrderPayload;
  /**
   * Holds a production entry for a production admin to review, instead of counting it straight away. Takes the
   * same quantity and optional split as overrideProducedQuantity, validated the same way, and a client
   * entryId; sending the same entryId again changes nothing. Allowed only while the business's
   * produceProductionEntryReview setting is on. The entry changes nothing else: not the job's produced
   * quantity or split, not what Post Jobs pre-fills, and no stock.
   */
  submitProducedQuantityForReview: ProductionLotPayload;
  /**
   * Submits a Draft session. The optional submissionNotes (internal staff notes, at most 512
   * characters; blank means none) and pullDate (a calendar day, separate from the saved shipDate) are
   * captured with the Submitted status in one event, so a refused Submit saves neither. Nonblank notes
   * from a caller who is not internal staff are refused with
   * RESTOCK_SESSION_SUBMISSION_NOTES_NOT_AUTHORIZED before anything is written. After a lost response,
   * read the same session: Submitted with the sent values means this Submit or another one landed;
   * nothing is replayed automatically.
   */
  submitRestockSession: RestockSessionPayload;
  submitVerifyContainer: VerifyContainerPayload;
  /**
   * Substitutes a catalog in each lot: every job on it takes the new catalog and that catalog's recipe for its pot,
   * while the lot keeps its number, plan, quantity, ready week, customer, group and location. Each lot is its own
   * write; a refused lot writes nothing, says why, and never stops the others.
   */
  substituteProductionLotCatalog: ProductionLotSubstitutionPayload;
  /** Switches one unposted lot to another variant of its plant and reapplies that variant's recipe: a one-lot catalog substitution limited to the same genus and series. */
  swapProductionLotVariant: ProductionLotPayload;
  synchronizeErpItemPrices: ErpItemPricingPayload;
  synchronizeRestockSession: RestockSessionPayload;
  synchronizeSalesPeople: Array<CustomerPayload>;
  /**
   * Takes allocation at one inventory key from other orders' lines and gives it to one line of this order, in one
   * write: each source line drops by what is taken from it, the receiving line rises by the total, and the key's
   * reserved total stays where it was.
   */
  takeLineItemAllocations: OrderPayload;
  /**
   * Switches a customer upgrade's Default flag. Default off keeps the upgrade but does not attach it to new
   * order lines.
   */
  toggleCustomerUpgradeDefault: CustomerPayload;
  /** Toggles an upgrade's IsDefault flag, enforcing the exclusive-category single-default invariant. */
  toggleItemUpgradeDefault: ItemPayload;
  toggleSftpDestination: SftpTenantConfigPayload;
  toggleSftpMongoDestination: SftpTenantConfigPayload;
  /**
   * Transfers inventory from one item's key to ANOTHER ITEM's key — the "size-up / reclassify" move a
   * field-grown / container-tree grower performs at annual grade-out (Live Oak 1" cal → 2" cal), where
   * FULFILL best practice is one item per species × size band. toLocationId and toGrade
   * default to the source key's, so a same-shelf reclassify sends neither.
   */
  transferInventoryItem: InventoryItemTransferPayload;
  /**
   * Unassign an open assignment's worker (Round 8 finding). The caller's userId becomes
   * ReassignedBy. Rejected once the assignment is Completed or Cancelled;
   * unassigning an already-unassigned assignment is an idempotent no-op.
   */
  unassignCountAssignment: CycleCountAssignmentPayload;
  unassignMaterialItemToVendor: MaterialItemPayload;
  /** Clear the assignee on a task assignment. Refused for a completed or cancelled task. */
  unassignTask: TaskAssignmentPayload;
  /** Puts a deleted characteristic back in the list with its values intact. Undeleting an active characteristic changes nothing. */
  undeleteItemCharacteristic: ItemCharacteristicPayload;
  /** Puts a deleted value back in the pick list. Undeleting an active value changes nothing. */
  undeleteItemCharacteristicValue: ItemCharacteristicPayload;
  /**
   * Restores a Deleted material item to Inactive. The operator re-activates it explicitly via
   * activateMaterialItem — undelete does not itself make the item usable again.
   */
  undeleteMaterialItem: MaterialItemPayload;
  /**
   * Restores a deleted production catalog entry as INACTIVE. Refused when another catalog entry now has the
   * same genus, series and color.
   */
  undeleteProductionCatalog: ProductionCatalogPayload;
  /** Puts a deleted tag color back in the list. Undeleting an active color changes nothing. */
  undeleteTagColor: TagColorPayload;
  /** Restores a Deleted vendor. It comes back Inactive. */
  undeleteVendor: VendorPayload;
  undoConsolidationApplication: ConsolidationApplicationPayload;
  /** Correction: undoes a delivery completion (Delivered -> Dispatched). */
  undoDeliveryCompletion: DeliveryPayload;
  undoFernieGapFill: UndoFernieGapFillPayload;
  /**
   * Correction: undoes a dispatch (Dispatched -> Loaded). Refused with ORDER_INVOICED when it
   *             would write to an order with a live invoice. Void the invoice first. A refusal leaves the whole load unchanged.
   */
  undoLoadDispatch: DeliveryPayload;
  undoRestockSessionOrderQuantityOverride: RestockSessionPayload;
  /**
   * Removes one entry from the CALLING user's ignored missing-data warnings, matched on both
   * code and subjectId, so the warning shows for them again. Resolves the caller from the
   * JWT like ignoreMissingData. Unignoring an entry that is not ignored writes nothing and
   * returns the user.
   */
  unignoreMissingData: UserPayload;
  /**
   * Removes the user's FusionAuth login link. The directory entry remains. Admin/SuperAdmin gated:
   * unlink is the first half of the unlink-then-relink escalation, since an entry with no link is
   * exactly what linkFusionAuthUser will accept a new subject for.
   */
  unlinkFusionAuthUser: UserPayload;
  /** Unlinks one or more production items from their sales items. */
  unlinkProductionItemsFromSalesItem: LinkProductionItemsToSalesItemPayload;
  /** W3. FLAG. Removes the bill's PO link. The worker will not auto-link that bill again. Not linked: ENTITY_NO_CHANGES. */
  unlinkRampBillFromPurchaseOrder: RampBillLinkPayload;
  /** W2. FLAG. Removes the vendor's Ramp link. Codes: RAMP_NOT_ENABLED. */
  unlinkVendorFromRampVendor: VendorPayload;
  /** Releases a run back to normal retention, clearing every pin field. */
  unpinQaTestRun: QaTestRunPayload;
  unsetDefaultGroup: PriceGroupPayload;
  unsetDefaultTerms: TermsPayload;
  /**
   * Unsets the tenant's delivery-schedule mapping for one route (any casing). Not idempotent:
   * unsetting a route that has no mapping (never set, or already unset) is a no-op that returns
   * an EntityCommandHasNoChangesError in `errors` with a null `routeDeliveryScheduleConfig`,
   * rather than succeeding silently — and never creates the tenant's config stream. Mirrors
   * setRouteDeliverySchedule.
   */
  unsetRouteDeliverySchedule: RouteDeliveryScheduleConfigPayload;
  /**
   * Removes the grant one person (by email) or the whole company (no email) holds on a saved view. Removing a
   * grant the view does not have writes nothing. Only the owner or a company admin may unshare (myRights.share);
   * anyone else is refused with REPORT_RIGHT_DENIED, and an open report with REPORT_OPEN_ACCESS.
   *
   * Unlike shareReport, this works while the company's SavedViews flag is off: removing a grant only narrows
   * access, and the grants a view was given while the flag was on are still enforced after it is turned off.
   */
  unshareReport: ReportPayload;
  /**
   * Takes a Shipped order back to Picked. The stock the ship took goes back on hand at the location and
   * grade it left from, the allocations the ship released come back at the quantities that shipped, the
   * shipped quantities are cleared, and the order's discounts and totals are restated on the picked basis.
   * The reason is required and shows in the order history with who unshipped the order and when. Admin
   * staff only. Refused, with guidance to issue a credit, when the order has a live invoice (a voided
   * invoice does not count), when the order or any of its invoices was exported to accounting, when it was
   * synchronized to the ERP or imported from the accounting system, when it is a scheduled order whose ship
   * rolled up into its master order, when it is on a dispatched delivery load, or when it is Closed,
   * Synchronized, SyncError, InTransit, Delivered, FailedDelivery, Cancelled or Deleted. Also refused when
   * the order shipped hard goods, when stock at a location it shipped from was counted, adjusted or moved
   * by hand after the ship, and when the inventory ledger cannot confirm what the ship took. Sent again for
   * an order it already unshipped, it finishes restating the money and changes nothing else.
   */
  unshipOrder: OrderPayload;
  /** Anonymous, rate limited. Unsubscribes the address the token names. */
  unsubscribeWhatsNewEmail: UnsubscribeWhatsNewEmailPayload;
  updateAcknowledgedQuantity: OrderPayload;
  updateAcknowledgmentEmail: OrderPayload;
  /**
   * Replaces the name and primary contact. Both are always supplied in full. Resubmitting identical
   * values writes no event.
   */
  updateAdminParentCompany: AdminParentCompanyPayload;
  /**
   * Cross-tenant admin mutation to turn a tenant's online invoice payments on or off. Off by default for every
   * tenant: while it is off no invoice email or PDF carries a pay link, no pay link can be issued, and every
   * pay-link lookup reports online payment as unavailable. Turn it on only in an environment where every
   * click-to-pay slice, settlement included, has been released; then run
   * backfillAdminTenantInvoicePayLinks to link the tenant's open invoices.
   */
  updateAdminTenantOnlineInvoicePaymentsEnabled: AdminTenantPayload;
  /**
   * Cross-tenant admin mutation to flip a tenant's OrganicReceiveMode. Used by
   * the wsapi admin console once a tenant's organic-lot populate-rate meets the
   * rollout threshold (e.g. Bonnie flips to Block after 60%).
   */
  updateAdminTenantOrganicReceiveMode: AdminTenantPayload;
  /**
   * Cross-tenant admin mutation to set the per-tenant Restock IRosProvider selection
   * (key + opaque per-provider JSON). Snapshotted into LockedRestockConfig at each
   * future session creation; in-flight sessions are not affected. Validates the provider key
   * against the keyed-DI registration before dispatching the command.
   */
  updateAdminTenantRestockProviderSettings: AdminTenantPayload;
  /**
   * Renames a product, replaces its flags, or both. Re-sending the name or the flag set it already has
   * writes nothing. A rename writes only the product: every tenant that has it reads the new name in its
   * Contracted Products, because that text is derived from the tenant's products when it is read.
   */
  updateAdminWorkSuiteProduct: AdminWorkSuiteProductPayload;
  updateAllocationTemplate: AllocationTemplatePayload;
  updateAndGetNextOrderNumber: NextOrderNumberPayload;
  updateAsyncImportJobStatus: AsyncImportJobPayload;
  updateBillingAddress: CustomerPayload;
  updateBlockingRule: BlockingRulePayload;
  /**
   * Updates the tenant-level business time zone (decision D's zone source) — the ONE calendar a
   * tenant's local-time, inclusive order-cutoff qualification conditions
   * (PriceGroupQualificationConditions.Qualifies) resolve against. Must be a recognized
   * IANA id (e.g. America/Denver); an unrecognized or unparseable id is rejected. No
   * SuperAdmin requirement — same tenant-scoped shape as updatePricingCalcDecimals.
   * Deliberately no "clear" — this only ever sets or replaces the configured zone. Consuming the
   * zone (and what happens when a configured qualification condition needs it but no zone was
   * ever set) is a separate concern from this mutation.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateBusinessTimeZone: TenantPayload;
  updateCategory: CategoryPayload;
  /**
   * Updates a Shipping UOM. eachesPerUnit is REQUIRED and must be at least 1 despite its
   * nullable Int type on the input: omitting it returns a RequiredField error naming
   * EachesPerUnit. This is NOT the behaviour of code, which sits beside it on
   * UpdateConfigCategoryInput, is also nullable, and IS genuinely PATCH — an omitted
   * code leaves the stored code untouched, an omitted eachesPerUnit is rejected.
   * Nothing in the shape of the two fields distinguishes them, which is why it is said here.
   * Requiring the count is what stops a pre-cutover Shipping UOM being renamed and re-saved while
   * still holding no count of its own, so the first edit of such a row is also the edit that gives
   * it a real count — including when the count submitted is 1.
   */
  updateConfigCategory: ConfigCategoryPayload;
  updateConfirmationEmail: OrderPayload;
  updateContact: CustomerPayload;
  updateContainerConfigDetails: ContainerConfigPayload;
  updateCustomer: CustomerPayload;
  updateCustomerGroup: CustomerGroupPayload;
  /** Saves a customer group's Hold production preference using the same staff authorization as group edits. The stored preference defaults to false. */
  updateCustomerGroupHoldProduction: CustomerGroupPayload;
  updateCustomerItem: CustomerItemPayload;
  updateCustomerItemAdditionalSkus: CustomerItemPayload;
  updateCustomerItemAdditionalUpcs: CustomerItemPayload;
  updateCustomerLocationOrderAddressEditPermissions: CustomerPayload;
  /**
   * Sets or clears a specific customer location's send-invoice-emails override.
   * Pass sendInvoiceEmails: null to clear the override (inherit from customer).
   * Mirrors updateCustomerLocationSendOrderEmails.
   */
  updateCustomerLocationSendInvoiceEmails: CustomerPayload;
  /**
   * Sets or clears a specific customer location's send-order-emails override.
   * Pass sendOrderEmails: null to clear the override (inherit from customer).
   */
  updateCustomerLocationSendOrderEmails: CustomerPayload;
  updateCustomerOrderAddressEditPermissions: CustomerPayload;
  /**
   * Toggles the customer-level master flag controlling invoice-issue emails.
   * The cascade order ?? location ?? customer at read time decides whether
   * emails actually send for any given invoice, resolved through the invoice's order.
   * Mirrors updateCustomerSendOrderEmails.
   */
  updateCustomerSendInvoiceEmails: CustomerPayload;
  /**
   * Toggles the customer-level master flag controlling order confirmation emails.
   * The cascade order ?? location ?? customer at read time decides whether
   * emails actually send for any given order.
   */
  updateCustomerSendOrderEmails: CustomerPayload;
  updateCustomerType: CustomerTypePayload;
  /**
   * Replaces a customer upgrade's definition in full. Default and Status are kept; switch Default with
   * toggleCustomerUpgradeDefault. Refused when the new name matches another active upgrade of this
   * customer at the same scope.
   */
  updateCustomerUpgrade: CustomerPayload;
  /**
   * Updates the tenant-level default freight charge configuration.
   * Used as the third-tier fallback when no customer or location freight is configured.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateDefaultFreightCharge: TenantPayload;
  /**
   * Sets or clears the tenant default minimum freight charge, applied once per order. A customer
   * override set through updateCustomer wins over it. The value must be non-negative with
   * at most two decimal places.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateDefaultMinimumFreightCharge: TenantPayload;
  updateDefaultOrderSubmitter: CustomerPayload;
  /**
   * Updates the per-tenant default weeks-of-supply applied by the Restock dashboard's
   * restockDailyDemand query when no explicit override is supplied. Must be
   * between 0.01 and 100 inclusive.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateDefaultWeeksOfSupply: TenantPayload;
  updateDeliveryScheduleLocations: DeliverySchedulePayload;
  /**
   * Sets the render mode for one order document type (invoice/confirmation, acknowledgement,
   * credit) for the current tenant. Legacy keeps the QuestPDF generator, ReportEngine
   * renders via the report engine + tenant binding, and Parallel renders both for artifact
   * comparison (only one is sent). Any unset (tenant, docType) pair defaults to Legacy, so
   * enabling this never silently changes current behavior. Authorized identically to the
   * report-binding mutations (current-tenant scoped).
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateDocumentRenderMode: TenantPayload;
  updateErpId: OrderPayload;
  updateErpLoadListQuantities: ErpLoadListSessionPayload;
  updateErpLoadListSessionItemAvailability: ErpLoadListSessionPayload;
  updateErpLoadListSessionName: ErpLoadListSessionPayload;
  updateErpLoadListSessionRoutes: ErpLoadListSessionPayload;
  updateErpLoadListSessionShipDate: ErpLoadListSessionPayload;
  updateErpManagerEmails: ErpManagerEmailsPayload;
  /**
   * Turns fernie's suggestions on or off for the whole company. Saving the value the tenant already has
   * writes nothing and answers with a no-changes error, as updateTrackShipmentWeight does.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateFernieSuggestionsOn: TenantPayload;
  /** Requires the caller's tenant Admin directory role or platform SuperAdmin. */
  updateFinalCreditEnabled: TenantPayload;
  /**
   * Replaces an entry's name, taxable default and account; a null account clears it. Orders that already
   * carry a charge from the entry keep the name they copied.
   */
  updateFlatChargeType: FlatChargeTypePayload;
  /**
   * Updates a forecast's header (name, description, programs, Monday-snapped window, weekly metric,
   * scenario slot). LockedConfig, customer, and level are fixed at creation. Rejected if the
   * forecast is soft-deleted or the new name collides with another active forecast.
   */
  updateForecast: ForecastPayload;
  updateImportRowImportResults: AsyncImportJobPayload;
  updateImportRowValidationResults: AsyncImportJobPayload;
  /**
   * Turns the reply to the person who forwarded a document on or off. Sending the current value again changes
   * nothing and answers ENTITY_NO_CHANGES. INTAKE_ADDRESS_REQUIRED before the address is created.
   */
  updateInboundDocumentSettings: InboundIntakeSettingsPayload;
  /**
   * Sets the tenant's invoicing mode (Manual / Automatic on Shipped, Ruling R7) and whether the
   * invoice email goes out when each invoice is issued, in either mode.
   * UNKNOWN is refused. Authorized identically to updateDocumentRenderMode
   * (current-tenant scoped).
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateInvoicingSettings: TenantPayload;
  /**
   * Updates an item's core fields and attributes. This is a full-replace mutation: any field
   * omitted from input resets to its default or clears the existing value — it does not
   * preserve what was previously set. Commissionable, Discountable, and Royalty are the only
   * exceptions and are preserved when omitted (Royalty can then only be cleared via
   * removeItemRoyalty). Callers that need to change a subset of fields without
   * resending the rest should use patchItem, which genuinely preserves every omitted
   * field.
   */
  updateItem: ItemPayload;
  /**
   * Updates an item's attributes. This is a full-replace mutation: any field omitted from
   * input resets to its default or clears the existing value (for example, omitting
   * substitution or minShipQty clears them) — it does not preserve what was
   * previously set. Commissionable, Discountable, Royalty and StripeTaxCode are the only exceptions and
   * are preserved when omitted (Royalty can then only be cleared via removeItemRoyalty; an empty
   * stripeTaxCode clears the code).
   * Callers that need to change a subset of fields without resending the rest should use
   * patchItem, which genuinely preserves every omitted field.
   */
  updateItemAttributes: ItemPayload;
  /** Changes a characteristic's name, sort order or on-hold flag. Send the values you last read as expected to refuse the change if someone else changed it first. A deleted characteristic must be undeleted before it can change. */
  updateItemCharacteristic: ItemCharacteristicPayload;
  /** Changes a value's name, sort order or on-hold flag. Send the values you last read as expected to refuse the change if someone else changed the value first. A deleted value must be undeleted before it can change. */
  updateItemCharacteristicValue: ItemCharacteristicPayload;
  updateItemImageUrl: ItemPayload;
  updateItemRetailPrice: ItemPayload;
  /** Replaces an existing upgrade definition in full (PUT); IsDefault and Status are preserved. */
  updateItemUpgrade: ItemPayload;
  /**
   * Full-replace update of a kit, including its Sites and its complete line list. Every nested kit
   * must be available at every Site the kit is, and the kit must stay available at every Site of each
   * kit that nests it.
   */
  updateKit: KitPayload;
  updateLineItem: OrderPayload;
  /**
   * Sets or clears an order line's note for a single note context (Ship, Pull or General): a
   * non-empty note text sets that context's note, a null or empty text clears it. One current
   * value per context per line; the resulting typed notes are exposed on lineItem.notes,
   * and the General context stays reflected on the pre-existing lineItem.note field
   * alongside it.
   */
  updateLineItemContextNote: OrderPayload;
  updateLineItemNote: OrderPayload;
  /**
   * Bulk-sets ContainerCode on existing order lines. Handles both the single-line edit
   * and the PWA "Apply to all lines" case (the input simply carries one or many items). The
   * command is idempotent — re-applying the same code on every targeted line is a safe no-op.
   */
  updateLineItemsContainerCode: OrderPayload;
  updateLocation: CustomerPayload;
  /** @deprecated Use SiteLocation mutations instead. */
  updateLocationAddress: LocationPayload;
  /** @deprecated Use SiteLocation mutations instead. */
  updateLocationName: LocationPayload;
  updateMasterAcknowledgedQuantity: MasterOrderPayload;
  updateMasterConfirmationEmail: MasterOrderPayload;
  updateMasterLineItem: MasterOrderPayload;
  updateMasterOrderContact: MasterOrderPayload;
  updateMasterOrderStatus: MasterOrderPayload;
  updateMasterSalesPerson: MasterOrderPayload;
  updateMaterialItemDetails: MaterialItemPayload;
  /**
   * Updates the maximum discount percentage for a tenant.
   * Percent is expressed as a decimal value between 0 and 1.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateMaxDiscountPercentage: TenantPayload;
  updateMissingItemGroups: OrderPayload;
  updateMissingMasterItemGroups: MasterOrderPayload;
  /**
   * Sets the Report aggregate ID rendered as the Orders page acknowledgement PDF for the
   * current tenant. Pass null or empty to clear the binding. Rejects a report id that does not
   * resolve for the tenant (never existed, or has been deleted) or one that has no design saved
   * yet, since either would leave every acknowledgement render failing.
   * BPF retains the hardcoded Bonnie acknowledgement and ignores this setting.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateOrderAcknowledgementReport: TenantPayload;
  /** Requires the caller's tenant Admin directory role or platform SuperAdmin. */
  updateOrderAddressEditPermissions: TenantPayload;
  updateOrderBillingAddress: OrderPayload;
  updateOrderContact: OrderPayload;
  /**
   * Changes an order's expected delivery date by running the existing order edit (editOrder) with only
   * the date changed. The edit validates the date and runs its usual follow-on steps: as when the date is
   * changed on the Orders page, the order returns to Open (Initialized when it has no lines), and an order
   * that was a draft (Open or Initialized) before the change is repriced; a Submitted, Acknowledged or Picked
   * order keeps its line prices. Refused with ORDER_SITE_NOT_ASSIGNED when the caller is assigned to sites and
   * the order ships from a site outside them.
   */
  updateOrderDeliveryDate: OrderPayload;
  /**
   * Sets the Report aggregate ID rendered as the Orders page invoice PDF for the current tenant.
   * Pass null or empty to clear the binding (hides the View Invoice action). Rejects a report id
   * that does not resolve for the tenant (never existed, or has been deleted) or one that has no
   * design saved yet, since either would leave every invoice render failing.
   * BPF retains the hardcoded Bonnie PDF and ignores this setting.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateOrderInvoiceReport: TenantPayload;
  updateOrderLocationAddress: OrderPayload;
  /**
   * Sets the Report aggregate ID rendered as the Orders page Pro Forma PDF (Documents, View
   * Pro Forma) for the current tenant. Pass null or empty to clear the binding, which falls
   * back to the seeded Pro Forma Invoice system template. Rejects a report id that does not
   * resolve for the tenant (never existed, or has been deleted) or one that has no design saved
   * yet, since either would leave every Pro Forma render failing.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateOrderProFormaReport: TenantPayload;
  /**
   * Sets the Report aggregate ID rendered as the Orders page pull slip PDF ("pick slip" in
   * worksuite-pwa) for the current tenant. Pass null or empty to clear the binding, which
   * falls back to the seeded Pull Slip system template. Rejects a report id that does not
   * resolve for the tenant (never existed, or has been deleted) or one that has no design saved
   * yet, since either would leave every pull slip render failing.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateOrderPullSlipReport: TenantPayload;
  /**
   * Sets or clears an order's route override — tier 1 of the hierarchical route setting
   * (tenant default → customer → ship-to → order, most-specific-wins). Route is a free-text
   * scalar (not a managed aggregate), so there is no existence gate. An empty/blank value clears
   * the override so the effective route inherits down the chain. Mirrors UpdateTermsId).
   */
  updateOrderRoute: OrderPayload;
  /**
   * Sets or clears the per-order send-invoice-emails override.
   * Pass sendInvoiceEmails: null to clear the override (inherit from
   * location/customer). Mirrors updateOrderSendOrderEmails.
   */
  updateOrderSendInvoiceEmails: OrderPayload;
  /**
   * Sets or clears the per-order send-order-emails override.
   * Pass sendOrderEmails: null to clear the override (inherit from
   * location/customer). Useful for historical-import flows that should not
   * trigger confirmation emails.
   */
  updateOrderSendOrderEmails: OrderPayload;
  updateOrderStatus: OrderPayload;
  updateOrderSyncAttempt: OrderPayload;
  /**
   * Sets the per-tenant policy for missing OrganicLotCode on an organic VPO receive item.
   * Warn surfaces a warning (allow submit). Block rejects the receive with a
   * ValidationError.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateOrganicReceiveMode: TenantPayload;
  /** Renames a processor and/or changes its online-payment ceiling (PUT — both fields replaced). */
  updatePaymentProcessor: PaymentProcessorPayload;
  /**
   * Updates the tenant-configured maximum length for sales-order and master-order PO numbers
   * (initializeOrder, submitFullOrder, and master-order create/edit). Must be between
   * 1 and 64 inclusive — it can only tighten below the absolute PO-number ceiling of 64 (purchase
   * orders and production lots always validate against that ceiling and are unaffected). Default 64
   * preserves today's behavior for every tenant that has not configured this.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updatePoNumberMaxLength: TenantPayload;
  /**
   * Upserts the calling tenant's portal settings (full-replace). Staff-only: a
   * customer-type portal JWT is rejected with a PORTAL_SETTINGS_STAFF_ONLY error
   * and no event is written. Tenant-scoped — settings are written to the caller's own
   * tenant stream, so one tenant cannot write another's settings. Same-value
   * re-submissions are a no-op (no phantom event).
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   *
   * The company slug is LOCKED against tenant-initiated changes, ALWAYS — including the very
   * FIRST save: an explicit companySlug that differs from the currently stored value
   * (empty or not) is rejected outright (CompanySlugLocked, no event) for an ordinary
   * tenant caller. Omitting the field, or resubmitting the CURRENT value, is unaffected. An
   * omitted slug reuses the tenant's existing one, or — on the first save with none — is
   * assigned a collision-safe default derived from the tenant's own code. The current slug is
   * read from the KurrentDB stream (no projection lag), so both the lock check and the reuse
   * decision are authoritative even if the slug projection is still catching up. The ONLY way to
   * choose or change a slug is the SuperAdmin-gated setAdminPortalCompanySlug override
   * (PortalSettingsAdminMutation.SetAdminPortalCompanySlug).
   *
   *
   * showGradeOnPortal is resolved against stored state rather than collapsing to
   * false: an omitted flag KEEPS the tenant's current value, and only an explicit
   * false turns grade display off. availabilitySource is merged the same way
   * (omitted keeps the stored value); it is a retired tombstone that no availability read
   * consults, accepted only so existing callers keep working. Its siblings includeSellableHardGoods and
   * preferAvailabilityImage still reset to false when omitted.
   * deliveryBlackouts is merged the same way, and because omission now means "keep", an
   * explicitly EMPTY list — [], not an omitted field and not null — is the only way
   * a client reopens every closed date. prePricingEnabled follows the same merge rule: an
   * omitted flag keeps the tenant's current value, so a settings save from a client build that
   * predates the field never resets pre-pricing to off. availabilityMinGrade is merged the
   * same way: an omitted floor keeps the tenant's current value (1 on a tenant that never saved
   * settings) rather than falling back to 2. portalAutoAcknowledge,
   * portalAutoAllocate and portalAutoAllocateStrategy follow the same rule. The
   * strategy accepts HIGHEST_GRADE, FIFO, LIFO and BALANCED;
   * SINGLE_LOCATION and PRIORITY are refused. buyerContactEditingEnabled
   * follows the same rule: an omitted flag keeps the tenant's current value, so a client build that
   * predates the field never switches buyer contact editing off.
   * portalCheckoutOrderStatus (OPEN or SUBMITTED) follows the same rule: an
   * omitted field keeps the tenant's current value, and a tenant that never saved one reads
   * OPEN.
   * priceLabels is merged like deliveryBlackouts: an omitted list keeps the stored
   * labels and [] clears them.
   * catalogChipSource (CATEGORY or ITEM_GROUP) follows the
   * prePricingEnabled rule: an omitted field keeps the tenant's current value, and a tenant
   * that never saved one reads CATEGORY.
   * buyerRetailPriceEditingEnabled follows the same rule: an omitted flag keeps the tenant's
   * current value, and a tenant that never saved one reads false. Buyers can save retail
   * prices only while the portal, prePricingEnabled and this flag are all on.
   */
  updatePortalSettings: PortalSettingsPayload;
  updatePriceGroup: PriceGroupPayload;
  updatePriceLevels: PriceGroupPayload;
  /**
   * Updates the tenant-level number of decimals used when ROUNDING PRICE CALCULATIONS —
   * MongoPricingService.ApplyPercentOff's whole-group derivation and PercentOff-kind price
   * level arithmetic. Must be between 2 and 20 inclusive. Default 2 preserves today's cent-rounded
   * behavior for every tenant that has not configured this. Display (order documents, PWA price
   * rendering) is a separate concern and is NOT affected by this setting — it always rounds to
   * cents.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updatePricingCalcDecimals: TenantPayload;
  /** Sets whether matching item numbers are linked automatically; defaults on. */
  updateProduceAutoLinkMatchingNumbers: TenantPayload;
  /**
   * Sets the tenant-level default relief percentage pre-filled onto new capacity windows (each
   * window remains individually editable). Must be between 0 and 100 inclusive. Defaults to 0
   * for a tenant that has never configured this. Resubmitting the value already stored returns an
   * EntityCommandHasNoChanges error and emits no event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateProduceDefaultReliefPercent: TenantPayload;
  /**
   * Turns Make to Order (Produce) on or off for the tenant.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateProduceEnabled: TenantPayload;
  /**
   * Sets the tenant-level policy for who can create a production plan from an order. ANYONE is
   * today's behaviour and the value a tenant that has never configured this reads as. With
   * PRODUCTION_STAFF, createMakeToOrderPlan refuses a caller without the Production or Admin
   * role (or an admin, superadmin or produce-admin login). Resubmitting the value already stored returns an
   * EntityCommandHasNoChanges error and emits no event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateProducePlanFromOrderAccess: TenantPayload;
  /**
   * Sets the tenant-level default unit a user types on the production schedule —
   * containers/trays or eaches; the other unit is derived. CONTAINERS is today's
   * behaviour and the value a tenant that has never configured this reads as. Resubmitting the
   * value already stored returns an EntityCommandHasNoChanges error and emits no event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateProducePlanningEntryUnit: TenantPayload;
  /**
   * Turns the review of floor production entries on or off. With it on, a production entry made by someone
   * without production-admin rights is held (submitProducedQuantityForReview) until a production admin
   * confirms or rejects it. Off is today's behaviour and the value a tenant that has never configured this
   * reads as. Resubmitting the value already stored returns an EntityCommandHasNoChanges error and
   * emits no event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateProduceProductionEntryReview: TenantPayload;
  /**
   * Sets how many decimals PRODUCE quantities display with, from 0 to 4 inclusive. Defaults to 2 for a
   * tenant that has never configured this. Display only: stored quantities keep full precision.
   * Resubmitting the value already stored returns an EntityCommandHasNoChanges error and emits
   * no event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateProduceQuantityDecimals: TenantPayload;
  /**
   * Sets the tenant-level produced-quantity rounding policy for the production schedule.
   * ROUND_UP is today's behaviour and the value a tenant that has never configured this
   * reads as. Space-plan consumption always rounds up to whole containers regardless of this
   * setting. Resubmitting the value already stored returns an EntityCommandHasNoChanges
   * error and emits no event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateProduceRounding: TenantPayload;
  /**
   * Sets the tenant-level basis the space plan consumes against available capacity —
   * yield-adjusted quantity to produce, or requested quantity. PRODUCE_QUANTITY is
   * today's behaviour and the value a tenant that has never configured this reads as. This
   * setting only stores the value — the space-plan consumer reads it separately. Resubmitting
   * the value already stored returns an EntityCommandHasNoChanges error and emits no
   * event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateProduceSpaceConsumptionBasis: TenantPayload;
  /**
   * Sets the tenant-level unit of measure for space-planning footprint dimensions. INCHES
   * is today's behaviour and the value a tenant that has never configured this reads as. This
   * setting only stores the value — the area-math consumer reads it separately. Resubmitting the
   * value already stored returns an EntityCommandHasNoChanges error and emits no event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateProduceSpacingDimensionUnit: TenantPayload;
  /**
   * Sets the tenant-level display-only preference for which date a production week renders as.
   * MONDAY (ISO) is today's behaviour and the value a tenant that has never configured
   * this reads as. Week numbers stay ISO-8601 regardless of this setting. Resubmitting the value
   * already stored returns an EntityCommandHasNoChanges error and emits no event.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateProduceWeekDisplayAnchor: TenantPayload;
  /** Updates an existing production catalog entry. */
  updateProductionCatalog: ProductionCatalogPayload;
  updateProductionCategoryDetails: ProductionCategoryPayload;
  updateProductionItem: ProductionItemPayload;
  updateProductionJobLocation: UpdateProductionJobLocationPayload;
  updateProductionLine: ProductionLinePayload;
  updateProductionLotAsyncImportJobRows: AsyncImportJobPayload;
  updateProductionLotCustomer: UpdateProductionLotCustomerPayload;
  updateProductionLotPlan: UpdateProductionLotPlanPayload;
  updateProductionMaterialEvent: ProductionMaterialEventPayload;
  updateProductionMaterialEventDetail: ProductionMaterialEventPayload;
  updateProductionPlanDetails: ProductionPlanPayload;
  updateProductionRecipeVariation: ProductionRecipePayload;
  /**
   * Changes only the variation fields sent, each with the value the caller saw, and returns the variation
   * as it is saved.
   */
  updateProductionRecipeVariationFields: ProductionRecipeVariationFieldsResult;
  updateProductionSpaceCategoryDetails: ProductionSpaceCategoryPayload;
  updateProductionSpaceEvent: ProductionSpaceEventPayload;
  updateProductionSpaceEventDetail: ProductionSpaceEventPayload;
  updateProductionSpaceTypeDetails: ProductionSpaceTypePayload;
  updateProductionTaskEvent: ProductionTaskEventPayload;
  /** Updates the default assignee for a task event already attached to a production item. */
  updateProductionTaskEventAssignee: ProductionItemPayload;
  /**
   * PUT semantics: this mutation fully replaces the targeted detail's mutable
   * fields with the supplied payload. All scalars on
   * ProductionTaskEventCommands.UpdateProductionTaskEventDetailData
   * are required; callers must supply the current values for any field they wish
   * to leave unchanged (no PATCH/merge semantics).
   */
  updateProductionTaskEventDetail: ProductionTaskEventPayload;
  updateProductionTrigger: ProductionTriggerPayload;
  updatePromotionRule: PromotionRulePayload;
  updatePublicScore: UpdatePublicScoreResult;
  /**
   * Sets the Report aggregate ID rendered as the Purchase Order PDF for the current tenant. Pass null or empty to clear the binding, which falls
   * back to the seeded Purchase Order system template. Rejects a report id that does not
   * resolve for the tenant (never existed, or has been deleted) or one that has no design saved
   * yet, since either would leave every Purchase Order render failing.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updatePurchaseOrderReport: TenantPayload;
  /**
   * Full replace of a report's content. Every content field is written from the input, so a
   * caller must send the report's current values for any field it does not intend to change.
   * App tags are not part of this mutation and are never altered by it — use setReportAppTags.
   *
   * The one exception is spreadsheetColumns: omitted or null keeps the stored columns, so an
   * edit that does not send them (rename, star, move to folder) never clears them. Any other
   * value replaces them, and "[]" clears them. Invalid columns are refused with
   * INVALID_SPREADSHEET_COLUMNS and a message naming the column, and nothing is written.
   *
   * The append is revision-pinned: a concurrent write to the same report between this call's
   * read and its write is rejected rather than silently overwriting the other writer. On that
   * error, re-read the report, reapply the edit, and submit again.
   *
   * Submitting values identical to the report's current content succeeds and writes no event,
   * rather than returning an error.
   *
   * Optionally send expectedVersion, the content version the caller opened (the version runReport
   * takes, the one reportVersions lists first). If the report has been saved or reverted since, the
   * save is refused with code REPORT_VERSION_CONFLICT, nothing is written, and the payload's
   * currentVersion says which version to reopen. Checked before the unchanged-save no-op, so a
   * stale save is refused even when its values equal the current ones. Omit it for the existing
   * behavior. App-tag changes are not content versions and never make a save stale.
   *
   * The payload's currentVersion is the report's content version after the call: the version this save
   * just wrote, the existing version when the save was unchanged, or the report's newer version when the
   * save was refused. Send it as expectedVersion on the next save.
   *
   * A save that races another save can also be refused with the entity-already-exists error instead of
   * REPORT_VERSION_CONFLICT. Treat it as a conflict too: re-read reportVersions and reopen the latest version.
   *
   * A saved view needs the change right (myRights.change): a caller who can only use it is refused with
   * REPORT_RIGHT_DENIED, and one who cannot open it gets the not-found error. Open reports take any caller.
   */
  updateReport: ReportPayload;
  /** Updates an existing report schedule. */
  updateReportSchedule: ReportSchedulePayload;
  /** Updates an existing report template. */
  updateReportTemplate: ReportTemplatePayload;
  updateReserveRule: ReserveRulePayload;
  updateRestockSession: RestockSessionPayload;
  updateRestockSessionOrderQuantities: RestockSessionPayload;
  updateRestockSessionReserveRules: RestockSessionPayload;
  updateSalesPerson: OrderPayload;
  updateSftpAggregationConfig: SftpTenantConfigPayload;
  updateSftpDestination: SftpTenantConfigPayload;
  updateSftpMongoColumnMaps: SftpTenantConfigPayload;
  updateSftpMongoDestination: SftpTenantConfigPayload;
  updateSftpSqlColumnMaps: SftpTenantConfigPayload;
  updateSftpSystemSettings: SftpSystemSettingsPayload;
  updateSftpTenantConfig: SftpTenantConfigPayload;
  updateShippedQuantity: OrderPayload;
  updateSiteLocationAsyncImportJobRows: AsyncImportJobPayload;
  /**
   * Updates a site map's target site and exclude-from-distribution flag. The mapped location and
   * program are fixed at creation. Rejected if the mapping is soft-deleted.
   */
  updateSiteMap: SiteMapPayload;
  updateSizeUom: SizeUomPayload;
  /**
   * Sets the tenant's DEFAULT statement delivery policy — how statements of account reach
   * customers, and whether an account closing the period at exactly zero is billed at all. Every
   * customer without a statementDeliveryMethod override of their own follows this, and
   * keeps following it as it changes. Omit skipZeroBalance to skip settled accounts.
   * UNKNOWN is refused, and so is resubmitting the policy already stored — that comes back
   * as a no-changes error rather than a silent success, and writes no event either way.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateStatementDeliverySettings: TenantPayload;
  /** Saves the current company's customer-item stock preference. Requires staff access and the caller's tenant Admin directory role or platform SuperAdmin. The stored preference defaults to false. */
  updateStockByCustomerItemSettings: TenantPayload;
  /**
   * Updates one sub-location's name, parent, type, ErpId and pick sequence; its status is kept. Refused for
   * a combined sub-location.
   */
  updateSubLocation: SiteLocationPayload;
  /**
   * Changes the cadence and/or amount of a tenant's existing Stripe subscription by swapping its item
   * to the rate-card price for the requested cadence (superadmin), hardened (T24) against three
   * footguns in the naive item-swap.
   *
   * Schedule guard: refuses outright when the subscription is currently managed by a Stripe
   * Subscription Schedule (multi-year phased pricing) — a direct Subscriptions-API item edit can
   * auto-split/overwrite the schedule's phases; that subscription must be edited via the Schedule
   * API instead.
   *
   *
   * Proration: sets proration_behavior from whether the cadence itself is changing —
   * none on a same-cadence re-price (a CPI/step-up bump at the same interval, where proration
   * would wrongly credit/debit the prepaid period), create_prorations (Stripe's default) on a
   * genuine cadence change, where none would instead bill the new amount immediately with no
   * credit for unused time.
   *
   *
   * No-op vs re-price: allows a same-cadence call through when the amount actually changes (so ops
   * can push a CPI bump without an artificial cadence swap) but still rejects a genuine no-op (same
   * cadence, same amount) before any Stripe re-price (a live retrieve always precedes this check, so
   * a no-op still costs one Stripe read). Only on a real cadence change is the terminal
   * SetTenantBillingFrequency sync attempted — it is IfChangedPer with no AllowNoOp, so
   * calling it on the same-cadence path would error AFTER the Stripe re-price already applied.
   *
   * No charge is rejected by amount (T21); the subscription's payment_settings.payment_method_types
   * is re-set from the same ACH-vs-card rule as Checkout against the T28 effective ceiling, so a
   * cadence/CPI change that crosses the ceiling mid-term is enforced immediately.
   */
  updateSubscription: AdminTenantPayload;
  /**
   * Changes a tag color's name, sort order or on-hold flag. Send the values you last read as expected
   * to refuse the change if someone else changed the color first. A deleted color must be undeleted
   * before it can change.
   */
  updateTagColor: TagColorPayload;
  updateTaskEventType: TaskEventTypePayload;
  /**
   * Replaces the grades Bulk Allocate and portal auto-allocate skip for the calling tenant (PUT
   * semantics). Each grade must be 1 to 5 and appear once; an empty list clears the setting so
   * automatic allocation uses every grade again. Hand allocation can still use an excluded grade.
   * On success, tenant.autoAllocateExcludedGrades lists the excluded grades in ascending order.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateTenantAutoAllocateExcludedGrades: TenantPayload;
  /**
   * Replaces the calling tenant's portal branding (PUT): the four text fields plus an optional logo
   * image; an omitted, null, or empty image clears it. On success, tenant.portalBranding
   * reflects the new values; None is only returned for tenants that have never called this
   * mutation — clients should fall back to platform defaults.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateTenantBranding: TenantPayload;
  /**
   * Replaces the calling tenant's company profile (PUT semantics). A null, omitted or blank field clears it; a blank name clears the override so the tenant name shows.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateTenantCompanyProfile: TenantPayload;
  /**
   * Replaces the calling tenant's custom grade labels (PUT semantics). Each entry's grade must be
   * 1–5; labels are trimmed and capped at 50 characters. An entry with an empty label clears that
   * grade's label, and grades omitted from the input are left unset. On success,
   * tenant.gradeLabels reflects the configured set; unset grades are absent (clients fall
   * back to the numeric grade). This is display only — grade values stay int 1–5.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateTenantGradeLabels: TenantPayload;
  /**
   * Sets the tenant-level opt-in master switch for order/confirmation/acknowledgement emails —
   * the settings-driven replacement for the wsapi-services Background Service Config
   * tenant-allowlist. Pass null to clear the setting back to "never configured"; pass
   * true/false to explicitly opt in/out. Read effectiveOrderEmailsEnabled
   * for the resolved value (unset defaults to false). Transitioning into enabled stamps
   * orderEmailsEnabledAt to now, unless the optional enabledAt input is supplied
   * (used by the current-sender backfill to stamp a past sentinel).
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateTenantOrderEmailsEnabled: TenantPayload;
  /**
   * Replaces the calling tenant's sign-in panel (PUT): the grower's marketing copy beside the sign-in
   * form. All five fields are required; an empty string clears one, and all five empty clear the
   * panel. imageUrl and linkUrl must be https. updateTenantBranding never touches
   * the panel. The panel is public: the anonymous branding reads return it. On success,
   * tenant.portalSignInPanel reflects the new values.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateTenantSignInPanel: TenantPayload;
  /**
   * Updates the per-tenant unit configuration for the restock / replenishment pipeline.
   * All six ingest + display unit fields are replaced atomically.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateTenantUnitConfig: TenantPayload;
  updateTerms: TermsPayload;
  updateTermsId: OrderPayload;
  /**
   * Turns shipment weight tracking on or off for the tenant. Off hides weight totals and weight gap
   * warnings in Fulfill and lists no item weight gaps in Missing Data. Saving the value the tenant
   * already has writes nothing and answers with a no-changes error, as updateProduceEnabled does.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateTrackShipmentWeight: TenantPayload;
  /** Requires the caller's tenant Admin directory role or platform SuperAdmin. */
  updateUseErpPricing: TenantPayload;
  updateUserAppSetting: UserAppSettingPayload;
  /**
   * Updates the user's display name. Admin/SuperAdmin gated like the rest of the tenant
   * user-admin surface — this writes to somebody else's directory entry, and there is no
   * self-service rename (the caller's own name comes from their invite/FusionAuth registration).
   */
  updateUserFullName: UserPayload;
  /**
   * Replaces the user's business roles with the given set. An empty set is allowed
   * and removes all roles. A set with the Portal role is refused (CUSTOMER_COMBINED) while the
   * user's customer is combined into another.
   *
   * Gated like the rest of the tenant user-admin surface: the RestockWriter policy (which
   * only excludes portal principals and checks no role whatsoever) plus the in-code
   * RequireTenantAdmin check, satisfied by a platform superadmin JWT or by the caller's own
   * Active directory entry holding the tenant Admin role. Until 2026-08-27 the policy was
   * the only gate here, which meant any staff JWT could call
   * updateUserRoles(userId: <own id>, roles: [Admin]) and become a tenant Admin — the
   * escalation this pairing closes.
   *
   *
   * Editing one's OWN roles is refused outright, for anyone, including a legitimate Admin: role
   * assignment is the mechanism by which authority is granted, so self-assignment is the one shape
   * that can manufacture authority the caller did not already hold. The refusal is enforced in the
   * domain against event-sourced aggregate state (EnsureActiveAndNotSelf), not against the
   * read model, so it holds while the WorkSuiteUsers projection is behind.
   */
  updateUserRoles: UserPayload;
  updateVendor: VendorPayload;
  updateVendorPurchaseOrderMetadata: VendorPurchaseOrderPayload;
  updateVendorPurchaseOrderSiteLocation: VendorPurchaseOrderPayload;
  /**
   * Sets the tenant-level Verify routing preference. Staged (default) routes submitted
   * containers to the supervisor review queue. Direct is owner-operator mode where the
   * worker's "Finished" also fires submitOrderVerification. Presentation routing for
   * worksuite-pwa only — the API enforces roles regardless of mode.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  updateVerifyMode: TenantPayload;
  updateWsapiImportEntityMapping: WsapiImportPayload;
  updateWsapiImportSchedule: WsapiImportPayload;
  /**
   * Uploads a primary portal photo for the item: validates the payload (jpeg/png/webp, <= 5MB),
   * stores the bytes in the single shared public-read "item-images" Azure Blob container under a
   * tenant/item-scoped, content-addressed path ({tenantId}/{itemId}/{contentHash}.{ext}), then
   * applies the returned RELATIVE path via the existing updateItemImageUrl flow — a configured
   * public base URL composes the absolute URL at resolve time. The image bytes never enter the event
   * store — only the resulting path is persisted and projected to the read model.
   */
  uploadItemImage: ItemPayload;
  upsertAdminTenantIntegration: AdminTenantPayload;
  upsertAdminTenantPricingPage: TenantPricingPagePayload;
  /**
   * Bulk add-or-update of 1..100 billing addresses in a single event-store append (the customer CSV
   * import's chunked path, replacing one addBillingAddress/updateBillingAddress call per row). An
   * address matching a stored billing address by id or address fields is updated with blank-preserve
   * semantics; any other address is inserted. Any invalid address fails the whole call with nothing written, and an
   * identical re-send is a no-op success.
   */
  upsertBillingAddresses: CustomerPayload;
  /**
   * Bulk add-or-update of 1..100 contacts in a single event-store append (the customer CSV import's
   * chunked path, replacing one addContact/updateContact call per row). A contact matching a stored
   * contact by id or importId is updated with blank-preserve semantics and keeps the stored id; any
   * other contact is inserted. Any invalid
   * contact fails the whole call with nothing written, and an identical re-send is a no-op success.
   */
  upsertContacts: CustomerPayload;
  /**
   * Adds or updates a customer AND at most one location, one billing address and one contact in a
   * single event-store append — the customer CSV import's one call per row, identical for a new and a
   * stored customer. Create vs update is decided strictly by customerId. Each child updates the
   * stored record it matches by id or natural key and is added otherwise; stored children not passed are
   * untouched, and more children of one kind go through upsertLocations /
   * upsertBillingAddresses / upsertContacts, which match the same way. Blank fields keep
   * the stored value.
   * Any invalid item fails the whole call with nothing written; an identical re-send appends nothing.
   */
  upsertCustomer: UpsertCustomerPayload;
  /**
   * Bulk add-or-update of 1..100 ship-to locations in a single event-store append (the customer CSV
   * import's chunked path, replacing one addLocation call per row). A location matching a stored
   * location by id, code or name is updated with blank-preserve semantics and keeps the stored id; any
   * other location is inserted. Any invalid
   * location fails the whole call with nothing written, and an identical re-send is a no-op success.
   */
  upsertLocations: CustomerPayload;
  /**
   * Creates or updates the Merge.dev CRM integration configuration for the current tenant (Salesforce
   * / HubSpot). Coexists with an accounting Merge integration under a distinct IntegrationId and, like
   * the accounting connect, seeds an enabled RunNow WsapiImport with the default CRM flows so the
   * MergeDevCrmImport worker selects the tenant on its next tick.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  upsertMergeCrmTenantIntegration: TenantPayload;
  /**
   * Creates or updates the Merge.dev integration configuration for the current tenant.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  upsertMergeTenantIntegration: TenantPayload;
  upsertMySqlAdminTenantIntegration: AdminTenantPayload;
  /** Requires the caller's tenant Admin directory role or platform SuperAdmin. */
  upsertMySqlTenantIntegration: TenantPayload;
  /** W3. WORKER ONLY. Upserts cached Ramp bills for the token's tenant (submitted bills only, never drafts). */
  upsertRampBills: UpsertRampBillsPayload;
  /** W2. WORKER ONLY. Upserts cached Ramp vendors for the token's tenant. Never writes to Ramp. */
  upsertRampVendors: UpsertRampVendorsPayload;
  /** Create or update RFID scan records (one per serial/location/date) */
  upsertRfidScans: UpsertRfidScansPayload;
  upsertTenantPricingPage: TenantPricingPagePayload;
  /** Create or update time entries (one per user/task/date) */
  upsertTimeEntries: TimeEntryPayload;
  /**
   * Creates or replaces the policy for one trial kind. PUT semantics — the allow-list and every
   * cap are replaced together, so clearing one entry means resending the full policy without it.
   * Re-sending an unchanged policy writes no event.
   */
  upsertTrialPolicy: AdminTrialPolicyPayload;
  /**
   * Strong-DTO entry point wsapi-services posts against. Validates a batch of
   * CategoryCommands.MergeCategory commands; successes are projected
   * synchronously to the production CategoryDocument shape and
   * written to Category.Staged.Summary in the GrowPointIntegrations
   * Mongo db. The pwa staged-review page queries this collection using the same
   * fragments as the production categories/category queries.
   * Failures partition into ValidateCategoryDocumentsResult.RowErrors
   * keyed by source row index — the batch is never aborted by a row-level failure.
   */
  validateCategoryDocuments: ValidateCategoryDocumentsResult;
  /**
   * Strong-DTO entry point for the GrowPoint customers import: wsapi-services posts a
   * batch of already-shaped CustomerCommands.ImportCustomer (parent +
   * nested locations together). Each is validated via
   * CustomerCommands.ValidImportCustomer.Create; successes are
   * projected synchronously to the production document shapes — one
   * CustomersSummaryDocument and one CustomerLocationDocument
   * per ship-to — and written to the staged collections in the
   * GrowPointIntegrations Mongo db (Customers.Staged.Summary +
   * Customers.Staged.Locations). The pwa staged-review pages query these
   * collections using the same fragments as the production
   * customers/customer/customerLocations queries. Failures
   * partition into ValidateCustomerDocumentsResult.RowErrors keyed
   * by source row index — the batch is never aborted by a row-level failure.
   */
  validateCustomerDocuments: ValidateCustomerDocumentsResult;
  /**
   * Checks the rows importHistoricalInvoices would import, against the tenant and against one another,
   * and reports each refused row's error. It writes nothing.
   */
  validateHistoricalInvoices: ValidateHistoricalInvoicesResult;
  /**
   * Strong-DTO entry point for the GrowPoint historical-orders import: wsapi-services posts a
   * batch of already-shaped ImportHistoricalOrder commands. Each is validated via
   * Clock); successes are projected synchronously to the
   * HistoricalOrderStagedSummaryDocument shape written to
   * HistoricalOrders.Staged.Summary plus one HistoricalOrderStagedLineItemDocument
   * per line written to HistoricalOrders.Staged.Lines in the GrowPointIntegrations
   * Mongo db, where the pwa staged-review grid reads them via the stagedHistoricalOrders /
   * stagedHistoricalOrderLineItems queries. Failures partition into
   * RowErrors keyed by source row index —
   * the batch is never aborted by a row-level failure. Mirrors validateItemsDocuments;
   * no event-store writes occur.
   */
  validateHistoricalOrderDocuments: ValidateHistoricalOrderDocumentsResult;
  validateHistoricalOrders: ValidateHistoricalOrdersResult;
  /**
   * Strong-DTO entry point for the GrowPoint inventory import: wsapi-services posts a
   * batch of already-shaped InventoryCommands.SetInventoryItem rows. Each is
   * validated via InventoryCommands.ValidSetInventoryItem.CreateForSystem — the
   * rule graph the production adjustInventoryItem mutation runs, less its required
   * reason: a staged row may name no reason code, and the import worker replays it with
   * Import (7); a code a row does name must be a known one. Successes are
   * projected synchronously to the production document shape
   * (InventoryItemDocument) plus the 1:1 import-command echo
   * (InventoryItemImportCommandDocument), then written to the staged
   * collections in the GrowPointIntegrations Mongo db
   * (Inventory.Staged.Summary + Inventory.Staged.ImportCommand).
   * ZERO event-store writes — promotion is the existing
   * createInventoryItem/adjustInventoryItem mutations. Failures
   * partition into ValidateInventoryItemDocumentsResult.RowErrors keyed by
   * source row index — the batch is never aborted by a row-level failure.
   */
  validateInventoryItemDocuments: ValidateInventoryItemDocumentsResult;
  /**
   * Strong-DTO entry point for the GrowPoint items import: wsapi-services posts a
   * batch of already-shaped ItemCommands.ImportItem. Each is validated
   * via ItemCommands.ValidImportItem.Create; successes are projected
   * synchronously to the production document shape — one
   * WorkSuite.GraphQl.Features.Products.ItemSummaryDocument — and to the
   * 1:1 import-command echo (WorkSuite.GraphQl.Features.Products.ItemImportCommandDocument),
   * then written to the staged collections in the GrowPointIntegrations Mongo
   * db (Items.Staged.Summary + Items.Staged.ImportCommand). The pwa
   * staged-review pages query these collections using the same fragments as the
   * production items/item queries. Failures partition into
   * ValidateItemsDocumentsResult.RowErrors keyed by source row index —
   * the batch is never aborted by a row-level failure. A row whose Stripe tax code Stripe does not list
   * is one of those failures; the batch's codes are checked against Stripe's catalogue once.
   */
  validateItemsDocuments: ValidateItemsDocumentsResult;
  /**
   * Strong-DTO entry point for the GrowPoint prices import: wsapi-services posts a
   * batch of already-shaped PriceGroupCommands.ImportPriceGroup (group +
   * full level list together). Each is validated via
   * PriceGroupCommands.ValidImportPriceGroup.Create — the exact
   * ValidAddPriceGroup + ValidUpdatePriceLevels rule graph the
   * production addPriceGroup/updatePriceLevels promote path runs;
   * successes are projected synchronously to the production document shapes — one
   * PriceGroupDocument and one PriceLevelDocument per level — plus the
   * 1:1 import-command echo (PriceGroupImportCommandDocument), then written to
   * the staged collections in the GrowPointIntegrations Mongo db
   * (PriceGroups.Staged.Summary + PriceGroups.Staged.Levels +
   * PriceGroups.Staged.ImportCommand). ZERO event-store writes — promotion is
   * the existing addPriceGroup + updatePriceLevels (+
   * setDefaultGroup) mutations. Failures partition into
   * ValidatePriceGroupDocumentsResult.RowErrors keyed by source row index —
   * the batch is never aborted by a row-level failure.
   *
   * Helm 019582ab: before validating, batch-loads the current level set for the group ids in
   * this batch (PriceGroupMutationsExtensions.LoadResolutionBaselineLevelsForGroupsAsync)
   * so a re-validate of an already-known group — the PWA's "Validate Data" resubmit — resolves
   * an omitted trap field (levelType/kind/percentOff/
   * referencePriceGroupId) against what that group actually holds instead of silently
   * downgrading it to the wire-level schema default. A group id with nothing staged and nothing
   * in production (a genuine first-time import) simply has no entries for it in the lookup, so
   * its levels resolve exactly as they did before this fix.
   *
   *
   * Helm 5673692e: that baseline is production AND staging resolved PER LEVEL, not staged-only.
   * Nothing clears a group's staged rows when it is promoted, so a group promoted and then
   * legitimately edited in the production Pricing UI would otherwise keep resolving against
   * staged rows asserting the pre-edit value — silently restoring the value the operator
   * deliberately changed on the very grid they review before promoting. Production therefore
   * wins every tier it can unambiguously match. Staging still covers the tiers production does
   * NOT match — levels synced since the last promote, every level of a group whose promote has
   * not landed, and date ranges a production level only partially overlaps — because dropping
   * those would downgrade them to the schema default, the same corruption from the other
   * direction. See LoadResolutionBaselineLevelsForGroupsAsync for the two halves and the
   * partial-promote reasoning, and PriceLevelReplacementResolver.ResolveMatch for the
   * precedence rule between them.
   */
  validatePriceGroupDocuments: ValidatePriceGroupDocumentsResult;
  validateProductionLot: ValidateProductionLotPayload;
  /**
   * Strong-DTO entry point for the GrowPoint site-locations import: wsapi-services posts
   * a batch of already-shaped SiteLocationCommands.MergeSiteLocation (one per
   * derived greenhouse, sub-locations nested). Each is validated via
   * SiteLocationCommands.ValidMergeSiteLocation.Create — the same parse the
   * production mergeSiteLocation mutation runs; successes are projected
   * synchronously to the production document shapes — one
   * WorkSuite.GraphQl.Features.SiteLocation.SiteLocationDocument and one
   * SubLocationDocument per sub-location — plus the 1:1 import-command echo,
   * then written to the staged collections in the GrowPointIntegrations Mongo db
   * (SiteLocations.Staged.Summary + SiteLocations.Staged.Locations +
   * SiteLocations.Staged.ImportCommand). The pwa staged-review pages query these
   * collections using the same fragments as the production
   * siteLocations/subLocations queries. Failures partition into
   * ValidateSiteLocationsDocumentsResult.RowErrors keyed by source row index —
   * the batch is never aborted by a row-level failure.
   */
  validateSiteLocationsDocuments: ValidateSiteLocationsDocumentsResult;
  /**
   * Re-checks this tenant's bound domain and records the current status. On the created path this
   * polls SendGrid: Verified when SendGrid confirms the CNAME records validate, Pending otherwise. On
   * the grandfather path this confirms the ownership-challenge TXT record (worksuite-domain-verify=
   * + the token) is published at _worksuite.{domain} via the shared DNS resolver: Verified when
   * present, Pending when absent or wrong; a DNS lookup failure fails closed with no status change.
   * A flip to Verified is rejected if another tenant is already Verified on the same domain or SendGrid
   * authentication. Call this after the records exposed by the tenantEmailDomain query
   * (dnsRecords on the created path, challengeTxtHost/challengeTxtRecord on the
   * grandfather path) have been published at the domain's DNS provider.
   */
  validateTenantEmailDomain: TenantEmailDomainPayload;
  /**
   * Strong-DTO entry point for the GrowPoint terms import: wsapi-services posts a
   * batch of already-shaped TermsCommands.ImportTerms. Each is validated via
   * TermsCommands.ValidImportTerms.Create (the SAME validation the production
   * importTerms promotion runs); successes are projected synchronously to the
   * production document shape — one WorkSuite.GraphQl.Features.Terms.TermsDocument —
   * and to the 1:1 import-command echo
   * (WorkSuite.GraphQl.Features.Terms.TermsImportCommandDocument), then written to the
   * staged collections in the GrowPointIntegrations Mongo db
   * (Terms.Staged.Summary + Terms.Staged.ImportCommand). Writes ZERO
   * event-store events — promotion is the separate production importTerms mutation.
   * Failures partition into ValidateTermsDocumentsResult.RowErrors keyed by source
   * row index — the batch is never aborted by a row-level failure.
   */
  validateTermsDocuments: ValidateTermsDocumentsResult;
  /**
   * Proves ownership of a claimed domain from its DNS TXT record and brings it into service. On
   * success the domain serves the tenant's portal and is approved for on-demand TLS issuance.
   * Requires the caller's tenant Admin directory role or platform SuperAdmin.
   */
  verifyPortalCustomDomain: PortalSettingsPayload;
  /**
   * Verifies the tenant's stored SMTP connection with a live connect + AUTH + test message to the
   * supplied recipient. Success marks it verified; a rejected connect / AUTH / send marks it failed with
   * a sanitized, non-secret reason. Both outcomes are a successful mutation returning the new status.
   */
  verifyTenantSmtpConnection: TenantSmtpConnectionPayload;
  /**
   * Voids the installation fee — the only way a fee ends unpaid. Cancelling the contract's
   * enrollment deliberately leaves the fee standing, because a signing fee is owed for work
   * already done. The fee worker voids the Stripe invoice and reports back through
   * confirmContractRecordFeeVoid.
   */
  voidContractRecordFee: ContractRecordPayload;
  /** Withdraws an issued invoice and reverses its sales tax in full at Stripe. */
  voidInvoice: InvoicePayload;
  /**
   * Voids one quote, addressed by price id and the revision the caller reviewed. Terminal: the
   * quote keeps its values, its vendor and its history, and no live read returns it again.
   */
  voidMaterialPrice: MaterialPriceWritePayload;
  /** Forgives the finance charge one issued invoice has run up, as of a date. */
  waiveInvoiceLateCharge: InvoicePayload;
  /**
   * Withdraws a revision that was not approved, for example one the grower declined, so it can never be approved.
   * An approved revision is refused.
   */
  withdrawMigrationSettingsRevision: MigrationSettingsRevisionPayload;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAbortOtaRolloutArgs = {
  input: AbortOtaRolloutInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAcceptGrowerBenchmarkAcceptableUseArgs = {
  input: AcceptGrowerBenchmarkAcceptableUseInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateAdminFeatureFlagArgs = {
  input: ActivateFeatureFlagInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateAdminTenantArgs = {
  input: ActivateTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateCategoryArgs = {
  input: ActivateCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateConfigCategoryArgs = {
  input: ActivateConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateContainerConfigArgs = {
  input: ActivateContainerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateCustomerArgs = {
  input: ActivateCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateCustomerGroupArgs = {
  input: ActivateCustomerGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateCustomerItemArgs = {
  input: ActivateCustomerItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateCustomerTypeArgs = {
  input: ActivateCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateDeliveryScheduleArgs = {
  input: ActivateDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateItemArgs = {
  input: ActivateItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateLocationArgs = {
  input: ActivateLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateMaterialItemArgs = {
  input: ActivateMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivatePaymentProcessorArgs = {
  input: ActivatePaymentProcessorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivatePriceGroupArgs = {
  input: ActivatePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionCategoryArgs = {
  input: ActivateProductionCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionItemArgs = {
  input: ActivateProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionLotArgs = {
  input: ActivateProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionMaterialEventArgs = {
  input: ActivateProductionMaterialEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionMaterialEventDetailArgs = {
  input: ActivateProductionMaterialEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionPlanArgs = {
  input: ActivateProductionPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionRecipeArgs = {
  input: ActivateProductionRecipeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionSpaceCategoryArgs = {
  input: ActivateProductionSpaceCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionSpaceEventArgs = {
  input: ActivateProductionSpaceEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionSpaceEventDetailArgs = {
  input: ActivateProductionSpaceEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionSpaceTypeArgs = {
  input: ActivateProductionSpaceTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionTaskEventArgs = {
  input: ActivateProductionTaskEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionTaskEventDetailArgs = {
  input: ActivateProductionTaskEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateProductionTriggerArgs = {
  input: ActivateProductionTriggerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateSftpTenantConfigArgs = {
  input: ActivateSftpTenantConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateSizeUomArgs = {
  input: ActivateSizeUomInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateTaskEventTypeArgs = {
  input: ActivateTaskEventTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateTermsArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationActivateVendorArgs = {
  input: ActivateVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddAdminParentCompanyArgs = {
  input: AddParentCompanyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddAdminParentCompanyAdministratorArgs = {
  input: AddParentCompanyAdministratorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddAdminTenantArgs = {
  input: AddTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddBayPolesArgs = {
  input: AddBayPolesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddBillingAddressArgs = {
  input: AddBillingAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddBlockingRuleLinkedItemsArgs = {
  input: AddBlockingRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddBlockingRuleLinkedLocationsArgs = {
  input: AddBlockingRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddBpfLotChangeArgs = {
  input: AddBpfLotChangeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddCategoryArgs = {
  input: AddCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddConfigCategoryArgs = {
  input: AddConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddContactArgs = {
  input: AddContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddContainerConfigArgs = {
  input: AddContainerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddContainerConfigForConfigCategoryArgs = {
  input: AddContainerConfigForConfigCategoryDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddContainerConfigToConfigCategoryArgs = {
  input: AddContainerConfigToConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddCustomerGroupArgs = {
  input: AddCustomerGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddCustomerItemArgs = {
  input: AddCustomerItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddCustomerItemsArgs = {
  input: AddCustomerItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddCustomerLocationSettingsNoteArgs = {
  input: AddCustomerLocationSettingsNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddCustomerTypeArgs = {
  input: AddCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddCustomerUpgradeArgs = {
  input: AddCustomerUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddEffectiveMaterialPriceArgs = {
  input: AddEffectiveMaterialPriceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddFlatChargeTypeArgs = {
  input: AddFlatChargeTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddGrowerBenchmarkActivityEntryArgs = {
  input: AddGrowerBenchmarkActivityEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddGrowerBenchmarkCommunityArgs = {
  input: AddGrowerBenchmarkCommunityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddGrowerBenchmarkInstructionSetArgs = {
  communityId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  segment: GrowerBenchmarkCommunitySegment;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddGrowerBenchmarkInstructionSetVersionArgs = {
  content: Scalars['String']['input'];
  effectiveAt: Scalars['DateTime']['input'];
  instructionSetId: Scalars['String']['input'];
  sections: Array<GrowerBenchmarkInstructionSectionInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddInboundAllowedSenderArgs = {
  input: AddInboundAllowedSenderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddInventoryNoteArgs = {
  input: AddInventoryNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddItemArgs = {
  input: AddItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddItemCharacteristicArgs = {
  input: AddItemCharacteristicInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddItemCharacteristicValueArgs = {
  input: AddItemCharacteristicValueInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddItemUpgradeArgs = {
  input: AddItemUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddLineItemsArgs = {
  input: AddLineItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddLineItemsWithPricingArgs = {
  input: AddLineItemsWithPricingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddLocationArgs = {
  input: AddLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddMasterLineItemsArgs = {
  input: AddMasterLineItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddMultipleRetailProductCountArgs = {
  input: Array<AddRetailProductCountInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddOrderFlatChargeArgs = {
  input: AddOrderFlatChargeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddOrderLineUpgradeArgs = {
  input: AddOrderLineUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddPortalCustomDomainArgs = {
  input: AddPortalCustomDomainInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddPriceGroupArgs = {
  input: AddPriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionLotAsyncImportJobRowsArgs = {
  input: AddProductionLotAsyncImportJobRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionMaterialEventDetailsArgs = {
  input: AddProductionMaterialEventDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionMaterialEventToCategoryArgs = {
  input: AddProductionMaterialEventToCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionMaterialEventToJobArgs = {
  input: AddProductionMaterialEventToJobDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionRecipeVariationArgs = {
  input: AddProductionRecipeVariationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionSpaceEventDetailsArgs = {
  input: AddProductionSpaceEventDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionSpaceEventToCategoryArgs = {
  input: AddProductionSpaceEventToCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionSpaceEventToJobArgs = {
  input: AddProductionSpaceEventToJobDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionTaskEventDetailsArgs = {
  input: AddProductionTaskEventDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionTaskEventToCategoryArgs = {
  input: AddProductionTaskEventToCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddProductionTaskEventToItemArgs = {
  input: AddProductionTaskEventToItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddPromotionRuleLinkedItemsArgs = {
  input: AddPromotionRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddPromotionRuleLinkedLocationsArgs = {
  input: AddPromotionRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddPurchaseOrderLineItemArgs = {
  input: AddPurchaseOrderLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddReserveRuleLinkedItemsArgs = {
  input: AddReserveRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddReserveRuleLinkedLocationsArgs = {
  input: AddReserveRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddRetailProductCountArgs = {
  input: AddRetailProductCountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSftpDestinationArgs = {
  input: AddSftpDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSftpMongoDestinationArgs = {
  input: AddSftpMongoDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSftpTenantConfigArgs = {
  input: AddSftpTenantConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddShipFromLocationArgs = {
  input: AddShipFromLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSignatureImageArgs = {
  input: AddSignatureImageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSiteLocationAsyncImportJobRowsArgs = {
  input: AddSiteLocationAsyncImportJobRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSizeUomArgs = {
  input: AddSizeUomInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSizeUomToConfigCategoryArgs = {
  input: AddSizeUomToConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddSubLocationArgs = {
  input: AddSubLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddTagColorArgs = {
  input: AddTagColorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddTaskAssignmentNoteArgs = {
  input: AddNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddTenantEmailDomainArgs = {
  input: AddTenantEmailDomainInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddTenantEmailSenderArgs = {
  input: AddTenantEmailSenderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddTenantUomNameArgs = {
  input: AddTenantUomNameInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddTermsArgs = {
  input: AddTermsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddVendorItemAliasArgs = {
  input: AddVendorItemAliasInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddVendorPurchaseOrderChargeArgs = {
  input: AddVendorPurchaseOrderChargeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAddWsapiImportEntityMappingArgs = {
  input: AddWsapiImportEntityMappingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustCountedQuantityArgs = {
  input: AdjustCountedQuantityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustInventoryItemArgs = {
  input: SetInventoryItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustInvoiceArgs = {
  input: AdjustInvoiceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustMaterialAllocationArgs = {
  input: AdjustAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustMaterialItemArgs = {
  input: AdjustMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustOrderFreightArgs = {
  input: AdjustOrderFreightInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustPostedProductionArgs = {
  input: AdjustPostedProductionDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustPriceLevelsArgs = {
  input: AdjustPriceLevelsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdjustProductionLotAllocationArgs = {
  input: AdjustProductionLotAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminCreateUserInvitesArgs = {
  input: CreateUserInvitesInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDbrCalcForceRecalcByCustomerArgs = {
  input: AdminDbrCalcForceRecalcByCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDbrCalcForceRecalcByItemArgs = {
  input: AdminDbrCalcForceRecalcByItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDbrCalcForceRecalcByLocationArgs = {
  input: AdminDbrCalcForceRecalcByLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDbrCalcForceRecalcByTenantArgs = {
  input: AdminDbrCalcForceRecalcByTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDbrCalcForceRecalcRowArgs = {
  input: AdminDbrCalcForceRecalcRowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDeleteUserInviteArgs = {
  input: DeleteUserInviteInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminDeleteWhatsNewFeatureArgs = {
  input: AdminDeleteWhatsNewFeatureInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRemoveDeviceArgs = {
  input: AdminRemoveDeviceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRepairOrphanedUserArgs = {
  tenantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminResendUserInviteArgs = {
  input: ResendUserInviteInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockCalcForceRecalcByCustomerArgs = {
  input: AdminRestockCalcForceRecalcByCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockCalcForceRecalcByItemArgs = {
  input: AdminRestockCalcForceRecalcByItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockCalcForceRecalcByLocationArgs = {
  input: AdminRestockCalcForceRecalcByLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockCalcForceRecalcByTenantArgs = {
  input: AdminRestockCalcForceRecalcByTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockCalcForceRecalcRowArgs = {
  input: AdminRestockCalcForceRecalcRowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockSeedImportDataArgs = {
  input: AdminRestockSeedImportDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminRestockSeedingKickPipelineArgs = {
  input: AdminRestockSeedingKickPipelineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminSaveWhatsNewFeatureArgs = {
  input: AdminSaveWhatsNewFeatureInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminSetWhatsNewEmailRecipientArgs = {
  input: AdminSetWhatsNewEmailRecipientInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdminSetWhatsNewReleaseEffectiveOnArgs = {
  input: AdminSetWhatsNewReleaseEffectiveOnInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdvanceBackgroundJobArgs = {
  input: AdvanceBackgroundJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdvanceBulkOrderDeleteJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdvanceConsolidationApplicationArgs = {
  input: AdvanceConsolidationApplicationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdvanceCorrectionRunArgs = {
  runId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdvanceFeatureFlagProductConversionJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdvanceMigrationImportRunArgs = {
  input: AdvanceMigrationImportRunInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdvanceMigrationValidationArgs = {
  input: AdvanceMigrationValidationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAdvanceProductionLotAsyncImportJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAllocateLineItemsArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  input: AllocateLineItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAllocateProductionLotToOrderLineArgs = {
  input: AllocateProductionLotToOrderLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAllocateRestockSessionInventoryArgs = {
  input: AllocateCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAmendPurchaseOrderLineItemArgs = {
  input: AmendPurchaseOrderLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAnswerMigrationImportQuestionArgs = {
  input: AnswerMigrationImportQuestionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApplyConsolidationArgs = {
  input: ApplyConsolidationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApplyConsolidationPreviewArgs = {
  input: ApplyConsolidationPreviewInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApplyCreditMemoArgs = {
  input: ApplyCreditMemoInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApplyCustomerCreditArgs = {
  input: ApplyCustomerCreditInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApplyLoadFreightArgs = {
  input: ApplyLoadFreightInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApplySupplierPriceImportArgs = {
  input: ApplySupplierPriceImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApproveCorrectionRunArgs = {
  planRevision: Scalars['Int']['input'];
  runId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApproveGrowerBenchmarkReviewArgs = {
  outputType: GrowerBenchmarkReviewOutputType;
  reviewId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApproveGrowerBenchmarkSubmissionArgs = {
  input: ApproveGrowerBenchmarkSubmissionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApproveMigrationReviewArgs = {
  input: ApproveMigrationReviewInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApproveProductionLotArgs = {
  input: ApproveProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationApprovePurchaseOrderArgs = {
  input: ApprovePurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignDeviceLocationArgs = {
  input: AssignDeviceLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignItemGlAccountsArgs = {
  input: AssignItemGlAccountsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignMaterialItemToVendorArgs = {
  input: AssignMaterialItemToVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignOrderToLoadArgs = {
  input: AssignOrderToLoadInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignReportOwnerArgs = {
  input: AssignReportOwnerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignUserCustomerArgs = {
  input: AssignUserCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignUserCustomersArgs = {
  input: AssignUserCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignUserRoutesArgs = {
  input: AssignUserRoutesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAssignUserSitesArgs = {
  input: AssignUserSitesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAtomicMoveArgs = {
  input: AtomicMoveMovementOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAttachAvailabilitySessionPhotoArgs = {
  input: AttachAvailabilityPhotoInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAttachRestockSessionKitArgs = {
  input: AttachRestockSessionKitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAutoAllocateRestockSessionOrderQuantitiesArgs = {
  input: AutoAllocateRestockSessionOrderQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationAutoLinkRampBillToPurchaseOrderArgs = {
  input: AutoLinkRampBillToPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBackfillAdminTenantInvoicePayLinksArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBackfillAdminTenantStripeCustomerArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBackfillCreditMemosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  dryRun: Scalars['Boolean']['input'];
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBackfillDepositOveragesArgs = {
  dryRun: Scalars['Boolean']['input'];
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBackfillMaterialItemDefaultVendorsArgs = {
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBackfillOrderCreditBackReferencesArgs = {
  dryRun: Scalars['Boolean']['input'];
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBackfillTrialKindsArgs = {
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchActivateCategoriesArgs = {
  input: BatchActivateCategoriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchActivateCustomersArgs = {
  input: BatchActivateCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchActivateItemsArgs = {
  input: BatchActivateItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchActivatePriceGroupsArgs = {
  input: BatchActivatePriceGroupsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchAddCategoriesArgs = {
  input: BatchAddCategoriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchAssignItemStripeTaxCodeArgs = {
  input: BatchAssignItemStripeTaxCodeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchCreateDraftProductionLotsArgs = {
  input: BatchCreateDraftProductionLotsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchDeactivateProductionLotsArgs = {
  input: BatchDeactivateProductionLotsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchDeleteCustomersArgs = {
  input: BatchDeleteCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchDeleteItemsArgs = {
  input: BatchDeleteItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchDeletePriceGroupsArgs = {
  input: BatchDeletePriceGroupsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchDeleteSiteLocationsArgs = {
  input: BatchDeleteSiteLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchImportItemsArgs = {
  input: BatchImportItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchInactivateCategoriesArgs = {
  input: BatchInactivateCategoriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchInactivateCustomersArgs = {
  input: BatchInactivateCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchInactivateItemsArgs = {
  input: BatchInactivateItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchInactivatePriceGroupsArgs = {
  input: BatchInactivatePriceGroupsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchOverrideProductionJobWeeksArgs = {
  input: BatchOverrideProductionJobWeeksInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchOverrideProductionLotQuantitiesArgs = {
  input: BatchOverrideProductionLotQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchRemoveCategoriesArgs = {
  input: BatchRemoveCategoriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchUpdateCategoriesArgs = {
  input: BatchUpdateCategoriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchUpdateCrmExportStatusesArgs = {
  input: BatchUpdateCrmExportStatusesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchUpdateMergeDevExportStatusesArgs = {
  input: BatchUpdateMergeDevExportStatusesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchUpdateProductionRecipeVariationFieldsArgs = {
  input: BatchUpdateProductionRecipeVariationFieldsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBatchUpdateProductionRecipeVariationsArgs = {
  input: BatchUpdateProductionRecipeVariationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBeginGrowerBenchmarkFirmLookupArgs = {
  input: BeginGrowerBenchmarkFirmLookupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBulkAllocateOrdersArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  input: BulkAllocateOrdersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBulkAssignTasksArgs = {
  input: BulkAssignTasksInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationBulkCreateMaterialItemArgs = {
  input: BulkCreateMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCalculateRestockOrderQuantityArgs = {
  input: RestockCalculationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelAssignmentArgs = {
  input: CancelAssignmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelBackgroundJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelBulkOrderDeleteJobArgs = {
  input: CancelBulkOrderDeleteJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelContractRecordEnrollmentArgs = {
  input: CancelContractRecordEnrollmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelCorrectionRunArgs = {
  runId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelCountSessionArgs = {
  input: CancelCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelErpLoadListSessionArgs = {
  input: CancelErpLoadListSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelFeatureFlagProductConversionJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelMarkedScheduleAndReEnrollContractRecordArgs = {
  input: CancelMarkedScheduleAndReEnrollInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelMigrationImportRunArgs = {
  input: MigrationImportRunControlInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelProductionLotAllocationArgs = {
  input: CancelProductionLotAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelPurchaseOrderArgs = {
  input: CancelPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelRestockSessionArgs = {
  input: CancelRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelScheduledInventoryTransferArgs = {
  input: CancelScheduledInventoryTransferInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelScheduledLaborRateArgs = {
  input: CancelScheduledLaborRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelScheduledOverheadRateArgs = {
  input: CancelScheduledOverheadRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelSupplierPriceExtractionArgs = {
  input: SupplierPriceImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelSupplierPriceImportApprovalArgs = {
  input: CancelSupplierPriceImportApprovalInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCancelTaskArgs = {
  input: CancelTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCarryOrderReceiptsToInvoiceArgs = {
  input: CarryOrderReceiptsToInvoiceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangePortalAvailabilityRuleArgs = {
  input: ChangePortalAvailabilityRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangePortalCheckoutMethodArgs = {
  input: ChangePortalCheckoutMethodInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangePortalHelpContactArgs = {
  input: ChangePortalHelpContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeProductionCatalogStatusArgs = {
  input: ChangeProductionCatalogStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeTaskAssignmentDueDateArgs = {
  input: AssignDueDateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeVendorPurchaseOrderItemsArgs = {
  input: ChangeVendorPurchaseOrderItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeVendorPurchaseOrderStatusArgs = {
  input: ChangeVendorPurchaseOrderStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeWorkOrderQuantityProducedArgs = {
  input: ChangeWorkOrderQuantityProducedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationChangeWorkOrderStatusArgs = {
  input: ChangeWorkOrderStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimAvailabilityPhotoGradeRequestsArgs = {
  input: ClaimAvailabilityPhotoGradeRequestsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimContractRecordEnrollmentArgs = {
  input: ClaimContractRecordEnrollmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimContractRecordFeeInvoiceArgs = {
  input: ClaimContractRecordFeeInvoiceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimCustomerDeliveriesArgs = {
  input: ClaimCustomerDeliveriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimDeviceArgs = {
  input: ClaimDeviceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimLoadEmailsArgs = {
  input: ClaimLoadEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimMigrationImportRunArgs = {
  input: ClaimMigrationRecordInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimMigrationPreparationJobArgs = {
  input: ClaimMigrationRecordInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimNotificationDeliveriesArgs = {
  input: ClaimNotificationDeliveriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimOnboardingHelpDeliveriesArgs = {
  input: ClaimOnboardingHelpDeliveriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimPendingErpWriteBacksArgs = {
  input: ClaimPendingErpWriteBacksInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimPostedErpWriteBacksArgs = {
  input: ClaimPostedErpWriteBacksInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimRampPurchaseOrderCopiesArgs = {
  input: ClaimRampPurchaseOrderCopiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClaimWhatsNewEmailBatchesArgs = {
  input: ClaimWhatsNewEmailBatchesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCleanCustomersArgs = {
  input: CleanCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCleanItemsArgs = {
  input: CleanItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearActiveCountSessionArgs = {
  input: ClearActiveCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearAdminFeatureFlagTenantOverrideArgs = {
  input: ClearFeatureFlagTenantOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearCategoryLaborCostArgs = {
  input: ClearCategoryLaborCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearCustomerCommissionOverrideArgs = {
  input: ClearCustomerCommissionOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearCustomerItemShippingConfigCategoryCodeArgs = {
  input: ClearCustomerItemShippingConfigCategoryCodeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearCustomerLocationNoteArgs = {
  input: ClearCustomerLocationNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearCustomerNoteArgs = {
  input: ClearCustomerNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearEmailSuppressionArgs = {
  input: ClearEmailSuppressionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearInventoryNoteArgs = {
  input: ClearInventoryNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearItemContainerConfigOverrideArgs = {
  input: ClearItemContainerConfigOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearItemLaborCostArgs = {
  input: ClearItemLaborCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearItemNoteArgs = {
  input: ClearItemNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearJobGrowWeeksOverrideArgs = {
  input: ClearJobGrowWeeksOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearJobLinksOverrideArgs = {
  input: ClearJobLinksOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearJobPlannedHoursOverrideArgs = {
  input: ClearJobPlannedHoursOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearJobPlantsPerPotOverrideArgs = {
  input: ClearJobPlantsPerPotOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearLoadDockArgs = {
  input: ClearLoadDockInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearLoadMilesArgs = {
  input: ClearLoadMilesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearLoadPickupWindowArgs = {
  input: ClearLoadPickupWindowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearLoadStopPlannedTimeArgs = {
  input: ClearLoadStopPlannedTimeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearOnHandAdjustmentQueueArgs = {
  input: ClearOnHandAdjustmentQueueInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearOrderDropShipDestinationArgs = {
  input: ClearOrderDropShipDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearOrderEmailRecipientRoutingArgs = {
  input: ClearOrderEmailRecipientRoutingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearOrderNoTaxArgs = {
  input: ClearOrderNoTaxInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearOrderNoteArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  input: ClearOrderNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearProductionJobsProgressArgs = {
  input: ClearProductionJobsProgressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearProductionLotCustomerArgs = {
  input: ClearProductionLotCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearProductionLotCustomerGroupArgs = {
  input: ClearProductionLotCustomerGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearProductionTaskEventJobExclusionArgs = {
  input: ClearProductionTaskEventJobExclusionDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearRestockSessionKitCapArgs = {
  input: ClearRestockSessionKitCapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearSpaceCategorySiteOverrideArgs = {
  input: ClearSpaceCategorySiteOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearSpaceDimensionOverrideArgs = {
  input: ClearSpaceDimensionOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearStopOutcomeArgs = {
  input: ClearStopOutcomeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearTaskEventDirectCostArgs = {
  input: ClearTaskEventDirectCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearTaskEventLaborTypeTagArgs = {
  input: ClearTaskEventLaborTypeTagInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearTaskEventThroughputArgs = {
  input: ClearTaskEventThroughputInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearTenantBillingLinkageArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearTenantBillingRateCardArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationClearTenantOnlinePaymentMaxAmountOverrideArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCloseGrowerBenchmarkCycleArgs = {
  input: CloseGrowerBenchmarkCycleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCombineCustomersArgs = {
  input: CombineCustomersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCombineItemsArgs = {
  input: CombineItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCombineProductionCatalogsArgs = {
  input: CombineProductionCatalogsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCombineProductionItemsArgs = {
  input: CombineProductionItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCombineShipTosArgs = {
  input: CombineShipTosInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCombineSubLocationsArgs = {
  input: CombineSubLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCombineTermsArgs = {
  input: CombineTermsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCommitGrowPointStagedRowsArgs = {
  input: CommitGrowPointStagedRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCommitSpaceRebalanceArgs = {
  input: CommitSpaceRebalanceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteAssignmentTaskArgs = {
  input: CompleteAssignmentTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteCountSessionArgs = {
  input: CompleteCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteDeliveryArgs = {
  input: CompleteDeliveryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteDepositExportArgs = {
  input: CompleteDepositExportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteDuplicateCheckRequestArgs = {
  input: CompleteDuplicateCheckRequestInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteM365MailboxConnectArgs = {
  input: CompleteM365MailboxConnectInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteMergeLinkArgs = {
  input: CompleteMergeLinkInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteMyMultiFactorEnrollmentArgs = {
  input: CompleteMyMultiFactorEnrollmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompletePaymentExportArgs = {
  input: CompletePaymentExportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteRampConnectArgs = {
  input: CompleteRampConnectInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteTaskArgs = {
  input: CompleteTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteTenantEmailSenderVerificationArgs = {
  input: CompleteTenantEmailSenderVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteTenantModuleResetArgs = {
  createdFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  createdTo?: InputMaybe<Scalars['LocalDate']['input']>;
  module: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCompleteUserInviteAsSignedInUserArgs = {
  input: CompleteUserInviteAsSignedInUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationComputeLoadMilesArgs = {
  input: ComputeLoadMilesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConfirmContractRecordFeeVoidArgs = {
  input: ConfirmContractRecordFeeVoidInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConfirmMaterialAllocationArgs = {
  input: ConfirmAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConfirmMyPhoneVerificationArgs = {
  input: ConfirmMyPhoneVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConfirmProducedQuantityEntryArgs = {
  input: ConfirmProducedQuantityEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConfirmReceiptArgs = {
  input: ConfirmReceiptInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConnectOrderEaseIntegrationArgs = {
  input: ConnectOrderEaseIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConsumeProductionJobsMaterialsArgs = {
  input: ConsumeProductionJobsMaterialsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationConvertFeatureFlagOverridesToProductsArgs = {
  chunkSize?: InputMaybe<Scalars['Int']['input']>;
  dryRun: Scalars['Boolean']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCorrectAcknowledgedQuantityArgs = {
  input: CorrectAcknowledgedQuantityItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCorrectCountedTotalArgs = {
  input: CorrectCountedTotalInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCorrectMaterialPriceArgs = {
  input: CorrectMaterialPriceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCorrectOrderArgs = {
  input: CorrectOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCountMaterialItemArgs = {
  input: CountMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateAdHocVendorPurchaseOrderArgs = {
  input: CreateAdHocVendorPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateAdminWorkSuiteProductArgs = {
  input: CreateWorkSuiteProductInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateAllocationTemplateArgs = {
  input: CreateAllocationTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateBillingPortalSessionArgs = {
  returnUrl: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateBillingPortalSessionForTenantArgs = {
  returnUrl: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateBlockingRuleArgs = {
  input: CreateBlockingRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateCommissionConfigArgs = {
  input: CreateCommissionConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateConsolidationPreviewArgs = {
  input: CreateConsolidationPreviewInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateCorrectionRunArgs = {
  correctionKey: Scalars['String']['input'];
  rows?: InputMaybe<Array<CorrectionRowInput>>;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateCountAssignmentArgs = {
  input: CreateCountAssignmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateCustomerArgs = {
  input: AddCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateErpLoadListSessionArgs = {
  input: CreateErpLoadListSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateForecastArgs = {
  input: CreateForecastInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateGrowerBenchmarkSubmissionDraftArgs = {
  input: CreateGrowerBenchmarkSubmissionDraftInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateInventoryItemArgs = {
  input: CreateInventoryItemCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateInvoiceEmailDraftArgs = {
  input: CreateInvoiceEmailDraftInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateJobArgs = {
  input: CreateJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateKitArgs = {
  input: CreateKitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateMakeToOrderPlanArgs = {
  input: CreateMakeToOrderPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateMakeToOrderPlanForLinesArgs = {
  input: CreateMakeToOrderPlanForLinesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateMaterialItemArgs = {
  input: CreateMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateMovementOrderArgs = {
  input: CreateMovementOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateMySubscriptionCheckoutSessionArgs = {
  frequency: BillingFrequency;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateOrUpdateTagByTagCodeArgs = {
  input: CreateOrUpdateTagByTagCodeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateOtaReleaseArgs = {
  input: CreateOtaReleaseInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreatePaymentProcessorArgs = {
  input: CreatePaymentProcessorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreatePortalUserArgs = {
  input: CreatePortalUserDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionCatalogArgs = {
  input: CreateProductionCatalogInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionItemArgs = {
  input: CreateProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionLineArgs = {
  input: CreateProductionLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionLotArgs = {
  input: CreateProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionLotAsyncImportJobArgs = {
  input: CreateProductionLotAsyncImportJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionMaterialEventArgs = {
  input: CreateProductionMaterialEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionRecipeArgs = {
  input: CreateProductionRecipeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionRecipeWithVariationArgs = {
  input: CreateProductionRecipeWithVariationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionSpaceEventArgs = {
  input: CreateProductionSpaceEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionTaskEventArgs = {
  input: CreateProductionTaskEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateProductionTriggerArgs = {
  input: CreateProductionTriggerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreatePromotionRuleArgs = {
  input: CreatePromotionRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreatePurchaseOrderAllocationArgs = {
  input: CreatePurchaseOrderAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateReportFolderArgs = {
  input: CreateReportFolderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateReportScheduleArgs = {
  input: CreateReportScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateReportTemplateArgs = {
  input: CreateReportTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateReserveRuleArgs = {
  input: CreateReserveRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateRestockSessionArgs = {
  input: CreateRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateScheduledOrderArgs = {
  input: CreateScheduledOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateSiteLocationAsyncImportJobArgs = {
  input: CreateSiteLocationAsyncImportJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateSiteMapArgs = {
  input: CreateSiteMapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateSubscriptionCheckoutSessionArgs = {
  frequency: BillingFrequency;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateSupplierPriceImportArgs = {
  input: CreateSupplierPriceImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateTaskAssignmentArgs = {
  input: CreateTaskAssignmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateTaskEventTypeArgs = {
  input: CreateTaskEventTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateTenantStripeAccountSessionArgs = {
  components: Array<StripeConnectComponent>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateUserInviteArgs = {
  input: CreateUserInviteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateUserInvitesArgs = {
  input: CreateUserInvitesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateVendorArgs = {
  input: CreateVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateVendorPurchaseOrderArgs = {
  input: CreateVendorPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateVolumePoolArgs = {
  input: CreateVolumePoolInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateWorkOrderArgs = {
  input: CreateWorkOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreateWsapiImportArgs = {
  input: CreateWsapiImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCreditExistingOrderArgs = {
  input: CreditExistingOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalAddContactArgs = {
  input: CustomerPortalAddContactInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalAddItemToShoppingCartArgs = {
  input: AddItemToCartInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalAddLineItemsArgs = {
  input: AddLineItemsInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalCancelOrderArgs = {
  input: CustomerPortalCancelOrderInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalCompleteCheckoutArgs = {
  orderId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalCreateFavoritesListArgs = {
  input: CreateFavoritesListInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalCreatePortalUserArgs = {
  input: CreatePortalUserInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalCreateShoppingCartArgs = {
  input: CreateCartInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalDeactivatePortalUserArgs = {
  input: DeactivatePortalUserInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalDeleteEmptyOrderArgs = {
  input: DeleteOrderInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalDeleteFavoritesListArgs = {
  input: DeleteFavoritesListInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalInitializeOrderArgs = {
  input: InitializeOrderInput;
  isPreorder?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalPlaceOrderArgs = {
  header: CustomerPortalPlaceOrderHeaderDataInput;
  isPreorder?: InputMaybe<Scalars['Boolean']['input']>;
  lines: Array<AddLineItemDataInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalRemoveContactArgs = {
  input: CustomerPortalRemoveContactInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalSaveRetailPricesArgs = {
  input: CustomerPortalSaveRetailPricesInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalSelfRegisterArgs = {
  input: SelfRegisterPortalUserDataInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalSetFavoritesListActiveArgs = {
  input: SetFavoritesListActiveInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalStartInvoiceCheckoutArgs = {
  invoiceIds: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdateAndGetNextOrderNumberArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdateContactArgs = {
  input: CustomerPortalUpdateContactInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdateFavoritesListArgs = {
  input: UpdateFavoritesListInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdatePortalUserArgs = {
  input: UpdatePortalUserInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationCustomerPortalUpdateShoppingCartArgs = {
  input: UpdateCartInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateConfigCategoryArgs = {
  input: DeactivateConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateContainerConfigArgs = {
  input: DeactivateContainerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateCustomerGroupArgs = {
  input: DeactivateCustomerGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateCustomerItemArgs = {
  input: DeactivateCustomerItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateCustomerTypeArgs = {
  input: DeactivateCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateCustomerUpgradeArgs = {
  input: DeactivateCustomerUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateFlatChargeTypeArgs = {
  input: DeactivateFlatChargeTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateItemUpgradeArgs = {
  input: DeactivateItemUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivatePaymentProcessorArgs = {
  input: DeactivatePaymentProcessorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionCategoryArgs = {
  input: DeactivateProductionCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionLineArgs = {
  input: DeactivateProductionLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionLotArgs = {
  input: DeactivateProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionPlanArgs = {
  input: DeactivateProductionPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionSpaceCategoryArgs = {
  input: DeactivateProductionSpaceCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateProductionSpaceTypeArgs = {
  input: DeactivateProductionSpaceTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateSizeUomArgs = {
  input: DeactivateSizeUomInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateTermsArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeallocatePurchaseOrderAllocationArgs = {
  input: DeallocatePurchaseOrderAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDecideSupplierPriceImportRowArgs = {
  input: DecideSupplierPriceImportRowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDecommissionDeviceArgs = {
  input: DecommissionDeviceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDefineForecastHolidayArgs = {
  input: DefineHolidayInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteAdminParentCompanyArgs = {
  input: DeleteParentCompanyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteAdminTenantIntegrationArgs = {
  input: DeleteTenantIntegrationInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteAdminTenantPricingPageArgs = {
  input: AdminTenantPricingPageDeleteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteAllocationTemplateArgs = {
  input: DeleteAllocationTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteBlockingRuleArgs = {
  input: DeleteBlockingRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteCarrierArgs = {
  input: DeleteCarrierInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteCustomerGroupArgs = {
  input: DeleteCustomerGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteCustomerTypeArgs = {
  input: DeleteCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteDeliveryScheduleArgs = {
  input: DeleteDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteDriverArgs = {
  input: DeleteDriverInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteErpLoadListSessionArgs = {
  input: DeleteErpLoadListSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteErpLoadListUserArgs = {
  input: DeleteErpLoadListUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteFirmwareFileArgs = {
  input: DeleteFirmwareFileInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteForecastArgs = {
  input: DeleteForecastInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteForecastHolidayArgs = {
  input: DeleteHolidayInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteItemArgs = {
  input: DeleteItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteItemCharacteristicArgs = {
  input: DeleteItemCharacteristicInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteItemCharacteristicValueArgs = {
  input: DeleteItemCharacteristicValueInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteKitArgs = {
  input: DeleteKitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteLoadArgs = {
  input: DeleteLoadInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteLoadLineArgs = {
  input: DeleteLoadLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteLogisticsDockArgs = {
  input: DeleteDockInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteLogisticsRouteArgs = {
  input: DeleteLogisticsRouteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteMasterOrderArgs = {
  input: DeleteMasterOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteMaterialItemArgs = {
  input: DeleteMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteOrderArgs = {
  input: DeleteOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteOrderKindArgs = {
  input: DeleteOrderKindInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeletePaymentProcessorArgs = {
  input: DeletePaymentProcessorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeletePriceGroupArgs = {
  input: DeletePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeletePriceLevelArgs = {
  input: DeletePriceLevelInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeletePriceLevelsArgs = {
  input: DeletePriceLevelsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionCatalogArgs = {
  input: DeleteProductionCatalogInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionCategoryArgs = {
  input: DeleteProductionCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionItemArgs = {
  input: DeleteProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionLotArgs = {
  input: DeleteProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionMaterialEventArgs = {
  input: DeleteProductionMaterialEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionPlanArgs = {
  input: DeleteProductionPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionRecipeArgs = {
  input: DeleteProductionRecipeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionSpaceCategoryArgs = {
  input: DeleteProductionSpaceCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionSpaceEventArgs = {
  input: DeleteProductionSpaceEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionSpaceTypeArgs = {
  input: DeleteProductionSpaceTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionTaskEventArgs = {
  input: DeleteProductionTaskEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteProductionTriggerArgs = {
  input: DeleteProductionTriggerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeletePromotionRuleArgs = {
  input: DeletePromotionRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteQaTestRunsArgs = {
  input: DeleteQaTestRunsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReportArgs = {
  input: DeleteReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReportExecutionArgs = {
  input: DeleteReportExecutionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReportFolderArgs = {
  input: DeleteReportFolderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReportScheduleArgs = {
  input: DeleteReportScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReportTemplateArgs = {
  input: DeleteReportTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteReserveRuleArgs = {
  input: DeleteReserveRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteRestockSessionArgs = {
  input: DeleteRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteSftpTenantConfigArgs = {
  input: DeleteSftpTenantConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteSiteLocationArgs = {
  input: DeleteSiteLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteSiteMapArgs = {
  input: DeleteSiteMapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteStagedEntityDocumentsArgs = {
  entity: GrowPointStagedEntity;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteTagColorArgs = {
  input: DeleteTagColorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteTaskEventTypeArgs = {
  input: DeleteTaskEventTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteTenantIntegrationArgs = {
  input: DeleteTenantIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteTermsArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteTimeEntryArgs = {
  input: DeleteTimeEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteUserInviteArgs = {
  input: DeleteUserInviteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteVehicleArgs = {
  input: DeleteVehicleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteVehicleTypeArgs = {
  input: DeleteVehicleTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteVendorArgs = {
  input: DeleteVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteWorkerConfigArgs = {
  input: DeleteWorkerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDeleteWsapiImportArgs = {
  input: DeleteWsapiImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDisableMyMultiFactorArgs = {
  input: DisableMyMultiFactorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDisableWsapiImportArgs = {
  input: DisableWsapiImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDiscardFloatingTimeEntryArgs = {
  input: DiscardFloatingTimeEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDiscardInboundDocumentArgs = {
  input: DiscardInboundDocumentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDiscardSupplierPriceImportArgs = {
  input: SupplierPriceImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDismissBackgroundJobArgs = {
  jobId: Scalars['String']['input'];
  type?: InputMaybe<BackgroundJobType>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDismissDuplicateCandidatesArgs = {
  input: DismissDuplicateCandidatesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDispatchLoadArgs = {
  input: DispatchLoadInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDraftGrowerBenchmarkReviewArgs = {
  reviewId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDraftGrowerBenchmarkReviewsForPeriodArgs = {
  communityId: Scalars['String']['input'];
  periodId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDuplicatePriceGroupArgs = {
  input: DuplicatePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationDuplicateProductionRecipeArgs = {
  input: DuplicateProductionRecipeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditCustomerLocationSettingsNoteArgs = {
  input: EditCustomerLocationSettingsNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditMasterOrderArgs = {
  input: EditMasterOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditOrderArgs = {
  input: EditOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditOrderFlatChargeArgs = {
  input: EditOrderFlatChargeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditPlanCellsArgs = {
  input: EditPlanCellsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditScheduledLaborRateArgs = {
  input: EditScheduledLaborRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditScheduledOverheadRateArgs = {
  input: EditScheduledOverheadRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEditWeeklyCellsArgs = {
  input: EditWeeklyCellsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEnableWsapiImportArgs = {
  input: EnableWsapiImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEnqueueErpWriteBackArgs = {
  input: EnqueueErpWriteBackInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationEnsureInvoicePayLinkArgs = {
  input: EnsureInvoicePayLinkInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationExchangePortalSessionHandoffCodeArgs = {
  input: ExchangePortalSessionHandoffCodeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationExecuteProductionJobArgs = {
  input: ExecuteProductionJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationExecuteScheduledInventoryTransferArgs = {
  input: ExecuteScheduledInventoryTransferInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationFillFernieGapsArgs = {
  input: FillFernieGapsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationFinalizeImportUploadArgs = {
  input: FinalizeImportUploadInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationFlagStaleEntryArgs = {
  input: FlagStaleEntriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationForceCancelStuckMtoReservationArgs = {
  input: ForceCancelStuckReservationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationForceFailConsolidationApplicationArgs = {
  input: ForceFailConsolidationApplicationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationForceReadyHandoffStuckMtoReservationArgs = {
  input: ForceReadyHandoffStuckReservationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationFulfillMaterialAllocationArgs = {
  input: FulfillAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationGenerateCustomerStatementRunArgs = {
  input: GenerateCustomerStatementRunInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationGenerateForecastArgs = {
  input: GenerateForecastInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationGradeInventoryItemArgs = {
  input: GradeInventoryItemCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationGrantParentCompanyTenantAccessArgs = {
  input: GrantParentCompanyTenantAccessInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationGrowerBenchmarkPurgeArgs = {
  input: GrowerBenchmarkPurgeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationGrowerBenchmarkQueueCohortPassArgs = {
  communityId: Scalars['String']['input'];
  periodId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationGrowerBenchmarkReclassifyFirmsArgs = {
  input: GrowerBenchmarkReclassifyFirmsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationGrowerBenchmarkUpsertMetricArgs = {
  input: GrowerBenchmarkMetricUpsertInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationHaltOtaReleaseArgs = {
  input: HaltOtaReleaseInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationIgnoreMissingDataArgs = {
  code: Scalars['String']['input'];
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportApprovedGrowerBenchmarkSubmissionArgs = {
  input: ImportApprovedGrowerBenchmarkSubmissionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportCustomerArgs = {
  input: ImportCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportCustomerRetailPricesArgs = {
  input: ImportCustomerRetailPricesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportHistoricalInvoicesArgs = {
  input: Array<ImportHistoricalInvoiceInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportHistoricalOrdersArgs = {
  input: Array<ImportHistoricalOrderInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportOrdersArgs = {
  input: ImportOrdersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationImportTermsArgs = {
  input: ImportTermsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateAdminFeatureFlagArgs = {
  input: InactivateFeatureFlagInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateAdminTenantArgs = {
  input: InactivateTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateCategoryArgs = {
  input: InactivateCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateCustomerArgs = {
  input: InactivateCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateDeliveryScheduleArgs = {
  input: InactivateDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateItemArgs = {
  input: InactivateItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateLocationArgs = {
  input: InactivateLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateMaterialItemArgs = {
  input: InactivateMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivatePriceGroupArgs = {
  input: InactivatePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionItemArgs = {
  input: InactivateProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionMaterialEventArgs = {
  input: InactivateProductionMaterialEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionMaterialEventDetailArgs = {
  input: InactivateProductionMaterialEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionRecipeArgs = {
  input: InactivateProductionRecipeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionSpaceEventArgs = {
  input: InactivateProductionSpaceEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionSpaceEventDetailArgs = {
  input: InactivateProductionSpaceEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionTaskEventArgs = {
  input: InactivateProductionTaskEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionTaskEventDetailArgs = {
  input: InactivateProductionTaskEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateProductionTriggerArgs = {
  input: InactivateProductionTriggerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateSftpTenantConfigArgs = {
  input: InactivateSftpTenantConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateSiteLocationArgs = {
  input: InactivateSiteLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateSubLocationArgs = {
  input: InactivateSubLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateTaskEventTypeArgs = {
  input: InactivateTaskEventTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInactivateVendorArgs = {
  input: InactivateVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationIncrementInventoryItemArgs = {
  input: IncrementInventoryItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationIngestDeviceCountArgs = {
  input: IngestDeviceCountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationIngestDeviceReadingsArgs = {
  input: IngestDeviceReadingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationIngestQaTestRunArgs = {
  input: IngestQaTestRunInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationIngestQaWatcherHeartbeatArgs = {
  input: IngestQaWatcherHeartbeatInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInitializeMasterOrderArgs = {
  input: InitializeMasterOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInitializeMergeDevExportArgs = {
  input: InitializeMergeDevExportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationInitializeOrderArgs = {
  input: InitializeOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationIssueCreditMemoArgs = {
  input: IssueCreditMemoInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLeaseDuplicateCheckRequestsArgs = {
  input: LeaseDuplicateCheckRequestsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkFloatingTimeEntryArgs = {
  input: LinkFloatingTimeEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkFusionAuthUserArgs = {
  input: LinkFusionAuthUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkFusionAuthUserByEmailArgs = {
  input: LinkFusionAuthUserByEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkProductionItemsToSalesItemArgs = {
  input: LinkProductionItemsToSalesItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkProductionItemsToSalesItemsArgs = {
  input: LinkProductionItemsToSalesItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkRampBillToPurchaseOrderArgs = {
  input: LinkRampBillToPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationLinkVendorToRampVendorArgs = {
  input: LinkVendorToRampVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkAdminTenantOnboardingUploadImportedArgs = {
  input: MarkAdminTenantOnboardingUploadImportedInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkContractRecordEnrollmentNeedsAttentionArgs = {
  input: MarkContractRecordEnrollmentNeedsAttentionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkContractRecordEnrollmentSucceededArgs = {
  input: MarkContractRecordEnrollmentSucceededInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkContractRecordEnrollmentVerifiedArgs = {
  input: MarkContractRecordEnrollmentVerifiedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkContractRecordFeeInvoicePaidArgs = {
  input: MarkContractRecordFeeInvoicePaidInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkContractRecordFeeInvoiceSentArgs = {
  input: MarkContractRecordFeeInvoiceSentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkContractRecordFeeNeedsAttentionArgs = {
  input: MarkContractRecordFeeNeedsAttentionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkContractRecordScheduleCancelledArgs = {
  input: MarkContractRecordScheduleCancelledInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkErpWriteBackAcceptedArgs = {
  input: MarkErpWriteBackAcceptedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkErpWriteBackFailedArgs = {
  input: MarkErpWriteBackFailedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkErpWriteBackNeedsReviewArgs = {
  input: MarkErpWriteBackNeedsReviewInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkErpWriteBackPostedArgs = {
  input: MarkErpWriteBackPostedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkErpWriteBackPostingArgs = {
  input: MarkErpWriteBackPostingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkErpWriteBackProcessedArgs = {
  input: MarkErpWriteBackProcessedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkMergeDevExportCompletedArgs = {
  input: MarkMergeDevExportCompletedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkMergeDevExportFailedPermanentArgs = {
  input: MarkMergeDevExportFailedPermanentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkMergeDevExportFailedTransientArgs = {
  input: MarkMergeDevExportFailedTransientInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkMergeDevExportNotExportedArgs = {
  input: MarkMergeDevExportNotExportedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkNotificationReadArgs = {
  input: MarkNotificationReadInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkNotificationUnreadArgs = {
  input: MarkNotificationUnreadInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkOrdersForInvoicingArgs = {
  input: MarkOrdersForInvoicingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkProductionJobsDoneArgs = {
  input: MarkProductionJobsDoneInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkProductionJobsStartedArgs = {
  input: MarkProductionJobsStartedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkProductionLotReadyArgs = {
  input: MarkProductionLotReadyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkRampPurchaseOrderCopyCompletedArgs = {
  input: MarkRampPurchaseOrderCopyCompletedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkRampPurchaseOrderCopyFailedPermanentArgs = {
  input: MarkRampPurchaseOrderCopyFailedPermanentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkRampPurchaseOrderCopyFailedTransientArgs = {
  input: MarkRampPurchaseOrderCopyFailedTransientInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkRampReconnectNeededArgs = {
  input: MarkRampReconnectNeededInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkRfidScansAsSyncedArgs = {
  ids: Array<Scalars['String']['input']>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkStatementPrintBatchFailedArgs = {
  input: MarkStatementPrintBatchFailedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkStatementPrintBatchReadyArgs = {
  input: MarkStatementPrintBatchReadyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkTrialRequestProvisionedArgs = {
  input: MarkTrialRequestProvisionedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkTrialRequestProvisioningArgs = {
  input: MarkTrialRequestProvisioningInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkTrialRequestProvisioningFailedArgs = {
  input: MarkTrialRequestProvisioningFailedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkUserInviteCompletedArgs = {
  input: MarkUserInviteCompletedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkUserInviteEmailFailedArgs = {
  input: MarkUserInviteEmailFailedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkUserInviteEmailSentArgs = {
  input: MarkUserInviteEmailSentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMarkUserInviteFailedArgs = {
  input: MarkUserInviteFailedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMaterializeMigrationImportQuestionsArgs = {
  input: MaterializeMigrationImportQuestionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeBackgroundServiceConfigArgs = {
  input: MergeBackgroundServiceConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeCarrierArgs = {
  input: MergeCarrierInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeContainerConfigArgs = {
  input: MergeContainerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeCustomerArgs = {
  input: MergeCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeDeliveryScheduleArgs = {
  input: MergeDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeDriverArgs = {
  input: MergeDriverInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeErpLoadListUserArgs = {
  input: MergeErpLoadListUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeForecastSettingsArgs = {
  input: MergeForecastSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeItemArgs = {
  input: MergeItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeJobWorkOrdersArgs = {
  input: MergeJobWorkOrdersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeLinkTokenArgs = {
  category?: MergeLinkCategory;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeLoadArgs = {
  input: MergeLoadInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeLoadLineArgs = {
  input: MergeLoadLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeLogisticsDockArgs = {
  input: MergeDockInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeLogisticsRouteArgs = {
  input: MergeLogisticsRouteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeMaterialItemByErpIdArgs = {
  input: MergeMaterialItemByErpIdInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeMergeDevAccountArgs = {
  input: MergeMergeDevAccountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeMergeDevPaymentArgs = {
  input: MergeMergeDevPaymentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeOrderArgs = {
  input: InitializeOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeOrderKindArgs = {
  input: MergeOrderKindInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergePriceGroupArgs = {
  input: MergePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergePriceLevelArgs = {
  input: MergePriceLevelInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeProductionCategoryArgs = {
  input: MergeProductionCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeProductionItemArgs = {
  input: MergeProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeProductionPlanArgs = {
  input: MergeProductionPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeProductionSpaceCategoryArgs = {
  input: MergeProductionSpaceCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeProductionSpaceTypeArgs = {
  input: MergeProductionSpaceTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeReplenishmentSettingsArgs = {
  input: MergeReplenishmentSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeSiteLocationArgs = {
  input: MergeSiteLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeVehicleArgs = {
  input: MergeVehicleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeVehicleTypeArgs = {
  input: MergeVehicleTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeVendorArgs = {
  input: MergeVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMergeWorkerConfigArgs = {
  input: MergeWorkerConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMintPortalSessionHandoffCodeArgs = {
  input: MintPortalSessionHandoffCodeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMoveInventoryItemArgs = {
  input: MoveInventoryItemCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationMoveMaterialItemArgs = {
  input: MoveMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOpenGrowerBenchmarkCycleArgs = {
  input: OpenGrowerBenchmarkCycleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOpenGrowerBenchmarkReviewForEditArgs = {
  reviewId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideInheritedEventForRecipeArgs = {
  input: OverrideInheritedEventForRecipeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideOrderLineUpgradePricingArgs = {
  input: OverrideOrderLineUpgradePricingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProducedQuantityArgs = {
  input: OverrideProducedQuantityDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionJobLocationArgs = {
  input: OverrideProductionJobLocationDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionJobQuantityArgs = {
  input: OverrideProductionJobQuantityDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionJobWeekReadyArgs = {
  input: OverrideProductionJobWeekReadyDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionJobWeekStartArgs = {
  input: OverrideProductionJobWeekStartDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionJobYieldArgs = {
  input: OverrideProductionJobYieldDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionLotCustomerArgs = {
  input: OverrideProductionLotCustomerDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionLotCustomerGroupArgs = {
  input: OverrideProductionLotCustomerGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideProductionLotQuantityArgs = {
  input: OverrideProductionLotQuantityDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationOverrideRestockSessionOrderQuantitiesArgs = {
  input: OverrideRestockSessionOrderQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPatchBatchAdminTenantArgs = {
  input: PatchBatchAdminTenantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPatchItemArgs = {
  input: PatchItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPauseCountSessionArgs = {
  input: PauseCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPauseMigrationImportRunArgs = {
  input: MigrationImportRunControlInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPauseOtaRolloutArgs = {
  input: PauseOtaRolloutInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPinQaTestRunArgs = {
  input: PinQaTestRunInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPlaceOrderHoldArgs = {
  input: PlaceOrderHoldInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPlanCorrectionRunArgs = {
  runId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPlanProductionJobMovesArgs = {
  input: PlanProductionJobMovesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPostCycleCountsArgs = {
  input: PostCycleCountsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPostProductionJobArgs = {
  input: PostProductionJobDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPostProductionJobsArgs = {
  input: PostProductionJobsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPrepareTenantModuleResetArgs = {
  createdFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  createdTo?: InputMaybe<Scalars['LocalDate']['input']>;
  module: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPresentMigrationReviewArgs = {
  input: PresentMigrationReviewInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPresentOnboardingHelpArgs = {
  input: PresentOnboardingHelpInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationProcessErpLoadListSessionArgs = {
  input: ProcessErpLoadListSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationProcessOnHandAdjustmentArgs = {
  input: ProcessOnHandAdjustmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPromoteOtaRolloutRingArgs = {
  input: PromoteOtaRolloutRingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationProrateOrderLinesArgs = {
  input: ProrateOrderLinesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPublicUserInviteAcceptArgs = {
  input: AcceptUserInviteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPublishOnboardingHelpRouteArgs = {
  input: PublishOnboardingHelpRouteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPublishOtaReleaseArgs = {
  input: PublishOtaReleaseInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPublishRestockWorkQueueResultBatchArgs = {
  input: PublishRestockWorkQueueResultBatchInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPublishWhatsNewComingSoonArgs = {
  input: PublishWhatsNewComingSoonInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPublishWhatsNewReleaseArgs = {
  input: PublishWhatsNewReleaseInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationPurgeMigrationRecordArgs = {
  input: PurgeMigrationRecordInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationQueueOnHandAdjustmentArgs = {
  input: QueueOnHandAdjustmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationQueueWhatsNewEmailArgs = {
  input: QueueWhatsNewEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRaiseDuplicateCandidatesArgs = {
  input: Array<RaiseDuplicateCandidateInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRaiseMigrationStatusNoticeArgs = {
  input: RaiseMigrationStatusNoticeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRaiseNotificationsArgs = {
  input: RaiseNotificationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReactivateFlatChargeTypeArgs = {
  input: ReactivateFlatChargeTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReactivateUserArgs = {
  input: ReactivateUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReactivateVolumePoolArgs = {
  input: ReactivateVolumePoolInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReapplyRecipesArgs = {
  input: ReapplyRecipesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReassignCountAssignmentArgs = {
  input: ReassignCountAssignmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReassignTaskArgs = {
  input: ReassignTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReassignWsapiImportIntegrationArgs = {
  input: ReassignWsapiImportIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRebuildForecastWeeklyHistoryArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecalculateRestockSessionArgs = {
  input: RecalculateRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReceiveMovementOrderArgs = {
  input: ReceiveMovementOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReceiveVendorPurchaseOrderItemsArgs = {
  input: ReceiveVendorPurchaseOrderItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecomputeSpaceUsageArgs = {
  input: RecomputeSpaceUsageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReconcileMovementOrderArgs = {
  input: ReconcileMovementOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReconcileOtaDeliveriesArgs = {
  input: ReconcileOtaDeliveriesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReconfirmOnboardingHelpRouteArgs = {
  input: ReconfirmOnboardingHelpRouteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReconnectMergeLinkArgs = {
  input?: InputMaybe<ReconnectMergeLinkInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordAccountingPlaceholderRefusalArgs = {
  input: RecordAccountingPlaceholderRefusalInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordAvailabilityPhotoGradeArgs = {
  input: RecordAvailabilityPhotoGradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordContactTextConsentArgs = {
  input: RecordContactTextConsentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordContractRecordEnrollmentStepCompletedArgs = {
  input: RecordContractRecordEnrollmentStepCompletedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordContractRecordFeeStepCompletedArgs = {
  input: RecordContractRecordFeeStepCompletedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordCustomerCreditRefundArgs = {
  input: RecordCustomerCreditRefundInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordCustomerDeliveryArgs = {
  input: RecordCustomerDeliveryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordCustomerTextReplyArgs = {
  input: RecordCustomerTextReplyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordCustomerTextStatusArgs = {
  input: RecordCustomerTextStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordDeviceFirmwareReportArgs = {
  input: RecordDeviceFirmwareReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordEmailDeliveryArgs = {
  input: RecordEmailDeliveryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordEmailSendArgs = {
  input: RecordEmailSendInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordGrowPointCommitOutcomesArgs = {
  input: RecordGrowPointCommitOutcomesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordImportSessionArgs = {
  input: RecordImportSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordInvoicePaymentArgs = {
  input: RecordInvoicePaymentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordLearningCheckAnsweredArgs = {
  conceptId: Scalars['String']['input'];
  correct: Scalars['Boolean']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordLearningConceptExplainedArgs = {
  conceptId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordLearningWalkthroughOutcomeArgs = {
  conceptId?: InputMaybe<Scalars['String']['input']>;
  outcome: LearningWalkthroughOutcome;
  walkthroughId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordLoadEmailOutcomeArgs = {
  input: RecordLoadEmailOutcomeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordManualJobCostArgs = {
  amount: Scalars['Decimal']['input'];
  costCategory: CostCategory;
  description: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  recordId?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordMaterialReceiptArgs = {
  input: RecordMaterialReceiptInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordMaterialReceiptGroupArgs = {
  input: RecordMaterialReceiptGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordMigrationImportCorrectionArgs = {
  input: RecordMigrationImportCorrectionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordMigrationImportRunObservationArgs = {
  input: RecordMigrationImportRunObservationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordMigrationImportRunVerificationArgs = {
  input: RecordMigrationImportRunVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordMigrationPreparationStageResultArgs = {
  input: RecordMigrationPreparationStageResultInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordMigrationSettingsRevisionArgs = {
  input: RecordMigrationSettingsRevisionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordMigrationValidationCompletionArgs = {
  input: RecordMigrationValidationCompletionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordNotificationDeliveryArgs = {
  input: RecordNotificationDeliveryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordOnboardingHelpDeliveryArgs = {
  input: RecordOnboardingHelpDeliveryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordOnboardingHelpRequestHandlingArgs = {
  input: RecordOnboardingHelpRequestHandlingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordOnboardingJourneyFactArgs = {
  input: RecordOnboardingJourneyFactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordOnboardingJourneySessionLoadedArgs = {
  input: RecordOnboardingJourneySessionLoadedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordOrderDepositArgs = {
  input: RecordOrderDepositInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordOrderPaymentArgs = {
  input: RecordOrderPaymentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordOrderPullsArgs = {
  input: RecordOrderPullsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordReportExecutionArgs = {
  input: RecordReportExecutionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordShrinkEventArgs = {
  input: RecordShrinkEventDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordSmsCarrierOptOutArgs = {
  input: RecordSmsCarrierOptOutInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordSmsDeliveryStatusArgs = {
  input: RecordSmsDeliveryStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordStopDeliveredArgs = {
  input: RecordStopDeliveredInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordStopPartiallyDeliveredArgs = {
  input: RecordStopPartiallyDeliveredInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordStopRefusedArgs = {
  input: RecordStopRefusedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordUserLastLoginsArgs = {
  input: RecordUserLastLoginsDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRecordWhatsNewEmailBatchOutcomeArgs = {
  input: RecordWhatsNewEmailBatchOutcomeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRefreshOrderTaxEstimateArgs = {
  input: RefreshOrderTaxEstimateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRefreshTenantEmailSenderStatusArgs = {
  input: RefreshTenantEmailSenderStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRefreshTenantIntegrationTokensArgs = {
  input: RefreshTenantIntegrationTokensInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRefundOnlinePaymentArgs = {
  input: RefundOnlinePaymentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRegisterCountArgs = {
  input: RegisterCountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRegisterDeviceArgs = {
  input: RegisterDeviceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRegisterGrowerBenchmarkFirmArgs = {
  input: RegisterGrowerBenchmarkFirmInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRegisterMyPushSubscriptionArgs = {
  input: RegisterMyPushSubscriptionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRegisterOnboardingUploadArgs = {
  input: RegisterOnboardingUploadInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReissueDeviceClaimCodeArgs = {
  input: ReissueDeviceClaimCodeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRejectProducedQuantityEntryArgs = {
  input: RejectProducedQuantityEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReleaseErpWriteBackArgs = {
  input: ReleaseErpWriteBackInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReleaseGrowerBenchmarkReviewArgs = {
  reviewId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReleaseInventoryHoldArgs = {
  input: ReleaseInventoryHoldInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReleaseMaterialAllocationArgs = {
  input: ReleaseAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReleaseMirroredStripeScheduleArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReleaseOrderHoldArgs = {
  input: ReleaseOrderHoldInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReleaseOrphanedOrderAllocationsArgs = {
  dryRun?: Scalars['Boolean']['input'];
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveAdminParentCompanyAdministratorArgs = {
  input: RemoveParentCompanyAdministratorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveBillingAddressArgs = {
  input: RemoveBillingAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveBlockingRuleLinkedItemsArgs = {
  input: RemoveBlockingRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveBlockingRuleLinkedLocationsArgs = {
  input: RemoveBlockingRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveCategoryArgs = {
  input: RemoveCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveContactArgs = {
  input: RemoveContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveContainerConfigFromConfigCategoryArgs = {
  input: RemoveContainerConfigFromConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveImportRowsArgs = {
  input: RemoveImportRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveInboundAllowedSenderArgs = {
  input: RemoveInboundAllowedSenderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveItemAvailabilityPhotoArgs = {
  input: RemoveItemAvailabilityPhotoInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveItemMinShipQtyArgs = {
  input: RemoveItemMinShipQtyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveItemRoyaltyArgs = {
  input: RemoveItemRoyaltyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveItemSubstitutionArgs = {
  input: RemoveItemSubstitutionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveLineItemArgs = {
  input: RemoveLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveLineItemAllocationsArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  input: RemoveLineItemAllocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveLocationArgs = {
  input: RemoveLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveMasterLineItemArgs = {
  input: RemoveMasterLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveMyPushSubscriptionArgs = {
  input: RemoveMyPushSubscriptionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveOrderFlatChargeArgs = {
  input: RemoveOrderFlatChargeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveOrderLineUpgradeArgs = {
  input: RemoveOrderLineUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemovePortalCustomDomainArgs = {
  input: RemovePortalCustomDomainInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionMaterialEventDetailArgs = {
  input: RemoveProductionMaterialEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionMaterialEventFromCategoryArgs = {
  input: RemoveProductionMaterialEventFromCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionMaterialEventFromJobArgs = {
  input: RemoveProductionMaterialEventFromJobDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionRecipeVariationArgs = {
  input: RemoveProductionRecipeVariationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionSpaceEventDetailArgs = {
  input: RemoveProductionSpaceEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionSpaceEventFromCategoryArgs = {
  input: RemoveProductionSpaceEventFromCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionSpaceEventFromJobArgs = {
  input: RemoveProductionSpaceEventFromJobDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionTaskEventDetailArgs = {
  input: RemoveProductionTaskEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionTaskEventFromCategoryArgs = {
  input: RemoveProductionTaskEventFromCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionTaskEventFromItemArgs = {
  input: RemoveProductionTaskEventFromItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveProductionTaskEventFromJobArgs = {
  input: RemoveProductionTaskEventFromJobDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemovePromotionRuleLinkedItemsArgs = {
  input: RemovePromotionRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemovePromotionRuleLinkedLocationsArgs = {
  input: RemovePromotionRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemovePurchaseOrderLineItemArgs = {
  input: RemovePurchaseOrderLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemovePushSubscriptionForWorkerArgs = {
  input: RemovePushSubscriptionForWorkerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveReserveRuleLinkedItemsArgs = {
  input: RemoveReserveRuleLinkedItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveReserveRuleLinkedLocationsArgs = {
  input: RemoveReserveRuleLinkedLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveSftpDestinationArgs = {
  input: RemoveSftpDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveSftpMongoDestinationArgs = {
  input: RemoveSftpMongoDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveShrinkEventArgs = {
  input: RemoveShrinkEventDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveSizeUomFromConfigCategoryArgs = {
  input: RemoveSizeUomFromConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveSpaceCapacityWindowArgs = {
  input: RemoveSpaceCapacityWindowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveSpaceTypeCapacityArgs = {
  input: RemoveSpaceTypeCapacityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveSubLocationArgs = {
  input: RemoveSubLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveTaskAssignmentTimeEntryArgs = {
  input: RemoveTimeEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveTenantEmailSenderArgs = {
  input: RemoveTenantEmailSenderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveVendorPurchaseOrderChargeArgs = {
  input: RemoveVendorPurchaseOrderChargeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveVerifyContainerArgs = {
  input: RemoveVerifyContainerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRemoveWsapiImportEntityMappingArgs = {
  input: RemoveWsapiImportEntityMappingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRenameCategoryArgs = {
  input: RenameCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRenameDeviceArgs = {
  input: RenameDeviceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRenameReportFolderArgs = {
  input: RenameReportFolderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRenameVolumePoolArgs = {
  input: RenameVolumePoolInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRenewMigrationImportRunClaimArgs = {
  input: RenewMigrationClaimInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRenewMigrationPreparationJobClaimArgs = {
  input: RenewMigrationClaimInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReopenProductionJobArgs = {
  input: ReopenProductionJobDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReorderItemAvailabilityPhotosArgs = {
  input: ReorderItemAvailabilityPhotosInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRepairMigrationHandoffArgs = {
  input: RepairMigrationHandoffInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRepairProductionJobReservationPegsArgs = {
  input: RepairProductionJobReservationPegsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReplaceCustomerSalesPeopleArgs = {
  input: ReplaceCustomerSalesPeopleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReplaceErpLoadListRoutesArgs = {
  input: ReplaceErpLoadListRoutesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReplaceSalesPeopleArgs = {
  input: ReplaceSalesPeopleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReplaceSpaceCapacityWindowArgs = {
  input: ReplaceSpaceCapacityWindowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReplayDeadLetteredCustomerItemsArgs = {
  input: ReplayDeadLetteredCustomerItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReplayOnlinePaymentExceptionArgs = {
  input: ReplayOnlinePaymentExceptionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRepointProductionRecipeLinksArgs = {
  input: RepointProductionRecipeLinksInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReportStatementPrintBatchProgressArgs = {
  input: ReportStatementPrintBatchProgressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRepriceOrderArgs = {
  input: RepriceOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRepriceOrderLineArgs = {
  input: RepriceOrderLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestBackgroundJobArgs = {
  input: RequestBackgroundJobInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestBulkOrderDeleteArgs = {
  input: RequestBulkOrderDeleteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestEarlyAccessArgs = {
  input: RequestEarlyAccessInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestFreightQuoteSendArgs = {
  input: RequestFreightQuoteSendInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestInvoicePayLinkResendArgs = {
  token: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestMaterialAllocationArgs = {
  input: RequestAllocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestMyPhoneVerificationArgs = {
  input: RequestMyPhoneVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestPlannedArrivalNoticesArgs = {
  input: RequestPlannedArrivalNoticesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestRampPurchaseOrderCopyArgs = {
  input: RequestRampPurchaseOrderCopyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestRestockCalculationArgs = {
  input: RequestRestockCalculationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestRestockDashboardRecalcArgs = {
  input: RequestRestockDashboardRecalcInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestStatementPrintBatchArgs = {
  input: RequestStatementPrintBatchInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestTenantEmailSenderVerificationArgs = {
  input: RequestTenantEmailSenderVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRequestTrialSignupVerificationArgs = {
  input: RequestTrialSignupVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResendInvoiceEmailArgs = {
  input: ResendInvoiceEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResendUserInviteArgs = {
  input: ResendUserInviteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetAcknowledgmentEmailArgs = {
  input: ResetAcknowledgmentEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetAdminTenantIntegrationsArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetConfirmationEmailArgs = {
  input: ResetConfirmationEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetOrderSyncStatusArgs = {
  input: ResetSyncStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetUserLoginArgs = {
  input: ResetUserLoginInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetWorkOrderQuantityProducedArgs = {
  input: ResetWorkOrderQuantityProducedInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetWorkerConfigRunNowArgs = {
  input: ResetWorkerConfigRunNowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResetWsapiImportRunNowArgs = {
  input: ResetWsapiImportRunNowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResolveDuplicateCandidateArgs = {
  input: ResolveDuplicateCandidateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResolveErpWriteBackArgs = {
  input: ResolveErpWriteBackInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResolveOnlinePaymentExceptionArgs = {
  input: ResolveOnlinePaymentExceptionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResolveTrialRequestArgs = {
  input: ResolveTrialRequestInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResolveUncertainLoadEmailArgs = {
  input: ResolveUncertainLoadEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRestoreGrowerBenchmarkReviewVersionArgs = {
  reviewId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResumeCountSessionArgs = {
  input: ResumeCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResumeMigrationImportRunArgs = {
  input: MigrationImportRunControlInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationResumeOtaRolloutArgs = {
  input: ResumeOtaRolloutInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRetireVendorItemAliasArgs = {
  input: RetireVendorItemAliasInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRetireVolumePoolArgs = {
  input: RetireVolumePoolInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRetryFailedBackgroundJobItemsArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRetryInvoiceExportArgs = {
  input: RetryInvoiceExportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRetryPaymentExportArgs = {
  input: RetryPaymentExportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevalidateImportArgs = {
  input: RevalidateImportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReverseManualJobCostArgs = {
  jobId: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevertCustomerCombineArgs = {
  input: RevertCustomerCombineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevertItemCombineArgs = {
  input: RevertItemCombineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevertProductionCatalogCombineArgs = {
  input: RevertProductionCatalogCombineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevertProductionItemCombineArgs = {
  input: RevertProductionItemCombineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevertReportArgs = {
  reportId: Scalars['String']['input'];
  version: Scalars['Long']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevertShipToCombineArgs = {
  input: RevertShipToCombineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevertSubLocationCombineArgs = {
  input: RevertSubLocationCombineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevertTermsCombineArgs = {
  input: RevertTermsCombineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReviewOnboardingParsingSuggestionArgs = {
  input: ReviewOnboardingParsingSuggestionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReviewOnlinePaymentCreditArgs = {
  input: ReviewOnlinePaymentCreditInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationReviewSupplierPriceImportRowArgs = {
  input: ReviewSupplierPriceImportRowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevokeDeviceCredentialArgs = {
  input: RevokeDeviceCredentialInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevokeGrowerBenchmarkRosterEntryArgs = {
  input: RevokeGrowerBenchmarkRosterEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevokeInvoicePayLinkArgs = {
  input: RevokeInvoicePayLinkInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRevokeParentCompanyTenantAccessArgs = {
  input: RevokeParentCompanyTenantAccessInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRoundRestockSessionOrderQuantityToFullCartArgs = {
  input: RoundRestockSessionOrderQuantityToFullCartInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRouteInboundDocumentArgs = {
  input: RouteInboundDocumentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRunDuplicateCheckArgs = {
  input: RunDuplicateCheckInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationRunReportArgs = {
  input: RunReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSaveConsolidationRulesArgs = {
  input: SaveConsolidationRulesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSaveGrowerBenchmarkCompareViewArgs = {
  input: SaveGrowerBenchmarkCompareViewInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSaveGrowerBenchmarkReviewVersionArgs = {
  changedSectionIds: Array<Scalars['String']['input']>;
  findingNotes: Array<GrowerBenchmarkReviewFindingNoteInput>;
  reviewId: Scalars['String']['input'];
  sections: Array<GrowerBenchmarkReviewSectionInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSaveRestockSessionKitCountsArgs = {
  input: SaveRestockSessionKitCountsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationScheduleContractRecordEnrollmentRetryArgs = {
  input: ScheduleContractRecordEnrollmentRetryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationScheduleContractRecordFeeRetryArgs = {
  input: ScheduleContractRecordFeeRetryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationScheduleInventoryTransferArgs = {
  input: ScheduleInventoryTransferInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationScheduleMasterOrderWeekArgs = {
  input: ScheduleMasterOrderWeekInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationScrapInventoryItemArgs = {
  input: ScrapInventoryItemCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSeedForecastHolidaysArgs = {
  input: SeedForecastHolidaysInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSelectRampEntityArgs = {
  input: SelectRampEntityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSelectSupplierPriceImportRowArgs = {
  input: SelectSupplierPriceImportRowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSelectTenantEmailSenderArgs = {
  input: SelectTenantEmailSenderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSendCustomerStatementsArgs = {
  input: SendCustomerStatementsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSendDeviceCommandArgs = {
  input: SendDeviceCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSendInvoiceEmailArgs = {
  input: SendInvoiceEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSendMasterOrderEmailArgs = {
  input: SendMasterOrderEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAccountingIntegrationConfigArgs = {
  input: SetAccountingIntegrationConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAccountingLineAccountsArgs = {
  input: SetAccountingLineAccountsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetActiveCountSessionArgs = {
  input: SetActiveCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAdminFeatureFlagGlobalValueArgs = {
  input: SetGlobalValueInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAdminFeatureFlagTenantOverrideArgs = {
  input: SetFeatureFlagTenantOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAdminFeatureFlagTenantOverridesArgs = {
  input: SetTenantOverridesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAdminPortalCompanySlugArgs = {
  input: AdminSetCompanySlugInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAdminTenantCustomerTextingArgs = {
  input: SetAdminTenantCustomerTextingInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAdminTenantFeaturesArgs = {
  input: SetTenantFeaturesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAdminTenantParentCompanyArgs = {
  input: SetTenantParentCompanyInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetAdminTenantWorkSuiteProductsArgs = {
  input: SetAdminTenantWorkSuiteProductsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetBackgroundServiceEnabledArgs = {
  input: SetBackgroundServiceEnabledInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetBpfUserStartingNodesArgs = {
  input: SetBpfUserStartingNodesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCategoryIncomeGlAccountArgs = {
  input: SetCategoryIncomeGlAccountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCategoryLaborCostArgs = {
  input: SetCategoryLaborCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCategoryUnitsPerPoleArgs = {
  input: SetCategoryUnitsPerPoleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCheckpointArgs = {
  input: SetCheckpointInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCommissionDefaultRateArgs = {
  input: SetCommissionDefaultRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetConsolidationLotPinsArgs = {
  input: SetConsolidationLotPinsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetConsolidationRuleSetArgs = {
  input: SetConsolidationRuleSetInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetContactCrmLinkArgs = {
  input: SetContactCrmLinkInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetContractRecordEnrollmentBackToPendingArgs = {
  input: SetContractRecordEnrollmentBackToPendingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetContractRecordFeeBackToPendingArgs = {
  input: SetContractRecordFeeBackToPendingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCountSessionTargetArgs = {
  input: SetCountSessionTargetInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCountedQuantityArgs = {
  input: SetCountedQuantityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerCommissionOverrideArgs = {
  input: SetCustomerCommissionOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerCrmLinkArgs = {
  input: SetCustomerCrmLinkInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerDefaultTagColorArgs = {
  input: SetCustomerDefaultTagColorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerDepositRequirementArgs = {
  input: SetCustomerDepositRequirementInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerDisabledVolumePoolsArgs = {
  input: SetCustomerDisabledVolumePoolsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerGroupArgs = {
  input: SetCustomerGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerItemEffectiveDatesArgs = {
  input: SetCustomerItemEffectiveDatesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerItemRetailPriceArgs = {
  input: SetCustomerItemRetailPriceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerItemShippingUomArgs = {
  input: SetCustomerItemShippingUomInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerLocationCoordinatesArgs = {
  input: SetCustomerLocationCoordinatesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerLocationDeliveryScheduleArgs = {
  input: SetCustomerLocationDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerLocationNoteArgs = {
  input: SetCustomerLocationNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerLocationReceivingEmailArgs = {
  input: SetCustomerLocationReceivingEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerLocationRouteArgs = {
  input: SetCustomerLocationRouteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerLocationServicingSiteArgs = {
  input: SetCustomerLocationServicingSiteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerMinimumFreightChargeArgs = {
  input: SetCustomerMinimumFreightChargeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerNoteArgs = {
  input: SetCustomerNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerOrderEntryUnitArgs = {
  input: SetCustomerOrderEntryUnitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerPriceEntryUnitArgs = {
  input: SetCustomerPriceEntryUnitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerRouteArgs = {
  input: SetCustomerRouteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerStatementDeliveryArgs = {
  input: SetCustomerStatementDeliveryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerTaxDetailsArgs = {
  input: SetCustomerTaxDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerTypeArgs = {
  input: SetCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetCustomerTypeRevenueGlAccountArgs = {
  input: SetCustomerTypeRevenueGlAccountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetDefaultGroupArgs = {
  input: SetDefaultGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetDefaultTermsArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetDefaultVendorArgs = {
  input: SetDefaultVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetDeviceDesiredConfigArgs = {
  input: SetDeviceDesiredConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetEmailSenderAdminOnlyArgs = {
  input: SetEmailSenderAdminOnlyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetErpCustomerRouteAssignmentsArgs = {
  input: SetErpCustomerRouteAssignmentsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetErpRouteSalespeopleArgs = {
  input: SetErpRouteSalespeopleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetErpWriteBackHoldArgs = {
  input: SetErpWriteBackHoldInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetGrowerBenchmarkFirmBillingStateArgs = {
  input: SetGrowerBenchmarkFirmBillingStateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetGrowerBenchmarkFirmChecklistItemArgs = {
  input: SetGrowerBenchmarkFirmChecklistItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetGrowerBenchmarkFirmProfileArgs = {
  input: SetGrowerBenchmarkFirmProfileInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetGrowerBenchmarkRetailMonthValuesArgs = {
  input: SetGrowerBenchmarkRetailMonthValuesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetGrowerBenchmarkRosterEntryArgs = {
  input: SetGrowerBenchmarkRosterEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetGrowerBenchmarkSubmissionStatusArgs = {
  input: SetGrowerBenchmarkSubmissionStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetInboundDocumentKindArgs = {
  input: SetInboundDocumentKindInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetInventoryBatchPlantDateArgs = {
  input: SetInventoryBatchPlantDateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetInventoryItemReadyDateArgs = {
  input: SetInventoryItemReadyDateCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetInvoiceEmailChannelArgs = {
  input: SetInvoiceEmailChannelInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemAvailabilityPhotoPrimaryArgs = {
  input: SetItemAvailabilityPhotoPrimaryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemBatchTrackingArgs = {
  input: SetItemBatchTrackingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemCharacteristicsArgs = {
  input: SetItemCharacteristicsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemContainerConfigOverrideArgs = {
  input: SetItemContainerConfigOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemDefaultTagColorArgs = {
  input: SetItemDefaultTagColorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemLaborCostArgs = {
  input: SetItemLaborCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemNoteArgs = {
  input: SetItemNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemPriceLabelArgs = {
  input: SetItemPriceLabelInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemProductionMappingsArgs = {
  input: SetItemProductionMappingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetItemShippingUomsArgs = {
  input: SetItemShippingUomsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetJobGrowWeeksOverrideArgs = {
  input: SetJobGrowWeeksOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetJobLinksOverrideArgs = {
  input: SetJobLinksOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetJobPlannedHoursOverrideArgs = {
  input: SetJobPlannedHoursOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetJobPlantsPerPotOverrideArgs = {
  input: SetJobPlantsPerPotOverrideDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLaborTypesArgs = {
  input: SetLaborTypesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLineItemCustomerItemArgs = {
  input: SetLineItemCustomerItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLineItemOverridePriceArgs = {
  input: SetLineItemOverridePriceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLineItemShippingUomArgs = {
  input: SetLineItemShippingUomInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLineItemTagColorsArgs = {
  input: SetLineItemTagColorsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLoadDockArgs = {
  input: SetLoadDockInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLoadLineStopArgs = {
  input: SetLoadLineStopInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLoadMilesArgs = {
  input: SetLoadMilesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLoadPickupWindowArgs = {
  input: SetLoadPickupWindowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLoadStopPlannedTimeArgs = {
  input: SetLoadStopPlannedTimeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLoadTransitKindArgs = {
  input: SetLoadTransitKindInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLocationDefaultSpaceTypeArgs = {
  input: SetLocationDefaultSpaceTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLocationOrderEmailContactsArgs = {
  input: SetLocationOrderEmailContactsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetLocationOverheadRateArgs = {
  input: SetLocationOverheadRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMaterialItemBaseUnitArgs = {
  input: SetMaterialItemBaseUnitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMaterialItemBatchPlantDateArgs = {
  input: SetMaterialItemBatchPlantDateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMaterialItemBatchTrackingArgs = {
  input: SetMaterialItemBatchTrackingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMaterialItemImageArgs = {
  input: SetMaterialItemImageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMaterialItemTagSpecArgs = {
  input: SetMaterialItemTagSpecInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMyLanguagePreferenceArgs = {
  input: SetMyLanguagePreferenceDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMyNotificationPreferencesArgs = {
  input: SetMyNotificationPreferencesDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMyProfileImageArgs = {
  input: SetMyProfileImageDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetMyWhatsNewEmailArgs = {
  input: SetMyWhatsNewEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetNotificationDocumentReportArgs = {
  input: SetNotificationDocumentReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetNotificationRecipientsArgs = {
  input: SetNotificationRecipientsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetNotificationSendChoiceArgs = {
  input: SetNotificationSendChoiceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetNotificationTextRecipientsArgs = {
  input: SetNotificationTextRecipientsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderContainerArgs = {
  input: SetOrderContainerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderDropShipDestinationArgs = {
  input: SetOrderDropShipDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderEmailEnablementArgs = {
  input: SetOrderEmailEnablementInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderEmailRecipientRoutingArgs = {
  input: SetOrderEmailRecipientRoutingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderEmailSettingsArgs = {
  input: SetOrderEmailSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderKindArgs = {
  input: SetOrderKindInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderNoTaxArgs = {
  input: SetOrderNoTaxInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderNoteArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  input: SetOrderNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderPlannedShipDateArgs = {
  input: SetOrderPlannedShipDateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderProgramArgs = {
  input: SetOrderProgramInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderQuoteDetailsArgs = {
  input: SetOrderQuoteDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderShipFromSiteArgs = {
  input: SetOrderShipFromSiteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderTagColorArgs = {
  input: SetOrderTagColorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderfulApiKeySecretNameArgs = {
  input: SetOrderfulApiKeySecretNameInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderfulIntegrationMappingArgs = {
  input: SetOrderfulIntegrationMappingInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderfulIntegrationStatusArgs = {
  input: SetOrderfulIntegrationStatusInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetOrderfulOrganizationIsaIdsArgs = {
  input: SetOrderfulOrganizationIsaIdsInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPodAssignmentReplicasArgs = {
  input: SetPodAssignmentReplicasInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPortalUserPermissionsArgs = {
  input: SetPortalUserPermissionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPriceGroupDerivationArgs = {
  input: SetPriceGroupDerivationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPriceGroupOrderVolumeDiscountArgs = {
  input: SetPriceGroupOrderVolumeDiscountInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPriceGroupQualificationConditionsArgs = {
  input: SetPriceGroupQualificationConditionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPriceLevelsVolumePoolArgs = {
  input: SetPriceLevelsVolumePoolInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPrimaryPortalCustomDomainArgs = {
  input: SetPrimaryPortalCustomDomainInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionJobNotesArgs = {
  input: SetProductionJobNotesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionLotAsyncImportJobRowIdsArgs = {
  input: SetProductionLotAsyncImportJobRowIdsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionLotProductionItemArgs = {
  input: SetProductionLotProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionRecipeFlatRateCostArgs = {
  input: SetRecipeFlatRateCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionRecipeMaterialVendorArgs = {
  input: SetRecipeMaterialVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionRecipeTaskEventIdsArgs = {
  input: SetRecipeTaskEventIdsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionRecipeTypeArgs = {
  input: SetProductionRecipeTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionTriggerRemindersArgs = {
  input: SetProductionTriggerRemindersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionYearPlanCellsArgs = {
  input: SetProductionYearPlanCellsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionYearPlanItemArgs = {
  input: SetProductionYearPlanItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetProductionYearPlanProductionPlanArgs = {
  input: SetProductionYearPlanProductionPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPropagationYieldArgs = {
  input: SetProductionJobPropagationYieldDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetPurchaseOrderUrgentArgs = {
  input: SetPurchaseOrderUrgentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetRampCopyPurchaseOrdersArgs = {
  input: SetRampCopyPurchaseOrdersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetRampVendorSuggestionsArgs = {
  input: SetRampVendorSuggestionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetRecipeAdditionalCostEventIdsArgs = {
  input: SetRecipeAdditionalCostEventIdsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetRecipeLaborSourceArgs = {
  input: SetRecipeLaborSourceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetReportAppTagsArgs = {
  input: SetReportAppTagsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetReportScheduleEmailSettingsArgs = {
  input: SetReportScheduleEmailSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetRestockSessionKitCapArgs = {
  input: SetRestockSessionKitCapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetRestockSessionOrderQuantitiesArgs = {
  input: SetRestockSessionOrderQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetRouteDeliveryScheduleArgs = {
  input: SetRouteDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSiteContactsArgs = {
  input: SetSiteContactsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSiteLaborRateArgs = {
  input: SetSiteLaborRateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSiteLocationAsyncImportJobRowIdsArgs = {
  input: SetSiteLocationAsyncImportJobRowIdsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSiteLocationCoordinatesArgs = {
  input: SetSiteLocationCoordinatesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSiteTimeZoneArgs = {
  input: SetSiteTimeZoneInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSpaceCapacityWindowArgs = {
  input: SetSpaceCapacityWindowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSpaceCategorySiteOverrideArgs = {
  input: SetSpaceCategorySiteOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSpaceDimensionOverrideArgs = {
  input: SetSpaceDimensionOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetSpaceTypeCapacityArgs = {
  input: SetSpaceTypeCapacityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetStockBatchesFromErpArgs = {
  input: SetStockBatchesFromErpInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetStoreClassesArgs = {
  input: SetStoreClassesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTaskEventDetailThroughputArgs = {
  input: SetTaskEventDetailThroughputInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTaskEventDirectCostArgs = {
  input: SetTaskEventDirectCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTaskEventLaborTypeTagArgs = {
  input: SetTaskEventLaborTypeTagInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTaskEventThroughputArgs = {
  input: SetTaskEventThroughputInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantAvailabilityQuantityBasisArgs = {
  input: SetTenantAvailabilityQuantityBasisInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantAvailabilityQuantityEntryArgs = {
  input: SetTenantAvailabilityQuantityEntryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantBillingFrequencyArgs = {
  frequency: BillingFrequency;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantBillingRateCardArgs = {
  input: SetTenantBillingRateCardInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantDefaultCarrierArgs = {
  input: SetTenantDefaultCarrierInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantDefaultEmailSenderArgs = {
  input: SetTenantDefaultEmailSenderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantDefaultRouteArgs = {
  input: SetTenantDefaultRouteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantLoadPaperworkBindingArgs = {
  input: SetTenantLoadPaperworkBindingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantLoadPaperworkPolicyArgs = {
  input: SetTenantLoadPaperworkPolicyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantMultiFactorRequirementArgs = {
  input: SetTenantMultiFactorRequirementInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantOnlinePaymentMaxAmountOverrideArgs = {
  input: SetTenantOnlinePaymentMaxAmountOverrideInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantOrderEntryUnitArgs = {
  input: SetTenantOrderEntryUnitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantPriceEntryUnitArgs = {
  input: SetTenantPriceEntryUnitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetTenantSmtpConnectionArgs = {
  input: SetTenantSmtpConnectionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetVendorMaterialCostArgs = {
  input: SetVendorMaterialCostInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetVendorPurchaseOrderPurposeTextArgs = {
  input: SetVendorPurchaseOrderPurposeTextInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetWorkOrderLineNumberArgs = {
  input: SetWorkOrderLineNumberInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetWorkerConfigRunNowArgs = {
  input: SetWorkerConfigRunNowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSetWsapiImportRunNowArgs = {
  input: SetWsapiImportRunNowInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationShareReportArgs = {
  input: ShareReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationShipMovementOrderArgs = {
  input: ShipMovementOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationShipOrderWithStockCorrectionsArgs = {
  input: ShipOrderWithStockCorrectionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationShipPurchaseOrderArgs = {
  input: ShipPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSkipAssignmentTaskArgs = {
  input: SkipAssignmentTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSplitProductionLotArgs = {
  input: SplitProductionLotDataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStageGrowerBenchmarkImportedLinesArgs = {
  input: StageGrowerBenchmarkImportedLinesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStampPortalCustomDomainLoginRedirectSyncArgs = {
  input: StampPortalCustomDomainLoginRedirectSyncInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartAssignmentTaskArgs = {
  input: StartAssignmentTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartCountSessionArgs = {
  input: StartCountSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartFloatingTimerArgs = {
  input: StartFloatingTimerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartInvoicePayLinkCheckoutArgs = {
  token: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartOrResumeOnboardingJourneyArgs = {
  input: StartOrResumeOnboardingJourneyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartOtaRolloutArgs = {
  input: StartOtaRolloutInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartReapplyRecipesRunArgs = {
  input: ReapplyRecipesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartRestockSessionCreationArgs = {
  input: StartRestockSessionCreationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartTaskArgs = {
  input: StartTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartTaskAssignmentTimerArgs = {
  input: StartTimerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStartTrialArgs = {
  input: StartTrialInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStopContactTextsArgs = {
  input: StopContactTextsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStopFloatingTimerArgs = {
  input: StopFloatingTimerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStopTaskAssignmentTimerArgs = {
  input: StopTimerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStoreRampTokensArgs = {
  input: StoreRampTokensInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationStripRetiredUserRolesArgs = {
  dryRun: Scalars['Boolean']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitContractRecordEnrollmentArgs = {
  input: SubmitContractRecordEnrollmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitDraftProductionLotArgs = {
  input: CreateProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitErpLoadListSessionArgs = {
  input: SubmitErpLoadListSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitFullOrderArgs = {
  input: SubmitFullOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitMigrationPreparedRowPageArgs = {
  input: SubmitMigrationPreparedRowPageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitOnboardingHelpRequestArgs = {
  input: SubmitOnboardingHelpInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitOnboardingParsingSuggestionArgs = {
  input: SubmitOnboardingParsingSuggestionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitOrderVerificationArgs = {
  input: SubmitOrderVerificationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitProducedQuantityForReviewArgs = {
  input: SubmitProducedQuantityForReviewInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitRestockSessionArgs = {
  input: SubmitRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubmitVerifyContainerArgs = {
  input: SubmitVerifyContainerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSubstituteProductionLotCatalogArgs = {
  input: SubstituteProductionLotCatalogInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSwapProductionLotVariantArgs = {
  input: SwapProductionLotVariantInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSynchronizeErpItemPricesArgs = {
  input: SynchronizeErpItemPricingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSynchronizeRestockSessionArgs = {
  input: SynchronizeRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationSynchronizeSalesPeopleArgs = {
  input: SynchronizeSalesPeopleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationTakeLineItemAllocationsArgs = {
  input: TakeLineItemAllocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationToggleCustomerUpgradeDefaultArgs = {
  input: ToggleCustomerUpgradeDefaultInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationToggleItemUpgradeDefaultArgs = {
  input: ToggleItemUpgradeDefaultInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationToggleSftpDestinationArgs = {
  input: ToggleSftpDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationToggleSftpMongoDestinationArgs = {
  input: ToggleSftpMongoDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationTransferInventoryItemArgs = {
  input: TransferInventoryItemCommandInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnassignCountAssignmentArgs = {
  input: UnassignCountAssignmentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnassignMaterialItemToVendorArgs = {
  input: UnassignMaterialItemToVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnassignTaskArgs = {
  input: UnassignTaskInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndeleteItemCharacteristicArgs = {
  input: UndeleteItemCharacteristicInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndeleteItemCharacteristicValueArgs = {
  input: UndeleteItemCharacteristicValueInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndeleteMaterialItemArgs = {
  input: UndeleteMaterialItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndeleteProductionCatalogArgs = {
  input: UndeleteProductionCatalogInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndeleteTagColorArgs = {
  input: UndeleteTagColorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndeleteVendorArgs = {
  input: UndeleteVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndoConsolidationApplicationArgs = {
  input: UndoConsolidationApplicationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndoDeliveryCompletionArgs = {
  input: UndoDeliveryCompletionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndoFernieGapFillArgs = {
  input: UndoFernieGapFillInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndoLoadDispatchArgs = {
  input: UndoLoadDispatchInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUndoRestockSessionOrderQuantityOverrideArgs = {
  input: UndoRestockSessionOrderQuantityOverrideInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnignoreMissingDataArgs = {
  code: Scalars['String']['input'];
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnlinkFusionAuthUserArgs = {
  input: UnlinkFusionAuthUserInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnlinkProductionItemsFromSalesItemArgs = {
  input: UnlinkProductionItemsFromSalesItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnlinkRampBillFromPurchaseOrderArgs = {
  input: UnlinkRampBillFromPurchaseOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnlinkVendorFromRampVendorArgs = {
  input: UnlinkVendorFromRampVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnpinQaTestRunArgs = {
  input: UnpinQaTestRunInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnsetDefaultGroupArgs = {
  input: UnsetDefaultGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnsetDefaultTermsArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnsetRouteDeliveryScheduleArgs = {
  input: UnsetRouteDeliveryScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnshareReportArgs = {
  input: UnshareReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnshipOrderArgs = {
  input: UnshipOrderInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUnsubscribeWhatsNewEmailArgs = {
  input: UnsubscribeWhatsNewEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAcknowledgedQuantityArgs = {
  input: UpdateAcknowledgedQuantityItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAcknowledgmentEmailArgs = {
  input: UpdateAcknowledgmentEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAdminParentCompanyArgs = {
  input: UpdateParentCompanyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAdminTenantOnlineInvoicePaymentsEnabledArgs = {
  input: UpdateOnlineInvoicePaymentsEnabledInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAdminTenantOrganicReceiveModeArgs = {
  input: UpdateOrganicReceiveModeInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAdminTenantRestockProviderSettingsArgs = {
  input: UpdateTenantRestockProviderSettingsInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAdminWorkSuiteProductArgs = {
  input: UpdateWorkSuiteProductInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAllocationTemplateArgs = {
  input: UpdateAllocationTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateAsyncImportJobStatusArgs = {
  input: UpdateAsyncImportJobStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateBillingAddressArgs = {
  input: UpdateBillingAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateBlockingRuleArgs = {
  input: UpdateBlockingRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateBusinessTimeZoneArgs = {
  input: UpdateBusinessTimeZoneInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateConfigCategoryArgs = {
  input: UpdateConfigCategoryInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateConfirmationEmailArgs = {
  input: UpdateConfirmationEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateContainerConfigDetailsArgs = {
  input: UpdateContainerConfigDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerArgs = {
  input: EditCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerGroupArgs = {
  input: UpdateCustomerGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerGroupHoldProductionArgs = {
  input: UpdateCustomerGroupHoldProductionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerItemArgs = {
  input: UpdateCustomerItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerItemAdditionalSkusArgs = {
  input: UpdateCustomerItemAdditionalSkusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerItemAdditionalUpcsArgs = {
  input: UpdateCustomerItemAdditionalUpcsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerLocationOrderAddressEditPermissionsArgs = {
  input: UpdateCustomerLocationOrderAddressEditPermissionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerLocationSendInvoiceEmailsArgs = {
  input: UpdateCustomerLocationSendInvoiceEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerLocationSendOrderEmailsArgs = {
  input: UpdateCustomerLocationSendOrderEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerOrderAddressEditPermissionsArgs = {
  input: UpdateCustomerOrderAddressEditPermissionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerSendInvoiceEmailsArgs = {
  input: UpdateCustomerSendInvoiceEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerSendOrderEmailsArgs = {
  input: UpdateCustomerSendOrderEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerTypeArgs = {
  input: UpdateCustomerTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateCustomerUpgradeArgs = {
  input: UpdateCustomerUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDefaultFreightChargeArgs = {
  input: UpdateDefaultFreightChargeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDefaultMinimumFreightChargeArgs = {
  input: UpdateDefaultMinimumFreightChargeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDefaultOrderSubmitterArgs = {
  input: UpdateDefaultOrderSubmitterInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDefaultWeeksOfSupplyArgs = {
  input: UpdateDefaultWeeksOfSupplyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDeliveryScheduleLocationsArgs = {
  input: UpdateDeliveryScheduleLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateDocumentRenderModeArgs = {
  input: UpdateDocumentRenderModeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpIdArgs = {
  input: UpdateErpIdInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpLoadListQuantitiesArgs = {
  input: UpdateErpLoadListQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpLoadListSessionItemAvailabilityArgs = {
  input: UpdateErpLoadListSessionItemAvailabilityInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpLoadListSessionNameArgs = {
  input: UpdateErpLoadListSessionNameInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpLoadListSessionRoutesArgs = {
  input: UpdateErpLoadListSessionRoutesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpLoadListSessionShipDateArgs = {
  input: UpdateErpLoadListSessionShipDateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateErpManagerEmailsArgs = {
  input: UpdateErpManagerEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateFernieSuggestionsOnArgs = {
  input: UpdateFernieSuggestionsOnInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateFinalCreditEnabledArgs = {
  input: UpdateFinalCreditEnabledInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateFlatChargeTypeArgs = {
  input: UpdateFlatChargeTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateForecastArgs = {
  input: UpdateForecastInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateImportRowImportResultsArgs = {
  input: UpdateImportRowImportResultsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateImportRowValidationResultsArgs = {
  input: UpdateImportRowValidationResultsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateInboundDocumentSettingsArgs = {
  input: UpdateInboundDocumentSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateInvoicingSettingsArgs = {
  input: UpdateInvoicingSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemArgs = {
  input: UpdateItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemAttributesArgs = {
  input: UpdateItemAttributesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemCharacteristicArgs = {
  input: UpdateItemCharacteristicInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemCharacteristicValueArgs = {
  input: UpdateItemCharacteristicValueInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemImageUrlArgs = {
  input: UpdateImageUrlInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemRetailPriceArgs = {
  input: UpdateRetailPriceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateItemUpgradeArgs = {
  input: UpdateItemUpgradeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateKitArgs = {
  input: UpdateKitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLineItemArgs = {
  input: UpdateLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLineItemContextNoteArgs = {
  input: UpdateLineItemContextNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLineItemNoteArgs = {
  input: UpdateLineItemNoteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLineItemsContainerCodeArgs = {
  input: UpdateLineItemsContainerCodeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLocationAddressArgs = {
  input: UpdateLocationAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateLocationNameArgs = {
  input: UpdateLocationNameInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterAcknowledgedQuantityArgs = {
  input: UpdateAcknowledgedQuantityMasterItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterConfirmationEmailArgs = {
  input: UpdateMasterConfirmationEmailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterLineItemArgs = {
  input: UpdateMasterLineItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterOrderContactArgs = {
  input: UpdateMasterOrderContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterOrderStatusArgs = {
  input: UpdateMasterOrderStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMasterSalesPersonArgs = {
  input: UpdateMasterOrderSalesPersonInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMaterialItemDetailsArgs = {
  input: UpdateMaterialItemDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMaxDiscountPercentageArgs = {
  input: UpdateMaxDiscountPercentageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMissingItemGroupsArgs = {
  input: UpdateMissingItemGroupsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateMissingMasterItemGroupsArgs = {
  input: UpdateMissingMasterItemGroupsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderAcknowledgementReportArgs = {
  input: UpdateOrderAcknowledgementReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderAddressEditPermissionsArgs = {
  input: UpdateOrderAddressEditPermissionsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderBillingAddressArgs = {
  input: UpdateOrderBillingAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderContactArgs = {
  input: UpdateOrderContactInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderDeliveryDateArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  input: UpdateOrderDeliveryDateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderInvoiceReportArgs = {
  input: UpdateOrderInvoiceReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderLocationAddressArgs = {
  input: UpdateOrderLocationAddressInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderProFormaReportArgs = {
  input: UpdateOrderProFormaReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderPullSlipReportArgs = {
  input: UpdateOrderPullSlipReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderRouteArgs = {
  input: UpdateRouteInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderSendInvoiceEmailsArgs = {
  input: UpdateOrderSendInvoiceEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderSendOrderEmailsArgs = {
  input: UpdateOrderSendOrderEmailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderStatusArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  input: UpdateOrderStatusInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrderSyncAttemptArgs = {
  input: UpdateSyncAttemptInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateOrganicReceiveModeArgs = {
  input: UpdateOrganicReceiveModeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePaymentProcessorArgs = {
  input: UpdatePaymentProcessorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePoNumberMaxLengthArgs = {
  input: UpdatePoNumberMaxLengthInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePortalSettingsArgs = {
  input: UpdatePortalSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePriceGroupArgs = {
  input: UpdatePriceGroupInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePriceLevelsArgs = {
  input: UpdatePriceLevelsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePricingCalcDecimalsArgs = {
  input: UpdatePricingCalcDecimalsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProduceAutoLinkMatchingNumbersArgs = {
  input: UpdateProduceAutoLinkMatchingNumbersInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProduceDefaultReliefPercentArgs = {
  input: UpdateProduceDefaultReliefPercentInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProduceEnabledArgs = {
  input: UpdateProduceEnabledInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProducePlanFromOrderAccessArgs = {
  input: UpdateProducePlanFromOrderAccessInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProducePlanningEntryUnitArgs = {
  input: UpdateProducePlanningEntryUnitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProduceProductionEntryReviewArgs = {
  input: UpdateProduceProductionEntryReviewInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProduceQuantityDecimalsArgs = {
  input: UpdateProduceQuantityDecimalsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProduceRoundingArgs = {
  input: UpdateProduceRoundingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProduceSpaceConsumptionBasisArgs = {
  input: UpdateProduceSpaceConsumptionBasisInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProduceSpacingDimensionUnitArgs = {
  input: UpdateProduceSpacingDimensionUnitInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProduceWeekDisplayAnchorArgs = {
  input: UpdateProduceWeekDisplayAnchorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionCatalogArgs = {
  input: UpdateProductionCatalogInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionCategoryDetailsArgs = {
  input: UpdateProductionCategoryDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionItemArgs = {
  input: UpdateProductionItemInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionJobLocationArgs = {
  input: UpdateProductionJobLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionLineArgs = {
  input: UpdateProductionLineInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionLotAsyncImportJobRowsArgs = {
  input: UpdateProductionLotAsyncImportJobRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionLotCustomerArgs = {
  input: UpdateProductionLotCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionLotPlanArgs = {
  input: UpdateProductionLotPlanInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionMaterialEventArgs = {
  input: UpdateProductionMaterialEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionMaterialEventDetailArgs = {
  input: UpdateProductionMaterialEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionPlanDetailsArgs = {
  input: UpdateProductionPlanDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionRecipeVariationArgs = {
  input: UpdateProductionRecipeVariationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionRecipeVariationFieldsArgs = {
  input: UpdateProductionRecipeVariationFieldsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionSpaceCategoryDetailsArgs = {
  input: UpdateProductionSpaceCategoryDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionSpaceEventArgs = {
  input: UpdateProductionSpaceEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionSpaceEventDetailArgs = {
  input: UpdateProductionSpaceEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionSpaceTypeDetailsArgs = {
  input: UpdateProductionSpaceTypeDetailsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionTaskEventArgs = {
  input: UpdateProductionTaskEventInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionTaskEventAssigneeArgs = {
  input: UpdateProductionTaskEventAssigneeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionTaskEventDetailArgs = {
  input: UpdateProductionTaskEventDetailInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateProductionTriggerArgs = {
  input: UpdateProductionTriggerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePromotionRuleArgs = {
  input: UpdatePromotionRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePublicScoreArgs = {
  increment: Scalars['Int']['input'];
  taskId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdatePurchaseOrderReportArgs = {
  input: UpdatePurchaseOrderReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateReportScheduleArgs = {
  input: UpdateReportScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateReportTemplateArgs = {
  input: UpdateReportTemplateInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateReserveRuleArgs = {
  input: UpdateReserveRuleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateRestockSessionArgs = {
  input: UpdateRestockSessionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateRestockSessionOrderQuantitiesArgs = {
  input: UpdateRestockSessionOrderQuantitiesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateRestockSessionReserveRulesArgs = {
  input: UpdateRestockSessionReserveRulesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSalesPersonArgs = {
  input: UpdateSalesPersonInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpAggregationConfigArgs = {
  input: UpdateSftpAggregationConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpDestinationArgs = {
  input: UpdateSftpDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpMongoColumnMapsArgs = {
  input: UpdateSftpMongoColumnMapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpMongoDestinationArgs = {
  input: UpdateSftpMongoDestinationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpSqlColumnMapsArgs = {
  input: UpdateSftpSqlColumnMapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpSystemSettingsArgs = {
  input: UpdateSftpSystemSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSftpTenantConfigArgs = {
  input: UpdateSftpTenantConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateShippedQuantityArgs = {
  input: UpdateShippedQuantityItemsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSiteLocationAsyncImportJobRowsArgs = {
  input: UpdateSiteLocationAsyncImportJobRowsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSiteMapArgs = {
  input: UpdateSiteMapInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSizeUomArgs = {
  input: UpdateSizeUomInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateStatementDeliverySettingsArgs = {
  input: UpdateStatementDeliverySettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateStockByCustomerItemSettingsArgs = {
  input: UpdateStockByCustomerItemSettingsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSubLocationArgs = {
  input: UpdateSubLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateSubscriptionArgs = {
  frequency: BillingFrequency;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTagColorArgs = {
  input: UpdateTagColorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTaskEventTypeArgs = {
  input: UpdateTaskEventTypeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantAutoAllocateExcludedGradesArgs = {
  input: UpdateTenantAutoAllocateExcludedGradesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantBrandingArgs = {
  input: UpdateTenantBrandingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantCompanyProfileArgs = {
  input: UpdateTenantCompanyProfileInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantGradeLabelsArgs = {
  input: UpdateTenantGradeLabelsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantOrderEmailsEnabledArgs = {
  input: UpdateOrderEmailsEnabledInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantSignInPanelArgs = {
  input: UpdateTenantSignInPanelInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTenantUnitConfigArgs = {
  input: UpdateTenantUnitConfigInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTermsArgs = {
  input: UpdateTermsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTermsIdArgs = {
  input: UpdateTermsIdInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateTrackShipmentWeightArgs = {
  input: UpdateTrackShipmentWeightInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateUseErpPricingArgs = {
  input: UpdateUseErpPricingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateUserAppSettingArgs = {
  input: UpdateUserAppSettingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateUserFullNameArgs = {
  input: UpdateUserFullNameInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateUserRolesArgs = {
  input: UpdateUserRolesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateVendorArgs = {
  input: UpdateVendorInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateVendorPurchaseOrderMetadataArgs = {
  input: UpdateVendorPurchaseOrderMetadataInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateVendorPurchaseOrderSiteLocationArgs = {
  input: UpdateVendorPurchaseOrderSiteLocationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateVerifyModeArgs = {
  input: UpdateVerifyModeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateWsapiImportEntityMappingArgs = {
  input: UpdateWsapiImportEntityMappingInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpdateWsapiImportScheduleArgs = {
  input: UpdateWsapiImportScheduleInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUploadItemImageArgs = {
  input: UploadItemImageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertAdminTenantIntegrationArgs = {
  input: UpsertTenantIntegrationInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertAdminTenantPricingPageArgs = {
  input: AdminTenantPricingPageUpsertInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertBillingAddressesArgs = {
  input: UpsertBillingAddressesInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertContactsArgs = {
  input: UpsertContactsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertCustomerArgs = {
  input: UpsertCustomerInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertLocationsArgs = {
  input: UpsertLocationsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertMergeCrmTenantIntegrationArgs = {
  input: UpsertMergeCrmTenantIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertMergeTenantIntegrationArgs = {
  input: UpsertMergeTenantIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertMySqlAdminTenantIntegrationArgs = {
  input: UpsertMySqlTenantIntegrationInput;
  tenantId: Scalars['String']['input'];
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertMySqlTenantIntegrationArgs = {
  input: UpsertMySqlTenantIntegrationInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertRampBillsArgs = {
  input: UpsertRampBillsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertRampVendorsArgs = {
  input: UpsertRampVendorsInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertRfidScansArgs = {
  input: Array<RfidScanInputDataInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertTenantPricingPageArgs = {
  input: UpsertTenantPricingPageInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertTimeEntriesArgs = {
  input: Array<UpsertTimeEntryInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationUpsertTrialPolicyArgs = {
  input: UpsertTrialPolicyInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateCategoryDocumentsArgs = {
  input: Array<MergeCategoryInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateCustomerDocumentsArgs = {
  input: Array<ImportCustomerInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateHistoricalInvoicesArgs = {
  input: Array<ImportHistoricalInvoiceInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateHistoricalOrderDocumentsArgs = {
  input: Array<ImportHistoricalOrderInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateHistoricalOrdersArgs = {
  input: Array<ImportHistoricalOrderInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateInventoryItemDocumentsArgs = {
  input: Array<SetInventoryItemInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateItemsDocumentsArgs = {
  input: Array<ImportItemInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidatePriceGroupDocumentsArgs = {
  input: Array<ImportPriceGroupInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateProductionLotArgs = {
  input: CreateProductionLotInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateSiteLocationsDocumentsArgs = {
  input: Array<MergeSiteLocationInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationValidateTermsDocumentsArgs = {
  input: Array<ImportTermsInput>;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationVerifyPortalCustomDomainArgs = {
  input: VerifyPortalCustomDomainInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationVerifyTenantSmtpConnectionArgs = {
  input: VerifyTenantSmtpConnectionInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationVoidContractRecordFeeArgs = {
  input: VoidContractRecordFeeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationVoidInvoiceArgs = {
  input: VoidInvoiceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationVoidMaterialPriceArgs = {
  input: VoidMaterialPriceInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationWaiveInvoiceLateChargeArgs = {
  input: WaiveInvoiceLateChargeInput;
};


/**
 * GraphQL mutation surface for the CRM export outbox. The single entry point,
 * batchUpdateCrmExportStatuses, mirrors batchUpdateMergeDevExportStatuses in
 * shape (per-row, exactly-one-outcome, per-row error isolation) and authorization (gated to
 * Policies.WorkerService — the wsapi-services worker authenticates with a service-account
 * JWT carrying the workerservice role, the tier established for outbound-export worker
 * surfaces by setCustomerCrmLink).
 */
export type MutationWithdrawMigrationSettingsRevisionArgs = {
  input: WithdrawMigrationSettingsRevisionInput;
};

/** A connection to a list of items. */
export type MyAssignedCountTasksConnection = {
  __typename?: 'MyAssignedCountTasksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyAssignedCountTasksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MyCountTaskDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyAssignedCountTasksEdge = {
  __typename?: 'MyAssignedCountTasksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MyCountTaskDocument;
};

/**
 * Read model for the Material mobile G5 "my tasks" view: one document per
 * (tenant, assignment, task) — equivalently one per (WorkerUserId × TaskId)
 * since each TaskId belongs to exactly one assignment with one worker. Projected from
 * CycleCountAssignment.V1.* events (HGI-09). The projection performs absolute upserts
 * only — no reads, no relative operators (atlas standard
 * accaf08f270b40efa04fbbcdd605fc1c).
 */
export type MyCountTaskDocument = {
  __typename?: 'MyCountTaskDocument';
  assignmentId: Scalars['String']['output'];
  binLocationId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedQty?: Maybe<Scalars['Decimal']['output']>;
  dueBy: Scalars['DateTime']['output'];
  expectedQty: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  lastEventAt: Scalars['DateTime']['output'];
  materialItemId: Scalars['String']['output'];
  overrideQty?: Maybe<Scalars['Decimal']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CycleCountTaskStatus;
  taskId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  varianceReasonCode?: Maybe<Scalars['Int']['output']>;
  workerUserId: Scalars['String']['output'];
};

/**
 * Read model for the Material mobile G5 "my tasks" view: one document per
 * (tenant, assignment, task) — equivalently one per (WorkerUserId × TaskId)
 * since each TaskId belongs to exactly one assignment with one worker. Projected from
 * CycleCountAssignment.V1.* events (HGI-09). The projection performs absolute upserts
 * only — no reads, no relative operators (atlas standard
 * accaf08f270b40efa04fbbcdd605fc1c).
 */
export type MyCountTaskDocumentFilterInput = {
  and?: InputMaybe<Array<MyCountTaskDocumentFilterInput>>;
  assignmentId?: InputMaybe<StringOperationFilterInput>;
  binLocationId?: InputMaybe<StringOperationFilterInput>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  completedQty?: InputMaybe<DecimalOperationFilterInput>;
  dueBy?: InputMaybe<DateTimeOperationFilterInput>;
  expectedQty?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastEventAt?: InputMaybe<DateTimeOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MyCountTaskDocumentFilterInput>>;
  overrideQty?: InputMaybe<DecimalOperationFilterInput>;
  skipReason?: InputMaybe<StringOperationFilterInput>;
  skippedAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<CycleCountTaskStatusOperationFilterInput>;
  taskId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  varianceReasonCode?: InputMaybe<IntOperationFilterInput>;
  workerUserId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read model for the Material mobile G5 "my tasks" view: one document per
 * (tenant, assignment, task) — equivalently one per (WorkerUserId × TaskId)
 * since each TaskId belongs to exactly one assignment with one worker. Projected from
 * CycleCountAssignment.V1.* events (HGI-09). The projection performs absolute upserts
 * only — no reads, no relative operators (atlas standard
 * accaf08f270b40efa04fbbcdd605fc1c).
 */
export type MyCountTaskDocumentSortInput = {
  assignmentId?: InputMaybe<SortEnumType>;
  binLocationId?: InputMaybe<SortEnumType>;
  completedAt?: InputMaybe<SortEnumType>;
  completedQty?: InputMaybe<SortEnumType>;
  dueBy?: InputMaybe<SortEnumType>;
  expectedQty?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastEventAt?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  overrideQty?: InputMaybe<SortEnumType>;
  skipReason?: InputMaybe<SortEnumType>;
  skippedAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  varianceReasonCode?: InputMaybe<SortEnumType>;
  workerUserId?: InputMaybe<SortEnumType>;
};

/** The caller's own two-step-verification state, as FusionAuth reports it right now. */
export type MyMultiFactorStatus = {
  __typename?: 'MyMultiFactorStatus';
  /**
   * The FusionAuth application this answer is scoped to — the second half of the feature's
   * (tenant, application) key. Reported so a client never has to infer which surface it asked about.
   */
  applicationId: Scalars['String']['output'];
  /** Whether any method is currently enabled. */
  enabled: Scalars['Boolean']['output'];
  /**
   * The instant mfaEnrollmentBlocking becomes true. null whenever
   * mfaEnrollmentRequired is false.
   */
  graceDeadline?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The enabled method names. Today either empty or ["authenticator"]: the deployed FusionAuth
   * Community edition offers no other factor.
   */
  methods: Array<Scalars['String']['output']>;
  /**
   * Whether mfaEnrollmentRequired has moved from advisory to blocking at the application
   * boundary: graceDeadline has passed.
   */
  mfaEnrollmentBlocking: Scalars['Boolean']['output'];
  /**
   * The step-up signal: whether the caller's tenant requires two-step verification for this
   * application and the caller holds no enrolled method. Always false once enabled is
   * true — an enrolled caller needs nothing here.
   */
  mfaEnrollmentRequired: Scalars['Boolean']['output'];
};

/** Reports the caller's current two-step-verification state, or why it could not be read. */
export type MyMultiFactorStatusPayload = {
  __typename?: 'MyMultiFactorStatusPayload';
  errors?: Maybe<Array<ValidationError>>;
  status?: Maybe<MyMultiFactorStatus>;
};

/** A connection to a list of items. */
export type MyNotificationsConnection = {
  __typename?: 'MyNotificationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyNotificationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<NotificationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyNotificationsEdge = {
  __typename?: 'MyNotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NotificationDocument;
};

/**
 * The parent company the calling user administers: the group of tenants they may move their own staff
 * between, the other administrators of that group, and every directory entry that exists across its
 * member tenants.
 */
export type MyParentCompany = {
  __typename?: 'MyParentCompany';
  administrators: Array<MyParentCompanyAdministrator>;
  /** Every directory entry across the member tenants, active and inactive alike, ordered by tenant then email. Inactive entries are included so access that has been revoked stays visible and can be restored. */
  members: Array<MyParentCompanyMember>;
  name: Scalars['String']['output'];
  parentCompanyId: Scalars['String']['output'];
  /** Derived lifecycle. ACTIVE when the parent company groups at least two member tenants AND has at least one administrator; INACTIVE otherwise. Never stored — computed per request from the current member-tenant and administrator counts, so it can never be stale. Access can only be granted or revoked across an ACTIVE parent company. */
  status: ParentCompanyStatus;
  /** The tenants that belong to this parent company, by name. Membership is a field on the TENANT, so this is read at query time rather than projected onto the parent company. */
  tenants: Array<MyParentCompanyTenant>;
};

/**
 * One administrator of the parent company — a person who may grant and revoke access across the
 * group's member tenants. Identified by their login id; the email is for display.
 */
export type MyParentCompanyAdministrator = {
  __typename?: 'MyParentCompanyAdministrator';
  email: Scalars['String']['output'];
  fusionAuthUserId: Scalars['String']['output'];
};

/**
 * One directory entry in one of the parent company's member tenants. Inactive entries are included as
 * well as active ones, so revoked access stays visible rather than simply disappearing.
 */
export type MyParentCompanyMember = {
  __typename?: 'MyParentCompanyMember';
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  fusionAuthUserId?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** A tenant belonging to the parent company. */
export type MyParentCompanyTenant = {
  __typename?: 'MyParentCompanyTenant';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type MyTaskAssignmentsConnection = {
  __typename?: 'MyTaskAssignmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyTaskAssignmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TaskAssignmentDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyTaskAssignmentsEdge = {
  __typename?: 'MyTaskAssignmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaskAssignmentDocument;
};

/** A tenant the caller may work in. */
export type MyTenant = {
  __typename?: 'MyTenant';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** One requested line's price. */
export type NewOrderLinePrice = {
  __typename?: 'NewOrderLinePrice';
  /** The caller's key. */
  key: Scalars['String']['output'];
  /** The unit price the order will be charged: 0 when the winning price is $0; none when nothing resolves or the line carries an override price. */
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
};

/** One line of an order pricesForNewOrderLines is asked to price. */
export type NewOrderLinePricingDataInput = {
  /** The line's quantity in eaches; its basis in the pool. */
  eaches: Scalars['Decimal']['input'];
  /** True when the line will carry an override price: it counts toward its pool but is not priced. */
  hasOverridePrice: Scalars['Boolean']['input'];
  /** The item to price. */
  itemId: Scalars['String']['input'];
  /** The caller's key, echoed back so the answer can be matched to its row. */
  key: Scalars['String']['input'];
};

/** The prices of one requested order's lines, in request order. */
export type NewOrderPrices = {
  __typename?: 'NewOrderPrices';
  /** One entry per requested line. */
  lines: Array<NewOrderLinePrice>;
};

/** One order that does not exist yet, as pricesForNewOrderLines is asked to price it. */
export type NewOrderPricingDataInput = {
  /** The ORDER's customer; its disabled volume pools govern every line. */
  customerId: Scalars['String']['input'];
  /** The ship-to location; drives the price-group hierarchy. */
  customerLocationId: Scalars['UUID']['input'];
  /** The date the order will carry; the reprice date and the requested ship date. */
  expectedDeliveryDate: Scalars['DateTime']['input'];
  /** The order's lines. */
  lines: Array<NewOrderLinePricingDataInput>;
};

export type NextOrderNumberPayload = {
  __typename?: 'NextOrderNumberPayload';
  nextOrderNumber: Scalars['Long']['output'];
};

export enum NoteContext {
  General = 'GENERAL',
  Pull = 'PULL',
  Ship = 'SHIP'
}

export type NoteContextOperationFilterInput = {
  eq?: InputMaybe<NoteContext>;
  in?: InputMaybe<Array<NoteContext>>;
  neq?: InputMaybe<NoteContext>;
  nin?: InputMaybe<Array<NoteContext>>;
};

export type NoteData = {
  __typename?: 'NoteData';
  id: Scalars['String']['output'];
  noteText: Scalars['String']['output'];
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
};

export type NoteDataInput = {
  id: Scalars['String']['input'];
  noteText: Scalars['String']['input'];
  submitDate: Scalars['DateTime']['input'];
  submittedBy: Scalars['String']['input'];
};

export enum NotificationChannel {
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Push = 'PUSH',
  Sms = 'SMS'
}

/**
 * One message the dispatch worker should now send, and everything it needs to send it without
 * reading anything else.
 */
export type NotificationDeliveryClaimData = {
  __typename?: 'NotificationDeliveryClaimData';
  /**
   * Where to send it on a channel with ONE address per recipient: the mailbox for email. Empty for
   * push, where a recipient is reached through every device they have enrolled — see
   * Subscriptions.
   */
  channelAddress: Scalars['String']['output'];
  /** Whether this claim is one notification or a day's worth. */
  deliveryMode: NotificationDeliveryMode;
  /** Their display name, for the greeting. */
  fullName: Scalars['String']['output'];
  /** Which language to render the copy in. */
  languagePreference: LanguagePreference;
  /** The rows to render, oldest first. Each is leased to the caller. */
  notifications: Array<NotificationDocument>;
  /** Who this message is for, normalised — the key the rows are addressed under. */
  recipientEmail: Scalars['String']['output'];
  /**
   * The recipient's enrolled devices, oldest first, for a channel addressed through them; empty for
   * every other channel. A push claim always carries at least one — a recipient with none is skipped
   * rather than claimed, since there is nothing to send to. The worker sends this message to each in
   * turn and prunes the ones the push service reports gone, through
   * removePushSubscriptionForWorker.
   */
  subscriptions: Array<PushSubscriptionDocument>;
};

/**
 * Result of a claim: the messages this worker now holds a lease on. An empty list is the ordinary
 * answer — it means there is nothing to send, not that anything went wrong.
 */
export type NotificationDeliveryClaimPayload = {
  __typename?: 'NotificationDeliveryClaimPayload';
  /** One entry per message to send. */
  claims: Array<NotificationDeliveryClaimData>;
  /** Populated only when the claim itself failed. */
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * The per-channel delivery block of a notification. One sub-document per channel rather than one
 * status for the row, because the channels succeed and fail independently — an email that bounced
 * must not mark the SMS unsent.
 *
 * In-app has no entry: for that channel the row IS the delivery, and its read state is
 * readAt.
 */
export type NotificationDeliveryData = {
  __typename?: 'NotificationDeliveryData';
  /** Email delivery state. */
  email: ChannelDeliveryData;
  /** Web Push delivery state. */
  push: ChannelDeliveryData;
  /** SMS delivery state. */
  sms: ChannelDeliveryData;
};

export enum NotificationDeliveryMode {
  DailyDigest = 'DAILY_DIGEST',
  Immediate = 'IMMEDIATE'
}

export type NotificationDeliveryModeOperationFilterInput = {
  eq?: InputMaybe<NotificationDeliveryMode>;
  in?: InputMaybe<Array<NotificationDeliveryMode>>;
  neq?: InputMaybe<NotificationDeliveryMode>;
  nin?: InputMaybe<Array<NotificationDeliveryMode>>;
};

/**
 * Result of recording a delivery outcome: the row as it now stands, so the worker can see whether
 * its failure bought a retry or spent the last attempt.
 */
export type NotificationDeliveryPayload = {
  __typename?: 'NotificationDeliveryPayload';
  /** Populated when the row was not leased to a worker, or does not exist. */
  errors?: Maybe<Array<ValidationError>>;
  /** The row as it now stands. */
  notification?: Maybe<NotificationDocument>;
};

export enum NotificationDeliveryStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sending = 'SENDING',
  Sent = 'SENT',
  Skipped = 'SKIPPED',
  Suppressed = 'SUPPRESSED'
}

/**
 * One notification, addressed to one recipient, produced by one source event. It is what the bell
 * counts, what the /notifications page lists, and what the channel dispatch worker sends
 * from.
 */
export type NotificationDocument = {
  __typename?: 'NotificationDocument';
  /**
   * Who caused the event, or null when the write carried no authenticated user. Kept
   * beside fields because it is also the skip rule: the projection never tells someone
   * about their own action.
   */
  actorEmail?: Maybe<Scalars['String']['output']>;
  /**
   * When the source event was written — the event's own created date, never the projection's clock, so
   * a rebuild reproduces the original ordering rather than stamping everything with the replay time.
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Per-channel send state, owned by the wsapi-services dispatch worker. Reserved by this slice: the
   * projection stamps the initial status on insert and nothing else writes here yet.
   */
  delivery: NotificationDeliveryData;
  /** Which entity of that type the notification is about — the other half of the deep link. */
  entityId: Scalars['String']['output'];
  /**
   * What kind of thing the notification is about — Order for every kind in this slice.
   * Pairs with entityId to say which one. The client builds its deep link from the pair
   * rather than from a URL stored here, so a route change is a client-side edit and not a
   * read-model migration.
   */
  entityType: Scalars['String']['output'];
  /**
   * Display inputs for the rendered title and body — orderNumber, customerName, and
   * actorName when the event named an actor. Values only, never a pre-rendered sentence: the
   * wording lives in the client so it can be changed or localised without a rebuild, and never free
   * text, so a row cannot carry anything a user typed.
   *
   * actorName currently holds the actor's EMAIL ADDRESS, not a display name: the
   * projection builds a row purely from the carrying event and may not read the user directory,
   * and the event carries only the address today. Render it as an address.
   */
  fields: Array<KeyValuePairOfStringAndString>;
  /**
   * The row's identifier, and the handle a client passes back to the mark-read and mark-unread
   * mutations. Stable for the life of the row: the same source event always addresses the same
   * document, so a replay rewrites this row rather than adding a second one.
   */
  id: Scalars['String']['output'];
  /** What happened. Persisted as the INTEGER ordinal — see NotificationKind. */
  kind: NotificationKind;
  /**
   * The product module this row belongs to ("Fulfill" for every kind in this slice). Drives the
   * icon the bell renders and the module filter the notifications page will offer.
   */
  module: Scalars['String']['output'];
  /** When the recipient read this row; null means unread, which is what the badge counts. */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Who this row is for: their email address, lowercased and whitespace-stripped once by the
   * projection, so the same person never accumulates rows under two casings.
   */
  recipientEmail: Scalars['String']['output'];
  /** The KurrentDB event id this row was built from. Half the id, and the support trail back to the stream. */
  sourceEventId: Scalars['String']['output'];
  /** The event type name this row was built from, for the same support trail. */
  sourceEventType: Scalars['String']['output'];
  /** The owning tenant, from ValidEntity.FromStreamId. Every read filters on it. */
  tenantId: Scalars['String']['output'];
};

/**
 * One notification, addressed to one recipient, produced by one source event. It is what the bell
 * counts, what the /notifications page lists, and what the channel dispatch worker sends
 * from.
 */
export type NotificationDocumentFilterInput = {
  /**
   * Who caused the event, or null when the write carried no authenticated user. Kept
   * beside fields because it is also the skip rule: the projection never tells someone
   * about their own action.
   */
  actorEmail?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<NotificationDocumentFilterInput>>;
  /** Which entity of that type the notification is about — the other half of the deep link. */
  entityId?: InputMaybe<StringOperationFilterInput>;
  /**
   * What kind of thing the notification is about — Order for every kind in this slice.
   * Pairs with entityId to say which one. The client builds its deep link from the pair
   * rather than from a URL stored here, so a route change is a client-side edit and not a
   * read-model migration.
   */
  entityType?: InputMaybe<StringOperationFilterInput>;
  /**
   * The row's identifier, and the handle a client passes back to the mark-read and mark-unread
   * mutations. Stable for the life of the row: the same source event always addresses the same
   * document, so a replay rewrites this row rather than adding a second one.
   */
  id?: InputMaybe<StringOperationFilterInput>;
  /** What happened. Persisted as the INTEGER ordinal — see NotificationKind. */
  kind?: InputMaybe<NotificationKindOperationFilterInput>;
  /**
   * The product module this row belongs to ("Fulfill" for every kind in this slice). Drives the
   * icon the bell renders and the module filter the notifications page will offer.
   */
  module?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NotificationDocumentFilterInput>>;
  /** The KurrentDB event id this row was built from. Half the id, and the support trail back to the stream. */
  sourceEventId?: InputMaybe<StringOperationFilterInput>;
  /** The event type name this row was built from, for the same support trail. */
  sourceEventType?: InputMaybe<StringOperationFilterInput>;
};

export enum NotificationDocumentKind {
  Acknowledgement = 'ACKNOWLEDGEMENT',
  Invoice = 'INVOICE',
  PullSlip = 'PULL_SLIP'
}

/** One document kind bound to a report at this scope. */
export type NotificationDocumentReportEntryData = {
  __typename?: 'NotificationDocumentReportEntryData';
  kind: NotificationDocumentKind;
  reportId: Scalars['String']['output'];
};

/** One document kind bound to a report at this scope. */
export type NotificationDocumentReportEntryDocument = {
  __typename?: 'NotificationDocumentReportEntryDocument';
  kind: NotificationDocumentKind;
  reportId: Scalars['String']['output'];
};

/** One order document's report binding as it applies to a customer. */
export type NotificationDocumentSettingsData = {
  __typename?: 'NotificationDocumentSettingsData';
  /** The customer's override, or None when the customer follows the tenant. */
  customerReportId?: Maybe<Scalars['String']['output']>;
  /** The report this customer's orders render with. */
  effectiveReportId: Scalars['String']['output'];
  /** The document kind. */
  kind: NotificationDocumentKind;
  /** The report the tenant renders this document with (its binding, else the seeded default). */
  tenantReportId: Scalars['String']['output'];
};

/**
 * One notification, addressed to one recipient, produced by one source event. It is what the bell
 * counts, what the /notifications page lists, and what the channel dispatch worker sends
 * from.
 */
export type NotificationDocumentSortInput = {
  /**
   * Who caused the event, or null when the write carried no authenticated user. Kept
   * beside fields because it is also the skip rule: the projection never tells someone
   * about their own action.
   */
  actorEmail?: InputMaybe<SortEnumType>;
  /**
   * When the source event was written — the event's own created date, never the projection's clock, so
   * a rebuild reproduces the original ordering rather than stamping everything with the replay time.
   */
  createdAt?: InputMaybe<SortEnumType>;
  /** Which entity of that type the notification is about — the other half of the deep link. */
  entityId?: InputMaybe<SortEnumType>;
  /**
   * What kind of thing the notification is about — Order for every kind in this slice.
   * Pairs with entityId to say which one. The client builds its deep link from the pair
   * rather than from a URL stored here, so a route change is a client-side edit and not a
   * read-model migration.
   */
  entityType?: InputMaybe<SortEnumType>;
  /**
   * The row's identifier, and the handle a client passes back to the mark-read and mark-unread
   * mutations. Stable for the life of the row: the same source event always addresses the same
   * document, so a replay rewrites this row rather than adding a second one.
   */
  id?: InputMaybe<SortEnumType>;
  /** What happened. Persisted as the INTEGER ordinal — see NotificationKind. */
  kind?: InputMaybe<SortEnumType>;
  /**
   * The product module this row belongs to ("Fulfill" for every kind in this slice). Drives the
   * icon the bell renders and the module filter the notifications page will offer.
   */
  module?: InputMaybe<SortEnumType>;
  /** When the recipient read this row; null means unread, which is what the badge counts. */
  readAt?: InputMaybe<SortEnumType>;
  /** The KurrentDB event id this row was built from. Half the id, and the support trail back to the stream. */
  sourceEventId?: InputMaybe<SortEnumType>;
  /** The event type name this row was built from, for the same support trail. */
  sourceEventType?: InputMaybe<SortEnumType>;
};

export type NotificationExcludedMobileData = {
  __typename?: 'NotificationExcludedMobileData';
  contactId: Scalars['UUID']['output'];
  phoneNumber: Scalars['String']['output'];
};

/** One mobile that gets no text of a kind at this scope. */
export type NotificationExcludedMobileDocument = {
  __typename?: 'NotificationExcludedMobileDocument';
  contactId: Scalars['UUID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type NotificationExcludedMobileInput = {
  contactId: Scalars['UUID']['input'];
  /** E.164. */
  phoneNumber: Scalars['String']['input'];
};

/** One key/value pair of a RaiseNotificationInput's fields. */
export type NotificationFieldInput = {
  /** The field name, as the client's copy table keys on. */
  key: Scalars['String']['input'];
  /** The field value — a display input only, never free text. */
  value: Scalars['String']['input'];
};

export enum NotificationKind {
  CustomerDetailsChangedInPortal = 'CUSTOMER_DETAILS_CHANGED_IN_PORTAL',
  CustomerSalespersonAdded = 'CUSTOMER_SALESPERSON_ADDED',
  InboundDocumentReceived = 'INBOUND_DOCUMENT_RECEIVED',
  LearningEscalation = 'LEARNING_ESCALATION',
  LearningNudge = 'LEARNING_NUDGE',
  MigrationStatus = 'MIGRATION_STATUS',
  MultiFactorDisabled = 'MULTI_FACTOR_DISABLED',
  MultiFactorEnrolled = 'MULTI_FACTOR_ENROLLED',
  OnboardingFileImported = 'ONBOARDING_FILE_IMPORTED',
  OrderAcknowledged = 'ORDER_ACKNOWLEDGED',
  OrderAcknowledgedQuantityCorrected = 'ORDER_ACKNOWLEDGED_QUANTITY_CORRECTED',
  OrderAssignedToYou = 'ORDER_ASSIGNED_TO_YOU',
  OrderCancelled = 'ORDER_CANCELLED',
  OrderEmailBounced = 'ORDER_EMAIL_BOUNCED',
  OrderErpSyncFailed = 'ORDER_ERP_SYNC_FAILED',
  OrderShipped = 'ORDER_SHIPPED',
  OrderSubmitted = 'ORDER_SUBMITTED',
  OrderVerificationVariance = 'ORDER_VERIFICATION_VARIANCE',
  PhoneVerificationCode = 'PHONE_VERIFICATION_CODE',
  ProductionTriggerReminder = 'PRODUCTION_TRIGGER_REMINDER',
  ReportRunFailed = 'REPORT_RUN_FAILED',
  ReportRunSucceeded = 'REPORT_RUN_SUCCEEDED',
  ScheduledTransferExecuted = 'SCHEDULED_TRANSFER_EXECUTED',
  ScheduledTransferNotExecuted = 'SCHEDULED_TRANSFER_NOT_EXECUTED',
  SmsEnrollmentConfirmed = 'SMS_ENROLLMENT_CONFIRMED',
  TaskCancelled = 'TASK_CANCELLED',
  TaskReassignedToYou = 'TASK_REASSIGNED_TO_YOU'
}

export type NotificationKindOperationFilterInput = {
  eq?: InputMaybe<NotificationKind>;
  in?: InputMaybe<Array<NotificationKind>>;
  neq?: InputMaybe<NotificationKind>;
  nin?: InputMaybe<Array<NotificationKind>>;
};

export type NotificationKindPreferenceData = {
  __typename?: 'NotificationKindPreferenceData';
  email: Scalars['Boolean']['output'];
  inApp: Scalars['Boolean']['output'];
  kind: NotificationKind;
  push: Scalars['Boolean']['output'];
  sms: Scalars['Boolean']['output'];
};

export type NotificationKindPreferenceDataFilterInput = {
  and?: InputMaybe<Array<NotificationKindPreferenceDataFilterInput>>;
  email?: InputMaybe<BooleanOperationFilterInput>;
  inApp?: InputMaybe<BooleanOperationFilterInput>;
  kind?: InputMaybe<NotificationKindOperationFilterInput>;
  or?: InputMaybe<Array<NotificationKindPreferenceDataFilterInput>>;
  push?: InputMaybe<BooleanOperationFilterInput>;
  sms?: InputMaybe<BooleanOperationFilterInput>;
};

export type NotificationKindPreferenceInputDataInput = {
  email: Scalars['Boolean']['input'];
  inApp: Scalars['Boolean']['input'];
  kind: NotificationKind;
  push: Scalars['Boolean']['input'];
  sms: Scalars['Boolean']['input'];
};

/**
 * One notification kind as it applies to a customer (or an order): the tenant catalog's state, the
 * override in force at this scope, and the recipients that result.
 */
export type NotificationKindSettingsData = {
  __typename?: 'NotificationKindSettingsData';
  /** The delivery channel the tenant catalog holds for this kind. */
  channel: OrderEmailChannel;
  /** Addresses the customer adds. */
  customerAdditionalEmails: Array<Scalars['String']['output']>;
  /** Derived addresses the customer leaves out. */
  customerExcludedEmails: Array<Scalars['String']['output']>;
  customerExcludedMobiles: Array<NotificationExcludedMobileData>;
  /** The customer's send choice for this kind (Inherit when unset). */
  customerSendChoice: NotificationSendChoice;
  /** Why the derived list is empty, when it is. */
  derivedFallbackReason: CustomerRecipientFallbackReason;
  /** The addresses the routing rule derives from the customer's contacts, before any adjustment. */
  derivedRecipients: Array<Scalars['String']['output']>;
  /** The notification kind. */
  docType: OrderEmailDocType;
  /** What a send would address after every scope's adjustments. */
  effectiveRecipients: Array<Scalars['String']['output']>;
  /** The choice in force: the order's, else the customer's, else Inherit. */
  effectiveSendChoice: NotificationSendChoice;
  /** Whether an automated send of this kind would go out, given the catalog, the choice, and the cascade. */
  effectiveSends: Scalars['Boolean']['output'];
  /** Addresses the order adds (empty when reading a customer). */
  orderAdditionalEmails: Array<Scalars['String']['output']>;
  /** Addresses the order leaves out (empty when reading a customer). */
  orderExcludedEmails: Array<Scalars['String']['output']>;
  /** Empty when reading a customer. */
  orderExcludedMobiles: Array<NotificationExcludedMobileData>;
  /** The order's send choice for this kind (Inherit when unset, or when reading a customer). */
  orderSendChoice: NotificationSendChoice;
  /**
   * The contact type this kind's recipient routing resolves to for the tenant: its own routing entry, else the
   * built-in default (Accounts Payable). Null for a kind that has no routing.
   */
  routedContactType?: Maybe<ContactType>;
  /** Whether the tenant has ever authored this kind. */
  tenantConfigured: Scalars['Boolean']['output'];
  /** Whether the tenant catalog has this kind switched on. */
  tenantEnabled: Scalars['Boolean']['output'];
  /** Who gets this kind by text: contacts whose mobile is ON, minus the exclusions at both scopes. Empty when the channel has no text. */
  textRecipients: Array<NotificationTextRecipientData>;
  /** True when the channel includes text but texts cannot go (texting not READY, or textRecipients empty), so this kind goes by email. */
  textsGoByEmail: Scalars['Boolean']['output'];
};

export enum NotificationOverrideScope {
  Customer = 'CUSTOMER',
  Order = 'ORDER'
}

/**
 * MongoDB read-model document for one customer- or order-scoped notification override record: the
 * sparse per-kind send choices, recipient adjustments and excluded mobiles, and the per-document report
 * bindings that NotificationResolution consults before falling through to the next scope. One
 * document per (tenant, scope, scope id); route all reads/writes through GetDocumentId.
 */
export type NotificationOverridesDocument = {
  __typename?: 'NotificationOverridesDocument';
  documentReports: Array<NotificationDocumentReportEntryDocument>;
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  recipients: Array<NotificationRecipientsEntryDocument>;
  scope: NotificationOverrideScope;
  scopeId: Scalars['String']['output'];
  sendChoices: Array<NotificationSendChoiceEntryDocument>;
  tenantId: Scalars['String']['output'];
  textRecipients: Array<NotificationTextRecipientsEntryDocument>;
};

export type NotificationOverridesPayload = {
  __typename?: 'NotificationOverridesPayload';
  errors?: Maybe<Array<ValidationError>>;
  notificationOverrides?: Maybe<NotificationOverridesStateData>;
};

/**
 * One customer- or order-scoped notification override record as exposed on the GraphQL contract: the
 * sparse per-kind send choices, recipient adjustments and excluded mobiles, and the per-document report
 * bindings set at this scope. A kind or document absent from these lists has no override at this scope.
 */
export type NotificationOverridesStateData = {
  __typename?: 'NotificationOverridesStateData';
  documentReports: Array<NotificationDocumentReportEntryData>;
  recipients: Array<NotificationRecipientsEntryData>;
  scope: NotificationOverrideScope;
  scopeId: Scalars['String']['output'];
  sendChoices: Array<NotificationSendChoiceEntryData>;
  tenantId: Scalars['String']['output'];
  textRecipients: Array<NotificationTextRecipientsEntryData>;
};

/**
 * Result of a single-row read-state mutation: the row as it now stands, so a client can update in
 * place without refetching.
 *
 * A null notification with no errors is a success, and it is the deliberate answer to
 * an id the caller does not own — including one that does not exist. The two cases are
 * indistinguishable on purpose: an error naming a row that "belongs to someone else" would confirm
 * the row is real, and this mutation is reachable by every signed-in user.
 */
export type NotificationPayload = {
  __typename?: 'NotificationPayload';
  /** Populated only when the write itself failed. */
  errors?: Maybe<Array<ValidationError>>;
  /** The affected row, or null when the caller owns no row with that id. */
  notification?: Maybe<NotificationDocument>;
};

/**
 * The message the notification projection publishes after it writes a live row, telling one
 * recipient's open clients that their bell has something new. It is also the payload of the
 * onNotificationReceived subscription.
 *
 * It names the row and nothing else. Read the notification back through myNotifications
 * rather than rendering from what arrives here.
 */
export type NotificationReceivedEvent = {
  __typename?: 'NotificationReceivedEvent';
  /** The Notifications document id to read back. */
  notificationId: Scalars['String']['output'];
  /** Who the row is for, in the same lowercased form the row and the topic use. */
  recipientEmail: Scalars['String']['output'];
  /** The tenant the notification belongs to. Redundant with the topic, and carried anyway so a consumer that logs or routes the message never has to parse it back out of the topic name. */
  tenantId: Scalars['String']['output'];
};

/** One kind's recipient adjustments at this scope. */
export type NotificationRecipientsEntryData = {
  __typename?: 'NotificationRecipientsEntryData';
  additionalEmails: Array<Scalars['String']['output']>;
  docType: OrderEmailDocType;
  excludedEmails: Array<Scalars['String']['output']>;
};

/** One kind's recipient adjustments at this scope. */
export type NotificationRecipientsEntryDocument = {
  __typename?: 'NotificationRecipientsEntryDocument';
  additionalEmails: Array<Scalars['String']['output']>;
  docType: OrderEmailDocType;
  excludedEmails: Array<Scalars['String']['output']>;
};

export enum NotificationSendChoice {
  Always = 'ALWAYS',
  Inherit = 'INHERIT',
  Never = 'NEVER'
}

/** One kind explicitly set to Always or Never at this scope. */
export type NotificationSendChoiceEntryData = {
  __typename?: 'NotificationSendChoiceEntryData';
  choice: NotificationSendChoice;
  docType: OrderEmailDocType;
};

/** One kind explicitly set to Always or Never at this scope. */
export type NotificationSendChoiceEntryDocument = {
  __typename?: 'NotificationSendChoiceEntryDocument';
  choice: NotificationSendChoice;
  docType: OrderEmailDocType;
};

/** Every notification kind and document binding as they apply to one customer, or to one order. */
export type NotificationSettingsData = {
  __typename?: 'NotificationSettingsData';
  /** The customer these settings apply to. */
  customerId: Scalars['String']['output'];
  /** One entry per order document. */
  documents: Array<NotificationDocumentSettingsData>;
  /** The sendOrderEmails cascade value at this scope. */
  effectiveSendOrderEmails: Scalars['Boolean']['output'];
  /** One entry per notification kind. */
  kinds: Array<NotificationKindSettingsData>;
  /** The order these settings apply to, or None when reading a customer. */
  orderId?: Maybe<Scalars['String']['output']>;
};

export type NotificationTextRecipientData = {
  __typename?: 'NotificationTextRecipientData';
  contactId: Scalars['UUID']['output'];
  contactName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type NotificationTextRecipientsEntryData = {
  __typename?: 'NotificationTextRecipientsEntryData';
  docType: OrderEmailDocType;
  excludedMobiles: Array<NotificationExcludedMobileData>;
};

/** One kind's excluded mobiles at this scope. */
export type NotificationTextRecipientsEntryDocument = {
  __typename?: 'NotificationTextRecipientsEntryDocument';
  docType: OrderEmailDocType;
  excludedMobiles: Array<NotificationExcludedMobileDocument>;
};

export type NullableOfCycleCountAssignmentStatusOperationFilterInput = {
  eq?: InputMaybe<CycleCountAssignmentStatus>;
  in?: InputMaybe<Array<InputMaybe<CycleCountAssignmentStatus>>>;
  neq?: InputMaybe<CycleCountAssignmentStatus>;
  nin?: InputMaybe<Array<InputMaybe<CycleCountAssignmentStatus>>>;
};

export type NullableOfDepositRequirementTypeOperationFilterInput = {
  eq?: InputMaybe<DepositRequirementType>;
  in?: InputMaybe<Array<InputMaybe<DepositRequirementType>>>;
  neq?: InputMaybe<DepositRequirementType>;
  nin?: InputMaybe<Array<InputMaybe<DepositRequirementType>>>;
};

export type NullableOfDeviceConnectivityOperationFilterInput = {
  eq?: InputMaybe<DeviceConnectivity>;
  in?: InputMaybe<Array<InputMaybe<DeviceConnectivity>>>;
  neq?: InputMaybe<DeviceConnectivity>;
  nin?: InputMaybe<Array<InputMaybe<DeviceConnectivity>>>;
};

export type NullableOfDimensionSourceOperationFilterInput = {
  eq?: InputMaybe<DimensionSource>;
  in?: InputMaybe<Array<InputMaybe<DimensionSource>>>;
  neq?: InputMaybe<DimensionSource>;
  nin?: InputMaybe<Array<InputMaybe<DimensionSource>>>;
};

export type NullableOfEmailSenderChannelOperationFilterInput = {
  eq?: InputMaybe<EmailSenderChannel>;
  in?: InputMaybe<Array<InputMaybe<EmailSenderChannel>>>;
  neq?: InputMaybe<EmailSenderChannel>;
  nin?: InputMaybe<Array<InputMaybe<EmailSenderChannel>>>;
};

export type NullableOfLocationStatusOperationFilterInput = {
  eq?: InputMaybe<LocationStatus>;
  in?: InputMaybe<Array<InputMaybe<LocationStatus>>>;
  neq?: InputMaybe<LocationStatus>;
  nin?: InputMaybe<Array<InputMaybe<LocationStatus>>>;
};

export type NullableOfOrderAllocationStatusOperationFilterInput = {
  eq?: InputMaybe<OrderAllocationStatus>;
  in?: InputMaybe<Array<InputMaybe<OrderAllocationStatus>>>;
  neq?: InputMaybe<OrderAllocationStatus>;
  nin?: InputMaybe<Array<InputMaybe<OrderAllocationStatus>>>;
};

export type NullableOfOrderEmailDocTypeOperationFilterInput = {
  eq?: InputMaybe<OrderEmailDocType>;
  in?: InputMaybe<Array<InputMaybe<OrderEmailDocType>>>;
  neq?: InputMaybe<OrderEmailDocType>;
  nin?: InputMaybe<Array<InputMaybe<OrderEmailDocType>>>;
};

export type NullableOfOrderEntryUnitOperationFilterInput = {
  eq?: InputMaybe<OrderEntryUnit>;
  in?: InputMaybe<Array<InputMaybe<OrderEntryUnit>>>;
  neq?: InputMaybe<OrderEntryUnit>;
  nin?: InputMaybe<Array<InputMaybe<OrderEntryUnit>>>;
};

export type NullableOfPriceEntryUnitOperationFilterInput = {
  eq?: InputMaybe<PriceEntryUnit>;
  in?: InputMaybe<Array<InputMaybe<PriceEntryUnit>>>;
  neq?: InputMaybe<PriceEntryUnit>;
  nin?: InputMaybe<Array<InputMaybe<PriceEntryUnit>>>;
};

export type NullableOfProductionCatalogOriginOperationFilterInput = {
  eq?: InputMaybe<ProductionCatalogOrigin>;
  in?: InputMaybe<Array<InputMaybe<ProductionCatalogOrigin>>>;
  neq?: InputMaybe<ProductionCatalogOrigin>;
  nin?: InputMaybe<Array<InputMaybe<ProductionCatalogOrigin>>>;
};

export type NullableOfProductionLotImportActionOperationFilterInput = {
  eq?: InputMaybe<ProductionLotImportAction>;
  in?: InputMaybe<Array<InputMaybe<ProductionLotImportAction>>>;
  neq?: InputMaybe<ProductionLotImportAction>;
  nin?: InputMaybe<Array<InputMaybe<ProductionLotImportAction>>>;
};

export type NullableOfProductionRecipeStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionRecipeStatus>;
  in?: InputMaybe<Array<InputMaybe<ProductionRecipeStatus>>>;
  neq?: InputMaybe<ProductionRecipeStatus>;
  nin?: InputMaybe<Array<InputMaybe<ProductionRecipeStatus>>>;
};

export type NullableOfQaPublicationReasonOperationFilterInput = {
  eq?: InputMaybe<QaPublicationReason>;
  in?: InputMaybe<Array<InputMaybe<QaPublicationReason>>>;
  neq?: InputMaybe<QaPublicationReason>;
  nin?: InputMaybe<Array<InputMaybe<QaPublicationReason>>>;
};

export type NullableOfShrinkTypeOperationFilterInput = {
  eq?: InputMaybe<ShrinkType>;
  in?: InputMaybe<Array<InputMaybe<ShrinkType>>>;
  neq?: InputMaybe<ShrinkType>;
  nin?: InputMaybe<Array<InputMaybe<ShrinkType>>>;
};

export type NullableOfStatementDeliveryMethodOperationFilterInput = {
  eq?: InputMaybe<StatementDeliveryMethod>;
  in?: InputMaybe<Array<InputMaybe<StatementDeliveryMethod>>>;
  neq?: InputMaybe<StatementDeliveryMethod>;
  nin?: InputMaybe<Array<InputMaybe<StatementDeliveryMethod>>>;
};

export type NullableOfTrialKindOperationFilterInput = {
  eq?: InputMaybe<TrialKind>;
  in?: InputMaybe<Array<InputMaybe<TrialKind>>>;
  neq?: InputMaybe<TrialKind>;
  nin?: InputMaybe<Array<InputMaybe<TrialKind>>>;
};

export type ObjectIdOperationFilterInput = {
  eq?: InputMaybe<Scalars['ObjectId']['input']>;
  gt?: InputMaybe<Scalars['ObjectId']['input']>;
  gte?: InputMaybe<Scalars['ObjectId']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  lt?: InputMaybe<Scalars['ObjectId']['input']>;
  lte?: InputMaybe<Scalars['ObjectId']['input']>;
  neq?: InputMaybe<Scalars['ObjectId']['input']>;
  ngt?: InputMaybe<Scalars['ObjectId']['input']>;
  ngte?: InputMaybe<Scalars['ObjectId']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  nlt?: InputMaybe<Scalars['ObjectId']['input']>;
  nlte?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type OnHandAdjustmentDocument = {
  __typename?: 'OnHandAdjustmentDocument';
  attemptCount: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  externalCustomerId: Scalars['String']['output'];
  externalItemId: Scalars['String']['output'];
  gtin: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  processed?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  resultMessage: Scalars['String']['output'];
  retailerId: Scalars['String']['output'];
  storeNumber: Scalars['String']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
  tenantId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: OnHandAdjustmentType;
};

export type OnHandAdjustmentDocumentFilterInput = {
  and?: InputMaybe<Array<OnHandAdjustmentDocumentFilterInput>>;
  attemptCount?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  externalCustomerId?: InputMaybe<StringOperationFilterInput>;
  externalItemId?: InputMaybe<StringOperationFilterInput>;
  gtin?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OnHandAdjustmentDocumentFilterInput>>;
  processed?: InputMaybe<DateTimeOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  resultMessage?: InputMaybe<StringOperationFilterInput>;
  retailerId?: InputMaybe<StringOperationFilterInput>;
  storeNumber?: InputMaybe<StringOperationFilterInput>;
  success?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  traceId?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<OnHandAdjustmentTypeOperationFilterInput>;
};

export type OnHandAdjustmentDocumentSortInput = {
  attemptCount?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  externalCustomerId?: InputMaybe<SortEnumType>;
  externalItemId?: InputMaybe<SortEnumType>;
  gtin?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  processed?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  resultMessage?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  storeNumber?: InputMaybe<SortEnumType>;
  success?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  traceId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum OnHandAdjustmentType {
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT',
  Set = 'SET'
}

export type OnHandAdjustmentTypeOperationFilterInput = {
  eq?: InputMaybe<OnHandAdjustmentType>;
  in?: InputMaybe<Array<OnHandAdjustmentType>>;
  neq?: InputMaybe<OnHandAdjustmentType>;
  nin?: InputMaybe<Array<OnHandAdjustmentType>>;
};

export type OnHandProcessIterationDocument = {
  __typename?: 'OnHandProcessIterationDocument';
  description: Scalars['String']['output'];
  entity: EntityType;
  errorCount: Scalars['Long']['output'];
  failCount: Scalars['Long']['output'];
  fatalError: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  retailerId: Scalars['String']['output'];
  retailerProcessorEnd: Scalars['DateTime']['output'];
  retailerProcessorStart: Scalars['DateTime']['output'];
  retries: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  successCount: Scalars['Long']['output'];
  tenantId: Scalars['String']['output'];
  totalItems: Scalars['Long']['output'];
  totalMs: Scalars['Long']['output'];
};

export type OnHandProcessIterationDocumentFilterInput = {
  and?: InputMaybe<Array<OnHandProcessIterationDocumentFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  entity?: InputMaybe<EntityTypeOperationFilterInput>;
  errorCount?: InputMaybe<LongOperationFilterInput>;
  failCount?: InputMaybe<LongOperationFilterInput>;
  fatalError?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ObjectIdOperationFilterInput>;
  or?: InputMaybe<Array<OnHandProcessIterationDocumentFilterInput>>;
  retailerId?: InputMaybe<StringOperationFilterInput>;
  retailerProcessorEnd?: InputMaybe<DateTimeOperationFilterInput>;
  retailerProcessorStart?: InputMaybe<DateTimeOperationFilterInput>;
  retries?: InputMaybe<IntOperationFilterInput>;
  success?: InputMaybe<BooleanOperationFilterInput>;
  successCount?: InputMaybe<LongOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalItems?: InputMaybe<LongOperationFilterInput>;
  totalMs?: InputMaybe<LongOperationFilterInput>;
};

export type OnHandProcessIterationDocumentSortInput = {
  description?: InputMaybe<SortEnumType>;
  entity?: InputMaybe<SortEnumType>;
  errorCount?: InputMaybe<SortEnumType>;
  failCount?: InputMaybe<SortEnumType>;
  fatalError?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  retailerProcessorEnd?: InputMaybe<SortEnumType>;
  retailerProcessorStart?: InputMaybe<SortEnumType>;
  retries?: InputMaybe<SortEnumType>;
  success?: InputMaybe<SortEnumType>;
  successCount?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalItems?: InputMaybe<SortEnumType>;
  totalMs?: InputMaybe<SortEnumType>;
};

export type OnHandProcessPayload = {
  __typename?: 'OnHandProcessPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<OnHandProcessStateData>;
};

/** A connection to a list of items. */
export type OnHandProcessQueueConnection = {
  __typename?: 'OnHandProcessQueueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OnHandProcessQueueEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OnHandAdjustmentDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OnHandProcessQueueEdge = {
  __typename?: 'OnHandProcessQueueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OnHandAdjustmentDocument;
};

export type OnHandProcessStateData = {
  __typename?: 'OnHandProcessStateData';
  attemptCount: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  externalCustomerId: Scalars['String']['output'];
  externalItemId: Scalars['String']['output'];
  gtin: Scalars['String']['output'];
  note: Scalars['String']['output'];
  processed?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  resultMessage: Scalars['String']['output'];
  retailerId: Scalars['String']['output'];
  storeNumber: Scalars['String']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
  tenantId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: OnHandAdjustmentType;
};

export type OnHandQueueIterationDocument = {
  __typename?: 'OnHandQueueIterationDocument';
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  endItemId: Scalars['Long']['output'];
  entity: EntityType;
  errors: Array<Scalars['String']['output']>;
  failCount: Scalars['Long']['output'];
  id: Scalars['ObjectId']['output'];
  retailerId: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  startItemId: Scalars['Long']['output'];
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  totalItems: Scalars['Long']['output'];
  totalMs: Scalars['Long']['output'];
};

export type OnHandQueueIterationDocumentFilterInput = {
  and?: InputMaybe<Array<OnHandQueueIterationDocumentFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  end?: InputMaybe<DateTimeOperationFilterInput>;
  endItemId?: InputMaybe<LongOperationFilterInput>;
  entity?: InputMaybe<EntityTypeOperationFilterInput>;
  errors?: InputMaybe<ListStringOperationFilterInput>;
  failCount?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<ObjectIdOperationFilterInput>;
  or?: InputMaybe<Array<OnHandQueueIterationDocumentFilterInput>>;
  retailerId?: InputMaybe<StringOperationFilterInput>;
  start?: InputMaybe<DateTimeOperationFilterInput>;
  startItemId?: InputMaybe<LongOperationFilterInput>;
  success?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalItems?: InputMaybe<LongOperationFilterInput>;
  totalMs?: InputMaybe<LongOperationFilterInput>;
};

export type OnHandQueueIterationDocumentSortInput = {
  description?: InputMaybe<SortEnumType>;
  end?: InputMaybe<SortEnumType>;
  endItemId?: InputMaybe<SortEnumType>;
  entity?: InputMaybe<SortEnumType>;
  failCount?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  retailerId?: InputMaybe<SortEnumType>;
  start?: InputMaybe<SortEnumType>;
  startItemId?: InputMaybe<SortEnumType>;
  success?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalItems?: InputMaybe<SortEnumType>;
  totalMs?: InputMaybe<SortEnumType>;
};

export enum OnboardingHelpChannel {
  Email = 'EMAIL',
  Teams = 'TEAMS'
}

/** One channel's delivery of an accepted request, as the grower and staff read it. */
export type OnboardingHelpChannelStatus = {
  __typename?: 'OnboardingHelpChannelStatus';
  /** How many claims the channel has taken. */
  attempts: Scalars['Int']['output'];
  /** The channel. */
  channel: OnboardingHelpChannel;
  /** When a retry or reconciliation may next be claimed. */
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  /** The provider's reference. Staff only; null for the grower. */
  providerReference?: Maybe<Scalars['String']['output']>;
  /** The last reason code a worker reported. */
  reasonCode?: Maybe<Scalars['String']['output']>;
  /** Where its delivery stands. */
  status: OnboardingHelpDeliveryStatus;
  /** When the channel last changed. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Why a worker holds a claimed channel, which decides what it must do before it sends. */
export enum OnboardingHelpClaimMode {
  /**
   * The previous worker's lease expired without a report, so its send may or may not have happened.
   * Reconcile with the provider by priorProviderReference or the request id before sending again.
   * Report HELD only after confirming the earlier attempt was not delivered; otherwise report UNCERTAIN, so
   * delivery uncertainty is never lost.
   */
  Reclaim = 'RECLAIM',
  /**
   * The previous attempt ended with an uncertain provider result. Establish what the provider holds, then
   * report Sent or Failed; do not send blind. Report HELD only after confirming the earlier attempt was not
   * delivered; otherwise report UNCERTAIN, so delivery uncertainty is never lost.
   */
  Reconcile = 'RECONCILE',
  /** A send after a retryable failure. Nothing was accepted by the provider. */
  Retry = 'RETRY',
  /** The first send on this channel. */
  Send = 'SEND'
}

/** One channel a worker now holds, with everything it needs to send it. */
export type OnboardingHelpClaimedDelivery = {
  __typename?: 'OnboardingHelpClaimedDelivery';
  /** When wsapi accepted the request. */
  acceptedAt: Scalars['DateTime']['output'];
  /** This claim's attempt number. Echo it when recording the outcome. */
  attempt: Scalars['Int']['output'];
  /** The claimed channel. */
  channel: OnboardingHelpChannel;
  /** The journey. */
  journeyId: Scalars['String']['output'];
  /** When the claim expires. A report after that may be refused. */
  leaseUntil: Scalars['DateTime']['output'];
  /** Why the channel was claimed, and so what to establish before sending. */
  mode: OnboardingHelpClaimMode;
  /** The provider reference a previous attempt recorded, for reconciliation. */
  priorProviderReference?: Maybe<Scalars['String']['output']>;
  /** Why the grower asked for help. */
  reason: OnboardingHelpReason;
  /** What the request cites, by id. */
  references: Array<OnboardingHelpReference>;
  /** The request. */
  requestId: Scalars['String']['output'];
  /** The grower who sent the request. */
  requestedBy: Scalars['String']['output'];
  /** The route the grower reviewed. Compare it with the route to be used before each send. */
  reviewedRoute: OnboardingHelpRouteDetails;
  /** The reviewed summary to send. Plain text. */
  summary: Scalars['String']['output'];
};

export enum OnboardingHelpDeliveryStatus {
  Failed = 'FAILED',
  Held = 'HELD',
  Pending = 'PENDING',
  Sending = 'SENDING',
  Sent = 'SENT',
  Unavailable = 'UNAVAILABLE',
  Uncertain = 'UNCERTAIN'
}

export enum OnboardingHelpHandling {
  Acknowledged = 'ACKNOWLEDGED',
  Resolved = 'RESOLVED',
  Unacknowledged = 'UNACKNOWLEDGED'
}

export enum OnboardingHelpReason {
  General = 'GENERAL',
  NoSupportedOperation = 'NO_SUPPORTED_OPERATION'
}

/** One thing an accepted help request cites, by id. */
export type OnboardingHelpReference = {
  __typename?: 'OnboardingHelpReference';
  /** The id. Never a name, an address or any other copied value. */
  id: Scalars['String']['output'];
  /** What the id names. */
  kind: OnboardingHelpReferenceKind;
};

export type OnboardingHelpReferenceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  kind: OnboardingHelpReferenceKind;
};

export enum OnboardingHelpReferenceKind {
  AffectedRecord = 'AFFECTED_RECORD',
  CorrectionPortion = 'CORRECTION_PORTION',
  Dependent = 'DEPENDENT',
  ImportRun = 'IMPORT_RUN',
  Job = 'JOB',
  Operation = 'OPERATION',
  PreparedRow = 'PREPARED_ROW',
  Receipt = 'RECEIPT'
}

/**
 * An accepted help request with its staff handling and per-channel delivery state. Acceptance, each
 * channel's delivery and staff handling are separate fields and none is derived from another.
 */
export type OnboardingHelpRequestReadback = {
  __typename?: 'OnboardingHelpRequestReadback';
  /** When wsapi accepted it. */
  acceptedAt: Scalars['DateTime']['output'];
  /** Who sent it. */
  acceptedBy: Scalars['String']['output'];
  /** When it was acknowledged. */
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The staff member who acknowledged it. */
  acknowledgedBy?: Maybe<Scalars['String']['output']>;
  /** Each channel the reviewed route names. Empty until the delivery row is visible. */
  channels: Array<OnboardingHelpChannelStatus>;
  /** Whether a person has acknowledged or resolved it. */
  handling: OnboardingHelpHandling;
  /** The journey the request belongs to. */
  journeyId: Scalars['String']['output'];
  /** Why the grower asked for help. */
  reason: OnboardingHelpReason;
  /** What the request cites, by id. */
  references: Array<OnboardingHelpReference>;
  /** The request. */
  requestId: Scalars['String']['output'];
  /** When it was resolved. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The staff member who resolved it. */
  resolvedBy?: Maybe<Scalars['String']['output']>;
  /** The staff route the grower reviewed. */
  reviewedRoute: OnboardingHelpRouteDetails;
  /** The request revision this read reflects. */
  streamRevision: Scalars['Long']['output'];
  /** The reviewed summary. Show as plain text. */
  summary: Scalars['String']['output'];
};

/** Whether services has published a staff route for the tenant. */
export enum OnboardingHelpRouteAvailability {
  /** A route is published and can be reviewed and bound to a request. */
  Available = 'AVAILABLE',
  /** No route is published. A request cannot be reviewed, and no destination is invented. */
  Unavailable = 'UNAVAILABLE'
}

/**
 * The staff route a request was reviewed against: the existing data-received staff-flow policy and the
 * audience the grower was shown. Non-secret; it never holds a recipient address or a webhook.
 */
export type OnboardingHelpRouteDetails = {
  __typename?: 'OnboardingHelpRouteDetails';
  /** The intended staff audience in words. */
  audience: Scalars['String']['output'];
  /** The channels the policy delivers through. */
  channels: Array<OnboardingHelpChannel>;
  /** Digest of the intended audience and destinations, excluding current membership. */
  fingerprint: Scalars['String']['output'];
  /** The staff-flow policy identity. */
  policyId: Scalars['String']['output'];
  /** The policy revision the grower reviewed. */
  revision: Scalars['Int']['output'];
};

/** The staff route as the grower is shown it, or the explicit absence of one. */
export type OnboardingHelpRouteView = {
  __typename?: 'OnboardingHelpRouteView';
  /** Whether a route is published. */
  availability: OnboardingHelpRouteAvailability;
  /** When the current revision was published. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The published route, or null when none is published. */
  route?: Maybe<OnboardingHelpRouteDetails>;
};

export type OnboardingJourneyArtifactEvidence = {
  __typename?: 'OnboardingJourneyArtifactEvidence';
  artifactId: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  jobId: Scalars['String']['output'];
  kind: OnboardingJourneyArtifactKind;
  recoveryStep?: Maybe<Scalars['String']['output']>;
  revision: Scalars['Int']['output'];
};

export enum OnboardingJourneyArtifactKind {
  Derived = 'DERIVED',
  Original = 'ORIGINAL',
  Prepared = 'PREPARED'
}

/** Which grower command touched the journey. */
export enum OnboardingJourneyCommandKind {
  Approval = 'APPROVAL',
  HelpRequest = 'HELP_REQUEST',
  HelpRouteReconfirmation = 'HELP_ROUTE_RECONFIRMATION',
  JourneyFact = 'JOURNEY_FACT',
  JourneyResume = 'JOURNEY_RESUME',
  JourneyStart = 'JOURNEY_START',
  ParsingSuggestion = 'PARSING_SUGGESTION',
  Presentation = 'PRESENTATION',
  QuestionAnswer = 'QUESTION_ANSWER',
  RunCancel = 'RUN_CANCEL',
  RunPause = 'RUN_PAUSE',
  RunResume = 'RUN_RESUME',
  SessionLoaded = 'SESSION_LOADED',
  Unknown = 'UNKNOWN',
  UploadRegistration = 'UPLOAD_REGISTRATION'
}

/** The result of a journey command, or why it was refused. */
export type OnboardingJourneyCommandPayload = {
  __typename?: 'OnboardingJourneyCommandPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<OnboardingJourneyCommandResult>;
};

/** What a journey command committed. */
export type OnboardingJourneyCommandResult = {
  __typename?: 'OnboardingJourneyCommandResult';
  /** The journey. */
  journeyId: Scalars['String']['output'];
  /** Recorded now, or already recorded by an earlier call. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The identity wsapi derived for the command. */
  recordId: Scalars['String']['output'];
  /** The journey revision after the command. A journey state read at a lower revision has not caught up yet. */
  streamRevision: Scalars['Long']['output'];
};

export type OnboardingJourneyCompletionEvidence = {
  __typename?: 'OnboardingJourneyCompletionEvidence';
  at: Scalars['DateTime']['output'];
  reference: Scalars['String']['output'];
  source: OnboardingJourneyEvidenceSource;
};

export type OnboardingJourneyDependency = {
  __typename?: 'OnboardingJourneyDependency';
  dependsOn: Scalars['String']['output'];
  evidenceKind?: Maybe<OnboardingJourneyEvidenceKind>;
  evidenceReference?: Maybe<Scalars['String']['output']>;
  factId: Scalars['String']['output'];
  satisfied: Scalars['Boolean']['output'];
  subject: Scalars['String']['output'];
};

export enum OnboardingJourneyEvidenceKind {
  DomainRule = 'DOMAIN_RULE',
  Query = 'QUERY',
  Question = 'QUESTION',
  Unknown = 'UNKNOWN',
  ValidationReceipt = 'VALIDATION_RECEIPT'
}

export enum OnboardingJourneyEvidenceSource {
  Observation = 'OBSERVATION',
  RunVerification = 'RUN_VERIFICATION'
}

/** One journey fact, as recorded. Text in it is data the grower or fernie supplied, never an instruction. */
export type OnboardingJourneyFactDocument = {
  __typename?: 'OnboardingJourneyFactDocument';
  dependsOn?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<OnboardingJourneyFactEvidenceDocument>;
  factId: Scalars['String']['output'];
  kind: OnboardingJourneyFactKind;
  /** Where the fact's authority comes from, fixed by its kind. */
  provenance: OnboardingJourneyFactProvenance;
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  sentMessageReference?: Maybe<Scalars['String']['output']>;
  sessionReference: Scalars['String']['output'];
  statement?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  turnId?: Maybe<Scalars['String']['output']>;
};

/** The evidence a validated fact cites. */
export type OnboardingJourneyFactEvidenceDocument = {
  __typename?: 'OnboardingJourneyFactEvidenceDocument';
  kind: OnboardingJourneyEvidenceKind;
  observed?: Maybe<Scalars['String']['output']>;
  observedAt?: Maybe<Scalars['DateTime']['output']>;
  reference: Scalars['String']['output'];
};

/** The evidence a dependency or an observation cites. */
export type OnboardingJourneyFactEvidenceInput = {
  kind: OnboardingJourneyEvidenceKind;
  observed?: InputMaybe<Scalars['String']['input']>;
  observedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export enum OnboardingJourneyFactKind {
  DependencyNoted = 'DEPENDENCY_NOTED',
  GoalStated = 'GOAL_STATED',
  ModelNote = 'MODEL_NOTE',
  NoFilesPathChosen = 'NO_FILES_PATH_CHOSEN',
  ScopeDeferred = 'SCOPE_DEFERRED',
  ScopeSelected = 'SCOPE_SELECTED',
  Unknown = 'UNKNOWN',
  ValidatedObservation = 'VALIDATED_OBSERVATION'
}

export enum OnboardingJourneyFactProvenance {
  GrowerStatement = 'GROWER_STATEMENT',
  ModelNote = 'MODEL_NOTE',
  Unknown = 'UNKNOWN',
  ValidatedFact = 'VALIDATED_FACT'
}

export type OnboardingJourneyFamilyProgress = {
  __typename?: 'OnboardingJourneyFamilyProgress';
  completeItemCount: Scalars['Int']['output'];
  completeOperationCount: Scalars['Int']['output'];
  deferredOperationCount: Scalars['Int']['output'];
  expiredOperationCount: Scalars['Int']['output'];
  family: Scalars['String']['output'];
  remainingOperationCount: Scalars['Int']['output'];
  selectedItemCount: Scalars['Int']['output'];
};

/** One data family of the staff progress report. */
export type OnboardingJourneyFamilyProgressReport = {
  __typename?: 'OnboardingJourneyFamilyProgressReport';
  /** The journey family key, such as customers. */
  familyKey: Scalars['String']['output'];
  /** The least advanced status of the family's selected items, or null when none is selected. */
  itemStatus?: Maybe<OnboardingJourneyItemStatus>;
  /** When that run last changed, which for a completed run is when it completed, or null when no run has the family. */
  latestRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** The state of the run still writing the family, else of its last run, or null when no run has it. */
  latestRunState?: Maybe<MigrationImportRunState>;
  /** The next step the family needs from the grower, as their plan shows it. */
  nextAction: OnboardingPlanNextAction;
  /** How many questions about the family's files wait for an answer. */
  openQuestionCount: Scalars['Int']['output'];
  /** Selected when any of the family's subjects is selected, else Deferred when any is deferred, else NotSelected. */
  scopeStatus: OnboardingJourneyScopeStatus;
};

export type OnboardingJourneyItemProgress = {
  __typename?: 'OnboardingJourneyItemProgress';
  completeOperationCount: Scalars['Int']['output'];
  evidence?: Maybe<OnboardingJourneyCompletionEvidence>;
  family: Scalars['String']['output'];
  operationCount: Scalars['Int']['output'];
  status: OnboardingJourneyItemStatus;
  subject: Scalars['String']['output'];
  unsatisfiedDependencies: Array<Scalars['String']['output']>;
};

export enum OnboardingJourneyItemStatus {
  AwaitingEvidence = 'AWAITING_EVIDENCE',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  WaitingOnDependency = 'WAITING_ON_DEPENDENCY'
}

export type OnboardingJourneyJobEvidence = {
  __typename?: 'OnboardingJourneyJobEvidence';
  jobId: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceVersion: Scalars['Int']['output'];
  state: OnboardingJourneyJobState;
};

export enum OnboardingJourneyJobState {
  Failed = 'FAILED',
  NeedsAnswers = 'NEEDS_ANSWERS',
  Pending = 'PENDING',
  Prepared = 'PREPARED',
  Running = 'RUNNING',
  Superseded = 'SUPERSEDED'
}

/** Whether the tenant has an onboarding journey and whether it is unfinished. */
export type OnboardingJourneyLookup = {
  __typename?: 'OnboardingJourneyLookup';
  /** True once the journey was started. */
  exists: Scalars['Boolean']['output'];
  /** The journey, when there is one. */
  journeyId?: Maybe<Scalars['String']['output']>;
  /** The chat session that owns the journey: the session it was started from, or, when it was started outside a chat, the earliest session the journey recorded (a resume, session load or fact), else the earliest session that touched it. Null when no session has touched it. Durable except in one case: a journey started outside a chat whose only chat contacts were approvals, question answers, presentations, help requests, parsing suggestions or upload registrations falls back to touch rows, which are purged after 365 days. */
  sessionReference?: Maybe<Scalars['String']['output']>;
  /** True while the journey has nothing selected yet or any selected item is not complete; false when there is no journey. */
  unfinished: Scalars['Boolean']['output'];
};

export type OnboardingJourneyNextAction = {
  __typename?: 'OnboardingJourneyNextAction';
  detail?: Maybe<Scalars['String']['output']>;
  kind: OnboardingJourneyNextActionKind;
  reference?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export enum OnboardingJourneyNextActionKind {
  AnswerQuestion = 'ANSWER_QUESTION',
  RecoverArtifact = 'RECOVER_ARTIFACT',
  ReviewPortion = 'REVIEW_PORTION',
  SatisfyDependency = 'SATISFY_DEPENDENCY',
  SelectScope = 'SELECT_SCOPE',
  VerifySelectedWork = 'VERIFY_SELECTED_WORK'
}

export type OnboardingJourneyOperationProgress = {
  __typename?: 'OnboardingJourneyOperationProgress';
  family: Scalars['String']['output'];
  operationId: Scalars['String']['output'];
  portionId: Scalars['String']['output'];
  runId?: Maybe<Scalars['String']['output']>;
  runState?: Maybe<OnboardingJourneyRunState>;
  scope: OnboardingJourneyScopeStatus;
  scopeKey: Scalars['String']['output'];
  status: OnboardingJourneyOperationStatus;
};

export enum OnboardingJourneyOperationStatus {
  AwaitingApproval = 'AWAITING_APPROVAL',
  CommittedUnverified = 'COMMITTED_UNVERIFIED',
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  HeldByRun = 'HELD_BY_RUN',
  NotWritten = 'NOT_WRITTEN',
  Rejected = 'REJECTED',
  Superseded = 'SUPERSEDED',
  Uncertain = 'UNCERTAIN',
  VerificationMismatch = 'VERIFICATION_MISMATCH'
}

export type OnboardingJourneyPortionProgress = {
  __typename?: 'OnboardingJourneyPortionProgress';
  artifactId: Scalars['String']['output'];
  artifactRevision: Scalars['Int']['output'];
  operations: Array<OnboardingJourneyOperationProgress>;
  portionId: Scalars['String']['output'];
  run?: Maybe<OnboardingJourneyRunProgress>;
};

export type OnboardingJourneyProgress = {
  __typename?: 'OnboardingJourneyProgress';
  dependencies: Array<OnboardingJourneyDependency>;
  families: Array<OnboardingJourneyFamilyProgress>;
  items: Array<OnboardingJourneyItemProgress>;
  nextActions: Array<OnboardingJourneyNextAction>;
  portions: Array<OnboardingJourneyPortionProgress>;
  remainingJobs: Array<OnboardingJourneyJobEvidence>;
  remainingRuns: Array<OnboardingJourneyRunProgress>;
  remainingWork: Array<OnboardingJourneyOperationProgress>;
  reportedOutcomes: Array<OnboardingJourneyOperationProgress>;
  runs: Array<OnboardingJourneyRunProgress>;
  scope: Array<OnboardingJourneyScopeItem>;
  unfinished: Scalars['Boolean']['output'];
};

/** One tenant's onboarding journey as staff see it. */
export type OnboardingJourneyProgressReport = {
  __typename?: 'OnboardingJourneyProgressReport';
  /** Every journey family, in the order a grower brings them in. */
  families: Array<OnboardingJourneyFamilyProgressReport>;
  /** The tenant's journey. */
  journeyId: Scalars['String']['output'];
  /** When the journey was created. */
  journeyStartedAt: Scalars['DateTime']['output'];
  /** When the tenant's first import run completed, or null while none has. */
  loadedViaAgentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The tenant. */
  tenantId: Scalars['String']['output'];
};

export type OnboardingJourneyQuestionEvidence = {
  __typename?: 'OnboardingJourneyQuestionEvidence';
  artifactId: Scalars['String']['output'];
  artifactRevision: Scalars['Int']['output'];
  blocking: Scalars['Boolean']['output'];
  family: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
  state: OnboardingJourneyQuestionState;
};

export enum OnboardingJourneyQuestionState {
  Answered = 'ANSWERED',
  Open = 'OPEN',
  Superseded = 'SUPERSEDED'
}

/** Whether the command recorded something new or found it already recorded. */
export enum OnboardingJourneyRecordOutcome {
  AlreadyRecorded = 'ALREADY_RECORDED',
  Recorded = 'RECORDED'
}

export enum OnboardingJourneyResolution {
  AlreadyRecorded = 'ALREADY_RECORDED',
  Resumed = 'RESUMED',
  Started = 'STARTED'
}

/** The chat references the chat service attaches to a grower command. Attribution only. */
export type OnboardingJourneyRoutingInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  sentMessageReference?: InputMaybe<Scalars['String']['input']>;
  sessionReference?: InputMaybe<Scalars['String']['input']>;
  turnId?: InputMaybe<Scalars['String']['input']>;
};

export enum OnboardingJourneyRunControl {
  Cancel = 'CANCEL',
  None = 'NONE',
  Pause = 'PAUSE',
  Resume = 'RESUME'
}

export type OnboardingJourneyRunProgress = {
  __typename?: 'OnboardingJourneyRunProgress';
  acknowledgedControlVersion: Scalars['Long']['output'];
  approvalId: Scalars['String']['output'];
  committedOperationCount: Scalars['Int']['output'];
  controlAcknowledged: Scalars['Boolean']['output'];
  controlRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  controlRequestedBy?: Maybe<Scalars['String']['output']>;
  controlVersion: Scalars['Long']['output'];
  finished: Scalars['Boolean']['output'];
  notWrittenOperationCount: Scalars['Int']['output'];
  requestedControl: OnboardingJourneyRunControl;
  runId: Scalars['String']['output'];
  state: OnboardingJourneyRunState;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OnboardingJourneyRunState {
  Applied = 'APPLIED',
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export type OnboardingJourneyScopeItem = {
  __typename?: 'OnboardingJourneyScopeItem';
  decidedAt: Scalars['DateTime']['output'];
  decidedByFactId: Scalars['String']['output'];
  family: Scalars['String']['output'];
  status: OnboardingJourneyScopeStatus;
  subject: Scalars['String']['output'];
};

export enum OnboardingJourneyScopeStatus {
  Deferred = 'DEFERRED',
  NotSelected = 'NOT_SELECTED',
  Selected = 'SELECTED'
}

/** How many touches of one command kind one day holds. */
export type OnboardingJourneySessionTouchCount = {
  __typename?: 'OnboardingJourneySessionTouchCount';
  commandKind: OnboardingJourneyCommandKind;
  count: Scalars['Int']['output'];
  day: Scalars['String']['output'];
};

/** One accepted grower command on the journey that carried a chat session reference. */
export type OnboardingJourneySessionTouchDocument = {
  __typename?: 'OnboardingJourneySessionTouchDocument';
  commandIdentity: Scalars['String']['output'];
  commandKind: OnboardingJourneyCommandKind;
  id: Scalars['String']['output'];
  journeyId: Scalars['String']['output'];
  sentMessageReference?: Maybe<Scalars['String']['output']>;
  /** The chat session. Opaque; it may no longer resolve once the grower deletes the chat. */
  sessionReference: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
  turnId?: Maybe<Scalars['String']['output']>;
  userEmail: Scalars['String']['output'];
  userSubject: Scalars['String']['output'];
};

/** Session touches for one tenant, and how many there were of each kind per day. */
export type OnboardingJourneySessionTouchReport = {
  __typename?: 'OnboardingJourneySessionTouchReport';
  /** Counts of every matching touch by day (UTC) and command kind, newest day first. */
  countsByDay: Array<OnboardingJourneySessionTouchCount>;
  /** The matching touch rows, newest first, up to the limit. */
  touches: Array<OnboardingJourneySessionTouchDocument>;
};

/** The result of a start or resume, or why it was refused. */
export type OnboardingJourneyStartPayload = {
  __typename?: 'OnboardingJourneyStartPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<OnboardingJourneyStartResult>;
};

/** The tenant's journey as a start or resume resolved it, in brief. */
export type OnboardingJourneyStartResult = {
  __typename?: 'OnboardingJourneyStartResult';
  /** The journey: pass it to every later journey command. */
  journeyId: Scalars['String']['output'];
  /** The next steps the journey's evidence points to. Derived output only; it authorizes nothing. */
  nextActions: Array<OnboardingJourneyNextAction>;
  /** Whether this call started the journey, resumed it for its chat turn, or recorded nothing new. */
  outcome: OnboardingJourneyResolution;
  /** When the journey was created. */
  startedAt: Scalars['DateTime']['output'];
  /** The journey revision after the call. A journey state read at a lower revision has not caught up yet. */
  streamRevision: Scalars['Long']['output'];
  /** True while nothing is selected yet or any selected item is not complete. */
  unfinished: Scalars['Boolean']['output'];
  /** How old that verification was when this call resolved the journey. */
  verificationAge?: Maybe<Scalars['TimeSpan']['output']>;
  /** The oldest verification among the complete selected items; none while no item is complete. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The tenant's onboarding journey as it stands, with the progress computed from it. */
export type OnboardingJourneyStateView = {
  __typename?: 'OnboardingJourneyStateView';
  /** The journey's files: each original upload, the artifacts derived from it and its prepared revisions (see kind), including any past their retention. */
  artifacts: Array<OnboardingJourneyArtifactEvidence>;
  /** Every journey fact, in the order recorded. */
  facts: Array<OnboardingJourneyFactDocument>;
  /** The journey's preparation jobs. */
  jobs: Array<OnboardingJourneyJobEvidence>;
  /** The journey. */
  journeyId: Scalars['String']['output'];
  /** Progress computed from the facts and the execution records on this read. */
  progress: OnboardingJourneyProgress;
  /** The journey's questions, with the artifact revision each applies to. */
  questions: Array<OnboardingJourneyQuestionEvidence>;
  /** When the journey was created. */
  startedAt: Scalars['DateTime']['output'];
  /** The last journey revision this read reflects. A command result with a higher revision has not reached it yet; show it as pending and do not repeat the command. */
  streamRevision: Scalars['Long']['output'];
};

/** One upload with no preparation job in the journey. Register its source id and version to prepare it. */
export type OnboardingOutsideUpload = {
  __typename?: 'OnboardingOutsideUpload';
  /** Lower-case hex SHA-256 of the uploaded bytes. */
  contentSha256: Scalars['String']['output'];
  /** The file name it was uploaded under. */
  fileName: Scalars['String']['output'];
  /** The upload's size. */
  sizeBytes: Scalars['Long']['output'];
  /** The source the upload belongs to. */
  sourceId: Scalars['String']['output'];
  /** The version the upload created. */
  sourceVersion: Scalars['Int']['output'];
  /** When the upload was recorded. */
  uploadedAt: Scalars['DateTime']['output'];
  /** Who uploaded it. */
  uploadedBy: Scalars['String']['output'];
};

/**
 * One parsing-improvement suggestion fernie made in a grower's review turn, as last projected. For staff
 * only; the grower never reads it. The suggestion is never applied.
 */
export type OnboardingParsingSuggestionDocument = {
  __typename?: 'OnboardingParsingSuggestionDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  family: OnboardingParsingSuggestionFamily;
  id: Scalars['String']['output'];
  /** The preparation job whose prepared data the turn reviewed. */
  jobId: Scalars['String']['output'];
  journeyId: Scalars['String']['output'];
  /** The model that produced the suggestion. */
  model: Scalars['String']['output'];
  reviewState: OnboardingParsingSuggestionReviewState;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  sentMessageReference: Scalars['String']['output'];
  /** The chat session. Opaque; it may no longer resolve once the grower deletes the chat. */
  sessionReference: Scalars['String']['output'];
  /** The source version the job prepared, as the caller passed it. */
  sourceVersion: Scalars['Int']['output'];
  staffNote?: Maybe<Scalars['String']['output']>;
  stage: OnboardingParsingSuggestionStage;
  /**
   * The last suggestion revision this read reflects. A review result with a higher revision has not
   * reached it yet: show it as pending. Send this revision with a review.
   */
  streamRevision: Scalars['Long']['output'];
  suggestionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /** fernie's suggestion: untrusted model output stored inert. Show it as plain text, never as markup. */
  text: Scalars['String']['output'];
  turnId: Scalars['String']['output'];
};

export enum OnboardingParsingSuggestionFamily {
  Customers = 'CUSTOMERS',
  Items = 'ITEMS',
  Orders = 'ORDERS',
  Pricing = 'PRICING',
  Terms = 'TERMS',
  Unknown = 'UNKNOWN'
}

/** What a review did. */
export enum OnboardingParsingSuggestionReviewOutcome {
  /** The review was appended. */
  Recorded = 'RECORDED',
  /** The suggestion moved past the revision sent; nothing was appended and the current state is returned. */
  Stale = 'STALE',
  /** The suggestion already had this review state and staff note; nothing was appended. */
  Unchanged = 'UNCHANGED'
}

export enum OnboardingParsingSuggestionReviewState {
  Actioned = 'ACTIONED',
  Dismissed = 'DISMISSED',
  Reviewed = 'REVIEWED',
  Unreviewed = 'UNREVIEWED'
}

export enum OnboardingParsingSuggestionStage {
  Intake = 'INTAKE',
  Mapping = 'MAPPING',
  Transform = 'TRANSFORM',
  Unknown = 'UNKNOWN',
  Validate = 'VALIDATE'
}

/** The caller's onboarding plan: the data to bring in, what to learn next, and the go-live checklist. */
export type OnboardingPlanData = {
  __typename?: 'OnboardingPlanData';
  /** The tenant's go-live checklist, or null while it cannot be read here. */
  goLive?: Maybe<OnboardingPlanGoLiveData>;
  /** The caller's learning progress with the next and upcoming concepts. */
  learn: OnboardingPlanLearnData;
  /** Each data family of the tenant's journey with its status and next step. */
  upload: OnboardingPlanUploadData;
};

/** One data family on the plan. */
export type OnboardingPlanFamilyData = {
  __typename?: 'OnboardingPlanFamilyData';
  /** How many of this family's records the tenant already has in Work Suite, from any source (staff load, import, manual entry). Live orders only for the orders family: history imports are not counted. */
  existingCount: Scalars['Int']['output'];
  /** The journey family key, such as customers. */
  family: Scalars['String']['output'];
  /** The least advanced status of the family's selected items, or null when none is selected. */
  itemStatus?: Maybe<OnboardingJourneyItemStatus>;
  /** The state of the run still writing the family, else of its last run, or null when no run has it. */
  latestRunState?: Maybe<OnboardingJourneyRunState>;
  /** The next step the family needs from the grower. */
  nextAction: OnboardingPlanNextAction;
  /** How many questions about the family's files wait for an answer. */
  openQuestionCount: Scalars['Int']['output'];
  /** Selected when any of the family's subjects is selected, else Deferred when any is deferred, else NotSelected. */
  scopeStatus: OnboardingJourneyScopeStatus;
};

/** The tenant's go-live checklist. */
export type OnboardingPlanGoLiveData = {
  __typename?: 'OnboardingPlanGoLiveData';
  /** Each go-live step and whether it is done. */
  items: Array<OnboardingPlanGoLiveItemData>;
};

/** One go-live step. */
export type OnboardingPlanGoLiveItemData = {
  __typename?: 'OnboardingPlanGoLiveItemData';
  /** True once the step is done. */
  done: Scalars['Boolean']['output'];
  /** The step, such as customers-in. */
  key: Scalars['String']['output'];
};

/** The caller's learning across every path they see. */
export type OnboardingPlanLearnData = {
  __typename?: 'OnboardingPlanLearnData';
  /** How many concepts the caller has completed. */
  completedCount: Scalars['Int']['output'];
  /** The first concept not yet complete, or null once every concept is. */
  nextConcept?: Maybe<LearningConcept>;
  /** How many concepts the caller sees. */
  totalCount: Scalars['Int']['output'];
  /** Up to three concepts not yet complete after the next one, in path order. */
  upcomingConcepts: Array<LearningConcept>;
};

/** The next step a data family needs from the grower. */
export enum OnboardingPlanNextAction {
  /** Answer the open questions about the family's files. */
  AnswerQuestions = 'ANSWER_QUESTIONS',
  /** The family is in and confirmed. */
  Done = 'DONE',
  /** Review and approve a portion of the family's files. */
  ReviewApprove = 'REVIEW_APPROVE',
  /** The unset value. The plan never returns it: every family gets one of the steps below. */
  Unknown = 'UNKNOWN',
  /** Upload the family's file: it is not chosen yet, nothing of it is ready to review, its file expired, or its run did not write it. */
  Upload = 'UPLOAD',
  /** Nothing to do yet: a run is writing or verifying the family, or it waits on another family. */
  Wait = 'WAIT'
}

/** The tenant's data families, each with its status and next step. */
export type OnboardingPlanUploadData = {
  __typename?: 'OnboardingPlanUploadData';
  /** False when the caller may not upload, answer or approve, such as an external connector token: they see each next step but cannot take it. */
  canAct: Scalars['Boolean']['output'];
  /** How many families are done. */
  completedCount: Scalars['Int']['output'];
  /** Every journey family, in the order a grower brings them in. */
  families: Array<OnboardingPlanFamilyData>;
  /** How many families there are. */
  totalCount: Scalars['Int']['output'];
};

export enum OnboardingReviewArea {
  Catalogs = 'CATALOGS',
  Categories = 'CATEGORIES',
  Customers = 'CUSTOMERS',
  Inventory = 'INVENTORY',
  Items = 'ITEMS',
  Locations = 'LOCATIONS',
  Orders = 'ORDERS',
  Pricing = 'PRICING',
  ProductionItems = 'PRODUCTION_ITEMS',
  Recipes = 'RECIPES',
  Schedule = 'SCHEDULE',
  SpaceCategories = 'SPACE_CATEGORIES',
  Terms = 'TERMS',
  Unknown = 'UNKNOWN',
  Vendors = 'VENDORS'
}

export type OnboardingReviewAreaOperationFilterInput = {
  eq?: InputMaybe<OnboardingReviewArea>;
  in?: InputMaybe<Array<OnboardingReviewArea>>;
  neq?: InputMaybe<OnboardingReviewArea>;
  nin?: InputMaybe<Array<OnboardingReviewArea>>;
};

export enum OnboardingSetupStage {
  DataLoading = 'DATA_LOADING',
  DataReceived = 'DATA_RECEIVED',
  Live = 'LIVE',
  NotStarted = 'NOT_STARTED',
  ReadyForReview = 'READY_FOR_REVIEW',
  Unknown = 'UNKNOWN',
  Validated = 'VALIDATED'
}

export type OnboardingSetupStageOperationFilterInput = {
  eq?: InputMaybe<OnboardingSetupStage>;
  in?: InputMaybe<Array<OnboardingSetupStage>>;
  neq?: InputMaybe<OnboardingSetupStage>;
  nin?: InputMaybe<Array<OnboardingSetupStage>>;
};

export enum OnboardingTrainingStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Unknown = 'UNKNOWN'
}

export type OnboardingTrainingStatusOperationFilterInput = {
  eq?: InputMaybe<OnboardingTrainingStatus>;
  in?: InputMaybe<Array<OnboardingTrainingStatus>>;
  neq?: InputMaybe<OnboardingTrainingStatus>;
  nin?: InputMaybe<Array<OnboardingTrainingStatus>>;
};

/** The result of an upload registration, or why it was refused. */
export type OnboardingUploadRegistrationPayload = {
  __typename?: 'OnboardingUploadRegistrationPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<OnboardingUploadRegistrationResult>;
};

/** What an upload registration committed. */
export type OnboardingUploadRegistrationResult = {
  __typename?: 'OnboardingUploadRegistrationResult';
  /** Where the job stands now. Superseded when a newer version of the source is registered. */
  job: MigrationPreparationJobStatus;
  /** The preparation job: the durable preparation intent the worker discovers and claims. */
  jobId: Scalars['String']['output'];
  /** The journey the upload was registered in. */
  journeyId: Scalars['String']['output'];
  /** Recorded now, or already recorded by an earlier call. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The registered source. */
  sourceId: Scalars['String']['output'];
  /** The registered version of the source. */
  sourceVersion: Scalars['Int']['output'];
};

/** The caller's Home welcome preference, with snooze expiry evaluated at read time. */
export type OnboardingWelcomePreference = {
  __typename?: 'OnboardingWelcomePreference';
  /** When the user dismissed the welcome for good. */
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True once the user dismissed the welcome. */
  isDismissed: Scalars['Boolean']['output'];
  /** True while a snooze is in force. */
  isSnoozed: Scalars['Boolean']['output'];
  /** When the current or last snooze was recorded. */
  snoozedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When that snooze ends. */
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
};

/** The caller's Home welcome preference after the command, or why it failed. */
export type OnboardingWelcomePreferencePayload = {
  __typename?: 'OnboardingWelcomePreferencePayload';
  errors?: Maybe<Array<ValidationError>>;
  preference?: Maybe<OnboardingWelcomePreference>;
};

/** One online payment in full, as grower finance staff inspect it. */
export type OnlinePaymentAttemptDetail = {
  __typename?: 'OnlinePaymentAttemptDetail';
  /** The gross received, once the payment succeeded; otherwise null. */
  amountReceived?: Maybe<Scalars['Decimal']['output']>;
  /** The payment attempt's id. */
  attemptId: Scalars['String']['output'];
  /** The charge's balance transaction, once the payment succeeded; otherwise null. */
  balanceTransactionId?: Maybe<Scalars['String']['output']>;
  /** GUEST or PORTAL. */
  channel: PaymentAttemptChannel;
  /** The Stripe charge that moved the money, once the payment succeeded; otherwise null. */
  chargeId?: Maybe<Scalars['String']['output']>;
  /** The ISO-4217 currency. */
  currency: Scalars['String']['output'];
  /** The customer the payment recorded when it started. */
  customerId: Scalars['String']['output'];
  /** True when a bank payment kept the discount it was eligible for when started. */
  discountKeptFromInitiation: Scalars['Boolean']['output'];
  /** What disputes withdrew. */
  disputedAmount: Scalars['Decimal']['output'];
  /** Every dispute. */
  disputes: Array<OnlinePaymentDispute>;
  /** When it succeeded, failed or ended, once it did; otherwise null. */
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Stripe's fee on it, once read; otherwise null. */
  fee?: Maybe<Scalars['Decimal']['output']>;
  /** When a bank payment was started, once one was; otherwise null. */
  initiatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Each invoice's share and what became of it. */
  invoices: Array<OnlinePaymentAttemptInvoice>;
  /** Why it failed, when it did; otherwise null. */
  lastFailure?: Maybe<Scalars['String']['output']>;
  /** How the payer paid, once Stripe reported it; otherwise null. */
  method?: Maybe<InvoicePaymentMethod>;
  /** What it left on the grower's account after the fee, once read; otherwise null. */
  net?: Maybe<Scalars['Decimal']['output']>;
  /** What the payment still holds: received, less what was taken back, plus what was given back. */
  netReceived: Scalars['Decimal']['output'];
  /** The Stripe payment reference, once named; otherwise null. */
  paymentReference?: Maybe<Scalars['String']['output']>;
  /** When the payment counts as received for its invoices, once it succeeded; otherwise null. */
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** What a new refund may still ask for. */
  refundableAmount: Scalars['Decimal']['output'];
  /** What refunds Stripe confirmed took back. */
  refundedAmount: Scalars['Decimal']['output'];
  /** Every refund staff asked for. */
  refunds: Array<OnlinePaymentRefund>;
  /** What Stripe gave back after disputes. */
  reinstatedAmount: Scalars['Decimal']['output'];
  /** Every refund and dispute withdrawal, and where it came off. */
  reversals: Array<OnlinePaymentReversal>;
  /** When the payment was started. */
  startedAt: Scalars['DateTime']['output'];
  /** OPEN, PROCESSING, SUCCEEDED, FAILED, CANCELLED or EXPIRED. */
  status: PaymentAttemptStatus;
  /** What the payer is charged. */
  total: Scalars['Decimal']['output'];
};

/** One invoice's share of an online payment, and what became of it. */
export type OnlinePaymentAttemptInvoice = {
  __typename?: 'OnlinePaymentAttemptInvoice';
  /** The cash the payment collects for the invoice. */
  allocatedAmount: Scalars['Decimal']['output'];
  /** The cash recorded against the invoice once settled; zero until then. */
  appliedAmount: Scalars['Decimal']['output'];
  /** The cash refunds and disputes took back off the invoice. */
  cashReversed: Scalars['Decimal']['output'];
  /** The credit entry the unapplied credit was recorded as, when any was. */
  creditEntryId?: Maybe<Scalars['String']['output']>;
  /** Whether staff marked the unapplied credit reviewed. */
  creditReviewed: Scalars['Boolean']['output'];
  /** The early-pay discount the allocated amount takes off. */
  discountAmount: Scalars['Decimal']['output'];
  /** The early-pay discount recorded with the payment once settled. */
  discountApplied: Scalars['Decimal']['output'];
  /** The invoice. */
  invoiceId: Scalars['String']['output'];
  /** The invoice number. */
  invoiceNumber: Scalars['String']['output'];
  /** The late charge the allocated amount adds on. */
  lateChargeAmount: Scalars['Decimal']['output'];
  /** APPLIED, NOTHING_PAYABLE or INVOICE_VOIDED once settled; otherwise null. */
  outcome?: Maybe<PaymentAttemptAllocationOutcome>;
  /** What the invoice owed when the payment started. */
  postedBalance: Scalars['Decimal']['output'];
  /** The part kept as unapplied credit for the customer; zero otherwise. */
  unappliedCreditAmount: Scalars['Decimal']['output'];
};

/** One invoice's share of an online payment, in a payment list. */
export type OnlinePaymentAttemptInvoiceSummary = {
  __typename?: 'OnlinePaymentAttemptInvoiceSummary';
  /** The cash the payment collects for the invoice. */
  allocatedAmount: Scalars['Decimal']['output'];
  /** The early-pay discount the allocated amount already takes off. */
  discountAmount: Scalars['Decimal']['output'];
  /** The invoice. */
  invoiceId: Scalars['String']['output'];
  /** The invoice number, as the payer saw it. */
  invoiceNumber: Scalars['String']['output'];
};

/** One page of online payments, newest first. */
export type OnlinePaymentAttemptPage = {
  __typename?: 'OnlinePaymentAttemptPage';
  /** The payments on this page. */
  items: Array<OnlinePaymentAttemptSummary>;
  /** How many payments match the filter in all. */
  totalCount: Scalars['Long']['output'];
};

/** One online payment, as grower finance staff list it. */
export type OnlinePaymentAttemptSummary = {
  __typename?: 'OnlinePaymentAttemptSummary';
  /** The gross received, once the payment succeeded; otherwise null. */
  amountReceived?: Maybe<Scalars['Decimal']['output']>;
  /** The payment attempt's id. */
  attemptId: Scalars['String']['output'];
  /** GUEST (a pay link) or PORTAL (a signed-in buyer). */
  channel: PaymentAttemptChannel;
  /** The ISO-4217 currency. */
  currency: Scalars['String']['output'];
  /** The customer the payment recorded when it started; never rewritten by a customer combine. */
  customerId: Scalars['String']['output'];
  /** The early-pay discount the payment's amounts take off, across its invoices. */
  discountAmount: Scalars['Decimal']['output'];
  /**
   * True when a bank payment kept the discount it was eligible for when the payer started it, even though it cleared
   * later.
   */
  discountKeptFromInitiation: Scalars['Boolean']['output'];
  /** What disputes withdrew. */
  disputedAmount: Scalars['Decimal']['output'];
  /** When it succeeded, failed or ended, once it did; otherwise null. */
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Stripe's fee on it, once read from its balance transaction; otherwise null. */
  fee?: Maybe<Scalars['Decimal']['output']>;
  /** Each invoice's share. */
  invoices: Array<OnlinePaymentAttemptInvoiceSummary>;
  /** Why it failed, when it did; otherwise null. */
  lastFailure?: Maybe<Scalars['String']['output']>;
  /** How the payer paid, once Stripe reported it; otherwise null. */
  method?: Maybe<InvoicePaymentMethod>;
  /** What it left on the grower's account after the fee, once read; otherwise null. */
  net?: Maybe<Scalars['Decimal']['output']>;
  /** The Stripe payment reference, once Stripe named it; otherwise null. */
  paymentReference?: Maybe<Scalars['String']['output']>;
  /** What refunds Stripe confirmed took back. */
  refundedAmount: Scalars['Decimal']['output'];
  /** When the payment was started. */
  startedAt: Scalars['DateTime']['output'];
  /** OPEN, PROCESSING, SUCCEEDED, FAILED, CANCELLED or EXPIRED. */
  status: PaymentAttemptStatus;
  /** What the payer is charged. */
  total: Scalars['Decimal']['output'];
};

/** One dispute of an online payment, as far as Stripe has taken it. */
export type OnlinePaymentDispute = {
  __typename?: 'OnlinePaymentDispute';
  /** The amount disputed. */
  amount: Scalars['Decimal']['output'];
  /** When it closed, once it did; otherwise null. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Stripe dispute. */
  disputeId: Scalars['String']['output'];
  /** Whether Stripe withdrew the disputed amount. */
  fundsWithdrawn: Scalars['Boolean']['output'];
  /** When it was opened, once recorded; otherwise null. */
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  /** WON, LOST or INQUIRY_CLOSED once closed; otherwise null. */
  outcome?: Maybe<PaymentAttemptDisputeOutcome>;
  /** Stripe's reason, once the opening was recorded; otherwise null. */
  reason?: Maybe<Scalars['String']['output']>;
  /** What Stripe gave back, kept as unapplied credit, once it did; otherwise null. */
  reinstatedAmount?: Maybe<Scalars['Decimal']['output']>;
};

/** A payment that could not be settled as it arrived, held with its evidence for staff. */
export type OnlinePaymentException = {
  __typename?: 'OnlinePaymentException';
  /** The payment attempt, when Work Suite has it; otherwise null. */
  attemptId?: Maybe<Scalars['String']['output']>;
  /** A plain description of what disagreed. */
  detail: Scalars['String']['output'];
  /** That event's type. */
  eventType: Scalars['String']['output'];
  /** The exception's id; replay it by this id. */
  exceptionId: Scalars['String']['output'];
  /** What the payment was expected to carry, when known; otherwise null. */
  expectedAmount?: Maybe<Scalars['Decimal']['output']>;
  /** The payment's currency, when known; otherwise null. */
  expectedCurrency?: Maybe<Scalars['String']['output']>;
  /** The invoice whose share is held, when one share is held; otherwise null. */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /** When it was last replayed, once it was; otherwise null. */
  lastReplayedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who last replayed it, once someone did; otherwise null. */
  lastReplayedBy?: Maybe<Scalars['String']['output']>;
  /** The Stripe payment reference, when the event named one; otherwise null. */
  paymentReference?: Maybe<Scalars['String']['output']>;
  /** Why it was held. */
  reason: PaymentReconciliationExceptionReason;
  /** What Stripe reported, when it reported an amount; otherwise null. */
  receivedAmount?: Maybe<Scalars['Decimal']['output']>;
  /** The currency Stripe reported, when it reported one; otherwise null. */
  receivedCurrency?: Maybe<Scalars['String']['output']>;
  /** When it was held. */
  recordedAt: Scalars['DateTime']['output'];
  /** How staff resolved it by hand, once they did; otherwise null. */
  resolutionNote?: Maybe<Scalars['String']['output']>;
  /** Whether a replay settled it, or staff marked it resolved. */
  resolved: Scalars['Boolean']['output'];
  /** When it was marked resolved by hand, once it was; otherwise null. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who marked it resolved by hand, once someone did; otherwise null. */
  resolvedBy?: Maybe<Scalars['String']['output']>;
  /** The refund or dispute withdrawal held, when money leaving a payment was held; otherwise null. */
  reversalKey?: Maybe<Scalars['String']['output']>;
  /** The Checkout session the payment was made through. */
  sessionId: Scalars['String']['output'];
  /** The Stripe event that raised it. */
  stripeEventId: Scalars['String']['output'];
};

/** A refund grower finance staff asked for, and where it stands. */
export type OnlinePaymentRefund = {
  __typename?: 'OnlinePaymentRefund';
  /** The amount asked for. */
  amount: Scalars['Decimal']['output'];
  /** The payment refunded. */
  attemptId: Scalars['String']['output'];
  /**
   * Whether Stripe confirmed the refund and its money was taken back off the payment; the same as status CONFIRMED.
   * Show where the refund stands from status: false is also the answer for a refund Stripe reported failed or canceled.
   */
  confirmed: Scalars['Boolean']['output'];
  /** Why staff asked for it. */
  reason: Scalars['String']['output'];
  /** The request's id; sending it again is safe. */
  refundRequestId: Scalars['String']['output'];
  /** When. */
  requestedAt: Scalars['DateTime']['output'];
  /** Who asked for it. */
  requestedBy: Scalars['String']['output'];
  /**
   * Where the refund stands: PENDING until Stripe confirms, fails or cancels it (nothing has moved in Work Suite yet);
   * CONFIRMED once its money was taken back off the payment; FAILED or CANCELED when Stripe reported so before its money
   * left, or FAILED when Stripe refused to make it, so nothing was taken back and a new refund, with a new
   * refundRequestId, may be asked for.
   */
  status: PaymentAttemptRefundStatus;
  /** Stripe's refund, once Stripe accepted it; otherwise null. */
  stripeRefundId?: Maybe<Scalars['String']['output']>;
  /** PAYMENT or UNAPPLIED_CREDIT. */
  target: PaymentAttemptRefundTarget;
};

/**
 * Where a refund would come off if Stripe confirmed it now, decided by the same rule the webhook applies. Nothing moves:
 * a preview locks nothing.
 */
export type OnlinePaymentRefundPreview = {
  __typename?: 'OnlinePaymentRefundPreview';
  /** The amount previewed. */
  amount: Scalars['Decimal']['output'];
  /** The part taken back from unapplied credit. */
  creditAmount: Scalars['Decimal']['output'];
  /** The cash taken back off each invoice. */
  invoices: Array<OnlinePaymentRefundPreviewInvoice>;
  /** The rule that split it. */
  policy: Scalars['String']['output'];
  /** What a refund may still ask for. */
  refundableAmount: Scalars['Decimal']['output'];
  /** The payment's unapplied credit still on the customer's balance. */
  unappliedCreditAvailable: Scalars['Decimal']['output'];
};

/** What one invoice gives back in a refund preview. */
export type OnlinePaymentRefundPreviewInvoice = {
  __typename?: 'OnlinePaymentRefundPreviewInvoice';
  /** The cash taken back. */
  cashReversed: Scalars['Decimal']['output'];
  /** The early-pay discount given back with it. */
  discountReversed: Scalars['Decimal']['output'];
  /** The invoice. */
  invoiceId: Scalars['String']['output'];
  /** Whether it would take the invoice from paid back to owing, which also revokes the invoice's pay link when it has one. */
  reopensFromPaid: Scalars['Boolean']['output'];
};

/** The result of a refund preview. */
export type OnlinePaymentRefundPreviewPayload = {
  __typename?: 'OnlinePaymentRefundPreviewPayload';
  /** Why it was refused, when it was. */
  errors?: Maybe<Array<ValidationError>>;
  /** Where the refund would come off; null when refused. */
  preview?: Maybe<OnlinePaymentRefundPreview>;
};

/** Money an online payment brought in that left the grower's account again, and where it came off. */
export type OnlinePaymentReversal = {
  __typename?: 'OnlinePaymentReversal';
  /** The amount taken back. */
  amount: Scalars['Decimal']['output'];
  /** The part taken back from the payment's unapplied credit. */
  creditAmount: Scalars['Decimal']['output'];
  /** The cash taken back off each invoice. */
  invoices: Array<OnlinePaymentReversalInvoice>;
  /** REFUND or DISPUTE_FUNDS_WITHDRAWN. */
  kind: PaymentAttemptReversalKind;
  /** When Stripe reported it. */
  occurredAt: Scalars['DateTime']['output'];
  /** The rule that split it between the credit and the invoices. */
  policy: Scalars['String']['output'];
  /** Stripe's reason, when it gave one; otherwise null. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The staff refund request it answers, when there is one; otherwise null. */
  refundRequestId?: Maybe<Scalars['String']['output']>;
  /** The key it is recorded under once. */
  reversalKey: Scalars['String']['output'];
  /** The Stripe refund or dispute. */
  stripeObjectId: Scalars['String']['output'];
};

/** What one reversal took back from one invoice. */
export type OnlinePaymentReversalInvoice = {
  __typename?: 'OnlinePaymentReversalInvoice';
  /** The cash taken back. */
  cashReversed: Scalars['Decimal']['output'];
  /** The early-pay discount given back with it. */
  discountReversed: Scalars['Decimal']['output'];
  /** The invoice. */
  invoiceId: Scalars['String']['output'];
  /** The late charge given back with it. */
  lateChargeReversed: Scalars['Decimal']['output'];
  /** Whether it revoked the invoice's pay link; staff send any new link. */
  payLinkRevoked: Scalars['Boolean']['output'];
  /** Whether it took the invoice from paid back to owing. */
  reopenedFromPaid: Scalars['Boolean']['output'];
};

/** Unapplied credit one online payment left for a customer, for staff review. */
export type OnlinePaymentUnappliedCredit = {
  __typename?: 'OnlinePaymentUnappliedCredit';
  /** The payment that left it. */
  attemptId: Scalars['String']['output'];
  /** The credit entry. */
  creditEntryId: Scalars['String']['output'];
  /** What the share credited. */
  creditedAmount: Scalars['Decimal']['output'];
  /** The customer the credit is on. */
  customerId: Scalars['String']['output'];
  /** The gross the payment brought in, once it succeeded; otherwise null. */
  grossReceipt?: Maybe<Scalars['Decimal']['output']>;
  /** The invoice whose share left the credit. */
  invoiceId: Scalars['String']['output'];
  /** The payment's Stripe reference, the source payment; null until Stripe named it. */
  paymentReference?: Maybe<Scalars['String']['output']>;
  /** When the payment counts as received. */
  receivedAt: Scalars['DateTime']['output'];
  /** Whether staff marked it reviewed. */
  reviewed: Scalars['Boolean']['output'];
  /** When, once reviewed; otherwise null. */
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who reviewed it, once someone did; otherwise null. */
  reviewedBy?: Maybe<Scalars['String']['output']>;
  /** What is still unapplied of it now. */
  unappliedAmount: Scalars['Decimal']['output'];
};

/** One page of the unapplied credit online payments left, newest payment first. */
export type OnlinePaymentUnappliedCreditPage = {
  __typename?: 'OnlinePaymentUnappliedCreditPage';
  /** The credit the payments on this page left; credit used up is left out unless asked for. */
  items: Array<OnlinePaymentUnappliedCredit>;
  /** How many credited payments match the filter in all: what skip and take page through. */
  totalCount: Scalars['Long']['output'];
};

/** One open job, as the background jobs worker discovers it. */
export type OpenBackgroundJobRef = {
  __typename?: 'OpenBackgroundJobRef';
  /** When the job was requested. */
  createdAt: Scalars['DateTime']['output'];
  /** The job id, unique within the tenant. */
  jobId: Scalars['String']['output'];
  /** The tenant that owns the job. */
  tenantId: Scalars['String']['output'];
  /** What the job does. */
  type: BackgroundJobType;
};

/** A connection to a list of items. */
export type OpenBulkOrderDeleteJobsConnection = {
  __typename?: 'OpenBulkOrderDeleteJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OpenBulkOrderDeleteJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BulkOrderDeleteJobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OpenBulkOrderDeleteJobsEdge = {
  __typename?: 'OpenBulkOrderDeleteJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BulkOrderDeleteJobDocument;
};

/** A correction run the worker still has to advance. */
export type OpenCorrectionRun = {
  __typename?: 'OpenCorrectionRun';
  /** The registered correction the run executes. */
  correctionKey: Scalars['String']['output'];
  /** Approved rows without a result yet. 0 for a run that only has its verify left. */
  rowsRemaining: Scalars['Int']['output'];
  /** The run, as advanceCorrectionRun takes it. */
  runId: Scalars['String']['output'];
  /** The tenant the run corrects: the worker calls advanceCorrectionRun as this tenant. */
  tenantId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type OpenCorrectionRunsConnection = {
  __typename?: 'OpenCorrectionRunsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OpenCorrectionRunsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OpenCorrectionRun>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OpenCorrectionRunsEdge = {
  __typename?: 'OpenCorrectionRunsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OpenCorrectionRun;
};

/** A connection to a list of items. */
export type OpenFeatureFlagProductConversionJobsConnection = {
  __typename?: 'OpenFeatureFlagProductConversionJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OpenFeatureFlagProductConversionJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FeatureFlagProductConversionJob>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OpenFeatureFlagProductConversionJobsEdge = {
  __typename?: 'OpenFeatureFlagProductConversionJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FeatureFlagProductConversionJob;
};

/** Input opening a new GrowerBenchmark collection cycle for a community (contract D9). */
export type OpenGrowerBenchmarkCycleInput = {
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Target deadline timestamp for member submissions. */
  dueAt: Scalars['DateTime']['input'];
  /** Program reviewer-facing cycle name. */
  label: Scalars['String']['input'];
  /** Ordered period identifiers collected by this cycle window. */
  periodIds: Array<Scalars['String']['input']>;
};

export type OptionOfBooleanFilterInput = {
  and?: InputMaybe<Array<OptionOfBooleanFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfBooleanFilterInput>>;
};

export type OptionOfDateOnlyFilterInput = {
  and?: InputMaybe<Array<OptionOfDateOnlyFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfDateOnlyFilterInput>>;
};

export type OptionOfDecimalFilterInput = {
  and?: InputMaybe<Array<OptionOfDecimalFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfDecimalFilterInput>>;
};

export type OptionOfDoubleFilterInput = {
  and?: InputMaybe<Array<OptionOfDoubleFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfDoubleFilterInput>>;
};

export type OptionOfInt32FilterInput = {
  and?: InputMaybe<Array<OptionOfInt32FilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfInt32FilterInput>>;
};

export type OptionOfMasterOrderContactDocumentDataFilterInput = {
  and?: InputMaybe<Array<OptionOfMasterOrderContactDocumentDataFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfMasterOrderContactDocumentDataFilterInput>>;
};

export type OptionOfMergeDevPaymentLedgerFilterInput = {
  and?: InputMaybe<Array<OptionOfMergeDevPaymentLedgerFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfMergeDevPaymentLedgerFilterInput>>;
};

export type OptionOfMergeDevRevenueRungFilterInput = {
  and?: InputMaybe<Array<OptionOfMergeDevRevenueRungFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfMergeDevRevenueRungFilterInput>>;
};

export type OptionOfMoneyDataFilterInput = {
  and?: InputMaybe<Array<OptionOfMoneyDataFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfMoneyDataFilterInput>>;
};

export type OptionOfOrderDropShipDestinationDataFilterInput = {
  and?: InputMaybe<Array<OptionOfOrderDropShipDestinationDataFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfOrderDropShipDestinationDataFilterInput>>;
};

export type OptionOfOtaRolloutStatusFilterInput = {
  and?: InputMaybe<Array<OptionOfOtaRolloutStatusFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfOtaRolloutStatusFilterInput>>;
};

export type OptionOfStringFilterInput = {
  and?: InputMaybe<Array<OptionOfStringFilterInput>>;
  isNone?: InputMaybe<BooleanOperationFilterInput>;
  isSome?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OptionOfStringFilterInput>>;
};

/** Represents the aggregated address edit permissions for orders at the tenant, customer, and location levels. */
export type OrderAddressEditPermissions = {
  __typename?: 'OrderAddressEditPermissions';
  /**
   * Gets a value indicating whether billing addresses can be edited for orders.
   * This is an aggregate of tenant, customer, and location level permissions - all must be true for this to be true.
   */
  billingAddressEditable: Scalars['Boolean']['output'];
  /**
   * Gets a value indicating whether location addresses can be edited for orders.
   * This is an aggregate of tenant, customer, and location level permissions - all must be true for this to be true.
   */
  locationAddressEditable: Scalars['Boolean']['output'];
};

export enum OrderAllocationStatus {
  Allocated = 'ALLOCATED',
  MakeToOrder = 'MAKE_TO_ORDER',
  NotStarted = 'NOT_STARTED',
  Partial = 'PARTIAL',
  Short = 'SHORT'
}

/** One source contribution to an order allocation transfer. */
export type OrderAllocationTake = {
  __typename?: 'OrderAllocationTake';
  /** This line and location allocation immediately after this contribution. */
  allocatedAfter?: Maybe<Scalars['Int']['output']>;
  /** This line and location allocation immediately before this contribution. */
  allocatedBefore?: Maybe<Scalars['Int']['output']>;
  /** Whether this order supplied or received the plants. */
  direction: AllocationTakeDirection;
  /** The inventory grade of the transferred plants. */
  grade: Scalars['Int']['output'];
  /** The transferred inventory item id. */
  itemId: Scalars['String']['output'];
  /** The current item name, when available. */
  itemName?: Maybe<Scalars['String']['output']>;
  /** The line on this order whose allocation changed. */
  lineItemId: Scalars['UUID']['output'];
  /** The location holding the transferred plants. */
  locationId: Scalars['String']['output'];
  /** The current location name, when available. */
  locationName?: Maybe<Scalars['String']['output']>;
  /** The current other order customer name, when available. */
  otherCustomerName?: Maybe<Scalars['String']['output']>;
  /** The receiving order for TAKEN_FOR, or the source order for TAKEN_FROM. */
  otherOrderId: Scalars['String']['output'];
  /** The current other order number, when available. */
  otherOrderNumber?: Maybe<Scalars['String']['output']>;
  /** The number of eaches transferred in this contribution. */
  quantity: Scalars['Int']['output'];
  /** The time the transfer was recorded in the event. */
  takenAt: Scalars['DateTime']['output'];
  /** The actor display name, falling back to the event email. */
  takenBy: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type OrderAllocationsConnection = {
  __typename?: 'OrderAllocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderAllocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AllocationItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderAllocationsEdge = {
  __typename?: 'OrderAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AllocationItemDocument;
};

export type OrderAssociationDataInput = {
  orderId: Scalars['String']['input'];
};

export type OrderCategoryVolumeDiscountData = {
  __typename?: 'OrderCategoryVolumeDiscountData';
  amount: Scalars['Decimal']['output'];
  categoryCode: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  discountedQuantity: Scalars['Decimal']['output'];
  lines: Array<OrderCategoryVolumeLineData>;
  matchedThreshold: Scalars['Decimal']['output'];
  qualifiedNotDiscountedByReason: Array<OrderCategoryVolumeExclusionData>;
  qualifiedNotDiscountedQuantity: Scalars['Decimal']['output'];
  qualifyingQuantity: Scalars['Decimal']['output'];
  tierPrice?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One category's tier-derived volume discount as stored on OrdersDocument and exposed
 * to clients. Document-only sub-record (boundary type suffix not applied because the parent
 * OrdersDocument is itself the read-model boundary type), used by this document and
 * nothing else, so a future field here can never break another type's backward compatibility.
 *
 * Mirrors the domain's OrderCategoryVolumeDiscount, with two boundary conversions: the
 * domain's Option<decimal> tier price becomes a nullable TierPrice
 * (null = the tier derives a different price per item, NOT a free tier), and dollar figures are
 * plain decimal rather than MoneyData because every amount on an order shares the
 * order's single currency, already carried on the document's money fields.
 */
export type OrderCategoryVolumeDiscountDocument = {
  __typename?: 'OrderCategoryVolumeDiscountDocument';
  /** This category's total discount in dollars — the sum of lines. */
  amount: Scalars['Decimal']['output'];
  /**
   * The category's CODE. A TargetType.Category price level stores the category's guid in its
   * TargetId, never this code.
   */
  categoryCode: Scalars['String']['output'];
  /** Display label; equal to CategoryCode today. */
  categoryName: Scalars['String']['output'];
  /**
   * Quantity of the lines actually ASSIGNED to this category — strictly the quantity PAID at the
   * tier. It falls below qualifyingQuantity for either of two independent reasons: a
   * multi-category line counts toward every category's qualifying quantity but is PAID by exactly
   * one, and an item-priced or overridden line supplies qualifying quantity while earning no
   * receipt anywhere. A difference is therefore NOT a multi-category signal on its own —
   * qualifiedNotDiscountedByReason states which it was.
   */
  discountedQuantity: Scalars['Decimal']['output'];
  /** Per-line receipts, for the explainer and for the tax base's exact apportionment. */
  lines: Array<OrderCategoryVolumeLineDocument>;
  /** The winning tier's threshold — the highest one ≤ the qualifying quantity. */
  matchedThreshold: Scalars['Decimal']['output'];
  /**
   * qualifiedNotDiscountedQuantity broken down by cause, ordered by reason and summing
   * exactly to it. ASSIGNED_TO_ANOTHER_CATEGORY is the one reason that does not mean the
   * customer went unpaid — those units were discounted under the category that benefited them most.
   * NON_DISCOUNTABLE_ITEM never appears: such units are outside qualifyingQuantity in
   * the first place and are reported on the progress row.
   */
  qualifiedNotDiscountedByReason: Array<OrderCategoryVolumeExclusionDocument>;
  /**
   * The units that bought this tier and were paid nothing at it — the total of
   * qualifiedNotDiscountedByReason, and nothing else. Server-computed so a client rendering
   * both figures never has to derive the shortfall against a differently-filtered numerator. Zero
   * on an order last recomputed before this field existed, alongside an empty breakdown. Render
   * THIS number beside its breakdown rather than computing
   * qualifyingQuantity − discountedQuantity and assuming the buckets account for all of it:
   * the two are equal on every order today, but only units with a stated cause are counted here, so
   * this figure can never over-claim and can in principle be the smaller of the two.
   */
  qualifiedNotDiscountedQuantity: Scalars['Decimal']['output'];
  /**
   * The order's total COUNTING quantity in this category — the number qualified against the tier
   * thresholds, and the popover's "2,550 / 2,550" numerator. Item-priced and overridden lines are
   * INCLUDED (the customer bought those units, so they are genuinely how much of this category is
   * on the order); only non-discountable lines are withheld, and those are reported on the matching
   * progress row's excludedByReason.
   */
  qualifyingQuantity: Scalars['Decimal']['output'];
  /**
   * The winning tier's unit price when every contributing line resolved the SAME one. null
   * when they did not; the exact per-line prices remain on lines. Null rather than 0
   * deliberately — a zero here would read as a free tier.
   */
  tierPrice?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One category's tier-derived volume discount as stored on OrdersDocument and exposed
 * to clients. Document-only sub-record (boundary type suffix not applied because the parent
 * OrdersDocument is itself the read-model boundary type), used by this document and
 * nothing else, so a future field here can never break another type's backward compatibility.
 *
 * Mirrors the domain's OrderCategoryVolumeDiscount, with two boundary conversions: the
 * domain's Option<decimal> tier price becomes a nullable TierPrice
 * (null = the tier derives a different price per item, NOT a free tier), and dollar figures are
 * plain decimal rather than MoneyData because every amount on an order shares the
 * order's single currency, already carried on the document's money fields.
 */
export type OrderCategoryVolumeDiscountDocumentFilterInput = {
  /** This category's total discount in dollars — the sum of lines. */
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<OrderCategoryVolumeDiscountDocumentFilterInput>>;
  /**
   * The category's CODE. A TargetType.Category price level stores the category's guid in its
   * TargetId, never this code.
   */
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  /** Display label; equal to CategoryCode today. */
  categoryName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Quantity of the lines actually ASSIGNED to this category — strictly the quantity PAID at the
   * tier. It falls below qualifyingQuantity for either of two independent reasons: a
   * multi-category line counts toward every category's qualifying quantity but is PAID by exactly
   * one, and an item-priced or overridden line supplies qualifying quantity while earning no
   * receipt anywhere. A difference is therefore NOT a multi-category signal on its own —
   * qualifiedNotDiscountedByReason states which it was.
   */
  discountedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Per-line receipts, for the explainer and for the tax base's exact apportionment. */
  lines?: InputMaybe<ListFilterInputTypeOfOrderCategoryVolumeLineDocumentFilterInput>;
  /** The winning tier's threshold — the highest one ≤ the qualifying quantity. */
  matchedThreshold?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderCategoryVolumeDiscountDocumentFilterInput>>;
  /**
   * qualifiedNotDiscountedQuantity broken down by cause, ordered by reason and summing
   * exactly to it. ASSIGNED_TO_ANOTHER_CATEGORY is the one reason that does not mean the
   * customer went unpaid — those units were discounted under the category that benefited them most.
   * NON_DISCOUNTABLE_ITEM never appears: such units are outside qualifyingQuantity in
   * the first place and are reported on the progress row.
   */
  qualifiedNotDiscountedByReason?: InputMaybe<ListFilterInputTypeOfOrderCategoryVolumeExclusionDocumentFilterInput>;
  /**
   * The units that bought this tier and were paid nothing at it — the total of
   * qualifiedNotDiscountedByReason, and nothing else. Server-computed so a client rendering
   * both figures never has to derive the shortfall against a differently-filtered numerator. Zero
   * on an order last recomputed before this field existed, alongside an empty breakdown. Render
   * THIS number beside its breakdown rather than computing
   * qualifyingQuantity − discountedQuantity and assuming the buckets account for all of it:
   * the two are equal on every order today, but only units with a stated cause are counted here, so
   * this figure can never over-claim and can in principle be the smaller of the two.
   */
  qualifiedNotDiscountedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The order's total COUNTING quantity in this category — the number qualified against the tier
   * thresholds, and the popover's "2,550 / 2,550" numerator. Item-priced and overridden lines are
   * INCLUDED (the customer bought those units, so they are genuinely how much of this category is
   * on the order); only non-discountable lines are withheld, and those are reported on the matching
   * progress row's excludedByReason.
   */
  qualifyingQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The winning tier's unit price when every contributing line resolved the SAME one. null
   * when they did not; the exact per-line prices remain on lines. Null rather than 0
   * deliberately — a zero here would read as a free tier.
   */
  tierPrice?: InputMaybe<DecimalOperationFilterInput>;
};

export type OrderCategoryVolumeExclusionData = {
  __typename?: 'OrderCategoryVolumeExclusionData';
  quantity: Scalars['Decimal']['output'];
  reason: CategoryVolumeExclusionReason;
};

/**
 * One reason bucket in a category-volume exclusion breakdown, as stored on OrdersDocument and
 * exposed to clients. Document-only sub-record, used by the two category-volume documents and
 * nothing else.
 */
export type OrderCategoryVolumeExclusionDocument = {
  __typename?: 'OrderCategoryVolumeExclusionDocument';
  /** Units attributed to this reason; always strictly positive. */
  quantity: Scalars['Decimal']['output'];
  /**
   * Why these units are missing from the figure this bucket breaks down. Read it together with the
   * COLLECTION it came from: the same vocabulary answers two different questions (was the quantity
   * excluded from qualification, or did it qualify and get paid nothing), and a reason only means
   * something against the one it is answering.
   */
  reason: CategoryVolumeExclusionReason;
};

/**
 * One reason bucket in a category-volume exclusion breakdown, as stored on OrdersDocument and
 * exposed to clients. Document-only sub-record, used by the two category-volume documents and
 * nothing else.
 */
export type OrderCategoryVolumeExclusionDocumentFilterInput = {
  and?: InputMaybe<Array<OrderCategoryVolumeExclusionDocumentFilterInput>>;
  or?: InputMaybe<Array<OrderCategoryVolumeExclusionDocumentFilterInput>>;
  /** Units attributed to this reason; always strictly positive. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Why these units are missing from the figure this bucket breaks down. Read it together with the
   * COLLECTION it came from: the same vocabulary answers two different questions (was the quantity
   * excluded from qualification, or did it qualify and get paid nothing), and a reason only means
   * something against the one it is answering.
   */
  reason?: InputMaybe<CategoryVolumeExclusionReasonOperationFilterInput>;
};

export type OrderCategoryVolumeLineData = {
  __typename?: 'OrderCategoryVolumeLineData';
  amount: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  linePrice: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  tierPrice: Scalars['Decimal']['output'];
};

/**
 * One order line's contribution to a category's volume discount. Amount is
 * (LinePrice − TierPrice) × Quantity, floored at zero — a line already priced at or below
 * the tier contributes exactly 0, never a negative "discount".
 */
export type OrderCategoryVolumeLineDocument = {
  __typename?: 'OrderCategoryVolumeLineDocument';
  amount: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  /** The unit price the line is charged, which this discount does NOT change. */
  linePrice: Scalars['Decimal']['output'];
  /** The item the line named before an item combine moved it to itemId; null when no combine moved it. */
  originalItemId?: Maybe<Scalars['String']['output']>;
  /**
   * The line's SUBTOTAL quantity basis (eaches when present, otherwise quantity) — the same basis the
   * line's money is computed on.
   */
  quantity: Scalars['Decimal']['output'];
  tierPrice: Scalars['Decimal']['output'];
};

/**
 * One order line's contribution to a category's volume discount. Amount is
 * (LinePrice − TierPrice) × Quantity, floored at zero — a line already priced at or below
 * the tier contributes exactly 0, never a negative "discount".
 */
export type OrderCategoryVolumeLineDocumentFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<OrderCategoryVolumeLineDocumentFilterInput>>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  lineItemId?: InputMaybe<UuidOperationFilterInput>;
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  /** The unit price the line is charged, which this discount does NOT change. */
  linePrice?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderCategoryVolumeLineDocumentFilterInput>>;
  /** The item the line named before an item combine moved it to itemId; null when no combine moved it. */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The line's SUBTOTAL quantity basis (eaches when present, otherwise quantity) — the same basis the
   * line's money is computed on.
   */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  tierPrice?: InputMaybe<DecimalOperationFilterInput>;
};

export type OrderCategoryVolumeProgressData = {
  __typename?: 'OrderCategoryVolumeProgressData';
  categoryCode: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  excludedByReason: Array<OrderCategoryVolumeExclusionData>;
  excludedQuantity: Scalars['Decimal']['output'];
  matchedThreshold?: Maybe<Scalars['Decimal']['output']>;
  matchedTierPrice?: Maybe<Scalars['Decimal']['output']>;
  nextThreshold?: Maybe<Scalars['Decimal']['output']>;
  nextTierPrice?: Maybe<Scalars['Decimal']['output']>;
  qualified: Scalars['Boolean']['output'];
  qualifiedNotDiscountedByReason: Array<OrderCategoryVolumeExclusionData>;
  qualifiedNotDiscountedQuantity: Scalars['Decimal']['output'];
  qualifyingQuantity: Scalars['Decimal']['output'];
  quantityToNextThreshold?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One category's LIVE tier progress as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record (boundary type suffix not applied because the parent
 * OrdersDocument is itself the read-model boundary type), used by this document and nothing
 * else.
 *
 * Mirrors the domain's OrderCategoryVolumeProgress, with the boundary conversion that record
 * applies everywhere: its Option<decimal> members become nullable decimal?.
 * null means the value does not exist (no tier reached, no tier ahead, or a tier whose price
 * differs per item) — never zero. A 0m here would read as a free tier or a reached target.
 */
export type OrderCategoryVolumeProgressDocument = {
  __typename?: 'OrderCategoryVolumeProgressDocument';
  /**
   * The category's CODE, as on the matching discount row when one exists. A TargetType.Category price
   * level stores the category's guid in its TargetId, never this code.
   */
  categoryCode: Scalars['String']['output'];
  /** Display label; equal to categoryCode today. */
  categoryName: Scalars['String']['output'];
  /**
   * excludedQuantity broken down by cause, ordered by reason and summing exactly to it.
   * Empty means nothing was excluded — and also on an order last recomputed before this field
   * existed, which reads as zero plus an empty list rather than as a wrong number.
   */
  excludedByReason: Array<OrderCategoryVolumeExclusionDocument>;
  /**
   * Units of this category ON THE ORDER that were held OUT of qualifyingQuantity — the "3"
   * in "8 of 11 units qualify, 3 excluded". The two are DISJOINT, so a client rendering the full
   * picture uses qualifyingQuantity + excludedQuantity as its denominator and
   * qualifyingQuantity alone as the number qualified against the tier. Zero on most orders:
   * only a non-discountable item withholds units.
   */
  excludedQuantity: Scalars['Decimal']['output'];
  /** The threshold of the tier currently reached; null when none is. */
  matchedThreshold?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The reached tier's unit price when it resolves one price across this order's items in the
   * category; null when it does not, and null when nothing is reached.
   */
  matchedTierPrice?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The lowest threshold STRICTLY above qualifyingQuantity — the progress denominator
   * ("2,550"). null when the highest configured tier is already reached, which is the signal
   * to render "top tier reached" instead of a progress bar.
   */
  nextThreshold?: Maybe<Scalars['Decimal']['output']>;
  /** The next tier's unit price — the "$0.99" in the enticement copy. */
  nextTierPrice?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Whether the order currently reaches any tier in this category. true does not imply a
   * discount row exists — a category can qualify and still save nothing, and such a category is
   * deliberately omitted from categoryVolumeDiscounts.
   */
  qualified: Scalars['Boolean']['output'];
  /**
   * qualifiedNotDiscountedQuantity broken down by cause, ordered by reason and summing
   * exactly to it. ASSIGNED_TO_ANOTHER_CATEGORY is the one reason that does not mean the
   * customer went unpaid.
   */
  qualifiedNotDiscountedByReason: Array<OrderCategoryVolumeExclusionDocument>;
  /**
   * Units that ARE inside qualifyingQuantity and are paid nothing at this category's tier. A
   * different statement from excludedQuantity: these units DID buy the tier, they just
   * cannot be paid at it. It is the total of qualifiedNotDiscountedByReason, and nothing
   * else — only units with a stated cause are counted, so it never over-claims. On every order
   * today it also equals qualifyingQuantity − discountedQuantity from the matching discount
   * row, but prefer this figure to that subtraction: they can differ if a tier ever cannot price
   * one of its own category's items. On a category that has reached no tier it counts only the
   * units that could never be paid at one (item-priced, overridden) plus any already paid under
   * another category — never the ordinary catalogue-priced lines, which are first in line for the
   * discount rather than excluded from it.
   */
  qualifiedNotDiscountedQuantity: Scalars['Decimal']['output'];
  /**
   * The order's total COUNTING quantity in this category — the progress numerator ("1,700"), and
   * the very number the discount qualified against. Item-priced and overridden lines COUNT toward
   * it: the customer bought those units, and ordering more of an item-priced SKU does move them
   * closer to a tier. Only non-discountable lines are withheld, and those are reported on
   * excludedQuantity. Zero is a real value, not a missing one.
   */
  qualifyingQuantity: Scalars['Decimal']['output'];
  /**
   * nextThreshold minus qualifyingQuantity, always positive when present — the "850
   * more units". Server-computed so the remaining figure can never be derived against a
   * differently-filtered numerator.
   */
  quantityToNextThreshold?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One category's LIVE tier progress as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record (boundary type suffix not applied because the parent
 * OrdersDocument is itself the read-model boundary type), used by this document and nothing
 * else.
 *
 * Mirrors the domain's OrderCategoryVolumeProgress, with the boundary conversion that record
 * applies everywhere: its Option<decimal> members become nullable decimal?.
 * null means the value does not exist (no tier reached, no tier ahead, or a tier whose price
 * differs per item) — never zero. A 0m here would read as a free tier or a reached target.
 */
export type OrderCategoryVolumeProgressDocumentFilterInput = {
  and?: InputMaybe<Array<OrderCategoryVolumeProgressDocumentFilterInput>>;
  /**
   * The category's CODE, as on the matching discount row when one exists. A TargetType.Category price
   * level stores the category's guid in its TargetId, never this code.
   */
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  /** Display label; equal to categoryCode today. */
  categoryName?: InputMaybe<StringOperationFilterInput>;
  /**
   * excludedQuantity broken down by cause, ordered by reason and summing exactly to it.
   * Empty means nothing was excluded — and also on an order last recomputed before this field
   * existed, which reads as zero plus an empty list rather than as a wrong number.
   */
  excludedByReason?: InputMaybe<ListFilterInputTypeOfOrderCategoryVolumeExclusionDocumentFilterInput>;
  /**
   * Units of this category ON THE ORDER that were held OUT of qualifyingQuantity — the "3"
   * in "8 of 11 units qualify, 3 excluded". The two are DISJOINT, so a client rendering the full
   * picture uses qualifyingQuantity + excludedQuantity as its denominator and
   * qualifyingQuantity alone as the number qualified against the tier. Zero on most orders:
   * only a non-discountable item withholds units.
   */
  excludedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** The threshold of the tier currently reached; null when none is. */
  matchedThreshold?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The reached tier's unit price when it resolves one price across this order's items in the
   * category; null when it does not, and null when nothing is reached.
   */
  matchedTierPrice?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The lowest threshold STRICTLY above qualifyingQuantity — the progress denominator
   * ("2,550"). null when the highest configured tier is already reached, which is the signal
   * to render "top tier reached" instead of a progress bar.
   */
  nextThreshold?: InputMaybe<DecimalOperationFilterInput>;
  /** The next tier's unit price — the "$0.99" in the enticement copy. */
  nextTierPrice?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderCategoryVolumeProgressDocumentFilterInput>>;
  /**
   * Whether the order currently reaches any tier in this category. true does not imply a
   * discount row exists — a category can qualify and still save nothing, and such a category is
   * deliberately omitted from categoryVolumeDiscounts.
   */
  qualified?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * qualifiedNotDiscountedQuantity broken down by cause, ordered by reason and summing
   * exactly to it. ASSIGNED_TO_ANOTHER_CATEGORY is the one reason that does not mean the
   * customer went unpaid.
   */
  qualifiedNotDiscountedByReason?: InputMaybe<ListFilterInputTypeOfOrderCategoryVolumeExclusionDocumentFilterInput>;
  /**
   * Units that ARE inside qualifyingQuantity and are paid nothing at this category's tier. A
   * different statement from excludedQuantity: these units DID buy the tier, they just
   * cannot be paid at it. It is the total of qualifiedNotDiscountedByReason, and nothing
   * else — only units with a stated cause are counted, so it never over-claims. On every order
   * today it also equals qualifyingQuantity − discountedQuantity from the matching discount
   * row, but prefer this figure to that subtraction: they can differ if a tier ever cannot price
   * one of its own category's items. On a category that has reached no tier it counts only the
   * units that could never be paid at one (item-priced, overridden) plus any already paid under
   * another category — never the ordinary catalogue-priced lines, which are first in line for the
   * discount rather than excluded from it.
   */
  qualifiedNotDiscountedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The order's total COUNTING quantity in this category — the progress numerator ("1,700"), and
   * the very number the discount qualified against. Item-priced and overridden lines COUNT toward
   * it: the customer bought those units, and ordering more of an item-priced SKU does move them
   * closer to a tier. Only non-discountable lines are withheld, and those are reported on
   * excludedQuantity. Zero is a real value, not a missing one.
   */
  qualifyingQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * nextThreshold minus qualifyingQuantity, always positive when present — the "850
   * more units". Server-computed so the remaining figure can never be derived against a
   * differently-filtered numerator.
   */
  quantityToNextThreshold?: InputMaybe<DecimalOperationFilterInput>;
};

export type OrderContactData = {
  __typename?: 'OrderContactData';
  emailAddress: EmailAddressData;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: PhoneNumberData;
  title: Scalars['String']['output'];
  type: ContactType;
};

export type OrderContactDataInput = {
  emailAddress: EmailAddressDataInput;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: PhoneNumberDataInput;
  title: Scalars['String']['input'];
  type: ContactType;
};

/**
 * The container a Shipping UOM rides, and how many of that UOM's units fit in one of them.
 * unitsPerContainer is the (UOM × container) pair's own trays-per-layer multiplied by its own
 * layers.
 */
export type OrderContainerFit = {
  __typename?: 'OrderContainerFit';
  containerCode: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  unitsPerContainer: Scalars['Int']['output'];
};

/**
 * A line whose own pack size and whose Shipping UOM's Eaches Per Unit both state a pack and
 * disagree. The line's eaches are unambiguous; how many shipping units they amount to is not, and
 * the line's own pack is what was counted. Kit lines never appear here — their quantities are
 * authored in eaches, so their pack of 1 is correct rather than stale.
 */
export type OrderContainerPackMismatch = {
  __typename?: 'OrderContainerPackMismatch';
  eachesPerUnit: Scalars['Int']['output'];
  handlingUom: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/**
 * How many shipping containers an order needs, derived from its lines' Shipping UOMs and the
 * tenant's container capacities. Derived and never stored: recomputed on every read, so it cannot
 * go stale when the order's lines, the item catalogue or the container setup change.
 */
export type OrderContainerRequirement = {
  __typename?: 'OrderContainerRequirement';
  /**
   * How many of each container the order needs. The container that lines naming no container of
   * their own ride comes first, then the rest by container code. Every Shipping UOM riding the same
   * container is added together before rounding up, so a half-full cart of one UOM and a half-full
   * cart of another are one cart, not two.
   */
  byContainer: Array<OrderContainerTotal>;
  /**
   * The per-Shipping-UOM detail behind byContainer, ordered by label. A Shipping UOM has one
   * entry for its lines that name no container and one for each container its other lines are saved
   * on. Entries with no fit are the ones whose lines appear in uncountedLines.
   */
  byShippingUom: Array<OrderShippingUomRollup>;
  /**
   * The weight of the order's goods in lb: each line's eaches (its shipping units times the pack, the
   * count it bills on) times its item's per-each weight, over the lines where both are known. Excludes
   * the containers. The whole order: a split order's share on one load is the client's to work out. A figure to read with unweighedLineCount.
   */
  goodsWeightLbs: Scalars['Decimal']['output'];
  /** How many lines disagree with their Shipping UOM, for the same reason. */
  mismatchCount: Scalars['Int']['output'];
  /**
   * Lines whose own pack size disagrees with their Shipping UOM's Eaches Per Unit. Advisory: the
   * line's own pack is what was counted.
   */
  mismatches: Array<OrderContainerPackMismatch>;
  /** The container named on the order, or absent when none is. */
  orderContainerCode?: Maybe<Scalars['String']['output']>;
  /** The order these numbers were computed for. */
  orderId: Scalars['String']['output'];
  /**
   * How many containers the order needs — the needed of the first byContainer
   * entry. Absent when nothing on the order has container capacity set up. Read
   * byContainer when an order can span more than one kind of container, and
   * uncountedLineCount to know whether anything was left out.
   */
  requiredContainerQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * True when nothing is missing from totalWeightLbs: no unweighed line, no uncounted line
   * (its containers are left out of the total), and every container type with needed above
   * zero has a weight.
   */
  totalWeightComplete: Scalars['Boolean']['output'];
  /**
   * The order's weight in lb: goodsWeightLbs plus the weight of every byContainer entry
   * that has one. The truck is not counted. Partial unless totalWeightComplete is true.
   */
  totalWeightLbs: Scalars['Decimal']['output'];
  /**
   * How many lines went uncounted. Redundant with uncountedLines on purpose, so a consumer
   * selecting only requiredContainerQuantity can still tell a complete figure from a
   * partial one.
   */
  uncountedLineCount: Scalars['Int']['output'];
  /**
   * Every line that contributed nothing, each with its reason. Lines with a non-positive quantity
   * are not listed — they are absent from the count because they ask for nothing, not because
   * anything is missing.
   */
  uncountedLines: Array<OrderUncountedLine>;
  /**
   * Every container type with needed above zero that has no weight, each with its reason. The
   * container half of the weight gaps: a type missing from totalWeightLbs is listed here.
   */
  unweighedContainers: Array<OrderUnweighedContainer>;
  /** How many lines add no weight, so a client that never selects the list can still tell. */
  unweighedLineCount: Scalars['Int']['output'];
  /**
   * Every positive-quantity line that adds no weight, each with its reason. As with
   * uncountedLines, the weight is never bare: a line missing from the sum is listed here.
   */
  unweighedLines: Array<OrderUnweighedLine>;
  /**
   * True when the order's own container carries the order's goods and is therefore the only
   * container a line with no container of its own is counted on. False when no container is named,
   * or when the named one is an outer container carrying none of the order's Shipping UOMs. A line
   * saved on its own container is counted on that container either way.
   */
  usedOrderContainer: Scalars['Boolean']['output'];
};

/**
 * How many of one container an order needs. fraction is the exact capacity the order
 * consumes (2.5 = two full containers and a half-full third); needed is that rounded
 * up once, after every Shipping UOM riding this container has been added in.
 */
export type OrderContainerTotal = {
  __typename?: 'OrderContainerTotal';
  containerCode: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  fraction: Scalars['Decimal']['output'];
  needed: Scalars['Int']['output'];
  /**
   * One container's own weight, in weightUnit. Absent, with the three fields below, when the
   * container type has no weight — which is how a client tells the types it should offer to weigh.
   */
  weightEach?: Maybe<Scalars['Decimal']['output']>;
  /** One container's own weight in lb; kilograms are converted at 2.20462262 lb per kg. */
  weightEachLbs?: Maybe<Scalars['Decimal']['output']>;
  /** This entry's weight in lb: needed times weightEachLbs. */
  weightLbs?: Maybe<Scalars['Decimal']['output']>;
  /** The unit weightEach is stated in. */
  weightUnit?: Maybe<WeightUnit>;
};

/**
 * Read-model representation of a single order-level typed note. Document-only sub-record
 * (boundary type suffix not applied because the parent OrdersDocument is itself the
 * read-model boundary type). Context is persisted as its string name per the
 * document-enum discipline so stored notes stay human-readable and resilient to reordering.
 */
export type OrderContextNoteDocument = {
  __typename?: 'OrderContextNoteDocument';
  context: NoteContext;
  submitDate: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * Read-model representation of a single order-level typed note. Document-only sub-record
 * (boundary type suffix not applied because the parent OrdersDocument is itself the
 * read-model boundary type). Context is persisted as its string name per the
 * document-enum discipline so stored notes stay human-readable and resilient to reordering.
 */
export type OrderContextNoteDocumentFilterInput = {
  and?: InputMaybe<Array<OrderContextNoteDocumentFilterInput>>;
  context?: InputMaybe<NoteContextOperationFilterInput>;
  or?: InputMaybe<Array<OrderContextNoteDocumentFilterInput>>;
  submitDate?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
};

export type OrderCorrectionData = {
  __typename?: 'OrderCorrectionData';
  counterpartOrderId: Scalars['String']['output'];
  linkedAt: Scalars['DateTime']['output'];
  newCustomerId: Scalars['String']['output'];
  originalCustomerId: Scalars['String']['output'];
  role: OrderCorrectionRole;
  sourceOrderId: Scalars['String']['output'];
  sourceOrderNumber: Scalars['String']['output'];
};

export type OrderCorrectionDataFilterInput = {
  and?: InputMaybe<Array<OrderCorrectionDataFilterInput>>;
  counterpartOrderId?: InputMaybe<StringOperationFilterInput>;
  linkedAt?: InputMaybe<DateTimeOperationFilterInput>;
  newCustomerId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderCorrectionDataFilterInput>>;
  originalCustomerId?: InputMaybe<StringOperationFilterInput>;
  role?: InputMaybe<OrderCorrectionRoleOperationFilterInput>;
  sourceOrderId?: InputMaybe<StringOperationFilterInput>;
  sourceOrderNumber?: InputMaybe<StringOperationFilterInput>;
};

export type OrderCorrectionDataSortInput = {
  counterpartOrderId?: InputMaybe<SortEnumType>;
  linkedAt?: InputMaybe<SortEnumType>;
  newCustomerId?: InputMaybe<SortEnumType>;
  originalCustomerId?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  sourceOrderId?: InputMaybe<SortEnumType>;
  sourceOrderNumber?: InputMaybe<SortEnumType>;
};

export enum OrderCorrectionRole {
  NewCustomerOrder = 'NEW_CUSTOMER_ORDER',
  OriginalCustomerCredit = 'ORIGINAL_CUSTOMER_CREDIT',
  Unknown = 'UNKNOWN'
}

export type OrderCorrectionRoleOperationFilterInput = {
  eq?: InputMaybe<OrderCorrectionRole>;
  in?: InputMaybe<Array<OrderCorrectionRole>>;
  neq?: InputMaybe<OrderCorrectionRole>;
  nin?: InputMaybe<Array<OrderCorrectionRole>>;
};

/** One credit order of a source order, as the backfill found it. */
export type OrderCreditBackfillCredit = {
  __typename?: 'OrderCreditBackfillCredit';
  /**
   * How many of the credit order's lines are matched to no source line because more than one line the source carried
   * before the credit had their SKU, name and cost, or another line the credit order was created with has them too.
   * No source line is guessed for them. Counted only for a credit its source did not record when this run read it,
   * and 0 for one it did.
   */
  ambiguousCreditLines: Scalars['Int']['output'];
  /** Its total: what it bills now, and what its source records for it once the run's write lands. */
  amount: Scalars['Decimal']['output'];
  /** The credit order. */
  creditOrderId: Scalars['String']['output'];
  /** Its number. */
  creditOrderNumber: Scalars['String']['output'];
  /** Its current status. */
  creditOrderStatus: OrderStatus;
  /** When it was created. */
  creditedAt: Scalars['DateTime']['output'];
  /** The currency of the amount. */
  currency: Scalars['String']['output'];
  /**
   * How it is linked to its source: a creditExistingOrder credit, or the original customer's credit of a
   * correctOrder, whose lines are mapped by position and never matched.
   */
  kind: CreditLinkKind;
  /**
   * The source lines it takes, as its source records them once the run's write lands. For a credit the source already
   * records, these are its recorded lines with every line that names its credit line, named before or by this run,
   * taking the eaches that credit line bills now, and every line that names none carried over unchanged; for a credit
   * to withdraw, the recorded lines; otherwise the credit order's own lines matched back to the source's. Over-credited
   * lines count these figures.
   */
  lines: Array<OrderCreditBackfillLine>;
  /**
   * How many lines of a live credit its source already records the run names the credit line of, or would on a dry
   * run, from the run's own read: only a line that names no credit line and is proved to come from exactly one, by the
   * matching that records a new credit or, for a correction credit, by a whole positional pairing, is named, and a tied
   * or omitted line is left unnamed. Once named, an edit of that credit line is restated on the source, so lowering or
   * removing it frees the eaches it took. A write that fails still reports what it planned to name; linesNamed reports
   * what it named.
   */
  linesMapped: Scalars['Int']['output'];
  /**
   * How many lines of its record the run's write named, counted from the restatements it appended: 0 on a dry run, and
   * 0 when the write failed before naming any.
   */
  linesNamed: Scalars['Int']['output'];
  /**
   * Every credit order line matched to no source line, with the source lines it could have come from and why. Listed
   * only for a credit its source did not record when this run read it: one to record, recorded by this run, failed
   * to record, or skipped. A skipped credit is never recorded, so its omitted lines are only reported. Empty for a
   * credit its source already recorded, even one an earlier run recorded with lines left off, whose omitted lines
   * only that run's report and its logs list. A credit with omitted lines is still recorded, with its amount in full
   * and its matched lines; the eaches of the lines it omits count against no source line's remaining creditable
   * eaches.
   */
  omittedLines: Array<OrderCreditBackfillOmittedLine>;
  /**
   * Whether its source recorded, when the run read it, an amount or eaches other than what the credit order bills:
   * a credit raised or lowered while nothing kept its source in sync. A write restates it to what it bills, and a line
   * that then stands credited past its ceiling is reported, never reversed.
   */
  outOfStep: Scalars['Boolean']['output'];
  /**
   * The amount its source recorded for it when the run read the source, beside what it bills (amount). Null when the
   * source did not record it.
   */
  recordedAmount?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The source lines and eaches its source recorded for it when the run read the source, beside what it takes once the
   * run's write lands (lines). Empty when the source did not record it.
   */
  recordedLines: Array<OrderCreditBackfillLine>;
  /**
   * Whether the run's write was to restate, or name the lines of, this credit's record and did not finish: the
   * recording landed and the restatement after it was refused or kept changing, or the recording failed first. The
   * run's errors say why, and the next run restates it.
   */
  restatementPending: Scalars['Boolean']['output'];
  /**
   * Why a LIVE correction credit its source does not record is skipped: its source is a Credit order, or is
   * Cancelled or Deleted. Null for every other credit, including a cancelled or deleted credit order, which is skipped
   * because of its own status.
   */
  skipReason?: Maybe<OrderCreditBackfillSkipReason>;
  /** What the backfill found or did for it. */
  status: OrderCreditBackfillStatus;
  /**
   * How many of the credit order's lines are matched to no source line because no line the source still carries can
   * be theirs: the line was added to the credit order later, no line had its SKU, name and cost before the credit, or
   * the one that did has since been removed. Counted only for a credit its source did not record when this run read
   * it, and 0 for one it did, even one an earlier run recorded with lines left off.
   */
  unmatchedCreditLines: Scalars['Int']['output'];
};

/** One source line a credit took, as the backfill matched it. */
export type OrderCreditBackfillLine = {
  __typename?: 'OrderCreditBackfillLine';
  /** The eaches the credit took from that line. */
  creditedEaches: Scalars['Int']['output'];
  /** The source order's line number. */
  lineNumber: Scalars['Int']['output'];
};

/** Why the backfill left a credit order line off the lines it records. */
export enum OrderCreditBackfillOmissionReason {
  /** The line was added to the credit order after the credit was raised, so it is no copy of a source line. */
  AddedToCreditLater = 'ADDED_TO_CREDIT_LATER',
  /**
   * A correction credit was created with a different number of lines than the source order bills now, so its
   * lines cannot be paired with the source's by position.
   */
  CorrectionLinesDoNotAlign = 'CORRECTION_LINES_DO_NOT_ALIGN',
  /**
   * A correction credit's line, paired by position with the source line it was built from, does not have that
   * line's SKU, name and cost, so the source has changed under the pairing.
   */
  CorrectionLineDiffers = 'CORRECTION_LINE_DIFFERS',
  /** No line the source order carried before the credit was raised had its SKU, name and cost. */
  NoSourceLine = 'NO_SOURCE_LINE',
  /**
   * Another line the credit order was created with has its SKU, name and cost. A credit order copies each source
   * line once, so at most one of them is that line's copy, and nothing proves which one, or with how many eaches.
   */
  SeveralCreditLines = 'SEVERAL_CREDIT_LINES',
  /**
   * More than one line the source order carried before the credit was raised had its SKU, name and cost,
   * counting lines since removed, so nothing proves which one it came from. Price and override price never
   * decide it, because either can change on either order after the credit is raised.
   */
  SeveralSourceLines = 'SEVERAL_SOURCE_LINES',
  /**
   * The one line the source order carried with its SKU, name and cost has since been removed or replaced, so the
   * source has no line left to record it against.
   */
  SourceLineRemoved = 'SOURCE_LINE_REMOVED'
}

/**
 * One line of a credit order that the backfill leaves off the lines it records, because it cannot be proved to
 * come from exactly one line the source order still carries.
 */
export type OrderCreditBackfillOmittedLine = {
  __typename?: 'OrderCreditBackfillOmittedLine';
  /**
   * The numbers of the source lines it could have come from: every line the source order carried with its SKU, name
   * and cost before the credit was raised, including lines since removed. Empty when there is none, and for a line
   * added to the credit order later.
   */
  candidateSourceLineNumbers: Array<Scalars['Int']['output']>;
  /** The credit order's line number. */
  creditLineNumber: Scalars['Int']['output'];
  /** Why it was left off. */
  reason: OrderCreditBackfillOmissionReason;
};

/** A source line whose credits add up to more than its credit ceiling. Reported, never reversed. */
export type OrderCreditBackfillOverCreditedLine = {
  __typename?: 'OrderCreditBackfillOverCreditedLine';
  /** The line's credit ceiling. */
  ceilingEaches: Scalars['Int']['output'];
  /** The eaches credited from it across every credit counted. */
  creditedEaches: Scalars['Int']['output'];
  /** The source order's line number. */
  lineNumber: Scalars['Int']['output'];
};

/** What one run of the credit back-reference backfill found and did. */
export type OrderCreditBackfillPayload = {
  __typename?: 'OrderCreditBackfillPayload';
  /** Live credits their source already recorded. On a second run, every credit neither skipped nor withdrawn. */
  creditsAlreadyRecorded: Scalars['Int']['output'];
  /** Credit orders found. */
  creditsFound: Scalars['Int']['output'];
  /**
   * Live credits their source recorded, when the run read it, with an amount or eaches other than what the credit order
   * bills. A run that writes restates each to what it bills. Zero on a run after a write that settled.
   */
  creditsOutOfStep: Scalars['Int']['output'];
  /** Credits this run recorded. Zero on a dry run, and zero on a second run. */
  creditsRecorded: Scalars['Int']['output'];
  /**
   * Credits whose restatement or naming the run's write did not finish; the run's errors say why, and the next run
   * restates them. Zero on a dry run.
   */
  creditsRestatementPending: Scalars['Int']['output'];
  /** Cancelled or deleted credit orders their source does not record, left as they are. */
  creditsSkipped: Scalars['Int']['output'];
  /** Live credits their source did not record yet when the run looked. */
  creditsToRecord: Scalars['Int']['output'];
  /** Credits their source still recorded although their credit orders are cancelled or deleted. */
  creditsToWithdraw: Scalars['Int']['output'];
  /**
   * Of those, the credits with EVERY line left off: recorded, or to record, with no source line at all. None of
   * their eaches counts against any source line, so a later whole-order credit of the source is not refused. Each is
   * logged at Error. A real run should not go ahead while a dry run reports any.
   */
  creditsWithAllLinesOmitted: Scalars['Int']['output'];
  /**
   * Credits this run records, would record, or failed to record, with at least one of their lines left off the
   * recorded lines because it could not be proved to come from exactly one line the source still carries. Each is
   * recorded with its amount in full and its matched lines, and its omittedLines say which lines were left off. A
   * run that writes logs each omitted line of a credit it recorded at Warning, and of a credit whose write's outcome
   * is unknown as one that may have been recorded; a credit whose write was refused is counted and not logged, and
   * is planned again by the next run. Skipped credits are never counted. A credit an earlier run recorded is not
   * counted again.
   */
  creditsWithLinesOmitted: Scalars['Int']['output'];
  /** Credits this run withdrew from their source. Zero on a dry run. */
  creditsWithdrawn: Scalars['Int']['output'];
  /** Whether the run only reported and wrote nothing. */
  dryRun: Scalars['Boolean']['output'];
  /** One entry per source order the run could not read or write. */
  errors?: Maybe<Array<ValidationError>>;
  /** Lines the run's writes named, counted from the restatements they appended. Zero on a dry run. */
  linesNamed: Scalars['Int']['output'];
  /**
   * Lines of credits their source already records that the run names the credit line of, or would on a dry run. Zero
   * on a run after a write that settled.
   */
  linesToName: Scalars['Int']['output'];
  /** Source lines credited past their ceiling. */
  overCreditedLineCount: Scalars['Int']['output'];
  /** Every source order, with its credits and over-credited lines. */
  sources: Array<OrderCreditBackfillSource>;
  /** Source orders with at least one credit order. */
  sourcesScanned: Scalars['Int']['output'];
};

/** Why the backfill leaves a live correction credit unrecorded on its source. */
export enum OrderCreditBackfillSkipReason {
  /** The source order is Cancelled or Deleted, so no credit counts against it. */
  SourceCancelledOrDeleted = 'SOURCE_CANCELLED_OR_DELETED',
  /**
   * The source order is itself a Credit order. A credit of a credit is never recorded: the live path refuses
   * one, and a correction of a Credit source writes no credit for the original customer.
   */
  SourceIsCredit = 'SOURCE_IS_CREDIT'
}

/** One source order and every credit raised against it. */
export type OrderCreditBackfillSource = {
  __typename?: 'OrderCreditBackfillSource';
  /** Its credit orders, oldest first. */
  credits: Array<OrderCreditBackfillCredit>;
  /**
   * Its lines credited past their ceiling once the run's write lands: every credit the source records, restated to
   * what it bills where the run restates it, and every credit the run records, less the ones the run withdraws.
   */
  overCreditedLines: Array<OrderCreditBackfillOverCreditedLine>;
  /** The credited order. */
  sourceOrderId: Scalars['String']['output'];
  /** Its number. */
  sourceOrderNumber: Scalars['String']['output'];
  /** The tenant. */
  tenantId: Scalars['String']['output'];
};

/** What the back-reference backfill found, or did, for one credit order. */
export enum OrderCreditBackfillStatus {
  /**
   * The source order already records this credit and its credit order is live, so it is not recorded again. Its
   * record is still brought in line with its credit order: the credit lines the matching proves are named on a
   * record that names none (linesMapped), and a record whose amount or eaches differ from what the credit order bills
   * now is restated to it (outOfStep), in one write per source that appends one restatement per credit it changes;
   * a tied or omitted line is left unnamed. A run after a write that settled writes nothing for it.
   */
  AlreadyRecorded = 'ALREADY_RECORDED',
  /**
   * The write that records or withdraws the credit failed; the run's errors say why. Nothing is known to be written
   * for it: re-running records or withdraws it, and when the store's answer was lost after the write landed, the
   * re-run finds the credit recorded and brings its record in line instead. A credit whose recording landed but whose
   * restatement after it did not is reported Recorded with restatementPending set, never Failed.
   */
  Failed = 'FAILED',
  /** This run recorded the credit on its source order. */
  Recorded = 'RECORDED',
  /** The credit order is cancelled or deleted and its source does not record it, so nothing is written for it. */
  Skipped = 'SKIPPED',
  /** A dry run found the source order does not record this credit yet. */
  ToRecord = 'TO_RECORD',
  /**
   * A dry run found the source order still records this credit although its credit order is cancelled or
   * deleted, which a cancel racing an earlier run's write leaves behind. A run that writes withdraws it.
   */
  ToWithdraw = 'TO_WITHDRAW',
  /** This run withdrew the credit from its source order, because its credit order is cancelled or deleted. */
  Withdrawn = 'WITHDRAWN'
}

/** One credit raised against an order, as the order's read model lists it under credits. */
export type OrderCreditEntry = {
  __typename?: 'OrderCreditEntry';
  /** The credit order's total as the credit landed. */
  amount: MoneyData;
  /** The Credit-type order raised against this order. */
  creditOrderId: Scalars['String']['output'];
  /** That credit order's number. */
  creditOrderNumber: Scalars['String']['output'];
  /** When the credit order was created. */
  creditedAt: Scalars['DateTime']['output'];
  /** Why the credit was raised; null when none was given. */
  reason?: Maybe<Scalars['String']['output']>;
};

export type OrderCustomerData = {
  __typename?: 'OrderCustomerData';
  billToAddress: AddressData;
  contact: OrderContactData;
  erpId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location: LocationData;
  name: Scalars['String']['output'];
};

export type OrderCustomerDataInput = {
  billToAddress: AddressDataInput;
  contact: OrderContactDataInput;
  erpId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  location: LocationDataInput;
  name: Scalars['String']['input'];
};

export type OrderDetailsPdfData = {
  __typename?: 'OrderDetailsPdfData';
  base64Pdf: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
};

export type OrderDiscountComponentData = {
  __typename?: 'OrderDiscountComponentData';
  amount: Scalars['Decimal']['output'];
  categoryCode?: Maybe<Scalars['String']['output']>;
  kind: OrderDiscountComponentKind;
  label: Scalars['String']['output'];
};

export enum OrderDiscountComponentKind {
  CategoryVolume = 'CATEGORY_VOLUME',
  CustomerDefault = 'CUSTOMER_DEFAULT',
  Manual = 'MANUAL',
  OrderVolume = 'ORDER_VOLUME'
}

export type OrderDropShipDestinationData = {
  __typename?: 'OrderDropShipDestinationData';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shipToName: Scalars['String']['output'];
  stateProvince: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

/** Result of the connect/disconnect mutations: the resulting status, or validation errors. */
export type OrderEaseConnectionPayload = {
  __typename?: 'OrderEaseConnectionPayload';
  errors?: Maybe<Array<ValidationError>>;
  integration?: Maybe<OrderEaseConnectionStatus>;
};

/**
 * Non-secret OrderEase connection status surfaced to the pwa. Returned by the
 * orderEaseIntegration query and embedded in the connect/disconnect payloads. Carries a MASKED
 * client key only — the client secret and refresh token never leave wsapi.
 */
export type OrderEaseConnectionStatus = {
  __typename?: 'OrderEaseConnectionStatus';
  connected: Scalars['Boolean']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  maskedClientKey?: Maybe<Scalars['String']['output']>;
};

export enum OrderEmailChannel {
  Email = 'EMAIL',
  EmailAndSms = 'EMAIL_AND_SMS',
  Sms = 'SMS'
}

export type OrderEmailChannelOperationFilterInput = {
  eq?: InputMaybe<OrderEmailChannel>;
  in?: InputMaybe<Array<OrderEmailChannel>>;
  neq?: InputMaybe<OrderEmailChannel>;
  nin?: InputMaybe<Array<OrderEmailChannel>>;
};

/**
 * How a one-off order document email leaves WorkSuite. The route is decided by the From selection in
 * the compose dialog, and the two routes have genuinely different preconditions, so readiness is
 * reported per route rather than collapsed into one verdict.
 */
export enum OrderEmailDeliveryRoute {
  /**
   * The caller's own connected Microsoft 365 mailbox ("Me — … (via my Outlook)"): the send happens
   * INLINE during the mutation, so it needs no background dispatch and no tenant sender, but it
   * does need a connected mailbox.
   */
  InlinePersonalMailbox = 'INLINE_PERSONAL_MAILBOX',
  /**
   * A tenant sender: the send is QUEUED and dispatched in the background. Queueing itself never
   * fails, so a queued send that can never be dispatched looks identical to one that will be — the
   * job simply sits forever. That is the failure this surface exists to make visible.
   */
  QueuedTenantSender = 'QUEUED_TENANT_SENDER'
}

export enum OrderEmailDocType {
  Acknowledgment = 'ACKNOWLEDGMENT',
  Cancellation = 'CANCELLATION',
  Confirmation = 'CONFIRMATION',
  DateChange = 'DATE_CHANGE',
  DeliveryScheduled = 'DELIVERY_SCHEDULED',
  Invoice = 'INVOICE',
  Quote = 'QUOTE'
}

export type OrderEmailDocTypeOperationFilterInput = {
  eq?: InputMaybe<OrderEmailDocType>;
  in?: InputMaybe<Array<OrderEmailDocType>>;
  neq?: InputMaybe<OrderEmailDocType>;
  nin?: InputMaybe<Array<OrderEmailDocType>>;
};

/**
 * One kind of the tenant's external notification catalog, carrying its EFFECTIVE state: the stored
 * settings where the tenant has authored any, and the platform defaults where it has not.
 */
export type OrderEmailNotificationCatalogEntryData = {
  __typename?: 'OrderEmailNotificationCatalogEntryData';
  /**
   * Gets the tenant-scoped reasons this kind's email cannot currently send — the sender, report
   * binding, and render-mode blockers that hold for every order of this kind, independent of any
   * particular order's recipients or the caller's own mailbox. Empty when nothing tenant-scoped
   * blocks it. The delivery-scheduled kind mails no document, so only the sender can block it.
   * ALWAYS empty for a kind with no dispatch leg (QUOTE, which setOrderEmailEnablement
   * rejects outright) — that kind's undeliverability is already expressed by its own enabled
   * field reading false and by the mutation's own rejection, so listing report/sender blockers here
   * would wrongly suggest fixing one could ever switch it on. Excludes
   * BACKGROUND_SENDING_NOT_ENABLED — this entry's own
   * enabled field already reports that — and every order- or caller-scoped blocker, which
   * has no tenant-wide answer. Computed by the same rules orderEmailSendReadiness uses for
   * these same three values, so a settings page can trust this list instead of re-deriving
   * readiness client-side.
   */
  blockers: Array<OrderEmailSendBlocker>;
  /** Gets the channel this kind is delivered over. */
  channel: OrderEmailChannel;
  /**
   * Gets whether the tenant has ever written settings for this kind. False means every other
   * field on this entry is a platform default rather than an authored value, which is what lets
   * the per-kind editor tell "off because nobody has configured it" from "explicitly turned off".
   */
  configured: Scalars['Boolean']['output'];
  /**
   * Gets the code-owned default recipient roles for this kind, in fallback order — the seed a
   * per-kind recipient editor starts an unauthored row from. Never a stored value: it is the
   * platform's built-in per-kind recipient-role hierarchy.
   */
  defaultRecipientRoles: Array<OrderEmailRecipientRole>;
  /** Gets the catalog kind this entry describes. */
  docType: OrderEmailDocType;
  /** Gets the authored body, or null when not authored. */
  emailBody?: Maybe<Scalars['String']['output']>;
  /** Gets the authored subject, or null when not authored. */
  emailSubject?: Maybe<Scalars['String']['output']>;
  /** Gets whether the platform sends this kind for this tenant. */
  enabled: Scalars['Boolean']['output'];
  /**
   * Gets whether this catalog kind has an implemented delivery path. Settings surfaces use this capability
   * to offer switches only for operational workflows, independently of saved enablement or readiness.
   */
  hasDeliveryImplementation: Scalars['Boolean']['output'];
  /** Gets whether the order's salesperson is Cc'd on this kind's email. */
  includeSalesPersonCc: Scalars['Boolean']['output'];
  /** Gets whether the servicing site's manager is Cc'd on this kind's email. */
  includeServicingSiteManagerCc: Scalars['Boolean']['output'];
  /** Gets the authored recipient list, empty when the tenant has authored none. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: Maybe<Scalars['String']['output']>;
};

/**
 * The order document type a recipient resolution is keyed against. Distinct from
 * OrderEmailDocType (which governs the tenant-authored
 * subject/body settings and treats invoice + credit-memo as one "Confirmation" config) — this enum keys
 * ONLY the doc-type -> ContactType recipient-routing table on
 * IOrderEmailRecipientResolver.
 */
export enum OrderEmailRecipientDocType {
  /**
   * The buyers' setting: confirmations, acknowledgments and quotes. Defaults to Accounts Payable, the
   * same default invoices have, so a tenant with no entries resolves every kind as it always did. Set and
   * cleared on its own; it never changes the invoice entry.
   */
  Confirmation = 'CONFIRMATION',
  /**
   * The planned-arrival notice for one stop of a load, sent to the customer's routed contacts when
   * the ship-to location has no receiving email. Defaults to the Primary contact.
   */
  DeliveryScheduled = 'DELIVERY_SCHEDULED',
  /**
   * Invoices only: the on-demand invoice email — the compose-dialog prefill, the Outlook draft flow, and
   * the personal-send no-recipients fallback (which transitively fixes the scheduled/system-sender
   * snapshot, since it seeds from the same prefill). Defaults to Accounts Payable.
   */
  Invoice = 'INVOICE'
}

export enum OrderEmailRecipientRole {
  CustomerPrimaryContact = 'CUSTOMER_PRIMARY_CONTACT',
  OrderContact = 'ORDER_CONTACT',
  PortalUserWhoPlacedOrder = 'PORTAL_USER_WHO_PLACED_ORDER'
}

/**
 * MongoDB read-model document for a tenant's order-email recipient-routing overrides — the sparse
 * doc-type -> ContactType map that OrderEmailRecipientResolver consults before
 * falling back to its built-in default. There is exactly one document per tenant; Id equals
 * TenantId today, but use GetDocumentId for all reads/writes. Mirrors
 * TenantRouteConfigDocument.
 */
export type OrderEmailRecipientRoutingDocument = {
  __typename?: 'OrderEmailRecipientRoutingDocument';
  entries: Array<OrderEmailRecipientRoutingEntryDocument>;
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
};

/** One doc-type -> contact-type routing entry, as exposed on the GraphQL contract. */
export type OrderEmailRecipientRoutingEntryData = {
  __typename?: 'OrderEmailRecipientRoutingEntryData';
  contactType: ContactType;
  docType: OrderEmailRecipientDocType;
};

/**
 * One sparse-map entry: a doc-type explicitly routed to a contact type. Absent from
 * Entries means "use the built-in default" — there
 * is no row for every doc-type, only the ones a tenant has configured.
 */
export type OrderEmailRecipientRoutingEntryDocument = {
  __typename?: 'OrderEmailRecipientRoutingEntryDocument';
  contactType: ContactType;
  docType: OrderEmailRecipientDocType;
};

export type OrderEmailRecipientRoutingPayload = {
  __typename?: 'OrderEmailRecipientRoutingPayload';
  errors?: Maybe<Array<ValidationError>>;
  orderEmailRecipientRouting?: Maybe<OrderEmailRecipientRoutingStateData>;
};

/**
 * A tenant's order-email recipient routing: the sparse set of doc-types that have an explicit
 * contact-type override. A doc-type absent from Entries uses the built-in default recipient.
 */
export type OrderEmailRecipientRoutingStateData = {
  __typename?: 'OrderEmailRecipientRoutingStateData';
  entries: Array<OrderEmailRecipientRoutingEntryData>;
  tenantId: Scalars['String']['output'];
};

/** Whether one delivery route can carry this order's document email, and if not, why not. */
export type OrderEmailRouteReadinessData = {
  __typename?: 'OrderEmailRouteReadinessData';
  /**
   * The distinguishable reasons this route cannot send. Empty when ready. A route can hit more than
   * one at once, so each finding is reported independently rather than collapsed.
   */
  blockers: Array<OrderEmailSendBlocker>;
  /** True when nothing blocks this route. Derived from blockers being empty. */
  isReady: Scalars['Boolean']['output'];
  /** The delivery route this verdict describes. */
  route: OrderEmailDeliveryRoute;
};

/**
 * A distinguishable reason an order document email cannot be sent by a given route. A route can
 * report more than one at once, so blockers are a list rather than a single status. Each value names
 * a condition that is configured somewhere different, by someone different, and today reports nothing
 * at all at send time.
 */
export enum OrderEmailSendBlocker {
  /**
   * This account's activation state could not be confirmed, so background sending cannot be
   * verified as available. Reported instead of BACKGROUND_SENDING_NOT_ENABLED: that value
   * means background sending was checked and found off, while this one means the check itself
   * could not run, so the safer answer is reported rather than a guess. Reserved: no check the
   * readiness surface performs can currently produce this reason. It is retained because the
   * value is published in the schema and retiring one is its own reviewed change. A queued route
   * that cannot send reports BACKGROUND_SENDING_NOT_ENABLED instead.
   */
  AccountActivationUnknown = 'ACCOUNT_ACTIVATION_UNKNOWN',
  /**
   * Background sending is not enabled for this account, so a queued send is never dispatched: the
   * job sits unclaimed with no error, no warning, and no execution stamp. This kind is switched
   * OFF in the tenant's external notification catalog, which an administrator turns on from the
   * notification settings surface — the flag the sending workers read once the catalog cutover
   * lands; until then a tenant may also be gated by its account-level order-email setting.
   */
  BackgroundSendingNotEnabled = 'BACKGROUND_SENDING_NOT_ENABLED',
  /**
   * The tenant's effective render mode for this document type selects the report engine
   * (ReportEngine or Parallel) while no document report resolves for it — the
   * automatic order emails would silently fall back to the legacy document in that state. Reserved:
   * it only fires alongside DOCUMENT_REPORT_NOT_CONFIGURED, and the one state that reports
   * that value today (tenant configuration that cannot be read) also reports a render mode that
   * expects no report, so this value cannot currently fire.
   */
  DocumentRenderModeExpectsReport = 'DOCUMENT_RENDER_MODE_EXPECTS_REPORT',
  /**
   * No document report resolves for this document type — not the customer's override, not the
   * tenant's binding, and not the built-in system default, so there is no document to render and
   * attach. Every document type reachable today (invoice, acknowledgement, quote) has a seeded
   * system default, so effective resolution never yields nothing: today this value is reported only
   * when the tenant's own configuration cannot be read, which readiness reports as this blocker
   * rather than assuming the seeded default applies.
   */
  DocumentReportNotConfigured = 'DOCUMENT_REPORT_NOT_CONFIGURED',
  /**
   * Recipient resolution produced no address for this order — neither a routed customer contact nor
   * the order's own contact carries an email — so there is nobody to send to on any route.
   */
  NoResolvedRecipients = 'NO_RESOLVED_RECIPIENTS',
  /**
   * The caller has a connected Microsoft 365 mailbox whose recorded grant does not include
   * Mail.Send, so the inline route cannot send from it. This covers a connection made before
   * the send permission was requested, a connection whose record predates send-capability being
   * stored at all, and a fresh grant that did not include Mail.Send. Reconnecting
   * re-authorizes and clears this blocker when the new grant includes Mail.Send. Reported
   * instead of, never alongside, PERSONAL_MAILBOX_NOT_CONNECTED: a mailbox that is not
   * connected at all gets that blocker, not this one.
   */
  PersonalMailboxCannotSend = 'PERSONAL_MAILBOX_CANNOT_SEND',
  /**
   * The caller has no connected Microsoft 365 mailbox, so there is nothing to send the message from
   * on the inline route. Per-user, not per-tenant — a colleague may well be connected.
   */
  PersonalMailboxNotConnected = 'PERSONAL_MAILBOX_NOT_CONNECTED',
  /**
   * The tenant's effective sender is not in a verified state, so the provider will refuse it. The
   * synthesized platform-default sender is always verified, so this only fires for a tenant that has
   * selected a sender of its own that has not completed verification.
   */
  SenderNotVerified = 'SENDER_NOT_VERIFIED',
  /**
   * The customer or the order has this kind set to Never; no route may send it until the choice
   * is changed on the customer's Notifications tab or the order.
   */
  SuppressedAtScope = 'SUPPRESSED_AT_SCOPE'
}

/**
 * A computed, read-only send-readiness snapshot for one order's document email, per delivery route.
 * Built on demand from the order, the tenant's report binding and render mode, the effective sender,
 * whether background sending is enabled, the caller's mailbox connection, and recipient resolution —
 * it is not itself a stored document. Exists because every one of those is configured in a different
 * place by a different person, and a send that cannot possibly work currently reports success.
 */
export type OrderEmailSendReadinessData = {
  __typename?: 'OrderEmailSendReadinessData';
  /**
   * The document type the order resolves to, derived server-side from the order's status by the same
   * predicate the draft and send surfaces use, so readiness cannot disagree with what a send would
   * actually do. It is QUOTE only when the caller asked for it with a docType argument
   * on a draft order.
   */
  docType: OrderEmailDocType;
  /** The order this snapshot was computed for. */
  orderId: Scalars['String']['output'];
  /**
   * One verdict per delivery route, in a stable order. Every route is always present — a route the
   * caller cannot currently use reports its blockers rather than being omitted.
   */
  routes: Array<OrderEmailRouteReadinessData>;
  /** The calling tenant this snapshot was computed for. Always the caller's own tenant. */
  tenantId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type OrderEmailSettingsConnection = {
  __typename?: 'OrderEmailSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderEmailSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrderEmailSettingsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** GraphQL data transfer record for a tenant's order-email settings. */
export type OrderEmailSettingsData = {
  __typename?: 'OrderEmailSettingsData';
  /** Gets whether both Cc flags were explicitly saved on the settings event. */
  ccFlagsSaved: Scalars['Boolean']['output'];
  /** Gets the channel this kind is delivered over. */
  channel: OrderEmailChannel;
  /** Gets the doc-type these settings apply to. */
  docType: OrderEmailDocType;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the authorable Handlebars email subject (tokens + inline {{#if}}), or null when
   * not authored. Rendered at send time; supports invoice-vs-credit branching on orderType.
   */
  emailSubject?: Maybe<Scalars['String']['output']>;
  /**
   * Gets whether the platform sends this kind for this tenant. This is the single source of truth
   * the sending workers and the send-readiness surface both read; false means nothing is sent, and
   * a tenant that has never turned the kind on reads false.
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * Gets whether the order's salesperson is to be Cc'd on this doc-type's email. False unless the
   * tenant has opted in.
   */
  includeSalesPersonCc: Scalars['Boolean']['output'];
  /**
   * Gets whether the manager of the order's servicing site is to be Cc'd on this doc-type's
   * email. False unless the tenant has opted in.
   */
  includeServicingSiteManagerCc: Scalars['Boolean']['output'];
  /** Gets the recipient list. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: Maybe<Scalars['String']['output']>;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the timestamp when the settings were last set. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who last set the settings. */
  updatedBy: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a tenant's authorable order-email settings. There is exactly one
 * document per (tenant, doc-type); route all reads/writes through GetDocumentId so the id
 * format can evolve without hunting call sites.
 */
export type OrderEmailSettingsDocument = {
  __typename?: 'OrderEmailSettingsDocument';
  /** Gets whether both Cc flags were explicitly saved on the settings event. */
  ccFlagsSaved: Scalars['Boolean']['output'];
  /** Gets the channel this kind is delivered over. */
  channel: OrderEmailChannel;
  /** Gets the doc-type these settings apply to. */
  docType: OrderEmailDocType;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: Maybe<Scalars['String']['output']>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: Maybe<Scalars['String']['output']>;
  /** Gets whether the platform sends this kind for this tenant. */
  enabled: Scalars['Boolean']['output'];
  /** Gets the MongoDB document identifier. */
  id: Scalars['String']['output'];
  /**
   * Gets whether the order's salesperson is to be Cc'd on this doc-type's email. False unless the
   * tenant has opted in.
   */
  includeSalesPersonCc: Scalars['Boolean']['output'];
  /**
   * Gets whether the manager of the order's servicing site is to be Cc'd on this doc-type's
   * email. False unless the tenant has opted in.
   */
  includeServicingSiteManagerCc: Scalars['Boolean']['output'];
  /** Gets the recipient list. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: Maybe<Scalars['String']['output']>;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the timestamp when the settings were last set. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who last set the settings. */
  updatedBy: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a tenant's authorable order-email settings. There is exactly one
 * document per (tenant, doc-type); route all reads/writes through GetDocumentId so the id
 * format can evolve without hunting call sites.
 */
export type OrderEmailSettingsDocumentFilterInput = {
  and?: InputMaybe<Array<OrderEmailSettingsDocumentFilterInput>>;
  /** Gets whether both Cc flags were explicitly saved on the settings event. */
  ccFlagsSaved?: InputMaybe<AbsentAsFalseBooleanOperationFilterInput>;
  /** Gets the channel this kind is delivered over. */
  channel?: InputMaybe<OrderEmailChannelOperationFilterInput>;
  /** Gets the doc-type these settings apply to. */
  docType?: InputMaybe<OrderEmailDocTypeOperationFilterInput>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: InputMaybe<StringOperationFilterInput>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: InputMaybe<StringOperationFilterInput>;
  /** Gets whether the platform sends this kind for this tenant. */
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Gets whether the order's salesperson is to be Cc'd on this doc-type's email. False unless the
   * tenant has opted in.
   */
  includeSalesPersonCc?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Gets whether the manager of the order's servicing site is to be Cc'd on this doc-type's
   * email. False unless the tenant has opted in.
   */
  includeServicingSiteManagerCc?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OrderEmailSettingsDocumentFilterInput>>;
  /** Gets the recipient list. */
  recipients?: InputMaybe<ListStringOperationFilterInput>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the timestamp when the settings were last set. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the email of the user who last set the settings. */
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read-model document for a tenant's authorable order-email settings. There is exactly one
 * document per (tenant, doc-type); route all reads/writes through GetDocumentId so the id
 * format can evolve without hunting call sites.
 */
export type OrderEmailSettingsDocumentSortInput = {
  /** Gets the channel this kind is delivered over. */
  channel?: InputMaybe<SortEnumType>;
  /** Gets the doc-type these settings apply to. */
  docType?: InputMaybe<SortEnumType>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: InputMaybe<SortEnumType>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: InputMaybe<SortEnumType>;
  /** Gets whether the platform sends this kind for this tenant. */
  enabled?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Gets whether the order's salesperson is to be Cc'd on this doc-type's email. False unless the
   * tenant has opted in.
   */
  includeSalesPersonCc?: InputMaybe<SortEnumType>;
  /**
   * Gets whether the manager of the order's servicing site is to be Cc'd on this doc-type's
   * email. False unless the tenant has opted in.
   */
  includeServicingSiteManagerCc?: InputMaybe<SortEnumType>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Gets the timestamp when the settings were last set. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Gets the email of the user who last set the settings. */
  updatedBy?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type OrderEmailSettingsEdge = {
  __typename?: 'OrderEmailSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrderEmailSettingsDocument;
};

/** Payload returned from order-email settings mutations. */
export type OrderEmailSettingsPayload = {
  __typename?: 'OrderEmailSettingsPayload';
  errors?: Maybe<Array<ValidationError>>;
  orderEmailSettings?: Maybe<OrderEmailSettingsData>;
};

export enum OrderEntityType {
  MasterOrder = 'MASTER_ORDER',
  Order = 'ORDER'
}

export type OrderEntityTypeOperationFilterInput = {
  eq?: InputMaybe<OrderEntityType>;
  in?: InputMaybe<Array<OrderEntityType>>;
  neq?: InputMaybe<OrderEntityType>;
  nin?: InputMaybe<Array<OrderEntityType>>;
};

export enum OrderEntryUnit {
  Eaches = 'EACHES',
  ShippingUom = 'SHIPPING_UOM'
}

export type OrderEntryUnitOperationFilterInput = {
  eq?: InputMaybe<OrderEntryUnit>;
  in?: InputMaybe<Array<OrderEntryUnit>>;
  neq?: InputMaybe<OrderEntryUnit>;
  nin?: InputMaybe<Array<OrderEntryUnit>>;
};

export enum OrderExportTriggerStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Closed = 'CLOSED',
  Picked = 'PICKED',
  Shipped = 'SHIPPED'
}

export type OrderFlatChargeData = {
  __typename?: 'OrderFlatChargeData';
  amount: Scalars['Decimal']['output'];
  at: Scalars['DateTime']['output'];
  basis?: Maybe<Scalars['String']['output']>;
  by: Scalars['String']['output'];
  flatChargeTypeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: OrderFlatChargeKind;
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  taxable: Scalars['Boolean']['output'];
};

/** One named flat charge on an order. Document-only sub-record, used by this document and nothing else. */
export type OrderFlatChargeDocument = {
  __typename?: 'OrderFlatChargeDocument';
  amount: Scalars['Decimal']['output'];
  /** When the latest add or edit was made. */
  at: Scalars['DateTime']['output'];
  /** Optional display text explaining how the amount was reached; null for a charge-list charge. */
  basis?: Maybe<Scalars['String']['output']>;
  /** Who made the latest add or edit. Staff only; refused for customer-portal callers. */
  by: Scalars['String']['output'];
  /** The charge-list entry the charge was picked from; null for the system fuel-surcharge kind. */
  flatChargeTypeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: OrderFlatChargeKind;
  /** The name copied from the entry when the charge was added. */
  name: Scalars['String']['output'];
  /** The reason given with the latest add or edit. */
  reason: Scalars['String']['output'];
  taxable: Scalars['Boolean']['output'];
};

/** One named flat charge on an order. Document-only sub-record, used by this document and nothing else. */
export type OrderFlatChargeDocumentFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<OrderFlatChargeDocumentFilterInput>>;
  /** When the latest add or edit was made. */
  at?: InputMaybe<DateTimeOperationFilterInput>;
  /** Optional display text explaining how the amount was reached; null for a charge-list charge. */
  basis?: InputMaybe<StringOperationFilterInput>;
  /** Who made the latest add or edit. Staff only; refused for customer-portal callers. */
  by?: InputMaybe<StringOperationFilterInput>;
  /** The charge-list entry the charge was picked from; null for the system fuel-surcharge kind. */
  flatChargeTypeId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  kind?: InputMaybe<OrderFlatChargeKindOperationFilterInput>;
  /** The name copied from the entry when the charge was added. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderFlatChargeDocumentFilterInput>>;
  /** The reason given with the latest add or edit. */
  reason?: InputMaybe<StringOperationFilterInput>;
  taxable?: InputMaybe<BooleanOperationFilterInput>;
};

export enum OrderFlatChargeKind {
  ChargeList = 'CHARGE_LIST',
  SystemFuelSurcharge = 'SYSTEM_FUEL_SURCHARGE',
  Unknown = 'UNKNOWN'
}

export type OrderFlatChargeKindOperationFilterInput = {
  eq?: InputMaybe<OrderFlatChargeKind>;
  in?: InputMaybe<Array<OrderFlatChargeKind>>;
  neq?: InputMaybe<OrderFlatChargeKind>;
  nin?: InputMaybe<Array<OrderFlatChargeKind>>;
};

/**
 * One entry in an order's audit history — a single event read straight off the order's KurrentDB
 * stream, carrying what happened, when, and who did it.
 */
export type OrderHistoryRecord = {
  __typename?: 'OrderHistoryRecord';
  /**
   * The persisted domain event-type name (e.g. "V1.StatusUpdated"). Stable and machine-readable, so a
   * client can key off it rather than parsing the label.
   */
  eventType: Scalars['String']['output'];
  /** The event's own identifier in the event store. */
  id: Scalars['String']['output'];
  /**
   * A human-readable description of what the event did (e.g. "Order deleted", "Status changed to
   * Shipped", "Line items added"). Always populated — an event type with no curated label is rendered
   * from its own name rather than left blank or shown as a raw internal string.
   */
  label: Scalars['String']['output'];
  /**
   * When the event was recorded on the stream. For events brought across by the KurrentDB replicator
   * this is the original write instant, not the copy's.
   */
  occurredAt: Scalars['DateTime']['output'];
  /**
   * The email of the user who performed the action, read from the event's metadata envelope. NULL —
   * never an empty string — when the event carries no acting user: a service or machine caller has no
   * email to stamp, and events written before performed-by attribution shipped carry no actor at all.
   * A client should render those as "unknown", which an empty string would misrepresent as an answer.
   */
  occurredBy?: Maybe<Scalars['String']['output']>;
};

/** A hold on an order: why it was placed, who placed it and when. While it stands the order cannot be picked, shipped, verified, closed or dispatched on a load. */
export type OrderHold = {
  __typename?: 'OrderHold';
  /** When the hold was placed. */
  placedAt: Scalars['DateTime']['output'];
  /** The email address of the user who placed the hold. */
  placedBy: Scalars['String']['output'];
  /** Why the order is held, as staff entered it. */
  reason: Scalars['String']['output'];
};

/**
 * What orderInspection could establish about one Order. UNAVAILABLE_OR_NOT_PERMITTED never proves that a
 * write did not happen: it is also the answer for an Order the caller may not see, and for one written so
 * recently that the order list does not show it yet.
 */
export enum OrderInspectionOutcome {
  /** The Order exists and the caller may see it. order holds it as stored. */
  Found = 'FOUND',
  /** The Order could not be read. Nothing is known; try again later. */
  ReadFailed = 'READ_FAILED',
  /** The caller cannot see an Order with this id. It may not exist, may be outside the caller's scope, or may not be listed yet. */
  UnavailableOrNotPermitted = 'UNAVAILABLE_OR_NOT_PERMITTED',
  /** Never a business value. */
  Unknown = 'UNKNOWN'
}

/** The result of orderInspection. order is set only when the outcome is FOUND. */
export type OrderInspectionPayload = {
  __typename?: 'OrderInspectionPayload';
  order?: Maybe<OrderStateData>;
  outcome: OrderInspectionOutcome;
};

/**
 * Compose-dialog defaults for a one-off order document email: the recipients (see the recipients
 * field), the tenant's effective verified sender, and the authored subject/body for the resolved
 * docType (raw Handlebars, or sensible raw defaults when not authored). All values are
 * editable by the client before sending.
 */
export type OrderInvoiceEmailDraftData = {
  __typename?: 'OrderInvoiceEmailDraftData';
  /**
   * Gets the document type this draft resolves to, derived server-side by
   * OrderEmailDocTypeResolution — INVOICE when the order carries an active issued
   * invoice, otherwise ACKNOWLEDGMENT for an Acknowledged or Picked order and
   * CONFIRMATION for everything else; a credit memo stays on CONFIRMATION whether or
   * not a bill stands against it. QUOTE is never resolved by default: this is QUOTE
   * only when the caller asked for it with a docType argument. The client should use this
   * value (not a hardcoded doc-type) for anything else that is doc-type-keyed, e.g. reading
   * orderEmailSettings directly.
   */
  docType: OrderEmailDocType;
  /**
   * Gets the raw (unrendered) Handlebars body: the tenant's docType-authored body when
   * set, otherwise a simple raw default.
   */
  emailBody: Scalars['String']['output'];
  /**
   * Gets the raw (unrendered) Handlebars subject: the tenant's docType-authored
   * subject when set, otherwise a raw default (Invoice {{orderNumber}} /
   * Order Acknowledgement {{orderNumber}} / Quote {{orderNumber}}).
   */
  emailSubject: Scalars['String']['output'];
  /**
   * Gets the default recipients — every email of every AccountsPayable-typed contact on the
   * order's customer, falling back to the order's own contact email when the customer has none. Empty
   * only when neither exists (the client shows an empty field rather than erroring).
   */
  recipients: Array<Scalars['String']['output']>;
  /**
   * Gets the report id that will render for docType (invoice, acknowledgement or quote): a
   * customer override, else the tenant's bound report, else the built-in system default — the
   * same rule View applies. For QUOTE it is always the seeded Quote template, whatever the
   * customer or tenant has bound. Null only when the caller's own tenant state could not be read.
   */
  reportId?: Maybe<Scalars['String']['output']>;
  /** Gets the effective sender (verified default, else earliest verified, else platform default). */
  sender: TenantEmailSenderData;
};

/**
 * One invoice raised against an order, in the shape an ORDER surface reads it: enough to say which
 * bill it is, whether it still stands, and what it is owed. Deliberately NOT the invoice — an order
 * page links to a bill, it does not restate one, so the lines, the tax breakdown and the payments
 * stay behind invoice(invoiceId).
 */
export type OrderInvoiceLink = {
  __typename?: 'OrderInvoiceLink';
  /** The date the invoice was issued. The terms clock starts here. */
  invoiceDate: Scalars['DateTime']['output'];
  /**
   * The invoice's own id, one per bill rather than one per order: an order that was billed, withdrawn
   * and billed again has a different invoice id for each bill, and only the orderId field says which
   * order they all belong to. It is NOT the order's id.
   */
  invoiceId: Scalars['String']['output'];
  /**
   * The invoice number. The order number on the order's first bill, and orderNumber-R1,
   * orderNumber-R2 and so on for each bill raised after a previous one was withdrawn.
   */
  invoiceNumber: Scalars['String']['output'];
  /**
   * What the invoice still owes from the amounts recorded against it. Excludes any late charge it
   * has run up but nobody has assessed, and any early-pay discount still available to it — both are
   * as-of figures, and customerReceivables is what reports them.
   */
  openBalance: Scalars['Decimal']['output'];
  /**
   * Where the invoice stands as MONEY — open, part paid, paid, or void. Derived from what has been
   * recorded against it, never stored, so it cannot drift from the amounts.
   */
  standing: InvoiceStanding;
  /**
   * Where the invoice stands as a DOCUMENT — issued, or withdrawn. A withdrawn invoice still
   * carries the amounts it billed and was paid; it is simply no longer a receivable.
   */
  status: InvoiceStatus;
};

export enum OrderInvoiceStatus {
  CreditMemo = 'CREDIT_MEMO',
  Invoiced = 'INVOICED',
  NotInvoiced = 'NOT_INVOICED',
  Unknown = 'UNKNOWN',
  Voided = 'VOIDED'
}

export type OrderInvoiceStatusOperationFilterInput = {
  eq?: InputMaybe<OrderInvoiceStatus>;
  in?: InputMaybe<Array<OrderInvoiceStatus>>;
  neq?: InputMaybe<OrderInvoiceStatus>;
  nin?: InputMaybe<Array<OrderInvoiceStatus>>;
};

/**
 * Read-model document for one entry in a tenant's order kind list, keyed {tenantId}-{orderKindId}. A deleted
 * kind's document is removed.
 */
export type OrderKindDocument = {
  __typename?: 'OrderKindDocument';
  /** The document key: the tenant id and the order kind id, joined by a hyphen. */
  id: Scalars['String']['output'];
  /** The order kind's name. */
  name: Scalars['String']['output'];
  /** The order kind's id. */
  orderKindId: Scalars['String']['output'];
  /** The tenant that owns the order kind. */
  tenantId: Scalars['String']['output'];
  /** When the order kind was last created or renamed. */
  updatedAt: Scalars['DateTime']['output'];
  /** Email of the user who last created or renamed the order kind. */
  updatedBy: Scalars['String']['output'];
};

/**
 * Read-model document for one entry in a tenant's order kind list, keyed {tenantId}-{orderKindId}. A deleted
 * kind's document is removed.
 */
export type OrderKindDocumentFilterInput = {
  and?: InputMaybe<Array<OrderKindDocumentFilterInput>>;
  /** The document key: the tenant id and the order kind id, joined by a hyphen. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** The order kind's name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderKindDocumentFilterInput>>;
  /** The order kind's id. */
  orderKindId?: InputMaybe<StringOperationFilterInput>;
  /** The tenant that owns the order kind. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** When the order kind was last created or renamed. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Email of the user who last created or renamed the order kind. */
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one entry in a tenant's order kind list, keyed {tenantId}-{orderKindId}. A deleted
 * kind's document is removed.
 */
export type OrderKindDocumentSortInput = {
  /** The document key: the tenant id and the order kind id, joined by a hyphen. */
  id?: InputMaybe<SortEnumType>;
  /** The order kind's name. */
  name?: InputMaybe<SortEnumType>;
  /** The order kind's id. */
  orderKindId?: InputMaybe<SortEnumType>;
  /** The tenant that owns the order kind. */
  tenantId?: InputMaybe<SortEnumType>;
  /** When the order kind was last created or renamed. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Email of the user who last created or renamed the order kind. */
  updatedBy?: InputMaybe<SortEnumType>;
};

/** Result of mergeOrderKind or deleteOrderKind. */
export type OrderKindPayload = {
  __typename?: 'OrderKindPayload';
  /** Why the call failed, such as a name already in use; null when it succeeded. */
  errors?: Maybe<Array<ValidationError>>;
  /** The order kind after the change; null when the call failed. */
  orderKind?: Maybe<OrderKindStateData>;
};

/** An order kind as returned by mergeOrderKind and deleteOrderKind. */
export type OrderKindStateData = {
  __typename?: 'OrderKindStateData';
  /** The order kind's name. */
  name: Scalars['String']['output'];
  /** The order kind's id. */
  orderKindId: Scalars['String']['output'];
  /** The tenant that owns the order kind. */
  tenantId: Scalars['String']['output'];
  /** When the order kind was last created, renamed or deleted. */
  updatedAt: Scalars['DateTime']['output'];
  /** Email of the user who last created, renamed or deleted the order kind. */
  updatedBy: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type OrderKindsConnection = {
  __typename?: 'OrderKindsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderKindsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrderKindDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderKindsEdge = {
  __typename?: 'OrderKindsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrderKindDocument;
};

export type OrderLineItemDocument = {
  __typename?: 'OrderLineItemDocument';
  /**
   * The eaches this line's ACKNOWLEDGED rung was stamped with — the figure the line bills while that rung
   * prices it, whatever unit the order was placed in. null on a line not acknowledged, on a line
   * acknowledged before acknowledgements stamped their eaches, and on a row projected before this field
   * existed, until the read model is re-projected or a later acknowledgement, correction or merge on the
   * line writes it.
   */
  acknowledgedEaches?: Maybe<Scalars['Int']['output']>;
  /** Acknowledged quantity in EACHES. */
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  /** The acknowledged quantity in SHIPPING UNITS. */
  acknowledgedUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether a person acknowledged or corrected this line to zero on the Order screen, so an
   * acknowledged quantity of zero bills nothing. false on every line acknowledged before the rule,
   * on every line an import acknowledged, and on a line not acknowledged yet.
   */
  acknowledgedZeroBillsNothing: Scalars['Boolean']['output'];
  /** The user who added this line. Staff only; refused for customer-portal callers. */
  addedBy: Scalars['String']['output'];
  /**
   * The eaches this line's ALLOCATED rung is stated in, on a line of an order placed in eaches.
   * null on every line of an order placed in Shipping UOM units, on a line with no allocated
   * rung, and on a line allocated before allocations stamped it.
   */
  allocatedEaches?: Maybe<Scalars['Int']['output']>;
  /**
   * The allocated quantity in SHIPPING UNITS. null until the line is allocated at all,
   * which is a different fact from an allocation of zero.
   */
  allocatedUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * The quantity of this line's item currently available across all locations and grades — the
   * per-line "Available Number". Resolved at read time from the live, ALLOCATION-AWARE
   * InventoryItem read model (InventoryItemDocument.AvailableQuantity, summed over
   * every location/grade row for the item), so it agrees with what the add-items dialog already
   * shows via GetInventoryItems. The sum is rounded to the nearest whole unit to preserve
   * this field's existing Int shape; see availableByLocation for the un-rounded,
   * per-location breakdown. A site-assigned caller only sees rows for their assigned locations
   * (same fail-closed scope as the add-items dialog). Returns 0 when the item has no
   * inventory rows in scope, and 0 for every customer-portal caller — the storefront
   * publishes availability only through the portal's own configured location/grade window, and
   * the site scope treats an unassigned caller (which every buyer is) as unrestricted.
   */
  available: Scalars['Int']['output'];
  /**
   * The allocation-aware available quantity for this line's item, broken out per location/grade —
   * the un-summed rows behind available. Sourced from the same InventoryItemDocument
   * read model as the add-items dialog, via a batched DataLoader (no N+1 across order lines), and
   * scoped to the caller's assigned locations exactly as the dialog is. Returns an empty list when
   * the item has no inventory rows in scope, and for every customer-portal caller: these rows name
   * the grower's internal locations and their live stock position per grade, which the storefront
   * must never surface (see available for why the site scope alone does not cover a buyer).
   */
  availableByLocation: Array<ItemAvailabilityByLocationData>;
  /** The line's assigned container code, or null when no container is assigned. */
  containerCode?: Maybe<Scalars['String']['output']>;
  /** The grower's internal unit cost basis for this line. Reads 0 for customer-portal callers — 0 is this field's existing not-set value, so the non-null schema type is preserved. Staff callers read the stored figure. */
  cost: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  /**
   * The customer item (customer SKU/UPC) this line uses: the one chosen when the line was added or
   * later via setLineItemCustomerItem, else the ordering customer's default for the item.
   * Null when none applies, and on every line added before customer items were stamped. It may
   * belong to another customer; it never changes the line's price.
   */
  customerItemId?: Maybe<Scalars['String']['output']>;
  /**
   * The customer SKU invoices and pull slips print for this line, snapshotted from
   * customerItemId. Null prints sku instead.
   */
  customerSku?: Maybe<Scalars['String']['output']>;
  /**
   * The customer UPC invoices and pull slips print for this line, snapshotted from
   * customerItemId. Null prints upc instead.
   */
  customerUpc?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  /**
   * How many eaches one shipping unit of this line holds, as snapshotted when the line was added.
   * null on a line written before the snapshot existed; such a line was priced at its
   * stated handling UOM, or at one each per unit when it stated none.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The line's count in SHIPPING UNITS (flats, trays, cases) — despite the name, which says
   * eaches. See the remarks on quantity for why neither field is renamed.
   */
  eachesQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * Where this line's stock comes from — the per-line replacement for the order-level
   * produceAllocate flag. Stored as a string per the document-enum discipline so rows stay
   * readable if ordinals ever shift. UNSPECIFIED for lines added
   * before this field existed (the read-model value is authoritative only for lines written after
   * this slice shipped — the order-level HasMakeToOrderLine rollup is what the Produce queue
   * filters on, and that IS backfilled for historical orders).
   */
  fulfillmentSource: FulfillmentSource;
  /**
   * How many eaches one shipping unit of this line holds — the eaches-per-unit of the Shipping
   * UOM the line was stamped with. NOT a unit of measure and not a UOM reference: the UOM is
   * shippingUomId / shippingConfigCategoryCode, and this is that UOM's pack size.
   */
  handlingUom?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  /**
   * Identifies the single "Add Kit" expansion that produced this line, or null for an ordinary
   * line. Adding the same kit to an order twice yields two different values here, so the two
   * expansions can be rendered as two separate groups.
   */
  kitGroupId?: Maybe<Scalars['String']['output']>;
  /**
   * The kit this line was expanded from, or null for an ordinary line that did not come from a
   * kit. Written once at line add and never revised — the projection stores whatever the client
   * supplied, and nothing verifies the kit still exists, so this may name a deleted kit. It is a
   * display grouping tag, not a reference.
   */
  kitId?: Maybe<Scalars['String']['output']>;
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  /**
   * Staff only; refused for customer-portal callers.
   * The reason a staff user gave for waiving the container configuration's order minimums when
   * this line was added or its quantity edited, or null when no override was claimed — which is
   * every line written before the rule existed, and every ordinary line since.
   */
  minimumOverrideReason?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<LineItemNoteDocument>;
  /**
   * The line's typed notes, one entry per note context (Ship, Pull, General). Additive
   * alongside note, which keeps resolving the General note on its own. A line with no
   * typed note in a context has no entry for it, and a line with no notes at all returns an
   * empty list.
   */
  notes: Array<LineItemContextNoteDocument>;
  /**
   * The unit the parent order was placed in, denormalized onto the line so a grid can tell which
   * of the line's two quantities the customer entered without a second read against the order.
   * Lines of orders created before this was stamped read as SHIPPING_UOM, which is what
   * they were.
   */
  orderEntryUnit: OrderEntryUnit;
  orderId: Scalars['String']['output'];
  /**
   * The eaches this line's ORDER rung was stated in — the number the customer typed on an order
   * placed in eaches. null on every line of an order placed in Shipping UOM units, where
   * the unit count is the entered figure and the eaches are derived from it.
   */
  orderedEaches?: Maybe<Scalars['Int']['output']>;
  /** The eaches originally ordered — the customer's ask, frozen on an active order. */
  orderedQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * The ordered quantity in SHIPPING UNITS — the count of UOM units the customer asked for, as
   * opposed to orderedQuantity, which counts eaches. The two are equal on a line whose
   * Shipping UOM holds one each per unit.
   */
  orderedUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * The item this line was placed on, when an item combine has since moved the line to the item it was
   * combined into; null when no combine moved it. A moved line carries the kept item's name and SKU,
   * and reverting the combine moves it back and clears this.
   */
  originalItemId?: Maybe<Scalars['String']['output']>;
  overridePrice?: Maybe<Scalars['Decimal']['output']>;
  price: Scalars['Decimal']['output'];
  /** The line's quantity in EACHES — the total plant count, not a container count. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Frozen snapshot of the item's royalty terms at line-add time. Null for customer-portal callers — the payee, rate and amount are supplier terms the storefront must never surface. Staff callers read the stored snapshot (still null for a line whose item carries no royalty). */
  royalty?: Maybe<LineItemRoyaltyDocument>;
  /** Staff only; refused for customer-portal callers. */
  royaltyExempt: Scalars['Boolean']['output'];
  /**
   * The eaches this line's SHIPPED rung was stamped with, by a shipment or a verification — the figure the
   * line bills while that rung prices it, whatever unit the order was placed in. null on a line not
   * shipped, on a line shipped or verified before those stamped their eaches, and on a row projected
   * before this field existed, until the read model is re-projected or a later shipment or verification
   * on the line writes it.
   */
  shippedEaches?: Maybe<Scalars['Int']['output']>;
  /** Shipped quantity in EACHES. */
  shippedQuantity?: Maybe<Scalars['Int']['output']>;
  /** The shipped quantity in SHIPPING UNITS. */
  shippedUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether a ship or verification recorded under the shipped-zero rule has shipped this line, so a
   * shipped quantity entered as zero bills nothing. false on every line shipped before the
   * rule, and on a line not shipped yet.
   */
  shippedZeroBillsNothing: Scalars['Boolean']['output'];
  /**
   * The Shipping UOM this line ships on, as a shipping-config CATEGORY code (ConfigCategory
   * namespace — the same code space as the item's defaultShippingConfigCategoryCode, the
   * customer item's shippingConfigCategoryCode on SkuUpcMapping, and the kit
   * line's). Frozen when the line was created, so an order reports the configuration it was
   * placed under rather than today's customer-item setup.
   *
   * null means "resolve at read" and is the value every line created before this field
   * existed carries — no migration, no backfill. Consumers fall back to
   * resolveSkuUpcMapping.
   */
  shippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  /**
   * The Shipping UOM this line ships and is priced on, by shipping-config category id.
   * null on every line placed before Shipping UOM references existed, and on any line
   * whose tenant has configured none — such a line prices at one each per unit.
   */
  shippingUomId?: Maybe<Scalars['String']['output']>;
  /**
   * The display name of the Shipping UOM this line was placed in, resolved from the line's frozen
   * shippingUomId against the line's own tenant's Shipping UOMs, so a later change to the
   * item's Shipping UOM never relabels a placed line. Null when the line has no frozen id (every
   * line placed before Shipping UOM references existed), when the id names no Shipping UOM of the
   * tenant, and when the Shipping UOM has a blank name; the code is never substituted. Published
   * for portal and staff callers alike, because a portal caller cannot read the tenant's
   * configuration categories itself.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  /**
   * The line's first Tag color, by tag color id, or null when the slot is blank. A color deleted
   * after it was chosen stays here.
   */
  tag1ColorId?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the line's first Tag color is locked, so a change to the order's header Tag color leaves it
   * as it is. false on every line placed before Tag colors existed.
   */
  tag1Locked: Scalars['Boolean']['output'];
  /**
   * The line's second Tag color, by tag color id, or null when the slot is blank. A color deleted
   * after it was chosen stays here.
   */
  tag2ColorId?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the line's second Tag color is locked. Stored as sent; the header Tag color never changes the
   * second slot. false on every line placed before Tag colors existed.
   */
  tag2Locked: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  /**
   * Computed pricing adjustment contributed by this line's upgrades, NOT persisted (resolved
   * at read time so it always reflects the stored upgrades and pricing fields). Shares the
   * OrderState.CalculateUpgradeAdjustment kernel with the order subtotal/total and taxable
   * base, so the adjustment surfaced here is exactly what the order total includes.
   */
  upgradeSubtotalAdjustment: Scalars['Decimal']['output'];
  /** Per-line upgrade ("Value Add") snapshots frozen onto this line. Empty for lines added before upgrades existed. Each snapshot is immutable with respect to the originating item. Each entry's cost reads null for customer-portal callers — it is the grower's internal cost of the upgrade, not the price the buyer pays (that is carried by pricing). Staff callers read the stored cost. */
  upgrades: Array<OrderLineUpgradeDocument>;
};

export type OrderLineItemDocumentFilterInput = {
  /**
   * The eaches this line's ACKNOWLEDGED rung was stamped with — the figure the line bills while that rung
   * prices it, whatever unit the order was placed in. null on a line not acknowledged, on a line
   * acknowledged before acknowledgements stamped their eaches, and on a row projected before this field
   * existed, until the read model is re-projected or a later acknowledgement, correction or merge on the
   * line writes it.
   */
  acknowledgedEaches?: InputMaybe<IntOperationFilterInput>;
  /** Acknowledged quantity in EACHES. */
  acknowledgedQuantity?: InputMaybe<IntOperationFilterInput>;
  /** The acknowledged quantity in SHIPPING UNITS. */
  acknowledgedUnits?: InputMaybe<IntOperationFilterInput>;
  addedBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * The eaches this line's ALLOCATED rung is stated in, on a line of an order placed in eaches.
   * null on every line of an order placed in Shipping UOM units, on a line with no allocated
   * rung, and on a line allocated before allocations stamped it.
   */
  allocatedEaches?: InputMaybe<IntOperationFilterInput>;
  /**
   * The allocated quantity in SHIPPING UNITS. null until the line is allocated at all,
   * which is a different fact from an allocation of zero.
   */
  allocatedUnits?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<OrderLineItemDocumentFilterInput>>;
  /** The line's assigned container code, or null when no container is assigned. */
  containerCode?: InputMaybe<StringOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer item (customer SKU/UPC) this line uses: the one chosen when the line was added or
   * later via setLineItemCustomerItem, else the ordering customer's default for the item.
   * Null when none applies, and on every line added before customer items were stamped. It may
   * belong to another customer; it never changes the line's price.
   */
  customerItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer SKU invoices and pull slips print for this line, snapshotted from
   * customerItemId. Null prints sku instead.
   */
  customerSku?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer UPC invoices and pull slips print for this line, snapshotted from
   * customerItemId. Null prints upc instead.
   */
  customerUpc?: InputMaybe<StringOperationFilterInput>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * How many eaches one shipping unit of this line holds, as snapshotted when the line was added.
   * null on a line written before the snapshot existed; such a line was priced at its
   * stated handling UOM, or at one each per unit when it stated none.
   */
  eachesPerUnit?: InputMaybe<IntOperationFilterInput>;
  /**
   * The line's count in SHIPPING UNITS (flats, trays, cases) — despite the name, which says
   * eaches. See the remarks on quantity for why neither field is renamed.
   */
  eachesQuantity?: InputMaybe<IntOperationFilterInput>;
  /**
   * Where this line's stock comes from — the per-line replacement for the order-level
   * produceAllocate flag. Stored as a string per the document-enum discipline so rows stay
   * readable if ordinals ever shift. UNSPECIFIED for lines added
   * before this field existed (the read-model value is authoritative only for lines written after
   * this slice shipped — the order-level HasMakeToOrderLine rollup is what the Produce queue
   * filters on, and that IS backfilled for historical orders).
   */
  fulfillmentSource?: InputMaybe<FulfillmentSourceOperationFilterInput>;
  /**
   * How many eaches one shipping unit of this line holds — the eaches-per-unit of the Shipping
   * UOM the line was stamped with. NOT a unit of measure and not a UOM reference: the UOM is
   * shippingUomId / shippingConfigCategoryCode, and this is that UOM's pack size.
   */
  handlingUom?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemGroup?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Identifies the single "Add Kit" expansion that produced this line, or null for an ordinary
   * line. Adding the same kit to an order twice yields two different values here, so the two
   * expansions can be rendered as two separate groups.
   */
  kitGroupId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The kit this line was expanded from, or null for an ordinary line that did not come from a
   * kit. Written once at line add and never revised — the projection stores whatever the client
   * supplied, and nothing verifies the kit still exists, so this may name a deleted kit. It is a
   * display grouping tag, not a reference.
   */
  kitId?: InputMaybe<StringOperationFilterInput>;
  lineItemId?: InputMaybe<UuidOperationFilterInput>;
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * The reason a staff user gave for waiving the container configuration's order minimums when
   * this line was added or its quantity edited, or null when no override was claimed — which is
   * every line written before the rule existed, and every ordinary line since.
   */
  minimumOverrideReason?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<LineItemNoteDocumentFilterInput>;
  /**
   * The line's typed notes, one entry per note context (Ship, Pull, General). Additive
   * alongside note, which keeps resolving the General note on its own. A line with no
   * typed note in a context has no entry for it, and a line with no notes at all returns an
   * empty list.
   */
  notes?: InputMaybe<ListFilterInputTypeOfLineItemContextNoteDocumentFilterInput>;
  or?: InputMaybe<Array<OrderLineItemDocumentFilterInput>>;
  /**
   * The unit the parent order was placed in, denormalized onto the line so a grid can tell which
   * of the line's two quantities the customer entered without a second read against the order.
   * Lines of orders created before this was stamped read as SHIPPING_UOM, which is what
   * they were.
   */
  orderEntryUnit?: InputMaybe<OrderEntryUnitOperationFilterInput>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The eaches this line's ORDER rung was stated in — the number the customer typed on an order
   * placed in eaches. null on every line of an order placed in Shipping UOM units, where
   * the unit count is the entered figure and the eaches are derived from it.
   */
  orderedEaches?: InputMaybe<IntOperationFilterInput>;
  /** The eaches originally ordered — the customer's ask, frozen on an active order. */
  orderedQuantity?: InputMaybe<IntOperationFilterInput>;
  /**
   * The ordered quantity in SHIPPING UNITS — the count of UOM units the customer asked for, as
   * opposed to orderedQuantity, which counts eaches. The two are equal on a line whose
   * Shipping UOM holds one each per unit.
   */
  orderedUnits?: InputMaybe<IntOperationFilterInput>;
  /**
   * The item this line was placed on, when an item combine has since moved the line to the item it was
   * combined into; null when no combine moved it. A moved line carries the kept item's name and SKU,
   * and reverting the combine moves it back and clears this.
   */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  overridePrice?: InputMaybe<DecimalOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  /** The line's quantity in EACHES — the total plant count, not a container count. */
  quantity?: InputMaybe<IntOperationFilterInput>;
  /** Staff only; refused for customer-portal callers. */
  royaltyExempt?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The eaches this line's SHIPPED rung was stamped with, by a shipment or a verification — the figure the
   * line bills while that rung prices it, whatever unit the order was placed in. null on a line not
   * shipped, on a line shipped or verified before those stamped their eaches, and on a row projected
   * before this field existed, until the read model is re-projected or a later shipment or verification
   * on the line writes it.
   */
  shippedEaches?: InputMaybe<IntOperationFilterInput>;
  /** Shipped quantity in EACHES. */
  shippedQuantity?: InputMaybe<IntOperationFilterInput>;
  /** The shipped quantity in SHIPPING UNITS. */
  shippedUnits?: InputMaybe<IntOperationFilterInput>;
  /**
   * The Shipping UOM this line ships on, as a shipping-config CATEGORY code (ConfigCategory
   * namespace — the same code space as the item's defaultShippingConfigCategoryCode, the
   * customer item's shippingConfigCategoryCode on SkuUpcMapping, and the kit
   * line's). Frozen when the line was created, so an order reports the configuration it was
   * placed under rather than today's customer-item setup.
   *
   * null means "resolve at read" and is the value every line created before this field
   * existed carries — no migration, no backfill. Consumers fall back to
   * resolveSkuUpcMapping.
   */
  shippingConfigCategoryCode?: InputMaybe<StringOperationFilterInput>;
  /**
   * The Shipping UOM this line ships and is priced on, by shipping-config category id.
   * null on every line placed before Shipping UOM references existed, and on any line
   * whose tenant has configured none — such a line prices at one each per unit.
   */
  shippingUomId?: InputMaybe<StringOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  /**
   * The line's first Tag color, by tag color id, or null when the slot is blank. A color deleted
   * after it was chosen stays here.
   */
  tag1ColorId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether the line's first Tag color is locked, so a change to the order's header Tag color leaves it
   * as it is. false on every line placed before Tag colors existed.
   */
  tag1Locked?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The line's second Tag color, by tag color id, or null when the slot is blank. A color deleted
   * after it was chosen stays here.
   */
  tag2ColorId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether the line's second Tag color is locked. Stored as sent; the header Tag color never changes the
   * second slot. false on every line placed before Tag colors existed.
   */
  tag2Locked?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  /**
   * Per-line upgrade ("Value Add") snapshots frozen onto this line. Empty for lines added
   * before upgrades existed. Each snapshot is immutable with respect to the originating item.
   */
  upgrades?: InputMaybe<ListFilterInputTypeOfOrderLineUpgradeDocumentFilterInput>;
};

export type OrderLineItemDocumentSortInput = {
  /**
   * The eaches this line's ACKNOWLEDGED rung was stamped with — the figure the line bills while that rung
   * prices it, whatever unit the order was placed in. null on a line not acknowledged, on a line
   * acknowledged before acknowledgements stamped their eaches, and on a row projected before this field
   * existed, until the read model is re-projected or a later acknowledgement, correction or merge on the
   * line writes it.
   */
  acknowledgedEaches?: InputMaybe<SortEnumType>;
  /** Acknowledged quantity in EACHES. */
  acknowledgedQuantity?: InputMaybe<SortEnumType>;
  /** The acknowledged quantity in SHIPPING UNITS. */
  acknowledgedUnits?: InputMaybe<SortEnumType>;
  addedBy?: InputMaybe<SortEnumType>;
  /**
   * The eaches this line's ALLOCATED rung is stated in, on a line of an order placed in eaches.
   * null on every line of an order placed in Shipping UOM units, on a line with no allocated
   * rung, and on a line allocated before allocations stamped it.
   */
  allocatedEaches?: InputMaybe<SortEnumType>;
  /**
   * The allocated quantity in SHIPPING UNITS. null until the line is allocated at all,
   * which is a different fact from an allocation of zero.
   */
  allocatedUnits?: InputMaybe<SortEnumType>;
  /** The line's assigned container code, or null when no container is assigned. */
  containerCode?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  /**
   * The customer item (customer SKU/UPC) this line uses: the one chosen when the line was added or
   * later via setLineItemCustomerItem, else the ordering customer's default for the item.
   * Null when none applies, and on every line added before customer items were stamped. It may
   * belong to another customer; it never changes the line's price.
   */
  customerItemId?: InputMaybe<SortEnumType>;
  /**
   * The customer SKU invoices and pull slips print for this line, snapshotted from
   * customerItemId. Null prints sku instead.
   */
  customerSku?: InputMaybe<SortEnumType>;
  /**
   * The customer UPC invoices and pull slips print for this line, snapshotted from
   * customerItemId. Null prints upc instead.
   */
  customerUpc?: InputMaybe<SortEnumType>;
  dateAdded?: InputMaybe<SortEnumType>;
  /**
   * How many eaches one shipping unit of this line holds, as snapshotted when the line was added.
   * null on a line written before the snapshot existed; such a line was priced at its
   * stated handling UOM, or at one each per unit when it stated none.
   */
  eachesPerUnit?: InputMaybe<SortEnumType>;
  /**
   * The line's count in SHIPPING UNITS (flats, trays, cases) — despite the name, which says
   * eaches. See the remarks on quantity for why neither field is renamed.
   */
  eachesQuantity?: InputMaybe<SortEnumType>;
  /**
   * Where this line's stock comes from — the per-line replacement for the order-level
   * produceAllocate flag. Stored as a string per the document-enum discipline so rows stay
   * readable if ordinals ever shift. UNSPECIFIED for lines added
   * before this field existed (the read-model value is authoritative only for lines written after
   * this slice shipped — the order-level HasMakeToOrderLine rollup is what the Produce queue
   * filters on, and that IS backfilled for historical orders).
   */
  fulfillmentSource?: InputMaybe<SortEnumType>;
  /**
   * How many eaches one shipping unit of this line holds — the eaches-per-unit of the Shipping
   * UOM the line was stamped with. NOT a unit of measure and not a UOM reference: the UOM is
   * shippingUomId / shippingConfigCategoryCode, and this is that UOM's pack size.
   */
  handlingUom?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemGroup?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  /**
   * Identifies the single "Add Kit" expansion that produced this line, or null for an ordinary
   * line. Adding the same kit to an order twice yields two different values here, so the two
   * expansions can be rendered as two separate groups.
   */
  kitGroupId?: InputMaybe<SortEnumType>;
  /**
   * The kit this line was expanded from, or null for an ordinary line that did not come from a
   * kit. Written once at line add and never revised — the projection stores whatever the client
   * supplied, and nothing verifies the kit still exists, so this may name a deleted kit. It is a
   * display grouping tag, not a reference.
   */
  kitId?: InputMaybe<SortEnumType>;
  lineItemId?: InputMaybe<SortEnumType>;
  lineNumber?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * The reason a staff user gave for waiving the container configuration's order minimums when
   * this line was added or its quantity edited, or null when no override was claimed — which is
   * every line written before the rule existed, and every ordinary line since.
   */
  minimumOverrideReason?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  note?: InputMaybe<LineItemNoteDocumentSortInput>;
  /**
   * The unit the parent order was placed in, denormalized onto the line so a grid can tell which
   * of the line's two quantities the customer entered without a second read against the order.
   * Lines of orders created before this was stamped read as SHIPPING_UOM, which is what
   * they were.
   */
  orderEntryUnit?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  /**
   * The eaches this line's ORDER rung was stated in — the number the customer typed on an order
   * placed in eaches. null on every line of an order placed in Shipping UOM units, where
   * the unit count is the entered figure and the eaches are derived from it.
   */
  orderedEaches?: InputMaybe<SortEnumType>;
  /** The eaches originally ordered — the customer's ask, frozen on an active order. */
  orderedQuantity?: InputMaybe<SortEnumType>;
  /**
   * The ordered quantity in SHIPPING UNITS — the count of UOM units the customer asked for, as
   * opposed to orderedQuantity, which counts eaches. The two are equal on a line whose
   * Shipping UOM holds one each per unit.
   */
  orderedUnits?: InputMaybe<SortEnumType>;
  /**
   * The item this line was placed on, when an item combine has since moved the line to the item it was
   * combined into; null when no combine moved it. A moved line carries the kept item's name and SKU,
   * and reverting the combine moves it back and clears this.
   */
  originalItemId?: InputMaybe<SortEnumType>;
  overridePrice?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  /** The line's quantity in EACHES — the total plant count, not a container count. */
  quantity?: InputMaybe<SortEnumType>;
  /** Staff only; refused for customer-portal callers. */
  royaltyExempt?: InputMaybe<SortEnumType>;
  /**
   * The eaches this line's SHIPPED rung was stamped with, by a shipment or a verification — the figure the
   * line bills while that rung prices it, whatever unit the order was placed in. null on a line not
   * shipped, on a line shipped or verified before those stamped their eaches, and on a row projected
   * before this field existed, until the read model is re-projected or a later shipment or verification
   * on the line writes it.
   */
  shippedEaches?: InputMaybe<SortEnumType>;
  /** Shipped quantity in EACHES. */
  shippedQuantity?: InputMaybe<SortEnumType>;
  /** The shipped quantity in SHIPPING UNITS. */
  shippedUnits?: InputMaybe<SortEnumType>;
  /**
   * The Shipping UOM this line ships on, as a shipping-config CATEGORY code (ConfigCategory
   * namespace — the same code space as the item's defaultShippingConfigCategoryCode, the
   * customer item's shippingConfigCategoryCode on SkuUpcMapping, and the kit
   * line's). Frozen when the line was created, so an order reports the configuration it was
   * placed under rather than today's customer-item setup.
   *
   * null means "resolve at read" and is the value every line created before this field
   * existed carries — no migration, no backfill. Consumers fall back to
   * resolveSkuUpcMapping.
   */
  shippingConfigCategoryCode?: InputMaybe<SortEnumType>;
  /**
   * The Shipping UOM this line ships and is priced on, by shipping-config category id.
   * null on every line placed before Shipping UOM references existed, and on any line
   * whose tenant has configured none — such a line prices at one each per unit.
   */
  shippingUomId?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  /**
   * The line's first Tag color, by tag color id, or null when the slot is blank. A color deleted
   * after it was chosen stays here.
   */
  tag1ColorId?: InputMaybe<SortEnumType>;
  /**
   * Whether the line's first Tag color is locked, so a change to the order's header Tag color leaves it
   * as it is. false on every line placed before Tag colors existed.
   */
  tag1Locked?: InputMaybe<SortEnumType>;
  /**
   * The line's second Tag color, by tag color id, or null when the slot is blank. A color deleted
   * after it was chosen stays here.
   */
  tag2ColorId?: InputMaybe<SortEnumType>;
  /**
   * Whether the line's second Tag color is locked. Stored as sent; the header Tag color never changes the
   * second slot. false on every line placed before Tag colors existed.
   */
  tag2Locked?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type OrderLineItemsConnection = {
  __typename?: 'OrderLineItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderLineItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrderLineItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderLineItemsEdge = {
  __typename?: 'OrderLineItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrderLineItemDocument;
};

/**
 * The preview of one unfinished Order line's price. An observation, not a lock: the Save prices again from the
 * sources as they stand when it runs.
 */
export type OrderLinePricePreview = {
  __typename?: 'OrderLinePricePreview';
  /** The saved line's current price, when the target is or merges into a saved line. */
  committedPrice?: Maybe<Scalars['Decimal']['output']>;
  /** The host's request generation, echoed. */
  controllerGeneration: Scalars['Int']['output'];
  /** The manual price the preview preserves. Present only when the state is MANUAL_PRESERVED. */
  manualPrice?: Maybe<Scalars['Decimal']['output']>;
  /** The mode the preview answered for, once it was resolved. */
  mode?: Maybe<OrderLinePricePreviewMode>;
  /** Whether the target is a new line or an edit, once the plan is known. */
  operation?: Maybe<OrderLinePricePreviewOperation>;
  /** The saved line the target ends up as, once the projection ran. */
  physicalTarget?: Maybe<OrderLinePricePreviewPhysicalTarget>;
  /** The Save plan the preview projected, once it was planned. */
  plan?: Maybe<OrderLineSavePlan>;
  /** The specific reason behind the state, when there is one. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The Save stage that would be refused, when the state is PLAN_NOT_READY. */
  refusedStage?: Maybe<Scalars['String']['output']>;
  /** When the preview read its sources. */
  resolvedAt: Scalars['DateTime']['output'];
  /** True when the Save would also move the price of another saved line. */
  siblingPricesChange: Scalars['Boolean']['output'];
  /** Where the price came from, when a pricing pass priced the line. */
  source?: Maybe<OrderLinePricePreviewSource>;
  /** The target staged line, echoed. */
  stagedLineId: Scalars['String']['output'];
  /** What the preview concluded. */
  state: OrderLinePricePreviewState;
  /** The price the line would carry after the Save. Present only when the state is READY. */
  suggestedPrice?: Maybe<Scalars['Decimal']['output']>;
};

/** A saved line as the host last observed it, in the quantities its Save would send. */
export type OrderLinePricePreviewBaselineLineInput = {
  /** The line's shipping-unit count, when the host has one. */
  eachesQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The saved line's item. */
  itemId: Scalars['String']['input'];
  /** The saved line's id. */
  lineItemId: Scalars['UUID']['input'];
  /** The saved line's number. */
  lineNumber: Scalars['Int']['input'];
  /** The line's eaches. */
  quantity: Scalars['Int']['input'];
};

/** The Order context the host observed when it asked for the preview. A mismatch is reported, never applied. */
export type OrderLinePricePreviewContextInput = {
  /** The host's request generation, echoed back so a late answer can be recognized. */
  controllerGeneration: Scalars['Int']['input'];
  /** The Order's customer as the host shows it. */
  customerId: Scalars['String']['input'];
  /** The Order's status as the host shows it. */
  orderStatus: OrderStatus;
  /** True while the host holds an unsaved customer, ship-to or date edit. */
  priceAffectingHeaderDirty: Scalars['Boolean']['input'];
  /** The Order's requested delivery date as the host shows it, or null when it has none. */
  requestedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The Order's ship-to location as the host shows it. */
  shipToLocationId: Scalars['UUID']['input'];
};

/** A line of the host's desired final draft, in the quantities and identity its Save would send. */
export type OrderLinePricePreviewDesiredLineInput = {
  /** The line's container. */
  containerCode?: InputMaybe<Scalars['String']['input']>;
  /** The customer item the line prints. */
  customerItemId?: InputMaybe<Scalars['String']['input']>;
  /** The line's shipping-unit count as the Save sends it, or null when the order is entered in eaches. */
  eachesQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Where the line is fulfilled from. */
  fulfillmentSource: FulfillmentSource;
  /** The line's handling unit of measure. */
  handlingUom?: InputMaybe<Scalars['Int']['input']>;
  /** The line's item. */
  itemId: Scalars['String']['input'];
  /** The kit expansion the line belongs to. */
  kitGroupId?: InputMaybe<Scalars['String']['input']>;
  /** The kit the line came from. */
  kitId?: InputMaybe<Scalars['String']['input']>;
  /** The saved line's id, or the id the add will send for a new line. */
  lineItemId: Scalars['UUID']['input'];
  /** The saved line this edits, or null or 0 for a new line. */
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  /** True only when a person deliberately entered this new line's price, including a zero or a price equal to the suggestion. */
  manualOrigin: Scalars['Boolean']['input'];
  /** The deliberately entered price, required when the line is of manual origin. */
  manualPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** The line's eaches as the Save sends them. */
  quantity: Scalars['Int']['input'];
  /** Whether the line is exempt from royalty. */
  royaltyExempt: Scalars['Boolean']['input'];
  /** The line's shipping configuration category. */
  shippingConfigCategoryCode?: InputMaybe<Scalars['String']['input']>;
  /** The line's Shipping UOM. */
  shippingUomId?: InputMaybe<Scalars['String']['input']>;
  /** The item code the add sends. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** The host's stable staged identity for the line. */
  stagedLineId: Scalars['String']['input'];
  /**
   * The automatic price a plain add sends for this new line when it is not of manual origin, not an override. Only a plain
   * add (serverPricedAdds false) reads it, and stating it on any desired line is what lets a plain add be previewed.
   */
  statedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** The item UPC the add sends. */
  upc?: InputMaybe<Scalars['String']['input']>;
};

/** What kind of line the host is editing, as its form declares it. */
export enum OrderLinePricePreviewEntityKind {
  /** A Custom line, which is priced manually only. */
  Custom = 'CUSTOM',
  /** A Hardgood line, which always prices from WorkSuite pricing. */
  Hardgood = 'HARDGOOD',
  /** A catalog Item line. */
  Item = 'ITEM'
}

/** The unfinished Order line draft to price, read against the saved Order without writing anything. */
export type OrderLinePricePreviewInput = {
  /** The saved lines the host observed, at most 1000. */
  baselineLines: Array<OrderLinePricePreviewBaselineLineInput>;
  /** The host's desired final lines, at most 1000. */
  desiredLines: Array<OrderLinePricePreviewDesiredLineInput>;
  /** The Order context the host observed. */
  expectedContext: OrderLinePricePreviewContextInput;
  /** The saved Order, or an empty id while the Order is not created yet. */
  orderId: Scalars['String']['input'];
  /** The Save mode the host will use. */
  saveMode: OrderLinePricePreviewSaveModeInput;
  /** The staged line to price. */
  target: OrderLinePricePreviewTargetInput;
};

/** The mode the preview answered for. Any change to it invalidates the answer. */
export type OrderLinePricePreviewMode = {
  __typename?: 'OrderLinePricePreviewMode';
  /** The target line's kind. */
  entityKind: OrderLinePricePreviewEntityKind;
  /** The tenant's ERP pricing mode. */
  erpPricing: Scalars['Boolean']['output'];
  /** A SHA-256 over the mode, the context and every baseline and desired line, for correlating this answer with the Save. */
  fingerprint: Scalars['String']['output'];
  /** The Save plan contract version. */
  planVersion: Scalars['Int']['output'];
  /** The Save receiver the target line's stage goes to. */
  receiver: OrderLinePricePreviewReceiver;
  /** Whether automatic new lines go to addLineItemsWithPricing; false for a plain add through addLineItems. */
  serverPricedAdds: Scalars['Boolean']['output'];
};

/** Whether the target staged line is a new line or an edit of a saved line. */
export enum OrderLinePricePreviewOperation {
  /** A new line the Save adds. */
  Add = 'ADD',
  /** A saved line the Save keeps or edits. */
  Edit = 'EDIT'
}

/** The saved line the target ends up as once the Save completes. */
export type OrderLinePricePreviewPhysicalTarget = {
  __typename?: 'OrderLinePricePreviewPhysicalTarget';
  /** The line's id. */
  lineItemId: Scalars['UUID']['output'];
  /** The line's number. */
  lineNumber: Scalars['Int']['output'];
  /** True when a new line would be merged into this saved line rather than added beside it. */
  mergedIntoExisting: Scalars['Boolean']['output'];
};

/** The Save receiver the target line's stage goes to. */
export enum OrderLinePricePreviewReceiver {
  /** addLineItems, which keeps the line's manual price, or, for a plain add, the automatic price the host states. */
  AddLineItems = 'ADD_LINE_ITEMS',
  /** addLineItemsWithPricing, which prices the line on the server. */
  AddLineItemsWithPricing = 'ADD_LINE_ITEMS_WITH_PRICING',
  /** No stage touches the target line itself. */
  None = 'NONE',
  /** updateLineItem, a quantity update of a saved line. */
  UpdateLineItem = 'UPDATE_LINE_ITEM'
}

/** Which pricing pass produced the line's price. */
export enum OrderLinePricePreviewReceiverMode {
  /** The per-line price a server-priced add gives a kit line, with levels in force at the clock. */
  PerLineAdd = 'PER_LINE_ADD',
  /** The per-line reprice kit lines receive after each line edit. */
  PerLineReprice = 'PER_LINE_REPRICE',
  /** The pooled pass a server-priced add prices its new lines with. */
  PooledAdd = 'POOLED_ADD',
  /** The pooled whole-order reprice that follows each line edit. */
  PooledReprice = 'POOLED_REPRICE'
}

/** The Save mode the host will use. The preview refuses to answer for a different mode than the server's. */
export type OrderLinePricePreviewSaveModeInput = {
  /** The tenant's ERP pricing mode as the host read it. */
  erpPricing: Scalars['Boolean']['input'];
  /** The Save plan contract version the host implements. */
  planVersion: Scalars['Int']['input'];
  /**
   * True when the host sends automatic new lines to addLineItemsWithPricing. False for a plain add, which sends every
   * new line to addLineItems and is previewed only when a desired line states its automatic price.
   */
  serverPricedAdds: Scalars['Boolean']['input'];
};

/** Where the line's price came from. */
export type OrderLinePricePreviewSource = {
  __typename?: 'OrderLinePricePreviewSource';
  /** The date price-level effectivity was evaluated at. */
  levelEffectiveAt: Scalars['DateTime']['output'];
  /** The Order's placed date used for qualification, when it has one. */
  placedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The quantity the line was priced at, when priced in a pooled pass. */
  pooledQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The price group the Order resolved to, when one did. */
  priceGroupId?: Maybe<Scalars['String']['output']>;
  /** The winning price level, or on an ERP-priced tenant the ERP price row, when one won. */
  priceLevelId?: Maybe<Scalars['String']['output']>;
  /** The pricing pass that produced it. */
  receiverMode: OrderLinePricePreviewReceiverMode;
  /** The Order's requested ship date used for qualification, when it has one. */
  requestedShipDate?: Maybe<Scalars['DateTime']['output']>;
  /** The volume pool the line was priced in, when it pools. */
  volumePoolId?: Maybe<Scalars['String']['output']>;
};

/** What the Order line price preview concluded for the target staged line. */
export enum OrderLinePricePreviewState {
  /** The Order, its mode or the host's baseline no longer matches what the host observed. */
  ContextChanged = 'CONTEXT_CHANGED',
  /** The Order has not been created yet, so there is no persisted context to price against. */
  ContextNotPersisted = 'CONTEXT_NOT_PERSISTED',
  /** The line's committed price stands; nothing in the planned Save restates it. */
  CurrentCommitted = 'CURRENT_COMMITTED',
  /** The request itself is unusable; the reason says why. */
  Error = 'ERROR',
  /** The host holds an unsaved price-affecting header edit, which must be saved and acknowledged first. */
  HeaderAckRequired = 'HEADER_ACK_REQUIRED',
  /** The line's price is a deliberate manual price, which the preview keeps and never replaces. */
  ManualPreserved = 'MANUAL_PRESERVED',
  /** The flow needs a native capability that is not delivered yet. */
  NativeCapabilityRequired = 'NATIVE_CAPABILITY_REQUIRED',
  /** A stage of the planned Save would be refused, so the Save as planned would not complete. */
  PlanNotReady = 'PLAN_NOT_READY',
  /** A proved resolution: the price the line would carry after the planned Save, adoptable as a suggestion. */
  Ready = 'READY',
  /** The line's intended receiver has no qualified preview mode yet. */
  ReceiverNotSupported = 'RECEIVER_NOT_SUPPORTED',
  /** A source the price depends on could not be read, so no price is offered. */
  UnavailableDependency = 'UNAVAILABLE_DEPENDENCY',
  /** Nothing prices the line; the reason says why. Never a manufactured price. */
  Unresolved = 'UNRESOLVED'
}

/** The staged line the host wants priced. */
export type OrderLinePricePreviewTargetInput = {
  /** What kind of line it is. */
  entityKind: OrderLinePricePreviewEntityKind;
  /** The staged id of a line in the desired lines. */
  stagedLineId: Scalars['String']['input'];
};

/** One recorded pull: a puller took a quantity of an order line from one location at one grade. Staff only. */
export type OrderLinePull = {
  __typename?: 'OrderLinePull';
  /** The grade pulled. */
  grade: Scalars['Int']['output'];
  /** The line's item. */
  itemId: Scalars['String']['output'];
  /** The order line that was pulled for. */
  lineItemId: Scalars['UUID']['output'];
  /** The location the quantity was pulled from. */
  locationId: Scalars['String']['output'];
  /** The pulled-from location's current name. Null when the location no longer resolves. */
  locationName?: Maybe<Scalars['String']['output']>;
  /** Identifies this pull. */
  pullId: Scalars['String']['output'];
  /** When the pull was recorded. */
  pulledAt: Scalars['DateTime']['output'];
  /** The email address of the user who pulled. */
  pulledBy: Scalars['String']['output'];
  /** How many were pulled, in the unit the line's quantity is in. */
  quantity: Scalars['Int']['output'];
};

/** The fixed Order line Save plan. Its stages run in this order: removals, pinned adds, server-priced adds, then updates. */
export type OrderLineSavePlan = {
  __typename?: 'OrderLineSavePlan';
  /** Staged ids of the new lines added with their manual price through addLineItems, in desired order. */
  pinnedAdds: Array<Scalars['String']['output']>;
  /** The plan contract version. */
  planVersion: Scalars['Int']['output'];
  /** Saved line numbers to remove, ascending. */
  removals: Array<Scalars['Int']['output']>;
  /** Staged ids of the new lines added through addLineItemsWithPricing, in desired order. */
  serverPricedAdds: Array<Scalars['String']['output']>;
  /** Quantity updates of saved lines, by ascending line number. */
  updates: Array<OrderLineSavePlanUpdate>;
};

/** One planned quantity update of a saved line. */
export type OrderLineSavePlanUpdate = {
  __typename?: 'OrderLineSavePlanUpdate';
  /** The shipping-unit count the update sends, or null when the order is entered in eaches. */
  eachesQuantity?: Maybe<Scalars['Int']['output']>;
  /** The saved line's number. */
  lineNumber: Scalars['Int']['output'];
  /** The eaches the update sends. */
  quantity: Scalars['Int']['output'];
  /** The staged line the update comes from. */
  stagedLineId: Scalars['String']['output'];
};

export type OrderLineUpgradeCostDataInput = {
  laborMinutes?: InputMaybe<Scalars['Decimal']['input']>;
  laborTypeCode?: InputMaybe<Scalars['String']['input']>;
  materialCost?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderLineUpgradeData = {
  __typename?: 'OrderLineUpgradeData';
  categoryLabel?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<ItemUpgradeCost>;
  lineItemUpgradeId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pricing: ItemUpgradePricing;
  source: OrderLineUpgradeSource;
  sourceItemUpgradeId?: Maybe<Scalars['String']['output']>;
};

/**
 * Read-model snapshot of a per-line upgrade ("Value Add"). Document-only sub-record. Enums are
 * stored as strings per the pinned document-enum discipline so stored rows stay readable if
 * ordinals ever shift — Source via BsonRepresentation here, the nested
 * Pricing.Mode via the ItemUpgradePricing class map registered in
 * Mongo (the shared record cannot carry the attribute) — and are surfaced to
 * GraphQL by name; Option<T> optionals render as nullable GraphQL fields via the
 * registered Option converters.
 */
export type OrderLineUpgradeDocument = {
  __typename?: 'OrderLineUpgradeDocument';
  categoryLabel?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<ItemUpgradeCost>;
  lineItemUpgradeId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pricing: ItemUpgradePricing;
  source: OrderLineUpgradeSource;
  sourceItemUpgradeId?: Maybe<Scalars['String']['output']>;
};

/**
 * Read-model snapshot of a per-line upgrade ("Value Add"). Document-only sub-record. Enums are
 * stored as strings per the pinned document-enum discipline so stored rows stay readable if
 * ordinals ever shift — Source via BsonRepresentation here, the nested
 * Pricing.Mode via the ItemUpgradePricing class map registered in
 * Mongo (the shared record cannot carry the attribute) — and are surfaced to
 * GraphQL by name; Option<T> optionals render as nullable GraphQL fields via the
 * registered Option converters.
 */
export type OrderLineUpgradeDocumentFilterInput = {
  and?: InputMaybe<Array<OrderLineUpgradeDocumentFilterInput>>;
  categoryLabel?: InputMaybe<OptionOfStringFilterInput>;
  lineItemUpgradeId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderLineUpgradeDocumentFilterInput>>;
  pricing?: InputMaybe<ItemUpgradePricingFilterInput>;
  source?: InputMaybe<OrderLineUpgradeSourceOperationFilterInput>;
  sourceItemUpgradeId?: InputMaybe<OptionOfStringFilterInput>;
};

export type OrderLineUpgradePricingDataInput = {
  flatPrice?: InputMaybe<Scalars['Decimal']['input']>;
  markupPercent?: InputMaybe<Scalars['Decimal']['input']>;
  mode: PricingMode;
};

export enum OrderLineUpgradeSource {
  AddedByUser = 'ADDED_BY_USER',
  AdHoc = 'AD_HOC',
  CustomerDefault = 'CUSTOMER_DEFAULT',
  CustomerItemDefault = 'CUSTOMER_ITEM_DEFAULT',
  ItemDefault = 'ITEM_DEFAULT',
  PrePricing = 'PRE_PRICING'
}

export type OrderLineUpgradeSourceOperationFilterInput = {
  eq?: InputMaybe<OrderLineUpgradeSource>;
  in?: InputMaybe<Array<OrderLineUpgradeSource>>;
  neq?: InputMaybe<OrderLineUpgradeSource>;
  nin?: InputMaybe<Array<OrderLineUpgradeSource>>;
};

export type OrderLocationDocumentData = {
  __typename?: 'OrderLocationDocumentData';
  adGroup: Scalars['String']['output'];
  address: CreateAddress;
  allowOrderBillingAddressEdit?: Maybe<Scalars['Boolean']['output']>;
  allowOrderLocationAddressEdit?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  globalLocationNumber: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  market: Scalars['String']['output'];
  name: Scalars['String']['output'];
  poRequired?: Maybe<Scalars['Boolean']['output']>;
  priceGroupId?: Maybe<Scalars['String']['output']>;
  priceGroupName?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  /**
   * Ship-to route snapshot (tier 2 of the hierarchical route setting), captured at order
   * create/edit time. Empty for orders that never captured an explicit route — those resolve
   * their effective route from the live inherited tier and are re-stamped on upstream change.
   * Mirrors TermsId's snapshot role.
   */
  route?: Maybe<Scalars['String']['output']>;
  salesPeople: Array<SalesPersonData>;
  storeNumber: Scalars['String']['output'];
  termsId?: Maybe<Scalars['String']['output']>;
};

export type OrderLocationDocumentDataFilterInput = {
  adGroup?: InputMaybe<StringOperationFilterInput>;
  address?: InputMaybe<CreateAddressFilterInput>;
  allowOrderBillingAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  allowOrderLocationAddressEdit?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<OrderLocationDocumentDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  globalLocationNumber?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderLocationDocumentDataFilterInput>>;
  poRequired?: InputMaybe<BooleanOperationFilterInput>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceGroupName?: InputMaybe<StringOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  /**
   * Ship-to route snapshot (tier 2 of the hierarchical route setting), captured at order
   * create/edit time. Empty for orders that never captured an explicit route — those resolve
   * their effective route from the live inherited tier and are re-stamped on upstream change.
   * Mirrors TermsId's snapshot role.
   */
  route?: InputMaybe<StringOperationFilterInput>;
  salesPeople?: InputMaybe<ListFilterInputTypeOfSalesPersonDataFilterInput>;
  storeNumber?: InputMaybe<StringOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
};

export type OrderLocationDocumentDataSortInput = {
  adGroup?: InputMaybe<SortEnumType>;
  address?: InputMaybe<CreateAddressSortInput>;
  allowOrderBillingAddressEdit?: InputMaybe<SortEnumType>;
  allowOrderLocationAddressEdit?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  globalLocationNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  poRequired?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceGroupName?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  /**
   * Ship-to route snapshot (tier 2 of the hierarchical route setting), captured at order
   * create/edit time. Empty for orders that never captured an explicit route — those resolve
   * their effective route from the live inherited tier and are re-stamped on upstream change.
   * Mirrors TermsId's snapshot role.
   */
  route?: InputMaybe<SortEnumType>;
  storeNumber?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
};

/** Staff marked this order No tax: a one-off exempt sale where the customer holds no certificate. While it is set, the order's sales tax estimate and its invoice are calculated as exempt. */
export type OrderNoTaxData = {
  __typename?: 'OrderNoTaxData';
  /** The staff note. Null when there is none. */
  note?: Maybe<Scalars['String']['output']>;
  /** Why the sale is exempt, from the same list as customer tax exemption certificates. */
  reason: CustomerTaxExemptionReason;
  /** When No tax was set or its reason or note last changed. */
  setAt: Scalars['DateTime']['output'];
  /** The email address of the user who set No tax or last changed its reason or note. */
  setBy: Scalars['String']['output'];
};

export type OrderNonDiscountableLineData = {
  __typename?: 'OrderNonDiscountableLineData';
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  lineSubtotal: Scalars['Decimal']['output'];
};

/**
 * One order line excluded from the customer/manual discount base because its item carries
 * Discountable = false. Document-only sub-record, used by this document and nothing else, so
 * a future field here can never break another type's backward compatibility.
 *
 * A receipt, NOT a discount: lineSubtotal is money the customer still owes in full.
 */
export type OrderNonDiscountableLineDocument = {
  __typename?: 'OrderNonDiscountableLineDocument';
  /** The item whose Discountable flag excluded the line. */
  itemId: Scalars['String']['output'];
  /** The order line this receipt belongs to. */
  lineItemId: Scalars['UUID']['output'];
  /** The line's position on the order, for display alongside the receipt. */
  lineNumber: Scalars['Int']['output'];
  /** The line's money as the order's subtotal counts it — the dollars withheld from the discount base. */
  lineSubtotal: Scalars['Decimal']['output'];
  /** The item the line named before an item combine moved it to itemId; null when no combine moved it. */
  originalItemId?: Maybe<Scalars['String']['output']>;
};

/**
 * One order line excluded from the customer/manual discount base because its item carries
 * Discountable = false. Document-only sub-record, used by this document and nothing else, so
 * a future field here can never break another type's backward compatibility.
 *
 * A receipt, NOT a discount: lineSubtotal is money the customer still owes in full.
 */
export type OrderNonDiscountableLineDocumentFilterInput = {
  and?: InputMaybe<Array<OrderNonDiscountableLineDocumentFilterInput>>;
  /** The item whose Discountable flag excluded the line. */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** The order line this receipt belongs to. */
  lineItemId?: InputMaybe<UuidOperationFilterInput>;
  /** The line's position on the order, for display alongside the receipt. */
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  /** The line's money as the order's subtotal counts it — the dollars withheld from the discount base. */
  lineSubtotal?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderNonDiscountableLineDocumentFilterInput>>;
  /** The item the line named before an item combine moved it to itemId; null when no combine moved it. */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
};

export type OrderPayload = {
  __typename?: 'OrderPayload';
  availabilityShortfalls?: Maybe<Array<PortalAvailabilityShortfallData>>;
  deliveryDateRejection?: Maybe<PortalDeliveryDateRejectionData>;
  errors?: Maybe<Array<ValidationError>>;
  order?: Maybe<OrderStateData>;
  proratedAcknowledgementRefusal?: Maybe<ProratedAcknowledgementRefusalData>;
  stageResult?: Maybe<OrderWriteStageResultData>;
  warnings?: Maybe<Array<OverAllocationWarningData>>;
};

/**
 * A single entry on the order's payment ledger as stored on the read model. Document-only
 * sub-record (boundary type suffix not applied because the parent OrdersDocument is
 * itself the read-model boundary type).
 */
export type OrderPaymentEntryDocument = {
  __typename?: 'OrderPaymentEntryDocument';
  /**
   * The entry's id in the accounting platform, once it has been created there: the payment id, or for a
   * deposit the accounting platform's journal entry id (Merge's remote id), or the Merge journal entry id when the
   * worker sent no remote id.
   */
  accountingPaymentId?: Maybe<Scalars['String']['output']>;
  amount: MoneyData;
  externalRemoteId?: Maybe<Scalars['String']['output']>;
  kind: OrderPaymentKind;
  occurredAt: Scalars['DateTime']['output'];
  paymentId?: Maybe<Scalars['String']['output']>;
  /**
   * Where this ledger entry stands with the tenant's accounting platform. NOT_APPLICABLE for entries
   * imported from the accounting platform, tenants with no accounting integration, and entries
   * that predate per-payment sync; RECORDED_LOCALLY_ONLY for every manual payment on an integrated tenant
   * (order-level payments are never exported) and for a deposit or payment when the platform cannot take
   * it. A DEPOSIT recorded after deposit export shipped on a platform that can post journal entries reports
   * PENDING, then COMPLETED, or FAILED_TRANSIENT / FAILED_PERMANENT with syncFailureReason; a deposit
   * recorded before that stays RECORDED_LOCALLY_ONLY.
   */
  paymentSyncStatus: PaymentSyncStatus;
  recordedBy?: Maybe<Scalars['String']['output']>;
  source: OrderPaymentSource;
  /**
   * Why the entry is not in the accounting system. For FAILED_TRANSIENT and FAILED_PERMANENT, the failure
   * the export reported. For RECORDED_LOCALLY_ONLY, a plain-language cause: "Order-level payments are
   * recorded in FULFILL only", or the invoice-not-exported or inbound-only explanation. Null for every
   * other status.
   */
  syncFailureReason?: Maybe<Scalars['String']['output']>;
};

/**
 * A single entry on the order's payment ledger as stored on the read model. Document-only
 * sub-record (boundary type suffix not applied because the parent OrdersDocument is
 * itself the read-model boundary type).
 */
export type OrderPaymentEntryDocumentFilterInput = {
  amount?: InputMaybe<MoneyDataFilterInput>;
  and?: InputMaybe<Array<OrderPaymentEntryDocumentFilterInput>>;
  externalRemoteId?: InputMaybe<OptionOfStringFilterInput>;
  kind?: InputMaybe<OrderPaymentKindOperationFilterInput>;
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OrderPaymentEntryDocumentFilterInput>>;
  paymentId?: InputMaybe<OptionOfStringFilterInput>;
  recordedBy?: InputMaybe<OptionOfStringFilterInput>;
  source?: InputMaybe<OrderPaymentSourceOperationFilterInput>;
};

export enum OrderPaymentKind {
  Deposit = 'DEPOSIT',
  Payment = 'PAYMENT'
}

export type OrderPaymentKindOperationFilterInput = {
  eq?: InputMaybe<OrderPaymentKind>;
  in?: InputMaybe<Array<OrderPaymentKind>>;
  neq?: InputMaybe<OrderPaymentKind>;
  nin?: InputMaybe<Array<OrderPaymentKind>>;
};

export enum OrderPaymentSource {
  Imported = 'IMPORTED',
  Manual = 'MANUAL'
}

export type OrderPaymentSourceOperationFilterInput = {
  eq?: InputMaybe<OrderPaymentSource>;
  in?: InputMaybe<Array<OrderPaymentSource>>;
  neq?: InputMaybe<OrderPaymentSource>;
  nin?: InputMaybe<Array<OrderPaymentSource>>;
};

/**
 * MongoDB read-model document for an order-production-lot allocation — a pure quantity
 * reservation linking an order line to a spec production lot. Projected from the
 * OrderProductionLotAllocation event stream by
 * OrderProductionLotAllocationProjectionService.
 */
export type OrderProductionLotAllocationDocument = {
  __typename?: 'OrderProductionLotAllocationDocument';
  /** Absolute allocated quantity against the spec lot. */
  allocatedQty: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** Lot total quantity — snapshot from the allocate event. Available = LotQty - sum(AllocatedQty across all allocations for this lot). */
  lotQty: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderLineId: Scalars['String']['output'];
  /** Ordered quantity on the order line — snapshot from the allocate event. Remaining = OrderedQty - AllocatedQty. */
  orderedQty: Scalars['Int']['output'];
  /**
   * Cumulative produced-and-pegged quantity for a make-to-order reservation whose lot has been produced
   * (0 until the first produce; ≤ AllocatedQty). The pegged units are realized as real
   * FULFILL inventory on the InventoryItem stream; the unproduced remainder is AllocatedQty - PeggedQty.
   * Set by the ProductionLotReservationProducedPegged projection arm.
   */
  peggedQty: Scalars['Int']['output'];
  productionLotId: Scalars['String']['output'];
  /** Finish-job WeekReadyDate snapshotted from the lot at allocation time. */
  readyWeek: Scalars['DateTime']['output'];
  status: OrderProductionLotAllocationStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB read-model document for an order-production-lot allocation — a pure quantity
 * reservation linking an order line to a spec production lot. Projected from the
 * OrderProductionLotAllocation event stream by
 * OrderProductionLotAllocationProjectionService.
 */
export type OrderProductionLotAllocationDocumentFilterInput = {
  /** Absolute allocated quantity against the spec lot. */
  allocatedQty?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<OrderProductionLotAllocationDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** Lot total quantity — snapshot from the allocate event. Available = LotQty - sum(AllocatedQty across all allocations for this lot). */
  lotQty?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OrderProductionLotAllocationDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderLineId?: InputMaybe<StringOperationFilterInput>;
  /** Ordered quantity on the order line — snapshot from the allocate event. Remaining = OrderedQty - AllocatedQty. */
  orderedQty?: InputMaybe<IntOperationFilterInput>;
  /**
   * Cumulative produced-and-pegged quantity for a make-to-order reservation whose lot has been produced
   * (0 until the first produce; ≤ AllocatedQty). The pegged units are realized as real
   * FULFILL inventory on the InventoryItem stream; the unproduced remainder is AllocatedQty - PeggedQty.
   * Set by the ProductionLotReservationProducedPegged projection arm.
   */
  peggedQty?: InputMaybe<IntOperationFilterInput>;
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  /** Finish-job WeekReadyDate snapshotted from the lot at allocation time. */
  readyWeek?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<OrderProductionLotAllocationStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for an order-production-lot allocation — a pure quantity
 * reservation linking an order line to a spec production lot. Projected from the
 * OrderProductionLotAllocation event stream by
 * OrderProductionLotAllocationProjectionService.
 */
export type OrderProductionLotAllocationDocumentSortInput = {
  /** Absolute allocated quantity against the spec lot. */
  allocatedQty?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Lot total quantity — snapshot from the allocate event. Available = LotQty - sum(AllocatedQty across all allocations for this lot). */
  lotQty?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  orderLineId?: InputMaybe<SortEnumType>;
  /** Ordered quantity on the order line — snapshot from the allocate event. Remaining = OrderedQty - AllocatedQty. */
  orderedQty?: InputMaybe<SortEnumType>;
  /**
   * Cumulative produced-and-pegged quantity for a make-to-order reservation whose lot has been produced
   * (0 until the first produce; ≤ AllocatedQty). The pegged units are realized as real
   * FULFILL inventory on the InventoryItem stream; the unproduced remainder is AllocatedQty - PeggedQty.
   * Set by the ProductionLotReservationProducedPegged projection arm.
   */
  peggedQty?: InputMaybe<SortEnumType>;
  productionLotId?: InputMaybe<SortEnumType>;
  /** Finish-job WeekReadyDate snapshotted from the lot at allocation time. */
  readyWeek?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** GraphQL mutation payload for order-production-lot-allocation operations. */
export type OrderProductionLotAllocationPayload = {
  __typename?: 'OrderProductionLotAllocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  orderProductionLotAllocation?: Maybe<OrderProductionLotAllocationDocument>;
};

export enum OrderProductionLotAllocationStatus {
  Active = 'ACTIVE',
  Adjusted = 'ADJUSTED',
  Cancelled = 'CANCELLED',
  ProducedPegged = 'PRODUCED_PEGGED',
  ReadyHandedOff = 'READY_HANDED_OFF',
  Reserved = 'RESERVED'
}

export type OrderProductionLotAllocationStatusOperationFilterInput = {
  eq?: InputMaybe<OrderProductionLotAllocationStatus>;
  in?: InputMaybe<Array<OrderProductionLotAllocationStatus>>;
  neq?: InputMaybe<OrderProductionLotAllocationStatus>;
  nin?: InputMaybe<Array<OrderProductionLotAllocationStatus>>;
};

/** A connection to a list of items. */
export type OrderProductionLotAllocationsConnection = {
  __typename?: 'OrderProductionLotAllocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrderProductionLotAllocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrderProductionLotAllocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrderProductionLotAllocationsEdge = {
  __typename?: 'OrderProductionLotAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrderProductionLotAllocationDocument;
};

export type OrderPullLineInput = {
  grade: Scalars['Int']['input'];
  lineItemId: Scalars['UUID']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

/** A staff follow-up on a draft order's quote: the day it is due, what it is about, who it is assigned to, and whether it has been done. */
export type OrderQuoteFollowUpData = {
  __typename?: 'OrderQuoteFollowUpData';
  /** The email address of the staff user the follow-up is assigned to, lower-cased. */
  assignee: Scalars['String']['output'];
  /** Whether the follow-up has been done. A done follow-up is no longer due. */
  done: Scalars['Boolean']['output'];
  /** What staff mean to raise when they follow up. Null when no note was left. */
  note?: Maybe<Scalars['String']['output']>;
  /** The day the follow-up is due, as a tenant-local date. */
  on: Scalars['LocalDate']['output'];
  /** When the follow-up's day, note, assignee or done flag last changed. Changing only the quote's valid-until date does not move it. */
  setAt: Scalars['DateTime']['output'];
  /** The email address of the user who last changed the follow-up's day, note, assignee or done flag. */
  setBy: Scalars['String']['output'];
};

/**
 * A staff follow-up on a draft order's quote: the day it is due, what it is about, who it is
 * assigned to, and whether it has been done.
 */
export type OrderQuoteFollowUpDocument = {
  __typename?: 'OrderQuoteFollowUpDocument';
  /** The email address of the staff user the follow-up is assigned to, lower-cased. */
  assignee: Scalars['String']['output'];
  /** Whether the follow-up has been done. A done follow-up is no longer due. */
  done: Scalars['Boolean']['output'];
  /** What staff mean to raise when they follow up. Null when no note was left. */
  note?: Maybe<Scalars['String']['output']>;
  /** The day the follow-up is due, as a tenant-local date. */
  on: Scalars['LocalDate']['output'];
  /** When the follow-up's day, note, assignee or done flag last changed. Changing only the quote's valid-until date does not move it. */
  setAt: Scalars['DateTime']['output'];
  /** The email address of the user who last changed the follow-up's day, note, assignee or done flag. */
  setBy: Scalars['String']['output'];
};

export enum OrderReceiptCarryOutcome {
  AccountingPaymentOnInvoice = 'ACCOUNTING_PAYMENT_ON_INVOICE',
  AdjustmentOnInvoice = 'ADJUSTMENT_ON_INVOICE',
  AlreadyOnInvoice = 'ALREADY_ON_INVOICE',
  Applied = 'APPLIED',
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  CustomerCreditOnInvoice = 'CUSTOMER_CREDIT_ON_INVOICE',
  DepositCreditUnreconciled = 'DEPOSIT_CREDIT_UNRECONCILED',
  ForeignPaymentOnInvoice = 'FOREIGN_PAYMENT_ON_INVOICE',
  InDepositCredit = 'IN_DEPOSIT_CREDIT',
  NegativeEntryOnLedger = 'NEGATIVE_ENTRY_ON_LEDGER',
  NotPositive = 'NOT_POSITIVE',
  ReferenceAmountConflict = 'REFERENCE_AMOUNT_CONFLICT',
  StaleCarriedPaymentOnInvoice = 'STALE_CARRIED_PAYMENT_ON_INVOICE',
  UnrecognisedKind = 'UNRECOGNISED_KIND'
}

/** Which of an order's dates set its ship week. */
export enum OrderShipWeekSource {
  /** The order's expected delivery date, used when it has neither a shipped nor a planned ship date. */
  Delivery = 'DELIVERY',
  /** The order's planned ship date, used when it has not shipped. */
  Planned = 'PLANNED',
  /** The order's shipped date. */
  Shipped = 'SHIPPED'
}

/**
 * One Shipping UOM's contribution: the shipping units its lines add up to, the container those units
 * ride, and the share of it they take.
 * containerFraction, containersNeeded and fit are all
 * absent together when the UOM rides no container here — the lines behind it are then reported in
 * uncountedLines.
 */
export type OrderShippingUomRollup = {
  __typename?: 'OrderShippingUomRollup';
  containerFraction?: Maybe<Scalars['Decimal']['output']>;
  containersNeeded?: Maybe<Scalars['Int']['output']>;
  fit?: Maybe<OrderContainerFit>;
  label: Scalars['String']['output'];
  lineCount: Scalars['Int']['output'];
  shippingUomCode: Scalars['String']['output'];
  totalQuantity: Scalars['Decimal']['output'];
};

export enum OrderSource {
  CustomerPortal = 'CUSTOMER_PORTAL',
  Fulfill = 'FULFILL',
  Import = 'IMPORT',
  Integration = 'INTEGRATION',
  RetailApp = 'RETAIL_APP',
  Unknown = 'UNKNOWN'
}

export type OrderSourceOperationFilterInput = {
  eq?: InputMaybe<OrderSource>;
  in?: InputMaybe<Array<OrderSource>>;
  neq?: InputMaybe<OrderSource>;
  nin?: InputMaybe<Array<OrderSource>>;
};

export type OrderStateData = {
  __typename?: 'OrderStateData';
  acknowledgmentEmails: Array<ConfirmationEmailData>;
  adjustedAt: Scalars['DateTime']['output'];
  adjustedBy: Scalars['String']['output'];
  /** Allocation transfer contributions involving this order, newest first. */
  allocationTakes: Array<OrderAllocationTake>;
  allocations: Array<AllocationItemData>;
  carrier: Scalars['String']['output'];
  categoryVolumeDiscounts: Array<OrderCategoryVolumeDiscountData>;
  categoryVolumeProgress: Array<OrderCategoryVolumeProgressData>;
  confirmationEmails: Array<ConfirmationEmailData>;
  containerCode: Scalars['String']['output'];
  correction?: Maybe<OrderCorrectionData>;
  creditedFromOrderId?: Maybe<Scalars['String']['output']>;
  creditedFromOrderNumber?: Maybe<Scalars['String']['output']>;
  customer: OrderCustomerData;
  /** The customer's own live pull slip report choice. Null when no customer choice is set or the chosen report no longer renders. */
  customerPullSlipReportId?: Maybe<Scalars['String']['output']>;
  customerTotal: Scalars['Decimal']['output'];
  /**
   * The order's customer-type revenue GL account resolved to its Merge.dev account RemoteId,
   * for the outbound order export's customer-type routing tier. Null when the customer has no
   * type assigned, the type is inactive, deleted, or has no RevenueGlAccountId, the mapped
   * account is archived, or no MergeDevAccount matches — the downstream wsapi-services handler
   * owns the unmapped fallback (item income account -> tenant default -> omit). Every one of
   * those null cases agrees with the revenue-account ladder's revenueAccountSummary
   * instead of handing the worker a RemoteId that fails at QuickBooks. Output-only field; every
   * hop is tenant-scoped, so a batch cannot leak one tenant's account into another.
   */
  customerTypeIncomeGlAccountRemoteId?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Decimal']['output'];
  discountBreakdown: Array<OrderDiscountComponentData>;
  discountPercent: Scalars['Decimal']['output'];
  discountReason: Scalars['String']['output'];
  dropShipDestination?: Maybe<OrderDropShipDestinationData>;
  /** Report id this order's acknowledgement renders with: the customer's document override, else the tenant binding, else the seeded default. */
  effectiveAcknowledgementReportId: Scalars['String']['output'];
  /** Report id this order's invoice renders with: the customer's document override, else the tenant binding, else the seeded default. */
  effectiveInvoiceReportId: Scalars['String']['output'];
  /** Report id this order's pull slip renders with: the customer's document override, else the tenant binding, else the seeded default. */
  effectivePullSlipReportId: Scalars['String']['output'];
  /** Resolved boolean controlling whether the order-confirmation email should be sent. Cascade is order ?? location ?? customer (most-specific-wins). True means send; false means skip. */
  effectiveSendOrderEmails: Scalars['Boolean']['output'];
  erpId: Scalars['String']['output'];
  /** What this order's sales tax is currently estimated at, and how far that figure can be trusted. */
  estimatedTax?: Maybe<OrderTaxEstimatePayload>;
  /**
   * The customer's current tax exemption certificate that already makes this order exempt: a
   * certificate for the state the order ships to, or else an All states certificate. Null when none
   * does, when the order ships to Canada (where the customer's Tax Exempt Number decides instead), and
   * always null for a customer-portal caller.
   */
  exemptingCertificate?: Maybe<CustomerTaxExemption>;
  expectedDeliveryDate: Scalars['DateTime']['output'];
  finalCredit?: Maybe<Scalars['Boolean']['output']>;
  flatCharges: Array<OrderFlatChargeData>;
  flatChargesTotal: Scalars['Decimal']['output'];
  /** The staff follow-up on this order's quote. Null when there is none. Staff only; refused for customer-portal callers. Kept on the order once it is submitted. Any move of the order out of draft (a submit, an acknowledge even of a line-less order, a ship, or a load dispatch even if it is later undone) stops a follow-up set before it, for good: after the order is reopened it still reads here as open, but quoteFollowUpsDue no longer lists it until its day, note, assignee or done flag is changed. A follow-up set or changed after a reopen reminds until the order next leaves draft. Saving it unchanged does not re-arm it. */
  followUp?: Maybe<OrderQuoteFollowUpData>;
  freightAdjustedAt: Scalars['DateTime']['output'];
  freightAdjustedBy: Scalars['String']['output'];
  freightChargeAmount: Scalars['Decimal']['output'];
  freightChargeReason: Scalars['String']['output'];
  freightChargeType?: Maybe<FreightChargeType>;
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  freightProvenance?: Maybe<LoadFreightProvenanceData>;
  freightSource: FreightSource;
  /** The hold on this order. Null when the order is not held, and always null for a customer-portal caller. Placed by placeOrderHold and removed by releaseOrderHold. While it stands the order cannot be picked, shipped, verified, closed or dispatched on a load; allocation, acknowledgment, edits, cancel and delete are unaffected. */
  hold?: Maybe<OrderHold>;
  initializationDate: Scalars['DateTime']['output'];
  /**
   * Whether this order has been billed. INVOICED means a live invoice stands against it — what the
   * customer owes on this order is then that bill's business, and the order's own balance and
   * payment standing are reported from it. VOIDED means the order was billed and every bill against
   * it has since been withdrawn, which is a different fact from never having been billed at all.
   * NOT_INVOICED means no invoice has ever been raised. CREDIT_MEMO means a Credit-type order, which is
   * never invoiced and issues a credit memo instead. Derived when asked, never stored, so it cannot go
   * stale; not filterable or sortable for the same reason.
   */
  invoiceStatus: OrderInvoiceStatus;
  /**
   * Every invoice raised against this order, newest first. An order has one invoice today — the
   * invoicing aggregate refuses a second — so this is empty or a single entry; it is published as a
   * list so a re-bill would extend the surface rather than break it. Carries enough to link to the
   * bill and show where it stands; the billed lines, the tax breakdown and the payments stay behind
   * invoice(invoiceId).
   */
  invoices: Array<OrderInvoiceLink>;
  lineItems: Array<LineItemData>;
  /** Staff marked this order No tax: why, an optional note, and who set it and when. Null when it is not set, and always null for a customer-portal caller. Set and cleared by setOrderNoTax and clearOrderNoTax until the order has a live invoice. While it is set, the order's sales tax estimate and its invoice are calculated as exempt. */
  noTax?: Maybe<OrderNoTaxData>;
  nonDiscountableLines: Array<OrderNonDiscountableLineData>;
  nonDiscountableSubtotal: Scalars['Decimal']['output'];
  orderEntryUnit: OrderEntryUnit;
  orderId: Scalars['String']['output'];
  orderKindId?: Maybe<Scalars['String']['output']>;
  /** The current name of the order's Order kind, so a rename shows at once. Null when the order has no kind or the kind has been deleted. */
  orderKindName?: Maybe<Scalars['String']['output']>;
  orderNumber: Scalars['String']['output'];
  orderVolumeDiscount?: Maybe<OrderVolumeDiscountData>;
  overrideTotal?: Maybe<Scalars['Decimal']['output']>;
  plannedShipDate?: Maybe<Scalars['DateTime']['output']>;
  poNumber: Scalars['String']['output'];
  /** How sales prices are entered and shown for this order: per each or per shipping unit. Prices are always stored and billed per each. Stamped from the customer's effective setting when the order is created and never changed afterwards. Orders created before this existed read as EACH. */
  priceEntryUnit: PriceEntryUnit;
  produceAllocate?: Maybe<Scalars['Boolean']['output']>;
  program?: Maybe<Scalars['String']['output']>;
  /** Where each line was pulled from: every pull recorded by recordOrderPulls, oldest first, with who pulled and when. Staff only: refused to a customer-portal caller. */
  pulls: Array<OrderLinePull>;
  /** The last day the quote on this order is valid, as a tenant-local date. Null when none is set. Kept on the order once it is submitted. */
  quoteValidUntil?: Maybe<Scalars['LocalDate']['output']>;
  revision?: Maybe<Scalars['Long']['output']>;
  route: Scalars['String']['output'];
  salesPerson: Scalars['String']['output'];
  sendInvoiceEmails?: Maybe<Scalars['Boolean']['output']>;
  sendOrderEmails?: Maybe<Scalars['Boolean']['output']>;
  shipFromLocation: ShipFromLocationData;
  shipFromSiteLocationId: Scalars['String']['output'];
  shippedDate?: Maybe<Scalars['DateTime']['output']>;
  signatureImage?: Maybe<SignatureImageData>;
  status: OrderStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  subtotal: Scalars['Decimal']['output'];
  syncAttempts: Array<SyncAttemptData>;
  tagColorId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  termsDiscountMessage?: Maybe<Scalars['String']['output']>;
  termsId: Scalars['String']['output'];
  termsName: Scalars['String']['output'];
  /** The order's tax-free grand total, royalty included. For a customer-portal caller, from whom the royalty is withheld, it is the billed total, the same figure as customerTotal. */
  total: Scalars['Decimal']['output'];
  type: OrderType;
  /** The order's verification in Verify: where it stands, each line's counted and final quantities, the manager's adjustments, and every container counted for it. Always null for a customer-portal caller. */
  verification?: Maybe<OrderVerificationDetail>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedBy: Scalars['String']['output'];
  volumePoolProgress: Array<OrderVolumePoolProgressData>;
};

export enum OrderStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Delivered = 'DELIVERED',
  FailedDelivery = 'FAILED_DELIVERY',
  Initialized = 'INITIALIZED',
  InTransit = 'IN_TRANSIT',
  Open = 'OPEN',
  Picked = 'PICKED',
  Shipped = 'SHIPPED',
  Submitted = 'SUBMITTED',
  Synchronized = 'SYNCHRONIZED',
  SyncError = 'SYNC_ERROR'
}

export type OrderStatusOperationFilterInput = {
  eq?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  neq?: InputMaybe<OrderStatus>;
  nin?: InputMaybe<Array<OrderStatus>>;
};

export type OrderSubmitterData = {
  __typename?: 'OrderSubmitterData';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type OrderSubmitterDataInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One jurisdiction's share of an order's estimated sales tax, as Stripe Tax calculated it. A zero row
 * means the seller holds no tax registration in that jurisdiction, which is information rather than a
 * failure.
 */
export type OrderTaxEstimateJurisdictionDocument = {
  __typename?: 'OrderTaxEstimateJurisdictionDocument';
  /** The estimated tax for this jurisdiction. */
  amount: Scalars['Decimal']['output'];
  /** The jurisdiction's human-readable name, e.g. "California". */
  jurisdiction: Scalars['String']['output'];
  /** The jurisdiction level, e.g. country, state or city. */
  level: Scalars['String']['output'];
  /** The rate applied, as a decimal percentage — 7.25 means 7.25%. */
  rate: Scalars['Decimal']['output'];
  /** Stripe's taxability reason code for the row. */
  reason: Scalars['String']['output'];
  /** The two-letter state code when the jurisdiction is state-scoped. */
  state?: Maybe<Scalars['String']['output']>;
  /** The amount this jurisdiction treated as taxable. */
  taxableAmount: Scalars['Decimal']['output'];
};

/**
 * One jurisdiction's share of an order's estimated sales tax, as Stripe Tax calculated it. A zero row
 * means the seller holds no tax registration in that jurisdiction, which is information rather than a
 * failure.
 */
export type OrderTaxEstimateJurisdictionDocumentFilterInput = {
  /** The estimated tax for this jurisdiction. */
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<OrderTaxEstimateJurisdictionDocumentFilterInput>>;
  /** The jurisdiction's human-readable name, e.g. "California". */
  jurisdiction?: InputMaybe<StringOperationFilterInput>;
  /** The jurisdiction level, e.g. country, state or city. */
  level?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderTaxEstimateJurisdictionDocumentFilterInput>>;
  /** The rate applied, as a decimal percentage — 7.25 means 7.25%. */
  rate?: InputMaybe<DecimalOperationFilterInput>;
  /** Stripe's taxability reason code for the row. */
  reason?: InputMaybe<StringOperationFilterInput>;
  /** The two-letter state code when the jurisdiction is state-scoped. */
  state?: InputMaybe<StringOperationFilterInput>;
  /** The amount this jurisdiction treated as taxable. */
  taxableAmount?: InputMaybe<DecimalOperationFilterInput>;
};

/** One jurisdiction's share of an order's estimated sales tax. */
export type OrderTaxEstimateJurisdictionPayload = {
  __typename?: 'OrderTaxEstimateJurisdictionPayload';
  /** The estimated tax for this jurisdiction. */
  amount: Scalars['Decimal']['output'];
  /** The jurisdiction's name, for example California. */
  jurisdiction: Scalars['String']['output'];
  /** How wide the jurisdiction is — country, state, county or city. */
  level: Scalars['String']['output'];
  /** The rate applied, as a percentage — 7.25 means 7.25%. */
  rate: Scalars['Decimal']['output'];
  /**
   * Why the jurisdiction taxed the order the way it did. A zero row reading notCollecting means the seller
   * holds no tax registration there, which is information rather than a failure.
   */
  reason: Scalars['String']['output'];
  /** The two-letter state code, when the jurisdiction sits inside a state. */
  state?: Maybe<Scalars['String']['output']>;
  /** How much of the order this jurisdiction treated as taxable. */
  taxableAmount: Scalars['Decimal']['output'];
};

/** An order's estimated sales tax, and how far it can be trusted. */
export type OrderTaxEstimatePayload = {
  __typename?: 'OrderTaxEstimatePayload';
  /** The estimated tax. Meaningful only when status says an estimate exists. */
  amount: Scalars['Decimal']['output'];
  /** The estimate split by jurisdiction. Empty when no estimate exists. */
  breakdown: Array<OrderTaxEstimateJurisdictionPayload>;
  /** When the estimate was taken, or null when it never has been. */
  estimatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the figure exists, is current, is out of date, or cannot be calculated. */
  status: OrderTaxEstimateStatus;
};

/** Where an order's estimated sales tax stands, from the reader's point of view. */
export enum OrderTaxEstimateStatus {
  /** An estimate exists and the order has not changed since it was taken. */
  Estimated = 'ESTIMATED',
  /** No estimate has ever been taken for this order. Show no tax figure at all — not a zero. */
  NotEstimated = 'NOT_ESTIMATED',
  /**
   * An estimate exists, but the order has changed since it was taken, so the figure no longer
   * describes this order. Show it as out of date rather than as current.
   */
  Stale = 'STALE',
  /**
   * The seller's Stripe Tax setup is not active, so no tax can be calculated at all. An explicit
   * state rather than a silent zero: a zero that Stripe calculated means the seller holds no
   * registration where the goods are going, which is a different fact entirely.
   */
  TenantNotTaxReady = 'TENANT_NOT_TAX_READY'
}

/** An email that went out because no contact could get the kind by text. */
export type OrderTextFallbackEmailData = {
  __typename?: 'OrderTextFallbackEmailData';
  kind: CustomerDeliveryKind;
  /** Matches EmailSendDocument.sendGridMessageId in emailSends. */
  sendGridMessageId?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['DateTime']['output'];
};

export type OrderTextHistoryData = {
  __typename?: 'OrderTextHistoryData';
  emailsInsteadOfTexts: Array<OrderTextFallbackEmailData>;
  /** Newest first. Texts for the order and its invoices. CONSENT_REQUEST rows are never listed. */
  texts: Array<OrderTextHistoryEntryData>;
};

export type OrderTextHistoryEntryData = {
  __typename?: 'OrderTextHistoryEntryData';
  body: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  kind: CustomerDeliveryKind;
  phoneLastFour: Scalars['String']['output'];
  /** Set only when NOT_DELIVERED. */
  reason?: Maybe<TextNotDeliveredReason>;
  /** When it was sent, or when it failed if it never went out. */
  sentAt: Scalars['DateTime']['output'];
  status: OrderTextStatus;
};

/** Stored as the int: UNKNOWN = 0, SENT = 1, DELIVERED = 2, NOT_DELIVERED = 3. */
export enum OrderTextStatus {
  Delivered = 'DELIVERED',
  NotDelivered = 'NOT_DELIVERED',
  Sent = 'SENT',
  Unknown = 'UNKNOWN'
}

export enum OrderType {
  Credit = 'CREDIT',
  MasterOrder = 'MASTER_ORDER',
  Po = 'PO',
  Retail = 'RETAIL',
  Unknown = 'UNKNOWN'
}

export type OrderTypeOperationFilterInput = {
  eq?: InputMaybe<OrderType>;
  in?: InputMaybe<Array<OrderType>>;
  neq?: InputMaybe<OrderType>;
  nin?: InputMaybe<Array<OrderType>>;
};

/** A line the rollup could not count, and why. Quantity is the line's ask in shipping units. */
export type OrderUncountedLine = {
  __typename?: 'OrderUncountedLine';
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  reason: OrderUncountedLineReason;
  shippingUomCode?: Maybe<Scalars['String']['output']>;
};

/**
 * Why a line contributed nothing to an order's container count. Ordinals are NOT persisted — this
 * enum exists only on the derived, never-stored OrderContainerRequirement read shape
 * (recomputed on every orderContainerRequirement query) — so it carries no
 * Enum-Ordinal-Stability obligation.
 */
export enum OrderUncountedLineReason {
  /**
   * The line has a Shipping UOM, but that UOM rides none of the containers in play — either no
   * ContainerConfig pairs it with a container at all, or the only container being considered (the
   * one the line is saved on, else the one named on the order) is one this UOM cannot ride. The
   * client's unfittedLines.
   */
  NoContainerCapacity = 'NO_CONTAINER_CAPACITY',
  /**
   * The line's item names no Shipping UOM, so there is nothing to look a capacity up by. The
   * client's unresolvedLines.
   */
  NoShippingUom = 'NO_SHIPPING_UOM'
}

/** A container type the order needs (needed above zero) that adds no weight, and why. */
export type OrderUnweighedContainer = {
  __typename?: 'OrderUnweighedContainer';
  containerCode: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  needed: Scalars['Int']['output'];
  reason: OrderUnweighedContainerReason;
};

/** Why a needed container type adds no weight to the order. */
export enum OrderUnweighedContainerReason {
  /** The container type has no weight. The fix is to weigh the container. */
  ContainerHasNoWeight = 'CONTAINER_HAS_NO_WEIGHT'
}

/** A positive-quantity line that adds no weight to the order, and why. Quantity is the line's ask. */
export type OrderUnweighedLine = {
  __typename?: 'OrderUnweighedLine';
  itemId: Scalars['String']['output'];
  lineItemId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  reason: OrderUnweighedLineReason;
};

/** Why a line adds no weight to the order. */
export enum OrderUnweighedLineReason {
  /** The line's eaches were never captured, so there is nothing to multiply the item weight by. */
  EachesNotCaptured = 'EACHES_NOT_CAPTURED',
  /** The line's item has no weight. The fix is to weigh the item. */
  ItemHasNoWeight = 'ITEM_HAS_NO_WEIGHT'
}

/** A line whose final quantity the manager changed from the counted one during verification. */
export type OrderVerificationAdjustment = {
  __typename?: 'OrderVerificationAdjustment';
  /** The line's item. */
  itemId: Scalars['String']['output'];
  /** The final quantity the manager set, in eaches. */
  newQuantity: Scalars['Int']['output'];
  /** The order line's number. */
  orderLineNumber: Scalars['Int']['output'];
  /** The scanned quantity the manager changed, in eaches. */
  originalQuantity: Scalars['Int']['output'];
};

/**
 * The supervisor dashboard's reconciliation view for one order: the containers' raw scans summed by
 * resolved item and compared, line by line, against the order's CURRENT lines. This shape is
 * derived and never stored — orderVerificationComparison recomputes it on every read, so
 * it can never be stale if the order changes between a worker's container submit and the supervisor's
 * review. The only persisted record of a verification remains the V1.OrderVerified event the
 * supervisor's submitOrderVerification emits.
 *
 * lines carries the per-order-line classification. unknownItems carries the
 * two kinds of rows that have no matching order line: scans whose barcode never resolved to an item
 * (blind-count unknowns) and resolved items that are not on the order. containers is the
 * contributing-container roster for drill-in. The line/unknown rows are shaped so the PWA can map them
 * straight into submitOrderVerification input (the direct-mode defaults are these rows
 * unmodified): itemId + orderLineNumber + scannedQuantity mirror
 * SubmitVerifyLineData.
 */
export type OrderVerificationComparison = {
  __typename?: 'OrderVerificationComparison';
  /** The active containers that contributed scans to this comparison, for drill-in. */
  containers: Array<VerifyComparisonContainer>;
  /** Per-order-line comparison rows (one per current order line), ordered by line number. */
  lines: Array<OrderVerificationComparisonLine>;
  /** The order this comparison was computed for. */
  orderId: Scalars['String']['output'];
  /**
   * Rows with no matching order line: unresolved-barcode scans (itemId
   * is None) and resolved items that are not on the order (ItemId present). Ordered by item id then barcode.
   */
  unknownItems: Array<VerifyComparisonUnknownItem>;
};

/**
 * One current order line compared against the summed scans for its item across every active container,
 * in eaches and in the unit the item is counted in.
 */
export type OrderVerificationComparisonLine = {
  __typename?: 'OrderVerificationComparisonLine';
  /** The order line's item. */
  itemId: Scalars['String']['output'];
  /** The order line's number. */
  orderLineNumber: Scalars['Int']['output'];
  /** The order line's ordered quantity, in eaches. */
  orderedQuantity: Scalars['Int']['output'];
  /**
   * orderedQuantity in shippingUnit: eaches divided by its eaches per unit, exact and never
   * rounded. Equal to orderedQuantity when shippingUnit is null.
   */
  orderedUnits: Scalars['Decimal']['output'];
  /**
   * The summed scan quantity for the line's item across every contributing container, in eaches: the scans
   * attributed to this order plus the scans attributed to no order, 0 when nothing was scanned for it.
   */
  scannedQuantity: Scalars['Int']['output'];
  /**
   * scannedQuantity in shippingUnit: eaches divided by its eaches per unit, exact and never
   * rounded. Equal to scannedQuantity when shippingUnit is null.
   */
  scannedUnits: Scalars['Decimal']['output'];
  /**
   * The unit the item is counted in: its effective default Shipping UOM (its own pick, else its first
   * category tag) as configured now, not the unit the order line was entered in. Null when the item has no
   * default Shipping UOM, or its default states no eaches count of at least one; such an item is counted in
   * eaches.
   */
  shippingUnit?: Maybe<ItemShippingUomData>;
  /**
   * How scannedQuantity compares with orderedQuantity. It is computed from the scans alone; a
   * client that lets a reviewer edit the final quantity compares that final quantity with the ordered one
   * itself.
   */
  variance: VerifyLineVariance;
};

/** A container counted for the order. */
export type OrderVerificationContainer = {
  __typename?: 'OrderVerificationContainer';
  /** The container's id. */
  containerId: Scalars['String']['output'];
  /** The drop read from the container's label. Empty when the container has no drop. */
  drop: Scalars['String']['output'];
  /**
   * When the container was last submitted, once its status is SUBMITTED or VERIFIED. Null before then, and once
   * it is removed.
   */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Who finished the container: the submitter its last submit carried, once its status is SUBMITTED or
   * VERIFIED. Null before then, and once it is removed.
   */
  finishedBy?: Maybe<Scalars['String']['output']>;
  /** When the container was removed, while its status is INACTIVE; null otherwise. */
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who removed the container, while its status is INACTIVE; null otherwise. */
  removedBy?: Maybe<Scalars['String']['output']>;
  /**
   * The reason the manager gave for removing the container, while its status is INACTIVE. Null otherwise, and
   * when no reason was given.
   */
  removedReason?: Maybe<Scalars['String']['output']>;
  /**
   * The summed quantity of every scan on the container, in eaches, including scans attributed to another order
   * that shares it.
   */
  scannedQuantity: Scalars['Int']['output'];
  /** The container's lifecycle status. */
  status: VerifyContainerStatus;
  /** When a verification consumed the container, once its status is VERIFIED; null before then. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * The order's verification in Verify: where it stands, each line's counted and final quantities, the
 * manager's adjustments, and every container counted for it. Quantities are in eaches.
 */
export type OrderVerificationDetail = {
  __typename?: 'OrderVerificationDetail';
  /**
   * The lines whose final quantity the manager changed from the counted one, as the verification on record
   * carries them. Empty until the order is verified, and when nothing was changed.
   */
  adjustments: Array<OrderVerificationAdjustment>;
  /**
   * Every container counted for the order, whatever its status, including removed ones. Ordered by first scan,
   * the order they were counted in; containers with no scans come last.
   */
  containers: Array<OrderVerificationContainer>;
  /**
   * One row per line, ordered by line number. A verified order lists the lines its verification shipped; any
   * other order lists its current lines. Empty when the state is NONE.
   */
  lines: Array<OrderVerificationLine>;
  /**
   * The reason the manager gave with the latest removal, while the state is RECOUNT_REQUESTED. Null in every
   * other state, and when no reason was given.
   */
  recountReason?: Maybe<Scalars['String']['output']>;
  /** Where the order stands in Verify. */
  state: OrderVerificationState;
  /** When the verification on record was committed. Null until the order is verified. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who submitted the verification on record. Null until the order is verified. */
  verifiedBy?: Maybe<Scalars['String']['output']>;
};

/** One order line's counted quantity against the quantity it shipped, in eaches. */
export type OrderVerificationLine = {
  __typename?: 'OrderVerificationLine';
  /**
   * What Verify counted for the line, in eaches. On a verified order, the scanned quantity the manager adjusted
   * from, else the final quantity. On any other order, the summed scans for the line's item across the order's
   * active containers: the scans attributed to this order plus the scans attributed to no order.
   */
  countedQuantity: Scalars['Int']['output'];
  /** The quantity the verification shipped for the line, in eaches. Null until the order is verified. */
  finalQuantity?: Maybe<Scalars['Int']['output']>;
  /** The line's item. */
  itemId: Scalars['String']['output'];
  /** The order line's number. */
  orderLineNumber: Scalars['Int']['output'];
};

/**
 * Where an order stands in Verify. The first that applies wins: VERIFIED, then PENDING_REVIEW, then
 * COUNTING, then RECOUNT_REQUESTED, then NONE.
 */
export enum OrderVerificationState {
  /** A container for the order is open or being scanned, and none is submitted. */
  Counting = 'COUNTING',
  /** No verification is on record and nothing is being counted for the order. */
  None = 'NONE',
  /** A counter submitted a container for the order, and it is waiting for the manager's review. */
  PendingReview = 'PENDING_REVIEW',
  /** The manager removed a container after the last container submit, so the order is to be counted again. */
  RecountRequested = 'RECOUNT_REQUESTED',
  /** A verification is on record: the order shipped the verified quantities. */
  Verified = 'VERIFIED'
}

export type OrderVolumeDiscountData = {
  __typename?: 'OrderVolumeDiscountData';
  amount: Scalars['Decimal']['output'];
  configuredValue: Scalars['Decimal']['output'];
  lines: Array<OrderVolumeLineData>;
  qualifyingSubtotal: Scalars['Decimal']['output'];
  qualifyingUnits: Scalars['Decimal']['output'];
  threshold: Scalars['Decimal']['output'];
  thresholdType: OrderVolumeThresholdType;
  uncappedAmount: Scalars['Decimal']['output'];
  valueType: OrderVolumeDiscountValueType;
};

/**
 * The order's ORDER-WIDE volume discount as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record, used by this document and nothing else, so a future field here can never
 * break another type's backward compatibility.
 *
 * Mirrors the domain's OrderVolumeDiscount. Dollar figures are plain decimal rather
 * than MoneyData because every amount on an order shares the order's single currency, already
 * carried on the document's money fields — the same choice
 * OrderCategoryVolumeDiscountDocument makes.
 */
export type OrderVolumeDiscountDocument = {
  __typename?: 'OrderVolumeDiscountDocument';
  /** The discount actually applied, in dollars — the sum of Lines. */
  amount: Scalars['Decimal']['output'];
  /**
   * The rule as configured: a percent VALUE (10 = 10%) or a flat dollar amount, per
   * ValueType. Never a 0–1 fraction.
   */
  configuredValue: Scalars['Decimal']['output'];
  /** Per-line allocated shares, for the explainer and for the tax base's exact apportionment. */
  lines: Array<OrderVolumeLineDocument>;
  /**
   * The GROSS subtotal — before either volume component and before the manual discount — on the basis
   * this rule was qualified against.
   */
  qualifyingSubtotal: Scalars['Decimal']['output'];
  /**
   * The order's total units on the basis this rule was qualified against, and the explainer's
   * "512 / 500 ✓" numerator.
   */
  qualifyingUnits: Scalars['Decimal']['output'];
  /** The rule's configured threshold — units or dollars per ThresholdType. */
  threshold: Scalars['Decimal']['output'];
  /** Whether the rule qualifies on total units or on gross order subtotal. */
  thresholdType: OrderVolumeThresholdType;
  /**
   * What the rule asked for before being bounded by the discountable base and by the tenant's
   * maximum discount percentage. Differs from Amount only when a bound engaged.
   */
  uncappedAmount: Scalars['Decimal']['output'];
  /** Whether ConfiguredValue is a percent value or a flat dollar amount. */
  valueType: OrderVolumeDiscountValueType;
};

/**
 * The order's ORDER-WIDE volume discount as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record, used by this document and nothing else, so a future field here can never
 * break another type's backward compatibility.
 *
 * Mirrors the domain's OrderVolumeDiscount. Dollar figures are plain decimal rather
 * than MoneyData because every amount on an order shares the order's single currency, already
 * carried on the document's money fields — the same choice
 * OrderCategoryVolumeDiscountDocument makes.
 */
export type OrderVolumeDiscountDocumentFilterInput = {
  /** The discount actually applied, in dollars — the sum of Lines. */
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<OrderVolumeDiscountDocumentFilterInput>>;
  /**
   * The rule as configured: a percent VALUE (10 = 10%) or a flat dollar amount, per
   * ValueType. Never a 0–1 fraction.
   */
  configuredValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Per-line allocated shares, for the explainer and for the tax base's exact apportionment. */
  lines?: InputMaybe<ListFilterInputTypeOfOrderVolumeLineDocumentFilterInput>;
  or?: InputMaybe<Array<OrderVolumeDiscountDocumentFilterInput>>;
  /**
   * The GROSS subtotal — before either volume component and before the manual discount — on the basis
   * this rule was qualified against.
   */
  qualifyingSubtotal?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The order's total units on the basis this rule was qualified against, and the explainer's
   * "512 / 500 ✓" numerator.
   */
  qualifyingUnits?: InputMaybe<DecimalOperationFilterInput>;
  /** The rule's configured threshold — units or dollars per ThresholdType. */
  threshold?: InputMaybe<DecimalOperationFilterInput>;
  /** Whether the rule qualifies on total units or on gross order subtotal. */
  thresholdType?: InputMaybe<OrderVolumeThresholdTypeOperationFilterInput>;
  /**
   * What the rule asked for before being bounded by the discountable base and by the tenant's
   * maximum discount percentage. Differs from Amount only when a bound engaged.
   */
  uncappedAmount?: InputMaybe<DecimalOperationFilterInput>;
  /** Whether ConfiguredValue is a percent value or a flat dollar amount. */
  valueType?: InputMaybe<OrderVolumeDiscountValueTypeOperationFilterInput>;
};

/**
 * The order's ORDER-WIDE volume discount as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record, used by this document and nothing else, so a future field here can never
 * break another type's backward compatibility.
 *
 * Mirrors the domain's OrderVolumeDiscount. Dollar figures are plain decimal rather
 * than MoneyData because every amount on an order shares the order's single currency, already
 * carried on the document's money fields — the same choice
 * OrderCategoryVolumeDiscountDocument makes.
 */
export type OrderVolumeDiscountDocumentSortInput = {
  /** The discount actually applied, in dollars — the sum of Lines. */
  amount?: InputMaybe<SortEnumType>;
  /**
   * The rule as configured: a percent VALUE (10 = 10%) or a flat dollar amount, per
   * ValueType. Never a 0–1 fraction.
   */
  configuredValue?: InputMaybe<SortEnumType>;
  /**
   * The GROSS subtotal — before either volume component and before the manual discount — on the basis
   * this rule was qualified against.
   */
  qualifyingSubtotal?: InputMaybe<SortEnumType>;
  /**
   * The order's total units on the basis this rule was qualified against, and the explainer's
   * "512 / 500 ✓" numerator.
   */
  qualifyingUnits?: InputMaybe<SortEnumType>;
  /** The rule's configured threshold — units or dollars per ThresholdType. */
  threshold?: InputMaybe<SortEnumType>;
  /** Whether the rule qualifies on total units or on gross order subtotal. */
  thresholdType?: InputMaybe<SortEnumType>;
  /**
   * What the rule asked for before being bounded by the discountable base and by the tenant's
   * maximum discount percentage. Differs from Amount only when a bound engaged.
   */
  uncappedAmount?: InputMaybe<SortEnumType>;
  /** Whether ConfiguredValue is a percent value or a flat dollar amount. */
  valueType?: InputMaybe<SortEnumType>;
};

export enum OrderVolumeDiscountValueType {
  FlatAmount = 'FLAT_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type OrderVolumeDiscountValueTypeOperationFilterInput = {
  eq?: InputMaybe<OrderVolumeDiscountValueType>;
  in?: InputMaybe<Array<OrderVolumeDiscountValueType>>;
  neq?: InputMaybe<OrderVolumeDiscountValueType>;
  nin?: InputMaybe<Array<OrderVolumeDiscountValueType>>;
};

export type OrderVolumeLineData = {
  __typename?: 'OrderVolumeLineData';
  amount: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
  lineBase: Scalars['Decimal']['output'];
  lineItemId: Scalars['UUID']['output'];
  lineNumber: Scalars['Int']['output'];
  quantity: Scalars['Decimal']['output'];
};

/**
 * One order line's allocated share of the order-wide volume discount. Allocated from an order-level
 * figure (not derived per line), with the rounding residual distributed so Σ Amount equals
 * the component's Amount exactly.
 */
export type OrderVolumeLineDocument = {
  __typename?: 'OrderVolumeLineDocument';
  /** This line's allocated share of the component, in dollars. */
  amount: Scalars['Decimal']['output'];
  /** The item on that line. */
  itemId: Scalars['String']['output'];
  /** The line's subtotal net of its own category-volume discount — the allocation basis. */
  lineBase: Scalars['Decimal']['output'];
  /** The order line this receipt belongs to. */
  lineItemId: Scalars['UUID']['output'];
  /** The line's position on the order, for display alongside the receipt. */
  lineNumber: Scalars['Int']['output'];
  /** The item the line named before an item combine moved it to itemId; null when no combine moved it. */
  originalItemId?: Maybe<Scalars['String']['output']>;
  /**
   * The line's SUBTOTAL quantity basis (eaches when present, otherwise quantity) — the same basis the
   * line's money is computed on and the unit-count threshold is summed on.
   */
  quantity: Scalars['Decimal']['output'];
};

/**
 * One order line's allocated share of the order-wide volume discount. Allocated from an order-level
 * figure (not derived per line), with the rounding residual distributed so Σ Amount equals
 * the component's Amount exactly.
 */
export type OrderVolumeLineDocumentFilterInput = {
  /** This line's allocated share of the component, in dollars. */
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<OrderVolumeLineDocumentFilterInput>>;
  /** The item on that line. */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** The line's subtotal net of its own category-volume discount — the allocation basis. */
  lineBase?: InputMaybe<DecimalOperationFilterInput>;
  /** The order line this receipt belongs to. */
  lineItemId?: InputMaybe<UuidOperationFilterInput>;
  /** The line's position on the order, for display alongside the receipt. */
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OrderVolumeLineDocumentFilterInput>>;
  /** The item the line named before an item combine moved it to itemId; null when no combine moved it. */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The line's SUBTOTAL quantity basis (eaches when present, otherwise quantity) — the same basis the
   * line's money is computed on and the unit-count threshold is summed on.
   */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
};

export type OrderVolumePoolProgressData = {
  __typename?: 'OrderVolumePoolProgressData';
  /** The pool's CODE as entered; empty when the pool cannot be found. */
  code: Scalars['String']['output'];
  linesAtBreak: Scalars['Int']['output'];
  /** The pool's display NAME; empty when the pool cannot be found. */
  name: Scalars['String']['output'];
  nextBreakQuantity?: Maybe<Scalars['Decimal']['output']>;
  participatingLineCount: Scalars['Int']['output'];
  /**
   * The volume pool this row reports on, resolved from the pool registry by id so its code and
   * name are always current. Null when the referenced pool cannot be found.
   */
  pool?: Maybe<VolumePool>;
  poolId: Scalars['String']['output'];
  pooledQuantity: Scalars['Decimal']['output'];
};

/**
 * One volume pool's LIVE standing as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record (boundary type suffix not applied because the parent
 * OrdersDocument is itself the read-model boundary type), used by this document and nothing
 * else.
 *
 * Mirrors the domain's OrderVolumePoolProgress, with the boundary conversion that record
 * applies everywhere: its Option<decimal> member becomes a nullable decimal?.
 * null on nextBreakQuantity means no member's ladder has a rung above the pooled
 * quantity — never zero, which would read as a break the pool has already passed.
 *
 *
 * Stores the pool's ID and never its code or name: pool names change on rename, so both are
 * resolved from the registry at query time through VolumePoolDataLoader — see
 * OrderVolumePoolProgressDocumentResolvers, which publishes pool, code and
 * name on this type.
 */
export type OrderVolumePoolProgressDocument = {
  __typename?: 'OrderVolumePoolProgressDocument';
  /**
   * The pool's CODE as entered — the label a totals card shows ("Quarts"). Empty when the pool
   * cannot be found; never a stale copy, because nothing denormalizes it.
   */
  code: Scalars['String']['output'];
  /**
   * How many priced members earned a rung above their OWN quantity — the lines the pool is
   * actually carrying. 0 is a real answer, not a missing one: a line big enough to reach
   * its rung alone gains nothing from the pool.
   */
  linesAtBreak: Scalars['Int']['output'];
  /**
   * The pool's display NAME. Empty when the pool cannot be found; never a stale copy, because
   * nothing denormalizes it.
   */
  name: Scalars['String']['output'];
  /**
   * The lowest rung threshold across every member's ladder STRICTLY above
   * pooledQuantity — the "1,008". null when the pool has passed every configured
   * break, which is the signal to render "top break reached" rather than a progress bar.
   */
  nextBreakQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** How many lines count toward the pool, pinned (override-priced) lines included. */
  participatingLineCount: Scalars['Int']['output'];
  /**
   * The volume pool this row reports on, resolved from the pool registry by id so its code and
   * name are always current. Null only when the referenced pool cannot be found — a pool deleted
   * out from under an order that was priced in it.
   */
  pool?: Maybe<VolumePool>;
  /**
   * The pool's id — the same value a pooled line's volumePoolId carries, so a client can
   * join the two without a second query.
   */
  poolId: Scalars['String']['output'];
  /**
   * The summed basis eaches of every line counting toward this pool — the quantity each of those
   * lines was priced at, and the "504" in "504 of 1,008". In EACHES (Ruling 3) and selected by the
   * order's STATUS (Ruling 2), so it is the very number the rung thresholds were compared against.
   * Non-discountable lines and pools the customer disabled do not count; an override-priced line
   * does.
   */
  pooledQuantity: Scalars['Decimal']['output'];
};

/**
 * One volume pool's LIVE standing as stored on OrdersDocument and exposed to clients.
 * Document-only sub-record (boundary type suffix not applied because the parent
 * OrdersDocument is itself the read-model boundary type), used by this document and nothing
 * else.
 *
 * Mirrors the domain's OrderVolumePoolProgress, with the boundary conversion that record
 * applies everywhere: its Option<decimal> member becomes a nullable decimal?.
 * null on nextBreakQuantity means no member's ladder has a rung above the pooled
 * quantity — never zero, which would read as a break the pool has already passed.
 *
 *
 * Stores the pool's ID and never its code or name: pool names change on rename, so both are
 * resolved from the registry at query time through VolumePoolDataLoader — see
 * OrderVolumePoolProgressDocumentResolvers, which publishes pool, code and
 * name on this type.
 */
export type OrderVolumePoolProgressDocumentFilterInput = {
  and?: InputMaybe<Array<OrderVolumePoolProgressDocumentFilterInput>>;
  /**
   * How many priced members earned a rung above their OWN quantity — the lines the pool is
   * actually carrying. 0 is a real answer, not a missing one: a line big enough to reach
   * its rung alone gains nothing from the pool.
   */
  linesAtBreak?: InputMaybe<IntOperationFilterInput>;
  /**
   * The lowest rung threshold across every member's ladder STRICTLY above
   * pooledQuantity — the "1,008". null when the pool has passed every configured
   * break, which is the signal to render "top break reached" rather than a progress bar.
   */
  nextBreakQuantity?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderVolumePoolProgressDocumentFilterInput>>;
  /** How many lines count toward the pool, pinned (override-priced) lines included. */
  participatingLineCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * The pool's id — the same value a pooled line's volumePoolId carries, so a client can
   * join the two without a second query.
   */
  poolId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The summed basis eaches of every line counting toward this pool — the quantity each of those
   * lines was priced at, and the "504" in "504 of 1,008". In EACHES (Ruling 3) and selected by the
   * order's STATUS (Ruling 2), so it is the very number the rung thresholds were compared against.
   * Non-discountable lines and pools the customer disabled do not count; an override-priced line
   * does.
   */
  pooledQuantity?: InputMaybe<DecimalOperationFilterInput>;
};

export enum OrderVolumeThresholdType {
  OrderSubtotal = 'ORDER_SUBTOTAL',
  UnitCount = 'UNIT_COUNT'
}

export type OrderVolumeThresholdTypeOperationFilterInput = {
  eq?: InputMaybe<OrderVolumeThresholdType>;
  in?: InputMaybe<Array<OrderVolumeThresholdType>>;
  neq?: InputMaybe<OrderVolumeThresholdType>;
  nin?: InputMaybe<Array<OrderVolumeThresholdType>>;
};

/**
 * How far an Order write got. Only ACKNOWLEDGED means every stage completed. REJECTED_BEFORE_WRITE means
 * this call wrote nothing. PARTIAL means the primary write landed and a later stage was refused; only
 * addLineItems on an Order past Open or Initialized writes in stages, so only it can be PARTIAL.
 * OUTCOME_UNKNOWN means the event store did not answer, so the stage may or may not have been written. On the
 * first stage of a staged write it can also mean a failed read before anything was appended, so check the
 * Order before acting.
 */
export enum OrderWriteOutcome {
  /** Every stage completed. */
  Acknowledged = 'ACKNOWLEDGED',
  /**
   * The event store did not answer a stage, or failed an all-or-nothing write's one append other than on a
   * stream conflict, so whether it was written is not known.
   */
  OutcomeUnknown = 'OUTCOME_UNKNOWN',
  /** The primary write landed; a later stage was refused, and the stages after it did not run. */
  Partial = 'PARTIAL',
  /** Refused before the first append. This call wrote nothing. */
  RejectedBeforeWrite = 'REJECTED_BEFORE_WRITE',
  /** Never a business value. */
  Unknown = 'UNKNOWN'
}

/** One write an Order mutation makes, in the order it makes them. */
export enum OrderWriteStage {
  /** correctOrder's primary write: the replacement Order at orderId, its credit when there is one, and the source back-reference, in one append. */
  CorrectionSubmitted = 'CORRECTION_SUBMITTED',
  /** The derived money on the correction's credit. The credit keeps the money the source billed, so it completes with nothing to write. */
  CreditDerivedMoney = 'CREDIT_DERIVED_MONEY',
  /** The derived money recompute (volume discounts, non-discountable totals, freight). On addLineItems to an Order past Open or Initialized, only its freight recompute is a separate append, after the lines. */
  DerivedMoney = 'DERIVED_MONEY',
  /** The explicit or customer-default Order discount. */
  Discount = 'DISCOUNT',
  /** The Order-level ERP id from the input. Completes with nothing to write when none was sent. */
  ErpId = 'ERP_ID',
  /** The inherited default freight folded into the Order. */
  Freight = 'FREIGHT',
  /** addLineItems' primary write: the new lines on orderId. */
  LinesAdded = 'LINES_ADDED',
  /** initializeOrder's primary write: the new Order at orderId. */
  OrderInitialized = 'ORDER_INITIALIZED',
  /** creditExistingOrder's primary write: the Credit at orderId and its record on the source Order, in one append. */
  OrderSubmitted = 'ORDER_SUBMITTED',
  /** The reprice of the Order's existing lines. */
  Reprice = 'REPRICE',
  /** Never a business value. */
  Unknown = 'UNKNOWN'
}

/**
 * How far an Order write got, stage by stage. orderId is the Order the primary write creates or changes,
 * including an id the server generated; it is null only when the caller sent none and the write was refused
 * before one was generated. Inspect it with orderInspection before acting on anything other than
 * ACKNOWLEDGED; never resend the same write with a new id.
 */
export type OrderWriteStageResultData = {
  __typename?: 'OrderWriteStageResultData';
  orderId?: Maybe<Scalars['String']['output']>;
  outcome: OrderWriteOutcome;
  stages: Array<OrderWriteStageStatusData>;
};

/** What happened to one stage. */
export enum OrderWriteStageStatus {
  /** The stage completed, possibly with nothing to write. */
  Acknowledged = 'ACKNOWLEDGED',
  /** The stage did not run. */
  NotRun = 'NOT_RUN',
  /** The event store did not answer, so whether this stage was written is not known. */
  OutcomeUnknown = 'OUTCOME_UNKNOWN',
  /** The stage was refused. The error is in errors. */
  Refused = 'REFUSED',
  /** Never a business value. */
  Unknown = 'UNKNOWN'
}

/** One stage of an Order write and what happened to it. */
export type OrderWriteStageStatusData = {
  __typename?: 'OrderWriteStageStatusData';
  stage: OrderWriteStage;
  status: OrderWriteStageStatus;
};

/**
 * Trading-partner functional-acknowledgment (X12 997) state of a transaction.
 * Maps from the v3 transaction acknowledgmentStatus field
 * (NOT_ACKNOWLEDGED | ACCEPTED | REJECTED | OVERDUE | ACCEPTED_WITH_ERRORS).
 */
export enum OrderfulAcknowledgmentStatus {
  /** The partner accepted the transaction (997 code A). Wire value ACCEPTED. */
  Accepted = 'ACCEPTED',
  /** The partner accepted with errors (997 code E). Wire value ACCEPTED_WITH_ERRORS. */
  AcceptedWithErrors = 'ACCEPTED_WITH_ERRORS',
  /** No 997 has been received yet. Wire value NOT_ACKNOWLEDGED. */
  NotAcknowledged = 'NOT_ACKNOWLEDGED',
  /** No 997 arrived within the configured window. Wire value OVERDUE. */
  Overdue = 'OVERDUE',
  /** The partner rejected the transaction (997 code R). Wire value REJECTED. */
  Rejected = 'REJECTED'
}

/**
 * Orderful delivery lifecycle of a transaction to its destination.
 * Maps from the v3 transaction deliveryStatus field (PENDING | SENT | DELIVERED | FAILED).
 */
export enum OrderfulDeliveryStatus {
  /** The transaction reached its destination. Wire value DELIVERED. */
  Delivered = 'DELIVERED',
  /** Delivery failed. Wire value FAILED. */
  Failed = 'FAILED',
  /** Delivery has not started. Wire value PENDING. */
  Pending = 'PENDING',
  /** The transaction has been sent toward its destination. Wire value SENT. */
  Sent = 'SENT'
}

/**
 * One row of the cross-tenant admin overview returned by orderfulIntegrationConfigs. Single-use
 * query-output type — only that query returns it, so its shape can change without breaking shared
 * contracts. Key status is exposed as the derived ApiKeyPresent flag only; the
 * @keyvault(...) reference is never carried on this type, so the admin overview can never leak it.
 */
export type OrderfulIntegrationConfigAdminRow = {
  __typename?: 'OrderfulIntegrationConfigAdminRow';
  /** True when an Orderful API key reference is configured for the tenant — never the value itself. */
  apiKeyPresent: Scalars['Boolean']['output'];
  /** The tenant's own Organization ISA id(s); empty when none are configured. */
  organizationIsaIds: Array<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  status: OrderfulIntegrationStatus;
  tenantId: Scalars['String']['output'];
  /** Tenant display name from our own registry; empty when the tenant has no registry entry. */
  tenantName: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * MongoDB read-model document for a tenant's Orderful integration config. There is exactly one
 * document per tenant; Id equals the tenant id today, but use GetDocumentId for all
 * reads/writes so that invariant can evolve without breaking call sites. OrderfulApiKeySecretName
 * is a @keyvault(...) reference string only — never the secret value.
 */
export type OrderfulIntegrationConfigDocument = {
  __typename?: 'OrderfulIntegrationConfigDocument';
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  orderfulApiKeySecretName?: Maybe<Scalars['String']['output']>;
  organizationIsaIds: Array<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  status: OrderfulIntegrationStatus;
  tenantId: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderfulIntegrationConfigPayload = {
  __typename?: 'OrderfulIntegrationConfigPayload';
  errors?: Maybe<Array<ValidationError>>;
  orderfulIntegrationConfig?: Maybe<OrderfulIntegrationConfigStateData>;
};

export type OrderfulIntegrationConfigStateData = {
  __typename?: 'OrderfulIntegrationConfigStateData';
  orderfulApiKeySecretName?: Maybe<Scalars['String']['output']>;
  organizationIsaIds: Array<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  status: OrderfulIntegrationStatus;
  tenantId: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrderfulIntegrationStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

/** A single EDI control reference. Maps from an Orderful referenceIdentifiers[] entry. */
export type OrderfulReferenceIdentifierApiData = {
  __typename?: 'OrderfulReferenceIdentifierApiData';
  /** Owning party of the reference. Maps from owner. */
  owner: OrderfulReferenceOwner;
  /** Envelope level of the reference. Maps from type. */
  type: OrderfulReferenceIdentifierType;
  /** The control number / reference value. Maps from value. */
  value: Scalars['String']['output'];
};

/**
 * Which EDI envelope level a reference identifier belongs to.
 * Maps from the v3 transaction referenceIdentifiers[].type field
 * (INTERCHANGE | GROUP | TRANSACTION).
 */
export enum OrderfulReferenceIdentifierType {
  /** Functional-group-level (GS) control reference. Wire value GROUP. */
  Group = 'GROUP',
  /** Interchange-level (ISA) control reference. Wire value INTERCHANGE. */
  Interchange = 'INTERCHANGE',
  /** Transaction-set-level (ST) control reference. Wire value TRANSACTION. */
  Transaction = 'TRANSACTION'
}

/**
 * Which party owns a reference identifier.
 * Maps from the v3 transaction referenceIdentifiers[].owner field (SENDER | RECEIVER).
 */
export enum OrderfulReferenceOwner {
  /** The reference belongs to the receiver. Wire value RECEIVER. */
  Receiver = 'RECEIVER',
  /** The reference belongs to the sender. Wire value SENDER. */
  Sender = 'SENDER'
}

/**
 * Orderful environment stream a transaction belongs to.
 * Maps from the v3 transaction stream field (TEST | LIVE).
 */
export enum OrderfulStream {
  /** Production traffic. Wire value LIVE. */
  Live = 'LIVE',
  /** Test/sandbox traffic. Wire value TEST. */
  Test = 'TEST'
}

/**
 * Reference to a transaction's 997 acknowledgment. Maps from the Orderful transaction
 * acknowledgment object. Only the href is exposed; full acknowledgment detail lives at a
 * separate Orderful endpoint and is out of scope for this slice.
 */
export type OrderfulTransactionAcknowledgmentRefApiData = {
  __typename?: 'OrderfulTransactionAcknowledgmentRefApiData';
  /** URL of the acknowledgment endpoint. Maps from acknowledgment.href. */
  href: Scalars['String']['output'];
};

/**
 * An Orderful EDI transaction. Serves both the list (summary) and single (detail) surfaces: Orderful
 * returns the same object for GET /v3/transactions and GET /v3/transactions/{id}; the
 * only difference is that detail expands message.transactionSets with the parsed EDI content.
 * That parsed segment payload is partner- and transaction-type-specific and is intentionally NOT
 * modeled here — Message exposes its href only.
 */
export type OrderfulTransactionApiData = {
  __typename?: 'OrderfulTransactionApiData';
  /**
   * Reference to the 997 acknowledgment, present only once an acknowledgment exists.
   * Maps from acknowledgment.
   */
  acknowledgment?: Maybe<OrderfulTransactionAcknowledgmentRefApiData>;
  /** 997 acknowledgment lifecycle. Maps from acknowledgmentStatus. */
  acknowledgmentStatus: OrderfulAcknowledgmentStatus;
  /** Partner-facing business number, when present. Maps from businessNumber. */
  businessNumber?: Maybe<Scalars['String']['output']>;
  /** When Orderful created the transaction. Maps from createdAt. */
  createdAt: Scalars['DateTime']['output'];
  /** Delivery lifecycle. Maps from deliveryStatus. */
  deliveryStatus: OrderfulDeliveryStatus;
  /**
   * Direction relative to the calling organization. DERIVED — not an Orderful field; computed by the
   * mapper from sender/receiver versus the organization's identity.
   */
  direction: OrderfulTransactionDirection;
  /** Canonical Orderful URL for this transaction. Maps from href. */
  href: Scalars['String']['output'];
  /** Orderful transaction id. Maps from id. */
  id: Scalars['String']['output'];
  /** When Orderful last updated the transaction. Maps from lastUpdatedAt. */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Reference to the EDI message content. Maps from message. */
  message: OrderfulTransactionMessageApiData;
  /** Receiving party identity. Maps from receiver. */
  receiver: OrderfulTransactionPartyApiData;
  /**
   * Interchange/group/transaction control references. Maps from referenceIdentifiers;
   * empty when none are present.
   */
  referenceIdentifiers: Array<OrderfulReferenceIdentifierApiData>;
  /** Sending party identity. Maps from sender. */
  sender: OrderfulTransactionPartyApiData;
  /** Environment stream. Maps from stream. */
  stream: OrderfulStream;
  /** EDI transaction type (e.g. 850_PURCHASE_ORDER). Maps from type. */
  type: OrderfulTransactionTypeApiData;
  /** Validation lifecycle. Maps from validationStatus. */
  validationStatus: OrderfulValidationStatus;
  /** Orderful API version that produced this object (e.g. v3). Maps from version. */
  version: Scalars['String']['output'];
};

/**
 * Direction of a transaction relative to the calling Orderful organization. This is a DERIVED proxy
 * field — Orderful exposes no native direction field; the mapper (T5) computes it from whether the
 * organization is the transaction's sender (OUTBOUND) or receiver (INBOUND).
 */
export enum OrderfulTransactionDirection {
  /** The organization is the receiver of the transaction. */
  Inbound = 'INBOUND',
  /** The organization is the sender of the transaction. */
  Outbound = 'OUTBOUND'
}

/**
 * Reference to a transaction's EDI message content. Maps from the Orderful transaction message
 * object. Only the content href is exposed; the parsed transactionSets segment tree is
 * intentionally not modeled in this slice.
 */
export type OrderfulTransactionMessageApiData = {
  __typename?: 'OrderfulTransactionMessageApiData';
  /** URL of the message content endpoint. Maps from message.href. */
  href: Scalars['String']['output'];
};

/**
 * Identity of a transaction's sender or receiver. Maps from the Orderful transaction sender /
 * receiver objects. (The relationship endpoint uses a different identity shape and is modeled
 * separately by the relationships task.)
 */
export type OrderfulTransactionPartyApiData = {
  __typename?: 'OrderfulTransactionPartyApiData';
  /** Live interchange (ISA) id. Maps from isaId. */
  isaId: Scalars['String']['output'];
  /** Live interchange id qualifier. Maps from isaIdQualifier. */
  isaIdQualifier: Scalars['String']['output'];
  /** Human-readable party name, when present. Maps from name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Test interchange id, when configured. Maps from testIsaId. */
  testIsaId?: Maybe<Scalars['String']['output']>;
  /** Test interchange id qualifier, when configured. Maps from testIsaIdQualifier. */
  testIsaIdQualifier?: Maybe<Scalars['String']['output']>;
};

/** The EDI transaction type of a transaction. Maps from the Orderful type object. */
export type OrderfulTransactionTypeApiData = {
  __typename?: 'OrderfulTransactionTypeApiData';
  /** Orderful transaction-type name, e.g. 850_PURCHASE_ORDER. Maps from type.name. */
  name: Scalars['String']['output'];
};

/**
 * Filter input for the orderfulTransactions proxy query. Every field is optional; supplied
 * fields are forwarded to Orderful's GET /v3/transactions as the matching wire query
 * parameters. Input boundary type: optional fields use T? (HotChocolate input
 * deserialization has no Option<T> support).
 */
export type OrderfulTransactionsFilterInput = {
  /** 997 acknowledgment lifecycle filter. Forwarded as repeated acknowledgmentStatus parameters. */
  acknowledgmentStatuses?: InputMaybe<Array<OrderfulAcknowledgmentStatus>>;
  /**
   * Inclusive lower bound of the created-at range. Orderful only accepts a closed-open range, so
   * this requires CreatedAtTo.
   */
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Exclusive upper bound of the created-at range. Orderful only accepts a closed-open range, so
   * this requires CreatedAtFrom.
   */
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Delivery lifecycle filter. Forwarded as repeated deliveryStatus parameters. */
  deliveryStatuses?: InputMaybe<Array<OrderfulDeliveryStatus>>;
  /** Receiver interchange (ISA) ids, at most 5. Forwarded as repeated receiverIsaId parameters. */
  receiverIsaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sender interchange (ISA) ids, at most 5. Forwarded as repeated senderIsaId parameters. */
  senderIsaIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Environment stream filter. Forwarded as the stream parameter. */
  stream?: InputMaybe<OrderfulStream>;
  /**
   * EDI transaction-type names (e.g. 850_PURCHASE_ORDER), at most 5. Forwarded as repeated
   * transactionType parameters.
   */
  transactionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Validation lifecycle filter. Forwarded as repeated validationStatus parameters. */
  validationStatuses?: InputMaybe<Array<OrderfulValidationStatus>>;
};

/**
 * One page of Orderful transactions plus the opaque cursors for the adjacent pages. Cursors are
 * extracted from the metadata.pagination.links URLs Orderful returns; None when no
 * adjacent page exists. Orderful caps a page at 100 transactions — there is no page-size knob.
 */
export type OrderfulTransactionsPageData = {
  __typename?: 'OrderfulTransactionsPageData';
  /**
   * Opaque cursor for the next page; pass back as the query's nextCursor argument.
   * None on the last page.
   */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /**
   * Opaque cursor for the previous page; pass back as the query's prevCursor argument.
   * None on the first page.
   */
  prevCursor?: Maybe<Scalars['String']['output']>;
  /** The transactions on this page, in the order Orderful returned them. */
  transactions: Array<OrderfulTransactionApiData>;
};

/**
 * Payload for the orderfulTransactions proxy query: the requested page on success, payload
 * errors (never exceptions) on any gating, transport, or mapping failure.
 */
export type OrderfulTransactionsPayload = {
  __typename?: 'OrderfulTransactionsPayload';
  errors?: Maybe<Array<ValidationError>>;
  transactionsPage?: Maybe<OrderfulTransactionsPageData>;
};

/**
 * Orderful validation lifecycle of a transaction's EDI content.
 * Maps from the v3 transaction validationStatus field (PROCESSING | VALID | INVALID).
 */
export enum OrderfulValidationStatus {
  /** The EDI content failed validation. Wire value INVALID. */
  Invalid = 'INVALID',
  /** Orderful is still validating the EDI content. Wire value PROCESSING. */
  Processing = 'PROCESSING',
  /** The EDI content passed validation. Wire value VALID. */
  Valid = 'VALID'
}

/** A connection to a list of items. */
export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrdersDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** MongoDB document representing an order. */
export type OrdersDocument = {
  __typename?: 'OrdersDocument';
  acknowledgmentEmail?: Maybe<ConfirmationEmailData>;
  /**
   * Which sender owns this order's acknowledgment email: LEGACY, DISPATCH, or UNKNOWN while no
   * acknowledgment has triggered for it.
   */
  acknowledgmentEmailRoute: CustomerEmailRoute;
  adjustedAt: Scalars['DateTime']['output'];
  /** Staff only; refused for customer-portal callers. */
  adjustedBy: Scalars['String']['output'];
  /**
   * Order-level allocation rollup so the FULFILL orders grid can answer "which orders still need
   * allocating?" without opening each order. Maintained by every allocate / deallocate /
   * make-to-order-reflection / line-item event as an absolute $set carried on the event
   * (legacy events carry no rollup and skip the write, preserving the last stamped value).
   * null on any order written before this rollup existed: no allocation status had been
   * derived for it until the one-time Mongo backfill stamped it. null is deliberately a
   * DIFFERENT answer from NOT_STARTED — "this order's status has not been worked out" is not
   * the same fact as "nobody has tried to allocate this order".
   */
  allocationStatus?: Maybe<OrderAllocationStatus>;
  /**
   * What has been received against the order. Once a LIVE invoice stands against it this is the cash
   * recorded on that invoice; otherwise it is the total of every ledger entry (payments and deposits)
   * applied to the order, which is null until the first payment event is projected. Written by the same
   * two sources as paymentStatus, and filterable and sortable for the same reason.
   */
  amountPaid?: Maybe<MoneyData>;
  /**
   * The order's outstanding balance. Once a LIVE invoice stands against it this is that invoice's open
   * balance; otherwise it is the order total less the amount paid, and is NULL until the first payment
   * event is projected. A null balance means nothing has been recorded against the order yet — it is
   * NOT a zero balance, and rendering it as 0 asserts the order is settled when it may never even have
   * been billed. Voiding the only live bill returns it to null for exactly that reason: nothing is
   * billed again until a new invoice is issued. Written by the same two sources as paymentStatus, and
   * filterable and sortable for the same reason.
   */
  balance?: Maybe<MoneyData>;
  billingAddress: AddressData;
  /**
   * Order-level carrier (ENS). Plain optional string — not a managed carrier
   * master/aggregate. Set at creation from V3.OrderInitialized (an explicit override,
   * or the customer's inherited default) and re-stamped by V2.OrderEdited. Empty string
   * when no carrier is set on V3+ orders; null only for legacy orders created before
   * this field existed.
   */
  carrier?: Maybe<Scalars['String']['output']>;
  /**
   * The order's tier-derived CATEGORY VOLUME discount components — one row per category whose
   * CategoryVolume tier the order's summed quantity qualified for. Feeds the PWA's "why this
   * price?" popover ("2,550/2,550 ✓, 6 contributing lines").
   *
   * A PLANE-2 component, distinct from DiscountAmount/DiscountPercent
   * (the manual/customer discount), which it never touches. The two stack in a fixed order:
   * line prices → category volume → customer/manual on the resulting net → tenant cap. Every
   * amount here is PLAIN DOLLARS, never a percent or fraction.
   *
   *
   * Empty means the order qualifies for no tier — which is also how the discount disappears when
   * a line is removed below a threshold. The projection $sets the whole array absolutely from the
   * event, so it can never drift from the OrderTotal stamped by the same event.
   */
  categoryVolumeDiscounts: Array<OrderCategoryVolumeDiscountDocument>;
  /**
   * LIVE per-category progress toward the order's CategoryVolume tiers — one row per category
   * that has a usable tier configured and at least one item on this order, present WHETHER OR NOT
   * any tier is currently reached.
   *
   * This is the field the "why this price?" popover reads to render the not-yet-reached case
   * ("1,700 / 2,550 — 850 more units to reach the $0.99 tier").
   * CategoryVolumeDiscounts cannot answer that question: it holds only categories that
   * already qualified AND saved money, so the category a customer is closest to buying into is
   * precisely the one missing from it.
   *
   *
   * Carries no money that any total is derived from — OrderTotal is unaffected by every
   * value here. QualifyingQuantity is the SAME number the discount qualified against,
   * produced by the same kernel pass under the same exclusions (item-priced, overridden and
   * non-discountable lines omitted), so a tier this promises is a tier the order will actually
   * receive.
   *
   *
   * Empty means no reachable tier is configured for anything on the order — NOT that the order
   * qualifies for nothing. An order that qualifies for nothing has rows here, each with
   * qualified: false. The projection $sets the whole array absolutely from the same
   * event that stamps the discounts, so the two can never be one mutation apart.
   */
  categoryVolumeProgress: Array<OrderCategoryVolumeProgressDocument>;
  confirmationEmail?: Maybe<ConfirmationEmailData>;
  /**
   * Which sender owns this order's confirmation email: LEGACY, DISPATCH, or UNKNOWN while no
   * confirmation has triggered for it.
   */
  confirmationEmailRoute: CustomerEmailRoute;
  /**
   * The ORDER's shipping container — a ContainerConfig.ContainerCode. Set or cleared by
   * V1.OrderContainerSet; null until a container is set, and null again once
   * cleared. Additive with no backfill, so every order that predates this field reads back
   * null. Mirrors Route's shape/semantics.
   *
   * The OUTER container the load ships on — distinct from the per-line container code carried on
   * LineItems[].ContainerCode, which it never cascades to.
   */
  containerCode?: Maybe<Scalars['String']['output']>;
  /** Correction linkage when this order was created by correctOrder; null for ordinary orders. */
  correction?: Maybe<OrderCorrectionData>;
  /**
   * Where a Credit-type order's money stands: APPLIED when all of its credit memo has been applied to invoices or
   * refunded, PARTIALLY_APPLIED when some has, UNAPPLIED when none has or no memo has been issued yet. A credit
   * is never a sale, so it never reads UNPAID. Null for every order that is not a Credit-type order.
   */
  creditApplicationStatus?: Maybe<CreditApplicationStatus>;
  /**
   * The credit memo this Credit-type order issued instead of an invoice. Null for every other order, and for a
   * Credit-type order whose memo has not been issued yet.
   */
  creditMemo?: Maybe<CreditMemoDocument>;
  /**
   * OrderId of the source order this Credit order was created from by the dedicated
   * credit-existing-order flow (V1.OrderCreditedFromSource). Null for every other
   * order.
   */
  creditedFromOrderId?: Maybe<Scalars['String']['output']>;
  /**
   * OrderNumber of the source order this Credit order was created from, captured for
   * display so grids never need a second lookup. Null for every other order.
   */
  creditedFromOrderNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The sum of every amount in credits, in the order's currency. Zero for an order nobody has
   * credited.
   */
  creditedTotal: MoneyData;
  /**
   * Every credit standing against this order from the credit-existing-order flow, oldest first: the
   * credit order's id and number, when it was created, its amount and why it was raised. A credit
   * order that is cancelled or deleted is withdrawn from this list in the same write. Empty for an
   * order nobody has credited. Written from the order's own V1.OrderCreditRecorded and
   * V1.OrderCreditWithdrawn events.
   */
  credits: Array<OrderCreditEntry>;
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  /** The customer's own live pull slip report choice. Null when no customer choice is set or the chosen report no longer renders. */
  customerPullSlipReportId?: Maybe<Scalars['String']['output']>;
  /**
   * The reason a delivery attempt on this order failed, when its status reads failed delivery.
   * None otherwise. No backfill: None for every order until FULFILL Logistics
   * dispatch and delivery write into the order stream.
   */
  deliveryFailureReason?: Maybe<Scalars['String']['output']>;
  /** How much the deposits recorded on this order exceed its total, in the order's currency, before the order is invoiced: the overpayment that moves to the customer's unapplied credit when it is, because an invoice applies a deposit only up to what it charges. Null when the deposits do not exceed the total, and once the order has been invoiced: the invoice's depositOverage is then the figure moved, and a bill raised after a void never moves it again. */
  depositOverage?: Maybe<MoneyData>;
  /** Total of the order's Kind=Deposit ledger entries — the deposit received so far. Zero when no deposit has been recorded. */
  depositReceived: Scalars['Decimal']['output'];
  /** The deposit required before this order can be allocated, derived live from the customer's current deposit requirement applied to the order total (percent) or the flat amount. Zero when the customer requires no deposit. */
  depositRequired: Scalars['Decimal']['output'];
  /** True when the deposit received meets or exceeds the deposit required (always true for customers with no requirement). When false, the order is deposit-blocked from allocation. */
  depositSatisfied: Scalars['Boolean']['output'];
  discountAmount: MoneyData;
  /** Itemized discount components for this order — one labelled row per source (category volume, order volume, and the customer-default or manual discount), in the order they were applied. Rows worth $0 are omitted, so an order with no discount returns an empty list. The amounts sum to exactly the dollars the discounts took off the subtotal, i.e. to categoryVolumeDiscounts + orderVolumeDiscount + effectiveDiscountAmount. That is NOT (subtotal - orderTotal) in general: orderTotal additionally carries freight, flat charges, royalty and tax, which are added after the discounts and are not discounts. The one exception is an order with overrideTotal set — an override replaces the total outright rather than discounting it, so the rows stay true about what the order qualified for but no longer reconcile against the computed totals. Every amount is plain dollars and non-negative: the amount that source took off, not a signed adjustment. */
  discountBreakdown: Array<OrderDiscountComponentData>;
  discountPercent: Scalars['Decimal']['output'];
  discountReason: Scalars['String']['output'];
  /**
   * Where planning ships and pins the load instead of the order's ship-to location, which this
   * never touches. Null when no destination is set. Set or cleared by the
   * setOrderDropShipDestination / clearOrderDropShipDestination mutations.
   */
  dropShipDestination?: Maybe<OrderDropShipDestinationData>;
  /** Report id this order's acknowledgement renders with: the customer's document override, else the tenant binding, else the seeded default. */
  effectiveAcknowledgementReportId: Scalars['String']['output'];
  /**
   * The resolved dollar value of the MANUAL/customer discount actually subtracted — a positive
   * flat DiscountAmount wins outright, otherwise the percent is applied to the
   * subtotal NET of CategoryVolumeDiscounts, which stack ahead of it (line prices →
   * category volume → customer/manual on the net). It is therefore measured against
   * Subtotal − CategoryVolumeDiscounts, not against Subtotal itself; the two
   * bases coincide only on an order that qualifies for no tier. A plain dollar amount (NOT a
   * percent or fraction — unlike DiscountPercent, which is surfaced as a percent,
   * this mirrors DiscountAmount's convention). Sourced from
   * OrderState.CalculateEffectiveDiscountAmount — the same kernel
   * OrderState.CalculateOrderTotal folds into every computed total, so this field never
   * diverges from what was actually subtracted. Re-stamped alongside Subtotal by the
   * same event set (a percent discount's dollar value moves whenever the subtotal does). Null
   * until the first such event projects it.
   */
  effectiveDiscountAmount?: Maybe<MoneyData>;
  /** Report id this order's invoice renders with: the customer's document override, else the tenant binding, else the seeded default. */
  effectiveInvoiceReportId: Scalars['String']['output'];
  /** The order's effective typed notes (Ship/Pull/General), resolved live at read time by inheritance: order override → ship-to customer location → customer. Each entry also reports which tier supplied the note (Order/Location/Customer, or None when no tier has one) so the UI can label the source. Always returns one entry per NoteContext. */
  effectiveNotes: Array<EffectiveOrderNote>;
  /** Report id this order's pull slip renders with: the customer's document override, else the tenant binding, else the seeded default. */
  effectivePullSlipReportId: Scalars['String']['output'];
  /**
   * Denormalized effective route the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveRouteResolver using the canonical precedence (direct Route
   * → ship-to Locations.Route snapshot → inherited customer-location → customer →
   * tenant-default route). null when nothing resolves. Re-stamped by
   * EffectiveRouteReStamper when an upstream tier changes.
   */
  effectiveRoute?: Maybe<Scalars['String']['output']>;
  /** Resolved boolean controlling whether the order-confirmation email should be sent. Cascade is order ?? location ?? customer (most-specific-wins). True means send; false means skip. */
  effectiveSendOrderEmails: Scalars['Boolean']['output'];
  /**
   * Denormalized terms id the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveTermsIdResolver using the canonical 3-tier precedence (direct
   * TermsId → ship-to Locations.TermsId snapshot → inherited
   * customer-location → customer → tenant-default terms). null when nothing resolves.
   * Empty strings on the source tiers are treated as absent (legacy JS-truthiness).
   */
  effectiveTermsId?: Maybe<Scalars['String']['output']>;
  /** Staff only; refused for customer-portal callers. The accounting-system code of the order. */
  erpId?: Maybe<Scalars['String']['output']>;
  /** What this order's sales tax is currently estimated at, and how far that figure can be trusted. Always an estimate: it is never charged, it is not part of orderTotal, and the tax the customer actually pays is settled when the order is invoiced on what was shipped. Read status first: on an order nobody has estimated the amount is zero and means nothing, which is a different fact from an estimate that genuinely came back at zero because the seller holds no tax registration where the goods are going. The figure is reported as out of date once anything that affects it moves: the lines, their prices or discounts, freight, the flat charges, the ship-to address, the customer's exemption, or the order's No tax. */
  estimatedTax?: Maybe<OrderTaxEstimatePayload>;
  /**
   * The total sales tax Stripe estimated for this order, as of the last time an estimate was taken.
   * Zero and meaningless unless estimatedTaxAt is set — read that first. Always an estimate: it is
   * never charged, never part of the order total, and the bill's real tax is settled when the order
   * is invoiced on what actually shipped.
   */
  estimatedTaxAmount: Scalars['Decimal']['output'];
  /**
   * When the estimate was taken, or null when none ever has been. This is the field that says whether
   * an estimate exists at all.
   */
  estimatedTaxAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The estimated tax broken down by jurisdiction, one row per jurisdiction, rate and reason. A zero
   * row means the seller holds no tax registration in that jurisdiction, which is information rather
   * than a failure. Empty until an estimate is taken.
   */
  estimatedTaxBreakdown: Array<OrderTaxEstimateJurisdictionDocument>;
  /**
   * Staff only; refused for customer-portal callers.
   * A fingerprint of the order as it stood when the estimate was taken. A reader that recomputes this
   * fingerprint from the order as it stands now and gets a different answer knows the order has moved
   * since, and shows the estimate as out of date rather than as current.
   */
  estimatedTaxInputsHash?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDate: Scalars['DateTime']['output'];
  finalCredit: Scalars['Boolean']['output'];
  /**
   * The named flat charges on the order (a pallet fee, for example), each billed once. Read-only on the
   * portal, which reads this same document through the orders query. Absent on an order projected
   * before charges existed, which reads as none.
   */
  flatCharges: Array<OrderFlatChargeDocument>;
  /** The sum of flatCharges, inside orderTotal like freight. Null until the order carries a charge. */
  flatChargesTotal?: Maybe<MoneyData>;
  /** The staff follow-up on this order's quote. Null when there is none. Staff only; refused for customer-portal callers. Kept on the order once it is submitted. Any move of the order out of draft (a submit, an acknowledge even of a line-less order, a ship, or a load dispatch even if it is later undone) stops a follow-up set before it, for good: after the order is reopened it still reads here as open, but quoteFollowUpsDue no longer lists it until its day, note, assignee or done flag is changed. A follow-up set or changed after a reopen reminds until the order next leaves draft. Saving it unchanged does not re-arm it. */
  followUp?: Maybe<OrderQuoteFollowUpDocument>;
  /** When the freight charge was last changed. */
  freightAdjustedAt: Scalars['DateTime']['output'];
  /** Staff only; refused for customer-portal callers. Who last changed the freight charge. */
  freightAdjustedBy: Scalars['String']['output'];
  /** The computed freight dollar amount. */
  freightChargeAmount?: Maybe<MoneyData>;
  /** The reason for the freight charge override. */
  freightChargeReason: Scalars['String']['output'];
  /** The freight charge type applied to this order. */
  freightChargeType?: Maybe<Scalars['Int']['output']>;
  /** The freight charge rate/amount configured on this order. */
  freightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  /**
   * What the load-written freight was built from. Null unless freightSource is LOAD, and always null for a
   * customer-portal caller.
   */
  freightProvenance?: Maybe<LoadFreightProvenanceDocument>;
  /**
   * Who decided the order's freight: INHERITED, MANUAL or LOAD (Apply freight). UNKNOWN when the freight was last
   * written before the source was recorded.
   */
  freightSource: FreightSource;
  /**
   * Order-level make-to-order rollup the Produce order-allocation queue filters on — true
   * when any line resolves to MAKE_TO_ORDER.
   * This is the per-line-derived replacement for produceAllocate as the queue trigger.
   * Seeded from produceAllocate by the OrderInitialized / OrderEdited / historical-import
   * arms (so existing produce-allocate orders are backfilled into the queue), then maintained from the
   * per-line sources by the LineItemsAdded / LineItemRemoved arms (absolute $set; legacy line
   * events carry a null rollup and skip the write, preserving the seeded value).
   */
  hasMakeToOrderLine: Scalars['Boolean']['output'];
  /**
   * Whether any of this order's delivery portions is currently recorded as a partial delivery —
   * visible on the order independent of its main status, per the dispatch/delivery ruling
   * (product decision task 05212e34). Backfilled on every pre-existing order by
   * orders-haspartialdelivery-backfill-v1.js, shipped with this PR: the C# default of
   * false reads correctly for a document missing the element, but [UseFiltering] /
   * [UseSorting] compile straight to a server-side Mongo query, and Mongo's $eq: false
   * does not match an absent element ($ne: false does) — so a filter or sort on this field
   * would have silently dropped every order that predates FULFILL Logistics dispatch/delivery.
   */
  hasPartialDelivery: Scalars['Boolean']['output'];
  /** Staff only; refused for customer-portal callers. The order's change history. */
  history: Array<Scalars['String']['output']>;
  /** When the hold was placed. Null when the order is not held, and always null for a customer-portal caller. */
  holdPlacedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email address of the user who placed the hold. Null when the order is not held. Staff only; refused for customer-portal callers. */
  holdPlacedBy?: Maybe<Scalars['String']['output']>;
  /** Why the order is held. Null when the order is not held, and always null for a customer-portal caller. */
  holdReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**
   * Staff only; refused for customer-portal callers.
   * The stable external sync key (Merge.dev invoice id) this order was imported under.
   * Indexed (TenantId, ImportId) so mergeOrder resolves create-vs-update by an ImportId
   * lookup rather than the deterministic OrderId it used to collide on. Empty for native orders
   * / those imported before ImportId existed. Distinct from ErpId.
   */
  importId: Scalars['String']['output'];
  initializedDate: Scalars['DateTime']['output'];
  /**
   * The id of the invoice raised against this order — the ACTIVE one where a bill still stands, and the
   * most recently withdrawn one where every bill has been. Null for an order that has never been billed.
   *
   * IT IDENTIFIES THE BILL, IT DOES NOT ASSERT ONE IS LIVE. That reading is invoiceStatus's, and the two
   * are deliberately separate: a voided order keeps this id so the withdrawn document can still be opened
   * from the row, and a re-issue overwrites it with the new bill's.
   */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /**
   * The invoice number of the bill raised against this order — what a person calls it. Null for an
   * order that has never been billed. Filterable and sortable.
   */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Where the order stands on being billed: never billed, billed and the bill still stands, or billed and
   * every bill withdrawn. Filterable and sortable.
   *
   * THE ONE AUTHORITY FOR THIS READING. It is stored here, on the order, and both order surfaces publish
   * it from storage — the combinedOrders grid AND the combinedOrders connection query, whose generated
   * filter and sort inputs carry it so the Fulfill CSV export can translate a grid filter onto them.
   * (OrderStateData still derives its own invoiceStatus through the invoice DataLoader; that surface is
   * out of this slice's scope and agrees with this one by construction, pinned by test.)
   *
   * UNKNOWN IS NEVER WRITTEN HERE. It is what a row predating this field reads as, and it is not a claim
   * that the order has never been billed — NOT_INVOICED is that claim, and the projection only makes it
   * for an order it has positively seen no live invoice for.
   */
  invoiceStatus: OrderInvoiceStatus;
  /**
   * Staff only; refused for customer-portal callers.
   * True for every order created by a history import, migration or not. Filter with eq: false to skip history (runs as $ne: true).
   */
  isHistoricalImport: Scalars['Boolean']['output'];
  itemIds: Scalars['String']['output'];
  /**
   * When an allocate or deallocate was last applied to this order; null when none ever has
   * been. This is what makes SHORT distinguishable from NOT_STARTED — an allocated
   * quantity of zero cannot tell "nobody tried" from "we tried and inventory came up short".
   * Mirrored from OrderState.LastAllocatedDate by the projection.
   */
  lastAllocatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The order's load factor — its rack count, for planning how much of a truck the order fills. The sum, across every line, of the line's eaches quantity times its item's configured load factor; never the pricing/handling-UOM quantity, which can be a tray or case count that would understate the racks. A line contributes only when BOTH its eaches quantity and its item's load factor were captured, so an item with no load factor contributes nothing rather than a zero. Null when NO line carries a load-factor-bearing item — an unknown rack count, which is not the same fact as an order that genuinely occupies no racks. Resolved live from the item read model, so it reflects load factors as configured today rather than as they stood when the order was placed. */
  loadFactor?: Maybe<Scalars['Decimal']['output']>;
  locations: OrderLocationDocumentData;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether a data migration imported the order as history. Set together with migrationSet and never cleared.
   * Filter with eq: true to select these orders and eq: false to skip them.
   */
  migrationHistorical: Scalars['Boolean']['output'];
  /**
   * Staff only; refused for customer-portal callers.
   * Whether the order's current status was set by a data migration. The next ordinary status change clears it.
   * Filter with eq: true to select these orders and eq: false to skip them.
   */
  migrationSet: Scalars['Boolean']['output'];
  /** What is still owed on this order once its credits are counted: balance less creditedTotal, in the order's currency — less only the part of each credit its credit memo has not already applied to an invoice (this order's or another's), so an applied memo is never subtracted twice. Null exactly when balance is null — nothing has been recorded against the order yet, which is not the same fact as nothing owed. */
  netAfterCredits?: Maybe<MoneyData>;
  /** Why staff marked this order No tax, from the same list as customer tax exemption certificates. Null when the order is not marked No tax. Portal (customer) users can read it, so a buyer sees the reason next to the tax on their order. The note and who set it are on noTax of order(orderId), which is staff only. */
  noTaxReason?: Maybe<CustomerTaxExemptionReason>;
  /**
   * The order's lines whose item carries Discountable = false. NOT a discount component:
   * nothing here is taken off the order. It is the record of which dollars a discretionary
   * discount may not be taken FROM, and it is what explains a percentage that came out smaller
   * than the headline rate. Empty means every line on the order is discountable.
   */
  nonDiscountableLines: Array<OrderNonDiscountableLineDocument>;
  /**
   * The sum of nonDiscountableLines in plain dollars — the amount withheld from the
   * customer/manual discount base. Null on orders written before the exclusion was recorded,
   * which reads as "no exclusion": the behaviour those orders were priced under.
   */
  nonDiscountableSubtotal?: Maybe<MoneyData>;
  numberOfLines: Scalars['Int']['output'];
  /** Whether the order is on hold. False for an order that was never held or whose hold was released, and always false for a customer-portal caller. */
  onHold: Scalars['Boolean']['output'];
  /**
   * The unit this order was placed in — whether the customer entered Shipping UOM units or
   * eaches. Stamped from the customer's effective setting when the order is created and never
   * changed afterwards, so a later change to that setting never restates a placed order. Orders
   * created before this was stamped read as SHIPPING_UOM, which is what they were.
   */
  orderEntryUnit: OrderEntryUnit;
  orderId: Scalars['String']['output'];
  /**
   * The id of the order's Order kind, from the tenant's Order kinds list. Set when the order is created and by
   * the setOrderKind mutation; null when it has none. Filter and group by kind use this id. The
   * kind's name is not stored: orderKindName resolves it at query time, so a rename needs no write here.
   */
  orderKindId?: Maybe<Scalars['String']['output']>;
  /** The current name of the order's Order kind, read from the tenant's Order kinds list, so a rename shows at once. Null when the order has no kind or the kind has been deleted. Filter by kind on orderKindId. */
  orderKindName?: Maybe<Scalars['String']['output']>;
  /**
   * Raw order-level typed notes (one current value per NoteContext), written by
   * the OrderEvents.V1.OrderNoteSet / OrderEvents.V1.OrderNoteCleared projection.
   * These are the order's own overrides only — effective-note inheritance (order → location →
   * customer) is resolved by a separate task. Empty until a note is set.
   */
  orderNotes: Array<OrderContextNoteDocument>;
  orderNumber: Scalars['String']['output'];
  orderStatus: OrderStatus;
  /** The order's grand total, royalty included. A customer-portal caller, from whom the royalty is withheld, reads the billed total instead, the figure combinedOrders gives that caller, and may not filter or sort the orders list on it. */
  orderTotal: MoneyData;
  orderType: OrderType;
  /**
   * The order's ORDER-WIDE volume discount component ("≥N units or ≥$X on the order ⇒ P% or $Y
   * off"), or null when the order's price group configures no rule or the order does not
   * reach its threshold. Feeds the totals card's itemised volume-discount breakdown alongside the
   * per-category rows.
   *
   * A second PLANE-2 component, distinct from both CategoryVolumeDiscounts and
   * DiscountAmount/DiscountPercent (the manual/customer discount). Stacking order:
   * line prices → category volume → order volume → customer/manual on the resulting net → tenant
   * cap. Every dollar figure here is PLAIN DOLLARS; ConfiguredValue alone carries the
   * rule's own convention (a percent value, or dollars for a flat rule) and is never a fraction.
   *
   *
   * null means the order reaches no threshold — which is also how the discount disappears
   * when a line is removed. The projection $sets the field absolutely from the event,
   * including to null, so it can never drift from the OrderTotal stamped by that
   * same event.
   */
  orderVolumeDiscount?: Maybe<OrderVolumeDiscountDocument>;
  /**
   * The customer this order belonged to before a customer combine moved it onto the customer it was
   * combined into; null when it was never moved.
   * Set once, so a chain of combines keeps the first customer.
   */
  originalCustomerId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the customer this order belonged to before a customer combine moved it, as that
   * customer was named when combined; null when it was never moved. What the screens show as
   * "from <original name>".
   */
  originalCustomerName?: Maybe<Scalars['String']['output']>;
  /**
   * The items this order named before an item combine moved its references to the item each was
   * combined into, space-separated like itemIds; null when no combine moved any. Reverting the
   * combine adds the item back to itemIds and takes it off this list; the kept item stays in
   * itemIds, so a search for it still finds the order.
   */
  originalItemIds?: Maybe<Scalars['String']['output']>;
  /**
   * The ship-to location id this order named before a combine moved it onto the ship-to it was combined
   * into (a ship-to combine, or a customer combine's "same as" ship-to) and re-pointed locations.id;
   * null when it was never moved. Set once, so a chain of combines keeps the first ship-to. The order's
   * ship-to name, code and address stay as they were when it was taken.
   */
  originalLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * The ship-to address id this order named before the same combine re-pointed locations.address.id;
   * null when it was never moved.
   */
  originalShipToId?: Maybe<Scalars['String']['output']>;
  overrideTotal?: Maybe<MoneyData>;
  /**
   * The order's payment standing. Once a LIVE invoice stands against the order this reports that
   * invoice's standing, because the bill is then what the customer owes; with no live invoice — never
   * billed, or every bill withdrawn — it is derived from the order's own amount paid versus its order
   * total, and reads UNPAID for an order that has never had a payment applied.
   *
   * ONE STORED READING, WRITTEN BY WHICHEVER AGGREGATE OWNS THE MONEY. The order's own payment events
   * write it while the order is unbilled; the INVOICE's events overwrite it the moment a bill is issued
   * and on every payment, adjustment, waiver and void thereafter — each carrying its own after-values, so
   * the projection only unpacks and $sets. Filtering and sorting therefore select by exactly what the
   * field publishes, with no divergence to disclose and no join to pay for.
   */
  paymentStatus: PaymentStatus;
  /**
   * The order's unified payment ledger — every payment and deposit applied to the order, in
   * apply order. Empty for orders that have never had a payment applied.
   */
  payments: Array<OrderPaymentEntryDocument>;
  /**
   * The order's PLANNED ship date — the date the load is scheduled to leave the building.
   * Deliberately distinct from shippedDate (actual, past-tense). Set or cleared by the
   * setOrderPlannedShipDate mutation; null until set, and null again once
   * cleared. Additive with no backfill, so every order that predates this field reads back
   * null. Filterable here (implicit binding), so the Planning window can query a
   * ship-date window directly instead of deriving it client-side from
   * ExpectedDeliveryDate minus a route's transit days.
   */
  plannedShipDate?: Maybe<Scalars['DateTime']['output']>;
  poNumber: Scalars['String']['output'];
  /**
   * How sales prices are entered and shown for this order: per each or per shipping unit. Prices are
   * always stored and billed per each. Stamped from the customer's effective setting when the order
   * was created and frozen: a later change to the company or customer setting never restates a
   * placed order. Orders placed before this existed read as EACH.
   */
  priceEntryUnit: PriceEntryUnit;
  /** Staff only; refused for customer-portal callers. The produce-allocation flag. */
  produceAllocate: Scalars['Boolean']['output'];
  /**
   * The order's Program, a name from the tenant's Programs list. Set when the order is created and by the
   * setOrderProgram mutation; null when it has none. Additive with no backfill, so every order
   * that predates it reads back null. Filterable, sortable and groupable.
   */
  program?: Maybe<Scalars['String']['output']>;
  /**
   * true when a prorate wrote acknowledged quantities while the order was Submitted and the order
   * has not been acknowledged since; false or null otherwise (null for an order never prorated, or
   * prorated before the field existed). Only true means prorated.
   */
  proratedWhileSubmitted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Staff only; refused for customer-portal callers.
   * Why the last QuickBooks export attempt did not get there. Null unless quickBooksExportStatus is
   * FAILED. Output only — a free-text diagnostic has no meaningful sort or set filter.
   */
  quickBooksExportError?: Maybe<Scalars['String']['output']>;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether the invoice raised against this order reached QuickBooks. NOT_EXPORTED for an order that has
   * never been billed, for a tenant with no accounting integration, and for an order whose export row is
   * the LEGACY ORDER export rather than an invoice export — that row's outcome was about the order, not
   * about a bill, and reading it as the invoice's would say a bill reached QuickBooks that was never sent.
   *
   * STORED ON THE ORDER for exactly the reason invoiceStatus beside it is: the Orders grid filters and
   * sorts on it server-side, and a join to the export read model per page is what that ruling exists to
   * avoid. Written by the export projection's mirror arm, never by the order's own arms.
   */
  quickBooksExportStatus: QuickBooksExportStatus;
  /**
   * Staff only; refused for customer-portal callers.
   * The id QuickBooks gave the invoice raised against this order, for opening it there. Null until an
   * export has succeeded, and kept afterwards so a later attempt cannot erase the pointer to a
   * QuickBooks invoice that already exists.
   */
  quickBooksRemoteInvoiceId?: Maybe<Scalars['String']['output']>;
  /**
   * The last day the quote on this order is valid, as a tenant-local date. Null when none is set.
   * Set and cleared by setOrderQuoteDetails while the order is a draft, and kept once it is submitted.
   */
  quoteValidUntil?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Staff only; refused for customer-portal callers.
   * Consecutive failed order→NAV sync attempts, mirrored from OrderState.RetryCount by the
   * projection. Non-null (defaults to 0) and seeded on order initialization so every order
   * carries the field — the sync worker's retryCount < N selection filter can only
   * exclude quarantined / over-threshold rows, never silently drop rows that lack the field.
   * Auto-exposed as retryCount: Int! plus its filter/sort inputs via BindFieldsImplicitly.
   */
  retryCount: Scalars['Int']['output'];
  /**
   * Order-level route override — tier 1 of the hierarchical route setting. Free-text scalar; set
   * or cleared by V1.RouteUpdated. null until an override is set. Mirrors
   * Carrier's shape/semantics.
   */
  route?: Maybe<Scalars['String']['output']>;
  /**
   * Order-level aggregate royalty — the sum of every line's frozen royalty snapshot
   * (LineItem.Royalty.Amount), sourced from OrderState.CalculateRoyalty. A plain
   * dollar amount (not a percent/fraction). Changes only when lines are added or removed — a
   * line's royalty is frozen at add time and never re-derived by quantity/price edits. Null until
   * the order's first line-item event projects it; zero for a historical (GrowPoint) import,
   * which carries no per-line royalty snapshot to sum.
   */
  royalty?: Maybe<MoneyData>;
  salesPerson?: Maybe<Scalars['String']['output']>;
  /**
   * Order-level override for the invoice-email toggle.
   * null means inherit from location/customer. Cascade resolved at read time
   * as order ?? location ?? customer, through the invoice's order.
   */
  sendInvoiceEmails?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Order-level override for the order-confirmation-email toggle.
   * null means inherit from location/customer. Cascade resolved at read time
   * as order ?? location ?? customer.
   */
  sendOrderEmails?: Maybe<Scalars['Boolean']['output']>;
  /** SiteLocationId of the site that services this order's SHIP-TO customer location, read live from the customer-location read model. Empty when the ship-to has no servicing site assigned, or when the order has no ship-to location. Exposed here so the order-email workers can resolve a ship-to's servicing site from the same orders query they already read. Distinct from shipFromSiteLocationId, which is the site the order ships FROM. */
  servicingSiteLocationId: Scalars['String']['output'];
  /**
   * The order's structured ship-from site — the WorkSuite-native SiteLocationId the FULFILL
   * container / ContainerConfig keys on. Set at creation from V3.OrderInitialized and
   * updated by V1.ShipFromSiteSet. Empty for orders that never carried a structured ship-from
   * site (legacy / pre-V3 streams); no backfill. Denormalized alongside ShipFromSiteName.
   */
  shipFromSiteLocationId: Scalars['String']['output'];
  /**
   * Denormalized display name of ShipFromSiteLocationId, resolved from the SiteLocation
   * read model at projection-write time (the CustomerName denormalization pattern) so the
   * combinedOrders grid renders, sorts, filters, and groups Ship-From Site without a per-row
   * lookup. Empty when no ship-from site is set or the id no longer resolves to a name.
   */
  shipFromSiteName: Scalars['String']['output'];
  shippedDate?: Maybe<Scalars['DateTime']['output']>;
  signatureImage?: Maybe<SignatureImageData>;
  /**
   * Where the order was created from. Set once when the order is created and never changed
   * afterwards. Orders created before this field existed, and orders whose origin was never
   * recorded, read as UNKNOWN — that value is never guessed at. Filterable and sortable.
   */
  source: OrderSource;
  /**
   * First moment the order entered an active state (Submitted / Acknowledged / Picked /
   * Shipped). Cleared back to null on re-open (Initialized / Open). Mirrors
   * OrderState.SubmittedAt apply-arm semantics so the document and the entity stay in
   * lockstep.
   */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Line items total before freight and discounts. Re-stamped by every event that can move it:
   * discount, override total, freight, and any line-item change (add, quantity update, merge,
   * removal, override price, reprice). Null until the first such event projects it.
   */
  subtotal?: Maybe<MoneyData>;
  /** Staff only; refused for customer-portal callers. When the order last synced to the accounting system. */
  syncDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The order's header Tag color, by tag color id, or null when none is set. A color deleted after it
   * was chosen stays here. Every order that predates this field reads back null.
   */
  tagColorId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  /**
   * Snapshot of the Terms record's discount percentage as a fraction (0.02 = 2%),
   * captured at OrderInitialized / OrderEdited time. Null when the order has no Terms
   * assigned.
   */
  termsAccrueInterestPercentage?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Snapshot of the Terms record's early-pay-discount window in days, captured at
   * OrderInitialized / OrderEdited time. Null when the order has no Terms assigned.
   * Used together with TermsAccrueInterestPercentage and
   * ExpectedDeliveryDate to derive the customer-facing discount message.
   */
  termsDiscountDays?: Maybe<Scalars['Int']['output']>;
  /** Customer-facing early-pay incentive message derived from the order's Terms snapshot, ExpectedDeliveryDate, and computed OrderTotal. Null when the order has no Terms assigned, or when DiscountDays/AccrueInterestPercentage is zero. */
  termsDiscountMessage?: Maybe<Scalars['String']['output']>;
  termsId?: Maybe<Scalars['String']['output']>;
  /**
   * Snapshot of the Terms record's net-due window in days, captured at OrderInitialized /
   * OrderEdited time. Null when the order has no Terms assigned.
   */
  termsTermLimitDays?: Maybe<Scalars['Int']['output']>;
  /**
   * The order's LIVE volume-pool standing (FULFILL Pooled Pricing) — one row per pool with at
   * least one line counting toward it, whether or not that pool has reached a break.
   *
   * This is what the totals card and the "why this price?" popover read to render "504 of 1,008
   * quarts — 3 lines pooled". The per-line volumePoolId cannot answer it: a line knows
   * which pool it is in and nothing about how much the pool has summed or what the next break is.
   *
   *
   * Carries no money that any total is derived from — a pooled line's earned rung is already its
   * own price, so pool savings are never a discount row and orderTotal is unaffected
   * by every value here.
   *
   *
   * The projection $sets the whole array absolutely from
   * V1.OrderVolumePoolProgressCalculated, which the pooled pass appends whenever the
   * standing moved — including on a pass that restated no price, which is exactly what a quantity
   * edit inside a rung does. Empty means no line counts toward any pool, which is every order
   * written before the pooled pass existed.
   */
  volumePoolProgress: Array<OrderVolumePoolProgressDocument>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC. Persisted so the
   * Orders grid can filter and sort Week Number server-side; mirrors the client's
   * getISOWeek(expectedDeliveryDate) derivation.
   */
  weekNumber: Scalars['Int']['output'];
};

/** MongoDB document representing an order. */
export type OrdersDocumentFilterInput = {
  acknowledgmentEmail?: InputMaybe<ConfirmationEmailDataFilterInput>;
  /**
   * Which sender owns this order's acknowledgment email: LEGACY, DISPATCH, or UNKNOWN while no
   * acknowledgment has triggered for it.
   */
  acknowledgmentEmailRoute?: InputMaybe<CustomerEmailRouteOperationFilterInput>;
  adjustedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Staff only; refused for customer-portal callers. */
  adjustedBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Order-level allocation rollup so the FULFILL orders grid can answer "which orders still need
   * allocating?" without opening each order. Maintained by every allocate / deallocate /
   * make-to-order-reflection / line-item event as an absolute $set carried on the event
   * (legacy events carry no rollup and skip the write, preserving the last stamped value).
   * null on any order written before this rollup existed: no allocation status had been
   * derived for it until the one-time Mongo backfill stamped it. null is deliberately a
   * DIFFERENT answer from NOT_STARTED — "this order's status has not been worked out" is not
   * the same fact as "nobody has tried to allocate this order".
   */
  allocationStatus?: InputMaybe<NullableOfOrderAllocationStatusOperationFilterInput>;
  /**
   * What has been received against the order. Once a LIVE invoice stands against it this is the cash
   * recorded on that invoice; otherwise it is the total of every ledger entry (payments and deposits)
   * applied to the order, which is null until the first payment event is projected. Written by the same
   * two sources as paymentStatus, and filterable and sortable for the same reason.
   */
  amountPaid?: InputMaybe<OptionOfMoneyDataFilterInput>;
  and?: InputMaybe<Array<OrdersDocumentFilterInput>>;
  /**
   * The order's outstanding balance. Once a LIVE invoice stands against it this is that invoice's open
   * balance; otherwise it is the order total less the amount paid, and is NULL until the first payment
   * event is projected. A null balance means nothing has been recorded against the order yet — it is
   * NOT a zero balance, and rendering it as 0 asserts the order is settled when it may never even have
   * been billed. Voiding the only live bill returns it to null for exactly that reason: nothing is
   * billed again until a new invoice is issued. Written by the same two sources as paymentStatus, and
   * filterable and sortable for the same reason.
   */
  balance?: InputMaybe<OptionOfMoneyDataFilterInput>;
  billingAddress?: InputMaybe<AddressDataFilterInput>;
  /**
   * Order-level carrier (ENS). Plain optional string — not a managed carrier
   * master/aggregate. Set at creation from V3.OrderInitialized (an explicit override,
   * or the customer's inherited default) and re-stamped by V2.OrderEdited. Empty string
   * when no carrier is set on V3+ orders; null only for legacy orders created before
   * this field existed.
   */
  carrier?: InputMaybe<StringOperationFilterInput>;
  /**
   * The order's tier-derived CATEGORY VOLUME discount components — one row per category whose
   * CategoryVolume tier the order's summed quantity qualified for. Feeds the PWA's "why this
   * price?" popover ("2,550/2,550 ✓, 6 contributing lines").
   *
   * A PLANE-2 component, distinct from DiscountAmount/DiscountPercent
   * (the manual/customer discount), which it never touches. The two stack in a fixed order:
   * line prices → category volume → customer/manual on the resulting net → tenant cap. Every
   * amount here is PLAIN DOLLARS, never a percent or fraction.
   *
   *
   * Empty means the order qualifies for no tier — which is also how the discount disappears when
   * a line is removed below a threshold. The projection $sets the whole array absolutely from the
   * event, so it can never drift from the OrderTotal stamped by the same event.
   */
  categoryVolumeDiscounts?: InputMaybe<ListFilterInputTypeOfOrderCategoryVolumeDiscountDocumentFilterInput>;
  /**
   * LIVE per-category progress toward the order's CategoryVolume tiers — one row per category
   * that has a usable tier configured and at least one item on this order, present WHETHER OR NOT
   * any tier is currently reached.
   *
   * This is the field the "why this price?" popover reads to render the not-yet-reached case
   * ("1,700 / 2,550 — 850 more units to reach the $0.99 tier").
   * CategoryVolumeDiscounts cannot answer that question: it holds only categories that
   * already qualified AND saved money, so the category a customer is closest to buying into is
   * precisely the one missing from it.
   *
   *
   * Carries no money that any total is derived from — OrderTotal is unaffected by every
   * value here. QualifyingQuantity is the SAME number the discount qualified against,
   * produced by the same kernel pass under the same exclusions (item-priced, overridden and
   * non-discountable lines omitted), so a tier this promises is a tier the order will actually
   * receive.
   *
   *
   * Empty means no reachable tier is configured for anything on the order — NOT that the order
   * qualifies for nothing. An order that qualifies for nothing has rows here, each with
   * qualified: false. The projection $sets the whole array absolutely from the same
   * event that stamps the discounts, so the two can never be one mutation apart.
   */
  categoryVolumeProgress?: InputMaybe<ListFilterInputTypeOfOrderCategoryVolumeProgressDocumentFilterInput>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataFilterInput>;
  /**
   * Which sender owns this order's confirmation email: LEGACY, DISPATCH, or UNKNOWN while no
   * confirmation has triggered for it.
   */
  confirmationEmailRoute?: InputMaybe<CustomerEmailRouteOperationFilterInput>;
  /**
   * The ORDER's shipping container — a ContainerConfig.ContainerCode. Set or cleared by
   * V1.OrderContainerSet; null until a container is set, and null again once
   * cleared. Additive with no backfill, so every order that predates this field reads back
   * null. Mirrors Route's shape/semantics.
   *
   * The OUTER container the load ships on — distinct from the per-line container code carried on
   * LineItems[].ContainerCode, which it never cascades to.
   */
  containerCode?: InputMaybe<StringOperationFilterInput>;
  /** Correction linkage when this order was created by correctOrder; null for ordinary orders. */
  correction?: InputMaybe<OrderCorrectionDataFilterInput>;
  /**
   * OrderId of the source order this Credit order was created from by the dedicated
   * credit-existing-order flow (V1.OrderCreditedFromSource). Null for every other
   * order.
   */
  creditedFromOrderId?: InputMaybe<StringOperationFilterInput>;
  /**
   * OrderNumber of the source order this Credit order was created from, captured for
   * display so grids never need a second lookup. Null for every other order.
   */
  creditedFromOrderNumber?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  /**
   * The reason a delivery attempt on this order failed, when its status reads failed delivery.
   * None otherwise. No backfill: None for every order until FULFILL Logistics
   * dispatch and delivery write into the order stream.
   */
  deliveryFailureReason?: InputMaybe<OptionOfStringFilterInput>;
  discountAmount?: InputMaybe<MoneyDataFilterInput>;
  discountPercent?: InputMaybe<PercentValueOperationFilterInput>;
  discountReason?: InputMaybe<StringOperationFilterInput>;
  /**
   * Where planning ships and pins the load instead of the order's ship-to location, which this
   * never touches. Null when no destination is set. Set or cleared by the
   * setOrderDropShipDestination / clearOrderDropShipDestination mutations.
   */
  dropShipDestination?: InputMaybe<OptionOfOrderDropShipDestinationDataFilterInput>;
  /**
   * The resolved dollar value of the MANUAL/customer discount actually subtracted — a positive
   * flat DiscountAmount wins outright, otherwise the percent is applied to the
   * subtotal NET of CategoryVolumeDiscounts, which stack ahead of it (line prices →
   * category volume → customer/manual on the net). It is therefore measured against
   * Subtotal − CategoryVolumeDiscounts, not against Subtotal itself; the two
   * bases coincide only on an order that qualifies for no tier. A plain dollar amount (NOT a
   * percent or fraction — unlike DiscountPercent, which is surfaced as a percent,
   * this mirrors DiscountAmount's convention). Sourced from
   * OrderState.CalculateEffectiveDiscountAmount — the same kernel
   * OrderState.CalculateOrderTotal folds into every computed total, so this field never
   * diverges from what was actually subtracted. Re-stamped alongside Subtotal by the
   * same event set (a percent discount's dollar value moves whenever the subtotal does). Null
   * until the first such event projects it.
   */
  effectiveDiscountAmount?: InputMaybe<MoneyDataFilterInput>;
  /**
   * Denormalized effective route the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveRouteResolver using the canonical precedence (direct Route
   * → ship-to Locations.Route snapshot → inherited customer-location → customer →
   * tenant-default route). null when nothing resolves. Re-stamped by
   * EffectiveRouteReStamper when an upstream tier changes.
   */
  effectiveRoute?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized terms id the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveTermsIdResolver using the canonical 3-tier precedence (direct
   * TermsId → ship-to Locations.TermsId snapshot → inherited
   * customer-location → customer → tenant-default terms). null when nothing resolves.
   * Empty strings on the source tiers are treated as absent (legacy JS-truthiness).
   */
  effectiveTermsId?: InputMaybe<StringOperationFilterInput>;
  /** Staff only; refused for customer-portal callers. The accounting-system code of the order. */
  erpId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The total sales tax Stripe estimated for this order, as of the last time an estimate was taken.
   * Zero and meaningless unless estimatedTaxAt is set — read that first. Always an estimate: it is
   * never charged, never part of the order total, and the bill's real tax is settled when the order
   * is invoiced on what actually shipped.
   */
  estimatedTaxAmount?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * When the estimate was taken, or null when none ever has been. This is the field that says whether
   * an estimate exists at all.
   */
  estimatedTaxAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The estimated tax broken down by jurisdiction, one row per jurisdiction, rate and reason. A zero
   * row means the seller holds no tax registration in that jurisdiction, which is information rather
   * than a failure. Empty until an estimate is taken.
   */
  estimatedTaxBreakdown?: InputMaybe<ListFilterInputTypeOfOrderTaxEstimateJurisdictionDocumentFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * A fingerprint of the order as it stood when the estimate was taken. A reader that recomputes this
   * fingerprint from the order as it stands now and gets a different answer knows the order has moved
   * since, and shows the estimate as out of date rather than as current.
   */
  estimatedTaxInputsHash?: InputMaybe<StringOperationFilterInput>;
  expectedDeliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  finalCredit?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The named flat charges on the order (a pallet fee, for example), each billed once. Read-only on the
   * portal, which reads this same document through the orders query. Absent on an order projected
   * before charges existed, which reads as none.
   */
  flatCharges?: InputMaybe<ListFilterInputTypeOfOrderFlatChargeDocumentFilterInput>;
  /** The sum of flatCharges, inside orderTotal like freight. Null until the order carries a charge. */
  flatChargesTotal?: InputMaybe<MoneyDataFilterInput>;
  /** When the freight charge was last changed. */
  freightAdjustedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Staff only; refused for customer-portal callers. Who last changed the freight charge. */
  freightAdjustedBy?: InputMaybe<StringOperationFilterInput>;
  /** The computed freight dollar amount. */
  freightChargeAmount?: InputMaybe<MoneyDataFilterInput>;
  /** The reason for the freight charge override. */
  freightChargeReason?: InputMaybe<StringOperationFilterInput>;
  /** The freight charge type applied to this order. */
  freightChargeType?: InputMaybe<IntOperationFilterInput>;
  /** The freight charge rate/amount configured on this order. */
  freightChargeValue?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Who decided the order's freight: INHERITED, MANUAL or LOAD (Apply freight). UNKNOWN when the freight was last
   * written before the source was recorded.
   */
  freightSource?: InputMaybe<FreightSourceOperationFilterInput>;
  /**
   * Order-level make-to-order rollup the Produce order-allocation queue filters on — true
   * when any line resolves to MAKE_TO_ORDER.
   * This is the per-line-derived replacement for produceAllocate as the queue trigger.
   * Seeded from produceAllocate by the OrderInitialized / OrderEdited / historical-import
   * arms (so existing produce-allocate orders are backfilled into the queue), then maintained from the
   * per-line sources by the LineItemsAdded / LineItemRemoved arms (absolute $set; legacy line
   * events carry a null rollup and skip the write, preserving the seeded value).
   */
  hasMakeToOrderLine?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Whether any of this order's delivery portions is currently recorded as a partial delivery —
   * visible on the order independent of its main status, per the dispatch/delivery ruling
   * (product decision task 05212e34). Backfilled on every pre-existing order by
   * orders-haspartialdelivery-backfill-v1.js, shipped with this PR: the C# default of
   * false reads correctly for a document missing the element, but [UseFiltering] /
   * [UseSorting] compile straight to a server-side Mongo query, and Mongo's $eq: false
   * does not match an absent element ($ne: false does) — so a filter or sort on this field
   * would have silently dropped every order that predates FULFILL Logistics dispatch/delivery.
   */
  hasPartialDelivery?: InputMaybe<BooleanOperationFilterInput>;
  /** Staff only; refused for customer-portal callers. The order's change history. */
  history?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * The stable external sync key (Merge.dev invoice id) this order was imported under.
   * Indexed (TenantId, ImportId) so mergeOrder resolves create-vs-update by an ImportId
   * lookup rather than the deterministic OrderId it used to collide on. Empty for native orders
   * / those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  initializedDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The id of the invoice raised against this order — the ACTIVE one where a bill still stands, and the
   * most recently withdrawn one where every bill has been. Null for an order that has never been billed.
   *
   * IT IDENTIFIES THE BILL, IT DOES NOT ASSERT ONE IS LIVE. That reading is invoiceStatus's, and the two
   * are deliberately separate: a voided order keeps this id so the withdrawn document can still be opened
   * from the row, and a re-issue overwrites it with the new bill's.
   */
  invoiceId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The invoice number of the bill raised against this order — what a person calls it. Null for an
   * order that has never been billed. Filterable and sortable.
   */
  invoiceNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * Where the order stands on being billed: never billed, billed and the bill still stands, or billed and
   * every bill withdrawn. Filterable and sortable.
   *
   * THE ONE AUTHORITY FOR THIS READING. It is stored here, on the order, and both order surfaces publish
   * it from storage — the combinedOrders grid AND the combinedOrders connection query, whose generated
   * filter and sort inputs carry it so the Fulfill CSV export can translate a grid filter onto them.
   * (OrderStateData still derives its own invoiceStatus through the invoice DataLoader; that surface is
   * out of this slice's scope and agrees with this one by construction, pinned by test.)
   *
   * UNKNOWN IS NEVER WRITTEN HERE. It is what a row predating this field reads as, and it is not a claim
   * that the order has never been billed — NOT_INVOICED is that claim, and the projection only makes it
   * for an order it has positively seen no live invoice for.
   */
  invoiceStatus?: InputMaybe<OrderInvoiceStatusOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * True for every order created by a history import, migration or not. Filter with eq: false to skip history (runs as $ne: true).
   */
  isHistoricalImport?: InputMaybe<AbsentAsFalseBooleanOperationFilterInput>;
  itemIds?: InputMaybe<StringOperationFilterInput>;
  /**
   * When an allocate or deallocate was last applied to this order; null when none ever has
   * been. This is what makes SHORT distinguishable from NOT_STARTED — an allocated
   * quantity of zero cannot tell "nobody tried" from "we tried and inventory came up short".
   * Mirrored from OrderState.LastAllocatedDate by the projection.
   */
  lastAllocatedDate?: InputMaybe<DateTimeOperationFilterInput>;
  locations?: InputMaybe<OrderLocationDocumentDataFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether a data migration imported the order as history. Set together with migrationSet and never cleared.
   * Filter with eq: true to select these orders and eq: false to skip them.
   */
  migrationHistorical?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether the order's current status was set by a data migration. The next ordinary status change clears it.
   * Filter with eq: true to select these orders and eq: false to skip them.
   */
  migrationSet?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The order's lines whose item carries Discountable = false. NOT a discount component:
   * nothing here is taken off the order. It is the record of which dollars a discretionary
   * discount may not be taken FROM, and it is what explains a percentage that came out smaller
   * than the headline rate. Empty means every line on the order is discountable.
   */
  nonDiscountableLines?: InputMaybe<ListFilterInputTypeOfOrderNonDiscountableLineDocumentFilterInput>;
  /**
   * The sum of nonDiscountableLines in plain dollars — the amount withheld from the
   * customer/manual discount base. Null on orders written before the exclusion was recorded,
   * which reads as "no exclusion": the behaviour those orders were priced under.
   */
  nonDiscountableSubtotal?: InputMaybe<MoneyDataFilterInput>;
  numberOfLines?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OrdersDocumentFilterInput>>;
  /**
   * The unit this order was placed in — whether the customer entered Shipping UOM units or
   * eaches. Stamped from the customer's effective setting when the order is created and never
   * changed afterwards, so a later change to that setting never restates a placed order. Orders
   * created before this was stamped read as SHIPPING_UOM, which is what they were.
   */
  orderEntryUnit?: InputMaybe<OrderEntryUnitOperationFilterInput>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The id of the order's Order kind, from the tenant's Order kinds list. Set when the order is created and by
   * the setOrderKind mutation; null when it has none. Filter and group by kind use this id. The
   * kind's name is not stored: orderKindName resolves it at query time, so a rename needs no write here.
   */
  orderKindId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Raw order-level typed notes (one current value per NoteContext), written by
   * the OrderEvents.V1.OrderNoteSet / OrderEvents.V1.OrderNoteCleared projection.
   * These are the order's own overrides only — effective-note inheritance (order → location →
   * customer) is resolved by a separate task. Empty until a note is set.
   */
  orderNotes?: InputMaybe<ListFilterInputTypeOfOrderContextNoteDocumentFilterInput>;
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  orderStatus?: InputMaybe<OrderStatusOperationFilterInput>;
  orderTotal?: InputMaybe<MoneyDataFilterInput>;
  orderType?: InputMaybe<OrderTypeOperationFilterInput>;
  /**
   * The order's ORDER-WIDE volume discount component ("≥N units or ≥$X on the order ⇒ P% or $Y
   * off"), or null when the order's price group configures no rule or the order does not
   * reach its threshold. Feeds the totals card's itemised volume-discount breakdown alongside the
   * per-category rows.
   *
   * A second PLANE-2 component, distinct from both CategoryVolumeDiscounts and
   * DiscountAmount/DiscountPercent (the manual/customer discount). Stacking order:
   * line prices → category volume → order volume → customer/manual on the resulting net → tenant
   * cap. Every dollar figure here is PLAIN DOLLARS; ConfiguredValue alone carries the
   * rule's own convention (a percent value, or dollars for a flat rule) and is never a fraction.
   *
   *
   * null means the order reaches no threshold — which is also how the discount disappears
   * when a line is removed. The projection $sets the field absolutely from the event,
   * including to null, so it can never drift from the OrderTotal stamped by that
   * same event.
   */
  orderVolumeDiscount?: InputMaybe<OrderVolumeDiscountDocumentFilterInput>;
  /**
   * The customer this order belonged to before a customer combine moved it onto the customer it was
   * combined into; null when it was never moved.
   * Set once, so a chain of combines keeps the first customer.
   */
  originalCustomerId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The name of the customer this order belonged to before a customer combine moved it, as that
   * customer was named when combined; null when it was never moved. What the screens show as
   * "from <original name>".
   */
  originalCustomerName?: InputMaybe<StringOperationFilterInput>;
  /**
   * The items this order named before an item combine moved its references to the item each was
   * combined into, space-separated like itemIds; null when no combine moved any. Reverting the
   * combine adds the item back to itemIds and takes it off this list; the kept item stays in
   * itemIds, so a search for it still finds the order.
   */
  originalItemIds?: InputMaybe<StringOperationFilterInput>;
  /**
   * The ship-to location id this order named before a combine moved it onto the ship-to it was combined
   * into (a ship-to combine, or a customer combine's "same as" ship-to) and re-pointed locations.id;
   * null when it was never moved. Set once, so a chain of combines keeps the first ship-to. The order's
   * ship-to name, code and address stay as they were when it was taken.
   */
  originalLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The ship-to address id this order named before the same combine re-pointed locations.address.id;
   * null when it was never moved.
   */
  originalShipToId?: InputMaybe<StringOperationFilterInput>;
  overrideTotal?: InputMaybe<MoneyDataFilterInput>;
  /**
   * The order's payment standing. Once a LIVE invoice stands against the order this reports that
   * invoice's standing, because the bill is then what the customer owes; with no live invoice — never
   * billed, or every bill withdrawn — it is derived from the order's own amount paid versus its order
   * total, and reads UNPAID for an order that has never had a payment applied.
   *
   * ONE STORED READING, WRITTEN BY WHICHEVER AGGREGATE OWNS THE MONEY. The order's own payment events
   * write it while the order is unbilled; the INVOICE's events overwrite it the moment a bill is issued
   * and on every payment, adjustment, waiver and void thereafter — each carrying its own after-values, so
   * the projection only unpacks and $sets. Filtering and sorting therefore select by exactly what the
   * field publishes, with no divergence to disclose and no join to pay for.
   */
  paymentStatus?: InputMaybe<PaymentStatusOperationFilterInput>;
  /**
   * The order's unified payment ledger — every payment and deposit applied to the order, in
   * apply order. Empty for orders that have never had a payment applied.
   */
  payments?: InputMaybe<ListFilterInputTypeOfOrderPaymentEntryDocumentFilterInput>;
  /**
   * The order's PLANNED ship date — the date the load is scheduled to leave the building.
   * Deliberately distinct from shippedDate (actual, past-tense). Set or cleared by the
   * setOrderPlannedShipDate mutation; null until set, and null again once
   * cleared. Additive with no backfill, so every order that predates this field reads back
   * null. Filterable here (implicit binding), so the Planning window can query a
   * ship-date window directly instead of deriving it client-side from
   * ExpectedDeliveryDate minus a route's transit days.
   */
  plannedShipDate?: InputMaybe<DateTimeOperationFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * How sales prices are entered and shown for this order: per each or per shipping unit. Prices are
   * always stored and billed per each. Stamped from the customer's effective setting when the order
   * was created and frozen: a later change to the company or customer setting never restates a
   * placed order. Orders placed before this existed read as EACH.
   */
  priceEntryUnit?: InputMaybe<PriceEntryUnitOperationFilterInput>;
  /** Staff only; refused for customer-portal callers. The produce-allocation flag. */
  produceAllocate?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The order's Program, a name from the tenant's Programs list. Set when the order is created and by the
   * setOrderProgram mutation; null when it has none. Additive with no backfill, so every order
   * that predates it reads back null. Filterable, sortable and groupable.
   */
  program?: InputMaybe<StringOperationFilterInput>;
  /**
   * true when a prorate wrote acknowledged quantities while the order was Submitted and the order
   * has not been acknowledged since; false or null otherwise (null for an order never prorated, or
   * prorated before the field existed). Only true means prorated.
   */
  proratedWhileSubmitted?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * Why the last QuickBooks export attempt did not get there. Null unless quickBooksExportStatus is
   * FAILED. Output only — a free-text diagnostic has no meaningful sort or set filter.
   */
  quickBooksExportError?: InputMaybe<StringOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether the invoice raised against this order reached QuickBooks. NOT_EXPORTED for an order that has
   * never been billed, for a tenant with no accounting integration, and for an order whose export row is
   * the LEGACY ORDER export rather than an invoice export — that row's outcome was about the order, not
   * about a bill, and reading it as the invoice's would say a bill reached QuickBooks that was never sent.
   *
   * STORED ON THE ORDER for exactly the reason invoiceStatus beside it is: the Orders grid filters and
   * sorts on it server-side, and a join to the export read model per page is what that ruling exists to
   * avoid. Written by the export projection's mirror arm, never by the order's own arms.
   */
  quickBooksExportStatus?: InputMaybe<QuickBooksExportStatusOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * The id QuickBooks gave the invoice raised against this order, for opening it there. Null until an
   * export has succeeded, and kept afterwards so a later attempt cannot erase the pointer to a
   * QuickBooks invoice that already exists.
   */
  quickBooksRemoteInvoiceId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The last day the quote on this order is valid, as a tenant-local date. Null when none is set.
   * Set and cleared by setOrderQuoteDetails while the order is a draft, and kept once it is submitted.
   */
  quoteValidUntil?: InputMaybe<LocalDateOperationFilterInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * Consecutive failed order→NAV sync attempts, mirrored from OrderState.RetryCount by the
   * projection. Non-null (defaults to 0) and seeded on order initialization so every order
   * carries the field — the sync worker's retryCount < N selection filter can only
   * exclude quarantined / over-threshold rows, never silently drop rows that lack the field.
   * Auto-exposed as retryCount: Int! plus its filter/sort inputs via BindFieldsImplicitly.
   */
  retryCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * Order-level route override — tier 1 of the hierarchical route setting. Free-text scalar; set
   * or cleared by V1.RouteUpdated. null until an override is set. Mirrors
   * Carrier's shape/semantics.
   */
  route?: InputMaybe<StringOperationFilterInput>;
  salesPerson?: InputMaybe<StringOperationFilterInput>;
  /**
   * Order-level override for the invoice-email toggle.
   * null means inherit from location/customer. Cascade resolved at read time
   * as order ?? location ?? customer, through the invoice's order.
   */
  sendInvoiceEmails?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Order-level override for the order-confirmation-email toggle.
   * null means inherit from location/customer. Cascade resolved at read time
   * as order ?? location ?? customer.
   */
  sendOrderEmails?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The order's structured ship-from site — the WorkSuite-native SiteLocationId the FULFILL
   * container / ContainerConfig keys on. Set at creation from V3.OrderInitialized and
   * updated by V1.ShipFromSiteSet. Empty for orders that never carried a structured ship-from
   * site (legacy / pre-V3 streams); no backfill. Denormalized alongside ShipFromSiteName.
   */
  shipFromSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized display name of ShipFromSiteLocationId, resolved from the SiteLocation
   * read model at projection-write time (the CustomerName denormalization pattern) so the
   * combinedOrders grid renders, sorts, filters, and groups Ship-From Site without a per-row
   * lookup. Empty when no ship-from site is set or the id no longer resolves to a name.
   */
  shipFromSiteName?: InputMaybe<StringOperationFilterInput>;
  shippedDate?: InputMaybe<DateTimeOperationFilterInput>;
  signatureImage?: InputMaybe<SignatureImageDataFilterInput>;
  /**
   * Where the order was created from. Set once when the order is created and never changed
   * afterwards. Orders created before this field existed, and orders whose origin was never
   * recorded, read as UNKNOWN — that value is never guessed at. Filterable and sortable.
   */
  source?: InputMaybe<OrderSourceOperationFilterInput>;
  /**
   * First moment the order entered an active state (Submitted / Acknowledged / Picked /
   * Shipped). Cleared back to null on re-open (Initialized / Open). Mirrors
   * OrderState.SubmittedAt apply-arm semantics so the document and the entity stay in
   * lockstep.
   */
  submittedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Line items total before freight and discounts. Re-stamped by every event that can move it:
   * discount, override total, freight, and any line-item change (add, quantity update, merge,
   * removal, override price, reprice). Null until the first such event projects it.
   */
  subtotal?: InputMaybe<MoneyDataFilterInput>;
  /** Staff only; refused for customer-portal callers. When the order last synced to the accounting system. */
  syncDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The order's header Tag color, by tag color id, or null when none is set. A color deleted after it
   * was chosen stays here. Every order that predates this field reads back null.
   */
  tagColorId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Snapshot of the Terms record's discount percentage as a fraction (0.02 = 2%),
   * captured at OrderInitialized / OrderEdited time. Null when the order has no Terms
   * assigned.
   */
  termsAccrueInterestPercentage?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Snapshot of the Terms record's early-pay-discount window in days, captured at
   * OrderInitialized / OrderEdited time. Null when the order has no Terms assigned.
   * Used together with TermsAccrueInterestPercentage and
   * ExpectedDeliveryDate to derive the customer-facing discount message.
   */
  termsDiscountDays?: InputMaybe<IntOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Snapshot of the Terms record's net-due window in days, captured at OrderInitialized /
   * OrderEdited time. Null when the order has no Terms assigned.
   */
  termsTermLimitDays?: InputMaybe<IntOperationFilterInput>;
  /**
   * The order's LIVE volume-pool standing (FULFILL Pooled Pricing) — one row per pool with at
   * least one line counting toward it, whether or not that pool has reached a break.
   *
   * This is what the totals card and the "why this price?" popover read to render "504 of 1,008
   * quarts — 3 lines pooled". The per-line volumePoolId cannot answer it: a line knows
   * which pool it is in and nothing about how much the pool has summed or what the next break is.
   *
   *
   * Carries no money that any total is derived from — a pooled line's earned rung is already its
   * own price, so pool savings are never a discount row and orderTotal is unaffected
   * by every value here.
   *
   *
   * The projection $sets the whole array absolutely from
   * V1.OrderVolumePoolProgressCalculated, which the pooled pass appends whenever the
   * standing moved — including on a pass that restated no price, which is exactly what a quantity
   * edit inside a rung does. Empty means no line counts toward any pool, which is every order
   * written before the pooled pass existed.
   */
  volumePoolProgress?: InputMaybe<ListFilterInputTypeOfOrderVolumePoolProgressDocumentFilterInput>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC. Persisted so the
   * Orders grid can filter and sort Week Number server-side; mirrors the client's
   * getISOWeek(expectedDeliveryDate) derivation.
   */
  weekNumber?: InputMaybe<IntOperationFilterInput>;
};

/** MongoDB document representing an order. */
export type OrdersDocumentSortInput = {
  acknowledgmentEmail?: InputMaybe<ConfirmationEmailDataSortInput>;
  /**
   * Which sender owns this order's acknowledgment email: LEGACY, DISPATCH, or UNKNOWN while no
   * acknowledgment has triggered for it.
   */
  acknowledgmentEmailRoute?: InputMaybe<SortEnumType>;
  adjustedAt?: InputMaybe<SortEnumType>;
  /** Staff only; refused for customer-portal callers. */
  adjustedBy?: InputMaybe<SortEnumType>;
  /**
   * Order-level allocation rollup so the FULFILL orders grid can answer "which orders still need
   * allocating?" without opening each order. Maintained by every allocate / deallocate /
   * make-to-order-reflection / line-item event as an absolute $set carried on the event
   * (legacy events carry no rollup and skip the write, preserving the last stamped value).
   * null on any order written before this rollup existed: no allocation status had been
   * derived for it until the one-time Mongo backfill stamped it. null is deliberately a
   * DIFFERENT answer from NOT_STARTED — "this order's status has not been worked out" is not
   * the same fact as "nobody has tried to allocate this order".
   */
  allocationStatus?: InputMaybe<SortEnumType>;
  /**
   * What has been received against the order. Once a LIVE invoice stands against it this is the cash
   * recorded on that invoice; otherwise it is the total of every ledger entry (payments and deposits)
   * applied to the order, which is null until the first payment event is projected. Written by the same
   * two sources as paymentStatus, and filterable and sortable for the same reason.
   */
  amountPaid?: InputMaybe<SortEnumType>;
  /**
   * The order's outstanding balance. Once a LIVE invoice stands against it this is that invoice's open
   * balance; otherwise it is the order total less the amount paid, and is NULL until the first payment
   * event is projected. A null balance means nothing has been recorded against the order yet — it is
   * NOT a zero balance, and rendering it as 0 asserts the order is settled when it may never even have
   * been billed. Voiding the only live bill returns it to null for exactly that reason: nothing is
   * billed again until a new invoice is issued. Written by the same two sources as paymentStatus, and
   * filterable and sortable for the same reason.
   */
  balance?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<AddressDataSortInput>;
  /**
   * Order-level carrier (ENS). Plain optional string — not a managed carrier
   * master/aggregate. Set at creation from V3.OrderInitialized (an explicit override,
   * or the customer's inherited default) and re-stamped by V2.OrderEdited. Empty string
   * when no carrier is set on V3+ orders; null only for legacy orders created before
   * this field existed.
   */
  carrier?: InputMaybe<SortEnumType>;
  confirmationEmail?: InputMaybe<ConfirmationEmailDataSortInput>;
  /**
   * Which sender owns this order's confirmation email: LEGACY, DISPATCH, or UNKNOWN while no
   * confirmation has triggered for it.
   */
  confirmationEmailRoute?: InputMaybe<SortEnumType>;
  /**
   * The ORDER's shipping container — a ContainerConfig.ContainerCode. Set or cleared by
   * V1.OrderContainerSet; null until a container is set, and null again once
   * cleared. Additive with no backfill, so every order that predates this field reads back
   * null. Mirrors Route's shape/semantics.
   *
   * The OUTER container the load ships on — distinct from the per-line container code carried on
   * LineItems[].ContainerCode, which it never cascades to.
   */
  containerCode?: InputMaybe<SortEnumType>;
  /** Correction linkage when this order was created by correctOrder; null for ordinary orders. */
  correction?: InputMaybe<OrderCorrectionDataSortInput>;
  /**
   * OrderId of the source order this Credit order was created from by the dedicated
   * credit-existing-order flow (V1.OrderCreditedFromSource). Null for every other
   * order.
   */
  creditedFromOrderId?: InputMaybe<SortEnumType>;
  /**
   * OrderNumber of the source order this Credit order was created from, captured for
   * display so grids never need a second lookup. Null for every other order.
   */
  creditedFromOrderNumber?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  /**
   * The reason a delivery attempt on this order failed, when its status reads failed delivery.
   * None otherwise. No backfill: None for every order until FULFILL Logistics
   * dispatch and delivery write into the order stream.
   */
  deliveryFailureReason?: InputMaybe<SortEnumType>;
  discountAmount?: InputMaybe<MoneyDataSortInput>;
  discountPercent?: InputMaybe<SortEnumType>;
  discountReason?: InputMaybe<SortEnumType>;
  /**
   * Where planning ships and pins the load instead of the order's ship-to location, which this
   * never touches. Null when no destination is set. Set or cleared by the
   * setOrderDropShipDestination / clearOrderDropShipDestination mutations.
   */
  dropShipDestination?: InputMaybe<SortEnumType>;
  /**
   * The resolved dollar value of the MANUAL/customer discount actually subtracted — a positive
   * flat DiscountAmount wins outright, otherwise the percent is applied to the
   * subtotal NET of CategoryVolumeDiscounts, which stack ahead of it (line prices →
   * category volume → customer/manual on the net). It is therefore measured against
   * Subtotal − CategoryVolumeDiscounts, not against Subtotal itself; the two
   * bases coincide only on an order that qualifies for no tier. A plain dollar amount (NOT a
   * percent or fraction — unlike DiscountPercent, which is surfaced as a percent,
   * this mirrors DiscountAmount's convention). Sourced from
   * OrderState.CalculateEffectiveDiscountAmount — the same kernel
   * OrderState.CalculateOrderTotal folds into every computed total, so this field never
   * diverges from what was actually subtracted. Re-stamped alongside Subtotal by the
   * same event set (a percent discount's dollar value moves whenever the subtotal does). Null
   * until the first such event projects it.
   */
  effectiveDiscountAmount?: InputMaybe<MoneyDataSortInput>;
  /**
   * Denormalized effective route the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveRouteResolver using the canonical precedence (direct Route
   * → ship-to Locations.Route snapshot → inherited customer-location → customer →
   * tenant-default route). null when nothing resolves. Re-stamped by
   * EffectiveRouteReStamper when an upstream tier changes.
   */
  effectiveRoute?: InputMaybe<SortEnumType>;
  /**
   * Denormalized terms id the combinedOrders grid resolves for each order, stamped at
   * projection-write time so the grid never resolves it per page row. Resolved by
   * EffectiveTermsIdResolver using the canonical 3-tier precedence (direct
   * TermsId → ship-to Locations.TermsId snapshot → inherited
   * customer-location → customer → tenant-default terms). null when nothing resolves.
   * Empty strings on the source tiers are treated as absent (legacy JS-truthiness).
   */
  effectiveTermsId?: InputMaybe<SortEnumType>;
  /** Staff only; refused for customer-portal callers. The accounting-system code of the order. */
  erpId?: InputMaybe<SortEnumType>;
  /**
   * The total sales tax Stripe estimated for this order, as of the last time an estimate was taken.
   * Zero and meaningless unless estimatedTaxAt is set — read that first. Always an estimate: it is
   * never charged, never part of the order total, and the bill's real tax is settled when the order
   * is invoiced on what actually shipped.
   */
  estimatedTaxAmount?: InputMaybe<SortEnumType>;
  /**
   * When the estimate was taken, or null when none ever has been. This is the field that says whether
   * an estimate exists at all.
   */
  estimatedTaxAt?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * A fingerprint of the order as it stood when the estimate was taken. A reader that recomputes this
   * fingerprint from the order as it stands now and gets a different answer knows the order has moved
   * since, and shows the estimate as out of date rather than as current.
   */
  estimatedTaxInputsHash?: InputMaybe<SortEnumType>;
  expectedDeliveryDate?: InputMaybe<SortEnumType>;
  finalCredit?: InputMaybe<SortEnumType>;
  /** The sum of flatCharges, inside orderTotal like freight. Null until the order carries a charge. */
  flatChargesTotal?: InputMaybe<MoneyDataSortInput>;
  /** When the freight charge was last changed. */
  freightAdjustedAt?: InputMaybe<SortEnumType>;
  /** Staff only; refused for customer-portal callers. Who last changed the freight charge. */
  freightAdjustedBy?: InputMaybe<SortEnumType>;
  /** The computed freight dollar amount. */
  freightChargeAmount?: InputMaybe<MoneyDataSortInput>;
  /** The reason for the freight charge override. */
  freightChargeReason?: InputMaybe<SortEnumType>;
  /** The freight charge type applied to this order. */
  freightChargeType?: InputMaybe<SortEnumType>;
  /** The freight charge rate/amount configured on this order. */
  freightChargeValue?: InputMaybe<SortEnumType>;
  /**
   * Who decided the order's freight: INHERITED, MANUAL or LOAD (Apply freight). UNKNOWN when the freight was last
   * written before the source was recorded.
   */
  freightSource?: InputMaybe<SortEnumType>;
  /**
   * Order-level make-to-order rollup the Produce order-allocation queue filters on — true
   * when any line resolves to MAKE_TO_ORDER.
   * This is the per-line-derived replacement for produceAllocate as the queue trigger.
   * Seeded from produceAllocate by the OrderInitialized / OrderEdited / historical-import
   * arms (so existing produce-allocate orders are backfilled into the queue), then maintained from the
   * per-line sources by the LineItemsAdded / LineItemRemoved arms (absolute $set; legacy line
   * events carry a null rollup and skip the write, preserving the seeded value).
   */
  hasMakeToOrderLine?: InputMaybe<SortEnumType>;
  /**
   * Whether any of this order's delivery portions is currently recorded as a partial delivery —
   * visible on the order independent of its main status, per the dispatch/delivery ruling
   * (product decision task 05212e34). Backfilled on every pre-existing order by
   * orders-haspartialdelivery-backfill-v1.js, shipped with this PR: the C# default of
   * false reads correctly for a document missing the element, but [UseFiltering] /
   * [UseSorting] compile straight to a server-side Mongo query, and Mongo's $eq: false
   * does not match an absent element ($ne: false does) — so a filter or sort on this field
   * would have silently dropped every order that predates FULFILL Logistics dispatch/delivery.
   */
  hasPartialDelivery?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * The stable external sync key (Merge.dev invoice id) this order was imported under.
   * Indexed (TenantId, ImportId) so mergeOrder resolves create-vs-update by an ImportId
   * lookup rather than the deterministic OrderId it used to collide on. Empty for native orders
   * / those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<SortEnumType>;
  initializedDate?: InputMaybe<SortEnumType>;
  /**
   * The id of the invoice raised against this order — the ACTIVE one where a bill still stands, and the
   * most recently withdrawn one where every bill has been. Null for an order that has never been billed.
   *
   * IT IDENTIFIES THE BILL, IT DOES NOT ASSERT ONE IS LIVE. That reading is invoiceStatus's, and the two
   * are deliberately separate: a voided order keeps this id so the withdrawn document can still be opened
   * from the row, and a re-issue overwrites it with the new bill's.
   */
  invoiceId?: InputMaybe<SortEnumType>;
  /**
   * The invoice number of the bill raised against this order — what a person calls it. Null for an
   * order that has never been billed. Filterable and sortable.
   */
  invoiceNumber?: InputMaybe<SortEnumType>;
  /**
   * Where the order stands on being billed: never billed, billed and the bill still stands, or billed and
   * every bill withdrawn. Filterable and sortable.
   *
   * THE ONE AUTHORITY FOR THIS READING. It is stored here, on the order, and both order surfaces publish
   * it from storage — the combinedOrders grid AND the combinedOrders connection query, whose generated
   * filter and sort inputs carry it so the Fulfill CSV export can translate a grid filter onto them.
   * (OrderStateData still derives its own invoiceStatus through the invoice DataLoader; that surface is
   * out of this slice's scope and agrees with this one by construction, pinned by test.)
   *
   * UNKNOWN IS NEVER WRITTEN HERE. It is what a row predating this field reads as, and it is not a claim
   * that the order has never been billed — NOT_INVOICED is that claim, and the projection only makes it
   * for an order it has positively seen no live invoice for.
   */
  invoiceStatus?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * True for every order created by a history import, migration or not. Filter with eq: false to skip history (runs as $ne: true).
   */
  isHistoricalImport?: InputMaybe<SortEnumType>;
  itemIds?: InputMaybe<SortEnumType>;
  /**
   * When an allocate or deallocate was last applied to this order; null when none ever has
   * been. This is what makes SHORT distinguishable from NOT_STARTED — an allocated
   * quantity of zero cannot tell "nobody tried" from "we tried and inventory came up short".
   * Mirrored from OrderState.LastAllocatedDate by the projection.
   */
  lastAllocatedDate?: InputMaybe<SortEnumType>;
  locations?: InputMaybe<OrderLocationDocumentDataSortInput>;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether a data migration imported the order as history. Set together with migrationSet and never cleared.
   * Filter with eq: true to select these orders and eq: false to skip them.
   */
  migrationHistorical?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether the order's current status was set by a data migration. The next ordinary status change clears it.
   * Filter with eq: true to select these orders and eq: false to skip them.
   */
  migrationSet?: InputMaybe<SortEnumType>;
  /**
   * The sum of nonDiscountableLines in plain dollars — the amount withheld from the
   * customer/manual discount base. Null on orders written before the exclusion was recorded,
   * which reads as "no exclusion": the behaviour those orders were priced under.
   */
  nonDiscountableSubtotal?: InputMaybe<MoneyDataSortInput>;
  numberOfLines?: InputMaybe<SortEnumType>;
  /**
   * The unit this order was placed in — whether the customer entered Shipping UOM units or
   * eaches. Stamped from the customer's effective setting when the order is created and never
   * changed afterwards, so a later change to that setting never restates a placed order. Orders
   * created before this was stamped read as SHIPPING_UOM, which is what they were.
   */
  orderEntryUnit?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  /**
   * The id of the order's Order kind, from the tenant's Order kinds list. Set when the order is created and by
   * the setOrderKind mutation; null when it has none. Filter and group by kind use this id. The
   * kind's name is not stored: orderKindName resolves it at query time, so a rename needs no write here.
   */
  orderKindId?: InputMaybe<SortEnumType>;
  orderNumber?: InputMaybe<SortEnumType>;
  orderStatus?: InputMaybe<SortEnumType>;
  orderTotal?: InputMaybe<MoneyDataSortInput>;
  orderType?: InputMaybe<SortEnumType>;
  /**
   * The order's ORDER-WIDE volume discount component ("≥N units or ≥$X on the order ⇒ P% or $Y
   * off"), or null when the order's price group configures no rule or the order does not
   * reach its threshold. Feeds the totals card's itemised volume-discount breakdown alongside the
   * per-category rows.
   *
   * A second PLANE-2 component, distinct from both CategoryVolumeDiscounts and
   * DiscountAmount/DiscountPercent (the manual/customer discount). Stacking order:
   * line prices → category volume → order volume → customer/manual on the resulting net → tenant
   * cap. Every dollar figure here is PLAIN DOLLARS; ConfiguredValue alone carries the
   * rule's own convention (a percent value, or dollars for a flat rule) and is never a fraction.
   *
   *
   * null means the order reaches no threshold — which is also how the discount disappears
   * when a line is removed. The projection $sets the field absolutely from the event,
   * including to null, so it can never drift from the OrderTotal stamped by that
   * same event.
   */
  orderVolumeDiscount?: InputMaybe<OrderVolumeDiscountDocumentSortInput>;
  /**
   * The customer this order belonged to before a customer combine moved it onto the customer it was
   * combined into; null when it was never moved.
   * Set once, so a chain of combines keeps the first customer.
   */
  originalCustomerId?: InputMaybe<SortEnumType>;
  /**
   * The name of the customer this order belonged to before a customer combine moved it, as that
   * customer was named when combined; null when it was never moved. What the screens show as
   * "from <original name>".
   */
  originalCustomerName?: InputMaybe<SortEnumType>;
  /**
   * The items this order named before an item combine moved its references to the item each was
   * combined into, space-separated like itemIds; null when no combine moved any. Reverting the
   * combine adds the item back to itemIds and takes it off this list; the kept item stays in
   * itemIds, so a search for it still finds the order.
   */
  originalItemIds?: InputMaybe<SortEnumType>;
  /**
   * The ship-to location id this order named before a combine moved it onto the ship-to it was combined
   * into (a ship-to combine, or a customer combine's "same as" ship-to) and re-pointed locations.id;
   * null when it was never moved. Set once, so a chain of combines keeps the first ship-to. The order's
   * ship-to name, code and address stay as they were when it was taken.
   */
  originalLocationId?: InputMaybe<SortEnumType>;
  /**
   * The ship-to address id this order named before the same combine re-pointed locations.address.id;
   * null when it was never moved.
   */
  originalShipToId?: InputMaybe<SortEnumType>;
  overrideTotal?: InputMaybe<MoneyDataSortInput>;
  /**
   * The order's payment standing. Once a LIVE invoice stands against the order this reports that
   * invoice's standing, because the bill is then what the customer owes; with no live invoice — never
   * billed, or every bill withdrawn — it is derived from the order's own amount paid versus its order
   * total, and reads UNPAID for an order that has never had a payment applied.
   *
   * ONE STORED READING, WRITTEN BY WHICHEVER AGGREGATE OWNS THE MONEY. The order's own payment events
   * write it while the order is unbilled; the INVOICE's events overwrite it the moment a bill is issued
   * and on every payment, adjustment, waiver and void thereafter — each carrying its own after-values, so
   * the projection only unpacks and $sets. Filtering and sorting therefore select by exactly what the
   * field publishes, with no divergence to disclose and no join to pay for.
   */
  paymentStatus?: InputMaybe<SortEnumType>;
  /**
   * The order's PLANNED ship date — the date the load is scheduled to leave the building.
   * Deliberately distinct from shippedDate (actual, past-tense). Set or cleared by the
   * setOrderPlannedShipDate mutation; null until set, and null again once
   * cleared. Additive with no backfill, so every order that predates this field reads back
   * null. Filterable here (implicit binding), so the Planning window can query a
   * ship-date window directly instead of deriving it client-side from
   * ExpectedDeliveryDate minus a route's transit days.
   */
  plannedShipDate?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  /**
   * How sales prices are entered and shown for this order: per each or per shipping unit. Prices are
   * always stored and billed per each. Stamped from the customer's effective setting when the order
   * was created and frozen: a later change to the company or customer setting never restates a
   * placed order. Orders placed before this existed read as EACH.
   */
  priceEntryUnit?: InputMaybe<SortEnumType>;
  /** Staff only; refused for customer-portal callers. The produce-allocation flag. */
  produceAllocate?: InputMaybe<SortEnumType>;
  /**
   * The order's Program, a name from the tenant's Programs list. Set when the order is created and by the
   * setOrderProgram mutation; null when it has none. Additive with no backfill, so every order
   * that predates it reads back null. Filterable, sortable and groupable.
   */
  program?: InputMaybe<SortEnumType>;
  /**
   * true when a prorate wrote acknowledged quantities while the order was Submitted and the order
   * has not been acknowledged since; false or null otherwise (null for an order never prorated, or
   * prorated before the field existed). Only true means prorated.
   */
  proratedWhileSubmitted?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * Why the last QuickBooks export attempt did not get there. Null unless quickBooksExportStatus is
   * FAILED. Output only — a free-text diagnostic has no meaningful sort or set filter.
   */
  quickBooksExportError?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * Whether the invoice raised against this order reached QuickBooks. NOT_EXPORTED for an order that has
   * never been billed, for a tenant with no accounting integration, and for an order whose export row is
   * the LEGACY ORDER export rather than an invoice export — that row's outcome was about the order, not
   * about a bill, and reading it as the invoice's would say a bill reached QuickBooks that was never sent.
   *
   * STORED ON THE ORDER for exactly the reason invoiceStatus beside it is: the Orders grid filters and
   * sorts on it server-side, and a join to the export read model per page is what that ruling exists to
   * avoid. Written by the export projection's mirror arm, never by the order's own arms.
   */
  quickBooksExportStatus?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * The id QuickBooks gave the invoice raised against this order, for opening it there. Null until an
   * export has succeeded, and kept afterwards so a later attempt cannot erase the pointer to a
   * QuickBooks invoice that already exists.
   */
  quickBooksRemoteInvoiceId?: InputMaybe<SortEnumType>;
  /**
   * The last day the quote on this order is valid, as a tenant-local date. Null when none is set.
   * Set and cleared by setOrderQuoteDetails while the order is a draft, and kept once it is submitted.
   */
  quoteValidUntil?: InputMaybe<SortEnumType>;
  /**
   * Staff only; refused for customer-portal callers.
   * Consecutive failed order→NAV sync attempts, mirrored from OrderState.RetryCount by the
   * projection. Non-null (defaults to 0) and seeded on order initialization so every order
   * carries the field — the sync worker's retryCount < N selection filter can only
   * exclude quarantined / over-threshold rows, never silently drop rows that lack the field.
   * Auto-exposed as retryCount: Int! plus its filter/sort inputs via BindFieldsImplicitly.
   */
  retryCount?: InputMaybe<SortEnumType>;
  /**
   * Order-level route override — tier 1 of the hierarchical route setting. Free-text scalar; set
   * or cleared by V1.RouteUpdated. null until an override is set. Mirrors
   * Carrier's shape/semantics.
   */
  route?: InputMaybe<SortEnumType>;
  salesPerson?: InputMaybe<SortEnumType>;
  /**
   * Order-level override for the invoice-email toggle.
   * null means inherit from location/customer. Cascade resolved at read time
   * as order ?? location ?? customer, through the invoice's order.
   */
  sendInvoiceEmails?: InputMaybe<SortEnumType>;
  /**
   * Order-level override for the order-confirmation-email toggle.
   * null means inherit from location/customer. Cascade resolved at read time
   * as order ?? location ?? customer.
   */
  sendOrderEmails?: InputMaybe<SortEnumType>;
  /**
   * The order's structured ship-from site — the WorkSuite-native SiteLocationId the FULFILL
   * container / ContainerConfig keys on. Set at creation from V3.OrderInitialized and
   * updated by V1.ShipFromSiteSet. Empty for orders that never carried a structured ship-from
   * site (legacy / pre-V3 streams); no backfill. Denormalized alongside ShipFromSiteName.
   */
  shipFromSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Denormalized display name of ShipFromSiteLocationId, resolved from the SiteLocation
   * read model at projection-write time (the CustomerName denormalization pattern) so the
   * combinedOrders grid renders, sorts, filters, and groups Ship-From Site without a per-row
   * lookup. Empty when no ship-from site is set or the id no longer resolves to a name.
   */
  shipFromSiteName?: InputMaybe<SortEnumType>;
  shippedDate?: InputMaybe<SortEnumType>;
  signatureImage?: InputMaybe<SignatureImageDataSortInput>;
  /**
   * Where the order was created from. Set once when the order is created and never changed
   * afterwards. Orders created before this field existed, and orders whose origin was never
   * recorded, read as UNKNOWN — that value is never guessed at. Filterable and sortable.
   */
  source?: InputMaybe<SortEnumType>;
  /**
   * First moment the order entered an active state (Submitted / Acknowledged / Picked /
   * Shipped). Cleared back to null on re-open (Initialized / Open). Mirrors
   * OrderState.SubmittedAt apply-arm semantics so the document and the entity stay in
   * lockstep.
   */
  submittedAt?: InputMaybe<SortEnumType>;
  /**
   * Line items total before freight and discounts. Re-stamped by every event that can move it:
   * discount, override total, freight, and any line-item change (add, quantity update, merge,
   * removal, override price, reprice). Null until the first such event projects it.
   */
  subtotal?: InputMaybe<MoneyDataSortInput>;
  /** Staff only; refused for customer-portal callers. When the order last synced to the accounting system. */
  syncDate?: InputMaybe<SortEnumType>;
  /**
   * The order's header Tag color, by tag color id, or null when none is set. A color deleted after it
   * was chosen stays here. Every order that predates this field reads back null.
   */
  tagColorId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /**
   * Snapshot of the Terms record's discount percentage as a fraction (0.02 = 2%),
   * captured at OrderInitialized / OrderEdited time. Null when the order has no Terms
   * assigned.
   */
  termsAccrueInterestPercentage?: InputMaybe<SortEnumType>;
  /**
   * Snapshot of the Terms record's early-pay-discount window in days, captured at
   * OrderInitialized / OrderEdited time. Null when the order has no Terms assigned.
   * Used together with TermsAccrueInterestPercentage and
   * ExpectedDeliveryDate to derive the customer-facing discount message.
   */
  termsDiscountDays?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
  /**
   * Snapshot of the Terms record's net-due window in days, captured at OrderInitialized /
   * OrderEdited time. Null when the order has no Terms assigned.
   */
  termsTermLimitDays?: InputMaybe<SortEnumType>;
  /**
   * ISO-8601 week-of-year (1–53) of ExpectedDeliveryDate in UTC. Persisted so the
   * Orders grid can filter and sort Week Number server-side; mirrors the client's
   * getISOWeek(expectedDeliveryDate) derivation.
   */
  weekNumber?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type OrdersEdge = {
  __typename?: 'OrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrdersDocument;
};

export enum OrganicReceiveMode {
  Block = 'BLOCK',
  Warn = 'WARN'
}

export type OrganicReceiveModeOperationFilterInput = {
  eq?: InputMaybe<OrganicReceiveMode>;
  in?: InputMaybe<Array<OrganicReceiveMode>>;
  neq?: InputMaybe<OrganicReceiveMode>;
  nin?: InputMaybe<Array<OrganicReceiveMode>>;
};

/**
 * Soft per-item warning surfaced by ReceiveVendorPurchaseOrderItems when the tenant
 * has OrganicReceiveMode = Warn and an organic item arrives with a missing
 * OrganicLotCode. The receive succeeds; the warning is shown to the operator.
 */
export type OrganicReceiveWarning = {
  __typename?: 'OrganicReceiveWarning';
  itemId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** One release of releaseOrphanedOrderAllocations: what a dead order gave back at one key. */
export type OrphanedOrderAllocationReleaseData = {
  __typename?: 'OrphanedOrderAllocationReleaseData';
  /** The key's grade. */
  grade: Scalars['Int']['output'];
  /** The key's item. */
  itemId: Scalars['String']['output'];
  /** The order's lines released. */
  lineItemIds: Array<Scalars['String']['output']>;
  /** The key's location. */
  locationId: Scalars['String']['output'];
  /** The order. */
  orderId: Scalars['String']['output'];
  /** The order's status, Deleted or Cancelled. */
  orderStatus: OrderStatus;
  /** The quantity released. */
  quantity: Scalars['Decimal']['output'];
};

/**
 * What delivering the line to its devices' twins did after the operation: how many devices received a target or had it
 * revoked, and every device that did not settle, with why.
 */
export type OtaDeliveryData = {
  __typename?: 'OtaDeliveryData';
  delivered: Scalars['Int']['output'];
  error: Scalars['String']['output'];
  lineVersion: Scalars['Long']['output'];
  repaired: Scalars['Int']['output'];
  revoked: Scalars['Int']['output'];
  unsettled: Array<OtaDeviceDelivery>;
};

export type OtaDeviceDelivery = {
  __typename?: 'OtaDeviceDelivery';
  detail: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  result: OtaDeviceDeliveryResult;
};

export enum OtaDeviceDeliveryResult {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Repaired = 'REPAIRED',
  Revoked = 'REVOKED',
  Skipped = 'SKIPPED',
  Superseded = 'SUPERSEDED',
  UnknownDevice = 'UNKNOWN_DEVICE',
  Unsettled = 'UNSETTLED'
}

export enum OtaDeviceFailure {
  FailedFinal = 'FAILED_FINAL',
  None = 'NONE',
  RolledBack = 'ROLLED_BACK',
  Timeout = 'TIMEOUT'
}

export enum OtaDeviceOutcomeState {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Offered = 'OFFERED'
}

/** A device's outcome for the offer it was last given: still waiting on its report, applied, or failed and how. */
export enum OtaDeviceStateOutcome {
  /** The device reported the offered build applied. */
  Applied = 'APPLIED',
  /** The device reported its final attempt failed. */
  FailedFinal = 'FAILED_FINAL',
  /** The device holds the offer and has not reported a result, or was never offered it. */
  Offered = 'OFFERED',
  /** The device reported its update rolled back. */
  RolledBack = 'ROLLED_BACK',
  /** The device's offer went unconfirmed past the confirmation timeout. */
  TimedOut = 'TIMED_OUT'
}

/** What recording one firmware report did. A redelivered report returns its original disposition and changes nothing. */
export type OtaFirmwareReportPayload = {
  __typename?: 'OtaFirmwareReportPayload';
  delivery?: Maybe<OtaDeliveryData>;
  disposition?: Maybe<OtaReportDisposition>;
  duplicate: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ValidationError>>;
  haltedRollout: Scalars['Boolean']['output'];
};

export enum OtaNoOpReason {
  ActiveRolloutExists = 'ACTIVE_ROLLOUT_EXISTS',
  None = 'NONE',
  RolloutAlreadyStarted = 'ROLLOUT_ALREADY_STARTED',
  RolloutNotActive = 'ROLLOUT_NOT_ACTIVE',
  RolloutNotFound = 'ROLLOUT_NOT_FOUND',
  RolloutNotPaused = 'ROLLOUT_NOT_PAUSED',
  SupersededTransition = 'SUPERSEDED_TRANSITION'
}

export type OtaOpenedRingData = {
  __typename?: 'OtaOpenedRingData';
  authorizationSequence: Scalars['Long']['output'];
  deviceIds: Array<Scalars['String']['output']>;
  openedAt: Scalars['DateTime']['output'];
  ringIndex: Scalars['Int']['output'];
};

export type OtaOpenedRingDocument = {
  __typename?: 'OtaOpenedRingDocument';
  authorizationSequence: Scalars['Long']['output'];
  deviceCount: Scalars['Int']['output'];
  openedAt: Scalars['DateTime']['output'];
  ringIndex: Scalars['Int']['output'];
};

export type OtaOpenedRingDocumentFilterInput = {
  and?: InputMaybe<Array<OtaOpenedRingDocumentFilterInput>>;
  authorizationSequence?: InputMaybe<LongOperationFilterInput>;
  deviceCount?: InputMaybe<IntOperationFilterInput>;
  openedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OtaOpenedRingDocumentFilterInput>>;
  ringIndex?: InputMaybe<IntOperationFilterInput>;
};

/** Whether promoting a rollout's current ring would succeed now, and the server's reason when it would not. */
export type OtaPromoteEligibilityData = {
  __typename?: 'OtaPromoteEligibilityData';
  /** True when the ring gates allow the promote. */
  canPromote: Scalars['Boolean']['output'];
  /** The refusal's error code; absent when the ring can be promoted. */
  code?: Maybe<Scalars['String']['output']>;
  /** The ring the answer is for. */
  fromRing: Scalars['Int']['output'];
  /** The refusal's message; absent when the ring can be promoted. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** The reconciliation of one line's deliveries. */
export type OtaReconcilePayload = {
  __typename?: 'OtaReconcilePayload';
  delivery?: Maybe<OtaDeliveryData>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum OtaReleaseChannel {
  Beta = 'BETA',
  Stable = 'STABLE'
}

export type OtaReleaseChannelOperationFilterInput = {
  eq?: InputMaybe<OtaReleaseChannel>;
  in?: InputMaybe<Array<OtaReleaseChannel>>;
  neq?: InputMaybe<OtaReleaseChannel>;
  nin?: InputMaybe<Array<OtaReleaseChannel>>;
};

/**
 * One release as its events' absolutes describe it. The status is Draft or Published, and the halted flag is set only by
 * a halt, which publishing never clears, so a halted release reads as halted whatever its status.
 */
export type OtaReleaseDocument = {
  __typename?: 'OtaReleaseDocument';
  buildPublishedAt: Scalars['DateTime']['output'];
  channel: OtaReleaseChannel;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deviceModel: Scalars['String']['output'];
  firmwareName: Scalars['String']['output'];
  haltReason: Scalars['String']['output'];
  halted: Scalars['Boolean']['output'];
  haltedAt?: Maybe<Scalars['DateTime']['output']>;
  haltedBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imagePath: Scalars['String']['output'];
  imageSha256: Scalars['String']['output'];
  imageSize: Scalars['Long']['output'];
  imageUrl: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  profile: DeviceProfile;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy: Scalars['String']['output'];
  sha: Scalars['String']['output'];
  status: OtaReleaseStatus;
  version: Scalars['String']['output'];
};

/**
 * One release as its events' absolutes describe it. The status is Draft or Published, and the halted flag is set only by
 * a halt, which publishing never clears, so a halted release reads as halted whatever its status.
 */
export type OtaReleaseDocumentFilterInput = {
  and?: InputMaybe<Array<OtaReleaseDocumentFilterInput>>;
  buildPublishedAt?: InputMaybe<DateTimeOperationFilterInput>;
  channel?: InputMaybe<OtaReleaseChannelOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  deviceModel?: InputMaybe<StringOperationFilterInput>;
  firmwareName?: InputMaybe<StringOperationFilterInput>;
  haltReason?: InputMaybe<StringOperationFilterInput>;
  halted?: InputMaybe<BooleanOperationFilterInput>;
  haltedAt?: InputMaybe<DateTimeOperationFilterInput>;
  haltedBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  imagePath?: InputMaybe<StringOperationFilterInput>;
  imageSha256?: InputMaybe<StringOperationFilterInput>;
  imageSize?: InputMaybe<LongOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OtaReleaseDocumentFilterInput>>;
  profile?: InputMaybe<DeviceProfileOperationFilterInput>;
  publishedAt?: InputMaybe<DateTimeOperationFilterInput>;
  publishedBy?: InputMaybe<StringOperationFilterInput>;
  sha?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<OtaReleaseStatusOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One release as its events' absolutes describe it. The status is Draft or Published, and the halted flag is set only by
 * a halt, which publishing never clears, so a halted release reads as halted whatever its status.
 */
export type OtaReleaseDocumentSortInput = {
  buildPublishedAt?: InputMaybe<SortEnumType>;
  channel?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  deviceModel?: InputMaybe<SortEnumType>;
  firmwareName?: InputMaybe<SortEnumType>;
  haltReason?: InputMaybe<SortEnumType>;
  halted?: InputMaybe<SortEnumType>;
  haltedAt?: InputMaybe<SortEnumType>;
  haltedBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  imagePath?: InputMaybe<SortEnumType>;
  imageSha256?: InputMaybe<SortEnumType>;
  imageSize?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  profile?: InputMaybe<SortEnumType>;
  publishedAt?: InputMaybe<SortEnumType>;
  publishedBy?: InputMaybe<SortEnumType>;
  sha?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type OtaReleasePayload = {
  __typename?: 'OtaReleasePayload';
  errors?: Maybe<Array<ValidationError>>;
  release?: Maybe<OtaReleaseStateData>;
};

export type OtaReleaseStateData = {
  __typename?: 'OtaReleaseStateData';
  buildPublishedAt: Scalars['DateTime']['output'];
  channel: OtaReleaseChannel;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deviceModel: Scalars['String']['output'];
  firmwareName: Scalars['String']['output'];
  haltReason: Scalars['String']['output'];
  haltedAt?: Maybe<Scalars['DateTime']['output']>;
  haltedBy: Scalars['String']['output'];
  imagePath: Scalars['String']['output'];
  imageSha256: Scalars['String']['output'];
  imageSize: Scalars['Long']['output'];
  imageUrl: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  profile: DeviceProfile;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy: Scalars['String']['output'];
  releaseId: Scalars['String']['output'];
  sha: Scalars['String']['output'];
  status: OtaReleaseStatus;
  version: Scalars['String']['output'];
};

export enum OtaReleaseStatus {
  Draft = 'DRAFT',
  Halted = 'HALTED',
  Published = 'PUBLISHED'
}

export type OtaReleaseStatusOperationFilterInput = {
  eq?: InputMaybe<OtaReleaseStatus>;
  in?: InputMaybe<Array<OtaReleaseStatus>>;
  neq?: InputMaybe<OtaReleaseStatus>;
  nin?: InputMaybe<Array<OtaReleaseStatus>>;
};

/** A connection to a list of items. */
export type OtaReleasesConnection = {
  __typename?: 'OtaReleasesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OtaReleasesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OtaReleaseDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OtaReleasesEdge = {
  __typename?: 'OtaReleasesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OtaReleaseDocument;
};

export enum OtaReportDisposition {
  AlreadyApplied = 'ALREADY_APPLIED',
  Applied = 'APPLIED',
  Evidence = 'EVIDENCE',
  FailedFinal = 'FAILED_FINAL',
  IdentityMismatch = 'IDENTITY_MISMATCH',
  Replayed = 'REPLAYED',
  RolledBack = 'ROLLED_BACK',
  Stale = 'STALE',
  Uncorrelated = 'UNCORRELATED'
}

export enum OtaReportedOutcome {
  Applied = 'APPLIED',
  FailedFinal = 'FAILED_FINAL',
  RolledBack = 'ROLLED_BACK'
}

export type OtaResultDataInput = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  authorizationSequence: Scalars['Long']['input'];
  imageSha256: Scalars['String']['input'];
  outcome: OtaReportedOutcome;
  reason?: InputMaybe<Scalars['String']['input']>;
  rolloutId: Scalars['String']['input'];
  sha: Scalars['String']['input'];
};

export type OtaRingDataInput = {
  cutoffBps?: InputMaybe<Scalars['Int']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  haltBps: Scalars['Int']['input'];
  haltMinFailures: Scalars['Int']['input'];
  kind: OtaRingKind;
  maxDevices?: InputMaybe<Scalars['Int']['input']>;
  minApplied: Scalars['Int']['input'];
  successBps: Scalars['Int']['input'];
};

export enum OtaRingKind {
  Cumulative = 'CUMULATIVE',
  Explicit = 'EXPLICIT'
}

export type OtaRingKindOperationFilterInput = {
  eq?: InputMaybe<OtaRingKind>;
  in?: InputMaybe<Array<OtaRingKind>>;
  neq?: InputMaybe<OtaRingKind>;
  nin?: InputMaybe<Array<OtaRingKind>>;
};

/** One opened ring's devices counted by outcome, from the same recorded state that gates promotion and halt. */
export type OtaRingOutcomeBreakdownData = {
  __typename?: 'OtaRingOutcomeBreakdownData';
  /** Devices that reported the offered build applied. */
  applied: Scalars['Int']['output'];
  /** How many devices the ring was opened over. */
  cohort: Scalars['Int']['output'];
  /** Rolled back plus failed final plus timed out. */
  failed: Scalars['Int']['output'];
  /** Devices that reported their final attempt failed. */
  failedFinal: Scalars['Int']['output'];
  /** How many cohort devices are known to have been offered by this ring: they hold its offer or reported a result for it. */
  offered: Scalars['Int']['output'];
  /** Cohort minus applied minus failed, including devices that are silent or were never offered. */
  pending: Scalars['Int']['output'];
  /** The ring's position in the rollout's plan. */
  ringIndex: Scalars['Int']['output'];
  /** Devices whose update rolled back. */
  rolledBack: Scalars['Int']['output'];
  /** Devices whose offer went unconfirmed past the confirmation timeout. */
  timedOut: Scalars['Int']['output'];
};

export type OtaRingPlanData = {
  __typename?: 'OtaRingPlanData';
  cutoffBps: Scalars['Int']['output'];
  deviceIds: Array<Scalars['String']['output']>;
  haltBps: Scalars['Int']['output'];
  haltMinFailures: Scalars['Int']['output'];
  kind: OtaRingKind;
  maxDevices?: Maybe<Scalars['Int']['output']>;
  minApplied: Scalars['Int']['output'];
  successBps: Scalars['Int']['output'];
};

export type OtaRingPlanDocument = {
  __typename?: 'OtaRingPlanDocument';
  cutoffBps: Scalars['Int']['output'];
  deviceIds: Array<Scalars['String']['output']>;
  haltBps: Scalars['Int']['output'];
  haltMinFailures: Scalars['Int']['output'];
  kind: OtaRingKind;
  maxDevices?: Maybe<Scalars['Int']['output']>;
  minApplied: Scalars['Int']['output'];
  successBps: Scalars['Int']['output'];
};

export type OtaRingPlanDocumentFilterInput = {
  and?: InputMaybe<Array<OtaRingPlanDocumentFilterInput>>;
  cutoffBps?: InputMaybe<IntOperationFilterInput>;
  deviceIds?: InputMaybe<ListStringOperationFilterInput>;
  haltBps?: InputMaybe<IntOperationFilterInput>;
  haltMinFailures?: InputMaybe<IntOperationFilterInput>;
  kind?: InputMaybe<OtaRingKindOperationFilterInput>;
  maxDevices?: InputMaybe<OptionOfInt32FilterInput>;
  minApplied?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OtaRingPlanDocumentFilterInput>>;
  successBps?: InputMaybe<IntOperationFilterInput>;
};

/** One device's outcome under a rollout, kept after a later rollout has re-offered the device. */
export type OtaRolloutDeviceStateData = {
  __typename?: 'OtaRolloutDeviceStateData';
  /** The attempt of the result, or zero when it has none. */
  attempt: Scalars['Int']['output'];
  /** The device. */
  deviceId: Scalars['String']['output'];
  /** When the device observed that report. */
  lastReportAt?: Maybe<Scalars['DateTime']['output']>;
  /** What the device reported, or offered when it has not reported. */
  outcome: OtaDeviceStateOutcome;
  /** The firmware version in the device's latest report for the rollout, when it has reported. */
  reportedVersion?: Maybe<Scalars['String']['output']>;
  /** The ring of the rollout that offered the device. */
  ringIndex: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type OtaRolloutDeviceStatesConnection = {
  __typename?: 'OtaRolloutDeviceStatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OtaRolloutDeviceStatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OtaRolloutDeviceStateData>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OtaRolloutDeviceStatesEdge = {
  __typename?: 'OtaRolloutDeviceStatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OtaRolloutDeviceStateData;
};

/**
 * One rollout as its events' absolutes describe it: created by the start, advanced by the lifecycle summary each later event
 * carries, and ended by the terminal status, which only a halt or abort writes. The effective status is the terminal
 * status when set, else the lifecycle status.
 */
export type OtaRolloutDocument = {
  __typename?: 'OtaRolloutDocument';
  acknowledgedSingleDeviceFleet: Scalars['Boolean']['output'];
  currentRing: Scalars['Int']['output'];
  deviceModel: Scalars['String']['output'];
  eligibleCountAtStart: Scalars['Int']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  firmwareName: Scalars['String']['output'];
  haltReason: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastResumeSequence: Scalars['Long']['output'];
  lifecycleStatus: OtaRolloutStatus;
  lineId: Scalars['String']['output'];
  openedRings: Array<OtaOpenedRingDocument>;
  /**
   * Whether promoting the rollout's current ring would succeed now and, when it would not, the server's reason. It is
   * the evaluation the promote mutation runs, over ring outcomes counted by the same ring state reading, so the two
   * cannot disagree. It does not check that a manifest signer is available, so the mutation can still fail on that. The
   * current rings of every rollout in a page are read together, sharing the read with ringOutcomes.
   */
  promoteEligibility: OtaPromoteEligibilityData;
  releaseId: Scalars['String']['output'];
  /**
   * Per opened ring, the devices counted by outcome from the recorded OTA state the ring outcome source gates on, or for
   * a superseded rollout from the reports that named it. Pending is every cohort device that has neither applied nor
   * failed. A store fault is an error on this field, never an empty list. The rings of every rollout in a page are read
   * together.
   */
  ringOutcomes: Array<OtaRingOutcomeBreakdownData>;
  rings: Array<OtaRingPlanDocument>;
  sha: Scalars['String']['output'];
  skippedRings: Array<Scalars['Int']['output']>;
  startedAt: Scalars['DateTime']['output'];
  startedBy: Scalars['String']['output'];
  /** The rollout's status: the terminal status once a halt or abort has ended it, else its lifecycle status. */
  status: OtaRolloutStatus;
  terminalStatus?: Maybe<OtaRolloutStatus>;
  version: Scalars['String']['output'];
};

/**
 * One rollout as its events' absolutes describe it: created by the start, advanced by the lifecycle summary each later event
 * carries, and ended by the terminal status, which only a halt or abort writes. The effective status is the terminal
 * status when set, else the lifecycle status.
 */
export type OtaRolloutDocumentFilterInput = {
  acknowledgedSingleDeviceFleet?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<OtaRolloutDocumentFilterInput>>;
  currentRing?: InputMaybe<IntOperationFilterInput>;
  deviceModel?: InputMaybe<StringOperationFilterInput>;
  eligibleCountAtStart?: InputMaybe<IntOperationFilterInput>;
  endedAt?: InputMaybe<DateTimeOperationFilterInput>;
  firmwareName?: InputMaybe<StringOperationFilterInput>;
  haltReason?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastResumeSequence?: InputMaybe<LongOperationFilterInput>;
  lifecycleStatus?: InputMaybe<OtaRolloutStatusOperationFilterInput>;
  lineId?: InputMaybe<StringOperationFilterInput>;
  openedRings?: InputMaybe<ListFilterInputTypeOfOtaOpenedRingDocumentFilterInput>;
  or?: InputMaybe<Array<OtaRolloutDocumentFilterInput>>;
  releaseId?: InputMaybe<StringOperationFilterInput>;
  rings?: InputMaybe<ListFilterInputTypeOfOtaRingPlanDocumentFilterInput>;
  sha?: InputMaybe<StringOperationFilterInput>;
  skippedRings?: InputMaybe<ListIntOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  startedBy?: InputMaybe<StringOperationFilterInput>;
  terminalStatus?: InputMaybe<OptionOfOtaRolloutStatusFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One rollout as its events' absolutes describe it: created by the start, advanced by the lifecycle summary each later event
 * carries, and ended by the terminal status, which only a halt or abort writes. The effective status is the terminal
 * status when set, else the lifecycle status.
 */
export type OtaRolloutDocumentSortInput = {
  acknowledgedSingleDeviceFleet?: InputMaybe<SortEnumType>;
  currentRing?: InputMaybe<SortEnumType>;
  deviceModel?: InputMaybe<SortEnumType>;
  eligibleCountAtStart?: InputMaybe<SortEnumType>;
  endedAt?: InputMaybe<SortEnumType>;
  firmwareName?: InputMaybe<SortEnumType>;
  haltReason?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastResumeSequence?: InputMaybe<SortEnumType>;
  lifecycleStatus?: InputMaybe<SortEnumType>;
  lineId?: InputMaybe<SortEnumType>;
  releaseId?: InputMaybe<SortEnumType>;
  sha?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  startedBy?: InputMaybe<SortEnumType>;
  terminalStatus?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type OtaRolloutOperationData = {
  __typename?: 'OtaRolloutOperationData';
  applied: Scalars['Boolean']['output'];
  authorizationSequence: Scalars['Long']['output'];
  operationId: Scalars['String']['output'];
  reason: OtaNoOpReason;
  rollout?: Maybe<OtaRolloutStateData>;
};

/**
 * The outcome of one rollout operation. Every rollout input carries a client-generated operation id: a retry of the same
 * request returns the original outcome, and the payload reports whether the operation applied or why it was a no-op (for
 * example a promote from a ring that has since moved on).
 */
export type OtaRolloutPayload = {
  __typename?: 'OtaRolloutPayload';
  delivery?: Maybe<OtaDeliveryData>;
  errors?: Maybe<Array<ValidationError>>;
  operation?: Maybe<OtaRolloutOperationData>;
};

export type OtaRolloutStateData = {
  __typename?: 'OtaRolloutStateData';
  acknowledgedSingleDeviceFleet: Scalars['Boolean']['output'];
  currentRing: Scalars['Int']['output'];
  deviceModel: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  firmwareName: Scalars['String']['output'];
  haltReason: Scalars['String']['output'];
  lastResumeSequence: Scalars['Long']['output'];
  lifecycleStatus: OtaRolloutStatus;
  lineId: Scalars['String']['output'];
  openedRings: Array<OtaOpenedRingData>;
  releaseId: Scalars['String']['output'];
  rings: Array<OtaRingPlanData>;
  rolloutId: Scalars['String']['output'];
  sha: Scalars['String']['output'];
  skippedRings: Array<Scalars['Int']['output']>;
  startedAt: Scalars['DateTime']['output'];
  startedBy: Scalars['String']['output'];
  status: OtaRolloutStatus;
  version: Scalars['String']['output'];
};

export enum OtaRolloutStatus {
  Aborted = 'ABORTED',
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Halted = 'HALTED',
  Paused = 'PAUSED'
}

export type OtaRolloutStatusOperationFilterInput = {
  eq?: InputMaybe<OtaRolloutStatus>;
  in?: InputMaybe<Array<OtaRolloutStatus>>;
  neq?: InputMaybe<OtaRolloutStatus>;
  nin?: InputMaybe<Array<OtaRolloutStatus>>;
};

/** A connection to a list of items. */
export type OtaRolloutsConnection = {
  __typename?: 'OtaRolloutsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OtaRolloutsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OtaRolloutDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OtaRolloutsEdge = {
  __typename?: 'OtaRolloutsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OtaRolloutDocument;
};

export type OtaSigningKeysPayload = {
  __typename?: 'OtaSigningKeysPayload';
  errors?: Maybe<Array<ValidationError>>;
  keys: Array<OtaSigningPublicKey>;
};

/** One public key version the firmware verifier may trust. Kid is the manifest header kid. */
export type OtaSigningPublicKey = {
  __typename?: 'OtaSigningPublicKey';
  algorithm: Scalars['String']['output'];
  isCurrent: Scalars['Boolean']['output'];
  jwk: Scalars['String']['output'];
  kid: Scalars['String']['output'];
  pem: Scalars['String']['output'];
};

export enum OutboundDetailLevel {
  ItemLevelDetail = 'ITEM_LEVEL_DETAIL',
  SummaryOnly = 'SUMMARY_ONLY'
}

/**
 * A permitted-but-flagged over-allocation on a single inventory key (item + location + grade).
 * Mirrors the domain over-allocation warning: availableQuantity is the resulting available
 * (on-hand minus allocated) AFTER the allocation and is negative when over-allocated — its
 * magnitude is the shortfall against requestedQuantity.
 */
export type OverAllocationWarningData = {
  __typename?: 'OverAllocationWarningData';
  availableQuantity: Scalars['Decimal']['output'];
  grade: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  requestedQuantity: Scalars['Decimal']['output'];
};

export type OverheadRateHistoryStateData = {
  __typename?: 'OverheadRateHistoryStateData';
  costPerSqFtPerWeek: Scalars['Decimal']['output'];
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  subLocationId?: Maybe<Scalars['String']['output']>;
};

export type OverheadRateStateData = {
  __typename?: 'OverheadRateStateData';
  costPerSqFtPerWeek: Scalars['Decimal']['output'];
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
};

export type OverrideInheritedEventForRecipeInput = {
  categoryEventId: Scalars['String']['input'];
  eventType: ProductionRecipeEventKind;
  productionRecipeId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

/**
 * The D2 override mutation's result: the recipe as it stands after the override, and the id of
 * the newly-cloned event so a caller can navigate straight to it.
 */
export type OverrideInheritedEventForRecipePayload = {
  __typename?: 'OverrideInheritedEventForRecipePayload';
  clonedEventId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  productionRecipe?: Maybe<ProductionRecipeStateData>;
};

/**
 * Canonical kind classification for a historical order-quantity override entry. The owning
 * document property is annotated [BsonRepresentation(BsonType.String)], so values are
 * persisted as BSON strings by member name; explicit integer assignments are retained for
 * JSON-side stability and future-safe migrations. Do not insert, reorder, or reassign existing
 * members. The Reverted name deliberately differs from the originating event class
 * OrderQuantityOverrideUndone because the product copy for the history surface uses
 * "Reverted".
 */
export enum OverrideKind {
  /** Originated from OrderQuantityAutoAllocated (T0b). */
  AutoAllocate = 'AUTO_ALLOCATE',
  /** Originated from OrderQuantityAdded — a bulk additive adjustment. */
  BulkAdd = 'BULK_ADD',
  /** Originated from OrderQuantitySubtracted — a bulk subtractive adjustment. */
  BulkSubtract = 'BULK_SUBTRACT',
  /** Originated from OrderQuantityReplaced — a direct manual edit of the order quantity. */
  ManualEdit = 'MANUAL_EDIT',
  /** Originated from OrderQuantityOverrideUndone. Product copy: "Reverted". */
  Reverted = 'REVERTED',
  /** Originated from OrderQuantityRoundedToFullCart. */
  RoundedToFullCart = 'ROUNDED_TO_FULL_CART',
  /** Originated from OrderQuantitySetToAchievable. */
  SetToAchievable = 'SET_TO_ACHIEVABLE',
  /** Originated from OrderQuantitySetToDemand. */
  SetToDemand = 'SET_TO_DEMAND',
  /** Originated from OrderQuantitySetToTargetWeeksOfSupply. */
  SetToTargetWeeksOfSupply = 'SET_TO_TARGET_WEEKS_OF_SUPPLY'
}

export type OverrideKindOperationFilterInput = {
  eq?: InputMaybe<OverrideKind>;
  in?: InputMaybe<Array<OverrideKind>>;
  neq?: InputMaybe<OverrideKind>;
  nin?: InputMaybe<Array<OverrideKind>>;
};

export type OverrideOrderLineUpgradePricingInput = {
  lineItemId: Scalars['String']['input'];
  lineItemUpgradeId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  pricing: OrderLineUpgradePricingDataInput;
};

export type OverrideProducedQuantityDataInput = {
  newProducedLocationId?: InputMaybe<Scalars['String']['input']>;
  newProducedLocations?: InputMaybe<Array<ProducedLocationQuantityInput>>;
  newProducedQuantity: Scalars['Decimal']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionJobLocationDataInput = {
  newLocationId: Scalars['String']['input'];
  productionJobIds: Array<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionJobQuantityDataInput = {
  newQuantity: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionJobWeekReadyDataInput = {
  newWeekReadyDate: Scalars['DateTime']['input'];
  productionJobIds: Array<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionJobWeekStartDataInput = {
  newWeekStartDate: Scalars['DateTime']['input'];
  productionJobIds: Array<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionJobYieldDataInput = {
  productionJobIds: Array<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
  yieldPercentage: Scalars['Decimal']['input'];
};

export type OverrideProductionLotCustomerDataInput = {
  newCustomerId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionLotCustomerGroupInput = {
  newCustomerGroupId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type OverrideProductionLotQuantityDataInput = {
  newQuantity: Scalars['Int']['input'];
  productionLotId: Scalars['String']['input'];
};

export type OverrideRestockSessionOrderQuantitiesInput = {
  items: Array<RestockOrderQuantityOverrideItemDataInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['String']['input'];
  targetWeeksOfSupply?: InputMaybe<Scalars['Decimal']['input']>;
  type: RestockOverrideType;
};

/** Saves a private Size UOM atomically with its Shipping UOM. Creates a missing unit or adopts and patches an existing unshared unit. Omit ownSizeUom for shared units. Code and eachesPerUnit must match the category's default code and count. */
export type OwnSizeUomDataInput = {
  /** Must equal the category's defaultSizeUomCode. */
  code: Scalars['String']['input'];
  /** The Size UOM label used by order reports. */
  description: Scalars['String']['input'];
  /** Must be positive and equal the category's eachesPerUnit. */
  eachesPerUnit: Scalars['Int']['input'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParentChildRelationship = {
  __typename?: 'ParentChildRelationship';
  parent: SiteLocationType;
  validChildren: Array<SiteLocationType>;
};

/**
 * The result of a parent-company access change: the directory entries the call left behind in each
 * tenant it touched, or the reasons it was refused.
 */
export type ParentCompanyAccessPayload = {
  __typename?: 'ParentCompanyAccessPayload';
  data?: Maybe<Array<MyParentCompanyMember>>;
  errors?: Maybe<Array<ValidationError>>;
};

export type ParentCompanyAdministratorData = {
  __typename?: 'ParentCompanyAdministratorData';
  email: Scalars['String']['output'];
  fusionAuthUserId: Scalars['String']['output'];
};

/**
 * One parent-company administrator: a customer-side person who may grant and revoke their own staff's
 * access across the group's member tenants. Identified by their FusionAuth user id; the email is
 * carried for display only and is never the identity.
 */
export type ParentCompanyAdministratorDocument = {
  __typename?: 'ParentCompanyAdministratorDocument';
  email: Scalars['String']['output'];
  fusionAuthUserId: Scalars['String']['output'];
};

/**
 * One parent-company administrator: a customer-side person who may grant and revoke their own staff's
 * access across the group's member tenants. Identified by their FusionAuth user id; the email is
 * carried for display only and is never the identity.
 */
export type ParentCompanyAdministratorDocumentFilterInput = {
  and?: InputMaybe<Array<ParentCompanyAdministratorDocumentFilterInput>>;
  email?: InputMaybe<StringOperationFilterInput>;
  fusionAuthUserId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ParentCompanyAdministratorDocumentFilterInput>>;
};

/**
 * A parent company's primary contact — the person Silver Fern escalates to about the whole group.
 * Always carries both name fields and at least one phone number or email address.
 */
export type ParentCompanyContactDocument = {
  __typename?: 'ParentCompanyContactDocument';
  emailAddresses: Array<ParentCompanyContactMethodDocument>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  phoneNumbers: Array<ParentCompanyContactMethodDocument>;
  title: Scalars['String']['output'];
  type: ContactType;
};

/**
 * A parent company's primary contact — the person Silver Fern escalates to about the whole group.
 * Always carries both name fields and at least one phone number or email address.
 */
export type ParentCompanyContactDocumentFilterInput = {
  and?: InputMaybe<Array<ParentCompanyContactDocumentFilterInput>>;
  emailAddresses?: InputMaybe<ListFilterInputTypeOfParentCompanyContactMethodDocumentFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ParentCompanyContactDocumentFilterInput>>;
  phoneNumbers?: InputMaybe<ListFilterInputTypeOfParentCompanyContactMethodDocumentFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<ContactTypeOperationFilterInput>;
};

/**
 * A parent company's primary contact — the person Silver Fern escalates to about the whole group.
 * Always carries both name fields and at least one phone number or email address.
 */
export type ParentCompanyContactDocumentSortInput = {
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/**
 * One typed phone number or email address on a parent company's primary contact. The type is text —
 * for a phone number one of MOBILE, HOME, WORK, FAX, OTHER or UNKNOWN; for an email address one of
 * HOME, WORK, OTHER or UNKNOWN.
 */
export type ParentCompanyContactMethodDocument = {
  __typename?: 'ParentCompanyContactMethodDocument';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * One typed phone number or email address on a parent company's primary contact. The type is text —
 * for a phone number one of MOBILE, HOME, WORK, FAX, OTHER or UNKNOWN; for an email address one of
 * HOME, WORK, OTHER or UNKNOWN.
 */
export type ParentCompanyContactMethodDocumentFilterInput = {
  and?: InputMaybe<Array<ParentCompanyContactMethodDocumentFilterInput>>;
  or?: InputMaybe<Array<ParentCompanyContactMethodDocumentFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A parent company: a grouping of the tenants owned by one customer, so that customer's own
 * administrators can grant their staff access across the group.
 */
export type ParentCompanyDocument = {
  __typename?: 'ParentCompanyDocument';
  /**
   * The customer-side people who may grant and revoke their own staff's access across the group's
   * member tenants. One of the two inputs to the derived status: a parent company is active only
   * when it has at least one administrator AND at least two member tenants. The other input, the
   * member-tenant count, lives on the tenant side and is read at query time.
   */
  administrators: Array<ParentCompanyAdministratorDocument>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The single person Silver Fern escalates to about the whole group. */
  primaryContact: ParentCompanyContactDocument;
  /** Derived lifecycle. ACTIVE when the parent company groups at least two member tenants AND has at least one administrator; INACTIVE otherwise; DELETED once it has been soft-deleted, which wins over both. Never stored — computed per request from the current member-tenant and administrator counts, so it can never be stale. */
  status: ParentCompanyStatus;
  /** The tenants that belong to this parent company, by name. Empty when none do. Membership is a field on the TENANT, so this is read at query time rather than projected onto the parent company. */
  tenants: Array<AdminTenantDocument>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * A parent company: a grouping of the tenants owned by one customer, so that customer's own
 * administrators can grant their staff access across the group.
 */
export type ParentCompanyDocumentFilterInput = {
  /**
   * The customer-side people who may grant and revoke their own staff's access across the group's
   * member tenants. One of the two inputs to the derived status: a parent company is active only
   * when it has at least one administrator AND at least two member tenants. The other input, the
   * member-tenant count, lives on the tenant side and is read at query time.
   */
  administrators?: InputMaybe<ListFilterInputTypeOfParentCompanyAdministratorDocumentFilterInput>;
  and?: InputMaybe<Array<ParentCompanyDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ParentCompanyDocumentFilterInput>>;
  /** The single person Silver Fern escalates to about the whole group. */
  primaryContact?: InputMaybe<ParentCompanyContactDocumentFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A parent company: a grouping of the tenants owned by one customer, so that customer's own
 * administrators can grant their staff access across the group.
 */
export type ParentCompanyDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /** The single person Silver Fern escalates to about the whole group. */
  primaryContact?: InputMaybe<ParentCompanyContactDocumentSortInput>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ParentCompanyStateData = {
  __typename?: 'ParentCompanyStateData';
  administrators: Array<ParentCompanyAdministratorData>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentCompanyId: Scalars['String']['output'];
  primaryContact: ContactData;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ParentCompanyStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

/**
 * GraphQL input for patching a single tenant. Null fields are not changed.
 * TrialExpirationDate sets the trial expiry; ClearTrialExpirationDate: true
 * removes it (the two are mutually exclusive — null on a patch input means "unchanged",
 * so clearing needs the explicit flag). TrialKind, TrialLimits and
 * TrialDataDeletedDate follow the same set/clear convention.
 */
export type PatchAdminTenantDataInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  businessTimeZone?: InputMaybe<Scalars['String']['input']>;
  clearOnboardingHelpUntil?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrialDataDeletedDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrialExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrialKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrialLimits?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Contracted Products text staff type from the signed contract. It shows only while the tenant has no WorkSuite products: once its products are set, contractedProducts shows their names instead. Null leaves it unchanged; an empty string clears it. */
  contractedProducts?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  finalCreditEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingHelpUntil?: InputMaybe<Scalars['DateTime']['input']>;
  onboardingSetup?: InputMaybe<OnboardingSetupStage>;
  onboardingTraining?: InputMaybe<OnboardingTrainingStatus>;
  poNumberMaxLength?: InputMaybe<Scalars['Int']['input']>;
  pricingCalcDecimals?: InputMaybe<Scalars['Int']['input']>;
  produceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  restockCalcEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  restockCalcMaxStalenessHours?: InputMaybe<Scalars['Int']['input']>;
  restockCalcRefreshHours?: InputMaybe<Scalars['Int']['input']>;
  restockCalcStrategyKey?: InputMaybe<Scalars['String']['input']>;
  trialDataDeletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  trialExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  trialKind?: InputMaybe<TrialKind>;
  trialLimits?: InputMaybe<TrialLimitsDataInput>;
  unitConfig?: InputMaybe<TenantUnitConfigDataInput>;
  useErpPricing?: InputMaybe<Scalars['Boolean']['input']>;
};

/** GraphQL input for batch-patching multiple tenants in a single request. */
export type PatchBatchAdminTenantInput = {
  tenants: Array<PatchAdminTenantDataInput>;
};

export type PatchItemInput = {
  categories?: InputMaybe<Array<ItemCategoryAssignmentDataInput>>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  native?: InputMaybe<Scalars['Boolean']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  stripeTaxCode?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PauseCountSessionInput = {
  countSessionId: Scalars['String']['input'];
};

export type PauseOtaRolloutInput = {
  fromRing: Scalars['Int']['input'];
  lineId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  rolloutId: Scalars['String']['input'];
};

export enum PaymentAttemptAllocationOutcome {
  Applied = 'APPLIED',
  InvoiceVoided = 'INVOICE_VOIDED',
  NothingPayable = 'NOTHING_PAYABLE'
}

export enum PaymentAttemptChannel {
  Guest = 'GUEST',
  Portal = 'PORTAL'
}

export enum PaymentAttemptDisputeOutcome {
  InquiryClosed = 'INQUIRY_CLOSED',
  Lost = 'LOST',
  Unknown = 'UNKNOWN',
  Won = 'WON'
}

export enum PaymentAttemptRefundStatus {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum PaymentAttemptRefundTarget {
  Payment = 'PAYMENT',
  UnappliedCredit = 'UNAPPLIED_CREDIT',
  Unknown = 'UNKNOWN'
}

export enum PaymentAttemptReversalKind {
  DisputeFundsWithdrawn = 'DISPUTE_FUNDS_WITHDRAWN',
  Refund = 'REFUND',
  Unknown = 'UNKNOWN'
}

export enum PaymentAttemptStatus {
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Open = 'OPEN',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED'
}

/** Data projection of payment-processor state returned in mutation payloads. */
export type PaymentProcessorData = {
  __typename?: 'PaymentProcessorData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlinePaymentMaxAmount: Scalars['Long']['output'];
  status: PaymentProcessorStatus;
};

/**
 * MongoDB read model for one system payment-processor row (T28). One document per processor, on the
 * PaymentProcessors collection; at most one is ever Active.
 * Deleted rows are RETAINED here and filtered at query level (see AdminPaymentProcessorQuery)
 * rather than removed + tombstoned — see the xmldoc on
 * PaymentProcessorDeleted for why.
 */
export type PaymentProcessorDocument = {
  __typename?: 'PaymentProcessorDocument';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlinePaymentMaxAmount: Scalars['Long']['output'];
  status: PaymentProcessorStatus;
};

/**
 * GraphQL mutation payload for admin payment-processor operations, containing either the resulting
 * processor or validation errors.
 */
export type PaymentProcessorPayload = {
  __typename?: 'PaymentProcessorPayload';
  data?: Maybe<PaymentProcessorData>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum PaymentProcessorStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export enum PaymentReconciliationExceptionReason {
  AccountMismatch = 'ACCOUNT_MISMATCH',
  AmountMismatch = 'AMOUNT_MISMATCH',
  AttemptNotPayable = 'ATTEMPT_NOT_PAYABLE',
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  PaymentIntentMismatch = 'PAYMENT_INTENT_MISMATCH',
  RefundFailedAfterReversal = 'REFUND_FAILED_AFTER_REVERSAL',
  ReversalBeforeSettlement = 'REVERSAL_BEFORE_SETTLEMENT',
  ReversalExceedsPayment = 'REVERSAL_EXCEEDS_PAYMENT',
  SessionMismatch = 'SESSION_MISMATCH',
  UnexpectedPaymentState = 'UNEXPECTED_PAYMENT_STATE',
  Unknown = 'UNKNOWN',
  UnknownReference = 'UNKNOWN_REFERENCE'
}

export enum PaymentStatus {
  Overpaid = 'OVERPAID',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Unpaid = 'UNPAID'
}

export type PaymentStatusOperationFilterInput = {
  eq?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  neq?: InputMaybe<PaymentStatus>;
  nin?: InputMaybe<Array<PaymentStatus>>;
};

/** Where one payment recorded in FULFILL stands with the tenant's accounting platform. */
export enum PaymentSyncStatus {
  /** Created in the accounting platform; accountingPaymentId names it there. */
  Completed = 'COMPLETED',
  /** Export failed and will not be retried; syncFailureReason says why. */
  FailedPermanent = 'FAILED_PERMANENT',
  /** The last attempt failed and will be retried; syncFailureReason says why. */
  FailedTransient = 'FAILED_TRANSIENT',
  /**
   * Nothing to sync: the tenant has no accounting integration, the payment came from the accounting
   * platform itself, or it was recorded before per-payment sync existed.
   */
  NotApplicable = 'NOT_APPLICABLE',
  /** Armed for export; the worker has not created it in the accounting platform yet. */
  Pending = 'PENDING',
  /**
   * The tenant is integrated but this payment is kept in FULFILL only — the platform cannot create
   * payments through Merge, or the invoice it settles was never exported.
   */
  RecordedLocallyOnly = 'RECORDED_LOCALLY_ONLY'
}

export type PendingCountCorrection = {
  __typename?: 'PendingCountCorrection';
  correctionId: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  kind: CountCorrectionKind;
  refusalReason?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Scalars['String']['output'];
  state: CountCorrectionState;
  stateChangedAt: Scalars['DateTime']['output'];
  value: Scalars['Decimal']['output'];
  version: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type PendingErpWriteBacksConnection = {
  __typename?: 'PendingErpWriteBacksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PendingErpWriteBacksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ErpWriteBackDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PendingErpWriteBacksEdge = {
  __typename?: 'PendingErpWriteBacksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ErpWriteBackDocument;
};

/** One production entry waiting for a production admin, with the job it is for. */
export type PendingProductionEntry = {
  __typename?: 'PendingProductionEntry';
  /** The entry id. */
  entryId: Scalars['UUID']['output'];
  /** The item the lot grows (the catalog item when the lot has none). */
  itemId: Scalars['String']['output'];
  /** The item's name, when known. */
  itemName?: Maybe<Scalars['String']['output']>;
  /** The entered split with location names; empty means the job's own location. */
  locations: Array<ProducedLocationQuantity>;
  /** The job. */
  productionJobId: Scalars['String']['output'];
  /** The lot. */
  productionLotId: Scalars['String']['output'];
  /** The entered produced quantity. */
  quantity: Scalars['Decimal']['output'];
  /** The job's ready week as yyyyww, for example 202644 is week 44 of 2026. */
  readyWeek?: Maybe<Scalars['Int']['output']>;
  /** When the entry was made. */
  submittedAt: Scalars['DateTime']['output'];
  /** Email of the person who made the entry. */
  submittedBy: Scalars['String']['output'];
};

/**
 * Read-model document for the pending-transfer-orders projection (MTR-04).
 * A document is materialised when a MovementOrderEvents.V1.MovementOrderCreated
 * event lands; MovementOrderEvents.V1.MovementOrderReceived writes a soft-delete
 * tombstone (IsReceived = true) rather than removing the row, so a
 * stale Created or Shipped redelivered after Received cannot resurrect a deleted document.
 * The MTR-02 pendingTransferOrdersByDestination query filters out tombstoned rows.
 */
export type PendingTransferOrderDocument = {
  __typename?: 'PendingTransferOrderDocument';
  /** Timestamp from the originating create event. */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the movement order. */
  createdBy: Scalars['String']['output'];
  /**
   * Expected arrival date for the transfer. MTR-04 events do not carry an explicit
   * expected date, so the projection defaults this to the Created event's
   * OccurredAt. When the business wires a true expected-date field onto the
   * command and event, the projection assignment is the only line that needs to change.
   */
  expectedDate: Scalars['DateTime']['output'];
  /** Source site (where stock is shipping from). */
  fromSiteLocationId: Scalars['String']['output'];
  /**
   * Denormalized source SiteLocation.Name resolved by the mutation layer at command
   * time (MovementOrderMutation.ResolveSiteLocationName) and carried on the
   * event payload. The projection writes this value through with no external reads
   * (discipline accaf08f). Empty string when the SiteLocation reference could not be
   * resolved at command time, or when a historical V1 event that predated the enrichment
   * fields is replayed — fail-soft so the row still lands and the receive UI is never
   * blocked on missing reference data.
   */
  fromSiteLocationName: Scalars['String']['output'];
  /**
   * Tombstone marker — true once MovementOrderReceived has landed. The Created
   * and Shipped handlers short-circuit when this is true so a stale redelivered event
   * cannot resurrect a received transfer onto the pending list.
   */
  isReceived: Scalars['Boolean']['output'];
  /** Per-line snapshot from the most recent create-or-ship event. */
  lines: Array<PendingTransferOrderLineDocument>;
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId: Scalars['String']['output'];
  /** Receive timestamp; populated alongside IsReceived on tombstone. */
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Receiver; populated alongside IsReceived on tombstone. */
  receivedBy?: Maybe<Scalars['String']['output']>;
  /** Optional timestamp populated when MovementOrderShipped lands. */
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Optional shipper populated when MovementOrderShipped lands. */
  shippedBy?: Maybe<Scalars['String']['output']>;
  /**
   * Lifecycle status — Created or Shipped while the row is active; Received once
   *             the row is tombstoned (see IsReceived). Readers MUST filter
   *             IsReceived != true to exclude tombstones (see MTR-02's query filter).
   */
  status: MovementOrderStatus;
  /** Owning tenant. */
  tenantId: Scalars['String']['output'];
  /** Destination site — the projection's primary lookup key for the MTR-02 query. */
  toSiteLocationId: Scalars['String']['output'];
  /**
   * Denormalized destination SiteLocation.Name resolved by the mutation layer at
   * command time (MovementOrderMutation.ResolveSiteLocationName) and carried
   * on the event payload; written through by the projection with no external reads. Empty
   * string under the same fail-soft contract as FromSiteLocationName.
   */
  toSiteLocationName: Scalars['String']['output'];
  /**
   * Human-readable transfer-order number used by the mobile receive UI as the visible
   * row label. MTR-04 events do not carry an explicit number, so the projection derives
   * it deterministically from MovementOrderId (first six hex chars). The
   * derivation lives in the projection so a future event-side number can replace it
   * without changing the read-model contract.
   */
  transferOrderNumber: Scalars['String']['output'];
  /** Timestamp of the most recent event that updated this document. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Read-model document for the pending-transfer-orders projection (MTR-04).
 * A document is materialised when a MovementOrderEvents.V1.MovementOrderCreated
 * event lands; MovementOrderEvents.V1.MovementOrderReceived writes a soft-delete
 * tombstone (IsReceived = true) rather than removing the row, so a
 * stale Created or Shipped redelivered after Received cannot resurrect a deleted document.
 * The MTR-02 pendingTransferOrdersByDestination query filters out tombstoned rows.
 */
export type PendingTransferOrderDocumentFilterInput = {
  and?: InputMaybe<Array<PendingTransferOrderDocumentFilterInput>>;
  /** Timestamp from the originating create event. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** User who created the movement order. */
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Expected arrival date for the transfer. MTR-04 events do not carry an explicit
   * expected date, so the projection defaults this to the Created event's
   * OccurredAt. When the business wires a true expected-date field onto the
   * command and event, the projection assignment is the only line that needs to change.
   */
  expectedDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Source site (where stock is shipping from). */
  fromSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized source SiteLocation.Name resolved by the mutation layer at command
   * time (MovementOrderMutation.ResolveSiteLocationName) and carried on the
   * event payload. The projection writes this value through with no external reads
   * (discipline accaf08f). Empty string when the SiteLocation reference could not be
   * resolved at command time, or when a historical V1 event that predated the enrichment
   * fields is replayed — fail-soft so the row still lands and the receive UI is never
   * blocked on missing reference data.
   */
  fromSiteLocationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Tombstone marker — true once MovementOrderReceived has landed. The Created
   * and Shipped handlers short-circuit when this is true so a stale redelivered event
   * cannot resurrect a received transfer onto the pending list.
   */
  isReceived?: InputMaybe<BooleanOperationFilterInput>;
  /** Per-line snapshot from the most recent create-or-ship event. */
  lines?: InputMaybe<ListFilterInputTypeOfPendingTransferOrderLineDocumentFilterInput>;
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PendingTransferOrderDocumentFilterInput>>;
  /** Receive timestamp; populated alongside IsReceived on tombstone. */
  receivedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Receiver; populated alongside IsReceived on tombstone. */
  receivedBy?: InputMaybe<OptionOfStringFilterInput>;
  /** Optional timestamp populated when MovementOrderShipped lands. */
  shippedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Optional shipper populated when MovementOrderShipped lands. */
  shippedBy?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * Lifecycle status — Created or Shipped while the row is active; Received once
   *             the row is tombstoned (see IsReceived). Readers MUST filter
   *             IsReceived != true to exclude tombstones (see MTR-02's query filter).
   */
  status?: InputMaybe<MovementOrderStatusOperationFilterInput>;
  /** Owning tenant. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Destination site — the projection's primary lookup key for the MTR-02 query. */
  toSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized destination SiteLocation.Name resolved by the mutation layer at
   * command time (MovementOrderMutation.ResolveSiteLocationName) and carried
   * on the event payload; written through by the projection with no external reads. Empty
   * string under the same fail-soft contract as FromSiteLocationName.
   */
  toSiteLocationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Human-readable transfer-order number used by the mobile receive UI as the visible
   * row label. MTR-04 events do not carry an explicit number, so the projection derives
   * it deterministically from MovementOrderId (first six hex chars). The
   * derivation lives in the projection so a future event-side number can replace it
   * without changing the read-model contract.
   */
  transferOrderNumber?: InputMaybe<StringOperationFilterInput>;
  /** Timestamp of the most recent event that updated this document. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Read-model document for the pending-transfer-orders projection (MTR-04).
 * A document is materialised when a MovementOrderEvents.V1.MovementOrderCreated
 * event lands; MovementOrderEvents.V1.MovementOrderReceived writes a soft-delete
 * tombstone (IsReceived = true) rather than removing the row, so a
 * stale Created or Shipped redelivered after Received cannot resurrect a deleted document.
 * The MTR-02 pendingTransferOrdersByDestination query filters out tombstoned rows.
 */
export type PendingTransferOrderDocumentSortInput = {
  /** Timestamp from the originating create event. */
  createdAt?: InputMaybe<SortEnumType>;
  /** User who created the movement order. */
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * Expected arrival date for the transfer. MTR-04 events do not carry an explicit
   * expected date, so the projection defaults this to the Created event's
   * OccurredAt. When the business wires a true expected-date field onto the
   * command and event, the projection assignment is the only line that needs to change.
   */
  expectedDate?: InputMaybe<SortEnumType>;
  /** Source site (where stock is shipping from). */
  fromSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Denormalized source SiteLocation.Name resolved by the mutation layer at command
   * time (MovementOrderMutation.ResolveSiteLocationName) and carried on the
   * event payload. The projection writes this value through with no external reads
   * (discipline accaf08f). Empty string when the SiteLocation reference could not be
   * resolved at command time, or when a historical V1 event that predated the enrichment
   * fields is replayed — fail-soft so the row still lands and the receive UI is never
   * blocked on missing reference data.
   */
  fromSiteLocationName?: InputMaybe<SortEnumType>;
  /**
   * Tombstone marker — true once MovementOrderReceived has landed. The Created
   * and Shipped handlers short-circuit when this is true so a stale redelivered event
   * cannot resurrect a received transfer onto the pending list.
   */
  isReceived?: InputMaybe<SortEnumType>;
  /** MovementOrder aggregate id (stable across the lifecycle). */
  movementOrderId?: InputMaybe<SortEnumType>;
  /** Receive timestamp; populated alongside IsReceived on tombstone. */
  receivedAt?: InputMaybe<SortEnumType>;
  /** Receiver; populated alongside IsReceived on tombstone. */
  receivedBy?: InputMaybe<SortEnumType>;
  /** Optional timestamp populated when MovementOrderShipped lands. */
  shippedAt?: InputMaybe<SortEnumType>;
  /** Optional shipper populated when MovementOrderShipped lands. */
  shippedBy?: InputMaybe<SortEnumType>;
  /**
   * Lifecycle status — Created or Shipped while the row is active; Received once
   *             the row is tombstoned (see IsReceived). Readers MUST filter
   *             IsReceived != true to exclude tombstones (see MTR-02's query filter).
   */
  status?: InputMaybe<SortEnumType>;
  /** Owning tenant. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Destination site — the projection's primary lookup key for the MTR-02 query. */
  toSiteLocationId?: InputMaybe<SortEnumType>;
  /**
   * Denormalized destination SiteLocation.Name resolved by the mutation layer at
   * command time (MovementOrderMutation.ResolveSiteLocationName) and carried
   * on the event payload; written through by the projection with no external reads. Empty
   * string under the same fail-soft contract as FromSiteLocationName.
   */
  toSiteLocationName?: InputMaybe<SortEnumType>;
  /**
   * Human-readable transfer-order number used by the mobile receive UI as the visible
   * row label. MTR-04 events do not carry an explicit number, so the projection derives
   * it deterministically from MovementOrderId (first six hex chars). The
   * derivation lives in the projection so a future event-side number can replace it
   * without changing the read-model contract.
   */
  transferOrderNumber?: InputMaybe<SortEnumType>;
  /** Timestamp of the most recent event that updated this document. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/**
 * Per-line snapshot persisted on PendingTransferOrderDocument.Lines.
 * Field-for-field mirror of MovementOrderEvents.V1.MovementOrderLineEventRecord
 * so the projection only has to translate the language-ext Option{T}
 * shape that is registered for Mongo serialization, plus denormalized
 * MaterialItemName / MaterialItemErpId resolved by the mutation
 * layer at command time and carried on the event payload (fail-soft to empty string when the
 * MaterialItem reference could not be resolved).
 */
export type PendingTransferOrderLineDocument = {
  __typename?: 'PendingTransferOrderLineDocument';
  /** Locked-at-receive-time organic flag (false until receipt — included for snapshot completeness). */
  isOrganicAtReceive: Scalars['Boolean']['output'];
  /** Stable line-item id (matches the event's LineItemId). */
  lineItemId: Scalars['String']['output'];
  /**
   * Denormalized MaterialItem.ErpId resolved by the mutation layer at command time
   * and carried on the event payload. Empty string under the same fail-soft contract as
   * MaterialItemName.
   */
  materialItemErpId: Scalars['String']['output'];
  /** MaterialItem moving on this line. */
  materialItemId: Scalars['String']['output'];
  /**
   * Denormalized MaterialItem.Name resolved by the mutation layer at command time
   * (MovementOrderMutation.ResolveMaterialEnrichment) and carried on the event
   * payload; written through by the projection with no external reads (discipline accaf08f).
   * Empty string when the MaterialItem reference could not be resolved at command time.
   */
  materialItemName: Scalars['String']['output'];
  /** Optional organic lot identifier carried verbatim from the source lot. */
  organicLotCode?: Maybe<Scalars['String']['output']>;
  /** Quantity recorded by the originating event (Created = ordered; Shipped = actual shipped). */
  quantity: Scalars['Decimal']['output'];
  /** Optional vendor lot identifier (BPF Tier 2 future-proofing). */
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Per-line snapshot persisted on PendingTransferOrderDocument.Lines.
 * Field-for-field mirror of MovementOrderEvents.V1.MovementOrderLineEventRecord
 * so the projection only has to translate the language-ext Option{T}
 * shape that is registered for Mongo serialization, plus denormalized
 * MaterialItemName / MaterialItemErpId resolved by the mutation
 * layer at command time and carried on the event payload (fail-soft to empty string when the
 * MaterialItem reference could not be resolved).
 */
export type PendingTransferOrderLineDocumentFilterInput = {
  and?: InputMaybe<Array<PendingTransferOrderLineDocumentFilterInput>>;
  /** Locked-at-receive-time organic flag (false until receipt — included for snapshot completeness). */
  isOrganicAtReceive?: InputMaybe<BooleanOperationFilterInput>;
  /** Stable line-item id (matches the event's LineItemId). */
  lineItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized MaterialItem.ErpId resolved by the mutation layer at command time
   * and carried on the event payload. Empty string under the same fail-soft contract as
   * MaterialItemName.
   */
  materialItemErpId?: InputMaybe<StringOperationFilterInput>;
  /** MaterialItem moving on this line. */
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized MaterialItem.Name resolved by the mutation layer at command time
   * (MovementOrderMutation.ResolveMaterialEnrichment) and carried on the event
   * payload; written through by the projection with no external reads (discipline accaf08f).
   * Empty string when the MaterialItem reference could not be resolved at command time.
   */
  materialItemName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PendingTransferOrderLineDocumentFilterInput>>;
  /** Optional organic lot identifier carried verbatim from the source lot. */
  organicLotCode?: InputMaybe<OptionOfStringFilterInput>;
  /** Quantity recorded by the originating event (Created = ordered; Shipped = actual shipped). */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Optional vendor lot identifier (BPF Tier 2 future-proofing). */
  vendorLotNumber?: InputMaybe<OptionOfStringFilterInput>;
};

/** A connection to a list of items. */
export type PendingTransferOrdersByDestinationConnection = {
  __typename?: 'PendingTransferOrdersByDestinationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PendingTransferOrdersByDestinationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PendingTransferOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PendingTransferOrdersByDestinationEdge = {
  __typename?: 'PendingTransferOrdersByDestinationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PendingTransferOrderDocument;
};

/** Filter operations on a percent-value-at-boundary decimal field. Operand semantics mirror the displayed unit (e.g. 5 means 5%, not 5× the value). The Mongo provider divides operands by 100 before comparing against the stored fraction. */
export type PercentValueOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PhoneNumberData = {
  __typename?: 'PhoneNumberData';
  type: PhoneNumberType;
  value: Scalars['String']['output'];
};

export type PhoneNumberDataInput = {
  type: PhoneNumberType;
  value: Scalars['String']['input'];
};

export enum PhoneNumberType {
  Fax = 'FAX',
  Home = 'HOME',
  Mobile = 'MOBILE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  Work = 'WORK'
}

/** The pickup window of a Load: a date and a from and to time. */
export type PickupWindowDocument = {
  __typename?: 'PickupWindowDocument';
  date: Scalars['LocalDate']['output'];
  /** Wall-clock time local to the pickup site, HH:mm, as typed. No time-zone conversion. */
  from: Scalars['String']['output'];
  /** Wall-clock time local to the pickup site, HH:mm, as typed, after From. No time-zone conversion. */
  to: Scalars['String']['output'];
};

/** The pickup window of a Load: a date and a from and to time. */
export type PickupWindowDocumentFilterInput = {
  and?: InputMaybe<Array<PickupWindowDocumentFilterInput>>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  /** Wall-clock time local to the pickup site, HH:mm, as typed. No time-zone conversion. */
  from?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PickupWindowDocumentFilterInput>>;
  /** Wall-clock time local to the pickup site, HH:mm, as typed, after From. No time-zone conversion. */
  to?: InputMaybe<StringOperationFilterInput>;
};

/** The pickup window of a Load: a date and a from and to time. */
export type PickupWindowDocumentSortInput = {
  date?: InputMaybe<SortEnumType>;
  /** Wall-clock time local to the pickup site, HH:mm, as typed. No time-zone conversion. */
  from?: InputMaybe<SortEnumType>;
  /** Wall-clock time local to the pickup site, HH:mm, as typed, after From. No time-zone conversion. */
  to?: InputMaybe<SortEnumType>;
};

/** The pickup window of a Load: a date and a from and to time. */
export type PickupWindowStateData = {
  __typename?: 'PickupWindowStateData';
  date: Scalars['LocalDate']['output'];
  /** Wall-clock time local to the pickup site, HH:mm, as typed. No time-zone conversion. */
  from: Scalars['String']['output'];
  /** Wall-clock time local to the pickup site, HH:mm, as typed, after From. No time-zone conversion. */
  to: Scalars['String']['output'];
};

/** Pins a run so retention keeps it. */
export type PinQaTestRunInput = {
  /** The run id (ADO build number or local run id). */
  id: Scalars['String']['input'];
  /** Why the run is kept, e.g. the release it is evidence for. Required. */
  reason: Scalars['String']['input'];
  /** Keep the run until this instant. Null pins it indefinitely. */
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PlaceOrderHoldInput = {
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type PlanCellEditInput = {
  cell: ForecastPlanCell;
  itemId: Scalars['String']['input'];
  operation: ForecastPlanCellEditOperation;
  region: Scalars['String']['input'];
  value: Scalars['Decimal']['input'];
};

/** Planned moves: one Move task per job, due on moveDate. */
export type PlanProductionJobMovesInput = {
  moveDate: Scalars['DateTime']['input'];
  /** At most 100. */
  moves: Array<PlannedProductionJobMoveInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** The result of planProductionJobMoves. */
export type PlanProductionJobMovesPayload = {
  __typename?: 'PlanProductionJobMovesPayload';
  errors?: Maybe<Array<ValidationError>>;
  /** The Move task created for each job, in request order. Null when errors are returned. */
  taskAssignmentIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** The planned arrival at one route stop of a Load. */
export type PlannedArrivalDocument = {
  __typename?: 'PlannedArrivalDocument';
  routeStopId: Scalars['String']['output'];
  /** Wall-clock time local to the ship-to, HH:mm, as typed. No time-zone conversion. */
  time: Scalars['String']['output'];
};

/** The planned arrival at one route stop of a Load. */
export type PlannedArrivalDocumentFilterInput = {
  and?: InputMaybe<Array<PlannedArrivalDocumentFilterInput>>;
  or?: InputMaybe<Array<PlannedArrivalDocumentFilterInput>>;
  routeStopId?: InputMaybe<StringOperationFilterInput>;
  /** Wall-clock time local to the ship-to, HH:mm, as typed. No time-zone conversion. */
  time?: InputMaybe<StringOperationFilterInput>;
};

/** Whether a stop's notice could be sent now. */
export enum PlannedArrivalNoticeReadiness {
  /** No order at the stop resolves a recipient. */
  MissingRecipient = 'MISSING_RECIPIENT',
  /** The stop is missing a driver or a rack count. */
  NotReady = 'NOT_READY',
  /** The stop has no planned arrival time. */
  NoPlannedTime = 'NO_PLANNED_TIME',
  /** Everything the notice needs is present. */
  Ready = 'READY',
  /** An order at the stop is set never to receive this notice. */
  Suppressed = 'SUPPRESSED',
  /** Unset; never returned. */
  Unknown = 'UNKNOWN'
}

/** What a request did for one stop. Per-stop outcomes are data, never errors. */
export enum PlannedArrivalNoticeRequestOutcome {
  /** This stop and planned time were already notified with the current content. */
  AlreadySent = 'ALREADY_SENT',
  /** A notice for this stop and planned time is already pending, sending or uncertain. */
  InFlight = 'IN_FLIGHT',
  /** No order at the stop resolves a recipient. */
  MissingRecipient = 'MISSING_RECIPIENT',
  /** The route stop is not one of the load's served stops. */
  NotOnLoad = 'NOT_ON_LOAD',
  /** The stop is missing a driver or a rack count; see missingField. */
  NotReady = 'NOT_READY',
  /** A corrected notice was asked for a stop whose content has not changed since its last send. */
  NotStale = 'NOT_STALE',
  /** The stop has no planned arrival time. */
  NoPlannedTime = 'NO_PLANNED_TIME',
  /** A notice was reserved for the worker to send, or a failed one was queued again. */
  Reserved = 'RESERVED',
  /** This stop and planned time were notified, but the content has changed since; see changedFields. */
  Stale = 'STALE',
  /** An order at the stop is set never to receive this notice; see blockingOrderNumber. */
  Suppressed = 'SUPPRESSED',
  /** Unset; never returned. */
  Unknown = 'UNKNOWN'
}

/** One stop in a notice request. */
export type PlannedArrivalNoticeStopInput = {
  /**
   * True to send a corrected notice for a stop that reads stale; it replaces the last notice and says what
   * changed. False sends the stop's first notice for its planned time.
   */
  corrected?: Scalars['Boolean']['input'];
  /** The route stop to notify. */
  routeStopId: Scalars['String']['input'];
};

/** What a request did for one stop. */
export type PlannedArrivalNoticeStopResult = {
  __typename?: 'PlannedArrivalNoticeStopResult';
  /** For a suppressed stop, the order that suppresses it. */
  blockingOrderNumber?: Maybe<Scalars['String']['output']>;
  /** For a stale stop or a corrected send, what changed since the last send. */
  changedFields: Array<Scalars['String']['output']>;
  /** For a stop that is not ready, the missing field: driverName or rackCount. */
  missingField?: Maybe<Scalars['String']['output']>;
  /** What happened. */
  outcome: PlannedArrivalNoticeRequestOutcome;
  /** The reservation made or found; null when there is none. */
  reservationId?: Maybe<Scalars['String']['output']>;
  /** The route stop. */
  routeStopId: Scalars['String']['output'];
  /** Conditions worth attention that did not stop the notice. */
  warnings: Array<PlannedArrivalNoticeWarning>;
};

/** One warning about a stop's notice. */
export type PlannedArrivalNoticeWarning = {
  __typename?: 'PlannedArrivalNoticeWarning';
  /** What the warning is. */
  code: PlannedArrivalNoticeWarningCode;
  /** The delivery date those orders expect. */
  orderDeliveryDate: Scalars['LocalDate']['output'];
  /** The orders it names. */
  orderNumbers: Array<Scalars['String']['output']>;
  /** The stop's planned delivery date. */
  plannedDeliveryDate: Scalars['LocalDate']['output'];
};

/** A condition worth the planner's attention that does not stop the notice. */
export enum PlannedArrivalNoticeWarningCode {
  /**
   * Orders at the stop expect a delivery date other than the stop's planned delivery date. The notice
   * never changes the order's date.
   */
  DeliveryDateMismatch = 'DELIVERY_DATE_MISMATCH',
  /** Unset; never returned. */
  Unknown = 'UNKNOWN'
}

/** The planned arrival at one route stop of a Load. */
export type PlannedArrivalStateData = {
  __typename?: 'PlannedArrivalStateData';
  routeStopId: Scalars['String']['output'];
  /** Wall-clock time local to the ship-to, HH:mm, as typed. No time-zone conversion. */
  time: Scalars['String']['output'];
};

/**
 * Provenance of a job's effective planned labor hours, surfaced via the computed
 * plannedHoursSource field. Ordinals are wire values — do not renumber.
 */
export enum PlannedHoursSource {
  Manual = 'MANUAL',
  Recipe = 'RECIPE'
}

/**
 * A lot that does not exist yet, for the previewPlannedLotStarts query. The key is the caller's own
 * and comes back on the matching result.
 */
export type PlannedLotInput = {
  key: Scalars['String']['input'];
  productionItemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  weekReadyDate: Scalars['DateTime']['input'];
};

/**
 * When a planned lot would start if it were created: the recipe variation lot creation would pick,
 * its grow weeks, and the week start those give. When no variation can be picked, the start, grow
 * weeks and variation are null and errors says why.
 */
export type PlannedLotStartPreview = {
  __typename?: 'PlannedLotStartPreview';
  errors?: Maybe<Array<ValidationError>>;
  growWeeks?: Maybe<Scalars['Int']['output']>;
  key: Scalars['String']['output'];
  productionItemId: Scalars['String']['output'];
  productionRecipeVariationId?: Maybe<Scalars['String']['output']>;
  weekStartDate?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * A dated move of one production job, carried by a Move task. Completing the task moves the job, and its posted
 * stock, from the from-location to the to-location.
 */
export type PlannedProductionJobMove = {
  __typename?: 'PlannedProductionJobMove';
  /** The job's location when the move was planned. Null when the job had none. */
  fromLocationId?: Maybe<Scalars['String']['output']>;
  /** The name of the from-location when the move was planned. */
  fromLocationName?: Maybe<Scalars['String']['output']>;
  /** The date the move is planned for. */
  moveDate: Scalars['DateTime']['output'];
  /** The job that moves. */
  productionJobId: Scalars['String']['output'];
  /** The lot the job belongs to. */
  productionLotId: Scalars['String']['output'];
  /** The location the job moves to when the task is completed. */
  toLocationId: Scalars['String']['output'];
  /** The name of the destination when the move was planned. */
  toLocationName: Scalars['String']['output'];
};

/**
 * A dated move of one production job, carried by a Move task. Completing the task moves the job, and its posted
 * stock, from the from-location to the to-location.
 */
export type PlannedProductionJobMoveFilterInput = {
  and?: InputMaybe<Array<PlannedProductionJobMoveFilterInput>>;
  /** The job's location when the move was planned. Null when the job had none. */
  fromLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The name of the from-location when the move was planned. */
  fromLocationName?: InputMaybe<StringOperationFilterInput>;
  /** The date the move is planned for. */
  moveDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PlannedProductionJobMoveFilterInput>>;
  /** The job that moves. */
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  /** The lot the job belongs to. */
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  /** The location the job moves to when the task is completed. */
  toLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The name of the destination when the move was planned. */
  toLocationName?: InputMaybe<StringOperationFilterInput>;
};

/** One job to move on a planned date. */
export type PlannedProductionJobMoveInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  toLocationId: Scalars['String']['input'];
};

/**
 * A dated move of one production job, carried by a Move task. Completing the task moves the job, and its posted
 * stock, from the from-location to the to-location.
 */
export type PlannedProductionJobMoveSortInput = {
  /** The job's location when the move was planned. Null when the job had none. */
  fromLocationId?: InputMaybe<SortEnumType>;
  /** The name of the from-location when the move was planned. */
  fromLocationName?: InputMaybe<SortEnumType>;
  /** The date the move is planned for. */
  moveDate?: InputMaybe<SortEnumType>;
  /** The job that moves. */
  productionJobId?: InputMaybe<SortEnumType>;
  /** The lot the job belongs to. */
  productionLotId?: InputMaybe<SortEnumType>;
  /** The location the job moves to when the task is completed. */
  toLocationId?: InputMaybe<SortEnumType>;
  /** The name of the destination when the move was planned. */
  toLocationName?: InputMaybe<SortEnumType>;
};

export type PlantsPerPotOverride = {
  __typename?: 'PlantsPerPotOverride';
  plantsPerPot: Scalars['Int']['output'];
  productionRecipeVariationId: Scalars['String']['output'];
  setAt: Scalars['DateTime']['output'];
  setBy: Scalars['String']['output'];
};

export type PlantsPerPotOverrideFilterInput = {
  and?: InputMaybe<Array<PlantsPerPotOverrideFilterInput>>;
  or?: InputMaybe<Array<PlantsPerPotOverrideFilterInput>>;
  plantsPerPot?: InputMaybe<IntOperationFilterInput>;
  productionRecipeVariationId?: InputMaybe<StringOperationFilterInput>;
  setAt?: InputMaybe<DateTimeOperationFilterInput>;
  setBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Pod assignment embedded in the admin background service config document.
 * When NotTenants is true, the pod runs for all active tenants EXCEPT
 * those in TenantIds (exclusion mode); when false, only for the listed tenants.
 * Replicas is the deployment replica count for this assignment.
 */
export type PodAssignmentData = {
  __typename?: 'PodAssignmentData';
  notTenants: Scalars['Boolean']['output'];
  podName: Scalars['String']['output'];
  replicas: Scalars['Int']['output'];
  tenantIds: Array<Scalars['String']['output']>;
};

export type PodAssignmentDataInput = {
  notTenants?: Scalars['Boolean']['input'];
  podName: Scalars['String']['input'];
  replicas?: Scalars['Int']['input'];
  tenantIds: Array<Scalars['String']['input']>;
};

export type PodAssignmentStateData = {
  __typename?: 'PodAssignmentStateData';
  /**
   * When true, the pod runs for all active tenants EXCEPT those in TenantIds
   * (exclusion mode). When false, the pod runs only for tenants in TenantIds.
   */
  notTenants: Scalars['Boolean']['output'];
  podName: Scalars['String']['output'];
  /**
   * Deployment replica count for this assignment. 1 unless the parent service is
   * multi-replica capable, in which case any odd value in [1, 33] is allowed.
   */
  replicas: Scalars['Int']['output'];
  tenantIds: Array<Scalars['String']['output']>;
};

export enum PortalAutoAllocateStrategy {
  Balanced = 'BALANCED',
  Fifo = 'FIFO',
  HighestGrade = 'HIGHEST_GRADE',
  Lifo = 'LIFO',
  Priority = 'PRIORITY',
  SingleLocation = 'SINGLE_LOCATION'
}

/**
 * One item a customer-portal buyer over-ordered, on a REJECTED add. requestedQuantity is the
 * cumulative quantity the order would have ended up holding for the item (the unallocated part of
 * its existing lines plus the rejected request), and availableQuantity is what the portal catalog publishes — the same
 * number the customerPortalItems query serves the storefront grid. That number is
 * what is ready by asOfDate, the order's delivery day, and nextReadyDate / nextReadyQuantity say when
 * more is ready and how much more; all three are null for an undated figure, and the next-ready pair
 * is null when nothing more is ever ready.
 */
export type PortalAvailabilityShortfallData = {
  __typename?: 'PortalAvailabilityShortfallData';
  asOfDate?: Maybe<Scalars['LocalDate']['output']>;
  availableQuantity: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  nextReadyDate?: Maybe<Scalars['LocalDate']['output']>;
  nextReadyQuantity?: Maybe<Scalars['Int']['output']>;
  requestedQuantity: Scalars['Int']['output'];
};

/**
 * The availability window a portal availability sheet is run for — the portal grid's own selector,
 * mirrored so the printed sheet and the grid answer one question the same way. Now prints only
 * what is available today; each upcoming window ALSO admits items with nothing available today
 * whose ready date falls inside it, printing their ready week in place of a quantity; Any
 * admits every item with a ready date at all.
 */
export enum PortalAvailabilityWindow {
  /** Available today, plus every item that carries a ready date, however far out. */
  Any = 'ANY',
  /** Available today, plus items whose ready date is within the next eight weeks. */
  EightWeeks = 'EIGHT_WEEKS',
  /** Available today, plus items whose ready date is within the next four weeks. */
  FourWeeks = 'FOUR_WEEKS',
  /** Only items with something available today. */
  Now = 'NOW',
  /** Available today, plus items whose ready date is within the next two weeks. */
  TwoWeeks = 'TWO_WEEKS'
}

/** GraphQL-side mirror of TenantPortalBranding, mapped in TenantState). */
export type PortalBrandingData = {
  __typename?: 'PortalBrandingData';
  displayName: Scalars['String']['output'];
  logoImage?: Maybe<PortalLogoImageData>;
  logoUrl: Scalars['String']['output'];
  palette: PortalPaletteData;
  primaryColorHex: Scalars['String']['output'];
  styleTokens: PortalStyleTokensData;
  tagline: Scalars['String']['output'];
};

/** GraphQL-side mirror of the portal button tokens. */
export type PortalButtonData = {
  __typename?: 'PortalButtonData';
  borderRadius?: Maybe<Scalars['Decimal']['output']>;
  textTransform: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type PortalButtonDataInput = {
  borderRadius?: InputMaybe<Scalars['Decimal']['input']>;
  textTransform?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** The freight checkout will add before the buyer places the order. */
export type PortalCartFreightData = {
  __typename?: 'PortalCartFreightData';
  /** The freight amount calculated from the subtotal with order placement's rounding. */
  amount: Scalars['Decimal']['output'];
  /** The effective freight calculation: none, a percentage or a flat fee. */
  type: FreightChargeType;
  /** The percentage rate or flat fee; zero when no freight applies. */
  value: Scalars['Decimal']['output'];
};

export enum PortalCheckoutMethod {
  CallToOrder = 'CALL_TO_ORDER',
  OnlineCheckout = 'ONLINE_CHECKOUT'
}

export enum PortalCheckoutOrderStatus {
  Open = 'OPEN',
  Submitted = 'SUBMITTED'
}

/**
 * One tenant's custom portal domain claim, as the wsapi-admin-pwa's cross-tenant Domains grid renders
 * it — the same per-domain state a tenant sees on their own portal settings, opened up across every
 * tenant for the SuperAdmin operability view. routed and lastConvergedAt are added by a
 * separate resolver, sourced from the Ingress reactor's action log rather than this record.
 */
export type PortalCustomDomainAdminData = {
  __typename?: 'PortalCustomDomainAdminData';
  domain: Scalars['String']['output'];
  /**
   * When the Ingress reactor last CONFIRMED a convergence for this domain (route or unroute);
   * null when there is no confirmed action to read — nothing has been confirmed yet, every
   * attempt so far has failed to confirm, or the confirming action aged out of the action log's
   * 90-day retention.
   */
  lastConvergedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When this claim was last written; null for a claim written before this field existed. */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the domain's OAuth redirect URL is currently registered for login. */
  loginRedirectRegistered: Scalars['Boolean']['output'];
  /**
   * Whether the domain's Ingress is currently believed to be routed. true when the Ingress
   * reactor's most recently CONFIRMED convergence for this domain created or found the Ingress
   * present; false when it deleted or found it absent; null when there is no confirmed
   * action to read — nothing has been processed yet, every attempt so far has failed to confirm, OR
   * the confirming action aged out of the action log's 90-day retention. That last case means a
   * domain that has been routed and quietly healthy for months can also read null here — cross-
   * check verifiedAt to tell "still routed, just no recent evidence" apart from "never routed".
   */
  routed?: Maybe<Scalars['Boolean']['output']>;
  status: PortalCustomDomainStatus;
  tenantId: Scalars['String']['output'];
  /** When ownership was last proven; null while the claim is unproven. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * One tenant's custom portal domain claim, as the wsapi-admin-pwa's cross-tenant Domains grid renders
 * it — the same per-domain state a tenant sees on their own portal settings, opened up across every
 * tenant for the SuperAdmin operability view. routed and lastConvergedAt are added by a
 * separate resolver, sourced from the Ingress reactor's action log rather than this record.
 */
export type PortalCustomDomainAdminDataFilterInput = {
  and?: InputMaybe<Array<PortalCustomDomainAdminDataFilterInput>>;
  domain?: InputMaybe<StringOperationFilterInput>;
  /** When this claim was last written; null for a claim written before this field existed. */
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  /** Whether the domain's OAuth redirect URL is currently registered for login. */
  loginRedirectRegistered?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<PortalCustomDomainAdminDataFilterInput>>;
  status?: InputMaybe<PortalCustomDomainStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** When ownership was last proven; null while the claim is unproven. */
  verifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * One tenant's custom portal domain claim, as the wsapi-admin-pwa's cross-tenant Domains grid renders
 * it — the same per-domain state a tenant sees on their own portal settings, opened up across every
 * tenant for the SuperAdmin operability view. routed and lastConvergedAt are added by a
 * separate resolver, sourced from the Ingress reactor's action log rather than this record.
 */
export type PortalCustomDomainAdminDataSortInput = {
  domain?: InputMaybe<SortEnumType>;
  /** When this claim was last written; null for a claim written before this field existed. */
  lastModified?: InputMaybe<SortEnumType>;
  /** Whether the domain's OAuth redirect URL is currently registered for login. */
  loginRedirectRegistered?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** When ownership was last proven; null while the claim is unproven. */
  verifiedAt?: InputMaybe<SortEnumType>;
};

/**
 * GraphQL-output projection of one custom portal domain, including everything the Portal Settings
 * screen needs to walk an admin through setup: the exact DNS records to publish, where the claim is
 * in its lifecycle, and whether login on the domain actually works yet.
 */
export type PortalCustomDomainData = {
  __typename?: 'PortalCustomDomainData';
  domain: Scalars['String']['output'];
  /**
   * Whether this is the portal's PRIMARY host — the one its link, canonical login and
   * self-registration links resolve to. Exactly one ACTIVE domain carries true whenever the
   * tenant holds any; a withdrawn domain never does. A tenant's sole active domain is primary
   * implicitly, so this reports true for it without the tenant having designated anything;
   * during a move to a new domain it reports which of the two overlapping domains is serving.
   */
  isPrimary: Scalars['Boolean']['output'];
  /**
   * Whether the domain's OAuth redirect URL is currently registered for login. Stamped by the
   * wsapi-services worker via stampPortalCustomDomainLoginRedirectSync after it attempts the
   * FusionAuth sync; false until that worker reports a successful registration.
   */
  loginRedirectRegistered: Scalars['Boolean']['output'];
  /**
   * Structured classification of why the last redirect sync attempt failed (see
   * PortalLoginRedirectSyncFailureKind); null when the last stamped attempt
   * succeeded (or none has been stamped yet). Persisted alongside loginSyncFailureReason —
   * the enum names the failure CATEGORY without the null-overloading a bare optional HTTP status
   * carried, while the sanitized string stays the human-readable summary.
   */
  loginSyncFailureKind?: Maybe<PortalLoginRedirectSyncFailureKind>;
  /**
   * Sanitized reason the last redirect sync attempt failed, as stamped by the wsapi-services
   * worker; null when the last stamped attempt succeeded (or none has been stamped yet).
   * Never carries a provider response body or credential.
   */
  loginSyncFailureReason?: Maybe<Scalars['String']['output']>;
  status: PortalCustomDomainStatus;
  /** Host the ownership-proof TXT record must be published at. */
  verificationRecordHost: Scalars['String']['output'];
  /** Exact TXT value to publish at verificationRecordHost. */
  verificationRecordValue: Scalars['String']['output'];
  /** When ownership was last proven; null while the claim is unproven. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Which half of the convergence contract a logged action exercised. */
export enum PortalCustomDomainIngressAction {
  /** Ensure the domain's Ingress exists (a PortalCustomDomainVerified event). */
  Route = 'ROUTE',
  /** Ensure the domain's Ingress is gone (a PortalCustomDomainRemoved event). */
  Unroute = 'UNROUTE'
}

export type PortalCustomDomainIngressActionOperationFilterInput = {
  eq?: InputMaybe<PortalCustomDomainIngressAction>;
  in?: InputMaybe<Array<PortalCustomDomainIngressAction>>;
  neq?: InputMaybe<PortalCustomDomainIngressAction>;
  nin?: InputMaybe<Array<PortalCustomDomainIngressAction>>;
};

/**
 * One row of the superadmin Ingress action log, as the wsapi-admin-pwa renders it. A projection of the
 * stored record rather than the record itself, so how the log is persisted (id composition, the
 * TTL-shaped date fields) stays free to change without breaking the admin contract.
 */
export type PortalCustomDomainIngressActionResult = {
  __typename?: 'PortalCustomDomainIngressActionResult';
  action: PortalCustomDomainIngressAction;
  domain: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  /**
   * When this action was first recorded — the row's fixed place in history. A replay re-handles the
   * event but never moves this, so it is what the log is sorted and aged by.
   */
  firstObservedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  ingressName: Scalars['String']['output'];
  /**
   * When the convergence was last confirmed against the cluster. Moves on every redelivery or
   * replay, so a value far newer than firstObservedAt means the reactor has re-checked this
   * domain since — not that anything changed.
   */
  lastConvergedAt: Scalars['DateTime']['output'];
  namespace: Scalars['String']['output'];
  outcome: PortalCustomDomainIngressOutcome;
  tenantId: Scalars['String']['output'];
};

/**
 * One row of the superadmin Ingress action log, as the wsapi-admin-pwa renders it. A projection of the
 * stored record rather than the record itself, so how the log is persisted (id composition, the
 * TTL-shaped date fields) stays free to change without breaking the admin contract.
 */
export type PortalCustomDomainIngressActionResultFilterInput = {
  action?: InputMaybe<PortalCustomDomainIngressActionOperationFilterInput>;
  and?: InputMaybe<Array<PortalCustomDomainIngressActionResultFilterInput>>;
  domain?: InputMaybe<StringOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  /**
   * When this action was first recorded — the row's fixed place in history. A replay re-handles the
   * event but never moves this, so it is what the log is sorted and aged by.
   */
  firstObservedAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  ingressName?: InputMaybe<StringOperationFilterInput>;
  /**
   * When the convergence was last confirmed against the cluster. Moves on every redelivery or
   * replay, so a value far newer than firstObservedAt means the reactor has re-checked this
   * domain since — not that anything changed.
   */
  lastConvergedAt?: InputMaybe<DateTimeOperationFilterInput>;
  namespace?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PortalCustomDomainIngressActionResultFilterInput>>;
  outcome?: InputMaybe<PortalCustomDomainIngressOutcomeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One row of the superadmin Ingress action log, as the wsapi-admin-pwa renders it. A projection of the
 * stored record rather than the record itself, so how the log is persisted (id composition, the
 * TTL-shaped date fields) stays free to change without breaking the admin contract.
 */
export type PortalCustomDomainIngressActionResultSortInput = {
  action?: InputMaybe<SortEnumType>;
  domain?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  /**
   * When this action was first recorded — the row's fixed place in history. A replay re-handles the
   * event but never moves this, so it is what the log is sorted and aged by.
   */
  firstObservedAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ingressName?: InputMaybe<SortEnumType>;
  /**
   * When the convergence was last confirmed against the cluster. Moves on every redelivery or
   * replay, so a value far newer than firstObservedAt means the reactor has re-checked this
   * domain since — not that anything changed.
   */
  lastConvergedAt?: InputMaybe<SortEnumType>;
  namespace?: InputMaybe<SortEnumType>;
  outcome?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PortalCustomDomainIngressActionsConnection = {
  __typename?: 'PortalCustomDomainIngressActionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PortalCustomDomainIngressActionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PortalCustomDomainIngressActionResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PortalCustomDomainIngressActionsEdge = {
  __typename?: 'PortalCustomDomainIngressActionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PortalCustomDomainIngressActionResult;
};

/**
 * Which convergence branch the Ingress gateway actually took for one domain. Every value is a SUCCESS
 * except Failed: "already present" and "already absent" are the idempotent re-delivery/replay
 * paths, not errors — distinguishing them is the whole point of the action log, because "nothing
 * happened" and "nothing needed to happen" look identical from the outside and only one of them is a
 * problem.
 */
export enum PortalCustomDomainIngressOutcome {
  /** Nothing to delete — never created, already removed, or manually deleted. */
  AlreadyAbsent = 'ALREADY_ABSENT',
  /** The Ingress was already there — a verify retry, a redelivered event, or a replay. */
  AlreadyPresent = 'ALREADY_PRESENT',
  /** The per-domain Ingress did not exist and was created. */
  Created = 'CREATED',
  /** The per-domain Ingress existed and was deleted. */
  Deleted = 'DELETED',
  /** Log-only: the convergence attempt returned an error. Never returned by the gateway. */
  Failed = 'FAILED'
}

export type PortalCustomDomainIngressOutcomeOperationFilterInput = {
  eq?: InputMaybe<PortalCustomDomainIngressOutcome>;
  in?: InputMaybe<Array<PortalCustomDomainIngressOutcome>>;
  neq?: InputMaybe<PortalCustomDomainIngressOutcome>;
  nin?: InputMaybe<Array<PortalCustomDomainIngressOutcome>>;
};

/**
 * Health of the portal custom-domain Ingress reactor in one read: its subscriber status (from the
 * shared ProjectionStatus record the subscribe machinery already maintains) alongside how many
 * of its events have dead-lettered. Both halves already existed and neither alone answers the
 * operator's actual question — "is routing keeping up, and has anything been dropped on the floor" —
 * which is why they are composed here rather than left to two separate admin round-trips.
 */
export type PortalCustomDomainIngressStatusResult = {
  __typename?: 'PortalCustomDomainIngressStatusResult';
  /** Dead-lettered events for this reactor — each one a domain that never converged. */
  deadLetterCount: Scalars['Long']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastProcessedPosition?: Maybe<Scalars['Long']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The subscriber's projection-status name, as the shared machinery derives it. */
  projectionName: Scalars['String']['output'];
  status?: Maybe<ProjectionHealth>;
};

export enum PortalCustomDomainStatus {
  PendingVerification = 'PENDING_VERIFICATION',
  Removed = 'REMOVED',
  Unknown = 'UNKNOWN',
  Verified = 'VERIFIED'
}

export type PortalCustomDomainStatusOperationFilterInput = {
  eq?: InputMaybe<PortalCustomDomainStatus>;
  in?: InputMaybe<Array<PortalCustomDomainStatus>>;
  neq?: InputMaybe<PortalCustomDomainStatus>;
  nin?: InputMaybe<Array<PortalCustomDomainStatus>>;
};

/** A connection to a list of items. */
export type PortalCustomDomainsConnection = {
  __typename?: 'PortalCustomDomainsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PortalCustomDomainsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PortalCustomDomainAdminData>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PortalCustomDomainsEdge = {
  __typename?: 'PortalCustomDomainsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PortalCustomDomainAdminData;
};

export type PortalDeliveryBlackoutData = {
  __typename?: 'PortalDeliveryBlackoutData';
  endDate: Scalars['LocalDate']['output'];
  startDate: Scalars['LocalDate']['output'];
};

export type PortalDeliveryBlackoutDataInput = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};

/**
 * A rejected customer-portal delivery date, with everything the picker needs to recover: the date the
 * buyer submitted, which half of the ship-date rule refused it, the weekdays the ship-to actually
 * receives deliveries on, and the first date still orderable at the instant of rejection.
 * earliestEligibleDate is null when nothing in the horizon is selectable.
 */
export type PortalDeliveryDateRejectionData = {
  __typename?: 'PortalDeliveryDateRejectionData';
  allowedDays: Array<DayOfWeek>;
  earliestEligibleDate?: Maybe<Scalars['LocalDate']['output']>;
  reason: DeliveryDateIneligibleReason;
  requestedDate: Scalars['LocalDate']['output'];
};

/** One (grade, availableQuantity) pair of an item's per-grade breakdown. */
export type PortalGradeAvailabilityData = {
  __typename?: 'PortalGradeAvailabilityData';
  /**
   * Quantity available at this grade — on hand minus allocated, summed across every location the
   * tenant's availability rule admits. Always greater than zero.
   */
  availableQuantity: Scalars['Decimal']['output'];
  /**
   * The inventory grade, 1-5, to be rendered with the tenant's own grade-label vocabulary from
   * customerPortalSettings.gradeLabels. Always at or above the tenant's availability minimum grade,
   * and never the gradeless sentinel 0 that hard goods key their inventory at.
   */
  grade: Scalars['Int']['output'];
};

export type PortalHelpContactData = {
  __typename?: 'PortalHelpContactData';
  /** Email address Portal customers use to reach the help contact. */
  email: Scalars['String']['output'];
  /** Display name of the person Portal customers are told to contact. */
  name: Scalars['String']['output'];
};

export type PortalHelpContactDataInput = {
  /** Email address Portal customers use to reach the help contact. */
  email: Scalars['String']['input'];
  /** Display name of the person Portal customers are told to contact. */
  name: Scalars['String']['input'];
};

/** Which portal a host serves, and under which layer it was matched. */
export type PortalHostTenantView = {
  __typename?: 'PortalHostTenantView';
  /** The tenant's vanity slug — empty when a custom domain resolved it. */
  companySlug: Scalars['String']['output'];
  /** The normalized host that resolved. */
  host: Scalars['String']['output'];
  /** True when the host is a tenant-owned custom domain (layer 2). */
  isCustomDomain: Scalars['Boolean']['output'];
  /** The tenant the host resolves to. */
  tenantId: Scalars['String']['output'];
};

/**
 * A charge a new order line for this item will carry for the signed-in customer: its name and how
 * it is priced. The amount is left to the client, and a charge priced at zero is still listed.
 */
export type PortalItemCharge = {
  __typename?: 'PortalItemCharge';
  /** The charge's name, as the order line will show it. */
  name: Scalars['String']['output'];
  /** How the charge is priced: a flat price, or a markup percent of the line price. */
  pricing: ItemUpgradePricing;
};

/**
 * One portal-visible item's available quantity broken down by inventory grade. The grade dimension
 * the item-level catalog rollup collapses: a catalog row carries a single availableQuantity summed
 * across every location and grade, while grade lives on the inventory key (item + location + grade).
 * Join this to the catalog row with the same itemId.
 */
export type PortalItemGradeAvailabilityData = {
  __typename?: 'PortalItemGradeAvailabilityData';
  /**
   * The item's available grades, HIGHEST GRADE FIRST — so the first entry is the grade chip and the
   * whole list is the per-grade breakdown. Never empty: an item with no grade left to show is absent
   * from the result entirely rather than present with an empty list.
   */
  grades: Array<PortalGradeAvailabilityData>;
  /**
   * The item these grade quantities belong to. Matches the itemId on the corresponding
   * customerPortalItems catalog row.
   */
  itemId: Scalars['String']['output'];
};

/**
 * One photo of a catalog item as a portal buyer sees it: where to load it and whether it is the
 * item's primary photo.
 */
export type PortalItemPhoto = {
  __typename?: 'PortalItemPhoto';
  /** Whether this is the item's primary photo. */
  isPrimary: Scalars['Boolean']['output'];
  /** Where to load the photo. */
  photoUrl: Scalars['String']['output'];
};

/**
 * The price label a buyer's catalog row carries. This is the whole buyer surface of a label: no id,
 * cost or source reaches a buyer.
 */
export type PortalItemPriceLabel = {
  __typename?: 'PortalItemPriceLabel';
  /** The charge for each plant. */
  flatPrice: Scalars['Decimal']['output'];
  /** The label's name, as an order line shows it. */
  name: Scalars['String']['output'];
};

export enum PortalLoginRedirectSyncFailureKind {
  ConnectionFailure = 'CONNECTION_FAILURE',
  DnsFailure = 'DNS_FAILURE',
  HttpStatus = 'HTTP_STATUS',
  MalformedResponse = 'MALFORMED_RESPONSE',
  Timeout = 'TIMEOUT',
  TlsFailure = 'TLS_FAILURE',
  Unknown = 'UNKNOWN'
}

export enum PortalLoginRedirectSyncOperation {
  Register = 'REGISTER',
  Remove = 'REMOVE'
}

/**
 * GraphQL-side mirror of the optional base64 portal logo image.
 * None renders as a null logoImage; clients display it as data:{mime};base64,{image}.
 */
export type PortalLogoImageData = {
  __typename?: 'PortalLogoImageData';
  image: Scalars['String']['output'];
  mime: Scalars['String']['output'];
};

/** The person buyers call to place an order while the portal is set to Call to order. */
export type PortalOrderContactData = {
  __typename?: 'PortalOrderContactData';
  /** Name of the person to ask for. Null when staff gave none. */
  name?: Maybe<Scalars['String']['output']>;
  /** Phone number buyers call, in the form (###) ###-####. */
  phone: Scalars['String']['output'];
};

/**
 * GraphQL-side mirror of the structured portal palette. Each role is a hex string, empty when
 * unset (the portal PWA fills unset roles from primaryColorHex). primary mirrors
 * primaryColorHex for back-compat.
 */
export type PortalPaletteData = {
  __typename?: 'PortalPaletteData';
  accent: Scalars['String']['output'];
  primary: Scalars['String']['output'];
  secondary: Scalars['String']['output'];
  surface: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type PortalPaletteDataInput = {
  accent?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PortalPriceLabel = {
  __typename?: 'PortalPriceLabel';
  /** The charge for each plant, at least 0 with at most 2 decimals. */
  flatPrice: Scalars['Decimal']['output'];
  /** Whether items without a label of their own use this one. Exactly one label is Default. */
  isDefault: Scalars['Boolean']['output'];
  /** What a staff screen and an order line show. */
  name: Scalars['String']['output'];
  /** Client-supplied id, unique within the tenant's labels. */
  priceLabelId: Scalars['String']['output'];
};

export type PortalPriceLabelInput = {
  /** The charge for each plant, at least 0 with at most 2 decimals. */
  flatPrice: Scalars['Decimal']['input'];
  /** Whether items without a label of their own use this one. Exactly one label is Default. */
  isDefault: Scalars['Boolean']['input'];
  /** What a staff screen and an order line show. */
  name: Scalars['String']['input'];
  /** Client-supplied id, unique within the tenant's labels. */
  priceLabelId: Scalars['String']['input'];
};

export enum PortalPricingAccess {
  Off = 'OFF',
  Visible = 'VISIBLE'
}

/**
 * The tenant's PUBLIC portal branding: the four display fields a pre-login page needs to stop looking
 * like a generic Silver Fern screen, plus the grower's sign-in panel, and nothing else, ever.
 */
export type PortalPublicBranding = {
  __typename?: 'PortalPublicBranding';
  displayName: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  primaryColorHex: Scalars['String']['output'];
  signInPanel?: Maybe<PortalPublicSignInPanel>;
  tagline: Scalars['String']['output'];
};

/**
 * The grower's sign-in marketing panel on the public branding read. Null when the tenant has no panel
 * or every field of it is blank; otherwise an unset field is an empty string. Both URLs are https.
 */
export type PortalPublicSignInPanel = {
  __typename?: 'PortalPublicSignInPanel';
  body: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  linkLabel: Scalars['String']['output'];
  linkUrl: Scalars['String']['output'];
};

/** Portal stock for one catalog item that becomes ready on one date, or that has no ready date. */
export type PortalReadyDateBucket = {
  __typename?: 'PortalReadyDateBucket';
  /**
   * The quantity that becomes ready on this date, never below 0. An over-allocated date shows 0; its
   * shortfall still counts against the cumulative quantity.
   */
  availableQuantity: Scalars['Int']['output'];
  /**
   * The quantity ready by this date: every unit with no ready date or a ready date on or before this one,
   * netted across locations. The last bucket's cumulative quantity equals the item's availableQuantity.
   */
  cumulativeAvailableQuantity: Scalars['Int']['output'];
  /** The date this stock becomes ready. Null for stock with no ready date, which is ready now. */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The ISO 8601 week number (1 to 53) of the ready date. Null when there is no ready date. */
  readyWeek?: Maybe<Scalars['Int']['output']>;
  /**
   * A numeric key for ordering by ready week (ISO year times 53 plus the ISO week). Null when there is no
   * ready date.
   */
  readyWeekIndex?: Maybe<Scalars['Int']['output']>;
  /**
   * The year-qualified ISO week of the ready date, such as 2026-W42. The year is the ISO week-numbering
   * year, so a date in early January can carry the previous year. Null when there is no ready date.
   */
  readyWeekLabel?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of an exchange: the session on success, or the reason it was refused. Exactly one of the two is
 * populated, and a refusal never carries session material.
 */
export type PortalSessionHandoffExchangePayload = {
  __typename?: 'PortalSessionHandoffExchangePayload';
  errors?: Maybe<Array<ValidationError>>;
  session?: Maybe<PortalSessionHandoffSessionData>;
};

/**
 * What a successful mint hands back to the canonical host: the code to put in the handoff URL and when
 * it stops working. Carries no session material — the material the caller just deposited is not echoed,
 * so the mint response is not a second copy of the session in flight.
 */
export type PortalSessionHandoffMintData = {
  __typename?: 'PortalSessionHandoffMintData';
  /** The single-use handoff code. The only value in this flow that belongs in a URL. */
  code: Scalars['String']['output'];
  /** When the code stops being redeemable, so the client can fail fast rather than round-trip. */
  expiresAt: Scalars['DateTime']['output'];
  /** The normalized domain the code is bound to, echoed so the caller builds the URL from what the server actually recorded. */
  targetDomain: Scalars['String']['output'];
};

/**
 * Result of a mint: the issued handoff on success, or the reason it was refused. Exactly one of the two
 * is populated.
 */
export type PortalSessionHandoffMintPayload = {
  __typename?: 'PortalSessionHandoffMintPayload';
  errors?: Maybe<Array<ValidationError>>;
  handoff?: Maybe<PortalSessionHandoffMintData>;
};

/**
 * What a successful exchange hands back to the portal client on the custom domain: the session material
 * the canonical host deposited, plus the tenant context the client bootstraps from.
 */
export type PortalSessionHandoffSessionData = {
  __typename?: 'PortalSessionHandoffSessionData';
  /**
   * The payload deposited at mint, decrypted. This response body is the ONE place it appears — it was
   * never in a URL, never logged, and is already gone from the store by the time this is returned.
   */
  sessionMaterial: Scalars['String']['output'];
  /** The domain the code was bound to, echoed for the client to assert against its own location. */
  targetDomain: Scalars['String']['output'];
  /** The tenant the session belongs to, so the client can bootstrap without a second lookup. */
  tenantId: Scalars['String']['output'];
};

export type PortalSettingsPayload = {
  __typename?: 'PortalSettingsPayload';
  errors?: Maybe<Array<ValidationError>>;
  portalSettings?: Maybe<PortalSettingsStateData>;
};

/**
 * GraphQL-output projection of the portal settings state. This is the shape the
 * worksuite-pwa portal consumer (task eded2645) reads from getPortalSettings
 * and the payload of updatePortalSettings. CatalogDisplayMode is the
 * domain enum, surfaced as a GraphQL enum (GRID/LIST).
 */
export type PortalSettingsStateData = {
  __typename?: 'PortalSettingsStateData';
  /**
   * Location filter of the FULFILL Customer Portal "Availability rule" as saved (a site or a
   * sub-location id); nullable — null means "all locations". A site pin also covers every
   * location under the site and a sub-location pin its active descendants, so match inventory
   * against availabilityLocationIds, not this id.
   */
  availabilityLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * The location ids the Availability rule admits, resolved from its availabilityLocationId pin. Empty
   * when there is no pin (every location is admitted). For a site pin: the site id, then every location
   * under the site (its sub-locations at every depth and the legacy locations it owns, whatever their
   * status). For a sub-location pin: that id, then every active sub-location beneath it at any depth
   * (a leaf admits only itself). Match inventory location ids against this list rather than
   * availabilityLocationId, so a pin admits the stock held under it; it is the same set the server
   * applies to portal availability.
   */
  availabilityLocationIds: Array<Scalars['String']['output']>;
  /**
   * Minimum inventory grade (grade-or-higher) of the FULFILL Customer Portal "Availability rule",
   * surfaced as a non-null Int; staff read/write this via portalSettings /
   * updatePortalSettings. 0 is the "Any" option (no grade floor, so gradeless
   * hard-good inventory is included); a tenant that has never saved settings reads 1 (the lowest
   * live grade, so every live grade shows).
   */
  availabilityMinGrade: Scalars['Int']['output'];
  /**
   * The Report aggregate id the portal's "Download PDF" availability sheet renders; null
   * means "use the seeded system template". Staff read/write this raw value via
   * portalSettings / updatePortalSettings; render with
   * effectiveAvailabilityReportId instead, which resolves the fallback.
   */
  availabilityReportId?: Maybe<Scalars['String']['output']>;
  /**
   * Retired. The availability source the tenant last saved; it no longer changes anything.
   * Every tenant's portal availability comes from inventory on hand minus allocated, through the
   * Availability rule. Reads LEDGER on a tenant that has never saved settings. Still
   * accepted by updatePortalSettings so existing callers keep working.
   */
  availabilitySource: AvailabilitySource;
  /**
   * The Portal "Buyers can edit their contacts" setting: whether the tenant's customers may add,
   * edit and remove their own contacts from the portal Account page. Defaults to false on a
   * tenant that has never opted in. Staff read/write this via portalSettings /
   * updatePortalSettings; an omitted input keeps the stored value.
   */
  buyerContactEditingEnabled: Scalars['Boolean']['output'];
  /**
   * The Portal "Buyers can edit their retail prices" setting as saved: whether the tenant's
   * customers may save their own retail prices from the portal. Defaults to false on a tenant
   * that has never opted in. Buyers can edit only while portalEnabled and
   * prePricingEnabled are also on. Staff read/write this via portalSettings /
   * updatePortalSettings; an omitted input keeps the stored value.
   */
  buyerRetailPriceEditingEnabled: Scalars['Boolean']['output'];
  /**
   * What the portal catalog's filter chips are built from: CATEGORY (the default, and what a
   * tenant that never saved it reads) or ITEM_GROUP. Staff read/write this via
   * portalSettings / updatePortalSettings; an omitted input keeps the stored value.
   */
  catalogChipSource: CatalogChipSource;
  catalogDisplayMode: CatalogDisplayMode;
  /**
   * How the tenant's portal buyers place orders: ONLINE_CHECKOUT (the default, and what a
   * tenant that never set it reads) or CALL_TO_ORDER (buyers are shown the order contact
   * and told to call). Staff set it through changePortalCheckoutMethod, never through
   * updatePortalSettings, which leaves it as it is.
   */
  checkoutMethod: PortalCheckoutMethod;
  /**
   * Per-tenant portal vanity-subdomain slug (DNS-label safe). Empty on a tenant that has never
   * saved settings; a random 8-char default is assigned — and returned here — the first time
   * settings are saved. Unique across all tenants.
   */
  companySlug: Scalars['String']['output'];
  /**
   * The tenant's own domains claimed for its portal, each carrying the DNS records to publish and
   * its verification/login-readiness state. Empty on a tenant that never added one; withdrawn
   * domains stay listed as REMOVED so the screen can show what was detached.
   */
  customDomains: Array<PortalCustomDomainData>;
  /**
   * Inclusive calendar windows the tenant has closed to portal deliveries, in the order they were
   * saved. Empty on a tenant that has closed no dates. Staff read/write these via
   * portalSettings / updatePortalSettings.
   */
  deliveryBlackouts: Array<PortalDeliveryBlackoutData>;
  /** Availability PDF report id the portal should render: the tenant's configured value, or the seeded Portal Availability template when unconfigured. */
  effectiveAvailabilityReportId: Scalars['String']['output'];
  /**
   * Whether this tenant has ever SAVED portal settings — i.e. whether a PortalSettings
   * stream exists — as opposed to reading the documented default-on-missing state.
   *
   * The read contract deliberately returns the same defaults either way, so without this flag a
   * caller cannot tell the two apart. That distinction is load-bearing: companySlug is
   * assigned on the FIRST save, and a client that disables its save action while nothing has
   * changed will otherwise leave a never-saved tenant unable to obtain a portal address at all.
   * The same state already gates self-registration and custom domains server-side
   * (EnsureSelfRegistrationEnabled, EnsurePortalSettingsSaved).
   *
   *
   * Do NOT infer this from an empty companySlug: a saved document could carry an empty
   * slug, which makes the slug a proxy rather than proof.
   */
  hasSavedSettings: Scalars['Boolean']['output'];
  /**
   * The grower-designated Portal help contact; null when none is designated. Staff set or
   * clear it through changePortalHelpContact, never through updatePortalSettings,
   * which leaves it as it is.
   */
  helpContact?: Maybe<PortalHelpContactData>;
  /**
   * "Include sellable hard goods" option of the FULFILL Customer Portal "Availability rule".
   * When true, gradeless sellable hard goods are included in availability; defaults to
   * false on a tenant that has never opted in.
   */
  includeSellableHardGoods: Scalars['Boolean']['output'];
  minimumOrderAmount: Scalars['Decimal']['output'];
  /**
   * The saved order contact (optional name, phone); null when none is saved. Kept while the method
   * is ONLINE_CHECKOUT so switching back needs no retyping; buyers see it only while the
   * method is CALL_TO_ORDER. Set through changePortalCheckoutMethod.
   */
  orderContact?: Maybe<PortalOrderContactData>;
  /**
   * Days before delivery day D the cutoff falls on: D is orderable only strictly before
   * orderCutoffTime on D minus this many days. Defaults to 1 ("the day before");
   * 0 is a same-day cutoff and 365 the maximum. Inert while orderCutoffTime is null.
   */
  orderCutoffLeadDays: Scalars['Int']['output'];
  /**
   * Rolling order-cutoff wall-clock time ("HH:mm") evaluated in
   * orderCutoffTimeZoneId; null means no cutoff is configured. Staff
   * read/write this via portalSettings / updatePortalSettings.
   */
  orderCutoffTime?: Maybe<Scalars['String']['output']>;
  /**
   * IANA zone the cutoff is evaluated in; required whenever orderCutoffTime is
   * set, null when no cutoff is configured.
   */
  orderCutoffTimeZoneId?: Maybe<Scalars['String']['output']>;
  /**
   * Whether a submitted Customer Portal order is acknowledged at its full ordered quantity
   * automatically. Defaults to false on a tenant that has never opted in. Staff read/write
   * this via portalSettings / updatePortalSettings. Office-entered orders are never
   * affected.
   */
  portalAutoAcknowledge: Scalars['Boolean']['output'];
  /**
   * Whether a submitted Customer Portal order is allocated automatically with
   * portalAutoAllocateStrategy. Defaults to false on a tenant that has never opted
   * in. Staff read/write this via portalSettings / updatePortalSettings.
   * Office-entered orders are never affected.
   */
  portalAutoAllocate: Scalars['Boolean']['output'];
  /**
   * The strategy portal orders are auto-allocated with; HIGHEST_GRADE unless the tenant
   * chose another. SINGLE_LOCATION and PRIORITY need extra input and are refused
   * by updatePortalSettings.
   */
  portalAutoAllocateStrategy: PortalAutoAllocateStrategy;
  /**
   * The status a portal checkout places the order in: OPEN (the default; staff submit) or
   * SUBMITTED. A customer whose orders sync to an ERP stays Open at checkout whatever the
   * setting. Staff read/write this via portalSettings / updatePortalSettings.
   * Office-entered orders are never affected.
   */
  portalCheckoutOrderStatus: PortalCheckoutOrderStatus;
  portalEnabled: Scalars['Boolean']['output'];
  /**
   * How many days past today a portal buyer may schedule a delivery for. Drives both the horizon
   * the storefront's date picker renders and the window checkout enforces. Defaults to 30 on a
   * tenant that has never set one; 1 is the minimum and 365 the maximum. Staff read/write this via
   * portalSettings / updatePortalSettings.
   */
  portalMaxDaysOut: Scalars['Int']['output'];
  /**
   * The Portal "Pre-pricing" setting: whether the tenant's customers see the retail prices staff
   * set for them. While it is off, customerRetailPrice on portal catalog items answers
   * null, pull slips and container tags print no retail price, and missing data lists no
   * customer item for a missing retail price. Staff can still set and import prices while it is
   * off. Defaults to false on a tenant that has never opted in. Staff read/write this via
   * portalSettings / updatePortalSettings. Turning it off keeps saved retail prices;
   * turning it back on restores them.
   */
  prePricingEnabled: Scalars['Boolean']['output'];
  /**
   * Governs the portal item-image resolver's precedence between the curated/staff-uploaded item
   * image and the newest grower availability photo. Defaults to false (curated image
   * primary — the fixed, correct default) on a tenant that has never opted in; true restores
   * the pre-fix behavior where the newest availability photo wins. Staff read/write this via
   * portalSettings / updatePortalSettings.
   */
  preferAvailabilityImage: Scalars['Boolean']['output'];
  /**
   * The tenant's price labels, in the order they were saved: each a name and a flat price for each
   * plant, exactly one marked Default. Empty when the tenant has none, which means no label charge.
   * Kept while Pre-pricing is off. Staff read/write these via portalSettings /
   * updatePortalSettings; an omitted input keeps the stored list and [] clears it.
   */
  priceLabels: Array<PortalPriceLabel>;
  /**
   * The custom domain the portal is currently served under — the host its link, canonical login and
   * self-registration links resolve to. null when the tenant holds no active custom domain,
   * in which case the portal is reached at its companySlug vanity subdomain. A tenant's sole
   * active domain is primary implicitly, so this is populated as soon as one is added, without the
   * tenant designating anything; during a move to a new domain it names which of the two
   * overlapping domains is serving, and setPrimaryPortalCustomDomain is what moves it.
   */
  primaryCustomDomain?: Maybe<Scalars['String']['output']>;
  selfRegistrationEnabled: Scalars['Boolean']['output'];
  /**
   * FULFILL Customer Portal "Show grade on portal" toggle. When true, the storefront may
   * display each item's grade to buyers using the tenant's grade-label vocabulary
   * (tenant.gradeLabels). Defaults to false on a tenant that has never opted in, so
   * grades stay hidden. Staff read/write this via portalSettings /
   * updatePortalSettings.
   */
  showGradeOnPortal: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

/** GraphQL-side mirror of the portal shape (corner radius) tokens. */
export type PortalShapeData = {
  __typename?: 'PortalShapeData';
  borderRadius?: Maybe<Scalars['Decimal']['output']>;
};

export type PortalShapeDataInput = {
  borderRadius?: InputMaybe<Scalars['Decimal']['input']>;
};

/**
 * GraphQL-side mirror of the grower's sign-in marketing panel. Each field is empty when unset, and both
 * URLs are https.
 */
export type PortalSignInPanelData = {
  __typename?: 'PortalSignInPanelData';
  body: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  linkLabel: Scalars['String']['output'];
  linkUrl: Scalars['String']['output'];
};

/** GraphQL-side mirror of the portal spacing tokens. */
export type PortalSpacingData = {
  __typename?: 'PortalSpacingData';
  unit?: Maybe<Scalars['Decimal']['output']>;
};

export type PortalSpacingDataInput = {
  unit?: InputMaybe<Scalars['Decimal']['input']>;
};

/**
 * GraphQL-side mirror of the structured portal style tokens. Each token is optional (empty string /
 * null = unset); the portal PWA fills unset tokens from its base theme.
 */
export type PortalStyleTokensData = {
  __typename?: 'PortalStyleTokensData';
  button: PortalButtonData;
  shape: PortalShapeData;
  spacing: PortalSpacingData;
  typography: PortalTypographyData;
};

export type PortalStyleTokensDataInput = {
  button?: InputMaybe<PortalButtonDataInput>;
  shape?: InputMaybe<PortalShapeDataInput>;
  spacing?: InputMaybe<PortalSpacingDataInput>;
  typography?: InputMaybe<PortalTypographyDataInput>;
};

/** GraphQL-side mirror of the portal typography tokens. */
export type PortalTypographyData = {
  __typename?: 'PortalTypographyData';
  baseFontSize?: Maybe<Scalars['Decimal']['output']>;
  baseFontWeight?: Maybe<Scalars['Decimal']['output']>;
  fontFamily: Scalars['String']['output'];
};

export type PortalTypographyDataInput = {
  baseFontSize?: InputMaybe<Scalars['Decimal']['input']>;
  baseFontWeight?: InputMaybe<Scalars['Decimal']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
};

export type PortalUserDocument = {
  __typename?: 'PortalUserDocument';
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  lastName: Scalars['String']['output'];
  portalUserId: Scalars['String']['output'];
  role: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  userType: UserType;
};

export type PortalUserDocumentFilterInput = {
  and?: InputMaybe<Array<PortalUserDocumentFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PortalUserDocumentFilterInput>>;
  portalUserId?: InputMaybe<StringOperationFilterInput>;
  role?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  userType?: InputMaybe<UserTypeOperationFilterInput>;
};

export type PortalUserDocumentSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  portalUserId?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  userType?: InputMaybe<SortEnumType>;
};

export type PortalUserPayload = {
  __typename?: 'PortalUserPayload';
  errors?: Maybe<Array<ValidationError>>;
  portalUser?: Maybe<PortalUserDocument>;
};

/** What a portal user may see in the customer portal. Staff set it with setPortalUserPermissions. */
export type PortalUserPermissions = {
  __typename?: 'PortalUserPermissions';
  /**
   * Whether the user sees prices. OFF hides wholesale prices, totals, charges, tax and freight from
   * every portal field and refuses invoices and payment; retail prices stay visible. Defaults to
   * VISIBLE.
   */
  pricing: PortalPricingAccess;
};

export type PortalUserStateData = {
  __typename?: 'PortalUserStateData';
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  lastName: Scalars['String']['output'];
  portalUserId: Scalars['String']['output'];
  role: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  userType: UserType;
};

export type PositionData = {
  __typename?: 'PositionData';
  commitPosition: Scalars['Long']['output'];
  preparePosition: Scalars['Long']['output'];
};

/** Input for a full cycle count submission at a store location. */
export type PostCycleCountsInput = {
  accuracyMeters?: InputMaybe<Scalars['Decimal']['input']>;
  capturedAt?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  items: Array<CycleCountItemInput>;
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  locationId: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PostProductionJobDataInput = {
  complete: Scalars['Boolean']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type PostProductionJobEntryInput = {
  complete: Scalars['Boolean']['input'];
  postingAttemptKey?: InputMaybe<Scalars['String']['input']>;
  postings: Array<PostProductionJobPostingLineInput>;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  shrinkReasonCode?: InputMaybe<Scalars['Int']['input']>;
};

export type PostProductionJobPostingLineInput = {
  grade: Scalars['Int']['input'];
  producedLocationId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type PostProductionJobResult = {
  __typename?: 'PostProductionJobResult';
  errors?: Maybe<Array<ValidationError>>;
  /**
   * The inventory post: the posted lines, the FULFILL inventory reconcile and the inventory-side peg, one
   * atomic append. ACKNOWLEDGED once it committed; PENDING when it was refused or its outcome is unknown, in
   * which case productionJobPostingStages reads back whether it landed.
   */
  inventoryPost: ProductionPostingStageStatus;
  productionJobId: Scalars['String']['output'];
  productionLot?: Maybe<ProductionLotStateData>;
  /** The lot the job belongs to, as the request named it. */
  productionLotId: Scalars['String']['output'];
  /**
   * The reservation peg, the separate append that follows the inventory post. UNKNOWN when the inventory
   * post was not acknowledged, so the peg was never reached; NOT_REQUIRED when the post pegged nothing;
   * PENDING when the peg append failed or its outcome is unknown, which
   * repairProductionJobReservationPegs resolves without posting again.
   */
  reservationPeg: ProductionPostingStageStatus;
  /** The absolute pegged quantity the post asked the reservation to hold, when it pegged. */
  reservationPeggedQuantity?: Maybe<Scalars['Int']['output']>;
};

export type PostProductionJobsInput = {
  jobs: Array<PostProductionJobEntryInput>;
};

export type PostProductionJobsPayload = {
  __typename?: 'PostProductionJobsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<PostProductionJobResult>;
};

export type PostedProductionLine = {
  __typename?: 'PostedProductionLine';
  eachesPerContainer?: Maybe<Scalars['Int']['output']>;
  grade: Scalars['Int']['output'];
  producedLocationId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  salesItemId?: Maybe<Scalars['String']['output']>;
};

/** A review fernie is showing the grower in this chat turn. */
export type PresentMigrationReviewInput = {
  /** The journey the subject belongs to. */
  journeyId: Scalars['String']['input'];
  /** A data portion or a settings-operation revision. */
  kind: MigrationApprovalKind;
  /** The chat references; session, turn and sent message are required. */
  routing: OnboardingJourneyRoutingInput;
  /** The portion's membership hash or the revision's hash, as the review shows it. */
  subjectHash?: InputMaybe<Scalars['String']['input']>;
  /** The portion id or the settings-operation revision id. */
  subjectId: Scalars['String']['input'];
};

/** A support summary to show the grower for review. */
export type PresentOnboardingHelpInput = {
  /** The grower's journey. */
  journeyId: Scalars['String']['input'];
  /** General for a setup question, NO_SUPPORTED_OPERATION for a correction no supported operation can make. */
  reason: OnboardingHelpReason;
  /** What the request cites, by id; at most 200. A NO_SUPPORTED_OPERATION request must cite the correction portion. Empty is valid. */
  references?: InputMaybe<Array<OnboardingHelpReferenceInput>>;
  /** The chat references; session, turn and sent message are required. */
  routing: OnboardingJourneyRoutingInput;
  /** The summary the grower reviews. At most 4000 characters once control and format characters are removed. */
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** The result of a review, or why it was refused. */
export type PresentOnboardingHelpPayload = {
  __typename?: 'PresentOnboardingHelpPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<PresentOnboardingHelpResult>;
};

/** What a review recorded. */
export type PresentOnboardingHelpResult = {
  __typename?: 'PresentOnboardingHelpResult';
  /** True when this request was already sent and accepted; nothing more needs sending. */
  alreadyAccepted: Scalars['Boolean']['output'];
  /** The journey. */
  journeyId: Scalars['String']['output'];
  /** Recorded now, or already recorded by an earlier call. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The review's id. Send it with the grower's request, in a later message. */
  presentationId: Scalars['String']['output'];
  /** The request id wsapi derived from the journey and the reviewed content. Send it with the grower's request. */
  requestId: Scalars['String']['output'];
  /** The staff route the grower is being shown and the request will be bound to. */
  route: OnboardingHelpRouteDetails;
};

/**
 * Why a job event is untouched by a reapply: it was attached ad-hoc to this job, or it is an
 * inherited event this job has excluded.
 */
export enum PreservedJobEventKind {
  /** A grower attached this event to the job directly; the reapply keeps it. */
  AdHocKept = 'AD_HOC_KEPT',
  /** A grower removed this inherited event from the job; the reapply keeps it out. */
  InheritedExcluded = 'INHERITED_EXCLUDED'
}

/**
 * One preserved job event in a reapply preview. Summary carries the wording the schedule
 * renders verbatim, so the phrasing lives in one place rather than in every client.
 */
export type PreservedJobEventProjection = {
  __typename?: 'PreservedJobEventProjection';
  eventId: Scalars['String']['output'];
  /** Which of the job's event lists this row belongs to. */
  eventKind: ProductionJobEventKind;
  kind: PreservedJobEventKind;
  summary: Scalars['String']['output'];
};

/** How sales prices are entered and shown: per each or per shipping unit. Prices are always stored and billed per each, so this changes no price, total or invoice. Separate from the order entry unit, which controls how quantities are entered. */
export enum PriceEntryUnit {
  /** Prices are entered and shown per each. Today's behaviour, and what an unset company, customer or older order reads as. Prices are always stored and billed per each. */
  Each = 'EACH',
  /** Prices are entered and shown per shipping unit (the product's shipping UOM). Prices are always stored and billed per each; the unit price is the each price times the eaches in the unit. */
  Unit = 'UNIT'
}

export type PriceEntryUnitOperationFilterInput = {
  eq?: InputMaybe<PriceEntryUnit>;
  in?: InputMaybe<Array<PriceEntryUnit>>;
  neq?: InputMaybe<PriceEntryUnit>;
  nin?: InputMaybe<Array<PriceEntryUnit>>;
};

export type PriceGroupBulkActionPayload = {
  __typename?: 'PriceGroupBulkActionPayload';
  errors?: Maybe<Array<ValidationError>>;
  priceGroups?: Maybe<Array<PriceGroupPayload>>;
};

export type PriceGroupDocument = {
  __typename?: 'PriceGroupDocument';
  /**
   * The price group this whole group derives its prices from ("this group = group X minus N%"), or
   * null when the group prices only from its own levels. Always paired with
   * DerivedPercentOff. Absent on price groups created before this field existed,
   * which read as no derivation.
   */
  derivedFromPriceGroupId?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage taken off the reference group's resolved price, in percent-value form
   * (4 = 4%), matching PercentOff — NOT the fraction form.
   */
  derivedPercentOff?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  /**
   * True when the group was created by the QB pricing sync (mergePriceGroup) and is owned by
   * it — manual edits may be overwritten on the next sync. False for user-created groups,
   * including groups created before this field existed.
   */
  isManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  numberOfLevels: Scalars['Int']['output'];
  /**
   * The group's ORDER VOLUME discount rule ("≥N units or ≥$X on the order ⇒ P% or $Y off"), or
   * null when the group configures none. Its own setting, deliberately not a price LEVEL:
   * it targets no item and no category, and it produces a discount rather than a charge.
   */
  orderVolumeDiscount?: Maybe<PriceGroupOrderVolumeDiscountDocument>;
  priceId: Scalars['String']['output'];
  /**
   * The group's declarative QUALIFICATION conditions ("placed on/before a cutoff AND at least N
   * days ahead of the requested ship date"), or null when the group is unconditional. Its
   * own setting, deliberately not a price LEVEL: the conditions target no item and no category,
   * and they decide whether the group applies at all rather than what anything costs.
   */
  qualificationConditions?: Maybe<PriceGroupQualificationConditionsDocument>;
  status: PricingStatus;
  tenantId: Scalars['String']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
  /**
   * What uses this price group: customers, ship-tos, other price groups' percent-off price levels and
   * deriving price groups, one group per kind. The total equals the Usage Count and the count a refused
   * delete names. Staff only: a customer caller gets an error and a null list, so the field stays nullable.
   * Read it for one price group at a time: it reads its own groups for each price group it is selected
   * on, so selecting it on a list of price groups costs several reads per row.
   */
  usedBy?: Maybe<UsedBy>;
};


export type PriceGroupDocumentUsedByArgs = {
  first?: Scalars['Int']['input'];
  kind?: InputMaybe<RecordKind>;
  offset?: Scalars['Int']['input'];
};

export type PriceGroupDocumentFilterInput = {
  and?: InputMaybe<Array<PriceGroupDocumentFilterInput>>;
  /**
   * The price group this whole group derives its prices from ("this group = group X minus N%"), or
   * null when the group prices only from its own levels. Always paired with
   * DerivedPercentOff. Absent on price groups created before this field existed,
   * which read as no derivation.
   */
  derivedFromPriceGroupId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The percentage taken off the reference group's resolved price, in percent-value form
   * (4 = 4%), matching PercentOff — NOT the fraction form.
   */
  derivedPercentOff?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * True when the group was created by the QB pricing sync (mergePriceGroup) and is owned by
   * it — manual edits may be overwritten on the next sync. False for user-created groups,
   * including groups created before this field existed.
   */
  isManaged?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberOfLevels?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PriceGroupDocumentFilterInput>>;
  /**
   * The group's ORDER VOLUME discount rule ("≥N units or ≥$X on the order ⇒ P% or $Y off"), or
   * null when the group configures none. Its own setting, deliberately not a price LEVEL:
   * it targets no item and no category, and it produces a discount rather than a charge.
   */
  orderVolumeDiscount?: InputMaybe<PriceGroupOrderVolumeDiscountDocumentFilterInput>;
  priceId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The group's declarative QUALIFICATION conditions ("placed on/before a cutoff AND at least N
   * days ahead of the requested ship date"), or null when the group is unconditional. Its
   * own setting, deliberately not a price LEVEL: the conditions target no item and no category,
   * and they decide whether the group applies at all rather than what anything costs.
   */
  qualificationConditions?: InputMaybe<PriceGroupQualificationConditionsDocumentFilterInput>;
  status?: InputMaybe<PricingStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type PriceGroupDocumentSortInput = {
  /**
   * The price group this whole group derives its prices from ("this group = group X minus N%"), or
   * null when the group prices only from its own levels. Always paired with
   * DerivedPercentOff. Absent on price groups created before this field existed,
   * which read as no derivation.
   */
  derivedFromPriceGroupId?: InputMaybe<SortEnumType>;
  /**
   * The percentage taken off the reference group's resolved price, in percent-value form
   * (4 = 4%), matching PercentOff — NOT the fraction form.
   */
  derivedPercentOff?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  /**
   * True when the group was created by the QB pricing sync (mergePriceGroup) and is owned by
   * it — manual edits may be overwritten on the next sync. False for user-created groups,
   * including groups created before this field existed.
   */
  isManaged?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  numberOfLevels?: InputMaybe<SortEnumType>;
  /**
   * The group's ORDER VOLUME discount rule ("≥N units or ≥$X on the order ⇒ P% or $Y off"), or
   * null when the group configures none. Its own setting, deliberately not a price LEVEL:
   * it targets no item and no category, and it produces a discount rather than a charge.
   */
  orderVolumeDiscount?: InputMaybe<PriceGroupOrderVolumeDiscountDocumentSortInput>;
  priceId?: InputMaybe<SortEnumType>;
  /**
   * The group's declarative QUALIFICATION conditions ("placed on/before a cutoff AND at least N
   * days ahead of the requested ship date"), or null when the group is unconditional. Its
   * own setting, deliberately not a price LEVEL: the conditions target no item and no category,
   * and they decide whether the group applies at all rather than what anything costs.
   */
  qualificationConditions?: InputMaybe<PriceGroupQualificationConditionsDocumentSortInput>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type PriceGroupOrderVolumeDiscountData = {
  __typename?: 'PriceGroupOrderVolumeDiscountData';
  thresholdType: OrderVolumeThresholdType;
  thresholdValue: Scalars['Decimal']['output'];
  value: Scalars['Decimal']['output'];
  valueType: OrderVolumeDiscountValueType;
};

/**
 * The order-volume rule as stored on PriceGroupDocument and exposed to clients.
 * Document-only sub-record (no Data suffix because the parent is itself the read-model
 * boundary type), used by this document and nothing else, so a future field here can never break
 * another type's backward compatibility.
 */
export type PriceGroupOrderVolumeDiscountDocument = {
  __typename?: 'PriceGroupOrderVolumeDiscountDocument';
  thresholdType: OrderVolumeThresholdType;
  /** Units or dollars, per ThresholdType. The rule applies at ≥ this value. */
  thresholdValue: Scalars['Decimal']['output'];
  /**
   * A percent VALUE (10 = 10%) or a dollar amount, per ValueType — never a 0–1
   * fraction, matching DerivedPercentOff and
   * PercentOff.
   */
  value: Scalars['Decimal']['output'];
  valueType: OrderVolumeDiscountValueType;
};

/**
 * The order-volume rule as stored on PriceGroupDocument and exposed to clients.
 * Document-only sub-record (no Data suffix because the parent is itself the read-model
 * boundary type), used by this document and nothing else, so a future field here can never break
 * another type's backward compatibility.
 */
export type PriceGroupOrderVolumeDiscountDocumentFilterInput = {
  and?: InputMaybe<Array<PriceGroupOrderVolumeDiscountDocumentFilterInput>>;
  or?: InputMaybe<Array<PriceGroupOrderVolumeDiscountDocumentFilterInput>>;
  thresholdType?: InputMaybe<OrderVolumeThresholdTypeOperationFilterInput>;
  /** Units or dollars, per ThresholdType. The rule applies at ≥ this value. */
  thresholdValue?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * A percent VALUE (10 = 10%) or a dollar amount, per ValueType — never a 0–1
   * fraction, matching DerivedPercentOff and
   * PercentOff.
   */
  value?: InputMaybe<DecimalOperationFilterInput>;
  valueType?: InputMaybe<OrderVolumeDiscountValueTypeOperationFilterInput>;
};

/**
 * The order-volume rule as stored on PriceGroupDocument and exposed to clients.
 * Document-only sub-record (no Data suffix because the parent is itself the read-model
 * boundary type), used by this document and nothing else, so a future field here can never break
 * another type's backward compatibility.
 */
export type PriceGroupOrderVolumeDiscountDocumentSortInput = {
  thresholdType?: InputMaybe<SortEnumType>;
  /** Units or dollars, per ThresholdType. The rule applies at ≥ this value. */
  thresholdValue?: InputMaybe<SortEnumType>;
  /**
   * A percent VALUE (10 = 10%) or a dollar amount, per ValueType — never a 0–1
   * fraction, matching DerivedPercentOff and
   * PercentOff.
   */
  value?: InputMaybe<SortEnumType>;
  valueType?: InputMaybe<SortEnumType>;
};

export type PriceGroupPayload = {
  __typename?: 'PriceGroupPayload';
  errors?: Maybe<Array<ValidationError>>;
  pricing?: Maybe<PriceGroupStateData>;
};

export type PriceGroupQualificationConditionsData = {
  __typename?: 'PriceGroupQualificationConditionsData';
  minLeadTimeDays?: Maybe<Scalars['Int']['output']>;
  orderByDate?: Maybe<Scalars['LocalDate']['output']>;
};

/**
 * The qualification conditions as stored on PriceGroupDocument and exposed to clients.
 * Document-only sub-record (no Data suffix because the parent is itself the read-model
 * boundary type), used by this document and nothing else, so a future field here can never break
 * another type's backward compatibility.
 */
export type PriceGroupQualificationConditionsDocument = {
  __typename?: 'PriceGroupQualificationConditionsDocument';
  /**
   * The minimum whole days between the placed date and the requested ship date, inclusive at the
   * boundary: exactly this many days qualifies, one fewer does not. 0 is a configured
   * condition; null means the group imposes no lead-time requirement.
   */
  minLeadTimeDays?: Maybe<Scalars['Int']['output']>;
  /**
   * The last date an order may be PLACED on and still qualify — inclusive, so an order placed on
   * the cutoff day itself qualifies. null means the group imposes no cutoff.
   *
   * A calendar DAY, exposed as the LocalDate scalar rather than DateTime: it is a
   * published date with no instant behind it, so a client has no offset to supply and no way to
   * make two spellings of one moment mean two different cutoff days.
   */
  orderByDate?: Maybe<Scalars['LocalDate']['output']>;
};

/**
 * The qualification conditions as stored on PriceGroupDocument and exposed to clients.
 * Document-only sub-record (no Data suffix because the parent is itself the read-model
 * boundary type), used by this document and nothing else, so a future field here can never break
 * another type's backward compatibility.
 */
export type PriceGroupQualificationConditionsDocumentFilterInput = {
  and?: InputMaybe<Array<PriceGroupQualificationConditionsDocumentFilterInput>>;
  /**
   * The minimum whole days between the placed date and the requested ship date, inclusive at the
   * boundary: exactly this many days qualifies, one fewer does not. 0 is a configured
   * condition; null means the group imposes no lead-time requirement.
   */
  minLeadTimeDays?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PriceGroupQualificationConditionsDocumentFilterInput>>;
  /**
   * The last date an order may be PLACED on and still qualify — inclusive, so an order placed on
   * the cutoff day itself qualifies. null means the group imposes no cutoff.
   *
   * A calendar DAY, exposed as the LocalDate scalar rather than DateTime: it is a
   * published date with no instant behind it, so a client has no offset to supply and no way to
   * make two spellings of one moment mean two different cutoff days.
   */
  orderByDate?: InputMaybe<LocalDateOperationFilterInput>;
};

/**
 * The qualification conditions as stored on PriceGroupDocument and exposed to clients.
 * Document-only sub-record (no Data suffix because the parent is itself the read-model
 * boundary type), used by this document and nothing else, so a future field here can never break
 * another type's backward compatibility.
 */
export type PriceGroupQualificationConditionsDocumentSortInput = {
  /**
   * The minimum whole days between the placed date and the requested ship date, inclusive at the
   * boundary: exactly this many days qualifies, one fewer does not. 0 is a configured
   * condition; null means the group imposes no lead-time requirement.
   */
  minLeadTimeDays?: InputMaybe<SortEnumType>;
  /**
   * The last date an order may be PLACED on and still qualify — inclusive, so an order placed on
   * the cutoff day itself qualifies. null means the group imposes no cutoff.
   *
   * A calendar DAY, exposed as the LocalDate scalar rather than DateTime: it is a
   * published date with no instant behind it, so a client has no offset to supply and no way to
   * make two spellings of one moment mean two different cutoff days.
   */
  orderByDate?: InputMaybe<SortEnumType>;
};

export enum PriceGroupQualificationSkipReason {
  LeadTimeBelowMinimum = 'LEAD_TIME_BELOW_MINIMUM',
  MissingBusinessTimeZone = 'MISSING_BUSINESS_TIME_ZONE',
  MissingOrderDate = 'MISSING_ORDER_DATE',
  OrderAfterOrderByDate = 'ORDER_AFTER_ORDER_BY_DATE'
}

/**
 * Where the resolved price group came from: which tier of the Location → Customer → Default
 * hierarchy supplied it, or — when the tier's own group did not QUALIFY for this order — that the
 * group actually used was reached by falling back along the derivation edge.
 */
export enum PriceGroupSource {
  /** The location carried no group; the customer's own group applied, and the order qualified for it. */
  Customer = 'CUSTOMER',
  /** Neither location nor customer carried a group; the tenant default applied. */
  Default = 'DEFAULT',
  /**
   * The tier's own group did not qualify and the price came from a group it DERIVES FROM — the
   * parent that is by construction the "regular" price the conditional group discounts off.
   *
   * This value REPLACES the tier label rather than sitting beside it, and the originating tier
   * is therefore not reported. Every group the walk rejected is listed in
   * skippedPriceGroups, in the order it tried them, ACROSS all tiers — so when an earlier
   * tier's group was offered and its whole chain failed before a later tier's group fell back to
   * its parent, the first entry belongs to the earlier tier, not to the tier that supplied the
   * group finally used. Read the list as "these groups were rejected, in this order", never as a
   * per-tier index.
   *
   *
   * Appended last, so the ordinals of the existing values are unchanged.
   */
  DerivedParentFallback = 'DERIVED_PARENT_FALLBACK',
  /** The order's ship-to location carries this group, and the order qualified for it. */
  Location = 'LOCATION'
}

/**
 * Per-row failure surfaced by validatePriceGroupDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError carries one (best-effort), otherwise null.
 */
export type PriceGroupStagedRowError = {
  __typename?: 'PriceGroupStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type PriceGroupStateData = {
  __typename?: 'PriceGroupStateData';
  derivedFromPriceGroupId?: Maybe<Scalars['String']['output']>;
  derivedPercentOff?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orderVolumeDiscount?: Maybe<PriceGroupOrderVolumeDiscountData>;
  priceLevels: Array<PriceLevelData>;
  qualificationConditions?: Maybe<PriceGroupQualificationConditionsData>;
  status: PricingStatus;
  tenantId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type PriceGroupsConnection = {
  __typename?: 'PriceGroupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PriceGroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PriceGroupDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PriceGroupsEdge = {
  __typename?: 'PriceGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PriceGroupDocument;
};

export enum PriceKind {
  Fixed = 'FIXED',
  PercentOff = 'PERCENT_OFF'
}

export type PriceKindOperationFilterInput = {
  eq?: InputMaybe<PriceKind>;
  in?: InputMaybe<Array<PriceKind>>;
  neq?: InputMaybe<PriceKind>;
  nin?: InputMaybe<Array<PriceKind>>;
};

export type PriceLevelData = {
  __typename?: 'PriceLevelData';
  customerSellPrice?: Maybe<Scalars['Decimal']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  growerCost?: Maybe<Scalars['Decimal']['output']>;
  growerSellPrice: Scalars['Decimal']['output'];
  kind: PriceKind;
  levelType: PriceLevelType;
  percentOff?: Maybe<Scalars['Decimal']['output']>;
  priceLevelId: Scalars['String']['output'];
  quantityThreshold: Scalars['Decimal']['output'];
  referencePriceGroupId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  targetId: Scalars['String']['output'];
  targetName: Scalars['String']['output'];
  type: TargetType;
  volumePoolId?: Maybe<Scalars['String']['output']>;
};

export type PriceLevelDocument = {
  __typename?: 'PriceLevelDocument';
  customerSellPrice?: Maybe<Scalars['Decimal']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The grower's internal cost basis for this level. Staff-only: always null for customer-portal callers, regardless of the stored value. */
  growerCost?: Maybe<Scalars['Decimal']['output']>;
  growerSellPrice: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  kind: PriceKind;
  levelType: PriceLevelType;
  /**
   * The item an Item level targeted before the latest item combine moved it to another item; null
   * when no combine moved it or once that combine is reverted. Any save of the group's levels
   * rewrites every level and clears it.
   */
  originalItemId?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Decimal']['output']>;
  priceGroupId: Scalars['String']['output'];
  priceLevelId: Scalars['String']['output'];
  quantityThreshold: Scalars['Decimal']['output'];
  referencePriceGroupId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  targetId: Scalars['String']['output'];
  targetName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  type: TargetType;
  /**
   * The volume pool this level belongs to, or null when it prices on its own line quantity alone.
   * Resolved from the pool registry by id, so the code and name are always current, and null also
   * when the referenced pool cannot be found.
   */
  volumePool?: Maybe<VolumePool>;
  /**
   * The id of the volume pool this level belongs to; null when the level prices on its own line
   * quantity alone. The pool's code and name are on the volumePool field, resolved from the registry.
   */
  volumePoolId?: Maybe<Scalars['String']['output']>;
};

export type PriceLevelDocumentFilterInput = {
  and?: InputMaybe<Array<PriceLevelDocumentFilterInput>>;
  customerSellPrice?: InputMaybe<DecimalOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  growerSellPrice?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  kind?: InputMaybe<PriceKindOperationFilterInput>;
  levelType?: InputMaybe<PriceLevelTypeOperationFilterInput>;
  or?: InputMaybe<Array<PriceLevelDocumentFilterInput>>;
  /**
   * The item an Item level targeted before the latest item combine moved it to another item; null
   * when no combine moved it or once that combine is reverted. Any save of the group's levels
   * rewrites every level and clears it.
   */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  percentOff?: InputMaybe<DecimalOperationFilterInput>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceLevelId?: InputMaybe<StringOperationFilterInput>;
  quantityThreshold?: InputMaybe<DecimalOperationFilterInput>;
  referencePriceGroupId?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  targetId?: InputMaybe<StringOperationFilterInput>;
  targetName?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<TargetTypeOperationFilterInput>;
  /**
   * The id of the volume pool this level belongs to; null when the level prices on its own line
   * quantity alone. The pool's code and name are on the volumePool field, resolved from the registry.
   */
  volumePoolId?: InputMaybe<StringOperationFilterInput>;
};

export type PriceLevelDocumentSortInput = {
  customerSellPrice?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  growerSellPrice?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  levelType?: InputMaybe<SortEnumType>;
  /**
   * The item an Item level targeted before the latest item combine moved it to another item; null
   * when no combine moved it or once that combine is reverted. Any save of the group's levels
   * rewrites every level and clears it.
   */
  originalItemId?: InputMaybe<SortEnumType>;
  percentOff?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceLevelId?: InputMaybe<SortEnumType>;
  quantityThreshold?: InputMaybe<SortEnumType>;
  referencePriceGroupId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  targetId?: InputMaybe<SortEnumType>;
  targetName?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  /**
   * The id of the volume pool this level belongs to; null when the level prices on its own line
   * quantity alone. The pool's code and name are on the volumePool field, resolved from the registry.
   */
  volumePoolId?: InputMaybe<SortEnumType>;
};

/** Boundary input for a whole-set-replace price level (updatePriceLevels). `kind`, `percentOff`, `referencePriceGroupId`, `levelType`, and `volumePoolId` are all OPTIONAL: omitting one on a level that matches an existing level (by target + quantity threshold + overlapping dates) PRESERVES that existing level's value instead of resetting it to the field's schema default. A level with no existing match (a brand-new level) falls back to the default (kind: FIXED, levelType: LINE_PRICE, no volume pool) when omitted, same as before. Send an explicit value to always win outright over the preserved one, including to deliberately clear a PercentOff configuration back to Fixed. Note: an explicit `null` is indistinguishable from an omitted field on all five — sending `null` also preserves rather than clears; to take levels OUT of a volume pool use setPriceLevelsVolumePool. */
export type PriceLevelInputDataInput = {
  customerSellPrice?: InputMaybe<Scalars['Decimal']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  growerCost?: InputMaybe<Scalars['Decimal']['input']>;
  growerSellPrice: Scalars['Decimal']['input'];
  /** Fixed (default) or PercentOff. OPTIONAL: omitting this on a level that matches an existing level PRESERVES that level's current Kind instead of resetting it to Fixed. Send `FIXED` explicitly to switch a PercentOff level back to Fixed even while omitting percentOff/referencePriceGroupId — a non-zero growerSellPrice has the same effect. */
  kind?: InputMaybe<PriceKind>;
  /** LinePrice (default) or CategoryVolume. OPTIONAL: omitting this on a level that matches an existing level (same target + quantity threshold + overlapping dates) PRESERVES that level's current LevelType instead of resetting it to LinePrice. A level with no existing match at that exact tier still defaults to LinePrice when omitted. */
  levelType?: InputMaybe<PriceLevelType>;
  percentOff?: InputMaybe<Scalars['Decimal']['input']>;
  quantityThreshold: Scalars['Decimal']['input'];
  referencePriceGroupId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  targetId: Scalars['String']['input'];
  targetName: Scalars['String']['input'];
  type: TargetType;
  /** The volume pool id this level belongs to. OPTIONAL: omitting it (or sending null or blank) on a level that matches an existing level PRESERVES that level's current pool; a brand-new level gets no pool. The pool must exist and be active. To remove levels from a pool use setPriceLevelsVolumePool — null here never clears. */
  volumePoolId?: InputMaybe<Scalars['String']['input']>;
};

export enum PriceLevelPriceField {
  CustomerSellPrice = 'CUSTOMER_SELL_PRICE',
  GrowerCost = 'GROWER_COST',
  GrowerSellPrice = 'GROWER_SELL_PRICE'
}

/**
 * Single sort directive for a priceLevelsBlock request. Multiple directives combine into a
 * composite sort in the order supplied. Field must be a GraphQL camelCase field name from the
 * server's allow-list; unknown fields produce a GraphQL error.
 * An ascending Id tiebreaker is always appended after the caller's directives, so this input never
 * needs to (and cannot) name it directly.
 */
export type PriceLevelSortInput = {
  descending: Scalars['Boolean']['input'];
  field: Scalars['String']['input'];
};

export enum PriceLevelType {
  CategoryVolume = 'CATEGORY_VOLUME',
  LinePrice = 'LINE_PRICE'
}

export type PriceLevelTypeOperationFilterInput = {
  eq?: InputMaybe<PriceLevelType>;
  in?: InputMaybe<Array<PriceLevelType>>;
  neq?: InputMaybe<PriceLevelType>;
  nin?: InputMaybe<Array<PriceLevelType>>;
};

/**
 * Windowed result for a single AG Grid SSRM block request against the price levels grid.
 * TotalCount is the count of rows matching the request's filters across every page, computed in
 * the SAME aggregation pass as Nodes (single $facet) so the two values can never drift from each
 * other the way two separate queries could.
 */
export type PriceLevelsBlockPayload = {
  __typename?: 'PriceLevelsBlockPayload';
  /** Rows for the requested offset/limit window. */
  nodes: Array<PriceLevelDocument>;
  /** Total rows matching the request's filters, independent of the current window. */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type PriceLevelsConnection = {
  __typename?: 'PriceLevelsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PriceLevelsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PriceLevelDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PriceLevelsEdge = {
  __typename?: 'PriceLevelsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PriceLevelDocument;
};

/** The one distinguishable reason an item priced or failed to price. */
export enum PriceResolutionOutcome {
  /** Resolution errored internally (surfaced here instead of being swallowed to 0). */
  Error = 'ERROR',
  /** A group resolved, but it holds no level targeting this item or any of its categories. */
  NoLevelsForItem = 'NO_LEVELS_FOR_ITEM',
  /** Candidate levels exist, but none matched the order date and quantity. */
  NoLevelMatches = 'NO_LEVEL_MATCHES',
  /**
   * No price group is CONFIGURED anywhere in the Location → Customer → Default hierarchy, so none
   * was ever offered to this order.
   *
   * Distinct from NO_QUALIFYING_PRICE_GROUP, which is the opposite situation with the same
   * price: groups were found and the order was refused by all of them. This value used to cover
   * both, and its published description used to say so, which was false whenever a group WAS found
   * and rejected.
   */
  NoPriceGroup = 'NO_PRICE_GROUP',
  /**
   * Price groups WERE found and the order qualified for none of them: every tier's group, and
   * every group each of those derives from, was offered and rejected. The chain is EXHAUSTED.
   *
   * Distinct from NO_PRICE_GROUP because the recovery is different and so is the money.
   * "No group is configured" is a setup gap and prices at 0 on every path. "Every group refused
   * this order" names a rule the order missed — read it off skippedPriceGroups — and the
   * money paths no longer accept its 0: the three add paths reject the line outright, and a
   * repriced line keeps the price it already had.
   *
   *
   * Appended last, so the ordinals of the existing values are unchanged.
   */
  NoQualifyingPriceGroup = 'NO_QUALIFYING_PRICE_GROUP',
  /** A level applied and the charged grower sell price is greater than 0. */
  Priced = 'PRICED',
  /**
   * No level of the group's OWN priced this item, but the group's whole-group derivation did:
   * the reference group's winner minus the configured percentage. See
   * Derivation for the full trace. Distinct from
   * Priced so a user can tell "this group prices this item" from "this group inherits
   * this item's price from another group", and from NoLevelsForItem /
   * NoLevelMatches, which would be dishonest labels for a price that WAS charged.
   * Appended last, so the ordinals of the existing values are unchanged.
   */
  PricedByDerivation = 'PRICED_BY_DERIVATION',
  /** A level applied and its grower sell price is exactly 0 (a valid, orderable price). */
  ZeroPrice = 'ZERO_PRICE'
}

export enum PricingMode {
  FlatPrice = 'FLAT_PRICE',
  MarkupPercent = 'MARKUP_PERCENT'
}

export type PricingModeOperationFilterInput = {
  eq?: InputMaybe<PricingMode>;
  in?: InputMaybe<Array<PricingMode>>;
  neq?: InputMaybe<PricingMode>;
  nin?: InputMaybe<Array<PricingMode>>;
};

export enum PricingStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type PricingStatusOperationFilterInput = {
  eq?: InputMaybe<PricingStatus>;
  in?: InputMaybe<Array<PricingStatus>>;
  neq?: InputMaybe<PricingStatus>;
  nin?: InputMaybe<Array<PricingStatus>>;
};

export type ProcessErpLoadListSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type ProcessOnHandAdjustmentInput = {
  externalCustomerId: Scalars['String']['input'];
  externalItemId: Scalars['String']['input'];
  gtin: Scalars['String']['input'];
  processedDate: Scalars['DateTime']['input'];
  quantity: Scalars['Int']['input'];
  resultMessage: Scalars['String']['input'];
  retailerId: Scalars['String']['input'];
  storeNumber: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
  type: OnHandAdjustmentType;
};

export enum ProducePlanFromOrderAccess {
  Anyone = 'ANYONE',
  ProductionStaff = 'PRODUCTION_STAFF'
}

export type ProducePlanFromOrderAccessOperationFilterInput = {
  eq?: InputMaybe<ProducePlanFromOrderAccess>;
  in?: InputMaybe<Array<ProducePlanFromOrderAccess>>;
  neq?: InputMaybe<ProducePlanFromOrderAccess>;
  nin?: InputMaybe<Array<ProducePlanFromOrderAccess>>;
};

export enum ProducePlanningEntryUnit {
  Containers = 'CONTAINERS',
  Eaches = 'EACHES'
}

export enum ProduceRoundingMode {
  Exact = 'EXACT',
  RoundDown = 'ROUND_DOWN',
  RoundUp = 'ROUND_UP'
}

export type ProduceRoundingModeOperationFilterInput = {
  eq?: InputMaybe<ProduceRoundingMode>;
  in?: InputMaybe<Array<ProduceRoundingMode>>;
  neq?: InputMaybe<ProduceRoundingMode>;
  nin?: InputMaybe<Array<ProduceRoundingMode>>;
};

export enum ProduceSpaceConsumptionBasis {
  ProduceQuantity = 'PRODUCE_QUANTITY',
  RequestedQuantity = 'REQUESTED_QUANTITY'
}

export type ProduceSpaceConsumptionBasisOperationFilterInput = {
  eq?: InputMaybe<ProduceSpaceConsumptionBasis>;
  in?: InputMaybe<Array<ProduceSpaceConsumptionBasis>>;
  neq?: InputMaybe<ProduceSpaceConsumptionBasis>;
  nin?: InputMaybe<Array<ProduceSpaceConsumptionBasis>>;
};

export enum ProduceSpacingDimensionUnit {
  Feet = 'FEET',
  Inches = 'INCHES'
}

/** The rungs of the produce-tag resolution ladder, most specific first. */
export enum ProduceTagDimension {
  Category = 'CATEGORY',
  Color = 'COLOR',
  Customer = 'CUSTOMER',
  Genus = 'GENUS',
  ReadyWeek = 'READY_WEEK',
  Series = 'SERIES',
  Year = 'YEAR'
}

/** What a caller knows about the plant it needs a tag for. */
export type ProduceTagResolutionCriteriaInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  readyWeek?: InputMaybe<Scalars['Int']['input']>;
  series?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The answer to one resolution question: the winning tag, why it won, and how many others could
 * also have served.
 */
export type ProduceTagResolutionResult = {
  __typename?: 'ProduceTagResolutionResult';
  /** Whether a tag was found at all. */
  isResolved: Scalars['Boolean']['output'];
  matchedDimensions: Array<ProduceTagDimension>;
  materialItem?: Maybe<MaterialItemDocument>;
  materialItemId?: Maybe<Scalars['String']['output']>;
  runnerUpCount: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  tagCode?: Maybe<Scalars['String']['output']>;
  tagSku?: Maybe<Scalars['String']['output']>;
  tagUpc?: Maybe<Scalars['String']['output']>;
};

/** Where a produce tag came from. */
export enum ProduceTagSource {
  /** A tag kept in step with a fulfill item by an automatic sync. */
  FulfillItem = 'FULFILL_ITEM',
  /** A tag a person created or imported. */
  Manual = 'MANUAL'
}

/** A connection to a list of items. */
export type ProduceTagsByTagCodesConnection = {
  __typename?: 'ProduceTagsByTagCodesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProduceTagsByTagCodesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProduceTagsByTagCodesEdge = {
  __typename?: 'ProduceTagsByTagCodesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemDocument;
};

/** A connection to a list of items. */
export type ProduceTagsConnection = {
  __typename?: 'ProduceTagsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProduceTagsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProduceTagsEdge = {
  __typename?: 'ProduceTagsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemDocument;
};

export enum ProduceWeekDisplayAnchor {
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY'
}

export type ProduceWeekDisplayAnchorOperationFilterInput = {
  eq?: InputMaybe<ProduceWeekDisplayAnchor>;
  in?: InputMaybe<Array<ProduceWeekDisplayAnchor>>;
  neq?: InputMaybe<ProduceWeekDisplayAnchor>;
  nin?: InputMaybe<Array<ProduceWeekDisplayAnchor>>;
};

/** One row of producedLocations: a location, its name, and the quantity produced there. */
export type ProducedLocationQuantity = {
  __typename?: 'ProducedLocationQuantity';
  locationId: Scalars['String']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Decimal']['output'];
};

export type ProducedLocationQuantityInput = {
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
};

/**
 * Where a production job's produced quantity came from: a completed count, or an operator entering or
 * correcting it by hand.
 */
export enum ProducedQuantitySource {
  /** A completed count recorded the produced quantity last. */
  Count = 'COUNT',
  /** An operator entered or corrected the produced quantity last. */
  Override = 'OVERRIDE',
  /** The job has no produced quantity yet. */
  Unknown = 'UNKNOWN'
}

export enum ProductionAdjustmentReason {
  CountCorrection = 'COUNT_CORRECTION',
  Damage = 'DAMAGE',
  Miscount = 'MISCOUNT',
  ShrinkActual = 'SHRINK_ACTUAL'
}

export type ProductionAdjustmentReasonOperationFilterInput = {
  eq?: InputMaybe<ProductionAdjustmentReason>;
  in?: InputMaybe<Array<ProductionAdjustmentReason>>;
  neq?: InputMaybe<ProductionAdjustmentReason>;
  nin?: InputMaybe<Array<ProductionAdjustmentReason>>;
};

/**
 * The lots and jobs a catalog combine touches. Every job on the combined catalog moves to the survivor, open or
 * posted, and keeps its recipe; each lot keeps its own production item.
 */
export type ProductionCatalogCombineLots = {
  __typename?: 'ProductionCatalogCombineLots';
  /** Jobs on the combined catalog, which move to the survivor. */
  jobs: Scalars['Int']['output'];
  /** Lots on the combined catalog that are not closed. */
  open: Scalars['Int']['output'];
  /** Lots on the combined catalog that are closed: their finish job is closed. */
  posted: Scalars['Int']['output'];
  /** Those of the unstamped lots on splits with any posted quantity. A warning, not a refusal. */
  postedUnstampedLotsOnSplits: Scalars['Int']['output'];
  /**
   * Categories the combine splits: the survivor's active production items there link to at most one sales item
   * before it, and with the combined catalog's items that move, to more than one after it. A lot without its own
   * production item on such a category cannot be sold until one is stamped.
   */
  splitCategories: Scalars['Int']['output'];
  /** Open lots on either catalog without their own production item, on one of those categories. */
  unstampedLotsOnSplits: Scalars['Int']['output'];
};

/** What combining the loser catalog into the survivor would do. Nothing is written. */
export type ProductionCatalogCombinePreview = {
  __typename?: 'ProductionCatalogCombinePreview';
  conflictCount: Scalars['Int']['output'];
  fields: Array<ProductionCombineField>;
  loserId: Scalars['String']['output'];
  lots: ProductionCatalogCombineLots;
  survivorId: Scalars['String']['output'];
};

export type ProductionCatalogCombinePreviewPayload = {
  __typename?: 'ProductionCatalogCombinePreviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  preview?: Maybe<ProductionCatalogCombinePreview>;
};

/**
 * Response data model for production catalog.
 * Maps from the domain state to GraphQL response.
 */
export type ProductionCatalogData = {
  __typename?: 'ProductionCatalogData';
  /** The alternate farm vendor snapshots. */
  alternateFarms: Array<ProductionCatalogFarmData>;
  /** Gets the color. */
  color: Scalars['String']['output'];
  /** The default farm vendor snapshot. */
  defaultFarm?: Maybe<ProductionCatalogFarmData>;
  /** Gets the genus. */
  genus: Scalars['String']['output'];
  /** The propagation origin, when supplied. */
  origin?: Maybe<ProductionCatalogOrigin>;
  /** Gets the production catalog ID. */
  productionCatalogId: Scalars['String']['output'];
  /** Gets the series. */
  series: Scalars['String']['output'];
  /** Gets the status. */
  status: ProductionCatalogStatus;
  /** Gets the tenant ID. */
  tenantId: Scalars['String']['output'];
};

/**
 * MongoDB read model document for production catalog entries.
 * Used for fast queries and GraphQL API responses.
 */
export type ProductionCatalogDocument = {
  __typename?: 'ProductionCatalogDocument';
  /** The production catalogs combined into this one. */
  absorbedCatalogIds: Array<Scalars['String']['output']>;
  /** The alternate farm vendor snapshots. */
  alternateFarms: Array<ProductionCatalogFarmDocumentData>;
  /** Gets the color of the production catalog. */
  color: Scalars['String']['output'];
  /** When this production catalog was combined into another. Null unless it was combined. */
  combinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The production catalog this one was combined into. Null unless it was combined. */
  combinedIntoProductionCatalogId?: Maybe<Scalars['String']['output']>;
  /** The default farm vendor snapshot. */
  defaultFarm?: Maybe<ProductionCatalogFarmDocumentData>;
  /** The genus, series and color of each production catalog combined into this one. */
  formerTriples: Array<ProductionCatalogTripleDocument>;
  /** Gets the genus of the production catalog. */
  genus: Scalars['String']['output'];
  /**
   * Unique identifier combining TenantId and ProductionCatalogId.
   * Format: {TenantId}-{ProductionCatalogId}
   */
  id: Scalars['String']['output'];
  /** The propagation origin, when supplied. */
  origin?: Maybe<ProductionCatalogOrigin>;
  /** Gets the unique identifier for this catalog entry. */
  productionCatalogId: Scalars['String']['output'];
  /** Gets the series of the production catalog. */
  series: Scalars['String']['output'];
  /** Gets the current status of this catalog (Active, Inactive, Deleted). */
  status: ProductionCatalogStatus;
  /** Gets the tenant ID that owns this catalog. */
  tenantId: Scalars['String']['output'];
  /** The number of production jobs on this catalog. Null when the count is unavailable. */
  usageCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * MongoDB read model document for production catalog entries.
 * Used for fast queries and GraphQL API responses.
 */
export type ProductionCatalogDocumentFilterInput = {
  /** The production catalogs combined into this one. */
  absorbedCatalogIds?: InputMaybe<ListStringOperationFilterInput>;
  /** The alternate farm vendor snapshots. */
  alternateFarms?: InputMaybe<ListFilterInputTypeOfProductionCatalogFarmDocumentDataFilterInput>;
  and?: InputMaybe<Array<ProductionCatalogDocumentFilterInput>>;
  /** Gets the color of the production catalog. */
  color?: InputMaybe<StringOperationFilterInput>;
  /** When this production catalog was combined into another. Null unless it was combined. */
  combinedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The production catalog this one was combined into. Null unless it was combined. */
  combinedIntoProductionCatalogId?: InputMaybe<StringOperationFilterInput>;
  /** The default farm vendor snapshot. */
  defaultFarm?: InputMaybe<ProductionCatalogFarmDocumentDataFilterInput>;
  /** The genus, series and color of each production catalog combined into this one. */
  formerTriples?: InputMaybe<ListFilterInputTypeOfProductionCatalogTripleDocumentFilterInput>;
  /** Gets the genus of the production catalog. */
  genus?: InputMaybe<StringOperationFilterInput>;
  /**
   * Unique identifier combining TenantId and ProductionCatalogId.
   * Format: {TenantId}-{ProductionCatalogId}
   */
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionCatalogDocumentFilterInput>>;
  /** The propagation origin, when supplied. */
  origin?: InputMaybe<NullableOfProductionCatalogOriginOperationFilterInput>;
  /** Gets the unique identifier for this catalog entry. */
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the series of the production catalog. */
  series?: InputMaybe<StringOperationFilterInput>;
  /** Gets the current status of this catalog (Active, Inactive, Deleted). */
  status?: InputMaybe<ProductionCatalogStatusOperationFilterInput>;
  /** Gets the tenant ID that owns this catalog. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * MongoDB read model document for production catalog entries.
 * Used for fast queries and GraphQL API responses.
 */
export type ProductionCatalogDocumentSortInput = {
  /** Gets the color of the production catalog. */
  color?: InputMaybe<SortEnumType>;
  /** When this production catalog was combined into another. Null unless it was combined. */
  combinedAt?: InputMaybe<SortEnumType>;
  /** The production catalog this one was combined into. Null unless it was combined. */
  combinedIntoProductionCatalogId?: InputMaybe<SortEnumType>;
  /** The default farm vendor snapshot. */
  defaultFarm?: InputMaybe<ProductionCatalogFarmDocumentDataSortInput>;
  /** Gets the genus of the production catalog. */
  genus?: InputMaybe<SortEnumType>;
  /**
   * Unique identifier combining TenantId and ProductionCatalogId.
   * Format: {TenantId}-{ProductionCatalogId}
   */
  id?: InputMaybe<SortEnumType>;
  /** The propagation origin, when supplied. */
  origin?: InputMaybe<SortEnumType>;
  /** Gets the unique identifier for this catalog entry. */
  productionCatalogId?: InputMaybe<SortEnumType>;
  /** Gets the series of the production catalog. */
  series?: InputMaybe<SortEnumType>;
  /** Gets the current status of this catalog (Active, Inactive, Deleted). */
  status?: InputMaybe<SortEnumType>;
  /** Gets the tenant ID that owns this catalog. */
  tenantId?: InputMaybe<SortEnumType>;
};

/** A farm vendor snapshot returned by a catalog mutation. */
export type ProductionCatalogFarmData = {
  __typename?: 'ProductionCatalogFarmData';
  vendorId: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};

/** A farm vendor snapshot on the catalog read model. */
export type ProductionCatalogFarmDocumentData = {
  __typename?: 'ProductionCatalogFarmDocumentData';
  vendorId: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};

/** A farm vendor snapshot on the catalog read model. */
export type ProductionCatalogFarmDocumentDataFilterInput = {
  and?: InputMaybe<Array<ProductionCatalogFarmDocumentDataFilterInput>>;
  or?: InputMaybe<Array<ProductionCatalogFarmDocumentDataFilterInput>>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
  vendorName?: InputMaybe<StringOperationFilterInput>;
};

/** A farm vendor snapshot on the catalog read model. */
export type ProductionCatalogFarmDocumentDataSortInput = {
  vendorId?: InputMaybe<SortEnumType>;
  vendorName?: InputMaybe<SortEnumType>;
};

export enum ProductionCatalogOrigin {
  Cutting = 'CUTTING',
  Liner = 'LINER',
  Plug = 'PLUG',
  Seed = 'SEED'
}

/**
 * GraphQL response payload for production catalog operations.
 * Contains either successful data or validation errors.
 */
export type ProductionCatalogPayload = {
  __typename?: 'ProductionCatalogPayload';
  catalog?: Maybe<ProductionCatalogData>;
  errors?: Maybe<Array<ValidationError>>;
};

export enum ProductionCatalogStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionCatalogStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionCatalogStatus>;
  in?: InputMaybe<Array<ProductionCatalogStatus>>;
  neq?: InputMaybe<ProductionCatalogStatus>;
  nin?: InputMaybe<Array<ProductionCatalogStatus>>;
};

/** A production catalog's genus, series and color as the read model stores them. */
export type ProductionCatalogTripleDocument = {
  __typename?: 'ProductionCatalogTripleDocument';
  color: Scalars['String']['output'];
  genus: Scalars['String']['output'];
  series: Scalars['String']['output'];
};

/** A production catalog's genus, series and color as the read model stores them. */
export type ProductionCatalogTripleDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionCatalogTripleDocumentFilterInput>>;
  color?: InputMaybe<StringOperationFilterInput>;
  genus?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionCatalogTripleDocumentFilterInput>>;
  series?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type ProductionCatalogsConnection = {
  __typename?: 'ProductionCatalogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionCatalogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionCatalogDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionCatalogsEdge = {
  __typename?: 'ProductionCatalogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionCatalogDocument;
};

/** A connection to a list of items. */
export type ProductionCategoriesConnection = {
  __typename?: 'ProductionCategoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionCategoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionCategoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionCategoriesEdge = {
  __typename?: 'ProductionCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionCategoryDocument;
};

export type ProductionCategoryDocument = {
  __typename?: 'ProductionCategoryDocument';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  eaches: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  /**
   * What a grower calls this container — "102 Tray" against the code "P102". Null when the category
   * states no label, in which case every PRODUCE surface names the container by its code instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  laborCostEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  laborCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  materialEventAttachments: Array<ProductionEventAttachmentDocumentData>;
  materialEventNames: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionSpaceCategoryCode: Scalars['String']['output'];
  productionSpaceCategoryId: Scalars['String']['output'];
  spaceEventAttachments: Array<ProductionEventAttachmentDocumentData>;
  spaceEventNames: Scalars['String']['output'];
  status: ProductionCategoryStatus;
  taskEventAttachments: Array<ProductionEventAttachmentDocumentData>;
  taskEventNames: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /** How many units of this category fit on one pole; null when the category does not count by pole. */
  unitsPerPole?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionCategoryDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionCategoryDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  eaches?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * What a grower calls this container — "102 Tray" against the code "P102". Null when the category
   * states no label, in which case every PRODUCE surface names the container by its code instead.
   */
  label?: InputMaybe<OptionOfStringFilterInput>;
  laborCostEffectiveDate?: InputMaybe<DateTimeOperationFilterInput>;
  laborCostPerUnit?: InputMaybe<DecimalOperationFilterInput>;
  materialEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionEventAttachmentDocumentDataFilterInput>;
  materialEventNames?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionCategoryDocumentFilterInput>>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionSpaceCategoryCode?: InputMaybe<StringOperationFilterInput>;
  productionSpaceCategoryId?: InputMaybe<StringOperationFilterInput>;
  spaceEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionEventAttachmentDocumentDataFilterInput>;
  spaceEventNames?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionCategoryStatusOperationFilterInput>;
  taskEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionEventAttachmentDocumentDataFilterInput>;
  taskEventNames?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** How many units of this category fit on one pole; null when the category does not count by pole. */
  unitsPerPole?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionCategoryDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  eaches?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * What a grower calls this container — "102 Tray" against the code "P102". Null when the category
   * states no label, in which case every PRODUCE surface names the container by its code instead.
   */
  label?: InputMaybe<SortEnumType>;
  laborCostEffectiveDate?: InputMaybe<SortEnumType>;
  laborCostPerUnit?: InputMaybe<SortEnumType>;
  materialEventNames?: InputMaybe<SortEnumType>;
  productionCategoryId?: InputMaybe<SortEnumType>;
  productionSpaceCategoryCode?: InputMaybe<SortEnumType>;
  productionSpaceCategoryId?: InputMaybe<SortEnumType>;
  spaceEventNames?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskEventNames?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** How many units of this category fit on one pole; null when the category does not count by pole. */
  unitsPerPole?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionCategoryPayload = {
  __typename?: 'ProductionCategoryPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionCategory?: Maybe<ProductionCategoryStateData>;
};

export type ProductionCategoryStateData = {
  __typename?: 'ProductionCategoryStateData';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  eaches: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  laborCostEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  laborCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  productionCategoryId: Scalars['String']['output'];
  productionMaterialEventAttachments: Array<ProductionEventAttachmentData>;
  productionMaterialEventIds: Array<Scalars['String']['output']>;
  productionSpaceCategoryId: Scalars['String']['output'];
  productionSpaceEventAttachments: Array<ProductionEventAttachmentData>;
  productionSpaceEventIds: Array<Scalars['String']['output']>;
  productionTaskEventAttachments: Array<ProductionEventAttachmentData>;
  productionTaskEventIds: Array<Scalars['String']['output']>;
  status: ProductionCategoryStatus;
  tenantId: Scalars['String']['output'];
  unitsPerPole?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionCategoryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionCategoryStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionCategoryStatus>;
  in?: InputMaybe<Array<ProductionCategoryStatus>>;
  neq?: InputMaybe<ProductionCategoryStatus>;
  nin?: InputMaybe<Array<ProductionCategoryStatus>>;
};

/** One row of a combine preview: a field's value on each item and after the combine. */
export type ProductionCombineField = {
  __typename?: 'ProductionCombineField';
  isConflict: Scalars['Boolean']['output'];
  keepBothAllowed: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: ProductionCombineFieldKind;
  label: Scalars['String']['output'];
  loserValue?: Maybe<Scalars['String']['output']>;
  resultValue?: Maybe<Scalars['String']['output']>;
  survivorValue?: Maybe<Scalars['String']['output']>;
};

/** How a field is merged when one production item is combined into another. */
export enum ProductionCombineFieldKind {
  /** Records that follow the combined item to the survivor. */
  Cascade = 'CASCADE',
  /** What each item already has, shown for comparison only. */
  History = 'HISTORY',
  /** The survivor keeps its value. Never a conflict. */
  Identity = 'IDENTITY',
  /** A list that is unioned. Never a conflict. */
  Multi = 'MULTI',
  /** The survivor's value wins and a blank is filled from the combined item. Two different values are a conflict. */
  Single = 'SINGLE'
}

/** Which value a conflicting field keeps. */
export enum ProductionCombinePickChoice {
  Loser = 'LOSER',
  Survivor = 'SURVIVOR'
}

/** The resolution of one conflicting field, by its preview key. */
export type ProductionCombinePickInput = {
  choice: ProductionCombinePickChoice;
  key: Scalars['String']['input'];
};

export type ProductionDemandIssue = {
  __typename?: 'ProductionDemandIssue';
  /** Warnings keep the line's lots; other issues leave its units unresolved. */
  isWarning: Scalars['Boolean']['output'];
  /** The lineKey of the input line the issue is about. */
  lineKey: Scalars['String']['output'];
  /** A readable explanation that names the value that did not resolve. */
  message: Scalars['String']['output'];
  /** The input line's quantity; on a CONSOLIDATED issue, the line's units in the held lot. */
  quantity: Scalars['Int']['output'];
  /** What went wrong with the line, or what to watch on it. */
  reason: ProductionDemandIssueReason;
};

export enum ProductionDemandIssueReason {
  /** The lot this demand would update was changed or absorbed by an applied consolidation; nothing is written for it. */
  Consolidated = 'CONSOLIDATED',
  /** The quantity is below 1. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** The ready week is not a Monday in yyyy-MM-dd form. */
  NotAMonday = 'NOT_A_MONDAY',
  /** A warning: the site has no single growing-area sub-location, so the line's lots are kept but carry no sub-location. */
  NoGrowingArea = 'NO_GROWING_AREA',
  /** The sales item has no production mapping line for the line's region in the ready week's ISO week. */
  NoMapping = 'NO_MAPPING',
  /** None of the mapped production items has a recipe at the site for the ready week. */
  NoRecipeAtSite = 'NO_RECIPE_AT_SITE',
  /** No customer group is named like the line's region (trimmed, ignoring case). */
  UnknownRegion = 'UNKNOWN_REGION',
  /** No item has the line's sales item number as its SKU (trimmed, exact). */
  UnknownSalesItem = 'UNKNOWN_SALES_ITEM',
  /** No site location has the line's forecast site as its erpId or name (trimmed, ignoring case). */
  UnknownSite = 'UNKNOWN_SITE'
}

export type ProductionDemandLineInput = {
  /** The forecast's site code, matched to a site location by erpId, else by name (trimmed, ignoring case). */
  forecastSite: Scalars['String']['input'];
  /** The caller's id for the line, echoed back on lots and issues. */
  lineKey: Scalars['String']['input'];
  /** The line's units, at least 1. */
  quantity: Scalars['Int']['input'];
  /** The ready week's Monday, yyyy-MM-dd. */
  readyWeek: Scalars['String']['input'];
  /** Region name, matched to a customer group by name (trimmed, ignoring case). */
  region: Scalars['String']['input'];
  /** The sales item's number, matched to an item's SKU (trimmed, exact). */
  salesItemNumber: Scalars['String']['input'];
};

export type ProductionDemandLot = {
  __typename?: 'ProductionDemandLot';
  /** The production item's category code, the import row's category. */
  categoryCode: Scalars['String']['output'];
  /** The production item's catalog colour. */
  color: Scalars['String']['output'];
  /** The customer group the lines' region resolved to. */
  customerGroupId: Scalars['String']['output'];
  /** That customer group's name, the import row's customerGroup. */
  customerGroupName: Scalars['String']['output'];
  /** The production item's catalog genus. */
  genus: Scalars['String']['output'];
  /** Lot Key for the keyed lot import: '<productionPlanId>|<32 lowercase hex>'. */
  lotKey: Scalars['String']['output'];
  /** The production item's catalog id. */
  productionCatalogId: Scalars['String']['output'];
  /** The production item's category id. */
  productionCategoryId: Scalars['String']['output'];
  /** The colour-level production item the lot grows. */
  productionItemId: Scalars['String']['output'];
  /** That production item's number, the import row's itemNumber. */
  productionItemNumber: Scalars['String']['output'];
  /** The units of every source line's share for this lot, summed. */
  quantity: Scalars['Int']['output'];
  /** The ready week's Monday, yyyy-MM-dd. */
  readyWeek: Scalars['String']['output'];
  /** The production item's catalog series. */
  series: Scalars['String']['output'];
  /** The site location the lines' forecast site resolved to. */
  siteLocationId: Scalars['String']['output'];
  /** That site's name, the import row's location. */
  siteName: Scalars['String']['output'];
  /** The lineKeys of the input lines whose units this lot sums. */
  sourceLineKeys: Array<Scalars['String']['output']>;
  /** erpId of the site's single growing-area leaf sub-location (the one leaf with a default space type); null when the site has none or several. */
  sublocationErpId?: Maybe<Scalars['String']['output']>;
};

export type ProductionDemandSplitInput = {
  /**
   * The demand lines to split, at most 20,000 per call. Lines that share a lot key must arrive in the same
   * call.
   */
  lines: Array<ProductionDemandLineInput>;
  /**
   * The plan the lots are for. It prefixes every lot key, so the same demand pushed into two plans makes
   * different lots.
   */
  productionPlanId: Scalars['String']['input'];
};

export type ProductionDemandSplitResult = {
  __typename?: 'ProductionDemandSplitResult';
  /** The input lines' quantities, summed. */
  inputUnits: Scalars['Int']['output'];
  /** One issue per line that did not resolve, plus a warning per resolved line whose site has no single growing area, plus a CONSOLIDATED issue per line with units in a lot an applied consolidation holds. */
  issues: Array<ProductionDemandIssue>;
  /** The lots' quantities, summed. */
  lotUnits: Scalars['Int']['output'];
  /** One entry per lot key, carrying everything ProductionLotImportRowValuesInput needs. A lot an applied consolidation holds is left out. */
  lots: Array<ProductionDemandLot>;
  /** Units on issues that are not warnings. inputUnits = lotUnits + unresolvedUnits. */
  unresolvedUnits: Scalars['Int']['output'];
};

export type ProductionEventAttachmentData = {
  __typename?: 'ProductionEventAttachmentData';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  source: ProductionEventAttachmentSource;
};

export type ProductionEventAttachmentDocumentData = {
  __typename?: 'ProductionEventAttachmentDocumentData';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type ProductionEventAttachmentDocumentDataFilterInput = {
  and?: InputMaybe<Array<ProductionEventAttachmentDocumentDataFilterInput>>;
  defaultAssignedTo?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionEventAttachmentDocumentDataFilterInput>>;
};

export enum ProductionEventAttachmentSource {
  AdHoc = 'AD_HOC',
  Inherited = 'INHERITED'
}

/**
 * One entry of the production items catalog: a native ProductionItem's id and number with its
 * denormalized taxonomy (Genus / Series / Color / Category). Returned by the
 * productionItemsCatalog query and by each mapping line's taxonomy resolver — the taxonomy is
 * always read from the native ProductionItems collection, never copied onto the mapping (W5).
 */
export type ProductionItemCatalogEntry = {
  __typename?: 'ProductionItemCatalogEntry';
  category: Scalars['String']['output'];
  color: Scalars['String']['output'];
  genus: Scalars['String']['output'];
  productionItemId: Scalars['String']['output'];
  productionItemNumber: Scalars['String']['output'];
  series: Scalars['String']['output'];
};

/** What combining the loser into the survivor would do. Nothing is written. */
export type ProductionItemCombinePreview = {
  __typename?: 'ProductionItemCombinePreview';
  conflictCount: Scalars['Int']['output'];
  fields: Array<ProductionCombineField>;
  loserId: Scalars['String']['output'];
  survivorId: Scalars['String']['output'];
};

export type ProductionItemCombinePreviewPayload = {
  __typename?: 'ProductionItemCombinePreviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  preview?: Maybe<ProductionItemCombinePreview>;
};

export type ProductionItemDocument = {
  __typename?: 'ProductionItemDocument';
  /** The numbers of the production items combined into this one. */
  absorbedNumbers: Array<Scalars['String']['output']>;
  /** The production items combined into this one. */
  absorbedProductionItemIds: Array<Scalars['String']['output']>;
  /** The color of the linked production catalog entry, denormalized by the query pipeline. */
  catalogColor: Scalars['String']['output'];
  /** The genus of the linked production catalog entry, denormalized by the query pipeline. */
  catalogGenus: Scalars['String']['output'];
  /** The series of the linked production catalog entry, denormalized by the query pipeline. */
  catalogSeries: Scalars['String']['output'];
  /** The code of the linked production category, denormalized by the query pipeline. */
  categoryCode: Scalars['String']['output'];
  /**
   * The eaches-per-container stated by this item's production category — 288 for a p288 tray. Null
   * when the item's category does not resolve, which is distinct from a category that states zero.
   */
  categoryEaches?: Maybe<Scalars['Int']['output']>;
  /** When this production item was combined into another. Null unless it was combined. */
  combinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The production item this one was combined into. Null unless it was combined. */
  combinedIntoProductionItemId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  laborCostEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  laborCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The eaches-per-unit of the sales item this production item is linked to, resolved through the
   * same Shipping UOM inheritance chain the Products surfaces read. Null when the item is unlinked,
   * when the linked sales item resolves to no Shipping UOM, or when the winning Shipping UOM states
   * no count.
   */
  linkedItemEachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The sales item this production item was linked to before the latest item combine moved the link
   * to the kept item; null when the link came from no combine.
   */
  originalItemId?: Maybe<Scalars['String']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionItemId: Scalars['String']['output'];
  productionItemNumber: Scalars['String']['output'];
  productionTaskEventAttachments: Array<ProductionItemEventAttachmentDocument>;
  /**
   * The labor cost per unit that actually applies to this production item: its own
   * laborCostPerUnit when one is set, otherwise the rate configured on its production
   * category. Null when neither level has a rate configured.
   */
  resolvedLaborCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The id of the record resolvedLaborCostPerUnit came from — this production item's id, or
   * its production category's id. Null when no rate resolved at either level.
   */
  resolvedLaborCostSourceId?: Maybe<Scalars['String']['output']>;
  /**
   * The display name of the record resolvedLaborCostPerUnit came from — this production
   * item's number, or its production category's code. Null when no rate resolved at either level.
   */
  resolvedLaborCostSourceName?: Maybe<Scalars['String']['output']>;
  /**
   * Which level supplied resolvedLaborCostPerUnit — "ProductionItem" when the item
   * carries its own rate, "ProductionCategory" when it inherits one. Null when no rate
   * resolved at either level.
   */
  resolvedLaborCostSourceType?: Maybe<Scalars['String']['output']>;
  /** The sales item (Item aggregate) this production item is linked to. Null when unlinked. */
  salesItemId?: Maybe<Scalars['String']['output']>;
  /** True while the current sales item link was made automatically by matching item numbers. */
  salesItemLinkedAutomatically: Scalars['Boolean']['output'];
  status: ProductionItemStatus;
  tenantId: Scalars['String']['output'];
  /**
   * Ruling D2's flag: true only when this item's category eaches and its linked sales item's
   * eaches-per-unit both resolve and differ. An unlinked item is false, and so is any item where
   * either side is unresolved. Advisory only — nothing downstream blocks, refuses or throws on it,
   * and the conversion still runs on the category's count.
   */
  unitMismatch: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionItemDocumentFilterInput = {
  /** The numbers of the production items combined into this one. */
  absorbedNumbers?: InputMaybe<ListStringOperationFilterInput>;
  /** The production items combined into this one. */
  absorbedProductionItemIds?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<ProductionItemDocumentFilterInput>>;
  /** The color of the linked production catalog entry, denormalized by the query pipeline. */
  catalogColor?: InputMaybe<StringOperationFilterInput>;
  /** The genus of the linked production catalog entry, denormalized by the query pipeline. */
  catalogGenus?: InputMaybe<StringOperationFilterInput>;
  /** The series of the linked production catalog entry, denormalized by the query pipeline. */
  catalogSeries?: InputMaybe<StringOperationFilterInput>;
  /** The code of the linked production category, denormalized by the query pipeline. */
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  /** When this production item was combined into another. Null unless it was combined. */
  combinedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The production item this one was combined into. Null unless it was combined. */
  combinedIntoProductionItemId?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  laborCostEffectiveDate?: InputMaybe<DateTimeOperationFilterInput>;
  laborCostPerUnit?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProductionItemDocumentFilterInput>>;
  /**
   * The sales item this production item was linked to before the latest item combine moved the link
   * to the kept item; null when the link came from no combine.
   */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionItemId?: InputMaybe<StringOperationFilterInput>;
  productionItemNumber?: InputMaybe<StringOperationFilterInput>;
  productionTaskEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionItemEventAttachmentDocumentFilterInput>;
  /**
   * The labor cost per unit that actually applies to this production item: its own
   * laborCostPerUnit when one is set, otherwise the rate configured on its production
   * category. Null when neither level has a rate configured.
   */
  resolvedLaborCostPerUnit?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The id of the record resolvedLaborCostPerUnit came from — this production item's id, or
   * its production category's id. Null when no rate resolved at either level.
   */
  resolvedLaborCostSourceId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The display name of the record resolvedLaborCostPerUnit came from — this production
   * item's number, or its production category's code. Null when no rate resolved at either level.
   */
  resolvedLaborCostSourceName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Which level supplied resolvedLaborCostPerUnit — "ProductionItem" when the item
   * carries its own rate, "ProductionCategory" when it inherits one. Null when no rate
   * resolved at either level.
   */
  resolvedLaborCostSourceType?: InputMaybe<StringOperationFilterInput>;
  /** The sales item (Item aggregate) this production item is linked to. Null when unlinked. */
  salesItemId?: InputMaybe<StringOperationFilterInput>;
  /** True while the current sales item link was made automatically by matching item numbers. */
  salesItemLinkedAutomatically?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<ProductionItemStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionItemDocumentSortInput = {
  /** The color of the linked production catalog entry, denormalized by the query pipeline. */
  catalogColor?: InputMaybe<SortEnumType>;
  /** The genus of the linked production catalog entry, denormalized by the query pipeline. */
  catalogGenus?: InputMaybe<SortEnumType>;
  /** The series of the linked production catalog entry, denormalized by the query pipeline. */
  catalogSeries?: InputMaybe<SortEnumType>;
  /** The code of the linked production category, denormalized by the query pipeline. */
  categoryCode?: InputMaybe<SortEnumType>;
  /** When this production item was combined into another. Null unless it was combined. */
  combinedAt?: InputMaybe<SortEnumType>;
  /** The production item this one was combined into. Null unless it was combined. */
  combinedIntoProductionItemId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  laborCostEffectiveDate?: InputMaybe<SortEnumType>;
  laborCostPerUnit?: InputMaybe<SortEnumType>;
  /**
   * The sales item this production item was linked to before the latest item combine moved the link
   * to the kept item; null when the link came from no combine.
   */
  originalItemId?: InputMaybe<SortEnumType>;
  productionCatalogId?: InputMaybe<SortEnumType>;
  productionCategoryId?: InputMaybe<SortEnumType>;
  productionItemId?: InputMaybe<SortEnumType>;
  productionItemNumber?: InputMaybe<SortEnumType>;
  /**
   * The labor cost per unit that actually applies to this production item: its own
   * laborCostPerUnit when one is set, otherwise the rate configured on its production
   * category. Null when neither level has a rate configured.
   */
  resolvedLaborCostPerUnit?: InputMaybe<SortEnumType>;
  /**
   * The id of the record resolvedLaborCostPerUnit came from — this production item's id, or
   * its production category's id. Null when no rate resolved at either level.
   */
  resolvedLaborCostSourceId?: InputMaybe<SortEnumType>;
  /**
   * The display name of the record resolvedLaborCostPerUnit came from — this production
   * item's number, or its production category's code. Null when no rate resolved at either level.
   */
  resolvedLaborCostSourceName?: InputMaybe<SortEnumType>;
  /**
   * Which level supplied resolvedLaborCostPerUnit — "ProductionItem" when the item
   * carries its own rate, "ProductionCategory" when it inherits one. Null when no rate
   * resolved at either level.
   */
  resolvedLaborCostSourceType?: InputMaybe<SortEnumType>;
  /** The sales item (Item aggregate) this production item is linked to. Null when unlinked. */
  salesItemId?: InputMaybe<SortEnumType>;
  /** True while the current sales item link was made automatically by matching item numbers. */
  salesItemLinkedAutomatically?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionItemEventAttachmentData = {
  __typename?: 'ProductionItemEventAttachmentData';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type ProductionItemEventAttachmentDocument = {
  __typename?: 'ProductionItemEventAttachmentDocument';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
};

export type ProductionItemEventAttachmentDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionItemEventAttachmentDocumentFilterInput>>;
  defaultAssignedTo?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionItemEventAttachmentDocumentFilterInput>>;
};

/** One requested link: supply exactly one production-item id or number and one Sales Item id or code. */
export type ProductionItemLinkPairInput = {
  productionItemId?: InputMaybe<Scalars['String']['input']>;
  productionItemNumber?: InputMaybe<Scalars['String']['input']>;
  salesItemCode?: InputMaybe<Scalars['String']['input']>;
  salesItemId?: InputMaybe<Scalars['String']['input']>;
};

/** How a preview or save ended for one original request row. */
export enum ProductionItemLinkPairOutcome {
  /** The production item already has this link as a manual link; nothing was written. */
  AlreadyLinked = 'ALREADY_LINKED',
  /** The requested link was written. */
  Linked = 'LINKED',
  /** The preview would replace the current Sales Item, included on the result. */
  MovesLink = 'MOVES_LINK',
  /** The row never started because the request was cancelled or its row budget was spent. */
  NotReached = 'NOT_REACHED',
  /** No production item was found in the caller's tenant. */
  ProductionItemNotFound = 'PRODUCTION_ITEM_NOT_FOUND',
  /** The row is invalid, duplicated, or refused by the existing link guards; reason explains why. */
  Refused = 'REFUSED',
  /** No matching Sales Item was found in the caller's tenant. */
  SalesItemNotFound = 'SALES_ITEM_NOT_FOUND',
  /** More than one active Sales Item has this normalized code. */
  SharedCode = 'SHARED_CODE',
  /** The preview found a valid new link, or would confirm an automatic link as manual; nothing was written. */
  WillLink = 'WILL_LINK'
}

/** One pair's result, keyed by its zero-based position in the request; absent metadata is null on GraphQL. */
export type ProductionItemLinkPairResult = {
  __typename?: 'ProductionItemLinkPairResult';
  currentSalesItemId?: Maybe<Scalars['String']['output']>;
  currentSalesItemName?: Maybe<Scalars['String']['output']>;
  outcome: ProductionItemLinkPairOutcome;
  productionItemId?: Maybe<Scalars['String']['output']>;
  productionItemNumber?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  salesItemCode?: Maybe<Scalars['String']['output']>;
  salesItemId?: Maybe<Scalars['String']['output']>;
  salesItemName?: Maybe<Scalars['String']['output']>;
};

/** One requested production item's outcome, keyed by its id. */
export type ProductionItemLinkResult = {
  __typename?: 'ProductionItemLinkResult';
  errors?: Maybe<Array<ValidationError>>;
  productionItemId: Scalars['String']['output'];
  status: ProductionItemLinkResultStatus;
};

/** How one requested production item of a link or unlink ended. */
export enum ProductionItemLinkResultStatus {
  /** The row's change was written. */
  Applied = 'APPLIED',
  /** The row was refused or hit a fault, so nothing was written. */
  Failed = 'FAILED',
  /** The row needed no change, so nothing was written. */
  Skipped = 'SKIPPED'
}

/** One unlinked production item and the single Sales Item its number matches. */
export type ProductionItemNumberMatch = {
  __typename?: 'ProductionItemNumberMatch';
  /** How the number matched the code (exact, or only after ignoring capitals and spaces). */
  matchKind: ItemCodeMatchKind;
  /** Id of the unlinked production item. */
  productionItemId: Scalars['String']['output'];
  /** The production item's number as stored. */
  productionItemNumber: Scalars['String']['output'];
  /** That Sales Item's code (SKU). */
  salesItemCode: Scalars['String']['output'];
  /** Id of the one active Sales Item whose code matches. */
  salesItemId: Scalars['String']['output'];
  /** That Sales Item's display name. */
  salesItemName: Scalars['String']['output'];
};

/** The preview of production items that could be linked by number, and the ones that cannot. */
export type ProductionItemNumberMatches = {
  __typename?: 'ProductionItemNumberMatches';
  /** Number of entries in matches. */
  matchCount: Scalars['Int']['output'];
  /** Production items matching exactly one Sales Item, with how each matched. */
  matches: Array<ProductionItemNumberMatch>;
  /** Number of entries in sharedCodes. */
  sharedCodeCount: Scalars['Int']['output'];
  /** Production items matching two or more Sales Items, with their candidates. */
  sharedCodes: Array<ProductionItemSharedCode>;
};

/** One order line behind a production item's ordered quantity in one ship week. */
export type ProductionItemOrderLineData = {
  __typename?: 'ProductionItemOrderLineData';
  /** Whether the line counts toward the ordered quantity. */
  counted: Scalars['Boolean']['output'];
  /** The counted eaches in containers; 0 when the line is not counted. */
  countedContainers: Scalars['Decimal']['output'];
  /** The production item's share of the line's eaches; 0 when the line is not counted. */
  countedEaches: Scalars['Decimal']['output'];
  /** The order's customer name. */
  customerName: Scalars['String']['output'];
  /** The order's expected delivery date. */
  expectedDeliveryDate: Scalars['DateTime']['output'];
  /** The order line's number. */
  lineNumber: Scalars['Int']['output'];
  /** The production item's share of the line, 100 when the sales item maps to it alone. */
  mixPct: Scalars['Decimal']['output'];
  /** The order's id. */
  orderId: Scalars['String']['output'];
  /** The order's number. */
  orderNumber: Scalars['String']['output'];
  /** The order's status. */
  orderStatus: OrderStatus;
  /** The order's type. */
  orderType: OrderType;
  /** The line's ordered eaches, before the mix split. */
  orderedEaches: Scalars['Int']['output'];
  /** The order's PO number. */
  poNumber: Scalars['String']['output'];
  /** The date that set the ship week. */
  shipDate: Scalars['DateTime']['output'];
  /** Which of the order's dates set its ship week. */
  shipDateSource: OrderShipWeekSource;
};

/** The counted ordered quantity of one production item in one ISO ship week. */
export type ProductionItemOrderedWeekRow = {
  __typename?: 'ProductionItemOrderedWeekRow';
  /** The ISO week number of the ship week. */
  isoWeek: Scalars['Int']['output'];
  /** The ISO year of the ship week. */
  isoYear: Scalars['Int']['output'];
  /** The counted eaches divided by the production category's eaches per container; 0 when the category has none. */
  orderedContainers: Scalars['Decimal']['output'];
  /** The counted eaches, after the mapping's mix split. */
  orderedEaches: Scalars['Decimal']['output'];
  /** The production item the orders' sales items map to. */
  productionItemId: Scalars['String']['output'];
};

/** The ordered quantity by production item and ISO ship week for one site. */
export type ProductionItemOrdersByShipWeekPayload = {
  __typename?: 'ProductionItemOrdersByShipWeekPayload';
  /** Why the window was refused; no rows are returned then. */
  errors?: Maybe<Array<ValidationError>>;
  /** Counted eaches in the window on orders with no ship-from site, on a tenant with more than one site. */
  noShipFromSiteOrderedEaches: Scalars['Decimal']['output'];
  /** One row per production item and ship week with counted eaches above 0. */
  rows: Array<ProductionItemOrderedWeekRow>;
  /** Counted eaches in the window whose sales item maps to no single production item. */
  unmatchedOrderedEaches: Scalars['Decimal']['output'];
};

export type ProductionItemPayload = {
  __typename?: 'ProductionItemPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionItem?: Maybe<ProductionItemStateData>;
};

/** An unlinked production item whose number matches two or more active Sales Items. */
export type ProductionItemSharedCode = {
  __typename?: 'ProductionItemSharedCode';
  /** The two or more active Sales Items whose codes match the number. */
  candidates: Array<SalesItemCandidate>;
  /** Id of the unlinked production item. */
  productionItemId: Scalars['String']['output'];
  /** The production item's number as stored. */
  productionItemNumber: Scalars['String']['output'];
};

export type ProductionItemStateData = {
  __typename?: 'ProductionItemStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  laborCostEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  laborCostPerUnit?: Maybe<Scalars['Decimal']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionItemId: Scalars['String']['output'];
  productionItemNumber: Scalars['String']['output'];
  productionTaskEventAttachments: Array<ProductionItemEventAttachmentData>;
  salesItemId?: Maybe<Scalars['String']['output']>;
  status: ProductionItemStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionItemStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type ProductionItemStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionItemStatus>;
  in?: InputMaybe<Array<ProductionItemStatus>>;
  neq?: InputMaybe<ProductionItemStatus>;
  nin?: InputMaybe<Array<ProductionItemStatus>>;
};

/** A connection to a list of items. */
export type ProductionItemsConnection = {
  __typename?: 'ProductionItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionItemsEdge = {
  __typename?: 'ProductionItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionItemDocument;
};

/**
 * Read-model row for one entry of a job's auditable adjustments trail (Post Jobs post-hoc corrections): a
 * signed Delta applied to the posted quantity at a (Grade x ProducedLocationId) slot, with its Reason and
 * optional Note. Set absolutely by the projection from Production.V1.JobProductionAdjusted (the event carries
 * the full trail). AppliedWhileClosed flags a correction made against an already-Closed job.
 */
export type ProductionJobAdjustmentDocument = {
  __typename?: 'ProductionJobAdjustmentDocument';
  adjustedAt: Scalars['DateTime']['output'];
  adjustedBy: Scalars['String']['output'];
  adjustmentId: Scalars['String']['output'];
  appliedWhileClosed: Scalars['Boolean']['output'];
  delta: Scalars['Int']['output'];
  grade: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  producedLocationId: Scalars['String']['output'];
  reason: ProductionAdjustmentReason;
  resultingSlotQuantity: Scalars['Int']['output'];
};

/**
 * Read-model row for one entry of a job's auditable adjustments trail (Post Jobs post-hoc corrections): a
 * signed Delta applied to the posted quantity at a (Grade x ProducedLocationId) slot, with its Reason and
 * optional Note. Set absolutely by the projection from Production.V1.JobProductionAdjusted (the event carries
 * the full trail). AppliedWhileClosed flags a correction made against an already-Closed job.
 */
export type ProductionJobAdjustmentDocumentFilterInput = {
  adjustedAt?: InputMaybe<DateTimeOperationFilterInput>;
  adjustedBy?: InputMaybe<StringOperationFilterInput>;
  adjustmentId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ProductionJobAdjustmentDocumentFilterInput>>;
  appliedWhileClosed?: InputMaybe<BooleanOperationFilterInput>;
  delta?: InputMaybe<IntOperationFilterInput>;
  grade?: InputMaybe<IntOperationFilterInput>;
  note?: InputMaybe<OptionOfStringFilterInput>;
  or?: InputMaybe<Array<ProductionJobAdjustmentDocumentFilterInput>>;
  producedLocationId?: InputMaybe<StringOperationFilterInput>;
  reason?: InputMaybe<ProductionAdjustmentReasonOperationFilterInput>;
  resultingSlotQuantity?: InputMaybe<IntOperationFilterInput>;
};

/** The consumption manifest across the requested jobs, plus whether any row is short on-hand. */
export type ProductionJobConsumptionManifest = {
  __typename?: 'ProductionJobConsumptionManifest';
  /** True when any row across any job is short on-hand (a batch-level pre-flight signal). */
  hasAnyShortage: Scalars['Boolean']['output'];
  /** Per-job computed consumption rows, in the order the jobs were requested. */
  jobs: Array<ProductionJobConsumptionManifestJob>;
};

/** The computed consumption rows for one production job. */
export type ProductionJobConsumptionManifestJob = {
  __typename?: 'ProductionJobConsumptionManifestJob';
  /** The produced quantity supplied by the caller that drove the computed quantities. */
  producedQuantity: Scalars['Int']['output'];
  /** The production job identifier. */
  productionJobId: Scalars['String']['output'];
  /** The computed consumption rows (one per distinct material item the job's recipe requires). */
  rows: Array<ProductionJobConsumptionManifestRow>;
};

/**
 * One computed consumption row of the manifest: a material required by a job, the recipe multiple, the
 * computed quantity (producedQuantity × multiple, summed across the job's recipe details for that
 * material), the suggested stock bin to draw from, the on-hand available for the material, and whether the
 * computed quantity exceeds on-hand (the step-③ pre-flight shortage signal).
 */
export type ProductionJobConsumptionManifestRow = {
  __typename?: 'ProductionJobConsumptionManifestRow';
  /**
   * The computed quantity to consume: producedQuantity × multiple, summed across the job's recipe
   * material details for this material. Matches the HardgoodsRequiredByReadyWeek math when the produced
   * quantity equals the job's planned quantity.
   */
  computedQuantity: Scalars['Decimal']['output'];
  /**
   * True when `computedQuantity` exceeds `onHandAvailable` — the pre-flight shortage warning the PWA
   * surfaces before posting.
   */
  hasShortage: Scalars['Boolean']['output'];
  /**
   * Suggested stock bin (location) to draw the material from — the material's stock location holding the
   * most on-hand. Empty when the material has no recorded on-hand anywhere.
   */
  locationId: Scalars['String']['output'];
  /** The material item category (denormalized for display). */
  materialItemCategory: Scalars['String']['output'];
  /** The material item identifier to decrement. */
  materialItemId: Scalars['String']['output'];
  /** The material item name (denormalized for display). */
  materialItemName: Scalars['String']['output'];
  /** The recipe material multiple (units of material per produced plant). */
  multiple: Scalars['Decimal']['output'];
  /** Total on-hand available for the material across all its stock bins for the tenant. */
  onHandAvailable: Scalars['Decimal']['output'];
  /** The site location of the suggested stock bin (empty when there is none). */
  siteLocationId: Scalars['String']['output'];
};

/**
 * Request row for productionJobConsumptionManifest: the production job to build a hardgoods
 * consumption manifest for, and the produced quantity that drives the computed material quantities
 * (producedQuantity × recipe material multiple). Produced quantity is the caller-supplied Post
 * Jobs value, which may differ from the job's planned quantity.
 */
export type ProductionJobConsumptionRequestInput = {
  producedQuantity: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
};

/**
 * Cost breakdown for a single production job, resolved from its recipe variation and site location.
 * BASIS CONTRACT: every cost resolver behind this result produces a PER-UNIT figure — the cost of
 * growing one unit. Material, labor and additional costs are defined per unit, so job quantity is never a term in
 * their arithmetic; overhead is priced for the whole job from the space it books and divided by the
 * job's quantity into its per-unit figure. This result publishes both bases explicitly so no consumer
 * has to infer one.
 * Each field named ...Cost carries a JOB TOTAL (the per-unit figure multiplied by a job
 * quantity); each field named ...CostPerUnit carries the unmultiplied per-unit figure.
 * Consumers that want a job total MUST read the total fields and MUST NOT multiply by quantity
 * themselves; consumers that want a unit rate MUST read the ...PerUnit fields.
 * The itemized materialEvents, laborEvents and overheadEvents lines, and the
 * calcSteps audit trail, remain on the PER-UNIT basis: they explain how one unit's cost was
 * derived, and the trail's closing steps record the quantity scaling that produced the job totals.
 *
 * WHICH quantity multiplies WHICH total is costSource-dependent, and the
 * quantities are published rather than left to be inferred. laborCost always scales by
 * quantity, the job's whole-container PLANNED quantity. The other COMPONENT totals
 * (materialsCost, supplierRoyaltyCost, overheadCost, additionalCost) scale by
 * exactQuantity, which equals quantity unless the tenant rounds produce quantities Exact,
 * and computedTotalCost is their sum. The quoted totalCost
 * scales by costingQuantity, which equals quantity unless a flat rate
 * is in effect on a job that has been counted. So totalCost == totalCostPerUnit × quantity
 * holds whenever costSource is COMPUTED and exactQuantity equals quantity,
 * totalCost == computedTotalCost whenever costSource is COMPUTED, and
 * totalCost == totalCostPerUnit × costingQuantity whenever it is FLAT_RATE.
 */
export type ProductionJobCostResult = {
  __typename?: 'ProductionJobCostResult';
  /** The recipe's extra costs for the WHOLE job: additionalCostPerUnit × exactQuantity. */
  additionalCost: Scalars['Decimal']['output'];
  /**
   * The recipe's extra costs (such as plug freight, non-stock packaging or testing fees) for ONE unit (flat):
   * the sum of the costPerEvent of the recipe's additional cost events, each a flat amount per flat.
   */
  additionalCostPerUnit: Scalars['Decimal']['output'];
  /**
   * Step-by-step audit trail showing how each PER-UNIT cost was calculated, followed by the
   * JOB_QUANTITY_APPLIED step that records the quantity scaling into the job totals.
   *
   * JOB_QUANTITY_APPLIED always decomposes the COMPUTED breakdown at the planned quantity,
   * which is what the component fields carry, so the trail cannot disagree with the fields it
   * explains. When a flat rate supersedes the total, one further FLAT_RATE_APPLIED step
   * closes the trail and names the number actually quoted alongside the one it replaced — the
   * same division of labour calculateRecipeCost uses between TOTAL_CALCULATED and
   * FLAT_RATE_APPLIED.
   */
  calcSteps: Array<CostCalcStep>;
  /**
   * Cost of the WHOLE job built up from the components: always equal to the sum of materialsCost, supplierRoyaltyCost,
   * laborCost, overheadCost and additionalCost. Equals totalCost when costSource is
   * COMPUTED; when a flat rate is in effect this is the superseded breakdown total.
   */
  computedTotalCost: Scalars['Decimal']['output'];
  /**
   * Cost of ONE unit built up from the components — the sum of materialsCostPerUnit,
   * supplierRoyaltyCostPerUnit, laborCostPerUnit, overheadCostPerUnit and
   * additionalCostPerUnit —
   * always computed from the breakdown
   * regardless of any flat-rate override. Equals totalCostPerUnit when
   * costSource is COMPUTED; when a flat rate is in effect this is the
   * superseded per-unit figure, published so the breakdown can be shown as reference without the
   * client re-adding the components itself.
   */
  computedTotalCostPerUnit: Scalars['Decimal']['output'];
  /**
   * Whether the quoted totals came from the computed breakdown or from the recipe's flat-rate
   * override. FLAT_RATE means an override is in effect on this job's own recipe and the
   * breakdown fields are reference values only.
   *
   * The server states this rather than leaving the client to infer it. A client comparing
   * totalCost against the component sum would get the wrong answer whenever the flat rate
   * happens to equal the computed total, and a result with no such flag at all is
   * indistinguishable from one where flat rates do not exist.
   */
  costSource: RecipeCostSource;
  /**
   * The quantity the quoted totalCost was converted at:
   * totalCost == totalCostPerUnit × costingQuantity, on every path including the
   * incomplete ones, except a COMPUTED job under the Exact rounding mode whose exactQuantity
   * differs from quantity, where labor and the other components scale by different quantities
   * and totalCost is their sum.
   *
   * Equals quantity whenever costSource is COMPUTED. It
   * diverges only when a flat rate is in effect AND the job has been counted, where it is the
   * job's ACTUAL produced quantity — a flat rate is a per-unit rate applied to the units a job
   * actually made, so a job planned at 50 that produced 48 quotes 48 × the rate. A job that has
   * never been counted has no actual to convert at and falls back to the planned quantity.
   *
   *
   * Published rather than left implicit because a client cannot re-derive it: the job's produced
   * quantity is on a different query, and comparing totalCost / totalCostPerUnit would be
   * a division a client should not have to reason about. It is a decimal rather than an
   * int because the produced quantity it can carry is one.
   */
  costingQuantity: Scalars['Decimal']['output'];
  /**
   * The direct cost of the WHOLE job: materialsCost, supplierRoyaltyCost, laborCost and
   * additionalCost, everything but overhead, so computedTotalCost is this plus overheadCost.
   */
  directCost: Scalars['Decimal']['output'];
  /**
   * The direct cost of ONE unit: materialsCostPerUnit, supplierRoyaltyCostPerUnit,
   * laborCostPerUnit and additionalCostPerUnit, everything but overhead, from the computed breakdown.
   */
  directCostPerUnit: Scalars['Decimal']['output'];
  /**
   * The quantity materialsCostPerUnit, supplierRoyaltyCostPerUnit, overheadCostPerUnit
   * and additionalCostPerUnit scale by into their job totals. Under the Exact rounding mode it is the
   * job's exact (unrounded) planned quantity, for example 0.23 of a tray planned as 1; otherwise, and for a
   * job planned before exact quantities were stored, it equals quantity.
   */
  exactQuantity: Scalars['Decimal']['output'];
  /** Reasons why individual cost components could not be resolved. */
  incompleteCostReasons: Array<Scalars['String']['output']>;
  /** True when all cost components could be fully resolved. */
  isComplete: Scalars['Boolean']['output'];
  /**
   * Labor cost for the WHOLE job: laborCostPerUnit × quantity, the whole-container quantity in
   * every rounding mode.
   */
  laborCost: Scalars['Decimal']['output'];
  /** Labor cost for ONE unit, resolved via the recipe's labor source mode. */
  laborCostPerUnit: Scalars['Decimal']['output'];
  /** Itemized PER-UNIT labor cost events with human-readable names. */
  laborEvents: Array<CostEventResult>;
  /** Itemized PER-UNIT BASE material cost events with human-readable names. */
  materialEvents: Array<CostEventResult>;
  /** BASE material cost for the WHOLE job: materialsCostPerUnit × exactQuantity. */
  materialsCost: Scalars['Decimal']['output'];
  /**
   * BASE material cost for ONE unit, from default vendor pricing summed across all BOM items.
   * Never includes the supplier royalty, which is its own component.
   */
  materialsCostPerUnit: Scalars['Decimal']['output'];
  /** Overall calculation status derived from step severities. */
  overallStatus: CostCalcStepSeverity;
  /**
   * Overhead cost for the WHOLE job: overheadCostPerUnit × exactQuantity. It equals the booked
   * space overhead (the square feet × weeks the job's space usage books, each week at the overhead rate per
   * square foot per week in effect that week; the job's sub-location's own rate when it has one, otherwise its
   * site's) except under the Exact rounding mode, where a part tray carries its exactQuantity share of it. It
   * leaves the job incomplete when the job books no space usage, a space category has no dimensions, or a week
   * has no rate.
   */
  overheadCost: Scalars['Decimal']['output'];
  /**
   * Overhead cost for ONE unit: the booked space overhead (the square feet × weeks the job's space usage books,
   * each week at the overhead rate in effect that week) divided by quantity, and 0 when the
   * quantity is 0 or less.
   */
  overheadCostPerUnit: Scalars['Decimal']['output'];
  /** Itemized PER-UNIT overhead cost events with human-readable names. */
  overheadEvents: Array<CostEventResult>;
  /** The production job this cost was calculated for. */
  productionJobId: Scalars['String']['output'];
  /** The production recipe used for cost resolution. */
  productionRecipeId: Scalars['String']['output'];
  /** The recipe variation selected for this job's week range. Null when variation could not be resolved. */
  productionRecipeVariationId?: Maybe<Scalars['String']['output']>;
  /**
   * The job's whole-container planned quantity. laborCostPerUnit scales by it into
   * laborCost in every rounding mode, so a part tray is charged a full tray of labor. The other
   * components scale by exactQuantity, which equals this outside the Exact rounding mode. The
   * quoted totalCost uses costingQuantity when a flat rate is in effect.
   */
  quantity: Scalars['Int']['output'];
  /** The site location used for labor and overhead rates. Null when site could not be resolved. */
  siteLocationId?: Maybe<Scalars['String']['output']>;
  /** Supplier royalty for the WHOLE job: supplierRoyaltyCostPerUnit × exactQuantity. */
  supplierRoyaltyCost: Scalars['Decimal']['output'];
  /**
   * Supplier royalty for ONE unit, from the SAME selected quotes and the SAME BOM multiples the
   * material cost used. The BOM multiple is applied here, on the per-unit basis; the job quantity
   * is applied once afterwards, exactly as it is for every other component.
   */
  supplierRoyaltyCostPerUnit: Scalars['Decimal']['output'];
  /**
   * Whether every quote behind the supplier royalty states one. INCOMPLETE means the royalty
   * figure is a known subtotal rather than a confirmed supplier cost. Reported separately from
   * isComplete, which describes whether the BASE breakdown resolved.
   */
  supplierRoyaltyCoverage: SupplierRoyaltyCoverage;
  /**
   * Itemized PER-UNIT supplier-royalty events, one per BOM line whose selected quote specifies a
   * royalty. Lines whose royalty is none or unknown produce no entry rather than a zero one.
   */
  supplierRoyaltyEvents: Array<CostEventResult>;
  /**
   * Cost of the WHOLE job as QUOTED: computedTotalCost when costSource is COMPUTED,
   * and totalCostPerUnit × costingQuantity when it is FLAT_RATE. This is the
   * figure to compare against job-total actuals such as JobCostRecordDocument.Amount.
   *
   * When costSource is COMPUTED this equals computedTotalCost, the sum of materialsCost, supplierRoyaltyCost,
   * laborCost, overheadCost and additionalCost. When a flat rate supersedes the breakdown it equals neither — the
   * components are reference figures at the planned quantity, and this is the authored rate at the
   * quantity actually produced. computedTotalCost is the like-for-like comparison.
   */
  totalCost: Scalars['Decimal']['output'];
  /**
   * Cost of ONE unit as QUOTED. Equals computedTotalCostPerUnit unless
   * costSource is FLAT_RATE, in which case it is the recipe's flat-rate
   * override amount and the component per-unit figures are reference values only.
   */
  totalCostPerUnit: Scalars['Decimal']['output'];
};

export type ProductionJobData = {
  __typename?: 'ProductionJobData';
  childJobs: Array<ProductionJobData>;
  countedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  exactQuantity?: Maybe<Scalars['Decimal']['output']>;
  growWeeksOverrides: Array<GrowWeeksOverride>;
  jobExecutionStatus: JobExecutionStatus;
  jobNumber: Scalars['Int']['output'];
  lastPostingAttemptKey?: Maybe<Scalars['String']['output']>;
  lastReconciledRecipeVersion: Scalars['Int']['output'];
  linksOverrides: Array<LinksOverride>;
  locationId?: Maybe<Scalars['String']['output']>;
  materialEventAttachments: Array<ProductionEventAttachmentData>;
  notes?: Maybe<Scalars['String']['output']>;
  plannedHoursOverride?: Maybe<Scalars['Decimal']['output']>;
  plantsPerPotOverrides: Array<PlantsPerPotOverride>;
  postedProductionLines: Array<PostedProductionLine>;
  postedShrinkReason?: Maybe<ShrinkType>;
  postingStatus: JobPostingStatus;
  producedFromCountSessionId?: Maybe<Scalars['String']['output']>;
  producedLocationId?: Maybe<Scalars['String']['output']>;
  producedQuantity?: Maybe<Scalars['Decimal']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionJobId: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  shrinkEvents: Array<ShrinkEvent>;
  spaceEventAttachments: Array<ProductionEventAttachmentData>;
  taskEventAttachments: Array<ProductionEventAttachmentData>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  weekReadyDate: Scalars['DateTime']['output'];
  weekStartDate: Scalars['DateTime']['output'];
  yield: Scalars['Decimal']['output'];
};

export type ProductionJobDocument = {
  __typename?: 'ProductionJobDocument';
  /**
   * Actual output quantity after subtracting recorded shrink events from the job's expected
   * output. Computed as (Quantity * Yield / 100) - sum(ShrinkEvents.Quantity), clamped to
   * never go negative.
   */
  actualYield: Scalars['Decimal']['output'];
  /**
   * The yield summary's ACTUAL output in eaches: actualYield, the expected output with every
   * recorded shrink event taken off, times the plants one of this job's containers holds. Reads 0 when
   * the job's category does not resolve, so show it only when unitLabel is non-empty and it is
   * above 0.
   */
  actualYieldEaches: Scalars['Decimal']['output'];
  categoryName: Scalars['String']['output'];
  color: Scalars['String']['output'];
  /** Count of completed task assignments on this job. */
  completedTaskCount: Scalars['Int']['output'];
  /**
   * CC-WSAPI-B4 — when the produced quantity was recorded (the source CountSession's CompletedAt).
   * Nullable/additive; null until the job is counted.
   */
  countedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  /**
   * The customer name for the job's lot-derived CustomerId, or null when the job's lot carries no customer
   * (CustomerId null) or the customer summary is absent. Mirrors the retired customer join, which read the
   * unwound lot's CustomerId (surfaced here as the aggregation-projected customerId field).
   */
  customerName?: Maybe<Scalars['String']['output']>;
  /** When the floor marked this job done (This week › Mark done), or null. */
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who marked it done (user email), or null. */
  doneBy?: Maybe<Scalars['String']['output']>;
  /**
   * This job's eaches: its quantity TO PRODUCE times the joined production category's eaches-per-container
   * constant (a p288 tray is 288). Computed PER ROW, so a lot of 2 on a 288 category reads 576 and never
   * the bare category constant. Zero when the job's category does not resolve, matching the schedule
   * grid's other unresolved-join numeric defaults.
   */
  eaches: Scalars['Decimal']['output'];
  /**
   * How many plants ONE of this job's containers holds, as its production category states it. Null when
   * the category does not resolve, which is a different answer from a category that states 0.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The effective grow-weeks in force for this job: the most-recently-set grow-weeks override for the
   * week-selected recipe variation, else that variation's recipe-default grow-weeks; null when the job's
   * ready week resolves to no applicable variation. Computed at read time against the current recipe —
   * never persisted by the projection, so the accaf08f replay-purity constraint does not apply. Variation
   * selection uses ProductionVariationSelector.SelectForWeek, the same rule the CountSession
   * snapshot and reapply-recipes preview use, so all three report the effective value for the same variation.
   * Emits a nullable Int at the schema (null = no applicable variation), matching the codebase's async
   * field-resolver convention (e.g. RestockDailyDemandRowResolvers.GetStoreRanking).
   */
  effectiveGrowWeeks?: Maybe<Scalars['Int']['output']>;
  /**
   * The effective plants-per-pot in force for this job: the most-recently-set plants-per-pot override for
   * the week-selected recipe variation, else that variation's recipe-default plants-per-pot; null when the
   * job's ready week resolves to no applicable variation. Computed at read time against the current recipe —
   * never persisted by the projection, so the accaf08f replay-purity constraint does not apply. Variation
   * selection uses ProductionVariationSelector.SelectForWeek, the same rule the CountSession
   * snapshot and reapply-recipes preview use, so all three report the effective value for the same variation.
   * Emits a nullable Int at the schema (null = no applicable variation), matching the codebase's async
   * field-resolver convention (e.g. RestockDailyDemandRowResolvers.GetStoreRanking).
   */
  effectivePlantsPerPot?: Maybe<Scalars['Int']['output']>;
  /** Inherited material and space events this job has had removed. */
  eventExclusions: Array<ProductionJobEventExclusionDocument>;
  /**
   * The exact (unrounded) planned quantity behind the whole-container quantity, e.g. 4.58 p288 trays
   * planned as 5. For a quantity set by hand it is that quantity. Null for jobs planned before it was
   * stored.
   */
  exactQuantity?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The yield summary's EXPECTED output in eaches: the quantity this job is set to produce, scaled by
   * its yield percentage, times the plants one of its containers holds. The eaches rendering of the
   * same figure the summary's Expected row shows in containers. Reads 0 when the job's category does
   * not resolve, so show it only when unitLabel is non-empty and it is above 0.
   */
  expectedOutputEaches: Scalars['Decimal']['output'];
  genus: Scalars['String']['output'];
  /**
   * The most-recently-set grow-weeks override value (the override with the latest
   * SetAt) across this job's per-variation overrides, or None when no override is set.
   * Lets the inline-edit UI surface the raw override value and detect the cleared state.
   * Option<T> per the active null-safety standard (5a153a33); OptionTypeInterceptor emits a
   * nullable Int at the schema, so this is schema-neutral.
   */
  growWeeksOverride?: Maybe<Scalars['Int']['output']>;
  growWeeksOverrides: Array<GrowWeeksOverride>;
  id: Scalars['String']['output'];
  /**
   * True when this job carries any per-variation grow-weeks override (i.e. the planner has
   * overridden grow weeks for at least one recipe variation). Drives the inline-edit "overridden"
   * badge. Computed live from the persisted GrowWeeksOverrides
   * collection — no projection state of its own, so it is replay-safe.
   */
  isGrowWeeksOverridden: Scalars['Boolean']['output'];
  /**
   * True when this job carries any per-variation plants-per-pot override. Drives the inline-edit
   * "overridden" badge. Computed live from the persisted
   * PlantsPerPotOverrides collection.
   */
  isPlantsPerPotOverridden: Scalars['Boolean']['output'];
  /**
   * True once a Production.V1.LotQuantityOverridden event has set this job's effective Quantity
   * away from the recipe-cascade value. There is no quantity-clear event, so this latches true.
   * Defaults false; pre-feature documents missing the field deserialize to false (no migration),
   * matching the JobExecutionStatus / ShrinkEvents additive precedent in this file.
   */
  isQuantityOverridden: Scalars['Boolean']['output'];
  isRecipeStale: Scalars['Boolean']['output'];
  /**
   * True once a Production.V1.JobYieldOverridden event has fired for this job. There is no
   * yield-clear event, so this latches true. Defaults false.
   */
  isYieldOverridden: Scalars['Boolean']['output'];
  jobExecutionStatus: JobExecutionStatus;
  jobNumber: Scalars['Int']['output'];
  /**
   * The client-minted posting attempt key carried on the job's latest keyed posting, or null when the job
   * has never been posted with an attempt key. A posting without a key leaves any earlier key unchanged.
   */
  lastPostingAttemptKey?: Maybe<Scalars['String']['output']>;
  lastReconciledRecipeVersion: Scalars['Int']['output'];
  linksOverrides: Array<LinksOverride>;
  locationId?: Maybe<Scalars['String']['output']>;
  /**
   * The job's location name: the sub-location's name when the job's LocationId resolves to a sub-location,
   * else the site-location's name when it resolves to a site, else null. Mirrors the retired aggregation's
   * SubLocation ?? SiteLocation ?? null precedence exactly (both were joined on the job's LocationId).
   */
  locationName?: Maybe<Scalars['String']['output']>;
  lotClosedStatus: LotClosedStatus;
  lotStatus: ProductionLotStatus;
  materialEventAttachments: Array<ProductionJobEventAttachmentDocument>;
  /**
   * The site the job was moved to when that site's recipe had no variation for the job's ready week,
   * so the job kept the recipe values of the site it left (Production.V1.JobNoRecipeAtSiteFlagged).
   * Null when the job is not flagged. A move or reapply that applies the variation for the job's
   * current site clears it (Production.V1.JobNoRecipeAtSiteCleared).
   */
  noRecipeAtSiteLocationId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * The catalog this job was on before its first catalog substitution. Null when the job was never
   * substituted, or was substituted back to that catalog. Written absolutely from
   * Production.V1.ProductionLotJobsOriginalCatalogRecorded; the schedule's Original Catalog column names it.
   */
  originalProductionCatalogId?: Maybe<Scalars['String']['output']>;
  /**
   * The ORIGINAL (imported, planned) ready/start week pair — "Original Ready Week" and
   * "Original Start Week" on the schedule grid. Captured once, from the week values the
   * ProductionLotCreated event carries for this job, and never rewritten afterwards: the
   * week-override events, grow-week overrides, recipe reapply and every cascade move the
   * mutable WeekReady*\/WeekStart* pair above (the "actual") and leave these alone. That
   * contrast is the whole feature — a grower compares the two to see which batches hit the
   * target ready date (CMG request row 42).
   *
   * Plain value members rather than Option<T>: the document's identity already implies a
   * creation event, so there is no meaningful "never had an original" state to model once the
   * backfill has run. Pre-backfill documents deserialize the missing fields to default(DateTime)
   * / 0, which is why the backfill (a checkpoint reset that replays ProductionLot-* from zero)
   * is part of this change rather than optional — see the projection service.
   */
  originalWeekReadyDate: Scalars['DateTime']['output'];
  originalWeekReadyIsoWeek: Scalars['Int']['output'];
  originalWeekReadyIsoYear: Scalars['Int']['output'];
  originalWeekStartDate: Scalars['DateTime']['output'];
  originalWeekStartIsoWeek: Scalars['Int']['output'];
  originalWeekStartIsoYear: Scalars['Int']['output'];
  parentProductionJobId?: Maybe<Scalars['String']['output']>;
  /**
   * Manual planned-hours override for this job (labor domain), or None when never set / cleared.
   * Some(hours) means a planner has pinned an explicit labor-hours figure that wins over the
   * recipe-derived per-task-event hours in LaborDemand — the escape hatch for migrated flat recipes
   * whose task events carry no UnitsPerHour. Provenance is exposed via the computed
   * plannedHoursSource field (Manual when Some, Recipe when None). Option<T> per the
   * active null-safety standard (5a153a33), matching YieldOverride / PropagationYield in this file;
   * OptionTypeInterceptor emits a nullable Decimal at the schema. Additive — pre-feature documents
   * missing the field deserialize to None.
   */
  plannedHoursOverride?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Provenance of this job's effective planned labor hours: 'Manual' when a manual planned-hours
   * override is set on the job (and therefore wins in LaborDemand), else 'Recipe' (hours derive from
   * the recipe's per-task-event throughput). Computed live from the persisted override, so it is
   * replay-safe with no projection state of its own. Pair with the raw plannedHoursOverride value the
   * document exposes directly so the PWA can render the override and its source.
   */
  plannedHoursSource: PlannedHoursSource;
  /**
   * The most-recently-set plants-per-pot override value (latest SetAt) across this job's
   * per-variation overrides, or None when no override is set. Option<T> per the active
   * null-safety standard (5a153a33); OptionTypeInterceptor emits a nullable Int at the schema.
   */
  plantsPerPotOverride?: Maybe<Scalars['Int']['output']>;
  plantsPerPotOverrides: Array<PlantsPerPotOverride>;
  postedAdjustments: Array<ProductionJobAdjustmentDocument>;
  postedProductionLines: Array<ProductionJobPostedLineDocument>;
  /**
   * The containers already posted from this job: the sum of every line in postedProductionLines,
   * dump and shrink lines included. 0 until the job is first posted.
   */
  postedQuantity: Scalars['Int']['output'];
  postedShrinkReason?: Maybe<ShrinkType>;
  postingStatus: JobPostingStatus;
  /**
   * This job's PRODUCED eaches: its counted produced quantity times the same category factor
   * eaches multiplies by. Null while the job is uncounted, mirroring the
   * producedQuantity it derives from; zero when a counted job's category does not resolve.
   */
  producedEaches?: Maybe<Scalars['Decimal']['output']>;
  /**
   * CC-WSAPI-B4 — where the job actually ended up (defaults to the job's location when the count
   * flow captures none). Nullable/additive; null until the job is counted.
   */
  producedLocationId?: Maybe<Scalars['String']['output']>;
  /** Where the produced quantity is, by location, in entry order. Empty = the single producedLocationId. */
  producedLocations: Array<ProducedLocationQuantity>;
  /**
   * CC-WSAPI-B4 — actual produced quantity counted at the line, written back from a completed
   * CountSession. Nullable (additive, backward-compatible per Atlas bde8323d); null until the job
   * is counted. Distinct from Quantity (the planned/target quantity). Pre-feature
   * documents missing the field deserialize to null.
   */
  producedQuantity?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Where this job's producedQuantity came from: COUNT when a completed count set it last,
   * OVERRIDE when an operator entered or corrected it last, and UNKNOWN while the job has none.
   */
  producedQuantitySource: ProducedQuantitySource;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  /**
   * The production item the job's lot grows. Set on the lot's finish job only; null on every other
   * job and on a finish job whose lot has none.
   */
  productionItemId?: Maybe<Scalars['String']['output']>;
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  productionPlanName: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  /**
   * The propagation yield (0.0–1.0) carried by the last Production.V1.JobPropagationYieldSet event,
   * or None if it was never set. Option<decimal> keeps the unset state distinct from an explicit
   * 0.0 so the inline-edit UI can tell "never set" from a deliberate zero. Option<T> per the
   * active null-safety standard (5a153a33); OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  propagationYield?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The purchase orders linked to this job, with each linked order's status and the quantity still owed
   * to this job. Empty when the job has no linked purchase order line.
   */
  purchaseOrdersForJob: Array<PurchaseOrderForJobData>;
  quantity: Scalars['Int']['output'];
  /**
   * The eaches a grower ASKED this job's lot for: the lot's requested quantity in containers times the
   * number of plants this job's container holds. This is the figure the phone labels Requested, and it
   * is the same number the production schedule reports in its own requestedEaches column for the
   * same job. Distinct from eaches, which is the quantity this job is set to PRODUCE, and the
   * two differ the moment either the lot's or the job's quantity is overridden. Reads 0 when the job
   * carries no lot or when its category does not resolve, so show it only when unitLabel is
   * non-empty and it is above 0.
   */
  requestedEaches: Scalars['Decimal']['output'];
  series: Scalars['String']['output'];
  /**
   * Each of this job's recorded shrink events, expressed in eaches, keyed by the id of the event it
   * belongs to. A history row binds the entry whose shrinkEventId matches its own rather than
   * multiplying that event's container quantity for itself. One entry per shrink event in the order the
   * job records them, and empty when the job has recorded none. Every entry reads 0 when the job's
   * category does not resolve, so show them only when unitLabel is non-empty.
   */
  shrinkEventEaches: Array<ProductionJobShrinkEventEachesData>;
  /**
   * Shrink/loss events recorded against this job during production. Defaults to
   * empty array; pre-existing documents missing this field deserialize naturally.
   */
  shrinkEvents: Array<ProductionJobShrinkEventDocument>;
  /**
   * Every run of weeks this job books, ordered by start week: space-event weeks, held weeks and
   * base-footprint weeks, each with its space type and square feet per week. Read from the same
   * space-usage rows as sqFtRequired.
   */
  spaceBookings: Array<JobSpaceBooking>;
  /**
   * SC-WSAPI-B — the space-category dimensions snapshotted onto this job at creation, or null when
   * the job has no resolved dimensions. Composed live from the persisted scalars, so it is
   * replay-safe (no projection state of its own). Pair with
   * SpaceDimensionsSource for provenance (site override vs default).
   */
  spaceDimensions?: Maybe<ProductionJobSpaceDimensionsData>;
  spaceDimensionsSource?: Maybe<DimensionSource>;
  spaceEventAttachments: Array<ProductionJobEventAttachmentDocument>;
  /**
   * Why sqFtRequired came back zero, or OK when it did not. See
   * SqFtRequirementCalculator for the classification.
   */
  sqFtReason: SqFtReason;
  /**
   * Round 7 section G — the square footage this job requires at its PEAK concurrent week, reading
   * back the same space-usage segments the space plan (spaceUtilization) itself reads
   * (SqFtRequirementCalculator, shared with the SpaceUsage write path — one calculator, not
   * two, and no re-derivation of dimensions or quantity). Zero whenever sqFtReason is not
   * OK; pair the two fields so the spacing section can show an info affordance for why.
   */
  sqFtRequired: Scalars['Decimal']['output'];
  /** When the floor marked this job started (This week › Mark started), or null. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who marked it started (user email), or null. */
  startedBy?: Maybe<Scalars['String']['output']>;
  taskEventAttachments: Array<ProductionJobEventAttachmentDocument>;
  tenantId: Scalars['String']['output'];
  /** Aggregated labor units from all task assignments on this job. */
  totalLoggedLaborUnits: Scalars['Int']['output'];
  /** Aggregated time (in seconds) from all task assignments on this job. */
  totalLoggedSeconds: Scalars['Long']['output'];
  /** Count of non-cancelled task assignments on this job. */
  totalTaskCount: Scalars['Int']['output'];
  /**
   * What a grower calls this job's container: the joined category's label when it states one, otherwise
   * that category's code. Empty when the job's category does not resolve, matching
   * categoryName's no-match default on the same join.
   */
  unitLabel: Scalars['String']['output'];
  /**
   * The containers this job produced that are not posted yet: producedQuantity less
   * postedQuantity, and never below 0, so a job posted past its produced quantity reads 0. Also 0
   * while the job has no produced quantity. Counted in whole containers: part of a container left by an
   * older entry is not included, because only whole containers can be posted.
   */
  unpostedProducedQuantity: Scalars['Int']['output'];
  /**
   * The containers this job is set to produce that are not posted yet: quantity less
   * postedQuantity, and never below 0, so a job posted past its planned quantity reads 0. Dump and
   * shrink lines already posted count as posted. A job with nothing posted reads its whole quantity.
   */
  unpostedQuantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  weekReadyDate: Scalars['DateTime']['output'];
  weekReadyIsoWeek: Scalars['Int']['output'];
  weekReadyIsoYear: Scalars['Int']['output'];
  weekStartDate: Scalars['DateTime']['output'];
  weekStartIsoWeek: Scalars['Int']['output'];
  weekStartIsoYear: Scalars['Int']['output'];
  yield: Scalars['Decimal']['output'];
  /**
   * The raw yield override value carried by the last Production.V1.JobYieldOverridden event, or
   * None if yield was never overridden. Equals Yield once set (the yield override is a destructive
   * replace of the effective Yield); surfaced separately so the inline-edit UI can distinguish an
   * explicit override from a recipe-derived effective yield, and detect the not-overridden state.
   * Option<T> per the active null-safety standard (5a153a33), matching the file's newest
   * additive member ShrinkEvent.Notes; OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  yieldOverride?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The yield summary's VARIANCE in eaches: actual output minus expected output, times the plants one
   * of this job's containers holds. NEGATIVE when the job lost more than its yield allowed for, which
   * is the ordinary reading, so a client must not treat a value below 0 as an error. Reads 0 when the
   * job's category does not resolve, which a client tells apart from a real zero variance by
   * unitLabel being empty.
   */
  yieldVarianceEaches: Scalars['Decimal']['output'];
};

export type ProductionJobDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionJobDocumentFilterInput>>;
  /** Count of completed task assignments on this job. */
  completedTaskCount?: InputMaybe<IntOperationFilterInput>;
  /**
   * CC-WSAPI-B4 — when the produced quantity was recorded (the source CountSession's CompletedAt).
   * Nullable/additive; null until the job is counted.
   */
  countedAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  /** When the floor marked this job done (This week › Mark done), or null. */
  doneAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Who marked it done (user email), or null. */
  doneBy?: InputMaybe<StringOperationFilterInput>;
  /** Inherited material and space events this job has had removed. */
  eventExclusions?: InputMaybe<ListFilterInputTypeOfProductionJobEventExclusionDocumentFilterInput>;
  /**
   * The exact (unrounded) planned quantity behind the whole-container quantity, e.g. 4.58 p288 trays
   * planned as 5. For a quantity set by hand it is that quantity. Null for jobs planned before it was
   * stored.
   */
  exactQuantity?: InputMaybe<OptionOfDecimalFilterInput>;
  growWeeksOverrides?: InputMaybe<ListFilterInputTypeOfGrowWeeksOverrideFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * True once a Production.V1.LotQuantityOverridden event has set this job's effective Quantity
   * away from the recipe-cascade value. There is no quantity-clear event, so this latches true.
   * Defaults false; pre-feature documents missing the field deserialize to false (no migration),
   * matching the JobExecutionStatus / ShrinkEvents additive precedent in this file.
   */
  isQuantityOverridden?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * True once a Production.V1.JobYieldOverridden event has fired for this job. There is no
   * yield-clear event, so this latches true. Defaults false.
   */
  isYieldOverridden?: InputMaybe<BooleanOperationFilterInput>;
  jobExecutionStatus?: InputMaybe<JobExecutionStatusOperationFilterInput>;
  jobNumber?: InputMaybe<IntOperationFilterInput>;
  /**
   * The client-minted posting attempt key carried on the job's latest keyed posting, or null when the job
   * has never been posted with an attempt key. A posting without a key leaves any earlier key unchanged.
   */
  lastPostingAttemptKey?: InputMaybe<StringOperationFilterInput>;
  lastReconciledRecipeVersion?: InputMaybe<IntOperationFilterInput>;
  linksOverrides?: InputMaybe<ListFilterInputTypeOfLinksOverrideFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  lotClosedStatus?: InputMaybe<LotClosedStatusOperationFilterInput>;
  lotStatus?: InputMaybe<ProductionLotStatusOperationFilterInput>;
  materialEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionJobEventAttachmentDocumentFilterInput>;
  /**
   * The site the job was moved to when that site's recipe had no variation for the job's ready week,
   * so the job kept the recipe values of the site it left (Production.V1.JobNoRecipeAtSiteFlagged).
   * Null when the job is not flagged. A move or reapply that applies the variation for the job's
   * current site clears it (Production.V1.JobNoRecipeAtSiteCleared).
   */
  noRecipeAtSiteLocationId?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionJobDocumentFilterInput>>;
  /**
   * The catalog this job was on before its first catalog substitution. Null when the job was never
   * substituted, or was substituted back to that catalog. Written absolutely from
   * Production.V1.ProductionLotJobsOriginalCatalogRecorded; the schedule's Original Catalog column names it.
   */
  originalProductionCatalogId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The ORIGINAL (imported, planned) ready/start week pair — "Original Ready Week" and
   * "Original Start Week" on the schedule grid. Captured once, from the week values the
   * ProductionLotCreated event carries for this job, and never rewritten afterwards: the
   * week-override events, grow-week overrides, recipe reapply and every cascade move the
   * mutable WeekReady*\/WeekStart* pair above (the "actual") and leave these alone. That
   * contrast is the whole feature — a grower compares the two to see which batches hit the
   * target ready date (CMG request row 42).
   *
   * Plain value members rather than Option<T>: the document's identity already implies a
   * creation event, so there is no meaningful "never had an original" state to model once the
   * backfill has run. Pre-backfill documents deserialize the missing fields to default(DateTime)
   * / 0, which is why the backfill (a checkpoint reset that replays ProductionLot-* from zero)
   * is part of this change rather than optional — see the projection service.
   */
  originalWeekReadyDate?: InputMaybe<DateTimeOperationFilterInput>;
  originalWeekReadyIsoWeek?: InputMaybe<IntOperationFilterInput>;
  originalWeekReadyIsoYear?: InputMaybe<IntOperationFilterInput>;
  originalWeekStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  originalWeekStartIsoWeek?: InputMaybe<IntOperationFilterInput>;
  originalWeekStartIsoYear?: InputMaybe<IntOperationFilterInput>;
  parentProductionJobId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Manual planned-hours override for this job (labor domain), or None when never set / cleared.
   * Some(hours) means a planner has pinned an explicit labor-hours figure that wins over the
   * recipe-derived per-task-event hours in LaborDemand — the escape hatch for migrated flat recipes
   * whose task events carry no UnitsPerHour. Provenance is exposed via the computed
   * plannedHoursSource field (Manual when Some, Recipe when None). Option<T> per the
   * active null-safety standard (5a153a33), matching YieldOverride / PropagationYield in this file;
   * OptionTypeInterceptor emits a nullable Decimal at the schema. Additive — pre-feature documents
   * missing the field deserialize to None.
   */
  plannedHoursOverride?: InputMaybe<OptionOfDecimalFilterInput>;
  plantsPerPotOverrides?: InputMaybe<ListFilterInputTypeOfPlantsPerPotOverrideFilterInput>;
  postedAdjustments?: InputMaybe<ListFilterInputTypeOfProductionJobAdjustmentDocumentFilterInput>;
  postedProductionLines?: InputMaybe<ListFilterInputTypeOfProductionJobPostedLineDocumentFilterInput>;
  postedShrinkReason?: InputMaybe<NullableOfShrinkTypeOperationFilterInput>;
  postingStatus?: InputMaybe<JobPostingStatusOperationFilterInput>;
  /**
   * CC-WSAPI-B4 — where the job actually ended up (defaults to the job's location when the count
   * flow captures none). Nullable/additive; null until the job is counted.
   */
  producedLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * CC-WSAPI-B4 — actual produced quantity counted at the line, written back from a completed
   * CountSession. Nullable (additive, backward-compatible per Atlas bde8323d); null until the job
   * is counted. Distinct from Quantity (the planned/target quantity). Pre-feature
   * documents missing the field deserialize to null.
   */
  producedQuantity?: InputMaybe<DecimalOperationFilterInput>;
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The production item the job's lot grows. Set on the lot's finish job only; null on every other
   * job and on a finish job whose lot has none.
   */
  productionItemId?: InputMaybe<StringOperationFilterInput>;
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  productionPlanId?: InputMaybe<StringOperationFilterInput>;
  productionRecipeId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The propagation yield (0.0–1.0) carried by the last Production.V1.JobPropagationYieldSet event,
   * or None if it was never set. Option<decimal> keeps the unset state distinct from an explicit
   * 0.0 so the inline-edit UI can tell "never set" from a deliberate zero. Option<T> per the
   * active null-safety standard (5a153a33); OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  propagationYield?: InputMaybe<OptionOfDecimalFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  /**
   * Shrink/loss events recorded against this job during production. Defaults to
   * empty array; pre-existing documents missing this field deserialize naturally.
   */
  shrinkEvents?: InputMaybe<ListFilterInputTypeOfProductionJobShrinkEventDocumentFilterInput>;
  spaceDimensionsSource?: InputMaybe<NullableOfDimensionSourceOperationFilterInput>;
  spaceEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionJobEventAttachmentDocumentFilterInput>;
  /** When the floor marked this job started (This week › Mark started), or null. */
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Who marked it started (user email), or null. */
  startedBy?: InputMaybe<StringOperationFilterInput>;
  taskEventAttachments?: InputMaybe<ListFilterInputTypeOfProductionJobEventAttachmentDocumentFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Aggregated labor units from all task assignments on this job. */
  totalLoggedLaborUnits?: InputMaybe<IntOperationFilterInput>;
  /** Aggregated time (in seconds) from all task assignments on this job. */
  totalLoggedSeconds?: InputMaybe<LongOperationFilterInput>;
  /** Count of non-cancelled task assignments on this job. */
  totalTaskCount?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  weekReadyDate?: InputMaybe<DateTimeOperationFilterInput>;
  weekReadyIsoWeek?: InputMaybe<IntOperationFilterInput>;
  weekReadyIsoYear?: InputMaybe<IntOperationFilterInput>;
  weekStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  weekStartIsoWeek?: InputMaybe<IntOperationFilterInput>;
  weekStartIsoYear?: InputMaybe<IntOperationFilterInput>;
  yield?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The raw yield override value carried by the last Production.V1.JobYieldOverridden event, or
   * None if yield was never overridden. Equals Yield once set (the yield override is a destructive
   * replace of the effective Yield); surfaced separately so the inline-edit UI can distinguish an
   * explicit override from a recipe-derived effective yield, and detect the not-overridden state.
   * Option<T> per the active null-safety standard (5a153a33), matching the file's newest
   * additive member ShrinkEvent.Notes; OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  yieldOverride?: InputMaybe<OptionOfDecimalFilterInput>;
};

export type ProductionJobDocumentSortInput = {
  /** Count of completed task assignments on this job. */
  completedTaskCount?: InputMaybe<SortEnumType>;
  /**
   * CC-WSAPI-B4 — when the produced quantity was recorded (the source CountSession's CompletedAt).
   * Nullable/additive; null until the job is counted.
   */
  countedAt?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  /** When the floor marked this job done (This week › Mark done), or null. */
  doneAt?: InputMaybe<SortEnumType>;
  /** Who marked it done (user email), or null. */
  doneBy?: InputMaybe<SortEnumType>;
  /**
   * The exact (unrounded) planned quantity behind the whole-container quantity, e.g. 4.58 p288 trays
   * planned as 5. For a quantity set by hand it is that quantity. Null for jobs planned before it was
   * stored.
   */
  exactQuantity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * True once a Production.V1.LotQuantityOverridden event has set this job's effective Quantity
   * away from the recipe-cascade value. There is no quantity-clear event, so this latches true.
   * Defaults false; pre-feature documents missing the field deserialize to false (no migration),
   * matching the JobExecutionStatus / ShrinkEvents additive precedent in this file.
   */
  isQuantityOverridden?: InputMaybe<SortEnumType>;
  /**
   * True once a Production.V1.JobYieldOverridden event has fired for this job. There is no
   * yield-clear event, so this latches true. Defaults false.
   */
  isYieldOverridden?: InputMaybe<SortEnumType>;
  jobExecutionStatus?: InputMaybe<SortEnumType>;
  jobNumber?: InputMaybe<SortEnumType>;
  /**
   * The client-minted posting attempt key carried on the job's latest keyed posting, or null when the job
   * has never been posted with an attempt key. A posting without a key leaves any earlier key unchanged.
   */
  lastPostingAttemptKey?: InputMaybe<SortEnumType>;
  lastReconciledRecipeVersion?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  lotClosedStatus?: InputMaybe<SortEnumType>;
  lotStatus?: InputMaybe<SortEnumType>;
  /**
   * The site the job was moved to when that site's recipe had no variation for the job's ready week,
   * so the job kept the recipe values of the site it left (Production.V1.JobNoRecipeAtSiteFlagged).
   * Null when the job is not flagged. A move or reapply that applies the variation for the job's
   * current site clears it (Production.V1.JobNoRecipeAtSiteCleared).
   */
  noRecipeAtSiteLocationId?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  /**
   * The catalog this job was on before its first catalog substitution. Null when the job was never
   * substituted, or was substituted back to that catalog. Written absolutely from
   * Production.V1.ProductionLotJobsOriginalCatalogRecorded; the schedule's Original Catalog column names it.
   */
  originalProductionCatalogId?: InputMaybe<SortEnumType>;
  /**
   * The ORIGINAL (imported, planned) ready/start week pair — "Original Ready Week" and
   * "Original Start Week" on the schedule grid. Captured once, from the week values the
   * ProductionLotCreated event carries for this job, and never rewritten afterwards: the
   * week-override events, grow-week overrides, recipe reapply and every cascade move the
   * mutable WeekReady*\/WeekStart* pair above (the "actual") and leave these alone. That
   * contrast is the whole feature — a grower compares the two to see which batches hit the
   * target ready date (CMG request row 42).
   *
   * Plain value members rather than Option<T>: the document's identity already implies a
   * creation event, so there is no meaningful "never had an original" state to model once the
   * backfill has run. Pre-backfill documents deserialize the missing fields to default(DateTime)
   * / 0, which is why the backfill (a checkpoint reset that replays ProductionLot-* from zero)
   * is part of this change rather than optional — see the projection service.
   */
  originalWeekReadyDate?: InputMaybe<SortEnumType>;
  originalWeekReadyIsoWeek?: InputMaybe<SortEnumType>;
  originalWeekReadyIsoYear?: InputMaybe<SortEnumType>;
  originalWeekStartDate?: InputMaybe<SortEnumType>;
  originalWeekStartIsoWeek?: InputMaybe<SortEnumType>;
  originalWeekStartIsoYear?: InputMaybe<SortEnumType>;
  parentProductionJobId?: InputMaybe<SortEnumType>;
  /**
   * Manual planned-hours override for this job (labor domain), or None when never set / cleared.
   * Some(hours) means a planner has pinned an explicit labor-hours figure that wins over the
   * recipe-derived per-task-event hours in LaborDemand — the escape hatch for migrated flat recipes
   * whose task events carry no UnitsPerHour. Provenance is exposed via the computed
   * plannedHoursSource field (Manual when Some, Recipe when None). Option<T> per the
   * active null-safety standard (5a153a33), matching YieldOverride / PropagationYield in this file;
   * OptionTypeInterceptor emits a nullable Decimal at the schema. Additive — pre-feature documents
   * missing the field deserialize to None.
   */
  plannedHoursOverride?: InputMaybe<SortEnumType>;
  postedShrinkReason?: InputMaybe<SortEnumType>;
  postingStatus?: InputMaybe<SortEnumType>;
  /**
   * CC-WSAPI-B4 — where the job actually ended up (defaults to the job's location when the count
   * flow captures none). Nullable/additive; null until the job is counted.
   */
  producedLocationId?: InputMaybe<SortEnumType>;
  /**
   * CC-WSAPI-B4 — actual produced quantity counted at the line, written back from a completed
   * CountSession. Nullable (additive, backward-compatible per Atlas bde8323d); null until the job
   * is counted. Distinct from Quantity (the planned/target quantity). Pre-feature
   * documents missing the field deserialize to null.
   */
  producedQuantity?: InputMaybe<SortEnumType>;
  productionCatalogId?: InputMaybe<SortEnumType>;
  productionCategoryId?: InputMaybe<SortEnumType>;
  /**
   * The production item the job's lot grows. Set on the lot's finish job only; null on every other
   * job and on a finish job whose lot has none.
   */
  productionItemId?: InputMaybe<SortEnumType>;
  productionJobId?: InputMaybe<SortEnumType>;
  productionLotId?: InputMaybe<SortEnumType>;
  productionPlanId?: InputMaybe<SortEnumType>;
  productionRecipeId?: InputMaybe<SortEnumType>;
  /**
   * The propagation yield (0.0–1.0) carried by the last Production.V1.JobPropagationYieldSet event,
   * or None if it was never set. Option<decimal> keeps the unset state distinct from an explicit
   * 0.0 so the inline-edit UI can tell "never set" from a deliberate zero. Option<T> per the
   * active null-safety standard (5a153a33); OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  propagationYield?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  spaceDimensionsSource?: InputMaybe<SortEnumType>;
  /** When the floor marked this job started (This week › Mark started), or null. */
  startedAt?: InputMaybe<SortEnumType>;
  /** Who marked it started (user email), or null. */
  startedBy?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Aggregated labor units from all task assignments on this job. */
  totalLoggedLaborUnits?: InputMaybe<SortEnumType>;
  /** Aggregated time (in seconds) from all task assignments on this job. */
  totalLoggedSeconds?: InputMaybe<SortEnumType>;
  /** Count of non-cancelled task assignments on this job. */
  totalTaskCount?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  weekReadyDate?: InputMaybe<SortEnumType>;
  weekReadyIsoWeek?: InputMaybe<SortEnumType>;
  weekReadyIsoYear?: InputMaybe<SortEnumType>;
  weekStartDate?: InputMaybe<SortEnumType>;
  weekStartIsoWeek?: InputMaybe<SortEnumType>;
  weekStartIsoYear?: InputMaybe<SortEnumType>;
  yield?: InputMaybe<SortEnumType>;
  /**
   * The raw yield override value carried by the last Production.V1.JobYieldOverridden event, or
   * None if yield was never overridden. Equals Yield once set (the yield override is a destructive
   * replace of the effective Yield); surfaced separately so the inline-edit UI can distinguish an
   * explicit override from a recipe-derived effective yield, and detect the not-overridden state.
   * Option<T> per the active null-safety standard (5a153a33), matching the file's newest
   * additive member ShrinkEvent.Notes; OptionTypeInterceptor emits a nullable Decimal at the schema.
   */
  yieldOverride?: InputMaybe<SortEnumType>;
};

/** One event attached to a production job, with the source marker the schedule renders a badge from. */
export type ProductionJobEventAttachmentDocument = {
  __typename?: 'ProductionJobEventAttachmentDocument';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  source: ProductionEventAttachmentSource;
};

/** One event attached to a production job, with the source marker the schedule renders a badge from. */
export type ProductionJobEventAttachmentDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionJobEventAttachmentDocumentFilterInput>>;
  defaultAssignedTo?: InputMaybe<StringOperationFilterInput>;
  eventId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionJobEventAttachmentDocumentFilterInput>>;
};

/**
 * A job-level removal of an inherited material or space event: the reapply preview reads these to
 * show growers which inherited events this job is deliberately keeping out.
 */
export type ProductionJobEventExclusionDocument = {
  __typename?: 'ProductionJobEventExclusionDocument';
  eventId: Scalars['String']['output'];
  eventKind: ProductionJobEventKind;
  excludedAt: Scalars['DateTime']['output'];
  excludedBy: Scalars['String']['output'];
};

/**
 * A job-level removal of an inherited material or space event: the reapply preview reads these to
 * show growers which inherited events this job is deliberately keeping out.
 */
export type ProductionJobEventExclusionDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionJobEventExclusionDocumentFilterInput>>;
  eventId?: InputMaybe<StringOperationFilterInput>;
  eventKind?: InputMaybe<ProductionJobEventKindOperationFilterInput>;
  excludedAt?: InputMaybe<DateTimeOperationFilterInput>;
  excludedBy?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionJobEventExclusionDocumentFilterInput>>;
};

export enum ProductionJobEventKind {
  Material = 'MATERIAL',
  Space = 'SPACE',
  Task = 'TASK'
}

export type ProductionJobEventKindOperationFilterInput = {
  eq?: InputMaybe<ProductionJobEventKind>;
  in?: InputMaybe<Array<ProductionJobEventKind>>;
  neq?: InputMaybe<ProductionJobEventKind>;
  nin?: InputMaybe<Array<ProductionJobEventKind>>;
};

/** What moving one production job to another location would change. */
export type ProductionJobMovePreview = {
  __typename?: 'ProductionJobMovePreview';
  /** The job's grow weeks as it stands: whole weeks from start to ready, rounded. */
  currentGrowWeeks: Scalars['Int']['output'];
  /** The job's start week as it stands. */
  currentWeekStartDate: Scalars['DateTime']['output'];
  /** The variation the move applies. Null unless the outcome is DESTINATION_RECIPE. */
  destinationVariationId?: Maybe<Scalars['String']['output']>;
  /** The applied variation's name, as reapplyRecipesPreview names variations. Null unless the outcome is DESTINATION_RECIPE. */
  destinationVariationName?: Maybe<Scalars['String']['output']>;
  /** The job's current location, or null when it has none. */
  fromLocationId?: Maybe<Scalars['String']['output']>;
  /** The job's current site, or null when the job has no location. */
  fromSiteLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * The recipe fields (for example GrowWeeks) whose planner override the job keeps through the move. A GrowWeeks
   * or PlantsPerPot override for the destination variation takes effect: the move brings the job to its value.
   * Any other override, such as Links, is left as it stands, and the move leaves that field alone.
   */
  keptOverrides: Array<Scalars['String']['output']>;
  /**
   * The grow weeks the move writes: when the grow weeks change applies, the job's grow weeks override for the
   * destination variation when it carries one, else the variation's; else the current grow weeks.
   */
  newGrowWeeks: Scalars['Int']['output'];
  /**
   * The start week the move writes: when the grow weeks change applies, the ready week less the new grow weeks
   * (the job's grow weeks override for the destination variation when it carries one, else the variation's),
   * else the current start week.
   */
  newWeekStartDate: Scalars['DateTime']['output'];
  /** True when the job's lot is planted: Change Location plans a dated move for it instead of moving it. */
  planted: Scalars['Boolean']['output'];
  /** The job this preview is for. */
  productionJobId: Scalars['String']['output'];
  /** The lot the job belongs to. */
  productionLotId: Scalars['String']['output'];
  /**
   * The reapplyRecipesPreview result computed at the destination site, its changed variations limited to the
   * destination variation, with the job's GrowWeeks and PlantsPerPot overrides standing in for the destination
   * variation's values. Null unless the outcome is DESTINATION_RECIPE.
   */
  reapply?: Maybe<ReapplyRecipesPreviewResult>;
  /** Whether the move keeps the job's recipe values, applies the destination site's variation, or finds no variation there. */
  recipeOutcome: ProductionJobMoveRecipeOutcome;
  /** The names of the space events the move attaches to the job. */
  spaceEventsAdded: Array<Scalars['String']['output']>;
  /** The names of the space events the move detaches from the job. */
  spaceEventsRemoved: Array<Scalars['String']['output']>;
  /** The location the job moves to. */
  toLocationId: Scalars['String']['output'];
  /** The destination's site. A sub-location maps to its site; a site maps to itself. */
  toSiteLocationId: Scalars['String']['output'];
  /** The job's ready week. A move never changes it. */
  weekReadyDate: Scalars['DateTime']['output'];
};

/** The production jobs to preview a move for, and the location they move to. */
export type ProductionJobMovePreviewInput = {
  /**
   * The jobs to move, at most 200 per call. A blank or malformed id fails the call; a well-formed id that
   * matches no job is left out of the result.
   */
  productionJobIds: Array<Scalars['String']['input']>;
  /** The location the jobs move to: a sub-location or a site. */
  toLocationId: Scalars['String']['input'];
};

/** What moving production jobs to another location would change, before the move is saved. */
export type ProductionJobMovePreviewPayload = {
  __typename?: 'ProductionJobMovePreviewPayload';
  /**
   * One error when there are no job ids, more than 200, a blank or malformed job id, a malformed destination id,
   * an unknown destination, a destination combined into another sub-location, or no job found.
   */
  errors?: Maybe<Array<ValidationError>>;
  /** One preview per requested job that exists, in request order. Null when errors are returned. */
  jobs?: Maybe<Array<ProductionJobMovePreview>>;
};

/** What a move does to a production job's recipe values. */
export enum ProductionJobMoveRecipeOutcome {
  /** The destination site's recipe variation is applied to the job. */
  DestinationRecipe = 'DESTINATION_RECIPE',
  /**
   * No variation of the job's recipe covers its ready week at the destination, or the recipe is deleted.
   * The job keeps its values and saving the move flags it.
   */
  NoRecipeAtDestination = 'NO_RECIPE_AT_DESTINATION',
  /**
   * Only the location changes: the destination is in the job's current site, or the job is not active
   * (its lot is not active, or it is posted or started), so no recipe is applied.
   */
  SameSite = 'SAME_SITE'
}

/**
 * Read-model row for one line of a job's last posting (Post Jobs batch close-out, task 30a36865): a
 * quantity produced at a grade × produced location. Grade 1–5 is a sellable live-goods grade
 * that fed FULFILL inventory; Grade == DumpShrinkGrade is
 * a dump/shrink line (no inventory). Set absolutely by the projection from Production.V1.JobProductionPosted.
 */
export type ProductionJobPostedLineDocument = {
  __typename?: 'ProductionJobPostedLineDocument';
  /**
   * The production category's eaches per container at the moment this line fed FULFILL inventory, so the
   * postProductionJobs mutation reverses the line at the factor it was posted at rather than at whatever
   * the category says now. None on a line written before the conversion landed (which fed the raw
   * container count, i.e. a factor of 1) and on a dump/shrink line, which never feeds inventory.
   * Pre-feature documents deserialize to the None default, so no migration is needed.
   */
  eachesPerContainer?: Maybe<Scalars['Int']['output']>;
  grade: Scalars['Int']['output'];
  producedLocationId: Scalars['String']['output'];
  /** The posted CONTAINER count, the number PRODUCE stores and shows. */
  quantity: Scalars['Int']['output'];
  /**
   * The sales item this line actually fed, so a production item relinked between two posts reverses the
   * ORIGINAL Live Goods row rather than the new one. None on a pre-conversion or dump/shrink line;
   * the mutation then falls back to the currently-resolved sales item.
   */
  salesItemId?: Maybe<Scalars['String']['output']>;
};

/**
 * Read-model row for one line of a job's last posting (Post Jobs batch close-out, task 30a36865): a
 * quantity produced at a grade × produced location. Grade 1–5 is a sellable live-goods grade
 * that fed FULFILL inventory; Grade == DumpShrinkGrade is
 * a dump/shrink line (no inventory). Set absolutely by the projection from Production.V1.JobProductionPosted.
 */
export type ProductionJobPostedLineDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionJobPostedLineDocumentFilterInput>>;
  /**
   * The production category's eaches per container at the moment this line fed FULFILL inventory, so the
   * postProductionJobs mutation reverses the line at the factor it was posted at rather than at whatever
   * the category says now. None on a line written before the conversion landed (which fed the raw
   * container count, i.e. a factor of 1) and on a dump/shrink line, which never feeds inventory.
   * Pre-feature documents deserialize to the None default, so no migration is needed.
   */
  eachesPerContainer?: InputMaybe<OptionOfInt32FilterInput>;
  grade?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionJobPostedLineDocumentFilterInput>>;
  producedLocationId?: InputMaybe<StringOperationFilterInput>;
  /** The posted CONTAINER count, the number PRODUCE stores and shows. */
  quantity?: InputMaybe<IntOperationFilterInput>;
  /**
   * The sales item this line actually fed, so a production item relinked between two posts reverses the
   * ORIGINAL Live Goods row rather than the new one. None on a pre-conversion or dump/shrink line;
   * the mutation then falls back to the currently-resolved sales item.
   */
  salesItemId?: InputMaybe<OptionOfStringFilterInput>;
};

/**
 * A job's posting stages as committed, for the Post Jobs page to resume from after a lost response: the
 * inventory post as the job's posting status and posted lines, the reservation peg against the target the
 * job's latest post or adjustment recorded, whether the job's hardgoods were consumed, and the last
 * posting attempt key committed on the job.
 */
export type ProductionJobPostingStages = {
  __typename?: 'ProductionJobPostingStages';
  hardgoodsConsumed: Scalars['Boolean']['output'];
  lastPostingAttemptKey?: Maybe<Scalars['String']['output']>;
  postedProductionLines: Array<PostedProductionLine>;
  postingStatus: JobPostingStatus;
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  reservationPeg: ProductionPostingStageStatus;
  reservationPeggedQuantity?: Maybe<Scalars['Int']['output']>;
};

/** One job to read the posting stages of, named by its lot and job. */
export type ProductionJobPostingStagesJobInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

/**
 * One job's started and done marks as stored after the call, or the job's errors when it could not be
 * updated (not found, or not on the named lot).
 */
export type ProductionJobProgressResult = {
  __typename?: 'ProductionJobProgressResult';
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  doneBy?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
};

/** One production job, named by its lot and job. */
export type ProductionJobRefInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type ProductionJobShrinkEventDocument = {
  __typename?: 'ProductionJobShrinkEventDocument';
  date: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  shrinkEventId: Scalars['String']['output'];
  shrinkType: ShrinkType;
};

export type ProductionJobShrinkEventDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionJobShrinkEventDocumentFilterInput>>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  notes?: InputMaybe<OptionOfStringFilterInput>;
  or?: InputMaybe<Array<ProductionJobShrinkEventDocumentFilterInput>>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  recordedAt?: InputMaybe<DateTimeOperationFilterInput>;
  recordedBy?: InputMaybe<StringOperationFilterInput>;
  shrinkEventId?: InputMaybe<StringOperationFilterInput>;
  shrinkType?: InputMaybe<ShrinkTypeOperationFilterInput>;
};

/**
 * One recorded shrink event's loss expressed in eaches, carried beside the id of the event it belongs
 * to so a history row can bind the server's number for its own event rather than multiplying the
 * event's container quantity itself. Read this list alongside shrinkEvents and match on
 * shrinkEventId.
 */
export type ProductionJobShrinkEventEachesData = {
  __typename?: 'ProductionJobShrinkEventEachesData';
  eaches: Scalars['Decimal']['output'];
  shrinkEventId: Scalars['String']['output'];
};

export type ProductionJobSpaceDimensionsData = {
  __typename?: 'ProductionJobSpaceDimensionsData';
  length: Scalars['Decimal']['output'];
  stagger: Scalars['Boolean']['output'];
  width: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type ProductionJobsConnection = {
  __typename?: 'ProductionJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionJobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionJobsEdge = {
  __typename?: 'ProductionJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionJobDocument;
};

/**
 * Results in request order. Top-level errors reject the whole batch before any job is read (no jobs, more
 * than 500, a job named twice, a job outside the caller's sites, a bad at).
 */
export type ProductionJobsProgressPayload = {
  __typename?: 'ProductionJobsProgressPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<ProductionJobProgressResult>;
};

/**
 * MongoDB read-model document for a production line, projected from the
 * ProductionLine event stream into the CountProductionLines collection.
 * activeCountSessionId is null when no count session is currently
 * running on this line.
 */
export type ProductionLineDocument = {
  __typename?: 'ProductionLineDocument';
  activeCountSessionId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  deviceIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** The line's placement in the tenant's location tree; null when unassigned. */
  locationId?: Maybe<Scalars['String']['output']>;
  status: ProductionLineStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * MongoDB read-model document for a production line, projected from the
 * ProductionLine event stream into the CountProductionLines collection.
 * activeCountSessionId is null when no count session is currently
 * running on this line.
 */
export type ProductionLineDocumentFilterInput = {
  activeCountSessionId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ProductionLineDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceIds?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** The line's placement in the tenant's location tree; null when unassigned. */
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLineDocumentFilterInput>>;
  status?: InputMaybe<ProductionLineStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for a production line, projected from the
 * ProductionLine event stream into the CountProductionLines collection.
 * activeCountSessionId is null when no count session is currently
 * running on this line.
 */
export type ProductionLineDocumentSortInput = {
  activeCountSessionId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** The line's placement in the tenant's location tree; null when unassigned. */
  locationId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type ProductionLinePayload = {
  __typename?: 'ProductionLinePayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLine?: Maybe<ProductionLineStateData>;
};

export type ProductionLineStateData = {
  __typename?: 'ProductionLineStateData';
  activeCountSessionId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  deviceIds: Array<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  productionLineId: Scalars['String']['output'];
  status: ProductionLineStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionLineStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ProductionLineStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionLineStatus>;
  in?: InputMaybe<Array<ProductionLineStatus>>;
  neq?: InputMaybe<ProductionLineStatus>;
  nin?: InputMaybe<Array<ProductionLineStatus>>;
};

/**
 * The phase a single advanceProductionLotAsyncImportJob call ran. None means the call
 * was a no-op (the job was not in a driveable state, or a claim race was lost).
 */
export enum ProductionLotAdvancePhase {
  Import = 'IMPORT',
  None = 'NONE',
  Validate = 'VALIDATE'
}

/** How an order line is tied to a production lot. */
export enum ProductionLotAllocationKind {
  /** An order line allocated to Live Goods stock that was posted from the lot's jobs. */
  PostedStock = 'POSTED_STOCK',
  /** An order line bound to the lot itself (make-to-order reservation). */
  Reservation = 'RESERVATION'
}

/**
 * MongoDB read model rolling up the total active allocated quantity against a single spec
 * production lot — one document per (TenantId, ProductionLotId), keyed by the composite
 * _id = {TenantId}-{ProductionLotId}. Maintained by
 * OrderProductionLotAllocationProjectionService from the absolute per-allocation
 * quantities carried on the OPLA events: every allocation's current reservation is held in
 * the contributions map (allocationId → absolute qty) and the total allocated qty
 * is recomputed as their sum on every update — only via aggregation-pipeline $set
 * ($mergeObjects + $sum over $objectToArray), never a relative operator and
 * never a read against prior state — so the document is a pure function of the SET of active
 * allocations and is identical on replay (Atlas accaf08f). Backs the server-side
 * over-allocation ceiling on the allocate and adjust mutations.
 */
export type ProductionLotAllocationRollupDocument = {
  __typename?: 'ProductionLotAllocationRollupDocument';
  /** Authoritative lot total quantity, snapshotted from the lot document on each allocate event. */
  lotQty: Scalars['Int']['output'];
  /** Net quantity still available to allocate against the lot — derived on read, never stored. */
  netAvailableQty: Scalars['Int']['output'];
  productionLotId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /** Sum of every allocation's reserved quantity for this lot — recomputed absolutely on each update. */
  totalAllocatedQty: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB read model rolling up the total active allocated quantity against a single spec
 * production lot — one document per (TenantId, ProductionLotId), keyed by the composite
 * _id = {TenantId}-{ProductionLotId}. Maintained by
 * OrderProductionLotAllocationProjectionService from the absolute per-allocation
 * quantities carried on the OPLA events: every allocation's current reservation is held in
 * the contributions map (allocationId → absolute qty) and the total allocated qty
 * is recomputed as their sum on every update — only via aggregation-pipeline $set
 * ($mergeObjects + $sum over $objectToArray), never a relative operator and
 * never a read against prior state — so the document is a pure function of the SET of active
 * allocations and is identical on replay (Atlas accaf08f). Backs the server-side
 * over-allocation ceiling on the allocate and adjust mutations.
 */
export type ProductionLotAllocationRollupDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionLotAllocationRollupDocumentFilterInput>>;
  /** Authoritative lot total quantity, snapshotted from the lot document on each allocate event. */
  lotQty?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLotAllocationRollupDocumentFilterInput>>;
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Sum of every allocation's reserved quantity for this lot — recomputed absolutely on each update. */
  totalAllocatedQty?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read model rolling up the total active allocated quantity against a single spec
 * production lot — one document per (TenantId, ProductionLotId), keyed by the composite
 * _id = {TenantId}-{ProductionLotId}. Maintained by
 * OrderProductionLotAllocationProjectionService from the absolute per-allocation
 * quantities carried on the OPLA events: every allocation's current reservation is held in
 * the contributions map (allocationId → absolute qty) and the total allocated qty
 * is recomputed as their sum on every update — only via aggregation-pipeline $set
 * ($mergeObjects + $sum over $objectToArray), never a relative operator and
 * never a read against prior state — so the document is a pure function of the SET of active
 * allocations and is identical on replay (Atlas accaf08f). Backs the server-side
 * over-allocation ceiling on the allocate and adjust mutations.
 */
export type ProductionLotAllocationRollupDocumentSortInput = {
  /** Authoritative lot total quantity, snapshotted from the lot document on each allocate event. */
  lotQty?: InputMaybe<SortEnumType>;
  productionLotId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Sum of every allocation's reserved quantity for this lot — recomputed absolutely on each update. */
  totalAllocatedQty?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionLotAllocationRollupsConnection = {
  __typename?: 'ProductionLotAllocationRollupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionLotAllocationRollupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionLotAllocationRollupDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionLotAllocationRollupsEdge = {
  __typename?: 'ProductionLotAllocationRollupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionLotAllocationRollupDocument;
};

export type ProductionLotAsyncImportJobRow = {
  __typename?: 'ProductionLotAsyncImportJobRow';
  category: Scalars['String']['output'];
  color: Scalars['String']['output'];
  createdEntityId?: Maybe<Scalars['String']['output']>;
  customer: Scalars['String']['output'];
  /** The customer group the row names, or empty when the row names none. */
  customerGroup: Scalars['String']['output'];
  /**
   * The customer group the row's customer group name resolved to. Null when the row names none or has
   * not been validated yet.
   */
  customerGroupId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  genus: Scalars['String']['output'];
  isAd: Scalars['Boolean']['output'];
  /** The Is Ad cell exactly as typed, when the client sent it; null otherwise. */
  isAdText?: Maybe<Scalars['String']['output']>;
  /** True when the row's plan names no plan yet, so the import creates it. A warning, not an error. Read it on rows that passed validation. */
  isNewPlan: Scalars['Boolean']['output'];
  /** The pre-finished value the row asked for. None when the row left it out; an existing lot's value is then kept. */
  isPreFinished?: Maybe<Scalars['Boolean']['output']>;
  /** The Is Pre-Finished cell exactly as typed, when the client sent it; null otherwise. */
  isPreFinishedText?: Maybe<Scalars['String']['output']>;
  isTrial: Scalars['Boolean']['output'];
  /** The Is Trial cell exactly as typed, when the client sent it; null otherwise. */
  isTrialText?: Maybe<Scalars['String']['output']>;
  /** The production item number the row names, or empty when the row names none. */
  itemNumber: Scalars['String']['output'];
  location: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  /** What the import plans (after Validating) or did (after Importing) with the row's keyed lot. Null for a row without a Lot Key. */
  lotAction?: Maybe<ProductionLotImportAction>;
  /** The row's Lot Key as typed, or empty when the row names none. */
  lotKey: Scalars['String']['output'];
  /** The existing lot a keyed row matched (UPDATE or UNCHANGED). Null for a lot this import created; its id is createdEntityId. */
  matchedProductionLotId?: Maybe<Scalars['String']['output']>;
  plan: Scalars['String']['output'];
  poNumber: Scalars['String']['output'];
  productionCatalogId?: Maybe<Scalars['String']['output']>;
  productionCategoryId?: Maybe<Scalars['String']['output']>;
  /**
   * The production item the row's item number resolved to. Null when the row names none or has not
   * been validated yet.
   */
  productionItemId?: Maybe<Scalars['String']['output']>;
  productionPlanId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  /** The Quantity cell exactly as typed, when the client sent it; null otherwise. */
  quantityText?: Maybe<Scalars['String']['output']>;
  /**
   * The values validation read as the grower meant them rather than as typed (a customer group in Customer, a
   * week number in Week Ready), each with what was typed and what it was read as. Empty when every value was
   * read as typed.
   */
  readAsMeant: Array<ProductionLotAsyncImportReadAsMeant>;
  /**
   * Every reason the row could not be validated, each with a code and the values needed to pre-fill its fix.
   * Empty for a validated row and a row not yet validated. error is their messages joined.
   */
  reasons: Array<ProductionLotAsyncImportRowReason>;
  /**
   * The yyyy-MM-dd Monday validation read Week Ready as, and the date the lot is created on. Null before
   * validation, and when Week Ready could not be read.
   */
  resolvedWeekReady?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  series: Scalars['String']['output'];
  status: AsyncImportRowStatus;
  sublocation: Scalars['String']['output'];
  sublocationId?: Maybe<Scalars['String']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
  weekReady: Scalars['String']['output'];
};

export type ProductionLotAsyncImportJobRowFilterInput = {
  and?: InputMaybe<Array<ProductionLotAsyncImportJobRowFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  color?: InputMaybe<StringOperationFilterInput>;
  createdEntityId?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<StringOperationFilterInput>;
  /** The customer group the row names, or empty when the row names none. */
  customerGroup?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer group the row's customer group name resolved to. Null when the row names none or has
   * not been validated yet.
   */
  customerGroupId?: InputMaybe<OptionOfStringFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  genus?: InputMaybe<StringOperationFilterInput>;
  isAd?: InputMaybe<BooleanOperationFilterInput>;
  /** The Is Ad cell exactly as typed, when the client sent it; null otherwise. */
  isAdText?: InputMaybe<OptionOfStringFilterInput>;
  /** True when the row's plan names no plan yet, so the import creates it. A warning, not an error. Read it on rows that passed validation. */
  isNewPlan?: InputMaybe<BooleanOperationFilterInput>;
  /** The pre-finished value the row asked for. None when the row left it out; an existing lot's value is then kept. */
  isPreFinished?: InputMaybe<OptionOfBooleanFilterInput>;
  /** The Is Pre-Finished cell exactly as typed, when the client sent it; null otherwise. */
  isPreFinishedText?: InputMaybe<OptionOfStringFilterInput>;
  isTrial?: InputMaybe<BooleanOperationFilterInput>;
  /** The Is Trial cell exactly as typed, when the client sent it; null otherwise. */
  isTrialText?: InputMaybe<OptionOfStringFilterInput>;
  /** The production item number the row names, or empty when the row names none. */
  itemNumber?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  /** What the import plans (after Validating) or did (after Importing) with the row's keyed lot. Null for a row without a Lot Key. */
  lotAction?: InputMaybe<NullableOfProductionLotImportActionOperationFilterInput>;
  /** The row's Lot Key as typed, or empty when the row names none. */
  lotKey?: InputMaybe<StringOperationFilterInput>;
  /** The existing lot a keyed row matched (UPDATE or UNCHANGED). Null for a lot this import created; its id is createdEntityId. */
  matchedProductionLotId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLotAsyncImportJobRowFilterInput>>;
  plan?: InputMaybe<StringOperationFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The production item the row's item number resolved to. Null when the row names none or has not
   * been validated yet.
   */
  productionItemId?: InputMaybe<StringOperationFilterInput>;
  productionPlanId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  /** The Quantity cell exactly as typed, when the client sent it; null otherwise. */
  quantityText?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * The values validation read as the grower meant them rather than as typed (a customer group in Customer, a
   * week number in Week Ready), each with what was typed and what it was read as. Empty when every value was
   * read as typed.
   */
  readAsMeant?: InputMaybe<ListFilterInputTypeOfProductionLotAsyncImportReadAsMeantFilterInput>;
  /**
   * Every reason the row could not be validated, each with a code and the values needed to pre-fill its fix.
   * Empty for a validated row and a row not yet validated. error is their messages joined.
   */
  reasons?: InputMaybe<ListFilterInputTypeOfProductionLotAsyncImportRowReasonFilterInput>;
  /**
   * The yyyy-MM-dd Monday validation read Week Ready as, and the date the lot is created on. Null before
   * validation, and when Week Ready could not be read.
   */
  resolvedWeekReady?: InputMaybe<OptionOfStringFilterInput>;
  rowIndex?: InputMaybe<IntOperationFilterInput>;
  series?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<AsyncImportRowStatusOperationFilterInput>;
  sublocation?: InputMaybe<StringOperationFilterInput>;
  sublocationId?: InputMaybe<StringOperationFilterInput>;
  warning?: InputMaybe<StringOperationFilterInput>;
  weekReady?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionLotAsyncImportJobRowSortInput = {
  category?: InputMaybe<SortEnumType>;
  color?: InputMaybe<SortEnumType>;
  createdEntityId?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<SortEnumType>;
  /** The customer group the row names, or empty when the row names none. */
  customerGroup?: InputMaybe<SortEnumType>;
  /**
   * The customer group the row's customer group name resolved to. Null when the row names none or has
   * not been validated yet.
   */
  customerGroupId?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  genus?: InputMaybe<SortEnumType>;
  isAd?: InputMaybe<SortEnumType>;
  /** The Is Ad cell exactly as typed, when the client sent it; null otherwise. */
  isAdText?: InputMaybe<SortEnumType>;
  /** True when the row's plan names no plan yet, so the import creates it. A warning, not an error. Read it on rows that passed validation. */
  isNewPlan?: InputMaybe<SortEnumType>;
  /** The pre-finished value the row asked for. None when the row left it out; an existing lot's value is then kept. */
  isPreFinished?: InputMaybe<SortEnumType>;
  /** The Is Pre-Finished cell exactly as typed, when the client sent it; null otherwise. */
  isPreFinishedText?: InputMaybe<SortEnumType>;
  isTrial?: InputMaybe<SortEnumType>;
  /** The Is Trial cell exactly as typed, when the client sent it; null otherwise. */
  isTrialText?: InputMaybe<SortEnumType>;
  /** The production item number the row names, or empty when the row names none. */
  itemNumber?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  /** What the import plans (after Validating) or did (after Importing) with the row's keyed lot. Null for a row without a Lot Key. */
  lotAction?: InputMaybe<SortEnumType>;
  /** The row's Lot Key as typed, or empty when the row names none. */
  lotKey?: InputMaybe<SortEnumType>;
  /** The existing lot a keyed row matched (UPDATE or UNCHANGED). Null for a lot this import created; its id is createdEntityId. */
  matchedProductionLotId?: InputMaybe<SortEnumType>;
  plan?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  productionCatalogId?: InputMaybe<SortEnumType>;
  productionCategoryId?: InputMaybe<SortEnumType>;
  /**
   * The production item the row's item number resolved to. Null when the row names none or has not
   * been validated yet.
   */
  productionItemId?: InputMaybe<SortEnumType>;
  productionPlanId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  /** The Quantity cell exactly as typed, when the client sent it; null otherwise. */
  quantityText?: InputMaybe<SortEnumType>;
  /**
   * The yyyy-MM-dd Monday validation read Week Ready as, and the date the lot is created on. Null before
   * validation, and when Week Ready could not be read.
   */
  resolvedWeekReady?: InputMaybe<SortEnumType>;
  rowIndex?: InputMaybe<SortEnumType>;
  series?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  sublocation?: InputMaybe<SortEnumType>;
  sublocationId?: InputMaybe<SortEnumType>;
  warning?: InputMaybe<SortEnumType>;
  weekReady?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionLotAsyncImportJobRowsConnection = {
  __typename?: 'ProductionLotAsyncImportJobRowsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionLotAsyncImportJobRowsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionLotAsyncImportJobRow>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionLotAsyncImportJobRowsEdge = {
  __typename?: 'ProductionLotAsyncImportJobRowsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionLotAsyncImportJobRow;
};

/**
 * A schedule import row value read the way the grower meant it rather than literally: a customer group typed in
 * the Customer column, or a week number typed in Week Ready.
 */
export type ProductionLotAsyncImportReadAsMeant = {
  __typename?: 'ProductionLotAsyncImportReadAsMeant';
  /** Which reading was applied. */
  kind: ProductionLotImportReadAsMeantKind;
  /** The cell as typed. */
  original: Scalars['String']['output'];
  /** What it was read as: the customer group's name, or the yyyy-MM-dd Monday. */
  resolved: Scalars['String']['output'];
};

/**
 * A schedule import row value read the way the grower meant it rather than literally: a customer group typed in
 * the Customer column, or a week number typed in Week Ready.
 */
export type ProductionLotAsyncImportReadAsMeantFilterInput = {
  and?: InputMaybe<Array<ProductionLotAsyncImportReadAsMeantFilterInput>>;
  /** Which reading was applied. */
  kind?: InputMaybe<ProductionLotImportReadAsMeantKindOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLotAsyncImportReadAsMeantFilterInput>>;
  /** The cell as typed. */
  original?: InputMaybe<StringOperationFilterInput>;
  /** What it was read as: the customer group's name, or the yyyy-MM-dd Monday. */
  resolved?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One reason a schedule import row could not be validated, with the values needed to pre-fill its fix. A row
 * carries one per problem; its error is their messages joined.
 */
export type ProductionLotAsyncImportRowReason = {
  __typename?: 'ProductionLotAsyncImportRowReason';
  /** The row's Category, for CATALOG_NOT_FOUND, RECIPE_NOT_FOUND and CATEGORY_NOT_FOUND; null otherwise. */
  category?: Maybe<Scalars['String']['output']>;
  /** What is wrong with the row. */
  code: ProductionLotImportRowReasonCode;
  /** The row's Color, for CATALOG_NOT_FOUND, RECIPE_NOT_FOUND and CATEGORY_NOT_FOUND; null otherwise. */
  color?: Maybe<Scalars['String']['output']>;
  /**
   * The column the reason is about (e.g. IsTrial, Quantity), for INVALID_TRUE_FALSE and INVALID_QUANTITY;
   *             null otherwise.
   */
  column?: Maybe<Scalars['String']['output']>;
  /** The row's Genus, for CATALOG_NOT_FOUND, RECIPE_NOT_FOUND and CATEGORY_NOT_FOUND; null otherwise. */
  genus?: Maybe<Scalars['String']['output']>;
  /** The readable sentence for this reason. */
  message: Scalars['String']['output'];
  /** The row's Series, for CATALOG_NOT_FOUND, RECIPE_NOT_FOUND and CATEGORY_NOT_FOUND; null otherwise. */
  series?: Maybe<Scalars['String']['output']>;
  /** The cell the reason is about, as typed. Null when the reason is about several cells. */
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * One reason a schedule import row could not be validated, with the values needed to pre-fill its fix. A row
 * carries one per problem; its error is their messages joined.
 */
export type ProductionLotAsyncImportRowReasonFilterInput = {
  and?: InputMaybe<Array<ProductionLotAsyncImportRowReasonFilterInput>>;
  /** The row's Category, for CATALOG_NOT_FOUND, RECIPE_NOT_FOUND and CATEGORY_NOT_FOUND; null otherwise. */
  category?: InputMaybe<OptionOfStringFilterInput>;
  /** What is wrong with the row. */
  code?: InputMaybe<ProductionLotImportRowReasonCodeOperationFilterInput>;
  /** The row's Color, for CATALOG_NOT_FOUND, RECIPE_NOT_FOUND and CATEGORY_NOT_FOUND; null otherwise. */
  color?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * The column the reason is about (e.g. IsTrial, Quantity), for INVALID_TRUE_FALSE and INVALID_QUANTITY;
   *             null otherwise.
   */
  column?: InputMaybe<OptionOfStringFilterInput>;
  /** The row's Genus, for CATALOG_NOT_FOUND, RECIPE_NOT_FOUND and CATEGORY_NOT_FOUND; null otherwise. */
  genus?: InputMaybe<OptionOfStringFilterInput>;
  /** The readable sentence for this reason. */
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLotAsyncImportRowReasonFilterInput>>;
  /** The row's Series, for CATALOG_NOT_FOUND, RECIPE_NOT_FOUND and CATEGORY_NOT_FOUND; null otherwise. */
  series?: InputMaybe<OptionOfStringFilterInput>;
  /** The cell the reason is about, as typed. Null when the reason is about several cells. */
  value?: InputMaybe<OptionOfStringFilterInput>;
};

export type ProductionLotDocument = {
  __typename?: 'ProductionLotDocument';
  archiveNotes?: Maybe<Scalars['String']['output']>;
  closedStatus: LotClosedStatus;
  consolidatedIntoProductionLotId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * The customer group this lot was explicitly planned for. None when the lot has no group of
   * its own — a customer-only lot's group stays derived from its customer and is never stored here.
   */
  customerGroupId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  /**
   * How many eaches one of this lot's containers holds: the factor netAvailableEaches converts at.
   * That is the factor the lot's finish job was posted at when its posting states one, otherwise the one
   * its production category states. Null when neither resolves, which is a different answer from a
   * category that states 0. For a tooltip explaining an eaches figure; a client never multiplies by it.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * ProductionCatalogId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCatalogId by the projection, and moved to the
   * survivor when a catalog combine re-points the finish job.
   * Null for legacy lots created before this field was added — missing BSON fields
   * deserialize to null without a backfill migration. Used by GetProductionLots
   * to filter candidate spec lots for order-production-lot allocation.
   */
  finishJobProductionCatalogId?: Maybe<Scalars['String']['output']>;
  /**
   * ProductionCategoryId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCategoryId by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobProductionCategoryId?: Maybe<Scalars['String']['output']>;
  /**
   * WeekReadyDate of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.WeekReadyDate by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobWeekReadyDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isAd: Scalars['Boolean']['output'];
  /**
   * True when the lot was planned to arrive already finished, so its finish job is ready in the ship week with
   * 0 grow weeks. Lots created before the field existed read as false.
   */
  isPreFinished: Scalars['Boolean']['output'];
  /**
   * True once the lot has been marked Ready (grow finished, handed off to FULFILL). Defaults to
   * false; missing BSON fields on legacy lots deserialize to false without a backfill migration.
   * Set absolutely by the projection from Production.V1.LotReady (Atlas accaf08f).
   */
  isReady: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  lotNumber: Scalars['Int']['output'];
  /**
   * The eaches of this lot still free to allocate to order lines: its containers times
   * eachesPerUnit, less every allocation and make-to-order reservation already held against it
   * (reservedQty, which is eaches), floored at 0. A new allocation is refused above exactly this
   * figure; an existing allocation can be raised to this figure plus its own current quantity. Reads 0 when
   * eachesPerUnit is null or below 1, so show it only when eachesPerUnit is set and it is
   * above 0.
   */
  netAvailableEaches: Scalars['Int']['output'];
  /**
   * Quantity of this lot still generally available — max(0, Quantity − ReservedQty). A
   * fully-pegged make-to-order lot reports 0 (it is NOT generally available). Populated via the same
   * aggregation pipeline join as reservedQty; never persisted.
   */
  netAvailableQty: Scalars['Int']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  /** The production item this lot grows, on its finish job's plant and pot. Null when the lot has none. */
  productionItemId?: Maybe<Scalars['String']['output']>;
  productionLotId: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  productionPlanName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  /**
   * Quantity of this lot reserved/allocated to order lines — the sum of every active
   * OrderProductionLotAllocation against this lot (a born-Reserved make-to-order peg counts in
   * full). Populated via the aggregation pipeline in GetProductionLots by left-joining the
   * per-lot ProductionLotAllocationRollups read model (TotalAllocatedQty); 0 when the lot
   * has no allocations or no rollup yet. Like productionPlanName/customerName
   * it is projection-time-only output — the lot projection writes field-scoped updates and never
   * persists it to the ProductionLots collection.
   */
  reservedQty: Scalars['Int']['output'];
  status: ProductionLotStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionLotDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionLotDocumentFilterInput>>;
  archiveNotes?: InputMaybe<StringOperationFilterInput>;
  closedStatus?: InputMaybe<LotClosedStatusOperationFilterInput>;
  consolidatedIntoProductionLotId?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * The customer group this lot was explicitly planned for. None when the lot has no group of
   * its own — a customer-only lot's group stays derived from its customer and is never stored here.
   */
  customerGroupId?: InputMaybe<OptionOfStringFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  /**
   * ProductionCatalogId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCatalogId by the projection, and moved to the
   * survivor when a catalog combine re-points the finish job.
   * Null for legacy lots created before this field was added — missing BSON fields
   * deserialize to null without a backfill migration. Used by GetProductionLots
   * to filter candidate spec lots for order-production-lot allocation.
   */
  finishJobProductionCatalogId?: InputMaybe<StringOperationFilterInput>;
  /**
   * ProductionCategoryId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCategoryId by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobProductionCategoryId?: InputMaybe<StringOperationFilterInput>;
  /**
   * WeekReadyDate of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.WeekReadyDate by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobWeekReadyDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isAd?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * True when the lot was planned to arrive already finished, so its finish job is ready in the ship week with
   * 0 grow weeks. Lots created before the field existed read as false.
   */
  isPreFinished?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * True once the lot has been marked Ready (grow finished, handed off to FULFILL). Defaults to
   * false; missing BSON fields on legacy lots deserialize to false without a backfill migration.
   * Set absolutely by the projection from Production.V1.LotReady (Atlas accaf08f).
   */
  isReady?: InputMaybe<BooleanOperationFilterInput>;
  isTrial?: InputMaybe<BooleanOperationFilterInput>;
  lotNumber?: InputMaybe<IntOperationFilterInput>;
  /**
   * Quantity of this lot still generally available — max(0, Quantity − ReservedQty). A
   * fully-pegged make-to-order lot reports 0 (it is NOT generally available). Populated via the same
   * aggregation pipeline join as reservedQty; never persisted.
   */
  netAvailableQty?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLotDocumentFilterInput>>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  /** The production item this lot grows, on its finish job's plant and pot. Null when the lot has none. */
  productionItemId?: InputMaybe<StringOperationFilterInput>;
  productionLotId?: InputMaybe<StringOperationFilterInput>;
  productionPlanId?: InputMaybe<StringOperationFilterInput>;
  productionPlanName?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  /**
   * Quantity of this lot reserved/allocated to order lines — the sum of every active
   * OrderProductionLotAllocation against this lot (a born-Reserved make-to-order peg counts in
   * full). Populated via the aggregation pipeline in GetProductionLots by left-joining the
   * per-lot ProductionLotAllocationRollups read model (TotalAllocatedQty); 0 when the lot
   * has no allocations or no rollup yet. Like productionPlanName/customerName
   * it is projection-time-only output — the lot projection writes field-scoped updates and never
   * persists it to the ProductionLots collection.
   */
  reservedQty?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<ProductionLotStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionLotDocumentSortInput = {
  archiveNotes?: InputMaybe<SortEnumType>;
  closedStatus?: InputMaybe<SortEnumType>;
  consolidatedIntoProductionLotId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * The customer group this lot was explicitly planned for. None when the lot has no group of
   * its own — a customer-only lot's group stays derived from its customer and is never stored here.
   */
  customerGroupId?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  /**
   * ProductionCatalogId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCatalogId by the projection, and moved to the
   * survivor when a catalog combine re-points the finish job.
   * Null for legacy lots created before this field was added — missing BSON fields
   * deserialize to null without a backfill migration. Used by GetProductionLots
   * to filter candidate spec lots for order-production-lot allocation.
   */
  finishJobProductionCatalogId?: InputMaybe<SortEnumType>;
  /**
   * ProductionCategoryId of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.ProductionCategoryId by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobProductionCategoryId?: InputMaybe<SortEnumType>;
  /**
   * WeekReadyDate of the lot's FinishJob, snapshotted from
   * Production.V1.LotCreated.FinishJob.WeekReadyDate by the projection.
   * Null for legacy lots — backward-compatible additive field.
   */
  finishJobWeekReadyDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isAd?: InputMaybe<SortEnumType>;
  /**
   * True when the lot was planned to arrive already finished, so its finish job is ready in the ship week with
   * 0 grow weeks. Lots created before the field existed read as false.
   */
  isPreFinished?: InputMaybe<SortEnumType>;
  /**
   * True once the lot has been marked Ready (grow finished, handed off to FULFILL). Defaults to
   * false; missing BSON fields on legacy lots deserialize to false without a backfill migration.
   * Set absolutely by the projection from Production.V1.LotReady (Atlas accaf08f).
   */
  isReady?: InputMaybe<SortEnumType>;
  isTrial?: InputMaybe<SortEnumType>;
  lotNumber?: InputMaybe<SortEnumType>;
  /**
   * Quantity of this lot still generally available — max(0, Quantity − ReservedQty). A
   * fully-pegged make-to-order lot reports 0 (it is NOT generally available). Populated via the same
   * aggregation pipeline join as reservedQty; never persisted.
   */
  netAvailableQty?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  /** The production item this lot grows, on its finish job's plant and pot. Null when the lot has none. */
  productionItemId?: InputMaybe<SortEnumType>;
  productionLotId?: InputMaybe<SortEnumType>;
  productionPlanId?: InputMaybe<SortEnumType>;
  productionPlanName?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  /**
   * Quantity of this lot reserved/allocated to order lines — the sum of every active
   * OrderProductionLotAllocation against this lot (a born-Reserved make-to-order peg counts in
   * full). Populated via the aggregation pipeline in GetProductionLots by left-joining the
   * per-lot ProductionLotAllocationRollups read model (TotalAllocatedQty); 0 when the lot
   * has no allocations or no rollup yet. Like productionPlanName/customerName
   * it is projection-time-only output — the lot projection writes field-scoped updates and never
   * persists it to the ProductionLots collection.
   */
  reservedQty?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export enum ProductionLotImportAction {
  Create = 'CREATE',
  Unchanged = 'UNCHANGED',
  Unknown = 'UNKNOWN',
  Update = 'UPDATE'
}

/** One schedule import in the imports list. */
export type ProductionLotImportJobSummary = {
  __typename?: 'ProductionLotImportJobSummary';
  /** The import's id. */
  asyncImportJobId: Scalars['String']['output'];
  /** When the import last finished. Null while it is in progress. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the import was started. */
  createdAt: Scalars['DateTime']['output'];
  /** The name of the file the import was uploaded from. Null for imports created before names were saved. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** How many rows have imported. */
  importedRows: Scalars['Int']['output'];
  /** Where the import is. */
  status: AsyncImportJobStatus;
  /** How many rows the import has. */
  totalRows: Scalars['Int']['output'];
  /**
   * How many rows are waiting: they failed validation or failed to import and can be fixed and imported
   *             from the same import.
   */
  waitingRows: Scalars['Int']['output'];
};

/** One schedule import in the imports list. */
export type ProductionLotImportJobSummaryFilterInput = {
  and?: InputMaybe<Array<ProductionLotImportJobSummaryFilterInput>>;
  /** The import's id. */
  asyncImportJobId?: InputMaybe<StringOperationFilterInput>;
  /** When the import last finished. Null while it is in progress. */
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When the import was started. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The name of the file the import was uploaded from. Null for imports created before names were saved. */
  fileName?: InputMaybe<OptionOfStringFilterInput>;
  /** How many rows have imported. */
  importedRows?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionLotImportJobSummaryFilterInput>>;
  /** Where the import is. */
  status?: InputMaybe<AsyncImportJobStatusOperationFilterInput>;
  /** How many rows the import has. */
  totalRows?: InputMaybe<IntOperationFilterInput>;
  /**
   * How many rows are waiting: they failed validation or failed to import and can be fixed and imported
   *             from the same import.
   */
  waitingRows?: InputMaybe<IntOperationFilterInput>;
};

/** One schedule import in the imports list. */
export type ProductionLotImportJobSummarySortInput = {
  /** The import's id. */
  asyncImportJobId?: InputMaybe<SortEnumType>;
  /** When the import last finished. Null while it is in progress. */
  completedAt?: InputMaybe<SortEnumType>;
  /** When the import was started. */
  createdAt?: InputMaybe<SortEnumType>;
  /** The name of the file the import was uploaded from. Null for imports created before names were saved. */
  fileName?: InputMaybe<SortEnumType>;
  /** How many rows have imported. */
  importedRows?: InputMaybe<SortEnumType>;
  /** Where the import is. */
  status?: InputMaybe<SortEnumType>;
  /** How many rows the import has. */
  totalRows?: InputMaybe<SortEnumType>;
  /**
   * How many rows are waiting: they failed validation or failed to import and can be fixed and imported
   *             from the same import.
   */
  waitingRows?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionLotImportJobsConnection = {
  __typename?: 'ProductionLotImportJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionLotImportJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionLotImportJobSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionLotImportJobsEdge = {
  __typename?: 'ProductionLotImportJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionLotImportJobSummary;
};

export enum ProductionLotImportReadAsMeantKind {
  CustomerAsCustomerGroup = 'CUSTOMER_AS_CUSTOMER_GROUP',
  Unknown = 'UNKNOWN',
  WeekNumberAsDate = 'WEEK_NUMBER_AS_DATE'
}

export type ProductionLotImportReadAsMeantKindOperationFilterInput = {
  eq?: InputMaybe<ProductionLotImportReadAsMeantKind>;
  in?: InputMaybe<Array<ProductionLotImportReadAsMeantKind>>;
  neq?: InputMaybe<ProductionLotImportReadAsMeantKind>;
  nin?: InputMaybe<Array<ProductionLotImportReadAsMeantKind>>;
};

/** Resolved entity IDs set by the worker after successful lookups. */
export type ProductionLotImportRowIdsInput = {
  customerGroupId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  isNewPlan?: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  lotAction?: InputMaybe<ProductionLotImportAction>;
  matchedProductionLotId?: InputMaybe<Scalars['String']['input']>;
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionItemId?: InputMaybe<Scalars['String']['input']>;
  productionPlanId: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  sublocationId?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductionLotImportRowReasonCode {
  CatalogNotFound = 'CATALOG_NOT_FOUND',
  CategoryNotFound = 'CATEGORY_NOT_FOUND',
  CustomerGroupConflict = 'CUSTOMER_GROUP_CONFLICT',
  CustomerGroupNotFound = 'CUSTOMER_GROUP_NOT_FOUND',
  CustomerNotFound = 'CUSTOMER_NOT_FOUND',
  CustomerNotInCustomerGroup = 'CUSTOMER_NOT_IN_CUSTOMER_GROUP',
  InvalidLotKey = 'INVALID_LOT_KEY',
  InvalidPoNumber = 'INVALID_PO_NUMBER',
  InvalidQuantity = 'INVALID_QUANTITY',
  InvalidTrueFalse = 'INVALID_TRUE_FALSE',
  InvalidWeekReady = 'INVALID_WEEK_READY',
  ItemNumberInvalid = 'ITEM_NUMBER_INVALID',
  LocationNotFound = 'LOCATION_NOT_FOUND',
  LotKeyConflict = 'LOT_KEY_CONFLICT',
  PlanInvalid = 'PLAN_INVALID',
  RecipeNotFound = 'RECIPE_NOT_FOUND',
  SublocationNotFound = 'SUBLOCATION_NOT_FOUND',
  Unknown = 'UNKNOWN',
  WeekReadyNotMonday = 'WEEK_READY_NOT_MONDAY',
  WeekReadyYearUnclear = 'WEEK_READY_YEAR_UNCLEAR'
}

export type ProductionLotImportRowReasonCodeOperationFilterInput = {
  eq?: InputMaybe<ProductionLotImportRowReasonCode>;
  in?: InputMaybe<Array<ProductionLotImportRowReasonCode>>;
  neq?: InputMaybe<ProductionLotImportRowReasonCode>;
  nin?: InputMaybe<Array<ProductionLotImportRowReasonCode>>;
};

/**
 * User-provided field values during upload or correction.
 * Does not include resolved IDs - those are set separately by the worker.
 * Converted to ProductionLotImportRowData via named init-only assignment so
 * adjacent string columns cannot be silently swapped at the boundary.
 */
export type ProductionLotImportRowValuesInput = {
  /** The Category cell. */
  category: Scalars['String']['input'];
  /** The Color cell. */
  color: Scalars['String']['input'];
  /** The Customer cell. */
  customer: Scalars['String']['input'];
  /** The Customer Group cell, optional; names the customer group the lot is planned for. */
  customerGroup?: Scalars['String']['input'];
  /** The Genus cell. */
  genus: Scalars['String']['input'];
  /** The Is Ad cell. */
  isAd: Scalars['Boolean']['input'];
  /** The Is Ad cell as typed, optional; read instead of IsAd when sent. */
  isAdText?: InputMaybe<Scalars['String']['input']>;
  /** The Is Pre-Finished cell, optional; null when the row leaves it out. */
  isPreFinished?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Is Pre-Finished cell as typed, optional; read instead of IsPreFinished. */
  isPreFinishedText?: InputMaybe<Scalars['String']['input']>;
  /** The Is Trial cell. */
  isTrial: Scalars['Boolean']['input'];
  /** The Is Trial cell as typed, optional; read instead of IsTrial when sent. */
  isTrialText?: InputMaybe<Scalars['String']['input']>;
  /** The Item Number cell, optional; names the production item the lot grows. */
  itemNumber?: Scalars['String']['input'];
  /** The Location cell, naming the site. */
  location: Scalars['String']['input'];
  /** The Lot Key cell, optional; the grower's own id for the lot. */
  lotKey?: Scalars['String']['input'];
  /** The Plan cell. */
  plan: Scalars['String']['input'];
  /** The PO Number cell. */
  poNumber: Scalars['String']['input'];
  /** The Quantity cell. */
  quantity: Scalars['Int']['input'];
  /** The Quantity cell as typed, optional; read instead of Quantity when sent. */
  quantityText?: InputMaybe<Scalars['String']['input']>;
  /** The row's position in the uploaded file. */
  rowIndex: Scalars['Int']['input'];
  /** The Series cell. */
  series: Scalars['String']['input'];
  /** The Sublocation cell, optional; resolved within the row's Location site when sent. */
  sublocation?: Scalars['String']['input'];
  /** The Week Ready cell. */
  weekReady: Scalars['String']['input'];
};

/** One open allocation against a production lot. */
export type ProductionLotOpenAllocation = {
  __typename?: 'ProductionLotOpenAllocation';
  customerName: Scalars['String']['output'];
  expectedDeliveryDate: Scalars['DateTime']['output'];
  itemName: Scalars['String']['output'];
  kind: ProductionLotAllocationKind;
  lineItemId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  orderStatus: OrderStatus;
  productionLotId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

/** Result of productionLotOpenAllocations. */
export type ProductionLotOpenAllocationsPayload = {
  __typename?: 'ProductionLotOpenAllocationsPayload';
  allocations?: Maybe<Array<ProductionLotOpenAllocation>>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * The field an override-history entry describes a change to. A closed set: every member is produced
 * by exactly one arm of the override-event allow-list, so the PWA's Overrides panel can label and
 * group rows off a stable contract instead of parsing the free-text summary or the raw event name.
 * Adding an override event to the allow-list adds a member here.
 */
export enum ProductionLotOverrideField {
  /** The lot's customer. */
  Customer = 'CUSTOMER',
  /** The lot's own customer group. */
  CustomerGroup = 'CUSTOMER_GROUP',
  /** The job's grow-weeks override against a recipe variation. */
  GrowWeeks = 'GROW_WEEKS',
  /** The job's links override against a recipe variation. */
  Links = 'LINKS',
  /** The job's location. */
  Location = 'LOCATION',
  /** A material event added to or removed from this one job by a grower. */
  MaterialEvent = 'MATERIAL_EVENT',
  /** The job's manual planned-hours override. */
  PlannedHours = 'PLANNED_HOURS',
  /** The job's plants-per-pot override against a recipe variation. */
  PlantsPerPot = 'PLANTS_PER_POT',
  /** The job's manually corrected produced location. */
  ProducedLocation = 'PRODUCED_LOCATION',
  /** The job's manually corrected produced quantity. */
  ProducedQuantity = 'PRODUCED_QUANTITY',
  /**
   * A quantity. Job-scoped (overrideProductionJobQuantity) when productionJobId is
   * set, lot-scoped (overrideProductionLotQuantity / splitProductionLot) when it is not.
   */
  Quantity = 'QUANTITY',
  /** The recipe version a job was reconciled to by an apply-recipe-changes run. */
  RecipeVersion = 'RECIPE_VERSION',
  /** A space event added to or removed from this one job by a grower. */
  SpaceEvent = 'SPACE_EVENT',
  /** A task event removed from this one job by a grower, or its removal undone. */
  TaskEvent = 'TASK_EVENT',
  /** The lot's catalog, changed by a catalog substitution. */
  Variant = 'VARIANT',
  /** The planner's explicit recipe-override choice for a catalog substitution. */
  VariantOverridePolicy = 'VARIANT_OVERRIDE_POLICY',
  /** The job's week-ready date. */
  WeekReadyDate = 'WEEK_READY_DATE',
  /** The job's week-start date. */
  WeekStartDate = 'WEEK_START_DATE',
  /** The job's yield (overrideProductionJobYield). */
  Yield = 'YIELD'
}

/**
 * One field-level override entry in a production lot's audit history, derived on demand from the
 * lot's KurrentDB event stream. Each record is one changed field on one event: what changed, what it
 * changed from, what it changed to, who did it and when.
 *
 * (id, field, productionJobId) is the unique key — a single event that moves more
 * than one field (a produced-quantity correction moving both quantity and location) yields one record
 * per changed field, and a substitution of one plant inside a combo yields one record per chain of that
 * plant, each on the chain's own job, all sharing the event's id.
 */
export type ProductionLotOverrideHistoryRecord = {
  __typename?: 'ProductionLotOverrideHistoryRecord';
  /** The domain event type name (e.g. Production.V1.JobGrowWeeksOverrideSet). */
  eventType: Scalars['String']['output'];
  /** Which field changed. */
  field: ProductionLotOverrideField;
  /** The event-store identifier of the event this entry was derived from. */
  id: Scalars['String']['output'];
  /** The human-readable name for newValue, on the same terms as previousDisplay. */
  newDisplay?: Maybe<Scalars['String']['output']>;
  /**
   * The value after the change, rendered invariantly; absent when the change removed the value
   * (an override cleared back to the recipe default).
   */
  newValue?: Maybe<Scalars['String']['output']>;
  /** When the change was recorded. */
  occurredAt: Scalars['DateTime']['output'];
  /**
   * The user (email or id) that made the change, or Fernie (for <email>) when the Fernie
   * agent made it on that user's behalf.
   */
  occurredBy: Scalars['String']['output'];
  /**
   * The human-readable name for previousValue when that value is an identifier the server can
   * resolve — a location, a space or material event, a customer. Absent when the field carries no
   * identifier (grow weeks, quantity, dates), when there was no previous value, or when the
   * identifier no longer resolves because the record it named was renamed away or deleted. A client
   * renders this when present and falls back to previousValue when it is not.
   */
  previousDisplay?: Maybe<Scalars['String']['output']>;
  /**
   * The value before the change, rendered invariantly; absent when there was no previous value
   * (an override set for the first time) or the event does not carry one.
   */
  previousValue?: Maybe<Scalars['String']['output']>;
  /**
   * The job the change applies to; absent for a lot-scoped change (customer, lot quantity).
   * Cascaded jobs — descendants a caller never named, rescheduled by batchOverrideProductionJobWeeks
   * — carry their own id here, so a cascade is attributed to the job that actually moved.
   */
  productionJobId?: Maybe<Scalars['String']['output']>;
  /**
   * A human-readable one-liner, e.g. "Grow weeks changed from 5 to 8". Where a display name
   * resolved it is the name that appears here, not the identifier.
   */
  summary: Scalars['String']['output'];
};

export type ProductionLotPayload = {
  __typename?: 'ProductionLotPayload';
  /**
   * The orders whose allocations executeProductionJob released because its consumption took stock orders held:
   * free stock goes first, then the newest orders' allocations. Only the orders the caller can see under the
   * orders visibility rule are named; otherAffectedOrderCount counts the rest. Empty when
   * nothing was released, and on every other mutation.
   */
  affectedOrders: Array<InventoryOrderImpactData>;
  errors?: Maybe<Array<ValidationError>>;
  /** How many other released orders there are, which the caller cannot see. */
  otherAffectedOrderCount: Scalars['Int']['output'];
  productionLot?: Maybe<ProductionLotStateData>;
};

export type ProductionLotStateData = {
  __typename?: 'ProductionLotStateData';
  closedStatus: LotClosedStatus;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerGroupId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  finishJob: ProductionJobData;
  isAd: Scalars['Boolean']['output'];
  isPreFinished: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  lotNumber: Scalars['Int']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  productionItemId?: Maybe<Scalars['String']['output']>;
  productionLotId: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  status: ProductionLotStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionLotStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionLotStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionLotStatus>;
  in?: InputMaybe<Array<ProductionLotStatus>>;
  neq?: InputMaybe<ProductionLotStatus>;
  nin?: InputMaybe<Array<ProductionLotStatus>>;
};

/** A live reservation that blocks the substitution until it is released. */
export type ProductionLotSubstitutionAllocation = {
  __typename?: 'ProductionLotSubstitutionAllocation';
  /** The reservation to cancel to release it. */
  allocationId: Scalars['String']['output'];
  /** The order the lot is reserved for. */
  orderId: Scalars['String']['output'];
  /** The order line the lot is reserved for. */
  orderLineId?: Maybe<Scalars['String']['output']>;
};

/** One job the substitution changes, before and after. */
export type ProductionLotSubstitutionJob = {
  __typename?: 'ProductionLotSubstitutionJob';
  /** The new catalog's recipe for the job's pot; absent when the new catalog has none. */
  newProductionRecipeId?: Maybe<Scalars['String']['output']>;
  /** The recipe the job uses now. */
  previousProductionRecipeId: Scalars['String']['output'];
  /** The job's pot. */
  productionCategoryId: Scalars['String']['output'];
  /** The job as it is now. */
  productionJobId: Scalars['String']['output'];
  /** The job's quantity to produce after the substitution. */
  quantityToProduceAfter?: Maybe<Scalars['Int']['output']>;
  /** The job's ready week after the substitution: the finish job's never changes; a child's follows its parent's new start week. */
  weekReadyDate: Scalars['DateTime']['output'];
  /** The job's start week after the substitution. */
  weekStartDateAfter?: Maybe<Scalars['DateTime']['output']>;
  /** The job's start week now. */
  weekStartDateBefore: Scalars['DateTime']['output'];
};

/** One lot's substitution: what changes, what blocks it, and whether it was substituted. */
export type ProductionLotSubstitutionLot = {
  __typename?: 'ProductionLotSubstitutionLot';
  /** Live reservations whose sales item would change; Release cancels them. */
  blockingAllocations: Array<ProductionLotSubstitutionAllocation>;
  /** Every reason this lot cannot be substituted now (preview lists all; mutation: why it was refused). Empty when it can be / was. */
  errors: Array<ValidationError>;
  /** True when the changed jobs carry planner overrides, so the override policy changes the result. */
  hasPlannerOverrides: Scalars['Boolean']['output'];
  /** True when the new catalog's selected variation is scoped to the lot's own site (Bell's site variant). */
  isLotSiteVariation: Scalars['Boolean']['output'];
  /** The jobs that change; after values are absent when the dry run could not run for this lot. */
  jobs: Array<ProductionLotSubstitutionJob>;
  /** Pots that need a recipe on the new catalog first, start (link-target) pots before the pots that link to them. */
  missingRecipes: Array<ProductionLotSubstitutionMissingRecipe>;
  /** The production item the lot carries after the substitution: the new catalog's single Active item for the finish pot, else none. */
  productionItemIdAfter?: Maybe<Scalars['String']['output']>;
  /** The production item the lot carries now. */
  productionItemIdBefore?: Maybe<Scalars['String']['output']>;
  /** The lot this result is for. */
  productionLotId: Scalars['String']['output'];
  /** Which of the lot's jobs the substitution changes. */
  scope: ProductionLotSubstitutionScope;
  /** True only in the mutation's result, for a lot that was substituted in this call. */
  substituted: Scalars['Boolean']['output'];
};

/** A pot the new catalog has no recipe for, and the recipe to copy for it. */
export type ProductionLotSubstitutionMissingRecipe = {
  __typename?: 'ProductionLotSubstitutionMissingRecipe';
  /** The pot that needs a recipe on the new catalog. */
  productionCategoryId: Scalars['String']['output'];
  /** The pot's name as the recipes list shows it. */
  productionCategoryName: Scalars['String']['output'];
  /** The original catalog's recipe for this pot — Duplicate Recipe's source. */
  sourceProductionRecipeId: Scalars['String']['output'];
};

/** A catalog substitution's outcome, or its preview, lot by lot. */
export type ProductionLotSubstitutionPayload = {
  __typename?: 'ProductionLotSubstitutionPayload';
  /** Request-level errors (empty list, bad ids, unknown/inactive/combined new catalog, original = new). */
  errors?: Maybe<Array<ValidationError>>;
  /** One result per distinct requested lot, in request order. */
  lots: Array<ProductionLotSubstitutionLot>;
};

/** The lots to preview a catalog substitution for, the catalog they replace and the catalog they would take. */
export type ProductionLotSubstitutionPreviewInput = {
  /** Absent previews a catalog Substitute will create first: every changed pot needs a copied recipe and a whole-lot production item clears. */
  newProductionCatalogId?: InputMaybe<Scalars['String']['input']>;
  /** The catalog being replaced in each lot. */
  originalProductionCatalogId: Scalars['String']['input'];
  /** Absent: per-lot facts are returned but after values only for lots without planner overrides. */
  overridePolicy?: InputMaybe<ProductionLotVariantOverridePolicy>;
  /** The lots to preview, each answered once in the order first named. */
  productionLotIds: Array<Scalars['String']['input']>;
};

/** Which jobs of a lot a substitution changes. */
export enum ProductionLotSubstitutionScope {
  /** The catalog being replaced is a plant inside a combo, so only that plant's jobs change. */
  ComboPlant = 'COMBO_PLANT',
  /** The catalog being replaced is not in the lot, or the lot could not be read. */
  Unknown = 'UNKNOWN',
  /** The finish job is on the catalog being replaced, so every job of the lot takes the new catalog's recipes. */
  WholeLot = 'WHOLE_LOT'
}

/** One entry of a lot's life-cycle timeline. */
export type ProductionLotTimelineEntry = {
  __typename?: 'ProductionLotTimelineEntry';
  /** When it happened. */
  at: Scalars['DateTime']['output'];
  /** Who did it. Null only when the record behind the entry does not name a person. */
  by?: Maybe<Scalars['String']['output']>;
  /** Plain-words detail: the grade of a posted line, the notes of a shrink, where a move went. */
  detail?: Maybe<Scalars['String']['output']>;
  /** What happened. */
  kind: ProductionLotTimelineKind;
  /** The location involved: where it was posted, started, shrunk or moved to. */
  locationId?: Maybe<Scalars['String']['output']>;
  /** The name of that location. */
  locationName?: Maybe<Scalars['String']['output']>;
  /** The order the entry is for, when it names one. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** That order's number. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** The production job the entry belongs to, when it belongs to one. */
  productionJobId?: Maybe<Scalars['String']['output']>;
  /** The quantity involved, when the entry has one. */
  quantity?: Maybe<Scalars['Decimal']['output']>;
  /** The shrink reason, or the adjustment reason, as a word. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** What happened to the lot at one point on its timeline. */
export enum ProductionLotTimelineKind {
  /** A posted quantity was adjusted after the fact. */
  Adjusted = 'ADJUSTED',
  /** The lot was created. */
  Created = 'CREATED',
  /** A job of the lot was marked done. */
  Done = 'DONE',
  /** Stock of the lot was moved to another location. */
  Moved = 'MOVED',
  /** An explanation about the timeline itself, such as pooled stock that cannot be tied to the lot. */
  Note = 'NOTE',
  /** Production was posted: a sellable line, or a dump line posted with the job. */
  Posted = 'POSTED',
  /** A phone shrink event was recorded. */
  Shrink = 'SHRINK',
  /** Stock of the lot was shipped, or the lot was allocated to an order. */
  Sold = 'SOLD',
  /** A job of the lot was started. */
  Started = 'STARTED'
}

/** A plant variant and the dry-run result of applying its recipe to this lot. */
export type ProductionLotVariantOption = {
  __typename?: 'ProductionLotVariantOption';
  /** Whether this lot may switch to this variant. The current variant always returns false. */
  canSwap: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  genus: Scalars['String']['output'];
  /** The finish job's grow weeks after the same dry run the mutation applies. */
  growWeeks?: Maybe<Scalars['Int']['output']>;
  /** True when the selected variation is scoped to the lot's own site. */
  isLotSiteVariation: Scalars['Boolean']['output'];
  productionCatalogId: Scalars['String']['output'];
  /** The production item the lot would carry after the swap. */
  productionItemId?: Maybe<Scalars['String']['output']>;
  /** The plant's recipe for the lot's pot; absent when no recipe exists. */
  productionRecipeId?: Maybe<Scalars['String']['output']>;
  /** The variation selected for the lot's scope and ready week; absent when none matches. */
  productionRecipeVariationId?: Maybe<Scalars['String']['output']>;
  /** The finish job's quantity to produce after yield derivation. */
  quantityToProduce?: Maybe<Scalars['Int']['output']>;
  /** A plain-English reason the swap is refused. */
  reason?: Maybe<Scalars['String']['output']>;
  series: Scalars['String']['output'];
  /** The space events the finish job would carry after the swap. */
  spaceEventNames: Array<Scalars['String']['output']>;
  /** The selected variation's site, when it is site-scoped. */
  variationSiteLocationId?: Maybe<Scalars['String']['output']>;
  /** The finish job's unchanged ready week. */
  weekReadyDate?: Maybe<Scalars['DateTime']['output']>;
  /** The finish job's start week after the swap. */
  weekStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** The finish job's yield after applying the explicitly chosen override policy. */
  yield?: Maybe<Scalars['Decimal']['output']>;
};

/** The current finish job and every other Active, non-combined plant with the lot's genus and series, sorted by color. */
export type ProductionLotVariantOptionsPayload = {
  __typename?: 'ProductionLotVariantOptionsPayload';
  /** The lot's finish job as it is now, with canSwap false. */
  current?: Maybe<ProductionLotVariantOption>;
  /** Errors preventing the options query from completing. */
  errors?: Maybe<Array<ValidationError>>;
  /** Every other Active, non-combined plant of the tenant with the same genus and series, sorted by color. */
  options: Array<ProductionLotVariantOption>;
  /** The explicit policy used for these previews; absent when the planner has not chosen. */
  overridePolicy?: Maybe<ProductionLotVariantOverridePolicy>;
  /** The lot whose variant options are described. */
  productionLotId: Scalars['String']['output'];
};

export enum ProductionLotVariantOverridePolicy {
  KeepCurrentOverrides = 'KEEP_CURRENT_OVERRIDES',
  UseVariantDefaults = 'USE_VARIANT_DEFAULTS'
}

/** A connection to a list of items. */
export type ProductionLotsConnection = {
  __typename?: 'ProductionLotsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionLotsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionLotDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionLotsEdge = {
  __typename?: 'ProductionLotsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionLotDocument;
};

export type ProductionMappingLineDataInput = {
  endIsoWeek?: InputMaybe<Scalars['Int']['input']>;
  endIsoYear?: InputMaybe<Scalars['Int']['input']>;
  mixPct?: InputMaybe<Scalars['Decimal']['input']>;
  productionItemId: Scalars['String']['input'];
  regions: Array<Scalars['String']['input']>;
  startIsoWeek?: InputMaybe<Scalars['Int']['input']>;
  startIsoYear?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductionMaterialEventDetailData = {
  __typename?: 'ProductionMaterialEventDetailData';
  description: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  multiple: Scalars['Decimal']['output'];
  productionMaterialEventDetailId: Scalars['String']['output'];
  status: ProductionMaterialEventStatus;
  triggerId: Scalars['String']['output'];
};

/**
 * A production material event detail row with triggerName and materialItemDescription
 * resolved fresh on every request, alongside materialName and materialErpCode, so a
 * trigger rename or a material rename/description change is always current on the next request.
 */
export type ProductionMaterialEventDetailDocument = {
  __typename?: 'ProductionMaterialEventDetailDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * The referenced material's current ERP code (MaterialItemDocument.ErpId), live-joined
   *             by tenant + materialItemId. Empty when the material item no longer resolves.
   */
  materialErpCode: Scalars['String']['output'];
  /**
   * The joined material item's current description; empty when the detail's material item no
   *             longer resolves.
   */
  materialItemDescription: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  /**
   * The referenced material's current canonical name (MaterialItemDocument.Name),
   *             live-joined by tenant + materialItemId. Empty when the material item no longer
   *             resolves.
   */
  materialName: Scalars['String']['output'];
  /**
   * The material units consumed per container of a production job, not per plant. A job's required
   * quantity of the material is its container count times this value.
   */
  multiple: Scalars['Decimal']['output'];
  productionMaterialEventDetailId: Scalars['String']['output'];
  productionMaterialEventId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  triggerId: Scalars['String']['output'];
  /** The joined trigger's current name; empty when the detail's trigger no longer resolves. */
  triggerName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * A production material event detail row with triggerName and materialItemDescription
 * resolved fresh on every request, alongside materialName and materialErpCode, so a
 * trigger rename or a material rename/description change is always current on the next request.
 */
export type ProductionMaterialEventDetailDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionMaterialEventDetailDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The referenced material's current ERP code (MaterialItemDocument.ErpId), live-joined
   *             by tenant + materialItemId. Empty when the material item no longer resolves.
   */
  materialErpCode?: InputMaybe<StringOperationFilterInput>;
  /**
   * The joined material item's current description; empty when the detail's material item no
   *             longer resolves.
   */
  materialItemDescription?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The referenced material's current canonical name (MaterialItemDocument.Name),
   *             live-joined by tenant + materialItemId. Empty when the material item no longer
   *             resolves.
   */
  materialName?: InputMaybe<StringOperationFilterInput>;
  /**
   * The material units consumed per container of a production job, not per plant. A job's required
   * quantity of the material is its container count times this value.
   */
  multiple?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProductionMaterialEventDetailDocumentFilterInput>>;
  productionMaterialEventDetailId?: InputMaybe<StringOperationFilterInput>;
  productionMaterialEventId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  triggerId?: InputMaybe<StringOperationFilterInput>;
  /** The joined trigger's current name; empty when the detail's trigger no longer resolves. */
  triggerName?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A production material event detail row with triggerName and materialItemDescription
 * resolved fresh on every request, alongside materialName and materialErpCode, so a
 * trigger rename or a material rename/description change is always current on the next request.
 */
export type ProductionMaterialEventDetailDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The referenced material's current ERP code (MaterialItemDocument.ErpId), live-joined
   *             by tenant + materialItemId. Empty when the material item no longer resolves.
   */
  materialErpCode?: InputMaybe<SortEnumType>;
  /**
   * The joined material item's current description; empty when the detail's material item no
   *             longer resolves.
   */
  materialItemDescription?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  /**
   * The referenced material's current canonical name (MaterialItemDocument.Name),
   *             live-joined by tenant + materialItemId. Empty when the material item no longer
   *             resolves.
   */
  materialName?: InputMaybe<SortEnumType>;
  /**
   * The material units consumed per container of a production job, not per plant. A job's required
   * quantity of the material is its container count times this value.
   */
  multiple?: InputMaybe<SortEnumType>;
  productionMaterialEventDetailId?: InputMaybe<SortEnumType>;
  productionMaterialEventId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  triggerId?: InputMaybe<SortEnumType>;
  /** The joined trigger's current name; empty when the detail's trigger no longer resolves. */
  triggerName?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionMaterialEventDetailsConnection = {
  __typename?: 'ProductionMaterialEventDetailsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionMaterialEventDetailsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionMaterialEventDetailDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionMaterialEventDetailsEdge = {
  __typename?: 'ProductionMaterialEventDetailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionMaterialEventDetailDocument;
};

export type ProductionMaterialEventDocument = {
  __typename?: 'ProductionMaterialEventDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionMaterialEventId: Scalars['String']['output'];
  status: ProductionMaterialEventStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionMaterialEventDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionMaterialEventDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionMaterialEventDocumentFilterInput>>;
  productionMaterialEventId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionMaterialEventStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionMaterialEventDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productionMaterialEventId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionMaterialEventPayload = {
  __typename?: 'ProductionMaterialEventPayload';
  errors?: Maybe<Array<ValidationError>>;
  event?: Maybe<ProductionMaterialEventStateData>;
};

export type ProductionMaterialEventStateData = {
  __typename?: 'ProductionMaterialEventStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  details: Array<ProductionMaterialEventDetailData>;
  name: Scalars['String']['output'];
  productionMaterialEventId: Scalars['String']['output'];
  status: ProductionMaterialEventStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionMaterialEventStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionMaterialEventStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionMaterialEventStatus>;
  in?: InputMaybe<Array<ProductionMaterialEventStatus>>;
  neq?: InputMaybe<ProductionMaterialEventStatus>;
  nin?: InputMaybe<Array<ProductionMaterialEventStatus>>;
};

/** A connection to a list of items. */
export type ProductionMaterialEventsConnection = {
  __typename?: 'ProductionMaterialEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionMaterialEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionMaterialEventDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionMaterialEventsEdge = {
  __typename?: 'ProductionMaterialEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionMaterialEventDocument;
};

export type ProductionPlanDocument = {
  __typename?: 'ProductionPlanDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  status: ProductionPlanStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionPlanDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionPlanDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionPlanDocumentFilterInput>>;
  productionPlanId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionPlanStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionPlanDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productionPlanId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionPlanPayload = {
  __typename?: 'ProductionPlanPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionPlan?: Maybe<ProductionPlanStateData>;
};

export type ProductionPlanStateData = {
  __typename?: 'ProductionPlanStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  status: ProductionPlanStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionPlanStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionPlanStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionPlanStatus>;
  in?: InputMaybe<Array<ProductionPlanStatus>>;
  neq?: InputMaybe<ProductionPlanStatus>;
  nin?: InputMaybe<Array<ProductionPlanStatus>>;
};

/** A connection to a list of items. */
export type ProductionPlansConnection = {
  __typename?: 'ProductionPlansConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionPlansEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionPlanDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionPlansEdge = {
  __typename?: 'ProductionPlansEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionPlanDocument;
};

/**
 * Where one stage of a job's posting stands. A job's posting commits in stages that land separately, so a
 * job's posted status alone never says its reservation peg or its hardgoods landed.
 */
export enum ProductionPostingStageStatus {
  /** The stage committed. */
  Acknowledged = 'ACKNOWLEDGED',
  /** The stage has nothing to do for this job. */
  NotRequired = 'NOT_REQUIRED',
  /** The stage has not been acknowledged as committed. */
  Pending = 'PENDING',
  /** The stage was not determined: it was never reached, or its job could not be read. */
  Unknown = 'UNKNOWN'
}

/**
 * The computed Bill-of-Materials for a production recipe variation. Derived from the
 * variation's referenced material events (excluding any explicitly excluded ones) by
 * flattening their details and joining with the material item catalog. There is no
 * dedicated BOM storage — this result is computed on demand.
 */
export type ProductionRecipeBom = {
  __typename?: 'ProductionRecipeBom';
  /** The number of distinct material items in the BOM. */
  distinctMaterialCount: Scalars['Int']['output'];
  /** The individual BOM entries (one per active material event detail). */
  entries: Array<ProductionRecipeBomEntry>;
  /** The production recipe identifier that owns this variation. */
  productionRecipeId: Scalars['String']['output'];
  /** The production recipe variation identifier the BOM was computed for. */
  productionRecipeVariationId: Scalars['String']['output'];
};

/**
 * A single Bill-of-Materials entry for a production recipe variation. Represents one
 * material item required by the variation via its referenced material events, with the
 * per-unit quantity (Multiple) pulled from the underlying material event detail.
 */
export type ProductionRecipeBomEntry = {
  __typename?: 'ProductionRecipeBomEntry';
  /** The detail description (denormalized from the material event detail). */
  description: Scalars['String']['output'];
  /** The production material event detail identifier that contributes this entry. */
  materialEventDetailId: Scalars['String']['output'];
  /** The production material event identifier that contributes this entry. */
  materialEventId: Scalars['String']['output'];
  /** The production material event name (denormalized for display). */
  materialEventName: Scalars['String']['output'];
  /** The material item category (denormalized for display). */
  materialItemCategory: Scalars['String']['output'];
  /** The material item identifier. */
  materialItemId: Scalars['String']['output'];
  /** The material item name (denormalized for display). */
  materialItemName: Scalars['String']['output'];
  /** The quantity multiple from the material event detail (quantity per produced unit). */
  quantity: Scalars['Decimal']['output'];
};

/**
 * A recipe's whole link chain anchored on one of its variations: the recipes it draws from
 * (upstream, one list per level) and the recipes that draw from it (downstream, one list per level).
 */
export type ProductionRecipeChain = {
  __typename?: 'ProductionRecipeChain';
  /**
   * Feeding recipes by level. Level 0 holds the recipes whose default-scope variation links this recipe's
   * catalog and category pair; each later level holds the recipes that link a recipe on the level before.
   */
  downstream: Array<Array<ProductionRecipeChainNode>>;
  /** The recipe the chain is anchored on. */
  recipe: ProductionRecipeChainNode;
  /**
   * Input links by level. Level 0 is the anchor variation's own links; each later level holds the links of
   * the default-scope variation of every recipe resolved on the level before, each naming that recipe in
   * parentProductionRecipeId. Empty for a start recipe.
   */
  upstream: Array<Array<ProductionRecipeChainLink>>;
  /** The variation the chain is anchored on. */
  variation: ProductionRecipeChainVariation;
};

/** One input link in a chain and the recipe its catalog and category pair resolves to. */
export type ProductionRecipeChainLink = {
  __typename?: 'ProductionRecipeChainLink';
  /** The linked catalog color. */
  catalogColor: Scalars['String']['output'];
  /** The linked catalog genus. */
  catalogGenus: Scalars['String']['output'];
  /** The linked catalog series. */
  catalogSeries: Scalars['String']['output'];
  /** The linked category code. */
  categoryCode: Scalars['String']['output'];
  /** How many of the linked component go into one pot of a combo. */
  componentsPerPot?: Maybe<Scalars['Int']['output']>;
  /** The recipe the pair resolved to; null when MISSING. */
  linkedRecipe?: Maybe<ProductionRecipeChainNode>;
  /**
   * The recipe whose default-scope variation holds this link; null on level 0, where the link is the anchor
   * variation's own.
   */
  parentProductionRecipeId?: Maybe<Scalars['String']['output']>;
  /** The linked catalog id. */
  productionCatalogId: Scalars['String']['output'];
  /** The linked category id. */
  productionCategoryId: Scalars['String']['output'];
  /** How the link's pair resolved to a recipe. */
  resolution: ProductionRecipeChainLinkResolution;
};

/** How a link's catalog and category pair resolved to a recipe. */
export enum ProductionRecipeChainLinkResolution {
  /** Exactly one Active recipe has the pair. */
  Active = 'ACTIVE',
  /** More than one Active recipe has the pair; the newest is returned. */
  Ambiguous = 'AMBIGUOUS',
  /** No Active recipe has the pair, but an Inactive one does. */
  Inactive = 'INACTIVE',
  /** No recipe has the pair. */
  Missing = 'MISSING'
}

/** One recipe in a chain, with the scalars of its default-scope variation. */
export type ProductionRecipeChainNode = {
  __typename?: 'ProductionRecipeChainNode';
  /** The recipe's catalog color. */
  catalogColor: Scalars['String']['output'];
  /** The recipe's catalog genus. */
  catalogGenus: Scalars['String']['output'];
  /** The recipe's catalog series. */
  catalogSeries: Scalars['String']['output'];
  /** The recipe's category code. */
  categoryCode: Scalars['String']['output'];
  /** Grow weeks of the recipe's default-scope variation; null when it has no variations. */
  growWeeks?: Maybe<Scalars['Int']['output']>;
  /** Whether the recipe is a combo. */
  isCombo: Scalars['Boolean']['output'];
  /** Whether the recipe is a start recipe. */
  isStartRecipe: Scalars['Boolean']['output'];
  /** Plants per pot of the recipe's default-scope variation; null when it has no variations. */
  plantsPerPot?: Maybe<Scalars['Int']['output']>;
  /** The recipe's catalog id. */
  productionCatalogId: Scalars['String']['output'];
  /** The recipe's category id. */
  productionCategoryId: Scalars['String']['output'];
  /** The recipe id. */
  productionRecipeId: Scalars['String']['output'];
  /** The recipe's lifecycle status. */
  status: ProductionRecipeStatus;
  /** Yield of the recipe's default-scope variation; null when it has no variations. */
  yield?: Maybe<Scalars['Decimal']['output']>;
};

/** The variation a chain is anchored on. */
export type ProductionRecipeChainVariation = {
  __typename?: 'ProductionRecipeChainVariation';
  /** The variation's grow weeks. */
  growWeeks: Scalars['Int']['output'];
  /** The variation's plants per pot. */
  plantsPerPot: Scalars['Int']['output'];
  /** The variation id. */
  productionRecipeVariationId: Scalars['String']['output'];
  /** The variation's yield. */
  yield: Scalars['Decimal']['output'];
};

/**
 * Denormalized default-variation scalars carried on the recipe summary document so the PWA
 * recipes grid can display growWeeks, plantsPerPot, and yield without an
 * N+1 variation fetch. "Default" follows the approved rule: the rangeless (base) variation when one
 * exists, else the earliest WeekRange.StartWeek (see
 * ProductionRecipeDefaultVariationSelector). Recipes with no variations resolve to None.
 */
export type ProductionRecipeDefaultVariationSummary = {
  __typename?: 'ProductionRecipeDefaultVariationSummary';
  growWeeks: Scalars['Int']['output'];
  plantsPerPot: Scalars['Int']['output'];
  yield: Scalars['Decimal']['output'];
};

/**
 * Per-page field resolvers for ProductionRecipeDocument. The defaultVariation
 * summary used to be enriched by a correlated $lookup inside BaseRecipeAggregate that
 * ran for EVERY recipe in the tenant before HotChocolate's paging $limit could cut the page —
 * on a large tenant (SFG, ~3,968 recipes) that whole-tenant fan-out (run twice thanks to
 * totalCount) blew red's ~5s request budget and hard-cancelled the query. Mirroring the
 * productionJobs fix (task 6ce6af8c / ProductionJobGraphType), the lookup is now a per-page,
 * [DataLoader]-batched resolver: it reads only the ≤page-size recipes HotChocolate actually
 * returns, so enrichment cost is O(pageSize), not O(all tenant recipes). The selection rule lives in
 * ProductionRecipeDefaultVariationSelector (the rangeless base wins; earliest StartWeek only
 * when the recipe has no base).
 */
export type ProductionRecipeDocument = {
  __typename?: 'ProductionRecipeDocument';
  /**
   * Task event IDs representing additional flat-rate costs (packaging, shipping, etc.).
   * Defaults to empty array for existing documents that predate this field (no migration required).
   */
  additionalCostEventIds: Array<Scalars['String']['output']>;
  catalogColor: Scalars['String']['output'];
  catalogGenus: Scalars['String']['output'];
  catalogSeries: Scalars['String']['output'];
  categoryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * The recipe's default-variation scalars (grow weeks / plants-per-pot / yield), or null when the
   * recipe has no variations. Resolved per page from the variations read model via a batched
   * DataLoader; never persisted by the projection, so no replay-purity constraint applies. Returns a
   * nullable reference (not Option<T>) because HotChocolate cannot infer an output schema
   * type from an Option of a complex type — the nullable maps to the same
   * defaultVariation: ProductionRecipeDefaultVariationSummary field the document property
   * previously produced, so the output surface is unchanged.
   */
  defaultVariation?: Maybe<ProductionRecipeDefaultVariationSummary>;
  /**
   * Whole-estimate flat-rate cost override for the recipe. When set, cost resolution quotes this
   * amount as the recipe's cost instead of the computed materials/labor/additional total. Null
   * means the recipe costs from its computed breakdown.
   */
  flatRateCost?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  isCombo: Scalars['Boolean']['output'];
  isStartRecipe: Scalars['Boolean']['output'];
  /**
   * Labor source mode for the recipe. Defaults to DefaultPerUnit for existing documents
   * that predate this field (no migration required — BsonDefaultValue handles missing values).
   */
  laborSource: RecipeLaborSource;
  /**
   * Per-(material event, material item) choice of which assigned vendor's cost prices that
   * material line when the recipe is costed. An absent entry means the material item's default
   * vendor is used, which is what every recipe did before overrides existed.
   *
   * Defaults to an empty array for documents that predate this field (no migration required).
   */
  materialEventVendorOverrides: Array<MaterialEventVendorOverrideDocument>;
  numberOfVariations: Scalars['Int']['output'];
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  status: ProductionRecipeStatus;
  /**
   * What the recipe targets: one catalog item (CATALOG), or every color of a genus and series
   * (SERIES). A SERIES recipe has an empty productionCatalogId, and catalogGenus and catalogSeries
   * name the series it covers.
   */
  targetKind: ProductionRecipeTargetKind;
  /**
   * Recipe-level task event IDs available for the recipe. The effective list of
   * task events for a variation is
   * (recipe.TaskEventIds ∪ variation.TaskEventIds) − variation.ExcludedTaskEventIds,
   * and this resolution is the responsibility of the frontend.
   *
   * The PWA is the source of truth for the effective list: at variation-save time it
   * merges the recipe header and variation lists and persists the merged result into
   * ProductionRecipeVariationDocument.TaskEventIds. All backend readers
   * (cost resolution, labor demand, job/work-order generation, item-program projection)
   * therefore read only the variation-level list — they must NOT re-merge recipe-header
   * IDs, or they would duplicate the frontend's responsibility and create two sources
   * of truth.
   *
   *
   * The recipe-header field is kept so the PWA can round-trip the authored list
   * independently of any specific variation. Introducing a backend merge helper is
   * explicitly out of scope for this audit.
   *
   *
   * Defaults to empty array for existing documents that predate this field
   * (no migration required).
   */
  taskEventIds: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  /**
   * Monotonic recipe version used to detect production jobs that were created
   * from an older recipe definition. Existing documents default to 1.
   */
  version: Scalars['Int']['output'];
};

export type ProductionRecipeDocumentFilterInput = {
  /**
   * Task event IDs representing additional flat-rate costs (packaging, shipping, etc.).
   * Defaults to empty array for existing documents that predate this field (no migration required).
   */
  additionalCostEventIds?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<ProductionRecipeDocumentFilterInput>>;
  catalogColor?: InputMaybe<StringOperationFilterInput>;
  catalogGenus?: InputMaybe<StringOperationFilterInput>;
  catalogSeries?: InputMaybe<StringOperationFilterInput>;
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whole-estimate flat-rate cost override for the recipe. When set, cost resolution quotes this
   * amount as the recipe's cost instead of the computed materials/labor/additional total. Null
   * means the recipe costs from its computed breakdown.
   */
  flatRateCost?: InputMaybe<OptionOfDecimalFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isCombo?: InputMaybe<BooleanOperationFilterInput>;
  isStartRecipe?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Labor source mode for the recipe. Defaults to DefaultPerUnit for existing documents
   * that predate this field (no migration required — BsonDefaultValue handles missing values).
   */
  laborSource?: InputMaybe<RecipeLaborSourceOperationFilterInput>;
  /**
   * Per-(material event, material item) choice of which assigned vendor's cost prices that
   * material line when the recipe is costed. An absent entry means the material item's default
   * vendor is used, which is what every recipe did before overrides existed.
   *
   * Defaults to an empty array for documents that predate this field (no migration required).
   */
  materialEventVendorOverrides?: InputMaybe<ListFilterInputTypeOfMaterialEventVendorOverrideDocumentFilterInput>;
  numberOfVariations?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionRecipeDocumentFilterInput>>;
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionRecipeId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionRecipeStatusOperationFilterInput>;
  /**
   * What the recipe targets: one catalog item (CATALOG), or every color of a genus and series
   * (SERIES). A SERIES recipe has an empty productionCatalogId, and catalogGenus and catalogSeries
   * name the series it covers.
   */
  targetKind?: InputMaybe<ProductionRecipeTargetKindOperationFilterInput>;
  /**
   * Recipe-level task event IDs available for the recipe. The effective list of
   * task events for a variation is
   * (recipe.TaskEventIds ∪ variation.TaskEventIds) − variation.ExcludedTaskEventIds,
   * and this resolution is the responsibility of the frontend.
   *
   * The PWA is the source of truth for the effective list: at variation-save time it
   * merges the recipe header and variation lists and persists the merged result into
   * ProductionRecipeVariationDocument.TaskEventIds. All backend readers
   * (cost resolution, labor demand, job/work-order generation, item-program projection)
   * therefore read only the variation-level list — they must NOT re-merge recipe-header
   * IDs, or they would duplicate the frontend's responsibility and create two sources
   * of truth.
   *
   *
   * The recipe-header field is kept so the PWA can round-trip the authored list
   * independently of any specific variation. Introducing a backend merge helper is
   * explicitly out of scope for this audit.
   *
   *
   * Defaults to empty array for existing documents that predate this field
   * (no migration required).
   */
  taskEventIds?: InputMaybe<ListStringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Monotonic recipe version used to detect production jobs that were created
   * from an older recipe definition. Existing documents default to 1.
   */
  version?: InputMaybe<IntOperationFilterInput>;
};

export type ProductionRecipeDocumentSortInput = {
  catalogColor?: InputMaybe<SortEnumType>;
  catalogGenus?: InputMaybe<SortEnumType>;
  catalogSeries?: InputMaybe<SortEnumType>;
  categoryCode?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * Whole-estimate flat-rate cost override for the recipe. When set, cost resolution quotes this
   * amount as the recipe's cost instead of the computed materials/labor/additional total. Null
   * means the recipe costs from its computed breakdown.
   */
  flatRateCost?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isCombo?: InputMaybe<SortEnumType>;
  isStartRecipe?: InputMaybe<SortEnumType>;
  /**
   * Labor source mode for the recipe. Defaults to DefaultPerUnit for existing documents
   * that predate this field (no migration required — BsonDefaultValue handles missing values).
   */
  laborSource?: InputMaybe<SortEnumType>;
  numberOfVariations?: InputMaybe<SortEnumType>;
  productionCatalogId?: InputMaybe<SortEnumType>;
  productionCategoryId?: InputMaybe<SortEnumType>;
  productionRecipeId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /**
   * What the recipe targets: one catalog item (CATALOG), or every color of a genus and series
   * (SERIES). A SERIES recipe has an empty productionCatalogId, and catalogGenus and catalogSeries
   * name the series it covers.
   */
  targetKind?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  /**
   * Monotonic recipe version used to detect production jobs that were created
   * from an older recipe definition. Existing documents default to 1.
   */
  version?: InputMaybe<SortEnumType>;
};

/**
 * The yield actually in force for a planned quantity, with the base it replaced and the volume tier
 * that replaced it.
 */
export type ProductionRecipeEffectiveYield = {
  __typename?: 'ProductionRecipeEffectiveYield';
  /** The variation's base yield, unchanged by any tier. */
  baseYield: Scalars['Decimal']['output'];
  /** The threshold of the tier in force, or None when the base yield still applies. */
  tierThresholdQuantity?: Maybe<Scalars['Int']['output']>;
  /** The yield in force — a tier's yield when one applies, otherwise the base yield. */
  yield: Scalars['Decimal']['output'];
};

export enum ProductionRecipeEventKind {
  Material = 'MATERIAL',
  Space = 'SPACE',
  Task = 'TASK'
}

/** One row of a recipe variation's effective event list, labeled by source. */
export type ProductionRecipeEventRow = {
  __typename?: 'ProductionRecipeEventRow';
  eventId: Scalars['String']['output'];
  eventType: ProductionRecipeEventKind;
  name: Scalars['String']['output'];
  source: ProductionRecipeEventSource;
  /** The category event this row overrides. Set only when Source is Overridden. */
  sourceEventId?: Maybe<Scalars['String']['output']>;
};

/**
 * Where a recipe variation's event row comes from: straight from the category, standing in for an
 * inherited one the variation cloned and excluded (D2), or authored on the recipe itself.
 */
export enum ProductionRecipeEventSource {
  Inherited = 'INHERITED',
  Overridden = 'OVERRIDDEN',
  Recipe = 'RECIPE'
}

/**
 * One group header for the Recipes sidebar: the group's Key (also used as the
 * where value when lazy-loading the group's children), a display Label, and
 * the server-computed Count of recipes in the group under the active search.
 */
export type ProductionRecipeGroupBucket = {
  __typename?: 'ProductionRecipeGroupBucket';
  /** Number of recipes in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /** Raw group key — category code, or "{genus} {series}" for catalog. */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for productionRecipeGroups. Mirrors the Recipes sidebar's group-by
 * options so the client can render server-computed group headers instead of grouping the full
 * catalog in memory: Category buckets on the joined category code, Catalog buckets
 * on the joined catalog "{genus} {series}" identity.
 */
export enum ProductionRecipeGroupField {
  /** One bucket per distinct catalog identity ("{genus} {series}"). */
  Catalog = 'CATALOG',
  /** One bucket per distinct category code. */
  Category = 'CATEGORY'
}

/**
 * One field that moved on one production recipe event: what changed, what it changed from and what
 * it changed to. A recipe event can move several fields at once (one variation update can change
 * grow weeks, yield and its task events together), so a history record carries a list of these.
 *
 * Values are rendered invariantly as text so the client never has to know a field's underlying
 * type. Composite fields render as one readable string: a week range as "12-24", a link list as
 * comma-separated "catalog:category:componentsPerPot" keys.
 */
export type ProductionRecipeHistoryChange = {
  __typename?: 'ProductionRecipeHistoryChange';
  /**
   * True when this field is one that bumps the recipe version and so reaches jobs already built from
   * the recipe. Every field the history reports today bumps the version, so this is true on every
   * change the API currently returns — do not render it as a discriminator yet. The flag is published
   * so that a descriptive field, one that leaves production untouched, can join the history later
   * without a breaking schema change.
   */
  affectsProduction: Scalars['Boolean']['output'];
  /**
   * The recipe field that changed, spelled exactly as the domain property (e.g. "GrowWeeks",
   * "TaskEventIds"). Stable across releases — safe to key client behaviour on.
   */
  fieldName: Scalars['String']['output'];
  /**
   * The value after the change; absent when the change removed the value (a field cleared, or an
   * event id being removed).
   */
  newValue?: Maybe<Scalars['String']['output']>;
  /**
   * The value before the change; absent when the field had no value (a first-time set, or an event
   * id being added).
   */
  previousValue?: Maybe<Scalars['String']['output']>;
  /**
   * A human-readable one-liner for this one field, e.g. "Grow weeks: 5 → 6" or
   * "Task event added: Transplant".
   */
  summary: Scalars['String']['output'];
};

/**
 * A single entry in the production recipe audit history, derived from the recipe event stream.
 * Each record corresponds to one event stored in KurrentDB for the recipe, and carries the
 * field-level changes that event made: what moved, from what, to what, by whom and when.
 */
export type ProductionRecipeHistoryRecord = {
  __typename?: 'ProductionRecipeHistoryRecord';
  /**
   * The fields this event moved, each with its own previous value, new value and one-line summary.
   * Empty for events that describe themselves fully — a creation, a variation added or removed, an
   * activation, an inactivation, a deletion.
   */
  changes: Array<ProductionRecipeHistoryChange>;
  /** The domain event type name (e.g. "Production.V1.RecipeCreated"). */
  eventType: Scalars['String']['output'];
  /** The unique event identifier from the event store. */
  id: Scalars['String']['output'];
  /** When the event was originally recorded. */
  occurredAt: Scalars['DateTime']['output'];
  /** The user (email or id) that performed the action, if known. */
  occurredBy: Scalars['String']['output'];
  /**
   * The variation the event applies to; absent for recipe-header events (creation, activation,
   * labor source, the recipe-level task event list).
   */
  productionRecipeVariationId?: Maybe<Scalars['String']['output']>;
  /**
   * A human-readable description of the action. When the event changed fields, this is those changes
   * joined with "; " (e.g. "Grow weeks: 5 → 6"); otherwise it is the action itself
   * (e.g. "Recipe created").
   */
  summary: Scalars['String']['output'];
};

export type ProductionRecipeLink = {
  __typename?: 'ProductionRecipeLink';
  componentsPerPot?: Maybe<Scalars['Int']['output']>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
};

export type ProductionRecipeLinkData = {
  __typename?: 'ProductionRecipeLinkData';
  catalogColor: Scalars['String']['output'];
  catalogGenus: Scalars['String']['output'];
  catalogSeries: Scalars['String']['output'];
  categoryCode: Scalars['String']['output'];
  componentsPerPot?: Maybe<Scalars['Int']['output']>;
  linkedProductionRecipeId?: Maybe<Scalars['String']['output']>;
  linkedRecipeStatus?: Maybe<ProductionRecipeStatus>;
  productionCatalogId: Scalars['String']['output'];
  productionCatalogIdWithTenant: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionCategoryIdWithTenant: Scalars['String']['output'];
};

export type ProductionRecipeLinkDataFilterInput = {
  and?: InputMaybe<Array<ProductionRecipeLinkDataFilterInput>>;
  catalogColor?: InputMaybe<StringOperationFilterInput>;
  catalogGenus?: InputMaybe<StringOperationFilterInput>;
  catalogSeries?: InputMaybe<StringOperationFilterInput>;
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  componentsPerPot?: InputMaybe<IntOperationFilterInput>;
  linkedProductionRecipeId?: InputMaybe<StringOperationFilterInput>;
  linkedRecipeStatus?: InputMaybe<NullableOfProductionRecipeStatusOperationFilterInput>;
  or?: InputMaybe<Array<ProductionRecipeLinkDataFilterInput>>;
  productionCatalogId?: InputMaybe<StringOperationFilterInput>;
  productionCatalogIdWithTenant?: InputMaybe<StringOperationFilterInput>;
  productionCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionCategoryIdWithTenant?: InputMaybe<StringOperationFilterInput>;
};

/** A connection to a list of items. */
export type ProductionRecipeLinkHealthConnection = {
  __typename?: 'ProductionRecipeLinkHealthConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionRecipeLinkHealthEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionRecipeLinkHealthRow>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionRecipeLinkHealthEdge = {
  __typename?: 'ProductionRecipeLinkHealthEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionRecipeLinkHealthRow;
};

export enum ProductionRecipeLinkHealthIssue {
  /** A non-combo recipe's link uses a catalog other than the recipe's own. */
  CatalogMismatch = 'CATALOG_MISMATCH',
  /** The link's (catalog, category) pair resolves to no recipe at all. */
  Dangling = 'DANGLING',
  /** The link resolves, but to a recipe that is not Active — lot builds through it will fail. */
  ResolvesToInactive = 'RESOLVES_TO_INACTIVE'
}

export type ProductionRecipeLinkHealthIssueOperationFilterInput = {
  eq?: InputMaybe<ProductionRecipeLinkHealthIssue>;
  in?: InputMaybe<Array<ProductionRecipeLinkHealthIssue>>;
  neq?: InputMaybe<ProductionRecipeLinkHealthIssue>;
  nin?: InputMaybe<Array<ProductionRecipeLinkHealthIssue>>;
};

/** One (link, issue) pair needing attention. A link with two issues produces two rows. */
export type ProductionRecipeLinkHealthRow = {
  __typename?: 'ProductionRecipeLinkHealthRow';
  issue: ProductionRecipeLinkHealthIssue;
  linkCatalogColor: Scalars['String']['output'];
  linkCatalogGenus: Scalars['String']['output'];
  linkCatalogSeries: Scalars['String']['output'];
  linkCategoryCode: Scalars['String']['output'];
  linkProductionCatalogId: Scalars['String']['output'];
  linkProductionCategoryId: Scalars['String']['output'];
  linkedProductionRecipeId?: Maybe<Scalars['String']['output']>;
  linkedRecipeStatus?: Maybe<ProductionRecipeStatus>;
  productionRecipeId: Scalars['String']['output'];
  productionRecipeVariationId: Scalars['String']['output'];
  recipeCatalogColor: Scalars['String']['output'];
  recipeCatalogGenus: Scalars['String']['output'];
  recipeCatalogSeries: Scalars['String']['output'];
  recipeCategoryCode: Scalars['String']['output'];
  recipeProductionCatalogId: Scalars['String']['output'];
};

/** One (link, issue) pair needing attention. A link with two issues produces two rows. */
export type ProductionRecipeLinkHealthRowFilterInput = {
  and?: InputMaybe<Array<ProductionRecipeLinkHealthRowFilterInput>>;
  issue?: InputMaybe<ProductionRecipeLinkHealthIssueOperationFilterInput>;
  linkCatalogColor?: InputMaybe<StringOperationFilterInput>;
  linkCatalogGenus?: InputMaybe<StringOperationFilterInput>;
  linkCatalogSeries?: InputMaybe<StringOperationFilterInput>;
  linkCategoryCode?: InputMaybe<StringOperationFilterInput>;
  linkProductionCatalogId?: InputMaybe<StringOperationFilterInput>;
  linkProductionCategoryId?: InputMaybe<StringOperationFilterInput>;
  linkedProductionRecipeId?: InputMaybe<StringOperationFilterInput>;
  linkedRecipeStatus?: InputMaybe<NullableOfProductionRecipeStatusOperationFilterInput>;
  or?: InputMaybe<Array<ProductionRecipeLinkHealthRowFilterInput>>;
  productionRecipeId?: InputMaybe<StringOperationFilterInput>;
  productionRecipeVariationId?: InputMaybe<StringOperationFilterInput>;
  recipeCatalogColor?: InputMaybe<StringOperationFilterInput>;
  recipeCatalogGenus?: InputMaybe<StringOperationFilterInput>;
  recipeCatalogSeries?: InputMaybe<StringOperationFilterInput>;
  recipeCategoryCode?: InputMaybe<StringOperationFilterInput>;
  recipeProductionCatalogId?: InputMaybe<StringOperationFilterInput>;
};

/** One (link, issue) pair needing attention. A link with two issues produces two rows. */
export type ProductionRecipeLinkHealthRowSortInput = {
  issue?: InputMaybe<SortEnumType>;
  linkCatalogColor?: InputMaybe<SortEnumType>;
  linkCatalogGenus?: InputMaybe<SortEnumType>;
  linkCatalogSeries?: InputMaybe<SortEnumType>;
  linkCategoryCode?: InputMaybe<SortEnumType>;
  linkProductionCatalogId?: InputMaybe<SortEnumType>;
  linkProductionCategoryId?: InputMaybe<SortEnumType>;
  linkedProductionRecipeId?: InputMaybe<SortEnumType>;
  linkedRecipeStatus?: InputMaybe<SortEnumType>;
  productionRecipeId?: InputMaybe<SortEnumType>;
  productionRecipeVariationId?: InputMaybe<SortEnumType>;
  recipeCatalogColor?: InputMaybe<SortEnumType>;
  recipeCatalogGenus?: InputMaybe<SortEnumType>;
  recipeCatalogSeries?: InputMaybe<SortEnumType>;
  recipeCategoryCode?: InputMaybe<SortEnumType>;
  recipeProductionCatalogId?: InputMaybe<SortEnumType>;
};

export type ProductionRecipeLinkInput = {
  componentsPerPot?: InputMaybe<Scalars['Int']['input']>;
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
};

/** One Recipe that uses a Catalog and Category pair as an input: at least one of its variations links the pair. */
export type ProductionRecipeLinkingPair = {
  __typename?: 'ProductionRecipeLinkingPair';
  /** The linking Recipe's catalog color. */
  catalogColor: Scalars['String']['output'];
  /** The linking Recipe's catalog genus. */
  catalogGenus: Scalars['String']['output'];
  /** The linking Recipe's catalog series. */
  catalogSeries: Scalars['String']['output'];
  /** The linking Recipe's category code. */
  categoryCode: Scalars['String']['output'];
  /** Whether the linking Recipe is a combo. */
  isCombo: Scalars['Boolean']['output'];
  /** Whether the linking Recipe is a start recipe. */
  isStartRecipe: Scalars['Boolean']['output'];
  /** How many of the linking Recipe's variations link the pair. */
  linkingVariationCount: Scalars['Int']['output'];
  /** The linking Recipe's id. */
  productionRecipeId: Scalars['String']['output'];
  /** The linking Recipe's lifecycle status. Inactive Recipes are returned, Deleted ones are not. */
  status: ProductionRecipeStatus;
};

/**
 * Every recipe mutation's result. linkingRecipes is set only when a delete of
 * a START recipe, or its switch to Simple, is refused because other recipes still link it
 * (START_RECIPE_HAS_LINKING_RECIPES):
 * it is the list the Delete Recipe screen renders and offers to re-point, in the same shape the
 * productionRecipesLinkingPair query returns, so the client needs no second query. Null on every
 * other outcome. It rides on the payload rather than the error because the wire ValidationError
 * type carries only a code, a message and a record reference.
 */
export type ProductionRecipePayload = {
  __typename?: 'ProductionRecipePayload';
  errors?: Maybe<Array<ValidationError>>;
  linkingRecipes?: Maybe<Array<ProductionRecipeLinkingPair>>;
  productionRecipe?: Maybe<ProductionRecipeStateData>;
};

export type ProductionRecipeStateData = {
  __typename?: 'ProductionRecipeStateData';
  additionalCostEventIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  flatRateCost?: Maybe<Scalars['Decimal']['output']>;
  genus?: Maybe<Scalars['String']['output']>;
  isCombo: Scalars['Boolean']['output'];
  isStartRecipe: Scalars['Boolean']['output'];
  laborSource: RecipeLaborSource;
  materialEventVendorOverrides: Array<MaterialEventVendorOverrideData>;
  productionCatalogId: Scalars['String']['output'];
  productionCategoryId: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  series?: Maybe<Scalars['String']['output']>;
  status: ProductionRecipeStatus;
  targetKind: ProductionRecipeTargetKind;
  taskEventIds: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  variations: Array<ProductionRecipeVariationData>;
  version: Scalars['Int']['output'];
};

export enum ProductionRecipeStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionRecipeStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionRecipeStatus>;
  in?: InputMaybe<Array<ProductionRecipeStatus>>;
  neq?: InputMaybe<ProductionRecipeStatus>;
  nin?: InputMaybe<Array<ProductionRecipeStatus>>;
};

export enum ProductionRecipeTargetKind {
  Catalog = 'CATALOG',
  Series = 'SERIES'
}

export type ProductionRecipeTargetKindOperationFilterInput = {
  eq?: InputMaybe<ProductionRecipeTargetKind>;
  in?: InputMaybe<Array<ProductionRecipeTargetKind>>;
  neq?: InputMaybe<ProductionRecipeTargetKind>;
  nin?: InputMaybe<Array<ProductionRecipeTargetKind>>;
};

export type ProductionRecipeVariationData = {
  __typename?: 'ProductionRecipeVariationData';
  customerGroupId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  excludedMaterialEventIds: Array<Scalars['String']['output']>;
  excludedSpaceEventIds: Array<Scalars['String']['output']>;
  excludedTaskEventIds: Array<Scalars['String']['output']>;
  growWeeks: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  links: Array<ProductionRecipeLink>;
  materialEventIds: Array<Scalars['String']['output']>;
  plantsPerPot: Scalars['Int']['output'];
  siteLocationId?: Maybe<Scalars['String']['output']>;
  spaceEventIds: Array<Scalars['String']['output']>;
  taskEventAssignmentOverrides: Array<EventAssignmentOverrideData>;
  taskEventIds: Array<Scalars['String']['output']>;
  weekRange?: Maybe<ProductionRecipeWeekRange>;
  yield: Scalars['Decimal']['output'];
  yieldTiers?: Maybe<Array<ProductionRecipeYieldTier>>;
};

export type ProductionRecipeVariationDataInput = {
  customerGroupId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  excludedMaterialEventIds: Array<Scalars['String']['input']>;
  excludedSpaceEventIds: Array<Scalars['String']['input']>;
  excludedTaskEventIds: Array<Scalars['String']['input']>;
  growWeeks: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  links: Array<ProductionRecipeLinkInput>;
  materialEventIds: Array<Scalars['String']['input']>;
  plantsPerPot: Scalars['Int']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  spaceEventIds: Array<Scalars['String']['input']>;
  taskEventAssignmentOverrides: Array<EventAssignmentOverrideDataInput>;
  taskEventIds: Array<Scalars['String']['input']>;
  weekRange?: InputMaybe<ProductionRecipeWeekRangeInput>;
  yield: Scalars['Decimal']['input'];
  yieldTiers?: InputMaybe<Array<ProductionRecipeYieldTierInput>>;
};

export type ProductionRecipeVariationDecimalChangeDataInput = {
  expected: Scalars['Decimal']['input'];
  value: Scalars['Decimal']['input'];
};

export type ProductionRecipeVariationDocument = {
  __typename?: 'ProductionRecipeVariationDocument';
  /**
   * Optional customer-group scope; null = not group-scoped. Mutually exclusive with the customer
   * scope above — a variation scopes to at most one of the two.
   */
  customerGroupId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the customer group this variation is scoped to, or null when it is not group-scoped
   * or the group no longer exists.
   */
  customerGroupName?: Maybe<Scalars['String']['output']>;
  /** Optional customer scope; null = customer-agnostic. Part of the (customer, site) resolution rung. */
  customerId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the customer this variation is scoped to, or null when it is customer-agnostic or
   * the customer no longer exists.
   */
  customerName?: Maybe<Scalars['String']['output']>;
  /** The yield this variation applies to a step planned to produce plannedQuantity. */
  effectiveYield: ProductionRecipeEffectiveYield;
  excludedMaterialEventIds: Array<Scalars['String']['output']>;
  excludedSpaceEventIds: Array<Scalars['String']['output']>;
  excludedTaskEventIds: Array<Scalars['String']['output']>;
  growWeeks: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  links: Array<ProductionRecipeLinkData>;
  materialEventIds: Array<Scalars['String']['output']>;
  parentCatalogColor: Scalars['String']['output'];
  parentCatalogGenus: Scalars['String']['output'];
  parentCatalogSeries: Scalars['String']['output'];
  parentCategoryCode: Scalars['String']['output'];
  parentIsCombo: Scalars['Boolean']['output'];
  /** The parent recipe's own catalog id. */
  parentProductionCatalogId: Scalars['String']['output'];
  plantsPerPot: Scalars['Int']['output'];
  productionRecipeId: Scalars['String']['output'];
  productionRecipeVariationId: Scalars['String']['output'];
  /**
   * The produce tag that should go on plants grown from this variation, chosen by the
   * most-specific-wins ladder from the parent recipe's category, genus, series and colour, the
   * variation's customer, and its start week. Unresolved when no tag fits or the tenant's Tags
   * feature is off.
   */
  resolvedTag: ProduceTagResolutionResult;
  /** Optional site-location scope; null = site-agnostic. Part of the (customer, site) resolution rung. */
  siteLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the site location this variation is scoped to, or null when it is site-agnostic or
   * the site no longer exists.
   */
  siteLocationName?: Maybe<Scalars['String']['output']>;
  spaceEventIds: Array<Scalars['String']['output']>;
  taskEventAssignmentOverrides: Array<EventAssignmentOverrideDocument>;
  taskEventIds: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  weekRange?: Maybe<ProductionRecipeWeekRange>;
  yield: Scalars['Decimal']['output'];
  /**
   * Volume-efficiency rungs, stored ascending by threshold. Empty (or absent, on documents written
   * before volume tiers) means the base yield always applies.
   */
  yieldTiers: Array<ProductionRecipeYieldTierDocument>;
};


export type ProductionRecipeVariationDocumentEffectiveYieldArgs = {
  plannedQuantity: Scalars['Int']['input'];
};

export type ProductionRecipeVariationDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionRecipeVariationDocumentFilterInput>>;
  /**
   * Optional customer-group scope; null = not group-scoped. Mutually exclusive with the customer
   * scope above — a variation scopes to at most one of the two.
   */
  customerGroupId?: InputMaybe<StringOperationFilterInput>;
  /** Optional customer scope; null = customer-agnostic. Part of the (customer, site) resolution rung. */
  customerId?: InputMaybe<StringOperationFilterInput>;
  excludedMaterialEventIds?: InputMaybe<ListStringOperationFilterInput>;
  excludedSpaceEventIds?: InputMaybe<ListStringOperationFilterInput>;
  excludedTaskEventIds?: InputMaybe<ListStringOperationFilterInput>;
  growWeeks?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  links?: InputMaybe<ListFilterInputTypeOfProductionRecipeLinkDataFilterInput>;
  materialEventIds?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionRecipeVariationDocumentFilterInput>>;
  parentCatalogColor?: InputMaybe<StringOperationFilterInput>;
  parentCatalogGenus?: InputMaybe<StringOperationFilterInput>;
  parentCatalogSeries?: InputMaybe<StringOperationFilterInput>;
  parentCategoryCode?: InputMaybe<StringOperationFilterInput>;
  parentIsCombo?: InputMaybe<BooleanOperationFilterInput>;
  /** The parent recipe's own catalog id. */
  parentProductionCatalogId?: InputMaybe<StringOperationFilterInput>;
  plantsPerPot?: InputMaybe<IntOperationFilterInput>;
  productionRecipeId?: InputMaybe<StringOperationFilterInput>;
  productionRecipeVariationId?: InputMaybe<StringOperationFilterInput>;
  /** Optional site-location scope; null = site-agnostic. Part of the (customer, site) resolution rung. */
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  spaceEventIds?: InputMaybe<ListStringOperationFilterInput>;
  taskEventAssignmentOverrides?: InputMaybe<ListFilterInputTypeOfEventAssignmentOverrideDocumentFilterInput>;
  taskEventIds?: InputMaybe<ListStringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  weekRange?: InputMaybe<ProductionRecipeWeekRangeFilterInput>;
  yield?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Volume-efficiency rungs, stored ascending by threshold. Empty (or absent, on documents written
   * before volume tiers) means the base yield always applies.
   */
  yieldTiers?: InputMaybe<ListFilterInputTypeOfProductionRecipeYieldTierDocumentFilterInput>;
};

export type ProductionRecipeVariationDocumentSortInput = {
  /**
   * Optional customer-group scope; null = not group-scoped. Mutually exclusive with the customer
   * scope above — a variation scopes to at most one of the two.
   */
  customerGroupId?: InputMaybe<SortEnumType>;
  /** Optional customer scope; null = customer-agnostic. Part of the (customer, site) resolution rung. */
  customerId?: InputMaybe<SortEnumType>;
  growWeeks?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  parentCatalogColor?: InputMaybe<SortEnumType>;
  parentCatalogGenus?: InputMaybe<SortEnumType>;
  parentCatalogSeries?: InputMaybe<SortEnumType>;
  parentCategoryCode?: InputMaybe<SortEnumType>;
  parentIsCombo?: InputMaybe<SortEnumType>;
  /** The parent recipe's own catalog id. */
  parentProductionCatalogId?: InputMaybe<SortEnumType>;
  plantsPerPot?: InputMaybe<SortEnumType>;
  productionRecipeId?: InputMaybe<SortEnumType>;
  productionRecipeVariationId?: InputMaybe<SortEnumType>;
  /** Optional site-location scope; null = site-agnostic. Part of the (customer, site) resolution rung. */
  siteLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  weekRange?: InputMaybe<ProductionRecipeWeekRangeSortInput>;
  yield?: InputMaybe<SortEnumType>;
};

export enum ProductionRecipeVariationField {
  CustomerGroupId = 'CUSTOMER_GROUP_ID',
  CustomerId = 'CUSTOMER_ID',
  EndWeek = 'END_WEEK',
  GrowWeeks = 'GROW_WEEKS',
  PlantsPerPot = 'PLANTS_PER_POT',
  SiteLocationId = 'SITE_LOCATION_ID',
  StartWeek = 'START_WEEK',
  WeekRange = 'WEEK_RANGE',
  Yield = 'YIELD'
}

/** The grid fields of one variation as they are saved. A null start and end week means all weeks. */
export type ProductionRecipeVariationFieldValues = {
  __typename?: 'ProductionRecipeVariationFieldValues';
  customerGroupId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  endWeek?: Maybe<Scalars['Int']['output']>;
  growWeeks: Scalars['Int']['output'];
  plantsPerPot: Scalars['Int']['output'];
  siteLocationId?: Maybe<Scalars['String']['output']>;
  startWeek?: Maybe<Scalars['Int']['output']>;
  variationId: Scalars['String']['output'];
  yield: Scalars['Decimal']['output'];
};

/**
 * Why a single-field variation save was refused. Code is stable for the grid to key on; Message is plain
 * English with the fix. The detail fields are set only for the codes that carry them:
 * PRODUCTION_RECIPE_VARIATION_CHANGED_ELSEWHERE sets ChangedFields and Saved;
 * PRODUCTION_RECIPE_VARIATION_WEEKS_OVERLAP sets OtherVariation;
 * PRODUCTION_RECIPE_VARIATION_CUSTOMER_AND_CUSTOMER_GROUP sets CustomerId and CustomerGroupId;
 * PRODUCTION_RECIPE_VARIATION_WEEK_RANGE_INCOMPLETE sets Field (the missing week);
 * PRODUCTION_RECIPE_VARIATION_VALUE_OUT_OF_RANGE sets Field, Min and Max (null Max = no upper bound);
 * PRODUCTION_RECIPE_VARIATION_COMBO_PLANTS_PER_POT sets Field and ComponentsPerPotSum.
 * Any other refusal carries its code and message only.
 */
export type ProductionRecipeVariationFieldsError = {
  __typename?: 'ProductionRecipeVariationFieldsError';
  changedFields?: Maybe<Array<ProductionRecipeVariationField>>;
  code?: Maybe<Scalars['String']['output']>;
  componentsPerPotSum?: Maybe<Scalars['Int']['output']>;
  customerGroupId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  field?: Maybe<ProductionRecipeVariationField>;
  max?: Maybe<Scalars['Decimal']['output']>;
  message: Scalars['String']['output'];
  min?: Maybe<Scalars['Decimal']['output']>;
  otherVariation?: Maybe<ProductionRecipeVariationFieldValues>;
  saved?: Maybe<ProductionRecipeVariationFieldValues>;
};

/**
 * The outcome of one single-field variation save. Variation is the variation as it is saved after the
 * call, whatever the status, so the grid can show the saved value beside a refusal; it is null only when
 * the recipe or variation could not be read (for example, a malformed or unknown id).
 */
export type ProductionRecipeVariationFieldsResult = {
  __typename?: 'ProductionRecipeVariationFieldsResult';
  errors?: Maybe<Array<ProductionRecipeVariationFieldsError>>;
  productionRecipeId: Scalars['String']['output'];
  status: ProductionRecipeVariationFieldsStatus;
  variation?: Maybe<ProductionRecipeVariationFieldValues>;
  variationId: Scalars['String']['output'];
};

/** What happened to one single-field variation save. */
export enum ProductionRecipeVariationFieldsStatus {
  /** The change was saved. */
  Applied = 'APPLIED',
  /** The change was not saved; Errors says why. */
  Refused = 'REFUSED',
  /** The variation already held the sent values, so nothing was written. */
  Unchanged = 'UNCHANGED'
}

export type ProductionRecipeVariationIdChangeDataInput = {
  expected?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProductionRecipeVariationWeekRangeChangeDataInput = {
  expected?: InputMaybe<ProductionRecipeVariationWeeksDataInput>;
  value?: InputMaybe<ProductionRecipeVariationWeeksDataInput>;
};

export type ProductionRecipeVariationWeeksDataInput = {
  endWeek?: InputMaybe<Scalars['Int']['input']>;
  startWeek?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductionRecipeVariationWholeNumberChangeDataInput = {
  expected: Scalars['Int']['input'];
  value: Scalars['Int']['input'];
};

/** A connection to a list of items. */
export type ProductionRecipeVariationsConnection = {
  __typename?: 'ProductionRecipeVariationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionRecipeVariationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionRecipeVariationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionRecipeVariationsEdge = {
  __typename?: 'ProductionRecipeVariationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionRecipeVariationDocument;
};

export type ProductionRecipeWeekRange = {
  __typename?: 'ProductionRecipeWeekRange';
  endWeek: Scalars['Int']['output'];
  startWeek: Scalars['Int']['output'];
};

export type ProductionRecipeWeekRangeFilterInput = {
  and?: InputMaybe<Array<ProductionRecipeWeekRangeFilterInput>>;
  endWeek?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionRecipeWeekRangeFilterInput>>;
  startWeek?: InputMaybe<IntOperationFilterInput>;
};

export type ProductionRecipeWeekRangeInput = {
  endWeek: Scalars['Int']['input'];
  startWeek: Scalars['Int']['input'];
};

export type ProductionRecipeWeekRangeSortInput = {
  endWeek?: InputMaybe<SortEnumType>;
  startWeek?: InputMaybe<SortEnumType>;
};

export type ProductionRecipeYieldTier = {
  __typename?: 'ProductionRecipeYieldTier';
  thresholdQuantity: Scalars['Int']['output'];
  yield: Scalars['Decimal']['output'];
};

export type ProductionRecipeYieldTierDocument = {
  __typename?: 'ProductionRecipeYieldTierDocument';
  thresholdQuantity: Scalars['Int']['output'];
  yield: Scalars['Decimal']['output'];
};

export type ProductionRecipeYieldTierDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionRecipeYieldTierDocumentFilterInput>>;
  or?: InputMaybe<Array<ProductionRecipeYieldTierDocumentFilterInput>>;
  thresholdQuantity?: InputMaybe<IntOperationFilterInput>;
  yield?: InputMaybe<DecimalOperationFilterInput>;
};

export type ProductionRecipeYieldTierInput = {
  thresholdQuantity: Scalars['Int']['input'];
  yield: Scalars['Decimal']['input'];
};

/** A connection to a list of items. */
export type ProductionRecipesConnection = {
  __typename?: 'ProductionRecipesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionRecipesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionRecipeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionRecipesEdge = {
  __typename?: 'ProductionRecipesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionRecipeDocument;
};

/** A connection to a list of items. */
export type ProductionSpaceCategoriesConnection = {
  __typename?: 'ProductionSpaceCategoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionSpaceCategoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionSpaceCategoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionSpaceCategoriesEdge = {
  __typename?: 'ProductionSpaceCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionSpaceCategoryDocument;
};

export type ProductionSpaceCategoryDimensionOverrideData = {
  __typename?: 'ProductionSpaceCategoryDimensionOverrideData';
  customerId?: Maybe<Scalars['String']['output']>;
  length: Scalars['Decimal']['output'];
  siteLocationId?: Maybe<Scalars['String']['output']>;
  spaceTypeId?: Maybe<Scalars['String']['output']>;
  stagger: Scalars['Boolean']['output'];
  width: Scalars['Decimal']['output'];
};

export type ProductionSpaceCategoryDocument = {
  __typename?: 'ProductionSpaceCategoryDocument';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** The default length applied when no site-specific override exists. */
  defaultLength?: Maybe<Scalars['Decimal']['output']>;
  /** The default hex-packing (stagger) flag applied when no override exists. */
  defaultStagger: Scalars['Boolean']['output'];
  /** The default width applied when no site-specific override exists. */
  defaultWidth?: Maybe<Scalars['Decimal']['output']>;
  /** All dimension overrides for this category, one row per (site?, customer?, spaceType?) override scope. */
  dimensionOverrides: Array<ProductionSpaceCategoryDimensionOverrideData>;
  /** Returns the effective dimensions for a site, customer, and/or space type, applying the most-specific-wins precedence with the tie-break customer > site > space type. */
  effectiveDimensions?: Maybe<SpaceCategoryDimensionsData>;
  id: Scalars['String']['output'];
  /** @deprecated Use defaultLength. */
  length?: Maybe<Scalars['Decimal']['output']>;
  productionSpaceCategoryId: Scalars['String']['output'];
  /** @deprecated Use dimensionOverrides, which also includes customer-scoped overrides. */
  siteOverrides: Array<ProductionSpaceCategorySiteOverrideData>;
  status: ProductionSpaceCategoryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  /** @deprecated Use defaultWidth. */
  width?: Maybe<Scalars['Decimal']['output']>;
};


export type ProductionSpaceCategoryDocumentEffectiveDimensionsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductionSpaceCategoryDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionSpaceCategoryDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  length?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProductionSpaceCategoryDocumentFilterInput>>;
  productionSpaceCategoryId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionSpaceCategoryStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  width?: InputMaybe<DecimalOperationFilterInput>;
};

export type ProductionSpaceCategoryDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  length?: InputMaybe<SortEnumType>;
  productionSpaceCategoryId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  width?: InputMaybe<SortEnumType>;
};

export type ProductionSpaceCategoryPayload = {
  __typename?: 'ProductionSpaceCategoryPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionSpaceCategory?: Maybe<ProductionSpaceCategoryStateData>;
};

export type ProductionSpaceCategorySiteOverrideData = {
  __typename?: 'ProductionSpaceCategorySiteOverrideData';
  length: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  width: Scalars['Decimal']['output'];
};

export type ProductionSpaceCategoryStateData = {
  __typename?: 'ProductionSpaceCategoryStateData';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  length: Scalars['Decimal']['output'];
  productionSpaceCategoryId: Scalars['String']['output'];
  stagger: Scalars['Boolean']['output'];
  status: ProductionSpaceCategoryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  width: Scalars['Decimal']['output'];
};

export enum ProductionSpaceCategoryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionSpaceCategoryStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionSpaceCategoryStatus>;
  in?: InputMaybe<Array<ProductionSpaceCategoryStatus>>;
  neq?: InputMaybe<ProductionSpaceCategoryStatus>;
  nin?: InputMaybe<Array<ProductionSpaceCategoryStatus>>;
};

export type ProductionSpaceEventDetailData = {
  __typename?: 'ProductionSpaceEventDetailData';
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  productionSpaceCategoryId: Scalars['String']['output'];
  productionSpaceEventDetailId: Scalars['String']['output'];
  productionSpaceTypeId: Scalars['String']['output'];
  status: ProductionSpaceEventStatus;
  triggerId: Scalars['String']['output'];
};

/**
 * A production space event detail row with categoryCode and typeCode resolved fresh on
 * every request, alongside triggerName, so a category/type/trigger rename is always current on
 * the next request.
 */
export type ProductionSpaceEventDetailDocument = {
  __typename?: 'ProductionSpaceEventDetailDocument';
  /** The joined space category's current code; empty when the detail's category no longer resolves. */
  categoryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  productionSpaceCategoryId: Scalars['String']['output'];
  productionSpaceEventDetailId: Scalars['String']['output'];
  productionSpaceEventId: Scalars['String']['output'];
  productionSpaceTypeId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  triggerId: Scalars['String']['output'];
  triggerName: Scalars['String']['output'];
  /** The joined space type's current code; empty when the detail's type no longer resolves. */
  typeCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * A production space event detail row with categoryCode and typeCode resolved fresh on
 * every request, alongside triggerName, so a category/type/trigger rename is always current on
 * the next request.
 */
export type ProductionSpaceEventDetailDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionSpaceEventDetailDocumentFilterInput>>;
  /** The joined space category's current code; empty when the detail's category no longer resolves. */
  categoryCode?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  duration?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionSpaceEventDetailDocumentFilterInput>>;
  productionSpaceCategoryId?: InputMaybe<StringOperationFilterInput>;
  productionSpaceEventDetailId?: InputMaybe<StringOperationFilterInput>;
  productionSpaceEventId?: InputMaybe<StringOperationFilterInput>;
  productionSpaceTypeId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  triggerId?: InputMaybe<StringOperationFilterInput>;
  triggerName?: InputMaybe<StringOperationFilterInput>;
  /** The joined space type's current code; empty when the detail's type no longer resolves. */
  typeCode?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A production space event detail row with categoryCode and typeCode resolved fresh on
 * every request, alongside triggerName, so a category/type/trigger rename is always current on
 * the next request.
 */
export type ProductionSpaceEventDetailDocumentSortInput = {
  /** The joined space category's current code; empty when the detail's category no longer resolves. */
  categoryCode?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  productionSpaceCategoryId?: InputMaybe<SortEnumType>;
  productionSpaceEventDetailId?: InputMaybe<SortEnumType>;
  productionSpaceEventId?: InputMaybe<SortEnumType>;
  productionSpaceTypeId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  triggerId?: InputMaybe<SortEnumType>;
  triggerName?: InputMaybe<SortEnumType>;
  /** The joined space type's current code; empty when the detail's type no longer resolves. */
  typeCode?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionSpaceEventDetailsConnection = {
  __typename?: 'ProductionSpaceEventDetailsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionSpaceEventDetailsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionSpaceEventDetailDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionSpaceEventDetailsEdge = {
  __typename?: 'ProductionSpaceEventDetailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionSpaceEventDetailDocument;
};

export type ProductionSpaceEventDocument = {
  __typename?: 'ProductionSpaceEventDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionSpaceEventId: Scalars['String']['output'];
  status: ProductionSpaceEventStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionSpaceEventDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionSpaceEventDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionSpaceEventDocumentFilterInput>>;
  productionSpaceEventId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionSpaceEventStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionSpaceEventDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productionSpaceEventId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionSpaceEventPayload = {
  __typename?: 'ProductionSpaceEventPayload';
  errors?: Maybe<Array<ValidationError>>;
  event?: Maybe<ProductionSpaceEventStateData>;
};

export type ProductionSpaceEventStateData = {
  __typename?: 'ProductionSpaceEventStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  details: Array<ProductionSpaceEventDetailData>;
  name: Scalars['String']['output'];
  productionSpaceEventId: Scalars['String']['output'];
  status: ProductionSpaceEventStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionSpaceEventStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionSpaceEventStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionSpaceEventStatus>;
  in?: InputMaybe<Array<ProductionSpaceEventStatus>>;
  neq?: InputMaybe<ProductionSpaceEventStatus>;
  nin?: InputMaybe<Array<ProductionSpaceEventStatus>>;
};

/** A connection to a list of items. */
export type ProductionSpaceEventsConnection = {
  __typename?: 'ProductionSpaceEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionSpaceEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionSpaceEventDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionSpaceEventsEdge = {
  __typename?: 'ProductionSpaceEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionSpaceEventDocument;
};

export type ProductionSpaceTypeDocument = {
  __typename?: 'ProductionSpaceTypeDocument';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  productionSpaceTypeId: Scalars['String']['output'];
  status: ProductionSpaceTypeStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionSpaceTypeDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionSpaceTypeDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionSpaceTypeDocumentFilterInput>>;
  productionSpaceTypeId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionSpaceTypeStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionSpaceTypeDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  productionSpaceTypeId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionSpaceTypePayload = {
  __typename?: 'ProductionSpaceTypePayload';
  errors?: Maybe<Array<ValidationError>>;
  productionSpaceType?: Maybe<ProductionSpaceTypeStateData>;
};

export type ProductionSpaceTypeStateData = {
  __typename?: 'ProductionSpaceTypeStateData';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  productionSpaceTypeId: Scalars['String']['output'];
  status: ProductionSpaceTypeStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionSpaceTypeStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionSpaceTypeStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionSpaceTypeStatus>;
  in?: InputMaybe<Array<ProductionSpaceTypeStatus>>;
  neq?: InputMaybe<ProductionSpaceTypeStatus>;
  nin?: InputMaybe<Array<ProductionSpaceTypeStatus>>;
};

/** A connection to a list of items. */
export type ProductionSpaceTypesConnection = {
  __typename?: 'ProductionSpaceTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionSpaceTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionSpaceTypeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionSpaceTypesEdge = {
  __typename?: 'ProductionSpaceTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionSpaceTypeDocument;
};

export type ProductionTaskEventDetailData = {
  __typename?: 'ProductionTaskEventDetailData';
  description: Scalars['String']['output'];
  materialItemId?: Maybe<Scalars['String']['output']>;
  multiple: Scalars['Decimal']['output'];
  productionTaskEventDetailId: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  status: ProductionTaskEventStatus;
  taskEventType?: Maybe<TaskEventTypeDocument>;
  taskEventTypeId: Scalars['String']['output'];
  /**
   * Resolved name of the referenced TaskEventType, denormalized into the mutation
   * response. Resolved synchronously in the mutation post-pipeline from
   * TaskEventTypeDocument; empty when the id has not yet been projected
   * or the document is unavailable.
   */
  taskEventTypeName: Scalars['String']['output'];
  triggerId: Scalars['String']['output'];
  /**
   * This step's own crew speed in containers per hour, not plants per hour. Null until set, and then labor
   * demand uses the event's unitsPerHour multiplied by the number of active steps for this step.
   */
  unitsPerHour?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductionTaskEventDetailDocument = {
  __typename?: 'ProductionTaskEventDetailDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materialItemDescription?: Maybe<Scalars['String']['output']>;
  materialItemId?: Maybe<Scalars['String']['output']>;
  multiple: Scalars['Decimal']['output'];
  productionTaskEventDetailId: Scalars['String']['output'];
  productionTaskEventId: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  taskEventType?: Maybe<TaskEventTypeDocument>;
  taskEventTypeId: Scalars['String']['output'];
  /**
   * Denormalized TaskEventTypeDocument.Name for the referenced TaskEventType,
   * set at projection time. Empty when the referenced id could not be resolved
   * (e.g. legacy V1 events that omitted the reference).
   */
  taskEventTypeName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  triggerId: Scalars['String']['output'];
  triggerName: Scalars['String']['output'];
  /**
   * This step's own crew speed in containers per hour. Null until set, and then the step falls back to the
   * event's UnitsPerHour multiplied by the event's number of active steps.
   */
  unitsPerHour?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionTaskEventDetailDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionTaskEventDetailDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  materialItemDescription?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  multiple?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProductionTaskEventDetailDocumentFilterInput>>;
  productionTaskEventDetailId?: InputMaybe<StringOperationFilterInput>;
  productionTaskEventId?: InputMaybe<StringOperationFilterInput>;
  sequence?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  taskEventTypeId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Denormalized TaskEventTypeDocument.Name for the referenced TaskEventType,
   * set at projection time. Empty when the referenced id could not be resolved
   * (e.g. legacy V1 events that omitted the reference).
   */
  taskEventTypeName?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  triggerId?: InputMaybe<StringOperationFilterInput>;
  triggerName?: InputMaybe<StringOperationFilterInput>;
  /**
   * This step's own crew speed in containers per hour. Null until set, and then the step falls back to the
   * event's UnitsPerHour multiplied by the event's number of active steps.
   */
  unitsPerHour?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionTaskEventDetailDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  materialItemDescription?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  multiple?: InputMaybe<SortEnumType>;
  productionTaskEventDetailId?: InputMaybe<SortEnumType>;
  productionTaskEventId?: InputMaybe<SortEnumType>;
  sequence?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskEventTypeId?: InputMaybe<SortEnumType>;
  /**
   * Denormalized TaskEventTypeDocument.Name for the referenced TaskEventType,
   * set at projection time. Empty when the referenced id could not be resolved
   * (e.g. legacy V1 events that omitted the reference).
   */
  taskEventTypeName?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  triggerId?: InputMaybe<SortEnumType>;
  triggerName?: InputMaybe<SortEnumType>;
  /**
   * This step's own crew speed in containers per hour. Null until set, and then the step falls back to the
   * event's UnitsPerHour multiplied by the event's number of active steps.
   */
  unitsPerHour?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductionTaskEventDetailsConnection = {
  __typename?: 'ProductionTaskEventDetailsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionTaskEventDetailsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionTaskEventDetailDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionTaskEventDetailsEdge = {
  __typename?: 'ProductionTaskEventDetailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionTaskEventDetailDocument;
};

export type ProductionTaskEventDocument = {
  __typename?: 'ProductionTaskEventDocument';
  costEffectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  costEffectiveTo?: Maybe<Scalars['DateTime']['output']>;
  costPerEvent?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  laborTypeTagId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productionTaskEventId: Scalars['String']['output'];
  status: ProductionTaskEventStatus;
  tenantId: Scalars['String']['output'];
  /**
   * Event-level crew speed in containers per hour, not plants per hour. Used only for active steps with
   * no unitsPerHour of their own, at this speed times the number of active steps. Editing it does not
   * change steps that have their own speed.
   */
  unitsPerHour?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionTaskEventDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionTaskEventDocumentFilterInput>>;
  costEffectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  costEffectiveTo?: InputMaybe<DateTimeOperationFilterInput>;
  costPerEvent?: InputMaybe<DecimalOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  laborTypeTagId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductionTaskEventDocumentFilterInput>>;
  productionTaskEventId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProductionTaskEventStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Event-level crew speed in containers per hour, not plants per hour. Used only for active steps with
   * no unitsPerHour of their own, at this speed times the number of active steps. Editing it does not
   * change steps that have their own speed.
   */
  unitsPerHour?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionTaskEventDocumentSortInput = {
  costEffectiveFrom?: InputMaybe<SortEnumType>;
  costEffectiveTo?: InputMaybe<SortEnumType>;
  costPerEvent?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  laborTypeTagId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productionTaskEventId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /**
   * Event-level crew speed in containers per hour, not plants per hour. Used only for active steps with
   * no unitsPerHour of their own, at this speed times the number of active steps. Editing it does not
   * change steps that have their own speed.
   */
  unitsPerHour?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionTaskEventPayload = {
  __typename?: 'ProductionTaskEventPayload';
  errors?: Maybe<Array<ValidationError>>;
  event?: Maybe<ProductionTaskEventStateData>;
};

export type ProductionTaskEventStateData = {
  __typename?: 'ProductionTaskEventStateData';
  costEffectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  costEffectiveTo?: Maybe<Scalars['DateTime']['output']>;
  costPerEvent?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  details: Array<ProductionTaskEventDetailData>;
  laborTypeTagId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productionTaskEventId: Scalars['String']['output'];
  status: ProductionTaskEventStatus;
  tenantId: Scalars['String']['output'];
  /**
   * Event-level crew speed in containers per hour, not plants per hour. Used only for active steps with
   * no unitsPerHour of their own, at this speed times the number of active steps. Editing it does not
   * change steps that have their own speed.
   */
  unitsPerHour?: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionTaskEventStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionTaskEventStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionTaskEventStatus>;
  in?: InputMaybe<Array<ProductionTaskEventStatus>>;
  neq?: InputMaybe<ProductionTaskEventStatus>;
  nin?: InputMaybe<Array<ProductionTaskEventStatus>>;
};

/** A connection to a list of items. */
export type ProductionTaskEventsConnection = {
  __typename?: 'ProductionTaskEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionTaskEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionTaskEventDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionTaskEventsEdge = {
  __typename?: 'ProductionTaskEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionTaskEventDocument;
};

export type ProductionTriggerDocument = {
  __typename?: 'ProductionTriggerDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * When the trigger stops applying. null means it never expires. null sorts below
   * every date, so order: { expireBy: ASC } returns never-expiring triggers first. Callers
   * wanting only dated triggers should pair the sort with where: { expireBy: { neq: null } }.
   */
  expireBy?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offset: Scalars['Int']['output'];
  productionTriggerId: Scalars['String']['output'];
  /** Calendar days before the trigger date to remind; an empty list turns reminders off. */
  reminderLeadTimes: Array<ProductionTriggerReminderLeadTime>;
  /** The reminder recipient; missing means reminders are off. */
  reminderRecipientEmail?: Maybe<Scalars['String']['output']>;
  source: ProductionTriggerSource;
  status: ProductionTriggerStatus;
  tenantId: Scalars['String']['output'];
  unit: ProductionTriggerUnit;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionTriggerDocumentFilterInput = {
  and?: InputMaybe<Array<ProductionTriggerDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * When the trigger stops applying. null means it never expires. null sorts below
   * every date, so order: { expireBy: ASC } returns never-expiring triggers first. Callers
   * wanting only dated triggers should pair the sort with where: { expireBy: { neq: null } }.
   */
  expireBy?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  offset?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductionTriggerDocumentFilterInput>>;
  productionTriggerId?: InputMaybe<StringOperationFilterInput>;
  /** Calendar days before the trigger date to remind; an empty list turns reminders off. */
  reminderLeadTimes?: InputMaybe<ListProductionTriggerReminderLeadTimeOperationFilterInput>;
  /** The reminder recipient; missing means reminders are off. */
  reminderRecipientEmail?: InputMaybe<StringOperationFilterInput>;
  source?: InputMaybe<ProductionTriggerSourceOperationFilterInput>;
  status?: InputMaybe<ProductionTriggerStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  unit?: InputMaybe<ProductionTriggerUnitOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProductionTriggerDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * When the trigger stops applying. null means it never expires. null sorts below
   * every date, so order: { expireBy: ASC } returns never-expiring triggers first. Callers
   * wanting only dated triggers should pair the sort with where: { expireBy: { neq: null } }.
   */
  expireBy?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  offset?: InputMaybe<SortEnumType>;
  productionTriggerId?: InputMaybe<SortEnumType>;
  /** The reminder recipient; missing means reminders are off. */
  reminderRecipientEmail?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProductionTriggerPayload = {
  __typename?: 'ProductionTriggerPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionTrigger?: Maybe<ProductionTriggerStateData>;
};

/** A due reminder for one trigger, trigger date and lead time, counting distinct jobs. */
export type ProductionTriggerReminderDue = {
  __typename?: 'ProductionTriggerReminderDue';
  jobCount: Scalars['Int']['output'];
  leadTime: ProductionTriggerReminderLeadTime;
  recipientEmail: Scalars['String']['output'];
  triggerDate: Scalars['LocalDate']['output'];
  triggerId: Scalars['String']['output'];
  triggerName: Scalars['String']['output'];
};

export enum ProductionTriggerReminderLeadTime {
  DayOf = 'DAY_OF',
  OneDayBefore = 'ONE_DAY_BEFORE',
  OneWeekBefore = 'ONE_WEEK_BEFORE'
}

export type ProductionTriggerReminderLeadTimeOperationFilterInput = {
  eq?: InputMaybe<ProductionTriggerReminderLeadTime>;
  in?: InputMaybe<Array<ProductionTriggerReminderLeadTime>>;
  neq?: InputMaybe<ProductionTriggerReminderLeadTime>;
  nin?: InputMaybe<Array<ProductionTriggerReminderLeadTime>>;
};

export enum ProductionTriggerSource {
  ReadyWeek = 'READY_WEEK',
  StartWeek = 'START_WEEK'
}

export type ProductionTriggerSourceOperationFilterInput = {
  eq?: InputMaybe<ProductionTriggerSource>;
  in?: InputMaybe<Array<ProductionTriggerSource>>;
  neq?: InputMaybe<ProductionTriggerSource>;
  nin?: InputMaybe<Array<ProductionTriggerSource>>;
};

export type ProductionTriggerStateData = {
  __typename?: 'ProductionTriggerStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** When the trigger stops applying. Null means it never expires. */
  expireBy?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  offset: Scalars['Int']['output'];
  productionTriggerId: Scalars['String']['output'];
  /** Calendar days before the trigger date to remind; an empty list turns reminders off. */
  reminderLeadTimes: Array<ProductionTriggerReminderLeadTime>;
  /** The reminder recipient; missing means reminders are off. */
  reminderRecipientEmail?: Maybe<Scalars['String']['output']>;
  source: ProductionTriggerSource;
  status: ProductionTriggerStatus;
  tenantId: Scalars['String']['output'];
  unit: ProductionTriggerUnit;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ProductionTriggerStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ProductionTriggerStatusOperationFilterInput = {
  eq?: InputMaybe<ProductionTriggerStatus>;
  in?: InputMaybe<Array<ProductionTriggerStatus>>;
  neq?: InputMaybe<ProductionTriggerStatus>;
  nin?: InputMaybe<Array<ProductionTriggerStatus>>;
};

export enum ProductionTriggerUnit {
  Day = 'DAY',
  Week = 'WEEK'
}

export type ProductionTriggerUnitOperationFilterInput = {
  eq?: InputMaybe<ProductionTriggerUnit>;
  in?: InputMaybe<Array<ProductionTriggerUnit>>;
  neq?: InputMaybe<ProductionTriggerUnit>;
  nin?: InputMaybe<Array<ProductionTriggerUnit>>;
};

/** A connection to a list of items. */
export type ProductionTriggersConnection = {
  __typename?: 'ProductionTriggersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductionTriggersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductionTriggerDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductionTriggersEdge = {
  __typename?: 'ProductionTriggersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductionTriggerDocument;
};

/** One week a refused save clashed on. savedQuantity is 0 when the week is not saved. */
export type ProductionYearPlanCellConflictData = {
  __typename?: 'ProductionYearPlanCellConflictData';
  isoWeek: Scalars['Int']['output'];
  productionItemId: Scalars['String']['output'];
  savedQuantity: Scalars['Int']['output'];
};

export type ProductionYearPlanCellDataInput = {
  /** The quantity the page showed for this week, 0 when empty. When sent, the save is refused if the week has since been saved as a value other than this one and other than quantity. */
  baseQuantity?: InputMaybe<Scalars['Int']['input']>;
  isoWeek: Scalars['Int']['input'];
  productionItemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type ProductionYearPlanItemData = {
  __typename?: 'ProductionYearPlanItemData';
  plannedLike?: Maybe<ProductionYearPlanLikeData>;
  productionItemId: Scalars['String']['output'];
  weeks: Array<ProductionYearPlanWeekData>;
};

export type ProductionYearPlanLikeData = {
  __typename?: 'ProductionYearPlanLikeData';
  compProductionItemId: Scalars['String']['output'];
  percent: Scalars['Int']['output'];
  shiftWeeks: Scalars['Int']['output'];
};

/**
 * The result of a year plan write: the plan on success, otherwise the errors and no plan. A save refused with
 * PRODUCTION_YEAR_PLAN_CHANGED also returns the plan as it is saved now and its conflicts.
 */
export type ProductionYearPlanPayload = {
  __typename?: 'ProductionYearPlanPayload';
  /**
   * Each week a PRODUCTION_YEAR_PLAN_CHANGED refusal clashed on, with the quantity saved for it now.
   * Empty otherwise.
   */
  conflicts: Array<ProductionYearPlanCellConflictData>;
  errors?: Maybe<Array<ValidationError>>;
  productionYearPlan?: Maybe<ProductionYearPlanStateData>;
};

export type ProductionYearPlanPlannedLikeDataInput = {
  compProductionItemId: Scalars['String']['input'];
  percent: Scalars['Int']['input'];
  shiftWeeks: Scalars['Int']['input'];
};

/**
 * A site's production year plan as the productionYearPlan query and the setProductionYearPlan*
 * mutations return it. items lists only items with a week above 0 or a plannedLike, and
 * weeks lists only weeks above 0, in isoWeek order.
 */
export type ProductionYearPlanStateData = {
  __typename?: 'ProductionYearPlanStateData';
  isoYear: Scalars['Int']['output'];
  items: Array<ProductionYearPlanItemData>;
  productionPlanId?: Maybe<Scalars['String']['output']>;
  productionYearPlanId: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProductionYearPlanWeekData = {
  __typename?: 'ProductionYearPlanWeekData';
  isoWeek: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type ProgramDocument = {
  __typename?: 'ProgramDocument';
  id: Scalars['String']['output'];
  program: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type ProgramDocumentFilterInput = {
  and?: InputMaybe<Array<ProgramDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProgramDocumentFilterInput>>;
  program?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type ProgramDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  program?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type ProgramReplenishmentSettingsDocument = {
  __typename?: 'ProgramReplenishmentSettingsDocument';
  defaultTargetWeeksOfSupply: Scalars['Decimal']['output'];
  forwardDaysLastYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  inventoryTrailingDays: Scalars['Int']['output'];
  minUsableDaysThreshold?: Maybe<Scalars['Int']['output']>;
  program: Scalars['String']['output'];
  roundToFullCart: Scalars['Boolean']['output'];
  sellThroughThreshold?: Maybe<Scalars['Decimal']['output']>;
  shipmentIncrement: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  trailingDaysThisYear: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ProgramReplenishmentSettingsDocumentFilterInput = {
  and?: InputMaybe<Array<ProgramReplenishmentSettingsDocumentFilterInput>>;
  defaultTargetWeeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
  forwardDaysLastYear?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inventoryTrailingDays?: InputMaybe<IntOperationFilterInput>;
  minUsableDaysThreshold?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProgramReplenishmentSettingsDocumentFilterInput>>;
  program?: InputMaybe<StringOperationFilterInput>;
  roundToFullCart?: InputMaybe<BooleanOperationFilterInput>;
  sellThroughThreshold?: InputMaybe<DecimalOperationFilterInput>;
  shipmentIncrement?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  trailingDaysThisYear?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ProgramReplenishmentSettingsDocumentSortInput = {
  defaultTargetWeeksOfSupply?: InputMaybe<SortEnumType>;
  forwardDaysLastYear?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inventoryTrailingDays?: InputMaybe<SortEnumType>;
  minUsableDaysThreshold?: InputMaybe<SortEnumType>;
  program?: InputMaybe<SortEnumType>;
  roundToFullCart?: InputMaybe<SortEnumType>;
  sellThroughThreshold?: InputMaybe<SortEnumType>;
  shipmentIncrement?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  trailingDaysThisYear?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ProgramWindowConfigDataInput = {
  minUsableDaysThreshold?: InputMaybe<Scalars['Int']['input']>;
  program: Scalars['String']['input'];
  sellThroughThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  trailingDaysThisYear?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramWindowConfigStateData = {
  __typename?: 'ProgramWindowConfigStateData';
  minUsableDaysThreshold?: Maybe<Scalars['Int']['output']>;
  program: Scalars['String']['output'];
  sellThroughThreshold?: Maybe<Scalars['Decimal']['output']>;
  trailingDaysThisYear?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type ProgramsConnection = {
  __typename?: 'ProgramsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProgramsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProgramDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProgramsEdge = {
  __typename?: 'ProgramsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProgramDocument;
};

export enum ProjectionHealth {
  Error = 'ERROR',
  Running = 'RUNNING',
  Stopped = 'STOPPED'
}

export type ProjectionHealthOperationFilterInput = {
  eq?: InputMaybe<ProjectionHealth>;
  in?: InputMaybe<Array<ProjectionHealth>>;
  neq?: InputMaybe<ProjectionHealth>;
  nin?: InputMaybe<Array<ProjectionHealth>>;
};

export type ProjectionStatusDocument = {
  __typename?: 'ProjectionStatusDocument';
  id: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lastProcessedPosition?: Maybe<Scalars['Long']['output']>;
  lastUpdated: Scalars['DateTime']['output'];
  projectionName: Scalars['String']['output'];
  status: ProjectionHealth;
};

export type ProjectionStatusDocumentFilterInput = {
  and?: InputMaybe<Array<ProjectionStatusDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastError?: InputMaybe<StringOperationFilterInput>;
  lastProcessedPosition?: InputMaybe<LongOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProjectionStatusDocumentFilterInput>>;
  projectionName?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ProjectionHealthOperationFilterInput>;
};

export type ProjectionStatusDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  lastError?: InputMaybe<SortEnumType>;
  lastProcessedPosition?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  projectionName?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type PromoteOtaRolloutRingInput = {
  fromRing: Scalars['Int']['input'];
  lineId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  rolloutId: Scalars['String']['input'];
};

export type PromotionRulePayload = {
  __typename?: 'PromotionRulePayload';
  errors?: Maybe<Array<ValidationError>>;
  promotionRule?: Maybe<PromotionRuleStateData>;
};

export type PromotionRuleStateData = {
  __typename?: 'PromotionRuleStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  linkedItemIds: Array<Scalars['String']['output']>;
  linkedLocationIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  promotionRuleId: Scalars['String']['output'];
  quantityFloor: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: PromotionRuleStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum PromotionRuleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

/** One line of an open, uninvoiced sales order. Every quantity is in eaches, the unit the order bills in. */
export type ProrateGridLine = {
  __typename?: 'ProrateGridLine';
  /**
   * Eaches acknowledged. A line acknowledged or corrected on its own since 31 August 2026 reads the eaches it
   * was given; one acknowledged on its own before then reads its ordered eaches. Any other line of an
   * Acknowledged or Picked order, or a line still carrying a figure from an earlier acknowledgement of its
   * whole order, reads its ordered eaches, because nothing has replaced the quantity it was ordered at. Null
   * only on a Submitted order's line that nobody has acknowledged. One kind of line reads differently from
   * the order, at any pack: a line acknowledged on its own between 2 and 31 August 2026 whose ordered
   * quantity was edited afterwards reads the new ordered eaches, while the order keeps the acknowledged
   * figure.
   */
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * Eaches allocated to the line from stock or by a make-to-order plan, 0 when none. It is the order's own
   * figure on a line of one each per unit, and on a line placed in eaches until more of the item is merged
   * into it; after such a merge it can differ from the order's by less than one pack until the order's
   * allocation next changes. On a line counted in units of a larger pack it can differ from the order's by
   * less than one pack after part of an allocation is released, after a make-to-order plan is cut, or when
   * the line holds two plans or both stock and a plan. Allocations made before 31 August 2026 are counted
   * from stock alone, so a make-to-order plan that old reads 0, and part of such an allocation released
   * since then is missing.
   */
  allocatedEaches: Scalars['Int']['output'];
  /** The customer. */
  customerId: Scalars['String']['output'];
  /** The customer's name. */
  customerName: Scalars['String']['output'];
  /** When the customer expects delivery. */
  expectedDeliveryDate: Scalars['DateTime']['output'];
  /** The line's General note, null when none. */
  generalNote?: Maybe<Scalars['String']['output']>;
  /** The item. */
  itemId: Scalars['String']['output'];
  /** The line. */
  lineItemId: Scalars['UUID']['output'];
  /** The line number on the order. */
  lineNumber: Scalars['Int']['output'];
  /**
   * True when the line itself says make-to-order, or states no source on a produce-allocate order, or a
   * make-to-order plan holds a live reservation for it: one that is Reserved, ReadyHandedOff or
   * ProducedPegged. A cancelled or adjusted reservation, or a manual allocation of an existing lot, does not
   * count. A line that states no source follows the order's produce-allocate flag as it stands now, which can
   * differ from how the order resolved the line when it was added if the flag has been edited since.
   */
  makeToOrder: Scalars['Boolean']['output'];
  /** The order. */
  orderId: Scalars['String']['output'];
  /** The order number. */
  orderNumber: Scalars['String']['output'];
  /** Submitted, Acknowledged or Picked. */
  orderStatus: OrderStatus;
  /**
   * Eaches ordered, counted the way the order bills them. Prorating never changes it. A line added before 31
   * August 2026 whose ordered units were recorded as zero shows its stored ordered quantity, which the order
   * does not bill.
   */
  orderedQuantity: Scalars['Int']['output'];
  /** The line's override price, null when none. */
  overridePrice?: Maybe<Scalars['Decimal']['output']>;
  /** The planned ship date, null until set. */
  plannedShipDate?: Maybe<Scalars['DateTime']['output']>;
  /** The line's price. */
  price: Scalars['Decimal']['output'];
};

/**
 * The prorate grid's read: one entry per requested item, one entry per open order line for those items,
 * and whether either half is partial for this caller.
 */
export type ProrateGridPayload = {
  __typename?: 'ProrateGridPayload';
  /** The open order lines, soonest expected delivery first, then order number compared as text, then line number. */
  lines: Array<ProrateGridLine>;
  /**
   * True when the caller sees only some of the tenant's orders (assigned customers, a route or a salesperson),
   * so lines on orders the caller cannot see are missing from the list.
   */
  linesLimitedByScope: Scalars['Boolean']['output'];
  /** True when on hand counts only the stock at the caller's assigned sites. */
  onHandLimitedBySite: Scalars['Boolean']['output'];
  /** One entry per requested item, in the order requested. */
  sizes: Array<ProrateGridSize>;
  /** True when more lines matched than the cap allows, so the list is incomplete. */
  truncatedByLimit: Scalars['Boolean']['output'];
};

/** One requested item with the stock the caller may see. */
export type ProrateGridSize = {
  __typename?: 'ProrateGridSize';
  /**
   * Eaches of the on-hand figure allocated to orders whose lines are not in the returned lines, such as
   * quotes, drafts, orders that failed to sync and orders the caller cannot see. Counted on the same stock
   * rows as on hand, so a caller limited by site sees only the holds at their own sites.
   */
  heldForOtherOrdersEaches: Scalars['Int']['output'];
  /** The item. */
  itemId: Scalars['String']['output'];
  /** The item's name, empty when the item is not found. */
  itemName: Scalars['String']['output'];
  /** Eaches on hand across every location and grade the caller may see, customer ship-to stock excluded. */
  onHandEaches: Scalars['Int']['output'];
  /** The item's SKU, empty when the item is not found. */
  sku: Scalars['String']['output'];
};

/** The changes to one order's lines. */
export type ProrateOrderDataInput = {
  /** The lines to change, each named once. */
  lines: Array<ProrateOrderLineDataInput>;
  /** The order. */
  orderId: Scalars['String']['input'];
};

/**
 * The changes to one order line. Only the fields that are sent are considered: a field left out keeps
 * the value the line already has, and a field sent with the value the line already has is not written
 * again. The ordered quantity is never changed.
 */
export type ProrateOrderLineDataInput = {
  /**
   * The quantity to acknowledge, in EACHES: a whole number of 0 or more, never a count of trays, flats
   * or other shipping units. The line is billed for exactly the eaches stated, and its shipping units
   * are rounded up from them, so 37 on a tray of 15 is 3 trays to pick and 37 eaches billed. Leave it
   * out to keep the line's acknowledged quantity. An acknowledged quantity cannot be cleared, so an
   * explicit null fails the order. Allocations above the new quantity are released, and a line
   * acknowledged at 0 bills nothing.
   */
  acknowledgedQuantity?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The line's General note. Leave it out to keep the note as it is; send an explicit null, an empty
   * text, or blank space only, to clear it.
   */
  generalNote?: InputMaybe<Scalars['String']['input']>;
  /** The line to change. It must match exactly one line of the order. */
  lineItemId: Scalars['UUID']['input'];
  /**
   * The override price, 0 or more. Leave it out to keep the line's price as it is; send an explicit
   * null to clear the override, so the line goes back to its catalog price.
   */
  overridePrice?: InputMaybe<Scalars['Decimal']['input']>;
};

/** One order line as the save left it, read back from the order itself. */
export type ProrateOrderLineResult = {
  __typename?: 'ProrateOrderLineResult';
  /**
   * The line's acknowledged quantity in EACHES: the eaches the line was acknowledged at, which is what this
   * save writes and what a value sent for the line is compared with, so this figure sent back unchanged is no
   * change. A line acknowledged without a quantity of its own (its order was acknowledged or picked by a status
   * change, or acknowledged without naming it) reads its ordered eaches, whatever acknowledged figure it
   * carries. Null only for a line of a Submitted order that nobody has acknowledged.
   */
  acknowledgedQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * The EACHES still allocated to the line: the sum of the order's allocations for it, so it is never a
   * count of shipping units and never rounded up to whole ones.
   */
  allocatedEaches: Scalars['Int']['output'];
  /** The line's General note. Null when the line has none. */
  generalNote?: Maybe<Scalars['String']['output']>;
  /** The line. */
  lineItemId: Scalars['UUID']['output'];
  /** The line's override price. Null when the line bills its catalog price. */
  overridePrice?: Maybe<Scalars['Decimal']['output']>;
};

/** Input to prorateOrderLines: every order the prorate grid changed, saved in one call. */
export type ProrateOrderLinesInput = {
  /**
   * The orders to save, at most 1,000, each named once. They are saved one at a time in the order
   * supplied, and each comes back with its own outcome.
   */
  orders: Array<ProrateOrderDataInput>;
};

/**
 * The result of a prorate save: one result per order id sent, in the order they were first sent. A
 * save that could not start at all (more orders than one call accepts, or a caller that may not
 * prorate) returns errors with no results. A save that runs out of time still returns a
 * result for every order: the ones it did not reach are SKIPPED with NOT_ATTEMPTED, nothing
 * was written to them, and they can be sent again. A cancelled save returns the same and adds a
 * batch-cancelled error. Anything that goes wrong on a single order is reported on that order's own
 * result and never touches the rest.
 */
export type ProrateOrderLinesPayload = {
  __typename?: 'ProrateOrderLinesPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<ProrateOrderResult>;
};

/** What a prorate save did to one order. */
export enum ProrateOrderOutcome {
  /**
   * The order's changes could not all be saved. message says why, names the line whose write did
   * not complete, and lists which of the values sent the order now holds and which it does not.
   */
  Failed = 'FAILED',
  /** Every change sent for the order was written. */
  Saved = 'SAVED',
  /** The order was left exactly as it was. skipReason and message say why. */
  Skipped = 'SKIPPED'
}

/**
 * The outcome for one order of a prorate save. Every order id sent yields exactly one of these,
 * whatever happened to it: one order failing never removes another order's result.
 */
export type ProrateOrderResult = {
  __typename?: 'ProrateOrderResult';
  /**
   * The lines sent for this order, as the order holds them once the save is done with it. Empty when
   * the order could not be read.
   */
  lines: Array<ProrateOrderLineResult>;
  /**
   * Set when outcome is SKIPPED or FAILED: why, in words. On a failure it also
   * names the line whose write did not complete and says which of the values sent the order now holds.
   * It says that nothing was written only when that is known.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** The order id as it was sent, so the caller can match results to its rows. */
  orderId: Scalars['String']['output'];
  /** The order's number. Null when the order could not be read. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** What the save did to this order. */
  outcome: ProrateOrderOutcome;
  /** Set only when outcome is SKIPPED. */
  skipReason?: Maybe<ProrateOrderSkipReason>;
  /**
   * The order's status once the save is done with it. A save never changes it. Null when the order
   * could not be read.
   */
  status?: Maybe<OrderStatus>;
};

/**
 * Why a prorate save left a whole order alone. Every order that is not saved comes back with one of
 * these, or with a failure message: a save never drops an order silently.
 */
export enum ProrateOrderSkipReason {
  /** The order is a credit. Credits are not prorated. */
  CreditOrder = 'CREDIT_ORDER',
  /** The id is a master order. Master orders are not prorated. */
  MasterOrder = 'MASTER_ORDER',
  /**
   * The save stopped before it reached this order: it had used up the two and a half minutes one save
   * may spend starting orders, or the request was cancelled. Nothing was written to the order. Send it
   * again; the orders already saved come back as NO_CHANGES if they are sent again with it.
   */
  NotAttempted = 'NOT_ATTEMPTED',
  /** Every value sent for the order already matches it, so there was nothing to write. */
  NoChanges = 'NO_CHANGES',
  /** The order has an invoice that has not been voided, so what it bills may no longer move. */
  OrderInvoiced = 'ORDER_INVOICED',
  /** No order with this id is visible to the caller under this tenant. */
  OrderNotFound = 'ORDER_NOT_FOUND',
  /**
   * The order's status is outside the prorate window. Only Submitted, Acknowledged and Picked orders
   * are prorated. An Open or Initialized order is a draft: one that was never submitted, or one that was
   * and has since been edited, which returns it to Open until it is submitted again. An order that has
   * shipped, closed, been cancelled or deleted, or is held for a sync error, may no longer be changed
   * here.
   */
  OrderStatusNotProratable = 'ORDER_STATUS_NOT_PRORATABLE'
}

/**
 * What an ordered-quantity edit under a prorated acknowledgement was refused for, in eaches (the figures the
 * order line stores and bills): the quantity the line is acknowledged at, and the ordered quantity the edit
 * asked for. Re-sending the same edit with prorateAcknowledgedToNewQuantity set prorates the line to
 * requestedQuantity and saves the edit in one request.
 */
export type ProratedAcknowledgementRefusalData = {
  __typename?: 'ProratedAcknowledgementRefusalData';
  acknowledgedQuantity: Scalars['Int']['output'];
  requestedQuantity: Scalars['Int']['output'];
};

/**
 * What a guest's Pay click got: Stripe's hosted Checkout URL, the lookup's own answer for a token that opens nothing
 * payable, or a typed refusal.
 */
export type PublicInvoiceCheckoutStartPayload = {
  __typename?: 'PublicInvoiceCheckoutStartPayload';
  /**
   * The hosted Checkout URL to redirect to; set only when the start succeeded. Pressing Pay again while that session is
   * still open returns the same URL, or a newly priced one.
   */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /**
   * For an EXPIRED or INVALID token, the lookup's own answer: the grower with no invoice data, or the single invalid
   * answer. Null for an ACTIVE token.
   */
  payLink?: Maybe<PublicInvoicePayLink>;
  /** Why an ACTIVE token's start was refused; null otherwise. */
  refusal?: Maybe<InvoiceCheckoutRefusal>;
  /** ACTIVE, EXPIRED or INVALID, exactly as publicInvoicePayLink answers the same token at the same moment. */
  tokenState: PublicInvoicePayLinkTokenState;
};

/**
 * What an anonymous holder of a pay-link token may see: who is asking to be paid, and the one invoice the token
 * opens while it is active. Nothing else about the tenant, the customer or any other invoice is reachable from
 * this type.
 */
export type PublicInvoicePayLink = {
  __typename?: 'PublicInvoicePayLink';
  /** Who is asking to be paid, with their contact details; null when the token is INVALID. */
  grower?: Maybe<PublicInvoicePayLinkGrower>;
  /** The invoice the token opens; null unless the token is ACTIVE. */
  invoice?: Maybe<PublicInvoicePayLinkInvoice>;
  /**
   * Whether the holder of an EXPIRED token can ask for a new link to be emailed to the address on file, through
   * requestInvoicePayLinkResend. False for an ACTIVE or INVALID token, and for an expired one whose invoice cannot be
   * emailed: online payments switched off, invoice emails turned off for the customer or order, or no address on
   * file.
   */
  newLinkAvailable: Scalars['Boolean']['output'];
  /**
   * Whether the holder can pay this invoice online right now: true only when the token is ACTIVE, the grower's online
   * invoice payments are switched on, the grower's Stripe account is ready to take a payment, and this invoice may be
   * paid online.
   */
  onlinePaymentAvailable: Scalars['Boolean']['output'];
  /** ACTIVE, EXPIRED or INVALID. */
  tokenState: PublicInvoicePayLinkTokenState;
};

/** The grower's public identity and contact details, as their invoices print them. */
export type PublicInvoicePayLinkGrower = {
  __typename?: 'PublicInvoicePayLinkGrower';
  /** The grower's trading name. */
  displayName: Scalars['String']['output'];
  /** The grower's contact email, or null when none is set. */
  email?: Maybe<Scalars['String']['output']>;
  /** The grower's portal logo, or null when none is set. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The grower's contact phone number, or null when none is set. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The grower's portal brand colour, or null when none is set. */
  primaryColorHex?: Maybe<Scalars['String']['output']>;
};

/** The one invoice an active pay link opens. */
export type PublicInvoicePayLinkInvoice = {
  __typename?: 'PublicInvoicePayLinkInvoice';
  /** Whether the grower can take an online payment right now, and the ways Checkout would offer to pay. */
  availability: InvoicePaymentAvailability;
  /** The ISO-4217 currency the invoice is billed in. */
  currency: Scalars['String']['output'];
  /** The date payment is due. */
  dueDate: Scalars['DateTime']['output'];
  /** The date the invoice was issued. */
  invoiceDate: Scalars['DateTime']['output'];
  /** The invoice's id. */
  invoiceId: Scalars['String']['output'];
  /** The invoice number the customer was billed under. */
  invoiceNumber: Scalars['String']['output'];
  /** Why the latest online payment of this invoice failed, when it did; otherwise null. */
  lastFailure?: Maybe<Scalars['String']['output']>;
  /**
   * The status of the online payment holding this invoice, OPEN or PROCESSING, from either the pay link or the
   * portal; null when none holds it. OPEN can be resumed with Pay; PROCESSING means a payment is in progress.
   */
  openAttemptStatus?: Maybe<PaymentAttemptStatus>;
  /**
   * What a bank payment still clearing will pay toward this invoice; zero when none is clearing. Not yet in
   * postedBalance.
   */
  pendingAmount: Scalars['Decimal']['output'];
  /**
   * What the invoice still owes from the payments and adjustments recorded against it. Not a quote: an early-pay
   * discount or a late charge that has not been recorded is not in it.
   */
  postedBalance: Scalars['Decimal']['output'];
  /**
   * What paying the invoice in full online costs right now, with its discount and late charge, and until when that
   * price holds. Viewing it locks nothing: Pay prices the invoice again.
   */
  quote: InvoicePaymentQuote;
  /**
   * PAYABLE. A link opens only an invoice that still owes something, so an ACTIVE answer never carries another
   * status; the field shares the portal's status type.
   */
  status: CustomerInvoiceStatus;
  /** What the invoice billed, after any deposit credit. */
  total: Scalars['Decimal']['output'];
};

/** What a pay-link token opens: its invoice, a page to ask for a new link, or nothing. */
export enum PublicInvoicePayLinkTokenState {
  /** The token is the current one of a live link, and its invoice can be paid. */
  Active = 'ACTIVE',
  /**
   * The token is the current one of a link that has run out, on an invoice that still owes something. The answer
   * names the grower so the holder can ask for a new link, and shows no invoice data.
   */
  Expired = 'EXPIRED',
  /**
   * The token opens nothing: malformed, unknown, revoked, replaced by a newer token, or for an invoice that has
   * been paid or voided. One value for all of them, so the answer says nothing about which.
   */
  Invalid = 'INVALID'
}

export type PublicUserInviteAcceptPayload = {
  __typename?: 'PublicUserInviteAcceptPayload';
  accepted: Scalars['Boolean']['output'];
  errors?: Maybe<Array<ValidationError>>;
  validity: UserInviteValidity;
};

/**
 * Public code-lookup payload. RecipientEmail is populated only when the code is valid, and
 * ChangePasswordId only when NextAction is SET_PASSWORD, which the server answers only for a login
 * this invitation's own send created and only while FusionAuth reports the stored token as still
 * redeemable. ChangePasswordId is the FusionAuth one-time set-password token the registration page
 * uses to set the password inline: single-use, scoped to this invitation's new login, and released
 * only to the holder of the (CSPRNG) invite code. For a reset or any other existing login the token
 * is never returned here, whatever the next action; it goes only to the login's own address by
 * email (SET_PASSWORD_FROM_EMAIL). Unknown and deleted codes both return NOT_FOUND so the anonymous
 * surface is not an enumeration oracle.
 */
export type PublicUserInvitePayload = {
  __typename?: 'PublicUserInvitePayload';
  changePasswordId?: Maybe<Scalars['String']['output']>;
  nextAction: UserInviteNextAction;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  validity: UserInviteValidity;
};

/** The staff route a worker publishes for its tenant. */
export type PublishOnboardingHelpRouteInput = {
  /** The intended audience in words, shown to the grower. At most 300 characters. */
  audience: Scalars['String']['input'];
  /** The channels the policy delivers through. */
  channels: Array<OnboardingHelpChannel>;
  /** Digest of the intended audience and destinations, excluding who currently belongs to them. */
  fingerprint: Scalars['String']['input'];
  /** The existing data-received staff-flow policy identity. */
  policyId: Scalars['String']['input'];
  /** The policy revision, 1 or more. */
  revision: Scalars['Int']['input'];
};

/** The result of a publish, or why it was refused. */
export type PublishOnboardingHelpRoutePayload = {
  __typename?: 'PublishOnboardingHelpRoutePayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<PublishOnboardingHelpRouteResult>;
};

/** What a publish recorded. */
export type PublishOnboardingHelpRouteResult = {
  __typename?: 'PublishOnboardingHelpRouteResult';
  /** Recorded now, or the same content was already published. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The route now published. */
  route: OnboardingHelpRouteDetails;
};

export type PublishOtaReleaseInput = {
  releaseId: Scalars['String']['input'];
};

/** Service-to-service publish input. One call per BulkWriteAsync batch. */
export type PublishRestockWorkQueueResultBatchInput = {
  calcDate: Scalars['DateTime']['input'];
  rows: Array<RestockWorkQueueResultBatchRowDataInput>;
  tenantId: Scalars['String']['input'];
};

export type PublishWhatsNewComingSoonInput = {
  /** Replaces the tenant's run-published Coming soon features; staff-edited ones stay. Every feature has comingSoon: true and tenantIds: [tenantId]. */
  features: Array<WhatsNewFeatureInput>;
  tenantId: Scalars['String']['input'];
};

/** Result of publishWhatsNewRelease and publishWhatsNewComingSoon. */
export type PublishWhatsNewPayload = {
  __typename?: 'PublishWhatsNewPayload';
  /** False when the stored features already matched the published list. */
  changed: Scalars['Boolean']['output'];
  /** Why the publish was refused, each with a code; null when it succeeded. */
  errors?: Maybe<Array<ValidationError>>;
  /** How many features the stored list holds, including the skipped ones. */
  featureCount: Scalars['Int']['output'];
  /** Keys left as they are because staff added or edited them in wsapi-admin. */
  skippedKeys: Array<Scalars['String']['output']>;
};

export type PublishWhatsNewReleaseInput = {
  /** Who approved this release's list. No approval, no list. */
  approvedBy: Scalars['String']['input'];
  /** The day the release reached production. */
  effectiveOn: Scalars['LocalDate']['input'];
  /** Every feature has comingSoon: false. */
  features: Array<WhatsNewFeatureInput>;
  label: Scalars['String']['input'];
  releaseNotesUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderAllocationDocument = {
  __typename?: 'PurchaseOrderAllocationDocument';
  created: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  items: Array<AllocationLineItemData>;
  orderId: Scalars['String']['output'];
  purchaseOrderId: Scalars['String']['output'];
  status: PurchaseOrderAllocationStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type PurchaseOrderAllocationDocumentFilterInput = {
  and?: InputMaybe<Array<PurchaseOrderAllocationDocumentFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfAllocationLineItemDataFilterInput>;
  or?: InputMaybe<Array<PurchaseOrderAllocationDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  purchaseOrderId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<PurchaseOrderAllocationStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type PurchaseOrderAllocationDocumentSortInput = {
  created?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  purchaseOrderId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type PurchaseOrderAllocationPayload = {
  __typename?: 'PurchaseOrderAllocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  purchaseOrderAllocation?: Maybe<PurchaseOrderAllocationDocument>;
};

export enum PurchaseOrderAllocationStatus {
  Active = 'ACTIVE',
  Deallocated = 'DEALLOCATED'
}

export type PurchaseOrderAllocationStatusOperationFilterInput = {
  eq?: InputMaybe<PurchaseOrderAllocationStatus>;
  in?: InputMaybe<Array<PurchaseOrderAllocationStatus>>;
  neq?: InputMaybe<PurchaseOrderAllocationStatus>;
  nin?: InputMaybe<Array<PurchaseOrderAllocationStatus>>;
};

/** A connection to a list of items. */
export type PurchaseOrderAllocationsConnection = {
  __typename?: 'PurchaseOrderAllocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PurchaseOrderAllocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PurchaseOrderAllocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PurchaseOrderAllocationsEdge = {
  __typename?: 'PurchaseOrderAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PurchaseOrderAllocationDocument;
};

/**
 * One purchase order linked to a production job, with that order's status and the quantity still owed for
 * this job's own lines. A job can link to several purchase orders, and one purchase order can carry lines
 * for several jobs — this entry reports only the portion of that order linked to this job.
 */
export type PurchaseOrderForJobData = {
  __typename?: 'PurchaseOrderForJobData';
  /**
   * The quantity still owed to this job across this purchase order's lines: the sum, over every line this job
   * linked to, of QuantityOrdered - QuantityReceived, clamped at zero per line so an over-received line
   * never contributes a negative amount.
   */
  openQuantity: Scalars['Decimal']['output'];
  /** The linked purchase order's identifier. */
  purchaseOrderId: Scalars['String']['output'];
  /** The linked purchase order's display number. */
  purchaseOrderNumber: Scalars['String']['output'];
  /** The linked purchase order's current lifecycle status. */
  status: VendorPurchaseOrderStatus;
};

/** Names one record for the retention purge, by its class and its own document id. */
export type PurgeMigrationRecordInput = {
  recordClass: MigrationRetentionClass;
  recordId: Scalars['String']['input'];
};

/** How the client that registered a push subscription was being displayed. */
export enum PushDisplayMode {
  /** Running in an ordinary browser tab. */
  Browser = 'BROWSER',
  /** Running as an installed app in its own window. */
  Standalone = 'STANDALONE'
}

/** The platform family of the client that registered a push subscription. */
export enum PushPlatform {
  /** Android. */
  Android = 'ANDROID',
  /** A desktop browser. */
  Desktop = 'DESKTOP',
  /** iPhone or iPad. */
  Ios = 'IOS'
}

/** How many devices one install identity holds. */
export type PushSubscriptionAppKeyCount = {
  __typename?: 'PushSubscriptionAppKeyCount';
  /** The install identity; null counts rows that never reported one. */
  appKey?: Maybe<Scalars['String']['output']>;
  /** Devices enrolled under it. */
  count: Scalars['Int']['output'];
};

/**
 * One browser's Web Push subscription — the endpoint the push service hands out for a single device,
 * and the two keys a message to it must be encrypted with. What the dispatch worker addresses the
 * push channel by, the way a mailbox addresses the email channel.
 */
export type PushSubscriptionDocument = {
  __typename?: 'PushSubscriptionDocument';
  /**
   * Which installed app registered this device: a module key such as material, or
   * worksuite for the root install. Null for a row registered by a client that predates install
   * identity.
   */
  appKey?: Maybe<Scalars['String']['output']>;
  /**
   * The device's auth secret, base64url, as the browser reported it. The other half of the
   * encryption inputs, and likewise never interpreted here.
   */
  auth: Scalars['String']['output'];
  /** When this device first registered. Never rewritten by a re-registration. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Whether the registering client was running as an installed app or in a browser tab. Null when the
   * client did not say.
   */
  displayMode?: Maybe<PushDisplayMode>;
  /**
   * The push service URL a message for this device is POSTed to. The device's identity, and the
   * handle the PWA and the dispatch worker both address a removal by.
   */
  endpoint: Scalars['String']['output'];
  /** The row's identifier, derived from Endpoint and nothing else. */
  id: Scalars['String']['output'];
  /**
   * When this device last registered, refreshed on every registration. It is how stale a
   * subscription is known to be, and what the read-time prune measures the retention window against.
   */
  lastSeenAt: Scalars['DateTime']['output'];
  /**
   * The device's P-256 ECDH public key, base64url, as the browser reported it. Half of what a
   * payload for this device is encrypted with; the worker passes it to the Web Push library
   * verbatim and this side never interprets it.
   */
  p256dh: Scalars['String']['output'];
  /** The platform the registering client reported. Null when the client did not say. */
  platform?: Maybe<PushPlatform>;
  /** The tenant the device was last registered under. Every read filters on it. */
  tenantId: Scalars['String']['output'];
  /**
   * Who the device was last registered by: their WorkSuiteUser DIRECTORY email, normalised exactly
   * as NotificationDocument.RecipientEmail is.
   */
  userEmail: Scalars['String']['output'];
};

/** Result of registering a device. */
export type PushSubscriptionPayload = {
  __typename?: 'PushSubscriptionPayload';
  /** Populated when the subscription was rejected or the write failed. */
  errors?: Maybe<Array<ValidationError>>;
  /** The registration as it now stands. */
  subscription?: Maybe<PushSubscriptionDocument>;
};

/**
 * One try at a test, as returned to the dashboard.
 *
 * Named without the Result suffix the older types in this file carry, and deliberately so:
 * the v2 SDL is pinned verbatim in four downstream tasks, and HotChocolate takes the GraphQL type
 * name straight from the C# one. The suffix would rename the published type.
 */
export type QaAttempt = {
  __typename?: 'QaAttempt';
  durationMs: Scalars['Long']['output'];
  error?: Maybe<Scalars['String']['output']>;
  errorSignature?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  transient?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * One try at a test. Kept individually rather than rolled up because flakiness is a SEQUENCE — a
 * failure followed by a pass — and a rollup that reports only the final outcome cannot distinguish
 * a scenario that passed first time from one that needed three goes.
 */
export type QaAttemptInput = {
  durationMs: Scalars['Long']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  /** Normalized first line of the error — the key later slices group failures by. */
  errorSignature?: InputMaybe<Scalars['String']['input']>;
  /** 0-based position in the retry sequence. */
  index: Scalars['Int']['input'];
  /**
   * passed | failed | skipped | timedOut | interrupted — the ATTEMPT vocabulary,
   * which is not the flow-test one.
   */
  status: Scalars['String']['input'];
  /**
   * True when errorSignature matched the publisher's
   * catalog/transient-signatures.json. Stored verbatim and NOT read by status derivation:
   * deciding which failures a release may ignore is Release QA 5's job, and folding that judgment
   * into the derived status here would make it unappealable.
   */
  transient?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One component observed deployed on the target when the run launched. */
export type QaComponentVersion = {
  __typename?: 'QaComponentVersion';
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** One deployed component observed on the target, e.g. wsapi at a build number. */
export type QaComponentVersionInput = {
  name: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/**
 * What the run launched against. Null on a run stored before the v2 contract — the schema says
 * nullable rather than inventing a target for history that never recorded one.
 */
export type QaExecutionTarget = {
  __typename?: 'QaExecutionTarget';
  baseUrl: Scalars['String']['output'];
  buildId: Scalars['String']['output'];
  buildReason: Scalars['String']['output'];
  components: Array<QaComponentVersion>;
  environment: Scalars['String']['output'];
  pipelineDefinitionId?: Maybe<Scalars['Int']['output']>;
  targetParameter?: Maybe<Scalars['String']['output']>;
  testRepoBranch: Scalars['String']['output'];
  testRepoCommit: Scalars['String']['output'];
};

/**
 * What the run actually launched against, captured by the publisher at launch time.
 *
 * The whole point of the v2 contract: a green run only certifies a release if we can say WHICH
 * build of WHICH environment it exercised. Before this, a run recorded its suite and environment
 * and nothing else, so a nightly that fired while a deploy was mid-flight was indistinguishable
 * from one that ran against the finished candidate.
 */
export type QaExecutionTargetInput = {
  /** The launched target, e.g. https://worksuite.silverfern.red. */
  baseUrl: Scalars['String']['input'];
  /**
   * ADO build id for pipeline runs — equal to the run's id — or the
   * local run id. Duplicated rather than inferred so the target snapshot stays self-describing
   * when it is read apart from its run.
   */
  buildId: Scalars['String']['input'];
  /**
   * ADO Build.Reason verbatim — Schedule | Manual | ResourceTrigger | IndividualCI |
   * Local | …. Stored as sent rather than mapped onto the existing trigger vocabulary,
   * because ADO owns this value and a mapping table here would rot the first time ADO adds one.
   */
  buildReason: Scalars['String']['input'];
  /** Observed deployed components when known; may be empty or absent. */
  components?: InputMaybe<Array<QaComponentVersionInput>>;
  /** stage or red, validated exactly like the run's own environment. */
  environment: Scalars['String']['input'];
  /** 102 or 112; null for local runs. */
  pipelineDefinitionId?: InputMaybe<Scalars['Int']['input']>;
  /** The worksuiteTarget parameter as launched; null when the pipeline has none. */
  targetParameter?: InputMaybe<Scalars['String']['input']>;
  testRepoBranch: Scalars['String']['input'];
  testRepoCommit: Scalars['String']['input'];
};

/**
 * One spec file's results. Video and Screenshots are RELATIVE blob
 * paths within the qa-media container — the publisher uploads the files itself and sends
 * only their paths, so large videos never travel through GraphQL.
 */
export type QaFlowInput = {
  durationSec: Scalars['Int']['input'];
  module: Scalars['String']['input'];
  screenshots: Array<Scalars['String']['input']>;
  spec: Scalars['String']['input'];
  status: Scalars['String']['input'];
  tests: Array<QaFlowTestInput>;
  title: Scalars['String']['input'];
  video?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One spec file's results, with Video/Screenshots already composed into
 * absolute URLs so the client never has to know the storage layout.
 */
export type QaFlowResult = {
  __typename?: 'QaFlowResult';
  durationSec: Scalars['Int']['output'];
  module: Scalars['String']['output'];
  screenshots: Array<Scalars['String']['output']>;
  spec: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tests: Array<QaFlowTestResult>;
  title: Scalars['String']['output'];
  video?: Maybe<Scalars['String']['output']>;
};

/**
 * One test result submitted by the publisher. There is no isNew field: regression status is
 * computed server-side at ingest, so a publisher cannot assert it.
 */
export type QaFlowTestInput = {
  /**
   * Every attempt in order, retries included. Null means one attempt equal to
   * status — the shape every pre-v2 publisher sends, normalized on the way in during scenario
   * derivation so nothing downstream has to special-case it.
   */
  attempts?: InputMaybe<Array<QaAttemptInput>>;
  /** Relative blob path of this test's cut video segment, if one was produced. */
  clip?: InputMaybe<Scalars['String']['input']>;
  durationMs: Scalars['Long']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /**
   * Stable id from the coverage catalog, e.g. ORD-SUBMIT-01. Null for untagged tests,
   * which stay invisible to scenario derivation — a test with no catalog identity cannot prove
   * or disprove a scenario the release is judged on.
   */
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  skipReason?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  videoStart?: InputMaybe<Scalars['Float']['input']>;
  /** Workflow the scenario belongs to in the catalog. Carried through unmodified. */
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

/** One test within a flow, as returned to the dashboard. */
export type QaFlowTestResult = {
  __typename?: 'QaFlowTestResult';
  /** Every attempt in order, retries included. */
  attempts: Array<QaAttempt>;
  /** Absolute URL of this failing test's cut video segment. */
  clip?: Maybe<Scalars['String']['output']>;
  durationMs: Scalars['Long']['output'];
  error?: Maybe<Scalars['String']['output']>;
  isNew: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Coverage-catalog id this test proves. Null when the test is untagged. */
  scenarioId?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  videoStart?: Maybe<Scalars['Float']['output']>;
  /** Catalog workflow the scenario belongs to. */
  workflowId?: Maybe<Scalars['String']['output']>;
};

/**
 * Whether this run's results are fit to render, and why not when they are not.
 *
 * Carries BSON attributes and legacy-answer initializers because, unlike the other result types
 * here, this one is materialized by the Mongo driver as well as by HotChocolate: the paged index
 * projects it inside QaTestRunSummaryResult, so the driver both reads the stored
 * string enum back and supplies these defaults when a legacy document has no publication element
 * to project. Detail reads never depend on them — they map through the detail path's own
 * defaults, which spell out the same answer — but a summary row of a
 * pre-v2 run has nothing else to fall back on, and defaulting mediaAvailable to
 * false there would tell the dashboard every historic run had lost its video.
 */
export type QaPublication = {
  __typename?: 'QaPublication';
  mediaAvailable: Scalars['Boolean']['output'];
  reason?: Maybe<QaPublicationReason>;
  status: QaPublicationStatus;
};

/**
 * Whether this run's results are fit to render, and why not when they are not.
 *
 * Carries BSON attributes and legacy-answer initializers because, unlike the other result types
 * here, this one is materialized by the Mongo driver as well as by HotChocolate: the paged index
 * projects it inside QaTestRunSummaryResult, so the driver both reads the stored
 * string enum back and supplies these defaults when a legacy document has no publication element
 * to project. Detail reads never depend on them — they map through the detail path's own
 * defaults, which spell out the same answer — but a summary row of a
 * pre-v2 run has nothing else to fall back on, and defaulting mediaAvailable to
 * false there would tell the dashboard every historic run had lost its video.
 */
export type QaPublicationFilterInput = {
  and?: InputMaybe<Array<QaPublicationFilterInput>>;
  mediaAvailable?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<QaPublicationFilterInput>>;
  reason?: InputMaybe<NullableOfQaPublicationReasonOperationFilterInput>;
  status?: InputMaybe<QaPublicationStatusOperationFilterInput>;
};

/**
 * Whether the publisher considers this run's results fit to render, and why not when it does not.
 * Absent means the legacy answer: published, with media.
 */
export type QaPublicationInput = {
  /**
   * False when videos and screenshots were dropped (a redaction failure, or a run that never got
   * far enough to record any). The dashboard uses it to explain missing media rather than
   * rendering dead play buttons.
   */
  mediaAvailable: Scalars['Boolean']['input'];
  /** Required when status is NOT_PUBLISHED; rejected at ingest otherwise. */
  reason?: InputMaybe<QaPublicationReason>;
  status: QaPublicationStatus;
};

/**
 * Why a run was not published. Required whenever status is NOT_PUBLISHED — a row with no
 * results and no reason is indistinguishable from a publisher bug.
 */
export enum QaPublicationReason {
  /** The run was cancelled before it finished. */
  Canceled = 'CANCELED',
  /** The target environment was down or deliberately dark when the run launched. */
  DarkTarget = 'DARK_TARGET',
  /**
   * A prerequisite step failed, so the scenarios downstream of it never got the chance to run.
   * Distinct from every other reason because it changes derivation: an expected scenario with no
   * test is BLOCKED rather than NOT_RUN — the fan-out rule in scenario derivation.
   */
  PrerequisiteFailed = 'PREREQUISITE_FAILED',
  /** Results existed but the publish step itself failed. */
  PublishFailed = 'PUBLISH_FAILED',
  /** A newer candidate replaced the one this run was launched for. */
  Superseded = 'SUPERSEDED',
  /** Media or output carried content that had not been redacted. */
  Unredacted = 'UNREDACTED',
  /** The run completed but executed no tests at all. */
  ZeroTests = 'ZERO_TESTS'
}

/**
 * Whether this run's results are fit to render, and why not when they are not.
 *
 * Carries BSON attributes and legacy-answer initializers because, unlike the other result types
 * here, this one is materialized by the Mongo driver as well as by HotChocolate: the paged index
 * projects it inside QaTestRunSummaryResult, so the driver both reads the stored
 * string enum back and supplies these defaults when a legacy document has no publication element
 * to project. Detail reads never depend on them — they map through the detail path's own
 * defaults, which spell out the same answer — but a summary row of a
 * pre-v2 run has nothing else to fall back on, and defaulting mediaAvailable to
 * false there would tell the dashboard every historic run had lost its video.
 */
export type QaPublicationSortInput = {
  mediaAvailable?: InputMaybe<SortEnumType>;
  reason?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

/**
 * Whether a run's results are fit to render on the dashboard.
 *
 * Enums rather than the string vocabularies used elsewhere for test outcomes and environments:
 * those two mirror Playwright's and the deployment's own words and
 * must tolerate a value we have never seen, whereas publication is OUR concept with a closed set —
 * a publisher inventing a third state is a bug the schema should reject at the boundary.
 */
export enum QaPublicationStatus {
  /**
   * The run produced a row but no usable results. It is still stored so the dashboard shows the
   * attempt rather than a silent gap in the history strip.
   */
  NotPublished = 'NOT_PUBLISHED',
  /** Results are complete and trustworthy; the dashboard renders them normally. */
  Published = 'PUBLISHED'
}

export type QaPublicationStatusOperationFilterInput = {
  eq?: InputMaybe<QaPublicationStatus>;
  in?: InputMaybe<Array<QaPublicationStatus>>;
  neq?: InputMaybe<QaPublicationStatus>;
  nin?: InputMaybe<Array<QaPublicationStatus>>;
};

/** One run retention may delete: unpinned, with no future pinUntil, and older than the cutoff. */
export type QaRetentionCandidate = {
  __typename?: 'QaRetentionCandidate';
  /**
   * ADO build that produced the run, for its retention lease. Null for a run with no recorded
   * target whose id is not a build number, such as a local run: it has no build to lease.
   */
  adoBuildId?: Maybe<Scalars['String']['output']>;
  /** The run date, which retention compares against its cutoff. */
  dateUtc: Scalars['DateTime']['output'];
  /** The environment the run executed against. */
  environment: Scalars['String']['output'];
  /** The run id. */
  id: Scalars['String']['output'];
  /**
   * Every relative Blob path the run references (flow videos, test clips, screenshots), each
   * once. These are the blobs to delete with the run.
   */
  mediaPaths: Array<Scalars['String']['output']>;
  /** The suite that produced the run. */
  suite: Scalars['String']['output'];
};

/**
 * Result of a delete: each requested id is in exactly one of deletedIds or refusedIds, unless the
 * request failed, in which case both are empty and errors says why.
 */
export type QaRetentionPayload = {
  __typename?: 'QaRetentionPayload';
  deletedIds: Array<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  refusedIds: Array<Scalars['String']['output']>;
};

/**
 * Aggregate tallies submitted with a run. Sent by the publisher rather than derived here so the
 * dashboard reports exactly what Playwright reported, including outcomes wsapi does not model.
 */
export type QaRunCountsInput = {
  failed: Scalars['Int']['input'];
  flaky: Scalars['Int']['input'];
  passed: Scalars['Int']['input'];
  skipped: Scalars['Int']['input'];
};

/** Pass/fail/skip/flaky tallies for a run, as returned to the dashboard. */
export type QaRunCountsResult = {
  __typename?: 'QaRunCountsResult';
  /** Scenarios a failed prerequisite prevented from running. Always server-derived. */
  blocked: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  flaky: Scalars['Int']['output'];
  /** Expected scenarios that no test carried. Zero for a legacy run. */
  notRun: Scalars['Int']['output'];
  passed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

/** Pass/fail/skip/flaky tallies for a run, as returned to the dashboard. */
export type QaRunCountsResultFilterInput = {
  and?: InputMaybe<Array<QaRunCountsResultFilterInput>>;
  /** Scenarios a failed prerequisite prevented from running. Always server-derived. */
  blocked?: InputMaybe<IntOperationFilterInput>;
  failed?: InputMaybe<IntOperationFilterInput>;
  flaky?: InputMaybe<IntOperationFilterInput>;
  /** Expected scenarios that no test carried. Zero for a legacy run. */
  notRun?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<QaRunCountsResultFilterInput>>;
  passed?: InputMaybe<IntOperationFilterInput>;
  skipped?: InputMaybe<IntOperationFilterInput>;
};

/** Pass/fail/skip/flaky tallies for a run, as returned to the dashboard. */
export type QaRunCountsResultSortInput = {
  /** Scenarios a failed prerequisite prevented from running. Always server-derived. */
  blocked?: InputMaybe<SortEnumType>;
  failed?: InputMaybe<SortEnumType>;
  flaky?: InputMaybe<SortEnumType>;
  /** Expected scenarios that no test carried. Zero for a legacy run. */
  notRun?: InputMaybe<SortEnumType>;
  passed?: InputMaybe<SortEnumType>;
  skipped?: InputMaybe<SortEnumType>;
};

/**
 * One catalog scenario's derived outcome, with its evidence already composed into absolute URLs
 * — the same treatment a flow's evidence gets.
 */
export type QaScenarioResult = {
  __typename?: 'QaScenarioResult';
  attempts: Array<QaAttempt>;
  clip?: Maybe<Scalars['String']['output']>;
  /** True when the run's expected set named this scenario. */
  expected: Scalars['Boolean']['output'];
  flowTitle?: Maybe<Scalars['String']['output']>;
  scenarioId: Scalars['String']['output'];
  screenshots: Array<Scalars['String']['output']>;
  spec?: Maybe<Scalars['String']['output']>;
  status: QaScenarioStatus;
  testName?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
};

/**
 * The outcome of one catalog scenario in one run, derived server-side during scenario
 * derivation rather than asserted by the publisher.
 *
 * This is the release-readiness vocabulary, deliberately NOT Playwright's own status set. It
 * answers "did this scenario prove itself in this run" — which
 * is why it has words Playwright has no concept of: a scenario the catalog expected but that no
 * test carried is NOT_RUN, and one whose prerequisite failed is BLOCKED.
 * Neither is a Playwright outcome; both are the difference between a green run and a green release.
 */
export enum QaScenarioStatus {
  /** A prerequisite stopped it from being exercised — not evidence of a defect. */
  Blocked = 'BLOCKED',
  /** The last attempt failed, timed out or was interrupted. */
  Fail = 'FAIL',
  /** Failed and then passed within the same run's retries. */
  Flaky = 'FLAKY',
  /** Expected by the catalog, but no test in this run carried the scenario id. */
  NotRun = 'NOT_RUN',
  /** Every attempt passed. */
  Pass = 'PASS',
  /** Deliberately skipped for a reason other than a blocking prerequisite. */
  Skipped = 'SKIPPED'
}

/**
 * Result of an ingest, pin or unpin. Follows the repo's payload convention: Data on
 * success, Errors on a validation failure, never both.
 */
export type QaTestRunPayload = {
  __typename?: 'QaTestRunPayload';
  data?: Maybe<QaTestRunResult>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Full detail for a single run — the summary fields plus every flow. */
export type QaTestRunResult = {
  __typename?: 'QaTestRunResult';
  adoUrl?: Maybe<Scalars['String']['output']>;
  appBuild?: Maybe<Scalars['String']['output']>;
  /** Opaque relman candidate id. Null for red runs and no-release weekly runs. */
  candidateId?: Maybe<Scalars['String']['output']>;
  /** Commit sha of the coverage catalog the expected set came from. */
  catalogRevision?: Maybe<Scalars['String']['output']>;
  /** Ingest contract that wrote this run: 2, or null for a legacy run. */
  contractVersion?: Maybe<Scalars['Int']['output']>;
  counts: QaRunCountsResult;
  dateUtc: Scalars['DateTime']['output'];
  durationSec: Scalars['Int']['output'];
  /** Environment the run exercised — stage or red. */
  environment: Scalars['String']['output'];
  /** Scenarios the run was expected to exercise. Empty for a legacy run. */
  expectedScenarioIds: Array<Scalars['String']['output']>;
  flows: Array<QaFlowResult>;
  id: Scalars['String']['output'];
  ingestedAt: Scalars['DateTime']['output'];
  partial: Scalars['Boolean']['output'];
  /** Why the run was pinned. Null when it is not pinned. */
  pinReason?: Maybe<Scalars['String']['output']>;
  /** Kept until this instant even when not pinned indefinitely. */
  pinUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Kept indefinitely: retention never offers this run for deletion. */
  pinned: Scalars['Boolean']['output'];
  /** When the current pin was set. */
  pinnedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who set the current pin. */
  pinnedBy?: Maybe<Scalars['String']['output']>;
  /** Never null: a legacy run reads back as PUBLISHED with media available. */
  publication: QaPublication;
  result: Scalars['String']['output'];
  /** Derived per-scenario outcomes. Empty for a legacy run. */
  scenarios: Array<QaScenarioResult>;
  suite: Scalars['String']['output'];
  /** What the run launched against. Null on a legacy run. */
  target?: Maybe<QaExecutionTarget>;
  trigger: Scalars['String']['output'];
};

/**
 * One row of the paged run index — everything the dashboard's history strip and health tiles need
 * WITHOUT the Flows array. Runs carry a flow per spec file, each with its full test list, so
 * a run document is orders of magnitude larger than its summary; projecting flows away server-side
 * keeps the index cheap no matter how deep the history grows.
 */
export type QaTestRunSummaryResult = {
  __typename?: 'QaTestRunSummaryResult';
  adoUrl?: Maybe<Scalars['String']['output']>;
  appBuild?: Maybe<Scalars['String']['output']>;
  /** Opaque relman candidate id. Null for a legacy run, red runs and weekly runs. */
  candidateId?: Maybe<Scalars['String']['output']>;
  counts: QaRunCountsResult;
  dateUtc: Scalars['DateTime']['output'];
  durationSec: Scalars['Int']['output'];
  /** Environment the run exercised — stage or red. */
  environment: Scalars['String']['output'];
  /** Number of flows (spec files) in the run — the index's stand-in for the omitted array. */
  flowCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  partial: Scalars['Boolean']['output'];
  /** Kept until this instant even when not pinned indefinitely. */
  pinUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Kept indefinitely: retention never offers this run for deletion. */
  pinned: Scalars['Boolean']['output'];
  /**
   * Publication state, on the SUMMARY as well as the detail. The history strip and health board
   * page this type, so a NOT_PUBLISHED run can only render as one — rather than as an ordinary
   * row with a strange result string — if the state reaches them here. Never null: a
   * legacy document reads as PUBLISHED with media available.
   */
  publication: QaPublication;
  result: Scalars['String']['output'];
  suite: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

/**
 * One row of the paged run index — everything the dashboard's history strip and health tiles need
 * WITHOUT the Flows array. Runs carry a flow per spec file, each with its full test list, so
 * a run document is orders of magnitude larger than its summary; projecting flows away server-side
 * keeps the index cheap no matter how deep the history grows.
 */
export type QaTestRunSummaryResultFilterInput = {
  adoUrl?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<QaTestRunSummaryResultFilterInput>>;
  appBuild?: InputMaybe<StringOperationFilterInput>;
  /** Opaque relman candidate id. Null for a legacy run, red runs and weekly runs. */
  candidateId?: InputMaybe<StringOperationFilterInput>;
  counts?: InputMaybe<QaRunCountsResultFilterInput>;
  dateUtc?: InputMaybe<DateTimeOperationFilterInput>;
  durationSec?: InputMaybe<IntOperationFilterInput>;
  /** Environment the run exercised — stage or red. */
  environment?: InputMaybe<StringOperationFilterInput>;
  /** Number of flows (spec files) in the run — the index's stand-in for the omitted array. */
  flowCount?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<QaTestRunSummaryResultFilterInput>>;
  partial?: InputMaybe<BooleanOperationFilterInput>;
  /** Kept until this instant even when not pinned indefinitely. */
  pinUntil?: InputMaybe<DateTimeOperationFilterInput>;
  /** Kept indefinitely: retention never offers this run for deletion. */
  pinned?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Publication state, on the SUMMARY as well as the detail. The history strip and health board
   * page this type, so a NOT_PUBLISHED run can only render as one — rather than as an ordinary
   * row with a strange result string — if the state reaches them here. Never null: a
   * legacy document reads as PUBLISHED with media available.
   */
  publication?: InputMaybe<QaPublicationFilterInput>;
  result?: InputMaybe<StringOperationFilterInput>;
  suite?: InputMaybe<StringOperationFilterInput>;
  trigger?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One row of the paged run index — everything the dashboard's history strip and health tiles need
 * WITHOUT the Flows array. Runs carry a flow per spec file, each with its full test list, so
 * a run document is orders of magnitude larger than its summary; projecting flows away server-side
 * keeps the index cheap no matter how deep the history grows.
 */
export type QaTestRunSummaryResultSortInput = {
  adoUrl?: InputMaybe<SortEnumType>;
  appBuild?: InputMaybe<SortEnumType>;
  /** Opaque relman candidate id. Null for a legacy run, red runs and weekly runs. */
  candidateId?: InputMaybe<SortEnumType>;
  counts?: InputMaybe<QaRunCountsResultSortInput>;
  dateUtc?: InputMaybe<SortEnumType>;
  durationSec?: InputMaybe<SortEnumType>;
  /** Environment the run exercised — stage or red. */
  environment?: InputMaybe<SortEnumType>;
  /** Number of flows (spec files) in the run — the index's stand-in for the omitted array. */
  flowCount?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  partial?: InputMaybe<SortEnumType>;
  /** Kept until this instant even when not pinned indefinitely. */
  pinUntil?: InputMaybe<SortEnumType>;
  /** Kept indefinitely: retention never offers this run for deletion. */
  pinned?: InputMaybe<SortEnumType>;
  /**
   * Publication state, on the SUMMARY as well as the detail. The history strip and health board
   * page this type, so a NOT_PUBLISHED run can only render as one — rather than as an ordinary
   * row with a strange result string — if the state reaches them here. Never null: a
   * legacy document reads as PUBLISHED with media available.
   */
  publication?: InputMaybe<QaPublicationSortInput>;
  result?: InputMaybe<SortEnumType>;
  suite?: InputMaybe<SortEnumType>;
  trigger?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type QaTestRunsConnection = {
  __typename?: 'QaTestRunsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<QaTestRunsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<QaTestRunSummaryResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type QaTestRunsEdge = {
  __typename?: 'QaTestRunsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: QaTestRunSummaryResult;
};

/** One watcher liveness heartbeat as published to the QA dashboard and the watchdog. */
export type QaWatcherHeartbeat = {
  __typename?: 'QaWatcherHeartbeat';
  /** Non-null list per the pin ([String!]!) — empty rather than null when clean. */
  errors: Array<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /**
   * Heartbeat id, published as the ID scalar because the pinned contract names
   * id: ID!.
   */
  id: Scalars['ID']['output'];
  lastAction?: Maybe<Scalars['String']['output']>;
  lastObservedRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastObservedRunId?: Maybe<Scalars['String']['output']>;
  observedAt: Scalars['DateTime']['output'];
  /** Server receipt clock, never caller-supplied. */
  receivedAt: Scalars['DateTime']['output'];
  status: QaWatcherStatus;
  version?: Maybe<Scalars['String']['output']>;
  watcher: Scalars['String']['output'];
};

/** Result of a heartbeat ingest: the stored heartbeat on success, or the reason it was refused. */
export type QaWatcherHeartbeatPayload = {
  __typename?: 'QaWatcherHeartbeatPayload';
  data?: Maybe<QaWatcherHeartbeat>;
  errors?: Maybe<Array<Error>>;
};

/**
 * Outcome of one watcher run-once cycle, as reported by the watcher itself.
 *
 * An enum rather than the sibling's free strings in QaTestStatuses: the vocabulary
 * is closed and owned by us, so an unknown value is a caller defect worth rejecting at the GraphQL
 * boundary rather than a new stream to render. Enum input coercion happens before execution, so an
 * invalid value never reaches a resolver.
 */
export enum QaWatcherStatus {
  /** The watcher observed a problem and acted on it — e.g. requested a rerun. */
  Actioned = 'ACTIONED',
  /** The watcher itself failed to complete its cycle. */
  Error = 'ERROR',
  /** The watcher observed a healthy board and took no action. */
  Green = 'GREEN'
}

export enum QuantityBasis {
  Eaches = 'EACHES',
  Unknown = 'UNKNOWN'
}

/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type Query = {
  __typename?: 'Query';
  /**
   * Returns the calling tenant's accounting integration policy. Never null: when nothing has been
   * persisted the per-tenant defaults are applied (provider-agnostic + summary-out + no pull yet)
   * via String). The tenant is resolved from the
   * caller's context (no tenant-id parameter) so a tenant can never read another tenant's policy.
   */
  accountingIntegrationConfig: AccountingIntegrationConfigDocument;
  /**
   * Returns the authenticated user's in-flight import jobs — those in
   * AsyncImportJobStatus.Uploading, AsyncImportJobStatus.Pending,
   * AsyncImportJobStatus.Validating, AsyncImportJobStatus.Validated,
   * AsyncImportJobStatus.ReadyForImport, or AsyncImportJobStatus.Importing
   * status. AsyncImportJobStatus.Uploading is the first pre-completion active state —
   * a job is Uploading from creation until finalizeImportUpload; including it closes the
   * cross-tab/reload race where a second concurrent import could start during the upload window.
   * Scoped to the caller's tenant and the caller's own jobs (matched on
   * AsyncImportJobDocument.CreatedBy) so the UI can detect and block concurrent
   * import starts across the full active workflow.
   */
  activeImportJobs?: Maybe<ActiveImportJobsConnection>;
  /**
   * All active portal-user mappings across tenants for a given email, read from the unified
   * WorkSuiteUsers read model (active Portal users). SuperAdmin-only.
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (users / user) instead.
   */
  activePortalUsersByEmail: Array<ActivePortalUserMapping>;
  /** Returns the full admin background service config document for a given service name. */
  adminBackgroundServiceConfig?: Maybe<AdminBackgroundServiceConfigDocument>;
  /** Lists all background service configs with filtering, sorting, and paging for admin management. */
  adminBackgroundServiceConfigs?: Maybe<AdminBackgroundServiceConfigsConnection>;
  /**
   * Returns one row per (pod x background service) pair so the admin PWA "Pods" tab can
   * render services grouped by pod without N+1 detail calls. Services with empty
   * PodAssignments produce no rows. AdminBackgroundServicePodResult.NotTenants
   * is the raw flag — exclusion math is left to the manifest query for runtime use.
   */
  adminBackgroundServicePods: Array<AdminBackgroundServicePodResult>;
  /**
   * Most recent CalcDate produced for a tenant. Powers the SLO/freshness indicator.
   * Returns null when the tenant has no results yet.
   */
  adminDbrCalcLatestResultDate?: Maybe<Scalars['DateTime']['output']>;
  /** Single result for a (tenant, customer, item, location) key. Returns null when no result has been computed. */
  adminDbrCalcResult?: Maybe<DbrCalcResultDocument>;
  /** All results for a single customer across the tenant's items and locations. */
  adminDbrCalcResultsByCustomer?: Maybe<AdminDbrCalcResultsByCustomerConnection>;
  /** All results for a single item across the tenant's locations. */
  adminDbrCalcResultsByItem?: Maybe<AdminDbrCalcResultsByItemConnection>;
  /** All results for a single location across the tenant's items. */
  adminDbrCalcResultsByLocation?: Maybe<AdminDbrCalcResultsByLocationConnection>;
  /** Paginated cursor connection of all results for a tenant. Supports filtering and sorting. */
  adminDbrCalcResultsByTenant?: Maybe<AdminDbrCalcResultsByTenantConnection>;
  /**
   * Scheduler heartbeat status: most recent EntityType.DbrCalcScheduler
   * iteration timestamp, and the configured tick interval from the admin background
   * service config. Either field is null when the corresponding source has no data.
   */
  adminDbrCalcSchedulerStatus: DbrCalcSchedulerStatusResult;
  /**
   * Full queue across all tenants. Powers the SuperAdmin queue inspector;
   * supports filtering, sorting, and paging via HotChocolate middleware.
   */
  adminDbrCalcTenantQueue?: Maybe<AdminDbrCalcTenantQueueConnection>;
  /**
   * Per-tenant calculation backlog summary. Returns null when the tenant has
   * no queue row (i.e. the scheduler has not yet observed it) or when the
   * supplied tenantId is not a valid tenant id.
   */
  adminDbrCalcWorkSummary?: Maybe<DbrCalcWorkSummary>;
  /**
   * Aggregated worker fleet snapshot: recent iteration count, current lease count,
   * oldest in-flight lease age, and recent batch timing percentiles. recentMinutes
   * bounds the iteration window (default 5; clamped to [1, 60] to bound the scan).
   */
  adminDbrCalcWorkerFleetStatus: DbrCalcWorkerFleetStatusResult;
  /**
   * Every device in the fleet, across all tenants. Removed devices and decommissioned devices are
   * hidden unless includeRemoved is true.
   */
  adminDevices?: Maybe<AdminDevicesConnection>;
  /** SuperAdmin. Newest first. */
  adminEarlyAccessRequests: Array<EarlyAccessRequest>;
  /**
   * Every non-deleted tenant crossed with the confirmation, acknowledgment and invoice email kinds,
   * each saying whether the email will actually send (feature flag on, tenant opted in, background
   * service covering the tenant, and no tenant-scoped blocker) and, when it will not, which of
   * those is the reason.
   */
  adminEmailDeliveryMatrix: Array<AdminEmailDeliveryRow>;
  /**
   * Returns the full feature flag document for a given feature name, including all tenant overrides.
   * Returns null if the feature flag has not been created.
   */
  adminFeatureFlag?: Maybe<FeatureFlagDocument>;
  /**
   * For every flag, how many tenants have it on, how many of those through a product, and how many have
   * their own setting on or off, out of every tenant that is not deleted. Each answer is resolved exactly
   * as the tenant's own sessions resolve it.
   */
  adminFeatureFlagHolderCounts: Array<AdminFeatureFlagHolderCount>;
  /**
   * Every tenant that is not deleted, ordered by name, with whether the flag is on for it and where that
   * comes from: inactive for everyone, its own setting, one of its products (named), its trial, or
   * everyone's default.
   */
  adminFeatureFlagHolders: Array<AdminFeatureFlagHolder>;
  /** Lists all feature flags with filtering, sorting, and paging for admin management. */
  adminFeatureFlags?: Maybe<AdminFeatureFlagsConnection>;
  /** Retrieves all tenant integrations across tenants with filtering and sorting. */
  adminIntegrations: Array<TenantIntegrationDocument>;
  /**
   * Health facts for every preparation job and import run in one journey of one tenant, for staff: what
   * is moving, what waits on a grower or a specialist, and what needs someone to look at the runtime.
   */
  adminMigrationHealthFacts: MigrationHealthFacts;
  /**
   * The counted failures of one tenant's import runs, or of one run when runId is given, newest
   * first, for staff: when each was counted, its error code and message, the consecutive count it reached and
   * whether it ended the run. Each run keeps its latest 50. A tenant or run with none, or one that does not
   * exist, gives an empty page.
   */
  adminMigrationImportRunFailures?: Maybe<AdminMigrationImportRunFailuresConnection>;
  /**
   * Accepted help requests across tenants, newest first, optionally narrowed by tenant and handling state,
   * each with its per-channel delivery state and provider references. The staff triage list.
   */
  adminOnboardingHelpRequests: Array<OnboardingHelpRequestReadback>;
  /**
   * SuperAdmin only. Staff read of one tenant's onboarding journey: when it started, when the agent first
   * loaded data, and each data family with the status and next step the tenant's plan shows plus the state
   * and time of its latest run. Null when the tenant has no journey.
   */
  adminOnboardingJourneyProgress?: Maybe<OnboardingJourneyProgressReport>;
  /**
   * The chat sessions that touched one tenant's onboarding journey, newest first, optionally narrowed
   * by journey, user and time range, with counts by command kind per day over the same range.
   */
  adminOnboardingJourneySessionTouches: OnboardingJourneySessionTouchReport;
  /**
   * fernie's parsing-improvement suggestions across tenants, newest first, optionally narrowed by tenant,
   * journey, family, stage and review state. Each carries the stream revision it was projected at: send
   * it with a review, and treat a review result at a higher revision as pending until the list catches up.
   */
  adminOnboardingParsingSuggestions: Array<OnboardingParsingSuggestionDocument>;
  /**
   * Lists Active WorkSuiteUsers rows whose WorkSuiteUser-{tenantId}-{userId} stream is
   * soft-deleted or tombstoned — the set adminRepairOrphanedUser can act on — bounded to the
   * first 2000 Active rows (sorted by tenantId then userId); check capReached on the result
   * before treating an empty or short list as complete. A row whose own probe fails is still returned
   * with streamState: UNKNOWN rather than failing the whole call. Platform superadmin only,
   * gated exactly like the other admin* queries (AdminTenantQuery).
   */
  adminOrphanedUsers: AdminOrphanedUsersResult;
  /**
   * Every parent company, paged, filterable and sortable. Soft-deleted parent companies are never
   * returned here, whatever filter is supplied.
   */
  adminParentCompanies?: Maybe<AdminParentCompaniesConnection>;
  /**
   * A single parent company by id, or null when no parent company has that id. A soft-deleted
   * parent company IS returned here, reporting its status as DELETED.
   */
  adminParentCompany?: Maybe<ParentCompanyDocument>;
  adminRestockCalcLatestResultDate?: Maybe<Scalars['DateTime']['output']>;
  adminRestockCalcResult?: Maybe<AdminRestockCalcResultDocument>;
  adminRestockCalcResultsByCustomer?: Maybe<AdminRestockCalcResultsByCustomerConnection>;
  adminRestockCalcResultsByItem?: Maybe<AdminRestockCalcResultsByItemConnection>;
  adminRestockCalcResultsByLocation?: Maybe<AdminRestockCalcResultsByLocationConnection>;
  adminRestockCalcResultsByTenant?: Maybe<AdminRestockCalcResultsByTenantConnection>;
  adminRestockCalcSchedulerStatus: AdminRestockCalcSchedulerStatusResult;
  adminRestockCalcTenantQueue?: Maybe<AdminRestockCalcTenantQueueConnection>;
  adminRestockCalcWorkSummary?: Maybe<AdminRestockCalcWorkSummary>;
  adminRestockCalcWorkerFleetStatus: AdminRestockCalcWorkerFleetStatusResult;
  adminRestockDataValidity: AdminRestockDataValidityPayload;
  /**
   * Restock-configured customers (with nested configured locations) for the seeding
   * dropdowns. search matches customer lookup code or name, case-insensitive.
   */
  adminRestockSeedingCustomerLocations?: Maybe<AdminRestockSeedingCustomerLocationsConnection>;
  /**
   * Whether the seeding mutation is enabled in this environment. The admin PWA hides the
   * seeding page when false (prod).
   */
  adminRestockSeedingEnabled: Scalars['Boolean']['output'];
  /**
   * Tenant items for the seeding dropdown, badged with hasAvailability so the UI can
   * flag items whose achievable will stay null. search matches item lookup code or
   * name, case-insensitive.
   */
  adminRestockSeedingItems?: Maybe<AdminRestockSeedingItemsConnection>;
  /**
   * Last-iteration state per daily-chain entity (UnitsShippedSync, InventoryState,
   * RestockCalcWorkMembershipUpserter, RestockPreCalculation) with today-UTC guard
   * satisfaction — explains why seeded data is not flowing and shows post-kick progress.
   */
  adminRestockSeedingPipelineStatus: AdminRestockSeedingPipelineStatusResult;
  /** Retrieves a single tenant by ID from KurrentDB event stream. Excludes deleted tenants. */
  adminTenant?: Maybe<TenantStateData>;
  /**
   * One tenant's features for the admin Features card: its products, and every flag with whether it is on for the
   * tenant, where that comes from and the tenant's own setting. Each answer is resolved exactly as the tenant's own
   * sessions resolve it. A save sends the products and each changed flag's own setting back as its expected parts.
   */
  adminTenantFeatures: AdminTenantFeatures;
  /**
   * Every office user of the tenant (active, not a portal buyer, not Silver Fern staff), ordered by email,
   * with their learning paths, last learning activity and whether they are stuck: a path incomplete and idle
   * Learning:NudgeAfterDays days (5 by default), escalated at Learning:EscalateAfterDays
   * (10 by default). Users who never started are listed too. For Silver Fern staff and the learning nudge
   * worker. Reading writes nothing.
   */
  adminTenantLearningProgress: Array<LearningUserProgress>;
  /** Returns the pricing page document for tenantId, or null if none is set. */
  adminTenantPricingPage?: Maybe<TenantPricingPageDocument>;
  /** Retrieves all non-deleted tenants from the MongoDB projection with paging, filtering, and sorting. */
  adminTenants?: Maybe<AdminTenantsConnection>;
  /**
   * Lists user invites for the admin surface. An explicit tenantId scopes
   * results to that tenant; a null/empty/whitespace tenantId returns invites
   * across ALL tenants. Gated by SuperAdmin — the same audience that can
   * already query any single tenant, so the all-tenants path adds no new data boundary.
   */
  adminUserInvites?: Maybe<AdminUserInvitesConnection>;
  /**
   * Cross-tenant WorkSuiteUsers directory lookup for the SuperAdmin console's User Health
   * card. Finds directory rows across ALL tenants filtered by email (case-insensitive, via a
   * secondary-strength email collation) and/or fusionAuthUserId. This is the detection read
   * the tenant-scoped users (GetUsers) query cannot serve: it deliberately drops the
   * TenantId == caller.TenantId filter so it can surface an orphan / wrong-tenant row that
   * lives under a DIFFERENT tenant than the caller's. Both parameters are optional and AND-combined;
   * a null/empty/whitespace parameter drops that predicate, so passing neither returns every
   * directory row (bounded by paging). Gated by the SuperAdmin policy — the same audience that
   * already queries any single tenant via adminUserInvites, so the all-tenants path adds no
   * new data boundary (see atlas standard "SuperAdmin Authorization Policy for Cross-Tenant
   * Operations": a cross-tenant lookup by email cannot be safely filtered by the caller's tenant
   * context).
   */
  adminUsers?: Maybe<AdminUsersConnection>;
  /** SuperAdmin. Per-recipient delivery of What's new emails for one tenant, newest release first. */
  adminWhatsNewEmailDeliveries: Array<WhatsNewEmailDelivery>;
  /** SuperAdmin. The tenant's recipients, subscribed or not, by email. */
  adminWhatsNewEmailRecipients: Array<WhatsNewEmailRecipient>;
  /** SuperAdmin. Newest release first. With tenantId: global features plus that tenant's. Flags ignored. */
  adminWhatsNewFeatures: Array<WhatsNewAdminFeature>;
  /** SuperAdmin. */
  adminWhatsNewPreview: WhatsNewAdminPreview;
  /** SuperAdmin. The kept releases, newest first. */
  adminWhatsNewReleases: Array<WhatsNewReleaseSummary>;
  /**
   * What saving flags as the product's flag set would do: for each flag it adds or removes, how many
   * tenants it turns on and how many it turns off, resolved exactly as their sessions would resolve it
   * after the save. Writes nothing.
   */
  adminWorkSuiteProductChangeImpact: Array<AdminWorkSuiteProductFlagImpact>;
  /**
   * How many tenants creating an ordinary product would turn each proposed flag on or off for.
   * A new product is not included for every tenant and has no assigned tenants, so every count is zero.
   * Writes nothing; assigning the product to tenants is a separate operation.
   */
  adminWorkSuiteProductCreateImpact: Array<AdminWorkSuiteProductFlagImpact>;
  /** Every product in the WorkSuite product catalog, in catalog order, with how many tenants have it. */
  adminWorkSuiteProducts: Array<AdminWorkSuiteProduct>;
  /** Returns the full admin worker config document for a given config name. */
  adminWorkerConfig?: Maybe<AdminWorkerConfigDocument>;
  /** Lists all worker configs with filtering, sorting, and paging for admin management. */
  adminWorkerConfigs?: Maybe<AdminWorkerConfigsConnection>;
  /**
   * The colIds a client may sort and filter on for one grid, from the same rules agGridRows enforces
   * and behind the same caller, caller-access and feature gates. The lists come from the per-request config, so
   * a grid whose rules depend on tenant state is reported as it behaves for this caller right now. An unknown
   * gridId is a top-level error.
   */
  agGridColumnCapabilities: AgGridColumnCapabilities;
  agGridRows: AgGridRowsResult;
  agGridSetValues: AgGridSetValuesResult;
  allBaseRatesOfSale?: Maybe<AllBaseRatesOfSaleConnection>;
  allContainerConfigs?: Maybe<AllContainerConfigsConnection>;
  allDailySalesProportions?: Maybe<AllDailySalesProportionsConnection>;
  allDeliverySchedules?: Maybe<AllDeliverySchedulesConnection>;
  /**
   * Resolves every known feature flag for the authenticated tenant in a single round-trip.
   * Intended for SPAs that want to load all flags at startup and react to subsequent
   * changes via the onFeatureFlagChanged subscription.
   */
  allFeatureFlags: Array<FeatureFlagResolvedItem>;
  /**
   * Returns the forecast-settings read-model document for the calling tenant (one doc per tenant).
   * Tenant-scoped via the load-bearing Eq(TenantId, ...) filter — guarded by a cross-tenant
   * leak integration test. Returns no rows when the Forecast flag is
   * disabled for the tenant.
   */
  allForecastSettings?: Maybe<AllForecastSettingsConnection>;
  allProgramReplenishmentSettings?: Maybe<AllProgramReplenishmentSettingsConnection>;
  allReplenishmentSettings?: Maybe<AllReplenishmentSettingsConnection>;
  allWeeklySlopeFactors?: Maybe<AllWeeklySlopeFactorsConnection>;
  allocationTemplate?: Maybe<AllocationTemplateDocument>;
  allocationTemplates?: Maybe<AllocationTemplatesConnection>;
  allottedTimeBaseline?: Maybe<AllottedTimeBaselineDocument>;
  /**
   * Recent-first history of assignments touching a given material item. B4-E
   * pushes the filter to Mongo via $in over the projected
   * MaterialItemIds array, replacing the prior tenant-wide
   * AssignmentHistoryFetchCap scan + in-memory filter (which could
   * truncate history beyond the cap). The bounded limit
   * (default 25, max MaxAssignmentHistoryLimit) is applied as a
   * Mongo $limit after SortByDescending(CreatedAt), so only the
   * requested page of matching assignments is materialized. Backed by the
   * idx_assignmentsummaries_tenant_materialitems_createdat compound index
   * declared in ConfigureMongoDbIndexesService.
   */
  assignmentHistoryByItem: Array<AssignmentSummaryDocument>;
  /**
   * Supervisor-scoped query — returns the assignments on the caller's tenant whose
   * flattened SiteLocationIds array contains the requested site, optionally
   * filtered by status. B4-E pushes the filter to Mongo via $in over the
   * projected array, eliminating the prior two-stage tenant-scan + post-fetch
   * in-memory bin-set match. Backed by the
   * idx_assignmentsummaries_tenant_sitelocations compound index declared in
   * ConfigureMongoDbIndexesService.
   */
  assignmentsByLocation: Array<AssignmentSummaryDocument>;
  asyncImportJob?: Maybe<AsyncImportJobDocument>;
  /**
   * Returns async import jobs across all tenants (no tenant filter) — worker-only.
   * The missing tenant filter is intentional and load-bearing: the external wsapi-services
   * scheduler needs to discover pending jobs across all tenants, then use an appropriate
   * tenant-specific token to access the detail rows. Because the result set spans every tenant,
   * the field is gated to Policies.WorkerService — the same gate
   * advanceProductionLotAsyncImportJob carries — so only a service-account JWT holding the
   * workerservice role reaches it. An ordinary tenant caller is rejected with
   * AUTH_NOT_AUTHORIZED and must use the tenant-scoped tenantAsyncImportJobs or the
   * single-job asyncImportJob instead; without the gate any authenticated user could read
   * every tenant's job metadata, including the createdBy email.
   */
  asyncImportJobs?: Maybe<AsyncImportJobsConnection>;
  /**
   * The newest grade suggestion for a photo in the caller's tenant, by suggestedAt. Null when the photo has
   * no suggestion, belongs to another tenant, the id is not a valid photo id, or the read fails: a missing
   * suggestion only means the grade is not preselected.
   */
  availabilityPhotoGradeSuggestion?: Maybe<AvailabilityPhotoGradeSuggestion>;
  availableInventory?: Maybe<AvailableInventoryConnection>;
  /**
   * Returns the registered IRosProvider keys (alphabetical, stable).
   * Admin-pwa binds its provider-selection dropdown to this. Companion to
   * updateAdminTenantRestockProviderSettings (R39).
   */
  availableRestockProviderKeys: Array<Scalars['String']['output']>;
  /**
   * The places the document can be sent to now, each with the kind of counterparty it needs. Empty until the
   * document has a kind, and empty when the company has no document with the id. INBOUND_DOCUMENTS_DISABLED when
   * forwarding documents is not turned on.
   */
  availableTargets: Array<InboundDocumentAvailableTarget>;
  /**
   * One of the caller's own background jobs, or null when there is none by that id, it belongs to someone else,
   * or the tenant's BackgroundJobs flag is off.
   */
  backgroundJob?: Maybe<BackgroundJob>;
  /**
   * One page of the items of one of the caller's own background jobs in job order, optionally only those in one
   * state: take items (1 to 100, default 100) after skipping skip. Empty when the job is not the
   * caller's or the tenant's BackgroundJobs flag is off.
   */
  backgroundJobItems: Array<BackgroundJobItem>;
  /**
   * Returns all enabled background service configs for a given pod.
   * This is what wsapi-services calls on startup to get its manifest.
   */
  backgroundServiceManifest: Array<BackgroundServiceConfigManifestResult>;
  blockingRule?: Maybe<BlockingRuleStateData>;
  blockingRuleItemLocations?: Maybe<BlockingRuleItemLocationsConnection>;
  /**
   * The task list for a single BPF material cycle-count mission — the surface the inventory PWA
   * pages, searches and sorts against. Tenant-scoped; optionally scoped to a single
   * siteLocationId. Paged, filterable, sortable so the PWA can server-side sort
   * on the denormalised itemDescription / categoryDescription / binDescription
   * fields (the legacy assignmentSortSelections.json options).
   */
  bpfCycleCountMissionTasks?: Maybe<BpfCycleCountMissionTasksConnection>;
  /**
   * BPF material cycle-count missions for the calling tenant — the surface the inventory PWA's
   * assignment list reads. Tenant-scoped (the in-query Eq(TenantId, ...) filter is the
   * load-bearing isolation boundary — no query in wsapi calls BpfTenantGuard.EnsureBpf, that
   * is a mutation-only pattern); paged, filterable, sortable. "Currently open" missions are scoped
   * via the standard where: { endDate: { gte: ... } } filter over endDate
   * rather than a bespoke argument.
   */
  bpfCycleCountMissions?: Maybe<BpfCycleCountMissionsConnection>;
  /**
   * The lot-change reason codes for the calling tenant — the parity replacement for the legacy
   * countReasons query that populates the PWA's reason dropdown. Tenant-scoped reference
   * data synced from Nav Reason Codes.
   */
  bpfLotChangeReasons?: Maybe<BpfLotChangeReasonsConnection>;
  /**
   * The BPF lot-change audit history for the calling tenant — the immutable record of every change
   * recorded by field users. Tenant-scoped; paged, filterable, sortable for triage.
   */
  bpfLotChanges?: Maybe<BpfLotChangesConnection>;
  /**
   * Lot counts by stage (GROW / READY / MATERIAL) per location node for the calling tenant — the
   * surface the inventory PWA reads to display Finish/Material counts. Tenant-scoped (the in-query
   * Eq(TenantId, ...) filter is the load-bearing isolation boundary); paged, filterable,
   * sortable so the PWA can scope by stage and station/house/section.
   */
  bpfLotCounts?: Maybe<BpfLotCountsConnection>;
  /**
   * Lot counts for a single stage for the calling tenant — convenience over the filterable
   * bpfLotCounts query for the PWA's per-stage views.
   */
  bpfLotCountsByStage?: Maybe<BpfLotCountsByStageConnection>;
  /**
   * Every Nav position (house or section) of one station for the calling tenant, stocked or empty,
   * ordered by position code: the places a Move from a cell of that station may go. Empty for a
   * station with no positions.
   */
  bpfPositions: Array<BpfPositionDocument>;
  /**
   * Each BPF sync worker's last successful Nav read for the caller's tenant; empty until a worker
   * has written one. Any signed-in user may read it. Read only.
   */
  bpfSyncStatus: Array<BpfSyncStatusDocument>;
  /**
   * All BPF user starting-node assignments for the tenant (admin/management surface). Tenant-scoped;
   * paged, filterable, sortable.
   */
  bpfUserStartingNodes?: Maybe<BpfUserStartingNodesConnection>;
  /** One of the tenant's jobs, or null when it has none by that id. */
  bulkOrderDeleteJob?: Maybe<BulkOrderDeleteJobDocument>;
  /**
   * The tenant's jobs, newest first (fixed: there is no sort argument), filterable by status and the other stored fields. The tenant is
   * forced server-side and ANDed into the filter, so a client-supplied tenant filter cannot reach another tenant's jobs.
   */
  bulkOrderDeleteJobs?: Maybe<BulkOrderDeleteJobsConnection>;
  /**
   * Calculates cost summaries for a batch of production jobs by resolving each job's
   * recipe variation and site location, then running cost resolution.
   * The cost resolvers produce PER-UNIT figures. This query is the job boundary — it is the layer
   * that knows each job's quantity — so it scales every job by its OWN quantity here and publishes
   * both bases on ProductionJobCostResult. Consumers aggregating across jobs (a lot,
   * a plan) therefore just sum the job totals; they must not re-apply quantity.
   * A recipe-level flat-rate override supersedes the computed breakdown here exactly as it does in
   * calculateRecipeCost, and costSource / computedTotalCost report which of
   * the two the quoted total came from. The one difference between the surfaces is the quantity
   * each converts at: the estimate is a per-unit figure a caller scales by what it PLANS to
   * produce, while a job quotes what it ACTUALLY produced once counted (costingQuantity).
   * A job's budget is fixed at its first execution: an executed job returns the result recorded then,
   * so a later price, recipe or rate change does not move it, while a job not yet executed is resolved live.
   */
  calculateProductionJobCosts: Array<ProductionJobCostResult>;
  /**
   * Calculates a cost summary for a production recipe variation at a specific site location.
   * Orchestrates materials, labor, and overhead cost resolution services.
   * For combo recipes, also traverses linked sub-recipes and aggregates their scaled costs.
   * When productionRecipeVariationId is null or empty, selects the first
   * variation for the recipe (sorted by ID) as the default.
   */
  calculateRecipeCost?: Maybe<RecipeCostSummaryResult>;
  carriers?: Maybe<CarriersConnection>;
  categories?: Maybe<CategoriesConnection>;
  /**
   * How much of a category a CategoryVolume tier in this price group would actually pay out on.
   * Returns the category's active item count and how many of those items already carry their OWN
   * line-price level in the same group — items a category tier can never pay, because a negotiated
   * price does not stack with a category break.
   *
   * Backs the price-level editor's configuration-time warning ("40 of this category's 50 items
   * already have their own price in this group and will not receive this tier"). Read-only, and it
   * resolves no prices: the same exclusion measured after the fact, in units rather than items,
   * is on an order's categoryVolumeProgress.
   *
   *
   * Tenant-scoped from the caller's context, never from an argument. Staff-only
   * ([Authorize], not the portal policy): it describes a price group's internal
   * configuration, which is not a customer's to see.
   */
  categoryVolumeCoverage: CategoryVolumeCoverage;
  checkpoint: CheckpointStateData;
  /**
   * Preparation jobs the preparation worker may claim, across every tenant, oldest first, at most 25:
   * Pending, or Running with no live claim. Worker only.
   */
  claimableMigrationPreparationJobs: Array<MigrationPreparationJobStatus>;
  clickUpRoadmapTasks: Array<ClickUpRoadmapTaskData>;
  clickUpTimeLoggerTasks: Array<ClickUpTaskData>;
  combinedOrders?: Maybe<CombinedOrdersConnection>;
  commandBarOptions?: Maybe<CommandBarOptionsConnection>;
  /**
   * A single user's commission configuration. Null when none exists, or when the
   * caller's directory roles do not allow seeing it: Sales users may only read
   * their own configuration; Sales Managers and Admins may read any.
   */
  commissionConfig?: Maybe<CommissionConfigDocument>;
  /**
   * The tenant's commission configurations. Visibility follows the caller's
   * directory roles: Sales users see only their own configuration, Sales Managers
   * and Admins see every configuration, and callers without a commission-relevant
   * role get an empty result.
   */
  commissionConfigs?: Maybe<CommissionConfigsConnection>;
  configCategories?: Maybe<ConfigCategoriesConnection>;
  configCategory?: Maybe<ConfigCategoryStateData>;
  consolidationApplication?: Maybe<ConsolidationApplication>;
  consolidationApplicationLots: Array<ConsolidationApplicationLot>;
  consolidationApplications: Array<ConsolidationApplication>;
  /**
   * Returns the consolidation preview for the calling tenant. Tenant id is
   * taken from the JWT via TenantId; the input
   * has no tenant field by design — every request is scoped to the caller.
   */
  consolidationPreview: ConsolidationPreviewPayload;
  consolidationPreviewLots: ConsolidationPreviewLotsPayload;
  /**
   * Returns the calling tenant's consolidation rule set, or null when the
   * tenant has not yet configured one. Tenant identity is sourced from the JWT via
   * UserResolverContext.TenantId; the caller cannot read another
   * tenant's rule set.
   */
  consolidationRuleSet?: Maybe<ConsolidationRuleSetDocument>;
  consolidationRules?: Maybe<ConsolidationRules>;
  consolidationRulesVersions: Array<ConsolidationRulesVersion>;
  containerConfig?: Maybe<ContainerConfigStateData>;
  /**
   * Resolves the single active ContainerConfigDocument matching a
   * (categoryCode × containerCode × siteLocationId)
   * key, or null when none matches. siteLocationId is the WorkSuite-native
   * site-location identifier (the same token the ship-from rework stores as
   * OrderState.ShipFromSiteLocationId), matched against each config's site list. Backs the
   * PWA "Packing Config" side-panel: querying this field once per order line batches into a single
   * MongoDB round-trip via the batched DataLoader (no N+1).
   */
  containerConfigByCategoryContainerSite?: Maybe<ContainerConfigDocument>;
  /**
   * Returns one row per distinct ContainerCode by aggregating over
   * ContainerConfig documents. The most recent metadata (by UpdatedAt)
   * wins for the per-container fields. Unknown-status documents are
   * excluded server-side so uninitialized projection state never leaks.
   */
  containers: Array<ContainerRow>;
  /** One contract record by its public request id, or null if it does not exist. */
  contractRecord?: Maybe<ContractRecordDocument>;
  /** Every contract record, filterable/sortable/paged, for the admin screen's list view. */
  contractRecords?: Maybe<ContractRecordsConnection>;
  /** Every registered correction, by key. */
  correctionDefinitions: Array<CorrectionDefinition>;
  /** One correction run with its rows, or null when there is none by that id. */
  correctionRun?: Maybe<CorrectionRunDocument>;
  /** Correction runs, newest first, optionally only one tenant's and only at one status. */
  correctionRuns?: Maybe<CorrectionRunsConnection>;
  /**
   * Every correction the session has carried, newest first by requestVersion unless an
   * order is sent. Includes corrections the session's pendingCorrection* slot has since
   * replaced, each with its own terminal state. Only corrections projected since this field shipped
   * are present; earlier corrections cannot be recovered, and a projection rebuild restores only the
   * session's last correction.
   */
  countCorrectionHistory?: Maybe<CountCorrectionHistoryConnection>;
  /**
   * Production lines for the caller's tenant. Supply siteLocationId to limit the result to
   * lines placed at that site or a sub-location beneath it, expanded server-side against the
   * tenant's location tree; lines with no location are always included regardless, since an
   * unplaced line is relevant to every site's operator until a human places it.
   */
  countProductionLines?: Maybe<CountProductionLinesConnection>;
  countReasons: Array<CountReasonData>;
  countRegistrations?: Maybe<CountRegistrationsConnection>;
  countSessions?: Maybe<CountSessionsConnection>;
  /**
   * Gets the credit memo a Credit-type order issued, by the credit order's id: what it credits, and through
   * applications, amountApplied, unapplied and applicationStatus where its money stands. Null when no memo has
   * been issued for that order.
   */
  creditMemo?: Maybe<CreditMemoDocument>;
  /**
   * Lists every credit whose price differs from what its source invoice line billed for the eaches it credits, by more
   * than a cent on a line, so the credits raised before credits priced like their sale can be seen; none is restated.
   * Each listed credit names its source order, the invoice it was compared with (or ORDER when the source
   * has no live invoice, so its lines as they stand), what it credits and what the sale billed for those eaches, line
   * by line. Also listed: a credit whose source's record names no credit line for a line (CREDIT_LINES_NOT_NAMED) or
   * does not record it at all (SOURCE_DOES_NOT_RECORD_THE_CREDIT): run backfillOrderCreditBackReferences, then this
   * again. A credit priced like its sale is counted, not listed. Cancelled and deleted credit orders, and Credit-type
   * orders raised from no source, are not checked. Reads only: nothing is written and Stripe is never asked, so a
   * second run reports the same. tenantIds narrows the report to those tenants; omitting it reports across every
   * tenant. A tenantIds list that names no tenant (CREDIT_PRICING_REPORT_NO_TENANTS), or an id in it that is not a
   * tenant id, refuses the report: nothing is read, and errors says why.
   */
  creditsPricedUnlikeTheirSale: CreditPricingReportPayload;
  /**
   * Reads the tenant's outbound CRM export outbox from the CrmExports collection.
   * Paginated, filterable, and sortable so the wsapi-services worker drains starvation-free —
   * it filters to the eligible statuses with NextRetryAt <= now
   * (where: { and: [{ exportStatus: { in: [PENDING, FAILED_TRANSIENT] } },
   * { or: [{ nextRetryAt: { eq: null } }, { nextRetryAt: { lte: $now } }] }] }),
   * sorts customerId ascending, and takes a page. Bare UsePaging caps first
   * at 50 — fine, the worker batches. Authorization mirrors the accounting worker query
   * (getMergeDevExports): plain [Authorize], tenant-scoped by the in-query
   * Eq(TenantId, ...) filter (worker presents a per-tenant token, same as accounting);
   * only the outcome-reporting mutation is gated to Policies.WorkerService.
   */
  crmExports?: Maybe<CrmExportsConnection>;
  customer?: Maybe<CustomerStateData>;
  /**
   * Returns one customer's activity timeline as a cursor-paged connection, newest first, merging order
   * milestones (placed, submitted, shipped, synchronized), every payment and deposit on those orders'
   * payment ledgers (imported from accounting and recorded manually alike), and the customer's notes —
   * both the historical activity-log notes and the current per-context notes, each timestamped when it
   * was written. The read is tenant-scoped, and each source is narrowed by the scope of its own grain:
   * orders by the caller's order-visibility precedence (customer, explicit assignment, route and the
   * order's own salesperson), so an order outside that scope contributes nothing; notes by the
   * customer-visibility precedence the customers query applies (customer, explicit assignment, route and
   * salesperson registry), so a caller reads a customer's notes only when customers would return it.
   * Deleted orders are excluded; cancelled orders are DELIBERATELY kept, unlike the two aggregate reads on
   * this panel, which exclude them — a feed records what happened rather than deriving a total, and a
   * cancelled row explains itself where a silently missing one does not. A customer with no activity
   * yields an empty connection rather than null. With the optional shipToLocationId the feed shows only
   * that store's orders and the payments on them, and leaves out the account-level customer notes; an
   * unknown store yields an empty connection. Requests for more than 200 entries in a page are
   * rejected.
   */
  customerActivityFeed?: Maybe<CustomerActivityFeedConnection>;
  /**
   * Previews combining the loser into the survivor: every field grouped by kind with its value on
   * each customer and after the combine, the conflicts that need a pick (the suggested contact and
   * ship-to pairs among them, a ship-to pair the combine would refuse as "same as" marked with the
   * reason), and each customer's history. Also lists the refusals the combine would meet while the loser
   * still has unaccepted portal invites, or when it would save more changes than one combine can, the staff
   * users and portal buyers below counted as if the combine gave them the survivor (blockers),
   * how many of the loser's active customer items sit on its ship-tos and at customer level
   * (shipToCustomerItemsMoving, customerLevelCustomerItems), and the staff users limited
   * to assigned customers who have the loser but not the survivor (limitedStaff), whom the combine
   * can be asked to give the survivor, the loser's Active portal buyers, whom the combine moves to the
   * survivor (portalBuyersMoving), and the outside syncs that feed each customer
   * (oldCustomerSyncSources, keptCustomerSyncSources), so the admin can decide whether the
   * loser's may also update the survivor's settings. Writes nothing. Refused, like the combine, while
   * the tenant syncs customers from its ERP, and for a caller explicitly assigned to customers who is not
   * assigned to both.
   */
  customerCombinePreview: CustomerCombinePreviewPayload;
  /**
   * Previews undoing the combine of the old customer loserId, from the same reads and functions as the undo:
   * the ship-tos and contacts that go back to it, each moved, added or edited while combined, how many customer
   * items go back on its ship-tos and at customer level, and how many orders and invoices move back to it
   * (goesBack); the moved ship-tos and contacts deleted while combined, which stay deleted
   * (deletedWhileCombined); the settings the combine changed that were changed again since, which stay on
   * the kept customer, and those it sets back (staysOnKeptCustomer, settingsRestored); the SKUs it
   * takes off each kept customer item the combine added SKUs to (skusComingOff); the staff users who lose
   * the kept customer (staffLosingKeptCustomer); the portal buyers the combine moved who go back to the old
   * customer (portalBuyersMovingBack); whether the revert window is open and, when closed, the
   * order, invoice or payment that closed it; and the other refusals the undo would meet (blockers).
   * Writes nothing. Refused, like the undo, for a caller explicitly assigned to customers who is not assigned to
   * both.
   */
  customerCombineRevertPreview: CustomerCombineRevertPreviewPayload;
  /**
   * Gets one customer's credit balance: what the grower owes them (balance), every credit received
   * (entries), what is still unapplied on each (openEntries), every application to one of their invoices
   * (applications) and every refund of it (refunds). A customer with no credit returns a zero
   * balance rather than null.
   */
  customerCredit?: Maybe<CustomerCreditDocument>;
  /**
   * Returns the tenant-scoped, paged customer groups over the CustomerGroups summary
   * read model. [UseFiltering] exposes a status filter (plus every other
   * document field) so callers can request active-only, inactive-only, or unfiltered results.
   * Soft-deleted groups are excluded unconditionally in the base Find filter, not via a
   * [UseFiltering] pass-through predicate -- a deleted group can never be fetched back
   * through this query by any caller-supplied filter combination. Mirrors
   * CustomerTypeQuery.GetCustomerTypes.
   */
  customerGroups?: Maybe<CustomerGroupsConnection>;
  /** One customer's remittances, newest first — the receivables view's "what did they send us" panel. */
  customerInvoicePaymentGroups: Array<InvoicePaymentGroup>;
  /**
   * Resolves the invoice recipients for customerId: every non-blank email of
   * every contact currently routed to receive this customer's invoices, plus why that list is empty
   * when it is. Null when customerId is not found in the caller's tenant.
   */
  customerInvoiceRecipients?: Maybe<CustomerInvoiceRecipientsData>;
  customerItem?: Maybe<CustomerItemStateData>;
  /** @deprecated Use skuUpcMappings instead. Will be removed in next release. */
  customerItems?: Maybe<CustomerItemsConnection>;
  /**
   * Server-computed group headers (with per-group counts) for the Restock Locations sidebar, so the
   * client renders grouping over the full location list without loading every location and grouping
   * in memory. Groups the SAME read model the list pane pages
   * (customerLocations rows) under the SAME caller visibility scope, so a scoped caller's bucket
   * counts match the rows they see and each bucket's key is usable
   * verbatim as the list where eq-value.
   * groupBy selects the bucket key (Region or Market). search is
   * the same case-insensitive OR-contains over the searchable fields the sidebar applies, so counts
   * reflect the active search. The group's children are then lazy-loaded via
   * customerLocations filtered to the bucket key.
   */
  customerLocationGroups: Array<CustomerLocationGroupBucket>;
  /** Retrieves the resolved purchase-order-required flag for a location using two-tier fallback: Location override, then Customer (default false) */
  customerLocationPoRequiredInherited: Scalars['Boolean']['output'];
  customerLocationRetailerNames: Array<Scalars['String']['output']>;
  /** Retrieves resolved terms ID for a location using three-tier fallback: Location → Customer → Default */
  customerLocationTermsIdInherited?: Maybe<Scalars['String']['output']>;
  customerLocations?: Maybe<CustomerLocationsConnection>;
  /**
   * Returns the caller's tenant's CustomerLocationDocument rows that have at
   * least one BaseRatesOfSale row — an existence gate, not a value filter. The Restock
   * orders wizard uses this surface to populate its store selector, which must only offer
   * locations the system can actually compute a replenishment for (i.e. those with a Base Rate
   * of Sale on file). Returns the SAME CustomerLocationDocument type as the
   * customerLocations query so the PWA can reuse its existing fragment, filter, and sort.
   */
  customerLocationsWithBaseRateOfSale?: Maybe<CustomerLocationsWithBaseRateOfSaleConnection>;
  /**
   * Every notification kind and document binding as they apply to one customer: the tenant catalog
   * merged with the customer's overrides and the recipients its contacts derive. Null when the
   * customer is not in the caller's tenant.
   */
  customerNotificationSettings?: Maybe<NotificationSettingsData>;
  /**
   * Computes the Customer 360 order-history and accounts-receivable rollup for one customer in a single
   * MongoDB aggregation over the combined-orders read model. STAFF-ONLY: the bare Authorize attribute
   * resolves to the default policy, which only the user, admin and superadmin roles satisfy, so a
   * portal-user JWT is rejected before this resolver runs and the own-customer (customer-portal) branch of
   * the shared order visibility scope is unreachable here. The Customer 360 panel this serves is the
   * Health tab of the Fulfill customer detail page, whose audience is salespeople and managers; the
   * customer portal is out of scope for this surface. The customer id is validated, the read is scoped to
   * the caller's tenant and to whatever staff order visibility the caller carries (assigned customers,
   * assigned routes, or own salesperson), and every division is zero-guarded.
   *
   * ONE order set feeds every ORDER-HISTORY accumulator: the customer's orders excluding master orders
   * (recurring templates, not purchases), cancelled orders and deleted orders — see the shared
   * customer-scoped match on OrderVisibilityScope. openOrderCount counts drafts, active orders and
   * sync-error orders within it. A well-formed customer id with no orders in scope returns a zeroed
   * rollup (not null) so the panel can render zeros; null is reserved for a malformed id.
   *
   *
   * The optional shipToLocationId narrows every ORDER-HISTORY figure to the orders shipped to that
   * store. It never reaches ReadReceivableAsync or ReadVisibleOrderIdsAsync: arBalance and aging stay
   * whole-account, because invoices belong to the billing customer rather than to a store. An unknown
   * store, or one belonging to another customer, yields a zeroed order rollup beside the whole-account
   * receivable.
   *
   *
   *
   * THE TWO ACCOUNTS-RECEIVABLE FIGURES DO NOT COME FROM THE ORDER PIPELINE AT ALL. An order is no
   * longer the receivable — an invoice is — so arBalance and the aging buckets are read from the
   * customer's invoices through the same rollup customerReceivables serves, and this resolver does no
   * A/R arithmetic of its own. That is what makes this panel, customerReceivables and the customer
   * statement agree by construction rather than by three implementations of one rule being kept in
   * step; the aging buckets, the day count and the accrual are all the shared kernels.
   *
   *
   * THE CALLER'S OWN ORDER VISIBILITY STILL NARROWS THEM. An invoice carries no salesperson and no
   * route, so a restricted caller's receivable is read through the orders they can already see rather
   * than through a second authorization rule written against invoices — a caller not entitled to this
   * customer sees no orders, therefore no invoices, therefore a zeroed receivable, exactly as the rest
   * of the rollup answers them. An unrestricted staff reader reads the account directly.
   */
  customerOrderStats?: Maybe<CustomerOrderStats>;
  /**
   * Retrieves the customer account for the authenticated portal user.
   * The customer ID is resolved from the portal user's JWT claims.
   */
  customerPortalAccount?: Maybe<CustomerPortalAccountData>;
  /**
   * Renders the signed-in portal buyer's branded availability sheet to a downloadable PDF,
   * through the tenant's configured report or the seeded default when none is set. Every value
   * that fills the sheet — the buyer's own tenant, customer and catalog — is fixed on the
   * server; the caller chooses only the availability window. Null when the caller does not
   * belong to the named tenant or is not a portal buyer. An error payload when the tenant's
   * portal is switched off or the render itself fails, carrying only a generic message to a
   * buyer.
   */
  customerPortalAvailabilityPdf?: Maybe<ReportPdfPayload>;
  /**
   * Returns the freight checkout will add for the signed-in buyer's own ship-to and cart subtotal,
   * using the same inherited freight settings and calculation as order placement. Nothing is saved.
   *
   *
   * **Returns:**
   * The freight type, value and calculated amount, or null for staff, an unavailable portal or customer,
   * or a ship-to the buyer does not own. No configured freight returns an amount of zero.
   */
  customerPortalCartFreight?: Maybe<PortalCartFreightData>;
  /**
   * Returns the selectable delivery dates for the authenticated portal user's customer at one
   * ship-to location, over a bounded horizon, each ineligible date carrying why it cannot be
   * picked. The customer is taken from the caller's JWT, never from client input. The one
   * argument that IS client input — the ship-to location id — is ownership-checked against
   * that same claim before it reaches the delivery-days resolver, so naming another customer's
   * location returns null rather than that customer's delivery pattern. Omitting the location
   * resolves the customer's route without a location-level override. The horizon's length is the
   * tenant's own max-days-out setting, 30 days for a tenant that has never changed it. Passing
   * isPreorder: true extends the horizon to a year, with the weekday, cutoff and closure rules
   * unchanged. A tenant with no delivery schedule and no cutoff gets an unrestricted calendar. Tenant-scoped: a tenantId that does
   * not match the caller's own tenant returns null, as does a tenant whose portal is disabled.
   */
  customerPortalEligibleDeliveryDates?: Maybe<EligibleDeliveryDatesData>;
  /**
   * Retrieves a single favorites list by ID for the authenticated tenant. Same shared staff + portal
   * contract as the list field: a buyer requesting a list outside their visible scope gets
   * null, the same shape as the existing tenant-mismatch and portal-disabled paths.
   */
  customerPortalFavoritesList?: Maybe<FavoritesListDocument>;
  /**
   * Returns a paged, filterable list of favorites lists for the authenticated tenant. Shared staff +
   * customer-portal field: the buyer portal's dashboard and catalog collection sections read it, so it
   * is gated by the Portal policy rather than the staff DefaultPolicy floor a
   * portal-user shopper cannot clear. What a buyer may SEE is narrowed server-side to Global
   * lists, lists scoped to their own customer, and lists scoped to their own user; staff results are
   * unchanged (full tenant-wide set). Buyers never receive an Inactive list or a list with no items; staff receive Active and
   * Inactive lists with their status (1 = Active, 3 = Inactive).
   */
  customerPortalFavoritesLists?: Maybe<CustomerPortalFavoritesListsConnection>;
  /**
   * Returns a paged, filterable list of inventory availability for the authenticated tenant.
   * Rows are already narrowed to the tenant's Availability rule (grade with the gradeless-hardgood
   * carve-out, location, includeSellableHardGoods) for every tenant, so the client does not have
   * to reconstruct it. When the tenant's portal settings cannot be read at all, a customer caller
   * is refused and a staff caller is served through the default rule, so a settings failure can
   * neither open a portal the tenant turned off nor empty the staff view.
   */
  customerPortalInventoryAvailability?: Maybe<CustomerPortalInventoryAvailabilityConnection>;
  /**
   * One of the signed-in buyer's own invoices. Null for an invoice billed to another customer, for one of
   * another tenant, for an id with no invoice behind it, when the portal is switched off, and for a caller who
   * is not a portal buyer — all answered identically.
   */
  customerPortalInvoice?: Maybe<CustomerPortalInvoice>;
  /**
   * The signed-in buyer's status read for one online payment of their own customer's invoices, from the portal or
   * a pay link. Null for another customer's payment, another tenant's, an unknown id, or a caller who is not a
   * portal buyer, all answered identically.
   */
  customerPortalInvoicePaymentAttempt?: Maybe<InvoicePaymentAttempt>;
  /**
   * The combined quote the signed-in buyer sees before Pay selected: what paying the named invoices of their own
   * customer together, in full, costs right now, priced by the same builder Pay uses. Locks nothing. A refusal
   * explains why the invoices cannot be paid together.
   */
  customerPortalInvoicePaymentQuote: CustomerPortalInvoicePaymentQuotePayload;
  /**
   * The signed-in buyer's own invoices, newest first: number, dates, totals, final tax, applied deposit credit,
   * posted balance, status, lines and payment history. Only invoices billed to the buyer's own customer are
   * returned. Empty when the portal is switched off, when tenantId is not the buyer's own tenant, and for a
   * caller who is not a portal buyer.
   */
  customerPortalInvoices?: Maybe<CustomerPortalInvoicesConnection>;
  /**
   * Returns filterable item availability data for the authenticated tenant: inventory rolled up
   * per item, for every tenant. When the settings cannot be read at all, a customer caller is
   * refused and a staff caller is still served, so a settings failure can neither open a portal
   * the tenant turned off nor empty the staff view.
   */
  customerPortalItemAvailability?: Maybe<Array<ItemAvailabilityDocument>>;
  /**
   * Per-grade available quantities for the authenticated tenant's items, so a storefront can show a
   * grade chip and a per-grade breakdown beside a catalog row that carries only one flat quantity.
   * One entry per item that has something to show, grades highest first; join it to the catalog by
   * itemId. The tenant's availability rule is enforced here, on the server, and is not left to the
   * client: a grade below the tenant's minimum grade is absent no matter how much stock sits at it,
   * quantities are summed only across the locations the rule admits, and gradeless inventory (the
   * sentinel grade 0 that hard goods key their inventory at) is never reported because it carries
   * no grade to show. Only grades with a positive available quantity appear, so an entry's first
   * grade is always one a buyer can actually be sold, and an item left with no such grade is
   * omitted entirely rather than returned with an empty list. Only items the portal catalog itself
   * shows are reported, through the same visibility rule customerPortalItems applies, so an item
   * deleted from the catalog is absent here too however much graded stock its inventory still
   * holds — every entry joins to a catalog row. Null — never an error, never an empty
   * list — when the request cannot be served: a tenantId that is not the caller's own, a tenant
   * whose portal is switched off (for customer callers, as everywhere else on this surface), or a
   * settings read the server could not complete. Read null as "no grade information", never as
   * "this tenant has no graded stock". The result is a paged connection like every other
   * customer-portal list, so a client that wants the whole catalog's grades must follow pageInfo
   * rather than assume one page holds them all. Entries come back ordered by itemId; there is no
   * where/order argument, because the rows are computed by the server rather than read from a
   * collection a filter could be pushed into.
   */
  customerPortalItemGradeAvailability?: Maybe<CustomerPortalItemGradeAvailabilityConnection>;
  /**
   * Returns a paged, filterable list of items available to the authenticated tenant.
   * availableQuantity is the server-computed inventory number (on-hand minus allocated) through
   * the tenant's Availability rule, for every tenant, so filtering on it matches what the catalog
   * shows. A tenant that has never saved portal settings is served through the default rule.
   * When the settings cannot be read at all, a customer caller is refused and a staff caller is
   * served through the default rule, so a settings failure can neither open a portal the tenant
   * turned off nor empty the staff catalog.
   */
  customerPortalItems?: Maybe<CustomerPortalItemsConnection>;
  /**
   * Retrieves a single portal user's current state by reading directly from the unified
   * WorkSuiteUser event stream, bypassing read-model projection lag. Returns null if
   * not found or inactive. Staff-only: a customer-type portal JWT gets null, consistent with
   * the portal authz pattern — a portal buyer may not read another portal user's PII. Tenant-scoped.
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (users / user) instead.
   */
  customerPortalPortalUserByStream?: Maybe<PortalUserStateData>;
  /**
   * The signed-in buyer's retail price history for one catalog item: every retail price record of its own
   * customer for the item, in the program the catalog shows, ended, in effect and scheduled alike, newest start
   * first. A record with no price is a cleared window. Refused with a coded error for a tenantId that is not the
   * caller's own, for a caller who is not a portal buyer, when the portal is off or the buyer's customer is not
   * Active or was combined, when buyer retail price editing is off, and for an item not in the catalog.
   */
  customerPortalRetailPriceHistory?: Maybe<CustomerPortalRetailPriceHistoryConnection>;
  /**
   * The signed-in buyer's retail price save by the jobId it was stored under, or null when there is none
   * by that id or it is not this buyer's save for its own customer. Poll it while the save is open. Refused with a
   * coded error, as customerPortalSaveRetailPrices is, for a tenantId that is not the caller's own, for a
   * caller who is not a portal buyer, when the portal is off or the buyer's customer is not Active or was
   * combined, and when buyer retail price editing is off.
   */
  customerPortalRetailPriceSave?: Maybe<CustomerPortalRetailPriceSave>;
  /**
   * Returns a paged, filterable list of the tenant's sellable, active hard goods for the customer
   * portal. Results are gated on the tenant's portal "Include sellable hard goods" setting; when
   * the tenant has not opted in (or never saved settings), an empty result is returned. Cross-tenant
   * requests or portal-disabled tenants return null.
   */
  customerPortalSellableHardgoods?: Maybe<CustomerPortalSellableHardgoodsConnection>;
  /**
   * Returns the read-only portal-enforcement settings for the authenticated portal user's
   * tenant, reading current state directly from the KurrentDB stream (no projection lag). When
   * the tenant has never saved settings the documented defaults are returned (portal enabled,
   * no minimum order, grid catalog). Deliberately NOT gated by PortalAccess — the
   * storefront relies on this field to detect a disabled portal and render its own "portal
   * unavailable" page, so it must stay readable even when PortalEnabled is false. Mirrors
   * the customer-portal authz gate used across the portal queries only for cross-tenant access: a
   * tenantId arg that does not match the caller's own tenant returns null.
   * Tenant-scoped — the stream is keyed by the caller's own tenant id, so one tenant can never
   * read another's settings.
   */
  customerPortalSettings?: Maybe<CustomerPortalSettingsData>;
  /** Retrieves a shopping cart by ID for the authenticated tenant. Requires authorization. */
  customerPortalShoppingCart?: Maybe<ShoppingCartStateData>;
  /** Works out what sales tax would be charged on the items in a shopping cart, right now. */
  customerPortalShoppingCartTaxEstimate?: Maybe<OrderTaxEstimatePayload>;
  /**
   * Lists the tenant's portal users, read from the unified WorkSuiteUsers read model
   * (active Portal users) and projected onto the legacy
   * PortalUserDocument shape. Staff-only: a customer-type portal JWT gets
   * null, consistent with the portal authz pattern — a portal buyer may not read the
   * tenant's full portal-user roster (PII), and so cannot see another customer's users.
   * Tenant-scoped — only the caller's own tenant. The free-form legacy role collapses to
   * "Portal" and the single unified FullName is split back into first/last
   * (see WorkSuiteUserPortalFacadeMapping).
   * @deprecated Backed by the unified User aggregate. Use the unified User surface (users / user) instead.
   */
  customerPortalUsers?: Maybe<CustomerPortalUsersConnection>;
  /**
   * What one customer owed on the invoice basis at asOfDate (defaulting to now), aged
   * and accrued as of it. A midnight (UTC) asOfDate names that whole day: the figures are read at its last
   * instant, as the aging report and a statement read the same day; any other value is read at that
   * instant. Invoices issued after it, and payments, adjustments, credits, waivers and voids dated after
   * it, are left out, so a later event never lowers an earlier balance. Unbilled exposure — shipped orders
   * with no invoice at that date — is reported beside the balance, never in it. A deleted customer owes
   * nothing here.
   */
  customerReceivables?: Maybe<CustomerReceivables>;
  /**
   * Every customer-level SKU/UPC/retail-price record for one customer, across items and any
   * status, for the Pre-pricing tab's history view. Staff-only: a customer-type portal JWT gets
   * null.
   */
  customerRetailPrices?: Maybe<CustomerRetailPricesConnection>;
  /**
   * One row per ship-to store of the customer, with its order count, lifetime and this-year order value
   * and last order date. STAFF-ONLY, like customerOrderStats: the bare Authorize attribute resolves
   * to the default policy, which a portal-user JWT does not satisfy.
   *
   * The order set and the caller's visibility are exactly those of customerOrderStats (the shared
   * combined-orders aggregate and customer-scoped match, master, cancelled and deleted orders excluded),
   * folded in ONE aggregation keyed by the order's ship-to id with the same accumulators. For the same
   * caller the rows therefore add up to that query's totals.
   *
   * Rows: every current ship-to of the customer, including stores with no orders (zero counts, null last
   * order date); plus every ship-to id found on the customer's orders that is no longer one of its
   * ship-tos, labelled from the snapshot on its newest order. The current ship-tos are narrowed by the
   * same customer visibility the customer and ship-to lists apply, so a caller who may not see the
   * customer gets no store names. A malformed customer id returns null; an
   * unknown customer returns an empty list.
   */
  customerShipToStats?: Maybe<Array<CustomerShipToStats>>;
  /** Renders one customer's generated statement so an operator can read it BEFORE deciding to send it. */
  customerStatementPreview: ReportPdfPayload;
  /**
   * Gets one run's per-customer review lines: who was considered, where their statement goes or why it
   * cannot, what it closes at, and whether it has been sent yet.
   */
  customerStatementRunReviewLines: Array<CustomerStatementRunOutcomeData>;
  /** Gets the customer-statement runs for the current tenant, newest first. */
  customerStatementRuns?: Maybe<CustomerStatementRunsConnection>;
  /** Null while the tenant has no businessName. */
  customerTextConsentWording?: Maybe<CustomerTextConsentWordingData>;
  /** Read from the aggregate. Only mobiles with an entry are listed. */
  customerTextConsents: Array<ContactTextConsentData>;
  /**
   * The calling tenant's customer texting setup. A tenant that never set it up reads NOT_SET_UP
   * with every other field null. Served on its own field so the portal tenant query never
   * carries it.
   */
  customerTexting: CustomerTextingData;
  /** Get all time entries with customer filtering support */
  customerTimeEntries?: Maybe<CustomerTimeEntriesConnection>;
  /**
   * Computes the customer's top-N SKUs by total quantity, with accompanying revenue, in a single
   * MongoDB aggregation. STAFF-ONLY (bare Authorize) — mirrors customerOrderStats; the
   * customer portal is out of scope for this Health-tab surface. The read honours the same
   * server-enforced order visibility scope every other order read entry point uses (tenant, plus any
   * explicit customer/route/salesperson restriction on the caller) — a caller outside their own scope
   * for the requested customer sees an empty list, never that customer's data. The order set is the SAME
   * one customerOrderStats aggregates — deleted and cancelled orders excluded — because the two are
   * read side by side on one panel and an aggregate over money and quantity must agree with the counters
   * beside it. Revenue honours OverridePrice over Price where set, matching how the order
   * itself values the line; quantity falls back to OrderedQuantity when null. Ties are broken by
   * SKU ascending for a deterministic order. top is clamped to [1, 50] so a caller cannot request
   * an unbounded result. A customer with no qualifying line items — or a malformed customerId —
   * returns an empty list, never null. The optional shipToLocationId narrows the order set to one
   * ship-to store; an unknown store, or a malformed id, returns an empty list.
   */
  customerTopSkus: Array<CustomerTopSku>;
  /**
   * Returns the tenant-scoped, paged customer types over the CustomerTypes summary
   * read model. [UseFiltering] exposes a status filter (plus every other
   * document field) so callers can request active-only, inactive-only, or unfiltered results.
   * Soft-deleted types (AI Helm fd75fc05) are excluded unconditionally in the base Find
   * filter, not via a [UseFiltering] pass-through predicate -- a deleted type can never
   * be fetched back through this query by any caller-supplied filter combination.
   */
  customerTypes?: Maybe<CustomerTypesConnection>;
  customers?: Maybe<CustomersConnection>;
  /**
   * Returns the caller's customers whose name matches any of the requested names
   * CASE-INSENSITIVELY, so a CSV cell carrying "walmart" resolves the stored customer "Walmart".
   * Same tenant scoping, caller visibility scope, filter and sort surface as customers;
   * this arm only adds the name predicate, which where: { name: { in: [...] } } cannot
   * express because every string filter operation is case-sensitive.
   * Match rule: whitespace runs are collapsed and the ends trimmed on BOTH sides, then the names
   * are compared ignoring case - the same rule the pwa's CSV imports key their own lookups by, so
   * raw CSV cells can be sent as-is. Names that normalize to blank are ignored, as are names
   * longer than a customer name can be stored (128 characters), which can identify no customer;
   * requesting no usable name returns an EMPTY page rather than the tenant's whole customer book.
   * A name nothing matches simply contributes no nodes, so an unknown customer stays a row-level
   * import issue rather than a failed query. Requesting more than 1000 names is refused with a
   * validation error; chunk a larger file client-side.
   */
  customersByNames?: Maybe<CustomersByNamesConnection>;
  /**
   * Returns the full stored state of the requested customers - the same CustomerStateData
   * customer(customerId) returns, locations, billing addresses and contacts included - so a
   * CSV import can compare its file against existing customers before it writes anything.
   * An id that does not exist in the caller's tenant, or names a deleted customer, is left out and
   * the request does not fail. Ids are de-duplicated and paged in a stable ordinal order;
   * a cursor names the customer id it follows, so the same cursor always resumes at the same
   * customer. Only the customers on the requested page are read. A page holds at most 100 nodes
   * (the default), and may hold fewer when some of its ids are not found - keep following
   * pageInfo.endCursor while hasNextPage is true. Requesting more than 1000 ids is
   * refused with a validation error; chunk a larger file client-side. An empty list returns an
   * empty page.
   *
   *
   * **Returns:**
   * One page of the requested customers that exist, in ordinal id order.
   */
  customersForImport?: Maybe<CustomersForImportConnection>;
  /**
   * Single-assignment detail. Returns null when the id does not match a
   * document on the caller's tenant.
   */
  cycleCountAssignment?: Maybe<AssignmentSummaryDocument>;
  /**
   * Returns cycle count submissions for the current tenant.
   * Supports optional filtering by location and/or recorded-by email.
   * Defaults to the last 7 days when no date filter is applied.
   */
  cycleCountHistory?: Maybe<CycleCountHistoryConnection>;
  deletedStreamTransactions?: Maybe<DeletedStreamTransactionsConnection>;
  deletedStreams?: Maybe<DeletedStreamsConnection>;
  deliverySchedule?: Maybe<DeliveryScheduleStateData>;
  /**
   * Whether a deposit recorded for the caller's tenant is written back to its connected accounting
   * platform through Merge (one journal entry), and why not when it is not. Reads the tenant's
   * current Merge link, the same state the deposit export decision reads.
   */
  depositWriteBackCapability: DepositWriteBackCapabilityPayload;
  /**
   * Single-device detail, scoped to the caller's tenant — a device owned by another tenant (or that
   * does not exist) resolves to null, applying the same ownership scoping as the device
   * mutations.
   */
  device?: Maybe<DeviceDocument>;
  /**
   * Unclaimed devices awaiting a claim (status Lobby), scoped to the devices assigned to the
   * caller's OWN tenant — a Lobby device is unowned but not unscoped: registerDevice stamps
   * which tenant it was shipped to, and that assignment is the visibility boundary, not a global
   * "anyone can browse" lobby. Mirrors the tenant-scoping that the fleet query applies post-claim.
   * Listing is deliberately NOT the same thing as claimable: a device whose claim code has lapsed
   * stays in this list — nothing moves it out of Lobby — so compare each row's
   * claimCodeExpiresAt against now and render an expired device as "expired — reissue
   * required" rather than offering a code that claimDevice will reject. Reissue is
   * reissueDeviceClaimCode (SuperAdmin/factory), which mints a fresh code and moves
   * claimCodeExpiresAt forward, so a rescued row stops rendering as expired.
   */
  deviceLobby?: Maybe<DeviceLobbyConnection>;
  /** One device's OTA delivery and outcome, or null when it was never offered or reported. */
  deviceOtaState?: Maybe<DeviceOtaStateDocument>;
  /**
   * The exact target string WorkSuite last wrote to the device's desired otaTarget and confirmed against its fence: a
   * signed manifest token, or an empty string for no current offer. Null when nothing was ever delivered.
   */
  deviceOtaTarget?: Maybe<DeviceOtaTargetData>;
  /**
   * The individual desired-config keys a device registered under profile accepts — every key
   * setDeviceDesiredConfig takes except the static network group (netMode, staticIp,
   * staticMask, staticGateway, dnsPrimary, dnsSecondary), which is set as a whole and may be left out,
   * and except the keys reserved but not yet used by the firmware (firmwareChannel, thresholdLow,
   * thresholdHigh), which are still accepted on write but never required.
   * Lets a client validate before submitting instead of hardcoding its own key list and discovering a
   * mismatch only as a runtime rejection.
   */
  deviceProfileConfigKeys: Array<Scalars['String']['output']>;
  /**
   * Device + metric history, bucketed/downsampled server-side for chart rendering. Tenant-scoped:
   * the query only ever reads readings whose Meta.TenantId matches the caller's own tenant,
   * regardless of which deviceId is requested.
   */
  deviceTelemetryHistory: Array<DeviceTelemetryBucketData>;
  /**
   * The latest reading per metric — for ONE device (device detail) when deviceId is supplied, or
   * across the caller's whole tenant fleet (fleet grid) when it is omitted. Always tenant-scoped.
   */
  deviceTelemetryLatest: DeviceTelemetryLatestData;
  /**
   * The caller's tenant fleet — every device it currently owns or has ever owned (Claimed and
   * Decommissioned; Lobby devices belong to no one and never appear here).
   */
  devices?: Maybe<DevicesConnection>;
  /** Due scheduled inventory transfers across every tenant: status SCHEDULED and dueAt at or before now, ordered by dueAt then id, strictly after the optional cursor, at most 50. WorkerService only. */
  dueScheduledInventoryTransfers: Array<DueScheduledInventoryTransfer>;
  /** Every pair key the tenant has for one entity type, in any status. Worker only. */
  duplicateCandidatePairKeys: Array<Scalars['String']['output']>;
  /**
   * The tenant's duplicate pairs in one status, newest first, optionally for one entity type, with the counts
   * for every entity type and whether a requested check is still waiting for the worker.
   * Admin staff and the duplicate finder worker only.
   */
  duplicateCandidates: DuplicateCandidatesPayload;
  /**
   * Returns the delivery schedule in force for one customer ship-to location: the location's own
   * override, else the schedule mapped to its effective route, else unrestricted. The response
   * carries which of those won, the route it resolved through, and the schedule it read, so a
   * form can render the effective days without reproducing any rule. Only Active schedules take
   * effect; an inactive or deleted one is skipped and the next setting applies. An active
   * schedule selecting no day still reports its id and name, staying distinguishable from nothing
   * being configured. Resolves against the caller's own tenant — an unknown or deleted customer,
   * or a location that is not that customer's, returns null.
   * Naming a location is what makes the route tier reachable: the route is inherited from the
   * ship-to, so omitting locationId (or passing an empty id) resolves no route and the answer is
   * unrestricted unless that location carries a schedule of its own. Pass the ship-to whenever
   * one is known.
   */
  effectiveDeliverySchedule?: Maybe<EffectiveDeliveryScheduleData>;
  /**
   * Resolves the effective sender for the current tenant across all channels, from the tenant's
   * approved sender selection: the platform sender under PLATFORM; the pinned company sender under
   * COMPANY (reported with a non-verified status while it is not selectable, never replaced by
   * another sender); under INHERIT the selectable default if set, else the earliest selectable
   * sender, else the synthesized platform-default fallback. tenantEmailSenderSelection reads the
   * same route with its readiness and reply routing. Deliberately
   * UNCHANGED by Decision D's adminOnly flag and the caller's role — the tenant default may
   * be admin-only because background/automatic sends are system acts, not user acts.
   */
  effectiveEmailSender: TenantEmailSenderData;
  /**
   * Where one item's revenue would post today: the account, the precedence rung that supplied it,
   * and any category disagreement stepped over on the way. Walks the item rung, then the item's
   * categories, then the tenant default — NOT the customer type, which is invoice-wide and can
   * still outrank all of it, which note says in words. Answers UNMAPPED with a null account for an
   * item with no mapping anywhere, and for an itemId this tenant does not have: an unknown item and
   * an unmapped one route the same, and neither is an error.
   */
  effectiveIncomeGlAccount: EffectiveIncomeGlAccount;
  /**
   * Gets email-send records for the current tenant, most recent first, optionally filtered by
   * order identifier, order number, report identifier, schedule identifier, or a sentAt
   * range. The sentAt range is an explicit server-built arg (not the generated where-input)
   * because SentAt is persisted as a BSON date for correct DESC
   * paging, and HotChocolate's generated DateTimeOffset where-filter serializes to a
   * {DateTime,Ticks,Offset} document shape that never matches that stored BSON date. Pairs
   * with the persisted, indexed deliveryStatus where-filter (Email Issues failure grid).
   */
  emailSends?: Maybe<EmailSendsConnection>;
  entityCheckpoints: Array<EntityCheckpointDocument>;
  /**
   * This does not follow the pattern: pull tenantId from accessToken.
   * UPDATE: When ready (requires the ability to easily change tenant authorization), update to follow current pattern.
   */
  entityEvents: Array<ResolvedEventData>;
  /**
   * Compares, for every ship-to of a tenant, the salespeople stored today (LocationsSalesPerson) with
   * the salespeople the ERP route data derives on asOfDate, and reports who would be added,
   * who would be dropped, the totals, and every person who would lose access with the number of ship-tos
   * they lose. Platform superadmin only. It reads the ERP data directly, so the tenant's
   * ErpAccessDerivation switch can be OFF; it is read-only.
   */
  erpAccessDarkRunDiff: ErpAccessDarkRunDiffResult;
  erpAvailability?: Maybe<ErpAvailabilityConnection>;
  erpFinishAvailability: Array<ErpAvailabilityRefreshItem>;
  erpItemPrices: Array<ErpItemPricingDocument>;
  erpItemPricing?: Maybe<ErpItemPricingStateData>;
  erpLoadListAvailability?: Maybe<ErpLoadListAvailabilityConnection>;
  erpLoadListQuantities?: Maybe<ErpLoadListQuantitiesConnection>;
  erpLoadListRoutes?: Maybe<ErpLoadListRoutesConnection>;
  erpLoadListSession?: Maybe<ErpLoadListSessionStateData>;
  erpLoadListSessions?: Maybe<ErpLoadListSessionsConnection>;
  erpLoadListUser?: Maybe<ErpLoadListUserStateData>;
  erpLoadListUsers?: Maybe<ErpLoadListUsersConnection>;
  erpManagerEmails?: Maybe<ErpManagerEmailsStateData>;
  erpPriceGroups: Array<Maybe<Scalars['String']['output']>>;
  erpStationRoutes: Array<Scalars['String']['output']>;
  erpStations: Array<Scalars['String']['output']>;
  /**
   * The calling tenant's ERP write-back hold, or null when the tenant has never set one. It is the hold's
   * read model, so it can trail a set by a moment; the claims and erpWriteBackRecordingEpoch read the hold
   * as it was set. Tenant admins only; anyone else gets an error.
   */
  erpWriteBackHold?: Maybe<ErpWriteBackHoldDocument>;
  /**
   * Returns the calling tenant's ERP write-back records, filterable and sortable for inspection
   * (queue depth, failure triage). Scoped to the caller's tenant. Worker consumption uses the
   * claimPendingErpWriteBacks mutation (atomic lease), NOT this query.
   */
  erpWriteBackQueue?: Maybe<ErpWriteBackQueueConnection>;
  /**
   * The recording epoch the calling tenant's apps stamp on the writes they record (the X-Sf-Recording-Epoch
   * header): 0 when the tenant has never set a hold, the rollback epoch less 1 while a rollback hold is
   * on, and the rollback epoch otherwise. Any signed-in user of the tenant may read it.
   */
  erpWriteBackRecordingEpoch: Scalars['Int']['output'];
  eventCounts?: Maybe<EventCountsConnection>;
  eventStreamAggregates?: Maybe<EventStreamAggregatesConnection>;
  /**
   * Records past their retention period and not yet purged, across every tenant, earliest due first, at
   * most 25, for the purge to take one at a time. Worker only.
   */
  expiredMigrationRecords: Array<MigrationExpiredRecord>;
  /**
   * Resolves the effective feature flag value for the authenticated tenant. The tenant's own on/off setting wins;
   * otherwise the flag is on when one of the tenant's products turns it on; otherwise it is off when the tenant's
   * trial allow-list does not name it; otherwise the global value decides. A settings-only own setting never
   * decides on/off, and its settings are merged in when the flag is on. Returns defaults if the flag is inactive
   * or not found.
   */
  featureFlag: FeatureFlagValueResult;
  /** One conversion job as it now stands, or null when there is no job by that id. */
  featureFlagProductConversionJob?: Maybe<FeatureFlagProductConversionJob>;
  fernieFindCandidates: FernieFindCandidatesPayload;
  fernieGapCandidates: FernieGapCandidatesPayload;
  fernieGapJob?: Maybe<FernieGapJob>;
  fernieQuickBooksLinks: FernieQuickBooksLinksPayload;
  fernieStripeTaxCodeCandidates: FernieStripeTaxCodeCandidatesPayload;
  fernieValuesInUse: FernieValuesInUsePayload;
  /** One release's manifest and a download link for every file in it. */
  firmwareDownload?: Maybe<FirmwareDownload>;
  /** Every published firmware build, newest first, optionally narrowed to one device model. */
  firmwareReleases: Array<FirmwareRelease>;
  /**
   * The calling tenant's charge list: every entry, or only the active ones an order can pick from when
   * activeOnly is true. Each entry resolves its QuickBooks account through account.
   */
  flatChargeTypes?: Maybe<FlatChargeTypesConnection>;
  /** Get all floating time entries for the tenant from MongoDB with paging, filtering, and sorting. */
  floatingTimeEntries?: Maybe<FloatingTimeEntriesConnection>;
  /** Get a single floating time entry by ID from the event store. */
  floatingTimeEntry?: Maybe<FloatingTimeEntryStateData>;
  /**
   * Returns a single active forecast by id for the calling tenant, or null when it does not exist,
   * is soft-deleted, or the Forecast flag is disabled. The read filters on the composite
   * _id ({tenantId}-{forecastId}), which embeds the tenant, so it cannot return
   * another tenant's forecast (discipline acada0ab).
   */
  forecast?: Maybe<ForecastDocument>;
  /**
   * The per-source freshness watermark of the calling tenant's synced history (W6): the latest transaction
   * Date in each ImportData source, capped at now. The Forecast feature gate is checked FIRST — a
   * tenant without the flag gets null, never a peek at ImportData. The read is scoped to the caller's
   * tenant (guarded by a cross-tenant leak test). This is the same max-transaction-date a generation run
   * pins its inputs at (ADR-001 ARCH-3), from one shared computation; an empty source reports null.
   */
  forecastHistoryWatermark?: Maybe<ForecastHistoryWatermark>;
  /**
   * Returns one holiday reference row by id for the calling tenant, or null when it does not exist, is
   * soft-deleted, or the FORECAST flag is disabled. Reads by the tenant-scoped composite _id, so the
   * read cannot cross tenants by construction.
   */
  forecastHoliday?: Maybe<HolidayDocument>;
  /**
   * Returns the calling tenant's active holiday reference rows (soft-deleted rows excluded), ordered by
   * date. Tenant-scoped via the stored TenantId, guarded by a cross-tenant leak integration test.
   * Returns an empty list when the FORECAST flag is disabled (the module is dark, nothing is exposed).
   */
  forecastHolidays: Array<HolidayDocument>;
  /**
   * Returns the calling tenant's forecast comp settings, or the A2 defaults when the tenant has
   * never saved (so the Assumptions page and generation always have a full config to snapshot).
   * When the Forecast flag resolves to disabled the
   * module is dark for the tenant and the query returns null — no settings are exposed.
   */
  forecastSettings?: Maybe<ForecastSettingsStateData>;
  /**
   * Computes the plan-grid Summary panel KPIs (spec §3.2) for a forecast over an optional scope, in a
   * single MongoDB aggregation. The FORECAST feature gate is checked FIRST: a tenant without the flag
   * gets null (no read-model rows are exposed), never a computed rollup. The forecast id is validated,
   * the read is scoped to the caller's tenant AND the forecast (guarded by a cross-tenant leak test),
   * and every weighted-average / vs-last-year division is zero-guarded. A well-formed forecast with no
   * rows in scope returns a zeroed summary (not null) so the panel can render zeros; null is reserved
   * for the feature-disabled and malformed-id cases.
   */
  forecastSummary?: Maybe<ForecastSummary>;
  /**
   * Returns the weekly-cell totals per plan row (region × item) for a forecast — the Σ-weeks-by-metric
   * inputs the PWA plan grid's Delta column needs (spec §3.2, W12 DoD), in a single MongoDB aggregation
   * over the worker-owned ForecastWeeklyCells collection. The FORECAST feature gate is checked
   * FIRST: a tenant without the flag gets an empty list (no read-model rows are exposed). The forecast id
   * is validated, the read is scoped to the caller's tenant AND the forecast (guarded by a cross-tenant
   * leak test), and the compound (TenantId, ForecastId, Region, ItemId) index serves both the
   * $match and the group-by-(region, item). An optional scope narrows to a subset of regions/items.
   */
  forecastWeeklyDeltaInputs: Array<ForecastWeeklyDeltaInput>;
  /**
   * Lists the calling tenant's active (non-soft-deleted) forecasts. Tenant-scoped via the
   * load-bearing TenantId filter, guarded by a cross-tenant leak integration test. Returns no rows
   * when the Forecast flag is disabled for the tenant.
   */
  forecasts?: Maybe<ForecastsConnection>;
  /**
   * The load's latest Freight Quote send to its carrier: its state, recipient, sent time and provider id.
   * Null when none was ever requested.
   */
  freightQuoteSendStatus?: Maybe<FreightQuoteSend>;
  /**
   * Generates a CSV for the specified report with optional parameter overrides. A report with
   * spreadsheet columns writes exactly those columns, in order, under their headers; a report without
   * them writes its data source's default columns. A saved view the caller cannot open is refused as not found.
   *
   *
   * **Returns:**
   * Payload with Success=true and CsvBase64 populated on success; Success=false with ErrorMessage on failure.
   */
  generateReportCsv: ReportCsvPayload;
  /**
   * Generates an Excel workbook for the specified report with optional parameter overrides. A report
   * with spreadsheet columns writes exactly those columns, in order, under their headers, every cell
   * formatted as text so leading zeros survive; a report without them writes its data source's default
   * columns. A saved view the caller cannot open is refused as not found.
   *
   *
   * **Returns:**
   * Payload with Success=true and ExcelBase64 populated on success; Success=false with ErrorMessage on failure.
   */
  generateReportExcel: ReportExcelPayload;
  /**
   * Generates a PDF for the specified report with optional parameter overrides. A saved view the caller cannot
   * open is refused as not found.
   *
   *
   * **Returns:**
   * Payload with Success=true and PdfBase64 populated on success; Success=false with ErrorMessage on failure.
   */
  generateReportPdf: ReportPdfPayload;
  /**
   * Reads one GrowPoint commit of the caller's tenant by its commit id: status, the reviewed rows
   * with their versions, the rejection reason and changed rows when it was rejected, and each
   * row's created, updated, failed or unknown outcome with its canonical id and Synchronization
   * iteration id, exactly as recorded. Null when the tenant has no commit with that id. Reading
   * never writes.
   */
  growPointCommit?: Maybe<GrowPointCommitData>;
  /**
   * The queued GrowPoint commit the import worker for entity should run for
   * tenantId, or null when none is queued. Gated to the wsapi-services worker
   * tier. Rows that already have an outcome carry it, so a resumed run can skip them.
   * stagingConflicts compares the reviewed rows with current staging at the time of this
   * read: when it is not empty the batch can no longer run exactly as reviewed.
   */
  growPointPendingCommit?: Maybe<GrowPointPendingCommitData>;
  /**
   * The current version of every staged row of one GrowPoint entity for the caller's tenant,
   * ordered by row id. A row is one staged summary document (row id = its document id); its
   * version changes whenever any staged document of the row changes, including its import-command
   * echo and child documents. Send these back unchanged as the reviewed rows of
   * commitGrowPointStagedRows. Reading never writes.
   */
  growPointStagedRowVersions: Array<GrowPointStagedRowVersionData>;
  /**
   * Lists access-log audit entries for communityId ordered by occurredAt descending and entryId descending.
   * Restricted to callers holding an effective COMMUNITY_ADMIN roster entry (or platform superadmin).
   */
  growerBenchmarkAccessLog: Array<GrowerBenchmarkAccessLogEntry>;
  /**
   * Downloads the access log of communityId as a CSV file whose header and row order match the console's access
   * log table (contract K3). Open to any effective roster entry on the community and to platform superadmins.
   */
  growerBenchmarkAccessLogExport?: Maybe<GrowerBenchmarkAccessLogExport>;
  /**
   * Lists the calling reader's own dashboard and compare activity trail entries for communityId, newest
   * first, defaulting to 20 and capped at 100 (contract C1).
   */
  growerBenchmarkActivity: Array<GrowerBenchmarkActivityEntry>;
  /**
   * Lists one billing summary row per active registered firm in communityId, combining console external billing
   * fields with bounded WorkSuite subscription status and current period end reads for WORKSUITE-billed firms
   * (contracts K1 and K2). Open to any effective roster entry on the community and to platform superadmins.
   */
  growerBenchmarkBillingSummary: Array<GrowerBenchmarkBillingSummaryRow>;
  /**
   * Resolves the canonical cohort key, matching firm count, floor flag, and community-wide period submission
   * coverage for selection without throwing on a sub-floor selection (contract C1).
   */
  growerBenchmarkCohort: GrowerBenchmarkCohort;
  /**
   * Lists the available classification facets and per-option firm counts and floor flags for communityId
   * and periodId (contract C1).
   */
  growerBenchmarkCohortFacets: Array<GrowerBenchmarkCohortFacet>;
  /**
   * Reads the cohort statistics pass runs of communityId, newest first, for periodId alone when supplied
   * (contract M3). Restricted to effective COMMUNITY_ANALYST roster holders and platform superadmins.
   */
  growerBenchmarkCohortPassRuns: Array<GrowerBenchmarkCohortPassRun>;
  /**
   * Reads the cohort statistics of communityId in periodId, for metricKey and cohortKey alone when supplied
   * (contract M3). Restricted to effective COMMUNITY_ANALYST roster holders and platform superadmins.
   */
  growerBenchmarkCohortStatistics: Array<GrowerBenchmarkCohortStatistic>;
  /**
   * Reads one GrowerBenchmark community, its firm registry, and its roster. Open to any effective roster entry on the
   * community and to platform superadmins.
   */
  growerBenchmarkCommunity?: Maybe<GrowerBenchmarkCommunity>;
  /**
   * Returns active catalog metrics, cohort statistics, caller position, and anonymized peer rows for
   * selection, refusing cohorts below the five-firm floor with GROWER_BENCHMARKS_COHORT_BELOW_FLOOR
   * (contract C1).
   */
  growerBenchmarkCompare: Array<GrowerBenchmarkCompareMetric>;
  /** Lists the calling reader's own saved compare views for communityId, newest first (contract C1). */
  growerBenchmarkCompareViews: Array<GrowerBenchmarkCompareView>;
  /**
   * Reads one GrowerBenchmark collection cycle (open or closed) by cycleId with live firm standing counts (contract D9).
   * Restricted to callers holding any effective roster entry on the cycle's community and to platform superadmins;
   * an unknown cycleId returns GROWER_BENCHMARKS_ACCESS_DENIED rather than a distinct not-found error.
   */
  growerBenchmarkCycle?: Maybe<GrowerBenchmarkCycle>;
  /**
   * Reads the approved facts of communityId in periodId, for firmId alone when supplied (contract M3). Restricted
   * to effective COMMUNITY_ANALYST roster holders and platform superadmins; a firmId not registered in the
   * community returns GROWER_BENCHMARKS_ACCESS_DENIED.
   */
  growerBenchmarkFacts: Array<GrowerBenchmarkFact>;
  /**
   * Returns the anonymized firm codes inside selection whose classification or metric attribute satisfies
   * predicate, with no peer statistics, refusing cohorts below the five-firm floor with
   * GROWER_BENCHMARKS_COHORT_BELOW_FLOOR (contract C1).
   */
  growerBenchmarkFirmCodesMatching: Array<Scalars['String']['output']>;
  /**
   * Reads the caller firm's GrowerBenchmark results page payload for periodId, or for the firm's most recent
   * computed period when periodId is omitted (contract C1).
   */
  growerBenchmarkFirmHome?: Maybe<GrowerBenchmarkFirmHome>;
  /**
   * Reads the firm metric values of communityId in periodId, for firmId and metricKey alone when supplied, each
   * with its rank and cohort size computed from the cohort statistic row (contract M3). Restricted to effective
   * COMMUNITY_ANALYST roster holders and platform superadmins; a firmId not registered in the community returns
   * GROWER_BENCHMARKS_ACCESS_DENIED.
   */
  growerBenchmarkFirmMetrics: Array<GrowerBenchmarkFirmMetric>;
  /**
   * Reads the console firm profile for firmId in communityId (contract K2). Open to any effective roster entry on
   * the community and to platform superadmins; refuses firms outside the community with GROWER_BENCHMARKS_ACCESS_DENIED.
   */
  growerBenchmarkFirmProfile?: Maybe<GrowerBenchmarkFirmProfile>;
  /**
   * Lists the staged imported-lines documents of communityId, narrowed by reportingUnitId and periodId when
   * given, newest staged first. Restricted to platform superadmins.
   */
  growerBenchmarkImportedLines: Array<GrowerBenchmarkImportedLines>;
  /**
   * Lists review instruction sets and their immutable versions for communityId. Open to callers holding any
   * effective roster entry on the community and to platform superadmins.
   */
  growerBenchmarkInstructionSets: Array<GrowerBenchmarkInstructionSet>;
  /**
   * Lists every active registered firm in communityId together with its console firm profile, tags, ticker, and
   * onboarding checklist (contract K2). Open to any effective roster entry on the community and to platform
   * superadmins.
   */
  growerBenchmarkMemberDirectory: Array<GrowerBenchmarkMemberDirectoryRow>;
  /**
   * Reads communityId's metric catalog ordered by group, sort order and key, active metrics only unless
   * includeInactive is true (contract M3). Restricted to effective COMMUNITY_ANALYST roster holders and platform
   * superadmins.
   */
  growerBenchmarkMetricCatalog: Array<GrowerBenchmarkMetric>;
  /**
   * Lists every active catalog metric definition for communityId in sortOrder with its formula,
   * inputs, unit, decimals, direction, bands, and derived target (contract C1).
   */
  growerBenchmarkMetricDefinitions: Array<GrowerBenchmarkMetricDefinition>;
  /**
   * Lists every GrowerBenchmark community where the caller holds an effective roster entry (or every registered
   * community for platform superadmins, returning an empty list when none exists). Non-superadmin callers whose
   * tenant and user are associated with no community receive GROWER_BENCHMARKS_FIRM_NOT_REGISTERED.
   */
  growerBenchmarkMyCommunities: Array<GrowerBenchmarkCommunity>;
  /**
   * Lists every active firm registry entry belonging to the caller's own tenant across all GrowerBenchmark
   * communities. Returns GROWER_BENCHMARKS_FIRM_NOT_REGISTERED when the caller's tenant holds no active firm
   * registration in any community.
   */
  growerBenchmarkMyFirms: Array<GrowerBenchmarkFirm>;
  /**
   * Reads the currently open reporting period for the caller's own member firm in communityId, returning null when
   * no reporting period is open (contract D9). Returns GROWER_BENCHMARKS_FIRM_NOT_REGISTERED when the caller's tenant holds
   * no active firm in communityId and GROWER_BENCHMARKS_ACCESS_DENIED when communityId is unknown.
   */
  growerBenchmarkMyPeriod?: Maybe<GrowerBenchmarkMyPeriod>;
  /**
   * Reads the approved version of a single released GrowerBenchmark review belonging to the caller's member firm
   * (contract R4). Raises GROWER_BENCHMARKS_REVIEW_NOT_APPROVED while Drafted or InEdit, GROWER_BENCHMARKS_REVIEW_NOT_RELEASED
   * while Approved and not yet released, and GROWER_BENCHMARKS_ACCESS_DENIED for unknown reviews or reviews belonging to
   * another firm.
   */
  growerBenchmarkMyReview?: Maybe<GrowerBenchmarkReview>;
  /**
   * Renders the approved version of a single released GrowerBenchmark review belonging to the caller's member firm as a
   * PDF, on demand, storing nothing (contract R4). A refusal returns success false, a null pdfBase64 and only the
   * stable code in errorMessage: GROWER_BENCHMARKS_DISABLED, GROWER_BENCHMARKS_ACCESS_DENIED, GROWER_BENCHMARKS_FIRM_NOT_REGISTERED,
   * GROWER_BENCHMARKS_REVIEW_NOT_APPROVED or GROWER_BENCHMARKS_REVIEW_NOT_RELEASED.
   */
  growerBenchmarkMyReviewPdf: GrowerBenchmarkReviewPdfPayload;
  /**
   * Lists the calling member firm's released GrowerBenchmark reviews across every community in which the caller's tenant
   * holds an active firm registration, serving only each review's approved version (contract R4). Raises
   * GROWER_BENCHMARKS_FIRM_NOT_REGISTERED when the caller's tenant is registered in no community.
   */
  growerBenchmarkMyReviews: Array<GrowerBenchmarkReview>;
  /**
   * Reads the currently open collection cycle for communityId with live firm standing counts, or returns null when
   * no cycle is open (contract D9). Restricted to callers holding any effective roster entry on the community and
   * to platform superadmins.
   */
  growerBenchmarkOpenCycle?: Maybe<GrowerBenchmarkCycle>;
  /**
   * Lists every reporting period for which the caller's firm has computed GrowerBenchmark figures in communityId,
   * ordered newest first (contract C1).
   */
  growerBenchmarkPeriods: Array<GrowerBenchmarkPeriod>;
  /**
   * Reads a single persisted GrowerBenchmark module purge run by purgeRunId from the default database, or null when no
   * matching record exists. Restricted to platform superadmins.
   */
  growerBenchmarkPurgeRun?: Maybe<GrowerBenchmarkPurgeRun>;
  /**
   * Lists persisted GrowerBenchmark module purge runs from the default database ordered newest first. Restricted to
   * platform superadmins.
   */
  growerBenchmarkPurgeRuns: Array<GrowerBenchmarkPurgeRun>;
  /**
   * Previews a bulk reclassification before it is saved: per band and per cohort, the current and proposed firm
   * counts over the community's active firms whose tenant has the GrowerBenchmark module on, and which rows fall below
   * the five-firm floor. A row below the floor is withheld for every metric; a row at or above it can still be
   * withheld for a metric fewer than floorFirmCount of its firms report. Writes nothing. Requires an effective
   * COMMUNITY_ANALYST roster entry (or platform superadmin) and refuses firms outside the community with
   * GROWER_BENCHMARKS_ACCESS_DENIED.
   */
  growerBenchmarkReclassifyFirmsPreview: GrowerBenchmarkReclassifyFirmsPreview;
  /**
   * Lists per-firm GrowerBenchmark review queue rows in communityId, optionally filtered by periodId and status. Open to
   * callers holding any effective roster entry on the community and to platform superadmins.
   */
  growerBenchmarkReportQueue: Array<GrowerBenchmarkReviewQueueRow>;
  /**
   * Reads one projected GrowerBenchmarkRetailMonthValues document by submissionId when it belongs to one of the caller's
   * registered member firms across all GrowerBenchmark communities, or returns null when absent (contract CR2).
   */
  growerBenchmarkRetailMonthValues?: Maybe<GrowerBenchmarkRetailMonthValues>;
  /**
   * Lists one GrowerBenchmarkRetailMonth row per calendar month in the inclusive range fromPeriodId..toPeriodId for
   * reportingUnitId across the caller's registered member firms, carrying null status, version, submissionId, and
   * values on months with no submission (contract CR2).
   */
  growerBenchmarkRetailMonths: Array<GrowerBenchmarkRetailMonth>;
  /**
   * Reads a single per-firm GrowerBenchmark review and its full version history by reviewId for reviewer inspection. Open
   * to callers holding any effective roster entry on the owning community and to platform superadmins; unknown or
   * unauthorized reviews raise GROWER_BENCHMARKS_ACCESS_DENIED.
   */
  growerBenchmarkReview?: Maybe<GrowerBenchmarkReview>;
  /**
   * Returns the separate per-firm review count and retainer content count approved for communityId and periodId,
   * exposing no combined total (contract R4). Open to callers holding any effective roster entry on the community
   * and to platform superadmins.
   */
  growerBenchmarkReviewMetering: GrowerBenchmarkReviewMetering;
  /**
   * Lists projected GrowerBenchmark submission versions in communityId ordered by createdAt descending and submissionId
   * descending, optionally filtered by reportingUnitId and periodId. Community analysts and platform superadmins
   * see all firms in the community; member-firm callers see only their own tenant's firms.
   */
  growerBenchmarkSubmissions: Array<GrowerBenchmarkSubmission>;
  /**
   * For each subject of one fernie idea, either accessDenied alone, or the subject's tenant and firm, whether the
   * module and the company's fernie suggestions are on for it, whether it is excluded and, when all of those hold,
   * its current revision, what code already settled, and the redacted state and options that may be asked about.
   * At most 50 subjects per call.
   */
  growerBenchmarksDecisionContext: Array<GrowerBenchmarkDecisionContextData>;
  /**
   * Returns the rows of the Hardgoods Inventory grid for the calling tenant. When
   * siteLocationId is provided, rows are scoped to that site; when
   * omitted (null), rows across all sites for the tenant are returned.
   * One row per (MaterialItemId, SiteLocationId), carrying the per-bin on-hand
   * breakdown, the last-counted timestamp, and the active cycle-count assignment (if any).
   */
  hardgoodsInventoryGrid?: Maybe<HardgoodsInventoryGridConnection>;
  /**
   * Returns the required quantity per material item over an inclusive range of NEEDED weeks
   * (recipe material multiple × scheduled production job lot size, summed), plus the
   * recipe-coverage percentage for the tenant. Each material counts in the week it is needed: the
   * ISO week of its Event Schedule trigger date (the row's scheduled week), which is the material
   * event detail's trigger measured from its job's start or ready week. A job that started before
   * the range still counts for the material it needs inside the range, and material a job needs
   * outside the range does not count, wherever the job starts.
   */
  hardgoodsRequiredByNeededWeekRange: HardgoodsRequiredSummary;
  /**
   * Returns the required quantity per material item for a ready week (recipe material
   * multiple × scheduled production job lot size, summed), plus the recipe-coverage
   * percentage for the tenant.
   */
  hardgoodsRequiredByReadyWeek: HardgoodsRequiredSummary;
  /**
   * The same answer as hardgoodsRequiredByNeededWeekRange under the field's original
   * argument names, kept so existing callers keep working. The weeks the startWeek arguments
   * name are NEEDED weeks: each material counts in the week it is needed, not in its job's start week.
   * @deprecated Counts each material in the week it is needed, the same as hardgoodsRequiredByNeededWeekRange. Use that field and its neededWeek arguments.
   */
  hardgoodsRequiredByStartWeekRange: HardgoodsRequiredSummary;
  /** One CSV wizard import, or null when the tenant has none with that id. */
  importSession?: Maybe<ImportSession>;
  /**
   * The rows a CSV wizard import could not load, in the order the wizard reported them. Empty when none failed or
   * the tenant has no import with that id.
   */
  importSessionRows: Array<ImportSessionRow>;
  /**
   * The tenant's CSV wizard imports, newest first. Narrow them with where on kind, status, startedAt and
   * startedBy.
   */
  importSessions?: Maybe<ImportSessionsConnection>;
  /**
   * One document of the company. Null when the company has no document with the id. INBOUND_DOCUMENTS_DISABLED
   * when forwarding documents is not turned on.
   */
  inboundDocument?: Maybe<InboundDocument>;
  /**
   * The company's forwarded and uploaded documents, newest first, at most 200. Pass a status to see only the
   * documents in it. INBOUND_DOCUMENTS_DISABLED when forwarding documents is not turned on.
   */
  inboundDocuments: Array<InboundDocument>;
  /**
   * The address the company forwards supplier documents to, who may send to it, and whether the forwarder gets a
   * reply. Null until the address is created. INBOUND_DOCUMENTS_DISABLED when forwarding documents is not turned on.
   */
  inboundIntakeSettings?: Maybe<InboundIntakeSettings>;
  /**
   * Returns a computed health snapshot for the caller's Merge.dev / accounting integration so a
   * "connected but never synced" or mis-seeded integration is visible instead of falsely green.
   * Tenant-scoped: every read is filtered to the caller's tenant; the integration is identified by the
   * supplied integrationId. Flags three distinguishable, independently-reported reasons — the
   * integration has never completed a sync cycle (no connection metadata and zero sync-state rows), no
   * enabled WsapiImport selects the tenant (so the import worker silently does nothing forever), and the
   * accounting provider is None while the Merge link is active (so outbound invoicing is silently off).
   * An integration that is not linked at all is reported healthy (nothing to fix) with no reasons.
   */
  integrationHealth: IntegrationHealthDocument;
  integrations: Array<TenantIntegrationDocument>;
  /**
   * The keyed adjustInventoryItem attempt saved under the idempotency key for one inventory key: the request
   * exactly as sent and the result it was answered with, both from the claim that submit saved, with the
   * claim's own id and time. Null means unknown, never "did not save": no claim under the key, a claim for
   * another location, item or grade, a claim past its retention window or saved before requests were
   * captured, and a location outside the caller's sites all answer null. Reading never writes.
   */
  inventoryAdjustmentAttempt?: Maybe<InventoryAdjustmentAttemptData>;
  /**
   * Which orders a regrade or a scrap of this quantity would hit if it ran now: the orders whose reservations a
   * regrade would carry to the new grade, or a scrap would release. Free stock goes first. A regrade then carries
   * the oldest orders first, and a scrap releases the newest orders first, exactly as the real change does.
   * Orders you can see come back with their number and customer; the rest are only counted.
   */
  inventoryAllocationImpactPreview: InventoryAllocationImpactPreviewPayload;
  /** Staff stock totals and customer holds across the caller's permitted sites and grades. */
  inventoryItemStockSummary?: Maybe<InventoryItemStockSummary>;
  inventoryItems?: Maybe<InventoryItemsConnection>;
  inventoryTransactions?: Maybe<InventoryTransactionsConnection>;
  /**
   * One invoice by its id, for the calling tenant. Returns null for an id with no invoice on it, for an
   * id belonging to another tenant, and for an id that is not a well-formed identifier.
   */
  invoice?: Maybe<InvoiceDocument>;
  /**
   * Invoice-type merge tokens for the order's ACTIVE issued invoice; null when the order has none.
   * Money is N2-formatted, dates use the report PDF date format. Values come from the same logic as
   * the ds-orders materializer.
   */
  invoiceEmailTokens?: Maybe<InvoiceEmailTokens>;
  /**
   * The remittance recorded under one transaction reference — every invoice it settled and by how much.
   * Returns null when no payment carries that reference for the calling tenant.
   */
  invoicePaymentGroup?: Maybe<InvoicePaymentGroup>;
  /**
   * What recording a payment of this amount, received on this date, would settle beside its cash — the
   * early-pay discount it would earn, the finance charge it would assess, and whether it would close
   * the invoice. Records nothing.
   */
  invoicePaymentPreview: InvoicePaymentPreview;
  /**
   * Which of the given orders currently have a LIVE invoice against them, or — for a Credit-type order — have
   * issued their credit memo. The complement, the orders not returned, is the set a mark-for-invoicing surface
   * offers: never-billed orders, orders whose every bill has been withdrawn, and Credit-type orders whose memo
   * has not been issued yet.
   */
  invoicedOrderIds: Array<Scalars['String']['output']>;
  /** The calling tenant's invoices, newest first by default. */
  invoices?: Maybe<InvoicesConnection>;
  iotDeadLetters?: Maybe<IotDeadLettersConnection>;
  iotIngestionMetrics: Array<IotIngestionOpsMetricsDocument>;
  item?: Maybe<ItemStateData>;
  itemAvailability: Array<ItemAvailabilityDocument>;
  /**
   * How much of each item will be available by a date, for up to 200 items in one call: what is on hand
   * and ready by then, plus planted production ready by then, minus every open order due by then
   * (allocated or not; drafts and the excluded order left out). Production not yet planted is shown
   * separately and is not part of the available figure. Staff only.
   */
  itemAvailabilityByDate: ItemAvailabilityByDatePayload;
  itemCategories: Array<Scalars['String']['output']>;
  /**
   * The calling tenant's item characteristics with their pick lists, deleted ones included so items can
   * still name them. Filter on status ACTIVE for the entries a user can pick.
   */
  itemCharacteristics?: Maybe<ItemCharacteristicsConnection>;
  /**
   * Shows what combining the loser into the survivor would do: every field with both values and the
   * result, the loser's stock and the price groups whose volume pools disagree, both of which block the
   * combine, each item's history, and whether the server would keep the same survivor. Reads only;
   * nothing is written. Refused, like the combine, when the loser carries an ERP id other than the
   * survivor's own (its own or one it absorbed in an earlier combine) and the tenant syncs items from
   * its ERP.
   */
  itemCombinePreview: ItemCombinePreviewPayload;
  itemGroups: Array<Scalars['String']['output']>;
  itemIdsByErpId: Array<ItemErpIdPair>;
  /**
   * Resolves SKUs to item ids, matched case-insensitively and exactly within the tenant, each key
   * echoed back as supplied. A combined item keeps its SKU, so its SKU resolves to the survivor at the
   * end of its chain, unless an item that is not combined now holds the SKU, which then wins. SKUs with
   * no matching item are absent from the result.
   */
  itemIdsBySku: Array<ItemSkuPair>;
  /**
   * Server-computed group headers (with per-group counts) for the Fulfill Items list pane, so the
   * client renders grouping over the full catalog without loading every item and grouping in memory.
   * groupBy selects the bucket key (scalar sort-category, item group, or canonical
   * status). search is the same every-word, any-order search the items query
   * takes, so counts equal the rows for the same text. The group's children are then lazy-loaded via the items
   * query filtered to the bucket key (where: { <field>: { eq: Key } }). Scoped to the same
   * tenant + non-deleted set as items, so the per-bucket counts sum to that query's total.
   */
  itemListGroups: Array<ItemGroupBucket>;
  /**
   * Photos for the given item at the given bin location, primary first. Returns an empty
   * list both when no photo has been captured at that (item, location) tuple AND when the lookup
   * itself fails — an invalid itemId/locationId, or a Mongo read error, collapse to the same empty
   * result as genuine absence. Callers cannot currently distinguish "no photo" from "the lookup
   * failed" from this field alone.
   */
  itemLocationPhotos: Array<ItemAvailabilityPhotoData>;
  /**
   * Photos for the given item (the item gallery, not a bin). Ordered with the primary first.
   * An empty list means no photo, or that the lookup failed — same collapse as
   * itemLocationPhotos.
   */
  itemPhotos: Array<ItemAvailabilityPhotoData>;
  itemPrice: Scalars['Decimal']['output'];
  /**
   * Read-only diagnostic companion to itemPrice: returns the full pricing-resolution
   * trace — the resolved price group and where it came from, every group price-group
   * QUALIFICATION rejected on the way and why, the used group's own conditions, per-candidate
   * level status, sibling levels on other items, the winning level, the final price, the
   * full-precision unit price with the tenant's calc precision and the quantity basis money uses,
   * and any internal error — so the UI can tell a user exactly why an item priced the way it did,
   * or didn't. This query never changes a resolved price; it only explains it. Same tenant
   * isolation as itemPrice; staff-only ([Authorize], not the portal policy), since
   * it describes a tenant's pricing configuration.
   *
   * The trace describes the rules AS THEY RESOLVE NOW (decision C, Kevin
   * 2026-08-20). FULFILL stores no per-line pricing receipt, so this is not a restatement of what
   * an already-charged line was charged under: a cutoff or a lead time edited since the order was
   * placed changes what this returns. UI copy must say so.
   *
   * Qualification is evaluated from the dates the caller supplies, and a missing date is
   * REPORTED rather than substituted (decision E). Supplying no
   * orderPlacedDate does not mean "use today" — a group carrying conditions is
   * reported as MISSING_ORDER_DATE and the trace shows the fallback, which is what makes an
   * order whose placed date never got stamped findable instead of silently discounted. A group
   * with NO conditions is unaffected by any of this, in both answer and cost.
   */
  itemPriceExplanation: ItemPriceExplanation;
  /**
   * Inverted pricing view for the Items page Pricing tab.
   * Returns every non-deleted PriceLevel targeting the given item — either directly
   * (Type == Item, TargetId == itemId) or via any category the item belongs to
   * (Type == Category, TargetId ∈ item.CategoryIds). Each row is joined with its
   * parent PriceGroup and with the target (Item or Category) for display names.
   * All joins are tenant-scoped; deleted items, categories, and price groups
   * are excluded. Read-only; does not mutate the Pricing domain.
   */
  itemPriceLevels: Array<ItemPriceLevelRow>;
  /**
   * Returns prices for multiple items in a single call.
   * When locationId is omitted, falls back to the tenant's default price group for staff callers;
   * a customer-portal caller resolves its OWN customer's price group instead (Customer → Default),
   * so a buyer is never quoted a price list that isn't theirs.
   * Supports quantity break pricing via the quantity parameter.
   */
  itemPrices: ItemPricesPayload;
  /**
   * Returns the calling tenant's production mapping for one sales item (its full set of lines, each
   * with taxonomy resolved from the native catalog), or null when the item has no mapping. Tenant-scoped
   * via the composite _id, guarded by a cross-tenant leak integration test. Returns null when neither
   * the FORECAST nor the PRODUCE flag is enabled for the tenant.
   */
  itemProductionMappings?: Maybe<ItemProductionMappingDocument>;
  itemPrograms?: Maybe<ItemProgramsConnection>;
  /**
   * Returns inventory restock metrics for a single item within a DBR session.
   * Branches on session.StationCode: non-null routes to the ERP-tenant path
   * (RestockAvailabilityDocument keyed by the synthetic ERP key, pricing
   * from ErpItemPricing); null routes to the inventory-tenant path
   * (RestockAvailabilityDocument with Source=Inventory aggregated
   * across internal locations, pricing via MongoPricingService).
   * Returns null when the session does not exist or is soft-deleted.
   */
  itemRestockMetrics?: Maybe<ItemRestockMetricsData>;
  /**
   * The "Did you mean" search for the item search bar: search with each word that matches no item replaced by the
   * closest word in the tenant's items, lowercased, and every other word kept as typed, joined by single spaces. Null when
   * every word matches an item, when no close word exists, when the search is blank, and wherever items searches
   * without the items Atlas index. A code with punctuation, such as PET-4, a word with a digit and a word under 4 letters are
   * never corrected.
   */
  itemSearchSuggestion?: Maybe<Scalars['String']['output']>;
  itemSubcategories: Array<Scalars['String']['output']>;
  /**
   * The tenant's items. search matches every word, in any order, in at least one of
   * name, SKU, UPC, ERP ID, item lookup code, genus, group, product group, sort category, or an old SKU or UPC the item
   * kept from the items combined into it, and combines with where. A typed
   * code with punctuation, such as PET-4, is matched as one unbroken piece (case-insensitive, no typo tolerance), so it
   * also finds longer codes that contain it, such as PET-45. A search with no order ranks by relevance. Where the
   * items Atlas index is enabled each word matches as a whole word or a word prefix, never a typo, and the search ranks by
   * score, which boosts an item whose name, SKU, UPC, old SKU or old UPC equals the whole search, then name;
   * itemSearchSuggestion offers a corrected search. Without that index it matches the words as typed, and a search
   * with no order lists items whose name, SKU, UPC, old SKU or old UPC equals the whole search first, then names whose
   * words all start with the search words. An explicit order replaces the ranking on either path.
   */
  items?: Maybe<ItemsConnection>;
  itemsWithBaseRateOfSale?: Maybe<ItemsWithBaseRateOfSaleConnection>;
  /**
   * Returns every non-deleted item for the caller's tenant joined with a per-item
   * sum of RestockAvailabilityDocument.Quantity and
   * RestockAvailabilityDocument.MustGoQty. Items with no
   * RestockAvailability rows return null for the joined sub-document
   * (preserved via $unwind with preserveNullAndEmptyArrays) — the
   * Restock UI uses this surface to populate the "add items" picker, which needs
   * items even when no availability has been ingested yet.
   */
  itemsWithRestockAvailability?: Maybe<ItemsWithRestockAvailabilityConnection>;
  job: JobDocument;
  /**
   * Returns the subcategory cost breakdown for a single production job within one cost category.
   *
   *
   * **Returns:**
   * The per-subcategory cost breakdown rows.
   */
  jobCostBreakdown: Array<CostCategoryBreakdown>;
  /**
   * Returns the raw recorded cost entries for a production job, optionally filtered by cost
   * category and source type.
   *
   *
   * **Returns:**
   * The matching job cost records, ordered by recorded date.
   */
  jobCostRecords: Array<JobCostRecordDocument>;
  /**
   * Returns the distinct kinds of work (subcategories) already recorded on the tenant's job cost
   * records, manual and time-entry costs alike, for suggesting names when recording a cost.
   *
   *
   * **Returns:**
   * The distinct non-empty subcategories, de-duplicated and sorted case-insensitively.
   */
  jobCostSubcategories: Array<Scalars['String']['output']>;
  /**
   * Returns the budget-versus-actual cost summary for a single production job, combining its
   * recorded costs with resolved budget totals and production progress. The budget is fixed at the
   * job's first execution; until then it is resolved live.
   *
   *
   * **Returns:**
   * The budget-versus-actual cost summary for the job.
   */
  jobCostSummary: JobCostSummary;
  /**
   * Returns the weekly cost timeline for a production job: the requested number of recent weeks
   * (bounded to a safe maximum), or, with productionWindow, every week of the
   * job's own production window.
   *
   *
   * **Returns:**
   * The weekly cost timeline entries.
   */
  jobCostTimeline: Array<CostTimelineEntry>;
  /**
   * The events attached to the jobs the selection names (job ids, or the Production Schedule's filter for Select
   * All, resolved for the caller's tenant), each with the number of selected jobs that carry it, most carried
   * first. A job counts once per event.
   */
  jobEventsInSelection: JobEventSelectionPayload;
  jobs?: Maybe<JobsConnection>;
  /**
   * A single kit by id, scoped to the caller's tenant and the Sites they can see, excluding deleted
   * kits.
   */
  kit?: Maybe<KitDocument>;
  /**
   * The kits the caller can see, excluding deleted ones, ordered by name ascending unless another
   * order is requested. With siteId, only the kits available at that Site: kits open to all Sites
   * plus kits limited to that Site or a Site above it. The optional search argument is a
   * case-insensitive "contains" over the kit name and container code.
   */
  kits?: Maybe<KitsConnection>;
  /** One currently-active, non-deactivated labor rate per labor type at asOf. */
  laborActiveRates: Array<LaborRateDocument>;
  laborDemand: LaborDemandSummary;
  /**
   * Paginated labor rate history (desc by EffectiveFrom). Filters deactivated rows by default;
   * pass includeDeactivated: true for admin/audit views.
   */
  laborRates?: Maybe<LaborRatesConnection>;
  lastPosition?: Maybe<Scalars['Long']['output']>;
  /**
   * The newest run for a suite — what the dashboard's health tiles read on load. Prefers a
   * complete run and only falls back to a partial one when that is all that exists, because a
   * subset run would otherwise shrink the exec view to whichever specs happened to be re-run.
   *
   * That preference is a compound sort rather than a query-then-fallback: Partial == false
   * sorts ahead of true, so one round-trip yields the newest complete run when one exists
   * and the newest partial run otherwise.
   */
  latestQaTestRun?: Maybe<QaTestRunResult>;
  /** Most recent heartbeat for a watcher by observation time, or null if it never reported. */
  latestQaWatcherHeartbeat?: Maybe<QaWatcherHeartbeat>;
  /**
   * Gets actual quantities for line items (Available - Reserved) aggregated at the line item level
   * Uses MongoDB aggregation pipeline for optimal performance
   * @deprecated Uses $lookup against removed OrderAllocations collection. Migrate to InventoryItem-based allocation tracking.
   */
  lineItemActualQuantities: Array<LineItemActualQuantityDocument>;
  /**
   * Obsolete: previously returned per-location/grade actual quantities by joining the removed
   * OrderAllocations collection. It can no longer produce data, so it now signals with a
   * RESOLVER_OBSOLETE error instead of degrading to a silent empty list.
   * @deprecated Uses $lookup against removed OrderAllocations collection. Migrate to InventoryItem-based allocation tracking.
   */
  lineItemActualQuantitiesByLocationGrade: Array<LineItemActualQuantityDocument>;
  /**
   * The planned-arrival notice status of each stop the load serves: the last request and the last send,
   * and separately the readiness, recipients and warnings for the next send. Empty for an unknown load.
   */
  loadStopNoticeStatus: Array<LoadStopNoticeStatus>;
  /**
   * The weight of each requested load, for the weekly Loads grid: one read instead of an
   * orderContainerRequirement call per order. Derived on every read and never stored. A split order
   * counts only the share of its goods that rides the load.
   *
   * A load id that is malformed, unknown or belongs to another tenant is left out of the result. Asking for
   * more than 200 ids is refused with a LOAD_WEIGHTS_TOO_MANY_LOAD_IDS error.
   */
  loadWeights: Array<LoadWeight>;
  /** @deprecated Use SiteLocation queries instead. */
  location?: Maybe<LocationDocument>;
  /**
   * Pagination-free resolver for the currently-active overhead rate with most-granular-wins:
   * when subLocationId is provided and a matching open, non-deactivated
   * sub-location rate exists at asOf, it wins. Otherwise the site-level rate
   * is returned. Deactivated rows (from a cascade) never resolve as active. Returns null when
   * neither parent nor sub-location has an active non-deactivated row.
   */
  locationActiveOverheadRate?: Maybe<LocationOverheadRateDocument>;
  /**
   * What still references a site or a sub-location, per kind: the count and up to 50 records. With a
   * locationId the report covers that sub-location and every sub-location under it; without one it covers
   * the site and all its sub-locations. In use means any reference: stock with its quantity, open orders,
   * production jobs, history and the other kinds. These are the counts the inactivate and remove commands
   * check. Reads only.
   */
  locationInUse: LocationInUsePayload;
  /**
   * Returns the most recently-written site-level overhead rate row (SubLocationId is null).
   * Pre-PR contract was a single-doc upsert; post-PR each EffectiveFrom is its own row in
   * append-only history. The latest-EffectiveFrom site-level row preserves read-after-write
   * behavior for both open-ended and bounded (closed-range) rates. For sub-location-aware
   * lookups with most-granular-wins + asOf, use locationActiveOverheadRate.
   */
  locationOverheadRate?: Maybe<LocationOverheadRateDocument>;
  /**
   * Paginated overhead rate history (desc by EffectiveFrom, default page size 50).
   * Filtering inputs derive from LocationOverheadRateDocument including
   * SubLocationId and EffectiveFrom ranges. Filters deactivated rows by default;
   * pass includeDeactivated: true for admin/audit views.
   */
  locationOverheadRates?: Maybe<LocationOverheadRatesConnection>;
  /** @deprecated Use SiteLocation queries instead. */
  locations?: Maybe<LocationsConnection>;
  locationsSalesPeople?: Maybe<LocationsSalesPeopleConnection>;
  /** Paginated Carriers for the calling tenant. */
  logisticsCarriers?: Maybe<LogisticsCarriersConnection>;
  /** Paginated per-load-line delivery portions for the calling tenant. */
  logisticsDeliveryOrderPortions?: Maybe<LogisticsDeliveryOrderPortionsConnection>;
  /** Paginated per-(load, route stop) delivery outcomes for the calling tenant. */
  logisticsDeliveryStops?: Maybe<LogisticsDeliveryStopsConnection>;
  /** Paginated per-load delivery rollups for the calling tenant. */
  logisticsDeliverySummaries?: Maybe<LogisticsDeliverySummariesConnection>;
  /** Paginated Docks for the calling tenant. */
  logisticsDocks?: Maybe<LogisticsDocksConnection>;
  /** Paginated Drivers for the calling tenant. */
  logisticsDrivers?: Maybe<LogisticsDriversConnection>;
  /** Paginated LoadLines for the calling tenant. */
  logisticsLoadLines?: Maybe<LogisticsLoadLinesConnection>;
  /**
   * Paginated LoadLines for the calling tenant sharing one order — how that order's
   *             quantity is split across loads/dates.
   */
  logisticsLoadLinesByOrder?: Maybe<LogisticsLoadLinesByOrderConnection>;
  /** Paginated Loads for the calling tenant. */
  logisticsLoads?: Maybe<LogisticsLoadsConnection>;
  /**
   * Paginated Loads for the calling tenant with a given ship date — the planner's
   *             day view.
   */
  logisticsLoadsByShipDate?: Maybe<LogisticsLoadsByShipDateConnection>;
  /** Paginated LogisticsRoutes for the calling tenant. */
  logisticsRoutes?: Maybe<LogisticsRoutesConnection>;
  /** Paginated VehicleTypes for the calling tenant. */
  logisticsVehicleTypes?: Maybe<LogisticsVehicleTypesConnection>;
  /** Paginated Vehicles for the calling tenant. */
  logisticsVehicles?: Maybe<LogisticsVehiclesConnection>;
  /**
   * Returns the subcategory cost breakdown aggregated across every production job in a lot for
   * one cost category.
   *
   *
   * **Returns:**
   * The per-subcategory cost breakdown rows aggregated across the lot.
   */
  lotCostBreakdown: Array<CostCategoryBreakdown>;
  /**
   * Returns the raw recorded cost entries across every production job in a lot, optionally
   * filtered by cost category.
   *
   *
   * **Returns:**
   * The matching job cost records across the lot, ordered by recorded date.
   */
  lotCostRecords: Array<JobCostRecordDocument>;
  /**
   * Returns the budget-versus-actual cost summary aggregated across every production job in a lot. An
   * executed job contributes the budget fixed at its first execution, and a job not yet executed its
   * live budget.
   *
   *
   * **Returns:**
   * The aggregated budget-versus-actual cost summary for the lot.
   */
  lotCostSummary: JobCostSummary;
  /**
   * Returns the weekly cost timeline aggregated across every production job in a lot: the requested
   * number of recent weeks (bounded to a safe maximum), or, with productionWindow,
   * every week of the lot's own production window.
   *
   *
   * **Returns:**
   * The weekly cost timeline entries aggregated across the lot.
   */
  lotCostTimeline: Array<CostTimelineEntry>;
  /**
   * Builds the Microsoft admin-consent URL an organization admin opens to approve mailbox connect for
   * everyone in their organization: the admin-consent endpoint with the app client id, the caller's
   * redirect URI, and the Graph permissions the connect requests.
   */
  m365MailboxAdminConsentUrl: Scalars['String']['output'];
  /**
   * Builds the Microsoft authorize URL the browser is sent to for a mailbox connect: the multitenant
   * authorize endpoint with the app client id, the delegated scopes, the redirect URI (the caller's,
   * or the configured default), and a signed, time-limited state value bound to the calling
   * user, which the connect mutation validates.
   */
  m365MailboxAuthorizeUrl: Scalars['String']['output'];
  /**
   * The current user's mailbox connection status (connected flag + address), read from the read model.
   * Returns a not-connected status when the user has never connected.
   */
  m365MailboxStatus: M365MailboxStatus;
  /**
   * How the lines of the chosen orders would combine into lots if Create Plan ran now. Saves nothing and
   * changes no order. With fillFromGrowingLots, untouched lines first take eaches from Active spec lots already
   * growing for their item and ready by the order's delivery week (nearest ready week first, then lowest lot
   * number), listed under fills with each order's shortfall; only the rest is grouped. Lines for the same production item, ready week (Monday of the order's expected
   * delivery week), sales item and pack size share one group; two groups can have the same item and week
   * when their sales item or pack size differs, because a lot rounds to one container size. The group's lot
   * quantity is the lines' total sized once, as one Create Plan for the whole group would size it. A line production lots cover in part goes in for its rest. A line already allocated to stock or fully planned into lots, with
   * no production item, or that Create Plan would refuse is listed under skipped with the reason and
   * Create Plan's own message. Same access as createMakeToOrderPlan, 1 to 200 orders.
   */
  makeToOrderPlanPreview: MakeToOrderPlanPreviewPayload;
  /**
   * Returns all make-to-order plan bindings for the caller's tenant, with paging, filtering, and
   * sorting. Filter by orderId, orderLineId, or productionLotId to scope to a
   * specific order line or minted lot.
   */
  makeToOrderPlans?: Maybe<MakeToOrderPlansConnection>;
  /**
   * Whether the caller's tenant will have a manual payment (recordInvoicePayment /
   * recordOrderPayment) accepted right now, and why not when it will not. Reads only: each
   * mutation re-checks its own gates.
   */
  manualPaymentCapability: ManualPaymentCapabilityPayload;
  masterOrder?: Maybe<MasterOrderStateData>;
  /**
   * Resolves the compose-dialog defaults for a master order's acknowledgement email. The document
   * type is always ACKNOWLEDGMENT; the recipients are every email of every
   * AccountsPayable-typed contact on the master's customer, falling back to the master's own
   * contact email; the subject and body are the tenant's authored acknowledgement subject and body
   * (raw Handlebars), else the raw defaults; and reportId is always the seeded Master Order
   * Acknowledgement template, since masters have no tenant binding and no customer override. Staff
   * only, and tenant-scoped from the caller's token. Null means the master is NOT THERE: an unknown
   * or foreign-tenant id, or a master outside the caller's order scope (customer, route or sales limiter). A master that is still Open errors with the typed
   * DOC_TYPE_NOT_ALLOWED_FOR_STATUS code (the acknowledgement is available from Submitted on).
   */
  masterOrderEmailDraft?: Maybe<OrderInvoiceEmailDraftData>;
  /**
   * Answers whether the caller can send a master order's acknowledgement email right now and, when
   * not, the typed reasons why. Masters send only from the caller's own Microsoft 365 mailbox, so
   * routes holds exactly one verdict, INLINE_PERSONAL_MAILBOX, and that one route is all
   * there is: there is no company-sender route for a master. The blockers are the ones
   * orderEmailSendReadiness reports for that route: the customer's Never setting for the
   * acknowledgement, the report, the render mode, the caller's mailbox (not connected, or connected
   * without send permission) and recipients. orderId carries the master order id. Staff only,
   * and tenant-scoped from the caller's token. Read-only. Returns null when the master is not found
   * in the caller's tenant or is outside the caller's order scope. A master that is still Open errors with the typed
   * DOC_TYPE_NOT_ALLOWED_FOR_STATUS code (the acknowledgement is available from Submitted on).
   */
  masterOrderEmailSendReadiness?: Maybe<OrderEmailSendReadinessData>;
  masterOrders?: Maybe<MasterOrdersConnection>;
  /**
   * Returns a single material allocation by id, scoped to the caller's tenant so an
   * allocation belonging to another tenant is never disclosed.
   *
   *
   * **Returns:**
   * The matching document, or null when no allocation exists for that id in the tenant.
   */
  materialAllocationById?: Maybe<MaterialAllocationDocument>;
  /**
   * Returns the projected material allocations for the caller's tenant, with paging,
   * filtering, and sorting applied by the GraphQL middleware.
   *
   *
   * **Returns:**
   * An executable, tenant-filtered query over the MaterialAllocations read model.
   */
  materialAllocations?: Maybe<MaterialAllocationsConnection>;
  /**
   * Returns material demand entries for a given site location and date range,
   * computed from production jobs and their material event attachments.
   */
  materialDemand: MaterialDemandSummary;
  /**
   * Server-computed group headers (with per-group counts) for the Material Events sidebar, so the
   * client renders grouping over the full event list without loading every event and grouping in
   * memory. groupBy selects the bucket key dimension (event Status or
   * event Name). search is the same case-insensitive OR-contains over the
   * event name the sidebar applies, so counts reflect the active search. The group's children are
   * then lazy-loaded via productionMaterialEvents filtered to the bucket key — each bucket's
   * Key equals that list's where eq-value for the
   * dimension (Status keys are canonical SCREAMING_SNAKE enum names).
   */
  materialEventGroups: Array<MaterialEventGroupBucket>;
  materialItem?: Maybe<MaterialItemDocument>;
  materialItemLocationQuantities?: Maybe<MaterialItemLocationQuantitiesConnection>;
  materialItemLocationQuantity?: Maybe<MaterialItemLocationQuantityDocument>;
  /**
   * The "Did you mean" search for the material item search: search with each word that matches no material item
   * replaced by the closest word in the tenant's material items, lowercased, and every other word kept as typed, joined by
   * single spaces. Null when every word matches a material item, when no close word exists, when the search is blank, and
   * wherever materialItems searches without the material item Atlas index. A code with punctuation, such as PET-4, a
   * word with a digit and a word under 4 letters are never corrected.
   *
   *
   * **Returns:**
   * The corrected search, or null when there is nothing to correct.
   */
  materialItemSearchSuggestion?: Maybe<Scalars['String']['output']>;
  materialItemSiteLocationQuantities?: Maybe<MaterialItemSiteLocationQuantitiesConnection>;
  materialItemSiteLocationQuantity?: Maybe<MaterialItemSiteLocationQuantityDocument>;
  materialItemTotalQuantity: Scalars['Decimal']['output'];
  /**
   * The tenant's material items. Excludes deleted items — fetch a deleted item by id instead.
   * search matches every word, in any order, in at least one of name, ERP ID, or an assigned vendor's item code, and
   * combines with where. A typed code with punctuation, such as PET-4, is matched as one unbroken piece
   * (case-insensitive, no typo tolerance), so it also finds longer codes that contain it, such as PET-45. A search with no
   * order ranks by relevance. Where the material item Atlas index is enabled each word matches as a whole word or a
   * word prefix, never a typo, the search ranks by score, boosting a material item whose name or code equals the whole
   * search, then by name, and materialItemSearchSuggestion offers a corrected search. Without that index it matches the
   * words as typed and lists a name or code equal to the whole search first, then names whose words all start with the search
   * words. An explicit order replaces the ranking on either path.
   */
  materialItems?: Maybe<MaterialItemsConnection>;
  /**
   * All open material orders for the calling tenant — the surface the PWA reads to list outstanding
   * POs and inbound transfer orders. Tenant-scoped; paged, filterable, sortable so the PWA can scope
   * by order type, station, vendor, or expected-receipt date.
   */
  materialOrders?: Maybe<MaterialOrdersConnection>;
  /**
   * Open material orders whose receiving station resolves to a single location node — the parity
   * replacement for legacy orderLinesForNode (and the Finish receive flow's
   * orderLinesForFinishNode, which is the same shape scoped to a node). Tenant-scoped and
   * filtered to locationId; paged, filterable, sortable.
   */
  materialOrdersForLocation?: Maybe<MaterialOrdersForLocationConnection>;
  /**
   * What correcting or voiding one vendor price would do to the price that applies on a stated day:
   * the selected price and revision, the values the action would write, the applicable price before and
   * after, and the material's purchasing revision. Writes nothing and reserves nothing.
   */
  materialPriceActionPreview: MaterialPriceActionPreviewPayload;
  /**
   * The price history of one material, oldest first, optionally narrowed to one price or one
   * vendor. Empty when the material has no events in the caller's tenant.
   */
  materialPriceHistory: Array<MaterialPriceHistoryRecord>;
  /**
   * Whether the caller's tenant's vendor prices can be read and acted on by PriceId, with the
   * counts that decide it.
   */
  materialPriceIdentityReadiness: MaterialPriceIdentityReadinessPayload;
  /**
   * How much of the caller's tenant's live vendor pricing states its supplier royalty, with the
   * counts by review state that decide it. Reported separately from whether a base price applies:
   * incomplete coverage never stops an estimate pricing.
   */
  materialPriceRoyaltyCoverage: MaterialPriceRoyaltyCoveragePayload;
  /**
   * Whether the caller's tenant can make explicit vendor price writes right now, with the reason
   * and the evidence when it cannot. Reads only: it reserves nothing and grants nothing.
   */
  materialPriceWriteCapability: MaterialPriceWriteCapabilityPayload;
  /**
   * The material-receipt audit history for the calling tenant — the immutable record of every
   * receipt recorded by field users (the parity replacement for the legacy
   * InventoryMaterial.OrderLineChange rows). Tenant-scoped; paged, filterable, sortable for
   * triage.
   */
  materialReceipts?: Maybe<MaterialReceiptsConnection>;
  /**
   * Returns material transactions (counts and moves) for the authenticated tenant,
   * with paging, filtering, and sorting support.
   */
  materialTransactions?: Maybe<MaterialTransactionsConnection>;
  /**
   * The calling user's own directory entry, resolved from their FusionAuth identity
   * (subject claim) with a case-insensitive email fallback. Null when the caller has
   * no directory entry yet — clients should treat that as "no business roles".
   */
  me?: Maybe<UserDocument>;
  mergeDevAccounts?: Maybe<MergeDevAccountsConnection>;
  /**
   * Returns the per-integration Merge.dev connection metadata (the friendly QuickBooks company name)
   * for the given integration, or null when the synchronizer has not yet captured a connection
   * document for the caller's tenant. Tenant-scoped: filtered by both the caller's tenant and the
   * supplied integration id.
   */
  mergeDevConnection?: Maybe<MergeDevConnectionDocument>;
  /**
   * Reads the tenant's outbound export attempts to Merge.dev (WS Orders → QB Invoices) from
   * the MergeDevExports read model. Paginated, filterable, and sortable so clients can
   * narrow to failures (e.g. where: { exportStatus: { eq: FAILED_PERMANENT } }) for
   * the PWA Errors tab.
   */
  mergeDevExports?: Maybe<MergeDevExportsConnection>;
  /** Returns the persisted genuine per-record Merge.dev import failures (entity type, source record id, human label, reason, and timestamp) for the given integration, newest-first, optionally capped to the most recent N. Backs the Integrations "Errors" tab so operators see why each record was dropped, not just a count. */
  mergeDevImportFailures: Array<MergeDevImportFailureDocument>;
  mergeDevPayments?: Maybe<MergeDevPaymentsConnection>;
  /** Returns the cached Merge.dev field schema for the given integration and model, or null if not yet discovered. */
  mergeDevSchema?: Maybe<MergeDevSchemaDocument>;
  /** Returns the most recent Merge.dev sync cycle metrics for the given integration, ordered by completion time descending. */
  mergeDevSyncMetrics: Array<MergeDevSyncMetricsDocument>;
  /** Returns the authoritative per-entity Merge.dev sync state (last successful sync time and consecutive-failure count) for the given integration, ordered by entity type. */
  mergeDevSyncState: Array<MergeDevSyncStateDocument>;
  /**
   * One page of the answers the next stage of a preparation job runs from: every current question of the
   * job's lineage answered at its current group revision, with each correction's values read from the
   * correction store now. Worker only.
   */
  migrationImportAnswersForJob: MigrationJobAnswerPage;
  /**
   * One page of the questions on the lineage of (journey, source): ids, definitions, group revisions,
   * answers and up to five example rows each, whose values are read from the prepared rows now and show
   * as expired once those rows are purged.
   */
  migrationImportQuestions: MigrationImportQuestionPage;
  /** One import run in the caller's tenant, or null when the tenant holds no such run. */
  migrationImportRun?: Maybe<MigrationImportRunStatus>;
  /**
   * Health and completion facts for one import run, for completion notices. Worker only. Null when no
   * such run exists.
   */
  migrationImportRunCompletionFacts?: Maybe<MigrationImportRunFacts>;
  /**
   * One import run's current confidence in the caller's tenant: each verified record read again now against what
   * verification recorded, with when it was checked, the upload and prepared revision the evidence rests on, and how
   * far each read model had got, and whether each prerequisite its operations referenced still holds as validation
   * recorded it. A run too large for one bounded read is not read now: the report shows its latest paced observation
   * with its age, or that one is pending. It speaks for this run only. Null when the tenant holds no such run.
   */
  migrationImportRunConfidence?: Maybe<MigrationImportRunConfidenceReport>;
  /**
   * Records of one import run in the caller's tenant, each read again now: the ones named by operation or record id,
   * at most 50, or else a sample of at most 25, optionally filtered by current status and record kind. A sample
   * illustrates a finding; it never stands in for the run's coverage. Null when the tenant holds no such run.
   */
  migrationImportRunRecords?: Maybe<MigrationImportRunRecordsReport>;
  /** The import runs of one journey in the caller's tenant, newest first, at most 100. */
  migrationImportRuns: Array<MigrationImportRunStatus>;
  /**
   * Completed import runs due for a paced confidence observation, across every tenant, at most 25: runs whose
   * approval covers more operations than one bounded confidence read rechecks and that hold no observation younger
   * than the observation refresh, never observed first, then the longest unobserved. The worker observes each under a
   * new observation id, one page per call: page 0 first, then each next page the call answers, until it answers done.
   * Worker only.
   */
  migrationImportRunsDueForObservation: Array<MigrationImportRunObservationDue>;
  /**
   * The coverage of the caller's tenant's journey, read now: per family, per approved or proposed portion, per
   * registered file (families fed and row counts that add up to the rows read) and per question, with why the selected
   * work is not verified yet. It speaks for the grower's selected work only, never for every family, the tenant's data
   * or a release. Null when the tenant holds no such journey.
   */
  migrationJourneyConfidence?: Maybe<MigrationJourneyConfidenceReport>;
  /**
   * One journey's operation receipts in the caller's tenant, and per upload what became of its rows. A committed
   * operation counts as written but not yet verified.
   */
  migrationOperationReceipts: MigrationReceiptsReport;
  /**
   * The reviews shown to the caller in a journey whose subject has no approval yet, newest first, one per
   * subject, at most 25. A listed review may since have gone stale; approve checks it again. A journey id that
   * cannot name a journey lists nothing.
   */
  migrationPendingReviews: Array<MigrationPendingReview>;
  /**
   * One portion's coverage in the caller's tenant's journey, read now: when it was checked, its run, its operations
   * by status and the selected work validation left out of it. It speaks for this portion only. Null when the journey
   * holds no such portion.
   */
  migrationPortionConfidence?: Maybe<MigrationPortionCoverage>;
  /** One preparation job in the caller's tenant, or null when the tenant holds no such job. */
  migrationPreparationJob?: Maybe<MigrationPreparationJobStatus>;
  /** The preparation jobs of one journey in the caller's tenant, newest first, at most 100. */
  migrationPreparationJobs: Array<MigrationPreparationJobStatus>;
  /**
   * One page of a prepared revision's rows on the lineage of (journey, source): the named revision, or
   * the newest when none is named, optionally for one prepared file. A revision whose rows the retention
   * purge took shows as expired, with no rows.
   */
  migrationPreparedRows: MigrationPreparedRowPage;
  /** The current value of each named catalog setting, as its own query reads it. An unsupported setting is refused. */
  migrationSettingValues: Array<MigrationSettingValue>;
  /**
   * One settings-operation revision of the caller's tenant in a journey: each change with its value now, its latest
   * readback and the receipts of its writes. Null when there is no such revision.
   */
  migrationSettingsRevision?: Maybe<MigrationSettingsRevisionResult>;
  /**
   * The missing-data warnings on the given records of one kind, in the order the records were asked
   * for. Advisory only: a warning never blocks a save and never changes a number. Warnings the caller
   * chose to ignore are left out unless includeIgnored is true; ignoring hides a warning from that
   * user only.
   */
  missingDataFindings: Array<MissingDataFinding>;
  /**
   * Returns a single pending transfer-order document by its underlying MovementOrder
   * aggregate id for the caller's tenant, or null when no matching row exists.
   * Used by the mobile receive UI to render the review step for one specific transfer.
   *
   *
   * **Returns:**
   *
   * The matching PendingTransferOrderDocument when found within the
   * caller's tenant; null when no row matches (unknown id, or id belongs to
   * another tenant).
   */
  movementOrder?: Maybe<PendingTransferOrderDocument>;
  /**
   * Returns the caller's tenant's MovementOrder history document for one MovementOrder id, at any
   * lifecycle stage, or null when no matching row exists. Unlike
   * movementOrderTransactionsByLocation it includes a transfer that is created but not yet
   * shipped, so a client can read back the saved intent (sites, bins, reason and requested lines)
   * before anything ships.
   *
   *
   * **Returns:**
   *
   * The matching MovementOrderHistoryDocument when found within the caller's tenant;
   * null when the id is malformed, unknown, or belongs to another tenant.
   */
  movementOrderHistory?: Maybe<MovementOrderHistoryDocument>;
  /**
   * Returns the caller's tenant's MovementOrder history rows for the given
   * SiteLocation, in both directions:
   *
   * Outbound — the location is the source and the order has shipped
   * (FromSiteLocationId == locationId and ShippedAt is set).
   * Inbound — the location is the destination and the order has been received
   * (ToSiteLocationId == locationId and ReceivedAt is set).
   *
   * A transfer shipped to the location but not yet received is a pending inbound, not
   * history, and is never returned — the ReceivedAt clause is what excludes it.
   *
   *
   * **Returns:**
   *
   * Pageable IExecutable`1 of MovementOrder history rows for the caller's
   * tenant where locationId is the shipped source or the received
   * destination.
   */
  movementOrderTransactionsByLocation?: Maybe<MovementOrderTransactionsConnection>;
  /** The caller's own QUEUED and RUNNING background Reapply Recipes runs, oldest first. */
  myActiveReapplyRecipesRuns: Array<ReapplyRecipesRun>;
  /**
   * Worker-scoped task list — returns the tasks assigned to the calling user on
   * the caller's tenant, optionally filtered by lifecycle status. Backed by the
   * MyCountTaskDocument read model (per-task row keyed by
   * (tenant, assignment, task)). The worker id is resolved from the
   * authenticated principal, never accepted as an argument — supervisor-scoped
   * "view another worker's tasks" is a separate authorized query.
   */
  myAssignedCountTasks?: Maybe<MyAssignedCountTasksConnection>;
  /** The caller's own background jobs, newest first (at most 100). Empty while the tenant's BackgroundJobs flag is off. */
  myBackgroundJobs: Array<BackgroundJob>;
  /**
   * The authenticated caller's own BPF starting-node grants — the parity replacement for the legacy
   * treeForUser query. Resolves by composite _id (tenant + caller user id) so the PWA
   * can scope its Finish/Material location pickers to the current user's entry points. The caller's
   * JWT sub arrives dashed or dashless depending on identity provider, but grants are always
   * keyed strict-dashless (matching the setBpfUserStartingNodes write path's ValidIdStrict),
   * so the sub is normalized via ValidIdStrict.CreateFromExternalId before the lookup —
   * otherwise a dashed sub never resolves a real grant. Returns null when the user has no assignment,
   * or when the sub fails id validation.
   */
  myBpfStartingNodes?: Maybe<BpfUserStartingNodeDocument>;
  /**
   * The caller's learning paths with their progress: the paths of the tenant's contracted modules
   * (only module when given), each holding the concepts the caller's roles allow.
   * Reading writes nothing.
   */
  myLearningPath: Array<LearningPath>;
  /**
   * The caller's own outstanding recovery codes — the ones that will still get them in if they lose
   * their authenticator app.
   *
   *
   * **Returns:**
   * The caller's outstanding codes, or why they could not be read.
   */
  myMultiFactorRecoveryCodes: MultiFactorRecoveryCodesPayload;
  /**
   * Whether the caller's own login has two-step verification turned on, and by which methods — plus
   * the tenant's step-up signal for this application: mfaEnrollmentRequired,
   * mfaEnrollmentBlocking and graceDeadline.
   *
   *
   * **Returns:**
   * The caller's current state, or why it could not be read.
   */
  myMultiFactorStatus: MyMultiFactorStatusPayload;
  /**
   * The signed-in user's own notifications, newest first. This is the list behind the bell's
   * dropdown and the notifications page; pass first to bound it (the bell takes five, the
   * page scrolls).
   *
   * There is no argument for whose notifications to read, and there will not be one. The tenant
   * and the recipient are taken from the caller's validated token and are applied to the Mongo
   * query before any client-supplied where or order is composed onto it, so those
   * two clauses can only ever narrow this result — a filter naming another address matches
   * nothing rather than reaching another inbox.
   *
   *
   * Note for anything rendering a row: fields["actorName"] currently carries the actor's
   * EMAIL ADDRESS, not their display name. The projection builds a row purely from the carrying
   * event and is not permitted to read the user directory, and the event carries only the address
   * today. Render it as an address, or resolve a name client-side; do not label it as a name.
   *
   *
   *
   * **Returns:**
   * The caller's notifications as a pageable, filterable, sortable executable.
   */
  myNotifications?: Maybe<MyNotificationsConnection>;
  /**
   * The caller's onboarding plan: each data family of the tenant's journey with its status and next step,
   * the caller's learning progress with the next and upcoming concepts, and the go-live checklist. A tenant
   * with no journey gets every family not selected, with upload next, except a family the tenant already has
   * records for, which is done. Each family also carries how many records the tenant
   * already has. An external connector token, which the mutation root refuses, gets the same plan with canAct false. Reading writes nothing.
   */
  myOnboardingPlan: OnboardingPlanData;
  /**
   * The caller's own Home welcome preference in this tenant. Reading it, and working out whether a
   * snooze has expired, writes nothing.
   */
  myOnboardingWelcomePreference: OnboardingWelcomePreference;
  /**
   * The parent company the calling user administers, or null when they administer none. Returns the
   * group's member tenants, its other administrators, and every directory entry across those tenants,
   * so an administrator can see and manage which of their staff work where.
   */
  myParentCompany?: Maybe<MyParentCompany>;
  /**
   * Returns task assignments assigned to the current user.
   * Excludes cancelled assignments by default.
   */
  myTaskAssignments?: Maybe<MyTaskAssignmentsConnection>;
  /**
   * The tenants the caller may work in, sorted by name — drives the tenant switcher, which the
   * client renders only when this returns more than one entry. A platform superadmin sees every
   * tenant that has not been deleted. Every other caller sees the tenants where they hold an
   * active, linked directory entry, unioned with their current tenant, so a caller with no linked
   * entries still resolves at least one.
   */
  myTenants: Array<MyTenant>;
  /**
   * How many notifications the signed-in user has not read — the number on the bell. Counted at
   * query time rather than kept as a stored counter, so nothing can drift out of step with the
   * rows themselves.
   *
   * The count is clamped to the maximum a 32-bit integer can carry. A recipient reaching two
   * billion unread notifications inside the thirty-day retention window is not a number this
   * field could report anyway, and a silently wrapped negative badge would be worse than a
   * pinned one.
   *
   *
   *
   * **Returns:**
   * The caller's unread count.
   */
  myUnreadNotificationCount: Scalars['Int']['output'];
  /**
   * The caller's tour state for each named walkthrough, so a screen can offer its tour once: one entry
   * per walkthrough id, trimmed, once each and in the order asked, at most 100. A null offeredAt means
   * the tour was never offered to the caller. Reading writes nothing.
   */
  myWalkthroughState: Array<LearningWalkthroughState>;
  /** Signed-in staff user: whether they get the What's new email. False until they opt in. */
  myWhatsNewEmail: Scalars['Boolean']['output'];
  /**
   * Returns the notification override record for one customer or order in the calling tenant, or
   * null when nothing has been set at that scope. A kind or document absent from the record's lists
   * has no override at that scope.
   */
  notificationOverrides?: Maybe<NotificationOverridesDocument>;
  onHandProcessQueue?: Maybe<OnHandProcessQueueConnection>;
  /**
   * One of the caller's tenant's accepted help requests with each channel's delivery state: email and Teams
   * pending, sent, failed, unavailable or uncertain, kept apart from acceptance and from staff handling.
   * Null when the tenant has no such request, or the read model does not show it yet (the submit result is
   * the receipt).
   */
  onboardingHelpRequest?: Maybe<OnboardingHelpRequestReadback>;
  /**
   * The caller's tenant's accepted help requests, newest first, optionally for one journey, each with its
   * per-channel delivery state.
   */
  onboardingHelpRequests: Array<OnboardingHelpRequestReadback>;
  /**
   * The staff route a help request would be bound to: the policy, revision, fingerprint, intended audience
   * in words and channels that services published for the caller's tenant, or an explicit Unavailable. It
   * carries no recipient address and no webhook.
   */
  onboardingHelpRoute: OnboardingHelpRouteView;
  /**
   * Whether the caller's tenant has an onboarding journey, whether it is unfinished, and its id. A journey
   * is unfinished while nothing is selected yet or any selected item is not complete. The evidence the Home
   * audience rule (3f07c6b6) reads.
   */
  onboardingJourneyLookup: OnboardingJourneyLookup;
  /**
   * The caller's tenant's uploads since its journey started that have no preparation job in the journey:
   * uploads made outside the setup conversation, such as on the legacy page, and attachments whose
   * registration never arrived. None is prepared until the grower asks and the upload is registered.
   * Empty when the tenant has no journey.
   */
  onboardingJourneyOutsideUploads: Array<OnboardingOutsideUpload>;
  /**
   * The caller's tenant's onboarding journey: facts, selected and deferred scope, dependency
   * reasons, per-family progress, portions, remaining selected work, next steps and whether the
   * journey is unfinished. Null when the tenant has no journey.
   */
  onboardingJourneyState?: Maybe<OnboardingJourneyStateView>;
  /**
   * Grower finance staff: one of your online payments in full: each invoice's share and what became of it, the charge
   * references, gross, fee and net, and every refund, dispute and refund request. Null for a payment that is not
   * yours, an id that names no payment, or when the payment cannot be read right now.
   */
  onlinePaymentAttempt?: Maybe<OnlinePaymentAttemptDetail>;
  /**
   * Grower finance staff: your online payments, newest first. Filter by status, by customer (a customer also returns
   * the payments of customers combined into it; each payment keeps the customer it started with) and by when they
   * started (from inclusive, before exclusive). take defaults to 50, at most 200. Null when the payments cannot be
   * read right now; try again.
   */
  onlinePaymentAttempts?: Maybe<OnlinePaymentAttemptPage>;
  /**
   * Grower finance staff: payments that could not be settled as they arrived, with their evidence, newest first. Only
   * open ones unless includeResolved. take defaults to 50, at most 200. Null when they cannot be read right now.
   */
  onlinePaymentExceptions?: Maybe<Array<OnlinePaymentException>>;
  /**
   * Grower finance staff: where a refund of one of your payments would come off if Stripe confirmed it now, by the
   * same rule Work Suite applies when it does: the payment's unapplied credit first, then its invoices in proportion
   * to what each still holds. amount null previews everything refundable. Nothing moves. A refused preview carries
   * its reason in errors.
   */
  onlinePaymentRefundPreview: OnlinePaymentRefundPreviewPayload;
  /**
   * Grower finance staff: unapplied credit your online payments left for customers, with each credit's source payment
   * and gross receipt, for review, one page of credited payments at a time, newest first. Filter by customer (a
   * customer also returns credit of customers combined into it). Credit already used up is left out unless
   * includeUsedUp, so a page can list fewer credits than it has payments; totalCount counts the credited payments that
   * skip and take page through. Apply credit to an invoice with applyCustomerCredit. Null when the credit cannot be
   * read right now.
   */
  onlinePaymentUnappliedCredits?: Maybe<OnlinePaymentUnappliedCreditPage>;
  /**
   * Every tenant's Pending and Running background jobs, oldest first, at most first (default 50, at most
   * 100), for the background jobs worker. Queued jobs are not listed. The missing tenant filter is intentional:
   * the worker discovers work across tenants. It is gated to Policies.WorkerService, as
   * openBulkOrderDeleteJobs is, so an ordinary caller cannot read other tenants' jobs.
   */
  openBackgroundJobs: Array<OpenBackgroundJobRef>;
  /**
   * Every tenant's Pending or Running jobs, oldest first, for the bulk delete worker. The missing tenant
   * filter is intentional: the worker discovers work across tenants, then acts with a tenant token. It is
   * gated to Policies.WorkerService, as asyncImportJobs is, so an ordinary caller cannot
   * read other tenants' jobs.
   */
  openBulkOrderDeleteJobs?: Maybe<OpenBulkOrderDeleteJobsConnection>;
  /** Approved or executing runs across tenants, oldest approval first. */
  openCorrectionRuns?: Maybe<OpenCorrectionRunsConnection>;
  /**
   * The conversion jobs still pending or running, oldest first, for the worker that advances them. A job spans every
   * tenant, so there is no tenant filter.
   */
  openFeatureFlagProductConversionJobs?: Maybe<OpenFeatureFlagProductConversionJobsConnection>;
  order?: Maybe<OrderStateData>;
  orderAddressEditPermissions: OrderAddressEditPermissions;
  /** @deprecated OrderAllocations collection removed. Allocation data is now on InventoryItem streams. Use inventoryItems query with AllocatedQuantity/AvailableQuantity fields instead. */
  orderAllocations?: Maybe<OrderAllocationsConnection>;
  /**
   * How many shipping containers an order needs, worked out from its lines' Shipping UOMs and the
   * tenant's container capacities. Derived on every read and never stored, so it cannot go stale
   * when the order's lines, the item catalogue or the container setup change.
   *
   * The figure agrees with the one the order's Containers panel shows, because it runs the same
   * algorithm. It is not a bare count: lines whose item names no Shipping UOM, and lines whose
   * UOM rides no container, are reported individually with their reason, and
   * uncountedLineCount exposes their existence to a caller that selects only
   * requiredContainerQuantity. Treat a non-zero uncountedLineCount as "this figure
   * is partial".
   *
   *
   * Null when the caller's tenant has no live order with this id — none exists, it has been
   * deleted, or the id is malformed. An order that exists but has no countable lines returns a
   * rollup with an absent requiredContainerQuantity, not null.
   */
  orderContainerRequirement?: Maybe<OrderContainerRequirement>;
  /**
   * How many shipping containers each requested order needs, for the logistics planning queue: one read
   * instead of an orderContainerRequirement call per order. Each entry is exactly what
   * orderContainerRequirement returns for that order, derived on every read and never stored. Treat a
   * non-zero uncountedLineCount as "this order's figure is partial".
   *
   * Entries come in the order the ids were asked for, one per order. An id that is malformed, unknown, deleted or
   * belongs to another tenant is left out of the result. Asking for more than 200 ids is refused with an
   * ORDER_CONTAINER_REQUIREMENTS_TOO_MANY_ORDER_IDS error.
   */
  orderContainerRequirements: Array<OrderContainerRequirement>;
  /**
   * Generates the Bonnie-branded order invoice PDF. Restricted to the BPF tenant —
   * returns null for any other tenant. Non-BPF tenants must use the reporting module
   * via generateReportPdf with the report ID configured in
   * TenantState.OrderInvoiceReportId.
   * @deprecated BPF-only legacy generator. Non-BPF tenants must use generateReportPdf with the tenant's OrderInvoiceReportId.
   */
  orderDetailsPdf?: Maybe<OrderDetailsPdfData>;
  /**
   * OrderEase connection status for the current tenant, for the pwa connect card. Reads the
   * tenant's aggregate state (same source of truth as the connect/disconnect payloads, so status is
   * strongly consistent with a just-completed mutation) and surfaces only non-secret status — the
   * connected flag, the connect timestamp, and a MASKED client key. The client secret and refresh
   * token never leave wsapi; the read-model credential columns exist solely for the workers.
   */
  orderEaseIntegration: OrderEaseConnectionStatus;
  /**
   * Gets the calling tenant's external notification catalog: every customer-facing order
   * notification kind the platform knows about, each with its effective state — whether it sends,
   * over which channel, its authored recipients and content, the default recipient roles a
   * per-kind editor seeds an unauthored row from, and the tenant-scoped reasons (if any) this kind
   * cannot currently send. Unlike orderEmailSettings, which returns only the rows a tenant
   * has written, this always answers for every kind, so a settings page can render the whole
   * catalog — including each kind's blocked state — without re-deriving readiness client-side or
   * having to know which kinds happen to have been configured.
   */
  orderEmailNotificationCatalog: Array<OrderEmailNotificationCatalogEntryData>;
  /**
   * Returns the calling tenant's order-email recipient-routing overrides (the sparse doc-type
   * -> ContactType map), or null when the tenant has never set any. Mirrors
   * tenantRouteConfig. A doc-type absent from Entries uses
   * OrderEmailRecipientResolver's built-in default.
   */
  orderEmailRecipientRouting?: Maybe<OrderEmailRecipientRoutingDocument>;
  /**
   * Answers, for each delivery route, whether this tenant can actually send the given order's
   * document email and — when it cannot — the typed reasons why. Covers the tenant's effective
   * sender, whether the tenant has this notification kind switched on in its external
   * notification catalog, the report bound for the resolved doc type, the effective render mode,
   * the caller's Microsoft 365 mailbox connection, and recipient resolution. Follows the same
   * shape as integrationHealth: a
   * computed snapshot carrying a derived ready flag and a list of typed, independently-reported
   * reasons. Staff-only, and tenant-scoped from the caller's token rather than from an argument.
   * Read-only: it inspects configuration and never queues, renders, or sends anything. Returns
   * null when the order is not found in the caller's tenant. When docType is
   * supplied but not accepted for the order
   * (OrderEmailDocTypeResolution.AllowsExplicit), the field errors with the
   * typed DOC_TYPE_NOT_ALLOWED_FOR_STATUS code — never a bare null, so a caller of this
   * override can distinguish "not allowed for this order" from "order not found", per the
   * unavailable-action greyed-with-reason requirement.
   */
  orderEmailSendReadiness?: Maybe<OrderEmailSendReadinessData>;
  /** Gets the order-email settings records for the current tenant. */
  orderEmailSettings?: Maybe<OrderEmailSettingsConnection>;
  /**
   * The audit history of an order: every event on the order's stream with its type, a
   * human-readable label, when it happened and the email of the user who did it.
   *
   * Works for an order in any status, DELETED included — that is the point of it. A delete appears
   * as an "Order deleted" entry carrying the acting user's email.
   *
   *
   * occurredBy is null, never an empty string, when the event carries no acting user — a service
   * or machine caller, or an event written before performed-by attribution shipped. Render those
   * as "unknown".
   *
   *
   * Records come back newest first, and the whole history is returned in one call. The ordering is
   * the stream's own append order reversed rather than a sort on the timestamp: several events
   * written by one mutation share an instant, and the append order is the causal order that breaks
   * those ties correctly.
   *
   *
   * An unknown order id, or one belonging to another tenant, returns an empty history rather than
   * an error — the same "no such order for you" answer the order query gives.
   *
   *
   *
   * **Returns:**
   * History records ordered newest-first, or an empty sequence when the order has no events.
   */
  orderHistory: Array<OrderHistoryRecord>;
  /**
   * One Order exactly as stored, for a caller recovering from an Order write whose stageResult was not
   * ACKNOWLEDGED. FOUND returns the Order with its lineage (correction, creditedFromOrderId). The caller's
   * order visibility is checked before the Order is read, so an Order the orders query would hide answers
   * UNAVAILABLE_OR_NOT_PERMITTED, as does an Order that does not exist or is not listed yet. That outcome
   * never proves a write did not happen. READ_FAILED means nothing is known.
   */
  orderInspection: OrderInspectionPayload;
  /**
   * Resolves the compose-dialog defaults for the given order: the resolved OrderEmailDocType
   * (from the order's live invoice, else its status — or docType when supplied
   * and accepted for that order), the recipients — every email of every AccountsPayable-typed
   * contact on the order's customer, falling back to the order's own contact email when the customer
   * has none (empty only when neither exists) — the effective verified sender, the authored
   * subject/body for the resolved doc-type (raw Handlebars, or raw defaults when not authored), and
   * the report id that will render for that doc-type — a customer override, else the tenant's bound
   * report, else the built-in system default, the same rule View applies (except QUOTE, which always
   * resolves to the seeded Quote template). Null means the order is
   * NOT THERE — an unknown or foreign-tenant orderId, or an unusable tenant/order id. An event-store
   * read that fails is raised, never flattened into that same null. When docType
   * is supplied but not accepted for the order
   * (OrderEmailDocTypeResolution.AllowsExplicit), the field errors with the typed
   * DOC_TYPE_NOT_ALLOWED_FOR_STATUS code — never a bare null either, so a caller of this
   * override can distinguish "not allowed for this order" from "order not found", per the
   * unavailable-action greyed-with-reason requirement.
   */
  orderInvoiceEmailDraft?: Maybe<OrderInvoiceEmailDraftData>;
  /** The calling tenant's order kinds. */
  orderKinds?: Maybe<OrderKindsConnection>;
  /**
   * The line items of the tenant's orders. A customer-portal caller reads the lines of its own
   * orders only — and never the lines of an order that has been deleted; a staff caller reads the
   * whole tenant. The grower's internal cost basis on the line is not surfaced to a buyer.
   */
  orderLineItems?: Maybe<OrderLineItemsConnection>;
  /**
   * Previews the price one unfinished line of a saved Order would carry once the host's staged line Save
   * lands, and writes nothing. The host sends the saved lines it observed and its desired final lines; the
   * server plans the Save the host will send (removals, then manual-price adds, then server-priced adds, then
   * quantity updates), projects each stage through the receivers' own rules from the Order as it stands, and
   * reports the target line's outcome with its source and the Save mode it answered for.
   *
   * An observation, not a lock: the Save prices again from the sources as they stand when it runs. A failed
   * pricing read answers UNAVAILABLE_DEPENDENCY, never a default price, and a manual price is preserved, never
   * replaced. An Order outside the caller's Order scope, one that does not exist and one not yet visible all
   * answer the same ORDER_UNAVAILABLE error. Staff-only.
   */
  orderLinePricePreview: OrderLinePricePreview;
  /**
   * Every notification kind as it applies to one order: the tenant catalog merged with the customer's
   * overrides and then the order's, and the recipients a send from this order would address. Null
   * when the order is not in the caller's tenant.
   */
  orderNotificationSettings?: Maybe<NotificationSettingsData>;
  /**
   * Returns a single order-production-lot allocation by its allocation id, scoped to the
   * caller's tenant. Filters on the composite _id ({TenantId}-{AllocationId})
   * so the lookup uses the free primary index rather than a secondary index (Atlas discipline
   * acada0ab).
   */
  orderProductionLotAllocationById?: Maybe<OrderProductionLotAllocationDocument>;
  /**
   * Returns all order-production-lot allocations for the caller's tenant, with paging,
   * filtering, and sorting. Filter by orderId, orderLineId, or
   * productionLotId to scope to a specific order line or lot.
   */
  orderProductionLotAllocations?: Maybe<OrderProductionLotAllocationsConnection>;
  /** Empty lists when the order has no texts or is not in the caller's tenant. */
  orderTextHistory: OrderTextHistoryData;
  orderVerificationComparison: OrderVerificationComparison;
  /**
   * Returns the calling tenant's Orderful integration config. Never null: when nothing has been
   * persisted the per-tenant defaults are applied (inactive, no mapping, no secret reference). The
   * tenant is resolved from the caller's context (no tenant-id parameter) so a tenant can never
   * read another tenant's config.
   */
  orderfulIntegrationConfig: OrderfulIntegrationConfigDocument;
  /**
   * Cross-tenant admin overview: every tenant that has an Orderful integration config, one row each,
   * enriched with the tenant display name from our own registry (Orderful exposes no list-orgs
   * endpoint). SuperAdmin-only. Key status is surfaced as a presence flag only — the
   * @keyvault(...) reference is never returned.
   */
  orderfulIntegrationConfigs: Array<OrderfulIntegrationConfigAdminRow>;
  /**
   * Lists the calling tenant's Orderful EDI transactions by proxying GET /v3/transactions
   * at resolve time — no projection is read or written. The tenant is resolved from the caller's
   * context (never an input), so a tenant can only ever see its own organization's transactions.
   * Gated twice, both as payload errors: the caller must hold an EDI role granting
   * View, and the tenant's integration must be Active
   * (enforced fail-closed inside IOrderfulClient.SendAsync, which also resolves the
   * per-tenant API key and applies the resilient client). Pages are Orderful-fixed at 100 max;
   * navigate with the returned cursors.
   */
  orderfulTransactions: OrderfulTransactionsPayload;
  orders?: Maybe<OrdersConnection>;
  /**
   * Distinct OrderStatus values present in the tenant's non-deleted combined orders
   * (orders + master orders) after applying the resolver's where filter. Powers the Fulfill
   * Orders grid's Status set-filter: the grid sends the same where it uses for
   * combinedOrders with the Status column's own predicate removed, so the option list shows
   * only statuses that will actually return rows. Never returns Deleted.
   */
  ordersStatuses: Array<OrderStatus>;
  /**
   * Distinct OrderType values present in the tenant's non-deleted combined orders
   * (orders + master orders) after applying the resolver's where filter. Powers the Fulfill
   * Orders grid's Type set-filter; see the ordersStatuses query for the set-filter contract.
   */
  ordersTypes: Array<OrderType>;
  /**
   * The public key of every enabled version of the manifest signing key that is inside its NotBefore/ExpiresOn window,
   * newest first, as JWK and PEM with its kid. A version staged with a future NotBefore is not listed until it is valid.
   * Rotation: add a new key version (wsapi keeps signing with the old kid until restarted, and both kids are listed
   * here), ship firmware that trusts every kid listed, restart wsapi so the probe proves the newest version and signing
   * moves to it, then disable the old version once no device needs it. Verifiers accept every kid listed here.
   * isCurrent marks the kid this wsapi instance signs with, so it is per instance and false until its probe passes.
   * The probe runs once per process: if the kid wsapi signs with later expires or is disabled it drops out of this list and
   * no key is current, so restart wsapi after an expiry or disable of the current version.
   */
  otaManifestSigningKeys: OtaSigningKeysPayload;
  /** One OTA release, or null when no release has this id. */
  otaRelease?: Maybe<OtaReleaseDocument>;
  /** Every OTA release as its read model holds it. */
  otaReleases?: Maybe<OtaReleasesConnection>;
  /** One OTA rollout, or null when no rollout has this id. */
  otaRollout?: Maybe<OtaRolloutDocument>;
  /**
   * Every device in the rollout's opened rings with what it reported, pageable, in ring then device order. It reads from
   * the same state as the ring outcomes, so a device a later rollout has re-offered is still listed under the rollout it
   * applied under. A device with no record of an offer or result from the rollout is listed as offered. With a tenant id
   * it lists only the devices that tenant owns; without one it lists the devices of every tenant.
   */
  otaRolloutDeviceStates?: Maybe<OtaRolloutDeviceStatesConnection>;
  /** Every OTA rollout as its read model holds it. */
  otaRollouts?: Maybe<OtaRolloutsConnection>;
  /**
   * Returns one payment processor by id, or null if it does not exist. Unlike the plural query, this
   * does not filter Deleted — a direct id lookup is an audit/debug path, not the active-processor picker.
   */
  paymentProcessor?: Maybe<PaymentProcessorDocument>;
  /**
   * Returns every non-deleted system payment processor. Small unpaged list by design — this is a
   * system-wide config catalog, not a tenant-scale collection.
   */
  paymentProcessors: Array<PaymentProcessorDocument>;
  /**
   * Distinct payment-status values present in the tenant's non-deleted combined orders (orders + master
   * orders) after applying the resolver's where filter. Powers the Fulfill Orders grid's Payment
   * Status set-filter; see the ordersStatuses query for the set-filter contract. Master orders carry
   * no payment ledger, so they always contribute the Unpaid value.
   */
  paymentStatuses: Array<PaymentStatus>;
  /**
   * Returns the calling tenant's PENDING write-back records for a single workflow, oldest-first, claimed or
   * not, without taking a lease. It counts PENDING records only: POSTING and POSTED records are in flight
   * (sent to NAV, not yet verified) and are not included, so their depth and age are read from
   * erpWriteBackQueue filtered on status. Use the claimPendingErpWriteBacks mutation to
   * actually claim records for processing.
   */
  pendingErpWriteBacks?: Maybe<PendingErpWriteBacksConnection>;
  /**
   * Production entries waiting for a production admin, oldest first. Optionally limited to one site and to a
   * range of ready weeks. Scoped to the caller's sites like the other PRODUCE reads.
   */
  pendingProductionEntries: Array<PendingProductionEntry>;
  /**
   * Returns pending transfer orders for the caller's tenant whose
   * PendingTransferOrderDocument.ToSiteLocationId matches the given
   * destination. Used by the mobile receive UI to populate the worker's "to-do" list at
   * their current location.
   *
   *
   * **Returns:**
   *
   * Pageable IExecutable`1 of pending transfer orders matching the
   * caller's tenant, the destination, and IsReceived == false.
   */
  pendingTransferOrdersByDestination?: Maybe<PendingTransferOrdersByDestinationConnection>;
  /**
   * The same lookup keyed on the HOST the portal was loaded from, covering both the vanity subdomain
   * and a tenant's verified custom domain, and answering in the same shape — including the same null
   * for an unknown host and for a known tenant with no branding. Resolution is delegated to the same
   * PortalHostResolver the existing anonymous host lookup uses, so a pending or unverified
   * custom domain resolves to nothing here exactly as it does there. Draws on the SAME rate-limit
   * window as the slug form, so alternating between them buys no extra budget.
   */
  portalBrandingByHost?: Maybe<PortalPublicBranding>;
  /**
   * UNAUTHENTICATED branding lookup for a portal vanity subdomain's company slug, so the pre-login
   * welcome and self-registration pages can show the tenant's own name and logo. Returns null for an
   * UNKNOWN slug and, identically, for a KNOWN tenant that has no branding set — the two answers are
   * indistinguishable, so this field is not an existence oracle for a claimed slug. An object comes
   * back only when at least one of the four display fields or one sign-in panel field is non-blank.
   * The sign-in panel is the grower's sign-in marketing copy, public on purpose so the sign-in page
   * can show it. No other tenant field is reachable here, and rate limiting is shared with the host form.
   */
  portalBrandingBySlug?: Maybe<PortalPublicBranding>;
  /**
   * The paged action log, newest first. The domain and tenant scopings are applied server-side rather
   * than through the generic where filter. Ordered by first-observed rather than last-converged
   * on purpose: a checkpoint replay re-confirms every historical domain at once, and sorting on that
   * would bury genuine recent activity under replay noise in the log an operator reset the checkpoint
   * to read.
   */
  portalCustomDomainIngressActions?: Maybe<PortalCustomDomainIngressActionsConnection>;
  /**
   * The reactor's health in one read. Always resolves: before the reactor has ever run there is no
   * status to report yet, and every status field comes back null — "not started" is itself the answer
   * the admin page needs to show, not an error.
   */
  portalCustomDomainIngressStatus: PortalCustomDomainIngressStatusResult;
  /**
   * Every tenant's custom portal domain claims in one cross-tenant page, for the wsapi-admin-pwa
   * Domains grid — the per-tenant portalSettings.customDomains field can only ever answer for
   * the caller's own tenant, so this is the SuperAdmin escape hatch onto the same state across all of
   * them. Defaults to ascending domain order when the caller supplies no order.
   */
  portalCustomDomains?: Maybe<PortalCustomDomainsConnection>;
  /**
   * Returns the calling tenant's portal settings, reading the current state directly
   * from the KurrentDB stream (no projection lag). When the tenant has never saved
   * settings the documented defaults are returned (portal enabled, no minimum order,
   * self-registration on, grid catalog) with hasSavedSettings false, which is how a
   * caller tells a never-saved tenant from a saved one. Staff-only: a customer-type portal JWT gets
   * null, consistent with the portal authz pattern. Tenant-scoped — the stream is
   * keyed by the caller's own tenant id, so one tenant cannot read another's settings.
   */
  portalSettings?: Maybe<PortalSettingsStateData>;
  /**
   * Previews the freight Apply freight would write for one load, read-only: per order the contributing loads, the
   * share, the minimum, the fuel surcharge with its basis, the outcome and any warning. Pass inputRevision to
   * applyLoadFreight so it writes only what this preview showed.
   */
  previewLoadFreight: LoadFreightPreview;
  /**
   * When each order line's lot would start and ship if Create Plan ran now, with the Pre-finish flag
   * applied to every line. Saves nothing. Each line is timed by the same job chain createMakeToOrderPlan
   * builds, under the order's customer and ship week, so the preview and the lots Create Plan makes cannot
   * disagree. A line Create Plan would refuse (sizing, allocation, or lot validation) is refused here too. One result per line, in the order given,
   * carrying its order line id. A line that cannot be timed or planned carries that error and no timing.
   */
  previewMakeToOrderPlanTiming: Array<MakeToOrderPlanLineTiming>;
  /**
   * When each planned lot would start if it were created at the site: the recipe variation lot
   * creation would pick for its item and ready week, that variation's grow weeks, and the week start
   * they give. Saves nothing. Returns one result per lot, in the order given, carrying its key. A lot
   * whose quantity is below 1, whose ready week is not a Monday, or whose item or variation cannot be
   * resolved carries an error and no start.
   */
  previewPlannedLotStarts: Array<PlannedLotStartPreview>;
  /** Checks up to 500 production-item/Sales-Item pairs without writing, returning one zero-based row result per pair. */
  previewProductionItemLinks: Array<ProductionItemLinkPairResult>;
  priceGroup?: Maybe<PriceGroupStateData>;
  priceGroups?: Maybe<PriceGroupsConnection>;
  /**
   * Relay-cursor read of price levels. priceGroupId, when supplied, is pushed into the FIRST
   * $match — ahead of the three target-name lookups — so the compound {TenantId, PriceGroupId} index
   * engages and the lookups only fan out over that group's rows. Previously the resolver matched on
   * TenantId alone and left group filtering to [UseFiltering]'s where clause, which
   * HotChocolate appends AFTER the lookups — every
   * tenant-wide level ran through all three joins before anything narrowed, which is what produced
   * the reported 10k-level totalCount TaskCanceledException. Any other where/
   * order the caller supplies via [UseFiltering]/[UseSorting] still applies
   * afterward as before; those dimensions aren't index-backed pre-lookup filters.
   * See the priceLevelsBlock field for the AG Grid SSRM offset-paging contract, which also
   * counts and pages in the same aggregation pass and appends an Id sort tiebreaker.
   */
  priceLevels?: Maybe<PriceLevelsConnection>;
  /**
   * AG Grid SSRM offset-block read of price levels: one request returns exactly the requested
   * offset/limit window (nodes) plus totalCount, both computed in a
   * SINGLE aggregation via $facet. priceGroupId, type, types, targetId, and
   * levelType are pushed into the pre-lookup $match the same way priceGroupId is on
   * the priceLevels field — levelType lives directly on the document, so it costs
   * nothing extra pre-lookup. sort always gets a trailing ascending-Id tiebreaker so
   * low-cardinality columns don't thrash page boundaries across blocks.
   * targetNameSearch is resolved to a bounded TargetId set BEFORE this query runs
   * (TargetNameSearchResolver) and pushed into the SAME pre-lookup $match — it never
   * converts the fast page-then-join path into join-then-match. See
   * PriceLevelsBlockQueryService's class doc for why that distinction matters.
   */
  priceLevelsBlock: PriceLevelsBlockPayload;
  /**
   * The unit price each line of an order that does not exist yet will be charged once the order is
   * created and the lines added through addLineItemsWithPricing: the same pooled pass, over the
   * order's lines together, at the order's own reprice and qualification dates. Backs the order CSV
   * import's preview, which prices a whole file in one call instead of one itemPrices call per
   * quantity — and itemPrices, a catalog query, prices each line alone.
   *
   * One answer per order, one price per line, in request order and keyed by the caller's line key.
   * A price is null when nothing resolves, when the line carries an override price (it still counts
   * toward its pool), or when the order's pass fails — a location of another tenant resolves nothing.
   * The only call-level error is a request over 100 orders or 1,000 lines in total. Tenant-scoped
   * from the caller's context. Staff-only. Kit lines are not priced.
   */
  pricesForNewOrderLines: Array<NewOrderPrices>;
  /** Returns the current pricing page for the caller's tenant, or null if none is set. */
  pricingPage?: Maybe<TenantPricingPageDocument>;
  /** One produce tag by the id of the material item that carries it. */
  produceTag?: Maybe<MaterialItemDocument>;
  /**
   * One produce tag by its tag code. Tag codes are unique per tenant and are matched without
   * regard to case.
   */
  produceTagByTagCode?: Maybe<MaterialItemDocument>;
  /**
   * The tenant's produce tags. Every tag is a material item, so each row carries the full
   * material item alongside its tag identity, its status and its on-hand quantity.
   */
  produceTags?: Maybe<ProduceTagsConnection>;
  /**
   * The tenant's produce tags whose tag code matches one of the requested codes. Codes are
   * trimmed and matched without regard to case, so raw CSV cells can be sent as-is, and each tag
   * is returned once however many requested codes match it. Blank codes are ignored; requesting
   * no usable code returns an empty page rather than every tag. A code nothing matches simply
   * contributes no nodes. Deleted tags are included, with their Deleted status, because importing
   * a row with a deleted tag's code updates that tag. Requesting more than 1000 codes is refused
   * with a validation error; chunk a larger file client-side.
   */
  produceTagsByTagCodes?: Maybe<ProduceTagsByTagCodesConnection>;
  /**
   * Retrieves a single production catalog by ID and tenant.
   * A deleted catalog is returned with status DELETED.
   */
  productionCatalog?: Maybe<ProductionCatalogData>;
  /**
   * Previews combining the loser catalog into the survivor: the genus, series and color; each production
   * item that moves; each item pair's labor cost; each recipe that moves or collides; each variation link
   * that is re-pointed; and the lots and jobs on the loser, which move to the survivor. Writes nothing.
   * Refused unless both catalogs are Active and not combined.
   */
  productionCatalogCombinePreview: ProductionCatalogCombinePreviewPayload;
  /** Retrieves a list of production catalogs with filtering, sorting, and pagination support. */
  productionCatalogs?: Maybe<ProductionCatalogsConnection>;
  productionCategories?: Maybe<ProductionCategoriesConnection>;
  productionCategory?: Maybe<ProductionCategoryStateData>;
  /**
   * Splits forecast demand (sales item x region x forecast site x ready week) into colour-level production
   * lot lines using the tenant's item-to-production mappings. Read-only: writes nothing. At most 20,000 lines
   * per call; send whole regions per call, so lines that share a lot key always arrive in the same call.
   * A lot an applied consolidation holds is left out and reported as a CONSOLIDATED issue.
   */
  productionDemandSplit: ProductionDemandSplitResult;
  /**
   * Previews combining the loser into the survivor: each field with its value on each item and after the
   * combine, the conflicts that need a pick, and what each item already has. Writes nothing. Refused
   * unless both items are Active, not combined, and on the same plant and pot.
   */
  productionItemCombinePreview: ProductionItemCombinePreviewPayload;
  /**
   * The existing-matches preview. Every unlinked, active, not-combined production item whose number equals
   * (ignoring capitals and all spaces; dashes, dots and other characters still count) the code of exactly one active,
   * not-combined Sales Item comes back in matches with how it matched; those that match two or more
   * come back in sharedCodes with their candidates. Reads only; linking happens elsewhere. Two
   * tenant-scoped reads and an in-memory join, with no per-item round trips.
   */
  productionItemNumberMatches: ProductionItemNumberMatches;
  /**
   * Every order line at a site that ships in one ISO week and resolves to a production item, counted or
   * not, by ship date then order number, from only the orders the caller may see.
   */
  productionItemOrderLinesByShipWeek: Array<ProductionItemOrderLineData>;
  /**
   * The counted ordered quantity of each production item at a site, by ISO ship week, over a window of
   * one ISO year, with the counted eaches that resolved to no single production item and, on a tenant with
   * more than one site, those on orders with no ship-from site. The rows and totals count only the orders
   * the caller may see, the same order visibility the production schedule and the open orders by product
   * report apply.
   */
  productionItemOrdersByShipWeek: ProductionItemOrdersByShipWeekPayload;
  productionItems?: Maybe<ProductionItemsConnection>;
  /**
   * Returns the distinct native production items (id and number with Genus / Series / Color / Category)
   * available to the calling tenant, for the mapping-setup picker. Replaces the legacy cross-DB
   * DB_ID('Produce') pull that silently returned nothing when the Produce database was absent: a
   * tenant with no production items gets an explicit empty list — never null, never a swallowed error.
   * A tenant with neither the FORECAST nor the PRODUCE flag enabled also gets an empty list (the module is dark, nothing is exposed).
   */
  productionItemsCatalog: Array<ProductionItemCatalogEntry>;
  /**
   * Contract for the CMG auto-link-by-code feature: given a sales item's code
   * (ItemStateData.Sku), returns every active production item whose
   * ProductionItemNumber matches it ignoring capitals and all spaces (dashes, dots and other characters still count). Field:
   * productionItemsMatchingSalesItemCode(sku: String!): [ProductionItemDocument!]!
   * — always a list, never a boolean, so the caller (worksuite-pwa) can tell 0/1/many apart:
   * zero or more than one match means the link stays manual, exactly one match is the trigger to
   * auto-link via the existing linkProductionItemsToSalesItem mutation.
   */
  productionItemsMatchingSalesItemCode: Array<ProductionItemDocument>;
  /**
   * Returns the computed consumption manifest (material × computed quantity × suggested bin + on-hand)
   * for each requested production job at its produced quantity.
   */
  productionJobConsumptionManifest: ProductionJobConsumptionManifest;
  /**
   * What moving production jobs to another location would change, before the move is saved: per job, the
   * start week and grow weeks now and after, the space events added and removed, the planner overrides the
   * move keeps, and whether the destination site has a recipe variation for the job. Read only.
   */
  productionJobMovePreview: ProductionJobMovePreviewPayload;
  /**
   * The posting stages of each named job, read from the lot and reservation streams so they hold right after
   * a post: the Post Jobs readback for a lost response. Takes at most 500 jobs, each named by its lot and job.
   * Results keep the request order; a job whose lot or job cannot be found, or whose ids are malformed, is
   * left out.
   */
  productionJobPostingStages: Array<ProductionJobPostingStages>;
  productionJobs?: Maybe<ProductionJobsConnection>;
  productionLot?: Maybe<ProductionLotStateData>;
  /**
   * Returns the per-lot allocation rollups for the caller's tenant — one document per spec
   * production lot, exposing lotQty, totalAllocatedQty, and the derived
   * netAvailableQty (max(0, lotQty − totalAllocatedQty)). Filter by
   * productionLotId (e.g. { in: [...] }) so the client can read live net
   * availability for the lots it is about to allocate against.
   */
  productionLotAllocationRollups?: Maybe<ProductionLotAllocationRollupsConnection>;
  /**
   * The plans the job's import creates, or created, because no plan of the tenant has their name. Each is
   * named once, as its first row spells it, in row order. Rows that failed validation are left out. Empty for
   * a job with no new plan, and for another tenant's job.
   */
  productionLotAsyncImportJobNewPlans: Array<Scalars['String']['output']>;
  productionLotAsyncImportJobRows?: Maybe<ProductionLotAsyncImportJobRowsConnection>;
  /**
   * The tenant's schedule imports, for the imports list: each with the file it was uploaded from (null for imports
   * created before names were saved), its status, and how many rows it has, imported and still waiting. Scoped to the
   * caller's tenant and to schedule (production-lot) imports server-side; every user of the tenant sees them.
   */
  productionLotImportJobs?: Maybe<ProductionLotImportJobsConnection>;
  /**
   * The open allocations on each named lot: reservations on the lot itself, and order-line allocations on
   * Live Goods stock posted from the lot's jobs. Open means the order is not settled (shipped or later,
   * cancelled or deleted) and the allocated quantity still outstanding on the line is above 0. Draft orders
   * are listed with their status. Takes at most 100 lot ids; a malformed id or more ids fails the call. Ids that are
   * not lots, and lots outside the caller's sites, are left out. Sorted by expected delivery date, then
   * order number. Staff only.
   */
  productionLotOpenAllocations: ProductionLotOpenAllocationsPayload;
  /**
   * Returns a production lot's override history, newest first — one record per changed field,
   * each carrying previous value, new value, actor and timestamp.
   *
   * productionJobId narrows the result to a single job's changes. The filter is
   * strict: it returns exactly the records attributed to that job, which includes the ones a
   * cascade produced for it (batchOverrideProductionJobWeeks reschedules descendants the
   * caller never named and emits a week event per moved job, so a cascaded descendant has its own
   * history under its own id). Lot-scoped records — customer, lot quantity — belong to no job and
   * are therefore returned only for the unfiltered lot view.
   *
   *
   * Like the recipe history this returns a flat list rather than a cursor-paging connection: the
   * only paging provider in wsapi is the MongoDB one, which cannot paginate an in-memory
   * event-store read, and the allow-list already bounds the returned set to the lot's overrides.
   * Note that it bounds the RESULT, not the work: the whole lot stream is still read and
   * deserialised, so cost tracks total lot stream length rather than the number of overrides. A
   * lot whose stream as a whole grows long is the trigger to reconsider — not a speculative
   * projection.
   *
   *
   * Values that are identifiers — a location, a space or material event, a customer — additionally
   * carry the name they resolve to, so the panel reads "Site 1 to Greenhouse B01" rather than one
   * identifier to another. Names are looked up per read model rather than per record: the identifiers
   * a history mentions are gathered first and resolved together, so the lookup work grows with the
   * number of read models the history touches, not with the number of records in it. A read model no
   * identifier mentions is not read at all, and a location can take two — site locations are consulted
   * only for an identifier the sub-location lookup did not resolve. An identifier that no longer
   * resolves keeps its invariant value. So does one whose lookup failed: the names are an
   * enrichment, so an unreachable read model costs this history its names, never its records.
   *
   *
   *
   * **Returns:**
   * Override records newest-first, or an empty sequence when the lot has no override history.
   */
  productionLotOverrideHistory: Array<ProductionLotOverrideHistoryRecord>;
  /**
   * Previews substituting a catalog in each lot without saving anything: the scope, every refusal, the recipes to
   * copy first, the reservations to release, the production item after, and each changing job's start week and
   * quantity after, from the same calculation the substitution applies.
   */
  productionLotSubstitutionPreview: ProductionLotSubstitutionPayload;
  /** The lot's timeline, oldest first. Empty for a lot that does not exist (like the override history). */
  productionLotTimeline: Array<ProductionLotTimelineEntry>;
  /** Lists other active variants and dry-runs the chosen override policy without saving anything. Without a policy, options contain metadata and require a choice before a swap is available. */
  productionLotVariantOptions: ProductionLotVariantOptionsPayload;
  /**
   * The tenant's production lots. When salesItemId is supplied the candidate set is scoped
   * server-side to the lots whose stock is that sales item, by the same rule allocation enforces: a
   * lot with its own production item follows that item's sales item, and a lot without one follows
   * its finish job's plant and pot when that plant and pot sells as that sales item alone. This is the
   * order-line-aware guardrail for Produce Allocation, so an under-scoped client cannot widen the
   * candidate set beyond the line's lots. Omitting salesItemId returns the unscoped tenant lot list.
   */
  productionLots?: Maybe<ProductionLotsConnection>;
  productionMaterialEvent?: Maybe<ProductionMaterialEventStateData>;
  /**
   * Returns paginated details for production material events. Supports two calling modes:
   *
   * Single-event mode: pass productionMaterialEventId as a non-null string
   * to filter to one event's details.
   *
   *
   * Batched mode: pass productionMaterialEventId: null and supply a
   * where: { productionMaterialEventId: { in: [...] } } filter to retrieve details
   * across multiple events in one round-trip.
   *
   * Results are always scoped to the caller's tenant. triggerName and
   * materialItemDescription are the current trigger name and material description, resolved
   * on each request, so a preview always shows the trigger's and material's current identity, never
   * a stale one. materialName and materialErpCode are resolved the same way.
   * multiple is the exact stored quantity multiple.
   */
  productionMaterialEventDetails?: Maybe<ProductionMaterialEventDetailsConnection>;
  productionMaterialEvents?: Maybe<ProductionMaterialEventsConnection>;
  productionPlan?: Maybe<ProductionPlanStateData>;
  productionPlans?: Maybe<ProductionPlansConnection>;
  productionRecipe?: Maybe<ProductionRecipeStateData>;
  /**
   * Returns the computed Bill-of-Materials for a specific production recipe variation.
   * Returns null when the variation cannot be found for the current tenant.
   */
  productionRecipeBom?: Maybe<ProductionRecipeBom>;
  /**
   * The link chain of a recipe, anchored on one of its variations (the default-scope variation when none
   * is given), walking up to maxDepth levels (clamped to 1..5) upstream and downstream.
   *
   *
   * **Returns:**
   *
   * The chain, or null when the recipe id is invalid, the recipe or the variation is not found in this
   * tenant, the recipe is Deleted, or the read fails.
   */
  productionRecipeChain?: Maybe<ProductionRecipeChain>;
  productionRecipeEvents?: Maybe<Array<ProductionRecipeEventRow>>;
  /**
   * Server-computed group headers (with per-group counts) for the Recipes sidebar, so the client
   * renders grouping over the full catalog without loading every recipe and grouping in memory.
   * groupBy selects the bucket key (category code, or "{genus} {series}"
   * catalog identity). search is tokenized on whitespace/hyphen runs, same as
   * the sidebar's own tokenizeSearchTerm, and applied as an AND of case-insensitive OR-contains
   * (every token must appear in some catalog/category field, but tokens may land in different
   * fields), so counts reflect the active search exactly as the sidebar computes it. The group's
   * children are then lazy-loaded via productionRecipes filtered to the bucket key.
   */
  productionRecipeGroups: Array<ProductionRecipeGroupBucket>;
  /**
   * Returns the audit history of a production recipe, newest first. Each record is one event from
   * the recipe's stream, carrying the fields that event moved with their previous and new values,
   * the actor and the timestamp.
   *
   * Ordering is the stream's own order reversed, not a sort on the timestamp: several events
   * written by one mutation share an instant, and the stream's append order is the causal order
   * that breaks those ties correctly.
   *
   *
   * The full history is returned in one call rather than wrapped in HotChocolate's cursor-paging
   * connection — the only existing wsapi paging provider is the MongoDB one, which cannot
   * paginate an in-memory event-store read. The History tab renders a flat list, so client-side
   * paging is sufficient.
   *
   *
   *
   * **Returns:**
   * History records ordered newest-first, or an empty sequence when the recipe has no events.
   */
  productionRecipeHistory: Array<ProductionRecipeHistoryRecord>;
  /**
   * Per-tenant link-health report: every link that dangles, resolves to an Inactive recipe, or breaks
   * the same-catalog rule for a non-combo recipe. The rules run as aggregation stages, so a healthy
   * tenant returns nothing without materializing its variations.
   */
  productionRecipeLinkHealth?: Maybe<ProductionRecipeLinkHealthConnection>;
  productionRecipeVariations?: Maybe<ProductionRecipeVariationsConnection>;
  productionRecipes?: Maybe<ProductionRecipesConnection>;
  /** The distinct Recipes that use a Catalog and Category pair as an input, i.e. whose variations link it. */
  productionRecipesLinkingPair: Array<ProductionRecipeLinkingPair>;
  productionSpaceCategories?: Maybe<ProductionSpaceCategoriesConnection>;
  productionSpaceCategory?: Maybe<ProductionSpaceCategoryStateData>;
  productionSpaceEvent?: Maybe<ProductionSpaceEventStateData>;
  /**
   * Returns paginated details for production space events. Supports two calling modes:
   *
   * Single-event mode: pass productionSpaceEventId as a non-null string
   * to filter to one event's details.
   *
   *
   * Batched mode: pass productionSpaceEventId: null and supply a
   * where: { productionSpaceEventId: { in: [...] } } filter to retrieve details
   * across multiple events in one round-trip.
   *
   * Results are always scoped to the caller's tenant. categoryCode and typeCode are
   * the current space category and type codes, resolved on each request, so a category/type rename
   * is always current on the next request.
   */
  productionSpaceEventDetails?: Maybe<ProductionSpaceEventDetailsConnection>;
  productionSpaceEvents?: Maybe<ProductionSpaceEventsConnection>;
  productionSpaceType?: Maybe<ProductionSpaceTypeStateData>;
  productionSpaceTypes?: Maybe<ProductionSpaceTypesConnection>;
  productionTaskEvent?: Maybe<ProductionTaskEventStateData>;
  /**
   * Returns paginated details for production task events. Supports two calling modes:
   *
   * Single-event mode: pass productionTaskEventId as a non-null string
   * to filter to one event's details.
   *
   *
   * Batched mode: pass productionTaskEventId: null and supply a
   * where: { productionTaskEventId: { in: [...] } } filter to retrieve details
   * across multiple events in one round-trip.
   *
   * Results are always scoped to the caller's tenant.
   */
  productionTaskEventDetails?: Maybe<ProductionTaskEventDetailsConnection>;
  productionTaskEvents?: Maybe<ProductionTaskEventsConnection>;
  /** Returns reminders due on the tenant-local sweep date for an authorized worker. */
  productionTriggerRemindersDue: Array<ProductionTriggerReminderDue>;
  productionTriggers?: Maybe<ProductionTriggersConnection>;
  /**
   * Returns the calling tenant's production year plan for one site and ISO year, or null when that site
   * has no plan for the year. Also null when the PRODUCE_PLAN_BUILDER flag is off for the tenant, when the
   * site is outside a site-scoped caller's assignment, or when the site id or year is malformed.
   */
  productionYearPlan?: Maybe<ProductionYearPlanStateData>;
  /**
   * Returns the ISO years that have a production year plan for the site, in ascending order. Empty when the
   * site has none, when the PRODUCE_PLAN_BUILDER flag is off for the tenant, or when the site is outside a
   * site-scoped caller's assignment.
   */
  productionYearPlanYears: Array<Scalars['Int']['output']>;
  programs?: Maybe<ProgramsConnection>;
  projectionStatus?: Maybe<ProjectionStatusDocument>;
  projectionStatuses: Array<ProjectionStatusDocument>;
  promotionRule?: Maybe<PromotionRuleStateData>;
  /**
   * The open sales-order lines for the chosen items, with each item's on-hand stock, for the prorate grid.
   * Staff only. Only Submitted, Acknowledged and Picked orders appear, never a master order, a credit or
   * an order with a live invoice. Orders are limited to what the caller can see on the orders query, and
   * on-hand counts only the stock the caller's sites allow, customer ship-to stock excluded;
   * linesLimitedByScope and onHandLimitedBySite say when either is partial for this caller. At most 2,500
   * lines come back; truncatedByLimit says when more matched.
   */
  prorateGrid: ProrateGridPayload;
  /**
   * UNAUTHENTICATED pay-link lookup for the guest pay page. Given the token from a pay link, returns exactly one
   * of three answers. ACTIVE: the grower's name and contact details, whether online payment is available, and
   * the one invoice the link opens. EXPIRED, for the current token of a link that has run out on an invoice that
   * still owes something: the grower's name and contact details and whether a new link can be requested, with no
   * invoice data. INVALID, the same answer with no grower and no invoice, for every token that opens nothing:
   * malformed, unknown, revoked, replaced by a newer token, or for an invoice that has been paid or voided. Reads
   * only: it records nothing and starts no payment, so following a link changes nothing.
   */
  publicInvoicePayLink: PublicInvoicePayLink;
  /**
   * UNAUTHENTICATED. The guest return page's status read: given the attempt id and the r secret from the return URL
   * Checkout sent the browser back to, the status of that one payment, for 14 days after it was started. Status
   * only: no grower, contacts or invoice number. Null, the one uniform answer, for an unknown attempt, a wrong
   * secret, a pay-link token, or a secret past its 14 days. A browser return never establishes payment.
   */
  publicInvoicePaymentAttempt?: Maybe<InvoicePaymentAttempt>;
  /**
   * UNAUTHENTICATED code lookup for the public registration page. Returns the invitation's
   * validity, the one next action the page should offer, the recipient email to prefill when
   * valid, and the setup token only when that next action is SET_PASSWORD. SET_PASSWORD is
   * answered only for a login this invitation's own send created whose stored token FusionAuth
   * still reports as redeemable. For a reset or any other existing login the token is never
   * returned: SET_PASSWORD_FROM_EMAIL tells the page the set-password link went to that login's
   * own address by email. Otherwise the page is told whether to sign in or ask an administrator
   * to resend. Unknown and deleted codes are both NOT_FOUND. Read-only: at most two FusionAuth
   * GETs (read the account, then validate the token only for a new login), never a write, mint
   * or email. The response is marked no-store because it can carry a credential.
   */
  publicUserInviteByCode: PublicUserInvitePayload;
  purchaseOrderAllocationById?: Maybe<PurchaseOrderAllocationDocument>;
  purchaseOrderAllocations?: Maybe<PurchaseOrderAllocationsConnection>;
  /**
   * How many push subscriptions each install identity holds in the caller's tenant — the telemetry for
   * retiring per-module installs. A null appKey counts registrations from clients that never
   * reported one.
   *
   *
   * **Returns:**
   * One entry per app key.
   */
  pushSubscriptionCountsByAppKey: Array<PushSubscriptionAppKeyCount>;
  /**
   * Full detail for one run, with media paths composed into absolute URLs. Returns null when the
   * id is unknown so a stale dashboard deep-link renders "run not found" rather than erroring.
   */
  qaTestRun?: Maybe<QaTestRunResult>;
  /**
   * Paged index of test runs, newest first by default. Flows are projected away (see
   * QaTestRunSummaryResult); the dashboard fetches a single run's detail separately
   * once the user selects it.
   */
  qaTestRuns?: Maybe<QaTestRunsConnection>;
  /**
   * Runs retention may delete, oldest first: unpinned, with no future pinUntil, and dated more
   * than olderThanDays before now. Each comes with every media path it references and its ADO
   * build id, so the caller can delete the blobs and release the lease before deleting the run.
   */
  qaTestRunsForRetention: Array<QaRetentionCandidate>;
  /** Heartbeats for a watcher, newest first, optionally from the given since instant onward. */
  qaWatcherHeartbeats: Array<QaWatcherHeartbeat>;
  /**
   * Draft orders (Initialized or Open) whose quote follow-up is due on or before asOf and is not done,
   * soonest first, then by order number. Only orders the caller can see are included, exactly as on
   * orders, so a sales-scoped user gets only the follow-ups on their own orders. Everyone's follow-ups
   * on those orders by default; pass mine: true for the caller's own (matched on their directory and
   * login email addresses, so a client never picks an address), or an assignee email for one staff
   * user's. Submitted and later orders never appear, even though they keep their follow-up as history.
   * Any move of an order out of draft (a submit, an acknowledge even of a line-less order, a ship, or
   * a load dispatch even if it is later undone) stops a follow-up set before it, for good, even if the
   * order later returns to Open; a follow-up set or changed after a reopen reminds until the order
   * next leaves draft.
   */
  quoteFollowUpsDue?: Maybe<QuoteFollowUpsDueConnection>;
  /** The tenant's Ramp connection. Never null: NOT_CONNECTED with empty fields when the tenant never connected. */
  rampConnection: RampConnectionData;
  /**
   * WORKER ONLY. Decrypted tokens plus what the worker needs to call Ramp for the token's tenant.
   * Null when the RAMP_INVOICES flag is off for the tenant, the status is not CONNECTED, or no entity is
   * picked; the worker skips that tenant. Never log the result.
   */
  rampConnectionCredentials?: Maybe<RampConnectionCredentialsData>;
  /** W4. The PO's Ramp copy. Null when the PO never had a copy job (Copy POs off, or Submitted before it was on). */
  rampPurchaseOrderCopy?: Maybe<RampPurchaseOrderCopyData>;
  /** W3. Invoice card for one PO. Null when the PO does not exist for the tenant. */
  rampPurchaseOrderInvoices?: Maybe<RampPurchaseOrderInvoicesData>;
  /** W2. The Vendors tab: every active Work Suite vendor, A to Z by name, with its Ramp link or its suggestion. */
  rampVendorLinkRows: Array<RampVendorLinkRowData>;
  /** W2. WORKER ONLY. Input for the vendor match (S3) for the token's tenant. */
  rampVendorMatchInput: RampVendorMatchInputData;
  /**
   * W2. The Change list: cached Ramp vendors that no other Work Suite vendor is linked to (the Ramp vendor
   * linked to vendorId stays in), A to Z by name, at most 500. search filters by name (case-insensitive
   * contains). Inactive Ramp vendors only with includeInactive.
   */
  rampVendors: Array<RampVendorData>;
  reapplyRecipesPreview: Array<ReapplyRecipesPreviewResult>;
  /** A background Reapply Recipes run of the caller's tenant, or null when there is none with this id. */
  reapplyRecipesRun?: Maybe<ReapplyRecipesRun>;
  /** The tenant's receivable aged as of now — the totals row beneath the receivablesAging grid. */
  receivablesAgingTotals: ReceivablesAgingTotals;
  /**
   * The candidate with this id, or null when there is none.
   *
   * Null rather than an error for an unknown id, matching qaTestRun(id): a dashboard
   * deep-link to a candidate that has since been pruned should render "not found", and ingest
   * stores candidate ids without a lookup, so a run can legitimately name a candidate this
   * source cannot resolve.
   */
  releaseCandidate?: Maybe<ReleaseCandidate>;
  /**
   * Server-computed group headers (with per-group counts) for the Restock Rules sidebar, so the
   * client renders grouping over the full rule set without loading every rule and grouping in
   * memory. groupBy selects the bucket key (rule Status or rule
   * RuleType). search is the same case-insensitive OR-contains over the
   * rule name/description the sidebar applies, so counts reflect the active search. The group's
   * children are then lazy-loaded via replenishmentRules filtered to the bucket key, which
   * is the canonical GraphQL enum value the list where filter expects.
   */
  replenishmentRuleGroups: Array<ReplenishmentRuleGroupBucket>;
  replenishmentRules?: Maybe<ReplenishmentRulesConnection>;
  replenishmentSettings?: Maybe<ReplenishmentSettingsStateData>;
  /**
   * Returns one row per item, location and grade with stock available to sell on the inventory
   * ledger, filterable by location and item. Every row carries the unit price the item resolves to
   * today: supply priceGroupId to quote a specific price group, or customerId to quote that
   * customer's group; priceGroupId wins when both are given, and the tenant's default price
   * group is used when neither is. Those two are pricing context only — they never change which
   * rows are returned, unlike locationId and itemId, which filter.
   */
  reportAvailabilityData: ReportAvailabilityDataPayload;
  /**
   * Returns one row per item with its price at the run's pricing context, its royalty note, today's
   * on-hand / allocated / available, and — for each of two configurable date windows — the scheduled
   * production delivering inside the window, the open order demand due inside it, the resulting
   * availability and a printed status (the quantity, or SOLD OUT at zero or below). Each window is
   * evaluated independently with on-hand counted in both. priceGroupId and customerId are pricing
   * context only — they never change which rows come back; itemId, itemCategories and productGroups
   * filter. WAIT LIST and NOT AVAILABLE are not modelled.
   */
  reportAvailabilityOutlookData: ReportAvailabilityOutlookDataPayload;
  /**
   * Returns one row per customer for report generation, carrying the customer's first billing address,
   * filterable by customer name and customer status.
   */
  reportBillToAddressesData: ReportBillToAddressesDataPayload;
  /**
   * Returns the payments a tenant received over a period — GrowPoint's Cash Receipts — one row per
   * payment recorded against an invoice, with the method it arrived by and the reference it carried.
   * It also serves GrowPoint's Credit Card report, which is the same population narrowed to card
   * payments over a ship-date window: paymentMethod, shipDateFrom, shipDateTo and
   * includeOrdersWithoutCardInfo are that selection, and the seeded Credit Card template is the
   * defaults for it.
   */
  reportCashReceiptsData: ReportCashReceiptsDataPayload;
  /**
   * Container-tag rows for the report builder preview of ds-container-tags — the GrowPoint
   * "Container Tags" report. Selects orders by orderNumber and/or
   * orderNumbers (at least one is required — an empty selection is refused rather than
   * widened to the tenant), optionally narrowed to one itemCode (exact SKU match,
   * case-insensitive), and expands each order line into tags: one per EACH of the
   * quantityBasis quantity (Acknowledged — the default — or Shipped) when
   * tagMode is PerUnit (the default), one per SHIPPING UNIT when it is
   * PerShippingUnit (one per each on a line with no unit count), or one per LINE when it is
   * PerLineItem. Both option arguments take the enum NAME as a string so the seeded
   * EnumValues round-trip exactly; unrecognized values fall back to the defaults.
   *
   * customerId narrows the selection to one bill-to customer's orders, and sortBy takes a
   * sort-order name — Customer groups each customer's tags together, CommonName groups each
   * item's. Leaving sortBy unset keeps this report's order-number-then-line-number order: the sort
   * opinion lives on a template, not on the source.
   *
   *
   * For a tenant printing units and eaches, a selection that yields more tags than one export prints is
   * refused with an error naming both counts, here and on the export, rather than printed short.
   *
   *
   * retailPricedOnly keeps only the lines that have a customer retail price above zero, so a line
   * without one yields no tags; a retail price needs the tenant's Pre-pricing setting on. A selection
   * limited this way is refused, for every tenant, when it yields more tags than one export prints or when
   * the retail prices of a selected order could not be read.
   *
   *
   * The caller's own order visibility is applied on top, resolved server-side through the same
   * scope prelude every order read runs, so a restricted caller receives tags only for the selected
   * orders their scope permits, and a customerId the caller may not name is refused outright
   * rather than quietly returning nothing — identically here and on the CSV / Excel / PDF export arm,
   * which shares this read.
   */
  reportContainerTagsData: ReportContainerTagsDataPayload;
  /**
   * Returns a tenant's accounts-receivable aging as of the requested aging date — what each
   * customer owes, split across the five day buckets, beside the interest their standing invoices
   * have run up and nobody has assessed.
   */
  reportCustomerAgingData: ReportCustomerAgingDataPayload;
  /**
   * Returns how long each customer takes to pay — GrowPoint's Customer Average Days to Pay — one row
   * per customer, with a mean and the payment count it was drawn from for each selected period.
   */
  reportCustomerAvgDaysToPayData: ReportCustomerAvgDaysToPayDataPayload;
  /**
   * Returns the interest a tenant's standing invoices have ACCRUED as of the requested date — one
   * row per invoice that is running something up, the per-invoice detail behind the interest a
   * Customer Aging report totals and a Customer Statement itemizes.
   */
  reportCustomerInterestData: ReportCustomerInterestDataPayload;
  /** Returns per-customer order history data for report generation. */
  reportCustomerOrderHistoryData: ReportCustomerOrderHistoryDataPayload;
  /**
   * Returns what each customer bought, paid and was credited over a period — one row per customer,
   * with the period's sales, credit memos, cash received, discounts taken and late charges assessed.
   */
  reportCustomerSalesPaymentsCreditsData: ReportCustomerSalesPaymentsCreditsDataPayload;
  /** Returns a tenant's customer accounts as one row per customer — the Customer Listing. */
  reportCustomersData: ReportCustomersDataPayload;
  /**
   * Returns one report row per cycle count item for the current tenant. The userId
   * filter and output field map to CycleCountLogDocument.RecordedBy,
   * which stores the email of the person who submitted the count.
   */
  reportCycleCountHistoryData: ReportCycleCountHistoryDataPayload;
  /**
   * Returns what sold in a ship-date window — one row per order, or one row per ship day when
   * the Date Summary Only parameter is set.
   *
   *
   * **Returns:**
   * The rows, plus the returned and total-matching counts in the row's grain.
   */
  reportDailySalesSummaryData: ReportDailySalesSummaryDataPayload;
  /**
   * Returns all report data sources. These are system-level seed data shared across all tenants
   * (not tenant-scoped), so no TenantId filter is applied.
   * Paging is omitted intentionally — the data source count is small and fixed.
   */
  reportDataSources: Array<ReportDataSourceDocument>;
  /**
   * Returns every load shipping on the requested ship date as one row per order, sharing the occupied stop number, ordered by load
   * number then drop number: the day's route schedule.
   */
  reportDayRouteScheduleData: ReportDayRouteScheduleDataPayload;
  /**
   * Returns one report row per item, with booked demand, on-hand inventory,
   * available inventory, scheduled production, net supply, and shortage.
   */
  reportDemandVsSupplyData: ReportDemandVsSupplyDataPayload;
  /**
   * Gets report execution records for the current tenant, optionally filtered
   * by report identifier, schedule identifier, or order identifier. Executions of a saved view the caller
   * cannot open are left out inside the query, so totalCount and every page cover only what they may see.
   */
  reportExecutions?: Maybe<ReportExecutionsConnection>;
  reportFolders?: Maybe<ReportFoldersConnection>;
  /** The Sage rows for a posting period, against the tenant's own G/L account numbers. */
  reportGeneralLedgerExportData: ReportGeneralLedgerExportDataPayload;
  /**
   * Returns inventory data for report generation. Filters the InventoryItems collection
   * by tenant and optional sku/itemName/locationId, returning one row per
   * (location × item × grade) combination.
   */
  reportInventoryData: ReportInventoryDataPayload;
  /**
   * Returns inventory transaction data for report generation. Filters the InventoryTransactions
   * collection by tenant and optional transaction type, item, item classification, location, sku,
   * actor, reason code, and timestamp range.
   */
  reportInventoryTransactionsData: ReportInventoryTransactionsDataPayload;
  /**
   * Returns the tenant's classification CODE LIST for report generation — GrowPoint's Inventory "Code
   * Report" (v26.09A). One row per code value, or one row per (code value × assigned item) when
   * includeItems asks for what uses each code.
   *
   *
   * **Returns:**
   *
   * The page of rows, its own size as totalCount, and the number of rows the selection produces
   * before the cap as totalMatching — so a caller can tell a full page from a truncated one.
   */
  reportItemCodesData: ReportItemCodesDataPayload;
  /**
   * Returns one row per item, carrying its descriptors, on-hand stock, open-order demand and the price
   * at the run's price group.
   */
  reportItemListData: ReportItemListDataPayload;
  /**
   * Returns purchased-item roll-up data for report generation — GrowPoint's Accounts Payable "Item
   * Purchase Summary" (v26.09A). ONE ROW PER ITEM, summed across every purchase order the filters
   * match, so an item bought on four purchase orders from two vendors is a single row carrying all
   * four P.O. numbers and both vendor names.
   */
  reportItemPurchaseSummaryData: ReportItemPurchaseSummaryDataPayload;
  /**
   * Returns kit composition for report generation — GrowPoint's Inventory "Assembly Report"
   * (v26.09A). One row per kit LINE, so a kit with four lines produces four rows, each repeating the
   * kit header columns.
   */
  reportKitsData: ReportKitsDataPayload;
  /**
   * Returns one Logistics load as one row per drop, in route-stop order — the rows load paperwork
   * (driver load sheet, broker rate confirmation, store delivery notification) prints.
   */
  reportLoadData: ReportLoadDataPayload;
  /**
   * Returns master order data for report generation. reportType chooses the row GRAIN:
   * Line (the default) gives one row per master-order line with the master order's header
   * columns repeated, and Release gives one row per RELEASE (child order) cut from the
   * master, with the LINE columns blank — a master order with no releases yet still returns one
   * header-only row. Filters the MasterOrder read model by tenant and the
   * caller's order visibility scope, then by optional master order number (or list), bill-to
   * customer, ship-to location code, P.O. number, salesperson and order-date range (upper bound
   * inclusive of the whole selected day). remainingQuantityOnly drops lines with nothing
   * left to release and omitClosedMasterOrders drops master orders that are exactly Closed.
   * sortBy orders each master order's LINES, groupBy orders the MASTER ORDERS (and
   * marks each salesperson's first row for the Summary's per-salesman page break), and
   * extendedAmountBasis chooses which quantity extendedPrice extends — acknowledged
   * (the default and historical behaviour), remaining, or released. Those three are LINE-level and
   * are inert under reportType = Release; every filter above still narrows the master orders
   * under both grains, and totalCount / totalMatching keep their meaning (rows, and
   * matched MASTER ORDERS) either way. Both arms of the source (this preview resolver and the
   * CSV / Excel / PDF export) run the same shared read, so they cannot drift on a filter, the
   * scope, the derived quantities, the grain or either ordering.
   */
  reportMasterOrdersData: ReportMasterOrdersDataPayload;
  /**
   * Returns material-item catalog data for report generation. Filters
   * MaterialItemDocument by tenant and optional name/erpId/status/category,
   * returning one row per material item. Status is projected as its enum string name so
   * CSV/PDF/Excel exports render the human-readable value.
   */
  reportMaterialItemsData: ReportMaterialItemsDataPayload;
  /**
   * Returns one row per item with open demand — quantity still owed, the number of open orders
   * behind it, the earliest and latest expected delivery date among them, and a per-order
   * breakdown naming each ordering customer and its open quantity.
   *
   * "Open" means Submitted, Acknowledged, Picked or SyncError (an order stuck in ERP sync error
   * still owes its goods), net of shipped quantities and floored at zero, windowed on the
   * orders' expected delivery date — the one shared definition
   * reportDemandVsSupplyData also reads, so the two report the same open quantity for
   * the same item over the same window.
   */
  reportOpenOrdersByItemData: ReportOpenOrdersByItemDataPayload;
  /**
   * What is still owed on each product in a ship-date window, broken out by the classification value
   * the product's demand carries — GrowPoint's Open Orders by Product sheet.
   *
   *
   * **Returns:**
   * The page of rows plus the pre-page match count.
   */
  reportOpenOrdersByProductData: ReportOpenOrdersByProductDataPayload;
  /** Returns one row per open order with line-level readiness summarized to the order. */
  reportOrderFulfillmentReadinessData: ReportOrderFulfillmentReadinessDataPayload;
  /**
   * Returns the GrowPoint Order Item Allocations rows: one row per order line item at each allocated
   * inventory location and grade, across every order matching the filters. A line carrying no
   * allocation contributes one row with a blank location, so unallocated demand is visible rather than
   * silently dropped. Order-header fields are denormalized onto every row so the list renders
   * tabularly without per-row joins on the client. Filter by bill-to customer, ship-to location code,
   * order number, master order number, order date range, ship date range, P.O. number, salesperson,
   * item, item product group, allocated location, order status and order allocation status. The
   * orderNumbers list selects several orders at once and narrows like orderNumber, both applying when
   * both are set; more than 200 distinct orders is refused rather than cut short, and with neither set
   * every order matching the other filters is reported. The orderKind filter selects sales orders
   * (released by no master order), master orders (released from one) or all. The allocationState row
   * filter keeps only unbalanced, non-allocated or no-location lines, and shippedOnly keeps only lines
   * that have shipped; both are judged against the whole line, so a line split across several
   * locations contributes all of its rows or none. Turning
   * includeZeroAcknowledgedMasterItems off drops lines on a master-released order whose acknowledged
   * quantity is explicitly zero; it is on unless set. Turning groupByLocation on reorders the rows so
   * each allocated location's rows are contiguous, with the unallocated rows last, and populates the
   * per-location pick total and its first and last row markers. There is no sort parameter — GrowPoint
   * offers no sort selector on this report. A window matching more orders than one run can page
   * through fails with an actionable error rather than returning a short report.
   */
  reportOrderItemAllocationsData: ReportOrderItemAllocationsDataPayload;
  /**
   * Returns the Order Item Stock by Location rows: for the items on the selected orders, one row per
   * inventory location and grade holding stock, with the location's site, on hand, committed and
   * available, and what the selected orders have allocated there. The location the selected orders are
   * allocated at is marked. Stock at a customer ship-to is left out. An item with no stock anywhere
   * prints once, at a blank location, after every site. Rows are ordered by site name, then the
   * location's pick sequence and name, then item code, item name and grade, with first and last row
   * markers for each site and location and a per-location allocated total. Select orders by order
   * number, by a list of order numbers (at most 200, a longer list is refused) or by an expected
   * delivery window, optionally narrowed by order status; a request selecting no orders is refused, and
   * an unrecognized status returns no rows.
   */
  reportOrderItemStockLocationsData: ReportOrderItemStockLocationsDataPayload;
  /**
   * Returns one report row per order line item, enriched with parent-order fields.
   *
   * The caller's own order visibility is applied on top of the parameter filters, resolved server-side
   * from their directory assignment rather than from anything the client sends. A caller restricted to a
   * set of customers, to routes, or to their own salesperson email receives only the line items whose
   * parent order that scope permits — the SAME rows this source's CSV / PDF / Excel arm already returns
   * to them.
   */
  reportOrderLineItemsData: ReportOrderLineItemsDataPayload;
  /**
   * Returns order data for report generation. Uses MongoDB aggregation pipeline with
   * $lookup joins to OrderLineItems and CustomersSummary, then maps to a denormalized
   * report shape. Filter semantics (tenant scoping, Deleted exclusion, enum-validation
   * short-circuit, inclusive-day-bound on dateTo) are shared with the PDF path
   * through ReportOrdersDataMaterializer.BuildBaseFilters. statuses
   * is the multi-status selector (e.g. "Shipped OR Closed"): when supplied it drives a Mongo
   * $in and wins over the single status eq, so a Customer
   * Statement / Invoice can target several real order statuses in one report.
   * route filters on the same resolved EffectiveRoute value the
   * route column shows. orderType filters on the OrderType enum
   * name the orderType column shows (e.g. Credit for a credit-memo render), sharing
   * the status filters' fail-closed validation; omitted, the matched set is exactly what it was
   * before the parameter existed. itemSortBy reorders each order's
   * items[] lines (ReportOrderItemSort: Code / Description / Sku / None) without
   * affecting which orders match or their sequence; anything unrecognized falls back to the
   * historical line-number order. salesPerson selects the orders stamped with one
   * salesperson email, matched case-insensitively because the field stores the email as typed.
   * sortBy orders the ORDERS themselves (ReportOrderSort: Date / OrderNumber /
   * Customer / Salesman / Drop) — applied before the row cap, so it decides which orders a saturated
   * selection returns; anything unrecognized falls back to the historical newest-first order.
   * Drop orders by the drop numbers a rendered report is given beside its order list; this
   * preview takes no order list, so every dropNumber here is null and Drop lists as Customer.
   * summarizeBySize, when true, turns each order's items into one row per Shipping UOM
   * size label and unit price with quantities and amounts summed, so a caller that passes
   * summarizeBySize gets the PDF's rows; omitted or false, every line prints as its own row.
   * loadId is the load being printed: it chooses which dock each order carries (in dock and
   * dockAssignments) and never adds or removes an order; omitted, an order carries the dock of every
   * load it rides.
   *
   * salesPerson names an IDENTITY, so it is refused before any row is read
   * (ReportIdentityParameterGate.PermitAsync) rather than silently narrowed to
   * nothing by the scope filter below — the same gate ds-order-line-items runs on its own
   * salesPersons parameter, and the preview twin of the export arm's refusal. A caller
   * refused at export who could still read the rows here would simply not press "Generate".
   *
   *
   * The caller's own order visibility is applied on top of those filters, resolved server-side from their
   * directory assignment rather than from anything the client sends. A caller restricted to a set of
   * customers, to routes, or to their own salesperson email receives only the orders that scope permits,
   * whatever parameters they pass.
   */
  reportOrdersData: ReportOrdersDataPayload;
  /**
   * The portal availability sheet's rows for the caller's tenant: one row per portal-visible item
   * with the same Available number the portal grid shows, its price at the named customer's price
   * group (a customer caller is always priced as themselves), its earliest ready date and week, and
   * its per-grade breakdown when the portal shows grades. Items with nothing available are omitted
   * unless the window admits their ready date, in which case availableDisplay carries the ready
   * week. The payload also carries the tenant's company block and portal logo, the window label and
   * the generation time, which the printed sheet binds at its root. A customer you may not report
   * on is refused rather than ignored.
   */
  reportPortalAvailabilityData: ReportPortalAvailabilityDataPayload;
  /**
   * Returns catalog prices for report generation — GrowPoint's Inventory "Price List". One row per
   * item, carrying what it costs at up to five chosen price levels AS OF the price date, alongside
   * the classification, discountable flag and royalty the sheet prints beside it.
   */
  reportPriceListData: ReportPriceListDataPayload;
  /**
   * Returns production cost rollup data for report generation. Filters the
   * CollectionNames.ProductionCosts collection by tenant and the optional
   * recipe, location, and date range parameters. Default sort is total cost descending so
   * the most expensive lots surface first for margin review.
   */
  reportProductionCostsData: ReportProductionCostsDataPayload;
  /**
   * Returns production job data for report generation. Filters the Job collection
   * by tenant and optional status, location, item, and delivery date range.
   */
  reportProductionJobsData: ReportProductionJobsDataPayload;
  /** Returns a tenant's production lots as one row per lot — the book a grower works from. */
  reportProductionLotsData: ReportProductionLotsDataPayload;
  /**
   * Returns production schedule data for report generation. Filters Job by tenant and optional
   * delivery date, location, and status, then joins tenant-scoped WorkOrder and SiteLocation data.
   */
  reportProductionScheduleData: ReportProductionScheduleDataPayload;
  /**
   * Returns a tenant's PRODUCE production schedule as one row per production job — the same rows
   * the PRODUCE › Schedule grid lists, with the job's location split into Site and Sublocation.
   */
  reportProductionScheduleProduceData: ReportProductionScheduleProduceDataPayload;
  /**
   * Returns a tenant's PRODUCE weekly cuttings: one row per variety and default farm, with the cuttings each
   * lot's first step (the stick week) needs in each ISO start week of one year. A combo's components count
   * under their own varieties.
   */
  reportProductionScheduleProduceWeeklyData: ReportProductionScheduleProduceWeeklyDataPayload;
  /**
   * Returns product data for report generation. Filters the ItemSummary collection
   * by tenant and optional status, genus, product group(s), item group(s), category codes,
   * item code and UPC presence; orders rows by the sortBy argument, fills the barcode column from
   * the barcodeSource argument, renders the upcDisplay column per upcFormat and prices each row
   * against priceGroupId.
   */
  reportProductsData: ReportProductsDataPayload;
  /**
   * Returns the consolidated pull list for the selected orders: one row per (item, allocated location,
   * grade, value adds label, retail price) with the allocated and ordered quantities summed across every contributing order line, the
   * contributing order numbers listed, and the distinct line pull notes joined. Select orders with
   * orderNumber and/or orderNumbers, at least one is required; an empty selection returns the empty
   * payload rather than widening to the tenant. At most 200 distinct orders per request. Lines with no
   * allocation roll into a blank-location row per SKU, value adds label and retail price. sortBy is one of Location, Sku or ItemName;
   * absent or unrecognized keeps the pick-path (Location) order. A selection OVER the 200-order cap
   * returns the empty payload on this preview field; the export arm is what reports the cap as an error.
   */
  reportPullListConsolidatedData: ReportPullListConsolidatedDataPayload;
  /**
   * Returns the picking-ticket rows for a single order. One row per
   * (order line item × allocated location). Order-header fields are denormalized
   * onto every row so the slip can be rendered tabularly without per-row joins
   * on the client. ReportPullSlipDataRow.AlternateLocations excludes
   * the allocated location itself and only includes locations with positive
   * available quantity.
   *
   * sortDirection is the builder-preview half of the ds-pull-slip report parameter of the
   * same name — Asc (the default, and what an omitted or unrecognized value resolves to) or
   * Desc. It reverses the pick-sequence leg of the row order only. Parsed here rather than
   * bound as an enum argument so the preview accepts exactly the strings a saved report stores.
   *
   *
   * loadId is the builder-preview half of the report parameter of the same name: the load being
   * printed. It only chooses which dock assignment the slip carries and never widens the order. Omitted,
   * the slip carries every load the order rides.
   */
  reportPullSlipData: ReportPullSlipDataPayload;
  /** Returns one profitability row per recipe with joined production lots and linked sales item data. */
  reportRecipeProfitabilityData: ReportRecipeProfitabilityDataPayload;
  /**
   * Returns aggregated royalty totals grouped by payee for orders shipped within
   * the supplied date window. Lines with RoyaltyExempt = true or no royalty config
   * are excluded. Orders in Cancelled, Deleted, or Initialized (Draft) status are
   * excluded. shippedTo is normalized to an inclusive end-of-day bound so a
   * UTC-midnight upper bound (the natural date-picker value) includes the entire
   * selected day. The rollup is shared with the reporting-engine export pipeline.
   */
  reportRoyaltyPayoutData: ReportRoyaltyPayoutDataPayload;
  /**
   * Returns the sales-by-category rollup. groupBy selects the rollup
   * dimension; dateFrom / dateTo bound the order
   * initialization date inclusively (no default — callers supply explicit bounds, or
   * omit them to scan the full corpus). customerId narrows to a single
   * customer. Rows are sorted by total revenue descending.
   */
  reportSalesByCategoryData: ReportSalesByCategoryDataPayload;
  /**
   * Returns the period-vs-period sales comparison rollup. metric
   * selects whether totals are Dollars or Units; groupBy selects
   * the grouping dimension. The same scope filters are applied to both periods.
   */
  reportSalesComparisonData: ReportSalesComparisonDataPayload;
  /**
   * Returns one row per commissionable line item on non-cancelled, non-draft orders whose basis date
   * falls in the period, with the commission each line earns its order's salesperson.
   */
  reportSalesPersonCommissionData: ReportSalesPersonCommissionDataPayload;
  /**
   * Returns one aggregated row per sales person. Orders without a sales person, and orders
   * in Deleted or Cancelled status, are excluded before grouping.
   */
  reportSalesPersonPerformanceData: ReportSalesPersonPerformanceDataPayload;
  /**
   * Returns the sales tax recorded over a period, per jurisdiction — either the tax billed on issued
   * invoices, which is the figure a return is filed from, or the informational estimate held on orders.
   */
  reportSalesTaxData: ReportSalesTaxDataPayload;
  /**
   * Returns a tenant's base rates of sale as one row per item, customer, location and program —
   * the demand signal DBR replenishment plans against.
   */
  reportSalesVelocityData: ReportSalesVelocityDataPayload;
  /** Gets report schedules for the current tenant. */
  reportSchedules?: Maybe<ReportSchedulesConnection>;
  /**
   * Returns one row per customer ship-to location for report generation, segmentable by state,
   * route ("run"), salesperson, customer name and customer status.
   */
  reportShipToAddressesData: ReportShipToAddressesDataPayload;
  /**
   * Shipping-label rows for the report builder preview of ds-shipping-labels — the GrowPoint
   * "Shipping Labels" report. Selects orders by orderNumber and/or orderNumbers, by a shipDateFrom /
   * shipDateTo window over the order's expected delivery date (both bounds inclusive), and/or by a
   * bill-to customerId; at least one of those is required, because a label for every order in the tenant
   * is never what was meant. Each matched order then prints labelsPerOrder identical labels, numbered
   * labelIndex 1..labelCount — GrowPoint's "number of labels per selection", whose per-order count grid
   * is a multi-order selection plus that count. The count is clamped to a maximum of 100 rather than
   * refused, and defaults to 1.
   *
   * Each label carries the order and customer, the ship-to snapshot, the bill-to address, the ship-from
   * site as the printed from-address, and a scannable per-label barcode value. There is no sort
   * parameter: GrowPoint offers no sort selector, so rows are always order number then label index.
   *
   *
   * The caller's own order visibility is applied on top, resolved server-side through the same scope
   * prelude every order read runs, and a customerId the caller may not name is refused outright rather
   * than quietly returning nothing — identically here and on the CSV / Excel / PDF export arm, which
   * shares this read.
   */
  reportShippingLabelsData: ReportShippingLabelsDataPayload;
  /** Gets a single report template by ID for the current tenant or system templates. */
  reportTemplate?: Maybe<ReportTemplateDocument>;
  /** Gets report templates for the current tenant and system templates. */
  reportTemplates?: Maybe<ReportTemplatesConnection>;
  /**
   * Returns vendor purchase order data for report generation. Filters the VendorPurchaseOrder
   * collection by tenant and optional status, vendor id, order-date range (upper bound inclusive of
   * the whole selected day), PO-number list and omit-closed flag. Default sort is OrderPlacedDate
   * descending so the most recently placed POs appear first. The reportType argument selects
   * the row grain (Summary = one row per PO, the default; Detail = one row per PO
   * line) and sortBy orders each PO's lines under Detail. The statuses list (a
   * general status-set filter, composing with status), itemCode (a line's material
   * item ERP id), categories (material-item categories) and omitZeroRemaining (lines
   * with ordered > received only) narrow which POs and, under Detail, which lines return; a PO
   * with no surviving line is not matched. quantityRemaining is ordered minus received,
   * clamped at zero. Both arms of the source (this preview resolver and the CSV / Excel / PDF
   * export) run the same shared read, so they cannot drift on a filter, the inclusive date bound,
   * the grain or the line ordering.
   */
  reportVendorPurchaseOrdersData: ReportVendorPurchaseOrdersDataPayload;
  /**
   * Returns one aggregated row per vendor. Filters the underlying
   * VendorPurchaseOrderDocument collection by tenant, optional vendorId
   * (vendor ERP id), and optional dateFrom/dateTo on
   * OrderPlacedDate (the upper bound covering the whole selected day). The optional
   * minimumValue is GrowPoint's "Minimum Value" floor on the rolled-up
   * TotalSpend; because no purchase order captures unit cost yet it currently matches
   * nothing, which is the honest answer rather than a dropped filter. Default sort is
   * VendorName ascending until the projection
   * enrichment task lands TotalSpend; the enrichment PR will move the primary sort
   * key to TotalSpend descending in lockstep with the sort doc + integration test.
   */
  reportVendorSpendData: ReportVendorSpendDataPayload;
  /**
   * Returns the vendor master for report generation — GrowPoint's Accounts Payable "Vendors"
   * listing. One row per VendorDocument, so a vendor with no purchase orders still appears
   * (unlike ds-vendor-purchase-orders and ds-vendor-spend, which are rooted in POs).
   */
  reportVendorsData: ReportVendorsDataPayload;
  /**
   * Returns the version history of a report, newest first. Each record is one full-snapshot event
   * (creation or update) written to the report's event stream, carrying the author, timestamp, and
   * the complete snapshot for preview. The report event stream is bounded (per-report) and small,
   * so the full history is returned in one call rather than wrapped in HotChocolate's cursor-paging
   * connection — the only existing wsapi paging provider is the MongoDB one, which cannot paginate
   * an in-memory event-store read. Tenant isolation is enforced by the stream name (built from the
   * caller's tenant) and [Authorize]. A saved view the caller cannot open returns no versions, the same
   * answer an unknown report gets.
   *
   *
   * **Returns:**
   * Version records ordered newest-first, or an empty sequence when the report has no events.
   */
  reportVersions: Array<ReportVersionRecord>;
  /**
   * Returns work order data for report generation. Filters the WorkOrder collection
   * by tenant and optional job, status, and start date range.
   */
  reportWorkOrdersData: ReportWorkOrdersDataPayload;
  /**
   * Returns the calling tenant's non-deleted reports that the caller may open: open reports, and the saved views
   * they own or that are shared with them or the whole company. A company admin sees every report. Views the
   * caller cannot open are left out inside the query, so totalCount and every page cover only visible reports.
   */
  reports?: Maybe<ReportsConnection>;
  /**
   * Returns the calling tenant's non-deleted reports carrying the given app tag — the app-scoped
   * surfacing query the worksuite-pwa in-app report menu/dock tab consumes. A report tagged with
   * multiple apps is returned by every matching call.
   *
   * Filtering note: on the generated `appTags` list filter, use `any: false` or a negated `some`
   * to mean "untagged". `none`/`all` require the array to exist AND be non-empty
   * (HotChocolate.Data.MongoDb emits `$exists: true, $nin: [[], null]` before the predicate),
   * so both untagged and never-tagged reports are excluded from those two operators.
   *
   * Only reports the caller may open are returned, decided inside the query exactly as reports decides it.
   */
  reportsByAppTag?: Maybe<ReportsByAppTagConnection>;
  reserveRule?: Maybe<ReserveRuleStateData>;
  resolveAvailabilityImportItems: AvailabilityImportItemResolutionPayload;
  /** The tag that should go on a plant, chosen by the most-specific-wins ladder. */
  resolveProduceTag: ProduceTagResolutionResult;
  /**
   * The tag that should go on each of many plants, chosen by the most-specific-wins ladder.
   * Results are returned in the same order as the criteria that produced them.
   */
  resolveProduceTags: Array<ProduceTagResolutionResult>;
  /**
   * Resolves the single active SKU/UPC mapping for a given (tenant, customer, customerLocationId?, itemId)
   * tuple at a moment in time. Falls back from location-specific to customer-level when no location
   * match exists. When several mappings are active at one level (one per program), the one in the
   * program of the customer's default mapping for the item is returned; when none is in that
   * program, that level is skipped and the lookup falls back the same way. Returns null when no
   * active mapping is resolved. An ambiguous selection raises a structured GraphQL error rather
   * than reporting a missing mapping.
   */
  resolveSkuUpcMapping?: Maybe<SkuUpcMapping>;
  /**
   * Resolves the active SKU/UPC mapping for EVERY requested item id at one
   * (tenant, customer, customerLocationId?) scope, so a caller with many items makes one call
   * instead of one call per item. Returns one entry per distinct requested item id, in the order
   * supplied; an item with no active mapping carries a null mapping rather than being dropped.
   * Each successful entry follows resolveSkuUpcMapping's ladder (location-specific, then
   * customer-level), tenant scoping and miss behavior. Per-item ambiguity remains contained as
   * a null mapping in this batch contract; the single-item field surfaces that fault as an error.
   * Requesting more than 1000 DISTINCT item ids is refused with a validation error, so no caller
   * can drive an unbounded lookup; chunk a larger file client-side. That bound is the only thing
   * that fails the whole field — an item id that names nothing, or that is not a usable id at all,
   * simply carries a null mapping and leaves every sibling entry untouched. The result is a plain
   * list, never a paged connection, so no page-size default can silently truncate a batch.
   */
  resolveSkuUpcMappings: Array<SkuUpcMappingResolution>;
  /**
   * Resolves supplier lines to the vendor's active materials: one answer per line, in request order, each
   * carrying its rowKey. Each line runs the matching ladder (an alias on the item id, the vendor item id,
   * the ERP id, the exact name, an alias on the description, then the words of the description) and stops
   * at the first rung with a hit. More than 1000 rows, a repeated rowKey, or a topN outside 1 to 10 fails
   * the request; a line that cannot be resolved answers UNMATCHED and never affects another line. Writes
   * nothing.
   */
  resolveVendorItems: Array<VendorItemResolution>;
  /**
   * Resolves the effective space capacity for a sub-location and space type at an ISO (year, week):
   * a year-specific window wins over a recurring window, which wins over the sub-location's
   * per-space-type year-round default, else null. Capacity rolls up the space plan's way (the parent
   * wins), so a sub-location under an ancestor with capacity of its own for the week resolves to the
   * outermost such ancestor's, the capacity its demand counts against. Carries the winning source for UI
   * provenance, and the location that holds the capacity. Shares the resolution ladder with the domain path
   * so the two read paths cannot drift.
   */
  resolvedSpaceCapacity?: Maybe<ResolvedSpaceCapacity>;
  /**
   * Calculates a RESTOCK allocation proposal for one item across the selected session stores without writing
   * anything: no session event, no order quantity and no allocation record. It runs the same validation, source
   * lookup and allocation algorithm as allocateRestockSessionInventory, using the station saved on the session.
   * An empty store selection is rejected, and every selected store must have a row for the item in the session.
   * To save a reviewed proposal, send its quantities to autoAllocateRestockSessionOrderQuantities.
   */
  restockAllocationPreview: RestockAllocationPreviewPayload;
  restockCustomerLocations?: Maybe<RestockCustomerLocationsConnection>;
  /**
   * Returns the caller-tenant's pre-calculated Restock demand rows for the
   * asOf day. weeksOfSupply is optional —
   * when omitted, the tenant aggregate's DefaultWeeksOfSupply is read and
   * applied. Tenant scope is derived from UserResolverContext.TenantId
   * and never accepted as input. Paging via the GraphQL Connection spec
   * (first/after/last/before).
   */
  restockDailyDemand?: Maybe<RestockDailyDemandConnection>;
  /**
   * Returns aggregate KPIs for the caller-tenant's pre-calculated Restock demand rows on
   * the asOf day. weeksOfSupply falls back to the
   * tenant's DefaultWeeksOfSupply when omitted — same resolution rule as
   * restockDailyDemand. Tenant scope is derived from
   * UserResolverContext.TenantId and never accepted as input.
   *
   * The optional station argument narrows the two demand-side tiles to one dashboard
   * station, on DIFFERENT axes: TOTAL DEMAND filters the calc slice by the station's resolved
   * store ErpIds (RestockWorkQueueResultDocument.LocationCode $in), while TOTAL
   * AVAILABLE filters ErpAvailabilityDocument.StationCode == station directly. A station
   * that resolves to zero stores yields zero demand (never a silent tenant-wide fall-through).
   * latestCalcDate stays tenant-wide and is NOT narrowed by the station. Omitting
   * station leaves every tile unchanged.
   */
  restockDailyDemandSummary: RestockDailyDemandSummaryData;
  /**
   * Aggregates RestockWorkQueueResultDocument rows for the caller's tenant
   * into per-store rows. Optional itemCodes / locationCodes
   * narrow the scope: null or empty for either parameter means "no filter on this axis."
   * Returns an empty list (not null) when scope yields no rows. Malformed entity codes
   * throw a top-level GraphQL error rather than silently scanning the collection.
   */
  restockDashboardStoreRows: Array<RestockDashboardStoreRowData>;
  /**
   * Server-paged, server-filtered, server-sorted variant of
   * GetRestockDashboardStoreRows. Mirrors the Orders pattern
   * restockSessionOrderItemsBlock: offset-based paging with a parallel
   * RestockDashboardStoreRowsBlockData.TotalCount so the PWA AG Grid
   * serverSide row model can render large tenants (~20k stores for BPF) without shipping
   * every row to the client. Tenant scope is identical to the legacy resolver — derived
   * from the JWT, never an input. The legacy resolver is intentionally untouched; the
   * PWA cutover is the sibling task.
   */
  restockDashboardStoreRowsBlock: RestockDashboardStoreRowsBlockData;
  /**
   * Previews roundRestockSessionOrderQuantityToFullCart over every row of the selected session stores without
   * writing anything: no session event and no order quantity. It runs that mutation's validation, container
   * capacities and rounding, then returns complete row counts and quantity totals, the rows rounding leaves out
   * with their reason, and up to 25 example rows of each kind. Auto round on load sends every session store to
   * that mutation, so a preview whose wholeSession is true shows what it would write. To apply the reviewed
   * rounding, call roundRestockSessionOrderQuantityToFullCart with the same stores.
   */
  restockFullCartPreview: RestockFullCartPreviewPayload;
  /**
   * Unified restock metrics entry point. Returns the seven-concept
   * RestockMetricsData shape at either session or item scope based
   * on whether itemId is supplied. Branches on
   * session.StationCode — non-null routes to the ERP-tenant path
   * (NAV/SQL availability + ERP pricing); null routes to the inventory-tenant path
   * (RestockAvailabilityDocument with Source=Inventory for Available,
   * InventoryItemDocument.AllocatedQuantity for Allocated, MongoPricingService
   * for prices, InTransit held at zero until an inventory-side analogue is
   * modelled). Returns null only when the session does not exist or is soft-deleted.
   */
  restockMetrics?: Maybe<RestockMetrics>;
  /**
   * Returns the BYOA explanation payload for a single Restock row, scoped to the caller's
   * tenant. Returns null when no explanation has been persisted for the
   * (sessionId, storeSkuKey) pair.
   */
  restockRowExplanation?: Maybe<RestockExplanationPayload>;
  restockSession?: Maybe<RestockSessionStateData>;
  /**
   * Current availability of the requested component Items for one Restock session, with its source,
   * scope, time and unit conversion. A session with a saved station reads ERP stock at that station;
   * a session without one reads Internal stock across the caller's current sites. Each Item says
   * whether the source holds a real quantity (zero included), has no record, or could not be read.
   * Returns null when the session does not exist, is deleted or is not in the caller's tenant.
   */
  restockSessionComponentAvailability?: Maybe<RestockSessionComponentAvailabilityPayload>;
  /**
   * Drill-down for a session create that completed with exclusions: the full capped
   * (≤200) excluded item-code list plus tuple/item totals, scoped to the caller's tenant.
   * Backed by the same RestockSessionCreationProgressDocument TTL audit row as the
   * progress surfaces — the subscription payload carries only a bounded sample, so the PWA
   * fetches this on demand when the user expands the amber created-with-exclusions notice.
   * Returns null when the session recorded no exclusions (or the audit row aged out).
   */
  restockSessionCreationExclusions?: Maybe<RestockSessionCreationExclusionsPayload>;
  /**
   * ERP-agnostic export feed of a session's orderable rows (OrderQuantity > 0), joined to
   * store/item/session reference data and resolved container codes. Mirrors the DBR
   * dbrSessionNavOrders shape but is deliberately not Nav-specific — downstream
   * integrations consume the generic store/station/carrier/container attributes.
   */
  restockSessionExportOrders?: Maybe<RestockSessionExportOrdersConnection>;
  /**
   * Paged read of the per-(tenant, session, item) allocated-quantity totals from the
   * CollectionNames.RestockSessionItemAllocations collection. Filtered to the
   * caller's tenant. Powers the allocation wizard's "available" widget.
   */
  restockSessionItemAllocations?: Maybe<RestockSessionItemAllocationsConnection>;
  /**
   * Returns per-item availability for every distinct item in a Restock session. Mirrors
   * dbrSessionItemsAvailability with the same ERP/inventory branching, reading from
   * CollectionNames.RestockSessions + CollectionNames.RestockSessionOrderItems.
   * Returns an empty list when the session is missing, soft-deleted, or has no order items.
   */
  restockSessionItemsAvailability: Array<RestockSessionItemAvailabilityData>;
  /**
   * The session's Kit plan: each attached Kit's counts per Store, its total against the session's
   * own cap and the maximum the current component availability supports, and for every Store and
   * component Item the planned quantity split into Kit usage and individual remainder, in eaches.
   * Derived on every read from the saved inputs, so a later change to a planned quantity shows as a
   * deficit for review, never as a changed count. Returns null when the session does not exist, is
   * deleted or is not in the caller's tenant.
   */
  restockSessionKitPlan?: Maybe<RestockSessionKitPlanData>;
  /**
   * Paged read of the persisted Restock session order-items grid, joined to the same shared
   * reference data as the DBR 1.0 surface (ItemSummary, CustomerLocations, CustomersSummary,
   * ErpItemPricing, CycleCountLog). Mirrors dbrSessionOrderItems.
   */
  restockSessionOrderItems?: Maybe<RestockSessionOrderItemsConnection>;
  /**
   * Windowed/grouped fetch of the Restock session order-items grid. Mirrors
   * dbrSessionOrderItemsBlock; the only difference is the source collection.
   */
  restockSessionOrderItemsBlock: RestockSessionOrderItemsBlockPayload;
  /**
   * Returns the append-only override history for a specific
   * (tenant, session, item, customerLocation) tuple from the
   * CollectionNames.RestockSessionOrderQuantityOverrideHistory collection,
   * ordered by newest change first (OccurredAt descending, with Sequence as a
   * stable tie-breaker). Tenant isolation is enforced by the first filter condition.
   * Mirrors dbrSessionOrderQuantityOverrideHistory.
   */
  restockSessionOrderQuantityOverrideHistory?: Maybe<RestockSessionOrderQuantityOverrideHistoryConnection>;
  /**
   * Returns the latest BYOA-v1 session-create progress phase for a single session, scoped to
   * the caller's tenant. Backed by the RestockSessionCreationProgressDocument
   * TTL audit row written by RestockSessionProgressEmitter. Lets the PWA seed
   * its progress modal from the last-known phase when the user opens the dashboard after the
   * onRestockSessionBatchProgress subscription would have already missed earlier
   * phases. Returns null when no progress doc exists for the session.
   * LEGACY: the subscription now replays the same state on (re)subscribe via the shared
   * RestockSessionProgressReader; this query is deleted once the PWA cutover
   * ships (helm task 62b07d66cf75406bbd807b2cac77bdee).
   */
  restockSessionProgress?: Maybe<RestockSessionBatchProgressPayload>;
  /**
   * Returns the persisted Restock calculation steps for a single
   * (sessionId, itemId, locationId) row, scoped to the caller's tenant. Steps live in
   * the RestockSessionCalcStepsDocument side collection (off the session's event
   * stream) and share the row with the BYOA explanation payload. Returns an empty array when
   * the row does not exist or its TTL window has expired. Mirrors
   * calcStepsForDbrSessionRow; the only signature difference is the composite
   * storeSkuKey assembled from (locationId, itemId).
   */
  restockSessionRowCalcSteps: Array<RestockCalcStepDocument>;
  /**
   * The Store pick tickets of a submitted session, one complete envelope for HTML and PDF output. Each
   * ticket lists each Kit the Store takes with its count and its components in eaches, then each Item the
   * Store takes individually: a Kit component appears there only with the positive eaches its Kits leave of
   * the planned quantity, and no combined total is listed. Every Store in scope is a ticket or a skip with
   * its reason. Built from what the session saved, never recalculated, and read only: printing again
   * writes nothing, whatever the state of the session's orders. Notes are never part of it.
   */
  restockSessionStoreTickets: RestockSessionStoreTicketsPayload;
  /**
   * Returns session-level totals for the v2 Submit Orders confirmation card: store count
   * (from the session document), selected item row count, and sums of Carts and
   * UnitValue × OrderQuantity across all RestockSessionOrderItemDocument
   * rows for the session. Mirrors dbrSessionSubmitSummary. Returns null when
   * the session does not exist, is soft-deleted, or the sessionId fails strict validation.
   */
  restockSessionSubmitSummary?: Maybe<RestockSessionSubmitSummaryData>;
  restockSessions?: Maybe<RestockSessionsConnection>;
  /**
   * The BP organic lots currently available for the calling tenant — the parity replacement for
   * inventory-api's retailAvailableBpLots. Read from the worker-owned RetailBpLots read
   * model with every retail count netted off the mirrored Nav quantity in eaches, both the counts recorded
   * here and the counts the legacy app recorded before the cutover, so a lot that has been fully dropped
   * off disappears instead of staying assignable forever. One row per Nav transfer-shipment line: when a
   * lot arrived on several lines the recorded counts are apportioned across them, so summing the rows of a
   * lot yields its true remaining availability. Pass includeDepleted: true to also list the lots
   * that are used up, with their netted quantity (zero or below), for credits and cycle counts against a
   * lot that has nothing left. Paged, filterable, sortable — over the NETTED quantity — so the PWA can
   * scope by product or station. Tenant-scoped.
   */
  retailAvailableBpLots?: Maybe<RetailAvailableBpLotsConnection>;
  /**
   * The retail store-count audit history for the calling tenant — the immutable record of every
   * count recorded by field users. Tenant-scoped; paged, filterable, sortable so the PWA can scope
   * by product, location, or count type for triage and read-back.
   */
  retailProductCounts?: Maybe<RetailProductCountsConnection>;
  /**
   * How completely this tenant's revenue routing is configured: per-rung mapped/total counts,
   * whether the tenant default can fire, every mapping that silently points at an archived
   * account, and the items whose categories disagree. The tenant comes from the caller's context,
   * so a tenant can never read another tenant's coverage.
   */
  revenueRoutingCoverage: RevenueRoutingCoverage;
  /** Gets paginated, filtered, and sortable RFID scan records for the current tenant */
  rfidScans?: Maybe<RfidScansConnection>;
  /**
   * Returns the calling tenant's route -> delivery-schedule mappings (the sparse route-code
   * -> DeliveryScheduleId map), or null when the tenant has never set any. Mirrors
   * orderEmailRecipientRouting. A route absent from Entries has no mapping.
   */
  routeDeliveryScheduleConfig?: Maybe<RouteDeliveryScheduleConfigDocument>;
  /**
   * The distinct route codes in use across this tenant's customers, ship-tos, orders and tenant
   * default route. The optional search argument is a case-insensitive "contains" over the route
   * code, so a term matches regardless of the casing it was typed or stored in.
   */
  routes?: Maybe<RoutesConnection>;
  runnableConsolidationApplications: Array<ConsolidationApplication>;
  /**
   * Import runs the import worker may claim, across every tenant, oldest first, at most 25: no live claim,
   * and Queued, Running or Applied, or Paused or Blocked with a Resume or Cancel waiting. Worker only.
   */
  runnableMigrationImportRuns: Array<MigrationImportRunStatus>;
  /**
   * Active sales items that could be the one a production item stands for: those of the same genus,
   * ignoring case, ranked by how many of the production item's series and color words appear in their
   * name or description and by whether a size's code is the production item's category code. At most
   * top. A ranking by plain matching, never a recommendation.
   */
  salesItemCandidatesForProductionItem: Array<ItemSummaryDocument>;
  /**
   * The Active sales items whose code matches number, a production item's number, ignoring capitals and all
   * spaces (dashes, dots and other characters still count), ordered by item id. A list, so none, one and several stay distinguishable. A blank number matches nothing.
   */
  salesItemsMatchingProductionItemNumber: Array<ItemSummaryDocument>;
  scavengeLog?: Maybe<ScavengeLogConnection>;
  /**
   * The tenant's scheduled item-to-item transfers, soonest due first unless an order is given, filterable by
   * schedule id, status and the source location, item and grade. A caller limited to assigned sites sees a
   * schedule when its source or its destination location is one of theirs. Not gated by the
   * ScheduledItemTransfers flag, so pending schedules stay visible and cancellable when it is off.
   */
  scheduledInventoryTransfers?: Maybe<ScheduledInventoryTransfersConnection>;
  /**
   * Gets the current tenant's selectable senders merged across EVERY registered channel source
   * (SendGrid single + domain, SMTP), each node carrying its channel. Each source enforces
   * its own send-eligibility contract server-side (SendGrid exposes only verified senders), never a
   * client-supplied filter. The merged set is small and bounded, so it is returned as a plain list
   * rather than a paged connection. isDefault follows the approved sender selection: no sender under
   * PLATFORM, only the pinned sender under COMPANY, the tenant default flag under INHERIT.
   *
   * CALLER-AWARE (Decision D): an unrestricted staff (admin) caller sees every selectable sender;
   * a non-admin staff caller never sees a sender flagged adminOnly. This is a UX filter on
   * the dropdown — the real security boundary is the use-time TenantEmailSenderGate
   * enforced on the FK-validated write paths.
   */
  selectableEmailSenders: Array<TenantEmailSenderData>;
  /**
   * Returns the hard goods (MaterialItems) the tenant offers for sale in the FULFILL context —
   * i.e. those flagged sellable and currently active. This is the available-to-sell surface a FULFILL
   * order picker uses to add a hard good to an order line. Non-sellable hard goods are excluded
   * here, but remain freely usable as item upgrades (any hard good can be an upgrade).
   */
  sellableHardgoods?: Maybe<SellableHardgoodsConnection>;
  /** Resolves the DNS/SendGrid domain-policy signal for the given domain. */
  senderDomainPolicy: SenderDomainPolicyData;
  /**
   * Returns the session-level restock metrics for the v2 Restock Orders sidebar.
   * Seven concepts (Available / Allocated / In Transit / Available for Orders /
   * On Order / Remaining Availability / Utilization %), each with a quantity and a
   * wholesale dollar value. Available, Allocated, and In Transit are deduped per
   * ItemId (wsapi mirrors each item onto every customer-location row, so
   * the per-item figure must be counted once). Allocated vs. In Transit routing
   * is decided by a per-tenant mapping keyed off user.TenantId. When the
   * session has no StationCode (inventory-tenant path), ERP-sourced
   * concepts (Available / In Transit / their values) are returned as zero; the
   * live OnOrder/RemainingAvailability/Utilization still
   * reflect the session's OrderQuantity state. RemainingAvailability
   * is unclamped — negatives signal legitimate over-allocation. Utilization
   * returns a large sentinel (9999.0) when AvailableForOrders <= 0
   * and OnOrder > 0, and 0 when both are zero. Returns null
   * when the session does not exist, is soft-deleted, or sessionId
   * fails ValidIdStrict.
   */
  sessionRestockMetrics?: Maybe<SessionRestockMetricsData>;
  sftpSystemSettings: SftpSystemSettingsStateData;
  sftpTenantConfig?: Maybe<SftpTenantConfigStateData>;
  sftpTenantConfigs?: Maybe<SftpTenantConfigsConnection>;
  sftpTenants: Array<Scalars['String']['output']>;
  /**
   * Distinct ship-from site names present in the tenant's non-deleted combined orders (orders + master
   * orders) after applying the resolver's where filter. Powers the Fulfill Orders grid's Ship-From
   * Site set-filter; see the ordersStatuses query for the set-filter contract. Blank names — the
   * master-order rows and legacy / pre-V3 orders that carry no structured ship-from site — are excluded,
   * so the list is exactly the distinct set of sites actually in use.
   */
  shipFromSiteNames: Array<Scalars['String']['output']>;
  /**
   * Previews combining the loser ship-to into the survivor ship-to of the same customer: every field
   * grouped by kind with its value on each ship-to and after the combine, the conflicts that need a pick,
   * what refuses the combine, and each ship-to's history. Writes nothing. Refused for a tenant the
   * ShipToCombine feature flag switches off.
   */
  shipToCombinePreview: ShipToCombinePreviewPayload;
  /**
   * Generates the Bonnie-branded shipping acknowledgement PDF. Restricted to the BPF tenant —
   * returns null for any other tenant. Non-BPF tenants must use the reporting module
   * via generateReportPdf with the report ID configured in
   * TenantState.OrderAcknowledgementReportId.
   * @deprecated BPF-only legacy generator. Non-BPF tenants must use generateReportPdf with the tenant's OrderAcknowledgementReportId.
   */
  shippingAcknowledgmentPdf?: Maybe<OrderDetailsPdfData>;
  /**
   * Shrink units and percent of produced, grouped by the requested keys, for a date range and an optional
   * site, with a grand total. Scoped to the caller's sites like the other PRODUCE reads.
   */
  shrinkLossReport: ShrinkLossReport;
  siteLocation?: Maybe<SiteLocationDocument>;
  siteLocationAsyncImportJobRows?: Maybe<SiteLocationAsyncImportJobRowsConnection>;
  siteLocationTypeRelationships: SiteLocationTypeRelationships;
  siteLocations?: Maybe<SiteLocationsConnection>;
  /**
   * Computes export-precondition site-map coverage for a forecast (spec P10/P12): over the grid of the
   * forecast customer's locations by the forecast's programs, the location-and-program pairs that lack a
   * site map. The FORECAST feature gate is checked FIRST — a tenant without the flag gets null, never a
   * computed coverage. The forecast id is validated and the forecast is loaded tenant-scoped (its
   * composite id embeds the tenant); a missing forecast returns null. Locations and existing mappings
   * are read tenant-and-customer scoped (guarded by a cross-tenant leak test). A well-formed forecast
   * with no locations or no programs returns an empty, complete coverage (not null) — an empty gap list
   * is a valid complete result.
   */
  siteMapCoverage?: Maybe<SiteMapCoverage>;
  /**
   * Lists the calling tenant's active site maps for a customer, optionally narrowed to a single
   * customer location. Tenant-scoped via the load-bearing TenantId filter, guarded by a cross-tenant
   * leak integration test. Returns no rows when the Forecast flag is disabled for the tenant.
   */
  siteMaps?: Maybe<SiteMapsConnection>;
  sizeUom?: Maybe<SizeUomStateData>;
  sizeUoms?: Maybe<SizeUomsConnection>;
  /**
   * Returns customer SKU/UPC/retail-price mappings (renamed from "customerItems") for the
   * given itemId within the caller's tenant. Same shape as the
   * deprecated customerItems query — both back the same Mongo collection.
   */
  skuUpcMappings?: Maybe<SkuUpcMappingsConnection>;
  /**
   * Returns customer SKU/UPC/retail-price mappings for every requested item id within the
   * caller's tenant, so a catalog-sized import fetches all existing cross-references in a bounded
   * number of round trips instead of one query per item. Item ids with no cross-references simply
   * contribute no nodes, and an empty itemIds list yields an empty connection.
   * Requesting more than 1000 item ids is refused with a validation error, so no caller can drive
   * an unbounded lookup; chunk a larger file client-side.
   */
  skuUpcMappingsForItems?: Maybe<SkuUpcMappingsForItemsConnection>;
  /**
   * Paginated, filterable, sortable space-capacity windows for the tenant. Clients scope to a site,
   * sub-location or space type via the filter input (e.g. where: { siteLocationId: { eq } }).
   */
  spaceCapacityWindows?: Maybe<SpaceCapacityWindowsConnection>;
  /**
   * Server-computed group headers (with per-group counts) for the Space Events sidebar, so the
   * client renders grouping over the full event list without loading every event and grouping in
   * memory. groupBy selects the bucket key dimension (event Status or
   * event Name). search is the same case-insensitive OR-contains over the
   * event name the sidebar applies, so counts reflect the active search. The group's children are
   * then lazy-loaded via productionSpaceEvents filtered to the bucket key — each bucket's
   * Key equals that list's where eq-value for the
   * dimension (Status keys are canonical SCREAMING_SNAKE enum names).
   */
  spaceEventGroups: Array<SpaceEventGroupBucket>;
  /**
   * Paginated, filterable, sortable year-round per-space-type default capacities for the tenant.
   * Clients scope to a site, sub-location or space type via the filter input (e.g.
   * where: { siteLocationId: { eq } }).
   */
  spaceTypeCapacities?: Maybe<SpaceTypeCapacitiesConnection>;
  spaceUtilization: Array<SpaceCapacityRow>;
  /**
   * Space use at every site the caller may see, one row per site, space type and ISO week in the window,
   * every production plan together. A week shows when the site has usage of the type that week or capacity
   * for it, so a free week still shows its capacity. Rows are sorted by site name, space-type code, ISO
   * year and ISO week.
   */
  spaceUtilizationAllSites: Array<SpaceSiteWeekRow>;
  /**
   * Stateless, read-only what-if overlay for the capacity board. Loads the same space-usage
   * documents as the spaceUtilization board for the given filters, applies the staged moves in
   * memory, adds the space each new lot would use if it were created, and returns before/after usage
   * per row plus violations and per-move validity/staleness. A new lot that cannot be planned adds
   * nothing and is reported in newLotErrors by its index; a failed read fails the request. Performs no
   * writes and never touches ProductionJob.SpaceDimensions.
   */
  spaceUtilizationPreview: SpaceUtilizationPreview;
  /**
   * Staged equivalent of the production categories query — cursor-paged,
   * with where/order against the same CategoryDocument type the
   * pwa Category grid already binds to. Reads from Category.Staged.Summary
   * populated by validateCategoryDocuments.
   */
  stagedCategories?: Maybe<StagedCategoriesConnection>;
  /**
   * Staged equivalent of the production single-category lookup — returns the
   * staged CategoryDocument for the given code, or null.
   */
  stagedCategory?: Maybe<CategoryDocument>;
  /**
   * Staged equivalent of the production customer(customerId) query —
   * returns a CustomerStateData stitched from the staged summary
   * + the staged ship-to locations so the pwa fragment Customer on
   * CustomerStateData works unchanged. Returns null when no staged
   * row exists for the customerId.
   */
  stagedCustomer?: Maybe<CustomerStateData>;
  /**
   * Staged equivalent of the production customerLocations query —
   * cursor-paged, with where/order against the same
   * CustomerLocationDocument type the pwa already binds to.
   * Reads from Customers.Staged.Locations populated by
   * validateCustomerDocuments.
   */
  stagedCustomerLocations?: Maybe<StagedCustomerLocationsConnection>;
  /**
   * Staged equivalent of the production customers query — cursor-paged,
   * with where/order against the same CustomersSummaryDocument
   * type the pwa Customer grid already binds to. Reads from
   * Customers.Staged.Summary populated by validateCustomerDocuments.
   */
  stagedCustomers?: Maybe<StagedCustomersConnection>;
  /**
   * Staged single-order lookup — returns the staged
   * HistoricalOrderStagedSummaryDocument for the given order id, or null when
   * no staged row exists for the (tenantId, orderId) pair.
   */
  stagedHistoricalOrder?: Maybe<HistoricalOrderStagedSummaryDocument>;
  /**
   * Staged line items for one order — returns the
   * HistoricalOrderStagedLineItemDocument echoes written by
   * validateHistoricalOrderDocuments into HistoricalOrders.Staged.Lines, in
   * line-number order, so the pwa staged-review grid can show an order's lines on row click.
   * Returns an empty list when no staged lines exist for the (tenantId, orderId) pair.
   */
  stagedHistoricalOrderLineItems: Array<HistoricalOrderStagedLineItemDocument>;
  /**
   * Staged historical orders for the tenant — cursor-paged, with where/order against the
   * HistoricalOrderStagedSummaryDocument the pwa staged-review grid binds to. Reads
   * from HistoricalOrders.Staged.Summary populated by validateHistoricalOrderDocuments.
   */
  stagedHistoricalOrders?: Maybe<StagedHistoricalOrdersConnection>;
  /**
   * Staged equivalent of the production getInventoryItems query — cursor-paged,
   * with where/order against the same InventoryItemDocument type the pwa
   * inventory grid already binds to. Reads from Inventory.Staged.Summary
   * populated by validateInventoryItemDocuments, resolving the linked item name +
   * sku and location name at query time via the staged name-lookup $lookup (the
   * staging projection writes those fields empty by design).
   */
  stagedInventoryItems?: Maybe<StagedInventoryItemsConnection>;
  /**
   * Staged equivalent of the production item(itemId) query — returns
   * an ItemStateData stitched from the staged summary so the
   * pwa fragment Item on ItemStateData works unchanged. Returns
   * null when no staged row exists for the itemId.
   */
  stagedItem?: Maybe<ItemStateData>;
  /**
   * Staged equivalent of the production items query — cursor-paged,
   * with where/order against the same ItemSummaryDocument type
   * the pwa Item grid already binds to. Reads from Items.Staged.Summary
   * populated by validateItemsDocuments.
   */
  stagedItems?: Maybe<StagedItemsConnection>;
  /**
   * Staged equivalent of the production priceGroups query — cursor-paged,
   * with where/order against the same PriceGroupDocument type the pwa
   * price-group grid already binds to. Reads from PriceGroups.Staged.Summary
   * populated by validatePriceGroupDocuments.
   */
  stagedPriceGroups?: Maybe<StagedPriceGroupsConnection>;
  /**
   * Staged equivalent of the production priceLevels query — cursor-paged,
   * with where/order against the same PriceLevelDocument type the pwa
   * already binds to (filter on priceGroupId for one group's levels).
   * Reads from PriceGroups.Staged.Levels populated by
   * validatePriceGroupDocuments; no item/category $lookup is needed because
   * the staged documents carry TargetName from the posted payload.
   *
   * Filtering/sorting go through the staged-specific input types rather than a bare
   * [UseFiltering]/[UseSorting]: those bind by CLR type and would pick up the
   * portal-motivated GrowerCost exclusion the production priceLevels query needs,
   * stripping cost filters from a SuperAdmin surface no portal caller can reach.
   */
  stagedPriceLevels?: Maybe<StagedPriceLevelsConnection>;
  /**
   * Staged equivalent of the production siteLocation(siteLocationId) query.
   * Returns null when no staged row exists for the siteLocationId.
   */
  stagedSiteLocation?: Maybe<SiteLocationDocument>;
  /**
   * Staged equivalent of the production siteLocations query — cursor-paged, with
   * where/order against the same SiteLocationDocument type the pwa already binds
   * to. Reads from SiteLocations.Staged.Summary populated by
   * validateSiteLocationsDocuments.
   */
  stagedSiteLocations?: Maybe<StagedSiteLocationsConnection>;
  /**
   * Staged equivalent of the production subLocations query — cursor-paged, with
   * where/order against the same SubLocationDocument type the pwa already binds
   * to. Reads from SiteLocations.Staged.Locations populated by
   * validateSiteLocationsDocuments.
   */
  stagedSubLocations?: Maybe<StagedSubLocationsConnection>;
  /**
   * Staged equivalent of the production termsById(termsId) query — returns a
   * TermsStateData stitched from the staged summary so the pwa Terms detail
   * fragments work unchanged. Returns null when no staged row exists for the termsId.
   */
  stagedTerm?: Maybe<TermsStateData>;
  /**
   * Staged equivalent of the production terms query — cursor-paged, with
   * where/order against the same TermsDocument type the pwa Terms grid already
   * binds to. Reads from Terms.Staged.Summary populated by
   * validateTermsDocuments. Uses the production
   * TermsDocumentFilterInputType so the staged filter input matches production
   * (percent-unit accrueInterestPercentage operands).
   */
  stagedTerms?: Maybe<StagedTermsConnection>;
  /**
   * Gets the print batch for one statement run: its status, how many of its statements have been
   * rendered so far out of how many it holds, why it failed when it did, and the URL to download it
   * from once it is ready.
   */
  statementPrintBatch: StatementPrintBatchPayload;
  /**
   * The BP organic lots available at a single station for the calling tenant — the parity replacement
   * for inventory-api's stationBpLotInventory, scoped to the supplied station
   * (stationLocationId, the PWA's treeLocationAndChildren station node).
   * Like inventory-api's station arm, the Nav transfer-shipment lines of one lot are summed into a
   * single row and the recorded retail counts, new and legacy, are netted off that total ONCE in eaches —
   * so this surface reports a lot's true station-wide availability. Paged, filterable, sortable — over
   * the NETTED quantity; tenant-scoped.
   */
  stationBpLotInventory?: Maybe<StationBpLotInventoryConnection>;
  /** The number of held plants that turning customer-item stock off would release. */
  stockByCustomerItemDisablePreview?: Maybe<StockByCustomerItemDisablePreview>;
  storeClasses?: Maybe<StoreClassStateData>;
  storedConsolidationPreview?: Maybe<ConsolidationPreview>;
  streamCounts?: Maybe<StreamCountsConnection>;
  /**
   * Stripe's product tax codes: the list an item's Stripe tax code is picked from. Read from Stripe and
   * kept in memory for an hour, never stored. When Stripe cannot be reached the query fails with a
   * stripe_tax_codes_unavailable error rather than returning an empty list.
   */
  stripeTaxCodes: Array<StripeTaxCode>;
  /**
   * For one UTC month written yyyy-MM, each grower's invoices recorded with Stripe Tax in a
   * jurisdiction where they are registered, the credit Silver Fern owes for those Stripe Tax fees in
   * the currency Stripe charged them, and the Stripe Tax calculations Work Suite made for them. A grower
   * with no counted invoice and no calculation in the month has no row.
   */
  stripeTaxFeeCredits: Array<StripeTaxFeeCredit>;
  subLocation?: Maybe<SubLocationDocument>;
  /**
   * Shows what combining the loser sub-location into the survivor would do: every field with both
   * values and the result, the records that still reference the loser and block the combine, each
   * side's history, and whether the server would keep the same survivor. Reads only; nothing is
   * written. Refused, like the combine, when the two are not Active siblings of the same type on the
   * site, either is already combined, or the loser has child sub-locations.
   */
  subLocationCombinePreview: SubLocationCombinePreviewPayload;
  subLocations?: Maybe<SubLocationsConnection>;
  /**
   * One import workspace: its source, where its extraction stands, the revision its review is at and
   * which approval it is working from. Null when the tenant holds no such import.
   */
  supplierPriceImport?: Maybe<SupplierPriceImportDocument>;
  /**
   * Where an approved supplier price import's apply stands, row by row, for every row of the approved
   * document. Null when the tenant's approval of this import was never applied.
   */
  supplierPriceImportApply?: Maybe<SupplierPriceImportApply>;
  /**
   * The selected rows that are not ready to be saved, and every unresolved thing holding each one.
   * A read only: it changes nothing and saves nothing. A row is listed while anything about it is
   * unresolved, so an empty list means every selected row is ready; a row that is not selected is
   * not listed at all. Each row carries all of its reasons rather than the first one found, so a
   * reviewer can fix the whole row in one pass instead of meeting the next reason after each save.
   */
  supplierPriceImportHeldRows: Array<SupplierPriceBlockedRow>;
  /**
   * Ranks the materials one supplier line might mean, best first. A read only: it ranks and
   * reports what the purchasing vendor currently charges, and records no match, because deciding
   * two things are the same product is a person's judgement. An empty candidates list means this
   * tenant genuinely has no material matching the line; a FAILURE to read them is an error, never
   * an empty list, because a reviewer told there is nothing will create a duplicate material.
   * Truncated says more matched than were returned, so a long list never reads as an empty one.
   */
  supplierPriceImportRowCandidates: SupplierPriceCandidateResult;
  /**
   * The live rows of one import — the published extraction revision's, in document order, with each
   * reviewer decision beside what was read.
   */
  supplierPriceImportRows: Array<SupplierPriceImportRowDocument>;
  /**
   * The tenant's own imports that are not discarded, newest activity first, so a reviewer can come back
   * to one they left. At most 50, the most one page of a paged list in this API holds unless that list
   * sets its own maximum. Given a purchasing vendor, only that vendor's imports.
   */
  supplierPriceImports: Array<SupplierPriceImportDocument>;
  /**
   * Read-only support snapshot of the named tenant: onboarding state plus its import jobs created in
   * the trailing 14 days, newest first. Null when no live tenant has that id.
   */
  supportTenantSnapshot?: Maybe<SupportTenantSnapshot>;
  synchronizationIterations?: Maybe<SynchronizationIterationsConnection>;
  synchronizationOnHandProcessIterations?: Maybe<SynchronizationOnHandProcessIterationsConnection>;
  synchronizationOnHandQueueingIterations?: Maybe<SynchronizationOnHandQueueingIterationsConnection>;
  /**
   * The calling tenant's tag colors, deleted ones included so records can still name them. Filter on
   * status ACTIVE for the colors a user can pick.
   */
  tagColors?: Maybe<TagColorsConnection>;
  /** Get a single task assignment by ID from the event store. */
  taskAssignment?: Maybe<TaskAssignmentStateData>;
  /** Get all task assignments for the tenant from MongoDB with paging, filtering, and sorting. */
  taskAssignments?: Maybe<TaskAssignmentsConnection>;
  /**
   * Server-computed group headers (with per-group counts) for the Task Events sidebar, so the client
   * renders grouping over the full event list without loading every event and grouping in memory.
   * groupBy selects the bucket key dimension (event Status or event
   * Name). search is the same case-insensitive OR-contains over the event
   * name the sidebar applies, so counts reflect the active search. The base set mirrors
   * productionTaskEvents — tenant-scoped and excluding Deleted — so a Status group-by's bucket
   * counts sum to the list total. The group's children are then lazy-loaded via
   * productionTaskEvents filtered to the bucket key, which equals that list's where
   * eq-value for the dimension (Status keys are canonical SCREAMING_SNAKE enum names).
   */
  taskEventGroups: Array<TaskEventGroupBucket>;
  taskEventType?: Maybe<TaskEventTypeStateData>;
  taskEventTypes?: Maybe<TaskEventTypesConnection>;
  tenant?: Maybe<TenantStateData>;
  /**
   * Returns the authenticated tenant's production import jobs for the user-facing list
   * (the PWA ScheduleImportListPage). Unlike GetAsyncImportJobs — which is intentionally
   * cross-tenant for the shared AsyncImportWorker — this query is tenant-scoped server-side:
   * the auth-context tenant from TenantResolver.RequireTenantId is AND-ed into the Mongo filter
   * before [UseFiltering] applies any client where-clause, so a client that supplies a mismatched
   * tenantId filter gets an impossible (tenantId == auth AND tenantId == client) predicate and
   * sees only the auth tenant's rows. The PWA-needed filters (createdBy, jobType) and createdAt
   * ordering remain available via the standard filtering/sorting surface; only tenantId is forced
   * server-side.
   */
  tenantAsyncImportJobs?: Maybe<TenantAsyncImportJobsConnection>;
  /** Whether the caller's tenant bills its sales orders through an ERP (the sales order sync to the ERP is set up for it). Staff only. */
  tenantBillsThroughErp: Scalars['Boolean']['output'];
  /**
   * UNAUTHENTICATED slug → tenant lookup for the portal vanity subdomain. The worksuite-pwa calls
   * this pre-login to resolve which tenant a {companySlug}.portal.silverfern.* host belongs
   * to, then bootstraps its tenant context exactly as it does from the /portal/:tenantSlug
   * path. Returns null for an unknown/unclaimed slug. Rate-limited per client (the only key
   * on this anonymous surface), gated like the other public portal reads
   * (publicUserInviteByCode, trialRequestStatus).
   */
  tenantByCompanySlug?: Maybe<TenantByCompanySlugView>;
  /**
   * UNAUTHENTICATED host → tenant lookup covering BOTH portal vanity layers: a registered
   * {companySlug}.portal.silverfern.* subdomain, and a tenant's own VERIFIED custom domain.
   * The worksuite-pwa calls this once pre-login on whatever host it was loaded from, then bootstraps
   * its tenant context exactly as it does from the /portal/:tenantSlug path. Returns
   * null for an unknown host, a non-portal host, and — deliberately — a custom domain whose
   * ownership is still unproven.
   */
  tenantByPortalHost?: Maybe<PortalHostTenantView>;
  /**
   * Returns the calling tenant's carrier configuration record (the tenant-default carrier), or
   * null when the tenant has not yet set a default. Mirrors tenantRouteConfig.
   */
  tenantCarrierConfig?: Maybe<TenantCarrierConfigDocument>;
  tenantCustomerPermissions?: Maybe<TenantCustomerPermissionsConnection>;
  /**
   * This tenant's bound email-authentication domain, or null when no domain is bound. Select
   * dnsRecords to fetch the live DNS records to publish at the domain's DNS provider before
   * calling validateTenantEmailDomain.
   */
  tenantEmailDomain?: Maybe<TenantEmailDomainData>;
  /**
   * Gets the current tenant's sender selection: the configured selection (kind, intended use, the pinned company
   * sender with its SMTP connection id, revision and receipt) and, separately, the effective route customer email
   * takes now (From identity, reply routing, intended use and readiness). Reading it never verifies a sender,
   * changes the selection or sends anything.
   */
  tenantEmailSenderSelection: TenantEmailSenderSelectionData;
  /** Gets all email sender identities for the current tenant. */
  tenantEmailSenders?: Maybe<TenantEmailSendersConnection>;
  tenantId: Scalars['String']['output'];
  /** Gets a single tenant integration token by integration ID from the event store. */
  tenantIntegrationToken?: Maybe<TenantIntegrationTokensStateData>;
  /** Gets all tenant integration tokens from MongoDB for the current tenant. */
  tenantIntegrationTokens: Array<TenantIntegrationTokenDocument>;
  /**
   * The caller's tenant's current multi-factor requirement for the staff WorkSuite application.
   * Reports an OFF, no-grace requirement when the (tenant, application) pair has never had one set
   * — the same state a tenant that never visits Company Settings is already in.
   *
   *
   * **Returns:**
   * The tenant's requirement, or why it could not be read.
   */
  tenantMultiFactorPolicy: TenantMultiFactorPolicyPayload;
  /**
   * The streams and collections a reset of the given module deletes. ALL is everything except
   * preserved data. An unknown module, or an owner not offered for reset, is an UNKNOWN_RESET_MODULE error.
   * ORDERS is an explicit selection for one tenant (tenantId required, else
   * RESET_TENANT_REQUIRED): the exact streams and documents to delete, optionally limited to orders created
   * from createdFrom to createdTo (inclusive days on the tenant's clock). A range for any other
   * module is RESET_RANGE_NOT_SUPPORTED; one ending before it starts is INVALID_RESET_RANGE.
   */
  tenantResetManifest: TenantResetManifest;
  /** The modules a tenant may be reset by: ALL first, then each module offered on its own. */
  tenantResetModules: Array<TenantResetModule>;
  /**
   * Returns the calling tenant's route configuration record (the tenant-default route), or
   * null when the tenant has not yet set a default.
   */
  tenantRouteConfig?: Maybe<TenantRouteConfigDocument>;
  /**
   * Gets the current tenant's custom SMTP connection (host / port / username / mode / addresses /
   * status / last-verified), or null when none is configured. The password is never exposed.
   */
  tenantSmtpConnection?: Maybe<TenantSmtpConnectionData>;
  /**
   * The calling tenant's Stripe Connect state: connected account id, onboarding state, Stripe Tax
   * readiness, the outstanding missing fields, and when readiness last changed. This is the surface
   * worksuite-pwa's Stripe Tax setup page reads, and isTaxReady on it is THE gate invoicing
   * and the order tax estimate consult.
   *
   * Reads the tenant's AGGREGATE (not the read model), the same source of truth the connect
   * mutations return, so the answer is strongly consistent with a just-completed create or refresh
   * — the same rationale as tenant.orderEaseIntegration. Tenant-scoped: the tenant comes from
   * the caller's JWT and is never an argument, so there is no cross-tenant read. A tenant with no
   * connect events yet resolves to the empty state (no account, not tax ready) rather than null, so
   * the pwa renders "not set up" without a null branch.
   */
  tenantStripeConnect: TenantStripeConnectData;
  /**
   * Returns the calling tenant's full purchase UOM name list: the fixed seed (each, bag, bale,
   * box, bundle, case, flat, pallet, roll, tray) unioned with any names the tenant has added.
   * Always returns at least the seed — a tenant that has never added a custom name still sees the
   * full default picklist, since the seed costs no aggregate/document to exist.
   */
  tenantUomNames: Array<Scalars['String']['output']>;
  terms?: Maybe<TermsConnection>;
  termsById?: Maybe<TermsStateData>;
  /**
   * Returns the caller's payment terms whose name matches any of the requested names
   * CASE-INSENSITIVELY, so a CSV cell carrying "net 30" resolves the stored terms "Net 30". Same
   * tenant scoping, filter and sort surface as terms; this arm only adds the name predicate,
   * which where: { name: { in: [...] } } cannot express because every string filter operation
   * is case-sensitive.
   * Match rule: leading and trailing whitespace is trimmed on BOTH sides, then the names are compared
   * ignoring case. Inner whitespace is NOT collapsed - "net  30" (two spaces) does not match
   * "Net 30" - which is the rule the pwa's terms import keys its own lookup by, so raw CSV cells can
   * be sent as-is. Regex characters in a name match literally. Names that are blank after trimming
   * are ignored, as are names longer than a terms name can be stored (128 characters); requesting
   * no usable name returns an EMPTY page rather than every terms row in the tenant.
   * Deleted terms are excluded; active, inactive and combined terms are all returned, because a new
   * terms name is refused when ANY of them already carries it. A name nothing matches simply contributes
   * no nodes. Requesting more than 1000 names is refused with a validation error; chunk a larger
   * file client-side. Staff only - not available to customer-portal callers.
   */
  termsByNames?: Maybe<TermsByNamesConnection>;
  /**
   * Shows what combining the loser into the survivor would do: every field with both values and the
   * result, how many customers, ship-tos and orders use each side, whether the default moves, and
   * whether the server would keep the same survivor. Reads only; nothing is written. A combine that
   * would be refused whatever the picks is shown with the error code in refusal.
   */
  termsCombinePreview: TermsCombinePreviewPayload;
  termsIdsByErpId: Array<TermsErpIdPair>;
  /**
   * Returns every configured trial policy. The collection holds one document per
   * TrialKind, so this is a small unpaged list by design.
   */
  trialPolicies: Array<TrialPolicyDocument>;
  /**
   * Returns the policy for one trial kind, or null when that kind has no policy row. Null is not
   * "unrestricted" — request-path callers read the policy through
   * ITrialPolicyProvider, which substitutes the built-in Standard defaults instead.
   */
  trialPolicy?: Maybe<TrialPolicyDocument>;
  /**
   * ANONYMOUS coarse status lookup by request id. Returns ONLY the request id and a collapsed
   * public status ({Pending, Approved, Rejected}); it exposes no contact PII, no match
   * candidates, and nothing about tenant existence. Keyed by the caller's own unguessable request
   * id and rate-limited per IP. Returns null for an unknown id.
   */
  trialRequestStatus?: Maybe<TrialRequestStatusView>;
  /**
   * SUPERADMIN approval queue: every trial request with full detail INCLUDING match candidates
   * and contact info, filterable/sortable/paged. This is the only surface that ever exposes the
   * match annotations. Oldest-first is the intended default ordering for the approval queue.
   */
  trialRequests?: Maybe<TrialRequestsConnection>;
  /**
   * Per-trial-tenant usage for the admin Trial Tenants grid and its detail drawer.
   *
   * tenantIds narrows the result to those tenants; omitted or empty returns every trial
   * tenant. Non-trial and deleted tenants are never returned, even when named explicitly — this
   * surface is defined over trial tenants, and a tenant with no cap context would be meaningless
   * here.
   */
  trialTenantUsage: Array<TrialTenantUsage>;
  /**
   * Lists the receipts on orders' payment ledgers that the order's live invoice does not hold: money
   * stranded when an invoice was issued while a payment or deposit was being written, and payments
   * imported from the accounting platform after the invoice was issued. Read-only; it records nothing.
   * Each row names the order, the invoice, the receipt's reference, amount and date, and the reason
   * (APPLIED means carryOrderReceiptsToInvoice would record it; any other outcome is why the repair would
   * hold it back). Checks a page of the tenant's live invoices per call: resume with nextAfterInvoiceId.
   */
  uncarriedOrderReceipts: UncarriedOrderReceiptsResult;
  /**
   * Handoffs left undone for more than one claim window, across every tenant, earliest due first, at most
   * 5, each with its kind and when it became due, for the repair to take one at a time. Worker only.
   */
  undoneMigrationHandoffs: Array<MigrationUndoneHandoff>;
  /**
   * W3. Link-invoice picker: cached bills of the PO vendor's linked Ramp vendor that are linked to no PO,
   * not ARCHIVED, newest issuedAt first, at most 50. Empty when the vendor is not linked.
   */
  unlinkedRampBillsForPurchaseOrder: Array<RampBillData>;
  /**
   * A single user from the tenant's user directory, or null when no user with the
   * given id exists in the caller's tenant.
   */
  user?: Maybe<UserDocument>;
  userAppSettings?: Maybe<UserAppSettingsConnection>;
  /**
   * Tenant-scoped pending-invites list for the worksuite app's Administration > Users page.
   * Unlike the SuperAdmin-only cross-tenant adminUserInvites console surface, the
   * tenant comes from the caller's JWT and there is no cross-tenant escape hatch, so a tenant can
   * only ever see its OWN invites. Callable by a platform superadmin JWT OR any tenant user whose
   * WorkSuiteUser directory entry is Active and holds the Admin role (the same in-code gate as
   * createUserInvite); the outer RestockWriter policy only excludes portal principals.
   * A superadmin gets the tenant's real pending list even with no directory entry, so it can
   * bootstrap an empty tenant; every other non-Admin caller still gets an empty list. By default
   * ("Pending" — includeExpired false) this means Unused and not yet past
   * ExpiresAt — accepted, used, failed, AND expired invites are excluded, exactly as
   * before this field was added. Passing includeExpired true additionally
   * surfaces the tenant's Unused invites now past ExpiresAt — still never accepted, used,
   * or failed invites — so a tenant admin can find one and re-invite it via
   * resendUserInvite (which resets ExpiresAt in place; see
   * TenantInviteAccess.EnsureNoExpiredInviteAwaitingResend for why
   * createUserInvite is not the path for this case). Returns the same
   * UserInviteDocument fields the admin grid renders, including status and
   * expiresAt so the caller can derive an "Expired" display state
   * (status == Unused && expiresAt < now).
   */
  userInvites: Array<UserInviteDocument>;
  /** Get current user's time entries with filtering support */
  userTimeEntries?: Maybe<UserTimeEntriesConnection>;
  /**
   * The tenant's user directory: internal staff with their business roles
   * (such as Sales, Sales Manager and Admin) and optional FusionAuth login link.
   */
  users?: Maybe<UsersConnection>;
  /**
   * How many eaches this item usually sells in on one order line, so a quantity far above it can be pointed out
   * while the line is entered. Counts this business's order lines for the item added in the last 180 days with a
   * positive quantity, on orders that are not cancelled, deleted, credit or master orders, newest first and at
   * most 50 of them. usualQuantity is their median in eaches, rounded to a whole number, and is null when fewer
   * than 8 lines count.
   */
  usualLineQuantity?: Maybe<UsualLineQuantity>;
  vendor?: Maybe<VendorStateData>;
  /**
   * The tenant's vendor item aliases, active ones only unless includeRetired is true, optionally for one
   * vendor or one material. A retired alias keeps its row, with retiredAt and effectiveUntil set.
   */
  vendorItemAliases?: Maybe<VendorItemAliasesConnection>;
  /**
   * The caller's tenant's vendor material costs, live ones only: a price whose vendor has been
   * unassigned, or which has been voided, is never returned, whichever fields the caller selects. Past
   * and future dated prices are returned as they always have been; the price history endpoint is where
   * voided and detached prices stay inspectable.
   */
  vendorMaterialCosts?: Maybe<VendorMaterialCostsConnection>;
  vendorPurchaseOrderById?: Maybe<VendorPurchaseOrderDocument>;
  /**
   * Returns, for each distinct material id in input order, the per-each catalog price this vendor has in force on
   * the given day (today when omitted), or null when there is none. It is the same price a new purchase-order line
   * is given when it carries no cost, so it never disagrees with create. It writes nothing. More than 500 ids is
   * refused.
   */
  vendorPurchaseOrderLineCostPreview: Array<VendorPurchaseOrderLineCostPreview>;
  vendorPurchaseOrders?: Maybe<VendorPurchaseOrdersConnection>;
  vendors?: Maybe<VendorsConnection>;
  verifyContainers?: Maybe<VerifyContainersConnection>;
  version: Scalars['String']['output'];
  /** One volume pool by id, regardless of status, or null when the tenant has no pool with that id. */
  volumePool?: Maybe<VolumePool>;
  /**
   * The tenant's volume pools, sorted by code. Retired pools are excluded unless
   * includeRetired is true. Unpaged by design: a tenant holds a handful of pools.
   */
  volumePools: Array<VolumePool>;
  /** Portal policy; empty for portal users. */
  whatsNew: WhatsNew;
  workOrder: WorkOrderDocument;
  workOrders?: Maybe<WorkOrdersConnection>;
  /**
   * Returns the resolved worker config values for a given service and tenant.
   * This is what wsapi-services calls at runtime to get tenant-specific config values.
   */
  workerConfigs: Array<WorkerConfigResult>;
  /**
   * The workers of the caller's tenant: each distinct email address that holds at least one saved app setting
   * there, once, in ascending ordinal order, with nothing else about them. The tenant always comes from the
   * sign-in, never from the request. Unpaged by design: a tenant has a handful of workers.
   */
  workerDirectory: Array<WorkerDirectoryEntry>;
  wsapiImport?: Maybe<WsapiImportStateData>;
  /**
   * Returns the distinct tenant IDs that have at least one enabled WsapiImport.
   * Cross-tenant query used by the Synchronization service to discover which tenants
   * to fan out import iterations across — replaces a direct Mongo distinct lookup.
   */
  wsapiImportTenants: Array<Scalars['String']['output']>;
  wsapiImports?: Maybe<WsapiImportsConnection>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryActiveImportJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AsyncImportJobDocumentSortInput>>;
  where?: InputMaybe<AsyncImportJobDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryActivePortalUsersByEmailArgs = {
  email: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminBackgroundServiceConfigArgs = {
  serviceName: BackgroundServiceName;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminBackgroundServiceConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminBackgroundServiceConfigResultSortInput>>;
  where?: InputMaybe<AdminBackgroundServiceConfigResultFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminBackgroundServicePodsArgs = {
  order?: InputMaybe<Array<AdminBackgroundServicePodResultSortInput>>;
  where?: InputMaybe<AdminBackgroundServicePodResultFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminDbrCalcLatestResultDateArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminDbrCalcResultArgs = {
  customerCode: Scalars['String']['input'];
  itemCode: Scalars['String']['input'];
  locationCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  weeksOfSupply: Scalars['Decimal']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminDbrCalcResultsByCustomerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerCode: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbrCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<DbrCalcResultDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminDbrCalcResultsByItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCode: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbrCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<DbrCalcResultDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminDbrCalcResultsByLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationCode: Scalars['String']['input'];
  order?: InputMaybe<Array<DbrCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<DbrCalcResultDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminDbrCalcResultsByTenantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbrCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<DbrCalcResultDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminDbrCalcTenantQueueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbrCalcTenantQueueDocumentSortInput>>;
  where?: InputMaybe<DbrCalcTenantQueueDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminDbrCalcWorkSummaryArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminDbrCalcWorkerFleetStatusArgs = {
  recentMinutes?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeRemoved?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceDocumentSortInput>>;
  where?: InputMaybe<DeviceDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminEarlyAccessRequestsArgs = {
  flag?: InputMaybe<FeatureFlagName>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminFeatureFlagArgs = {
  name: FeatureFlagName;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminFeatureFlagHoldersArgs = {
  name: FeatureFlagName;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminFeatureFlagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminFeatureFlagResultSortInput>>;
  where?: InputMaybe<AdminFeatureFlagResultFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminIntegrationsArgs = {
  order?: InputMaybe<Array<TenantIntegrationDocumentSortInput>>;
  where?: InputMaybe<TenantIntegrationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminMigrationHealthFactsArgs = {
  journeyId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminMigrationImportRunFailuresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  runId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminOnboardingHelpRequestsArgs = {
  handling?: InputMaybe<OnboardingHelpHandling>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminOnboardingJourneyProgressArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminOnboardingJourneySessionTouchesArgs = {
  journeyId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId: Scalars['String']['input'];
  until?: InputMaybe<Scalars['DateTime']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminOnboardingParsingSuggestionsArgs = {
  family?: InputMaybe<OnboardingParsingSuggestionFamily>;
  journeyId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  reviewState?: InputMaybe<OnboardingParsingSuggestionReviewState>;
  stage?: InputMaybe<OnboardingParsingSuggestionStage>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminOrphanedUsersArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminParentCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ParentCompanyDocumentSortInput>>;
  where?: InputMaybe<ParentCompanyDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminParentCompanyArgs = {
  parentCompanyId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockCalcLatestResultDateArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockCalcResultArgs = {
  customerCode: Scalars['String']['input'];
  itemCode: Scalars['String']['input'];
  locationCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  weeksOfSupply: Scalars['Decimal']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockCalcResultsByCustomerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerCode: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminRestockCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<AdminRestockCalcResultDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockCalcResultsByItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCode: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminRestockCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<AdminRestockCalcResultDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockCalcResultsByLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationCode: Scalars['String']['input'];
  order?: InputMaybe<Array<AdminRestockCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<AdminRestockCalcResultDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockCalcResultsByTenantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminRestockCalcResultDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<AdminRestockCalcResultDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockCalcTenantQueueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminRestockCalcTenantQueueDocumentSortInput>>;
  where?: InputMaybe<AdminRestockCalcTenantQueueDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockCalcWorkSummaryArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockCalcWorkerFleetStatusArgs = {
  recentMinutes?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockDataValidityArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockSeedingCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockSeedingItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminRestockSeedingPipelineStatusArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminTenantArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminTenantFeaturesArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminTenantLearningProgressArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminTenantPricingPageArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminTenantDocumentSortInput>>;
  where?: InputMaybe<AdminTenantDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminUserInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserInviteDocumentSortInput>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserInviteDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fusionAuthUserId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserDocumentSortInput>>;
  where?: InputMaybe<UserDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminWhatsNewEmailDeliveriesArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  releaseLabel?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminWhatsNewEmailRecipientsArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminWhatsNewFeaturesArgs = {
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  releaseLabel?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminWhatsNewPreviewArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminWorkSuiteProductChangeImpactArgs = {
  input: WorkSuiteProductChangeImpactInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminWorkSuiteProductCreateImpactArgs = {
  input: WorkSuiteProductCreateImpactInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminWorkerConfigArgs = {
  configName: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAdminWorkerConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AdminWorkerConfigResultSortInput>>;
  where?: InputMaybe<AdminWorkerConfigResultFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAgGridColumnCapabilitiesArgs = {
  gridId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAgGridRowsArgs = {
  backgroundJobId?: InputMaybe<Scalars['String']['input']>;
  gridId: Scalars['String']['input'];
  request: GridRequestInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAgGridSetValuesArgs = {
  colId: Scalars['String']['input'];
  gridId: Scalars['String']['input'];
  request: GridRequestInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllBaseRatesOfSaleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BaseRateOfSaleDocumentSortInput>>;
  where?: InputMaybe<BaseRateOfSaleDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllContainerConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContainerConfigDocumentSortInput>>;
  where?: InputMaybe<ContainerConfigDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllDailySalesProportionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DailySalesProportionDocumentSortInput>>;
  where?: InputMaybe<DailySalesProportionDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllDeliverySchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeliveryScheduleDocumentSortInput>>;
  where?: InputMaybe<DeliveryScheduleDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllForecastSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ForecastSettingsDocumentSortInput>>;
  where?: InputMaybe<ForecastSettingsDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllProgramReplenishmentSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProgramReplenishmentSettingsDocumentSortInput>>;
  where?: InputMaybe<ProgramReplenishmentSettingsDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllReplenishmentSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReplenishmentSettingsDocumentSortInput>>;
  where?: InputMaybe<ReplenishmentSettingsDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllWeeklySlopeFactorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WeeklySlopeFactorDocumentSortInput>>;
  where?: InputMaybe<WeeklySlopeFactorDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllocationTemplateArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllocationTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AllocationTemplateDocumentSortInput>>;
  where?: InputMaybe<AllocationTemplateDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAllottedTimeBaselineArgs = {
  productionCategoryId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAssignmentHistoryByItemArgs = {
  limit?: Scalars['Int']['input'];
  materialItemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAssignmentsByLocationArgs = {
  siteLocationId: Scalars['String']['input'];
  status?: InputMaybe<CycleCountAssignmentStatus>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAsyncImportJobArgs = {
  asyncImportJobId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAsyncImportJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AsyncImportJobDocumentSortInput>>;
  where?: InputMaybe<AsyncImportJobDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAvailabilityPhotoGradeSuggestionArgs = {
  photoId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAvailableInventoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InventoryItemDocumentSortInput>>;
  where?: InputMaybe<InventoryItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryAvailableTargetsArgs = {
  documentId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBackgroundJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBackgroundJobItemsArgs = {
  jobId: Scalars['String']['input'];
  skip?: Scalars['Int']['input'];
  state?: InputMaybe<BackgroundJobItemState>;
  take?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBackgroundServiceManifestArgs = {
  runsOn: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBlockingRuleArgs = {
  blockingRuleId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBlockingRuleItemLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BlockingRuleItemLocationDocumentSortInput>>;
  where?: InputMaybe<BlockingRuleItemLocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBpfCycleCountMissionTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  missionKey: Scalars['String']['input'];
  order?: InputMaybe<Array<BpfMissionTaskDocumentSortInput>>;
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BpfMissionTaskDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBpfCycleCountMissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfMissionDocumentSortInput>>;
  where?: InputMaybe<BpfMissionDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBpfLotChangeReasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfLotChangeReasonDocumentSortInput>>;
  where?: InputMaybe<BpfLotChangeReasonDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBpfLotChangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfLotChangeDocumentSortInput>>;
  where?: InputMaybe<BpfLotChangeDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBpfLotCountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfLotCountDocumentSortInput>>;
  where?: InputMaybe<BpfLotCountDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBpfLotCountsByStageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfLotCountDocumentSortInput>>;
  stage: BpfLotStage;
  where?: InputMaybe<BpfLotCountDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBpfPositionsArgs = {
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBpfUserStartingNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BpfUserStartingNodeDocumentSortInput>>;
  where?: InputMaybe<BpfUserStartingNodeDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBulkOrderDeleteJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryBulkOrderDeleteJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BulkOrderDeleteJobDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCalculateProductionJobCostsArgs = {
  productionJobIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCalculateRecipeCostArgs = {
  productionRecipeId: Scalars['String']['input'];
  productionRecipeVariationId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCarriersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CarrierDocumentSortInput>>;
  where?: InputMaybe<CarrierDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CategoryDocumentSortInput>>;
  where?: InputMaybe<CategoryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCategoryVolumeCoverageArgs = {
  categoryCode: Scalars['String']['input'];
  priceGroupId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCheckpointArgs = {
  checkpointType: CheckpointType;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCombinedOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  backgroundJobId?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CombinedOrderDocumentSortInput>>;
  where?: InputMaybe<CombinedOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCommandBarOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CommandBarDocumentSortInput>>;
  where?: InputMaybe<CommandBarDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCommissionConfigArgs = {
  userId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCommissionConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CommissionConfigDocumentSortInput>>;
  where?: InputMaybe<CommissionConfigDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryConfigCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ConfigCategoryDocumentSortInput>>;
  where?: InputMaybe<ConfigCategoryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryConfigCategoryArgs = {
  configCategoryId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryConsolidationApplicationArgs = {
  applicationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryConsolidationApplicationLotsArgs = {
  applicationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryConsolidationApplicationsArgs = {
  productionPlanIds?: InputMaybe<Array<Scalars['String']['input']>>;
  take?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryConsolidationPreviewArgs = {
  input: ConsolidationPreviewInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryConsolidationPreviewLotsArgs = {
  previewId: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryContainerConfigArgs = {
  containerConfigId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryContainerConfigByCategoryContainerSiteArgs = {
  categoryCode: Scalars['String']['input'];
  containerCode: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryContractRecordArgs = {
  requestId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryContractRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContractRecordDocumentSortInput>>;
  where?: InputMaybe<ContractRecordDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCorrectionRunArgs = {
  runId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCorrectionRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CorrectionRunStatus>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCountCorrectionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countSessionId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CountCorrectionHistoryDocumentSortInput>>;
  where?: InputMaybe<CountCorrectionHistoryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCountProductionLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionLineDocumentSortInput>>;
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductionLineDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCountRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CountRegistrationDocumentSortInput>>;
  where?: InputMaybe<CountRegistrationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCountSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CountSessionDocumentSortInput>>;
  where?: InputMaybe<CountSessionDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCreditMemoArgs = {
  creditOrderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCreditsPricedUnlikeTheirSaleArgs = {
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCrmExportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CrmExportDocumentSortInput>>;
  where?: InputMaybe<CrmExportDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerActivityFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  shipToLocationId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerCombinePreviewArgs = {
  loserId: Scalars['String']['input'];
  survivorId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerCombineRevertPreviewArgs = {
  loserId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerCreditArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerGroupDocumentSortInput>>;
  where?: InputMaybe<CustomerGroupDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerInvoicePaymentGroupsArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerInvoiceRecipientsArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerItemArgs = {
  customerItemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SkuUpcMappingSortInput>>;
  where?: InputMaybe<SkuUpcMappingFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerLocationGroupsArgs = {
  groupBy: CustomerLocationGroupField;
  includeCombined?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerLocationPoRequiredInheritedArgs = {
  locationId: Scalars['UUID']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerLocationTermsIdInheritedArgs = {
  locationId: Scalars['UUID']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCombined?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  namesIgnoringCase?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<CustomerLocationDocumentSortInput>>;
  where?: InputMaybe<CustomerLocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerLocationsWithBaseRateOfSaleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerLocationDocumentSortInput>>;
  where?: InputMaybe<CustomerLocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerNotificationSettingsArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerOrderStatsArgs = {
  customerId: Scalars['String']['input'];
  shipToLocationId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalAccountArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalAvailabilityPdfArgs = {
  tenantId: Scalars['String']['input'];
  window: PortalAvailabilityWindow;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalCartFreightArgs = {
  locationId: Scalars['UUID']['input'];
  subtotal: Scalars['Decimal']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalEligibleDeliveryDatesArgs = {
  isPreorder?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalFavoritesListArgs = {
  favoritesListId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalFavoritesListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FavoritesListDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<FavoritesListDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalInventoryAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InventoryItemDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<InventoryItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalInvoicePaymentAttemptArgs = {
  attemptId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalInvoicePaymentQuoteArgs = {
  invoiceIds: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalItemAvailabilityArgs = {
  order?: InputMaybe<Array<ItemAvailabilityDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<ItemAvailabilityDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalItemGradeAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ItemSummaryDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<ItemSummaryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalPortalUserByStreamArgs = {
  portalUserId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalRetailPriceHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalRetailPriceSaveArgs = {
  jobId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalSellableHardgoodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<MaterialItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalSettingsArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalShoppingCartArgs = {
  cartId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalShoppingCartTaxEstimateArgs = {
  cartId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerPortalUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PortalUserDocumentSortInput>>;
  tenantId: Scalars['String']['input'];
  where?: InputMaybe<PortalUserDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerReceivablesArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  customerId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerRetailPricesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SkuUpcMappingSortInput>>;
  where?: InputMaybe<SkuUpcMappingFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerShipToStatsArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerStatementPreviewArgs = {
  customerId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerStatementRunReviewLinesArgs = {
  runId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerStatementRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerStatementRunDocumentSortInput>>;
  where?: InputMaybe<CustomerStatementRunDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerTextConsentsArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerTimeEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TimeEntryDocumentSortInput>>;
  where?: InputMaybe<TimeEntryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerTopSkusArgs = {
  customerId: Scalars['String']['input'];
  shipToLocationId?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomerTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerTypeDocumentSortInput>>;
  where?: InputMaybe<CustomerTypeDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  backgroundJobId?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCombined?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomersSummaryDocumentSortInput>>;
  where?: InputMaybe<CustomersSummaryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomersByNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCombined?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  names: Array<Scalars['String']['input']>;
  order?: InputMaybe<Array<CustomersSummaryDocumentSortInput>>;
  where?: InputMaybe<CustomersSummaryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCustomersForImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  customerIds: Array<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCycleCountAssignmentArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryCycleCountHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<CycleCountLogDocumentSortInput>>;
  recordedBy?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<CycleCountLogDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDeletedStreamTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeletedStreamTransactionDocumentSortInput>>;
  where?: InputMaybe<DeletedStreamTransactionDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDeletedStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeletedStreamDocumentSortInput>>;
  where?: InputMaybe<DeletedStreamDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDeliveryScheduleArgs = {
  deliveryScheduleId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDeviceArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDeviceLobbyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceDocumentSortInput>>;
  where?: InputMaybe<DeviceDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDeviceOtaStateArgs = {
  deviceId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDeviceOtaTargetArgs = {
  deviceId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDeviceProfileConfigKeysArgs = {
  profile: DeviceProfile;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDeviceTelemetryHistoryArgs = {
  deviceId: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  maxPoints?: Scalars['Int']['input'];
  metric: Scalars['String']['input'];
  to: Scalars['DateTime']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDeviceTelemetryLatestArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceDocumentSortInput>>;
  where?: InputMaybe<DeviceDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDueScheduledInventoryTransfersArgs = {
  after?: InputMaybe<DueScheduledInventoryTransferCursorInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDuplicateCandidatePairKeysArgs = {
  entityType: DuplicateEntityType;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryDuplicateCandidatesArgs = {
  input: DuplicateCandidatesInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryEffectiveDeliveryScheduleArgs = {
  customerId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['UUID']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryEffectiveIncomeGlAccountArgs = {
  itemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryEmailSendsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EmailSendDocumentSortInput>>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  sentAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  sentAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<EmailSendDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryEntityCheckpointsArgs = {
  order?: InputMaybe<Array<EntityCheckpointDocumentSortInput>>;
  where?: InputMaybe<EntityCheckpointDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryEntityEventsArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpAccessDarkRunDiffArgs = {
  asOfDate: Scalars['LocalDate']['input'];
  changedOnly?: Scalars['Boolean']['input'];
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpAvailabilityDocumentSortInput>>;
  where?: InputMaybe<ErpAvailabilityDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpFinishAvailabilityArgs = {
  stationCode: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpItemPricesArgs = {
  order?: InputMaybe<Array<ErpItemPricingDocumentSortInput>>;
  where?: InputMaybe<ErpItemPricingDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpItemPricingArgs = {
  erpPriceGroupId: Scalars['String']['input'];
  startYear: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpLoadListAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpLoadListAvailabilityDocumentSortInput>>;
  where?: InputMaybe<ErpLoadListAvailabilityDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpLoadListQuantitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpLoadListQuantitiesDocumentSortInput>>;
  where?: InputMaybe<ErpLoadListQuantitiesDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpLoadListRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpLoadListRouteDocumentSortInput>>;
  where?: InputMaybe<ErpLoadListRouteDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpLoadListSessionArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpLoadListSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpLoadListSessionDocumentSortInput>>;
  where?: InputMaybe<ErpLoadListSessionDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpLoadListUserArgs = {
  erpLoadListUserId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpLoadListUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpLoadListUserDocumentSortInput>>;
  where?: InputMaybe<ErpLoadListUserDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpStationRoutesArgs = {
  station: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryErpWriteBackQueueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpWriteBackDocumentSortInput>>;
  where?: InputMaybe<ErpWriteBackDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryEventCountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EventCountDocumentSortInput>>;
  where?: InputMaybe<EventCountDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryEventStreamAggregatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EventStreamAggregateDocumentSortInput>>;
  where?: InputMaybe<EventStreamAggregateDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFeatureFlagArgs = {
  name: FeatureFlagName;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFeatureFlagProductConversionJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFernieFindCandidatesArgs = {
  input: FernieFindCandidatesInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFernieGapCandidatesArgs = {
  input: FernieGapCandidatesInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFernieGapJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFernieQuickBooksLinksArgs = {
  input: FernieQuickBooksLinksInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFernieStripeTaxCodeCandidatesArgs = {
  input: FernieStripeTaxCodeCandidatesInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFernieValuesInUseArgs = {
  input: FernieValuesInUseInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFirmwareDownloadArgs = {
  deviceModel: Scalars['String']['input'];
  firmwareName: Scalars['String']['input'];
  sha: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFirmwareReleasesArgs = {
  deviceModel?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFlatChargeTypesArgs = {
  activeOnly?: Scalars['Boolean']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FlatChargeTypeDocumentSortInput>>;
  where?: InputMaybe<FlatChargeTypeDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFloatingTimeEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDiscarded?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FloatingTimeEntryDocumentSortInput>>;
  where?: InputMaybe<FloatingTimeEntryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFloatingTimeEntryArgs = {
  floatingTimeEntryId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryForecastArgs = {
  forecastId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryForecastHolidayArgs = {
  holidayId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryForecastSummaryArgs = {
  forecastId: Scalars['String']['input'];
  scope?: InputMaybe<ForecastSummaryScopeInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryForecastWeeklyDeltaInputsArgs = {
  forecastId: Scalars['String']['input'];
  scope?: InputMaybe<ForecastWeeklyDeltaScopeInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryForecastsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ForecastDocumentSortInput>>;
  where?: InputMaybe<ForecastDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryFreightQuoteSendStatusArgs = {
  loadId: Scalars['ID']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGenerateReportCsvArgs = {
  parameters?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGenerateReportExcelArgs = {
  parameters?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGenerateReportPdfArgs = {
  footerHtml?: InputMaybe<Scalars['String']['input']>;
  headerHtml?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowPointCommitArgs = {
  commitId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowPointPendingCommitArgs = {
  entity: GrowPointStagedEntity;
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowPointStagedRowVersionsArgs = {
  entity: GrowPointStagedEntity;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkAccessLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkAccessLogExportArgs = {
  communityId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkActivityArgs = {
  communityId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkBillingSummaryArgs = {
  communityId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkCohortArgs = {
  selection: GrowerBenchmarkCohortSelectionInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkCohortFacetsArgs = {
  communityId: Scalars['String']['input'];
  periodId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkCohortPassRunsArgs = {
  communityId: Scalars['String']['input'];
  periodId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkCohortStatisticsArgs = {
  cohortKey?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['String']['input'];
  metricKey?: InputMaybe<Scalars['String']['input']>;
  periodId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkCommunityArgs = {
  communityId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkCompareArgs = {
  metricKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  selection: GrowerBenchmarkCohortSelectionInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkCompareViewsArgs = {
  communityId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkCycleArgs = {
  cycleId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkFactsArgs = {
  communityId: Scalars['String']['input'];
  firmId?: InputMaybe<Scalars['String']['input']>;
  periodId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkFirmCodesMatchingArgs = {
  predicate: GrowerBenchmarkFirmAttributePredicateInput;
  selection: GrowerBenchmarkCohortSelectionInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkFirmHomeArgs = {
  communityId: Scalars['String']['input'];
  periodId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkFirmMetricsArgs = {
  communityId: Scalars['String']['input'];
  firmId?: InputMaybe<Scalars['String']['input']>;
  metricKey?: InputMaybe<Scalars['String']['input']>;
  periodId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkFirmProfileArgs = {
  communityId: Scalars['String']['input'];
  firmId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkImportedLinesArgs = {
  communityId: Scalars['String']['input'];
  periodId?: InputMaybe<Scalars['String']['input']>;
  reportingUnitId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkInstructionSetsArgs = {
  communityId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkMemberDirectoryArgs = {
  communityId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkMetricCatalogArgs = {
  communityId: Scalars['String']['input'];
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkMetricDefinitionsArgs = {
  communityId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkMyPeriodArgs = {
  communityId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkMyReviewArgs = {
  reviewId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkMyReviewPdfArgs = {
  reviewId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkOpenCycleArgs = {
  communityId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkPeriodsArgs = {
  communityId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkPurgeRunArgs = {
  purgeRunId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkReclassifyFirmsPreviewArgs = {
  input: GrowerBenchmarkReclassifyFirmsInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkReportQueueArgs = {
  communityId: Scalars['String']['input'];
  periodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GrowerBenchmarkReviewStatus>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkRetailMonthValuesArgs = {
  submissionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkRetailMonthsArgs = {
  fromPeriodId: Scalars['String']['input'];
  reportingUnitId: Scalars['String']['input'];
  toPeriodId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkReviewArgs = {
  reviewId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkReviewMeteringArgs = {
  communityId: Scalars['String']['input'];
  periodId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarkSubmissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  periodId?: InputMaybe<Scalars['String']['input']>;
  reportingUnitId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryGrowerBenchmarksDecisionContextArgs = {
  idea: Scalars['Int']['input'];
  subjects: Array<Scalars['ID']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryHardgoodsInventoryGridArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HardgoodsInventoryGridDocumentSortInput>>;
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<HardgoodsInventoryGridDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryHardgoodsRequiredByNeededWeekRangeArgs = {
  includeWeeklyBreakdown?: Scalars['Boolean']['input'];
  neededWeekFromIsoWeek: Scalars['Int']['input'];
  neededWeekFromIsoYear: Scalars['Int']['input'];
  neededWeekToIsoWeek: Scalars['Int']['input'];
  neededWeekToIsoYear: Scalars['Int']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryHardgoodsRequiredByReadyWeekArgs = {
  readyWeek?: InputMaybe<Scalars['DateTime']['input']>;
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryHardgoodsRequiredByStartWeekRangeArgs = {
  includeWeeklyBreakdown?: Scalars['Boolean']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  startWeekFromIsoWeek: Scalars['Int']['input'];
  startWeekFromIsoYear: Scalars['Int']['input'];
  startWeekToIsoWeek: Scalars['Int']['input'];
  startWeekToIsoYear: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryImportSessionArgs = {
  importSessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryImportSessionRowsArgs = {
  importSessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryImportSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImportSessionFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInboundDocumentArgs = {
  documentId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInboundDocumentsArgs = {
  status?: InputMaybe<InboundDocumentStatus>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryIntegrationHealthArgs = {
  integrationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryIntegrationsArgs = {
  order?: InputMaybe<Array<TenantIntegrationDocumentSortInput>>;
  where?: InputMaybe<TenantIntegrationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInventoryAdjustmentAttemptArgs = {
  grade: Scalars['Int']['input'];
  idempotencyKey: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInventoryAllocationImpactPreviewArgs = {
  input: InventoryAllocationImpactPreviewInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInventoryItemStockSummaryArgs = {
  itemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInventoryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InventoryItemDocumentSortInput>>;
  where?: InputMaybe<InventoryItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInventoryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InventoryTransactionDocumentSortInput>>;
  where?: InputMaybe<InventoryTransactionDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInvoiceEmailTokensArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInvoicePaymentGroupArgs = {
  transactionRef: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInvoicePaymentPreviewArgs = {
  amount: Scalars['Decimal']['input'];
  invoiceId: Scalars['String']['input'];
  receivedDate: Scalars['DateTime']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInvoicedOrderIdsArgs = {
  orderIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InvoiceDocumentSortInput>>;
  where?: InputMaybe<InvoiceDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryIotDeadLettersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IotDeadLetterDocumentSortInput>>;
  where?: InputMaybe<IotDeadLetterDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryIotIngestionMetricsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemArgs = {
  itemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemAvailabilityArgs = {
  order?: InputMaybe<Array<ItemAvailabilityDocumentSortInput>>;
  where?: InputMaybe<ItemAvailabilityDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemAvailabilityByDateArgs = {
  input: ItemAvailabilityByDateInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemCharacteristicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ItemCharacteristicDocumentSortInput>>;
  where?: InputMaybe<ItemCharacteristicDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemCombinePreviewArgs = {
  loserId: Scalars['String']['input'];
  survivorId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemIdsByErpIdArgs = {
  erpIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemIdsBySkuArgs = {
  skus: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemListGroupsArgs = {
  groupBy: ItemGroupField;
  includeCombined?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemLocationPhotosArgs = {
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemPhotosArgs = {
  itemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemPriceArgs = {
  itemId: Scalars['String']['input'];
  locationId: Scalars['UUID']['input'];
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemPriceExplanationArgs = {
  eachesQuantity?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  lineItemId?: InputMaybe<Scalars['UUID']['input']>;
  locationId: Scalars['UUID']['input'];
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderPlacedDate?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemPriceLevelsArgs = {
  itemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemPricesArgs = {
  itemIds: Array<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemProductionMappingsArgs = {
  salesItemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ItemProgramDocumentSortInput>>;
  where?: InputMaybe<ItemProgramDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemRestockMetricsArgs = {
  itemId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemSearchSuggestionArgs = {
  search: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  backgroundJobId?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCombined?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  namesIgnoringCase?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ItemSummaryDocumentSortInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ItemSummaryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemsWithBaseRateOfSaleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ItemSummaryDocumentSortInput>>;
  where?: InputMaybe<ItemSummaryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryItemsWithRestockAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ItemWithRestockAvailabilityDocumentSortInput>>;
  source?: InputMaybe<RestockAvailabilitySource>;
  where?: InputMaybe<ItemWithRestockAvailabilityDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryJobCostBreakdownArgs = {
  costCategory: CostCategory;
  jobId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryJobCostRecordsArgs = {
  costCategory?: InputMaybe<CostCategory>;
  jobId: Scalars['String']['input'];
  sourceType?: InputMaybe<CostSourceType>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryJobCostSubcategoriesArgs = {
  costCategory?: InputMaybe<CostCategory>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryJobCostSummaryArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryJobCostTimelineArgs = {
  jobId: Scalars['String']['input'];
  productionWindow?: Scalars['Boolean']['input'];
  weeks?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryJobEventsInSelectionArgs = {
  selection: JobEventsSelectionInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<JobDocumentSortInput>>;
  where?: InputMaybe<JobDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryKitArgs = {
  kitId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryKitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<KitDocumentSortInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<KitDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLaborActiveRatesArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLaborDemandArgs = {
  endDate: Scalars['DateTime']['input'];
  siteLocationId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLaborRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeactivated?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LaborRateDocumentSortInput>>;
  where?: InputMaybe<LaborRateDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLatestQaTestRunArgs = {
  environment?: InputMaybe<Scalars['String']['input']>;
  suite: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLatestQaWatcherHeartbeatArgs = {
  watcher: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLineItemActualQuantitiesArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLineItemActualQuantitiesByLocationGradeArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLoadStopNoticeStatusArgs = {
  loadId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLoadWeightsArgs = {
  loadIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLocationArgs = {
  locationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLocationActiveOverheadRateArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  siteLocationId: Scalars['String']['input'];
  subLocationId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLocationInUseArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLocationOverheadRateArgs = {
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLocationOverheadRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeactivated?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationOverheadRateDocumentSortInput>>;
  where?: InputMaybe<LocationOverheadRateDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationDocumentSortInput>>;
  where?: InputMaybe<LocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLocationsSalesPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LocationsSalesPersonDocumentSortInput>>;
  where?: InputMaybe<LocationsSalesPersonDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsCarriersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LogisticsCarrierDocumentSortInput>>;
  where?: InputMaybe<LogisticsCarrierDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsDeliveryOrderPortionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeliveryOrderPortionDocumentSortInput>>;
  where?: InputMaybe<DeliveryOrderPortionDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsDeliveryStopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeliveryStopDocumentSortInput>>;
  where?: InputMaybe<DeliveryStopDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsDeliverySummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeliverySummaryDocumentSortInput>>;
  where?: InputMaybe<DeliverySummaryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsDocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LogisticsDockDocumentSortInput>>;
  where?: InputMaybe<LogisticsDockDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsDriversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DriverDocumentSortInput>>;
  where?: InputMaybe<DriverDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsLoadLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LoadLineDocumentSortInput>>;
  where?: InputMaybe<LoadLineDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsLoadLinesByOrderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LoadLineDocumentSortInput>>;
  orderId: Scalars['String']['input'];
  where?: InputMaybe<LoadLineDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsLoadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LoadDocumentSortInput>>;
  where?: InputMaybe<LoadDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsLoadsByShipDateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LoadDocumentSortInput>>;
  shipDate: Scalars['LocalDate']['input'];
  where?: InputMaybe<LoadDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LogisticsRouteDocumentSortInput>>;
  where?: InputMaybe<LogisticsRouteDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsVehicleTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VehicleTypeDocumentSortInput>>;
  where?: InputMaybe<VehicleTypeDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLogisticsVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VehicleDocumentSortInput>>;
  where?: InputMaybe<VehicleDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLotCostBreakdownArgs = {
  costCategory: CostCategory;
  lotId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLotCostRecordsArgs = {
  costCategory?: InputMaybe<CostCategory>;
  lotId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLotCostSummaryArgs = {
  lotId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryLotCostTimelineArgs = {
  lotId: Scalars['String']['input'];
  productionWindow?: Scalars['Boolean']['input'];
  weeks?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryM365MailboxAdminConsentUrlArgs = {
  redirectUri: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryM365MailboxAuthorizeUrlArgs = {
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMakeToOrderPlanPreviewArgs = {
  input: MakeToOrderPlanPreviewInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMakeToOrderPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MakeToOrderPlanDocumentSortInput>>;
  where?: InputMaybe<MakeToOrderPlanDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMasterOrderArgs = {
  masterOrderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMasterOrderEmailDraftArgs = {
  masterOrderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMasterOrderEmailSendReadinessArgs = {
  masterOrderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMasterOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MasterOrdersDocumentSortInput>>;
  where?: InputMaybe<MasterOrdersDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialAllocationByIdArgs = {
  materialAllocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialAllocationDocumentSortInput>>;
  where?: InputMaybe<MaterialAllocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialDemandArgs = {
  endDate: Scalars['DateTime']['input'];
  siteLocationId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialEventGroupsArgs = {
  groupBy: MaterialEventGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialItemArgs = {
  materialItemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialItemLocationQuantitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemLocationQuantityDocumentSortInput>>;
  where?: InputMaybe<MaterialItemLocationQuantityDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialItemLocationQuantityArgs = {
  locationId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialItemSearchSuggestionArgs = {
  search: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialItemSiteLocationQuantitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemSiteLocationQuantityDocumentSortInput>>;
  where?: InputMaybe<MaterialItemSiteLocationQuantityDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialItemSiteLocationQuantityArgs = {
  materialItemId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialItemTotalQuantityArgs = {
  materialItemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemDocumentSortInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MaterialItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpOrderDocumentSortInput>>;
  where?: InputMaybe<ErpOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialOrdersForLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['String']['input'];
  order?: InputMaybe<Array<ErpOrderDocumentSortInput>>;
  where?: InputMaybe<ErpOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialPriceActionPreviewArgs = {
  input: MaterialPriceActionPreviewInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialPriceHistoryArgs = {
  materialItemId: Scalars['String']['input'];
  priceId?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialReceiptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialReceiptDocumentSortInput>>;
  where?: InputMaybe<MaterialReceiptDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMaterialTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialTransactionDocumentSortInput>>;
  where?: InputMaybe<MaterialTransactionDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMergeDevAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MergeDevAccountDocumentSortInput>>;
  where?: InputMaybe<MergeDevAccountDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMergeDevConnectionArgs = {
  integrationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMergeDevExportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MergeDevExportDocumentSortInput>>;
  where?: InputMaybe<MergeDevExportDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMergeDevImportFailuresArgs = {
  integrationId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMergeDevPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MergeDevPaymentDocumentSortInput>>;
  where?: InputMaybe<MergeDevPaymentDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMergeDevSchemaArgs = {
  integrationId: Scalars['String']['input'];
  model: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMergeDevSyncMetricsArgs = {
  integrationId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMergeDevSyncStateArgs = {
  integrationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationImportAnswersForJobArgs = {
  id: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationImportQuestionsArgs = {
  journeyId: Scalars['String']['input'];
  openOnly?: Scalars['Boolean']['input'];
  skip?: Scalars['Int']['input'];
  sourceId: Scalars['String']['input'];
  take?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationImportRunArgs = {
  runId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationImportRunCompletionFactsArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationImportRunConfidenceArgs = {
  runId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationImportRunRecordsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  operationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  runId: Scalars['String']['input'];
  statuses?: InputMaybe<Array<MigrationRecordConfidenceStatus>>;
  targetEntity?: InputMaybe<Scalars['String']['input']>;
  targetIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationImportRunsArgs = {
  journeyId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationJourneyConfidenceArgs = {
  journeyId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationOperationReceiptsArgs = {
  journeyId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationPendingReviewsArgs = {
  journeyId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationPortionConfidenceArgs = {
  journeyId: Scalars['String']['input'];
  portionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationPreparationJobArgs = {
  jobId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationPreparationJobsArgs = {
  journeyId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationPreparedRowsArgs = {
  file?: InputMaybe<Scalars['String']['input']>;
  journeyId: Scalars['String']['input'];
  revisionId?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  sourceId: Scalars['String']['input'];
  take?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationSettingValuesArgs = {
  settingKeys: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMigrationSettingsRevisionArgs = {
  journeyId: Scalars['String']['input'];
  revisionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMissingDataFindingsArgs = {
  codes?: InputMaybe<Array<MissingDataCode>>;
  entityType: MissingDataEntityType;
  includeIgnored?: InputMaybe<Scalars['Boolean']['input']>;
  subjectIds: Array<Scalars['ID']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMovementOrderArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMovementOrderHistoryArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMovementOrderTransactionsByLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['String']['input'];
  order?: InputMaybe<Array<MovementOrderHistoryDocumentSortInput>>;
  where?: InputMaybe<MovementOrderHistoryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMyAssignedCountTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MyCountTaskDocumentSortInput>>;
  status?: InputMaybe<CycleCountTaskStatus>;
  where?: InputMaybe<MyCountTaskDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMyLearningPathArgs = {
  module?: InputMaybe<LearningModule>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMyNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<NotificationDocumentSortInput>>;
  unreadOnly?: Scalars['Boolean']['input'];
  where?: InputMaybe<NotificationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMyTaskAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaskAssignmentDocumentSortInput>>;
  where?: InputMaybe<TaskAssignmentDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryMyWalkthroughStateArgs = {
  walkthroughIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryNotificationOverridesArgs = {
  scope: NotificationOverrideScope;
  scopeId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOnHandProcessQueueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OnHandAdjustmentDocumentSortInput>>;
  where?: InputMaybe<OnHandAdjustmentDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOnboardingHelpRequestArgs = {
  requestId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOnboardingHelpRequestsArgs = {
  journeyId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOnlinePaymentAttemptArgs = {
  attemptId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOnlinePaymentAttemptsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  startedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<PaymentAttemptStatus>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOnlinePaymentExceptionsArgs = {
  includeResolved: Scalars['Boolean']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOnlinePaymentRefundPreviewArgs = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  attemptId: Scalars['String']['input'];
  target: PaymentAttemptRefundTarget;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOnlinePaymentUnappliedCreditsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  includeUsedUp: Scalars['Boolean']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOpenBackgroundJobsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOpenBulkOrderDeleteJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BulkOrderDeleteJobDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOpenCorrectionRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOpenFeatureFlagProductConversionJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderAddressEditPermissionsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AllocationItemDocumentSortInput>>;
  where?: InputMaybe<AllocationItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderContainerRequirementArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderContainerRequirementsArgs = {
  orderIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderDetailsPdfArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderEmailSendReadinessArgs = {
  docType?: InputMaybe<OrderEmailDocType>;
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderEmailSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrderEmailSettingsDocumentSortInput>>;
  where?: InputMaybe<OrderEmailSettingsDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderHistoryArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderInspectionArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderInvoiceEmailDraftArgs = {
  docType?: InputMaybe<OrderEmailDocType>;
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderKindsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrderKindDocumentSortInput>>;
  where?: InputMaybe<OrderKindDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrderLineItemDocumentSortInput>>;
  where?: InputMaybe<OrderLineItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderLinePricePreviewArgs = {
  input: OrderLinePricePreviewInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderNotificationSettingsArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderProductionLotAllocationByIdArgs = {
  allocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderProductionLotAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrderProductionLotAllocationDocumentSortInput>>;
  where?: InputMaybe<OrderProductionLotAllocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderTextHistoryArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderVerificationComparisonArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrderfulTransactionsArgs = {
  filter?: InputMaybe<OrderfulTransactionsFilterInput>;
  nextCursor?: InputMaybe<Scalars['String']['input']>;
  prevCursor?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  backgroundJobId?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrdersDocumentSortInput>>;
  where?: InputMaybe<OrdersDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrdersStatusesArgs = {
  where?: InputMaybe<CombinedOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOrdersTypesArgs = {
  where?: InputMaybe<CombinedOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOtaReleaseArgs = {
  releaseId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOtaReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OtaReleaseDocumentSortInput>>;
  where?: InputMaybe<OtaReleaseDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOtaRolloutArgs = {
  rolloutId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOtaRolloutDeviceStatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rolloutId: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryOtaRolloutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OtaRolloutDocumentSortInput>>;
  where?: InputMaybe<OtaRolloutDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPaymentProcessorArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPaymentStatusesArgs = {
  where?: InputMaybe<CombinedOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPendingErpWriteBacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ErpWriteBackDocumentSortInput>>;
  where?: InputMaybe<ErpWriteBackDocumentFilterInput>;
  workflow: ErpWriteBackWorkflow;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPendingProductionEntriesArgs = {
  siteId?: InputMaybe<Scalars['String']['input']>;
  weekFrom?: InputMaybe<Scalars['Int']['input']>;
  weekTo?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPendingTransferOrdersByDestinationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  destinationLocationId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PendingTransferOrderDocumentSortInput>>;
  where?: InputMaybe<PendingTransferOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPortalBrandingByHostArgs = {
  host: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPortalBrandingBySlugArgs = {
  slug: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPortalCustomDomainIngressActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PortalCustomDomainIngressActionResultSortInput>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PortalCustomDomainIngressActionResultFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPortalCustomDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PortalCustomDomainAdminDataSortInput>>;
  where?: InputMaybe<PortalCustomDomainAdminDataFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPreviewLoadFreightArgs = {
  loadId: Scalars['ID']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPreviewMakeToOrderPlanTimingArgs = {
  input: MakeToOrderPlanTimingInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPreviewPlannedLotStartsArgs = {
  lots: Array<PlannedLotInput>;
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPreviewProductionItemLinksArgs = {
  pairs: Array<ProductionItemLinkPairInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPriceGroupArgs = {
  groupId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPriceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PriceGroupDocumentSortInput>>;
  where?: InputMaybe<PriceGroupDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPriceLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PriceLevelDocumentSortInput>>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PriceLevelDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPriceLevelsBlockArgs = {
  levelType?: InputMaybe<PriceLevelType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<PriceLevelSortInput>>;
  targetId?: InputMaybe<Scalars['String']['input']>;
  targetNameSearch?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TargetType>;
  types?: InputMaybe<Array<TargetType>>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPricesForNewOrderLinesArgs = {
  orders: Array<NewOrderPricingDataInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProduceTagArgs = {
  materialItemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProduceTagByTagCodeArgs = {
  tagCode: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProduceTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemDocumentSortInput>>;
  where?: InputMaybe<MaterialItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProduceTagsByTagCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagCodes: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionCatalogArgs = {
  productionCatalogId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionCatalogCombinePreviewArgs = {
  loserId: Scalars['String']['input'];
  survivorId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionCatalogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCombined?: Scalars['Boolean']['input'];
  includeDeleted?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionCatalogDocumentSortInput>>;
  where?: InputMaybe<ProductionCatalogDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionCategoryDocumentSortInput>>;
  where?: InputMaybe<ProductionCategoryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionCategoryArgs = {
  productionCategoryId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionDemandSplitArgs = {
  input: ProductionDemandSplitInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionItemCombinePreviewArgs = {
  loserId: Scalars['String']['input'];
  survivorId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionItemOrderLinesByShipWeekArgs = {
  isoWeek: Scalars['Int']['input'];
  isoYear: Scalars['Int']['input'];
  productionItemId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionItemOrdersByShipWeekArgs = {
  isoWeekEnd: Scalars['Int']['input'];
  isoWeekStart: Scalars['Int']['input'];
  isoYear: Scalars['Int']['input'];
  productionItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCombined?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionItemDocumentSortInput>>;
  where?: InputMaybe<ProductionItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionItemsMatchingSalesItemCodeArgs = {
  sku: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionJobConsumptionManifestArgs = {
  jobs: Array<ProductionJobConsumptionRequestInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionJobMovePreviewArgs = {
  input: ProductionJobMovePreviewInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionJobPostingStagesArgs = {
  jobs: Array<ProductionJobPostingStagesJobInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDrafts?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionJobDocumentSortInput>>;
  where?: InputMaybe<ProductionJobDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotArgs = {
  productionLotId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotAllocationRollupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionLotAllocationRollupDocumentSortInput>>;
  where?: InputMaybe<ProductionLotAllocationRollupDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotAsyncImportJobNewPlansArgs = {
  asyncImportJobId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotAsyncImportJobRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asyncImportJobId: Scalars['String']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionLotAsyncImportJobRowSortInput>>;
  where?: InputMaybe<ProductionLotAsyncImportJobRowFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotImportJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionLotImportJobSummarySortInput>>;
  where?: InputMaybe<ProductionLotImportJobSummaryFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotOpenAllocationsArgs = {
  productionLotIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotOverrideHistoryArgs = {
  productionJobId?: InputMaybe<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotSubstitutionPreviewArgs = {
  input: ProductionLotSubstitutionPreviewInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotTimelineArgs = {
  productionLotId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotVariantOptionsArgs = {
  overridePolicy?: InputMaybe<ProductionLotVariantOverridePolicy>;
  productionLotId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionLotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDrafts?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionLotDocumentSortInput>>;
  salesItemId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductionLotDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionMaterialEventArgs = {
  productionMaterialEventId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionMaterialEventDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionMaterialEventDetailDocumentSortInput>>;
  productionMaterialEventId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductionMaterialEventDetailDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionMaterialEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionMaterialEventDocumentSortInput>>;
  where?: InputMaybe<ProductionMaterialEventDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionPlanArgs = {
  productionPlanId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionPlanDocumentSortInput>>;
  where?: InputMaybe<ProductionPlanDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionRecipeArgs = {
  productionRecipeId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionRecipeBomArgs = {
  productionRecipeVariationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionRecipeChainArgs = {
  maxDepth?: Scalars['Int']['input'];
  productionRecipeId: Scalars['String']['input'];
  productionRecipeVariationId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionRecipeEventsArgs = {
  productionRecipeVariationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionRecipeGroupsArgs = {
  groupBy: ProductionRecipeGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionRecipeHistoryArgs = {
  productionRecipeId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionRecipeLinkHealthArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionRecipeLinkHealthRowSortInput>>;
  where?: InputMaybe<ProductionRecipeLinkHealthRowFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionRecipeVariationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionRecipeVariationDocumentSortInput>>;
  where?: InputMaybe<ProductionRecipeVariationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionRecipesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionRecipeDocumentSortInput>>;
  where?: InputMaybe<ProductionRecipeDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionRecipesLinkingPairArgs = {
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionSpaceCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionSpaceCategoryDocumentSortInput>>;
  where?: InputMaybe<ProductionSpaceCategoryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionSpaceCategoryArgs = {
  productionSpaceCategoryId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionSpaceEventArgs = {
  productionSpaceEventId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionSpaceEventDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionSpaceEventDetailDocumentSortInput>>;
  productionSpaceEventId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductionSpaceEventDetailDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionSpaceEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionSpaceEventDocumentSortInput>>;
  where?: InputMaybe<ProductionSpaceEventDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionSpaceTypeArgs = {
  productionSpaceTypeId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionSpaceTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionSpaceTypeDocumentSortInput>>;
  where?: InputMaybe<ProductionSpaceTypeDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionTaskEventArgs = {
  productionTaskEventId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionTaskEventDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionTaskEventDetailDocumentSortInput>>;
  productionTaskEventId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductionTaskEventDetailDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionTaskEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionTaskEventDocumentSortInput>>;
  where?: InputMaybe<ProductionTaskEventDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionTriggerRemindersDueArgs = {
  date: Scalars['LocalDate']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductionTriggerDocumentSortInput>>;
  where?: InputMaybe<ProductionTriggerDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionYearPlanArgs = {
  isoYear: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProductionYearPlanYearsArgs = {
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProgramDocumentSortInput>>;
  where?: InputMaybe<ProgramDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProjectionStatusArgs = {
  projectionName: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProjectionStatusesArgs = {
  order?: InputMaybe<Array<ProjectionStatusDocumentSortInput>>;
  where?: InputMaybe<ProjectionStatusDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPromotionRuleArgs = {
  promotionRuleId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryProrateGridArgs = {
  itemIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPublicInvoicePayLinkArgs = {
  token: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPublicInvoicePaymentAttemptArgs = {
  attemptId: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPublicUserInviteByCodeArgs = {
  code: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPurchaseOrderAllocationByIdArgs = {
  purchaseOrderAllocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryPurchaseOrderAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PurchaseOrderAllocationDocumentSortInput>>;
  where?: InputMaybe<PurchaseOrderAllocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryQaTestRunArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryQaTestRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<QaTestRunSummaryResultSortInput>>;
  where?: InputMaybe<QaTestRunSummaryResultFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryQaTestRunsForRetentionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  olderThanDays?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryQaWatcherHeartbeatsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  watcher: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryQuoteFollowUpsDueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asOf: Scalars['LocalDate']['input'];
  assignee?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRampPurchaseOrderCopyArgs = {
  purchaseOrderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRampPurchaseOrderInvoicesArgs = {
  purchaseOrderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRampVendorsArgs = {
  includeInactive?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReapplyRecipesPreviewArgs = {
  jobIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReapplyRecipesRunArgs = {
  runId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReleaseCandidateArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReplenishmentRuleGroupsArgs = {
  groupBy: ReplenishmentRuleGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReplenishmentRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReplenishmentRuleSummaryDocumentSortInput>>;
  where?: InputMaybe<ReplenishmentRuleSummaryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportAvailabilityDataArgs = {
  characteristicId1?: InputMaybe<Scalars['String']['input']>;
  characteristicId2?: InputMaybe<Scalars['String']['input']>;
  characteristicId3?: InputMaybe<Scalars['String']['input']>;
  characteristicId4?: InputMaybe<Scalars['String']['input']>;
  characteristicId5?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportAvailabilityOutlookDataArgs = {
  characteristicId1?: InputMaybe<Scalars['String']['input']>;
  characteristicId2?: InputMaybe<Scalars['String']['input']>;
  characteristicId3?: InputMaybe<Scalars['String']['input']>;
  characteristicId4?: InputMaybe<Scalars['String']['input']>;
  characteristicId5?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  windowAFrom: Scalars['DateTime']['input'];
  windowALabel?: InputMaybe<Scalars['String']['input']>;
  windowATo: Scalars['DateTime']['input'];
  windowBFrom: Scalars['DateTime']['input'];
  windowBLabel?: InputMaybe<Scalars['String']['input']>;
  windowBTo: Scalars['DateTime']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportBillToAddressesDataArgs = {
  customerName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportCashReceiptsDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  includeOrdersWithoutCardInfo?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentNumber?: InputMaybe<Scalars['String']['input']>;
  shipDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  shipDateTo?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportContainerTagsDataArgs = {
  characteristicId1?: InputMaybe<Scalars['String']['input']>;
  characteristicId2?: InputMaybe<Scalars['String']['input']>;
  characteristicId3?: InputMaybe<Scalars['String']['input']>;
  characteristicId4?: InputMaybe<Scalars['String']['input']>;
  characteristicId5?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  quantityBasis?: InputMaybe<Scalars['String']['input']>;
  retailPricedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  tagMode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportCustomerAgingDataArgs = {
  ageBasis?: InputMaybe<Scalars['String']['input']>;
  agingDate: Scalars['DateTime']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  creditBalanceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  minBalance?: InputMaybe<Scalars['Decimal']['input']>;
  minDaysOutstanding?: InputMaybe<Scalars['Int']['input']>;
  omitZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportCustomerAvgDaysToPayDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  periodAFrom: Scalars['DateTime']['input'];
  periodALabel?: InputMaybe<Scalars['String']['input']>;
  periodATo: Scalars['DateTime']['input'];
  periodBFrom?: InputMaybe<Scalars['DateTime']['input']>;
  periodBLabel?: InputMaybe<Scalars['String']['input']>;
  periodBTo?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportCustomerInterestDataArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportCustomerOrderHistoryDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  minOrderCount?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportCustomerSalesPaymentsCreditsDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportCustomersDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportCycleCountHistoryDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportDailySalesSummaryDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateSummaryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  printShipToName?: InputMaybe<Scalars['Boolean']['input']>;
  salesPersons?: InputMaybe<Array<Scalars['String']['input']>>;
  shipDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  shipDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  shipToCode?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportDataSourcesArgs = {
  order?: InputMaybe<Array<ReportDataSourceDocumentSortInput>>;
  where?: InputMaybe<ReportDataSourceDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportDayRouteScheduleDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  shipDate: Scalars['LocalDate']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportDemandVsSupplyDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  shortOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportExecutionDocumentSortInput>>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ReportExecutionDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportFoldersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportFolderDocumentSortInput>>;
  where?: InputMaybe<ReportFolderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportGeneralLedgerExportDataArgs = {
  arAccount?: InputMaybe<Scalars['String']['input']>;
  cashAccount?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  taxAccount?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportInventoryDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationStatus?: InputMaybe<Scalars['String']['input']>;
  maxAvailableQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  maxCommittedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  maxOnhandQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  minAvailableQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  minCommittedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  minOnhandQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  omitZeroQuantityLocations?: InputMaybe<Scalars['Boolean']['input']>;
  readyDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  readyDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportInventoryTransactionsDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  itemGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportItemCodesDataArgs = {
  codeList?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeItems?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportItemListDataArgs = {
  amountBasis?: InputMaybe<Scalars['String']['input']>;
  characteristicId1?: InputMaybe<Scalars['String']['input']>;
  characteristicId2?: InputMaybe<Scalars['String']['input']>;
  characteristicId3?: InputMaybe<Scalars['String']['input']>;
  characteristicId4?: InputMaybe<Scalars['String']['input']>;
  characteristicId5?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByProductGroup?: InputMaybe<Scalars['Boolean']['input']>;
  includeLastCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeOnOrderDetail?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  negativeAvailableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  omitZeroOnHand?: InputMaybe<Scalars['Boolean']['input']>;
  omitZeroOnHandAndOnOrder?: InputMaybe<Scalars['Boolean']['input']>;
  onHandMax?: InputMaybe<Scalars['Decimal']['input']>;
  onHandMin?: InputMaybe<Scalars['Decimal']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  shipDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  shipDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportItemPurchaseSummaryDataArgs = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeReceivingDetail?: InputMaybe<Scalars['Boolean']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  minQuantity?: InputMaybe<Scalars['Int']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  poNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  poStatus?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportKitsDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportLoadDataArgs = {
  loadNumber: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportMasterOrdersDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  extendedAmountBasis?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  locationCode?: InputMaybe<Scalars['String']['input']>;
  omitClosedMasterOrders?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  remainingQuantityOnly?: InputMaybe<Scalars['Boolean']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  salesPerson?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportMaterialItemsDataArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportOpenOrdersByItemDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportOpenOrdersByProductDataArgs = {
  blankRowsBelowHeader?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeAcknowledgementNotes?: InputMaybe<Scalars['Boolean']['input']>;
  includePullNotes?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  itemGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  pivotAxis?: InputMaybe<Scalars['String']['input']>;
  pivotValues?: InputMaybe<Array<Scalars['String']['input']>>;
  printOrderedQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  shipDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  shipDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportOrderFulfillmentReadinessDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dueDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  readinessStatus?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportOrderItemAllocationsDataArgs = {
  allocationState?: InputMaybe<Scalars['String']['input']>;
  allocationStatus?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByLocation?: InputMaybe<Scalars['Boolean']['input']>;
  includeZeroAcknowledgedMasterItems?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationCode?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  masterOrderNumber?: InputMaybe<Scalars['String']['input']>;
  orderKind?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  salesPerson?: InputMaybe<Scalars['String']['input']>;
  shipDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  shipDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  shippedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportOrderItemStockLocationsDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  shipDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  shipDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportOrderLineItemsDataArgs = {
  customerBasis?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeItemInventory?: InputMaybe<Scalars['Boolean']['input']>;
  includeLineNotes?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  itemGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  salesPersons?: InputMaybe<Array<Scalars['String']['input']>>;
  shipDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  shipDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  shipFromSiteId?: InputMaybe<Scalars['String']['input']>;
  shippedState?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportOrdersDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemSortBy?: InputMaybe<Scalars['String']['input']>;
  loadId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderType?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  salesPerson?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  summarizeBySize?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportPortalAvailabilityDataArgs = {
  characteristicId1?: InputMaybe<Scalars['String']['input']>;
  characteristicId2?: InputMaybe<Scalars['String']['input']>;
  characteristicId3?: InputMaybe<Scalars['String']['input']>;
  characteristicId4?: InputMaybe<Scalars['String']['input']>;
  characteristicId5?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  window?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportPriceListDataArgs = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  characteristicId1?: InputMaybe<Scalars['String']['input']>;
  characteristicId2?: InputMaybe<Scalars['String']['input']>;
  characteristicId3?: InputMaybe<Scalars['String']['input']>;
  characteristicId4?: InputMaybe<Scalars['String']['input']>;
  characteristicId5?: InputMaybe<Scalars['String']['input']>;
  descriptionFormat?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeItemsNotOnPriceLevel?: InputMaybe<Scalars['Boolean']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  notDiscountableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  priceDate?: InputMaybe<Scalars['DateTime']['input']>;
  priceDateFrom1?: InputMaybe<Scalars['DateTime']['input']>;
  priceDateFrom2?: InputMaybe<Scalars['DateTime']['input']>;
  priceDateFrom3?: InputMaybe<Scalars['DateTime']['input']>;
  priceDateFrom4?: InputMaybe<Scalars['DateTime']['input']>;
  priceDateFrom5?: InputMaybe<Scalars['DateTime']['input']>;
  priceDateThru1?: InputMaybe<Scalars['DateTime']['input']>;
  priceDateThru2?: InputMaybe<Scalars['DateTime']['input']>;
  priceDateThru3?: InputMaybe<Scalars['DateTime']['input']>;
  priceDateThru4?: InputMaybe<Scalars['DateTime']['input']>;
  priceDateThru5?: InputMaybe<Scalars['DateTime']['input']>;
  priceFromQty1?: InputMaybe<Scalars['Int']['input']>;
  priceFromQty2?: InputMaybe<Scalars['Int']['input']>;
  priceFromQty3?: InputMaybe<Scalars['Int']['input']>;
  priceFromQty4?: InputMaybe<Scalars['Int']['input']>;
  priceFromQty5?: InputMaybe<Scalars['Int']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  priceGroupId2?: InputMaybe<Scalars['String']['input']>;
  priceGroupId3?: InputMaybe<Scalars['String']['input']>;
  priceGroupId4?: InputMaybe<Scalars['String']['input']>;
  priceGroupId5?: InputMaybe<Scalars['String']['input']>;
  priceHeading1?: InputMaybe<Scalars['String']['input']>;
  priceHeading2?: InputMaybe<Scalars['String']['input']>;
  priceHeading3?: InputMaybe<Scalars['String']['input']>;
  priceHeading4?: InputMaybe<Scalars['String']['input']>;
  priceHeading5?: InputMaybe<Scalars['String']['input']>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportProductionCostsDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportProductionJobsDataArgs = {
  deliveryDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportProductionLotsDataArgs = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  lotNumberFrom?: InputMaybe<Scalars['Int']['input']>;
  lotNumberTo?: InputMaybe<Scalars['Int']['input']>;
  productionCategoryId?: InputMaybe<Scalars['String']['input']>;
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportProductionScheduleDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportProductionScheduleProduceDataArgs = {
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  combos?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  includeChildJobs?: InputMaybe<Scalars['Boolean']['input']>;
  lotNumber?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<Array<Scalars['String']['input']>>;
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
  readyDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  readyDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  startWeekFrom?: InputMaybe<Scalars['Int']['input']>;
  startWeekTo?: InputMaybe<Scalars['Int']['input']>;
  startYear?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportProductionScheduleProduceWeeklyDataArgs = {
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  lotNumber?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<Array<Scalars['String']['input']>>;
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
  startYear?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportProductsDataArgs = {
  barcodeSource?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  characteristicId1?: InputMaybe<Scalars['String']['input']>;
  characteristicId2?: InputMaybe<Scalars['String']['input']>;
  characteristicId3?: InputMaybe<Scalars['String']['input']>;
  characteristicId4?: InputMaybe<Scalars['String']['input']>;
  characteristicId5?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  upcFormat?: InputMaybe<Scalars['String']['input']>;
  upcPresence?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportPullListConsolidatedDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  loadId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportPullSlipDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  loadId?: InputMaybe<Scalars['String']['input']>;
  orderNumber: Scalars['String']['input'];
  sortDirection?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportRecipeProfitabilityDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  minMarginPercent?: InputMaybe<Scalars['Decimal']['input']>;
  productionCategoryId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportRoyaltyPayoutDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  itemCategory?: InputMaybe<Scalars['String']['input']>;
  payeeName?: InputMaybe<Scalars['String']['input']>;
  shippedFrom: Scalars['DateTime']['input'];
  shippedTo: Scalars['DateTime']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportSalesByCategoryDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy: SalesByCategoryGroupBy;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportSalesComparisonDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateBasis?: InputMaybe<SalesComparisonDateBasis>;
  excludeInitialized?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy: SalesComparisonGroupBy;
  metric: SalesComparisonMetric;
  minPeriodATotal?: InputMaybe<Scalars['Decimal']['input']>;
  periodAFrom: Scalars['DateTime']['input'];
  periodATo: Scalars['DateTime']['input'];
  periodBFrom: Scalars['DateTime']['input'];
  periodBTo: Scalars['DateTime']['input'];
  salesPerson?: InputMaybe<Scalars['String']['input']>;
  shipFromSiteLocationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SalesComparisonSort>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportSalesPersonCommissionDataArgs = {
  commissionedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customerBasis?: InputMaybe<Scalars['String']['input']>;
  dateBasis?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  deductDiscountTaken?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  salesPerson?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportSalesPersonPerformanceDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  salesPerson?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportSalesTaxDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  detailSort?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeVoided?: InputMaybe<Scalars['Boolean']['input']>;
  includeZeroTaxDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  summarySort?: InputMaybe<Scalars['String']['input']>;
  taxBasis?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportSalesVelocityDataArgs = {
  customerCode?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  locationCode?: InputMaybe<Scalars['String']['input']>;
  minWeeklyRateOfSale?: InputMaybe<Scalars['Decimal']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportScheduleDocumentSortInput>>;
  where?: InputMaybe<ReportScheduleDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportShipToAddressesDataArgs = {
  customerName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportShippingLabelsDataArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  labelsPerOrder?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  shipDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  shipDateTo?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportTemplateArgs = {
  templateId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportTemplateDocumentSortInput>>;
  where?: InputMaybe<ReportTemplateDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportVendorPurchaseOrdersDataArgs = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  omitClosedPurchaseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  omitZeroRemaining?: InputMaybe<Scalars['Boolean']['input']>;
  poNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportVendorSpendDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  minimumValue?: InputMaybe<Scalars['Decimal']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportVendorsDataArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  stateProvince?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportVersionsArgs = {
  reportId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportWorkOrdersDataArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportDocumentSortInput>>;
  where?: InputMaybe<ReportDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReportsByAppTagArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appTag: AppTag;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportDocumentSortInput>>;
  where?: InputMaybe<ReportDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryReserveRuleArgs = {
  reserveRuleId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryResolveAvailabilityImportItemsArgs = {
  items: Array<AvailabilityImportItemInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryResolveProduceTagArgs = {
  criteria: ProduceTagResolutionCriteriaInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryResolveProduceTagsArgs = {
  criteria: Array<ProduceTagResolutionCriteriaInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryResolveSkuUpcMappingArgs = {
  atMoment?: InputMaybe<Scalars['DateTime']['input']>;
  customerId: Scalars['String']['input'];
  customerLocationId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryResolveSkuUpcMappingsArgs = {
  atMoment?: InputMaybe<Scalars['DateTime']['input']>;
  customerId: Scalars['String']['input'];
  customerLocationId?: InputMaybe<Scalars['String']['input']>;
  itemIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryResolveVendorItemsArgs = {
  rows: Array<VendorItemResolveRowInput>;
  topN?: Scalars['Int']['input'];
  vendorId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryResolvedSpaceCapacityArgs = {
  isoWeek: Scalars['Int']['input'];
  isoYear: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
  spaceTypeId: Scalars['String']['input'];
  subLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockAllocationPreviewArgs = {
  input: RestockAllocationPreviewInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockCustomerLocationDocumentSortInput>>;
  where?: InputMaybe<RestockCustomerLocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockDailyDemandArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asOf: Scalars['DateTime']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DbrCalcResultDocumentSortInput>>;
  weeksOfSupply?: InputMaybe<Scalars['Decimal']['input']>;
  where?: InputMaybe<DbrCalcResultDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockDailyDemandSummaryArgs = {
  asOf: Scalars['DateTime']['input'];
  station?: InputMaybe<Scalars['String']['input']>;
  weeksOfSupply?: InputMaybe<Scalars['Decimal']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockDashboardStoreRowsArgs = {
  itemCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  scoreDate?: InputMaybe<Scalars['DateTime']['input']>;
  station?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockDashboardStoreRowsBlockArgs = {
  filter?: InputMaybe<RestockDashboardStoreRowFilterInput>;
  itemCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  offset: Scalars['Int']['input'];
  scoreDate?: InputMaybe<Scalars['DateTime']['input']>;
  sort?: InputMaybe<Array<RestockDashboardStoreRowSortInput>>;
  station?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockFullCartPreviewArgs = {
  input: RestockFullCartPreviewInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockMetricsArgs = {
  filter?: InputMaybe<RestockMetricsFilterInput>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockRowExplanationArgs = {
  sessionId: Scalars['String']['input'];
  storeSkuKey: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionComponentAvailabilityArgs = {
  itemIds: Array<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionCreationExclusionsArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionExportOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockSessionExportOrderDocumentSortInput>>;
  sessionId: Scalars['String']['input'];
  where?: InputMaybe<RestockSessionExportOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionItemAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockSessionItemAllocationDocumentSortInput>>;
  sessionId: Scalars['String']['input'];
  where?: InputMaybe<RestockSessionItemAllocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionItemsAvailabilityArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionKitPlanArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionOrderItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockSessionOrderItemDocumentSortInput>>;
  sessionId: Scalars['String']['input'];
  where?: InputMaybe<RestockSessionOrderItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionOrderItemsBlockArgs = {
  filter?: InputMaybe<RestockOrderItemFilterInput>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  groupKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
  sort?: InputMaybe<Array<RestockOrderItemSortInput>>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionOrderQuantityOverrideHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerLocationId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockSessionOrderQuantityOverrideHistoryDocumentSortInput>>;
  restockSessionId: Scalars['String']['input'];
  where?: InputMaybe<RestockSessionOrderQuantityOverrideHistoryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionProgressArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionRowCalcStepsArgs = {
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionStoreTicketsArgs = {
  customerLocationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionSubmitSummaryArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRestockSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RestockSessionDocumentSortInput>>;
  where?: InputMaybe<RestockSessionDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRetailAvailableBpLotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDepleted?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RetailAvailableBpLotDocumentSortInput>>;
  where?: InputMaybe<RetailAvailableBpLotDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRetailProductCountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RetailProductCountDocumentSortInput>>;
  where?: InputMaybe<RetailProductCountDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRfidScansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RfidScanDocumentSortInput>>;
  where?: InputMaybe<RfidScanDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RouteDocumentSortInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<RouteDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryRunnableConsolidationApplicationsArgs = {
  take: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySalesItemCandidatesForProductionItemArgs = {
  productionItemId: Scalars['ID']['input'];
  top?: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySalesItemsMatchingProductionItemNumberArgs = {
  number: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryScavengeLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ScavengeLogDocumentSortInput>>;
  where?: InputMaybe<ScavengeLogDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryScheduledInventoryTransfersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ScheduledInventoryTransferDocumentSortInput>>;
  where?: InputMaybe<ScheduledInventoryTransferDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySellableHardgoodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MaterialItemDocumentSortInput>>;
  where?: InputMaybe<MaterialItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySenderDomainPolicyArgs = {
  domain: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySessionRestockMetricsArgs = {
  sessionId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySftpTenantConfigArgs = {
  configId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySftpTenantConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SftpTenantConfigDocumentSortInput>>;
  where?: InputMaybe<SftpTenantConfigDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryShipFromSiteNamesArgs = {
  where?: InputMaybe<CombinedOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryShipToCombinePreviewArgs = {
  loserLocationId: Scalars['String']['input'];
  survivorLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryShippingAcknowledgmentPdfArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryShrinkLossReportArgs = {
  input: ShrinkLossReportInput;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySiteLocationArgs = {
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySiteLocationAsyncImportJobRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asyncImportJobId: Scalars['String']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SiteLocationAsyncImportJobRowSortInput>>;
  where?: InputMaybe<SiteLocationAsyncImportJobRowFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySiteLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SiteLocationDocumentSortInput>>;
  where?: InputMaybe<SiteLocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySiteMapCoverageArgs = {
  forecastId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySiteMapsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  customerLocationId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SiteMapDocumentSortInput>>;
  where?: InputMaybe<SiteMapDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySizeUomArgs = {
  code: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySizeUomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SizeUomDocumentSortInput>>;
  where?: InputMaybe<SizeUomDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySkuUpcMappingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SkuUpcMappingSortInput>>;
  where?: InputMaybe<SkuUpcMappingFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySkuUpcMappingsForItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemIds: Array<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SkuUpcMappingSortInput>>;
  where?: InputMaybe<SkuUpcMappingFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySpaceCapacityWindowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SpaceCapacityWindowDocumentSortInput>>;
  where?: InputMaybe<SpaceCapacityWindowDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySpaceEventGroupsArgs = {
  groupBy: SpaceEventGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySpaceTypeCapacitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SpaceTypeCapacityDocumentSortInput>>;
  where?: InputMaybe<SpaceTypeCapacityDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySpaceUtilizationArgs = {
  isoWeekEnd?: InputMaybe<Scalars['Int']['input']>;
  isoWeekStart?: InputMaybe<Scalars['Int']['input']>;
  isoYear?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId: Scalars['String']['input'];
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySpaceUtilizationAllSitesArgs = {
  fromIsoYearWeek: Scalars['Int']['input'];
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
  toIsoYearWeek: Scalars['Int']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySpaceUtilizationPreviewArgs = {
  isoWeekEnd?: InputMaybe<Scalars['Int']['input']>;
  isoWeekStart?: InputMaybe<Scalars['Int']['input']>;
  isoYear?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  moves?: InputMaybe<Array<SpaceMoveInput>>;
  newLots?: InputMaybe<Array<SpaceNewLotInput>>;
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId: Scalars['String']['input'];
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CategoryDocumentSortInput>>;
  where?: InputMaybe<CategoryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedCategoryArgs = {
  code: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedCustomerArgs = {
  customerId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerLocationDocumentSortInput>>;
  where?: InputMaybe<CustomerLocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomersSummaryDocumentSortInput>>;
  where?: InputMaybe<CustomersSummaryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedHistoricalOrderArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedHistoricalOrderLineItemsArgs = {
  orderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedHistoricalOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HistoricalOrderStagedSummaryDocumentSortInput>>;
  where?: InputMaybe<HistoricalOrderStagedSummaryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedInventoryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InventoryItemDocumentSortInput>>;
  where?: InputMaybe<InventoryItemDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedItemArgs = {
  itemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ItemSummaryDocumentSortInput>>;
  where?: InputMaybe<ItemSummaryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedPriceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PriceGroupDocumentSortInput>>;
  where?: InputMaybe<PriceGroupDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedPriceLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<StagedPriceLevelDocumentSortInput>>;
  where?: InputMaybe<StagedPriceLevelDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedSiteLocationArgs = {
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedSiteLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SiteLocationDocumentSortInput>>;
  where?: InputMaybe<SiteLocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedSubLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SubLocationDocumentSortInput>>;
  where?: InputMaybe<SubLocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedTermArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStagedTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TermsDocumentSortInput>>;
  where?: InputMaybe<TermsDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStatementPrintBatchArgs = {
  statementRunId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStationBpLotInventoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RetailAvailableBpLotDocumentSortInput>>;
  stationLocationId: Scalars['String']['input'];
  where?: InputMaybe<RetailAvailableBpLotDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStoredConsolidationPreviewArgs = {
  previewId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStreamCountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<StreamCountDocumentSortInput>>;
  where?: InputMaybe<StreamCountDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryStripeTaxFeeCreditsArgs = {
  month: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySubLocationArgs = {
  locationId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySubLocationCombinePreviewArgs = {
  loserLocationId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
  survivorLocationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySubLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCombined?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SubLocationDocumentSortInput>>;
  where?: InputMaybe<SubLocationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySupplierPriceImportArgs = {
  importId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySupplierPriceImportApplyArgs = {
  approvalId: Scalars['String']['input'];
  importId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySupplierPriceImportHeldRowsArgs = {
  importId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySupplierPriceImportRowCandidatesArgs = {
  importId: Scalars['String']['input'];
  sourceRowId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySupplierPriceImportRowsArgs = {
  importId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySupplierPriceImportsArgs = {
  purchasingVendorId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySupportTenantSnapshotArgs = {
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySynchronizationIterationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IterationDocumentSortInput>>;
  where?: InputMaybe<IterationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySynchronizationOnHandProcessIterationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OnHandProcessIterationDocumentSortInput>>;
  where?: InputMaybe<OnHandProcessIterationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QuerySynchronizationOnHandQueueingIterationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OnHandQueueIterationDocumentSortInput>>;
  where?: InputMaybe<OnHandQueueIterationDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTagColorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TagColorDocumentSortInput>>;
  where?: InputMaybe<TagColorDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTaskAssignmentArgs = {
  taskAssignmentId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTaskAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaskAssignmentDocumentSortInput>>;
  where?: InputMaybe<TaskAssignmentDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTaskEventGroupsArgs = {
  groupBy: TaskEventGroupField;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTaskEventTypeArgs = {
  taskEventTypeId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTaskEventTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaskEventTypeDocumentSortInput>>;
  where?: InputMaybe<TaskEventTypeDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTenantAsyncImportJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AsyncImportJobDocumentSortInput>>;
  where?: InputMaybe<AsyncImportJobDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTenantByCompanySlugArgs = {
  slug: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTenantByPortalHostArgs = {
  host: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTenantCustomerPermissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TenantCustomerPermissionsDocumentSortInput>>;
  where?: InputMaybe<TenantCustomerPermissionsDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTenantEmailSendersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TenantEmailSenderDocumentSortInput>>;
  where?: InputMaybe<TenantEmailSenderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTenantIntegrationTokenArgs = {
  integrationId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTenantIntegrationTokensArgs = {
  order?: InputMaybe<Array<TenantIntegrationTokenDocumentSortInput>>;
  where?: InputMaybe<TenantIntegrationTokenDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTenantResetManifestArgs = {
  createdFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  createdTo?: InputMaybe<Scalars['LocalDate']['input']>;
  module: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TermsDocumentSortInput>>;
  where?: InputMaybe<TermsDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTermsByIdArgs = {
  termsId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTermsByNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names: Array<Scalars['String']['input']>;
  order?: InputMaybe<Array<TermsDocumentSortInput>>;
  where?: InputMaybe<TermsDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTermsCombinePreviewArgs = {
  loserId: Scalars['String']['input'];
  survivorId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTermsIdsByErpIdArgs = {
  erpIds: Array<Scalars['String']['input']>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTrialPolicyArgs = {
  kind: TrialKind;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTrialRequestStatusArgs = {
  requestId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTrialRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TrialRequestDocumentSortInput>>;
  where?: InputMaybe<TrialRequestDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryTrialTenantUsageArgs = {
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryUncarriedOrderReceiptsArgs = {
  input?: InputMaybe<UncarriedOrderReceiptsInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryUnlinkedRampBillsForPurchaseOrderArgs = {
  purchaseOrderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryUserAppSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserAppSettingDocumentSortInput>>;
  where?: InputMaybe<UserAppSettingDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryUserInvitesArgs = {
  includeExpired?: Scalars['Boolean']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryUserTimeEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TimeEntryDocumentSortInput>>;
  where?: InputMaybe<TimeEntryDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserDocumentSortInput>>;
  where?: InputMaybe<UserDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryUsualLineQuantityArgs = {
  itemId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryVendorArgs = {
  vendorId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryVendorItemAliasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeRetired?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  materialItemId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<VendorItemAliasSortInput>>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<VendorItemAliasFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryVendorMaterialCostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  materialItemId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<VendorMaterialCostDocumentSortInput>>;
  where?: InputMaybe<VendorMaterialCostDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryVendorPurchaseOrderByIdArgs = {
  vendorPurchaseOrderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryVendorPurchaseOrderLineCostPreviewArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  materialItemIds: Array<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryVendorPurchaseOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VendorPurchaseOrderDocumentSortInput>>;
  where?: InputMaybe<VendorPurchaseOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryVendorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  backgroundJobId?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VendorDocumentSortInput>>;
  where?: InputMaybe<VendorDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryVerifyContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VerifyContainerDocumentSortInput>>;
  where?: InputMaybe<VerifyContainerDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryVolumePoolArgs = {
  id: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryVolumePoolsArgs = {
  includeRetired?: Scalars['Boolean']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryWorkOrderArgs = {
  workOrderId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WorkOrderDocumentSortInput>>;
  where?: InputMaybe<WorkOrderDocumentFilterInput>;
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryWorkerConfigsArgs = {
  serviceName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryWsapiImportArgs = {
  wsapiImportId: Scalars['String']['input'];
};


/**
 * Read side of release candidates — what a QA run's candidateId points at.
 *
 * Gated by the QaRead policy, the same policy as the run queries: this is operational
 * telemetry about our own releases, not tenant data, and a dashboard that can read a run's
 * candidate id must be able to resolve it.
 */
export type QueryWsapiImportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WsapiImportDocumentSortInput>>;
  where?: InputMaybe<WsapiImportDocumentFilterInput>;
};

export type QueueOnHandAdjustmentInput = {
  externalCustomerId: Scalars['String']['input'];
  externalItemId: Scalars['String']['input'];
  gtin: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  retailerId: Scalars['String']['input'];
  storeNumber: Scalars['String']['input'];
  type: OnHandAdjustmentType;
};

/** Input of queueWhatsNewEmail. */
export type QueueWhatsNewEmailInput = {
  /** The published release to email. */
  releaseLabel: Scalars['String']['input'];
};

/** Result of queueWhatsNewEmail. */
export type QueueWhatsNewEmailPayload = {
  __typename?: 'QueueWhatsNewEmailPayload';
  /** How many batches this call queued. */
  batchCount: Scalars['Int']['output'];
  /** Why the queue was refused, each with a code; null when it succeeded. */
  errors?: Maybe<Array<ValidationError>>;
  /** False when the release's email was already queued. */
  queued: Scalars['Boolean']['output'];
  /** How many recipients those batches hold in all. */
  recipientCount: Scalars['Int']['output'];
};

/**
 * Where one invoice stands with QuickBooks: whether it got there, which QuickBooks invoice it became, why
 * it did not, when it was last attempted, and how many attempts have failed since it was last armed.
 */
export type QuickBooksExportState = {
  __typename?: 'QuickBooksExportState';
  /** Why the last attempt did not reach QuickBooks. Null unless the status is FAILED. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** When the export row was last written — the arming, or the outcome the worker last reported. */
  lastAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The id QuickBooks gave the invoice it created. Present once an export has succeeded, and KEPT
   * afterwards — including while a later attempt is pending or has failed — because it is the only thing
   * that tells the exporter a QuickBooks invoice already exists for this bill.
   */
  remoteInvoiceId?: Maybe<Scalars['String']['output']>;
  /**
   * The Chart-of-Accounts row resolvedRevenueRung's winning mapping posted revenue to, on the MOST
   * RECENT completed attempt. Null whenever resolvedRevenueRung is null, UNMAPPED, or MIXED — an
   * itemized invoice whose lines resolved through different rungs and/or accounts has no single account
   * to name here — or when the account has since been removed from the tenant's synced Chart of
   * Accounts. PERSISTS ACROSS A RETRY: re-arming an export does not clear it, so a PENDING or FAILED
   * reading can still carry the prior completion's account until a new one lands.
   */
  resolvedRevenueAccount?: Maybe<MergeDevAccountDocument>;
  /**
   * The precedence rung whose income-GL mapping won on the MOST RECENT completed attempt.
   * CUSTOMER_TYPE, ITEM, CATEGORY, TENANT_DEFAULT or UNMAPPED name the rung that carried the account below;
   * MIXED means an itemized invoice whose lines resolved through different rungs and/or accounts, so no
   * single account speaks for the invoice as a whole. Null when no completion has ever carried a rung —
   * an export issued before this ladder existed, or one that has never yet completed. PERSISTS ACROSS A
   * RETRY: re-arming an export does not clear it, so a PENDING or FAILED reading can still carry the
   * prior completion's rung until a new one lands.
   */
  resolvedRevenueRung?: Maybe<MergeDevRevenueRung>;
  /**
   * How many attempts have failed and been retried since the export was last armed. Reset to zero each
   * time the invoice is armed or re-armed, because that is when the exporter's retry budget starts again.
   */
  retryCount: Scalars['Int']['output'];
  /** Whether the invoice reached QuickBooks, is on its way, or did not get there. */
  status: QuickBooksExportStatus;
};

export enum QuickBooksExportStatus {
  Failed = 'FAILED',
  NotExported = 'NOT_EXPORTED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type QuickBooksExportStatusOperationFilterInput = {
  eq?: InputMaybe<QuickBooksExportStatus>;
  in?: InputMaybe<Array<QuickBooksExportStatus>>;
  neq?: InputMaybe<QuickBooksExportStatus>;
  nin?: InputMaybe<Array<QuickBooksExportStatus>>;
};

/** A connection to a list of items. */
export type QuoteFollowUpsDueConnection = {
  __typename?: 'QuoteFollowUpsDueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<QuoteFollowUpsDueEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrdersDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type QuoteFollowUpsDueEdge = {
  __typename?: 'QuoteFollowUpsDueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrdersDocument;
};

export type RaiseDuplicateCandidateInput = {
  aErpId?: InputMaybe<Scalars['String']['input']>;
  aHistoryCount: Scalars['Int']['input'];
  aName: Scalars['String']['input'];
  bErpId?: InputMaybe<Scalars['String']['input']>;
  bHistoryCount: Scalars['Int']['input'];
  bName: Scalars['String']['input'];
  confidence: Scalars['Float']['input'];
  entityType: DuplicateEntityType;
  flags: Array<DuplicateFieldFlagInput>;
  idA: Scalars['String']['input'];
  idB: Scalars['String']['input'];
  label: Scalars['String']['input'];
  modelVersion: Scalars['String']['input'];
  score: Scalars['Float']['input'];
  source: DuplicateCandidateSource;
};

/** One recorded outcome of an import run, for its migration-status notice. */
export type RaiseMigrationStatusNoticeInput = {
  /**
   * For Blocked, the acknowledged control version the run's completion facts show: it names the block episode.
   * Not part of the key for Completed or Failed.
   */
  acknowledgedControlVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The run's composite id, as its completion facts name it. */
  id: Scalars['String']['input'];
  /**
   * The state the run reached: Completed for its verified completion summary, Failed for its failure, Blocked for one
   * block episode. No other state raises a notice.
   */
  outcome: MigrationImportRunState;
  /**
   * The outcome's source key: MigrationImportRun:{runId}:Completed, MigrationImportRun:{runId}:Failed, or
   * MigrationImportRun:{runId}:Blocked:{acknowledgedControlVersion} for a block episode. The run id is the run's own
   * id, not its composite id, and the outcome is spelled exactly as here, not as the enum value. Any other key is
   * refused.
   */
  sourceKey: Scalars['String']['input'];
};

/** The notification rows one outcome stands as, one per recipient, or why nothing was raised. */
export type RaiseMigrationStatusNoticePayload = {
  __typename?: 'RaiseMigrationStatusNoticePayload';
  errors?: Maybe<Array<ValidationError>>;
  notifications: Array<NotificationDocument>;
};

/** One notification to raise, addressed to one recipient, with no KurrentDB event behind it. */
export type RaiseNotificationInput = {
  /** Who or what caused this raise, if there is one to name. Optional: a time-based sweep usually names none. */
  actorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Which entity of that type. */
  entityId: Scalars['String']['input'];
  /** What kind of thing this is about, paired with entityId for the client's deep link. */
  entityType: Scalars['String']['input'];
  /**
   * Display inputs for the client's rendered title and body — values only, never free text. GraphQL has
   * no bare map input type, so each pair rides as a NotificationFieldInput.
   */
  fields?: InputMaybe<Array<NotificationFieldInput>>;
  /**
   * What happened. PhoneVerificationCode is refused: that kind is minted only by
   * requestMyPhoneVerification, alongside the one-time code this mutation has no way to supply.
   */
  kind: NotificationKind;
  /** The product module this row belongs to, for the bell's icon and filter. */
  module: Scalars['String']['input'];
  /** Who this row is for. Validated against the directory before it decides the initial delivery state. */
  recipientEmail: Scalars['String']['input'];
  /**
   * The caller's own deterministic key for WHY this notification exists — a hash of kind, entity id and
   * day bucket is the brief's example, but the shape is the caller's to choose. Combined with the tenant
   * and the recipient to form the row id, so two raises carrying the same key for the same recipient
   * address the same row and the second is a no-op.
   */
  sourceKey: Scalars['String']['input'];
};

/** Input for raiseNotifications. The tenant comes from the worker's own token, never from here. */
export type RaiseNotificationsInput = {
  /** One entry per notification to raise, each addressed to one recipient. */
  batch: Array<RaiseNotificationInput>;
};

/**
 * Result of raiseNotifications: the row each batch entry now stands as. Unlike the
 * caller-facing read-state mutations on this collection, a validation failure here IS an error rather
 * than a silent empty success — the caller is a producer that needs to know an entry could not be
 * raised, not a person who might have double-clicked.
 */
export type RaiseNotificationsPayload = {
  __typename?: 'RaiseNotificationsPayload';
  /** Populated, with the notifications list empty, when the batch was rejected. */
  errors?: Maybe<Array<ValidationError>>;
  /** One row per batch entry, in the same order the batch was submitted. */
  notifications: Array<NotificationDocument>;
};

/** A Ramp bill (Ramp's word for a vendor invoice) cached from GET /developer/v1/bills. */
export type RampBillData = {
  __typename?: 'RampBillData';
  /** The bill amount in major units. */
  amount: Scalars['Decimal']['output'];
  /** The bill currency, e.g. USD. */
  currencyCode: Scalars['String']['output'];
  /** The plain-words status the PO card shows. */
  displayStatus: RampBillDisplayStatus;
  /** Ramp due_at. Null when Ramp sent none. */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  /** Ramp deep_link_url: the bill in the grower's accounting system, when Ramp has synced it. Not a Ramp link. */
  erpUrl?: Maybe<Scalars['String']['output']>;
  /** Ramp invoice_number. Null when Ramp sent none. */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** Ramp issued_at. Null when Ramp sent none. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the RampSync worker last sent this bill. */
  lastSyncedAt: Scalars['DateTime']['output'];
  /** Ramp paid_at. Null until Ramp reports the bill paid. */
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  /** Ramp payment.amount in major units. Null when Ramp sent no payment. */
  paymentAmount?: Maybe<Scalars['Decimal']['output']>;
  /** Ramp payment.payment_date. Null when Ramp sent no payment. */
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Raw Ramp payment.payment_method, e.g. ACH. */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** Raw Ramp approval_status, e.g. PENDING. */
  rampApprovalStatus?: Maybe<Scalars['String']['output']>;
  /** The Ramp bill id (a UUID with dashes), exactly as Ramp sends it. */
  rampBillId: Scalars['String']['output'];
  /** Ramp purchase_order_id: the Ramp PO this bill is matched to in Ramp (Ramp Plus). */
  rampPurchaseOrderId?: Maybe<Scalars['String']['output']>;
  /** Raw Ramp status: OPEN or PAID. */
  rampStatus: Scalars['String']['output'];
  /** Raw Ramp status_summary, e.g. APPROVAL_PENDING. */
  rampStatusSummary?: Maybe<Scalars['String']['output']>;
  /** Link that opens the bill in Ramp, built from config Ramp:BillWebUrlTemplate. Null when the template is not set. */
  rampUrl?: Maybe<Scalars['String']['output']>;
  /** The Ramp vendor id of the bill, exactly as Ramp sends it. */
  rampVendorId: Scalars['String']['output'];
  /** The Ramp vendor name. Null when Ramp sent none. */
  rampVendorName?: Maybe<Scalars['String']['output']>;
};

/** Plain-words status of one Ramp bill, derived from Ramp's status, status_summary and approval_status. */
export enum RampBillDisplayStatus {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Paid = 'PAID',
  PaymentScheduled = 'PAYMENT_SCHEDULED',
  Problem = 'PROBLEM',
  Rejected = 'REJECTED',
  WaitingForApproval = 'WAITING_FOR_APPROVAL'
}

export type RampBillLinkData = {
  __typename?: 'RampBillLinkData';
  /** How the bill was linked: MANUAL or AUTO. Null after an unlink. */
  linkSource?: Maybe<RampBillLinkSource>;
  /** When the bill was linked. Null after an unlink. */
  linkedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email of who linked the bill. Null after an unlink. */
  linkedBy?: Maybe<Scalars['String']['output']>;
  /** Null after an unlink. */
  purchaseOrderId?: Maybe<Scalars['String']['output']>;
  /** The Ramp bill id, exactly as Ramp sends it. */
  rampBillId: Scalars['String']['output'];
};

export type RampBillLinkPayload = {
  __typename?: 'RampBillLinkPayload';
  errors?: Maybe<Array<ValidationError>>;
  rampBillLink?: Maybe<RampBillLinkData>;
};

export enum RampBillLinkSource {
  /** The worker linked it because Ramp matched the bill to the PO's Ramp copy (Ramp Plus). */
  Auto = 'AUTO',
  /** A user picked the bill on the PO. */
  Manual = 'MANUAL'
}

export type RampBillRowInput = {
  /** Ramp amount.amount divided by amount.minor_unit_conversion_rate. */
  amount: Scalars['Decimal']['input'];
  /** Ramp amount.currency_code: 3 letters, e.g. USD. */
  currencyCode: Scalars['String']['input'];
  /** Ramp deep_link_url, as sent. */
  deepLinkUrl?: InputMaybe<Scalars['String']['input']>;
  /** Ramp due_at. */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Ramp invoice_number. */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Ramp issued_at. */
  issuedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Ramp paid_at. */
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Ramp payment.amount in major units. */
  paymentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  /** Ramp payment.payment_date. */
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Raw Ramp payment.payment_method. */
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** Raw Ramp approval_status. */
  rampApprovalStatus?: InputMaybe<Scalars['String']['input']>;
  /** The Ramp bill id exactly as Ramp sends it, dashes kept. At most 64 characters. */
  rampBillId: Scalars['String']['input'];
  /** Ramp purchase_order_id, as sent. */
  rampPurchaseOrderId?: InputMaybe<Scalars['String']['input']>;
  /** Raw Ramp status, e.g. OPEN or PAID. Required. */
  rampStatus: Scalars['String']['input'];
  /** Raw Ramp status_summary. */
  rampStatusSummary?: InputMaybe<Scalars['String']['input']>;
  /** The Ramp vendor id of the bill exactly as Ramp sends it. At most 64 characters. */
  rampVendorId: Scalars['String']['input'];
  /** Ramp vendor.name. */
  rampVendorName?: InputMaybe<Scalars['String']['input']>;
};

/** Decrypted credentials for the RampSync worker. Only the worker can read this type. */
export type RampConnectionCredentialsData = {
  __typename?: 'RampConnectionCredentialsData';
  accessToken: Scalars['String']['output'];
  accessTokenExpiresAt: Scalars['DateTime']['output'];
  /** Ramp API base for this environment, e.g. https://demo-api.ramp.com (sandbox) or https://api.ramp.com. */
  apiBaseUrl: Scalars['String']['output'];
  copyPurchaseOrders: Scalars['Boolean']['output'];
  entityId: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  /** Null when Ramp sent no refresh_token_expires_in. */
  refreshTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The tenant's Ramp connection as any staff user may see it. Never carries a token. */
export type RampConnectionData = {
  __typename?: 'RampConnectionData';
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Email of the admin who last connected. */
  connectedBy?: Maybe<Scalars['String']['output']>;
  /** Copy POs to Ramp (Ramp Plus or Procurement add-on): whether a submitted PO is copied to Ramp. */
  copyPurchaseOrders: Scalars['Boolean']['output'];
  /** Entities captured at the last connect. More than one and entityId null means an admin must pick one. */
  entities: Array<RampEntityData>;
  /** The Ramp entity Work Suite uses. Null until picked; auto-picked when the Ramp account has exactly one entity. */
  entityId?: Maybe<Scalars['String']['output']>;
  /**
   * Name of the picked entity, shown as the Ramp company name. Ramp entities are the legal companies in a
   * Ramp account; the account's own name needs scope business:read, which the app does not request.
   */
  entityName?: Maybe<Scalars['String']['output']>;
  /** True when status is CONNECTED, entities has more than one entry and entityId is null. */
  needsEntitySelection: Scalars['Boolean']['output'];
  /** Short, token-free reason recorded by the worker when status became RECONNECT_NEEDED. */
  reconnectReason?: Maybe<Scalars['String']['output']>;
  status: RampConnectionStatus;
};

export type RampConnectionPayload = {
  __typename?: 'RampConnectionPayload';
  errors?: Maybe<Array<ValidationError>>;
  rampConnection?: Maybe<RampConnectionData>;
};

export enum RampConnectionStatus {
  Connected = 'CONNECTED',
  NotConnected = 'NOT_CONNECTED',
  /** Ramp refused the stored tokens (access revoked or expired). An admin connects again; data already in Work Suite stays. */
  ReconnectNeeded = 'RECONNECT_NEEDED'
}

/** One Ramp entity of the connected Ramp business, as listed by GET /developer/v1/entities at connect time. */
export type RampEntityData = {
  __typename?: 'RampEntityData';
  /** Ramp entity currency, e.g. USD. Null when Ramp sent none. Sent as the currency of a PO copied to Ramp. */
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Ramp entity_name. */
  name: Scalars['String']['output'];
};

export type RampLinkedInvoiceData = {
  __typename?: 'RampLinkedInvoiceData';
  /** The cached Ramp bill. */
  bill: RampBillData;
  /** Who linked the bill: a user (MANUAL) or the worker (AUTO). */
  linkSource: RampBillLinkSource;
  /** When the bill was linked. */
  linkedAt: Scalars['DateTime']['output'];
  /** Email of the user who linked it, or the worker's email for AUTO. */
  linkedBy: Scalars['String']['output'];
};

/** A claimed copy or archive job, with everything the worker sends to Ramp. */
export type RampPurchaseOrderCopyClaimData = {
  __typename?: 'RampPurchaseOrderCopyClaimData';
  /** The claim lapses at this time; an unfinished job can then be claimed again. */
  claimedUntil: Scalars['DateTime']['output'];
  /** The picked entity's currency (RampEntityData.currency); USD when Ramp sent none. Work Suite POs have no currency. */
  currencyCode: Scalars['String']['output'];
  /** Empty for ARCHIVE. */
  lines: Array<RampPurchaseOrderCopyLineData>;
  operation: RampPurchaseOrderCopyOperation;
  purchaseOrderId: Scalars['String']['output'];
  /** Send as purchase_order_number. Also send purchaseOrderId as the Ramp PO external_id. */
  purchaseOrderNumber: Scalars['String']['output'];
  rampEntityId: Scalars['String']['output'];
  /** Set for ARCHIVE: the Ramp PO to archive. */
  rampPurchaseOrderId?: Maybe<Scalars['String']['output']>;
  /** Set for COPY: the PO vendor's linked Ramp vendor. */
  rampVendorId?: Maybe<Scalars['String']['output']>;
  retryCount: Scalars['Int']['output'];
};

/** The PO's Ramp copy, for the PO detail. */
export type RampPurchaseOrderCopyData = {
  __typename?: 'RampPurchaseOrderCopyData';
  /** When the last COPY or ARCHIVE completed. Null until one has. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Last failure as one sentence the PWA shows after "Couldn't copy to Ramp.": "Ramp said: <Ramp's message>" when
   * Ramp sent one, otherwise a short plain reason such as "Ramp did not answer in time." At most 500
   * characters. Never tokens or whole response bodies.
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  notCopiedReason?: Maybe<RampPurchaseOrderNotCopiedReason>;
  operation: RampPurchaseOrderCopyOperation;
  purchaseOrderId: Scalars['String']['output'];
  /** Ramp's id of the copy, once COPY completed. Kept after ARCHIVE. */
  rampPurchaseOrderId?: Maybe<Scalars['String']['output']>;
  /** Ramp's purchase_order_number of the copy, as Ramp returned it. Null until COPY completed. Kept after ARCHIVE. */
  rampPurchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  /** Ramp's ramp_url of the copy. */
  rampPurchaseOrderUrl?: Maybe<Scalars['String']['output']>;
  retryCount: Scalars['Int']['output'];
  status: RampPurchaseOrderCopyStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** One line to send to Ramp. Items first in line order, then one line per order charge (quantity 1). */
export type RampPurchaseOrderCopyLineData = {
  __typename?: 'RampPurchaseOrderCopyLineData';
  description: Scalars['String']['output'];
  /** Work Suite line id or charge id; send as the Ramp line external_id. */
  externalId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  /** Major units. */
  unitPrice: Scalars['Decimal']['output'];
};

export enum RampPurchaseOrderCopyOperation {
  /** Archive the PO's Ramp copy (POST /developer/v1/purchase-orders/{id}/archive). */
  Archive = 'ARCHIVE',
  /** Create the PO in Ramp (POST /developer/v1/purchase-orders). */
  Copy = 'COPY'
}

export type RampPurchaseOrderCopyPayload = {
  __typename?: 'RampPurchaseOrderCopyPayload';
  errors?: Maybe<Array<ValidationError>>;
  rampPurchaseOrderCopy?: Maybe<RampPurchaseOrderCopyData>;
};

export enum RampPurchaseOrderCopyStatus {
  /** The PO was cancelled before its copy was made, so it will never be copied. */
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  FailedPermanent = 'FAILED_PERMANENT',
  FailedTransient = 'FAILED_TRANSIENT',
  /** Copy POs was on but the PO could not be copied; see notCopiedReason. */
  NotCopied = 'NOT_COPIED',
  Pending = 'PENDING'
}

/** Invoice status of a whole PO, from its linked bills (archived and rejected bills do not count). */
export enum RampPurchaseOrderInvoiceStatus {
  Invoiced = 'INVOICED',
  NotInvoiced = 'NOT_INVOICED',
  Paid = 'PAID',
  PartlyPaid = 'PARTLY_PAID'
}

/** Invoices on one PO, for the PO detail card. */
export type RampPurchaseOrderInvoicesData = {
  __typename?: 'RampPurchaseOrderInvoicesData';
  /** Anything but CONNECTED means statuses may be out of date. */
  connectionStatus: RampConnectionStatus;
  /** True when a line with QuantityReceived > 0 has no UnitCost, so receivedValue is understated. */
  hasUncostedReceivedLines: Scalars['Boolean']['output'];
  /** The PO's invoice status from its counted linked bills. */
  invoiceStatus: RampPurchaseOrderInvoiceStatus;
  /** Sum of amount over counted linked bills (not ARCHIVED, not REJECTED). */
  invoicedTotal: Scalars['Decimal']['output'];
  /** Every linked bill, archived and rejected included, newest issuedAt first. A link whose bill the worker has not cached yet is left out until it is. */
  invoices: Array<RampLinkedInvoiceData>;
  /** Sum of amount over counted linked bills whose displayStatus is PAID. */
  paidTotal: Scalars['Decimal']['output'];
  /** The Work Suite purchase order id. */
  purchaseOrderId: Scalars['String']['output'];
  /** Sum over lines of QuantityReceived x UnitCost, plus every order charge. Uncosted lines add 0. */
  receivedValue: Scalars['Decimal']['output'];
  /** The Work Suite vendor id of the PO. */
  vendorId: Scalars['String']['output'];
  /** False when the PO's vendor has no Ramp link; the card then says so and links to the vendor page. */
  vendorLinkedToRamp: Scalars['Boolean']['output'];
};

export enum RampPurchaseOrderNotCopiedReason {
  /** The PO number does not fit the format Ramp requires (recorded by action task A2). */
  PoNumberFormat = 'PO_NUMBER_FORMAT',
  /** A line has no unit cost. */
  UncostedLine = 'UNCOSTED_LINE',
  /** The PO's vendor is not linked to a Ramp vendor. */
  VendorNotLinked = 'VENDOR_NOT_LINKED'
}

/** A Ramp bill-pay vendor cached from GET /developer/v1/vendors. */
export type RampVendorData = {
  __typename?: 'RampVendorData';
  /** Ramp's is_active. Ramp marks a vendor inactive instead of deleting it. */
  isActive: Scalars['Boolean']['output'];
  /** The Ramp vendor name. */
  name: Scalars['String']['output'];
  /** The Ramp vendor id (a UUID with dashes), exactly as Ramp sends it. */
  rampVendorId: Scalars['String']['output'];
};

/** One row of the Vendors tab on the Ramp integration page. */
export type RampVendorLinkRowData = {
  __typename?: 'RampVendorLinkRowData';
  /** The city of the vendor's billing address. Null when not set. */
  city?: Maybe<Scalars['String']['output']>;
  /** The linked Ramp vendor from the cache. Null when not linked or not cached yet. */
  rampVendor?: Maybe<RampVendorData>;
  /** The linked Ramp vendor id. Null when not linked. */
  rampVendorId?: Maybe<Scalars['String']['output']>;
  /** The state or province of the vendor's billing address. Null when not set. */
  state?: Maybe<Scalars['String']['output']>;
  /** Only when not linked: the stored match, left out when its Ramp vendor is now linked to another vendor or no longer active. */
  suggestion?: Maybe<RampVendorSuggestionData>;
  /** The Work Suite vendor id. */
  vendorId: Scalars['String']['output'];
  /** The Work Suite vendor name. */
  vendorName: Scalars['String']['output'];
};

/** What the worker matches: active unlinked Work Suite vendors against active Ramp vendors no Work Suite vendor is linked to. */
export type RampVendorMatchInputData = {
  __typename?: 'RampVendorMatchInputData';
  /** The tenant's active cached Ramp vendors that no Work Suite vendor is linked to. */
  rampVendors: Array<RampVendorData>;
  /** The tenant's active Work Suite vendors with no Ramp link. */
  vendors: Array<RampVendorMatchVendorData>;
};

export enum RampVendorMatchSource {
  Code = 'CODE',
  Jev = 'JEV'
}

/**
 * How sure a vendor suggestion is. The PWA shows SAME_NAME with the chip "Same name", SUGGESTED with "Suggested"
 * and CHECK with the orange chip "Check" (Kevin's mockup, screen 2 B). The word Jev is never shown to growers.
 */
export enum RampVendorMatchTier {
  /** Jev picked this Ramp vendor with confidence 0.60 to under 0.85. Linked one at a time, never in bulk. */
  Check = 'CHECK',
  /** Names are equal after dropping Inc, LLC, Co, Corp, Corporation and Company. Found by code, Jev on or off. */
  SameName = 'SAME_NAME',
  /** Jev picked this Ramp vendor with confidence 0.85 or more. Included in linkSuggestedRampVendors. */
  Suggested = 'SUGGESTED'
}

/** An active, unlinked Work Suite vendor for the worker to match. */
export type RampVendorMatchVendorData = {
  __typename?: 'RampVendorMatchVendorData';
  /** The city of the vendor's billing address. Null when not set. */
  city?: Maybe<Scalars['String']['output']>;
  /** The inputHash stored with this vendor's last match result. Null when never matched. */
  inputHash?: Maybe<Scalars['String']['output']>;
  /** The Work Suite vendor name. */
  name: Scalars['String']['output'];
  /** The state or province of the vendor's billing address. Null when not set. */
  state?: Maybe<Scalars['String']['output']>;
  /** The Work Suite vendor id. */
  vendorId: Scalars['String']['output'];
};

export type RampVendorRowInput = {
  /** Ramp's is_active. */
  isActive: Scalars['Boolean']['input'];
  /** The Ramp vendor name as Ramp sends it. At most 1,024 characters. */
  name: Scalars['String']['input'];
  /** The Ramp vendor id exactly as Ramp sends it, dashes kept. At most 64 characters. */
  rampVendorId: Scalars['String']['input'];
};

/** The worker's match for an unlinked Work Suite vendor (wsapi-services S3). */
export type RampVendorSuggestionData = {
  __typename?: 'RampVendorSuggestionData';
  /** Jev confidence, 0 to 1. Null for CODE. */
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Jev model version. Null for CODE. */
  modelVersion?: Maybe<Scalars['String']['output']>;
  /** The suggested Ramp vendor, from the cache. */
  rampVendor: RampVendorData;
  /** Who found the suggestion: the worker's own name match (CODE) or Jev (JEV). */
  source: RampVendorMatchSource;
  /** When the worker stored this suggestion. */
  suggestedAt: Scalars['DateTime']['output'];
  /** How sure the suggestion is. */
  tier: RampVendorMatchTier;
};

export type RampVendorSuggestionRowInput = {
  /** Jev confidence, 0 to 1. Required for JEV, ignored for CODE. */
  confidence?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Worker-defined hash of what it matched on (the vendor's name, city and state, the candidate Ramp vendors,
   * and whether Jev was on). The worker skips a vendor whose stored hash still equals the new one.
   */
  inputHash: Scalars['String']['input'];
  /** Jev model version. Required for JEV, ignored for CODE. */
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  /** Null records that the worker found no match; tier, source, confidence and modelVersion are then ignored. */
  rampVendorId?: InputMaybe<Scalars['String']['input']>;
  /** CODE for SAME_NAME, JEV for SUGGESTED and CHECK. Required when rampVendorId is set. */
  source?: InputMaybe<RampVendorMatchSource>;
  /** How sure the match is. Required when rampVendorId is set. */
  tier?: InputMaybe<RampVendorMatchTier>;
  /** The Work Suite vendor id: 32 hexadecimal characters, no dashes. */
  vendorId: Scalars['String']['input'];
};

export type ReactivateFlatChargeTypeInput = {
  id: Scalars['String']['input'];
};

export type ReactivateUserInput = {
  userId: Scalars['String']['input'];
};

export type ReactivateVolumePoolInput = {
  id: Scalars['String']['input'];
};

/**
 * Why a reapply cannot update this job. Only an active job can be updated: its lot is active, it is not
 * posted and it has not started.
 */
export enum ReapplyBlockedReason {
  /** The job has been posted, in part or in full. */
  JobPosted = 'JOB_POSTED',
  /** The job has already started. */
  JobStarted = 'JOB_STARTED',
  /** The job's lot is not active (it is a draft, inactive or deleted). */
  LotNotActive = 'LOT_NOT_ACTIVE',
  /** Neither the color recipe nor the series recipe has a window that covers the job's week and scope. */
  NoRecipeCovers = 'NO_RECIPE_COVERS'
}

export type ReapplyError = {
  __typename?: 'ReapplyError';
  code: Scalars['String']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  eventListName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  productionJobId: Scalars['String']['output'];
  variationId?: Maybe<Scalars['String']['output']>;
};

export type ReapplyRecipesEventIdChangeInput = {
  eventId: Scalars['String']['input'];
  eventListName: Scalars['String']['input'];
  expectedEventFingerprint?: InputMaybe<Scalars['String']['input']>;
  kind: EventChangeKind;
};

export type ReapplyRecipesInput = {
  jobSelections: Array<ReapplyRecipesJobSelectionInput>;
};

export type ReapplyRecipesJobResult = {
  __typename?: 'ReapplyRecipesJobResult';
  applied: Array<RecipeChangeApplied>;
  currentRecipeVersion: Scalars['Int']['output'];
  failed: Array<RecipeChangeFailed>;
  fullyReconciled: Scalars['Boolean']['output'];
  previewedAtRecipeVersion: Scalars['Int']['output'];
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  skipped: Array<RecipeChangeSkipped>;
};

export type ReapplyRecipesJobSelectionInput = {
  cascadeParentProductionJobId?: InputMaybe<Scalars['String']['input']>;
  fullyReconciled: Scalars['Boolean']['input'];
  previewedAtRecipeVersion: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
  removedVariationIds: Array<Scalars['String']['input']>;
  variationSelections: Array<ReapplyRecipesVariationSelectionInput>;
};

export type ReapplyRecipesPayload = {
  __typename?: 'ReapplyRecipesPayload';
  errors: Array<ReapplyError>;
  results: Array<ReapplyRecipesJobResult>;
};

export type ReapplyRecipesPreviewResult = {
  __typename?: 'ReapplyRecipesPreviewResult';
  affectedChildJobs: Array<AffectedChildJob>;
  /**
   * The resolver's message when blockedReason is NO_RECIPE_COVERS: why neither the color nor the series recipe
   * covers this job, listing both recipes' windows. Null for every other job.
   */
  blockedMessage?: Maybe<Scalars['String']['output']>;
  /**
   * Why a reapply cannot update this job, or null when it can. The diff is still returned so the grower
   * sees what is behind, but the reapply mutation refuses a job that carries a reason (JOB_NOT_ACTIVE).
   */
  blockedReason?: Maybe<ReapplyBlockedReason>;
  /**
   * currentQuantity before it was rounded to whole containers: the job's exact quantity, or
   * its whole quantity when it has no exact one (a job planned before it was stored). Additive beside the
   * whole number, which stays the number every other reader uses.
   */
  currentExactQuantity: Scalars['Decimal']['output'];
  /** This job's quantity to produce as it stands today. */
  currentQuantity: Scalars['Int']['output'];
  currentRecipeVersion: Scalars['Int']['output'];
  diff: JobDiffProjection;
  /** The lot's requested quantity — what the grower asked to have on hand. */
  lotQuantity: Scalars['Int']['output'];
  /**
   * The material/space events this reapply will NOT touch, and why — the grower-owned rows that sit
   * outside the recipe's authority. Rendered alongside the diff so "apply recipe changes" states
   * plainly what it is leaving alone instead of the grower discovering it afterwards.
   */
  preservedJobEvents: Array<PreservedJobEventProjection>;
  productionJobId: Scalars['String']['output'];
  productionRecipeId: Scalars['String']['output'];
  /**
   * projectedQuantity before it was rounded to whole containers, with the same "would become
   * if you apply the yield change" meaning. Equals currentExactQuantity when no yield change
   * is pending.
   */
  projectedExactQuantity: Scalars['Decimal']['output'];
  /**
   * This job's quantity to produce if the pending yield change is applied — the same number the
   * reapply mutation writes when the submitted selection includes that variation's Yield field.
   * Equals currentQuantity when no yield change is pending, the recipe was deleted, or a planner has
   * already pinned this job's quantity by hand. The preview takes only job ids, so it does not know
   * which changes will be selected: a selection that omits Yield leaves the quantity where it is.
   * Render this as "would become if you apply the yield change", not "will become".
   */
  projectedQuantity: Scalars['Int']['output'];
  recipeDeleted: Scalars['Boolean']['output'];
  recipeName?: Maybe<Scalars['String']['output']>;
};

/** A background Reapply Recipes run started by startReapplyRecipesRun. */
export type ReapplyRecipesRun = {
  __typename?: 'ReapplyRecipesRun';
  /** The jobs with at least one applied change. */
  appliedJobs: Scalars['Int']['output'];
  /**
   * The group errors reapplyRecipes would return for the same selections, then the error that failed the
   * run, if one did, with an empty productionJobId.
   */
  errors: Array<ReapplyError>;
  /** Every job result with at least one failed change, exactly as reapplyRecipes returns it. */
  failedResults: Array<ReapplyRecipesJobResult>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  lastProgressAt: Scalars['DateTime']['output'];
  /** The job selections whose lot group has finished, whatever its outcome. */
  processedJobs: Scalars['Int']['output'];
  runId: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  startedByEmail: Scalars['String']['output'];
  status: ReapplyRecipesRunStatus;
  /** The job selections in the run's input. */
  totalJobs: Scalars['Int']['output'];
};

export enum ReapplyRecipesRunStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export type ReapplyRecipesVariationSelectionInput = {
  assignmentOverrideEventIds: Array<Scalars['String']['input']>;
  eventIdChanges: Array<ReapplyRecipesEventIdChangeInput>;
  regenerateTaskEvents: Scalars['Boolean']['input'];
  scalarFieldNames: Array<Scalars['String']['input']>;
  variationId: Scalars['String']['input'];
};

/** Input for reassignCountAssignment. */
export type ReassignCountAssignmentInput = {
  assignmentId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  workerUserId: Scalars['String']['input'];
};

/** GraphQL input for reassignTask. The assignee source is set by the server, never the client. */
export type ReassignTaskInput = {
  newAssignedTo?: InputMaybe<Scalars['String']['input']>;
  taskAssignmentId: Scalars['String']['input'];
};

export type ReassignWsapiImportIntegrationInput = {
  newIntegrationId: Scalars['String']['input'];
  wsapiImportId: Scalars['String']['input'];
};

export type RecalculateRestockSessionInput = {
  sessionId: Scalars['String']['input'];
};

/** A tenant's whole receivable, aged — the totals row under the receivables aging grid. */
export type ReceivablesAgingTotals = {
  __typename?: 'ReceivablesAgingTotals';
  /**
   * The finance charge the tenant's overdue invoices have run up and nobody has assessed. NOT part of
   * arBalance, and a snapshot sum — each term was struck when its own invoice was last acted on.
   */
  accruedLateCharges: Scalars['Decimal']['output'];
  /**
   * What the tenant is owed across every customer, net of what their credit holds unapplied: each customer's
   * arBalance on the grid, summed.
   */
  arBalance: Scalars['Decimal']['output'];
  /** Not yet due, less the customers' unapplied credit. */
  current: Scalars['Decimal']['output'];
  /** How many customers owe anything at all. */
  customersOwing: Scalars['Int']['output'];
  /** 1 to 30 days past due. */
  days1To30: Scalars['Decimal']['output'];
  /** 31 to 60 days past due. */
  days31To60: Scalars['Decimal']['output'];
  /** 61 to 90 days past due. */
  days61To90: Scalars['Decimal']['output'];
  /** More than 90 days past due. */
  days90Plus: Scalars['Decimal']['output'];
  /** How many invoices are standing across the tenant. */
  openInvoiceCount: Scalars['Int']['output'];
  /**
   * The customers' unapplied credit, summed: money the tenant owes back, already netted from arBalance and
   * current.
   */
  unappliedCredit: Scalars['Decimal']['output'];
};

/**
 * Input record for receiveMovementOrder. ReceivedLines must replay the
 * full Shipped snapshot 1:1; quantities may differ to record real loss/gain.
 */
export type ReceiveMovementOrderInput = {
  idempotentKey: Scalars['String']['input'];
  movementOrderId: Scalars['String']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  receivedLines: Array<MovementOrderLineInput>;
  toLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type ReceiveVendorPurchaseOrderItemInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  batches?: InputMaybe<Array<MaterialBinBatchQuantityDataInput>>;
  id: Scalars['String']['input'];
  isOrganicAtReceive?: InputMaybe<Scalars['Boolean']['input']>;
  organicLotCode?: InputMaybe<Scalars['String']['input']>;
  plantDate?: InputMaybe<Scalars['LocalDate']['input']>;
  plantStatus?: InputMaybe<Scalars['String']['input']>;
  qualityNotes?: InputMaybe<Scalars['String']['input']>;
  quantityReceived: Scalars['Decimal']['input'];
  receiveToLocationId: Scalars['String']['input'];
  shortageNotes?: InputMaybe<Scalars['String']['input']>;
  varianceReason?: InputMaybe<VendorReceiveVarianceReason>;
  vendorLotNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ReceiveVendorPurchaseOrderItemsInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  items: Array<ReceiveVendorPurchaseOrderItemInput>;
  receivedByUserEmail: Scalars['String']['input'];
  shipmentReceivedDate: Scalars['DateTime']['input'];
  vendorPurchaseOrderId: Scalars['String']['input'];
};

/**
 * One applied recipe change as the reapplyRecipes MUTATION reports it. This is the mutation's
 * own response contract, deliberately separate from the domain RecipeChangeApplied the
 * RecipeChangesAppliedToJob event stores.
 */
export type RecipeChangeApplied = {
  __typename?: 'RecipeChangeApplied';
  changeType: Scalars['String']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  eventListName?: Maybe<Scalars['String']['output']>;
  expectedEventFingerprint?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  variationId: Scalars['String']['output'];
};

export type RecipeChangeFailed = {
  __typename?: 'RecipeChangeFailed';
  changeType: Scalars['String']['output'];
  code: Scalars['String']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  eventListName?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  variationId: Scalars['String']['output'];
};

export type RecipeChangeSkipped = {
  __typename?: 'RecipeChangeSkipped';
  changeType: Scalars['String']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  eventListName?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  variationId: Scalars['String']['output'];
};

/**
 * Where a cost total came from: the computed cost breakdown, or a flat-rate override that
 * supersedes it. Shared by RecipeCostSummaryResult and
 * ProductionJobCostResult so the estimate and the job-cost surfaces answer the
 * question in the same vocabulary; a second enum with the same two members would let the two
 * surfaces drift apart in exactly the way this flag exists to prevent.
 */
export enum RecipeCostSource {
  /** The total is the sum of the resolved material, labor and additional costs. */
  Computed = 'COMPUTED',
  /**
   * A flat-rate cost override supersedes the computed breakdown, either on this recipe or on a
   * linked sub-recipe rolled into a combo total. The breakdown fields remain populated as
   * reference.
   *
   * On a ProductionJobCostResult only the first case can arise: the job-cost path
   * resolves the job's own recipe and traverses no combo links, so an override on a linked
   * sub-recipe is never folded into a job total.
   */
  FlatRate = 'FLAT_RATE'
}

/** Computed cost breakdown for a production recipe variation at a specific site location. */
export type RecipeCostSummaryResult = {
  __typename?: 'RecipeCostSummaryResult';
  /** Total additional cost (per pot) from flat-rate cost events (packaging, shipping, etc.). */
  additionalCost: Scalars['Decimal']['output'];
  /** Step-by-step audit trail showing how each cost was calculated. */
  calcSteps: Array<CostCalcStep>;
  /**
   * Sum of materials, supplier royalty, plug, labor, additional and overhead costs (per pot), always computed
   * from the breakdown regardless of any flat-rate override. Equals TotalCost when costSource is
   * COMPUTED; when a flat rate is in effect this is the superseded breakdown total, published so
   * the breakdown can be shown as reference without the client re-adding the components itself.
   * The supplier royalty is part of that reference breakdown and is never appended on top of an
   * authored flat rate.
   */
  computedTotalCost: Scalars['Decimal']['output'];
  /**
   * Whether TotalCost came from the computed breakdown or from a flat-rate override. FLAT_RATE
   * means an override is in effect on this recipe or on a linked sub-recipe folded into a combo
   * total, and the breakdown fields are reference values only.
   */
  costSource: RecipeCostSource;
  /**
   * The direct cost (per pot): materials, supplier royalty, plug, labor and additional, everything but
   * overhead. Always from the computed breakdown, so ComputedTotalCost is this plus OverheadCost.
   */
  directCost: Scalars['Decimal']['output'];
  /** Reasons why individual cost components could not be resolved. */
  incompleteCostReasons: Array<Scalars['String']['output']>;
  /** True when all cost components could be fully resolved. */
  isComplete: Scalars['Boolean']['output'];
  /** Total labor cost (per pot) resolved via the recipe's labor source mode. */
  laborCost: Scalars['Decimal']['output'];
  /** The labor source mode used for this calculation. */
  laborCostSource: RecipeLaborSource;
  /**
   * Total BASE material cost (per pot) from default vendor pricing across all BOM items. Never
   * includes the supplier royalty, which is its own component.
   */
  materialsCost: Scalars['Decimal']['output'];
  /** Overall calculation status derived from step severities. */
  overallStatus: CostCalcStepSeverity;
  /**
   * Bench-space overhead (per pot): the square feet one pot holds in each week of its space plan, from a nominal
   * start this week, times the site's overhead rate per square foot per week in effect that week. Counted
   * exactly once into ComputedTotalCost. Zero, and the cost incomplete, when the site has no rate, when no
   * bench space is planned, or for the space a category with no dimensions would book.
   */
  overheadCost: Scalars['Decimal']['output'];
  /**
   * Cost of the plugs one flat starts from (per pot): plugs per flat, counting plug losses as
   * planning does, times the linked plug recipe's cost per plug. Zero for a recipe with no plug
   * link and for every combo, whose linked costs roll up through the other components instead.
   * Counted exactly once into ComputedTotalCost. Reported on the recipe cost only: the plug is its
   * own child job with its own budget, so job and lot budgets never include this line.
   */
  plugCost: Scalars['Decimal']['output'];
  /**
   * Total supplier royalty (per pot) from the SAME selected quotes and the SAME BOM multiples the
   * material cost used. Its own component, counted exactly once into ComputedTotalCost and never
   * into MaterialsCost.
   */
  supplierRoyaltyCost: Scalars['Decimal']['output'];
  /**
   * Whether every quote behind SupplierRoyaltyCost states its supplier royalty. INCOMPLETE means
   * the figure is a known subtotal: at least one quote left its royalty unrecorded, which is not
   * the same as recording it as none. Reported separately from IsComplete, which describes whether
   * the BASE breakdown resolved and is deliberately unmoved by royalty coverage so a legacy
   * recipe keeps quoting exactly as it always did.
   */
  supplierRoyaltyCoverage: SupplierRoyaltyCoverage;
  /**
   * The recipe's cost (per pot), overhead included. Equals ComputedTotalCost unless costSource is
   * FLAT_RATE, in which case it is the flat-rate override amount.
   */
  totalCost: Scalars['Decimal']['output'];
};

export enum RecipeLaborSource {
  DefaultPerUnit = 'DEFAULT_PER_UNIT',
  Events = 'EVENTS'
}

export type RecipeLaborSourceOperationFilterInput = {
  eq?: InputMaybe<RecipeLaborSource>;
  in?: InputMaybe<Array<RecipeLaborSource>>;
  neq?: InputMaybe<RecipeLaborSource>;
  nin?: InputMaybe<Array<RecipeLaborSource>>;
};

/**
 * The tenant whose SpaceUsage documents are rebuilt. afterProductionJobId resumes an earlier
 * call: pass the lastProductionJobId it returned, and this call starts at the next job in job id
 * order. Leave it out to start at the tenant's first job.
 */
export type RecomputeSpaceUsageInput = {
  afterProductionJobId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/**
 * rowsAffected counts the Mongo writes this call made, upserts plus prunes, summed over every
 * job it visited. Zero is a legitimate answer for a tenant with no jobs that book space.
 * lastProductionJobId null with no errors means the walk reached the tenant's last job,
 * and the rebuild is done. Otherwise the call stopped early, because its time budget ran out or at the
 * error it reports, and the jobs it counted are re-planned and durable. Call again with
 * lastProductionJobId as afterProductionJobId, after clearing the error if there is one,
 * to carry on from where it stopped. After an error the cursor is the last page boundary before it, so
 * the next call may re-plan up to one page of jobs again, which converges on the same documents; a
 * null cursor next to an error means start again from the first job.
 */
export type RecomputeSpaceUsagePayload = {
  __typename?: 'RecomputeSpaceUsagePayload';
  errors?: Maybe<Array<ValidationError>>;
  lastProductionJobId?: Maybe<Scalars['String']['output']>;
  rowsAffected: Scalars['Long']['output'];
};

/**
 * Input record for reconcileMovementOrder. Variance resolutions must cover
 * exactly the set of lines whose shipped quantity differs from received.
 */
export type ReconcileMovementOrderInput = {
  idempotentKey: Scalars['String']['input'];
  movementOrderId: Scalars['String']['input'];
  varianceResolutions: Array<VarianceResolutionInput>;
};

export type ReconcileOtaDeliveriesInput = {
  lineId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
};

/** The grower's confirmation of a changed staff route. */
export type ReconfirmOnboardingHelpRouteInput = {
  /** The text the grower typed when confirming, exactly as sent. Required. */
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  /** The review of the changed route the grower saw, shown in an earlier message. */
  presentationId: Scalars['String']['input'];
  /** The accepted request. */
  requestId: Scalars['String']['input'];
  /** The chat references; session, turn and sent message are required. */
  routing: OnboardingJourneyRoutingInput;
};

/** The result of a confirmation, or why it was refused. */
export type ReconfirmOnboardingHelpRoutePayload = {
  __typename?: 'ReconfirmOnboardingHelpRoutePayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<ReconfirmOnboardingHelpRouteResult>;
};

/** What a confirmation recorded. */
export type ReconfirmOnboardingHelpRouteResult = {
  __typename?: 'ReconfirmOnboardingHelpRouteResult';
  /** Recorded now, or the confirmation was already recorded. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The request. */
  requestId: Scalars['String']['output'];
  /** The route the request's unsent channels are now held against. */
  reviewedRoute: OnboardingHelpRouteDetails;
  /** The request revision after the call. */
  streamRevision: Scalars['Long']['output'];
};

/**
 * Input for reconnectMergeLink. The reconnect re-prompts with the same setup step so the user
 * re-confirms explicit choices (NOT a silent auto-preserve). Setup is optional: when omitted
 * the backstop preserves the tenant's current config.
 */
export type ReconnectMergeLinkInput = {
  setup?: InputMaybe<MergeConnectSetupInput>;
};

/** The export worker's report that the accounting provider definitively refused to create the placeholder item for one (purpose, account) pair. The worker re-sends it on every batch that skips the pair because of its memo; wsapi dedups repeats. */
export type RecordAccountingPlaceholderRefusalInput = {
  /** The account ImportId exactly as read from the tenant's accounting config (salesTaxAccountId / freightAccountId / depositAppliedAccountId / roundingAdjustmentAccountId) or, for SALES, from the revenue ladder rung that routed the line. NOT the Merge account id resolved at export time, which differs after a Merge re-link. */
  accountImportId: Scalars['String']['input'];
  /** Merge's problem_type for the refusal, when it carried one. At most 128 characters. */
  mergeProblemType?: InputMaybe<Scalars['String']['input']>;
  /** Which invoice line the refused placeholder item was for. */
  purpose: AccountingPlaceholderPurpose;
  /** The provider's refusal message, verbatim. At most 4096 characters. */
  reason: Scalars['String']['input'];
  /** When the export worker first saw the refusal. */
  refusedAt: Scalars['DateTime']['input'];
};

/** Input for recordAvailabilityPhotoGrade. The tenant comes from the worker's token. */
export type RecordAvailabilityPhotoGradeInput = {
  /** SUGGESTED, SKIPPED or FAILED; UNKNOWN is refused. */
  outcome: AvailabilityPhotoGradeOutcome;
  /** Why the photo was skipped or failed; required for SKIPPED and FAILED, at most 1024 characters once trimmed. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The leased row. */
  requestId: Scalars['String']['input'];
  /** The model's suggestion; required for SUGGESTED, otherwise null. */
  suggestion?: InputMaybe<AvailabilityPhotoGradeSuggestionInput>;
};

/** Result of a record. */
export type RecordAvailabilityPhotoGradePayload = {
  __typename?: 'RecordAvailabilityPhotoGradePayload';
  /** Populated when the row does not exist, is not the caller's, or the move is not allowed. */
  errors?: Maybe<Array<ValidationError>>;
  /** The row recorded against; null when the call failed. */
  requestId?: Maybe<Scalars['String']['output']>;
};

export type RecordContactTextConsentInput = {
  /** Not after today (UTC). */
  agreedOn: Scalars['LocalDate']['input'];
  contactId: Scalars['UUID']['input'];
  customerId: Scalars['String']['input'];
  method: ContactTextConsentMethod;
  /** E.164 of a Mobile-typed number saved on the contact. */
  phoneNumber: Scalars['String']['input'];
  /** 1 to 200 characters. */
  proofReference: Scalars['String']['input'];
  wordingVersion: Scalars['Int']['input'];
};

export type RecordContractRecordEnrollmentStepCompletedInput = {
  requestId: Scalars['String']['input'];
  stepName: Scalars['String']['input'];
  stripeObjectId?: InputMaybe<Scalars['String']['input']>;
  stripeObjectKind: ContractRecordStripeObjectKind;
};

export type RecordContractRecordFeeStepCompletedInput = {
  requestId: Scalars['String']['input'];
  stepName: Scalars['String']['input'];
  stripeObjectId?: InputMaybe<Scalars['String']['input']>;
  stripeObjectKind: ContractRecordStripeObjectKind;
};

export type RecordCustomerCreditRefundInput = {
  amount: Scalars['Decimal']['input'];
  customerId: Scalars['String']['input'];
  method: CustomerCreditRefundMethod;
  note?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  refundId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for recording one customer message outcome. */
export type RecordCustomerDeliveryInput = {
  /** Which attempt this outcome is for, counting from one. */
  attempt?: Scalars['Int']['input'];
  /** Which channel's delivery block this outcome belongs to. */
  channel: NotificationChannel;
  /** The row the worker leased. */
  deliveryId: Scalars['String']['input'];
  /** Why it failed, kept on the row for support. */
  error?: InputMaybe<Scalars['String']['input']>;
  /** Whether the provider's rejection is one no retry could fix. Defaults to false. */
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The provider's handle for an accepted message. */
  providerMessageId?: InputMaybe<Scalars['String']['input']>;
  /** SENT or FAILED. The other states are the claim path's to write. */
  status: NotificationDeliveryStatus;
  /** What was sent, for an SMS outcome. Ignored for EMAIL. */
  text?: InputMaybe<RecordCustomerTextInput>;
};

/** What one text outcome carries beyond the shared fields. */
export type RecordCustomerTextInput = {
  /** The Twilio account the text was sent from. */
  accountSid?: InputMaybe<Scalars['String']['input']>;
  /** The exact text sent. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The From number Twilio used. */
  fromNumber?: InputMaybe<Scalars['String']['input']>;
  /** 0 or null is stored as null (unknown). */
  numSegments?: InputMaybe<Scalars['Int']['input']>;
  /** Twilio's error code when the send failed. */
  providerErrorCode?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordCustomerTextReplyInput = {
  /** Twilio From: the customer's mobile. */
  customerNumber: Scalars['String']['input'];
  /** Twilio To: the grower's number. Resolves the tenant. */
  growerNumber: Scalars['String']['input'];
  occurredAt: Scalars['DateTime']['input'];
  /** Twilio's inbound MessageSid. The idempotency key. */
  providerMessageSid: Scalars['String']['input'];
  replyType: CustomerTextReplyType;
};

export type RecordCustomerTextReplyResult = {
  __typename?: 'RecordCustomerTextReplyResult';
  /** For the HELP reply. Null when UNKNOWN_NUMBER. */
  businessName?: Maybe<Scalars['String']['output']>;
  /** Consent entries the reply changed. */
  matchedContacts: Scalars['Int']['output'];
  outcome: CustomerTextReplyOutcome;
  /** Null when UNKNOWN_NUMBER. */
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type RecordCustomerTextStatusInput = {
  /** Twilio From on the callback: the grower's number. Resolves the tenant. */
  growerNumber: Scalars['String']['input'];
  /** Filled on the row while the row's numSegments is null. 0 is ignored. */
  numSegments?: InputMaybe<Scalars['Int']['input']>;
  occurredAt: Scalars['DateTime']['input'];
  providerErrorCode?: InputMaybe<Scalars['Int']['input']>;
  /** The Message SID the row was recorded with. */
  providerMessageId: Scalars['String']['input'];
  /** Twilio MessageStatus: queued, sending, sent, delivered, undelivered or failed. */
  providerStatus: Scalars['String']['input'];
};

export type RecordCustomerTextStatusResult = {
  __typename?: 'RecordCustomerTextStatusResult';
  /** Existing enum: UPDATED, NOT_FOUND, IGNORED. */
  outcome: RecordSmsDeliveryStatusOutcome;
  /** The row's SMS status after the callback. Null when NOT_FOUND. */
  status?: Maybe<NotificationDeliveryStatus>;
};

export type RecordDeviceFirmwareReportInput = {
  bootId?: InputMaybe<Scalars['Long']['input']>;
  deviceId: Scalars['String']['input'];
  firmwareVersion?: InputMaybe<Scalars['String']['input']>;
  observedAt: Scalars['DateTime']['input'];
  otaResult?: InputMaybe<OtaResultDataInput>;
  seq: Scalars['Long']['input'];
};

export type RecordEmailDeliveryInput = {
  bounceClassification?: InputMaybe<Scalars['String']['input']>;
  eventType: EmailDeliveryEventType;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  recipient: Scalars['String']['input'];
  sendGridMessageId: Scalars['String']['input'];
  sgEventId?: InputMaybe<Scalars['String']['input']>;
  statusCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type RecordEmailSendInput = {
  channel?: InputMaybe<EmailSenderChannel>;
  docType?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  emailSendId?: InputMaybe<Scalars['String']['input']>;
  fromEmail: Scalars['String']['input'];
  fromName?: InputMaybe<Scalars['String']['input']>;
  loadId?: InputMaybe<Scalars['String']['input']>;
  operatorAsserted?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  pdfSizeBytes?: InputMaybe<Scalars['Long']['input']>;
  plannedDeliveryDate?: InputMaybe<Scalars['LocalDate']['input']>;
  plannedTime?: InputMaybe<Scalars['String']['input']>;
  rackCount?: InputMaybe<Scalars['Int']['input']>;
  recipients: Array<RecordEmailSendRecipientDataInput>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  reservationId?: InputMaybe<Scalars['String']['input']>;
  reservationVersion?: InputMaybe<Scalars['Int']['input']>;
  routeStopId?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  sendGridMessageId?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  source: EmailSendSource;
  stopNumber?: InputMaybe<Scalars['Int']['input']>;
  subject: Scalars['String']['input'];
};

export type RecordEmailSendRecipientDataInput = {
  email: Scalars['String']['input'];
  kind: EmailRecipientKind;
  sendErrorMessage?: InputMaybe<Scalars['String']['input']>;
  sendStatus?: EmailRecipientSendStatus;
};

/** Input for recordGrowPointCommitOutcomes. */
export type RecordGrowPointCommitOutcomesInput = {
  /** The commit the outcomes belong to. */
  commitId: Scalars['String']['input'];
  /** The Synchronization iteration id of the run that produced the outcomes. */
  iterationId: Scalars['String']['input'];
  /** One outcome per reviewed row; a row that already has an outcome keeps it. */
  rows: Array<GrowPointRowOutcomeInput>;
  /** The tenant whose commit the worker ran. */
  tenantId: Scalars['String']['input'];
};

/**
 * Result of recordGrowPointCommitOutcomes: the commit with every outcome as recorded.
 * Commit null with a validation, not-found, rejected or unknown-rows error means nothing was
 * recorded. With any other error the outcome is unknown; recording is idempotent per row, so send
 * the same outcomes again.
 */
export type RecordGrowPointCommitOutcomesPayload = {
  __typename?: 'RecordGrowPointCommitOutcomesPayload';
  commit?: Maybe<GrowPointCommitData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type RecordImportSessionInput = {
  failedRows: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
  importSessionId: Scalars['String']['input'];
  importedRows: Scalars['Int']['input'];
  kind: ImportSessionKind;
  rows?: InputMaybe<Array<ImportSessionRowDataInput>>;
  status: ImportSessionStatus;
  totalRows: Scalars['Int']['input'];
};

/** The session that was recorded, or why it was not. */
export type RecordImportSessionPayload = {
  __typename?: 'RecordImportSessionPayload';
  errors?: Maybe<Array<ValidationError>>;
  importSessionId?: Maybe<Scalars['String']['output']>;
};

/** One invoice's share of a recorded payment. */
export type RecordInvoicePaymentEntryInput = {
  /**
   * The cash applied to this invoice. Must be greater than zero; it may be less than the invoice's
   * balance (a partial payment) or more than it (an overpayment), and is recorded either way.
   */
  amount: Scalars['Decimal']['input'];
  /**
   * The early-pay discount to record. Leave it out to take the computed one; send zero to refuse it. A
   * value here requires a note.
   */
  discountTaken?: InputMaybe<Scalars['Decimal']['input']>;
  /** The issued invoice the money is applied to. */
  invoiceId: Scalars['String']['input'];
  /**
   * The finance charge to record. Leave it out to take the computed one; send zero to waive it. A value
   * here requires a note.
   */
  lateChargeAssessed?: InputMaybe<Scalars['Decimal']['input']>;
  /** How this money reached the tenant. */
  method: InvoicePaymentMethod;
  /**
   * Free text kept with the payment. Required when either adjustment is overridden — it is the only
   * record of why the computed figure was not used.
   */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * When the money was received, which is not necessarily when it is being recorded. The late charge and
   * the early-pay discount are computed as of this date, so a cheque keyed in late still earns the
   * discount it arrived in time for.
   */
  receivedDate: Scalars['DateTime']['input'];
};

/** Input for the record-invoice-payment mutation. */
export type RecordInvoicePaymentInput = {
  /**
   * What the payment applies to each invoice. At least one entry is required, and an invoice may be named
   * only once — split a payment across invoices by amount, not by repeating an invoice.
   */
  payments: Array<RecordInvoicePaymentEntryInput>;
  /**
   * The payer's own reference for the whole payment — a cheque number, a bank reference, a settlement id.
   * It is recorded against every invoice the payment settles, which is what lets them be read back
   * together as one remittance. Optional, but a payment recorded without one cannot be grouped later.
   */
  transactionRef?: InputMaybe<Scalars['String']['input']>;
};

/** Payload returned from the record-invoice-payment mutation. */
export type RecordInvoicePaymentPayload = {
  __typename?: 'RecordInvoicePaymentPayload';
  /** Populated only when the payment was refused, in which case nothing at all was recorded. */
  errors?: Maybe<Array<ValidationError>>;
  /** Every invoice the payment settled, as it stands after the payment — in the order they were named. */
  invoices?: Maybe<Array<InvoiceStateData>>;
};

export enum RecordKind {
  Category = 'CATEGORY',
  Customer = 'CUSTOMER',
  CustomerType = 'CUSTOMER_TYPE',
  HardGood = 'HARD_GOOD',
  Item = 'ITEM',
  ItemCharacteristic = 'ITEM_CHARACTERISTIC',
  ItemCharacteristicValue = 'ITEM_CHARACTERISTIC_VALUE',
  Location = 'LOCATION',
  Order = 'ORDER',
  PriceGroup = 'PRICE_GROUP',
  PriceLevel = 'PRICE_LEVEL',
  ShipTo = 'SHIP_TO',
  TagColor = 'TAG_COLOR',
  Terms = 'TERMS',
  Unknown = 'UNKNOWN'
}

/** Input for recordLoadEmailOutcome. The tenant comes from the worker's token. */
export type RecordLoadEmailOutcomeInput = {
  /** The sender channel actually used. */
  channelUsed?: InputMaybe<EmailSenderChannel>;
  /** The worker's note when it fell back to another channel. */
  fallbackNote?: InputMaybe<Scalars['String']['input']>;
  /** The sender address actually used; required for SENT. */
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  /** The sender name actually used. */
  fromName?: InputMaybe<Scalars['String']['input']>;
  /** SENT, FAILED or UNCERTAIN. */
  outcome: LoadEmailOutcome;
  /** The provider's message id for an accepted send. */
  providerMessageId?: InputMaybe<Scalars['String']['input']>;
  /** Why the send failed or is uncertain. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The claimed row. */
  reservationId: Scalars['String']['input'];
};

/**
 * GraphQL input for recordMaterialReceiptGroup: the group's receipts in the order they are
 * saved and posted. Tenant and user are taken from the authenticated principal, never this input.
 */
export type RecordMaterialReceiptGroupInput = {
  receipts: Array<RecordMaterialReceiptInput>;
};

/**
 * GraphQL input for recordMaterialReceipt. Primitive/non-Option fields only (HotChocolate
 * input type). Tenant and user are taken from the authenticated principal, never this input.
 */
export type RecordMaterialReceiptInput = {
  binCode: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  lineNo: Scalars['Int']['input'];
  notes: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  orderType: ErpOrderType;
  quantityReceived: Scalars['Decimal']['input'];
  recordedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unit: Scalars['String']['input'];
  vendorLotNumber: Scalars['String']['input'];
};

/** A grower's correction with no open question, as sent from chat. */
export type RecordMigrationImportCorrectionInput = {
  /** The rows and fields corrected, at most 100. */
  fields: Array<MigrationImportCorrectedFieldInput>;
  /** The journey. */
  journeyId: Scalars['String']['input'];
  /** The prepared revision corrected. */
  revisionId: Scalars['String']['input'];
  /** The chat references; session, turn and sent message are required. */
  routing: OnboardingJourneyRoutingInput;
  /** The source the corrected revision was prepared from. */
  sourceId: Scalars['String']['input'];
};

/**
 * Reads one page of a verified import run's paced confidence observation; the run id, observation id and page are the
 * command's identity.
 */
export type RecordMigrationImportRunObservationInput = {
  /** The run's composite id. */
  id: Scalars['String']['input'];
  /** The worker's id for the observation, the same for every page of it. */
  observationId: Scalars['String']['input'];
  /** The page to read, from 0: the first call reads 0, and each next one the page the last answered. */
  page: Scalars['Int']['input'];
};

/**
 * The page of a run's paced observation the call recorded, and then the next page to read or, once every page is
 * recorded, the observation with its age; or why the call recorded nothing.
 */
export type RecordMigrationImportRunObservationPayload = {
  __typename?: 'RecordMigrationImportRunObservationPayload';
  /** Whether the observation is recorded: every page is, so the worker is done with this observation id. */
  done: Scalars['Boolean']['output'];
  /** Why the call recorded nothing. */
  errors?: Maybe<Array<ValidationError>>;
  /** The first page of the observation not recorded yet; null once every page is. */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** The observation, once its pages cover every verified operation; null before. */
  observation?: Maybe<MigrationImportRunObservation>;
  /** The page recorded under the observation id. */
  page?: Maybe<MigrationImportRunObservationPage>;
};

/** Records the verification of the applied import run the caller holds; the run id and claim token are the command's identity. */
export type RecordMigrationImportRunVerificationInput = {
  claimToken: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** A run's recorded verification, or why the call changed nothing. */
export type RecordMigrationImportRunVerificationPayload = {
  __typename?: 'RecordMigrationImportRunVerificationPayload';
  errors?: Maybe<Array<ValidationError>>;
  verification?: Maybe<MigrationImportRunVerificationSummary>;
};

/** What one preparation stage ended with, under the claim token and the job's attempt count it ran under. */
export type RecordMigrationPreparationStageResultInput = {
  attempt: Scalars['Int']['input'];
  blockingQuestions: Scalars['Int']['input'];
  claimToken: Scalars['String']['input'];
  id: Scalars['String']['input'];
  outcome: MigrationPreparationStageOutcome;
  rowsPrepared: Scalars['Int']['input'];
  rowsRead: Scalars['Int']['input'];
  stage: Scalars['String']['input'];
};

/** A settings-operation revision to record in a journey. */
export type RecordMigrationSettingsRevisionInput = {
  /** Every setting it changes, each at most once. */
  changes: Array<MigrationSettingChangeInput>;
  /** The caller's key for this revision: the same key returns the same revision. */
  idempotencyKey: Scalars['String']['input'];
  /** The journey it belongs to. */
  journeyId: Scalars['String']['input'];
};

/** Completes a validation run whose every page is recorded, under the job's claim. */
export type RecordMigrationValidationCompletionInput = {
  claimToken: Scalars['String']['input'];
  id: Scalars['String']['input'];
  revisionId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};

export type RecordMigrationValidationCompletionPayload = {
  __typename?: 'RecordMigrationValidationCompletionPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<RecordMigrationValidationCompletionResult>;
};

/** What a validation completion recorded. */
export type RecordMigrationValidationCompletionResult = {
  __typename?: 'RecordMigrationValidationCompletionResult';
  /** Order imports emit no business notification. */
  notificationsSuppressed: Scalars['Boolean']['output'];
  /** The blocking questions open when the receipt was written. */
  openBlockingQuestions: Array<Scalars['String']['output']>;
  /** How many operations the run validated. */
  operationCount: Scalars['Int']['output'];
  /** Recorded now, or already recorded by an earlier call. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The ready portions in order, each small enough for one approval to recheck; empty when no operation is ready. */
  portionIds: Array<Scalars['String']['output']>;
  /** How many of them are in the ready portions. */
  readyOperations: Scalars['Int']['output'];
  /** The receipt's content hash. */
  receiptDigest: Scalars['String']['output'];
  /** The prepared revision. */
  revisionId: Scalars['String']['output'];
  /** The run. */
  runId: Scalars['String']['output'];
};

/** Input for recording one delivery outcome. */
export type RecordNotificationDeliveryInput = {
  /** Which attempt this outcome is for, counting from one. Drives the retry budget and the backoff. */
  attempt?: Scalars['Int']['input'];
  /** Which channel's delivery block this outcome belongs to. */
  channel: NotificationChannel;
  /** Why it failed, kept on the row for support. */
  error?: InputMaybe<Scalars['String']['input']>;
  /** The row the worker leased. */
  notificationId: Scalars['String']['input'];
  /**
   * Whether the provider's rejection is one no retry could fix — an address it refuses, a
   * subscription it has retired. Such a failure is final immediately instead of consuming the
   * remaining attempts on a timer. Defaults to false.
   */
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The provider's handle for an accepted message, for matching its later webhooks. */
  providerMessageId?: InputMaybe<Scalars['String']['input']>;
  /** SENT or FAILED. The other states are the claim path's to write. */
  status: NotificationDeliveryStatus;
};

/** A worker's report for one leased channel. */
export type RecordOnboardingHelpDeliveryInput = {
  /** The attempt number the claim returned. */
  attempt: Scalars['Int']['input'];
  /** The channel the worker holds. */
  channel: OnboardingHelpChannel;
  /** For FAILED: true when no retry could succeed, which ends the channel at once. */
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The provider's reference for the message, when it gave one. An id only. */
  providerReference?: InputMaybe<Scalars['String']['input']>;
  /** A short reason code, such as ROUTE_CHANGED. An id only; never provider text or an address. */
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  /** The request. */
  requestId: Scalars['String']['input'];
  /** SENT, FAILED, UNAVAILABLE, UNCERTAIN or HELD. UNAVAILABLE with the reason code ROUTE_CHANGED holds the channel, as HELD does. */
  status: OnboardingHelpDeliveryStatus;
};

/** The result of a report, or why it was refused. */
export type RecordOnboardingHelpDeliveryPayload = {
  __typename?: 'RecordOnboardingHelpDeliveryPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<RecordOnboardingHelpDeliveryResult>;
};

/** One channel after a report. */
export type RecordOnboardingHelpDeliveryResult = {
  __typename?: 'RecordOnboardingHelpDeliveryResult';
  /** How many claims the channel has taken. */
  attempts: Scalars['Int']['output'];
  /** The channel. */
  channel: OnboardingHelpChannel;
  /** When a retry or reconciliation may next be claimed. */
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  /** The recorded provider reference. */
  providerReference?: Maybe<Scalars['String']['output']>;
  /** The recorded reason code. */
  reasonCode?: Maybe<Scalars['String']['output']>;
  /** True when the report repeated the last one and changed nothing. */
  repeated: Scalars['Boolean']['output'];
  /** The request. */
  requestId: Scalars['String']['output'];
  /** Where the channel stands now. */
  status: OnboardingHelpDeliveryStatus;
};

/** A staff acknowledgement or resolution. */
export type RecordOnboardingHelpRequestHandlingInput = {
  /** ACKNOWLEDGED or RESOLVED. */
  handling: OnboardingHelpHandling;
  /** The request, as the staff query listed it. */
  requestId: Scalars['String']['input'];
  /** The tenant the request belongs to, as the staff query listed it. */
  tenantId: Scalars['String']['input'];
};

/** The result of a handling step, or why it was refused. */
export type RecordOnboardingHelpRequestHandlingPayload = {
  __typename?: 'RecordOnboardingHelpRequestHandlingPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<RecordOnboardingHelpRequestHandlingResult>;
};

/** Where a request's staff handling stands after the command. */
export type RecordOnboardingHelpRequestHandlingResult = {
  __typename?: 'RecordOnboardingHelpRequestHandlingResult';
  /** The handling state now. */
  handling: OnboardingHelpHandling;
  /** Recorded now, or the step was already recorded. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The request. */
  requestId: Scalars['String']['output'];
  /** The request revision after the command. */
  streamRevision: Scalars['Long']['output'];
  /** The tenant. */
  tenantId: Scalars['String']['output'];
};

/** One journey fact to record. */
export type RecordOnboardingJourneyFactInput = {
  dependsOn?: InputMaybe<Scalars['String']['input']>;
  evidence?: InputMaybe<OnboardingJourneyFactEvidenceInput>;
  journeyId: Scalars['String']['input'];
  kind: OnboardingJourneyFactKind;
  routing: OnboardingJourneyRoutingInput;
  statement?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** The session that loaded the journey. */
export type RecordOnboardingJourneySessionLoadedInput = {
  journeyId: Scalars['String']['input'];
  routing: OnboardingJourneyRoutingInput;
};

export type RecordOrderDepositInput = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type RecordOrderPaymentInput = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type RecordOrderPullsInput = {
  orderId: Scalars['String']['input'];
  pullAttemptKey: Scalars['UUID']['input'];
  pulls: Array<OrderPullLineInput>;
};

/** A record a warning points at: what kind it is, its id, and a name to show for it. */
export type RecordRef = {
  __typename?: 'RecordRef';
  /** What kind of record this is. */
  entityType: MissingDataEntityType;
  /** The record's own id. For a category, the stored id as it is, in either of its shapes. */
  id: Scalars['ID']['output'];
  /** A name to show for the record, never blank: the record's id when it has no name. */
  label: Scalars['String']['output'];
  /**
   * The id of the record this one sits under, when its page is reached through that record: the site of a
   * SUB_LOCATION. Null for every other kind.
   */
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type RecordReportExecutionInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  executionId: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  pdfSizeBytes: Scalars['Long']['input'];
  recipientCount: Scalars['Int']['input'];
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  reportId: Scalars['String']['input'];
  reportName?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
};

export type RecordShrinkEventDataInput = {
  input: RecordShrinkEventInput;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type RecordShrinkEventInput = {
  date: Scalars['DateTime']['input'];
  grade?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  producedLocationId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  shrinkEventId: Scalars['String']['input'];
  shrinkType: ShrinkType;
};

/** Input for one inbound carrier STOP or START. */
export type RecordSmsCarrierOptOutInput = {
  /**
   * When the carrier says the reply happened. Stamped onto the user's block rather than measured from
   * this process's clock, so a webhook that queued still reports when the handset actually replied.
   */
  occurredAt: Scalars['DateTime']['input'];
  /** Which way the reply went: STOP stops the channel, START starts it again. */
  optOutType: SmsCarrierOptOutType;
  /**
   * The E.164 number the reply came from, matched EXACTLY against each user's verified number. Not the
   * number a user typed into their settings, which carries no consent and is never texted.
   */
  phoneNumber: Scalars['String']['input'];
  /**
   * The provider's handle for the inbound message, and the idempotency key. Twilio's inbound
   * MessageSid, or a stable key the caller built when it has no SID to hand. A redelivery
   * carrying a SID already applied in that direction changes nothing and reports ALREADY_APPLIED.
   */
  providerMessageSid: Scalars['String']['input'];
  /**
   * The tenant whose directory to match the number in. Supplied by the caller rather than taken from
   * the worker's token: see the mutation's remarks for why an inbound reply cannot be scoped that way.
   */
  tenantId: Scalars['String']['input'];
};

/** Result of recordSmsCarrierOptOut. */
export type RecordSmsCarrierOptOutResult = {
  __typename?: 'RecordSmsCarrierOptOutResult';
  /** How many users in the tenant hold that verified number. */
  matchedUsers: Scalars['Int']['output'];
  /** What happened to them. */
  outcome: SmsCarrierOptOutOutcome;
};

/** Input for recording one Twilio delivery-status webhook. */
export type RecordSmsDeliveryStatusInput = {
  /**
   * When Twilio says this happened. Stamped onto the row's deliveredAt for a delivery
   * confirmation; carried through unchanged rather than measured from this process's own clock.
   */
  occurredAt: Scalars['DateTime']['input'];
  /** Twilio's ErrorCode for this callback, when it reports one. */
  providerErrorCode?: InputMaybe<Scalars['Int']['input']>;
  /** The Twilio message SID the row's SMS block was stamped with when it was sent. */
  providerMessageId: Scalars['String']['input'];
  /**
   * Twilio's MessageStatus for this callback: queued, sending, sent,
   * delivered, undelivered, or failed. Any other value is treated the same as
   * the three that carry no actionable state change.
   */
  providerStatus: Scalars['String']['input'];
  /**
   * The tenant to look the row up in. Supplied by the caller rather than taken from the worker's
   * token: see the mutation's remarks for why a status callback cannot be scoped that way.
   */
  tenantId: Scalars['String']['input'];
};

/** What happened when one Twilio delivery-status webhook was applied. */
export enum RecordSmsDeliveryStatusOutcome {
  /**
   * A row was found but nothing changed: the provider status carried no actionable state change
   * (queued, sending, sent, or one this mutation does not recognise), the webhook was a repeat of
   * one already applied, or the row was already terminal Failed.
   */
  Ignored = 'IGNORED',
  /** No row in this tenant carries this provider message id. */
  NotFound = 'NOT_FOUND',
  /** The row's SMS block changed state. */
  Updated = 'UPDATED'
}

/** Result of recordSmsDeliveryStatus. */
export type RecordSmsDeliveryStatusResult = {
  __typename?: 'RecordSmsDeliveryStatusResult';
  /** Populated only when the write itself failed (a Mongo error). */
  errors?: Maybe<Array<ValidationError>>;
  /** What happened to the row. */
  outcome: RecordSmsDeliveryStatusOutcome;
  /** The row's resulting SMS status, or null when no row was found. */
  status?: Maybe<NotificationDeliveryStatus>;
};

export type RecordStopDeliveredInput = {
  loadId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orders: Array<StopOutcomeOrderQuantityDataInput>;
  routeStopId: Scalars['String']['input'];
};

export type RecordStopPartiallyDeliveredInput = {
  loadId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orders: Array<StopOutcomeOrderQuantityDataInput>;
  routeStopId: Scalars['String']['input'];
};

export type RecordStopRefusedInput = {
  loadId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orders: Array<StopOutcomeOrderQuantityDataInput>;
  routeStopId: Scalars['String']['input'];
};

/**
 * Boundary input for recordUserLastLogins: a batch of FusionAuth last-login instants for the
 * caller's tenant. Batched (not per-user) because the worker syncs a whole tenant per iteration and a
 * per-user mutation would mean N round-trips. Single-use Data type per the read-model/command
 * type-isolation convention already noted in UsersMutation.cs.
 */
export type RecordUserLastLoginsDataInput = {
  entries: Array<UserLastLoginEntryDataInput>;
};

/**
 * Result of recordUserLastLogins: the number of directory rows whose lastLoginAt was
 * actually moved forward. An entry whose fusionAuthUserId matches no directory row in the
 * caller's tenant, and an entry whose instant does not advance the stored value (the monotonic guard),
 * are both silently excluded from the count — neither is an error. A malformed
 * fusionAuthUserId IS an error and surfaces in errors.
 */
export type RecordUserLastLoginsPayload = {
  __typename?: 'RecordUserLastLoginsPayload';
  errors?: Maybe<Array<ValidationError>>;
  updatedCount: Scalars['Int']['output'];
};

/** Input of recordWhatsNewEmailBatchOutcome. */
export type RecordWhatsNewEmailBatchOutcomeInput = {
  /** The leased batch. */
  batchId: Scalars['String']['input'];
  /**
   * The claimedAt the claim returned for this batch. With it, the outcome changes the batch's status only while
   * that lease is the one holding it; the sent addresses are recorded either way. Without it, the outcome is not
   * pinned to a lease.
   */
  claimedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Why the attempt failed, when it did. */
  error?: InputMaybe<Scalars['String']['input']>;
  /** Recipients the worker sent to in this attempt. */
  sentEmails: Array<Scalars['String']['input']>;
  /** True closes the batch as sent; false puts it back for another attempt. */
  succeeded: Scalars['Boolean']['input'];
};

/** Result of recordWhatsNewEmailBatchOutcome. */
export type RecordWhatsNewEmailBatchOutcomePayload = {
  __typename?: 'RecordWhatsNewEmailBatchOutcomePayload';
  /** Why the outcome was refused, each with a code (UNKNOWN_BATCH for an unknown batch id); null when it was recorded. */
  errors?: Maybe<Array<ValidationError>>;
  /** True when the outcome was recorded; false when the call failed. */
  recorded: Scalars['Boolean']['output'];
};

/** Input for the refresh-order-tax-estimate mutation. */
export type RefreshOrderTaxEstimateInput = {
  /** The order to estimate. */
  orderId: Scalars['String']['input'];
};

/** Payload returned from the refresh-order-tax-estimate mutation. */
export type RefreshOrderTaxEstimatePayload = {
  __typename?: 'RefreshOrderTaxEstimatePayload';
  /** Populated only when the refresh was refused and nothing was stored. */
  errors?: Maybe<Array<ValidationError>>;
  /** The estimate as it stands after the refresh. */
  estimate?: Maybe<OrderTaxEstimatePayload>;
};

export type RefreshTenantEmailSenderStatusInput = {
  senderId: Scalars['String']['input'];
};

export type RefreshTenantIntegrationTokensInput = {
  accessToken: Scalars['String']['input'];
  accessTokenExpiration: Scalars['DateTime']['input'];
  integrationId: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  refreshTokenExpiration: Scalars['DateTime']['input'];
};

/** A refund grower finance staff ask for. No payer card or bank details are ever asked for. */
export type RefundOnlinePaymentInput = {
  /** The amount; null refunds everything the target still holds. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** The succeeded payment to refund. */
  attemptId: Scalars['String']['input'];
  /** Why. Required. */
  reason: Scalars['String']['input'];
  /**
   * Your id for this request. Required: make it once per refund you mean to make, and send the same id when you retry.
   * A retry of a request Stripe already answered asks Stripe nothing and answers with that refund; one Stripe never
   * answered asks again with the same idempotency key. Either way it can never refund twice.
   */
  refundRequestId: Scalars['String']['input'];
  /** PAYMENT refunds the payment; UNAPPLIED_CREDIT refunds only the credit it left. */
  target: PaymentAttemptRefundTarget;
};

/** The result of asking for a refund. */
export type RefundOnlinePaymentPayload = {
  __typename?: 'RefundOnlinePaymentPayload';
  /** Why it was refused, when it was. */
  errors?: Maybe<Array<ValidationError>>;
  /** The refund asked for: pending until Stripe confirms it; null on error. */
  refund?: Maybe<OnlinePaymentRefund>;
};

export type RegisterCountInput = {
  countSessionId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
};

export type RegisterDeviceInput = {
  assignedTenantId: Scalars['String']['input'];
  profile: DeviceProfile;
};

/**
 * registerDevice's payload. claimCode is the plaintext claim code, disclosed here and
 * never stored (only its hash is, on the aggregate). No QUERY returns it, and the only other mutation
 * that ever returns one is reissueDeviceClaimCode, which mints a REPLACEMENT for a device still
 * in the lobby — it discloses the new code, never this one. The caller (admin/factory tooling) must
 * capture it here.
 *
 * credential is the device's IoT Hub connection credential and follows exactly the same rule:
 * issued once, here, and never recoverable. It is deliberately on THIS payload rather than
 * claimDevice's — registration is the factory-side, SuperAdmin-gated step that flashes a physical
 * unit, so key material never reaches the ordinary tenant user who later claims the device.
 */
export type RegisterDevicePayload = {
  __typename?: 'RegisterDevicePayload';
  claimCode?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<DeviceCredentialData>;
  device?: Maybe<DeviceStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * Input registering a member firm or updating an already-registered firm's label and classification facets
 * on a GrowerBenchmark community (contract C7).
 */
export type RegisterGrowerBenchmarkFirmInput = {
  /** Optional cohort classification facets. */
  classification?: InputMaybe<Array<GrowerBenchmarkClassificationFacetInput>>;
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Stable firm identifier within the community. */
  firmId: Scalars['String']['input'];
  /** Optional neutral peer-row code; defaults to firmId on first registration. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Reporting units registered under the firm. */
  reportingUnits: Array<GrowerBenchmarkReportingUnitInput>;
  /** Owning WorkSuite tenant identifier of the firm. */
  tenantId: Scalars['String']['input'];
};

/**
 * Input for registerMyPushSubscription — the three values a browser's PushSubscription
 * carries. Whose device it is comes from the token, never from here.
 */
export type RegisterMyPushSubscriptionInput = {
  /**
   * Which installed app is registering: a lowercase module key, or worksuite for the root install.
   * Optional; omitting it leaves any stored value unchanged.
   */
  appKey?: InputMaybe<Scalars['String']['input']>;
  /** The device's auth secret, base64url, as the browser reported it. */
  auth: Scalars['String']['input'];
  /** Whether the client runs as an installed app or in a browser tab. Optional. */
  displayMode?: InputMaybe<PushDisplayMode>;
  /** The push service URL the browser issued for this device. */
  endpoint: Scalars['String']['input'];
  /** The device's P-256 ECDH public key, base64url, as the browser reported it. */
  p256dh: Scalars['String']['input'];
  /** The client's platform family. Optional. */
  platform?: InputMaybe<PushPlatform>;
};

/** One completed upload to register for preparation. */
export type RegisterOnboardingUploadInput = {
  /** The journey id start or resume returned. */
  journeyId: Scalars['String']['input'];
  /** The chat session; the turn and sent message only when fernie registers it. */
  routing: OnboardingJourneyRoutingInput;
  /** The source id the upload returned. Null for an upload recorded before uploads kept versions. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** The source version the upload returned. Null for an upload recorded before uploads kept versions. */
  sourceVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type ReissueDeviceClaimCodeInput = {
  serial: Scalars['String']['input'];
};

/**
 * reissueDeviceClaimCode's payload. claimCode is the plaintext, disclosed HERE and
 * nowhere else — only its hash reaches the aggregate, and no query returns either. A code not
 * captured from this one response is unrecoverable, exactly as at registration.
 */
export type ReissueDeviceClaimCodePayload = {
  __typename?: 'ReissueDeviceClaimCodePayload';
  claimCode?: Maybe<Scalars['String']['output']>;
  device?: Maybe<DeviceStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Input of rejectProducedQuantityEntry. A reason is required. */
export type RejectProducedQuantityEntryInput = {
  /** The held entry to reject. */
  entryId: Scalars['UUID']['input'];
  /** The job the entry is on. */
  productionJobId: Scalars['String']['input'];
  /** The lot the job belongs to. */
  productionLotId: Scalars['String']['input'];
  /** Why it is rejected. */
  reason: Scalars['String']['input'];
};

export type ReleaseAllocationInput = {
  allocationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/**
 * A nominated set of component builds — what a QA run is judging when it carries a candidate id.
 *
 * wsapi does not own this. relman nominates candidates and knows their lineage; this type is the
 * read-only shape wsapi renders so the QA dashboard can answer "which build was this run about"
 * without the dashboard talking to two services. It is reached only through the release
 * candidate source seam, and in this slice the only registered source is a mock —
 * Release QA 5 swaps in the live relman adapter behind config without touching this type or the
 * query that returns it.
 */
export type ReleaseCandidate = {
  __typename?: 'ReleaseCandidate';
  /** Commit sha of the coverage catalog the expected set below was cut from. */
  catalogRevision: Scalars['String']['output'];
  components: Array<ReleaseComponent>;
  /** Environment the candidate is nominated into — stage or red. */
  environment: Scalars['String']['output'];
  /** Scenarios a run judging this candidate is expected to exercise. */
  expectedScenarioIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nominatedAt: Scalars['DateTime']['output'];
  /** Role that nominated it, not the person: candidates outlive individuals. */
  nominatedByRole: Scalars['String']['output'];
  /**
   * What production was running before this candidate — the baseline a reviewer compares
   * against when deciding whether a failure is a regression or pre-existing.
   */
  priorProductionComponents: Array<ReleaseComponent>;
  status: ReleaseCandidateStatus;
  /** The candidate that replaced this one, when it was superseded. */
  supersededById?: Maybe<Scalars['ID']['output']>;
  /** The candidate this one replaced. */
  supersedesId?: Maybe<Scalars['ID']['output']>;
};

/** Where a candidate sits in the release lifecycle. */
export enum ReleaseCandidateStatus {
  /** Put forward for release; the run that judges it may not have finished. */
  Nominated = 'NOMINATED',
  /** It went to production. */
  Shipped = 'SHIPPED',
  /** A newer candidate replaced it before it shipped. */
  Superseded = 'SUPERSEDED',
  /** It was pulled without shipping and without a replacement. */
  Withdrawn = 'WITHDRAWN'
}

/** One repository's build within a candidate. */
export type ReleaseComponent = {
  __typename?: 'ReleaseComponent';
  branch?: Maybe<Scalars['String']['output']>;
  buildId?: Maybe<Scalars['String']['output']>;
  commit?: Maybe<Scalars['String']['output']>;
  deployedAt?: Maybe<Scalars['DateTime']['output']>;
  repo: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/** GraphQL input for releaseErpWriteBack. ClaimToken is the token the claim returned. */
export type ReleaseErpWriteBackInput = {
  claimToken: Scalars['String']['input'];
  erpWriteBackId: Scalars['String']['input'];
};

export type ReleaseInventoryHoldInput = {
  customerItemId: Scalars['String']['input'];
  grade: Scalars['Int']['input'];
  idempotencyKey: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ReleaseOrderHoldInput = {
  orderId: Scalars['String']['input'];
};

/** The result of releaseOrphanedOrderAllocations. */
export type ReleaseOrphanedOrderAllocationsPayload = {
  __typename?: 'ReleaseOrphanedOrderAllocationsPayload';
  /** Whether the run only reported. */
  dryRun: Scalars['Boolean']['output'];
  /** Why the run was refused, when it was. */
  errors?: Maybe<Array<ValidationError>>;
  /** Every release, planned or written. */
  releases: Array<OrphanedOrderAllocationReleaseData>;
};

export type RemoveBillingAddressInput = {
  addressId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};

export type RemoveBlockingRuleLinkedItemsInput = {
  blockingRuleId: Scalars['String']['input'];
  linkedItemIds: Array<Scalars['String']['input']>;
};

export type RemoveBlockingRuleLinkedLocationsInput = {
  blockingRuleId: Scalars['String']['input'];
  linkedLocationIds: Array<Scalars['String']['input']>;
};

export type RemoveCategoryInput = {
  code: Scalars['String']['input'];
};

export type RemoveContactInput = {
  contactId: Scalars['UUID']['input'];
  customerId: Scalars['String']['input'];
};

export type RemoveContainerConfigFromConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
};

export type RemoveImportRowsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rowIndexes: Array<Scalars['Int']['input']>;
};

/** Removes an allowed sender. */
export type RemoveInboundAllowedSenderInput = {
  /** The id of the sender to remove. */
  allowedSenderId: Scalars['String']['input'];
};

export type RemoveItemAvailabilityPhotoInput = {
  itemId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  photoId: Scalars['String']['input'];
};

export type RemoveItemMinShipQtyInput = {
  itemId: Scalars['String']['input'];
};

export type RemoveItemRoyaltyInput = {
  itemId: Scalars['String']['input'];
};

export type RemoveItemSubstitutionInput = {
  itemId: Scalars['String']['input'];
};

export type RemoveLineItemAllocationsInput = {
  lineItemIds: Array<Scalars['UUID']['input']>;
  orderId: Scalars['String']['input'];
};

export type RemoveLineItemInput = {
  id: Scalars['UUID']['input'];
  lineNumber: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
};

export type RemoveLocationInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['UUID']['input'];
};

export type RemoveMasterLineItemInput = {
  id: Scalars['UUID']['input'];
  lineNumber: Scalars['Int']['input'];
  masterOrderId: Scalars['String']['input'];
};

/**
 * Input for removeMyPushSubscription. The endpoint only — whose device it is comes from the
 * token.
 */
export type RemoveMyPushSubscriptionInput = {
  /** The endpoint to retire. */
  endpoint: Scalars['String']['input'];
};

export type RemoveOrderFlatChargeInput = {
  flatChargeId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type RemoveOrderLineUpgradeInput = {
  lineItemId: Scalars['String']['input'];
  lineItemUpgradeId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type RemoveParentCompanyAdministratorInput = {
  fusionAuthUserId: Scalars['String']['input'];
  parentCompanyId: Scalars['String']['input'];
};

export type RemovePortalCustomDomainInput = {
  domain: Scalars['String']['input'];
};

export type RemoveProductionMaterialEventDetailInput = {
  productionMaterialEventDetailId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type RemoveProductionMaterialEventFromCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type RemoveProductionMaterialEventFromJobDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type RemoveProductionRecipeVariationInput = {
  productionRecipeId: Scalars['String']['input'];
  variationId: Scalars['String']['input'];
};

export type RemoveProductionSpaceEventDetailInput = {
  productionSpaceEventDetailId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type RemoveProductionSpaceEventFromCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type RemoveProductionSpaceEventFromJobDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type RemoveProductionTaskEventDetailInput = {
  productionTaskEventDetailId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type RemoveProductionTaskEventFromCategoryInput = {
  productionCategoryId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type RemoveProductionTaskEventFromItemInput = {
  productionItemId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type RemoveProductionTaskEventFromJobDataInput = {
  productionJobId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type RemovePromotionRuleLinkedItemsInput = {
  linkedItemIds: Array<Scalars['String']['input']>;
  promotionRuleId: Scalars['String']['input'];
};

export type RemovePromotionRuleLinkedLocationsInput = {
  linkedLocationIds: Array<Scalars['String']['input']>;
  promotionRuleId: Scalars['String']['input'];
};

export type RemovePurchaseOrderLineItemInput = {
  lineItemId: Scalars['String']['input'];
  purchaseOrderId: Scalars['String']['input'];
};

/**
 * Input for removePushSubscriptionForWorker. The tenant comes from the worker's token, never
 * from here.
 */
export type RemovePushSubscriptionForWorkerInput = {
  /** The endpoint the push service rejected as gone. */
  endpoint: Scalars['String']['input'];
};

/** Result of retiring a device. */
export type RemovePushSubscriptionPayload = {
  __typename?: 'RemovePushSubscriptionPayload';
  /** Populated only when the removal itself failed. */
  errors?: Maybe<Array<ValidationError>>;
  /** Whether a registration was actually removed. */
  removed: Scalars['Boolean']['output'];
};

export type RemoveReserveRuleLinkedItemsInput = {
  linkedItemIds: Array<Scalars['String']['input']>;
  reserveRuleId: Scalars['String']['input'];
};

export type RemoveReserveRuleLinkedLocationsInput = {
  linkedLocationIds: Array<Scalars['String']['input']>;
  reserveRuleId: Scalars['String']['input'];
};

export type RemoveSftpDestinationInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
};

export type RemoveSftpMongoDestinationInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
};

export type RemoveShrinkEventDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  shrinkEventId: Scalars['String']['input'];
};

export type RemoveSizeUomFromConfigCategoryInput = {
  configCategoryId: Scalars['String']['input'];
  sizeUomCode: Scalars['String']['input'];
};

export type RemoveSpaceCapacityWindowInput = {
  endWeek: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
  spaceTypeId: Scalars['String']['input'];
  startWeek: Scalars['Int']['input'];
  subLocationId: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type RemoveSpaceTypeCapacityInput = {
  siteLocationId: Scalars['String']['input'];
  spaceTypeId: Scalars['String']['input'];
  subLocationId: Scalars['String']['input'];
};

export type RemoveSubLocationInput = {
  acknowledgeInUse: Scalars['Boolean']['input'];
  locationId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type RemoveTenantEmailSenderInput = {
  senderId: Scalars['String']['input'];
};

export type RemoveTimeEntryInput = {
  taskAssignmentId: Scalars['String']['input'];
  timeEntryId: Scalars['String']['input'];
};

export type RemoveVendorPurchaseOrderChargeInput = {
  chargeId: Scalars['String']['input'];
  purchaseOrderId: Scalars['String']['input'];
};

export type RemoveVerifyContainerInput = {
  containerId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  removedBy: Scalars['String']['input'];
};

export type RemoveWsapiImportEntityMappingInput = {
  entityMappingId: Scalars['String']['input'];
  wsapiImportId: Scalars['String']['input'];
};

export type RemovedVariationProjection = {
  __typename?: 'RemovedVariationProjection';
  completedEventCount: Scalars['Int']['output'];
  plannedEventCount: Scalars['Int']['output'];
  variationId: Scalars['String']['output'];
  variationName: Scalars['String']['output'];
};

export type RenameCategoryInput = {
  code: Scalars['String']['input'];
  newCode: Scalars['String']['input'];
};

export type RenameDeviceInput = {
  deviceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type RenameReportFolderInput = {
  folderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type RenameVolumePoolInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum RenderDocType {
  Acknowledgement = 'ACKNOWLEDGEMENT',
  Credit = 'CREDIT',
  Invoice = 'INVOICE'
}

export enum RenderMode {
  Legacy = 'LEGACY',
  Parallel = 'PARALLEL',
  ReportEngine = 'REPORT_ENGINE'
}

/** Renews the claim the caller holds on one preparation job or import run. */
export type RenewMigrationClaimInput = {
  claimToken: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type ReopenProductionJobDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type ReorderItemAvailabilityPhotosInput = {
  itemId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  photoIds: Array<Scalars['String']['input']>;
};

/** Names one record whose handoff was left undone. */
export type RepairMigrationHandoffInput = {
  id: Scalars['String']['input'];
};

/** One job whose reservation peg to repair, named by its lot and job. */
export type RepairProductionJobReservationPegJobInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

/**
 * One job's repair outcome: the reservation peg stage after the repair and the target it was held to, or
 * the job's errors. reservationPeg is UNKNOWN when the job could not be read, and PENDING with an error
 * when the peg append failed again.
 */
export type RepairProductionJobReservationPegResult = {
  __typename?: 'RepairProductionJobReservationPegResult';
  errors?: Maybe<Array<ValidationError>>;
  productionJobId: Scalars['String']['output'];
  productionLotId: Scalars['String']['output'];
  reservationPeg: ProductionPostingStageStatus;
  reservationPeggedQuantity?: Maybe<Scalars['Int']['output']>;
};

/** Jobs whose pending reservation peg to apply again, at most 500 per call, each named once. */
export type RepairProductionJobReservationPegsInput = {
  jobs: Array<RepairProductionJobReservationPegJobInput>;
};

/**
 * Results in request order. Top-level errors reject the whole batch before any job is read (size cap, site
 * scope, a job named twice).
 */
export type RepairProductionJobReservationPegsPayload = {
  __typename?: 'RepairProductionJobReservationPegsPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<RepairProductionJobReservationPegResult>;
};

export type ReplaceCustomerSalesPeopleInput = {
  customerId: Scalars['String']['input'];
  salesPeopleEmails: Array<Scalars['String']['input']>;
};

export type ReplaceErpLoadListRoutesInput = {
  routeCodes: Array<Scalars['String']['input']>;
};

export type ReplaceSalesPeopleInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['UUID']['input'];
  salesPeopleEmails: Array<Scalars['String']['input']>;
};

export type ReplaceSpaceCapacityWindowInput = {
  amount: Scalars['Decimal']['input'];
  endWeek: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  oldAmount: Scalars['Decimal']['input'];
  oldEndWeek: Scalars['Int']['input'];
  oldNotes?: InputMaybe<Scalars['String']['input']>;
  oldReliefFraction: Scalars['Decimal']['input'];
  oldSpaceTypeId: Scalars['String']['input'];
  oldStartWeek: Scalars['Int']['input'];
  oldSubLocationId: Scalars['String']['input'];
  oldYear?: InputMaybe<Scalars['Int']['input']>;
  reliefFraction: Scalars['Decimal']['input'];
  siteLocationId: Scalars['String']['input'];
  spaceTypeId: Scalars['String']['input'];
  startWeek: Scalars['Int']['input'];
  subLocationId: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** The tenants whose dead-lettered customer items are replayed, and whether to write. */
export type ReplayDeadLetteredCustomerItemsInput = {
  /** When true, reports what a run would do and writes nothing at all. */
  dryRun: Scalars['Boolean']['input'];
  /** At least one tenant. Only these tenants' dead letters are read or replayed. */
  tenantIds: Array<Scalars['String']['input']>;
};

/**
 * What one replay run did, or on a dry run would do. runId names the run's audit records and is
 * null on a dry run, which writes none.
 */
export type ReplayDeadLetteredCustomerItemsPayload = {
  __typename?: 'ReplayDeadLetteredCustomerItemsPayload';
  /** False when the time budget stopped the run before it reached every stream. */
  complete: Scalars['Boolean']['output'];
  /** The counts of each customer the replayed streams belong to. */
  customers: Array<CustomerItemReplayCounts>;
  /** Whether this run wrote nothing. */
  dryRun: Scalars['Boolean']['output'];
  /** Why the run did not start, when it did not. */
  errors?: Maybe<Array<ValidationError>>;
  /** Every stream that could not be read or applied, with the reason. */
  failures: Array<CustomerItemReplayFailure>;
  /** The streams the run never reached because its time budget ran out. */
  notReached: Scalars['Int']['output'];
  /** The run's id, which names one audit record per tenant; null on a dry run. */
  runId?: Maybe<Scalars['String']['output']>;
  /** Every stream skipped because its customer, ship-to or item has since been combined away, deleted or deactivated. */
  skippedCombinedOrDeleted: Array<CustomerItemReplaySkip>;
  /** Every stream skipped because applying it would also write a collection other than CustomerItems. */
  skippedWouldWriteOtherCollection: Array<CustomerItemReplaySkip>;
  /** The counts of each requested tenant. */
  tenants: Array<CustomerItemReplayCounts>;
};

/** The exception to replay once its cause is resolved. */
export type ReplayOnlinePaymentExceptionInput = {
  /** The exception's id. */
  exceptionId: Scalars['String']['input'];
};

/** The result of replaying an exception. */
export type ReplayOnlinePaymentExceptionPayload = {
  __typename?: 'ReplayOnlinePaymentExceptionPayload';
  /** Why it could not be replayed, when it could not. */
  errors?: Maybe<Array<ValidationError>>;
  /** The exception as it stands after the replay; null on error. */
  exception?: Maybe<OnlinePaymentException>;
  /** What processing its event again did; null on error. */
  outcome?: Maybe<StripePaymentEventOutcome>;
};

/**
 * One group header for the Restock Rules sidebar: the group's Key (the canonical
 * GraphQL enum name, also used verbatim as the where eq value when lazy-loading the
 * group's children via replenishmentRules), a display Label, and the
 * server-computed Count of rules in the group under the active search.
 */
export type ReplenishmentRuleGroupBucket = {
  __typename?: 'ReplenishmentRuleGroupBucket';
  /** Number of rules in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /**
   * Canonical (SCREAMING_SNAKE_CASE) group key — the GraphQL enum value the
   * replenishmentRules list where filter expects as its eq argument.
   */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for replenishmentRuleGroups. Mirrors the Restock Rules sidebar's
 * group-by options so the client can render server-computed group headers instead of grouping the
 * full rule set in memory: Status buckets on the rule's lifecycle status, RuleType
 * buckets on the rule's strategy (Blocking / Promotion / Reserve). Both are flat scalar fields on
 * the ReplenishmentRuleSummaryDocument read model that map directly to the
 * replenishmentRules list where filter.
 */
export enum ReplenishmentRuleGroupField {
  /** One bucket per distinct rule strategy (BLOCKING, PROMOTION, RESERVE). */
  RuleType = 'RULE_TYPE',
  /** One bucket per distinct rule lifecycle status (e.g. ACTIVE, INACTIVE). */
  Status = 'STATUS'
}

export type ReplenishmentRuleSummaryDocument = {
  __typename?: 'ReplenishmentRuleSummaryDocument';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  itemCount: Scalars['Int']['output'];
  level: ReserveRuleLevel;
  linkedItemIds: Array<Scalars['String']['output']>;
  linkedLocationIds: Array<Scalars['String']['output']>;
  locationCount: Scalars['Int']['output'];
  mode: ReserveRuleMode;
  name: Scalars['String']['output'];
  percentage: Scalars['Decimal']['output'];
  quantityFloor: Scalars['Int']['output'];
  ruleId: Scalars['String']['output'];
  ruleType: ReplenishmentRuleSummaryType;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: ReplenishmentRuleSummaryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type ReplenishmentRuleSummaryDocumentFilterInput = {
  and?: InputMaybe<Array<ReplenishmentRuleSummaryDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemCount?: InputMaybe<IntOperationFilterInput>;
  level?: InputMaybe<ReserveRuleLevelOperationFilterInput>;
  linkedItemIds?: InputMaybe<ListStringOperationFilterInput>;
  linkedLocationIds?: InputMaybe<ListStringOperationFilterInput>;
  locationCount?: InputMaybe<IntOperationFilterInput>;
  mode?: InputMaybe<ReserveRuleModeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReplenishmentRuleSummaryDocumentFilterInput>>;
  percentage?: InputMaybe<DecimalOperationFilterInput>;
  quantityFloor?: InputMaybe<IntOperationFilterInput>;
  ruleId?: InputMaybe<StringOperationFilterInput>;
  ruleType?: InputMaybe<ReplenishmentRuleSummaryTypeOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ReplenishmentRuleSummaryStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type ReplenishmentRuleSummaryDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCount?: InputMaybe<SortEnumType>;
  level?: InputMaybe<SortEnumType>;
  locationCount?: InputMaybe<SortEnumType>;
  mode?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  percentage?: InputMaybe<SortEnumType>;
  quantityFloor?: InputMaybe<SortEnumType>;
  ruleId?: InputMaybe<SortEnumType>;
  ruleType?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export enum ReplenishmentRuleSummaryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ReplenishmentRuleSummaryStatusOperationFilterInput = {
  eq?: InputMaybe<ReplenishmentRuleSummaryStatus>;
  in?: InputMaybe<Array<ReplenishmentRuleSummaryStatus>>;
  neq?: InputMaybe<ReplenishmentRuleSummaryStatus>;
  nin?: InputMaybe<Array<ReplenishmentRuleSummaryStatus>>;
};

export enum ReplenishmentRuleSummaryType {
  Blocking = 'BLOCKING',
  Promotion = 'PROMOTION',
  Reserve = 'RESERVE',
  Unknown = 'UNKNOWN'
}

export type ReplenishmentRuleSummaryTypeOperationFilterInput = {
  eq?: InputMaybe<ReplenishmentRuleSummaryType>;
  in?: InputMaybe<Array<ReplenishmentRuleSummaryType>>;
  neq?: InputMaybe<ReplenishmentRuleSummaryType>;
  nin?: InputMaybe<Array<ReplenishmentRuleSummaryType>>;
};

/** A connection to a list of items. */
export type ReplenishmentRulesConnection = {
  __typename?: 'ReplenishmentRulesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReplenishmentRulesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReplenishmentRuleSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReplenishmentRulesEdge = {
  __typename?: 'ReplenishmentRulesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReplenishmentRuleSummaryDocument;
};

export type ReplenishmentSettingsDocument = {
  __typename?: 'ReplenishmentSettingsDocument';
  allocationPriorities: Array<AllocationPriorityDimension>;
  allocationReservationPercentage: Scalars['Decimal']['output'];
  allocationType: AllocationType;
  defaultTargetWeeksOfSupply: Scalars['Decimal']['output'];
  forwardDaysLastYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  inventoryTrailingDays: Scalars['Int']['output'];
  minUsableDaysThreshold?: Maybe<Scalars['Int']['output']>;
  roundToFullCart: Scalars['Boolean']['output'];
  sellThroughThreshold?: Maybe<Scalars['Decimal']['output']>;
  shipmentIncrement: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  trailingDaysThisYear: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ReplenishmentSettingsDocumentFilterInput = {
  allocationPriorities?: InputMaybe<ListAllocationPriorityDimensionOperationFilterInput>;
  allocationReservationPercentage?: InputMaybe<DecimalOperationFilterInput>;
  allocationType?: InputMaybe<AllocationTypeOperationFilterInput>;
  and?: InputMaybe<Array<ReplenishmentSettingsDocumentFilterInput>>;
  defaultTargetWeeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
  forwardDaysLastYear?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inventoryTrailingDays?: InputMaybe<IntOperationFilterInput>;
  minUsableDaysThreshold?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ReplenishmentSettingsDocumentFilterInput>>;
  roundToFullCart?: InputMaybe<BooleanOperationFilterInput>;
  sellThroughThreshold?: InputMaybe<DecimalOperationFilterInput>;
  shipmentIncrement?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  trailingDaysThisYear?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ReplenishmentSettingsDocumentSortInput = {
  allocationReservationPercentage?: InputMaybe<SortEnumType>;
  allocationType?: InputMaybe<SortEnumType>;
  defaultTargetWeeksOfSupply?: InputMaybe<SortEnumType>;
  forwardDaysLastYear?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inventoryTrailingDays?: InputMaybe<SortEnumType>;
  minUsableDaysThreshold?: InputMaybe<SortEnumType>;
  roundToFullCart?: InputMaybe<SortEnumType>;
  sellThroughThreshold?: InputMaybe<SortEnumType>;
  shipmentIncrement?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  trailingDaysThisYear?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ReplenishmentSettingsPayload = {
  __typename?: 'ReplenishmentSettingsPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<ReplenishmentSettingsStateData>;
};

export type ReplenishmentSettingsStateData = {
  __typename?: 'ReplenishmentSettingsStateData';
  allocationPriorities: Array<AllocationPriorityDimension>;
  allocationReservationPercentage: Scalars['Decimal']['output'];
  allocationType: AllocationType;
  defaultTargetWeeksOfSupply: Scalars['Decimal']['output'];
  forwardDaysLastYear: Scalars['Int']['output'];
  inventoryTrailingDays: Scalars['Int']['output'];
  minUsableDaysThreshold?: Maybe<Scalars['Int']['output']>;
  programWindowConfigs: Array<ProgramWindowConfigStateData>;
  roundToFullCart: Scalars['Boolean']['output'];
  sellThroughThreshold?: Maybe<Scalars['Decimal']['output']>;
  shipmentIncrement: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  trailingDaysThisYear: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ReplenishmentUnit {
  Eaches = 'EACHES',
  Trays = 'TRAYS'
}

export type ReplenishmentUnitOperationFilterInput = {
  eq?: InputMaybe<ReplenishmentUnit>;
  in?: InputMaybe<Array<ReplenishmentUnit>>;
  neq?: InputMaybe<ReplenishmentUnit>;
  nin?: InputMaybe<Array<ReplenishmentUnit>>;
};

export type RepointProductionRecipeLinksInput = {
  productionRecipeId: Scalars['String']['input'];
  targetProductionRecipeId: Scalars['String']['input'];
};

/**
 * Per-recipe results in the order the linking-pair query lists them. Top-level Errors carries the
 * whole-call rejections raised before any recipe is touched — source or target recipe not found, the
 * two being the same recipe or the same pair, the target not an Active start recipe — and the marker
 * that the request was cancelled part-way. A rejection leaves Results empty; a cancelled run leaves in
 * Results every recipe it actually processed, so a short list is never silently read as a complete report.
 */
export type RepointProductionRecipeLinksPayload = {
  __typename?: 'RepointProductionRecipeLinksPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<RepointProductionRecipeLinksResult>;
};

/** One linking recipe's outcome, keyed by recipe id so the caller can map it back to the list it was shown. */
export type RepointProductionRecipeLinksResult = {
  __typename?: 'RepointProductionRecipeLinksResult';
  errors?: Maybe<Array<ValidationError>>;
  productionRecipeId: Scalars['String']['output'];
  status: RepointProductionRecipeLinksStatus;
};

/** How one linking recipe's step of a link re-point ended. */
export enum RepointProductionRecipeLinksStatus {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Skipped = 'SKIPPED'
}

export enum ReportAccess {
  Open = 'OPEN',
  Owned = 'OWNED'
}

export type ReportAccessOperationFilterInput = {
  eq?: InputMaybe<ReportAccess>;
  in?: InputMaybe<Array<ReportAccess>>;
  neq?: InputMaybe<ReportAccess>;
  nin?: InputMaybe<Array<ReportAccess>>;
};

/** Address data for billing or shipping on report output. */
export type ReportAddressData = {
  __typename?: 'ReportAddressData';
  attention?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  /** Ship To only: the ship-to's location code. Empty when it has none, and always empty on Bill To. */
  code: Scalars['String']['output'];
  /**
   * Ship To only: that contact's first email address. Empty when there is no contact or it has no
   * email, and always empty on Bill To.
   */
  contactEmail: Scalars['String']['output'];
  /**
   * Ship To only: the name of the ship-to's effective contact, which is its own default contact,
   * else the customer's Primary contact. Null when there is none, and always null on Bill To.
   */
  contactName?: Maybe<Scalars['String']['output']>;
  /** Ship To only: that contact's first phone number. Null when it has none. */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** Ship To only: the ship-to address's country code. Empty when it has none, and always empty on Bill To. */
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * Ship To only: the ship-to's own receiving email, where its delivery notices go. A combined ship-to
   * holds the survivor's. Null when it has none or its customer can't be read, and always null on Bill To.
   * Not the Ship To contact's email (ContactEmail).
   */
  receivingEmail?: Maybe<Scalars['String']['output']>;
  /**
   * Ship To only: when that receiving window ends, HH:mm in the store's local time. Null when there is
   * no window, and always null on Bill To.
   */
  receivingWindowEnd?: Maybe<Scalars['String']['output']>;
  /**
   * Ship To only: when the ship-to's receiving window in effect starts, HH:mm in the store's local time.
   * The ship-to's own window, else its customer's. Null when neither has one, and always null on Bill To.
   */
  receivingWindowStart?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  /** Ship To only: the ship-to's store number. Empty when it has none, and always empty on Bill To. */
  storeNumber: Scalars['String']['output'];
  street: Scalars['String']['output'];
  /**
   * Second address line (AddressData.AddressLine2); empty when unused. The legacy address
   * block renders this beneath street.
   */
  street2: Scalars['String']['output'];
  /**
   * Ship To only: the minutes a delivery to the ship-to takes to unload. The ship-to's own, else its
   * customer's. Null when neither has them, and always null on Bill To.
   */
  unloadMinutes?: Maybe<Scalars['Int']['output']>;
  zip: Scalars['String']['output'];
};

/**
 * One item-at-location-and-grade row with stock available to sell, read from the inventory
 * ledger. The grain is the item LOCATION and grade, not the item: an item stocked at four
 * locations contributes four rows, and the builder groups on the item columns to roll up to
 * item level.
 *
 * The grain is also what makes the Notes column possible — notes live on the inventory row,
 * and the item-summary read model has no comment field at all, so an item-grain source could
 * not carry notes.
 */
export type ReportAvailabilityData = {
  __typename?: 'ReportAvailabilityData';
  /**
   * Gets the item's primary category, joined from the item read model. Empty when the item
   * has no categories or its summary row is missing.
   */
  category: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 1. Empty when the column is not bound or the item has no value. */
  characteristic1: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 1. Empty when the column is not bound. */
  characteristic1Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 2. Empty when the column is not bound or the item has no value. */
  characteristic2: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 2. Empty when the column is not bound. */
  characteristic2Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 3. Empty when the column is not bound or the item has no value. */
  characteristic3: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 3. Empty when the column is not bound. */
  characteristic3Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 4. Empty when the column is not bound or the item has no value. */
  characteristic4: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 4. Empty when the column is not bound. */
  characteristic4Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 5. Empty when the column is not bound or the item has no value. */
  characteristic5: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 5. Empty when the column is not bound. */
  characteristic5Name: Scalars['String']['output'];
  /** Gets how many eaches one unit of the shipping unit holds. Null when the item has no unit. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * Gets a value indicating whether this row OPENS a run of rows for the same item — true on the
   * first of an item's locations, so a template can print an item header above them.
   */
  firstOfItem: Scalars['Boolean']['output'];
  /** Gets the grade the stock is held at. Null for gradeless stock. */
  grade?: Maybe<Scalars['Int']['output']>;
  /** Gets the item identifier. */
  itemId: Scalars['String']['output'];
  /** Gets the item's current name. */
  itemName: Scalars['String']['output'];
  /**
   * Gets the item's available quantity across every location in its run, carried on EVERY row of
   * that run so a template may print the figure in the section header as readily as its footer.
   */
  itemQuantityTotal: Scalars['Decimal']['output'];
  /**
   * Gets the item band's unit total: the item band total over the eaches per unit, cut
   * at two decimals. Null when the item has no named unit. A band is one item, so its rows always share
   * one pack.
   */
  itemQuantityUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets a value indicating whether this row CLOSES a run of rows for the same item — true on the
   * last of an item's locations, so a template can print the item's subtotal beneath them.
   */
  lastOfItem: Scalars['Boolean']['output'];
  /**
   * Gets the location identifier the stock is held at. Normally a sub-location (a bay or bench),
   * but stock held against a whole site carries that site's identifier instead.
   */
  locationId: Scalars['String']['output'];
  /**
   * Gets the location name, joined at query time with the same precedence the Inventory source
   * uses: the sub-location's name when the stock is held at one, otherwise the site
   * location's. Falls back to empty when the location has been deleted or never existed, so a
   * row is never dropped just because its location cannot be named.
   */
  locationName: Scalars['String']['output'];
  /**
   * Gets a value indicating whether the item is a native plant species, joined from the item
   * read model. False when the item's summary row is missing, matching the domain default —
   * an unjoinable row reports "not native" rather than dropping out of the report.
   */
  native: Scalars['Boolean']['output'];
  /**
   * Gets the most recent note on the inventory row — surfaced in the report builder as the
   * "Notes" column. Empty when the row has no note; such rows still appear, they simply render
   * a blank cell.
   */
  notes: Scalars['String']['output'];
  /**
   * Gets a value indicating whether any returned row has a named unit. The same on every row, so a
   * template can show its units columns for the whole page, header and total rows included, and leave them
   * out entirely when every item is counted in eaches.
   */
  pageHasUnits: Scalars['Boolean']['output'];
  /**
   * Gets the unit price this item resolves to today, quoted through the same pricing engine an
   * order uses. The pricing context comes from the report's priceGroupId / customerId parameters
   * — an explicit price group wins, otherwise the named customer's group, otherwise the tenant's
   * default group. It is never taken from the row's own location, which is a physical inventory
   * location and not a customer ship-to.
   *
   * Quoted at quantity 1 and at today's date, so quantity breaks are evaluated at a single unit:
   * an availability sheet quotes a unit price, not the price of buying the whole stand.
   *
   *
   * Zero when no price level matches the item in the resolved group, which is the amount a newly
   * added order line would be charged (OrderExtensions.RecomputeFromContract) — the cell
   * renders 0 rather than blank, and the row is never filtered out for it. Repricing is the one
   * exception: an already-priced line treats a zero resolution as "no contract price found" and
   * keeps its existing price (OrderRepricing Rule 2), so a 0 here does not mean an existing
   * line would be repriced to 0.
   */
  price: Scalars['Decimal']['output'];
  /** Gets the quantity available to sell: on hand less allocated, in whole units. */
  quantity: Scalars['Int']['output'];
  /**
   * Gets the quantity as one string, 2 (4.5 inch tray) · 30 ea, or the bare each count when the
   * item has no named unit.
   */
  quantityText: Scalars['String']['output'];
  /**
   * Gets the quantity over the eaches per unit, cut toward zero at two decimals. Null
   * when the item has no unit.
   */
  quantityUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets when the inventory row last changed. */
  recordedAt: Scalars['DateTime']['output'];
  /** Gets the user who last changed the inventory row. */
  recordedBy: Scalars['String']['output'];
  /**
   * Gets the name of the Shipping UOM the item ships as today, for example 4.5 inch tray. Null when
   * the item has no unit (a pack of one or an unstated pack) or its Shipping UOM has no name.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the item's primary size code, joined from the item read model. Empty when the item
   * has no sizes or its summary row is missing.
   */
  size: Scalars['String']['output'];
  /** Gets the SKU on the inventory row, or the item's when the row carries none. */
  sku: Scalars['String']['output'];
  /** Gets the item's current UPC. */
  upc: Scalars['String']['output'];
};

/** Payload wrapper for the reportAvailabilityData query. */
export type ReportAvailabilityDataPayload = {
  __typename?: 'ReportAvailabilityDataPayload';
  /** The availability rows returned for the current page. */
  data: Array<ReportAvailabilityData>;
  /** The number of rows returned for the current page. */
  totalCount: Scalars['Int']['output'];
  /** The total number of availability rows matching the filters before paging. */
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the report's grand-total row, one entry per summable column. Projected from the map
   * ReportAvailabilityDataRollup.ExecuteAsync already folded — the SAME map the export arm
   * carries, because both arms enter through that one rollup.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * One item of the customer-facing availability book. The grain is the ITEM: current on-hand /
 * allocated / available are summed over every inventory key, and each of the two windows carries
 * the scheduled production and open demand dated inside it plus the availability and status that
 * follow. Money, labels and statuses are also carried as STRINGS because the PDF service's
 * Handlebars registers no format or concat helper.
 */
export type ReportAvailabilityOutlookData = {
  __typename?: 'ReportAvailabilityOutlookData';
  /** Gets the item's first category code — the product family the book is sectioned by. Empty when the item has none. */
  category: Scalars['String']['output'];
  /** Gets the category section's total allocated. */
  categoryCurrentAllocatedTotal: Scalars['Decimal']['output'];
  /** Gets the category section's total current allocated in units. Null when the section's rows hold different packs, where only the eaches total foots. */
  categoryCurrentAllocatedUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the category section's total available now, which can be negative when the section is over-allocated. */
  categoryCurrentAvailableTotal: Scalars['Decimal']['output'];
  /** Gets the category section's total current available in units. Null when the section's rows hold different packs, where only the eaches total foots. */
  categoryCurrentAvailableUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the category section's total on-hand — the same figure on every row of the run. */
  categoryCurrentOnHandTotal: Scalars['Decimal']['output'];
  /** Gets the category section's total current on hand in units. Null when the section's rows hold different packs, where only the eaches total foots. */
  categoryCurrentOnHandUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the category section's total window-A availability. */
  categoryWindowAAvailableTotal: Scalars['Decimal']['output'];
  /** Gets the category section's total window-A availability in units. Null when the section's rows hold different packs, where only the eaches total foots. */
  categoryWindowAAvailableUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the category section's total open demand inside window A. */
  categoryWindowAOpenDemandTotal: Scalars['Decimal']['output'];
  /** Gets the category section's total window-A open demand in units. Null when the section's rows hold different packs, where only the eaches total foots. */
  categoryWindowAOpenDemandUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the category section's total scheduled production inside window A. */
  categoryWindowAScheduledProductionTotal: Scalars['Decimal']['output'];
  /** Gets the category section's total window-A scheduled production in units. Null when the section's rows hold different packs, where only the eaches total foots. */
  categoryWindowAScheduledProductionUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the category section's total window-B availability. */
  categoryWindowBAvailableTotal: Scalars['Decimal']['output'];
  /** Gets the category section's total window-B availability in units. Null when the section's rows hold different packs, where only the eaches total foots. */
  categoryWindowBAvailableUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the category section's total open demand inside window B. */
  categoryWindowBOpenDemandTotal: Scalars['Decimal']['output'];
  /** Gets the category section's total window-B open demand in units. Null when the section's rows hold different packs, where only the eaches total foots. */
  categoryWindowBOpenDemandUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the category section's total scheduled production inside window B. */
  categoryWindowBScheduledProductionTotal: Scalars['Decimal']['output'];
  /** Gets the category section's total window-B scheduled production in units. Null when the section's rows hold different packs, where only the eaches total foots. */
  categoryWindowBScheduledProductionUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** The item's value for the characteristic bound to Characteristic 1. Empty when the column is not bound or the item has no value. */
  characteristic1: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 1. Empty when the column is not bound. */
  characteristic1Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 2. Empty when the column is not bound or the item has no value. */
  characteristic2: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 2. Empty when the column is not bound. */
  characteristic2Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 3. Empty when the column is not bound or the item has no value. */
  characteristic3: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 3. Empty when the column is not bound. */
  characteristic3Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 4. Empty when the column is not bound or the item has no value. */
  characteristic4: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 4. Empty when the column is not bound. */
  characteristic4Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 5. Empty when the column is not bound or the item has no value. */
  characteristic5: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 5. Empty when the column is not bound. */
  characteristic5Name: Scalars['String']['output'];
  /** Gets the allocated quantity summed over every inventory key. */
  currentAllocated: Scalars['Decimal']['output'];
  /** Gets the current allocated in units: the eaches over the eaches per unit, cut toward zero at two decimals. Null when the item has no unit. */
  currentAllocatedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets on-hand minus allocated — today's available-to-promise, which can be negative when over-allocated. */
  currentAvailable: Scalars['Decimal']['output'];
  /**
   * Gets the available-now quantity as one string, 2 (4.5 inch tray) · 30 ea, or the bare each count
   * when the item has no named unit.
   */
  currentAvailableText: Scalars['String']['output'];
  /** Gets the current available in units: the eaches over the eaches per unit, cut toward zero at two decimals. Null when the item has no unit. */
  currentAvailableUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the on-hand quantity summed over every inventory key. */
  currentOnHand: Scalars['Decimal']['output'];
  /** Gets the current on hand in units: the eaches over the eaches per unit, cut toward zero at two decimals. Null when the item has no unit. */
  currentOnHandUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets how many eaches one unit of the shipping unit holds. Null when the item has no unit. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /** Gets a value indicating whether this row opens a new category section on the page — computed server-side so the template can print a section header without a groupBy helper. */
  firstOfCategory: Scalars['Boolean']['output'];
  /** Gets the item identifier. */
  itemId: Scalars['String']['output'];
  /** Gets the item's lookup code — GrowPoint's printed "item code", distinct from the SKU. */
  itemLookupCode: Scalars['String']['output'];
  /** Gets the item name. */
  itemName: Scalars['String']['output'];
  /** Gets a value indicating whether this row closes its category section on the page. */
  lastOfCategory: Scalars['Boolean']['output'];
  /**
   * Gets a value indicating whether any returned row has a named unit. The same on every row, so a
   * template can show its units columns for the whole page, header and total rows included, and leave them
   * out entirely when every item is counted in eaches.
   */
  pageHasUnits: Scalars['Boolean']['output'];
  /** Gets the unit price at the run's pricing context (explicit price group, else the customer's group, else the tenant default; no match is 0). */
  price: Scalars['Decimal']['output'];
  /** Gets the unit price formatted as money, for the PDF template. */
  priceFormatted: Scalars['String']['output'];
  /** Gets the item's product group. */
  productGroup: Scalars['String']['output'];
  /** Gets the royalty note composed from the item's royalty config ("Royalty 12% to Payee", "Royalty $0.15/unit to Payee"), or empty when the item carries none. */
  royaltyNote: Scalars['String']['output'];
  /**
   * Gets the name of the Shipping UOM the item ships as today, for example 4.5 inch tray. Null when
   * the item has no unit (a pack of one or an unstated pack) or its Shipping UOM has no name.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /** Gets the item's first size code. Empty when the item has none. */
  size: Scalars['String']['output'];
  /** Gets the SKU. */
  sku: Scalars['String']['output'];
  /** Gets CurrentOnHand + WindowAScheduledProduction − WindowAOpenDemand. */
  windowAAvailable: Scalars['Decimal']['output'];
  /** Gets the window-A availability in units: the eaches over the eaches per unit, cut toward zero at two decimals. Null when the item has no unit. */
  windowAAvailableUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets window A's inclusive lower bound. */
  windowAFrom: Scalars['DateTime']['output'];
  /** Gets the label of window A as resolved for the run. */
  windowALabel: Scalars['String']['output'];
  /** Gets the open order demand (Submitted / Acknowledged / Picked / SyncError, net of shipped) with an expected delivery date inside window A. */
  windowAOpenDemand: Scalars['Decimal']['output'];
  /** Gets the window-A open demand in units: the eaches over the eaches per unit, cut toward zero at two decimals. Null when the item has no unit. */
  windowAOpenDemandUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the Released / In Production job quantity with a delivery date inside window A. */
  windowAScheduledProduction: Scalars['Decimal']['output'];
  /** Gets the window-A scheduled production in units: the eaches over the eaches per unit, cut toward zero at two decimals. Null when the item has no unit. */
  windowAScheduledProductionUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the printed status for window A: the available quantity, or SOLD OUT when it is zero or negative. */
  windowAStatus: Scalars['String']['output'];
  /** Gets window A's inclusive upper bound, as the last instant of the selected day. */
  windowATo: Scalars['DateTime']['output'];
  /** Gets CurrentOnHand + WindowBScheduledProduction − WindowBOpenDemand. */
  windowBAvailable: Scalars['Decimal']['output'];
  /** Gets the window-B availability in units: the eaches over the eaches per unit, cut toward zero at two decimals. Null when the item has no unit. */
  windowBAvailableUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets window B's inclusive lower bound. */
  windowBFrom: Scalars['DateTime']['output'];
  /** Gets the label of window B as resolved for the run. */
  windowBLabel: Scalars['String']['output'];
  /** Gets the open order demand with an expected delivery date inside window B. */
  windowBOpenDemand: Scalars['Decimal']['output'];
  /** Gets the window-B open demand in units: the eaches over the eaches per unit, cut toward zero at two decimals. Null when the item has no unit. */
  windowBOpenDemandUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the Released / In Production job quantity with a delivery date inside window B. */
  windowBScheduledProduction: Scalars['Decimal']['output'];
  /** Gets the window-B scheduled production in units: the eaches over the eaches per unit, cut toward zero at two decimals. Null when the item has no unit. */
  windowBScheduledProductionUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the printed status for window B: the available quantity, or SOLD OUT when it is zero or negative. */
  windowBStatus: Scalars['String']['output'];
  /** Gets window B's inclusive upper bound, as the last instant of the selected day. */
  windowBTo: Scalars['DateTime']['output'];
};

/** Payload wrapper for the reportAvailabilityOutlookData query. */
export type ReportAvailabilityOutlookDataPayload = {
  __typename?: 'ReportAvailabilityOutlookDataPayload';
  /** The item rows returned for the current page. */
  data: Array<ReportAvailabilityOutlookData>;
  /** The number of rows returned for the current page. */
  totalCount: Scalars['Int']['output'];
  /** The total number of items matching the filters before paging. */
  totalMatching: Scalars['Int']['output'];
  /** Gets the payload-level totals map the report builder renders after the row loop. */
  totals: Array<ReportColumnTotal>;
};

/**
 * One customer's bill-to address for report generation. The grain is the CUSTOMER: the row carries the
 * customer's first billing address, the default bill-to the order path applies, and a customer with no
 * billing address is still listed with blank address fields.
 */
export type ReportBillToAddressData = {
  __typename?: 'ReportBillToAddressData';
  /** Gets the customer account number (the customer's ERP id). */
  accountNumber: Scalars['String']['output'];
  /** Gets the first address line. */
  addressLine1: Scalars['String']['output'];
  /** Gets the second address line. */
  addressLine2: Scalars['String']['output'];
  /** Gets the city. */
  city: Scalars['String']['output'];
  /** Gets the country, empty when the customer has no billing address. */
  country: Scalars['String']['output'];
  /** Gets the customer identifier. */
  customerId: Scalars['String']['output'];
  /** Gets the customer name. */
  customerName: Scalars['String']['output'];
  /** Gets the customer-type id, empty when the customer holds no type. */
  customerTypeId: Scalars['String']['output'];
  /** Gets the customer-type display name, empty when the customer holds no type. */
  customerTypeName: Scalars['String']['output'];
  /**
   * Gets the customer's primary-contact phone number (CustomersSummaryDocument.PrimaryContactPhone).
   * Empty when the customer has no Primary contact, or that contact records no phone.
   */
  phone: Scalars['String']['output'];
  /** Gets the state or province. */
  state: Scalars['String']['output'];
  /** Gets the addressee recorded on the bill-to address. */
  toName: Scalars['String']['output'];
  /** Gets the postal code. */
  zipcode: Scalars['String']['output'];
};

/** Payload wrapper for the reportBillToAddressesData query. */
export type ReportBillToAddressesDataPayload = {
  __typename?: 'ReportBillToAddressesDataPayload';
  /** The bill-to address rows returned for the current page. */
  data: Array<ReportBillToAddressData>;
  /** The number of rows returned for the current page. */
  totalCount: Scalars['Int']['output'];
  /** The total number of customers matching the filters before paging. */
  totalMatching: Scalars['Int']['output'];
};

/**
 * Payload wrapper for the reportCashReceiptsData query. TotalCount is the number of rows
 * returned; TotalMatching is the number matching the filters before the page cap, so the builder
 * can prompt the caller to narrow when the two differ.
 */
export type ReportCashReceiptsDataPayload = {
  __typename?: 'ReportCashReceiptsDataPayload';
  data: Array<ReportCashReceiptsDataRow>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no payment matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of a Cash Receipts render — a single payment as it was recorded against an invoice.
 *
 *
 * THIS ROW SHAPE IS DESIGNED FOR FOUR REPORTS, NOT ONE. GrowPoint's Cash Receipts, Credit Card,
 * Customer Average Days to Pay, and Customer Sales, Payments and Credits are all selections over the
 * same population — payments received — and the fields that separate them are carried here so none of
 * the three needs a second payments source: paymentMethod is what a Credit Card report filters
 * to, invoiceDate and daysToPay are what an Average Days to Pay report averages, and
 * discountTaken / lateChargeAssessed are the credit side of a Sales, Payments and Credits
 * report.
 *
 *
 *
 * NOTHING HERE IS DERIVED FROM A BALANCE. Every money field is a figure the payment event recorded.
 * What the payment left owing and whether the invoice now reads as paid are questions about the
 * INVOICE, answered on InvoiceDocument and deliberately absent here — a receipts register that
 * carried its own opinion about a balance would be a second answer free to drift from the invoice's.
 * The one computed member is daysToPay, which is a subtraction of two dates on this same
 * row.
 *
 *
 *
 * PROPERTY ORDER IS THE SEEDED COLUMN ORDER, and through TabularDataFlattener it is also the
 * CSV / Excel header order. APPEND, never insert.
 */
export type ReportCashReceiptsDataRow = {
  __typename?: 'ReportCashReceiptsDataRow';
  /** The cash received. This figure alone, not what it settled once credits are applied. */
  amount: Scalars['Decimal']['output'];
  /** The amount as the customer's currency prints it — e.g. $1,234.56. */
  amountFormatted: Scalars['String']['output'];
  /**
   * The ERP-facing customer code (CustomersSummaryDocument.CustomerLookupCode) an A/R clerk
   * reconciles against. Blank when the customer's summary row has not been projected yet.
   */
  customerCode: Scalars['String']['output'];
  /** The customer who paid. Internal id; customerCode is the one a clerk reads. */
  customerId: Scalars['String']['output'];
  /** The customer's name. */
  customerName: Scalars['String']['output'];
  /**
   * Whole days from invoiceDate to receivedDate. NEGATIVE when the payer
   * paid before the invoice was issued — a deposit-shaped prepayment — which is left signed rather
   * than floored at zero so an average over these rows is not quietly biased upward.
   */
  daysToPay: Scalars['Int']['output'];
  /**
   * The early-pay discount the payer took, which settled part of the bill alongside the cash. Zero on
   * most rows.
   */
  discountTaken: Scalars['Decimal']['output'];
  /** The discountTaken as the customer's currency prints it. */
  discountTakenFormatted: Scalars['String']['output'];
  /**
   * The date the invoice was issued — the start of the terms clock, and the first input to
   * daysToPay.
   */
  invoiceDate: Scalars['DateTime']['output'];
  /**
   * The number of the invoice this payment settled. An invoice bills exactly one order and takes its
   * number, so this reads as the order number on an order's first bill and as orderNumber-R1,
   * orderNumber-R2 and so on for a bill raised after a previous one was withdrawn. GrowPoint's separate
   * Order No. selection therefore needs no separate column.
   */
  invoiceNumber: Scalars['String']['output'];
  /** The invoice's standing at read time — Issued, Voided, and so on. */
  invoiceStatus: Scalars['String']['output'];
  /** The finance charge assessed with this payment. ADDS to what the invoice is owed. */
  lateChargeAssessed: Scalars['Decimal']['output'];
  /** The lateChargeAssessed as the customer's currency prints it. */
  lateChargeAssessedFormatted: Scalars['String']['output'];
  /**
   * Free text carrying whatever the structured fields do not — where an Other-method payment
   * says what it actually was. Blank when the payment carried none.
   */
  note: Scalars['String']['output'];
  /**
   * How the payment reached the tenant — Check, Ach, Card, Stripe,
   * Edi, Other or Cash, as the enum's NAME so CSV and Excel render a word
   * rather than an ordinal.
   */
  paymentMethod: Scalars['String']['output'];
  /**
   * The payer-side reference — a check number, or a Stripe PaymentIntent id. Blank when the payment
   * carried none.
   */
  paymentNumber: Scalars['String']['output'];
  /**
   * When the money was received. THIS is the date the report's period bounds, not
   * recordedAt — a check received on the 30th and keyed on the 2nd belongs in the month
   * it arrived, which is the month the payer will say they paid in.
   */
  receivedDate: Scalars['DateTime']['output'];
  /**
   * When the payment was keyed in, which is not when the money arrived — see
   * receivedDate. Carried so a period that looks short can be checked against
   * late-keyed receipts.
   */
  recordedAt: Scalars['DateTime']['output'];
  /** The email of whoever recorded the payment, or the webhook that did. */
  recordedBy: Scalars['String']['output'];
};

/**
 * One entry of a report's grand-total row: the COLUMN that was summed, and its sum over the
 * returned page.
 */
export type ReportColumnTotal = {
  __typename?: 'ReportColumnTotal';
  /** The column path summed, e.g. orderedQuantity. */
  column: Scalars['String']['output'];
  /** The sum of that column over the returned rows. */
  value: Scalars['Decimal']['output'];
};

export type ReportCompanyData = {
  __typename?: 'ReportCompanyData';
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * One printable container tag. The grain is a TAG, not a line: under tagMode = PerUnit a line
 * with basis quantity N yields N of these (tagIndex 1..N of tagCount); under
 * PerShippingUnit a line of N shipping units yields N; under PerLineItem it yields exactly
 * one. Property names are the seeded items[].* field ids of ds-container-tags — the PWA's
 * generic fetcher builds its selection set from the seed, so the two must agree exactly.
 */
export type ReportContainerTagRow = {
  __typename?: 'ReportContainerTagRow';
  /** The item's value for the characteristic bound to Characteristic 1. Empty when the column is not bound or the item has no value. */
  characteristic1: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 1. Empty when the column is not bound. */
  characteristic1Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 2. Empty when the column is not bound or the item has no value. */
  characteristic2: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 2. Empty when the column is not bound. */
  characteristic2Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 3. Empty when the column is not bound or the item has no value. */
  characteristic3: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 3. Empty when the column is not bound. */
  characteristic3Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 4. Empty when the column is not bound or the item has no value. */
  characteristic4: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 4. Empty when the column is not bound. */
  characteristic4Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 5. Empty when the column is not bound or the item has no value. */
  characteristic5: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 5. Empty when the column is not bound. */
  characteristic5Name: Scalars['String']['output'];
  /**
   * The container code the tag identifies: the LINE's own container code when set, otherwise the ORDER's
   * shipping container code. Null when neither is set.
   */
  containerCode?: Maybe<Scalars['String']['output']>;
  /**
   * The active ContainerConfig name for containerCode, resolved best-effort per
   * tenant (preferring the config in the line's shipping category). Null when no config matches.
   */
  containerName?: Maybe<Scalars['String']['output']>;
  /** The order's customer, denormalized on the order read model. */
  customerName: Scalars['String']['output'];
  /** The line's eaches under quantityBasis, the figure quantity carries. */
  eaches: Scalars['Int']['output'];
  /** How many eaches one shipping unit of the line holds. Null when the line's pack is one or unstated. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /** The line's SKU — GrowPoint's "Item Code". */
  itemCode: Scalars['String']['output'];
  /** The line's item name. */
  itemName: Scalars['String']['output'];
  /** The order line number. */
  lineNumber: Scalars['Int']['output'];
  /** The order the tagged line belongs to. */
  orderNumber: Scalars['String']['output'];
  /** The line's quantity under quantityBasis (null on the line reads as 0). */
  quantity: Scalars['Int']['output'];
  /** The quantity basis the tags were counted from — Acknowledged or Shipped. */
  quantityBasis: Scalars['String']['output'];
  /**
   * The line's customer retail price per each, the same price the pull slip prints for the line. Null
   * unless the tenant's Pre-pricing setting is on and the line has a retail price.
   */
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The retail price as the tag prints it, with its currency symbol and two decimals, e.g. $5.99. Null
   * exactly when the retail price is null.
   */
  retailPriceFormatted?: Maybe<Scalars['String']['output']>;
  /** The order's resolved route, if any. */
  route?: Maybe<Scalars['String']['output']>;
  /** The order's shipped date; null until the order ships. */
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The name of the Shipping UOM the line was placed under, e.g. 4.5 inch tray. Null when the line's pack
   * is one or unstated, or when its Shipping UOM has no name.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /** Scannable value unique per tag: {orderNumber}-{lineNumber}-{tagIndex}. */
  tagBarcodeValue: Scalars['String']['output'];
  /** How many tags the line yields under the chosen tag mode. */
  tagCount: Scalars['Int']['output'];
  /** 1-based position of this tag within the line's tags. */
  tagIndex: Scalars['Int']['output'];
  /**
   * What this tag counts as the Avery sheet prints it after its position: the shipping unit for a labelled
   * tray tag (4.5 inch tray (15 ea)), ea for a per-pot tag, the line's quantity for a per-line tag (2 (4.5
   * inch tray) · 30 ea, or 30 ea). Null unless the tenant prints units and eaches; a null keeps the tag's
   * text as it was.
   */
  tagQuantityText?: Maybe<Scalars['String']['output']>;
  /**
   * The shipping unit this tag stands for as the tag prints it, e.g. 4.5 inch tray (15 ea). Null unless
   * the tag mode is PerShippingUnit, the line has a unit count for the basis and a named Shipping UOM of
   * more than one each, and the tenant prints units and eaches; a null keeps the tag's text as it was.
   */
  tagUnitText?: Maybe<Scalars['String']['output']>;
  /**
   * The UPC the tag prints: the customer's UPC for the line when it has one, otherwise the item's own UPC.
   * Empty when neither is set.
   */
  upc: Scalars['String']['output'];
  /**
   * The UPC for a UPC-A barcode: the value of upc, with surrounding spaces removed, when it is twelve digits
   * with a correct check digit; otherwise blank. It is never completed from eleven digits and never replaced
   * by the item's UPC.
   */
  upcBarcode: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportContainerTagsData query. TotalCount is the number of tag
 * records returned (capped by first, at most 5000);
 * TotalMatching is the number of tags the selection would yield before the cap, so a template can
 * render "Showing X of Y" and the builder can prompt the user to narrow the selection.
 */
export type ReportContainerTagsDataPayload = {
  __typename?: 'ReportContainerTagsDataPayload';
  data: Array<ReportContainerTagRow>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * Result of a generateReportCsv query. On success, CsvBase64
 * carries the UTF-8 CSV payload base64-encoded; on failure, ErrorMessage
 * carries a diagnostic string.
 */
export type ReportCsvPayload = {
  __typename?: 'ReportCsvPayload';
  /** The base64-encoded UTF-8 CSV content, or null on failure. */
  csvBase64?: Maybe<Scalars['String']['output']>;
  /** An error description if generation failed, or null on success. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether CSV generation succeeded. */
  success: Scalars['Boolean']['output'];
};

/**
 * Payload wrapper for the reportCustomerAgingData query. TotalCount is the number of
 * rows returned; TotalMatching is the number matching the filters before the page cap, so the
 * builder can prompt the caller to narrow when the two differ.
 */
export type ReportCustomerAgingDataPayload = {
  __typename?: 'ReportCustomerAgingDataPayload';
  /** Gets the aging rows returned for the current page. */
  data: Array<ReportCustomerAgingDataRow>;
  /** Gets the number of rows returned after the page cap. */
  totalCount: Scalars['Int']['output'];
  /** Gets the number of rows matching the filters before the page cap. */
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of a Customer Aging render. ONE record serves all three
 * ReportCustomerAgingReportType grains, because the seeded data source declares one column
 * set and the report-builder Table picker binds to it — a per-grain record would mean three sources.
 *
 *
 * WHICH FIELDS CARRY A VALUE DEPENDS ON THE GRAIN, and the unpopulated ones are blank rather than
 * absent so a template bound to a column never renders a Handlebars miss:
 *
 *
 * Summary (one row per customer) — every customer field; the transaction fields
 * (orderNumber, transactionDate, daysPastDue) are blank,
 * because a customer's balance spans many invoices with many ages.
 * Detail (one row per standing invoice) — every field, with the aging columns
 * carrying that ONE invoice's open balance in its own bucket.
 * GrandTotals (one row for the whole selection) — the aging columns and nothing else;
 * there is no single customer or invoice to name.
 *
 *
 *
 * THE PARTITION IS THE FIVE DAY BUCKETS:
 * current + days1To30 + days31To60 + days61To90 + days90Plus = totalDue.
 * interest is NOT in it — it is an accrual nobody has charged — and neither is unbilled,
 * what shipped orders nobody has billed are owed. days61Plus and every
 * *Formatted mirror are PRESENTATION — summing them alongside the partition double-counts.
 */
export type ReportCustomerAgingDataRow = {
  __typename?: 'ReportCustomerAgingDataRow';
  /**
   * The country the account was most recently billed at — the billing address on the order behind the
   * account's latest invoice, which is the address a mailed customer statement is addressed to. Blank
   * when no invoice of theirs carries one.
   */
  country: Scalars['String']['output'];
  /** Not yet due as of the aging date, less the customer's unapplied credit, which ages as current. */
  current: Scalars['Decimal']['output'];
  /**
   * The currency-formatted presentation mirror of current. Rendered server-side because the
   * PDF service's Handlebars registers no number-formatting helper — a template binding the raw
   * decimal prints an unpunctuated, unsymbolled figure. PRESENTATION ONLY: summing the mirrors
   * alongside the five-bucket partition double-counts.
   */
  currentFormatted: Scalars['String']['output'];
  /**
   * The ERP-facing customer code (CustomersSummaryDocument.CustomerLookupCode) an A/R clerk
   * reconciles against — not customerId, which is internal.
   */
  customerCode: Scalars['String']['output'];
  /** current summed over this row's customer band. Zero off the Detail grain. */
  customerCurrentTotal: Scalars['Decimal']['output'];
  /** days1To30 summed over this row's customer band. Zero off the Detail grain. */
  customerDays1To30Total: Scalars['Decimal']['output'];
  /** days31To60 summed over this row's customer band. Zero off the Detail grain. */
  customerDays31To60Total: Scalars['Decimal']['output'];
  /** days61Plus summed over this row's customer band. Zero off the Detail grain. */
  customerDays61PlusTotal: Scalars['Decimal']['output'];
  /** days61To90 summed over this row's customer band. Zero off the Detail grain. */
  customerDays61To90Total: Scalars['Decimal']['output'];
  /** days90Plus summed over this row's customer band. Zero off the Detail grain. */
  customerDays90PlusTotal: Scalars['Decimal']['output'];
  /** The customer. Blank on a GrandTotals row. */
  customerId: Scalars['String']['output'];
  /** interest summed over this row's customer band. Zero off the Detail grain. */
  customerInterestTotal: Scalars['Decimal']['output'];
  /** The customer's name. Blank on a GrandTotals row. */
  customerName: Scalars['String']['output'];
  /** The customer's status (Active / Inactive), as its name. */
  customerStatus: Scalars['String']['output'];
  /**
   * totalDue summed over this row's customer band — that customer's Summary-grain total due
   * whenever the page cap did not cut the band. Zero off the Detail grain.
   */
  customerTotalDueTotal: Scalars['Decimal']['output'];
  /** The customer's type NAME, not its id — the value a printed report is read with. */
  customerType: Scalars['String']['output'];
  /** 1 to 30 days past due. */
  days1To30: Scalars['Decimal']['output'];
  /** Presentation mirror of days1To30. PRESENTATION ONLY, as currentFormatted. */
  days1To30Formatted: Scalars['String']['output'];
  /** 31 to 60 days past due. */
  days31To60: Scalars['Decimal']['output'];
  /** Presentation mirror of days31To60. PRESENTATION ONLY, as currentFormatted. */
  days31To60Formatted: Scalars['String']['output'];
  /**
   * days61To90 plus days90Plus — the single "61+" column GrowPoint's
   * aging prints. DERIVED for presentation and deliberately NOT part of the partition. Computed
   * server-side because it has to be: the PDF service's Handlebars registers no arithmetic helper,
   * so a template reaching for (add …) renders blank.
   */
  days61Plus: Scalars['Decimal']['output'];
  /** Presentation mirror of the derived days61Plus. PRESENTATION ONLY, as currentFormatted. */
  days61PlusFormatted: Scalars['String']['output'];
  /** 61 to 90 days past due. WHAT IS OWED ONLY — accrued interest is held in interest. */
  days61To90: Scalars['Decimal']['output'];
  /** Presentation mirror of days61To90. PRESENTATION ONLY, as currentFormatted. */
  days61To90Formatted: Scalars['String']['output'];
  /** More than 90 days past due. WHAT IS OWED ONLY, as above. */
  days90Plus: Scalars['Decimal']['output'];
  /** Presentation mirror of days90Plus. PRESENTATION ONLY, as currentFormatted. */
  days90PlusFormatted: Scalars['String']['output'];
  /**
   * Days past due for this transaction on a Detail row, negative when not yet due. Null on Summary
   * and GrandTotals rows.
   */
  daysPastDue?: Maybe<Scalars['Int']['output']>;
  /**
   * True on the FIRST row of each customer's run of invoice rows — the customer band's header
   * marker. Stamped on the Detail grain only, over the rows AS RETURNED; always false on Summary and
   * GrandTotals rows, where a customer (or the whole selection) is already a single row.
   */
  firstOfCustomer: Scalars['Boolean']['output'];
  /**
   * The finance charge the standing invoices have RUN UP as of the aging date and nobody has
   * assessed, net of anything already forgiven. Held beside the day buckets and deliberately OUTSIDE
   * the partition: nothing has charged it, so it is not owed and adding it to totalDue would
   * demand payment of money the customer does not owe. The footer still reads
   * Current / 1-30 / 31-60 / 61+ / Interest / Total Due; what changed is that the row no
   * longer adds up, because the last two figures answer different questions.
   */
  interest: Scalars['Decimal']['output'];
  /** Presentation mirror of interest. PRESENTATION ONLY, as currentFormatted. */
  interestFormatted: Scalars['String']['output'];
  /**
   * True only on the Detail row that carries the customer's unapplied credit (the row whose orderNumber reads
   * "Unapplied credit"); false on every invoice row and on Summary and GrandTotals rows. The credit row is a
   * negative amount in current and is no invoice, so a reader that counts invoices leaves it out by this flag.
   * totalMatching counts it as a row.
   */
  isUnappliedCredit: Scalars['Boolean']['output'];
  /**
   * True on the LAST row of each customer's run of invoice rows — gates the band's subtotal row.
   * Detail grain only, as firstOfCustomer.
   */
  lastOfCustomer: Scalars['Boolean']['output'];
  /**
   * The invoice, on a Detail row: the number it was billed under, which for a first issuance is the
   * number of the order it bills. "Unapplied credit" on the Detail row that carries the customer's credit not
   * yet applied to any invoice, which sits in current as a negative amount. Blank on Summary and GrandTotals
   * rows.
   */
  orderNumber: Scalars['String']['output'];
  /**
   * The customer's assigned salesperson emails, joined. The CUSTOMER's salespeople, resolved from
   * the same two read models ds-ship-to-addresses resolves them from — deliberately not the
   * SalesPerson stamped on each order, which would make a customer-grain row disagree with
   * every other customer-grain read in the system.
   */
  salesPerson: Scalars['String']['output'];
  /** The customer's payment terms name. Blank when the customer carries no terms. */
  terms: Scalars['String']['output'];
  /**
   * The row's whole receivable — the sum of the five day buckets, and the figure that equals a
   * Customer Statement's closing balance for the same customer at the same instant. The accrued
   * interest beside it is not part of this.
   */
  totalDue: Scalars['Decimal']['output'];
  /** Presentation mirror of totalDue. PRESENTATION ONLY, as currentFormatted. */
  totalDueFormatted: Scalars['String']['output'];
  /**
   * The date this invoice was aged FROM on a Detail row — the due date frozen onto it at issue. Null
   * on Summary and GrandTotals rows, which span many invoices with many dates. Emitting the date the
   * age was actually taken from is what lets a reader reproduce a row's bucket by hand.
   */
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * What the customer's shipped orders that had no live invoice at the aging date are owed — each
   * order's total less the deposits and payments received on it by then. Reported BESIDE the aging and
   * NOT part of totalDue or of any bucket: nothing has billed it yet. Carried on Summary and
   * GrandTotals rows; zero on a Detail row, which is one invoice.
   */
  unbilled: Scalars['Decimal']['output'];
  /** Presentation mirror of unbilled. PRESENTATION ONLY, as currentFormatted. */
  unbilledFormatted: Scalars['String']['output'];
  /** How many shipped orders stood unbilled at the aging date. Zero on a Detail row. */
  unbilledOrderCount: Scalars['Int']['output'];
};

/**
 * Payload wrapper for the reportCustomerAvgDaysToPayData query. TotalCount is the number
 * of rows returned; TotalMatching is the number of CUSTOMERS matching the selection before the
 * page cap, so the builder can prompt the caller to narrow when the two differ.
 */
export type ReportCustomerAvgDaysToPayDataPayload = {
  __typename?: 'ReportCustomerAvgDaysToPayDataPayload';
  /** Gets the per-customer payment rows returned for the current page. */
  data: Array<ReportCustomerAvgDaysToPayDataRow>;
  /** Gets the number of rows returned after the page cap. */
  totalCount: Scalars['Int']['output'];
  /** Gets the number of customers matching the selection before the page cap. */
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of a Customer Average Days to Pay render — a single customer's payment behaviour across the
 * selected periods.
 *
 *
 * ONE ROW PER CUSTOMER, NOT PER PAYMENT. It is the rollup of the same population
 * ReportCashReceiptsDataRow lists individually: the per-payment daysToPay that register
 * publishes as a column is what this averages, so a reader can reconcile any figure here against the
 * receipts behind it without the two reports disagreeing about a single payment.
 *
 *
 *
 * EVERY AVERAGE SHIPS BESIDE ITS SAMPLE SIZE, and that pairing is the point rather than a nicety. An
 * "average days to pay" computed from two payments and one computed from two hundred read identically
 * on a page, and an A/R clerk chasing the first one is chasing noise. The count column makes the thin
 * sample visible instead of hiding it inside the average.
 *
 *
 *
 * NO DATA IS NOT ZERO. A customer with no payments in a period carries  there,
 * never 0: zero days to pay is a real and excellent figure — the customer paid on the day of
 * invoice — so reporting it for an account with no synced payment history would state the opposite of
 * the truth. That is the whole reason the average members are nullable rather than defaulted.
 *
 *
 *
 * PROPERTY ORDER IS THE SEEDED COLUMN ORDER, and through TabularDataFlattener it is also the
 * CSV / Excel header order. APPEND, never insert.
 */
export type ReportCustomerAvgDaysToPayDataRow = {
  __typename?: 'ReportCustomerAvgDaysToPayDataRow';
  /**
   * The ERP-facing customer code (CustomersSummaryDocument.CustomerLookupCode) an A/R clerk
   * reconciles against. Blank when the customer's summary row has not been projected yet.
   */
  customerCode: Scalars['String']['output'];
  /** The customer this row describes. Internal id; customerCode is the one a clerk reads. */
  customerId: Scalars['String']['output'];
  /** The customer's name. Blank when the customer's summary row has not been projected yet. */
  customerName: Scalars['String']['output'];
  /** The customer-type id, empty when the customer holds no type. */
  customerTypeId: Scalars['String']['output'];
  /** The customer-type display name, empty when the customer holds no type. */
  customerTypeName: Scalars['String']['output'];
  /**
   * Mean whole days to pay across the union of the selected periods, or null when
   * the customer had no payments in any of them.
   */
  overallAverageDays?: Maybe<Scalars['Decimal']['output']>;
  /** overallAverageDays as the document prints it. */
  overallAverageDaysFormatted: Scalars['String']['output'];
  /**
   * How many payments the overall average was drawn from — never larger than the sum of the period
   * counts, and smaller when the periods overlap.
   */
  overallPaymentCount: Scalars['Int']['output'];
  /**
   * Mean whole days from invoice date to payment date over period A's payments, or
   * null when this customer had none in that window.
   */
  periodAAverageDays?: Maybe<Scalars['Decimal']['output']>;
  /**
   * periodAAverageDays as the document prints it — one decimal, or an em dash for no
   * data.
   */
  periodAAverageDaysFormatted: Scalars['String']['output'];
  /**
   * Period A's operator-supplied column description, echoed onto every row so a template can bind its
   * column header from the data rather than hardcoding "Period A".
   */
  periodALabel: Scalars['String']['output'];
  /**
   * How many payments period A's average was drawn from. The honesty column: 0 here is what
   * makes a null average readable as "no history" rather than as a missing figure.
   */
  periodAPaymentCount: Scalars['Int']['output'];
  /**
   * Mean whole days to pay over period B's payments, or null when this customer had
   * none in that window — or when the caller selected no period B at all. The two cases are told
   * apart by periodBLabel, which is blank only in the second.
   */
  periodBAverageDays?: Maybe<Scalars['Decimal']['output']>;
  /** periodBAverageDays as the document prints it. */
  periodBAverageDaysFormatted: Scalars['String']['output'];
  /** Period B's operator-supplied column description. Blank when no period B was selected. */
  periodBLabel: Scalars['String']['output'];
  /** How many payments period B's average was drawn from. */
  periodBPaymentCount: Scalars['Int']['output'];
};

/** Customer summary data for report output. */
export type ReportCustomerData = {
  __typename?: 'ReportCustomerData';
  accountNumber: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  /** The customer-type id, empty when the customer holds no type. */
  typeId: Scalars['String']['output'];
  /** The customer-type display name, empty when the customer holds no type. */
  typeName: Scalars['String']['output'];
};

/** Flattened customer record for report generation. One row per CustomersSummary document. */
export type ReportCustomerDataRow = {
  __typename?: 'ReportCustomerDataRow';
  currency: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  /** The customer-type id, empty when the customer holds no type. */
  customerTypeId: Scalars['String']['output'];
  /** The customer-type display name, empty when the customer holds no type. */
  customerTypeName: Scalars['String']['output'];
  dateCreated: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfContacts: Scalars['Int']['output'];
  numberOfLocations: Scalars['Int']['output'];
  priceGroupName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  synchronizeOrders: Scalars['Boolean']['output'];
  termsId?: Maybe<Scalars['String']['output']>;
};

/**
 * Payload wrapper for the reportCustomerInterestData query. TotalCount is the number
 * of rows returned; TotalMatching is the number matching the filters before the page cap, so
 * the builder can prompt the caller to narrow when the two differ.
 */
export type ReportCustomerInterestDataPayload = {
  __typename?: 'ReportCustomerInterestDataPayload';
  /** Gets the accruing-invoice rows returned for the current page. */
  data: Array<ReportCustomerInterestDataRow>;
  /** Gets the number of rows returned after the page cap. */
  totalCount: Scalars['Int']['output'];
  /** Gets the number of rows matching the filters before the page cap. */
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of a Customer Interest render: ONE standing invoice's ACCRUED interest as of the requested
 * date, with the customer it bills, the balance and rate it is accruing on, and how long it has been
 * running.
 *
 *
 * ACCRUED, NOT ASSESSED — THIS IS THE READING CHANGE THE INVOICE BASIS FORCES. There is no monthly
 * charge run and no charge document: an invoice accrues continuously and is only ever charged when a
 * payment assesses it. Every figure here is therefore what the invoice WOULD be charged if it settled
 * on the as-of date, which is deliberately NOT in its open balance, NOT in the customer's closing
 * balance and NOT in any aging bucket. A row is a standing obligation running up, not a transaction
 * that happened.
 *
 *
 *
 * EVERY AMOUNT IS InvoiceAccrual'S, struck per invoice on that invoice's own frozen due date,
 * terms and open balance — the same function the customer statement's interest lines and the Customer
 * Aging report's interest column read. A render of this report and a statement for the same customer
 * at the same as-of date therefore list the same invoices at the same amounts, because neither
 * computes anything of its own.
 *
 *
 *
 * ONE ROW PER INVOICE, AND ONLY WHILE SOMETHING IS ACCRUING. An invoice still inside its terms, one
 * under terms carrying no finance-charge rate, and one whose accrual has been forgiven in full all run
 * up nothing and produce no row — the same zero-drop the statement's interest section makes, so the
 * two agree on which invoices appear as well as on what each owes.
 *
 *
 *
 * EVERY MONEY AND RATE FIELD CARRIES A *Formatted PRESENTATION MIRROR, rendered server-side
 * because it has to be: the PDF service's Handlebars registers no number-formatting and no
 * arithmetic helper, so a template binding a raw decimal prints an unpunctuated, unsymbolled figure.
 * The mirrors are PRESENTATION ONLY — summing them alongside the raw fields double-counts.
 */
export type ReportCustomerInterestDataRow = {
  __typename?: 'ReportCustomerInterestDataRow';
  /**
   * The finance charge the invoice has run up as of the as-of date and nobody has assessed, NET of
   * anything already forgiven. Never negative.
   */
  amount: Scalars['Decimal']['output'];
  /** Presentation mirror of amount. PRESENTATION ONLY — see the record remarks. */
  amountFormatted: Scalars['String']['output'];
  /** Presentation mirror of appliedAnnualRatePercent, as appliedMonthlyRateFormatted. */
  appliedAnnualRateFormatted: Scalars['String']['output'];
  /** The same rate expressed annually, as a percentage. */
  appliedAnnualRatePercent: Scalars['Decimal']['output'];
  /**
   * appliedMonthlyRatePercent rendered with a trailing percent sign. PRESENTATION ONLY —
   * the Handlebars runtime cannot multiply a fraction out or append the sign itself.
   */
  appliedMonthlyRateFormatted: Scalars['String']['output'];
  /** The monthly periodic rate the invoice accrues at, as a percentage. */
  appliedMonthlyRatePercent: Scalars['Decimal']['output'];
  /**
   * The early-pay discount still on offer to a payment that SETTLES the invoice, as of the as-of
   * date. Zero once the discount window has closed.
   */
  availableDiscount: Scalars['Decimal']['output'];
  /** Presentation mirror of availableDiscount. PRESENTATION ONLY, as amountFormatted. */
  availableDiscountFormatted: Scalars['String']['output'];
  /** amount (interest accrued) summed over this row's customer band. */
  customerAmountTotal: Scalars['Decimal']['output'];
  /** availableDiscount summed over this row's customer band. */
  customerAvailableDiscountTotal: Scalars['Decimal']['output'];
  /**
   * The ERP-facing customer code (CustomersSummaryDocument.CustomerLookupCode) an A/R clerk
   * reconciles against — not CustomerId, which is internal.
   */
  customerCode: Scalars['String']['output'];
  /** The internal customer id the invoice bills. */
  customerId: Scalars['String']['output'];
  /** lateChargeWaived summed over this row's customer band. */
  customerLateChargeWaivedTotal: Scalars['Decimal']['output'];
  /** The customer's name. */
  customerName: Scalars['String']['output'];
  /** openBalance summed over this row's customer band. */
  customerOpenBalanceTotal: Scalars['Decimal']['output'];
  /** The customer-type id, empty when the customer holds no type. */
  customerTypeId: Scalars['String']['output'];
  /** The customer-type display name, empty when the customer holds no type. */
  customerTypeName: Scalars['String']['output'];
  /**
   * The date the INVOICE fell due, as frozen onto it at issue — the date the accrual is counted
   * from, and the same date that selected the invoice's aging bucket.
   */
  dueDate: Scalars['DateTime']['output'];
  /**
   * True on the FIRST row of each customer's run of accruing invoices — the customer band's
   * header marker, stamped over the rows AS RETURNED.
   */
  firstOfCustomer: Scalars['Boolean']['output'];
  /**
   * The date the customer was billed. Carried because it is the date the early-pay window runs
   * from, and therefore the only field that explains an availableDiscount beside it.
   */
  invoiceDate: Scalars['DateTime']['output'];
  /**
   * The number the accruing invoice was billed under — the audit key a customer disputing an
   * interest figure names, and the key that ties a row here to the same invoice on the customer's
   * statement and on the Customer Aging report's Detail grain.
   */
  invoiceNumber: Scalars['String']['output'];
  /** True on the LAST row of each customer's run of accruing invoices — gates the band's subtotal row. */
  lastOfCustomer: Scalars['Boolean']['output'];
  /**
   * The finance charge already FORGIVEN on this invoice — the sum of its waivers, which
   * amount is already net of.
   */
  lateChargeWaived: Scalars['Decimal']['output'];
  /** Presentation mirror of lateChargeWaived. PRESENTATION ONLY, as amountFormatted. */
  lateChargeWaivedFormatted: Scalars['String']['output'];
  /**
   * How many whole months past due the invoice is as of the report's as-of date — the multiplier
   * the charge is accumulated over, and the field that explains why the amount is the size it is.
   */
  monthsPastDue: Scalars['Int']['output'];
  /**
   * The receivable the charge is struck on — what the invoice still owes from the amounts recorded
   * against it, after its payments, adjustments and deposit credit.
   */
  openBalance: Scalars['Decimal']['output'];
  /** Presentation mirror of openBalance. PRESENTATION ONLY, as amountFormatted. */
  openBalanceFormatted: Scalars['String']['output'];
  /**
   * Whether the invoice's own frozen terms rate applies or a jurisdictional ceiling replaces it — a
   * FinanceChargeRateBasis name. The field a customer disputing a rate is answered from.
   */
  rateBasis: Scalars['String']['output'];
};

/** Per-customer order history rollup for report generation. */
export type ReportCustomerOrderHistoryData = {
  __typename?: 'ReportCustomerOrderHistoryData';
  /** Gets the customer account number. */
  accountNumber: Scalars['String']['output'];
  /** Gets the average order value for the customer. */
  avgOrderValue: Scalars['Decimal']['output'];
  /** Gets the customer identifier. */
  customerId: Scalars['String']['output'];
  /** Gets the customer name. */
  customerName: Scalars['String']['output'];
  /** The customer-type id, empty when the customer holds no type. */
  customerTypeId: Scalars['String']['output'];
  /** The customer-type display name, empty when the customer holds no type. */
  customerTypeName: Scalars['String']['output'];
  /** Gets the number of days since the customer's last order. */
  daysSinceLastOrder: Scalars['Int']['output'];
  /** Gets the earliest order date for the customer. */
  firstOrderDate: Scalars['DateTime']['output'];
  /** Gets the latest order date for the customer. */
  lastOrderDate: Scalars['DateTime']['output'];
  /** Gets the number of orders for the customer. */
  orderCount: Scalars['Int']['output'];
  /** Gets the customer price group name. */
  priceGroupName: Scalars['String']['output'];
  /** Gets the total order revenue for the customer. */
  totalRevenue: Scalars['Decimal']['output'];
  /**
   * Gets the eaches the customer ordered: each line's quantity, else its ordered quantity, summed. An each
   * count, not a count of shipping units: a line of 2 trays of 15 adds 30.
   */
  totalUnits: Scalars['Decimal']['output'];
};

/** Payload wrapper for the reportCustomerOrderHistoryData query. */
export type ReportCustomerOrderHistoryDataPayload = {
  __typename?: 'ReportCustomerOrderHistoryDataPayload';
  /** The customer order history rows returned for the current page. */
  data: Array<ReportCustomerOrderHistoryData>;
  /** The number of rows returned for the current page. */
  totalCount: Scalars['Int']['output'];
  /** The total number of customer rows matching the filters before paging. */
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * Payload wrapper for the reportCustomerSalesPaymentsCreditsData query. TotalCount is
 * the number of rows returned; TotalMatching is the number matching the filters before the
 * page cap, so the builder can prompt the caller to narrow when the two differ.
 */
export type ReportCustomerSalesPaymentsCreditsDataPayload = {
  __typename?: 'ReportCustomerSalesPaymentsCreditsDataPayload';
  /** Gets the per-customer activity rows returned for the current page. */
  data: Array<ReportCustomerSalesPaymentsCreditsDataRow>;
  /** Gets the number of rows returned after the page cap. */
  totalCount: Scalars['Int']['output'];
  /** Gets the number of rows matching the filters before the page cap. */
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of a Customer Sales, Payments and Credits render — ONE CUSTOMER'S whole period, rolled up.
 *
 *
 * THE GRAIN IS THE CUSTOMER, NOT THE TRANSACTION, and that is what separates this report from the
 * three registers it is folded from. ds-cash-receipts already lists payments one per row,
 * ds-orders with orderType = Credit already lists credit memos, and neither of them
 * answers "what did this account do this period" in one line. Because the grain IS the summary,
 * GrowPoint's "omit detail" option needs no flag here — there is no detail on this source to
 * suppress.
 *
 *
 *
 * SALES AND CREDITS ARE ORDER-BASIS; PAYMENTS ARE INVOICE-LEDGER BASIS. The two bases are not an
 * oversight. Sales and credits count orders raised in the window, the same population and the same
 * date field the Customer Statement's activity table lists, which is what lets a reader foot this
 * report against a statement for the same customer and period. Payments come from
 * InvoicePayments because that is where a payment's own money lives; reading order payment
 * entries instead would have been a second, drifting answer. Sales are therefore what was ORDERED,
 * not what was INVOICED.
 *
 *
 *
 * THE MONEY COLUMNS ARE A FIVE-FIELD PARTITION:
 * salesTotal − creditsTotal − paymentsTotal − discountsTaken + lateChargesAssessed =
 * netActivity. netActivity and every *Formatted mirror are PRESENTATION — summing
 * them alongside the partition double-counts.
 *
 *
 *
 * PROPERTY ORDER IS THE SEEDED COLUMN ORDER, and through TabularDataFlattener it is also the
 * CSV / Excel header order. APPEND, never insert.
 */
export type ReportCustomerSalesPaymentsCreditsDataRow = {
  __typename?: 'ReportCustomerSalesPaymentsCreditsDataRow';
  /** How many credit orders made up creditsTotal. */
  creditsCount: Scalars['Int']['output'];
  /**
   * What the customer was credited in the window — the total of every OrderType.Credit order
   * raised in it, as a POSITIVE magnitude.
   */
  creditsTotal: Scalars['Decimal']['output'];
  /** The creditsTotal as the customer's currency prints it. */
  creditsTotalFormatted: Scalars['String']['output'];
  /**
   * The ERP-facing customer code (CustomersSummaryDocument.CustomerLookupCode) an A/R clerk
   * reconciles against. Blank when the customer's summary row has not been projected yet.
   */
  customerCode: Scalars['String']['output'];
  /** The customer. Internal id; customerCode is the one a clerk reads. */
  customerId: Scalars['String']['output'];
  /** The customer's name. */
  customerName: Scalars['String']['output'];
  /** The customer-type id, empty when the customer holds no type. */
  customerTypeId: Scalars['String']['output'];
  /** The customer-type display name, empty when the customer holds no type. */
  customerTypeName: Scalars['String']['output'];
  /**
   * The early-pay discounts the customer took on those payments — money that settled part of a bill
   * without arriving as cash.
   */
  discountsTaken: Scalars['Decimal']['output'];
  /** The discountsTaken as the customer's currency prints it. */
  discountsTakenFormatted: Scalars['String']['output'];
  /**
   * The finance charges assessed with those payments. ADDS to what the customer was owed, which is
   * why it enters netActivity with the opposite sign to every other column.
   */
  lateChargesAssessed: Scalars['Decimal']['output'];
  /** The lateChargesAssessed as the customer's currency prints it. */
  lateChargesAssessedFormatted: Scalars['String']['output'];
  /**
   * The period's net movement on the account:
   * salesTotal − creditsTotal − paymentsTotal − discountsTaken + lateChargesAssessed.
   */
  netActivity: Scalars['Decimal']['output'];
  /** The netActivity as the customer's currency prints it. */
  netActivityFormatted: Scalars['String']['output'];
  /** How many recorded payments made up paymentsTotal. */
  paymentsCount: Scalars['Int']['output'];
  /**
   * The cash received from the customer in the window — the payments ds-cash-receipts lists
   * one per row, summed.
   */
  paymentsTotal: Scalars['Decimal']['output'];
  /** The paymentsTotal as the customer's currency prints it. */
  paymentsTotalFormatted: Scalars['String']['output'];
  /** How many non-credit orders made up salesTotal. */
  salesCount: Scalars['Int']['output'];
  /** What the customer was sold in the window — the total of every NON-CREDIT order raised in it. */
  salesTotal: Scalars['Decimal']['output'];
  /** The salesTotal as the customer's currency prints it — e.g. $1,234.56. */
  salesTotalFormatted: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportCustomersData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters; when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportCustomersDataPayload = {
  __typename?: 'ReportCustomersDataPayload';
  /** Gets the customer rows returned for the current page. */
  data: Array<ReportCustomerDataRow>;
  /** Gets the number of rows returned after the page cap. */
  totalCount: Scalars['Int']['output'];
  /** Gets the number of customers matching the filters before the page cap. */
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/** Payload wrapper for the reportCycleCountHistoryData query. */
export type ReportCycleCountHistoryDataPayload = {
  __typename?: 'ReportCycleCountHistoryDataPayload';
  /** The returned cycle count item rows. */
  data: Array<ReportCycleCountHistoryItemData>;
  /** The number of rows returned after applying the page limit. */
  totalCount: Scalars['Int']['output'];
  /** The total number of rows matching the filters before applying the page limit. */
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the report's grand-total row, one entry per summable column. Projected from the map
   * ReportCycleCountHistoryDataSource.ReadAsync already folded — never summed a second time
   * here, so the preview and the CSV / Excel / PDF arm publish the same figures by construction.
   */
  totals: Array<ReportColumnTotal>;
};

/** Flattened cycle count history record for report generation. */
export type ReportCycleCountHistoryItemData = {
  __typename?: 'ReportCycleCountHistoryItemData';
  /** Gets the UTC timestamp when the count was posted. */
  countedAt: Scalars['DateTime']['output'];
  /** Gets the hard-count quantity recorded for this item. */
  countedQuantity: Scalars['Decimal']['output'];
  /** Gets the cycle count submission identifier. */
  cycleCountId: Scalars['String']['output'];
  /** Gets the counted item identifier. */
  itemId: Scalars['String']['output'];
  /** Gets the counted item display name. */
  itemName: Scalars['String']['output'];
  /** Gets the counted location identifier. */
  locationId: Scalars['String']['output'];
  /** Gets the counted location display name. */
  locationName: Scalars['String']['output'];
  /**
   * Gets a value indicating whether the counted item is a native plant species, joined from the
   * item read model. Unlike Sku/ItemName — which are point-in-time snapshots frozen onto the
   * count — this reflects the item as configured today, because the count record has no Native.
   */
  native: Scalars['Boolean']['output'];
  /** Gets the counted item SKU. */
  sku: Scalars['String']['output'];
  /** Gets the user id, mapped from the cycle count RecordedBy email. */
  userId: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportDailySalesSummaryData query. TotalCount is the number
 * of rows returned; TotalMatching is the number matching the filters — when
 * TotalMatching > TotalCount the client should prompt the user to narrow the selection.
 */
export type ReportDailySalesSummaryDataPayload = {
  __typename?: 'ReportDailySalesSummaryDataPayload';
  /** Gets the returned rows — one per order, or one per ship day in summary mode. */
  data: Array<ReportDailySalesSummaryDataRow>;
  /** Gets the number of rows returned after applying the page limit. */
  totalCount: Scalars['Int']['output'];
  /** Gets the number of rows matching the filters before the page limit. */
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the report's grand-total row, one entry per summable column. The payload-level
   * replacement for the deprecated per-row report*Total fields.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of the Daily Sales Summary — an ORDER in detail mode, a SHIP DAY in summary mode.
 * GrowPoint's Daily Sales Summary (v26.09A, Accounts Receivable) at reduced scope.
 */
export type ReportDailySalesSummaryDataRow = {
  __typename?: 'ReportDailySalesSummaryDataRow';
  /** Bill-to customer code. Empty on a date-summary row. */
  customerCode: Scalars['String']['output'];
  /** Bill-to customer id. Empty on a date-summary row. */
  customerId: Scalars['String']['output'];
  /** Bill-to customer name. Empty on a date-summary row. */
  customerName: Scalars['String']['output'];
  /** Customer type id, taken from the bill-to account — the value the Customer Types filter matches on. Empty on a date-summary row. */
  customerTypeId: Scalars['String']['output'];
  /** Customer type name, taken from the bill-to account. Empty on a date-summary row. */
  customerTypeName: Scalars['String']['output'];
  /** Applied discount for this row's ship day, folded over the rows returned. Day Gross Sales less this is Day Net Sales. */
  dateDiscount: Scalars['Decimal']['output'];
  /** Gross sales for this row's ship day, folded over the rows returned. */
  dateGrossSales: Scalars['Decimal']['output'];
  /** Net sales for this row's ship day, folded over the rows returned. */
  dateNetSales: Scalars['Decimal']['output'];
  /** Orders on this row's ship day, over the rows returned. */
  dateOrderCount: Scalars['Int']['output'];
  /** Order totals for this row's ship day, folded over the rows returned. */
  dateOrderTotal: Scalars['Decimal']['output'];
  /** Echo of the Date Summary Only parameter, matching Is Date Summary on every row of a render. */
  dateSummaryOnly: Scalars['Boolean']['output'];
  /** The discount applied to the order: its effective discount amount, or 0 when the order has no positive line subtotal to discount. Gross Sales less this is Net Sales. */
  discount: Scalars['Decimal']['output'];
  /** True on the first row of a contiguous run of rows sharing a ship day, so a template can open a day band. Under a sort other than Ship Date the same day can begin several runs. */
  firstOfDate: Scalars['Boolean']['output'];
  /** Gross sales — the live sum of the order's line revenue, before the order-level discount. Computed from the lines rather than read from the order's stored subtotal, which is not maintained by later line edits. */
  grossSales: Scalars['Decimal']['output'];
  /** True when this row is a whole ship day rather than a single order. Set by the Date Summary Only parameter, which changes the row grain; on a summary row the order-level columns are empty and Order Count carries the day's order count. */
  isDateSummary: Scalars['Boolean']['output'];
  /** True on the last row of a contiguous run of rows sharing a ship day, so a template can print the day subtotal under it. */
  lastOfDate: Scalars['Boolean']['output'];
  /**
   * True on the final row returned. Legacy gate for the report total; read the payload-level `totals` map instead.
   * @deprecated The grand-total row no longer rides on a row: read the payload-level `totals` map (totals: [ReportColumnTotal!]!) outside the row loop. Retained until saved reports migrate their bindings.
   */
  lastRow: Scalars['Boolean']['output'];
  /** Net sales — gross less the order's effective discount. This is the figure the day and report totals fold, and the basis Sales by Category, Sales Comparison and the Sales History reports use, so the same window reconciles across all of them. */
  netSales: Scalars['Decimal']['output'];
  /** Orders behind this row — always 1 on a detail row, the day's count on a summary row. */
  orderCount: Scalars['Int']['output'];
  /** Order id. Empty on a date-summary row. */
  orderId: Scalars['String']['output'];
  /** Order number. Empty on a date-summary row. */
  orderNumber: Scalars['String']['output'];
  /** Order status. Empty on a date-summary row. */
  orderStatus: Scalars['String']['output'];
  /** The order's own total (an override total if one was set, otherwise subtotal less discount plus freight, royalty and tax) — what the customer was billed. Informational: the day and report totals fold Net Sales, not this. Do not add the two together. */
  orderTotal: Scalars['Decimal']['output'];
  /** Customer PO number. Empty on a date-summary row. */
  poNumber: Scalars['String']['output'];
  /** Echo of the Print Ship To Name parameter. Presentation only — the Ship To Name column is always populated, so turning it on cannot change a total. */
  printShipToName: Scalars['Boolean']['output'];
  /**
   * Net sales across every row returned.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportNetSales: Scalars['Decimal']['output'];
  /**
   * Orders across every row returned.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportOrderCount: Scalars['Int']['output'];
  /**
   * Order totals across every row returned.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportOrderTotal: Scalars['Decimal']['output'];
  /** Salesperson email recorded on the order. Empty on a date-summary row. */
  salesPerson: Scalars['String']['output'];
  /** Ship date — the order's expected delivery date, which is what the Ship Date From/To filter bounds. On a summary row this is the day the row rolls up. */
  shipDate: Scalars['DateTime']['output'];
  /** Ship-to location code recorded on the order — the value the Ship To Code filter matches. Empty on a date-summary row. */
  shipToCode: Scalars['String']['output'];
  /** Ship-to location name. GrowPoint's "print Ship To customer name" switch is the Print Ship To Name parameter, echoed onto every row; the column is always populated, so the switch cannot change a total. Empty on a date-summary row. */
  shipToName: Scalars['String']['output'];
  /** Ship-to state or province. Empty on a date-summary row. */
  shipToState: Scalars['String']['output'];
};

export type ReportData = {
  __typename?: 'ReportData';
  /** OPEN for a report everyone in the company may use and change; OWNED for a saved view. */
  access: ReportAccess;
  appTags: Array<AppTag>;
  craftJsTemplate: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  filters: Scalars['String']['output'];
  folderId?: Maybe<Scalars['String']['output']>;
  /** Who else may use or change an owned view. */
  grants: Array<ReportGrantData>;
  handlebarsTemplate: Scalars['String']['output'];
  isStarred: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The owner's email on an owned view; null on an open report. */
  owner?: Maybe<Scalars['String']['output']>;
  pageSettings: Scalars['String']['output'];
  parameterConfig: Scalars['String']['output'];
  parameterValues: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  /**
   * The spreadsheet layout CSV and Excel exports follow: a JSON array of { "header", "value" }
   * columns, each value a Handlebars template rendered per row. [] keeps the default columns.
   */
  spreadsheetColumns: Scalars['String']['output'];
  status: ReportStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Report data source document — read-only cross-tenant seed collection defining available
 * data sources for the reports feature (e.g., Orders). Seeded at startup by
 * ReportDataSourceSeedService.
 */
export type ReportDataSourceDocument = {
  __typename?: 'ReportDataSourceDocument';
  /** Category for grouping data sources */
  category: Scalars['String']['output'];
  /** Description of the data source */
  description: Scalars['String']['output'];
  /** Available fields that can be selected from this data source */
  fields: Array<ReportDataSourceField>;
  /**
   * The groupings this source can print a header or subtotal row for. Empty means the source
   * offers none.
   */
  groupBy: Array<ReportDataSourceGroupBy>;
  /** Unique data source identifier (e.g., "orders") */
  id: Scalars['String']['output'];
  /** Display name of the data source */
  name: Scalars['String']['output'];
  /** Parameters that can be used to filter this data source */
  parameters: Array<ReportDataSourceParameter>;
  /** GraphQL query name to fetch data from this source */
  queryName: Scalars['String']['output'];
  /**
   * Column paths this source's grand-total row may sum, e.g. orderedQuantity. The report
   * builder offers "Show total row" over the chosen columns intersected with this list, and emits
   * {{totals.<column>}} after the {{/each}}, reading the payload's totals
   * map. Empty means the source offers no total row.
   */
  reportTotals: Array<Scalars['String']['output']>;
};

/**
 * Report data source document — read-only cross-tenant seed collection defining available
 * data sources for the reports feature (e.g., Orders). Seeded at startup by
 * ReportDataSourceSeedService.
 */
export type ReportDataSourceDocumentFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceDocumentFilterInput>>;
  /** Category for grouping data sources */
  category?: InputMaybe<StringOperationFilterInput>;
  /** Description of the data source */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Available fields that can be selected from this data source */
  fields?: InputMaybe<ListFilterInputTypeOfReportDataSourceFieldFilterInput>;
  /**
   * The groupings this source can print a header or subtotal row for. Empty means the source
   * offers none.
   */
  groupBy?: InputMaybe<ListFilterInputTypeOfReportDataSourceGroupByFilterInput>;
  /** Unique data source identifier (e.g., "orders") */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Display name of the data source */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceDocumentFilterInput>>;
  /** Parameters that can be used to filter this data source */
  parameters?: InputMaybe<ListFilterInputTypeOfReportDataSourceParameterFilterInput>;
  /** GraphQL query name to fetch data from this source */
  queryName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Column paths this source's grand-total row may sum, e.g. orderedQuantity. The report
   * builder offers "Show total row" over the chosen columns intersected with this list, and emits
   * {{totals.<column>}} after the {{/each}}, reading the payload's totals
   * map. Empty means the source offers no total row.
   */
  reportTotals?: InputMaybe<ListStringOperationFilterInput>;
};

/**
 * Report data source document — read-only cross-tenant seed collection defining available
 * data sources for the reports feature (e.g., Orders). Seeded at startup by
 * ReportDataSourceSeedService.
 */
export type ReportDataSourceDocumentSortInput = {
  /** Category for grouping data sources */
  category?: InputMaybe<SortEnumType>;
  /** Description of the data source */
  description?: InputMaybe<SortEnumType>;
  /** Unique data source identifier (e.g., "orders") */
  id?: InputMaybe<SortEnumType>;
  /** Display name of the data source */
  name?: InputMaybe<SortEnumType>;
  /** GraphQL query name to fetch data from this source */
  queryName?: InputMaybe<SortEnumType>;
};

/** Field definition within a report data source, supporting nested hierarchies. */
export type ReportDataSourceField = {
  __typename?: 'ReportDataSourceField';
  /** Item fields for array types */
  arrayItemFields?: Maybe<Array<ReportDataSourceField>>;
  /** Child fields for object types */
  children?: Maybe<Array<ReportDataSourceField>>;
  /** Optional description of the field */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique field identifier */
  id: Scalars['String']['output'];
  /** Display label for the field */
  label: Scalars['String']['output'];
  /** Dot-notation path to the field in the data */
  path: Scalars['String']['output'];
  /** Data type (string, number, date, enum, object, array) */
  type: Scalars['String']['output'];
};

/** Field definition within a report data source, supporting nested hierarchies. */
export type ReportDataSourceFieldFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceFieldFilterInput>>;
  /** Item fields for array types */
  arrayItemFields?: InputMaybe<ListFilterInputTypeOfReportDataSourceFieldFilterInput>;
  /** Child fields for object types */
  children?: InputMaybe<ListFilterInputTypeOfReportDataSourceFieldFilterInput>;
  /** Optional description of the field */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Unique field identifier */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Display label for the field */
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceFieldFilterInput>>;
  /** Dot-notation path to the field in the data */
  path?: InputMaybe<StringOperationFilterInput>;
  /** Data type (string, number, date, enum, object, array) */
  type?: InputMaybe<StringOperationFilterInput>;
};

/** One grouping a report data source can print a header or subtotal row for. */
export type ReportDataSourceGroupBy = {
  __typename?: 'ReportDataSourceGroupBy';
  /**
   * Row field that is true on the FIRST row of each run — gates a group header row. Null when the
   * source stamps no opening marker.
   */
  firstRowFlag?: Maybe<Scalars['String']['output']>;
  /** Row fields carrying the group's identifying labels, for the header row */
  headerFields: Array<ReportDataSourceGroupHeaderField>;
  /** Stable identifier for the grouping, e.g. "item" or "salesPerson" */
  key: Scalars['String']['output'];
  /** Display label for the grouping, as the builder's "Group by" picker renders it */
  label: Scalars['String']['output'];
  /**
   * Row field that is true on the LAST row of each run — gates a group subtotal row. Null when
   * the source stamps no closing marker.
   */
  lastRowFlag?: Maybe<Scalars['String']['output']>;
  /**
   * A parameter that must carry a particular value before the source stamps these flags at all.
   * Null when the grouping needs no parameter beyond requiresSort.
   */
  requiresParameter?: Maybe<ReportDataSourceGroupParameter>;
  /**
   * The sortBy value that makes rows of this group contiguous. Null when the source's
   * ordering is fixed and the rows are always contiguous, or when the source offers no
   * sortBy at all.
   */
  requiresSort?: Maybe<Scalars['String']['output']>;
  /** Subtotals this grouping carries, each naming the column it sums */
  totals: Array<ReportDataSourceGroupTotal>;
};

/** One grouping a report data source can print a header or subtotal row for. */
export type ReportDataSourceGroupByFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceGroupByFilterInput>>;
  /**
   * Row field that is true on the FIRST row of each run — gates a group header row. Null when the
   * source stamps no opening marker.
   */
  firstRowFlag?: InputMaybe<StringOperationFilterInput>;
  /** Row fields carrying the group's identifying labels, for the header row */
  headerFields?: InputMaybe<ListFilterInputTypeOfReportDataSourceGroupHeaderFieldFilterInput>;
  /** Stable identifier for the grouping, e.g. "item" or "salesPerson" */
  key?: InputMaybe<StringOperationFilterInput>;
  /** Display label for the grouping, as the builder's "Group by" picker renders it */
  label?: InputMaybe<StringOperationFilterInput>;
  /**
   * Row field that is true on the LAST row of each run — gates a group subtotal row. Null when
   * the source stamps no closing marker.
   */
  lastRowFlag?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceGroupByFilterInput>>;
  /**
   * A parameter that must carry a particular value before the source stamps these flags at all.
   * Null when the grouping needs no parameter beyond requiresSort.
   */
  requiresParameter?: InputMaybe<ReportDataSourceGroupParameterFilterInput>;
  /**
   * The sortBy value that makes rows of this group contiguous. Null when the source's
   * ordering is fixed and the rows are always contiguous, or when the source offers no
   * sortBy at all.
   */
  requiresSort?: InputMaybe<StringOperationFilterInput>;
  /** Subtotals this grouping carries, each naming the column it sums */
  totals?: InputMaybe<ListFilterInputTypeOfReportDataSourceGroupTotalFilterInput>;
};

/** A row field printed on a group's header row. */
export type ReportDataSourceGroupHeaderField = {
  __typename?: 'ReportDataSourceGroupHeaderField';
  /** Column path on the row, e.g. customerName */
  fieldPath: Scalars['String']['output'];
  /** Display label for the field on the header row */
  label: Scalars['String']['output'];
};

/** A row field printed on a group's header row. */
export type ReportDataSourceGroupHeaderFieldFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceGroupHeaderFieldFilterInput>>;
  /** Column path on the row, e.g. customerName */
  fieldPath?: InputMaybe<StringOperationFilterInput>;
  /** Display label for the field on the header row */
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceGroupHeaderFieldFilterInput>>;
};

/** A parameter value a grouping requires before its flags are populated. */
export type ReportDataSourceGroupParameter = {
  __typename?: 'ReportDataSourceGroupParameter';
  /** Name of the parameter, matching a declared ReportDataSourceParameter.Name */
  name: Scalars['String']['output'];
  /**
   * The value it must carry, as the parameter JSON spells it — "true" for a boolean
   * switch, the member name for an enum.
   */
  value: Scalars['String']['output'];
};

/** A parameter value a grouping requires before its flags are populated. */
export type ReportDataSourceGroupParameterFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceGroupParameterFilterInput>>;
  /** Name of the parameter, matching a declared ReportDataSourceParameter.Name */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceGroupParameterFilterInput>>;
  /**
   * The value it must carry, as the parameter JSON spells it — "true" for a boolean
   * switch, the member name for an enum.
   */
  value?: InputMaybe<StringOperationFilterInput>;
};

/** One subtotal a grouping carries: the COLUMN it sums, and the row field holding that sum. */
export type ReportDataSourceGroupTotal = {
  __typename?: 'ReportDataSourceGroupTotal';
  /** The column path being summed, e.g. allocatedQuantity */
  column: Scalars['String']['output'];
  /** The row field carrying that sum, e.g. locationCommittedTotal */
  field: Scalars['String']['output'];
};

/** One subtotal a grouping carries: the COLUMN it sums, and the row field holding that sum. */
export type ReportDataSourceGroupTotalFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceGroupTotalFilterInput>>;
  /** The column path being summed, e.g. allocatedQuantity */
  column?: InputMaybe<StringOperationFilterInput>;
  /** The row field carrying that sum, e.g. locationCommittedTotal */
  field?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceGroupTotalFilterInput>>;
};

/** Configuration for LOOKUP-type parameters that render as entity search autocompletes. */
export type ReportDataSourceLookupConfig = {
  __typename?: 'ReportDataSourceLookupConfig';
  /** Fields to display in the dropdown */
  displayFields: Array<Scalars['String']['output']>;
  /** Entity to search (e.g., "customer", "item", "order") */
  entity: Scalars['String']['output'];
  /** Field to use as the selected value */
  valueField: Scalars['String']['output'];
};

/** Configuration for LOOKUP-type parameters that render as entity search autocompletes. */
export type ReportDataSourceLookupConfigFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceLookupConfigFilterInput>>;
  /** Fields to display in the dropdown */
  displayFields?: InputMaybe<ListStringOperationFilterInput>;
  /** Entity to search (e.g., "customer", "item", "order") */
  entity?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceLookupConfigFilterInput>>;
  /** Field to use as the selected value */
  valueField?: InputMaybe<StringOperationFilterInput>;
};

/** Parameter definition for filtering a report data source. */
export type ReportDataSourceParameter = {
  __typename?: 'ReportDataSourceParameter';
  /** Default value if not specified */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Optional description of the parameter */
  description?: Maybe<Scalars['String']['output']>;
  /** Allowed values for enum-type parameters */
  enumValues?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether this parameter is required */
  isRequired: Scalars['Boolean']['output'];
  /** Display label for the parameter */
  label: Scalars['String']['output'];
  /**
   * Element type for LIST-type parameters (e.g. "STRING"); the builder/preview and the
   * bulk-render ribbon read this to render a multi-value input. Null for scalar parameters.
   */
  listType?: Maybe<Scalars['String']['output']>;
  /** Lookup configuration for LOOKUP-type parameters */
  lookupConfig?: Maybe<ReportDataSourceLookupConfig>;
  /** Parameter name used in queries */
  name: Scalars['String']['output'];
  /** Data type (string, number, date, enum, list) */
  type: Scalars['String']['output'];
};

/** Parameter definition for filtering a report data source. */
export type ReportDataSourceParameterFilterInput = {
  and?: InputMaybe<Array<ReportDataSourceParameterFilterInput>>;
  /** Default value if not specified */
  defaultValue?: InputMaybe<StringOperationFilterInput>;
  /** Optional description of the parameter */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Allowed values for enum-type parameters */
  enumValues?: InputMaybe<ListStringOperationFilterInput>;
  /** Whether this parameter is required */
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  /** Display label for the parameter */
  label?: InputMaybe<StringOperationFilterInput>;
  /**
   * Element type for LIST-type parameters (e.g. "STRING"); the builder/preview and the
   * bulk-render ribbon read this to render a multi-value input. Null for scalar parameters.
   */
  listType?: InputMaybe<StringOperationFilterInput>;
  /** Lookup configuration for LOOKUP-type parameters */
  lookupConfig?: InputMaybe<ReportDataSourceLookupConfigFilterInput>;
  /** Parameter name used in queries */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDataSourceParameterFilterInput>>;
  /** Data type (string, number, date, enum, list) */
  type?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One order on a load shipping on the requested date, ordered by load number then
 * drop number. The load's own columns (load, route, truck, driver, dock) repeat on every one of its drops,
 * and the first-of-load and last-of-load flags mark each load's band.
 */
export type ReportDayRouteScheduleData = {
  __typename?: 'ReportDayRouteScheduleData';
  /** Gets the planned container count on the load line, or null when none is planned. */
  containerCount?: Maybe<Scalars['Int']['output']>;
  /** Gets the name of the container configuration the load ships in. */
  containerName: Scalars['String']['output'];
  /** Gets the customer name recorded on the load line. */
  customerName: Scalars['String']['output'];
  /** Gets the delivery address of the drop's route stop, or null when it names no stop. */
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  /** Gets the name of the dock the load ships from, or null when it has none. */
  dockName?: Maybe<Scalars['String']['output']>;
  /** Gets the driver's name, or null when the load has no driver. */
  driverName?: Maybe<Scalars['String']['output']>;
  /** Gets the driver's phone, or null when the load has no driver. */
  driverPhone?: Maybe<Scalars['String']['output']>;
  /** Gets the occupied route stop number on the full load, shared by orders at that stop; null for unplaced orders. */
  dropNumber?: Maybe<Scalars['Int']['output']>;
  /** Gets whether this is the first drop of its load, the row a template opens the load's band on. */
  firstOfLoad: Scalars['Boolean']['output'];
  /** Gets whether this is the last drop of its load. */
  lastOfLoad: Scalars['Boolean']['output'];
  /** Gets the load number. */
  loadNumber: Scalars['Int']['output'];
  /** Gets the load's status name (Planning, Loaded, Dispatched, Delivered). */
  loadStatus: Scalars['String']['output'];
  /** Gets the order number of the drop's load line. */
  orderNumber: Scalars['String']['output'];
  /** Gets the planned arrival at the drop's stop as stored (HH:mm), or null when none is planned. */
  plannedArrival?: Maybe<Scalars['String']['output']>;
  /** Gets the order's customer P.O. number, or null when the order is not in the read model. */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** Gets the ship-to's region, or null when the ship-to has none. */
  region?: Maybe<Scalars['String']['output']>;
  /** Gets the route code, or null when the load has no route. */
  routeCode?: Maybe<Scalars['String']['output']>;
  /** Gets the route name, or null when the load has no route. */
  routeName?: Maybe<Scalars['String']['output']>;
  /** Gets the ship date the report was run for. */
  shipDate: Scalars['LocalDate']['output'];
  /** Gets the ship-to's name, or null when the drop's stop names no ship-to. */
  shipToName?: Maybe<Scalars['String']['output']>;
  /** Gets the truck's name, or null when the load has no vehicle. */
  vehicleName?: Maybe<Scalars['String']['output']>;
};

/**
 * Payload wrapper for the reportDayRouteScheduleData query. TotalCount is the number of order rows returned
 * (capped by first and at 5000). TotalMatching is the number of order rows the caller may see on that
 * ship date before the cap.
 */
export type ReportDayRouteScheduleDataPayload = {
  __typename?: 'ReportDayRouteScheduleDataPayload';
  data: Array<ReportDayRouteScheduleData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /** The report's grand total. Always empty: ds-day-route-schedule declares no summable column. */
  totals: Array<ReportColumnTotal>;
};

/** Flattened demand vs supply record for report generation. One row per item. */
export type ReportDemandVsSupplyData = {
  __typename?: 'ReportDemandVsSupplyData';
  /** The available quantity in units, cut toward zero at two decimals. Null when the item has no unit. */
  availableDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The total available inventory quantity for the item. */
  availableQuantity: Scalars['Decimal']['output'];
  /** The available quantity as a document prints it. The bare quantity, exactly as availableQuantity prints, when the item has no named unit. */
  availableQuantityText: Scalars['String']['output'];
  /** The booked quantity in units, cut toward zero at two decimals. Null when the item has no unit. */
  bookedDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The total open booked order quantity (Submitted / Acknowledged / Picked / SyncError, net of shipped quantities) for the item in the selected window. */
  bookedQuantity: Scalars['Decimal']['output'];
  /** The booked quantity as a document prints it, "2 (4.5 inch tray) · 30 ea". The bare quantity, exactly as bookedQuantity prints, when the item has no named unit. */
  bookedQuantityText: Scalars['String']['output'];
  /** How many eaches one unit of that Shipping UOM holds, as it states today. Null when the pack is one or unstated. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /** The item genus code. */
  genusCode: Scalars['String']['output'];
  /** The item identifier. */
  itemId: Scalars['String']['output'];
  /** The item display name. */
  itemName: Scalars['String']['output'];
  /** Whether the item is a native plant species. */
  native: Scalars['Boolean']['output'];
  /** The total net supply, calculated from on-hand inventory plus scheduled production. */
  netSupply: Scalars['Decimal']['output'];
  /** The net supply in units, cut toward zero at two decimals. Null when the item has no unit. */
  netSupplyDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The net supply as a document prints it. The bare quantity, exactly as netSupply prints, when the item has no named unit. */
  netSupplyText: Scalars['String']['output'];
  /** The on-hand quantity in units, cut toward zero at two decimals. Null when the item has no unit. */
  onHandDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The total on-hand inventory quantity for the item. */
  onHandQuantity: Scalars['Decimal']['output'];
  /** The on-hand quantity as a document prints it. The bare quantity, exactly as onHandQuantity prints, when the item has no named unit. */
  onHandQuantityText: Scalars['String']['output'];
  /** The scheduled production quantity in units, cut toward zero at two decimals. Null when the item has no unit. */
  scheduledProductionDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The total scheduled production quantity for the item in the selected window. */
  scheduledProductionQuantity: Scalars['Decimal']['output'];
  /** The scheduled production quantity as a document prints it. The bare quantity, exactly as scheduledProductionQuantity prints, when the item has no named unit. */
  scheduledProductionQuantityText: Scalars['String']['output'];
  /** The name of the Shipping UOM the item ships as today, the unit a document prints beside each quantity ("4.5 inch tray"). Null when the item's pack is one or unstated, and when its Shipping UOM has no name. */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /** The shortage quantity, calculated as booked demand beyond net supply. */
  shortage: Scalars['Decimal']['output'];
  /** The shortage in units, cut toward zero at two decimals. Null when the item has no unit. */
  shortageDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The shortage as a document prints it. The bare quantity, exactly as shortage prints, when the item has no named unit. */
  shortageText: Scalars['String']['output'];
  /** The signed cover position, net supply minus booked demand. Negative means the item is short by that much; zero or positive means booked demand is covered. Unlike shortage, it is not floored at zero. */
  shortfall: Scalars['Decimal']['output'];
  /** The shortfall in units, cut toward zero at two decimals, negative when short. Null when the item has no unit. */
  shortfallDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The shortfall as a document prints it, negative when short. The bare quantity, exactly as shortfall prints, when the item has no named unit. */
  shortfallText: Scalars['String']['output'];
  /** The item SKU. */
  sku: Scalars['String']['output'];
  /** The inclusive lower date-window bound applied to demand and scheduled production. */
  windowFrom?: Maybe<Scalars['DateTime']['output']>;
  /** The inclusive upper date-window bound applied to demand and scheduled production. */
  windowTo?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Payload wrapper for the reportDemandVsSupplyData query. TotalCount is the number of records returned
 * after applying the row limit. TotalMatching is the total number of records matching the filters before limiting.
 */
export type ReportDemandVsSupplyDataPayload = {
  __typename?: 'ReportDemandVsSupplyDataPayload';
  /** The returned demand vs supply rows. */
  data: Array<ReportDemandVsSupplyData>;
  /** The number of rows returned after applying the row limit. */
  totalCount: Scalars['Int']['output'];
  /** The total number of rows matching the filters before applying the row limit. */
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the report's grand-total row, one entry per summable column. Projected from the map
   * ReportDemandVsSupplyDataSource.ReadAsync already folded — never summed a second time
   * here, so the preview and the CSV / Excel / PDF arm publish the same figures by construction.
   */
  totals: Array<ReportColumnTotal>;
};

/** One load an order rides and the dock that load ships from, as a picking or load document prints it. */
export type ReportDockAssignmentData = {
  __typename?: 'ReportDockAssignmentData';
  /** How many containers of the order ride this load. Null when none was recorded. */
  containerCount?: Maybe<Scalars['Int']['output']>;
  /** The dock the load ships from, exactly as it is stored. The word Dock is never added. */
  dockName: Scalars['String']['output'];
  /** The number of the load the order rides. */
  loadNumber: Scalars['Int']['output'];
  /** The order's portion of this load, e.g. Load 12, 3 containers. Set only when the order rides more than one load, so a split order shows each dock beside its portion. Empty otherwise. */
  portionLabel: Scalars['String']['output'];
};

export type ReportDocument = {
  __typename?: 'ReportDocument';
  /**
   * OPEN: everyone in the company may use and change it, as every report could before saved views. OWNED: a saved
   * view, open to its owner, a company admin and the people its grants name. Reports saved before saved views
   * store no value and read OPEN, so filter with neq: OWNED, never eq: OPEN.
   */
  access: ReportAccess;
  appTags: Array<AppTag>;
  craftJsTemplate: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  filters: Scalars['String']['output'];
  folderId?: Maybe<Scalars['String']['output']>;
  /** Who else may use or change an owned view: people by email, or the whole company. */
  grants: Array<ReportGrantDocument>;
  handlebarsTemplate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isStarred: Scalars['Boolean']['output'];
  /**
   * What the signed-in caller may do with this report. use: open it and run its row actions within their own
   * rights. change: edit it. share: give, change or remove grants (the owner or a company admin, on an owned view).
   */
  myRights: ReportRights;
  name: Scalars['String']['output'];
  /** The owner's email on an owned view; null on an open report. */
  owner?: Maybe<Scalars['String']['output']>;
  pageSettings: Scalars['String']['output'];
  parameterConfig: Scalars['String']['output'];
  parameterValues: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  /**
   * The spreadsheet layout CSV and Excel exports follow: a JSON array of { "header", "value" }
   * columns, each value a Handlebars template rendered per row. [] keeps the default columns.
   */
  spreadsheetColumns: Scalars['String']['output'];
  status: ReportStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ReportDocumentFilterInput = {
  /**
   * OPEN: everyone in the company may use and change it, as every report could before saved views. OWNED: a saved
   * view, open to its owner, a company admin and the people its grants name. Reports saved before saved views
   * store no value and read OPEN, so filter with neq: OWNED, never eq: OPEN.
   */
  access?: InputMaybe<ReportAccessOperationFilterInput>;
  and?: InputMaybe<Array<ReportDocumentFilterInput>>;
  appTags?: InputMaybe<ListAppTagOperationFilterInput>;
  craftJsTemplate?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  dataSourceId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  filters?: InputMaybe<StringOperationFilterInput>;
  folderId?: InputMaybe<StringOperationFilterInput>;
  /** Who else may use or change an owned view: people by email, or the whole company. */
  grants?: InputMaybe<ListFilterInputTypeOfReportGrantDocumentFilterInput>;
  handlebarsTemplate?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isStarred?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDocumentFilterInput>>;
  /** The owner's email on an owned view; null on an open report. */
  owner?: InputMaybe<StringOperationFilterInput>;
  pageSettings?: InputMaybe<StringOperationFilterInput>;
  parameterConfig?: InputMaybe<StringOperationFilterInput>;
  parameterValues?: InputMaybe<StringOperationFilterInput>;
  reportId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The spreadsheet layout CSV and Excel exports follow: a JSON array of { "header", "value" }
   * columns, each value a Handlebars template rendered per row. [] keeps the default columns.
   */
  spreadsheetColumns?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ReportStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ReportDocumentSortInput = {
  /**
   * OPEN: everyone in the company may use and change it, as every report could before saved views. OWNED: a saved
   * view, open to its owner, a company admin and the people its grants name. Reports saved before saved views
   * store no value and read OPEN, so filter with neq: OWNED, never eq: OPEN.
   */
  access?: InputMaybe<SortEnumType>;
  craftJsTemplate?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  dataSourceId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  filters?: InputMaybe<SortEnumType>;
  folderId?: InputMaybe<SortEnumType>;
  handlebarsTemplate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isStarred?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /** The owner's email on an owned view; null on an open report. */
  owner?: InputMaybe<SortEnumType>;
  pageSettings?: InputMaybe<SortEnumType>;
  parameterConfig?: InputMaybe<SortEnumType>;
  parameterValues?: InputMaybe<SortEnumType>;
  reportId?: InputMaybe<SortEnumType>;
  /**
   * The spreadsheet layout CSV and Excel exports follow: a JSON array of { "header", "value" }
   * columns, each value a Handlebars template rendered per row. [] keeps the default columns.
   */
  spreadsheetColumns?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/**
 * An order's drop-ship destination on report output: where the order is delivered instead of its
 * saved ship-to location. Every field is empty, and the pin null, when the order has none.
 */
export type ReportDropShipDestinationData = {
  __typename?: 'ReportDropShipDestinationData';
  /** The destination's city. Empty when it has none. */
  city: Scalars['String']['output'];
  /** The instructions for the driver at the destination. Empty when there are none. */
  deliveryNotes: Scalars['String']['output'];
  /** The destination's map pin latitude. Null when it has no pin. */
  latitude?: Maybe<Scalars['Decimal']['output']>;
  /** The destination's map pin longitude. Null when it has no pin. */
  longitude?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The name the destination prints under, such as the job site's name. Always set on a drop-ship
   * order, so a template can test it to tell a drop-ship order from an ordinary one.
   */
  name: Scalars['String']['output'];
  /** The destination's state or province. Empty when it has none. */
  state: Scalars['String']['output'];
  /** The destination's first address line. Empty when it has no street address, such as a map pin only. */
  street: Scalars['String']['output'];
  /** The destination's second address line. Empty when unused. */
  street2: Scalars['String']['output'];
  /** The destination's postal code. Empty when it has none. */
  zip: Scalars['String']['output'];
};

/**
 * Result of a generateReportExcel query. On success, ExcelBase64
 * carries the XLSX workbook bytes base64-encoded; on failure, ErrorMessage
 * carries a diagnostic string.
 */
export type ReportExcelPayload = {
  __typename?: 'ReportExcelPayload';
  /** An error description if generation failed, or null on success. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The base64-encoded XLSX workbook bytes, or null on failure. */
  excelBase64?: Maybe<Scalars['String']['output']>;
  /** Whether Excel generation succeeded. */
  success: Scalars['Boolean']['output'];
};

/** GraphQL data transfer object for a report execution record. */
export type ReportExecutionData = {
  __typename?: 'ReportExecutionData';
  /**
   * The lowercase hex SHA-256 of the PDF this execution generated, so a downloaded file can be matched to the
   * execution that produced it. Set only on successful runReport executions; null otherwise.
   */
  artifactSha256?: Maybe<Scalars['String']['output']>;
  /** The error message if the execution failed. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** When the execution occurred. */
  executedAt: Scalars['DateTime']['output'];
  /** The email of the executor. */
  executedBy: Scalars['String']['output'];
  /** The unique execution identifier. */
  executionId: Scalars['String']['output'];
  /** The optional order id this execution relates to. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** The JSON-serialised parameters used. */
  parameters?: Maybe<Scalars['String']['output']>;
  /** The size of the generated PDF in bytes. */
  pdfSizeBytes: Scalars['Long']['output'];
  /** The number of recipients the PDF was sent to. */
  recipientCount: Scalars['Int']['output'];
  /** The recipient email addresses. */
  recipients: Array<Scalars['String']['output']>;
  /** The report identifier that was executed. */
  reportId: Scalars['String']['output'];
  /** The report name snapshot at execution time. */
  reportName?: Maybe<Scalars['String']['output']>;
  /**
   * The saved report content version this execution rendered, as listed by reportVersions. Set only on
   * executions recorded by runReport; null on executions recorded through recordReportExecution.
   */
  reportVersion?: Maybe<Scalars['Long']['output']>;
  /** The schedule identifier that triggered this execution, if any. */
  scheduleId?: Maybe<Scalars['String']['output']>;
  /** The status of the execution record. */
  status: ReportExecutionStatus;
  /** Whether the execution succeeded. */
  success: Scalars['Boolean']['output'];
  /** The tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** The trigger type (Scheduled or Manual). */
  triggerType: Scalars['String']['output'];
};

/** MongoDB document representing a projected report execution record. */
export type ReportExecutionDocument = {
  __typename?: 'ReportExecutionDocument';
  /** Gets the lowercase hex SHA-256 of the PDF a successful runReport execution generated; null otherwise. */
  artifactSha256?: Maybe<Scalars['String']['output']>;
  /** Gets the error message if execution failed. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Gets the timestamp when the execution occurred. */
  executedAt: Scalars['DateTime']['output'];
  /** Gets the email of the executor. */
  executedBy: Scalars['String']['output'];
  /** Gets the unique execution identifier. */
  executionId: Scalars['String']['output'];
  /** Gets the MongoDB document identifier. */
  id: Scalars['String']['output'];
  /** Gets the optional order id this execution relates to (filterable on getReportExecutions). */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Gets the JSON-serialised parameters used. */
  parameters?: Maybe<Scalars['String']['output']>;
  /** Gets the size of the generated PDF in bytes. */
  pdfSizeBytes: Scalars['Long']['output'];
  /** Gets the number of recipients the PDF was sent to. */
  recipientCount: Scalars['Int']['output'];
  /** Gets the list of recipient email addresses. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the report identifier that was executed. */
  reportId: Scalars['String']['output'];
  /** Gets the report name snapshot at execution time. */
  reportName?: Maybe<Scalars['String']['output']>;
  /** Gets the saved report content version a runReport execution rendered; null for other executions. */
  reportVersion?: Maybe<Scalars['Long']['output']>;
  /** Gets the schedule identifier that triggered this execution. */
  scheduleId?: Maybe<Scalars['String']['output']>;
  /** Gets the status of the execution record. */
  status: ReportExecutionStatus;
  /** Gets a value indicating whether the execution succeeded. */
  success: Scalars['Boolean']['output'];
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the trigger type (Scheduled or Manual). */
  triggerType: Scalars['String']['output'];
};

/** MongoDB document representing a projected report execution record. */
export type ReportExecutionDocumentFilterInput = {
  and?: InputMaybe<Array<ReportExecutionDocumentFilterInput>>;
  /** Gets the lowercase hex SHA-256 of the PDF a successful runReport execution generated; null otherwise. */
  artifactSha256?: InputMaybe<StringOperationFilterInput>;
  /** Gets the error message if execution failed. */
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  /** Gets the timestamp when the execution occurred. */
  executedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the email of the executor. */
  executedBy?: InputMaybe<StringOperationFilterInput>;
  /** Gets the unique execution identifier. */
  executionId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportExecutionDocumentFilterInput>>;
  /** Gets the optional order id this execution relates to (filterable on getReportExecutions). */
  orderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the JSON-serialised parameters used. */
  parameters?: InputMaybe<StringOperationFilterInput>;
  /** Gets the size of the generated PDF in bytes. */
  pdfSizeBytes?: InputMaybe<LongOperationFilterInput>;
  /** Gets the number of recipients the PDF was sent to. */
  recipientCount?: InputMaybe<IntOperationFilterInput>;
  /** Gets the list of recipient email addresses. */
  recipients?: InputMaybe<ListStringOperationFilterInput>;
  /** Gets the report identifier that was executed. */
  reportId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the report name snapshot at execution time. */
  reportName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the saved report content version a runReport execution rendered; null for other executions. */
  reportVersion?: InputMaybe<LongOperationFilterInput>;
  /** Gets the schedule identifier that triggered this execution. */
  scheduleId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the status of the execution record. */
  status?: InputMaybe<ReportExecutionStatusOperationFilterInput>;
  /** Gets a value indicating whether the execution succeeded. */
  success?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the trigger type (Scheduled or Manual). */
  triggerType?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB document representing a projected report execution record. */
export type ReportExecutionDocumentSortInput = {
  /** Gets the lowercase hex SHA-256 of the PDF a successful runReport execution generated; null otherwise. */
  artifactSha256?: InputMaybe<SortEnumType>;
  /** Gets the error message if execution failed. */
  errorMessage?: InputMaybe<SortEnumType>;
  /** Gets the timestamp when the execution occurred. */
  executedAt?: InputMaybe<SortEnumType>;
  /** Gets the email of the executor. */
  executedBy?: InputMaybe<SortEnumType>;
  /** Gets the unique execution identifier. */
  executionId?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the optional order id this execution relates to (filterable on getReportExecutions). */
  orderId?: InputMaybe<SortEnumType>;
  /** Gets the JSON-serialised parameters used. */
  parameters?: InputMaybe<SortEnumType>;
  /** Gets the size of the generated PDF in bytes. */
  pdfSizeBytes?: InputMaybe<SortEnumType>;
  /** Gets the number of recipients the PDF was sent to. */
  recipientCount?: InputMaybe<SortEnumType>;
  /** Gets the report identifier that was executed. */
  reportId?: InputMaybe<SortEnumType>;
  /** Gets the report name snapshot at execution time. */
  reportName?: InputMaybe<SortEnumType>;
  /** Gets the saved report content version a runReport execution rendered; null for other executions. */
  reportVersion?: InputMaybe<SortEnumType>;
  /** Gets the schedule identifier that triggered this execution. */
  scheduleId?: InputMaybe<SortEnumType>;
  /** Gets the status of the execution record. */
  status?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the execution succeeded. */
  success?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Gets the trigger type (Scheduled or Manual). */
  triggerType?: InputMaybe<SortEnumType>;
};

/** Payload returned from report execution mutations. */
export type ReportExecutionPayload = {
  __typename?: 'ReportExecutionPayload';
  errors?: Maybe<Array<ValidationError>>;
  reportExecution?: Maybe<ReportExecutionData>;
};

export enum ReportExecutionStatus {
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export type ReportExecutionStatusOperationFilterInput = {
  eq?: InputMaybe<ReportExecutionStatus>;
  in?: InputMaybe<Array<ReportExecutionStatus>>;
  neq?: InputMaybe<ReportExecutionStatus>;
  nin?: InputMaybe<Array<ReportExecutionStatus>>;
};

/** A connection to a list of items. */
export type ReportExecutionsConnection = {
  __typename?: 'ReportExecutionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportExecutionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportExecutionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportExecutionsEdge = {
  __typename?: 'ReportExecutionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportExecutionDocument;
};

export type ReportFolderData = {
  __typename?: 'ReportFolderData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  folderId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ReportFolderDocument = {
  __typename?: 'ReportFolderDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  folderId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ReportFolderDocumentFilterInput = {
  and?: InputMaybe<Array<ReportFolderDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  folderId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportFolderDocumentFilterInput>>;
  parentId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type ReportFolderDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  folderId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type ReportFolderPayload = {
  __typename?: 'ReportFolderPayload';
  errors?: Maybe<Array<ValidationError>>;
  folder?: Maybe<ReportFolderData>;
};

/** A connection to a list of items. */
export type ReportFoldersConnection = {
  __typename?: 'ReportFoldersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportFoldersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportFolderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportFoldersEdge = {
  __typename?: 'ReportFoldersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportFolderDocument;
};

/** The ds-general-ledger-export preview payload. */
export type ReportGeneralLedgerExportDataPayload = {
  __typename?: 'ReportGeneralLedgerExportDataPayload';
  /** The Sage rows, capped to the caller's requested page size. */
  data: Array<ReportGeneralLedgerExportDataRow>;
  /** How many rows came back. */
  totalCount: Scalars['Int']['output'];
  /**
   * How many rows the period produced in total. A preview that shows fewer than this is a PARTIAL
   * ledger — its date groups will not foot — which is why the seeded template says so on its face and why
   * the export arm never applies a row cap of its own.
   */
  totalMatching: Scalars['Int']['output'];
};

/**
 * One Sage General Journal row as the report BUILDER sees it — GraphQL-legal field names, with the Sage
 * column spellings carried as the seeded labels.
 */
export type ReportGeneralLedgerExportDataRow = {
  __typename?: 'ReportGeneralLedgerExportDataRow';
  /** The signed amount: debits positive, credits negative, plain two-decimal. */
  amount: Scalars['String']['output'];
  /** The journal entry's date, formatted as Sage's importer reads it (7/1/2026). */
  date: Scalars['String']['output'];
  /** The line's description — Order : 14616 Houston Garden Centers. */
  description: Scalars['String']['output'];
  /** The tenant's G/L account number this line posts to. */
  glAccount: Scalars['String']['output'];
  /**
   * How many rows this row's DATE GROUP contains — Sage's Number of Distributions. Repeated on
   * every row of the group, which is the shape the importer expects.
   */
  numberOfDistributions: Scalars['Int']['output'];
  /** Always blank — WorkSuite has no recurring-journal concept. */
  recurFrequency: Scalars['String']['output'];
  /** Always blank — WorkSuite has no recurring-journal concept. */
  recurNumber: Scalars['String']['output'];
  /** The per-import batch label, identical on every row of a render. */
  reference: Scalars['String']['output'];
};

/** One grant on an owned view. */
export type ReportGrantData = {
  __typename?: 'ReportGrantData';
  /** The person's email; null when the grant is to the whole company. */
  email?: Maybe<Scalars['String']['output']>;
  /** PERSON or COMPANY. */
  granteeKind: ReportGranteeKind;
  /** USE opens the view and runs its row actions; CHANGE also edits it. */
  right: ReportGrantRight;
};

/** One grant on an owned view. */
export type ReportGrantDocument = {
  __typename?: 'ReportGrantDocument';
  /** The person's email; null when the grant is to the whole company. */
  email?: Maybe<Scalars['String']['output']>;
  /** PERSON or COMPANY. */
  granteeKind: ReportGranteeKind;
  /** USE opens the view and runs its row actions; CHANGE also edits it. */
  right: ReportGrantRight;
};

/** One grant on an owned view. */
export type ReportGrantDocumentFilterInput = {
  and?: InputMaybe<Array<ReportGrantDocumentFilterInput>>;
  /** The person's email; null when the grant is to the whole company. */
  email?: InputMaybe<StringOperationFilterInput>;
  /** PERSON or COMPANY. */
  granteeKind?: InputMaybe<ReportGranteeKindOperationFilterInput>;
  or?: InputMaybe<Array<ReportGrantDocumentFilterInput>>;
  /** USE opens the view and runs its row actions; CHANGE also edits it. */
  right?: InputMaybe<ReportGrantRightOperationFilterInput>;
};

export enum ReportGrantRight {
  Change = 'CHANGE',
  Unknown = 'UNKNOWN',
  Use = 'USE'
}

export type ReportGrantRightOperationFilterInput = {
  eq?: InputMaybe<ReportGrantRight>;
  in?: InputMaybe<Array<ReportGrantRight>>;
  neq?: InputMaybe<ReportGrantRight>;
  nin?: InputMaybe<Array<ReportGrantRight>>;
};

export enum ReportGranteeKind {
  Company = 'COMPANY',
  Person = 'PERSON',
  Unknown = 'UNKNOWN'
}

export type ReportGranteeKindOperationFilterInput = {
  eq?: InputMaybe<ReportGranteeKind>;
  in?: InputMaybe<Array<ReportGranteeKind>>;
  neq?: InputMaybe<ReportGranteeKind>;
  nin?: InputMaybe<Array<ReportGranteeKind>>;
};

/**
 * Payload wrapper for the reportInventoryData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters — when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportInventoryDataPayload = {
  __typename?: 'ReportInventoryDataPayload';
  /** Gets the returned inventory rows. */
  data: Array<ReportInventoryItemData>;
  /** Gets the number of rows returned after applying the page limit. */
  totalCount: Scalars['Int']['output'];
  /** Gets the number of rows matching the filters before the page limit. */
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the report's grand-total row, one entry per summable column. The payload-level
   * replacement for the deprecated per-row report*Total fields.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * Flattened inventory record for report generation. One row per
 * (location × item × grade) combination — the same key used by
 * InventoryItemDocument.
 */
export type ReportInventoryItemData = {
  __typename?: 'ReportInventoryItemData';
  allocatedQuantity: Scalars['Decimal']['output'];
  /** Gets the committed quantity as one string, or the bare each count when the item has no named unit. */
  allocatedQuantityText: Scalars['String']['output'];
  /** Gets AllocatedQuantity over EachesPerUnit, cut toward zero at two decimals. Null when the item has no unit. */
  allocatedQuantityUnits?: Maybe<Scalars['Decimal']['output']>;
  availableQuantity: Scalars['Decimal']['output'];
  /** Gets the available quantity as one string, or the bare each count when the item has no named unit. */
  availableQuantityText: Scalars['String']['output'];
  /** Gets AvailableQuantity over EachesPerUnit, cut toward zero at two decimals. Null when the item has no unit. */
  availableQuantityUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets how many eaches one unit of ShippingUomLabel holds. Null when the item has no unit. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * Gets the item's genus, joined at query time. Drives the genus sub-total row. Empty for a hard good,
   * which sub-totals under a blank genus rather than dropping out of the report.
   */
  genus: Scalars['String']['output'];
  /** Gets the available total for this row's genus group. */
  genusAvailableTotal: Scalars['Decimal']['output'];
  /** Gets the available total of this row's genus group in units. Null when the group mixes packs. */
  genusAvailableUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the committed total for this row's genus group. */
  genusCommittedTotal: Scalars['Decimal']['output'];
  /** Gets the committed total of this row's genus group in units. Null when the group mixes packs. */
  genusCommittedUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the on-hand total for this row's genus group, within its location. */
  genusOnhandTotal: Scalars['Decimal']['output'];
  /** Gets the on-hand total of this row's genus group in units. Null when the group mixes packs. */
  genusOnhandUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  grade: Scalars['Int']['output'];
  /**
   * Gets the item's lookup code (ItemSummaryDocument.ItemLookupCode) — GrowPoint's "Item Code",
   * joined at query time. Distinct from the sku field, which the inventory row stores itself. Empty
   * for a hard good and when the item does not resolve.
   */
  itemCode: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  /**
   * Gets a value indicating whether this is the last row of its genus group — gates the genus sub-total
   * row. Only a true sub-total when the rows are ordered so a genus's rows are contiguous, which is why
   * the seeded template pins its sort.
   */
  lastOfGenus: Scalars['Boolean']['output'];
  /**
   * Gets a value indicating whether this is the last row of its location group — the flag a template
   * gates its location total row on ({{#if lastOfLocation}}).
   */
  lastOfLocation: Scalars['Boolean']['output'];
  /**
   * Gets a value indicating whether this is the final returned row — the LEGACY gate for the
   * grand-total row. A report built today reads the payload-level totals map instead.
   * @deprecated The grand-total row no longer rides on a row: read the payload-level `totals` map (totals: [ReportColumnTotal!]!) outside the row loop. Retained until saved reports migrate their bindings.
   */
  lastRow: Scalars['Boolean']['output'];
  lastTransactionDate: Scalars['DateTime']['output'];
  lastTransactionType: Scalars['String']['output'];
  /** Gets the available total for this row's location group. */
  locationAvailableTotal: Scalars['Decimal']['output'];
  /** Gets the available total of this row's location group in units. Null when the group mixes packs. */
  locationAvailableUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the committed (allocated) total for this row's location group. */
  locationCommittedTotal: Scalars['Decimal']['output'];
  /** Gets the committed total of this row's location group in units. Null when the group mixes packs. */
  locationCommittedUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  /** Gets the on-hand total for this row's location group. */
  locationOnhandTotal: Scalars['Decimal']['output'];
  /** Gets the on-hand total of this row's location group in units. Null when the group mixes packs. */
  locationOnhandUnitsTotal?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets a value indicating whether the item is a native plant species, joined from the item
   * read model — the inventory read model carries only the item id.
   */
  native: Scalars['Boolean']['output'];
  onOrderQuantity: Scalars['Decimal']['output'];
  /**
   * Gets a value indicating whether any returned row has a named unit. The same on every row, so a
   * template can show its units columns for the whole page, header and total rows included, and leave them
   * out entirely when every item is counted in eaches.
   */
  pageHasUnits: Scalars['Boolean']['output'];
  previousQuantity: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  /** Gets the on-hand quantity as one string, 2 (4.5 inch tray) · 30 ea, or the bare each count when the item has no named unit. */
  quantityText: Scalars['String']['output'];
  /** Gets Quantity over EachesPerUnit, cut toward zero at two decimals. Null when the item has no unit. */
  quantityUnits?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets the optional date the live goods are projected to be ready, copied straight from
   * InventoryItemDocument.ReadyDate (it replaces the legacy GrowPoint "seasons" concept —
   * there is no season model here). Null when none was entered, which renders as a BLANK cell
   * everywhere; null is the common case, not an edge case.
   */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Gets the YEAR-QUALIFIED ISO week label derived from the ready date (e.g.
   * 2026-W35), or null whenever the ready date is null — never 0, never 1.
   *
   * Deliberately NOT InventoryItemDocument.ReadyWeek: that property is a bare week number
   * with no year, so week 35 of 2026 and of 2027 are indistinguishable and collate together.
   * Single-sourced in IsoWeekDerivation.IsoWeekLabelOrNull.
   */
  readyWeek?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the numeric ordering key for the ready week (isoYear * 53 + isoWeek), or
   * null when there is no ready date. Prefer it for ordering: the ready week label
   * happens to sort chronologically too (year-first, both parts zero-padded), but that is a
   * property of the label's format, and only this key stays correct if the format changes.
   */
  readyWeekIndex?: Maybe<Scalars['Int']['output']>;
  /**
   * Gets the available total across every returned row. Identical on every row.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportAvailableTotal: Scalars['Decimal']['output'];
  /**
   * Gets the committed total across every returned row. Identical on every row.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportCommittedTotal: Scalars['Decimal']['output'];
  /**
   * Gets the on-hand total across every returned row. Identical on every row.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportOnhandTotal: Scalars['Decimal']['output'];
  /**
   * Gets the name of the Shipping UOM the row's item ships as today, for example 4.5 inch tray.
   * Null when the item has no unit (a pack of one or an unstated pack) or its Shipping UOM has no name.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** Flattened inventory transaction record for report generation. One row per transaction document. */
export type ReportInventoryTransactionData = {
  __typename?: 'ReportInventoryTransactionData';
  /**
   * Gets quantity in units: the eaches over eachesPerUnit, cut toward zero at two decimals
   * (25 eaches on a pack of 18 is 1.38). Null when the item has no unit.
   */
  derivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets how many eaches one unit of that Shipping UOM holds, as it states today. Null when the pack is one
   * or unstated.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  grade: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  /**
   * Gets a value indicating whether this is the final returned row — the LEGACY gate for the
   * grand-total row. A report built today reads the payload-level totals map instead.
   * @deprecated The grand-total row no longer rides on a row: read the payload-level `totals` map (totals: [ReportColumnTotal!]!) outside the row loop. Retained until saved reports migrate their bindings.
   */
  lastRow: Scalars['Boolean']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  /**
   * Gets a value indicating whether the item is a native plant species, joined from the item
   * read model. This is the item's CURRENT flag, not a value frozen at transaction time — the
   * transaction document has no Native of its own.
   */
  native: Scalars['Boolean']['output'];
  /**
   * Gets a value indicating whether any returned row has a named unit. The same on every row, so a
   * template can show a units column for the whole page, header and total row included, and leave it
   * out entirely when every item is counted in eaches.
   */
  pageHasUnits: Scalars['Boolean']['output'];
  /** Gets previousQuantity in units, cut toward zero at two decimals. Null when the item has no unit. */
  previousDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  previousQuantity: Scalars['Decimal']['output'];
  /**
   * Gets previousQuantity as a document prints it, "1 (4.5 inch tray) · 15 ea". The bare quantity,
   * exactly as previousQuantity prints, when the item has no named unit.
   */
  previousQuantityText: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  /**
   * Gets quantity as a document prints it, "2 (4.5 inch tray) · 30 ea". The bare quantity, exactly
   * as quantity prints, when the item has no named unit.
   */
  quantityText: Scalars['String']['output'];
  /**
   * Gets the reason code the adjustment was recorded under, or the empty string when the transaction
   * carries none.
   */
  reasonCode: Scalars['String']['output'];
  /**
   * Gets the quantity summed across every returned row — identical on every row, so a template can read
   * it from inside its {{#each}}.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportQuantityTotal: Scalars['Decimal']['output'];
  /**
   * Gets the name of the Shipping UOM the item ships as today, the unit a document prints beside the
   * quantity ("4.5 inch tray"). Null when the item's pack is one or unstated, and when its Shipping UOM has
   * no name.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  transactionType: Scalars['String']['output'];
  /**
   * Gets the actor who performed the transaction, as their EMAIL — every inventory mutation stamps
   * this from the caller's UserResolverContext.Email server-side, so it is a real identity
   * rather than an opaque id. GrowPoint's "Who" column.
   */
  userId: Scalars['String']['output'];
  why: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportInventoryTransactionsData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters - when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportInventoryTransactionsDataPayload = {
  __typename?: 'ReportInventoryTransactionsDataPayload';
  /** Gets the returned inventory transaction rows. */
  data: Array<ReportInventoryTransactionData>;
  /** Gets the number of rows returned after applying the page limit. */
  totalCount: Scalars['Int']['output'];
  /** Gets the number of rows matching the filters before the page limit. */
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the report's grand-total row, one entry per summable column. The payload-level
   * replacement for the deprecated per-row report*Total fields.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of the Code Report. The row grain depends on the includeItems parameter, but the row
 * SHAPE does not — which is what lets CSV, Excel and PDF flatten it identically in both modes.
 */
export type ReportItemCodeData = {
  __typename?: 'ReportItemCodeData';
  /** The code value itself. */
  code: Scalars['String']['output'];
  /**
   * Which code list this row belongs to — the ReportItemCodeList member name (Category,
   * ItemGroup or ProductGroup). Carried on every row rather than only in the header so an
   * exported CSV, which has no header block, still says what it is a list of.
   */
  codeList: Scalars['String']['output'];
  /**
   * Whether this row OPENS a new code section — true on the first row carrying each code, so a
   * template can print a code header above the items assigned to it.
   */
  firstOfCode: Scalars['Boolean']['output'];
  /**
   * How many items carry this code, tenant-wide. Always the UNTRUNCATED count: when a page cuts a
   * code's item rows short the count still reports every item, so the total is never silently
   * understated by the display cap — the same rule ds-item-list applies to its on-order
   * breakdown.
   */
  itemCount: Scalars['Int']['output'];
  /** The item using this code. Blank when includeItems is false, or when nothing carries the code. */
  itemId: Scalars['String']['output'];
  /** The item's lookup code — also the row's secondary sort key. */
  itemLookupCode: Scalars['String']['output'];
  /** The item's name. */
  itemName: Scalars['String']['output'];
  /**
   * The item's lifecycle status, projected as its enum NAME so CSV / Excel / PDF render the
   * human-readable value rather than a stored ordinal.
   */
  itemStatus: Scalars['String']['output'];
  /** The item's SKU. */
  sku: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportItemCodesData query. totalCount is the number of rows
 * returned (capped by the caller's first, itself clamped to
 * ReportDataSourceConstants.MaxReportRows); totalMatching is the number of rows the
 * selection produces before that cap, so a template rendering
 * "Showing {{totalCount}} of {{totalMatching}}" can signal truncation.
 */
export type ReportItemCodesDataPayload = {
  __typename?: 'ReportItemCodesDataPayload';
  data: Array<ReportItemCodeData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * One row of the GrowPoint Item List — a denormalized item carrying its descriptors, its on-hand stock,
 * the open-order demand against it and the price at the run's price group.
 */
export type ReportItemListData = {
  __typename?: 'ReportItemListData';
  /**
   * Gets the resolved amount basis, as its enum NAME — the run's amountBasis after fallback.
   * Echoed onto every row because parameter values never reach the Handlebars context, so this is the
   * only way a template can label its amount column with the basis it is actually printing.
   */
  amountBasis: Scalars['String']['output'];
  /**
   * Gets the per-unit amount under amountBasis — cogs for Cost per Unit, price for
   * Value per Unit. Null only on the cost basis for an item carrying no COGS, deliberately not 0.
   */
  amountPerUnit?: Maybe<Scalars['Decimal']['output']>;
  /** Gets amountPerUnit formatted as money, for the PDF template, whose Handlebars registers no format helper. Empty when the amount is null. */
  amountPerUnitFormatted: Scalars['String']['output'];
  /**
   * Gets availableQuantity in units, cut toward zero at two decimals, negative where the item is
   * committed beyond its stock. Null when the item has no unit.
   */
  availableDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets the available quantity — onHandQuantity MINUS onOrderQuantity. Negative when the
   * item is committed beyond what is in the ground, which is the whole point of GrowPoint's
   * "print only negative available" run.
   */
  availableQuantity: Scalars['Decimal']['output'];
  /**
   * Gets availableQuantity as a document prints it. The bare quantity, exactly as
   * availableQuantity prints, when the item has no named unit.
   */
  availableQuantityText: Scalars['String']['output'];
  /** Gets the item's first category code — the product family the sheet is sectioned by. Empty when the item has none. */
  category: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 1. Empty when the column is not bound or the item has no value. */
  characteristic1: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 1. Empty when the column is not bound. */
  characteristic1Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 2. Empty when the column is not bound or the item has no value. */
  characteristic2: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 2. Empty when the column is not bound. */
  characteristic2Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 3. Empty when the column is not bound or the item has no value. */
  characteristic3: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 3. Empty when the column is not bound. */
  characteristic3Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 4. Empty when the column is not bound or the item has no value. */
  characteristic4: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 4. Empty when the column is not bound. */
  characteristic4Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 5. Empty when the column is not bound or the item has no value. */
  characteristic5: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 5. Empty when the column is not bound. */
  characteristic5Name: Scalars['String']['output'];
  /** Gets the item's cost of goods (purchase price). Null when the item carries none — deliberately not 0, which is a real cost. */
  cogs?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the item name — GrowPoint's "Common Name". WorkSuite has no dedicated common-name field. */
  commonName: Scalars['String']['output'];
  /** Gets the item description. */
  description: Scalars['String']['output'];
  /**
   * Gets how many eaches one unit of that Shipping UOM holds, as it states today. Null when the pack is one
   * or unstated.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * Gets the extended amount — amountPerUnit multiplied by onHandQuantity, the value of
   * the stock on hand at the chosen basis. Null on the same terms as amountPerUnit.
   */
  extendedAmount?: Maybe<Scalars['Decimal']['output']>;
  /** Gets extendedAmount formatted as money, for the PDF template, whose Handlebars registers no format helper. Empty when the amount is null. */
  extendedAmountFormatted: Scalars['String']['output'];
  /**
   * Gets whether this row opens a product-group section — true on the FIRST row of each group, and only
   * when the run asked for grouping under sortBy = ProductGroup. The section marker a template's
   * group heading gates on, the firstOfCategory shape ds-availability-outlook established.
   */
  firstOfProductGroup: Scalars['Boolean']['output'];
  /**
   * Gets the item's lookup code — GrowPoint's printed "Item Code", deliberately distinct from
   * sku. Both are on the row so neither reading is lost.
   */
  itemCode: Scalars['String']['output'];
  /** Gets the item's item group. */
  itemGroup: Scalars['String']['output'];
  /** Gets the item identifier. */
  itemId: Scalars['String']['output'];
  /** Gets when the count in lastCountQuantity was posted. Null on the same terms. */
  lastCountDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gets the quantity of the most recent cycle count recorded for the item. Null unless
   * includeLastCount asked for it, or when the item has never been counted. It is the last
   * RECORDED count for the item rather than a per-grower-location figure.
   */
  lastCountQuantity?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets whether this row closes a product-group section — true on the LAST row of each group, on the
   * same terms as firstOfProductGroup. What a template's sub-total line gates on.
   */
  lastOfProductGroup: Scalars['Boolean']['output'];
  /** Gets the item's genus — GrowPoint's "Latin Name". WorkSuite has no dedicated Latin-name field. */
  latinName: Scalars['String']['output'];
  /** Gets onHandQuantity in units, cut toward zero at two decimals. Null when the item has no unit. */
  onHandDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets the on-hand quantity summed over every inventory key, or over only the keys at the run's
   * location when one is named.
   */
  onHandQuantity: Scalars['Decimal']['output'];
  /**
   * Gets onHandQuantity as a document prints it, "2 (4.5 inch tray) · 30 ea". The bare quantity,
   * exactly as onHandQuantity prints, when the item has no named unit.
   */
  onHandQuantityText: Scalars['String']['output'];
  /** Gets onOrderQuantity in units, cut toward zero at two decimals. Null when the item has no unit. */
  onOrderDerivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets the per-order breakdown behind onOrderQuantity — GrowPoint's "print on-order
   * detail". Empty unless includeOnOrderDetail asked for it, and truncated to the
   * earliest-delivering 50 entries.
   */
  onOrderDetail: Array<ReportItemListOnOrderLineData>;
  /**
   * Gets the open order demand (Submitted / Acknowledged / Picked / SyncError, net of shipped
   * quantities) with an expected delivery date inside the run's ship-date window. Never
   * truncated by the onOrderDetail display cap.
   */
  onOrderQuantity: Scalars['Decimal']['output'];
  /**
   * Gets onOrderQuantity as a document prints it. The bare quantity, exactly as
   * onOrderQuantity prints, when the item has no named unit.
   */
  onOrderQuantityText: Scalars['String']['output'];
  /**
   * Gets the unit price at the run's pricing context — the explicit price group, else the tenant
   * default; no match is 0. GrowPoint's "price level" is a price GROUP in WorkSuite.
   */
  price: Scalars['Decimal']['output'];
  /** Gets the unit price formatted as money, for the PDF template, whose Handlebars registers no format helper. */
  priceFormatted: Scalars['String']['output'];
  /** Gets the item's product group. */
  productGroup: Scalars['String']['output'];
  /**
   * Gets the product group's total available quantity, on the same terms as
   * productGroupOnHandTotal. Negative when the group as a whole is committed beyond its stock —
   * negative rows net against the rest, so it equals the group's on-hand total minus its on-order total.
   */
  productGroupAvailableTotal?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets the product group's total extended amount at the run's basis, on the same terms as
   * productGroupOnHandTotal. Sums only the rows carrying an amount, so a group of items with no
   * COGS totals null rather than 0.
   */
  productGroupExtendedAmountTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Gets productGroupExtendedAmountTotal formatted as money, on the same terms as extendedAmountFormatted. Empty on every row but the group's last. */
  productGroupExtendedAmountTotalFormatted: Scalars['String']['output'];
  /**
   * Gets the product group's total on-hand quantity — GrowPoint's "print product totals". Null except on
   * the row where lastOfProductGroup is true.
   */
  productGroupOnHandTotal?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets the product group's total on-order quantity, on the same terms as
   * productGroupOnHandTotal: null except on the row where lastOfProductGroup is true.
   */
  productGroupOnOrderTotal?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets the earliest ready date among the inventory keys summed into onHandQuantity —
   * the date the first of that stock becomes sellable, WorkSuite's replacement for GrowPoint's
   * "season". Null when no key carries one.
   */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Gets the name of the Shipping UOM the item ships as today, the unit a document prints beside each
   * quantity ("4.5 inch tray"). Null when the item's pack is one or unstated, and when its Shipping UOM has
   * no name.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /** Gets the SKU. */
  sku: Scalars['String']['output'];
  /** Gets the item status, as its enum NAME so exports render a readable value. */
  status: Scalars['String']['output'];
  /** Gets the inclusive lower ship-date bound applied to the on-order column, echoed so a render states the window it ran over. */
  windowFrom?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the inclusive upper ship-date bound applied to the on-order column. */
  windowTo?: Maybe<Scalars['DateTime']['output']>;
};

/** Payload wrapper for the reportItemListData query. */
export type ReportItemListDataPayload = {
  __typename?: 'ReportItemListDataPayload';
  /** The returned item rows. */
  data: Array<ReportItemListData>;
  /** The number of rows returned after applying the row limit. */
  totalCount: Scalars['Int']['output'];
  /** The number of items matching the filters before the row limit. When an on-hand range or the omit-zero filter is supplied this is the count after those filters, which are applied in memory. */
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no items matched. */
  totals: Array<ReportColumnTotal>;
};

/** One order behind an item's on-order total, for the GrowPoint Item List's on-order detail block. */
export type ReportItemListOnOrderLineData = {
  __typename?: 'ReportItemListOnOrderLineData';
  /** Gets the ordering customer's name, as denormalized onto the order. */
  customerName: Scalars['String']['output'];
  /** Gets the order's expected delivery date — the field the ship-date window is applied to. */
  expectedDeliveryDate: Scalars['DateTime']['output'];
  /** Gets the order number. */
  orderNumber: Scalars['String']['output'];
  /** Gets the line's remaining open quantity, net of what has shipped. */
  quantity: Scalars['Decimal']['output'];
};

/**
 * One purchased item, rolled up across every matched purchase order — GrowPoint's Accounts Payable
 * "Item Purchase Summary" row.
 */
export type ReportItemPurchaseSummaryData = {
  __typename?: 'ReportItemPurchaseSummaryData';
  /**
   * The item's category — a material item's only classification. Blank when the item no longer
   * resolves: a purchase-order line snapshots no category.
   */
  category: Scalars['String']['output'];
  /** The earliest order-placed date among the contributing purchase orders. */
  firstOrderDate: Scalars['DateTime']['output'];
  /**
   * Whether the two receiving columns are populated. Echoed onto the row because parameter values
   * never reach a template's Handlebars context, so a template gates its receiving columns on this.
   */
  includesReceivingDetail: Scalars['Boolean']['output'];
  /** The item's code — its material-item ERP id, from the live catalog where it resolves. */
  itemCode: Scalars['String']['output'];
  /** The item's description, from the live catalog where it resolves. */
  itemDescription: Scalars['String']['output'];
  /** The latest order-placed date among the contributing purchase orders. */
  lastOrderDate: Scalars['DateTime']['output'];
  /** How many purchase-order lines contributed. Never fewer than purchaseOrderCount. */
  lineCount: Scalars['Int']['output'];
  /** The material item's id. Blank on lines written before the id was captured. */
  materialItemId: Scalars['String']['output'];
  /** The contributing P.O. numbers, distinct and ordered. */
  poNumbers: Scalars['String']['output'];
  /** How many distinct purchase orders contributed to this row. */
  purchaseOrderCount: Scalars['Int']['output'];
  /** Total quantity ordered of this item across the matched purchase-order lines. */
  quantityOrdered: Scalars['Decimal']['output'];
  /**
   * Total quantity received, or null when receiving detail was not requested — null rather than zero,
   * so "not asked for" cannot be read as "nothing received".
   */
  quantityReceived?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Total quantity still outstanding — each line's ordered minus received clamped at zero BEFORE
   * summing, so an over-receipt on one line cannot cancel a shortage on another. Null under the same
   * condition as quantityReceived.
   */
  quantityRemaining?: Maybe<Scalars['Decimal']['output']>;
  /** How many distinct vendors the item was bought from. */
  vendorCount: Scalars['Int']['output'];
  /** Those vendors' names, distinct and ordered. */
  vendorNames: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportItemPurchaseSummaryData query. TotalCount is the number
 * of rows returned; TotalMatching is the total number of ITEM rows the filters rolled up to —
 * when TotalMatching exceeds TotalCount the client should prompt the user to narrow their
 * filters. Both count items, not purchase orders: the roll-up IS this source's row grain, unlike
 * ds-vendor-purchase-orders, which counts purchase orders in both of its grains.
 */
export type ReportItemPurchaseSummaryDataPayload = {
  __typename?: 'ReportItemPurchaseSummaryDataPayload';
  data: Array<ReportItemPurchaseSummaryData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the report's grand-total row, one entry per summable column. Projected from the map
   * ReportItemPurchaseSummaryDataSource.ReadAsync already folded — never summed a second
   * time here, so the preview and the CSV / Excel / PDF arm publish the same figures by
   * construction.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * One line of one kit — GrowPoint's Assembly Report grain. A kit with four lines produces four rows,
 * each repeating the kit header columns so the row stands alone in a flat CSV.
 */
export type ReportKitData = {
  __typename?: 'ReportKitData';
  /** The line's category code, snapshotted at save time. Empty when the line records none. */
  categoryCode: Scalars['String']['output'];
  /** The container the kit is built into, empty when the kit names none. */
  containerCode: Scalars['String']['output'];
  /**
   * The eaches-per-tray snapshot captured on the line, blank when the line records none. Blank is
   * deliberately not zero: "not captured" and "zero per tray" are different facts.
   */
  eachesPerTray?: Maybe<Scalars['Int']['output']>;
  /** The date the kit stops being available, blank when it is open-ended. */
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Gets a value indicating whether this row OPENS a run of lines for the same kit — true on a
   * kit's first line, so a template can print a kit header above its components.
   */
  firstOfKit: Scalars['Boolean']['output'];
  /**
   * The referenced item's CODE — ItemSummaryDocument.Sku, GrowPoint's "Item Code". Empty on a
   * nested-kit line, and empty on an item line whose item no longer resolves (the domain validates
   * that a nested KIT exists but never that an item reference does).
   */
  itemCode: Scalars['String']['output'];
  /** The referenced item's description, live from the item catalog. Empty on a nested-kit line. */
  itemDescription: Scalars['String']['output'];
  /** The kit's entity id — stable across renames, unlike the kit name. */
  kitId: Scalars['String']['output'];
  /**
   * Gets the kit's total component quantity across its own lines, carried on EVERY line of the
   * kit so a template may print the figure in the section header as readily as its footer.
   */
  kitMultipleTotal: Scalars['Decimal']['output'];
  /** The kit's display name — GrowPoint's assembly heading, and the primary row ordering. */
  kitName: Scalars['String']['output'];
  /**
   * The line's primary display label, snapshotted when the line was saved and deliberately not
   * re-resolved on read — so it shows what the kit was authored to say even if the item was renamed.
   */
  label: Scalars['String']['output'];
  /**
   * Gets a value indicating whether this row CLOSES a run of lines for the same kit — true on a
   * kit's last line, so a template can print the kit's subtotal beneath its components.
   */
  lastOfKit: Scalars['Boolean']['output'];
  /** The line's kind as its enum name — Item for a catalog item, Kit for a nested kit. */
  lineKind: Scalars['String']['output'];
  /**
   * The line's 1-based position within the kit AS AUTHORED. Line order is part of a kit's identity
   * (Kit.IsSameAsStored compares lines with SequenceEqual), so the report prints them
   * in the order they were saved rather than in Mongo's natural order.
   */
  lineNumber: Scalars['Int']['output'];
  /** How many of the referenced item or kit this line contributes, counted in uomCode. */
  multiple: Scalars['Int']['output'];
  /**
   * The nested kit's current name, for a line whose lineKind is Kit. Empty on an
   * item line. A nested-kit line whose target kit is deleted is not returned at all — see
   * ReportKitsRead.
   */
  nestedKitName: Scalars['String']['output'];
  /**
   * The referenced item's product group, live from the item catalog — what the Product Group filter
   * matches on. Empty on a nested-kit line.
   */
  productGroup: Scalars['String']['output'];
  /**
   * What the line points at: an item id when lineKind is Item, a kit id when it
   * is Kit. Which meaning applies is determined solely by the kind.
   */
  refId: Scalars['String']['output'];
  /** The line's secondary display label, snapshotted at save time alongside the primary label. */
  secondaryLabel: Scalars['String']['output'];
  /** The Sites the kit is limited to, by name, or All Sites when the kit is open to every Site. */
  siteId: Scalars['String']['output'];
  /** The line's size code, snapshotted at save time. Empty when the line records none. */
  sizeCode: Scalars['String']['output'];
  /** The date the kit becomes available, blank when it is open-ended. */
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * The unit multiple is counted in, as its enum name — Each, Tray or
   * Layer on an item line, Kit on a nested-kit line.
   */
  uomCode: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportKitsData query. TotalCount is the number of records returned
 * (capped at ReportDataSourceConstants.MaxReportRows).
 * TotalMatching is the total number of records matching the filters — when TotalMatching > TotalCount,
 * the client should prompt the user to narrow their filters.
 */
export type ReportKitsDataPayload = {
  __typename?: 'ReportKitsDataPayload';
  data: Array<ReportKitData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the report's grand-total row, one entry per summable column. Projected from the map
   * ReportKitsRead.ExecuteAsync already folded — the SAME map the export arm carries,
   * because both arms enter through that one read.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * One DROP on a Logistics load for report generation — one row per LogisticsLoadLines document,
 * in route-stop order. The load header, carrier, driver, vehicle, route and delivery-summary rollup
 * columns are REPEATED on every row, so the generic PDF path hoists them to the template root and a
 * CSV / Excel export stays one flat sheet.
 */
export type ReportLoadData = {
  __typename?: 'ReportLoadData';
  /** Gets the carrier's contact phone, or null when the load has no carrier. */
  carrierContactPhone?: Maybe<Scalars['String']['output']>;
  /** Gets the carrier's fuel surcharge percent, or null when none is recorded. */
  carrierFuelSurchargePercent?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the carrier name, or null when the load has no carrier. */
  carrierName?: Maybe<Scalars['String']['output']>;
  /** Gets the carrier's rate amount, or null when none is recorded. */
  carrierRateAmount?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the carrier's rate basis name (Flat, PerContainer, PerMile, PerStop). */
  carrierRateBasis?: Maybe<Scalars['String']['output']>;
  /** Gets when the load was completed, or null when it has not been. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the planned container count on the load line, or null when none is planned. */
  containerCount?: Maybe<Scalars['Int']['output']>;
  /** Gets the name of the container configuration the load ships in. */
  containerName: Scalars['String']['output'];
  /** Gets the customer name recorded on the load line. */
  customerName: Scalars['String']['output'];
  /** Gets the delivery address of the drop's route stop, or null when it names no stop. */
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  /** Gets when the drop's delivery outcome was recorded, or null when none has been. */
  deliveryOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the drop's delivery outcome name (Pending, Delivered, Refused, Partial), or null before dispatch. */
  deliveryOutcome?: Maybe<Scalars['String']['output']>;
  /** Gets when the load was dispatched, or null when it has not been. */
  dispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the driver name, or null when the load has no driver. */
  driverName?: Maybe<Scalars['String']['output']>;
  /** Gets the driver phone, or null when the load has no driver. */
  driverPhone?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the drop's 1-based position on the load: route-stop order, with drops that name no stop on
   * the load's route last.
   */
  dropNumber: Scalars['Int']['output'];
  /** Gets the load number the report was run for. */
  loadNumber: Scalars['Int']['output'];
  /**
   * Gets the current name of the order's Order kind, resolved from the tenant's Order kinds when the report
   * runs, or null when the order has no kind or the kind has been removed.
   */
  orderKind?: Maybe<Scalars['String']['output']>;
  /** Gets the order number of the drop's load line. */
  orderNumber: Scalars['String']['output'];
  /** Gets the order's total ordered quantity in eaches, or null when the order has no lines. */
  orderedQuantity?: Maybe<Scalars['Int']['output']>;
  /** Gets the order's customer P.O. number, or null when the order is not in the read model. */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** Gets the order's Program, or null when the order has none or is not in the read model. */
  program?: Maybe<Scalars['String']['output']>;
  /** Gets the route code, or null when the load has no route. */
  routeCode?: Maybe<Scalars['String']['output']>;
  /** Gets the route name, or null when the load has no route. */
  routeName?: Maybe<Scalars['String']['output']>;
  /** Gets the load's ship date. */
  shipDate: Scalars['LocalDate']['output'];
  /** Gets the order's total shipped quantity in eaches, or null when the order has no lines. */
  shipQuantity?: Maybe<Scalars['Int']['output']>;
  /** Gets the load's status name (Planning, Loaded, Dispatched, Delivered). */
  status: Scalars['String']['output'];
  /** Gets the drop's route-stop mileage, or null when the stop records none. */
  stopMileage?: Maybe<Scalars['Float']['output']>;
  /** Gets the load's delivered stop count, or null before dispatch. */
  stopsDelivered?: Maybe<Scalars['Int']['output']>;
  /** Gets the load's partially delivered stop count, or null before dispatch. */
  stopsPartial?: Maybe<Scalars['Int']['output']>;
  /** Gets the load's pending stop count, or null before dispatch. */
  stopsPending?: Maybe<Scalars['Int']['output']>;
  /** Gets the load's refused stop count, or null before dispatch. */
  stopsRefused?: Maybe<Scalars['Int']['output']>;
  /** Gets the load's total stop count from its delivery summary, or null before dispatch. */
  stopsTotal?: Maybe<Scalars['Int']['output']>;
  /**
   * Gets the sum of the route-stop mileage over the distinct stops the load visits, or null when none
   * of them records a mileage.
   */
  totalMiles?: Maybe<Scalars['Float']['output']>;
  /** Gets whether the vehicle has a liftgate, or null when the load has no vehicle. */
  vehicleHasLiftgate?: Maybe<Scalars['Boolean']['output']>;
  /** Gets whether the vehicle is temperature controlled, or null when the load has no vehicle. */
  vehicleIsTempControlled?: Maybe<Scalars['Boolean']['output']>;
  /** Gets the vehicle license plate, or null when the load has no vehicle. */
  vehicleLicensePlate?: Maybe<Scalars['String']['output']>;
  /** Gets the vehicle name, or null when the load has no vehicle. */
  vehicleName?: Maybe<Scalars['String']['output']>;
};

/**
 * Payload wrapper for the reportLoadData query. TotalCount is the number of drops returned (capped at
 * 5000). TotalMatching is the number of drops on the load the caller may see before that cap.
 */
export type ReportLoadDataPayload = {
  __typename?: 'ReportLoadDataPayload';
  data: Array<ReportLoadData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total. Always empty: ds-load declares no summable column — its load
   * rollups are carried as columns instead.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * One load an order rides, as the Freight Quote packet prints it: the carrier and contact, the container
 * type with its dimensions and weight, the pickup window and transit kind, the order's stop with its planned
 * arrival, and the site the load picks up from.
 */
export type ReportLoadFreightData = {
  __typename?: 'ReportLoadFreightData';
  /** The carrier's contact email. Empty when none is stored. */
  carrierContactEmail: Scalars['String']['output'];
  /** The carrier's contact name. Empty when none is stored. */
  carrierContactName: Scalars['String']['output'];
  /** The carrier's contact phone. Empty when none is stored. */
  carrierContactPhone: Scalars['String']['output'];
  /** The hired carrier's name. Empty when the load has no carrier. */
  carrierName: Scalars['String']['output'];
  /** How many containers of the order ride this load. Null when any of its lines on the load has no count. */
  containerCount?: Maybe<Scalars['Int']['output']>;
  /** The container type's depth. Null when the container type no longer resolves. */
  containerDepth?: Maybe<Scalars['Decimal']['output']>;
  /** The container type's height. Null when the container type no longer resolves. */
  containerHeight?: Maybe<Scalars['Decimal']['output']>;
  /** The container type the load ships in. Empty when none is set. */
  containerName: Scalars['String']['output'];
  /** The weight of one container of this type, in containerWeightUnit. Null when none is set. */
  containerWeight?: Maybe<Scalars['Decimal']['output']>;
  /** The unit of containerWeight: lb or kg. Empty when no weight is set. */
  containerWeightUnit: Scalars['String']['output'];
  /** The container type's width. Null when the container type no longer resolves. */
  containerWidth?: Maybe<Scalars['Decimal']['output']>;
  /** The number of the load the order rides. */
  loadNumber: Scalars['Int']['output'];
  /** The pickup date. Null when no pickup window is set. */
  pickupDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The pickup window's start, HH:mm local to the pickup site, as typed. Empty when none is set. */
  pickupFrom: Scalars['String']['output'];
  /** The pickup window's end, HH:mm local to the pickup site, as typed. Empty when none is set. */
  pickupTo: Scalars['String']['output'];
  /** The planned arrival at the order's stop, HH:mm local to the ship-to, as typed. Empty when none is set. */
  plannedArrival: Scalars['String']['output'];
  /** The pickup site's address. Empty fields when the origin is ambiguous or missing. */
  shipFromAddress: ReportAddressData;
  /** The pickup site's latitude. Null when the site has no pin or the origin is ambiguous or missing. */
  shipFromLatitude?: Maybe<Scalars['Decimal']['output']>;
  /** The pickup site's longitude. Null when the site has no pin or the origin is ambiguous or missing. */
  shipFromLongitude?: Maybe<Scalars['Decimal']['output']>;
  /** The site the load picks up from. Empty when the origin is ambiguous or missing. */
  shipFromName: Scalars['String']['output'];
  /** Why no pickup site printed: the load's orders name more than one, or none could be found. Empty when the site resolved. */
  shipFromNote: Scalars['String']['output'];
  /** The order's stop latitude. Null when the stop has no pin. */
  stopLatitude?: Maybe<Scalars['Decimal']['output']>;
  /** The order's stop longitude. Null when the stop has no pin. */
  stopLongitude?: Maybe<Scalars['Decimal']['output']>;
  /** The order's position among the route's stops, starting at 1. Null when the order has no stop on the load. */
  stopSequence?: Maybe<Scalars['Int']['output']>;
  /** How the load travels: Same day, Overnight or Multi-day. Empty when the planner has not set it. */
  transitKind: Scalars['String']['output'];
};

/**
 * Flattened master order record for report generation. ONE record serves both of the source's
 * ReportMasterOrderReportType grains, because the seeded data source declares one column set
 * and the report-builder Table picker binds to it.
 *
 *
 * WHICH FIELDS CARRY A VALUE DEPENDS ON THE GRAIN, and the unpopulated ones are blank rather than
 * absent so a template bound to a column never renders a Handlebars miss:
 *
 *
 * Line (the default) — one row per master-order LINE with the master order's header
 * columns repeated on each, so a per-record document (the Master Order Acknowledgement) reads its
 * header from the first row and its line table from the row set. Every release* field is
 * blank and firstOfMasterOrder is false.
 * Release — one row per RELEASE (child order) cut from the master, the grain the
 * Master Release Sub-Orders listing prints. Every LINE field (lineId … lineNote) is
 * blank. A master order with no releases yet still emits one row, header only.
 *
 *
 *
 * Status is rendered as the enum name (e.g. "Acknowledged") so exports show
 * human-readable values. ReleasedQuantity / ShippedQuantity are derived by SKU from
 * the master order's stored release and shipment facts; RemainingQuantity is ordered minus
 * released, floored at zero. Those are LINE totals across every release — distinct from
 * ReleaseQuantity, which is one release's own quantity; summing one never double-counts the
 * other, because only one of the two is populated on any given row.
 */
export type ReportMasterOrderData = {
  __typename?: 'ReportMasterOrderData';
  acknowledgedQuantity: Scalars['Int']['output'];
  billToAddressLine1: Scalars['String']['output'];
  billToAddressLine2: Scalars['String']['output'];
  billToCity: Scalars['String']['output'];
  billToCountry: Scalars['String']['output'];
  billToName: Scalars['String']['output'];
  billToStateProvince: Scalars['String']['output'];
  billToZipcode: Scalars['String']['output'];
  /** When the confirmation email was last sent, if ever. */
  confirmationEmailSent?: Maybe<Scalars['DateTime']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  /** The bill-to customer-type id, empty when the customer holds no type. */
  customerTypeId: Scalars['String']['output'];
  /** The bill-to customer-type display name, empty when the customer holds no type. */
  customerTypeName: Scalars['String']['output'];
  /**
   * The quantity the extendedAmountBasis parameter names × unitPrice. Defaults to
   * the acknowledged quantity — the source's historical extension.
   */
  extendedPrice: Scalars['Decimal']['output'];
  /**
   * True on the first row of each master order's block of releases — the section marker the Master
   * Release Sub-Orders template gates its master-order heading band on. Always false on the Line
   * grain.
   */
  firstOfMasterOrder: Scalars['Boolean']['output'];
  /**
   * True on the first row of each salesperson's block when groupBy is SalesPerson,
   * false otherwise — the section marker the Master Order Summary gates its salesperson heading
   * and "page per salesman" break on.
   */
  firstOfSalesPerson: Scalars['Boolean']['output'];
  itemGroup: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  /**
   * True on the LAST row of each master order's block of releases — the companion to
   * firstOfMasterOrder. Always false on the Line grain.
   */
  lastOfMasterOrder: Scalars['Boolean']['output'];
  /**
   * True on the LAST row of each salesperson's block, so a template can close the section with its
   * subtotal row rather than only open it. Always false when the read is not grouped by salesperson.
   */
  lastOfSalesPerson: Scalars['Boolean']['output'];
  lineId: Scalars['String']['output'];
  /** The line's note text, if one was entered. */
  lineNote?: Maybe<Scalars['String']['output']>;
  lineNumber: Scalars['Int']['output'];
  masterOrderId: Scalars['String']['output'];
  masterOrderNumber: Scalars['String']['output'];
  /** Release line count summed over this master order's block. Zero off the Release grain. */
  masterOrderReleaseLineCountTotal: Scalars['Int']['output'];
  /**
   * Release quantity summed over this master order's whole block of releases. Zero off the Release
   * grain. Deliberately NOT orderTotal or releaseTotal, which are per-row header
   * values this rollup never repurposes.
   */
  masterOrderReleaseQuantityTotal: Scalars['Int']['output'];
  numberOfLines: Scalars['Int']['output'];
  /** The master order's initialized date; absent on a document not yet replayed since the field was added. */
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  orderTotal: Scalars['Decimal']['output'];
  orderedQuantity: Scalars['Int']['output'];
  poNumber: Scalars['String']['output'];
  releaseCount: Scalars['Int']['output'];
  /** When the release was cut — its child order's initialization date. Absent off the Release grain. */
  releaseDate?: Maybe<Scalars['DateTime']['output']>;
  /** The date the release is expected to deliver. Absent off the Release grain. */
  releaseExpectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** How many lines the release carries. Zero off the Release grain. */
  releaseLineCount: Scalars['Int']['output'];
  /**
   * The release's 1-based sequence within its master order, in release-date order. Zero off the
   * Release grain.
   */
  releaseNumber: Scalars['Int']['output'];
  /** The release's child ORDER id. Blank off the Release grain. */
  releaseOrderId: Scalars['String']['output'];
  /**
   * The release's child ORDER number — the sub-order this grain is named for, resolved server-side
   * from the master order's stored release facts. Blank off the Release grain, and on the row of a
   * master order that has no releases yet.
   */
  releaseOrderNumber: Scalars['String']['output'];
  /**
   * The total quantity THIS release took, summed over its own lines. Deliberately not
   * releasedQuantity, which is a per-SKU total across every release on the master order.
   */
  releaseQuantity: Scalars['Int']['output'];
  /** The release's own order total. Zero off the Release grain. */
  releaseTotal: Scalars['Decimal']['output'];
  releasedQuantity: Scalars['Int']['output'];
  remainingQuantity: Scalars['Int']['output'];
  salesPerson: Scalars['String']['output'];
  /** Extended price summed over this row's whole salesperson block. Zero when ungrouped. */
  salesPersonExtendedTotal: Scalars['Decimal']['output'];
  /** Ordered quantity summed over this row's whole salesperson block. Zero when ungrouped. */
  salesPersonOrderedTotal: Scalars['Int']['output'];
  shipFromLocationName: Scalars['String']['output'];
  shipToAddressLine1: Scalars['String']['output'];
  shipToAddressLine2: Scalars['String']['output'];
  shipToCity: Scalars['String']['output'];
  shipToCode: Scalars['String']['output'];
  shipToCountry: Scalars['String']['output'];
  shipToName: Scalars['String']['output'];
  shipToStateProvince: Scalars['String']['output'];
  shipToStoreNumber: Scalars['String']['output'];
  shipToZipcode: Scalars['String']['output'];
  shippedQuantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  status: Scalars['String']['output'];
  unitPrice: Scalars['Decimal']['output'];
  upc: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportMasterOrdersData query. TotalCount is the number of rows returned
 * (one per master-order line, or one per release under reportType = Release, capped at 5000).
 * TotalMatching is the total number of MASTER ORDERS matching the filters under EITHER grain — the
 * rows are lines or releases, so TotalCount can exceed TotalMatching; when the master-order page was
 * capped (more matched than were read) the client should prompt the user to narrow their filters.
 */
export type ReportMasterOrdersDataPayload = {
  __typename?: 'ReportMasterOrdersDataPayload';
  data: Array<ReportMasterOrderData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no master orders matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * Flattened material-item record for report generation. One row per MaterialItemDocument.
 * Status is projected as a string so the same shape renders correctly across GraphQL output and
 * CSV/PDF/Excel exports.
 */
export type ReportMaterialItemData = {
  __typename?: 'ReportMaterialItemData';
  accountingId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  defaultVendorId: Scalars['String']['output'];
  defaultVendorName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * Payload wrapper for the reportMaterialItemsData query. TotalCount is the number of records returned
 * (capped at ReportDataSourceConstants.MaxReportRows).
 * TotalMatching is the total number of records matching the filters — when TotalMatching > TotalCount,
 * the client should prompt the user to narrow their filters.
 */
export type ReportMaterialItemsDataPayload = {
  __typename?: 'ReportMaterialItemsDataPayload';
  data: Array<ReportMaterialItemData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** Open demand for a single item, with the per-customer / per-order breakdown it is made of. */
export type ReportOpenOrdersByItemData = {
  __typename?: 'ReportOpenOrdersByItemData';
  /** Per-order breakdown of this item's open quantity, sorted by expected delivery date ascending then order number. One entry per order, so an item ordered by four customers renders four entries. */
  customerOrders: Array<ReportOpenOrdersByItemOrder>;
  /** Earliest expected delivery date among the contributing orders. */
  earliestExpectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** The item's genus code. */
  genusCode: Scalars['String']['output'];
  /** The item this row rolls up. */
  itemId: Scalars['String']['output'];
  /** The item's name. */
  itemName: Scalars['String']['output'];
  /** Latest expected delivery date among the contributing orders. */
  latestExpectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the item is native. */
  native: Scalars['Boolean']['output'];
  /** Quantity still owed to customers on this item across every open order in the window. Identical to the bookedQuantity ds-demand-vs-supply reports for the same item over the same window — both read the one shared open-demand definition. */
  openQuantity: Scalars['Decimal']['output'];
  /** Number of open orders contributing to this item's open quantity, i.e. the length of customerOrders. */
  orderCount: Scalars['Int']['output'];
  /** The item's SKU. */
  sku: Scalars['String']['output'];
  /** The delivery-window lower bound this row was computed against, echoed back so a rendered report can print the window it covers. */
  windowFrom?: Maybe<Scalars['DateTime']['output']>;
  /** The delivery-window upper bound this row was computed against. */
  windowTo?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Top-level payload for the reportOpenOrdersByItemData query. One row per item that still has
 * open demand, each carrying the orders that demand comes from.
 */
export type ReportOpenOrdersByItemDataPayload = {
  __typename?: 'ReportOpenOrdersByItemDataPayload';
  /** One aggregated row per item, sorted by item name ascending. */
  data: Array<ReportOpenOrdersByItemData>;
  /** Number of distinct orders represented across every row. Lower than the sum of the per-row order counts whenever one order carries several of the reported items. */
  distinctOrderCount: Scalars['Int']['output'];
  /** Number of item rows returned. */
  itemCount: Scalars['Int']['output'];
  /** Total number of items with open demand before the runaway-query cap was applied. */
  totalMatching: Scalars['Int']['output'];
  /** Sum of OpenQuantity across every returned item row. */
  totalOpenQuantity: Scalars['Decimal']['output'];
  /** True when the runaway-query cap excluded item rows. When true, narrow the item or delivery-window filters to see the rest. */
  truncatedByLimit: Scalars['Boolean']['output'];
};

/** One open order's contribution to an item's open quantity. */
export type ReportOpenOrdersByItemOrder = {
  __typename?: 'ReportOpenOrdersByItemOrder';
  /** The ordering customer's id. */
  customerId: Scalars['String']['output'];
  /** The ordering customer's name. */
  customerName: Scalars['String']['output'];
  /** The order's expected delivery date, the field the report's date window is applied to. */
  expectedDeliveryDate: Scalars['DateTime']['output'];
  /** Quantity of this item still owed on this order, summed across every one of the order's lines for the item. */
  openQuantity: Scalars['Decimal']['output'];
  /** The order's id. */
  orderId: Scalars['String']['output'];
  /** The customer-facing order number. */
  orderNumber: Scalars['String']['output'];
  /** The customer's purchase-order number on the order, when supplied. */
  poNumber: Scalars['String']['output'];
  /** The order's status — always one of Submitted, Acknowledged, Picked or SyncError, the statuses that carry open demand. */
  status: Scalars['String']['output'];
};

/**
 * One row of the Open Orders by Product sheet: what is still owed on one product, for one value of the
 * caller-chosen classification axis.
 */
export type ReportOpenOrdersByProductData = {
  __typename?: 'ReportOpenOrdersByProductData';
  /** Acknowledged eaches across the matched lines behind this pairing. */
  acknowledgedQuantity: Scalars['Int']['output'];
  /**
   * The General and Ship context notes on the contributing lines — GrowPoint's
   * acknowledgement memo. Blank unless includeAcknowledgementNotes is on.
   */
  acknowledgementNotes: Scalars['String']['output'];
  /**
   * Print a block of blank rows under the column header — GrowPoint's "blank rows below column header",
   * for writing counts on by hand. Identical on every row.
   */
  blankRowsBelowHeader: Scalars['Boolean']['output'];
  /** Earliest ship date among the matched lines' orders, or null when none carried one. */
  earliestShipDate?: Maybe<Scalars['DateTime']['output']>;
  /** True on the product's first returned row — gates the section heading. */
  firstOfItem: Scalars['Boolean']['output'];
  /** Acknowledged eaches summed across every returned row for this product. */
  itemAcknowledgedTotal: Scalars['Int']['output'];
  /** The product's internal id. The grouping key — two products can share a name and a blank SKU. */
  itemId: Scalars['String']['output'];
  /** The product's name, which the sheet reads in order by. */
  itemName: Scalars['String']['output'];
  /** Open eaches summed across every returned row for this product: the section subtotal. */
  itemOpenTotal: Scalars['Int']['output'];
  /** Ordered eaches summed across every returned row for this product. */
  itemOrderedTotal: Scalars['Int']['output'];
  /** Shipped eaches summed across every returned row for this product. */
  itemShippedTotal: Scalars['Int']['output'];
  /** True on the product's final returned row — gates the subtotal row. */
  lastOfItem: Scalars['Boolean']['output'];
  /**
   * True on the final returned row — the LEGACY gate for the report grand total. A report built
   * today reads the payload-level totals map instead.
   * @deprecated The grand-total row no longer rides on a row: read the payload-level `totals` map (totals: [ReportColumnTotal!]!) outside the row loop. Retained until saved reports migrate their bindings.
   */
  lastRow: Scalars['Boolean']['output'];
  /** Latest ship date among the matched lines' orders, or null when none carried one. */
  latestShipDate?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the product is grown here rather than bought in. */
  native: Scalars['Boolean']['output'];
  /**
   * What is still owed, in eaches: max(0, (quantity ?? ordered) - shipped) summed across the
   * matched lines.
   */
  openQuantity: Scalars['Int']['output'];
  /**
   * What is still owed as one string: 2 (4.5 inch tray) · 30 ea when the row has one pack, else
   * 30 ea. Null when the tenant does not print units and eaches.
   */
  openQuantityText?: Maybe<Scalars['String']['output']>;
  /**
   * openQuantity in units of the one pack every line behind the row holds, cut toward zero at two
   * decimals. Null when the lines' packs disagree, the row is Unassigned, the axis is item-level, or the
   * tenant does not print units and eaches.
   */
  openUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Distinct orders behind this pairing. */
  orderCount: Scalars['Int']['output'];
  /** Ordered eaches across the matched lines behind this pairing: an each count, not a count of shipping units. */
  orderedQuantity: Scalars['Int']['output'];
  /**
   * The ordered quantity as one string, on the same terms as openQuantityText. Null when the
   * tenant does not print units and eaches.
   */
  orderedQuantityText?: Maybe<Scalars['String']['output']>;
  /**
   * orderedQuantity in units of the row's one pack, cut toward zero at two decimals. Null on the
   * same rows as openUnits.
   */
  orderedUnits?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Whether any returned row has a unit count. The same on every row, so a template can switch its value
   * and quantity cells for the whole page, and print the figures it printed before when no row has one.
   * Always false for a tenant that does not print units and eaches.
   */
  pageHasUnits: Scalars['Boolean']['output'];
  /**
   * Which classification dimension this run broke the product's demand out by — a
   * ReportProductPivotAxis name. Identical on every row.
   */
  pivotAxis: Scalars['String']['output'];
  /**
   * The axis value this row breaks out — GrowPoint's size — or Unassigned when the product
   * carries none of the selected values.
   */
  pivotValue: Scalars['String']['output'];
  /** The most axis values this report will break a product out into. Identical on every row. */
  pivotValueBound: Scalars['Int']['output'];
  /**
   * The name of the Shipping UOM pivotValue names, for example 4.5 inch tray. The value
   * itself for an item-level axis, the Unassigned bucket, and a code no Shipping UOM names.
   */
  pivotValueLabel: Scalars['String']['output'];
  /** Print the Ordered column — GrowPoint's "print ordered quantity". Identical on every row. */
  printOrderedQuantity: Scalars['Boolean']['output'];
  /** The product's product group. */
  productGroup: Scalars['String']['output'];
  /**
   * The Pull context notes on the contributing lines — GrowPoint's pull-slip memo. Blank unless
   * includePullNotes is on. Same joining and cap as the acknowledgement memo column.
   */
  pullNotes: Scalars['String']['output'];
  /**
   * Open eaches summed across every returned row: an each count across every pack. Identical on every row.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportOpenTotal: Scalars['Int']['output'];
  /**
   * Ordered eaches summed across every returned row: an each count across every pack. Identical on every row.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportOrderedTotal: Scalars['Int']['output'];
  /** Shipped eaches across the matched lines behind this pairing. */
  shippedQuantity: Scalars['Int']['output'];
  /** Print the acknowledgement memo column. Identical on every row. */
  showAcknowledgementNotes: Scalars['Boolean']['output'];
  /** Print the pull-slip memo column. Identical on every row. */
  showPullNotes: Scalars['Boolean']['output'];
  /** The product's item code, GrowPoint's Product Code. */
  sku: Scalars['String']['output'];
  /**
   * True when the run named or discovered more axis values than the break-out limit and the
   * surplus was dropped. Identical on every row.
   */
  truncatedByPivotBound: Scalars['Boolean']['output'];
};

/**
 * The ds-open-orders-by-product preview payload — the rows the builder renders plus the two
 * counts its pager reads.
 */
export type ReportOpenOrdersByProductDataPayload = {
  __typename?: 'ReportOpenOrdersByProductDataPayload';
  /** Gets the page of (product × axis value) rows, in sheet order. */
  data: Array<ReportOpenOrdersByProductData>;
  /** Gets rows returned on this page. */
  totalCount: Scalars['Int']['output'];
  /**
   * Gets the rows the filters matched before the page limit. Follows the caller's visibility
   * scope, so a restricted caller is not told how many rows they were denied.
   */
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the report's grand-total row, one entry per summable column. The payload-level
   * replacement for the deprecated per-row report*Total fields.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * One consolidated invoice row: every line matching on (size, genus, upc)
 * folded together by ReportOrderItemConsolidation. Deliberately its OWN type rather than a
 * reuse of the per-line item row — a consolidated row has no line number, SKU, note or
 * per-line quantity basis, and carrying an arbitrary group member's values in those fields would
 * print a fact about one variety over a quantity spanning five.
 */
export type ReportOrderConsolidatedItemData = {
  __typename?: 'ReportOrderConsolidatedItemData';
  /** The group's eaches over the shared pack, cut toward zero at two decimals. Null without a shared pack. */
  derivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The printed row label: the size and genus joined by a space ("Quart Pentas"), the form
   * GrowPoint's consolidated invoice prints. Falls back to the first contributing line's
   * productName when the group has no genus, so a hard good still prints its own name
   * rather than a bare size or a blank.
   */
  description: Scalars['String']['output'];
  /** The eaches the group's lines bill on, summed. */
  eaches: Scalars['Int']['output'];
  /** The pack every line in the group shares. Null on the same terms as the label. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The group's extended price: the summed items[].lineTotal. Summed rather than
   * recomputed from quantity x unitPrice, so the consolidated table
   * foots to the order's subtotal exactly — every upgrade adjustment already folded into a line
   * total is carried across rather than re-derived from a price that cannot express it.
   */
  extendedPrice: Scalars['Decimal']['output'];
  /** extendedPrice, formatted the same way as unitPriceFormatted. */
  extendedPriceFormatted: Scalars['String']['output'];
  /**
   * The group's genus (items[].genus) — the second key. Empty for hard goods and for any
   * item with no genus set, which therefore consolidate on size and UPC alone.
   */
  genus: Scalars['String']['output'];
  /**
   * How many order lines folded into this row — 1 for an unconsolidated item. Offered so a
   * template (or a reader reconciling the invoice against the acknowledgement) can tell a
   * genuinely single line from a five-variety roll-up printing one summed quantity.
   */
  lineCount: Scalars['Int']['output'];
  /**
   * What unitPrice is per, when every line in the group is priced on the same basis: the unit label,
   * or "ea". Null when the lines are priced on different bases.
   */
  priceBasisLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The group's price per each: extendedPrice over eaches. The first line's price per each
   * when the group has no eaches.
   */
  pricePerEach: Scalars['Decimal']['output'];
  /**
   * The summed items[].quantity across the group, on the same basis the per-line column
   * uses. A group summing to 0 is KEPT, not filtered — GrowPoint prints
   * "0 Quart Portulaca" for an item acknowledged but not shipped, and dropping the row would
   * silently hide it from the customer receiving the delivery.
   */
  quantity: Scalars['Int']['output'];
  /**
   * The group's quantity as a document prints it, "2 (4.5 inch tray) · 30 ea": each unit's count and label,
   * then the eaches. The bare eaches when no line has a named unit.
   */
  quantityText: Scalars['String']['output'];
  /** The Shipping UOM code every line in the group shares. Null on the same terms as the label. */
  shippingUomCode?: Maybe<Scalars['String']['output']>;
  /**
   * The Shipping UOM name every line in the group shares ("4.5 inch tray"). Null when the lines are
   * placed in different units, and when they have none.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The group's size code (items[].size) — the first key. Empty when the contributing
   * items carry no size; such lines consolidate together under a blank size rather than dropping
   * out of the invoice.
   */
  size: Scalars['String']['output'];
  /**
   * The group's effective per-unit price: extendedPrice over quantity.
   * One derivation rather than a uniform/mixed branch, because the per-line unitPrice is
   * itself lineTotal / quantity — so on a group whose lines share a price this reproduces
   * exactly that price, and on a mixed group it is the quantity-weighted average.
   * extendedPrice stays the authoritative figure: no display rounding is applied here, but
   * decimal division still rounds at the type's own precision, so quantity x this
   * reconciles to extendedPrice without being bit-exact for a non-terminating quotient
   * (three units totalling 1.00, say). On a zero-quantity group (division undefined) it falls
   * back to the first contributing line's unit price, mirroring the per-line type's own
   * zero-quantity fallback, so the row still shows what the item would have cost.
   */
  unitPrice: Scalars['Decimal']['output'];
  /**
   * unitPrice, formatted the same way as the order's totalAmountFormatted: rounded to
   * the cent, thousands-grouped and prefixed with the customer's currency symbol. Display only, so
   * unitPrice keeps its full precision.
   */
  unitPriceFormatted: Scalars['String']['output'];
  /**
   * The group's stored whole unit counts, summed. Null when the lines are in different units or any has
   * none stored.
   */
  units?: Maybe<Scalars['Int']['output']>;
  /**
   * The group's UPC (items[].upc) — the third key. Empty when the items have no UPC, which
   * is the ordinary case for the colour varieties this roll-up exists to collapse: they differ by
   * item code, not by UPC, so an empty UPC does NOT prevent grouping. It is the size and genus
   * that keep unrelated blank-UPC items apart.
   */
  upc: Scalars['String']['output'];
};

/**
 * Flattened order record for report generation, combining order header, customer,
 * addresses, and line items into a single denormalized shape.
 */
export type ReportOrderData = {
  __typename?: 'ReportOrderData';
  /**
   * What has been received against the order. Once a LIVE invoice stands against it this is the cash
   * recorded on that invoice, because the bill is then what the customer owes; otherwise it is the
   * total of every ledger entry (payments and deposits) applied to the order
   * (OrdersDocument.AmountPaid). An order that has never been paid against reports
   * 0, never an unknown value.
   */
  amountPaid: Scalars['Decimal']['output'];
  /**
   * amountPaid, pre-formatted with the customer's own currency symbol and thousands grouping —
   * see ReportShared.ReportMoneyFormatter.
   */
  amountPaidFormatted: Scalars['String']['output'];
  /**
   * Outstanding balance on the order. Once a LIVE invoice stands against it this is that invoice's
   * open balance; otherwise it is the order total less the amount paid
   * (OrdersDocument.Balance), less the royalty the bill never charges. An order that has never
   * been paid against reports the full order total less that royalty, never zero.
   */
  balance: Scalars['Decimal']['output'];
  /**
   * What is still owed, SIGNED: the live invoice's open balance, negative when the customer has paid
   * more than the bill; the order's outstanding balance when no invoice stands. Always equal to
   * balance, under the name an invoice document prints.
   */
  balanceDue: Scalars['Decimal']['output'];
  /** balanceDue, formatted the same way as amountPaidFormatted. */
  balanceDueFormatted: Scalars['String']['output'];
  /** balance, formatted the same way as amountPaidFormatted. */
  balanceFormatted: Scalars['String']['output'];
  billTo: ReportAddressData;
  /**
   * The order's carrier code, inherited from the customer at order-create time
   * (OrdersDocument.Carrier). null when the order has no carrier set — renders
   * blank on report output, the same way the other optional header strings on this type
   * (paymentTerms, route) already do; never the literal text "null".
   */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Tenant company profile (remit-to), the ds-orders company.* catalog object. Always populated; name falls back to the tenant name. */
  company: ReportCompanyData;
  /**
   * The order's line items rolled up for a CONSOLIDATED invoice: one row per
   * (size, genus, upc), quantities summed. Additive and independent —
   * items is untouched, so the acknowledgement stays itemised per item code while
   * the invoice collapses (GrowPoint's five Quart Pentas colour varieties print as one
   * "Quart Pentas" line). Consolidation lives here rather than in the report builder because the
   * builder's grouped table renders group headers OVER detail rows and cannot reduce a group to
   * one row, and the PDF service's Handlebars registers no sum/groupBy helper —
   * a template can only print what the payload already folded. Computed on the single materializer
   * call both the preview resolver and the PDF arm share, so the two cannot disagree.
   * Empty when the order has no lines.
   */
  consolidatedItems: Array<ReportOrderConsolidatedItemData>;
  /**
   * How many containers the order fills, rounded up to whole containers: the headline of the order's
   * Containers tab. Null when the order names no container or no line has container capacity set up.
   */
  containerCount?: Maybe<Scalars['Int']['output']>;
  /** The name of the container containerCount counts. Null whenever containerCount is. */
  containerName?: Maybe<Scalars['String']['output']>;
  /**
   * How many of the order's lines the container count leaves out because they have no Shipping UOM or no
   * container capacity. 0 when every line was counted.
   */
  containerUncountedLines: Scalars['Int']['output'];
  customer: ReportCustomerData;
  /**
   * The deposit credited to the live invoice when it was issued. 0 for an order with no live invoice
   * (a deposit on an un-invoiced order is part of amountPaid, as before), and 0 for a bill raised
   * against an order that held no deposit.
   */
  depositApplied: Scalars['Decimal']['output'];
  /** depositApplied, formatted the same way as amountPaidFormatted. */
  depositAppliedFormatted: Scalars['String']['output'];
  /**
   * The resolved dollar value actually subtracted from subtotal — sourced ONLY from the
   * kernel-computed OrdersDocument.EffectiveDiscountAmount (flat-beats-percent: a positive
   * flat discount always wins over a percent discount). Reports 0 — never a recompute — for
   * an order whose EffectiveDiscountAmount has not yet been kernel-computed / backfilled,
   * rather than deriving money at read time from fields that may themselves be stale. A projection
   * rebuild or the orders-effective-discount-royalty-backfill-v1.js migration is the repair
   * path for a null value, not a recompute here. (OrdersDocument.DiscountPercent is now a
   * single FRACTION convention for live and imported orders alike — Helm e1860e5d — so the
   * up-to-100x hazard this note used to cite no longer exists.) Never the flat OrdersDocument.DiscountAmount alone — that
   * field ignores a percent discount entirely. Supersedes the deprecated discountAmount
   * alias; both fields stay in sync until the seeded Invoice / Acknowledgement / Packing Slip
   * templates migrate.
   */
  discount: Scalars['Decimal']['output'];
  /**
   * Deprecated alias for discount — carries the same resolved effective-discount
   * value (NOT the flat OrdersDocument.DiscountAmount alone). Kept in sync until seeded
   * Invoice / Acknowledgement / Packing Slip templates migrate their bindings to discount.
   * @deprecated Use `discount` instead. Will be removed once seeded Invoice / Acknowledgement / Packing Slip templates migrate.
   */
  discountAmount: Scalars['Decimal']['output'];
  /**
   * discount, formatted the same way as totalAmountFormatted. A percent discount can
   * leave discount on a third decimal (28.608); this prints it to the cent ($28.61) while
   * discount keeps the unrounded figure.
   */
  discountFormatted: Scalars['String']['output'];
  discountPercent: Scalars['Decimal']['output'];
  /**
   * The dock name(s) the order ships from, each distinct name once, comma-separated, exactly as stored.
   * With a loadId report parameter it is that load's dock; without one, the dock of every load the
   * order rides. Empty when the order rides no load or its load has no dock.
   */
  dock: Scalars['String']['output'];
  /**
   * Every load assignment that has a dock, lowest load number first: one entry per load the order rides
   * (or, with a loadId report parameter, only the named loads). A split order lists each
   * load's dock beside its portion. Empty when there is no dock.
   */
  dockAssignments: Array<ReportDockAssignmentData>;
  /**
   * The order's drop on its load, as the caller supplied it in dropNumbers beside
   * orderNumbers. Null when none was supplied for the order. The reportOrdersData query takes
   * no order list, so it is always null there.
   */
  dropNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * Where the order is really delivered when it is drop-shipped, such as a job site. The saved
   * location in shipTo is unchanged. Every field is empty, and the pin null, when the order
   * has no drop-ship destination.
   */
  dropShipDestination: ReportDropShipDestinationData;
  /**
   * When payment is due. With a live invoice it is the INVOICE's due date (issue date plus the net-due
   * window of the terms it was issued under), so editing the order afterwards cannot move a date the
   * customer was already given; otherwise it is the order's expected delivery date plus its terms.
   */
  dueDate: Scalars['DateTime']['output'];
  /**
   * The first day of the delivery-day range for this order: the run of consecutive allowed delivery days
   * that holds the expected delivery date, inside its Monday to Sunday week. The ship-to's allowed days come
   * from its own delivery schedule, else its route's. Equals the expected delivery date when the ship-to has
   * no restriction or the date is not an allowed day. Empty when the order has no expected delivery date.
   */
  eligibleDeliveryFrom?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * The last day of the delivery-day range for this order, the end of the run that
   * eligibleDeliveryFrom starts. Empty when the order has no expected delivery date.
   */
  eligibleDeliveryTo?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * What the order bills the customer as it stands today (no royalty, no tax; an override total as typed) plus
   * its stored tax estimate, so an estimate and never a charge; it equals that figure when nobody has estimated
   * the order. It is never the invoice's figure: an invoiced print's totalAmount and taxAmount carry the tax as
   * issued.
   * While the order is marked No tax it equals what the order bills, with no tax estimate added.
   */
  estimatedTotalWithTax: Scalars['Decimal']['output'];
  /** estimatedTotalWithTax, formatted the same way as totalAmountFormatted. An estimate, never a charge. */
  estimatedTotalWithTaxFormatted: Scalars['String']['output'];
  /**
   * The order's expected delivery date (OrdersDocument.ExpectedDeliveryDate). This is the
   * date the legacy invoice ("Invoice & Delivery Date"), credit memo ("Pick Up Date"), and
   * acknowledgement ("Ship Date") all print — distinct from orderDate (initialized),
   * shipDate (actual ship), and dueDate (terms-derived).
   */
  expectedDeliveryDate: Scalars['DateTime']['output'];
  /**
   * Whether this credit order is a final credit (OrdersDocument.FinalCredit) — the per-order
   * value shown as "Final Credit: Yes/No". Surfaced so a credit-memo template can render that line,
   * but only when finalCreditEnabled (the tenant-level gate below) is on.
   */
  finalCredit: Scalars['Boolean']['output'];
  /**
   * Whether the tenant's final-credit feature is enabled (TenantState.FinalCreditEnabled),
   * resolved once per page from the tenant aggregate. This is the GATE the legacy credit generator
   * used (via IsFinalCreditEnabled) to decide whether to render the per-order
   * finalCredit "Final Credit: Yes/No" row at all; a credit-memo template reproduces the
   * legacy behavior by showing that row only when this is true. Defaults to false
   * when the tenant flag cannot be resolved. Tenant-level, so identical for every row on a page.
   */
  finalCreditEnabled: Scalars['Boolean']['output'];
  /**
   * The order's named flat charges (a $75 pallet fee, for example), in the order they were added. Empty
   * when the order has none, which is how a template prints them only when present.
   */
  flatCharges: Array<ReportOrderFlatChargeData>;
  /**
   * Freight charge captured on the order header (OrdersDocument.FreightChargeAmount).
   * Defaults to 0m when the order has no freight charge set.
   */
  freight: Scalars['Decimal']['output'];
  /** freight, formatted the same way as totalAmountFormatted. */
  freightFormatted: Scalars['String']['output'];
  /**
   * The order's effective General note, resolved live by the same inheritance chain. Routed
   * onto the general order documents (invoice, acknowledgement). null when no tier
   * supplies one.
   */
  generalNotes?: Maybe<Scalars['String']['output']>;
  /**
   * Whether an estimate has ever been taken for this order. This is the flag a document binds when it
   * must print no tax row at all rather than a zero one: a genuine zero estimate is real data — the
   * seller holds no tax registration where the goods are going — and is not the same fact as nobody
   * having estimated the order, so taxAmount reading zero can never answer the question on its own.
   */
  hasEstimatedTax: Scalars['Boolean']['output'];
  /**
   * The date the ACTIVE invoice was issued — the date the terms clock starts from, and the date an
   * invoice document prints. null on the same terms as invoiceNumber.
   */
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The number of the ACTIVE invoice raised against this order — the bill that still stands. This is the
   * INVOICE's own number (the order number on a first bill, orderNumber-R1, -R2 and so on for a bill
   * raised after a previous one was withdrawn), never the order number restated: an invoice document
   * printing the order number where the receivable carries another is the defect this field exists to
   * remove. null for an order that has never been invoiced AND for one whose every invoice has
   * been voided, so a template prints a pro forma with {{#if invoiceNumber}} rather than an
   * invoice number nothing owes.
   */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Where the ACTIVE invoice stands as a document, as its enum name — Issued. null on the
   * same terms as invoiceNumber; a voided invoice is never the active one, so this never reads
   * Voided.
   */
  invoiceStatus?: Maybe<Scalars['String']['output']>;
  itemCount: Scalars['Int']['output'];
  items: Array<ReportOrderItemData>;
  /**
   * The freight view of every named load the order rides, lowest load number first: carrier and contact,
   * container type with dimensions and weight, pickup window, transit kind, the order's stop with its planned
   * arrival, and the pickup site. Empty unless the print names a load with a loadId report parameter.
   */
  loadFreight: Array<ReportLoadFreightData>;
  /**
   * Why the order's live invoice went out with No tax, for example Resale, as recorded when it was issued.
   * Null when the order has no live invoice, or its invoice did not go out with No tax. The order's No tax
   * note is never included.
   */
  noTaxReason?: Maybe<Scalars['String']['output']>;
  /**
   * Free-form running order history joined into a single string from
   * OrdersDocument.History. This is the legacy generic notes field that predates
   * the typed Ship/Pull/General notes below; it is kept (not dropped) so existing report
   * templates that bind {{notes}} keep rendering. New templates should prefer the
   * routed ShipNotes / PullNotes / GeneralNotes fields.
   */
  notes?: Maybe<Scalars['String']['output']>;
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['String']['output'];
  /**
   * The current name of the order's Order kind, resolved from the tenant's Order kinds when the report runs. The
   * order stores only the kind's id. Empty when the order has no kind or the kind has been removed.
   */
  orderKind: Scalars['String']['output'];
  /**
   * The order's load factor — its RACK COUNT, GrowPoint's Sales Orders "Load Factor" column, which
   * customers plan truck loads from. The sum, across every line, of the line's eaches quantity
   * (items[].eachesQuantity, the physical "Order Qty" figure) times its item's load factor
   * (items[].loadFactor) — never the pricing/handling-UOM items[].quantity, which can
   * be a tray or case count that would understate the racks, the same basis
   * shipWeightLbs above uses and for the same reason. A line contributes only when BOTH its
   * eaches quantity and its item's load factor were captured; a line whose eaches quantity was
   * never captured displays 0 for items[].eachesQuantity but is NOT treated as a
   * captured zero here.
   *
   * null when NO line carries a load-factor-bearing item — an UNKNOWN rack count, which is
   * not the same fact as an order that genuinely occupies no racks, and printing 0 on a load
   * sheet would assert the latter. A captured load factor of 0 is a real value and does
   * contribute.
   *
   *
   * NOTE THE DELIBERATE DIFFERENCE FROM shipWeightLbs, which returns a genuine 0 when
   * no line is weighed and null when only SOME are. Weight is all-or-nothing on a Bill of
   * Lading, where a silently-low total is the dangerous outcome; a rack count is read as a running
   * planning figure and GrowPoint itself shows the partial sum, so a partially-known order sums the
   * lines that ARE known rather than collapsing to null.
   *
   *
   * Computed by OrderLoadFactor.Compute, the same function every rack count on every screen
   * resolves through — the Order page's orders.loadFactor, and the Sales Orders grid's and
   * orders CSV export's combinedOrders load factor — so this document and the screens can
   * never disagree about an order's rack count.
   */
  orderLoadFactor?: Maybe<Scalars['Decimal']['output']>;
  orderNumber: Scalars['String']['output'];
  /**
   * The order type as its enum name (e.g. Credit, Sales), sourced from
   * OrdersDocument.OrderType. Lets an invoice template pick the invoice-vs-credit variant
   * the legacy QuestPDF generator selected via order.Type == OrderType.Credit — a credit
   * memo renders negated quantities/totals and the "Credit Memo" heading instead of "Invoice".
   */
  orderType: Scalars['String']['output'];
  /**
   * The customer this order was taken for, when a customer combine has since moved it onto the
   * customer it was combined into; null for an order still on its own customer.
   */
  originalCustomerId?: Maybe<Scalars['String']['output']>;
  /** The name of that customer when it was combined; null when the order was never moved. */
  originalCustomerName?: Maybe<Scalars['String']['output']>;
  /**
   * The URL an invoice encodes as its scannable QR code and surfaces as its "Pay online" hyperlink. When the
   * grower's online invoice payments are switched on and the order's live invoice has an active pay link, it
   * is that invoice's durable pay URL — the same one the invoice email prints. Otherwise it is what it always
   * was: the grower's legacy payment-portal link where one is configured, and empty everywhere else.
   */
  paymentQrPayload: Scalars['String']['output'];
  /**
   * The order's payment standing as its enum name: Unpaid, PartiallyPaid,
   * Paid, or Overpaid. Translated from the LIVE invoice's standing once one stands
   * against the order; otherwise worked out from the amount paid against the order total less the
   * royalty the bill never charges, the same figure balance is worked from.
   */
  paymentStatus: Scalars['String']['output'];
  /**
   * With a live invoice this is the terms the INVOICE was issued under, as a label built from its
   * frozen snapshot ("Net 30", "2/10 Net 30", "Due on receipt"). Otherwise it is the order's payment
   * terms DISPLAY NAME (e.g. "NET 30"), resolved from the Terms read model's
   * TermsDocument.Name by ReportOrdersDataMaterializer.ResolveTermsName — never the
   * raw OrdersDocument.TermsId. null when the order has no terms set, or the id no
   * longer resolves (a foreign id, or a deleted terms record).
   */
  paymentTerms?: Maybe<Scalars['String']['output']>;
  /**
   * The cash recorded against the live invoice, carried order payments included; the order's own
   * amountPaid when no invoice stands. Always equal to amountPaid, under the name an invoice document
   * prints.
   */
  paymentsApplied: Scalars['Decimal']['output'];
  /** paymentsApplied, formatted the same way as amountPaidFormatted. */
  paymentsAppliedFormatted: Scalars['String']['output'];
  poNumber: Scalars['String']['output'];
  /**
   * The marker a load's print carries when it prints only that load's portion of a split order, for example
   * "Part 1 of 2 · 70 of 140". Empty for every other print, which is how a template shows it only when present.
   */
  portionLabel: Scalars['String']['output'];
  /** The order's Program, a name from the tenant's Programs list. Empty when the order has none. */
  program: Scalars['String']['output'];
  /**
   * The order's effective Pull note, resolved live by the same inheritance chain. Routed
   * onto the pull sheet / picking ticket. null when no tier supplies one.
   */
  pullNotes?: Maybe<Scalars['String']['output']>;
  /**
   * The last day the quote on this order is valid, as a tenant-local date. Empty when none is set.
   * Set on a draft order with setOrderQuoteDetails, so a quote document can print it.
   */
  quoteValidUntil?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * The load factor (including zero), or the whole order's container count when no load factor exists, or
   * else the carts the printed load plans for the order: the container counts of its loadFreight entries
   * added up. Null only when none of the three exists. The planned carts exist only when a load is printed,
   * and not when any loadFreight entry has no count. On a split order, the load factor and the planned carts
   * are this load's portion while the container count is the whole order's, as the Containers tab shows it.
   */
  racks?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The order's resolved route (OrdersDocument.EffectiveRoute), resolved by the same
   * 3-tier precedence (direct order override → ship-to location → customer → tenant default)
   * as the live order.effectiveRoute field. null when nothing resolves.
   */
  route?: Maybe<Scalars['String']['output']>;
  /**
   * Order-level royalty rollup computed as the sum of per-line
   * OrderLineItemDocument.Royalty.Amount snapshots. OrdersDocument has no
   * order-level royalty field; rollup is computed in ReportOrdersDataQuery after
   * the line-item join. Defaults to 0m when no lines carry a royalty snapshot.
   */
  royalty: Scalars['Decimal']['output'];
  salesPerson?: Maybe<Scalars['String']['output']>;
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The order's effective Ship note, resolved live by the order-note inheritance chain
   * (order override → ship-to customer location → customer) via
   * WorkSuite.GraphQl.Features.Orders.EffectiveOrderNotes. Routed onto shipping
   * documents (packing slip, order acknowledgement). null when no tier supplies one.
   */
  shipNotes?: Maybe<Scalars['String']['output']>;
  shipTo: ReportAddressData;
  /**
   * Computed shipment weight for the order, in pounds: the sum, across every line, of the
   * line's each count (the eaches the line bills on, which items[].eaches prints) times its
   * item's per-each weight (items[].weightLbs). items[].eachesQuantity counts shipping
   * units, so 7 flats of 12 weigh 84 eaches, never 7. A line counts
   * as WEIGHED only when BOTH its eaches quantity and its item's weight were captured — a line
   * whose eaches quantity was never captured displays 0 for
   * items[].eachesQuantity but is NOT treated as a captured zero here; it counts as
   * unweighed, exactly like a line whose item has no captured weight. When every line is
   * weighed (including an order with no lines), this is the real sum. When NO line is weighed,
   * this is a genuine 0 — the same "nothing captured yet" convention this data source
   * uses elsewhere. When SOME but not all lines are weighed, this is null rather than a
   * total that silently omits an unweighed line's contribution while still looking like a
   * complete number — a Bill of Lading showing no weight is safer than one showing a
   * silently-low one.
   */
  shipWeightLbs?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The line-item subtotal on the SHIPPED basis: items[].shippedLineTotal summed across every
   * line, so a document billing what shipped foots its subtotal to the shipped line amounts printed
   * above it. Folded from the mapped item values, exactly as totalShippedQuantity is.
   * Distinct from subtotal, which stays on the order basis — a line shipped 0 still counts
   * there and counts nothing here. 0 for an order nothing has shipped on. Before freight,
   * discount, royalty and tax; no shipped order total is derived from it.
   */
  shippedSubtotal: Scalars['Decimal']['output'];
  /**
   * Alias for freight — the freight charge captured on the order header
   * (OrdersDocument.FreightChargeAmount) — so a template built against the "shipping"
   * terminology binds the same dollar value as one built against "freight".
   */
  shippingAmount: Scalars['Decimal']['output'];
  /**
   * Captured authorized-signature block (base64 image + signer name) when the order carries one,
   * else null. Mirrors the signature the legacy invoice / credit / acknowledgement PDFs
   * render above the footer from OrderStateData.SignatureImage.
   */
  signature?: Maybe<ReportOrderSignatureData>;
  status: Scalars['String']['output'];
  /**
   * The true line-item subtotal — the sum of every line's amount BEFORE freight and discount are
   * applied (OrdersDocument.Subtotal) — distinct from totalAmount, the grand
   * total. Falls back to summing items' lineTotal for an order whose
   * Subtotal has not yet been kernel-computed (see discount).
   */
  subtotal: Scalars['Decimal']['output'];
  /**
   * subtotal, formatted the same way as totalAmountFormatted: rounded to the cent,
   * thousands-grouped and prefixed with the customer's currency symbol. Display only, so
   * subtotal itself keeps its full precision.
   */
  subtotalFormatted: Scalars['String']['output'];
  /**
   * The ESTIMATED sales tax on the order, from Stripe. Estimated, never charged: it is not part of
   * totalAmount, and the tax the customer actually pays is settled when the order is invoiced on what
   * was shipped. Reads 0 for an order nobody has estimated — which is not the same as a genuine zero
   * estimate, so a report that must distinguish the two should show the estimate date beside it.
   * Filing figures come from invoices, never from this field. With a live invoice it is instead the tax
   * the INVOICE charged, as issued, and hasEstimatedTax reads false. A load's portion print (portionLabel
   * set) keeps the portion's cut estimate.
   * Reads 0 while the order is marked No tax.
   */
  taxAmount: Scalars['Decimal']['output'];
  /**
   * taxAmount, formatted the same way as totalAmountFormatted. Still only the ESTIMATE: it is never
   * what the customer is charged, and the tax actually owed is settled when the order is invoiced on
   * what shipped.
   * Reads 0 while the order is marked No tax.
   */
  taxAmountFormatted: Scalars['String']['output'];
  /**
   * The combined rate the ESTIMATED sales tax works out to, as a PERCENT in 0..100 — 6.5 means 6.5%,
   * not 0.065. It is derived from the stored Stripe estimate, so it is an estimate too, and it reads
   * 0 for an order nobody has estimated. An order taxed in one jurisdiction resolves to that
   * jurisdiction's rate; an order taxed by a state, a county and a city resolves to the combined rate
   * across all of them, which is the rate a customer would recognise. With a live invoice it is still
   * the order's estimated rate, not the rate behind taxAmount, which is the invoice's issued tax.
   * Reads 0 while the order is marked No tax.
   */
  taxRate: Scalars['Decimal']['output'];
  /**
   * The early-pay discount message, for example "You may deduct $25.00 if paid in full before 6/11/2026."
   * It is never worked out on the royalty. With a live invoice the deduction is worked out from the invoice's
   * total after the deposit credit; otherwise from what the order bills the customer, its total less its royalty
   * or an override total as typed. Null when the order's terms offer no early-pay discount.
   */
  termsDiscountMessage?: Maybe<Scalars['String']['output']>;
  /**
   * items[].acknowledgedQuantity summed across every line — the ACK total. An order that
   * has not passed the acknowledge gate foots 0, because every line contributes the
   * 0 its own column shows; see the acknowledgedQuantity item field for
   * why an uncaptured acknowledgement and an explicit zero are the same value here.
   */
  totalAcknowledgedQuantity: Scalars['Int']['output'];
  /**
   * The order total, never the royalty, which the invoice never bills (the royalty stays in royalty). With a
   * live invoice it is the invoice's gross before the deposit credit: subtotal, freight, flat charges and tax as
   * issued. With none it is what the order bills the customer, the same figure the order page and the order
   * emails show: the order's total less its royalty, or an override total as typed. A load's portion print
   * (portionLabel set) carries the portion's own total instead, worked out the same way from the portion's cut
   * figures; when an invoice stands, that total also adds the portion's cut tax.
   */
  totalAmount: Scalars['Decimal']['output'];
  /** totalAmount, formatted the same way as amountPaidFormatted. */
  totalAmountFormatted: Scalars['String']['output'];
  /**
   * The eaches every line of the order bills on, summed: items[].eaches across the order's lines.
   * The eaches grand total a document foots beside its per-unit totals (unitTotals).
   */
  totalEaches: Scalars['Int']['output'];
  /**
   * items[].orderedQuantity summed across every line — the ORD figure GrowPoint's order
   * Acknowledgement foots beneath its ordered column. Folded from the MAPPED item values rather
   * than re-read off the line documents, exactly as totalUnits is, so this total can never
   * disagree with the rows printed above it.
   */
  totalOrderedQuantity: Scalars['Int']['output'];
  /**
   * The order's quantity as a document prints it: each unit's count and label, then the eaches grand
   * total, "12 (4.5 inch tray) · 3 (flat) · 234 ea". The bare eaches total when no line has a named unit.
   */
  totalQuantityText: Scalars['String']['output'];
  /**
   * items[].shippedQuantity summed across every line — the SHIP total, and 0 for
   * every order that has not shipped yet, on the same footing as
   * totalAcknowledgedQuantity.
   */
  totalShippedQuantity: Scalars['Int']['output'];
  /**
   * Every line's quantity, summed. It counts shipping units on lines priced per unit and eaches on lines
   * priced per each, so it is not one unit's count: totalEaches is the order's each count and
   * unitTotals its count per unit.
   */
  totalUnits: Scalars['Int']['output'];
  /**
   * The order's quantity per Shipping UOM label: one entry per unit the order's lines are placed in, in
   * the order each unit first appears, carrying that unit's summed unit count and eaches. Lines with no
   * unit (a pack of one or an unstated pack) count only toward totalEaches. Empty when no line has
   * a named unit.
   */
  unitTotals: Array<ReportOrderUnitTotalData>;
};

/** One named flat charge on an order, as a document prints it: "Pallet fee: $75.00". */
export type ReportOrderFlatChargeData = {
  __typename?: 'ReportOrderFlatChargeData';
  /** The amount billed. */
  amount: Scalars['Decimal']['output'];
  /** amount, formatted the same way as totalAmountFormatted. */
  amountFormatted: Scalars['String']['output'];
  /** The charge's name, as copied from the tenant's charge list when it was added. */
  name: Scalars['String']['output'];
};

/** Flattened order fulfillment readiness record for report generation. */
export type ReportOrderFulfillmentReadinessData = {
  __typename?: 'ReportOrderFulfillmentReadinessData';
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  earliestUnblockDate?: Maybe<Scalars['DateTime']['output']>;
  expectedDeliveryDate: Scalars['DateTime']['output'];
  linesBlockedInventory: Scalars['Int']['output'];
  linesBlockedProduction: Scalars['Int']['output'];
  linesLate: Scalars['Int']['output'];
  linesReady: Scalars['Int']['output'];
  linesTotal: Scalars['Int']['output'];
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  poNumber: Scalars['String']['output'];
  readinessPercent: Scalars['Decimal']['output'];
  readinessStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportOrderFulfillmentReadinessData query. TotalCount is the number of
 * records returned (capped at 5000). TotalMatching is the total number of records matching the
 * filters before the page limit is applied. TotalMatchingExact is false when the input
 * materialization hit the cap (TotalMatching is then a lower bound, and the caller should
 * narrow the filter for an exact total).
 */
export type ReportOrderFulfillmentReadinessDataPayload = {
  __typename?: 'ReportOrderFulfillmentReadinessDataPayload';
  data: Array<ReportOrderFulfillmentReadinessData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  totalMatchingExact: Scalars['Boolean']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no orders matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of the GrowPoint Order Item Allocations and Open Orders by Location reports — an order line
 * at ONE allocated location, with the order header denormalized onto it so the list renders tabularly
 * without per-row joins.
 */
export type ReportOrderItemAllocationsData = {
  __typename?: 'ReportOrderItemAllocationsData';
  /** Gets the line's acknowledged quantity in units, as stored. Null when the line has no unit or none is stored. */
  acknowledgedUnits?: Maybe<Scalars['Int']['output']>;
  /** Gets the quantity allocated AT THIS LOCATION. Sums across the line's rows. */
  allocatedQuantity: Scalars['Int']['output'];
  /**
   * Gets the line's allocated quantity in units across every location, as stored. REPEATS on each of the
   * line's rows, as lineAllocatedQuantity does. Null when the line has no unit or none is stored.
   */
  allocatedUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * Gets the order-level allocation rollup (NotStarted / Partial / Allocated / Short / MakeToOrder),
   * as its enum name. Blank for an order whose stream predates the rollup and was never re-stamped.
   */
  allocationStatus: Scalars['String']['output'];
  /**
   * Gets the code of the container the row's shipping unit rides: the order's own container when its
   * goods ride it, else the configured container that fits the shipping unit at the order's ship-from
   * site. Blank when no container fits or the unit states no eaches; never a guessed capacity.
   */
  containerCode: Scalars['String']['output'];
  /**
   * Gets the share of one container the row takes: its pick units over unitsPerContainer,
   * unrounded. Null on the same terms as containerCode.
   */
  containerFraction?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the name of that container. Blank on the same terms as containerCode. */
  containerName: Scalars['String']['output'];
  /** Gets the bill-to customer's identifier. */
  customerId: Scalars['String']['output'];
  /** Gets the bill-to customer's name — GrowPoint's "Bill To". */
  customerName: Scalars['String']['output'];
  /**
   * Gets pickQuantity over eachesPerUnit, cut toward zero at two decimals. Null when the
   * line has no unit.
   */
  derivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the row's pick quantity in eaches, the same figure as pickQuantity. */
  eaches: Scalars['Int']['output'];
  /**
   * Gets how many eaches one unit of the line holds, from the line's own snapshot taken when it was placed,
   * never the Shipping UOM's current count. Null when the pack is one or unstated.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * Gets whether this is the FIRST returned row at its location — gates the section heading. False
   * unless groupByLocation is on.
   */
  firstOfLocation: Scalars['Boolean']['output'];
  /** Gets the inventory grade this row's allocation was taken from. */
  grade: Scalars['Int']['output'];
  /** Gets the item identifier. */
  itemId: Scalars['String']['output'];
  /** Gets the item name as it was recorded on the line. */
  itemName: Scalars['String']['output'];
  /**
   * Gets whether this is the LAST returned row at its location — gates the subtotal row. False unless
   * groupByLocation is on.
   */
  lastOfLocation: Scalars['Boolean']['output'];
  /**
   * Gets the line's total allocated quantity across every location. REPEATS on each of the line's
   * rows — do not sum it down a column.
   */
  lineAllocatedQuantity: Scalars['Int']['output'];
  /** Gets the line number within the order. */
  lineNumber: Scalars['Int']['output'];
  /**
   * Gets the containers the row's location needs, e.g. 4 CC Rack · 1 Shelf: each container's
   * fractions summed over the location's returned rows and rounded up once, never adding different
   * containers together; ends + N lines not counted when lines fit no container. REPEATS on each
   * of the location's rows. Blank unless groupByLocation is on, as locationPickTotal is.
   */
  locationContainersText: Scalars['String']['output'];
  /**
   * Gets the inventory location this row's allocation sits at, or blank when the line carries no
   * allocation, or an allocation with no location. Blank is the row this report exists to surface,
   * not a defect.
   */
  locationId: Scalars['String']['output'];
  /**
   * Gets the allocated location's name, or blank when the location is unknown to the sub-location
   * read model — the id is still printed, so the row is never silently unattributed.
   */
  locationName: Scalars['String']['output'];
  /**
   * Gets pickQuantity summed across every returned row at this row's location —
   * GrowPoint's per-location subtotal. REPEATS on each of the location's rows; the template prints it
   * once, gated on lastOfLocation.
   */
  locationPickTotal: Scalars['Int']['output'];
  /**
   * Gets the number of the master order that RELEASED this order, or blank when the order was not
   * released from one. Resolved through MasterOrdersDocument.Releases, the only link between
   * the two — an order document carries no master-order id of its own.
   */
  masterOrderNumber: Scalars['String']['output'];
  /** Gets the order date — the order's initialized date. */
  orderDate: Scalars['DateTime']['output'];
  /** Gets the order identifier. */
  orderId: Scalars['String']['output'];
  /** Gets the order number — GrowPoint's "Order No.". */
  orderNumber: Scalars['String']['output'];
  /**
   * Gets the quantity the line should be allocated to — acknowledged where set, else the line
   * quantity, else ordered. Mirrors OrderState.ResolveAllocationQuantityBasis; see
   * ReportOrderAllocationStateFilter.ResolveAllocationQuantityBasis.
   */
  orderedQuantity: Scalars['Int']['output'];
  /** Gets the line's ordered quantity in units, as stored. Null when the line has no unit or none is stored. */
  orderedUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * Gets the id of the range or house the row's location sits in: the location's parent. Empty when the
   * location has no parent, the parent no longer exists, or the row has no location.
   */
  parentLocationId: Scalars['String']['output'];
  /** Gets the name of the range or house the row's location sits in. Empty when the location has no parent. */
  parentLocationName: Scalars['String']['output'];
  /**
   * Gets the quantity this row asks a crew to DIG — allocatedQuantity at a real
   * location, and unallocatedQuantity in the blank-location bucket.
   */
  pickQuantity: Scalars['Int']['output'];
  /** Gets the customer's P.O. number — GrowPoint prints this as the "Reference No.". */
  poNumber: Scalars['String']['output'];
  /**
   * Gets the item's Product Group, joined live from the item read model (ItemSummaryDocument.ProductGroup)
   * rather than the line's snapshot. Empty when the item cannot be resolved or has none.
   */
  productGroup: Scalars['String']['output'];
  /**
   * Gets the row's pick quantity as a document prints it, "2 (4.5 inch tray) · 30 ea". The bare each
   * count when the line has no unit or its Shipping UOM has no name.
   */
  quantityText: Scalars['String']['output'];
  /** Gets the order's salesperson. */
  salesPerson: Scalars['String']['output'];
  /** Gets the expected delivery date — GrowPoint's "Ship Date". */
  shipDate: Scalars['DateTime']['output'];
  /** Gets the ship-to customer location's code — GrowPoint's "Ship To" range. */
  shipToCode: Scalars['String']['output'];
  /** Gets the ship-to customer location's name. */
  shipToName: Scalars['String']['output'];
  /** Gets the quantity shipped against the line, or 0 when nothing has shipped. */
  shippedQuantity: Scalars['Int']['output'];
  /** Gets the line's shipped quantity in units, as stored. Null when the line has no unit or none is stored. */
  shippedUnits?: Maybe<Scalars['Int']['output']>;
  /** Gets the code of that Shipping UOM. Null when the line has no unit or the Shipping UOM has no code. */
  shippingUomCode?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the name of the Shipping UOM the row's line was placed under, the unit a document prints beside
   * the pick quantity ("4.5 inch tray"). Resolved by the same ladder as ds-orders: the line's own
   * stamp, then its frozen shipping-config code, then its item's default. Null when the line's pack is one
   * or unstated, and when no Shipping UOM with a name resolves.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /** Gets the line's SKU — GrowPoint's "Item Code" range matches against this. */
  sku: Scalars['String']['output'];
  /** Gets the order's lifecycle status, as its enum NAME so exports render it readably. */
  status: Scalars['String']['output'];
  /**
   * Gets the item's Subcategory, joined live from the item read model (ItemSummaryDocument.Subcategory).
   * Empty when the item cannot be resolved or has none.
   */
  subcategory: Scalars['String']['output'];
  /**
   * Gets what the line still lacks: orderedQuantity less lineAllocatedQuantity, floored at zero so an
   * over-allocated line reads 0 rather than a negative shortfall. Over-allocation is permitted by the
   * allocate command, and a negative "unallocated" would read as a shortfall of the opposite sign in
   * every export that sums it. REPEATS on each of the line's rows.
   */
  unallocatedQuantity: Scalars['Int']['output'];
  /**
   * Gets the stored whole unit count of pickQuantity: the allocation basis's stored rung on a
   * never-allocated line. Null on an allocated row, whose share of an allocation has no stored unit
   * count, and when the line has no unit.
   */
  units?: Maybe<Scalars['Int']['output']>;
  /** Gets how many of the row's shipping units one container holds. Null on the same terms as containerCode. */
  unitsPerContainer?: Maybe<Scalars['Int']['output']>;
};

/** Payload wrapper for the reportOrderItemAllocationsData query. */
export type ReportOrderItemAllocationsDataPayload = {
  __typename?: 'ReportOrderItemAllocationsDataPayload';
  /** The returned allocation rows. */
  data: Array<ReportOrderItemAllocationsData>;
  /** The number of rows returned after applying the row limit. */
  totalCount: Scalars['Int']['output'];
  /** The number of rows matching the filters before the row limit, counted after the line-level row filters, which are applied in memory. */
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/** Line item data for a single order line on report output. */
export type ReportOrderItemData = {
  __typename?: 'ReportOrderItemData';
  /**
   * The line's ACKNOWLEDGED quantity — GrowPoint's ACK column, what was committed back to the
   * customer. Raw EACHES, on the same basis as orderedQuantity.
   *
   * 0 when the line carries none, which is the state of every line whose order has not
   * passed the acknowledge gate. That is INDISTINGUISHABLE from an explicit acknowledgement of
   * zero, and unavoidably so: the read model stores both as the same absent/zero value, so no
   * reading here can separate them. Rendering the blank as 0 rather than leaving the cell
   * empty is the same "nothing captured yet" convention amountPaid and totalUnits
   * use on this source, and it is what ds-order-line-items already prints.
   */
  acknowledgedQuantity: Scalars['Int']['output'];
  /** The acknowledged quantity in units, as stored. Null when the line has no unit or none is stored. */
  acknowledgedUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * The line item's Category CODE as shown on the Item DETAILS page, joined from the item read
   * model's FIRST category (ItemSummaryDocument.Categories[0]) — the order line carries no
   * category of its own, so this reflects the item as configured today rather than at order time,
   * the same live-join convention as genus and size above. Deliberately NOT
   * ItemSummaryDocument.SortCategory, which is every assigned code sorted and comma-joined
   * and so diverges from this column on a multi-category item; also NOT Group (Item Group),
   * a separate field. Empty when the item cannot be resolved or has no category assigned (e.g. an
   * item with Categories: []).
   */
  category: Scalars['String']['output'];
  /**
   * The line's assigned container code (OrderLineItemDocument.ContainerCode), shown in the
   * legacy acknowledgement line table's "Container Code" column. null when unassigned.
   */
  containerCode?: Maybe<Scalars['String']['output']>;
  /**
   * eaches over eachesPerUnit, cut toward zero at two decimals: 25 eaches on a pack of 18 is
   * 1.38. Null when the line has no unit.
   */
  derivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The line item's Description, joined from the item read model
   * (ItemSummaryDocument.Description) — the order line carries no description of its own,
   * so this reflects the item as configured today rather than at order time, the same live-join
   * convention genus, size, native, weightLbs and loadFactor
   * above follow. Distinct from productName (the order-time snapshot of the item's Name).
   * Empty when the item cannot be resolved or has no description set.
   */
  description: Scalars['String']['output'];
  /** The eaches this line bills on: the stage-aware each count lineTotal extends across. */
  eaches: Scalars['Int']['output'];
  /**
   * How many eaches one unit of this line holds, from the line's own snapshot taken when it was placed,
   * never the Shipping UOM's current count. Null when the pack is one or unstated.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The line's count in SHIPPING UNITS (trays, flats, cases), OrderLineItemDocument.EachesQuantity,
   * whose name says eaches but which holds units. quantity prints this same count on a line
   * priced per unit; eaches is the line's each count. 0 when the line carries no unit count.
   */
  eachesQuantity: Scalars['Int']['output'];
  /**
   * The line item's genus, joined from the item read model (ItemSummaryDocument.Genus) —
   * the order line carries no genus of its own, so this reflects the item as configured today
   * rather than at order time, the same convention native, weightLbs and
   * loadFactor below follow. null when the item cannot be resolved; empty when the
   * item has no genus set (a hard good). One of the three keys consolidatedItems groups on.
   */
  genus?: Maybe<Scalars['String']['output']>;
  /**
   * Always null: an order line has no grade. Grade is an ALLOCATION-level fact in this
   * domain (InventoryItemDocument.Grade, keyed by item x location x grade), and
   * the order-side allocation resolvers that once carried it are obsoleted. Kept declared, and
   * kept as a seeded column, so a template that already binds it renders blank rather than
   * breaking — but nothing populates it, and no value should be invented to fill the gap.
   */
  grade?: Maybe<Scalars['String']['output']>;
  /**
   * The line's item code — the item SKU saved on the line — whatever customer SKU sku
   * prints.
   */
  itemCode: Scalars['String']['output'];
  /**
   * The line item's item-group label (OrderLineItemDocument.ItemGroup), shown in the legacy
   * invoice / credit line table's "Item Group" column. null when ungrouped.
   */
  itemGroup?: Maybe<Scalars['String']['output']>;
  lineNumber: Scalars['Int']['output'];
  lineTotal: Scalars['Decimal']['output'];
  /** lineTotal, formatted the same way as unitPriceFormatted. */
  lineTotalFormatted: Scalars['String']['output'];
  /**
   * The line item's load factor, joined from the item read model
   * (ItemSummaryDocument.LoadFactor) — the order line carries no load factor of its own, so
   * this reflects the item as configured today rather than at order time, the same convention
   * native and weightLbs above already follow. null when the item cannot be
   * resolved or has no captured load factor. Feeds the order-header orderLoadFactor rollup.
   */
  loadFactor?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Whether the line's item is a native plant species, joined from the item read model
   * (ItemSummaryDocument.Native) — the order line carries no Native of its own, so this
   * reflects the item as configured today rather than at order time. The order-grain columns
   * cannot express this; it lives on the line because one line resolves to exactly one item.
   */
  native: Scalars['Boolean']['output'];
  /**
   * The line item's note text (OrderLineItemDocument.Note.NoteText), shown in the legacy
   * acknowledgement line table's "Note" column. null when the line has no note.
   */
  note?: Maybe<Scalars['String']['output']>;
  /**
   * The line's ORDERED quantity — GrowPoint's ORD column, what the customer asked for. The RAW
   * OrderLineItemDocument.OrderedQuantity in EACHES, deliberately NOT run through
   * ReportOrdersDataMaterializer.ResolveQuantityBasis: that chain exists to keep
   * quantity on the basis lineTotal is PRICED from, and ORD/ACK/SHIP are a different
   * fact: a reconciliation of asked / committed / shipped. The mapping is byte-for-byte the one the
   * tabular ds-order-line-items source already applies (ReportOrderLineItemsRead), so
   * the two sources cannot report a different ORD for the same order.
   *
   * 0 when the line carries no ordered quantity. The same three stages counted in UNITS are
   * orderedUnits, acknowledgedUnits and shippedUnits, and quantityText
   * prints the line's quantity in both.
   */
  orderedQuantity: Scalars['Int']['output'];
  /** The ordered quantity in units, as stored. Null when the line has no unit or none is stored. */
  orderedUnits?: Maybe<Scalars['Int']['output']>;
  /**
   * The line's Ship note, falling back to its General note (note) when no Ship note is
   * set. This is the value the seeded Packing Slip template's line "Note" column binds
   * (ReportTemplateSeedService.PackingSlipId, craft.js node ps-items). It is a
   * declared ds-orders column so the report builder's Add All cannot drop that binding, but a
   * report wanting a literal note should pick shipNote or note — those stay
   * independently exposed with no fallback, so a General-only line renders on the packing slip
   * exactly as it did before typed notes existed (day-one parity). null when the line has
   * neither a Ship nor a General note.
   */
  packingSlipNote?: Maybe<Scalars['String']['output']>;
  /**
   * What unitPrice and royaltyPerUnit are per: the unit label when the line is priced per
   * unit, "ea" when it is priced per each, and "unit" for a per-unit price whose unit has no name.
   */
  priceBasisLabel: Scalars['String']['output'];
  /**
   * The line's price per each: lineTotal over eaches, upgrades included, printed beside a
   * per-unit unitPrice. The line's catalog price when it has no eaches.
   */
  pricePerEach: Scalars['Decimal']['output'];
  productName: Scalars['String']['output'];
  /**
   * The line's Pull-context typed note text (OrderLineItemDocument.Notes, the entry keyed
   * NoteContext.Pull), picked for the report builder. Independent of note — never
   * falls back to the General note. null when the line carries no Pull note.
   */
  pullNote?: Maybe<Scalars['String']['output']>;
  /**
   * The quantity shown in the "Qty" column, on the same basis lineTotal is priced from: the
   * line's shipping-unit count (eachesQuantity) on a line priced per unit, and its each count on
   * a line priced per each, which is every line entered in eaches and every line whose stamped eaches
   * are not a whole number of units. priceBasisLabel names which. Because unitPrice is
   * the upgrade-inclusive effective price (see its own doc), quantity x unitPrice
   * reconstructs lineTotal on every row, with or without an upgrade.
   */
  quantity: Scalars['Int']['output'];
  /**
   * The line's quantity as a document prints it: the stored unit count, the unit label and the eaches,
   * "2 (4.5 inch tray) · 30 ea", with thousands separators. The bare each count, "30", when the line has
   * no unit or its Shipping UOM has no name.
   */
  quantityText: Scalars['String']['output'];
  /**
   * The line's royalty per quantity-basis unit — GrowPoint's "item royalty per unit" column,
   * offered so a credit memo (or invoice) template can print it as a toggleable line column.
   * Derived as the captured line-total royalty Amount over the same quantity basis
   * lineTotal is priced from — the identical Amount the order-header
   * royalty rollup sums, so on a line with a non-zero quantity basis the column
   * reconciles exactly against that rollup (per-unit times quantity equals the line's
   * contribution). A zero-quantity Flat-rate line instead shows its configured per-unit
   * Rate, which is deliberate and does NOT multiply out to the line's frozen
   * Amount: the rate is an absolute per-unit amount by definition and stays the
   * meaningful figure to print, whereas the quotient is undefined. null when the line
   * carries no royalty (or a Percentage royalty sits on a zero-quantity line) — distinct from a
   * genuine 0 royalty. Appended last so no existing field on this ds-orders item record changes
   * its declared position.
   */
  royaltyPerUnit?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The line's Ship-context typed note text (OrderLineItemDocument.Notes, the entry keyed
   * NoteContext.Ship), picked for the report builder. Independent of note — never
   * falls back to the General note. null when the line carries no Ship note.
   */
  shipNote?: Maybe<Scalars['String']['output']>;
  /**
   * The line's money on the SHIPPED basis: the eaches that shipped, priced per each with the same
   * override and upgrade ("Value Add") pricing as lineTotal. NOT shippedQuantity x
   * unitPrice — on a line entered in shipping units unitPrice is per shipping unit, so
   * that product over-charges a line whose shipping unit holds more than one each. A line shipped 0
   * reads 0 here even though
   * lineTotal keeps billing it on its acknowledged quantity, and a line not shipped yet also
   * reads 0. Equals lineTotal on a line billed at its shipped quantity whose shipped eaches fill
   * whole shipping units (or that was entered in eaches); on a line that ships a partial pack,
   * lineTotal still prices the rounded-up units times the pack while this prices the shipped
   * eaches the order bills.
   */
  shippedLineTotal: Scalars['Decimal']['output'];
  /**
   * The line's SHIPPED quantity, GrowPoint's SHIP column: what left the building. Raw EACHES, on
   * the same basis as orderedQuantity. 0 when the line carries
   * none, the normal state for every order that has not shipped yet.
   */
  shippedQuantity: Scalars['Int']['output'];
  /** The shipped quantity in units, as stored. Null when the line has no unit or none is stored. */
  shippedUnits?: Maybe<Scalars['Int']['output']>;
  /** The code of that Shipping UOM. Null when the line has no unit or the Shipping UOM has no code. */
  shippingUomCode?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the Shipping UOM this line was placed under, the unit a document prints beside the
   * line's quantity ("4.5 inch tray"). Resolved from the line's own Shipping UOM stamp, then its frozen
   * shipping-config code, then its item's default. Null when the line's pack is one or unstated, and when
   * no Shipping UOM with a name resolves.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The line item's size code — the item read model's FIRST size (ItemSummaryDocument.Sizes),
   * following the one-size-per-item convention ds-availability established
   * (multi-size items are deferred there too). Item-sourced for the same reason as
   * genus: the order line carries no size. null when the item cannot be resolved or
   * has no size. One of the three keys consolidatedItems groups on.
   */
  size?: Maybe<Scalars['String']['output']>;
  /**
   * The SKU the document prints for the line: the customer SKU of the line's customer item when it
   * has one (OrderLineItemDocument.CustomerSku), else the item SKU saved on the line. The
   * item's own code is itemCode.
   */
  sku: Scalars['String']['output'];
  /**
   * The effective price per quantity, INCLUDING any upgrade ("Value Add") adjustment folded
   * into lineTotal: per unit on a line priced per unit (a tray at 4.50), per each on a line priced
   * per each, as priceBasisLabel names; pricePerEach is always per each. Derived as
   * lineTotal / quantity, NOT the raw catalog OverridePrice ?? Price. An upgrade contributes a dollar term
   * (OrderState.CalculateUpgradeAdjustment) the raw catalog price cannot express, so this
   * derivation is what keeps quantity x unitPrice == lineTotal true on every
   * row rather than only on upgrade-free lines. Carries full (unrounded) decimal precision, like
   * every other money field on this type — no display-rounding is applied, so the footing identity
   * holds exactly rather than drifting by a cent the way a 2dp-rounded value re-multiplied by
   * quantity could. Falls back to the raw catalog price on a zero-quantity line.
   */
  unitPrice: Scalars['Decimal']['output'];
  /**
   * unitPrice, formatted the same way as the order's totalAmountFormatted: rounded to
   * the cent, thousands-grouped and prefixed with the customer's currency symbol. Display only, so
   * unitPrice keeps its full precision and quantity x unitPrice still foots to
   * lineTotal.
   */
  unitPriceFormatted: Scalars['String']['output'];
  /**
   * The line's stored whole unit count: the rung the server stamped, which eachesQuantity also
   * carries and a per-unit unitPrice is priced from. Null when the line has no unit.
   */
  units?: Maybe<Scalars['Int']['output']>;
  /**
   * The UPC the document prints for the line, shown in the legacy line table's UPC column: the
   * customer UPC of the line's customer item when it has one (OrderLineItemDocument.CustomerUpc),
   * else the item UPC saved on the line (OrderLineItemDocument.Upc). Empty when neither has
   * one. consolidatedItems groups on this printed value.
   */
  upc: Scalars['String']['output'];
  /** The line's upgrades (value adds) by name, comma-separated in line order; blank when none. */
  valueAddsLabel: Scalars['String']['output'];
  /**
   * The line item's physical unit weight in pounds, joined from the item read model
   * (ItemSummaryDocument.WeightLbs) — the order line carries no weight of its own, so
   * this reflects the item as configured today rather than at order time, the same convention
   * native above already follows. null when the item cannot be resolved or has no
   * captured weight. Feeds the order-header shipWeightLbs rollup.
   */
  weightLbs?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * One row of the Order Item Stock by Location sheet: one item, at one inventory location and grade
 * holding stock, for the items on a set of selected orders.
 */
export type ReportOrderItemStockLocationsData = {
  __typename?: 'ReportOrderItemStockLocationsData';
  /** Gets the selected orders allocated here, ascending, joined with ", ". */
  allocatedOrderNumbers: Scalars['String']['output'];
  /** Gets what the selected orders have allocated at this location and grade. Sums down a column. */
  allocatedToTheseOrders: Scalars['Decimal']['output'];
  /** Gets the quantity available at this location and grade; negative when over-committed. */
  available: Scalars['Decimal']['output'];
  /** Gets the quantity committed to ANY order at this location and grade. */
  committed: Scalars['Decimal']['output'];
  /** Gets whether this is the first returned row of its location — gates the location header. */
  firstOfLocation: Scalars['Boolean']['output'];
  /** Gets whether this is the first returned row of its site — gates the site header. */
  firstOfSite: Scalars['Boolean']['output'];
  /** Gets the inventory grade of the stock. Zero on the no-stock row. */
  grade: Scalars['Int']['output'];
  /** Gets whether the selected orders are allocated here — the marked location. */
  isAllocatedHere: Scalars['Boolean']['output'];
  /** Gets the item's lookup code from the item catalog, or blank when it has none. */
  itemCode: Scalars['String']['output'];
  /** Gets the item identifier. */
  itemId: Scalars['String']['output'];
  /** Gets the item name as the order line recorded it. */
  itemName: Scalars['String']['output'];
  /** Gets whether this is the last returned row of its location — gates the location subtotal. */
  lastOfLocation: Scalars['Boolean']['output'];
  /** Gets whether this is the last returned row of its site — gates the site footer. */
  lastOfSite: Scalars['Boolean']['output'];
  /**
   * Gets the allocated-to-these-orders quantity summed over the location's RETURNED rows. Repeats on each of
   * them; the template prints it on the last one.
   */
  locationAllocatedTotal: Scalars['Decimal']['output'];
  /** Gets the inventory location holding the stock. Blank on the no-stock row. */
  locationId: Scalars['String']['output'];
  /**
   * Gets the location's name, or blank when the location is unknown to the sub-location read model —
   * the id is still printed. Blank on the no-stock row.
   */
  locationName: Scalars['String']['output'];
  /** Gets the quantity on hand at this location and grade. */
  onHand: Scalars['Decimal']['output'];
  /** Gets the selected orders carrying the item, ascending, joined with ", ". */
  orderNumbers: Scalars['String']['output'];
  /**
   * Gets the item's quantity to allocate across the selected orders, each line counted once. REPEATS on
   * each of the item's rows — do not total it.
   */
  orderedQuantity: Scalars['Decimal']['output'];
  /**
   * Gets the site the location belongs to. A location with no site parent is its own site. Blank on
   * the no-stock row.
   */
  siteId: Scalars['String']['output'];
  /** Gets the site's name. Blank on the no-stock row. */
  siteName: Scalars['String']['output'];
  /** Gets the SKU as the order line recorded it. */
  sku: Scalars['String']['output'];
  /**
   * Gets what the item's lines across the selected orders still lack, each line counted once. REPEATS on
   * each of the item's rows — do not total it.
   */
  unallocatedQuantity: Scalars['Decimal']['output'];
};

/** Payload wrapper for the reportOrderItemStockLocationsData query. */
export type ReportOrderItemStockLocationsDataPayload = {
  __typename?: 'ReportOrderItemStockLocationsDataPayload';
  /** The returned stock rows. */
  data: Array<ReportOrderItemStockLocationsData>;
  /** The number of rows returned after applying the row limit. */
  totalCount: Scalars['Int']['output'];
  /** The number of rows the selected orders produced before the row limit. */
  totalMatching: Scalars['Int']['output'];
};

/** Flattened order line item record for report generation. */
export type ReportOrderLineItemData = {
  __typename?: 'ReportOrderLineItemData';
  /**
   * Gets the acknowledged quantity — what was confirmed back to the customer. Zero when the line
   * carries none (never acknowledged), which is indistinguishable from an explicit acknowledgement
   * of zero; the underlying document stores both as the same absent/zero value.
   */
  acknowledgedQuantity: Scalars['Int']['output'];
  /** The acknowledged quantity in units, as stored. Null when the line has no unit or none is stored. */
  acknowledgedUnits?: Maybe<Scalars['Int']['output']>;
  /** Gets the currency code. */
  currency: Scalars['String']['output'];
  /** Gets this customer's acknowledged quantity summed the same way. */
  customerAcknowledgedTotal: Scalars['Int']['output'];
  /**
   * Gets the code of the customer this report is grouped by — the ship-to location's code under
   * the ShipTo basis, the bill-to account's ERP id under BillTo. Always the field
   * the CustomerCode sort ordered on, so the printed column cannot disagree with the row
   * order. Empty when the customer carries no code.
   */
  customerCode: Scalars['String']['output'];
  /** Gets the customer identifier from the joined order. */
  customerId: Scalars['String']['output'];
  /**
   * lineAmount summed across this row's contiguous customer run — what a Sales History
   * per-customer subtotal prints under lastOfCustomer.
   */
  customerLineAmountTotal: Scalars['Decimal']['output'];
  /**
   * Gets the customer display name denormalized onto the joined order. A report showing raw
   * customer guids is unreadable, so this is the column templates bind; customerId
   * stays for joins. Empty when the order never carried a denormalized name.
   */
  customerName: Scalars['String']['output'];
  /**
   * Gets this customer's ordered quantity summed across its contiguous RUN of returned rows —
   * computed after the page limit, so a rendered subtotal always equals the lines printed above
   * it. Run-scoped rather than customer-scoped so the number is well-defined under any sort; it
   * reads as a per-customer subtotal when a customer's rows sit together, which the customer
   * sorts guarantee and the seeded template pins.
   */
  customerOrderedTotal: Scalars['Int']['output'];
  /** Gets this customer's shipped quantity summed the same way. */
  customerShippedTotal: Scalars['Int']['output'];
  /**
   * eaches over eachesPerUnit, cut toward zero at two decimals: 25 eaches on a pack of 18 is
   * 1.38. Null when the line has no unit.
   */
  derivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The eaches this line bills on: the each count lineAmount extends across. */
  eaches: Scalars['Int']['output'];
  /**
   * How many eaches one unit of this line holds, from the line's own snapshot taken when it was placed,
   * never the Shipping UOM's current count. Null when the pack is one or unstated.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * Gets a value indicating whether this is the FIRST row of its item in the returned sequence.
   * A template prints a per-item header (SKU, name, on hand / committed / available) on this row
   * with {{#if firstOfItem}} — the opening twin of lastOfItem. Reads as a header
   * only when the item's rows are contiguous, which ItemThenOrder guarantees.
   */
  firstOfItem: Scalars['Boolean']['output'];
  /** Gets this item's acknowledged quantity summed the same way. */
  itemAcknowledgedTotal: Scalars['Int']['output'];
  /** Gets the item's available quantity summed the same way, or null. */
  itemAvailableQuantity?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets the item's committed (allocated to orders) quantity summed the same way, or null.
   * The sellable / non-sellable split GrowPoint prints beside it does not exist in WorkSuite and
   * is deliberately not derived.
   */
  itemCommittedQuantity?: Maybe<Scalars['Decimal']['output']>;
  /**
   * lineAmount summed across every returned row for this item. Server-side because the
   * external PDF service's Handlebars registers no sum helper.
   */
  itemLineAmountTotal: Scalars['Decimal']['output'];
  /**
   * Gets the item's on-hand quantity summed over every inventory row carrying it, or null when
   * the includeItemInventory parameter was not set or the item has no inventory rows.
   * Absent rather than zero so an unrequested column never prints as "0 on hand".
   */
  itemOnHandQuantity?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets this item's ordered quantity summed across every RETURNED row — computed after the page
   * limit, so a rendered subtotal always equals the sum of the lines printed above it.
   */
  itemOrderedTotal: Scalars['Int']['output'];
  /** Gets this item's shipped quantity summed the same way. */
  itemShippedTotal: Scalars['Int']['output'];
  /**
   * Gets a value indicating whether this is the LAST row of its customer run. A template prints
   * the per-customer subtotal on this row with {{#if lastOfCustomer}} — the customer twin
   * of lastOfItem, and needed for the same reason: the external PDF service's
   * Handlebars has no sum helper, so every total must arrive pre-summed.
   */
  lastOfCustomer: Scalars['Boolean']['output'];
  /**
   * Gets a value indicating whether this is the item's LAST row in the returned sequence. A
   * template prints its per-item subtotal on this row with {{#if lastOfItem}} — no
   * summing helper needed, which matters because Handlebars is compiled by an external service
   * with no sum. Well-defined under any sort; it reads as a subtotal divider when the
   * item's rows are contiguous, which the ItemThenOrder sort guarantees.
   */
  lastOfItem: Scalars['Boolean']['output'];
  /**
   * True on the final row of a location run — the flag a template gates its location subtotal row
   * on, and the page break that gives the detail edition one location per page.
   */
  lastOfLocation: Scalars['Boolean']['output'];
  /**
   * True on the final row of an order's contiguous run — gates the Sales History by Order No.
   * subtotal row and its page-per-order break, the way lastOfCustomer gates the by-Customer
   * edition's. Meaningful only under a sort that keeps an order's lines together
   * (OrderNo, which the templates pin, or the default OrderThenLine).
   */
  lastOfOrder: Scalars['Boolean']['output'];
  /**
   * Gets a value indicating whether this is the FINAL returned row — the LEGACY gate for the single
   * grand-total row. A report built today reads the payload-level totals map instead.
   * @deprecated The grand-total row no longer rides on a row: read the payload-level `totals` map (totals: [ReportColumnTotal!]!) outside the row loop. Retained until saved reports migrate their bindings.
   */
  lastRow: Scalars['Boolean']['output'];
  /** The line's full money value, pack-scaled and upgrade-inclusive. */
  lineAmount: Scalars['Decimal']['output'];
  /**
   * Gets the line's dated change history rendered as text — one entry per recorded quantity
   * change, line note, or terminal order status, as "yyyy-MM-dd – text", separated by "; ".
   * Read from the OrderLineChangeLogs projection when the includeLineNotes
   * parameter is set; empty otherwise. Quantities print what the events recorded — a prior value
   * is shown only when it was itself recorded, and no wait-list quantity is ever derived.
   */
  lineNotes: Scalars['String']['output'];
  /** Gets the line number. */
  lineNumber: Scalars['Int']['output'];
  /** Acknowledged quantity summed across this row's contiguous location run. */
  locationAcknowledgedTotal: Scalars['Int']['output'];
  /** Line amount summed across this row's contiguous location run. */
  locationLineAmountTotal: Scalars['Decimal']['output'];
  /**
   * Ordered quantity summed across this row's contiguous ship-from LOCATION run — what a location
   * subtotal row prints. Pre-computed here because the external PDF service's Handlebars registers
   * no sum helper.
   */
  locationOrderedTotal: Scalars['Int']['output'];
  /** Shipped quantity summed across this row's contiguous location run. */
  locationShippedTotal: Scalars['Int']['output'];
  /** Gets the item display name. */
  name: Scalars['String']['output'];
  /**
   * Gets a value indicating whether the line's item is a native plant species, joined from the
   * item read model. This is the item's CURRENT flag — the order line carries no Native of its
   * own, so a historical order reflects the item as it is configured today.
   */
  native: Scalars['Boolean']['output'];
  /** Acknowledged quantity summed across this row's contiguous order run. */
  orderAcknowledgedTotal: Scalars['Int']['output'];
  /**
   * The date the order was PLACED — OrdersDocument.InitializedDate, and the leftmost column
   * of GrowPoint's Open Orders by Item sheet. The SAME field dateFrom / dateTo bound,
   * so a row's date always agrees with the filter that selected it — the order-date twin of
   * shipDate's relationship to shipDateFrom / shipDateTo.
   */
  orderDate: Scalars['DateTime']['output'];
  /**
   * orderDate pre-rendered as Jul 3, 2026 — the string the Open Orders by Item
   * template's leftmost column binds, so the GrowPoint parity sheet prints a date a grower reads
   * rather than a machine timestamp.
   */
  orderDateFormatted: Scalars['String']['output'];
  /** Gets the order identifier from the line item. */
  orderId: Scalars['String']['output'];
  /**
   * lineAmount summed across this row's contiguous order run. Server-side for the reason
   * itemLineAmountTotal is: the external PDF service's Handlebars registers no
   * sum helper, so a template that added the rows up would render blank.
   */
  orderLineAmountTotal: Scalars['Decimal']['output'];
  /** Gets the order number from the joined order. */
  orderNumber: Scalars['String']['output'];
  /**
   * Ordered quantity summed across this row's contiguous ORDER run — the order twin of
   * customerOrderedTotal, and what a Sales History by Order No. subtotal prints.
   */
  orderOrderedTotal: Scalars['Int']['output'];
  /** Shipped quantity summed across this row's contiguous order run. */
  orderShippedTotal: Scalars['Int']['output'];
  /** Gets the ordered quantity. */
  orderedQuantity: Scalars['Int']['output'];
  /** The ordered quantity in units, as stored. Null when the line has no unit or none is stored. */
  orderedUnits?: Maybe<Scalars['Int']['output']>;
  /** Gets the override price, when one exists. */
  overridePrice?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets the customer's purchase-order number from the joined order. Empty for orders placed
   * without one — a common and legitimate state, not an error.
   */
  poNumber: Scalars['String']['output'];
  /** Gets the base price. */
  price: Scalars['Decimal']['output'];
  /** What price, overridePrice and sellPrice are per: "ea", since a line's price is per each. */
  priceBasisLabel: Scalars['String']['output'];
  /** Gets the effective quantity, falling back to ordered quantity. */
  quantity: Scalars['Int']['output'];
  /**
   * The line's quantity as a document prints it, "2 (4.5 inch tray) · 30 ea", with thousands separators.
   * The bare each count when the line has no unit or its Shipping UOM has no name.
   */
  quantityText: Scalars['String']['output'];
  /**
   * Acknowledged quantity summed across every returned row. Identical on every row.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportAcknowledgedTotal: Scalars['Int']['output'];
  /**
   * lineAmount summed across every returned row — the Extended column of the Report Totals
   * row. Identical on every row.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportLineAmountTotal: Scalars['Decimal']['output'];
  /**
   * Ordered quantity summed across EVERY returned row — the report-wide grand total, identical on
   * every row. A template prints it once, under lastRow.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportOrderedTotal: Scalars['Int']['output'];
  /**
   * Shipped quantity summed across every returned row. Identical on every row.
   * @deprecated Use the payload-level `totals` map (totals: [ReportColumnTotal!]!), keyed by the column it sums. Retained until saved reports migrate their bindings.
   */
  reportShippedTotal: Scalars['Int']['output'];
  /**
   * Gets the order's salesperson — an EMAIL, which is what the order stores. Empty when the order
   * carries no salesperson, which is a legitimate state (a house account, or an order taken
   * without one), not an error.
   */
  salesPerson: Scalars['String']['output'];
  /**
   * The line's EFFECTIVE unit price — overridePrice when the line carries one, else
   * price. The column a "Sell Price" report prints.
   */
  sellPrice: Scalars['Decimal']['output'];
  /**
   * The order's expected delivery date — the ship date a Sales History report prints and the SAME
   * field shipDateFrom / shipDateTo bound, so a row's date always agrees with the
   * filter that selected it.
   */
  shipDate: Scalars['DateTime']['output'];
  /**
   * The order's SHIP-FROM site name — the location the goods leave from — or Unassigned for
   * an order that never carried a structured ship-from site. What the Sales History by Location
   * templates group, sort and subtotal by.
   */
  shipFromLocationName: Scalars['String']['output'];
  /**
   * Gets the ship-to location's name, from the snapshot captured on the order. The column a
   * ship-to-basis report prints where a bill-to-basis one prints customerName —
   * which continues to name the ACCOUNT under either basis, so a saved report's columns never
   * change meaning.
   */
  shipToName: Scalars['String']['output'];
  /**
   * Gets the ship-to address's state or province. Always the ship-to's, under either customer
   * basis: a bill-to account has no single state, and "where is this going" is the question the
   * GrowPoint state filter and state sort both ask.
   */
  shipToState: Scalars['String']['output'];
  /**
   * Gets the shipped quantity. Zero when the line carries none, which is the normal state for
   * every order that has not shipped yet.
   */
  shippedQuantity: Scalars['Int']['output'];
  /** The shipped quantity in units, as stored. Null when the line has no unit or none is stored. */
  shippedUnits?: Maybe<Scalars['Int']['output']>;
  /** The code of that Shipping UOM. Null when the line has no unit or the Shipping UOM has no code. */
  shippingUomCode?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the Shipping UOM this line was placed under, the unit a document prints beside the
   * line's quantity ("4.5 inch tray"). Resolved from the line's own Shipping UOM stamp, then its frozen
   * shipping-config code, then its item's default. Null when the line's pack is one or unstated, and when
   * no Shipping UOM with a name resolves.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /** Gets the item SKU. */
  sku: Scalars['String']['output'];
  /** Gets the order status from the joined order. */
  status: Scalars['String']['output'];
  /**
   * The first moment the order entered an active state (Submitted / Acknowledged / Picked /
   * Shipped) — OrdersDocument.SubmittedAt reused exactly as-is per product ruling (Kennedy
   * 2026-09-02), rather than a new domain field. Null for an order that has never been submitted,
   * and cleared back to null when the order re-opens — accepted rather than backfilled, so a
   * re-opened order's waitlist position resets along with it.
   */
  submittedDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * submittedDate pre-rendered as Jul 3, 2026 — the companion the Open Orders
   * by Item template's Submitted column binds, formatted the same way
   * orderDateFormatted is. Empty, never a placeholder string, for an order that has
   * never been submitted.
   */
  submittedDateFormatted: Scalars['String']['output'];
  /** The line's stored whole unit count, the rung the server stamped. Null when the line has no unit. */
  units?: Maybe<Scalars['Int']['output']>;
};

/** Payload wrapper for the reportOrderLineItemsData query. */
export type ReportOrderLineItemsDataPayload = {
  __typename?: 'ReportOrderLineItemsDataPayload';
  /** Gets the returned order line item rows. */
  data: Array<ReportOrderLineItemData>;
  /** Gets the number of rows returned after applying the page limit. */
  totalCount: Scalars['Int']['output'];
  /** Gets the total number of rows matching the filters before applying the page limit. */
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the report's grand-total row, one entry per summable column. The payload-level
   * replacement for the deprecated per-row report*Total fields.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * Authorized-signature block for report output. Mirrors the base64 image + signer name the legacy
 * QuestPDF invoice / credit / acknowledgement PDFs render above the footer.
 */
export type ReportOrderSignatureData = {
  __typename?: 'ReportOrderSignatureData';
  /** Signer first name printed beneath the signature. */
  firstName: Scalars['String']['output'];
  /** Base64-encoded signature image bytes (no data-URI prefix). */
  imageBase64: Scalars['String']['output'];
  /** Signer last name printed beneath the signature. */
  lastName: Scalars['String']['output'];
  /** MIME type of the signature image (e.g. image/png), for building a data URI. */
  mime: Scalars['String']['output'];
};

/**
 * One Shipping UOM's share of an order's quantity: the units of that label and the eaches they hold. An
 * order foots one of these per unit label beside its eaches grand total, totalEaches.
 */
export type ReportOrderUnitTotalData = {
  __typename?: 'ReportOrderUnitTotalData';
  /** This unit's eaches over its pack, cut toward zero at two decimals. */
  derivedUnits: Scalars['Decimal']['output'];
  /** The eaches this unit's lines bill on, summed. */
  eaches: Scalars['Int']['output'];
  /** How many eaches one unit holds, from the lines' own snapshots. */
  eachesPerUnit: Scalars['Int']['output'];
  /** This unit's share as a document prints it, "12 (4.5 inch tray) · 180 ea". */
  quantityText: Scalars['String']['output'];
  /** The Shipping UOM's code. Null when it has none. */
  shippingUomCode?: Maybe<Scalars['String']['output']>;
  /** The Shipping UOM's name, "4.5 inch tray". */
  shippingUomLabel: Scalars['String']['output'];
  /**
   * The stored whole unit counts of this unit's lines, summed. Null when any of those lines has none
   * stored, in which case derivedUnits is the count to print.
   */
  units?: Maybe<Scalars['Int']['output']>;
};

/**
 * Payload wrapper for the reportOrdersData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters — when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportOrdersDataPayload = {
  __typename?: 'ReportOrdersDataPayload';
  data: Array<ReportOrderData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

export type ReportPayload = {
  __typename?: 'ReportPayload';
  /** The report's content version after the call, set only by updateReport: the version just written, the existing one when the save was unchanged, or the newer one when the save was refused with REPORT_VERSION_CONFLICT. */
  currentVersion?: Maybe<Scalars['Long']['output']>;
  /** Why the mutation was refused. */
  errors?: Maybe<Array<ValidationError>>;
  /** The report after the mutation. */
  report?: Maybe<ReportData>;
};

/** Payload returned from the generateReportPdf query. */
export type ReportPdfPayload = {
  __typename?: 'ReportPdfPayload';
  /** A stable machine-readable failure code (REPORT_TOO_LARGE), or null when none applies. */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** An error description if generation failed. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The base64-encoded PDF content, or null on failure. */
  pdfBase64?: Maybe<Scalars['String']['output']>;
  /** Whether PDF generation succeeded. */
  success: Scalars['Boolean']['output'];
};

/**
 * The tenant's company block for the sheet header — the effective company profile (remit-to) the
 * orders source prints as company.*, plus the portal logo URL from the tenant's portal
 * branding. Every field is nullable so a tenant with no profile or no branding renders text only.
 */
export type ReportPortalAvailabilityCompanyData = {
  __typename?: 'ReportPortalAvailabilityCompanyData';
  /** City. */
  city?: Maybe<Scalars['String']['output']>;
  /** Contact email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The portal logo URL from TenantPortalBranding; null when no branding is set. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The company name; falls back to the tenant name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Contact phone. */
  phone?: Maybe<Scalars['String']['output']>;
  /** State or province. */
  state?: Maybe<Scalars['String']['output']>;
  /** Street address line. */
  street?: Maybe<Scalars['String']['output']>;
  /** Website. */
  website?: Maybe<Scalars['String']['output']>;
  /** Postal code. */
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * One portal-visible item on the availability sheet. Its Available number is the buyer's grid's own:
 * the inventory the tenant's portal Availability rule admits, summed for the item across locations,
 * whichever availability source the tenant uses. Its price is quoted at the buyer's price group.
 */
export type ReportPortalAvailabilityData = {
  __typename?: 'ReportPortalAvailabilityData';
  /**
   * What the Available column prints: the quantity when there is one, or Ready wk NN when
   * the row survived only because its ready date falls inside an upcoming window.
   */
  availableDisplay: Scalars['String']['output'];
  /**
   * The portal's Available number: the item's on-hand minus allocated inventory, counting only the
   * rows the tenant's portal Availability rule admits — its grade floor, with sellable hard goods
   * carved back in where the tenant includes them, its pinned location where one is set — summed
   * across the locations the rule admits. This is what the buyer's catalog grid shows, on both
   * availability sources. Zero when no inventory row qualifies.
   */
  availableQuantity: Scalars['Int']['output'];
  /**
   * AvailableQuantity over EachesPerUnit, cut toward zero at two decimals. Null when the item
   * has no unit.
   */
  availableUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The item's first category code — the section the sheet is grouped by. */
  category: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 1. Empty when the column is not bound or the item has no value. */
  characteristic1: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 1. Empty when the column is not bound. */
  characteristic1Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 2. Empty when the column is not bound or the item has no value. */
  characteristic2: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 2. Empty when the column is not bound. */
  characteristic2Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 3. Empty when the column is not bound or the item has no value. */
  characteristic3: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 3. Empty when the column is not bound. */
  characteristic3Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 4. Empty when the column is not bound or the item has no value. */
  characteristic4: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 4. Empty when the column is not bound. */
  characteristic4Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 5. Empty when the column is not bound or the item has no value. */
  characteristic5: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 5. Empty when the column is not bound. */
  characteristic5Name: Scalars['String']['output'];
  /** How many eaches one unit of ShippingUomLabel holds. Null when the item has no unit. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * Per-grade available quantities from the inventory ledger, e.g. Grade 1: 120 · Grade 2: 40,
   * using the tenant's own grade labels where set. Empty when the tenant does not show grades on
   * the portal, or when no grade has stock.
   */
  gradeSummary: Scalars['String']['output'];
  /** The item id, joining to the catalog row of the same id. */
  itemId: Scalars['String']['output'];
  /** The item's lookup code. */
  itemLookupCode: Scalars['String']['output'];
  /** The item name as the catalog shows it. */
  itemName: Scalars['String']['output'];
  /**
   * Gets a value indicating whether any returned row has a named unit. The same on every row, so a
   * template can show its units columns for the whole page, header and total rows included, and leave them
   * out entirely when every item is counted in eaches.
   */
  pageHasUnits: Scalars['Boolean']['output'];
  /** The unit price at the resolved price group; zero when no price resolves. */
  price: Scalars['Decimal']['output'];
  /**
   * The unit price formatted as money, for a template with no money helper — or Call for price
   * when Price is zero or negative, mirroring what the portal grid prints for the same
   * item.
   */
  priceFormatted: Scalars['String']['output'];
  /** The item's product group. */
  productGroup: Scalars['String']['output'];
  /** The earliest ready date on the item's ledger rows under the Availability rule, if any. */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The ISO week of ReadyDate, or null when there is none. */
  readyWeek?: Maybe<Scalars['Int']['output']>;
  /**
   * The name of the Shipping UOM the item ships as today, for example 4.5 inch tray. Null when the
   * item has no unit (a pack of one or an unstated pack) or its Shipping UOM has no name. When it is set,
   * AvailableDisplay prints the labelled pair, 2 (4.5 inch tray) · 30 ea, and each grade in
   * GradeSummary does too.
   */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /** The item's first size code. */
  size: Scalars['String']['output'];
  /** The item's SKU. */
  sku: Scalars['String']['output'];
};

/**
 * The reportPortalAvailabilityData preview payload: the page of rows the report builder
 * renders, the pre-cap count, and the report-level values the printed sheet binds at its root — the
 * tenant's company block, the window label and the generation stamp. The export arm emits the same
 * three at the JSON root through ReportPage.RootFields.
 */
export type ReportPortalAvailabilityDataPayload = {
  __typename?: 'ReportPortalAvailabilityDataPayload';
  /** The tenant's company block and portal logo, for the sheet's header. */
  company: ReportPortalAvailabilityCompanyData;
  /** The rows on this page, in category-then-item-name order. */
  data: Array<ReportPortalAvailabilityData>;
  /** When the sheet was generated (UTC). */
  generatedAt: Scalars['DateTime']['output'];
  /** The number of rows returned, after the row cap. */
  totalCount: Scalars['Int']['output'];
  /** The number of rows the window rule kept BEFORE the row cap. */
  totalMatching: Scalars['Int']['output'];
  /** The human label of the window this sheet was run for, e.g. "Available within 4 weeks". */
  windowLabel: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportPriceListData query. TotalCount is the number of records returned
 * (capped at ReportDataSourceConstants.MaxReportRows).
 * TotalMatching is the total number of records matching the filters — when TotalMatching > TotalCount,
 * the client should prompt the user to narrow their filters.
 */
export type ReportPriceListDataPayload = {
  __typename?: 'ReportPriceListDataPayload';
  data: Array<ReportPriceListItemData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable — today only
   * royaltyAmount. Empty when the page matched nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * Flattened catalog-price record for report generation — GrowPoint's Inventory "Price List". One row
 * per ITEM, carrying its classification, its discountable flag, its royalty, and what it costs at up
 * to five price levels as of the report's price date.
 */
export type ReportPriceListItemData = {
  __typename?: 'ReportPriceListItemData';
  /** The item's category codes, empty when it carries none. */
  categories: Array<Scalars['String']['output']>;
  /** The item's value for the characteristic bound to Characteristic 1. Empty when the column is not bound or the item has no value. */
  characteristic1: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 1. Empty when the column is not bound. */
  characteristic1Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 2. Empty when the column is not bound or the item has no value. */
  characteristic2: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 2. Empty when the column is not bound. */
  characteristic2Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 3. Empty when the column is not bound or the item has no value. */
  characteristic3: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 3. Empty when the column is not bound. */
  characteristic3Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 4. Empty when the column is not bound or the item has no value. */
  characteristic4: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 4. Empty when the column is not bound. */
  characteristic4Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 5. Empty when the column is not bound or the item has no value. */
  characteristic5: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 5. Empty when the column is not bound. */
  characteristic5Name: Scalars['String']['output'];
  /**
   * Whether the item may be discounted. GrowPoint's "only not-discountable prices" filter selects on
   * the false case; the column is printed either way so the sheet says which rows it kept.
   */
  discountable: Scalars['Boolean']['output'];
  /**
   * True on the first row of each product-group section — the marker a template gates a section
   * heading on, so the sheet reads as GrowPoint's product grouping rather than a flat list.
   */
  firstOfProductGroup: Scalars['Boolean']['output'];
  /**
   * The item CODE — ItemSummaryDocument.Sku. GrowPoint's "Item Code", what the
   * itemCode filter matches, and the report's secondary sort key.
   */
  itemCode: Scalars['String']['output'];
  /** The item's description, empty when none was recorded. */
  itemDescription: Scalars['String']['output'];
  /** The item's item group — GrowPoint's Item Code axis. ItemSummaryDocument.Group. */
  itemGroup: Scalars['String']['output'];
  /** The item's entity id — stable across renames, unlike the item code. */
  itemId: Scalars['String']['output'];
  /** The item's common name. */
  itemName: Scalars['String']['output'];
  /**
   * True on the last row of each product-group section — the marker a template gates a group
   * SUBTOTAL line on, the closing companion to firstOfProductGroup.
   */
  lastOfProductGroup: Scalars['Boolean']['output'];
  /**
   * The date every price column on this row is quoted at — the report's price date, or today when the
   * caller supplied none. Carried ON THE ROW so an exported sheet states its own as-of date rather
   * than depending on a template header to repeat a parameter.
   */
  priceDate: Scalars['DateTime']['output'];
  /**
   * The heading printed over column 1 — GrowPoint's per-column "column heading" when the caller named
   * one, otherwise the resolved level’s name (priceLevel1Name).
   */
  priceLevel1Heading: Scalars['String']['output'];
  /**
   * The name of the price group filling column 1, empty when the caller chose none and the tenant has
   * no default. Printed so a sheet carrying several columns says which level each one is.
   */
  priceLevel1Name: Scalars['String']['output'];
  /**
   * What column 1's price level charges for this item on the price date. None when that level
   * holds no price for it — which is the row "include items not on price level" drops.
   */
  priceLevel1Price?: Maybe<Scalars['Decimal']['output']>;
  /** The heading printed over column 2 — the caller's heading, else the resolved level's name (priceLevel2Name). See the remarks on priceLevel1Heading. */
  priceLevel2Heading: Scalars['String']['output'];
  /** The name of the price group filling column 2, empty when the caller chose none. */
  priceLevel2Name: Scalars['String']['output'];
  /** Column 2's price for this item on the price date. None when unchosen or unpriced. */
  priceLevel2Price?: Maybe<Scalars['Decimal']['output']>;
  /** The heading printed over column 3 — the caller's heading, else the resolved level's name (priceLevel3Name). See the remarks on priceLevel1Heading. */
  priceLevel3Heading: Scalars['String']['output'];
  /** The name of the price group filling column 3, empty when the caller chose none. */
  priceLevel3Name: Scalars['String']['output'];
  /** Column 3's price for this item on the price date. None when unchosen or unpriced. */
  priceLevel3Price?: Maybe<Scalars['Decimal']['output']>;
  /** The heading printed over column 4 — the caller's heading, else the resolved level's name (priceLevel4Name). See the remarks on priceLevel1Heading. */
  priceLevel4Heading: Scalars['String']['output'];
  /** The name of the price group filling column 4, empty when the caller chose none. */
  priceLevel4Name: Scalars['String']['output'];
  /** Column 4's price for this item on the price date. None when unchosen or unpriced. */
  priceLevel4Price?: Maybe<Scalars['Decimal']['output']>;
  /** The heading printed over column 5 — the caller's heading, else the resolved level's name (priceLevel5Name). See the remarks on priceLevel1Heading. */
  priceLevel5Heading: Scalars['String']['output'];
  /** The name of the price group filling column 5, empty when the caller chose none. */
  priceLevel5Name: Scalars['String']['output'];
  /** Column 5's price for this item on the price date. None when unchosen or unpriced. */
  priceLevel5Price?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The text GrowPoint's "Description to print" selected for this row — the item's common name (the
   * default), its Latin name, its description, or one of the two description-and-code composites.
   */
  printedDescription: Scalars['String']['output'];
  /**
   * The item's product group — GrowPoint's Product Code axis, and the report's PRIMARY sort key
   * because the sheet's grouping is fixed by product.
   */
  productGroup: Scalars['String']['output'];
  /**
   * The product group's total royalty, carried on the row that CLOSES the group and
   * None on every other row — so a template's subtotal line fires once per group.
   */
  productGroupRoyaltyAmountTotal?: Maybe<Scalars['Decimal']['output']>;
  /**
   * GrowPoint's "print item royalty amount": the royalty in DOLLARS PER UNIT. A Flat royalty is
   * its own rate; a Percentage royalty is that fraction of the column 1 price
   * (priceLevel1Price).
   */
  royaltyAmount?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The item's configured royalty rate AS CONFIGURED — an absolute $/unit for a Flat royalty,
   * a FRACTION (0.05 = 5%) for a Percentage one. None when the item carries no royalty.
   */
  royaltyRate?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The item's royalty rate type as its enum name — Flat or Percentage — or empty when
   * the item carries no royalty configuration.
   */
  royaltyRateType: Scalars['String']['output'];
  /** The item's status as its enum name — never Deleted, which this source excludes. */
  status: Scalars['String']['output'];
};

/** Flattened product record for report generation. One row per ItemSummary document. */
export type ReportProductData = {
  __typename?: 'ReportProductData';
  availableQuantity: Scalars['Int']['output'];
  /**
   * Gets the value a barcode block should encode for this item — the SKU or the UPC, chosen by the
   * barcodeSource parameter (default SKU). Empty when the chosen field is blank on the item: a barcode
   * list promising UPCs never silently falls back to printing the SKU.
   */
  barcode: Scalars['String']['output'];
  categories: Array<Scalars['String']['output']>;
  /** The item's value for the characteristic bound to Characteristic 1. Empty when the column is not bound or the item has no value. */
  characteristic1: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 1. Empty when the column is not bound. */
  characteristic1Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 2. Empty when the column is not bound or the item has no value. */
  characteristic2: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 2. Empty when the column is not bound. */
  characteristic2Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 3. Empty when the column is not bound or the item has no value. */
  characteristic3: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 3. Empty when the column is not bound. */
  characteristic3Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 4. Empty when the column is not bound or the item has no value. */
  characteristic4: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 4. Empty when the column is not bound. */
  characteristic4Name: Scalars['String']['output'];
  /** The item's value for the characteristic bound to Characteristic 5. Empty when the column is not bound or the item has no value. */
  characteristic5: Scalars['String']['output'];
  /** The name of the characteristic bound to Characteristic 5. Empty when the column is not bound. */
  characteristic5Name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /**
   * Gets a value indicating whether this row OPENS a run of rows for the same genus — true on the
   * first item of each genus, so a template can print a genus header above them.
   */
  firstOfGenus: Scalars['Boolean']['output'];
  genus: Scalars['String']['output'];
  /**
   * Gets the genus band's total available quantity, carried on EVERY row of the run so a template
   * may print the figure in the section header as readily as its footer.
   */
  genusAvailableQuantityTotal: Scalars['Decimal']['output'];
  group: Scalars['String']['output'];
  isOrganic: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  /**
   * Gets a value indicating whether this row CLOSES a run of rows for the same genus — true on
   * the last item of each genus, so a template can print the genus subtotal beneath them.
   */
  lastOfGenus: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Gets a value indicating whether the item is a native plant species. */
  native: Scalars['Boolean']['output'];
  /**
   * Gets the item's price in the price group named by the priceGroupId parameter (the tenant default
   * when blank) at today's date and quantity 1. Zero when the group holds no level for the item.
   */
  price: Scalars['Decimal']['output'];
  productGroup: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  status: Scalars['String']['output'];
  upc: Scalars['String']['output'];
  /**
   * Gets the UPC as the upcFormat parameter renders it (default Raw): the stored value, with a UPC-A
   * check digit appended to an eleven-digit code, or additionally grouped for print. Empty when the
   * item has no UPC — a UPC sheet never invents a value. The raw upc column is untouched.
   */
  upcDisplay: Scalars['String']['output'];
};

/**
 * Per-recipe / per-lot cost rollup row. Material + labor + overhead = total; cost-per-unit is
 * total divided by actual quantity. One row per ProductionCosts document.
 */
export type ReportProductionCostData = {
  __typename?: 'ReportProductionCostData';
  /** The actual containers in eaches; null, never zero, when the category does not resolve. */
  actualEaches?: Maybe<Scalars['Int']['output']>;
  actualQuantity: Scalars['Int']['output'];
  /**
   * Total cost divided by the actual eaches, rounded to four places. Null when the actual eaches are
   * unknown or zero. costPerUnit is the cost per container.
   */
  costPerEach?: Maybe<Scalars['Decimal']['output']>;
  costPerUnit: Scalars['Decimal']['output'];
  date: Scalars['DateTime']['output'];
  /**
   * How many eaches one container of the lot's production category holds. Null when the lot or its
   * category does not resolve.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /** Whether this row opens a recipe band. Only ever set under the RecipeThenDate sort. */
  firstOfRecipe: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  laborCost: Scalars['Decimal']['output'];
  /** Whether this row closes a recipe band. Only ever set under the RecipeThenDate sort. */
  lastOfRecipe: Scalars['Boolean']['output'];
  locationId: Scalars['String']['output'];
  materialCost: Scalars['Decimal']['output'];
  overheadCost: Scalars['Decimal']['output'];
  /**
   * The same answer on every row: the tenant prints units and eaches and the page has a lot with a
   * container. A seeded template prints its container and eaches columns only when it is true.
   */
  pageHasUnits: Scalars['Boolean']['output'];
  /** The planned containers in eaches; null, never zero, when the category does not resolve. */
  plannedEaches?: Maybe<Scalars['Int']['output']>;
  plannedQuantity: Scalars['Int']['output'];
  productionLotId: Scalars['String']['output'];
  /**
   * The actual quantity as one string, 500 (4.5 inch tray) · 7,500 ea; the container count
   * alone when the category does not resolve.
   */
  quantityText: Scalars['String']['output'];
  /**
   * The band's summed actual eaches, repeated on each of its rows. Null outside a band, and for a band
   * with a lot whose category does not resolve.
   */
  recipeActualEachesTotal?: Maybe<Scalars['Int']['output']>;
  /** The band's summed actual quantity, repeated on each of its rows; zero outside a band. */
  recipeActualQuantityTotal?: Maybe<Scalars['Int']['output']>;
  recipeId: Scalars['String']['output'];
  recipeName: Scalars['String']['output'];
  /** The band's summed total cost, repeated on each of its rows; zero outside a band. */
  recipeTotalCostTotal: Scalars['Decimal']['output'];
  totalCost: Scalars['Decimal']['output'];
  /** The container's name: the category's Label, or its Code when it has none. */
  uomLabel?: Maybe<Scalars['String']['output']>;
};

/**
 * Payload wrapper for the reportProductionCostsData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters; when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportProductionCostsDataPayload = {
  __typename?: 'ReportProductionCostsDataPayload';
  data: Array<ReportProductionCostData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable. Empty when the
   * page matched nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/** Flattened production job record for report generation. One row per Job document. */
export type ReportProductionJobData = {
  __typename?: 'ReportProductionJobData';
  containerQuantity: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  item: ReportProductionJobItemData;
  jobId: Scalars['String']['output'];
  jobType: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  unitOfMeasure: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workOrderCount: Scalars['Int']['output'];
};

/** Item data on a production job for report output. */
export type ReportProductionJobItemData = {
  __typename?: 'ReportProductionJobItemData';
  genusCode: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * Gets a value indicating whether the item is a native plant species, joined from the item
   * read model — the job's embedded item snapshot carries no Native of its own.
   */
  native: Scalars['Boolean']['output'];
  upc: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportProductionJobsData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters — when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportProductionJobsDataPayload = {
  __typename?: 'ReportProductionJobsDataPayload';
  data: Array<ReportProductionJobData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable. Empty when the
   * page matched nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/** Flattened production lot record for report generation. One row per ProductionLots document. */
export type ReportProductionLotData = {
  __typename?: 'ReportProductionLotData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * The customer band's summed eaches, repeated on each of its rows; blank outside a band and on a band
   * with a lot whose category does not resolve.
   */
  customerEachesTotal?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  /** The ordering customer's name, joined from the customer read model. */
  customerName: Scalars['String']['output'];
  /**
   * The customer band's summed quantity, repeated on each of its rows; zero outside a band. Blank, for a
   * tenant printing units and eaches, on a band whose lots do not share one container size.
   */
  customerQuantityTotal?: Maybe<Scalars['Int']['output']>;
  /**
   * The lot's quantity in eaches: 500 trays of 15 is 7,500. Blank, never zero, when the category does not
   * resolve.
   */
  eaches?: Maybe<Scalars['Int']['output']>;
  /**
   * How many eaches one container of the lot's production category holds: a 4.5 inch tray of 15 is 15.
   * Blank when the category does not resolve.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /** Whether this row opens a customer band. Only ever set under the CustomerThenLot sort. */
  firstOfCustomer: Scalars['Boolean']['output'];
  /** Whether this row opens a production category band. Only ever set under the CategoryThenLot sort. */
  firstOfProductionCategory: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isAd: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  /** Whether this row closes a customer band. Only ever set under the CustomerThenLot sort. */
  lastOfCustomer: Scalars['Boolean']['output'];
  /** Whether this row closes a production category band. Only ever set under the CategoryThenLot sort. */
  lastOfProductionCategory: Scalars['Boolean']['output'];
  lotNumber: Scalars['Int']['output'];
  /**
   * True on every row when the tenant prints units and eaches and at least one lot has a container, so a
   * template prints its container and eaches columns for the whole page or not at all.
   */
  pageHasUnits: Scalars['Boolean']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The production category's code, joined from the production category read model. The closest
   * backed analogue of GrowPoint's Item Code on a production lot — it is a production category,
   * not an item, and is labelled as such everywhere it surfaces.
   */
  productionCategoryCode: Scalars['String']['output'];
  /**
   * The production category band's summed eaches, repeated on each of its rows; blank outside a band and
   * on the band of lots whose category does not resolve.
   */
  productionCategoryEachesTotal?: Maybe<Scalars['Int']['output']>;
  /**
   * The lot's finish-job production category id, as stored on the lot. Selectable through the
   * source's productionCategoryId parameter.
   */
  productionCategoryId?: Maybe<Scalars['String']['output']>;
  /**
   * The production category band's summed quantity, repeated on each of its rows; zero outside a band.
   * Blank, for a tenant printing units and eaches, on a band whose lots do not share one container size,
   * which only the band of lots whose category does not resolve can be.
   */
  productionCategoryQuantityTotal?: Maybe<Scalars['Int']['output']>;
  productionLotId: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  /** The lot's production plan name, joined from the production plan read model. */
  productionPlanName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  /**
   * The lot's quantity as containers and eaches, 500 (4.5 inch tray) · 7,500 ea; the container count
   * alone when the category does not resolve.
   */
  quantityText: Scalars['String']['output'];
  status: Scalars['String']['output'];
  /**
   * The lot's container name: the production category's label, falling back to its code. Blank when the
   * category does not resolve.
   */
  uomLabel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportProductionLotsData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters; when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportProductionLotsDataPayload = {
  __typename?: 'ReportProductionLotsDataPayload';
  data: Array<ReportProductionLotData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable. Empty when the
   * page matched nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/** Flattened production schedule row for report generation. One row per Job document. */
export type ReportProductionScheduleData = {
  __typename?: 'ReportProductionScheduleData';
  containerQuantity: Scalars['Int']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  /** Whether this row opens its ISO delivery week's band. */
  firstOfWeek: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  jobName: Scalars['String']['output'];
  /** Whether this row closes its ISO delivery week's band. */
  lastOfWeek: Scalars['Boolean']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  /**
   * Gets a value indicating whether the scheduled job's item is a native plant species, joined
   * from the item read model — the job's embedded item snapshot carries no Native of its own.
   */
  native: Scalars['Boolean']['output'];
  productionQuantity: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  /** The week's summed container quantity, repeated on each of its rows. */
  weekContainerQuantityTotal: Scalars['Int']['output'];
  weekNumber: Scalars['Int']['output'];
  /** The week's summed production quantity, repeated on each of its rows. */
  weekProductionQuantityTotal: Scalars['Int']['output'];
  weekStartDate: Scalars['DateTime']['output'];
  workOrders: Array<ReportProductionScheduleWorkOrderData>;
};

/** Payload wrapper for the reportProductionScheduleData query. */
export type ReportProductionScheduleDataPayload = {
  __typename?: 'ReportProductionScheduleDataPayload';
  data: Array<ReportProductionScheduleData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable. Empty when the
   * page matched nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/** One component of a combo job: the plant it grows and how many go in each pot. */
export type ReportProductionScheduleProduceComboComponent = {
  __typename?: 'ReportProductionScheduleProduceComboComponent';
  /** The component's production category code; blank when the category is missing. */
  categoryName: Scalars['String']['output'];
  /** The component's production catalog color; blank when unset or the catalog entry is missing. */
  color: Scalars['String']['output'];
  /** How many of this component go in each pot; 1 when the link does not say. */
  componentsPerPot: Scalars['Int']['output'];
  /** The component's production catalog genus; blank when the catalog entry is missing. */
  genus: Scalars['String']['output'];
  /**
   * The Qty to Produce of the component's own job in the same lot, the job that feeds the combo for this link
   * (same catalog and category as the link); blank when the lot has no such job.
   */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The component's production catalog series; blank when unset or the catalog entry is missing. */
  series: Scalars['String']['output'];
  /** The start week number of that job; blank when there is none. */
  startWeek?: Maybe<Scalars['Int']['output']>;
};

/**
 * Payload wrapper for the reportProductionScheduleProduceData query. TotalCount is the
 * number of rows returned (capped at the source's row cap). TotalMatching is the total number
 * of production jobs matching the filters; when it exceeds TotalCount the client should prompt
 * the user to narrow their filters.
 */
export type ReportProductionScheduleProduceDataPayload = {
  __typename?: 'ReportProductionScheduleProduceDataPayload';
  /** The page of production job rows. */
  data: Array<ReportProductionScheduleProduceRow>;
  /** The number of rows on this page. */
  totalCount: Scalars['Int']['output'];
  /** The pre-cap count of jobs matching the filters. */
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable. Empty when the
   * page matched nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of the PRODUCE production schedule report — one production JOB, carrying the same joined
 * values the PRODUCE › Schedule grid shows for it, plus the job's location split into its Site and
 * Sublocation.
 */
export type ReportProductionScheduleProduceRow = {
  __typename?: 'ReportProductionScheduleProduceRow';
  /**
   * The alternate farms on the job's catalog, by vendor name, in the order the catalog lists them and
   * separated by commas, such as Dummen Orange, Syngenta Flowers. Blank when the catalog has none or
   * the job has no catalog.
   */
  alternateFarms?: Maybe<Scalars['String']['output']>;
  /**
   * The job's catalog origin: Seed, Cutting, Liner or Plug. Blank when the catalog
   * has no origin or the job has no catalog.
   */
  catalogOrigin?: Maybe<Scalars['String']['output']>;
  /** The production category's code — the grid's categoryName column. */
  categoryName: Scalars['String']['output'];
  /** The production catalog's color; blank when unset or the catalog entry is missing. */
  color: Scalars['String']['output'];
  /**
   * The combo's components: the links of the recipe variation in force, in order, each with its components
   * per pot. Empty on a job that is not a combo.
   */
  comboComponents: Array<ReportProductionScheduleProduceComboComponent>;
  /**
   * The combo's components on one line, Petunia Supertunia Red ×3 · Calibrachoa Bloomtastic Lemon ×2;
   * blank on a job that is not a combo or a combo with no components.
   */
  comboComponentsText?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the lot's customer group: the group chosen for the lot itself when it has one, else the lot
   * customer's group, as the Schedule grid's Customer Group column prints it. Blank when neither applies.
   */
  customerGroupName?: Maybe<Scalars['String']['output']>;
  /** The lot's customer name, joined through the lot; blank for a job with no lot or customer. */
  customerName: Scalars['String']['output'];
  /** The SKU on that customer item; blank in the same cases as the customer UPC. */
  customerSku?: Maybe<Scalars['String']['output']>;
  /**
   * The UPC on the lot customer's active, customer-wide customer item for the job's linked sales item, in effect
   * today; blank when the lot has no customer, the job has no linked sales item, no customer item applies, or the
   * customer items could not be read.
   */
  customerUpc?: Maybe<Scalars['String']['output']>;
  /**
   * The default farm on the job's catalog, by the vendor name saved with the catalog. Blank when the catalog
   * has no default farm or the job has no catalog.
   */
  defaultFarmName?: Maybe<Scalars['String']['output']>;
  /**
   * The quantity to produce in eaches: 500 trays of 15 is 7,500. Blank, never zero, when the category does
   * not resolve.
   */
  eaches?: Maybe<Scalars['Int']['output']>;
  /**
   * How many eaches one container of the job's production category holds: a 4.5 inch tray of 15 is 15.
   * Blank when the category does not resolve.
   */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The job's quantity to produce BEFORE rounding to whole containers, e.g. 4.5795 of a tray where
   * the quantity to produce is 5. Never truncated. A job planned before the exact quantity was stored reads its
   * whole quantity to produce.
   */
  exactQuantity: Scalars['Decimal']['output'];
  /** Whether this row opens a ready-week band. Only ever set under the ReadyWeekThenCustomer sort. */
  firstOfReadyWeek: Scalars['Boolean']['output'];
  /** Whether this row opens a start-week band. Only ever set under the StartWeekThenCustomer sort. */
  firstOfStartWeek: Scalars['Boolean']['output'];
  /** The production catalog's genus; blank when the catalog entry is missing. */
  genus: Scalars['String']['output'];
  /** Whether the job grows a combo: its recipe is a combo, or the variation in force says its recipe is one. */
  isCombo: Scalars['Boolean']['output'];
  /**
   * Whether the job is its lot's final step: it feeds no later job, or the job it feeds is no longer on file in
   * the lot.
   */
  isFinalStep: Scalars['Boolean']['output'];
  /** The job number, as the grid's jobCode column prints it. */
  jobNumber: Scalars['String']['output'];
  /** Whether this row closes a ready-week band. Only ever set under the ReadyWeekThenCustomer sort. */
  lastOfReadyWeek: Scalars['Boolean']['output'];
  /** Whether this row closes a start-week band. Only ever set under the StartWeekThenCustomer sort. */
  lastOfStartWeek: Scalars['Boolean']['output'];
  /** The lot number, as the grid's lotCode column prints it; none for a job with no lot. */
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** The lot's REQUESTED quantity — the grid's lotQuantity column; none for a job with no lot. */
  lotQuantity?: Maybe<Scalars['Int']['output']>;
  /** The lot's status label (Active / Inactive); Unknown for a job with no lot. */
  lotStatus: Scalars['String']['output'];
  /**
   * The names of the job's material events, as the Event Schedule shows them for the job, once each in name order
   * and comma-separated; blank when the job has none.
   */
  materialEventNames?: Maybe<Scalars['String']['output']>;
  /**
   * The category code of the next step, the job this job feeds; blank on the lot's final step or when its category
   * is no longer on file.
   */
  nextStepCategoryName?: Maybe<Scalars['String']['output']>;
  /**
   * The color of the next step, the job this job feeds, from its production catalog; blank on the lot's final step
   * or when the color is unset.
   */
  nextStepColor?: Maybe<Scalars['String']['output']>;
  /**
   * How many eaches one container of the next step's production category holds; blank on the lot's final step or
   * when that category is no longer on file.
   */
  nextStepEachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The next step's plants per pot with overrides applied, the way plants per pot is for this job;
   * blank on the lot's final step or when its recipe resolves to no variation.
   */
  nextStepPlantsPerPot?: Maybe<Scalars['Int']['output']>;
  /**
   * The quantity to produce on the next step, the job this job feeds, in that step's own containers; blank on the
   * lot's final step.
   */
  nextStepQuantity?: Maybe<Scalars['Int']['output']>;
  /** The ready week number of the next step, the job this job feeds; blank on the lot's final step. */
  nextStepReadyWeek?: Maybe<Scalars['Int']['output']>;
  /** The start week number of the next step, the job this job feeds; blank on the lot's final step. */
  nextStepStartWeek?: Maybe<Scalars['Int']['output']>;
  /**
   * The UPC of the next step, the job this job feeds, read from its production item's linked sales item the same
   * way as this job's own UPC; blank on the lot's final step or when the next step reaches no sales item UPC.
   */
  nextStepUpc?: Maybe<Scalars['String']['output']>;
  /** The job's notes; blank when it has none. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The ISO week number the job was ORIGINALLY scheduled to be ready, locked at lot creation. */
  originalReadyWeek: Scalars['Int']['output'];
  /** The ISO week number the job was ORIGINALLY scheduled to start, locked at lot creation. */
  originalStartWeek: Scalars['Int']['output'];
  /**
   * True on every row when the tenant prints units and eaches and at least one job has a container, so a
   * template prints its container and eaches columns for the whole page or not at all.
   */
  pageHasUnits: Scalars['Boolean']['output'];
  /**
   * The job number of the next step, the job this job feeds (in a combo, the finished job each component feeds);
   * blank on the lot's final step.
   */
  parentJobNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The job's plants per pot: its plants-per-pot override for the recipe variation in force, else that
   * variation's own plants per pot. The PRODUCE Schedule grid's effectivePlantsPerPot; blank when the
   * job's recipe resolves to no variation.
   */
  plantsPerPot?: Maybe<Scalars['Int']['output']>;
  /** The lot's PO number; blank when the lot has none. */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** The job's posting status, as the API names it: NOT_POSTED, PARTIALLY_POSTED or CLOSED. */
  postingStatus: Scalars['String']['output'];
  /** The SKU to print: the customer SKU when it has a value, else the sales item's SKU. */
  printedSku?: Maybe<Scalars['String']['output']>;
  /**
   * The UPC to print: the customer UPC when it has a value, else the sales item's UPC; blank
   * when neither has one.
   */
  printedUpc?: Maybe<Scalars['String']['output']>;
  /**
   * The category code of the prior step, the one job that feeds this job; blank when there is no single prior step
   * or its category is no longer on file.
   */
  priorStepCategoryName?: Maybe<Scalars['String']['output']>;
  /** The quantity of the prior step, the one job that feeds this job; blank when there is no single prior step. */
  priorStepQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * The site of the prior step, the one job that feeds this job; blank when no job feeds it, several do (the
   * finished job of a combo), or the prior step has no site.
   */
  priorStepSiteName?: Maybe<Scalars['String']['output']>;
  /** The start week number of the prior step, the one job that feeds this job; blank when there is no single prior step. */
  priorStepStartWeek?: Maybe<Scalars['Int']['output']>;
  /**
   * The sublocation of the prior step, the one job that feeds this job; blank when there is no single prior step
   * or it has no sublocation.
   */
  priorStepSublocationName?: Maybe<Scalars['String']['output']>;
  /**
   * The quantity posted for the job, the figure the PRODUCE Schedule grid prints as Posted Qty: its posted
   * production lines summed, dump and shrink lines left out. A production adjustment rewrites those lines, so
   * the figure already carries it. Blank until the job posts a line that is not dump or shrink.
   */
  producedQuantity?: Maybe<Scalars['Int']['output']>;
  /** The job's production plan name; blank when the plan is no longer on file. */
  productionPlanName: Scalars['String']['output'];
  /** The job's propagation yield, 0 to 1, as last set on the job; blank when never set. */
  propagationYield?: Maybe<Scalars['Decimal']['output']>;
  /** The job's quantity TO PRODUCE — the grid's quantity column. */
  quantity: Scalars['Int']['output'];
  /**
   * The quantity to produce as containers and eaches, 500 (4.5 inch tray) · 7,500 ea; the container
   * count alone when the category does not resolve.
   */
  quantityText: Scalars['String']['output'];
  /** The ready week's start date (its Monday) — the value the ready-week filters compare against. */
  readyDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ISO week number of the job's ready week, as the grid shows it. */
  readyWeek: Scalars['Int']['output'];
  /**
   * The ready-week band's summed eaches, repeated on each of its rows; blank outside a band and on a band
   * with a job whose category does not resolve.
   */
  readyWeekEachesTotal?: Maybe<Scalars['Int']['output']>;
  /**
   * The ready-week band's summed produced quantity, repeated on each of its rows, a job with nothing posted adding
   * zero; zero outside a band. Blank, for a tenant printing units and eaches, on a band whose jobs do not share
   * one container size.
   */
  readyWeekProducedTotal?: Maybe<Scalars['Int']['output']>;
  /**
   * The ready-week band's summed quantity to produce, repeated on each of its rows; zero outside a band.
   * Blank, for a tenant printing units and eaches, on a band whose jobs do not share one container size.
   */
  readyWeekQuantityTotal?: Maybe<Scalars['Int']['output']>;
  /** The production catalog's series; blank when unset or the catalog entry is missing. */
  series: Scalars['String']['output'];
  /**
   * The containers lost to shrink on the job: its current shrink events summed, across every shrink type. 0 when
   * the job has no shrink events.
   */
  shrinkQuantity: Scalars['Int']['output'];
  /**
   * The site (house) the job is placed at: the site of its sub-location, or the site itself when
   * the job is placed directly at one. None for a job with no location.
   */
  siteName?: Maybe<Scalars['String']['output']>;
  /**
   * The SKU of the sales item linked to the job's production item; blank when the job has no production item, the
   * production item links no sales item, or the linked sales item is deleted or has no SKU.
   */
  sku?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the job's space event, as the Event Schedule shows it for the job; the earliest scheduled one when
   * the job has several. Blank when the job has none.
   */
  spaceEventName?: Maybe<Scalars['String']['output']>;
  /**
   * The ISO week the job's space event is scheduled in, as text such as Wk 14; blank when the job has no
   * space event or the event's trigger date does not resolve.
   */
  spaceWeek?: Maybe<Scalars['String']['output']>;
  /** The start week's start date (its Monday) — the value the start-week filters compare against. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ISO week number of the job's start week, as the grid shows it. */
  startWeek: Scalars['Int']['output'];
  /**
   * The start-week band's summed eaches, repeated on each of its rows; blank outside a band and on a band
   * with a job whose category does not resolve.
   */
  startWeekEachesTotal?: Maybe<Scalars['Int']['output']>;
  /**
   * The start-week band's summed quantity to produce, repeated on each of its rows; zero outside a band.
   * Blank, for a tenant printing units and eaches, on a band whose jobs do not share one container size.
   */
  startWeekQuantityTotal?: Maybe<Scalars['Int']['output']>;
  /**
   * The job's step in its lot, counting from 1 in start week order, the job number breaking a tie. Every job takes
   * its own number, so the components of a combo, though grown side by side, are numbered one after another and
   * the finished job they feed comes after them. Blank when the job's lot can no longer be read.
   */
  stepNumber?: Maybe<Scalars['Int']['output']>;
  /** The sub-location (bay) the job is placed at; none when it is placed at a site or nowhere. */
  sublocationName?: Maybe<Scalars['String']['output']>;
  /** The resolved tag's code; blank when Tags is disabled or no tag resolves. */
  tagCode?: Maybe<Scalars['String']['output']>;
  /** The resolved tag's material item id; blank when Tags is disabled or no tag resolves. */
  tagMaterialItemId?: Maybe<Scalars['String']['output']>;
  /**
   * The resolved tag's on-hand quantity across the sites the caller can see (every site for a caller with no
   * site limit), repeated for every job resolving to that tag. Zero when the tag has no inventory there; blank
   * when Tags is disabled or no tag resolves.
   */
  tagOnHand?: Maybe<Scalars['Decimal']['output']>;
  /** The resolved tag's SKU; blank when Tags is disabled, no tag resolves, or its SKU is unset. */
  tagSku?: Maybe<Scalars['String']['output']>;
  /** The resolved tag's UPC; blank when Tags is disabled, no tag resolves, or its UPC is unset. */
  tagUpc?: Maybe<Scalars['String']['output']>;
  /**
   * The names of the job's task events, as the Event Schedule shows them for the job, once each in name order and
   * comma-separated. Blank when the job has none. A task event with no steps has no Event Schedule row, so it is
   * not listed.
   */
  taskEventNames?: Maybe<Scalars['String']['output']>;
  /**
   * The ISO week of the job's earliest task step by trigger date, a step whose trigger does not resolve counting
   * last; blank when the job has no task step or none resolves. A task event with no steps is not counted.
   */
  taskWeek?: Maybe<Scalars['Int']['output']>;
  /** The job's container code: the production category's code, the grid's uomCode column. */
  uomCode?: Maybe<Scalars['String']['output']>;
  /**
   * The job's container name: the production category's label, falling back to its code, the grid's
   * uomLabel column. Blank when the category does not resolve.
   */
  uomLabel?: Maybe<Scalars['String']['output']>;
  /**
   * The UPC of the sales item linked to the job's production item; blank when the job has no production item, the
   * production item links no sales item, or the linked sales item is deleted or has no UPC.
   */
  upc?: Maybe<Scalars['String']['output']>;
  /**
   * How far the produced quantity is from the quantity to produce, as a percentage of the quantity to produce,
   * to two decimal places: 520 produced against 500 is 4, and 450 is -10. Blank when nothing is posted or the
   * quantity to produce is zero.
   */
  variancePercent?: Maybe<Scalars['Decimal']['output']>;
  /** The job's yield percentage: its yield override when one is set, else the yield the job was planned with. */
  yield: Scalars['Decimal']['output'];
};

/**
 * Payload wrapper for the reportProductionScheduleProduceWeeklyData query. TotalCount is the
 * number of rows returned (capped at the source's row cap). TotalMatching is the number of variety and
 * farm rows the filters produce; when it exceeds TotalCount the client should prompt the user to narrow
 * their filters.
 */
export type ReportProductionScheduleProduceWeeklyDataPayload = {
  __typename?: 'ReportProductionScheduleProduceWeeklyDataPayload';
  /** The page of variety rows. */
  data: Array<ReportProductionScheduleProduceWeeklyRow>;
  /** The number of rows on this page. */
  totalCount: Scalars['Int']['output'];
  /** The pre-cap count of variety rows. */
  totalMatching: Scalars['Int']['output'];
};

/**
 * One row of the PRODUCE weekly cuttings report: one catalog variety (genus, series and color) and default
 * farm, with the cuttings each lot's first step (the stick week) needs in each ISO week of the Start Year,
 * counted in the week that step STARTS. A combo's components count under their own varieties. A job's cuttings
 * are its quantity times the eaches one container of its category holds times its effective plants per pot.
 */
export type ReportProductionScheduleProduceWeeklyRow = {
  __typename?: 'ReportProductionScheduleProduceWeeklyRow';
  /** The catalog origin: Seed, Cutting, Liner or Plug. Blank when the catalog has no origin. */
  catalogOrigin?: Maybe<Scalars['String']['output']>;
  /** The catalog color; blank when the catalog has none. */
  color: Scalars['String']['output'];
  /** The vendor name saved on the catalog's default farm; blank when the catalog has no default farm. */
  defaultFarmName?: Maybe<Scalars['String']['output']>;
  /** The catalog genus; blank for a job whose catalog does not resolve. */
  genus: Scalars['String']['output'];
  /** The catalog series; blank when the catalog has none. */
  series: Scalars['String']['output'];
  /** The cuttings of every week on the row, summed. */
  total: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 1 of the Start Year. */
  week01: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 2 of the Start Year. */
  week02: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 3 of the Start Year. */
  week03: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 4 of the Start Year. */
  week04: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 5 of the Start Year. */
  week05: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 6 of the Start Year. */
  week06: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 7 of the Start Year. */
  week07: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 8 of the Start Year. */
  week08: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 9 of the Start Year. */
  week09: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 10 of the Start Year. */
  week10: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 11 of the Start Year. */
  week11: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 12 of the Start Year. */
  week12: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 13 of the Start Year. */
  week13: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 14 of the Start Year. */
  week14: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 15 of the Start Year. */
  week15: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 16 of the Start Year. */
  week16: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 17 of the Start Year. */
  week17: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 18 of the Start Year. */
  week18: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 19 of the Start Year. */
  week19: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 20 of the Start Year. */
  week20: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 21 of the Start Year. */
  week21: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 22 of the Start Year. */
  week22: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 23 of the Start Year. */
  week23: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 24 of the Start Year. */
  week24: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 25 of the Start Year. */
  week25: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 26 of the Start Year. */
  week26: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 27 of the Start Year. */
  week27: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 28 of the Start Year. */
  week28: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 29 of the Start Year. */
  week29: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 30 of the Start Year. */
  week30: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 31 of the Start Year. */
  week31: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 32 of the Start Year. */
  week32: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 33 of the Start Year. */
  week33: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 34 of the Start Year. */
  week34: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 35 of the Start Year. */
  week35: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 36 of the Start Year. */
  week36: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 37 of the Start Year. */
  week37: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 38 of the Start Year. */
  week38: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 39 of the Start Year. */
  week39: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 40 of the Start Year. */
  week40: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 41 of the Start Year. */
  week41: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 42 of the Start Year. */
  week42: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 43 of the Start Year. */
  week43: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 44 of the Start Year. */
  week44: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 45 of the Start Year. */
  week45: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 46 of the Start Year. */
  week46: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 47 of the Start Year. */
  week47: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 48 of the Start Year. */
  week48: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 49 of the Start Year. */
  week49: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 50 of the Start Year. */
  week50: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 51 of the Start Year. */
  week51: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 52 of the Start Year. */
  week52: Scalars['Int']['output'];
  /** The cuttings of the jobs that start in ISO week 53 of the Start Year. 0 in a year of 52 weeks. */
  week53: Scalars['Int']['output'];
};

/** Work order summary nested under a production schedule row. */
export type ReportProductionScheduleWorkOrderData = {
  __typename?: 'ReportProductionScheduleWorkOrderData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskCount: Scalars['Int']['output'];
};

/**
 * Payload wrapper for the reportProductsData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters - when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportProductsDataPayload = {
  __typename?: 'ReportProductsDataPayload';
  data: Array<ReportProductData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /** Gets the report's grand-total row, one entry per summable column. */
  totals: Array<ReportColumnTotal>;
};

/**
 * Payload wrapper for the reportPullListConsolidatedData query. TotalCount is the number of
 * rolled-up rows returned (capped by first, at most ReportDataSourceConstants.MaxReportRows);
 * TotalMatching is the number of rolled-up rows across every selected order before that cap.
 */
export type ReportPullListConsolidatedDataPayload = {
  __typename?: 'ReportPullListConsolidatedDataPayload';
  data: Array<ReportPullListConsolidatedRow>;
  /** The dock of the load being printed, exactly as stored, when the print names a load (the loadId report parameter). Set only on a load-rooted print, where every row is a roll-up across the whole load and so has no order to carry a dock. Empty on an order-rooted print, and when the load has no dock. */
  dock: Scalars['String']['output'];
  /** The document-level order-to-dock list: each contributing order's current load assignments and docks, one entry per order and load, separate from the item roll-up rows. Set only on an order-rooted print (no loadId report parameter). Empty on a load-rooted print, and when no order has a dock. */
  orderDocks: Array<ReportPullListOrderDockData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /** Number of source pull-slip rows consumed across the selected orders, before each order's own row cap. Exceeds the consumed row count only when a source order was truncated, in which case the quantities on this report are understated. */
  totalSourceRows: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of the consolidated pull list, one (item, allocated location, grade, value adds label, retail price)
 * group rolled up across every selected order. Property names are the seeded column ids and the CSV / Excel
 * headers, so this record is APPEND-ONLY: a new column goes at the end (see the Native /
 * AllocatedSiteId precedent on the pull slip's export row), never between existing ones.
 */
export type ReportPullListConsolidatedRow = {
  __typename?: 'ReportPullListConsolidatedRow';
  /** Grade allocated at this location. 0 on an unallocated-demand row. */
  allocatedGrade: Scalars['Int']['output'];
  /** Identifier of the location the quantity is allocated from. Empty on the row that carries a SKU's UNALLOCATED demand: lines with no allocation roll into one blank-location row per SKU, value adds label and retail price so that demand is visible rather than dropped. */
  allocatedLocationId: Scalars['String']['output'];
  /** Display name of the allocated location. Empty on an unallocated-demand row. */
  allocatedLocationName: Scalars['String']['output'];
  /** The id of the range or house the allocated location sits in (the location's parent). Empty when the location has no parent, and on an unallocated-demand row. */
  allocatedParentLocationId: Scalars['String']['output'];
  /** The name of the range or house the allocated location sits in (the location's parent). Blank when the location has no parent. Group a template on it to print one band per range. */
  allocatedParentLocationName: Scalars['String']['output'];
  /** Identifier of the site the allocated location belongs to; echoes the location id when the location is not a sub-location of any site. Empty on an unallocated-demand row. */
  allocatedSiteId: Scalars['String']['output'];
  /** Display name of the allocated location's site; echoes the location name when the location is not a sub-location of any site. Empty on an unallocated-demand row. */
  allocatedSiteName: Scalars['String']['output'];
  /** Available quantity at the allocated location at generation time. 0 on an unallocated-demand row. */
  availableAtAllocated: Scalars['Decimal']['output'];
  /** The item's Category CODE, the same value the pull slip prints (the item's first category). Empty when the item cannot be resolved or has no category assigned. */
  category: Scalars['String']['output'];
  /** The code of the container every contributing line rides, as the pull slip prints it per row. Empty when the lines ride different containers or any line fits no container; never a guessed capacity. */
  containerCode: Scalars['String']['output'];
  /** The share of one container the row takes: the contributing lines' fractions summed, unrounded. Null on the same terms as containerCode. */
  containerFraction?: Maybe<Scalars['Decimal']['output']>;
  /** The name of that container. Empty on the same terms as containerCode. */
  containerName: Scalars['String']['output'];
  /** The customer retail price every contributing line carries, per each. Rows split on it, so one row carries one price or none. Null unless the tenant's Pre-pricing setting is on and the customer has an effective customer-level price for the item. */
  customerRetailPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Currency for customerRetailPrice. Null exactly when customerRetailPrice is null. */
  customerRetailPriceCurrency?: Maybe<Scalars['String']['output']>;
  /** customerRetailPrice as a fixed 2-decimal, currency-symbol-prefixed string (e.g. $5.99). Null exactly when customerRetailPrice is null. */
  customerRetailPriceFormatted?: Maybe<Scalars['String']['output']>;
  /** The row's pull eaches over the shared pack, cut toward zero at two decimals. Null without a shared pack. */
  derivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The row's pull quantity in eaches: the allocated eaches on an allocated row, the eaches the lines' stage rungs bill on an unallocated-demand row. */
  eaches: Scalars['Int']['output'];
  /** The pack every contributing line shares, from the lines' own snapshots. Null on the same terms as shippingUomLabel. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /** True on the FIRST row of each run of rows sharing an allocated location, so a template can open a location section header. Only meaningful under the pick-path (Location) sort, which is what makes a location's rows contiguous. */
  firstOfLocation: Scalars['Boolean']['output'];
  /** True when the allocated location currently holds no on-hand quantity of this item. Always false on an unallocated-demand row — there is no bin to be empty. */
  isAllocatedLocationEmpty: Scalars['Boolean']['output'];
  /** Stable identifier of the item. */
  itemId: Scalars['String']['output'];
  /** Display name of the item. */
  itemName: Scalars['String']['output'];
  /** True on the LAST row of each run of rows sharing an allocated location, so a template can close a location section with its subtotal row. */
  lastOfLocation: Scalars['Boolean']['output'];
  /** Pull quantity summed over this row's whole location band — the total to pull before walking on. Carried on every row of the band so a template may print it in the section header as readily as its footer. */
  locationAllocatedTotal: Scalars['Int']['output'];
  /** The containers this row's location band needs, e.g. 4 CC Rack · 1 Shelf: each container's fractions summed over the band's contributing lines and rounded up once, never adding different containers together. Ends + N lines not counted when lines fit no container. Carried on every row of the band. */
  locationContainersText: Scalars['String']['output'];
  /** Ordered quantity summed over this row's whole location band. */
  locationOrderedTotal: Scalars['Int']['output'];
  /** Whether the item is a native plant species, joined from the item read model. */
  native: Scalars['Boolean']['output'];
  /** On-hand quantity at the allocated location at generation time. 0 on an unallocated-demand row. */
  onHandAtAllocated: Scalars['Decimal']['output'];
  /** Number of distinct selected orders contributing to this row. */
  orderCount: Scalars['Int']['output'];
  /** The distinct Order kind names of the contributing orders, sorted and comma-separated. Empty when none of them has a kind. */
  orderKind: Scalars['String']['output'];
  /** The distinct contributing order numbers, sorted and comma-separated. */
  orderNumbers: Scalars['String']['output'];
  /** The item's Product Group, the same value the pull slip prints. Blank when the item has none. */
  productGroup: Scalars['String']['output'];
  /** The distinct Programs of the contributing orders, sorted and comma-separated. Empty when none of them has a Program. */
  program: Scalars['String']['output'];
  /** The distinct non-empty line pull notes of the contributing lines (each line's Pull-context note, falling back to its general note — the same rule as the pull slip's Note column), joined with " | ". */
  pullNotes: Scalars['String']['output'];
  /** The row's pull quantity as a document prints it, e.g. 2 (4.5 inch tray) · 30 ea: each unit's count and name, then the eaches. The bare eaches when no line has a named unit. */
  quantityText: Scalars['String']['output'];
  /** The code of that Shipping UOM. Null on the same terms as shippingUomLabel. */
  shippingUomCode?: Maybe<Scalars['String']['output']>;
  /** The name of the Shipping UOM every contributing line shares, e.g. 4.5 inch tray. Null when the lines differ in unit or have none. */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /** SKU of the item being pulled. */
  sku: Scalars['String']['output'];
  /** The item's Subcategory, the same value the pull slip prints. Blank when the item has none. */
  subcategory: Scalars['String']['output'];
  /** Sum of the quantity allocated to this item at this location across every selected order — the quantity to pull. 0 on an unallocated-demand row. */
  totalAllocatedQuantity: Scalars['Int']['output'];
  /** Sum of the ORDERED quantity of every order line contributing to this row, each line counted once even when it is allocated across several locations. */
  totalOrderedQuantity: Scalars['Int']['output'];
  /** The stored whole unit counts of the row's pull quantity, summed: set on an unallocated-demand row, whose lines' stage rungs are stored, and null on an allocated row, whose allocated eaches have none. */
  units?: Maybe<Scalars['Int']['output']>;
  /** How many shipping units one container holds. Null on the same terms as containerCode, and when the contributing orders' sites configure different capacities. */
  unitsPerContainer?: Maybe<Scalars['Int']['output']>;
  /** UPC of the item being pulled. */
  upc: Scalars['String']['output'];
  /** The value add names every contributing line carries, joined by commas. Rows split on it, so a product's custom or reserve trays print apart from its standard row. Empty when the lines carry none. */
  valueAddsLabel: Scalars['String']['output'];
};

/**
 * One contributing order's load assignment on the Consolidated Pull List's order-to-dock list. Sub-type
 * name suffix is "Data" per the wsapi GraphQL convention.
 */
export type ReportPullListOrderDockData = {
  __typename?: 'ReportPullListOrderDockData';
  /** How many containers of the order ride this load. Null when none was recorded. */
  containerCount?: Maybe<Scalars['Int']['output']>;
  /** The dock the load ships from, exactly as stored. The word Dock is never added. */
  dockName: Scalars['String']['output'];
  /** The number of the load the order rides. */
  loadNumber: Scalars['Int']['output'];
  /** The contributing order's number. */
  orderNumber: Scalars['String']['output'];
  /** The order's portion of this load, e.g. Load 12, 3 containers. Set only when the order rides more than one load. Empty otherwise. */
  portionLabel: Scalars['String']['output'];
};

/**
 * One alternate location holding the same item as the row's allocation, with current
 * on-hand and available so the picker can pull from a backup bin if the primary is empty.
 * Sub-type name suffix is "Data" per the wsapi GraphQL convention to prevent cross-type
 * reuse breakage (per WorkSuite.GraphQl.Features.Orders.AddLineItemData).
 */
export type ReportPullSlipAlternateLocationData = {
  __typename?: 'ReportPullSlipAlternateLocationData';
  /** Available quantity at the alternate location. Always > 0 (zero-available locations are filtered out). */
  available: Scalars['Decimal']['output'];
  /** Grade present at the alternate location. */
  grade: Scalars['Int']['output'];
  /** Identifier of the alternate location. */
  locationId: Scalars['String']['output'];
  /** Alternate location display name. */
  locationName: Scalars['String']['output'];
  /** On-hand quantity at the alternate location. */
  onHand: Scalars['Decimal']['output'];
};

/**
 * One container the order needs, on the pull slip's order header. Sub-type name suffix is "Data" per the
 * wsapi GraphQL convention.
 */
export type ReportPullSlipContainerTotalData = {
  __typename?: 'ReportPullSlipContainerTotalData';
  /** The container's code. */
  containerCode: Scalars['String']['output'];
  /** The container's name. */
  containerName: Scalars['String']['output'];
  /** How many of this container the order needs, rounded up once. */
  count: Scalars['Int']['output'];
};

/**
 * Payload wrapper for the reportPullSlipData query. TotalCount is the number of
 * rows returned (capped at ReportDataSourceConstants.MaxReportRows). TotalMatching
 * is the total number of rows matching the orderNumber lookup before any client-side limit; for the
 * single-order resolver these are usually equal unless the caller passes a smaller first.
 */
export type ReportPullSlipDataPayload = {
  __typename?: 'ReportPullSlipDataPayload';
  data: Array<ReportPullSlipDataRow>;
  /** Order-level header for the slip — the order number, PO, dates, status, ship-to address, effective Pull note, and order-number barcode value — carried independently of the line-item rows so the slip header and barcode still render for an order with no allocations (empty Data). Null only when the order itself does not resolve. */
  order?: Maybe<ReportPullSlipOrderData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /** The picking ticket's grand-total row, one entry per summable column, summed over the rows this ticket returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of the picking ticket — exactly one (order line item × allocated location) pair. A line
 * item that is allocated across N physical locations contributes N rows; an order with 5 line items
 * where line 3 spans 2 locations produces 6 rows total. Order-header fields are denormalized onto
 * every row so the slip can be rendered tabularly without per-row joins on the client.
 */
export type ReportPullSlipDataRow = {
  __typename?: 'ReportPullSlipDataRow';
  /** Grade allocated at this location. */
  allocatedGrade: Scalars['Int']['output'];
  /** Identifier of the location the picker is being directed to for this row. */
  allocatedLocationId: Scalars['String']['output'];
  /** Allocated location display name. */
  allocatedLocationName: Scalars['String']['output'];
  /** The id of the range or house the allocated location sits in (the location's parent). Empty when the location has no parent, the parent no longer exists, or the row has no allocation. */
  allocatedParentLocationId: Scalars['String']['output'];
  /** The name of the range or house the allocated location sits in (the location's parent). Blank when the location has no parent. Group a template on it to print one band per range. */
  allocatedParentLocationName: Scalars['String']['output'];
  /** Quantity to pull from the allocated location for this line item. */
  allocatedQuantity: Scalars['Int']['output'];
  /** Identifier of the site (WorkSuite SiteLocation) that owns the allocated location — the sub-location's SiteLocationId. Equal to AllocatedLocationId when the allocated location has no site parent (a site-level location itself, or a legacy flat-hierarchy tenant), so this is never empty when the row has an allocation. Lets a report split pick tickets by site (the crew-level grouping) while AllocatedLocationName stays the sorted pick-path column inside the sheet. */
  allocatedSiteId: Scalars['String']['output'];
  /** Display name of the site that owns the allocated location. Equal to AllocatedLocationName when the allocated location has no site parent, so flat-hierarchy tenants degrade to grouping by location (today's behavior) with no template change required. */
  allocatedSiteName: Scalars['String']['output'];
  /** Other locations holding this item with positive available quantity at slip-generation time. Sorted by available quantity descending. The allocated location itself is never present in this list. */
  alternateLocations: Array<ReportPullSlipAlternateLocationData>;
  /** Available (on-hand minus allocated) at the allocated location at the time of slip generation. */
  availableAtAllocated: Scalars['Decimal']['output'];
  /** The line item's Category CODE (Item DETAILS page), joined live as Categories[0] — never SortCategory or Group. Empty when the item cannot be resolved or has no category assigned. */
  category: Scalars['String']['output'];
  /** The code of the container the row's shipping unit rides: the order's own container when its goods ride it, else the configured container that fits the shipping unit at the order's ship-from site. Empty when no container fits or the unit states no eaches. */
  containerCode: Scalars['String']['output'];
  /** The share of one container the row takes: its shipping units over unitsPerContainer, unrounded (20 flats on a 35-flat rack is 0.571). Null on the same terms as containerCode. */
  containerFraction?: Maybe<Scalars['Decimal']['output']>;
  /** The name of that container. Empty on the same terms as containerCode. */
  containerName: Scalars['String']['output'];
  /** The containers the row's whole order needs, worded for a page, the same text as the order header's containerTotalsText. Denormalized onto every row. */
  containerTotalsText: Scalars['String']['output'];
  /** The containers this row needs, rounded up once from Container Fraction. Blank on the same terms as Container Code. */
  containersNeeded?: Maybe<Scalars['Int']['output']>;
  /** Customer ERP account number / external identifier. */
  customerAccountNumber: Scalars['String']['output'];
  /** Customer identifier for joining customer-specific reference data. */
  customerId: Scalars['String']['output'];
  /** Customer display name. */
  customerName: Scalars['String']['output'];
  /** The resolved customer retail price for this line. Null unless the tenant's Pre-pricing setting is on and the order's customer has an effective customer-level price for the line's item. */
  customerRetailPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Currency for customerRetailPrice. Null exactly when customerRetailPrice is null. */
  customerRetailPriceCurrency?: Maybe<Scalars['String']['output']>;
  /** customerRetailPrice formatted as a fixed 2-decimal, currency-symbol-prefixed string (e.g. $5.99). Null exactly when customerRetailPrice is null. */
  customerRetailPriceFormatted?: Maybe<Scalars['String']['output']>;
  /** The row's pull eaches over eachesPerUnit, cut toward zero at two decimals. Null when the line has no unit. */
  derivedUnits?: Maybe<Scalars['Decimal']['output']>;
  /** The line item's Description, joined live from the item read model. Empty when the item cannot be resolved or has no description set. */
  description: Scalars['String']['output'];
  /** The dock name(s) the row's order ships from, each distinct name once, comma-separated, exactly as stored. Empty when there is no dock. */
  dock: Scalars['String']['output'];
  /** Every load assignment that has a dock for the row's order, lowest load number first. Empty when there is no dock. */
  dockAssignments: Array<ReportDockAssignmentData>;
  /** The name of the driver on the load the ticket is printed from, as stored. Empty when the print names no load that carries the order, or the load has no driver. */
  driverName: Scalars['String']['output'];
  /** The order's drop number on the load the ticket is printed from, the same number the load manifest prints. Empty unless the print names a load that carries the order. */
  dropNumber?: Maybe<Scalars['Int']['output']>;
  /** Expected delivery date. */
  dueDate: Scalars['DateTime']['output'];
  /** The row's pull quantity in eaches: the allocated eaches on an allocated row, else the eaches the line's stage rung bills. */
  eaches: Scalars['Int']['output'];
  /** Eaches on one full shelf: Units per Shelf times the shipping unit's eaches per unit. Blank on the same terms as Container Code. */
  eachesPerShelf?: Maybe<Scalars['Int']['output']>;
  /** How many eaches one unit of the line holds, from the line's own snapshot taken when it was placed, never the Shipping UOM's current count. Null when the pack is one or unstated. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * True on the FIRST row of each run of rows sharing an allocated location, so a template
   *             can open a location section header on the pick path.
   */
  firstOfLocation: Scalars['Boolean']['output'];
  /** Order general note: the order's effective General note, resolved by the same inheritance chain as pullNotes (order override → ship-to location → customer). Denormalized onto every row. Empty when no tier supplies a General note. */
  generalNotes: Scalars['String']['output'];
  /** True when this row came from an actual allocation; false for an appended unallocated-line row. */
  isAllocated: Scalars['Boolean']['output'];
  /** True when the allocated bin is empty at slip-generation time. Lets the UI surface the alternates pane. */
  isAllocatedLocationEmpty: Scalars['Boolean']['output'];
  /** The line's item code (the item SKU), unchanged by the customer SKU that sku prints. */
  itemCode: Scalars['String']['output'];
  /** Item identifier used to join inventory for the alternate-location backup pane. */
  itemId: Scalars['String']['output'];
  /** Item display name. */
  itemName: Scalars['String']['output'];
  /** The ID of the kit this line was added from. Empty when the line was not added from a kit. */
  kitId: Scalars['String']['output'];
  /** The kit this line was added from, by name. Empty when the line was not added from a kit or the kit is missing. */
  kitName: Scalars['String']['output'];
  /**
   * True on the LAST row of each run of rows sharing an allocated location, so a template
   *             can close the section with its subtotal row.
   */
  lastOfLocation: Scalars['Boolean']['output'];
  /** Line general note: the line's General note, falling back to its single legacy note. Null when the line has neither. */
  lineGeneralNote?: Maybe<Scalars['String']['output']>;
  /** Position of this line on the order (1-based). */
  lineNumber: Scalars['Int']['output'];
  /** Line pull note: the line's Pull note, with no fallback. Null when the line has no Pull note. */
  linePullNote?: Maybe<Scalars['String']['output']>;
  /** Line ship note: the line's Ship note, with no fallback. Null when the line has no Ship note. */
  lineShipNote?: Maybe<Scalars['String']['output']>;
  /** The number of the load the ticket is printed from. Empty unless the print names a load that carries the order. */
  loadNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * Allocated quantity summed over this row's whole location band — what to pull from this
   *             bin before walking on. Carried on every row of the band so a template may print it in the
   *             section header as readily as its footer.
   */
  locationAllocatedTotal: Scalars['Int']['output'];
  /** The containers this row's location band needs, e.g. 4 CC Rack · 1 Shelf: each container's fractions summed over the band and rounded up once, never adding different containers together. Ends + N lines not counted when band lines fit no container. Carried on every row of the band. */
  locationContainersText: Scalars['String']['output'];
  /** Whether the line's item is a native plant species, joined from the item read model. */
  native: Scalars['Boolean']['output'];
  /** Line pull note, falling back to the general note. The original Note column, kept as it always printed; choose Line pull note or Line general note to print one note explicitly. Null when the line has neither a Pull nor a General note. */
  note?: Maybe<Scalars['String']['output']>;
  /** On-hand quantity at the allocated location at the time of slip generation. Zero when the bin is empty. */
  onHandAtAllocated: Scalars['Decimal']['output'];
  /** Order initialization date. */
  orderDate: Scalars['DateTime']['output'];
  /** Stable identifier of the order this slip row belongs to. */
  orderId: Scalars['String']['output'];
  /** The current name of the order's Order kind, resolved from the tenant's Order kinds at read time. Empty when the order has no kind or the kind has been removed. */
  orderKind: Scalars['String']['output'];
  /** Human-readable order number used by the picker to acknowledge the slip. */
  orderNumber: Scalars['String']['output'];
  /** Quantity ordered on this line item (across all allocated locations combined). */
  orderedQuantity: Scalars['Int']['output'];
  /** The line's ordered quantity in units, as stored. Null when the line has no unit or none is stored. */
  orderedUnits?: Maybe<Scalars['Int']['output']>;
  /** The alternate locations as one text value, each as its name and on-hand quantity, e.g. Q12_p05 (14), Dock (3). Empty when there are none. */
  otherLocations: Scalars['String']['output'];
  /** The planned arrival time of the order's stop on the load the ticket is printed from, as stored. Empty when no arrival is planned or the print names no load that carries the order. */
  plannedArrival: Scalars['String']['output'];
  /** The date of the planned move. Null exactly when plannedMoveLocationName is null. */
  plannedMoveDate?: Maybe<Scalars['DateTime']['output']>;
  /** The planned move date as printed on the slip, e.g. Nov 3, 2026. Null exactly when plannedMoveDate is null. */
  plannedMoveDateText?: Maybe<Scalars['String']['output']>;
  /** Where the plants at this location are planned to move: the destination of the open Move task of the job that posted the stock. Null when no open move leaves this location. */
  plannedMoveLocationName?: Maybe<Scalars['String']['output']>;
  /** Customer purchase order number (optional). */
  poNumber: Scalars['String']['output'];
  /** What customerRetailPrice is per: ea. A customer's retail price is the price one pot sells for, stickered on each pot, whatever unit the line ships in. */
  priceBasisLabel: Scalars['String']['output'];
  /** The line item's Product Group, joined live from the item read model. Empty when the item cannot be resolved or has no product group set. */
  productGroup: Scalars['String']['output'];
  /** The order's Program, a name from the tenant's Programs list. Empty when the order has none. */
  program: Scalars['String']['output'];
  /** Effective Pull note for the order, resolved by the same inheritance chain the live order.effectiveNotes field and the ds-orders report path use (order override → ship-to location → customer). Denormalized onto every row so the pull sheet can render it once from any row. Empty when no tier supplies a Pull note. */
  pullNotes: Scalars['String']['output'];
  /** The quantity to pull for this row: the allocated quantity when allocated, otherwise the line's furthest-progressed stage quantity in shipping units (shipped, else acknowledged, else ordered). */
  pullQuantity: Scalars['Int']['output'];
  /** The row's pull quantity as a document prints it, e.g. 2 (4.5 inch tray) · 30 ea. The bare each count when the line has no unit or its Shipping UOM has no name. */
  quantityText: Scalars['String']['output'];
  /** The ready date of the inventory at the pulled location. Null on an unallocated row or when that inventory has no ready date. */
  readyDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The effective route of the row's order, the same value the orders report prints. Empty when the order has no route. */
  route: Scalars['String']['output'];
  /** One row per shelf of one full container: shelf number and eaches. Bind a Table block to this array to print one line per shelf. Empty on the same terms as Container Code; partial last containers keep the full layout. */
  shelves: Array<ReportPullSlipShelfData>;
  /** The number of shelves in one full container, from its configured layers. Blank on the same terms as Container Code. */
  shelvesPerContainer?: Maybe<Scalars['Int']['output']>;
  /** Date the order was shipped, or null if not yet shipped. */
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  /** Order ship note: the order's effective Ship note, resolved by the same inheritance chain as pullNotes (order override → ship-to location → customer). Denormalized onto every row. Empty when no tier supplies a Ship note. */
  shipNotes: Scalars['String']['output'];
  /** Ship-to city. */
  shipToCity: Scalars['String']['output'];
  /** Ship-to contact name: the ship-to's own default contact, else the customer's Primary contact. Null when there is neither. */
  shipToContactName?: Maybe<Scalars['String']['output']>;
  /** Ship-to contact's first phone number. Null when the contact has none. */
  shipToContactPhone?: Maybe<Scalars['String']['output']>;
  /** Ship-to recipient name. */
  shipToName: Scalars['String']['output'];
  /** Ship-to state/province. */
  shipToState: Scalars['String']['output'];
  /** Ship-to street address line. */
  shipToStreet: Scalars['String']['output'];
  /** Ship-to postal code. */
  shipToZip: Scalars['String']['output'];
  /** The code of that Shipping UOM. Null when the line has no unit or the Shipping UOM has no code. */
  shippingUomCode?: Maybe<Scalars['String']['output']>;
  /** The name of the Shipping UOM the row's line was placed under, e.g. 4.5 inch tray. Null when the line's pack is one or unstated, and when no Shipping UOM with a name resolves. */
  shippingUomLabel?: Maybe<Scalars['String']['output']>;
  /** The SKU the slip prints for the line: the customer SKU of the line's customer item when it has one, else the item SKU. The item's own code is itemCode. */
  sku: Scalars['String']['output'];
  /** Order status at the time the slip was generated (string-projected enum). */
  status: Scalars['String']['output'];
  /** The line item's Subcategory, joined live from the item read model. Empty when the item cannot be resolved or has no subcategory set. */
  subcategory: Scalars['String']['output'];
  /** The stored whole unit count of the row's pull quantity: the line's stage rung on an unallocated row. Null on an allocated row, whose allocated eaches have no stored unit rung, and when the line has no unit. */
  units?: Maybe<Scalars['Int']['output']>;
  /** How many of the row's shipping units one container holds. Null on the same terms as containerCode; never a guessed capacity. */
  unitsPerContainer?: Maybe<Scalars['Int']['output']>;
  /** The shipping units one shelf holds, from the fitted container configuration. Blank on the same terms as Container Code. */
  unitsPerShelf?: Maybe<Scalars['Int']['output']>;
  /** The UPC the slip prints for the line: the customer UPC of the line's customer item when it has one, else the item UPC (optional). */
  upc: Scalars['String']['output'];
  /** Names of the line's value adds, across every source, in line order. Empty when the line carries none. */
  valueAdds: Array<Scalars['String']['output']>;
  /** The line's value add names joined by commas, in line order, as one text value a pull sheet can be sectioned on. Empty when the line carries none. */
  valueAddsLabel: Scalars['String']['output'];
  /** The name of the truck on the load the ticket is printed from, as stored. Empty when the print names no load that carries the order, or the load has no truck. */
  vehicleName: Scalars['String']['output'];
};

/**
 * Order-level header for the picking ticket, carried once per order rather than denormalized onto
 * each row. The seeded Pull Slip template binds these fields at the record root ({{orderNumber}},
 * {{shipToName}}, {{pullNotes}}, {{barcodeValue}}) so the header and order-number
 * barcode print even when the order has no allocations and the row table is empty. Sub-type name suffix
 * is "Data" per the wsapi GraphQL convention (see ReportPullSlipAlternateLocationData).
 */
export type ReportPullSlipOrderData = {
  __typename?: 'ReportPullSlipOrderData';
  /** Scannable value for the order-number barcode printed on the slip. Currently the order number itself, so the picking crew can scan the ticket back to the order. */
  barcodeValue: Scalars['String']['output'];
  /** Carrier assigned to the order — the truck/hauler the picking crew stages this order for. The order's own stored carrier value; empty when the order has no carrier. */
  carrier: Scalars['String']['output'];
  /** The containers the order needs, one entry per container, rounded up once after every shipping unit on that container is added in. Lines that fit no container are left out and reported in containerTotalsText. */
  containerTotals: Array<ReportPullSlipContainerTotalData>;
  /** The containers the order needs, worded for a page, e.g. 4 CC Rack · 1 Shelf, ending + 2 lines not counted when lines fit no container. The same numbers the order's container requirement shows. Empty when there is nothing to count. */
  containerTotalsText: Scalars['String']['output'];
  /** Customer ERP account number / external identifier. */
  customerAccountNumber: Scalars['String']['output'];
  /** Customer identifier for joining customer-specific reference data. */
  customerId: Scalars['String']['output'];
  /** Customer display name. */
  customerName: Scalars['String']['output'];
  /** The dock name(s) the order ships from, each distinct name once, comma-separated, exactly as stored. With a loadId report parameter it is that load's dock; without one, the dock of every load the order rides. Empty when there is no dock. */
  dock: Scalars['String']['output'];
  /** Every load assignment that has a dock, one entry per load the order rides (or, with a loadId report parameter, only the named loads), lowest load number first. A split order lists each load's dock beside its portion. Empty when there is no dock. */
  dockAssignments: Array<ReportDockAssignmentData>;
  /** The name of the driver on the load the ticket is printed from, as stored. Empty when the print names no load that carries the order, or the load has no driver. */
  driverName: Scalars['String']['output'];
  /** The order's drop number on the load the ticket is printed from, the same number the load manifest prints. Empty unless the print names a load that carries the order. */
  dropNumber?: Maybe<Scalars['Int']['output']>;
  /** Expected delivery date. */
  dueDate: Scalars['DateTime']['output'];
  /** Order general note: the effective General note for the order (order override → ship-to location → customer). Empty when no tier supplies a General note. */
  generalNotes: Scalars['String']['output'];
  /** The number of the load the ticket is printed from. Empty unless the print names a load that carries the order. */
  loadNumber?: Maybe<Scalars['Int']['output']>;
  /** Order initialization date. */
  orderDate: Scalars['DateTime']['output'];
  /** Stable identifier of the order. */
  orderId: Scalars['String']['output'];
  /** The current name of the order's Order kind, resolved from the tenant's Order kinds at read time. Empty when the order has no kind or the kind has been removed. */
  orderKind: Scalars['String']['output'];
  /** Human-readable order number used by the picker to acknowledge the slip. */
  orderNumber: Scalars['String']['output'];
  /** The planned arrival time of the order's stop on the load the ticket is printed from, as stored. Empty when no arrival is planned or the print names no load that carries the order. */
  plannedArrival: Scalars['String']['output'];
  /** Customer purchase order number (optional). */
  poNumber: Scalars['String']['output'];
  /** The order's Program, a name from the tenant's Programs list. Empty when the order has none. */
  program: Scalars['String']['output'];
  /** Effective Pull note for the order (order override → ship-to location → customer). Empty when no tier supplies a Pull note. */
  pullNotes: Scalars['String']['output'];
  /** The order's effective route, the same value the orders report prints. Empty when the order has no route. */
  route: Scalars['String']['output'];
  /** Date the order was shipped, or null if not yet shipped. */
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  /** Order ship note: the effective Ship note for the order (order override → ship-to location → customer). Empty when no tier supplies a Ship note. */
  shipNotes: Scalars['String']['output'];
  /** Ship-to city. */
  shipToCity: Scalars['String']['output'];
  /** Ship-to contact name: the ship-to's own default contact, else the customer's Primary contact. Null when there is neither. */
  shipToContactName?: Maybe<Scalars['String']['output']>;
  /** Ship-to contact's first phone number. Null when the contact has none. */
  shipToContactPhone?: Maybe<Scalars['String']['output']>;
  /** Ship-to recipient name. */
  shipToName: Scalars['String']['output'];
  /** Ship-to state/province. */
  shipToState: Scalars['String']['output'];
  /** Ship-to street address line. */
  shipToStreet: Scalars['String']['output'];
  /** Ship-to postal code. */
  shipToZip: Scalars['String']['output'];
  /** Order status at the time the slip was generated (string-projected enum). */
  status: Scalars['String']['output'];
  /** The name of the truck on the load the ticket is printed from, as stored. Empty when the print names no load that carries the order, or the load has no truck. */
  vehicleName: Scalars['String']['output'];
};

/** One shelf of a full container, for a repeating shelf table on the pull slip. */
export type ReportPullSlipShelfData = {
  __typename?: 'ReportPullSlipShelfData';
  /** Eaches held on this shelf of a full container. */
  eaches: Scalars['Int']['output'];
  /** Shelf number within one full container, starting at 1. */
  shelfNumber: Scalars['Int']['output'];
};

/** A named charge included in the purchase order estimated total. */
export type ReportPurchaseOrderChargeData = {
  __typename?: 'ReportPurchaseOrderChargeData';
  /** The signed amount; discounts are negative. */
  amount: Scalars['Decimal']['output'];
  /** The charge label shown to the vendor. */
  label: Scalars['String']['output'];
};

/**
 * Flattened recipe profitability record for report generation, with per-container figures and an estimated crop total.
 * Units sold are the container count sourced from joined production lots, average sell price is
 * ItemSummary.SellPrice with RetailPrice fallback (both per each) lifted by the production
 * category's Eaches, and average unit cost is the full recipe cost per container
 * (materials, plugs, labor and additional costs), costed at each lot's site and weighted by
 * containers produced. An incomplete cost is blank and flagged, never $0.
 */
export type ReportRecipeProfitabilityData = {
  __typename?: 'ReportRecipeProfitabilityData';
  /** Gets the per-container sell price: ItemSummary.SellPrice, falling back to RetailPrice, times the category's Eaches. Null when the category does not resolve or the item has no price (a price of 0.00 counts as none). */
  avgSellPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the full recipe cost per container (materials, plugs, labor and additional costs), costed at each job's site and weighted by containers produced. Null when the cost is incomplete at any site. */
  avgUnitCost?: Maybe<Scalars['Decimal']['output']>;
  /** Gets a value indicating whether the recipe cost could not be fully resolved, in which case AvgUnitCost and MarginPercent are blank rather than zero. */
  costIncomplete: Scalars['Boolean']['output'];
  /** Gets the eaches in one container, from the production category. Null when the category does not resolve or states no pack. */
  eachesPerContainer?: Maybe<Scalars['Int']['output']>;
  /** Gets the eaches produced: containers times the category's Eaches. Null when the category does not resolve or states no pack. */
  eachesProduced?: Maybe<Scalars['Int']['output']>;
  /** Gets the estimated total crop cost: containers produced times the current full recipe cost per container. Null when that cost is incomplete. */
  estimatedTotalCost?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the linked sales item identifier, when one is available. */
  itemId?: Maybe<Scalars['String']['output']>;
  /** Gets the linked sales item name, when one is available. */
  itemName?: Maybe<Scalars['String']['output']>;
  /** Gets the margin percentage on the per-container basis: (avgSellPrice - avgUnitCost) / avgSellPrice * 100. Blank when there is no price or the cost is incomplete. */
  marginPercent?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Gets a value indicating whether the recipe's sales item is a native plant species, read off
   * the ItemSummary row this source already left-joins. Unambiguous despite the aggregation
   * because the item is part of the group key, so every row is scoped to exactly one item.
   */
  native: Scalars['Boolean']['output'];
  /** Gets the production catalog identifier. */
  productionCatalogId: Scalars['String']['output'];
  /** Gets the production category identifier. */
  productionCategoryId: Scalars['String']['output'];
  /** Gets the production category's label, falling back to its code. Empty when the category does not resolve. */
  productionCategoryLabel: Scalars['String']['output'];
  /** Gets the production recipe identifier. */
  productionRecipeId: Scalars['String']['output'];
  /** Gets a display name built from the recipe catalog/category fields. */
  recipeName: Scalars['String']['output'];
  /** Gets the linked sales item SKU, when one is available. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Gets the containers produced: the sum of joined production lot quantities for the recipe. */
  unitsSold: Scalars['Int']['output'];
};

/** Payload wrapper for the reportRecipeProfitabilityData query. */
export type ReportRecipeProfitabilityDataPayload = {
  __typename?: 'ReportRecipeProfitabilityDataPayload';
  /** The returned recipe profitability rows. */
  data: Array<ReportRecipeProfitabilityData>;
  /** The number of rows returned after applying the page limit. */
  totalCount: Scalars['Int']['output'];
  /** The total number of rows matching the filters before applying the page limit. */
  totalMatching: Scalars['Int']['output'];
};

export type ReportRights = {
  __typename?: 'ReportRights';
  change: Scalars['Boolean']['output'];
  share: Scalars['Boolean']['output'];
  use: Scalars['Boolean']['output'];
};

/** Per-item-category breakdown of royalty totals within a payee. */
export type ReportRoyaltyPayoutDataCategoryBreakdown = {
  __typename?: 'ReportRoyaltyPayoutDataCategoryBreakdown';
  category: Scalars['String']['output'];
  lineCount: Scalars['Int']['output'];
  totalRoyalty: Scalars['Decimal']['output'];
};

/** Per-customer breakdown of royalty totals within a payee. */
export type ReportRoyaltyPayoutDataCustomerBreakdown = {
  __typename?: 'ReportRoyaltyPayoutDataCustomerBreakdown';
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  lineCount: Scalars['Int']['output'];
  totalRoyalty: Scalars['Decimal']['output'];
};

/**
 * Aggregated royalty totals for a single payee, with sub-breakdowns by customer
 * and item category.
 */
export type ReportRoyaltyPayoutDataPayee = {
  __typename?: 'ReportRoyaltyPayoutDataPayee';
  /** Per-customer breakdown within this payee, sorted by customer name ascending. */
  byCustomer: Array<ReportRoyaltyPayoutDataCustomerBreakdown>;
  /** Per-category breakdown within this payee, sorted by category ascending. Lines whose item has no SortCategory are grouped under an empty-string key. */
  byItemCategory: Array<ReportRoyaltyPayoutDataCategoryBreakdown>;
  /** Number of lines tied to this payee. */
  lineCount: Scalars['Int']['output'];
  /** The royalty payee, taken from the frozen line snapshot. */
  payeeName: Scalars['String']['output'];
  /** Sum of pre-discount line subtotals tied to this payee. */
  totalLineSubtotal: Scalars['Decimal']['output'];
  /** Sum of royalty amounts owed to this payee. */
  totalRoyalty: Scalars['Decimal']['output'];
};

/**
 * Top-level payload for the reportRoyaltyPayoutData query. Aggregates frozen
 * per-line royalty snapshots over a shippedAt date range, grouped by payee,
 * with optional sub-breakdowns by customer and item category.
 */
export type ReportRoyaltyPayoutDataPayload = {
  __typename?: 'ReportRoyaltyPayoutDataPayload';
  /** One aggregated row per payee, sorted by payee name ascending. */
  byPayee: Array<ReportRoyaltyPayoutDataPayee>;
  /** Number of distinct payees in the result. */
  distinctPayeeCount: Scalars['Int']['output'];
  /** Number of matched royalty-bearing lines in the report. */
  lineCount: Scalars['Int']['output'];
  /** Sum of EachesQuantity * (HandlingUom ?? 1) * (OverridePrice ?? Price) across every matched line — the pre-discount line revenue the royalty was earned against, matching the Phase 1 royalty basis. */
  totalLineSubtotal: Scalars['Decimal']['output'];
  /** Total number of matched source lines before the runaway-query cap was applied. */
  totalMatching: Scalars['Int']['output'];
  /** Sum of LineItemRoyalty.Amount across every matched line. */
  totalRoyalty: Scalars['Decimal']['output'];
  /** True when the runaway-query cap excluded rows. When true, finance must narrow the date range to get an accurate total. */
  truncatedByLimit: Scalars['Boolean']['output'];
};

/**
 * Per-group sales-by-category rollup row. Director-level KPI shape: revenue + units rolled up
 * by Category / Customer / Region across a date range.
 */
export type ReportSalesByCategoryData = {
  __typename?: 'ReportSalesByCategoryData';
  /** TotalRevenue / OrderCount. Zero when OrderCount is zero. */
  avgOrderValue: Scalars['Decimal']['output'];
  /** Echoed groupBy parameter (e.g. 'Category', 'Customer', 'Region') so the row is self-describing. */
  groupBy: Scalars['String']['output'];
  /** Raw key of the group (e.g. category code, customer id, or region code). */
  groupKey: Scalars['String']['output'];
  /** Display label for the group (e.g. category name, customer name, or region label). */
  groupLabel: Scalars['String']['output'];
  /** Distinct order count contributing to the group. */
  orderCount: Scalars['Int']['output'];
  /** Sum of (quantity * unit-price) for all line items in the group. */
  totalRevenue: Scalars['Decimal']['output'];
  /** Eaches sold across the group: each line's quantity, else its ordered quantity, summed. An each count, not a count of shipping units: a line of 2 trays of 15 adds 30. */
  totalUnits: Scalars['Int']['output'];
};

/**
 * Payload wrapper for the reportSalesByCategoryData query.
 * TotalCount is the number of rows returned (capped at 5000).
 * TotalMatching is the total number of groups matching the filters; when
 * TotalMatching > TotalCount, the client should prompt the user to narrow filters.
 */
export type ReportSalesByCategoryDataPayload = {
  __typename?: 'ReportSalesByCategoryDataPayload';
  data: Array<ReportSalesByCategoryData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable —
   * totalRevenue and totalUnits. Empty when the page matched nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * Per-group period-vs-period sales comparison row. PercentChange is null when
 * PeriodATotal is zero (avoids divide-by-zero; null is more informative than
 * Infinity / NaN / a sentinel).
 */
export type ReportSalesComparisonData = {
  __typename?: 'ReportSalesComparisonData';
  /** PeriodBTotal minus PeriodATotal (negative = decline, positive = growth). */
  delta: Scalars['Decimal']['output'];
  /** Echoed groupBy parameter (e.g. 'Customer', 'Item'). */
  groupBy: Scalars['String']['output'];
  /** Raw key of the group (e.g. customer id, item id, customer-type code). */
  groupKey: Scalars['String']['output'];
  /** Display label for the group (e.g. customer name, item name). */
  groupLabel: Scalars['String']['output'];
  /** Echoed metric parameter ('Dollars' or 'Units') so the row is self-describing. 'Units' totals count eaches, not shipping units. */
  metric: Scalars['String']['output'];
  /** Distinct order count contributing to Period A. */
  orderCountA: Scalars['Int']['output'];
  /** Distinct order count contributing to Period B. */
  orderCountB: Scalars['Int']['output'];
  /** (Delta / PeriodATotal) * 100. Null when PeriodATotal is 0. */
  percentChange?: Maybe<Scalars['Decimal']['output']>;
  /** Echoed Period A start (inclusive). */
  periodAFrom: Scalars['DateTime']['output'];
  /** Echoed Period A end (inclusive). */
  periodATo: Scalars['DateTime']['output'];
  /** Aggregate metric value over Period A: dollars, or eaches under the Units metric (an each count, not a count of shipping units). */
  periodATotal: Scalars['Decimal']['output'];
  /** Echoed Period B start (inclusive). */
  periodBFrom: Scalars['DateTime']['output'];
  /** Echoed Period B end (inclusive). */
  periodBTo: Scalars['DateTime']['output'];
  /** Aggregate metric value over Period B: dollars, or eaches under the Units metric (an each count, not a count of shipping units). */
  periodBTotal: Scalars['Decimal']['output'];
  /** True on every row of a Units run, whose period totals count eaches, not shipping units. False on a Dollars run. */
  showEachesBasis: Scalars['Boolean']['output'];
};

/**
 * Payload wrapper for the reportSalesComparisonData query.
 * TotalCount is the number of records returned (capped at 5000).
 * TotalMatching is the total number of groups matching the filters; when
 * TotalMatching > TotalCount, the client should prompt the user to narrow filters.
 */
export type ReportSalesComparisonDataPayload = {
  __typename?: 'ReportSalesComparisonDataPayload';
  data: Array<ReportSalesComparisonData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable —
   * periodATotal, periodBTotal and delta. Empty when the page matched nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * Payload wrapper for the reportSalesPersonCommissionData query. TotalCount is the number
 * of rows returned (capped by first); TotalMatching is the number of commissionable lines
 * the period actually matched. When TotalMatching > TotalCount the run is TRUNCATED and its
 * totals do not add up to what is owed — narrow the period or raise the cap before paying anyone from
 * it.
 */
export type ReportSalesPersonCommissionDataPayload = {
  __typename?: 'ReportSalesPersonCommissionDataPayload';
  /** One row per commissionable line item, in the caller's sortBy order. */
  data: Array<ReportSalesPersonCommissionDataRow>;
  /** Rows returned. */
  totalCount: Scalars['Int']['output'];
  /** Commissionable lines matched before the cap. */
  totalMatching: Scalars['Int']['output'];
};

/** One commissionable order line, with the commission it earns for the order's salesperson. */
export type ReportSalesPersonCommissionDataRow = {
  __typename?: 'ReportSalesPersonCommissionDataRow';
  /**
   * The revenue the commission was actually charged against: grossAmount, or
   * grossAmount − discountAmount when deductDiscountTaken is set.
   */
  basisAmount: Scalars['Decimal']['output'];
  /** basisAmount × commissionRatePercent ÷ 100, rounded to cents. */
  commissionAmount: Scalars['Decimal']['output'];
  /**
   * The effective rate applied, 0–100: the salesperson's override for ratedCustomerId
   * when one exists, otherwise their default rate. A salesperson with no commission configuration
   * rates at 0.
   */
  commissionRatePercent: Scalars['Decimal']['output'];
  /** The account's ERP id under a bill-to basis, the location's code under a ship-to basis. */
  customerCode: Scalars['String']['output'];
  /**
   * The customer this row is grouped and subtotalled under, per the run's customerBasis: the
   * order's bill-to account id, or the ship-to location id. ⚠️ NOT necessarily the identity the RATE
   * was resolved against — see the ratedCustomerId field.
   */
  customerId: Scalars['String']['output'];
  /** The display name matching customerId under the same basis. */
  customerName: Scalars['String']['output'];
  /**
   * This line's pro-rated share of the order's discount. Reported on every row regardless of
   * deductDiscountTaken, so a reader can see what the toggle would change without re-running.
   */
  discountAmount: Scalars['Decimal']['output'];
  /**
   * True on the first row of a consecutive run of rows for the same salesperson — the template's cue
   * for a heading or a page break (GrowPoint's "page per salesman").
   */
  firstOfSalesPerson: Scalars['Boolean']['output'];
  /** The line's gross revenue, before any order-level discount. */
  grossAmount: Scalars['Decimal']['output'];
  /** The line's item id. */
  itemId: Scalars['String']['output'];
  /** The line's item name. */
  itemName: Scalars['String']['output'];
  /**
   * True on the last row of that run — the template's cue for a subtotal line (GrowPoint's "salesman
   * totals").
   */
  lastOfSalesPerson: Scalars['Boolean']['output'];
  /** The parent order's id. A drill-through handle for the PWA; not an export column. */
  orderId: Scalars['String']['output'];
  /** The parent order's number — GrowPoint's "Trans No.". */
  orderNumber: Scalars['String']['output'];
  /**
   * The line's billable EACHES, not its shipping units (packs × pack size, or the eaches a stage
   * stated): the same quantity basis grossAmount was computed on and the basis unitPrice
   * is per, so quantity × unit price is the gross amount for a line carrying no upgrades.
   */
  quantity: Scalars['Int']['output'];
  /**
   * The customer the commission RATE was resolved against — ALWAYS the order's bill-to account, on
   * both bases, because CommissionConfig.CustomerOverrides is keyed by customer account id and a
   * ship-to LOCATION id could never match one. Its own column so a ship-to-basis statement can still
   * show which override produced its rate.
   */
  ratedCustomerId: Scalars['String']['output'];
  /** The salesperson email stamped on the order — the identity the commission is owed to. */
  salesPerson: Scalars['String']['output'];
  /**
   * The run's commissionable revenue, summed over the RETURNED rows. Same two caveats as
   * salesPersonCommissionTotal.
   */
  salesPersonBasisTotal: Scalars['Decimal']['output'];
  /**
   * The run's commission, summed over the RETURNED rows.
   *
   * ⚠️ Two caveats, both deliberate. It sums the returned PAGE, not the matched population — so when
   * TotalMatching > TotalCount this subtotal is partial, exactly as the rows above it are.
   * And a "run" is CONSECUTIVE: under the default SalesPerson sort each rep forms one run and
   * this is their period total, but under a date or order-number sort their rows interleave and each
   * subtotal covers only its own stretch — so a total line always adds up the rows printed directly
   * above it.
   */
  salesPersonCommissionTotal: Scalars['Decimal']['output'];
  /** The line's SKU. */
  sku: Scalars['String']['output'];
  /**
   * The date this row was measured against: the order's ship date or its order date, per the run's
   * dateBasis. NOT a payment date — WorkSuite's payment data is integration-dependent, so no
   * paid-date basis exists.
   */
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  /** The line's effective unit price (OverridePrice ?? Price). */
  unitPrice: Scalars['Decimal']['output'];
};

/** Aggregated sales performance record for report generation. One row per sales person. */
export type ReportSalesPersonPerformanceData = {
  __typename?: 'ReportSalesPersonPerformanceData';
  avgOrderValue: Scalars['Decimal']['output'];
  firstOrderDate: Scalars['DateTime']['output'];
  lastOrderDate: Scalars['DateTime']['output'];
  orderCount: Scalars['Int']['output'];
  salesPerson: Scalars['String']['output'];
  totalRevenue: Scalars['Decimal']['output'];
  /**
   * Gets the eaches sold on the salesperson's orders: each line's quantity, else its ordered quantity,
   * summed. An each count, not a count of shipping units: a line of 2 trays of 15 adds 30.
   */
  totalUnits: Scalars['Int']['output'];
};

/**
 * Payload wrapper for the reportSalesPersonPerformanceData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters - when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportSalesPersonPerformanceDataPayload = {
  __typename?: 'ReportSalesPersonPerformanceDataPayload';
  data: Array<ReportSalesPersonPerformanceData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable —
   * totalRevenue, totalUnits and orderCount. Empty when the page matched
   * nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * Payload wrapper for the reportSalesTaxData query. TotalCount is the number of rows
 * returned; TotalMatching is the number matching the filters before the page cap, so the
 * builder can prompt the caller to narrow when the two differ.
 */
export type ReportSalesTaxDataPayload = {
  __typename?: 'ReportSalesTaxDataPayload';
  data: Array<ReportSalesTaxDataRow>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * Gets the filing period's grand-total row, one entry per summable column. Projected from the map
   * ReportSalesTaxDataSource.ReadAsync already folded — never summed a second time here, so
   * the preview and the CSV / Excel / PDF arm publish the same tax figure by construction.
   */
  totals: Array<ReportColumnTotal>;
};

/**
 * One row of a Sales Tax render — a single jurisdiction's tax, as Stripe recorded it. ONE record
 * serves both ReportSalesTaxReportType grains and both ReportSalesTaxBasis sources,
 * because the seeded data source declares one column set and the report-builder Table picker binds
 * to it — a per-grain record would mean four sources.
 *
 *
 * NOTHING HERE IS COMPUTED FROM A RATE. Every amount is a figure Stripe calculated and WorkSuite
 * stored; the report unwinds a recorded breakdown array and, on the summary grain, adds the rows
 * up. rate is carried because Stripe recorded it, not because anything is multiplied by it.
 *
 *
 *
 * WHICH FIELDS CARRY A VALUE DEPENDS ON THE GRAIN, and the unpopulated ones are blank rather than
 * absent so a template bound to a column never renders a Handlebars miss:
 *
 *
 * Detail (one row per document × jurisdiction) — every field.
 * Summary (one row per jurisdiction) — the jurisdiction and money fields; the document
 * and customer fields (documentNumber, documentDate, customerId,
 * customerCode, customerName, stripeTaxTransactionId, noTaxReason) are
 * blank, because a jurisdiction's liability spans many documents and many customers.
 *
 *
 *
 * PROPERTY ORDER IS THE SEEDED COLUMN ORDER, and through TabularDataFlattener it is also the
 * CSV / Excel header order. APPEND, never insert.
 */
export type ReportSalesTaxDataRow = {
  __typename?: 'ReportSalesTaxDataRow';
  /**
   * Which recorded figure this row came from — Invoiced or Estimate. Echoed onto
   * every row rather than left to the header because CSV and Excel carry no header: the flattener
   * exports the row array and nothing else, so a reader handed the file must still be able to
   * tell a filing figure from an estimate.
   */
  basis: Scalars['String']['output'];
  /**
   * The ERP-facing customer code (CustomersSummaryDocument.CustomerLookupCode) an A/R clerk
   * reconciles against — not customerId, which is internal. Blank on a Summary row.
   */
  customerCode: Scalars['String']['output'];
  /** The customer billed. Blank on a Summary row. */
  customerId: Scalars['String']['output'];
  /** The customer's name. Blank on a Summary row. */
  customerName: Scalars['String']['output'];
  /** The customer-type id, empty when the customer holds no type. */
  customerTypeId: Scalars['String']['output'];
  /** The customer-type display name, empty when the customer holds no type. */
  customerTypeName: Scalars['String']['output'];
  /**
   * The date the document is periodised on — the INVOICE DATE on the invoiced basis, the ORDER
   * DATE on the estimate basis. This is the date the requested period bounds, so a reader can
   * reproduce the selection by hand. None on a Summary row, which spans many dates.
   */
  documentDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The document this tax was recorded against — the INVOICE NUMBER on the invoiced basis, the
   * ORDER NUMBER on the estimate basis. Blank on a Summary row.
   */
  documentNumber: Scalars['String']['output'];
  /**
   * The estimate disclaimer, on every Estimate row, and BLANK on an Invoiced row.
   * The row-level half of the banner, for the same reason basis is on the row: the seeded
   * template's conditional banner reaches the PDF and the builder preview, and this reaches the
   * CSV and the spreadsheet, which the template never touches.
   */
  filingNote: Scalars['String']['output'];
  /**
   * Whether this row came from a VOIDED invoice, and therefore carries reversed amounts. Always
   * false unless includeVoided was asked for, and always false on the estimate basis.
   */
  isVoided: Scalars['Boolean']['output'];
  /**
   * The taxing jurisdiction Stripe named, e.g. California. A FLAT name: Stripe's breakdown
   * has no second tier, which is why GrowPoint's Tax Code 2 has no equivalent here.
   */
  jurisdiction: Scalars['String']['output'];
  /** The jurisdiction's level as Stripe recorded it — country, state, city, … */
  level: Scalars['String']['output'];
  /**
   * Why the invoice went out with No tax, for example Resale, as recorded on the invoice when it was
   * issued. Detail rows on the Invoiced basis only. Blank on a Summary row, on the Estimate basis and on
   * any invoice that did not go out with No tax. The order's No tax note is never included.
   */
  noTaxReason: Scalars['String']['output'];
  /**
   * The rate Stripe recorded for this jurisdiction, AS A PERCENT (7.25 means 7.25%). Blank
   * as zero on a Summary row: one jurisdiction can appear at several rates across a period, and a
   * blended figure would be arithmetic this report does not do.
   */
  rate: Scalars['Decimal']['output'];
  /**
   * The percent-formatted presentation mirror of rate. Rendered server-side because the PDF
   * service's Handlebars registers no number-formatting helper — a template binding the raw
   * decimal prints an unpunctuated, unsuffixed figure. PRESENTATION ONLY.
   */
  rateFormatted: Scalars['String']['output'];
  /**
   * Stripe's taxability reason for this row — customer_exempt, not_subject_to_tax,
   * not_collecting, standard_rated, … This is what distinguishes an exempt customer
   * from a non-taxable item from an unregistered destination, all three of which otherwise appear
   * as a zero. It is carried as a column rather than offered as a filter because it is Stripe's
   * vocabulary, not ours, and pinning a filter to it would freeze that vocabulary into our seed.
   */
  reason: Scalars['String']['output'];
  /** The two-letter state code, where the jurisdiction carries one. Blank otherwise. */
  state: Scalars['String']['output'];
  /**
   * Stripe's tax transaction id for the invoice — the handle a filing reconciles against Stripe's
   * own records. Blank on the estimate basis (an estimate has a calculation, never a transaction)
   * and on a Summary row.
   */
  stripeTaxTransactionId: Scalars['String']['output'];
  /**
   * The tax itself. On the invoiced basis this is the filing figure; a voided invoice included via
   * includeVoided carries it NEGATED, mirroring the reversal Stripe holds.
   */
  tax: Scalars['Decimal']['output'];
  /** Currency-formatted mirror of tax. PRESENTATION ONLY, as taxableAmountFormatted. */
  taxFormatted: Scalars['String']['output'];
  /** The amount this jurisdiction taxed, as Stripe recorded it. */
  taxableAmount: Scalars['Decimal']['output'];
  /**
   * Currency-formatted mirror of taxableAmount. PRESENTATION ONLY: summing the mirrors
   * alongside the raw decimals double-counts.
   */
  taxableAmountFormatted: Scalars['String']['output'];
};

/** Flattened sales velocity record for report generation. One row per BaseRateOfSale document. */
export type ReportSalesVelocityData = {
  __typename?: 'ReportSalesVelocityData';
  /** Timestamp when the base rate of sale was calculated. */
  calculatedAt: Scalars['DateTime']['output'];
  /** Customer code associated with the base rate of sale. */
  customerCode: Scalars['String']['output'];
  /** Item code associated with the base rate of sale. */
  itemCode: Scalars['String']['output'];
  /** Location code associated with the base rate of sale. */
  locationCode: Scalars['String']['output'];
  /** Whether the item is a native plant species. */
  native: Scalars['Boolean']['output'];
  /** Program associated with the base rate of sale. */
  program: Scalars['String']['output'];
  /** Total units sold across all days in the base-rate-of-sale trailing window. */
  rawTrailingUnitsSold: Scalars['Int']['output'];
  /** Units sold across trailing days that passed constraint detection. */
  usableTrailingUnitsSold: Scalars['Int']['output'];
  /** Rolling weekly rate of sale used by DBR replenishment. */
  weeklyRateOfSale: Scalars['Decimal']['output'];
};

/**
 * Payload wrapper for the reportSalesVelocityData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters.
 */
export type ReportSalesVelocityDataPayload = {
  __typename?: 'ReportSalesVelocityDataPayload';
  data: Array<ReportSalesVelocityData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable —
   * rawTrailingUnitsSold and usableTrailingUnitsSold. Empty when the page matched
   * nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/** GraphQL data transfer record for a report schedule. */
export type ReportScheduleData = {
  __typename?: 'ReportScheduleData';
  /** Gets the timestamp when the schedule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who created the schedule. */
  createdBy: Scalars['String']['output'];
  /** Gets the cron expression defining the schedule frequency. */
  cronExpression: Scalars['String']['output'];
  /** Gets the optional order-email doc-type carried opaquely for the executor to stamp on the email audit. */
  docType?: Maybe<OrderEmailDocType>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the authorable Handlebars email subject (tokens + inline {{#if}}), or null when
   * not authored. Rendered at send time; supports invoice-vs-credit branching on
   * orderType for order-context reuse.
   */
  emailSubject?: Maybe<Scalars['String']['output']>;
  /** Gets the date when the schedule expires. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Gets a value indicating whether this schedule is active. */
  isActive: Scalars['Boolean']['output'];
  /** Gets the last completed run time. */
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the schedule name. */
  name: Scalars['String']['output'];
  /** Gets the next scheduled run time. */
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the optional order id carried opaquely for the executor to stamp on the email audit. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Gets the optional order number carried opaquely for the executor to stamp on the email audit. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Gets the output format (e.g. PDF, CSV, EXCEL). */
  outputFormat: Scalars['String']['output'];
  /** Gets the JSON blob of report parameters. */
  parameters?: Maybe<Scalars['String']['output']>;
  /**
   * Gets why the schedule exists: PAY_LINK_RESEND for an invoice email that carries a pay link (a customer's
   * request for a new link, or a staff resend), else UNKNOWN. Set when the schedule is created and never changed
   * by an update.
   */
  purpose: ReportSchedulePurpose;
  /** Gets the list of recipient email addresses. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the report identifier this schedule is linked to. */
  reportId: Scalars['String']['output'];
  /** Gets the optional report template identifier. */
  reportTemplateId?: Maybe<Scalars['String']['output']>;
  /**
   * Gets a value indicating whether this is a one-shot (runOnce) schedule. When true the schedule
   * fires once at nextRunAt and is deactivated by the executor; the cron expression
   * is optional.
   */
  runOnce: Scalars['Boolean']['output'];
  /** Gets the unique schedule identifier. */
  scheduleId: Scalars['String']['output'];
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: Maybe<Scalars['String']['output']>;
  /** Gets the date when the schedule becomes effective. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the current status of the schedule. */
  status: ReportScheduleStatus;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the IANA timezone identifier used to interpret cron times. */
  timeZoneId: Scalars['String']['output'];
  /** Gets the timestamp when the schedule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who last updated the schedule. */
  updatedBy: Scalars['String']['output'];
};

/** MongoDB document representing a projected report schedule. */
export type ReportScheduleDocument = {
  __typename?: 'ReportScheduleDocument';
  /** Gets the timestamp when the schedule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who created the schedule. */
  createdBy: Scalars['String']['output'];
  /** Gets the cron expression defining the schedule frequency. */
  cronExpression: Scalars['String']['output'];
  /** Gets the optional order-email doc-type carried opaquely for the executor. */
  docType?: Maybe<OrderEmailDocType>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: Maybe<Scalars['String']['output']>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: Maybe<Scalars['String']['output']>;
  /** Gets the date when the schedule expires. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the MongoDB document identifier. */
  id: Scalars['String']['output'];
  /** Gets a value indicating whether this schedule is active. */
  isActive: Scalars['Boolean']['output'];
  /** Gets the last completed run time. */
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the schedule name. */
  name: Scalars['String']['output'];
  /** Gets the next scheduled run time. */
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the optional order id carried opaquely for the executor. */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Gets the optional order number carried opaquely for the executor. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Gets the output format (e.g. PDF, CSV, EXCEL). */
  outputFormat: Scalars['String']['output'];
  /** Gets the JSON blob of report parameters. */
  parameters?: Maybe<Scalars['String']['output']>;
  /**
   * Gets why the schedule exists: PAY_LINK_RESEND for an invoice email that carries a pay link (a customer's
   * request for a new link, or a staff resend), else UNKNOWN. Set when the schedule is created and never changed
   * by an update.
   */
  purpose: ReportSchedulePurpose;
  /** Gets the list of recipient email addresses. */
  recipients: Array<Scalars['String']['output']>;
  /** Gets the report identifier this schedule is linked to. */
  reportId: Scalars['String']['output'];
  /** Gets the optional report template identifier. */
  reportTemplateId?: Maybe<Scalars['String']['output']>;
  /** Gets a value indicating whether this is a one-shot (runOnce) schedule. */
  runOnce: Scalars['Boolean']['output'];
  /** Gets the unique schedule identifier. */
  scheduleId: Scalars['String']['output'];
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: Maybe<Scalars['String']['output']>;
  /** Gets the date when the schedule becomes effective. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the current status of the schedule. */
  status: ReportScheduleStatus;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the IANA timezone identifier used to interpret cron times. */
  timeZoneId: Scalars['String']['output'];
  /** Gets the timestamp when the schedule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets the email of the user who last updated the schedule. */
  updatedBy: Scalars['String']['output'];
};

/** MongoDB document representing a projected report schedule. */
export type ReportScheduleDocumentFilterInput = {
  and?: InputMaybe<Array<ReportScheduleDocumentFilterInput>>;
  /** Gets the timestamp when the schedule was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the email of the user who created the schedule. */
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /** Gets the cron expression defining the schedule frequency. */
  cronExpression?: InputMaybe<StringOperationFilterInput>;
  /** Gets the optional order-email doc-type carried opaquely for the executor. */
  docType?: InputMaybe<NullableOfOrderEmailDocTypeOperationFilterInput>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: InputMaybe<StringOperationFilterInput>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: InputMaybe<StringOperationFilterInput>;
  /** Gets the date when the schedule expires. */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Gets a value indicating whether this schedule is active. */
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the last completed run time. */
  lastRunAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the schedule name. */
  name?: InputMaybe<StringOperationFilterInput>;
  /** Gets the next scheduled run time. */
  nextRunAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ReportScheduleDocumentFilterInput>>;
  /** Gets the optional order id carried opaquely for the executor. */
  orderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the optional order number carried opaquely for the executor. */
  orderNumber?: InputMaybe<StringOperationFilterInput>;
  /** Gets the output format (e.g. PDF, CSV, EXCEL). */
  outputFormat?: InputMaybe<StringOperationFilterInput>;
  /** Gets the JSON blob of report parameters. */
  parameters?: InputMaybe<StringOperationFilterInput>;
  /**
   * Gets why the schedule exists: PAY_LINK_RESEND for an invoice email that carries a pay link (a customer's
   * request for a new link, or a staff resend), else UNKNOWN. Set when the schedule is created and never changed
   * by an update.
   */
  purpose?: InputMaybe<ReportSchedulePurposeOperationFilterInput>;
  /** Gets the list of recipient email addresses. */
  recipients?: InputMaybe<ListStringOperationFilterInput>;
  /** Gets the report identifier this schedule is linked to. */
  reportId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the optional report template identifier. */
  reportTemplateId?: InputMaybe<StringOperationFilterInput>;
  /** Gets a value indicating whether this is a one-shot (runOnce) schedule. */
  runOnce?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the unique schedule identifier. */
  scheduleId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the date when the schedule becomes effective. */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the current status of the schedule. */
  status?: InputMaybe<ReportScheduleStatusOperationFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the IANA timezone identifier used to interpret cron times. */
  timeZoneId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the timestamp when the schedule was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the email of the user who last updated the schedule. */
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB document representing a projected report schedule. */
export type ReportScheduleDocumentSortInput = {
  /** Gets the timestamp when the schedule was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Gets the email of the user who created the schedule. */
  createdBy?: InputMaybe<SortEnumType>;
  /** Gets the cron expression defining the schedule frequency. */
  cronExpression?: InputMaybe<SortEnumType>;
  /** Gets the optional order-email doc-type carried opaquely for the executor. */
  docType?: InputMaybe<SortEnumType>;
  /** Gets the authorable Handlebars/HTML email body, or null when not authored. */
  emailBody?: InputMaybe<SortEnumType>;
  /** Gets the authorable Handlebars email subject, or null when not authored. */
  emailSubject?: InputMaybe<SortEnumType>;
  /** Gets the date when the schedule expires. */
  endDate?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether this schedule is active. */
  isActive?: InputMaybe<SortEnumType>;
  /** Gets the last completed run time. */
  lastRunAt?: InputMaybe<SortEnumType>;
  /** Gets the schedule name. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the next scheduled run time. */
  nextRunAt?: InputMaybe<SortEnumType>;
  /** Gets the optional order id carried opaquely for the executor. */
  orderId?: InputMaybe<SortEnumType>;
  /** Gets the optional order number carried opaquely for the executor. */
  orderNumber?: InputMaybe<SortEnumType>;
  /** Gets the output format (e.g. PDF, CSV, EXCEL). */
  outputFormat?: InputMaybe<SortEnumType>;
  /** Gets the JSON blob of report parameters. */
  parameters?: InputMaybe<SortEnumType>;
  /**
   * Gets why the schedule exists: PAY_LINK_RESEND for an invoice email that carries a pay link (a customer's
   * request for a new link, or a staff resend), else UNKNOWN. Set when the schedule is created and never changed
   * by an update.
   */
  purpose?: InputMaybe<SortEnumType>;
  /** Gets the report identifier this schedule is linked to. */
  reportId?: InputMaybe<SortEnumType>;
  /** Gets the optional report template identifier. */
  reportTemplateId?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether this is a one-shot (runOnce) schedule. */
  runOnce?: InputMaybe<SortEnumType>;
  /** Gets the unique schedule identifier. */
  scheduleId?: InputMaybe<SortEnumType>;
  /** Gets the selected tenant sender id, or null when no sender is selected. */
  senderId?: InputMaybe<SortEnumType>;
  /** Gets the date when the schedule becomes effective. */
  startDate?: InputMaybe<SortEnumType>;
  /** Gets the current status of the schedule. */
  status?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Gets the IANA timezone identifier used to interpret cron times. */
  timeZoneId?: InputMaybe<SortEnumType>;
  /** Gets the timestamp when the schedule was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Gets the email of the user who last updated the schedule. */
  updatedBy?: InputMaybe<SortEnumType>;
};

/** Payload returned from report schedule mutations. */
export type ReportSchedulePayload = {
  __typename?: 'ReportSchedulePayload';
  errors?: Maybe<Array<ValidationError>>;
  reportSchedule?: Maybe<ReportScheduleData>;
};

export enum ReportSchedulePurpose {
  PayLinkResend = 'PAY_LINK_RESEND',
  Unknown = 'UNKNOWN'
}

export type ReportSchedulePurposeOperationFilterInput = {
  eq?: InputMaybe<ReportSchedulePurpose>;
  in?: InputMaybe<Array<ReportSchedulePurpose>>;
  neq?: InputMaybe<ReportSchedulePurpose>;
  nin?: InputMaybe<Array<ReportSchedulePurpose>>;
};

export enum ReportScheduleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ReportScheduleStatusOperationFilterInput = {
  eq?: InputMaybe<ReportScheduleStatus>;
  in?: InputMaybe<Array<ReportScheduleStatus>>;
  neq?: InputMaybe<ReportScheduleStatus>;
  nin?: InputMaybe<Array<ReportScheduleStatus>>;
};

/** A connection to a list of items. */
export type ReportSchedulesConnection = {
  __typename?: 'ReportSchedulesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportSchedulesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportScheduleDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportSchedulesEdge = {
  __typename?: 'ReportSchedulesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportScheduleDocument;
};

/**
 * One mailable ship-to location for report generation. The grain is the customer LOCATION, not
 * the customer: a customer with four locations contributes four rows, because a mailing list is
 * a list of addresses. The customer domain has no primary/default location, so there is no
 * non-arbitrary way to collapse these to one row per customer.
 */
export type ReportShipToAddressData = {
  __typename?: 'ReportShipToAddressData';
  /** Gets the customer account number. */
  accountNumber: Scalars['String']['output'];
  /** Gets the first address line. */
  addressLine1: Scalars['String']['output'];
  /** Gets the second address line. */
  addressLine2: Scalars['String']['output'];
  /** Gets the city. */
  city: Scalars['String']['output'];
  /** Gets the ship-to location code. */
  code: Scalars['String']['output'];
  /** Gets the country. */
  country: Scalars['String']['output'];
  /** Gets the customer identifier. */
  customerId: Scalars['String']['output'];
  /** Gets the customer name. */
  customerName: Scalars['String']['output'];
  /** The customer-type id, empty when the customer holds no type. */
  customerTypeId: Scalars['String']['output'];
  /** The customer-type display name, empty when the customer holds no type. */
  customerTypeName: Scalars['String']['output'];
  /** Gets the ship-to location identifier. */
  locationId: Scalars['String']['output'];
  /** Gets the ship-to location name. */
  locationName: Scalars['String']['output'];
  /** Gets the market recorded on the ship-to location. */
  market: Scalars['String']['output'];
  /**
   * Gets the customer's primary-contact phone number (CustomersSummaryDocument.PrimaryContactPhone).
   * Customer-level, not location-level, so every ship-to row for the same customer repeats it.
   * Empty when the customer has no Primary contact, or that contact records no phone.
   * Declared LAST in the record — the raw CSV export arm derives its header row from the row
   * record's declaration order (TabularDataFlattener.ExtractHeaders), so a mid-record
   * insert would shift every column after it (Region, Market, StoreNumber) one to the right in
   * every ds-ship-to-addresses CSV export. Mirrors the append-only rule already applied to the
   * Fields catalog entry in ReportDataSourceSeedService, on a separate ordering path.
   */
  phone: Scalars['String']['output'];
  /** Gets the region recorded on the ship-to location. */
  region: Scalars['String']['output'];
  /**
   * Gets the effective route ("run") for this ship-to: the location's own route, falling back to
   * the customer-level route and then the tenant default. Mirrors
   * MongoCustomerService.GetInheritedRoute.
   */
  route: Scalars['String']['output'];
  /**
   * Gets the effective salesperson email addresses for this ship-to's customer: the per-location
   * projection's list, falling back to the customer-level list. Empty when the tenant has not
   * assigned salespeople (assignment requires an active user holding a Sales role).
   */
  salesPersonEmails: Array<Scalars['String']['output']>;
  /** Gets the state or province. */
  state: Scalars['String']['output'];
  /** Gets the store number recorded on the ship-to location. */
  storeNumber: Scalars['String']['output'];
  /** Gets the addressee recorded on the ship-to address. */
  toName: Scalars['String']['output'];
  /** Gets the postal code. */
  zipcode: Scalars['String']['output'];
};

/** Payload wrapper for the reportShipToAddressesData query. */
export type ReportShipToAddressesDataPayload = {
  __typename?: 'ReportShipToAddressesDataPayload';
  /** The ship-to address rows returned for the current page. */
  data: Array<ReportShipToAddressData>;
  /** The number of rows returned for the current page. */
  totalCount: Scalars['Int']['output'];
  /** The total number of ship-to locations matching the filters before paging. */
  totalMatching: Scalars['Int']['output'];
};

/**
 * One printable shipping label. The grain is a LABEL, not an order: an order prints
 * labelsPerOrder of these (labelIndex 1..N of labelCount), which is how GrowPoint's
 * "number of labels per selection" and its per-order label-count grid are expressed. Property names are the
 * seeded items[].* field ids of ds-shipping-labels — the PWA's generic fetcher builds its
 * selection set from the seed, so the two must agree exactly.
 */
export type ReportShippingLabelRow = {
  __typename?: 'ReportShippingLabelRow';
  /** First line of the billing address. */
  billToAddressLine1: Scalars['String']['output'];
  /** Second line of the billing address; empty when the address has only one. */
  billToAddressLine2: Scalars['String']['output'];
  /** Billing city. */
  billToCity: Scalars['String']['output'];
  /** Billing country. */
  billToCountry: Scalars['String']['output'];
  /**
   * Addressee on the order's billing address, falling back to the customer's name. GrowPoint's "Bill To"
   * block — carried so a label template can print it, not because it is the delivery address.
   */
  billToName: Scalars['String']['output'];
  /** Billing state or province. */
  billToState: Scalars['String']['output'];
  /** Billing postal code. */
  billToZipcode: Scalars['String']['output'];
  /** The order's carrier, if any. */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Identifier of the bill-to customer. */
  customerId: Scalars['String']['output'];
  /** The bill-to customer's name, denormalized on the order read model. */
  customerName: Scalars['String']['output'];
  /** Scannable value unique per label: {orderNumber}-{labelIndex}. */
  labelBarcodeValue: Scalars['String']['output'];
  /** How many labels the order prints — the resolved labelsPerOrder. */
  labelCount: Scalars['Int']['output'];
  /** 1-based position of this label within the order's labels. */
  labelIndex: Scalars['Int']['output'];
  /** The order the label ships with. */
  orderNumber: Scalars['String']['output'];
  /** The customer's P.O. number for the order; empty when none was recorded. */
  poNumber: Scalars['String']['output'];
  /** The order's resolved route ("run"), if any. */
  route?: Maybe<Scalars['String']['output']>;
  /**
   * The order's expected delivery date — the date the label is printed against. Null on an order that
   * never recorded one. Deliberately NOT the actual shipped date, which is still null when a label is
   * printed.
   */
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  /** First line of the ship-from site's address; empty when the site records none. */
  shipFromAddressLine1: Scalars['String']['output'];
  /** Second line of the ship-from site's address. */
  shipFromAddressLine2: Scalars['String']['output'];
  /** Ship-from city. */
  shipFromCity: Scalars['String']['output'];
  /** Ship-from country. */
  shipFromCountry: Scalars['String']['output'];
  /**
   * Name of the order's ship-from site — GrowPoint's "print from-address" block. Falls back to the name
   * denormalized on the order when the site no longer resolves, and is EMPTY on a legacy / pre-V3 order
   * that never captured a structured ship-from site (there is no backfill). WorkSuite records no
   * tenant-level company address, so the shipping origin is the only real from-address available.
   */
  shipFromName: Scalars['String']['output'];
  /** Ship-from state or province. */
  shipFromState: Scalars['String']['output'];
  /** Ship-from postal code. */
  shipFromZipcode: Scalars['String']['output'];
  /** First line of the ship-to address snapshotted onto the order. */
  shipToAddressLine1: Scalars['String']['output'];
  /** Second line of the ship-to address; empty when the address has only one. */
  shipToAddressLine2: Scalars['String']['output'];
  /** Ship-to city. */
  shipToCity: Scalars['String']['output'];
  /** Ship-to country. */
  shipToCountry: Scalars['String']['output'];
  /**
   * Addressee on the ship-to snapshot: the address's own ToName, falling back to the ship-to
   * location's name and then the customer's. A label with a blank addressee is undeliverable.
   */
  shipToName: Scalars['String']['output'];
  /** Ship-to state or province. */
  shipToState: Scalars['String']['output'];
  /** Ship-to postal code. */
  shipToZipcode: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportShippingLabelsData query. TotalCount is the number of label
 * records returned (capped by first, at most 5000); TotalMatching is the number of labels the
 * selection would yield before that cap — matched orders × labelsPerOrder — so a template can render
 * "Showing X of Y" and the builder can prompt the user to narrow the selection.
 */
export type ReportShippingLabelsDataPayload = {
  __typename?: 'ReportShippingLabelsDataPayload';
  data: Array<ReportShippingLabelRow>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/** Input for a worker reporting render progress on a batch. */
export type ReportStatementPrintBatchProgressInput = {
  /** The batch being rendered. */
  printBatchId: Scalars['String']['input'];
  /** How many of the batch's statements are rendered so far. */
  renderedCount: Scalars['Int']['input'];
};

export enum ReportStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ReportStatusOperationFilterInput = {
  eq?: InputMaybe<ReportStatus>;
  in?: InputMaybe<Array<ReportStatus>>;
  neq?: InputMaybe<ReportStatus>;
  nin?: InputMaybe<Array<ReportStatus>>;
};

/** GraphQL data transfer record for a report template. */
export type ReportTemplateData = {
  __typename?: 'ReportTemplateData';
  category: Scalars['String']['output'];
  craftJsTemplate: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  handlebarsTemplate: Scalars['String']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parameters: Scalars['String']['output'];
  status: ReportTemplateStatus;
  tags: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** MongoDB document representing a projected report template. */
export type ReportTemplateDocument = {
  __typename?: 'ReportTemplateDocument';
  category: Scalars['String']['output'];
  craftJsTemplate: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  handlebarsTemplate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /**
   * The page settings, as JSON text, that a report rendered from this template uses. Set for the
   * built-in templates (label templates return their label stock) and null for a template created by a
   * tenant.
   */
  pageSettings?: Maybe<Scalars['String']['output']>;
  parameters: Scalars['String']['output'];
  status: ReportTemplateStatus;
  tags: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** MongoDB document representing a projected report template. */
export type ReportTemplateDocumentFilterInput = {
  and?: InputMaybe<Array<ReportTemplateDocumentFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  craftJsTemplate?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  dataSourceId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  handlebarsTemplate?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportTemplateDocumentFilterInput>>;
  parameters?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ReportTemplateStatusOperationFilterInput>;
  tags?: InputMaybe<StringOperationFilterInput>;
  templateId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB document representing a projected report template. */
export type ReportTemplateDocumentSortInput = {
  category?: InputMaybe<SortEnumType>;
  craftJsTemplate?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  dataSourceId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  handlebarsTemplate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parameters?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tags?: InputMaybe<SortEnumType>;
  templateId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** Payload returned from report template mutations. */
export type ReportTemplatePayload = {
  __typename?: 'ReportTemplatePayload';
  errors?: Maybe<Array<ValidationError>>;
  reportTemplate?: Maybe<ReportTemplateData>;
};

export enum ReportTemplateStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type ReportTemplateStatusOperationFilterInput = {
  eq?: InputMaybe<ReportTemplateStatus>;
  in?: InputMaybe<Array<ReportTemplateStatus>>;
  neq?: InputMaybe<ReportTemplateStatus>;
  nin?: InputMaybe<Array<ReportTemplateStatus>>;
};

/** A connection to a list of items. */
export type ReportTemplatesConnection = {
  __typename?: 'ReportTemplatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportTemplatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportTemplateDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportTemplatesEdge = {
  __typename?: 'ReportTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportTemplateDocument;
};

/**
 * Flattened vendor record for report generation. One row per VendorDocument — the vendor
 * master grain, so a vendor with no purchase orders still appears.
 */
export type ReportVendorData = {
  __typename?: 'ReportVendorData';
  /** The billing address's first street line, empty when the vendor has no billing address. */
  addressLine1: Scalars['String']['output'];
  /** The billing address's second street line, empty when absent or when the vendor has no billing address. */
  addressLine2: Scalars['String']['output'];
  /** The billing address's city, empty when the vendor has no billing address. */
  city: Scalars['String']['output'];
  /** The billing address's country, empty when the vendor has no billing address. */
  country: Scalars['String']['output'];
  /** The vendor's free-text description, empty when none was recorded. */
  description: Scalars['String']['output'];
  /**
   * When the vendor record last changed. Optional because the read model only carries it for
   * vendors written since the field existed — rendered blank rather than as an epoch date.
   */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** The vendor's display name — what the Name sort orders on. */
  name: Scalars['String']['output'];
  /** The billing address's state or province — what the State sort orders on. */
  stateProvince: Scalars['String']['output'];
  /** The vendor's status as its enum name — Active or Inactive. */
  status: Scalars['String']['output'];
  /** The billing address's attention line, empty when the vendor has no billing address. */
  toName: Scalars['String']['output'];
  /**
   * The vendor CODE — VendorDocument.ErpId. GrowPoint's "Vendor Code", and what the
   * vendorCode filter and the Code sort both address.
   */
  vendorCode: Scalars['String']['output'];
  /** The vendor's entity id — stable across renames, unlike the vendor code. */
  vendorId: Scalars['String']['output'];
  /** The billing address's postal code, empty when the vendor has no billing address. */
  zipcode: Scalars['String']['output'];
};

/**
 * Flattened vendor purchase order record for report generation. One row per
 * VendorPurchaseOrderDocument under the default Summary grain, or one row per PO LINE
 * (header columns repeated) under the Detail grain selected by the reportType parameter.
 * Status is rendered as the enum name (e.g. "Confirmed") so PDF/CSV/XLSX exports show
 * human-readable values. The line-VALUE columns are nullable and null on every Summary row; the
 * purchase-order BAND members appended after them are non-nullable and read false / 0
 * off the Detail grain. Both sets are additive, so consumers built against the original nine columns
 * are unaffected.
 */
export type ReportVendorPurchaseOrderData = {
  __typename?: 'ReportVendorPurchaseOrderData';
  /** Signed order-level charges; discounts are negative. */
  charges: Array<ReportPurchaseOrderChargeData>;
  /**
   * The material item's description, read from the material item read model (Detail grain only).
   * wsapi models no "common name"; this is the nearest distinct descriptive text.
   */
  commonName?: Maybe<Scalars['String']['output']>;
  /** Ordered eaches times per-each cost over the whole purchase order. */
  estimatedSubtotal?: Maybe<Scalars['Decimal']['output']>;
  /** Estimated subtotal plus signed charges. */
  estimatedTotal?: Maybe<Scalars['Decimal']['output']>;
  /**
   * True on the FIRST line of each purchase order's run — the purchase-order band's header marker.
   * Stamped on the Detail grain only; always false on a Summary row, which already is one order.
   */
  firstOfPurchaseOrder: Scalars['Boolean']['output'];
  isUrgent: Scalars['Boolean']['output'];
  /** False when the eaches are not a whole number of packs (Detail grain only). */
  isWholeVendorQuantity?: Maybe<Scalars['Boolean']['output']>;
  /** The line's item code — the material item's ERP id (Detail grain only). */
  itemCode?: Maybe<Scalars['String']['output']>;
  /** The line's item description — the material item name as ordered (Detail grain only). */
  itemDescription?: Maybe<Scalars['String']['output']>;
  /** Material name captured on the purchase order line. */
  itemName?: Maybe<Scalars['String']['output']>;
  /**
   * True on the LAST line of each purchase order's run — gates the band's subtotal row. Detail grain
   * only, as firstOfPurchaseOrder.
   */
  lastOfPurchaseOrder: Scalars['Boolean']['output'];
  /** The PO line's number (Detail grain only). */
  lineNumber?: Maybe<Scalars['Int']['output']>;
  /** Ordered eaches times per-each unit cost. */
  lineTotal?: Maybe<Scalars['Decimal']['output']>;
  locationId: Scalars['String']['output'];
  /** The requested delivery date. */
  needByDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The order header note intended for the vendor. */
  noteToVendor?: Maybe<Scalars['String']['output']>;
  orderDate: Scalars['DateTime']['output'];
  poId: Scalars['String']['output'];
  poNumber: Scalars['String']['output'];
  /** quantityOrdered summed over this line's purchase order. Zero off the Detail grain. */
  purchaseOrderQuantityOrderedTotal: Scalars['Decimal']['output'];
  /** quantityReceived summed over this line's purchase order. Zero off the Detail grain. */
  purchaseOrderQuantityReceivedTotal: Scalars['Decimal']['output'];
  /** quantityRemaining summed over this line's purchase order. Zero off the Detail grain. */
  purchaseOrderQuantityRemainingTotal: Scalars['Decimal']['output'];
  /** Quality notes recorded on the line at receiving (Detail grain only). */
  qualityNotes?: Maybe<Scalars['String']['output']>;
  /** Quantity ordered on the line (Detail grain only). */
  quantityOrdered?: Maybe<Scalars['Decimal']['output']>;
  /** Quantity received against the line so far (Detail grain only). */
  quantityReceived?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Quantity still outstanding on the line — ordered minus received, clamped at zero (Detail grain
   * only). Appended after the original line columns: saved reports bind columns by path.
   */
  quantityRemaining?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The ordered quantity with its unit, as the purchase order prints it (476.37 cu yd; 2,773 ea).
   * Detail grain only. A combined line is this one quantity; jobs are not printed.
   */
  quantityWithUnit?: Maybe<Scalars['String']['output']>;
  /** Shipping postal address, falling back to the site address. */
  shipToAddress?: Maybe<Scalars['String']['output']>;
  /** Shipping addressee, falling back to the site name. */
  shipToName?: Maybe<Scalars['String']['output']>;
  /** ISO week number derived from the need-by date. */
  shipWeekIsoWeek?: Maybe<Scalars['Int']['output']>;
  /** ISO week year derived from the need-by date. */
  shipWeekIsoYear?: Maybe<Scalars['Int']['output']>;
  /** Shortage notes recorded on the line at receiving (Detail grain only). */
  shortageNotes?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalLineItems: Scalars['Int']['output'];
  /** The line material's short unit label in English (ea, cu yd). Each when the material names none. Detail grain only. */
  unit?: Maybe<Scalars['String']['output']>;
  /** Per-each unit cost; empty on uncosted lines. */
  unitCost?: Maybe<Scalars['Decimal']['output']>;
  /** Unit cost per vendor unit, or per each when no pack is assigned. */
  unitCostPerVendorUom?: Maybe<Scalars['Decimal']['output']>;
  /** The line material's short unit label in Spanish. Each when the material names none. Detail grain only. */
  unitEs?: Maybe<Scalars['String']['output']>;
  /** The line material's unit name in English (each, cubic yard). Each when the material names none. Detail grain only. */
  unitName?: Maybe<Scalars['String']['output']>;
  /** The line material's unit name in Spanish. Each when the material names none. Detail grain only. */
  unitNameEs?: Maybe<Scalars['String']['output']>;
  /** How many of the material's units make up one vendor pack, which may be decimal (7.11 cu yd per bale) (Detail grain only; empty when no pack). */
  unitsPerVendorUom?: Maybe<Scalars['Decimal']['output']>;
  /** Vendor billing postal address. */
  vendorAddress?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
  /** Vendor item code from the matching vendor link, falling back to the captured material code. */
  vendorItemCode?: Maybe<Scalars['String']['output']>;
  vendorName: Scalars['String']['output'];
  /** Quantity ordered in whole vendor packs, rounded up; the eaches when no pack (Detail grain only). */
  vendorQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The PO vendor's pack name on the material (Detail grain only; empty when no pack). */
  vendorUom?: Maybe<Scalars['String']['output']>;
};

/**
 * Payload wrapper for the reportVendorPurchaseOrdersData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of PURCHASE ORDERS matching the filters — in the
 * Detail grain the rows are lines, so TotalCount can exceed TotalMatching; when the PO page was capped
 * (more POs matched than were read) the client should prompt the user to narrow their filters.
 */
export type ReportVendorPurchaseOrdersDataPayload = {
  __typename?: 'ReportVendorPurchaseOrdersDataPayload';
  data: Array<ReportVendorPurchaseOrderData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * Per-vendor spend rollup for strategic sourcing reports. One row per distinct vendor
 * (keyed by VendorPurchaseOrderDocument.ErpId).
 *
 * Field coverage caveat: The current VendorPurchaseOrderDocument projection does
 * not carry per-line-item unit cost, expected delivery date, or per-PO receipt-completed date.
 * Until the projection is enriched (tracked as a follow-up task), the financial and SLA fields
 * — totalSpend, avgPoSize, onTimeReceiptCount, lateReceiptCount,
 * onTimePercent, and avgLeadTimeDays — are returned as null so the PWA
 * Report Builder can distinguish "data not yet available" from a legitimate zero. The schema
 * surface is stable; downstream rollouts will turn the nulls into live values once the
 * projection lands the source fields.
 */
export type ReportVendorSpendData = {
  __typename?: 'ReportVendorSpendData';
  /**
   * Average lead time in days between order placed and receipt completed. null
   * until the projection carries PO-level received-completed date.
   */
  avgLeadTimeDays?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Average PO value (= TotalSpend / PoCount). null until
   * TotalSpend is populated by the projection enrichment task.
   */
  avgPoSize?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Number of POs received after their expected delivery date. null until the
   * projection carries expected delivery date and PO-level receipt-completed date.
   */
  lateReceiptCount?: Maybe<Scalars['Int']['output']>;
  /**
   * On-time receipt percentage in the 0–100 range. null until
   * OnTimeReceiptCount and LateReceiptCount are populated.
   */
  onTimePercent?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Number of POs received on or before their expected delivery date. null until the
   * projection carries expected delivery date and PO-level receipt-completed date.
   */
  onTimeReceiptCount?: Maybe<Scalars['Int']['output']>;
  /** Number of purchase orders for the vendor in the filtered window. */
  poCount: Scalars['Int']['output'];
  /** Total line items across all rolled-up POs for the vendor. */
  totalLineItems: Scalars['Int']['output'];
  /**
   * Sum of vendor-side spend across the rolled-up POs. null until the projection
   * enrichment task lands per-line-item unit cost; a real zero (e.g., all POs cancelled
   * before invoicing) and "not yet available" must be distinguishable for the PWA Report
   * Builder.
   */
  totalSpend?: Maybe<Scalars['Decimal']['output']>;
  /** Vendor ERP identifier (matches VendorPurchaseOrderDocument.ErpId). */
  vendorId: Scalars['String']['output'];
  /** Vendor display name as denormalised on the most recent PO for the vendor. */
  vendorName: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportVendorSpendData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of vendor rollup rows matching the filters —
 * when TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportVendorSpendDataPayload = {
  __typename?: 'ReportVendorSpendDataPayload';
  data: Array<ReportVendorSpendData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /** The report's grand-total row, one entry per summable column, summed over the rows this page returned. Empty when no rows matched. */
  totals: Array<ReportColumnTotal>;
};

/**
 * Payload wrapper for the reportVendorsData query. TotalCount is the number of records returned
 * (capped at ReportDataSourceConstants.MaxReportRows).
 * TotalMatching is the total number of records matching the filters — when TotalMatching > TotalCount,
 * the client should prompt the user to narrow their filters.
 */
export type ReportVendorsDataPayload = {
  __typename?: 'ReportVendorsDataPayload';
  data: Array<ReportVendorData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
};

/**
 * A single version of a report, derived on-demand from the report's KurrentDB event stream. Each
 * record corresponds to one full-snapshot event (creation or update) stored for the report, and
 * carries the complete snapshot so the UI can preview or diff a version without a second call.
 */
export type ReportVersionRecord = {
  __typename?: 'ReportVersionRecord';
  /** The Craft.js layout template at this version. */
  craftJsTemplate: Scalars['String']['output'];
  /** The data source bound to the report at this version. */
  dataSourceId: Scalars['String']['output'];
  /** The report description at this version. */
  description: Scalars['String']['output'];
  /** The unique event identifier from the event store. */
  eventId: Scalars['String']['output'];
  /** The domain event type name (e.g. "V1.ReportUpdated"). */
  eventType: Scalars['String']['output'];
  /** The saved filters (JSON) at this version. */
  filters: Scalars['String']['output'];
  /** The folder the report lived in at this version, if any. */
  folderId?: Maybe<Scalars['String']['output']>;
  /** The compiled Handlebars template at this version. */
  handlebarsTemplate: Scalars['String']['output'];
  /** Whether the report was starred at this version. */
  isStarred: Scalars['Boolean']['output'];
  /** The report name at this version. */
  name: Scalars['String']['output'];
  /** The page settings (JSON) at this version. */
  pageSettings: Scalars['String']['output'];
  /** The parameter configuration (JSON) at this version. */
  parameterConfig: Scalars['String']['output'];
  /** The saved parameter values (JSON) at this version. */
  parameterValues: Scalars['String']['output'];
  /** The spreadsheet columns (JSON) at this version; [] for none. */
  spreadsheetColumns: Scalars['String']['output'];
  /** When this version was recorded. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user (email) that authored this version. */
  updatedBy: Scalars['String']['output'];
  /** The event-stream revision that identifies this version; pass it to revertReport. */
  version: Scalars['Long']['output'];
};

/** Flattened work order record for report generation. One row per WorkOrder document. */
export type ReportWorkOrderData = {
  __typename?: 'ReportWorkOrderData';
  activityCode: Scalars['String']['output'];
  containerQuantity: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  /** Whether this row opens a job band. Only ever set under the JobThenLine sort. */
  firstOfJob: Scalars['Boolean']['output'];
  jobId: Scalars['String']['output'];
  /** The band's summed planned quantity, repeated on each of its rows; zero outside a band. */
  jobPlannedQuantityTotal: Scalars['Int']['output'];
  /** The band's summed quantity produced, repeated on each of its rows; zero outside a band. */
  jobQuantityProducedTotal: Scalars['Int']['output'];
  /** Whether this row closes a job band. Only ever set under the JobThenLine sort. */
  lastOfJob: Scalars['Boolean']['output'];
  lineNumber: Scalars['Int']['output'];
  plannedQuantity: Scalars['Int']['output'];
  productionPhaseCode: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  quantityProduced: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workOrderId: Scalars['String']['output'];
};

/**
 * Payload wrapper for the reportWorkOrdersData query. TotalCount is the number of records returned
 * (capped at 5000). TotalMatching is the total number of records matching the filters - when
 * TotalMatching > TotalCount, the client should prompt the user to narrow their filters.
 */
export type ReportWorkOrdersDataPayload = {
  __typename?: 'ReportWorkOrdersDataPayload';
  data: Array<ReportWorkOrderData>;
  totalCount: Scalars['Int']['output'];
  totalMatching: Scalars['Int']['output'];
  /**
   * The report's grand total, one entry per column the source declares summable. Empty when the
   * page matched nothing.
   */
  totals: Array<ReportColumnTotal>;
};

/** A connection to a list of items. */
export type ReportsByAppTagConnection = {
  __typename?: 'ReportsByAppTagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportsByAppTagEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportsByAppTagEdge = {
  __typename?: 'ReportsByAppTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportDocument;
};

/** A connection to a list of items. */
export type ReportsConnection = {
  __typename?: 'ReportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportsEdge = {
  __typename?: 'ReportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportDocument;
};

export type RepriceOrderInput = {
  orderId: Scalars['String']['input'];
};

export type RepriceOrderLineInput = {
  lineItemId: Scalars['UUID']['input'];
  orderId: Scalars['String']['input'];
};

/** What repriceOrderLine did to the line it was asked to reprice. */
export enum RepriceOrderLineOutcome {
  /** Price resolution moved the line to a new price. */
  Repriced = 'REPRICED',
  /** The line carries an override price, which reprice never sets or clears. Nothing ran. */
  SkippedOverridePrice = 'SKIPPED_OVERRIDE_PRICE',
  /**
   * Price resolution ran and the line kept its price — it is already at its contract price, or no
   * price level resolved one (a zero resolution never overwrites a price).
   */
  Unchanged = 'UNCHANGED'
}

/**
 * Payload for repriceOrderLine: the order after the reprice (the same shape every order
 * mutation returns), the repriced line from that order, and what happened to it. On failure all
 * three are null and errors is populated.
 */
export type RepriceOrderLinePayload = {
  __typename?: 'RepriceOrderLinePayload';
  errors?: Maybe<Array<ValidationError>>;
  lineItem?: Maybe<LineItemData>;
  order?: Maybe<OrderStateData>;
  outcome?: Maybe<RepriceOrderLineOutcome>;
};

/**
 * Payload for repriceOrder: the order after the reprice (the same shape every order mutation returns) and how
 * many of its lines were repriced, kept their price, or were skipped because they carry an override price. On
 * failure the order and the counts are null and errors is populated.
 */
export type RepriceOrderPayload = {
  __typename?: 'RepriceOrderPayload';
  errors?: Maybe<Array<ValidationError>>;
  order?: Maybe<OrderStateData>;
  repricedLineCount?: Maybe<Scalars['Int']['output']>;
  skippedOverrideLineCount?: Maybe<Scalars['Int']['output']>;
  unchangedLineCount?: Maybe<Scalars['Int']['output']>;
};

export type RequestAllocationInput = {
  allocationId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  requiredQty: Scalars['Decimal']['input'];
  targetLocationId: Scalars['String']['input'];
};

/** Input to requestBackgroundJob: one user action to run in the background. */
export type RequestBackgroundJobInput = {
  /**
   * The items to handle, in order. At least one, and no more than 10,000; send an empty list when
   * lotChanges names the lots instead.
   */
  items: Array<RequestBackgroundJobItemInput>;
  /**
   * For a JOB_EVENTS_ADD or JOB_EVENTS_REMOVE job, a selector the server resolves to one item per
   * production job when the job is requested (the jobs listed, or the Production Schedule's filter for Select All,
   * with no 2,000 cap). The server then sets the title ("Add event: 1,240 jobs") and fills items; send either items
   * or a selector.
   */
  jobEvents?: InputMaybe<JobEventsSelectorInput>;
  /** The id the screen reserved for this action, a GUID. Sending the same id again returns the job already stored. */
  jobId: Scalars['String']['input'];
  /**
   * For a LOT_CHANGES job, a selector the server resolves to one item per lot when the job is requested (the
   * lots listed, or the Production Schedule's filter for Select All, with no 2,000 cap). The server then sets the
   * title ("Change customer: 122 lots") and fills items; send either items or a selector.
   */
  lotChanges?: InputMaybe<LotChangesSelectorInput>;
  /**
   * For a LOT_DEACTIVATE job, the lots (or the schedule's filter) to deactivate, resolved to one item per lot when
   * the job is requested. Or send items, one per lot.
   */
  lotDeactivate?: InputMaybe<LotDeactivateSelectorInput>;
  /**
   * For a LOT_WEEK_OVERRIDES job, the lots (or the schedule's filter) whose jobs move to the given weeks, resolved
   * to one item per lot when the job is requested. Or send items, one per lot, each naming its jobs and their weeks.
   */
  lotWeekOverrides?: InputMaybe<LotWeekOverridesSelectorInput>;
  /** The screen route the job is started from. */
  sourceRoute: Scalars['String']['input'];
  /** The label the job queue shows. */
  title: Scalars['String']['input'];
  /** What the job does. */
  type: BackgroundJobType;
};

/** One item of requestBackgroundJob. */
export type RequestBackgroundJobItemInput = {
  /** The item's id, unique within the job. */
  itemId: Scalars['String']['input'];
  /** What the item's row shows. */
  label: Scalars['String']['input'];
  /** The order the item touches, if any. Two jobs touching one order never run at once. */
  orderKey?: InputMaybe<Scalars['String']['input']>;
  /** The type-specific input, as a JSON text. */
  payloadJson: Scalars['String']['input'];
};

/** Input to requestBulkOrderDelete: the orders to delete in the background. */
export type RequestBulkOrderDeleteInput = {
  /**
   * The orders to delete. Repeated ids are collapsed, keeping first-seen order. At least one, and no more than
   * the tenant's MaxOrdersPerJob (default 10,000); otherwise the whole request is refused.
   */
  orderIds: Array<Scalars['String']['input']>;
};

export type RequestEarlyAccessInput = {
  flag: FeatureFlagName;
};

/** Result of requestEarlyAccess. */
export type RequestEarlyAccessPayload = {
  __typename?: 'RequestEarlyAccessPayload';
  /** Why the request was refused, each with a code; null when it succeeded. */
  errors?: Maybe<Array<ValidationError>>;
  /** True once the request is on record, including on a repeat. */
  requestedByMe: Scalars['Boolean']['output'];
};

/** Input for requestFreightQuoteSend. */
export type RequestFreightQuoteSendInput = {
  /** The load whose Freight Quote to send to its carrier. */
  loadId: Scalars['ID']['input'];
  /** A note added under the email's short fixed message. Null or blank adds none. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** One address to send to instead of the carrier's contact email. Null or blank sends to the carrier's. */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Result of requestFreightQuoteSend. */
export type RequestFreightQuoteSendPayload = {
  __typename?: 'RequestFreightQuoteSendPayload';
  /** Why the request was refused, each with a code; nothing was reserved when present. */
  errors?: Maybe<Array<ValidationError>>;
  /** The send the request reserved or re-requested; null when it was refused. */
  send?: Maybe<FreightQuoteSend>;
};

/** The answer to every pay-link resend request. */
export type RequestInvoicePayLinkResendPayload = {
  __typename?: 'RequestInvoicePayLinkResendPayload';
  /** Always true. The answer never says whether an email was sent. */
  accepted: Scalars['Boolean']['output'];
};

/**
 * Input for requestMyPhoneVerification. The number only. Whose account it is verified against
 * comes from the token.
 */
export type RequestMyPhoneVerificationInput = {
  /**
   * The number to verify, in strict E.164 (+15025550134). This is the storage form Twilio is
   * handed directly, not the US display form the rest of WorkSuite accepts for contacts.
   */
  phoneNumber: Scalars['String']['input'];
};

/** Input for requestPlannedArrivalNotices. */
export type RequestPlannedArrivalNoticesInput = {
  /** The load whose stops to notify. */
  loadId: Scalars['String']['input'];
  /** The stops to notify. A repeated stop id counts once, with its first entry. */
  stops: Array<PlannedArrivalNoticeStopInput>;
};

/** Result of requestPlannedArrivalNotices. */
export type RequestPlannedArrivalNoticesPayload = {
  __typename?: 'RequestPlannedArrivalNoticesPayload';
  /** Request-level failures, such as KIND_DISABLED; nothing is reserved when present. */
  errors?: Maybe<Array<ValidationError>>;
  /** One result per distinct requested stop. */
  results: Array<PlannedArrivalNoticeStopResult>;
};

export type RequestRampPurchaseOrderCopyInput = {
  purchaseOrderId: Scalars['String']['input'];
};

export type RequestRestockCalculationInput = {
  itemIds: Array<Scalars['String']['input']>;
  locationIds: Array<Scalars['String']['input']>;
  /** @deprecated Never consumed; ignored by the server. Will be removed with the DEL2 client cutover. */
  merge?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId: Scalars['String']['input'];
};

/**
 * Optional scope for the dashboard refresh. Both lists null/empty triggers a tenant-wide
 * recalc. When both are populated the filter is the intersection (item AND location must
 * match) — matching what a dashboard user would expect after filtering by both axes.
 */
export type RequestRestockDashboardRecalcInput = {
  itemCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Input for requesting a print batch. The company is taken from the authenticated user, never from
 * the input.
 */
export type RequestStatementPrintBatchInput = {
  /** The completed statement run to print. */
  statementRunId: Scalars['String']['input'];
};

export type RequestTenantEmailSenderVerificationInput = {
  senderId: Scalars['String']['input'];
};

/** Anonymous input to request an email-verification code. */
export type RequestTrialSignupVerificationInput = {
  email: Scalars['String']['input'];
};

/**
 * Uniform response to requestTrialSignupVerification. sent is true
 * whenever a code was issued; it never reveals whether the address is already associated with a
 * tenant.
 */
export type RequestTrialSignupVerificationPayload = {
  __typename?: 'RequestTrialSignupVerificationPayload';
  errors?: Maybe<Array<ValidationError>>;
  sent: Scalars['Boolean']['output'];
};

/** Input to resendInvoiceEmail. */
export type ResendInvoiceEmailInput = {
  /** The issued invoice to email again, with a pay link. */
  invoiceId: Scalars['String']['input'];
};

/** Payload of resendInvoiceEmail. */
export type ResendInvoiceEmailPayload = {
  __typename?: 'ResendInvoiceEmailPayload';
  /**
   * Why there is no result: a portal caller, an invoice this tenant has not issued, or a read or write that failed, a
   * store outage for example. A link that cannot be made is SUPPRESSED, not an error.
   */
  errors?: Maybe<Array<ValidationError>>;
  /** What the resend did; null when the request was refused or could not complete. */
  result?: Maybe<InvoiceEmailResendResult>;
};

export type ResendUserInviteInput = {
  inviteId: Scalars['String']['input'];
};

export enum ReserveRuleLevel {
  Category = 'CATEGORY',
  Item = 'ITEM',
  ProductGroup = 'PRODUCT_GROUP',
  Program = 'PROGRAM',
  SubCategory = 'SUB_CATEGORY',
  Unknown = 'UNKNOWN'
}

export type ReserveRuleLevelOperationFilterInput = {
  eq?: InputMaybe<ReserveRuleLevel>;
  in?: InputMaybe<Array<ReserveRuleLevel>>;
  neq?: InputMaybe<ReserveRuleLevel>;
  nin?: InputMaybe<Array<ReserveRuleLevel>>;
};

export enum ReserveRuleMode {
  Allocate = 'ALLOCATE',
  Reserve = 'RESERVE',
  Unknown = 'UNKNOWN'
}

export type ReserveRuleModeOperationFilterInput = {
  eq?: InputMaybe<ReserveRuleMode>;
  in?: InputMaybe<Array<ReserveRuleMode>>;
  neq?: InputMaybe<ReserveRuleMode>;
  nin?: InputMaybe<Array<ReserveRuleMode>>;
};

export type ReserveRulePayload = {
  __typename?: 'ReserveRulePayload';
  errors?: Maybe<Array<ValidationError>>;
  reserveRule?: Maybe<ReserveRuleStateData>;
};

export type ReserveRuleStateData = {
  __typename?: 'ReserveRuleStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  level: ReserveRuleLevel;
  linkedItemIds: Array<Scalars['String']['output']>;
  linkedLocationIds: Array<Scalars['String']['output']>;
  mode: ReserveRuleMode;
  name: Scalars['String']['output'];
  percentage: Scalars['Decimal']['output'];
  reserveRuleId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: ReserveRuleStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum ReserveRuleStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type ResetAcknowledgmentEmailInput = {
  endInitializationDate?: InputMaybe<Scalars['DateTime']['input']>;
  startInitializationDate: Scalars['DateTime']['input'];
};

export type ResetConfirmationEmailInput = {
  endInitializationDate?: InputMaybe<Scalars['DateTime']['input']>;
  startInitializationDate: Scalars['DateTime']['input'];
};

export type ResetSyncStatusInput = {
  orderIds: Array<Scalars['String']['input']>;
};

/**
 * Boundary input for resetUserLogin: the directory user whose FusionAuth login is being
 * reset, plus the replacement invite's expiry and FusionAuth application registrations — the SAME
 * two knobs createUserInvite carries, so the recovery invite is shaped exactly like an
 * ordinary tenant invite. There is deliberately NO recipient email: it is read from the target
 * directory row, so a reset can never redirect a user's login to a different address, and no
 * linkedUserId beyond the target, so a reset can never fork the row. Single-use boundary
 * input per the command/read-model type-isolation convention; named without a Data suffix
 * so HotChocolate emits ResetUserLoginInput, matching the sibling CreateUserInviteInput
 * the PWA already codegens against.
 */
export type ResetUserLoginInput = {
  expiresInDays: Scalars['Int']['input'];
  registrations: Array<UserInviteRegistrationDataInput>;
  userId: Scalars['String']['input'];
};

export type ResetWorkOrderQuantityProducedInput = {
  jobId: Scalars['String']['input'];
  workOrderId: Scalars['String']['input'];
};

export type ResetWorkerConfigRunNowInput = {
  configName: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type ResetWsapiImportRunNowInput = {
  wsapiImportId: Scalars['String']['input'];
};

export type ResolveDuplicateCandidateInput = {
  id: Scalars['String']['input'];
  outcome: DuplicateCandidateOutcome;
};

/**
 * GraphQL input for resolveErpWriteBack: the record, what NAV shows for it, and a note on what was
 * checked. The tenant is taken from the authenticated user, never the input.
 */
export type ResolveErpWriteBackInput = {
  erpWriteBackId: Scalars['String']['input'];
  navShows: ErpWriteBackNavCheck;
  note: Scalars['String']['input'];
};

/** The exception to mark resolved by hand, and how it was resolved. */
export type ResolveOnlinePaymentExceptionInput = {
  /** The exception's id. */
  exceptionId: Scalars['String']['input'];
  /** How it was resolved. Required. */
  note: Scalars['String']['input'];
};

/** The result of marking an exception resolved by hand. */
export type ResolveOnlinePaymentExceptionPayload = {
  __typename?: 'ResolveOnlinePaymentExceptionPayload';
  /** Why it was refused, when it was. */
  errors?: Maybe<Array<ValidationError>>;
  /** The exception as it stands after; null on error. */
  exception?: Maybe<OnlinePaymentException>;
};

/** Superadmin input to resolve a pending trial request. */
export type ResolveTrialRequestInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  resolution: TrialRequestResolution;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for resolveUncertainLoadEmail. */
export type ResolveUncertainLoadEmailInput = {
  /** The Uncertain row to close. */
  reservationId: Scalars['String']['input'];
  /** MARK_SENT or MARK_FAILED. */
  resolution: LoadEmailResolution;
};

export type ResolvedEventData = {
  __typename?: 'ResolvedEventData';
  event: EventRecordData;
  isResolved: Scalars['Boolean']['output'];
  link?: Maybe<EventRecordData>;
  originalEventNumber: Scalars['Long']['output'];
  originalPosition?: Maybe<PositionData>;
  originalStreamId: Scalars['String']['output'];
};

/** The resolved price group and which tier of the Location → Customer → Default hierarchy supplied it. */
export type ResolvedPriceGroup = {
  __typename?: 'ResolvedPriceGroup';
  name: Scalars['String']['output'];
  priceGroupId: Scalars['String']['output'];
  source: PriceGroupSource;
};

/**
 * Where revenue posts, and which precedence rung decided it. Selected on an invoice line
 * (revenueAccount) and on the invoice header (revenueAccountSummary) by the outbound QuickBooks
 * export, which GL-codes the document from it rather than re-deriving the routing itself.
 *
 *
 * remoteId is the QuickBooks-native account id and is null exactly when rung is UNMAPPED — nothing
 * resolved at any rung, and the exported document carries no account. importId is the
 * WorkSuite-side stable id of the same account. rung is never null: UNMAPPED is a reading, not an
 * absence.
 */
export type ResolvedRevenueAccount = {
  __typename?: 'ResolvedRevenueAccount';
  /**
   * The Chart-of-Accounts row the winning rung resolved to, inlined. Null when rung is UNMAPPED.
   * Already loaded while the ladder ran, so selecting it costs no extra read.
   */
  account?: Maybe<MergeDevAccountDocument>;
  /**
   * The categories that disagreed, when the item sat in two or more mapped categories pointing
   * at DIFFERENT accounts. The category rung is skipped in that case and routing falls to the
   * tenant default, so these ids are the configuration to fix — and the link from the routing
   * card back to the items. Empty whenever the category rung applied cleanly or did not apply.
   */
  conflictingCategoryIds: Array<Scalars['String']['output']>;
  /**
   * The WorkSuite-side stable id (the accounting sync's document id) of the same account. Null
   * when rung is UNMAPPED, and on a legacy account imported before import ids existed.
   */
  importId?: Maybe<Scalars['String']['output']>;
  /**
   * The QuickBooks-native account remote id the winning rung resolved to. Null when rung is
   * UNMAPPED, and null on an account synced before remote ids were recorded.
   */
  remoteId?: Maybe<Scalars['String']['output']>;
  /**
   * Which precedence rung supplied the account: CUSTOMER_TYPE, ITEM, CATEGORY, TENANT_DEFAULT,
   * or UNMAPPED when none did. Never MIXED — that is an invoice-wide roll-up over lines that
   * resolved differently, which one line or one summary cannot be.
   */
  rung: MergeDevRevenueRung;
  /**
   * Every archived account this resolution stepped over, named with the rung that offered it.
   * An archived account is never a routing source — posting to one fails at QuickBooks — so it
   * is skipped and surfaced here rather than discovered from a failed export.
   */
  staleMappings: Array<StaleRevenueMapping>;
};

/**
 * The effective space capacity resolved for a sub-location, space type and ISO week, and the location that
 * holds it.
 */
export type ResolvedSpaceCapacity = {
  __typename?: 'ResolvedSpaceCapacity';
  amount: Scalars['Decimal']['output'];
  /**
   * The location whose capacity this is: the outermost of the sub-location and its ancestors with capacity of
   * its own for the week (the house for a bay under it), else the sub-location itself.
   */
  creditedSubLocationId: Scalars['String']['output'];
  /** The credited location's name; null when it is not a live sub-location of the site. */
  creditedSubLocationName?: Maybe<Scalars['String']['output']>;
  reliefFraction: Scalars['Decimal']['output'];
  source: SpaceCapacitySource;
};

/**
 * Component breakdown of RestockDashboardStoreRowData.AllocationReason.
 * Surfaced alongside the resolved reason so the PWA breakdown dialog can show *why* a
 * store landed where it did (which tier, which threshold, how stale the last delivery,
 * what the decayed sales signal looked like) without recomputing on the client.
 * Sibling of RestockIndexBreakdownData for the legacy S27 score —
 * intentionally separate so the two grids can show both during the parity cutover.
 */
export type RestockAllocationBreakdownData = {
  __typename?: 'RestockAllocationBreakdownData';
  /**
   * Trailing decayed sales sum — Layer 1 of the spec. Same value carried on the row's
   * RestockDashboardStoreRowData.DecayedScore; included here so the
   * dialog displays a self-contained snapshot. Null when no underlying
   * DailyTransactionSummaries rows exist for the store, matching
   * RestockDashboardStoreRowData.DecayedScore semantics.
   */
  decayedScore?: Maybe<Scalars['Decimal']['output']>;
  /** Half-life used for the decay calculation (currently fixed by configuration; surfaced for audit). */
  halfLifeDays: Scalars['Int']['output'];
  /** Most recent delivery date observed in the lookup window. Null when none. */
  lastDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Lookback window applied to DecayedScore (currently fixed by configuration; surfaced for audit). */
  lookbackDays: Scalars['Int']['output'];
  /** The resolved classification — duplicated from the row for dialog self-containment. */
  reason: RestockAllocationReason;
  /**
   * Tier-derived weeks-since-ship cutoff. A store at or above this for its tier is
   * forced into RestockAllocationReason.Mandatory.
   */
  thresholdWeeks: Scalars['Int']['output'];
  /**
   * Resolved store tier (StoreClass) used for the threshold lookup. Always a
   * non-empty string — a null/blank StoreClass on the underlying row is
   * normalized to "Unranked" before the breakdown is built.
   */
  tier: Scalars['String']['output'];
  /**
   * Floor-division weeks since this store's most recent delivery in the lookup window.
   * Null when no delivery is on record in the window (treated as
   * RestockAllocationReason.Excluded regardless of tier).
   */
  weeksSinceShip?: Maybe<Scalars['Int']['output']>;
};

/**
 * A read-only allocation proposal for one item across the selected session stores. Calculating it wrote
 * nothing. To save it, send the reviewed quantities to autoAllocateRestockSessionOrderQuantities.
 */
export type RestockAllocationPreviewData = {
  __typename?: 'RestockAllocationPreviewData';
  /** The item the proposal allocates. */
  itemId: Scalars['String']['output'];
  /** The proposal, with one allocation for each selected store, in the same shape and with the same values allocateRestockSessionInventory returns for the same source and settings. */
  result: AllocationResultData;
  /** The session the proposal was calculated for. */
  sessionId: Scalars['String']['output'];
  /** Null when no reviewedSourceToken was sent. True when the source differs from the reviewed preview, so this new proposal needs review before Apply. False when it is unchanged. This is checked when the preview runs and is not a lock: the source can still change before Apply. */
  sourceChanged?: Maybe<Scalars['Boolean']['output']>;
  /** A fingerprint of the settings and of the source the proposal was calculated from: the selected stores, their planning values and the available pool. Send it back as reviewedSourceToken to learn whether the source changed. */
  sourceToken: Scalars['String']['output'];
  /** The station saved on the session, which chose the site and its ERP availability. Empty when the session has no station and exactly one site carries an empty code. */
  stationCode: Scalars['String']['output'];
};

export type RestockAllocationPreviewInput = {
  allocationType: AllocationType;
  availability?: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  mode?: AllocationMode;
  perStoreMinimum?: Scalars['Int']['input'];
  priorities: Array<AllocationPriorityDimension>;
  reservationQuantity: Scalars['Int']['input'];
  reviewedSourceToken?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  storeIds: Array<Scalars['String']['input']>;
};

/**
 * Result of restockAllocationPreview. On success it carries the proposal and no errors. On failure it carries
 * no proposal, the error with its stable code, and a typed station reason when the station is the cause.
 */
export type RestockAllocationPreviewPayload = {
  __typename?: 'RestockAllocationPreviewPayload';
  /** Empty on success. On failure, one error with a stable code. An error allocateRestockSessionInventory can also return has the same message and code; SESSION_NOT_FOUND, NO_STORES_SELECTED and STORES_NOT_IN_SESSION come from checks only the preview makes. */
  errors: Array<AllocationErrorData>;
  /** The proposal. Null when the preview failed. */
  preview?: Maybe<RestockAllocationPreviewData>;
  /** Set only when the preview failed because the session's station cannot supply the allocation context. */
  stationUnavailableReason?: Maybe<RestockAllocationStationUnavailableReason>;
};

/**
 * Classification produced by Layer 2 of the new Restock dashboard allocation formula.
 * Drives whether a store ships this replenishment cycle, competes for remaining capacity,
 * or is bumped to area-manager review.
 */
export enum RestockAllocationReason {
  /**
   * Store competes for remaining ship slots based on its decayedScore.
   * weeksSinceShip < tier threshold. Default classification for active stores.
   */
  Eligible = 'ELIGIBLE',
  /**
   * Store has not received a delivery within inactivityWeeks (default 16 weeks),
   * or has no delivery in the lookup window at all. Bumped to the inactive-review list
   * instead of auto-shipping.
   */
  Excluded = 'EXCLUDED',
  /**
   * Store ships this cycle regardless of score because it has gone too long without a
   * delivery for its tier. tier threshold ≤ weeksSinceShip < inactivityWeeks.
   */
  Mandatory = 'MANDATORY'
}

/**
 * Why the station saved on the session cannot supply the allocation context. No other site is used in its
 * place, so there is no proposal and Apply should stay unavailable until the station problem is fixed.
 */
export enum RestockAllocationStationUnavailableReason {
  /** More than one site carries the session's station code. */
  Ambiguous = 'AMBIGUOUS',
  /** No site carries the session's station code. This includes a session with no station when no site carries an empty code. */
  Missing = 'MISSING',
  /** The station's site has no ERP availability record for the item. */
  SourceNotSupported = 'SOURCE_NOT_SUPPORTED',
  /** The site lookup failed, so it is not known whether the station is supported. A retry may succeed. */
  Unavailable = 'UNAVAILABLE'
}

export type RestockAvailabilityByItemIdSummary = {
  __typename?: 'RestockAvailabilityByItemIdSummary';
  itemId: Scalars['String']['output'];
  mustGoQty: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
};

export type RestockAvailabilityByItemIdSummaryFilterInput = {
  and?: InputMaybe<Array<RestockAvailabilityByItemIdSummaryFilterInput>>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  mustGoQty?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<RestockAvailabilityByItemIdSummaryFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type RestockAvailabilityByItemIdSummarySortInput = {
  itemId?: InputMaybe<SortEnumType>;
  mustGoQty?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export enum RestockAvailabilitySource {
  Erp = 'ERP',
  Internal = 'INTERNAL'
}

/**
 * Client-facing batch lifecycle phase emitted on the onRestockSessionBatchProgress
 * subscription. Carries phase signals for two server flows behind a single contract:
 *
 *
 *     The chunked session-creation worker (StartRestockSessionCreation +
 *     RestockSessionCreationWorkflowWorker) — emits Populating,
 *     Calculating, Persisting.
 *
 *
 *     The BYOA-v1 default-WOS session creation + on-demand-miss flow — emits
 *     EnqueuingMisses, WaitingOnRCDQ, WaitingOnRCAQ,
 *     HydratingGrid. The phase emit wiring lands in C2; C1 only locks the contract.
 *
 *
 * Idle is the terminal state for both flows so the PWA can reset its progress UI.
 * New values are appended only — additive per Atlas standard bde8323d82064d928e44bebcff552a2e.
 */
export enum RestockBatchPhase {
  /**
   * A Restock calculation is running, either as the second phase of chunked session creation
   * or as a standalone client-triggered calculation.
   */
  Calculating = 'CALCULATING',
  /**
   * BYOA-v1 flow: wsapi is enqueuing missing
   * (tenant, customer, item, location, wos) tuples into RestockCalcOnDemandWork
   * for the wsapi-services calc fleet to drain. First in-flight phase of session
   * creation when default-WOS hits do not cover every selected row.
   */
  EnqueuingMisses = 'ENQUEUING_MISSES',
  /**
   * BYOA-v1 flow: wsapi is reading RestockCalcResults and writing session
   * order-item rows. Terminal in-flight phase before Idle for the BYOA-v1
   * session-creation path.
   */
  HydratingGrid = 'HYDRATING_GRID',
  /**
   * Terminal state; emitted on workflow completion or failure so the PWA can reset any
   * in-flight progress UI. On failure the payload's Error field carries the
   * failure message.
   */
  Idle = 'IDLE',
  /**
   * Chunked-creation worker: writing calculated rows back to MongoDB — the terminal in-flight
   * phase of the StartRestockSessionCreation workflow.
   */
  Persisting = 'PERSISTING',
  /**
   * Chunked-creation worker: hydrating order-item rows from master data — the first phase
   * of the StartRestockSessionCreation workflow.
   */
  Populating = 'POPULATING',
  /**
   * BYOA-v1 flow: waiting for the wsapi-services RestockCalcAchievableQuantity
   * worker to react to the demand writes and write achievable columns to
   * RestockCalcResults.
   */
  WaitingOnRcaq = 'WAITING_ON_RCAQ',
  /**
   * BYOA-v1 flow: waiting for the wsapi-services RestockCalcDemandQuantity
   * worker to drain enqueued tuples and write demand columns to RestockCalcResults.
   */
  WaitingOnRcdq = 'WAITING_ON_RCDQ'
}

export type RestockBatchSummary = {
  __typename?: 'RestockBatchSummary';
  blockedCount: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

export type RestockCalcStep = {
  __typename?: 'RestockCalcStep';
  code: Scalars['String']['output'];
  context: Array<RestockCalcStepContextEntry>;
  message: Scalars['String']['output'];
  severity: RestockCalcStepSeverity;
};

/** Mongo-side representation of a single context entry on RestockCalcStepDocument. */
export type RestockCalcStepContextDocument = {
  __typename?: 'RestockCalcStepContextDocument';
  /** Context key (e.g. "reservePercent"). */
  key: Scalars['String']['output'];
  /** Stringified context value. */
  value: Scalars['String']['output'];
};

export type RestockCalcStepContextEntry = {
  __typename?: 'RestockCalcStepContextEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RestockCalcStepContextEntryFilterInput = {
  and?: InputMaybe<Array<RestockCalcStepContextEntryFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RestockCalcStepContextEntryFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Mongo-side representation of a single Restock calculation step. Owned by the Document layer
 * so the read model can evolve independently of domain commands and event records.
 */
export type RestockCalcStepDocument = {
  __typename?: 'RestockCalcStepDocument';
  /** Stable machine-readable identifier for the step (e.g. "RESERVE_APPLIED"). */
  code: Scalars['String']['output'];
  /** Key/value pairs carrying inputs and outputs that contributed to this step. */
  context: Array<RestockCalcStepContextDocument>;
  /** Human-readable description of what the step computed or why it was applied. */
  message: Scalars['String']['output'];
  /** Severity tier; see RestockCalcStepSeverity for canonical values. */
  severity: Scalars['String']['output'];
};

export type RestockCalcStepFilterInput = {
  and?: InputMaybe<Array<RestockCalcStepFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  context?: InputMaybe<ListFilterInputTypeOfRestockCalcStepContextEntryFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RestockCalcStepFilterInput>>;
  severity?: InputMaybe<RestockCalcStepSeverityOperationFilterInput>;
};

export enum RestockCalcStepSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type RestockCalcStepSeverityOperationFilterInput = {
  eq?: InputMaybe<RestockCalcStepSeverity>;
  in?: InputMaybe<Array<RestockCalcStepSeverity>>;
  neq?: InputMaybe<RestockCalcStepSeverity>;
  nin?: InputMaybe<Array<RestockCalcStepSeverity>>;
};

export type RestockCalculationData = {
  __typename?: 'RestockCalculationData';
  batchSummary?: Maybe<RestockBatchSummary>;
  results?: Maybe<Array<RestockCalculationResult>>;
  totalCount: Scalars['Int']['output'];
};

export type RestockCalculationInput = {
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  itemIds: Array<Scalars['String']['input']>;
  locationIds: Array<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  targetWeeksOfSupply: Scalars['Decimal']['input'];
};

export type RestockCalculationPayload = {
  __typename?: 'RestockCalculationPayload';
  errors?: Maybe<Array<ValidationError>>;
  restockCalculation?: Maybe<RestockCalculationData>;
};

export type RestockCalculationResult = {
  __typename?: 'RestockCalculationResult';
  /**
   * Per-store allocation from the MIP solver driven by tenant-level allocation defaults
   * (reservation %, allocation type, ordered priorities). 0 when no ERP availability exists
   * for the item at the session's station, when no session is provided (ad-hoc calcs), or
   * when the solver cannot produce a feasible solution for the item.
   */
  achievableQuantity: Scalars['Int']['output'];
  /** Final order quantity after greenhouse supply constraints and pro-rata distribution. */
  adjustedOrderQuantity: Scalars['Int']['output'];
  /** Percentage of post-reserve inventory pre-committed by the matched allocate rule (0 if no rule). */
  allocatePercent: Scalars['Decimal']['output'];
  /** Greenhouse units available to ship after reserve and allocate deductions. */
  availableToShip: Scalars['Int']['output'];
  /** Ordered breakdown of each calculation step for this row, used for debugging and UI traces. */
  calcSteps: Array<RestockCalcStep>;
  /** Timestamp when the calculation was produced. */
  calculatedAt: Scalars['DateTime']['output'];
  /** The delivery date used for the calculation (lead time applied to the request date). */
  deliveryDate: Scalars['DateTime']['output'];
  /** Total greenhouse inventory for this item; null when no availability data exists. */
  greenhouseInventory?: Maybe<Scalars['Int']['output']>;
  /** Identifier of the item this row belongs to. */
  itemId: Scalars['String']['output'];
  /** Identifier of the customer location this row belongs to. */
  locationId: Scalars['String']['output'];
  /** Order quantity prior to greenhouse supply constraints (post-rounding). */
  orderQuantity: Scalars['Int']['output'];
  /** Overall status of the calculation for this row (e.g. success or an error state). */
  overallStatus: CalculationStatus;
  /** Projected on-hand units at the delivery date after current-horizon sell-down. */
  predictedOnHand: Scalars['Int']['output'];
  /** Total units sold across all days in the base-rate-of-sale trailing window (pre-constraint). */
  rawTrailingUnitsSold: Scalars['Int']['output'];
  /** Units needed to bring PredictedOnHand up to TargetOnHand. */
  replenishmentTarget: Scalars['Int']['output'];
  /** Percentage of greenhouse inventory withheld by the matched reserve rule (0 if no rule). */
  reservePercent: Scalars['Decimal']['output'];
  /** Units withheld from greenhouse inventory by the reserve rule. */
  reserveQuantity: Scalars['Int']['output'];
  /** Expected units sold between now and the delivery date (demand during lead time). */
  sellDownUnits: Scalars['Decimal']['output'];
  /** Target inventory position (WeeklyRateOfSale × tenant target weeks of supply). */
  targetOnHand: Scalars['Int']['output'];
  /** Dollar value of trailing sales: unit price × RawTrailingUnitsSold. Price is resolved from ERP or Mongo pricing based on the tenant's UseErpPricing flag, as of CalculatedAt, at quantity 1. */
  trailingSales: Scalars['Decimal']['output'];
  /** Current on-hand inventory units at the location for this item at the time of calculation. */
  unitsOnHand: Scalars['Int']['output'];
  /** Units sold across the subset of trailing days that passed constraint detection. */
  usableTrailingUnitsSold: Scalars['Int']['output'];
  /** Seven-day average sales rate for this (item, location) used to project demand. */
  weeklyRateOfSale: Scalars['Decimal']['output'];
};

export enum RestockCalculationStatus {
  Failed = 'FAILED',
  Idle = 'IDLE',
  InProgress = 'IN_PROGRESS'
}

export type RestockCalculationStatusOperationFilterInput = {
  eq?: InputMaybe<RestockCalculationStatus>;
  in?: InputMaybe<Array<RestockCalculationStatus>>;
  neq?: InputMaybe<RestockCalculationStatus>;
  nin?: InputMaybe<Array<RestockCalculationStatus>>;
};

/** The authorized scope a component availability read used. */
export enum RestockComponentAvailabilityScope {
  /** Internal availability limited to the caller's assigned sites. */
  AssignedSites = 'ASSIGNED_SITES',
  /** ERP availability at the session's saved station. */
  SessionStation = 'SESSION_STATION',
  /** Internal availability across every site in the tenant. */
  Tenant = 'TENANT'
}

/** Whether the source holds availability for a component Item. */
export enum RestockComponentAvailabilityStatus {
  /** The source has availability for the Item. A zero quantity is a real zero. */
  Found = 'FOUND',
  /** The source has no availability record for the Item. This is not a zero. */
  SourceMissing = 'SOURCE_MISSING',
  /** Availability could not be read for the Item; see the reason. */
  Unavailable = 'UNAVAILABLE'
}

/** Whether a component Item's unit conversion is proven. */
export enum RestockComponentConversionStatus {
  /** A step used a default: the tenant has no saved unit configuration, or trays are involved and the Item has no size record (one each per tray was assumed). */
  Defaulted = 'DEFAULTED',
  /** Every unit step uses saved tenant configuration and, where trays are involved, the Item's size factor. */
  Resolved = 'RESOLVED',
  /** No eaches or display quantity is given: the Item was not found, or trays are involved and the Item has no usable size factor. */
  Unresolved = 'UNRESOLVED'
}

/** Why a component Item's availability could not be read. */
export enum RestockComponentUnavailableReason {
  /** No current Item with this id exists in the tenant. */
  ItemNotFound = 'ITEM_NOT_FOUND',
  /** The session's saved station matches more than one site. */
  StationAmbiguous = 'STATION_AMBIGUOUS',
  /** The station lookup failed. */
  StationLookupFailed = 'STATION_LOOKUP_FAILED',
  /** The session's saved station matches no site. */
  StationNotFound = 'STATION_NOT_FOUND'
}

/**
 * Trimmed read model for Restock bulk-fetch scenarios (grids, tree selectors, session wizard).
 * Excludes fields only needed by the location edit form, flattens address to City/StateProvince,
 * and replaces the notes array with NoteCount.
 */
export type RestockCustomerLocationDocument = {
  __typename?: 'RestockCustomerLocationDocument';
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerLookupCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['UUID']['output'];
  market: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priceGroupId: Scalars['String']['output'];
  priceGroupName: Scalars['String']['output'];
  region: Scalars['String']['output'];
  settings?: Maybe<RestockCustomerLocationSettingsDocument>;
  stateProvince: Scalars['String']['output'];
  storeNumber: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * Trimmed read model for Restock bulk-fetch scenarios (grids, tree selectors, session wizard).
 * Excludes fields only needed by the location edit form, flattens address to City/StateProvince,
 * and replaces the notes array with NoteCount.
 */
export type RestockCustomerLocationDocumentFilterInput = {
  and?: InputMaybe<Array<RestockCustomerLocationDocumentFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerLookupCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<UuidOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RestockCustomerLocationDocumentFilterInput>>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceGroupName?: InputMaybe<StringOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  settings?: InputMaybe<RestockCustomerLocationSettingsDocumentFilterInput>;
  stateProvince?: InputMaybe<StringOperationFilterInput>;
  storeNumber?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Trimmed read model for Restock bulk-fetch scenarios (grids, tree selectors, session wizard).
 * Excludes fields only needed by the location edit form, flattens address to City/StateProvince,
 * and replaces the notes array with NoteCount.
 */
export type RestockCustomerLocationDocumentSortInput = {
  city?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerLookupCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceGroupName?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  settings?: InputMaybe<RestockCustomerLocationSettingsDocumentSortInput>;
  stateProvince?: InputMaybe<SortEnumType>;
  storeNumber?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/**
 * Trimmed settings sub-document for the Restock read model.
 * Excludes ShippingNotes, RuleIds, and the full Notes array (replaced by NoteCount).
 */
export type RestockCustomerLocationSettingsDocument = {
  __typename?: 'RestockCustomerLocationSettingsDocument';
  deliveryScheduleId: Scalars['String']['output'];
  deliveryScheduleName: Scalars['String']['output'];
  noteCount: Scalars['Int']['output'];
  retailerName: Scalars['String']['output'];
  route: Scalars['String']['output'];
  storeClass: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

/**
 * Trimmed settings sub-document for the Restock read model.
 * Excludes ShippingNotes, RuleIds, and the full Notes array (replaced by NoteCount).
 */
export type RestockCustomerLocationSettingsDocumentFilterInput = {
  and?: InputMaybe<Array<RestockCustomerLocationSettingsDocumentFilterInput>>;
  deliveryScheduleId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Always "" in MongoDB — never written by any projection.
   * The real value is resolved at the GraphQL layer via
   * RestockCustomerLocationSettingsDocumentResolvers.GetDeliveryScheduleNameAsync.
   */
  deliveryScheduleName?: InputMaybe<StringOperationFilterInput>;
  noteCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RestockCustomerLocationSettingsDocumentFilterInput>>;
  retailerName?: InputMaybe<StringOperationFilterInput>;
  route?: InputMaybe<StringOperationFilterInput>;
  storeClass?: InputMaybe<StringOperationFilterInput>;
  zone?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Trimmed settings sub-document for the Restock read model.
 * Excludes ShippingNotes, RuleIds, and the full Notes array (replaced by NoteCount).
 */
export type RestockCustomerLocationSettingsDocumentSortInput = {
  deliveryScheduleId?: InputMaybe<SortEnumType>;
  /**
   * Always "" in MongoDB — never written by any projection.
   * The real value is resolved at the GraphQL layer via
   * RestockCustomerLocationSettingsDocumentResolvers.GetDeliveryScheduleNameAsync.
   */
  deliveryScheduleName?: InputMaybe<SortEnumType>;
  noteCount?: InputMaybe<SortEnumType>;
  retailerName?: InputMaybe<SortEnumType>;
  route?: InputMaybe<SortEnumType>;
  storeClass?: InputMaybe<SortEnumType>;
  zone?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RestockCustomerLocationsConnection = {
  __typename?: 'RestockCustomerLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockCustomerLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockCustomerLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockCustomerLocationsEdge = {
  __typename?: 'RestockCustomerLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockCustomerLocationDocument;
};

/** A connection to a list of items. */
export type RestockDailyDemandConnection = {
  __typename?: 'RestockDailyDemandConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockDailyDemandEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DbrCalcResultDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockDailyDemandEdge = {
  __typename?: 'RestockDailyDemandEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DbrCalcResultDocument;
};

/**
 * Aggregate KPIs over the tenant's RestockWorkQueueResultDocument rows for a
 * given asOf / weeksOfSupply slice. Backs the Restock Demand Dashboard's
 * top-of-page KPI tiles (Total Demand, Total Achievable) — the row grid uses SSRM cursor
 * paging, so the tiles cannot be summed client-side without a full-table scan.
 */
export type RestockDailyDemandSummaryData = {
  __typename?: 'RestockDailyDemandSummaryData';
  /**
   * Most recent RestockWorkQueueResultDocument.CalcDate across the tenant —
   * independent of asOf so the dashboard can self-correct when the user's
   * asOf=now falls before today's calc has run. null when the tenant has no
   * calc results at all.
   */
  latestCalcDate?: Maybe<Scalars['DateTime']['output']>;
  rowCount: Scalars['Int']['output'];
  /**
   * Sum of RestockWorkQueueResultDocument.AchievableQuantity across the slice,
   * substituting 0 for any row whose allocation result is still null. Matches the
   * per-row orderQuantity fallback contract in RestockDailyDemandRowResolvers.
   */
  totalAchievable: Scalars['Int']['output'];
  /**
   * Sum of ErpAvailability.Quantity — the pre-allocation supply number from the ERP
   * master. Computed server-side because ItemSummaryDocument.AvailableQuantity is empty
   * for ERP-driven tenants, so the dashboard cannot reduce client-side. Tenant-wide by default;
   * when a station is supplied it narrows to ErpAvailability.StationCode == station
   * (the availability axis — distinct from the demand tile's ErpId scoping). The slice's
   * asOf / weeksOfSupply do not narrow this tile.
   */
  totalAvailable: Scalars['Decimal']['output'];
  totalDemand: Scalars['Decimal']['output'];
};

/** Result of requestRestockDashboardRecalc. */
export type RestockDashboardRecalcPayload = {
  __typename?: 'RestockDashboardRecalcPayload';
  errors?: Maybe<Array<ValidationError>>;
  modifiedCount: Scalars['Long']['output'];
};

/**
 * Set-membership filter on RestockAllocationReason. The row matches when its
 * allocation reason equals any element of In. Empty or null means no filter on
 * this field. Mirrors the AG Grid set-filter shape so the PWA SSRM-v2 grid can pass through
 * multi-select choices without an extra mapping layer.
 */
export type RestockDashboardStoreRowAllocationReasonFilterInput = {
  in?: InputMaybe<Array<RestockAllocationReason>>;
};

/**
 * One row in the Restock Demand Dashboard's per-store aggregate. Each row collapses
 * every item-level RestockWorkQueueResultDocument for a single
 * (CustomerCode, LocationCode) into the metrics the
 * dashboard needs: TotalDemand summed across items, ItemCount
 * counted across rows, and LastCalculatedAt set to the most recent calc
 * timestamp in scope. RestockIndex ranks the store 0–100 using Nathan's
 * S27 formula (demand × 0.6 cap 50 + 25 − WoS × 4 cap 25 + velocity × 0.25 cap 15 +
 * storeClass A:10/B:5/C:0, total cap 100); RestockIndexBreakdown exposes
 * each component for the UI breakdown dialog.
 */
export type RestockDashboardStoreRowData = {
  __typename?: 'RestockDashboardStoreRowData';
  /**
   * Per-component breakdown of AllocationReason. Surfaces tier, threshold,
   * weeks-since-ship, last-delivery date, decayed score, and the resolved reason for the PWA
   * breakdown dialog. Null when no underlying DailyTransactionSummaries rows exist
   * for the store (matching DecayedScore being null).
   */
  allocationBreakdown?: Maybe<RestockAllocationBreakdownData>;
  /**
   * Layer 2 of the new allocation formula — whether the store is forced to ship this cycle
   * (MANDATORY), competes on score (ELIGIBLE), or is bumped to inactive
   * review (EXCLUDED). Defaults to RestockAllocationReason.Eligible
   * when the row has no underlying transactions yet.
   */
  allocationReason: RestockAllocationReason;
  /** Customer code shared by every result row in this aggregate bucket. */
  customerCode: Scalars['String']['output'];
  /**
   * Resolved CustomersSummaryDocument.CustomerId for the
   * (CustomerCode, LocationCode) pair. Null when no matching
   * customer is projected yet (orphan aggregate) — caller should treat the row as display-only.
   */
  customerId?: Maybe<Scalars['String']['output']>;
  /**
   * Resolved RestockCustomerLocationDocument.LocationId for this store. Null when the
   * customer is found but its restock-location read model has not yet been projected. The
   * dashboard treats null here as "Start Session unavailable for this row."
   */
  customerLocationId?: Maybe<Scalars['String']['output']>;
  /**
   * Layer 1 of the new allocation formula — recency-weighted sum of UnitsSold over the
   * configured lookback window (default 56 days). Each day's units contribute
   * units × exp(-ln(2) × daysAgo / halfLife). Null only when no
   * DailyTransactionSummaries rows exist for the store in the window (treated as zero
   * signal upstream by the allocation rules).
   */
  decayedScore?: Maybe<Scalars['Decimal']['output']>;
  /** Count of RestockWorkQueueResultDocument rows folded into this aggregate. */
  itemCount: Scalars['Int']['output'];
  /**
   * Maximum RestockWorkQueueResultDocument.CalcDate across the grouped rows;
   * null when every in-scope row is a stub.
   */
  lastCalculatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Most recent delivery (UnitsShipped > 0) date observed in the lookup window. Null when none. */
  lastDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Location code shared by every result row in this aggregate bucket. */
  locationCode: Scalars['String']['output'];
  /**
   * Per-store priority score, 0–100, computed at aggregate-query time. Nullable for the
   * edge case where the underlying InputsSnapshot rows pre-date the writer-side
   * keys (WeeklyRos, UnitsOnHand) — once every store has at least one
   * post-S27 calc row, this is non-null in steady state.
   */
  restockIndex?: Maybe<Scalars['Int']['output']>;
  /**
   * Per-component breakdown of RestockIndex. Null when RestockIndex
   * is null. Surfaced so the PWA breakdown dialog can show which component is driving the
   * score without recomputing on the client.
   */
  restockIndexBreakdown?: Maybe<RestockIndexBreakdownData>;
  /**
   * Sum of UnitsSold over the trailing
   * RestockDashboardAllocationOptions.SalesVelocityWindowDays (default 28 days).
   * Null when no sales rows exist for the store in the window.
   */
  sales4Wk?: Maybe<Scalars['Int']['output']>;
  /**
   * Store class from RestockCustomerLocationDocument.Settings.StoreClass. Null when the
   * restock-location read model (or its settings sub-document) is not yet projected.
   */
  storeClass?: Maybe<Scalars['String']['output']>;
  /**
   * Resolved chain-store name from CustomersSummaryDocument.Name
   * (e.g. "TRACTOR SUPPLY CO. #2205"). Null when no matching customer is projected.
   */
  storeName?: Maybe<Scalars['String']['output']>;
  /**
   * Chain-store-suffix store number from RestockCustomerLocationDocument.StoreNumber
   * (e.g. "2205"). Null when the restock-location read model is not yet projected.
   */
  storeNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Tier-derived weeks-since-ship cutoff resolved from
   * RestockDashboardAllocationOptions.TierThresholdWeeks for this row's
   * effective tier (a null/blank StoreClass normalizes to "Unranked").
   */
  thresholdWeeks?: Maybe<Scalars['Int']['output']>;
  /** Sum of RestockWorkQueueResultDocument.DemandQuantity across the grouped rows. */
  totalDemand: Scalars['Decimal']['output'];
  /**
   * Sales4Wk divided by distinct sale-days in the same window. Null when no
   * sales rows exist for the store in the window.
   */
  velocity4Wk?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Floor-division weeks between scoreDate and the most recent UnitsShipped > 0
   * row for the store. Null when no delivery is on record in the lookup window, which the
   * allocation rules treat as RestockAllocationReason.Excluded.
   */
  weeksSinceShip?: Maybe<Scalars['Int']['output']>;
};

/** Decimal column filter. All populated properties combine with AND semantics. */
export type RestockDashboardStoreRowDecimalFilterInput = {
  equalTo?: InputMaybe<Scalars['Decimal']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Decimal']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Decimal']['input']>;
};

/**
 * Column-level filters applied to a Restock dashboard store-rows block request. Every property
 * is optional; non-null properties combine with AND semantics. Three classes of filterable field:
 *
 *
 * Mongo-resolvable fields (customerCode, locationCode, itemCount,
 * totalDemand, restockIndex) — applied in a post-$group $match
 * stage so the materialized set is reduced before C# merge.
 * Enrichment fields (storeName, storeNumber, storeClass) — applied
 * in C# after the post-pipeline batch fetch resolves them from CustomersSummary and
 * RestockCustomerLocations. They are not joined into the Mongo pipeline (see the class
 * docs on RestockDashboardStoreRowsBlockQueryService for why an in-pipeline
 * $lookup against the full ~28k-row collections is unsafe).
 * Allocation fields (decayedScore, weeksSinceShip, thresholdWeeks,
 * sales4Wk, velocity4Wk, allocationReason) — applied in C# after the
 * parallel DailyTransactionSummaries aggregate is merged in, because those values do
 * not exist on the source RestockCalcResults row and cannot be expressed as a pipeline
 * $match.
 *
 *
 * Numeric range predicates on nullable allocation fields treat null rows as non-matching:
 * supplying any of equalTo / gte / lte excludes rows whose underlying
 * value is null (matches AG Grid's clientSide default and avoids ambiguity about
 * whether a missing value satisfies a numeric bound). String predicates on the enrichment
 * fields apply the same nulls-non-matching rule: a row whose storeName / storeNumber
 * / storeClass is unresolved (no matching customer or location read model) is excluded
 * when any predicate component is supplied.
 */
export type RestockDashboardStoreRowFilterInput = {
  allocationReason?: InputMaybe<RestockDashboardStoreRowAllocationReasonFilterInput>;
  customerCode?: InputMaybe<RestockDashboardStoreRowStringFilterInput>;
  decayedScore?: InputMaybe<RestockDashboardStoreRowDecimalFilterInput>;
  itemCount?: InputMaybe<RestockDashboardStoreRowIntFilterInput>;
  locationCode?: InputMaybe<RestockDashboardStoreRowStringFilterInput>;
  restockIndex?: InputMaybe<RestockDashboardStoreRowIntFilterInput>;
  sales4Wk?: InputMaybe<RestockDashboardStoreRowIntFilterInput>;
  storeClass?: InputMaybe<RestockDashboardStoreRowStringFilterInput>;
  storeName?: InputMaybe<RestockDashboardStoreRowStringFilterInput>;
  storeNumber?: InputMaybe<RestockDashboardStoreRowStringFilterInput>;
  thresholdWeeks?: InputMaybe<RestockDashboardStoreRowIntFilterInput>;
  totalDemand?: InputMaybe<RestockDashboardStoreRowDecimalFilterInput>;
  velocity4Wk?: InputMaybe<RestockDashboardStoreRowDecimalFilterInput>;
  weeksSinceShip?: InputMaybe<RestockDashboardStoreRowIntFilterInput>;
};

/** Integer column filter. All populated properties combine with AND semantics. */
export type RestockDashboardStoreRowIntFilterInput = {
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Single sort directive for a Restock dashboard store-rows block request. Multiple directives
 * combine into a composite sort in the order supplied. Field must be a GraphQL
 * camelCase field name resolvable by the server's allow-list; unknown fields produce a
 * top-level GraphQL error.
 */
export type RestockDashboardStoreRowSortInput = {
  descending: Scalars['Boolean']['input'];
  field: Scalars['String']['input'];
};

/**
 * String column filter. EqualTo produces an exact match and wins over
 * Contains; Contains performs a case-insensitive substring match
 * via a regex-escaped pattern.
 */
export type RestockDashboardStoreRowStringFilterInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  equalTo?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Windowed result for a single block request against the Restock dashboard store-rows grid.
 * Nodes holds the current page; TotalCount reports the number of
 * rows matching the active itemCodes/locationCodes + filter scope across all
 * pages. No group-totals branch yet — the dashboard UI doesn't ship grouping; can be added
 * later without breaking changes.
 */
export type RestockDashboardStoreRowsBlockData = {
  __typename?: 'RestockDashboardStoreRowsBlockData';
  /** Leaf rows for the current page. */
  nodes: Array<RestockDashboardStoreRowData>;
  /**
   * Total matching rows for the current scope. Computed in the same aggregation round trip as
   * Nodes so the count cannot drift relative to the returned page.
   */
  totalCount: Scalars['Int']['output'];
};

/**
 * Per-tenant data-validity summary: the evaluated checks plus the worst-of rollup. The flat
 * Checks list maps 1:1 to the PWA RAG cards; a category grouping can be added
 * later without breaking this shape.
 */
export type RestockDataValiditySummary = {
  __typename?: 'RestockDataValiditySummary';
  checks: Array<RestockValidityCheck>;
  evaluatedAt: Scalars['DateTime']['output'];
  overallStatus: RestockValidityStatus;
  tenantId: Scalars['String']['output'];
};

/**
 * BYOA explanation payload for a single Restock calc row. The Payload string is
 * capped at 4096 bytes by the writer; oversized inputs are truncated with
 * Overflowed = true so the audit row is always persisted.
 */
export type RestockExplanationPayload = {
  __typename?: 'RestockExplanationPayload';
  /** Version of the provider model that produced the payload. */
  modelVersion: Scalars['String']['output'];
  /** True when the payload was truncated to fit the size cap. */
  overflowed: Scalars['Boolean']['output'];
  /** JSON-serialized provider payload, capped to 4096 bytes UTF-8. */
  payload: Scalars['String']['output'];
  /** Identifier of the provider that emitted this explanation (e.g. "internal-statistical"). */
  providerKey: Scalars['String']['output'];
  /** UTC timestamp at which the explanation was persisted. */
  writtenAt: Scalars['DateTime']['output'];
};

/**
 * What roundRestockSessionOrderQuantityToFullCart would do to every row of the selected stores, calculated
 * without writing anything. Counts and totals cover every row; each example list holds at most 25 rows.
 */
export type RestockFullCartPreviewData = {
  __typename?: 'RestockFullCartPreviewData';
  /** At most 25 of the rows rounding changes, the largest change first. increasedRowCount and decreasedRowCount count every changed row. */
  changes: Array<RestockFullCartRowData>;
  /** Units removed across the lowered rows. */
  decreasedQuantity: Scalars['Int']['output'];
  /** Rows whose order quantity rounding lowers. A store whose rows add up to less than half a cart rounds every row to zero. */
  decreasedRowCount: Scalars['Int']['output'];
  /** Units added across the raised rows. */
  increasedQuantity: Scalars['Int']['output'];
  /** Rows whose order quantity rounding raises. */
  increasedRowCount: Scalars['Int']['output'];
  /** The selected stores' total order quantity after rounding. */
  orderQuantityAfter: Scalars['Int']['output'];
  /** The selected stores' total order quantity now. */
  orderQuantityBefore: Scalars['Int']['output'];
  /** Every row of the selected stores: the sum of increasedRowCount, decreasedRowCount, unchangedRowCount and skippedRowCount. */
  rowCount: Scalars['Int']['output'];
  /** How many different stores were selected. A store sent twice, dashed and dashless, counts once. */
  selectedStoreCount: Scalars['Int']['output'];
  /** The session previewed. */
  sessionId: Scalars['String']['output'];
  /** How many stores the session has. */
  sessionStoreCount: Scalars['Int']['output'];
  /** Rows rounding leaves out. Skips lists them by reason. */
  skippedRowCount: Scalars['Int']['output'];
  /** One entry for each reason that leaves at least one row out, with its complete row count and at most 25 example rows. */
  skips: Array<RestockFullCartSkipData>;
  /** Null when no reviewedSourceToken was sent. True when the source differs from the reviewed preview, so this new preview needs review before Apply. False when it is unchanged. This is checked when the preview runs and is not a lock: the source can still change before Apply. */
  sourceChanged?: Maybe<Scalars['Boolean']['output']>;
  /** A fingerprint of what the rounding read: the selected stores, their rows' order quantities and the items' container capacities. Send it back as reviewedSourceToken to learn whether the source changed. */
  sourceToken: Scalars['String']['output'];
  /** Selected stores with no row in this session. Rounding changes nothing there; they are listed so the selection is not silently narrowed. */
  storesNotInSession: Array<Scalars['String']['output']>;
  /** Rows rounding considers whose order quantity already equals the rounded value. */
  unchangedRowCount: Scalars['Int']['output'];
  /** True when every session store is selected. Auto round on load sends every session store, so this preview then shows what it would write. */
  wholeSession: Scalars['Boolean']['output'];
};

export type RestockFullCartPreviewInput = {
  customerLocationIds: Array<Scalars['String']['input']>;
  reviewedSourceToken?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};

/**
 * Result of restockFullCartPreview. On success it carries the preview and no errors. On failure it carries no
 * preview and one error.
 */
export type RestockFullCartPreviewPayload = {
  __typename?: 'RestockFullCartPreviewPayload';
  /** Empty on success. On failure, one error: the message and code roundRestockSessionOrderQuantityToFullCart returns for the same input, or SESSION_NOT_FOUND when no session with the id exists in the caller's tenant. */
  errors: Array<ValidationError>;
  /** The preview. Null when the preview failed. */
  preview?: Maybe<RestockFullCartPreviewData>;
};

/** One example row of a full-cart preview. */
export type RestockFullCartRowData = {
  __typename?: 'RestockFullCartRowData';
  /** The row's store, in the form the session holds it. */
  customerLocationId: Scalars['String']['output'];
  /** The row's item. */
  itemId: Scalars['String']['output'];
  /** The item's name on the session row. */
  itemName: Scalars['String']['output'];
  /** The row's order quantity now. */
  orderQuantity: Scalars['Int']['output'];
  /** The row's order quantity after rounding. */
  roundedOrderQuantity: Scalars['Int']['output'];
  /** The store's name on the session row. */
  storeName: Scalars['String']['output'];
  /** The units per cart rounding uses, from the item's active container configuration. Null when the item has none. */
  unitsPerCart?: Maybe<Scalars['Int']['output']>;
};

/** The rows of the selected stores that full-cart rounding leaves out for one reason. */
export type RestockFullCartSkipData = {
  __typename?: 'RestockFullCartSkipData';
  /** At most 25 of these rows, by store and then item. Rounding leaves their order quantity as it is. */
  examples: Array<RestockFullCartRowData>;
  /** Why these rows are left out. */
  reason: RestockFullCartSkipReason;
  /** Every row left out for this reason. */
  rowCount: Scalars['Int']['output'];
};

export enum RestockFullCartSkipReason {
  NoContainerCapacity = 'NO_CONTAINER_CAPACITY',
  NoOrderQuantity = 'NO_ORDER_QUANTITY'
}

/**
 * Component breakdown of RestockDashboardStoreRowData.RestockIndex. Exposed
 * alongside the aggregate score so the PWA breakdown dialog can attribute a store's rank
 * to its strongest driver (demand, urgency, velocity, or class) without recomputing the
 * formula client-side. Sum of components equals the pre-cap index; the dashboard's
 * RestockIndex applies the 100-cap to the sum.
 */
export type RestockIndexBreakdownData = {
  __typename?: 'RestockIndexBreakdownData';
  /** Demand contribution — min(50, totalDemand × 0.6). */
  demandScore: Scalars['Int']['output'];
  /** Store-class bonus — A:10, B:5, C:0, anything else:0. */
  rankBonus: Scalars['Int']['output'];
  /** Velocity contribution — min(15, salesVelocity × 0.25). */
  velocityScore: Scalars['Int']['output'];
  /** Urgency contribution — max(0, 25 − weeksOfSupply × 4); lower WoS scores higher. */
  wosScore: Scalars['Int']['output'];
};

/**
 * Unified restock metrics shape served by restockMetrics(sessionId, itemId).
 * Scope is session-level when itemId is omitted and item-level when itemId
 * is supplied; in either case the shape is the same seven concepts — six physical
 * metrics (each with a quantity and wholesale dollar value) plus a non-additive
 * UtilizationPercent. Supersedes SessionRestockMetricsData and
 * ItemRestockMetricsData; those remain callable during the rollout and
 * are removed in a follow-up cleanup task.
 * RemainingAvailability is unclamped so negatives signal over-allocation.
 * UtilizationPercent returns the 9999.0 sentinel when
 * AvailableForOrders <= 0 and OnOrder > 0, and 0 when both
 * are zero.
 */
export type RestockMetrics = {
  __typename?: 'RestockMetrics';
  allocated: MetricValue;
  available: MetricValue;
  availableForOrders: MetricValue;
  inTransit: MetricValue;
  onOrder: MetricValue;
  remainingAvailability: MetricValue;
  utilizationPercent: Scalars['Decimal']['output'];
};

/** Optional item and hierarchy filters applied to restock metrics aggregation. */
export type RestockMetricsFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filters by exact match on ItemSummaryDocument.Group (the item group / singular).
   * Provide one or more candidate values; an item matches if its Group equals any.
   */
  itemGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  itemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filters by exact match on ItemSummaryDocument.Subcategory (a singular field).
   * Provide one or more candidate values; an item matches if its Subcategory equals any.
   */
  subcategories?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Decimal column filter. All populated properties combine with AND semantics. */
export type RestockOrderItemDecimalFilterInput = {
  equalTo?: InputMaybe<Scalars['Decimal']['input']>;
  greaterThan?: InputMaybe<Scalars['Decimal']['input']>;
  lessThan?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RestockOrderItemDelta = {
  __typename?: 'RestockOrderItemDelta';
  achievableQuantity: Scalars['Int']['output'];
  customerLocationId: Scalars['String']['output'];
  demandQuantity: Scalars['Int']['output'];
  hasOverrides: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  orderQuantity: Scalars['Int']['output'];
  previousOrderQuantity?: Maybe<Scalars['Int']['output']>;
};

/**
 * Column-level filters applied to a Restock session order items block request. Every property is
 * optional; non-null properties combine with AND semantics. Only doc-native fields are
 * filterable — ERP-derived fields are intentionally excluded because they are resolved per-row
 * after the windowing match stage.
 */
export type RestockOrderItemFilterInput = {
  achievableQuantity?: InputMaybe<RestockOrderItemIntFilterInput>;
  city?: InputMaybe<RestockOrderItemStringFilterInput>;
  demandQuantity?: InputMaybe<RestockOrderItemIntFilterInput>;
  description?: InputMaybe<RestockOrderItemStringFilterInput>;
  inTransit?: InputMaybe<RestockOrderItemIntFilterInput>;
  itemGroup?: InputMaybe<RestockOrderItemStringFilterInput>;
  itemName?: InputMaybe<RestockOrderItemStringFilterInput>;
  itemNumber?: InputMaybe<RestockOrderItemStringFilterInput>;
  orderQuantity?: InputMaybe<RestockOrderItemIntFilterInput>;
  overallStatus?: InputMaybe<RestockOrderItemStringFilterInput>;
  predictedOnHand?: InputMaybe<RestockOrderItemIntFilterInput>;
  productGroup?: InputMaybe<RestockOrderItemStringFilterInput>;
  route?: InputMaybe<RestockOrderItemStringFilterInput>;
  sellDownUnits?: InputMaybe<RestockOrderItemIntFilterInput>;
  stateProvince?: InputMaybe<RestockOrderItemStringFilterInput>;
  storeClass?: InputMaybe<RestockOrderItemStringFilterInput>;
  storeName?: InputMaybe<RestockOrderItemStringFilterInput>;
  subcategory?: InputMaybe<RestockOrderItemStringFilterInput>;
  targetOnHand?: InputMaybe<RestockOrderItemIntFilterInput>;
  unitsOnHand?: InputMaybe<RestockOrderItemIntFilterInput>;
  weeklyRateOfSale?: InputMaybe<RestockOrderItemDecimalFilterInput>;
  weeksOfSupply?: InputMaybe<RestockOrderItemDecimalFilterInput>;
};

/**
 * Aggregate row representing one group under the current group-by path.
 * GroupKeyValues is ordered to match the group-by sequence up to and including
 * this group's level.
 */
export type RestockOrderItemGroupTotal = {
  __typename?: 'RestockOrderItemGroupTotal';
  /** Sum of leaf AchievableQuantity values in this group. */
  achievableQuantity: Scalars['Int']['output'];
  /**
   * Sum of resolved leaf Available values in this group. Resolution matches the detail
   * path: RestockAvailability (with Source=Erp) when a matching doc exists for
   * the row's ItemNumber + session station, otherwise the stored doc value.
   */
  available: Scalars['Int']['output'];
  /** Sum of leaf DemandQuantity values in this group. */
  demandQuantity: Scalars['Int']['output'];
  /** Group-by key values identifying this group, in group-by order. */
  groupKeyValues: Array<Scalars['String']['output']>;
  /** Sum of leaf OrderQuantity values in this group. */
  orderQuantity: Scalars['Int']['output'];
  /** Number of leaf rows contributing to this group. */
  rowCount: Scalars['Int']['output'];
  /** Sum of leaf UnitsOnHand values in this group. */
  unitsOnHand: Scalars['Int']['output'];
};

/** Integer column filter. All populated properties combine with AND semantics. */
export type RestockOrderItemIntFilterInput = {
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Single sort directive for a Restock session order items block request. Multiple directives
 * combine into a composite sort in the order supplied. Field must be a GraphQL
 * camelCase field name resolvable by the server's allow-list; unknown fields produce a GraphQL
 * error.
 */
export type RestockOrderItemSortInput = {
  descending: Scalars['Boolean']['input'];
  field: Scalars['String']['input'];
};

/**
 * String column filter. EqualTo produces an exact match and wins over
 * Contains; Contains performs a case-insensitive substring match
 * via a regex-escaped pattern.
 */
export type RestockOrderItemStringFilterInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  equalTo?: InputMaybe<Scalars['String']['input']>;
};

export type RestockOrderQuantityOverrideItemDataInput = {
  customerLocationId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
};

export enum RestockOverrideType {
  Add = 'ADD',
  Replace = 'REPLACE',
  Subtract = 'SUBTRACT',
  ToAchievable = 'TO_ACHIEVABLE',
  ToDemand = 'TO_DEMAND',
  ToTargetWeeksOfSupply = 'TO_TARGET_WEEKS_OF_SUPPLY'
}

export type RestockProviderSettingsData = {
  __typename?: 'RestockProviderSettingsData';
  rosProviderConfig?: Maybe<Scalars['String']['output']>;
  rosProviderKey: Scalars['String']['output'];
};

export type RestockProviderSettingsDataFilterInput = {
  and?: InputMaybe<Array<RestockProviderSettingsDataFilterInput>>;
  or?: InputMaybe<Array<RestockProviderSettingsDataFilterInput>>;
  rosProviderConfig?: InputMaybe<StringOperationFilterInput>;
  rosProviderKey?: InputMaybe<StringOperationFilterInput>;
};

export type RestockProviderSettingsDataSortInput = {
  rosProviderConfig?: InputMaybe<SortEnumType>;
  rosProviderKey?: InputMaybe<SortEnumType>;
};

export type RestockReserveRuleDataInput = {
  id: Scalars['String']['input'];
  level: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  percentage: Scalars['Decimal']['input'];
  value: Scalars['String']['input'];
};

/**
 * Payload for the onRestockSessionBatchProgress subscription. Each event
 * represents the in-flight state of one of:
 *
 *   the chunked server-driven session creation workflow (
 *     StartRestockSessionCreation),
 *   the BYOA-v1 default-WOS session creation + on-demand-miss flow (
 *     CreateRestockSession — phase emit lands in C2),
 *   a client-triggered Restock calculation.
 *
 * This type is transient and never persisted — it exists only to carry progress signals
 * from the server to connected subscribers. Subscribers must subscribe BEFORE issuing the
 * triggering mutation; SessionId is client-generated, so the PWA can subscribe up-front
 * without a race against the producer.
 */
export type RestockSessionBatchProgressPayload = {
  __typename?: 'RestockSessionBatchProgressPayload';
  /**
   * Zero-based index of the batch currently in flight. Always 0 when
   * Phase is RestockBatchPhase.Idle, when the producing
   * event has not yet reached a progressed batch, or when the active phase does not
   * carry batch semantics (BYOA-v1 phases — see RestockBatchPhase).
   */
  currentBatch: Scalars['Int']['output'];
  /**
   * Populated with the worker error message when Phase is
   * RestockBatchPhase.Idle and the workflow terminated abnormally;
   * null on successful terminal events or in-flight progress.
   */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * Bounded comma-joined sample of the excluded item codes (first five, with a trailing
   * ellipsis when more were excluded); null when nothing was excluded. The full capped list
   * is served by the restockSessionCreationExclusions drill-down query.
   */
  excludedItemCodesSample?: Maybe<Scalars['String']['output']>;
  /**
   * Full distinct count of items excluded from the session because their tuples were
   * un-computable data gaps (missing rate-of-sale/inventory data). Non-zero only on the
   * terminal Idle payload of a create that completed with exclusions — the amber
   * partial-success state; Error stays null on that payload.
   */
  excludedItemCount: Scalars['Int']['output'];
  /**
   * Comma-joined distinct missing-input reason codes
   * (NO_BASE_ROS / NO_INVENTORY / NO_GREENHOUSE_INVENTORY); null when
   * nothing was skipped.
   */
  missingInputReasonsSample?: Maybe<Scalars['String']['output']>;
  /**
   * Count of tuples skipped because the drain resolved them as missing-input data gaps (the row
   * exists but carries no demand). Distinct from ExcludedItemCount (the
   * un-computable, never-produced-a-row population). Non-zero only on a terminal Idle
   * whose session completed with such rows; Error stays null.
   */
  missingInputSkipCount: Scalars['Int']['output'];
  /** Full distinct count of items spanned by the missing-input skip rows. */
  missingInputSkipItemCount: Scalars['Int']['output'];
  /**
   * UTC instant the producing emit was stamped. Live publishes carry the emitter's clock at
   * publish time; events replayed from the RestockSessionCreationProgressDocument audit
   * row on (re)subscribe carry the row's LastUpdate. Lets clients order events and
   * distinguish a fresh transition from a replayed last-known state.
   */
  occurredAt: Scalars['DateTime']['output'];
  /**
   * The current lifecycle phase. RestockBatchPhase.Idle is emitted
   * on terminal success or failure so clients can reset local UI.
   */
  phase: RestockBatchPhase;
  /** The ID of the session this progress notification is scoped to. */
  sessionId: Scalars['String']['output'];
  /**
   * Total number of batches expected for the current workflow. Always
   * 0 when Phase is RestockBatchPhase.Idle or when
   * the active phase does not carry batch semantics (BYOA-v1 phases).
   */
  totalBatches: Scalars['Int']['output'];
};

/** Availability of one component Item within a session's availability read. */
export type RestockSessionComponentAvailabilityData = {
  __typename?: 'RestockSessionComponentAvailabilityData';
  /** Whether the conversion from the source unit to eaches and display is proven. */
  conversion: RestockComponentConversionStatus;
  /**
   * Whole eaches shown in the display unit, rounded up to whole trays. Null when the eaches
   * quantity is null.
   */
  displayQuantity?: Maybe<Scalars['Int']['output']>;
  /** Eaches per tray from the Item's size record. Null when the Item has no positive size factor. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The source quantity converted to eaches, before any display rounding. Null unless FOUND
   * with a conversion that is not UNRESOLVED.
   */
  eachesQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The requested Item id. */
  itemId: Scalars['String']['output'];
  /** The quantity as stored by the source, in the source unit. Null unless FOUND. */
  sourceQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** When the source last refreshed this Item's availability. Null unless FOUND. */
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the source holds availability for this Item. */
  status: RestockComponentAvailabilityStatus;
  /** Why the Item is UNAVAILABLE; null for any other status. */
  unavailableReason?: Maybe<RestockComponentUnavailableReason>;
};

/**
 * Current availability of the requested component Items for one Restock session, read from the
 * session's own availability source with its scope, units and conversion provenance.
 */
export type RestockSessionComponentAvailabilityPayload = {
  __typename?: 'RestockSessionComponentAvailabilityPayload';
  /** When this read was taken. */
  asOf: Scalars['DateTime']['output'];
  /** The unit display quantities are shown in. */
  displayUnit: ReplenishmentUnit;
  /**
   * True only when at least one Item was requested and every Item is FOUND with a RESOLVED
   * conversion. A partial, missing, unavailable or defaulted row makes the set incomplete.
   */
  isComplete: Scalars['Boolean']['output'];
  /** One row per distinct requested Item id, in request order. */
  items: Array<RestockSessionComponentAvailabilityData>;
  /** The authorized scope the availability was read under. */
  scope: RestockComponentAvailabilityScope;
  /**
   * The site locations an ASSIGNED_SITES read was limited to, sorted. Empty for the other scopes,
   * and empty for an assigned caller whose sites resolve to no location.
   */
  scopeLocationIds: Array<Scalars['String']['output']>;
  /** The session this availability was read for. */
  sessionId: Scalars['String']['output'];
  /** The site the saved station resolved to (ERP source only, when it resolved). */
  siteLocationId?: Maybe<Scalars['String']['output']>;
  /** ERP when the session has a saved station, otherwise INTERNAL inventory. */
  source: RestockAvailabilitySource;
  /** The unit the source stores quantities in. */
  sourceUnit: ReplenishmentUnit;
  /** The session's saved station (ERP source only). */
  stationCode?: Maybe<Scalars['String']['output']>;
  /** True when the tenant has no saved unit configuration and the default (all trays) was used. */
  unitConfigDefaulted: Scalars['Boolean']['output'];
};

/** The unit a component's planned quantity is stored in, and the eaches one unit holds. */
export type RestockSessionComponentBasisData = {
  __typename?: 'RestockSessionComponentBasisData';
  eachesPerUnit: Scalars['Int']['output'];
  /** True when a Kit count save recorded this unit; false when it is the current configuration. */
  recorded: Scalars['Boolean']['output'];
  unit: ReplenishmentUnit;
};

/**
 * Drill-down payload for the restockSessionCreationExclusions query: the structured
 * exclusions recorded when a session create completed with un-computable data-gap tuples
 * excluded (missing rate-of-sale/inventory data). Backed by the
 * RestockSessionCreationProgressDocument TTL audit row, so exclusions are queryable
 * for the retention window after the create — the live
 * onRestockSessionBatchProgress payload carries only a bounded item-code sample.
 */
export type RestockSessionCreationExclusionsPayload = {
  __typename?: 'RestockSessionCreationExclusionsPayload';
  /**
   * Distinct, ordered excluded item codes, capped at 200 entries. Compare with
   * ExcludedItemCount to detect truncation.
   */
  excludedItemCodes: Array<Scalars['String']['output']>;
  /**
   * Full distinct count of items spanned by the excluded tuples — always the total, even
   * when ExcludedItemCodes is capped.
   */
  excludedItemCount: Scalars['Int']['output'];
  /** Count of un-computable tuples excluded from the session. */
  excludedTupleCount: Scalars['Int']['output'];
  /** UTC instant the terminal progress emit recorded the exclusions. */
  occurredAt: Scalars['DateTime']['output'];
  /** The session whose create completed with exclusions. */
  sessionId: Scalars['String']['output'];
};

export type RestockSessionCreationStatusData = {
  __typename?: 'RestockSessionCreationStatusData';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentChunk: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  lastProgressAt: Scalars['DateTime']['output'];
  phase: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  totalChunks: Scalars['Int']['output'];
};

export type RestockSessionCreationStatusDocument = {
  __typename?: 'RestockSessionCreationStatusDocument';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentChunk: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  lastProgressAt: Scalars['DateTime']['output'];
  phase: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  totalChunks: Scalars['Int']['output'];
};

export type RestockSessionCreationStatusDocumentFilterInput = {
  and?: InputMaybe<Array<RestockSessionCreationStatusDocumentFilterInput>>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  currentChunk?: InputMaybe<IntOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  lastProgressAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RestockSessionCreationStatusDocumentFilterInput>>;
  phase?: InputMaybe<StringOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  totalChunks?: InputMaybe<IntOperationFilterInput>;
};

export type RestockSessionCreationStatusDocumentSortInput = {
  completedAt?: InputMaybe<SortEnumType>;
  currentChunk?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  lastProgressAt?: InputMaybe<SortEnumType>;
  phase?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  totalChunks?: InputMaybe<SortEnumType>;
};

export type RestockSessionDocument = {
  __typename?: 'RestockSessionDocument';
  /** Current chunk index from the most recent RestockCalculationProgressed. Null before first progress event. */
  calculationCurrentChunk?: Maybe<Scalars['Int']['output']>;
  /** Lifecycle state of the session's server-side calculation orchestration. */
  calculationStatus: RestockCalculationStatus;
  /** Total chunks reported by the orchestrator for the current calculation. Null before first progress event. */
  calculationTotalChunks?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * Live state of the server-driven creation workflow. null until the creation workflow
   * is started for this session. Hot Chocolate auto-surfaces this as a GraphQL field on the
   * restockSession/restockSessions queries — no resolver needed.
   */
  creationStatus?: Maybe<RestockSessionCreationStatusDocument>;
  id: Scalars['String']['output'];
  /** Error message from the most recent calculation failure. Empty when not in Failed state. */
  lastCalculationError: Scalars['String']['output'];
  /**
   * Server-minted id of the session's latest calculation request, as returned in the requestId of
   * the mutation that started it. Null before the first request and when the latest request was
   * accepted before request correlation shipped.
   */
  lastRequestId?: Maybe<Scalars['String']['output']>;
  /**
   * Snapshot of the provider, algorithm settings, and business rules captured at session
   * creation. null on documents projected from streams created before the locked-config
   * snapshot shipped (event-sourced backward compatibility).
   */
  lockedConfig?: Maybe<LockedRestockConfig>;
  /**
   * The calendar day the Stores' stock is pulled, captured by Submit. Null before Submit and when
   * Submit gave none. Separate from shipDate.
   */
  pullDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Items x Stores pairs in the latest calculation request's scope. */
  requestedRowCount?: Maybe<Scalars['Int']['output']>;
  reserveRules: Array<RestockSessionReserveRuleDocument>;
  /**
   * How many of the latest calculation request's pairs resolved to a calculable tuple and were
   * recalculated. Set once that request Completed; less than requestedRowCount means only part of
   * the scope was calculated. Null while the request is InProgress or after it Failed.
   */
  resolvedRowCount?: Maybe<Scalars['Int']['output']>;
  selectedItemIds: Array<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  sessionName: Scalars['String']['output'];
  shipDate: Scalars['DateTime']['output'];
  stationCode?: Maybe<Scalars['String']['output']>;
  status: RestockSessionStatus;
  storeCount: Scalars['Int']['output'];
  /** Internal staff notes captured by Submit, as written. Null before Submit and when Submit gave none. Always null for a caller who is not internal staff. */
  submissionNotes?: Maybe<Scalars['String']['output']>;
  targetWeeksOfSupply?: Maybe<Scalars['Decimal']['output']>;
  tenantId: Scalars['String']['output'];
  totalQuantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RestockSessionDocumentFilterInput = {
  and?: InputMaybe<Array<RestockSessionDocumentFilterInput>>;
  /** Current chunk index from the most recent RestockCalculationProgressed. Null before first progress event. */
  calculationCurrentChunk?: InputMaybe<IntOperationFilterInput>;
  /** Lifecycle state of the session's server-side calculation orchestration. */
  calculationStatus?: InputMaybe<RestockCalculationStatusOperationFilterInput>;
  /** Total chunks reported by the orchestrator for the current calculation. Null before first progress event. */
  calculationTotalChunks?: InputMaybe<IntOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Live state of the server-driven creation workflow. null until the creation workflow
   * is started for this session. Hot Chocolate auto-surfaces this as a GraphQL field on the
   * restockSession/restockSessions queries — no resolver needed.
   */
  creationStatus?: InputMaybe<RestockSessionCreationStatusDocumentFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** Error message from the most recent calculation failure. Empty when not in Failed state. */
  lastCalculationError?: InputMaybe<StringOperationFilterInput>;
  /**
   * Server-minted id of the session's latest calculation request, as returned in the requestId of
   * the mutation that started it. Null before the first request and when the latest request was
   * accepted before request correlation shipped.
   */
  lastRequestId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Snapshot of the provider, algorithm settings, and business rules captured at session
   * creation. null on documents projected from streams created before the locked-config
   * snapshot shipped (event-sourced backward compatibility).
   */
  lockedConfig?: InputMaybe<LockedRestockConfigFilterInput>;
  or?: InputMaybe<Array<RestockSessionDocumentFilterInput>>;
  /**
   * The calendar day the Stores' stock is pulled, captured by Submit. Null before Submit and when
   * Submit gave none. Separate from shipDate.
   */
  pullDate?: InputMaybe<LocalDateOperationFilterInput>;
  /** Items x Stores pairs in the latest calculation request's scope. */
  requestedRowCount?: InputMaybe<IntOperationFilterInput>;
  reserveRules?: InputMaybe<ListFilterInputTypeOfRestockSessionReserveRuleDocumentFilterInput>;
  /**
   * How many of the latest calculation request's pairs resolved to a calculable tuple and were
   * recalculated. Set once that request Completed; less than requestedRowCount means only part of
   * the scope was calculated. Null while the request is InProgress or after it Failed.
   */
  resolvedRowCount?: InputMaybe<IntOperationFilterInput>;
  selectedItemIds?: InputMaybe<ListStringOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  sessionName?: InputMaybe<StringOperationFilterInput>;
  shipDate?: InputMaybe<DateTimeOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<RestockSessionStatusOperationFilterInput>;
  storeCount?: InputMaybe<IntOperationFilterInput>;
  targetWeeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  totalQuantity?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type RestockSessionDocumentSortInput = {
  /** Current chunk index from the most recent RestockCalculationProgressed. Null before first progress event. */
  calculationCurrentChunk?: InputMaybe<SortEnumType>;
  /** Lifecycle state of the session's server-side calculation orchestration. */
  calculationStatus?: InputMaybe<SortEnumType>;
  /** Total chunks reported by the orchestrator for the current calculation. Null before first progress event. */
  calculationTotalChunks?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * Live state of the server-driven creation workflow. null until the creation workflow
   * is started for this session. Hot Chocolate auto-surfaces this as a GraphQL field on the
   * restockSession/restockSessions queries — no resolver needed.
   */
  creationStatus?: InputMaybe<RestockSessionCreationStatusDocumentSortInput>;
  id?: InputMaybe<SortEnumType>;
  /** Error message from the most recent calculation failure. Empty when not in Failed state. */
  lastCalculationError?: InputMaybe<SortEnumType>;
  /**
   * Server-minted id of the session's latest calculation request, as returned in the requestId of
   * the mutation that started it. Null before the first request and when the latest request was
   * accepted before request correlation shipped.
   */
  lastRequestId?: InputMaybe<SortEnumType>;
  /**
   * Snapshot of the provider, algorithm settings, and business rules captured at session
   * creation. null on documents projected from streams created before the locked-config
   * snapshot shipped (event-sourced backward compatibility).
   */
  lockedConfig?: InputMaybe<LockedRestockConfigSortInput>;
  /**
   * The calendar day the Stores' stock is pulled, captured by Submit. Null before Submit and when
   * Submit gave none. Separate from shipDate.
   */
  pullDate?: InputMaybe<SortEnumType>;
  /** Items x Stores pairs in the latest calculation request's scope. */
  requestedRowCount?: InputMaybe<SortEnumType>;
  /**
   * How many of the latest calculation request's pairs resolved to a calculable tuple and were
   * recalculated. Set once that request Completed; less than requestedRowCount means only part of
   * the scope was calculated. Null while the request is InProgress or after it Failed.
   */
  resolvedRowCount?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  sessionName?: InputMaybe<SortEnumType>;
  shipDate?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  storeCount?: InputMaybe<SortEnumType>;
  targetWeeksOfSupply?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  totalQuantity?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/**
 * ERP-agnostic projection of a restock session's orderable rows (OrderQuantity > 0),
 * shaped for downstream order export/synchronization. Mirrors the DBR
 * DbrSessionNavOrderDocument field set but is deliberately not tied to any single
 * ERP (e.g. Nav) — the store/station/carrier/container fields are generic fulfillment
 * attributes resolved from shared read models.
 */
export type RestockSessionExportOrderDocument = {
  __typename?: 'RestockSessionExportOrderDocument';
  carts: Scalars['Decimal']['output'];
  containerCode?: Maybe<Scalars['String']['output']>;
  customerLocationId: Scalars['String']['output'];
  defaultCarrier?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  itemNumber: Scalars['String']['output'];
  orderQuantity: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  shipDate: Scalars['DateTime']['output'];
  stationCode: Scalars['String']['output'];
  status: RestockSessionStatus;
  storeName: Scalars['String']['output'];
  storeNumber: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * ERP-agnostic projection of a restock session's orderable rows (OrderQuantity > 0),
 * shaped for downstream order export/synchronization. Mirrors the DBR
 * DbrSessionNavOrderDocument field set but is deliberately not tied to any single
 * ERP (e.g. Nav) — the store/station/carrier/container fields are generic fulfillment
 * attributes resolved from shared read models.
 */
export type RestockSessionExportOrderDocumentFilterInput = {
  and?: InputMaybe<Array<RestockSessionExportOrderDocumentFilterInput>>;
  carts?: InputMaybe<DecimalOperationFilterInput>;
  containerCode?: InputMaybe<StringOperationFilterInput>;
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  defaultCarrier?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  itemNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RestockSessionExportOrderDocumentFilterInput>>;
  orderQuantity?: InputMaybe<IntOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  shipDate?: InputMaybe<DateTimeOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<RestockSessionStatusOperationFilterInput>;
  storeName?: InputMaybe<StringOperationFilterInput>;
  storeNumber?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * ERP-agnostic projection of a restock session's orderable rows (OrderQuantity > 0),
 * shaped for downstream order export/synchronization. Mirrors the DBR
 * DbrSessionNavOrderDocument field set but is deliberately not tied to any single
 * ERP (e.g. Nav) — the store/station/carrier/container fields are generic fulfillment
 * attributes resolved from shared read models.
 */
export type RestockSessionExportOrderDocumentSortInput = {
  carts?: InputMaybe<SortEnumType>;
  containerCode?: InputMaybe<SortEnumType>;
  customerLocationId?: InputMaybe<SortEnumType>;
  defaultCarrier?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  itemNumber?: InputMaybe<SortEnumType>;
  orderQuantity?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  shipDate?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  storeName?: InputMaybe<SortEnumType>;
  storeNumber?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RestockSessionExportOrdersConnection = {
  __typename?: 'RestockSessionExportOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockSessionExportOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockSessionExportOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockSessionExportOrdersEdge = {
  __typename?: 'RestockSessionExportOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockSessionExportOrderDocument;
};

/**
 * Running per-(tenant, session, item) allocated-quantity total for the live wizard's
 * "available" calculation, with a per-store breakdown so projections can apply deltas
 * without re-loading the aggregate. Mirrors DbrSessionItemAllocationDocument in
 * DBR 1.0.
 */
export type RestockSessionItemAllocationDocument = {
  __typename?: 'RestockSessionItemAllocationDocument';
  allocatedQuantity: Scalars['Int']['output'];
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  lastEventAt: Scalars['DateTime']['output'];
  perStore: Array<KeyValuePairOfStringAndInt32>;
  sessionId: Scalars['String']['output'];
  stationCode: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * Running per-(tenant, session, item) allocated-quantity total for the live wizard's
 * "available" calculation, with a per-store breakdown so projections can apply deltas
 * without re-loading the aggregate. Mirrors DbrSessionItemAllocationDocument in
 * DBR 1.0.
 */
export type RestockSessionItemAllocationDocumentFilterInput = {
  allocatedQuantity?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<RestockSessionItemAllocationDocumentFilterInput>>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  lastEventAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RestockSessionItemAllocationDocumentFilterInput>>;
  perStore?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndInt32FilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  stationCode?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Running per-(tenant, session, item) allocated-quantity total for the live wizard's
 * "available" calculation, with a per-store breakdown so projections can apply deltas
 * without re-loading the aggregate. Mirrors DbrSessionItemAllocationDocument in
 * DBR 1.0.
 */
export type RestockSessionItemAllocationDocumentSortInput = {
  allocatedQuantity?: InputMaybe<SortEnumType>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  lastEventAt?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  stationCode?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RestockSessionItemAllocationsConnection = {
  __typename?: 'RestockSessionItemAllocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockSessionItemAllocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockSessionItemAllocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockSessionItemAllocationsEdge = {
  __typename?: 'RestockSessionItemAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockSessionItemAllocationDocument;
};

export type RestockSessionItemAvailabilityData = {
  __typename?: 'RestockSessionItemAvailabilityData';
  available: Scalars['Int']['output'];
  availableValue: Scalars['Decimal']['output'];
  itemId: Scalars['String']['output'];
};

/** Where and when component availability was read, and the eaches each component converted to. */
export type RestockSessionKitAvailabilityData = {
  __typename?: 'RestockSessionKitAvailabilityData';
  asOf: Scalars['DateTime']['output'];
  /** Each component Item the source holds a quantity for with a proven conversion. */
  items: Array<RestockSessionKitComponentAvailabilityData>;
  scope: RestockSessionKitAvailabilityScope;
  /** The site locations an assigned-sites read was limited to. */
  scopeLocationIds: Array<Scalars['String']['output']>;
  siteLocationId?: Maybe<Scalars['String']['output']>;
  /** The unit the source stores its quantities in. */
  sourceUnit: ReplenishmentUnit;
  stationCode?: Maybe<Scalars['String']['output']>;
};

export enum RestockSessionKitAvailabilityScope {
  AssignedSites = 'ASSIGNED_SITES',
  SessionStation = 'SESSION_STATION',
  Tenant = 'TENANT',
  Unknown = 'UNKNOWN'
}

/** This session's own cap on a Kit's total, with the availability that supported it when set. */
export type RestockSessionKitCapData = {
  __typename?: 'RestockSessionKitCapData';
  availability: RestockSessionKitAvailabilityData;
  cap: Scalars['Int']['output'];
  setAt: Scalars['DateTime']['output'];
  setBy: Scalars['String']['output'];
  /** The maximum the component availability supported when the cap was set. */
  supportedMaximum: Scalars['Int']['output'];
};

/** One component Item's available eaches as read. */
export type RestockSessionKitComponentAvailabilityData = {
  __typename?: 'RestockSessionKitComponentAvailabilityData';
  /** Unrounded available eaches. */
  eaches: Scalars['Decimal']['output'];
  /** The Item's own tray size the conversion used. Null when it needed none. */
  eachesPerUnit?: Maybe<Scalars['Int']['output']>;
  itemId: Scalars['String']['output'];
};

/** The eaches of one component Item a single Kit uses. */
export type RestockSessionKitComponentEachesData = {
  __typename?: 'RestockSessionKitComponentEachesData';
  eaches: Scalars['Long']['output'];
  itemId: Scalars['String']['output'];
};

export enum RestockSessionKitComponentStatus {
  Conserved = 'CONSERVED',
  Deficit = 'DEFICIT',
  NotPlanned = 'NOT_PLANNED',
  UnitBasisUnresolved = 'UNIT_BASIS_UNRESOLVED',
  Unknown = 'UNKNOWN'
}

export type RestockSessionKitCountDataInput = {
  count: Scalars['Int']['input'];
  customerLocationId: Scalars['String']['input'];
  kitId: Scalars['String']['input'];
};

export type RestockSessionKitData = {
  __typename?: 'RestockSessionKitData';
  definitions: Array<RestockSessionKitDefinitionData>;
  kitId: Scalars['String']['output'];
  siteIds: Array<Scalars['String']['output']>;
};

export type RestockSessionKitDefinitionData = {
  __typename?: 'RestockSessionKitDefinitionData';
  containerCode: Scalars['String']['output'];
  kitId: Scalars['String']['output'];
  lines: Array<RestockSessionKitLineData>;
  name: Scalars['String']['output'];
  sourceUpdatedAt: Scalars['DateTime']['output'];
};

export type RestockSessionKitLineData = {
  __typename?: 'RestockSessionKitLineData';
  kind: KitLineKind;
  label: Scalars['String']['output'];
  lineId: Scalars['String']['output'];
  multiple: Scalars['Int']['output'];
  refId: Scalars['String']['output'];
  secondaryLabel: Scalars['String']['output'];
  unit?: Maybe<RestockSessionKitLineUnitData>;
};

export type RestockSessionKitLineUnitData = {
  __typename?: 'RestockSessionKitLineUnitData';
  eachesPerUnit: Scalars['Int']['output'];
  shippingUomCode: Scalars['String']['output'];
  shippingUomId: Scalars['String']['output'];
};

/**
 * Outcome of attachRestockSessionKit. On success, the session id and the Kit snapshot the
 * session now holds; on a refusal, only the errors, and nothing was written.
 */
export type RestockSessionKitPayload = {
  __typename?: 'RestockSessionKitPayload';
  errors?: Maybe<Array<ValidationError>>;
  kit?: Maybe<RestockSessionKitData>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

/** One component Item at one Store: its planned quantity split into Kit usage and remainder. */
export type RestockSessionKitPlanComponentData = {
  __typename?: 'RestockSessionKitPlanComponentData';
  /** The unit the planned quantity is stored in. Null when it cannot be proved. */
  basis?: Maybe<RestockSessionComponentBasisData>;
  customerLocationId: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  /** The eaches the Store's Kit counts use, summed across every Kit. */
  kitEaches: Scalars['Long']['output'];
  /** True when Kits use the component and its plan does not cover them. */
  needsReview: Scalars['Boolean']['output'];
  plannedEaches?: Maybe<Scalars['Long']['output']>;
  /** The Store's current planned quantity, in its stored unit. Null when the Store has no row for the Item. */
  plannedQuantity?: Maybe<Scalars['Int']['output']>;
  /** Planned eaches less Kit eaches. Negative when the Kits use more than is planned. */
  remainderEaches?: Maybe<Scalars['Long']['output']>;
  status: RestockSessionKitComponentStatus;
};

/**
 * A session's Kit plan, derived on every read from its saved Kit counts and caps, its attached Kit
 * compositions and its current planned quantities. Each component's planned quantity, in eaches, is
 * its Kit usage plus its individual remainder. Nothing in it is reserved stock.
 */
export type RestockSessionKitPlanData = {
  __typename?: 'RestockSessionKitPlanData';
  /** The current component availability the supported maximums come from. Null when no Kit is attached. */
  availability?: Maybe<RestockSessionKitAvailabilityData>;
  /** One row per session Store and component Item of any attached Kit. */
  components: Array<RestockSessionKitPlanComponentData>;
  /** True when no component needs review and no Kit is above its cap. Submit is refused otherwise. */
  isValid: Scalars['Boolean']['output'];
  kits: Array<RestockSessionKitPlanKitData>;
  sessionId: Scalars['String']['output'];
  /**
   * Notes that never change isValid, needsReview or Submit: each Kit with no cap whose total is above
   * the maximum the current component availability supports.
   */
  warnings: Array<RestockSessionKitPlanWarningData>;
};

/** One attached Kit's counts across the session's Stores, against its session cap. */
export type RestockSessionKitPlanKitData = {
  __typename?: 'RestockSessionKitPlanKitData';
  cap?: Maybe<RestockSessionKitCapData>;
  /** Eaches of each component Item one Kit uses, nested Kits expanded. */
  componentEachesPerKit: Array<RestockSessionKitComponentEachesData>;
  /** How far the total is above the cap. Zero without a cap. */
  excessCount: Scalars['Int']['output'];
  kitId: Scalars['String']['output'];
  /** One row per session Store. */
  stores: Array<RestockSessionKitPlanStoreData>;
  /**
   * The most of this Kit the current component availability supports after every other Kit's entered
   * total takes its share of a shared component. Observed under the read's scope, not reserved. Null
   * when a component has no current quantity with a proven conversion.
   */
  supportedMaximum?: Maybe<Scalars['Int']['output']>;
  /** The Kit's counts summed across the session's Stores. */
  totalCount: Scalars['Int']['output'];
};

export type RestockSessionKitPlanPayload = {
  __typename?: 'RestockSessionKitPlanPayload';
  /** Why the mutation was refused; null on success. */
  errors?: Maybe<Array<ValidationError>>;
  /** The session's Kit plan after the change; null when the mutation was refused. */
  plan?: Maybe<RestockSessionKitPlanData>;
  /** The session the plan belongs to; null when the mutation was refused. */
  sessionId?: Maybe<Scalars['String']['output']>;
};

/** One Kit's saved count at one session Store. */
export type RestockSessionKitPlanStoreData = {
  __typename?: 'RestockSessionKitPlanStoreData';
  count: Scalars['Int']['output'];
  customerLocationId: Scalars['String']['output'];
  /**
   * The most of this Kit the Store's planned components still support with every other Kit's count
   * held as entered. Zero when a component is not planned at the Store. Null when a planned
   * component's unit cannot be proved.
   */
  suggestedCount?: Maybe<Scalars['Int']['output']>;
};

/** A note on the Kit plan that does not block Submit. */
export type RestockSessionKitPlanWarningData = {
  __typename?: 'RestockSessionKitPlanWarningData';
  /** RESTOCK_SESSION_KIT_TOTAL_ABOVE_SUPPORTED_MAXIMUM: a Kit with no cap is planned above what current stock supports. */
  code: Scalars['String']['output'];
  kitId: Scalars['String']['output'];
  /** The most of this Kit the current component availability supports. Observed, not reserved. */
  supportedMaximum: Scalars['Int']['output'];
  /** The Kit's counts summed across the session's Stores. */
  totalCount: Scalars['Int']['output'];
};

export type RestockSessionOrderItemData = {
  __typename?: 'RestockSessionOrderItemData';
  achievableQuantity?: Maybe<Scalars['Int']['output']>;
  allocatePercent: Scalars['Decimal']['output'];
  allocatedValue: Scalars['Decimal']['output'];
  available: Scalars['Int']['output'];
  availableToShip: Scalars['Int']['output'];
  availableValue: Scalars['Decimal']['output'];
  blockingRuleIds: Array<Scalars['String']['output']>;
  calculatedAt?: Maybe<Scalars['DateTime']['output']>;
  calculatedOrderQuantity: Scalars['Int']['output'];
  carts: Scalars['Decimal']['output'];
  customerLocationId: Scalars['String']['output'];
  daysSinceLastDelivery: Scalars['Int']['output'];
  daysSinceLastSale: Scalars['Int']['output'];
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  demandQuantity: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  greenhouseInventory?: Maybe<Scalars['Int']['output']>;
  inTransit: Scalars['Int']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  itemNumber: Scalars['String']['output'];
  orderQuantity: Scalars['Int']['output'];
  overallStatus: Scalars['String']['output'];
  predictedOnHand: Scalars['Int']['output'];
  previousOrderQuantity?: Maybe<Scalars['Int']['output']>;
  promotionRuleIds: Array<Scalars['String']['output']>;
  rawTrailingUnitsSold: Scalars['Int']['output'];
  replenishmentTarget: Scalars['Int']['output'];
  reservePercent: Scalars['Decimal']['output'];
  reserveQuantity: Scalars['Int']['output'];
  sellDownUnits: Scalars['Decimal']['output'];
  storeName: Scalars['String']['output'];
  targetOnHand: Scalars['Int']['output'];
  trailingSales: Scalars['Decimal']['output'];
  unitValue: Scalars['Decimal']['output'];
  unitsOnHand: Scalars['Int']['output'];
  unitsOnHandValue: Scalars['Decimal']['output'];
  unitsReplenished: Scalars['Int']['output'];
  usableTrailingUnitsSold: Scalars['Int']['output'];
  weeklyRateOfSale: Scalars['Decimal']['output'];
  weeksOfSupply: Scalars['Decimal']['output'];
};

export type RestockSessionOrderItemDocument = {
  __typename?: 'RestockSessionOrderItemDocument';
  /**
   * Per-store achievable from the allocation engine; null when allocation did not
   * run for the row. Atlas standard e05b714192b34cc298e08d3bbbc241da — readers must
   * surface "unknown", never coerce to zero.
   */
  achievableQuantity?: Maybe<Scalars['Int']['output']>;
  allocatePercent: Scalars['Decimal']['output'];
  allocatedValue: Scalars['Decimal']['output'];
  available: Scalars['Int']['output'];
  availableToShip: Scalars['Int']['output'];
  availableValue: Scalars['Decimal']['output'];
  blockingRuleIds: Array<Scalars['String']['output']>;
  calculatedAt?: Maybe<Scalars['DateTime']['output']>;
  calculatedOrderQuantity: Scalars['Int']['output'];
  carts: Scalars['Decimal']['output'];
  categories?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: Maybe<Scalars['String']['output']>;
  /**
   * NAV container code captured at populate time from
   * WorkSuite.Domain.Restock.Session.RestockSessionEvents.V1.RestockSessionOrderItemPopulatedRecord.ContainerCode.
   * Mirrors the column surfaced in the DBR 1.0 Restock Orders grid. Null when no station code is
   * configured on the session, when the item has no matching NAV availability row, or when the
   * session was populated before the field shipped.
   */
  containerCode?: Maybe<Scalars['String']['output']>;
  customerLocationId: Scalars['String']['output'];
  daysSinceLastDelivery: Scalars['Int']['output'];
  daysSinceLastSale: Scalars['Int']['output'];
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  demandQuantity: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  greenhouseInventory?: Maybe<Scalars['Int']['output']>;
  /**
   * Boolean materialization of "has any override ever fired for this row" — set true on the
   * first override and never reset. Lets the grid filter/sort without a separate count check.
   */
  hasOverrides: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  inTransit: Scalars['Int']['output'];
  itemGroup?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  itemNumber: Scalars['String']['output'];
  /**
   * Latest WorkSuite.GraphQl.Features.Engage.CycleCountLogDocument.PostedAt for
   * this row's (TenantId, CustomerLocationId, ItemId) triple, joined in at read time by
   * the Restock session aggregation pipeline. null when no cycle count exists.
   * Not persisted by the projection service.
   */
  lastCycleCountAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Highest KurrentDB commit-position observed by an override event for this row. Stored as a
   * monotonic long so the projection can use $max for idempotent advance.
   */
  latestOverrideSequence: Scalars['Long']['output'];
  location?: Maybe<CustomerLocationDocument>;
  onHandConfidencePercent: Scalars['Decimal']['output'];
  orderQuantity: Scalars['Int']['output'];
  overallStatus: Scalars['String']['output'];
  /**
   * Number of override-history rows in
   * WorkSuite.GraphQl.Features.Shared.CollectionNames.RestockSessionOrderQuantityOverrideHistory
   * for this (Tenant, Session, Item, CustomerLocation) tuple. Maintained by the main
   * projection alongside every order-quantity override event. Mirrors the DBR 1.0 grid badge.
   */
  overrideCount: Scalars['Int']['output'];
  predictedOnHand: Scalars['Int']['output'];
  previousOrderQuantity?: Maybe<Scalars['Int']['output']>;
  productGroup?: Maybe<Scalars['String']['output']>;
  programs?: Maybe<Array<Scalars['String']['output']>>;
  promotionRuleIds: Array<Scalars['String']['output']>;
  rawTrailingUnitsSold: Scalars['Int']['output'];
  remainingValue: Scalars['Decimal']['output'];
  replenishmentTarget: Scalars['Int']['output'];
  reservePercent: Scalars['Decimal']['output'];
  reserveQuantity: Scalars['Int']['output'];
  roundToFullCart: Scalars['Boolean']['output'];
  route?: Maybe<Scalars['String']['output']>;
  sellDownUnits: Scalars['Decimal']['output'];
  sessionId: Scalars['String']['output'];
  shipmentIncrement: Scalars['Int']['output'];
  sizes?: Maybe<Array<ItemDocumentSize>>;
  stateProvince?: Maybe<Scalars['String']['output']>;
  storeClass?: Maybe<Scalars['String']['output']>;
  storeName: Scalars['String']['output'];
  subcategory?: Maybe<Scalars['String']['output']>;
  targetOnHand: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  trailingSales: Scalars['Decimal']['output'];
  unitValue: Scalars['Decimal']['output'];
  unitsOnHand: Scalars['Int']['output'];
  unitsOnHandValue: Scalars['Decimal']['output'];
  /**
   * Units-per-cart capacity from the item's first active container configuration. Null when
   * the item has no active container configuration linked.
   */
  unitsPerCart?: Maybe<Scalars['Int']['output']>;
  unitsReplenished: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  usableTrailingUnitsSold: Scalars['Int']['output'];
  weeklyRateOfSale: Scalars['Decimal']['output'];
  weeksOfSupply: Scalars['Decimal']['output'];
};

export type RestockSessionOrderItemDocumentFilterInput = {
  /**
   * Per-store achievable from the allocation engine; null when allocation did not
   * run for the row. Atlas standard e05b714192b34cc298e08d3bbbc241da — readers must
   * surface "unknown", never coerce to zero.
   */
  achievableQuantity?: InputMaybe<IntOperationFilterInput>;
  allocatePercent?: InputMaybe<DecimalOperationFilterInput>;
  allocatedValue?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<RestockSessionOrderItemDocumentFilterInput>>;
  available?: InputMaybe<IntOperationFilterInput>;
  availableToShip?: InputMaybe<IntOperationFilterInput>;
  availableValue?: InputMaybe<DecimalOperationFilterInput>;
  blockingRuleIds?: InputMaybe<ListStringOperationFilterInput>;
  calculatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  calculatedOrderQuantity?: InputMaybe<IntOperationFilterInput>;
  carts?: InputMaybe<DecimalOperationFilterInput>;
  categories?: InputMaybe<ListStringOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * NAV container code captured at populate time from
   * WorkSuite.Domain.Restock.Session.RestockSessionEvents.V1.RestockSessionOrderItemPopulatedRecord.ContainerCode.
   * Mirrors the column surfaced in the DBR 1.0 Restock Orders grid. Null when no station code is
   * configured on the session, when the item has no matching NAV availability row, or when the
   * session was populated before the field shipped.
   */
  containerCode?: InputMaybe<StringOperationFilterInput>;
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  daysSinceLastDelivery?: InputMaybe<IntOperationFilterInput>;
  daysSinceLastSale?: InputMaybe<IntOperationFilterInput>;
  deliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  demandQuantity?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  greenhouseInventory?: InputMaybe<IntOperationFilterInput>;
  /**
   * Boolean materialization of "has any override ever fired for this row" — set true on the
   * first override and never reset. Lets the grid filter/sort without a separate count check.
   */
  hasOverrides?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inTransit?: InputMaybe<IntOperationFilterInput>;
  itemGroup?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  itemNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * Latest WorkSuite.GraphQl.Features.Engage.CycleCountLogDocument.PostedAt for
   * this row's (TenantId, CustomerLocationId, ItemId) triple, joined in at read time by
   * the Restock session aggregation pipeline. null when no cycle count exists.
   * Not persisted by the projection service.
   */
  lastCycleCountAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Highest KurrentDB commit-position observed by an override event for this row. Stored as a
   * monotonic long so the projection can use $max for idempotent advance.
   */
  latestOverrideSequence?: InputMaybe<LongOperationFilterInput>;
  location?: InputMaybe<CustomerLocationDocumentFilterInput>;
  or?: InputMaybe<Array<RestockSessionOrderItemDocumentFilterInput>>;
  orderQuantity?: InputMaybe<IntOperationFilterInput>;
  overallStatus?: InputMaybe<StringOperationFilterInput>;
  /**
   * Number of override-history rows in
   * WorkSuite.GraphQl.Features.Shared.CollectionNames.RestockSessionOrderQuantityOverrideHistory
   * for this (Tenant, Session, Item, CustomerLocation) tuple. Maintained by the main
   * projection alongside every order-quantity override event. Mirrors the DBR 1.0 grid badge.
   */
  overrideCount?: InputMaybe<IntOperationFilterInput>;
  predictedOnHand?: InputMaybe<IntOperationFilterInput>;
  previousOrderQuantity?: InputMaybe<IntOperationFilterInput>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  programs?: InputMaybe<ListStringOperationFilterInput>;
  promotionRuleIds?: InputMaybe<ListStringOperationFilterInput>;
  rawTrailingUnitsSold?: InputMaybe<IntOperationFilterInput>;
  replenishmentTarget?: InputMaybe<IntOperationFilterInput>;
  reservePercent?: InputMaybe<DecimalOperationFilterInput>;
  reserveQuantity?: InputMaybe<IntOperationFilterInput>;
  roundToFullCart?: InputMaybe<BooleanOperationFilterInput>;
  route?: InputMaybe<StringOperationFilterInput>;
  sellDownUnits?: InputMaybe<DecimalOperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  shipmentIncrement?: InputMaybe<IntOperationFilterInput>;
  sizes?: InputMaybe<ListFilterInputTypeOfItemDocumentSizeFilterInput>;
  stateProvince?: InputMaybe<StringOperationFilterInput>;
  storeClass?: InputMaybe<StringOperationFilterInput>;
  storeName?: InputMaybe<StringOperationFilterInput>;
  subcategory?: InputMaybe<StringOperationFilterInput>;
  targetOnHand?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  trailingSales?: InputMaybe<DecimalOperationFilterInput>;
  unitValue?: InputMaybe<DecimalOperationFilterInput>;
  unitsOnHand?: InputMaybe<IntOperationFilterInput>;
  unitsOnHandValue?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Units-per-cart capacity from the item's first active container configuration. Null when
   * the item has no active container configuration linked.
   */
  unitsPerCart?: InputMaybe<IntOperationFilterInput>;
  unitsReplenished?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  usableTrailingUnitsSold?: InputMaybe<IntOperationFilterInput>;
  weeklyRateOfSale?: InputMaybe<DecimalOperationFilterInput>;
  weeksOfSupply?: InputMaybe<DecimalOperationFilterInput>;
};

export type RestockSessionOrderItemDocumentSortInput = {
  /**
   * Per-store achievable from the allocation engine; null when allocation did not
   * run for the row. Atlas standard e05b714192b34cc298e08d3bbbc241da — readers must
   * surface "unknown", never coerce to zero.
   */
  achievableQuantity?: InputMaybe<SortEnumType>;
  allocatePercent?: InputMaybe<SortEnumType>;
  allocatedValue?: InputMaybe<SortEnumType>;
  available?: InputMaybe<SortEnumType>;
  availableToShip?: InputMaybe<SortEnumType>;
  availableValue?: InputMaybe<SortEnumType>;
  calculatedAt?: InputMaybe<SortEnumType>;
  calculatedOrderQuantity?: InputMaybe<SortEnumType>;
  carts?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<SortEnumType>;
  /**
   * NAV container code captured at populate time from
   * WorkSuite.Domain.Restock.Session.RestockSessionEvents.V1.RestockSessionOrderItemPopulatedRecord.ContainerCode.
   * Mirrors the column surfaced in the DBR 1.0 Restock Orders grid. Null when no station code is
   * configured on the session, when the item has no matching NAV availability row, or when the
   * session was populated before the field shipped.
   */
  containerCode?: InputMaybe<SortEnumType>;
  customerLocationId?: InputMaybe<SortEnumType>;
  daysSinceLastDelivery?: InputMaybe<SortEnumType>;
  daysSinceLastSale?: InputMaybe<SortEnumType>;
  deliveryDate?: InputMaybe<SortEnumType>;
  demandQuantity?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  greenhouseInventory?: InputMaybe<SortEnumType>;
  /**
   * Boolean materialization of "has any override ever fired for this row" — set true on the
   * first override and never reset. Lets the grid filter/sort without a separate count check.
   */
  hasOverrides?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inTransit?: InputMaybe<SortEnumType>;
  itemGroup?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  itemNumber?: InputMaybe<SortEnumType>;
  /**
   * Latest WorkSuite.GraphQl.Features.Engage.CycleCountLogDocument.PostedAt for
   * this row's (TenantId, CustomerLocationId, ItemId) triple, joined in at read time by
   * the Restock session aggregation pipeline. null when no cycle count exists.
   * Not persisted by the projection service.
   */
  lastCycleCountAt?: InputMaybe<SortEnumType>;
  /**
   * Highest KurrentDB commit-position observed by an override event for this row. Stored as a
   * monotonic long so the projection can use $max for idempotent advance.
   */
  latestOverrideSequence?: InputMaybe<SortEnumType>;
  location?: InputMaybe<CustomerLocationDocumentSortInput>;
  orderQuantity?: InputMaybe<SortEnumType>;
  overallStatus?: InputMaybe<SortEnumType>;
  /**
   * Number of override-history rows in
   * WorkSuite.GraphQl.Features.Shared.CollectionNames.RestockSessionOrderQuantityOverrideHistory
   * for this (Tenant, Session, Item, CustomerLocation) tuple. Maintained by the main
   * projection alongside every order-quantity override event. Mirrors the DBR 1.0 grid badge.
   */
  overrideCount?: InputMaybe<SortEnumType>;
  predictedOnHand?: InputMaybe<SortEnumType>;
  previousOrderQuantity?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  rawTrailingUnitsSold?: InputMaybe<SortEnumType>;
  replenishmentTarget?: InputMaybe<SortEnumType>;
  reservePercent?: InputMaybe<SortEnumType>;
  reserveQuantity?: InputMaybe<SortEnumType>;
  roundToFullCart?: InputMaybe<SortEnumType>;
  route?: InputMaybe<SortEnumType>;
  sellDownUnits?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  shipmentIncrement?: InputMaybe<SortEnumType>;
  stateProvince?: InputMaybe<SortEnumType>;
  storeClass?: InputMaybe<SortEnumType>;
  storeName?: InputMaybe<SortEnumType>;
  subcategory?: InputMaybe<SortEnumType>;
  targetOnHand?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  trailingSales?: InputMaybe<SortEnumType>;
  unitValue?: InputMaybe<SortEnumType>;
  unitsOnHand?: InputMaybe<SortEnumType>;
  unitsOnHandValue?: InputMaybe<SortEnumType>;
  /**
   * Units-per-cart capacity from the item's first active container configuration. Null when
   * the item has no active container configuration linked.
   */
  unitsPerCart?: InputMaybe<SortEnumType>;
  unitsReplenished?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  usableTrailingUnitsSold?: InputMaybe<SortEnumType>;
  weeklyRateOfSale?: InputMaybe<SortEnumType>;
  weeksOfSupply?: InputMaybe<SortEnumType>;
};

/**
 * Windowed result for a single block request against a Restock session's order items grid.
 * Nodes holds leaf rows for the current page; GroupTotals holds
 * summary rows when the client is browsing a group level. The two arrays are mutually
 * exclusive — a summary request returns empty Nodes and vice versa.
 */
export type RestockSessionOrderItemsBlockPayload = {
  __typename?: 'RestockSessionOrderItemsBlockPayload';
  /** Aggregated totals per group, populated only when the request is a group summary. */
  groupTotals: Array<RestockOrderItemGroupTotal>;
  /** Leaf rows for the current page. Empty when the request resolves to a group summary. */
  nodes: Array<RestockSessionOrderItemDocument>;
  /**
   * Total matching rows for the current filter/group scope. For leaf requests this is the row
   * count across all pages; for group summaries it is the number of groups returned.
   */
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type RestockSessionOrderItemsConnection = {
  __typename?: 'RestockSessionOrderItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockSessionOrderItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockSessionOrderItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockSessionOrderItemsEdge = {
  __typename?: 'RestockSessionOrderItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockSessionOrderItemDocument;
};

/** A connection to a list of items. */
export type RestockSessionOrderQuantityOverrideHistoryConnection = {
  __typename?: 'RestockSessionOrderQuantityOverrideHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockSessionOrderQuantityOverrideHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockSessionOrderQuantityOverrideHistoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Append-only history record capturing a single (item, customerLocation) line item inside an
 * order-quantity override event on a RestockSession. One document is written per line item per
 * event. The document Id is derived from the KurrentDB commit position and the
 * item's index inside the event's Items list so replaying the same batch never produces
 * duplicate rows. Mirrors DbrSessionOrderQuantityOverrideHistoryDocument from DBR 1.0;
 * the OverrideKind enum is shared with DBR (canonical kind classification).
 */
export type RestockSessionOrderQuantityOverrideHistoryDocument = {
  __typename?: 'RestockSessionOrderQuantityOverrideHistoryDocument';
  /**
   * Bulk operand for OverrideKind.BulkAdd (+Quantity) and
   * OverrideKind.BulkSubtract (-Quantity). null for all other kinds.
   */
  bulkOperand?: Maybe<Scalars['Int']['output']>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: Maybe<Scalars['String']['output']>;
  /** Customer location the override targets, in its original GUID format from the event. */
  customerLocationId: Scalars['String']['output'];
  /** Deterministic composite id: "{commitPosition}:{itemIndex}". */
  id: Scalars['String']['output'];
  /** Item the override targets. */
  itemId: Scalars['String']['output'];
  /** When the originating event was applied. Sourced from the event's UpdatedAt. */
  occurredAt: Scalars['DateTime']['output'];
  /** Order quantity recorded on the event's line item. */
  orderQuantity: Scalars['Int']['output'];
  /** Event type mapping — stored as a string for readability and future-safe migrations. */
  overrideKind: OverrideKind;
  /** Previous order quantity recorded on the event's line item, if the event carried one. */
  previousOrderQuantity?: Maybe<Scalars['Int']['output']>;
  /** RestockSession the override targets. */
  restockSessionId: Scalars['String']['output'];
  /**
   * Monotonic ordering sequence from resolvedEvent.OriginalPosition?.CommitPosition cast
   * to long. Pairs with OccurredAt as a deterministic tie-breaker.
   */
  sequence: Scalars['Long']['output'];
  /** Owning tenant. First key of the collection's compound index for isolation. */
  tenantId: Scalars['String']['output'];
  /** User that produced the override. */
  updatedBy: Scalars['String']['output'];
};

/**
 * Append-only history record capturing a single (item, customerLocation) line item inside an
 * order-quantity override event on a RestockSession. One document is written per line item per
 * event. The document Id is derived from the KurrentDB commit position and the
 * item's index inside the event's Items list so replaying the same batch never produces
 * duplicate rows. Mirrors DbrSessionOrderQuantityOverrideHistoryDocument from DBR 1.0;
 * the OverrideKind enum is shared with DBR (canonical kind classification).
 */
export type RestockSessionOrderQuantityOverrideHistoryDocumentFilterInput = {
  and?: InputMaybe<Array<RestockSessionOrderQuantityOverrideHistoryDocumentFilterInput>>;
  /**
   * Bulk operand for OverrideKind.BulkAdd (+Quantity) and
   * OverrideKind.BulkSubtract (-Quantity). null for all other kinds.
   */
  bulkOperand?: InputMaybe<IntOperationFilterInput>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<StringOperationFilterInput>;
  /** Customer location the override targets, in its original GUID format from the event. */
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  /** Deterministic composite id: "{commitPosition}:{itemIndex}". */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Item the override targets. */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** When the originating event was applied. Sourced from the event's UpdatedAt. */
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RestockSessionOrderQuantityOverrideHistoryDocumentFilterInput>>;
  /** Order quantity recorded on the event's line item. */
  orderQuantity?: InputMaybe<IntOperationFilterInput>;
  /** Event type mapping — stored as a string for readability and future-safe migrations. */
  overrideKind?: InputMaybe<OverrideKindOperationFilterInput>;
  /** Previous order quantity recorded on the event's line item, if the event carried one. */
  previousOrderQuantity?: InputMaybe<IntOperationFilterInput>;
  /** RestockSession the override targets. */
  restockSessionId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Monotonic ordering sequence from resolvedEvent.OriginalPosition?.CommitPosition cast
   * to long. Pairs with OccurredAt as a deterministic tie-breaker.
   */
  sequence?: InputMaybe<LongOperationFilterInput>;
  /** Owning tenant. First key of the collection's compound index for isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** User that produced the override. */
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Append-only history record capturing a single (item, customerLocation) line item inside an
 * order-quantity override event on a RestockSession. One document is written per line item per
 * event. The document Id is derived from the KurrentDB commit position and the
 * item's index inside the event's Items list so replaying the same batch never produces
 * duplicate rows. Mirrors DbrSessionOrderQuantityOverrideHistoryDocument from DBR 1.0;
 * the OverrideKind enum is shared with DBR (canonical kind classification).
 */
export type RestockSessionOrderQuantityOverrideHistoryDocumentSortInput = {
  /**
   * Bulk operand for OverrideKind.BulkAdd (+Quantity) and
   * OverrideKind.BulkSubtract (-Quantity). null for all other kinds.
   */
  bulkOperand?: InputMaybe<SortEnumType>;
  /**
   * The item this row's item has been combined into; null while the item stands on its own. The row stays
   * on the combined item, whose id its own id is built from, and a revert clears this.
   */
  combinedIntoItemId?: InputMaybe<SortEnumType>;
  /** Customer location the override targets, in its original GUID format from the event. */
  customerLocationId?: InputMaybe<SortEnumType>;
  /** Deterministic composite id: "{commitPosition}:{itemIndex}". */
  id?: InputMaybe<SortEnumType>;
  /** Item the override targets. */
  itemId?: InputMaybe<SortEnumType>;
  /** When the originating event was applied. Sourced from the event's UpdatedAt. */
  occurredAt?: InputMaybe<SortEnumType>;
  /** Order quantity recorded on the event's line item. */
  orderQuantity?: InputMaybe<SortEnumType>;
  /** Event type mapping — stored as a string for readability and future-safe migrations. */
  overrideKind?: InputMaybe<SortEnumType>;
  /** Previous order quantity recorded on the event's line item, if the event carried one. */
  previousOrderQuantity?: InputMaybe<SortEnumType>;
  /** RestockSession the override targets. */
  restockSessionId?: InputMaybe<SortEnumType>;
  /**
   * Monotonic ordering sequence from resolvedEvent.OriginalPosition?.CommitPosition cast
   * to long. Pairs with OccurredAt as a deterministic tie-breaker.
   */
  sequence?: InputMaybe<SortEnumType>;
  /** Owning tenant. First key of the collection's compound index for isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** User that produced the override. */
  updatedBy?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type RestockSessionOrderQuantityOverrideHistoryEdge = {
  __typename?: 'RestockSessionOrderQuantityOverrideHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockSessionOrderQuantityOverrideHistoryDocument;
};

export type RestockSessionPayload = {
  __typename?: 'RestockSessionPayload';
  /** Why the mutation was refused; null on success. */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * Server-minted id of the calculation request this mutation started, set only by
   * requestRestockCalculation and recalculateRestockSession. The session's lastRequestId carries the
   * same id, so a caller can tell which request a later status belongs to.
   */
  requestId?: Maybe<Scalars['String']['output']>;
  /** Terse human-readable outcome; null when the mutation was refused. */
  result?: Maybe<Scalars['String']['output']>;
  /** Post-mutation values of the rows an order-quantity mutation touched. */
  updatedRows?: Maybe<Array<RestockOrderItemDelta>>;
};

export type RestockSessionReserveRuleData = {
  __typename?: 'RestockSessionReserveRuleData';
  id: Scalars['String']['output'];
  level: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Decimal']['output'];
  value: Scalars['String']['output'];
};

export type RestockSessionReserveRuleDocument = {
  __typename?: 'RestockSessionReserveRuleDocument';
  id: Scalars['String']['output'];
  level: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Decimal']['output'];
  value: Scalars['String']['output'];
};

export type RestockSessionReserveRuleDocumentFilterInput = {
  and?: InputMaybe<Array<RestockSessionReserveRuleDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  level?: InputMaybe<StringOperationFilterInput>;
  mode?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RestockSessionReserveRuleDocumentFilterInput>>;
  percentage?: InputMaybe<DecimalOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Adds unallocatedAvailability(itemId, stationCode) to the
 * RestockSessionStateData GraphQL type (the type returned by the
 * restockSession(sessionId) root query). Returns
 * liveErp − allocatedQuantity for the given item, capping at zero. If the projection
 * has not yet built a row (session newly created or replay lagging), we treat
 * allocatedQuantity as zero and return the live ERP value. Mirrors
 * DbrSessionUnallocatedAvailabilityResolver.
 */
export type RestockSessionStateData = {
  __typename?: 'RestockSessionStateData';
  calculationStatus: RestockCalculationStatus;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  creationStatus?: Maybe<RestockSessionCreationStatusData>;
  kits: Array<RestockSessionKitData>;
  lastCalculationError: Scalars['String']['output'];
  lastRequestId?: Maybe<Scalars['String']['output']>;
  lockedConfig?: Maybe<LockedRestockConfig>;
  orderItems: Array<RestockSessionOrderItemData>;
  /** The calendar day the Stores' stock is pulled, captured by Submit. Null before Submit and when Submit gave none. Separate from shipDate. */
  pullDate?: Maybe<Scalars['LocalDate']['output']>;
  requestedRowCount?: Maybe<Scalars['Int']['output']>;
  reserveRules: Array<RestockSessionReserveRuleData>;
  resolvedRowCount?: Maybe<Scalars['Int']['output']>;
  selectedItemIds: Array<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  sessionName: Scalars['String']['output'];
  shipDate: Scalars['DateTime']['output'];
  stationCode?: Maybe<Scalars['String']['output']>;
  status: RestockSessionStatus;
  stores: Array<RestockSessionStoreData>;
  /** Internal staff notes captured by Submit, as written. Null before Submit and when Submit gave none. Always null for a caller who is not internal staff. */
  submissionNotes?: Maybe<Scalars['String']['output']>;
  targetWeeksOfSupply?: Maybe<Scalars['Decimal']['output']>;
  tenantId: Scalars['String']['output'];
  unallocatedAvailability: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};


/**
 * Adds unallocatedAvailability(itemId, stationCode) to the
 * RestockSessionStateData GraphQL type (the type returned by the
 * restockSession(sessionId) root query). Returns
 * liveErp − allocatedQuantity for the given item, capping at zero. If the projection
 * has not yet built a row (session newly created or replay lagging), we treat
 * allocatedQuantity as zero and return the live ERP value. Mirrors
 * DbrSessionUnallocatedAvailabilityResolver.
 */
export type RestockSessionStateDataUnallocatedAvailabilityArgs = {
  itemId: Scalars['String']['input'];
  stationCode: Scalars['String']['input'];
};

export enum RestockSessionStatus {
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
  Synchronized = 'SYNCHRONIZED'
}

export type RestockSessionStatusOperationFilterInput = {
  eq?: InputMaybe<RestockSessionStatus>;
  in?: InputMaybe<Array<RestockSessionStatus>>;
  neq?: InputMaybe<RestockSessionStatus>;
  nin?: InputMaybe<Array<RestockSessionStatus>>;
};

export type RestockSessionStoreData = {
  __typename?: 'RestockSessionStoreData';
  customerLocationId: Scalars['String']['output'];
  storeName: Scalars['String']['output'];
};

export enum RestockSessionStoreTicketSkipReason {
  NoPlannedRows = 'NO_PLANNED_ROWS',
  NoPositiveQuantity = 'NO_POSITIVE_QUANTITY'
}

/**
 * Result of restockSessionStoreTickets. On success it carries the envelope and no errors. On failure it
 * carries no envelope and one error, so a partial set of tickets is never returned.
 */
export type RestockSessionStoreTicketsPayload = {
  __typename?: 'RestockSessionStoreTicketsPayload';
  /** The tickets of the Stores in scope. Null when the read failed. */
  envelope?: Maybe<RestockStoreTicketEnvelopeData>;
  /**
   * Empty on success. On failure, one error: SESSION_NOT_FOUND when no live session with the id exists in
   * the caller's tenant, or a RESTOCK_SESSION_TICKET code naming the saved data that stops a complete set.
   */
  errors: Array<ValidationError>;
};

export type RestockSessionSubmitSummaryData = {
  __typename?: 'RestockSessionSubmitSummaryData';
  selectedItemCount: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  storeCount: Scalars['Int']['output'];
  totalCarts: Scalars['Decimal']['output'];
  totalValue: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type RestockSessionsConnection = {
  __typename?: 'RestockSessionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RestockSessionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RestockSessionDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RestockSessionsEdge = {
  __typename?: 'RestockSessionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RestockSessionDocument;
};

/** One Store's ticket: each Kit it takes with its components, then each Item it takes individually. */
export type RestockStoreTicketData = {
  __typename?: 'RestockStoreTicketData';
  /** The Store's id as the session saved it. */
  customerLocationId: Scalars['String']['output'];
  /** Each Item the Store takes individually, by Item number. An Item appears at most once. */
  items: Array<RestockStoreTicketItemData>;
  /** Each Kit the Store takes, in the order the Kits were attached to the session. */
  kits: Array<RestockStoreTicketKitData>;
  storeName: Scalars['String']['output'];
};

/**
 * The Store pick tickets of a submitted session, read from what the session saved and never recalculated:
 * its accepted planned quantities, its Kit compositions as attached, its Kit counts and the unit it recorded
 * for each component's planned quantity. Every Store in scope is a ticket or a skip. Notes are never part of
 * it.
 */
export type RestockStoreTicketEnvelopeData = {
  __typename?: 'RestockStoreTicketEnvelopeData';
  /** The Kit groups across every ticket. */
  kitGroupCount: Scalars['Int']['output'];
  /** The Kit component lines and individual Item lines across every ticket. */
  lineCount: Scalars['Int']['output'];
  /**
   * The calendar day Submit saved for pulling stock, separate from shipDate. Null when Submit saved none,
   * as on every session submitted before Pull Date existed.
   */
  pullDate?: Maybe<Scalars['LocalDate']['output']>;
  sessionId: Scalars['String']['output'];
  sessionName: Scalars['String']['output'];
  /** The session's saved Ship Date. */
  shipDate: Scalars['DateTime']['output'];
  skippedStoreCount: Scalars['Int']['output'];
  /** One entry per Store in scope with nothing to pick, in the session's Store order. */
  skips: Array<RestockStoreTicketSkipData>;
  /** SUBMITTED or SYNCHRONIZED. A session whose orders have not been processed prints the same tickets. */
  status: RestockSessionStatus;
  /** The Stores in scope: ticketCount plus skippedStoreCount. */
  storeCount: Scalars['Int']['output'];
  ticketCount: Scalars['Int']['output'];
  /** One ticket per Store with something to pick, in the session's Store order. */
  tickets: Array<RestockStoreTicketData>;
};

/**
 * One Item a Store takes individually. When the Store's Kits use the Item, the individual quantity is
 * remainingEaches; otherwise it is the whole plannedQuantity.
 */
export type RestockStoreTicketItemData = {
  __typename?: 'RestockStoreTicketItemData';
  /** The unit the session recorded for the planned quantity. Null when no Kit at the Store uses the Item. */
  basis?: Maybe<RestockStoreTicketUnitBasisData>;
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  itemNumber: Scalars['String']['output'];
  /** The eaches the Store's Kits use. Zero when no Kit at the Store uses the Item. */
  kitEaches: Scalars['Long']['output'];
  /** The accepted planned quantity, in the unit it was stored in. */
  plannedQuantity: Scalars['Int']['output'];
  /**
   * What to pick, as printed: remainingEaches followed by "ea" when the Store's Kits use the Item,
   * otherwise plannedQuantity alone, in the unit it was stored in.
   */
  quantityText: Scalars['String']['output'];
  /** The planned eaches less kitEaches, always above zero. Null when no Kit at the Store uses the Item. */
  remainingEaches?: Maybe<Scalars['Long']['output']>;
};

/** One component Item of a Kit group, in eaches. */
export type RestockStoreTicketKitComponentData = {
  __typename?: 'RestockStoreTicketKitComponentData';
  /** The eaches the group's whole count uses: count times eachesPerKit. */
  eaches: Scalars['Long']['output'];
  eachesPerKit: Scalars['Long']['output'];
  itemId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  itemNumber: Scalars['String']['output'];
};

/** One Kit a Store takes, as the session saved its composition when the Kit was attached. */
export type RestockStoreTicketKitData = {
  __typename?: 'RestockStoreTicketKitData';
  /** Each component Item, nested Kits expanded, by Item number. */
  components: Array<RestockStoreTicketKitComponentData>;
  containerCode: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  /** The source Kit's id. Opening it shows the Kit as it is now, which never changes this ticket. */
  kitId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** When the source Kit was last updated as of the attach, so a later edit of it can be told apart. */
  sourceUpdatedAt: Scalars['DateTime']['output'];
};

/** A Store in scope that gets no ticket, and why. */
export type RestockStoreTicketSkipData = {
  __typename?: 'RestockStoreTicketSkipData';
  customerLocationId: Scalars['String']['output'];
  reason: RestockSessionStoreTicketSkipReason;
  /** The reason, as printed. */
  reasonText: Scalars['String']['output'];
  storeName: Scalars['String']['output'];
};

/** The unit a planned quantity was stored in, and the eaches one unit holds. */
export type RestockStoreTicketUnitBasisData = {
  __typename?: 'RestockStoreTicketUnitBasisData';
  eachesPerUnit: Scalars['Int']['output'];
  unit: ReplenishmentUnit;
};

/**
 * One evaluated data-validity check. Value is the rendered metric behind the
 * status (e.g. "310991/497125 demand>0 (63%)"); Detail and
 * Remediation are human hints. RelatedTaskId links a known Helm bug
 * when one backs the check.
 */
export type RestockValidityCheck = {
  __typename?: 'RestockValidityCheck';
  detail?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  relatedTaskId?: Maybe<Scalars['String']['output']>;
  remediation?: Maybe<Scalars['String']['output']>;
  status: RestockValidityStatus;
  value: Scalars['String']['output'];
};

/**
 * RAG status for a single Restock data-validity check (and the rolled-up overall status).
 * Unknown is first so a default-constructed value reads as "not yet evaluated".
 * Re-homed from wsapi-admin-api (PR #8762) — behaviour preserved, names prefixed to avoid
 * collisions in the larger wsapi schema.
 */
export enum RestockValidityStatus {
  Amber = 'AMBER',
  Green = 'GREEN',
  Red = 'RED',
  Unknown = 'UNKNOWN'
}

/**
 * Payload broadcast on restockWorkQueueResultBatchCompleted once per
 * RestockWorkQueueResultDocument batch the worker (S19) flushes via
 * BulkWriteAsync. Batched-only from inception — there is no per-row channel
 * for the Restock work-queue result stream, ever.
 */
export type RestockWorkQueueResultBatchPayload = {
  __typename?: 'RestockWorkQueueResultBatchPayload';
  calcDate: Scalars['DateTime']['output'];
  rows: Array<RestockWorkQueueResultBatchRowData>;
  tenantId: Scalars['String']['output'];
};

/**
 * Mutation result for publishRestockWorkQueueResultBatch. RowCount
 * echoes the batch size accepted for publish; a non-empty Errors array
 * signals the caller's input was rejected before any topic event was sent.
 */
export type RestockWorkQueueResultBatchPublishedPayload = {
  __typename?: 'RestockWorkQueueResultBatchPublishedPayload';
  errors?: Maybe<Array<ValidationError>>;
  rowCount: Scalars['Int']['output'];
};

/**
 * Single calc result inside a batch. Shape is shared between the publish input and the
 * broadcast payload so PWA clients and the worker speak the same row schema. The
 * Data suffix locks the type to this contract — keep it out of other surfaces
 * to preserve forward compatibility.
 */
export type RestockWorkQueueResultBatchRowData = {
  __typename?: 'RestockWorkQueueResultBatchRowData';
  calcDate: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  demandQuantity: Scalars['Decimal']['output'];
  itemCode: Scalars['String']['output'];
  locationCode: Scalars['String']['output'];
  strategyKey: Scalars['String']['output'];
};

/**
 * Single calc result inside a batch. Shape is shared between the publish input and the
 * broadcast payload so PWA clients and the worker speak the same row schema. The
 * Data suffix locks the type to this contract — keep it out of other surfaces
 * to preserve forward compatibility.
 */
export type RestockWorkQueueResultBatchRowDataInput = {
  calcDate: Scalars['DateTime']['input'];
  customerCode: Scalars['String']['input'];
  demandQuantity: Scalars['Decimal']['input'];
  itemCode: Scalars['String']['input'];
  locationCode: Scalars['String']['input'];
  strategyKey: Scalars['String']['input'];
};

export type ResumeCountSessionInput = {
  countSessionId: Scalars['String']['input'];
};

export type ResumeOtaRolloutInput = {
  lineId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  rolloutId: Scalars['String']['input'];
};

/**
 * A single available BP organic lot the Retail PWA can assign to an organic product count — the
 * parity replacement for inventory-api's retailAvailableBpLots node shape. This is a query
 * OUTPUT read directly from the worker-owned RetailBpLots collection: the document's BSON
 * field names line up 1:1 with the collection the RetailBpLotSync worker writes, so this is a
 * straight read, not a re-projection. A lot is "available" when its on-hand quantity is positive.
 *
 * The collection (RetailBpLots) is owned by the wsapi-services RetailBpLotSync worker
 * (Nav Transfer Shipment upsert + sweep); this surface only reads it, tenant-scoped, so retail field
 * users can pick the BP lot a delivered / credited / counted organic product belongs to.
 */
export type RetailAvailableBpLotDocument = {
  __typename?: 'RetailAvailableBpLotDocument';
  /** The available on-hand quantity for the lot (the worker's Quantity). */
  availableQuantity: Scalars['Decimal']['output'];
  /** The BP organic lot code (the worker's LotReference — bp lot code). */
  bpLotCode: Scalars['String']['output'];
  /** The Nav item / SKU the lot is for (the worker's ItemReference; legacy itemNo). */
  itemNo: Scalars['String']['output'];
  /** The station (SiteLocation) the lot currently sits at (the worker's SiteLocationId; legacy locationId). */
  locationId: Scalars['String']['output'];
  /** The owning tenant (always BPF). The load-bearing multi-tenant isolation field. */
  tenantId: Scalars['String']['output'];
};

/**
 * A single available BP organic lot the Retail PWA can assign to an organic product count — the
 * parity replacement for inventory-api's retailAvailableBpLots node shape. This is a query
 * OUTPUT read directly from the worker-owned RetailBpLots collection: the document's BSON
 * field names line up 1:1 with the collection the RetailBpLotSync worker writes, so this is a
 * straight read, not a re-projection. A lot is "available" when its on-hand quantity is positive.
 *
 * The collection (RetailBpLots) is owned by the wsapi-services RetailBpLotSync worker
 * (Nav Transfer Shipment upsert + sweep); this surface only reads it, tenant-scoped, so retail field
 * users can pick the BP lot a delivered / credited / counted organic product belongs to.
 */
export type RetailAvailableBpLotDocumentFilterInput = {
  and?: InputMaybe<Array<RetailAvailableBpLotDocumentFilterInput>>;
  /** The available on-hand quantity for the lot (the worker's Quantity). */
  availableQuantity?: InputMaybe<DecimalOperationFilterInput>;
  /** The BP organic lot code (the worker's LotReference — bp lot code). */
  bpLotCode?: InputMaybe<StringOperationFilterInput>;
  /** The Nav item / SKU the lot is for (the worker's ItemReference; legacy itemNo). */
  itemNo?: InputMaybe<StringOperationFilterInput>;
  /** The station (SiteLocation) the lot currently sits at (the worker's SiteLocationId; legacy locationId). */
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RetailAvailableBpLotDocumentFilterInput>>;
  /** The owning tenant (always BPF). The load-bearing multi-tenant isolation field. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A single available BP organic lot the Retail PWA can assign to an organic product count — the
 * parity replacement for inventory-api's retailAvailableBpLots node shape. This is a query
 * OUTPUT read directly from the worker-owned RetailBpLots collection: the document's BSON
 * field names line up 1:1 with the collection the RetailBpLotSync worker writes, so this is a
 * straight read, not a re-projection. A lot is "available" when its on-hand quantity is positive.
 *
 * The collection (RetailBpLots) is owned by the wsapi-services RetailBpLotSync worker
 * (Nav Transfer Shipment upsert + sweep); this surface only reads it, tenant-scoped, so retail field
 * users can pick the BP lot a delivered / credited / counted organic product belongs to.
 */
export type RetailAvailableBpLotDocumentSortInput = {
  /** The available on-hand quantity for the lot (the worker's Quantity). */
  availableQuantity?: InputMaybe<SortEnumType>;
  /** The BP organic lot code (the worker's LotReference — bp lot code). */
  bpLotCode?: InputMaybe<SortEnumType>;
  /** The Nav item / SKU the lot is for (the worker's ItemReference; legacy itemNo). */
  itemNo?: InputMaybe<SortEnumType>;
  /** The station (SiteLocation) the lot currently sits at (the worker's SiteLocationId; legacy locationId). */
  locationId?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). The load-bearing multi-tenant isolation field. */
  tenantId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RetailAvailableBpLotsConnection = {
  __typename?: 'RetailAvailableBpLotsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RetailAvailableBpLotsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RetailAvailableBpLotDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RetailAvailableBpLotsEdge = {
  __typename?: 'RetailAvailableBpLotsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RetailAvailableBpLotDocument;
};

/**
 * Per-count result for the batch mutation: the audit record on success, or the validation error on
 * failure. The IdempotencyKey echoes the input key so the PWA can correlate each result
 * to the offline-queued count it submitted.
 */
export type RetailCountResult = {
  __typename?: 'RetailCountResult';
  count?: Maybe<RetailProductCountDocument>;
  error?: Maybe<ValidationError>;
  idempotencyKey: Scalars['String']['output'];
};

export enum RetailCountType {
  Credit = 'CREDIT',
  CycleCount = 'CYCLE_COUNT',
  DropOff = 'DROP_OFF',
  MustGo = 'MUST_GO',
  Unknown = 'UNKNOWN'
}

export type RetailCountTypeOperationFilterInput = {
  eq?: InputMaybe<RetailCountType>;
  in?: InputMaybe<Array<RetailCountType>>;
  neq?: InputMaybe<RetailCountType>;
  nin?: InputMaybe<Array<RetailCountType>>;
};

/**
 * Batch payload for the multi-count mutation. Results holds one row per input count (in
 * input order), each carrying either the audit record or the per-count error — so a partial
 * offline-replay flush surfaces exactly which counts landed and which were rejected.
 * Errors carries a BATCH-level failure only (e.g. the BPF-only tenant rejection or an
 * empty/over-cap batch), in which case Results is empty.
 */
export type RetailProductCountBatchPayload = {
  __typename?: 'RetailProductCountBatchPayload';
  errors?: Maybe<Array<ValidationError>>;
  results: Array<RetailCountResult>;
};

/**
 * Immutable audit record for a single retail store product count recorded by a BPF field user at a
 * retail customer location — the wsapi-resident replacement for the legacy
 * InventoryRetail.LocationProductCount rows. Written exactly once per logical count
 * (idempotency-key deduped); never updated after creation. The ERP write-back enqueue
 * (workflow = Retail, destined for the post-back worker → Nav CustomerInventoryLog)
 * follows this write.
 *
 * This domain is part of the Bonnie-bespoke inventory feature and is deliberately ISOLATED from the
 * shared InventoryItem domain — no InventoryEvents, no InventoryItems/
 * RestockAvailability writes. Nav is the source of truth.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>, which would leak as a broken
 * OptionOf{X}FilterInput.
 */
export type RetailProductCountDocument = {
  __typename?: 'RetailProductCountDocument';
  /**
   * The BP organic lot code assigned to this count; empty for non-organic products. Drives the
   * BP-lot organic tracking surface (retailAvailableBpLots / stationBpLotInventory).
   */
  bpLotCode: Scalars['String']['output'];
  /** The kind of count recorded (DropOff / Credit / CycleCount / MustGo). */
  countType: RetailCountType;
  /** When the count was recorded. */
  createdAt: Scalars['DateTime']['output'];
  /** The retail customer reference this location belongs to; empty when not resolved client-side. */
  customerReference: Scalars['String']['output'];
  /** The ERP write-back queue record id this count enqueued; empty if enqueue was skipped on a dedup hit. */
  erpWriteBackId: Scalars['String']['output'];
  /** Document id — composite {TenantId}-{RetailCountId}. Always route through GetDocumentId. */
  id: Scalars['String']['output'];
  /**
   * Idempotency key (the legacy idempotentKey). Unique per (tenant, key): a duplicate submit
   * with the same key returns the existing record without re-enqueuing a write-back, so a PWA retry
   * / offline replay never double-posts to Nav.
   */
  idempotencyKey: Scalars['String']['output'];
  /** The Nav item / SKU this count concerns; empty when only the product id is supplied. */
  itemReference: Scalars['String']['output'];
  /** The latitude where the count was recorded; 0 when not captured. */
  latitude: Scalars['Float']['output'];
  /** The retail customer/store location this count was recorded at (the legacy LocationId). */
  locationId: Scalars['String']['output'];
  /** The longitude where the count was recorded; 0 when not captured. */
  longitude: Scalars['Float']['output'];
  /** Free-form field-user note; empty when none. */
  note: Scalars['String']['output'];
  /** The Nav product id this count concerns (the legacy ProductId). */
  productId: Scalars['String']['output'];
  /** The product-count quantity delta the field user recorded. */
  quantityChange: Scalars['Decimal']['output'];
  /** The server-generated audit-record id, distinct from the composite Id. */
  retailCountId: Scalars['String']['output'];
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId: Scalars['String']['output'];
  /** The unit of measure for the count (e.g. EA, FLAT); empty when not supplied. */
  unit: Scalars['String']['output'];
  /** The unit / case-pack quantity delta the field user recorded (legacy UnitQuantityChange). */
  unitQuantityChange: Scalars['Decimal']['output'];
  /** The field user (email) who recorded the count, from the authenticated principal. */
  user: Scalars['String']['output'];
};

/**
 * Immutable audit record for a single retail store product count recorded by a BPF field user at a
 * retail customer location — the wsapi-resident replacement for the legacy
 * InventoryRetail.LocationProductCount rows. Written exactly once per logical count
 * (idempotency-key deduped); never updated after creation. The ERP write-back enqueue
 * (workflow = Retail, destined for the post-back worker → Nav CustomerInventoryLog)
 * follows this write.
 *
 * This domain is part of the Bonnie-bespoke inventory feature and is deliberately ISOLATED from the
 * shared InventoryItem domain — no InventoryEvents, no InventoryItems/
 * RestockAvailability writes. Nav is the source of truth.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>, which would leak as a broken
 * OptionOf{X}FilterInput.
 */
export type RetailProductCountDocumentFilterInput = {
  and?: InputMaybe<Array<RetailProductCountDocumentFilterInput>>;
  /**
   * The BP organic lot code assigned to this count; empty for non-organic products. Drives the
   * BP-lot organic tracking surface (retailAvailableBpLots / stationBpLotInventory).
   */
  bpLotCode?: InputMaybe<StringOperationFilterInput>;
  /** The kind of count recorded (DropOff / Credit / CycleCount / MustGo). */
  countType?: InputMaybe<RetailCountTypeOperationFilterInput>;
  /** When the count was recorded. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The retail customer reference this location belongs to; empty when not resolved client-side. */
  customerReference?: InputMaybe<StringOperationFilterInput>;
  /** The ERP write-back queue record id this count enqueued; empty if enqueue was skipped on a dedup hit. */
  erpWriteBackId?: InputMaybe<StringOperationFilterInput>;
  /** Document id — composite {TenantId}-{RetailCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Idempotency key (the legacy idempotentKey). Unique per (tenant, key): a duplicate submit
   * with the same key returns the existing record without re-enqueuing a write-back, so a PWA retry
   * / offline replay never double-posts to Nav.
   */
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  /** The Nav item / SKU this count concerns; empty when only the product id is supplied. */
  itemReference?: InputMaybe<StringOperationFilterInput>;
  /** The latitude where the count was recorded; 0 when not captured. */
  latitude?: InputMaybe<FloatOperationFilterInput>;
  /** The retail customer/store location this count was recorded at (the legacy LocationId). */
  locationId?: InputMaybe<StringOperationFilterInput>;
  /** The longitude where the count was recorded; 0 when not captured. */
  longitude?: InputMaybe<FloatOperationFilterInput>;
  /** Free-form field-user note; empty when none. */
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RetailProductCountDocumentFilterInput>>;
  /** The Nav product id this count concerns (the legacy ProductId). */
  productId?: InputMaybe<StringOperationFilterInput>;
  /** The product-count quantity delta the field user recorded. */
  quantityChange?: InputMaybe<DecimalOperationFilterInput>;
  /** The server-generated audit-record id, distinct from the composite Id. */
  retailCountId?: InputMaybe<StringOperationFilterInput>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The unit of measure for the count (e.g. EA, FLAT); empty when not supplied. */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** The unit / case-pack quantity delta the field user recorded (legacy UnitQuantityChange). */
  unitQuantityChange?: InputMaybe<DecimalOperationFilterInput>;
  /** The field user (email) who recorded the count, from the authenticated principal. */
  user?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Immutable audit record for a single retail store product count recorded by a BPF field user at a
 * retail customer location — the wsapi-resident replacement for the legacy
 * InventoryRetail.LocationProductCount rows. Written exactly once per logical count
 * (idempotency-key deduped); never updated after creation. The ERP write-back enqueue
 * (workflow = Retail, destined for the post-back worker → Nav CustomerInventoryLog)
 * follows this write.
 *
 * This domain is part of the Bonnie-bespoke inventory feature and is deliberately ISOLATED from the
 * shared InventoryItem domain — no InventoryEvents, no InventoryItems/
 * RestockAvailability writes. Nav is the source of truth.
 *
 *
 * Query OUTPUT / [UseFiltering] source only — optional fields use plain strings (empty when
 * not applicable), never Option<T>, which would leak as a broken
 * OptionOf{X}FilterInput.
 */
export type RetailProductCountDocumentSortInput = {
  /**
   * The BP organic lot code assigned to this count; empty for non-organic products. Drives the
   * BP-lot organic tracking surface (retailAvailableBpLots / stationBpLotInventory).
   */
  bpLotCode?: InputMaybe<SortEnumType>;
  /** The kind of count recorded (DropOff / Credit / CycleCount / MustGo). */
  countType?: InputMaybe<SortEnumType>;
  /** When the count was recorded. */
  createdAt?: InputMaybe<SortEnumType>;
  /** The retail customer reference this location belongs to; empty when not resolved client-side. */
  customerReference?: InputMaybe<SortEnumType>;
  /** The ERP write-back queue record id this count enqueued; empty if enqueue was skipped on a dedup hit. */
  erpWriteBackId?: InputMaybe<SortEnumType>;
  /** Document id — composite {TenantId}-{RetailCountId}. Always route through GetDocumentId. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Idempotency key (the legacy idempotentKey). Unique per (tenant, key): a duplicate submit
   * with the same key returns the existing record without re-enqueuing a write-back, so a PWA retry
   * / offline replay never double-posts to Nav.
   */
  idempotencyKey?: InputMaybe<SortEnumType>;
  /** The Nav item / SKU this count concerns; empty when only the product id is supplied. */
  itemReference?: InputMaybe<SortEnumType>;
  /** The latitude where the count was recorded; 0 when not captured. */
  latitude?: InputMaybe<SortEnumType>;
  /** The retail customer/store location this count was recorded at (the legacy LocationId). */
  locationId?: InputMaybe<SortEnumType>;
  /** The longitude where the count was recorded; 0 when not captured. */
  longitude?: InputMaybe<SortEnumType>;
  /** Free-form field-user note; empty when none. */
  note?: InputMaybe<SortEnumType>;
  /** The Nav product id this count concerns (the legacy ProductId). */
  productId?: InputMaybe<SortEnumType>;
  /** The product-count quantity delta the field user recorded. */
  quantityChange?: InputMaybe<SortEnumType>;
  /** The server-generated audit-record id, distinct from the composite Id. */
  retailCountId?: InputMaybe<SortEnumType>;
  /** The owning tenant (always BPF). Every read filters on this for multi-tenant isolation. */
  tenantId?: InputMaybe<SortEnumType>;
  /** The unit of measure for the count (e.g. EA, FLAT); empty when not supplied. */
  unit?: InputMaybe<SortEnumType>;
  /** The unit / case-pack quantity delta the field user recorded (legacy UnitQuantityChange). */
  unitQuantityChange?: InputMaybe<SortEnumType>;
  /** The field user (email) who recorded the count, from the authenticated principal. */
  user?: InputMaybe<SortEnumType>;
};

/**
 * Single-record payload for the retail product-count mutation. Carries the audit record on success,
 * or the validation error(s) on failure (including the BPF-only tenant rejection).
 */
export type RetailProductCountPayload = {
  __typename?: 'RetailProductCountPayload';
  count?: Maybe<RetailProductCountDocument>;
  errors?: Maybe<Array<ValidationError>>;
};

/** A connection to a list of items. */
export type RetailProductCountsConnection = {
  __typename?: 'RetailProductCountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RetailProductCountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RetailProductCountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RetailProductCountsEdge = {
  __typename?: 'RetailProductCountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RetailProductCountDocument;
};

/** The alias to retire. */
export type RetireVendorItemAliasInput = {
  /** The alias id. */
  aliasId: Scalars['String']['input'];
};

export type RetireVolumePoolInput = {
  id: Scalars['String']['input'];
};

/** One user stripRetiredUserRoles found holding a retired role. */
export type RetiredUserRoleStrip = {
  __typename?: 'RetiredUserRoleStrip';
  /** The user's email. */
  email: Scalars['String']['output'];
  /** Why this user was not stripped. Null when it was, and on a dry run. */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * The roles the user holds after the strip, or would on a dry run. The same as rolesBefore when
   * the strip failed for this user.
   */
  rolesAfter: Array<UserRole>;
  /** The roles the directory row held when the run read it. */
  rolesBefore: Array<UserRole>;
  /** The user's tenant. */
  tenantId: Scalars['String']['output'];
  /** The user. */
  userId: Scalars['String']['output'];
};

/** Input for the retry-invoice-export mutation. */
export type RetryInvoiceExportInput = {
  /**
   * The issued invoice whose QuickBooks export is being re-armed. The invoice id is the id of the order it
   * bills, and it is also the export's key — which is why the same invoice can only ever have one export.
   */
  invoiceId: Scalars['String']['input'];
};

/** Payload returned from the retry-invoice-export mutation. */
export type RetryInvoiceExportPayload = {
  __typename?: 'RetryInvoiceExportPayload';
  /** Populated only when the request was refused, in which case nothing was re-armed. */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * Where the invoice's QuickBooks export stands after being re-armed — PENDING, keeping the id of any
   * QuickBooks invoice it already became. Null when the request was refused.
   */
  export?: Maybe<QuickBooksExportState>;
  /** Whether the export was re-armed. */
  success: Scalars['Boolean']['output'];
};

/** Input for the retry-payment-export mutation. */
export type RetryPaymentExportInput = {
  /**
   * The payment line whose accounting export is being re-armed — the paymentId on the invoice or
   * order payment entry.
   */
  paymentId: Scalars['String']['input'];
};

/** Payload returned from the retry-payment-export mutation. */
export type RetryPaymentExportPayload = {
  __typename?: 'RetryPaymentExportPayload';
  /** Populated only when the request was refused, in which case nothing was re-armed. */
  errors?: Maybe<Array<ValidationError>>;
  /** Whether the export was re-armed. */
  success: Scalars['Boolean']['output'];
  /** Where the payment stands after the re-arm — PENDING. Null when the request was refused. */
  syncStatus?: Maybe<PaymentSyncStatus>;
};

/** Checks an import's rows again. Rows that have imported are never checked again. */
export type RevalidateImportInput = {
  /** The import to check again. */
  asyncImportJobId: Scalars['String']['input'];
  /**
   * Only these rows, when given (e.g. the one row just fixed); every row that has not imported
   *             when omitted.
   */
  rowIndexes?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * How completely a tenant's revenue routing is configured, for the accounting routing card: how
 * many of each rung's records carry an income GL mapping, whether the tenant default is set, every
 * mapping that points at an archived account, and the items whose categories disagree.
 *
 *
 * The counts answer "how much of this rung is mapped", not "how much of it routes" — a mapped
 * customer type still loses to nothing, and a mapped item still loses to its customer type. What
 * actually routes for one item is the effectiveIncomeGlAccount preview.
 */
export type RevenueRoutingCoverage = {
  __typename?: 'RevenueRoutingCoverage';
  /** Categories naming a category-level income GL account. */
  categoriesMapped: Scalars['Int']['output'];
  /** Every category the tenant still has — deleted ones excluded. */
  categoriesTotal: Scalars['Int']['output'];
  /**
   * How many items sit in two or more mapped categories pointing at DIFFERENT accounts. EXACT,
   * however many there are — this is the number the routing card shows. The category rung is
   * skipped for each of these items and routing falls to the tenant default.
   */
  categoryConflictCount: Scalars['Int']['output'];
  /**
   * The first 100 of those items, so the card can link into a filtered items grid. A SAMPLE, not
   * the set: when categoryConflictCount is larger than this list, the rest are found by filtering
   * the items grid rather than by paging this field. Empty when the count is zero.
   */
  categoryConflictItemIds: Array<Scalars['String']['output']>;
  /**
   * Customer types that can route revenue: live, active, and naming a revenue GL account. An
   * inactive or deleted type is never a routing source however it is mapped, so it is excluded
   * here even when it still carries an account.
   */
  customerTypesMapped: Scalars['Int']['output'];
  /** Every customer type the tenant still has — deleted ones excluded. */
  customerTypesTotal: Scalars['Int']['output'];
  /**
   * Whether the tenant default income account is set AND still resolves to an account that is
   * not archived — i.e. whether the last rung before UNMAPPED can actually fire. A default
   * pointing at an archived account reads false here and is named in staleMappings.
   */
  defaultSet: Scalars['Boolean']['output'];
  /** Items naming an item-level income GL account. */
  itemsMapped: Scalars['Int']['output'];
  /** Every item the tenant still has — deleted ones excluded. */
  itemsTotal: Scalars['Int']['output'];
  /**
   * Every income GL mapping that points at an ARCHIVED account, one entry per level and account.
   * These mappings look configured and silently do not route, because an archived account is
   * skipped at every rung.
   */
  staleMappings: Array<StaleRevenueMapping>;
};

export type RevertCustomerCombineInput = {
  loserId: Scalars['String']['input'];
};

export type RevertCustomerCombinePayload = {
  __typename?: 'RevertCustomerCombinePayload';
  errors?: Maybe<Array<ValidationError>>;
  loserId?: Maybe<Scalars['String']['output']>;
  survivorId?: Maybe<Scalars['String']['output']>;
};

export type RevertItemCombineInput = {
  loserId: Scalars['String']['input'];
};

export type RevertItemCombinePayload = {
  __typename?: 'RevertItemCombinePayload';
  errors?: Maybe<Array<ValidationError>>;
  loserId?: Maybe<Scalars['String']['output']>;
  survivorId?: Maybe<Scalars['String']['output']>;
};

export type RevertProductionCatalogCombineInput = {
  loserId: Scalars['String']['input'];
};

export type RevertProductionCatalogCombinePayload = {
  __typename?: 'RevertProductionCatalogCombinePayload';
  /** Why the revert was refused; null when it succeeded. */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * The sales items whose forecast lines stayed on the survivor's items because they changed after the combine.
   * Empty when every recorded sales item was restored, null on error.
   */
  forecastSalesItemIdsNotRestored?: Maybe<Array<Scalars['String']['output']>>;
  /** The catalog that is active again; null on error. */
  loserId?: Maybe<Scalars['String']['output']>;
  /** The catalog the combined one was absorbed into; null on error. */
  survivorId?: Maybe<Scalars['String']['output']>;
};

export type RevertProductionItemCombineInput = {
  loserId: Scalars['String']['input'];
};

export type RevertProductionItemCombinePayload = {
  __typename?: 'RevertProductionItemCombinePayload';
  /** Why the revert was refused; null when it succeeded. */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * The sales items whose forecast lines stayed on the survivor because they changed after the combine.
   * Empty when every recorded sales item was restored, null on error.
   */
  forecastSalesItemIdsNotRestored?: Maybe<Array<Scalars['String']['output']>>;
  /** The item that is active again; null on error. */
  loserId?: Maybe<Scalars['String']['output']>;
  /** The item the combined one was absorbed into; null on error. */
  survivorId?: Maybe<Scalars['String']['output']>;
};

export type RevertShipToCombineInput = {
  customerId: Scalars['String']['input'];
  loserLocationId: Scalars['String']['input'];
};

export type RevertShipToCombinePayload = {
  __typename?: 'RevertShipToCombinePayload';
  customerId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  loserLocationId?: Maybe<Scalars['String']['output']>;
  survivorLocationId?: Maybe<Scalars['String']['output']>;
};

export type RevertSubLocationCombineInput = {
  loserLocationId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type RevertSubLocationCombinePayload = {
  __typename?: 'RevertSubLocationCombinePayload';
  errors?: Maybe<Array<ValidationError>>;
  loserLocationId?: Maybe<Scalars['String']['output']>;
  survivorLocationId?: Maybe<Scalars['String']['output']>;
};

export type RevertTermsCombineInput = {
  loserId: Scalars['String']['input'];
};

export type RevertTermsCombinePayload = {
  __typename?: 'RevertTermsCombinePayload';
  errors?: Maybe<Array<ValidationError>>;
  loserId?: Maybe<Scalars['String']['output']>;
  survivorId?: Maybe<Scalars['String']['output']>;
};

/** A staff review of one suggestion. */
export type ReviewOnboardingParsingSuggestionInput = {
  /** The stream revision the suggestion was listed with. */
  observedStreamRevision: Scalars['Long']['input'];
  /** The review state to set. */
  reviewState: OnboardingParsingSuggestionReviewState;
  /** A short staff note, at most 500 characters. Empty clears it. */
  staffNote?: InputMaybe<Scalars['String']['input']>;
  /** The suggestion, as the staff query listed it. */
  suggestionId: Scalars['String']['input'];
  /** The tenant the suggestion belongs to, as the staff query listed it. */
  tenantId: Scalars['String']['input'];
};

/** The result of a review, or why it was refused. */
export type ReviewOnboardingParsingSuggestionPayload = {
  __typename?: 'ReviewOnboardingParsingSuggestionPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<ReviewOnboardingParsingSuggestionResult>;
};

/** A suggestion's review as it stands after a review command. */
export type ReviewOnboardingParsingSuggestionResult = {
  __typename?: 'ReviewOnboardingParsingSuggestionResult';
  /** Whether the review was appended, changed nothing or was stale. */
  outcome: OnboardingParsingSuggestionReviewOutcome;
  /** The current review state. */
  reviewState: OnboardingParsingSuggestionReviewState;
  /** The current staff note. */
  staffNote?: Maybe<Scalars['String']['output']>;
  /** The suggestion's stream revision now. A listed suggestion at a lower revision has not caught up yet. */
  streamRevision: Scalars['Long']['output'];
  /** The suggestion. */
  suggestionId: Scalars['String']['output'];
  /** The tenant the suggestion belongs to. */
  tenantId: Scalars['String']['output'];
};

/** The unapplied credit to mark reviewed. */
export type ReviewOnlinePaymentCreditInput = {
  /** The payment that left it. */
  attemptId: Scalars['String']['input'];
  /** The invoice whose share left it. */
  invoiceId: Scalars['String']['input'];
  /** What staff note. Optional. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** The result of marking credit reviewed. */
export type ReviewOnlinePaymentCreditPayload = {
  __typename?: 'ReviewOnlinePaymentCreditPayload';
  /** The credit as it stands after the review; null on error. */
  credit?: Maybe<OnlinePaymentUnappliedCredit>;
  /** Why it was refused, when it was. */
  errors?: Maybe<Array<ValidationError>>;
};

/** Saves one reviewer decision on one extracted row. */
export type ReviewSupplierPriceImportRowInput = {
  /** The explicit decision to save the base while the royalty stays unconfirmed. */
  baseOnlyIntent: Scalars['Boolean']['input'];
  /** The base per each the reviewer accepts, as a number. */
  basePerEach?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * The base per each as exact decimal text, in the same form addEffectiveMaterialPrice and
   * correctMaterialPrice take. Send this rather than basePerEach, which a JSON client can only send as a
   * double, so every digit the reviewer typed is saved. When both are sent they must be the same amount;
   * a pair that disagrees is refused rather than one of them being picked.
   */
  basePerEachText?: InputMaybe<Scalars['String']['input']>;
  /** The review revision the reviewer read. A save against any other revision is refused. */
  expectedReviewRevision: Scalars['Int']['input'];
  /** The import the row belongs to. */
  importId: Scalars['String']['input'];
  /** Anything the reviewer wants recorded against the row. */
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  /** The royalty per each the reviewer confirms, as a number. Accepted only with SPECIFIED. */
  royaltyPerEach?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * The royalty per each as exact decimal text. Send this rather than royaltyPerEach for the same reason
   * as basePerEachText; when both are sent they must be the same amount. Accepted only with SPECIFIED.
   */
  royaltyPerEachText?: InputMaybe<Scalars['String']['input']>;
  /** Which of the reviewed royalty states the reviewer is asserting. */
  royaltyReviewState: SupplierPriceImportRoyaltyReviewState;
  /** The extracted row being reviewed. */
  sourceRowId: Scalars['String']['input'];
};

export type ReviewedMaterialPriceSourceInput = {
  basis: MaterialPriceQuoteBasis;
  calcDecimals: Scalars['Int']['input'];
  denominator: Scalars['Decimal']['input'];
  origin: MaterialPriceComponentOrigin;
  pageReference?: InputMaybe<Scalars['String']['input']>;
  quotedUnit?: InputMaybe<Scalars['String']['input']>;
  rowReference?: InputMaybe<Scalars['String']['input']>;
  royaltyTreatment?: InputMaybe<Scalars['String']['input']>;
  sourceAmount: Scalars['String']['input'];
  sourceCurrency: Scalars['String']['input'];
  sourceDocumentId?: InputMaybe<Scalars['String']['input']>;
  sourceDraftId?: InputMaybe<Scalars['String']['input']>;
  sourceRowId?: InputMaybe<Scalars['String']['input']>;
  sourceText: Scalars['String']['input'];
  supplierDescription?: InputMaybe<Scalars['String']['input']>;
  supplierIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeDeviceCredentialInput = {
  deviceId: Scalars['String']['input'];
};

/** Input revoking an existing roster entry on a GrowerBenchmark community (contract C7). */
export type RevokeGrowerBenchmarkRosterEntryInput = {
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Identifier of the roster entry to revoke. */
  rosterEntryId: Scalars['String']['input'];
};

/** Input to the revoke-invoice-pay-link mutation. */
export type RevokeInvoicePayLinkInput = {
  /** The link to revoke. */
  payLinkId: Scalars['String']['input'];
  /** Why it is being revoked. Required. */
  reason: Scalars['String']['input'];
};

/**
 * Removes a user's access to one or more of a parent company's member tenants by deactivating their
 * directory entry there. Their login is untouched and access can be granted again later.
 */
export type RevokeParentCompanyTenantAccessInput = {
  fusionAuthUserId: Scalars['String']['input'];
  parentCompanyId: Scalars['String']['input'];
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** RFID scan document - one per serial/location/day, updated throughout the day */
export type RfidScanDocument = {
  __typename?: 'RfidScanDocument';
  /** When this record was first created */
  createdAt: Scalars['DateTime']['output'];
  /** WorkSuite customer ID */
  customerId: Scalars['String']['output'];
  /** Composite ID: {TenantId}_{SerialId}_{LocationId}_{yyyy-MM-dd} */
  id: Scalars['String']['output'];
  /** WorkSuite item ID */
  itemId: Scalars['String']['output'];
  /** Location where scan occurred */
  locationId: Scalars['String']['output'];
  /** Quantity scanned (typically 1) */
  quantity: Scalars['Int']['output'];
  /** Type of RFID record */
  recordType: Scalars['Int']['output'];
  /** Client timestamp when scan was recorded */
  recordedAt: Scalars['DateTime']['output'];
  /** Salesperson or purchaser identifier */
  salespersonPurchaserId: Scalars['String']['output'];
  /** Date component for natural key */
  scanDate: Scalars['LocalDate']['output'];
  /** EPC - unique RFID tag identifier */
  serialId: Scalars['String']['output'];
  /** When this record was synced to external system (null = not synced) */
  syncDate?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  /** When this record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** RFID scan document - one per serial/location/day, updated throughout the day */
export type RfidScanDocumentFilterInput = {
  and?: InputMaybe<Array<RfidScanDocumentFilterInput>>;
  /** When this record was first created */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** WorkSuite customer ID */
  customerId?: InputMaybe<StringOperationFilterInput>;
  /** Composite ID: {TenantId}_{SerialId}_{LocationId}_{yyyy-MM-dd} */
  id?: InputMaybe<StringOperationFilterInput>;
  /** WorkSuite item ID */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** Location where scan occurred */
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RfidScanDocumentFilterInput>>;
  /** Quantity scanned (typically 1) */
  quantity?: InputMaybe<IntOperationFilterInput>;
  /** Type of RFID record */
  recordType?: InputMaybe<IntOperationFilterInput>;
  /** Client timestamp when scan was recorded */
  recordedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Salesperson or purchaser identifier */
  salespersonPurchaserId?: InputMaybe<StringOperationFilterInput>;
  /** Date component for natural key */
  scanDate?: InputMaybe<LocalDateOperationFilterInput>;
  /** EPC - unique RFID tag identifier */
  serialId?: InputMaybe<StringOperationFilterInput>;
  /** When this record was synced to external system (null = not synced) */
  syncDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** RFID scan document - one per serial/location/day, updated throughout the day */
export type RfidScanDocumentSortInput = {
  /** When this record was first created */
  createdAt?: InputMaybe<SortEnumType>;
  /** WorkSuite customer ID */
  customerId?: InputMaybe<SortEnumType>;
  /** Composite ID: {TenantId}_{SerialId}_{LocationId}_{yyyy-MM-dd} */
  id?: InputMaybe<SortEnumType>;
  /** WorkSuite item ID */
  itemId?: InputMaybe<SortEnumType>;
  /** Location where scan occurred */
  locationId?: InputMaybe<SortEnumType>;
  /** Quantity scanned (typically 1) */
  quantity?: InputMaybe<SortEnumType>;
  /** Type of RFID record */
  recordType?: InputMaybe<SortEnumType>;
  /** Client timestamp when scan was recorded */
  recordedAt?: InputMaybe<SortEnumType>;
  /** Salesperson or purchaser identifier */
  salespersonPurchaserId?: InputMaybe<SortEnumType>;
  /** Date component for natural key */
  scanDate?: InputMaybe<SortEnumType>;
  /** EPC - unique RFID tag identifier */
  serialId?: InputMaybe<SortEnumType>;
  /** When this record was synced to external system (null = not synced) */
  syncDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** When this record was last updated */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** RFID scan input data */
export type RfidScanInputDataInput = {
  customerId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  recordType: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
  salespersonPurchaserId: Scalars['String']['input'];
  serialId: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type RfidScansConnection = {
  __typename?: 'RfidScansConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RfidScansEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RfidScanDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RfidScansEdge = {
  __typename?: 'RfidScansEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RfidScanDocument;
};

export type RoundRestockSessionOrderQuantityToFullCartInput = {
  customerLocationIds: Array<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};

/**
 * MongoDB read-model document for a tenant's route -> delivery-schedule mappings — the sparse
 * route-code -> DeliveryScheduleId map that AllowedDeliveryDaysResolver consults when a
 * ship-to location has no explicit schedule. There is exactly one document per tenant; Id
 * equals TenantId today, but use GetDocumentId for all reads/writes. Mirrors
 * OrderEmailRecipientRoutingDocument.
 */
export type RouteDeliveryScheduleConfigDocument = {
  __typename?: 'RouteDeliveryScheduleConfigDocument';
  entries: Array<RouteDeliveryScheduleEntryDocument>;
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
};

export type RouteDeliveryScheduleConfigPayload = {
  __typename?: 'RouteDeliveryScheduleConfigPayload';
  errors?: Maybe<Array<ValidationError>>;
  routeDeliveryScheduleConfig?: Maybe<RouteDeliveryScheduleConfigStateData>;
};

/**
 * A tenant's route -> delivery-schedule config: the sparse set of routes that have an explicit
 * schedule mapping. A route absent from Entries has no mapping (portal delivery dates fall
 * through to the next resolution tier).
 */
export type RouteDeliveryScheduleConfigStateData = {
  __typename?: 'RouteDeliveryScheduleConfigStateData';
  entries: Array<RouteDeliveryScheduleEntryData>;
  tenantId: Scalars['String']['output'];
};

/** One route-code -> delivery-schedule mapping, as exposed on the GraphQL contract. */
export type RouteDeliveryScheduleEntryData = {
  __typename?: 'RouteDeliveryScheduleEntryData';
  deliveryScheduleId: Scalars['String']['output'];
  routeCode: Scalars['String']['output'];
};

/**
 * One sparse-map entry: a route explicitly mapped to a delivery schedule. Absent from
 * Entries means "route has no mapping".
 * Route codes match case-insensitively at read time; the stored casing is the latest SET's
 * casing (the projection's case-insensitive pull converges to at most one entry per route).
 */
export type RouteDeliveryScheduleEntryDocument = {
  __typename?: 'RouteDeliveryScheduleEntryDocument';
  /** The referenced delivery schedule's name, weekday flags, and status, resolved at query time so a rename, day-toggle, or status change is reflected immediately. Null when the mapping carries no schedule id, or the schedule has been deleted or no longer exists. An inactivated schedule is NOT null here — it resolves with status INACTIVE so callers can flag the mapping as unenforced. Served by the same batched lookup as deliveryScheduleName, so selecting both costs one query, not two. */
  deliverySchedule?: Maybe<DeliveryScheduleSummaryData>;
  deliveryScheduleId: Scalars['String']['output'];
  /** The referenced schedule's name, or an empty string when the mapping carries no schedule id or the schedule no longer exists. Retained for existing clients; new clients should prefer deliverySchedule.name, which distinguishes a missing schedule (null) from one genuinely named an empty string. */
  deliveryScheduleName: Scalars['String']['output'];
  routeCode: Scalars['String']['output'];
};

/**
 * The distinct route codes in use across this tenant. Values appear automatically as customers,
 * ship-tos, orders and the tenant default route are saved; casing variants collapse to a single
 * entry that keeps the first spelling seen. Two tenants using the same route code each get their
 * own entry.
 */
export type RouteDocument = {
  __typename?: 'RouteDocument';
  /**
   * Composite identifier in the form tenant id, hyphen, case-folded route code — unique per
   * tenant, and the same for every casing variant of one route.
   */
  id: Scalars['String']['output'];
  /**
   * The route code as it is displayed: the FIRST spelling seen for this entry, trimmed, with
   * casing preserved exactly as it was typed. Later saves of a different casing match the same
   * entry rather than adding one, and never rewrite this spelling.
   */
  route: Scalars['String']['output'];
  /**
   * The tenant this route belongs to. Two tenants using the same route code each get their own
   * entry, so a route code is never shared across tenants.
   */
  tenantId: Scalars['String']['output'];
};

/**
 * The distinct route codes in use across this tenant. Values appear automatically as customers,
 * ship-tos, orders and the tenant default route are saved; casing variants collapse to a single
 * entry that keeps the first spelling seen. Two tenants using the same route code each get their
 * own entry.
 */
export type RouteDocumentFilterInput = {
  and?: InputMaybe<Array<RouteDocumentFilterInput>>;
  /**
   * Composite identifier in the form tenant id, hyphen, case-folded route code — unique per
   * tenant, and the same for every casing variant of one route.
   */
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RouteDocumentFilterInput>>;
  /**
   * The route code as it is displayed: the FIRST spelling seen for this entry, trimmed, with
   * casing preserved exactly as it was typed. Later saves of a different casing match the same
   * entry rather than adding one, and never rewrite this spelling.
   */
  route?: InputMaybe<StringOperationFilterInput>;
  /**
   * The tenant this route belongs to. Two tenants using the same route code each get their own
   * entry, so a route code is never shared across tenants.
   */
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * The distinct route codes in use across this tenant. Values appear automatically as customers,
 * ship-tos, orders and the tenant default route are saved; casing variants collapse to a single
 * entry that keeps the first spelling seen. Two tenants using the same route code each get their
 * own entry.
 */
export type RouteDocumentSortInput = {
  /**
   * Composite identifier in the form tenant id, hyphen, case-folded route code — unique per
   * tenant, and the same for every casing variant of one route.
   */
  id?: InputMaybe<SortEnumType>;
  /**
   * The route code as it is displayed: the FIRST spelling seen for this entry, trimmed, with
   * casing preserved exactly as it was typed. Later saves of a different casing match the same
   * entry rather than adding one, and never rewrite this spelling.
   */
  route?: InputMaybe<SortEnumType>;
  /**
   * The tenant this route belongs to. Two tenants using the same route code each get their own
   * entry, so a route code is never shared across tenants.
   */
  tenantId?: InputMaybe<SortEnumType>;
};

/** Sends a document to a place that makes something from it. */
export type RouteInboundDocumentInput = {
  /** The vendor or customer, when the place needs one. */
  counterparty?: InputMaybe<InboundDocumentCounterpartyInput>;
  /** The document id. */
  documentId: Scalars['String']['input'];
  /** Where to send the document. */
  target: InboundDocumentTarget;
};

/** One driving-order stop as read. Isolated document-layer shape. */
export type RouteStopData = {
  __typename?: 'RouteStopData';
  address: Scalars['String']['output'];
  customerLocationId?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mileage?: Maybe<Scalars['Float']['output']>;
  notes: Scalars['String']['output'];
  routeStopId: Scalars['String']['output'];
  transitDays: Scalars['Int']['output'];
};

/** One driving-order stop as read. Isolated document-layer shape. */
export type RouteStopDataFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<RouteStopDataFilterInput>>;
  customerLocationId?: InputMaybe<OptionOfStringFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  latitude?: InputMaybe<OptionOfDoubleFilterInput>;
  longitude?: InputMaybe<OptionOfDoubleFilterInput>;
  mileage?: InputMaybe<OptionOfDoubleFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RouteStopDataFilterInput>>;
  routeStopId?: InputMaybe<StringOperationFilterInput>;
  transitDays?: InputMaybe<IntOperationFilterInput>;
};

export type RouteStopDataInput = {
  address: Scalars['String']['input'];
  customerLocationId?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mileage?: InputMaybe<Scalars['Float']['input']>;
  notes: Scalars['String']['input'];
  routeStopId: Scalars['String']['input'];
  transitDays: Scalars['Int']['input'];
};

export type RouteStopStateData = {
  __typename?: 'RouteStopStateData';
  address: Scalars['String']['output'];
  customerLocationId?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mileage?: Maybe<Scalars['Float']['output']>;
  notes: Scalars['String']['output'];
  routeStopId: Scalars['String']['output'];
  transitDays: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type RoutesConnection = {
  __typename?: 'RoutesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RoutesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RouteDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RoutesEdge = {
  __typename?: 'RoutesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RouteDocument;
};

export type RowImportResultInput = {
  createdEntityId?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  rowIndex: Scalars['Int']['input'];
  status: AsyncImportRowStatus;
};

export type RowValidationResultInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  rowIndex: Scalars['Int']['input'];
  status: AsyncImportRowStatus;
  warning?: InputMaybe<Scalars['String']['input']>;
};

export type RoyaltyConfig = {
  __typename?: 'RoyaltyConfig';
  payeeName: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  rateType: RoyaltyRateType;
};

/** Projection-side representation of an item's WorkSuite.Domain.Shared.RoyaltyConfig. */
export type RoyaltyConfigDocument = {
  __typename?: 'RoyaltyConfigDocument';
  payeeName: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  rateType: RoyaltyRateType;
};

/** Projection-side representation of an item's WorkSuite.Domain.Shared.RoyaltyConfig. */
export type RoyaltyConfigDocumentFilterInput = {
  and?: InputMaybe<Array<RoyaltyConfigDocumentFilterInput>>;
  or?: InputMaybe<Array<RoyaltyConfigDocumentFilterInput>>;
  payeeName?: InputMaybe<StringOperationFilterInput>;
  rate?: InputMaybe<DecimalOperationFilterInput>;
  rateType?: InputMaybe<RoyaltyRateTypeOperationFilterInput>;
};

/** Projection-side representation of an item's WorkSuite.Domain.Shared.RoyaltyConfig. */
export type RoyaltyConfigDocumentSortInput = {
  payeeName?: InputMaybe<SortEnumType>;
  rate?: InputMaybe<SortEnumType>;
  rateType?: InputMaybe<SortEnumType>;
};

export type RoyaltyConfigInput = {
  payeeName: Scalars['String']['input'];
  rate: Scalars['Decimal']['input'];
  rateType: RoyaltyRateType;
};

/** Whether a quote's royalty component is known. */
export enum RoyaltyCoverage {
  /** The royalty was reviewed: a confirmed zero or a stated amount. */
  Complete = 'COMPLETE',
  /**
   * The royalty is unknown, either never reviewed or reviewed without confirmation. The amount is not
   * zero; it is unstated, so any total carrying this quote is a known subtotal.
   */
  Incomplete = 'INCOMPLETE'
}

export enum RoyaltyRateType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

export type RoyaltyRateTypeOperationFilterInput = {
  eq?: InputMaybe<RoyaltyRateType>;
  in?: InputMaybe<Array<RoyaltyRateType>>;
  neq?: InputMaybe<RoyaltyRateType>;
  nin?: InputMaybe<Array<RoyaltyRateType>>;
};

export type RunDuplicateCheckInput = {
  entityType?: InputMaybe<DuplicateEntityType>;
};

export type RunDuplicateCheckPayload = {
  __typename?: 'RunDuplicateCheckPayload';
  errors?: Maybe<Array<ValidationError>>;
  requestId?: Maybe<Scalars['String']['output']>;
};

/** Input for runReport. */
export type RunReportInput = {
  /**
   * A 32-character dashless id the caller allocates once per run attempt, before the first call. It becomes the
   * recorded execution's id. Send the same id again to settle an attempt whose reply was lost: the retry returns
   * the execution already recorded under it and never records a second one.
   */
  executionId: Scalars['String']['input'];
  /**
   * The reviewed parameter JSON, in the shape generateReportPdf takes. When supplied it is the whole parameter
   * set the run uses; when null the run uses the parameter values saved on that version. Recorded on the execution as
   * sent.
   */
  parameters?: InputMaybe<Scalars['String']['input']>;
  /** The saved report to run. */
  reportId: Scalars['String']['input'];
  /**
   * The saved content version the caller reviewed: the newest version listed by reportVersions. The run
   * is refused, before anything is generated or recorded, when that is no longer the report's current content version.
   */
  reportVersion: Scalars['Long']['input'];
};

/** What a runReport call did. */
export enum RunReportOutcome {
  /**
   * This run was already recorded under its execution id, by an earlier call whose reply was lost or by a
   * concurrent call. That execution is returned exactly as it was recorded. No PDF is returned, because this
   * call recorded nothing and the recorded execution's file was not produced by it.
   */
  AlreadyRecorded = 'ALREADY_RECORDED',
  /** The PDF could not be generated and this call recorded a failed execution saying why. No PDF is returned. */
  GenerationFailed = 'GENERATION_FAILED',
  /** A PDF was generated and this call recorded a successful execution for it. The PDF is returned. */
  Recorded = 'RECORDED',
  /**
   * The execution record could not be confirmed, so it may or may not exist. A PDF this call generated is returned
   * but is not linked to any recorded execution. Send the same execution id again to settle it.
   */
  RecordUnconfirmed = 'RECORD_UNCONFIRMED'
}

/**
 * Payload for runReport. When the run was refused, errors says why, every other field is null, and nothing
 * was recorded by the call. Otherwise errors is null and outcome says what happened.
 */
export type RunReportPayload = {
  __typename?: 'RunReportPayload';
  /**
   * The lowercase hex SHA-256 of the bytes in pdfBase64, present exactly when pdfBase64 is. On RECORDED it equals
   * the execution's artifactSha256.
   */
  artifactSha256?: Maybe<Scalars['String']['output']>;
  /**
   * Why generation failed, for GENERATION_FAILED and for RECORD_UNCONFIRMED when generation also failed;
   * null otherwise.
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Why the run was refused; null unless it was. */
  errors?: Maybe<Array<ValidationError>>;
  /** What this call did; null when it was refused. */
  outcome?: Maybe<RunReportOutcome>;
  /**
   * The PDF this call generated, for RECORDED and for RECORD_UNCONFIRMED when generation succeeded; null
   * otherwise. Never a PDF from an earlier run.
   */
  pdfBase64?: Maybe<Scalars['String']['output']>;
  /**
   * The recorded execution, for RECORDED, GENERATION_FAILED and ALREADY_RECORDED; null otherwise. Its
   * executionId is the id to inspect in run history and reportExecutions.
   */
  reportExecution?: Maybe<ReportExecutionData>;
};

/**
 * Grouping dimension for the sales-by-category data source. One row is emitted per distinct
 * value of the chosen dimension.
 */
export enum SalesByCategoryGroupBy {
  /** Group by item category (first Categories entry on the joined item). */
  Category = 'CATEGORY',
  /** Group by customer (one row per customer). */
  Customer = 'CUSTOMER',
  /** Group by billing-address region (state/province). */
  Region = 'REGION'
}

/** Which order date places an order in Period A or Period B. Default is ORDER_DATE. */
export enum SalesComparisonDateBasis {
  /** The date the order was booked. */
  OrderDate = 'ORDER_DATE',
  /** The date the order shipped. Orders with no shipped date are left out. */
  ShippedDate = 'SHIPPED_DATE'
}

/**
 * Grouping dimension for the period-vs-period sales comparison data source.
 * One row is emitted per distinct value of the chosen dimension.
 */
export enum SalesComparisonGroupBy {
  /** Group by customer (one row per customer). */
  Customer = 'CUSTOMER',
  /** Group by item (one row per item / SKU). */
  Item = 'ITEM',
  /** Group by sales person. */
  SalesPerson = 'SALES_PERSON'
}

/** Metric selector for the period-vs-period sales comparison data source. */
export enum SalesComparisonMetric {
  /** Aggregate revenue (line-item dollar totals) per period. */
  Dollars = 'DOLLARS',
  /**
   * Aggregate eaches per period: each line's quantity, else its ordered quantity, summed. An each count,
   * not a count of shipping units: a line of 2 trays of 15 adds 30.
   */
  Units = 'UNITS'
}

/**
 * Sort order for the sales comparison rows. Default is PercentChangeDesc
 * so the biggest growers/decliners surface first.
 */
export enum SalesComparisonSort {
  /** Largest negative dollar/unit delta first. */
  DeltaAsc = 'DELTA_ASC',
  /** Largest positive dollar/unit delta first. */
  DeltaDesc = 'DELTA_DESC',
  /** Group label ascending (alphabetical). */
  GroupLabelAsc = 'GROUP_LABEL_ASC',
  /** Largest negative percent change first; null percent changes last. */
  PercentChangeAsc = 'PERCENT_CHANGE_ASC',
  /** Largest positive percent change first; null percent changes last. */
  PercentChangeDesc = 'PERCENT_CHANGE_DESC',
  /** Largest Period A total first. */
  PeriodATotalDesc = 'PERIOD_A_TOTAL_DESC',
  /** Largest Period B total first. */
  PeriodBTotalDesc = 'PERIOD_B_TOTAL_DESC'
}

/** A Sales Item whose code matches a production item's number. */
export type SalesItemCandidate = {
  __typename?: 'SalesItemCandidate';
  /** The candidate's code (SKU). */
  salesItemCode: Scalars['String']['output'];
  /** Id of the candidate Sales Item. */
  salesItemId: Scalars['String']['output'];
  /** The candidate's display name. */
  salesItemName: Scalars['String']['output'];
};

export type SalesPersonData = {
  __typename?: 'SalesPersonData';
  emailAddress: EmailAddressData;
};

export type SalesPersonDataFilterInput = {
  and?: InputMaybe<Array<SalesPersonDataFilterInput>>;
  emailAddress?: InputMaybe<EmailAddressDataFilterInput>;
  or?: InputMaybe<Array<SalesPersonDataFilterInput>>;
};

export type SalesPersonDataInput = {
  emailAddress: EmailAddressDataInput;
};

export type SalesPersonMapDataInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type SaveConsolidationRulesInput = {
  demand: ConsolidationDemandRulesInput;
  expectedVersion: Scalars['Int']['input'];
  extraDemand: ConsolidationExtraDemandRulesInput;
  genusMinimum: ConsolidationGenusMinimumRulesInput;
  minimumRuns: ConsolidationMinimumRunRulesInput;
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  plannerChanges: ConsolidationPlannerChangeRulesInput;
  productionPlanIds: Array<Scalars['String']['input']>;
  readyWindows: ConsolidationReadyWindowRulesInput;
  siteLocationIds: Array<Scalars['String']['input']>;
  sites: ConsolidationSiteRulesInput;
  smallRuns: ConsolidationSmallRunRulesInput;
  tidyUp: ConsolidationTidyUpRulesInput;
};

export type SaveConsolidationRulesPayload = {
  __typename?: 'SaveConsolidationRulesPayload';
  consolidationRules?: Maybe<ConsolidationRules>;
  errors?: Maybe<Array<ValidationError>>;
  success: Scalars['Boolean']['output'];
};

/** Input saving or replacing a named compare page view owned by the calling reader (contract C1). */
export type SaveGrowerBenchmarkCompareViewInput = {
  communityId: Scalars['String']['input'];
  facets: Array<GrowerBenchmarkCohortFacetSelectionInput>;
  highlightedFirmLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  metricKeys: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  periodId: Scalars['String']['input'];
};

export type SaveRestockSessionKitCountsInput = {
  counts: Array<RestockSessionKitCountDataInput>;
  sessionId: Scalars['String']['input'];
};

export type ScalarFieldChangeProjection = {
  __typename?: 'ScalarFieldChangeProjection';
  fieldName: Scalars['String']['output'];
  hasExistingOverride: Scalars['Boolean']['output'];
  jobValue?: Maybe<Scalars['JSON']['output']>;
  recipeValue?: Maybe<Scalars['JSON']['output']>;
};

export type ScanDataInput = {
  barcode: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  scannedAt: Scalars['DateTime']['input'];
  scannedBy: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type ScavengeLogConnection = {
  __typename?: 'ScavengeLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ScavengeLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ScavengeLogDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ScavengeLogDocument = {
  __typename?: 'ScavengeLogDocument';
  checkTime: Scalars['DateTime']['output'];
  duration: Scalars['TimeSpan']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  scavengeId: Scalars['String']['output'];
  scavengeStatus?: Maybe<ScavengeStatus>;
  startTime: Scalars['DateTime']['output'];
  status: ScavengeLogStatus;
  stopRequested?: Maybe<Scalars['DateTime']['output']>;
  stopRequestedBy?: Maybe<Scalars['String']['output']>;
  stopped?: Maybe<Scalars['DateTime']['output']>;
  threadCount: Scalars['Int']['output'];
};

export type ScavengeLogDocumentFilterInput = {
  and?: InputMaybe<Array<ScavengeLogDocumentFilterInput>>;
  checkTime?: InputMaybe<DateTimeOperationFilterInput>;
  duration?: InputMaybe<TimeSpanOperationFilterInput>;
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ScavengeLogDocumentFilterInput>>;
  scavengeId?: InputMaybe<StringOperationFilterInput>;
  scavengeStatus?: InputMaybe<ScavengeStatusFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ScavengeLogStatusOperationFilterInput>;
  stopRequested?: InputMaybe<DateTimeOperationFilterInput>;
  stopRequestedBy?: InputMaybe<StringOperationFilterInput>;
  stopped?: InputMaybe<DateTimeOperationFilterInput>;
  threadCount?: InputMaybe<IntOperationFilterInput>;
};

export type ScavengeLogDocumentSortInput = {
  checkTime?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  scavengeId?: InputMaybe<SortEnumType>;
  scavengeStatus?: InputMaybe<ScavengeStatusSortInput>;
  startTime?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  stopRequested?: InputMaybe<SortEnumType>;
  stopRequestedBy?: InputMaybe<SortEnumType>;
  stopped?: InputMaybe<SortEnumType>;
  threadCount?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type ScavengeLogEdge = {
  __typename?: 'ScavengeLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScavengeLogDocument;
};

export enum ScavengeLogStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

export type ScavengeLogStatusOperationFilterInput = {
  eq?: InputMaybe<ScavengeLogStatus>;
  in?: InputMaybe<Array<ScavengeLogStatus>>;
  neq?: InputMaybe<ScavengeLogStatus>;
  nin?: InputMaybe<Array<ScavengeLogStatus>>;
};

export type ScavengeStatus = {
  __typename?: 'ScavengeStatus';
  chunksScavenged: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  eventsDeleted: Scalars['Long']['output'];
  scavengeCompletedPercent: Scalars['Int']['output'];
  scavengeId: Scalars['String']['output'];
  scavengeResult: Scalars['String']['output'];
  spaceReclaimed: Scalars['Long']['output'];
  totalEventsScanned: Scalars['Long']['output'];
};

export type ScavengeStatusFilterInput = {
  and?: InputMaybe<Array<ScavengeStatusFilterInput>>;
  chunksScavenged?: InputMaybe<IntOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  eventsDeleted?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ScavengeStatusFilterInput>>;
  scavengeCompletedPercent?: InputMaybe<IntOperationFilterInput>;
  scavengeId?: InputMaybe<StringOperationFilterInput>;
  scavengeResult?: InputMaybe<StringOperationFilterInput>;
  spaceReclaimed?: InputMaybe<LongOperationFilterInput>;
  totalEventsScanned?: InputMaybe<LongOperationFilterInput>;
};

export type ScavengeStatusSortInput = {
  chunksScavenged?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  eventsDeleted?: InputMaybe<SortEnumType>;
  scavengeCompletedPercent?: InputMaybe<SortEnumType>;
  scavengeId?: InputMaybe<SortEnumType>;
  scavengeResult?: InputMaybe<SortEnumType>;
  spaceReclaimed?: InputMaybe<SortEnumType>;
  totalEventsScanned?: InputMaybe<SortEnumType>;
};

export type ScheduleContractRecordEnrollmentRetryInput = {
  lastError: Scalars['String']['input'];
  nextAttemptAt: Scalars['DateTime']['input'];
  requestId: Scalars['String']['input'];
};

export type ScheduleContractRecordFeeRetryInput = {
  lastError: Scalars['String']['input'];
  nextAttemptAt: Scalars['DateTime']['input'];
  requestId: Scalars['String']['input'];
};

export type ScheduleInventoryTransferInput = {
  effectiveDate: Scalars['LocalDate']['input'];
  fixedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantityMode: ScheduledTransferQuantityMode;
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  scheduledInventoryTransferId: Scalars['String']['input'];
  toGrade?: InputMaybe<Scalars['Int']['input']>;
  toItemId: Scalars['String']['input'];
  toLocationId?: InputMaybe<Scalars['String']['input']>;
  why: Scalars['String']['input'];
};

export type ScheduleMasterOrderWeekInput = {
  lines: Array<ScheduledWeekLineDataInput>;
  masterOrderId: Scalars['String']['input'];
  order: InitializeOrderInput;
};

/** The result of scheduling one Master Order week. */
export type ScheduleMasterOrderWeekPayload = {
  __typename?: 'ScheduleMasterOrderWeekPayload';
  /** 1, or 2 when a read failed before any write and the week was tried once more. */
  attempts: Scalars['Int']['output'];
  /** Why the week stopped, when it did not reach DISCOUNT_APPLIED. */
  errors?: Maybe<Array<ValidationError>>;
  /** The Master as the link stage saved it, once that stage was acknowledged. */
  masterOrder?: Maybe<MasterOrderStateData>;
  /** The child Order id the request reserved for this week. */
  orderId: Scalars['String']['output'];
  /** What is known about the week's stages. Read it before the errors: a stage outcome is not a failure of the stages before it. */
  outcome: ScheduledWeekOutcome;
};

/**
 * One scheduled item-to-item transfer: a single inventory key to be transferred to another item on a
 * future date, with its status and, once it fires, what it moved.
 */
export type ScheduledInventoryTransferDocument = {
  __typename?: 'ScheduledInventoryTransferDocument';
  /** Why the transfer was cancelled; null when no reason was given. */
  cancelWhy?: Maybe<Scalars['String']['output']>;
  /** When the transfer was cancelled; null unless it was cancelled. */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who cancelled the transfer; null unless it was cancelled. */
  cancelledByEmail?: Maybe<Scalars['String']['output']>;
  /**
   * The UTC instant the transfer becomes due: the start of the effective date in the tenant's business time
   * zone when it was scheduled. A later change to the tenant's zone does not move it.
   */
  dueAt: Scalars['DateTime']['output'];
  /** The calendar date the transfer takes effect, in the tenant's business time zone. */
  effectiveDate: Scalars['LocalDate']['output'];
  /** When the transfer fired; null until it has. */
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Why the transfer could not fire; null unless it failed. */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The whole eaches a Fixed transfer moves; null for Remaining. */
  fixedQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The source item's name when it was scheduled. */
  fromItemName: Scalars['String']['output'];
  /** The source item's SKU when it was scheduled. */
  fromSku: Scalars['String']['output'];
  /** The source key's grade. */
  grade: Scalars['Int']['output'];
  /** The quantity left behind because it was allocated to orders; null until it has fired. */
  heldBackQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The composite read-model key, {TenantId}-{ScheduledInventoryTransferId}. */
  id: Scalars['String']['output'];
  /** The source key's item. */
  itemId: Scalars['String']['output'];
  /** The source key's location. */
  locationId: Scalars['String']['output'];
  /** The source location's name when it was scheduled. */
  locationName: Scalars['String']['output'];
  /** The quantity the transfer moved; null until it has fired. */
  movedQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** Remaining moves whatever is available when the transfer fires; Fixed moves a fixed quantity. */
  quantityMode: ScheduledTransferQuantityMode;
  /** The count-reason code the transfer will record; null when none was given. */
  reasonCode?: Maybe<Scalars['Int']['output']>;
  /** When the transfer was scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
  /** Who scheduled the transfer. */
  scheduledByEmail: Scalars['String']['output'];
  /** The schedule's id: the value cancelScheduledInventoryTransfer takes. */
  scheduledInventoryTransferId: Scalars['String']['output'];
  /** How far a Fixed transfer fell short of its quantity; null until it has fired. */
  shortfallQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** Scheduled while pending; the first terminal status once it has been cancelled or has fired. */
  status: ScheduledInventoryTransferStatus;
  /** The tenant the schedule belongs to. */
  tenantId: Scalars['String']['output'];
  /** The destination grade; the source's when the scheduler did not name one. */
  toGrade: Scalars['Int']['output'];
  /** The item the stock is transferred to. */
  toItemId: Scalars['String']['output'];
  /** The destination item's name when it was scheduled. */
  toItemName: Scalars['String']['output'];
  /** The destination location; the source's when the scheduler did not name one. */
  toLocationId: Scalars['String']['output'];
  /** The destination location's name when it was scheduled. */
  toLocationName: Scalars['String']['output'];
  /** The destination item's SKU when it was scheduled. */
  toSku: Scalars['String']['output'];
  /** The id pairing the two inventory ledger rows the transfer wrote; null until it has fired. */
  transferId?: Maybe<Scalars['String']['output']>;
  /** Why the transfer was scheduled. */
  why: Scalars['String']['output'];
};

/**
 * One scheduled item-to-item transfer: a single inventory key to be transferred to another item on a
 * future date, with its status and, once it fires, what it moved.
 */
export type ScheduledInventoryTransferDocumentFilterInput = {
  and?: InputMaybe<Array<ScheduledInventoryTransferDocumentFilterInput>>;
  /** The source key's grade. */
  grade?: InputMaybe<IntOperationFilterInput>;
  /** The source key's item. */
  itemId?: InputMaybe<StringOperationFilterInput>;
  /** The source key's location. */
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ScheduledInventoryTransferDocumentFilterInput>>;
  /** The schedule's id: the value cancelScheduledInventoryTransfer takes. */
  scheduledInventoryTransferId?: InputMaybe<StringOperationFilterInput>;
  /** Scheduled while pending; the first terminal status once it has been cancelled or has fired. */
  status?: InputMaybe<ScheduledInventoryTransferStatusOperationFilterInput>;
};

/**
 * One scheduled item-to-item transfer: a single inventory key to be transferred to another item on a
 * future date, with its status and, once it fires, what it moved.
 */
export type ScheduledInventoryTransferDocumentSortInput = {
  /** Why the transfer was cancelled; null when no reason was given. */
  cancelWhy?: InputMaybe<SortEnumType>;
  /** When the transfer was cancelled; null unless it was cancelled. */
  cancelledAt?: InputMaybe<SortEnumType>;
  /** Who cancelled the transfer; null unless it was cancelled. */
  cancelledByEmail?: InputMaybe<SortEnumType>;
  /**
   * The UTC instant the transfer becomes due: the start of the effective date in the tenant's business time
   * zone when it was scheduled. A later change to the tenant's zone does not move it.
   */
  dueAt?: InputMaybe<SortEnumType>;
  /** The calendar date the transfer takes effect, in the tenant's business time zone. */
  effectiveDate?: InputMaybe<SortEnumType>;
  /** When the transfer fired; null until it has. */
  executedAt?: InputMaybe<SortEnumType>;
  /** Why the transfer could not fire; null unless it failed. */
  failureReason?: InputMaybe<SortEnumType>;
  /** The whole eaches a Fixed transfer moves; null for Remaining. */
  fixedQuantity?: InputMaybe<SortEnumType>;
  /** The source item's name when it was scheduled. */
  fromItemName?: InputMaybe<SortEnumType>;
  /** The source item's SKU when it was scheduled. */
  fromSku?: InputMaybe<SortEnumType>;
  /** The source key's grade. */
  grade?: InputMaybe<SortEnumType>;
  /** The quantity left behind because it was allocated to orders; null until it has fired. */
  heldBackQuantity?: InputMaybe<SortEnumType>;
  /** The composite read-model key, {TenantId}-{ScheduledInventoryTransferId}. */
  id?: InputMaybe<SortEnumType>;
  /** The source key's item. */
  itemId?: InputMaybe<SortEnumType>;
  /** The source key's location. */
  locationId?: InputMaybe<SortEnumType>;
  /** The source location's name when it was scheduled. */
  locationName?: InputMaybe<SortEnumType>;
  /** The quantity the transfer moved; null until it has fired. */
  movedQuantity?: InputMaybe<SortEnumType>;
  /** Remaining moves whatever is available when the transfer fires; Fixed moves a fixed quantity. */
  quantityMode?: InputMaybe<SortEnumType>;
  /** The count-reason code the transfer will record; null when none was given. */
  reasonCode?: InputMaybe<SortEnumType>;
  /** When the transfer was scheduled. */
  scheduledAt?: InputMaybe<SortEnumType>;
  /** Who scheduled the transfer. */
  scheduledByEmail?: InputMaybe<SortEnumType>;
  /** The schedule's id: the value cancelScheduledInventoryTransfer takes. */
  scheduledInventoryTransferId?: InputMaybe<SortEnumType>;
  /** How far a Fixed transfer fell short of its quantity; null until it has fired. */
  shortfallQuantity?: InputMaybe<SortEnumType>;
  /** Scheduled while pending; the first terminal status once it has been cancelled or has fired. */
  status?: InputMaybe<SortEnumType>;
  /** The destination grade; the source's when the scheduler did not name one. */
  toGrade?: InputMaybe<SortEnumType>;
  /** The item the stock is transferred to. */
  toItemId?: InputMaybe<SortEnumType>;
  /** The destination item's name when it was scheduled. */
  toItemName?: InputMaybe<SortEnumType>;
  /** The destination location; the source's when the scheduler did not name one. */
  toLocationId?: InputMaybe<SortEnumType>;
  /** The destination location's name when it was scheduled. */
  toLocationName?: InputMaybe<SortEnumType>;
  /** The destination item's SKU when it was scheduled. */
  toSku?: InputMaybe<SortEnumType>;
  /** The id pairing the two inventory ledger rows the transfer wrote; null until it has fired. */
  transferId?: InputMaybe<SortEnumType>;
  /** Why the transfer was scheduled. */
  why?: InputMaybe<SortEnumType>;
};

/** The result of executing one schedule: what happened, with the quantities that were or would be moved. */
export type ScheduledInventoryTransferExecution = {
  __typename?: 'ScheduledInventoryTransferExecution';
  /** SOURCE_KEY_MISSING, DESTINATION_ITEM_NOT_ACTIVE or HARD_GOOD_KEY; set on Failed only. */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The allocated quantity left on the source and nothing else. */
  heldBackQuantity: Scalars['Decimal']['output'];
  /** The schedule's id. */
  id: Scalars['String']['output'];
  /** The quantity moved; 0 unless Executed (and as recorded for AlreadyFinal). */
  movedQuantity: Scalars['Decimal']['output'];
  /** What this call did. */
  outcome: ScheduledInventoryTransferExecutionOutcome;
  /** The fixed quantity minus the moved quantity for a Fixed schedule; 0 for Remaining. */
  shortfallQuantity: Scalars['Decimal']['output'];
  /** The id shared by the two inventory ledger rows; set when stock moved. */
  transferId?: Maybe<Scalars['String']['output']>;
};

/** What executeScheduledInventoryTransfer did with one schedule. */
export enum ScheduledInventoryTransferExecutionOutcome {
  /** The schedule had already left Scheduled (fired or cancelled); nothing was written. */
  AlreadyFinal = 'ALREADY_FINAL',
  /** This call moved stock and recorded it. */
  Executed = 'EXECUTED',
  /** This call refused the transfer and recorded why; no inventory event was written. */
  Failed = 'FAILED',
  /** The schedule is not due yet; nothing was written. */
  NotDue = 'NOT_DUE',
  /** This call found nothing available to move and recorded that; no inventory event was written. */
  Skipped = 'SKIPPED'
}

/**
 * The result of scheduleInventoryTransfer or cancelScheduledInventoryTransfer: the schedule after the
 * write, or the errors that refused it.
 */
export type ScheduledInventoryTransferPayload = {
  __typename?: 'ScheduledInventoryTransferPayload';
  errors?: Maybe<Array<ValidationError>>;
  scheduledInventoryTransfer?: Maybe<ScheduledInventoryTransferStateData>;
};

/** A scheduled item-to-item transfer as the schedule and cancel mutations return it. */
export type ScheduledInventoryTransferStateData = {
  __typename?: 'ScheduledInventoryTransferStateData';
  /** Why the transfer was cancelled; null when no reason was given. */
  cancelWhy?: Maybe<Scalars['String']['output']>;
  /** When the transfer was cancelled; null unless it was cancelled. */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who cancelled the transfer; null unless it was cancelled. */
  cancelledByEmail?: Maybe<Scalars['String']['output']>;
  /**
   * The UTC instant the transfer becomes due: the start of the effective date in the tenant's business time zone
   * when it was scheduled. A later change to the tenant's zone does not move it.
   */
  dueAt: Scalars['DateTime']['output'];
  /** The calendar date the transfer takes effect, in the tenant's business time zone. */
  effectiveDate: Scalars['LocalDate']['output'];
  /** The whole eaches a Fixed transfer moves; null for Remaining. */
  fixedQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The source item's name when it was scheduled. */
  fromItemName: Scalars['String']['output'];
  /** The source item's SKU when it was scheduled. */
  fromSku: Scalars['String']['output'];
  /** The source key's grade. */
  grade: Scalars['Int']['output'];
  /** The source key's item. */
  itemId: Scalars['String']['output'];
  /** The source key's location. */
  locationId: Scalars['String']['output'];
  /** The source location's name when it was scheduled. */
  locationName: Scalars['String']['output'];
  /** Remaining moves whatever is available when the transfer fires; Fixed moves a fixed quantity. */
  quantityMode: ScheduledTransferQuantityMode;
  /** The count-reason code the transfer will record; null when none was given. */
  reasonCode?: Maybe<Scalars['Int']['output']>;
  /** When the transfer was scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
  /** Who scheduled the transfer. */
  scheduledByEmail: Scalars['String']['output'];
  /** The schedule's id: the value cancelScheduledInventoryTransfer takes. */
  scheduledInventoryTransferId: Scalars['String']['output'];
  /** Scheduled while pending; the first terminal status once it has been cancelled or has fired. */
  status: ScheduledInventoryTransferStatus;
  /** The tenant the schedule belongs to. */
  tenantId: Scalars['String']['output'];
  /** The destination grade; the source's when the scheduler did not name one. */
  toGrade: Scalars['Int']['output'];
  /** The item the stock is transferred to. */
  toItemId: Scalars['String']['output'];
  /** The destination item's name when it was scheduled. */
  toItemName: Scalars['String']['output'];
  /** The destination location; the source's when the scheduler did not name one. */
  toLocationId: Scalars['String']['output'];
  /** The destination location's name when it was scheduled. */
  toLocationName: Scalars['String']['output'];
  /** The destination item's SKU when it was scheduled. */
  toSku: Scalars['String']['output'];
  /** Why the transfer was scheduled. */
  why: Scalars['String']['output'];
};

export enum ScheduledInventoryTransferStatus {
  Cancelled = 'CANCELLED',
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  Scheduled = 'SCHEDULED',
  Skipped = 'SKIPPED',
  Unknown = 'UNKNOWN'
}

export type ScheduledInventoryTransferStatusOperationFilterInput = {
  eq?: InputMaybe<ScheduledInventoryTransferStatus>;
  in?: InputMaybe<Array<ScheduledInventoryTransferStatus>>;
  neq?: InputMaybe<ScheduledInventoryTransferStatus>;
  nin?: InputMaybe<Array<ScheduledInventoryTransferStatus>>;
};

/** A connection to a list of items. */
export type ScheduledInventoryTransfersConnection = {
  __typename?: 'ScheduledInventoryTransfersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ScheduledInventoryTransfersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ScheduledInventoryTransferDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ScheduledInventoryTransfersEdge = {
  __typename?: 'ScheduledInventoryTransfersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledInventoryTransferDocument;
};

export type ScheduledOrderData = {
  __typename?: 'ScheduledOrderData';
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
};

export type ScheduledOrderDataFilterInput = {
  and?: InputMaybe<Array<ScheduledOrderDataFilterInput>>;
  or?: InputMaybe<Array<ScheduledOrderDataFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  orderNumber?: InputMaybe<StringOperationFilterInput>;
};

export enum ScheduledTransferQuantityMode {
  Fixed = 'FIXED',
  Remaining = 'REMAINING',
  Unknown = 'UNKNOWN'
}

export type ScheduledWeekLineDataInput = {
  childLineId: Scalars['UUID']['input'];
  itemId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  sourceMasterLineId: Scalars['UUID']['input'];
};

export enum ScheduledWeekOutcome {
  DiscountApplied = 'DISCOUNT_APPLIED',
  Initialized = 'INITIALIZED',
  LinesAdded = 'LINES_ADDED',
  MasterLinked = 'MASTER_LINKED',
  TransientReadFailedBeforeAnyWrite = 'TRANSIENT_READ_FAILED_BEFORE_ANY_WRITE',
  Unknown = 'UNKNOWN',
  UnknownDiscountApplied = 'UNKNOWN_DISCOUNT_APPLIED',
  UnknownInitialized = 'UNKNOWN_INITIALIZED',
  UnknownLinesAdded = 'UNKNOWN_LINES_ADDED',
  UnknownMasterLinked = 'UNKNOWN_MASTER_LINKED',
  ValidationRejectedBeforeAnyWrite = 'VALIDATION_REJECTED_BEFORE_ANY_WRITE'
}

export type ScrapInventoryItemCommandInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['Int']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reason: Scalars['String']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  why: Scalars['String']['input'];
};

/**
 * Input for the idempotent legacy-holiday seed. The through-year caps the range (defaults to
 *             2035); the start is always the 2018 legacy floor so the historical window is never left short.
 */
export type SeedForecastHolidaysInput = {
  throughYear?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Outcome of a seed run: how many holidays the range produced, how many new rows were written,
 *             how many were already present (skipped), and the effective upper year.
 */
export type SeedForecastHolidaysPayload = {
  __typename?: 'SeedForecastHolidaysPayload';
  defined: Scalars['Int']['output'];
  errors?: Maybe<Array<ValidationError>>;
  requested: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  throughYear: Scalars['Int']['output'];
};

export type SelectRampEntityInput = {
  entityId: Scalars['String']['input'];
};

/** Adds one row to, or removes it from, the selection an approval would cover. */
export type SelectSupplierPriceImportRowInput = {
  expectedReviewRevision: Scalars['Int']['input'];
  importId: Scalars['String']['input'];
  selected: Scalars['Boolean']['input'];
  sourceRowId: Scalars['String']['input'];
};

export type SelectTenantEmailSenderInput = {
  channel?: InputMaybe<EmailSenderChannel>;
  expectedRevision: Scalars['Int']['input'];
  intendedUse?: InputMaybe<EmailSenderIntendedUse>;
  kind: EmailSenderSelectionKind;
  senderId?: InputMaybe<Scalars['String']['input']>;
  smtpConnectionId?: InputMaybe<Scalars['String']['input']>;
};

/** The company sender a COMPANY selection pins, as it was approved. */
export type SelectedCompanySenderData = {
  __typename?: 'SelectedCompanySenderData';
  /** Gets the connection method: SENDGRID_SINGLE (verified address), SENDGRID_DOMAIN (authenticated domain) or SMTP. */
  channel: EmailSenderChannel;
  /** Gets the display name as approved. */
  displayName: Scalars['String']['output'];
  /** Gets the from-address as approved. */
  email: Scalars['String']['output'];
  /** Gets the selectable-sender id on that channel. */
  senderId: Scalars['String']['output'];
  /** Gets the custom SMTP connection id; null unless the channel is SMTP. */
  smtpConnectionId?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for the anonymous customer-portal self-registration mutation. A self-registering buyer
 * supplies their own details plus the customer they belong to (the worksuite-pwa self-register
 * form resolves the customer for the buyer); the tenant is an explicit argument because the caller
 * is unauthenticated. The FusionAuth application + roles are NOT accepted from the caller — an
 * unauthenticated surface must not choose its own registration — they are server-determined from
 * CustomerPortalProvisioningOptions. Single-use Data type per the
 * read-model/command type-isolation convention.
 */
export type SelfRegisterPortalUserDataInput = {
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiresInDays: Scalars['Int']['input'];
  fullName: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type SellableHardgoodsConnection = {
  __typename?: 'SellableHardgoodsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SellableHardgoodsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MaterialItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SellableHardgoodsEdge = {
  __typename?: 'SellableHardgoodsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MaterialItemDocument;
};

/** Input for the send-customer-statements mutation. */
export type SendCustomerStatementsInput = {
  /**
   * The customers to send to, named explicitly. THIS LIST IS THE ENTIRE PERMISSION TO EMAIL: a customer
   * absent from it is not sent to, and an empty list is refused rather than read as "everybody".
   */
  customerIds: Array<Scalars['String']['input']>;
  /** The generated run whose statements are being sent. */
  runId: Scalars['String']['input'];
};

export type SendDeviceCommandInput = {
  command: DeviceCommandName;
  deviceId: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['String']['input']>;
};

/**
 * sendDeviceCommand's payload. changeId is populated only for SET_WIFI — the
 * correlation id the caller matches against a later lastWifiChange outcome — and is null for every
 * other command.
 */
export type SendDeviceCommandPayload = {
  __typename?: 'SendDeviceCommandPayload';
  changeId?: Maybe<Scalars['String']['output']>;
  device?: Maybe<DeviceStateData>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * Input for sendInvoiceEmail: the order id plus the compose dialog's (possibly user-edited)
 * recipients and RAW (unrendered) Handlebars subject/body — the same editable fields
 * getOrderInvoiceEmailDraft prefills — and an optional explicit docType override. The
 * tenant and user come from the caller's JWT (the email is sent from the caller's own mailbox for the
 * caller's own tenant), never from input.
 *
 * The three compose fields are NULLABLE on purpose. This mutation shipped as a one-field
 * { orderId } input, so making them required would break any caller still sending that shape;
 * each instead falls back server-side — recipients to every email of every AccountsPayable-typed
 * contact on the order's customer, falling back in turn to the order's own contact email when the
 * customer has none; subject/body to the seeded, doc-type-keyed defaults
 * (Invoice {{orderNumber}} / Order Acknowledgement {{orderNumber}} /
 * Quote {{orderNumber}}).
 */
export type SendInvoiceEmailInput = {
  /**
   * Optional, additive override of the resolved default (OrderEmailDocTypeResolution — the
   * order's live issued invoice, else its status). Omitted, the send resolves exactly the doc type it
   * always has. Supplied, it is honored only when the order accepts it
   * (OrderEmailDocTypeResolution.AllowsExplicit — always the order's own resolved default, and
   * otherwise per OrderStatusExtensions.AllowsExplicitOrderEmailDocType) — e.g. requesting
   * Acknowledgment on a Submitted order, which the default alone would resolve to the invoice —
   * else the send is rejected with DOC_TYPE_NOT_ALLOWED_FOR_STATUS.
   */
  docType?: InputMaybe<OrderEmailDocType>;
  /** Caller-edited raw body, or omitted to use the doc-type-keyed default. */
  emailBody?: InputMaybe<Scalars['String']['input']>;
  /** Caller-edited raw subject, or omitted to use the doc-type-keyed default. */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  /** The order to send a document for. */
  orderId: Scalars['String']['input'];
  /** Caller-edited recipients, or omitted to resolve the order's default recipients. */
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Result of sendInvoiceEmail: whether the invoice email was sent from the caller's own
 * mailbox and the draft's Outlook draftWebLink. On success the link points at the sent message; on
 * DRAFT_CREATED_SEND_FAILED it points at the created-but-unsent draft so the user can finish it in
 * Outlook; on every other failure it is null. Errors carry the coded validation error(s) that stopped it.
 */
export type SendInvoiceEmailPayload = {
  __typename?: 'SendInvoiceEmailPayload';
  draftWebLink?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
  sent: Scalars['Boolean']['output'];
};

/**
 * Input for sendMasterOrderEmail: the master order id plus the compose dialog's optional,
 * possibly user-edited recipients and RAW (unrendered) Handlebars subject/body. The tenant and user
 * come from the caller's JWT, never from input. The document type is always the acknowledgement.
 */
export type SendMasterOrderEmailInput = {
  /** Caller-edited raw body, or omitted to use the acknowledgement default. */
  emailBody?: InputMaybe<Scalars['String']['input']>;
  /** Caller-edited raw subject, or omitted to use the acknowledgement default. */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  /** The master order to send the acknowledgement for. */
  masterOrderId: Scalars['String']['input'];
  /** Caller-edited recipients, or omitted to resolve the master's default recipients. */
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * The senderDomainPolicy query result: the server-computed DNS/SendGrid signal the PWA uses to
 * warn before a user adds a single sender on a domain whose DNS configuration would guarantee
 * spam/quarantine treatment for an unaligned SendGrid send. Every field is null when the domain
 * could not be resolved — either it failed basic domain-format validation, or a DNS/SendGrid lookup
 * failed — so the client shows no warning rather than a false one. This fail-open behavior is
 * server-side only; it is never cached, so a transient lookup hiccup recovers on the next call.
 */
export type SenderDomainPolicyData = {
  __typename?: 'SenderDomainPolicyData';
  /**
   * The domain's DMARC enforcement policy, or null when the domain publishes no _dmarc TXT
   * record (or one without a recognized p= tag).
   */
  dmarcPolicy?: Maybe<EmailDmarcPolicy>;
  /**
   * True when the domain matches an authenticated domain on our SendGrid account (the same
   * account-wide domain-authentication lookup addTenantEmailDomain uses to grandfather an
   * already-authenticated domain). False while SendGrid has not yet validated that domain's DNS
   * records. Null only on lookup failure.
   */
  isDomainAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the domain's SPF record already authorizes SendGrid to send on its behalf (an
   * include:sendgrid.net-style mechanism). Null only on lookup failure.
   */
  spfIncludesSendgrid?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the domain's SPF record ends in a hard-fail (-all) qualifier — the
   * configuration that, combined with a quarantine/reject DMARC policy, guarantees an unaligned
   * SendGrid send is rejected or quarantined. Null only on lookup failure.
   */
  spfStrict?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Session-level restock metrics aggregated server-side for the v2 Restock Orders
 * sidebar. Seven concepts (Available / Allocated / In Transit / Available for Orders
 * / On Order / Remaining Availability / Utilization %), each with a quantity and a
 * wholesale dollar value. Per-item dedup is applied to Available, Allocated, and
 * In Transit so the same item mirrored across multiple customer-location rows is
 * counted once. Per-tenant field mapping decides which ERP source backs Allocated
 * vs. In Transit. Unclamped: RemainingAvailability may be negative to
 * signal over-allocation; UtilizationPercent returns a large sentinel
 * (9999.0) when AvailableForOrders <= 0 and OnOrder > 0.
 */
export type SessionRestockMetricsData = {
  __typename?: 'SessionRestockMetricsData';
  allocated: Scalars['Int']['output'];
  allocatedValue: Scalars['Decimal']['output'];
  available: Scalars['Int']['output'];
  availableForOrders: Scalars['Int']['output'];
  availableForOrdersValue: Scalars['Decimal']['output'];
  availableValue: Scalars['Decimal']['output'];
  inTransit: Scalars['Int']['output'];
  inTransitValue: Scalars['Decimal']['output'];
  onOrder: Scalars['Int']['output'];
  onOrderValue: Scalars['Decimal']['output'];
  remainingAvailability: Scalars['Int']['output'];
  remainingAvailabilityValue: Scalars['Decimal']['output'];
  sessionId: Scalars['String']['output'];
  utilizationPercent: Scalars['Decimal']['output'];
  utilizationPercentValue: Scalars['Decimal']['output'];
};

export type SetAccountingIntegrationConfigInput = {
  defaultIncomeAccountImportId?: InputMaybe<Scalars['String']['input']>;
  defaultIncomeAccountName?: InputMaybe<Scalars['String']['input']>;
  defaultIncomeAccountRemoteId?: InputMaybe<Scalars['String']['input']>;
  mergeDevAccountId?: InputMaybe<Scalars['String']['input']>;
  outboundDetail: OutboundDetailLevel;
  provider: AccountingProvider;
};

export type SetAccountingLineAccountsInput = {
  depositAppliedAccountId?: InputMaybe<Scalars['String']['input']>;
  freightAccountId?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargeAccountId?: InputMaybe<Scalars['String']['input']>;
  roundingAdjustmentAccountId?: InputMaybe<Scalars['String']['input']>;
  salesTaxAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type SetActiveCountSessionInput = {
  activeCountSessionId: Scalars['String']['input'];
  productionLineId: Scalars['String']['input'];
};

export type SetAdminTenantCustomerTextingInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  messagingServiceSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state: CustomerTextingState;
  submittedOn?: InputMaybe<Scalars['LocalDate']['input']>;
};

/**
 * The result of a tenant features save: the tenant's features after it, the flags it turns on or off, or the
 * errors that stopped it.
 */
export type SetAdminTenantFeaturesPayload = {
  __typename?: 'SetAdminTenantFeaturesPayload';
  /**
   * The flags the save turns on or off for the tenant, in enum order: what a dry run would do, or what the save
   * did. Empty when the save was refused.
   */
  changes: Array<AdminTenantFeatureChange>;
  /**
   * The tenant's features as they now are, with the products and each listed flag read from their streams: as
   * written after a save, as loaded after a dry run, and as saved by someone else on a TENANT_FEATURES_CONFLICT. A
   * caller can send them back as its next save's expected parts. Null for any other refusal.
   */
  data?: Maybe<AdminTenantFeatures>;
  /** Why the save was refused, or null. */
  errors?: Maybe<Array<ValidationError>>;
};

export type SetAdminTenantWorkSuiteProductsInput = {
  tenantId: Scalars['String']['input'];
  workSuiteProductIds: Array<Scalars['String']['input']>;
};

export type SetBackgroundServiceEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  serviceName: BackgroundServiceName;
};

export type SetBpfUserStartingNodesInput = {
  startingNodes: Array<BpfStartingNodeDataInput>;
  userId: Scalars['String']['input'];
};

export type SetCategoryIncomeGlAccountInput = {
  categoryId: Scalars['String']['input'];
  incomeGlAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCategoryLaborCostInput = {
  effectiveDate: Scalars['DateTime']['input'];
  laborCostPerUnit: Scalars['Decimal']['input'];
  productionCategoryId: Scalars['String']['input'];
};

export type SetCategoryUnitsPerPoleInput = {
  productionCategoryId: Scalars['String']['input'];
  unitsPerPole?: InputMaybe<Scalars['Int']['input']>;
};

export type SetCheckpointInput = {
  checkpointType: CheckpointType;
  externalId: Scalars['String']['input'];
};

export type SetCommissionDefaultRateInput = {
  newRatePercent: Scalars['Decimal']['input'];
  userId: Scalars['String']['input'];
};

export type SetConsolidationLotPinsInput = {
  pinned: Scalars['Boolean']['input'];
  productionLotIds: Array<Scalars['String']['input']>;
};

export type SetConsolidationLotPinsPayload = {
  __typename?: 'SetConsolidationLotPinsPayload';
  errors?: Maybe<Array<ValidationError>>;
  pinnedProductionLotIds: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SetConsolidationRuleSetInput = {
  customerGrouping: ConsolidationCustomerGrouping;
  direction: ConsolidationDirection;
  locationGrouping: ConsolidationLocationGrouping;
  lookBackWeeks: Scalars['Int']['input'];
  lookForwardWeeks: Scalars['Int']['input'];
  minimumLotQuantity: Scalars['Int']['input'];
  roundingUnit?: InputMaybe<Scalars['Int']['input']>;
};

export type SetContactCrmLinkInput = {
  contactId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  importId: Scalars['String']['input'];
};

export type SetContractRecordEnrollmentBackToPendingInput = {
  requestId: Scalars['String']['input'];
};

export type SetContractRecordFeeBackToPendingInput = {
  requestId: Scalars['String']['input'];
};

export type SetCountSessionTargetInput = {
  countSessionId: Scalars['String']['input'];
  newTargetQuantity: Scalars['Decimal']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SetCountedQuantityInput = {
  countSessionId: Scalars['String']['input'];
  countedQuantity: Scalars['Decimal']['input'];
};

export type SetCustomerCommissionOverrideInput = {
  customerId: Scalars['String']['input'];
  ratePercent: Scalars['Decimal']['input'];
  userId: Scalars['String']['input'];
};

export type SetCustomerCrmLinkInput = {
  crmImportId: Scalars['String']['input'];
  crmRecordUrl?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  erpId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerDefaultTagColorInput = {
  customerId: Scalars['String']['input'];
  expected?: InputMaybe<ExpectedCustomerDefaultTagColorInput>;
  tagColorId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerDepositRequirementInput = {
  customerId: Scalars['String']['input'];
  depositRequirementType?: InputMaybe<DepositRequirementType>;
  depositRequirementValue?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SetCustomerDisabledVolumePoolsInput = {
  customerId: Scalars['String']['input'];
  volumePoolIds: Array<Scalars['String']['input']>;
};

export type SetCustomerGroupInput = {
  customerGroupId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
};

export type SetCustomerItemEffectiveDatesInput = {
  customerItemId: Scalars['String']['input'];
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetCustomerItemRetailPriceInput = {
  customerItemId: Scalars['String']['input'];
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SetCustomerItemShippingUomInput = {
  customerItemId: Scalars['String']['input'];
  shippingUomId: Scalars['String']['input'];
};

export type SetCustomerLocationCoordinatesInput = {
  customerId: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  locationId: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SetCustomerLocationDeliveryScheduleInput = {
  customerId: Scalars['String']['input'];
  deliveryScheduleId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
};

export type SetCustomerLocationNoteInput = {
  context: NoteContext;
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerLocationReceivingEmailInput = {
  customerId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
};

export type SetCustomerLocationRouteInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerLocationServicingSiteInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  servicingSiteLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerMinimumFreightChargeInput = {
  clearMinimumFreightCharge?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['String']['input'];
  minimumFreightCharge?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SetCustomerNoteInput = {
  context: NoteContext;
  customerId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerOrderEntryUnitInput = {
  customerId: Scalars['String']['input'];
  orderEntryUnit?: InputMaybe<OrderEntryUnit>;
};

export type SetCustomerPriceEntryUnitInput = {
  /** The customer whose override is set or cleared. */
  customerId: Scalars['String']['input'];
  /** How sales prices are entered and shown for this customer: per each or per shipping unit. Prices are always stored and billed per each. Null clears the override so the customer follows the company default. */
  priceEntryUnit?: InputMaybe<PriceEntryUnit>;
};

export type SetCustomerRouteInput = {
  customerId: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerStatementDeliveryInput = {
  customerId: Scalars['String']['input'];
  deliveryMethod?: InputMaybe<StatementDeliveryMethod>;
  skipZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetCustomerTaxDetailsInput = {
  customerId: Scalars['String']['input'];
  exemptions: Array<CustomerTaxExemptionInput>;
  federalTaxNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerTypeInput = {
  customerId: Scalars['String']['input'];
  customerTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCustomerTypeRevenueGlAccountInput = {
  id: Scalars['String']['input'];
  revenueGlAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type SetDefaultGroupInput = {
  id: Scalars['String']['input'];
};

export type SetDefaultVendorInput = {
  id: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

export type SetDeviceDesiredConfigInput = {
  configKeys: Array<DeviceConfigKeyEntryDataInput>;
  deviceId: Scalars['String']['input'];
};

export type SetEmailSenderAdminOnlyInput = {
  adminOnly: Scalars['Boolean']['input'];
  senderId: Scalars['String']['input'];
};

export type SetErpCustomerRouteAssignmentsInput = {
  assignments: Array<ErpRouteAssignmentInput>;
  customerErpId: Scalars['String']['input'];
};

export type SetErpRouteSalespeopleInput = {
  assignments: Array<ErpSalespersonAssignmentInput>;
  name: Scalars['String']['input'];
  routeCode: Scalars['String']['input'];
  stationCode: Scalars['String']['input'];
};

export type SetErpWriteBackHoldInput = {
  hold: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
  rollback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetFavoritesListActiveInput = {
  active: Scalars['Boolean']['input'];
  favoritesListId: Scalars['String']['input'];
};

export type SetFeatureFlagTenantOverrideInput = {
  /** The tenant's settings JSON, replacing its current settings in full. Omit to keep the tenant's current settings; send {} to clear. */
  config?: InputMaybe<Scalars['String']['input']>;
  mode: TenantFlagSettingMode;
  name: FeatureFlagName;
  tenantId: Scalars['String']['input'];
};

export type SetGlobalValueInput = {
  config: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  name: FeatureFlagName;
};

/** Input setting the console billing state for a registered member firm (contract K2). */
export type SetGrowerBenchmarkFirmBillingStateInput = {
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Optional external paid-through timestamp; permitted only when source is EXTERNAL. */
  externalPaidThrough?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional external subscription status; permitted only when source is EXTERNAL. */
  externalStatus?: InputMaybe<Scalars['String']['input']>;
  /** Target registered firm identifier within the community. */
  firmId: Scalars['String']['input'];
  /** Selected billing source (EXTERNAL, WORKSUITE, or UNSET). */
  source: GrowerBenchmarkBillingSource;
};

/** Input setting the completion state of one onboarding checklist item on a GrowerBenchmark firm profile (contract K2). */
export type SetGrowerBenchmarkFirmChecklistItemInput = {
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Target registered firm identifier within the community. */
  firmId: Scalars['String']['input'];
  /** Whether the checklist item is marked complete. */
  isComplete: Scalars['Boolean']['input'];
  /** Stable checklist item key. */
  itemKey: Scalars['String']['input'];
};

/**
 * Input editing a member firm's console profile together with its community registry label and classification facets
 * (contract K2).
 */
export type SetGrowerBenchmarkFirmProfileInput = {
  /** Complete replacement cohort classification facet list for the firm. */
  classification: Array<GrowerBenchmarkClassificationFacetInput>;
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Target registered firm identifier within the community. */
  firmId: Scalars['String']['input'];
  /** Optional neutral peer-row code; leaves the stored label unchanged when omitted. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Free-form console labels attached to the firm profile. */
  tags: Array<Scalars['String']['input']>;
  /** Optional ticker symbol attached to the firm profile. */
  ticker?: InputMaybe<Scalars['String']['input']>;
};

/** Input writing or replacing the retail month figures for a reporting unit and calendar month period (contract CR2). */
export type SetGrowerBenchmarkRetailMonthValuesInput = {
  /** Warning rule codes explicitly accepted by the caller for this submission. */
  acceptedWarningCodes: Array<Scalars['String']['input']>;
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Calendar month period identifier in YYYY-MM form. */
  periodId: Scalars['String']['input'];
  /** Reporting unit identifier owned by the caller's firm. */
  reportingUnitId: Scalars['String']['input'];
  /** Retail month figures to record. */
  values: GrowerBenchmarkRetailMonthValuesInput;
};

/** Input granting or updating a user's roster entry on a GrowerBenchmark community (contract C7). */
export type SetGrowerBenchmarkRosterEntryInput = {
  /** Recorded reason why userId holds role. */
  basis: Scalars['String']['input'];
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Optional scheduled expiry timestamp. */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Roster role granted to userId. */
  role: GrowerBenchmarkRosterRole;
  /** Timestamp at which the entry's active window opens. */
  startsAt: Scalars['DateTime']['input'];
  /** Subject user identifier receiving the roster entry. */
  userId: Scalars['String']['input'];
};

/** Input transitioning an existing GrowerBenchmark submission version's status (contract C7). */
export type SetGrowerBenchmarkSubmissionStatusInput = {
  /** Requested target submission status. */
  status: GrowerBenchmarkSubmissionStatus;
  /** Target submission version identifier. */
  submissionId: Scalars['String']['input'];
};

/** Sets what a document is. */
export type SetInboundDocumentKindInput = {
  /** The document id. */
  documentId: Scalars['String']['input'];
  /** What the document is. */
  kind: InboundDocumentKind;
  /** True to use the same kind for the next document from this sender that looks the same. */
  rememberRule: Scalars['Boolean']['input'];
};

/**
 * Input of setInventoryBatchPlantDate: the inventory row, the batch it holds, and the planting fields
 * to change.
 */
export type SetInventoryBatchPlantDateInput = {
  /** The batch whose planting is edited, as typed; matched ignoring spacing and case. */
  batchCode: Scalars['String']['input'];
  /** The row's grade. */
  grade: Scalars['Int']['input'];
  /** The row's item. */
  itemId: Scalars['String']['input'];
  /** The row's location. */
  locationId: Scalars['String']['input'];
  /** The batch's plant date. Leave it out to keep the current date; send null to clear it. */
  plantDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /**
   * The batch's plant status: free text such as a secondary date or a grow location, trimmed and at most 256
   * characters. Leave it out to keep the current status; send null or blank text to clear it.
   */
  plantStatus?: InputMaybe<Scalars['String']['input']>;
};

export type SetInventoryItemInput = {
  batches?: InputMaybe<Array<InventoryBatchQuantityDataInput>>;
  grade: Scalars['Int']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemType: ItemType;
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  why: Scalars['String']['input'];
};

export type SetInventoryItemReadyDateCommandInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  readyDate: Scalars['LocalDate']['input'];
  why: Scalars['String']['input'];
};

export type SetInvoiceEmailChannelInput = {
  channel?: OrderEmailChannel;
};

export type SetItemAvailabilityPhotoPrimaryInput = {
  itemId: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  photoId: Scalars['String']['input'];
};

export type SetItemBatchTrackingInput = {
  confirmClearBatches?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  itemId: Scalars['String']['input'];
};

export type SetItemCharacteristicPickDataInput = {
  expected?: InputMaybe<ExpectedItemCharacteristicPickValueDataInput>;
  itemCharacteristicId: Scalars['String']['input'];
  valueId?: InputMaybe<Scalars['String']['input']>;
};

export type SetItemCharacteristicsInput = {
  itemId: Scalars['String']['input'];
  picks: Array<SetItemCharacteristicPickDataInput>;
};

export type SetItemContainerConfigOverrideInput = {
  containerCode: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  maxLayersPerContainer?: InputMaybe<Scalars['Int']['input']>;
  maxTraysPerLayer?: InputMaybe<Scalars['Int']['input']>;
  shipFactor?: InputMaybe<Scalars['Int']['input']>;
  shipIncrement?: InputMaybe<Scalars['Int']['input']>;
  shipMinimum?: InputMaybe<Scalars['Int']['input']>;
  shippingConfigCategoryCode: Scalars['String']['input'];
  siteCode: Scalars['String']['input'];
  sizeUomCode: Scalars['String']['input'];
};

export type SetItemDefaultTagColorInput = {
  expected?: InputMaybe<ExpectedItemTagColorInput>;
  itemId: Scalars['String']['input'];
  tagColorId?: InputMaybe<Scalars['String']['input']>;
  tagColorLocked: Scalars['Boolean']['input'];
};

export type SetItemLaborCostInput = {
  effectiveDate: Scalars['DateTime']['input'];
  laborCostPerUnit: Scalars['Decimal']['input'];
  productionItemId: Scalars['String']['input'];
};

export type SetItemNoteInput = {
  context: NoteContext;
  itemId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetItemPriceLabelInput = {
  itemId: Scalars['String']['input'];
  priceLabelId?: InputMaybe<Scalars['String']['input']>;
};

export type SetItemProductionMappingsInput = {
  lines: Array<ProductionMappingLineDataInput>;
  salesItemId: Scalars['String']['input'];
};

export type SetItemShippingUomsInput = {
  defaultShippingUomId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  shippingUomIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SetJobGrowWeeksOverrideDataInput = {
  growWeeks: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type SetJobLinksOverrideDataInput = {
  linkId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type SetJobPlannedHoursOverrideDataInput = {
  plannedHours: Scalars['Decimal']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type SetJobPlantsPerPotOverrideDataInput = {
  plantsPerPot: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  productionRecipeVariationId: Scalars['String']['input'];
};

export type SetLaborTypesInput = {
  laborTypes: Array<LaborTypeDataInput>;
  siteLocationId: Scalars['String']['input'];
};

export type SetLineItemCustomerItemInput = {
  customerItemId?: InputMaybe<Scalars['String']['input']>;
  lineItemId: Scalars['UUID']['input'];
  orderId: Scalars['String']['input'];
};

export type SetLineItemOverridePriceInput = {
  lineItemId: Scalars['UUID']['input'];
  orderId: Scalars['String']['input'];
  /** Override price for one each of the line. Send this or overrideUnitPrice, never both; both null clears the override. */
  overridePrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** Override price for one shipping unit (flat, tray) of the line, in place of overridePrice. Send this or overridePrice, never both (both is refused); both null clears the override. Prices are stored and billed per each: the server stores this ÷ the line's eaches per unit, unrounded. On a line with no shipping unit it is the per-each override. */
  overrideUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SetLineItemShippingUomInput = {
  lineItemId: Scalars['UUID']['input'];
  minimumOverrideReason?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  shippingUomId: Scalars['String']['input'];
};

export type SetLineItemTagColorsInput = {
  lines: Array<LineItemTagColorsInput>;
  orderId: Scalars['String']['input'];
};

export type SetLoadDockInput = {
  dockId: Scalars['String']['input'];
  loadId: Scalars['String']['input'];
};

export type SetLoadLineStopInput = {
  loadLineId: Scalars['String']['input'];
  routeStopId?: InputMaybe<Scalars['String']['input']>;
};

export type SetLoadMilesInput = {
  loadId: Scalars['String']['input'];
  miles: Scalars['Decimal']['input'];
};

export type SetLoadPickupWindowInput = {
  date: Scalars['LocalDate']['input'];
  from?: InputMaybe<Scalars['String']['input']>;
  loadId: Scalars['String']['input'];
  to?: InputMaybe<Scalars['String']['input']>;
};

export type SetLoadStopPlannedTimeInput = {
  loadId: Scalars['String']['input'];
  routeStopId: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type SetLoadTransitKindInput = {
  kind: TransitKind;
  loadId: Scalars['String']['input'];
};

export type SetLocationDefaultSpaceTypeInput = {
  siteLocationId: Scalars['String']['input'];
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
  subLocationId: Scalars['String']['input'];
};

export type SetLocationOrderEmailContactsInput = {
  contactIds: Array<Scalars['UUID']['input']>;
  customerId: Scalars['String']['input'];
  locationId: Scalars['UUID']['input'];
};

export type SetLocationOverheadRateInput = {
  costPerSqFtPerWeek: Scalars['Decimal']['input'];
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  siteLocationId: Scalars['String']['input'];
  subLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type SetMaterialItemBaseUnitInput = {
  baseUnit: MaterialUnit;
  id: Scalars['String']['input'];
};

/**
 * Input of setMaterialItemBatchPlantDate: the material item, the bin, the batch it holds, and the
 * planting fields to change.
 */
export type SetMaterialItemBatchPlantDateInput = {
  /** The batch whose planting is edited, as typed; matched ignoring spacing and case. */
  batchCode: Scalars['String']['input'];
  /** The bin that holds the batch. */
  locationId: Scalars['String']['input'];
  /** The material item. */
  materialItemId: Scalars['String']['input'];
  /** The batch's plant date. Leave it out to keep the current date; send null to clear it. */
  plantDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /**
   * The batch's plant status: free text such as a secondary date or a grow location, trimmed and at most 256
   * characters. Leave it out to keep the current status; send null or blank text to clear it.
   */
  plantStatus?: InputMaybe<Scalars['String']['input']>;
};

export type SetMaterialItemBatchTrackingInput = {
  confirmClearBatches?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  materialItemId: Scalars['String']['input'];
};

export type SetMaterialItemImageInput = {
  base64Image?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
};

export type SetMaterialItemTagSpecInput = {
  id: Scalars['String']['input'];
  tag: TagSpecDataInput;
};

/**
 * Boundary input for setMyLanguagePreference: the caller's own new language preference (EN or
 * ES) for the Work Suite UI. There is deliberately NO userId — the target is always the authenticated
 * caller's own directory entry (mirrors SetMyProfileImageData — no admin-sets-others in v1).
 * An out-of-schema enum literal is rejected by GraphQL at request-validation time before this
 * resolver even runs; the domain-level ValidLanguagePreference type is the backstop for any
 * other caller of the command.
 */
export type SetMyLanguagePreferenceDataInput = {
  languagePreference: LanguagePreference;
};

/**
 * Boundary input for setMyNotificationPreferences: the caller's own complete notification
 * settings. There is deliberately NO userId — the target is always the authenticated caller's own
 * directory entry (mirrors SetMyLanguagePreferenceData — no admin-sets-others in v1).
 * Single-use Data type per the command/read-model type-isolation convention.
 */
export type SetMyNotificationPreferencesDataInput = {
  emailDeliveryMode: NotificationDeliveryMode;
  emailEnabled: Scalars['Boolean']['input'];
  kindOverrides: Array<NotificationKindPreferenceInputDataInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pushEnabled: Scalars['Boolean']['input'];
  smsDeliveryMode: NotificationDeliveryMode;
  smsEnabled: Scalars['Boolean']['input'];
};

/**
 * Boundary input for setMyProfileImage: the caller's own avatar bytes (Base64) plus MIME type.
 * Both fields are nullable so the input stays additive; presence, format (jpeg/png/webp) and size
 * (<= 5 MB) are enforced during validation (ValidImageUpload). There is deliberately
 * NO userId — the target is always the authenticated caller's own directory entry (no admin-sets-others
 * in v1). Single-use Data type per the command/read-model type-isolation convention.
 */
export type SetMyProfileImageDataInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
};

export type SetMyWhatsNewEmailInput = {
  subscribed: Scalars['Boolean']['input'];
};

/** Binds one document kind to a report for a customer. A null report id clears the override. */
export type SetNotificationDocumentReportInput = {
  kind: NotificationDocumentKind;
  reportId?: InputMaybe<Scalars['String']['input']>;
  scope: NotificationOverrideScope;
  scopeId: Scalars['String']['input'];
};

/**
 * Sets one kind's recipient adjustments at a scope: derived addresses to leave out and addresses to
 * add. Both lists empty clears the override.
 */
export type SetNotificationRecipientsInput = {
  additionalEmails: Array<Scalars['String']['input']>;
  docType: OrderEmailDocType;
  excludedEmails: Array<Scalars['String']['input']>;
  scope: NotificationOverrideScope;
  scopeId: Scalars['String']['input'];
};

/** Sets one kind's send choice at a scope. Inherit clears the override. */
export type SetNotificationSendChoiceInput = {
  choice: NotificationSendChoice;
  docType: OrderEmailDocType;
  scope: NotificationOverrideScope;
  scopeId: Scalars['String']['input'];
};

/** An empty excludedMobiles list is Reset to default for that kind at that scope. */
export type SetNotificationTextRecipientsInput = {
  /** CONFIRMATION, ACKNOWLEDGMENT or INVOICE. */
  docType: OrderEmailDocType;
  excludedMobiles: Array<NotificationExcludedMobileInput>;
  scope: NotificationOverrideScope;
  scopeId: Scalars['String']['input'];
};

export type SetOrderContainerInput = {
  containerCode?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type SetOrderDropShipDestinationInput = {
  destination: DropShipDestinationDataInput;
  orderId: Scalars['String']['input'];
};

export type SetOrderEmailEnablementInput = {
  channel?: OrderEmailChannel;
  docType: OrderEmailDocType;
  enabled: Scalars['Boolean']['input'];
};

/** Sets one doc-type's routed contact type. Uses the real generated enums on the wire. */
export type SetOrderEmailRecipientRoutingInput = {
  contactType: ContactType;
  docType: OrderEmailRecipientDocType;
};

export type SetOrderEmailSettingsInput = {
  docType: OrderEmailDocType;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  includeSalesPersonCc?: InputMaybe<Scalars['Boolean']['input']>;
  includeServicingSiteManagerCc?: InputMaybe<Scalars['Boolean']['input']>;
  recipients: Array<Scalars['String']['input']>;
  senderId?: InputMaybe<Scalars['String']['input']>;
};

export type SetOrderKindInput = {
  orderId: Scalars['String']['input'];
  orderKindId?: InputMaybe<Scalars['String']['input']>;
};

/** Marks an order No tax, or changes its reason or note. Saving the reason and note the order already carries returns the ENTITY_NO_CHANGES error and records nothing. */
export type SetOrderNoTaxInput = {
  /** An optional note, at most 512 characters. Null, empty or blank means no note. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The order. Refused with ORDER_NO_TAX_STATUS_LOCKED when it is Synchronized, Cancelled or Deleted, or past Shipped and already synchronized to the ERP; with ORDER_NO_TAX_CREDIT_ORDER when it is a credit order; and with ORDER_INVOICED while it has a live invoice (a voided invoice does not count). */
  orderId: Scalars['String']['input'];
  /** Why the sale is exempt, from the same list as customer tax exemption certificates. UNKNOWN is refused. */
  reason: CustomerTaxExemptionReason;
};

export type SetOrderNoteInput = {
  context: NoteContext;
  orderId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetOrderPlannedShipDateInput = {
  orderId: Scalars['String']['input'];
  plannedShipDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetOrderProgramInput = {
  orderId: Scalars['String']['input'];
  program?: InputMaybe<Scalars['String']['input']>;
};

/** The quote details to change on a draft order (Initialized or Open). PATCH semantics: a field left out, or sent as null, keeps its current value. To remove a value use clearQuoteValidUntil, clearFollowUp, or an empty followUpNote. A save that changes nothing returns the ENTITY_NO_CHANGES error and records nothing. */
export type SetOrderQuoteDetailsInput = {
  /** True removes the whole follow-up. Refused with ORDER_QUOTE_FOLLOW_UP_CLEAR_CONFLICT when sent with followUpOn, a non-empty followUpNote, a followUpAssignee or followUpDone true; the empty values a form sends for those are ignored. Null or false changes nothing. */
  clearFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** True removes the valid-until date. Refused with ORDER_QUOTE_VALID_UNTIL_CONFLICT when sent with quoteValidUntil. Null or false changes nothing. */
  clearQuoteValidUntil?: InputMaybe<Scalars['Boolean']['input']>;
  /** The email address of the staff user the follow-up is assigned to, stored lower-cased. Null or blank keeps the current assignee. A new follow-up with none is assigned to the caller's directory email address, and is refused with ORDER_QUOTE_FOLLOW_UP_ASSIGNEE_REQUIRED when the caller has no usable email address. A caller with no usable email address cannot set or change a follow-up at all, even naming an assignee, and is refused with ORDER_QUOTE_FOLLOW_UP_CALLER_REQUIRED. */
  followUpAssignee?: InputMaybe<Scalars['String']['input']>;
  /** True marks the follow-up done, which takes it off the due list; false opens it again. Null keeps the current flag. False does nothing on an order with no follow-up. */
  followUpDone?: InputMaybe<Scalars['Boolean']['input']>;
  /** What the follow-up is about, at most 500 characters once trimmed. Null keeps the current note; an empty or blank note removes it, and does nothing on an order with no follow-up. */
  followUpNote?: InputMaybe<Scalars['String']['input']>;
  /** The day staff should follow up, as a tenant-local date. Null keeps the current day. Needed to start a follow-up: on an order with no follow-up, a non-empty followUpNote, a followUpAssignee or followUpDone true without this day is refused with ORDER_QUOTE_FOLLOW_UP_DATE_REQUIRED. */
  followUpOn?: InputMaybe<Scalars['LocalDate']['input']>;
  /** The order. It must be Initialized or Open; any other status is refused with ORDER_QUOTE_DETAILS_NOT_DRAFT, even when the details sent are the ones it already carries. */
  orderId: Scalars['String']['input'];
  /** The last day the quote is valid, as a tenant-local date. Null keeps the current date; use clearQuoteValidUntil to remove it. */
  quoteValidUntil?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type SetOrderShipFromSiteInput = {
  orderId: Scalars['String']['input'];
  shipFromSiteLocationId: Scalars['String']['input'];
};

export type SetOrderTagColorInput = {
  expected?: InputMaybe<ExpectedTagColorInput>;
  orderId: Scalars['String']['input'];
  tagColorId?: InputMaybe<Scalars['String']['input']>;
};

export type SetOrderfulApiKeySecretNameInput = {
  orderfulApiKeySecretName?: InputMaybe<Scalars['String']['input']>;
};

export type SetOrderfulIntegrationMappingInput = {
  organizationName?: InputMaybe<Scalars['String']['input']>;
};

export type SetOrderfulIntegrationStatusInput = {
  status: OrderfulIntegrationStatus;
};

export type SetOrderfulOrganizationIsaIdsInput = {
  organizationIsaIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SetPodAssignmentReplicasInput = {
  podName: Scalars['String']['input'];
  replicaCount: Scalars['Int']['input'];
  serviceName: BackgroundServiceName;
};

export type SetPortalUserPermissionsInput = {
  pricing: PortalPricingAccess;
  userId: Scalars['String']['input'];
};

export type SetPriceGroupDerivationInput = {
  derivedFromPriceGroupId?: InputMaybe<Scalars['String']['input']>;
  derivedPercentOff?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
};

export type SetPriceGroupOrderVolumeDiscountInput = {
  id: Scalars['String']['input'];
  thresholdType?: InputMaybe<OrderVolumeThresholdType>;
  thresholdValue?: InputMaybe<Scalars['Decimal']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
  valueType?: InputMaybe<OrderVolumeDiscountValueType>;
};

export type SetPriceGroupQualificationConditionsInput = {
  id: Scalars['String']['input'];
  minLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  orderByDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type SetPriceLevelsVolumePoolInput = {
  priceGroupId: Scalars['String']['input'];
  priceLevelIds: Array<Scalars['String']['input']>;
  volumePoolId?: InputMaybe<Scalars['String']['input']>;
};

export type SetPrimaryPortalCustomDomainInput = {
  domain: Scalars['String']['input'];
};

/** A job's new notes. Null or blank clears them. */
export type SetProductionJobNotesInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type SetProductionJobPropagationYieldDataInput = {
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
  propagationYield: Scalars['Decimal']['input'];
};

/**
 * Input for worker to set resolved entity IDs after successful lookups.
 * Merges IDs into existing row data without modifying user-provided values.
 */
export type SetProductionLotAsyncImportJobRowIdsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<ProductionLotImportRowIdsInput>;
};

export type SetProductionLotProductionItemInput = {
  productionItemId?: InputMaybe<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};

export type SetProductionRecipeTypeInput = {
  isStartRecipe: Scalars['Boolean']['input'];
  productionRecipeId: Scalars['String']['input'];
};

export type SetProductionTriggerRemindersInput = {
  leadTimes: Array<ProductionTriggerReminderLeadTime>;
  productionTriggerId: Scalars['String']['input'];
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
};

export type SetProductionYearPlanCellsInput = {
  cells: Array<ProductionYearPlanCellDataInput>;
  isoYear: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type SetProductionYearPlanItemInput = {
  isoYear: Scalars['Int']['input'];
  plannedLike?: InputMaybe<ProductionYearPlanPlannedLikeDataInput>;
  productionItemId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
};

export type SetProductionYearPlanProductionPlanInput = {
  isoYear: Scalars['Int']['input'];
  productionPlanId?: InputMaybe<Scalars['String']['input']>;
  siteLocationId: Scalars['String']['input'];
};

export type SetPurchaseOrderUrgentInput = {
  isUrgent: Scalars['Boolean']['input'];
  purchaseOrderId: Scalars['String']['input'];
};

export type SetRampCopyPurchaseOrdersInput = {
  enabled: Scalars['Boolean']['input'];
};

export type SetRampVendorSuggestionsInput = {
  /** 1 to 200 rows. Each row replaces that vendor's stored match result. */
  rows: Array<RampVendorSuggestionRowInput>;
};

export type SetRampVendorSuggestionsPayload = {
  __typename?: 'SetRampVendorSuggestionsPayload';
  errors?: Maybe<Array<ValidationError>>;
  updatedCount: Scalars['Int']['output'];
};

export type SetRecipeAdditionalCostEventIdsInput = {
  productionRecipeId: Scalars['String']['input'];
  taskEventIds: Array<Scalars['String']['input']>;
};

export type SetRecipeFlatRateCostInput = {
  flatRateCost?: InputMaybe<Scalars['Decimal']['input']>;
  productionRecipeId: Scalars['String']['input'];
};

export type SetRecipeLaborSourceInput = {
  laborSource: RecipeLaborSource;
  productionRecipeId: Scalars['String']['input'];
};

export type SetRecipeMaterialVendorInput = {
  materialItemId: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
  productionRecipeId: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type SetRecipeTaskEventIdsInput = {
  productionRecipeId: Scalars['String']['input'];
  taskEventIds: Array<Scalars['String']['input']>;
};

export type SetReportAppTagsInput = {
  appTags: Array<AppTag>;
  reportId: Scalars['String']['input'];
};

export type SetReportScheduleEmailSettingsInput = {
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  scheduleId: Scalars['String']['input'];
  senderId?: InputMaybe<Scalars['String']['input']>;
};

export type SetRestockSessionKitCapInput = {
  cap: Scalars['Int']['input'];
  kitId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type SetRestockSessionOrderQuantitiesInput = {
  items: Array<SetRestockSessionOrderQuantityItemDataInput>;
  sessionId: Scalars['String']['input'];
};

export type SetRestockSessionOrderQuantityItemDataInput = {
  customerLocationId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  orderQuantity: Scalars['Int']['input'];
};

/** Sets (replaces) one route's delivery-schedule mapping. */
export type SetRouteDeliveryScheduleInput = {
  deliveryScheduleId: Scalars['String']['input'];
  routeCode: Scalars['String']['input'];
};

export type SetSiteContactsInput = {
  contacts: Array<SiteContactDataInput>;
  siteLocationId: Scalars['String']['input'];
};

export type SetSiteLaborRateInput = {
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  laborTypeId: Scalars['String']['input'];
  ratePerHour: Scalars['Decimal']['input'];
  siteLocationId: Scalars['String']['input'];
};

/**
 * Input for worker to set resolved entity IDs after successful lookups.
 * Merges IDs into existing row data without modifying user-provided values.
 */
export type SetSiteLocationAsyncImportJobRowIdsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<SiteLocationImportRowIdsInput>;
};

export type SetSiteLocationCoordinatesInput = {
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  siteLocationId: Scalars['String']['input'];
};

export type SetSiteTimeZoneInput = {
  siteLocationId: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type SetSpaceCapacityWindowInput = {
  amount: Scalars['Decimal']['input'];
  endWeek: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reliefFraction: Scalars['Decimal']['input'];
  siteLocationId: Scalars['String']['input'];
  spaceTypeId: Scalars['String']['input'];
  startWeek: Scalars['Int']['input'];
  subLocationId: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type SetSpaceCategorySiteOverrideInput = {
  length: Scalars['Decimal']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
  siteLocationId: Scalars['String']['input'];
  width: Scalars['Decimal']['input'];
};

export type SetSpaceDimensionOverrideInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  length: Scalars['Decimal']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
  stagger?: Scalars['Boolean']['input'];
  width: Scalars['Decimal']['input'];
};

export type SetSpaceTypeCapacityInput = {
  amount: Scalars['Decimal']['input'];
  siteLocationId: Scalars['String']['input'];
  spaceTypeId: Scalars['String']['input'];
  subLocationId: Scalars['String']['input'];
};

/** An ERP read of one stock position, to set the batches a row or a bin holds from it. */
export type SetStockBatchesFromErpInput = {
  /** The lots the ERP read names; an empty list is a read that holds nothing. */
  batches: Array<ErpLotDataInput>;
  /** The material bin. Name this or locationId, never both. */
  binId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ERP read's identity. A replay of the same read for the same row or bin is a no-op; it is joined to the
   * position's key into an idempotency key of at most 128 characters.
   */
  erpReadId: Scalars['String']['input'];
  /** The row's grade; ignored for a bin, which is gradeless. */
  grade: Scalars['Int']['input'];
  /** The sales item of a row, or the material item of a bin. */
  itemId: Scalars['String']['input'];
  /** The kind of item a row holds; required for a row, which a hard good may not be, and ignored for a bin. */
  itemType?: InputMaybe<ItemType>;
  /** The inventory row's location. Name this or binId, never both. */
  locationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * True when the ERP holds the stock by lot, so the lots replace the position's batches (the unknown batch and any
   * batch a person named included). False keeps the batches people entered and sets the total.
   */
  lotHeld: Scalars['Boolean']['input'];
  /** The site the bin belongs to; required for a bin and ignored for a row. */
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
};

/** The payload of setStockBatchesFromErp: the position it set, or the refusal. */
export type SetStockBatchesFromErpPayload = {
  __typename?: 'SetStockBatchesFromErpPayload';
  /** The refusals, if any. */
  errors?: Maybe<Array<ValidationError>>;
  /** The position set. */
  result?: Maybe<StockBatchesFromErpData>;
};

export type SetStoreClassesInput = {
  storeClasses: Array<StoreClassEntryInput>;
};

export type SetTaskEventDetailThroughputInput = {
  productionTaskEventDetailId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
  unitsPerHour: Scalars['Decimal']['input'];
};

export type SetTaskEventDirectCostInput = {
  costPerEvent: Scalars['Decimal']['input'];
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  productionTaskEventId: Scalars['String']['input'];
};

export type SetTaskEventLaborTypeTagInput = {
  laborTypeTagId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type SetTaskEventThroughputInput = {
  productionTaskEventId: Scalars['String']['input'];
  unitsPerHour: Scalars['Decimal']['input'];
};

export type SetTenantAvailabilityQuantityBasisInput = {
  quantityBasis: AvailabilityQuantityBasis;
};

export type SetTenantAvailabilityQuantityEntryInput = {
  quantityEntry: AvailabilityQuantityEntry;
};

export type SetTenantBillingRateCardInput = {
  annualAmount?: InputMaybe<Scalars['Long']['input']>;
  currency?: Scalars['String']['input'];
  monthlyAmount?: InputMaybe<Scalars['Long']['input']>;
  quarterlyAmount?: InputMaybe<Scalars['Long']['input']>;
};

export type SetTenantDefaultCarrierInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
};

export type SetTenantDefaultEmailSenderInput = {
  senderId: Scalars['String']['input'];
};

export type SetTenantDefaultRouteInput = {
  route?: InputMaybe<Scalars['String']['input']>;
};

export type SetTenantFeaturesInput = {
  dryRun?: Scalars['Boolean']['input'];
  /** The tenant's products as adminTenantFeatures returned them, in any order. The save is refused with TENANT_FEATURES_CONFLICT, and nothing is written, when the tenant's products are no longer these. */
  expectedWorkSuiteProductIds: Array<Scalars['String']['input']>;
  settings: Array<TenantFlagSettingDataInput>;
  tenantId: Scalars['String']['input'];
  workSuiteProductIds: Array<Scalars['String']['input']>;
};

export type SetTenantLoadPaperworkBindingInput = {
  kind: LoadPaperworkKind;
  reportId?: InputMaybe<Scalars['String']['input']>;
};

export type SetTenantLoadPaperworkPolicyInput = {
  dropShipKinds: Array<LoadPaperworkKind>;
  regularKinds: Array<LoadPaperworkKind>;
};

/** Input for setTenantMultiFactorRequirement: the requirement's new state, replaced wholesale. */
export type SetTenantMultiFactorRequirementInput = {
  /**
   * Days of advisory notice before the requirement becomes blocking, or null for none. Rejected
   * if negative.
   */
  graceWindowDays?: InputMaybe<Scalars['Int']['input']>;
  /** Whether unenrolled users of this tenant's staff application are pressed to enrol. */
  requireMfa: Scalars['Boolean']['input'];
};

export type SetTenantOnlinePaymentMaxAmountOverrideInput = {
  onlinePaymentMaxAmount: Scalars['Long']['input'];
};

export type SetTenantOrderEntryUnitInput = {
  orderEntryUnit: OrderEntryUnit;
};

export type SetTenantOverridesInput = {
  name: FeatureFlagName;
  tenantOverrides: Array<TenantOverrideDataInput>;
};

export type SetTenantParentCompanyInput = {
  parentCompanyId?: InputMaybe<Scalars['String']['input']>;
};

export type SetTenantPriceEntryUnitInput = {
  /** How sales prices are entered and shown: per each or per shipping unit. Prices are always stored and billed per each. */
  priceEntryUnit: PriceEntryUnit;
};

/**
 * Input for setTenantSmtpConnection. The plaintext password is encrypted server-side before
 * any event is written and is never stored or echoed back. The tenant is taken from the caller's JWT.
 */
export type SetTenantSmtpConnectionInput = {
  /** Gets the configured from-address list. */
  addresses: Array<SmtpSenderAddressInput>;
  /** Gets the from-mode governing which addresses are usable. */
  fromMode: SmtpFromMode;
  /** Gets the SMTP server host. */
  host: Scalars['String']['input'];
  /** Gets the plaintext SMTP AUTH password (encrypted at rest server-side; never returned). */
  password: Scalars['String']['input'];
  /** Gets the SMTP server port (587 STARTTLS by convention). */
  port: Scalars['Int']['input'];
  /** Gets the SMTP AUTH username. */
  username: Scalars['String']['input'];
};

export type SetVendorMaterialCostInput = {
  /** The calendar DAY this cost takes effect. Any time of day you send is DISCARDED: the server stores midnight UTC of the day your value names IN THE OFFSET YOU SENT, not in UTC, so 2026-08-21T23:00:00-05:00 is stored as 2026-08-21T00:00:00Z and not 2026-08-22. Reading the cost back returns that midnight-UTC value rather than what you submitted. A cost is picked by the latest effective day on or before today, so a future day does not apply early. Omit the field (or send null) to record the always-effective BASE RATE for this vendor instead of a dated cost — null here is not "unknown". */
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  materialItemId: Scalars['String']['input'];
  unitCost: Scalars['Decimal']['input'];
  vendorId: Scalars['String']['input'];
};

export type SetVendorPurchaseOrderPurposeTextInput = {
  purchaseOrderId: Scalars['String']['input'];
  purposeText: Scalars['String']['input'];
};

export type SetWorkOrderLineNumberInput = {
  jobId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  workOrderId: Scalars['String']['input'];
};

export type SetWorkerConfigRunNowInput = {
  configName: Scalars['String']['input'];
  runNow: Scalars['Boolean']['input'];
  tenantId: Scalars['String']['input'];
};

export type SetWsapiImportRunNowInput = {
  wsapiImportId: Scalars['String']['input'];
};

export type SftpSystemSettingsPayload = {
  __typename?: 'SftpSystemSettingsPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<SftpSystemSettingsStateData>;
};

export type SftpSystemSettingsStateData = {
  __typename?: 'SftpSystemSettingsStateData';
  enabled: Scalars['Boolean']['output'];
  timerPeriodString: Scalars['String']['output'];
};

export type SftpTenantConfigDocument = {
  __typename?: 'SftpTenantConfigDocument';
  batchSize: Scalars['Int']['output'];
  configId: Scalars['String']['output'];
  configName: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  destinations: Array<DestinationConfigData>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  mongoDestinations: Array<MongoDestinationDocumentData>;
  podId: Scalars['String']['output'];
  source: SourceConfigData;
  status: SftpTenantConfigStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type SftpTenantConfigDocumentFilterInput = {
  and?: InputMaybe<Array<SftpTenantConfigDocumentFilterInput>>;
  batchSize?: InputMaybe<IntOperationFilterInput>;
  configId?: InputMaybe<StringOperationFilterInput>;
  configName?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  destinations?: InputMaybe<ListFilterInputTypeOfDestinationConfigDataFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  mongoDestinations?: InputMaybe<ListFilterInputTypeOfMongoDestinationDocumentDataFilterInput>;
  or?: InputMaybe<Array<SftpTenantConfigDocumentFilterInput>>;
  podId?: InputMaybe<StringOperationFilterInput>;
  source?: InputMaybe<SourceConfigDataFilterInput>;
  status?: InputMaybe<SftpTenantConfigStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SftpTenantConfigDocumentSortInput = {
  batchSize?: InputMaybe<SortEnumType>;
  configId?: InputMaybe<SortEnumType>;
  configName?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  podId?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SourceConfigDataSortInput>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type SftpTenantConfigPayload = {
  __typename?: 'SftpTenantConfigPayload';
  errors?: Maybe<Array<ValidationError>>;
  sftpTenantConfig?: Maybe<SftpTenantConfigDocument>;
};

export type SftpTenantConfigStateData = {
  __typename?: 'SftpTenantConfigStateData';
  batchSize: Scalars['Int']['output'];
  configId: Scalars['String']['output'];
  configName: Scalars['String']['output'];
  destinations: Array<DestinationConfigData>;
  enabled: Scalars['Boolean']['output'];
  mongoDestinations: Array<MongoDestinationConfigData>;
  podId: Scalars['String']['output'];
  source: SourceConfigData;
  status: SftpTenantConfigStatus;
  tenantId: Scalars['String']['output'];
};

export enum SftpTenantConfigStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Initialized = 'INITIALIZED',
  Unknown = 'UNKNOWN'
}

export type SftpTenantConfigStatusOperationFilterInput = {
  eq?: InputMaybe<SftpTenantConfigStatus>;
  in?: InputMaybe<Array<SftpTenantConfigStatus>>;
  neq?: InputMaybe<SftpTenantConfigStatus>;
  nin?: InputMaybe<Array<SftpTenantConfigStatus>>;
};

/** A connection to a list of items. */
export type SftpTenantConfigsConnection = {
  __typename?: 'SftpTenantConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SftpTenantConfigsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SftpTenantConfigDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SftpTenantConfigsEdge = {
  __typename?: 'SftpTenantConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SftpTenantConfigDocument;
};

export type ShareReportInput = {
  granteeEmail?: InputMaybe<Scalars['String']['input']>;
  granteeKind: ReportGranteeKind;
  reportId: Scalars['String']['input'];
  right: ReportGrantRight;
};

export type ShipFromLocationData = {
  __typename?: 'ShipFromLocationData';
  name: Scalars['String']['output'];
};

export type ShipFromLocationDataInput = {
  name: Scalars['String']['input'];
};

export type ShipHardgoodCountDataInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode: Scalars['Int']['input'];
  siteLocationId: Scalars['String']['input'];
};

/**
 * Input record for shipMovementOrder. ShippedLines must replay the
 * full Created snapshot (same LineItemId set, same MaterialItemId per line);
 * quantities may differ.
 */
export type ShipMovementOrderInput = {
  fromLocationId?: InputMaybe<Scalars['String']['input']>;
  idempotentKey: Scalars['String']['input'];
  movementOrderId: Scalars['String']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  shippedLines: Array<MovementOrderLineInput>;
};

export type ShipOrderAllocationDataInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  lineItemId: Scalars['UUID']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type ShipOrderLineDataInput = {
  id: Scalars['UUID']['input'];
  shippedQuantity: Scalars['Int']['input'];
};

export type ShipOrderWithStockCorrectionsInput = {
  allocations: Array<ShipOrderAllocationDataInput>;
  hardgoodCounts: Array<ShipHardgoodCountDataInput>;
  items: Array<ShipOrderLineDataInput>;
  orderId: Scalars['String']['input'];
  stockCorrections: Array<ShipStockCorrectionDataInput>;
};

export type ShipPurchaseOrderInput = {
  purchaseOrderId: Scalars['String']['input'];
};

export type ShipStockCorrectionDataInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  why: Scalars['String']['input'];
};

/**
 * Something that refuses the combine: a restock session, delivery schedule, replenishment rule or site
 * map naming the combined ship-to, a key of it feeding code-keyed data (CODE_IN_USE), or an
 * append over the KurrentDB maximum (TOO_LARGE).
 */
export type ShipToCombineBlocker = {
  __typename?: 'ShipToCombineBlocker';
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** One row of a ship-to combine preview: a field's value on each ship-to and after the combine. */
export type ShipToCombineField = {
  __typename?: 'ShipToCombineField';
  isConflict: Scalars['Boolean']['output'];
  keepBothAllowed: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: ShipToCombineFieldKind;
  label: Scalars['String']['output'];
  loserValue?: Maybe<Scalars['String']['output']>;
  resultValue?: Maybe<Scalars['String']['output']>;
  survivorValue?: Maybe<Scalars['String']['output']>;
};

/** How a field is merged when one ship-to is combined into another of the same customer. */
export enum ShipToCombineFieldKind {
  /** A count of history, shown for comparison only. */
  History = 'HISTORY',
  /** The survivor keeps its value; the combined ship-to's value becomes an alias. Never a conflict. */
  Identity = 'IDENTITY',
  /** A list that is unioned. Never a conflict. */
  Multi = 'MULTI',
  /**
   * The same item mapped on both ship-tos by customer item rows that differ: the picked side's row
   * serves the survivor and the other is retired. Identical rows need no pick.
   */
  Reference = 'REFERENCE',
  /** A setting. Any difference, blank included, is a conflict. */
  Setting = 'SETTING',
  /** The survivor's value wins and a blank is filled from the combined ship-to. Two different values are a conflict. */
  Single = 'SINGLE'
}

/** Counts of what a ship-to already has. */
export type ShipToCombineHistory = {
  __typename?: 'ShipToCombineHistory';
  customerItems: Scalars['Int']['output'];
  masterOrders: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
};

/** The resolution of one conflicting field, by its preview key. */
export type ShipToCombinePickInput = {
  choice: CustomerCombinePickChoice;
  key: Scalars['String']['input'];
};

/** What combining the loser ship-to into the survivor ship-to would do. Nothing is written. */
export type ShipToCombinePreview = {
  __typename?: 'ShipToCombinePreview';
  blockers: Array<ShipToCombineBlocker>;
  conflictCount: Scalars['Int']['output'];
  customerId: Scalars['String']['output'];
  fields: Array<ShipToCombineField>;
  loserHistory: ShipToCombineHistory;
  loserLocationId: Scalars['String']['output'];
  survivorHistory: ShipToCombineHistory;
  survivorLocationId: Scalars['String']['output'];
  survivorSuggested: Scalars['Boolean']['output'];
};

export type ShipToCombinePreviewPayload = {
  __typename?: 'ShipToCombinePreviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  preview?: Maybe<ShipToCombinePreview>;
};

/**
 * One ship-to combined into this ship-to: its id, name and Code as they were, when it was combined and
 * by whom.
 */
export type ShipToCombineRecord = {
  __typename?: 'ShipToCombineRecord';
  combinedAt: Scalars['DateTime']['output'];
  combinedBy: Scalars['String']['output'];
  loserCode: Scalars['String']['output'];
  loserLocationId: Scalars['String']['output'];
  loserName: Scalars['String']['output'];
};

/**
 * One ship-to combined into this ship-to: its id, name and Code as they were, when it was combined and
 * by whom.
 */
export type ShipToCombineRecordFilterInput = {
  and?: InputMaybe<Array<ShipToCombineRecordFilterInput>>;
  combinedAt?: InputMaybe<DateTimeOperationFilterInput>;
  combinedBy?: InputMaybe<StringOperationFilterInput>;
  loserCode?: InputMaybe<StringOperationFilterInput>;
  loserLocationId?: InputMaybe<StringOperationFilterInput>;
  loserName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ShipToCombineRecordFilterInput>>;
};

export enum ShippingUomSource {
  Category = 'CATEGORY',
  CustomerItem = 'CUSTOMER_ITEM',
  Item = 'ITEM',
  None = 'NONE'
}

export type ShopperData = {
  __typename?: 'ShopperData';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type ShoppingCartCustomerData = {
  __typename?: 'ShoppingCartCustomerData';
  billToAddress: CartAddressData;
  customerId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shipToAddress: CartAddressData;
  shopper: ShopperData;
};

export type ShoppingCartItemData = {
  __typename?: 'ShoppingCartItemData';
  dateAdded: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  itemGroup: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  upc: Scalars['String']['output'];
};

export type ShoppingCartPayload = {
  __typename?: 'ShoppingCartPayload';
  errors?: Maybe<Array<ValidationError>>;
  shoppingCart?: Maybe<ShoppingCartStateData>;
};

export type ShoppingCartStateData = {
  __typename?: 'ShoppingCartStateData';
  cartId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: ShoppingCartCustomerData;
  expectedDeliveryDate: Scalars['DateTime']['output'];
  items: Array<ShoppingCartItemData>;
  shopperId: Scalars['String']['output'];
  status: ShoppingCartStatus;
  tenantId: Scalars['String']['output'];
};

export enum ShoppingCartStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Empty = 'EMPTY',
  Open = 'OPEN',
  Submitted = 'SUBMITTED'
}

export type ShrinkEvent = {
  __typename?: 'ShrinkEvent';
  date: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  shrinkEventId: Scalars['String']['output'];
  shrinkType: ShrinkType;
};

/** One way the shrink and loss report can be grouped. The request lists them in the order to group by. */
export enum ShrinkLossGroupBy {
  /** One group per production category. */
  Category = 'CATEGORY',
  /** One group per crop (the job's production item). */
  Crop = 'CROP',
  /** One group per location the shrink came out of. */
  Location = 'LOCATION',
  /** One group per shrink reason. */
  Reason = 'REASON',
  /** One group per production week, counted from the tenant's week anchor day. */
  Week = 'WEEK'
}

/** The report: its rows and the grand total. */
export type ShrinkLossReport = {
  __typename?: 'ShrinkLossReport';
  rows: Array<ShrinkLossReportRow>;
  total: ShrinkLossReportRow;
};

/** Input of the shrinkLossReport query. */
export type ShrinkLossReportInput = {
  /** First day of the range, by shrink date (inclusive). */
  from: Scalars['LocalDate']['input'];
  /** The groupings, in order. An empty list returns only the total row. */
  groupBy: Array<ShrinkLossGroupBy>;
  /** Limits the report to one site (its own location and its sub-locations). Null reads every site the caller can see. */
  siteId?: InputMaybe<Scalars['String']['input']>;
  /** Last day of the range, by shrink date (inclusive). */
  to: Scalars['LocalDate']['input'];
};

/** One row of the shrink and loss report. Only the keys that were asked for in groupBy are filled in. */
export type ShrinkLossReportRow = {
  __typename?: 'ShrinkLossReportRow';
  /** The production category, when grouped by category. */
  categoryId?: Maybe<Scalars['String']['output']>;
  /** The production category's code, when grouped by category. */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** The crop (the job's production item), when grouped by crop. */
  itemId?: Maybe<Scalars['String']['output']>;
  /** The crop's name (genus, series and color), when grouped by crop. */
  itemName?: Maybe<Scalars['String']['output']>;
  /** The location the shrink came out of, when grouped by location. */
  locationId?: Maybe<Scalars['String']['output']>;
  /** That location's name, when grouped by location. */
  locationName?: Maybe<Scalars['String']['output']>;
  /** Shrink as a percent of the posted quantity of the lots that had shrink in the range (0 to 100, two decimals). The base is only the lots that shrank, not everything grown. Null when that posted quantity is zero. */
  percentOfProduced?: Maybe<Scalars['Decimal']['output']>;
  /** Posted quantity of the jobs (or of their posted slots, when grouped by location) behind the row. */
  producedQuantity: Scalars['Int']['output'];
  /** The lots behind the row, for the drill-down. */
  productionLotIds: Array<Scalars['String']['output']>;
  /** The shrink reason, when grouped by reason. */
  reason?: Maybe<ShrinkType>;
  /** Units lost to phone shrink events in the row. */
  shrinkQuantity: Scalars['Int']['output'];
  /** The production week number of the shrink date, counted from the tenant's week anchor day, when grouped by week. */
  week?: Maybe<Scalars['Int']['output']>;
  /** The year of that production week, when grouped by week. */
  year?: Maybe<Scalars['Int']['output']>;
};

export enum ShrinkType {
  Disease = 'DISEASE',
  EnvironmentalLoss = 'ENVIRONMENTAL_LOSS',
  Other = 'OTHER',
  Overproduction = 'OVERPRODUCTION',
  QualityIssue = 'QUALITY_ISSUE'
}

export type ShrinkTypeOperationFilterInput = {
  eq?: InputMaybe<ShrinkType>;
  in?: InputMaybe<Array<ShrinkType>>;
  neq?: InputMaybe<ShrinkType>;
  nin?: InputMaybe<Array<ShrinkType>>;
};

export type SignatureImageData = {
  __typename?: 'SignatureImageData';
  dateCaptured: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  image: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mime: Scalars['String']['output'];
};

export type SignatureImageDataFilterInput = {
  and?: InputMaybe<Array<SignatureImageDataFilterInput>>;
  dateCaptured?: InputMaybe<DateTimeOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  image?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  mime?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SignatureImageDataFilterInput>>;
};

export type SignatureImageDataSortInput = {
  dateCaptured?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  image?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  mime?: InputMaybe<SortEnumType>;
};

export type SiteAddressData = {
  __typename?: 'SiteAddressData';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  stateProvince: Scalars['String']['output'];
  toName: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type SiteAddressDataFilterInput = {
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  addressLine2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<SiteAddressDataFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<SiteAddressDataFilterInput>>;
  stateProvince?: InputMaybe<StringOperationFilterInput>;
  toName?: InputMaybe<StringOperationFilterInput>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
};

export type SiteAddressDataInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** Validated but NOT stored by mergeSiteLocation. Set the site's GPS pin with setSiteLocationCoordinates. */
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  /** Validated but NOT stored by mergeSiteLocation. Set the site's GPS pin with setSiteLocationCoordinates. */
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  stateProvince: Scalars['String']['input'];
  toName: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type SiteAddressDataSortInput = {
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  stateProvince?: InputMaybe<SortEnumType>;
  toName?: InputMaybe<SortEnumType>;
  zipcode?: InputMaybe<SortEnumType>;
};

export type SiteContactDataInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role: SiteContactRole;
};

/** A named contact stored within a site location document. */
export type SiteContactDocumentData = {
  __typename?: 'SiteContactDocumentData';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  role: SiteContactRole;
};

/** A named contact stored within a site location document. */
export type SiteContactDocumentDataFilterInput = {
  and?: InputMaybe<Array<SiteContactDocumentDataFilterInput>>;
  email?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteContactDocumentDataFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  role?: InputMaybe<SiteContactRoleOperationFilterInput>;
};

export enum SiteContactRole {
  Dispatch = 'DISPATCH',
  Manager = 'MANAGER',
  Unknown = 'UNKNOWN'
}

export type SiteContactRoleOperationFilterInput = {
  eq?: InputMaybe<SiteContactRole>;
  in?: InputMaybe<Array<SiteContactRole>>;
  neq?: InputMaybe<SiteContactRole>;
  nin?: InputMaybe<Array<SiteContactRole>>;
};

export type SiteContactStateData = {
  __typename?: 'SiteContactStateData';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  role: SiteContactRole;
};

/** Labor rate data for a specific labor type at a site location. */
export type SiteLaborRateDocumentData = {
  __typename?: 'SiteLaborRateDocumentData';
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  laborTypeId: Scalars['String']['output'];
  ratePerHour: Scalars['Decimal']['output'];
};

/** Labor rate data for a specific labor type at a site location. */
export type SiteLaborRateDocumentDataFilterInput = {
  and?: InputMaybe<Array<SiteLaborRateDocumentDataFilterInput>>;
  effectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveTo?: InputMaybe<DateTimeOperationFilterInput>;
  laborTypeId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteLaborRateDocumentDataFilterInput>>;
  ratePerHour?: InputMaybe<DecimalOperationFilterInput>;
};

export type SiteLaborRateStateData = {
  __typename?: 'SiteLaborRateStateData';
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  laborTypeId: Scalars['String']['output'];
  ratePerHour: Scalars['Decimal']['output'];
};

export type SiteLocationAsyncImportJobRow = {
  __typename?: 'SiteLocationAsyncImportJobRow';
  createdEntityId?: Maybe<Scalars['String']['output']>;
  erpId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationStatus: Scalars['String']['output'];
  locationType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentLocationId?: Maybe<Scalars['String']['output']>;
  parentRef: Scalars['String']['output'];
  /** The imported pick/pull walk-order position; null when the column was blank. */
  pickSequence?: Maybe<Scalars['Int']['output']>;
  rowIndex: Scalars['Int']['output'];
  siteLocationId?: Maybe<Scalars['String']['output']>;
  status: AsyncImportRowStatus;
  warning?: Maybe<Scalars['String']['output']>;
};

export type SiteLocationAsyncImportJobRowFilterInput = {
  and?: InputMaybe<Array<SiteLocationAsyncImportJobRowFilterInput>>;
  createdEntityId?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  kind?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationStatus?: InputMaybe<StringOperationFilterInput>;
  locationType?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteLocationAsyncImportJobRowFilterInput>>;
  parentLocationId?: InputMaybe<StringOperationFilterInput>;
  parentRef?: InputMaybe<StringOperationFilterInput>;
  /** The imported pick/pull walk-order position; null when the column was blank. */
  pickSequence?: InputMaybe<IntOperationFilterInput>;
  rowIndex?: InputMaybe<IntOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<AsyncImportRowStatusOperationFilterInput>;
  warning?: InputMaybe<StringOperationFilterInput>;
};

export type SiteLocationAsyncImportJobRowSortInput = {
  createdEntityId?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationStatus?: InputMaybe<SortEnumType>;
  locationType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentLocationId?: InputMaybe<SortEnumType>;
  parentRef?: InputMaybe<SortEnumType>;
  /** The imported pick/pull walk-order position; null when the column was blank. */
  pickSequence?: InputMaybe<SortEnumType>;
  rowIndex?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  warning?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SiteLocationAsyncImportJobRowsConnection = {
  __typename?: 'SiteLocationAsyncImportJobRowsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SiteLocationAsyncImportJobRowsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SiteLocationAsyncImportJobRow>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SiteLocationAsyncImportJobRowsEdge = {
  __typename?: 'SiteLocationAsyncImportJobRowsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SiteLocationAsyncImportJobRow;
};

export type SiteLocationBulkActionPayload = {
  __typename?: 'SiteLocationBulkActionPayload';
  errors?: Maybe<Array<ValidationError>>;
  siteLocations?: Maybe<Array<SiteLocationPayload>>;
};

export type SiteLocationDocument = {
  __typename?: 'SiteLocationDocument';
  address?: Maybe<SiteAddressData>;
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * Labor rates configured for this site. Defaults to empty list for existing documents
   * that predate this field (no migration required — same as LaborTypes above).
   */
  laborRates: Array<SiteLaborRateDocumentData>;
  /**
   * Labor types configured for this site. Defaults to empty list for existing documents
   * that predate this field (no migration required — MongoDB deserializes missing arrays as null,
   * and the default initializer handles it).
   */
  laborTypes: Array<LaborTypeDocumentData>;
  name: Scalars['String']['output'];
  /**
   * Named contacts at this site. Empty for every site that has never had contacts set.
   * Ordering is not significant — a resubmission differing only in order is absorbed as a no-op.
   */
  siteContacts: Array<SiteContactDocumentData>;
  siteLocationId: Scalars['String']['output'];
  status: LocationStatus;
  tenantId: Scalars['String']['output'];
  /**
   * IANA time-zone id (e.g. America/Los_Angeles). Null for documents that predate this
   * field; rate mutations reject with SiteTimeZoneRequired until the TZ is set.
   */
  timeZone?: Maybe<Scalars['String']['output']>;
  /**
   * Provenance of TimeZone. Defaults to TimeZoneProvenance.Derived so
   * legacy Mongo documents (which already have TimeZone populated by the V1
   * SiteTimeZoneSet projection but lack this field) deserialize with the same semantics as
   * V1 event replay at the state-reducer level — preserving the pre-PR "derivation may overwrite"
   * behavior. The projection unconditionally writes both TimeZone and
   * TimeZoneProvenance together for every new event, so the default only affects
   * legacy rows. TimeZoneProvenance.Explicit means the operator set the zone via
   * setSiteTimeZone and address-derivation will not overwrite it.
   */
  timeZoneProvenance: TimeZoneProvenance;
  updated: Scalars['DateTime']['output'];
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type SiteLocationDocumentFilterInput = {
  address?: InputMaybe<SiteAddressDataFilterInput>;
  and?: InputMaybe<Array<SiteLocationDocumentFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Labor rates configured for this site. Defaults to empty list for existing documents
   * that predate this field (no migration required — same as LaborTypes above).
   */
  laborRates?: InputMaybe<ListFilterInputTypeOfSiteLaborRateDocumentDataFilterInput>;
  /**
   * Labor types configured for this site. Defaults to empty list for existing documents
   * that predate this field (no migration required — MongoDB deserializes missing arrays as null,
   * and the default initializer handles it).
   */
  laborTypes?: InputMaybe<ListFilterInputTypeOfLaborTypeDocumentDataFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteLocationDocumentFilterInput>>;
  /**
   * Named contacts at this site. Empty for every site that has never had contacts set.
   * Ordering is not significant — a resubmission differing only in order is absorbed as a no-op.
   */
  siteContacts?: InputMaybe<ListFilterInputTypeOfSiteContactDocumentDataFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<LocationStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /**
   * IANA time-zone id (e.g. America/Los_Angeles). Null for documents that predate this
   * field; rate mutations reject with SiteTimeZoneRequired until the TZ is set.
   */
  timeZone?: InputMaybe<StringOperationFilterInput>;
  /**
   * Provenance of TimeZone. Defaults to TimeZoneProvenance.Derived so
   * legacy Mongo documents (which already have TimeZone populated by the V1
   * SiteTimeZoneSet projection but lack this field) deserialize with the same semantics as
   * V1 event replay at the state-reducer level — preserving the pre-PR "derivation may overwrite"
   * behavior. The projection unconditionally writes both TimeZone and
   * TimeZoneProvenance together for every new event, so the default only affects
   * legacy rows. TimeZoneProvenance.Explicit means the operator set the zone via
   * setSiteTimeZone and address-derivation will not overwrite it.
   */
  timeZoneProvenance?: InputMaybe<TimeZoneProvenanceOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SiteLocationDocumentSortInput = {
  address?: InputMaybe<SiteAddressDataSortInput>;
  created?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /**
   * IANA time-zone id (e.g. America/Los_Angeles). Null for documents that predate this
   * field; rate mutations reject with SiteTimeZoneRequired until the TZ is set.
   */
  timeZone?: InputMaybe<SortEnumType>;
  /**
   * Provenance of TimeZone. Defaults to TimeZoneProvenance.Derived so
   * legacy Mongo documents (which already have TimeZone populated by the V1
   * SiteTimeZoneSet projection but lack this field) deserialize with the same semantics as
   * V1 event replay at the state-reducer level — preserving the pre-PR "derivation may overwrite"
   * behavior. The projection unconditionally writes both TimeZone and
   * TimeZoneProvenance together for every new event, so the default only affects
   * legacy rows. TimeZoneProvenance.Explicit means the operator set the zone via
   * setSiteTimeZone and address-derivation will not overwrite it.
   */
  timeZoneProvenance?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/**
 * Resolved entity IDs set by the worker after successful lookups.
 * For Site rows, only SiteLocationId is set (the new or matched site id).
 * For SubLocation rows, all three IDs are set: the owning site, the resolved parent (if
 * the parent is itself a sub-location), and the sub-location's own id.
 */
export type SiteLocationImportRowIdsInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  parentLocationId?: InputMaybe<Scalars['String']['input']>;
  rowIndex: Scalars['Int']['input'];
  siteLocationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * User-provided field values during upload or correction.
 * Does not include resolved IDs - those are set separately by the worker.
 * Converted to SiteLocationImportRowData via named init-only assignment so
 * adjacent string columns cannot be silently swapped at the boundary.
 */
export type SiteLocationImportRowValuesInput = {
  erpId: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  locationStatus: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentRef: Scalars['String']['input'];
  pickSequence?: InputMaybe<Scalars['Int']['input']>;
  rowIndex: Scalars['Int']['input'];
};

export type SiteLocationPayload = {
  __typename?: 'SiteLocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  siteLocation?: Maybe<SiteLocationStateData>;
};

/**
 * Per-row failure surfaced by validateSiteLocationsDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError carries one (best-effort), otherwise null.
 */
export type SiteLocationStagedRowError = {
  __typename?: 'SiteLocationStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type SiteLocationStateData = {
  __typename?: 'SiteLocationStateData';
  address?: Maybe<SiteAddressData>;
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  laborRates: Array<SiteLaborRateStateData>;
  laborRatesHistory: Array<SiteLaborRateStateData>;
  laborTypes: Array<LaborTypeStateData>;
  locations: Array<LocationStateData>;
  name: Scalars['String']['output'];
  overheadRate?: Maybe<OverheadRateStateData>;
  overheadRates: Array<OverheadRateHistoryStateData>;
  siteContacts: Array<SiteContactStateData>;
  status: LocationStatus;
  tenantId: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  timeZoneProvenance: TimeZoneProvenance;
  updated: Scalars['DateTime']['output'];
};

export enum SiteLocationType {
  Aisle = 'AISLE',
  Bay = 'BAY',
  Bin = 'BIN',
  Field = 'FIELD',
  House = 'HOUSE',
  Pole = 'POLE',
  Row = 'ROW',
  Section = 'SECTION',
  ShipTo = 'SHIP_TO',
  Unknown = 'UNKNOWN',
  Warehouse = 'WAREHOUSE'
}

export type SiteLocationTypeOperationFilterInput = {
  eq?: InputMaybe<SiteLocationType>;
  in?: InputMaybe<Array<SiteLocationType>>;
  neq?: InputMaybe<SiteLocationType>;
  nin?: InputMaybe<Array<SiteLocationType>>;
};

export type SiteLocationTypeRelationships = {
  __typename?: 'SiteLocationTypeRelationships';
  childToParents: Array<ChildParentRelationship>;
  parentToChildren: Array<ParentChildRelationship>;
  rootTypes: Array<SiteLocationType>;
};

/** A connection to a list of items. */
export type SiteLocationsConnection = {
  __typename?: 'SiteLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SiteLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SiteLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SiteLocationsEdge = {
  __typename?: 'SiteLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SiteLocationDocument;
};

/**
 * Export-precondition coverage for a forecast: over the grid of the forecast customer's locations by the
 * forecast's programs, which location-and-program pairs still lack a site map. A missing mapping hard-
 * blocks the weekly site fan-out, so the plan-grid export badge (spec P10/P12) reads the isComplete flag
 * and lists the gaps so an operator can resolve them. An excluded mapping (excludeFromDistribution) is a
 * resolved decision, not a gap, so it counts as covered. A well-formed forecast whose scope is fully
 * mapped — or whose customer has no locations or the forecast has no programs — returns an empty gap list
 * with isComplete true (an empty list is a valid, complete result, never an error).
 */
export type SiteMapCoverage = {
  __typename?: 'SiteMapCoverage';
  /** The forecast this coverage was computed for. */
  forecastId: Scalars['String']['output'];
  /** Number of pairs in scope with no site map — the export-blocking gaps. */
  gapCount: Scalars['Int']['output'];
  /** The unmapped location-and-program pairs, each carrying its location display fields. */
  gaps: Array<SiteMapCoverageGap>;
  /** True when every pair in scope is mapped (no export-blocking gaps remain). */
  isComplete: Scalars['Boolean']['output'];
  /** Number of pairs in scope that have an active site map (mapped, including excluded mappings). */
  mappedPairs: Scalars['Int']['output'];
  /** Number of location-and-program pairs in the forecast scope (locations × programs). */
  totalPairs: Scalars['Int']['output'];
};

/**
 * A single unmapped location-and-program pair for a forecast — one row of the coverage badge/panel. The
 * location display fields are denormalized from the customer location so the UI can render the gap
 * without a second lookup.
 */
export type SiteMapCoverageGap = {
  __typename?: 'SiteMapCoverageGap';
  /** The customer location id (matches CustomerLocation.LocationId) that lacks a mapping. */
  customerLocationId: Scalars['String']['output'];
  /** Display name of the customer location. */
  locationName: Scalars['String']['output'];
  /** The forecast program id the location is unmapped for. */
  programId: Scalars['String']['output'];
  /** Region of the customer location. */
  region: Scalars['String']['output'];
  /** Store number of the customer location. */
  storeNumber: Scalars['String']['output'];
};

/**
 * Read-model document for one SiteMap mapping, keyed by {tenantId}-{siteMapId}. The composite
 * _id embeds the tenant, so single-mapping reads filter on _id and cannot leak across tenants
 * (discipline acada0ab). List reads filter on TenantId plus CustomerId (and optionally
 * CustomerLocationId) plus IsDeleted so soft-deleted mappings are excluded (guarded by a cross-tenant
 * leak integration test). CustomerId is denormalized onto the mapping so the by-customer read and the
 * coverage query filter directly rather than joining back through CustomerLocations.
 */
export type SiteMapDocument = {
  __typename?: 'SiteMapDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerLocationId: Scalars['String']['output'];
  /**
   * Data-driven replacement for the legacy hard-coded 'NRS' site literal (spec §8.14). When
   * true the weekly site fan-out drops this mapping instead of distributing to it, but the mapping
   * still counts as a covered decision for the export-precondition coverage query.
   */
  excludeFromDistribution: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  programId: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  siteMapId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Read-model document for one SiteMap mapping, keyed by {tenantId}-{siteMapId}. The composite
 * _id embeds the tenant, so single-mapping reads filter on _id and cannot leak across tenants
 * (discipline acada0ab). List reads filter on TenantId plus CustomerId (and optionally
 * CustomerLocationId) plus IsDeleted so soft-deleted mappings are excluded (guarded by a cross-tenant
 * leak integration test). CustomerId is denormalized onto the mapping so the by-customer read and the
 * coverage query filter directly rather than joining back through CustomerLocations.
 */
export type SiteMapDocumentFilterInput = {
  and?: InputMaybe<Array<SiteMapDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Data-driven replacement for the legacy hard-coded 'NRS' site literal (spec §8.14). When
   * true the weekly site fan-out drops this mapping instead of distributing to it, but the mapping
   * still counts as a covered decision for the export-precondition coverage query.
   */
  excludeFromDistribution?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SiteMapDocumentFilterInput>>;
  programId?: InputMaybe<StringOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  siteMapId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one SiteMap mapping, keyed by {tenantId}-{siteMapId}. The composite
 * _id embeds the tenant, so single-mapping reads filter on _id and cannot leak across tenants
 * (discipline acada0ab). List reads filter on TenantId plus CustomerId (and optionally
 * CustomerLocationId) plus IsDeleted so soft-deleted mappings are excluded (guarded by a cross-tenant
 * leak integration test). CustomerId is denormalized onto the mapping so the by-customer read and the
 * coverage query filter directly rather than joining back through CustomerLocations.
 */
export type SiteMapDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerLocationId?: InputMaybe<SortEnumType>;
  /**
   * Data-driven replacement for the legacy hard-coded 'NRS' site literal (spec §8.14). When
   * true the weekly site fan-out drops this mapping instead of distributing to it, but the mapping
   * still counts as a covered decision for the export-precondition coverage query.
   */
  excludeFromDistribution?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  programId?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  siteMapId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type SiteMapPayload = {
  __typename?: 'SiteMapPayload';
  errors?: Maybe<Array<ValidationError>>;
  siteMap?: Maybe<SiteMapStateData>;
};

/**
 * GraphQL output shape returned by the site map mutations (create/update/delete). Mirrors the
 * aggregate state after the command applied.
 */
export type SiteMapStateData = {
  __typename?: 'SiteMapStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerLocationId: Scalars['String']['output'];
  excludeFromDistribution: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  programId: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  siteMapId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type SiteMapsConnection = {
  __typename?: 'SiteMapsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SiteMapsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SiteMapDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SiteMapsEdge = {
  __typename?: 'SiteMapsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SiteMapDocument;
};

export type SizeUomDocument = {
  __typename?: 'SizeUomDocument';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  eachesPerUnit: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  status: SizeUomStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type SizeUomDocumentFilterInput = {
  and?: InputMaybe<Array<SizeUomDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  eachesPerUnit?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SizeUomDocumentFilterInput>>;
  status?: InputMaybe<SizeUomStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

export type SizeUomDocumentSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  eachesPerUnit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

export type SizeUomPayload = {
  __typename?: 'SizeUomPayload';
  errors?: Maybe<Array<ValidationError>>;
  sizeUom?: Maybe<SizeUomStateData>;
};

export type SizeUomStateData = {
  __typename?: 'SizeUomStateData';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  eachesPerUnit: Scalars['Int']['output'];
  sizeUomId: Scalars['String']['output'];
  status: SizeUomStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum SizeUomStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type SizeUomStatusOperationFilterInput = {
  eq?: InputMaybe<SizeUomStatus>;
  in?: InputMaybe<Array<SizeUomStatus>>;
  neq?: InputMaybe<SizeUomStatus>;
  nin?: InputMaybe<Array<SizeUomStatus>>;
};

/** A connection to a list of items. */
export type SizeUomsConnection = {
  __typename?: 'SizeUomsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SizeUomsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SizeUomDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SizeUomsEdge = {
  __typename?: 'SizeUomsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SizeUomDocument;
};

/** Input for skipAssignmentTask. */
export type SkipAssignmentTaskInput = {
  assignmentId: Scalars['String']['input'];
  binLocationId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/**
 * One price group the qualification walk offered this order and rejected, with the reason and both
 * halves of the comparison behind it — the configured rule and the values it was judged on — so a
 * UI can render "needs 84 days, order has 60" without doing any arithmetic of its own.
 */
export type SkippedPriceGroupExplanation = {
  __typename?: 'SkippedPriceGroupExplanation';
  /** The group's configured minimum lead time in whole days, or None when it imposes none. */
  configuredMinLeadTimeDays?: Maybe<Scalars['Int']['output']>;
  /** The group's configured order-by cutoff, or None when it imposes none. */
  configuredOrderByDate?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * The whole days the lead-time comparison actually counted, from
   * orderPlacedBusinessDay to requestedShipDay — the "order has 60"
   * half of the sentence. Signed: a ship day before the placed day is negative. None on the same
   * two reasons as orderPlacedBusinessDay.
   */
  leadTimeDays?: Maybe<Scalars['Int']['output']>;
  /** Display name of the rejected group; empty when it could not be resolved. */
  name: Scalars['String']['output'];
  /**
   * The business day the order's placed instant counted as, in the tenant's business time zone —
   * the day the cutoff was actually compared against (decision D, Kevin 2026-08-20).
   *
   * Deliberately the LOCALIZED day and not the caller's instant. An order placed 11:59pm
   * Mountain on Oct 13 qualifies against an Oct 13 cutoff even though its UTC instant reads Oct 14;
   * echoing the instant beside the verdict would show a user a date that appears to contradict the
   * answer printed next to it.
   *
   *
   * None exactly when reason is MISSING_ORDER_DATE or
   * MISSING_BUSINESS_TIME_ZONE — there is no business day to report when the order carries
   * no date, and no calendar to project one onto with no zone. Substituting the clock or UTC is
   * what decisions D and E forbid.
   */
  orderPlacedBusinessDay?: Maybe<Scalars['LocalDate']['output']>;
  /** The rejected group. */
  priceGroupId: Scalars['String']['output'];
  /** Which condition, or which missing input, rejected it. */
  reason: PriceGroupQualificationSkipReason;
  /**
   * The requested ship date as the calendar day it was stored as — read as written, never
   * zone-converted (a midnight-UTC ship date pushed through Mountain would lose a day and turn an
   * exactly-84-day order into an 83-day rejection). None on the same two reasons as
   * orderPlacedBusinessDay.
   */
  requestedShipDay?: Maybe<Scalars['LocalDate']['output']>;
};

/**
 * Customer-specific SKU/UPC/retail-price mapping document. The Mongo collection name and
 * internal C# type retain the historical "CustomerItem" naming for stream/projection
 * continuity; the GraphQL SDL type is renamed to SkuUpcMapping via
 * GraphQLNameAttribute because the public concept is "customer's SKU/UPC mapping",
 * not "an item type". See Atlas standard a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2 — Chief Architect
 * approval was secured via the queue-owner promotion of this task to AUTO_DEV.
 */
export type SkuUpcMapping = {
  __typename?: 'SkuUpcMapping';
  additionalSkus: Array<Scalars['String']['output']>;
  additionalUpcs: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerItemId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  /**
   * Eaches in one unit of effectiveShippingUomId. Null means UNSTATED — never zero, never
   * one — whether because no Shipping UOM won or because the winning one states no count.
   */
  effectiveEachesPerUnit?: Maybe<Scalars['Int']['output']>;
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The Shipping UOM this customer ships this item as: this mapping's own shippingUomId
   * override when it names one, otherwise the item's effectiveShippingUomId.
   */
  effectiveShippingUomId?: Maybe<Scalars['String']['output']>;
  /**
   * Which rung supplied effectiveShippingUomId: this customer's own override
   * (CUSTOMER_ITEM), the item's own pick (ITEM), a category tag (CATEGORY),
   * or nothing (NONE). CUSTOMER_ITEM appears here and nowhere else.
   */
  effectiveShippingUomSource: ShippingUomSource;
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  itemId: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationName: Scalars['String']['output'];
  /**
   * The item this customer item named before the latest item combine moved it onto the kept item;
   * null when no combine moved it or once that combine is reverted.
   */
  originalItemId?: Maybe<Scalars['String']['output']>;
  /**
   * The program this mapping belongs to (free text, backed by the tenant's Programs names
   * list). Null means "no program". Mappings for the same customer, location and item may
   * overlap in time only when their programs differ.
   */
  program?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use retailShelfPrice. Will be removed in next release. */
  retailPrice?: Maybe<Scalars['Decimal']['output']>;
  retailShelfPrice?: Maybe<Scalars['Decimal']['output']>;
  retailShelfPriceCurrency?: Maybe<Scalars['String']['output']>;
  /**
   * Overrides which of the item's shipping-config category codes is the default for this
   * customer at the resolved (customer, location?, item) scope — same ConfigCategory namespace
   * as ItemAttributes.DefaultShippingConfigCategoryCode. Null means "inherit the item's
   * default". This is a shipping-config CATEGORY code, not a shipping UOM — not to be confused
   * with ItemContainerConfigOverride.SizeUomCode, which is an independent value in the
   * same ContainerConfig key tuple.
   */
  shippingConfigCategoryCode?: Maybe<Scalars['String']['output']>;
  /**
   * This customer item's Shipping UOM override (ConfigCategoryId). Null means it inherits the
   * item's effective default; a value is always a deliberate non-default choice.
   */
  shippingUomId?: Maybe<Scalars['String']['output']>;
  sizeUomCode?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  status: CustomerItemStatus;
  tenantId: Scalars['String']['output'];
  upc?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * Customer-specific SKU/UPC/retail-price mapping document. The Mongo collection name and
 * internal C# type retain the historical "CustomerItem" naming for stream/projection
 * continuity; the GraphQL SDL type is renamed to SkuUpcMapping via
 * GraphQLNameAttribute because the public concept is "customer's SKU/UPC mapping",
 * not "an item type". See Atlas standard a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2 — Chief Architect
 * approval was secured via the queue-owner promotion of this task to AUTO_DEV.
 */
export type SkuUpcMappingFilterInput = {
  additionalSkus?: InputMaybe<ListStringOperationFilterInput>;
  additionalUpcs?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<SkuUpcMappingFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerItemId?: InputMaybe<StringOperationFilterInput>;
  effectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveUntil?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SkuUpcMappingFilterInput>>;
  /**
   * The item this customer item named before the latest item combine moved it onto the kept item;
   * null when no combine moved it or once that combine is reverted.
   */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The program this mapping belongs to (free text, backed by the tenant's Programs names
   * list). Null means "no program". Mappings for the same customer, location and item may
   * overlap in time only when their programs differ.
   */
  program?: InputMaybe<StringOperationFilterInput>;
  retailPrice?: InputMaybe<DecimalOperationFilterInput>;
  retailShelfPriceCurrency?: InputMaybe<StringOperationFilterInput>;
  /**
   * Overrides which of the item's shipping-config category codes is the default for this
   * customer at the resolved (customer, location?, item) scope — same ConfigCategory namespace
   * as ItemAttributes.DefaultShippingConfigCategoryCode. Null means "inherit the item's
   * default". This is a shipping-config CATEGORY code, not a shipping UOM — not to be confused
   * with ItemContainerConfigOverride.SizeUomCode, which is an independent value in the
   * same ContainerConfig key tuple.
   */
  shippingConfigCategoryCode?: InputMaybe<StringOperationFilterInput>;
  /**
   * This customer item's Shipping UOM override (ConfigCategoryId). Null means it inherits the
   * item's effective default; a value is always a deliberate non-default choice.
   */
  shippingUomId?: InputMaybe<StringOperationFilterInput>;
  sizeUomCode?: InputMaybe<StringOperationFilterInput>;
  sku?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<CustomerItemStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * One item's answer from resolveSkuUpcMappings: the item that was asked about, and the
 * mapping that resolved for it. This batch contains an ambiguous item's fault as a null mapping
 * without losing its siblings; resolveSkuUpcMapping exposes ambiguity as a GraphQL error.
 */
export type SkuUpcMappingResolution = {
  __typename?: 'SkuUpcMappingResolution';
  /**
   * The requested item id. Present on every entry, including the ones that resolved to nothing,
   * so a caller can key results back to its items without a second lookup.
   */
  itemId: Scalars['String']['output'];
  /**
   * The active mapping for this item, or null when none applies or its selection is ambiguous.
   * This batch keeps either outcome inside its own entry; every sibling still carries its own answer.
   */
  mapping?: Maybe<SkuUpcMapping>;
};

/**
 * Customer-specific SKU/UPC/retail-price mapping document. The Mongo collection name and
 * internal C# type retain the historical "CustomerItem" naming for stream/projection
 * continuity; the GraphQL SDL type is renamed to SkuUpcMapping via
 * GraphQLNameAttribute because the public concept is "customer's SKU/UPC mapping",
 * not "an item type". See Atlas standard a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2 — Chief Architect
 * approval was secured via the queue-owner promotion of this task to AUTO_DEV.
 */
export type SkuUpcMappingSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerItemId?: InputMaybe<SortEnumType>;
  effectiveFrom?: InputMaybe<SortEnumType>;
  effectiveUntil?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  /**
   * The item this customer item named before the latest item combine moved it onto the kept item;
   * null when no combine moved it or once that combine is reverted.
   */
  originalItemId?: InputMaybe<SortEnumType>;
  /**
   * The program this mapping belongs to (free text, backed by the tenant's Programs names
   * list). Null means "no program". Mappings for the same customer, location and item may
   * overlap in time only when their programs differ.
   */
  program?: InputMaybe<SortEnumType>;
  retailPrice?: InputMaybe<SortEnumType>;
  retailShelfPriceCurrency?: InputMaybe<SortEnumType>;
  /**
   * Overrides which of the item's shipping-config category codes is the default for this
   * customer at the resolved (customer, location?, item) scope — same ConfigCategory namespace
   * as ItemAttributes.DefaultShippingConfigCategoryCode. Null means "inherit the item's
   * default". This is a shipping-config CATEGORY code, not a shipping UOM — not to be confused
   * with ItemContainerConfigOverride.SizeUomCode, which is an independent value in the
   * same ContainerConfig key tuple.
   */
  shippingConfigCategoryCode?: InputMaybe<SortEnumType>;
  /**
   * This customer item's Shipping UOM override (ConfigCategoryId). Null means it inherits the
   * item's effective default; a value is always a deliberate non-default choice.
   */
  shippingUomId?: InputMaybe<SortEnumType>;
  sizeUomCode?: InputMaybe<SortEnumType>;
  sku?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SkuUpcMappingsConnection = {
  __typename?: 'SkuUpcMappingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SkuUpcMappingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SkuUpcMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SkuUpcMappingsEdge = {
  __typename?: 'SkuUpcMappingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SkuUpcMapping;
};

/** A connection to a list of items. */
export type SkuUpcMappingsForItemsConnection = {
  __typename?: 'SkuUpcMappingsForItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SkuUpcMappingsForItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SkuUpcMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SkuUpcMappingsForItemsEdge = {
  __typename?: 'SkuUpcMappingsForItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SkuUpcMapping;
};

/** What one inbound carrier STOP or START did to the tenant's directory. */
export enum SmsCarrierOptOutOutcome {
  /**
   * Users matched and every one of them was already where this reply would have put them, either
   * because the direction was already applied or because this exact message was already seen.
   * A redelivered webhook lands here, which is what idempotent looks like from the relay's side.
   */
  AlreadyApplied = 'ALREADY_APPLIED',
  /**
   * No user in that tenant holds that verified number. Not an error: a tenant receives replies only
   * from handsets it texted, but a number can be un-verified between the text and the reply, and a
   * misrouted webhook is a real possibility the relay has to be able to see.
   */
  NoMatch = 'NO_MATCH',
  /** At least one matched user had the block set, or lifted, by this call. */
  Recorded = 'RECORDED'
}

export enum SmsCarrierOptOutType {
  Start = 'START',
  Stop = 'STOP'
}

export enum SmtpConnectionStatus {
  Failed = 'FAILED',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export enum SmtpFromMode {
  AnyWithList = 'ANY_WITH_LIST',
  DefinedList = 'DEFINED_LIST',
  SingleAccount = 'SINGLE_ACCOUNT'
}

/** GraphQL view of one configured SMTP from-address. */
export type SmtpSenderAddressData = {
  __typename?: 'SmtpSenderAddressData';
  /**
   * Gets whether this address is restricted to admin callers (Decision D). Defaults to false
   * (anyone-can-send).
   */
  adminOnly: Scalars['Boolean']['output'];
  /** Gets the friendly from-name. */
  displayName: Scalars['String']['output'];
  /** Gets the from-address. */
  email: Scalars['String']['output'];
};

/** Input for one configured SMTP from-address. Display name is optional (defaults to the email). */
export type SmtpSenderAddressInput = {
  /**
   * Gets whether this address is restricted to admin callers (Decision D). Nullable so existing
   * callers that predate this field can omit it; null and false are both treated as
   * anyone-can-send.
   */
  adminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gets the optional friendly from-name. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Gets the from-address. */
  email: Scalars['String']['input'];
};

export type SortColumnInput = {
  colId: Scalars['String']['input'];
  sort: Scalars['String']['input'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SourceConfigData = {
  __typename?: 'SourceConfigData';
  directory: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  filePattern: Scalars['String']['output'];
  password: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SourceConfigDataFilterInput = {
  and?: InputMaybe<Array<SourceConfigDataFilterInput>>;
  directory?: InputMaybe<StringOperationFilterInput>;
  endpoint?: InputMaybe<StringOperationFilterInput>;
  filePattern?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SourceConfigDataFilterInput>>;
  port?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
};

export type SourceConfigDataSortInput = {
  directory?: InputMaybe<SortEnumType>;
  endpoint?: InputMaybe<SortEnumType>;
  filePattern?: InputMaybe<SortEnumType>;
  port?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
};

/**
 * A capacity row with the same fields as a `SpaceCapacityRow` row (so names and capacity-derived
 * fields resolve through the same GraphQL type resolvers), annotated with the what-if before/after
 * math. The row's `totalUsed` carries the after-move value.
 */
export type SpaceCapacityPreviewRow = {
  __typename?: 'SpaceCapacityPreviewRow';
  remainingAfter: Scalars['Decimal']['output'];
  row: SpaceCapacityRow;
  usedAfter: Scalars['Decimal']['output'];
  usedBefore: Scalars['Decimal']['output'];
};

export type SpaceCapacityRow = {
  __typename?: 'SpaceCapacityRow';
  byProductionPlan: Array<SpacePlanLoad>;
  bySpaceType: Array<SpaceTypeUtilization>;
  /**
   * Whether a capacity window (year-specific or recurring) or a positive flat fallback resolved for
   * this row's (sub-location, space type, ISO year/week). False = uncovered: `totalAvailable` 0 and
   * `capacityPct` null, but the demand row is retained and flagged.
   */
  capacityCovered: Scalars['Boolean']['output'];
  /**
   * Utilization as a percentage of resolved capacity, or null when no capacity is configured for this
   * (sub-location, space type, ISO year/week) — i.e. `capacityCovered` is false. Demand still renders;
   * the UI flags the null as uncovered rather than dropping the row (legacy silently dropped uncovered
   * demand).
   */
  capacityPct?: Maybe<Scalars['Decimal']['output']>;
  isoWeek: Scalars['Int']['output'];
  isoYear: Scalars['Int']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  productionPlanName: Scalars['String']['output'];
  remaining: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  siteLocationName: Scalars['String']['output'];
  spaceTypeCode: Scalars['String']['output'];
  spaceTypeId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalAvailable: Scalars['Decimal']['output'];
  totalUsed: Scalars['Decimal']['output'];
  trendBuckets: Array<SpaceTrendBucket>;
};

export enum SpaceCapacitySource {
  /** @deprecated Flat sub-location capacity was deleted. This tier is retired and never produced. */
  FlatFallback = 'FLAT_FALLBACK',
  None = 'NONE',
  PerTypeDefault = 'PER_TYPE_DEFAULT',
  RecurringWindow = 'RECURRING_WINDOW',
  YearWindow = 'YEAR_WINDOW'
}

/** A row whose after-move usage exceeds its sub-location capacity. */
export type SpaceCapacityViolation = {
  __typename?: 'SpaceCapacityViolation';
  capacity: Scalars['Decimal']['output'];
  isoWeek: Scalars['Int']['output'];
  isoYear: Scalars['Int']['output'];
  locationId: Scalars['String']['output'];
  overBy: Scalars['Decimal']['output'];
  productionPlanId: Scalars['String']['output'];
  spaceTypeId: Scalars['String']['output'];
  usedAfter: Scalars['Decimal']['output'];
};

/**
 * Read-model row for one space-capacity window. One doc per
 * (tenantId, siteLocationId, subLocationId, spaceTypeId, year-scope, startWeek, endWeek) — the window's
 * full identity key — so re-projecting the same window produces a byte-identical document. Indexed by
 * (tenantId, siteLocationId, subLocationId, spaceTypeId), and rebuilt in full for a site whenever the
 * site's windows change.
 */
export type SpaceCapacityWindowDocument = {
  __typename?: 'SpaceCapacityWindowDocument';
  amount: Scalars['Decimal']['output'];
  endWeek: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  reliefFraction: Scalars['Decimal']['output'];
  siteLocationId: Scalars['String']['output'];
  spaceTypeId: Scalars['String']['output'];
  startWeek: Scalars['Int']['output'];
  subLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  /** Null for a recurring/seasonal window; the specific year otherwise. */
  year?: Maybe<Scalars['Int']['output']>;
};

/**
 * Read-model row for one space-capacity window. One doc per
 * (tenantId, siteLocationId, subLocationId, spaceTypeId, year-scope, startWeek, endWeek) — the window's
 * full identity key — so re-projecting the same window produces a byte-identical document. Indexed by
 * (tenantId, siteLocationId, subLocationId, spaceTypeId), and rebuilt in full for a site whenever the
 * site's windows change.
 */
export type SpaceCapacityWindowDocumentFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<SpaceCapacityWindowDocumentFilterInput>>;
  endWeek?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SpaceCapacityWindowDocumentFilterInput>>;
  reliefFraction?: InputMaybe<DecimalOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  spaceTypeId?: InputMaybe<StringOperationFilterInput>;
  startWeek?: InputMaybe<IntOperationFilterInput>;
  subLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  /** Null for a recurring/seasonal window; the specific year otherwise. */
  year?: InputMaybe<IntOperationFilterInput>;
};

/**
 * Read-model row for one space-capacity window. One doc per
 * (tenantId, siteLocationId, subLocationId, spaceTypeId, year-scope, startWeek, endWeek) — the window's
 * full identity key — so re-projecting the same window produces a byte-identical document. Indexed by
 * (tenantId, siteLocationId, subLocationId, spaceTypeId), and rebuilt in full for a site whenever the
 * site's windows change.
 */
export type SpaceCapacityWindowDocumentSortInput = {
  amount?: InputMaybe<SortEnumType>;
  endWeek?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  reliefFraction?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  spaceTypeId?: InputMaybe<SortEnumType>;
  startWeek?: InputMaybe<SortEnumType>;
  subLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  /** Null for a recurring/seasonal window; the specific year otherwise. */
  year?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SpaceCapacityWindowsConnection = {
  __typename?: 'SpaceCapacityWindowsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SpaceCapacityWindowsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SpaceCapacityWindowDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SpaceCapacityWindowsEdge = {
  __typename?: 'SpaceCapacityWindowsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SpaceCapacityWindowDocument;
};

export type SpaceCategoryDimensionsData = {
  __typename?: 'SpaceCategoryDimensionsData';
  length: Scalars['Decimal']['output'];
  stagger: Scalars['Boolean']['output'];
  width: Scalars['Decimal']['output'];
};

/**
 * One group header for the Space Events sidebar: the group's Key (also used as the
 * where eq-value when lazy-loading the group's children via productionSpaceEvents), a
 * display Label, and the server-computed Count of events in the group under
 * the active search. For the Status dimension the Key is the canonical SCREAMING_SNAKE
 * enum name (e.g. ACTIVE), so it is directly usable as the GraphQL enum literal in
 * where: { status: { eq: ACTIVE } }.
 */
export type SpaceEventGroupBucket = {
  __typename?: 'SpaceEventGroupBucket';
  /** Number of events in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /** Raw group key — canonical status enum name, or the event name. */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for spaceEventGroups. Mirrors the Space Events sidebar's group-by options
 * so the client can render server-computed group headers instead of grouping the full event list in
 * memory: Status buckets on the event lifecycle status, Name buckets on the event name.
 * Both are flat scalar fields on ProductionSpaceEventDocument.
 */
export enum SpaceEventGroupField {
  /** One bucket per distinct event name. */
  Name = 'NAME',
  /** One bucket per distinct event status (Active / Inactive / Deleted / Unknown). */
  Status = 'STATUS'
}

/**
 * One staged what-if move for the spaceUtilizationPreview query: relocate a production job to a new
 * sub-location and/or shift its week start. Both targets are optional — a null toLocationId keeps the
 * job's current location and a null toWeekStartIso keeps its current week start. toWeekStartIso is an
 * ISO-8601 date (any day within the target ISO week; normalized to its ISO week/year). The optional
 * staged-against baseline (stagedLocationId / stagedWeekStartIso) is what the client captured when
 * the move was staged; the preview compares it to the job's current location/week to flag
 * changedSinceStaged. No write ever touches ProductionJob.SpaceDimensions.
 */
export type SpaceMoveInput = {
  lotId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  stagedLocationId?: InputMaybe<Scalars['String']['input']>;
  stagedWeekStartIso?: InputMaybe<Scalars['String']['input']>;
  toLocationId?: InputMaybe<Scalars['String']['input']>;
  toWeekStartIso?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Validity and staleness for a single staged move. `isValid` is the AND of
 * job-exists, not-archived, target-location-valid, and target-week-valid;
 * `changedSinceStaged` is an advisory staleness flag (last-writer-wins at commit)
 * and does not gate validity.
 */
export type SpaceMovePreview = {
  __typename?: 'SpaceMovePreview';
  changedSinceStaged: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  jobArchived: Scalars['Boolean']['output'];
  jobExists: Scalars['Boolean']['output'];
  lotId: Scalars['String']['output'];
  productionJobId: Scalars['String']['output'];
  targetLocationValid: Scalars['Boolean']['output'];
  targetWeekValid: Scalars['Boolean']['output'];
  toLocationId?: Maybe<Scalars['String']['output']>;
  toWeekStartIso?: Maybe<Scalars['String']['output']>;
};

/** Why one new lot books no space: its quantity, ready week, item, recipe or variation cannot be planned. */
export type SpaceNewLotError = {
  __typename?: 'SpaceNewLotError';
  /** Why the lot cannot be planned. */
  errors: Array<ValidationError>;
  /** The lot's zero-based index in the newLots input. */
  index: Scalars['Int']['output'];
};

/**
 * A lot that does not exist yet, for the spaceUtilizationPreview query: the space it would use if it
 * were created at locationId for productionItemId, ready in the week of weekReadyDate, at quantity.
 * Nothing is saved.
 */
export type SpaceNewLotInput = {
  locationId: Scalars['String']['input'];
  productionItemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  weekReadyDate: Scalars['DateTime']['input'];
};

export type SpacePlanLoad = {
  __typename?: 'SpacePlanLoad';
  endDate: Scalars['LocalDate']['output'];
  planName: Scalars['String']['output'];
  productionPlanId: Scalars['String']['output'];
  qty: Scalars['Decimal']['output'];
  startDate: Scalars['LocalDate']['output'];
};

/** The part of a SpaceSiteWeekRow's usage that belongs to one region. */
export type SpaceRegionUsage = {
  __typename?: 'SpaceRegionUsage';
  /** The effective customer group of the lots counted here, or null for "No region". */
  customerGroupId?: Maybe<Scalars['String']['output']>;
  /** The customer group's name, or null for "No region". */
  customerGroupName?: Maybe<Scalars['String']['output']>;
  /** The area this region's lots hold at the site in the week. */
  totalUsed: Scalars['Decimal']['output'];
};

/**
 * One site's use of one space type in one ISO week, every production plan together, as the All Sites view
 * of the space plan shows it.
 */
export type SpaceSiteWeekRow = {
  __typename?: 'SpaceSiteWeekRow';
  /**
   * totalUsed split by region, the effective customer group of each lot: the lot's own group, else
   * its customer's group. Sorted by group name, with "No region" (a null group) last. The parts always sum
   * to totalUsed; a week with capacity and no usage has none.
   */
  byRegion: Array<SpaceRegionUsage>;
  /**
   * Whether at least one location of the site has capacity for this space type and week: a year
   * window, a recurring window or a per-type default.
   */
  capacityCovered: Scalars['Boolean']['output'];
  /**
   * totalUsed as a percentage of totalAvailable, or null when no location has
   * capacity for this space type and week (capacityCovered is false).
   */
  capacityPct?: Maybe<Scalars['Decimal']['output']>;
  /** The ISO week, 1 to 53. */
  isoWeek: Scalars['Int']['output'];
  /** The ISO year of the week. */
  isoYear: Scalars['Int']['output'];
  /** totalAvailable minus totalUsed; negative when the site is over capacity. */
  remaining: Scalars['Decimal']['output'];
  /** The site the row belongs to. */
  siteLocationId: Scalars['String']['output'];
  /** The site's name. */
  siteLocationName: Scalars['String']['output'];
  /** The space type's code, such as BENCH; empty when the usage has no space type. */
  spaceTypeCode: Scalars['String']['output'];
  /** Empty for usage booked with no space type, such as a job placed on the site itself. */
  spaceTypeId: Scalars['String']['output'];
  /**
   * The capacity of the site for this space type and week, rolled up: a location's capacity is its own
   * if set for the week, otherwise the sum of its children, recursively (the parent wins, so nothing is
   * counted twice). A location with no capacity set for the week adds nothing.
   */
  totalAvailable: Scalars['Decimal']['output'];
  /**
   * The area this space type holds at the site in this week, every production plan (or the one filtered
   * plan) together: the sum of the site's rows on the single-site space plan for the same week and type.
   */
  totalUsed: Scalars['Decimal']['output'];
};

export type SpaceTrendBucket = {
  __typename?: 'SpaceTrendBucket';
  utilizationPct: Scalars['Decimal']['output'];
  weekLabel: Scalars['String']['output'];
  weekStart: Scalars['LocalDate']['output'];
};

/** A connection to a list of items. */
export type SpaceTypeCapacitiesConnection = {
  __typename?: 'SpaceTypeCapacitiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SpaceTypeCapacitiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SpaceTypeCapacityDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SpaceTypeCapacitiesEdge = {
  __typename?: 'SpaceTypeCapacitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SpaceTypeCapacityDocument;
};

/**
 * Read-model row for one year-round per-space-type default capacity. One doc per
 * (tenantId, siteLocationId, subLocationId, spaceTypeId) — the row's full identity key — so
 * re-projecting the same row produces a byte-identical document. Indexed by
 * (tenantId, siteLocationId, subLocationId, spaceTypeId), and rebuilt in full for a site whenever the
 * site's per-type capacities change.
 */
export type SpaceTypeCapacityDocument = {
  __typename?: 'SpaceTypeCapacityDocument';
  amount: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  spaceTypeId: Scalars['String']['output'];
  subLocationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/**
 * Read-model row for one year-round per-space-type default capacity. One doc per
 * (tenantId, siteLocationId, subLocationId, spaceTypeId) — the row's full identity key — so
 * re-projecting the same row produces a byte-identical document. Indexed by
 * (tenantId, siteLocationId, subLocationId, spaceTypeId), and rebuilt in full for a site whenever the
 * site's per-type capacities change.
 */
export type SpaceTypeCapacityDocumentFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<SpaceTypeCapacityDocumentFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SpaceTypeCapacityDocumentFilterInput>>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  spaceTypeId?: InputMaybe<StringOperationFilterInput>;
  subLocationId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * Read-model row for one year-round per-space-type default capacity. One doc per
 * (tenantId, siteLocationId, subLocationId, spaceTypeId) — the row's full identity key — so
 * re-projecting the same row produces a byte-identical document. Indexed by
 * (tenantId, siteLocationId, subLocationId, spaceTypeId), and rebuilt in full for a site whenever the
 * site's per-type capacities change.
 */
export type SpaceTypeCapacityDocumentSortInput = {
  amount?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  spaceTypeId?: InputMaybe<SortEnumType>;
  subLocationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

export type SpaceTypeUtilization = {
  __typename?: 'SpaceTypeUtilization';
  spaceTypeId: Scalars['String']['output'];
  spaceTypeName: Scalars['String']['output'];
  utilizationPct: Scalars['Decimal']['output'];
};

/**
 * Read-only, stateless what-if result for the spaceUtilizationPreview query: the capacity board
 * recomputed in memory with the staged moves applied. Nothing is persisted.
 */
export type SpaceUtilizationPreview = {
  __typename?: 'SpaceUtilizationPreview';
  /** Per-move validity and staleness, in the order supplied. */
  moves: Array<SpaceMovePreview>;
  /**
   * The new lots that book no space because they cannot be planned, each keyed by its index in the
   * newLots input. Empty when every new lot can be planned. A lot outside the site, location or space
   * type filters is out of scope, not an error.
   */
  newLotErrors: Array<SpaceNewLotError>;
  /**
   * Every (location, space type, plan, week) row touched by the base board or the staged moves,
   * annotated with before/after usage and post-move remaining capacity.
   */
  rows: Array<SpaceCapacityPreviewRow>;
  /** Rows whose after-move usage exceeds the sub-location capacity. */
  violations: Array<SpaceCapacityViolation>;
};

export type SplitProductionLotDataInput = {
  newLots: Array<SplitProductionLotTargetDataInput>;
  productionLotId: Scalars['String']['input'];
  retainedQuantity: Scalars['Int']['input'];
};

export type SplitProductionLotPayload = {
  __typename?: 'SplitProductionLotPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
};

export type SplitProductionLotTargetDataInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  productionLotId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  weekReadyDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * Why a job's sqFtRequired came back zero, surfaced as sqFtReason on the job detail so
 * the Round 7 spacing section can show an info affordance instead of a bare zero. Ordinals are wire
 * values — do not renumber.
 */
export enum SqFtReason {
  /**
   * The segment active at the peak week resolves a space category that defines customer-scoped
   * dimension overrides, but none of them match this job's customer, and nothing else (site
   * override, category default) fills the gap.
   */
  CustomerMismatch = 'CUSTOMER_MISMATCH',
  /**
   * The segment active at the peak week resolves a space category, but no site/customer/space-type
   * override and no category default produced usable dimensions for it.
   */
  NoDimensions = 'NO_DIMENSIONS',
  /**
   * The job books SpaceUsage segments, but not one of them occupies a single week: every segment's
   * stored interval expands to a zero-week span, so there is no week for a peak to be taken across.
   * A condition of the stored rows rather than a configuration gap - a segment whose IntervalWeekSpan
   * is zero and whose legacy Duration fallback (SpaceUsageIntervals.Of) is also zero, which the two
   * fields' documented zero cases each permit independently.
   */
  NoOccupiedWeeks = 'NO_OCCUPIED_WEEKS',
  /**
   * The job carries no space-event attachment and books no SpaceUsage segments, so no default space
   * (base footprint) is booked for it either.
   */
  NoSpaceEvent = 'NO_SPACE_EVENT',
  /**
   * The job books no SpaceUsage segments at all despite carrying a space-event attachment: none of
   * its active details resolved to an interval, and its production category configures no base
   * space category (or the configured id does not resolve), so there is no footprint to measure.
   */
  NoSpaceType = 'NO_SPACE_TYPE',
  /** The job books its full peak-week footprint; sqFtRequired is that peak, in square feet. */
  Ok = 'OK',
  /**
   * The segment active at the peak week has a nonzero AreaPerUnit but a zero TotalArea — dimensions
   * resolved fine, but the quantity that multiplies AreaPerUnit into TotalArea came back zero, so its
   * footprint had nothing to multiply by.
   */
  ZeroQuantity = 'ZERO_QUANTITY'
}

export type SqlColumnMapData = {
  __typename?: 'SqlColumnMapData';
  columnName: Scalars['String']['output'];
  csvHeader?: Maybe<Scalars['String']['output']>;
  dynamicDefault?: Maybe<DynamicDefaultUnitData>;
  staticDefault?: Maybe<StaticDefaultUnitData>;
  transform?: Maybe<DynamicTransformUnitData>;
  type: SqlDataType;
};

export type SqlColumnMapDataFilterInput = {
  and?: InputMaybe<Array<SqlColumnMapDataFilterInput>>;
  columnName?: InputMaybe<StringOperationFilterInput>;
  csvHeader?: InputMaybe<StringOperationFilterInput>;
  dynamicDefault?: InputMaybe<DynamicDefaultUnitDataFilterInput>;
  or?: InputMaybe<Array<SqlColumnMapDataFilterInput>>;
  staticDefault?: InputMaybe<StaticDefaultUnitDataFilterInput>;
  transform?: InputMaybe<DynamicTransformUnitDataFilterInput>;
  type?: InputMaybe<SqlDataTypeOperationFilterInput>;
};

export type SqlColumnMapDataInput = {
  columnName: Scalars['String']['input'];
  csvHeader?: InputMaybe<Scalars['String']['input']>;
  dynamicDefault?: InputMaybe<DynamicDefaultUnitDataInput>;
  staticDefault?: InputMaybe<StaticDefaultUnitDataInput>;
  transform?: InputMaybe<DynamicTransformUnitDataInput>;
  type: SqlDataType;
};

export enum SqlDataType {
  Boolean = 'BOOLEAN',
  Byte = 'BYTE',
  DateTime = 'DATE_TIME',
  Decimal = 'DECIMAL',
  Double = 'DOUBLE',
  Float = 'FLOAT',
  Guid = 'GUID',
  Int = 'INT',
  Long = 'LONG',
  NotSet = 'NOT_SET',
  Short = 'SHORT',
  String = 'STRING'
}

export type SqlDataTypeOperationFilterInput = {
  eq?: InputMaybe<SqlDataType>;
  in?: InputMaybe<Array<SqlDataType>>;
  neq?: InputMaybe<SqlDataType>;
  nin?: InputMaybe<Array<SqlDataType>>;
};

/** Input staging one firm period's legacy line values ahead of its import approval (contract G2). */
export type StageGrowerBenchmarkImportedLinesInput = {
  /** Target GrowerBenchmark community identifier. */
  communityId: Scalars['String']['input'];
  /** Line values read from the source for this firm period. */
  lines: Array<GrowerBenchmarkImportedLineInput>;
  /** Reporting period identifier (for example 2026 or 2026-09). */
  periodId: Scalars['String']['input'];
  /** Registered reporting unit the staged figures belong to. */
  reportingUnitId: Scalars['String']['input'];
  /** Lowercase hexadecimal SHA-256 digest of the source file. */
  sourceDigest: Scalars['String']['input'];
  /** Original file name of the legacy source the figures were read from. */
  sourceFileName: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type StagedCategoriesConnection = {
  __typename?: 'StagedCategoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedCategoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CategoryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedCategoriesEdge = {
  __typename?: 'StagedCategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CategoryDocument;
};

/**
 * Deleted-document count for a single staged collection that backs a
 * GrowPointStagedEntity. CollectionName is the
 * GrowPointCollectionNames constant; the count
 * comes from MongoDB's DeleteResult.DeletedCount.
 */
export type StagedCollectionDeletionData = {
  __typename?: 'StagedCollectionDeletionData';
  collectionName: Scalars['String']['output'];
  deletedCount: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type StagedCustomerLocationsConnection = {
  __typename?: 'StagedCustomerLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedCustomerLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedCustomerLocationsEdge = {
  __typename?: 'StagedCustomerLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerLocationDocument;
};

/** A connection to a list of items. */
export type StagedCustomersConnection = {
  __typename?: 'StagedCustomersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedCustomersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomersSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedCustomersEdge = {
  __typename?: 'StagedCustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomersSummaryDocument;
};

/** A connection to a list of items. */
export type StagedHistoricalOrdersConnection = {
  __typename?: 'StagedHistoricalOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedHistoricalOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<HistoricalOrderStagedSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedHistoricalOrdersEdge = {
  __typename?: 'StagedHistoricalOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HistoricalOrderStagedSummaryDocument;
};

/** A connection to a list of items. */
export type StagedInventoryItemsConnection = {
  __typename?: 'StagedInventoryItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedInventoryItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InventoryItemDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedInventoryItemsEdge = {
  __typename?: 'StagedInventoryItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InventoryItemDocument;
};

/** A connection to a list of items. */
export type StagedItemsConnection = {
  __typename?: 'StagedItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ItemSummaryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedItemsEdge = {
  __typename?: 'StagedItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ItemSummaryDocument;
};

/** A connection to a list of items. */
export type StagedPriceGroupsConnection = {
  __typename?: 'StagedPriceGroupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedPriceGroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PriceGroupDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedPriceGroupsEdge = {
  __typename?: 'StagedPriceGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PriceGroupDocument;
};

export type StagedPriceLevelDocumentFilterInput = {
  and?: InputMaybe<Array<StagedPriceLevelDocumentFilterInput>>;
  customerSellPrice?: InputMaybe<DecimalOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  growerCost?: InputMaybe<DecimalOperationFilterInput>;
  growerSellPrice?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  kind?: InputMaybe<PriceKindOperationFilterInput>;
  levelType?: InputMaybe<PriceLevelTypeOperationFilterInput>;
  or?: InputMaybe<Array<StagedPriceLevelDocumentFilterInput>>;
  /**
   * The item an Item level targeted before the latest item combine moved it to another item; null
   * when no combine moved it or once that combine is reverted. Any save of the group's levels
   * rewrites every level and clears it.
   */
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  percentOff?: InputMaybe<DecimalOperationFilterInput>;
  priceGroupId?: InputMaybe<StringOperationFilterInput>;
  priceLevelId?: InputMaybe<StringOperationFilterInput>;
  quantityThreshold?: InputMaybe<DecimalOperationFilterInput>;
  referencePriceGroupId?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  targetId?: InputMaybe<StringOperationFilterInput>;
  targetName?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<TargetTypeOperationFilterInput>;
  /**
   * The id of the volume pool this level belongs to; null when the level prices on its own line
   * quantity alone. The pool's code and name are on the volumePool field, resolved from the registry.
   */
  volumePoolId?: InputMaybe<StringOperationFilterInput>;
};

export type StagedPriceLevelDocumentSortInput = {
  customerSellPrice?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  growerCost?: InputMaybe<SortEnumType>;
  growerSellPrice?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  levelType?: InputMaybe<SortEnumType>;
  /**
   * The item an Item level targeted before the latest item combine moved it to another item; null
   * when no combine moved it or once that combine is reverted. Any save of the group's levels
   * rewrites every level and clears it.
   */
  originalItemId?: InputMaybe<SortEnumType>;
  percentOff?: InputMaybe<SortEnumType>;
  priceGroupId?: InputMaybe<SortEnumType>;
  priceLevelId?: InputMaybe<SortEnumType>;
  quantityThreshold?: InputMaybe<SortEnumType>;
  referencePriceGroupId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  targetId?: InputMaybe<SortEnumType>;
  targetName?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  /**
   * The id of the volume pool this level belongs to; null when the level prices on its own line
   * quantity alone. The pool's code and name are on the volumePool field, resolved from the registry.
   */
  volumePoolId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type StagedPriceLevelsConnection = {
  __typename?: 'StagedPriceLevelsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedPriceLevelsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PriceLevelDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedPriceLevelsEdge = {
  __typename?: 'StagedPriceLevelsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PriceLevelDocument;
};

/** A connection to a list of items. */
export type StagedSiteLocationsConnection = {
  __typename?: 'StagedSiteLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedSiteLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SiteLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedSiteLocationsEdge = {
  __typename?: 'StagedSiteLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SiteLocationDocument;
};

/** A connection to a list of items. */
export type StagedSubLocationsConnection = {
  __typename?: 'StagedSubLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedSubLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SubLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedSubLocationsEdge = {
  __typename?: 'StagedSubLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SubLocationDocument;
};

/** A connection to a list of items. */
export type StagedTermsConnection = {
  __typename?: 'StagedTermsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StagedTermsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TermsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StagedTermsEdge = {
  __typename?: 'StagedTermsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TermsDocument;
};

/**
 * One income-GL mapping that points at an ARCHIVED account: the precedence level that holds it and
 * the account it names. An archived account is skipped at every rung, so a mapping listed here is
 * configuration that silently no longer routes.
 */
export type StaleRevenueMapping = {
  __typename?: 'StaleRevenueMapping';
  /** The WorkSuite-side stable id of the archived account. */
  accountImportId: Scalars['String']['output'];
  /**
   * The archived account's name, so the warning can be read without a
   *             second lookup.
   */
  accountName: Scalars['String']['output'];
  /**
   * The precedence rung holding the mapping — CUSTOMER_TYPE, ITEM, CATEGORY or
   *             TENANT_DEFAULT.
   */
  level: MergeDevRevenueRung;
};

export type StampPortalCustomDomainLoginRedirectSyncInput = {
  domain: Scalars['String']['input'];
  failureKind?: InputMaybe<PortalLoginRedirectSyncFailureKind>;
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  operation: PortalLoginRedirectSyncOperation;
  succeeded: Scalars['Boolean']['input'];
  verificationToken: Scalars['String']['input'];
};

/** Input for startAssignmentTask; addresses the task by its item × bin business key. */
export type StartAssignmentTaskInput = {
  assignmentId: Scalars['String']['input'];
  binLocationId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
  materialItemId: Scalars['String']['input'];
};

export type StartCountSessionInput = {
  countSessionId: Scalars['String']['input'];
  crewSize: Scalars['Int']['input'];
  productionJobId: Scalars['String']['input'];
  productionLineId: Scalars['String']['input'];
  targetQty: Scalars['Decimal']['input'];
};

export type StartFloatingTimerInput = {
  floatingTimeEntryId: Scalars['String']['input'];
  headcount?: InputMaybe<Scalars['Int']['input']>;
  /** Optional phone time the timer started, ISO 8601 UTC. Omit it to use the server clock. Refused when more than 2 minutes in the future or more than 7 days old. */
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['String']['input'];
};

/** Reports a started enrollment, or why one could not be started. */
export type StartMyMultiFactorEnrollmentPayload = {
  __typename?: 'StartMyMultiFactorEnrollmentPayload';
  enrollment?: Maybe<MultiFactorEnrollmentStart>;
  errors?: Maybe<Array<ValidationError>>;
};

/** Where a start or resume came from: fernie sends its routing fields, Home Get started sends none. */
export type StartOrResumeOnboardingJourneyInput = {
  routing?: InputMaybe<OnboardingJourneyRoutingInput>;
};

export type StartOtaRolloutInput = {
  acknowledgeSingleDeviceFleet: Scalars['Boolean']['input'];
  operationId: Scalars['String']['input'];
  releaseId: Scalars['String']['input'];
  rings: Array<OtaRingDataInput>;
  rolloutId: Scalars['String']['input'];
};

export type StartRampConnectPayload = {
  __typename?: 'StartRampConnectPayload';
  /** Ramp authorize URL to send the browser to. Carries response_type=code, client_id, redirect_uri, scope, state. */
  authorizeUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
};

export type StartReapplyRecipesRunPayload = {
  __typename?: 'StartReapplyRecipesRunPayload';
  /** Why the start was refused; empty when the run was queued. */
  errors: Array<ReapplyError>;
  /** The queued run; null when the start was refused. */
  run?: Maybe<ReapplyRecipesRun>;
};

export type StartRestockSessionCreationInput = {
  itemIds: Array<Scalars['String']['input']>;
  locationIds: Array<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  shipDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetWeeksOfSupply: Scalars['Decimal']['input'];
};

export type StartTaskInput = {
  taskAssignmentId: Scalars['String']['input'];
};

export type StartTimerInput = {
  headcount?: InputMaybe<Scalars['Int']['input']>;
  /** Optional phone time the timer started, ISO 8601 UTC. Omit it to use the server clock. Refused when more than 2 minutes in the future or more than 7 days old. Also refused when more than 2 minutes earlier than the end of this task's previous timer run. A start equal to the start of any run this task already recorded replays that run and answers ENTITY_NO_CHANGES. */
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  taskAssignmentId: Scalars['String']['input'];
};

/**
 * Anonymous input to submit a trial signup. The VerificationToken is the code delivered by
 * requestTrialSignupVerification. CAPTCHA is deferred (Kennedy 07-02): an optional
 * captchaToken can be added here additively later without breaking existing clients.
 * AcceptedTermsVersion is the Trial Terms of Service version the prospect accepted
 * (nullable-additive the same way, so pre-terms clients keep working); it is recorded on the
 * signup, never validated, and never changes the uniform response.
 */
export type StartTrialInput = {
  acceptedTermsVersion?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  contactFirstName: Scalars['String']['input'];
  contactLastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  requestedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  source?: InputMaybe<Scalars['String']['input']>;
  verificationToken: Scalars['String']['input'];
};

/**
 * Uniform response to startTrial. Every accepted signup — matched or not, auto-approved or
 * pending — receives the identical message and only its own request id, so the
 * anonymous surface reveals nothing about matches, tenant existence, or the approval outcome.
 */
export type StartTrialPayload = {
  __typename?: 'StartTrialPayload';
  errors?: Maybe<Array<ValidationError>>;
  message: Scalars['String']['output'];
  requestId?: Maybe<Scalars['String']['output']>;
};

export enum StatementDeliveryMethod {
  Both = 'BOTH',
  Email = 'EMAIL',
  None = 'NONE',
  Print = 'PRINT',
  Unknown = 'UNKNOWN'
}

/**
 * MongoDB request document for one statement print batch — the work order wsapi records and a
 * wsapi-services print worker consumes.
 */
export type StatementPrintBatchDocument = {
  __typename?: 'StatementPrintBatchDocument';
  /**
   * Gets the opaque token identifying the worker currently holding this batch, or null when it is
   * unclaimed. A claim older than the claim lease is presumed abandoned and may be taken again.
   */
  claimToken?: Maybe<Scalars['String']['output']>;
  /** Gets when the current claim was taken; null when the batch is unclaimed. */
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gets when the batch reached a terminal status, ready or failed; null while it is still
   * outstanding.
   */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gets the URL the rendered batch can be downloaded from once it is ready, exactly as the worker
   * reported it; null in every other state.
   */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Gets why the batch failed, as the worker reported it; null unless the batch failed. */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** Gets the MongoDB document identifier — composite over tenant and batch, as every read model here is. */
  id: Scalars['String']['output'];
  /** Gets the batch identifier, distinct from the composite document id. */
  printBatchId: Scalars['String']['output'];
  /**
   * Gets how many of those statements the worker has rendered so far. Zero until a worker reports
   * otherwise, and equal to the statement count once the batch is ready.
   */
  renderedCount: Scalars['Int']['output'];
  /** Gets when the batch was requested. */
  requestedAt: Scalars['DateTime']['output'];
  /** Gets the email of the operator who requested it. */
  requestedBy: Scalars['String']['output'];
  /** Gets the completed statement run this batch prints from. */
  statementRunId: Scalars['String']['output'];
  /** Gets the statements to render, in the order the worker must render them. */
  statements: Array<StatementPrintBatchItemDocument>;
  /** Gets how far along the batch is. */
  status: StatementPrintBatchStatus;
  /** Gets the owning tenant. Every read filters on this, so no tenant can see another's batch. */
  tenantId: Scalars['String']['output'];
};

/** One customer's statement within a print batch: who it is for, and what to render. */
export type StatementPrintBatchItemDocument = {
  __typename?: 'StatementPrintBatchItemDocument';
  /** Gets the customer the statement is for. */
  customerId: Scalars['String']['output'];
  /** Gets the customer's name, as the run recorded it, so a batch reads as a list of names. */
  customerName: Scalars['String']['output'];
  /**
   * Gets the report parameters this statement renders from, copied verbatim off the run's review
   * line so the printed document is the one the operator reviewed.
   */
  statementParameters: Scalars['String']['output'];
};

/**
 * Standard single-batch payload for the statement print-batch mutations. Carries the affected batch
 * on success, or the error on failure.
 */
export type StatementPrintBatchPayload = {
  __typename?: 'StatementPrintBatchPayload';
  errors?: Maybe<Array<ValidationError>>;
  printBatch?: Maybe<StatementPrintBatchDocument>;
};

export enum StatementPrintBatchStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  Rendering = 'RENDERING',
  Unknown = 'UNKNOWN'
}

export enum StaticDefaultType {
  Constant = 'CONSTANT',
  DateTime = 'DATE_TIME',
  FileDate = 'FILE_DATE',
  FileName = 'FILE_NAME',
  Guid = 'GUID',
  NotSet = 'NOT_SET'
}

export type StaticDefaultTypeOperationFilterInput = {
  eq?: InputMaybe<StaticDefaultType>;
  in?: InputMaybe<Array<StaticDefaultType>>;
  neq?: InputMaybe<StaticDefaultType>;
  nin?: InputMaybe<Array<StaticDefaultType>>;
};

export type StaticDefaultUnitData = {
  __typename?: 'StaticDefaultUnitData';
  argument?: Maybe<Scalars['String']['output']>;
  type: StaticDefaultType;
};

export type StaticDefaultUnitDataFilterInput = {
  and?: InputMaybe<Array<StaticDefaultUnitDataFilterInput>>;
  argument?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StaticDefaultUnitDataFilterInput>>;
  type?: InputMaybe<StaticDefaultTypeOperationFilterInput>;
};

export type StaticDefaultUnitDataInput = {
  argument?: InputMaybe<Scalars['String']['input']>;
  type: StaticDefaultType;
};

/** A connection to a list of items. */
export type StationBpLotInventoryConnection = {
  __typename?: 'StationBpLotInventoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StationBpLotInventoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RetailAvailableBpLotDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StationBpLotInventoryEdge = {
  __typename?: 'StationBpLotInventoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RetailAvailableBpLotDocument;
};

/** The row or bin an ERP read set, with the quantity and batches it now holds. */
export type StockBatchesFromErpData = {
  __typename?: 'StockBatchesFromErpData';
  /**
   * The orders whose allocations a bin import released because it lowered stock orders held: free stock goes
   * first, then the newest orders' allocations. Only the orders the caller can see under the orders
   * visibility rule are named; otherAffectedOrderCount counts the rest. Empty when nothing was
   * released, and for a row import.
   */
  affectedOrders: Array<InventoryOrderImpactData>;
  /** The batches with stock; empty while the item is not batch tracked. */
  batches: Array<InventoryBatch>;
  /** The row's grade; zero for a bin. */
  grade: Scalars['Int']['output'];
  /** The item. */
  itemId: Scalars['String']['output'];
  /** The row's location, or the bin. */
  locationId: Scalars['String']['output'];
  /** How many other released orders there are, which the caller cannot see. */
  otherAffectedOrderCount: Scalars['Int']['output'];
  /** What the position holds. */
  quantity: Scalars['Decimal']['output'];
  /** True when the read had been applied before, so nothing was written. */
  replayed: Scalars['Boolean']['output'];
};

/** Plants held for customer items that turning customer-item stock off would release. */
export type StockByCustomerItemDisablePreview = {
  __typename?: 'StockByCustomerItemDisablePreview';
  heldQuantity: Scalars['Decimal']['output'];
};

export type StopContactTextsInput = {
  contactId: Scalars['UUID']['input'];
  customerId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type StopFloatingTimerInput = {
  floatingTimeEntryId: Scalars['String']['input'];
  /** Optional phone time the timer stopped, ISO 8601 UTC. Omit it to use the server clock. Refused when more than 2 minutes in the future or earlier than the start, and a phone stop more than 24 hours after the start is refused. A server-clock stop has no length cap, so a running timer can always be stopped. */
  stoppedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StopOutcomeBilledLineDataInput = {
  billedQuantity: Scalars['Int']['input'];
  lineItemId: Scalars['UUID']['input'];
};

export enum StopOutcomeBilling {
  BillDelivered = 'BILL_DELIVERED',
  BillFullOrder = 'BILL_FULL_ORDER',
  Unknown = 'UNKNOWN'
}

export enum StopOutcomeKind {
  Delivered = 'DELIVERED',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  Refused = 'REFUSED',
  Unknown = 'UNKNOWN'
}

export type StopOutcomeOrderQuantityDataInput = {
  billedLines?: InputMaybe<Array<StopOutcomeBilledLineDataInput>>;
  billing?: InputMaybe<StopOutcomeBilling>;
  deliveredQuantity: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
  refusedQuantity: Scalars['Int']['input'];
};

/**
 * One order's delivered or refused quantity on a stop outcome, in the load's container
 *             unit.
 */
export type StopOutcomeOrderQuantityStateData = {
  __typename?: 'StopOutcomeOrderQuantityStateData';
  deliveredQuantity: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  refusedQuantity: Scalars['Int']['output'];
};

/** The current recorded outcome for one route stop on a delivery. */
export type StopOutcomeStateData = {
  __typename?: 'StopOutcomeStateData';
  kind: StopOutcomeKind;
  note?: Maybe<Scalars['String']['output']>;
  orders: Array<StopOutcomeOrderQuantityStateData>;
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  routeStopId: Scalars['String']['output'];
};

export type StopTimerInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Optional phone time the timer stopped, ISO 8601 UTC. Omit it to use the server clock. Refused when more than 2 minutes in the future or earlier than the start, and a phone stop more than 24 hours after the start is refused. A server-clock stop has no length cap, so a running timer can always be stopped. A stop equal to the end of any run this task already recorded replays that stop and answers ENTITY_NO_CHANGES. */
  stoppedAt?: InputMaybe<Scalars['DateTime']['input']>;
  taskAssignmentId: Scalars['String']['input'];
};

export type StoreAllocationData = {
  __typename?: 'StoreAllocationData';
  achievableQuantity: Scalars['Int']['output'];
  demandMetPercentage: Scalars['Decimal']['output'];
  /**
   * True only when a positive per-store minimum was applied to this store. When false,
   * minConstraintMet is always true and carries no meaning.
   */
  minConstraintApplies: Scalars['Boolean']['output'];
  minConstraintMet: Scalars['Boolean']['output'];
  shortfall: Scalars['Int']['output'];
  storeId: Scalars['String']['output'];
  weeksOfSupply: Scalars['Decimal']['output'];
};

export type StoreClassEntryInput = {
  class: Scalars['String']['input'];
  rank: Scalars['Int']['input'];
};

export type StoreClassEntryStateData = {
  __typename?: 'StoreClassEntryStateData';
  class: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
};

export type StoreClassPayload = {
  __typename?: 'StoreClassPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<StoreClassStateData>;
};

export type StoreClassStateData = {
  __typename?: 'StoreClassStateData';
  storeClasses: Array<StoreClassEntryStateData>;
  tenantId: Scalars['String']['output'];
};

export type StoreRampTokensInput = {
  accessToken: Scalars['String']['input'];
  accessTokenExpiresAt: Scalars['DateTime']['input'];
  refreshToken: Scalars['String']['input'];
  refreshTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StreamCountDocument = {
  __typename?: 'StreamCountDocument';
  count: Scalars['Long']['output'];
  streamName: Scalars['String']['output'];
};

export type StreamCountDocumentFilterInput = {
  and?: InputMaybe<Array<StreamCountDocumentFilterInput>>;
  count?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<StreamCountDocumentFilterInput>>;
  streamName?: InputMaybe<StringOperationFilterInput>;
};

export type StreamCountDocumentSortInput = {
  count?: InputMaybe<SortEnumType>;
  streamName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type StreamCountsConnection = {
  __typename?: 'StreamCountsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StreamCountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<StreamCountDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StreamCountsEdge = {
  __typename?: 'StreamCountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: StreamCountDocument;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Result of stripRetiredUserRoles: every user found holding a retired role, ordered by tenant then
 * user. errors is set only when the directory could not be read, and then users is null.
 */
export type StripRetiredUserRolesPayload = {
  __typename?: 'StripRetiredUserRolesPayload';
  errors?: Maybe<Array<ValidationError>>;
  users?: Maybe<Array<RetiredUserRoleStrip>>;
};

/**
 * Mutation payload for createTenantStripeAccountSession. On success clientSecret is the
 * short-lived Account Session secret ConnectJS initializes with; on rejection it is null and
 * errors carries the reason.
 */
export type StripeAccountSessionPayload = {
  __typename?: 'StripeAccountSessionPayload';
  clientSecret?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ValidationError>>;
};

/**
 * Mutation payload for createBillingPortalSession. On success portalUrl is the
 * hosted Stripe Customer Portal URL; on rejection portalUrl is null and
 * errors carries the reason.
 */
export type StripeBillingPortalSessionPayload = {
  __typename?: 'StripeBillingPortalSessionPayload';
  errors?: Maybe<Array<ValidationError>>;
  portalUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Mutation payload for createSubscriptionCheckoutSession. On success sessionUrl is
 * the hosted Stripe Checkout URL the admin hands the tenant; on rejection (e.g. an unlinked tenant,
 * or a cadence the rate card does not offer) sessionUrl is null and
 * errors carries the reason.
 */
export type StripeCheckoutSessionPayload = {
  __typename?: 'StripeCheckoutSessionPayload';
  errors?: Maybe<Array<ValidationError>>;
  sessionUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * One Connect embedded component a tenant-facing Account Session can enable. Mirrors Stripe's
 * components[…][enabled] keys on POST /v1/account_sessions; the mapping to the SDK's
 * option objects lives in StripeConnectRequestFactory.BuildAccountSession.
 */
export enum StripeConnectComponent {
  /**
   * Stripe's account_management — lets the tenant manage account details Stripe would otherwise
   * show only on a Stripe Dashboard, which this account does not have. Required on every Stripe-liable,
   * no-dashboard account (2026-09-08 ruling; Atlas standard 65316676845a4a8a84dcb51eb21ec55f).
   */
  AccountManagement = 'ACCOUNT_MANAGEMENT',
  /** Stripe's account_onboarding — collects the account's verification requirements. */
  AccountOnboarding = 'ACCOUNT_ONBOARDING',
  /**
   * Stripe's notification_banner — surfaces Stripe-required action items (e.g. outstanding
   * verification requests) inside worksuite-pwa instead of a Stripe Dashboard notification the tenant
   * cannot see. Required on every Stripe-liable, no-dashboard account (2026-09-08 ruling; Atlas
   * standard 65316676845a4a8a84dcb51eb21ec55f).
   */
  NotificationBanner = 'NOTIFICATION_BANNER',
  /** Stripe's tax_registrations — the jurisdictions the tenant is registered to collect in. */
  TaxRegistrations = 'TAX_REGISTRATIONS',
  /** Stripe's tax_settings — head office address and preset product tax code. */
  TaxSettings = 'TAX_SETTINGS'
}

export enum StripePaymentEventOutcome {
  DisputeRecorded = 'DISPUTE_RECORDED',
  ExceptionRecorded = 'EXCEPTION_RECORDED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Ignored = 'IGNORED',
  NoChange = 'NO_CHANGE',
  Processing = 'PROCESSING',
  RefundStatusRecorded = 'REFUND_STATUS_RECORDED',
  Reinstated = 'REINSTATED',
  Reversed = 'REVERSED',
  Settled = 'SETTLED',
  Unknown = 'UNKNOWN'
}

/** One product tax code in Stripe's tax-code catalogue, the list an item's Stripe tax code is picked from. */
export type StripeTaxCode = {
  __typename?: 'StripeTaxCode';
  /** Stripe's description of what the code covers. */
  description: Scalars['String']['output'];
  /** The code an item carries, such as txcd_99999999. */
  id: Scalars['String']['output'];
  /** Stripe's name for the code. */
  name: Scalars['String']['output'];
};

/** One grower's Stripe Tax fees for one UTC month, and the credit Silver Fern owes them for those fees. */
export type StripeTaxFeeCredit = {
  __typename?: 'StripeTaxFeeCredit';
  /**
   * The successful Stripe Tax calculations Work Suite made for the grower in the month: invoice issue,
   * order and cart tax estimates. Informational: no credit is given for them. Counted from the day
   * this count was deployed, so earlier months read 0.
   */
  calculationCount: Scalars['Int']['output'];
  /** The invoice count times the per-transaction fee Stripe charges the grower's account, in currency. */
  creditAmount: Scalars['Decimal']['output'];
  /**
   * The currency Stripe charges the grower's account its tax fee in: USD for a United States account,
   * CAD for a Canadian one. Never converted.
   */
  currency: Scalars['String']['output'];
  /**
   * Invoices issued in the month (by issue time, not invoice date) whose tax was recorded as a Stripe
   * Tax transaction with at least one jurisdiction where the grower is registered. A voided invoice
   * still counts, and its reissue counts again, because Stripe charged for each transaction.
   */
  invoiceCount: Scalars['Int']['output'];
  /** The grower's tenant id. */
  tenantId: Scalars['String']['output'];
  /** The grower's tenant name. */
  tenantName: Scalars['String']['output'];
};

export enum StripeTaxSettingsStatus {
  Active = 'ACTIVE',
  None = 'NONE',
  Pending = 'PENDING'
}

export type StripeTaxSettingsStatusOperationFilterInput = {
  eq?: InputMaybe<StripeTaxSettingsStatus>;
  in?: InputMaybe<Array<StripeTaxSettingsStatus>>;
  neq?: InputMaybe<StripeTaxSettingsStatus>;
  nin?: InputMaybe<Array<StripeTaxSettingsStatus>>;
};

/** One record that still references the loser; the combine is refused until it is cleared. */
export type SubLocationCombineBlocker = {
  __typename?: 'SubLocationCombineBlocker';
  kind: SubLocationCombineBlockerKind;
  label: Scalars['String']['output'];
  recordId: Scalars['String']['output'];
};

/** What kind of record still references the loser and blocks a sub-location combine. */
export enum SubLocationCombineBlockerKind {
  AvailabilityPhoto = 'AVAILABILITY_PHOTO',
  /** Retired with availability sessions: never reported any more. Kept so the member name stays reserved. */
  AvailabilitySession = 'AVAILABILITY_SESSION',
  BpfStartingNode = 'BPF_STARTING_NODE',
  CountLog = 'COUNT_LOG',
  CycleCountTask = 'CYCLE_COUNT_TASK',
  Device = 'DEVICE',
  Inventory = 'INVENTORY',
  InventoryHistory = 'INVENTORY_HISTORY',
  MaterialAllocation = 'MATERIAL_ALLOCATION',
  MaterialBin = 'MATERIAL_BIN',
  MovementOrder = 'MOVEMENT_ORDER',
  PortalAvailabilityRule = 'PORTAL_AVAILABILITY_RULE',
  ProductionJob = 'PRODUCTION_JOB',
  ProductionLine = 'PRODUCTION_LINE',
  UserAssignedNode = 'USER_ASSIGNED_NODE',
  VpoReceipt = 'VPO_RECEIPT',
  WorkOrder = 'WORK_ORDER'
}

/** One row of a sub-location combine: both values and the value the combine will leave. */
export type SubLocationCombineField = {
  __typename?: 'SubLocationCombineField';
  isConflict: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: SubLocationCombineFieldKind;
  label: Scalars['String']['output'];
  loserValue?: Maybe<Scalars['String']['output']>;
  resultValue?: Maybe<Scalars['String']['output']>;
  survivorValue?: Maybe<Scalars['String']['output']>;
};

export enum SubLocationCombineFieldKind {
  Behaviour = 'BEHAVIOUR',
  Fixed = 'FIXED',
  History = 'HISTORY',
  Identity = 'IDENTITY',
  Multi = 'MULTI',
  Single = 'SINGLE'
}

/** How much history points at one sub-location: counts, shown so the survivor can be chosen with care. */
export type SubLocationCombineHistory = {
  __typename?: 'SubLocationCombineHistory';
  countLogs: Scalars['Int']['output'];
  inventoryRows: Scalars['Int']['output'];
  inventoryTransactions: Scalars['Int']['output'];
  materialRows: Scalars['Int']['output'];
  productionJobs: Scalars['Int']['output'];
};

export enum SubLocationCombinePickChoice {
  Loser = 'LOSER',
  Survivor = 'SURVIVOR'
}

export type SubLocationCombinePickInput = {
  choice: SubLocationCombinePickChoice;
  key: Scalars['String']['input'];
};

/** What combining the loser into the survivor would do. Nothing is written to build it. */
export type SubLocationCombinePreview = {
  __typename?: 'SubLocationCombinePreview';
  blockers: Array<SubLocationCombineBlocker>;
  conflictCount: Scalars['Int']['output'];
  fields: Array<SubLocationCombineField>;
  loserHistory: SubLocationCombineHistory;
  loserLocationId: Scalars['String']['output'];
  siteLocationId: Scalars['String']['output'];
  survivorHistory: SubLocationCombineHistory;
  survivorLocationId: Scalars['String']['output'];
  survivorSuggested: Scalars['Boolean']['output'];
};

export type SubLocationCombinePreviewPayload = {
  __typename?: 'SubLocationCombinePreviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  preview?: Maybe<SubLocationCombinePreview>;
};

export type SubLocationDataInput = {
  erpId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  locationType: SiteLocationType;
  name: Scalars['String']['input'];
  parentLocationId: Scalars['String']['input'];
  pickSequence?: InputMaybe<Scalars['Int']['input']>;
  status: LocationStatus;
};

export type SubLocationDocument = {
  __typename?: 'SubLocationDocument';
  /**
   * ErpIds of the absorbed sub-locations, index-aligned with absorbedLocationIds; empty where the
   * absorbed sub-location had none.
   */
  absorbedErpIds: Array<Scalars['String']['output']>;
  /**
   * Ids of the sub-locations combined into this one, directly or through a combine into one of those,
   * oldest first.
   */
  absorbedLocationIds: Array<Scalars['String']['output']>;
  /** Names of the absorbed sub-locations, index-aligned with absorbedLocationIds. */
  absorbedNames: Array<Scalars['String']['output']>;
  /** When the sub-location was combined into combinedIntoLocationId. */
  combinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who combined the sub-location into combinedIntoLocationId. */
  combinedBy?: Maybe<Scalars['String']['output']>;
  /**
   * The sub-location this one was combined into; null when it was never combined or the combine
   * was reverted.
   */
  combinedIntoLocationId?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  /**
   * Resolves DefaultSpaceTypeId to the full production space type document it names, batched
   * across a page of sub-locations. Returns null when the sub-location has no default set.
   */
  defaultSpaceType?: Maybe<ProductionSpaceTypeDocument>;
  /**
   * The production space type this location's inventory is assumed to occupy absent a more
   * specific per-item assignment; null until setLocationDefaultSpaceType is called.
   * The resolved type is exposed as the defaultSpaceType field.
   */
  defaultSpaceTypeId?: Maybe<Scalars['String']['output']>;
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationType: SiteLocationType;
  name: Scalars['String']['output'];
  parentLocationId: Scalars['String']['output'];
  /**
   * The grower's pick/pull walk-order position for this location; null when unsequenced.
   * The pull slip reads this to walk the greenhouse in the configured route instead of alphabetically.
   */
  pickSequence?: Maybe<Scalars['Int']['output']>;
  siteLocationId: Scalars['String']['output'];
  status: LocationStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  /**
   * Inventory rows plus material bin quantity rows at this sub-location; null when the count is
   * briefly unavailable. Nothing is stored.
   */
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type SubLocationDocumentFilterInput = {
  /**
   * ErpIds of the absorbed sub-locations, index-aligned with absorbedLocationIds; empty where the
   * absorbed sub-location had none.
   */
  absorbedErpIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * Ids of the sub-locations combined into this one, directly or through a combine into one of those,
   * oldest first.
   */
  absorbedLocationIds?: InputMaybe<ListStringOperationFilterInput>;
  /** Names of the absorbed sub-locations, index-aligned with absorbedLocationIds. */
  absorbedNames?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<SubLocationDocumentFilterInput>>;
  /** When the sub-location was combined into combinedIntoLocationId. */
  combinedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Who combined the sub-location into combinedIntoLocationId. */
  combinedBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * The sub-location this one was combined into; null when it was never combined or the combine
   * was reverted.
   */
  combinedIntoLocationId?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The production space type this location's inventory is assumed to occupy absent a more
   * specific per-item assignment; null until setLocationDefaultSpaceType is called.
   * The resolved type is exposed as the defaultSpaceType field.
   */
  defaultSpaceTypeId?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationType?: InputMaybe<SiteLocationTypeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SubLocationDocumentFilterInput>>;
  parentLocationId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The grower's pick/pull walk-order position for this location; null when unsequenced.
   * The pull slip reads this to walk the greenhouse in the configured route instead of alphabetically.
   */
  pickSequence?: InputMaybe<IntOperationFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<LocationStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SubLocationDocumentSortInput = {
  /** When the sub-location was combined into combinedIntoLocationId. */
  combinedAt?: InputMaybe<SortEnumType>;
  /** Who combined the sub-location into combinedIntoLocationId. */
  combinedBy?: InputMaybe<SortEnumType>;
  /**
   * The sub-location this one was combined into; null when it was never combined or the combine
   * was reverted.
   */
  combinedIntoLocationId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  /**
   * The production space type this location's inventory is assumed to occupy absent a more
   * specific per-item assignment; null until setLocationDefaultSpaceType is called.
   * The resolved type is exposed as the defaultSpaceType field.
   */
  defaultSpaceTypeId?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentLocationId?: InputMaybe<SortEnumType>;
  /**
   * The grower's pick/pull walk-order position for this location; null when unsequenced.
   * The pull slip reads this to walk the greenhouse in the configured route instead of alphabetically.
   */
  pickSequence?: InputMaybe<SortEnumType>;
  siteLocationId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
};

/**
 * One record that references a location. The quantity is the on-hand quantity for the INVENTORY and
 * MATERIAL_BIN kinds, else null.
 */
export type SubLocationReference = {
  __typename?: 'SubLocationReference';
  kind: SubLocationReferenceKind;
  label: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Decimal']['output']>;
  recordId: Scalars['String']['output'];
};

/** What kind of record references a location. */
export enum SubLocationReferenceKind {
  AvailabilityPhoto = 'AVAILABILITY_PHOTO',
  /** Retired with availability sessions: never reported any more. Kept so stored kind names still read. */
  AvailabilitySession = 'AVAILABILITY_SESSION',
  BpfStartingNode = 'BPF_STARTING_NODE',
  CountLog = 'COUNT_LOG',
  CycleCountTask = 'CYCLE_COUNT_TASK',
  Device = 'DEVICE',
  Inventory = 'INVENTORY',
  InventoryHistory = 'INVENTORY_HISTORY',
  MaterialAllocation = 'MATERIAL_ALLOCATION',
  MaterialBin = 'MATERIAL_BIN',
  MovementOrder = 'MOVEMENT_ORDER',
  OpenOrder = 'OPEN_ORDER',
  PortalAvailabilityRule = 'PORTAL_AVAILABILITY_RULE',
  ProductionJob = 'PRODUCTION_JOB',
  ProductionLine = 'PRODUCTION_LINE',
  UserAssignedNode = 'USER_ASSIGNED_NODE',
  VpoReceipt = 'VPO_RECEIPT',
  WorkOrder = 'WORK_ORDER'
}

/** A connection to a list of items. */
export type SubLocationsConnection = {
  __typename?: 'SubLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SubLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SubLocationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubLocationsEdge = {
  __typename?: 'SubLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SubLocationDocument;
};

export type SubmitContractRecordEnrollmentInput = {
  attester?: InputMaybe<Scalars['String']['input']>;
  collectionMethod: ContractCollectionMethod;
  daysUntilDue?: InputMaybe<Scalars['Int']['input']>;
  installFee?: InputMaybe<InstallFeeInput>;
  manualInvoiceDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  paperReference?: InputMaybe<Scalars['String']['input']>;
  phases: Array<ContractPhaseDataInput>;
  startDate: Scalars['DateTime']['input'];
  tenantId: Scalars['String']['input'];
};

export type SubmitErpLoadListSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type SubmitFullOrderInput = {
  customer: OrderCustomerDataInput;
  erpId?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate: Scalars['DateTime']['input'];
  finalCredit: Scalars['Boolean']['input'];
  fromLocation: ShipFromLocationDataInput;
  initializationDateOverride?: InputMaybe<Scalars['DateTime']['input']>;
  items: Array<AddLineItemDataInput>;
  orderId: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  poNumber: Scalars['String']['input'];
  produceAllocate?: Scalars['Boolean']['input'];
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  shipFromSiteLocationId?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<CaptureSignatureDataInput>;
  termsId?: InputMaybe<Scalars['String']['input']>;
  type: OrderType;
};

/** One page of a prepared artifact's rows, under the job's claim. */
export type SubmitMigrationPreparedRowPageInput = {
  /** The artifact the page belongs to. */
  artifact: MigrationPreparedArtifactInput;
  /** The job's current claim token. Checked, not identity. */
  claimToken: Scalars['String']['input'];
  /** The job's composite id. */
  id: Scalars['String']['input'];
  /** The page, from 0. */
  page: Scalars['Int']['input'];
  /** 1 to 100 rows. */
  rows: Array<MigrationPreparedRowInput>;
};

export type SubmitMigrationPreparedRowPagePayload = {
  __typename?: 'SubmitMigrationPreparedRowPagePayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<SubmitMigrationPreparedRowPageResult>;
};

/** What a prepared-row page call recorded. */
export type SubmitMigrationPreparedRowPageResult = {
  __typename?: 'SubmitMigrationPreparedRowPageResult';
  /** Recorded now, or already recorded by an earlier call. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The page recorded. */
  page: Scalars['Int']['output'];
  /** How many pages the revision has. */
  pageCount: Scalars['Int']['output'];
  /** How many of the revision's pages are held now. */
  pagesHeld: Scalars['Int']['output'];
  /** The prepared revision; validation and the question page name it. */
  revisionId: Scalars['String']['output'];
  /** The revision's number within its lineage, from 1. */
  revisionNumber: Scalars['Int']['output'];
};

/** The grower's sent request. */
export type SubmitOnboardingHelpInput = {
  /** The text the grower typed when sending, exactly as sent. Required; a flag cannot stand in for it. */
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  /** The review the grower saw, shown in an earlier message. */
  presentationId: Scalars['String']['input'];
  /** The request the review named. */
  requestId: Scalars['String']['input'];
  /** The chat references; session, turn and sent message are required. */
  routing: OnboardingJourneyRoutingInput;
};

/** The result of a send, or why it was refused. */
export type SubmitOnboardingHelpPayload = {
  __typename?: 'SubmitOnboardingHelpPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<SubmitOnboardingHelpResult>;
};

/** The receipt for an accepted request. */
export type SubmitOnboardingHelpResult = {
  __typename?: 'SubmitOnboardingHelpResult';
  /** When wsapi accepted the request. */
  acceptedAt: Scalars['DateTime']['output'];
  /** Who sent it. */
  acceptedBy: Scalars['String']['output'];
  /** The journey. */
  journeyId: Scalars['String']['output'];
  /** Recorded now, or already recorded by an earlier call. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The request. */
  requestId: Scalars['String']['output'];
  /** The staff route the request is bound to. */
  reviewedRoute: OnboardingHelpRouteDetails;
  /** The request revision after the call. A request read at a lower revision has not caught up yet. */
  streamRevision: Scalars['Long']['output'];
};

/** fernie's parsing-improvement suggestion from one review turn. */
export type SubmitOnboardingParsingSuggestionInput = {
  /** The data family the suggestion concerns. */
  family: OnboardingParsingSuggestionFamily;
  /** The preparation job whose prepared data the turn reviewed. */
  jobId: Scalars['String']['input'];
  /** The grower's journey. */
  journeyId: Scalars['String']['input'];
  /** The model that produced the suggestion. */
  model: Scalars['String']['input'];
  /** The chat references; session, turn and sent message are required. */
  routing: OnboardingJourneyRoutingInput;
  /** The source version that job prepared. */
  sourceVersion: Scalars['Int']['input'];
  /** The capability stage the suggestion concerns. */
  stage: OnboardingParsingSuggestionStage;
  /** The suggestion. At most 4000 characters once control and format characters are removed. */
  text: Scalars['String']['input'];
};

/** The result of a submission, or why it was refused. */
export type SubmitOnboardingParsingSuggestionPayload = {
  __typename?: 'SubmitOnboardingParsingSuggestionPayload';
  errors?: Maybe<Array<ValidationError>>;
  result?: Maybe<SubmitOnboardingParsingSuggestionResult>;
};

/** What a submission recorded. Carries no suggestion text and no review state. */
export type SubmitOnboardingParsingSuggestionResult = {
  __typename?: 'SubmitOnboardingParsingSuggestionResult';
  /** The journey. */
  journeyId: Scalars['String']['output'];
  /** Recorded now, or already recorded by an earlier call from the same turn. */
  outcome: OnboardingJourneyRecordOutcome;
  /** The suggestion's stream revision after the command. */
  streamRevision: Scalars['Long']['output'];
  /** The identity wsapi derived from (tenant, journey, job, turn). */
  suggestionId: Scalars['String']['output'];
};

export type SubmitOrderVerificationInput = {
  adjustments: Array<SubmitVerifyAdjustmentDataInput>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  lines: Array<SubmitVerifyLineDataInput>;
  orderId: Scalars['String']['input'];
  substitutions: Array<SubmitVerifySubstitutionDataInput>;
  verifyContainerIds: Array<Scalars['String']['input']>;
};

/**
 * Input of submitProducedQuantityForReview: the same quantity and optional split as
 * overrideProducedQuantity, plus a client-minted entryId that makes a repeat a no-op.
 */
export type SubmitProducedQuantityForReviewInput = {
  /** Client-minted id of this entry. */
  entryId: Scalars['UUID']['input'];
  /** The optional split by location; it must add up to the quantity. */
  locations?: InputMaybe<Array<ProducedLocationQuantityInput>>;
  /** The job the entry is for. */
  productionJobId: Scalars['String']['input'];
  /** The lot the job belongs to. */
  productionLotId: Scalars['String']['input'];
  /** The produced quantity. */
  quantity: Scalars['Decimal']['input'];
};

export type SubmitRestockSessionInput = {
  pullDate?: InputMaybe<Scalars['LocalDate']['input']>;
  sessionId: Scalars['String']['input'];
  submissionNotes?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitVerifyAdjustmentDataInput = {
  itemId: Scalars['String']['input'];
  newQuantity: Scalars['Int']['input'];
  orderLineNumber: Scalars['Int']['input'];
  originalQuantity: Scalars['Int']['input'];
};

export type SubmitVerifyContainerInput = {
  containerId?: InputMaybe<Scalars['String']['input']>;
  drop?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  orderAssociations: Array<OrderAssociationDataInput>;
  scans: Array<ScanDataInput>;
  submitted: Scalars['Boolean']['input'];
  submittedBy: Scalars['String']['input'];
};

export type SubmitVerifyLineDataInput = {
  itemId: Scalars['String']['input'];
  orderLineNumber: Scalars['Int']['input'];
  shippedQuantity: Scalars['Int']['input'];
};

export type SubmitVerifySubstitutionDataInput = {
  newItemId: Scalars['String']['input'];
  orderLineNumber: Scalars['Int']['input'];
  originalItemId: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Subscribes to live updates for a single count session. Emits the latest
   * CountSessionDocument after each coalesced batch of projection updates,
   * and the current document immediately on connect. The sessionId is
   * client-supplied, so a client may open the subscription before the session exists.
   */
  countSessionTicked: CountSessionDocument;
  deviceChanged: DeviceDocument;
  deviceTelemetryTicked: DeviceTelemetryPoint;
  /**
   * Subscribes to manifest changes for the pod identified by runsOn.
   * Publishers (admin background-service-config and worker-config mutations)
   * emit one event per affected pod after a successful write.
   */
  manifestChanged: ManifestChangedEvent;
  /**
   * Fires when one of your background jobs changes: its status, its counts, or it finishes. The event names the
   * job only; read it again with backgroundJob or myBackgroundJobs.
   */
  onBackgroundJobProgress: BackgroundJobProgressEvent;
  /**
   * Follows one of the tenant's bulk order delete jobs: a message with the job's status and counts after
   * each page the worker finishes, and when the job is cancelled. Read the job's current state, and its
   * failed orders once it has finished, with the bulkOrderDeleteJob query.
   */
  onBulkOrderDeleteJobProgress: BulkOrderDeleteJobProgress;
  /**
   * Subscribes to feature flag changes for the authenticated tenant. The PWA
   * receives one event per change and re-runs featureFlag(name: ...) or
   * allFeatureFlags to pull the new value.
   */
  onFeatureFlagChanged: FeatureFlagChangedEvent;
  /**
   * Subscribes to InventoryItem changes for the authenticated user's tenant.
   * Publishes an InventoryItemDocument each time the projection
   * service processes an inventory event.
   */
  onInventoryItemChanged: InventoryItemDocument;
  /**
   * Fires when a new notification is written for the signed-in user — the bell's live wake-up.
   * The payload names the row and nothing else; refetch myNotifications and
   * myUnreadNotificationCount on each event rather than rendering from what arrives here,
   * which also keeps a row a concurrent mark-read has already changed from being drawn stale.
   *
   * Takes no arguments, by design. Which user's feed this is comes from the token supplied at
   * connection_init, and the delivery boundary is the topic name itself: the projection
   * publishes to a topic scoped to one tenant and one recipient, and this resolver derives that
   * same name from the caller's own claims. Two users never share a stream and there is no
   * argument a client could vary to listen to someone else. Current In-app preferences also
   * filter each signal, including preferences changed after the connection opened.
   *
   *
   *
   * **Returns:**
   * The message, unchanged.
   */
  onNotificationReceived: NotificationReceivedEvent;
  /**
   * Subscribes to progress for a single Restock session. Emits a phase (plus a
   * batch counter when the active phase carries batch semantics) after each
   * workflow checkpoint. Terminal events emit RestockBatchPhase.Idle
   * so clients can reset local progress UI; Error is populated on failure.
   * On every (re)subscribe the last-known state from the
   * RestockSessionCreationProgressDocument audit row is replayed first (when one
   * exists), so clients recover the current phase after a reconnect without polling.
   * Subscribe BEFORE invoking the triggering mutation — SessionId is client-generated,
   * so the subscription can be opened up-front without a producer race.
   */
  onRestockSessionBatchProgress: RestockSessionBatchProgressPayload;
  /**
   * Subscribes the authenticated staff caller to their tenant's user-directory changes. The admin
   * users grid/detail panel refreshes the affected row from the pushed UserDocument.
   */
  onUserChanged: UserDocument;
  restockWorkQueueResultBatchCompleted: RestockWorkQueueResultBatchPayload;
  /**
   * Subscribes the authenticated supervisor to their tenant's container status changes. The PWA
   * refetches the comparison on Submitted and drops the row on Verified.
   */
  verifyContainerStatusChanged: VerifyContainerStatusChangedEvent;
};


export type SubscriptionCountSessionTickedArgs = {
  sessionId: Scalars['String']['input'];
};


export type SubscriptionDeviceTelemetryTickedArgs = {
  deviceId: Scalars['String']['input'];
};


export type SubscriptionManifestChangedArgs = {
  runsOn: Scalars['String']['input'];
};


export type SubscriptionOnBulkOrderDeleteJobProgressArgs = {
  jobId: Scalars['String']['input'];
};


export type SubscriptionOnRestockSessionBatchProgressArgs = {
  sessionId: Scalars['String']['input'];
};

/** The lots whose catalog to substitute, the catalog they replace, the new catalog and the planner's override choice. */
export type SubstituteProductionLotCatalogInput = {
  /** The catalog each lot takes instead. */
  newProductionCatalogId: Scalars['String']['input'];
  /** The catalog being replaced in each lot. */
  originalProductionCatalogId: Scalars['String']['input'];
  /** Whether the changed jobs keep their planner overrides or take the new recipe's values. */
  overridePolicy: ProductionLotVariantOverridePolicy;
  /** The lots to substitute, each answered once in the order first named. */
  productionLotIds: Array<Scalars['String']['input']>;
};

export type Substitution = {
  __typename?: 'Substitution';
  substitutionType: SubstitutionType;
  value: Scalars['String']['output'];
};

export type SubstitutionDocument = {
  __typename?: 'SubstitutionDocument';
  substitutionType: SubstitutionType;
  value: Scalars['String']['output'];
};

export type SubstitutionDocumentFilterInput = {
  and?: InputMaybe<Array<SubstitutionDocumentFilterInput>>;
  or?: InputMaybe<Array<SubstitutionDocumentFilterInput>>;
  substitutionType?: InputMaybe<SubstitutionTypeOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type SubstitutionDocumentSortInput = {
  substitutionType?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type SubstitutionInput = {
  substitutionType: SubstitutionType;
  value: Scalars['String']['input'];
};

export enum SubstitutionType {
  Category = 'CATEGORY',
  ItemGroup = 'ITEM_GROUP',
  Subcategory = 'SUBCATEGORY'
}

export type SubstitutionTypeOperationFilterInput = {
  eq?: InputMaybe<SubstitutionType>;
  in?: InputMaybe<Array<SubstitutionType>>;
  neq?: InputMaybe<SubstitutionType>;
  nin?: InputMaybe<Array<SubstitutionType>>;
};

export enum SupplierPriceAmountUnresolvedReason {
  Blank = 'BLANK',
  Malformed = 'MALFORMED',
  OutOfRange = 'OUT_OF_RANGE',
  UncertainBasis = 'UNCERTAIN_BASIS',
  Unknown = 'UNKNOWN',
  UnsupportedScale = 'UNSUPPORTED_SCALE'
}

export type SupplierPriceBlockedRow = {
  __typename?: 'SupplierPriceBlockedRow';
  blockers: Array<SupplierPriceReviewBlocker>;
  sourceOrdinal: Scalars['Int']['output'];
  sourcePage: Scalars['Int']['output'];
  sourceRowId: Scalars['String']['output'];
};

/** How a supplier line was matched to a material, in the order the ways of matching can be trusted. */
export enum SupplierPriceCandidateMatchKind {
  /** The supplier's own item identifier is already recorded against this vendor assignment. */
  ExactSupplierItemId = 'EXACT_SUPPLIER_ITEM_ID',
  /** The line's description matches the material's normalized name or description exactly. */
  NormalizedName = 'NORMALIZED_NAME',
  /** An approved earlier line from this vendor was saved as this material, on its item id or its description. */
  SavedAlias = 'SAVED_ALIAS',
  /** The line and the material share enough normalized words to be worth reading. */
  SimilarName = 'SIMILAR_NAME',
  Unknown = 'UNKNOWN'
}

/** The candidates for one supplier line, and whether the reviewer is seeing all of them. */
export type SupplierPriceCandidateResult = {
  __typename?: 'SupplierPriceCandidateResult';
  /** The ranked materials, best first. */
  candidates: Array<SupplierPriceMaterialCandidate>;
  /** The row these candidates are for. */
  sourceRowId: Scalars['String']['output'];
  /** Whether more materials matched than were returned. */
  truncated: Scalars['Boolean']['output'];
};

/** Where an approved supplier price import's apply stands, row by row. */
export type SupplierPriceImportApply = {
  __typename?: 'SupplierPriceImportApply';
  /** The approval being applied. */
  approvalId: Scalars['String']['output'];
  /**
   * Whether the approval may still be applied: active, or cancelled or superseded. Under a cancelled or
   * superseded approval, a waiting row will not run under this approval.
   */
  approvalState: SupplierPriceImportApprovalState;
  /** The import the approval belongs to. */
  importId: Scalars['String']['output'];
  /** Every row of the approved document, in the order the document lists them. */
  rows: Array<SupplierPriceImportApplyRow>;
  /**
   * Whether any write of the approval is still not saved. Call apply again only while this is true, stop is
   * null, and the last call moved at least one row out of waiting. A call whose request is cancelled starts no
   * further write, and one cancelled before its first write saves nothing: it either fails with a payload error
   * (a gate or capture read took the cancel) or still reports true, so this alone must never drive a loop.
   */
  stepsRemain: Scalars['Boolean']['output'];
  /** The write this call stopped on, and why; null when it stopped on none. */
  stop?: Maybe<SupplierPriceImportApplyStop>;
};

/** One row of an approved supplier price import, and where its apply stands. */
export type SupplierPriceImportApplyRow = {
  __typename?: 'SupplierPriceImportApplyRow';
  /**
   * Whether saving the price changes what the material costs now, as worked out when the approval was first
   * applied: false for a future date or a vendor that is not the material's default. Null when the approval
   * saves no price for the row.
   */
  changesCurrentCosting?: Maybe<Scalars['Boolean']['output']>;
  /** Whether that material is a new one this import creates for the row, by this approval or by an earlier one. */
  createdMaterial: Scalars['Boolean']['output'];
  /** What the review decided the row is. */
  disposition: SupplierPriceRowDisposition;
  /**
   * What is known to be payable per each, as exact decimal text: the base, plus the royalty only when it is
   * confirmed. The approved value; null when the approval saves no price for the row.
   */
  knownSubtotalPerEach?: Maybe<Scalars['String']['output']>;
  /** The material the approval writes for the row; null when it writes none. */
  materialItemId?: Maybe<Scalars['String']['output']>;
  /** The price the row's write saved; null until it is saved. */
  priceId?: Maybe<Scalars['String']['output']>;
  /** The royalty state the row's price saves; null when the approval saves no price for the row. */
  royaltyStatus?: Maybe<SupplierRoyaltyStatus>;
  /** The row. */
  sourceRowId: Scalars['String']['output'];
  /** Where the row's apply stands. */
  status: SupplierPriceImportApplyRowStatus;
  /** How the row's price was saved, from its receipt; null until it is saved. */
  write?: Maybe<MaterialPriceOperationKind>;
};

/** Where one row of an approved supplier price import stands in its apply. */
export enum SupplierPriceImportApplyRowStatus {
  /** The row's new material was created, and its price has not been saved yet. */
  MaterialCreatedUnpriced = 'MATERIAL_CREATED_UNPRICED',
  /** The approval selected the row as one to skip or as information only, so nothing is written for it. */
  NothingToSave = 'NOTHING_TO_SAVE',
  /** The approval did not select the row, so nothing is written for it. */
  NotSelected = 'NOT_SELECTED',
  /** The price the row quotes is already the saved price, so nothing is written for it. */
  NoChange = 'NO_CHANGE',
  /**
   * An earlier approval of this import saved a price for the row, or created the material it prices, and this
   * approval leaves the row out. What it saved stays as it was saved.
   */
  RetainedFromEarlier = 'RETAINED_FROM_EARLIER',
  /** Every write for the row is saved. */
  Saved = 'SAVED',
  /** An earlier approval of this import already saved the row exactly as this one would. */
  SavedEarlier = 'SAVED_EARLIER',
  /** This call stopped on one of the row's writes, and nothing was saved for that write. */
  Stopped = 'STOPPED',
  /** Never given to a row; it exists only so an unset value cannot read as a real status. */
  Unknown = 'UNKNOWN',
  /** The row's writes have not run yet. */
  Waiting = 'WAITING'
}

/** What one apply step came to in one call. */
export enum SupplierPriceImportApplyStepResult {
  /**
   * The step was already applied, by an earlier call, a concurrent one or a write outside any apply whose
   * control record this call added, and nothing was written twice.
   */
  AlreadyDone = 'ALREADY_DONE',
  /** The step's material write and its control record were appended by this call. */
  Committed = 'COMMITTED',
  /**
   * The step stopped for any other reason. It wrote nothing, unless the store failed while saving it; the
   * next call reads the control stream and so finds whether that write landed.
   */
  Failed = 'FAILED',
  /** The approval was cancelled or replaced before the step could append, so it wrote nothing. */
  Fenced = 'FENCED',
  /** A material or price the step writes changed after the approval, so it wrote nothing. */
  StaleReviewConflict = 'STALE_REVIEW_CONFLICT',
  /** Never given to a step; it exists only so an unset value cannot read as a real result. */
  Unknown = 'UNKNOWN',
  /** The import's vendor was removed from the material while its prices stayed, so the step wrote nothing. */
  VendorPricesConflict = 'VENDOR_PRICES_CONFLICT'
}

/** The write an apply call stopped on, which saved nothing. */
export type SupplierPriceImportApplyStop = {
  __typename?: 'SupplierPriceImportApplyStop';
  /** The refusal's code; null when it carries none. */
  code?: Maybe<Scalars['String']['output']>;
  /** The material the write was for. */
  materialItemId: Scalars['String']['output'];
  /** The refusal's message. */
  message: Scalars['String']['output'];
  /** The write's position in the approved plan, from 1. */
  ordinal: Scalars['Int']['output'];
  /** What the write came to. */
  result: SupplierPriceImportApplyStepResult;
  /** The rows the write stands for. */
  sourceRowIds: Array<Scalars['String']['output']>;
};

export enum SupplierPriceImportApprovalState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Superseded = 'SUPERSEDED',
  Unknown = 'UNKNOWN'
}

/**
 * One tenant's private supplier-price import workspace: its source, where its extraction stands, the
 * revision its review is at, and which approval it is working from.
 */
export type SupplierPriceImportDocument = {
  __typename?: 'SupplierPriceImportDocument';
  /** The approval the control stream last reported as eligible, for display. Never authority. */
  activeApprovalId: Scalars['String']['output'];
  /** The generation that approval holds, for display. Never authority. */
  approvalGeneration: Scalars['Int']['output'];
  /** The current attempt number against this source. Increments on every accepted start or retry. */
  attempt: Scalars['Int']['output'];
  /** The attempt's absolute ceiling. No renewal moves it. */
  attemptExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** When the workspace was discarded, if it was. */
  discardedAt?: Maybe<Scalars['DateTime']['output']>;
  discardedBy: Scalars['String']['output'];
  /** How many rows the last successful extraction published. */
  extractedRowCount: Scalars['Int']['output'];
  /**
   * The plain progress or recovery message for the current attempt. Safe by construction: it is written
   * from a fixed server vocabulary, so no raw document text and no model output can reach a status.
   */
  extractionMessage: Scalars['String']['output'];
  /**
   * Whether trying the reading again could change the outcome. False before any reading has been started,
   * because that is a start rather than a retry, and false when the latest attempt failed because the
   * reading service is not set up for this environment, which no retry clears. True in every other state:
   * failed, expired, cancelled, superseded, running and succeeded.
   */
  extractionRetryable: Scalars['Boolean']['output'];
  /** Which extraction revision the current rows belong to. A rerun produces a new one. */
  extractionRevision: Scalars['Int']['output'];
  extractionState: SupplierPriceImportExtractionState;
  /** Composite id, {tenantId}-{importId}, matching the AsyncImport job convention. */
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  /** When the live attempt last renewed. Null when no attempt is live. */
  lastHeartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the last explicit retry was ACCEPTED, which is what the server cooldown is measured from. */
  lastRetryAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the current lease lapses unless renewed. Null when no attempt is live. */
  leaseExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The fencing token. Cancel and explicit retry increment it, and every heartbeat, renewal and result
   * carries the generation it was issued under, so a fenced worker can neither extend the lease nor
   * publish.
   */
  leaseGeneration: Scalars['Int']['output'];
  /**
   * The revision whose rows are LIVE. It moves only when an attempt publishes a validated result, so a
   * failed, cancelled or superseded attempt leaves the reviewed rows a person already worked on exactly
   * where they were.
   */
  publishedExtractionRevision: Scalars['Int']['output'];
  /**
   * The existing purchasing vendor this import's prices are for, chosen by the reviewer. Separate from
   * the source document's manufacturer, and never switched by anything the document says.
   */
  purchasingVendorId: Scalars['String']['output'];
  /**
   * The workspace's optimistic review revision. Every review edit carries the revision it read and
   * advances this one, so a stale edit is refused rather than silently overwriting a colleague's.
   */
  reviewRevision: Scalars['Int']['output'];
  /** The one stored source, or null while the workspace is still awaiting it. */
  source?: Maybe<SupplierPriceImportSourceData>;
  status: SupplierPriceImportStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum SupplierPriceImportExtractionState {
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  NeverRun = 'NEVER_RUN',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
  Superseded = 'SUPERSEDED',
  Unknown = 'UNKNOWN'
}

/** Names one import. */
export type SupplierPriceImportInput = {
  importId: Scalars['String']['input'];
};

/** Reports one supplier price import, or why it could not be changed. */
export type SupplierPriceImportPayload = {
  __typename?: 'SupplierPriceImportPayload';
  errors?: Maybe<Array<ValidationError>>;
  supplierPriceImport?: Maybe<SupplierPriceImportDocument>;
};

/**
 * One extracted row of a supplier's price document, with the reviewer's decisions alongside what was
 * read. Rows belong to an extraction revision: a rerun creates a NEW row set and reconciles explicitly,
 * because a row's page and position are evidence of where a number was seen, not a durable identity.
 */
export type SupplierPriceImportRowDocument = {
  __typename?: 'SupplierPriceImportRowDocument';
  /**
   * The reviewer's explicit "Save base; royalty unconfirmed" intent, recorded as its own fact rather
   * than inferred from the royalty state, so a replay can prove the intent was stated.
   */
  baseOnlyIntent: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** What the reviewer decided this row means. Every row carries one. */
  disposition: SupplierPriceRowDisposition;
  /** The draft material's reviewed category, which has to already exist in the tenant. */
  draftCategory: Scalars['String']['output'];
  /** The draft material's reviewed name. */
  draftName: Scalars['String']['output'];
  /**
   * True for a row the document itself shows as dropped — ordered against, confirmed zero. Preserved as
   * its own row rather than merged into a later live row of the same name, because they are different
   * facts about different quantities.
   */
  droppedInSource: Scalars['Boolean']['output'];
  /**
   * Whether an absent effective date is the reviewer's deliberate base-rate choice rather than a
   * date nobody supplied. A missing date and a base rate are different answers.
   */
  effectiveDateDeliberatelyOmitted: Scalars['Boolean']['output'];
  /** The BASE per-each price as read. Never the base plus royalty. */
  extractedBasePerEach?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The base amount exactly as the document printed it, such as ".5354". Evidence of what the page
   * said, kept apart from the number read; it is never read as a number itself.
   */
  extractedBasePerEachText?: Maybe<Scalars['String']['output']>;
  /** Why the base amount was left empty, when the reading said. */
  extractedBasePerEachUnresolvedReason?: Maybe<SupplierPriceAmountUnresolvedReason>;
  /** What the document showed as confirmed. Zero is a real value here, not an absence. */
  extractedConfirmedQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The confirmed quantity exactly as the document printed it. */
  extractedConfirmedQuantityText?: Maybe<Scalars['String']['output']>;
  /** Why the confirmed quantity was left empty, when the reading said. */
  extractedConfirmedQuantityUnresolvedReason?: Maybe<SupplierPriceAmountUnresolvedReason>;
  extractedCurrency: Scalars['String']['output'];
  extractedDescription: Scalars['String']['output'];
  extractedEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** The line extension as read, so a reviewer can reconcile quantity times base against it. */
  extractedExtension?: Maybe<Scalars['Decimal']['output']>;
  /** The line extension exactly as the document printed it. */
  extractedExtensionText?: Maybe<Scalars['String']['output']>;
  /** Why the line extension was left empty, when the reading said. */
  extractedExtensionUnresolvedReason?: Maybe<SupplierPriceAmountUnresolvedReason>;
  /** The product form as printed, such as an unrooted cutting. Used to rank likely matches. */
  extractedForm?: Maybe<Scalars['String']['output']>;
  extractedItemCode: Scalars['String']['output'];
  /** Qualifications the document itself carried for this row, kept verbatim for the reviewer. */
  extractedNotes: Scalars['String']['output'];
  /** What the document showed as ordered, kept even when nothing was confirmed. */
  extractedOrderedQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** The ordered quantity exactly as the document printed it. */
  extractedOrderedQuantityText?: Maybe<Scalars['String']['output']>;
  /** Why the ordered quantity was left empty, when the reading said. */
  extractedOrderedQuantityUnresolvedReason?: Maybe<SupplierPriceAmountUnresolvedReason>;
  /**
   * The unit or pack the document quoted the amounts for, as printed: "each", "per 100", "flat of 32".
   * Evidence for the reviewer, who decides the basis; nothing works one out from it.
   */
  extractedQuotedUnitText?: Maybe<Scalars['String']['output']>;
  /** The royalty per each as read. A null value alone establishes nothing; the royalty's unresolved reason says why, when the reading said. */
  extractedRoyaltyPerEach?: Maybe<Scalars['Decimal']['output']>;
  /** The royalty amount exactly as the document printed it. Never read as a number itself. */
  extractedRoyaltyPerEachText?: Maybe<Scalars['String']['output']>;
  /**
   * Why the royalty was left empty, when the reading said. Any reason but blank means the document printed
   * a figure for the royalty, so confirming there is none holds the row until the royalty is stated or the
   * base is saved alone. Blank is nothing printed or only a word that names no amount, such as "incl.".
   */
  extractedRoyaltyPerEachUnresolvedReason?: Maybe<SupplierPriceAmountUnresolvedReason>;
  /** The size or "Sold As" text as printed. Used to rank likely matches. */
  extractedSize?: Maybe<Scalars['String']['output']>;
  /** The extraction revision that produced this row set. */
  extractionRevision: Scalars['Int']['output'];
  /** Composite id, {tenantId}-{importId}-{extractionRevision}-{sourceRowId}. */
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  /**
   * Whether the source named more than one candidate manufacturer and nobody has picked between
   * them. Held apart from an absent manufacturer so a reviewer is told there is a choice to make.
   */
  manufacturerAmbiguous: Scalars['Boolean']['output'];
  reviewNotes: Scalars['String']['output'];
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the reviewed base amount prices one each or a stated pack of them. */
  reviewedBaseBasis: SupplierPriceQuoteBasis;
  /** How many of the material's units the reviewed base amount covers: one for a direct per-each quote, otherwise a pack size (a decimal, greater than zero, at most 4 decimal places). */
  reviewedBaseDenominator: Scalars['Decimal']['output'];
  /** The BASE the reviewer accepted, when they have. Null while unreviewed. */
  reviewedBasePerEach?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The reviewed base per each as exact decimal text, null whenever reviewedBasePerEach is null. The
   * same amount as the number with every digit it holds; for an amount of twenty fractional digits or
   * fewer it is the canonical form basePerEachText takes, so a client can send it back unchanged. Read
   * this rather than the number, which a JSON client receives as a double.
   */
  reviewedBasePerEachText?: Maybe<Scalars['String']['output']>;
  reviewedBy: Scalars['String']['output'];
  /** The effective date a reviewer established, separate from the source's order and ship dates. */
  reviewedEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** A reviewer's tenant-local manufacturer label, used when no vendor record exists. */
  reviewedManufacturerLabel: Scalars['String']['output'];
  /**
   * The existing vendor record a reviewer named as the manufacturer behind this line. Empty until
   * somebody names one, and never filled in from the purchasing vendor.
   */
  reviewedManufacturerVendorId: Scalars['String']['output'];
  /** Whether the reviewed royalty amount prices one each or a stated pack of them. */
  reviewedRoyaltyBasis: SupplierPriceQuoteBasis;
  /** How many of the material's units the reviewed royalty amount covers; a decimal pack size when the royalty prices a pack. */
  reviewedRoyaltyDenominator: Scalars['Decimal']['output'];
  /**
   * The royalty the reviewer confirmed. Null for every state except Specified, including the
   * explicit "save base, royalty unconfirmed" decision, which is a decision about a NULL amount.
   */
  reviewedRoyaltyPerEach?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The confirmed royalty per each as exact decimal text, null whenever reviewedRoyaltyPerEach is
   * null. Read this rather than the number for the same reason as reviewedBasePerEachText.
   */
  reviewedRoyaltyPerEachText?: Maybe<Scalars['String']['output']>;
  /** This row's own revision, advanced by each review edit. */
  rowRevision: Scalars['Int']['output'];
  royaltyReviewState: SupplierPriceImportRoyaltyReviewState;
  /** Whether this row is part of the selection an approval would cover. */
  selected: Scalars['Boolean']['output'];
  /** The new-material draft this row creates or joins. Repeated rows may share one. */
  sharedDraftId: Scalars['String']['output'];
  /** The source revision these rows were read from. */
  sourceId: Scalars['String']['output'];
  /** Position within the page. Evidence for the reviewer, never identity. */
  sourceOrdinal: Scalars['Int']['output'];
  /** Page the row was read from. Evidence for the reviewer, never identity. */
  sourcePage: Scalars['Int']['output'];
  /**
   * Stable identity of this row WITHIN its extraction revision. Selections, approvals and receipts are
   * all expressed in these, which is why a rerun cannot transfer consent: its rows are new ones.
   */
  sourceRowId: Scalars['String']['output'];
  /** The existing material a matched row points at. Never a production catalog id. */
  targetMaterialItemId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum SupplierPriceImportRoyaltyReviewState {
  ConfirmedNone = 'CONFIRMED_NONE',
  ExtractedUnknown = 'EXTRACTED_UNKNOWN',
  LegacyUnspecified = 'LEGACY_UNSPECIFIED',
  ReviewedUnconfirmed = 'REVIEWED_UNCONFIRMED',
  Specified = 'SPECIFIED',
  Unknown = 'UNKNOWN'
}

/** The stored source document: one per import, immutable once written. */
export type SupplierPriceImportSourceData = {
  __typename?: 'SupplierPriceImportSourceData';
  /** The file name the uploader's browser sent, kept for display only. */
  fileName: Scalars['String']['output'];
  /** What the document's header named as the manufacturer. Never a vendor selection. */
  manufacturerName: Scalars['String']['output'];
  /** Pages the PDF parser found. Bounded before anything was stored. */
  pageCount: Scalars['Int']['output'];
  /** Size of the stored document, as counted while streaming. */
  sizeBytes: Scalars['Long']['output'];
  /** Lower-case hex SHA-256 of the exact stored bytes. */
  sourceHash: Scalars['String']['output'];
  /** Server-minted identity of this source revision. Referenced by every extracted row. */
  sourceId: Scalars['String']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy: Scalars['String']['output'];
};

export enum SupplierPriceImportStatus {
  Approved = 'APPROVED',
  AwaitingSource = 'AWAITING_SOURCE',
  Discarded = 'DISCARDED',
  Extracted = 'EXTRACTED',
  Extracting = 'EXTRACTING',
  ExtractionFailed = 'EXTRACTION_FAILED',
  SourceStored = 'SOURCE_STORED',
  Unknown = 'UNKNOWN'
}

/** One material a reviewer might mean, with what it currently costs from the purchasing vendor. */
export type SupplierPriceMaterialCandidate = {
  __typename?: 'SupplierPriceMaterialCandidate';
  /** The material's category. */
  category: Scalars['String']['output'];
  /** The vendor's live base cost per each, when there is one. */
  currentBasePerEach?: Maybe<Scalars['Decimal']['output']>;
  /** The live effective date; none is a deliberate base rate. */
  currentEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** The live royalty amount, present only for a confirmed state. */
  currentRoyaltyPerEach?: Maybe<Scalars['Decimal']['output']>;
  /** Which of the four royalty states the live price carries. */
  currentRoyaltyStatus: SupplierRoyaltyStatus;
  /** The material's description as stored, unmodified. */
  description: Scalars['String']['output'];
  /** Whether the material is active and can be priced. */
  isAvailable: Scalars['Boolean']['output'];
  /** Whether the purchasing vendor is this material's default. */
  isDefaultVendor: Scalars['Boolean']['output'];
  /** How this material was reached. */
  matchKind: SupplierPriceCandidateMatchKind;
  /** The material item's own id. Never a production catalog id. */
  materialItemId: Scalars['String']['output'];
  /** The material's name as stored, unmodified. */
  name: Scalars['String']['output'];
  /** The material's purchasing revision at read time. */
  purchasingRevision: Scalars['Int']['output'];
  /** Position in the ranking, best first. Never a confidence and never an identity. */
  rank: Scalars['Int']['output'];
  /** The supplier item identifier already recorded on that vendor assignment. */
  vendorItemId: Scalars['String']['output'];
};

export enum SupplierPriceQuoteBasis {
  ConvertedPerPack = 'CONVERTED_PER_PACK',
  DirectPerEach = 'DIRECT_PER_EACH',
  Unknown = 'UNKNOWN'
}

export enum SupplierPriceReviewBlocker {
  CommittedPriceNotInForce = 'COMMITTED_PRICE_NOT_IN_FORCE',
  ConflictingDuplicateRow = 'CONFLICTING_DUPLICATE_ROW',
  IncompleteMaterialDraft = 'INCOMPLETE_MATERIAL_DRAFT',
  MissingBaseOnlyConsent = 'MISSING_BASE_ONLY_CONSENT',
  MissingPurchasingVendor = 'MISSING_PURCHASING_VENDOR',
  MissingTargetMaterial = 'MISSING_TARGET_MATERIAL',
  ReconciliationRequired = 'RECONCILIATION_REQUIRED',
  ReReviewRequired = 'RE_REVIEW_REQUIRED',
  Unknown = 'UNKNOWN',
  UnresolvedBaseAmount = 'UNRESOLVED_BASE_AMOUNT',
  UnresolvedBaseBasis = 'UNRESOLVED_BASE_BASIS',
  UnresolvedCurrency = 'UNRESOLVED_CURRENCY',
  UnresolvedDisposition = 'UNRESOLVED_DISPOSITION',
  UnresolvedEffectiveDate = 'UNRESOLVED_EFFECTIVE_DATE',
  UnresolvedKnownSubtotal = 'UNRESOLVED_KNOWN_SUBTOTAL',
  UnresolvedRoyalty = 'UNRESOLVED_ROYALTY',
  UnresolvedRoyaltyAmount = 'UNRESOLVED_ROYALTY_AMOUNT',
  UnresolvedRoyaltyBasis = 'UNRESOLVED_ROYALTY_BASIS',
  UnsupportedCalcPrecision = 'UNSUPPORTED_CALC_PRECISION'
}

export enum SupplierPriceRowDisposition {
  CreateMaterial = 'CREATE_MATERIAL',
  Informational = 'INFORMATIONAL',
  MatchExisting = 'MATCH_EXISTING',
  Skip = 'SKIP',
  Unknown = 'UNKNOWN',
  Unresolved = 'UNRESOLVED'
}

/**
 * Budget figures for the separately recorded supplier royalty. Its actual side is deliberately
 * ABSENT rather than zero: the recorded cost ledger has material, labor and overhead categories and
 * no supplier-royalty one, so nothing has ever posted a royalty actual. Publishing a zero there
 * would assert that no royalty was spent, which is exactly the false claim the separate component
 * exists to prevent.
 */
export type SupplierRoyaltyCostValueModel = {
  __typename?: 'SupplierRoyaltyCostValueModel';
  /** Always absent — supplier royalty is not separately tracked in the actual ledger. */
  actual?: Maybe<Scalars['Decimal']['output']>;
  /** Budgeted supplier royalty, resolved from the same quotes the material budget used. */
  budget: Scalars['Decimal']['output'];
  /** Whether every quote behind the budget states its supplier royalty. */
  coverage: SupplierRoyaltyCoverage;
  /** Always absent, because it is an actual plus the budgeted remainder. */
  projected?: Maybe<Scalars['Decimal']['output']>;
  /** Always absent, because it is budget minus an actual that does not exist. */
  variance?: Maybe<Scalars['Decimal']['output']>;
};

export enum SupplierRoyaltyCoverage {
  Confirmed = 'CONFIRMED',
  Incomplete = 'INCOMPLETE',
  NotApplicable = 'NOT_APPLICABLE'
}

export enum SupplierRoyaltyStatus {
  ConfirmedNone = 'CONFIRMED_NONE',
  LegacyUnspecified = 'LEGACY_UNSPECIFIED',
  ReviewedUnconfirmed = 'REVIEWED_UNCONFIRMED',
  Specified = 'SPECIFIED'
}

export type SupplierRoyaltyStatusOperationFilterInput = {
  eq?: InputMaybe<SupplierRoyaltyStatus>;
  in?: InputMaybe<Array<SupplierRoyaltyStatus>>;
  neq?: InputMaybe<SupplierRoyaltyStatus>;
  nin?: InputMaybe<Array<SupplierRoyaltyStatus>>;
};

/** One import job in a support tenant snapshot. */
export type SupportImportJob = {
  __typename?: 'SupportImportJob';
  /** When the job finished, or null while it is still running. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the job was started. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email of the user who started the job. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** How many rows failed to import. */
  failedRows?: Maybe<Scalars['Int']['output']>;
  /** The import job's id — the same value asyncImportJob(asyncImportJobId:) takes. */
  id: Scalars['ID']['output'];
  /** How many rows were imported successfully. */
  importedRows?: Maybe<Scalars['Int']['output']>;
  /** What kind of data the job imports. */
  jobType?: Maybe<AsyncImportJobType>;
  /** Where the job is in its import workflow. */
  status?: Maybe<AsyncImportJobStatus>;
  /** How many rows the uploaded file contained. */
  totalRows?: Maybe<Scalars['Int']['output']>;
};

/**
 * Read-only support view of one tenant: its onboarding state and its import jobs from the trailing
 * 14 days, newest first. Carries nothing else the admin tenant read model holds — no integrations,
 * secrets, billing or configuration.
 */
export type SupportTenantSnapshot = {
  __typename?: 'SupportTenantSnapshot';
  /** The tenant's import jobs created in the trailing 14 days, newest first. */
  importJobs: Array<SupportImportJob>;
  /** How far the tenant has progressed through onboarding data setup. */
  onboardingSetup?: Maybe<OnboardingSetupStage>;
  /**
   * How far the tenant has progressed through onboarding training, derived from its office users'
   * learning progress as tenant.learningTrainingStatus derives it.
   */
  onboardingTraining?: Maybe<OnboardingTrainingStatus>;
  /** The files the grower delivered through the onboarding card, oldest first. */
  onboardingUploads?: Maybe<Array<TenantOnboardingUploadData>>;
  /** The tenant id named in the request. */
  tenantId: Scalars['String']['output'];
  /** The tenant's display name. */
  tenantName?: Maybe<Scalars['String']['output']>;
};

export type SwapProductionLotVariantInput = {
  overridePolicy: ProductionLotVariantOverridePolicy;
  productionCatalogId: Scalars['String']['input'];
  productionItemId?: InputMaybe<Scalars['String']['input']>;
  productionLotId: Scalars['String']['input'];
};

export type SyncAttemptData = {
  __typename?: 'SyncAttemptData';
  dateAttempted: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type SynchronizationIterationsConnection = {
  __typename?: 'SynchronizationIterationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SynchronizationIterationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<IterationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SynchronizationIterationsEdge = {
  __typename?: 'SynchronizationIterationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: IterationDocument;
};

/** A connection to a list of items. */
export type SynchronizationOnHandProcessIterationsConnection = {
  __typename?: 'SynchronizationOnHandProcessIterationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SynchronizationOnHandProcessIterationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OnHandProcessIterationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SynchronizationOnHandProcessIterationsEdge = {
  __typename?: 'SynchronizationOnHandProcessIterationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OnHandProcessIterationDocument;
};

/** A connection to a list of items. */
export type SynchronizationOnHandQueueingIterationsConnection = {
  __typename?: 'SynchronizationOnHandQueueingIterationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SynchronizationOnHandQueueingIterationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OnHandQueueIterationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SynchronizationOnHandQueueingIterationsEdge = {
  __typename?: 'SynchronizationOnHandQueueingIterationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OnHandQueueIterationDocument;
};

export type SynchronizeErpItemPricingInput = {
  erpPriceGroupId: Scalars['String']['input'];
  itemPrices: Array<ItemPriceInput>;
};

export type SynchronizeRestockSessionInput = {
  sessionId: Scalars['String']['input'];
};

export type SynchronizeSalesPeopleInput = {
  salesPeople: Array<SalesPersonMapDataInput>;
};

/** A color in the tenant's list of tag colors, including deleted ones. */
export type TagColorDocument = {
  __typename?: 'TagColorDocument';
  /** The color's name, such as Red. Unique within the tenant ignoring case, deleted colors included. */
  name: Scalars['String']['output'];
  /**
   * Whether the tenant has put this color on hold. It is stored and returned as set; the tag color
   * list itself does not act on it.
   */
  onHold: Scalars['Boolean']['output'];
  /** The color's position in the tenant's list, 0 or more. Lower values come first. */
  sortOrder: Scalars['Int']['output'];
  /**
   * ACTIVE while the color is in the list, DELETED after deleteTagColor. Deleted colors are still
   * returned so records that use them can name them, and undeleteTagColor brings one back.
   */
  status: TagColorStatus;
  /** The tag color's id, unique within the tenant. It stays the same when the color is renamed. */
  tagColorId: Scalars['String']['output'];
};

/** A color in the tenant's list of tag colors, including deleted ones. */
export type TagColorDocumentFilterInput = {
  and?: InputMaybe<Array<TagColorDocumentFilterInput>>;
  /** The color's name, such as Red. Unique within the tenant ignoring case, deleted colors included. */
  name?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether the tenant has put this color on hold. It is stored and returned as set; the tag color
   * list itself does not act on it.
   */
  onHold?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<TagColorDocumentFilterInput>>;
  /** The color's position in the tenant's list, 0 or more. Lower values come first. */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  /**
   * ACTIVE while the color is in the list, DELETED after deleteTagColor. Deleted colors are still
   * returned so records that use them can name them, and undeleteTagColor brings one back.
   */
  status?: InputMaybe<TagColorStatusOperationFilterInput>;
  /** The tag color's id, unique within the tenant. It stays the same when the color is renamed. */
  tagColorId?: InputMaybe<StringOperationFilterInput>;
};

/** A color in the tenant's list of tag colors, including deleted ones. */
export type TagColorDocumentSortInput = {
  /** The color's name, such as Red. Unique within the tenant ignoring case, deleted colors included. */
  name?: InputMaybe<SortEnumType>;
  /**
   * Whether the tenant has put this color on hold. It is stored and returned as set; the tag color
   * list itself does not act on it.
   */
  onHold?: InputMaybe<SortEnumType>;
  /** The color's position in the tenant's list, 0 or more. Lower values come first. */
  sortOrder?: InputMaybe<SortEnumType>;
  /**
   * ACTIVE while the color is in the list, DELETED after deleteTagColor. Deleted colors are still
   * returned so records that use them can name them, and undeleteTagColor brings one back.
   */
  status?: InputMaybe<SortEnumType>;
  /** The tag color's id, unique within the tenant. It stays the same when the color is renamed. */
  tagColorId?: InputMaybe<SortEnumType>;
};

/** The result of a tag color mutation: the tag color after the change, or the errors that stopped it. */
export type TagColorPayload = {
  __typename?: 'TagColorPayload';
  errors?: Maybe<Array<ValidationError>>;
  tagColor?: Maybe<TagColorStateData>;
};

/** A tag color as a mutation returns it, after the change. */
export type TagColorStateData = {
  __typename?: 'TagColorStateData';
  /** The color's name, such as Red. Unique within the tenant ignoring case, deleted colors included. */
  name: Scalars['String']['output'];
  /**
   * Whether the tenant has put this color on hold. It is stored and returned as set; the tag color
   * list itself does not act on it.
   */
  onHold: Scalars['Boolean']['output'];
  /** The color's position in the tenant's list, 0 or more. Lower values come first. */
  sortOrder: Scalars['Int']['output'];
  /**
   * ACTIVE while the color is in the list, DELETED after deleteTagColor. Deleted colors are still
   * returned so records that use them can name them, and undeleteTagColor brings one back.
   */
  status: TagColorStatus;
  /** The tag color's id, unique within the tenant. It stays the same when the color is renamed. */
  tagColorId: Scalars['String']['output'];
};

export enum TagColorStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type TagColorStatusOperationFilterInput = {
  eq?: InputMaybe<TagColorStatus>;
  in?: InputMaybe<Array<TagColorStatus>>;
  neq?: InputMaybe<TagColorStatus>;
  nin?: InputMaybe<Array<TagColorStatus>>;
};

export type TagColorValuesInput = {
  name: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
};

/** A connection to a list of items. */
export type TagColorsConnection = {
  __typename?: 'TagColorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TagColorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TagColorDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TagColorsEdge = {
  __typename?: 'TagColorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TagColorDocument;
};

export type TagSpecDataInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fulfillItemCode?: InputMaybe<Scalars['String']['input']>;
  genus?: InputMaybe<Scalars['String']['input']>;
  retail?: InputMaybe<Scalars['Decimal']['input']>;
  series?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  tagCode: Scalars['String']['input'];
  tagId?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
  weekFrom?: InputMaybe<Scalars['Int']['input']>;
  weekTo?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type TakeAllocationSourceInput = {
  lineItemId: Scalars['UUID']['input'];
  orderId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type TakeLineItemAllocationsInput = {
  grade: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  lineItemId: Scalars['UUID']['input'];
  locationId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  sources: Array<TakeAllocationSourceInput>;
};

export enum TargetType {
  Category = 'CATEGORY',
  Item = 'ITEM',
  Material = 'MATERIAL'
}

export type TargetTypeOperationFilterInput = {
  eq?: InputMaybe<TargetType>;
  in?: InputMaybe<Array<TargetType>>;
  neq?: InputMaybe<TargetType>;
  nin?: InputMaybe<Array<TargetType>>;
};

/** MongoDB read model document for the TaskAssignment aggregate. */
export type TaskAssignmentDocument = {
  __typename?: 'TaskAssignmentDocument';
  activeTimerCreatedBy?: Maybe<Scalars['String']['output']>;
  /**
   * Number of workers that the currently running timer is tracking time for.
   * Null when no timer is running. Mirrors TaskAssignmentState.ActiveTimerHeadcount.
   * Introduced by finding #54 — previously tracked only in aggregate state.
   */
  activeTimerHeadcount?: Maybe<Scalars['Int']['output']>;
  activeTimerStartTime?: Maybe<Scalars['DateTime']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * The task's due date. It is set in one of three ways: on creation (the optional dueDate
   * input), by the materialization trigger (TaskAssignmentDueDateAssigned), or by
   * changeTaskAssignmentDueDate. It is null only when none of those set it. Nullable so the
   * GraphQL field is additive (DateTime, not DateTime!, AI Atlas bde8323d); no migration for
   * existing documents.
   */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /**
   * True when this task is a planned Move task (it carries plannedMove). Tasks written before planned
   * moves read false.
   */
  isPlannedMove: Scalars['Boolean']['output'];
  /**
   * Planned hours for the step: the job quantity divided by the step's crew speed, worked out when the task
   * was created. Null when the task is not a step task or the step has no usable crew speed.
   */
  plannedHours?: Maybe<Scalars['Decimal']['output']>;
  /** The dated move this Move task applies when it is completed. Null for every other task. */
  plannedMove?: Maybe<PlannedProductionJobMove>;
  productionJobId?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable production job number of the linked job, surfaced in place of the raw
   * production job id. Null for ad-hoc/floating tasks that have no production job.
   */
  productionJobNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * The task event step (detail) this task does, when the task is one step of a job's task event. Null for
   * a bundle-level, ad-hoc or floating task.
   */
  productionTaskEventDetailId?: Maybe<Scalars['String']['output']>;
  /**
   * Site (the linked production job's location) this task belongs to, for server-side
   * site filtering. Null for ad-hoc/floating tasks that have no production job.
   */
  siteLocationId?: Maybe<Scalars['String']['output']>;
  sourceLevel: TaskAssignmentSourceLevel;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  status: TaskAssignmentStatus;
  /**
   * The step's name, such as Pinching, shown with taskEventName (the task event, or bundle) as context. Null
   * when the task is not a step task.
   */
  stepName?: Maybe<Scalars['String']['output']>;
  taskAssignmentId: Scalars['String']['output'];
  taskEventName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /** Sum of duration (in seconds) from all time entries on this task assignment. */
  totalDurationSeconds: Scalars['Long']['output'];
  /** Sum of headcount across all time entries on this task assignment. */
  totalLaborUnits: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** MongoDB read model document for the TaskAssignment aggregate. */
export type TaskAssignmentDocumentFilterInput = {
  activeTimerCreatedBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * Number of workers that the currently running timer is tracking time for.
   * Null when no timer is running. Mirrors TaskAssignmentState.ActiveTimerHeadcount.
   * Introduced by finding #54 — previously tracked only in aggregate state.
   */
  activeTimerHeadcount?: InputMaybe<IntOperationFilterInput>;
  activeTimerStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<TaskAssignmentDocumentFilterInput>>;
  assignedTo?: InputMaybe<StringOperationFilterInput>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  completedBy?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /**
   * The task's due date. It is set in one of three ways: on creation (the optional dueDate
   * input), by the materialization trigger (TaskAssignmentDueDateAssigned), or by
   * changeTaskAssignmentDueDate. It is null only when none of those set it. Nullable so the
   * GraphQL field is additive (DateTime, not DateTime!, AI Atlas bde8323d); no migration for
   * existing documents.
   */
  dueDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * True when this task is a planned Move task (it carries plannedMove). Tasks written before planned
   * moves read false.
   */
  isPlannedMove?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<TaskAssignmentDocumentFilterInput>>;
  /**
   * Planned hours for the step: the job quantity divided by the step's crew speed, worked out when the task
   * was created. Null when the task is not a step task or the step has no usable crew speed.
   */
  plannedHours?: InputMaybe<DecimalOperationFilterInput>;
  /** The dated move this Move task applies when it is completed. Null for every other task. */
  plannedMove?: InputMaybe<PlannedProductionJobMoveFilterInput>;
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Human-readable production job number of the linked job, surfaced in place of the raw
   * production job id. Null for ad-hoc/floating tasks that have no production job.
   */
  productionJobNumber?: InputMaybe<OptionOfInt32FilterInput>;
  /**
   * The task event step (detail) this task does, when the task is one step of a job's task event. Null for
   * a bundle-level, ad-hoc or floating task.
   */
  productionTaskEventDetailId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Site (the linked production job's location) this task belongs to, for server-side
   * site filtering. Null for ad-hoc/floating tasks that have no production job.
   */
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  sourceLevel?: InputMaybe<TaskAssignmentSourceLevelOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  startedBy?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<TaskAssignmentStatusOperationFilterInput>;
  /**
   * The step's name, such as Pinching, shown with taskEventName (the task event, or bundle) as context. Null
   * when the task is not a step task.
   */
  stepName?: InputMaybe<StringOperationFilterInput>;
  taskAssignmentId?: InputMaybe<StringOperationFilterInput>;
  taskEventName?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Sum of duration (in seconds) from all time entries on this task assignment. */
  totalDurationSeconds?: InputMaybe<LongOperationFilterInput>;
  /** Sum of headcount across all time entries on this task assignment. */
  totalLaborUnits?: InputMaybe<IntOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for the TaskAssignment aggregate. */
export type TaskAssignmentDocumentSortInput = {
  activeTimerCreatedBy?: InputMaybe<SortEnumType>;
  /**
   * Number of workers that the currently running timer is tracking time for.
   * Null when no timer is running. Mirrors TaskAssignmentState.ActiveTimerHeadcount.
   * Introduced by finding #54 — previously tracked only in aggregate state.
   */
  activeTimerHeadcount?: InputMaybe<SortEnumType>;
  activeTimerStartTime?: InputMaybe<SortEnumType>;
  assignedTo?: InputMaybe<SortEnumType>;
  completedAt?: InputMaybe<SortEnumType>;
  completedBy?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /**
   * The task's due date. It is set in one of three ways: on creation (the optional dueDate
   * input), by the materialization trigger (TaskAssignmentDueDateAssigned), or by
   * changeTaskAssignmentDueDate. It is null only when none of those set it. Nullable so the
   * GraphQL field is additive (DateTime, not DateTime!, AI Atlas bde8323d); no migration for
   * existing documents.
   */
  dueDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * True when this task is a planned Move task (it carries plannedMove). Tasks written before planned
   * moves read false.
   */
  isPlannedMove?: InputMaybe<SortEnumType>;
  /**
   * Planned hours for the step: the job quantity divided by the step's crew speed, worked out when the task
   * was created. Null when the task is not a step task or the step has no usable crew speed.
   */
  plannedHours?: InputMaybe<SortEnumType>;
  /** The dated move this Move task applies when it is completed. Null for every other task. */
  plannedMove?: InputMaybe<PlannedProductionJobMoveSortInput>;
  productionJobId?: InputMaybe<SortEnumType>;
  /**
   * Human-readable production job number of the linked job, surfaced in place of the raw
   * production job id. Null for ad-hoc/floating tasks that have no production job.
   */
  productionJobNumber?: InputMaybe<SortEnumType>;
  /**
   * The task event step (detail) this task does, when the task is one step of a job's task event. Null for
   * a bundle-level, ad-hoc or floating task.
   */
  productionTaskEventDetailId?: InputMaybe<SortEnumType>;
  /**
   * Site (the linked production job's location) this task belongs to, for server-side
   * site filtering. Null for ad-hoc/floating tasks that have no production job.
   */
  siteLocationId?: InputMaybe<SortEnumType>;
  sourceLevel?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  startedBy?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /**
   * The step's name, such as Pinching, shown with taskEventName (the task event, or bundle) as context. Null
   * when the task is not a step task.
   */
  stepName?: InputMaybe<SortEnumType>;
  taskAssignmentId?: InputMaybe<SortEnumType>;
  taskEventName?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Sum of duration (in seconds) from all time entries on this task assignment. */
  totalDurationSeconds?: InputMaybe<SortEnumType>;
  /** Sum of headcount across all time entries on this task assignment. */
  totalLaborUnits?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** GraphQL data type for task assignment notes. */
export type TaskAssignmentNoteData = {
  __typename?: 'TaskAssignmentNoteData';
  addedAt: Scalars['DateTime']['output'];
  addedBy: Scalars['String']['output'];
  content: Scalars['String']['output'];
};

/** GraphQL payload for TaskAssignment mutations. */
export type TaskAssignmentPayload = {
  __typename?: 'TaskAssignmentPayload';
  errors?: Maybe<Array<ValidationError>>;
  taskAssignment?: Maybe<TaskAssignmentStateData>;
};

export enum TaskAssignmentSourceLevel {
  AdHoc = 'AD_HOC',
  Category = 'CATEGORY',
  Item = 'ITEM',
  Recipe = 'RECIPE',
  Unknown = 'UNKNOWN'
}

export type TaskAssignmentSourceLevelOperationFilterInput = {
  eq?: InputMaybe<TaskAssignmentSourceLevel>;
  in?: InputMaybe<Array<TaskAssignmentSourceLevel>>;
  neq?: InputMaybe<TaskAssignmentSourceLevel>;
  nin?: InputMaybe<Array<TaskAssignmentSourceLevel>>;
};

/** GraphQL data type for TaskAssignment state. */
export type TaskAssignmentStateData = {
  __typename?: 'TaskAssignmentStateData';
  assignedTo?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  notes: Array<TaskAssignmentNoteData>;
  /** The step's planned hours, job quantity divided by the step's crew speed; null when unknown. */
  plannedHours?: Maybe<Scalars['Decimal']['output']>;
  productionJobId?: Maybe<Scalars['String']['output']>;
  productionJobNumber?: Maybe<Scalars['Int']['output']>;
  /** The task event step (detail) this task does; null when it is not a step task. */
  productionTaskEventDetailId?: Maybe<Scalars['String']['output']>;
  siteLocationId?: Maybe<Scalars['String']['output']>;
  sourceLevel: TaskAssignmentSourceLevel;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  status: TaskAssignmentStatus;
  /** The step's name, read with taskEventName (the bundle) as context; null when not a step task. */
  stepName?: Maybe<Scalars['String']['output']>;
  taskAssignmentId: Scalars['String']['output'];
  taskEventName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timeEntries: Array<TimeEntryData>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum TaskAssignmentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

export type TaskAssignmentStatusOperationFilterInput = {
  eq?: InputMaybe<TaskAssignmentStatus>;
  in?: InputMaybe<Array<TaskAssignmentStatus>>;
  neq?: InputMaybe<TaskAssignmentStatus>;
  nin?: InputMaybe<Array<TaskAssignmentStatus>>;
};

/** A connection to a list of items. */
export type TaskAssignmentsConnection = {
  __typename?: 'TaskAssignmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TaskAssignmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TaskAssignmentDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaskAssignmentsEdge = {
  __typename?: 'TaskAssignmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaskAssignmentDocument;
};

/**
 * One group header for the Task Events sidebar: the group's Key (also used as the
 * where eq-value when lazy-loading the group's children via productionTaskEvents), a
 * display Label, and the server-computed Count of events in the group under
 * the active search. For the Status dimension the Key is the canonical SCREAMING_SNAKE
 * enum name (e.g. ACTIVE), so it is directly usable as the GraphQL enum literal in
 * where: { status: { eq: ACTIVE } }.
 */
export type TaskEventGroupBucket = {
  __typename?: 'TaskEventGroupBucket';
  /** Number of events in the group matching the active search filter. */
  count: Scalars['Int']['output'];
  /** Raw group key — canonical status enum name, or the event name. */
  key: Scalars['String']['output'];
  /** Display label for the group header (currently equal to the key). */
  label: Scalars['String']['output'];
};

/**
 * Grouping dimension for taskEventGroups. Mirrors the Task Events sidebar's group-by options so
 * the client can render server-computed group headers instead of grouping the full event list in
 * memory: Status buckets on the event lifecycle status, Name buckets on the event name.
 * Both are flat scalar fields on ProductionTaskEventDocument.
 */
export enum TaskEventGroupField {
  /** One bucket per distinct event name. */
  Name = 'NAME',
  /** One bucket per distinct event status (Active / Inactive / Unknown). Deleted is excluded. */
  Status = 'STATUS'
}

export type TaskEventRegenerationCandidateProjection = {
  __typename?: 'TaskEventRegenerationCandidateProjection';
  defaultAssignedTo?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
};

/** MongoDB read model document for TaskEventType. */
export type TaskEventTypeDocument = {
  __typename?: 'TaskEventTypeDocument';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reducesSellableStock: Scalars['Boolean']['output'];
  status: TaskEventTypeStatus;
  taskEventTypeId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** MongoDB read model document for TaskEventType. */
export type TaskEventTypeDocumentFilterInput = {
  and?: InputMaybe<Array<TaskEventTypeDocumentFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TaskEventTypeDocumentFilterInput>>;
  reducesSellableStock?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<TaskEventTypeStatusOperationFilterInput>;
  taskEventTypeId?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for TaskEventType. */
export type TaskEventTypeDocumentSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  reducesSellableStock?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskEventTypeId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
};

/** GraphQL payload for TaskEventType mutations. */
export type TaskEventTypePayload = {
  __typename?: 'TaskEventTypePayload';
  errors?: Maybe<Array<ValidationError>>;
  taskEventType?: Maybe<TaskEventTypeStateData>;
};

export type TaskEventTypeStateData = {
  __typename?: 'TaskEventTypeStateData';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reducesSellableStock: Scalars['Boolean']['output'];
  status: TaskEventTypeStatus;
  taskEventTypeId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum TaskEventTypeStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export type TaskEventTypeStatusOperationFilterInput = {
  eq?: InputMaybe<TaskEventTypeStatus>;
  in?: InputMaybe<Array<TaskEventTypeStatus>>;
  neq?: InputMaybe<TaskEventTypeStatus>;
  nin?: InputMaybe<Array<TaskEventTypeStatus>>;
};

/** A connection to a list of items. */
export type TaskEventTypesConnection = {
  __typename?: 'TaskEventTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TaskEventTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TaskEventTypeDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaskEventTypesEdge = {
  __typename?: 'TaskEventTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaskEventTypeDocument;
};

/** A connection to a list of items. */
export type TenantAsyncImportJobsConnection = {
  __typename?: 'TenantAsyncImportJobsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TenantAsyncImportJobsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AsyncImportJobDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TenantAsyncImportJobsEdge = {
  __typename?: 'TenantAsyncImportJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AsyncImportJobDocument;
};

/**
 * Whether Stripe Tax can calculate tax on the platform-billing objects that charge a tenant for
 * WorkSuite. Spans two different Stripe vocabularies — a CUSTOMER's tax.automatic_tax and an
 * INVOICE's automatic_tax.status — so one indicator can read both.
 */
export enum TenantAutomaticTaxStatus {
  /** Stripe's tax calculation failed — failed on both a customer and an invoice. */
  Failed = 'FAILED',
  /**
   * Tax is not being collected. On a customer this is Stripe's not_collecting (no
   * registration covers the customer's location); on an invoice it is automatic tax switched off, so
   * no calculation was attempted at all.
   */
  NotCollecting = 'NOT_COLLECTING',
  /**
   * Tax can be calculated. On a customer this is Stripe's supported; on an invoice it is
   * complete — including a complete calculation that came to zero, which is an exemption and
   * not a problem.
   */
  Supported = 'SUPPORTED',
  /**
   * Stripe reported no automatic-tax value, or one this version does not recognize. The default, so
   * a value Stripe adds later degrades to "we do not know" rather than to a specific claim.
   */
  Unknown = 'UNKNOWN',
  /**
   * Stripe cannot place the customer. On a customer this is unrecognized_location; on an
   * invoice it is requires_location_inputs.
   */
  UnrecognizedLocation = 'UNRECOGNIZED_LOCATION'
}

/**
 * GraphQL + read-model projection of a tenant's platform-billing state (TenantBilling).
 * Surfaced on both the tenant-scoped tenant query and the cross-tenant admin surface, and
 * embedded in AdminTenantDocument. Amounts are money in minor units (e.g. cents).
 */
export type TenantBillingData = {
  __typename?: 'TenantBillingData';
  /**
   * The active charge in minor units for the current Frequency — the rate-card amount
   * for that cadence. Null when no cadence is active or that cadence is not offered. Derived; not stored.
   */
  activeChargeAmount?: Maybe<Scalars['Long']['output']>;
  /** Per-tenant annual charge in minor units. Null = annual cadence not offered. */
  annualAmount?: Maybe<Scalars['Long']['output']>;
  /**
   * One priced offer per cadence this tenant's rate card carries an amount for: the negotiated
   * pre-tax amount, Stripe's estimate of the tax and total on it, and whether card is offered
   * alongside ACH at that amount. Empty when no cadence is offered. The stored amounts are always
   * present; only the tax estimate needs Stripe, and it is null when Stripe did not calculate one —
   * no usable address, automatic tax off, or a read that failed. Creates nothing in Stripe.
   */
  cadenceOffers: Array<TenantCadenceOffer>;
  /** When a cancellation is scheduled, the instant the subscription ends; null when none is scheduled. */
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  /** True when Stripe has a cancellation scheduled for this subscription (auto-renewal is off). */
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  /**
   * Starting annual price and collection terms of this tenant's live contract (see hasLiveContract).
   * Available before its Stripe subscription starts; null when there is no live contract or phase,
   * and on a row of a tenant list. This is the first phase's price, not the sum of all phases or the
   * active subscription's charge.
   */
  contractBilling?: Maybe<TenantContractBillingSummary>;
  /**
   * End of the last phase of this tenant's live contract record (see hasLiveContract); null
   * when there is none, and on a row of a tenant list.
   */
  contractEndDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Start date of this tenant's live contract record (see hasLiveContract); null when there
   * is none, and on a row of a tenant list.
   */
  contractStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** ISO-4217 currency code for the rate card. Defaults to USD. */
  currency: Scalars['String']['output'];
  /** Next renewal / charge date; null when there is no active subscription period. */
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** The active billing cadence. The active charge is the rate-card amount for this cadence. */
  frequency: BillingFrequency;
  /**
   * True when THIS tenant has a live contract record: a ContractRecords row with no
   * cancellation and status Succeeded or Verified. When more than one live record exists for the
   * tenant, the one with the latest submittedAt is used. Backs the worksuite-pwa Billing page
   * for a future-start enrollment, whose Stripe mirror stays empty until the schedule activates on
   * the contract's start date, and the createMySubscriptionCheckoutSession refusal that keeps
   * a contracted tenant from starting a second, duplicate subscription. Always false on a row of a
   * tenant LIST, where this is not resolved at all (see the remarks): a list row cannot report a
   * contract, so read it off tenant or adminTenant, or read contractRecords for
   * a cross-tenant list.
   */
  hasLiveContract: Scalars['Boolean']['output'];
  /**
   * This tenant's live contract record's installation-fee lane (see hasLiveContract);
   * null when there is no live record, the record carries no fee, or the fee has been voided, and on
   * a row of a tenant list. The hosted invoice URL and due date stay null until the fee reaches Sent,
   * and the paid date and paid amount populate once it reaches Paid.
   */
  installFee?: Maybe<TenantInstallFee>;
  /**
   * The most recently raised invoice for this tenant's Stripe customer, whatever raised it — a
   * subscription renewal or a standalone installation fee. A real finalized invoice, not an estimate.
   * Null when the customer has never been invoiced, when the tenant has no Stripe customer, when
   * Stripe could not be read, and on a row of a tenant list.
   */
  lastInvoice?: Maybe<TenantInvoiceSummary>;
  /** Amount of the most recent successful payment in minor units; null until a payment is recorded. */
  lastPaymentAmount?: Maybe<Scalars['Long']['output']>;
  /** Date of the most recent successful payment; null until a payment is recorded. */
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Per-tenant monthly charge in minor units. Null = monthly cadence not offered. */
  monthlyAmount?: Maybe<Scalars['Long']['output']>;
  /**
   * DEPRECATED (T21): always false. Card-vs-ACH eligibility is no longer a single on/off
   * flag — ACH is offered at any amount, and card is offered up to the effective ceiling published
   * as onlinePaymentMaxAmount. Retained (not removed) only because deleting a GraphQL field
   * is a breaking change for worksuite-pwa; the pwa cleanup removes the read and this field retires
   * with it.
   * @deprecated Always false since T21. Card-vs-ACH eligibility is no longer a single on/off flag — ACH is offered at any amount and card up to onlinePaymentMaxAmount. Read onlinePaymentMaxAmount instead.
   */
  onlinePaymentDisabled: Scalars['Boolean']['output'];
  /**
   * The EFFECTIVE card-eligibility ceiling in minor units for this tenant (T28/T21). ACH is offered
   * at any amount — nothing is collected offline by amount. This is the INCLUSIVE ceiling at or below
   * which card is additionally offered alongside ACH; a chosen cadence charge above it is ACH-only.
   * Resolution order: this tenant's onlinePaymentMaxAmountOverride if set; else the system
   * payment-configuration aggregate's Active processor cap; else the StripeOptions bootstrap
   * fallback, used only before any processor has ever been activated.
   */
  onlinePaymentMaxAmount: Scalars['Long']['output'];
  /**
   * This tenant's own online-payment-ceiling override in minor units (T28, superadmin-set); null
   * when none is set. When set, it wins over the system-resolved value published as
   * onlinePaymentMaxAmount — see that field's description for the full resolution order.
   */
  onlinePaymentMaxAmountOverride?: Maybe<Scalars['Long']['output']>;
  /** Per-tenant quarterly charge in minor units. Null = quarterly cadence not offered. */
  quarterlyAmount?: Maybe<Scalars['Long']['output']>;
  /** The subscription lifecycle status mirrored from Stripe. */
  status: BillingStatus;
  /** Stripe customer id (cus_…); null until the tenant is linked to Stripe. */
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this tenant is linked to a Stripe customer. The precondition for every live Stripe read
   * on this type: with no customer there is nothing to ask Stripe about, so tax readiness, both
   * invoice fields and every cadence tax estimate are null. Derived; not stored.
   */
  stripeCustomerLinked: Scalars['Boolean']['output'];
  /**
   * Stripe Subscription Schedule id (sub_sched_…) mirrored from the linked subscription;
   * null until a schedule-managed subscription is first linked. Cleared on both release paths
   * (dwight PR 14408 review, 116544): a watermark-fresh subscription webhook that carries no
   * schedule detaches it automatically, and releaseMirroredStripeSchedule clears it on
   * demand. A non-null value therefore reflects a live schedule as of the newest delivery wsapi
   * has processed. Lets the admin card deep-link the schedule in the Stripe dashboard.
   */
  stripeScheduleId?: Maybe<Scalars['String']['output']>;
  /** Stripe subscription id (sub_…); null until a subscription is created. */
  subscriptionId?: Maybe<Scalars['String']['output']>;
  /**
   * The subscription's line items (Stripe subscription item + price references). Multi-item-capable
   * so a future per-module subscription is the same shape; empty until the tenant is linked.
   */
  subscriptionItems: Array<TenantSubscriptionItemData>;
  /**
   * Date the linked Stripe subscription was first created, mirrored from
   * subscription.start_date; null until a subscription is linked.
   */
  subscriptionStartDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether Stripe Tax can calculate tax when Silver Fern charges THIS tenant for WorkSuite, and the
   * most recent uncleared failure if there is one. Null when the tenant has no Stripe customer, and
   * null when Stripe could not be read — including on a row of a tenant LIST, where this is not
   * resolved at all (see the remarks). Resolved live from Stripe with the platform key.
   */
  taxReadiness?: Maybe<TenantTaxReadiness>;
  /**
   * End of the subscription's contracted term, mirrored from the linked Subscription Schedule's
   * last phase end — only when the webhook payload carries the expanded Subscription Schedule
   * object. wsapi's webhook endpoint does not currently request that expansion, so this field is
   * effectively always null today; also null when the subscription has no schedule.
   */
  termEndDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Stripe's preview of the next charge on this tenant's existing subscription — or, before one
   * exists, on its mirrored future-start schedule. Every amount is an estimate that can still move
   * before Stripe finalizes the invoice. Null when nothing is scheduled, when the tenant has no
   * Stripe customer, when Stripe could not be read, and on a row of a tenant list. Creates nothing in
   * Stripe.
   */
  upcomingInvoice?: Maybe<TenantInvoiceSummary>;
};

/**
 * GraphQL + read-model projection of a tenant's platform-billing state (TenantBilling).
 * Surfaced on both the tenant-scoped tenant query and the cross-tenant admin surface, and
 * embedded in AdminTenantDocument. Amounts are money in minor units (e.g. cents).
 */
export type TenantBillingDataFilterInput = {
  and?: InputMaybe<Array<TenantBillingDataFilterInput>>;
  /** Per-tenant annual charge in minor units. Null = annual cadence not offered. */
  annualAmount?: InputMaybe<LongOperationFilterInput>;
  /** When a cancellation is scheduled, the instant the subscription ends; null when none is scheduled. */
  cancelAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** True when Stripe has a cancellation scheduled for this subscription (auto-renewal is off). */
  cancelAtPeriodEnd?: InputMaybe<BooleanOperationFilterInput>;
  /** ISO-4217 currency code for the rate card. Defaults to USD. */
  currency?: InputMaybe<StringOperationFilterInput>;
  /** Next renewal / charge date; null when there is no active subscription period. */
  currentPeriodEnd?: InputMaybe<DateTimeOperationFilterInput>;
  /** The active billing cadence. The active charge is the rate-card amount for this cadence. */
  frequency?: InputMaybe<BillingFrequencyOperationFilterInput>;
  /** Amount of the most recent successful payment in minor units; null until a payment is recorded. */
  lastPaymentAmount?: InputMaybe<LongOperationFilterInput>;
  /** Date of the most recent successful payment; null until a payment is recorded. */
  lastPaymentDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Per-tenant monthly charge in minor units. Null = monthly cadence not offered. */
  monthlyAmount?: InputMaybe<LongOperationFilterInput>;
  /**
   * This tenant's own online-payment-ceiling override in minor units (T28, superadmin-set); null
   * when none is set. When set, it wins over the system-resolved value published as
   * onlinePaymentMaxAmount — see that field's description for the full resolution order.
   */
  onlinePaymentMaxAmountOverride?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<TenantBillingDataFilterInput>>;
  /** Per-tenant quarterly charge in minor units. Null = quarterly cadence not offered. */
  quarterlyAmount?: InputMaybe<LongOperationFilterInput>;
  /** The subscription lifecycle status mirrored from Stripe. */
  status?: InputMaybe<BillingStatusOperationFilterInput>;
  /** Stripe customer id (cus_…); null until the tenant is linked to Stripe. */
  stripeCustomerId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Stripe Subscription Schedule id (sub_sched_…) mirrored from the linked subscription;
   * null until a schedule-managed subscription is first linked. Cleared on both release paths
   * (dwight PR 14408 review, 116544): a watermark-fresh subscription webhook that carries no
   * schedule detaches it automatically, and releaseMirroredStripeSchedule clears it on
   * demand. A non-null value therefore reflects a live schedule as of the newest delivery wsapi
   * has processed. Lets the admin card deep-link the schedule in the Stripe dashboard.
   */
  stripeScheduleId?: InputMaybe<StringOperationFilterInput>;
  /** Stripe subscription id (sub_…); null until a subscription is created. */
  subscriptionId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The subscription's line items (Stripe subscription item + price references). Multi-item-capable
   * so a future per-module subscription is the same shape; empty until the tenant is linked.
   */
  subscriptionItems?: InputMaybe<ListFilterInputTypeOfTenantSubscriptionItemDataFilterInput>;
  /**
   * Date the linked Stripe subscription was first created, mirrored from
   * subscription.start_date; null until a subscription is linked.
   */
  subscriptionStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * End of the subscription's contracted term, mirrored from the linked Subscription Schedule's
   * last phase end — only when the webhook payload carries the expanded Subscription Schedule
   * object. wsapi's webhook endpoint does not currently request that expansion, so this field is
   * effectively always null today; also null when the subscription has no schedule.
   */
  termEndDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * GraphQL + read-model projection of a tenant's platform-billing state (TenantBilling).
 * Surfaced on both the tenant-scoped tenant query and the cross-tenant admin surface, and
 * embedded in AdminTenantDocument. Amounts are money in minor units (e.g. cents).
 */
export type TenantBillingDataSortInput = {
  /** Per-tenant annual charge in minor units. Null = annual cadence not offered. */
  annualAmount?: InputMaybe<SortEnumType>;
  /** When a cancellation is scheduled, the instant the subscription ends; null when none is scheduled. */
  cancelAt?: InputMaybe<SortEnumType>;
  /** True when Stripe has a cancellation scheduled for this subscription (auto-renewal is off). */
  cancelAtPeriodEnd?: InputMaybe<SortEnumType>;
  /** ISO-4217 currency code for the rate card. Defaults to USD. */
  currency?: InputMaybe<SortEnumType>;
  /** Next renewal / charge date; null when there is no active subscription period. */
  currentPeriodEnd?: InputMaybe<SortEnumType>;
  /** The active billing cadence. The active charge is the rate-card amount for this cadence. */
  frequency?: InputMaybe<SortEnumType>;
  /** Amount of the most recent successful payment in minor units; null until a payment is recorded. */
  lastPaymentAmount?: InputMaybe<SortEnumType>;
  /** Date of the most recent successful payment; null until a payment is recorded. */
  lastPaymentDate?: InputMaybe<SortEnumType>;
  /** Per-tenant monthly charge in minor units. Null = monthly cadence not offered. */
  monthlyAmount?: InputMaybe<SortEnumType>;
  /**
   * This tenant's own online-payment-ceiling override in minor units (T28, superadmin-set); null
   * when none is set. When set, it wins over the system-resolved value published as
   * onlinePaymentMaxAmount — see that field's description for the full resolution order.
   */
  onlinePaymentMaxAmountOverride?: InputMaybe<SortEnumType>;
  /** Per-tenant quarterly charge in minor units. Null = quarterly cadence not offered. */
  quarterlyAmount?: InputMaybe<SortEnumType>;
  /** The subscription lifecycle status mirrored from Stripe. */
  status?: InputMaybe<SortEnumType>;
  /** Stripe customer id (cus_…); null until the tenant is linked to Stripe. */
  stripeCustomerId?: InputMaybe<SortEnumType>;
  /**
   * Stripe Subscription Schedule id (sub_sched_…) mirrored from the linked subscription;
   * null until a schedule-managed subscription is first linked. Cleared on both release paths
   * (dwight PR 14408 review, 116544): a watermark-fresh subscription webhook that carries no
   * schedule detaches it automatically, and releaseMirroredStripeSchedule clears it on
   * demand. A non-null value therefore reflects a live schedule as of the newest delivery wsapi
   * has processed. Lets the admin card deep-link the schedule in the Stripe dashboard.
   */
  stripeScheduleId?: InputMaybe<SortEnumType>;
  /** Stripe subscription id (sub_…); null until a subscription is created. */
  subscriptionId?: InputMaybe<SortEnumType>;
  /**
   * Date the linked Stripe subscription was first created, mirrored from
   * subscription.start_date; null until a subscription is linked.
   */
  subscriptionStartDate?: InputMaybe<SortEnumType>;
  /**
   * End of the subscription's contracted term, mirrored from the linked Subscription Schedule's
   * last phase end — only when the webhook payload carries the expanded Subscription Schedule
   * object. wsapi's webhook endpoint does not currently request that expansion, so this field is
   * effectively always null today; also null when the subscription has no schedule.
   */
  termEndDate?: InputMaybe<SortEnumType>;
};

/**
 * Public view returned by tenantByCompanySlug: the tenant id the portal vanity subdomain
 * resolves to, plus the normalized slug that resolved it. Deliberately minimal — the pwa needs only
 * the tenant id to bootstrap settings.tenantId from the subdomain before login, mirroring how
 * it reads the tenant from the /portal/:tenantSlug path today.
 */
export type TenantByCompanySlugView = {
  __typename?: 'TenantByCompanySlugView';
  companySlug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * One cadence a tenant is offered, priced for the Billing page: the negotiated rate-card amount, what
 * Stripe estimates the tax and total on it would be today, and whether card is offered alongside ACH
 * at that amount. Amounts are money in MINOR units (e.g. cents). One offer exists per cadence the
 * tenant's rate card carries an amount for.
 */
export type TenantCadenceOffer = {
  __typename?: 'TenantCadenceOffer';
  /**
   * The negotiated rate-card amount for this cadence in minor units, before tax. Never changed by
   * anything here — this is the stored amount, not an estimate.
   */
  baseAmount: Scalars['Long']['output'];
  /**
   * Whether a card may be used for this cadence's charge. ACH is offered at any amount; card is
   * offered at or below the tenant's effective online-payment ceiling, measured against
   * estimatedTotal — the tax-inclusive payable total, not the pre-tax base amount (D5).
   */
  cardEligible: Scalars['Boolean']['output'];
  /**
   * What Stripe estimates the tax on this cadence would be, in minor units; null when Stripe did not
   * calculate tax — no usable address, automatic tax off, a failed calculation, or an unavailable
   * preview. Null means "not calculated", never "zero"; a genuine exempt calculation reports 0.
   */
  estimatedTax?: Maybe<Scalars['Long']['output']>;
  /**
   * What this cadence would total in minor units, tax included — the same amount card eligibility is
   * decided on (D5). When no Stripe preview could be resolved this falls back to the pre-tax base
   * amount, which UNDERSTATES the real total wherever tax actually applies, so it is an estimate and
   * not a floor on what will be owed. isEstimate is always true here. estimatedTax is
   * null whenever Stripe did not calculate tax, which is WIDER than the case this falls back to the
   * base amount: a preview Stripe served but could not compute tax on still supplies this total,
   * and still reports no tax.
   */
  estimatedTotal: Scalars['Long']['output'];
  /** The cadence this offer prices. */
  frequency: BillingFrequency;
  /**
   * Always true: every amount here except the base amount is a Stripe estimate that can move before
   * an invoice is finalized.
   */
  isEstimate: Scalars['Boolean']['output'];
};

/**
 * MongoDB read-model document for a tenant's carrier configuration — the tier-0 default of the
 * hierarchical carrier setting. There is exactly one document per tenant; Id equals
 * TenantId today, but use GetDocumentId for all reads/writes so that invariant can
 * evolve without breaking call sites. Mirrors TenantRouteConfigDocument.
 */
export type TenantCarrierConfigDocument = {
  __typename?: 'TenantCarrierConfigDocument';
  carrier: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
};

export type TenantCarrierConfigPayload = {
  __typename?: 'TenantCarrierConfigPayload';
  errors?: Maybe<Array<ValidationError>>;
  tenantCarrierConfig?: Maybe<TenantCarrierConfigStateData>;
};

export type TenantCarrierConfigStateData = {
  __typename?: 'TenantCarrierConfigStateData';
  carrier: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type TenantCompanyProfileData = {
  __typename?: 'TenantCompanyProfileData';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * Starting price and collection terms of a live contract. Contract enrollment bills annually in USD;
 * the first phase supplies the starting annual amount even when later phases have different prices.
 */
export type TenantContractBillingSummary = {
  __typename?: 'TenantContractBillingSummary';
  annualAmountCents: Scalars['Int']['output'];
  collectionMethod: ContractCollectionMethod;
  currency: Scalars['String']['output'];
  daysUntilDue?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type TenantCustomerPermissionsConnection = {
  __typename?: 'TenantCustomerPermissionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TenantCustomerPermissionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TenantCustomerPermissionsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type TenantCustomerPermissionsDocument = {
  __typename?: 'TenantCustomerPermissionsDocument';
  billingAddressEditable: Scalars['Boolean']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationAddressEditable: Scalars['Boolean']['output'];
  locationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type TenantCustomerPermissionsDocumentFilterInput = {
  and?: InputMaybe<Array<TenantCustomerPermissionsDocumentFilterInput>>;
  billingAddressEditable?: InputMaybe<BooleanOperationFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationAddressEditable?: InputMaybe<BooleanOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TenantCustomerPermissionsDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type TenantCustomerPermissionsDocumentSortInput = {
  billingAddressEditable?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationAddressEditable?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type TenantCustomerPermissionsEdge = {
  __typename?: 'TenantCustomerPermissionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TenantCustomerPermissionsDocument;
};

/**
 * Adds dnsRecords to TenantEmailDomainData as a field-level resolver rather than a
 * plain property, so clients that don't select it never pay for or fail on the live SendGrid round-trip
 * — unlike every other tenantEmail* read, which is Mongo-only.
 */
export type TenantEmailDomainData = {
  __typename?: 'TenantEmailDomainData';
  boundAt: Scalars['DateTime']['output'];
  /**
   * When the pending grandfather claim stops blocking a rival tenant's bind for the same domain, or
   * null when there is no pending grandfather challenge.
   */
  challengeExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The per-tenant ownership-challenge token a grandfather bind must prove before it verifies, or
   * null on the created path (SendGrid CNAME proves ownership there) and once verified. Published as
   * the value of the challengeTxtRecord TXT record at challengeTxtHost.
   */
  challengeToken?: Maybe<Scalars['String']['output']>;
  /**
   * The DNS host to publish the ownership-challenge TXT record at (_worksuite.{domain}), or
   * null when there is no pending grandfather challenge.
   */
  challengeTxtHost?: Maybe<Scalars['String']['output']>;
  /**
   * The exact TXT record value to publish to prove ownership (worksuite-domain-verify={token}),
   * or null when there is no pending grandfather challenge.
   */
  challengeTxtRecord?: Maybe<Scalars['String']['output']>;
  /**
   * Live DNS records for this bound domain, fetched from SendGrid only when selected. Null signals
   * the lookup failed (SendGrid outage/timeout/contract error) — distinct from an empty list, which
   * means the domain genuinely has no DNS records reported. Failures are logged and degrade the field
   * to null rather than erroring the whole query.
   */
  dnsRecords?: Maybe<Array<TenantEmailDomainDnsRecord>>;
  domain: Scalars['String']['output'];
  origin: EmailDomainOrigin;
  sendGridDomainId: Scalars['String']['output'];
  status: EmailSenderVerificationStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TenantEmailDomainDnsRecord = {
  __typename?: 'TenantEmailDomainDnsRecord';
  data: Scalars['String']['output'];
  host: Scalars['String']['output'];
  type: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type TenantEmailDomainPayload = {
  __typename?: 'TenantEmailDomainPayload';
  domain?: Maybe<TenantEmailDomainData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** GraphQL data transfer record for a single tenant sender identity. */
export type TenantEmailSenderData = {
  __typename?: 'TenantEmailSenderData';
  /** Gets the timestamp when the sender was added (default when platform-default). */
  addedAt: Scalars['DateTime']['output'];
  /** Gets the CAN-SPAM physical street address (line 1). */
  addressLine1: Scalars['String']['output'];
  /** Gets the optional second address line, or None when not supplied. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /**
   * Gets a value indicating whether this sender is restricted to admin callers (Decision D).
   * Defaults to false (anyone-can-send). Filters getSelectableEmailSenders for non-admin
   * callers and is enforced again (defense in depth) at the FK-validated write paths
   * (setOrderEmailSettings / setReportScheduleEmailSettings). Never filters
   * getEffectiveEmailSender — the tenant default may be admin-only because background sends
   * are system acts, not user acts.
   */
  adminOnly: Scalars['Boolean']['output'];
  /** Gets the connection channel this sender is served through (single/domain/SMTP/M365). */
  channel: EmailSenderChannel;
  /** Gets the city. */
  city: Scalars['String']['output'];
  /** Gets the country. */
  country: Scalars['String']['output'];
  /** Gets the friendly from-name. */
  displayName: Scalars['String']['output'];
  /** Gets the from-address. */
  email: Scalars['String']['output'];
  /**
   * Gets a value indicating whether this sender is the tenant default. On the selectable and effective
   * senders it follows the approved sender selection: no sender under PLATFORM, only the pinned sender
   * under COMPANY, the tenant default flag under INHERIT.
   */
  isDefault: Scalars['Boolean']['output'];
  /** Gets a value indicating whether this sender is the synthesized platform-default fallback. */
  isPlatformDefault: Scalars['Boolean']['output'];
  /** Gets the SendGrid verified-sender / domain handle, or None before verification is requested. */
  sendGridSenderId?: Maybe<Scalars['String']['output']>;
  /** Gets the sender identifier. */
  senderId: Scalars['String']['output'];
  /** Gets the optional state or province, or None when not supplied. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the timestamp of the last change to the sender (default when platform-default). */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Gets the SendGrid verification method for a SendGrid-channel sender, or None for a sender served
   * through a non-SendGrid channel (e.g. custom SMTP). The channel — not this method —
   * discriminates the source; this stays SendGrid-specific and is absent off the SendGrid channels.
   */
  verificationMethod?: Maybe<EmailSenderVerificationMethod>;
  /** Gets the verification lifecycle status. */
  verificationStatus: EmailSenderVerificationStatus;
  /** Gets the optional postal / ZIP code, or None when not supplied. */
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * MongoDB read-model document for a single tenant sender identity. One document per (tenant,
 * sender); route all reads/writes through String) so the id format can evolve
 * without hunting call sites.
 */
export type TenantEmailSenderDocument = {
  __typename?: 'TenantEmailSenderDocument';
  /** Gets the timestamp when the sender was added. */
  addedAt: Scalars['DateTime']['output'];
  /** Gets the CAN-SPAM physical street address (line 1). */
  addressLine1: Scalars['String']['output'];
  /** Gets the optional second address line, or None when not supplied. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /**
   * Gets a value indicating whether this sender is restricted to admin callers (Decision D).
   * Defaults to false (anyone-can-send).
   */
  adminOnly: Scalars['Boolean']['output'];
  /** Gets the city. */
  city: Scalars['String']['output'];
  /** Gets the country. */
  country: Scalars['String']['output'];
  /** Gets the friendly from-name. */
  displayName: Scalars['String']['output'];
  /** Gets the from-address. */
  email: Scalars['String']['output'];
  /** Gets the MongoDB document identifier ({tenantId}-{senderId}). */
  id: Scalars['String']['output'];
  /** Gets a value indicating whether this sender is the tenant default. */
  isDefault: Scalars['Boolean']['output'];
  /** Gets the SendGrid verified-sender / domain handle, or None before verification is requested. */
  sendGridSenderId?: Maybe<Scalars['String']['output']>;
  /** Gets the sender identifier. */
  senderId: Scalars['String']['output'];
  /** Gets the optional state or province, or None when not supplied. */
  stateProvince?: Maybe<Scalars['String']['output']>;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the timestamp of the last change to the sender. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets how the sender is verified with SendGrid. */
  verificationMethod: EmailSenderVerificationMethod;
  /** Gets the verification lifecycle status. */
  verificationStatus: EmailSenderVerificationStatus;
  /** Gets the optional postal / ZIP code, or None when not supplied. */
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * MongoDB read-model document for a single tenant sender identity. One document per (tenant,
 * sender); route all reads/writes through String) so the id format can evolve
 * without hunting call sites.
 */
export type TenantEmailSenderDocumentFilterInput = {
  /** Gets the timestamp when the sender was added. */
  addedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the CAN-SPAM physical street address (line 1). */
  addressLine1?: InputMaybe<StringOperationFilterInput>;
  /** Gets the optional second address line, or None when not supplied. */
  addressLine2?: InputMaybe<OptionOfStringFilterInput>;
  /**
   * Gets a value indicating whether this sender is restricted to admin callers (Decision D).
   * Defaults to false (anyone-can-send).
   */
  adminOnly?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TenantEmailSenderDocumentFilterInput>>;
  /** Gets the city. */
  city?: InputMaybe<StringOperationFilterInput>;
  /** Gets the country. */
  country?: InputMaybe<StringOperationFilterInput>;
  /** Gets the friendly from-name. */
  displayName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the from-address. */
  email?: InputMaybe<StringOperationFilterInput>;
  /** Gets the MongoDB document identifier ({tenantId}-{senderId}). */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Gets a value indicating whether this sender is the tenant default. */
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<TenantEmailSenderDocumentFilterInput>>;
  /** Gets the SendGrid verified-sender / domain handle, or None before verification is requested. */
  sendGridSenderId?: InputMaybe<OptionOfStringFilterInput>;
  /** Gets the sender identifier. */
  senderId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the optional state or province, or None when not supplied. */
  stateProvince?: InputMaybe<OptionOfStringFilterInput>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the timestamp of the last change to the sender. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets how the sender is verified with SendGrid. */
  verificationMethod?: InputMaybe<EmailSenderVerificationMethodOperationFilterInput>;
  /** Gets the verification lifecycle status. */
  verificationStatus?: InputMaybe<EmailSenderVerificationStatusOperationFilterInput>;
  /** Gets the optional postal / ZIP code, or None when not supplied. */
  zip?: InputMaybe<OptionOfStringFilterInput>;
};

/**
 * MongoDB read-model document for a single tenant sender identity. One document per (tenant,
 * sender); route all reads/writes through String) so the id format can evolve
 * without hunting call sites.
 */
export type TenantEmailSenderDocumentSortInput = {
  /** Gets the timestamp when the sender was added. */
  addedAt?: InputMaybe<SortEnumType>;
  /** Gets the CAN-SPAM physical street address (line 1). */
  addressLine1?: InputMaybe<SortEnumType>;
  /** Gets the optional second address line, or None when not supplied. */
  addressLine2?: InputMaybe<SortEnumType>;
  /**
   * Gets a value indicating whether this sender is restricted to admin callers (Decision D).
   * Defaults to false (anyone-can-send).
   */
  adminOnly?: InputMaybe<SortEnumType>;
  /** Gets the city. */
  city?: InputMaybe<SortEnumType>;
  /** Gets the country. */
  country?: InputMaybe<SortEnumType>;
  /** Gets the friendly from-name. */
  displayName?: InputMaybe<SortEnumType>;
  /** Gets the from-address. */
  email?: InputMaybe<SortEnumType>;
  /** Gets the MongoDB document identifier ({tenantId}-{senderId}). */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether this sender is the tenant default. */
  isDefault?: InputMaybe<SortEnumType>;
  /** Gets the SendGrid verified-sender / domain handle, or None before verification is requested. */
  sendGridSenderId?: InputMaybe<SortEnumType>;
  /** Gets the sender identifier. */
  senderId?: InputMaybe<SortEnumType>;
  /** Gets the optional state or province, or None when not supplied. */
  stateProvince?: InputMaybe<SortEnumType>;
  /** Gets the tenant identifier. */
  tenantId?: InputMaybe<SortEnumType>;
  /** Gets the timestamp of the last change to the sender. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Gets how the sender is verified with SendGrid. */
  verificationMethod?: InputMaybe<SortEnumType>;
  /** Gets the verification lifecycle status. */
  verificationStatus?: InputMaybe<SortEnumType>;
  /** Gets the optional postal / ZIP code, or None when not supplied. */
  zip?: InputMaybe<SortEnumType>;
};

/** Payload returned from tenant email-sender mutations. */
export type TenantEmailSenderPayload = {
  __typename?: 'TenantEmailSenderPayload';
  errors?: Maybe<Array<ValidationError>>;
  sender?: Maybe<TenantEmailSenderData>;
};

/**
 * A tenant's sender selection read back in two parts: what was approved (the configured selection, with its
 * revision and receipt) and what customer email is sent from right now (the effective route, with its reply
 * routing and readiness). The two differ whenever the approved company sender is not verified yet.
 */
export type TenantEmailSenderSelectionData = {
  __typename?: 'TenantEmailSenderSelectionData';
  /** Gets the approved selection: kind, intended use, the pinned company sender, revision and receipt. */
  configured: EmailSenderSelectionData;
  /** Gets the route customer email takes now: the From identity, reply routing, intended use and readiness. */
  effective: EffectiveEmailSenderRouteData;
};

/** Payload returned from selectTenantEmailSender: the selection read back after the write, or the refusal. */
export type TenantEmailSenderSelectionPayload = {
  __typename?: 'TenantEmailSenderSelectionPayload';
  errors?: Maybe<Array<ValidationError>>;
  selection?: Maybe<TenantEmailSenderSelectionData>;
};

/** A connection to a list of items. */
export type TenantEmailSendersConnection = {
  __typename?: 'TenantEmailSendersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TenantEmailSendersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TenantEmailSenderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TenantEmailSendersEdge = {
  __typename?: 'TenantEmailSendersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TenantEmailSenderDocument;
};

export type TenantFlagOwnSettingInput = {
  /** The settings JSON adminTenantFeatures returned, unchanged: it is compared exactly. */
  config: Scalars['String']['input'];
  /** The mode adminTenantFeatures returned. UNKNOWN is refused. */
  mode: TenantFlagSettingMode;
};

export enum TenantFlagSettingAction {
  Clear = 'CLEAR',
  Off = 'OFF',
  On = 'ON',
  SettingsOnly = 'SETTINGS_ONLY',
  Unknown = 'UNKNOWN'
}

export type TenantFlagSettingDataInput = {
  action: TenantFlagSettingAction;
  /** The tenant's settings JSON, replacing its current settings in full. Omit to keep the tenant's current settings; send {} to clear. Not read for CLEAR. */
  config?: InputMaybe<Scalars['String']['input']>;
  /** The tenant's own setting on this flag as adminTenantFeatures returned it, or null when it returned none; CLEAR sends the setting it clears. The save is refused with TENANT_FEATURES_CONFLICT, and nothing is written, when the tenant's setting on the flag is no longer this one. */
  expectedOwnSetting?: InputMaybe<TenantFlagOwnSettingInput>;
  name: FeatureFlagName;
};

export enum TenantFlagSettingMode {
  Off = 'OFF',
  On = 'ON',
  SettingsOnly = 'SETTINGS_ONLY',
  Unknown = 'UNKNOWN'
}

/** GraphQL-output projection of a single tenant grade → custom label pairing. */
export type TenantGradeLabelData = {
  __typename?: 'TenantGradeLabelData';
  grade: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/**
 * GraphQL projection of a tenant's live contract record's installation-fee lane, surfaced as
 * TenantBillingData.installFee for the grower's Billing page. See
 * TenantBillingData.InstallFee for when this is null.
 */
export type TenantInstallFee = {
  __typename?: 'TenantInstallFee';
  amountCents: Scalars['Int']['output'];
  amountPaidCents?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  status: ContractFeeStatus;
  /**
   * The fee invoice's amount before tax, in minor units; null until the fee reaches Sent, and null
   * when Stripe could not be read. Read live from the fee's own Stripe invoice — the stored
   * amountCents is the negotiated base and never moves, so it is not this number once tax
   * exists.
   */
  subtotal?: Maybe<Scalars['Long']['output']>;
  /**
   * The tax Stripe calculated on the fee invoice, in minor units; null until the fee reaches Sent,
   * and null when Stripe could not be read. Zero is a real answer — an exempt customer's fee invoice
   * is taxed at zero.
   */
  tax?: Maybe<Scalars['Long']['output']>;
  /**
   * The fee invoice's total including tax, in minor units; null until the fee reaches Sent, and null
   * when Stripe could not be read. This is what the grower is actually asked to pay.
   */
  total?: Maybe<Scalars['Long']['output']>;
};

export type TenantIntegrationData = {
  __typename?: 'TenantIntegrationData';
  accessTokenExpiration: Scalars['DateTime']['output'];
  /**
   * Which Merge.dev product category this integration belongs to (accounting vs CRM). Lets the pwa
   * route a Merge integration to the right detail UI — the source field reports MERGE_DEV for
   * both. Unknown for non-Merge integrations (native QuickBooks, MySQL).
   */
  category: IntegrationCategory;
  created: Scalars['DateTime']['output'];
  integrationId: Scalars['String']['output'];
  /**
   * Merge.dev display name of the connected accounting platform (e.g. "QuickBooks Online").
   * Null carries the same semantics as MergeDevIntegrationSlug.
   */
  mergeDevIntegrationName?: Maybe<Scalars['String']['output']>;
  /**
   * Merge.dev slug of the connected accounting platform (e.g. "quickbooks-online", "xero").
   * Null for non-Merge.dev integrations, and for Merge.dev links completed before platform
   * identity was captured — all such legacy links are QuickBooks Online, the only connector
   * enabled until then; consumers may fall back to "QuickBooks Online" when null.
   */
  mergeDevIntegrationSlug?: Maybe<Scalars['String']['output']>;
  realmId: Scalars['String']['output'];
  refreshTokenExpiration: Scalars['DateTime']['output'];
  source: IntegrationSource;
};

/** MongoDB read model document for tenant integration configurations (QuickBooks, MySQL, Merge.dev). */
export type TenantIntegrationDocument = {
  __typename?: 'TenantIntegrationDocument';
  accessTokenExpiresAt: Scalars['DateTime']['output'];
  /**
   * Which Merge.dev product category this integration belongs to (accounting vs CRM). Lets the pwa
   * route a Merge integration to the right detail UI — the source field reports MERGE_DEV for
   * both. Unknown for non-Merge integrations (native QuickBooks, MySQL).
   */
  category: IntegrationCategory;
  integrationId: Scalars['String']['output'];
  mergeDevBaseUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Merge.dev display name of the connected accounting platform (e.g. "QuickBooks Online").
   * Null carries the same legacy-QuickBooks-Online semantics as MergeDevIntegrationSlug.
   */
  mergeDevIntegrationName?: Maybe<Scalars['String']['output']>;
  /**
   * Merge.dev slug of the connected accounting platform (e.g. "quickbooks-online", "xero").
   * Null means the link was completed before platform identity was captured — all such legacy
   * links are QuickBooks Online, the only connector enabled until then; consumers may fall back
   * to "QuickBooks Online" when null.
   */
  mergeDevIntegrationSlug?: Maybe<Scalars['String']['output']>;
  mergeDevOrderExportTriggerStatus?: Maybe<Scalars['Int']['output']>;
  mySqlDatabase?: Maybe<Scalars['String']['output']>;
  mySqlEndpoint?: Maybe<Scalars['String']['output']>;
  mySqlUsername?: Maybe<Scalars['String']['output']>;
  orderEaseBaseUrl?: Maybe<Scalars['String']['output']>;
  /** When the grower most recently completed the OrderEase connect grant. */
  orderEaseConnectedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether the connected Merge.dev platform supports outbound invoice creation (POST Invoices)
   * through Merge. Inbound-only platforms (QuickBooks Desktop, Sage Business Cloud Accounting,
   * Wave, Dynamics 365 Finance & Operations) are false; every other slug and null (legacy
   * QuickBooks Online) is true.
   */
  outboundInvoiceExportSupported: Scalars['Boolean']['output'];
  realmId?: Maybe<Scalars['String']['output']>;
  refreshTokenExpiresAt: Scalars['DateTime']['output'];
  source: IntegrationSource;
  tenantId: Scalars['String']['output'];
};

/** MongoDB read model document for tenant integration configurations (QuickBooks, MySQL, Merge.dev). */
export type TenantIntegrationDocumentFilterInput = {
  accessTokenExpiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<TenantIntegrationDocumentFilterInput>>;
  /**
   * Which Merge.dev product category this integration belongs to (accounting vs CRM). Lets the pwa
   * route a Merge integration to the right detail UI — the source field reports MERGE_DEV for
   * both. Unknown for non-Merge integrations (native QuickBooks, MySQL).
   */
  category?: InputMaybe<IntegrationCategoryOperationFilterInput>;
  integrationId?: InputMaybe<StringOperationFilterInput>;
  mergeDevBaseUrl?: InputMaybe<StringOperationFilterInput>;
  /**
   * Merge.dev display name of the connected accounting platform (e.g. "QuickBooks Online").
   * Null carries the same legacy-QuickBooks-Online semantics as MergeDevIntegrationSlug.
   */
  mergeDevIntegrationName?: InputMaybe<StringOperationFilterInput>;
  /**
   * Merge.dev slug of the connected accounting platform (e.g. "quickbooks-online", "xero").
   * Null means the link was completed before platform identity was captured — all such legacy
   * links are QuickBooks Online, the only connector enabled until then; consumers may fall back
   * to "QuickBooks Online" when null.
   */
  mergeDevIntegrationSlug?: InputMaybe<StringOperationFilterInput>;
  mergeDevOrderExportTriggerStatus?: InputMaybe<IntOperationFilterInput>;
  mySqlDatabase?: InputMaybe<StringOperationFilterInput>;
  mySqlEndpoint?: InputMaybe<StringOperationFilterInput>;
  mySqlUsername?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TenantIntegrationDocumentFilterInput>>;
  orderEaseBaseUrl?: InputMaybe<StringOperationFilterInput>;
  /** When the grower most recently completed the OrderEase connect grant. */
  orderEaseConnectedAt?: InputMaybe<DateTimeOperationFilterInput>;
  realmId?: InputMaybe<StringOperationFilterInput>;
  refreshTokenExpiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  source?: InputMaybe<IntegrationSourceOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read model document for tenant integration configurations (QuickBooks, MySQL, Merge.dev). */
export type TenantIntegrationDocumentSortInput = {
  accessTokenExpiresAt?: InputMaybe<SortEnumType>;
  /**
   * Which Merge.dev product category this integration belongs to (accounting vs CRM). Lets the pwa
   * route a Merge integration to the right detail UI — the source field reports MERGE_DEV for
   * both. Unknown for non-Merge integrations (native QuickBooks, MySQL).
   */
  category?: InputMaybe<SortEnumType>;
  integrationId?: InputMaybe<SortEnumType>;
  mergeDevBaseUrl?: InputMaybe<SortEnumType>;
  /**
   * Merge.dev display name of the connected accounting platform (e.g. "QuickBooks Online").
   * Null carries the same legacy-QuickBooks-Online semantics as MergeDevIntegrationSlug.
   */
  mergeDevIntegrationName?: InputMaybe<SortEnumType>;
  /**
   * Merge.dev slug of the connected accounting platform (e.g. "quickbooks-online", "xero").
   * Null means the link was completed before platform identity was captured — all such legacy
   * links are QuickBooks Online, the only connector enabled until then; consumers may fall back
   * to "QuickBooks Online" when null.
   */
  mergeDevIntegrationSlug?: InputMaybe<SortEnumType>;
  mergeDevOrderExportTriggerStatus?: InputMaybe<SortEnumType>;
  mySqlDatabase?: InputMaybe<SortEnumType>;
  mySqlEndpoint?: InputMaybe<SortEnumType>;
  mySqlUsername?: InputMaybe<SortEnumType>;
  orderEaseBaseUrl?: InputMaybe<SortEnumType>;
  /** When the grower most recently completed the OrderEase connect grant. */
  orderEaseConnectedAt?: InputMaybe<SortEnumType>;
  realmId?: InputMaybe<SortEnumType>;
  refreshTokenExpiresAt?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type TenantIntegrationTokenDocument = {
  __typename?: 'TenantIntegrationTokenDocument';
  accessTokenExpiration: Scalars['DateTime']['output'];
  /** Composite ID: {tenantId}-{integrationId} */
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  refreshTokenExpiration: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
};

export type TenantIntegrationTokenDocumentFilterInput = {
  accessTokenExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<TenantIntegrationTokenDocumentFilterInput>>;
  /** Composite ID: {tenantId}-{integrationId} */
  id?: InputMaybe<StringOperationFilterInput>;
  integrationId?: InputMaybe<StringOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TenantIntegrationTokenDocumentFilterInput>>;
  refreshTokenExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type TenantIntegrationTokenDocumentSortInput = {
  accessTokenExpiration?: InputMaybe<SortEnumType>;
  /** Composite ID: {tenantId}-{integrationId} */
  id?: InputMaybe<SortEnumType>;
  integrationId?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  refreshTokenExpiration?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type TenantIntegrationTokensPayload = {
  __typename?: 'TenantIntegrationTokensPayload';
  errors?: Maybe<Array<ValidationError>>;
  state?: Maybe<TenantIntegrationTokensStateData>;
};

export type TenantIntegrationTokensStateData = {
  __typename?: 'TenantIntegrationTokensStateData';
  accessTokenExpiration: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  refreshTokenExpiration: Scalars['DateTime']['output'];
};

/**
 * One platform-billing invoice as the tenant and admin Billing surfaces show it — a finalized Stripe
 * invoice, or a preview of one Stripe has not raised yet. Amounts are money in MINOR units (e.g.
 * cents). Read live from Stripe with the platform key; nothing here is stored.
 */
export type TenantInvoiceSummary = {
  __typename?: 'TenantInvoiceSummary';
  /** What is still owed on the invoice, in minor units. */
  amountDue: Scalars['Long']['output'];
  /** What has been paid against the invoice, in minor units. */
  amountPaid: Scalars['Long']['output'];
  /** Stripe's hosted invoice page; null on a preview, which has no hosted page. */
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  /** The Stripe invoice id (in_…); null on a preview, which is not a Stripe object. */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /**
   * True when this is a Stripe PREVIEW of a charge that has not been raised yet, so every amount can
   * still move before the invoice is finalized. False on a real finalized invoice.
   */
  isEstimate: Scalars['Boolean']['output'];
  /** The customer-facing invoice number; null on a preview and until Stripe assigns one. */
  number?: Maybe<Scalars['String']['output']>;
  /** End of the billing period the invoice covers; null when Stripe reported none. */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Start of the billing period the invoice covers; null when Stripe reported none. */
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  /** The invoice total before tax, in minor units. */
  subtotal: Scalars['Long']['output'];
  /**
   * The tax on the invoice in minor units — the SUM of every total_taxes entry, because one
   * invoice can carry several tax lines (state plus local, say). Zero when the invoice carries none.
   */
  tax: Scalars['Long']['output'];
  /** What Stripe's automatic tax reports about THIS invoice's own calculation. */
  taxStatus: TenantAutomaticTaxStatus;
  /** The invoice total including tax, in minor units. */
  total: Scalars['Long']['output'];
};

/** The answer to completeTenantModuleReset: every post-reset step of the module has run. */
export type TenantModuleResetCompletion = {
  __typename?: 'TenantModuleResetCompletion';
  /** Always true on success; a failure is a GraphQL error instead. */
  completed: Scalars['Boolean']['output'];
};

/**
 * The answer to prepareTenantModuleReset: whether the module's data may now be deleted. When a guard
 * refuses, nothing was changed and blockedReason says why; when ready, every pre-reset step has run.
 */
export type TenantModuleResetPreparation = {
  __typename?: 'TenantModuleResetPreparation';
  /** Why the reset is refused, one sentence per refusing guard; null when ready. */
  blockedReason?: Maybe<Scalars['String']['output']>;
  /** True when every guard held and every pre-reset step ran; the worker may delete the module's data. */
  ready: Scalars['Boolean']['output'];
};

/**
 * A tenant's multi-factor requirement for one application — the Company Settings-facing shape of the
 * stored policy.
 */
export type TenantMultiFactorPolicy = {
  __typename?: 'TenantMultiFactorPolicy';
  /**
   * The FusionAuth application this requirement governs — the second half of the (tenant, application)
   * key, reported so a client never has to infer which surface it asked about.
   */
  applicationId: Scalars['String']['output'];
  /**
   * The instant the requirement was last turned on — the anchor the grace window counts from. Turning
   * it back on after being off moves this forward; saving again while already on does not.
   * null while the requirement has never been enabled.
   */
  enabledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The computed instant every unenrolled user of this application becomes blocked:
   * enabledAt plus graceWindowDays. null whenever enabledAt is null.
   */
  graceDeadline?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Days of advisory notice before the requirement becomes blocking. null means blocking takes
   * effect immediately once the requirement is on.
   */
  graceWindowDays?: Maybe<Scalars['Int']['output']>;
  /** Whether unenrolled users of this application are pressed to enrol. */
  requireMfa: Scalars['Boolean']['output'];
};

/** Reports a tenant's multi-factor requirement, or why it could not be read or written. */
export type TenantMultiFactorPolicyPayload = {
  __typename?: 'TenantMultiFactorPolicyPayload';
  errors?: Maybe<Array<ValidationError>>;
  policy?: Maybe<TenantMultiFactorPolicy>;
};

export type TenantOnboardingUploadData = {
  __typename?: 'TenantOnboardingUploadData';
  blobName: Scalars['String']['output'];
  contentSha256?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  reviewAreas: Array<OnboardingReviewArea>;
  sizeBytes: Scalars['Long']['output'];
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceVersion?: Maybe<Scalars['Int']['output']>;
  uploadedBy: Scalars['String']['output'];
};

export type TenantOnboardingUploadDataFilterInput = {
  and?: InputMaybe<Array<TenantOnboardingUploadDataFilterInput>>;
  blobName?: InputMaybe<StringOperationFilterInput>;
  contentSha256?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  importedAt?: InputMaybe<DateTimeOperationFilterInput>;
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TenantOnboardingUploadDataFilterInput>>;
  reviewAreas?: InputMaybe<ListOnboardingReviewAreaOperationFilterInput>;
  sizeBytes?: InputMaybe<LongOperationFilterInput>;
  sourceId?: InputMaybe<StringOperationFilterInput>;
  sourceVersion?: InputMaybe<IntOperationFilterInput>;
  uploadedBy?: InputMaybe<StringOperationFilterInput>;
};

export type TenantOverrideDataInput = {
  config: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  /** Whether the override only carries the tenant's settings, while on/off follows its products, its trial and the default. Omit to keep the tenant's stored value (false when it has none). */
  settingsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};

/** MongoDB sub-document representing a tenant-specific feature flag override. */
export type TenantOverrideDocument = {
  __typename?: 'TenantOverrideDocument';
  config: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  /**
   * True when the override only carries the tenant's settings: on/off then follows its products, its trial and
   * everyone's default, and enabled does not decide it. False for an override written before the field existed.
   */
  settingsOnly: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

export type TenantPayload = {
  __typename?: 'TenantPayload';
  errors?: Maybe<Array<ValidationError>>;
  tenant?: Maybe<TenantStateData>;
};

/** GraphQL-facing snapshot of a tenant's pricing page state after a successful mutation. */
export type TenantPricingPageData = {
  __typename?: 'TenantPricingPageData';
  content: Scalars['String']['output'];
  exists: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB read model for a tenant's personalized pricing page.
 * One document per tenant. Projected from the TenantPricingPage-{TenantId} stream.
 */
export type TenantPricingPageDocument = {
  __typename?: 'TenantPricingPageDocument';
  /** Full HTML/text content shown to growers on the pricing page. */
  content: Scalars['String']['output'];
  /** Mongo id; also the tenant id (one document per tenant). */
  id: Scalars['String']['output'];
  /** The tenant this pricing page belongs to. Equal to Id. */
  tenantId: Scalars['String']['output'];
  /** Timestamp of the last upsert. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Mutation payload for TenantPricingPage upsert/delete. */
export type TenantPricingPagePayload = {
  __typename?: 'TenantPricingPagePayload';
  data?: Maybe<TenantPricingPageData>;
  errors?: Maybe<Array<ValidationError>>;
};

/** The documents of one read-model collection an explicit reset selection deletes. */
export type TenantResetCollectionDocuments = {
  __typename?: 'TenantResetCollectionDocuments';
  /** The collection, e.g. Orders. */
  collectionName: Scalars['String']['output'];
  /** The _ids of the documents to delete, ordinal-sorted. */
  documentIds: Array<Scalars['String']['output']>;
};

/**
 * What resetting one module of a tenant deletes, as returned by tenantResetManifest. The reset worker
 * deletes, for the tenant: every stream of each streamEntityNames entry
 * ({EntityName}-{tenantId} and {EntityName}-{tenantId}-…), every stream matching a
 * streamKeyPatterns entry, and the tenant's documents in each collectionNames entry.
 */
export type TenantResetManifest = {
  __typename?: 'TenantResetManifest';
  /** Read-model collections whose tenant documents are deleted, ordinal-sorted. */
  collectionNames: Array<Scalars['String']['output']>;
  /** The first created day the selection was limited to, inclusive; null for no lower bound. */
  createdFrom?: Maybe<Scalars['LocalDate']['output']>;
  /** The last created day the selection was limited to, inclusive; null for no upper bound. */
  createdTo?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * The read-model documents to delete, by collection name (ordinal-sorted) then _id (ordinal-sorted);
   * empty unless explicitSelection. A collection with nothing selected is listed with no ids.
   */
  documentIds: Array<TenantResetCollectionDocuments>;
  /**
   * Whether this reset removes exactly the records listed in streamNames and
   * documentIds rather than whole entity names and collections. False for every owner and ALL.
   */
  explicitSelection: Scalars['Boolean']['output'];
  /** The module key the manifest is for, e.g. PRODUCE. */
  module: Scalars['String']['output'];
  /** How many orders the selection removes, credit orders included; 0 unless explicitSelection. */
  selectedOrderCount: Scalars['Int']['output'];
  /** Entity names all of whose tenant streams are deleted, ordinal-sorted. */
  streamEntityNames: Array<Scalars['String']['output']>;
  /**
   * Stream key templates whose matching tenant streams are deleted, ordinal-sorted, e.g.
   * InventoryItem-{tenantId}-*-*-0. Segments are separated by a hyphen; {tenantId} is the tenant,
   * * any one segment, !x any one segment except x, anything else that literal segment;
   * the segment count must match.
   */
  streamKeyPatterns: Array<Scalars['String']['output']>;
  /**
   * Full names of the streams to hard-delete, e.g. Order-{tenantId}-{orderId}, ordinal-sorted; empty
   * unless explicitSelection.
   */
  streamNames: Array<Scalars['String']['output']>;
};

/** A module an operator may reset for a tenant, as listed by tenantResetModules. */
export type TenantResetModule = {
  __typename?: 'TenantResetModule';
  /** Name shown to the operator. */
  displayName: Scalars['String']['output'];
  /** The key to pass to tenantResetManifest and the reset worker, e.g. PRODUCE or ALL. */
  key: Scalars['String']['output'];
};

/**
 * MongoDB read-model document for a tenant's route configuration — the tier-0 default of the
 * hierarchical route setting. There is exactly one document per tenant; Id equals
 * TenantId today, but use GetDocumentId for all reads/writes so that invariant can
 * evolve without breaking call sites.
 */
export type TenantRouteConfigDocument = {
  __typename?: 'TenantRouteConfigDocument';
  id: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  route: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type TenantRouteConfigPayload = {
  __typename?: 'TenantRouteConfigPayload';
  errors?: Maybe<Array<ValidationError>>;
  tenantRouteConfig?: Maybe<TenantRouteConfigStateData>;
};

export type TenantRouteConfigStateData = {
  __typename?: 'TenantRouteConfigStateData';
  route: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * GraphQL view of a tenant's custom SMTP connection. Carries the configuration and verification status
 * but NEVER the password (encrypted or otherwise) — the password lives only in the aggregate and the
 * non-exposed read model, read solely by the SMTP sender worker.
 */
export type TenantSmtpConnectionData = {
  __typename?: 'TenantSmtpConnectionData';
  /** Gets the configured from-address list. */
  addresses: Array<SmtpSenderAddressData>;
  /** Gets the from-mode governing which addresses are usable. */
  fromMode: SmtpFromMode;
  /** Gets the SMTP server host. */
  host: Scalars['String']['output'];
  /** Gets a sanitized (non-secret) description of the last verification failure, or None. */
  lastError?: Maybe<Scalars['String']['output']>;
  /** Gets the timestamp of the last successful verification, or None if never verified. */
  lastVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the SMTP server port. */
  port: Scalars['Int']['output'];
  /** Gets the verification status. */
  status: SmtpConnectionStatus;
  /** Gets the tenant identifier. */
  tenantId: Scalars['String']['output'];
  /** Gets the timestamp of the last change to the connection. */
  updatedAt: Scalars['DateTime']['output'];
  /** Gets the SMTP AUTH username. */
  username: Scalars['String']['output'];
};

/** Payload returned from tenant SMTP connection mutations (never carries the password). */
export type TenantSmtpConnectionPayload = {
  __typename?: 'TenantSmtpConnectionPayload';
  connection?: Maybe<TenantSmtpConnectionData>;
  errors?: Maybe<Array<ValidationError>>;
};

export type TenantStateData = {
  __typename?: 'TenantStateData';
  /** True when this business has allocated an order in the last 60 days. Always false for customer-portal callers. */
  allocatesOrders: Scalars['Boolean']['output'];
  allowOrderBillingAddressEdit: Scalars['Boolean']['output'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['output'];
  /**
   * Grades (1 to 5) that Bulk Allocate and portal auto-allocate skip, in ascending order. An empty
   * list means automatic allocation uses every grade. Hand allocation can still use an excluded grade.
   */
  autoAllocateExcludedGrades: Array<Scalars['Int']['output']>;
  /** Company-wide Availability quantity basis. Null until configured: each screen keeps today's start. SHIPPING_UOM uses each item's own shipping unit and conversion. */
  availabilityQuantityBasis?: Maybe<AvailabilityQuantityBasis>;
  /** Company-wide Availability entry method. Null until configured, which reads as KEYPAD. */
  availabilityQuantityEntry?: Maybe<AvailabilityQuantityEntry>;
  /**
   * Per-tenant platform-billing state (Stripe linkage, per-tenant rate card, active cadence,
   * subscription status, and most-recent payment). Always present; defaults to an empty
   * (unconfigured) billing state for tenants with no billing events in their stream. This is the
   * surface the worksuite-pwa Billing page reads.
   */
  billing: TenantBillingData;
  /** Company preference to break stock out by customer item. Defaults to false. */
  breakStockOutByCustomerItem: Scalars['Boolean']['output'];
  /**
   * Tenant-level business time zone (decision D's zone source), as a validated IANA id. null
   * means the tenant has never configured this — NEVER read as UTC. Set with
   * updateBusinessTimeZone.
   */
  businessTimeZone?: Maybe<Scalars['String']['output']>;
  /** The tenant's company profile (remit-to). Always present: name falls back to the tenant name when no profile is set; other fields are null until set. */
  companyProfile: TenantCompanyProfileData;
  /**
   * The modules and add-ons this tenant contracted for (e.g. "FULFILL, PRODUCE, Customer Portal"). Once the
   * tenant's WorkSuite products are set it is their names as the product catalog has them now: the products
   * every tenant has first, then catalog order, so it follows a product rename without the tenant being saved.
   * Before that it is whatever staff typed, and empty means not typed. Free text, never parsed into a structured
   * list — the home card, provisioning and Learning paths only print it and test it case-insensitively for
   * module names. Set the products with setAdminTenantWorkSuiteProducts, the typed text with
   * patchBatchAdminTenant.
   */
  contractedProducts: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  /** The tenant-level default freight charge type. */
  defaultFreightChargeType?: Maybe<FreightChargeType>;
  /** The tenant-level default freight charge value. */
  defaultFreightChargeValue?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The tenant default minimum freight charge, applied once per order. A customer override wins
   * over it. Null means no minimum is configured. Set with updateDefaultMinimumFreightCharge.
   */
  defaultMinimumFreightCharge?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Per-tenant default weeks-of-supply applied by the Restock dashboard's
   * restockDailyDemand query when no explicit override is supplied.
   * Default: TenantState.DefaultWeeksOfSupplyDefault.
   */
  defaultWeeksOfSupply: Scalars['Decimal']['output'];
  /**
   * Per-document-type render mode overrides the tenant has explicitly set (invoice/confirmation,
   * acknowledgement, credit). Only configured doc types appear; a doc type absent here resolves to
   * the RenderMode.Legacy default. Read effectiveDocumentRenderModes for the resolved
   * value across every doc type.
   */
  documentRenderModes: Array<DocumentRenderModeData>;
  /** Effective render mode for every order document type (invoice/confirmation, acknowledgement, credit): the tenant's configured value, or Legacy when unset. Read by the render-time email workers to choose the legacy QuestPDF generator vs the report engine (Parallel renders both). */
  effectiveDocumentRenderModes: Array<DocumentRenderModeData>;
  /** Order acknowledgement report id the PWA should render: the tenant's configured value, or the seeded Order Acknowledgement template when unconfigured. */
  effectiveOrderAcknowledgementReportId: Scalars['String']['output'];
  /** Whether order/confirmation/acknowledgement emails are enabled for the tenant: the tenant's configured value, or false (opt-in) when unconfigured. */
  effectiveOrderEmailsEnabled: Scalars['Boolean']['output'];
  /** Order invoice report id the PWA should render: the tenant's configured value, or the seeded Professional Invoice template when unconfigured. */
  effectiveOrderInvoiceReportId: Scalars['String']['output'];
  /** Order Pro Forma report id the PWA should render: the tenant's configured value, or the seeded Pro Forma Invoice template when unconfigured. */
  effectiveOrderProFormaReportId: Scalars['String']['output'];
  /** Order pull slip ("pick slip") report id the PWA should render: the tenant's configured value, or the seeded Pull Slip template when unconfigured. */
  effectiveOrderPullSlipReportId: Scalars['String']['output'];
  /** Purchase Order report id the PWA should render: the tenant's configured value, or the seeded Purchase Order template when unconfigured. */
  effectivePurchaseOrderReportId: Scalars['String']['output'];
  /**
   * Whether the invoice email goes out when each invoice is issued, in either
   * invoicingMode: issued by staff while MANUAL, or by the AutoInvoice worker while
   * AUTOMATIC. Defaults to false. Set with updateInvoicingSettings.
   */
  emailInvoiceOnIssue: Scalars['Boolean']['output'];
  /** True when this company sees fernie's suggestions right now: the JevDecisions feature flag is on for the tenant and fernieSuggestionsOn is true. Every suggestion surface reads this one value. */
  fernieSuggestionsEnabled: Scalars['Boolean']['output'];
  /** Whether fernie's suggestions show for this company. On by default. Off hides every fernie suggestion for everyone at the company. Set with updateFernieSuggestionsOn. */
  fernieSuggestionsOn: Scalars['Boolean']['output'];
  finalCreditEnabled: Scalars['Boolean']['output'];
  /**
   * Per-tenant custom display labels for inventory grades 1–5 (display layer only — grade values
   * stay int 1–5). Only grades the tenant has labelled appear here; an empty list means no custom
   * labels are configured and consumers fall back to the numeric grade client-side.
   */
  gradeLabels: Array<TenantGradeLabelData>;
  integrations: Array<TenantIntegrationData>;
  /**
   * Tenant-level invoicing mode (Ruling R7): MANUAL (staff issues invoices via
   * markOrdersForInvoicing) or AUTOMATIC (the wsapi-services AutoInvoice sweep
   * worker issues one invoice per Shipped order). Defaults to MANUAL for tenants with no
   * TenantInvoicingSettingsUpdated event in their stream — today's behavior. Set with
   * updateInvoicingSettings.
   */
  invoicingMode: InvoicingMode;
  /** True when the tenant is on a self-serve trial — i.e. a trialExpirationDate is present. False for real (non-trial) tenants. */
  isTrial: Scalars['Boolean']['output'];
  /**
   * The tenant's training status, derived from its office users' in-app learning: NOT_STARTED while no
   * office user has any progress, IN_PROGRESS once someone has, and COMPLETE once every active office user
   * has completed every learning path they see. Read this in place of onboardingTraining, which is only
   * what staff last set by hand. Always UNKNOWN for a customer-portal caller.
   */
  learningTrainingStatus: OnboardingTrainingStatus;
  /**
   * The tenant's load paperwork settings for the Logistics load screen: one Report aggregate ID
   * binding per load paperwork kind (manifest, pull sheet, delivery ticket, invoice), plus the
   * policy for which kinds print for a regular load and for a drop-ship load. New concept — no
   * historical value, no backfill. Set with setTenantLoadPaperworkBinding and
   * setTenantLoadPaperworkPolicy.
   */
  loadPaperwork: LoadPaperworkData;
  maxDiscountPercentage: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  /** True while onboarding help mode is on: a help end date is set, today is on or before that day, and onboarding setup is not LIVE. Always false for a customer-portal caller. */
  onboardingHelpOn: Scalars['Boolean']['output'];
  /**
   * The last day of onboarding help mode, as staff picked it (local midnight with its offset).
   * Null means help mode was never turned on or was cleared. Read onboardingHelpOn for
   * whether help is on right now. Set and cleared with patchBatchAdminTenant. Always null
   * for a customer-portal caller.
   */
  onboardingHelpUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   * How far the tenant has progressed through onboarding data setup.
   * UNKNOWN means unset: what every tenant created before new tenants started at
   * NOT_STARTED reads, or one staff set back to UNKNOWN. A NON-NULL enum on
   * purpose: the enum's own UNKNOWN member
   * already expresses "unset", so a nullable field would give clients two spellings of the same
   * state. Set with patchBatchAdminTenant.
   */
  onboardingSetup: OnboardingSetupStage;
  /**
   * How far the tenant has progressed through onboarding training, as staff last set it by hand.
   * Independent of the data-setup stage; same non-null, UNKNOWN-means-unset contract.
   * learningTrainingStatus derives the same status from the tenant's learning progress; read that instead.
   */
  onboardingTraining: OnboardingTrainingStatus;
  /**
   * The files the grower delivered through the onboarding card, oldest first. Empty for a tenant
   * that has uploaded nothing. Metadata only — no bytes, no URL.
   */
  onboardingUploads: Array<TenantOnboardingUploadData>;
  /**
   * Whether this tenant's customers may pay issued invoices online. False until Silver Fern turns it on
   * for the tenant; while it is false no invoice email or PDF carries a pay link and the public pay-link
   * lookup reports online payment as unavailable.
   */
  onlineInvoicePaymentsEnabled: Scalars['Boolean']['output'];
  /**
   * Report aggregate ID rendered as the Orders page acknowledgement PDF. Empty string means
   * no report is configured. Ignored for BPF, which retains the hardcoded Bonnie PDF.
   */
  orderAcknowledgementReportId: Scalars['String']['output'];
  /**
   * Tenant-level opt-in master switch for order/confirmation/acknowledgement emails. Null
   * means the tenant has never configured this setting — the Settings page shows "not
   * configured" for that state. Read effectiveOrderEmailsEnabled for the resolved
   * value the wsapi-services email workers act on.
   */
  orderEmailsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Timestamp of the most recent transition of orderEmailsEnabled into true —
   * the enablement cutoff the wsapi-services email worker filters orders on so enabling a
   * tenant never blasts its historical backlog. Null means the tenant has never been enabled.
   */
  orderEmailsEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The company default for the unit customers place orders in: SHIPPING_UOM (the unit
   * count is the number the customer gives) or EACHES (the eaches are the number the
   * customer gives). A customer's own orderEntryUnit override wins over this; a customer
   * with no override follows it. Defaults to SHIPPING_UOM — today's behaviour — for
   * tenants that have never configured it. Set with setTenantOrderEntryUnit.
   */
  orderEntryUnit: OrderEntryUnit;
  /**
   * Report aggregate ID rendered as the Orders page invoice PDF. Empty string means
   * no report is configured. Ignored for BPF, which retains the hardcoded Bonnie PDF.
   */
  orderInvoiceReportId: Scalars['String']['output'];
  /**
   * Report aggregate ID rendered as the Orders page Pro Forma PDF (Documents, View Pro Forma).
   * Empty string means no report is configured — read
   * effectiveOrderProFormaReportId for the value the PWA should render.
   */
  orderProFormaReportId: Scalars['String']['output'];
  /**
   * Report aggregate ID rendered as the Orders page pull slip PDF ("pick slip" in
   * worksuite-pwa). Empty string means no report is configured — read
   * effectiveOrderPullSlipReportId for the value the PWA should render.
   */
  orderPullSlipReportId: Scalars['String']['output'];
  /**
   * Per-tenant policy for missing OrganicLotCode on an organic VPO receive item.
   * OrganicReceiveMode.Warn surfaces a warning and allows submit;
   * OrganicReceiveMode.Block denies submit with a ValidationError.
   * Defaults to OrganicReceiveMode.Warn for back-compat with existing
   * tenants. New tenants are flipped to OrganicReceiveMode.Block when
   * AddTenant chains the corresponding event.
   */
  organicReceiveMode: OrganicReceiveMode;
  /**
   * The parent company this tenant belongs to, or empty when it belongs to none. Set with
   * setAdminTenantParentCompany.
   */
  parentCompanyId: Scalars['String']['output'];
  /**
   * Tenant-configured maximum length for sales-order and master-order PO numbers. Defaults to
   * 64 — current/unchanged behavior for every tenant that has not configured this.
   */
  poNumberMaxLength: Scalars['Int']['output'];
  /** None when no branding has been configured; OptionTypeInterceptor rewrites to nullable at the GraphQL schema boundary. */
  portalBranding?: Maybe<PortalBrandingData>;
  /**
   * The grower's sign-in marketing panel, saved by updateTenantSignInPanel and separate from
   * portalBranding. Null when no panel is stored.
   */
  portalSignInPanel?: Maybe<PortalSignInPanelData>;
  /**
   * The company default for how sales prices are entered and shown: EACH or UNIT
   * (per shipping unit). Prices are always stored and billed per each. A customer's own
   * priceEntryUnit override wins over this; a customer with no override follows it. Null on a
   * tenant that has never set it, which reads as EACH. Set with setTenantPriceEntryUnit.
   */
  priceEntryUnit?: Maybe<PriceEntryUnit>;
  /**
   * Number of decimals used when ROUNDING PRICE CALCULATIONS — the whole-group derivation and
   * PercentOff-kind price level arithmetic. Valid range 2..20. Defaults to 2 — current/unchanged
   * (cent-rounded) behavior for every tenant that has not configured this. Display (order
   * documents, PWA price rendering) is a separate concern and always rounds to cents regardless
   * of this setting. Set with updatePricingCalcDecimals.
   */
  pricingCalcDecimals: Scalars['Int']['output'];
  /** Whether matching item numbers link automatically. On when never configured. */
  produceAutoLinkMatchingNumbers: Scalars['Boolean']['output'];
  /**
   * Tenant-level default relief percentage pre-filled onto new capacity windows (each window
   * remains individually editable). Valid range 0..100. Defaults to 0 for tenants that have
   * never configured this. Set with updateProduceDefaultReliefPercent.
   */
  produceDefaultReliefPercent: Scalars['Decimal']['output'];
  produceEnabled: Scalars['Boolean']['output'];
  /**
   * Tenant-level policy for who can create a production plan from an order. Defaults to ANYONE
   * for tenants that have never configured this. With PRODUCTION_STAFF, only people with the
   * Production or Admin role (or an admin, superadmin or produce-admin login) can. Set with
   * updateProducePlanFromOrderAccess.
   */
  producePlanFromOrderAccess: ProducePlanFromOrderAccess;
  /**
   * Tenant-level default unit a user types on the production schedule — containers/trays or
   * eaches; the other unit is derived. Defaults to CONTAINERS for tenants that have never
   * configured this. Set with updateProducePlanningEntryUnit.
   */
  producePlanningEntryUnit: ProducePlanningEntryUnit;
  /**
   * True when a production entry made by someone without production-admin rights is held for review by a
   * production admin. Defaults to false for tenants that have never configured this. Set with
   * updateProduceProductionEntryReview.
   */
  produceProductionEntryReview: Scalars['Boolean']['output'];
  /**
   * How many decimals PRODUCE quantities display with (0 to 4). Defaults to 2 for tenants that have
   * never configured this. Display only: stored quantities keep full precision. Set with
   * updateProduceQuantityDecimals.
   */
  produceQuantityDecimals: Scalars['Int']['output'];
  /**
   * Tenant-level produced-quantity rounding policy for the production schedule. Defaults to
   * ROUND_UP for tenants that have never configured this. Space-plan consumption always
   * rounds up to whole containers regardless of this setting. Set with
   * updateProduceRounding.
   */
  produceRounding: ProduceRoundingMode;
  /**
   * Tenant-level basis the space plan consumes against available capacity. Defaults to
   * PRODUCE_QUANTITY for tenants that have never configured this. This field only stores
   * the value — the space-plan consumer reads it separately. Set with
   * updateProduceSpaceConsumptionBasis.
   */
  produceSpaceConsumptionBasis: ProduceSpaceConsumptionBasis;
  /**
   * Tenant-level unit of measure for space-planning footprint dimensions. Defaults to
   * INCHES for tenants that have never configured this. This field only stores the
   * value — the area-math consumer reads it separately. Set with
   * updateProduceSpacingDimensionUnit.
   */
  produceSpacingDimensionUnit: ProduceSpacingDimensionUnit;
  /**
   * Tenant-level display-only preference for which date a production week renders as. Week
   * numbers stay ISO-8601 everywhere regardless of this setting. Defaults to MONDAY for
   * tenants that have never configured this. Set with updateProduceWeekDisplayAnchor.
   */
  produceWeekDisplayAnchor: ProduceWeekDisplayAnchor;
  /** The tenant's chosen Purchase Order design. Empty = the built-in design. */
  purchaseOrderReportId: Scalars['String']['output'];
  /** Per-tenant feature gate for the Demand-Based Replenishment Engine. Default: false. */
  restockCalcEnabled: Scalars['Boolean']['output'];
  /**
   * Maximum allowable staleness of RestockCalc results before they are considered invalid, in hours.
   * Must be >= TenantState.MinRestockCalcHours and >= RestockCalcRefreshHours
   * (enforced by the PatchTenant invariant guard).
   * Default: TenantState.DefaultRestockCalcMaxStalenessHours.
   */
  restockCalcMaxStalenessHours: Scalars['Int']['output'];
  /**
   * RestockCalc cache refresh interval, in hours. Must be >= TenantState.MinRestockCalcHours
   * (enforced by ValidInt). Default: TenantState.DefaultRestockCalcRefreshHours.
   */
  restockCalcRefreshHours: Scalars['Int']['output'];
  /**
   * Identifier selecting which RestockCalc strategy implementation processes this tenant.
   * Free-form for now; will tighten to a registered set once additional strategies land.
   * Default: TenantState.DefaultRestockCalcStrategyKey.
   */
  restockCalcStrategyKey: Scalars['String']['output'];
  /**
   * The tenant's DEFAULT statement delivery method — how statements of account reach customers
   * that have no override of their own. null means the tenant has never configured
   * statement delivery, which is NOT the same as EMAIL: it reads as today's behaviour,
   * where eligibility is the activity-or-non-zero-balance rule and every eligible customer is
   * emailed. Set with updateStatementDeliverySettings.
   */
  statementDeliveryMethod?: Maybe<StatementDeliveryMethod>;
  /**
   * Whether a customer closing the period at exactly zero is passed over. null exactly
   * when statementDeliveryMethod is null — the policy is one value, set or absent.
   */
  statementSkipZeroBalance?: Maybe<Scalars['Boolean']['output']>;
  status: TenantStatus;
  /**
   * Per-tenant Stripe Connect state — the tenant's own connected account and the Stripe Tax
   * readiness observed on it. Always present; defaults to an empty (no account, not tax ready) state
   * for tenants with no connect events in their stream. isTaxReady on this object is the gate
   * worksuite-pwa reads to decide whether the mark-for-invoicing surface is available or shows the
   * readiness banner. Deliberately EXCLUDED from the customer-portal projection below — it is
   * tenant-operational state, not storefront data.
   */
  stripeConnect: TenantStripeConnectData;
  tenantId: Scalars['String']['output'];
  /**
   * Whether the tenant tracks shipment weight. Off (the default) hides weight totals and weight gap warnings
   * in Fulfill and lists no item weight gaps in Missing Data. Set with updateTrackShipmentWeight.
   */
  trackShipmentWeight: Scalars['Boolean']['output'];
  /**
   * When an expired trial's tenant data was manually deleted, stamped by an administrator. Null
   * means no deletion has been recorded; deletion itself stays a manual operation.
   */
  trialDataDeletedDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * When the tenant's self-serve trial expires. Null means a real (non-trial) tenant —
   * presence of a date is what marks a trial tenant; there is no separate tenant-type field.
   */
  trialExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Which trial policy the tenant runs under. Null means no kind was ever stamped — consumers
   * MUST read that as Standard, the restrictive default, so trials provisioned before this
   * field existed stay bounded without a backfill. Only meaningful alongside
   * TrialExpirationDate, which is what marks a tenant as a trial in the first place.
   */
  trialKind?: Maybe<TrialKind>;
  /**
   * Per-tenant overrides for the trial creation caps. Null means no overrides at all; a null
   * category inside the object means that one category uses the TrialPolicy default. Null is
   * never "unlimited".
   */
  trialLimits?: Maybe<TrialLimitsData>;
  /** Per-tenant unit configuration for the restock / replenishment pipeline. */
  unitConfig: TenantUnitConfigData;
  useErpPricing: Scalars['Boolean']['output'];
  /**
   * Tenant-level Verify routing preference read by worksuite-pwa to decide worker Finished
   * behavior. VerifyMode.Staged (default) routes submits to the supervisor review queue;
   * VerifyMode.Direct is owner-operator mode. Defaults to VerifyMode.Staged for
   * tenants with no TenantVerifyModeUpdated event in their stream.
   */
  verifyMode: VerifyMode;
  /**
   * The ids of the WorkSuite products this tenant has, in catalog order, without the products every
   * tenant has. Empty for a tenant whose products were never set. Set with
   * setAdminTenantWorkSuiteProducts. Always empty for a customer-portal caller.
   */
  workSuiteProductIds: Array<Scalars['String']['output']>;
};

export enum TenantStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type TenantStatusOperationFilterInput = {
  eq?: InputMaybe<TenantStatus>;
  in?: InputMaybe<Array<TenantStatus>>;
  neq?: InputMaybe<TenantStatus>;
  nin?: InputMaybe<Array<TenantStatus>>;
};

/**
 * GraphQL + read-model projection of a tenant's Stripe Connect state
 * (TenantStripeConnect) — the tenant's own connected account and the Stripe Tax readiness
 * observed on it. Surfaced on the tenant-scoped tenantStripeConnect query and on
 * tenant.stripeConnect, and embedded in AdminTenantDocument so the inbound
 * account.updated webhook can resolve a tenant by connected account id.
 *
 * Distinct from TenantBillingData, which is the platform-billing Stripe customer and
 * subscription that charges the tenant for WorkSuite itself. The platform account is never the tax
 * context.
 */
export type TenantStripeConnectData = {
  __typename?: 'TenantStripeConnectData';
  /**
   * How many Stripe Tax registrations on the connected account were active when readiness was last
   * observed. Tax settings can be active with none, and tax is then not collected anywhere, so the
   * tenant is not tax ready until this is at least 1.
   */
  activeTaxRegistrationCount: Scalars['Int']['output'];
  /** Stripe connected account id (acct_…); null until the tenant has one. */
  connectedAccountId?: Maybe<Scalars['String']['output']>;
  /**
   * Two-letter country the Stripe account was created in (US or CA); null until the tenant has an
   * account. An account created before the country was recorded reads US, since every such account
   * was created in the United States.
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * THE tax gate: true only when Stripe reports the connected account's tax settings active, the
   * account has at least one active tax registration, and no field is still missing (so a default
   * tax code is set). Settings status alone does not reflect whether the account is ready to collect
   * tax: with no active registration Stripe calculates zero tax everywhere, and with no default tax
   * code it refuses every taxable line. Marking orders for invoicing and the order tax estimate both
   * consult this; a tenant that is not ready is refused with a typed error rather than silently
   * invoiced at $0. Derived; not stored.
   */
  isTaxReady: Scalars['Boolean']['output'];
  /**
   * Whether the connected account finished Connect onboarding (details_submitted), mirrored
   * from the account.updated webhook. Informational for the pwa onboarding surface only — it is NOT
   * the invoicing gate; read isTaxReady for that.
   */
  onboardingComplete: Scalars['Boolean']['output'];
  /**
   * The fields the connected account still needs before it is tax ready: Stripe's own missing fields
   * verbatim, plus preset_tax_code whenever the tax settings have no default tax code, which can
   * happen while tax settings are active. Empty when nothing is outstanding, and empty when nothing
   * has been observed, so the pwa readiness banner can say exactly what is outstanding.
   */
  taxMissingFields: Array<Scalars['String']['output']>;
  /**
   * When the recorded readiness was last observed to CHANGE — not the last time it was polled. A
   * refresh (or an account.updated delivery) reporting the same facts is a no-op and does not advance
   * this. Null until the first observation.
   */
  taxReadinessCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Stripe Tax Settings status on the connected account as last observed. Persisted as a STRING (not
   * the ordinal) so the read model stays self-describing.
   */
  taxSettingsStatus: StripeTaxSettingsStatus;
};

/**
 * GraphQL + read-model projection of a tenant's Stripe Connect state
 * (TenantStripeConnect) — the tenant's own connected account and the Stripe Tax readiness
 * observed on it. Surfaced on the tenant-scoped tenantStripeConnect query and on
 * tenant.stripeConnect, and embedded in AdminTenantDocument so the inbound
 * account.updated webhook can resolve a tenant by connected account id.
 *
 * Distinct from TenantBillingData, which is the platform-billing Stripe customer and
 * subscription that charges the tenant for WorkSuite itself. The platform account is never the tax
 * context.
 */
export type TenantStripeConnectDataFilterInput = {
  /**
   * How many Stripe Tax registrations on the connected account were active when readiness was last
   * observed. Tax settings can be active with none, and tax is then not collected anywhere, so the
   * tenant is not tax ready until this is at least 1.
   */
  activeTaxRegistrationCount?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<TenantStripeConnectDataFilterInput>>;
  /** Stripe connected account id (acct_…); null until the tenant has one. */
  connectedAccountId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether the connected account finished Connect onboarding (details_submitted), mirrored
   * from the account.updated webhook. Informational for the pwa onboarding surface only — it is NOT
   * the invoicing gate; read isTaxReady for that.
   */
  onboardingComplete?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<TenantStripeConnectDataFilterInput>>;
  /**
   * The fields the connected account still needs before it is tax ready: Stripe's own missing fields
   * verbatim, plus preset_tax_code whenever the tax settings have no default tax code, which can
   * happen while tax settings are active. Empty when nothing is outstanding, and empty when nothing
   * has been observed, so the pwa readiness banner can say exactly what is outstanding.
   */
  taxMissingFields?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * When the recorded readiness was last observed to CHANGE — not the last time it was polled. A
   * refresh (or an account.updated delivery) reporting the same facts is a no-op and does not advance
   * this. Null until the first observation.
   */
  taxReadinessCheckedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Stripe Tax Settings status on the connected account as last observed. Persisted as a STRING (not
   * the ordinal) so the read model stays self-describing.
   */
  taxSettingsStatus?: InputMaybe<StripeTaxSettingsStatusOperationFilterInput>;
};

/**
 * GraphQL + read-model projection of a tenant's Stripe Connect state
 * (TenantStripeConnect) — the tenant's own connected account and the Stripe Tax readiness
 * observed on it. Surfaced on the tenant-scoped tenantStripeConnect query and on
 * tenant.stripeConnect, and embedded in AdminTenantDocument so the inbound
 * account.updated webhook can resolve a tenant by connected account id.
 *
 * Distinct from TenantBillingData, which is the platform-billing Stripe customer and
 * subscription that charges the tenant for WorkSuite itself. The platform account is never the tax
 * context.
 */
export type TenantStripeConnectDataSortInput = {
  /**
   * How many Stripe Tax registrations on the connected account were active when readiness was last
   * observed. Tax settings can be active with none, and tax is then not collected anywhere, so the
   * tenant is not tax ready until this is at least 1.
   */
  activeTaxRegistrationCount?: InputMaybe<SortEnumType>;
  /** Stripe connected account id (acct_…); null until the tenant has one. */
  connectedAccountId?: InputMaybe<SortEnumType>;
  /**
   * Whether the connected account finished Connect onboarding (details_submitted), mirrored
   * from the account.updated webhook. Informational for the pwa onboarding surface only — it is NOT
   * the invoicing gate; read isTaxReady for that.
   */
  onboardingComplete?: InputMaybe<SortEnumType>;
  /**
   * When the recorded readiness was last observed to CHANGE — not the last time it was polled. A
   * refresh (or an account.updated delivery) reporting the same facts is a no-op and does not advance
   * this. Null until the first observation.
   */
  taxReadinessCheckedAt?: InputMaybe<SortEnumType>;
  /**
   * Stripe Tax Settings status on the connected account as last observed. Persisted as a STRING (not
   * the ordinal) so the read model stays self-describing.
   */
  taxSettingsStatus?: InputMaybe<SortEnumType>;
};

/**
 * Mutation payload for createTenantStripeConnectedAccount and
 * refreshTenantStripeTaxReadiness. On success stripeConnect carries the tenant's
 * resulting connect state — including isTaxReady, read straight off the aggregate, so the
 * response is strongly consistent with the write rather than waiting on the read model. On rejection
 * it is null and errors carries the reason (including the typed Stripe Tax errors, which are
 * surfaced rather than swallowed).
 */
export type TenantStripeConnectPayload = {
  __typename?: 'TenantStripeConnectPayload';
  errors?: Maybe<Array<ValidationError>>;
  stripeConnect?: Maybe<TenantStripeConnectData>;
};

/**
 * GraphQL + read-model projection of a single subscription line item (TenantSubscriptionItem).
 * The charge fields (T23) are null on items linked before the price mirror existed.
 */
export type TenantSubscriptionItemData = {
  __typename?: 'TenantSubscriptionItemData';
  currency?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  intervalCount?: Maybe<Scalars['Long']['output']>;
  priceId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  subscriptionItemId: Scalars['String']['output'];
  unitAmount?: Maybe<Scalars['Long']['output']>;
};

/**
 * GraphQL + read-model projection of a single subscription line item (TenantSubscriptionItem).
 * The charge fields (T23) are null on items linked before the price mirror existed.
 */
export type TenantSubscriptionItemDataFilterInput = {
  and?: InputMaybe<Array<TenantSubscriptionItemDataFilterInput>>;
  currency?: InputMaybe<StringOperationFilterInput>;
  interval?: InputMaybe<StringOperationFilterInput>;
  intervalCount?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<TenantSubscriptionItemDataFilterInput>>;
  priceId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  subscriptionItemId?: InputMaybe<StringOperationFilterInput>;
  unitAmount?: InputMaybe<LongOperationFilterInput>;
};

/** Stripe's customer tax-exemption status (tax_exempt). */
export enum TenantTaxExemptStatus {
  /** Exempt from tax; Stripe calculates zero. */
  Exempt = 'EXEMPT',
  /** Not exempt — tax applies normally. Stripe's default for a new customer. */
  None = 'NONE',
  /** Reverse charge applies; the buyer self-accounts for the tax. */
  Reverse = 'REVERSE'
}

/**
 * The most recent Stripe Tax failure recorded for a tenant's platform billing by the Stripe webhook's
 * tax lane, while it is still uncleared. Never a live Stripe read.
 */
export type TenantTaxFailure = {
  __typename?: 'TenantTaxFailure';
  /**
   * Stripe's machine-readable identifier for the failure: last_finalization_error.code
   * (e.g. customer_tax_location_invalid) when Stripe supplied one, otherwise the
   * automatic_tax.disabled_reason.
   */
  code: Scalars['String']['output'];
  /**
   * The Stripe invoice the failure was observed on; null when it came from a subscription or a
   * schedule, neither of which names an invoice.
   */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /** When the failure was observed — the Stripe event's own creation time. */
  occurredAt: Scalars['DateTime']['output'];
  /**
   * Stripe's automatic_tax.disabled_reason (e.g. requires_location_inputs,
   * finalization_requires_location_inputs) when Stripe supplied one, otherwise the
   * finalization error code.
   */
  reason: Scalars['String']['output'];
};

/**
 * A tenant's Stripe Tax readiness for PLATFORM billing — whether Silver Fern can calculate tax when it
 * charges this tenant for WorkSuite. Resolved live from the Stripe customer with the platform key,
 * except the last failure, which comes from the webhook lane's stored state.
 */
export type TenantTaxReadiness = {
  __typename?: 'TenantTaxReadiness';
  /** Whether Stripe reports it can calculate tax for this customer's location. */
  automaticTaxStatus: TenantAutomaticTaxStatus;
  /**
   * The Stripe customer carries an address Stripe Tax can work from: a country plus at least one of
   * street line 1 or postal code. False whenever the customer has no address at all.
   */
  hasBillingAddress: Scalars['Boolean']['output'];
  /**
   * The most recent recorded tax failure for this tenant's platform billing, while it is still
   * uncleared; null when none was ever recorded, and null once a later complete-tax invoice cleared
   * it. This is the readiness signal, not an archive.
   */
  lastFailure?: Maybe<TenantTaxFailure>;
  /** The customer's tax-exemption status. */
  taxExempt: TenantTaxExemptStatus;
};

export type TenantUnitConfigData = {
  __typename?: 'TenantUnitConfigData';
  dailyInventoryStateIngestUnit: ReplenishmentUnit;
  dailyTransactionSummaryIngestUnit: ReplenishmentUnit;
  erpAvailabilityIngestUnit: ReplenishmentUnit;
  erpInTransitIngestUnit: ReplenishmentUnit;
  inventoryItemIngestUnit: ReplenishmentUnit;
  restockViewDisplayUnit: ReplenishmentUnit;
};

export type TenantUnitConfigDataFilterInput = {
  and?: InputMaybe<Array<TenantUnitConfigDataFilterInput>>;
  dailyInventoryStateIngestUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
  dailyTransactionSummaryIngestUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
  erpAvailabilityIngestUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
  erpInTransitIngestUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
  inventoryItemIngestUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
  or?: InputMaybe<Array<TenantUnitConfigDataFilterInput>>;
  restockViewDisplayUnit?: InputMaybe<ReplenishmentUnitOperationFilterInput>;
};

export type TenantUnitConfigDataInput = {
  dailyInventoryStateIngestUnit: ReplenishmentUnit;
  dailyTransactionSummaryIngestUnit: ReplenishmentUnit;
  erpAvailabilityIngestUnit: ReplenishmentUnit;
  erpInTransitIngestUnit: ReplenishmentUnit;
  inventoryItemIngestUnit: ReplenishmentUnit;
  restockViewDisplayUnit: ReplenishmentUnit;
};

export type TenantUnitConfigDataSortInput = {
  dailyInventoryStateIngestUnit?: InputMaybe<SortEnumType>;
  dailyTransactionSummaryIngestUnit?: InputMaybe<SortEnumType>;
  erpAvailabilityIngestUnit?: InputMaybe<SortEnumType>;
  erpInTransitIngestUnit?: InputMaybe<SortEnumType>;
  inventoryItemIngestUnit?: InputMaybe<SortEnumType>;
  restockViewDisplayUnit?: InputMaybe<SortEnumType>;
};

/** Full merged (seed ∪ tenant-custom) purchase UOM name list, returned by both the query and the add mutation. */
export type TenantUomListPayload = {
  __typename?: 'TenantUomListPayload';
  errors?: Maybe<Array<ValidationError>>;
  names?: Maybe<Array<Scalars['String']['output']>>;
};

export type TenantValueData = {
  __typename?: 'TenantValueData';
  tenantId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TenantValueDataInput = {
  tenantId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TenantValueStateData = {
  __typename?: 'TenantValueStateData';
  tenantId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type TermsByNamesConnection = {
  __typename?: 'TermsByNamesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TermsByNamesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TermsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TermsByNamesEdge = {
  __typename?: 'TermsByNamesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TermsDocument;
};

/** One row of a payment terms combine: both values and the value the combine will leave. */
export type TermsCombineField = {
  __typename?: 'TermsCombineField';
  isConflict: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: TermsCombineFieldKind;
  label: Scalars['String']['output'];
  loserValue?: Maybe<Scalars['String']['output']>;
  resultValue?: Maybe<Scalars['String']['output']>;
  survivorValue?: Maybe<Scalars['String']['output']>;
};

export enum TermsCombineFieldKind {
  Days = 'DAYS',
  History = 'HISTORY',
  Identity = 'IDENTITY',
  Setting = 'SETTING'
}

export enum TermsCombinePickChoice {
  Loser = 'LOSER',
  Survivor = 'SURVIVOR'
}

export type TermsCombinePickInput = {
  choice: TermsCombinePickChoice;
  key: Scalars['String']['input'];
};

/** What combining the loser into the survivor would do. Nothing is written to build it. */
export type TermsCombinePreview = {
  __typename?: 'TermsCombinePreview';
  /** How many fields need a pick. */
  conflictCount: Scalars['Int']['output'];
  /** The loser is the tenant default, so the default moves to the survivor. */
  defaultMoves: Scalars['Boolean']['output'];
  /** Every field with both values and the value the combine would leave. */
  fields: Array<TermsCombineField>;
  /** The payment terms that would be combined into the survivor. */
  loserId: Scalars['String']['output'];
  /** How many customers, ship-tos and orders use the loser. */
  loserUsage: TermsCombineUsage;
  /** The error code the combine would be refused with, whatever the picks; null when it can go ahead. */
  refusal?: Maybe<Scalars['String']['output']>;
  /** The payment terms that would stay. */
  survivorId: Scalars['String']['output'];
  /** The requested survivor has more customers plus ship-tos (fewer re-points), or as many and at least as many orders. */
  survivorSuggested: Scalars['Boolean']['output'];
  /** How many customers, ship-tos and orders use the survivor. */
  survivorUsage: TermsCombineUsage;
};

export type TermsCombinePreviewPayload = {
  __typename?: 'TermsCombinePreviewPayload';
  errors?: Maybe<Array<ValidationError>>;
  preview?: Maybe<TermsCombinePreview>;
};

/** How many customers, ship-tos and orders use one payment terms record. */
export type TermsCombineUsage = {
  __typename?: 'TermsCombineUsage';
  customers: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  shipTos: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type TermsConnection = {
  __typename?: 'TermsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TermsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TermsDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type TermsDocument = {
  __typename?: 'TermsDocument';
  /** ERP ids of the absorbed payment terms, index-aligned with absorbedTermsIds. */
  absorbedErpIds: Array<Scalars['String']['output']>;
  /** Names of the absorbed payment terms, index-aligned with absorbedTermsIds. */
  absorbedNames: Array<Scalars['String']['output']>;
  /** Ids of the payment terms combined into these, in combine order. */
  absorbedTermsIds: Array<Scalars['String']['output']>;
  accrueInterestPercentage: Scalars['Decimal']['output'];
  /** When these payment terms were combined into combinedIntoTermsId. */
  combinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who combined these payment terms into combinedIntoTermsId. */
  combinedBy?: Maybe<Scalars['String']['output']>;
  /** The payment terms these were combined into. */
  combinedIntoTermsId?: Maybe<Scalars['String']['output']>;
  discountDays: Scalars['Int']['output'];
  /**
   * The GrowPoint terms-master natural key (artrm.CODE) this terms record was imported
   * under. Empty for terms created natively in the pwa. Backs the importTerms add-or-merge
   * dedupe and the termsIdsByErpId link resolution (both keyed on (TenantId, ErpId)).
   */
  erpId: Scalars['String']['output'];
  /**
   * Monthly periodic finance-charge rate, stored as a fraction (0.015 = 1.5%/month).
   * Surfaced as a percent value by TermsDocumentType. Distinct from
   * accrueInterestPercentage, which is the early-pay discount, not interest.
   */
  financeChargeMonthlyRate: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  /**
   * Jurisdictional maximum legal finance-charge rate, stored as an ANNUAL fraction
   * (0.18 = 18% APR). Surfaced as a percent value by TermsDocumentType.
   */
  maximumAnnualFinanceChargeRate: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  status: TermsStatus;
  tenantId: Scalars['String']['output'];
  termLimitDays: Scalars['Int']['output'];
  termsId: Scalars['String']['output'];
  /**
   * The number of customers, ship-tos and orders on these payment terms, company-wide: the number a refused
   * delete names. Null when the count is unavailable, and always null for a customer-portal caller, as
   * the count is a tenant-wide cross-customer aggregate.
   */
  usageCount?: Maybe<Scalars['Int']['output']>;
  /**
   * What uses these payment terms: customers, ship-tos and orders, one group per kind. The total equals the
   * Usage Count and the count a refused delete names. Staff only: a customer caller gets an error and a null
   * list, so the field stays nullable. Read it for one terms at a time: it reads its own groups for each
   * terms it is selected on, so selecting it on a list of terms costs several reads per row.
   */
  usedBy?: Maybe<UsedBy>;
};


export type TermsDocumentUsedByArgs = {
  first?: Scalars['Int']['input'];
  kind?: InputMaybe<RecordKind>;
  offset?: Scalars['Int']['input'];
};

export type TermsDocumentFilterInput = {
  accrueInterestPercentage?: InputMaybe<PercentValueOperationFilterInput>;
  and?: InputMaybe<Array<TermsDocumentFilterInput>>;
  /** When these payment terms were combined into combinedIntoTermsId. */
  combinedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The payment terms these were combined into. */
  combinedIntoTermsId?: InputMaybe<StringOperationFilterInput>;
  discountDays?: InputMaybe<IntOperationFilterInput>;
  /**
   * The GrowPoint terms-master natural key (artrm.CODE) this terms record was imported
   * under. Empty for terms created natively in the pwa. Backs the importTerms add-or-merge
   * dedupe and the termsIdsByErpId link resolution (both keyed on (TenantId, ErpId)).
   */
  erpId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Monthly periodic finance-charge rate, stored as a fraction (0.015 = 1.5%/month).
   * Surfaced as a percent value by TermsDocumentType. Distinct from
   * accrueInterestPercentage, which is the early-pay discount, not interest.
   */
  financeChargeMonthlyRate?: InputMaybe<PercentValueOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Jurisdictional maximum legal finance-charge rate, stored as an ANNUAL fraction
   * (0.18 = 18% APR). Surfaced as a percent value by TermsDocumentType.
   */
  maximumAnnualFinanceChargeRate?: InputMaybe<PercentValueOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TermsDocumentFilterInput>>;
  status?: InputMaybe<TermsStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  termLimitDays?: InputMaybe<IntOperationFilterInput>;
  termsId?: InputMaybe<StringOperationFilterInput>;
};

export type TermsDocumentSortInput = {
  accrueInterestPercentage?: InputMaybe<SortEnumType>;
  /** When these payment terms were combined into combinedIntoTermsId. */
  combinedAt?: InputMaybe<SortEnumType>;
  /** The payment terms these were combined into. */
  combinedIntoTermsId?: InputMaybe<SortEnumType>;
  discountDays?: InputMaybe<SortEnumType>;
  /**
   * The GrowPoint terms-master natural key (artrm.CODE) this terms record was imported
   * under. Empty for terms created natively in the pwa. Backs the importTerms add-or-merge
   * dedupe and the termsIdsByErpId link resolution (both keyed on (TenantId, ErpId)).
   */
  erpId?: InputMaybe<SortEnumType>;
  /**
   * Monthly periodic finance-charge rate, stored as a fraction (0.015 = 1.5%/month).
   * Surfaced as a percent value by TermsDocumentType. Distinct from
   * accrueInterestPercentage, which is the early-pay discount, not interest.
   */
  financeChargeMonthlyRate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  /**
   * Jurisdictional maximum legal finance-charge rate, stored as an ANNUAL fraction
   * (0.18 = 18% APR). Surfaced as a percent value by TermsDocumentType.
   */
  maximumAnnualFinanceChargeRate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  termLimitDays?: InputMaybe<SortEnumType>;
  termsId?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type TermsEdge = {
  __typename?: 'TermsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TermsDocument;
};

/**
 * A single erpId-to-termsId resolution returned by the termsIdsByErpId query.
 * Single-purpose by design (per the wsapi single-use type convention) — do not reuse for other surfaces.
 */
export type TermsErpIdPair = {
  __typename?: 'TermsErpIdPair';
  erpId: Scalars['String']['output'];
  termsId: Scalars['String']['output'];
};

export type TermsPayload = {
  __typename?: 'TermsPayload';
  errors?: Maybe<Array<ValidationError>>;
  terms?: Maybe<TermsStateData>;
};

/**
 * Per-row failure surfaced by validateTermsDocuments. RowIndex
 * is the position in the posted batch (so wsapi-services / AG Grid can map back to
 * the source row); Field is the offending field name when the underlying
 * ValidationError implements IFieldValidationError, otherwise null.
 */
export type TermsStagedRowError = {
  __typename?: 'TermsStagedRowError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type TermsStateData = {
  __typename?: 'TermsStateData';
  /**
   * Annual interest rate as a percent value (5 means 5%), not a fraction. Internally
   * the domain stores the fraction form (0.05); this field is boundary-converted at the
   * API edge so callers send and receive percent values.
   */
  accrueInterestPercentage: Scalars['Decimal']['output'];
  discountDays: Scalars['Int']['output'];
  /**
   * The GrowPoint terms-master natural key (artrm.CODE) this terms record was imported
   * under. Empty for terms created natively in the pwa.
   */
  erpId: Scalars['String']['output'];
  /**
   * Monthly periodic finance-charge rate as a percent value (1.5 means 1.5% per month =
   * 18% APR), not a fraction. The domain stores the fraction form (0.015); this field is
   * boundary-converted at the API edge, matching accrueInterestPercentage.
   * Distinct from that field, which is the EARLY-PAY DISCOUNT, not interest.
   */
  financeChargeMonthlyRate: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  /**
   * Jurisdictional maximum legal finance-charge rate as an ANNUAL percent value (18 means
   * 18% APR), not a fraction. Configured per terms record, never hardcoded to one state.
   * The domain stores the fraction form (0.18); this field is boundary-converted at the
   * API edge.
   */
  maximumAnnualFinanceChargeRate: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  status: TermsStatus;
  tenantId: Scalars['String']['output'];
  termLimitDays: Scalars['Int']['output'];
};

export enum TermsStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type TermsStatusOperationFilterInput = {
  eq?: InputMaybe<TermsStatus>;
  in?: InputMaybe<Array<TermsStatus>>;
  neq?: InputMaybe<TermsStatus>;
  nin?: InputMaybe<Array<TermsStatus>>;
};

/** Stored as the int: UNKNOWN = 0, OPTED_OUT = 1, NOT_A_MOBILE_NUMBER = 2, UNREACHABLE = 3, BLOCKED_BY_CARRIER = 4, OTHER = 5. */
export enum TextNotDeliveredReason {
  BlockedByCarrier = 'BLOCKED_BY_CARRIER',
  NotAMobileNumber = 'NOT_A_MOBILE_NUMBER',
  OptedOut = 'OPTED_OUT',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  Unreachable = 'UNREACHABLE'
}

/** GraphQL data type for task assignment time entries. */
export type TimeEntryData = {
  __typename?: 'TimeEntryData';
  createdBy: Scalars['String']['output'];
  duration: Scalars['TimeSpan']['output'];
  endTime: Scalars['DateTime']['output'];
  headcount: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  timeEntryId: Scalars['String']['output'];
};

/** Time entry document - one per user/task/day, updated throughout the day */
export type TimeEntryDocument = {
  __typename?: 'TimeEntryDocument';
  /** Task ID from ClickUp */
  clickUpTaskId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Customer ID from ClickUp */
  customerId: Scalars['String']['output'];
  /** Date of work performed */
  entryDate: Scalars['DateTime']['output'];
  /** Total hours worked (not incremental) */
  hoursWorked: Scalars['Decimal']['output'];
  /** Composite ID: {TenantId}_{UserId}_{ClickUpTaskId}_{Date} */
  id: Scalars['String']['output'];
  /** Developer notes about work */
  notes: Scalars['String']['output'];
  /** Project ID from ClickUp */
  projectId: Scalars['String']['output'];
  /** Task title for display */
  taskTitle: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  /** Last modified timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** User email address */
  userId: Scalars['String']['output'];
};

/** Time entry document - one per user/task/day, updated throughout the day */
export type TimeEntryDocumentFilterInput = {
  and?: InputMaybe<Array<TimeEntryDocumentFilterInput>>;
  /** Task ID from ClickUp */
  clickUpTaskId?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Customer ID from ClickUp */
  customerId?: InputMaybe<StringOperationFilterInput>;
  /** Date of work performed */
  entryDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Total hours worked (not incremental) */
  hoursWorked?: InputMaybe<DecimalOperationFilterInput>;
  /** Composite ID: {TenantId}_{UserId}_{ClickUpTaskId}_{Date} */
  id?: InputMaybe<StringOperationFilterInput>;
  /** Developer notes about work */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TimeEntryDocumentFilterInput>>;
  /** Project ID from ClickUp */
  projectId?: InputMaybe<StringOperationFilterInput>;
  /** Task title for display */
  taskTitle?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** Last modified timestamp */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** User email address */
  userId?: InputMaybe<StringOperationFilterInput>;
};

/** Time entry document - one per user/task/day, updated throughout the day */
export type TimeEntryDocumentSortInput = {
  /** Task ID from ClickUp */
  clickUpTaskId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  /** Customer ID from ClickUp */
  customerId?: InputMaybe<SortEnumType>;
  /** Date of work performed */
  entryDate?: InputMaybe<SortEnumType>;
  /** Total hours worked (not incremental) */
  hoursWorked?: InputMaybe<SortEnumType>;
  /** Composite ID: {TenantId}_{UserId}_{ClickUpTaskId}_{Date} */
  id?: InputMaybe<SortEnumType>;
  /** Developer notes about work */
  notes?: InputMaybe<SortEnumType>;
  /** Project ID from ClickUp */
  projectId?: InputMaybe<SortEnumType>;
  /** Task title for display */
  taskTitle?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** Last modified timestamp */
  updatedAt?: InputMaybe<SortEnumType>;
  /** User email address */
  userId?: InputMaybe<SortEnumType>;
};

/** Upsert operation result */
export type TimeEntryPayload = {
  __typename?: 'TimeEntryPayload';
  errors?: Maybe<Array<ValidationError>>;
  timeEntries?: Maybe<Array<TimeEntryDocument>>;
};

export type TimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']['input']>;
  gt?: InputMaybe<Scalars['TimeSpan']['input']>;
  gte?: InputMaybe<Scalars['TimeSpan']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']['input']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']['input']>;
  lte?: InputMaybe<Scalars['TimeSpan']['input']>;
  neq?: InputMaybe<Scalars['TimeSpan']['input']>;
  ngt?: InputMaybe<Scalars['TimeSpan']['input']>;
  ngte?: InputMaybe<Scalars['TimeSpan']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']['input']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']['input']>;
  nlte?: InputMaybe<Scalars['TimeSpan']['input']>;
};

export enum TimeZoneProvenance {
  Derived = 'DERIVED',
  Explicit = 'EXPLICIT',
  Unset = 'UNSET'
}

export type TimeZoneProvenanceOperationFilterInput = {
  eq?: InputMaybe<TimeZoneProvenance>;
  in?: InputMaybe<Array<TimeZoneProvenance>>;
  neq?: InputMaybe<TimeZoneProvenance>;
  nin?: InputMaybe<Array<TimeZoneProvenance>>;
};

export type ToggleCustomerUpgradeDefaultInput = {
  customerId: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  upgradeId: Scalars['String']['input'];
};

export type ToggleItemUpgradeDefaultInput = {
  isDefault: Scalars['Boolean']['input'];
  itemId: Scalars['String']['input'];
  upgradeId: Scalars['String']['input'];
};

export type ToggleSftpDestinationInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  enable: Scalars['Boolean']['input'];
};

export type ToggleSftpMongoDestinationInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  enable: Scalars['Boolean']['input'];
};

export type TransferInventoryItemCommandInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['Int']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  quantity: Scalars['Decimal']['input'];
  reasonCode?: InputMaybe<Scalars['Int']['input']>;
  toGrade?: InputMaybe<Scalars['Int']['input']>;
  toItemId: Scalars['String']['input'];
  toLocationId?: InputMaybe<Scalars['String']['input']>;
  why: Scalars['String']['input'];
};

export enum TransformType {
  NotSet = 'NOT_SET',
  Regex = 'REGEX'
}

export type TransformTypeOperationFilterInput = {
  eq?: InputMaybe<TransformType>;
  in?: InputMaybe<Array<TransformType>>;
  neq?: InputMaybe<TransformType>;
  nin?: InputMaybe<Array<TransformType>>;
};

export enum TransitKind {
  MultiDay = 'MULTI_DAY',
  Overnight = 'OVERNIGHT',
  SameDay = 'SAME_DAY',
  Unknown = 'UNKNOWN'
}

export type TransitKindOperationFilterInput = {
  eq?: InputMaybe<TransitKind>;
  in?: InputMaybe<Array<TransitKind>>;
  neq?: InputMaybe<TransitKind>;
  nin?: InputMaybe<Array<TransitKind>>;
};

/** Where a tenant sits against one capped category. */
export type TrialCategoryUsage = {
  __typename?: 'TrialCategoryUsage';
  /** The capped category. */
  category: TrialLimitCategory;
  /**
   * The tenant's current usage, absent when the count could not be read. Absent means UNKNOWN and is
   * never a synonym for zero — a transient datastore failure yields no count, and reporting that as
   * 0 would tell an operator a trial is empty when it may be full.
   */
  current?: Maybe<Scalars['Long']['output']>;
  /**
   * The cap in force — the tenant's own override when it has one, else the trial policy default for
   * its kind. Absent means NO CAP APPLIES: either the tenant is exempt (a Migrator trial, flagged by
   * capsExempt) or its kind has no policy configured. A cap of 0 is legal and distinct from absent:
   * it means "may not create any".
   */
  effectiveCap?: Maybe<Scalars['Int']['output']>;
};

export enum TrialKind {
  Migrator = 'MIGRATOR',
  Standard = 'STANDARD'
}

/** What one run of the trial-kind backfill did. */
export type TrialKindBackfillPayload = {
  __typename?: 'TrialKindBackfillPayload';
  /**
   * One entry per tenant whose stamp failed. A failure does not abort the run: the remaining tenants
   * are still stamped, and re-running picks up whatever was left behind.
   */
  errors?: Maybe<Array<ValidationError>>;
  /**
   * In-scope trial tenants that already carried a kind and were left exactly as they were. Non-trial
   * and deleted tenants are not in scope at all and are counted in neither number.
   */
  skipped: Scalars['Int']['output'];
  /** Trial tenants this run stamped Standard. Zero on a re-run — everything already carries a kind. */
  stamped: Scalars['Int']['output'];
  /**
   * The tenants this run stamped, so an operator knows exactly which ones to review. Nothing
   * distinguishes a migrating customer's trial from an ordinary one retroactively, so every kind-less
   * trial is stamped Standard — the restrictive kind — and known migrators are re-flagged afterwards
   * from the Trial Tenants grid. That re-flag is a deliberate manual follow-up, not automation.
   */
  stampedTenantIds: Array<Scalars['String']['output']>;
};

/**
 * The thirteen capped resource categories a Standard trial tenant runs under. Each member pairs
 * one-for-one with a property on BOTH the trial policy limits (the per-trial-kind policy default)
 * and the per-tenant trial limit overrides. Cap resolution is the single place that pairing is
 * expressed.
 */
export enum TrialLimitCategory {
  /** Customers (CustomersSummary read model). */
  Customers = 'CUSTOMERS',
  /** Inventory items (InventoryItems read model). */
  InventoryItems = 'INVENTORY_ITEMS',
  /** Catalog items (ItemSummary read model). */
  Items = 'ITEMS',
  /** Material items (MaterialItem read model). */
  MaterialItems = 'MATERIAL_ITEMS',
  /** Orders (Orders read model). */
  Orders = 'ORDERS',
  /** Price groups (PriceGroups read model). */
  PriceGroups = 'PRICE_GROUPS',
  /** Price levels (PriceLevels read model), tenant-wide across all price groups. */
  PriceLevels = 'PRICE_LEVELS',
  /** Production lots (ProductionLots read model). */
  ProductionLots = 'PRODUCTION_LOTS',
  /** Production recipes (ProductionRecipes read model). */
  ProductionRecipes = 'PRODUCTION_RECIPES',
  /** Seats — directory users PLUS still-pending user invites (two collections). */
  Seats = 'SEATS',
  /** Site locations (SiteLocations read model). */
  SiteLocations = 'SITE_LOCATIONS',
  /**
   * Child locations under a SINGLE site (SubLocations read model). Unlike every other
   * category this cap is per-site, not tenant-wide.
   */
  SiteLocationChildrenPerSite = 'SITE_LOCATION_CHILDREN_PER_SITE',
  /** Vendors (Vendor read model). */
  Vendors = 'VENDORS'
}

export type TrialLimitsData = {
  __typename?: 'TrialLimitsData';
  customers?: Maybe<Scalars['Int']['output']>;
  inventoryItems?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Scalars['Int']['output']>;
  materialItems?: Maybe<Scalars['Int']['output']>;
  orders?: Maybe<Scalars['Int']['output']>;
  priceGroups?: Maybe<Scalars['Int']['output']>;
  priceLevels?: Maybe<Scalars['Int']['output']>;
  productionLots?: Maybe<Scalars['Int']['output']>;
  productionRecipes?: Maybe<Scalars['Int']['output']>;
  seats?: Maybe<Scalars['Int']['output']>;
  siteLocationChildrenPerSite?: Maybe<Scalars['Int']['output']>;
  siteLocations?: Maybe<Scalars['Int']['output']>;
  vendors?: Maybe<Scalars['Int']['output']>;
};

export type TrialLimitsDataFilterInput = {
  and?: InputMaybe<Array<TrialLimitsDataFilterInput>>;
  customers?: InputMaybe<IntOperationFilterInput>;
  inventoryItems?: InputMaybe<IntOperationFilterInput>;
  items?: InputMaybe<IntOperationFilterInput>;
  materialItems?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<TrialLimitsDataFilterInput>>;
  orders?: InputMaybe<IntOperationFilterInput>;
  priceGroups?: InputMaybe<IntOperationFilterInput>;
  priceLevels?: InputMaybe<IntOperationFilterInput>;
  productionLots?: InputMaybe<IntOperationFilterInput>;
  productionRecipes?: InputMaybe<IntOperationFilterInput>;
  seats?: InputMaybe<IntOperationFilterInput>;
  siteLocationChildrenPerSite?: InputMaybe<IntOperationFilterInput>;
  siteLocations?: InputMaybe<IntOperationFilterInput>;
  vendors?: InputMaybe<IntOperationFilterInput>;
};

export type TrialLimitsDataInput = {
  customers?: InputMaybe<Scalars['Int']['input']>;
  inventoryItems?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Scalars['Int']['input']>;
  materialItems?: InputMaybe<Scalars['Int']['input']>;
  orders?: InputMaybe<Scalars['Int']['input']>;
  priceGroups?: InputMaybe<Scalars['Int']['input']>;
  priceLevels?: InputMaybe<Scalars['Int']['input']>;
  productionLots?: InputMaybe<Scalars['Int']['input']>;
  productionRecipes?: InputMaybe<Scalars['Int']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  siteLocationChildrenPerSite?: InputMaybe<Scalars['Int']['input']>;
  siteLocations?: InputMaybe<Scalars['Int']['input']>;
  vendors?: InputMaybe<Scalars['Int']['input']>;
};

export type TrialLimitsDataSortInput = {
  customers?: InputMaybe<SortEnumType>;
  inventoryItems?: InputMaybe<SortEnumType>;
  items?: InputMaybe<SortEnumType>;
  materialItems?: InputMaybe<SortEnumType>;
  orders?: InputMaybe<SortEnumType>;
  priceGroups?: InputMaybe<SortEnumType>;
  priceLevels?: InputMaybe<SortEnumType>;
  productionLots?: InputMaybe<SortEnumType>;
  productionRecipes?: InputMaybe<SortEnumType>;
  seats?: InputMaybe<SortEnumType>;
  siteLocationChildrenPerSite?: InputMaybe<SortEnumType>;
  siteLocations?: InputMaybe<SortEnumType>;
  vendors?: InputMaybe<SortEnumType>;
};

/**
 * MongoDB read model document for one trial kind's policy — the feature flags a trial of that kind
 * may turn on, and the default creation caps it runs under. One document per
 * TrialKind, keyed by the kind name.
 */
export type TrialPolicyDocument = {
  __typename?: 'TrialPolicyDocument';
  /**
   * The flags a trial of this kind may turn on. DEFAULT-DENY — a flag absent from this list is off
   * for the trial regardless of the tenant's own feature-flag overrides.
   */
  allowedFeatureFlags: Array<FeatureFlagName>;
  /**
   * The default creation caps for this kind. A tenant's own trialLimits override wins per
   * category; categories it leaves unset fall through to these values.
   */
  defaultLimits: TrialPolicyLimitsData;
  id: Scalars['String']['output'];
  kind: TrialKind;
};

export type TrialPolicyLimitsData = {
  __typename?: 'TrialPolicyLimitsData';
  customers: Scalars['Int']['output'];
  inventoryItems: Scalars['Int']['output'];
  items: Scalars['Int']['output'];
  materialItems: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  priceGroups: Scalars['Int']['output'];
  priceLevels: Scalars['Int']['output'];
  productionLots: Scalars['Int']['output'];
  productionRecipes: Scalars['Int']['output'];
  seats: Scalars['Int']['output'];
  siteLocationChildrenPerSite: Scalars['Int']['output'];
  siteLocations: Scalars['Int']['output'];
  vendors: Scalars['Int']['output'];
};

export type TrialPolicyLimitsDataInput = {
  customers: Scalars['Int']['input'];
  inventoryItems: Scalars['Int']['input'];
  items: Scalars['Int']['input'];
  materialItems: Scalars['Int']['input'];
  orders: Scalars['Int']['input'];
  priceGroups: Scalars['Int']['input'];
  priceLevels: Scalars['Int']['input'];
  productionLots: Scalars['Int']['input'];
  productionRecipes: Scalars['Int']['input'];
  seats: Scalars['Int']['input'];
  siteLocationChildrenPerSite: Scalars['Int']['input'];
  siteLocations: Scalars['Int']['input'];
  vendors: Scalars['Int']['input'];
};

/** Data projection of trial policy state returned in mutation payloads. */
export type TrialPolicyStateData = {
  __typename?: 'TrialPolicyStateData';
  allowedFeatureFlags: Array<FeatureFlagName>;
  defaultLimits: TrialPolicyLimitsData;
  kind: TrialKind;
};

/**
 * MongoDB read model for a self-serve trial-signup request. Surfaced in full (including
 * matchCandidates and contact PII) ONLY to superadmins via the approval-queue query;
 * the anonymous status surface never returns this type. The provisioning worker filters on
 * status == Approved/Linked.
 */
export type TrialRequestDocument = {
  __typename?: 'TrialRequestDocument';
  /**
   * Version of the Trial Terms of Service the prospect accepted at submit (the clickwrap assent
   * record); createdAt is the server-side assent timestamp. Null when no assent was
   * recorded — a pre-terms client bundle or a direct API caller. Surfaced on the superadmin
   * trialRequests query so the approval pipeline can see it.
   */
  acceptedTermsVersion?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  contactFirstName: Scalars['String']['output'];
  contactLastName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  /** Deterministic stream id — the resolve mutation targets the aggregate by this. */
  entityId: Scalars['String']['output'];
  /** Most recent provisioning failure reason (the request stays retryable). */
  failureReason: Scalars['String']['output'];
  id: Scalars['String']['output'];
  linkedTenantId: Scalars['String']['output'];
  matchCandidates: Array<MatchCandidateDocument>;
  normalizedCompany: Scalars['String']['output'];
  normalizedEmail: Scalars['String']['output'];
  /**
   * Optional freeform prospect note ("anything we should know?"), trimmed/capped at signup and
   * null when left blank. Exposed on the superadmin trialRequests query so staff — and the
   * wsapi-services Forge hook — can read it. Nullable so a pre-notes document reads as "no note".
   */
  notes?: Maybe<Scalars['String']['output']>;
  provisionedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Tenant the worker provisioned into once provisioning succeeded. */
  provisionedTenantId: Scalars['String']['output'];
  provisioningFailedAt?: Maybe<Scalars['DateTime']['output']>;
  provisioningStartedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason: Scalars['String']['output'];
  /** Unguessable public id (what the prospect polls with); indexed for status lookups. */
  requestId: Scalars['String']['output'];
  requestedModules: Array<Scalars['String']['output']>;
  resolvedBy: Scalars['String']['output'];
  source: Scalars['String']['output'];
  /** Lifecycle status as a TrialRequestStatus ordinal. */
  status: Scalars['Int']['output'];
  /** Tenant code the provisioning worker stamped before creating the tenant; empty until provisioning starts. */
  tenantCode: Scalars['String']['output'];
  trialDays: Scalars['Int']['output'];
};

/**
 * MongoDB read model for a self-serve trial-signup request. Surfaced in full (including
 * matchCandidates and contact PII) ONLY to superadmins via the approval-queue query;
 * the anonymous status surface never returns this type. The provisioning worker filters on
 * status == Approved/Linked.
 */
export type TrialRequestDocumentFilterInput = {
  /**
   * Version of the Trial Terms of Service the prospect accepted at submit (the clickwrap assent
   * record); createdAt is the server-side assent timestamp. Null when no assent was
   * recorded — a pre-terms client bundle or a direct API caller. Surfaced on the superadmin
   * trialRequests query so the approval pipeline can see it.
   */
  acceptedTermsVersion?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<TrialRequestDocumentFilterInput>>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  contactFirstName?: InputMaybe<StringOperationFilterInput>;
  contactLastName?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  /** Deterministic stream id — the resolve mutation targets the aggregate by this. */
  entityId?: InputMaybe<StringOperationFilterInput>;
  /** Most recent provisioning failure reason (the request stays retryable). */
  failureReason?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  linkedTenantId?: InputMaybe<StringOperationFilterInput>;
  matchCandidates?: InputMaybe<ListFilterInputTypeOfMatchCandidateDocumentFilterInput>;
  normalizedCompany?: InputMaybe<StringOperationFilterInput>;
  normalizedEmail?: InputMaybe<StringOperationFilterInput>;
  /**
   * Optional freeform prospect note ("anything we should know?"), trimmed/capped at signup and
   * null when left blank. Exposed on the superadmin trialRequests query so staff — and the
   * wsapi-services Forge hook — can read it. Nullable so a pre-notes document reads as "no note".
   */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TrialRequestDocumentFilterInput>>;
  provisionedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Tenant the worker provisioned into once provisioning succeeded. */
  provisionedTenantId?: InputMaybe<StringOperationFilterInput>;
  provisioningFailedAt?: InputMaybe<DateTimeOperationFilterInput>;
  provisioningStartedAt?: InputMaybe<DateTimeOperationFilterInput>;
  rejectionReason?: InputMaybe<StringOperationFilterInput>;
  /** Unguessable public id (what the prospect polls with); indexed for status lookups. */
  requestId?: InputMaybe<StringOperationFilterInput>;
  requestedModules?: InputMaybe<ListStringOperationFilterInput>;
  resolvedBy?: InputMaybe<StringOperationFilterInput>;
  source?: InputMaybe<StringOperationFilterInput>;
  /** Lifecycle status as a TrialRequestStatus ordinal. */
  status?: InputMaybe<IntOperationFilterInput>;
  /** Tenant code the provisioning worker stamped before creating the tenant; empty until provisioning starts. */
  tenantCode?: InputMaybe<StringOperationFilterInput>;
  trialDays?: InputMaybe<IntOperationFilterInput>;
};

/**
 * MongoDB read model for a self-serve trial-signup request. Surfaced in full (including
 * matchCandidates and contact PII) ONLY to superadmins via the approval-queue query;
 * the anonymous status surface never returns this type. The provisioning worker filters on
 * status == Approved/Linked.
 */
export type TrialRequestDocumentSortInput = {
  /**
   * Version of the Trial Terms of Service the prospect accepted at submit (the clickwrap assent
   * record); createdAt is the server-side assent timestamp. Null when no assent was
   * recorded — a pre-terms client bundle or a direct API caller. Surfaced on the superadmin
   * trialRequests query so the approval pipeline can see it.
   */
  acceptedTermsVersion?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  completedAt?: InputMaybe<SortEnumType>;
  contactFirstName?: InputMaybe<SortEnumType>;
  contactLastName?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  /** Deterministic stream id — the resolve mutation targets the aggregate by this. */
  entityId?: InputMaybe<SortEnumType>;
  /** Most recent provisioning failure reason (the request stays retryable). */
  failureReason?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  linkedTenantId?: InputMaybe<SortEnumType>;
  normalizedCompany?: InputMaybe<SortEnumType>;
  normalizedEmail?: InputMaybe<SortEnumType>;
  /**
   * Optional freeform prospect note ("anything we should know?"), trimmed/capped at signup and
   * null when left blank. Exposed on the superadmin trialRequests query so staff — and the
   * wsapi-services Forge hook — can read it. Nullable so a pre-notes document reads as "no note".
   */
  notes?: InputMaybe<SortEnumType>;
  provisionedAt?: InputMaybe<SortEnumType>;
  /** Tenant the worker provisioned into once provisioning succeeded. */
  provisionedTenantId?: InputMaybe<SortEnumType>;
  provisioningFailedAt?: InputMaybe<SortEnumType>;
  provisioningStartedAt?: InputMaybe<SortEnumType>;
  rejectionReason?: InputMaybe<SortEnumType>;
  /** Unguessable public id (what the prospect polls with); indexed for status lookups. */
  requestId?: InputMaybe<SortEnumType>;
  resolvedBy?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  /** Lifecycle status as a TrialRequestStatus ordinal. */
  status?: InputMaybe<SortEnumType>;
  /** Tenant code the provisioning worker stamped before creating the tenant; empty until provisioning starts. */
  tenantCode?: InputMaybe<SortEnumType>;
  trialDays?: InputMaybe<SortEnumType>;
};

/** Superadmin resolve payload (full request document). */
export type TrialRequestPayload = {
  __typename?: 'TrialRequestPayload';
  errors?: Maybe<Array<ValidationError>>;
  trialRequest?: Maybe<TrialRequestDocument>;
};

/** How a superadmin is resolving a pending trial request. */
export enum TrialRequestResolution {
  Approve = 'APPROVE',
  LinkToExisting = 'LINK_TO_EXISTING',
  Reject = 'REJECT'
}

/** Anonymous status view — coarse status keyed by the caller's own request id ONLY. */
export type TrialRequestStatusView = {
  __typename?: 'TrialRequestStatusView';
  requestId: Scalars['String']['output'];
  status: TrialSignupPublicStatus;
};

/** A connection to a list of items. */
export type TrialRequestsConnection = {
  __typename?: 'TrialRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TrialRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TrialRequestDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TrialRequestsEdge = {
  __typename?: 'TrialRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TrialRequestDocument;
};

/** Coarse lifecycle status exposed to the anonymous status probe (no PII, no candidates). */
export enum TrialSignupPublicStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/**
 * How many child locations one of the tenant's sites holds. The child-location cap is measured per
 * site, so the drawer needs this breakdown rather than a single tenant-wide number.
 */
export type TrialSiteChildUsage = {
  __typename?: 'TrialSiteChildUsage';
  /** Child locations currently under that site. */
  children: Scalars['Int']['output'];
  /** The parent site. */
  siteLocationId: Scalars['String']['output'];
};

/**
 * One trial tenant's stewardship snapshot: where it sits against every capped category, how many
 * seats it consumes, and how recently it was used. Read-only and assembled per request — it is not
 * a stored read model.
 */
export type TrialTenantUsage = {
  __typename?: 'TrialTenantUsage';
  /**
   * True when the creation caps do not apply to this tenant, which today means a Migrator trial.
   * Every effective cap is then absent; this flag says WHY, so the grid can render "exempt" instead
   * of a blank cap it has to explain.
   */
  capsExempt: Scalars['Boolean']['output'];
  /**
   * One entry per capped category — always all of them, in a stable order, so the grid can bind a
   * fixed column set.
   */
  categories: Array<TrialCategoryUsage>;
  /**
   * A cheap freshness signal, NOT an activity system: the most recent order initialization timestamp
   * for the tenant, absent when it has never created an order. Orders were chosen because they are
   * the one high-signal tenant artifact already indexed so that "newest first" costs nothing.
   */
  lastActivity?: Maybe<Scalars['DateTime']['output']>;
  /** The tenant's display name, so the grid needs no second lookup. */
  name: Scalars['String']['output'];
  /**
   * Seats consumed: provisioned users PLUS still-pending invites. Deliberately the same number as
   * the seats entry in the categories list (it is read from it, not counted again) — surfaced as its
   * own field because seats are a headline grid column and should not require the client to search
   * the category list.
   */
  seats?: Maybe<Scalars['Long']['output']>;
  /**
   * Per-site child-location counts, for the drawer. One entry per site that has at least one child;
   * a site with no children is omitted rather than reported as zero. The per-site child category
   * reports the MAXIMUM across these, because that cap is per-site and the worst site is the one
   * that will hit it first.
   */
  siteChildCounts: Array<TrialSiteChildUsage>;
  /** The tenant this snapshot describes. */
  tenantId: Scalars['String']['output'];
  /**
   * When an administrator recorded the expired trial's data as deleted; absent when no deletion has
   * been stamped. Separates "expired, data still present" from "expired and cleaned up".
   */
  trialDataDeletedDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * When the trial expires. Always present here — its presence is what selected the tenant into this
   * query at all.
   */
  trialExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The kind the trial actually runs under. Resolved, never absent: a tenant with no stamped kind
   * reports Standard, the restrictive default every enforcement path already applies to it.
   * Consumers must not re-derive this.
   */
  trialKind: TrialKind;
};

/** Input for unassignCountAssignment. */
export type UnassignCountAssignmentInput = {
  assignmentId: Scalars['String']['input'];
  idempotentKey: Scalars['String']['input'];
};

export type UnassignMaterialItemToVendorInput = {
  id: Scalars['String']['input'];
  vendorId: Scalars['String']['input'];
};

/** GraphQL input for unassignTask. The assignee source is set by the server, never the client. */
export type UnassignTaskInput = {
  taskAssignmentId: Scalars['String']['input'];
};

/**
 * What a customer owes on orders that have SHIPPED but that nobody has billed yet — money the goods are
 * out for that is not yet an invoice. Reported beside the accounts receivable and never inside it: it
 * is in no balance, no aging bucket and no statement closing balance until an invoice is issued for it,
 * and from that instant it is the invoice's.
 */
export type UnbilledExposure = {
  __typename?: 'UnbilledExposure';
  /**
   * What the shipped, unbilled orders are owed: each order's total less every deposit and payment
   * recorded against it by the as-of date, and less what was paid by then on a bill of the order that has
   * since been voided, summed. A deposit such a voided bill moved to the customer's unapplied credit is the
   * credit's, which arBalance nets, so it is not subtracted here as well. Signed — an order paid beyond its
   * total reads negative. NOT part of arBalance or of any aging bucket.
   */
  amount: Scalars['Decimal']['output'];
  /** How many shipped orders stood unbilled at the as-of date. */
  orderCount: Scalars['Int']['output'];
};

/** One receipt on an order's payment ledger that its live invoice does not hold. */
export type UncarriedOrderReceipt = {
  __typename?: 'UncarriedOrderReceipt';
  /** The cash the entry recorded. */
  amount: Scalars['Decimal']['output'];
  /** The entry's currency. */
  currency: Scalars['String']['output'];
  /** The live invoice that lacks it. */
  invoiceId: Scalars['String']['output'];
  /** The invoice's number. */
  invoiceNumber: Scalars['String']['output'];
  /** Whether the ledger entry is a payment or a deposit. */
  kind: OrderPaymentKind;
  /** The order whose ledger holds the receipt. */
  orderId: Scalars['String']['output'];
  /** The order's number. */
  orderNumber: Scalars['String']['output'];
  /**
   * Why the invoice lacks it: APPLIED means carryOrderReceiptsToInvoice would record it now; any other
   * outcome is why the repair would hold it back.
   */
  reason: OrderReceiptCarryOutcome;
  /** When the money was received. */
  receivedDate: Scalars['DateTime']['output'];
  /** Whether the entry was recorded in FULFILL or imported from the accounting platform. */
  source: OrderPaymentSource;
  /** The receipt's identity, which is the reference it would carry on the invoice. */
  transactionRef: Scalars['String']['output'];
};

/** Input for the uncarried-order-receipts detector. */
export type UncarriedOrderReceiptsInput = {
  /**
   * Where to resume: the nextAfterInvoiceId of the previous call. Leave it out to start at the
   * beginning.
   */
  afterInvoiceId?: InputMaybe<Scalars['String']['input']>;
  /**
   * How many live invoices to check in this call. Defaults to 200 and is capped at 1000, because each invoice
   * costs two stream reads.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** What one detector call found. */
export type UncarriedOrderReceiptsResult = {
  __typename?: 'UncarriedOrderReceiptsResult';
  /** How many live invoices this call checked. */
  invoicesChecked: Scalars['Int']['output'];
  /** The cursor for the next call; null when this call reached the end of the tenant's live invoices. */
  nextAfterInvoiceId?: Maybe<Scalars['String']['output']>;
  /** Every receipt missing from its live invoice, in invoice then ledger order. */
  uncarried: Array<UncarriedOrderReceipt>;
};

export type UndeleteItemCharacteristicInput = {
  itemCharacteristicId: Scalars['String']['input'];
};

export type UndeleteItemCharacteristicValueInput = {
  itemCharacteristicId: Scalars['String']['input'];
  valueId: Scalars['String']['input'];
};

export type UndeleteMaterialItemInput = {
  materialItemId: Scalars['String']['input'];
};

export type UndeleteProductionCatalogInput = {
  productionCatalogId: Scalars['String']['input'];
};

export type UndeleteTagColorInput = {
  tagColorId: Scalars['String']['input'];
};

export type UndeleteVendorInput = {
  id: Scalars['String']['input'];
};

export type UndoConsolidationApplicationInput = {
  applicationId: Scalars['String']['input'];
};

export type UndoDeliveryCompletionInput = {
  loadId: Scalars['String']['input'];
};

export type UndoFernieGapFillInput = {
  undoToken: Scalars['String']['input'];
};

export type UndoFernieGapFillPayload = {
  __typename?: 'UndoFernieGapFillPayload';
  errors?: Maybe<Array<Error>>;
  jobId?: Maybe<Scalars['String']['output']>;
  restored: Scalars['Int']['output'];
};

export type UndoLoadDispatchInput = {
  loadId: Scalars['String']['input'];
};

export type UndoRestockSessionOrderQuantityOverrideInput = {
  items: Array<RestockOrderQuantityOverrideItemDataInput>;
  sessionId: Scalars['String']['input'];
};

export type UnlinkFusionAuthUserInput = {
  userId: Scalars['String']['input'];
};

/** Input for unlinking one or more production items from their sales items. */
export type UnlinkProductionItemsFromSalesItemInput = {
  productionItemIds: Array<Scalars['String']['input']>;
};

export type UnlinkRampBillFromPurchaseOrderInput = {
  rampBillId: Scalars['String']['input'];
};

export type UnlinkVendorFromRampVendorInput = {
  vendorId: Scalars['String']['input'];
};

/** Releases a pinned run back to normal retention. */
export type UnpinQaTestRunInput = {
  /** The run id (ADO build number or local run id). */
  id: Scalars['String']['input'];
};

export enum UnpooledReason {
  CustomerDisabled = 'CUSTOMER_DISABLED',
  NotDiscountable = 'NOT_DISCOUNTABLE',
  NoPool = 'NO_POOL',
  OverridePrice = 'OVERRIDE_PRICE',
  Unknown = 'UNKNOWN'
}

export type UnsetDefaultGroupInput = {
  id: Scalars['String']['input'];
};

/** Unsets one route's delivery-schedule mapping. */
export type UnsetRouteDeliveryScheduleInput = {
  routeCode: Scalars['String']['input'];
};

export type UnshareReportInput = {
  granteeEmail?: InputMaybe<Scalars['String']['input']>;
  granteeKind: ReportGranteeKind;
  reportId: Scalars['String']['input'];
};

export type UnshipOrderInput = {
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type UnsubscribeWhatsNewEmailInput = {
  token: Scalars['String']['input'];
};

export type UnsubscribeWhatsNewEmailPayload = {
  __typename?: 'UnsubscribeWhatsNewEmailPayload';
  errors?: Maybe<Array<ValidationError>>;
  /** True once the address is unsubscribed (also when it already was). */
  unsubscribed: Scalars['Boolean']['output'];
};

export type UpdateAcknowledgedQuantityDataInput = {
  acknowledgedQuantity?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateAcknowledgedQuantityItemsInput = {
  expectedRevision?: InputMaybe<Scalars['Long']['input']>;
  items: Array<UpdateAcknowledgedQuantityDataInput>;
  orderId: Scalars['String']['input'];
};

export type UpdateAcknowledgedQuantityMasterItemsInput = {
  masterItems: Array<UpdateMasterAcknowledgedQuantityDataInput>;
  masterOrderId: Scalars['String']['input'];
};

export type UpdateAcknowledgmentEmailInput = {
  emailAddress: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateAllocationTemplateInput = {
  allocationType: AllocationType;
  equalizeWeeksOfSupply: Scalars['Boolean']['input'];
  favorHigherWeight: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  mode: AllocationMode;
  name: Scalars['String']['input'];
  priorities: Array<AllocationPriorityDimension>;
  targetWeeksOfSupply?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateAsyncImportJobStatusInput = {
  asyncImportJobId: Scalars['String']['input'];
  status: AsyncImportJobStatus;
};

export type UpdateBillingAddressInput = {
  customerId: Scalars['String']['input'];
  newAddress: CreateAddressInput;
};

export type UpdateBlockingRuleInput = {
  blockingRuleId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for updating the tenant-level business time zone setting. */
export type UpdateBusinessTimeZoneInput = {
  businessTimeZone: Scalars['String']['input'];
};

export type UpdateCartInput = {
  billToAddressCity: Scalars['String']['input'];
  billToAddressCountry: Scalars['String']['input'];
  billToAddressId: Scalars['String']['input'];
  billToAddressLine1: Scalars['String']['input'];
  billToAddressLine2: Scalars['String']['input'];
  billToAddressStateProvince: Scalars['String']['input'];
  billToAddressToName: Scalars['String']['input'];
  billToAddressZipcode: Scalars['String']['input'];
  cartId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  expectedDeliveryDate: Scalars['DateTime']['input'];
  shipToAddressCity: Scalars['String']['input'];
  shipToAddressCountry: Scalars['String']['input'];
  shipToAddressId: Scalars['String']['input'];
  shipToAddressLine1: Scalars['String']['input'];
  shipToAddressLine2: Scalars['String']['input'];
  shipToAddressStateProvince: Scalars['String']['input'];
  shipToAddressToName: Scalars['String']['input'];
  shipToAddressZipcode: Scalars['String']['input'];
  shopperEmail: Scalars['String']['input'];
  shopperFirstName: Scalars['String']['input'];
  shopperId: Scalars['String']['input'];
  shopperLastName: Scalars['String']['input'];
  shopperPhone: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type UpdateCategoryInput = {
  category: CategoryDataInput;
};

export type UpdateConfigCategoryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  configCategoryId: Scalars['String']['input'];
  defaultSizeUomCode: Scalars['String']['input'];
  eachesPerUnit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  ownSizeUom?: InputMaybe<OwnSizeUomDataInput>;
};

export type UpdateConfirmationEmailInput = {
  emailAddress: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateContactInput = {
  contact: ContactDataInput;
  customerId: Scalars['String']['input'];
};

export type UpdateContainerConfigDetailsInput = {
  categoryCode: Scalars['String']['input'];
  containerCode: Scalars['String']['input'];
  containerConfigId: Scalars['String']['input'];
  /** null = preserve, "" = clear. */
  containerName?: InputMaybe<Scalars['String']['input']>;
  /** null = preserve. */
  depth?: InputMaybe<Scalars['Decimal']['input']>;
  /** null = preserve. */
  height?: InputMaybe<Scalars['Decimal']['input']>;
  maxLayersPerContainer: Scalars['Int']['input'];
  maxTraysPerLayer: Scalars['Int']['input'];
  /** null = preserve, "" = clear link, id = set. */
  parentContainerConfigId?: InputMaybe<Scalars['String']['input']>;
  /** null = preserve. */
  shipFactor?: InputMaybe<Scalars['Int']['input']>;
  shipIncrement?: InputMaybe<Scalars['Int']['input']>;
  /** null = preserve. */
  shipMinimum?: InputMaybe<Scalars['Int']['input']>;
  /** null = preserve, [] = clear, values = replace. Every provided site must exist and be active. */
  siteCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** null = preserve, "" = clear. */
  sizeUomCode?: InputMaybe<Scalars['String']['input']>;
  /** null with a null weightUnit = preserve. A weight needs weightUnit POUNDS or KILOGRAMS. At most 2 decimals, never rounded. */
  weight?: InputMaybe<Scalars['Decimal']['input']>;
  /** null = preserve. UNKNOWN with no weight clears the weight. POUNDS or KILOGRAMS require a weight. */
  weightUnit?: InputMaybe<WeightUnit>;
  /** null = preserve. */
  width?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateCustomerGroupHoldProductionInput = {
  holdProduction: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type UpdateCustomerGroupInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCustomerItemAdditionalSkusInput = {
  additionalSkus: Array<Scalars['String']['input']>;
  customerItemId: Scalars['String']['input'];
};

export type UpdateCustomerItemAdditionalUpcsInput = {
  additionalUpcs: Array<Scalars['String']['input']>;
  customerItemId: Scalars['String']['input'];
};

export type UpdateCustomerItemInput = {
  customerItemId: Scalars['String']['input'];
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveUntil?: InputMaybe<Scalars['DateTime']['input']>;
  isDefault: Scalars['Boolean']['input'];
  program?: InputMaybe<Scalars['String']['input']>;
  retailShelfPrice?: InputMaybe<Scalars['Decimal']['input']>;
  retailShelfPriceCurrency?: InputMaybe<Scalars['String']['input']>;
  shippingConfigCategoryCode?: InputMaybe<Scalars['String']['input']>;
  sizeUomCode?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerLocationOrderAddressEditPermissionsInput = {
  allowOrderBillingAddressEdit: Scalars['Boolean']['input'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['input'];
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type UpdateCustomerLocationSendInvoiceEmailsInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  sendInvoiceEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCustomerLocationSendOrderEmailsInput = {
  customerId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  sendOrderEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCustomerOrderAddressEditPermissionsInput = {
  allowOrderBillingAddressEdit: Scalars['Boolean']['input'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['input'];
  customerId: Scalars['String']['input'];
};

export type UpdateCustomerSendInvoiceEmailsInput = {
  customerId: Scalars['String']['input'];
  sendInvoiceEmails: Scalars['Boolean']['input'];
};

export type UpdateCustomerSendOrderEmailsInput = {
  customerId: Scalars['String']['input'];
  sendOrderEmails: Scalars['Boolean']['input'];
};

export type UpdateCustomerTypeInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  revenueGlAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerUpgradeInput = {
  customerId: Scalars['String']['input'];
  upgrade: CustomerUpgradeDataInput;
};

/** Input for updating the tenant-level default freight charge. */
export type UpdateDefaultFreightChargeInput = {
  defaultFreightChargeType?: InputMaybe<FreightChargeType>;
  defaultFreightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Input for setting or clearing the tenant default minimum freight charge. */
export type UpdateDefaultMinimumFreightChargeInput = {
  /** true removes the minimum, which is what a blanked input sends. Cannot be combined with a value. */
  clearDefaultMinimumFreightCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum to set. Omitted leaves it unchanged. */
  defaultMinimumFreightCharge?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateDefaultOrderSubmitterInput = {
  customerId: Scalars['String']['input'];
  orderSubmitter: OrderSubmitterDataInput;
};

export type UpdateDefaultWeeksOfSupplyInput = {
  defaultWeeksOfSupply: Scalars['Decimal']['input'];
};

export type UpdateDeliveryScheduleLocationsInput = {
  deliveryScheduleId: Scalars['String']['input'];
  locationIds: Array<Scalars['String']['input']>;
};

export type UpdateDestinationConfigDataInput = {
  connectionString?: InputMaybe<Scalars['String']['input']>;
  destinationId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  schemaName: Scalars['String']['input'];
  scriptTimeout: Scalars['String']['input'];
  sqlAfterScript?: InputMaybe<Scalars['String']['input']>;
  sqlBeforeScript?: InputMaybe<Scalars['String']['input']>;
  sqlColumns: Array<SqlColumnMapDataInput>;
  tableName: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdateDocumentRenderModeInput = {
  docType: RenderDocType;
  renderMode: RenderMode;
};

export type UpdateErpAvailabilityItemInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  erpItemId: Scalars['String']['input'];
  inTransitQty: Scalars['Int']['input'];
  locationName: Scalars['String']['input'];
  mustGoQuantity: Scalars['Int']['input'];
  productGroup: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  stationCode: Scalars['String']['input'];
  upc: Scalars['String']['input'];
};

export type UpdateErpIdInput = {
  erpId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateErpLoadListQuantitiesInput = {
  quantities: Array<UpdateErpLoadListQuantityInput>;
  sessionId: Scalars['String']['input'];
};

export type UpdateErpLoadListQuantityInput = {
  containerCode: Scalars['String']['input'];
  containerUtilization: Scalars['Decimal']['input'];
  erpItemId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  routeCode: Scalars['String']['input'];
  upc: Scalars['String']['input'];
};

export type UpdateErpLoadListSessionItemAvailabilityInput = {
  items: Array<UpdateErpAvailabilityItemInput>;
  sessionId: Scalars['String']['input'];
};

export type UpdateErpLoadListSessionNameInput = {
  sessionId: Scalars['String']['input'];
  sessionName: Scalars['String']['input'];
};

export type UpdateErpLoadListSessionRoutesInput = {
  routes: Array<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};

export type UpdateErpLoadListSessionShipDateInput = {
  sessionId: Scalars['String']['input'];
  shipDate: Scalars['DateTime']['input'];
};

export type UpdateErpManagerEmailsInput = {
  emails: Array<ErpManagerEmailDataInput>;
};

export type UpdateFavoritesListInput = {
  description: Scalars['String']['input'];
  favoritesListId: Scalars['String']['input'];
  items: Array<FavoritesListItemDataInput>;
  name: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['Int']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFernieSuggestionsOnInput = {
  fernieSuggestionsOn: Scalars['Boolean']['input'];
};

export type UpdateFinalCreditEnabledInput = {
  finalCreditEnabled: Scalars['Boolean']['input'];
};

export type UpdateFlatChargeTypeInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  taxable: Scalars['Boolean']['input'];
};

export type UpdateForecastInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  forecastId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  programIds: Array<Scalars['String']['input']>;
  scenarioSlot: ForecastScenarioSlot;
  startDate: Scalars['DateTime']['input'];
  weeklyMetric: ForecastWeeklyMetric;
};

export type UpdateImageUrlInput = {
  imageUrl: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
};

export type UpdateImportRowImportResultsInput = {
  asyncImportJobId: Scalars['String']['input'];
  results: Array<RowImportResultInput>;
};

export type UpdateImportRowValidationResultsInput = {
  asyncImportJobId: Scalars['String']['input'];
  results: Array<RowValidationResultInput>;
};

/** Changes the forwarding settings. */
export type UpdateInboundDocumentSettingsInput = {
  /** True to reply to the person who forwarded a document. */
  replyToForwarder: Scalars['Boolean']['input'];
};

export type UpdateInvoicingSettingsInput = {
  emailInvoiceOnIssue: Scalars['Boolean']['input'];
  invoicingMode: InvoicingMode;
};

export type UpdateItemAttributesInput = {
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  defaultShippingConfigCategoryCode?: InputMaybe<Scalars['String']['input']>;
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic: Scalars['Boolean']['input'];
  itemId: Scalars['String']['input'];
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  native?: InputMaybe<Scalars['Boolean']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingConfigCategoryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  stripeTaxCode?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: Scalars['Boolean']['input'];
  usedForRetail: Scalars['Boolean']['input'];
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateItemCharacteristicInput = {
  expected?: InputMaybe<ExpectedItemCharacteristicDataInput>;
  itemCharacteristicId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type UpdateItemCharacteristicValueInput = {
  expected?: InputMaybe<ExpectedItemCharacteristicValueDataInput>;
  itemCharacteristicId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
  valueId: Scalars['String']['input'];
};

export type UpdateItemInput = {
  categories: Array<ItemCategoryAssignmentDataInput>;
  cogs?: InputMaybe<Scalars['Decimal']['input']>;
  commissionable?: InputMaybe<Scalars['Boolean']['input']>;
  containerConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultCarrier?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  erpId?: Scalars['String']['input'];
  genus?: InputMaybe<Scalars['String']['input']>;
  heightInches?: InputMaybe<Scalars['Decimal']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemGroup?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['String']['input'];
  itemLookupCode?: InputMaybe<Scalars['String']['input']>;
  lengthInches?: InputMaybe<Scalars['Decimal']['input']>;
  loadFactor?: InputMaybe<Scalars['Decimal']['input']>;
  minShipQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  native?: InputMaybe<Scalars['Boolean']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  retailPrice?: InputMaybe<Scalars['Decimal']['input']>;
  royalty?: InputMaybe<RoyaltyConfigInput>;
  shippingIncrement?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  subcategory?: InputMaybe<Scalars['String']['input']>;
  substitution?: InputMaybe<SubstitutionInput>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  usedForRetail?: InputMaybe<Scalars['Boolean']['input']>;
  weightLbs?: InputMaybe<Scalars['Decimal']['input']>;
  widthInches?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateItemUpgradeInput = {
  itemId: Scalars['String']['input'];
  upgrade: ItemUpgradeDataInput;
};

export type UpdateKitInput = {
  containerCode: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  kitId: Scalars['String']['input'];
  lines: Array<KitLineDataInput>;
  name: Scalars['String']['input'];
  /** @deprecated Ignored. Send siteIds to set the Sites a kit is limited to. */
  siteId?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type UpdateLineItemContainerCodeDataInput = {
  containerCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateLineItemContextNoteInput = {
  context: NoteContext;
  lineItemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type UpdateLineItemInput = {
  lineItem: LineItemUpdateDataInput;
  lineNumber: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
  prorateAcknowledgedToNewQuantity?: Scalars['Boolean']['input'];
};

export type UpdateLineItemNoteInput = {
  lineItemId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type UpdateLineItemsContainerCodeInput = {
  items: Array<UpdateLineItemContainerCodeDataInput>;
  orderId: Scalars['String']['input'];
};

export type UpdateLocationAddressInput = {
  address: CreateAddressInput;
  locationId: Scalars['String']['input'];
};

export type UpdateLocationInput = {
  customerId: Scalars['String']['input'];
  location: CreateCustomerLocationInput;
};

export type UpdateLocationNameInput = {
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateMasterAcknowledgedQuantityDataInput = {
  acknowledgedQuantity?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateMasterConfirmationEmailInput = {
  emailAddress: Scalars['String']['input'];
  masterOrderId: Scalars['String']['input'];
};

export type UpdateMasterLineItemInput = {
  lineItem: MasterLineItemUpdateDataInput;
  lineNumber: Scalars['Int']['input'];
  masterOrderId: Scalars['String']['input'];
};

export type UpdateMasterOrderContactInput = {
  contact: MasterOrderContactDataInput;
  masterOrderId: Scalars['String']['input'];
};

export type UpdateMasterOrderSalesPersonInput = {
  emailAddress: Scalars['String']['input'];
  masterOrderId: Scalars['String']['input'];
};

export type UpdateMasterOrderStatusInput = {
  masterOrderId: Scalars['String']['input'];
  status: MasterOrderStatus;
};

export type UpdateMaterialItemDetailsInput = {
  accountingId?: InputMaybe<Scalars['String']['input']>;
  base64Image?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  erpId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMaxDiscountPercentageInput = {
  maxDiscountPercentage: Scalars['Decimal']['input'];
};

export type UpdateMissingItemGroupsInput = {
  orderId: Scalars['String']['input'];
};

export type UpdateMissingMasterItemGroupsInput = {
  masterOrderId: Scalars['String']['input'];
};

export type UpdateMongoDestinationConfigDataInput = {
  aggregation?: InputMaybe<MongoAggregationConfigDataInput>;
  collectionName: Scalars['String']['input'];
  connectionString?: InputMaybe<Scalars['String']['input']>;
  databaseName: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  mongoColumns: Array<MongoColumnMapDataInput>;
};

export type UpdateOnlineInvoicePaymentsEnabledInput = {
  onlineInvoicePaymentsEnabled: Scalars['Boolean']['input'];
};

export type UpdateOrderAcknowledgementReportInput = {
  orderAcknowledgementReportId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderAddressEditPermissionsInput = {
  allowOrderBillingAddressEdit: Scalars['Boolean']['input'];
  allowOrderLocationAddressEdit: Scalars['Boolean']['input'];
};

export type UpdateOrderBillingAddressInput = {
  billingAddress: AddressDataInput;
  customerId: Scalars['String']['input'];
  locationId: Scalars['UUID']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateOrderContactInput = {
  contact: OrderContactDataInput;
  orderId: Scalars['String']['input'];
};

/** Input to updateOrderDeliveryDate: the order and its new expected delivery date. */
export type UpdateOrderDeliveryDateInput = {
  /** The new expected delivery date, validated as editOrder validates it. */
  expectedDeliveryDate: Scalars['DateTime']['input'];
  /** The order to change. */
  orderId: Scalars['String']['input'];
};

export type UpdateOrderEmailsEnabledInput = {
  enabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrderInvoiceReportInput = {
  orderInvoiceReportId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderLocationAddressInput = {
  customerId: Scalars['String']['input'];
  locationAddress: AddressDataInput;
  locationId: Scalars['UUID']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateOrderProFormaReportInput = {
  orderProFormaReportId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderPullSlipReportInput = {
  orderPullSlipReportId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderSendInvoiceEmailsInput = {
  orderId: Scalars['String']['input'];
  sendInvoiceEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrderSendOrderEmailsInput = {
  orderId: Scalars['String']['input'];
  sendOrderEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrderStatusInput = {
  dateUpdatedOverride?: InputMaybe<Scalars['DateTime']['input']>;
  orderId: Scalars['String']['input'];
  status: OrderStatus;
};

export type UpdateOrganicReceiveModeInput = {
  organicReceiveMode: OrganicReceiveMode;
};

export type UpdateParentCompanyInput = {
  name: Scalars['String']['input'];
  parentCompanyId: Scalars['String']['input'];
  primaryContact: ContactDataInput;
};

export type UpdatePaymentProcessorInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  onlinePaymentMaxAmount: Scalars['Long']['input'];
};

/** Input for updating the tenant-configured PO-number max length. */
export type UpdatePoNumberMaxLengthInput = {
  poNumberMaxLength: Scalars['Int']['input'];
};

export type UpdatePortalSettingsInput = {
  availabilityLocationId?: InputMaybe<Scalars['String']['input']>;
  availabilityMinGrade?: InputMaybe<Scalars['Int']['input']>;
  availabilityReportId?: InputMaybe<Scalars['String']['input']>;
  availabilitySource?: InputMaybe<AvailabilitySource>;
  buyerContactEditingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  buyerRetailPriceEditingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  catalogChipSource?: InputMaybe<CatalogChipSource>;
  catalogDisplayMode: CatalogDisplayMode;
  companySlug?: InputMaybe<Scalars['String']['input']>;
  deliveryBlackouts?: InputMaybe<Array<PortalDeliveryBlackoutDataInput>>;
  includeSellableHardGoods?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount: Scalars['Decimal']['input'];
  orderCutoffLeadDays?: InputMaybe<Scalars['Int']['input']>;
  orderCutoffTime?: InputMaybe<Scalars['String']['input']>;
  orderCutoffTimeZoneId?: InputMaybe<Scalars['String']['input']>;
  portalAutoAcknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  portalAutoAllocate?: InputMaybe<Scalars['Boolean']['input']>;
  portalAutoAllocateStrategy?: InputMaybe<PortalAutoAllocateStrategy>;
  portalCheckoutOrderStatus?: InputMaybe<PortalCheckoutOrderStatus>;
  portalEnabled: Scalars['Boolean']['input'];
  portalMaxDaysOut?: InputMaybe<Scalars['Int']['input']>;
  prePricingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  preferAvailabilityImage?: InputMaybe<Scalars['Boolean']['input']>;
  priceLabels?: InputMaybe<Array<PortalPriceLabelInput>>;
  selfRegistrationEnabled: Scalars['Boolean']['input'];
  showGradeOnPortal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePortalUserInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  portalUserId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userType: UserType;
};

export type UpdatePriceGroupInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdatePriceLevelsInput = {
  priceGroupId: Scalars['String']['input'];
  priceLevels: Array<PriceLevelInputDataInput>;
  replaceAllLevels?: Scalars['Boolean']['input'];
};

/** Input for updating the tenant-level pricing calculation decimals setting. */
export type UpdatePricingCalcDecimalsInput = {
  pricingCalcDecimals: Scalars['Int']['input'];
};

export type UpdateProduceAutoLinkMatchingNumbersInput = {
  enabled: Scalars['Boolean']['input'];
};

export type UpdateProduceDefaultReliefPercentInput = {
  produceDefaultReliefPercent: Scalars['Decimal']['input'];
};

export type UpdateProduceEnabledInput = {
  produceEnabled: Scalars['Boolean']['input'];
};

export type UpdateProducePlanFromOrderAccessInput = {
  producePlanFromOrderAccess: ProducePlanFromOrderAccess;
};

export type UpdateProducePlanningEntryUnitInput = {
  producePlanningEntryUnit: ProducePlanningEntryUnit;
};

export type UpdateProduceProductionEntryReviewInput = {
  produceProductionEntryReview: Scalars['Boolean']['input'];
};

export type UpdateProduceQuantityDecimalsInput = {
  produceQuantityDecimals: Scalars['Int']['input'];
};

export type UpdateProduceRoundingInput = {
  produceRounding: ProduceRoundingMode;
};

export type UpdateProduceSpaceConsumptionBasisInput = {
  produceSpaceConsumptionBasis: ProduceSpaceConsumptionBasis;
};

export type UpdateProduceSpacingDimensionUnitInput = {
  produceSpacingDimensionUnit: ProduceSpacingDimensionUnit;
};

export type UpdateProduceWeekDisplayAnchorInput = {
  produceWeekDisplayAnchor: ProduceWeekDisplayAnchor;
};

/**
 * The new values for an existing production catalog entry. An omitted origin or farm field keeps its stored
 * value, and null or an empty list clears it.
 */
export type UpdateProductionCatalogInput = {
  /** The alternate farms, active vendors of this tenant. Omit them to keep the stored list, or send an empty list to clear it. */
  alternateFarmVendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  color: Scalars['String']['input'];
  /** The default farm, an active vendor of this tenant. Omit it to keep the stored farm, or send null to clear it. */
  defaultFarmVendorId?: InputMaybe<Scalars['String']['input']>;
  genus: Scalars['String']['input'];
  /** The propagation origin. Omit it to keep the stored origin, or send null to clear it. */
  origin?: InputMaybe<ProductionCatalogOrigin>;
  productionCatalogId: Scalars['String']['input'];
  series: Scalars['String']['input'];
};

export type UpdateProductionCategoryDetailsInput = {
  code: Scalars['String']['input'];
  eaches: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  productionCategoryId: Scalars['String']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
};

export type UpdateProductionItemInput = {
  productionCatalogId: Scalars['String']['input'];
  productionCategoryId: Scalars['String']['input'];
  productionItemId: Scalars['String']['input'];
  productionItemNumber: Scalars['String']['input'];
};

export type UpdateProductionJobLocationDataInput = {
  locationId: Scalars['String']['input'];
  productionJobId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type UpdateProductionJobLocationInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  updates: Array<UpdateProductionJobLocationDataInput>;
};

export type UpdateProductionJobLocationPayload = {
  __typename?: 'UpdateProductionJobLocationPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
};

export type UpdateProductionLineInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  deviceIds: Array<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  productionLineId: Scalars['String']['input'];
};

/**
 * Input for user corrections to row values. Used when user fixes validation errors.
 * Clears any previously resolved IDs since lookups must be re-performed.
 */
export type UpdateProductionLotAsyncImportJobRowsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<ProductionLotImportRowValuesInput>;
};

export type UpdateProductionLotCustomerDataInput = {
  customerId: Scalars['String']['input'];
  productionLotId: Scalars['String']['input'];
};

export type UpdateProductionLotCustomerInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  updates: Array<UpdateProductionLotCustomerDataInput>;
};

export type UpdateProductionLotCustomerPayload = {
  __typename?: 'UpdateProductionLotCustomerPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
};

export type UpdateProductionLotPlanDataInput = {
  productionLotId: Scalars['String']['input'];
  productionPlanId: Scalars['String']['input'];
};

export type UpdateProductionLotPlanInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  updates: Array<UpdateProductionLotPlanDataInput>;
};

export type UpdateProductionLotPlanPayload = {
  __typename?: 'UpdateProductionLotPlanPayload';
  errors?: Maybe<Array<ValidationError>>;
  productionLots?: Maybe<Array<ProductionLotStateData>>;
};

export type UpdateProductionMaterialEventDetailInput = {
  detail: AddProductionMaterialEventDetailsDataInput;
  productionMaterialEventId: Scalars['String']['input'];
};

export type UpdateProductionMaterialEventInput = {
  name: Scalars['String']['input'];
  productionMaterialEventId: Scalars['String']['input'];
};

export type UpdateProductionPlanDetailsInput = {
  name: Scalars['String']['input'];
  productionPlanId: Scalars['String']['input'];
};

export type UpdateProductionRecipeVariationFieldsInput = {
  customerGroupId?: InputMaybe<ProductionRecipeVariationIdChangeDataInput>;
  customerId?: InputMaybe<ProductionRecipeVariationIdChangeDataInput>;
  growWeeks?: InputMaybe<ProductionRecipeVariationWholeNumberChangeDataInput>;
  plantsPerPot?: InputMaybe<ProductionRecipeVariationWholeNumberChangeDataInput>;
  productionRecipeId: Scalars['String']['input'];
  siteLocationId?: InputMaybe<ProductionRecipeVariationIdChangeDataInput>;
  variationId: Scalars['String']['input'];
  weekRange?: InputMaybe<ProductionRecipeVariationWeekRangeChangeDataInput>;
  yield?: InputMaybe<ProductionRecipeVariationDecimalChangeDataInput>;
};

export type UpdateProductionRecipeVariationInput = {
  productionRecipeId: Scalars['String']['input'];
  variation: ProductionRecipeVariationDataInput;
};

export type UpdateProductionSpaceCategoryDetailsInput = {
  code: Scalars['String']['input'];
  length: Scalars['Decimal']['input'];
  productionSpaceCategoryId: Scalars['String']['input'];
  stagger?: Scalars['Boolean']['input'];
  width: Scalars['Decimal']['input'];
};

export type UpdateProductionSpaceEventDetailInput = {
  detail: AddProductionSpaceEventDetailsDataInput;
  productionSpaceEventId: Scalars['String']['input'];
};

export type UpdateProductionSpaceEventInput = {
  name: Scalars['String']['input'];
  productionSpaceEventId: Scalars['String']['input'];
};

export type UpdateProductionSpaceTypeDetailsInput = {
  code: Scalars['String']['input'];
  productionSpaceTypeId: Scalars['String']['input'];
};

export type UpdateProductionTaskEventAssigneeInput = {
  defaultAssignedTo?: InputMaybe<Scalars['String']['input']>;
  productionItemId: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type UpdateProductionTaskEventDetailDataInput = {
  description: Scalars['String']['input'];
  materialItemId?: InputMaybe<Scalars['String']['input']>;
  multiple: Scalars['Decimal']['input'];
  productionTaskEventDetailId: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  taskEventTypeId: Scalars['String']['input'];
  triggerId: Scalars['String']['input'];
};

export type UpdateProductionTaskEventDetailInput = {
  detail: UpdateProductionTaskEventDetailDataInput;
  productionTaskEventId: Scalars['String']['input'];
};

export type UpdateProductionTaskEventInput = {
  name: Scalars['String']['input'];
  productionTaskEventId: Scalars['String']['input'];
};

export type UpdateProductionTriggerInput = {
  expireBy?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  productionTriggerId: Scalars['String']['input'];
  source: ProductionTriggerSource;
  unit: ProductionTriggerUnit;
};

export type UpdatePromotionRuleInput = {
  description: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  promotionRuleId: Scalars['String']['input'];
  quantityFloor: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type UpdatePublicScoreResult = {
  __typename?: 'UpdatePublicScoreResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  newScore: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdatePurchaseOrderReportInput = {
  purchaseOrderReportId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportInput = {
  craftJsTemplate: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  expectedVersion?: InputMaybe<Scalars['Long']['input']>;
  filters: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
  handlebarsTemplate: Scalars['String']['input'];
  isStarred: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pageSettings: Scalars['String']['input'];
  parameterConfig: Scalars['String']['input'];
  parameterValues: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
  spreadsheetColumns?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportScheduleInput = {
  clearReportTemplateId?: InputMaybe<Scalars['Boolean']['input']>;
  cronExpression: Scalars['String']['input'];
  docType?: InputMaybe<OrderEmailDocType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive: Scalars['Boolean']['input'];
  lastRunAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  nextRunAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  outputFormat: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
  reportTemplateId?: InputMaybe<Scalars['String']['input']>;
  runOnce: Scalars['Boolean']['input'];
  scheduleId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeZoneId: Scalars['String']['input'];
};

export type UpdateReportTemplateInput = {
  category: Scalars['String']['input'];
  craftJsTemplate: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  handlebarsTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  tags: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export type UpdateReserveRuleInput = {
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  level: ReserveRuleLevel;
  linkedItemIds: Array<Scalars['String']['input']>;
  linkedLocationIds: Array<Scalars['String']['input']>;
  mode: ReserveRuleMode;
  name: Scalars['String']['input'];
  percentage: Scalars['Decimal']['input'];
  reserveRuleId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type UpdateRestockSessionInput = {
  sessionId: Scalars['String']['input'];
  sessionName: Scalars['String']['input'];
  shipDate: Scalars['DateTime']['input'];
  targetWeeksOfSupply: Scalars['Decimal']['input'];
};

export type UpdateRestockSessionOrderItemInput = {
  achievableQuantity: Scalars['Int']['input'];
  allocatedValue: Scalars['Decimal']['input'];
  available: Scalars['Int']['input'];
  availableValue: Scalars['Decimal']['input'];
  blockingRuleIds: Array<Scalars['String']['input']>;
  carts: Scalars['Decimal']['input'];
  customerLocationId: Scalars['String']['input'];
  daysSinceLastDelivery: Scalars['Int']['input'];
  daysSinceLastSale: Scalars['Int']['input'];
  demandQuantity: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  inTransit: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
  itemNumber: Scalars['String']['input'];
  orderQuantity: Scalars['Int']['input'];
  promotionRuleIds: Array<Scalars['String']['input']>;
  storeName: Scalars['String']['input'];
  trailingSales: Scalars['Decimal']['input'];
  unitValue: Scalars['Decimal']['input'];
  unitsOnHand: Scalars['Int']['input'];
  unitsOnHandValue: Scalars['Decimal']['input'];
  unitsReplenished: Scalars['Int']['input'];
  weeksOfSupply: Scalars['Decimal']['input'];
};

export type UpdateRestockSessionOrderQuantitiesInput = {
  items: Array<UpdateRestockSessionOrderItemInput>;
  sessionId: Scalars['String']['input'];
};

export type UpdateRestockSessionReserveRulesInput = {
  rules: Array<RestockReserveRuleDataInput>;
  sessionId: Scalars['String']['input'];
};

export type UpdateRetailPriceInput = {
  itemId: Scalars['String']['input'];
  retailPrice: Scalars['Decimal']['input'];
};

export type UpdateRouteInput = {
  orderId: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSalesPersonInput = {
  emailAddress: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type UpdateSftpAggregationConfigInput = {
  aggregation?: InputMaybe<MongoAggregationConfigDataInput>;
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
};

export type UpdateSftpDestinationInput = {
  configId: Scalars['String']['input'];
  destination: UpdateDestinationConfigDataInput;
  destinationId: Scalars['String']['input'];
};

export type UpdateSftpMongoColumnMapInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  mongoColumns: Array<MongoColumnMapDataInput>;
};

export type UpdateSftpMongoDestinationInput = {
  configId: Scalars['String']['input'];
  destination: UpdateMongoDestinationConfigDataInput;
  destinationId: Scalars['String']['input'];
};

export type UpdateSftpSqlColumnMapInput = {
  configId: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  sqlColumns: Array<SqlColumnMapDataInput>;
};

export type UpdateSftpSystemSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  timerPeriodString: Scalars['String']['input'];
};

export type UpdateSftpTenantConfigInput = {
  batchSize: Scalars['Int']['input'];
  configId: Scalars['String']['input'];
  configName: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  podId: Scalars['String']['input'];
  sourceDirectory: Scalars['String']['input'];
  sourceEndpoint: Scalars['String']['input'];
  sourceFilePattern: Scalars['String']['input'];
  sourcePassword?: InputMaybe<Scalars['String']['input']>;
  sourcePort: Scalars['Int']['input'];
  sourceType: Scalars['String']['input'];
  sourceUsername: Scalars['String']['input'];
};

export type UpdateShippedQuantityDataInput = {
  id: Scalars['UUID']['input'];
  shippedQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateShippedQuantityItemsInput = {
  dateShippedOverride?: InputMaybe<Scalars['DateTime']['input']>;
  items: Array<UpdateShippedQuantityDataInput>;
  orderId: Scalars['String']['input'];
};

/**
 * Input for user corrections to row values. Used when user fixes validation errors.
 * Clears any previously resolved IDs since lookups must be re-performed.
 */
export type UpdateSiteLocationAsyncImportJobRowsInput = {
  asyncImportJobId: Scalars['String']['input'];
  rows: Array<SiteLocationImportRowValuesInput>;
};

export type UpdateSiteMapInput = {
  excludeFromDistribution: Scalars['Boolean']['input'];
  siteLocationId: Scalars['String']['input'];
  siteMapId: Scalars['String']['input'];
};

export type UpdateSizeUomInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  eachesPerUnit: Scalars['Int']['input'];
};

export type UpdateStatementDeliverySettingsInput = {
  deliveryMethod: StatementDeliveryMethod;
  skipZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateStockByCustomerItemSettingsInput = {
  breakStockOutByCustomerItem: Scalars['Boolean']['input'];
  confirmedReleaseQuantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateSubLocationInput = {
  erpId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  locationType: SiteLocationType;
  name: Scalars['String']['input'];
  parentLocationId?: InputMaybe<Scalars['String']['input']>;
  pickSequence?: InputMaybe<Scalars['Int']['input']>;
  siteLocationId: Scalars['String']['input'];
};

export type UpdateSyncAttemptInput = {
  attemptDate: Scalars['DateTime']['input'];
  erpId?: InputMaybe<Scalars['String']['input']>;
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
};

export type UpdateTagColorInput = {
  expected?: InputMaybe<TagColorValuesInput>;
  name: Scalars['String']['input'];
  onHold: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
  tagColorId: Scalars['String']['input'];
};

export type UpdateTaskEventTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reducesSellableStock?: InputMaybe<Scalars['Boolean']['input']>;
  taskEventTypeId: Scalars['String']['input'];
};

export type UpdateTenantAutoAllocateExcludedGradesInput = {
  grades: Array<Scalars['Int']['input']>;
};

export type UpdateTenantBrandingInput = {
  displayName: Scalars['String']['input'];
  logoImage?: InputMaybe<LogoImageDataInput>;
  logoUrl: Scalars['String']['input'];
  palette?: InputMaybe<PortalPaletteDataInput>;
  primaryColorHex: Scalars['String']['input'];
  styleTokens?: InputMaybe<PortalStyleTokensDataInput>;
  tagline: Scalars['String']['input'];
};

export type UpdateTenantCompanyProfileInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantGradeLabelsInput = {
  labels: Array<GradeLabelDataInput>;
};

export type UpdateTenantRestockProviderSettingsInput = {
  rosProviderConfig?: InputMaybe<Scalars['String']['input']>;
  rosProviderKey: Scalars['String']['input'];
};

export type UpdateTenantSignInPanelInput = {
  body: Scalars['String']['input'];
  headline: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  linkLabel: Scalars['String']['input'];
  linkUrl: Scalars['String']['input'];
};

/** Input for updating the per-tenant unit configuration. */
export type UpdateTenantUnitConfigInput = {
  unitConfig: TenantUnitConfigDataInput;
};

export type UpdateTermsIdInput = {
  orderId: Scalars['String']['input'];
  termsId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTermsInput = {
  accrueInterestPercentage: Scalars['Decimal']['input'];
  discountDays?: InputMaybe<Scalars['Int']['input']>;
  financeChargeMonthlyRate?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  maximumAnnualFinanceChargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  termLimitDays: Scalars['Int']['input'];
};

export type UpdateTrackShipmentWeightInput = {
  trackShipmentWeight: Scalars['Boolean']['input'];
};

export type UpdateUseErpPricingInput = {
  useErpPricing: Scalars['Boolean']['input'];
};

export type UpdateUserAppSettingInput = {
  base64Settings: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateUserFullNameInput = {
  fullName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateUserRolesInput = {
  roles: Array<UserRole>;
  userId: Scalars['String']['input'];
};

export type UpdateVendorInput = {
  billingAddress: CreateAddressInput;
  description: Scalars['String']['input'];
  erpId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateVendorPurchaseOrderMetadataInput = {
  needByDate?: InputMaybe<Scalars['LocalDate']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderId: Scalars['String']['input'];
};

export type UpdateVendorPurchaseOrderSiteLocationInput = {
  siteLocationId: Scalars['String']['input'];
  vendorPurchaseOrderId: Scalars['String']['input'];
};

export type UpdateVerifyModeInput = {
  verifyMode: VerifyMode;
};

export type UpdateWorkSuiteProductInput = {
  flags?: InputMaybe<Array<FeatureFlagName>>;
  name?: InputMaybe<Scalars['String']['input']>;
  workSuiteProductId: Scalars['String']['input'];
};

export type UpdateWsapiImportEntityMappingInput = {
  enabled: Scalars['Boolean']['input'];
  entityMappingId: Scalars['String']['input'];
  entityType: WsapiImportEntityType;
  keySourceField: Scalars['String']['input'];
  keyTargetField: Scalars['String']['input'];
  sourceTable: Scalars['String']['input'];
  wsapiImportId: Scalars['String']['input'];
};

export type UpdateWsapiImportScheduleInput = {
  scheduleDayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  scheduleTimeOfDay?: InputMaybe<Scalars['String']['input']>;
  wsapiImportId: Scalars['String']['input'];
};

export type UploadItemImageInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertBillingAddressesInput = {
  billingAddresses: Array<CreateAddressInput>;
  customerId: Scalars['String']['input'];
};

/** How many children of one kind an upsertCustomer call inserted, updated or left unchanged. */
export type UpsertChildCountsData = {
  __typename?: 'UpsertChildCountsData';
  inserted: Scalars['Int']['output'];
  unchanged: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type UpsertContactsInput = {
  combinedCustomerRow?: InputMaybe<CombinedCustomerRowInput>;
  contacts: Array<ContactDataInput>;
  customerId: Scalars['String']['input'];
};

export type UpsertCustomerInput = {
  allowOrderBillingAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderLocationAddressEdit?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<CreateAddressInput>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  combinedCustomerRow?: InputMaybe<CombinedCustomerRowInput>;
  contact?: InputMaybe<ContactDataInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  customerLookupCode?: InputMaybe<Scalars['String']['input']>;
  customerTypeId?: InputMaybe<Scalars['String']['input']>;
  customerTypeName?: InputMaybe<Scalars['String']['input']>;
  defaultDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  erpPriceGroupId?: InputMaybe<Scalars['String']['input']>;
  federalTaxNumber?: InputMaybe<Scalars['String']['input']>;
  freightChargeType?: InputMaybe<FreightChargeType>;
  freightChargeValue?: InputMaybe<Scalars['Decimal']['input']>;
  location?: InputMaybe<CreateCustomerLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderSubmitter?: InputMaybe<OrderSubmitterDataInput>;
  poRequired?: InputMaybe<Scalars['Boolean']['input']>;
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  salesPersonEmail?: InputMaybe<Scalars['String']['input']>;
  synchronizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  taxExemptNumber?: InputMaybe<Scalars['String']['input']>;
  termsId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The result of upsertCustomer: the customer written plus, per child kind, how many of the
 * passed children were inserted, updated or unchanged — so an import summary stays accurate without
 * the caller knowing the stored state. Every field but Errors is null when the call failed.
 */
export type UpsertCustomerPayload = {
  __typename?: 'UpsertCustomerPayload';
  billingAddresses?: Maybe<UpsertChildCountsData>;
  contacts?: Maybe<UpsertChildCountsData>;
  customer?: Maybe<CustomerStateData>;
  errors?: Maybe<Array<ValidationError>>;
  locations?: Maybe<UpsertChildCountsData>;
};

export type UpsertLocationsInput = {
  combinedCustomerRow?: InputMaybe<CombinedCustomerRowInput>;
  customerId: Scalars['String']['input'];
  locations: Array<CreateCustomerLocationInput>;
};

export type UpsertMergeCrmTenantIntegrationInput = {
  accountToken: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
  integrationName?: InputMaybe<Scalars['String']['input']>;
  integrationSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertMergeTenantIntegrationInput = {
  accountToken: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  integrationName?: InputMaybe<Scalars['String']['input']>;
  integrationSlug?: InputMaybe<Scalars['String']['input']>;
  orderExportTriggerStatus?: OrderExportTriggerStatus;
};

export type UpsertMySqlTenantIntegrationInput = {
  database: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UpsertRampBillsInput = {
  /** 1 to 200 rows. Each row replaces every cached Ramp field of that bill; links are never touched. */
  bills: Array<RampBillRowInput>;
};

export type UpsertRampBillsPayload = {
  __typename?: 'UpsertRampBillsPayload';
  errors?: Maybe<Array<ValidationError>>;
  upsertedCount: Scalars['Int']['output'];
};

export type UpsertRampVendorsInput = {
  /** 1 to 200 rows. Each row replaces the cached name and isActive for that Ramp vendor. */
  vendors: Array<RampVendorRowInput>;
};

export type UpsertRampVendorsPayload = {
  __typename?: 'UpsertRampVendorsPayload';
  errors?: Maybe<Array<ValidationError>>;
  upsertedCount: Scalars['Int']['output'];
};

/** Upsert operation result */
export type UpsertRfidScansPayload = {
  __typename?: 'UpsertRfidScansPayload';
  errors?: Maybe<Array<ValidationError>>;
  rfidScans?: Maybe<Array<RfidScanDocument>>;
};

export type UpsertTenantIntegrationInput = {
  accessToken: Scalars['String']['input'];
  accessTokenExpiration: Scalars['DateTime']['input'];
  integrationId: Scalars['String']['input'];
  realmId: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  refreshTokenExpiration: Scalars['DateTime']['input'];
  source: IntegrationSource;
};

export type UpsertTenantPricingPageInput = {
  content: Scalars['String']['input'];
};

/** Time entry input data */
export type UpsertTimeEntryInput = {
  clickUpTaskId: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  entryDate: Scalars['DateTime']['input'];
  hoursWorked: Scalars['Decimal']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  taskTitle: Scalars['String']['input'];
};

export type UpsertTrialPolicyInput = {
  allowedFeatureFlags: Array<FeatureFlagName>;
  defaultLimits: TrialPolicyLimitsDataInput;
  kind: TrialKind;
};

/**
 * What uses a record, grouped by kind. The total is the record's Usage Count, the number its delete is
 * refused on, and the sum of the group totals.
 */
export type UsedBy = {
  __typename?: 'UsedBy';
  /** One group per kind that uses the record; a kind nothing uses is left out. */
  groups: Array<UsedByGroup>;
  /** How many records use this record, including the ones the caller cannot open. */
  total: Scalars['Int']['output'];
};

/**
 * The records of one kind that use a record. Refs lists the ones the caller may open, one page at a time;
 * hidden counts the ones the caller may not open, so every page plus hidden adds up to the total.
 */
export type UsedByGroup = {
  __typename?: 'UsedByGroup';
  /** True when the caller may open more records of this kind than this page lists. */
  hasMore: Scalars['Boolean']['output'];
  /** How many of them the caller may not open; these are counted, never listed. */
  hidden: Scalars['Int']['output'];
  /** The kind of every record in the group. */
  kind: RecordKind;
  /** This page of the records the caller may open. */
  refs: Array<UsedByRef>;
  /** How many records of this kind use the record. */
  total: Scalars['Int']['output'];
};

/** One record that uses another. */
export type UsedByRef = {
  __typename?: 'UsedByRef';
  /** The record's id, as the record's own queries take it. */
  id: Scalars['String']['output'];
  /** The record's kind. */
  kind: RecordKind;
  /** The record's name, or the name of the record it belongs to when it has none. */
  name: Scalars['String']['output'];
  /**
   * The record this one opens under, such as a ship-to's customer or a price level's price group; null when
   * the record opens on its own.
   */
  parent?: Maybe<UsedByRef>;
  /** The record's status, as its own status field reads; null when the kind has none. */
  status?: Maybe<Scalars['String']['output']>;
};

export type UserAppSettingData = {
  __typename?: 'UserAppSettingData';
  appSettingsId: Scalars['String']['output'];
  base64Settings: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  group: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type UserAppSettingDocument = {
  __typename?: 'UserAppSettingDocument';
  appSettingsId: Scalars['String']['output'];
  base64Settings: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  group: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type UserAppSettingDocumentFilterInput = {
  and?: InputMaybe<Array<UserAppSettingDocumentFilterInput>>;
  appSettingsId?: InputMaybe<StringOperationFilterInput>;
  base64Settings?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserAppSettingDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
};

export type UserAppSettingDocumentSortInput = {
  appSettingsId?: InputMaybe<SortEnumType>;
  base64Settings?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  emailAddress?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type UserAppSettingPayload = {
  __typename?: 'UserAppSettingPayload';
  errors?: Maybe<Array<ValidationError>>;
  setting?: Maybe<UserAppSettingData>;
};

/** A connection to a list of items. */
export type UserAppSettingsConnection = {
  __typename?: 'UserAppSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserAppSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserAppSettingDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserAppSettingsEdge = {
  __typename?: 'UserAppSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserAppSettingDocument;
};

/**
 * A user in the tenant's directory. The user's roles are the source of truth for
 * business-level access (Sales, Sales Manager, Admin, etc.); the FusionAuth link is
 * optional and only present when the user has a login.
 */
export type UserDocument = {
  __typename?: 'UserDocument';
  /**
   * The PRECOMPUTED resolved customer access scope for this user — the ready-to-inject filter value
   * the query layer reads directly (B2/C2/C3) instead of recomputing per request. A non-empty set
   * limits the user to those customers; an EMPTY list means "no limit — sees all". Written from the
   * UserCustomersAssigned event and mirrors a portal user's legacy single customerId,
   * so exactly one field carries the resolved scope. (C1 adds sibling site/location scope fields for
   * the expanded access model; this field remains the customer-id scope.)
   */
  assignedCustomerIds: Array<Scalars['String']['output']>;
  /**
   * The PRECOMPUTED resolved route access scope for this user (D2) — the ready-to-inject filter
   * value the query layer reads directly (D3) instead of recomputing per request. A non-empty set
   * limits the user to those routes; an EMPTY list means "no limit — sees all". Written from the
   * UserRoutesAssigned event. There is no legacy predecessor for this axis, so existing
   * users correctly default to an empty (unrestricted) list — no backfill required.
   */
  assignedRoutes: Array<Scalars['String']['output']>;
  /**
   * The site/location NODE ids this user is scoped to (each a site or a location node). Empty
   * means "no site limit" — the user sees all sites. Access is parent-and-below: assigning a node
   * grants that node and every descendant. Defaults to empty for existing users that predate this
   * field — which correctly means "no limit" for this brand-new axis (no migration required).
   */
  assignedSiteIds: Array<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  /** The customer this user is scoped to, or null for internal staff. */
  customerId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  /** The linked FusionAuth user id, or null when the user has no login. */
  fusionAuthUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**
   * The missing-data warnings this user chose to ignore, each for one record or for every warning of
   * its code. Ignoring hides a warning from this user only.
   */
  ignoredMissingData: Array<IgnoredMissingData>;
  /**
   * The user's language preference for the Work Suite UI, defaulting to EN.
   *
   * UNLIKE the list-typed AssignedRoutes axis (where an ABSENT array and an EXPLICIT
   * empty array read identically), an absent enum key here is NOT interchangeable with its C#
   * default at the query layer: getUsers carries [UseFiltering]/
   * [UseSorting], and this field is mapped to a literal BSON string via
   * BsonRepresentation(BsonType.String), so a filter like
   * languagePreference: { eq: EN } compiles to a literal Mongo
   * { LanguagePreference: { $eq: "EN" } } match — which does NOT match a document where
   * the key is missing entirely. The C# member-initializer default only helps SINGLE-document
   * reads (me, getUser) that deserialize a doc lacking the key; it does nothing
   * for a query-layer filter/sort evaluated by MongoDB itself.
   *
   *
   * The field is therefore always PHYSICALLY PRESENT on disk: the projection service's
   * ApplyCreated handler seeds it via SetOnInsert(..., LanguagePreference.EN) on
   * every go-forward user creation, and the one-time migration
   * worksuiteuser-languagepreference-backfill-v1 (k8s/migration-scripts/, gated
   * per the MongoDB pipeline-gated K8s Job migration practice) backfills the literal string
   * "EN" onto every WorkSuiteUsers document that predates this field, before the deploy
   * that adds it. Only after that backfill does "default EN when unset" hold for
   * filtering/sorting, not just single-document reads.
   */
  languagePreference: LanguagePreference;
  /**
   * The most recent moment this user was recorded as active in WorkSuite (day-granularity), or
   * null if they have never triggered an activity heartbeat. Stamped by
   * recordUserActivity via a direct read-model update -- not event-sourced, and unrelated to
   * lastModified, which tracks edits to the directory record itself, not the user's own
   * presence.
   */
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The moment this user last AUTHENTICATED, sourced from FusionAuth's own lastLoginInstant
   * and synced by the wsapi-services UserLastLoginSyncWorker via the
   * recordUserLastLogins mutation -- a direct read-model write, not event-sourced (login is an
   * external FusionAuth fact, not a WorkSuiteUser aggregate decision). null means the
   * user has never logged in, or has not yet been synced.
   *
   * A THIRD, distinct fact from its two neighbours: UNLIKE lastActiveAt (an in-app
   * presence/activity heartbeat, day-granularity, hourly-throttled, stamped by
   * recordUserActivity), this is authentication, not presence. UNLIKE lastModified
   * (edits to the directory record itself), this tracks the user's own sign-in, not changes to their
   * record. Never reuse, rename, or fold into either.
   */
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastModified: Scalars['DateTime']['output'];
  /**
   * Whether this user's FusionAuth login currently has any multi-factor method enabled. Stamped by
   * the myMultiFactor* surface via a direct read-model write -- not event-sourced, because
   * enrollment is an external FusionAuth fact rather than a WorkSuiteUser aggregate decision,
   * exactly like LastLoginAt. false for a user who has never enrolled, and for
   * one who has no FusionAuth login at all.
   */
  multiFactorEnabled: Scalars['Boolean']['output'];
  /**
   * The FusionAuth multi-factor methods currently enabled on this user's login -- today always
   * empty or ["authenticator"], since the deployed Community edition offers no other factor.
   */
  multiFactorMethods: Array<Scalars['String']['output']>;
  /** How this user's notification email is paced — immediate, or one daily digest. */
  notificationEmailDeliveryMode: NotificationDeliveryMode;
  /**
   * Whether this user has opted in to notification email. Defaults to false, as do the SMS
   * and push flags beside it: every outbound notification channel is opt-in, so a user who has never
   * saved preferences is silent on all three. The in-app bell has no flag here — it is always on at
   * the channel level and can only be muted per notification kind.
   */
  notificationEmailEnabled: Scalars['Boolean']['output'];
  /**
   * The sparse per-kind channel matrix — only the kinds this user deliberately differentiated. A
   * kind that is absent follows the channel flags above, so a new notification kind reaches everyone
   * on their existing settings. Empty for a user who has never saved.
   */
  notificationKindOverrides: Array<NotificationKindPreferenceData>;
  /**
   * Whether this user has opted in to Web Push notifications, delivered through the PWA's service
   * worker. Defaults to false — opt-in, like every outbound channel.
   */
  notificationPushEnabled: Scalars['Boolean']['output'];
  /**
   * Reserved forward-compatibility slot for SMS pacing. Texts are always sent immediately no matter
   * what this holds; it exists so enabling SMS batching later needs no change to the stored shape.
   * Defaults to immediate.
   */
  notificationSmsDeliveryMode: NotificationDeliveryMode;
  /**
   * Whether this user has opted in to notification SMS. Defaults to false — opt-in, like
   * every outbound channel. Independent of whether a phone number is on file.
   */
  notificationSmsEnabled: Scalars['Boolean']['output'];
  /**
   * When the outstanding verification code expires, or null when no exchange is pending
   * or its expiry is unknown for a legacy read model.
   */
  pendingPhoneExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The number a verification code is currently outstanding for, or null when no exchange is
   * in flight. For the settings page to show which handset it is waiting on.
   */
  pendingPhoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The E.164 number the SMS channel texts, or null when the user has not supplied one.
   * Independent of the SMS flag: saving a number does not switch SMS on, and switching SMS off does
   * not discard the number.
   */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this user has completed a phone-verification exchange. It is the SMS channel's consent
   * gate: with this false, an ordinary SMS notification is resolved Skipped rather than sent, however
   * the channel switch and the per-kind matrix are set.
   */
  phoneNumberVerified: Scalars['Boolean']['output'];
  /**
   * What this user may see in the customer portal. Meaningful only for a portal user; every other user
   * reads the defaults.
   */
  portalPermissions: PortalUserPermissions;
  /**
   * The user's profile picture, stored as the relative, content-addressed blob path the avatar
   * storage writes (or null when none is set). The UserDocumentType resolver composes this
   * into an absolute public URL at query time via UserImageBlobOptions.PublicBaseUrl, so the
   * GraphQL profileImageUrl field always returns a fully-qualified URL.
   */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  roles: Array<UserRole>;
  /**
   * When the carrier stopped delivering to VerifiedPhoneNumber because that handset
   * replied STOP, or null when it is carrying normally. A CARRIER block, not a preference.
   */
  smsCarrierBlockedAt?: Maybe<Scalars['DateTime']['output']>;
  status: UserStatus;
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  /**
   * The E.164 number that completed the verification exchange, or null when none has. The
   * only address an ordinary SMS notification is ever sent to.
   */
  verifiedPhoneNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * A user in the tenant's directory. The user's roles are the source of truth for
 * business-level access (Sales, Sales Manager, Admin, etc.); the FusionAuth link is
 * optional and only present when the user has a login.
 */
export type UserDocumentFilterInput = {
  and?: InputMaybe<Array<UserDocumentFilterInput>>;
  /**
   * The PRECOMPUTED resolved customer access scope for this user — the ready-to-inject filter value
   * the query layer reads directly (B2/C2/C3) instead of recomputing per request. A non-empty set
   * limits the user to those customers; an EMPTY list means "no limit — sees all". Written from the
   * UserCustomersAssigned event and mirrors a portal user's legacy single customerId,
   * so exactly one field carries the resolved scope. (C1 adds sibling site/location scope fields for
   * the expanded access model; this field remains the customer-id scope.)
   */
  assignedCustomerIds?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * The PRECOMPUTED resolved route access scope for this user (D2) — the ready-to-inject filter
   * value the query layer reads directly (D3) instead of recomputing per request. A non-empty set
   * limits the user to those routes; an EMPTY list means "no limit — sees all". Written from the
   * UserRoutesAssigned event. There is no legacy predecessor for this axis, so existing
   * users correctly default to an empty (unrestricted) list — no backfill required.
   */
  assignedRoutes?: InputMaybe<ListStringOperationFilterInput>;
  /**
   * The site/location NODE ids this user is scoped to (each a site or a location node). Empty
   * means "no site limit" — the user sees all sites. Access is parent-and-below: assigning a node
   * grants that node and every descendant. Defaults to empty for existing users that predate this
   * field — which correctly means "no limit" for this brand-new axis (no migration required).
   */
  assignedSiteIds?: InputMaybe<ListStringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** The customer this user is scoped to, or null for internal staff. */
  customerId?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  /** The linked FusionAuth user id, or null when the user has no login. */
  fusionAuthUserId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The user's language preference for the Work Suite UI, defaulting to EN.
   *
   * UNLIKE the list-typed AssignedRoutes axis (where an ABSENT array and an EXPLICIT
   * empty array read identically), an absent enum key here is NOT interchangeable with its C#
   * default at the query layer: getUsers carries [UseFiltering]/
   * [UseSorting], and this field is mapped to a literal BSON string via
   * BsonRepresentation(BsonType.String), so a filter like
   * languagePreference: { eq: EN } compiles to a literal Mongo
   * { LanguagePreference: { $eq: "EN" } } match — which does NOT match a document where
   * the key is missing entirely. The C# member-initializer default only helps SINGLE-document
   * reads (me, getUser) that deserialize a doc lacking the key; it does nothing
   * for a query-layer filter/sort evaluated by MongoDB itself.
   *
   *
   * The field is therefore always PHYSICALLY PRESENT on disk: the projection service's
   * ApplyCreated handler seeds it via SetOnInsert(..., LanguagePreference.EN) on
   * every go-forward user creation, and the one-time migration
   * worksuiteuser-languagepreference-backfill-v1 (k8s/migration-scripts/, gated
   * per the MongoDB pipeline-gated K8s Job migration practice) backfills the literal string
   * "EN" onto every WorkSuiteUsers document that predates this field, before the deploy
   * that adds it. Only after that backfill does "default EN when unset" hold for
   * filtering/sorting, not just single-document reads.
   */
  languagePreference?: InputMaybe<LanguagePreferenceOperationFilterInput>;
  /**
   * The most recent moment this user was recorded as active in WorkSuite (day-granularity), or
   * null if they have never triggered an activity heartbeat. Stamped by
   * recordUserActivity via a direct read-model update -- not event-sourced, and unrelated to
   * lastModified, which tracks edits to the directory record itself, not the user's own
   * presence.
   */
  lastActiveAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The moment this user last AUTHENTICATED, sourced from FusionAuth's own lastLoginInstant
   * and synced by the wsapi-services UserLastLoginSyncWorker via the
   * recordUserLastLogins mutation -- a direct read-model write, not event-sourced (login is an
   * external FusionAuth fact, not a WorkSuiteUser aggregate decision). null means the
   * user has never logged in, or has not yet been synced.
   *
   * A THIRD, distinct fact from its two neighbours: UNLIKE lastActiveAt (an in-app
   * presence/activity heartbeat, day-granularity, hourly-throttled, stamped by
   * recordUserActivity), this is authentication, not presence. UNLIKE lastModified
   * (edits to the directory record itself), this tracks the user's own sign-in, not changes to their
   * record. Never reuse, rename, or fold into either.
   */
  lastLoginAt?: InputMaybe<DateTimeOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * Whether this user's FusionAuth login currently has any multi-factor method enabled. Stamped by
   * the myMultiFactor* surface via a direct read-model write -- not event-sourced, because
   * enrollment is an external FusionAuth fact rather than a WorkSuiteUser aggregate decision,
   * exactly like LastLoginAt. false for a user who has never enrolled, and for
   * one who has no FusionAuth login at all.
   */
  multiFactorEnabled?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The FusionAuth multi-factor methods currently enabled on this user's login -- today always
   * empty or ["authenticator"], since the deployed Community edition offers no other factor.
   */
  multiFactorMethods?: InputMaybe<ListStringOperationFilterInput>;
  /** How this user's notification email is paced — immediate, or one daily digest. */
  notificationEmailDeliveryMode?: InputMaybe<NotificationDeliveryModeOperationFilterInput>;
  /**
   * Whether this user has opted in to notification email. Defaults to false, as do the SMS
   * and push flags beside it: every outbound notification channel is opt-in, so a user who has never
   * saved preferences is silent on all three. The in-app bell has no flag here — it is always on at
   * the channel level and can only be muted per notification kind.
   */
  notificationEmailEnabled?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The sparse per-kind channel matrix — only the kinds this user deliberately differentiated. A
   * kind that is absent follows the channel flags above, so a new notification kind reaches everyone
   * on their existing settings. Empty for a user who has never saved.
   */
  notificationKindOverrides?: InputMaybe<ListFilterInputTypeOfNotificationKindPreferenceDataFilterInput>;
  /**
   * Whether this user has opted in to Web Push notifications, delivered through the PWA's service
   * worker. Defaults to false — opt-in, like every outbound channel.
   */
  notificationPushEnabled?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Reserved forward-compatibility slot for SMS pacing. Texts are always sent immediately no matter
   * what this holds; it exists so enabling SMS batching later needs no change to the stored shape.
   * Defaults to immediate.
   */
  notificationSmsDeliveryMode?: InputMaybe<NotificationDeliveryModeOperationFilterInput>;
  /**
   * Whether this user has opted in to notification SMS. Defaults to false — opt-in, like
   * every outbound channel. Independent of whether a phone number is on file.
   */
  notificationSmsEnabled?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<UserDocumentFilterInput>>;
  /**
   * When the outstanding verification code expires, or null when no exchange is pending
   * or its expiry is unknown for a legacy read model.
   */
  pendingPhoneExpiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The number a verification code is currently outstanding for, or null when no exchange is
   * in flight. For the settings page to show which handset it is waiting on.
   */
  pendingPhoneNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * The E.164 number the SMS channel texts, or null when the user has not supplied one.
   * Independent of the SMS flag: saving a number does not switch SMS on, and switching SMS off does
   * not discard the number.
   */
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * Whether this user has completed a phone-verification exchange. It is the SMS channel's consent
   * gate: with this false, an ordinary SMS notification is resolved Skipped rather than sent, however
   * the channel switch and the per-kind matrix are set.
   */
  phoneNumberVerified?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * The user's profile picture, stored as the relative, content-addressed blob path the avatar
   * storage writes (or null when none is set). The UserDocumentType resolver composes this
   * into an absolute public URL at query time via UserImageBlobOptions.PublicBaseUrl, so the
   * GraphQL profileImageUrl field always returns a fully-qualified URL.
   */
  profileImageUrl?: InputMaybe<StringOperationFilterInput>;
  roles?: InputMaybe<ListUserRoleOperationFilterInput>;
  /**
   * When the carrier stopped delivering to VerifiedPhoneNumber because that handset
   * replied STOP, or null when it is carrying normally. A CARRIER block, not a preference.
   */
  smsCarrierBlockedAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<UserStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  /**
   * The E.164 number that completed the verification exchange, or null when none has. The
   * only address an ordinary SMS notification is ever sent to.
   */
  verifiedPhoneNumber?: InputMaybe<StringOperationFilterInput>;
};

/**
 * A user in the tenant's directory. The user's roles are the source of truth for
 * business-level access (Sales, Sales Manager, Admin, etc.); the FusionAuth link is
 * optional and only present when the user has a login.
 */
export type UserDocumentSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  /** The customer this user is scoped to, or null for internal staff. */
  customerId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  /** The linked FusionAuth user id, or null when the user has no login. */
  fusionAuthUserId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The user's language preference for the Work Suite UI, defaulting to EN.
   *
   * UNLIKE the list-typed AssignedRoutes axis (where an ABSENT array and an EXPLICIT
   * empty array read identically), an absent enum key here is NOT interchangeable with its C#
   * default at the query layer: getUsers carries [UseFiltering]/
   * [UseSorting], and this field is mapped to a literal BSON string via
   * BsonRepresentation(BsonType.String), so a filter like
   * languagePreference: { eq: EN } compiles to a literal Mongo
   * { LanguagePreference: { $eq: "EN" } } match — which does NOT match a document where
   * the key is missing entirely. The C# member-initializer default only helps SINGLE-document
   * reads (me, getUser) that deserialize a doc lacking the key; it does nothing
   * for a query-layer filter/sort evaluated by MongoDB itself.
   *
   *
   * The field is therefore always PHYSICALLY PRESENT on disk: the projection service's
   * ApplyCreated handler seeds it via SetOnInsert(..., LanguagePreference.EN) on
   * every go-forward user creation, and the one-time migration
   * worksuiteuser-languagepreference-backfill-v1 (k8s/migration-scripts/, gated
   * per the MongoDB pipeline-gated K8s Job migration practice) backfills the literal string
   * "EN" onto every WorkSuiteUsers document that predates this field, before the deploy
   * that adds it. Only after that backfill does "default EN when unset" hold for
   * filtering/sorting, not just single-document reads.
   */
  languagePreference?: InputMaybe<SortEnumType>;
  /**
   * The most recent moment this user was recorded as active in WorkSuite (day-granularity), or
   * null if they have never triggered an activity heartbeat. Stamped by
   * recordUserActivity via a direct read-model update -- not event-sourced, and unrelated to
   * lastModified, which tracks edits to the directory record itself, not the user's own
   * presence.
   */
  lastActiveAt?: InputMaybe<SortEnumType>;
  /**
   * The moment this user last AUTHENTICATED, sourced from FusionAuth's own lastLoginInstant
   * and synced by the wsapi-services UserLastLoginSyncWorker via the
   * recordUserLastLogins mutation -- a direct read-model write, not event-sourced (login is an
   * external FusionAuth fact, not a WorkSuiteUser aggregate decision). null means the
   * user has never logged in, or has not yet been synced.
   *
   * A THIRD, distinct fact from its two neighbours: UNLIKE lastActiveAt (an in-app
   * presence/activity heartbeat, day-granularity, hourly-throttled, stamped by
   * recordUserActivity), this is authentication, not presence. UNLIKE lastModified
   * (edits to the directory record itself), this tracks the user's own sign-in, not changes to their
   * record. Never reuse, rename, or fold into either.
   */
  lastLoginAt?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  /**
   * Whether this user's FusionAuth login currently has any multi-factor method enabled. Stamped by
   * the myMultiFactor* surface via a direct read-model write -- not event-sourced, because
   * enrollment is an external FusionAuth fact rather than a WorkSuiteUser aggregate decision,
   * exactly like LastLoginAt. false for a user who has never enrolled, and for
   * one who has no FusionAuth login at all.
   */
  multiFactorEnabled?: InputMaybe<SortEnumType>;
  /** How this user's notification email is paced — immediate, or one daily digest. */
  notificationEmailDeliveryMode?: InputMaybe<SortEnumType>;
  /**
   * Whether this user has opted in to notification email. Defaults to false, as do the SMS
   * and push flags beside it: every outbound notification channel is opt-in, so a user who has never
   * saved preferences is silent on all three. The in-app bell has no flag here — it is always on at
   * the channel level and can only be muted per notification kind.
   */
  notificationEmailEnabled?: InputMaybe<SortEnumType>;
  /**
   * Whether this user has opted in to Web Push notifications, delivered through the PWA's service
   * worker. Defaults to false — opt-in, like every outbound channel.
   */
  notificationPushEnabled?: InputMaybe<SortEnumType>;
  /**
   * Reserved forward-compatibility slot for SMS pacing. Texts are always sent immediately no matter
   * what this holds; it exists so enabling SMS batching later needs no change to the stored shape.
   * Defaults to immediate.
   */
  notificationSmsDeliveryMode?: InputMaybe<SortEnumType>;
  /**
   * Whether this user has opted in to notification SMS. Defaults to false — opt-in, like
   * every outbound channel. Independent of whether a phone number is on file.
   */
  notificationSmsEnabled?: InputMaybe<SortEnumType>;
  /**
   * When the outstanding verification code expires, or null when no exchange is pending
   * or its expiry is unknown for a legacy read model.
   */
  pendingPhoneExpiresAt?: InputMaybe<SortEnumType>;
  /**
   * The number a verification code is currently outstanding for, or null when no exchange is
   * in flight. For the settings page to show which handset it is waiting on.
   */
  pendingPhoneNumber?: InputMaybe<SortEnumType>;
  /**
   * The E.164 number the SMS channel texts, or null when the user has not supplied one.
   * Independent of the SMS flag: saving a number does not switch SMS on, and switching SMS off does
   * not discard the number.
   */
  phoneNumber?: InputMaybe<SortEnumType>;
  /**
   * Whether this user has completed a phone-verification exchange. It is the SMS channel's consent
   * gate: with this false, an ordinary SMS notification is resolved Skipped rather than sent, however
   * the channel switch and the per-kind matrix are set.
   */
  phoneNumberVerified?: InputMaybe<SortEnumType>;
  /**
   * The user's profile picture, stored as the relative, content-addressed blob path the avatar
   * storage writes (or null when none is set). The UserDocumentType resolver composes this
   * into an absolute public URL at query time via UserImageBlobOptions.PublicBaseUrl, so the
   * GraphQL profileImageUrl field always returns a fully-qualified URL.
   */
  profileImageUrl?: InputMaybe<SortEnumType>;
  /**
   * When the carrier stopped delivering to VerifiedPhoneNumber because that handset
   * replied STOP, or null when it is carrying normally. A CARRIER block, not a preference.
   */
  smsCarrierBlockedAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  /**
   * The E.164 number that completed the verification exchange, or null when none has. The
   * only address an ordinary SMS notification is ever sent to.
   */
  verifiedPhoneNumber?: InputMaybe<SortEnumType>;
};

export type UserInviteDocument = {
  __typename?: 'UserInviteDocument';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** Customer scope for a portal invite; empty for a staff/tenant invite. */
  customerId: Scalars['String']['output'];
  emailError: Scalars['String']['output'];
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  emailStatus: Scalars['Int']['output'];
  error: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  expiresInDays: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  fusionAuthUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inviteId: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** WorkSuiteUser auto-linked on completion; empty when the invite is unlinked. */
  linkedUserId: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  /**
   * True when the acceptance that completed this invite found the FusionAuth login locked and
   * reactivated it first; false for every other invite.
   */
  reactivatedLogin: Scalars['Boolean']['output'];
  recipientEmail: Scalars['String']['output'];
  registrations: Array<UserInviteRegistrationDocumentData>;
  resentAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the invited user is a customer (portal) or tenant (staff) user. */
  userType: UserType;
};

export type UserInviteDocumentFilterInput = {
  acceptedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<UserInviteDocumentFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /** Customer scope for a portal invite; empty for a staff/tenant invite. */
  customerId?: InputMaybe<StringOperationFilterInput>;
  emailError?: InputMaybe<StringOperationFilterInput>;
  emailSentAt?: InputMaybe<DateTimeOperationFilterInput>;
  emailStatus?: InputMaybe<IntOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  expiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  expiresInDays?: InputMaybe<IntOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fusionAuthUserId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inviteId?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  /** WorkSuiteUser auto-linked on completion; empty when the invite is unlinked. */
  linkedUserId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserInviteDocumentFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  /**
   * True when the acceptance that completed this invite found the FusionAuth login locked and
   * reactivated it first; false for every other invite.
   */
  reactivatedLogin?: InputMaybe<BooleanOperationFilterInput>;
  recipientEmail?: InputMaybe<StringOperationFilterInput>;
  registrations?: InputMaybe<ListFilterInputTypeOfUserInviteRegistrationDocumentDataFilterInput>;
  resentAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  usedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Whether the invited user is a customer (portal) or tenant (staff) user. */
  userType?: InputMaybe<UserTypeOperationFilterInput>;
};

export type UserInviteDocumentSortInput = {
  acceptedAt?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  /** Customer scope for a portal invite; empty for a staff/tenant invite. */
  customerId?: InputMaybe<SortEnumType>;
  emailError?: InputMaybe<SortEnumType>;
  emailSentAt?: InputMaybe<SortEnumType>;
  emailStatus?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  expiresAt?: InputMaybe<SortEnumType>;
  expiresInDays?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fusionAuthUserId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inviteId?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  /** WorkSuiteUser auto-linked on completion; empty when the invite is unlinked. */
  linkedUserId?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  /**
   * True when the acceptance that completed this invite found the FusionAuth login locked and
   * reactivated it first; false for every other invite.
   */
  reactivatedLogin?: InputMaybe<SortEnumType>;
  recipientEmail?: InputMaybe<SortEnumType>;
  resentAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  usedAt?: InputMaybe<SortEnumType>;
  /** Whether the invited user is a customer (portal) or tenant (staff) user. */
  userType?: InputMaybe<SortEnumType>;
};

/**
 * The one thing the registration page should do next for an invitation, decided entirely on the
 * server from the stored invitation, a read-only look at FusionAuth, and the
 * INVITE_SIGN_IN_COMPLETION feature flag. NONE accompanies an unknown code; SET_PASSWORD is the
 * only value that comes with a setup token, and only for a login this invitation's own send
 * created; SIGN_IN_TO_COMPLETE means the invited login already exists and the person finishes by
 * signing in as it; ADMIN_RESEND_REQUIRED means nothing the invitee can do will finish this
 * invitation and an administrator must resend it; RESEND_PENDING means a resend is queued;
 * COMPLETION_PENDING means acceptance is recorded and provisioning is still running; COMPLETE means
 * the invitation is done; CONTACT_ADMINISTRATOR means either provisioning failed or the invited
 * login exists but sign-in completion is switched off for the tenant; TEMPORARILY_UNAVAILABLE means
 * FusionAuth could not be consulted and the page should retry; SET_PASSWORD_FROM_EMAIL means the
 * invitation is for an existing login and its set-password link was emailed to that login's own
 * address, so the page sets the password with the token from that emailed link and never receives
 * one here.
 */
export enum UserInviteNextAction {
  AdminResendRequired = 'ADMIN_RESEND_REQUIRED',
  Complete = 'COMPLETE',
  CompletionPending = 'COMPLETION_PENDING',
  ContactAdministrator = 'CONTACT_ADMINISTRATOR',
  None = 'NONE',
  ResendPending = 'RESEND_PENDING',
  SetPassword = 'SET_PASSWORD',
  /** The set-password link was emailed to the login's owner; this response carries no token. */
  SetPasswordFromEmail = 'SET_PASSWORD_FROM_EMAIL',
  SignInToComplete = 'SIGN_IN_TO_COMPLETE',
  TemporarilyUnavailable = 'TEMPORARILY_UNAVAILABLE'
}

export type UserInvitePayload = {
  __typename?: 'UserInvitePayload';
  errors?: Maybe<Array<ValidationError>>;
  userInvite?: Maybe<UserInviteDocument>;
};

export type UserInviteRegistrationDataInput = {
  applicationId: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']>;
};

/**
 * Document-local registration shape — deliberately separate from the command's
 * UserInviteRegistrationData and the event's InviteRegistrationData per the
 * single-use Data-type convention, so the read model can evolve without breaking either.
 */
export type UserInviteRegistrationDocumentData = {
  __typename?: 'UserInviteRegistrationDocumentData';
  applicationId: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

/**
 * Document-local registration shape — deliberately separate from the command's
 * UserInviteRegistrationData and the event's InviteRegistrationData per the
 * single-use Data-type convention, so the read model can evolve without breaking either.
 */
export type UserInviteRegistrationDocumentDataFilterInput = {
  and?: InputMaybe<Array<UserInviteRegistrationDocumentDataFilterInput>>;
  applicationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserInviteRegistrationDocumentDataFilterInput>>;
  roles?: InputMaybe<ListStringOperationFilterInput>;
};

export enum UserInviteValidity {
  Expired = 'EXPIRED',
  NotFound = 'NOT_FOUND',
  Used = 'USED',
  Valid = 'VALID'
}

/**
 * One FusionAuth user's last-login instant, as read by the wsapi-services
 * UserLastLoginSyncWorker off FusionAuth's lastLoginInstant. fusionAuthUserId is
 * the join key the worker actually has from FusionAuth (not the directory's own userId).
 */
export type UserLastLoginEntryDataInput = {
  fusionAuthUserId: Scalars['String']['input'];
  lastLoginAt: Scalars['DateTime']['input'];
};

export type UserPayload = {
  __typename?: 'UserPayload';
  errors?: Maybe<Array<ValidationError>>;
  user?: Maybe<UserDocument>;
};

export enum UserRole {
  Admin = 'ADMIN',
  EdiManager = 'EDI_MANAGER',
  EdiViewer = 'EDI_VIEWER',
  Finance = 'FINANCE',
  /** @deprecated Retired 2026-10-20: grants nothing and cannot be assigned. Kept only as a stable event-replay ordinal. */
  Maintenance = 'MAINTENANCE',
  /** @deprecated Decision 5: grants no visibility bypass. Read scope is decided by OrderVisibilityScope. Kept as a stable event-replay ordinal + transitional write-side bypass input. */
  NoOrderRestrictions = 'NO_ORDER_RESTRICTIONS',
  /** @deprecated Retired 2026-10-20: grants nothing and cannot be assigned. Kept only as a stable event-replay ordinal. */
  Ops = 'OPS',
  Portal = 'PORTAL',
  ProduceAdmin = 'PRODUCE_ADMIN',
  Production = 'PRODUCTION',
  RestockOrderer = 'RESTOCK_ORDERER',
  Sales = 'SALES',
  SalesManager = 'SALES_MANAGER',
  VerifyDispatcher = 'VERIFY_DISPATCHER',
  VerifyManager = 'VERIFY_MANAGER',
  VerifyScanner = 'VERIFY_SCANNER'
}

export type UserRoleOperationFilterInput = {
  eq?: InputMaybe<UserRole>;
  in?: InputMaybe<Array<UserRole>>;
  neq?: InputMaybe<UserRole>;
  nin?: InputMaybe<Array<UserRole>>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type UserStatusOperationFilterInput = {
  eq?: InputMaybe<UserStatus>;
  in?: InputMaybe<Array<UserStatus>>;
  neq?: InputMaybe<UserStatus>;
  nin?: InputMaybe<Array<UserStatus>>;
};

/** A connection to a list of items. */
export type UserTimeEntriesConnection = {
  __typename?: 'UserTimeEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserTimeEntriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TimeEntryDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserTimeEntriesEdge = {
  __typename?: 'UserTimeEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TimeEntryDocument;
};

export enum UserType {
  Customer = 'CUSTOMER',
  Tenant = 'TENANT'
}

export type UserTypeOperationFilterInput = {
  eq?: InputMaybe<UserType>;
  in?: InputMaybe<Array<UserType>>;
  neq?: InputMaybe<UserType>;
  nin?: InputMaybe<Array<UserType>>;
};

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserDocument;
};

/** How many eaches an item usually sells in on one order line. */
export type UsualLineQuantity = {
  __typename?: 'UsualLineQuantity';
  /** The item asked about. */
  itemId: Scalars['String']['output'];
  /** How many order lines were counted, from 0 to 50. */
  lineCount: Scalars['Int']['output'];
  /** The median eaches of the counted order lines, rounded to a whole number. Null when fewer than 8 lines were counted. */
  usualQuantity?: Maybe<Scalars['Int']['output']>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Result of validateCategoryDocuments: how many staged-summary documents were
 * inserted / updated in Category.Staged.Summary plus per-row validation failures.
 */
export type ValidateCategoryDocumentsResult = {
  __typename?: 'ValidateCategoryDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<CategoryStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * Result of validateCustomerDocuments: how many parent summaries were
 * inserted / updated in Customers.Staged.Summary plus per-row validation
 * failures. The location-collection fan-out is implicit (one delete-and-insert
 * per parent) and not separately reported.
 */
export type ValidateCustomerDocumentsResult = {
  __typename?: 'ValidateCustomerDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<CustomerStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * What validateHistoricalInvoices found in a batch: how many rows would import, and why it would refuse
 * the rest.
 */
export type ValidateHistoricalInvoicesResult = {
  __typename?: 'ValidateHistoricalInvoicesResult';
  /** One error for each row that fails a check. */
  rowErrors: Array<HistoricalInvoiceImportRowError>;
  /** The number of rows that pass every check. */
  valid: Scalars['Int']['output'];
};

/**
 * Result of validateHistoricalOrderDocuments: how many summary documents were inserted /
 * updated in HistoricalOrders.Staged.Summary plus per-row validation failures. The
 * line-item-collection fan-out is implicit (one delete-and-insert per order) and not separately
 * reported.
 */
export type ValidateHistoricalOrderDocumentsResult = {
  __typename?: 'ValidateHistoricalOrderDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<HistoricalOrderStagedRowError>;
  updated: Scalars['Int']['output'];
};

export type ValidateHistoricalOrdersResult = {
  __typename?: 'ValidateHistoricalOrdersResult';
  rowErrors: Array<HistoricalOrderImportRowError>;
  valid: Scalars['Int']['output'];
};

/**
 * Result of validateInventoryItemDocuments: how many inventory summaries were
 * inserted / updated in Inventory.Staged.Summary plus per-row validation
 * failures. The import-command-collection fan-out is a 1:1 sibling and not
 * separately reported. Errors is non-null only when the whole batch was
 * rejected (e.g. the staged collections are locked while the tenant's import
 * worker is running) — nothing was written.
 */
export type ValidateInventoryItemDocumentsResult = {
  __typename?: 'ValidateInventoryItemDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<InventoryItemStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * Result of validateItemsDocuments: how many summary documents were
 * inserted / updated in Items.Staged.Summary plus per-row validation
 * failures. The import-command-collection fan-out is implicit (one upsert
 * per row) and not separately reported. Errors is non-null only when
 * the whole batch was rejected (e.g. the staged collections are locked while
 * the tenant's import worker is running) — nothing was written.
 */
export type ValidateItemsDocumentsResult = {
  __typename?: 'ValidateItemsDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<ItemStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * Result of validatePriceGroupDocuments: how many group summaries were
 * inserted / updated in PriceGroups.Staged.Summary plus per-row validation
 * failures. The levels- and import-command-collection fan-outs are implicit (one
 * replace / one upsert per group) and not separately reported.
 */
export type ValidatePriceGroupDocumentsResult = {
  __typename?: 'ValidatePriceGroupDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<PriceGroupStagedRowError>;
  updated: Scalars['Int']['output'];
};

export type ValidateProductionLotPayload = {
  __typename?: 'ValidateProductionLotPayload';
  errors?: Maybe<Array<ValidationError>>;
  isValid: Scalars['Boolean']['output'];
};

/**
 * Result of validateSiteLocationsDocuments: how many site summaries were
 * inserted / updated in SiteLocations.Staged.Summary plus per-row validation
 * failures. The sub-location and import-command fan-outs are implicit (per parent)
 * and not separately reported.
 */
export type ValidateSiteLocationsDocumentsResult = {
  __typename?: 'ValidateSiteLocationsDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<SiteLocationStagedRowError>;
  updated: Scalars['Int']['output'];
};

/**
 * Result of validateTermsDocuments: how many summary documents were
 * inserted / updated in Terms.Staged.Summary plus per-row validation
 * failures. The import-command-collection fan-out is implicit (one upsert per row)
 * and not separately reported. Errors is non-null only when the whole batch
 * was rejected (e.g. the staged collections are locked while the tenant's import
 * worker is running) — nothing was written.
 */
export type ValidateTermsDocumentsResult = {
  __typename?: 'ValidateTermsDocumentsResult';
  errors?: Maybe<Array<ValidationError>>;
  inserted: Scalars['Int']['output'];
  rowErrors: Array<TermsStagedRowError>;
  updated: Scalars['Int']['output'];
};

export type ValidationError = {
  __typename?: 'ValidationError';
  code?: Maybe<Scalars['String']['output']>;
  /** The kinds of record holding the record whose delete was refused because it is in use, each with its count, largest first. The counts add up to the in-use count the message names. Empty for every other error. */
  inUseBreakdown: Array<InUseCount>;
  message: Scalars['String']['output'];
  /** The id of the record this error names, as the record's own queries take it. Null when recordKind is UNKNOWN. */
  recordId?: Maybe<Scalars['String']['output']>;
  /** The kind of the record this error names, such as the record whose delete was refused because it is in use. UNKNOWN when the error names no record. */
  recordKind: RecordKind;
};

export type ValueColumnInput = {
  aggFunc: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

/** Per-line variance-resolution input for reconcileMovementOrder. */
export type VarianceResolutionInput = {
  countReasonCode: Scalars['Int']['input'];
  lineItemId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  receivedQuantity: Scalars['Decimal']['input'];
  shippedQuantity: Scalars['Decimal']['input'];
};

/** GraphQL projection of a single variance resolution recorded by reconcile. */
export type VarianceResolutionStateData = {
  __typename?: 'VarianceResolutionStateData';
  countReasonCode: Scalars['Int']['output'];
  lineItemId: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  receivedQuantity: Scalars['Decimal']['output'];
  shippedQuantity: Scalars['Decimal']['output'];
};

export type VariationDiffProjection = {
  __typename?: 'VariationDiffProjection';
  assignmentOverrideChanges: Array<AssignmentOverrideChangeProjection>;
  candidateTaskEventsToRegenerate: Array<TaskEventRegenerationCandidateProjection>;
  eventIdChanges: Array<EventIdChangeProjection>;
  scalarFieldChanges: Array<ScalarFieldChangeProjection>;
  variationId: Scalars['String']['output'];
  variationName: Scalars['String']['output'];
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Vehicle, keyed
 * {tenantId}-{vehicleId}. Deleted rows are removed outright (matching the pwa reference
 * slice's hard-delete-from-array semantics).
 */
export type VehicleDocument = {
  __typename?: 'VehicleDocument';
  carrierId?: Maybe<Scalars['String']['output']>;
  hasLiftgate: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isTempControlled: Scalars['Boolean']['output'];
  licensePlate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownership: VehicleOwnership;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  vehicleId: Scalars['String']['output'];
  vehicleTypeId: Scalars['String']['output'];
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Vehicle, keyed
 * {tenantId}-{vehicleId}. Deleted rows are removed outright (matching the pwa reference
 * slice's hard-delete-from-array semantics).
 */
export type VehicleDocumentFilterInput = {
  and?: InputMaybe<Array<VehicleDocumentFilterInput>>;
  carrierId?: InputMaybe<OptionOfStringFilterInput>;
  hasLiftgate?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isTempControlled?: InputMaybe<BooleanOperationFilterInput>;
  licensePlate?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VehicleDocumentFilterInput>>;
  ownership?: InputMaybe<VehicleOwnershipOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  vehicleId?: InputMaybe<StringOperationFilterInput>;
  vehicleTypeId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) Vehicle, keyed
 * {tenantId}-{vehicleId}. Deleted rows are removed outright (matching the pwa reference
 * slice's hard-delete-from-array semantics).
 */
export type VehicleDocumentSortInput = {
  carrierId?: InputMaybe<SortEnumType>;
  hasLiftgate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isTempControlled?: InputMaybe<SortEnumType>;
  licensePlate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  ownership?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  vehicleId?: InputMaybe<SortEnumType>;
  vehicleTypeId?: InputMaybe<SortEnumType>;
};

export enum VehicleOwnership {
  Leased = 'LEASED',
  Owned = 'OWNED',
  Rented = 'RENTED',
  Unknown = 'UNKNOWN'
}

export type VehicleOwnershipOperationFilterInput = {
  eq?: InputMaybe<VehicleOwnership>;
  in?: InputMaybe<Array<VehicleOwnership>>;
  neq?: InputMaybe<VehicleOwnership>;
  nin?: InputMaybe<Array<VehicleOwnership>>;
};

export type VehiclePayload = {
  __typename?: 'VehiclePayload';
  errors?: Maybe<Array<ValidationError>>;
  vehicle?: Maybe<VehicleStateData>;
};

export type VehicleStateData = {
  __typename?: 'VehicleStateData';
  carrierId?: Maybe<Scalars['String']['output']>;
  hasLiftgate: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isTempControlled: Scalars['Boolean']['output'];
  licensePlate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownership: VehicleOwnership;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  vehicleId: Scalars['String']['output'];
  vehicleTypeId: Scalars['String']['output'];
};

/**
 * One capacity-matrix row as read. Isolated document-layer shape (never shared with the
 *             domain or command layer's own line type).
 */
export type VehicleTypeCapacityData = {
  __typename?: 'VehicleTypeCapacityData';
  containerConfigId: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  maxCount: Scalars['Int']['output'];
};

/**
 * One capacity-matrix row as read. Isolated document-layer shape (never shared with the
 *             domain or command layer's own line type).
 */
export type VehicleTypeCapacityDataFilterInput = {
  and?: InputMaybe<Array<VehicleTypeCapacityDataFilterInput>>;
  containerConfigId?: InputMaybe<StringOperationFilterInput>;
  containerName?: InputMaybe<StringOperationFilterInput>;
  maxCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<VehicleTypeCapacityDataFilterInput>>;
};

export type VehicleTypeCapacityDataInput = {
  containerConfigId: Scalars['String']['input'];
  containerName: Scalars['String']['input'];
  maxCount: Scalars['Int']['input'];
};

export type VehicleTypeCapacityStateData = {
  __typename?: 'VehicleTypeCapacityStateData';
  containerConfigId: Scalars['String']['output'];
  containerName: Scalars['String']['output'];
  maxCount: Scalars['Int']['output'];
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) VehicleType, keyed
 * {tenantId}-{vehicleTypeId}, carrying its embedded capacity matrix. Deleted rows are
 * removed outright.
 */
export type VehicleTypeDocument = {
  __typename?: 'VehicleTypeDocument';
  capacities: Array<VehicleTypeCapacityData>;
  id: Scalars['String']['output'];
  /** The most this vehicle type may carry, stated in maxLoadWeightUnit, or null when there is no limit. */
  maxLoadWeight?: Maybe<Scalars['Decimal']['output']>;
  /** maxLoadWeight in pounds (kilograms converted at 2.20462262 lb per kg), or null when there is no limit. */
  maxLoadWeightLbs?: Maybe<Scalars['Decimal']['output']>;
  /** Unit of maxLoadWeight. UNKNOWN when there is no limit. */
  maxLoadWeightUnit: WeightUnit;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  vehicleTypeId: Scalars['String']['output'];
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) VehicleType, keyed
 * {tenantId}-{vehicleTypeId}, carrying its embedded capacity matrix. Deleted rows are
 * removed outright.
 */
export type VehicleTypeDocumentFilterInput = {
  and?: InputMaybe<Array<VehicleTypeDocumentFilterInput>>;
  capacities?: InputMaybe<ListFilterInputTypeOfVehicleTypeCapacityDataFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** The most this vehicle type may carry, stated in maxLoadWeightUnit, or null when there is no limit. */
  maxLoadWeight?: InputMaybe<DecimalOperationFilterInput>;
  /** maxLoadWeight in pounds (kilograms converted at 2.20462262 lb per kg), or null when there is no limit. */
  maxLoadWeightLbs?: InputMaybe<DecimalOperationFilterInput>;
  /** Unit of maxLoadWeight. UNKNOWN when there is no limit. */
  maxLoadWeightUnit?: InputMaybe<WeightUnitOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VehicleTypeDocumentFilterInput>>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  vehicleTypeId?: InputMaybe<StringOperationFilterInput>;
};

/**
 * Read-model document for one FULFILL Logistics (Helm 1aaa55f5) VehicleType, keyed
 * {tenantId}-{vehicleTypeId}, carrying its embedded capacity matrix. Deleted rows are
 * removed outright.
 */
export type VehicleTypeDocumentSortInput = {
  id?: InputMaybe<SortEnumType>;
  /** The most this vehicle type may carry, stated in maxLoadWeightUnit, or null when there is no limit. */
  maxLoadWeight?: InputMaybe<SortEnumType>;
  /** maxLoadWeight in pounds (kilograms converted at 2.20462262 lb per kg), or null when there is no limit. */
  maxLoadWeightLbs?: InputMaybe<SortEnumType>;
  /** Unit of maxLoadWeight. UNKNOWN when there is no limit. */
  maxLoadWeightUnit?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  vehicleTypeId?: InputMaybe<SortEnumType>;
};

export type VehicleTypePayload = {
  __typename?: 'VehicleTypePayload';
  errors?: Maybe<Array<ValidationError>>;
  vehicleType?: Maybe<VehicleTypeStateData>;
};

export type VehicleTypeStateData = {
  __typename?: 'VehicleTypeStateData';
  capacities: Array<VehicleTypeCapacityStateData>;
  maxLoadWeight?: Maybe<Scalars['Decimal']['output']>;
  maxLoadWeightLbs?: Maybe<Scalars['Decimal']['output']>;
  maxLoadWeightUnit: WeightUnit;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  vehicleTypeId: Scalars['String']['output'];
};

export type VendorDocument = {
  __typename?: 'VendorDocument';
  billingAddress?: Maybe<AddressData>;
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * The stable external sync key (Merge.dev document id) this vendor was imported under.
   * Indexed (TenantId, ImportId) so mergeVendor resolves create-vs-update by an ImportId
   * lookup rather than the entity identity it used to collide on. Empty for native vendors /
   * those imported before ImportId existed. Distinct from ErpId.
   */
  importId: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** W2. The linked Ramp vendor id. Nullable string (not Option) so VendorDocumentFilterInput keeps eq/in. */
  rampVendorId?: Maybe<Scalars['String']['output']>;
  status: VendorStatus;
  tenantId: Scalars['String']['output'];
  vendorId: Scalars['String']['output'];
};

export type VendorDocumentFilterInput = {
  and?: InputMaybe<Array<VendorDocumentFilterInput>>;
  billingAddress?: InputMaybe<AddressDataFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * The stable external sync key (Merge.dev document id) this vendor was imported under.
   * Indexed (TenantId, ImportId) so mergeVendor resolves create-vs-update by an ImportId
   * lookup rather than the entity identity it used to collide on. Empty for native vendors /
   * those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<StringOperationFilterInput>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorDocumentFilterInput>>;
  /** W2. The linked Ramp vendor id. Nullable string (not Option) so VendorDocumentFilterInput keeps eq/in. */
  rampVendorId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<VendorStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
};

export type VendorDocumentSortInput = {
  billingAddress?: InputMaybe<AddressDataSortInput>;
  description?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * The stable external sync key (Merge.dev document id) this vendor was imported under.
   * Indexed (TenantId, ImportId) so mergeVendor resolves create-vs-update by an ImportId
   * lookup rather than the entity identity it used to collide on. Empty for native vendors /
   * those imported before ImportId existed. Distinct from ErpId.
   */
  importId?: InputMaybe<SortEnumType>;
  lastModified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  /** W2. The linked Ramp vendor id. Nullable string (not Option) so VendorDocumentFilterInput keeps eq/in. */
  rampVendorId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  vendorId?: InputMaybe<SortEnumType>;
};

/**
 * One supplier-item alias: a supplier's item id or description, for one purchasing vendor, pointing
 * at one material.
 */
export type VendorItemAlias = {
  __typename?: 'VendorItemAlias';
  aliasId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The decision time that last made the alias active. */
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  /** The decision time that retired the alias; null while it is active. */
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The manufacturer in its key form (vendor:{id} or label:{text}), or null when the
   * manufacturer is unknown.
   */
  manufacturerKey?: Maybe<Scalars['String']['output']>;
  materialItemId: Scalars['String']['output'];
  replacedByAliasId?: Maybe<Scalars['String']['output']>;
  /** When the alias's retirement was written; null while it is active. */
  retiredAt?: Maybe<Scalars['DateTime']['output']>;
  source: VendorItemAliasSource;
  status: VendorItemAliasStatus;
  supplierDescription?: Maybe<Scalars['String']['output']>;
  /** The normalized supplier item id, set only when the key is an item id. */
  supplierItemId?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** The active alias that owns the supplier key, and the material it points at. */
export type VendorItemAliasCollision = {
  __typename?: 'VendorItemAliasCollision';
  /** The alias that owns the key. */
  aliasId: Scalars['String']['output'];
  /** The material that alias points at. */
  materialItemId: Scalars['String']['output'];
};

/**
 * One supplier-item alias: a supplier's item id or description, for one purchasing vendor, pointing
 * at one material.
 */
export type VendorItemAliasFilterInput = {
  aliasId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<VendorItemAliasFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** The decision time that last made the alias active. */
  effectiveFrom?: InputMaybe<DateTimeOperationFilterInput>;
  /** The decision time that retired the alias; null while it is active. */
  effectiveUntil?: InputMaybe<DateTimeOperationFilterInput>;
  /**
   * The manufacturer in its key form (vendor:{id} or label:{text}), or null when the
   * manufacturer is unknown.
   */
  manufacturerKey?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorItemAliasFilterInput>>;
  replacedByAliasId?: InputMaybe<StringOperationFilterInput>;
  /** When the alias's retirement was written; null while it is active. */
  retiredAt?: InputMaybe<DateTimeOperationFilterInput>;
  source?: InputMaybe<VendorItemAliasSourceOperationFilterInput>;
  status?: InputMaybe<VendorItemAliasStatusOperationFilterInput>;
  supplierDescription?: InputMaybe<StringOperationFilterInput>;
  /** The normalized supplier item id, set only when the key is an item id. */
  supplierItemId?: InputMaybe<StringOperationFilterInput>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

/** The result of adding or retiring a vendor item alias. */
export type VendorItemAliasPayload = {
  __typename?: 'VendorItemAliasPayload';
  /** Why the write was refused. */
  errors?: Maybe<Array<ValidationError>>;
  /** The refusals a caller can act on, each with what it needs to act. */
  typedErrors?: Maybe<VendorItemAliasTypedErrors>;
  /** The alias as the write left it; null when the write was refused. */
  vendorItemAlias?: Maybe<VendorItemAlias>;
};

/**
 * One supplier-item alias: a supplier's item id or description, for one purchasing vendor, pointing
 * at one material.
 */
export type VendorItemAliasSortInput = {
  aliasId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  /** The decision time that last made the alias active. */
  effectiveFrom?: InputMaybe<SortEnumType>;
  /** The decision time that retired the alias; null while it is active. */
  effectiveUntil?: InputMaybe<SortEnumType>;
  /**
   * The manufacturer in its key form (vendor:{id} or label:{text}), or null when the
   * manufacturer is unknown.
   */
  manufacturerKey?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  replacedByAliasId?: InputMaybe<SortEnumType>;
  /** When the alias's retirement was written; null while it is active. */
  retiredAt?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  supplierDescription?: InputMaybe<SortEnumType>;
  /** The normalized supplier item id, set only when the key is an item id. */
  supplierItemId?: InputMaybe<SortEnumType>;
  vendorId?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export enum VendorItemAliasSource {
  CsvImport = 'CSV_IMPORT',
  ImportApply = 'IMPORT_APPLY',
  Manual = 'MANUAL',
  PoImport = 'PO_IMPORT',
  Unknown = 'UNKNOWN'
}

export type VendorItemAliasSourceOperationFilterInput = {
  eq?: InputMaybe<VendorItemAliasSource>;
  in?: InputMaybe<Array<VendorItemAliasSource>>;
  neq?: InputMaybe<VendorItemAliasSource>;
  nin?: InputMaybe<Array<VendorItemAliasSource>>;
};

export enum VendorItemAliasStatus {
  Active = 'ACTIVE',
  Retired = 'RETIRED',
  Unknown = 'UNKNOWN'
}

export type VendorItemAliasStatusOperationFilterInput = {
  eq?: InputMaybe<VendorItemAliasStatus>;
  in?: InputMaybe<Array<VendorItemAliasStatus>>;
  neq?: InputMaybe<VendorItemAliasStatus>;
  nin?: InputMaybe<Array<VendorItemAliasStatus>>;
};

/** The refusals of an alias write a caller can act on. */
export type VendorItemAliasTypedErrors = {
  __typename?: 'VendorItemAliasTypedErrors';
  /** Another material already owns the supplier key; replace it or choose another key. */
  collision?: Maybe<VendorItemAliasCollision>;
};

/** A connection to a list of items. */
export type VendorItemAliasesConnection = {
  __typename?: 'VendorItemAliasesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VendorItemAliasesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VendorItemAlias>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VendorItemAliasesEdge = {
  __typename?: 'VendorItemAliasesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VendorItemAlias;
};

/** One material a supplier line may be. */
export type VendorItemCandidate = {
  __typename?: 'VendorItemCandidate';
  /** The alias that pointed at it, when an alias rung found it. */
  aliasId?: Maybe<Scalars['String']['output']>;
  /** The material's ERP id, when it has one. */
  materialItemErpId?: Maybe<Scalars['String']['output']>;
  /** The material's id. */
  materialItemId: Scalars['String']['output'];
  /** The material's name. */
  materialItemName: Scalars['String']['output'];
  /** The rung that found it. */
  rung: ItemMatchRung;
  /** How well it matched, 0 to 100. */
  score: Scalars['Int']['output'];
  /** The item id on the material's assignment to the vendor, when it has one. */
  vendorItemId?: Maybe<Scalars['String']['output']>;
};

/** The answer for one supplier line of a resolveVendorItems request. */
export type VendorItemResolution = {
  __typename?: 'VendorItemResolution';
  /** The materials the line may be, the suggested one first; never more than topN. */
  candidates: Array<VendorItemCandidate>;
  /** The material the line resolved to; set only when the outcome is AUTO. */
  match?: Maybe<VendorItemCandidate>;
  /** Whether the line resolved, needs a person, or found nothing to suggest. */
  outcome: ItemResolveOutcome;
  /** The line's key, as the request gave it. */
  rowKey: Scalars['String']['output'];
  /**
   * Aliases on the line's keys that were not used because their material is no longer an active material
   * assigned to the vendor.
   */
  skippedAliasIds: Array<Scalars['String']['output']>;
};

/** One supplier line to resolve, as the supplier wrote it. */
export type VendorItemResolveRowInput = {
  /** The supplier's description of the line. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ERP id the line names, when it names one. */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The line's manufacturer in its key form (vendor:{id} or label:{text}), as the alias list publishes it.
   * Narrows the supplier item id aliases to that manufacturer's; leave it empty to match across manufacturers.
   */
  manufacturerKey?: InputMaybe<Scalars['String']['input']>;
  /** The caller's key for the line, unique within the request and echoed on its answer. */
  rowKey: Scalars['String']['input'];
  /** The supplier's item id for the line. */
  vendorItemId?: InputMaybe<Scalars['String']['input']>;
};

/** MongoDB read-model document for vendor-specific material cost entries. */
export type VendorMaterialCostDocument = {
  __typename?: 'VendorMaterialCostDocument';
  /**
   * The calendar DAY this cost takes effect, independent of the week/year rollup fields. Rows
   * written since effective-day canonicalisation shipped carry midnight UTC of the day they name:
   * the server discards any time of day the caller supplied and reads the day in the offset the
   * caller SENT, not in UTC, so 2026-08-21T23:00:00-05:00 is stored — and returned here — as
   * 2026-08-21T00:00:00Z rather than 2026-08-22. Rows written BEFORE it carry the save-time
   * instant and were not migrated, so this field is not uniformly midnight across historical data
   * and exact-equality filtering on it is unreliable: match a day with a half-open range —
   * effectiveDate gte that day AND lt the following day — rather than eq, which silently returns
   * nothing for a cost saved at any other time of day. Pricing is unaffected either way, because
   * the estimate reads the calendar day off whatever instant is stored. Null does not mean
   * unknown: it means the row is the always-effective BASE RATE for its vendor rather than a
   * dated cost.
   */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  effectiveWeek?: Maybe<Scalars['Int']['output']>;
  effectiveYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isDefaultVendor: Scalars['Boolean']['output'];
  materialItemId: Scalars['String']['output'];
  /**
   * The stable identity of this logical price, canonical lower-case 32-hex: replay-derived for a
   * row written by the legacy scalar path, writer-minted for an explicit versioned price. Survives
   * every amount, date and royalty change and the void, which is what makes it the key for
   * actions; the document id stays the date-derived value old consumers already hold and must be
   * treated as opaque. Null on a row the identity replay has not reached yet; the readiness query
   * reports how many such rows a tenant still has.
   */
  priceId?: Maybe<Scalars['String']['output']>;
  /**
   * Monotonic per price, starting at 1 on the first write and advancing on every change to the
   * row, corrections and the void included. Zero on a row the identity replay has not reached
   * yet. Guarded by the last applied event number so a retried or duplicated event delivery can
   * never add a phantom revision; a full rebuild reproduces the same value the aggregate holds.
   */
  revision: Scalars['Int']['output'];
  /**
   * Active, or Voided once the price is excluded from live reads for good. Independent of vendor
   * detachment: reattaching the vendor never clears a void. A row written before this field
   * existed hydrates as Active, which is the truth about every one of them because no void could
   * have been recorded.
   */
  status: MaterialPriceStatus;
  /**
   * The separately recorded supplier royalty per each, paired with the unit cost on the same
   * PriceId and Revision and never folded into it. Null unless the royalty status is ConfirmedNone
   * (zero) or Specified (positive) — an unknown royalty is absent, never a zero.
   */
  supplierRoyaltyPerEach?: Maybe<Scalars['Decimal']['output']>;
  /** The recorded royalty per each as exact decimal text, null whenever supplierRoyaltyPerEach is null. Read this rather than the number for the same reason as unitCostText. */
  supplierRoyaltyPerEachText?: Maybe<Scalars['String']['output']>;
  /**
   * The review state of the supplier royalty per each. A row written by the legacy scalar path,
   * and every row written before this field existed, hydrates as LegacyUnspecified: unknown
   * history, not a confirmed zero.
   */
  supplierRoyaltyStatus: SupplierRoyaltyStatus;
  tenantId: Scalars['String']['output'];
  /** The BASE per-each cost of this quote, never including the separately recorded supplier royalty. */
  unitCost: Scalars['Decimal']['output'];
  /** The BASE per-each cost as exact decimal text. The same amount as unitCost, in a form that carries every digit the row holds; seed a correction from this rather than from the number, which a JSON client receives as a double. */
  unitCostText: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  vendorId: Scalars['String']['output'];
};

/** MongoDB read-model document for vendor-specific material cost entries. */
export type VendorMaterialCostDocumentFilterInput = {
  and?: InputMaybe<Array<VendorMaterialCostDocumentFilterInput>>;
  /**
   * The calendar DAY this cost takes effect, independent of the week/year rollup fields. Rows
   * written since effective-day canonicalisation shipped carry midnight UTC of the day they name:
   * the server discards any time of day the caller supplied and reads the day in the offset the
   * caller SENT, not in UTC, so 2026-08-21T23:00:00-05:00 is stored — and returned here — as
   * 2026-08-21T00:00:00Z rather than 2026-08-22. Rows written BEFORE it carry the save-time
   * instant and were not migrated, so this field is not uniformly midnight across historical data
   * and exact-equality filtering on it is unreliable: match a day with a half-open range —
   * effectiveDate gte that day AND lt the following day — rather than eq, which silently returns
   * nothing for a cost saved at any other time of day. Pricing is unaffected either way, because
   * the estimate reads the calendar day off whatever instant is stored. Null does not mean
   * unknown: it means the row is the always-effective BASE RATE for its vendor rather than a
   * dated cost.
   */
  effectiveDate?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveWeek?: InputMaybe<IntOperationFilterInput>;
  effectiveYear?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDefaultVendor?: InputMaybe<BooleanOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorMaterialCostDocumentFilterInput>>;
  /**
   * The stable identity of this logical price, canonical lower-case 32-hex: replay-derived for a
   * row written by the legacy scalar path, writer-minted for an explicit versioned price. Survives
   * every amount, date and royalty change and the void, which is what makes it the key for
   * actions; the document id stays the date-derived value old consumers already hold and must be
   * treated as opaque. Null on a row the identity replay has not reached yet; the readiness query
   * reports how many such rows a tenant still has.
   */
  priceId?: InputMaybe<StringOperationFilterInput>;
  /**
   * Monotonic per price, starting at 1 on the first write and advancing on every change to the
   * row, corrections and the void included. Zero on a row the identity replay has not reached
   * yet. Guarded by the last applied event number so a retried or duplicated event delivery can
   * never add a phantom revision; a full rebuild reproduces the same value the aggregate holds.
   */
  revision?: InputMaybe<IntOperationFilterInput>;
  /**
   * Active, or Voided once the price is excluded from live reads for good. Independent of vendor
   * detachment: reattaching the vendor never clears a void. A row written before this field
   * existed hydrates as Active, which is the truth about every one of them because no void could
   * have been recorded.
   */
  status?: InputMaybe<MaterialPriceStatusOperationFilterInput>;
  /**
   * The separately recorded supplier royalty per each, paired with the unit cost on the same
   * PriceId and Revision and never folded into it. Null unless the royalty status is ConfirmedNone
   * (zero) or Specified (positive) — an unknown royalty is absent, never a zero.
   */
  supplierRoyaltyPerEach?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The review state of the supplier royalty per each. A row written by the legacy scalar path,
   * and every row written before this field existed, hydrates as LegacyUnspecified: unknown
   * history, not a confirmed zero.
   */
  supplierRoyaltyStatus?: InputMaybe<SupplierRoyaltyStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  /** The BASE per-each cost of this quote, never including the separately recorded supplier royalty. */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
};

/** MongoDB read-model document for vendor-specific material cost entries. */
export type VendorMaterialCostDocumentSortInput = {
  /**
   * The calendar DAY this cost takes effect, independent of the week/year rollup fields. Rows
   * written since effective-day canonicalisation shipped carry midnight UTC of the day they name:
   * the server discards any time of day the caller supplied and reads the day in the offset the
   * caller SENT, not in UTC, so 2026-08-21T23:00:00-05:00 is stored — and returned here — as
   * 2026-08-21T00:00:00Z rather than 2026-08-22. Rows written BEFORE it carry the save-time
   * instant and were not migrated, so this field is not uniformly midnight across historical data
   * and exact-equality filtering on it is unreliable: match a day with a half-open range —
   * effectiveDate gte that day AND lt the following day — rather than eq, which silently returns
   * nothing for a cost saved at any other time of day. Pricing is unaffected either way, because
   * the estimate reads the calendar day off whatever instant is stored. Null does not mean
   * unknown: it means the row is the always-effective BASE RATE for its vendor rather than a
   * dated cost.
   */
  effectiveDate?: InputMaybe<SortEnumType>;
  effectiveWeek?: InputMaybe<SortEnumType>;
  effectiveYear?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefaultVendor?: InputMaybe<SortEnumType>;
  materialItemId?: InputMaybe<SortEnumType>;
  /**
   * The stable identity of this logical price, canonical lower-case 32-hex: replay-derived for a
   * row written by the legacy scalar path, writer-minted for an explicit versioned price. Survives
   * every amount, date and royalty change and the void, which is what makes it the key for
   * actions; the document id stays the date-derived value old consumers already hold and must be
   * treated as opaque. Null on a row the identity replay has not reached yet; the readiness query
   * reports how many such rows a tenant still has.
   */
  priceId?: InputMaybe<SortEnumType>;
  /**
   * Monotonic per price, starting at 1 on the first write and advancing on every change to the
   * row, corrections and the void included. Zero on a row the identity replay has not reached
   * yet. Guarded by the last applied event number so a retried or duplicated event delivery can
   * never add a phantom revision; a full rebuild reproduces the same value the aggregate holds.
   */
  revision?: InputMaybe<SortEnumType>;
  /**
   * Active, or Voided once the price is excluded from live reads for good. Independent of vendor
   * detachment: reattaching the vendor never clears a void. A row written before this field
   * existed hydrates as Active, which is the truth about every one of them because no void could
   * have been recorded.
   */
  status?: InputMaybe<SortEnumType>;
  /**
   * The separately recorded supplier royalty per each, paired with the unit cost on the same
   * PriceId and Revision and never folded into it. Null unless the royalty status is ConfirmedNone
   * (zero) or Specified (positive) — an unknown royalty is absent, never a zero.
   */
  supplierRoyaltyPerEach?: InputMaybe<SortEnumType>;
  /**
   * The review state of the supplier royalty per each. A row written by the legacy scalar path,
   * and every row written before this field existed, hydrates as LegacyUnspecified: unknown
   * history, not a confirmed zero.
   */
  supplierRoyaltyStatus?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  /** The BASE per-each cost of this quote, never including the separately recorded supplier royalty. */
  unitCost?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  vendorId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VendorMaterialCostsConnection = {
  __typename?: 'VendorMaterialCostsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VendorMaterialCostsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VendorMaterialCostDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VendorMaterialCostsEdge = {
  __typename?: 'VendorMaterialCostsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VendorMaterialCostDocument;
};

export type VendorPayload = {
  __typename?: 'VendorPayload';
  errors?: Maybe<Array<ValidationError>>;
  vendor?: Maybe<VendorStateData>;
};

/**
 * One order-level charge or adder on a vendor purchase order — freight, fuel, pallets and similar
 * fees.
 */
export type VendorPurchaseOrderChargeData = {
  __typename?: 'VendorPurchaseOrderChargeData';
  amount: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  /** Charge classification. Discount lowers the estimated total; Unknown and other kinds add. */
  kind: VendorPurchaseOrderChargeKind;
  label: Scalars['String']['output'];
};

/**
 * One order-level charge or adder on a vendor purchase order — freight, fuel, pallets and similar
 * fees.
 */
export type VendorPurchaseOrderChargeDataFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<VendorPurchaseOrderChargeDataFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  /** Charge classification. Discount lowers the estimated total; Unknown and other kinds add. */
  kind?: InputMaybe<VendorPurchaseOrderChargeKindOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorPurchaseOrderChargeDataFilterInput>>;
};

export enum VendorPurchaseOrderChargeKind {
  Discount = 'DISCOUNT',
  Freight = 'FREIGHT',
  Other = 'OTHER',
  Tax = 'TAX',
  Unknown = 'UNKNOWN'
}

export type VendorPurchaseOrderChargeKindOperationFilterInput = {
  eq?: InputMaybe<VendorPurchaseOrderChargeKind>;
  in?: InputMaybe<Array<VendorPurchaseOrderChargeKind>>;
  neq?: InputMaybe<VendorPurchaseOrderChargeKind>;
  nin?: InputMaybe<Array<VendorPurchaseOrderChargeKind>>;
};

export type VendorPurchaseOrderDocument = {
  __typename?: 'VendorPurchaseOrderDocument';
  billingAddress?: Maybe<AddressData>;
  charges: Array<VendorPurchaseOrderChargeData>;
  created: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  /** Estimated line-cost subtotal: the sum, across every line, of QuantityOrdered * UnitCost. An uncosted line (UnitCost not set) contributes zero — this is an ESTIMATE built from whatever costs have been captured so far, not a claim that every line is costed. Excludes order-level charges/adders; see estimatedTotal for those included. */
  estimatedSubtotal: Scalars['Decimal']['output'];
  /** estimatedSubtotal minus Discount charges, plus all other order-level charges. Charges without a kind remain additive. */
  estimatedTotal: Scalars['Decimal']['output'];
  id: Scalars['String']['output'];
  isUrgent: Scalars['Boolean']['output'];
  items: Array<VendorPurchaseOrderItemData>;
  /**
   * The order's need-by date. Optional/manually-entered; drives the derived ship week shown on
   * the PO list, workspace panel and printed PO document.
   */
  needByDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Free-text working notes on the order. Also printed on the Export PO document. */
  notes: Scalars['String']['output'];
  orderPlacedDate: Scalars['DateTime']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  purpose: VendorPurchaseOrderPurpose;
  /** What the buyer typed as the order's purpose. Used when no line has a job. Empty when none. */
  purposeText: Scalars['String']['output'];
  receipts: Array<VendorPurchaseOrderReceiptData>;
  /** ISO 8601 week number (1-53) derived from needByDate; computed on read and never stored. */
  shipWeek?: Maybe<Scalars['Int']['output']>;
  shippingAddress?: Maybe<AddressData>;
  siteLocationId: Scalars['String']['output'];
  status: VendorPurchaseOrderStatus;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  vendorId: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};

export type VendorPurchaseOrderDocumentFilterInput = {
  and?: InputMaybe<Array<VendorPurchaseOrderDocumentFilterInput>>;
  billingAddress?: InputMaybe<AddressDataFilterInput>;
  charges?: InputMaybe<ListFilterInputTypeOfVendorPurchaseOrderChargeDataFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isUrgent?: InputMaybe<BooleanOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfVendorPurchaseOrderItemDataFilterInput>;
  /**
   * The order's need-by date. Optional/manually-entered; drives the derived ship week shown on
   * the PO list, workspace panel and printed PO document.
   */
  needByDate?: InputMaybe<LocalDateOperationFilterInput>;
  /** Free-text working notes on the order. Also printed on the Export PO document. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorPurchaseOrderDocumentFilterInput>>;
  orderPlacedDate?: InputMaybe<DateTimeOperationFilterInput>;
  purchaseOrderNumber?: InputMaybe<StringOperationFilterInput>;
  receipts?: InputMaybe<ListFilterInputTypeOfVendorPurchaseOrderReceiptDataFilterInput>;
  /** ISO 8601 week number (1-53) derived from needByDate; computed on read and never stored. */
  shipWeek?: InputMaybe<IntOperationFilterInput>;
  shippingAddress?: InputMaybe<AddressDataFilterInput>;
  siteLocationId?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<VendorPurchaseOrderStatusOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  vendorId?: InputMaybe<StringOperationFilterInput>;
  vendorName?: InputMaybe<StringOperationFilterInput>;
};

export type VendorPurchaseOrderDocumentSortInput = {
  billingAddress?: InputMaybe<AddressDataSortInput>;
  created?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isUrgent?: InputMaybe<SortEnumType>;
  /**
   * The order's need-by date. Optional/manually-entered; drives the derived ship week shown on
   * the PO list, workspace panel and printed PO document.
   */
  needByDate?: InputMaybe<SortEnumType>;
  /** Free-text working notes on the order. Also printed on the Export PO document. */
  notes?: InputMaybe<SortEnumType>;
  orderPlacedDate?: InputMaybe<SortEnumType>;
  purchaseOrderNumber?: InputMaybe<SortEnumType>;
  /** ISO 8601 week number (1-53) derived from needByDate; computed on read and never stored. */
  shipWeek?: InputMaybe<SortEnumType>;
  shippingAddress?: InputMaybe<AddressDataSortInput>;
  siteLocationId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  vendorId?: InputMaybe<SortEnumType>;
  vendorName?: InputMaybe<SortEnumType>;
};

export type VendorPurchaseOrderItemData = {
  __typename?: 'VendorPurchaseOrderItemData';
  erpJobId: Scalars['String']['output'];
  eventDetailId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isCostOverridden: Scalars['Boolean']['output'];
  isOrganicAtReceive: Scalars['Boolean']['output'];
  itemName: Scalars['String']['output'];
  /** The jobs this line's quantity is for, in the order they were sent (earliest-needed first), each with what it still has on order. Empty when the line lists no jobs; such a line may link one job through productionJobId instead. */
  jobShares: Array<VendorPurchaseOrderLineJobShare>;
  lineNumber: Scalars['Int']['output'];
  materialItemErpId: Scalars['String']['output'];
  materialItemId: Scalars['String']['output'];
  organicLotCode?: Maybe<Scalars['String']['output']>;
  productionJobId?: Maybe<Scalars['String']['output']>;
  /** The linked production job's number, null when no linked job is available. */
  productionJobNumber?: Maybe<Scalars['Int']['output']>;
  qualityNotes?: Maybe<Scalars['String']['output']>;
  quantityOrdered: Scalars['Decimal']['output'];
  quantityReceived: Scalars['Decimal']['output'];
  shortageNotes?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['Decimal']['output']>;
  /** The line's per-each cost as exact decimal text, null on an uncosted line. The same amount as unitCost, in a form that carries every digit the line holds; read this rather than the number when the cost may be quoted beyond four decimals. */
  unitCostText?: Maybe<Scalars['String']['output']>;
  varianceReason: VendorReceiveVarianceReason;
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

export type VendorPurchaseOrderItemDataFilterInput = {
  and?: InputMaybe<Array<VendorPurchaseOrderItemDataFilterInput>>;
  erpJobId?: InputMaybe<StringOperationFilterInput>;
  eventDetailId?: InputMaybe<OptionOfStringFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isCostOverridden?: InputMaybe<BooleanOperationFilterInput>;
  isOrganicAtReceive?: InputMaybe<BooleanOperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  jobShares?: InputMaybe<ListFilterInputTypeOfVendorPurchaseOrderLineJobShareDataFilterInput>;
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  materialItemErpId?: InputMaybe<StringOperationFilterInput>;
  materialItemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorPurchaseOrderItemDataFilterInput>>;
  organicLotCode?: InputMaybe<OptionOfStringFilterInput>;
  productionJobId?: InputMaybe<OptionOfStringFilterInput>;
  qualityNotes?: InputMaybe<StringOperationFilterInput>;
  quantityOrdered?: InputMaybe<DecimalOperationFilterInput>;
  quantityReceived?: InputMaybe<DecimalOperationFilterInput>;
  shortageNotes?: InputMaybe<StringOperationFilterInput>;
  unitCost?: InputMaybe<OptionOfDecimalFilterInput>;
  varianceReason?: InputMaybe<VendorReceiveVarianceReasonOperationFilterInput>;
  vendorLotNumber?: InputMaybe<OptionOfStringFilterInput>;
};

/** One material's catalog price preview for a new purchase-order line. */
export type VendorPurchaseOrderLineCostPreview = {
  __typename?: 'VendorPurchaseOrderLineCostPreview';
  /** The material the price is for. */
  materialItemId: Scalars['String']['output'];
  /** Per each; null when the vendor has no catalog price in force that day. */
  unitCost?: Maybe<Scalars['Decimal']['output']>;
  /** The same amount as exact decimal text; null when unitCost is null. */
  unitCostText?: Maybe<Scalars['String']['output']>;
};

export type VendorPurchaseOrderLineJobShare = {
  __typename?: 'VendorPurchaseOrderLineJobShare';
  eventDetailId: Scalars['String']['output'];
  /** The job's number, null when the job is not available. */
  jobNumber?: Maybe<Scalars['Int']['output']>;
  /** What this job still has on order: the part of its share the line's ordered quantity covers, less what receipts have filled. Receipts fill the earliest-needed jobs first; any quantity ordered beyond the shares' total counts toward no job. */
  openQuantity: Scalars['Decimal']['output'];
  productionJobId: Scalars['String']['output'];
  /** The share of the line's quantity this job needs, in the material's unit. */
  quantity: Scalars['Decimal']['output'];
};

export type VendorPurchaseOrderLineJobShareDataFilterInput = {
  and?: InputMaybe<Array<VendorPurchaseOrderLineJobShareDataFilterInput>>;
  eventDetailId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorPurchaseOrderLineJobShareDataFilterInput>>;
  productionJobId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
};

export type VendorPurchaseOrderPayload = {
  __typename?: 'VendorPurchaseOrderPayload';
  errors?: Maybe<Array<ValidationError>>;
  vendorPurchaseOrder?: Maybe<VendorPurchaseOrderDocument>;
  warnings?: Maybe<Array<OrganicReceiveWarning>>;
};

/** What the order is for, derived from linked jobs, buyer text or line items. */
export type VendorPurchaseOrderPurpose = {
  __typename?: 'VendorPurchaseOrderPurpose';
  /** JOBS: distinct production category names of the jobs, in line order. */
  categoryNames: Array<Scalars['String']['output']>;
  /** JOBS: earliest job start week within its ISO year. */
  firstStartIsoWeek?: Maybe<Scalars['Int']['output']>;
  /** JOBS: ISO year of the earliest job start week. */
  firstStartIsoYear?: Maybe<Scalars['Int']['output']>;
  /** JOBS: distinct catalog genera of the jobs, in line order. */
  genusNames: Array<Scalars['String']['output']>;
  /** ITEMS: the total number of distinct line item names. */
  itemCount: Scalars['Int']['output'];
  /** ITEMS: the first three distinct line item names, in line order. */
  itemNames: Array<Scalars['String']['output']>;
  /** JOBS: distinct jobs behind the lines. 0 otherwise. */
  jobCount: Scalars['Int']['output'];
  /** JOBS: latest job start week within its ISO year. */
  lastStartIsoWeek?: Maybe<Scalars['Int']['output']>;
  /** JOBS: ISO year of the latest job start week. */
  lastStartIsoYear?: Maybe<Scalars['Int']['output']>;
  /** ITEMS: the order's need-by week, when set. */
  needByIsoWeek?: Maybe<Scalars['Int']['output']>;
  /** ITEMS: ISO year of the order's need-by week, when set. */
  needByIsoYear?: Maybe<Scalars['Int']['output']>;
  /** JOBS: distinct production plan names of the jobs, in line order. Empty when the jobs carry no plan. */
  planNames: Array<Scalars['String']['output']>;
  /** The rule supplying this summary. */
  source: VendorPurchaseOrderPurposeSource;
  /** BUYER_TEXT: the buyer's text. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The source of the purchase order purpose summary. */
export enum VendorPurchaseOrderPurposeSource {
  /** No jobs resolve and the buyer supplied purpose text. */
  BuyerText = 'BUYER_TEXT',
  /** No jobs or buyer text; line items describe the purpose. */
  Items = 'ITEMS',
  /** At least one line resolves to a production job. */
  Jobs = 'JOBS'
}

/**
 * Per-receipt history entry appended by the VendorPurchaseOrderItemsReceived projection so the
 * correction handler can resolve the receive location for a specific line item — needed when the
 * receive happens at a location other than the PO-level SiteLocationId (cross-location receipt).
 * Each entry also keeps the receiver, variance reason, vendor lot, organic lot code and notes
 * given with that receipt. A line received as several lots writes one entry per lot that brought
 * stock, each with that lot's quantity and its code as both its vendor lot and organic lot code.
 *
 * Deduplicated on event replay by ReceiptEntryId, which is derived deterministically from
 * the VPO id, the line item id, and the receiving VendorPurchaseOrderItemsReceived
 * event's own KurrentDB commit-position/event-id identity, with the lot's position on the line
 * appended for an entry of a split line — never from the received-at
 * location or timestamp, which two genuinely distinct receives can share. This is why two
 * same-item, same-location, same-timestamp receives land as two rows instead of merging.
 */
export type VendorPurchaseOrderReceiptData = {
  __typename?: 'VendorPurchaseOrderReceiptData';
  itemId: Scalars['String']['output'];
  /** The organic lot code captured with this receipt. */
  organicLotCode?: Maybe<Scalars['String']['output']>;
  /** Quality notes entered with this receipt. */
  qualityNotes?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Decimal']['output'];
  receiptEntryId: Scalars['String']['output'];
  receiveLocationId: Scalars['String']['output'];
  /** Who recorded this receipt. */
  receivedBy?: Maybe<Scalars['String']['output']>;
  receivedDate: Scalars['DateTime']['output'];
  /** Shortage notes entered with this receipt. */
  shortageNotes?: Maybe<Scalars['String']['output']>;
  /** Why this receipt differed from what was ordered, as given when it was recorded. */
  varianceReason: VendorReceiveVarianceReason;
  /** The vendor's lot number for the stock in this receipt. */
  vendorLotNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Per-receipt history entry appended by the VendorPurchaseOrderItemsReceived projection so the
 * correction handler can resolve the receive location for a specific line item — needed when the
 * receive happens at a location other than the PO-level SiteLocationId (cross-location receipt).
 * Each entry also keeps the receiver, variance reason, vendor lot, organic lot code and notes
 * given with that receipt. A line received as several lots writes one entry per lot that brought
 * stock, each with that lot's quantity and its code as both its vendor lot and organic lot code.
 *
 * Deduplicated on event replay by ReceiptEntryId, which is derived deterministically from
 * the VPO id, the line item id, and the receiving VendorPurchaseOrderItemsReceived
 * event's own KurrentDB commit-position/event-id identity, with the lot's position on the line
 * appended for an entry of a split line — never from the received-at
 * location or timestamp, which two genuinely distinct receives can share. This is why two
 * same-item, same-location, same-timestamp receives land as two rows instead of merging.
 */
export type VendorPurchaseOrderReceiptDataFilterInput = {
  and?: InputMaybe<Array<VendorPurchaseOrderReceiptDataFilterInput>>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VendorPurchaseOrderReceiptDataFilterInput>>;
  /** The organic lot code captured with this receipt. */
  organicLotCode?: InputMaybe<StringOperationFilterInput>;
  /** Quality notes entered with this receipt. */
  qualityNotes?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  receiptEntryId?: InputMaybe<StringOperationFilterInput>;
  receiveLocationId?: InputMaybe<StringOperationFilterInput>;
  /** Who recorded this receipt. */
  receivedBy?: InputMaybe<StringOperationFilterInput>;
  receivedDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Shortage notes entered with this receipt. */
  shortageNotes?: InputMaybe<StringOperationFilterInput>;
  /** Why this receipt differed from what was ordered, as given when it was recorded. */
  varianceReason?: InputMaybe<VendorReceiveVarianceReasonOperationFilterInput>;
  /** The vendor's lot number for the stock in this receipt. */
  vendorLotNumber?: InputMaybe<StringOperationFilterInput>;
};

export enum VendorPurchaseOrderStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Confirmed = 'CONFIRMED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  Shipped = 'SHIPPED',
  Submitted = 'SUBMITTED',
  Unconfirmed = 'UNCONFIRMED'
}

export type VendorPurchaseOrderStatusOperationFilterInput = {
  eq?: InputMaybe<VendorPurchaseOrderStatus>;
  in?: InputMaybe<Array<VendorPurchaseOrderStatus>>;
  neq?: InputMaybe<VendorPurchaseOrderStatus>;
  nin?: InputMaybe<Array<VendorPurchaseOrderStatus>>;
};

/** A connection to a list of items. */
export type VendorPurchaseOrdersConnection = {
  __typename?: 'VendorPurchaseOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VendorPurchaseOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VendorPurchaseOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VendorPurchaseOrdersEdge = {
  __typename?: 'VendorPurchaseOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VendorPurchaseOrderDocument;
};

export enum VendorReceiveVarianceReason {
  Damaged = 'DAMAGED',
  None = 'NONE',
  Other = 'OTHER',
  Overship = 'OVERSHIP',
  QualityReject = 'QUALITY_REJECT',
  Short = 'SHORT',
  SubstituteAccepted = 'SUBSTITUTE_ACCEPTED',
  WrongItem = 'WRONG_ITEM'
}

export type VendorReceiveVarianceReasonOperationFilterInput = {
  eq?: InputMaybe<VendorReceiveVarianceReason>;
  in?: InputMaybe<Array<VendorReceiveVarianceReason>>;
  neq?: InputMaybe<VendorReceiveVarianceReason>;
  nin?: InputMaybe<Array<VendorReceiveVarianceReason>>;
};

export type VendorStateData = {
  __typename?: 'VendorStateData';
  billingAddress?: Maybe<CreateAddress>;
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** W2. The linked Ramp vendor from the cache. Null when not linked or not cached yet. */
  rampVendor?: Maybe<RampVendorData>;
  /** W2. The Ramp vendor this Work Suite vendor is linked to. Null when not linked. */
  rampVendorId?: Maybe<Scalars['String']['output']>;
  status: VendorStatus;
  tenantId: Scalars['String']['output'];
  vendorId: Scalars['String']['output'];
};

export enum VendorStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type VendorStatusOperationFilterInput = {
  eq?: InputMaybe<VendorStatus>;
  in?: InputMaybe<Array<VendorStatus>>;
  neq?: InputMaybe<VendorStatus>;
  nin?: InputMaybe<Array<VendorStatus>>;
};

/** A connection to a list of items. */
export type VendorsConnection = {
  __typename?: 'VendorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VendorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VendorDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VendorsEdge = {
  __typename?: 'VendorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VendorDocument;
};

/** A container that contributed scans to the comparison, surfaced for the dashboard's drill-in. */
export type VerifyComparisonContainer = {
  __typename?: 'VerifyComparisonContainer';
  /** The container's id. */
  containerId: Scalars['String']['output'];
  /** The drop read from the container's label. Empty when the container has no drop (a label-less count). */
  drop: Scalars['String']['output'];
  /** When the container was last submitted, once its status is SUBMITTED or VERIFIED; null before then. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Who finished the container: the submitter name its last submit carried, once its status is SUBMITTED
   * or VERIFIED; null before then.
   */
  finishedBy?: Maybe<Scalars['String']['output']>;
  /** When the container's earliest scan was taken; null while it has no scans. */
  firstScannedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The label scanned off the container; empty when nothing was scanned. */
  label: Scalars['String']['output'];
  /** The number of scan rows on the container (not the summed quantity). */
  scanCount: Scalars['Int']['output'];
  /** The summed quantity of every scan row on the container, in eaches: the same rows scanCount counts. */
  scannedQuantity: Scalars['Int']['output'];
  /** The container's lifecycle status. */
  status: VerifyContainerStatus;
};

/**
 * A scanned quantity that has no matching order line. Two cases:
 *
 * itemId is None — a raw barcode that never resolved to an item (blind-count
 * unknown). The Barcodes that summed into ScannedQuantity are listed.
 * itemId is Some — a resolved item that is not on the current order (e.g. a stray
 * item scanned into the container). Barcodes lists the contributing barcodes.
 *
 * Optional fields use Option<T>: this is a pure query OUTPUT object (no
 * [UseFiltering]/[UseSorting] on the computed resolver), so the OptionTypeInterceptor
 * rewrites it to a nullable GraphQL field cleanly.
 */
export type VerifyComparisonUnknownItem = {
  __typename?: 'VerifyComparisonUnknownItem';
  barcodes: Array<Scalars['String']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  scannedQuantity: Scalars['Int']['output'];
};

/**
 * MongoDB read-model document for a VerifyContainer — a raw-capture snapshot of a scanned
 * shipping container, projected from VerifyContainerEvents by
 * VerifyContainerProjectionService and read by the verifyContainers query that backs
 * the supervisor dashboard. There is exactly one document per container; Id is
 * {TenantId}-{ContainerId} — always route through String) so the format
 * can evolve without hunting every read/write site.
 *
 * Every VerifyContainerSubmitted carries the WHOLE snapshot, so the projection replaces the
 * entire document on each submit (mirroring the aggregate's whole-state-replace contract).
 *  persists as the enum member NAME (a BSON string) so the dashboard can filter
 * and sort on it; the ordinals stay int-stable in the event stream regardless.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data — so optional fields use T? (not Option<T>): the
 * OptionTypeInterceptor rewrites only output object types, so an Option<T> here
 * would leak as a broken OptionOf{X}FilterInput (null-safety standard 5a153a33).
 */
export type VerifyContainerDocument = {
  __typename?: 'VerifyContainerDocument';
  /**
   * The container's AGGREGATE identity (the KurrentDB stream key), distinct from the composite
   * Id. A client-frozen GUID the mobile offline queue supplies so a replay
   * converges on this same stream; server-generated only for callers that omit it.
   */
  containerId: Scalars['String']['output'];
  /** The drop, read from the label. Empty when the container has no drop (a label-less count). */
  drop: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * Raw scanned QR/text from the physical container — business/display data, independent of
   * ContainerId. May be empty when the scan produced nothing usable.
   */
  label: Scalars['String']['output'];
  /** The orders this container holds. N-ready for future racking; v1 resolves to exactly one. */
  orderAssociations: Array<VerifyContainerOrderAssociationDocument>;
  removedAt: Scalars['DateTime']['output'];
  removedBy: Scalars['String']['output'];
  /** The manager's reason for discarding the container; null when none was given. */
  removedReason?: Maybe<Scalars['String']['output']>;
  /** The raw item scans, including unknown barcodes (unresolved ItemId). */
  scans: Array<VerifyContainerScanDocument>;
  status: VerifyContainerStatus;
  submittedAt: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  verifiedAt: Scalars['DateTime']['output'];
};

/**
 * MongoDB read-model document for a VerifyContainer — a raw-capture snapshot of a scanned
 * shipping container, projected from VerifyContainerEvents by
 * VerifyContainerProjectionService and read by the verifyContainers query that backs
 * the supervisor dashboard. There is exactly one document per container; Id is
 * {TenantId}-{ContainerId} — always route through String) so the format
 * can evolve without hunting every read/write site.
 *
 * Every VerifyContainerSubmitted carries the WHOLE snapshot, so the projection replaces the
 * entire document on each submit (mirroring the aggregate's whole-state-replace contract).
 *  persists as the enum member NAME (a BSON string) so the dashboard can filter
 * and sort on it; the ordinals stay int-stable in the event stream regardless.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data — so optional fields use T? (not Option<T>): the
 * OptionTypeInterceptor rewrites only output object types, so an Option<T> here
 * would leak as a broken OptionOf{X}FilterInput (null-safety standard 5a153a33).
 */
export type VerifyContainerDocumentFilterInput = {
  and?: InputMaybe<Array<VerifyContainerDocumentFilterInput>>;
  /**
   * The container's AGGREGATE identity (the KurrentDB stream key), distinct from the composite
   * Id. A client-frozen GUID the mobile offline queue supplies so a replay
   * converges on this same stream; server-generated only for callers that omit it.
   */
  containerId?: InputMaybe<StringOperationFilterInput>;
  /** The drop, read from the label. Empty when the container has no drop (a label-less count). */
  drop?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  /**
   * Raw scanned QR/text from the physical container — business/display data, independent of
   * ContainerId. May be empty when the scan produced nothing usable.
   */
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VerifyContainerDocumentFilterInput>>;
  /** The orders this container holds. N-ready for future racking; v1 resolves to exactly one. */
  orderAssociations?: InputMaybe<ListFilterInputTypeOfVerifyContainerOrderAssociationDocumentFilterInput>;
  removedAt?: InputMaybe<DateTimeOperationFilterInput>;
  removedBy?: InputMaybe<StringOperationFilterInput>;
  /** The manager's reason for discarding the container; null when none was given. */
  removedReason?: InputMaybe<StringOperationFilterInput>;
  /** The raw item scans, including unknown barcodes (unresolved ItemId). */
  scans?: InputMaybe<ListFilterInputTypeOfVerifyContainerScanDocumentFilterInput>;
  status?: InputMaybe<VerifyContainerStatusOperationFilterInput>;
  submittedAt?: InputMaybe<DateTimeOperationFilterInput>;
  submittedBy?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  verifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/**
 * MongoDB read-model document for a VerifyContainer — a raw-capture snapshot of a scanned
 * shipping container, projected from VerifyContainerEvents by
 * VerifyContainerProjectionService and read by the verifyContainers query that backs
 * the supervisor dashboard. There is exactly one document per container; Id is
 * {TenantId}-{ContainerId} — always route through String) so the format
 * can evolve without hunting every read/write site.
 *
 * Every VerifyContainerSubmitted carries the WHOLE snapshot, so the projection replaces the
 * entire document on each submit (mirroring the aggregate's whole-state-replace contract).
 *  persists as the enum member NAME (a BSON string) so the dashboard can filter
 * and sort on it; the ordinals stay int-stable in the event stream regardless.
 *
 *
 * This type is a query OUTPUT and a [UseFiltering] source only — never a mutation input or
 * command *Data — so optional fields use T? (not Option<T>): the
 * OptionTypeInterceptor rewrites only output object types, so an Option<T> here
 * would leak as a broken OptionOf{X}FilterInput (null-safety standard 5a153a33).
 */
export type VerifyContainerDocumentSortInput = {
  /**
   * The container's AGGREGATE identity (the KurrentDB stream key), distinct from the composite
   * Id. A client-frozen GUID the mobile offline queue supplies so a replay
   * converges on this same stream; server-generated only for callers that omit it.
   */
  containerId?: InputMaybe<SortEnumType>;
  /** The drop, read from the label. Empty when the container has no drop (a label-less count). */
  drop?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /**
   * Raw scanned QR/text from the physical container — business/display data, independent of
   * ContainerId. May be empty when the scan produced nothing usable.
   */
  label?: InputMaybe<SortEnumType>;
  removedAt?: InputMaybe<SortEnumType>;
  removedBy?: InputMaybe<SortEnumType>;
  /** The manager's reason for discarding the container; null when none was given. */
  removedReason?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  submittedAt?: InputMaybe<SortEnumType>;
  submittedBy?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  verifiedAt?: InputMaybe<SortEnumType>;
};

/** One order the container holds. */
export type VerifyContainerOrderAssociationData = {
  __typename?: 'VerifyContainerOrderAssociationData';
  orderId: Scalars['String']['output'];
};

/**
 * One order the container holds. Document-only sub-record (no boundary Data suffix —
 *             the parent VerifyContainerDocument is itself the read-model boundary type).
 */
export type VerifyContainerOrderAssociationDocument = {
  __typename?: 'VerifyContainerOrderAssociationDocument';
  orderId: Scalars['String']['output'];
  /** The associated order's human order number; null when the order does not exist in this tenant. */
  orderNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * One order the container holds. Document-only sub-record (no boundary Data suffix —
 *             the parent VerifyContainerDocument is itself the read-model boundary type).
 */
export type VerifyContainerOrderAssociationDocumentFilterInput = {
  and?: InputMaybe<Array<VerifyContainerOrderAssociationDocumentFilterInput>>;
  or?: InputMaybe<Array<VerifyContainerOrderAssociationDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
};

export type VerifyContainerPayload = {
  __typename?: 'VerifyContainerPayload';
  errors?: Maybe<Array<ValidationError>>;
  verifyContainer?: Maybe<VerifyContainerStateData>;
};

/**
 * A single raw item scan. ItemId is null for an unknown barcode (captured
 * raw, never blocking the scan — blind count). orderId is the associated order the
 * scan is attributed to, or null when it counts toward every associated order.
 */
export type VerifyContainerScanData = {
  __typename?: 'VerifyContainerScanData';
  barcode: Scalars['String']['output'];
  itemId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  scannedAt: Scalars['DateTime']['output'];
  scannedBy: Scalars['String']['output'];
};

/**
 * A single raw item scan. ItemId is null for an unknown barcode (captured raw,
 * never blocking the scan — blind count). T? (not Option<T>) because the parent
 * document is a [UseFiltering] source. originalItemId is the item the scan resolved
 * to when an item combine has since moved the scan to the item it was combined into; null when no combine
 * moved it. orderId is the associated order the scan is attributed to, or null when
 * the scan counts toward every associated order.
 */
export type VerifyContainerScanDocument = {
  __typename?: 'VerifyContainerScanDocument';
  barcode: Scalars['String']['output'];
  itemId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  originalItemId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  scannedAt: Scalars['DateTime']['output'];
  scannedBy: Scalars['String']['output'];
};

/**
 * A single raw item scan. ItemId is null for an unknown barcode (captured raw,
 * never blocking the scan — blind count). T? (not Option<T>) because the parent
 * document is a [UseFiltering] source. originalItemId is the item the scan resolved
 * to when an item combine has since moved the scan to the item it was combined into; null when no combine
 * moved it. orderId is the associated order the scan is attributed to, or null when
 * the scan counts toward every associated order.
 */
export type VerifyContainerScanDocumentFilterInput = {
  and?: InputMaybe<Array<VerifyContainerScanDocumentFilterInput>>;
  barcode?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VerifyContainerScanDocumentFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  originalItemId?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  scannedAt?: InputMaybe<DateTimeOperationFilterInput>;
  scannedBy?: InputMaybe<StringOperationFilterInput>;
};

/**
 * GraphQL-facing snapshot of a VerifyContainerState returned by the
 * submitVerifyContainer / removeVerifyContainer mutations. A flat DTO that mirrors
 * the replayed domain state; optional fields surface as nullable primitives (no Option<T>
 * on the wire). The Mongo read model and its queries are a separate task — this type is only the
 * mutation's response shape.
 */
export type VerifyContainerStateData = {
  __typename?: 'VerifyContainerStateData';
  /** The drop, read from the label. Empty when the container has no drop (a label-less count). */
  drop: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  orderAssociations: Array<VerifyContainerOrderAssociationData>;
  removedAt: Scalars['DateTime']['output'];
  removedBy: Scalars['String']['output'];
  /** The manager's reason for discarding the container; null when none was given. */
  removedReason?: Maybe<Scalars['String']['output']>;
  scans: Array<VerifyContainerScanData>;
  status: VerifyContainerStatus;
  submittedAt: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  verifiedAt: Scalars['DateTime']['output'];
};

export enum VerifyContainerStatus {
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Open = 'OPEN',
  Scanned = 'SCANNED',
  Submitted = 'SUBMITTED',
  Verified = 'VERIFIED'
}

/**
 * Payload delivered to verifyContainerStatusChanged subscribers: a single container's
 * lifecycle transition. The supervisor dashboard reacts by VerifyContainerStatus:
 * on Submitted it refetches the comparison for that container;
 * on Verified it drops the row (also clearing a second
 * supervisor's screen). OrderIds lets the client target the affected order(s) without
 * a round-trip. The payload intentionally carries only identity + status; richer container detail is
 * pulled via the verifyContainers query.
 */
export type VerifyContainerStatusChangedEvent = {
  __typename?: 'VerifyContainerStatusChangedEvent';
  containerId: Scalars['String']['output'];
  orderIds: Array<Scalars['String']['output']>;
  status: VerifyContainerStatus;
};

export type VerifyContainerStatusOperationFilterInput = {
  eq?: InputMaybe<VerifyContainerStatus>;
  in?: InputMaybe<Array<VerifyContainerStatus>>;
  neq?: InputMaybe<VerifyContainerStatus>;
  nin?: InputMaybe<Array<VerifyContainerStatus>>;
};

/** A connection to a list of items. */
export type VerifyContainersConnection = {
  __typename?: 'VerifyContainersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VerifyContainersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VerifyContainerDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VerifyContainersEdge = {
  __typename?: 'VerifyContainersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VerifyContainerDocument;
};

/**
 * How a comparison line's summed scan quantity stacks up against its order line's ordered quantity.
 * Ordinals are NOT persisted — this enum exists only on the derived, never-stored
 * OrderVerificationComparison read shape (computed fresh on every
 * orderVerificationComparison query) — so it carries no Enum-Ordinal-Stability obligation.
 */
export enum VerifyLineVariance {
  /** Scanned sum equals the ordered quantity. */
  Matched = 'MATCHED',
  /** Scanned sum is greater than the ordered quantity. */
  Over = 'OVER',
  /** Scanned sum is less than the ordered quantity. */
  Short = 'SHORT'
}

export enum VerifyMode {
  Direct = 'DIRECT',
  Staged = 'STAGED'
}

export type VerifyPortalCustomDomainInput = {
  domain: Scalars['String']['input'];
};

/**
 * Input for verifyTenantSmtpConnection. The server sends a live test message to
 * testRecipient using the stored connection; success marks it verified, failure marks it failed
 * with a sanitized reason.
 */
export type VerifyTenantSmtpConnectionInput = {
  /** Gets the address the verification test message is sent to. */
  testRecipient: Scalars['String']['input'];
};

export type VoidContractRecordFeeInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
};

/** Input for the void-invoice mutation. */
export type VoidInvoiceInput = {
  /** The issued invoice to withdraw. */
  invoiceId: Scalars['String']['input'];
  /** Why it is being withdrawn. Required — it is the only part of a void a later reader cannot reconstruct. */
  reason: Scalars['String']['input'];
};

export type VoidMaterialPriceInput = {
  expectedPriceRevision: Scalars['Int']['input'];
  expectedPurchasingRevision?: InputMaybe<Scalars['Int']['input']>;
  materialItemId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** A tenant-owned volume pool: price ladders tagged with the same pool are summed together toward one volume break when an order is priced. Retired pools are hidden from volumePools unless includeRetired is set. */
export type VolumePool = {
  __typename?: 'VolumePool';
  /** The tenant-unique pool code as entered. Immutable after creation; a flat pricing CSV names a pool by this value. */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantityBasis: QuantityBasis;
  /** When the pool was retired; null while it is still active. */
  retiredAt?: Maybe<Scalars['DateTime']['output']>;
  status: VolumePoolStatus;
  tenantId: Scalars['String']['output'];
  volumePoolId: Scalars['String']['output'];
};

/**
 * GraphQL mutation payload for the VolumePool aggregate. Either VolumePool carries the
 * post-event state, or Errors describes why the mutation failed.
 */
export type VolumePoolPayload = {
  __typename?: 'VolumePoolPayload';
  errors?: Maybe<Array<ValidationError>>;
  volumePool?: Maybe<VolumePoolStateData>;
};

export type VolumePoolStateData = {
  __typename?: 'VolumePoolStateData';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantityBasis: QuantityBasis;
  retiredAt?: Maybe<Scalars['DateTime']['output']>;
  status: VolumePoolStatus;
  tenantId: Scalars['String']['output'];
  volumePoolId: Scalars['String']['output'];
};

export enum VolumePoolStatus {
  Active = 'ACTIVE',
  Retired = 'RETIRED',
  Unknown = 'UNKNOWN'
}

/** Input for the waive-invoice-late-charge mutation. */
export type WaiveInvoiceLateChargeInput = {
  /**
   * The date to forgive the accrued charge as of. This chooses WHICH months are forgiven: the invoice
   * keeps accruing afterwards, so a charge forgiven in March is running again in April.
   */
  asOfDate: Scalars['DateTime']['input'];
  /** The issued invoice whose accrued finance charge is being forgiven. */
  invoiceId: Scalars['String']['input'];
  /** Why it is being forgiven. Required. */
  reason: Scalars['String']['input'];
};

export type WeeklyCellEditInput = {
  isoWeek: Scalars['Int']['input'];
  isoYear: Scalars['Int']['input'];
  itemId: Scalars['String']['input'];
  metric: ForecastWeeklyMetric;
  region: Scalars['String']['input'];
  value: Scalars['Decimal']['input'];
};

export type WeeklySlopeFactorDocument = {
  __typename?: 'WeeklySlopeFactorDocument';
  calcSteps: Array<RestockCalcStep>;
  calculatedAt: Scalars['DateTime']['output'];
  customerCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  productGroup: Scalars['String']['output'];
  region: Scalars['String']['output'];
  slopeFactor: Scalars['Decimal']['output'];
  tenantId: Scalars['String']['output'];
  weekOfYear: Scalars['Int']['output'];
};

export type WeeklySlopeFactorDocumentFilterInput = {
  and?: InputMaybe<Array<WeeklySlopeFactorDocumentFilterInput>>;
  calcSteps?: InputMaybe<ListFilterInputTypeOfRestockCalcStepFilterInput>;
  calculatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WeeklySlopeFactorDocumentFilterInput>>;
  productGroup?: InputMaybe<StringOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  slopeFactor?: InputMaybe<DecimalOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  weekOfYear?: InputMaybe<IntOperationFilterInput>;
};

export type WeeklySlopeFactorDocumentSortInput = {
  calculatedAt?: InputMaybe<SortEnumType>;
  customerCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  productGroup?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  slopeFactor?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  weekOfYear?: InputMaybe<SortEnumType>;
};

export enum WeightUnit {
  Kilograms = 'KILOGRAMS',
  Pounds = 'POUNDS',
  Unknown = 'UNKNOWN'
}

export type WeightUnitOperationFilterInput = {
  eq?: InputMaybe<WeightUnit>;
  in?: InputMaybe<Array<WeightUnit>>;
  neq?: InputMaybe<WeightUnit>;
  nin?: InputMaybe<Array<WeightUnit>>;
};

/** What's new for the signed-in tenant. Empty when the WhatsNew flag is off for the tenant, for portal users, or when nothing is published. */
export type WhatsNew = {
  __typename?: 'WhatsNew';
  /** The tenant's open asks that haven't shipped (comingSoon features). */
  comingSoon: Array<WhatsNewFeature>;
  /** Newest first; at most 26. */
  releases: Array<WhatsNewRelease>;
};

/** One stored What's new feature as staff see it in wsapi-admin, with its audit fields. */
export type WhatsNewAdminFeature = {
  __typename?: 'WhatsNewAdminFeature';
  /** Who approved the release's list it was published in; null when staff added it. */
  approvedBy?: Maybe<Scalars['String']['output']>;
  /** True once staff added or edited it here; a release re-publish leaves it alone. */
  editedInAdmin: Scalars['Boolean']['output'];
  /** The feature with its tenant ids and askers in full. */
  feature: WhatsNewFeature;
  /** When the publish that wrote it ran; null when staff added it. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When it was last added or edited in wsapi-admin. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who last added or edited it in wsapi-admin. */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** One tenant's What's new as its staff see it, with the features they don't see and why. */
export type WhatsNewAdminPreview = {
  __typename?: 'WhatsNewAdminPreview';
  /** Features of the kept releases the tenant doesn't see, and why. */
  hidden: Array<WhatsNewHiddenFeature>;
  /** Exactly what whatsNew returns for the tenant's staff. */
  whatsNew: WhatsNew;
};

/** A tenant user who asked for a feature. */
export type WhatsNewAsker = {
  __typename?: 'WhatsNewAsker';
  /** The day they asked, or null when it is not known. */
  askedOn?: Maybe<Scalars['LocalDate']['output']>;
  /** Who asked. */
  name: Scalars['String']['output'];
  /** The asker's tenant. */
  tenantId: Scalars['String']['output'];
};

export type WhatsNewAskerInput = {
  askedOn?: InputMaybe<Scalars['LocalDate']['input']>;
  name: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** One leased batch of a release's What's new email: one SendGrid request. */
export type WhatsNewEmailBatch = {
  __typename?: 'WhatsNewEmailBatch';
  /**
   * When this lease was taken: the lease token. Send it back as claimedAt in
   * recordWhatsNewEmailBatchOutcome, so an outcome from a lease that ran out and was re-claimed cannot
   * change the batch another claim is sending.
   */
  claimedAt: Scalars['DateTime']['output'];
  /** The day the release reached production. */
  effectiveOn: Scalars['LocalDate']['output'];
  /** The features in this email: tenant features first, then global ones. Never tryEarly or comingSoon. */
  features: Array<WhatsNewFeature>;
  /** The batch id. */
  id: Scalars['String']['output'];
  /** The repo's LanguagePreference enum (EN, ES). */
  language: LanguagePreference;
  /** The release label the email is for. */
  releaseLabel: Scalars['String']['output'];
  /** The tenants whose recipients are in this batch: at most 1,000 recipients in all, one SendGrid request. */
  tenants: Array<WhatsNewEmailBatchTenant>;
};

/** One recipient of a What's new email batch. */
export type WhatsNewEmailBatchRecipient = {
  __typename?: 'WhatsNewEmailBatchRecipient';
  /** The address. */
  email: Scalars['String']['output'];
  /** The user's full name, or null. */
  name?: Maybe<Scalars['String']['output']>;
  /** RFC 8058 one-click target: https://<wsapi host>/whats-new/unsubscribe?token=... */
  oneClickUnsubscribeUrl: Scalars['String']['output'];
  /** Footer link: https://<Work Suite host>/unsubscribe/whats-new?token=...&lang=<en|es> */
  unsubscribePageUrl: Scalars['String']['output'];
};

/** One tenant in a What's new email batch. */
export type WhatsNewEmailBatchTenant = {
  __typename?: 'WhatsNewEmailBatchTenant';
  /** Only recipients this batch has not been sent to yet. */
  recipients: Array<WhatsNewEmailBatchRecipient>;
  /** The tenant. */
  tenantId: Scalars['String']['output'];
  /** The tenant's name. */
  tenantName: Scalars['String']['output'];
};

/** Result of claimWhatsNewEmailBatches. */
export type WhatsNewEmailClaimPayload = {
  __typename?: 'WhatsNewEmailClaimPayload';
  /** The leased batches, oldest first. */
  batches: Array<WhatsNewEmailBatch>;
  /** Why the claim was refused, each with a code; null when it succeeded. */
  errors?: Maybe<Array<ValidationError>>;
};

/** Whether one What's new email reached one recipient of one tenant. */
export type WhatsNewEmailDelivery = {
  __typename?: 'WhatsNewEmailDelivery';
  /** The recipient's address. */
  email: Scalars['String']['output'];
  /** When SendGrid last reported an event for the recipient, or null before the first. */
  lastEventAt?: Maybe<Scalars['DateTime']['output']>;
  /** The release the email was for. */
  releaseLabel: Scalars['String']['output'];
  /** When the email was sent to the recipient, or null when it is not known. */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The recipient's delivery status (pending, delivered, opened, bounced, dropped, spam report, blocked, deferred).
   * Pending until SendGrid reports an event.
   */
  status: EmailRecipientDeliveryStatus;
  /** The recipient's tenant. */
  tenantId: Scalars['String']['output'];
};

export type WhatsNewEmailRecipient = {
  __typename?: 'WhatsNewEmailRecipient';
  changedAt: Scalars['DateTime']['output'];
  changedBy?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** How the last change was made. */
  source: WhatsNewEmailSource;
  subscribed: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

export type WhatsNewEmailRecipientPayload = {
  __typename?: 'WhatsNewEmailRecipientPayload';
  errors?: Maybe<Array<ValidationError>>;
  recipient?: Maybe<WhatsNewEmailRecipient>;
};

export enum WhatsNewEmailSource {
  Admin = 'ADMIN',
  EmailLink = 'EMAIL_LINK',
  Preferences = 'PREFERENCES',
  Unknown = 'UNKNOWN'
}

/** One What's new feature. Global when tenantIds is empty (Also new); otherwise only those tenants see it (You asked for). */
export type WhatsNewFeature = {
  __typename?: 'WhatsNewFeature';
  /** Who asked, and when. whatsNew only returns the signed-in tenant's askers. */
  askedBy: Array<WhatsNewAsker>;
  /** An open ask that hasn't shipped: one tenant, no release. */
  comingSoon: Scalars['Boolean']['output'];
  /** A link to a demo of the feature, or null. */
  demoUrl?: Maybe<Scalars['String']['output']>;
  /** Longer lines under the summary, in order; at most 12. */
  details: Array<WhatsNewText>;
  /** A link to the feature's docs, or null. */
  docsUrl?: Maybe<Scalars['String']['output']>;
  /** The day the feature's release reached production. Null on comingSoon features. */
  effectiveOn?: Maybe<Scalars['LocalDate']['output']>;
  /** The flag this feature depends on, or null. A tenant never sees a feature whose flag is off for it; a tryEarly feature shows only while its flag is off. */
  featureFlag?: Maybe<FeatureFlagName>;
  /** The feature's id; a republish that keeps the feature keeps its id. */
  id: Scalars['String']['output'];
  /** A link to an image of the feature, or null. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Stable within a release, e.g. quotes. */
  key: Scalars['String']['output'];
  /** The product area the feature belongs to. */
  module: WhatsNewModule;
  /** Null on comingSoon features. */
  releaseLabel?: Maybe<Scalars['String']['output']>;
  /** A link to the full release notes this feature shipped in, or null. */
  releaseNotesUrl?: Maybe<Scalars['String']['output']>;
  /** tryEarly only: the signed-in user already asked for it. */
  requestedByMe: Scalars['Boolean']['output'];
  /** comingSoon only: plain status words, never a date. */
  status?: Maybe<WhatsNewText>;
  /** The one line under the title. */
  summary: WhatsNewText;
  /** Empty = global. whatsNew only ever returns [] or the signed-in tenant's own id. */
  tenantIds: Array<Scalars['String']['output']>;
  /** The feature's title. */
  title: WhatsNewText;
  /** Walkthrough registry id; null when no tour passed its latest run. */
  tourId?: Maybe<Scalars['String']['output']>;
  /** An early-preview feature the tenant can ask to try. Needs featureFlag. */
  tryEarly: Scalars['Boolean']['output'];
};

export type WhatsNewFeatureInput = {
  askedBy: Array<WhatsNewAskerInput>;
  comingSoon: Scalars['Boolean']['input'];
  demoUrl?: InputMaybe<Scalars['String']['input']>;
  details: Array<WhatsNewTextInput>;
  docsUrl?: InputMaybe<Scalars['String']['input']>;
  featureFlag?: InputMaybe<FeatureFlagName>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  module: WhatsNewModule;
  status?: InputMaybe<WhatsNewTextInput>;
  summary: WhatsNewTextInput;
  /** Empty = global. */
  tenantIds: Array<Scalars['String']['input']>;
  title: WhatsNewTextInput;
  tourId?: InputMaybe<Scalars['String']['input']>;
  tryEarly: Scalars['Boolean']['input'];
};

/** A feature of a kept release that one tenant doesn't see, with the first rule that hides it. */
export type WhatsNewHiddenFeature = {
  __typename?: 'WhatsNewHiddenFeature';
  /** The feature with its tenant ids and askers in full. */
  feature: WhatsNewFeature;
  /** The first rule that hides the feature from the tenant. */
  reason: WhatsNewHiddenReason;
};

/** Why a tenant doesn't see a feature. */
export enum WhatsNewHiddenReason {
  /** The feature's flag is off for the tenant. */
  FlagOff = 'FLAG_OFF',
  /** A global feature whose module's flag is off for the tenant. */
  ModuleOff = 'MODULE_OFF',
  /** The feature's release reaches production after today (UTC). */
  NotYetEffective = 'NOT_YET_EFFECTIVE',
  /** The feature is for other tenants only. */
  OtherTenant = 'OTHER_TENANT',
  /** A tenant feature of the same release has the same key, and whatsNew keeps that one. */
  ReplacedByTenantFeature = 'REPLACED_BY_TENANT_FEATURE',
  /** A Try early feature whose flag is already on for the tenant. */
  TryEarlyFlagOn = 'TRY_EARLY_FLAG_ON',
  /** None of the rules below; never expected. */
  Unknown = 'UNKNOWN',
  /** The tenant's WhatsNew flag is off, so it sees nothing. */
  WhatsNewOff = 'WHATS_NEW_OFF'
}

export enum WhatsNewModule {
  Forecast = 'FORECAST',
  Fulfill = 'FULFILL',
  General = 'GENERAL',
  Mobile = 'MOBILE',
  Portal = 'PORTAL',
  Produce = 'PRODUCE',
  Reports = 'REPORTS',
  Restock = 'RESTOCK',
  Unknown = 'UNKNOWN'
}

/** One release in What's new: its label, the day it reached production, and its features. */
export type WhatsNewRelease = {
  __typename?: 'WhatsNewRelease';
  /** The day the release reached production. */
  effectiveOn: Scalars['LocalDate']['output'];
  /** The tenant's features first, then global ones; among the visible features, a key in both keeps the tenant's feature. Includes tryEarly features. */
  features: Array<WhatsNewFeature>;
  /** Release label, e.g. 2026-10-16 (the label the release notes use). */
  label: Scalars['String']['output'];
  /** A link to the release notes, or null. */
  releaseNotesUrl?: Maybe<Scalars['String']['output']>;
};

/** One kept release: its label, its day, how many features it holds and who approved it. */
export type WhatsNewReleaseSummary = {
  __typename?: 'WhatsNewReleaseSummary';
  /** Who approved the release's list; null when no publish wrote it. */
  approvedBy?: Maybe<Scalars['String']['output']>;
  /** The day the release reached production. */
  effectiveOn: Scalars['LocalDate']['output'];
  /** How many stored features the release holds, global and tenant ones alike. */
  featureCount: Scalars['Int']['output'];
  /** The release label. */
  label: Scalars['String']['output'];
};

/** What's new text in English, with Spanish when the publish gave one. */
export type WhatsNewText = {
  __typename?: 'WhatsNewText';
  /** The English text. */
  en: Scalars['String']['output'];
  /** The Spanish text, or null when there is none. */
  es?: Maybe<Scalars['String']['output']>;
};

export type WhatsNewTextInput = {
  en: Scalars['String']['input'];
  es?: InputMaybe<Scalars['String']['input']>;
};

/** A revision to withdraw before approval. */
export type WithdrawMigrationSettingsRevisionInput = {
  journeyId: Scalars['String']['input'];
  revisionId: Scalars['String']['input'];
};

export type WorkOrderBuildItemData = {
  __typename?: 'WorkOrderBuildItemData';
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  unitOfMeasure: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

export type WorkOrderBuildItemDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderBuildItemDataFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderBuildItemDataFilterInput>>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  unitOfMeasure?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type WorkOrderData = {
  __typename?: 'WorkOrderData';
  activityCode: Scalars['String']['output'];
  buildItems: Array<WorkOrderBuildItemData>;
  containerQuantity: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  plannedQuantity: Scalars['Int']['output'];
  productionPhaseCode: Scalars['String']['output'];
  productionQuantity: Scalars['Int']['output'];
  quantityProduced: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  workOrderStatus: WorkOrderStatus;
};

export type WorkOrderDocument = {
  __typename?: 'WorkOrderDocument';
  activityCode?: Maybe<Scalars['String']['output']>;
  buildItems?: Maybe<Array<WorkOrderBuildItemData>>;
  containerQuantity: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  erpId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
  plannedQuantity?: Maybe<Scalars['Int']['output']>;
  productionPhaseCode?: Maybe<Scalars['String']['output']>;
  productionQuantity: Scalars['Int']['output'];
  quantityProduced: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  workOrderStatus: WorkOrderStatus;
};

export type WorkOrderDocumentFilterInput = {
  activityCode?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderDocumentFilterInput>>;
  buildItems?: InputMaybe<ListFilterInputTypeOfWorkOrderBuildItemDataFilterInput>;
  containerQuantity?: InputMaybe<IntOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  deliveryDate?: InputMaybe<DateTimeOperationFilterInput>;
  erpId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  jobId?: InputMaybe<StringOperationFilterInput>;
  lineNumber?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderDocumentFilterInput>>;
  plannedQuantity?: InputMaybe<IntOperationFilterInput>;
  productionPhaseCode?: InputMaybe<StringOperationFilterInput>;
  productionQuantity?: InputMaybe<IntOperationFilterInput>;
  quantityProduced?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  workOrderStatus?: InputMaybe<WorkOrderStatusOperationFilterInput>;
};

export type WorkOrderDocumentSortInput = {
  activityCode?: InputMaybe<SortEnumType>;
  containerQuantity?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  deliveryDate?: InputMaybe<SortEnumType>;
  erpId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jobId?: InputMaybe<SortEnumType>;
  lineNumber?: InputMaybe<SortEnumType>;
  plannedQuantity?: InputMaybe<SortEnumType>;
  productionPhaseCode?: InputMaybe<SortEnumType>;
  productionQuantity?: InputMaybe<SortEnumType>;
  quantityProduced?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  workOrderStatus?: InputMaybe<SortEnumType>;
};

export type WorkOrderInput = {
  activityCode: Scalars['String']['input'];
  buildItems: Array<BuildItemInput>;
  containerQuantity: Scalars['Int']['input'];
  erpId: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  plannedQuantity: Scalars['Int']['input'];
  productionPhaseCode: Scalars['String']['input'];
  productionQuantity: Scalars['Int']['input'];
  quantityProduced: Scalars['Int']['input'];
  status: WorkOrderStatus;
  workOrderId: Scalars['String']['input'];
};

export enum WorkOrderStatus {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Unknown = 'UNKNOWN'
}

export type WorkOrderStatusOperationFilterInput = {
  eq?: InputMaybe<WorkOrderStatus>;
  in?: InputMaybe<Array<WorkOrderStatus>>;
  neq?: InputMaybe<WorkOrderStatus>;
  nin?: InputMaybe<Array<WorkOrderStatus>>;
};

/** A connection to a list of items. */
export type WorkOrdersConnection = {
  __typename?: 'WorkOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<WorkOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WorkOrderDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WorkOrdersEdge = {
  __typename?: 'WorkOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WorkOrderDocument;
};

/** A proposed new flag set for a product, to see what saving it would do. */
export type WorkSuiteProductChangeImpactInput = {
  /** The product's complete proposed flag set. */
  flags: Array<FeatureFlagName>;
  /** The product. */
  productId: Scalars['String']['input'];
};

/** The flags proposed for a new product that is not included for every tenant. */
export type WorkSuiteProductCreateImpactInput = {
  /** The new product's complete flag set. */
  flags: Array<FeatureFlagName>;
};

/** A product in the WorkSuite product catalog, as a create or update wrote it. */
export type WorkSuiteProductStateData = {
  __typename?: 'WorkSuiteProductStateData';
  /** The flags the product turns on. Empty for a product that only records the contract. */
  flags: Array<FeatureFlagName>;
  /** The product id. */
  id: Scalars['String']['output'];
  /** True for a product every tenant has without a switch, such as FULFILL. */
  includedForEveryCustomer: Scalars['Boolean']['output'];
  /** The product name. */
  name: Scalars['String']['output'];
  /** The catalog position; lower sorts first. */
  order: Scalars['Int']['output'];
};

/**
 * Result containing a resolved worker config value for a specific service and tenant.
 * This is what wsapi-services receives at runtime.
 */
export type WorkerConfigResult = {
  __typename?: 'WorkerConfigResult';
  configName: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WorkerConfigStateData = {
  __typename?: 'WorkerConfigStateData';
  configName: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  tenantValues: Array<TenantValueStateData>;
};

/** One worker in the tenant's worker directory, identified by email address alone. */
export type WorkerDirectoryEntry = {
  __typename?: 'WorkerDirectoryEntry';
  /** The worker's email address, as written on their saved app settings. */
  emailAddress: Scalars['String']['output'];
};

export type WsapiImportDocument = {
  __typename?: 'WsapiImportDocument';
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  entityMappings: Array<EntityMappingData>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  runNow: Scalars['Boolean']['output'];
  scheduleDayOfWeek?: Maybe<Scalars['Int']['output']>;
  scheduleTimeOfDay?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  wsapiImportId: Scalars['String']['output'];
};

export type WsapiImportDocumentFilterInput = {
  and?: InputMaybe<Array<WsapiImportDocumentFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  entityMappings?: InputMaybe<ListFilterInputTypeOfEntityMappingDataFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  integrationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WsapiImportDocumentFilterInput>>;
  runNow?: InputMaybe<BooleanOperationFilterInput>;
  scheduleDayOfWeek?: InputMaybe<IntOperationFilterInput>;
  scheduleTimeOfDay?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<StringOperationFilterInput>;
  updated?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  wsapiImportId?: InputMaybe<StringOperationFilterInput>;
};

export type WsapiImportDocumentSortInput = {
  created?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  integrationId?: InputMaybe<SortEnumType>;
  runNow?: InputMaybe<SortEnumType>;
  scheduleDayOfWeek?: InputMaybe<SortEnumType>;
  scheduleTimeOfDay?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  updated?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  wsapiImportId?: InputMaybe<SortEnumType>;
};

export enum WsapiImportEntityType {
  Account = 'ACCOUNT',
  Contact = 'CONTACT',
  CrmAccount = 'CRM_ACCOUNT',
  CrmContact = 'CRM_CONTACT',
  CrmCustomerExport = 'CRM_CUSTOMER_EXPORT',
  Customer = 'CUSTOMER',
  InvoiceImport = 'INVOICE_IMPORT',
  Item = 'ITEM',
  JournalEntry = 'JOURNAL_ENTRY',
  Location = 'LOCATION',
  Order = 'ORDER',
  OrderExport = 'ORDER_EXPORT',
  Payment = 'PAYMENT',
  PricingImport = 'PRICING_IMPORT',
  TaxRate = 'TAX_RATE',
  Vendor = 'VENDOR'
}

export type WsapiImportEntityTypeOperationFilterInput = {
  eq?: InputMaybe<WsapiImportEntityType>;
  in?: InputMaybe<Array<WsapiImportEntityType>>;
  neq?: InputMaybe<WsapiImportEntityType>;
  nin?: InputMaybe<Array<WsapiImportEntityType>>;
};

export type WsapiImportPayload = {
  __typename?: 'WsapiImportPayload';
  errors?: Maybe<Array<ValidationError>>;
  wsapiImport?: Maybe<WsapiImportStateData>;
};

export type WsapiImportStateData = {
  __typename?: 'WsapiImportStateData';
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  entityMappings: Array<EntityMappingData>;
  integrationId: Scalars['String']['output'];
  runNow: Scalars['Boolean']['output'];
  scheduleDayOfWeek?: Maybe<Scalars['Int']['output']>;
  scheduleTimeOfDay?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  wsapiImportId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type WsapiImportsConnection = {
  __typename?: 'WsapiImportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<WsapiImportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<WsapiImportDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WsapiImportsEdge = {
  __typename?: 'WsapiImportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WsapiImportDocument;
};

export type { TDateISO };